(function () {
	'use strict';

	angular
		.module('app.admin.environment', ['ng.jsoneditor'])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.adminEnvironment', {
				url: '/admin/environment?active',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.environment/views/admin-environment.html',
						controller: 'adminEnvironmentController as vm'
					},
					'maintenance@app.adminEnvironment': {
						templateUrl: 'app/main/admin.environment/views/tabs/maintenance.html',
						controller: 'MaintenanceController as vm'
					}
				},
                params: {
					active: 'general'
				},
				reloadOnSearch: false,
				permissions: 'admin.environment.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('admin.environment', {
			title: 'environment',
			icon: 'icon-home-variant',
			state: 'app.adminEnvironment',
			translate: 'ADMIN.ENVIRONMENT_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().admin.environment.enabled;
			}
		});
        //*******************************************

		//*******************************************
		// API
		//*******************************************
        nuitApiProvider.register('config', 'configurations', {allow: ['get','put'], params: {scope: 'environment'}});
        nuitApiProvider.register('config.single', 'configurations/:key', {allow: ['delete','put'], params: {scope: 'environment'}});
		nuitApiProvider.register('config.add', 'configurations', {allow: ['post'], params: {scope: 'environment'}});
        nuitApiProvider.register('theme.css', 'themes/css', {allow: ['get','post','put','delete']});
        nuitApiProvider.register('profiles.recreate', 'production/images/profiles/recreate', {allow: ['get']});
		nuitApiProvider.register('profiles.copy.admin', 'folder/admin/copy', {allow: ['post']});
		//*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
            admin: {
                environment: {
                    enabled: false
                }
            }
        };
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorWorkdays', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/workDays/workdays.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, OrderService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		vm.getDay = getDay;
		vm.currentDay = [];
		vm.selected = false;
		vm.exists = exists;

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {

			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
				if (entry !== undefined) {
					vm.currentDay.push(entry);
				}
			}
		}

		function getDay(day, list) {
			var idx = list.indexOf(day);
			if (idx > -1) {
				list.splice(idx, 1);
				vm.value.splice(idx, 1);
			} else {
				list.push(day);
				vm.value.push(day);
			}
		}

		function exists(day, list) {
			return list.indexOf(day) > -1;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorUserArray', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/userArray/user-array.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				onUpdate: '<'
			}
		});

	/** @ngInject */
	function Controller($scope, nuitDataService, UserService, imsUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.$onInit = init;
		vm.$onChanges = onChanges;
		vm.moveUp = moveUp;
		vm.moveDown = moveDown;
		vm.add = add;
		vm.remove = remove;
		vm.getPerson = getPerson;
		//*******************************************

		function init() {
			UserService.getUsers();
		}

		function onChanges(changes){
			if(changes.active){
				if(changes.active && vm.value.length===0){

				}
			}
		}

		function moveUp(index){
			var entry = vm.value.splice(index, 1)[0];
			vm.value.splice(index - 1, 0, entry);
			notify();
		}

		function moveDown(index){
			var entry = vm.value.splice(index, 1)[0];
			vm.value.splice(index + 1, 0, entry);
			notify();
		}

		function remove(index){
			vm.value.splice(index, 1);
			notify();
		}

		function add() {
			return imsUtils.openUserSelection(
				UserService.users,
				{singleSelect: false, header: 'APP.ADD', cancel: 'APP.CANCEL', confirm: 'APP.OK', showRoles: true}
			)
				.then(function (data) {
					for (var i = 0; i < data.users.length; i++) {
						if(vm.value.indexOf(data.users[i].id)===-1) {
							vm.value.push(data.users[i].id);
						}
					}
					notify();
				});
		}

		function getPerson(id){
			return nuitDataService.getOne(UserService.users,id);
		}

		function notify(){
			if(vm.onUpdate){
				vm.onUpdate();
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorTranslationArray', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/translationArray/translation-array.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				type: '@'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, ConditionCheckService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		vm.newTranslation = newTranslation;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
		}

		function newTranslation() {
			vm.value.push({id:'',text:{}});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorTagGroupSelection', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/tagGroupSelection/tag-group-selection.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, OrderTagsService,imsTranslation) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.languages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = imsTranslation.language;
		var groups = {};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.getGroups = getGroups;
		vm.newSelection = newSelection;
		//*******************************************

		init();

		function init() {
			OrderTagsService.reload()
				.then(function(data){
					for(var i=0;i<data.length;i++){
						var tag = data[i];

						if(!tag.group || tag.group.length===0){
							continue;
						}

						if(!groups.hasOwnProperty(tag.group)){
							groups[tag.group] = [];
						}

						groups[tag.group].push(tag);
					}
			 	});
		}

		function getGroups(){
			return Object.keys(groups);
		}

		function newSelection() {
			vm.value.push({multiple:false,required:false});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorStateSelection', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/stateSelection/state-selection.component.html',
			controller: Controller,
			controllerAs: 'vm',
			require: {
				parentForm: '?^^form'
			},
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller($mdDialog, $state, $translate, msNavigationService, imsConfig) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.allStates = [];
		vm.$onInit = init;
		vm.permissionFor = permissionFor;
		vm.openPicker = openPicker;
		//*******************************************

		/**
		 * Builds the list of every registered $stateProvider state, enriched with
		 * its navigation translation key (from msNavigationService) and the
		 * permission required to reach it (from the state definition).
		 */
		function init() {
			var navByState = {};
			msNavigationService.getFlatNavigation().forEach(function (item) {
				if (item.state && !navByState[item.state]) {
					navByState[item.state] = item;
				}
			});

			vm.allStates = $state.get()
				.filter(function (state) {
					// Only states that map to a navigation entry with a translation,
					// are not hidden, are not admin states, and whose required
					// permission(s) are enabled in the config (admin permissions excluded).
					var navItem = state.name ? navByState[state.name] : null;
					return navItem
						&& (navItem.translate || navItem.title)
						&& !isNavItemHidden(navItem)
						&& state.name.toLowerCase().indexOf('admin') === -1
						&& hasEnabledNonAdminPermission(state.permissions);
				})
				.map(function (state) {
					var navItem = navByState[state.name];
					var translateKey = navItem.translate || navItem.title;
					return {
						state: state.name,
						translate: translateKey,
						label: $translate.instant(translateKey),
						permission: normalizePermission(state.permissions)
					};
				})
				.sort(function (a, b) {
					return a.label.localeCompare(b.label);
				});
		}

		/**
		 * Evaluates a navigation item's "hidden" flag, which is commonly a function
		 * (closing over the config) but may also be a plain boolean.
		 * @param {Object} navItem
		 * @returns {boolean}
		 */
		function isNavItemHidden(navItem) {
			var hidden = navItem.hidden;
			if (angular.isFunction(hidden)) {
				try {
					return !!hidden();
				} catch (e) {
					return false;
				}
			}
			return !!hidden;
		}

		function normalizePermission(permissions) {
			if (!permissions) {
				return null;
			}
			return angular.isArray(permissions) ? permissions.join(', ') : permissions;
		}

		function toPermissionArray(permissions) {
			if (!permissions) {
				return [];
			}
			return angular.isArray(permissions) ? permissions : [permissions];
		}

		/**
		 * True when the state has at least one permission and every required
		 * permission is non-admin and currently enabled in the config.
		 * @param {string|Array} permissions
		 * @returns {boolean}
		 */
		function hasEnabledNonAdminPermission(permissions) {
			var list = toPermissionArray(permissions);
			if (list.length === 0) {
				return false;
			}
			for (var i = 0; i < list.length; i++) {
				var permission = list[i].toString();
				if (permission.toLowerCase().indexOf('admin') !== -1) {
					return false;
				}
				if (!isEnabled(permission)) {
					return false;
				}
			}
			return true;
		}

		/**
		 * Safely resolves whether a permission is enabled in the config. The config
		 * path may be incomplete, so a missing key counts as "not enabled" rather
		 * than throwing.
		 * @param {string} permission
		 * @returns {boolean}
		 */
		function isEnabled(permission) {
			try {
				return !!imsConfig.hasPermissions(permission);
			} catch (e) {
				return false;
			}
		}

		/**
		 * Returns the permission required to reach the given state, or null.
		 * @param {string} state
		 * @returns {string|null}
		 */
		function permissionFor(state) {
			for (var i = 0; i < vm.allStates.length; i++) {
				if (vm.allStates[i].state === state) {
					return vm.allStates[i].permission;
				}
			}
			return null;
		}

		/**
		 * Opens the picker dialog listing all states. On confirm the chosen state
		 * is written into the config value.
		 * @param {Event} $event
		 */
		function openPicker($event) {
			$mdDialog.show({
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: true,
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.environment/components/config-editor/customInput/stateSelection/state-selection.info.html',
				locals: { states: vm.allStates, selected: vm.value, pathsJson: angular.toJson(buildPaths(), true) },
				/** @ngInject */
				controller: function ($mdDialog, $window, states, selected, pathsJson) {
					var dialog = this;
					dialog.states = states;
					dialog.selected = selected;
					dialog.pathsJson = pathsJson;
					dialog.showJson = false;
					dialog.toggleJson = function () {
						dialog.showJson = !dialog.showJson;
					};
					dialog.copyJson = function () {
						try {
							$window.navigator.clipboard.writeText(dialog.pathsJson);
						} catch (e) {
							// clipboard unavailable - the textarea is selectable as fallback
						}
					};
					dialog.confirm = function () {
						$mdDialog.hide(dialog.selected);
					};
					dialog.cancel = function () {
						$mdDialog.cancel();
					};
				}
			}).then(function (picked) {
				if (picked) {
					vm.value = picked;
					// Picking programmatically bypasses the input's ngModel, so mark
					// the surrounding form dirty to enable the Save button.
					if (vm.parentForm) {
						vm.parentForm.$setDirty();
					}
				}
			}, angular.noop);
		}

		/**
		 * Maps every selectable state to its relative url path.
		 * @returns {Array<{state: string, path: string}>}
		 */
		function buildPaths() {
			return vm.allStates.map(function (entry) {
				return {
					state: entry.state,
					path: ($state.href(entry.state) || '').replace(/^#/, '')
				};
			});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorStampingTools', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/stampingTools/stamping-tools.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				onSizesUpdated: '&',
				onToolsUpdated: '&'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.toolTabs = [];
		vm.showSizes = false;
		vm.showShapes = false;

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = init;
		vm.addTool = addTool;
		vm.addShape = addShape;
		vm.addSize = addSize;
		vm.deleteTool = deleteTool;
		vm.deleteShape = deleteShape;
		vm.deleteSize = deleteSize;
		vm.moveLeft = moveLeft;
		vm.moveRight = moveRight;
		vm.moveUp = moveUp;
		vm.moveDown = moveDown;

		//*******************************************

		function init() {
			if (typeof vm.onSizesUpdated === 'function') {
				vm.onSizesUpdated(sanitizeToolSizesForUpdate());
			}
			if (typeof vm.onToolsUpdated === 'function') {
				vm.onToolsUpdated(sanitizeToolsForUpdate());
			}

			for(var i=0;i<vm.value.length;i++){
				for(var j=0;j<vm.value[i].sizes.length;j++){
					if(angular.isString(vm.value[i].sizes[j].value)){
						vm.value[i].sizes[j].value = parseFloat(vm.value[i].sizes[j].value);
					}
				}
			}
		}

		function addTool() {
			vm.value.push({id: 'new Tool'});
			if (typeof vm.onToolsUpdated === 'function') {
				vm.onToolsUpdated(sanitizeToolsForUpdate());
			}
		}

		function addShape(tool) {
			if(!tool.shapes){
				tool.shapes = [];
			}

			tool.shapes.push({});
		}

		function addSize(tool) {
			if(!tool.sizes){
				tool.sizes = [];
			}

			var defaultId = 'new size';
			var newId;

			do {
				if (!newId) {
					newId = defaultId;
				} else {
					var lastChar = parseInt(newId.slice(-1));
					var uid = isNaN(lastChar) ? 1 : lastChar + 1;
					newId = defaultId + uid;
				}
			} while (sizeIdExists(newId));

			tool.sizes.push({id: newId});

			if (typeof vm.onSizesUpdated === 'function') {
				vm.onSizesUpdated(sanitizeToolSizesForUpdate());
			}
		}

		function deleteTool(tool) {
			nuitDataService.removeOne(vm.value, tool.id);

			if (typeof vm.onSizesUpdated === 'function') {
				vm.onSizesUpdated(sanitizeToolSizesForUpdate());
			}
			if (typeof vm.onToolsUpdated === 'function') {
				vm.onToolsUpdated(sanitizeToolsForUpdate());
			}
		}

		function deleteShape(toolindex, index) {
			vm.value[toolindex].shapes.splice(index, 1);
		}

		function deleteSize(toolindex, index) {
			vm.value[toolindex].sizes.splice(index, 1);

			if (typeof vm.onSizesUpdated === 'function') {
				vm.onSizesUpdated(sanitizeToolSizesForUpdate());
			}
		}

		function sanitizeToolSizesForUpdate() {
			console.log(vm.value);
			return {
				sizes: vm.value.reduce(function (result, tool) {
					return result.concat(tool.sizes.map(function (size) {
						return size.id;
					}));
				}, [])
			};
		}
		function sanitizeToolsForUpdate() {
			return {
				tools: vm.value.reduce(function (result, tool) {
					return result.concat(tool.id);
				}, [])
			};
		}

		function sizeIdExists(id) {
			return vm.value.findIndex(function (tool) {
				return tool.sizes.findIndex(function (size) {
					return size.id === id;
				}) >= 0;
			}) >= 0;
		}

		function moveLeft(index){
			var tool = vm.value.splice(index, 1)[0];
			vm.value.splice(index - 1, 0, tool);
		}

		function moveRight(index){
			var tool = vm.value.splice(index, 1)[0];
			vm.value.splice(index + 1, 0, tool);
		}

		function moveUp(array, index){
			var entry = array.splice(index, 1)[0];
			array.splice(index - 1, 0, entry);
			if (typeof vm.onSizesUpdated === 'function') {
				vm.onSizesUpdated(sanitizeToolSizesForUpdate());
			}
		}

		function moveDown(array, index){
			var entry = array.splice(index, 1)[0];
			array.splice(index + 1, 0, entry);
			if (typeof vm.onSizesUpdated === 'function') {
				vm.onSizesUpdated(sanitizeToolSizesForUpdate());
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorStampingTemplates', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/stampingTemplates/stamping-templates.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				sizes: '<',
				tools: '<',
				areas: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.templateTabs = [];
		vm.showLines = false;

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = init;
		vm.addTemplate = addTemplate;
		vm.addLine = addLine;
		vm.deleteTemplate = deleteTemplate;
		vm.deleteLine = deleteLine;

		//*******************************************

		function init() {
		}

		function addTemplate() {
			vm.value.push({id: 'new Template'});
		}

		function addLine(template) {
			console.log(template);
			if(!template.lines){
				template.lines = [];
			}
			template.lines.push({});
		}


		function deleteTemplate(tool) {
			nuitDataService.removeOne(vm.value, tool.id);


		}

		function deleteLine(lineindex, index) {
			vm.value[lineindex].lines.splice(index, 1);
		}

	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorStampingAreas', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/stampingAreas/stamping-areas.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				sizes: '<',
				onAreasUpdated: '&'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, nuitDataService) {

		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.isPosition = '';
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = init;
		vm.addArea = addArea;
		vm.deleteArea = deleteArea;
		vm.isTop = isTop;
		vm.isBottom = isBottom;
		vm.isLeft = isLeft;
		vm.isRight = isRight;
		//*******************************************

		function init() {
			console.log(vm.sizes);
			if (typeof vm.onAreasUpdated === 'function') {
				vm.onAreasUpdated(sanitizeAreasForUpdate());
			}
		}

		function addArea() {
			vm.value.push({ id: 'new Area'});
			if (typeof vm.onAreasUpdated === 'function') {
				vm.onAreasUpdated(sanitizeAreasForUpdate());
			}
		}
		function deleteArea(area) {
			nuitDataService.removeOne(vm.value, area.id);
			if (typeof vm.onAreasUpdated === 'function') {
				vm.onAreasUpdated(sanitizeAreasForUpdate());
			}
		}

		function isTop(area) {
			if(area.isTop === true){
				area.isBottom = undefined;
			}
		}

		function isBottom(area) {
			if(area.isBottom === true){
				area.isTop = undefined;
			}
		}

		function isLeft(area) {
			if(area.isLeft === true){
				area.isRight = undefined;
			}
		}

		function isRight(area) {
			if(area.isRight === true){
				area.isLeft = undefined;
			}
		}

		function sanitizeAreasForUpdate() {
			return {
				areas: vm.value.reduce(function (result, area) {
					return result.concat(area.id);
				}, [])
			};
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorSalesOrderOverrides', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/salesOrderOverrides/sales-order-overrides.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller($scope, SalesObject, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.$onInit = init;
		vm.$onChanges = onChanges;
		vm.toggle = toggle;
		vm.getOptions = getOptions;
		vm.currentIds = [];
		vm.defaultOptions = [];
		//*******************************************

		function init(){
			vm.defaultOptions = SalesObject.getDefaultSalesObject();
		}

		function getOptions() {
			var options = [];

			for(var i = 0;i<vm.defaultOptions.length;i++){
					options.push(vm.defaultOptions[i].id);
			}

			return options;
		}

		function onChanges(){
			if(vm.active && vm.value.length!==0) {
				for(var i = 0;i<vm.value.length;i++){
					vm.currentIds.push(vm.value[i].id);
				}
			}

			toggle();
		}

		function toggle(){
			for(var i=0;i<vm.currentIds.length;i++){
				var existingEntry = nuitDataService.getOne(vm.value,vm.currentIds[i]);
				var entry = nuitDataService.getOne(vm.defaultOptions,vm.currentIds[i]);
				if(!existingEntry && entry) {
					vm.value.push(entry);
				}
			}

			var toDelete = [];

			for(var i=0;i<vm.value.length;i++){
				if(vm.currentIds.indexOf(vm.value[i].id)===-1){
					toDelete.push(vm.value[i].id);
				}
			}

			for(var i=0;i<toDelete.length;i++){
				nuitDataService.removeOne(vm.value,toDelete[i]);
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorSalesOrder', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/salesOrder/sales-order.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller($scope, SalesObject, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.$onInit = init;
		vm.$onChanges = onChanges;
		vm.moveUp = moveUp;
		vm.moveDown = moveDown;
		//*******************************************

		function init() {
		}

		function onChanges(changes){
			if(changes.active){
				if(changes.active && vm.value.length===0){
					updateValue();
				}
			}
		}

		function updateValue(){
			if(vm.active && vm.value.length===0) {
				nuitDataService.replaceAll(vm.value, SalesObject.getDefaultSalesObject());
			}
		}

		function moveUp(index){
			var entry = vm.value.splice(index, 1)[0];
			vm.value.splice(index - 1, 0, entry);
		}

		function moveDown(index){
			var entry = vm.value.splice(index, 1)[0];
			vm.value.splice(index + 1, 0, entry);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorReadOnlyStatis', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/readOnlyStatis/read-only-statis.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, OrderService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		vm.stati = OrderService.queue;
		vm.statis = angular.copy(vm.stati);
		vm.getStatus = getStatus;
		vm.currentStatis = [];
		vm.selected = false;
		vm.exists = exists;

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (entry !== undefined) {
					vm.currentStatis.push(entry);
				}
			}
		}

		function getStatus(status, list) {
			var idx = list.indexOf(status.id);
			if (idx > -1) {
				list.splice(idx, 1);
				vm.value.splice(idx, 1);
			} else {
				list.push(status.id);
				vm.value.push(status.id);
			}
		}

		function exists(status, list) {
			return list.indexOf(status) > -1;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorReadOnlyConditions', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/readOnlyConditions/read-only-conditions.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				type: '@'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, ConditionCheckService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		vm.conditions = ConditionCheckService.getConditions();
		vm.operators = ConditionCheckService.getOperators();
		vm.newCondition = newCondition;
		vm.newStyle = newStyle;
		vm.style = false;
		vm.styleAttribute = '';
		vm.styleValue = '';
		vm.deleteStyle = deleteStyle;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {

			if (vm.value !== undefined) {
				//	vm.value.push({style:{}});
			}
			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
				if (entry.style !== undefined) {
					vm.style = true;
				}
			}
		}

		function newCondition() {
			vm.value.push({});
		}

		function newStyle(idx) {

			if (!vm.value[idx].style) {
				vm.value[idx].style = {};
			}
			vm.value[idx].style[vm.styleAttribute] = vm.styleValue;
			vm.style = true;
			vm.styleValue = '';
			vm.styleAttribute = '';
		}

		function deleteStyle(key, style) {
			delete style[key];
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorFilters', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/queueFilters/filters.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, nuitFilterService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		vm.inputTypes = nuitFilterService.getInputTypes();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorProductFilters', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/productFilters/product-filters.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				onChange: '&',
				type: '@'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, nuitUtils, $mdDialog, $document ) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		vm.deleteElement = deleteElement;
		vm.moveUpElement = moveUpElement;
		vm.moveDownElement = moveDownElement;
		vm.addFilter = addFilter;
		vm.editFilter = editFilter;

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
			}
		}

		function addFilter(type, filters) {
			$mdDialog
				.show(generateProductsEditFilterDialog(type))
				.then(function (filter) {
					filters.push(filter);
				})
				.catch(angular.noop);
		}

		function editFilter(type, filters, filter) {
			var copy = angular.copy(filter);
			copy.index = filters.indexOf(filter);
			console.log(filter);
			console.log(filters);
			console.log(type);
			$mdDialog
				.show(generateProductsEditFilterDialog(type, copy))
				.then(function (filter) {
					filters.splice(filter.index, 1, filter);
					delete filter.index;
				})
				.catch(angular.noop);
		}

		function generateProductsEditFilterDialog(type, filter) {
			var controller = type === 'product' ? 'ProductsEditFilterController' : 'MaterialEditFilterController';
			var templateUrl = type === 'product' ?
				'app/main/system.system/dialogs/products.edit-filter/products.edit-filter.html' :
				'app/main/system.system/dialogs/material.edit-filter/material.edit-filter.html';

			return {
				controller: controller,
				controllerAs: 'vm',
				templateUrl: templateUrl,
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					Filter: filter
				}
			};
		}

		function moveUpElement(element, collection) {
			if (!element) {
				return;
			}

			var index = collection.indexOf(element);
			if (index > -1) {
				collection.splice(index, 1);
				collection.splice(index - 1, 0, element);
				doOnChnage();
			}
		}

		function moveDownElement(element, collection) {
			if (!element) {
				return;
			}

			var index = collection.indexOf(element);
			if (index > -1) {
				collection.splice(index, 1);
				collection.splice(index + 1, 0, element);
				doOnChnage();
			}
		}

		function deleteElement(element, collection) {
			if (!element) {
				return;
			}
			nuitUtils
				.showDeleteConfirmation()
				.then(function () {
					var index = collection.indexOf(element);
					if (index > -1) {
						collection.splice(index, 1);
						doOnChnage();
					}
				});
		}

		function doOnChnage() {
			if(vm.onChange){
				vm.onChange();
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorOrderStatus', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/orderStatus/order-status.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				typeFilter: '@'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, OrderService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		//*******************************************

		function init() {
			if(vm.typeFilter) {
				vm.statis = angular.copy(OrderService.getStatisByType(vm.typeFilter));
			}else{
				vm.statis = angular.copy(OrderService.queue);
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorImageUpload', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/imageUpload/image-upload.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				onChange: '&'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, imsUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.$onInit = init;
		vm.uploadImage = uploadImage;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
		}

		function uploadImage() {
			imsUtils.uploadEnvImage()
				.then(function (url) {
					vm.value = url;
				});
		}

		function doOnChange() {
			if(vm.onChange){
				vm.onChange();
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorHolidays', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/holidays/holidays.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				dirty: '='
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, $filter) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;
		vm.hasBankHolidays = hasBankHolidays;
		vm.addBankHolidays = addBankHolidays;
		vm.formatHoliday = formatHoliday;
		vm.removeHoliday = removeHoliday;
		vm.isDate = isDate;
		vm.filter = filter;

		//*******************************************

		function init() {
			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
			}
		}

		function hasBankHolidays() {
			if (vm.value.length > 0) {
				return true;
			}

		}

		function addBankHolidays() {
			if (vm.value.indexOf(vm.date.getTime() === -1)) {
				vm.value.push(vm.date.getTime());
				vm.value.sort();
				vm.date = null;
				vm.dirty = true;
			}

		}

		function formatHoliday(holiday) {
			return $filter('nuitDate')(holiday);
		}

		function removeHoliday(index) {
			vm.value.splice(index, 1);
			vm.dirty = true;
		}

		function filter(date) {
			if (hasBankHolidays()) {
				for (var index in vm.value) {
					var holiday = moment(vm.value[index]).toDate();
					if (date.getDate() === holiday.getDate() && date.getMonth() === holiday.getMonth() && date.getYear() === holiday.getYear()) {
						return false;
					}
				}
			}

			var day = date.getDay();

			return day !== 0 && day !== 6;
		}

		function isDate() {
			return angular.isDate(vm.date);
		}


	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorFormatWithLineBreaks', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/formatWithLineBreaks/format-with-line-breaks.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.lineIndex = -1;
		vm.$onInit = init;
		vm.getSplit = getSplit;
		vm.editLine = editLine;
		vm.deleteLine = deleteLine;
		vm.addLine = addLine;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
			/*for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
			}*/
		}

		function getSplit(){
			return vm.value.split('\n');
		}

		function editLine(index){
			var lines = getSplit();

			vm.lineIndex = vm.lineIndex>=0?-1:index;

			if(vm.lineIndex>=0) {
				vm.lineText = lines[index];
			}else if(vm.lineText){
				lines[index] = angular.copy(vm.lineText);
				delete vm.lineText;
				vm.value = lines.join('\n');
			}
		}

		function addLine(){
			vm.value = vm.value + '\n';
			editLine(getSplit().length-1);
		}

		function deleteLine(index){
			var lines = getSplit();
			lines.splice(index,1);
			vm.value = lines.join('\n');
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorFavorites', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/favorites/favorites.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorExportOptions', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/exportOptions/exportOptions.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {

			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configExchangeFlowId', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/exchangeFlowId/exchange-flow-id.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitDataService, $q,nuitConfig, $translate, AppService, NodeRedService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.flows = [];
		vm.$onInit = init;
		//*******************************************

		function init() {
			AppService.reload()
				.then(function(apps){
					var promises = [];
					for(var i=0;i<apps.length;i++){
						var app = apps[i];
						if(app.type === 'nodered'){
							promises.push(NodeRedService.get(app.id).getFlows());
						}
					}
					return $q.all(promises)
						.then(function(data){
							var flowArray = [];
							var usedIds = [];
							for(var i=0;i<data.length;i++)
							{
								var flows = data[i];
								if(usedIds.indexOf(flows[0].id) === -1) {
									for (var j = 0; j < flows.length; j++) {
										flowArray.push({id: flows[j].id, name: flows[j].name});
										usedIds.push(flows[j].id);
									}
								}
							}
							vm.flows = flowArray;
						});
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configExchangeAppId', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/exchangeAppId/exchange-app-id.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				typeFilter: '@'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, AppService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		//*******************************************

		function init() {
			AppService.reload()
				.then(function(apps){
					if(vm.typeFilter) {
						vm.apps = angular.copy(apps.filter(function(app){return app.type === vm.typeFilter;}));
					}else{
						vm.apps = angular.copy(apps);
					}
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorEvoCartFields', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/evoCartFields/evo-cart-fields.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				onChange: '&'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, $mdDialog, $document, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		vm.addCartField = addCartField;
		vm.editCartField = editCartField;
		vm.moveUpElement = moveUpElement;
		vm.moveDownElement = moveDownElement;
		vm.deleteElement = deleteElement;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
			}
		}

		function addCartField() {
			$mdDialog
				.show(generateCartEditFieldDialog())
				.then(function (cartField) {
					vm.value.push(cartField);
					doOnChnage();
				})
				.catch(angular.noop);
		}

		function editCartField(field) {
			var copy = angular.copy(field);
			copy.index = vm.value.indexOf(field);
			console.log(copy);
			$mdDialog
				.show(generateCartEditFieldDialog(copy))
				.then(function (cartField) {
					vm.value.splice(cartField.index, 1, cartField);
					delete cartField.index;
					doOnChnage();
				})
				.catch(angular.noop);
		}

		function generateCartEditFieldDialog(cartField) {
			return {
				controller: 'CartEditFieldController',
				controllerAs: 'vm',
				templateUrl: 'app/main/system.system/dialogs/cart.edit-field/cart.edit-field.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					Field: cartField
				}
			};
		}

		function moveUpElement(element, collection) {
			if (!element) {
				return;
			}

			var index = collection.indexOf(element);
			if (index > -1) {
				collection.splice(index, 1);
				collection.splice(index - 1, 0, element);
				doOnChnage();
			}
		}

		function moveDownElement(element, collection) {
			if (!element) {
				return;
			}

			var index = collection.indexOf(element);
			if (index > -1) {
				collection.splice(index, 1);
				collection.splice(index + 1, 0, element);
				doOnChnage();
			}
		}

		function deleteElement(element, collection) {
			if (!element) {
				return;
			}
			nuitUtils
				.showDeleteConfirmation()
				.then(function () {
					var index = collection.indexOf(element);
					if (index > -1) {
						collection.splice(index, 1);
						doOnChnage();
					}
				});
		}

		function doOnChnage() {
			if(vm.onChange){
				vm.onChange();
			}
		}


	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorEnableSelection', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/enableSelection/enable-selection.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, OrderService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.$onInit = init;
		//*******************************************

		function init() {
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorDropDown', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/dropDown/drop-down.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				selectableValues: '<',
				multiple: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, OrderService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		//*******************************************

		function init() {
			vm.mimeTypes = [
				'image/jpeg',
				'image/png',
				'application/pdf'
			];
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorDisableInvoiceStatus', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/disableInvoiceStatus/disable-invoice-status.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				type: '='
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, InvoiceService, InvoiceRemarkService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		vm.statis = [];
		vm.getStatus = getStatus;
		vm.currentStatis = [];
		vm.selected = false;
		vm.exists = exists;

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {

			if (vm.type === 'invoice') {
				vm.statis = InvoiceService.statusFields;
				InvoiceService.reloadStatus();
			}
			if (vm.type === 'remark') {
				vm.statis = InvoiceRemarkService.remarkType;
				InvoiceRemarkService.reloadType();
			}

			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (entry !== undefined) {
					vm.currentStatis.push(entry);
				}
			}
		}

		function getStatus(status, list) {
			console.log(status, list);
			var idx = list.indexOf(status.id);
			if (idx > -1) {
				list.splice(idx, 1);
				vm.value.splice(idx, 1);
			} else {
				list.push(status.id);
				vm.value.push(status.id);
			}
		}

		function exists(status, list) {
			return list.indexOf(status) > -1;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorCustomFields', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/customFields/custom-fields.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorCustomAttributes', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/customAttributes/custom-attributes.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.$onInit = init;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
			for (var i = 0; i < vm.value.length; i++) {
				var entry = vm.value[i];
				if (angular.isString(entry.name)) {
					var name = angular.copy(entry.name);
					entry.name = {};
					entry.name[vm.currentLanguage] = name;
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorColorSelection', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/colorSelection/color-selection.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<',
				onChange: '&'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, imsUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.$onInit = init;
		vm.getStyle = getStyle;
		vm.isValidHexColor = isValidHexColor;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {
		}

		function doOnChange() {
			if(vm.onChange){
				vm.onChange();
			}
		}

		function getStyle(){
			return { 'background-color': vm.value};
		}

		function isValidHexColor(){
			return new RegExp(/^#[0-9A-F]{6}$/i).test(vm.value);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorArrayOrder', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/arrayOrder/array-order.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				defaultValues:'<',
				active: '<',
			}
		});

	/** @ngInject */
	function Controller($scope, SalesObject, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.$onInit = init;
		vm.$onChanges = onChanges;
		vm.moveUp = moveUp;
		vm.moveDown = moveDown;
		vm.add = add;
		vm.remove = remove;
		//*******************************************

		function init() {
		}

		function onChanges(changes){
			if(changes.active){
				if(changes.active && vm.value.length===0){
					updateValue();
				}
			}
		}

		function updateValue(){
			if(vm.active && vm.value.length===0) {
				nuitDataService.replaceAll(vm.value, vm.defaultValues);
			}
		}

		function moveUp(index){
			var entry = vm.value.splice(index, 1)[0];
			vm.value.splice(index - 1, 0, entry);
		}

		function moveDown(index){
			var entry = vm.value.splice(index, 1)[0];
			vm.value.splice(index + 1, 0, entry);
		}

		function remove(index){
			vm.value.splice(index, 1);
		}

		function add(entry){
			vm.value.push(entry);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditorAddressesByCountry', {
			templateUrl: 'app/main/admin.environment/components/config-editor/customInput/addressesByCountry/addresses-by-country.component.html',
			controller: Controller,
			controllerAs: 'vm',
			bindings: {
				value: '=',
				active: '<'
			}
		});

	/** @ngInject */
	function Controller(nuitConfig, $translate, Countries) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.countries = Countries;
		vm.config = nuitConfig.current;
		vm.$onInit = init;
		vm.getDefault = getDefault;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isString = angular.isString;

		//*******************************************

		function init() {

		}

		function getDefault(){
			return {country: '',address:''};
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials.attributes', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.material-attributes', {
				url: '/material-attributes',
				views: {
					'content@app': {
						templateUrl: 'app/main/merchandising.materials.attributes/views/attributes.html',
						controller: 'MaterialAttributesController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.materials.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('merchandising.settings.material-attributes', {
			title: 'Attributes',
			icon: 'icon-food-variant',
			state: 'app.material-attributes',
			translate: 'MATERIAL.ATTRIBUTES',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.materials.enabled ||
				 		!nuitConfigProvider.getCurrent().ims.materials.attributes.enabled;
			}
		});
        //*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('material.attributes', 'material/attributes', {allow: ['get', 'post']});
        nuitApiProvider.register('material.attribute', 'material/attributes/:id', {allow: ['get', 'put', 'delete']});
        //*******************************************


	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials.attributes')
		.controller('ChangeDeliveryStatusDialogController', Controller);

	/** @ngInject */
	function Controller(Status, $mdDialog, nuitConfig, imsTranslation, DeliveryService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.selectedStatus = Status;
		vm.newAttribute = false;
        vm.config = nuitConfig.current;
		vm.languages = nuitConfig.current.languages;
		vm.currentLanguage = imsTranslation.language;
		vm.statis = DeliveryService.statusFields;
		vm.pickedUp = new Date();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.submit = submit;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){

			DeliveryService.reloadStatus()
				.then(function () {
					for(var i = vm.statis.length-1; i >= 0 ; i--){
						if(vm.statis[i].id === 1){
							vm.statis.splice(i, 1);
						}
					}
				});
		}
        /**
         * Closes this dialog with a positive result.
         */
		function submit() {

			vm.pickedUp = Date.parse(vm.pickedUp) / 1000;

			$mdDialog.hide([vm.selectedStatus, vm.pickedUp]);
		}

        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.transport', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider,
						 msNavigationServiceProvider,
						 nuitConfigProvider,
						 TRANSPORT_SETTINGS,
						 nuitApiProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.transport', {
				url: '/forwarders?page',
				views: {
					'content@app': {
						templateUrl: 'app/main/partners.companies/views/partners.companies.html',
						controller: 'PartnersCompaniesController as vm'
					},
					'body@app.transport': {
						templateUrl: 'app/main/partners.transport/views/forwarders-list.html',
						controller: 'ForwardersListController as vm'
					}
				},
				permissions: 'ims.transport.forwarder.enabled',
			})
			.state('app.transport.compose', {
				url: '/add?type',
				views: {
					'body@app.transport': {
						templateUrl: 'app/main/partners.companies/views/company-compose.html',
						controller: 'CompanyComposeController as vm'
					}
				},
				permissions: 'ims.transport.forwarder.enabled'
			})
			.state('app.transport.details', {
				url: '/:forwarderId?active',
				views: {
					'body@app.transport': {
						templateUrl: 'app/main/partners.transport/views/forwarders-details.html',
						controller: 'ForwarderDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.transport.forwarder.enabled',
			})
			.state('app.transport-board', {
				url: '/transport_board',
				views: {
					'content@app': {
						templateUrl: 'app/main/partners.transport/views/forwarders-delivery-board.html',
						controller: 'DeliveryBoardController as vm'
					}
				},
				permissions: 'ims.transport.deliveryCalendar.enabled',
			})
			.state('app.transport-board.detail', {
				url: '/:orderId?active?origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.orders/views/order-details.html',
						controller: 'OrderDetailsController as vm'
					},
					'forwarding@app.transport-board.detail':{
						templateUrl: 'app/main/orders.orders/views/partials/forwarding-details.html',
						controller: 'OrderForwardingDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				params:{
					active: 'forwarding'
				},
				data: {api: 'OrderService'},
				permissions: 'ims.transport.delivery.enabled'
			})
			.state('app.transport-config', {
				url: '/transport_config?active',
				views: {
					'content@app': {
						templateUrl: 'app/main/partners.transport/views/delivery-configuration.html',
						controller: 'DeliveryConfigurationController as vm'
					}
				},
				reloadOnSearch: false,
				params: {
					active: 'delay'
				},
				permissions: 'ims.transport.deliveryConfig.enabled',
			});

		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('transport.forwarders', {
			title: 'transport',
			icon: 'icon-truck',
			state: 'app.transport',
			translate: 'FORWARDERS.FORWARDERS_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.transport.forwarder.enabled;
			}
		});
		msNavigationServiceProvider.saveItem('transport.delivery_board', {
			title: 'transport-calendar',
			icon: 'icon-timetable',
			state: 'app.transport-board',
			translate: 'TRANSPORT.DELIVERY_BOARD',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.transport.deliveryCalendar.enabled;
			}
		})
		msNavigationServiceProvider.saveItem('transport.config', {
			title: 'Settings',
			icon: 'icon-cog',
			translate: 'APP.SETTINGS_NAV',
			state: 'app.transport-config',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.transport.deliveryConfig.enabled;
			}
		});

		//*******************************************
		// API ROUTES
		//*******************************************

		//Postal Code Delay

		nuitApiProvider.register('postalcodedelays', '/delivery/postalcodedelays', {allow: ['post', 'get']});
		nuitApiProvider.register('postalcodedelays.one', '/delivery/postalcodedelays/:id', {allow: ['put', 'get', 'delete']});

		//Delivery Numbers

		nuitApiProvider.register('deliverynumbers', '/delivery/deliverynumbers', {allow: ['post', 'get']});
		nuitApiProvider.register('deliverynumbers.one', '/delivery/deliverynumbers/:id', {allow: ['put', 'get', 'patch', 'delete']});
		nuitApiProvider.register('deliverynumbertemplates', '/delivery/deliverynumbertemplates', {allow: ['get']});

		//Delivery Workdays

		nuitApiProvider.register('deliveryworkdays', '/delivery/workdays', {allow: ['post', 'get']});
		nuitApiProvider.register('deliveryworkdays.one', '/delivery/workdays/:id', {allow: ['put', 'get', 'delete']});


		//FORWARDERS

		nuitApiProvider.register('forwarders', '/delivery/carriers', {allow: ['get']});
		nuitApiProvider.register('forwarders.add', '/delivery/carriers', {allow: ['post']});
		nuitApiProvider.register('forwarders.one', '/delivery/carriers/:carrierID', {allow: ['put', 'delete', 'get']});
		nuitApiProvider.register('forwarders.users', '/delivery/carriers/:carrierId/users', {allow: ['post', 'get']});
		nuitApiProvider.register('forwarders.users.one', '/delivery/carriers/:carrierId/users/:userId', {allow: ['delete']});
		nuitApiProvider.register('forwarders.users.notification', '/delivery/carriers/:carrierId/users/:userId/notifications', {allow: ['put']});
		nuitApiProvider.register('forwarders.users.urls', '/delivery/carriers/:carrierId/users/:personId/urls', {allow: ['get']});
		nuitApiProvider.register('forwarders.addresses', '/delivery/carriers/:carrierId/addresses', {allow: ['post', 'get']});
		nuitApiProvider.register('forwarders.addresses.one', '/delivery/carriers/:carrierId/addresses/:addressId', {allow: ['put', 'get', 'delete']});

		//DELIVERY

		nuitApiProvider.register('deliveries', '/delivery/deliveries', {allow: ['post', 'get']});
		nuitApiProvider.register('deliveries.one', '/delivery/deliveries/:deliveryId', {allow: ['put', 'get', 'patch', 'delete']});
		nuitApiProvider.register('deliveries.status', '/delivery/deliverystatus', {allow: ['get']});
		//*******************************************
		// SETTINGS
		//*******************************************

		nuitConfigProvider.injectIntoDefault(TRANSPORT_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.controller('PostalCodeDelayDialogController', Controller);

	/** @ngInject */
	function Controller(Delay, $mdDialog, nuitConfig, imsTranslation, InvoiceService, Countries) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.selectedDelay = Delay;
		vm.newAttribute = false;
		vm.config = nuitConfig.current;
		vm.languages = nuitConfig.current.languages;
		vm.currentLanguage = imsTranslation.language;
		vm.delay = {};
		vm.countries = Countries;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.submit = submit;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init(){

			if(Delay){
				vm.delay = Delay;
				vm.delay.delay = vm.delay.delay/86400;
			}
			vm.delay.zipCodeAsterisk = true;
		}
		/**
		 * Closes this dialog with a positive result.
		 */
		function submit() {
			vm.delay.delay = vm.delay.delay *86400;
			$mdDialog.hide(vm.delay);
		}

		/**
		 * Closes this dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.controller('DeliveryNumberDialogController', Controller);

	/** @ngInject */
	function Controller(DeliveryNumber, $mdDialog, nuitConfig, imsTranslation, DeliveryNumberService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.selectedDelay = DeliveryNumber;
		vm.config = nuitConfig.current;
		vm.languages = nuitConfig.current.languages;
		vm.currentLanguage = imsTranslation.language;
		vm.deliveryNumber = {};
		vm.deliveryNumbers = DeliveryNumberService.deliveryNumbers;
		vm.tplFields = [];
		vm.updatePossible = true;
		vm.requiredField = true;
		vm.showNumbers = false;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.submit = submit;
		vm.setTpl = setTpl;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init(){

			//reload delivery numbers and template
			DeliveryNumberService.reload().then(function () {
				vm.deliveryNumbers = DeliveryNumberService.deliveryNumbers;
				DeliveryNumberService.reloadTpl().then(function () {
					vm.tplFields = DeliveryNumberService.templateFields;
					var templateFields = angular.copy(vm.tplFields);
					vm.tplFields = [];
					templateFields.forEach(function (tplField) {
						tplField = tplField.replace(/{{|}}/gi, '');
						vm.tplFields.push(tplField);
					});
				});

				var autoRenew = 0;

				//Dialog with DeliveryNumber object - to edit one
				if (DeliveryNumber) {
					vm.deliveryNumber = DeliveryNumber;
					vm.showNumbers = true;
					vm.deliveryNumber.end = new Date((vm.deliveryNumber.end * 1000));
					vm.deliveryNumber.start = new Date((vm.deliveryNumber.start * 1000));

					if(vm.deliveryNumber.number > 0){
						vm.updatePossible = false;
					}
					if (!vm.deliveryNumber.autoRenew) {
						vm.requiredField = false;
					}

					//check autorenew from all
					vm.deliveryNumbers.forEach(function (deliveryNumber) {
						if (deliveryNumber.autoRenew) {
							autoRenew += 1;
							if (autoRenew > 1) {
								vm.requiredField = false;
							}
						}
					});
				}
				//Dialog without DeliveryNumber - to create and add a new one
				else {
					if(vm.deliveryNumbers.length > 0 ) {
						vm.deliveryNumbers.forEach(function (deliveryNumber) {
							if (!deliveryNumber.autoRenew) {
								vm.requiredField = false;
							}
						});
					}else{
						vm.deliveryNumber.autoRenew = true;
					}
				}
			});
		}
		/**
		 * Closes this dialog with a positive result.
		 */
		function submit() {
			$mdDialog.hide(vm.deliveryNumber);
		}

		/**
		 * Closes this dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		function setTpl(key) {
			if (vm.deliveryNumber.tpl === undefined) {
				vm.deliveryNumber.tpl = '';
			}
			vm.deliveryNumber.tpl = vm.deliveryNumber.tpl + '{{' + key + '}}';
			vm.deliveryNumberForm.$setDirty();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.credit', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, CREDIT_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.credit', {
				url: '/credit?term&page&start',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.credit/views/credits.html',
						controller: 'CreditsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.credit.enabled'
			})
			.state('app.credit.details', {
				url: '/:creditId?origin?companyId',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.credit/views/partials/credit-details.html',
						controller: 'CreditDetailsController as vm'
					}
				},
				permission: 'ims.credit.enabled'
			})
			.state('app.credit_number', {
				url: '/credit_number',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.settings/views/number-list.html',
						controller: 'NumberController as vm'
					}
				},
				permission: 'ims.credit.enabled'
			})
			.state('app.credit_number.credit_number_details', {
				url: '/:numberId',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.settings/views/partials/number-details.html',
						controller: 'NumberDetailsController as vm'
					}
				},
				permission: 'ims.credit.enabled'
			})
		;
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************


		msNavigationServiceProvider.saveItem('accounting.credits', {
			title: 'credits',
			icon: 'icon-cash-multiple',
			state: 'app.credit',
			translate: 'CREDIT.CREDITS_NAV',
			weight: 50,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.credit.enabled;
			}
		});


		msNavigationServiceProvider.saveItem('accounting.settings.credit_configuration', {
			title: 'credit_configuration',
			icon: 'icon-numeric',
			state: 'app.credit_number',
			translate: 'CREDIT.CREDIT_CONFIG_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.credit.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(CREDIT_SETTINGS);
		//*******************************************

		//*******************************************
		// ROUTES
		//*******************************************
		nuitApiProvider.register('credit.credits', '/accounting/creditnotes', {allow: ['post','get']});
		nuitApiProvider.register('credit.credits.one.update', '/accounting/creditnotes/:id', {allow: ['patch','get','put']});
		nuitApiProvider.register('credit.creditnumbers', '/accounting/creditnotenumbers', {allow: ['post','get']});
		nuitApiProvider.register('credit.creditnumbers.one', '/accounting/creditnotenumbers/:id', {allow: ['get','put','delete']});
		nuitApiProvider.register('credit.creditnumbers.tpl', '/accounting/creditnotenumbertemplates', {allow: ['get']});
		nuitApiProvider.register('credit.credits.status', '/accounting/creditnotestatus', {allow: ['get']});
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.credit')
		.controller('ChangeCreditStatusDialogController', Controller);

	/** @ngInject */
	function Controller(Credit, $mdDialog, nuitConfig, imsTranslation, CreditService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.selectedStatus = Credit.status;
		vm.amountRedeemed = Credit.sumRedeemed;
		vm.sumAmount = Credit.sumAmount;
		vm.newAttribute = false;
        vm.config = nuitConfig.current;
		vm.languages = nuitConfig.current.languages;
		vm.currentLanguage = imsTranslation.language;
		vm.statis = CreditService.statusFields;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.submit = submit;
		vm.onStatusChange = onStatusChange;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){

			CreditService.reloadStatus();
		}
        /**
         * Closes this dialog with a positive result.
         */
		function submit() {
			$mdDialog.hide([vm.selectedStatus, vm.amountRedeemed]);
		}

		function onStatusChange() {
			if(vm.selectedStatus === 3){
				vm.amountRedeemed = angular.copy(vm.sumAmount);
			}
			if(vm.selectedStatus === 1){
				vm.amountRedeemed = 0;
			}
		}

        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.credit')
		.controller('UpdateSumRedeemedDialogController', Controller);

	/** @ngInject */
	function Controller(Sum, Credit, Amount, $mdDialog, nuitConfig, imsTranslation, CreditService, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.sumRedeemed = Sum;
		vm.creditId = Credit;
		vm.sumAmount = Amount;

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.submit = submit;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init(){


		}
		/**
		 * Closes this dialog with a positive result.
		 */
		function submit() {

			CreditService.updateSumRedeemed(vm.creditId, vm.sumRedeemed)
				.then(function (res) {
					nuitUtils.showSuccessToast();
					$mdDialog.hide(res);
				})
				.catch(function () {
					nuitUtils.showErrorToast();
				});

		}

		/**
		 * Closes this dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.accounting', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, ACCOUNTING_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.invoice_creation', {
				url: '/invoice_creation?term?page?status',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.accounting/views/invoice-creation.html',
						controller: 'InvoiceCreationController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.accounting.enabled'
			})
			.state('app.invoice_creation.detail', {
				url: '/:orderId?active?origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.orders/views/order-details.html',
						controller: 'OrderDetailsController as vm'
					},
					'forwarding@app.invoice_creation.detail':{
						templateUrl: 'app/main/orders.orders/views/partials/forwarding-details.html',
						controller: 'OrderForwardingDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.accounting.enabled',
				data: {api: 'OrderService'}
			})
			.state('app.invoices', {
				url: '/invoices?term&page&start',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.accounting/views/invoices.html',
						controller: 'InvoicesController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.accounting.enabled'
			})
			.state('app.invoice_board', {
				url: '/invoice_board?start',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.accounting/views/invoice-board.html',
						controller: 'InvoiceBoardController as vm'
					}
				},
				permissions: 'ims.accounting.enabled'
			})
			.state('app.invoice_board.details', {
				url: '/:invoiceId?invoiceOrigin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.accounting/views/partials/invoice-details.html',
						controller: 'InvoiceDetailsController as vm'
					}
				},
				permission: 'ims.accounting.enabled'
			})
			.state('app.invoice_board.details.detail', {
				url: '/:orderId?origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.orders/views/order-details.html',
						controller: 'OrderDetailsController as vm'
					},
					'forwarding@app.invoice_board.details.detail':{
						templateUrl: 'app/main/orders.orders/views/partials/forwarding-details.html',
						controller: 'OrderForwardingDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.accounting.enabled',
				data: {api: 'OrderService'}
			})
			.state('app.invoice_board.details.credit', {
				url: '/credits/:creditId?origin?invoiceId?companyId',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.credit/views/partials/credit-details.html',
						controller: 'CreditDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.accounting.enabled'
			})
			.state('app.invoice_number', {
				url: '/invoice_number',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.settings/views/number-list.html',
						controller: 'NumberController as vm'
					}
				},
				permission: 'ims.accounting.enabled'
			})
			.state('app.invoice_number.invoice_number_details', {
				url: '/:numberId',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.settings/views/partials/number-details.html',
						controller: 'NumberDetailsController as vm'
					}
				},
				permission: 'ims.accounting.enabled'
			})
			.state('app.invoices.details', {
				url: '/:invoiceId?invoiceOrigin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.accounting/views/partials/invoice-details.html',
						controller: 'InvoiceDetailsController as vm'
					}
				},
				permission: 'ims.accounting.enabled'
			})
			.state('app.invoices.details.detail', {
				url: '/order/:orderId?origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.orders/views/order-details.html',
						controller: 'OrderDetailsController as vm'
					},
					'forwarding@app.invoices.details.detail':{
						templateUrl: 'app/main/orders.orders/views/partials/forwarding-details.html',
						controller: 'OrderForwardingDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.accounting.enabled',
				data: {api: 'OrderService'}
			})
			.state('app.invoices.details.credit', {
				url: '/credits/:creditId?invoiceId&companyId&origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.credit/views/partials/credit-details.html',
						controller: 'CreditDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.credit.enabled'
			})
		;
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('accounting.invoice_creation', {
			title: 'orders',
			icon: 'icon-cash',
			translate: 'ACCOUNTING.INVOICE_CREATION_NAV',
			state: 'app.invoice_creation',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.accounting.enabled;
			}
		});
		msNavigationServiceProvider.saveItem('accounting.settings', {
			title: 'Settings',
			icon: 'icon-cog',
			translate: 'APP.SETTINGS_NAV',
			weight: 100,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.accounting.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('accounting.invoices', {
			title: 'invoices',
			icon: 'icon-cash-multiple',
			state: 'app.invoices',
			translate: 'ACCOUNTING.INVOICES_NAV',
			weight: 20,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.accounting.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('accounting.invoice_board', {
			title: 'invoice_board',
			icon: 'icon-calendar',
			state: 'app.invoice_board',
			translate: 'ACCOUNTING.INVOICE_BOARD_NAV',
			weight: 30,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.accounting.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('accounting.settings.invoice_configuration', {
			title: 'invoice_configuration',
			icon: 'icon-numeric',
			state: 'app.invoice_number',
			translate: 'ACCOUNTING.INVOICE_CONFIG_NAV',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.accounting.enabled;
			}
		});
        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(ACCOUNTING_SETTINGS);
		//*******************************************

		//*******************************************
		// ROUTES
		//*******************************************
		nuitApiProvider.register('accounting.invoices', '/accounting/invoices', {allow: ['post','get']});
		nuitApiProvider.register('accounting.invoices.one.update', '/accounting/invoices/:id', {allow: ['patch','get','put']});
		nuitApiProvider.register('invoice.invoicenumbers', '/accounting/invoicenumbers', {allow: ['post','get']});
		nuitApiProvider.register('invoice.invoicenumbers.one', '/accounting/invoicenumbers/:id', {allow: ['get','put','delete']});
		nuitApiProvider.register('invoice.invoicenumbers.tpl', '/accounting/invoicenumbertemplates', {allow: ['get']});
		nuitApiProvider.register('accounting.invoices.status', '/accounting/invoicestatus', {allow: ['get']});
		nuitApiProvider.register('accounting.invoices.remarks', '/accounting/invoices/:invoiceId/remarks', {allow: ['get','post']});
		nuitApiProvider.register('accounting.invoices.remarks.one', '/accounting/invoices/:invoiceId/remarks/:id', {allow: ['patch','get']});
		nuitApiProvider.register('accounting.invoices.remarks.type', '/accounting/remarktypes', {allow: ['get']});
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.controller('AddRemarkDialogController', Controller);

	/** @ngInject */
	function Controller(Remark, Invoice, $state, $mdDialog, nuitConfig, imsTranslation, InvoiceService, InvoiceRemarkService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.languages = nuitConfig.current.languages;
		vm.currentLanguage = imsTranslation.language;
		vm.remarkType = InvoiceRemarkService.remarkType;
		vm.remarkTypeOptions = [];
		vm.remark = [];
		vm.showRemarkType = true;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.submit = submit;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {

			InvoiceRemarkService.reloadType()
				.then(function () {
					loadTypeOptions();
				});


			console.log(Remark);
			if (Remark) {
				InvoiceRemarkService.loadOneRemark(Invoice, Remark)
					.then(function (remark) {
						vm.remark = remark;
						if (vm.remark.type === 6) {
							vm.showRemarkType = false;
						}
					});

			}
		}

		function loadTypeOptions() {
			vm.remarkTypeOptions = angular.copy(vm.remarkType);
			for (var i = 0; i < vm.remarkTypeOptions.length; i++) {
				if (vm.remarkTypeOptions[i].id === 6) {
					vm.remarkTypeOptions.splice(i, 1);
				}
			}
		}

		/**
		 * Closes this dialog with a positive result.
		 */
		function submit() {
			if (!vm.remark.remark) {
				vm.remark.remark = '';
			}
			$mdDialog.hide(vm.remark);
		}

		/**
		 * Closes this dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials.attributes')
		.controller('ChangeStatusDialogController', Controller);

	/** @ngInject */
	function Controller(Status, $mdDialog, nuitConfig, imsTranslation, InvoiceService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.selectedStatus = Status;
		vm.newAttribute = false;
        vm.config = nuitConfig.current;
		vm.languages = nuitConfig.current.languages;
		vm.currentLanguage = imsTranslation.language;
		vm.statis = InvoiceService.statusFields;
		vm.paidAt = new Date();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.submit = submit;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){

			vm.statis = angular.copy(vm.statis);

			InvoiceService.reloadStatus()
				.then(function () {
					for(var x = vm.statis.length-1; x >= 0; x--) {
						if(vm.statis[x].id < Status){
							vm.statis.splice(x, 1);
						}
					}
				});
		}
        /**
         * Closes this dialog with a positive result.
         */
		function submit() {


            // Submit attribute
			console.log(vm.selectedStatus);
			vm.paidAt = Date.parse(vm.paidAt) / 1000;
			console.log(vm.paidAt);

			$mdDialog.hide([vm.selectedStatus, vm.paidAt]);
		}

        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, SYSTEM_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.system', {
				url: '/system?active',
				views: {
					'content@app': {
						templateUrl: 'app/main/system.system/views/system.html',
						controller: 'SystemController as vm'
					},
					'holidays@app.system':{
						templateUrl: 'app/main/system.system/views/tabs/holidays.html',
						controller: 'HolidayController as vm'
					},
				},
				reloadOnSearch: false,
				params: {
					active: 'evo'
				},
				permissions: 'ims.system.enabled'
			});

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('system.system', {
			title: 'system',
			icon: 'icon-cog',
			state: 'app.system',
			translate: 'SYSTEM.SYSTEM_NAV',
			weight: 70,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.system.enabled;
			}
		});

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('system', '/system', {allow: ['get']});
        nuitApiProvider.register('system.config', 'configurations', {allow: ['get','put'], params: {scope: 'environment'}});
        nuitApiProvider.register('system.config.one', 'configurations/:id', {allow: ['get'], params: {scope: 'environment'}});

        nuitApiProvider.register('system.folders.public', 'folder/folders', {allow: ['get', 'post']});
        nuitApiProvider.register('system.folder.public', 'folder/folders/:id', {allow: ['put', 'delete']});

        nuitApiProvider.register('system.attributes', 'shop/attributes', {allow: ['get']});

        nuitApiProvider.register('system.colors.csv', 'exchange/colors/nuit', {allow: ['put']});
		nuitApiProvider.register('system.materials.csv', 'exchange/materials/nuit', {allow: ['put', 'get']});

        nuitApiProvider.register('env.translations.languages', '/languages?scope=environment', {allow: ['get']});
        nuitApiProvider.register('env.translations', '/translations?origin=none&scope=environment&enDefault=false', {allow: ['get', 'post']});
        nuitApiProvider.register('env.translations.update', '/translations/:key', {allow: ['put'], params: {scope:'environment'} });
		nuitApiProvider.register('env.translations.delete', '/translations/:key', {allow: ['delete'], params: {scope:'environment'}});
		nuitApiProvider.register('env.translations.csv', '/translation/import?scope=environment', {allow: ['post']});

		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(SYSTEM_SETTINGS);
		//*******************************************
	}
})();

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('SystemColorEditController', SystemColorEditController);

	/** @ngInject */
	function SystemColorEditController($mdDialog, $translate, nuitConfig, Color){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.config = nuitConfig.current;
		vm.color = Color;
		vm.newColor = !vm.color;
		vm.currentLanguage = $translate.use();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
		vm.setRgb = setRgb;
		vm.setHex = setHex;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {
            if(vm.newColor) {
                vm.color = {
                    name: {
                    },
                    code: null,
                    hex: '',
                    value: {
                        r: 0,
                        g: 0,
                        b: 0
                    },
					externalId: null
                };
                vm.setHex();
            } else {
                var values = vm.color.rgb.split(',');
                vm.color.value = {
                    r: parseInt(values[0]),
                    g: parseInt(values[1]),
                    b: parseInt(values[2])
                };
            }
        }
		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
            vm.color.rgb = vm.color.value.r + "," + vm.color.value.g + "," + vm.color.value.b;
            vm.color.hex = rgbToHex(vm.color.value.r, vm.color.value.g, vm.color.value.b);

            delete vm.color.values;

			$mdDialog.hide(vm.color);
		}

        function componentToHex(c) {
            var hex = c.toString(16);
            return hex.length === 1 ? "0" + hex : hex;
        }

        function rgbToHex(r, g, b) {
            return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
        }

		function hexToRgb(hex) {
			var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result ? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16)
			} : null;
		}

		function setRgb(){
			var rgb = hexToRgb(vm.color.hex);

			if(rgb!==null){
				vm.color.value.r = rgb.r;
				vm.color.value.g = rgb.g;
				vm.color.value.b = rgb.b;
			}else{
				vm.color.hex = "";
			}
		}

		function setHex(){
			vm.color.hex = rgbToHex(vm.color.value.r, vm.color.value.g, vm.color.value.b);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('SystemDialogTranslationController', SystemDialogTranslationController);

	/** @ngInject */
	function SystemDialogTranslationController($mdDialog, translation, envLanguage, nuitConfig) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.translation = translation;
        vm.new = !translation;
        vm.availableLanguages = nuitConfig.current.languages;
        //*******************************************

		//*******************************************
		// METHODS (EXPOSURE)
		//*******************************************
		vm.save = save;
		vm.abort = abort;
        //*******************************************

        //*******************************************
        // INITIALIZATION
        //*******************************************
        init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

        function init() {
            if(vm.new) {
                vm.translation = {
                    key: "",
                    values: {}
                };

                for(var i in vm.availableLanguages) {
                    vm.translation.values[vm.availableLanguages[i]] = "";
                }
            }
        }

		function save() {
            $mdDialog.hide(vm.translation);
		}

		function abort() {
            $mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('StampingEditToolController', StampingEditToolController);

	/** @ngInject */
	function StampingEditToolController(Tool, $mdDialog, $translate, nuitConfig){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.tool = Tool;
		vm.newTool = !vm.tool;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
        vm.shapes = [];
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
        //*******************************************
        
		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************
        
		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {
            vm.shapes = ['circle', 'square', 'roundedrect'];
        }
		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}
		/**
		 * Submits the dialog form.
		 */
		function submit() {
			$mdDialog.hide(vm.tool);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('StampingEditGeneratorController', StampingEditGeneratorController);

	/** @ngInject */
	function StampingEditGeneratorController(Generator, Tools, $mdDialog, $translate, nuitConfig){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.generator = Generator;
        vm.tools = Tools;
		vm.newGenerator = !vm.generator;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
        vm.userLanguage = $translate.use();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
        //*******************************************
        
		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************
        
		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {
            if(vm.newGenerator) {
                vm.generator = { 
                    restrictionsDist: {
                        type: 'none'
                    }
                };
            }
        }
		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}
		/**
		 * Submits the dialog form.
		 */
		function submit() {
			$mdDialog.hide(vm.generator);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('ProfilesEditFolderDialogController', ProfilesEditFolderDialogController);

	/** @ngInject */
	function ProfilesEditFolderDialogController(Folder, Folders, $mdToast, $mdDialog, $translate, nuitConfig, imsTranslation) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.folder = angular.extend({ name: {}}, Folder);
        vm.folders = Folders;
		vm.languages = nuitConfig.getCurrent().languages;
		vm.currLang = $translate.use();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.save = save;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function generateUnexpectedErrorToast() {
			return $mdToast
				.simple()
				.position('bottom right')
				.textContent($translate.instant('APP.UNKNOWN_ERROR'));
		}

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){
            flatifyFolders();
			if(!vm.folder){
				return;
			} else if(!vm.folder.id) {
                vm.folder.name = {};
            }
		}

        function flatifyFolders() {
            if(!vm.folders) { return; }

            var result = [];
            for(var i in vm.folders) {
                unpack(result, vm.folders[i]);
            }
            vm.folders = result;

            function unpack(result, obj) {
                result.push(obj);
                if(obj.children) {
                    for(var i in obj.children) {
                        unpack(result, obj.children[i]);
                    }
                }
            }
        }
        /**
         * Closes this dialog with a positive result.
         */
		function save() {
			$mdDialog.hide(vm.folder);
		}
        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('ProductsEditFilterController', ProductsEditFilterController);

	/** @ngInject */
	function ProductsEditFilterController(Filter, $mdDialog, $translate, nuitConfig, nuitColors, nuitApi, EVOConfigService, nuitDataService){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filter = Filter;
		vm.newFilter = !vm.filter;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
        vm.attributes = [];
        vm.colors = nuitColors.all;
        vm.productsConfig = EVOConfigService.config.products;
        vm.selectedOptions = [];
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {
            nuitColors.reload();
            nuitApi('system.attributes')
                .get()
                .then(function(response) {
                    vm.attributes.splice(0, vm.attributes.length);
                    for(var i in response.data) {
                        var attribute = response.data[i];
                        if(!vm.newFilter && attribute.id.toString() === vm.filter.id.toString()) {
                            vm.selectedFilter = attribute;
							nuitDataService.replaceAll(vm.selectedOptions,vm.filter.values);
                        } else {
                            var unique = true;
                            for(var f in vm.productsConfig.filters.value) {
                                if(vm.productsConfig.filters.value[f].id.toString() === attribute.id.toString()) {
                                    unique = false;
                                    break;
                                }
                            }
                            if(!unique) { continue; }
                        }

                        if(attribute.type === 'enum' || attribute.type === 'number' || attribute.type === 'string') {
                            vm.attributes.push(response.data[i]);
                        }
                    }
            });
        }

		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
            var filter = {
                id: vm.selectedFilter.id,
                name: {},
                type: vm.selectedFilter.type,
				restrictedOptions: (angular.isDefined(vm.filter) && vm.filter.hasOwnProperty('restrictedOptions'))?vm.filter.restrictedOptions:false
            };

            if(!vm.newFilter && vm.filter.hasOwnProperty('index')) {
            	filter['index'] = vm.filter.index;
			}

            if(filter.type === 'enum') {
            	if(filter.restrictedOptions) {
            		filter.values = vm.selectedOptions;
				}else {
					filter.values = vm.selectedFilter.restrictions.options;
				}
            } else if(filter.type === 'generic_materialgroup' || filter.type === 'generic_colors') {
                filter.options = vm.selectedFilter.options;
            }

            switch(filter.type) {
                case 'generic_materialgroup':
                    for (var i in vm.availableLanguages) {
                        filter.name[vm.availableLanguages[i]] = $translate.instant('APP.MATERIALGROUP', null, null, vm.availableLanguages[i]);
                    }
                    break;
                case 'generic_colors':
                    for (var i in vm.availableLanguages) {
                        filter.name[vm.availableLanguages[i]] = $translate.instant('APP.COLOR', null, null, vm.availableLanguages[i]);
                    }
                    break;
                default:
                    for (var i in vm.availableLanguages) {
                        filter.name[vm.availableLanguages[i]] = vm.selectedFilter.name[vm.availableLanguages[i]];
                    }
                    break;
            }

			$mdDialog.hide(filter);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('MaterialEditFilterController', MaterialEditFilterController);

	/** @ngInject */
	function MaterialEditFilterController(Filter, $mdDialog, $translate, nuitConfig, nuitApi, EVOConfigService){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filter = Filter;
		vm.newFilter = !vm.filter;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
        vm.attributes = [];
        vm.materialConfig = EVOConfigService.config.material;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {
            nuitApi('material.attributes')
                .get()
                .then(function(response) {
                    vm.attributes.splice(0, vm.attributes.length);
                    for(var i in response.data) {
                        var attribute = response.data[i];
                        if(!vm.newFilter && attribute.id.toString() === vm.filter.id.toString()) {
                            vm.selectedFilter = attribute;
                            vm.selectedFilter.useComparator = vm.filter.useComparator;
                        } else {
                            var unique = true;
                            for(var f in vm.materialConfig.filters.value) {
                                if(vm.materialConfig.filters.value[f].id.toString() === attribute.id.toString()) {
                                    unique = false;
                                    break;
                                }
                            }
                            if(!unique) { continue; }
                        }

                        if(attribute.type === 'string'
                            || attribute.type === 'number') {
                            vm.attributes.push(response.data[i]);
                        }
                    }
            });
        }

		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
            var filter = {
                id: vm.selectedFilter.id,
                name: vm.selectedFilter.name,
                type: vm.selectedFilter.type,
				useComparator: vm.selectedFilter.useComparator
            };

            if(!vm.newFilter && vm.filter.hasOwnProperty('index')) {
            	filter['index'] = vm.filter.index;
			}

			$mdDialog.hide(filter);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('CartEditFieldController', CartEditFieldController);

	/** @ngInject */
	function CartEditFieldController(Field, $mdDialog, $translate, nuitConfig){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.field = Field;
		vm.newField = !vm.field;

		if(!vm.field){
			vm.field = {};
		}

		if(!vm.field.conditions){
			vm.field.conditions = [];
		}

		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {

        }
		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			$mdDialog.hide(vm.field);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('LogisticsAddTableController', controller);

	/** @ngInject */
	function controller($mdDialog){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.table = {};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
        //*******************************************
        
		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************
        
		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {
            
        }
		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			$mdDialog.hide(vm.table);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system.sales', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, SALES_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.sales', {
				url: '/sales?active',
				views: {
					'content@app': {
						templateUrl: 'app/main/system.sales/views/system.sales.html',
						controller: 'SalesController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.sales.enabled'
			});

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('system.sales', {
			title: 'sales',
			icon: 'icon-cart',
			state: 'app.sales',
			translate: 'SYSTEM.SALES_NAV',
			weight: 80,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.sales.enabled;
			}
		});
        //*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('sales.config', '/shop/config/profiles', {allow: ['get', 'post', 'put', 'delete']});
		nuitApiProvider.register('sales.config.special', 'shop/config/profiles/special', {allow: ['get', 'post', 'delete']});
		nuitApiProvider.register('sales.config.rawmaterials', '/shop/config/rawmaterials', {allow: ['get']});
		nuitApiProvider.register('sales.config.rawmaterials.one', '/shop/config/rawmaterials/:id', {allow: ['get', 'post', 'delete']});
        nuitApiProvider.register('sales.shop.config', '/shop/config', {allow: ['get', 'post', 'delete']});
        nuitApiProvider.register('sales.shop.pricerules', '/shop/config/products/price', {allow: ['get', 'post', 'delete']});
        nuitApiProvider.register('sales.logistic.tables', '/shop/config/logistics', {allow: ['get', 'post', 'delete']});
        nuitApiProvider.register('sales.logistic.surcharge', '/shop/config/logistics/surcharge', {allow: ['get', 'post', 'delete']});
		nuitApiProvider.register('sales.config.key', '/shop/config/:id', {allow: ['delete']});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(SALES_SETTINGS);
		//*******************************************
	}
})();

(function () {
	'use strict';

	angular
		.module('app.system.sales')
		.controller('RawMaterialPickerController', controller);

	/** @ngInject */
	function controller($mdDialog, $filter, imsMaterials, excludeIds) {
		var vm = this;

		vm.search = '';
		vm.groups = imsMaterials.groups
			.filter(function (group) { return excludeIds.indexOf(group.id) < 0; })
			.map(function (group) {
				return {
					id: group.id,
					label: $filter('nuitTranslate')(group.name, '???')
				};
			})
			.sort(function (a, b) { return a.label.localeCompare(b.label); });

		vm.group = null;
		vm.pick = pick;
		vm.cancel = cancel;
		vm.matches = matches;

		function matches(group) {
			if (!vm.search) { return true; }
			return group.label.toLowerCase().indexOf(vm.search.toLowerCase()) >= 0;
		}

		function pick() {
			$mdDialog.hide(vm.group.id);
		}

		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, EXCHANGE_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.exchange', {
				url: '/exchange?page&term',
				views: {
					'content@app': {
						templateUrl: 'app/main/system.exchange/views/exchange.html'
					},
					'body@app.exchange': {
						templateUrl: 'app/main/system.exchange/views/job-list.html',
						controller: 'JobListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.exchange.enabled'
			})
			.state('app.exchange.compose_job', {
				url: '/add',
				views: {
					'body@app.exchange': {
						templateUrl: 'app/main/system.exchange/views/job-details.html',
						controller: 'JobDetailsController as vm'
					}
				},
				permissions: 'ims.exchange.enabled'
			})
			.state('app.exchange.detail', {
				url: '/:jobId?active',
				views: {
					'body@app.exchange': {
						templateUrl: 'app/main/system.exchange/views/job-details.html',
						controller: 'JobDetailsController as vm'
					},
					'triggers@app.exchange.detail': {
						templateUrl: 'app/main/system.exchange/views/partials/triggers.html',
						controller: 'JobTriggersController as vm'
					}
				},
				params: {
					active: 'general'
				},
				reloadOnSearch: false,
				permissions: 'ims.exchange.enabled'
			})
			.state('app.exchange-apis', {
				url: '/exchange-apis?page&term',
				views: {
					'content@app': {
						templateUrl: 'app/main/system.exchange/views/api.html'
					},
					'body@app.exchange-apis': {
						templateUrl: 'app/main/system.exchange/views/api-list.html',
						controller: 'ApiListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.exchange.enabled'
			})
			.state('app.exchange-apis.compose', {
				url: '/add',
				views: {
					'body@app.exchange-apis': {
						templateUrl: 'app/main/system.exchange/views/api-details.html',
						controller: 'ApiDetailsController as vm'
					}
				},
				permissions: 'ims.exchange.enabled'
			})
			.state('app.exchange-apps', {
				url: '/exchange-apps?page&term',
				views: {
					'content@app': {
						templateUrl: 'app/main/system.exchange/views/app.html'
					},
					'body@app.exchange-apps': {
						templateUrl: 'app/main/system.exchange/views/app-list.html',
						controller: 'AppListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.exchange.enabled'
			})
			.state('app.exchange-apps.quickbooks', {
				url: '/quickbooks/:appId',
				views: {
					'body@app.exchange-apps': {
						templateUrl: 'app/main/system.exchange/views/quickbook-details.html',
						controller: 'QuickbookDetailsController as vm'
					},
					'items@app.exchange-apps.quickbooks':{
						templateUrl: 'app/main/system.exchange/views/partials/quickbook-items.html',
						controller: 'QuickbookDetailsItemsController as vm'
					},
					'customers@app.exchange-apps.quickbooks':{
						templateUrl: 'app/main/system.exchange/views/partials/quickbook-customers.html',
						controller: 'QuickbookDetailsCustomersController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.exchange.enabled'
			})
			.state('app.exchange-apps.nodered', {
				url: '/nodered/:appId',
				views: {
					'body@app.exchange-apps': {
						templateUrl: 'app/main/system.exchange/views/nodered-details.html',
						controller: 'NodeRedDetailController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.exchange.enabled'
			})
			.state('app.exchange-apps.xero', {
				url: '/xero/:appId',
				views: {
					'body@app.exchange-apps': {
						templateUrl: 'app/main/system.exchange/views/xero-details.html',
						controller: 'XeroDetailsController as vm'
					},
					'customers@app.exchange-apps.xero':{
						templateUrl: 'app/main/system.exchange/views/partials/xero-customers.html',
						controller: 'XeroDetailsCustomersController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.exchange.enabled'
			})
			.state('app.exchange-apps.sage', {
				url: '/sage/:appId',
				views: {
					'body@app.exchange-apps': {
						templateUrl: 'app/main/system.exchange/views/sage-details.html',
						controller: 'SageDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.exchange.enabled'
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('system.exchange', {
			title: 'Exchange',
			icon: 'icon-worker',
			translate: 'EXCHANGE.EXCHANGE',
			weight: 100,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.exchange.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('system.exchange.jobs', {
			title: 'Jobs',
			icon: 'icon-worker',
			state: 'app.exchange',
			translate: 'EXCHANGE.JOBS',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.exchange.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('system.exchange.apis', {
			title: 'Apps',
			icon: 'icon-key',
			state: 'app.exchange-apis',
			translate: 'EXCHANGE.APIS',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.exchange.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('system.exchange.apps', {
			title: 'Apps',
			icon: 'icon-key',
			state: 'app.exchange-apps',
			translate: 'EXCHANGE.APPS',
			weight: 20,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.exchange.enabled;
			}
		});

		//*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('exchange.jobs.all', '/exchange/jobs', {allow: ['get', 'post']});
		nuitApiProvider.register('exchange.job.one', '/exchange/jobs/:id', {allow: ['get', 'put', 'delete']});
		nuitApiProvider.register('exchange.job.one.history', '/exchange/jobs/:id/histories', {allow: ['get']});
		nuitApiProvider.register('exchange.job.one.history.one', '/exchange/jobs/:jobID/histories/:historyID', {allow: ['get']});
		nuitApiProvider.register('exchange.job.run', '/exchange/jobs/:id/start', {allow: ['post']});
		nuitApiProvider.register('exchange.job.force', '/exchange/jobs/:id/force', {allow: ['post']});
		nuitApiProvider.register('exchange.job.cancel', '/exchange/jobs/:id/abort', {allow: ['post']});
		nuitApiProvider.register('exchange.task.delete', '/exchange/tasks/:taskId', {allow: ['delete']});
		nuitApiProvider.register('exchange.task.create', '/exchange/jobs/:id/tasks', {allow: ['post','put']});
		nuitApiProvider.register('exchange.task.one', '/exchange/jobs/:jobId/tasks/:taskId', {allow: ['get']});
		nuitApiProvider.register('exchange.task.update', '/exchange/tasks/:id', {allow: ['put']});
		nuitApiProvider.register('exchange.serviceinfo', '/exchange/serviceinfo', {allow: ['get']});
		nuitApiProvider.register('exchange.triggerinfo', '/exchange/triggerinfo', {allow: ['get']});

		nuitApiProvider.register('exchange.apis', '/exchange/tokens', {allow: ['get', 'post']});
		nuitApiProvider.register('exchange.api.one', '/exchange/tokens/:id', {allow: ['delete']});

		nuitApiProvider.register('exchange.apps', '/exchange/apps', {allow: ['get', 'post']});
		nuitApiProvider.register('exchange.apps.one', '/exchange/apps/:id', {allow: ['get', 'delete']});
		nuitApiProvider.register('exchange.apps.types', '/exchange/apps/types', {allow: ['get']});
		nuitApiProvider.register('exchange.apps.tasks', 'exchange/apps/:id/tasks', {allow: ['get']});

		//quickbooks
		nuitApiProvider.register('exchange.apps.quickbooks', '/exchange/apps/:id/quickbooks', {allow: ['get', 'delete']});

		nuitApiProvider.register('exchange.apps.quickbooks.customer', '/exchange/apps/:id/quickbooks/customer', {allow: ['get']});
		nuitApiProvider.register('exchange.apps.quickbooks.customer.type', '/exchange/apps/:id/quickbooks/customer/type', {allow: ['get']});
		nuitApiProvider.register('exchange.apps.quickbooks.customer.import', '/exchange/apps/:id/quickbooks/customer/import', {allow: ['get']});

		nuitApiProvider.register('exchange.apps.quickbooks.item', '/exchange/apps/:id/quickbooks/item', {allow: ['get']});
		nuitApiProvider.register('exchange.apps.quickbooks.item.category', '/exchange/apps/:id/quickbooks/item/category', {allow: ['get']});
		nuitApiProvider.register('exchange.apps.quickbooks.item.import', '/exchange/apps/:id/quickbooks/item/import', {allow: ['get']});

		nuitApiProvider.register('exchange.apps.quickbooks.config', '/exchange/apps/:id/quickbooks/config', {allow: ['get','patch']});
		nuitApiProvider.register('exchange.apps.quickbooks.accounts', '/exchange/apps/:id/quickbooks/account', {allow: ['get','put']});
		//nuitApiProvider.register('exchange.apps.quickbooks.item.export', '/exchange/apps/quickbooks/item/export', {allow: ['get']});
		nuitApiProvider.register('exchange.apps.quickbooks.invoice.export', '/exchange/apps/:id/quickbooks/invoice', {allow: ['get']});

		//nodered
		nuitApiProvider.register('exchange.apps.nodered.flows.one', '/exchange/apps/:id/nodered/flows/:flowId', {allow: ['get','put', 'delete', 'post']});
		nuitApiProvider.register('exchange.apps.nodered.flows', '/exchange/apps/:id/nodered/flows', {allow: ['get','post']});
		nuitApiProvider.register('exchange.apps.nodered.flows.global', '/exchange/apps/:id/nodered/flows/global', {allow: ['get','post']});
		nuitApiProvider.register('exchange.apps.nodered.flow.upload', 'exchange/apps/:id/nodered/flows/:flowId/upload', {allow: ['post']});
		nuitApiProvider.register('exchange.apps.nodered.flow.execute', 'exchange/apps/:appId/nodered/flows/:flowId/execute',{allow:['get']});


		nuitApiProvider.register('exchange.triggers', '/exchange/jobs/:id/triggers', {allow: ['post']});
		nuitApiProvider.register('exchange.triggers.one', '/exchange/triggers/:id', {allow: ['delete']});
		nuitApiProvider.register('exchange.transferinfo', '/exchange/transferinfo', {allow: ['get']});

		//xero
		nuitApiProvider.register('exchange.apps.xero', '/exchange/apps/:id/xero/token', {allow: ['get', 'delete']});
		nuitApiProvider.register('exchange.apps.xero.connections', '/exchange/apps/:id/xero/connections', {allow: ['get']});
		nuitApiProvider.register('exchange.apps.xero.config', '/exchange/apps/:id/xero/config', {allow: ['patch']});
		nuitApiProvider.register('exchange.apps.xero.contacts', '/exchange/apps/:id/xero/contacts', {allow: ['get']});
		nuitApiProvider.register('exchange.apps.xero.contacts.import', '/exchange/apps/:id/xero/contacts/import', {allow: ['get']});
		nuitApiProvider.register('exchange.apps.xero.export.order', '/exchange/apps/:id/xero/invoice', {allow: ['post']});

		//sage
		nuitApiProvider.register('exchange.apps.sage.parts.import', '/exchange/apps/:id/sage/parts/import', {allow: ['post']});
		nuitApiProvider.register('exchange.apps.sage.clients.import', '/exchange/apps/:id/sage/clients/import', {allow: ['post']});

		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(EXCHANGE_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('ErrorLogController', ErrorLogController);

	/** @ngInject */
	function ErrorLogController(nuitApi, JOB_ID, HISTORY_ID) {

		var vm = this;

		init();

		function init() {
			nuitApi('exchange.job.one.history.one', JOB_ID, HISTORY_ID)
				.get()
				.then(function(response){
					vm.history = response.data;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('NewTriggerController', NewTriggerController);

	/** @ngInject */
	function NewTriggerController($mdDialog, trigger, nuitConfig, JobViewService, TriggerService) {

		var vm = this;

		init();

		function init() {
			vm.triggerInfo = [];
			vm.newTrigger = trigger === null;
			vm.trigger = vm.newTrigger ? {conditions:{}} : angular.copy(trigger);
			vm.save = save;
			vm.hide = hide;
			vm.onTypeChanged = onTypeChanged;
			vm.readableCron = JobViewService.readableCron;
			vm.timezones = moment.tz.names();
			vm.config = nuitConfig.getCurrent();

			TriggerService.getTriggerInfo()
				.then(function(response){
					for(var key in response){
						vm.triggerInfo.push(response[key]);
						vm.triggerInfo[vm.triggerInfo.length-1].id = key;

						if(!vm.newTrigger){
							if(vm.trigger.type===vm.triggerInfo[vm.triggerInfo.length-1].id){
								vm.trigger.type = vm.triggerInfo[vm.triggerInfo.length-1];
							}
						}
					}
				});
		}

		function save() {
			if (vm.form.$invalid) {
				return;
			}

			$mdDialog.hide(vm.trigger);
		}

		function onTypeChanged(){
			vm.trigger.value = '';
			vm.trigger.timezone = vm.trigger.type==='cron'?vm.config.localization.timeZone.code:'';
		}

		function hide() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('NewTaskController', NewTaskController);

	/** @ngInject */
	function NewTaskController($mdDialog, nuitConfig, nuitUtils, nuitDataService, job, task, ExchangeService, AppService) {

		var vm = this;

		init();

		function init() {
			vm.job = job;
			vm.newTask = task === null;
			vm.task = vm.newTask ? {} : angular.copy(task);
			vm.config = nuitConfig.getCurrent();
			vm.save = save;
			vm.hide = hide;
			vm.onServiceChanged = onServiceChanged;
			vm.onMethodChanged = onMethodChanged;
			vm.reloadAppTasks = reloadAppTasks;
			vm.updateAppTasks = updateAppTasks;
			vm.taskTypeChanged = taskTypeChanged;
			vm.serviceInfo = {};
			vm.transferInfo = {};
			vm.transferInfoLoaded = false;
			vm.taskTypes = ['format','app'];
			vm.taskType = (!vm.newTask && vm.task.app.id)?'app':'format';
			console.error('ttskdls',vm.task,vm.taskType);
			vm.apps = AppService.apps;
			vm.appTasks = [];

			ExchangeService.getServiceInfo()
				.then(function(serviceInfo){
					nuitDataService.replaceOneEntity(vm.serviceInfo,serviceInfo.formats);

					if(!vm.newTask){
						vm.service = nuitDataService.getOneByKeys(vm.serviceInfo,{name:vm.task.format});
						vm.task.method = nuitDataService.getOneByKeys(vm.service.methods,{name:vm.task.method});
						onMethodChanged();
					}
				});

			ExchangeService.getTransferInfo()
				.then(function (transferInfo) {
					nuitDataService.replaceOneEntity(vm.transferInfo, transferInfo);
					vm.transferInfoLoaded = true;
				});

			AppService.reload()
				.then(function(){
					if(!vm.newTask && vm.task.app.id){
						reloadAppTasks();
					}
				});
		}

		function save() {
			if (vm.form.$invalid) {
				return;
			}

			if(vm.task.app){
				//var app = nuitDataService.getOne(vm.apps,vm.task.app.id);
				//var task = nuitDataService.getOne(vm.appTasks,vm.task.app.taskId);
				//vm.task.
			}else {
				vm.task.service = vm.service.name;
			}

			if (vm.newTask) {
				addTask();
			}
			else {
				updateTask();
			}
		}

		function addTask() {
			ExchangeService.createTask(vm.job, getSanitizedTask())
				.then(function () {
					hide();
					nuitUtils.showSuccessToast();
				})
				.catch(function () {
					nuitUtils.showErrorToast();
				});
		}

		function updateTask() {
			var task = getSanitizedTask();
			task.id = vm.task.id;

			ExchangeService.updateTask(vm.job, task)
				.then(function () {
					hide();
					nuitUtils.showSuccessToast();
				})
				.catch(function () {
					nuitUtils.showErrorToast();
				});
		}

		function getSanitizedTask(){
			if(vm.taskType==='format') {
				var task = {};
				task.format = vm.task.service;
				task.type = vm.task.method.type;
				task.method = vm.task.method.name;
				task.transfer = vm.task.transfer;

				return task;
			}else{
				var app = nuitDataService.getOne(vm.apps,vm.task.app.id);
				var taskObject = nuitDataService.getOne(vm.appTasks,vm.task.app.taskId);

				if(app){
					vm.task.app.type = app.type;
					vm.task.app.name = app.name + ' - ' + taskObject.name;
				}
				return vm.task;
			}
		}

		function onServiceChanged(){
			vm.task.format = vm.service.name;
			vm.task.type = vm.service.type;
			vm.task.method = '';
			vm.task.format = '';
			vm.task.transfer = null;
		}

		function onMethodChanged(){
			var contentTypes = nuitDataService.getOneByKeys(vm.transferInfo.fields,{name:'contentType'});
				nuitDataService.replaceAll(contentTypes.values, vm.task.method.contentTypes);
		}

		function hide() {
			$mdDialog.cancel();
		}

		function updateAppTasks(){
			reloadAppTasks()
				.finally(function(){
					if(vm.task.app.id){
						if(vm.task.app.type) {
							delete vm.task.app.taskId;
						}
						console.error('update app!',vm.task.app);
					}
				});
		}

		function reloadAppTasks(){
			return AppService.getTasks(vm.task.app.id)
				.then(function(tasks){
					nuitDataService.replaceAll(vm.appTasks,tasks);
				});
		}

		function taskTypeChanged(){
			vm.task = {};
			if(this.taskType==='app'){
				vm.task['app'] = {};
			}
			console.error('app!',vm.task);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('NewFlowController', NewFlowController);

	/** @ngInject */
	function NewFlowController($mdDialog, types, globalFlows) {

		var vm = this;
		vm.types = types;
		vm.globalFlows = globalFlows;
		vm.flowTypes = ['local', 'global'];
		vm.selectedType = vm.flowTypes[0];

		init();

		function init() {
			vm.save = save;
			vm.hide = hide;
			vm.clearFlow = clearFlow;
			vm.clearFlow();
			vm.isType = isType;
		}

		function clearFlow() {
			vm.flow = {
				id: undefined
			};
		}

		function isType(type) {
			return vm.selectedType === type;
		}

		function save() {
			if (vm.form.$invalid) {
				return;
			}

			$mdDialog.hide(vm.flow);
		}

		function hide() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('NewAppController', NewAppController);

	/** @ngInject */
	function NewAppController($mdDialog, types) {

		var vm = this;

		init();

		function init() {
			vm.save = save;
			vm.hide = hide;
			vm.types = types;
			vm.app = {};
		}

		function save() {
			if (vm.form.$invalid) {
				return;
			}

			$mdDialog.hide(vm.app);
		}

		function hide() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue', ['app.production.general'])
		// Toggle for projectName in the production order name (release hotfix
		// 433ce872): resolves each order's project in the create-order dialog.
		// Off on develop - set to true to enable it again.
		.constant('QUEUE_PROJECT_NAMES_ENABLED', false)
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitApiProvider, nuitConfigProvider, PRODUCTION_QUEUE_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.production-queue', {
				url: '/production/queue?status?term',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.queue/views/production-queue.html',
						controller: 'ProductionQueueListController as vm'
					}
				},
				permissions: 'ims.queue.enabled',
				reloadOnSearch: false
			})
			.state('app.production-queue.detail', {
				url: '/orders/:orderId?active',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.queue/views/production-queue-detail.html',
						controller: 'ProductionQueueDetailsController as vm'
					}
				},
				permissions: 'ims.queue.enabled',
				reloadOnSearch: false
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('production.queue', {
			title: 'queue',
			icon: 'icon-clock',
			state: 'app.production-queue',
			translate: 'QUEUE.QUEUE_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.queue.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('queue.order', 'production/orders', {allow: ['post'], versions:[2]});
		nuitApiProvider.register('queue.materials', '/production/profilematerials', {allow: ['get']});
		nuitApiProvider.register('queue.estimation', 'production/times/estimations', {allow: ['get'], versions:[{number: 2, path: '/v2/productiontime'}]});

		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(PRODUCTION_QUEUE_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue')
		.controller('QueueCreateOrderController', QueueCreateOrderController);

	/** @ngInject */
	function QueueCreateOrderController($filter, $q, Orders, $mdDialog, ProductionQueueService, nuitUtils, nuitErrorService, nuitDataService, nuitConfig, ProductionPlanningService, FormatterService, OrderService, ProjectService, QUEUE_PROJECT_NAMES_ENABLED) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.orders = Orders;
		vm.planningBoards = [];
		vm.config = nuitConfig.current;

		var completionDate = angular.isNumber(vm.orders[0].details.completionDate) ? vm.orders[0].details.completionDate : Math.round((new Date()).getTime() / 1000);

		vm.newOrder = {name: '', completionDate: completionDate, orders: getOrderIds(), hours: 0, minutes: 0};
		vm.completionDate = completionDate;
		vm.productionDate = 0;
		vm.inProgress = false;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		/**
		 * Initializes this controller.
		 */
		function init() {
			ProductionPlanningService.getPlanningBoards()
				.then(function (response) {
					if (response && response.length > 0) {
						vm.planningBoards = response;

						// Set default planningBoardId
						vm.newOrder.boardId = vm.planningBoards[0].id;
					}
				});

			for (var i in vm.orders) {
				if (angular.isNumber(vm.orders[i].details.completionDate) && vm.orders[i].details.completionDate < vm.completionDate) {
					vm.completionDate = vm.orders[i].details.completionDate;
				}
			}

			vm.completionDate = Math.max(vm.completionDate,Date.now()/1000);

			vm.completionDate = new Date(vm.completionDate * 1000);

			var orderHasProductionDate = false;

			for(var i in vm.orders){
				if(angular.isNumber(vm.orders[i].details.productionDate)){
					vm.productionDate = Number.MAX_VALUE;
					orderHasProductionDate = true;
					break;
				}
			}

			for (var i in vm.orders) {
				if (angular.isNumber(vm.orders[i].details.productionDate) && vm.orders[i].details.productionDate < vm.productionDate) {
					vm.productionDate = vm.orders[i].details.productionDate;
				}
			}

			if(orderHasProductionDate) {
				vm.productionDate = new Date(vm.productionDate * 1000);
			}else{
				vm.productionDate = new Date(Date.now());
			}

			ProductionQueueService.getEstimation(vm.newOrder.orders)
				.then(function (response) {
					vm.newOrder.hours = Math.floor(response/3600);
					vm.newOrder.minutes = Math.floor((response-vm.newOrder.hours*3600)/60);
				});

			if(vm.config.ims.queue.productionOrderName!==''){
				loadProjectNames().then(buildOrderName);
			}
		}

		/**
		 * The essential list view has no projectId, so the order details are loaded
		 * to assign projectName to each passed order (only if a format uses it).
		 */
		function loadProjectNames() {
			if (!QUEUE_PROJECT_NAMES_ENABLED || angular.toJson(vm.config.ims.queue.productionOrderName).indexOf('projectName') < 0) {
				return $q.when();
			}

			return $q.all(Orders.map(function (order) {
				return OrderService.loadOrder(order.id)
					.then(function (detail) {
						var project = detail.projectId ? ProjectService.getByUuid(detail.projectId) : null;
						order.projectName = project ? project.name : '';
					})
					.catch(function () {
						order.projectName = '';
					});
			}));
		}

		function buildOrderName() {
			var orderNames = Orders.map(function(order){return FormatterService.format(vm.config.ims.queue.productionOrderName.shopOrderFormat, order);}).join(', ');

			vm.newOrder.name = FormatterService.format(vm.config.ims.queue.productionOrderName.format,{
				orderNames: orderNames,
				orders: Orders,
				completionDate: $filter('nuitDatetime')(vm.completionDate.getTime() / 1000, 'date')
			},true).slice(0,255);
		}

		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			vm.inProgress = true;

			vm.newOrder.completionDate = parseInt(vm.completionDate.getTime() / 1000);
			vm.newOrder.productionDate = parseInt(vm.productionDate.getTime() / 1000);

			ProductionQueueService.createProductionOrder(vm.newOrder)
				.then(function () {
					nuitUtils.showSuccessToast();
					$mdDialog.hide();
				})
				.catch(function (response) {
					nuitErrorService.handle(response.data);
				})
				.finally(function () {
					vm.inProgress = false;
				});
		}

		function getOrderIds() {
			return nuitDataService.getUnique(vm.orders).map(function (currentValue) {
				return parseInt(currentValue.id,10);
			});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.planning.boards', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.planning-boards', {
				url: '/production/planning-boards?index',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.planning.boards/views/boards.html',
						controller: 'ProductionPlanningBoardsController as vm'
					},
					'planningBoard@app.planning-boards': {
						templateUrl: 'app/main/production.planning.boards/views/tabs/planning-board.html',
						controller: 'ProductionPlanningBoardController as vm'
					}
				},
				params: {
					index: '0'
				},
				reloadOnSearch: false,
				permissions: 'ims.planning.boards.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('production.planning', {
			title: 'Planning',
			icon: 'icon-calendar-clock',
			translate: 'PRODUCTION.PLANNING',
			state: 'app.planning-boards',
			weight: 30,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.planning.boards.enabled;
			}
		});

        //*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************

        //*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.planning.boards')
		.controller('UpdateProductionDateDialogController', UpdateProductionDateDialogController);

	/** @ngInject */
	function UpdateProductionDateDialogController($mdDialog, nuitConfig) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.productionDate = new Date(Date.now());
		vm.config = nuitConfig.current;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.save = save;
		vm.filterDates = filterDates;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){

		}

		function close() {
			$mdDialog.cancel();
		}

		function save() {
			// Datepicker uses different timestamp format
			var productionDate = Math.floor(vm.productionDate.getTime());
        	$mdDialog.hide(productionDate);
        }

		function filterDates(date){
			return vm.config.ims.planning.boards.workDays.indexOf(date.getDay())!==-1;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.planning.boards')
		.controller('UpdatePlanningBoardDialogController', UpdatePlanningBoardDialogController);

	/** @ngInject */
	function UpdatePlanningBoardDialogController($mdDialog, nuitConfig, ProductionPlanningService, planningBoardId) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.planningBoards = ProductionPlanningService.planningBoards;
        vm.planningBoardId = planningBoardId;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
       
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.save = save;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
            
		}

		function close() {
			$mdDialog.cancel();
		}

		function save() {
           $mdDialog.hide(vm.planningBoardId);        
        }
	}
}());

(function () {
	'use strict';
	angular
	  .module('app.production.planning.boards')
	  .component('planningEventMenu', {
		  templateUrl: 'app/main/production.planning.boards/components/planning-event-menu/planning-event-menu.component.html',
		  controllerAs: 'vm',
		  controller: Controller,
		  bindings: {
              isFlipped: '=',
              onFlip: '&',
			  onOpen: '&',
              onDetailClick: '&'
		  }
	  });

	function Controller(){
		var vm = this;

		vm.open = open;

		function open(){
			vm.onFlip();

			if(vm.onOpen) {
				vm.onOpen();
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders', ['app.production.general','nuit.solution'])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, PRODUCTION_ORDERS_SETTINGS, NUIT_SOLUTION_CONFIG) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.production-orders', {
				url: '/production/orders?group?term?page?startFilterDate?endFilterDate',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.orders/views/production-orders.html',
						controller: 'ProductionOrdersListController as vm'
					}
				},
				permissions: 'ims.productionOrders.enabled',
				reloadOnSearch: false
			})
			.state('app.production-orders.details', {
				url: '/:orderId?active?origin?searchId',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.orders/views/production-orders-detail.html',
						controller: 'ProductionOrderDetailsController as vm'
					},
					'profiles@app.production-orders.details':{
						templateUrl: 'app/main/production.orders/views/tabs/profiles.html',
						controller: 'ProductionOrderProfilesController as vm'
					},
					'geometries@app.production-orders.details':{
						templateUrl: 'app/main/production.orders/views/tabs/geometries.html',
						controller: 'ProductionOrderGeometriesController as vm'
					},
					'production@app.production-orders.details':{
						templateUrl: 'app/main/production.orders/views/tabs/production.html',
						controller: 'ProductionController as vm'
					},
					'planning@app.production-orders.details':{
						templateUrl: 'app/main/production.orders/views/tabs/planning.html',
						controller: 'ProductionOrderPlanningController as vm'
					}
				},
				permissions: 'ims.productionOrders.enabled',
				reloadOnSearch: false
			})
			.state('app.production-part',{
				url: '/production/part/:partId?origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.orders/views/production-order-part.html',
						controller: 'ProductionOrderPartController as vm'
					}
				},
				permissions: 'ims.productionOrders.enabled'
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('production.orders', {
			title: 'orders',
			icon: 'icon-factory',
			state: 'app.production-orders',
			translate: 'PRODUCTION_ORDERS.PRODUCTION_ORDERS_NAV',
			weight: 20,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.productionOrders.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('production.orders', 'production/orders', {allow: ['get'], versions:[2]});
		nuitApiProvider.register('production.orders.documents', 'production/orders/:id/status/documents', {allow: ['get'], versions:[2]});
		nuitApiProvider.register('production.orders.solutions', 'production/orders/:id/status/solutions', {allow: ['get'], versions:[2]});
		nuitApiProvider.register('production.orders.solutions.recreate', 'production/orders/:id/tasks/solutions/recreate', {allow: ['post'], versions:[2]});
		nuitApiProvider.register('production.order', 'production/orders/:id', {allow: ['get', 'delete', 'put'], versions:[2]});
		nuitApiProvider.register('production.order.jobs', 'production/orders/:id/machinejobs', {allow: ['get'], versions:[2]});
		nuitApiProvider.register('production.order.job.produce', 'production/orders/:orderId/machinejobs/:jobId/produce', {allow: ['get'], versions:[2]});
		nuitApiProvider.register('production.produce', 'production/orders/:id/produce', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('production.reset', 'production/orders/:id/reset', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('production.finish', 'production/orders/:id/finish', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('production.status', 'production/orders/:id/productionstatus', {allow: ['get'], versions:[2]});
		nuitApiProvider.register('production.solution.customdata', '/production/solutions/:id/customdata', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('production.solutions.optimize', '/cuttingoptimization/solutions', {allow: ['put']});
		nuitApiProvider.register('production.solutions.optimize.v2', '/production/v2/cuttingoptimization/solutions', {allow: ['put']});
		nuitApiProvider.register('production.solutions.machinesolution', '/cuttingoptimization/machinesolutions', {allow: ['put']});
		nuitApiProvider.register('production.solutions.machinesolution.v2', 'production/v2/cuttingoptimization/machinesolutions', {allow: ['put']});
		nuitApiProvider.register('production.producible', 'production/orders/:id/producible', {allow: ['get'], versions:[2]});
		nuitApiProvider.register('production.solution.update', 'production/solutions/:id', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('productionprofiles.manualworkmachine', 'production/productionprofiles/:id/manualworkmachine', {allow: ['put', 'delete'], versions:[2]});
		nuitApiProvider.register('productionprofiles.offset', 'production/productionprofiles/:id/offset', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('productionprofiles.cuttingmachine', 'production/productionprofiles/:id/cuttingmachine', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('productionprofiles.cuttingmachines', 'production/cuttingmachines', {allow: ['get','put'], versions:[2]});
		nuitApiProvider.register('productionprofiles.bendingmachine', 'production/productionprofiles/:id/bendingmachine', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('productionprofiles.bendingmachines', 'production/bendingmachines', {allow: ['get','put'], versions:[2]});
		nuitApiProvider.register('productionprofiles.punchingmachine', 'production/productionprofiles/:id/punchingmachine', {allow: ['put', 'delete'], versions:[2]});
		nuitApiProvider.register('productionprofiles.punchingmachines', 'production/punchingmachines', {allow: ['put'], versions:[2]});
		// v2 only - no v1 counterpart
		nuitApiProvider.register('productionprofiles.punchingprogram.v2', 'production/v2/productionprofiles/:id/punchingprogram', {allow: ['post']});
		nuitApiProvider.register('productionprofiles.punchingprogram.prepare.v2', 'production/v2/productionprofiles/:id/punchingprogram/prepare', {allow: ['post']});
		nuitApiProvider.register('productionprofiles.dxf.v2', 'production/v2/productionprofiles/:id/dxf', {allow: ['get']});
		nuitApiProvider.register('punchingprograms.program.v2', 'machine/v2/punchingprograms/:id/program', {allow: ['delete']});
		nuitApiProvider.register('productionprofiles.one', 'production/productionprofiles/:id/position', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('productionprofiles.get.one', 'production/productionprofiles/:id', {allow: ['get'], versions:[2]});
		nuitApiProvider.register('productionprofiles.get.all', 'production/orders/:id/productionprofiles', {allow: ['get'], versions:[2]});

		nuitApiProvider.register('production.part', 'production/productionprofiles', {allow: ['get'], versions:[2]});
		nuitApiProvider.register('production.parts.cut', 'production/parts/:id/cut', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('production.parts.stamped', 'production/parts/:id/stamped', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('production.parts.bended', 'production/parts/:id/bended', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('production.parts.complaints', 'production/parts/:id/complains', {allow: ['post'], versions:[2]});
		nuitApiProvider.register('production.parts.customdata', 'production/parts/:id/customdata', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('production.parts.produced.set', 'production/parts/:id/produced/set', {allow: ['put'], versions:[2]});
		nuitApiProvider.register('production.parts.produced.unset', 'production/parts/:id/produced/unset', {allow: ['put'], versions:[2]});

		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		PRODUCTION_ORDERS_SETTINGS.ims.productionOrders['solution'] = angular.copy(NUIT_SOLUTION_CONFIG);
		nuitConfigProvider.injectIntoDefault(PRODUCTION_ORDERS_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.constant('NUIT_SOLUTION_ROOT','app/main/nuit-solution');
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.controller('SolutionController', SolutionController);

	/** @ngInject */
	function SolutionController($timeout,$mdDialog, $state, nuitConfig, Solution, EnableUi, EnableComplain, LimitJobs, ReadOnly, nuitApiProxy, nuitUtils, ListSelectionService, DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.solution = Solution;
		vm.solutionConfig = DotNotationService.get(nuitConfig.getCurrent(),'ims.productionOrders.solution',{});
		vm.solutionCopy = null;
		vm.oldSolutions = [];
		vm.oldSolutions.push(angular.copy(vm.solution));
		vm.selectedSolutionIndex = -1;
		vm.touchedElements = ListSelectionService.get('solution.touchedElements');
		vm.showMachineJob = false;
		vm.limitJobs = LimitJobs;
		vm.enableUi = EnableUi !== undefined ? EnableUi : true;
		vm.readOnly = ReadOnly !== undefined ? ReadOnly : false;
		vm.enableComplain = EnableComplain !== undefined ? EnableComplain: false;

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.submit = submit;
		vm.optimize = optimize;
		vm.setSolution = setSolution;
		vm.toggleMachineJob = toggleMachineJob;
		vm.deleteSolution = deleteSolution;
		vm.solutionHasChanged = solutionHasChanged;

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function close() {
			$mdDialog.hide();
		}

		function submit() {
			nuitApiProxy('production.solution.update', vm.solution.id).put(
				vm.solution
			).then(hideAndReload)
			.catch(nuitUtils.showErrorToast);
		}

		function optimize() {
			if(vm.solutionConfig.renderer.tag==='svg') {
				var oldId = vm.solution.id;
				nuitApiProxy('production.solutions.optimize').put(vm.solution)
					.then(function (response) {
						vm.touchedElements.deselectAll();
						vm.solution = response.data;
						vm.solution.id = oldId;
						vm.oldSolutions.push(angular.copy(vm.solution));
						vm.selectedSolutionIndex = vm.oldSolutions.length - 1;
					}).catch(nuitUtils.showErrorToast);

				vm.solution = {jobs: []};
			}else{
				nuitApiProxy('production.solutions.optimize').put(vm.solution)
					.then(function (response) {
						vm.touchedElements.deselectAll();
						var oldId = vm.solution.id;
						vm.solution = response.data;
						vm.solution.id = oldId;
						vm.oldSolutions.push(angular.copy(vm.solution));
						vm.selectedSolutionIndex = vm.oldSolutions.length - 1;
					}).catch(nuitUtils.showErrorToast);
			}
		}

		function setSolution(index) {
			if(vm.solutionConfig.renderer.tag==='svg') {
				vm.solution = {jobs: []};
				$timeout(function () {
					vm.solution = angular.copy(vm.oldSolutions[index]);
				}, 10);
			}else{
				vm.solution = angular.copy(vm.oldSolutions[index]);
			}
		}

		function toggleMachineJob() {
			if(vm.solutionConfig.renderer.tag==='svg') {
				if (vm.showMachineJob) {
					vm.solutionCopy = angular.copy(vm.solution);
					nuitApiProxy('production.solutions.machinesolution').put(vm.solution)
						.then(function (response) {
							vm.touchedElements.deselectAll();
							vm.solution = response.data;
						});
					vm.solution = {jobs: []};
				} else {
					vm.solution = {jobs: []};
					$timeout(function () {
						vm.solution = vm.solutionCopy;
					}, 10);
				}
			}else{
				if (vm.showMachineJob) {
					nuitApiProxy('production.solutions.machinesolution').put(vm.solution)
						.then(function (response) {
							vm.touchedElements.deselectAll();
							vm.solutionCopy = vm.solution;
							vm.solution = response.data;
						});
				} else {
					vm.solution = vm.solutionCopy;
				}
			}
		}

		function hideAndReload() {
			$mdDialog.hide(vm.solution);
			$state.reload();
		}

		function deleteSolution() {
			vm.oldSolutions.splice(vm.selectedSolutionIndex, 1);
			vm.selectedSolutionIndex = Math.max(0, Math.min(vm.selectedSolutionIndex, vm.oldSolutions.length - 1));
			vm.setSolution(vm.selectedSolutionIndex);
		}

		function solutionHasChanged() {
			var selected = vm.touchedElements.getSelected();
			var needsOptimization = false;

			for (var i = 0; i < selected.length; i++) {
				var element = selected[i];
				if (
					element.length !== element.originalLength ||
					element.height !== element.originalHeight ||
					element.manualWork !== element.originalManualWork) {
					needsOptimization = true;
					break;
				}
			}

			vm.overallLength = 0;

			if(vm.solution) {
				for (var j = 0; j < vm.solution.jobs.length; j++) {
					vm.overallLength += vm.solution.jobs[j].length;
				}
			}

			return needsOptimization || (vm.solution && vm.solution.originalHeight !== vm.solution.height);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.controller('LabelController', LabelController);

	/** @ngInject */
	function LabelController($mdDialog, label, nuitConfig, nuitUtils, PrinterService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.label = label;

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.print = print;

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function close() {
			$mdDialog.cancel();
		}

		function print() {
			PrinterService.addPrintJob({ 'label': vm.label })
				.then(function () {
					$mdDialog.hide();
					nuitUtils.showSuccessToast();
				})
				.catch(nuitUtils.showErrorToast);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.component('batchUpdater', {
			templateUrl: 'app/main/production.orders/components/batch-updater/batch-updater.html',
			controller: BatchUpdaterController,
			controllerAs: 'vm',
			bindings: {
				//ngModel: '=',
				materialInfos: '<',
				coilMachines: '<',
				bendingMachines: '<',
				punchingMachines: '<',
				onSave: '<'
			}
		});

	/** @ngInject */
	function BatchUpdaterController($filter, nuitConfig, ListSelectionService, nuitDataService, imsMaterials, BendingMachineService, PunchingMachineService) {
		//*******************************************
		// CONTROLLER
		//*******************************************
		var vm = this;
		vm.selection = ListSelectionService.get('production.profile', true);

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.open = false;

		vm.loading = false;
		vm.config = nuitConfig.getCurrent();

		vm.enabledCoil = false;
		vm.coilMachine = null;
		vm.coilMaterial = null;
		vm.coilMaterialWidth = 0;
		vm.coilId = null;
		vm.coils = [];

		vm.enabledBend = false;
		vm.manualBends = false;
		vm.bendingMachine = null;
		vm.bendingMaterial = null;
		vm.bendingMaterials = [];

		vm.enabledPunch = false;
		vm.punchingMachine = null;
		vm.punchingMaterialThickness = 0;
		vm.punchingMaterial = null;
		vm.punchingMaterials = [];


		vm.updateCoilMaterials = updateCoilMaterials;
		vm.updateCoil = updateCoil;
		vm.isDefaultCoilMaterial = isDefaultCoilMaterial;

		vm.updateBendingMaterials = updateBendingMaterials;
		vm.isDefaultBendingMaterial = isDefaultBendingMaterial;
		vm.reuseBendingPrograms = reuseBendingPrograms;

		vm.updatePunchingMaterials = updatePunchingMaterials;

		vm.displaySingleCoil = displaySingleCoil;

		vm.disableSave = disableSave;
		vm.save = save;

		vm.getName = function(material){
			return $filter('nuitTranslate')(material.name);
		};

		function updateCoilMaterials(){
			vm.coilMaterial = null;
			vm.coilId = null;
			vm.coilMaterialWidth = 0;
			vm.coils = nuitDataService.replaceAll(vm.coils,[]);
			imsMaterials
				.getMaterialsOfCoilMachine(vm.coilMachine.id)
				.then(function(coils) {
					nuitDataService.replaceAll(vm.coils,nuitDataService.getUnique(angular.copy(coils)));
				});
		}

		function updateCoil(){
			var coil;

			if(vm.coilMaterial.coils.length===1) {
				vm.coilId = vm.coilMaterial.coils[0].id;
			}

			if(vm.coilId==='' || vm.coilId) {
				coil = vm.coilMaterial.coils.find(function (coil) {
					return coil.id === vm.coilId;
				});
			}

			if(coil){
				vm.coilMaterialWidth = coil.width;
			}else{
				vm.coilMaterialWidth = 0;
			}
		}

		function updateBendingMaterials(){
			vm.bendingMaterial = null;
			vm.bendingMaterials = nuitDataService.replaceAll(vm.bendingMaterials,[]);
			BendingMachineService.reloadMaterials(vm.bendingMachine.id)
				.then(function (materials) {
					nuitDataService.replaceAll(vm.bendingMaterials,angular.copy(materials));
				});
		}

		function updatePunchingMaterials(){
			vm.punchingMaterialThickness = 0;
			vm.punchingMaterial = null;
			vm.punchingMaterials = nuitDataService.replaceAll(vm.punchingMaterials,[]);
			PunchingMachineService.reloadMaterials(vm.punchingMachine.id)
				.then(function(materials){
					nuitDataService.replaceAll(vm.punchingMaterials,angular.copy(materials));
				});
		}

		function isDefaultCoilMaterial(material) {
			var selected = vm.selection.getSelected();

			if(selected.length===1) {
				return selected[0].material.coils.filter(function (m) {
					return m.machineId === vm.coilMachine.id && m.machineMaterialId === material.id;
				}).length > 0;
			}else
			{
				return false;
			}
		}

		function isDefaultBendingMaterial(material) {
			var selected = vm.selection.getSelected();

			if(selected.length===1) {
				return selected[0].material.bendings.filter(function(m){
					return m.bendingMachineId===vm.bendingMachine.id && m.bendingMaterialId === material.id;
				}).length>0;
			}else{
				return false;
			}
		}

		function displaySingleCoil(){
			if(vm.coilMaterial && vm.coilMaterial.coils && vm.coilMaterial.coils.length===1){
				return $filter('nuitTranslate')(vm.coilMaterial.name) !== $filter('nuitTranslate')(vm.coilMaterial.coils[0].name);
			}

			return false;
		}

		function reuseBendingPrograms() {
			var machine;

			if(vm.bendingMachine) {
				machine = nuitDataService.getOne(vm.bendingMachines, vm.bendingMachine.id);
			}

			if (machine && machine.hasOwnProperty('reuseBendingPrograms')) {
				return machine.reuseBendingPrograms;
			} else {
				return false;
			}
		}

		function disableSave(){
			return	vm.selection.getSelected().length===0 ||
					vm.loading ||
					!(vm.enabledCoil || vm.enabledPunch || vm.enabledBend) ||
					(vm.enabledCoil && !vm.coilMachine) ||
					(vm.enabledPunch && !vm.punchingMachine) ||
					(vm.enabledBend && !vm.bendingMachine);
		}

		function save(){
			if(vm.onSave){
				var data = {};

				if(vm.coilMachine && vm.enabledCoil){
					data.coil = {
						coils: vm.coils,
						machine: vm.coilMachine,
						material: vm.coilMaterial,
						width: vm.coilMaterialWidth,
						coilId: (vm.coilMaterial && vm.coilMaterial.coils && vm.coilMaterial.coils.length===1)?vm.coilMaterial.coils[0].id:vm.coilId
					};
				}

				if(vm.bendingMachine && vm.enabledBend){
					data.bend = {
						materials: vm.bendingMaterials,
						machine: vm.bendingMachine,
						material: vm.bendingMaterial,
						//manual: vm.manualBends
					};
				}

				if(vm.punchingMachine && vm.enabledPunch){
					data.punch = {
						materials: vm.punchingMaterials,
						machine: vm.punchingMachine,
						material: vm.punchingMaterial,
						thickness: vm.punchingMaterialThickness
					};
				}

				vm.loading = true;

				vm.onSave(vm.selection.getSelected(),data)
					.finally(function(){
						vm.loading = false;
					});
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products', ['app.products.attributes', 'app.products.tags'])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, PRODUCTS_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.products', {
				url: '/products?category&index&term&page',
				views: {
					'content@app': {
						templateUrl: 'app/main/merchandising.products/views/products.html',
						controller: 'ProductsController as vm'
					},
					'body@app.products': {
						templateUrl: 'app/main/merchandising.products/views/product-list.html',
						controller: 'ProductListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.products.enabled'
			})
			.state('app.products.compose', {
				url: '/add?externalId&active',
				views: {
					'body@app.products': {
						templateUrl: 'app/main/merchandising.products/views/product-compose.html',
						controller: 'ProductComposeController as vm'
					}
				},
                reloadOnSearch: false,
				permissions: 'ims.products.enabled'
			})
			.state('app.products.detail', {
				url: '/:itemId?externalId&active',
				views: {
					'body@app.products': {
						templateUrl: 'app/main/merchandising.products/views/product-details.html',
						controller: 'ProductDetailsController as vm'
					}
				},
                reloadOnSearch: false,
				permissions: 'ims.products.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('merchandising.products', {
			title: 'Products',
			icon: 'icon-nutriton',
			translate: 'MATERIALS.ARTICLES_NAV',
			state: 'app.products',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.products.enabled
			}
		});
        //*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('products.list', 'shop/products', {allow: ['get', 'post']});
		nuitApiProvider.register('products.list.v2', 'shop/v2/products', {allow: ['get']});
        nuitApiProvider.register('products.single', 'shop/products/:id', {allow: ['get', 'put', 'delete']});
        nuitApiProvider.register('products.categories', 'shop/categories', {allow: ['get', 'post']});
        nuitApiProvider.register('products.category', 'shop/categories/:id', {allow: ['delete', 'put']});
        nuitApiProvider.register('products.attributes', 'shop/attributes', {allow: ['get']});
        nuitApiProvider.register('products.tags', 'shop/tags', {allow: ['get']});
        //*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(PRODUCTS_SETTINGS);
        //*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products')
		.controller('TransferDialogController', TransferDialogController);

	/** @ngInject */
	function TransferDialogController($mdDialog, Transfer, TransferService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.isNew = Transfer.id === undefined;
		vm.transfer = angular.extend({}, TransferService.sanitizeTransferFormat(Transfer));
		vm.transferService = TransferService;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.save = save;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){
		}
        /**
         * Closes this dialog with a positive result.
         */
		function save() {
			$mdDialog.hide(vm.transfer);
		}
        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, PRODUCTION_MACHINES_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.machines', {
				url: '/machines',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.machines/views/coil-machine-list.html',
						controller: 'CoilMachineListController as vm'
					}
				},
				permissions: 'ims.machines.enabled'
			})
			.state('app.machines.coil', {
				url: '/coil-machines',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.machines/views/coil-machine-list.html',
						controller: 'CoilMachineListController as vm'
					}
				},
				permissions: 'ims.machines.enabled'
			})
			.state('app.machines.bending', {
				url: '/bending-machines',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.machines/views/bending-machine-list.html',
						controller: 'BendingMachineListController as vm'
					}
				},
				permissions: 'ims.machines.enabled'
			})
			.state('app.machines.punching', {
				url: '/punching-machines',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.machines/views/punching-machine-list.html',
						controller: 'PunchingMachineListController as vm'
					}
				},
				permissions: 'ims.machines.enabled'
			})
			.state('app.machines.bending.details', {
				url: '/details/:machineId',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.machines/views/partials/bending-machine-details.html',
						controller: 'BendingMachineDetailsController as vm'
					}
				},
				permissions: 'ims.machines.enabled'
			})
			.state('app.machines.coil.details', {
				url: '/details/:machineId',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.machines/views/partials/coil-machine-details.html',
						controller: 'CoilMachineDetailsController as vm'
					}
				},
				permissions: 'ims.machines.enabled'
			})
			.state('app.machines.punching.details', {
				url: '/details/:machineId',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.machines/views/partials/punching-machine-details.html',
						controller: 'PunchingMachineDetailsController as vm'
					}
				},
				permissions: 'ims.machines.enabled'
			})
			.state('app.machines.bending.add', {
				url: '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.machines/views/partials/bending-machine-details.html',
						controller: 'AddBendingMachineController as vm'
					}
				},
				permissions: 'ims.machines.enabled'
			})
			.state('app.machines.coil.add', {
				url: '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.machines/views/partials/coil-machine-details.html',
						controller: 'AddCoilMachineController as vm'
					}
				},
				permissions: 'ims.machines.enabled'
			})
			.state('app.machines.punching.add', {
				url: '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.machines/views/partials/punching-machine-details.html',
						controller: 'AddPunchingMachineController as vm'
					}
				},
				permissions: 'ims.machines.enabled'
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('production.settings.coil', {
			title: 'Bending Machine',
			icon: 'icon-oil',
			state: 'app.machines.coil',
			translate: 'MACHINES.COIL_MACHINES',
			weight: 50,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.machines.enabled || !nuitConfigProvider.getCurrent().ims.machines.coil.enabled;
			}
		});
		msNavigationServiceProvider.saveItem('production.settings.bending', {
			title: 'Bending Machine',
			icon: 'icon-oil',
			state: 'app.machines.bending',
			translate: 'MACHINES.BENDING_MACHINES',
			weight: 40,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.machines.enabled || !nuitConfigProvider.getCurrent().ims.machines.bending.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('production.settings.punching', {
			title: 'Punching Machine',
			icon: 'icon-oil',
			state: 'app.machines.punching',
			translate: 'MACHINES.PUNCHING_MACHINES',
			weight: 40,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.machines.enabled  || !nuitConfigProvider.getCurrent().ims.machines.punching.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************;
		nuitConfigProvider.injectIntoDefault(PRODUCTION_MACHINES_SETTINGS);
		//*******************************************

		nuitApiProvider.register('machines.nusync.token', 'machine/bendingmachines/:id/nusync/token', {allow: ['get'], versions: [2]});

		nuitApiProvider.register('bendingmachine.transfer', 'machine/bendingmachines/:id/transfers/:transferId', {allow: ['put', 'delete'], versions: [2]});
		nuitApiProvider.register('bendingmachine.transfer.add', 'machine/bendingmachines/:id/transfers', {allow: ['post'], versions: [2]});

		nuitApiProvider.register('coilmachine.nusync.token', 'machine/coilmachines/:id/nusync/token', {allow: ['get'], versions: [2]});
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.controller('TwinDialogController', TwinDialogController);

	/** @ngInject */
	function TwinDialogController($sce, $scope, $mdDialog) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		var CHANNEL_NAME = 'nulink-twin';
		var CLOSE_TIMEOUT = 3000;

		vm.channel = null;
		vm.connected = false;
		vm.closing = false;
		vm.loading = true;
		vm.errors = [];

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.iframeLoaded = iframeLoaded;
		vm.twinLocation = twinLocation;
		vm.closeDialog = closeDialog;

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Resolves the machineui (nuLink Twin) location.
		 * ?token=latest forwards to latest.nulink.twin... on non-localhost hosts.
		 * @returns {*} trusted resource url
		 */
		function twinLocation() {
			// TODO: move to config (e.g. config.ims.productionOrders.twin.location) once the POC settles
			var twinUrl = 'https://twin.nu-it.com/?token=latest';

			// Uncomment for local development
			//twinUrl = 'http://localhost:3002/';

			return $sce.trustAsResourceUrl(twinUrl);
		}

		/**
		 * Called by the iframe-onload directive: once at link time (before the
		 * iframe has loaded) and again for each 'load' event of the iframe.
		 * @param {HTMLIFrameElement} iframe
		 */
		function iframeLoaded(iframe) {
			if (vm.channel) {
				// Subsequent invocation = the iframe actually fired 'load'
				vm.loading = false;
				$scope.$applyAsync();
				return;
			}

			// TODO: restrict the accepted origin for production
			// (e.g. vm.channel.$.validateOrigin(['https://twin.nu-it.com'], true))
			vm.channel = window.IFrameChannel.createIFrameChannel(CHANNEL_NAME, iframe);
			console.debug('[nulink-twin] IMS: host channel created, waiting for machineui client (iframe src: ' + iframe.src + ')');

			vm.channel.$.addEventListener('connection-change', function (status) {
				console.debug('[nulink-twin] IMS: connection status changed ->', status);
				vm.connected = status === 'connected';
				$scope.$applyAsync();
			});

			vm.channel.$.addEventListener('connected', function () {
				console.debug('[nulink-twin] IMS <-> machineui: channel connected (MessageChannel established)');
			});

			vm.channel.$.addEventListener('closed', function () {
				console.debug('[nulink-twin] IMS <-> machineui: channel closed');
			});

			vm.channel.addEventListener('ready', function () {
				console.debug('[nulink-twin] IMS <-> machineui: communication established (client reported ready)');

				// No data is passed for now. Later the current context (order, part, ...)
				// goes here, mimicking the editor dialog's setConfig()/setProfile().
				// vm.channel.setConfig({...});
			});
		}

		/**
		 * Closes this dialog. Notifies the client via a 'close' call first and
		 * waits (bounded) for its response before tearing down the channel.
		 */
		function closeDialog() {
			if (!vm.channel || !vm.connected) {
				destroyAndCancel();
				return;
			}

			vm.closing = true;

			var done = false;
			var timeout = setTimeout(function () {
				if (!done) {
					done = true;
					addError('Client did not acknowledge close within ' + CLOSE_TIMEOUT + 'ms');
					destroyAndCancel();
				}
			}, CLOSE_TIMEOUT);

			vm.channel.close()
				.then(function (response) {
					console.debug('[nulink-twin] close acknowledged:', response);
				})
				.catch(function (error) {
					addError('close() failed: ' + (error && error.message ? error.message : error));
				})
				.then(function () {
					if (!done) {
						done = true;
						clearTimeout(timeout);
						destroyAndCancel();
					}
				});
		}

		function destroyAndCancel() {
			if (vm.channel) {
				vm.channel.$.destroy();
				vm.channel = null;
			}
			$mdDialog.cancel();
		}

		/**
		 * POC error output: log and show in the dialog's error bar.
		 * @param {string} message
		 */
		function addError(message) {
			console.error('[nulink-twin] ' + message);
			vm.errors.push(message);
			$scope.$applyAsync();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.general', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock(msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider) {
		//*******************************************
		// API ROUTES
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		//*******************************************


		msNavigationServiceProvider.saveItem('production.settings', {
			title: 'Settings',
			icon: 'icon-cog',
			translate: 'APP.SETTINGS_NAV',
			weight: 50,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.planning.boards.enabled
					&& !nuitConfigProvider.getCurrent().ims.machines.enabled
					&& !nuitConfigProvider.getCurrent().ims.machines.coil.enabled
					&& !nuitConfigProvider.getCurrent().ims.machines.punching.enabled
					&& !nuitConfigProvider.getCurrent().ims.machines.bending.enabled;


			}
		});

		nuitApiProvider.register('download.bending.program', 'machine/bendingmachines/:id/bendingfiles', {allow: ['get'], versions: [2]});
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.general')
		.controller('BendFileDownloadController', BendFileDownloadController);

	/** @ngInject */
	function BendFileDownloadController($timeout, $mdDialog, BendFileDownloadService, BendingMachineService, Profile) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		vm.cancel = cancel;
		vm.save = save;
		vm.getDownloadUrl = getDownloadUrl;

		init();

		vm.machines = BendingMachineService.machines;
		vm.machineId = -1;
		vm.profile = Profile;

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){
			BendingMachineService.reload()
				.then(function(){
					if(vm.machines.length>0){
						for(var i=0;i<vm.machines.length;i++){
							var machine = vm.machines[i];
							if(machine.enabled && !machine.manualWork){
								vm.machineId = vm.machines[i].id;
								break;
							}
						}
					}
				});
		}
        /**
         * Closes this dialog with a positive result.
         */
		function save() {
			$mdDialog.hide();
		}
        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}

		function getDownloadUrl(){
			return BendFileDownloadService.downloadUrl(vm.machineId,vm.profile.id);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.general', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock(nuitConfigProvider, nuitApiProvider) {
		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('companies', '/company/companies', {allow: ['get']});
		nuitApiProvider.register('companies.add', '/company/companies', {allow: ['post']});
		nuitApiProvider.register('companies.one', '/company/companies/:id', {allow: ['put','delete', 'get']});
		//nuitApiProvider.register('companies.one.include.users', '/company/companies/:id/users', {allow: ['get']});
		nuitApiProvider.register('companies.users','/company/companies/:companyId/users',{allow: ['post', 'get']});
		nuitApiProvider.register('companies.users.one','/company/companies/:companyId/users/:personId',{allow: ['put','delete']});
		nuitApiProvider.register('companies.users.urls','/company/companies/:companyId/users/:personId/urls',{allow: ['get']});

		nuitApiProvider.register('companies.addresses', '/company/companies/:id/addresses', {allow: ['post']});
		nuitApiProvider.register('companies.deliveryAddresses', '/company/companies/:id/deliveryaddresses', {allow: ['post']});

		nuitApiProvider.register('addresses.one', '/company/addresses/:id', {allow: ['delete','put']});
		nuitApiProvider.register('deliveryAddresses.one', '/company/deliveryaddresses/:id', {allow: ['delete','put']});

		nuitApiProvider.register(
			'companies.discounts.rawmaterial',
			'/company/companies/:id/discounts/rawmaterials/:rawMaterialId',
			{allow: ['delete','put']}
			);

		nuitApiProvider.register('companies.companynumbers', '/company/customernumbers', {allow: ['post','get']});
		nuitApiProvider.register('companies.companynumbers.one', '/company/customernumbers/:id', {allow: ['get','put','delete']});
		nuitApiProvider.register('companies.companynumbers.tpl', '/company/customernumbertemplates', {allow: ['get']});
		nuitApiProvider.register('companies.triggers', 'notifications/triggers/nsq', {allow: ['get']});


		//*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
			ims: {}
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.general')
		.controller('NewAddressController', NewAddressController);

	/** @ngInject */
	function NewAddressController($mdDialog, nuitConfig, address, type, Countries) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.address = address?angular.copy(address):{countryCode: nuitConfig.current.environment.companyData.countryCode};
		vm.header = type==='deliveryAddresses'?'COMPANY.DELIVERY_ADDRESS':'COMPANY.BILLING_ADDRESS';
		vm.countries = Countries;

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.save = save;

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function close() {
			$mdDialog.cancel();
		}

		function save() {
			$mdDialog.hide(vm.address);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials', ['app.materials.attributes', 'app.materials.groups','app.materials.sales'])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, MATERIALS_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.materials', {
				url: '/materials?group&index&term&attributes&page',
				views: {
					'content@app': {
						templateUrl: 'app/main/merchandising.materials/views/materials.html',
						controller: 'MaterialsController as vm'
					},
					'body@app.materials': {
						templateUrl: 'app/main/merchandising.materials/views/material-list.html',
						controller: 'MaterialListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.materials.enabled'
			})
			.state('app.materials.compose', {
				url: '/add',
				views: {
					'body@app.materials': {
						templateUrl: 'app/main/merchandising.materials/views/material-compose.html',
						controller: 'MaterialComposeController as vm'
					}
				},
				permissions: 'ims.materials.enabled'
			})
			.state('app.materials.detail', {
				url: '/:materialId?active',
				views: {
					'body@app.materials': {
						templateUrl: 'app/main/merchandising.materials/views/material-details.html',
						controller: 'MaterialDetailsController as vm'
					},
					'bending@app.materials.detail':{
						templateUrl: 'app/main/merchandising.materials/views/material-details-bending.html',
						controller: 'MaterialDetailsBendingController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.materials.enabled'
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('merchandising.materials', {
			title: 'Materials',
			icon: 'icon-texture',
			state: 'app.materials',
			translate: 'MATERIALS.MATERIALS_NAV',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.materials.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('merchandising.settings', {
			title: 'Settings',
			icon: 'icon-cog',
			translate: 'APP.SETTINGS_NAV',
			weight: 20,
			hidden: function () {
				var hidden = true;

				if(nuitConfigProvider.getCurrent().ims.materials.enabled){
					hidden =
						hidden &&
						!nuitConfigProvider.getCurrent().ims.materials.attributes.enabled &&
						!nuitConfigProvider.getCurrent().ims.materials.groups.enabled &&
						!nuitConfigProvider.getCurrent().ims.materials.batchEditing.price;
				}

				if(nuitConfigProvider.getCurrent().ims.products.enabled) {
					hidden =
						hidden &&
						!nuitConfigProvider.getCurrent().ims.products.attributes.enabled &&
						!nuitConfigProvider.getCurrent().ims.products.tags.enabled;
				}

				return hidden;
			}
		});

		//*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('materials.sheets', '/material/materials/:id/sheets', {allow: ['get', 'post']});
		nuitApiProvider.register('materials.sheets.one', '/material/materials/:id/sheets/:sheetId', {allow:['put', 'delete']});
		nuitApiProvider.register('materials.coils.one', '/material/materials/:id/coils/machines/:machineId', {allow: ['post','put', 'delete']});
		nuitApiProvider.register('materials.coils.all', '/material/materials/:id/coils', {allow: ['get']});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(MATERIALS_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.controller('EditOrderTagDialogController', EditOrderTagDialogController);

	/** @ngInject */
	function EditOrderTagDialogController(Tag, $mdDialog, nuitConfig, nuitUtils, imsTranslation, UserService, imsUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.isNew = Tag===undefined;
		vm.tag = angular.extend({}, Tag);
		vm.languages = nuitConfig.getCurrent().languages;
		vm.userSelection = false; //might be removed //nuitConfig.getCurrent().ims.users.enabled===true;
		vm.currentLanguage = imsTranslation.language;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.save = save;
		vm.openUserSelection = openUserSelection;
		vm.currentUser = {};
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){
			if(vm.userSelection && vm.tag.userId) {
				UserService.getUserById(vm.tag.userId)
					.then(function (user) {
						vm.currentUser = user;
					});
			}
		}
        /**
         * Closes this dialog with a positive result.
         */
		function save() {
			$mdDialog.hide(vm.tag);
		}
        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}

		function openUserSelection(){
			UserService.getUsers()
				.then(function(response) {
					var selection = [];

					UserService.getUsers()
						.then(function (response) {
							for (var j = 0; j < response.length; j++) {
								selection.push(response[j]);
							}

							return imsUtils.openUserSelection(
								selection,
								{singleSelect: true, header: 'APP.RESTORE', cancel: 'APP.CANCEL', confirm: 'APP.OK',showRoles:true}
							)
								.then(function (data) {
									vm.tag.userId = data.users[0].id;
									vm.currentUser = data.users[0];
								});
						});
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies', ['app.partners.general'])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider,
						 msNavigationServiceProvider,
						 nuitConfigProvider,
						 PARTNERS_COMPANIES_SETTINGS) {

		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.partners-companies', {
				url: '/companies?term&mode&page',
				views: {
					'content@app': {
						templateUrl: 'app/main/partners.companies/views/partners.companies.html',
						controller: 'PartnersCompaniesController as vm'
					},
					'body@app.partners-companies': {
						templateUrl: 'app/main/partners.companies/views/companies-list.html',
						controller: 'CompaniesListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.companies.enabled'
			})
			.state('app.partners-companies.compose', {
				url: '/add?type',
				views: {
					'body@app.partners-companies': {
						templateUrl: 'app/main/partners.companies/views/company-compose.html',
						controller: 'CompanyComposeController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.companies.enabled'
			})
			.state('app.partners-companies.details', {
				url: '/:companyId?active&invoiceId&invoiceOrigin&start',
				views: {
					'body@app.partners-companies': {
						templateUrl: 'app/main/partners.companies/views/company-details.html',
						controller: 'CompanyDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.companies.enabled'
			})
			.state('app.partners-companies.details.credit_details', {
				url: '/credits/:creditId?companyId?origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.credit/views/partials/credit-details.html',
						controller: 'CreditDetailsController as vm'
					}
				},
				permission: 'ims.credit.enabled'
			})
			.state('app.partners-companies.details.invoice_details', {
				url: '/invoice/:invoiceId?invoiceOrigin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.accounting/views/partials/invoice-details.html',
						controller: 'InvoiceDetailsController as vm'
					}
				},
				permission: 'ims.accounting.enabled'
			})
			.state('app.partners-companies.details.invoice_details.order', {
				url: '/order/:orderId?origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.orders/views/order-details.html',
						controller: 'OrderDetailsController as vm'
					}
				},
				permission: 'ims.accounting.enabled',
				data: {api: 'OrderService'}
			})
			.state('app.partners-companynumbers', {
				url: '/company_numbers',
				views: {
					'content@app': {
						templateUrl: 'app/main/partners.companies/views/company-numbers.html',
						controller: 'CompanyNumbersController as vm'
					}
				},
				permission: 'ims.companies.enabled'
			})
			.state('app.partners-companynumbers.details', {
				url: '/:companynumberId',
				views: {
					'content@app': {
						templateUrl: 'app/main/partners.companies/views/partials/company-numbers.details.html',
						controller: 'CompanyNumbersDetailsController as vm'
					}
				},
				permission: 'ims.companies.enabled'
			})

		;

		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('partners.settings', {
			title: 'Settings',
			icon: 'icon-cog',
			translate: 'APP.SETTINGS_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.companies.enabled || !nuitConfigProvider.getCurrent().ims.companies.companyNumbersEnabled;
			}
		});
		msNavigationServiceProvider.saveItem('partners.companies', {
			title: 'companies',
			icon: 'icon-domain',
			state: 'app.partners-companies',
			translate: 'PARTNERS.COMPANIES_NAV',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.companies.enabled ;
			}
		});
		msNavigationServiceProvider.saveItem('partners.settings.company_number', {
			title: 'company_number',
			icon: 'icon-numeric',
			state: 'app.partners-companynumbers',
			translate: 'COMPANY.COMPANY_NUMBERS',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.companies.enabled || !nuitConfigProvider.getCurrent().ims.companies.companyNumbersEnabled;
			}
		});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(PARTNERS_COMPANIES_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.controller('AddNotificationUser', AddNotificationUser);

	/** @ngInject */
	function AddNotificationUser($mdDialog, nuitConfig, imsMaterials, CompanyNotification, Users) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.users = angular.copy(Users);
		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.save = save;

		init();

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){

		}

		function close() {
			$mdDialog.cancel();
		}

		function save() {
			$mdDialog.hide(vm.user);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.controller('RawMaterialDiscountController', RawMaterialDiscountController);

	/** @ngInject */
	function RawMaterialDiscountController($mdDialog, nuitConfig, discount, currentDiscounts, imsMaterials, RawMaterialDiscount) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.isNew = discount?false:true;
		vm.discount = discount?angular.copy(discount):{percent:0};
		vm.rawMaterials = RawMaterialDiscount.rawMaterials;

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.save = save;

		init();

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
			RawMaterialDiscount.reload(currentDiscounts);
		}

		function close() {
			$mdDialog.cancel();
		}

		function save() {
			$mdDialog.hide(vm.discount);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.controller('AddTriggerController', AddTriggerController);

	/** @ngInject */
	function AddTriggerController($mdDialog, nuitConfig, imsMaterials, CompanyNotification, Company) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.company = angular.copy(Company);
		vm.triggers = CompanyNotification.triggers;
		vm.availableTriggers = [];

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.save = save;

		init();

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
			CompanyNotification.reload()
				.finally(function(){
					console.log(vm.company.notification);
					for(var i=0;i<vm.triggers.length;i++) {
						var trigger = vm.triggers[i];
						if (!vm.company.notification.trigger || !vm.company.notification.trigger.hasOwnProperty(trigger)) {
							vm.availableTriggers.push(trigger);
						}
					}
				});
		}

		function close() {
			$mdDialog.cancel();
		}

		function save() {
			$mdDialog.hide(vm.trigger);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.controller('AddNotificationAdditional', AddNotificationAdditional);

	/** @ngInject */
	function AddNotificationAdditional($mdDialog, $translate, nuitConfig) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
		vm.contactData = {lang:vm.currentLanguage};
		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.save = save;

		init();

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){

		}

		function close() {
			$mdDialog.cancel();
		}

		function save() {
			$mdDialog.hide(vm.contactData);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.component('companyTrigger', {
			templateUrl: 'app/main/partners.companies/components/company-trigger/company-trigger.html',
			controller: CompanyTrigger,
			controllerAs: 'vm',
			bindings: {
				company: '='
			}
		});

	/** @ngInject */
	function CompanyTrigger(CompanyNotification, nuitDataService, nuitUtils) {
		//*******************************************
		// CONTROLLER
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.$onInit = init;
		vm.remove = CompanyNotification.remove;
		vm.update = CompanyNotification.update;
		vm.getValidUsers = CompanyNotification.getValidUsers;
		vm.addUser = addUser;
		vm.addAdditional = addAdditional;
		vm.removeReceiver = removeReceiver;
		vm.getPerson = getPerson;

		function init(){

		}

		function addUser(trigger){
			CompanyNotification.addUser(trigger, vm.company)
				.then(function(userId){
					vm.company.notification.trigger[trigger].receivers.push({userId: userId});
					vm.update(vm.company);
				});
		}

		function addAdditional(trigger){
			CompanyNotification.addAdditional(trigger)
				.then(function(data){
					vm.company.notification.trigger[trigger].receivers.push({contactData:data});
					vm.update(vm.company);
				});
		}

		function removeReceiver(trigger, index){
			nuitUtils.showDeleteConfirmation()
				.then(function(){
					vm.company.notification.trigger[trigger].receivers.splice(index, 1);
					vm.update(vm.company);
				});
		}

		function getPerson(id){
			return nuitDataService.getOne(vm.company.users,id);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.controller('EditTagDialogController', EditTagDialogController);

	/** @ngInject */
	function EditTagDialogController(Tag, $mdDialog, nuitConfig, nuitUtils, imsTranslation) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.tag = angular.extend({}, Tag);
		vm.languages = nuitConfig.getCurrent().languages;
		vm.currLang = imsTranslation.language;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.save = save;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){
			if(!vm.tag){
				return;
			} else if(!vm.tag.id) {
                vm.tag.name = {};
            }
		}
        /**
         * Closes this dialog with a positive result.
         */
		function save() {
			$mdDialog.hide(vm.tag);
		}
        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products.attributes', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.attributes', {
				url: '/attributes',
				views: {
					'content@app': {
						templateUrl: 'app/main/merchandising.products.attributes/views/attributes.html',
						controller: 'AttributesController as vm'
					}
				},
				reloadOnSearch: false,
				permission: 'ims.products.attributes.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('merchandising.settings.product-attributes', {
			title: 'Attributes',
			icon: 'icon-food-variant',
			state: 'app.attributes',
			translate: 'PRODUCTS.ATTRIBUTES',
			weight: 20,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.products.enabled ||
				 		!nuitConfigProvider.getCurrent().ims.products.attributes.enabled;
			}
		});
        //*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('product.attributes', 'shop/attributes', {allow: ['get', 'post']});
        nuitApiProvider.register('product.attribute', 'shop/attributes/:id', {allow: ['get', 'put', 'delete']});
        //*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products.attributes')
		.controller('EditAttributeDialogController', EditAttributeDialogController);

	/** @ngInject */
	function EditAttributeDialogController(Attribute, $mdDialog, nuitUtils, nuitConfig, imsMaterials, imsTranslation, imsColors) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.attribute = angular.extend({}, Attribute);
        vm.newAttribute = false;
        vm.config = nuitConfig.current;
		vm.languages = nuitConfig.current.languages;
		vm.currentLanguage = imsTranslation.language;
        vm.materials = imsMaterials.materials;
        vm.materialGroups = imsMaterials.groups;
        vm.colors = imsColors.colors;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.loadMaterialGroups = loadMaterialGroups;
        vm.loadMaterials = loadMaterials;
        vm.loadColors = loadColors;
		vm.cancel = cancel;
		vm.submit = submit;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){
			if(!vm.attribute || !vm.attribute.id){
                vm.newAttribute = true;

                vm.attribute = {
                    name: {},
                    type: 'string',
                    restrictions: {
                        options: []
                    }
                };
            } else {
                if(vm.attribute.type === 'material') {
                    loadMaterials();
                    loadMaterialGroups();
                }
            }
		}
        /**
         * Closes this dialog with a positive result.
         */
		function submit() {
            // Extract hidden & header
            var hidden = vm.attribute.restrictions.hidden;
            var header = vm.attribute.restrictions.header;

            // Clear restrictions
            if(vm.attribute.type === 'enum') {
                vm.attribute.restrictions = {
                    options: vm.attribute.restrictions.options
                };
            } else if(vm.attribute.type === 'number') {
                vm.attribute.restrictions = {
                    min: vm.attribute.restrictions.min,
                    max: vm.attribute.restrictions.max,
                    unit: vm.attribute.restrictions.unit
                };
            } else if(vm.attribute.type === 'string') {
                vm.attribute.restrictions = {
                    regex: vm.attribute.restrictions.regex
                };
            }  else if(vm.attribute.type === 'material') {
                if(!vm.attribute.restrictions.materials) { vm.attribute.restrictions.materials = []; }
                if(!vm.attribute.restrictions.groups) { vm.attribute.restrictions.groups = []; }
                vm.attribute.restrictions = {
                    materials: vm.attribute.restrictions.materials,
                    groups: vm.attribute.restrictions.groups,
                    blacklist: vm.attribute.restrictions.blacklist
                };
            } else if(vm.attribute.type === 'color') {
                vm.attribute.restrictions = {
                    colors: vm.attribute.restrictions.colors,
                    blacklist: vm.attribute.restrictions.blacklist
                };
            } else if(vm.attribute.type === 'length') {
                vm.attribute.restrictions = {
                    min: vm.attribute.restrictions.min,
                    max: vm.attribute.restrictions.max,
                    usesPositions: vm.attribute.restrictions.usesPositions
                };
            } 
            
            // Add hidden & header
            vm.attribute.restrictions.hidden = hidden;
            vm.attribute.restrictions.header = header;
            
            // Submit attribute
			$mdDialog.hide(vm.attribute);
		}
        /**
         * Reloads all material groups.
         * @returns {Promise}
         */
        function loadMaterialGroups() {
            imsMaterials.reloadGroups();
        }
        
        /**
         * Reloads all material groups.
         * @returns {Promise}
         */
        function loadMaterials() {
            imsMaterials.reload();
        }
        
        /**
         * Reloads all colors.
         * @returns {Promise}
         */
        function loadColors() {
            return imsColors.reloadColors();
        }
        
        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
    'use strict';

    var modules = [
		'ngAnimate',
		'ngAria',
		'ngCookies',
		'ngMessages',
		'ngSanitize',
		'ngMaterial',
		'pascalprecht.translate',
		'ui.router'
	];

    if(typeof Raven !=='undefined'){
    	modules.push('ngRaven');
	}

    angular
        .module('app.core', modules);
})();

/* global angular */
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('SelectParentCategory', SelectParentCategory);

    /** @ngInject */
    function SelectParentCategory($mdDialog, Categories, ParentCategoryId) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
        var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.groups = [];
        vm.selectedGroup = null;
        vm.expandedGroups = [];
        vm.folder = null;
        vm.form = {};
        vm.treeOptions = {
            templateUrl: 'core/components/nuit-profile-selection/main-tree.html',
            nodeChildren: 'children',
            dirSelectable: true,
            injectClasses: {
                ul: "a1",
                li: "a2",
                liSelected: "a7",
                iExpanded: "a3",
                iCollapsed: "a4",
                iLeaf: "a5",
                label: "a6",
                labelSelected: "a8"
            },
            allowDeselect: false
        };
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.submit = submit;
        vm.close = close;
        vm.showSelected = showSelected;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
		//*******************************************

        ////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        function init() {
			vm.categories = Categories;
		}

        function showSelected(node) {
            vm.folder = node;
        }

        function submit() {
            $mdDialog.hide(vm.folder);
        }

        function close() {
            $mdDialog.cancel();
        }
    }

})();

(function () {
	'use strict';

	angular
		.module('app.products')
		.controller('CategoryDialogController', CategoryDialogController);

	/** @ngInject */
	function CategoryDialogController(Category, ParentCategoryId, $mdDialog, nuitUtils, imsUtils, nuitConfig, imsTranslation, ProductService, ProfileFoldersView) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.isNew = Category === undefined;
		vm.category = angular.extend({ name: {}}, Category);
		if(ParentCategoryId) {
			vm.category.parent = ParentCategoryId;
		}
        vm.categories = ProductService.getFlatifiedCategories();
		vm.languages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = imsTranslation.language;
		vm.selectedParent = null;
		// Ids that must not be selectable as parent: the category itself and all
		// of its descendants (choosing one would create a circular reference).
		vm.excludedParentIds = collectExcludedParentIds(vm.category);
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.save = save;
		vm.addImage = addImage;
		vm.deleteImage = deleteImage;
		vm.openImage = openImage;
		vm.selectCategory = selectCategory;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){
			if(!vm.category){
				return;
			} else if(!vm.category.id) {
                vm.category.name = {};
				vm.category.description = {};
            }

            if(!vm.category.images){
				vm.category.images = [];
			}

			if(vm.category.parent){
				vm.selectedParent = vm.categories.find(function(category){return category.id===vm.category.parent;});
			}
		}
        /**
         * Closes this dialog with a positive result.
         */
		function save() {
			if(vm.category.parent === undefined){
				vm.category.parent = null;
			}
			$mdDialog.hide(vm.category);
		}
        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}

		function addImage(){
			imsUtils.uploadProductImage()
				.then(function(url){
					vm.category.images.push({url:url});
				});
		}

		function deleteImage(image){
			var index = vm.category.images.indexOf(image);

			if(index>=0){
				vm.category.images.splice(index,1);
			}
		}

		function openImage(url, $event){
			nuitUtils.magnifyImage(url, $event);
		}

		/**
		 * Builds a lookup of category ids that may not be used as parent for the
		 * edited category: the category itself plus its whole subtree. The subtree
		 * is read from the authoritative tree in the service (falling back to the
		 * edited copy) so descendants cannot be selected and form a cycle.
		 * @param {Object} category - the category being edited
		 * @return {Object} map of excluded id -> true
		 */
		function collectExcludedParentIds(category){
			var excluded = {};

			if(!category || !category.id){
				return excluded;
			}

			excluded[category.id] = true;

			var node = ProductService.getCategoryById(category.id) || category;

			(function walk(nodes){
				if(!nodes){ return; }
				for(var i=0; i<nodes.length; i++){
					excluded[nodes[i].id] = true;
					walk(nodes[i].children);
				}
			})(node.children);

			return excluded;
		}

		function selectCategory($event){
			$event.stopPropagation();

			var dialog = {
				controller: 'SelectParentCategory',
				controllerAs: 'vm',
				templateUrl: 'app/main/merchandising.products/dialogs/select-parent-category/select-parent-category.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: false,
				autoWrap: false,
				multiple: true,
				locals: {
					Categories: vm.categories,
					ParentCategoryId: vm.category.parent
				}
			};

			return $mdDialog.show(dialog)
				.then(function (selected) {
					vm.category.parent = selected?selected.id:undefined;
					return vm.selectedParent = selected;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials.sales', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.material-sales', {
				url: '/material-sales?searchText?page',
				views: {
					'content@app': {
						templateUrl: 'app/main/merchandising.materials.sales/views/material-sales.html',
						controller: 'MaterialSalesController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.materials.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('merchandising.settings.sales', {
			title: 'Sales',
			icon: 'icon-sale',
			state: 'app.material-sales',
			translate: 'MATERIAL.SALES_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.materials.batchEditing.price;
			}
		});
        //*******************************************

		nuitApiProvider.register('materials.patch', '/material/materials', {allow: ['patch']});
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials.sales')
		.controller('MaterialSalesChangeDialogController', MaterialSalesChangeDialogController);

	/** @ngInject */
	function MaterialSalesChangeDialogController(Group, $mdDialog, nuitConfig, nuitUtils, imsTranslation) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.group = angular.extend({}, Group);
		vm.config = nuitConfig.getCurrent();
		vm.languages = vm.config.languages;
		vm.selectedLanguage = imsTranslation.language;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.save = save;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){
			if(!vm.group){
				return;
			} else if(!vm.group.id) {
                vm.group.name = {};
            }

            if(!vm.group.blankSteps){
            	vm.group.blankSteps = [];
			}else{
				vm.group.blankSteps = vm.group.blankSteps.map(function(value,index){return {id: index, step: value};});
			}
		}
        /**
         * Closes this dialog with a positive result.
         */
		function save() {
			vm.group.blankSteps = vm.group.blankSteps.map(function(value){return value.step;});
			$mdDialog.hide(vm.group);
		}
        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials.groups', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.material-groups', {
				url: '/material-groups',
				views: {
					'content@app': {
						templateUrl: 'app/main/merchandising.materials.groups/views/material-groups.html',
						controller: 'MaterialGroupsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.materials.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('merchandising.settings.groups', {
			title: 'Groups',
			icon: 'icon-group',
			state: 'app.material-groups',
			translate: 'MATERIAL.GROUPS_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.materials.enabled ||
				 		!nuitConfigProvider.getCurrent().ims.materials.groups.enabled;
			}
		});
        //*******************************************


	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials.groups')
		.controller('RawMaterialDialogController', RawMaterialDialogController);

	/** @ngInject */
	function RawMaterialDialogController(Group, $mdDialog, nuitConfig, nuitUtils, imsTranslation) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.group = angular.extend({}, Group);
		vm.config = nuitConfig.getCurrent();
		vm.languages = vm.config.languages;
		vm.selectedLanguage = imsTranslation.language;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.save = save;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){
			if(!vm.group){
				return;
			} else if(!vm.group.id) {
                vm.group.name = {};
            }

            if(!vm.group.blankSteps){
            	vm.group.blankSteps = [];
			}else{
				vm.group.blankSteps = vm.group.blankSteps.map(function(value,index){return {id: index, step: value};});
			}

			if(!vm.group.lengthSteps){
				vm.group.lengthSteps = [];
			}else{
				vm.group.lengthSteps = vm.group.lengthSteps.map(function(value,index){return {id: index, step: value};});
			}

			if(!vm.group.preDefinedLengths){
				vm.group.preDefinedLengths = [];
			}else{
				vm.group.preDefinedLengths = vm.group.preDefinedLengths.map(function(value,index){return {id: index, step: value};});
			}
		}
        /**
         * Closes this dialog with a positive result.
         */
		function save() {
			vm.group.blankSteps = vm.group.blankSteps.map(function(value){return value.step;});
			vm.group.lengthSteps = vm.group.lengthSteps.map(function(value){return value.step;});
			vm.group.preDefinedLengths = vm.group.preDefinedLengths.map(function(value){return value.step;});
			$mdDialog.hide(vm.group);
		}
        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials.attributes')
		.controller('EditMaterialAttributeDialogController', Controller);

	/** @ngInject */
	function Controller(Attribute, $mdDialog, nuitConfig, imsTranslation) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.attribute = angular.extend({}, Attribute);
		vm.newAttribute = false;
        vm.config = nuitConfig.current;
		vm.languages = nuitConfig.current.languages;
		vm.currentLanguage = imsTranslation.language;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.submit = submit;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init(){
			if(!vm.attribute || !vm.attribute.id){
				vm.newAttribute = true;
                vm.attribute = {
                    name: {},
                    type: 'string',
                    restrictions: {
                        options: []
                    }
                };
            }
		}
        /**
         * Closes this dialog with a positive result.
         */
		function submit() {
            // Extract hidden
            var hidden = vm.attribute.restrictions.hidden;

           if(vm.attribute.type === 'number') {
                vm.attribute.restrictions = {
                    min: vm.attribute.restrictions.min,
                    max: vm.attribute.restrictions.max,
                    unit: vm.attribute.restrictions.unit
                };
            } else if(vm.attribute.type === 'string') {
                vm.attribute.restrictions = {
                    regex: vm.attribute.restrictions.regex
                };
            }

            // Add hidden
            vm.attribute.restrictions.hidden = hidden;

            // Submit attribute
			$mdDialog.hide(vm.attribute);
		}

        /**
         * Closes this dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.controller('BendingDialogController', BendingDialogController);

	/** @ngInject */
	function BendingDialogController($state,$mdDialog, BendingMachineService, nuitUtils, Bending) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.isEdit = typeof Bending.bendingMachineId !== 'undefined';
		vm.bending = angular.copy(Bending);
		vm.materialId = $state.params.materialId;
		vm.materials = BendingMachineService.materials;
		vm.availableMachines = vm.isEdit?BendingMachineService.machines:BendingMachineService.availableMachines;
		vm.machinesLoading = false;
		vm.materialsLoading = false;
		//*******************************************

		//*******************************************
		// METHODS (EXPOSURE)
		//*******************************************
		vm.reloadMachines = reloadMachines;
		vm.reloadMaterials = reloadMaterials;
		vm.save = save;
		vm.cancel = cancel;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			reloadMachines();
		}

		function reloadMachines() {
			vm.machinesLoading = true;
			BendingMachineService
				.reload()
				.then(function()
				{
					if(vm.isEdit)
					{
						reloadMaterials(vm.bending.bendingMachineId);
					}
				})
				.finally(function () {
					vm.machinesLoading = false;
				});
		}

		function reloadMaterials(id) {
			if (typeof vm.bending.bendingMachineId === 'undefined') {
				return;
			}

			if(!vm.isEdit) {
				vm.bending.bendingMaterialId = null;
			}

			vm.materialsLoading = true;
			BendingMachineService
				.reloadMaterials(vm.bending.bendingMachineId)
				.finally(function () {
					vm.materialsLoading = false;
				});
		}

		function save() {
			if (!vm.bendingForm.$invalid) {
				if(vm.isEdit)
				{
					BendingMachineService.updateBending(vm.materialId,vm.bending.bendingMaterialId, vm.bending.bendingMachineId)
						.then(function () {
							BendingMachineService.updateAvailableMachines();
							$mdDialog.hide(vm.bending);
						})
						.catch(function (error) {
							nuitUtils.showErrorToast('MATERIALS.ERROR_FORM_INVALID');
						});
				}
				else {
					BendingMachineService.addBending(vm.materialId, vm.bending.bendingMaterialId, vm.bending.bendingMachineId)
						.then(function () {
							BendingMachineService.updateAvailableMachines();
							$mdDialog.hide(vm.bending);
						})
						.catch(function (error) {
							nuitUtils.showErrorToast('MATERIALS.ERROR_FORM_INVALID');
						});
				}
			}
			else
			{

				return nuitUtils.showErrorToast('MATERIALS.ERROR_FORM_INVALID');
			}
		}

		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.controller('CuttingDialogController', CuttingDialogController);

	/** @ngInject */
	function CuttingDialogController($mdDialog, imsMaterials, Cutting, Coils, CoilMachineService, nuitUtils, nuitUnits, ProfileServiceHelper, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
        //*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.cutting = angular.copy(Cutting);
        vm.coils = [];
		vm.coilMachines = CoilMachineService.getMachines();
        vm.selectedCoil = null;
        vm.unit = nuitUnits;
        vm.machinesLoading = false;
        vm.materialsLoading = false;
        //*******************************************

		//*******************************************
		// METHODS (EXPOSURE)
		//*******************************************
        vm.reloadMachines = reloadMachines;
        vm.reloadCoils = reloadCoils;
        vm.onCoilChange = onCoilChange;
        vm.isValidMachine = isValidMachine;
        vm.save = save;
		vm.cancel = cancel;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Initializes this controller.
         */
		function init() {
			reloadMachines();

            if(vm.cutting && vm.cutting.machineId && vm.cutting.type === 'coil') {
				reloadCoils();
            }
		}
        /**
         * Reloads all coil machines.
         */
        function reloadMachines() {
                vm.machinesLoading = true;
                CoilMachineService
                    .reload()
                    .then(function() {
                        vm.coils = [];
                        vm.cutting.machineId = undefined;
                        vm.machinesLoading = false;
                    })
                    .catch(function () {
                        nuitUtils.showErrorToast('MATERIALS.ERROR_LOADING_MACHINES');
                    });
        }
        /**
         * Reloads all coil materials.
         */
        function reloadCoils() {
            vm.materialsLoading = true;
            imsMaterials
                .getMaterialsOfCoilMachine(vm.cutting.machineId)
                .then(function(coils) {
                	nuitDataService.replaceAll(vm.coils,nuitDataService.getUnique(coils));
                    vm.materialsLoading = false;
            })
            .catch(nuitUtils.showErrorToast);
        }
        /**
         * This method is called whenever
         * the selected coil of the current
         * machine changes.
         */
        function onCoilChange() {
            if(vm.selectedCoil !== null) {
                vm.cutting.machineMaterialId = vm.selectedCoil.id;
                if(angular.isDefined(vm.selectedCoil.width)) {
                    vm.cutting.width = vm.selectedCoil.width;
                }
            } else {
                vm.cutting.materialId = null;
            }
        }

        function isValidMachine(id){
        	for(var i=0;i<Coils.length;i++){
        		if(Coils[i].machineId===id){
        			return false;
				}
			}

			return true;
		}

        /**
         * Closes the dialog with a positive result.
         * Only works it the form is valid.
         * Displays an error toast otherwise.
         */
		function save() {
			if(vm.cuttingForm.$invalid){
				return nuitUtils.showErrorToast('MATERIALS.ERROR_FORM_INVALID');
			}

			$mdDialog.hide(vm.cutting);
		}
        /**
         * Cancels the dialog.
         */
		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.setup', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.adminSetup', {
				url: '/admin/setup?category',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.setup/views/main.html',
						controller: 'AdminSetupController as vm'
					},
					'body@app.adminSetup': {
						templateUrl: 'app/main/admin.setup/views/list.html',
						controller: 'AdminSetupListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.setup.enabled'
			}).state('app.adminSetup.detail', {
				url: '/:id?active',
				views: {
					'body@app.adminSetup': {
						templateUrl: 'app/main/admin.setup/views/edit-setup.html',
						controller: 'AdminSetupEditController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.setup.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('admin.setup', {
			title: 'setup',
			icon: 'icon-book-open',
			state: 'app.adminSetup',
			translate: 'SETUP.SETUP_NAV',
			weight: 15,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().admin.setup.enabled;
			}
		});
        //*******************************************

		//*******************************************
		// API
		//*******************************************
        nuitApiProvider.register('admin.templates', 'setup/templates', {allow: ['get','post']});
        nuitApiProvider.register('admin.template', 'setup/templates/:id', {allow: ['delete','put', 'get']});
        nuitApiProvider.register('admin.definitions', 'setup/definitions', {allow: ['get','post']});
        nuitApiProvider.register('admin.definition', 'setup/definitions/:key', {allow: ['get']});
        nuitApiProvider.register('admin.definition.specific', 'setup/definitions/:key/:id', {allow: ['delete', 'put']});
        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
			admin: {
                setup: {
                    enabled: false
                }
			}
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.setup')
		.controller('AddLanguageDialogController', controller);

	/** @ngInject */
	function controller($mdDialog, SetupDefinitions, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.language = {};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.create = create;
        vm.cancel = cancel;
        vm.onLanguageChange = onLanguageChange;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
		}

		function cancel() {
			$mdDialog.cancel();
		}

		function create() {
            if(vm.language.code === undefined || vm.language.code === '' || vm.language.code === null) {
                return;
            }
            
            SetupDefinitions
                .addLanguage(vm.language)
                .then(function () {
                    $mdDialog.hide(vm.language);
                })
                    .catch(nuitUtils.showErrorToast);
		}
        
        function onLanguageChange() {
            if(vm.language.code === undefined || vm.language.code === '' || vm.language.code === null) {
                vm.language = {};
                return;
            }
            
            vm.language.code = vm.language.code.toLowerCase();
            vm.language.translation = 'APP.LANG_' + vm.language.code.toUpperCase();
            vm.language.flag = 'assets/images/flags/' + vm.language.code + '.png';
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.setup')
		.controller('EditUnitDialogController', controller);

	/** @ngInject */
	function controller(Unit, UnitName, $mdDialog, SetupDefinitions, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.unit = Unit === undefined ? { symbol: { type: 2 }, factor: { type: 5 }, decimals: { type: 1 }} : Unit;
        vm.isNew = Unit === undefined;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.create = create;
        vm.cancel = cancel;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
		}

		function cancel() {
			$mdDialog.cancel();
		}

		function create() {
            SetupDefinitions
                .addDefinition(vm.unit, UnitName)
                .then(function () {
                    $mdDialog.hide(vm.unit);
                })
                    .catch(nuitUtils.showErrorToast);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.setup')
		.controller('EditFormatDialogController', controller);

	/** @ngInject */
	function controller(Format, FormatType, $mdDialog, SetupDefinitions, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.format = Format === undefined ? { value: '', type: 2 } : Format;
        vm.isNew = Format === undefined;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.create = create;
        vm.cancel = cancel;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
		}

		function cancel() {
			$mdDialog.cancel();
		}

		function create() {
            if(FormatType !== undefined) {
                SetupDefinitions
                    .addDefinition(vm.format, FormatType)
                    .then(function () {
                        $mdDialog.hide(vm.format);
                    })
                        .catch(nuitUtils.showErrorToast);
            } else {
                $mdDialog.hide(vm.format);
            }
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.setup')
		.controller('EditDefinitionsDialogController', controller);

	/** @ngInject */
	function controller($mdDialog, SetupDefinitions, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.definitions = SetupDefinitions.definitions;
        vm.compose = {};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.cancel = cancel;
        vm.toListEntry = toListEntry;
        vm.addDefinition = addDefinition;
        vm.selectDefinition = selectDefinition;
        vm.deleteDefinition = deleteDefinition;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
            SetupDefinitions.reload();
		}
        
        function addDefinition(key, value) {
            value = JSON.parse(value);
            SetupDefinitions.addDefinition(value, key);
            delete vm.compose[key];
        }
        
        function selectDefinition(key, value) {
            vm.compose[key] = JSON.stringify(value.value);
        }
        
        function deleteDefinition(key, value) {
            nuitUtils.showDeleteConfirmation().then(function() {
                SetupDefinitions.deleteDefinition(key, value.id);
            });
        }
        
        function toListEntry(obj) {
            return JSON.stringify(obj);
        }

		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.setup')
		.controller('EditCategoryDialogController', controller);

	/** @ngInject */
	function controller(Category, $mdDialog, SetupDefinitions) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.category = Category === undefined ? {} : Category;
        vm.isNew = Category === undefined;
        vm.languages = SetupDefinitions.languages;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.create = create;
        vm.cancel = cancel;
        vm.onLanguageSelect = onLanguageSelect;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
            if(vm.languages.length !== 0) {
                vm.currentLanguage = vm.languages[0].value.code;
            }
            
            SetupDefinitions.reloadLanguages()
                .then(function() {
                    vm.currentLanguage = vm.languages[0].value.code;
            });
		}

		function cancel() {
			$mdDialog.cancel();
		}
        
        function onLanguageSelect(newValue) {
            if(angular.isString(newValue) && newValue.startsWith('$')) {
                SetupDefinitions.showAddLanguageDialog();
                delete vm.currentLanguage;
            }
        }

		function create() {
            // Fill name so all languages are set to either english or any
            for (var index in vm.languages) {
                var lang = vm.languages[index].value.code;
                if (vm.category.name[lang] === undefined) {
                    if (vm.category.name.en === undefined) {
                        vm.category.name[lang] = vm.category.name[Object.keys(vm.category.name)[0]];
                    } else {
                        vm.category.name[lang] = vm.category.name.en;
                    }
                }
            }
            
            $mdDialog.hide(vm.category);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.setup')
		.controller('AddSetupDialogController', controller);

	/** @ngInject */
	function controller($mdDialog, SetupDefinitions) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.template = {};
        vm.languages = SetupDefinitions.languages;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.create = create;
        vm.cancel = cancel;
        vm.onLanguageSelect = onLanguageSelect;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
            if(vm.languages.length !== 0) {
                vm.currentLanguage = vm.languages[0].value.code;
            }
            
            SetupDefinitions.reloadLanguages()
                .then(function() {
                    vm.currentLanguage = vm.languages[0].value.code;
            });
		}

		function cancel() {
			$mdDialog.cancel();
		}
        
        function onLanguageSelect(newValue) {
            if(angular.isString(newValue) && newValue.startsWith('$')) {
                SetupDefinitions.showAddLanguageDialog();
                delete vm.currentLanguage;
            }
        }

		function create() {
            // Fill name so all languages are set to either english or any
            for (var index in vm.languages) {
                var lang = vm.languages[index].value.code;
                if (vm.template.name[lang] === undefined) {
                    if (vm.template.name.en === undefined) {
                        vm.template.name[lang] = vm.template.name[Object.keys(vm.template.name)[0]];
                    } else {
                        vm.template.name[lang] = vm.template.name.en;
                    }
                }
            }
            
            $mdDialog.hide(vm.template);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.controller('TestRequestController', TestRequestController);

	/** @ngInject */
	function TestRequestController(nuitDataService, $mdDialog, EnvironmentService, nuitUtils, $http) {
		var vm = this;

		vm.testUrl = 'http://localhost:3000';
		vm.useFetch = false;
		vm.response = '';
		vm.cancel = cancel;
		vm.submit = submit;

		init();

		function init(){
			vm.inProgress = true;
			EnvironmentService.getCurrent()
				.then(function(environment){
					vm.inProgress = false;
					nuitDataService.replaceOneEntity(vm.environment, environment);
				});
		}

		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			if (vm.useFetch) {
				return fetch(vm.testUrl, {
					targetAddressSpace: 'local',
				}).then(function (response) {
					return response.json();
				}).then(function (response) {
					nuitUtils.showSuccessToast(response);
					vm.response = JSON.stringify(response, null, 2);
				}).catch(function (error) {
					nuitUtils.showErrorToast(error);
					vm.response = JSON.stringify(error, null, 2);
					return null;
				});
			} else {
				return $http({
						method: 'GET',
						url: vm.testUrl
					}
				)
					.then(function(response){
						nuitUtils.showSuccessToast(response);
						vm.response = JSON.stringify(response, null, 2);
					})
					.catch(function(error) {
						nuitUtils.showErrorToast(error);
						vm.response = JSON.stringify(error, null, 2);
						return null;
					});
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.controller('OrdersEditStatusController', OrdersEditStatusController);

	/** @ngInject */
	function OrdersEditStatusController(Status, $mdDialog, $translate, nuitConfig, nuitApi){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.status = Status;
		vm.newStatus = !vm.status;
		vm.availableLanguages = nuitConfig.getCurrent().languages;
		vm.currentLanguage = $translate.use();
        vm.documents = [];
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
        vm.getDocumentById = getDocumentById;
		vm.cancel = cancel;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {
            if(!vm.status) {
                vm.status = {};
            }else{
            	if(angular.isString(vm.status.transitionText)){
            		vm.status.transitionText = {};
				}
			}

            nuitApi('documents.all')
                .get()
                .then(function(response) {
                    vm.documents.splice(0, vm.documents.length);
                    angular.merge(vm.documents, response.data);
            });
        }

        function getDocumentById(id) {
            for(var index in vm.documents) {
                if(vm.documents[index].id === id) {
                    return vm.documents[index];
                }
            }
            return {};
        }

		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			$mdDialog.hide(vm.status);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configEditor', {
			templateUrl: 'app/main/admin.environment/components/config-editor/config-editor.component.html',
			controller: ConfigEditorController,
			controllerAs: 'vm',
			bindings: {
				wholeConfig: '=',
				defaultName: '@',
				defaultConfig: '<',
				defaultRoot: '@',
				controller: '<',
				removeable: '@'
			}
		});

	/** @ngInject */
	function ConfigEditorController($injector, $timeout, nuitConfig, imsUtils, DotNotationService, SettingsTreeService, AdminConfig, ConfigEditorInputMapping) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var $ctrl = this;
		$ctrl.jsonOptions = {mode: 'tree'};
		$ctrl.listView = true;
		$ctrl.tree = {};
		$ctrl.template = 'app/main/admin.environment/components/config-editor/customInput/{{REPLACEME}}.html';
		$ctrl.mapping = ConfigEditorInputMapping.get();
		$ctrl.stampingToolSizes = [];
		$ctrl.stampingTools = [];
		$ctrl.stampingAreas = [];
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		$ctrl.mergeDefault = mergeDefault;
		$ctrl.resetDefault = resetDefault;
		$ctrl.isInConfig = isInConfig;
		$ctrl.addConfig = addConfig;
		$ctrl.removeConfig = removeConfig;
		$ctrl.updateNumberType = updateNumberType;
		$ctrl.containsSearchTerm = containsSearchTerm;
		$ctrl.hasSearchTerm = hasSearchTerm;
		$ctrl.getCustomInput = getCustomInput;
		$ctrl.onStampingToolSizesUpdated = onStampingToolSizesUpdated;
		$ctrl.onStampingToolsUpdated = onStampingToolsUpdated;
		$ctrl.onStampingAreasUpdated = onStampingAreasUpdated;
		//*******************************************

		function mergeDefault() {
			var newConfig = {};
			var modifiedDefault = {};
			DotNotationService.add(modifiedDefault, $ctrl.defaultRoot, $ctrl.defaultTraversed);
			angular.merge(newConfig, modifiedDefault, $ctrl.wholeConfig);
			angular.merge($ctrl.wholeConfig, newConfig, angular.copy($ctrl.wholeConfig));
		}

		function resetDefault() {
			if (Object.keys($ctrl.wholeConfig).length === 0) {
				$timeout(resetDefault, 500); //this is a hack to prevent reset with an empty config
			} else {
				$ctrl.default = nuitConfig.toAPIConfig(angular.copy($ctrl.defaultConfig?$ctrl.defaultConfig:$injector.get($ctrl.defaultName)));
				$ctrl.defaultCopy = angular.copy($ctrl.default);
				$ctrl.defaultTraversed = DotNotationService.get($ctrl.default, $ctrl.defaultRoot);
				updateTree();
			}
		}

		function updateTree() {
			$ctrl.tree = SettingsTreeService.get($ctrl.default, $ctrl.wholeConfig, $ctrl.defaultRoot, $ctrl.defaultName);
		}

		function isInConfig(key) {
			return DotNotationService.hasKey($ctrl.wholeConfig, key);
		}

		function addConfig(key) {
			DotNotationService.add($ctrl.wholeConfig, key, DotNotationService.get($ctrl.default, key));
			if ($ctrl.controller.propagateToServer()) {
				AdminConfig.unmarkForDeletion(key);
			}
		}

		function removeConfig(key) {
			imsUtils.showDeleteConfirmation()
				.then(function () {
					if ($ctrl.controller.propagateToServer()) {
						AdminConfig.markForDeletion(key);
					}

					DotNotationService.set($ctrl.default, key + '.value', DotNotationService.get($ctrl.defaultCopy, key + '.value'));
					DotNotationService.remove($ctrl.wholeConfig, key);
					updateTree();
				});
		}

		function updateNumberType(model){
			if(model.data.value===parseInt(model.data.value)){
				model.data.type = 1;
			}else{
				model.data.type = 5;
			}
		}

		function containsSearchTerm(model){
			if(!$ctrl.controller.searchTerm || $ctrl.controller.searchTerm===''){
				return true;
			}else{
				return model.name.toLowerCase().indexOf($ctrl.controller.searchTerm.toLowerCase())>=0;
			}
		}

		function hasSearchTerm(){
			return $ctrl.controller.searchTerm && $ctrl.controller.searchTerm!=='';
		}

		function getCustomInput(model){
			if($ctrl.mapping.hasOwnProperty(model)){
				return $ctrl.template.replace('{{REPLACEME}}',$ctrl.mapping[model]);
			}else{
				return null;
			}
		}

		function onStampingToolSizesUpdated(sizes) {
			$ctrl.stampingToolSizes = sizes;
		}

		function onStampingToolsUpdated(tools) {
			$ctrl.stampingTools = tools;
		}

		function onStampingAreasUpdated(areas) {
			$ctrl.stampingAreas = areas;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configSingleType', {
			templateUrl: 'app/main/admin.environment/components/config-single-type/config-single-type.component.html',
			controller: ConfigSingleController,
			controllerAs: 'vm',
			bindings: {
				config: '=',
				key: '@',
				type: '@',
				defaultValue: '<',
				showDefaultValue: '<',
				translation: '@',
				useDotNotation: '<',
				toDefaultOnDelete: '<',
				onChange: '<'
			}
		});

	/** @ngInject */
	function ConfigSingleController($timeout, imsUtils, DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.value = {value: vm.defaultValue, type: parseInt(vm.type)};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.init = init;
		vm.isInConfig = isInConfig;
		vm.addConfig = addConfig;
		vm.removeConfig = removeConfig;
		vm.updateConfig = updateConfig;
		vm.containsSearchTerm = containsSearchTerm;

		//*******************************************
		function init() {
			if(vm.type==="3"){
				throw new Error('Type 3 config is not supported right now!');
			}else{
				vm.value.type = parseInt(vm.type);
			}

			if(Object.keys(vm.config).length === 0){
				$timeout(init,500); //this is a hack to prevent reset with an empty config
			}else {
				if (vm.useDotNotation) {
					vm.value = isInConfig() ? DotNotationService.get(vm.config, vm.key) : {value: vm.defaultValue, type:vm.type};
				} else {
					vm.value = isInConfig() ? vm.config[vm.key] : {value: vm.defaultValue, type:vm.type};
				}
			}
		}

		function isInConfig() {
			if (vm.useDotNotation) {
				return DotNotationService.hasKey(vm.config, vm.key);
			} else {
				return vm.config.hasOwnProperty(vm.key);
			}
		}

		function addConfig() {
			if (vm.useDotNotation) {
				DotNotationService.add(vm.config, vm.key, {value: vm.defaultValue, type:parseInt(vm.type)});
			}
			else {
				vm.config[vm.key] = {value: vm.defaultValue, type:parseInt(vm.type)};
			}

			if(vm.onChange){
				vm.onChange();
			}
		}

		function removeConfig() {
			imsUtils.showDeleteConfirmation()
				.then(function () {
					vm.value = {value: vm.defaultValue, type:parseInt(vm.type)};

					if(vm.toDefaultOnDelete){
						updateConfig();
					}else{
						if (vm.useDotNotation) {
							DotNotationService.remove(vm.config, vm.key);
						} else {
							delete vm.config[vm.key];
						}
					}

					if(vm.onChange){
						vm.onChange();
					}
				});
		}

		function updateConfig() {
			if (vm.useDotNotation) {
				DotNotationService.set(vm.config, vm.key, {value: vm.value.value, type:parseInt(vm.type)});
			} else {
				vm.config[vm.key] = {value: vm.value.value, type:parseInt(vm.type)};
			}

			if(vm.onChange){
				vm.onChange();
			}
		}

		function containsSearchTerm(){
			if(!vm.searchTerm || vm.searchTerm===''){
				return true;
			}else{
				return vm.key.toLowerCase().indexOf(vm.searchTerm.toLowerCase())>=0;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.component('configSingle', {
			templateUrl: 'app/main/admin.environment/components/config-single/config-single.component.html',
			controller: ConfigSingleController,
			controllerAs: 'vm',
			bindings: {
				config: '=',
				key: '@',
				type: '@',
				defaultValue: '<',
				showDefaultValue: '<',
				translation: '@',
				useDotNotation: '<',
				toDefaultOnDelete: '<',
				searchTerm: '<',
				onDeleteConfig: '<'
			}
		});

	/** @ngInject */
	function ConfigSingleController($timeout, imsUtils, DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.value = null;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.init = init;
		vm.isInConfig = isInConfig;
		vm.addConfig = addConfig;
		vm.removeConfig = removeConfig;
		vm.updateConfig = updateConfig;
		vm.containsSearchTerm = containsSearchTerm;

		//*******************************************
		function init() {
			if(vm.type==="3"){
				throw new Error('Type 3 config is not supported right now!');
			}

			if(Object.keys(vm.config).length === 0){
				$timeout(init,500); //this is a hack to prevent reset with an empty config
			}else {
				if (vm.useDotNotation) {
					vm.value = isInConfig() ? DotNotationService.get(vm.config, vm.key) : vm.defaultValue;
				} else {
					vm.value = isInConfig() ? vm.config[vm.key] : vm.defaultValue;
				}
			}
		}

		function isInConfig() {
			if (vm.useDotNotation) {
				return DotNotationService.hasKey(vm.config, vm.key);
			} else {
				return vm.config.hasOwnProperty(vm.key);
			}
		}

		function addConfig() {
			if (vm.useDotNotation) {
				DotNotationService.add(vm.config, vm.key, vm.defaultValue);
			}
			else {
				vm.config[vm.key] = vm.defaultValue;
			}
		}

		function removeConfig() {
			imsUtils.showDeleteConfirmation()
				.then(function () {
					vm.value = vm.defaultValue;

					if(vm.toDefaultOnDelete){
						updateConfig();
					}else{
						if (vm.useDotNotation) {
							DotNotationService.remove(vm.config, vm.key);
						} else {
							delete vm.config[vm.key];
						}

						if(vm.onDeleteConfig){
							vm.onDeleteConfig(vm.key);
						}
					}
				});
		}

		function updateConfig() {
			if (vm.useDotNotation) {
				DotNotationService.set(vm.config, vm.key, vm.value);
			} else {
				vm.config[vm.key] = vm.value;
			}
		}

		function containsSearchTerm(){
			if(!vm.searchTerm || vm.searchTerm===''){
				return true;
			}else{
				return vm.key.toLowerCase().indexOf(vm.searchTerm.toLowerCase())>=0;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitApiProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.notification-channels', {
				url: '/admin/notifications/channels',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'ChannelListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			})
			.state('app.notification-templates', {
				url: '/admin/notifications/templates',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'TemplateListController as vm'
					}
				},
				data:{
					global: false
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			})
			.state('app.notification-templates-global', {
				url: '/admin/notifications/templates-global',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'TemplateListController as vm'
					}
				},
				data:{
					global: true
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			})
			.state('app.notification-templates.content', {
				url: '/content?templateId?global',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'ContentListController as vm'
					}
				},
				data:{
					global: false
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			})
			.state('app.notification-templates-global.content', {
				url: '/content?templateId?global',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'ContentListController as vm'
					}
				},

				data:{
					global: true
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			})
			.state('app.notification-events', {
				url: '/admin/notifications/events',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'EventListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			})
			.state('app.notification-events.users', {
				url: '/users?eventId',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'EventUserListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			})
			.state('app.notification-events.roles', {
				url: '/roles?eventId',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'EventRoleListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			})
			.state('app.notification-events.additional', {
				url: '/additional?eventId',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'EventAdditionalListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			})
			.state('app.notification-events.custom', {
				url: '/custom?eventId',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'EventCustomListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			})
			.state('app.notification-events.triggers', {
				url: '/triggers?eventId',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.notifications/views/default.html',
						controller: 'EventTriggerListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.notifications.enabled'
			});

        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('admin.notifications', {
			title: 'notifications',
			icon: 'icon-chart-bar',
			translate: 'NOTIFICATIONS.NOTIFICATIONS_NAV',
			weight: 100,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().admin.notifications.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('admin.notifications.channels', {
			title: 'Jobs',
			icon: 'icon-worker',
			state: 'app.notification-channels',
			translate: 'NOTIFICATIONS.CHANNELS',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().admin.notifications.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('admin.notifications.templates', {
			title: 'Apps',
			icon: 'icon-key',
			state: 'app.notification-templates',
			translate: 'NOTIFICATIONS.TEMPLATES',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().admin.notifications.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('admin.notifications.templates-global', {
			title: 'Apps',
			icon: 'icon-key',
			state: 'app.notification-templates-global',
			translate: 'NOTIFICATIONS.TEMPLATES-GLOBAL',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().admin.notifications.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('admin.notifications.events', {
			title: 'Apps',
			icon: 'icon-key',
			state: 'app.notification-events',
			translate: 'NOTIFICATIONS.EVENTS',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().admin.notifications.enabled;
			}
		});
        //*******************************************

		//*******************************************
		// API
		//*******************************************
		nuitApiProvider.register('notification.channels', 'notification/channels', {allow: ['get']});
		nuitApiProvider.register('notification.channels.add', 'notification/channels', {allow: ['post']});
		nuitApiProvider.register('notification.channels.one', 'notification/channels/:id', {allow: ['put','delete']});

		nuitApiProvider.register('notification.templates', 'notification/templates', {allow: ['get']});
		nuitApiProvider.register('notification.templates.add', 'notification/templates', {allow: ['post']});
		nuitApiProvider.register('notification.templates.one', 'notification/templates/:id', {allow: ['put','delete','get']});

		nuitApiProvider.register('notification.global.templates', 'notification/global/templates', {allow: ['get']});
		nuitApiProvider.register('notification.global.templates.add', 'notification/global/templates', {allow: ['post']});
		nuitApiProvider.register('notification.global.templates.one', 'notification/global/templates/:id', {allow: ['put','delete','get']});

		nuitApiProvider.register('notification.contents', 'notification/templates/:id/content', {allow: ['get']});
		nuitApiProvider.register('notification.contents.add', 'notification/templates/:id/content', {allow: ['post']});
		nuitApiProvider.register('notification.contents.one', 'notification/templates/:id/content', {allow: ['put','delete']});

		nuitApiProvider.register('notification.global.contents', 'notification/global/templates/:id/content', {allow: ['get']});
		nuitApiProvider.register('notification.global.contents.add', 'notification/global/templates/:id/content', {allow: ['post']});
		nuitApiProvider.register('notification.global.contents.one', 'notification/global/templates/:id/content', {allow: ['put','delete']});

		nuitApiProvider.register('notification.contenttypes', '/notification/supported/contenttypes', {allow: ['get']});

		nuitApiProvider.register('notification.events', 'notification/events', {allow: ['get']});
		nuitApiProvider.register('notification.events.add', 'notification/events', {allow: ['post']});
		nuitApiProvider.register('notification.events.one', 'notification/events/:id', {allow: ['put','delete','get']});

		nuitApiProvider.register('notification.events.triggers', 'notification/triggers', {allow: ['post']});
		nuitApiProvider.register('notification.events.triggers.one', 'notification/triggers/:id', {allow: ['put','delete']});

		nuitApiProvider.register('notification.events.users', 'notification/events/:id/users', {allow: ['post','get','delete', 'put']});
		nuitApiProvider.register('notification.events.roles', 'notification/events/:id/roles', {allow: ['post','get','delete', 'put']});
		nuitApiProvider.register('notification.events.additional', 'notification/events/:id/additional', {allow: ['post','get','delete','put']});
		nuitApiProvider.register('notification.events.custom', 'notification/events/:id/custom', {allow: ['post','get','delete','put']});

		nuitApiProvider.register('notification.global.schemas', '/notification/supported/schemas', {allow: ['get']});
		nuitApiProvider.register('notification.channeltypes', '/notification/supported/channeltypes', {allow: ['get']});
		nuitApiProvider.register('notification.triggertypes', '/notification/supported/triggers', {allow: ['get']});
		nuitApiProvider.register('notification.triggernames', '/notification/supported/triggers/:id', {allow: ['get']});

        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
			admin: {
                notifications: {
                    enabled: false
                }
			}
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EditEventUserController', EditEventUserController);

	/** @ngInject */
	function EditEventUserController($mdDialog, nuitConfig, nuitUtils, nuitDataService, user, users, ChannelService) {

		var vm = this;
		vm.newUser = user === null;
		vm.user = vm.newUser?{}:angular.copy(user);
		vm.channels = ChannelService.entities;
		vm.users = users;

		init();

		function init() {
			vm.save = save;
			vm.cancel = cancel;
			ChannelService.getAll();
		}

		function save() {
			$mdDialog.hide(vm.user);
		}

		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EditTriggerController', EditTriggerController);

	/** @ngInject */
	function EditTriggerController($mdDialog, nuitApi, nuitConfig, nuitUtils, nuitDataService, trigger) {

		var vm = this;

		vm.newTrigger = trigger === null;
		vm.triggerTypes = [];
		vm.triggerNames = [];
		vm.config = nuitConfig.getCurrent();
		vm.trigger = vm.newTrigger ? {conditions:{}} : angular.copy(trigger);

		vm.save = save;
		vm.cancel = cancel;
		vm.updateTriggerNames = updateTriggerNames;

		init();

		function init() {
			nuitApi('notification.triggertypes')
				.get()
				.then(function (response) {
					nuitDataService.replaceAll(vm.triggerTypes, response.data);
					reloadTriggerNames(vm.newTrigger ? vm.triggerTypes[0] : vm.trigger.type);
				});
		}

		function reloadTriggerNames(type) {
			return nuitApi('notification.triggernames',type)
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(vm.triggerNames, response.data);
				});
		}

		function save() {
			$mdDialog.hide(vm.trigger);
		}

		function cancel() {
			$mdDialog.cancel();
		}

		function updateTriggerNames() {
			vm.trigger.name = '';
			reloadTriggerNames(vm.trigger.type);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EditTemplateController', EditTemplateController);

	/** @ngInject */
	function EditTemplateController($mdDialog, nuitConfig, nuitUtils, nuitDataService, nuitApi, template, global, GlobalTemplateService) {

		var vm = this;

		vm.newTemplate = template === null;
		vm.template = vm.newTemplate ? {parent:0} : angular.copy(template);
		vm.global = global;
		vm.schemas = [];

		vm.save = save;
		vm.cancel = cancel;
		vm.clearParent = clearParent;

		init();

		function init() {
			if (!vm.global) {
				vm.globalTemplates = GlobalTemplateService.entities;
				GlobalTemplateService.getAll();
			}

			nuitApi('notification.global.schemas')
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(vm.schemas, response.data);
				});
		}

		function save() {
			$mdDialog.hide(vm.template);
		}

		function cancel() {
			$mdDialog.cancel();
		}

		function clearParent(){
			vm.template.parent = 0;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EditEventRoleController', EditEventRoleController);

	/** @ngInject */
	function EditEventRoleController($mdDialog, nuitConfig, nuitUtils, nuitDataService, role, ChannelService, RoleService) {

		var vm = this;
		vm.newRole = role === null;
		vm.role = vm.newRole?{}:angular.copy(role);
		vm.channels = ChannelService.entities;
		vm.roles = RoleService.roles;

		init();

		function init() {
			vm.save = save;
			vm.cancel = cancel;
			vm.getTypeName = RoleService.getTypeName;
			ChannelService.getAll();

			if(!vm.newRole) {
				RoleService.reload();
			}
		}

		function save() {
			$mdDialog.hide(vm.role);
		}

		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EditEventController', EditEventController);

	/** @ngInject */
	function EditEventController($mdDialog, nuitConfig, nuitUtils, nuitDataService, event, TemplateService) {

		var vm = this;

		init();

		function init() {
			vm.newEvent = event === null;
			vm.event = vm.newEvent ? {} : angular.copy(event);
			vm.save = save;
			vm.cancel = cancel;
			vm.templates = TemplateService.entities;

			TemplateService.getAll();
		}

		function save() {
			$mdDialog.hide(vm.event);
		}

		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EditCustomController', EditCustomController);

	/** @ngInject */
	function EditCustomController($mdDialog, nuitConfig, ChannelService, custom) {

		var vm = this;
		vm.newCustom = custom === null;
		vm.custom = vm.newCustom?{}:angular.copy(custom);
		vm.channels = ChannelService.entities;
		vm.config = nuitConfig.getCurrent();

		vm.save = save;
		vm.cancel = cancel;
		ChannelService.getAll();

		function save() {
			$mdDialog.hide(vm.custom);
		}

		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EditContentController', EditContentController);

	/** @ngInject */
	function EditContentController($sce, $mdDialog, nuitApi, nuitConfig, nuitUtils, nuitDataService, content) {

		var vm = this;

		init();

		function init() {
			vm.newContent = content === null;
			vm.config = nuitConfig.getCurrent();
			vm.content = vm.newContent ? {} : angular.copy(content);
			vm.save = save;
			vm.cancel = cancel;
			vm.renderContent = renderContent;
			vm.contentTypes = [];

			nuitApi('notification.contenttypes')
				.get()
				.then(function(response){
					nuitDataService.replaceAll(vm.contentTypes,response.data);
				});
		}

		function save() {
			$mdDialog.hide(vm.content);
		}

		function cancel() {
			$mdDialog.cancel();
		}

		function renderContent(content){
			return $sce.trustAsHtml(content);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EditChannelController', EditChannelController);

	/** @ngInject */
	function EditChannelController($mdDialog, nuitConfig, nuitUtils, nuitDataService, nuitApi, channel) {

		var vm = this;

		vm.newChannel = channel === null;
		vm.channel = vm.newChannel ? {} : angular.copy(channel);
		vm.channelTypes = [];
		vm.loading = true;

		vm.save = save;
		vm.cancel = cancel;

		init();

		function init() {

			nuitApi('notification.channeltypes')
				.get()
				.then(function(response){
					nuitDataService.replaceAll(vm.channelTypes,response.data);
					vm.loading = false;
				});
		}

		function save() {
			$mdDialog.hide(vm.channel);
		}

		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EditAdditionalController', EditAdditionalController);

	/** @ngInject */
	function EditAdditionalController($mdDialog, nuitConfig, ChannelService, RoleService, nuitDataService, additional) {

		var vm = this;
		vm.newAdditional = additional === null;
		vm.additional = vm.newAdditional?{contactData:{}}:angular.copy(additional);
		vm.channels = ChannelService.entities;
		vm.config = nuitConfig.getCurrent();
		vm.roles = RoleService.roles;

		vm.save = save;
		vm.cancel = cancel;
		ChannelService.getAll();
		//RoleService.reload();

		function save() {
			$mdDialog.hide(vm.additional);
		}

		function cancel() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
    'use strict';

    angular
        .module('app.admin.documents', [])
        .config(config);

    function config($stateProvider, msNavigationServiceProvider, nuitApiProvider, nuitConfigProvider) {
	    //*******************************************
	    // STATES
	    //*******************************************
        $stateProvider
            .state('app.adminDocuments', {
                url: '/admin/documents?page',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin.documents/views/documents.html'
                    },
                    'body@app.adminDocuments': {
                        templateUrl: 'app/main/admin.documents/views/document-list.html',
	                    controller: 'AdminDocumentListController as vm'
                    }
                },
	            reloadOnSearch: false,
				permissions: 'admin.documents.enabled'
            })
	        .state('app.adminDocuments.compose', {
	        	url: '/add?local',
		        views: {
	        		'body@app.adminDocuments': {
	        			templateUrl: 'app/main/admin.documents/views/document-add.html',
				        controller: 'AdminDocumentAddController as vm'
			        }
		        },
				permissions: 'admin.documents.enabled'
	        })
	        .state('app.adminDocuments.detail',{
		        url: '/:templateKey?lang&local',
		        views: {
		        	'body@app.adminDocuments': {
		        		templateUrl: 'app/main/admin.documents/views/document-details.html',
				        controller: 'AdminDocumentDetailsController as vm'
			        }
		        },
				permissions: 'admin.documents.enabled'
	        });
        //*******************************************

	    //*******************************************
	    // NAVIGATION
	    //*******************************************
        msNavigationServiceProvider.saveItem('admin.documents', {
            title: 'Dokumente',
            icon: 'icon-file-pdf-box',
            state: 'app.adminDocuments',
            translate: 'ADMIN.DOCUMENTS_NAV',
            weight: 30,
	        hidden: function () {
            	return !nuitConfigProvider.getCurrent().admin.documents.enabled;
	        }
        });
        //*******************************************

	    //*******************************************
	    // API
	    //*******************************************
        nuitApiProvider.register('templates.all', '/documents/templates/default', {allow: ['get']});
        nuitApiProvider.register('templates.env.all', '/documents/templates/environment', {allow: ['get']});
        nuitApiProvider.register('templates', '/documents/templates/default/:key', {allow: ['get','post','put','delete']});
        nuitApiProvider.register('templates.env', '/documents/templates/environment/:key', {allow: ['get','post','put','delete']});
        nuitApiProvider.register('templates.preview', '/documents/templates/default/:key/sample', {allow: ['get']});
        nuitApiProvider.register('templates.env.preview', '/documents/templates/environment/:key/sample', {allow: ['get']});
        nuitApiProvider.register('templates.pdf', '/documents/pdf/:name', {allow: ['get','post']});
        nuitApiProvider.register('documents.all', 'shop/documents', {allow: ['get', 'post']});
        nuitApiProvider.register('documents.single', 'shop/documents/:id', {allow: ['get', 'put', 'delete']});
		nuitApiProvider.register('order.documents.all', 'shop/documents/orders', {allow: ['get', 'post']});
		nuitApiProvider.register('order.documents.single', 'shop/documents/orders/:id', {allow: ['get', 'put', 'delete']});
		nuitApiProvider.register('offer.documents.all', 'shop/documents/offers', {allow: ['get', 'post']});
		nuitApiProvider.register('offer.documents.single', 'shop/documents/offers/:id', {allow: ['get', 'put', 'delete']});

		nuitApiProvider.register('production.documents.all', 'production/documents', {allow: ['get', 'post'], versions:[2]});
		nuitApiProvider.register('production.documents.single', 'production/documents/:id', {allow: ['get', 'put', 'delete'], versions:[2]});
		nuitApiProvider.register('accounting.documents.all', 'accounting/documents/invoices', {allow: ['get', 'post']});
		nuitApiProvider.register('accounting.documents.single', 'accounting/documents/invoices/:id', {allow: ['get', 'put', 'delete']});
		nuitApiProvider.register('credit.documents.all', 'accounting/documents/creditnotes', {allow: ['get', 'post']});
		nuitApiProvider.register('credit.documents.single', 'accounting/documents/creditnotes/:id', {allow: ['get', 'put', 'delete']});

		nuitApiProvider.register('delivery.documents.all', 'delivery/documents', {allow: ['post', 'get']});
		nuitApiProvider.register('delivery.documents.single', 'delivery/documents/:id', {allow: ['put', 'get', 'delete']});
        //*******************************************

	    //*******************************************
	    // SETTINGS
	    //*******************************************
	    var settings = {
		    admin: {
			    documents: {
			    	enabled: false
			    }
		    }
	    };

	    nuitConfigProvider.injectIntoDefault(settings);
        //*******************************************
    }
})();

(function () {
	'use strict';

	angular
		.module('app.admin.documents')
		.controller('DocumentsEditController', controller);

	/** @ngInject */
	function controller(Document, $mdDialog, DocumentsService, nuitConfig, imsTranslation, RoleService){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//**************s*****************************
		// VARIABLES
		//*******************************************
		vm.document = Document;
        vm.templates = DocumentsService.templates;
        vm.envTemplates = DocumentsService.envTemplates;
		vm.isNew = !vm.document;
        vm.languages = nuitConfig.current.languages;
		vm.currentLanguage = imsTranslation.language;
        vm.roles = RoleService.roles;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
        vm.getDataOfLang = getDataOfLang;
		vm.cancel = cancel;
        //*******************************************
        
		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************
        
		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {
            if(!vm.document) {
                vm.document = { data: [] };
            }
            
            RoleService.reload();
            
            for(var index in vm.languages) {
                if(getDataOfLang(vm.languages[index]) === null) {
                    vm.document.data.push({ lang: vm.languages[index] });
                }
            }
        }
        
        function getDataOfLang(lang) {
            for(var index in vm.document.data) {
                if(vm.document.data[index].lang === lang) {
                    return vm.document.data[index];
                }
            }
            return null;
        }
        
		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
            for(var index = 0;index < vm.document.data.length; index++) {
                var data = vm.document.data[index];
                if(data.content === undefined) {
                    vm.document.data.splice(index, 1);
                    index--;
                    continue;
                }
                if(data.header === undefined) { data.header = null; }
                if(data.footer === undefined) { data.footer = null; }
            }
            
			$mdDialog.hide(vm.document);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.controller('AddEnvironmentDialogController', AddEnvironmentDialogController);

	/** @ngInject */
	function AddEnvironmentDialogController($mdDialog, SetupTemplates, ClientsService, nuitApi, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.env = {};
        vm.templates = SetupTemplates.templates;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.cancel = cancel;
		vm.create = create;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
            SetupTemplates.reload();
		}

		function cancel() {
			$mdDialog.cancel();
		}

		function create() {
            vm.isCreating = true;
            ClientsService
                .addEnvironment(vm.env)
                .then(function(response) {
                    if(response && response.data) {
                        $mdDialog.hide(response.data); 
                    } else {
                        $mdDialog.hide(); 
                    }
                    nuitUtils.showSuccessToast();
            }).catch(nuitUtils.showErrorToast)
                .finally(function() {
                    vm.isCreating = false;
            });
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.users', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, USERS_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.users', {
				url: '/users?role&page&term',
				views: {
					'content@app': {
						templateUrl: 'app/main/system.users/views/users.html'
					},
					'body@app.users': {
						templateUrl: 'app/main/system.users/views/user-list.html',
						controller: 'UserListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.users.enabled'
			})
			.state('app.users.compose', {
				url: '/add',
				views: {
					'body@app.users': {
						templateUrl: 'app/main/system.users/views/user-details.html',
						controller: 'UserDetailsController as vm'
					}
				},
				permissions: 'ims.users.enabled'
			})
			.state('app.users.detail', {
				url: '/:userId?active',
				views: {
					'body@app.users': {
						templateUrl: 'app/main/system.users/views/user-details.html',
						controller: 'UserDetailsController as vm'
					}
				},
				params: {
					active: 'general'
				},
				reloadOnSearch: false,
				permissions: 'ims.users.enabled'
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('system.users', {
			title: 'Users',
			icon: 'icon-worker',
			state: 'app.users',
			translate: 'USERS.USERS',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.users.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('users', '/users', {allow: ['get']});
		nuitApiProvider.register('users.create', '/users', {allow: ['post']});
		nuitApiProvider.register('users.one', '/users/:id', {allow: ['get', 'put', 'delete','patch']});
        nuitApiProvider.register('user.password', 'auth/:id', { allow: ['put'] });
        nuitApiProvider.register('user.config', '/configurations?scope=user', {allow:['get', 'put']});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(USERS_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.users')
		.factory('UserService', UserService);

	/** @ngInject */
	function UserService(nuitApi, nuitDataService, $log) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _users = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			addUser: addUser,
			getUsers: getUsers,
			getUserById: getUserById,
			updateUser: updateUser,
			deleteUser: deleteUser,
			restoreUser: restoreUser
		};

		//*******************************************
		/// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'users', {
			get: getUsersProperty
		});

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		/**
		 * Loads page with materials from remote server
		 * @param page
		 * @return {Promise}
		 */
		function getUsers(params) {
			if (params) {
				if (params.hasOwnProperty('roleIds')) {
					params['roleIds'] = params['roleIds'].join(',');
				}
			} else {
				params = {};
			}

			return nuitApi('users')
				.get(params)
				.then(function (response) {
					var users = response.data;

					// Append products
					_users.splice(0, _users.length);
					nuitDataService.replaceAll(_users, users);

					return users;
				})
				.catch(function (error) {
					$log.warn('Error loading user page', error);
					throw new Error('Error loading users');
				});
		}

		function getUsersProperty() {
			return _users;
		}

		function getUserById(id,params) {
			return nuitApi('users.one', id).get(params)
				.then(function (response) {
					var user = response.data;
					return user;
				});
		}

		function addUser(user) {
			return nuitApi('users.create')
				.post(user)
				.then(function (response) {
					_users.push(response.data);

					return response.data;
				});
		}

		/**
		 * Sends the updated user to the remote server.
		 * Returns a promise.
		 * @param user
		 */
		function updateUser(user, params) {
			return nuitApi('users.one', user.id)
				.put(user, params)
				.then(function (response) {
					var updatedUser = response.data;

					angular.merge(user, updatedUser);
					return user;
				});
		}

		function restoreUser(user){
			return updateUser(user, {undelete:true});
		}

		function deleteUser(user) {
			return nuitApi('users.one', user.id)
				.delete()
				.then(function (response) {
					for (var i = 0; i < _users.length; i++) {
						if (_users[i].id === user.id) {
							_users.splice(i, 1);
						}
					}

					return _users;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.users')
		.controller('UserListController', UserListController);

	/** @ngInject */
	function UserListController($q, $state, imsTranslation, UserService, RoleService, nuitUtils, imsUtils, nuitConfig, nuitApi) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.allowNextPage = false;
		vm.allowPrevPage = false;
		vm.currentPage = parseInt($state.params.page) || 0;
		vm.loading = true;
		vm.items = [];
		vm.searchText = $state.params.term || '';
		vm.selectedItems = [];
		vm.translation = imsTranslation;
		vm.currentPageEntities = [];
		vm.filteredEntities = [];
		vm.roleIds = [];
		vm.config = nuitConfig.current;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.deselectAll = deselectAll;
		vm.openItem = openItem;
		vm.isSelected = isSelected;
		vm.search = search;
		vm.selectAll = selectAll;
		vm.toggleSelectItem = toggleSelectItem;
		vm.toggleSelectedItems = toggleSelectedItems;
		vm.getRoleById = getRoleById;
		vm.deleteSelected = deleteSelected;
		vm.openUserSelection = openUserSelection;
		vm.disableUserAdding = disableUserAdding;
		vm.openUserSignup = openUserSignup;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function deselectAll() {
			vm.selectedItems = [];
		}

		function init() {
			vm.loadingItems = true;

			RoleService.reload()
				.then(function () {
					for (var i = 0; i < RoleService.roles.length; i++) {
						if (RoleService.roles[i].type === 0) {
							vm.roleIds.push(RoleService.roles[i].id);
						}
					}
					loadPage(vm.roleIds);
				});
		}

		function loadPage(roleIds) {
			UserService.getUsers({roleIds: roleIds})
				.then(function (response) {
					deselectAll();
					vm.items = response;
					filterAll();
				})
				.finally(function () {
					vm.loadingItems = false;
				});
		}

		function openUserSelection(){
			UserService.getUsers()
				.then(function(response) {
					var selection = [];
					var roleIds = [];

					for (var i = 0; i < RoleService.roles.length; i++) {
						roleIds.push(RoleService.roles[i].id);
					}

					for (var j = 0; j < response.length; j++) {
						if (roleIds.indexOf(response[j].roleId) === -1) {
							response[j].hasNoRole = true;
							selection.push(response[j]);
						}
					}

					UserService.getUsers({roleIds: vm.roleIds, deleted: true})
						.then(function (response) {
							for (var j = 0; j < response.length; j++) {
								selection.push(response[j]);
							}

							return imsUtils.openUserSelection(
								selection,
								{header: 'APP.RESTORE', cancel: 'APP.CANCEL', confirm: 'APP.OK',showRoles:true}
							)
								.then(function (data) {
									var promises = [];
									for (var i = 0; i < data.users.length; i++) {
										if(data.users[i].hasNoRole){
											promises.push(UserService.updateUser(data.users[i]));
										}else {
											promises.push(UserService.restoreUser(data.users[i]));
										}
									}
									$q.all(promises)
										.then(function () {
											loadPage(vm.roleIds);
											nuitUtils.showSuccessToast();
										})
										.catch(function () {
											nuitUtils.showErrorToast();
										});
								});
						});
				});
		}

		function getRoleById(id) {
			return RoleService.getRoleById(id);
		}

		function isSelected(item) {
			return vm.selectedItems.indexOf(item) >= 0;
		}

		function openItem(userId) {
			$state.go('app.users.detail', {
				userId: userId,
				page: vm.currentPage,
				term: vm.searchText
			}, {inherit: false});
		}

		function search() {
			$state.go('app.users', {term: vm.searchText, page: null});
			filterAll();
		}

		function selectAll() {
			deselectAll();

			angular.forEach(vm.currentPageEntities, function (item) {
				vm.selectedItems.push(item);
			});
		}

		function toggleSelectItem(item, $event) {
			$event.stopPropagation();

			var position = vm.selectedItems.indexOf(item);

			if (position >= 0) {
				vm.selectedItems.splice(position, 1);
			} else {
				vm.selectedItems.push(item);
			}
		}

		function toggleSelectedItems() {
			if (vm.selectedItems.length > 0) {
				deselectAll();
			} else {
				selectAll();
			}
		}

		function deleteSelected() {
			var showConfirmation = vm.selectedItems.length === 1 ?
				nuitUtils.showDeleteConfirmation :
				nuitUtils.showDeleteMultiConfirm;

			showConfirmation().then(function () {
				for (var i = 0; i < vm.selectedItems.length; i++) {
					var promises = [];
					promises.push(UserService.deleteUser(vm.selectedItems[i]));
					$q.all(promises)
						.then(function(){
							loadPage(vm.roleIds);
						});
				}
			});
		}

		function filterAll() {
			vm.filteredEntities = [];

			for (var i = 0; i < vm.items.length; i++) {
				var user = vm.items[i];
				if (filter(user)) {
					vm.filteredEntities.push(user);
				}
			}
		}

		function filter(user) {
			if (vm.searchText === '') {
				return true;
			} else {
				var keys = ['firstName', 'lastName'];

				for (var i = 0; i < keys.length; i++) {
					if(user[keys[i]].toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0){
						return true;
					}
				}

				return false;
			}
		}

		function disableUserAdding(){
			return vm.config.ims.users.restrictions.enabled && vm.items.length>=vm.config.ims.users.restrictions.maxUsers;
		}

		function openUserSignup(){
			imsUtils.openUserSignup(0);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.users')
		.controller('UserDetailsController', UserDetailsController);

	/** @ngInject */
	function UserDetailsController($state, $translate, imsUtils, imsTranslation, nuitConfig, UserService, nuitApi, nuitUtils, RoleService, EnvironmentService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();            // Contains the nuit config
		vm.itemId = $state.params.userId;               // ID of current user
		vm.isExistingUser = false;
        vm.selectedTab = $state.params.active;
		vm.loadingItem = false;                          // Indicator if a loading process is running
		vm.user = {};                            // Contains current user
        vm.userConfig = {};
        vm.roles = RoleService.roles;
        vm.translation = imsTranslation;
		vm.evoVersions = EnvironmentService.evoVersions;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.saveUser = saveUser;
        vm.isPasswordChangeable = isPasswordChangeable;
        vm.isEmailChangeable = isEmailChangeable;
        vm.changePassword = changePassword;
        vm.changeEmail = changeEmail;
		vm.uploadImage = uploadImage;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Sets all required variables which are needed by the view and loads current material into scope
		 */
		function init() {
			vm.isExistingUser = vm.itemId && vm.itemId > 0;

			if (vm.isExistingUser) {
				vm.loadingItem = true;

				UserService.getUserById(vm.itemId)
					.then(function (user) {
						vm.user = user;
					})
					.catch(nuitUtils.showErrorToast)
					.finally(function () {
						vm.loadingItem = false;
					});

				nuitConfig.reload()
					.then(function () {
						nuitApi('user.config')
							.get({user: vm.itemId})
							.then(function (response) {
								angular.merge(vm.userConfig, defaultUserConfig(), response.data);
							});
					});
			} else {
				vm.user.locale = $translate.use();
				vm.user.invoiced = true;
			}

            RoleService.reload();
		}

        /**
         * Returns the default user config.
         * @returns {Object}
         */
        function defaultUserConfig() {
            return {
                ims: {
                    enabled: {
                        type: 4,
                        value: true
                    },
                    bills: {
                        enabled: {value: false, type: 4}
                    },
                    proposals: {
                        enabled: {value: false, type: 4}
                    },
					orders: {
						enabled: {value: true, type: 4}
					},
					materials: {
						enabled: {value: false, type: 4}
					},
					products: {
                        enabled: {value: false, type: 4},
						sales: {
							enabled: {value: false, type: 4}
						}
					},
					productionOrders: {
						enabled: {value: false, type: 4}
					},
					queue: {
						enabled: {value: false, type: 4}
					},
					roles: {
						enabled: {value: false, type: 4}
					},
					sales: {
						enabled: {value: false, type: 4}
					},
					planning: {
						enabled: {value: false, type: 4}
					},
					productionEasy: {
						enabled: {value: false, type: 4}
					},
					companies: {
						enabled: {value: false, type: 4},
						admin: {
							enabled: {value: false, type: 4}
						}
					},
                    system: {
                        enabled: {value: false, type: 4}
                    },
                    materialControlling: {
                        enabled: {value: false, type: 4}
                    },
                    controllingSales: {
                        enabled: {value: false, type: 4}
                    },
                    users: {
                        enabled: {value: false, type: 4}
                    },
                    machines: {
                        enabled: {value: false, type: 4}
                    },
                    suppliers: {
                        enabled: {value: false, type: 4}
                    },
                    transport: {
                        enabled: {value: false, type: 4}
                    },
                    dashboard: {
                        enabled: {value: false, type: 4}
                    }
                },
				evo: {
					editor: {
                        enabled: {value: false, type: 4},
						stamping: {
							enabled: {value: false, type: 4}
						}
					},
					products: {
                        enabled: {value: false, type: 4},
						showPrices: {value: false, type: 4}
					},
					cart: {
                        enabled: {value: false, type: 4},
						showPrices: {value: false, type: 4}
					},toolbar: {
						languages: {
							enabled: {value: true, type: 4}
						}
					}
				},
				admin: {
					clients: {
						enabled: {value: false, type: 4}
					},
					environment: {
						enabled: {value: false, type: 4}
					},
					documents: {
						enabled: {value: false, type: 4}
					},
					status: {
						enabled: {value: false, type: 4}
					},
					translations: {
						enabled: {value: false, type: 4}
					}
				}
            };
        }

        function isPasswordChangeable() {
            return angular.isString(vm.password) && vm.password.length >= 3
            && vm.password === vm.passwordRepeat;
        }

        function isEmailChangeable()
		{
			return angular.isString(vm.newEmail) && vm.newEmail.length>3 && !vm.itemForm.newEmail.$error['email'] &&
				angular.isString(vm.passwordForEmail) && vm.passwordForEmail.length >= 3 &&
				angular.isString(vm.passwordRepeatForEmail) && vm.passwordRepeatForEmail.length >= 3 &&
				vm.passwordForEmail === vm.passwordRepeatForEmail;
		}

        function changePassword() {
			if(nuitUtils.isValidPassword(vm.password)) {
				nuitApi('user.password', vm.itemId)
					.put({password: vm.password})
					.then(function () {
						nuitUtils.showSuccessToast();
						vm.password = '';
						vm.passwordRepeat = '';
					})
					.catch(nuitUtils.showErrorToast);
			}
        }

        function changeEmail(){
        	if(nuitUtils.isValidPassword(vm.passwordForEmail)) {
				nuitApi('user.password', vm.itemId)
					.put({
						password: vm.passwordForEmail,
						email: vm.user.email,
						newEmail: vm.newEmail
					})
					.then(function () {
						nuitUtils.showSuccessToast();
						vm.user.email = vm.newEmail;
						vm.passwordForEmail = '';
						vm.passwordRepeatForEmail = '';
						vm.newEmail = '';
					})
					.catch(nuitUtils.showErrorToast);
			}
		}

		/**
		 * Sends the updated user to the remote server.
		 */
		function saveUser() {
            /*nuitApi('user.config')
                .put(vm.userConfig,{},{params: {user:vm.itemId}})
                .then(function(response) {
                    nuitConfig.reload();
			});*/
			var promise = null;

			if (vm.isExistingUser) {
				// Update existing user
				promise = UserService.updateUser(vm.user);
			}
			else if (nuitUtils.isValidPassword(vm.user.password)) {
				// Create new user
				promise = UserService.addUser(vm.user);
			}
			else {
				return;
			}

			promise
				.then(function () {
					nuitUtils.showSuccessToast();
					$state.go('app.users');
				})
				.catch(function (error) {
                    nuitUtils.showErrorToast();
                });
		}

		function uploadImage() {
			imsUtils.uploadEnvImage()
				.then(function (url) {
					vm.user.avatar = url;
					vm.itemForm.$setDirty();
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.factory('SystemService', SystemService);

	/** @ngInject */
	function SystemService(nuitApi, $log) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _services = {};
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			loadData: loadData
		};

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function loadData() {
			return nuitApi('system')
				.get()
				.then(function (response) {
					var result = response.data;
					return result;
				})
				.catch(function (error) {
					$log.warn('Error loading system informations');
					throw new Error(error);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.factory('EVOConfigService', EVOConfigService);

	/** @ngInject */
	function EVOConfigService(nuitApi, nuitConfig) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _config = DefaultConfig();
		var _holidays = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
            update: update,
			getHolidays: getHolidays,
			isHoliday: isHoliday
		};
        //*******************************************

        //*******************************************
        // PROPERTIES
        //*******************************************
        Object.defineProperty(service, 'config', { get: function() { return _config; } });
        Object.defineProperty(service, 'holidays', { get: function() { return _holidays; } });
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
        function DefaultConfig() {
            return {
                products: {
                    filters: {
                        type: 3,
                        value: []
                    }
                },
				material: {
					filters: {
						type: 3,
						value: []
					}
				},
                cart: {
                    showBadge: {value: false, type: 4 },
                    badgeColor: {value: '#25ae93', type: 2},
                    fields: {
                        type: 3,
                        value: []
                    }
                },
                editor: {
                    stamping: {
                        allowFreePlacement: { value: true, type: 4 },
                        allowMouseToolScaling: { value: true, type: 4 },
                        tools: { value: [], type: 3 },
                        generators: { value: [], type: 3}
                    }
                }
            };
        }

		function reload() {
			return nuitApi('system.config')
                    .get()
                    .then(function(response) {
                        angular.merge(_config, response.data.evo);
                return _config;
            });
		}

		function getHolidays(){
			if(nuitConfig.getCurrent().ims.system.bankHolidaySettings.enabled) {
				return nuitApi('system.config.one', 'evo.cart.delivery.bankHolidays').get()
					.then(function (response) {
						var config = response.data;
						if(config.evo && config.evo.cart && config.evo.cart.delivery && config.evo.cart.delivery.bankHolidays) {
							_holidays.splice(0,_holidays.length);
							var holidays = config.evo.cart.delivery.bankHolidays.value;
							for(var i=0;i<holidays.length;i++){
								_holidays.push(new Date(holidays[i]));
							}
						}
					});
			}
		}

		function isHoliday(date){
			if(date===undefined){
				return false;
			}

			var current;
			if (angular.isNumber(date)) {
				current = new Date(date * 1000);
			} else {
				current = date;
			}
			current.setHours(0, 0, 0, 0);
			for (var i = 0; i < _holidays.length; i++) {
				if (current.getTime() === _holidays[i].getTime()) {
					return true;
				}
			}
			return false;
		}

        function update() {
            var config = { evo: _config };
            return nuitApi('system.config')
                    .put(config)
					.then(function(){
						getHolidays();
					});
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.factory('envLanguage', envLanguageService);

	/** @ngInject */
	function envLanguageService($log, nuitApi) {
        //*******************************************
        // VARIABLES
        //*******************************************
        var table = {};
        var languages = [];
        var keyCount = 0;
        //*******************************************

        //*******************************************
        // SERVICE
        //*******************************************
        var service = {
            addKey: addKey,
            deleteKey: deleteKey,
            reload: reload,
            getKeys: getKeys,
            getTable: getTable,
            getLanguages: getLanguages,
            getKeyCount: getKeyCount,
            updateKey: updateKey,
            uploadTranslations: uploadTranslations
        };
        //*******************************************

        //*******************************************
        // PROPERTIES
        //*******************************************
        Object.defineProperty(service, 'languages', { get: function() { return languages; } });
        Object.defineProperty(service, 'translations', { get: function() { return table; } });
        //*******************************************

        //*******************************************
        // INITIALIZATION
        //*******************************************
        init();
        //*******************************************

        //*******************************************
        return service;
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        /**
         * Initializes the service.
         */
        function init() {
            nuitApi('env.translations.languages')
                .get()
                .then(function (response) {
                    languages.splice(0, languages.length);
                    angular.merge(languages, response.data);
                });

            reload();
        }

        function reload() {
            keyCount = 0;
            table = {};
            
            return nuitApi('env.translations')
                .get()
                .then(function (response) {
                    var all = response.data;
                    angular.forEach(all, function (pair, lang) {
                        angular.forEach(pair, function (value, key) {
                            if (!table[key]) {
                                table[key] = {};
                                keyCount++;
                            }
                            table[key][lang] = value;
                        });
                    });
                });
        }

        function addKey(key, lang, value) {
            if(!angular.isString(value) || value.length < 1) { $log.error('Translation value for key "' + key + '" and lang "' + lang + '" is empty!'); }
            return nuitApi('env.translations')
				.post({key: key, lang: lang, value: value})
				.then(function () {
					if (!table[key]) {
						table[key] = {};
						keyCount++;
					}

					table[key][lang] = value;
					return table;
				})
				.catch(function (error) {
					$log.error('Error inserting translation key');
					throw error;
				});
        }

        function updateKey(key) {
            angular.forEach(languages, function (lang) {
                if (table[key][lang]) {
                    nuitApi('env.translations.update', key).put({value: table[key][lang], lang: lang});
                }
            });
        }

        function deleteKey(key) {
            return nuitApi('env.translations.delete', key)
                .delete({scope:'environment'})
                .then(function() {
                    delete table[key];
            });
        }

        function getTable() {
            return table;
        }

        function getLanguages() {
            return languages;
        }

        function getKeyCount() {
            return keyCount;
        }

        function getKeys() {
            var result = [];
            angular.forEach(table, function (value, key) {
                result.push(key);
            });
            return result;
        }

        function uploadTranslations(fileData) {
            var uploadPromise = nuitApi('env.translations.csv')
				.post(fileData, {}, {
					headers: {
						'Content-Type': undefined
					}
                });
            
            return uploadPromise
				.then(function () {
                    // TODO: Backend should return inserted / updated translations to prevent the need of reloading all translations
                    return reload();
                })
                .catch(function (error) {
					$log.error('Failed to upload translations!');
					throw error;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('SystemController', SystemController);

	/** @ngInject */
	function SystemController($log, $q, $state, $translate, $document, $mdDialog, $scope, nuitConfig, envLanguage, EVOConfigService, imsColors, imsMaterials,
							  nuitApi, nuitUtils, imsTranslationService, DotNotationService, PostalCodeDelayService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.availableLanguages = envLanguage.languages;
		vm.config = nuitConfig.getCurrent();
		vm.currentLanguage = $translate.use();
		vm.currentTab = $state.params.active;
		vm.loading = true;
		// Tab [Settings|EVO]
		vm.cartConfig = {};
		vm.productsConfig = {};
		vm.materialConfig = {};
		vm.folders = {};                                            // Contains all folders visible in the folder hierachy
		vm.expandedFolders = [];                                    // Contains all expanded folders, updates UI and vice versa
		vm.selectedFolder = null;                                   // Contains the currently selected folder
		vm.treeOptions = createTreeOptions();                       // Contains the options for the tree control directive
		// Tab [Translations]
		vm.searchText = '';
		vm.translations = envLanguage.translations;
		// Tab [Company]
		vm.companyData = {};
		// Tab [Colors]
		vm.colors = imsColors.colors;

		vm.editableCartConfig = [
			{
				header: 'CART.CART_NAV',
				configs:[
					{key:'delivery.minDateOffset', translation:'EVO_CART_SETTINGS.DELIVERY.MIN_DATE_OFFSET', type: '1', defaultValue: 0},
					{key:'delivery.extendedMinDateOffsetStart', translation:'EVO_CART_SETTINGS.DELIVERY.EXTENDED_MIN_DATE_OFFSET_START', type: '2', defaultValue: ''},
					{key:'delivery.extendedMinDateOffsetDays', translation:'EVO_CART_SETTINGS.DELIVERY.EXTENDED_MIN_DATE_OFFSET_DAYS', type: '1', defaultValue: 0},
					{key:'delivery.minDateOffsetPickup', translation:'EVO_CART_SETTINGS.DELIVERY.MIN_DATE_OFFSET_PICKUP', type: '1', defaultValue: 0},
					{key:'delivery.extendedMinDateOffsetPickupStart', translation:'EVO_CART_SETTINGS.DELIVERY.EXTENDED_MIN_DATE_OFFSET_PICKUP_START', type: '2', defaultValue: ''},
					{key:'delivery.extendedMinDateOffsetPickupDays', translation:'EVO_CART_SETTINGS.DELIVERY.EXTENDED_MIN_DATE_OFFSET_PICKUP_DAYS', type: '1', defaultValue: 0},
					]
			}
		];
		//*******************************************

		//*******************************************
		// METHODS EXPOSURE
		//*******************************************
		// Tab [Settings|EVO]
		vm.deleteElement = deleteElement;
		vm.moveUpElement = moveUpElement;
		vm.moveDownElement = moveDownElement;
		/*vm.addPublicFolder = addPublicFolder;
		vm.renamePublicFolder = renamePublicFolder;
		vm.deletePublicFolder = deletePublicFolder;*/
		vm.addStampingTool = addStampingTool;
		vm.editStampingTool = editStampingTool;
		vm.addStampingGenerator = addStampingGenerator;
		vm.editStampingGenerator = editStampingGenerator;
		vm.saveConfig = saveConfig;
		vm.hasConfigs = hasConfigs;
		// Tab [Company]
		vm.submitCompanyData = submitCompanyData;
		// Tab [Translations]
		vm.addTranslation = addTranslation;
		vm.openTranslation = openTranslation;
		vm.deleteTranslation = deleteTranslation;
		vm.containsSearchText = containsSearchText;
		vm.showImportTranslationsDialog = showImportTranslationsDialog;
		// Tab [Colors]
		vm.addColor = addColor;
		vm.editColor = editColor;
		vm.deleteColor = deleteColor;
		vm.showImportColorsDialog = showImportColorsDialog;
		//vm.isInConfig = isInConfig;
		//vm.saveFields = saveFields;

		//Tab [Import/Export]
		vm.showImportMaterialsDialog = showImportMaterialsDialog;
		vm.showExportMaterialsDialog = showExportMaterialsDialog;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		$scope.$on('translateChangeSuccess', onTranslateChangeSuccess);

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		function onStateChangeSuccess() {
			vm.currentTab = $state.params.active;
		}

		function onTranslateChangeSuccess() {
			vm.currentLanguage = $translate.use();
		}

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************

		/*function saveFields() {
			EVOConfigService.update();
		}

		function isInConfig(key) {
			return DotNotationService.hasKey(vm.config, key);

		}*/

		function moveUpElement(element, collection) {
			if (!element) {
				return;
			}

			var index = collection.indexOf(element);
			if (index > -1) {
				collection.splice(index, 1);
				collection.splice(index - 1, 0, element);
				EVOConfigService.update();
			}
		}

		function moveDownElement(element, collection) {
			if (!element) {
				return;
			}

			var index = collection.indexOf(element);
			if (index > -1) {
				collection.splice(index, 1);
				collection.splice(index + 1, 0, element);
				EVOConfigService.update();
			}
		}

		function deleteElement(element, collection) {
			if (!element) {
				return;
			}
			nuitUtils
				.showDeleteConfirmation()
				.then(function () {
					var index = collection.indexOf(element);
					if (index > -1) {
						collection.splice(index, 1);
						EVOConfigService.update();
					}
				});
		}

		function generateTranslationEditingDialog(locals) {
			return {
				controller: 'SystemDialogTranslationController',
				controllerAs: 'vm',
				templateUrl: 'app/main/system.system/dialogs/translation/translation.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: locals
			};
		}

		function generateTranslationsImportDialog() {
			return {
				controller: 'CsvImportController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/csv.import/csv.import.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					title: 'TRANSLATIONS.IMPORT_TRANSLATIONS',
					fileName: 'translations'
				}
			};
		}

		function generateColorEditDialog(color) {
			return {
				controller: 'SystemColorEditController',
				controllerAs: 'vm',
				templateUrl: 'app/main/system.system/dialogs/color/color.edit.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					Color: angular.copy(color)
				}
			};
		}

		function generateColorsImportDialog() {
			return {
				controller: 'CsvImportController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/csv.import/csv.import.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					title: 'COLORS.IMPORT',
					fileName: 'import'
				}
			};
		}

		function generateMaterialsImportDialog() {
			return {
				controller: 'CsvImportController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/csv.import/csv.import.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					title: 'MATERIALS.IMPORT',
					fileName: 'import'
				}
			};
		}


		function generateStampingEditToolDialog(tool) {
			return {
				controller: 'StampingEditToolController',
				controllerAs: 'vm',
				templateUrl: 'app/main/system.system/dialogs/stamping.edit-tool/stamping.edit-tool.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					Tool: tool
				}
			};
		}

		function generateStampingEditGeneratorDialog(generator, tools) {
			return {
				controller: 'StampingEditGeneratorController',
				controllerAs: 'vm',
				templateUrl: 'app/main/system.system/dialogs/stamping.edit-generator/stamping.edit-generator.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					Generator: generator,
					Tools: tools
				}
			};
		}


		function generateFolderEditDialog(folder) {
			return {
				controller: 'ProfilesEditFolderDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/system.system/dialogs/profiles.edit-folder/profiles.edit-folder.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Folder: (folder === undefined ? {} : angular.copy(folder)),
					Folders: vm.folders
				}
			};
		}

		/**
		 * Returns the options for the folder tree.
		 * @returns {profiles.controllerL#1.ProfilesController.createTreeOptions.profiles.controllerAnonym$0}
		 */
		function createTreeOptions() {
			return {
				nodeChildren: 'children',
				dirSelectable: true,
				injectClasses: {
					ul: 'a1',
					li: 'a2',
					liSelected: 'a7',
					iExpanded: 'a3',
					iCollapsed: 'a4',
					iLeaf: 'a5',
					label: 'a6',
					labelSelected: 'a8'
				}
			};
		}

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			EVOConfigService
				.reload()
				.then(function (response) {
					vm.cartConfig = EVOConfigService.config.cart;
					if(vm.cartConfig.assignee.enabled && vm.cartConfig.assignee.enabled.value && !vm.cartConfig.assignee.users){
						vm.cartConfig.assignee.users =  {value: [], type: 3};
					}
					vm.productsConfig = EVOConfigService.config.products;
					vm.editorConfig = EVOConfigService.config.editor;
					vm.materialConfig = EVOConfigService.config.material;
				});

			vm.companyData = defaultCompanyData();

			nuitApi('system.config')
				.get()
				.then(function (response) {
					if (response.data.environment && response.data.environment.companyData) {
						vm.companyData = angular.merge(vm.companyData, response.data.environment.companyData);
					}
				});

			//reloadProfileFolders();

			imsColors.reloadColors().finally(function () {
				vm.loading = false;
			});
			nuitConfig.reload();


		}

		function saveConfig() {
			EVOConfigService.update();
		}

		function hasConfigs(config, selection){
			var hasConfigs = false;

			for(var i=0;i<selection.length;i++){
				hasConfigs = hasConfigs || DotNotationService.hasKey(config, selection[i].key);
			}

			return hasConfigs;
		}

		/*function addPublicFolder() {
			$mdDialog
				.show(generateFolderEditDialog())
				.then(function (result) {
					result.origin = 'production';
					return nuitApi('system.folders.public').post(result);
				})
				.then(function (result) {
					reloadProfileFolders();
				})
				.catch(function (rejection) {
				});
		}

		function renamePublicFolder(folder) {
			$mdDialog
				.show(generateFolderEditDialog(folder))
				.then(function (result) {
					return nuitApi('system.folder.public', result.id).put(result);
				})
				.then(function (result) {
					reloadProfileFolders();
				})
				.catch(function (rejection) {
				});
		}

		function deletePublicFolder(folder) {
			nuitUtils.showDeleteConfirmation('PROFILES.DELETE_FOLDER', 'PROFILES.DELETE_FOLDER_HTML').then(function () {
				nuitApi('system.folder.public', folder.id)
					.delete()
					.then(function () {
						reloadProfileFolders();
					});
			});
		}

		function reloadProfileFolders() {
			nuitApi('system.folders.public')
				.get({origin: 'production', user: 0})
				.then(function (response) {
					vm.folders = unpackage(response.data.environment, true, false);

					function unpackage(obj, root, pub) {
						var result = [];
						if (obj !== null) {
							angular.forEach(obj, function (value, key) {
								if (value === null) {
									return;
								}
								value.public = pub;
								value.root = root;
								value.children = unpackage(value.children, false, pub);
								result.push(value);
							});
						}
						return result;
					}
				});
		}*/

		function defaultCompanyData() {
			return {
				name: {value: '', type: 2},
				email: {value: '', type: 2},
				countryCode: {value: '', type: 2},
				city: {value: '', type: 2},
				area: {value: '', type: 2},
				zipCode: {value: '', type: 2},
				street: {value: '', type: 2},
				housenumber: {value: '', type: 2}
			};
		}

		function submitCompanyData() {
			var config = {
				environment: {
					companyData: vm.companyData
				}
			};

			nuitApi('system.config')
				.put(config)
				.then(nuitUtils.showSuccessToast);
		}

		function openTranslation(translation) {
			$mdDialog
				.show(generateTranslationEditingDialog({
					translation: angular.copy(translation)
				}))
				.then(function (changedTranslation) {
					vm.translations[changedTranslation.key] = changedTranslation.values;
					return envLanguage.updateKey(changedTranslation.key);
				})
				.then(function () {
					$translate.refresh();
				});
		}

		function deleteTranslation(key) {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					envLanguage
						.deleteKey(key)
						.then(function () {
							$translate.refresh();
							nuitUtils.showSuccessToast();
						})
						.catch(nuitUtils.showErrorToast);
				});
		}

		function addTranslation() {
			$mdDialog
				.show(generateTranslationEditingDialog({translation: undefined}))
				.then(function (newTranslation) {
					var key = newTranslation.key;
					var values = newTranslation.values;
					var promises = [];

					angular.forEach(values, function (value, lang) {
						if (value === '') {
							return;
						}
						var promise = envLanguage.addKey(key, lang, value);

						promise.catch(function (error) {
							console.log(error);
						});

						promises.push(promise);
					});

					$q.all(promises)
						.then(function () {
							nuitUtils.showSuccessToast();
							$translate.refresh();
						})
						.catch(function () {
							$log.error('Error updating translation');
							nuitUtils.showErrorToast();
						});
				});
		}

		function showImportTranslationsDialog() {
			$mdDialog
				.show(generateTranslationsImportDialog())
				.then(function (fileData) {
					envLanguage
						.uploadTranslations(fileData)
						.then(function (response) {
							// Translations have been reloaded, need to set reference again
							vm.translations = envLanguage.translations;
							$translate.refresh();
							nuitUtils.showSuccessToast();
						})
						.catch(function (error) {
							$log.error(error);
							nuitUtils.showErrorToast();
						});
				})
				.catch(angular.noop);
		}

		function addStampingGenerator() {
			$mdDialog
				.show(generateStampingEditGeneratorDialog(undefined, vm.editorConfig.stamping.tools.value))
				.then(function (generator) {
					if (!vm.editorConfig.stamping.generators) {
						vm.editorConfig.stamping.generators = {type: 3, value: []};
					}
					vm.editorConfig.stamping.generators.value.push(generator);
					EVOConfigService.update();
				})
				.catch(angular.noop);
		}

		function editStampingGenerator(generator) {
			var copy = angular.copy(generator);
			copy.index = vm.editorConfig.stamping.generators.value.indexOf(generator);
			$mdDialog
				.show(generateStampingEditGeneratorDialog(generator, vm.editorConfig.stamping.tools.value))
				.then(function (generator) {
					vm.editorConfig.stamping.generators.value.splice(generator.index, 1, generator);
					delete generator.index;
					EVOConfigService.update();
				})
				.catch(angular.noop);
		}


		function addStampingTool() {
			$mdDialog
				.show(generateStampingEditToolDialog())
				.then(function (tool) {
					if (!vm.editorConfig.stamping.tools) {
						vm.cartConfig.stamping.tools = {type: 3, value: []};
					}
					vm.editorConfig.stamping.tools.value.push(tool);
					EVOConfigService.update();
				})
				.catch(angular.noop);
		}

		function editStampingTool(tool) {
			var copy = angular.copy(tool);
			copy.index = vm.editorConfig.stamping.tools.value.indexOf(tool);
			$mdDialog
				.show(generateStampingEditToolDialog(copy))
				.then(function (tool) {
					vm.editorConfig.stamping.tools.value.splice(tool.index, 1, tool);
					delete tool.index;
					EVOConfigService.update();
				})
				.catch(angular.noop);
		}


		function addColor() {
			$mdDialog
				.show(generateColorEditDialog())
				.then(function (color) {
					imsColors.addColor(color)
						.then(function () {
							nuitUtils.showSuccessToast();
						})
						.catch(nuitUtils.showErrorToast);
				})
				.catch(angular.noop);
		}

		function editColor(color) {
			$mdDialog
				.show(generateColorEditDialog(color))
				.then(function (newColor) {
					imsColors.updateColor(newColor).then(function (response) {
						nuitUtils.showSuccessToast();
						angular.merge(color, response.data);
					})
						.catch(nuitUtils.showErrorToast);
				})
				.catch(angular.noop);
		}

		function deleteColor(color) {
			nuitUtils.showDeleteConfirmation().then(function () {
				imsColors.deleteColor(color)
					.then(nuitUtils.showSuccessToast)
					.catch(nuitUtils.showErrorToast);
			})
				.catch(angular.noop);
		}

		function showImportColorsDialog() {
			$mdDialog
				.show(generateColorsImportDialog())
				.then(function (fileData) {
					imsColors
						.uploadColors(fileData)
						.then(function (data) {
							imsColors.reload();
							nuitUtils.showSuccessToast();
						})
						.catch(function (error) {
							$log.error(error);
							nuitUtils.showErrorToast();
						});
				})
				.catch(angular.noop);
		}

		function showImportMaterialsDialog() {
			$mdDialog
				.show(generateMaterialsImportDialog())
				.then(function (fileData) {
					console.log(fileData);
					imsMaterials
						.uploadMaterials(fileData)
						.then(function (data) {
							imsMaterials.reload();
							nuitUtils.showSuccessToast();
						})
						.catch(function (error) {
							$log.error(error);
							nuitUtils.showErrorToast();
						});
				})
				.catch(angular.noop);
		}

		function showExportMaterialsDialog() {
			imsMaterials.downloadMaterials()
				.then(function () {

					nuitUtils.showSuccessToast();
				})
				.catch(function (error) {
					$log.error(error);
					nuitUtils.showErrorToast();
				});
		}

		function containsSearchText(translation) {
			return imsTranslationService.containsSearchText(translation, vm.searchText);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.controller('HolidayController', HolidayController);

	/** @ngInject */
	function HolidayController($filter, nuitUtils, nuitDataService, EVOConfigService, DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.isSaving = false;
		vm.isDirty = false;
		//*******************************************

		//*******************************************
		// METHODS EXPOSURE
		//*******************************************
		vm.save = save;

		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			EVOConfigService.reload()
				.then(function(){
					if(DotNotationService.hasKey(EVOConfigService.config, 'cart.delivery.bankHolidays')){
						vm.holidays = EVOConfigService.config.cart.delivery.bankHolidays.value;

					}else{
						vm.holidays = null;
					}
				});
		}

		function save(){
			vm.isSaving = true;

			var holidays = angular.copy(vm.holidays);

			EVOConfigService.reload()
				.then(function(){
					DotNotationService.set(EVOConfigService.config,'cart.delivery.bankHolidays.value',holidays);
					vm.holidays = EVOConfigService.config.cart.delivery.bankHolidays.value;
					EVOConfigService.update()
						.then(function(){
							vm.isDirty = false;
							vm.isSaving = false;
							nuitUtils.showSuccessToast();
						})
						.catch(nuitUtils.showErrorToast);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system.sales')
		.factory('SalesService', SalesService);

	/** @ngInject */
	function SalesService($q, nuitApi, nuitUtils) {
		//*******************************************
		// VARIABLES
		//*******************************************
        var bendingPrices = [];
        var bendingPricesLinear = 0.0;
        var bendingPriceLimit = -1;
        var edgeDiscounts = [];
        var surcharges = [];
        var discounts = [];
        var specials = [];
        var fixedWaste = 0.0;
        var shopConfig = {};
        var priceRules = [];
        var edgeCostPricePercent = 0;
        var edgeCostPriceAbsolute = 0;
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
            save: save,
            reload: reload
		};
        //*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		Object.defineProperty(service, 'bendingPrices', {
			get: function() { return bendingPrices; }
		});
		Object.defineProperty(service, 'enabled', {
			get: function() { return shopConfig['sales.enabled']; },
            set: function(value) { shopConfig['sales.enabled'] = value; }
		});
        Object.defineProperty(service, 'priceRules', {
			get: function() { return priceRules; }
		});
        Object.defineProperty(service, 'shopConfig', {
			get: function() { return shopConfig; }
		});
		Object.defineProperty(service, 'discounts', {
			get: function() { return discounts; }
		});
        Object.defineProperty(service, 'specials', {
			get: function() { return specials; }
		});
		Object.defineProperty(service, 'bendingPriceLimit', {
			get: function() { return bendingPriceLimit; },
            set: function(value) { bendingPriceLimit = value; }
		});
		Object.defineProperty(service, 'bendingPricesLinear', {
			get: function() { return bendingPricesLinear; },
            set: function(value) { bendingPricesLinear = value; }
		});
        Object.defineProperty(service, 'edgeDiscounts', {
			get: function() { return edgeDiscounts; },
            set: function(value) { edgeDiscounts = value; }
		});
		Object.defineProperty(service, 'surcharges', {
			get: function() { return surcharges; },
			set: function(value) { surcharges = value; }
		});
		Object.defineProperty(service, 'fixedWaste', {
			get: function() { return fixedWaste; },
            set: function(value) { fixedWaste = value; }
		});
		Object.defineProperty(service, 'edgeCostPriceAbsolute', {
			get: function() { return edgeCostPriceAbsolute; },
			set: function(value) { edgeCostPriceAbsolute = value; }
		});
		Object.defineProperty(service, 'edgeCostPricePercent', {
			get: function() { return edgeCostPricePercent; },
			set: function(value) { edgeCostPricePercent = value; }
		});
        //*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        function init() {
            for(var i = 0; i< 60;i++) {
                bendingPrices.push(0.0);
            }
        }

        function reload() {
            var bending = nuitApi('sales.config')
                .get()
                .then(function(response) {
                    discounts.splice(0, discounts.length);
                    angular.merge(discounts, response.data.discount);

                    bendingPriceLimit = response.data.edge.prices.length > 0 && response.data.edge.prices.length < 60 ? response.data.edge.prices.length-1 : -1;
                    bendingPricesLinear = response.data.edge.continue;
                    fixedWaste = response.data.fixedWaste;
                    if(response.data.edge.costPrice) {
						edgeCostPriceAbsolute = response.data.edge.costPrice.absolute;
						edgeCostPricePercent = response.data.edge.costPrice.percent;
					}

                    edgeDiscounts.splice(0, edgeDiscounts.length);
                    angular.merge(edgeDiscounts, response.data.edge.discount);

					surcharges.splice(0, surcharges.length);
					angular.merge(surcharges, response.data.edge.surcharge);

                    bendingPrices.splice(0, bendingPrices.length);
                    angular.merge(bendingPrices, response.data.edge.prices);
                    while(bendingPrices.length < 60) {
                        bendingPrices.push(0.0);
                    }
            });

            nuitApi('sales.config.special')
				.get()
				.then(function(response){
					angular.merge(specials, response.data);
				});

            var shopconfig = nuitApi('sales.shop.config')
                .get()
                .then(function(response) {
                    nuitUtils.clearObj(shopConfig);
                    angular.merge(shopConfig, response.data);
            });

            var priceRulesPromise = nuitApi('sales.shop.pricerules')
                .get()
                .then(function (response) {
                    priceRules.splice(0, priceRules.length);
                    angular.merge(priceRules, response.data);
                });

            return $q.all([bending, shopconfig, priceRulesPromise]);
        }

        function save() {
            var data = {
                edge: {
                    prices: bendingPriceLimit < 0 ? bendingPrices : angular.copy(bendingPrices).splice(0, bendingPriceLimit+1),
                    'continue': bendingPricesLinear,
                    discount: edgeDiscounts,
					surcharge: surcharges,
					costPrice:{
                    	absolute:edgeCostPriceAbsolute,
						percent: edgeCostPricePercent
					}
                },
                discount: discounts,
                fixedWaste: fixedWaste
            };

            return $q.all([nuitApi('sales.config').post(data),
                nuitApi('sales.config.special').post(specials),
                nuitApi('sales.shop.config').post([shopConfig])],
                nuitApi('sales.shop.pricerules').post(priceRules));
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system.sales')
		.factory('RawMaterialEdgePricesService', factory);

	/** @ngInject */
	function factory($q, $log, nuitApi) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var BENDING_PRICES_LENGTH = 60;
		var entries = [];
		// Ids that have been removed in the UI but were previously persisted on the
		// server — DELETEd on the next save() call. Locally-only adds that get
		// removed before save are not staged here.
		var pendingDeleteIds = [];
		// Snapshot of ids that are confirmed persisted on the server. Used to tell
		// "this entry exists on the server and should be DELETEd on remove" from
		// "this entry was added in this session and never got PUT yet".
		var persistedIds = {};
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			save: save,
			get: get,
			add: add,
			duplicate: duplicate,
			duplicateFromConfig: duplicateFromConfig,
			remove: remove,
			defaultEntry: defaultEntry
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'entries', {
			get: function () { return entries; }
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function reload() {
			return nuitApi('sales.config.rawmaterials')
				.get()
				.then(function (response) {
					entries.splice(0, entries.length);
					pendingDeleteIds.splice(0, pendingDeleteIds.length);
					persistedIds = {};
					if (!angular.isArray(response.data) || response.data.length === 0) {
						return entries;
					}
					var fetches = response.data.map(function (meta) {
						persistedIds[meta.id] = true;
						return nuitApi('sales.config.rawmaterials.one', meta.id)
							.get()
							.then(function (full) {
								entries.push(stripDiscounts(normalize(full.data)));
							});
					});
					return $q.all(fetches).then(function () { return entries; });
				});
		}

		function save() {
			var ops = [];

			for (var i = 0; i < pendingDeleteIds.length; i++) {
				ops.push(deleteOne(pendingDeleteIds[i]));
			}

			for (var j = 0; j < entries.length; j++) {
				ops.push(upsertOne(entries[j]));
			}

			return $q.all(ops).then(function () {
				pendingDeleteIds.splice(0, pendingDeleteIds.length);
			});
		}

		function get(id) {
			for (var i = 0; i < entries.length; i++) {
				if (entries[i].id === id) {
					return entries[i];
				}
			}
			return null;
		}

		function add(id) {
			var existing = get(id);
			if (existing) { return existing; }
			// If the entry was staged for deletion in this session and the user re-adds it,
			// drop the pending DELETE so the upsert wins.
			var pendingIdx = pendingDeleteIds.indexOf(id);
			if (pendingIdx >= 0) { pendingDeleteIds.splice(pendingIdx, 1); }
			var entry = normalize(defaultEntry(id));
			entries.push(entry);
			return entry;
		}

		function duplicate(sourceId, targetId) {
			var existing = get(targetId);
			if (existing) { return existing; }
			var source = get(sourceId);
			if (!source) { return null; }
			var pendingIdx = pendingDeleteIds.indexOf(targetId);
			if (pendingIdx >= 0) { pendingDeleteIds.splice(pendingIdx, 1); }
			var entry = stripDiscounts(angular.copy(source));
			entry.id = targetId;
			entries.push(entry);
			return entry;
		}

		// Seeds a new entry from a server-shaped sales config payload — used to clone
		// the global "General" config (which lives in SalesService, not entries[]) into
		// a per-rawmaterial override. The payload matches the wire format produced by
		// SalesService.save(), so normalize() reconstructs _bendingPriceLimit and pads
		// the prices array the same way reload() does.
		function duplicateFromConfig(targetId, configPayload) {
			var existing = get(targetId);
			if (existing) { return existing; }
			var pendingIdx = pendingDeleteIds.indexOf(targetId);
			if (pendingIdx >= 0) { pendingDeleteIds.splice(pendingIdx, 1); }
			var entry = stripDiscounts(normalize({ id: targetId, profile: angular.copy(configPayload) }));
			entries.push(entry);
			return entry;
		}

		function remove(id) {
			for (var i = entries.length - 1; i >= 0; i--) {
				if (entries[i].id === id) {
					entries.splice(i, 1);
				}
			}
			if (persistedIds[id] && pendingDeleteIds.indexOf(id) < 0) {
				pendingDeleteIds.push(id);
			}
		}

		// Mirrors the /v2/config/profiles shape under `profile`, plus the entry id.
		function defaultEntry(id) {
			return {
				id: id,
				profile: {
					edge: {
						prices: [],
						'continue': 1,
						costPrice: {percent: 0, absolute: 0}
					},
					fixedWaste: 0
				}
			};
		}

		// Pads prices to BENDING_PRICES_LENGTH and stashes the original cutoff in
		// _bendingPriceLimit, mirroring the convention SalesService uses for the
		// global config. The synthetic limit field is stripped from the wire payload
		// in toWire().
		function normalize(raw) {
			var entry = angular.copy(raw);
			if (!entry.profile) { entry.profile = {}; }
			if (!entry.profile.edge) { entry.profile.edge = {}; }
			if (!angular.isArray(entry.profile.edge.prices)) { entry.profile.edge.prices = []; }
			if (entry.profile.edge['continue'] == null) { entry.profile.edge['continue'] = 0; }
			if (!entry.profile.edge.costPrice) { entry.profile.edge.costPrice = {percent: 0, absolute: 0}; }
			if (entry.profile.fixedWaste == null) { entry.profile.fixedWaste = 0; }

			var origLen = entry.profile.edge.prices.length;
			while (entry.profile.edge.prices.length < BENDING_PRICES_LENGTH) {
				entry.profile.edge.prices.push(0);
			}
			entry._bendingPriceLimit = (origLen > 0 && origLen < BENDING_PRICES_LENGTH) ? origLen - 1 : -1;
			return entry;
		}

		// Discounts and surcharges are not edited in this UI. Clear them whenever an
		// entry enters entries[] (reload/duplicate) so stale server values can't leak
		// back into a save.
		function stripDiscounts(entry) {
			if (entry.profile && entry.profile.edge) {
				entry.profile.edge.discount = undefined;
				entry.profile.edge.surcharge = undefined;
			}
			if (entry.profile) {
				entry.profile.discount = undefined;
			}
			return entry;
		}

		function toWire(entry) {
			var prices = entry._bendingPriceLimit < 0
				? angular.copy(entry.profile.edge.prices)
				: angular.copy(entry.profile.edge.prices).splice(0, entry._bendingPriceLimit + 1);
			return {
				profile: {
					edge: {
						prices: prices,
						'continue': entry.profile.edge['continue'],
						discount: entry.profile.edge.discount,
						surcharge: entry.profile.edge.surcharge,
						costPrice: {
							absolute: entry.profile.edge.costPrice.absolute,
							percent: entry.profile.edge.costPrice.percent
						}
					},
					discount: entry.profile.discount,
					fixedWaste: entry.profile.fixedWaste
				}
			};
		}

		function upsertOne(entry) {
			return nuitApi('sales.config.rawmaterials.one', entry.id)
				.post(toWire(entry))
				.then(function () {
					persistedIds[entry.id] = true;
				});
		}

		function deleteOne(id) {
			return nuitApi('sales.config.rawmaterials.one', id)
				.delete()
				.then(function () {
					delete persistedIds[id];
				})
				.catch(function (err) {
					// If the entry was already gone server-side (404), drop the
					// stale persistedIds entry but don't fail the whole save.
					if (err && err.status === 404) {
						delete persistedIds[id];
						return;
					}
					$log.error('Failed to delete raw material edge config ' + id, err);
					return $q.reject(err);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system.sales')
		.factory('LogisticsService', factory);

	/** @ngInject */
	function factory(nuitApi, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var tables = [];
		var surcharge = {};
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			update: update,
			reloadSurcharge: reloadSurcharge,
			updateSurcharge: updateSurcharge
		};
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		Object.defineProperty(service, 'tables', {
			get: function () {
				return tables;
			}
		});
		Object.defineProperty(service, 'surcharge', {
			get: function () {
				return surcharge;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function reload() {
			return nuitApi('sales.logistic.tables')
				.get()
				.then(function (response) {
					tables.splice(0, tables.length);
					angular.merge(tables, response.data);
				});
		}

		function update() {
			if(tables.length>0) {
				return nuitApi('sales.logistic.tables')
					.post(tables);
			}
			else{
				return nuitApi('sales.logistic.tables')
					.delete();
			}
		}

		function reloadSurcharge() {
			return nuitApi('sales.logistic.surcharge')
				.get()
				.then(function (response) {
					nuitDataService.replaceOneEntity(surcharge, response.data);
				})
				.catch(function(error){
					nuitDataService.replaceOneEntity(surcharge, {fixedTime:[],specials:[]});
				});
		}

		function updateSurcharge() {
			return nuitApi('sales.logistic.surcharge')
				.post(surcharge);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.system.sales')
		.controller('SalesController', SalesController);

	/** @ngInject */
	function SalesController($translate, $filter, $state, $scope, $mdDialog, $document, nuitConfig, $q, nuitUnits, imsTranslation, imsMaterials, ProductAttributes, SalesService, LogisticsService, RawMaterialEdgePricesService, ProductService, nuitUtils, nuitDataService, imsUtils, CART_SHIPPING_TYPES, Countries) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.loading = true;
        vm.sales = SalesService;
        vm.nuitUnits = nuitUnits;
		vm.config = nuitConfig.getCurrent();
        vm.shopConfig = SalesService.shopConfig;
		vm.currentTab = $state.params.active;
        vm.bendingPrices = SalesService.bendingPrices;
        vm.edgeDiscounts = SalesService.edgeDiscounts;
        vm.edgeSurcharge = SalesService.surcharges;
        vm.discounts = SalesService.discounts;
        vm.specials = SalesService.specials;
        vm.surcharge = LogisticsService.surcharge;
        vm.logisticTables = LogisticsService.tables;

        vm.materials = imsMaterials.materials;
        vm.groups = imsMaterials.groups;
        vm.attributes = ProductAttributes.all;

        vm.salesRule = {};
        vm.salesRules = SalesService.priceRules;
        vm.priceRuleTypes = ProductService.priceRuleTypes;
		vm.materialAttributeBase = ProductService.materialAttributeBase;
        vm.priceModifiers = ProductService.priceModifiers;
        vm.priceModifierTypes = ProductService.priceModifierTypes;
        vm.numericCombinators = ProductService.numericCombinators;
        vm.productProperties = ProductService.productProperties;
        vm.booleanComparators = ProductService.booleanComparators;
        vm.numericComparators = ProductService.numericComparators;

        vm.shippingTypes = CART_SHIPPING_TYPES;
        vm.countries = Countries;

        // Raw-material-specific edge-price overrides. activeEntry === null means the global
        // SalesService config is being edited; otherwise it's a member of rawMaterialEdges.
        vm.rawMaterialEdges = RawMaterialEdgePricesService.entries;
        vm.activeEntry = null;
        vm.activeEdge = SalesService;
        //*******************************************

		//*******************************************
		// METHODS EXPOSURE
		//*******************************************
        vm.isBendingPriceEditable = isBendingPriceEditable;
        vm.toggleBendingLimit = toggleBendingLimit;
        vm.showAddLogisticsTableDialog = showAddLogisticsTableDialog;
        vm.getLogisticsTableColumnCount = getLogisticsTableColumnCount;
        vm.addLogisticsRow = addLogisticsRow;
        vm.removeLogisticsRow = removeLogisticsRow;
        vm.addLogisticsColumn = addLogisticsColumn;
        vm.removeLogisticsColumn = removeLogisticsColumn;
        vm.toggleEditTable = toggleEditTable;
        vm.deleteTable = deleteTable;
        vm.getLogisticsTestPrice = getLogisticsTestPrice;
        vm.moveSpecial = moveSpecial;
        vm.removeSpecial = removeSpecial;

        // Product Pricerules
        vm.getAttributeById = ProductAttributes.getById;
        vm.createPriceRule = createPriceRule;
        vm.isRuleValid = isRuleValid;
        vm.showRuleLimitations = showRuleLimitations;
        vm.showRulePriceModifier = showRulePriceModifier;
        vm.showNumberCondition = showNumberCondition;
        vm.showLengthCondition = showLengthCondition;
        vm.showAreaCondition = showAreaCondition;
        vm.showMaterialCondition = showMaterialCondition;
        vm.showMaterialGroupCondition = showMaterialGroupCondition;
        vm.getRuleConditionDisplayValue = getRuleConditionDisplayValue;
        vm.getRuleComparatorType = getRuleComparatorType;
        vm.getComparatorKey = getComparatorKey;
        vm.ruleTypeToKey = ProductService.getRuleTypeKey;
        vm.priceModifierTypeToSymbol = ProductService.getPriceModifierSymbol;
        vm.getProductPropertyKey = ProductService.getProductPropertyKey;
        vm.movePriceRule = movePriceRule;
        vm.editPriceRule = editPriceRule;
        vm.deletePriceRule = deletePriceRule;
        vm.resetRule = resetRule;
        vm.addImageToSpecial = addImageToSpecial;

        vm.save = save;

        // Edge-price tab — chip strip + per-rawmaterial editing
        vm.selectGeneralEdge = selectGeneralEdge;
        vm.selectMaterialEdge = selectMaterialEdge;
        vm.addRawMaterialEdge = addRawMaterialEdge;
        vm.duplicateGeneral = duplicateGeneral;
        vm.duplicateEntry = duplicateEntry;
        vm.removeEntry = removeEntry;
        vm.getRawMaterialName = getRawMaterialName;
        vm.entrySortKey = function (entry) { return getRawMaterialName(entry.id); };
        vm.isMaterialEdgeActive = function () { return vm.activeEntry !== null; };
        //*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
        function generateLogisticsAddTableDialog() {
			return {
				controller: 'LogisticsAddTableController',
				controllerAs: 'vm',
				templateUrl: 'app/main/system.sales/dialogs/logistics.add-table/logistics.add-table.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true
			};
		}

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		function onStateChangeSuccess() {
			vm.currentTab = $state.params.active;
		}

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
            var promises = [];

            promises.push(LogisticsService.reload());
            promises.push(LogisticsService.reloadSurcharge());
            promises.push(SalesService.reload());
            promises.push(RawMaterialEdgePricesService.reload());
            promises.push(ProductAttributes.reload());
            promises.push(imsMaterials.reload());
            promises.push(imsMaterials.reloadGroups());

            $q
                .all(promises)
                .finally(function () {
                    vm.loading = false;
					vm.selectedLanguage = $translate.use();
                });
		}

        function save() {
            $q.all([
                vm.sales.save(),
                RawMaterialEdgePricesService.save()
            ]).then(function () {
                nuitUtils.showSuccessToast();
            }, function (err) {
                console.error('Sales save failed', err);
            });
            LogisticsService.update();
            LogisticsService.updateSurcharge();
        }

        function selectGeneralEdge() {
            vm.activeEntry = null;
            vm.activeEdge = SalesService;
            vm.bendingPrices = SalesService.bendingPrices;
        }

        function selectMaterialEdge(entry) {
            vm.activeEntry = entry;
            vm.activeEdge = makeEdgeAdapter(entry);
            vm.bendingPrices = entry.profile.edge.prices;
        }

        function addRawMaterialEdge() {
            var excludeIds = vm.rawMaterialEdges.map(function (e) { return e.id; });
            $mdDialog.show({
                controller: 'RawMaterialPickerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/system.sales/dialogs/raw-material-picker/raw-material-picker.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: { excludeIds: excludeIds }
            }).then(function (rawMaterialId) {
                if (rawMaterialId == null) { return; }
                var entry = RawMaterialEdgePricesService.add(rawMaterialId);
                selectMaterialEdge(entry);
            });
        }

        function duplicateGeneral() {
            var excludeIds = vm.rawMaterialEdges.map(function (e) { return e.id; });
            $mdDialog.show({
                controller: 'RawMaterialPickerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/system.sales/dialogs/raw-material-picker/raw-material-picker.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: { excludeIds: excludeIds }
            }).then(function (rawMaterialId) {
                if (rawMaterialId == null) { return; }
                // Mirrors the wire shape from SalesService.save(): prices truncated to
                // the active limit so normalize() rebuilds _bendingPriceLimit correctly.
                var limit = SalesService.bendingPriceLimit;
                var prices = limit < 0
                    ? angular.copy(SalesService.bendingPrices)
                    : angular.copy(SalesService.bendingPrices).slice(0, limit + 1);
                var snapshot = {
                    edge: {
                        prices: prices,
                        'continue': SalesService.bendingPricesLinear,
                        discount: angular.copy(SalesService.edgeDiscounts || []),
                        surcharge: angular.copy(SalesService.surcharges || []),
                        costPrice: {
                            absolute: SalesService.edgeCostPriceAbsolute,
                            percent: SalesService.edgeCostPricePercent
                        }
                    },
                    discount: angular.copy(SalesService.discounts || []),
                    fixedWaste: SalesService.fixedWaste
                };
                var copy = RawMaterialEdgePricesService.duplicateFromConfig(rawMaterialId, snapshot);
                if (copy) { selectMaterialEdge(copy); }
            });
        }

        function duplicateEntry(entry) {
            if (!entry) { return; }
            var excludeIds = vm.rawMaterialEdges.map(function (e) { return e.id; });
            $mdDialog.show({
                controller: 'RawMaterialPickerController',
                controllerAs: 'vm',
                templateUrl: 'app/main/system.sales/dialogs/raw-material-picker/raw-material-picker.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: { excludeIds: excludeIds }
            }).then(function (rawMaterialId) {
                if (rawMaterialId == null) { return; }
                var copy = RawMaterialEdgePricesService.duplicate(entry.id, rawMaterialId);
                if (copy) { selectMaterialEdge(copy); }
            });
        }

        function removeEntry(entry) {
            if (!entry) { return; }
            nuitUtils
                .showDeleteConfirmation()
                .then(function () {
                    var wasActive = vm.activeEntry === entry;
                    RawMaterialEdgePricesService.remove(entry.id);
                    if (wasActive) { selectGeneralEdge(); }
                });
        }

        function getRawMaterialName(rawMaterialId) {
            var group = imsMaterials.getGroupById(rawMaterialId);
            if (!group) { return '#' + rawMaterialId; }
            return $filter('nuitTranslate')(group.name, '???');
        }

        // Adapter exposing the same property names SalesService provides for edge data,
        // backed by an entry's profile fields. Keeps bending.html bindings uniform across
        // the global config and per-rawmaterial entries.
        function makeEdgeAdapter(entry) {
            return {
                get bendingPriceLimit() { return entry._bendingPriceLimit; },
                set bendingPriceLimit(v) { entry._bendingPriceLimit = v; },
                get bendingPricesLinear() { return entry.profile.edge['continue']; },
                set bendingPricesLinear(v) { entry.profile.edge['continue'] = v; },
                get fixedWaste() { return entry.profile.fixedWaste; },
                set fixedWaste(v) { entry.profile.fixedWaste = v; },
                get edgeCostPriceAbsolute() { return entry.profile.edge.costPrice.absolute; },
                set edgeCostPriceAbsolute(v) { entry.profile.edge.costPrice.absolute = v; },
                get edgeCostPricePercent() { return entry.profile.edge.costPrice.percent; },
                set edgeCostPricePercent(v) { entry.profile.edge.costPrice.percent = v; }
            };
        }

        function getLogisticsTableColumnCount(table) {
            return (table.lengths.length || 1) + (table.zips.length > 0 ? 1 : 0);
        }

        function isTableInEditMode(table) {
            if(angular.isObject(table.weight) && table.weight._edit === true) { return true; }

            for(var index in table.lengths) {
                if(table.lengths[index]._edit === true) { return true; }
            }
            for(var index in table.zips) {
                if(table.zips[index]._edit === true) { return true; }
            }
            for(var index in table.data) {
                for(var i in table.data[index]) {
                    if(table.data[index][i]._edit === true) { return true; }
                }
            }

            return false;
        }

        function deleteTable(index) {
            nuitUtils
                .showDeleteConfirmation()
                .then(function() {
                    vm.logisticTables.splice(index, 1);
            });
        }

        function toggleEditTable(table) {
            var newState = true;
            if(isTableInEditMode(table)) {
                newState = false;
            }

            table._edit = newState;

            if(angular.isObject(table.weight)) { table.weight._edit = newState; }

            for(var index in table.lengths) {
                table.lengths[index]._edit = newState;
            }
            for(var index in table.zips) {
                table.zips[index]._edit = newState;
            }
            for(var index in table.data) {
                for(var i in table.data[index]) {
                    table.data[index][i]._edit = newState;
                }
            }
        }

        function getLogisticsTestPrice() {
            if(!angular.isNumber(vm.testWeight)) { return 0.0; }
            if(!angular.isNumber(vm.testLength)) { return 0.0; }

            if(vm.activeRules === undefined) { vm.activeRules = []; }

            var testData = {
                weight: vm.testWeight,
                length: vm.testLength,
                zip: vm.testZIP || '',
                price: vm.testPrice || 0.0
            };

            var result = {
                base: 0,
                pBase: 1.0,
                bonus: 0,
                pBonus: 1.0
            };

            vm.activeRules.splice(0, vm.activeRules.length);
            for (var index in vm.logisticTables) {
                var table = vm.logisticTables[vm.logisticTables.length - index - 1];
                if (angular.isObject(table.prices)) {
                    for (var row in table.data) {
                        var data = table.data[row][0];
                        if (!compare(testData.price, table.prices[row].min.value, table.prices[row].min.comparator)
                            || !compare(testData.price, table.prices[row].max.value, table.prices[row].max.comparator)) { continue; }
                        vm.activeRules.push(table.data[row]);
                        apply(result, data.operator, data.value, data.type);
                    }
                    continue;
                }
                if(angular.isObject(table.weight) && !compare(testData.weight, table.weight.value, table.weight.comparator)) { continue; }
                for(var row in table.data) {
                    if(table.zips.length > 0 && table.zips[row].value && testData.zip.indexOf(table.zips[row].value) !== 0) { continue; }
                    for(var column in table.data[row]) {
                        var data = table.data[row][column];
                        if(table.lengths.length > 0 && !compare(testData.length, table.lengths[column].value, table.lengths[column].comparator)) { continue; }
                        vm.activeRules.push(data);
                        apply(result, data.operator, data.value, data.type);
                    }
                }
            }

            return result.base * result.pBase * result.pBonus + result.bonus;
        }

        function apply(result, operator, value, valueType) {
            switch (operator) {
                case '+':
                    switch (valueType) {
                        case 'c':
                            result.bonus += value;
                            break;
                        case '%':
                            result.pBonus += value * 0.01;
                            break;
                    }
                    break;
                case '-':
                    switch (valueType) {
                        case 'c':
                            result.bonus -= value;
                            break;
                        case '%':
                            result.pBonus -= value * 0.01;
                            break;
                    }
                    break;
                case '=':
                    switch (valueType) {
                        case 'c':
                            result.base = value;
                            break;
                        case '%':
                            result.pBase = value * 0.01;
                            break;
                    }
                    break;
            }
        }

        function compare(v1, v2, comparator) {
            switch(comparator) {
                case '<': return v1 < v2;
                case '<=': return v1 <= v2;
                case '>': return v1 > v2;
                case '>=': return v1 >= v2;
                case '=': return v1 === v2;
            }
            return false;
        }

        function showAddLogisticsTableDialog() {
            $mdDialog.show(generateLogisticsAddTableDialog())
                .then(function(tableDef) {
                    var table = {
                        name: tableDef.name,
                        lengths: [],
                        zips: [],
                        prices: [],
                        data: []
                    };
                if(tableDef.weight === true) {
                    table.weight = {
                        comparator: '<',
                        value: 100
                    };
                }
                if(tableDef.lengths === true) {
                    table.lengths.push({
                        comparator: '<',
                        value: 100
                    });
                }
                if(tableDef.zips === true) {
                    table.zips.push({
                        comparator:'%=',
                        //value: '1'
                    });
                }
                if (tableDef.prices === true) {
                    table.prices.push({
                        min: {
                            comparator: '>=',
                            value: 0
                        }, max: {
                            comparator: '<',
                            value: 500
                        }});
                } else {
                    delete table.prices;
                }
                table.data.push([{
                    type: 'c',
                    value: 0,
                    operator: '='
                }]);
                vm.logisticTables.push(table);
            });
        }

        function addLogisticsRow(table) {
            if(table.zips.length > 0) {
                table.zips.push({
                    comparator: '%=',
                    //value: '1'
                });
            }
            if (table.prices && table.prices.length > 0) {
                table.prices.push({
                    min: {
                        comparator: '>=',
                        value: '0'
                    }, max: {
                        comparator: '<',
                        value: '500'
                    }});
            }
            var dataCount = Math.max(1, table.lengths.length);
            var data = [];
            while(dataCount > 0) {
                data.push({
                    type: 'c',
                    value: 0,
                    operator: '='
                });
                dataCount--;
            }
            table.data.push(data);
        }

        function removeLogisticsRow(table) {
            if(table.zips.length > 1) {
                table.zips.splice(table.zips.length-1, 1);
            }
            if(table.data.length > 1) {
                table.data.splice(table.data.length-1, 1);
            }
        }

        function addLogisticsColumn(table) {
            table.lengths.push({
                comparator: '>',
                value: '100'
            });
            for(var index in table.data) {
                table.data[index].push({
                    type: 'c',
                    value: 0,
                    operator: '='
                });
            }
        }

        function removeLogisticsColumn(table) {
            if(table.lengths.length > 1) {
                table.lengths.splice(table.lengths.length-1, 1);
            }
            if(table.data[0].length > 1) {
                for(var index in table.data) {
                    table.data[index].splice(table.data[index].length-1, 1);
                }
            }
        }

        function isBendingPriceEditable(index) {
            return vm.activeEdge.bendingPriceLimit >= index || vm.activeEdge.bendingPriceLimit < 0;
        }

        function toggleBendingLimit(index) {
            if(vm.activeEdge.bendingPriceLimit === index) {
                vm.activeEdge.bendingPriceLimit = -1;

            } else {
                vm.activeEdge.bendingPriceLimit = index;
            }
        }

        function isRuleValid() {
             if(vm.salesRule.type === undefined) { return false; }

			 if(vm.salesRule.priceModifierType===vm.materialAttributeBase && angular.isString(vm.salesRule.priceModifier)){
				 return true;
			 }

             if(!angular.isString(vm.salesRule.priceModifier)
             || !angular.isNumber(vm.salesRule.priceModifierValue)
             || !angular.isString(vm.salesRule.priceModifierType)) {
                return false;
             }

             switch(vm.salesRule.type) {
                 case 'attribute':
                    if(vm.salesRule.attribute === undefined
                    || vm.salesRule.conditionType === undefined
                    || vm.salesRule.conditionValue === undefined) {
                        return false;
                    }
                    return true;
                case 'combination':
                    if(vm.salesRule.lh_attribute === undefined
                    || vm.salesRule.rh_attribute === undefined
                    || vm.salesRule.combinationType === undefined) {
                        return false;
                    }
                    return true;
                case 'productdata':
                    if(vm.salesRule.property === undefined
                    || vm.salesRule.conditionType === undefined
                    || vm.salesRule.conditionValue === undefined) {
                        return false;
                    }
                    return true;
                default:
                    return false;
             }
        }

        function showRuleLimitations() {
            if(vm.salesRule.priceModifier === undefined ||
                vm.salesRule.priceModifierValue === undefined ||
                vm.salesRule.priceModifierType === undefined) {
                return false;
            }
            switch(vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined
                        && (vm.salesRule.attribute.type === 'number' || vm.salesRule.attribute.type === 'length')
                        && (vm.salesRule.conditionType === '/' || vm.salesRule.conditionType === '$');
                case 'combination':
                    return vm.salesRule.lh_attribute !== undefined && vm.salesRule.rh_attribute !== undefined && vm.salesRule.combinationType !== undefined;
                case 'productdata':
                    return (vm.salesRule.conditionType === '/' || vm.salesRule.conditionType === '$');
                default:
                    return false;
            }
        }

        function showNumberCondition() {
            switch (vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined
                        && vm.salesRule.attribute.type === 'number';
                case 'combination':
                    return vm.salesRule.lh_attribute !== undefined
                        && vm.salesRule.rh_attribute !== undefined
                        && vm.salesRule.combinationType !== undefined
                        && vm.salesRule.lh_attribute.type === 'number'
                        && vm.salesRule.rh_attribute.type === 'number';
                case 'productdata':
                    return vm.salesRule.property === 'general.quantity';
                default:
                    return false;
            }
        }

        function showLengthCondition() {
            switch (vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined
                        && vm.salesRule.attribute.type === 'length';
                case 'combination':
                    return vm.salesRule.lh_attribute !== undefined
                        && vm.salesRule.rh_attribute !== undefined
                        && vm.salesRule.combinationType !== undefined
                        && ((vm.salesRule.lh_attribute.type === 'length' && vm.salesRule.rh_attribute.type === 'number')
                        || (vm.salesRule.lh_attribute.type === 'number' && vm.salesRule.rh_attribute.type === 'length'));
                case 'productdata':
                    return vm.salesRule.property === 'profile.blank' ||
                        vm.salesRule.property === 'profile.length';

                default:
                    return false;
            }
        }

        function showAreaCondition() {
            switch (vm.salesRule.type) {
                case 'combination':
                    return vm.salesRule.lh_attribute !== undefined
                        && vm.salesRule.rh_attribute !== undefined
                        && vm.salesRule.combinationType !== undefined
                        && vm.salesRule.lh_attribute.type === 'length'
                        && vm.salesRule.rh_attribute.type === 'length';
                default:
                    return false;
            }
        }

        function showMaterialCondition() {
            switch (vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined
                        && vm.salesRule.attribute.type === 'material';
                case 'productdata':
                    return vm.salesRule.property === 'profile.material';
                default:
                    return false;
            }
        }

        function showMaterialGroupCondition() {
            switch (vm.salesRule.type) {
                case 'productdata':
                    return vm.salesRule.property === 'profile.materialgroup';
                default:
                    return false;
            }
        }

        function getRuleConditionDisplayValue(rule) {
            switch(rule.type) {
                case 'attribute':
					var attr = ProductAttributes.getById(rule.attributeId);
					switch (attr.type) {
						case 'color':
							return $filter('nuitTranslate')(nuitDataService.getOne(vm.colors,rule.conditionValue).name, '???');
						case 'material':
							if(rule.priceModifierType===vm.materialAttributeBase){
								return $filter('translate')('SALES.ATTRIBUTE_BASE_PRICE');
							}

							return $filter('nuitTranslate')(nuitDataService.getOne(vm.materials,rule.conditionValue).name, '???');
						case 'length':
							return $filter('nuitUnit')(rule.conditionValue,'length');
					}
                    break;
                case 'combination':
                    break;
                case 'productdata':
                    switch(rule.property) {
                        case 'profile.material':
							if(rule.priceModifierType===vm.materialAttributeBase){
								return $filter('translate')('SALES.ATTRIBUTE_BASE_PRICE');
							}

							if(angular.isArray(rule.conditionValue)){
                                var result = '\r\n';
                                for(var index in rule.conditionValue) {
									result += $filter('nuitTranslate')(nuitDataService.getOne(vm.materials,rule.conditionValue[index]).name, '???') + '\r\n';
                                }
                                return result;
                            } else {
								return $filter('nuitTranslate')(nuitDataService.getOne(vm.materials,rule.conditionValue).name, '???');
                            }
                        case 'profile.materialgroup':
                         if(angular.isArray(rule.conditionValue)){
                             var result = '\r\n';
                             for(var index in rule.conditionValue) {
								 result += $filter('nuitTranslate')(nuitDataService.getOne(vm.groups,rule.conditionValue[index]).name, '???') + '\r\n';
                             }
                             return result;
                         } else {
							 return $filter('nuitTranslate')(nuitDataService.getOne(vm.groups,rule.conditionValue).name, '???');
                         }
						case 'profile.length':
						case 'profile.blank':
							return $filter('nuitUnit')(rule.conditionValue,'length');
                    }
            }
            return rule.conditionValue;
        }

        function showRulePriceModifier() {
            switch(vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined;
                case 'combination':
                    return vm.salesRule.lh_attribute !== undefined && vm.salesRule.rh_attribute !== undefined && vm.salesRule.combinationType !== undefined;
                case 'productdata':
                    return vm.salesRule.property !== undefined;
                default:
                    return false;
            }
        }

        function getComparatorKey(rule) {
            var type = getRuleComparatorType(rule);
            switch(type) {
                case 'boolean':
                    return ProductService.getBooleanComparatorKey(rule.conditionType);
                case 'numeric':
                    return ProductService.getNumericComparatorKey(rule.conditionType);
                case 'string':
                    return rule.conditionType;
            }
            return rule.conditionType;
        }

        function getRuleComparatorType(rule) {
            switch(rule.type) {
                case 'attribute':
                    var attr = ProductAttributes.getById(rule.attributeId);
                    switch(attr.type) {
                        case 'enum':
                        case 'material':
                        case 'color':
                            return 'boolean';
                        case 'length':
                        case 'number':
                            return 'numeric';
                        case 'string':
                            return 'string';
                    }
                    break;
                case 'combination':
                    return 'numeric';
                case 'productdata':
                    switch(rule.property) {
                        case 'general.quantity':
                        case 'profile.blank':
                        case 'profile.length':
                            return 'numeric';
                        case 'profile.material':
                        case 'profile.materialgroup':
                            return 'boolean';
                    }
                    break;
            }
            return '';
        }

        function moveSpecial(index, offset) {
            var special = vm.specials.splice(index, 1)[0];
            vm.specials.splice(index + offset, 0, special);
        }

        function removeSpecial(index) {
            var special = vm.specials[index];

            if(special.name !== '' || special.description !== '' || special.price !== 0 || special.pricePerUnit !== 0) {
                nuitUtils.showDeleteConfirmation()
                    .then(function() {
                        vm.specials.splice(index, 1);
                });
            } else {
                vm.specials.splice(index, 1);
            }
        }

        function addImageToSpecial(special){
			imsUtils.uploadEnvImage()
				.then(function (url) {
					special.img = url;
				});
		}

        function movePriceRule(index, offset) {
            var rule = vm.salesRules.splice(index, 1)[0];
            vm.salesRules.splice(index + offset, 0, rule);
        }

        function editPriceRule(index) {
            vm.editedPriceRule = vm.salesRules[index];
            vm.salesRule = angular.copy(vm.salesRules[index]);

            switch(vm.salesRule.type) {
                case 'attribute':
                    vm.salesRule.attribute = ProductAttributes.getById(vm.salesRule.attributeId);
                    break;
                case 'combination':
                    vm.salesRule.lh_attribute = ProductAttributes.getById(vm.salesRule.lhAttributeId);
                    vm.salesRule.rh_attribute = ProductAttributes.getById(vm.salesRule.rhAttributeId);
                    break;
            }
        }

        function deletePriceRule(index) {
            nuitUtils.showDeleteConfirmation()
                .then(function () {
                    var deleted = vm.salesRules.splice(index, 1)[0];
                    if (vm.editedPriceRule === deleted) {
                        resetRule();
                    }
                });
        }

        function resetRule() {
            delete vm.editedPriceRule;
            vm.salesRule = {};
        }

        function createPriceRule() {
            if(!isRuleValid()) { return; }

            var rule = {
                type: vm.salesRule.type,
                priceModifier: vm.salesRule.priceModifier,
                priceModifierValue: vm.salesRule.priceModifierValue,
                priceModifierType: vm.salesRule.priceModifierType,
                priceModifierMin: vm.salesRule.priceModifierMin,
                priceModifierMax: vm.salesRule.priceModifierMax
            };

            switch(vm.salesRule.type) {
                case 'attribute':
                    rule.attributeId = vm.salesRule.attribute.id;
                    switch (vm.salesRule.attribute.type) {
                        case 'enum':
                            rule.conditionType = vm.salesRule.conditionType;
                            rule.conditionValue = vm.salesRule.conditionValue;
                            break;
                        case 'length':
                        case 'number':
                            rule.conditionType = vm.salesRule.conditionType;
                            rule.conditionValue = vm.salesRule.conditionValue;
                            rule.conditionStart = vm.salesRule.conditionStart;
                            break;
                    }
                    break;
                case 'combination':
                    rule.lhAttributeId = vm.salesRule.lh_attribute.id;
                    rule.rhAttributeId = vm.salesRule.rh_attribute.id;
                    rule.combinationType = vm.salesRule.combinationType;
                    rule.conditionType = vm.salesRule.conditionType;
                    rule.conditionValue = vm.salesRule.conditionValue;
                    rule.conditionStart = vm.salesRule.conditionStart;
                    break;
                case 'productdata':
                    rule.property = vm.salesRule.property;
                    switch (vm.salesRule.property) {
                        case 'general.quantity':
                        case 'profile.blank':
                        case 'profile.length':
                            rule.conditionType = vm.salesRule.conditionType;
                            rule.conditionValue = vm.salesRule.conditionValue;
                            rule.conditionStart = vm.salesRule.conditionStart;
                            break;
                        case 'profile.material':
                        case 'profile.materialgroup':
                            rule.conditionType = vm.salesRule.conditionType;
                            rule.conditionValue = vm.salesRule.conditionValue;
                            break;
                    }
                    break;
            }

            if (vm.editedPriceRule) {
                nuitUtils.clearObj(vm.editedPriceRule);
                angular.merge(vm.editedPriceRule, rule);
                delete vm.editedPriceRule;
            } else {
                vm.salesRules.push(rule);
            }

            vm.salesRule = {};
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.profiles', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, PROFILES_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.profiles', {
				url: '/profiles?folder',
				views: {
					'content@app': {
						templateUrl: 'app/main/system.profiles/views/profiles.html',
						controller: 'ProfilesController as vm'
					},
					'body@app.profiles': {
						templateUrl: 'app/main/system.profiles/views/profile-list.html',
						controller: 'ProfileListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.profiles.enabled'
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('system.profiles', {
			title: 'Users',
			icon: 'icon-worker',
			state: 'app.profiles',
			translate: 'EVO.PROFILES',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.profiles.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************

		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(PROFILES_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.profiles')
		.controller('ProfilesController', ProfilesController);

	/** @ngInject */
	function ProfilesController($translate,$stateParams, $state, $transitions, $scope, $filter, $mdSidenav, $mdDialog, nuitUtils, ProductService, nuitConfig, ProfileFolders) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.privateFolders = ProfileFolders.privateFolders;
		vm.publicFolders = ProfileFolders.publicFolders;
		vm.filteredProfiles = [];
		vm.pagedProfiles = [];
		vm.profiles = ProfileFolders.profiles;
		vm.isLoading = false;
		vm.expandedFolders = [];
		vm.selectedFolder = null;
		vm.treeOptions = createTreeOptions();
		vm.$stateParams = $stateParams;
		vm.$state = $state;
		vm.orderTree = orderTree;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.showSelected = showSelected;
		vm.toggleSidenav = toggleSidenav;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		// a transition hook, not '$stateChangeSuccess' - index.run.js broadcasts that
		// one synthetically on every url change, still carrying the old state
		var deregisterOnSuccess = $transitions.onSuccess({to: 'app.profiles'}, function () {
			applySelectedFolder();
		});
		$scope.$on('$destroy', deregisterOnSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createTreeOptions() {
			return {
				nodeChildren: 'children',
				dirSelectable: true,
				injectClasses: {
					ul: 'a1',
					li: 'a2',
					liSelected: 'a7',
					iExpanded: 'a3',
					iCollapsed: 'a4',
					iLeaf: 'a5',
					label: 'a6',
					labelSelected: 'a8'
				},
				allowDeselect: false,
				orderBy: ' | orderByTranslated:"name"'
			};
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			ProfileFolders.reload()
				.then(function(){
					if(!$state.params.folder) {
						showSelected({id: 'public'});
					}else{
						applySelectedFolder();
					}
				});
		}

		// writes the url only - applySelectedFolder() reacts to it
		function showSelected(folder) {
			if (angular.isNumber(folder)) {
				folder = {id: folder};
			}

			$state.go('.', {
				folder: folder.id
			}, {
				notify: false
			});
		}

		function applySelectedFolder() {
			if (!$state.params.folder) {
				return;
			}

			var id = ProfileFolders.parseFolderId($state.params.folder);
			// the 'public'/'private' pseudo folders have no folder entity
			var folder = ProfileFolders.getFolderById(id) || {id: id};

			ProfileFolders.cacheSelectedFolder(folder);

			vm.profiles = null;
			vm.pagedProfiles.splice(0, vm.pagedProfiles.length);

			var parent = ProfileFolders.getFolderById(folder.parentId);
			while (parent !== null) {
				if (vm.expandedFolders.indexOf(parent) < 0) {
					vm.expandedFolders.push(parent);
				}
				parent = ProfileFolders.getFolderById(parent.parentId);
			}

			vm.selectedFolder = folder;
		}

		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}

		function orderTree(entity){
			if(vm.config.ims.profiles.sortByName) {
				return $filter('nuitTranslate')(entity.name, '???');
			}else{
				return entity.position;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.profiles')
		.controller('ProfileListController', ProfileListController);

	/** @ngInject */
	function ProfileListController($mdDialog, $state, $scope, $translate, $filter, $q, $timeout, DotNotationService, ProductService, imsTranslation, ListSelectionService, imsMaterials, nuitUtils, FavoriteService, nuitConfig, nuitProfiles, nuitApiProxy, imsUtils,nuitDataService,ProfileFoldersView, ProfileFolders) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.profiles = [];
		vm.filteredEntities = [];
		vm.currentPage = 0;
		vm.currentPageEntities = [];
		vm.selection = ListSelectionService.get('system.profiles', true);
		vm.isLoading = true;
		vm.term = angular.isDefined($state.params.term) ? $state.params.term : '';
		vm.lang = nuitConfig.current.languages;
		vm.config = nuitConfig.current;
		vm.$state = $state;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.deselectAll = vm.selection.deselectAll;
		vm.deleteSelected = deleteSelected;
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.isIndeterminate = vm.selection.isIndeterminate;
		vm.openProfile = openProfile;
		vm.newProfile = newProfile;
		vm.moveProfiles = function($event){
			var selected = vm.getSelected();
			ProfileFoldersView.moveMultiple(
				$event,
				selected,
				vm.selectedFolder,
				ProfileFolders.publicFolders,
				ProfileFolders.privateFolders
				)
				.then(function(){
					for(var i=0;i<selected.length;i++) {
						nuitDataService.removeOne(vm.profiles, selected[i].id);
					}
					filterProfiles();
				})
				.then(nuitUtils.showSuccessToast);
		};
		vm.renameFolder = function($event, folder){
			ProfileFoldersView.renameFolder($event, folder)
				.then(function(){
					ProfileFolders.reload()
						.then(function(){
							$scope.$parent.vm.showSelected(ProfileFolders.getFolderById(folder.id));
						});
				});
		};
		vm.renameProfile = ProfileFoldersView.rename;
		vm.search = search;
		vm.toggleSelectProfile = vm.selection.toggleSelectedEntity;
		vm.toggleSelectedProfiles = toggleSelectedProfiles;
		vm.toggleSidenav = $scope.$parent.vm.toggleSidenav;
		vm.filterProfiles = filterProfiles;
		vm.magnifyImage = nuitUtils.magnifyImage;
		vm.selectedFolder = null;
		vm.swapFolder = function(folder,swapId){
			ProfileFoldersView.swapFolder(folder,swapId)
				.then(function(newFolder){
					$scope.$parent.vm.showSelected(newFolder);
				});
		};
		vm.addFolder = function($event){
			ProfileFoldersView.addFolder($event,vm.selectedFolder,vm.selectedFolder?vm.selectedFolder.public:$state.params.folder==='public')
				.then(ProfileFolders.reload);
		};
		vm.deleteFolder = function($event){
			var parentId = vm.selectedFolder.parentId?vm.selectedFolder.parentId:vm.selectedFolder.public?'public':'private';
			ProfileFoldersView.deleteFolder($event,vm.selectedFolder)
				.then(function(){
					ProfileFolders.reload()
						.then(function(){
							$state.go('.', {
								folder: parentId
							}, {
								notify: false
							});
						});
				});
		};
		vm.moveFolder = function($event){
			ProfileFoldersView.moveFolder($event,vm.selectedFolder,vm.selectedFolder.public?ProfileFolders.publicFolders:undefined,vm.selectedFolder.public?undefined:ProfileFolders.privateFolders)
				.then(ProfileFolders.reload);
		};

		vm.getName = function(profile){
			return $filter('nuitTranslate')(profile.data.name);
		};
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			delayedStateInit();
		}

		function delayedStateInit(){
			if(ProfileFolders.isReloading){
				window.setTimeout(delayedStateInit,500);
			}else{
				onStateChangeSuccess();
			}
		}

		function openProfile(profile) {
			imsUtils.openEditor(profile.data)
				.then(function(newProfileData){
					nuitApiProxy('profile.single',profile.id).put(newProfileData)
						.then(function(response){
							nuitDataService.replaceOneEntity(profile.data,response.data);
							nuitUtils.showSuccessToast();
						})
						.catch(function(){
							nuitUtils.showErrorToast();
						});
				});
		}

		function newProfile($event){
			imsUtils.openEditor(undefined,undefined, undefined, undefined, true)
				.then(function(newProfileData){
					return $mdDialog
						.show(ProfileFoldersView.createRenameDialog($event,newProfileData.name,'APP.NAME','APP.SAVE'))
						.then(function(name){
							delete newProfileData.id;
							newProfileData.name = name;
							return nuitApiProxy('profile.save')
								.post(newProfileData, {folder: $state.params.folder})
								.then(function(response) {
									reloadFolderProfiles($state.params.folder);
									nuitUtils.showSuccessToast();})
								.catch(function(response) {
									nuitUtils.showErrorToast();
								});
						});
				});
		}

		/**
		 * Deletes all selected products.
		 */
		function deleteSelected() {
			var promise;
			if (vm.getSelected().length > 1) {
				promise = nuitUtils.showDeleteMultiConfirm();
			} else if (vm.getSelected().length === 1) {
				promise = nuitUtils.showDeleteConfirmation();
			} else {
				return;
			}

			promise.then(function () {
				var promises = [];
				angular.forEach(vm.getSelected(), function (profile, key) {
					var deletePromise = nuitApiProxy('profiles.single',profile.id)
						.delete()
						.then(function (response) {
							nuitDataService.removeOne(vm.profiles,profile.id);
							filterProfiles();
						});
					promises.push(deletePromise);
				});
				vm.deselectAll();
				$q
					.all(promises)
					.then(nuitUtils.showSuccessToast)
					.catch(nuitUtils.showErrorToast);
			});
		}

		/**
		 * Performs a LOCAL search operation.
		 * Might be replaced with an API call later on.
		 */
		function search() {
			filterProfiles();
		}

		/**
		 * Filters all products based on the selected category and search term.
		 */
		function filterProfiles() {
			vm.filteredEntities.splice(0, vm.filteredEntities.length);
			var currentProfiles = sortProfiles(vm.profiles);

			var i;
			for (i in currentProfiles) {
				if (filterProfile(currentProfiles[i])) {
					vm.filteredEntities.push(currentProfiles[i]);
				}
			}

			vm.filteredEntities = FavoriteService.sort($filter('orderByNuitTranslated')(vm.filteredEntities, 'name'));
			vm.deselectAll();
		}

		function filterProfile(profile) {
			return (vm.term === '' || ($filter('nuitTranslate')(profile.data.name,'').toLowerCase().includes(vm.term.toLowerCase())));
		}


		/**
		 * Toggles the selection of all selected products
		 * between selecting all products of the current page
		 * and no products.
		 */
		function toggleSelectedProfiles() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * This event is fired whenever the state changes
		 * @param fromState
		 * @param toState
		 */
		function onStateChangeSuccess(fromState, toState) {
			vm.selectedFolder = ProfileFolders.getFolderById(ProfileFolders.parseFolderId($state.params.folder));

			vm.term = $state.params.term || '';

			reloadFolderProfiles($state.params.folder);
		}

		function reloadFolderProfiles(id) {
			vm.isLoading = true;
			if(id) {
				return nuitApiProxy('profiles.list', id)
					.get()
					.then(function (response) {
						vm.profiles = !angular.isArray(response.data) ? [] : response.data;
					})
					.catch(function(){
						vm.profiles = [];
					})
					.finally(function(){
						filterProfiles();
						vm.isLoading = false;
					});
			}else{
				vm.profiles = [];
				filterProfiles();
				vm.isLoading = false;
			}
		}

		function sortProfiles(profiles){
			if(vm.config.evo && vm.config.evo.account && vm.config.evo.account.files && vm.config.evo.account.files.sortByName) {
				return $filter('orderBySavedProfileName')(profiles);
			}else{
				return profiles;
			}
		}
	}
}());

(function () {
    'use strict';

    angular
        .module('app.roles', [])
        .config(config);

    function config($stateProvider, msNavigationServiceProvider, nuitApiProvider, nuitConfigProvider, ROLES_SETTINGS) {
	    //*******************************************
	    // STATES
	    //*******************************************
        $stateProvider
            .state('app.roles', {
                url: '/roles?term&index&page',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/system.roles/views/roles.html',
                        controller: 'RolesController as vm'
                    },
                    'body@app.roles': {
                        templateUrl: 'app/main/system.roles/views/role-list.html',
	                    controller: 'RoleListController as vm'
                    }
                },
	            reloadOnSearch: false,
				permissions: 'ims.roles.enabled'
            })
	        .state('app.roles.compose', {
	        	url: '/add',
		        views: {
	        		'body@app.roles': {
	        			templateUrl: 'app/main/system.roles/views/role-details.html',
				        controller: 'RoleDetailsController as vm'
			        }
		        },
				permissions: 'ims.roles.enabled'
	        })
	        .state('app.roles.detail',{
		        url: '/:roleId',
		        views: {
		        	'body@app.roles': {
		        		templateUrl: 'app/main/system.roles/views/role-details.html',
				        controller: 'RoleDetailsController as vm'
			        }
		        },
				permissions: 'ims.roles.enabled'
	        });
        //*******************************************

	    //*******************************************
	    // NAVIGATION
	    //*******************************************
        msNavigationServiceProvider.saveItem('system.roles', {
            title: 'Benutzerrollen',
            icon: 'icon-account-multiple',
            state: 'app.roles',
            translate: 'USERS.ROLES',
            weight: 20,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.roles.enabled;
			}
        });
        //*******************************************

	    //*******************************************
	    // API ROUTES
	    //*******************************************
	    nuitApiProvider.register('roles.all', '/roles', {allow: ['get', 'post']});
	    nuitApiProvider.register('roles.single', '/roles/:id', {allow: ['get', 'put', 'delete']});
        nuitApiProvider.register('config.environment', '/configurations?scope=environment&format=compact', {allow: ['get']});
        //*******************************************

	    //*******************************************
	    // SETTINGS
	    //*******************************************
	    nuitConfigProvider.injectIntoDefault(ROLES_SETTINGS);
        //*******************************************
    }
})();

(function () {
	'use strict';

	angular
		.module('app.roles')
		.factory('RoleService', RoleService);

	/** @ngInject */
	function RoleService(nuitApi, $injector, nuitDataService, $log, ROLES_CONSTANTS, SetupDefinitions, nuitConfig, DotNotationService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _roles = [];
		var _types = [
			{id: 0, name: 'ROLES.TYPES.INTERNAL', config: 'ims.roles.enabled'},
			{id: 1, name: 'ROLES.TYPES.PARTNERS', config: 'ims.companies.enabled'},
			{id: 2, name: 'ROLES.TYPES.CARRIERS', config: 'ims.transport.enabled'}
		];
		var _defaultRoleConfig = {};
		var _moduleGroups = {};
		var defaultModuleConfigs = {};
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			addRole: addRole,
			deleteRole: deleteRole,
			loadRole: loadRole,
			updateRole: updateRole,
			getRoleById: getRoleById,
			getTypeName: getTypeName,
			getGroups: SetupDefinitions.getGroups,
			getGroupHeader: SetupDefinitions.getGroupHeader,
			getGroupIndex: SetupDefinitions.getGroupIndex
		};
		//*******************************************
		init();
		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'roles', {
			get: function () {
				return _roles;
			}
		});
		Object.defineProperty(service, 'types', {
			get: function () {
				return _types;
			}
		});
		Object.defineProperty(service, 'defaultRoleConfig', {
			get: function () {
				return _defaultRoleConfig;
			}
		});
		Object.defineProperty(service, 'moduleGroups', {
			get: function () {
				return _moduleGroups;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function init() {

			for (var i = 0; i < ROLES_CONSTANTS.length; i++) {
				var moduleConfig = $injector.get(ROLES_CONSTANTS[i]);
				defaultModuleConfigs[ROLES_CONSTANTS[i]] = moduleConfig;
				_defaultRoleConfig = angular.merge(_defaultRoleConfig, nuitConfig.toAPIConfig(moduleConfig));
			}
			_defaultRoleConfig = angular.merge(_defaultRoleConfig, getDefaultRoleConfig());

			nuitConfig.reload()
				.then(function () {
					SetupDefinitions.reloadModules()
						.then(function () {
							SetupDefinitions.updateModuleGroups();
							for (var locationKey in SetupDefinitions.moduleGroups) {
								var moduleGroup = SetupDefinitions.moduleGroups[locationKey];
								for (var i = 0; i < moduleGroup.length; i++) {
									var module = moduleGroup[i];
									var moduleConstantName;

									if (DotNotationService.get(nuitConfig.current, module.key, false) && DotNotationService.hasKey(_defaultRoleConfig, module.key)) {
										if (!_moduleGroups[locationKey]) {
											_moduleGroups[locationKey] = [];
										}

										for (var key in defaultModuleConfigs) {
											if (DotNotationService.hasKey(defaultModuleConfigs[key], module.key)) {
												moduleConstantName = key;
												break;
											}
										}

										var config = DotNotationService.get(_defaultRoleConfig, module.rootKey, {});

										_moduleGroups[locationKey].push({
											name: module.name,
											key: module.key,
											rootKey: module.rootKey,
											config: config,
											constantName: moduleConstantName,
											moduleName: module.moduleName,
											moduleType: module.moduleType
										});
									}
								}
							}
						});
				});
		}


		/**
		 * Reloads all roles and stores them in the public array.
		 * @return {Promise}
		 */
		function reload() {
			return nuitApi('roles.all')
				.get()
				.then(function (response) {
					var roles = response.data;

					_roles.splice(0, _roles.length);
					// Append roles
					for (var i in roles) {
						_roles.push(roles[i]);
					}

					return roles;
				})
				.catch(function (error) {
					$log.warn('Error loading roles!', error);
					return error;
				});
		}

		/**
		 * Returns loaded material or if unknown loads material from remote server
		 * @param id
		 * @return {Promise} requested material
		 */
		function loadRole(id) {
			return nuitApi('roles.single', id)
				.get()
				.then(function (response) {
					return response.data;
				});
		}

		function getDefaultRoleConfig() {
			return {
				evo: {
					cart: {
						enabled: {value: false, type: 4}
					},
					editor: {
						enabled: {value: false, type: 4}
					},
					products: {
						enabled: {value: false, type: 4}
					},
					sketches: {
						enabled: {value: false, type: 4}
					}
				}
			};
		}

		function deleteRole(role) {
			return nuitApi('roles.single', role.id)
				.delete()
				.then(function () {
					for (var i in _roles) {
						if (_roles[i].id === role.id) {
							_roles.splice(i, 1);
							break;
						}
					}
				});
		}

		function getRoleById(id) {
			for (var i in _roles) {
				if (_roles[i].id === id) {
					return _roles[i];
				}
			}
			return null;
		}

		function addRole(data) {
			return nuitApi('roles.all')
				.post(data)
				.then(function (response) {
					var addedRole = response.data;

					_roles.push(addedRole);

					return addedRole;
				});
		}

		/**
		 * Sends updated material to remote server
		 * @param role
		 */
		function updateRole(role) {
			return nuitApi('roles.single', role.id)
				.put(role)
				.then(function (response) {
					var updatedRole = response.data;

					angular.merge(role, updatedRole);
					return role;
				});
		}

		function getTypeName(id) {
			var type = nuitDataService.getOne(_types, id);
			return type ? type.name : '';
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.roles')
		.controller('RolesController', RolesController);

	/** @ngInject */
	function RolesController($mdSidenav) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
        //*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.toggleSidenav = toggleSidenav;
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}
        //*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.roles')
		.controller('RoleListController', RoleListController);

	/** @ngInject */
	function RoleListController($state, $filter, $scope, $q, imsTranslation, RoleService, nuitUtils, ListSelectionService) {
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.translation = imsTranslation;
		vm.currentPage = 0;
		vm.isLoading = true;
		vm.roles = RoleService.roles;
		vm.searchText = $state.params.term;

        vm.selection = ListSelectionService.get('system.roles', true);
        vm.currentPageEntities =[];
        vm.filteredEntities =[];

        //*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.deselectAll =  vm.selection.deselectAll;
        vm.deleteSelection = deleteSelection;
		vm.openItem = openItem;
		vm.getSelected = vm.selection.getSelected;
		vm.isSelected =  vm.selection.isSelected;
		vm.search = search;
		vm.toggleSelectRole = vm.selection.toggleSelectedEntity;
		vm.toggleSelectedRoles = toggleSelectedRoles;
		vm.toggleSidenav = $scope.$parent.vm.toggleSidenav;
        vm.getTypeName = RoleService.getTypeName;
        //*******************************************

		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

        ////////////////////////////////////////////////////////////////////////

		function onStateChangeSuccess() {

			if ($state.params.page && $state.params.page !== vm.currentPage) {
				vm.currentPage = $state.params.page;
			}

		}

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
            RoleService
                .reload()
                .finally(function() {
                    vm.isLoading = false;
                    filterRoles();
                });
		}

		function openItem(roleId) {
			$state.go('app.roles.detail', {
				roleId: roleId,
				page: vm.currentPage}, {inherit: false});
		}


		function search() {
			$state.go('app.roles', {
				term: vm.searchText});
            filterRoles();
		}


        function deleteSelection() {

			var promise;
			if(vm.getSelected().length > 1) {
				promise = nuitUtils.showDeleteMultiConfirm();
			} else if(vm.getSelected().length === 1) {
				promise = nuitUtils.showDeleteConfirmation();
			} else {
				return;
			}

			promise.then(function() {
				var promises = [];
				angular.forEach(vm.getSelected(), function(role, key) {
					var deletePromise = RoleService
						.deleteRole(role)
						.then(function(role) {
							filterRoles();
						});
					promises.push(deletePromise);
				});
				vm.deselectAll();
				$q
					.all(promises)
					.then(nuitUtils.showSuccessToast)
					.catch(nuitUtils.showErrorToast);
			});
        }

		function toggleSelectedRoles() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

        function filterRole(role) {
            return vm.searchText === undefined || vm.searchText === '' || role.name[imsTranslation.language].toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0;
        }

        function filterRoles() {
            var i;
            vm.filteredEntities.splice(0, vm.filteredEntities.length);
            for(i in vm.roles) {
                if(filterRole(vm.roles[i])) {
                    vm.filteredEntities.push(vm.roles[i]);
                }
            }

			vm.filteredEntities = $filter('orderByNuitTranslated')(vm.filteredEntities, 'name');

            vm.deselectAll();
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.roles')
		.controller('RoleDetailsController', RoleDetailsController);

	/** @ngInject */
	function RoleDetailsController($timeout, $state, $scope, imsTranslation, nuitApi, nuitConfig, nuitUtils,
								   RoleService, DotNotationService, UserService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.translation = imsTranslation;
		vm.config = {};                                 // Contains the nuit config
		vm.roleId = $state.params.roleId;               // ID of current role
		vm.role = null;                                   // Contains current role
		vm.selectedLanguage = imsTranslation.language;  // Contains currently selected language key
		vm.isLoading = true;                            // Indicator if a loading process is running
		vm.types = RoleService.types;
		vm.modules = {};
		vm.defaultRoleConfig = RoleService.defaultRoleConfig;
		vm.moduleGroups = RoleService.moduleGroups;
		vm.newRole = false;
		vm.hasUsers = true;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.toggleSidenav = $scope.$parent.vm.toggleSidenav;
		vm.isAnyEnabled = isAnyEnabled;
		vm.save = save;
		vm.propagateToServer = function () {
			return false;
		};
		vm.getGroups = RoleService.getGroups;
		vm.showModule = showModule;
		vm.getGroupHeader = RoleService.getGroupHeader;
		vm.getGroupIndex = RoleService.getGroupIndex;
		vm.onChange = onChange;
		vm.onCreate = onCreate;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			vm.config = nuitConfig.current;

			if (vm.roleId) {
				RoleService.loadRole(vm.roleId)
					.then(function (role) {
						vm.role = role;
						//vm.role.config = angular.merge(vm.role.config, RoleService.defaultRoleConfig);
						vm.isLoading = false;
						vm.newRole = false;
					});
				UserService.getUsers({roleIds: [vm.roleId]})
					.then(function (users) {
						vm.hasUsers = users.length > 0;
					});
			} else {
				vm.isLoading = false;
				vm.newRole = true;
				vm.role = {
					name: {},
					config: RoleService.defaultRoleConfig
				};
				vm.hasUsers = false;
			}
			reloadEnvConfig();


		}

		function save() {
			if (vm.roleId) {
				RoleService
					.updateRole(vm.role)
					.then(function () {
						nuitUtils.showSuccessToast();
						$state.go('app.roles');
					})
					.catch(nuitUtils.showErrorToast);
			} else {
				RoleService
					.addRole(vm.role)
					.then(function () {
						nuitUtils.showSuccessToast();
						$state.go('app.roles');
					}).catch(nuitUtils.showErrorToast);
			}
		}

		function isAnyEnabled(config) {
			for (var key in config) {
				if (config[key].enabled) {
					return true;
				}
			}
			return false;
		}

		function reloadEnvConfig() {
			nuitApi('config.environment')
				.get()
				.then(function (response) {
					vm.envConfig = response.data;
				});
		}

		function showModule(module) {
			return DotNotationService.get(vm.role.config, module.key + '.value', false) && Object.keys(module.config).length > 1;
		}

		function onChange(module) {
			if (!vm.role.config[module.moduleType][module.moduleName]) {
				DotNotationService.set(vm.role.config, module.key + '.type', 4);
			}
		}

		function onCreate(module){
			DotNotationService.set(vm.role.config, module.key, {value: false, type: 4});
			vm.itemForm.$setDirty();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.factory('XeroService', XeroService);

	/** @ngInject */
	function XeroService(AppService, $filter, $q, $http, nuitAuth, nuitApi, nuitUtils, nuitDataService, CompanyService, ProductService) {
		var _appInstances = {};

		var service = initService();

		return service;

		function initService()
		{
			return{
				get: get
			};
		}

		/**
		 *
		 * @param id to return distinct selector instances
		 * @param deselectPreviouslySelected, clears previous selected entities if TRUE
		 * @returns {listSelectorInstance}
		 */
		function get(id)
		{
			if(!_appInstances[id])
			{
				_appInstances[id] = initInstance(id);
			}

			return _appInstances[id];
		}

		function initInstance(appId) {

			//*******************************************
			// VARIABLES
			//*******************************************
			var _customerTypes = [];
			var _itemCategories = [];
			var _customers = [];
			var _items = [];
			var _companies = [];
			var _products = [];
			var _config = {};
			var _data = {};
			var _connections = [];
			var _isConnected = false;
			var _isLoading = false;
			var _app = {};
			//*******************************************

			//*******************************************
			/// SERVICE
			//*******************************************
			var service = {
				reload: reload,
				needsConnection: needsConnection,
				connect: connect,
				disconnect: disconnect,
				patchConfig: patchConfig,
				getCompanies: getCompanies,
				linkCompany: linkCompany,
				unlinkCompany: unlinkCompany,
				importCustomers: importCustomers,
				getProducts: getProducts,
				getItems: getItems,
				linkProduct: linkProduct,
				unlinkProduct: unlinkProduct,
				importItems: importItems,
				invoiceExport: invoiceExport
			};

			//*******************************************
			/// PROPERTIES
			//*******************************************
			Object.defineProperty(service, 'customerTypes', {
				get: function () {
					return _customerTypes;
				}
			});
			Object.defineProperty(service, 'itemCategories', {
				get: function () {
					return _itemCategories;
				}
			});
			Object.defineProperty(service, 'customers', {
				get: function () {
					return _customers;
				}
			});
			Object.defineProperty(service, 'items', {
				get: function () {
					return _items;
				}
			});
			Object.defineProperty(service, 'companies', {
				get: function () {
					return _companies;
				}
			});
			Object.defineProperty(service, 'products', {
				get: function () {
					return _products;
				}
			});
			Object.defineProperty(service, 'isConnected', {
				get: function () {
					return _isConnected;
				}
			});
			Object.defineProperty(service, 'isLoading', {
				get: function () {
					return _isLoading;
				}
			});
			Object.defineProperty(service, 'connections', {
				get: function () {
					return _connections;
				}
			});
			Object.defineProperty(service, 'config', {
				get: function () {
					return _config;
				}
			});
			Object.defineProperty(service, 'data', {
				get: function () {
					return _data;
				}
			});
			Object.defineProperty(service, 'app',{
				get: function(){
					return _app;
				}
			});

			return service;
			//*******************************************

			////////////////////////////////////////////////////////////////////////

			//*******************************************
			// PUBLIC METHODS
			//*******************************************
			function reload() {
				console.error('reloading xero');
				_isLoading = true;
				return isConnected()
					.then(function (isConnected) {
						if (isConnected) {
							return $q.all([getApp(), getConnections(), getCompanies()]).
									then(function(){return getContacts();});
						}
					})
					.finally(function () {
						_isLoading = false;
					});
			}

			function getApp(){
				return AppService.get(appId)
					.then(function(app){
						nuitDataService.replaceOneEntity(_app,app);
						return _app;
					});
			}

			function isConnected() {
				return nuitApi('exchange.apps.xero', appId)
					.get()
					.then(function (response) {
						_isConnected = true;
						nuitDataService.replaceOneEntity(_data, response.data);
						return _isConnected;
					})
					.catch(function (res) {
						console.error('failed');
						if (res.status === 404 || res.status === 500) {
							_isConnected = false;
						}
						return _isConnected;
					});
			}

			function needsConnection() {
				return true;
			}

			function connect($event) {
				$event.stopPropagation();
				var url = nuitApi.getBaseUrl() + 'exchange/apps/' + appId + '/xero/authurl' + '?access-token=' + nuitAuth.getToken();
				console.log(url);
				window.open(url, 'blank');
			}

			function disconnect($event) {
				$event.stopPropagation();
				nuitUtils.showDeleteConfirmation()
					.then(function () {
						return nuitApi('exchange.apps.xero',appId)
							.delete()
							.then(function (res) {
								console.log(res);
								_isConnected = false;
								nuitDataService.replaceOneEntity(_data, {});
								return _isConnected;
							});
					});
			}

			function patchConfig(data) {
				return nuitApi('exchange.apps.xero.config',appId)
					.patch(data)
					.then(function (response) {
						nuitDataService.updateOneEntity(_config, response.data);
						return _config;
					})
					.catch(function (error) {
						throw new Error('Error patching quickbook config');
					});
			}

			function getCompanies() {
				return CompanyService.reload(true, ['active', 'externalId'])
					.then(function (companies) {
						var activeCompanies = companies.filter(
							function (company) {
								return company.active;
							});
						return nuitDataService.replaceAll(_companies, $filter('orderBy')(activeCompanies, 'name'));
					});
			}

			function linkCompany(id, externalId) {
				return nuitApi('companies.one', id).get()
					.then(function (response) {
						var company = response.data;
						company.externalId = externalId;
						return nuitApi('companies.one', id)
							.put(company)
							.then(function (response) {
								var newCompany = response.data;
								var company = nuitDataService.replaceOne(_companies, {
									id: newCompany.id,
									name: newCompany.name,
									externalId: newCompany.externalId
								});

								if (company.externalId) {
									var customer = nuitDataService.getOneByKeys(_customers, {ContactID: company.externalId});
									if (customer) {
										customer.company = company;
										nuitDataService.replaceOneByKeys(_customers, customer, ['externalId']);
										nuitDataService.replaceAll(_customers, angular.copy(_customers));
									}
								}

								return _companies;
							});
					});
			}

			function unlinkCompany(id) {
				var externalId = nuitDataService.getOne(_companies, id).externalId;

				return linkCompany(id, null)
					.then(function () {
						var customer = nuitDataService.getOneByKeys(_customers, {externalId: externalId});
						if (customer) {
							customer.company = null;
							nuitDataService.replaceOneByKeys(_customers, customer, ['externalId']);
						}
						return customer;
					});
			}

			function getItems(categoryIds) {
				return nuitApi('exchange.apps.quickbooks.item',appId)
					.get({categoryid: categoryIds})
					.then(function (response) {
						var mappedItems = [];

						for (var i = 0; i < response.data.length; i++) {
							var item = response.data[i];
							var product = nuitDataService.getOneByKeys(_products, {externalId: item.externalId});

							if (product) {
								item.product = product;
							} else {
								item.product = null;
							}

							mappedItems.push(item);
						}

						nuitDataService.replaceAll(_items, $filter('orderByTranslated')(mappedItems, 'name'));
						return _items;
					})
					.catch(function (error) {
						throw new Error('Error loading items');
					});
			}

			function getProducts() {
				return ProductService.reloadProducts()
					.then(function (products) {
						var activeProducts = products.filter(
							function (product) {
								return product.purchasable;
							});
						var mapped = activeProducts.map(function (product) {
							return {id: product.id, name: product.name, externalId: product.externalId};
						});
						//$filter('orderByNuitTranslate')(products, 'name')
						return nuitDataService.replaceAll(_products, mapped);
					});
			}

			function linkProduct(id, externalId) {
				return nuitApi('products.single', id).get()
					.then(function (response) {
						var product = response.data;
						product.externalId = externalId ? externalId : '';
						return nuitApi('products.single', id)
							.put(product)
							.then(function (response) {
								var newProduct = response.data;
								var product = nuitDataService.replaceOne(_products, {
									id: newProduct.id,
									name: newProduct.name,
									externalId: newProduct.externalId
								});

								if (product.externalId) {
									var item = nuitDataService.getOneByKeys(_items, {externalId: product.externalId});
									if (item) {
										item.product = product;
										nuitDataService.replaceOneByKeys(_products, item, ['externalId']);
										nuitDataService.replaceAll(_items, angular.copy(_items));
									}
								}

								return _products;
								//return nuitDataService.replaceOneByKeys(_items,{id:product.id, name:product.name, externalId:product.externalId},['externalId']);
							});
					});
			}

			function unlinkProduct(id) {
				var externalId = nuitDataService.getOne(_products, id).externalId;

				return linkProduct(id, null)
					.then(function () {
						var item = nuitDataService.getOneByKeys(_items, {externalId: externalId});
						if (item) {
							item.product = null;
							nuitDataService.replaceOneByKeys(_items, item, ['externalId']);
						}
						return item;
					});
			}

			function importCustomers() {
				return nuitApi('exchange.apps.xero.contacts.import',appId)
					.get()
					.then(function (response) {
						return response.data;
					})
					.catch(function (error) {
						throw new Error('Error importing customers');
					});
			}

			function importItems(categoryIds) {
				return nuitApi('exchange.apps.quickbooks.item.import',appId)
					.get({categoryid: categoryIds})
					.then(function (response) {
						return response.data;
					})
					.catch(function (error) {
						throw new Error('Error importing items');
					});
			}

			function getConnections() {
				return nuitApi('exchange.apps.xero.connections',appId)
					.get()
					.then(function (response) {
						nuitDataService.replaceAll(_connections, response.data);
						return _connections;
					})
					.catch(function (error) {
						throw new Error('Error loading xero connections');
					});
			}

			function invoiceExport(orderId) {
				return nuitApi('exchange.apps.xero.export.order',appId)
					.post(undefined, {orderId: orderId})
					.then(function (response) {
						return response.data;
					})
					.catch(function (error) {
						throw new Error('invoice export failed');
					});
			}

			function getContacts() {
				return nuitApi('exchange.apps.xero.contacts',appId)
					.get()
					.then(function (response) {
						var mappedCustomers = [];

						for (var i = 0; i < response.data.length; i++) {
							var customer = response.data[i];
							var company = nuitDataService.getOneByKeys(_companies, {externalId: customer.ContactID});

							if (company) {
								customer.company = company;
							} else {
								customer.company = null;
							}

							mappedCustomers.push(customer);
						}

						nuitDataService.replaceAll(_customers, $filter('orderBy')(mappedCustomers, 'name'));
						return _customers;
					})
					.catch(function (error) {
						throw new Error('Error loading customers');
					});
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.factory('TriggerService', TriggerService);

	/** @ngInject */
	function TriggerService(nuitApi, GenericRequestService) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = GenericRequestService.get(
			'exchange.triggers',
			{
				add: 'exchange.triggers',
				remove: 'exchange.triggers.one'
			},
			true
		);

		service.getTriggerInfo = getTriggerInfo;

		return service;

		function getTriggerInfo(){
			return nuitApi('exchange.triggerinfo')
				.get()
				.then(function(response){
					return response.data;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.factory('SageService', SageService);

	/** @ngInject */
	function SageService($q, nuitApi, nuitDataService, AppService) {
		var _appInstances = {};

		var service = initService();

		return service;

		function initService()
		{
			return{
				get: get
			};
		}

		/**
		 *
		 * @param id to return distinct app instances
		 * @returns {sageAppInstance}
		 */
		function get(id)
		{
			if(!_appInstances[id])
			{
				_appInstances[id] = initInstance(id);
			}

			return _appInstances[id];
		}

		function initInstance(appId) {

			//*******************************************
			// VARIABLES
			//*******************************************
			var _isLoading = false;
			var _app = {};
			//*******************************************

			//*******************************************
			/// SERVICE
			//*******************************************
			var service = {
				reload: reload,
				needsConnection: needsConnection,
				importParts: importParts,
				importClients: importClients
			};

			//*******************************************
			/// PROPERTIES
			//*******************************************
			Object.defineProperty(service, 'isLoading', {
				get: function () {
					return _isLoading;
				}
			});
			Object.defineProperty(service, 'app',{
				get: function(){
					return _app;
				}
			});

			return service;
			//*******************************************

			////////////////////////////////////////////////////////////////////////

			//*******************************************
			// PUBLIC METHODS
			//*******************************************
			function reload() {
				_isLoading = true;
				return getApp()
					.finally(function () {
						_isLoading = false;
					});
			}

			function needsConnection() {
				return false;
			}

			function importParts() {
				return runImport('exchange.apps.sage.parts.import');
			}

			function importClients() {
				return runImport('exchange.apps.sage.clients.import');
			}

			//*******************************************
			// PRIVATE METHODS
			//*******************************************
			function getApp(){
				return AppService.get(appId)
					.then(function(app){
						nuitDataService.replaceOneEntity(_app,app);
						return _app;
					});
			}

			function runImport(route) {
				return nuitApi(route, appId)
					.post()
					.then(function (response) {
						return response.data;
					})
					.catch(function (error) {
						// backend error body is always {"err": "..."}
						return $q.reject(error && error.data && error.data.err ? error.data.err : 'MESSAGE.ERROR');
					});
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.factory('QuickbooksService', QuickbooksService);

	/** @ngInject */
	function QuickbooksService(AppService, $filter, $q, nuitAuth, nuitApi, nuitUtils, nuitDataService, CompanyService, ProductService) {
		var _appInstances = {};

		var service = initService();

		return service;

		function initService()
		{
			return{
				get: get
			};
		}

		/**
		 *
		 * @param id to return distinct selector instances
		 * @param deselectPreviouslySelected, clears previous selected entities if TRUE
		 * @returns {listSelectorInstance}
		 */
		function get(id)
		{
			if(!_appInstances[id])
			{
				_appInstances[id] = initInstance(id);
			}

			return _appInstances[id];
		}

		function initInstance(appId) {

			//*******************************************
			// VARIABLES
			//*******************************************
			var _customerTypes = [];
			var _itemCategories = [];
			var _customers = [];
			var _items = [];
			var _companies = [];
			var _products = [];
			var _config = {};
			var _data = {};
			var _accounts = [];
			var _isConnected = false;
			var _isLoading = false;
			var _app = {};
			//*******************************************

			//*******************************************
			/// SERVICE
			//*******************************************
			var service = {
				reload: reload,
				needsConnection: needsConnection,
				connect: connect,
				disconnect: disconnect,
				getCustomerTypes: getCustomerTypes,
				getItemTypes: getItemCategories,
				getCompanies: getCompanies,
				getCustomers: getCustomers,
				linkCompany: linkCompany,
				unlinkCompany: unlinkCompany,
				importCustomers: importCustomers,
				getProducts: getProducts,
				getItems: getItems,
				linkProduct: linkProduct,
				unlinkProduct: unlinkProduct,
				importItems: importItems,
				itemExport: itemExport,
				patchConfig: patchConfig,
				invoiceExport: invoiceExport
			};

			//*******************************************
			/// PROPERTIES
			//*******************************************
			Object.defineProperty(service, 'customerTypes', {
				get: function () {
					return _customerTypes;
				}
			});
			Object.defineProperty(service, 'itemCategories', {
				get: function () {
					return _itemCategories;
				}
			});
			Object.defineProperty(service, 'customers', {
				get: function () {
					return _customers;
				}
			});
			Object.defineProperty(service, 'items', {
				get: function () {
					return _items;
				}
			});
			Object.defineProperty(service, 'companies', {
				get: function () {
					return _companies;
				}
			});
			Object.defineProperty(service, 'products', {
				get: function () {
					return _products;
				}
			});
			Object.defineProperty(service, 'isConnected', {
				get: function () {
					return _isConnected;
				}
			});
			Object.defineProperty(service, 'isLoading', {
				get: function () {
					return _isLoading;
				}
			});
			Object.defineProperty(service, 'accounts', {
				get: function () {
					return _accounts;
				}
			});
			Object.defineProperty(service, 'config', {
				get: function () {
					return _config;
				}
			});
			Object.defineProperty(service, 'data', {
				get: function () {
					return _data;
				}
			});
			Object.defineProperty(service, 'app',{
				get: function(){
					return _app;
				}
			});

			return service;
			//*******************************************

			////////////////////////////////////////////////////////////////////////

			//*******************************************
			// PUBLIC METHODS
			//*******************************************
			function reload() {
				_isLoading = true;
				return isConnected()
					.then(function (isConnected) {
						if (isConnected) {
							return $q.all([getApp(), getAccounts(), getConfig(), getCustomerTypes(), getItemCategories()]);
						}
					})
					.finally(function () {
						_isLoading = false;
					});
			}

			function getApp(){
				return AppService.get(appId)
					.then(function(app){
						nuitDataService.replaceOneEntity(_app,app);
						return _app;
					});
			}

			function isConnected() {
				return nuitApi('exchange.apps.quickbooks', appId)
					.get()
					.then(function (response) {
						_isConnected = true;
						nuitDataService.replaceOneEntity(_data, response.data);
						return _isConnected;
					})
					.catch(function (res) {
						console.error('failed');
						if (res.status === 404 || res.status === 500) {
							_isConnected = false;
						}
						return _isConnected;
					});
			}

			function needsConnection() {
				return true;
			}

			function connect($event) {
				$event.stopPropagation();
				var url = nuitApi.getBaseUrl() + 'exchange/apps/' + appId + '/quickbooks/authrequest' + '?access-token=' + nuitAuth.getToken();
				console.log(url);
				window.open(url, 'blank');
			}

			function disconnect($event) {
				$event.stopPropagation();
				nuitUtils.showDeleteConfirmation()
					.then(function () {
						return nuitApi('exchange.apps.quickbooks',appId)
							.delete()
							.then(function (res) {
								console.log(res);
								_isConnected = false;
								nuitDataService.replaceOneEntity(_data, {});
								return _isConnected;
							});
					});
			}

			function getCompanies() {
				return CompanyService.reload(true, ['active', 'externalId'])
					.then(function (companies) {
						var activeCompanies = companies.filter(
							function (company) {
								return company.active;
							});
						return nuitDataService.replaceAll(_companies, $filter('orderBy')(activeCompanies, 'name'));
					});
			}

			function linkCompany(id, externalId) {
				return nuitApi('companies.one', id).get()
					.then(function (response) {
						var company = response.data;
						company.externalId = externalId;
						return nuitApi('companies.one', id)
							.put(company)
							.then(function (response) {
								var newCompany = response.data;
								var company = nuitDataService.replaceOne(_companies, {
									id: newCompany.id,
									name: newCompany.name,
									externalId: newCompany.externalId
								});

								if (company.externalId) {
									var customer = nuitDataService.getOneByKeys(_customers, {externalId: company.externalId});
									if (customer) {
										customer.company = company;
										nuitDataService.replaceOneByKeys(_customers, customer, ['externalId']);
										nuitDataService.replaceAll(_customers, angular.copy(_customers));
									}
								}

								return _companies;
							});
					});
			}

			function unlinkCompany(id) {
				var externalId = nuitDataService.getOne(_companies, id).externalId;

				return linkCompany(id, null)
					.then(function () {
						var customer = nuitDataService.getOneByKeys(_customers, {externalId: externalId});
						if (customer) {
							customer.company = null;
							nuitDataService.replaceOneByKeys(_customers, customer, ['externalId']);
						}
						return customer;
					});
			}

			function getCustomerTypes() {
				return nuitApi('exchange.apps.quickbooks.customer.type',appId)
					.get()
					.then(function (response) {
						nuitDataService.replaceAll(_customerTypes, response.data);
						return _customerTypes;
					})
					.catch(function (error) {
						throw new Error('Error loading customerTypes');
					});
			}

			function getItemCategories() {
				return nuitApi('exchange.apps.quickbooks.item.category',appId)
					.get()
					.then(function (response) {
						nuitDataService.replaceAll(_itemCategories, response.data);
						return _itemCategories;
					})
					.catch(function (error) {
						throw new Error('Error loading itemCategories');
					});
			}

			function getCustomers(typeIds) {
				return nuitApi('exchange.apps.quickbooks.customer',appId)
					.get({typeid: typeIds})
					.then(function (response) {
						var mappedCustomers = [];

						for (var i = 0; i < response.data.length; i++) {
							var customer = response.data[i];
							var company = nuitDataService.getOneByKeys(_companies, {externalId: customer.externalId});

							if (company) {
								customer.company = company;
							} else {
								customer.company = null;
							}

							mappedCustomers.push(customer);
						}

						nuitDataService.replaceAll(_customers, $filter('orderBy')(mappedCustomers, 'name'));
						return _customers;
					})
					.catch(function (error) {
						throw new Error('Error loading customers');
					});
			}

			function getItems(categoryIds) {
				return nuitApi('exchange.apps.quickbooks.item',appId)
					.get({categoryid: categoryIds})
					.then(function (response) {
						var mappedItems = [];

						for (var i = 0; i < response.data.length; i++) {
							var item = response.data[i];
							var product = nuitDataService.getOneByKeys(_products, {externalId: item.externalId});

							if (product) {
								item.product = product;
							} else {
								item.product = null;
							}

							mappedItems.push(item);
						}

						nuitDataService.replaceAll(_items, $filter('orderByTranslated')(mappedItems, 'name'));
						return _items;
					})
					.catch(function (error) {
						throw new Error('Error loading items');
					});
			}

			function getProducts() {
				return ProductService.reloadProducts()
					.then(function (products) {
						var activeProducts = products.filter(
							function (product) {
								return product.purchasable;
							});
						var mapped = activeProducts.map(function (product) {
							return {id: product.id, name: product.name, externalId: product.externalId};
						});
						//$filter('orderByNuitTranslate')(products, 'name')
						return nuitDataService.replaceAll(_products, mapped);
					});
			}

			function linkProduct(id, externalId) {
				return nuitApi('products.single', id).get()
					.then(function (response) {
						var product = response.data;
						product.externalId = externalId ? externalId : '';
						return nuitApi('products.single', id)
							.put(product)
							.then(function (response) {
								var newProduct = response.data;
								var product = nuitDataService.replaceOne(_products, {
									id: newProduct.id,
									name: newProduct.name,
									externalId: newProduct.externalId
								});

								if (product.externalId) {
									var item = nuitDataService.getOneByKeys(_items, {externalId: product.externalId});
									if (item) {
										item.product = product;
										nuitDataService.replaceOneByKeys(_products, item, ['externalId']);
										nuitDataService.replaceAll(_items, angular.copy(_items));
									}
								}

								return _products;
								//return nuitDataService.replaceOneByKeys(_items,{id:product.id, name:product.name, externalId:product.externalId},['externalId']);
							});
					});
			}

			function unlinkProduct(id) {
				var externalId = nuitDataService.getOne(_products, id).externalId;

				return linkProduct(id, null)
					.then(function () {
						var item = nuitDataService.getOneByKeys(_items, {externalId: externalId});
						if (item) {
							item.product = null;
							nuitDataService.replaceOneByKeys(_items, item, ['externalId']);
						}
						return item;
					});
			}

			function importCustomers(typeIds) {
				return nuitApi('exchange.apps.quickbooks.customer.import',appId)
					.get({typeid: typeIds})
					.then(function (response) {
						return response.data;
					})
					.catch(function (error) {
						throw new Error('Error importing customers');
					});
			}

			function importItems(categoryIds) {
				return nuitApi('exchange.apps.quickbooks.item.import',appId)
					.get({categoryid: categoryIds})
					.then(function (response) {
						return response.data;
					})
					.catch(function (error) {
						throw new Error('Error importing items');
					});
			}

			function getConfig() {
				return nuitApi('exchange.apps.quickbooks.config',appId)
					.get()
					.then(function (response) {
						nuitDataService.replaceOneEntity(_config, response.data);
						return _config;
					})
					.catch(function (error) {
						throw new Error('Error loading quickbook config');
					});
			}

			function patchConfig(data) {
				return nuitApi('exchange.apps.quickbooks.config',appId)
					.patch(data)
					.then(function (response) {
						nuitDataService.updateOneEntity(_config, response.data);
						return _config;
					})
					.catch(function (error) {
						throw new Error('Error patching quickbook config');
					});
			}

			function getAccounts() {
				return nuitApi('exchange.apps.quickbooks.accounts',appId)
					.get()
					.then(function (response) {
						nuitDataService.replaceAll(_accounts, response.data);
						return _accounts;
					})
					.catch(function (error) {
						throw new Error('Error loading quickbook accounts');
					});
			}

			function itemExport(accountRef) {
				return nuitApi('exchange.apps.quickbooks.config', appId)
					.patch({incomeAccountRef: accountRef})
					.then(function () {
						return getConfig();
					})
					.catch(function (error) {
						throw new Error('Item export failed');
					});
			}

			function invoiceExport(orderId) {
				return nuitApi('exchange.apps.quickbooks.invoice.export',appId)
					.get({orderid: orderId})
					.then(function (response) {
						return response.data;
					})
					.catch(function (error) {
						throw new Error('invoice export failed');
					});
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.factory('NodeRedService', NodeRedService);

	/** @ngInject */
	function NodeRedService($filter, $q, nuitAuth, nuitApi, nuitUtils, nuitDataService, AppService) {
		var _appInstances = {};

		var service = initService();

		return service;

		function initService()
		{
			return{
				get: get
			};
		}

		/**
		 *
		 * @param id to return distinct selector instances
		 * @param deselectPreviouslySelected, clears previous selected entities if TRUE
		 * @returns {listSelectorInstance}
		 */
		function get(id)
		{
			if(!_appInstances[id])
			{
				_appInstances[id] = initInstance(id);
			}

			return _appInstances[id];
		}

		function initInstance(appId) {

			//*******************************************
			// VARIABLES
			//*******************************************
			var _flows = [];
			var _globalFlows = [];
			var _isLoading = false;
			var _app = {};
			//*******************************************

			//*******************************************
			/// SERVICE
			//*******************************************
			var service = {
				reload: reload,
				getFlows: getFlows,
				getGlobalFlows: getGlobalFlows,
				needsConnection: needsConnection,
				remove: remove,
				add: add,
				execute: execute,
				addGlobal: addGlobal
			};

			//*******************************************
			/// PROPERTIES
			//*******************************************
			Object.defineProperty(service, 'flows', {
				get: function () {
					return _flows;
				}
			});

			Object.defineProperty(service, 'globalFlows', {
				get: function () {
					return _globalFlows;
				}
			});

			Object.defineProperty(service, 'isLoading', {
				get: function () {
					return _isLoading;
				}
			});
			Object.defineProperty(service, 'app',{
				get: function(){
					return _app;
				}
			});

			return service;
			//*******************************************

			////////////////////////////////////////////////////////////////////////

			//*******************************************
			// PUBLIC METHODS
			//*******************************************
			function reload() {
				_isLoading = true;
				return $q.all([getApp(),getFlows(), getGlobalFlows()])
					.finally(function () {
						_isLoading = false;
					});
			}

			function needsConnection() {
				return false;
			}

			function getApp(){
				return AppService.get(appId)
					.then(function(app){
						nuitDataService.replaceOneEntity(_app,app);
						return _app;
					});
			}

			function getFlows() {
				return nuitApi('exchange.apps.nodered.flows',appId)
					.get()
					.then(function (response) {
						nuitDataService.replaceAll(_flows, response.data);
						return _flows;
					})
					.catch(function (error) {
						nuitDataService.replaceAll(_flows, []);
						return _flows;
					});
			}

			function getGlobalFlows() {
				return nuitApi('exchange.apps.nodered.flows.global',appId)
					.get()
					.then(function (response) {
						nuitDataService.replaceAll(_globalFlows, response.data);
						return _globalFlows;
					})
					.catch(function (error) {
						nuitDataService.replaceAll(_globalFlows, []);
						return _globalFlows;
					});
			}

			function remove(id){
				return nuitApi('exchange.apps.nodered.flows.one', appId, id)
					.delete()
					.then(function(response){
						nuitDataService.removeOne(_flows, id);
						return response.data;
					})
					.catch(function (error) {
						throw new Error('Error deleting flow');
					});
			}

			function add(flow){
				return nuitApi('exchange.apps.nodered.flows', appId)
					.post(flow)
					.then(function(response){
						nuitDataService.addOne(_flows, response.data);
						return response.data;
					})
					.catch(function (error) {
						throw new Error('Error adding flow');
					});
			}

			function addGlobal(flow){
				console.error(flow);
				return nuitApi('exchange.apps.nodered.flows.one', appId, flow.id)
					.post()
					.then(function(response){
						nuitDataService.addOne(_flows, response.data);
						return response.data;
					})
					.catch(function (error) {
						throw new Error('Error adding global flow');
					});
			}

			function execute(flowId, params) {
				angular.extend(params, { 'access-token': nuitAuth.getToken() });

				return nuitApi('exchange.apps.nodered.flow.execute',appId, flowId)
					.get(params)
					.then(function (response) {
						return response.data;
					})
					.catch(function (error) {
						throw new Error('order export failed');
					});
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.factory('JobViewService', JobViewService);

	/** @ngInject */
	function JobViewService($translate, ExchangeService, nuitDataService) {
		var _job = {};
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			readableCron: readableCron
		};

		Object.defineProperty(service,'job',{
			get: function(){return _job;},
			set: function(value){
				nuitDataService.replaceOneEntity(_job,value);
			}
		});

		return service;

		function readableCron(execution){
			if(!execution) {
				return '';
			}

			try{
				return cronstrue.toString(execution, { locale: $translate.use() });
			}catch(error){
				return '';
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.factory('ExchangeService', ExchangeService);

	/** @ngInject */
	function ExchangeService(nuitApi, nuitDataService, $log, $translate) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _jobs = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			getJobs: getJobs,
			getJobById: getJobById,
			createJob: createJob,
			updateTasks: updateTasks,
			updateJob: updateJob,
			deleteJob: deleteJob,
			deleteTask: deleteTask,
			createTask: createTask,
			updateTask: updateTask,
			runJob: runJob,
			cancelJob: cancelJob,
			getServiceInfo: getServiceInfo,
			getTransferInfo: getTransferInfo,
			getHistory: getHistory
		};

		//*******************************************
		/// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'jobs', {
			get: function () {
				return _jobs;
			}
		});

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		/**
		 * Loads page with materials from remote server
		 * @param page
		 * @return {Promise}
		 */
		function getJobs() {
			return nuitApi('exchange.jobs.all')
				.get()
				.then(function (response) {
					nuitDataService.replaceAll(_jobs, response.data);
					return _jobs;
				})
				.catch(function (error) {
					$log.warn('Error loading job page', error);
					throw new Error('Error loading jobs');
				});
		}

		function getJobById(id) {
			return nuitApi('exchange.job.one', id)
				.get()
				.then(function (response) {
					return response.data;
				});
		}

		function updateJob(job) {
			return nuitApi('exchange.job.one', job.id)
				.put(job);
		}

		function createJob(job) {
			return nuitApi('exchange.jobs.all')
				.post(job);
		}

		function deleteJob(id) {
			return nuitApi('exchange.job.one', id)
				.delete()
				.then(function () {
					nuitDataService.removeOne(_jobs, id);
				});
		}

		function deleteTask(id) {
			return nuitApi('exchange.task.delete', id)
				.delete();
		}

		function createTask(job, task) {
			return nuitApi('exchange.task.create', job.id)
				.post(task)
				.then(function (response) {
					nuitDataService.addOne(job.tasks, response.data);
				});
		}

		function updateTasks(job) {
			var copy = angular.copy(job.tasks);
			for(var i=0;i<copy.length;i++){
				copy[i].histories = [];
			}

			return nuitApi('exchange.task.create', job.id)
				.put(copy)
				.then(function (response) {
					console.log(response.data);
				});
		}

		function updateTask(job, task) {
			return nuitApi('exchange.task.update', task.id)
				.put(task)
				.then(function (response) {
					nuitDataService.updateOne(job.tasks, response.data);
				});
		}

		function runJob(job) {
			var api = job.forceExecution ? 'exchange.job.force' : 'exchange.job.run';

			return nuitApi(api, job.id)
				.post()
				.then(function (response) {
					return response.data;
				});
		}

		function cancelJob(job) {
			return nuitApi('exchange.job.cancel', job.id)
				.post()
				.then(function (response) {
					return response.data;
				});
		}

		function getServiceInfo() {
			return nuitApi('exchange.serviceinfo')
				.get()
				.then(function (response) {
					return response.data;
				});
		}

		function getTransferInfo(){
			return nuitApi('exchange.transferinfo')
				.get()
				.then(function(response){
					return response.data;
				});
		}

		function getHistory(jobId, limit){
			return nuitApi('exchange.job.one.history', jobId)
				.get({limit: limit})
				.then(function(response){
					return response.data;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.service('AppService', AppService);

	/** @ngInject */
	function AppService(nuitApi, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _apps = [];
		var _appTypes = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			getAppTypes: getAppTypes,
			add: add,
			remove: remove,
			get: get,
			getTasks: getTasks
		};

		//*******************************************
		/// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'apps', {
			get: function(){return _apps;}
		});
		Object.defineProperty(service, 'appTypes', {
			get: function(){return _appTypes;}
		});

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		/**
		 * Loads page with materials from remote server
		 * @param page
		 * @return {Promise}
		 */

		//for future implementation: to get all available apps
		function reload() {
			return nuitApi('exchange.apps')
				.get()
				.then(function (response) {
					nuitDataService.replaceAll(_apps, response.data?response.data:[]);
					return _apps;
				})
				.catch(function (error) {
					throw new Error('Error loading apps');
				});
		}

		function add(app){
			return nuitApi('exchange.apps')
				.post(app)
				.then(function(response){
					return response.data;
				})
				.catch(function (error) {
					throw new Error('Error loading apps');
				});
		}

		function remove(id){
			return nuitApi('exchange.apps.one', id)
				.delete()
				.then(function(response){
					nuitDataService.removeOne(_apps, id);
					return response.data;
				})
				.catch(function (error) {
					throw new Error('Error deleting app');
				});
		}

		function getAppTypes(){
			return nuitApi('exchange.apps.types')
				.get()
				.then(function (response) {
					nuitDataService.replaceAll(_appTypes, response.data?response.data:[]);
					return _appTypes;
				})
				.catch(function (error) {
					throw new Error('Error loading apps');
				});
		}

		function get(id) {
			return nuitApi('exchange.apps.one', id)
				.get()
				.then(function (res) {
					nuitDataService.replaceOne(_apps, res.data);
					return res.data;
				})
				.catch( function (res) {
					if(res.status === 404){
						return false;
					}
				});
		}

		function getTasks(id) {
			return nuitApi('exchange.apps.tasks', id)
				.get()
				.then(function (res) {
					return res.data;
				})
				.catch( function (res) {
					return [];
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.factory('ApiService', ApiService);

	/** @ngInject */
	function ApiService(nuitApi, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _apis = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			getApis: getApis,
			createApi: createApi,
			deleteApi: deleteApi
		};

		//*******************************************
		/// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'apis', {
			get: function(){return _apis;}
		});

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		/**
		 * Loads page with materials from remote server
		 * @param page
		 * @return {Promise}
		 */
		function getApis() {
			return nuitApi('exchange.apis')
				.get()
				.then(function (response) {
					nuitDataService.replaceAll(_apis, response.data?response.data:[]);
					return _apis;
				})
				.catch(function (error) {
					throw new Error('Error loading apps');
				});
		}

		function createApi(job){
			return nuitApi('exchange.apis')
				.post(job);
		}

		function deleteApi(id){
			return nuitApi('exchange.api.one', id)
				.delete()
				.then(function(){
					nuitDataService.removeOne(_apis,id);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('XeroDetailsController', XeroDetailsController);

	/** @ngInject */
	function XeroDetailsController($scope, $timeout, $state, $mdDialog, nuitConfig, nuitUtils, nuitDataService, ApiService, XeroService, OrderService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.xeroService = XeroService.get($state.params.appId);
		vm.config = nuitConfig.getCurrent();            // Contains the nuit config
		vm.orderStatus = [];
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		//vm.save = save;
		vm.patchConfig = patchConfig;
		vm.changeConnectionId = changeConnectionId;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init() {
			vm.xeroService.reload();
			if (OrderService.statusLoading) {
				OrderService.statusLoading.then(function(){
					vm.orderStatus = OrderService.orderFilters;
				});
			} else {
				vm.orderStatus = OrderService.orderFilters;
			}
		}

		function changeConnectionId(){
			patchConfig({tenantId: vm.xeroService.data.config.tenantId});
		}

		function patchConfig(data){
			vm.xeroService.patchConfig(data)
				.then(function(){
					nuitUtils.showSuccessToast();
				})
				.catch(function(){
					nuitUtils.showErrorToast();
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('XeroDetailsCustomersController', XeroDetailsCustomersController);

	/** @ngInject */
	function XeroDetailsCustomersController($filter, $scope, $timeout, $state, $mdDialog, nuitConfig, nuitUtils, nuitDataService, ApiService, XeroService) {
		var vm = this;

		vm.config = nuitConfig.getCurrent();
		vm.selectedCompany = null;
		vm.selectedCustomer = null;
		vm.importingCustomers = false;
		vm.searchTerm = '';

		vm.xeroService = XeroService.get($state.params.appId);
		vm.customers = vm.xeroService.customers;
		vm.companies = vm.xeroService.companies;

		vm.link = link;
		vm.unlink = unlink;
		vm.getCustomerName = getCustomerName;
		vm.selectCompany = selectCompany;
		vm.importCustomers = importCustomers;

		Object.defineProperty(vm,'unLinkedCustomers',{get:function(){
				return vm.xeroService.customers.filter(function(customer){return customer.company===null;});
			}});

		Object.defineProperty(vm,'unLinkedCompanies',{get:function(){
				return vm.xeroService.companies.filter(function(company){return company.externalId===null || company.externalId.length===0;});
		}});

		Object.defineProperty(vm, 'unLinkedCompaniesSearch',{get:function(){
				var all = vm.unLinkedCompanies;
				if(vm.searchTerm.length>0) {
					return all.filter(function (company) {
						return company.name.toLowerCase().startsWith(vm.searchTerm.toLowerCase());
					});
				}else{
					return all;
				}
			}});

		Object.defineProperty(vm,'linkedCompanies',{get:function(){
				return vm.xeroService.companies.filter(function(company){return company.externalId!==null && company.externalId.length>0;});
		}});

		Object.defineProperty(vm, 'linkedCompaniesSearch',{get:function(){
				var all = vm.linkedCompanies;
				if(vm.searchTerm.length>0) {
					return all.filter(function (company) {
						return company.name.toLowerCase().startsWith(vm.searchTerm.toLowerCase());
					});
				}else{
					return all;
				}
		}});

		init();

		function init() {
			vm.xeroService.getCompanies()
				.then(function(){
					selectNextUnlinkedCompany();
				});
		}

		function link(){
			if(vm.selectedCompany && vm.selectedCustomer) {
				vm.xeroService.linkCompany(vm.selectedCompany.id, vm.selectedCustomer.ContactID)
					.then(function(){
						selectNextUnlinkedCompany();
					});
				vm.selectedCompany = null;
				vm.selectedCustomer = null;
			}
		}

		function selectNextUnlinkedCompany(){
			if(vm.unLinkedCompanies.length>0){
				selectCompany(vm.unLinkedCompanies[0]);
			}else{
				selectCompany(null);
			}
		}

		function unlink(){
			if(vm.selectedCompany){
				vm.xeroService.unlinkCompany(vm.selectedCompany.id)
					.then(function(){
						vm.selectedCompany = null;
						vm.selectedCustomer = null;
					});
			}
		}

		function getCustomerName(externalId){
			var customer = nuitDataService.getOneByKeys(vm.customers,{ContactID:externalId});
			return customer?customer.Name:'';
		}

		function selectCompany(company){
			if(vm.selectCompany===company){
				return;
			}else {
				vm.selectedCustomer = null;
				vm.selectedCompany = company;
				if (company && (company.externalId === null || company.externalId.length === 0)) {
					var customers = vm.unLinkedCustomers.filter(function (customer) {
						return customer.Name.toLowerCase() === company.name.toLowerCase();
					});
					if (customers.length > 0) {
						vm.selectedCustomer = customers[0];
					} else if (vm.unLinkedCustomers.length > 0) {
						vm.selectedCustomer = vm.unLinkedCustomers[0];
					}
				} else {
					vm.selectedCustomer = null;
				}
			}
		}

		function importCustomers(){
			vm.importingCustomers = true;
			vm.xeroService.importCustomers()
				.catch(nuitUtils.showErrorToast)
				.finally(function(){
					vm.importingCustomers = false;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('SageDetailsController', SageDetailsController);

	/** @ngInject */
	function SageDetailsController($state, nuitUtils, SageService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.sageService = SageService.get($state.params.appId);
		vm.importingParts = false;
		vm.importingClients = false;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.importParts = importParts;
		vm.importClients = importClients;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init() {
			vm.sageService.reload();
		}

		function importParts(){
			vm.importingParts = true;
			vm.sageService.importParts()
				.then(function(){
					nuitUtils.showSuccessToast();
				})
				.catch(nuitUtils.showErrorToast)
				.finally(function(){
					vm.importingParts = false;
				});
		}

		function importClients(){
			vm.importingClients = true;
			vm.sageService.importClients()
				.then(function(){
					nuitUtils.showSuccessToast();
				})
				.catch(nuitUtils.showErrorToast)
				.finally(function(){
					vm.importingClients = false;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('QuickbookDetailsController', QuickbookDetailsController);

	/** @ngInject */
	function QuickbookDetailsController($scope, $timeout, $state, $mdDialog, nuitConfig, nuitUtils, nuitDataService, ApiService, QuickbooksService, OrderService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.qbService = QuickbooksService.get($state.params.appId);
		vm.config = nuitConfig.getCurrent();            // Contains the nuit config
		vm.orderStatus = [];
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		//vm.save = save;
		vm.changeAccountId = changeAccountId;
		vm.patchConfig = patchConfig;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init() {
			vm.qbService.reload();
			if (OrderService.statusLoading) {
				OrderService.statusLoading.then(function(){
					vm.orderStatus = OrderService.orderFilters;
				});
			} else {
				vm.orderStatus = OrderService.orderFilters;
			}
		}

		/*function save() {
			ApiService.createApi(vm.app)
				.then(function () {
					$state.go('app.exchange-apis');
				})
				.catch(nuitUtils.showErrorToast);
		}*/

		function changeAccountId(){
			vm.qbService.itemExport(vm.qbService.config.incomeAccountRef)
				.then(function(){
					nuitUtils.showSuccessToast();
				})
				.catch(function(){
					nuitUtils.showErrorToast();
				});
		}

		function patchConfig(id){
			var data = {};
			data[id] = vm.qbService.config[id];
			vm.qbService.patchConfig(data)
				.then(function(){
					nuitUtils.showSuccessToast();
				})
				.catch(function(){
					nuitUtils.showErrorToast();
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('QuickbookDetailsItemsController', QuickbookDetailsItemsController);

	/** @ngInject */
	function QuickbookDetailsItemsController($filter, $scope, $timeout, $state, $mdDialog, nuitConfig, nuitUtils, nuitDataService, ApiService, QuickbooksService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();
		vm.filteredCategories = [];
		vm.selectedProduct = null;
		vm.selectedItem = null;
		vm.importingItems = false;
		vm.searchTerm = '';

		vm.qbService = QuickbooksService.get($state.params.appId);
		vm.itemCategories = vm.qbService.itemCategories;
		vm.items = vm.qbService.items;
		vm.products = vm.qbService.products;

		vm.link = link;
		vm.unlink = unlink;
		vm.getItemName = getItemName;
		vm.selectProduct = selectProduct;
		vm.importItems = importItems;

		Object.defineProperty(vm,'unLinkedItems',{get:function(){
				return vm.qbService.items.filter(function(item){return item.product===null;});
			}});

		Object.defineProperty(vm,'unLinkedProducts',{get:function(){
				return vm.qbService.products.filter(function(product){return product.externalId===null || product.externalId.length===0;});
			}});

		Object.defineProperty(vm, 'unLinkedProductsSearch',{get:function(){
				var all = vm.unLinkedProducts;
				if(vm.searchTerm.length>0) {
					return all.filter(function (product) {
						var name = $filter('nuitTranslate')(product.name, '');
						return name.toLowerCase().startsWith(vm.searchTerm.toLowerCase());
					});
				}else{
					return all;
				}
			}});

		Object.defineProperty(vm,'linkedProducts',{get:function(){
				return vm.qbService.products.filter(function(product){return product.externalId!==null && product.externalId.length>0;});
			}});

		Object.defineProperty(vm, 'linkedProductsSearch',{get:function(){
				var all = vm.linkedProducts;
				if(vm.searchTerm.length>0) {
					return all.filter(function (product) {
						var name = $filter('nuitTranslate')(product.name, '');
						return name.toLowerCase().startsWith(vm.searchTerm.toLowerCase());
					});
				}else{
					return all;
				}
			}});

		init();

		function init() {
			$scope.$watch('vm.filteredCategories',filterChanged);
			vm.qbService.getProducts()
				.then(function(){
					filterChanged([]);
				});
		}

		function filterChanged(newValue){
			vm.qbService.getItems(newValue);
		}

		function link(){
			if(vm.selectedProduct && vm.selectedItem) {
				vm.qbService.linkProduct(vm.selectedProduct.id, vm.selectedItem.externalId)
					.then(function(){
						selectNextUnlinkedProduct();
					});
				vm.selectedProduct = null;
				vm.selectedItem = null;
			}
		}

		function selectNextUnlinkedProduct(){
			if(vm.unLinkedProducts.length>0){
				selectProduct(vm.unLinkedProducts[0]);
			}else{
				selectProduct(null);
			}
		}

		function selectProduct(product){
			if(vm.selectProduct===product){
				return;
			}else {
				vm.selectedItem = null;
				vm.selectedProduct = product;
				if (product && (product.externalId === null || product.externalId.length === 0)) {
					var items = vm.unLinkedItems.filter(function (item) {
						var name = $filter('nuitTranslate')(product.name, '');
						return item.name.toLowerCase() === name.toLowerCase();
					});
					if (items.length > 0) {
						vm.selectedItem = items[0];
					} else if (vm.unLinkedItems.length > 0) {
						vm.selectedItem = vm.unLinkedItems[0];
					}
				} else {
					vm.selectedItem = null;
				}
			}
		}

		function unlink(){
			if(vm.selectedProduct){
				vm.qbService.unlinkProduct(vm.selectedProduct.id)
					.then(function(){
						vm.selectedProduct = null;
						vm.selectedItem = null;
					});
			}
		}

		function getItemName(externalId){
			var item = nuitDataService.getOneByKeys(vm.items,{externalId:externalId});
			return item?item.name:'';
		}

		function importItems(){
			vm.importingItems = true;
			vm.qbService.importItems(this.filteredCategories)
				.catch(nuitUtils.showErrorToast)
				.finally(function(){
					vm.importingItems = false;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('QuickbookDetailsCustomersController', QuickbookDetailsCustomersController);

	/** @ngInject */
	function QuickbookDetailsCustomersController($filter, $scope, $timeout, $state, $mdDialog, nuitConfig, nuitUtils, nuitDataService, ApiService, QuickbooksService) {
		var vm = this;

		vm.config = nuitConfig.getCurrent();
		vm.filteredTypes = [];
		vm.selectedCompany = null;
		vm.selectedCustomer = null;
		vm.importingCustomers = false;
		vm.searchTerm = '';

		vm.qbService = QuickbooksService.get($state.params.appId);
		vm.customerTypes = vm.qbService.customerTypes;
		vm.customers = vm.qbService.customers;
		vm.companies = vm.qbService.companies;

		vm.link = link;
		vm.unlink = unlink;
		vm.getCustomerName = getCustomerName;
		vm.selectCompany = selectCompany;
		vm.importCustomers = importCustomers;

		Object.defineProperty(vm,'unLinkedCustomers',{get:function(){
				return vm.qbService.customers.filter(function(customer){return customer.company===null;});
			}});

		Object.defineProperty(vm,'unLinkedCompanies',{get:function(){
				return vm.qbService.companies.filter(function(company){return company.externalId===null || company.externalId.length===0;});
		}});

		Object.defineProperty(vm, 'unLinkedCompaniesSearch',{get:function(){
				var all = vm.unLinkedCompanies;
				if(vm.searchTerm.length>0) {
					return all.filter(function (company) {
						return company.name.toLowerCase().startsWith(vm.searchTerm.toLowerCase());
					});
				}else{
					return all;
				}
			}});

		Object.defineProperty(vm,'linkedCompanies',{get:function(){
				return vm.qbService.companies.filter(function(company){return company.externalId!==null && company.externalId.length>0;});
		}});

		Object.defineProperty(vm, 'linkedCompaniesSearch',{get:function(){
				var all = vm.linkedCompanies;
				if(vm.searchTerm.length>0) {
					return all.filter(function (company) {
						return company.name.toLowerCase().startsWith(vm.searchTerm.toLowerCase());
					});
				}else{
					return all;
				}
		}});

		init();

		function init() {
			$scope.$watch('vm.filteredTypes',filterChanged);
			vm.qbService.getCompanies()
				.then(function(){
					filterChanged([])
						.then(function(){
							selectNextUnlinkedCompany();
						});
				});
		}

		function filterChanged(newValue){
			return vm.qbService.getCustomers(newValue);
		}

		function link(){
			if(vm.selectedCompany && vm.selectedCustomer) {
				vm.qbService.linkCompany(vm.selectedCompany.id, vm.selectedCustomer.externalId)
					.then(function(){
						selectNextUnlinkedCompany();
					});
				vm.selectedCompany = null;
				vm.selectedCustomer = null;
			}
		}

		function selectNextUnlinkedCompany(){
			if(vm.unLinkedCompanies.length>0){
				selectCompany(vm.unLinkedCompanies[0]);
			}else{
				selectCompany(null);
			}
		}

		function unlink(){
			if(vm.selectedCompany){
				vm.qbService.unlinkCompany(vm.selectedCompany.id)
					.then(function(){
						vm.selectedCompany = null;
						vm.selectedCustomer = null;
					});
			}
		}

		function getCustomerName(externalId){
			var customer = nuitDataService.getOneByKeys(vm.customers,{externalId:externalId});
			return customer?customer.name:'';
		}

		function selectCompany(company){
			if(vm.selectCompany===company){
				return;
			}else {
				vm.selectedCustomer = null;
				vm.selectedCompany = company;
				if (company && (company.externalId === null || company.externalId.length === 0)) {
					var customers = vm.unLinkedCustomers.filter(function (customer) {
						return customer.name.toLowerCase() === company.name.toLowerCase();
					});
					if (customers.length > 0) {
						vm.selectedCustomer = customers[0];
					} else if (vm.unLinkedCustomers.length > 0) {
						vm.selectedCustomer = vm.unLinkedCustomers[0];
					}
				} else {
					vm.selectedCustomer = null;
				}
			}
		}

		function importCustomers(){
			vm.importingCustomers = true;
			vm.qbService.importCustomers(this.filteredTypes)
				.catch(nuitUtils.showErrorToast)
				.finally(function(){
					vm.importingCustomers = false;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('NodeRedDetailController', NodeRedDetailController);

	/** @ngInject */
	function NodeRedDetailController(ListSelectionService, $scope, $timeout, $state, $mdDialog, nuitConfig, nuitUtils, nuitDataService, ApiService, NodeRedService, OrderService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.currentPage = parseInt($state.params.page) || 0;
		vm.nrService = NodeRedService.get($state.params.appId);
		vm.config = nuitConfig.getCurrent();            // Contains the nuit config
		vm.isLoading = vm.nrService.isLoading;
		vm.currentPageEntities = [];
		vm.filteredEntities = [];
		vm.selection = ListSelectionService.get('exchange.exchange-apps.nodered', true);
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isSelected = vm.selection.isSelected;
		vm.toggleSelected = vm.selection.toggleSelectedEntity;
		vm.toggleSelection = toggleSelection;
		vm.deleteSelected = deleteSelected;
		vm.isIndeterminate = function(entities){
			return vm.selection.isIndeterminate(entities.map(function(entity){return entity.id;}));
		};
		vm.showNewFlowDialog = showNewFlowDialog;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init() {
			reload();
		}

		function reload() {
			vm.nrService.reload()
				.then(function () {
					for (var i = 0; i < vm.nrService.flows.length; i++) {
						filterAll();
					}
				});
		}

		function filterAll() {
			vm.filteredEntities = [];

			for (var i = 0; i < vm.nrService.flows.length; i++) {
				var flow = vm.nrService.flows[i];
				if (filter(flow)) {
					vm.filteredEntities.push(flow);
				}
			}
		}

		function filter(flow) {
			return true;
		}


		function toggleSelection() {
			console.error(vm.currentPageEntities.map(function (entity) {return entity.id;}).length);
			vm.selection.toggleSelectedEntities(vm.currentPageEntities.map(function (entity) {return entity.id;}));
		}

		function deleteSelected() {
			var showConfirmation = vm.selection.getSelected().length === 1 ?
				nuitUtils.showDeleteConfirmation :
				nuitUtils.showDeleteMultiConfirm;

			showConfirmation().then(function () {
				for (var i = 0; i < vm.selection.getSelected().length; i++) {
					vm.nrService.remove(vm.selection.getSelected()[i])
						.then(function () {
							vm.nrService.reload()
								.then(function(){
									vm.selection.deselectAll();
									filterAll();
								});
						});
				}
			});
		}

		function showNewFlowDialog() {
			$mdDialog.show({
				controller: 'NewFlowController',
				controllerAs: 'vm',
				locals: {
					types: vm.appTypes,
					globalFlows: vm.nrService.globalFlows
				},
				templateUrl: 'app/main/system.exchange/dialogs/new-flow/new-flow.html',
				clickOutsideToClose: true
			})
				.then(function (flow) {
					if(flow.id){
						vm.nrService.addGlobal(flow)
							.then(function(){
								reload();
							});
					}else{
						vm.nrService.add(flow)
							.then(function(){
								reload();
							});
					}
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('JobTriggersController', JobTriggersController);

	/** @ngInject */
	function JobTriggersController($state, $mdDialog, nuitUtils, nuitConfig, nuitDataService, TriggerService, JobViewService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();            // Contains the nuit config
		vm.job = JobViewService.job;
		vm.readableCron = JobViewService.readableCron;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.showTriggerDialog = showTriggerDialog;
		vm.removeTrigger = removeTrigger;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Sets all required variables which are needed by the view and loads current material into scope
		 */
		function init() {

		}

		function showTriggerDialog(trigger) {
			$mdDialog.show({
				controller: 'NewTriggerController',
				controllerAs: 'vm',
				locals: {trigger: trigger},
				templateUrl: 'app/main/system.exchange/dialogs/new-trigger/new-trigger.html',
				clickOutsideToClose: true
			})
				.then(function (newTrigger) {
					if(trigger===null){
						addTrigger(newTrigger);
					}else{
						updateTrigger(newTrigger);
					}
				});
		}

		function addTrigger(newTrigger){
			newTrigger.type = newTrigger.type.id;
			TriggerService.add(newTrigger, vm.job.id)
				.then(function(newTrigger){
					nuitDataService.addOne(vm.job.triggers,newTrigger);
				})
				.catch(nuitUtils.showErrorToast);
		}

		function updateTrigger(newExecution){

		}

		function removeTrigger(execution){
			nuitUtils.showDeleteConfirmation()
				.then(function(){
					TriggerService.remove(execution)
						.then(function(){
							nuitDataService.removeOne(vm.job.triggers,execution.id);
						})
						.catch(nuitUtils.showErrorToast);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('JobListController', JobListController);

	/** @ngInject */
	function JobListController($mdDialog, $scope, $state, $timeout, nuitConfig, imsTranslation, nuitUtils, nuitApi, nuitAuth, ListSelectionService, ExchangeService, JobViewService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.currentPage = parseInt($state.params.page) || 0;
		vm.loading = true;
		vm.jobs = [];
		vm.searchText = $state.params.term || '';
		vm.translation = imsTranslation;
		vm.currentPageEntities = [];
		vm.filteredEntities = [];
		vm.selection = ListSelectionService.get('exchange.exchange', true);
		vm.config = nuitConfig.getCurrent();
		vm.polls = [];
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openDetails = openDetails;
		vm.isSelected = vm.selection.isSelected;
		vm.search = search;
		vm.toggleSelected = vm.selection.toggleSelectedEntity;
		vm.toggleSelection = toggleSelection;
		vm.deleteSelected = deleteSelected;
		vm.lastRun = ExchangeService.lastRun;
		vm.runJob = runJob;
		vm.cancelJob = cancelJob;
		vm.canCancelJob = canCancelJob;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			$scope.$on('$destroy', onDestroy);

			ExchangeService.getJobs()
				.then(function (jobs) {
					vm.loading = false;
					vm.jobs = jobs;
					for (var i = 0; i < vm.jobs.length; i++) {
						pollJob(vm.jobs[i]);
					}

					filterAll();
				});


		}

		function onDestroy() {
			for (var i = 0; i < vm.polls.length; i++) {
				$timeout.cancel(vm.polls[i]);
			}
		}

		function pollJob(job) {
			if (canCancelJob(job)) {
				vm.polls.push($timeout(
					function () {
						ExchangeService.getJobById(job.id)
							.then(function (newJob) {
								nuitDataService.replaceOne(ExchangeService.jobs,newJob);
								filterAll();
								pollJob(newJob);
							});
					}, vm.config.ims.exchange.refreshInterval));
			}
		}

		function canCancelJob(job){
			return job.status === 'running' || job.status === 'waiting' || job.status === 'aborting';
		}

		function openDetails(jobId) {
			$state.go('app.exchange.detail', {
				jobId: jobId,
				page: vm.currentPage,
				term: vm.searchText
			}, {inherit: false});
		}

		function search() {
			$state.go('app.exchange', {term: vm.searchText, page: null});
			filterAll();
		}

		function toggleSelection() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

		function deleteSelected() {
			var showConfirmation = vm.selection.getSelected().length === 1 ?
				nuitUtils.showDeleteConfirmation :
				nuitUtils.showDeleteMultiConfirm;

			showConfirmation().then(function () {
				for (var i = 0; i < vm.selection.getSelected().length; i++) {
					ExchangeService.deleteJob(vm.selection.getSelected()[i].id)
						.then(function () {
							vm.selection.deselectAll();
							filterAll();
						});
				}
			});
		}

		function filterAll() {
			vm.filteredEntities = [];

			for (var i = 0; i < vm.jobs.length; i++) {
				var job = vm.jobs[i];
				if (filter(job)) {
					vm.filteredEntities.push(job);
				}
			}
		}

		function filter(job) {
			if (vm.searchText === '') {
				return true;
			} else {
				var keys = ['name'];

				for (var i = 0; i < keys.length; i++) {
					if (job[keys[i]].toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0) {
						return true;
					}
				}

				return false;
			}
		}

		function runJob(job) {
			ExchangeService.runJob(job)
				.then(function (newStatus) {
					job.status = newStatus;
					pollJob(job);
					nuitUtils.showSuccessToast();
				})
				.catch(nuitUtils.showErrorToast);
		}

		function cancelJob(job) {
			ExchangeService.cancelJob(job)
				.then(function (newStatus) {
					job.status = newStatus;
					pollJob(job);
				})
				.catch(nuitUtils.showErrorToast);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('JobDetailsController', JobDetailsController);

	/** @ngInject */
	function JobDetailsController(imsTranslation, $translate, $scope, $timeout, $state, $mdDialog, nuitConfig, nuitUtils, nuitDataService, ExchangeService, DotNotationService, JobViewService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();            // Contains the nuit config
		vm.jobId = $state.params.jobId;               // ID of current user
		vm.isExistingJob = false;
		vm.loading = false;                          // Indicator if a loading process is running
		vm.job = JobViewService.job;                            // Contains current user
		vm.tasksDirty = false;
		vm.selectedLanguage = imsTranslation.language;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.save = save;
		vm.deleteTask = deleteTask;
		vm.showTaskDialog = showTaskDialog;
		vm.down = down;
		vm.up = up;
		vm.showErrorLogDialog = showErrorLogDialog;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Sets all required variables which are needed by the view and loads current material into scope
		 */
		function init() {
			vm.isExistingJob = vm.jobId && vm.jobId > 0;

			if (vm.isExistingJob) {
				vm.loading = true;

				ExchangeService.getJobById(vm.jobId)
					.then(function (job) {
						JobViewService.job = job;
						return ExchangeService.getHistory(job.id, 1000)
							.then(function(history){
								vm.history = history;
							});
					})
					.catch(nuitUtils.showErrorToast)
					.finally(function () {
						vm.loading = false;
					});
			}
		}

		function save() {
			if(vm.form.$valid && vm.form.$dirty) {
				var promise = null;

				if (vm.isExistingJob) {
					promise = ExchangeService.updateJob(vm.job);
				}
				else {
					promise = ExchangeService.createJob(vm.job);
				}

				promise
					.then(function () {
						nuitUtils.showSuccessToast();
						$state.go('app.exchange');
					})
					.catch(function (error) {
						nuitUtils.showErrorToast();
					});
			}

			if (vm.tasksDirty) {
				ExchangeService.updateTasks(vm.job)
					.then(function(response){
						vm.tasksDirty = false;
					})
					.catch(nuitUtils.showErrorToast);
			}
		}

		function deleteTask(id) {
			nuitUtils.showDeleteConfirmation()
				.then(
					function () {
						ExchangeService.deleteTask(id)
							.then(function () {
								nuitDataService.removeOne(vm.job.tasks, id);
							});
					}
				);
		}

		function showTaskDialog(task) {
			$mdDialog.show({
				controller: 'NewTaskController',
				controllerAs: 'vm',
				locals: {job: vm.job, task: task},
				templateUrl: 'app/main/system.exchange/dialogs/new-task/new-task.html',
				clickOutsideToClose: true
			});
		}

		function down(index, $event) {
			$event.stopPropagation();
			insert(index + 1, getTask(index));
		}

		function up(index, $event) {
			$event.stopPropagation();
			insert(index - 1, getTask(index));
		}

		function getTask(index) {
			return vm.job.tasks.splice(index, 1)[0];
		}

		function insert(index, task) {
			vm.tasksDirty = true;
			vm.job.tasks.splice(index, 0, task);
			vm.form.$setDirty();
		}

		function showErrorLogDialog(jobId, historyId) {
			$mdDialog.show({
				controller: 'ErrorLogController',
				controllerAs: 'vm',
				locals: {JOB_ID: jobId, HISTORY_ID: historyId},
				templateUrl: 'app/main/system.exchange/dialogs/error-log/error-log.html',
				clickOutsideToClose: true
			});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('AppListController', AppListController);

	/** @ngInject */
	function AppListController(nuitDataService, $scope, $state, $timeout, $mdDialog, nuitConfig, imsTranslation, nuitUtils, ListSelectionService, AppService, nuitApi, nuitAuth, QuickbooksService, NodeRedService, XeroService, SageService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.currentPage = parseInt($state.params.page) || 0;
		vm.loading = true;
		vm.apps = [];
		vm.appTypes = [];
		vm.searchText = $state.params.term || '';
		vm.translation = imsTranslation;
		vm.currentPageEntities = [];
		vm.filteredEntities = [];
		vm.selection = ListSelectionService.get('exchange.exchange-apps', true);
		vm.config = nuitConfig.getCurrent();
		vm.state = $state;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.showNewAppDialog = showNewAppDialog;
		vm.isSelected = vm.selection.isSelected;
		vm.search = search;
		vm.toggleSelected = vm.selection.toggleSelectedEntity;
		vm.toggleSelection = toggleSelection;
		vm.deleteSelected = deleteSelected;
		vm.isIndeterminate = function(entities){
			return vm.selection.isIndeterminate(entities.map(function(entity){return entity.id;}));
		};
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			reloadApps()
				.then(function(){
					AppService.getAppTypes()
						.then(function(types){
							vm.appTypes = [];
							for(var i=0; i<types.length; i++){
								var type = types[i];

								if(getEnabledByType(type) && canAdd(type,vm.apps)){
									vm.appTypes.push(type);
								}
							}
						});
				});
			filterAll();
		}

		function reloadApps() {
			return AppService.reload()
				.then(function (apps) {
					var newApps = [];
					for (var i = 0; i < apps.length; i++) {
						var app = apps[i];
						newApps.push({
							name: app.name,
							type: app.type,
							api: getServiceByType(app.id, app.type),
							details: getDetailsByType(app.type),
							id: app.id
						});
					}

					for (var i = 0; i < newApps.length; i++) {
						var newApp = newApps[i];
						if (newApp.api) {
							newApp.api.reload();
						}
					}

					nuitDataService.replaceAll(vm.apps, newApps);

					filterAll();
					vm.loading = false;
				});
		}

		function getServiceByType(id,type){
			switch(type){
					case 'quickbooks':
						return QuickbooksService.get(id);
					case 'nodered':
						return NodeRedService.get(id);
					case 'xero':
						return XeroService.get(id);
					case 'sage':
						return SageService.get(id);
					default:
						return null;
			}
		}

		function getDetailsByType(type){
			switch(type){
					case 'quickbooks':
						return 'app.exchange-apps.quickbooks';
					case 'nodered':
						return 'app.exchange-apps.nodered';
					case 'xero':
						return 'app.exchange-apps.xero';
					case 'sage':
						return 'app.exchange-apps.sage';
				default:
					return null;
			}
		}

		function getEnabledByType(type){
			switch(type){
				case 'quickbooks':
					return vm.config.ims.exchange.quickbooks.enabled;
				case 'nodered':
					return vm.config.ims.exchange.nodered.enabled;
				case 'xero':
					return vm.config.ims.exchange.xero.enabled;
				case 'sage':
					return vm.config.ims.exchange.sage.enabled;
				default:
					return false;

			}
		}

		function canAdd(type, apps){
			var appsOfType = apps.filter(function(app){return app.type===type;});
			switch(type){
				case 'quickbooks':
				case 'nodered':
				case 'xero':
				case 'sage':
					return appsOfType.length === 0;
				default:
					return true;
			}
		}

		function search() {
			$state.go('app.exchange-apps', {term: vm.searchText, page: null});
			filterAll();
		}

		function filterAll() {
			vm.filteredEntities = [];

			for (var i = 0; i < vm.apps.length; i++) {
				var app = vm.apps[i];
				if (filter(app)) {
					vm.filteredEntities.push(app);
				}
			}
		}

		function filter(app) {
			if (vm.searchText === '') {
				return true;
			} else {
				var keys = ['app'];

				for (var i = 0; i < keys.length; i++) {
					if (app[keys[i]].toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0) {
						return true;
					}
				}

				return false;
			}
		}

		function showNewAppDialog() {
			$mdDialog.show({
				controller: 'NewAppController',
				controllerAs: 'vm',
				locals: {types: vm.appTypes},
				templateUrl: 'app/main/system.exchange/dialogs/new-app/new-app.html',
				clickOutsideToClose: true
			})
				.then(function (app) {
					AppService.add(app)
						.then(function(){
							reloadApps();
						});
				});
		}

		function toggleSelection() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities.map(function (entity) {return entity.id;}));
		}

		function deleteSelected() {
			var showConfirmation = vm.selection.getSelected().length === 1 ?
				nuitUtils.showDeleteConfirmation :
				nuitUtils.showDeleteMultiConfirm;

			showConfirmation().then(function () {
				for (var i = 0; i < vm.selection.getSelected().length; i++) {
					AppService.remove(vm.selection.getSelected()[i])
						.then(function () {
							reloadApps()
								.then(function(){
									vm.selection.deselectAll();
									filterAll();
								});
						});
				}
			});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('ApiListController', ApiListController);

	/** @ngInject */
	function ApiListController($scope, $state, $timeout, nuitConfig, imsTranslation, nuitUtils, ListSelectionService, ApiService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.currentPage = parseInt($state.params.page) || 0;
		vm.loading = true;
		vm.apps = [];
		vm.searchText = $state.params.term || '';
		vm.translation = imsTranslation;
		vm.currentPageEntities = [];
		vm.filteredEntities = [];
		vm.selection = ListSelectionService.get('exchange.exchange-apis', true);
		vm.config = nuitConfig.getCurrent();
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.isSelected = vm.selection.isSelected;
		vm.search = search;
		vm.toggleSelected = vm.selection.toggleSelectedEntity;
		vm.toggleSelection = toggleSelection;
		vm.deleteSelected = deleteSelected;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			ApiService.getApis()
				.then(function (apps) {
					vm.loading = false;
					vm.apps = apps;
					filterAll();
				});
		}

		function search() {
			$state.go('app.exchange-apis', {term: vm.searchText, page: null});
			filterAll();
		}

		function toggleSelection() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

		function deleteSelected() {
			var showConfirmation = vm.selection.getSelected().length === 1 ?
				nuitUtils.showDeleteConfirmation :
				nuitUtils.showDeleteMultiConfirm;

			showConfirmation().then(function () {
				for (var i = 0; i < vm.selection.getSelected().length; i++) {
					ApiService.deleteApi(vm.selection.getSelected()[i].id)
						.then(function () {
							vm.selection.deselectAll();
							filterAll();
						});
				}
			});
		}

		function filterAll() {
			vm.filteredEntities = [];

			for (var i = 0; i < vm.apps.length; i++) {
				var app = vm.apps[i];
				if (filter(app)) {
					vm.filteredEntities.push(app);
				}
			}
		}

		function filter(app) {
			if (vm.searchText === '') {
				return true;
			} else {
				var keys = ['app'];

				for (var i = 0; i < keys.length; i++) {
					if (app[keys[i]].toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0) {
						return true;
					}
				}

				return false;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.controller('ApiDetailsController', ApiDetailsController);

	/** @ngInject */
	function ApiDetailsController($scope, $timeout, $state, $mdDialog, nuitConfig, nuitUtils, nuitDataService, ApiService, DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();            // Contains the nuit config
		vm.app = {};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.save = save;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init() {
		}

		function save() {
			ApiService.createApi(vm.app)
				.then(function () {
					$state.go('app.exchange-apis');
				})
				.catch(nuitUtils.showErrorToast);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue')
		.service('ProductionQueueService', ProductionQueueService);

	/** @ngInject */
	function ProductionQueueService(nuitApiProxy, OrderService, $q) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _queues = [];
		//*******************************************

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			createProductionOrder: createProductionOrder,
			getEstimation: getEstimation
		};
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function createProductionOrder(order) {
			var shopOrderStatus = OrderService.getStatusByMappedProdStatus(0);

			if (!shopOrderStatus) {
				var deferred = $q.defer();
				deferred.reject({data: {code: 'NO_STATUS'}});
				return deferred.promise;
			} else {
				return nuitApiProxy('queue.order')
					.post({
						name: order.name,
						status: 0,
						completionDate: order.completionDate,
						productionDate: order.productionDate,
						boardId: order.boardId,
						orderIds: order.orders,
						shopOrderStatus: shopOrderStatus,
						estimatedTime: order.hours * 3600 + order.minutes * 60
					})
					.then(function (response) {
						OrderService.updateLocalOrderStatus(order.orders, shopOrderStatus);
						return response.data;
					});
			}
		}

		function getEstimation(orderIds) {
			return nuitApiProxy('queue.estimation')
				.get({orderIds: orderIds.join(',')})
				.then(function (response) {
					return response.data.estimatedTime;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue')
		.service('MaterialInfoService', MaterialInfoService);

	/** @ngInject */
	function MaterialInfoService(nuitApi, OrderService, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _materials = {};
		var _usedMaterials = [];
		//*******************************************

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			update: update
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'materials', {
			get: function () {
				return _materials;
			}
		});
		Object.defineProperty(service, 'usedMaterials', {
			get: function () {
				return _usedMaterials;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function update() {
			nuitDataService.replaceAll(_usedMaterials,[]);
			nuitDataService.replaceOneEntity(_materials,{});

			var firstNormalStatus = 0;

			for(var i=0;i<OrderService.queueFilters.length;i++){
				if(OrderService.queueFilters[i].transitionTo && OrderService.queueFilters[i].transitionTo.length>0){
					firstNormalStatus = i;
					break;
				}
			}

			OrderService.orders.forEach(function (order) {
				if ((!_materials[order.id] || _materials[order.id].length===0) && order.status === OrderService.queueFilters[firstNormalStatus].id) {
					_materials[order.id] = [];

					var profileIds = order.profiles.map(function (profile) {
						return profile.positions[0].id;
					});

					angular.forEach(order.products,function(product){
						if(product.type==='profile') {
							if (product.positions && product.positions.length > 0 && product.positions[0].profileId) {
								profileIds.push(product.positions[0].profileId);
							} else {
								console.error('order', order.id, 'has product', product, 'with no positions');
							}
						}
					});

					if (profileIds.length > 0) {
						nuitApi('queue.materials').get({ids: profileIds.join(',')})
							.then(function (response) {
								if(response.data) {
									response.data.forEach(function (material) {
										if (material.id !== 0 && nuitDataService.getOne(_usedMaterials, material.id) === null) {
											_usedMaterials.push(material);
										}
										if (_materials[order.id].filter(function (innerMaterial) {
											return material.id === innerMaterial.id;
										}).length === 0) {
											_materials[order.id].push(material);
										}
									});
								}
							});
					}

					/*angular.forEach(order.products,function(product){
						if(
							product.type==='profile' &&
							_materials[order.id].filter(function (innerMaterial) {return product.data.profile.material.id === innerMaterial.id;}).length === 0)
						{
							_materials[order.id].push(product.data.profile.material);
						}
					});*/

					//***OFFLINE VERSION***
					/*order.profiles.forEach(function (profile) {
						if (_materials[order.id].filter(function (material) {
								return material.id === profile.material.id;
							}).length === 0) {
							_materials[order.id].push(profile.material);
						}
					});*/
					//*********************
				}
				else {
					delete _materials[order.id];
				}
			});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue')
		.service('EasyProductionService', EasyProductionService);

	/** @ngInject */
	function EasyProductionService(nuitApi, OrderService, $q, $filter, $mdDialog, ShopOrderDetailsService, ProductionQueueService, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _queues = [];
		//*******************************************

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			createOrder: createOrder,
		};
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function createOrder(){
			return OrderService.createOrder(
				{
					details: {
						orderProjectName: '-',
						//completionDate: new Date().getTime() / 1000
					},
					status: this.statusFilter
				}
			)
				.then(function(order){
					return OrderService.moveToNextStatus(order);
				})
				.then(function(order){
					var config = ShopOrderDetailsService.getDefaultDialogConfig();
					config.positions = false;
					config.details.editButton = true;

					return ShopOrderDetailsService.editOrDeleteById(order.id, config)
						.then(function(order){
							if (!angular.isNumber(order.details.completionDate)) {
								order.details.completionDate = parseInt(order.details.completionDate.getTime() / 1000);
							}
							return ProductionQueueService.createProductionOrder({name:((order.details.orderProjectName && order.details.orderProjectName!=='-' && order.details.orderProjectName.length>0)?order.details.orderProjectName:undefined),completionDate:order.details.completionDate, orders: [order.id], hours: 0, minutes: 0});
						});
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue')
		.controller('ProductionQueueListController', ProductionQueueListController);

	/** @ngInject */
	function ProductionQueueListController(
											$rootScope,
											$state,
										   $mdDialog,
										   $filter,
										   $scope,
										   nuitConfig,
										   nuitFilterService,
										   imsTranslation,
										   OrderService,
										   ProductionQueueService,
										   nuitUtils,
										   nuitDataService,
										   ListSelectionService,
										   ShopOrderDetailsService,
										   FilterCountService,
										   MaterialInfoService,
										   ConditionCheckService,
										   OrderViewService,
										   DeliveryService,
										   FormatterService,
										   DateSearchService,
											OrderQueryService,
											imsUtils,
											imsNextChannel,
											ProjectService,
											QUEUE_PROJECT_NAMES_ENABLED
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		OrderViewService.setApi('OrderService');
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.currentPage = 0;
		vm.currentPageEntities = [];
		vm.searchText = '';
		vm.config = nuitConfig.current;
		vm.translation = imsTranslation;
		vm.orders = OrderService.orders;
		vm.OrderService = OrderService;
		vm.statusFilter = '1';
		vm.loading = true;
		vm.selection = ListSelectionService.get('production.queue', true);
		vm.filterCount = FilterCountService.get('production.queue', true);
		vm.materialInfos = MaterialInfoService.materials;
		vm.usedMaterialInfos = MaterialInfoService.usedMaterials;
		vm.todayDay = new Date();
		vm.today = Date.parse(vm.todayDay) / 1000;
		vm.startStatus = '';
		vm.filters = [];
		vm.filterValues = {};
		vm.prefilteredEntities = [];
		vm.deliveryObjects = [];
		vm.filteredMaterials = [];
		vm.colorFilterEnabled = false;
		//*******************************************

		//*******************************************
		// METHODS (EXPOSURE)
		//*******************************************
		vm.getGroupById = getGroupById;
		vm.createProductionOrder = createProductionOrder;
		vm.getOrderPositions = OrderService.getOrderPositions;
		vm.setStatusFilter = setStatusFilter;
		vm.isSelected = vm.selection.isSelected;
		vm.toggleSelectOrder = vm.selection.toggleSelectedEntity;
		vm.getSelected = vm.selection.getSelected;
		vm.deleteSelected = OrderViewService.deleteSelected;
		vm.toggleSelectedOrders = toggleSelectedOrders;
		vm.isIndeterminate = function(entities){
			return vm.selection.isIndeterminate(entities.map(function(entity){return entity.id;}));
		};
		vm.openOrder = openOrder;
		vm.enableProductionOrderButton = enableProductionOrderButton;
		vm.search = search;
		vm.getFilterCount = vm.filterCount.get;
		vm.isFilterSelected = isFilterSelected;
		vm.filterAll = filterAll;
		vm.filterControls = filterControls;
		vm.enableDelete = enableDelete;
		vm.checkDeliveryObject = checkDeliveryObject;
		vm.getShippingDate = getShippingDate;
		vm.getTitle = OrderQueryService.getTitle;
		vm.getTitleById = OrderQueryService.getTitleById;
		vm.upload = upload;
		vm.showUploadButton = showUploadButton;

		vm.unregisterConfigListener = null;
		var now = new Date().getTime();
		vm.startFilterDate = new Date(now);
		vm.endFilterDate = new Date(now);

		if(nuitConfig.isReady()) {
			setFilterDates();
		}else{
			vm.unregisterConfigListener = $rootScope.$on('config::config.loaded',setFilterDates);
		}
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createOrderDialog(orders) {
			return {
				controller: 'QueueCreateOrderController',
				controllerAs: 'vm',
				templateUrl: 'app/main/production.queue/dialogs/queue.createOrder/queue.createOrder.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Orders: orders
				}
			};
		}

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			if (OrderService.statusLoading) {
				OrderService.statusLoading.then(reload);
			} else {
				reload();
			}
		}

		function reload() {
			// Projects are resolved to projectName in the create-order dialog.
			if (QUEUE_PROJECT_NAMES_ENABLED) {
				ProjectService.reload().catch(angular.noop);
			}

			return OrderService
				.reload({status: OrderService.getStatusQueryParams(OrderService.queueFilters), view:'essential'})
				.then(function () {
					vm.filters = vm.config.ims.queue.filters;
					vm.statusFilter = OrderService.queueFilters[0].id;
					vm.loading = false;
					MaterialInfoService.update();
					filterAll();
					vm.startStatus = vm.statusFilter;
					vm.customFilterControls.refresh();
				})
				.catch(nuitUtils.showErrorToast);
		}

		function setFilterDates(){
			DateSearchService.initDates(
				vm.config.ims.queue.list.dateFilter.startOffset,
				vm.config.ims.queue.list.dateFilter.endOffset
			);

			vm.startFilterDate = DateSearchService.startDate;
			vm.endFilterDate = DateSearchService.endDate;

			if (vm.unregisterConfigListener !== null) {
				vm.unregisterConfigListener();
			}
		}

		function onStateChangeSuccess() {
			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}
			if($state.params.startFilterDate && $state.params.endFilterDate){
				vm.startFilterDate = new Date(parseInt($state.params.startFilterDate));
				vm.endFilterDate = new Date(parseInt($state.params.endFilterDate));
				DateSearchService.setDates(vm.startFilterDate,vm.endFilterDate);
				DateSearchService.enabled = true;
			}
			vm.selection.deselectAll();
			filterAll();
		}

		function createProductionOrder() {
			var orders = [];

			for(var i=0;i<vm.getSelected().length;i++){
				orders.push(nuitDataService.getOne(vm.orders,vm.getSelected()[i]));
			}

			$mdDialog.show(createOrderDialog(orders))
				.then(
					function () {
						vm.selection.deselectAll();
						filterAll();
					}
				)
				.catch(angular.noop);
		}

		/**
		 * Toggles the selected orders.
		 */
		function toggleSelectedOrders() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities.map(function (order) {return order.id;}));
		}

		function setStatusFilter(value) {
			if (vm.statusFilter === value.toString()) {
				return;
			}
			vm.statusFilter = value.toString();
			vm.selection.deselectAll();
			vm.filterValues = {};
			filterAll();
			$state.go('.', {status: value >= 0 ? vm.statusFilter : undefined});
		}

		function search() {
			$state.go('.', {term: vm.searchText});
		}

		function filterAll() {
			vm.filterCount.resetAll();
			vm.prefilteredEntities = [];
			vm.filteredEntities = [];

			for (var i = 0; i < vm.orders.length; i++) {
				var order = vm.orders[i];
				if (filter(order)) {
					vm.prefilteredEntities.push(order);

					if (nuitFilterService.matches(vm.config.ims.queue.filters, vm.filterValues, order)) {
						vm.filteredEntities.push(order);
					}
				}
				vm.filterCount.increment(order.status);
			}

			vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, vm.config.ims.queue.list.orderBy, true);
		}


		function filter(order) {
			return (
				vm.statusFilter < 0 ||
				(order.status === vm.statusFilter && isQueueStatus(vm.statusFilter))
				) &&
				hasFilteredMaterial(order) &&
				dateInBetween(order) &&
				isQueueStatus(order.status) &&
				matchesSearchTerm(order);
		}

		function matchesSearchTerm(order) {
			return vm.searchText === '' || FormatterService.matches(vm.config.ims.orders.nameFormat, order, vm.searchText);
		}

		function isFilterSelected(status) {
			return vm.statusFilter === status.toString();
		}

		function isQueueStatus(id) {
			if(vm.config.ims.orders.list.status.prepend.indexOf(id)!==-1){
				return true;
			}

			id = parseInt(id, 10);
			if (id < 0) {
				return false;
			}

			var nextStatus = OrderService.getNextStatus(id);
			var previousStatus = id === 0 ? null : OrderService.getPreviousStatus(String(id));

			return OrderService.getStatusById(id).type === 'production' ||
				(nextStatus !== null && nextStatus.type === 'production') ||
				(previousStatus !== null && previousStatus.type === 'production');
		}

		function dateInBetween(order){
			if(vm.config.ims.queue.list.dateFilter.enabled){
				return DateSearchService.inBetween(order, vm.config.ims.queue.list.dateFilter.filterDate);
			}else{
				return true;
			}
		}

		function hasFilteredMaterial(order){
			var materials = vm.materialInfos.hasOwnProperty(order.id)?vm.materialInfos[order.id]:[];
			if(vm.filteredMaterials.length>0 && vm.colorFilterEnabled){
				for(var i=0;i<materials.length;i++){
					if(vm.filteredMaterials.indexOf(materials[i].id)!==-1){
						return true;
					}
				}

				return false;
			}else{
				return true;
			}
		}


		function getGroupById(id) {
			return ProductionQueueService.getGroupById(id);
		}

		function openOrder(order) {
			if (vm.config.ims.orders.v2.enabled && imsNextChannel.navigateTo('/production/queue/' + order.id)) {
				return;
			}

			var config = ShopOrderDetailsService.getDefaultDialogConfig();

			var editable = true;

			angular.forEach(vm.config.ims.orders.readOnlyStatis, function (status) {
				editable = editable && status.toString() !== order.status;
			});

			editable = editable && !ConditionCheckService.matchesAll(vm.config.ims.orders.readOnlyConditions, order, false);

			var nextStatus = vm.OrderService.getNextStatus(order.status);

			var preProduction = nextStatus && nextStatus.type === 'production';

			if (editable) {
				config.positions = !preProduction; //true means read only
				config.products = !preProduction; //true means read only
			} else {
				config.positions = true; //true means read only
				config.products = true; //true means read only
			}

			config.prices.show = false;

			ShopOrderDetailsService.openById(order.id, config)
				.then(function (order) {
					nuitDataService.updateOne(vm.orders, order);
					filterAll();
				});
		}

		function enableProductionOrderButton() {
			return vm.getSelected().length > 0 && vm.statusFilter !== '-1' &&
				vm.OrderService.getNextStatus(vm.statusFilter).type === 'production';
		}

		function enableDelete() {
			var selected = vm.getSelected();

			if (selected.length > 0) {
				var enabled = true;

				for (var i = 0; i < selected.length; i++) {
					var order = nuitDataService.getOne(vm.orders,selected[i]);

					enabled = enabled && vm.config.ims.queue.list.canDeleteStatis.indexOf(order.status) >= 0;
					enabled = enabled && ConditionCheckService.matchesAll(vm.config.ims.queue.list.canDeleteConditions, order, false);
				}

				return enabled;
			}
			else {
				return false;
			}
		}

		function filterControls(controls) {
			vm.customFilterControls = controls;
		}

		function checkDeliveryObject(order) {
			if (vm.config.ims.transport.enabled) {
				return DeliveryService.loadOne(order.id, true)
					.then(function (delivery) {
						nuitDataService.upsertOne(vm.deliveryObjects,delivery);
						console.log(vm.deliveryObjects);
					})
					.catch(function (e) {
						if(e.status !== 400){
							nuitUtils.showErrorToast();
						}
					});
			}
		}

		function getShippingDate(id){
			var delivery = nuitDataService.getOneByKeys(vm.deliveryObjects, {orderId:id});

			if(delivery && delivery.shippingDate){
				return delivery.shippingDate;
			}else{
				return null;
			}
		}

		function upload(){
			//console.error('upload!!');
			imsUtils.uploadToNodeRedFlow(
				[vm.config.ims.queue.list.upload.appId,vm.config.ims.queue.list.upload.flowId],
				nuitConfig.current.ims.queue.list.upload.acceptedMimeTypes,
				nuitConfig.current.ims.queue.list.upload.maxSize
			);
		}

		function showUploadButton(){
			return 	vm.config.ims.queue.list.upload.enabled &&
					vm.config.ims.queue.list.upload.appId!=='' &&
					vm.config.ims.queue.list.upload.flowId!=='';
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue')
		.controller('ProductionQueueDetailsController', ProductionQueueDetailsController);

	/** @ngInject */
	function ProductionQueueDetailsController($state, $mdToast, nuitConfig, nuitAuth, OrderService, imsColors, imsMaterials, imsTranslation, imsUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();                            // Contains the nuit config
		vm.orderId = $state.params.orderId;               // ID of current material
		vm.loadingItem = true;                          // Indicator if a loading process is running
		vm.currentTab = $state.params.active;
		vm.order = {};                            // Contains current order
		vm.groups = [];
		vm.materials = imsMaterials.materials;
		vm.colors = imsColors.colors;
		vm.currentLanguage = imsTranslation.language;
		vm.editDetails = false;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.addAdditionalLength = addAdditionalLength;
		vm.removeProfilePosition = removeProfilePosition;
		vm.updateOrder = updateOrder;
		vm.getMaterialById = imsMaterials.getMaterialById;
		vm.openEditor = openEditor;
		vm.getDocumentURL = imsUtils.getDocumentURL;
		vm.filterMaterialsForAttribute = filterMaterialsForAttribute;
		vm.filterColorsForAttribute = filterColorsForAttribute;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorUpdatingItemToast() {
			return $mdToast
				.simple()
				.textContent('Error updating cart')
				.position('bottom right')
				.hideDelay(500);
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Sets all required variables which are needed by the view and loads current material into scope
		 */
		function init() {
			// Loads order from the OrderService
			OrderService.loadOrder(vm.orderId)
				.then(function (order) {
					vm.order = order;
					vm.loadingItem = false;
					if (angular.isNumber(vm.order.details.completionDate)) {
						vm.order.details.completionDate = new Date(vm.order.details.completionDate * 1000);
					} else {
						vm.order.details.completionDate = new Date();
					}

					if (isMaterialRequired()) {
						imsMaterials.reload();
					}
					if (isColorRequired()) {
						imsColors.reload();
					}
				})
				.catch(imsUtils.showErrorToast);
		}

		/**
		 * Returns true if a material is required in any attribute.
		 * @returns {Boolean}
		 */
		function isMaterialRequired() {
			if (vm.order.profiles.length > 0) {
				return true;
			}
			for (var j in vm.order.products) {
				for (var i in vm.order.products[j].attributes) {
					if (vm.order.products[j].attributes[i].type === 'material') {
						return true;
					}
				}
			}
			return false;
		}

		/**
		 * Returns true if a material is required in any attribute.
		 * @returns {Boolean}
		 */
		function isColorRequired() {
			for (var j in vm.order.products) {
				for (var i in vm.order.products[j].attributes) {
					if (vm.order.products[j].attributes[i].type === 'color') {
						return true;
					}
				}
			}
			return false;
		}

		function filterMaterialsForAttribute(attribute) {
			var blacklist = !!attribute.restrictions.blacklist;
			return function (material) {
				var matches = attribute.restrictions.materials.indexOf(material.id) >= 0 || attribute.restrictions.groups.indexOf(material.rawMaterialId) >= 0;
				return matches !== blacklist;
			};
		}

		function filterColorsForAttribute(attribute) {
			var blacklist = !!attribute.restrictions.blacklist;
			return function (color) {
				var matches = attribute.restrictions.colors.indexOf(color.id) >= 0;
				return matches !== blacklist;
			};
		}

		/**
		 * Adds a position to the given profile.
		 * @param {Object} profile
		 */
		function addAdditionalLength(profile) {
			var position = {
				length: vm.config.defaults.profile.length,
				quantity: 1
			};

			profile.positions.push(position);
		}

		/**
		 * Removes the profile position at the given index.
		 * @param {Object} profile
		 * @param {Number} index
		 */
		function removeProfilePosition(profile, index) {
			profile.positions.slice(index, 1);
		}

		/**
		 * Sends updated material to remote server
		 */
		function updateOrder() {
			var order = angular.copy(vm.order);
			order.details.completionDate = parseInt(order.details.completionDate.getTime() / 1000);
			OrderService
				.updateOrder(order)
				.then(function (response) {
					$state.go('app.orders.detail', {
						orderId: response.id
					});
					vm.orderForm.$setPristine();
				})
				.catch(function () {
					$mdToast.show(createErrorUpdatingItemToast());
				});
		}

		function openEditor(profile) {
			imsUtils.openEditorAndSaveMultipleDefault(profile);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.planning.boards')
		.controller('ProductionPlanningBoardsController', ProductionPlanningBoardsController);

	/** @ngInject */
	function ProductionPlanningBoardsController($scope, $state, $mdDialog, $q, nuitConfig, nuitUtils, ProductionPlanningService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.config = nuitConfig.getCurrent();
		vm.planningBoards = [];
		vm.selectedIndex = parseInt($state.params.index, 10);
		vm.loading = true;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		
		//*******************************************

		//*******************************************
		// METHOD EXPOSURE
		//*******************************************

		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************

		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			ProductionPlanningService.getPlanningBoards()
				.then(function(response) {
					vm.planningBoards = response;

					ProductionPlanningService.update()
						.then(function() {
							vm.loading = false;
						})
						.catch(nuitUtils.showErrorToast);
				})
				.catch(nuitUtils.showErrorToast);;
		}

		////////////////////////////////////////////////////////////////////////
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.planning.boards')
		.controller('ProductionPlanningBoardController', ProductionPlanningBoardController);

	/** @ngInject */
	function ProductionPlanningBoardController($scope, $state, $translate, $q, $mdDialog, $filter, nuitConfig, nuitDataService, nuitUtils, ProductionPlanningService, ProductionOrdersService, dragulaService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.planningBoards = ProductionPlanningService.planningBoards;
		vm.config = nuitConfig.getCurrent();
		vm.planningBoardId = 0;

		vm.planningTitle = '';
		vm.currentWeek = [];
		vm.selectedItems = [];
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		var _events = ProductionPlanningService.planningEvents;
		var _dragDropEvent = {};

		//*******************************************

		//*******************************************
		// METHOD EXPOSURE
		//*******************************************
		vm.onLoad = onLoad;

		vm.previousWeek = previousWeek;
		vm.nextWeek = nextWeek;

		vm.isSelected = isSelected;
		vm.toggleEvent = toggleEvent;
		vm.openEventDetail = openEventDetail;
		vm.flipWidget = flipWidget;

		vm.getEstimatedTime = getEstimatedTime;
		vm.formatEstimatedTime = formatEstimatedTime;

		vm.deleteSelectedItems = deleteSelectedItems;
		vm.showUpdatePlanningBoardDialog = showUpdatePlanningBoardDialog;
		vm.showUpdateProductionDateDialog = showUpdateProductionDateDialog;
		vm.getEstimatedWeekTime = getEstimatedWeekTime;
		//*******************************************


		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('planning-event-bag.drop', onDropPlanningEvent);
		$scope.$on('planning-event-bag.drop-model', OnDropPlanningEventModelSynced);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			// Setup dragula drag and drop container
			dragulaService.options($scope, 'planning-event-bag', {});
		}

		function onLoad(planningBoardId) {
			vm.planningBoardId = planningBoardId;

			initializePlanningWeek();
			setPlanningTimeframe();
		}

		/**
		 * Event raised as soon as an event is dropped in a container
		 * Parse information about the drag & drop event and save to _dragDropEvent
		 * @param element html element which was dragged
		 * @param target html container where the element was droppped
		 * @param source html container from whicht the element was dragged
		 * @param sibling next element in target container (undefined when element was dropped at the end of the container)
		 */
		function onDropPlanningEvent($event, element, target, source, sibling) {
			_dragDropEvent = {};

			// Information about the dragged event
			var sourceId = parseInt(element.attr('id'), 10);
			var sourceDate = source.attr('date');
			var sourceTimestamp = Math.floor(parseInt(source.attr('timestamp'), 10) / 1000);

			// Information about where the event was dropped
			var targetDate = target.attr('date');
			var targetTimestamp = Math.floor(parseInt(target.attr('timestamp'), 10) / 1000);

			var sourceIndex;
			var sourceEvent = getPlanningBoardEvents(sourceDate)
				.find(function (event, index) {
					if (event.id === sourceId) {
						sourceIndex = index;
						return true;
					}

					return false;
				});

			// Sibling is undefined --> event was dropped at the end of the container
			var siblingId = sibling ? parseInt(sibling.attr('id'), 10) : null;
			var targetEvents = getPlanningBoardEvents(targetDate);

			var targetIndex;
			if (siblingId) {
				targetIndex = targetEvents
					.findIndex(function (event) {
						return event.id === siblingId;
					});
			}
			else {
				targetIndex = targetEvents.length;
			}

			_dragDropEvent = {
				sourceEvent: sourceEvent,
				sourceDate: sourceDate,
				sourceTimestamp: sourceTimestamp,
				sourceIndex: sourceIndex,
				targetDate: targetDate,
				targetTimestamp: targetTimestamp,
				targetIndex: targetIndex
			};
		}

		/**
		 * Event raised after onDropPlanningEvent as soon as the model has been synced
		 */
		function OnDropPlanningEventModelSynced() {

			var targetEvents = getPlanningBoardEvents(_dragDropEvent.targetDate);
			rewriteIndex(targetEvents, _dragDropEvent.targetTimestamp);

			if (_dragDropEvent.targetDate !== _dragDropEvent.sourceDate) {
				var sourceEvents = getPlanningBoardEvents(_dragDropEvent.sourceDate);
				rewriteIndex(sourceEvents, _dragDropEvent.sourceTimestamp);
			}

			_dragDropEvent.sourceEvent.productionDate = _dragDropEvent.targetTimestamp;
			_dragDropEvent.sourceEvent.productionDateFormatted = _dragDropEvent.targetDate;

			ProductionPlanningService.updateSlotDate(_dragDropEvent.sourceEvent);
		}

		function rewriteIndex(array, timestamp) {
			if (array.length > 0) {
				var newIndizes = array.map(function (event, index) {
					return {
						id: event.id,
						boardIdx: index + 1,
						productionDate: timestamp * 1000
					};
				});

				ProductionPlanningService.updateOrders(newIndizes);
			}
		}

		function openEventDetail($event, planningBoardEvent) {
			var origin = $state.current.name + '({ index: \'' + $state.params.index + '\'})';
			$state.go('app.production-orders.details', {orderId: planningBoardEvent.id, origin: origin});
		}

		function flipWidget(event){
			if(!event.hasDetails) {
				ProductionPlanningService.getEventDetails(event);
			}
		}

		function isSelected(planningBoardEvent) {
			return vm.selectedItems.indexOf(planningBoardEvent) >= 0;
		}

		function toggleEvent(planningBoardEvent) {
			var index = vm.selectedItems.indexOf(planningBoardEvent);

			if (index >= 0) {
				vm.selectedItems.splice(index, 1);
			}
			else {
				vm.selectedItems.push(planningBoardEvent);
			}
		}

		/**
		 * Calculate and format estimated time for a whole day
		 * @param date Format: DD.MM.YYYY
		 */
		function getEstimatedTime(date) {
			var events = getPlanningBoardEvents(date);
			var estimatedTimeSum = 0;

			for (var index = 0; index < events.length; index++) {
				estimatedTimeSum += events[index].estimatedTime;
			}

			return formatEstimatedTime(estimatedTimeSum);
		}

		function formatEstimatedTime(estimatedTime) {
			var hours = Math.floor(estimatedTime / 3600);
			var minutes = Math.floor((estimatedTime - hours * 3600) / 60);

			if (hours === 0) {
				return minutes + ' ' + $translate.instant('APP.MINUTES');
			}

			return hours + ' ' + $translate.instant('APP.HOURS') + ', ' + minutes + ' ' + $translate.instant('APP.MINUTES');
		}

		function nextWeek() {
			setupWeek(7, 'd');
		}

		function previousWeek() {
			setupWeek(-7, 'd');
		}

		function deleteSelectedItems() {
			var confirmationPromise = vm.selectedItems.length > 1 ?
				nuitUtils.showDeleteMultiConfirm() :
				nuitUtils.showDeleteConfirmation();

			confirmationPromise
				.then(function () {
					var promises = [];

					for (var i = 0; i < vm.selectedItems.length; i++) {
						promises.push(deleteProductionOrder(vm.selectedItems[i]));
					}

					$q.all(promises)
						.then(function () {
							vm.selectedItems = [];

							nuitUtils.showSuccessToast();
						})
						.catch(nuitUtils.showErrorToast);
				});
		}


		function showUpdatePlanningBoardDialog() {
			$mdDialog.show(createUpdatePlanningBoardDialog())
				.then(function (planningBoardId) {
					if (vm.planningBoardId === planningBoardId) {
						return;
					}

					var orders = vm.selectedItems.map(function (event) {
						return {
							id: event.id,
							boardId: planningBoardId
						};
					});

					ProductionPlanningService.updateOrders(orders)
						.then(function () {
							for (var i = 0; i < vm.selectedItems.length; i++) {
								updatePlanningBoard(vm.selectedItems[i], planningBoardId);
							}

							vm.selectedItems = [];
						});
				});
		}

		function showUpdateProductionDateDialog() {
			$mdDialog.show(createUpdateProductionDateDialog())
				.then(function (productionDate) {

					var orders = vm.selectedItems.map(function (event) {
						return {
							id: event.id,
							productionDate: productionDate
						};
					});

					ProductionPlanningService.updateOrders(orders)
						.then(function () {
							for (var i = 0; i < vm.selectedItems.length; i++) {
								updateProductionDate(vm.selectedItems[i], productionDate);
							}

							vm.selectedItems = [];
						});
				});
		}

		////////////////////////////////////////////////////////////////////////

		function createUpdatePlanningBoardDialog() {
			return {
				controller: 'UpdatePlanningBoardDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/production.planning.boards/dialogs/update-planning-board/update-planning-board-dialog.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					planningBoardId: vm.planningBoardId
				}
			};
		}

		function createUpdateProductionDateDialog() {
			return {
				controller: 'UpdateProductionDateDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/production.planning.boards/dialogs/update-production-date/update-production-date-dialog.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
			};
		}

		function deleteProductionOrder(planningBoardEvent) {
			return ProductionOrdersService.remove(planningBoardEvent)
				.then(function () {
					var planningBoardEvents = getPlanningBoardEvents(planningBoardEvent.slotDateFormatted);

					var index = planningBoardEvents.indexOf(planningBoardEvent);
					if (index >= 0) {
						planningBoardEvents.splice(index, 1);
					}
				});
		}

		function updatePlanningBoard(planningBoardEvent, planningBoardId) {
			// todo kalu server call

			var planningBoardEvents = getPlanningBoardEvents(planningBoardEvent.slotDateFormatted);

			var index = planningBoardEvents.indexOf(planningBoardEvent);
			if (index >= 0) {
				if (!_events[planningBoardId][planningBoardEvent.slotDateFormatted]) {
					_events[planningBoardId][planningBoardEvent.slotDateFormatted] = [];
				}

				_events[planningBoardId][planningBoardEvent.slotDateFormatted].push(planningBoardEvent);

				planningBoardEvents.splice(index, 1);
			}
		}

		function updateProductionDate(planningBoardEvent, productionDate) {
			var sourcePlanningBoardEvents = getPlanningBoardEvents(planningBoardEvent.slotDateFormatted);

			var index = sourcePlanningBoardEvents.indexOf(planningBoardEvent);

			if (index >= 0) {
				planningBoardEvent.productionDate = productionDate;
				planningBoardEvent.productionDateFormatted = $filter('nuitDatetime')(new Date(productionDate).getTime()/1000,'date');

				ProductionPlanningService.updateSlotDate(planningBoardEvent);

				var targetPlanningBoardEvents = getPlanningBoardEvents(planningBoardEvent.slotDateFormatted);
				targetPlanningBoardEvents.push(planningBoardEvent);

				sourcePlanningBoardEvents.splice(index, 1);
			}
		}

		function setupWeek(offset, timeFrame) {
			for (var i = 0; i < vm.currentWeek.length; i++) {
				var date = moment(vm.currentWeek[i].timestamp).add(offset, timeFrame);
				var dateFormatted = $filter('nuitDatetime')(date.valueOf()/1000,'date');
				var events = getPlanningBoardEvents(dateFormatted);

				vm.currentWeek[i].timestamp = date.valueOf();
				vm.currentWeek[i].dateFormatted = dateFormatted;
				vm.currentWeek[i].events = events;
				vm.currentWeek[i].estimatedTime = (events);
			}

			setPlanningTimeframe();
		}

		function initializePlanningWeek() {
			var now = moment();
			var currentDayOfWeek = now.day();
			var startDayOfWeek = parseInt(vm.config.ims.planning.boards.startDayOfWeek, 10);
			var workDays = vm.config.ims.planning.boards.workDays;

			var startDate = startDayOfWeek > currentDayOfWeek ?
				now.subtract(7 - (startDayOfWeek - currentDayOfWeek), 'd') :
				now.subtract(currentDayOfWeek - startDayOfWeek, 'd');

			for (var i = 0; i < 7; i++) {
				var date = moment(startDate).add(i, 'd');

				if (workDays.indexOf(date.day()) !== -1) {
					var dayTranslation = 'APP.' + date.format('dddd').toUpperCase();
					var dateFormatted = $filter('nuitDatetime')(date.valueOf()/1000,'date');
					var events = getPlanningBoardEvents(dateFormatted);

					if(vm.config.ims.planning.boards.overview.material) {
						for (var j = 0; j < events.length; j++) {
							var event = events[j];
							if (!event.hasDetails) {
								ProductionPlanningService.getEventDetails(event);
							}
						}
					}

					vm.currentWeek.push({
						translationKey: dayTranslation,
						timestamp: date.valueOf(),
						dateFormatted: dateFormatted,
						events: events
					});
				}
			}

			setPlanningTimeframe();
		}

		function getPlanningBoardEvents(date) {
			if (!_events[vm.planningBoardId][date]) {
				_events[vm.planningBoardId][date] = [];
			}

			return _events[vm.planningBoardId][date];
		}

		function setPlanningTimeframe() {
			vm.planningTimeframe = vm.currentWeek[0].dateFormatted + ' - ' + $filter('nuitDatetime')(vm.currentWeek[0].timestamp/1000 + 86400*6,'date');
		}

		function getEstimatedWeekTime(week) {
			var estimatedTimeSum = 0;

			for(var j = 0; j < week.length; j++) {
				if(week[j].events.length > 0) {
					for(var i=0; i < week[j].events.length; i++) {
						estimatedTimeSum += week[j].events[i].estimatedTime;
					}
				}
			}

			return formatEstimatedTime(estimatedTimeSum);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.planning', ['app.production.planning.boards'])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, PRODUCTION_PLANNING_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.planning', {
				url: '/production/planning',
				views: {
					'content@app': {
						templateUrl: 'app/main/production.planning/views/planning.html'
					},
					'body@app.planning': {
						templateUrl: 'app/main/production.planning/views/board-list.html',
						controller: 'ProductionPlanningBoardListController as vm'
					}
                },
				permissions: 'ims.planning.enabled'
            })
            .state('app.planning.compose', {
				url: '/add',
				views: {
					'body@app.planning': {
						templateUrl: 'app/main/production.planning/views/board-details.html',
						controller: 'ProductionPlanningBoardDetailsController as vm'
					}
				},
				permissions: 'ims.planning.enabled'
			})
			.state('app.planning.detail', {
				url: '/:planningBoardId',
				views: {
					'body@app.planning': {
						templateUrl: 'app/main/production.planning/views/board-details.html',
						controller: 'ProductionPlanningBoardDetailsController as vm'
					}
				},
				permissions: 'ims.planning.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************

		msNavigationServiceProvider.saveItem('production.settings.boards', {
			title: 'Boards',
			icon: 'icon-calendar-clock',
			state: 'app.planning',
			translate: 'PLANNING.BOARDS_NAV',
			weight: 40,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.planning.enabled || !nuitConfigProvider.getCurrent().ims.planning.boards.enabled;
			}
		});

        //*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('planning.boards', 'production/boards', { allow: ['get'] , versions: [2]});
		nuitApiProvider.register('planning.boards.one', 'production/boards/:id', { allow: ['get', 'put', 'delete'] , versions: [2]});
		nuitApiProvider.register('planning.boards.create', 'production/boards', { allow: ['post'] , versions: [2]});
		nuitApiProvider.register('planning.orders.update', 'production/orders', { allow: ['put'] , versions: [2]});
        //*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(PRODUCTION_PLANNING_SETTINGS);
        //*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.planning')
		.service('ProductionPlanningService', ProductionPlanningService);

	/** @ngInject */
	function ProductionPlanningService(nuitApiProxy, $log, $q, $timeout, $filter, nuitDataService, ProductionOrdersService, OrderService, nuitConfig) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _planningBoards = [];
		var _planningEvents = [];
		//*******************************************

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			getPlanningBoards: getPlanningBoards,
			getPlanningBoardById: getPlanningBoardById,
			addPlanningBoard: addPlanningBoard,
			updatePlanningBoard: updatePlanningBoard,
			deletePlanningBoard: deletePlanningBoard,
			update: update,
			updateProductionDate: updateProductionDate,
			updateSortOrder: updateSortOrder,
			updateOrders: updateOrders,
			getEventDetails: getEventDetails,
			updateSlotDate: updateSlotDate
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'planningBoards', {
			get: function () {
				return _planningBoards;
			}
		});

		Object.defineProperty(service, 'planningEvents', {
			get: function () {
				return _planningEvents;
			}
		});

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function getPlanningBoards() {
			return nuitApiProxy('planning.boards')
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(_planningBoards, response.data);
				})
				.catch(function (error) {
					$log.warn('Error loading boards', error);
					throw new Error('Error loading boards');
				});
		}

		function getPlanningBoardById(planningBoardId) {
			return nuitApiProxy('planning.boards.one', planningBoardId)
				.get()
				.then(function (response) {
					return response.data;
				})
				.catch(function (error) {
					$log.warn('Error loading board with id ' + planningBoardId, error);
					throw new Error('Error loading board with id' + planningBoardId);
				});
		}

		function addPlanningBoard(planningBoard) {
			return nuitApiProxy('planning.boards.create')
				.post(planningBoard)
				.then(function (response) {
					return nuitDataService.addOne(_planningBoards, response.data);
				})
				.catch(function (error) {
					$log.warn('Error creating board', error);
					throw new Error('Error creating board');
				});
		}

		function updatePlanningBoard(planningBoard) {
			return nuitApiProxy('planning.boards.one', planningBoard.id)
				.put(planningBoard)
				.then(function (response) {
					return nuitDataService.replaceOneEntity(planningBoard, response.data);
				})
				.catch(function (error) {
					$log.warn('Error updating board', error);
					throw new Error('Error updating board');
				});
		}

		function deletePlanningBoard(planningBoard) {
			return nuitApiProxy('planning.boards.one', planningBoard.id)
				.delete()
				.then(function (response) {
					return nuitDataService.removeOne(_planningBoards, planningBoard.id);
				})
				.catch(function (error) {
					$log.warn('Error deleting board', error);
					throw new Error('Error deleting board');
				});
		}

		function update() {
			var events = [];

			return ProductionOrdersService
				.reload({status: ProductionOrdersService.getStatusQueryParams('prepare')})
				.then(function () {
					for (var i = 0; i < ProductionOrdersService.getOrders().length; i++) {
						var productionOrder = ProductionOrdersService.getOrders()[i];
						var event = generateEvent(productionOrder);

						if (productionOrder.completionDate > 0) {
							events.push(event);
						}
					}
					groupByPlanningBoardAndDate(events);
				});
		}

		function getEventDetails(event) {
			ProductionOrdersService.getOrderById(event.id)
				.then(function (responseProdOrder) {
					event.hasDetails = true;
					event.shopOrderCount = responseProdOrder.shopOrderIds.length;

					if (responseProdOrder.materialInfos && responseProdOrder.materialInfos.length > 0) {
						for (var i = 0; i < responseProdOrder.materialInfos.length; i++) {
							event.materialInfos.push(responseProdOrder.materialInfos[i]);
						}
					}

					for (var j = 0; j < responseProdOrder.shopOrderIds.length; j++) {
						OrderService.loadOrder(responseProdOrder.shopOrderIds[j])
							.then(function (response) {
								if (event !== null) {
									event.shopOrders.push(response);
									event.shopOrderDesc = generateShopOrderDesc(event.shopOrders);
								}
							});
					}

					ProductionOrdersService.getStatus(event)
						.then(function (data) {
							event.totalParts = data.totalParts;
						});

				});
		}


		function updateProductionDate(planningEvent) {

		}

		function updateSortOrder(planningEvent) {

		}

		////////////////////////////////////////////////////////////////////////

		function groupByPlanningBoardAndDate(events) {
			_planningEvents.splice(0, _planningEvents.length);

			var index = 0;

			// Create array for each planning board existing
			for (; index < _planningBoards.length; index++) {
				_planningEvents[_planningBoards[index].id] = [];
			}

			index = 0;
			for (; index < events.length; index++) {
				var event = events[index];

				// PlanningBoardId set on event does not exist anymore
				if (typeof _planningEvents[event.planningBoardId] === 'undefined') {
					continue;
				}

				// Create array containing all events of one day and one planning board
				if (typeof _planningEvents[event.planningBoardId][event.slotDateFormatted] === 'undefined') {
					_planningEvents[event.planningBoardId][event.slotDateFormatted] = [];
				}

				_planningEvents[event.planningBoardId][event.slotDateFormatted].push(event);
			}

			for (var i = 0; i < _planningEvents.length; i++) {
				for (var key in _planningEvents[i]) {
					_planningEvents[i][key].sort(function (a, b) {
						if (a.boardIdx > b.boardIdx) {
							return 1;
						} else if (a.boardIdx > b.boardIdx) {
							return -1;
						} else {
							return 0;
						}
					});
				}
			}
		}

		function generateEvent(order) {
			var event = {
				id: order.id,
				shortName: order.shortName,
				planningBoardId: order.boardId,
				title: order.name,
				status: order.status,
				statusGroup: getStatusGroupById(order.status),
				shopOrders: [],
				shopOrderCount: 0,
				shopOrderDesc: '',
				materialInfos: [],
				totalParts: '-',
				estimatedTime: order.estimatedTime,
				productionDate: order.productionDate,
				boardIdx: order.boardIdx
			};

			event.productionDateFormatted = $filter('nuitDatetime')(event.productionDate, 'date');

			var estimatedTimeIcon = event.estimatedTime / 3600;
			event.estimatedTimeIcon = estimatedTimeIcon < 1 ? 33 : (estimatedTimeIcon < 4 ? 66 : 100);

			updateSlotDate(event);

			return event;
		}

		function updateSlotDate(event){
			var now = new Date().getTime()/1000;

			if(event.productionDate<now && event.status<2 && nuitConfig.current.ims.planning.boards.showOldPendingOrdersToday){
				event.slotDate = now;
				event.slotDateFormatted = $filter('nuitDatetime')(event.slotDate, 'date');
			}else{
				event.slotDate = event.productionDate;
				event.slotDateFormatted = event.productionDateFormatted;
			}
		}

		function getStatusGroupById(id) {
			return ProductionOrdersService.getGroupById(id);
		}

		function generateShopOrderDesc(shopOrders) {
			var shopOrderDesc = '';

			if (shopOrders) {
				for (var i = 0; i < shopOrders.length; i++) {
					shopOrderDesc += shopOrders[i].ordered_by.email + ':' + shopOrders[i].details.orderProjectName + '<br>';
				}
			}

			return shopOrderDesc;
		}

		function getEventById(events, id) {
			for (var k = 0; k < events.length; k++) {
				if (id === events[k].id) {
					return events[k];
				}
			}

			return null;
		}

		function updateOrders(orders) {
			var data = orders.map(function (order) {
					return {
						id: order.id,
						boardId: order.boardId,
						productionDate: Math.floor(order.productionDate / 1000),
						completionDate: Math.floor(order.completionDate / 1000),
						estimatedTime: order.estimatedTime,
						boardIdx: order.boardIdx
					};
				}
			);

			return nuitApiProxy('planning.orders.update')
				.put(
					data
				);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.planning')
		.controller('ProductionPlanningBoardListController', ProductionPlanningBoardListController);

	/** @ngInject */
	function ProductionPlanningBoardListController($state, $scope, nuitUtils, imsTranslation, ProductionPlanningService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		
		// TODO: Currently no paging implemented
		vm.allowNextPage = false;
		vm.allowPrevPage = false;

		vm.items = ProductionPlanningService.planningBoards;
		vm.selectedItems = [];
		vm.translation = imsTranslation;
		vm.loadingItems = false;

		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		
		// TODO: Currently no paging implemented
		vm.nextPage = function(){};
		vm.prevPage = function(){};

		vm.selectAll = selectAll;
		vm.deselectAll = deselectAll;
		vm.isSelected = isSelected;

		vm.openItem = openItem;
		vm.toggleSelectItem = toggleSelectItem;
		vm.toggleSelectedItems = toggleSelectedItems;

		vm.deleteSelectedItems = deleteSelectedItems;

		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************

		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);

		/**
		* This event is fired whenever the state (or its params) change, including the initial state change
		*/
		function onStateChangeSuccess() {
			vm.deselectAll();
		}

		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************

		init();

		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			vm.loadingItems = true;

			ProductionPlanningService.getPlanningBoards()
				.then(function (response) {
					vm.deselectAll();
				})
				.finally(function () {
					vm.loadingItems = false;
				});
		}

		function selectAll() {
			vm.deselectAll();

			angular.forEach(vm.items, function(item) {
				vm.selectedItems.push(item);
			});
		}

		function deselectAll() {
			vm.selectedItems = [];
		}

		function isSelected(item) {
			return vm.selectedItems.indexOf(item) >= 0;
		}

		function openItem(item) {
			$state.go('app.planning.detail', { planningBoardId: item.id });
		}

		function toggleSelectItem(item, $event) {
			$event.stopPropagation();

			var index = vm.selectedItems.indexOf(item);

			if (index >= 0) {
				vm.selectedItems.splice(index, 1);
			}
			else {
				vm.selectedItems.push(item);
			}
		}

		function toggleSelectedItems() {
			if (vm.selectedItems.length > 0) {
				vm.deselectAll();
			}
			else {
				vm.selectAll();
			}
		}

		function deleteSelectedItems() {
			var showConfirmation = vm.selectedItems.length === 1 ? 
				nuitUtils.showDeleteConfirmation :
				nuitUtils.showDeleteMultiConfirm;

			showConfirmation().then(function() {
				for (var i = 0; i < vm.selectedItems.length; i++) {
					ProductionPlanningService.deletePlanningBoard(vm.selectedItems[i])
						.then(function (response) {
							deselectAll();
						});
				}
			});
		}
	}
}());

(function () {
    'use strict';  

	angular
		.module('app.production.planning')
        .controller('ProductionPlanningBoardDetailsController', ProductionPlanningBoardDetailsController);
        
    /** @ngInject */
	function ProductionPlanningBoardDetailsController($state, $q, $translate, nuitUtils, nuitConfig, ProductionPlanningService) {
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
        //*******************************************
        
        vm.planningBoardId = parseInt($state.params.planningBoardId, 10);
        vm.loadingItem = false;
        vm.planningBoard = {};
        vm.selectedLanguage = $translate.use();
        vm.config = nuitConfig.getCurrent();
        
        //*******************************************

		//*******************************************
		// METHODS (Exposure)
        //*******************************************
        
        vm.savePlanningBoard = savePlanningBoard;

        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        
        init();
        
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
        //*******************************************
        
        function init() {
            // Load existing board in update mode 
            if (vm.planningBoardId && vm.planningBoardId > 0) {
                vm.loadingItem = true;

                ProductionPlanningService.getPlanningBoardById(vm.planningBoardId)
                    .then(function (response) {
                        vm.planningBoard = response;
                        return response;
                    })
                    .catch(function() {
                        nuitUtils.showErrorToast();
                        $state.go('app.planning');  
                    })
                    .finally(function() {
                        vm.loadingItem = false;
                    });
            }
        }

        function savePlanningBoard() {
            var promise = null;

            if (vm.planningBoardId && vm.planningBoardId > 0) {
                // Update existing planningBoard
                promise = ProductionPlanningService.updatePlanningBoard(vm.planningBoard);
            }
            else {
                // Create new planningBoard
                promise = ProductionPlanningService.addPlanningBoard(vm.planningBoard);
            }

            promise
                .then(function (response) {
                    nuitUtils.showSuccessToast();
                    $state.go('app.planning');
                })
                .catch(function (error) {
                    nuitUtils.showErrorToast();
                });
        }

        //*******************************************
    }
})();

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.service('TeaserService', TeaserService);

	/** @ngInject */
	function TeaserService( ) {

		var _productionProfile = {};

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			getMachine: getMachine,
			hasMachine: hasMachine,
			getData: getData
		};

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function getMachine(machines){
			for(var i=0;i<machines.length;i++){
				if(machines[i].hasOwnProperty('customData') && machines[i].customData.hasOwnProperty('teaser') && machines[i].customData.teaser.hasOwnProperty('enabled') && machines[i].customData.teaser.enabled===true){
					return machines[i];
				}
			}

			return undefined;
		}

		function hasMachine(machines){
			return getMachine(machines)!==undefined;
		}

		function getData(machineType, machines){
			var machine = getMachine(machines);

			if(machine!==undefined){
				return {
					link:machine.customData.teaser.url?machine.customData.teaser.url:'https://cidanmachinery.com/',
					header:'PRODUCTION_ORDERS.'+machineType.toUpperCase(),
					details:'PRODUCTION_ORDERS.' + machineType.toUpperCase() + '.TEASER',
					imageUrl: machine.customData.teaser.image?machine.customData.teaser.image:'https://cidanmachinery.com/wp-content/themes/cidan/img/cidan-logo.png'
				};
			}else{
				return undefined;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.service('SolutionViewService', SolutionViewService);

	/** @ngInject */
	function SolutionViewService($mdDialog) {

		var _productionProfile = {};

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			open: open
		};

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function open(solution, enableUi, limitJobs, readOnly, enableComplain) {
			return $mdDialog.show(createSolutionDialog(solution, enableUi, limitJobs, readOnly, enableComplain));
		}

		function createSolutionDialog(solution, enableUi, limitJobs, readOnly, enableComplain) {
			return {
				controller: 'SolutionController',
				controllerAs: 'vm',
				templateUrl: 'app/main/production.orders/dialogs/solution/solution.html',
				clickOutsideToClose: true,
				locals: {
					Solution: angular.copy(solution),
					EnableUi: enableUi,
					LimitJobs: limitJobs,
					ReadOnly: readOnly,
					EnableComplain: enableComplain
				}
			};
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.service('ProfileService', ProfileService);

	/** @ngInject */
	function ProfileService($q, $http, $window, $timeout, nuitApiProxy, nuitAuth, nuitUtils, nuitDataService, imsMaterials, imsUtils, ProfileServiceHelper, BendingMachineService, CoilMachineService, PunchingMachineService, PollRequestService, nuitProfiles) {
		//*******************************************
		// CONSTANTS
		//*******************************************
		var _currentProfile = 0;
		var _punchingProgramPolls = {};

		var PUNCHING_PROGRAM_STATE = {PENDING: 'pending', AVAILABLE: 'available', ERROR: 'error'};
		// v1: 0 recreating, 1 available, 2 error / v2: 1 created, 2 requested, 3 prepared, 4 error
		var PUNCHING_PROGRAM_STATUS_V1 = {0: PUNCHING_PROGRAM_STATE.PENDING, 1: PUNCHING_PROGRAM_STATE.AVAILABLE, 2: PUNCHING_PROGRAM_STATE.ERROR};
		var PUNCHING_PROGRAM_STATUS_V2 = {1: PUNCHING_PROGRAM_STATE.PENDING, 2: PUNCHING_PROGRAM_STATE.PENDING, 3: PUNCHING_PROGRAM_STATE.AVAILABLE, 4: PUNCHING_PROGRAM_STATE.ERROR};

		// All rules must pass to offer the punching dxf download. Each rule gets a
		// production profile or a geometry (_isGeometry) - add/remove rules here.
		var PUNCHING_DXF_RULES = [
			isEvoV2,
			hasPunchesToExport,
			hasValidBendingMachine,
			hasValidPunchingMachine
		];

		// *******************************************
		// SERVICE
		//*******************************************
		var service = {
			getProducedParts: getProducedParts,
			getCutParts: getCutParts,
			getStampedParts: getStampedParts,
			getBendedParts: getBendedParts,
			getQuantityParts: getQuantityParts,
			getCount: getCount,
			updateManualWorkMachine: updateManualWorkMachine,
			updateOffset: updateOffset,
			getBendingProgramState: getBendingProgramState,
			updateCuttingMachine: updateCuttingMachine,
			batchUpdateCuttingMachines: batchUpdateCuttingMachines,
			updateCuttingMachines: updateCuttingMachines,
			updateBendingMachine: updateBendingMachine,
			batchUpdateBendingMachines: batchUpdateBendingMachines,
			updateBendingMachines: updateBendingMachines,
			updateGeometryAfterBendingMachineChange: updateGeometryAfterBendingMachineChange,
			batchUpdatePunchingMachines: batchUpdatePunchingMachines,
			updatePunchingMachine: updatePunchingMachine,
			updatePunchingMachines: updatePunchingMachines,
			updateGeometryAfterPunchingMachineChange: updateGeometryAfterPunchingMachineChange,
			createPunchingProgram: createPunchingProgram,
			preparePunchingProgram: preparePunchingProgram,
			removePunchingMachines: removePunchingMachines,
			deletePunchingProgram: deletePunchingProgram,
			getPunchingProgramState: getPunchingProgramState,
			isEvoV2: isEvoV2,
			PUNCHING_PROGRAM_STATE: PUNCHING_PROGRAM_STATE,
			canDownloadPunchingDxf: canDownloadPunchingDxf,
			hasPunchingProgramsEnabled: hasPunchingProgramsEnabled,
			downloadPunchingDxf: downloadPunchingDxf,
			getPunchingThicknesses: getPunchingThicknesses,
			onCoilMachineChanged: onCoilMachineChanged,
			updateProfile: updateProfile,
			onBendingMachineChanged: onBendingMachineChanged,
			handleBendingProgram: handleBendingProgram,
			usesManualCoilMachine: usesManualCoilMachine,
			onPunchingMachineChanged: onPunchingMachineChanged,
			clearPunchingStatusPolls: clearPunchingStatusPolls,
			hasPunches: nuitProfiles.hasStamps
		};

		Object.defineProperty(service, 'currentProfile', {
			get: function () {
				return _currentProfile;
			},
			set: function (newValue) {
				_currentProfile = newValue;
			}
		});

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function getProducedParts(profile) {
			return getCount(profile, 'produced');
		}

		function getCutParts(profile) {
			return getCount(profile, 'cut');
		}

		function getStampedParts(profile) {
			return getCount(profile, 'stamped');
		}

		function getBendedParts(profile) {
			return getCount(profile, 'bended');
		}

		function getQuantityParts(profile) {
			return getCount(profile, 'quantity');
		}

		function getCount(profile, key) {
			var result = 0;
			for (var i = 0; i < profile.parts.length; i++) {
				if (profile.parts[i].hasOwnProperty(key)) {
					result = result + profile.parts[i][key];
				}
			}
			return result;
		}

		function updateManualWorkMachine(profile) {
			var machine = nuitDataService.getOne(
				profile.bendingMachineData.afterBendingPosition.positions,
				profile.customData.manualWorkMachine.id
			);

			if (machine === null) {
				return nuitApiProxy('productionprofiles.manualworkmachine', profile.id)
					.delete()
					.then(function (response) {
						nuitDataService.updateOneEntity(profile, response.data);
					});
			}
			else {
				return nuitApiProxy('productionprofiles.manualworkmachine', profile.id)
					.put(machine)
					.then(function (response) {
						nuitDataService.updateOneEntity(profile, response.data);
					});
			}
		}

		function updateOffset(profile) {
			return nuitApiProxy('productionprofiles.offset', profile.id)
				.put({offset: profile.customData.offset})
				.then(function (response) {
					nuitDataService.updateOneEntity(profile, response.data);
				});
		}

		function getBendingProgramState(profile) {
			return profile.bendingProgramStatus;
		}

		function updateCuttingMachine(profile, resetMaterial, attributesToUpdate) {
			if (typeof attributesToUpdate === 'undefined') {
				attributesToUpdate = ['cuttingMachineId', 'cuttingMaterialId', 'cuttingCoilId', 'manualCuts', 'cuttingMaterialWidth'];
			}

			if (typeof resetMaterial !== 'undefined' && resetMaterial === true) {
				profile.cuttingMaterialId = null;
			}

			return nuitApiProxy('productionprofiles.cuttingmachine', profile.id)
				.put(ProfileServiceHelper.generateUpdatedMachineData(profile, attributesToUpdate))
				.then(function (response) {
					nuitDataService.updateOneEntity(profile, response.data);
				});
		}

		function batchUpdateCuttingMachines(ids,machine,material,width,coilId){
			return nuitApiProxy('productionprofiles.cuttingmachines')
				.put(
					{
						productionProfileIds: ids,
						cuttingMachine:
							{
								machineId: machine.id,
								materialId: material?material.id:null,
								materialWidth: width,
								coilId: coilId
							}
					});
		}

		function updateCuttingMachines(geometry, resetMaterial) {
			if (typeof resetMaterial !== 'undefined' && resetMaterial === true) {
				geometry.cuttingMaterialId = null;
				geometry.cuttingCoilId = null;
			}

			return nuitApiProxy('productionprofiles.cuttingmachines')
				.put(
					{
						productionProfileIds: ProfileServiceHelper.getProductionProfileIds(geometry),
						cuttingMachine:
							{
								machineId: geometry.cuttingMachineId,
								materialId: geometry.cuttingMaterialId,
								materialWidth: geometry.cuttingMaterialWidth,
								coilId: geometry.cuttingCoilId
							}
					})
				.then(function(response){
					var newGeometry = response.data[0];
					geometry.cuttingCoilId = newGeometry.cuttingCoilId;
					geometry.cuttingMaterialId = newGeometry.cuttingMaterialId;
					geometry.cuttingMaterialWidth = newGeometry.cuttingMaterialWidth;
				});
		}

		function updateBendingMachine(profile, attributesToUpdate) {
			if (typeof attributesToUpdate === 'undefined') {
				attributesToUpdate = ['bendingMachineId', 'bendingMaterialId', 'manualBends'];
			}

			if(attributesToUpdate.indexOf('manualBends')!==-1 && Number.isInteger(profile.manualBends)){
				profile.manualBends = profile.manualBends===1;
			}

			return nuitApiProxy('productionprofiles.bendingmachine', profile.id)
				.put(ProfileServiceHelper.generateUpdatedMachineData(profile, attributesToUpdate))
				.then(function (response) {
					nuitDataService.updateOneEntity(profile, response.data);
					onBendingMachineChanged(profile);
				});
		}

		function batchUpdateBendingMachines(ids,machine,material, manual){
			return nuitApiProxy('productionprofiles.bendingmachines')
				.put(
					{
						productionProfileIds: ids,
						bendingMachine:
							{
								machineId: machine.id,
								materialId: material?material.bendingMaterialId:null,
								//manualBends: manual
							}
				});
		}

		function updateBendingMachines(geometry, resetMaterial) {
			if (resetMaterial) {
				geometry.bendingMaterialId = null;
			}

			return nuitApiProxy('productionprofiles.bendingmachines')
				.put(
					{
						productionProfileIds: ProfileServiceHelper.getProductionProfileIds(geometry),
						bendingMachine: {machineId: geometry.bendingMachineId, materialId: geometry.bendingMaterialId}
					})
				.then(function(response){
					if(response.data && response.data.length>0){
						updateGeometryAfterBendingMachineChange(geometry, response.data[0]);
					}
					return response;
				});
		}

		function updateGeometryAfterBendingMachineChange(geometry, productionProfile){
			geometry.productionBlank = productionProfile.blank;
			geometry.productionProfile = productionProfile;
			geometry.bendingProgram = productionProfile.bendingProgram;
			geometry.bendingProgramId = productionProfile.bendingProgramId;
			geometry.bendingProgramStatus = productionProfile.bendingProgramStatus;
			geometry.bendingProgramUrl = productionProfile.bendingProgramUrl;
		}

		function updatePunchingMachine(profile, attributesToUpdate) {
			if (typeof attributesToUpdate === 'undefined') {
				attributesToUpdate = ['punchingMachineId', 'punchingMaterialId', 'punchingMaterialThickness','punchingRecreateProgram'];
			}

			return nuitApiProxy('productionprofiles.punchingmachine', profile.id)
				.put(ProfileServiceHelper.generateUpdatedMachineData(profile, attributesToUpdate))
				.then(function (response) {
					delete profile.punchingRecreateProgram;
					nuitDataService.updateOneEntity(profile, response.data);
					onPunchingMachineChanged(profile);
				});
		}

		function batchUpdatePunchingMachines(ids, machine, material, thickness){
			return nuitApiProxy('productionprofiles.punchingmachines')
				.put(
					{
						productionProfileIds: ids,
						punchingMachine: buildPunchingMachineData(machine.id, material ? material.id : null, thickness)
					});
		}

		function updatePunchingMachines(geometry) {
			return nuitApiProxy('productionprofiles.punchingmachines')
				.put(
					{
						productionProfileIds: ProfileServiceHelper.getProductionProfileIds(geometry),
						punchingMachine: buildPunchingMachineData(geometry.punchingMachineId, geometry.punchingMaterialId, geometry.punchingMaterialThickness)
					})
				.then(function(response){
					if(response.data && response.data.length>0){
						updateGeometryAfterPunchingMachineChange(geometry, response.data[0]);
					}
					return response;
				});
		}

		// production-v2 only knows the machine - materials don't exist there
		function buildPunchingMachineData(machineId, materialId, thickness) {
			if (isEvoV2()) {
				return {machineId: machineId};
			}

			return {machineId: machineId, materialId: materialId, materialThickness: thickness};
		}

		function updateGeometryAfterPunchingMachineChange(geometry, productionProfile){
			var attributes = [
				'punchingMachineId','punchingMaterialId','punchingMaterialThickness',
				'punchingProgramError','punchingProgramId','punchingProgramStatus'
			];

			for (var i = 0; i < attributes.length; i++) {
				geometry[attributes[i]] = productionProfile[attributes[i]];

				for (var j = 0; j < geometry.productionProfiles.length; j++) {
					geometry.productionProfiles[j][attributes[i]] = productionProfile[attributes[i]];
				}
			}
		}

		//*******************************************
		// PUNCHING PROGRAM (geometry mode, v2 only - the routes exist in production-v2 only)
		//*******************************************
		// Makes sure every production profile of the geometry has the program of its
		// current flat geometry (find-or-create) and polls while it is prepared.
		function createPunchingProgram(geometry) {
			if (!isEvoV2()) {
				return $q.reject(new Error('punching programs are only implemented for v2'));
			}

			return $q.all(ProfileServiceHelper.getProductionProfileIds(geometry).map(function (id) {
				return nuitApiProxy('productionprofiles.punchingprogram', id).post();
			}))
				.then(function (responses) {
					applyPunchingProgram(geometry, responses[0].data);
					onPunchingMachineChanged(geometry);
				});
		}

		// Retry: re-sends the existing program to preparation. One geometry means one
		// program (find-or-create on the punch hash), so it is prepared once via the
		// first production profile - the status update (NSQ) reaches every profile
		// holding that program. A prepared program needs force=true (409 else).
		function preparePunchingProgram(geometry, force) {
			if (!isEvoV2()) {
				return $q.reject(new Error('punching programs are only implemented for v2'));
			}

			return nuitApiProxy('productionprofiles.punchingprogram.prepare', geometry.productionProfiles[0].id)
				.post(undefined, force ? {force: true} : undefined)
				.then(function (response) {
					applyPunchingProgram(geometry, response.data);
					onPunchingMachineChanged(geometry);
				});
		}

		// Removes machine and program assignment of every production profile of the
		// geometry (the program stays in machine-v2). Choosing a machine again
		// prepares a new program.
		function removePunchingMachines(geometry) {
			if (!isEvoV2()) {
				return $q.reject(new Error('punching programs are only implemented for v2'));
			}

			var pollId = getPunchingStatusId(geometry);

			if (_punchingProgramPolls[pollId]) {
				_punchingProgramPolls[pollId].cancel();
				delete _punchingProgramPolls[pollId];
			}

			return $q.all(ProfileServiceHelper.getProductionProfileIds(geometry).map(function (id) {
				return nuitApiProxy('productionprofiles.punchingmachine', id).delete();
			}))
				.then(function (responses) {
					// the route answers the production profile; clear locally if it doesn't
					applyPunchingProgram(geometry, responses[0].data || {
						punchingMachineId: null, punchingMaterialId: null, punchingMaterialThickness: null,
						punchingProgramId: null, punchingProgramStatus: null, punchingProgramError: null
					});
				});
		}

		// Deletes the program data in machine-v2 (executable, info, error). The
		// machine stays assigned; locally the geometry is reset as if no program
		// had ever been created, so 'create' is offered again.
		// Note: machine-v2 only resets the program to created and production-v2
		// keeps its id on the production profiles - after a reload the program
		// shows up again with status created.
		function deletePunchingProgram(geometry) {
			if (!isEvoV2()) {
				return $q.reject(new Error('punching programs are only implemented for v2'));
			}

			return nuitApiProxy('punchingprograms.program', geometry.punchingProgramId).delete()
				.then(function () {
					applyPunchingProgram(geometry, {
						punchingMachineId: geometry.punchingMachineId,
						punchingMaterialId: geometry.punchingMaterialId,
						punchingMaterialThickness: geometry.punchingMaterialThickness,
						punchingProgramId: null, punchingProgramStatus: null, punchingProgramError: null
					});
				});
		}
		//*******************************************

		function getPunchingProgramState(profile) {
			var mapping = isEvoV2() ? PUNCHING_PROGRAM_STATUS_V2 : PUNCHING_PROGRAM_STATUS_V1;
			return mapping.hasOwnProperty(profile.punchingProgramStatus) ? mapping[profile.punchingProgramStatus] : null;
		}

		// v3 machine config: settings.programs.enabled
		function hasPunchingProgramsEnabled(profile) {
			var machine = profile.punchingMachineId ? nuitDataService.getOne(PunchingMachineService.getMachinesMapped(), profile.punchingMachineId) : null;
			return !!(machine && machine.settings && machine.settings.programs && machine.settings.programs.enabled);
		}

		function canDownloadPunchingDxf(profile) {
			return PUNCHING_DXF_RULES.every(function (rule) {
				return rule(profile);
			});
		}

		function downloadPunchingDxf(profile) {
			var productionProfile = profile._isGeometry ? profile.productionProfiles[0] : profile;
			var url = nuitApiProxy('productionprofiles.dxf', productionProfile.id).getUrl();

			// the backend names the file (profile number > short name > id); the
			// local name is only used if Content-Disposition isn't readable (CORS)
			return imsUtils.downloadDocument(url, getPunchingDxfFilename(profile), {preferServerName: true})
				.catch(function (err) {
					nuitUtils.showErrorToast();
					throw err;
				});
		}

		function getPunchingDxfFilename(profile) {
			var profileData = getProfileData(profile);
			var name = profileData && profileData.name ? profileData.name : 'punching';
			return name.replace(/[\\/:*?"<>|]/g, '_') + '.dxf';
		}

		//*******************************************
		// PUNCHING DXF RULES
		//*******************************************
		function isEvoV2() {
			return nuitAuth.getEvoVersion() === 3;
		}

		function hasPunchesToExport(profile) {
			return nuitProfiles.hasStamps(getProfileData(profile));
		}

		function hasValidBendingMachine(profile) {
			return isEnabledMachine(BendingMachineService.getMachinesMapped(), profile.bendingMachineId);
		}

		function hasValidPunchingMachine(profile) {
			return isEnabledMachine(PunchingMachineService.getMachinesMapped(), profile.punchingMachineId);
		}

		function isEnabledMachine(machines, machineId) {
			if (!machineId) {
				return false;
			}

			var machine = nuitDataService.getOne(machines, machineId);
			return !!(machine && machine.enabled);
		}

		function getProfileData(profile) {
			return profile._isGeometry ? profile.productionProfiles[0].profile : profile.profile;
		}
		//*******************************************

		function onCoilMachineChanged(profile, saveUpdateCuttingMachine, force) {
			var deferred = $q.defer();

			var key = 'cut_' + profile.cuttingMachineId;

			if (ProfileServiceHelper.dataExpired(key) || force) {

				ProfileServiceHelper.resetEntry(key);

				imsMaterials
					.getMaterialsOfCoilMachine(profile.cuttingMachineId)
					.then(function (coils) {
						ProfileServiceHelper.updateEntry(key, coils);
						if (saveUpdateCuttingMachine) {
							updateCuttingMachine(profile, true);
						}
					})
					.finally(function(){
						deferred.resolve();
					});
			}else{
				deferred.resolve();
			}

			profile.coils = ProfileServiceHelper.pool[key];

			var machine = null;

			if (CoilMachineService.machines.length > 0) {
				machine = CoilMachineService.getByIdOffline(profile.cuttingMachineId);
			}

			if (saveUpdateCuttingMachine && (profile.coils.length > 0 || (machine !== null && machine.manualWork))) {
				updateCuttingMachine(profile, true);
			}

			return deferred.promise;
		}

		function usesManualCoilMachine(profile){
			var machine = null;

			if (CoilMachineService.machines.length > 0) {
				machine = CoilMachineService.getByIdOffline(profile.cuttingMachineId);
			}

			return machine?machine.manualWork:false;
		}

		function updateProfile(profile) {
			return nuitApiProxy('productionprofiles.one', profile.id).put({
				length: profile.profile.length,
				quantity: profile.parts[0].quantity
			})
				.catch(function(error){
					nuitUtils.showErrorToast();
					throw error;
				});
		}

		function onBendingMachineChanged(profile, saveUpdateBendingMachine) {
			var key = 'bend_' + profile.bendingMachineId;

			if (ProfileServiceHelper.dataExpired(key)) {

				ProfileServiceHelper.resetEntry(key);

				BendingMachineService.reloadMaterials(profile.bendingMachineId)
					.then(function (materials) {
						ProfileServiceHelper.updateEntry(key, materials, ['bendingMaterialId']);
						if (saveUpdateBendingMachine) {
							updateBendingLogic(profile);
						}
					});
			}

			profile.bendingMaterials = ProfileServiceHelper.pool[key];

			if (saveUpdateBendingMachine && profile.bendingMaterials.length > 0) {
				updateBendingLogic(profile);
			}
		}

		function updateBendingLogic(profile) {
			if (profile._isGeometry) {
				updateBendingMachines(profile);
			} else {
				updateBendingMachine(profile);
			}
		}

		function handleBendingProgram(url, poll){
			return $http({
					method: 'GET',
					url: url
				}
			)
				.then(function(response){
					if(response.status===200){
						if(response.data.href){
							$window.open(response.data.href, '_blank');
						}else{
							nuitUtils.showSuccessToast();
						}
					}else{
						nuitUtils.showSuccessToast();
					}
					return $timeout(poll, 1000);
				})
				.catch(function() {
					nuitUtils.showErrorToast();
					return null;
				});
		}

		function onPunchingMachineChanged(profile, saveUpdatePunchingMachine, clearValues) {
			if(clearValues && clearValues.length>0){
				for(var i=0;i<clearValues.length;i++){
					profile[clearValues[i]] = null;
				}
			}

			var key = 'punch_' + profile.punchingMachineId;
			var pollId = getPunchingStatusId(profile);

			var dataExpired = ProfileServiceHelper.dataExpired(key);

			if (dataExpired) {

				ProfileServiceHelper.resetEntry(key);

				PunchingMachineService.reloadMaterials(profile.punchingMachineId)
					.then(function (materials) {
						ProfileServiceHelper.updateEntry(key, materials);
						if (saveUpdatePunchingMachine) {
							updatePunchingLogic(profile);
						}
					});
			}

			profile.punchingMaterials = ProfileServiceHelper.pool[key];

			// machine-v2 has no punching materials, so v2 saves without them
			if (!dataExpired && saveUpdatePunchingMachine && (isEvoV2() || profile.punchingMaterials.length > 0)) {
				updatePunchingLogic(profile);
			}

			if(saveUpdatePunchingMachine && _punchingProgramPolls[pollId]){
				_punchingProgramPolls[pollId].cancel();
				delete _punchingProgramPolls[pollId];
			}

			if(shouldPollPunchingProgram(profile)){
				updatePunchingProgramStatus(profile);
			}
		}

		// Single entry point of the punching program status polling - nothing else
		// starts a poll (updatePunchingProgramStatus only re-arms its own poll).
		function shouldPollPunchingProgram(profile) {
			if (isEvoV2()) {
				// production-v2 prepares the punching program asynchronously
				// (machine-v2 find-or-create) and writes status transitions onto the
				// production profiles from the machinePunchingProgramUpdated.v2 event.
				// There is no status route, so PunchingMachineService.getProgramStatus
				// re-fetches GET productionprofiles/:id every 2s while the state is
				// PENDING (v2 status 1 created / 2 requested) and stops at AVAILABLE (3)
				// or ERROR (4). Polls are keyed by production profile id (a geometry
				// uses its first production profile) and are cancelled on a machine
				// change, on removing the machine and on $destroy (clearPunchingStatusPolls).
				//
				// To disable: return false here - the status then only changes with a
				// save or a reload. Machines without programs enabled never get a
				// program, so they aren't polled.
				return hasPunchingProgramsEnabled(profile) && getPunchingProgramState(profile) === PUNCHING_PROGRAM_STATE.PENDING;
			}

			return profile.punchingMaterialId && profile.punchingMaterialThickness && !isPunchingProgramFinal(profile);
		}

		function isPunchingProgramFinal(profile) {
			var state = getPunchingProgramState(profile);
			return state === PUNCHING_PROGRAM_STATE.AVAILABLE || state === PUNCHING_PROGRAM_STATE.ERROR;
		}

		// a geometry has no id of its own - its first production profile represents it
		function getPunchingStatusId(profile) {
			return profile._isGeometry ? profile.productionProfiles[0].id : profile.id;
		}

		function applyPunchingProgram(profile, punching) {
			if (profile._isGeometry) {
				updateGeometryAfterPunchingMachineChange(profile, punching);
				return;
			}

			profile.punchingMachineId = punching.punchingMachineId;
			profile.punchingMaterialId = punching.punchingMaterialId;
			profile.punchingMaterialThickness = punching.punchingMaterialThickness;
			profile.punchingProgramError = punching.punchingProgramError;
			profile.punchingProgramId = punching.punchingProgramId;
			profile.punchingProgramStatus = punching.punchingProgramStatus;
		}

		function updatePunchingProgramStatus(profile){
			var id = getPunchingStatusId(profile);

			return PunchingMachineService.getProgramStatus(id)
				.then(function(update){
					var punching = update.data;
					var response = true;

					if(_punchingProgramPolls[id] && isPunchingProgramFinal(punching)){
						_punchingProgramPolls[id].cancel();
						delete _punchingProgramPolls[id];
						response = false;
					}else if(!_punchingProgramPolls[id]){
						var poll = PollRequestService.get('production-punching-program-'+id, true);
						poll.start(function(){return updatePunchingProgramStatus(profile);},2000);
						_punchingProgramPolls[id] = poll;
					}

					applyPunchingProgram(profile, punching);

					return response;
				});
		}

		function updatePunchingLogic(profile) {
			if (profile._isGeometry) {
				updatePunchingMachines(profile)
					.then(function () {
						onPunchingMachineChanged(profile);
					})
					.catch(nuitUtils.showErrorToast);
			} else {
				updatePunchingMachine(profile);
			}
		}

		function getPunchingThicknesses(profile){
			if(profile.punchingMaterialId){
				var material = nuitDataService.getOne(profile.punchingMaterials, profile.punchingMaterialId);

				var thicknesses = [];

				if(material) {
					for (var i = 0; i < material.thicknesses.length; i++) {
						if(thicknesses.indexOf(material.thicknesses[i])===-1){
							thicknesses.push(material.thicknesses[i]);
						}
					}
				}

				return thicknesses.sort();
			}else{
				return [];
			}
		}

		function clearPunchingStatusPolls(){
			for(var key in _punchingProgramPolls){
				_punchingProgramPolls[key].cancel();
				delete _punchingProgramPolls[key];
				console.error(key);
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.service('ProfileServiceHelper', ProfileServiceHelper);

	/** @ngInject */
	function ProfileServiceHelper(nuitDataService) {
		//*******************************************
		// CONSTANTS
		//*******************************************
		var UPDATE_INTERVAL = 30;

		// *******************************************
		// SERVICE
		//*******************************************
		var service = {
			generateUpdatedMachineData: generateUpdatedMachineData,
			dataExpired: dataExpired,
			getProductionProfileIds: getProductionProfileIds,
			resetEntry: resetEntry,
			updateEntry: updateEntry,
			pool: {},
			lastUpdate: {}
		};

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************

		function generateUpdatedMachineData(profile,attributesToUpdate)
		{
			var data = {};
			var keyReplacements = ['machineId','materialId', 'materialWidth', 'coilId', 'materialThickness','recreateProgram'];

				for (var i = 0; i < attributesToUpdate.length; i++) {
					var key = attributesToUpdate[i];
					var dataKey = key;

					for(var j=0;j<keyReplacements.length;j++) {
						if (key.toLowerCase().indexOf(keyReplacements[j].toLowerCase()) !== -1) {
							dataKey = keyReplacements[j];
							continue;
						}
					}

					data[dataKey] = profile[key];
			}

			return data;
		}

		function dataExpired(id)
		{
			return !service.pool.hasOwnProperty(id) ||
					(Date.now()/1000 - service.lastUpdate[id]) > UPDATE_INTERVAL;
		}

		function getProductionProfileIds(geometry)
		{
			var ids = [];

			for(var i=0;i<geometry.productionProfiles.length;i++)
			{
				ids.push(geometry.productionProfiles[i].id);
			}

			return ids;
		}

		function resetEntry(id)
		{
			if(service.pool.hasOwnProperty(id))
			{
				service.pool[id].splice(0,service.pool[id].length);
			}
			else
			{
				service.pool[id] = [];
			}
		}

		function updateEntry(id,data,keyArray)
		{
			nuitDataService.replaceAll(
				service.pool[id],
				nuitDataService.getUniqueByKeys(data, keyArray)
			);
			service.lastUpdate[id] = Date.now()/1000;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.service('ProductionOrdersService', ProductionOrdersService);

	/** @ngInject */
	function ProductionOrdersService(nuitApiProxy, nuitDataService, OrderService, $q) {
		//*******************************************
		// CONSTANTS
		//*******************************************
		var staticGroups = [
			{
				id: 0,
				name: 'prepare',
				translation: 'PRODUCTION_ORDERS.PREPARE',
				icon: 'icon-arrange-send-backward',
				fgColor: 'blue-500-fg',
				bgColor: 'md-blue-500-bg',
				planningBgColor: 'md-blue-500-bg',
				actions: ['produce', 'move-back']
			},
			{
				id: 1,
				name: 'in-production',
				translation: 'PRODUCTION_ORDERS.IN_PRODUCTION',
				icon: 'icon-auto-fix',
				fgColor: 'deep-orange-500-fg',
				bgColor: 'md-deep-orange-500-bg',
				planningBgColor: 'md-deep-orange-500-bg',
				actions: ['finish']
			},
			{
				id: 2,
				name: 'finished',
				translation: 'PRODUCTION_ORDERS.FINISHED',
				icon: 'icon-check-all',
				fgColor: 'light-green-700-fg',
				bgColor: 'md-light-green-700-bg',
				planningBgColor: 'md-light-green-600-bg',
				actions: []
			}
		];

		//*******************************************
		// VARIABLES
		//*******************************************
		var _orders = [];

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			getGroups: getGroups,
			getGroupById: getGroupById,

			produce: produce,
			producible: producible,
			finish: finish,
			reset: reset,
			getStatus: getStatus,
			getOrders: getOrders,
			reload: reload,
			getOrderById: getOrderById,
			remove: remove,
			reloadSolutions: reloadSolutions,
			reloadDocuments: reloadDocuments,
			reloadJobs: reloadJobs,
			resendJob: resendJob,
			getStatusQueryParams: getStatusQueryParams
		};

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function getGroups() {
			return angular.copy(staticGroups);
		}

		function getGroupById(id) {
			var output = false;

			for (var i in staticGroups) {
				if (staticGroups[i].id === id) {
					output = staticGroups[i];
					break;
				}
			}

			return output;
		}

		function getOrders() {
			return _orders;
		}

		function getStatus(order) {
			return nuitApiProxy('production.status', order.id)
				.get()
				.then(function (response) {
					return response.data;
				});
		}


		function produce(order) {
			return producible(order)
				.then(function () {
					return statusChangeInternal('production.produce', order, order.status + 1);
				});
		}

		function producible(order) {
			var deferred = $q.defer();

			nuitApiProxy('production.producible', order.id)
				.get()
				.then(
					function (response) {
						deferred.resolve(response);
					}
				)
				.catch(
					function (response) {
						deferred.reject(response);
					}
				);

			return deferred.promise;
		}

		function finish(order) {
			return statusChangeInternal('production.finish', order, order.status + 1);
		}

		function reset(order) {
			return statusChangeInternal('production.reset', order, 0);
		}

		function statusChangeInternal(route, order, productionStatus) {
			return nuitApiProxy(route, order.id)
				.put({shopOrderStatus: OrderService.getStatusByMappedProdStatus(productionStatus)})
				.then(function (response) {
					nuitDataService.updateOneEntity(order, response.data); //order may not be the same instance as stored in _orders -> update both
					nuitDataService.updateOne(_orders, response.data);
				});
		}

		function reload(filter) {
			return nuitApiProxy('production.orders')
				.get(filter)
				.then(function (response) {
					_orders.splice(0, _orders.length);

					for (var i in response.data) {
						_orders.push(response.data[i]);
					}

					return response.data;
				});
		}

		function getOrderById(id) {
			return nuitApiProxy('production.order', id)
				.get()
				.then(function (response) {
					if (!response.data.documents) {
						response.data.documents = [];
					}
					// shop order ids: 'shopOrders' (v1) and 'orderIds' (v2) are
					// both superseded by 'shopOrderIds'
					if (!response.data.shopOrderIds) {
						response.data.shopOrderIds = response.data.orderIds || response.data.shopOrders || [];
					}
					return response.data;
				});
		}

		function remove(order) {
			return nuitApiProxy('production.order', order.id)
				.delete({shopOrderStatus: order.status < 2 ? OrderService.getPreProductionState() : null})
				.then(function () {
					nuitDataService.removeOne(_orders, order.id);
				});
		}

		function reloadSolutions(order, recreate) {
			var promise;

			if(recreate){
				promise = nuitApiProxy('production.orders.solutions.recreate', order.id).post();
			}else{
				promise = nuitApiProxy('production.orders.solutions', order.id).get();
			}

			return promise
				.then(function (response) {
					nuitDataService.replaceAll(order.solutions, response.data.data);
					return {
						updating: response.data.update !== null,
						error: response.data.error
					};
				});
		}

		function reloadDocuments(order) {
			return nuitApiProxy('production.orders.documents', order.id).get()
				.then(function (response) {
					nuitDataService.replaceAll(order.documents, response.data.data);
					return {
						updating: response.data.update !== null,
						error: response.data.error
					};
				});
		}

		function reloadJobs(orderId) {
			return nuitApiProxy('production.order.jobs', orderId)
				.get()
				.then(function (response) {
					return response.data;
				});
		}

		function resendJob(job) {
			return nuitApiProxy('production.order.job.produce', job.orderId, job.id)
				.get()
				.then(function (response) {
					return nuitDataService.replaceOneEntity(job, response.data);
				});
		}

		function getStatusQueryParams(currentGroup){
			var exclude = [];

			if(currentGroup!=='finished' && currentGroup!=='none'){
				exclude = 'finished';
			}

			var params = [];

			for(var i=0;i<staticGroups.length;i++)
			{
				if(staticGroups[i].name!==exclude)
				{
					params.push(staticGroups[i].id);
				}
			}

			return params.join(',');
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.service('ProductionOrderViewService', ProductionOrderViewService);

	/** @ngInject */
	function ProductionOrderViewService($q, $state, $filter, $rootScope, nuitSimplePunching, nuitApiProxy, ProductionOrdersService, ProfileService, OrderService, nuitUtils, nuitDataService, imsUtils, nuitConfig, $mdDialog, BendingMachineService, PartService, DotNotationService, FeedbackService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _order = {};
		var _shopOrders = [];
		var _products = [];
		var _config = nuitConfig.current;
		var _feedback = [];
		var _unregisterConfigListener = null;
		var _isLoading = false;

		if(nuitConfig.isReady()) {
			reloadStamping();
		}else{
			_unregisterConfigListener = $rootScope.$on('config::config.loaded',reloadStamping);
		}

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			getOrderById: getOrderById,
			updateProductionProfiles: updateProductionProfiles,
			updateManualBendsAndCuts: updateManualBendsAndCuts,
			updateGeometryImages: updateGeometryImages,
			updatePartModeAttributes: updatePartModeAttributes,
			updateMaterialsInSolutions: updateMaterialsInSolutions,
			updateCheckBoxes: updateCheckBoxes,
			reloadSolutions: reloadSolutions,
			openLabel: openLabel,
			openImage: imsUtils.openImage,
			setDefaultCoilMaterial: setDefaultCoilMaterial,
			setDefaultBendings: setDefaultBendings,
			complain: complain,
			getProductionProfile: getProductionProfile,
			getFeedback: getFeedback,
			setFeedback: setFeedback,
			reloadFeedbackForProfile: reloadFeedbackForProfile,
			batchUpdateMachines: batchUpdateMachines,
			getCoilsByCuttingMaterialId: getCoilsByCuttingMaterialId,
			displaySingleCoil: displaySingleCoil
		};

		//*******************************************


		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'order', {
			get: function () {
				return _order;
			}
		});
		Object.defineProperty(service, 'isLoading', {
			get: function () {
				return _isLoading;
			}
		});
		Object.defineProperty(service, 'shopOrders', {
			get: function () {
				return _shopOrders;
			}
		});
		Object.defineProperty(service, 'products', {
			get: function () {
				return _products;
			}
		});
		Object.defineProperty(service, 'feedback', {
			get: function () {
				return _feedback;
			}
		});
		//*******************************************

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function reloadStamping() {
			if(_config.editor && _config.editor.nuitDrawStampingRework) {
				if(_config.editor.nuitDrawStampingRework.areas) {
					nuitSimplePunching.setArea(_config.editor.nuitDrawStampingRework.areas);
				}
				if(_config.editor.nuitDrawStampingRework.tools){
					nuitSimplePunching.setTools(_config.editor.nuitDrawStampingRework.tools);
				}
			}

			if(_unregisterConfigListener!==null){
				_unregisterConfigListener();
				_unregisterConfigListener = null;
			}
		}

		function getOrderById(id) {
			_isLoading = true;
			angular.copy({},_order);
			return ProductionOrdersService
				.getOrderById(id)
				.then(function (order) {
					_isLoading = false;
					for (var i = 0; i < order.productionProfiles.length; i++) {
						order.productionProfiles[i].manualCuts = ProfileService.getCount(order.productionProfiles[i], 'manualCuts');
						order.productionProfiles[i].manualCutsBool = order.productionProfiles[i].manualCuts > 0;
						order.productionProfiles[i].manualBends = order.productionProfiles[i].parts[0].manualBends;
					}

					if (!order.hasOwnProperty('solutions')) {
						order.solutions = [];
					}

					updateMaterialsInSolutions(order);
					buildGeometryData(order);
					updatePartModeAttributes(order);

					angular.copy(order, _order);

					reloadShopOrders();

					reloadFeedback();

					return _order;
				});
		}

		function updateProductionProfiles(){
			return nuitApiProxy('productionprofiles.get.all',_order.id)
				.get()
				.then(function(response){
					nuitDataService.replaceAll(_order.productionProfiles,response.data);
					for (var i = 0; i < _order.productionProfiles.length; i++) {
						_order.productionProfiles[i].manualCuts = ProfileService.getCount(_order.productionProfiles[i], 'manualCuts');
						_order.productionProfiles[i].manualCutsBool = _order.productionProfiles[i].manualCuts > 0;
						_order.productionProfiles[i].manualBends = _order.productionProfiles[i].parts[0].manualBends;
					}
					buildGeometryData(_order);
					updatePartModeAttributes(_order);
					return _order.productionProfiles;
				});
		}

		function updateMaterialsInSolutions(order) {
			for (var i = 0; i < order.solutions.length; i++) {
				var newMaterial = getMaterialById(order, order.solutions[i].materialId);

				if (!order.solutions[i].hasOwnProperty('material')) {
					order.solutions[i].material = newMaterial;
				}
				else{
					nuitDataService.updateOneEntity(order.solutions[i].material,newMaterial);
				}
			}
		}

		function getMaterialById(order, id) {
			for (var i = 0; i < order.materialInfos.length; i++) {
				if (order.materialInfos[i].material.id === id) {
					return order.materialInfos[i].material;
				}
			}
		}

		function buildGeometryData(order) {
			order.geometries = {};

			for (var i = 0; i < order.productionProfiles.length; i++) {
				var profile = order.productionProfiles[i].profile;

				var key = getGeometryGroupKey(order.productionProfiles[i]);

				if (!order.geometries.hasOwnProperty(key)) {
					// TODO: bending program fields come from the first production profile only.
					// Fine while a group needs a single program (e.g. Thalmann). Machines that
					// need one program per length (e.g. Cidan) need these per production
					// profile, with the group expandable to list them.
					order.geometries[key] =
						{
							geometry: profile.geometry,
							material: profile.material,
							images: [],
							imageIndex: 0,
							stamps: profile.stamps,
							punches: profile.punches,
							tiltingsCount: profile.tiltingsCount,
							profileBlank: profile.blank,
							profile: profile,
							productionBlank: order.productionProfiles[i].blank,
							productionProfile: order.productionProfiles[i],
							productionProfiles: [],
							bendingMachineId: order.productionProfiles[i].bendingMachineId,
							cuttingMachineId: order.productionProfiles[i].cuttingMachineId,
							cuttingMaterialId: order.productionProfiles[i].cuttingMaterialId,
							cuttingCoilId: order.productionProfiles[i].cuttingCoilId,
							cuttingMaterialWidth: order.productionProfiles[i].cuttingMaterialWidth,
							bendingProgramUrl: order.productionProfiles[i].bendingProgramUrl,
							bendingProgramId: order.productionProfiles[i].bendingProgramId,
							bendingProgramStatus: order.productionProfiles[i].bendingProgramStatus,
							bendingMaterialId: order.productionProfiles[i].bendingMaterialId,
							punchingMachineId: order.productionProfiles[i].punchingMachineId,
							punchingMaterialId: order.productionProfiles[i].punchingMaterialId,
							punchingMaterialThickness: order.productionProfiles[i].punchingMaterialThickness,
							punchingProgramId: order.productionProfiles[i].punchingProgramId,
							punchingProgramStatus: order.productionProfiles[i].punchingProgramStatus,
							punchingProgramError: order.productionProfiles[i].punchingProgramError,
							_isGeometry: true,
						};
				}

				order.geometries[key].productionProfiles.push(
					order.productionProfiles[i]
				);
			}

			for (var geometryKey in order.geometries) {
				updateGeometryImages(order.geometries[geometryKey]);
			}

			updateManualBendsAndCuts(order);
			updateCheckBoxes(order);
		}

		// v2 hashes a simple profile's running length into its geometry, so each
		// length gets its own geometry.id. Simple profiles (bends only, no punches,
		// not tapered, single side) are grouped by their cross section (bendHashX)
		// instead. Geometries are deduplicated by hash in v2, so identical profiles
		// share a geometry.id; everything else stays one group per production profile.
		// v1 keeps grouping by geometry.id.
		function getGeometryGroupKey(productionProfile) {
			var profile = productionProfile.profile;

			if (ProfileService.isEvoV2()) {
				// boxes come with simple=true, so multiSide has to be checked as well
				if (profile.simple && !profile.multiSide && profile.geometry && profile.geometry.bendHashX) {
					return 'simple_' + profile.geometry.bendHashX + '_' + profile.material.id;
				}

				return 'profile_' + productionProfile.id;
			}

			return profile.geometry.id + '_' + profile.material.id;
		}

		// One image per distinct preview of the group (profiles of different length
		// render differently); identical images are listed once.
		function updateGeometryImages(geometry) {
			var images = [];
			var urls = [];

			for (var i = 0; i < geometry.productionProfiles.length; i++) {
				var productionProfile = geometry.productionProfiles[i];
				var url = $filter('profileImage')(productionProfile.profile);

				if (urls.indexOf(url) === -1) {
					urls.push(url);
					images.push({url: url, productionProfile: productionProfile});
				}
			}

			geometry.images = images;
			geometry.imageIndex = Math.min(geometry.imageIndex || 0, Math.max(images.length - 1, 0));
		}

		function updateManualBendsAndCuts(order) {
			for (var currentKey in order.geometries) {
				var geometries = order.geometries[currentKey];

				geometries.manualBendAll = true;
				geometries.manualCutAll = true;

				for (var j = 0; j < geometries.productionProfiles.length; j++) {
					geometries.manualBendAll = geometries.manualBendAll && geometries.productionProfiles[j].manualBends;
					geometries.manualCutAll = geometries.manualCutAll && (geometries.productionProfiles[j].manualCuts === geometries.productionProfiles[j].parts[0].quantity);
				}
			}
		}

		function updateCheckBoxes(order) {
			for (var currentKey in order.geometries) {
				var geometries = order.geometries[currentKey];
				geometries.producedAll = true;

				for(var l=0;l<_config.ims.productionOrders.productionProfile.partsMode.customData.checkBoxes.length;l++) {
					var field = _config.ims.productionOrders.productionProfile.partsMode.customData.checkBoxes[l];
					var allKey = field.attribute + 'All';
					geometries[allKey] = true;

					for (var j = 0; j < geometries.productionProfiles.length; j++) {
						geometries[allKey] = geometries[allKey] && geometries.productionProfiles[j].parts[0].customData[field.attribute];
					}
				}

				for (var k = 0; k < geometries.productionProfiles.length; k++) {
					geometries.producedAll = geometries.producedAll && geometries.productionProfiles[k].parts[0].produced;
				}
			}
		}

		function updatePartModeAttributes(order) {
			for (var i = 0; i < order.productionProfiles.length; i++) {
				var profile = order.productionProfiles[i];
				profile.bendedAll = true;
				profile.cutAll = true;
				profile.stampedAll = true;


				for(var l=0;l<_config.ims.productionOrders.productionProfile.partsMode.customData.checkBoxes.length;l++) {
					var field = _config.ims.productionOrders.productionProfile.partsMode.customData.checkBoxes[l];
					profile[field.attribute + 'All'] = true;
				}

				for (var j = 0; j < profile.parts.length; j++) {
					var part = profile.parts[j];
					profile.bendedAll = profile.bendedAll && part.bended === 1;
					profile.cutAll = profile.cutAll && part.cut === 1;
					profile.stampedAll = profile.stampedAll && part.stamped === 1;


					for(var k=0;k<_config.ims.productionOrders.productionProfile.partsMode.customData.checkBoxes.length;k++){
						var field = _config.ims.productionOrders.productionProfile.partsMode.customData.checkBoxes[k];

						if(!part.customData){
							DotNotationService.add(part,'customData.'+field.attribute,false);
						}

						profile[field.attribute + 'All'] = profile[field.attribute + 'All'] && part.customData[field.attribute];
					}
				}
			}
		}

		function reloadShopOrders() {
			_shopOrders.splice(0, _shopOrders.length);
			_products.splice(0,_products.length);

			for (var i = 0; i < _order.shopOrderIds.length; i++) {
				OrderService.loadOrder(_order.shopOrderIds[i])
					.then(function (response) {
						_shopOrders.push(response);
						while(response.products.length>0){
							_products.push(response.products.shift());
						}
					});
			}
		}

		function reloadFeedback(){
			if(_config.ims.productionOrders.feedback.enabled) {
				BendingMachineService.reload()
					.then(function(){
						//_feedback.splice(0, _feedback.length);
						for (var i = 0; i < _order.productionProfiles.length; i++) {
							reloadFeedbackForProfile(_order.productionProfiles[i]);
						}
					});
			}
		}

		function reloadFeedbackForProfile(profile){
			return FeedbackService.getFeedback(profile)
				.then(function (data) {
					return nuitDataService.upsertOne(
						_feedback,
						data,
						['geometryId', 'machineId', 'materialId']
						);
				});
		}

		function getFeedback(profile, reload){
			if(_config.ims.productionOrders.feedback.enabled) {
				var geometryId, machineId, materialId;
				if (profile._isGeometry) {
					geometryId = profile.geometry.id;
					machineId = profile.bendingMachineId;
					materialId = profile.material.id;
				} else {
					geometryId = profile.profile.geometry.id;
					machineId = profile.bendingMachineId;
					materialId = profile.profile.materialId;
				}

				var feedback = nuitDataService.getOneByKeys(
					_feedback,
					{geometryId: geometryId, machineId: machineId, materialId: materialId}
				);

				if (reload) {
					reloadFeedbackForProfile(profile);
				}

				return feedback;
			}
		}

		function setFeedback(profile, producible){
			var geometryId, machineId, materialId;

			if(profile._isGeometry){
				geometryId = profile.geometry.id;
				machineId = profile.bendingMachineId;
				materialId = profile.material.id;
			}else{
				geometryId = profile.profile.geometry.id;
				machineId = profile.bendingMachineId;
				materialId = profile.profile.materialId;
			}

			var feedback = angular.copy(service.getFeedback(profile));
			feedback.manufacturable = producible;
			feedback.changed = true;
			nuitDataService.replaceOneByKeys(_feedback, feedback, {geometryId: geometryId, machineId: machineId, materialId: materialId});

			FeedbackService.postFeedback(
				{
					machineId: machineId,
					producible: producible,
					noteIds: [],
					geometryId: geometryId,
					materialId: materialId
				}
			);
		}

		function reloadSolutions(order, recreate) {
			return ProductionOrdersService.reloadSolutions(order, recreate)
				.then(function (status) {
					updateMaterialsInSolutions(order);
					return status;
				})
				.catch(nuitUtils.showErrorToast);
		}

		function openLabel(label) {
			$mdDialog.show(createLabelDialog(label));
		}

		function createLabelDialog(label) {
			return {
				controller: 'LabelController',
				controllerAs: 'vm',
				templateUrl: 'app/main/production.orders/dialogs/label/label.html',
				clickOutsideToClose: true,
				locals: {
					label: label
				}
			};
		}

		function setDefaultCoilMaterial(data) {
			return nuitApiProxy('materials.coils.one', data.materialId, data.machineId).put(data)
				.then(function (response) {
					nuitUtils.showSuccessToast();
					return response;
				})
				.catch(nuitUtils.showErrorToast);
		}

		function setDefaultBendings(materialId, bendingMaterialId, bendingMachineId) {
			return BendingMachineService.addBending(materialId, bendingMaterialId, bendingMachineId)
				.then(function (response) {
					nuitUtils.showSuccessToast();
					return response;
				})
				.catch(nuitUtils.showErrorToast);
		}

		function complain(part){
			return nuitUtils.showConfirmationDialog('PRODUCTION_ORDERS.COMPLAIN','PRODUCTION_ORDERS.COMPLAIN_CONTENT')
				.then(function(){
					return PartService.complain(part)
						.then(function(part){
							nuitUtils.showSuccessToast();
							return part;
						});
				});
		}

		function getProductionProfile(id) {
			return nuitApiProxy('productionprofiles.get.one', id)
				.get()
				.then(function (response) {
					return response.data;
				});
		}

		function batchUpdateMachines(ids, data){
			var promises = [];

			if(data.coil && (data.coil.machine.manualWork || data.coil.material)){
				promises.push(function(){return ProfileService.batchUpdateCuttingMachines(ids,data.coil.machine,data.coil.material,data.coil.width, data.coil.coilId);});
			}

			if(data.bend){
				promises.push(function(){return ProfileService.batchUpdateBendingMachines(ids,data.bend.machine,data.bend.material, data.bend.manual)});
			}

			if(data.punch){
				promises.push(function(){return ProfileService.batchUpdatePunchingMachines(ids,data.punch.machine, data.punch.material,data.punch.thickness)});
			}

			function doAsyncSeries(arr) {
				return arr.reduce(function (promise, item) {
					return promise.then(function() {
						return item();
					});
				}, $q.when([]));
			}

			return doAsyncSeries(promises)
				.then(function(response){
					nuitUtils.showSuccessToast();
					return response.data;
				})
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});
		}

		function getCoilsByCuttingMaterialId(profileOrGeometry){
			var material;

			if(profileOrGeometry.coils) {
				material = profileOrGeometry.coils.find(function (entry) {
					return entry.id === profileOrGeometry.cuttingMaterialId;
				});
			}
			return material && material.coils? material.coils : [];
		}

		function displaySingleCoil(profileOrGeometry){
			var material;

			if(profileOrGeometry.coils) {
				material = profileOrGeometry.coils.find(function (entry) {
					return entry.id === profileOrGeometry.cuttingMaterialId;
				});
			}

			if(material && material.coils && material.coils.length===1){
				return $filter('nuitTranslate')(material.name) !== $filter('nuitTranslate')(material.coils[0].name);
			}

			return false;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.service('PartService', PartService);

	/** @ngInject */
	function PartService(nuitApi, nuitDataService) {

		var _productionProfile = {};

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			add: add,
			getProductionProfileByPartId: getProductionProfileByPartId,
			complain: complain,
			updateCustomData: updateCustomData,
			updateProduced: updateProduced
		};

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'productionProfile', {
			get: function () {
				return _productionProfile;
			}
		});

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function add(part,type)
		{
			var added = part[type]===1?1:-1;

			return nuitApi('production.parts.'+type,part.id)
				.put({add:added})
				.then(function(response){
					nuitDataService.updateOneEntity(part,response.data);
				});
		}

		function getProductionProfileByPartId(partId)
		{
			return nuitApi('production.part')
				.get({partId:partId})
				.then(function(response){
					return angular.merge(_productionProfile,response.data);
				});
		}

		function complain(part){
			return nuitApi('production.parts.complaints',part.id)
				.post()
				.then(function(response){
					return angular.merge(part,response.data);
				});
		}

		function updateCustomData(part){
			return nuitApi('production.parts.customdata',part.id)
				.put(part.customData)
				.then(function(response){
					return angular.merge(part,response.data);
				});
		}

		function updateProduced(part){
			var promise;

			if(part.produced){
				promise = nuitApi('production.parts.produced.set',part.id);
			}else{
				promise = nuitApi('production.parts.produced.unset',part.id);
			}

			return promise
				.put()
				.then(function(response){
					return angular.merge(part,response.data);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.controller('ProductionController', ProductionController);

	/** @ngInject */
	function ProductionController($scope,
								  $mdDialog,
								  $translate,
								  $filter,
								  CoilMachineService,
								  ProductionOrdersService,
								  ProductionOrderViewService,
								  nuitUtils,
								  nuitDataService,
								  nuitAuth,
								  nuitUnits,
								  nuitConfig,
								  SolutionViewService) {

		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.machines = CoilMachineService.machines;
		vm.order = ProductionOrderViewService.order;
		vm.jobs = [];
		vm.jobsByMachine = {};
		vm.nuitUnits = nuitUnits;
		vm.config = nuitConfig.current;
		vm.resentJob = null;
		vm.lastRefresh = "-";
		//*******************************************

		//*******************************************
		// METHOD (EXPOSURE)
		//*******************************************
		vm.resend = resend;
		vm.reload = reload;
		vm.reloadJobs = reloadJobs;
		vm.showError = showError;
		vm.showJob = showJob;
		$scope.$on('$stateChangeSuccess', stateChanged);

		//*******************************************

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			reload();
		}

		function stateChanged(event, toState, toParams) {
			if (toParams.active === 'production') {
				reload();
			}
		}

		function reload() {
			if (CoilMachineService.machines.length === 0) {
				CoilMachineService.reload()
					.then(reloadJobs)
					.catch(nuitUtils.showErrorToast);
			} else {
				reloadJobs()
					.catch(nuitUtils.showErrorToast);
			}
		}

		function reloadJobs() {
			nuitDataService.replaceOneEntity(vm.jobsByMachine, {});

			return ProductionOrdersService.reloadJobs(vm.order.id)
				.then(function (response) {
					nuitDataService.replaceAll(vm.jobs, response);
					sort();
					vm.lastRefresh = $filter('nuitDatetime')(Date.now()/1000,'HH:mm:ss');
				});
		}

		function sort() {
			for (var i = 0; i < vm.jobs.length; i++) {
				var job = vm.jobs[i];

				if (!vm.jobsByMachine.hasOwnProperty(job.machineId)) {
					vm.jobsByMachine[job.machineId] = {
						machine: CoilMachineService.getByIdOffline(job.machineId),
						jobs: []
					};
				}

				vm.jobsByMachine[job.machineId].jobs.push(job);
			}
		}

		function resend(job) {
			nuitUtils.showConfirmationDialog('JOB.CONFIRM_RESEND_TITLE', 'JOB.CONFIRM_RESEND_CONTENT')
				.then(function () {
					vm.resentJob = job;

					ProductionOrdersService.resendJob(job)
						.then(function () {
							if (job.error !== null && nuitAuth.getUser().status === 2) {
								showError(job.error);
							}
						})
						.finally(function () {
							vm.resentJob = null;
						});
				});
		}

		function showError(error) {
			$mdDialog.show($mdDialog.alert({
				title: $translate.instant('ERROR.TITLE'),
				textContent: error !== null ? error : '-',
				ok: $translate.instant('APP.CLOSE')
			}));
		}

		function showJob(job){
			for(var i=0;i<vm.order.solutions.length;i++){
				for(var j=0;j<vm.order.solutions[i].jobs.length;j++){
					if(vm.order.solutions[i].jobs[j].name===job.jobName){
						SolutionViewService.open(
							vm.order.solutions[i],
							false,
							{start:j + 1,count:1}
						);
						break;
					}
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.controller('ProductionOrderProfilesController', ProductionOrderProfilesController);

	/** @ngInject */
	function ProductionOrderProfilesController(
												$filter,
												$rootScope,
											   $scope,
											   $window,
											   $location,
											   $timeout,
											   $state,
											   nuitConfig,
											   nuitUtils,
											   $http,
											   ProductionOrderViewService,
											   BendingMachineService,
											   CoilMachineService,
											   PunchingMachineService,
											   ProfileService,
											   PartService,
											   DotNotationService,
											   nuitDataService,
											   imsUtils,
											   imsTranslation,
												FeedbackService,
											   TeaserService,
												imsNextChannel,
												nuitAuth) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.order = ProductionOrderViewService.order;
		vm.getFeedback = ProductionOrderViewService.getFeedback;
		vm.config = nuitConfig.current;
		vm.coilMachines = CoilMachineService.getMachinesMapped();
		vm.bendingMachines = BendingMachineService.getMachinesMapped();
		vm.punchingMachines = PunchingMachineService.getMachinesMapped();
		vm.shopOrders = ProductionOrderViewService.shopOrders;
		vm.lastProfile = 0;
		vm.offset = 0;
		vm.collapsedIds = [];
		vm.bendingProgramPoll = null;
		vm.unregisterConfigListener = null;
		vm.selectedLanguage = imsTranslation.language;
		vm.skipProfileReload = true;
		vm.lastActiveTab = '';
		vm.bendMachineTeaser = undefined;
		vm.coilMachineTeaser = undefined;
		vm.punchingMachineTeaser = undefined;

		if (vm.config.ims.productionOrders.productionProfile.partsMode.navBar.enabled && vm.config.ims.productionOrders.productionProfile.partsMode.navBar.virtual) {
			vm.profileCount = vm.config.ims.productionOrders.productionProfile.partsMode.navBar.itemCount - 1;
		} else {
			vm.profileCount = vm.order.productionProfiles.length;
		}

		vm.showProfileDetailsButton = nuitAuth.getEvoVersion() === 3;
		vm.imsNextChannel = imsNextChannel;
		//*******************************************

		//*******************************************
		// METHOD (EXPOSURE)
		//*******************************************
		vm.getProducedParts = ProfileService.getProducedParts;
		vm.getCutParts = ProfileService.getCutParts;
		vm.getStampedParts = ProfileService.getStampedParts;
		vm.getProducedParts = ProfileService.getProducedParts;
		vm.getBendedParts = ProfileService.getBendedParts;
		vm.getQuantityParts = ProfileService.getQuantityParts;
		vm.openLabel = ProductionOrderViewService.openLabel;
		vm.openImage = ProductionOrderViewService.openImage;
		vm.getCoilsByCuttingMaterialId = ProductionOrderViewService.getCoilsByCuttingMaterialId;
		vm.displaySingleCoil = ProductionOrderViewService.displaySingleCoil;
		vm.updateManualWorkMachine = updateManualWorkMachine;
		vm.updateCuttingMachine = updateCuttingMachine;
		vm.batchUpdateMachines = batchUpdateMachines;
		vm.updateBendingMachine = updateBendingMachine;
		vm.updatePunchingMachine = updatePunchingMachine;
		vm.getPunchingThicknesses = ProfileService.getPunchingThicknesses;
		vm.updateOffset = updateOffset;
		vm.add = add;
		vm.updateAllByType = updateAllByType;
		vm.getBendingProgramState = ProfileService.getBendingProgramState;
		vm.onCoilMachineChanged = ProfileService.onCoilMachineChanged;
		vm.onBendingMachineChanged = ProfileService.onBendingMachineChanged;
		vm.onPunchingMachineChanged = ProfileService.onPunchingMachineChanged;
		vm.hasPunches = ProfileService.hasPunches;
		vm.usesManualCoilMachine = ProfileService.usesManualCoilMachine;
		vm.openExternalUrl = openExternalUrl;
		vm.openEditor = openEditor;
		vm.setDefaultMaterial = setDefaultMaterial;
		vm.setDefaultBendings = setDefaultBendings;
		vm.canSetDefaultBendings = canSetDefaultBendings;
		vm.getValue = getValue;
		vm.complain = ProductionOrderViewService.complain;
		vm.reuseBendingPrograms = reuseBendingPrograms;
		vm.updatePart = updatePart;
		vm.updateAllParts = updateAllParts;
		vm.mouseWheel = null;
		vm.profileService = ProfileService;
		vm.firstLoad = true;
		vm.reloadingProfiles = false;
		vm.updateCoilWidth = ProfileService.updateCuttingMachine;
		vm.isDefaultMaterial = isDefaultMaterial;
		vm.collapseParts = collapseParts;
		vm.autoCollapseParts = autoCollapseParts;
		vm.hasCollapsedId = hasCollapsedId;
		vm.focusSearchField = focusSearchField;
		vm.setFeedback = ProductionOrderViewService.setFeedback;
		vm.getShopOrderProjectName = getShopOrderProjectName;
		vm.hasPartId = hasPartId;
		vm.hightlightPart = hightlightPart;
		vm.getName = function(material){
			return $filter('nuitTranslate')(material.name);
		};
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$destroy', onDestroy);
		$scope.$on('$stateChangeSuccess', onStateChange);

		if (vm.config.ims.productionOrders.productionProfile.partsMode.navBar.enabled) {
			$scope.$watch('vm.profileService.currentProfile', updateTabs);
		}

		Object.defineProperty(vm, 'startOffset',{
			get:function(){
				if(vm.config.ims.productionOrders.productionProfile.partsMode.navBar.virtual){
					return vm.profileService.currentProfile + vm.offset;
				}else {
					return 0;
				}
			}
		});

		//*******************************************

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			autoCollapseParts();
			onStateChange();
			initCoilMachine();
			initBendingMachine();

			if(nuitConfig.isReady()) {
				delayedInit();
			}else{
				vm.unregisterConfigListener = $rootScope.$on('config::config.loaded',delayedInit());
			}

			vm.skipProfileReload = false;
		}

		function initCoilMachine(){
			CoilMachineService.reload()
				.then(function () {
					for (var i = 0; i < vm.order.productionProfiles.length; i++) {
						ProfileService.onCoilMachineChanged(vm.order.productionProfiles[i], false);
					}
					vm.coilMachineTeaser = TeaserService.hasMachine(vm.coilMachines)?TeaserService.getData('CUTTING_MACHINE',vm.coilMachines):undefined;
				})
				.catch(function () {
					nuitUtils.showErrorToast('PRODUCTION_ORDERS.ERROR_LOADING_COIL_MACHINES');
				});
		}

		function initBendingMachine(){
			BendingMachineService.reload()
				.then(function () {
					vm.order.productionProfiles.forEach(function (profile) {
						updateBendingMachineData(profile);
						ProfileService.onBendingMachineChanged(profile);
					});
					vm.bendMachineTeaser = TeaserService.hasMachine(vm.bendingMachines)?TeaserService.getData('BENDING_MACHINE',vm.bendingMachines):undefined;
				})
				.catch(nuitUtils.showErrorToast);
		}

		function initPunchingMachine(){
			if(vm.config.ims.productionOrders.productionProfile.punchingMachineConfig.enabled) {
				PunchingMachineService.reload()
					.then(function () {
						vm.order.productionProfiles.forEach(function (profile) {
							ProfileService.onPunchingMachineChanged(profile);
						});
						vm.punchingMachineTeaser = TeaserService.hasMachine(vm.punchingMachines)?TeaserService.getData('PUNCHING_MACHINE',vm.punchingMachines):undefined;
					})
					.catch(nuitUtils.showErrorToast);
			}
		}

		function delayedInit(){
			initPunchingMachine();

			if (vm.config.ims.productionOrders.productionProfile.partsMode.navBar.enabled) {
				var root = document.getElementById('profiles');
				angular.element(root).parent().parent().on('scroll', infiniteScroll);
				angular.element(root).parent().parent().on('mousewheel', checkScrolling);
				angular.element(document).on('keydown', keyNavigate);
			}

			if (vm.unregisterConfigListener !== null) {
				vm.unregisterConfigListener();
			}
		}

		function onDestroy() {
			if (vm.config.ims.productionOrders.productionProfile.partsMode.navBar.enabled) {
				var root = document.getElementById('profiles');
				angular.element(root).parent().parent().off('scroll', infiniteScroll);
				clearMouseWheel();
				angular.element(root).parent().parent().off().on('mousewheel', checkScrolling);
				angular.element(document).off('keydown', keyNavigate);
			}

			if(vm.bendingProgramPoll){
				$timeout.cancel(vm.bendingProgramPoll);
				vm.bendingProgramPoll = null;
			}

			ProfileService.clearPunchingStatusPolls();

			if (vm.unregisterConfigListener !== null) {
				vm.unregisterConfigListener();
			}
		}

		function onStateChange() {
			vm.handleArrowNav = $state.params.active === 'profiles';

			if($state.params.active==='profiles' && $state.params.active!==vm.lastActiveTab && !ProductionOrderViewService.isLoading && !vm.skipProfileReload){
				vm.reloadingProfiles = true;
				if(ProductionOrderViewService.order.id) {
					ProductionOrderViewService.updateProductionProfiles()
						.then(function(){
							vm.reloadingProfiles = false;
							initBendingMachine();
							initPunchingMachine();

							var machineIds = [];
							for (var i = 0; i < vm.order.productionProfiles.length; i++) {
								if(vm.order.productionProfiles[i].cuttingMachineId) {
									var profile = vm.order.productionProfiles[i];
									ProfileService.onCoilMachineChanged(
										vm.order.productionProfiles[i],
										false,
										machineIds.indexOf(vm.order.productionProfiles[i].cuttingMachineId) === -1
									)
										.then(function(){
											var material = nuitDataService.getOne(profile.coils, profile.cuttingMaterialId);

											if (material) {
												var coils = material.coils;

												var coil = coils.length===1?coils[0]:coils.find(function(coil){return coil.id===profile.cuttingCoilId;});

												if(coil) {
													profile.cuttingMaterialWidth = coil.width;
												}else{
													profile.cuttingMaterialWidth = 0;
												}
											}
										});

									machineIds.push(vm.order.productionProfiles[i].cuttingMachineId);
								}
							}
						});
				}
			}

			vm.lastActiveTab = $state.params.active;
		}

		function updateTabs() {
				updateOffsets();
				$timeout(function () {
					if (vm.firstLoad) {
						vm.firstLoad = false;
						return;
					}

					var id;

					if (!vm.config.ims.productionOrders.productionProfile.partsMode.navBar.virtual) {
						id = angular.element(document.getElementById('profileScrollView')).children()[vm.profileService.currentProfile].id;
					} else if (vm.profileService.currentProfile === 0) {
						id = angular.element(document.getElementById('profileScrollView')).children().first()[0].id;
					} else {
						id = angular.element(document.getElementById('profileScrollView')).children().first().next()[0].id;
					}

					if(!vm.mouseWheel) {
						$location.hash(id);
					}

					//var profileNav = angular.element(document.getElementById('profileNav')).find('md-tab-item');
					//profileNav[0].focus();
				}, 100);
			}

		function keyNavigate(event) {
			var isLeftOrRight = vm.handleArrowNav && [37, 39].indexOf(event.keyCode) !== -1;

			if (isLeftOrRight) {
				if (vm.profileService.currentProfile === 0 && event.keyCode === 37) {
					vm.profileService.currentProfile = vm.order.productionProfiles.length - 1;
				}
				else if (vm.profileService.currentProfile === vm.order.productionProfiles.length - 1 && event.keyCode === 39) {
					vm.profileService.currentProfile = 0;
				} else {
					vm.profileService.currentProfile += event.keyCode === 37 ? -1 : 1;
				}

				event.stopPropagation();
				updateScrollView(0, true);
			}

			return !isLeftOrRight;
		}

		function checkScrolling(event) {
			if (vm.mouseWheel !== null) {
				$timeout.cancel(vm.mouseWheel);
				clearMouseWheel();
			}

			vm.mouseWheel = $timeout(clearMouseWheel, 250);
		}

		function clearMouseWheel() {
			vm.mouseWheel = null;
		}

		function infiniteScroll(event) {
			var children = angular.element(document.getElementById('profileScrollView')).children();

			if (vm.mouseWheel !== null) {

				if(vm.config.ims.productionOrders.productionProfile.partsMode.navBar.virtual)
				{
					if ((children.last().position().top < event.target.scrollTop || event.target.scrollHeight === event.target.scrollTop + event.target.clientHeight) && ProfileService.currentProfile < vm.order.productionProfiles.length - 1) {
						updateScrollView(1);
					} else if (event.target.scrollTop === 0 && vm.profileService.currentProfile !== 0) {
						updateScrollView(-1);
					}
				}
				else{
					var prevChild = children.eq(Math.max(0,ProfileService.currentProfile-1));
					var nextChild = children.eq(Math.min(vm.order.productionProfiles.length-1,ProfileService.currentProfile+1));

					if(ProfileService.currentProfile<vm.order.productionProfiles.length-1 && event.target.scrollTop>=nextChild.position().top){
						updateScrollView(1);
					}else if(ProfileService.currentProfile>0 && event.target.scrollTop<=prevChild.position().top){
						updateScrollView(-1);
					}
				}
			}
		}

		function updateScrollView(offset, force) {
			vm.profileService.currentProfile += offset;

			if(vm.config.ims.productionOrders.productionProfile.partsMode.navBar.virtual || force) {
				$scope.$digest();
				$location.hash(angular.element(document.getElementById('profileScrollView')).children().first().next()[0].id);
			}
		}

		function updateOffsets() {
			if(!vm.config.ims.productionOrders.productionProfile.partsMode.navBar.virtual) {
				vm.offset = -1;
				vm.profileCount = vm.order.productionProfiles.length;
			} else if (vm.profileService.currentProfile === 0) {
				vm.offset = 0;
				vm.profileCount = vm.config.ims.productionOrders.productionProfile.partsMode.navBar.itemCount - 1;
			} else {
				vm.offset = -1;
				vm.profileCount = vm.config.ims.productionOrders.productionProfile.partsMode.navBar.itemCount;
			}
		}

		function updateManualWorkMachine(profile) {
			ProfileService.updateManualWorkMachine(profile)
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});
		}

		function batchUpdateMachines(selected, data){
			var materialIds = selected.map(function (s){return s.material.id;});
			var profiles = [];

			for(var i=0;i<vm.order.productionProfiles.length;i++){
				var profile = vm.order.productionProfiles[i];
				if(materialIds.indexOf(profile.profile.material.id)!==-1){
					profiles.push(profile);
				}
			}

			return ProductionOrderViewService.batchUpdateMachines(profiles.map(function(m){return m.id;}),data)
				.then(function(newProfiles){
					for (var i = 0; i < newProfiles.length; i++) {
						var newProfile = newProfiles[i];
						var currentProfile = nuitDataService.getOne(profiles,newProfile.id);

						if(data.coil) {
							var coilAttributes = [
								'cuttingMachine','cuttingMachineId','cuttingMaterialId','cuttingCoilId',
								'cuttingMaterialRequired','cuttingMaterialWidth'
							];

							for(var j=0;j<coilAttributes.length;j++){
								currentProfile[coilAttributes[j]] = newProfile[coilAttributes[j]];
							}
							currentProfile.coils = angular.copy(data.coil.coils);
						}
						if(data.bend){
							var bendAttributes = [
								'bendingFile','bendingMachine','bendingMachineId','bendingManualRework',
								'bendingMaterialId','bendingMaterialRequired','bendingProgram',
								'bendingProgramId','bendingProgramStatus','bendingProgramUrl'];

							for(var k=0;k<bendAttributes.length;k++){
								currentProfile[bendAttributes[k]] = newProfile[bendAttributes[k]];
							}
							currentProfile.bendingMaterials = angular.copy(data.bend.materials);
						}
						if(data.punch){
							var punchAttributes = [
								'punchingMachineId','punchingMaterialId','punchingMaterialThickness',
								'punchingProgramError','punchingProgramId','punchingProgramStatus',
								'punchingRotate'
							];

							for(var l=0;l<punchAttributes.length;l++){
								currentProfile[punchAttributes[l]] = newProfile[punchAttributes[l]];
							}
							currentProfile.punchingMaterials = angular.copy(data.punch.materials);
						}
					}
				});
		}

		function updateCuttingMachine(profile, resetMaterial) {
			var material = nuitDataService.getOne(profile.coils, profile.cuttingMaterialId);

			if (material) {
				var coils = material.coils;

				var coil = coils.length===1?coils[0]:coils.find(function(coil){return coil.id===profile.cuttingCoilId;});

				if(coil) {
					profile.cuttingMaterialWidth = coil.width;
				}else{
					profile.cuttingMaterialWidth = 0;
				}
			}

			ProfileService.updateCuttingMachine(profile, resetMaterial)
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});
		}

		function updateBendingMachine(profile, resetMaterial) {
			if (resetMaterial) {
				profile.bendingMaterialId = null;
			}

			updateBendingMachineData(profile);
			ProfileService.updateBendingMachine(profile)
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});
		}

		function updateBendingMachineData(profile) {
			var machine = nuitDataService.getOne(vm.bendingMachines, profile.bendingMachineId);
			profile.bendingMachineData = DotNotationService.get(machine, 'customData');

			profile.manualWorkMachines = [{id: null, name: ''}];
			profile.manualWorkMachines = profile.manualWorkMachines.concat(DotNotationService.get(machine, 'customData.afterBendingPosition.positions', []));
		}

		function updatePunchingMachine(profile, resetMaterial) {
			if (resetMaterial) {
				profile.punchingMaterial = null;
				profile.punchingMaterialId = null;
				profile.punchingMaterialThickness = null;
			}

			ProfileService.updatePunchingMachine(profile)
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});
		}

		function getValue(object, dotNotation) {
			return DotNotationService.get(object, dotNotation);
		}

		function updateOffset(profile) {
			ProfileService.updateOffset(profile)
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});
		}

		function openExternalUrl(url, profile, queryParams) {
			vm.lastMissingProgramProfile = profile;

			if(vm.bendingProgramPoll){
				$timeout.cancel(vm.bendingProgramPoll);
				vm.bendingProgramPoll = null;
			}

			if(queryParams){
				var newUrl = new URL(url);
				var params = new URLSearchParams(newUrl.search);

				for(var key in queryParams){
					params.append(key,queryParams[key]);
				}

				newUrl.search = params.toString();
				url = newUrl.href;
			}

			vm.bendingProgramPoll = ProfileService.handleBendingProgram(url, pollBendingProgramStatus);
		}

		function add(part, type) {
			if (part[type] === 0) {
				nuitUtils.showConfirmationDialog('PRODUCTION_ORDERS.RESET_VALUE', 'PRODUCTION_ORDERS.RESET_VALUE_CONTENT')
					.then(function () {
						addInternal(part, type);
					})
					.catch(function () {
						part[type] = 1;
					});
			}
			else {
				addInternal(part, type);
			}
		}

		function addInternal(part, type) {
			PartService.add(part, type)
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});

			ProductionOrderViewService.updatePartModeAttributes(vm.order);
		}

		function updatePart(part) {
			PartService.updateCustomData(part)
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});

			ProductionOrderViewService.updatePartModeAttributes(vm.order);
		}

		function updateAllParts(profile, key) {
			var keyParts = key.split('.');
			var allKey = keyParts[keyParts.length - 1] + 'All';

			for (var i = 0; i < profile.parts.length; i++) {
				var newValue = profile[allKey];

				if (DotNotationService.get(profile.parts[i], key) !== newValue) {
					DotNotationService.set(profile.parts[i], key, newValue);
					PartService.updateCustomData(profile.parts[i])
						.catch(function(){
							nuitUtils.showErrorToast();
							$state.reload();
						});
				}
			}
		}

		function updateAllByType(profile, type) {
			var value = profile[type + 'All'];

			if (!value) {
				nuitUtils.showConfirmationDialog('PRODUCTION_ORDERS.RESET_ALL_VALUES', 'PRODUCTION_ORDERS.RESET_ALL_VALUES_CONTENT')
					.then(function () {
						updateAllByTypeInternal(profile, type, value);
					})
					.catch(function () {
						profile[type + 'All'] = true;
					});
			}
			else {
				updateAllByTypeInternal(profile, type, value);
			}
		}

		function updateAllByTypeInternal(profile, type, value) {
			for (var i = 0; i < profile.parts.length; i++) {
				var newValue = value ? 1 : 0;

				if (profile.parts[i][type] !== newValue) {
					profile.parts[i][type] = value ? 1 : 0;
					PartService.add(profile.parts[i], type)
						.catch(function(){
							nuitUtils.showErrorToast();
							$state.reload();
						});
				}
			}
		}

		function setDefaultMaterial(profile) {
			var material = profile.coils.filter(function (m) {
				return m.id === profile.cuttingMaterialId;
			})[0];

			var data = {};

			data['machineId'] = profile.cuttingMachineId;
			data['machineMaterialId'] = profile.cuttingMaterialId;
			data['width'] = material.width;
			data['materialId'] = profile.profile.material.id;

			ProductionOrderViewService.setDefaultCoilMaterial(data)
				.then(function (response) {
					vm.order.productionProfiles.forEach(function (p) {
						if (profile.profile.material.id === p.profile.material.id) {
							nuitDataService.upsertOne(p.profile.material.coils,response.data,['machineId']);
						}
					});
				})
				.catch(function(){
					$state.reload();
				});
		}

		function isDefaultMaterial(profile, coil) {
			return profile.profile.material.coils.filter(function (m) {
				return m.machineId === profile.cuttingMachineId && m.machineMaterialId === coil.id;
			}).length > 0;
		}

		function setDefaultBendings(profile) {
			ProductionOrderViewService.setDefaultBendings(
				profile.profile.material.id,
				profile.bendingMaterialId,
				profile.bendingMachineId)
				.then(function (response) {
					if (response) {
						vm.order.productionProfiles.forEach(function (p) {
							if (profile.profile.material.id === p.profile.material.id) {
								p.profile.material.bendings.push(response);
							}
						});
					}
				})
				.catch(function(){
					$state.reload();
				});
		}

		function canSetDefaultBendings(profile) {
			for (var i = 0; i < profile.profile.material.bendings.length; i++) {
				if (profile.profile.material.bendings[i].bendingMachineId === profile.bendingMachineId) {
					return false;
				}
			}

			return profile.bendingMaterialId !== null && profile.profile.material.bendings.filter(function (m) {
				return m.bendingMaterialId === profile.bendingMaterialId;
			}).length === 0;
		}

		function reuseBendingPrograms(profile) {
			var machine = nuitDataService.getOne(vm.bendingMachines, profile.bendingMachineId);

			if (machine && machine.hasOwnProperty('reuseBendingPrograms')) {
				return machine.reuseBendingPrograms;
			} else {
				return false;
			}
		}

		function openEditor(profile, productionProfile) {
			var oldMaterialId = profile.material.id;
			var oldProfile = JSON.parse(JSON.stringify(angular.copy(profile)));

			imsUtils.openEditorAndSave(profile)
				.then(function (newProfile) {
					if(vm.config.ims.productionOrders.feedback.enabled){
						nuitUtils.showFeedbackDialog(angular.copy(oldProfile), angular.copy(newProfile), angular.copy(productionProfile));
					}

					ProductionOrderViewService.getProductionProfile(productionProfile.id).then(
						function(data){
							nuitDataService.replaceOneEntity(productionProfile, data);
							ProfileService.onCoilMachineChanged(productionProfile, false);
							ProfileService.onBendingMachineChanged(productionProfile, false);
							ProfileService.onPunchingMachineChanged(productionProfile,false);
							productionProfile.manualCuts = ProfileService.getCount(productionProfile, 'manualCuts');
							productionProfile.manualCutsBool = productionProfile.manualCuts > 0;
							productionProfile.manualBends = productionProfile.parts[0].manualBends;
						}
					);

					var needsReload = oldMaterialId !== profile.material.id || profile.blank !== oldProfile.blank;

					if (needsReload) {
						$state.reload();
					}
				});
		}

		function pollBendingProgramStatus(){
			if(vm.lastMissingProgramProfile){
				ProductionOrderViewService.getProductionProfile(vm.lastMissingProgramProfile.id)
					.then(function(newProfile){
						if(newProfile.bendingProgramStatus===2) {
							vm.lastMissingProgramProfile.bendingProgramId = newProfile.bendingProgramId;
							vm.lastMissingProgramProfile.bendingProgramUrl = newProfile.bendingProgramUrl;
							vm.lastMissingProgramProfile.bendingProgramStatus = newProfile.bendingProgramStatus;
							vm.lastMissingProgramProfile = null;
							vm.bendingProgramPoll = null;
						}
						else{
							vm.bendingProgramPoll = $timeout(pollBendingProgramStatus, 1000);
						}
					});
			}
		}

		function collapseParts(id){
			var index = vm.collapsedIds.indexOf(id);

			if(index>=0){
				vm.collapsedIds.splice(index,1);
			}else{
				vm.collapsedIds.push(id);
			}
		}

		function hasCollapsedId(id){
			if($state.params.searchId && $state.params.searchId.length>0){
				return false;
			}else{
				return vm.collapsedIds.indexOf(id)>=0;
			}
		}

		function focusSearchField(type, index){
			$timeout(function(){
				$('#' + type + 'MaterialSelect_'+index).click();
				$timeout(function(){
					$('#' + type + 'MaterialSearch_'+index).focus();
				},100);
			},100);
		}

		function autoCollapseParts(){
			if(vm.order){
				if(vm.config.ims.productionOrders.productionProfile.partsMode.autoCollapseParts){
					vm.order.productionProfiles.forEach(function (profile) {
						collapseParts(profile.id);
					});
				}
			}else{
				$timeout(autoCollapseParts,200);
			}
		}

		function getShopOrderProjectName(id) {
			var shopOrder = nuitDataService.getOne(vm.shopOrders, id);

			if (shopOrder && shopOrder.details.hasOwnProperty(vm.config.evo.cart.fields[0].id)) {
				return shopOrder.details[vm.config.evo.cart.fields[0].id];
			}
			else {
				return '';
			}
		}

		function hasPartId(parts){
			if($state.params.searchId && $state.params.searchId.length>0){
				for(var i=0;i<parts.length;i++) {
					if (parts[i].id.toString().startsWith($state.params.searchId)) {
						return true;
					}
				}
			} else{
				return true;
			}
		}

		function hightlightPart(part){
			if($state.params.searchId && $state.params.searchId.length>0){
				return part.id.toString().startsWith($state.params.searchId);
			} else{
				return false;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.controller('ProductionOrderPlanningController', ProductionOrderPlanningController);

	/** @ngInject */
	function ProductionOrderPlanningController($scope, $translate, nuitConfig, nuitUtils, ProductionOrderViewService, ProductionPlanningService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.order = ProductionOrderViewService.order;
		vm.planningBoards = ProductionPlanningService.planningBoards;
		vm.config = nuitConfig.current;

		vm.completionDate = null;
		vm.productionDate = null;
		vm.hours = 0;
		vm.minutes = 0;
		//*******************************************

		//*******************************************
		// METHOD (EXPOSURE)
		//*******************************************
		vm.updateProductionOrderPlanning = updateProductionOrderPlanning;
		vm.filterDates = filterDates;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************

		//*******************************************

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			ProductionPlanningService.getPlanningBoards();

			vm.completionDate = new Date(vm.order.completionDate * 1000);
			vm.productionDate = new Date(vm.order.productionDate * 1000);

			vm.hours = Math.floor(vm.order.estimatedTime / 3600);
			vm.minutes = Math.floor((vm.order.estimatedTime - vm.hours * 3600) / 60);
		}

		function updateProductionOrderPlanning() {
			ProductionPlanningService.updateOrders([{
				id: vm.order.id,
				boardId: vm.order.boardId,
				productionDate: vm.productionDate,
				completionDate: vm.completionDate,
				estimatedTime: vm.hours*3600 + vm.minutes*60
			}])
				.then(function (response) {
						vm.planningForm.$setPristine();

					}
				);
		}

		function filterDates(date){
			return vm.config.ims.planning.boards.workDays.indexOf(date.getDay())!==-1;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.controller('ProductionOrderPartController', ProductionOrderPartController);

	/** @ngInject */
	function ProductionOrderPartController($state,
										   nuitConfig,
										   nuitUtils,
										   ProductionOrderViewService,
										   PartService) {

		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.order = {};
		vm.profile = PartService.productionProfile;
		vm.part = {};
		vm.loading = true;
		vm.config = nuitConfig.current;
		vm.origin = $state.params.origin?$state.params.origin:null;
		//*******************************************

		//*******************************************
		// METHOD (EXPOSURE)
		//*******************************************
		vm.openLabel = ProductionOrderViewService.openLabel;
		vm.openImage = ProductionOrderViewService.openImage;
		vm.complain = ProductionOrderViewService.complain;
		vm.add = add;
		vm.update = PartService.updateCustomData;
		//*******************************************

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			PartService.getProductionProfileByPartId($state.params.partId)
				.then(selectPart);
		}

		function selectPart() {
			vm.part = angular.merge(vm.part, vm.profile.parts[0]);
			vm.order = angular.merge(vm.order, vm.profile.order);
			vm.loading = false;
		}

		function add(part, type) {
			if (part[type] === 0) {
				nuitUtils.showConfirmationDialog('PRODUCTION_ORDERS.RESET_VALUE', 'PRODUCTION_ORDERS.RESET_VALUE_CONTENT')
					.then(function () {
						PartService.add(part, type);
					})
					.catch(function () {
						part[type] = 1;
					});
			}
			else {
				PartService.add(part, type);
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.controller('ProductionOrdersListController', ProductionOrdersListController);

	/** @ngInject */
	function ProductionOrdersListController($q, $rootScope, $scope, $state, $filter, ProductionOrdersService, ProductionPlanningService, nuitConfig, nuitUtils, ListSelectionService, FilterCountService, nuitErrorService, nuitDataService, FeedbackService, BendingMachineService, DateSearchService, EasyProductionService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.currentPage = 0;
		vm.currentPageEntities = [];
		vm.config = nuitConfig.current;
		vm.groups = ProductionOrdersService.getGroups();
		vm.orders = ProductionOrdersService.getOrders();
		vm.loading = true;
		vm.selection = ListSelectionService.get('production.orders', true);
		vm.filterCount = FilterCountService.get('production.orders', true);
		vm.status = vm.groups[0].id;
		vm.searchText = $state.params.term || '';
		vm.todayDay = new Date();
		vm.today = Date.parse(vm.todayDay) / 1000;
		vm.planningBoards = ProductionPlanningService.planningBoards;
		vm.unregisterConfigListener = null;
		var now = new Date().getTime();
		vm.startFilterDate = new Date(now);
		vm.endFilterDate = new Date(now);
		vm.dateSearch = DateSearchService;
		vm.productionOrderInProgress = false;
		vm.inProgress = false;
		//*******************************************

		//*******************************************
		// METHOD EXPOSURE
		//*******************************************
		vm.search = search;
		vm.getGroupById = getGroupById;
		vm.toggleSelectOrder = vm.selection.toggleSelectedEntity;
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.isIndeterminate = vm.selection.isIndeterminate;
		vm.toggleSelected = toggleSelected;
		vm.removeSelected = removeSelected;
		vm.produceSelected = produceSelected;
		vm.finishSelected = finishSelected;
		vm.resetSelected = resetSelected;
		vm.getFilterCount = vm.filterCount.get;
		vm.isFilterSelected = isFilterSelected;
		vm.updateProductionStatus = updateProductionStatus;
		vm.getPlanningBoardName = getPlanningBoardName;
		vm.getManufacturableCount = getManufacturableCount;
		vm.filterAll = filterAll;
		vm.createOrder = function(){
			vm.productionOrderInProgress = true;
			EasyProductionService.createOrder()
				.then(function(order){
					nuitDataService.addOne(vm.orders,order);
					filterAll();
				})
				.finally(function(){
					vm.productionOrderInProgress = false;
				});
		};
		vm.getName = function(order){
			return order.name;
		};
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			ProductionPlanningService.getPlanningBoards();
			if(nuitConfig.isReady()){
				delayedInit();
			}else {
				vm.unregisterConfigListener = $rootScope.$on('config::config.loaded', delayedInit);
			}
		}

		function delayedInit(){
			DateSearchService.initDates(
				vm.config.ims.productionOrders.list.dateFilter.startOffset,
				vm.config.ims.productionOrders.list.dateFilter.endOffset
			);

			vm.startFilterDate = DateSearchService.startDate;
			vm.endFilterDate = DateSearchService.endDate;

			if(vm.config.ims.productionOrders.feedback.enabled){
				BendingMachineService.reload()
					.then(function(){
						initProductionOrders();
					});
			}else{
				initProductionOrders();
			}

			if (vm.unregisterConfigListener !== null) {
				vm.unregisterConfigListener();
			}
		}

		function initProductionOrders(){
			return ProductionOrdersService.reload({status: ProductionOrdersService.getStatusQueryParams('prepare')})
				.then(function(){
					markPartial();
					filterAll();
				})
				.catch(nuitUtils.showErrorToast)
				.finally(function () {
					vm.loading = false;
				});
		}

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {
			vm.group = $state.params.group;
			vm.status = $state.params.group === 'none' ? -1: 0;

			for (var i = 0; i < vm.groups.length; i++) {
				if (vm.groups[i].name === $state.params.group) {
					vm.status = vm.groups[i].id;
				}
			}

			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}

			if ($state.params.page && $state.params.page !== vm.currentPage) {
				vm.currentPage = $state.params.page;
			}

			if ($state.params.group === 'finished' || $state.params.group === 'none') {
				ProductionOrdersService.reload({status: ProductionOrdersService.getStatusQueryParams($state.params.group)})
					.then(finishStateReload);
			}

			if($state.params.startFilterDate && $state.params.endFilterDate){
				vm.startFilterDate = new Date(parseInt($state.params.startFilterDate));
				vm.endFilterDate = new Date(parseInt($state.params.endFilterDate));
				DateSearchService.setDates(vm.startFilterDate,vm.endFilterDate);
				DateSearchService.enabled = true;
			}

			finishStateReload();
		}

		function finishStateReload() {
			markPartial();
			vm.selection.deselectAll();
			filterAll();
		}

		function getGroupById(id) {
			return ProductionOrdersService.getGroupById(id);
		}

		function toggleSelected() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

		function removeSelected() {
			nuitUtils.showDeleteMultiConfirm()
				.then(function () {
					var selection = vm.getSelected();
					var promises = [];

					for (var i = 0; i < selection.length; i++) {
						promises.push(ProductionOrdersService.remove(selection[i]));
					}

					vm.selection.deselectAll();
					vm.inProgress = true;

					$q.all(promises)
						.then(function () {
							nuitUtils.showSuccessToast();
							filterAll();
						})
						.catch(nuitUtils.showErrorToast)
						.finally(function () {
							vm.inProgress = false;
							vm.selection.deselectAll();
						});
				});
		}

		function produceSelected() {
			setStateInternal(ProductionOrdersService.produce)
				.catch(function (response) {
					nuitErrorService.handle(response.data[0]);
				});
		}

		function resetSelected() {
			setStateInternal(ProductionOrdersService.reset);
		}

		function finishSelected() {
			setStateInternal(ProductionOrdersService.finish);
		}

		function setStateInternal(route) {
			var deferred = $q.defer();

			var selection = vm.getSelected();
			var promises = [];

			for (var i = 0; i < selection.length; i++) {
				promises.push(route(selection[i]));
			}

			vm.inProgress = true;

			$q.all(promises)
				.then(function (response) {
					nuitUtils.showSuccessToast();
					filterAll();
					deferred.resolve(response);
				})
				.catch(function (response) {
					nuitUtils.showErrorToast();
					deferred.reject(response);
				}).finally(function () {
					vm.inProgress = false;
					vm.selection.deselectAll();
				});

			vm.selection.deselectAll();

			return deferred.promise;
		}

		function search() {
			$state.go('app.production-orders', {term: vm.searchText});
		}

		function markPartial(){
			//if(vm.config.ims.productionOrders.productionProfile.partsMode.enabled) {
				vm.orders.forEach(function(order){
					if(!order._partial){
						order._partial = true;
					}
				});
			//}
		}

		function filterAll() {
			vm.filterCount.resetAll();
			vm.filteredEntities = [];

			for (var i = 0; i < vm.orders.length; i++) {
				var order = vm.orders[i];
				if (dateInBetween(order) && filter(order)) {
					vm.filteredEntities.push(order);
				}
				vm.filterCount.increment(order.status);
			}

			vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, vm.config.ims.productionOrders.list.orderBy, true);
			vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, 'complaint', true);
		}

		function filter(order) {
			return (order.status === vm.status || $state.params.group === 'none') &&
				(vm.searchText === '' || order.name.toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0);
		}

		function dateInBetween(order){
			if(vm.config.ims.productionOrders.list.dateFilter.enabled){
				return DateSearchService.inBetween(order, vm.config.ims.productionOrders.list.dateFilter.filterDate);
			}else{
				return true;
			}
		}

		function isFilterSelected(status) {
			return vm.status === status;
		}

		function updateProductionStatus(order){
			return ProductionOrdersService.getStatus(order)
				.then(function(status){
					order.productionStatus = status;

					if(vm.config.ims.productionOrders.list.showMaterial || vm.config.ims.productionOrders.feedback.enabled){
						order.feedbacks = [];

						return ProductionOrdersService.getOrderById(order.id)
							.then(function(fullOrder){
								var promises = [];

								if(vm.config.ims.productionOrders.list.showMaterial) {
									order.materialInfos = fullOrder.materialInfos;
								}

								if(vm.config.ims.productionOrders.feedback.enabled) {
									for (var i = 0; i < fullOrder.productionProfiles.length; i++) {
										promises.push(FeedbackService.getFeedback(fullOrder.productionProfiles[i])
											.then(function (feedback) {
												order.feedbacks.push(feedback);
												return;
											})
											.catch(function (error) {
												order.feedbacks.push({error: error});
												return;
											})
										);
									}
								}

								return $q.all(promises)
									.finally(function(){return order;});
							});
					}else {
						return order;
					}
				});
		}

		function getManufacturableCount(order, manufacturable){
			var manufacturableCount = 0;

			if(order.feedbacks) {
				for (var i = 0; i < order.feedbacks.length; i++) {
					if (order.feedbacks[i].manufacturable === manufacturable) {
						manufacturableCount++;
					}
				}
			}

			return manufacturableCount;
		}

		function getPlanningBoardName(order){
			var board = vm.planningBoards.find(function (board) {
				if(board.id === order.boardId){
					return board.name;
				}
			});
			return board?board.name:null;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.controller('ProductionOrderGeometriesController', ProductionOrderGeometriesController);

	/** @ngInject */
	function ProductionOrderGeometriesController(
												$filter,
												$http,
												$window,
												$scope,
												$state,
												 $timeout,
												 nuitApi,
												 nuitConfig,
												 nuitUtils,
												 nuitDataService,
												 ProductionOrderViewService,
												 BendingMachineService,
												 CoilMachineService,
												PunchingMachineService,
												 ProfileService,
												 imsUtils,
												 nuitUnits,
												 imsTranslation,
												FeedbackService,
												PartService,
												DotNotationService,
												TeaserService,
												imsNextChannel,
												nuitProfiles,
												nuitAuth) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.order = ProductionOrderViewService.order;
		vm.getFeedback = ProductionOrderViewService.getFeedback;
		vm.setFeedback = ProductionOrderViewService.setFeedback;
		vm.config = nuitConfig.current;
		vm.coilMachines = CoilMachineService.getMachinesMapped();
		vm.bendingMachines = BendingMachineService.getMachinesMapped();
		vm.punchingMachines = PunchingMachineService.getMachinesMapped();
		vm.shopOrders = ProductionOrderViewService.shopOrders;
		vm.openLabel = ProductionOrderViewService.openLabel;
		vm.openImage = ProductionOrderViewService.openImage;
		vm.getCoilsByCuttingMaterialId = ProductionOrderViewService.getCoilsByCuttingMaterialId;
		vm.displaySingleCoil = ProductionOrderViewService.displaySingleCoil;
		vm.unit = nuitUnits;
		vm.selectedLanguage = imsTranslation.language;
		vm.lastMissingProgramGeometry = null;
		vm.bendingProgramPoll = null;
		vm.bendMachineTeaser = undefined;
		vm.coilMachineTeaser = undefined;
		vm.punchingMachineTeaser = undefined;
		vm.PUNCHING_PROGRAM_STATE = ProfileService.PUNCHING_PROGRAM_STATE;

		vm.showProfileDetailsButton = nuitAuth.getEvoVersion() === 3;
		vm.imsNextChannel = imsNextChannel;
		//*******************************************

		//*******************************************
		// METHOD (EXPOSURE)
		//*******************************************
		vm.getProducedParts = ProfileService.getProducedParts;
		vm.getCutParts = ProfileService.getCutParts;
		vm.getStampedParts = ProfileService.getStampedParts;
		vm.getProducedParts = ProfileService.getProducedParts;
		vm.getBendedParts = ProfileService.getBendedParts;
		vm.getQuantityParts = ProfileService.getQuantityParts;
		vm.isBox = nuitProfiles.isBox;
		vm.updateProfile = updateProfile;

		vm.updateCuttingMachines = updateCuttingMachines;
		vm.batchUpdateMachines = batchUpdateMachines;
		vm.updateBendingMachines = updateBendingMachines;
		vm.updateManualCuts = updateManualCuts;
		vm.updateManualCutsBool = updateManualCutsBool;
		vm.updateAllManualCuts = updateAllManualCuts;
		vm.updateManualBends = updateManualBends;
		vm.updateAllManualBends = updateAllManualBends;
		vm.setDefaultCoilMaterial = setDefaultCoilMaterial;
		vm.getShopOrderProjectName = getShopOrderProjectName;
		vm.setDefaultBendings = setDefaultBendings;
		vm.canSetDefaultBendings = canSetDefaultBendings;
		vm.reuseBendingPrograms = reuseBendingPrograms;
		vm.updatePart = updatePart;
		vm.updateAllParts = updateAllParts;
		vm.updateCoilWidth = ProfileService.updateCuttingMachines;
		vm.updateAllProducedStates = updateAllProducedStates;
		vm.updateProducedState = updateProducedState;

		vm.getBendingProgramState = ProfileService.getBendingProgramState;
		vm.onCoilMachineChanged = ProfileService.onCoilMachineChanged;
		vm.onBendingMachineChanged = ProfileService.onBendingMachineChanged;
		vm.usesManualCoilMachine = ProfileService.usesManualCoilMachine;

		vm.hasPunches = hasPunches;
		vm.updatePunchingMachines = updatePunchingMachines;
		vm.onPunchingMachineChanged = ProfileService.onPunchingMachineChanged;
		vm.getPunchingThicknesses = ProfileService.getPunchingThicknesses;
		vm.getPunchingProgramState = ProfileService.getPunchingProgramState;
		vm.createPunchingProgram = createPunchingProgram;
		vm.preparePunchingProgram = preparePunchingProgram;
		vm.removePunchingMachines = removePunchingMachines;
		vm.deletePunchingProgram = deletePunchingProgram;
		vm.canDownloadPunchingDxf = ProfileService.canDownloadPunchingDxf;
		vm.hasPunchingProgramsEnabled = ProfileService.hasPunchingProgramsEnabled;
		vm.downloadPunchingDxf = ProfileService.downloadPunchingDxf;
		vm.isEvoV2 = ProfileService.isEvoV2;

		vm.openEditor = openEditor;
		vm.getCurrentImage = getCurrentImage;
		vm.isDefaultMaterial = isDefaultMaterial;
		vm.focusSearchField = focusSearchField;
		vm.openExternalUrl = openExternalUrl;
		vm.getName = function(material){
			return $filter('nuitTranslate')(material.name);
		};
		//*******************************************


		$scope.$on('$destroy', onDestroy);
		$scope.$on('$stateChangeSuccess', onStateChange);

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			CoilMachineService.reload()
				.then(function () {
					for (var key in vm.order.geometries) {
						ProfileService.onCoilMachineChanged(vm.order.geometries[key], false);
					}
					vm.coilMachineTeaser = TeaserService.hasMachine(vm.coilMachines)?TeaserService.getData('CUTTING_MACHINE',vm.coilMachines):undefined;
				})
				.catch(function () {
					nuitUtils.showErrorToast('PRODUCTION_ORDERS.ERROR_LOADING_COIL_MACHINES');
				});

			BendingMachineService.reload()
				.then(function () {
					for (var key in vm.order.geometries) {
						ProfileService.onBendingMachineChanged(vm.order.geometries[key], false);
					}
					vm.bendMachineTeaser = TeaserService.hasMachine(vm.bendingMachines)?TeaserService.getData('BENDING_MACHINE',vm.bendingMachines):undefined;
				})
				.catch(nuitUtils.showErrorToast);

			if(vm.config.ims.productionOrders.productionProfile.punchingMachineConfig.enabled) {
				PunchingMachineService.reload()
					.then(function () {
						for (var key in vm.order.geometries) {
							if (vm.order.geometries[key].punchingMachineId) {
								ProfileService.onPunchingMachineChanged(vm.order.geometries[key], false);
							}
						}
						vm.punchingMachineTeaser = TeaserService.hasMachine(vm.punchingMachines)?TeaserService.getData('PUNCHING_MACHINE',vm.punchingMachines):undefined;
					})
					.catch(nuitUtils.showErrorToast);
			}
		}

		function onDestroy() {
			if(vm.bendingProgramPoll){
				$timeout.cancel(vm.bendingProgramPoll);
				vm.bendingProgramPoll = null;
			}

			ProfileService.clearPunchingStatusPolls();
		}

		function updateAllManualCuts(geometry) {
			for (var i = 0; i < geometry.productionProfiles.length; i++) {
				geometry.productionProfiles[i].manualCuts = geometry.manualCutAll ? geometry.productionProfiles[i].parts[0].quantity : 0;
				geometry.productionProfiles[i].manualCutsBool = geometry.manualCutAll;
				updateManualCuts(geometry.productionProfiles[i], false);
			}
		}

		function updateManualCutsBool(profile) {
			profile.manualCuts = profile.manualCutsBool ? profile.parts[0].quantity : 0;
			updateManualCuts(profile, false);
		}

		function updateManualCuts(profile, resetMaterial) {
			if (typeof resetMaterial === 'undefined') {
				resetMaterial = true;
			}

			if (typeof profile.manualCuts === 'undefined' || profile.manualCuts === null) {
				profile.manualCuts = 1;
			}

			profile.manualCuts = Math.min(profile.parts[0].quantity, Math.max(0, profile.manualCuts));

			ProfileService.updateCuttingMachine(profile, resetMaterial, ['manualCuts'])
				.then(function () {
					ProductionOrderViewService.updateManualBendsAndCuts(vm.order);
				})
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});
		}

		function batchUpdateMachines(selected, data){
			var materialIds = selected.map(function (s){return s.material.id;});
			var profiles = [];
			var geometries = {};

			for (var key in vm.order.geometries) {
				if(materialIds.indexOf(vm.order.geometries[key].material.id)!==-1) {
					for (var j = 0; j < vm.order.geometries[key].productionProfiles.length; j++) {
						var profile = vm.order.geometries[key].productionProfiles[j];
						profiles.push(profile);
						if(j===0){
							geometries[profile.id] = vm.order.geometries[key];
						}
					}
				}
			}

			return ProductionOrderViewService.batchUpdateMachines(profiles.map(function(m){return m.id;}),data)
				.then(function(newProfiles){
					for (var i = 0; i < newProfiles.length; i++) {
						var newProfile = newProfiles[i];
						var currentProfile = nuitDataService.getOne(profiles,newProfile.id);
						var geometry = geometries[newProfile.id];

						if (data.coil) {
							var coilAttributes = [
								'cuttingMachine','cuttingMachineId','cuttingMaterialId', 'cuttingCoilId',
								'cuttingMaterialRequired','cuttingMaterialWidth'
							];

							for(var j=0;j<coilAttributes.length;j++){
								currentProfile[coilAttributes[j]] = newProfile[coilAttributes[j]];
							}

							if(geometry) {
								for (var k = 0; k < coilAttributes.length; k++) {
									geometry[coilAttributes[k]] = newProfile[coilAttributes[k]];
								}

								geometry.coils = angular.copy(data.coil.coils);
							}
						}

						if (data.bend) {
							var bendAttributes = [
								'bendingFile','bendingMachine','bendingMachineId','bendingManualRework',
								'bendingMaterialId','bendingMaterialRequired','bendingProgram',
								'bendingProgramId','bendingProgramStatus','bendingProgramUrl'];

							for(var l=0;l<bendAttributes.length;l++){
								currentProfile[bendAttributes[l]] = newProfile[bendAttributes[l]];
							}

							if(geometry) {
								for (var m = 0; m < bendAttributes.length; m++) {
									geometry[bendAttributes[m]] = newProfile[bendAttributes[m]];
								}

								geometry.bendingMaterials = angular.copy(data.bend.materials);

								ProfileService.updateGeometryAfterBendingMachineChange(geometry, newProfile);
							}
						}

						if (data.punch) {
							var punchAttributes = [
								'punchingMachineId','punchingMaterialId','punchingMaterialThickness',
								'punchingProgramError','punchingProgramId','punchingProgramStatus',
								'punchingRotate'
							];

							for(var n=0;n<punchAttributes.length;n++){
								currentProfile[punchAttributes[n]] = newProfile[punchAttributes[n]];
							}

							if(geometry) {
								ProfileService.updateGeometryAfterPunchingMachineChange(geometry, newProfile);
								geometry.punchingMaterials = angular.copy(data.punch.materials);
								ProfileService.onPunchingMachineChanged(geometry, false);
							}
						}
					}
				});
		}

		function updateCuttingMachines(geometry, resetMaterial) {
			var material = nuitDataService.getOne(geometry.coils, geometry.cuttingMaterialId);

			if (material) {
				var coils = material.coils;

				var coil = coils.length===1?coils[0]:coils.find(function(coil){return coil.id===geometry.cuttingCoilId;});

				if(coil) {
					geometry.cuttingMaterialWidth = coil.width;
				}else{
					geometry.cuttingMaterialWidth = 0;
				}
			}

			ProfileService.updateCuttingMachines(geometry, resetMaterial)
				.then(function () {
					if (resetMaterial) {
						ProfileService.onCoilMachineChanged(geometry, false);
					}
				})
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});
		}

		function updateAllManualBends(geometry) {
			for (var i = 0; i < geometry.productionProfiles.length; i++) {
				geometry.productionProfiles[i].manualBends = geometry.manualBendAll;
				updateManualBends(geometry.productionProfiles[i]);
			}
		}

		function updateManualBends(profile) {
			ProfileService.updateBendingMachine(profile, ['manualBends'])
				.then(function () {
					ProductionOrderViewService.updateManualBendsAndCuts(vm.order);
				})
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});
		}

		function updateBendingMachines(geometry, resetMaterial) {
			ProfileService.updateBendingMachines(geometry, resetMaterial)
				.then(function () {
					if (resetMaterial) {
						ProfileService.onBendingMachineChanged(geometry, false);
					}
				})
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});
		}

		function hasPunches(geometry) {
			return ProfileService.hasPunches(geometry.productionProfiles[0].profile);
		}

		function updatePunchingMachines(geometry, resetMaterial) {
			if (resetMaterial) {
				geometry.punchingMaterialId = null;
				geometry.punchingMaterialThickness = null;
			}

			ProfileService.onPunchingMachineChanged(geometry, true);
		}

		function createPunchingProgram(geometry) {
			runPunchingAction(geometry, ProfileService.createPunchingProgram);
		}

		// Always available. Per spec an error or in-progress program is re-sent as is,
		// a prepared one (AVAILABLE) keeps its executable unless forced (409 otherwise).
		function preparePunchingProgram(geometry) {
			var force = ProfileService.getPunchingProgramState(geometry) === ProfileService.PUNCHING_PROGRAM_STATE.AVAILABLE;

			runPunchingAction(geometry, function (g) {
				return ProfileService.preparePunchingProgram(g, force);
			});
		}

		function removePunchingMachines(geometry) {
			runPunchingAction(geometry, ProfileService.removePunchingMachines);
		}

		// geometry._punchingBusy disables the program buttons while a request runs
		function deletePunchingProgram(geometry) {
			runPunchingAction(geometry, ProfileService.deletePunchingProgram);
		}

		function runPunchingAction(geometry, action) {
			geometry._punchingBusy = true;

			action(geometry)
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				})
				.finally(function(){
					geometry._punchingBusy = false;
				});
		}

		// simple profiles of one group only differ in length, so their previews look
		// alike - the first image is shown (imageIndex stays 0 for now)
		function getCurrentImage(geometry) {
			return geometry.images[geometry.imageIndex] || null;
		}

		function openEditor(geometry) {
			var positions = [];

			// profiles of one group can differ in length - every position keeps its own
			// length (the first one takes the editor's, see openEditorAndSaveMultiple).
			// Without a length the backend converts the geometry with length 0 and fails.
			for (var i = 0; i < geometry.productionProfiles.length; i++) {
				positions.push({
					id: geometry.productionProfiles[i].profileId,
					length: geometry.productionProfiles[i].profile.length
				});
			}

			var oldMaterialId = geometry.productionProfiles[0].profile.material.id;
			var oldProfile = JSON.parse(JSON.stringify(geometry.productionProfiles[0].profile));

			imsUtils.openEditorAndSaveMultiple(geometry.productionProfiles[0].profile, positions)
				.then(function (profile) {
					if(vm.config.ims.productionOrders.feedback.enabled){
						nuitUtils.showFeedbackDialog(angular.copy(oldProfile), angular.copy(profile),angular.copy(geometry.productionProfiles[0]));
					}

					angular.merge(geometry.productionProfiles[0].profile, profile);
					ProductionOrderViewService.updateGeometryImages(geometry);
					geometry.tiltingsCount = profile.tiltingsCount;
					geometry.blank = profile.blank;

					// only the first profile comes back - the others were saved too and
					// need to be reloaded
					var needsReload = oldMaterialId !== profile.material.id || profile.blank !== oldProfile.blank ||
						geometry.productionProfiles.length > 1;

					if (oldMaterialId !== profile.material.id) {
						geometry.material = profile.material;
					}

					if(needsReload){
						$state.reload();
					}
				});
		}

		function setDefaultCoilMaterial(geometry) {
			var material = geometry.coils.filter(function (m) {
				return m.id === geometry.cuttingMaterialId;
			})[0];

			var data = {};

			data['machineId'] = geometry.cuttingMachineId;
			data['machineMaterialId'] = geometry.cuttingMaterialId;


			var coils = material.coils;

			var coil = coils.length===1?coils[0]:coils.find(function(coil){return coil.id===geometry.cuttingCoilId;});

			if(coil) {
				data['width'] = material.width = coil.width;
			}else{
				data['width'] = material.width = 0;
			}

			data['materialId'] = geometry.material.id;

			ProductionOrderViewService.setDefaultCoilMaterial(data)
				.then(function (response) {
					for (var key in vm.order.geometries) {
						var g = vm.order.geometries[key];
						if (g.material.id === geometry.material.id) {
							nuitDataService.upsertOne(g.material.coils, response.data, ['machineId']);
						}
					}
				});
		}

		function isDefaultMaterial(geometry, coil) {
			return geometry.material.coils.filter(function (m) {
				return m.machineId === geometry.cuttingMachineId && m.machineMaterialId === coil.id;
			}).length > 0;
		}

		function getShopOrderProjectName(id) {
			var shopOrder = nuitDataService.getOne(vm.shopOrders, id);

			if (shopOrder && shopOrder.details.hasOwnProperty(vm.config.evo.cart.fields[0].id)) {
				return shopOrder.details[vm.config.evo.cart.fields[0].id];
			}
			else {
				return '';
			}
		}

		function setDefaultBendings(geometry) {
			ProductionOrderViewService.setDefaultBendings(
				geometry.material.id,
				geometry.bendingMaterialId,
				geometry.bendingMachineId)
				.then(function (response) {
					if (response) {
						for (var key in vm.order.geometries) {
							var g = vm.order.geometries[key];
							if (g.material.id === geometry.material.id) {
								g.material.bendings.push(response);
							}
						}
					}
				});
		}

		function canSetDefaultBendings(geometry) {
			for (var i = 0; i < geometry.material.bendings.length; i++) {
				if (geometry.material.bendings[i].bendingMachineId === geometry.bendingMachineId) {
					return false;
				}
			}

			return geometry.bendingMaterialId !== null && geometry.material.bendings.filter(function (m) {
				return m.bendingMaterialId === geometry.bendingMaterialId;
			}).length === 0;
		}

		function reuseBendingPrograms(geometry) {
			var machine = nuitDataService.getOne(vm.bendingMachines, geometry.bendingMachineId);

			if (machine && machine.hasOwnProperty('reuseBendingPrograms')) {
				return machine.reuseBendingPrograms;
			} else {
				return false;
			}
		}

		function updateProfile(profile) {
			ProfileService.updateProfile(profile)
				.then(function () {
					if (profile.parts[0].quantity < profile.manualCuts) {
						updateManualCuts(profile);
					}
				})
				.catch(function(){
					$state.reload();
				});
		}

		function focusSearchField(type, index){
			$timeout(function(){
				$('#' + type + 'MaterialSelect_'+index).click();
				$timeout(function(){
					$('#' + type + 'MaterialSearch_'+index).focus();
				},100);
			},100);
		}

		function openExternalUrl(url, geometry, queryParams) {
			vm.lastMissingProgramGeometry = geometry;

			if(vm.bendingProgramPoll){
				$timeout.cancel(vm.bendingProgramPoll);
				vm.bendingProgramPoll = null;
			}

			if(queryParams){
				var newUrl = new URL(url);
				var params = new URLSearchParams(newUrl.search);

				for(var key in queryParams){
					params.append(key,queryParams[key]);
				}

				newUrl.search = params.toString();
				url = newUrl.href;
			}

			vm.bendingProgramPoll = ProfileService.handleBendingProgram(url, pollBendingProgramStatus);
		}

		function pollBendingProgramStatus(){
			if(vm.lastMissingProgramGeometry){
				ProductionOrderViewService.getProductionProfile(vm.lastMissingProgramGeometry.productionProfiles[0].id)
					.then(function(newProfile){
						if(vm.lastMissingProgramGeometry.productionProfiles[0]!==newProfile.bendingProgramStatus) {
							vm.lastMissingProgramGeometry.bendingProgramId = newProfile.bendingProgramId;
							vm.lastMissingProgramGeometry.bendingProgramStatus = newProfile.bendingProgramStatus;
							vm.lastMissingProgramGeometry.bendingProgramUrl = newProfile.bendingProgramUrl;
							vm.lastMissingProgramGeometry = null;
							vm.bendingProgramPoll = null;
						}else{
							vm.bendingProgramPoll = $timeout(pollBendingProgramStatus, 1000);
						}
					});
			}
		}

		function postFeedback(geometry, producible){
			FeedbackService.postFeedback(
				{
				machineId: geometry.bendingMachineId,
				producible: producible,
				noteIds: [],
				geometryId: geometry.geometry.id,
				materialId: geometry.material.id
				}
			);
		}

		function onStateChange(){
			if($state.params.active==='geometries') {
				var machineIds = [];
				for (var key in vm.order.geometries) {
					if(vm.order.geometries[key].cuttingMachineId) {
						var geometry = vm.order.geometries[key];
						ProfileService.onCoilMachineChanged(
							vm.order.geometries[key],
							false,
							machineIds.indexOf(vm.order.geometries[key].cuttingMachineId) === -1
						).then(function(){
							var material = nuitDataService.getOne(geometry.coils, geometry.cuttingMaterialId);

							if (material) {
								var coils = material.coils;

								var coil = coils.length===1?coils[0]:coils.find(function(coil){return coil.id===geometry.cuttingCoilId;});

								if(coil) {
									geometry.cuttingMaterialWidth = coil.width;
								}else{
									geometry.cuttingMaterialWidth = 0;
								}
							}
						});

						machineIds.push(vm.order.geometries[key].cuttingMachineId);
					}
				}
			};
		}

		function updateProducedState(part) {
			PartService.updateProduced(part)
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});

			ProductionOrderViewService.updatePartModeAttributes(vm.order);
			ProductionOrderViewService.updateCheckBoxes(vm.order);
		}

		function updateAllProducedStates(geometry) {
			for (var i = 0; i < geometry.productionProfiles.length; i++) {
				var profile = geometry.productionProfiles[i];
				var newValue = geometry.producedAll;

				if (profile.parts[0].produced !== newValue) {
					profile.parts[0].produced = newValue;
					PartService.updateProduced(profile.parts[0])
						.catch(function(){
							nuitUtils.showErrorToast();
							$state.reload();
						});
				}
			}
		}

		function updatePart(part) {
			PartService.updateCustomData(part)
				.catch(function(){
					nuitUtils.showErrorToast();
					$state.reload();
				});

			ProductionOrderViewService.updatePartModeAttributes(vm.order);
			ProductionOrderViewService.updateCheckBoxes(vm.order);
		}

		function updateAllParts(geometry, key) {
			var keyParts = key.split('.');
			var allKey = keyParts[keyParts.length - 1] + 'All';

			for (var i = 0; i < geometry.productionProfiles.length; i++) {
				var profile = geometry.productionProfiles[i];
				var newValue = geometry[allKey];

				if (DotNotationService.get(profile.parts[0], key) !== newValue) {
					DotNotationService.set(profile.parts[0], key, newValue);
					PartService.updateCustomData(profile.parts[0])
						.catch(function(){
							nuitUtils.showErrorToast();
							$state.reload();
						});
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.controller('ProductionOrderDetailsController', ProductionOrderDetailsController);

	/** @ngInject */
	function ProductionOrderDetailsController($scope,
											  $rootScope,
											  $state,
											  $interval,
											  $translate,
											  $filter,
											  nuitConfig,
											  nuitUtils,
											  nuitAuth,
											  nuitApi,
											  nuitDataService,
											  DotNotationService,
											  ProductionOrderViewService,
											  ProductionOrdersService,
											  ShopOrderDetailsService,
											  OrderService,
											  ProfileService,
											  CoilMachineService,
											  BendingMachineService,
											  nuitErrorService,
											  SolutionViewService,
											  PollRequestService,
											  ConditionCheckService,
											  imsNextChannel) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.order = ProductionOrderViewService.order;
		vm.orderProgessState = 'NONE';
		vm.loading = true;
		vm.selectedTab = $state.params.active;

		if(nuitConfig.isReady() && !nuitConfig.current.ims.productionOrders.productionProfile.partsMode.enabled && vm.selectedTab==='profiles'){
			vm.selectedTab = 'geometries';
			$state.go('.', {active: 'geometries'}, {
				notify: false
			});
		}


		vm.config = nuitConfig.current;
		vm.updateTimeout = null;
		vm.shopOrders = ProductionOrderViewService.shopOrders;
		vm.products = ProductionOrderViewService.products;
		vm.producible = [];
		vm.origin = $state.params.origin ? $state.params.origin : 'app.production-orders';
		vm.profileService = ProfileService;
		vm.profileService.currentProfile = 0;
		vm.isProducible = false;
		vm.producibleInProgress = false;
		vm.solutionsByMachine = {};
		vm.olutionStatus = null;
		vm.machineCount = 0;
		vm.expanded = false;
		vm.documentStatus = {updating: true};
		vm.solutionStatus = {updating: true};
		vm.activeLanguage = $translate.use();
		vm.documentPoll = PollRequestService.get('production-documents', true);
		vm.solutionPoll = PollRequestService.get('production-solutions', true);
		vm.searchId = $state.params.searchId || '';
		//*******************************************

		//*******************************************
		// METHOD (EXPOSURE)
		//*******************************************
		vm.getProgress = getProgress;
		vm.getDetailProgress = getDetailProgress;
		vm.getGroupById = getGroupById;
		vm.produce = produce;
		vm.finish = finish;
		vm.reset = reset;
		vm.remove = remove;
		vm.openSolution = openSolution;
		vm.toggleSolution = toggleSolution;
		vm.openShopOrder = openShopOrder;
		vm.getDocumentURL = getDocumentURL;
		vm.reloadDetails = reloadDetails;
		vm.isShopOrderInProduction = isShopOrderInProduction;
		vm.moveShopOrderToNextStatus = moveShopOrderToNextStatus;
		vm.formatPercentage = formatPercentage;
		vm.getCoilMachineName = CoilMachineService.getNameById;
		vm.expandErrors = expandErrors;
		vm.getProductTranslation = getProductTranslation;
		vm.getCoilMachine = CoilMachineService.getByIdOffline;
		vm.getBendingMachine = BendingMachineService.getByIdOffline;
		vm.reloadProducibility = reloadProducibility;
		vm.recreateSolutions = recreateSolutions;
		vm.hasErrorType = hasErrorType;
		vm.search = search;
		vm.hasPartId = hasPartId;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$destroy', onDestroy);
		var unbindLanguageChange = $rootScope.$on('$translateChangeSuccess', onLanguageChange);
		//*******************************************

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			reloadOrder();
		}

		function reloadOrder(){
			ProductionOrderViewService
				.getOrderById($state.params.orderId)
				.then(function () {
					reloadDetails();
				})
				.catch(function () {
					nuitUtils.showErrorToast('PRODUCTION_ORDERS.ERROR_LOADING_ORDER');
				})
				.finally(function () {
					vm.loading = false;
				});

			vm.updateTimeout = $interval(
				function(){
					reloadProductionStatus();
					if(vm.order.status===0) {
						reloadProducibility();
					}
				}, 10000);
		}

		function reloadProductionStatus(){
			if (vm.order) {
				ProductionOrdersService
					.getStatus(vm.order)
					.then(function (status) {
						var bendingStatus = angular.copy(status.machine.bending);
						var coilStatus = angular.copy(status.machine.coil);

						status.machine.bending = [];
						status.machine.coil = [];

						for(var i=0;i<bendingStatus.length;i++){
							var machine = vm.getBendingMachine(bendingStatus[i].machineId);
							if(machine && machine.customData && machine.customData.feedbackEnabled) {
								bendingStatus[i].machine = vm.getBendingMachine(bendingStatus[i].machineId);
								status.machine.bending.push(bendingStatus[i]);
							}
						}
						for(var i=0;i<coilStatus.length;i++){
							var machine = vm.getCoilMachine(coilStatus[i].machineId);
							if(machine && machine.customData.feedbackEnabled) {
								coilStatus[i].machine = vm.getCoilMachine(coilStatus[i].machineId);
								status.machine.coil.push(coilStatus[i]);
							}
						}
						/*for(var key in status.punching){

						}*/

						vm.order.productionStatus = status;
					});
			}
		}

		function reloadProducibility() {
			vm.producibleInProgress = true;

			ProductionOrdersService.producible(vm.order)
				.then(function () {
					vm.producible.splice(0, vm.producible.length);
					vm.isProducible = true;
				})
				.catch(function (response) {
					vm.producible.splice(0, vm.producible.length);
					vm.producible = angular.merge(vm.producible, mapErrorProfileIds(response.data));
					vm.isProducible = false;
				})
				.finally(function () {
					vm.producibleInProgress = false;
				});
		}

		/**
		 * Replaces profile ids (uuids on v3) in error data with the number shown in the profiles tab.
		 * @param {Array} errors - producible errors [{code, data}]
		 * @returns {Array}
		 */
		function mapErrorProfileIds(errors) {
			// v1/v2 ids are plain numbers and already displayed as is
			if(!angular.isArray(errors) || nuitAuth.getEvoVersion() !== 3) { return errors; }

			var names = {};
			angular.forEach(vm.order.productionProfiles, function (productionProfile) {
				var name = $filter('shortName')(productionProfile.profile);
				names[productionProfile.profileId] = name;
				if(productionProfile.profile) { names[productionProfile.profile.id] = name; }
			});

			angular.forEach(errors, function (error) {
				angular.forEach(error && error.data, function (value, key) {
					if(names[value]) { error.data[key] = names[value]; }
				});
			});

			return errors;
		}

		function hasErrorType(type){
			for(var i=0;i<vm.producible.length;i++){
				if(vm.producible[i].code.toUpperCase()===type){
					return true;
				}
			}
			return false;
		}

		function produce() {
			vm.orderProgessState = 'PRODUCE';

			ProductionOrdersService.produce(vm.order)
				.then(function () {
					nuitUtils.showSuccessToast();
				})
				.catch(function (response) {
					if (response.status === 409) {
						vm.producible = angular.merge(vm.producible, mapErrorProfileIds(response.data));
						nuitErrorService.handle(response.data[0]);
					}
					else {
						nuitUtils.showErrorToast();
					}
				})
				.finally(resetOrderInProgress);
		}

		function finish() {
			vm.orderProgessState = 'FINISH';

			ProductionOrdersService.finish(vm.order)
				.then(function () {
					nuitUtils.showSuccessToast();
				})
				.catch(function () {
					nuitUtils.showErrorToast();
				})
				.finally(resetOrderInProgress);
		}

		function reset() {
			vm.orderProgessState = 'RESET';

			ProductionOrdersService.reset(vm.order)
				.then(function () {
					nuitUtils.showSuccessToast();
				})
				.catch(function () {
					nuitUtils.showErrorToast();
				})
				.finally(function(){
					resetOrderInProgress();
					ProductionOrderViewService.updateProductionProfiles();
				});
		}

		function remove() {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					vm.orderProgessState = 'REMOVE';

					ProductionOrdersService.remove(vm.order)
						.then(function () {
							nuitUtils.showSuccessToast();
							$state.go('app.production-orders');
						})
						.catch(function () {
							nuitUtils.showErrorToast();
						})
						.finally(resetOrderInProgress);
				});
		}

		function getProgress() {
			if (!vm.order && !vm.order.productionStatus) {
				return 0;
			}

			return vm.order.productionStatus.producedParts / vm.order.productionStatus.totalParts * 100;
		}

		function getDetailProgress(produced, total){
			if (!produced || !total) {
				return 0;
			}

			return produced / total * 100;
		}

		function getGroupById(id) {
			return ProductionOrdersService.getGroupById(id);
		}

		function onLanguageChange() {
			vm.activeLanguage = $translate.use();
		}

		function onDestroy() {
			$interval.cancel(vm.updateTimeout);
			vm.documentPoll.cancel();
			unbindLanguageChange();
		}

		function openSolution(solution) {
			SolutionViewService.open(
				solution,
				true,
				false,
				vm.order.status !== 0,
				vm.order.status===1 && vm.config.ims.productionOrders.productionProfile.complain.enabled
			)
				.then(function(){
					if(vm.order.status===1 && vm.config.ims.productionOrders.productionProfile.complain.enabled) {
						reloadOrder();
					}
				});
		}

		// The configured key lives in the solution's customData, a missing value counts as false
		// (default roma.lastSlitOnWaste). The customdata route replaces sent top-level keys as a
		// whole, so the complete top-level object is sent.
		function toggleSolution(solution) {
			var key = vm.config.ims.productionOrders.solutionToggle.key;
			var rootKey = key.split('.')[0];
			var customData = {};

			solution.customData = solution.customData || {};
			DotNotationService.set(solution.customData, key, !DotNotationService.get(solution.customData, key, false));
			customData[rootKey] = solution.customData[rootKey];

			nuitApi('production.solution.customdata', solution.id)
				.put(customData)
				.then(reloadDocuments)
				.catch(nuitUtils.showErrorToast);
		}

		function openShopOrder(shopOrder) {
			if (vm.config.ims.orders.v2.enabled && imsNextChannel.navigateTo('/production/orders/' + vm.order.id + '/shop/' + shopOrder.id)) {
				return;
			}

			var editable = true;

			angular.forEach(vm.config.ims.orders.readOnlyStatis, function (status) {
				editable = editable && status.toString() !== shopOrder.status;
			});

			editable = editable && !ConditionCheckService.matchesAll(vm.config.ims.orders.readOnlyConditions, shopOrder, false);

			var config = ShopOrderDetailsService.getDefaultDialogConfig();

			if (!editable) {
				config.positions = true; //true means read only
				config.products = true; //true means read only
			}

			config.prices.show = false;

			ShopOrderDetailsService.openById(shopOrder.id, config);
		}

		function getDocumentURL(documentObj) {
			if (documentObj && documentObj.url) {
				return buildUrl(documentObj.url);
			} else if (documentObj && documentObj.href) {
				return buildUrl(documentObj.href);
			} else {
				return "";
			}
		}

		function buildUrl(url) {
			return url + '?access-token=' + nuitAuth.getToken();
		}

		function reloadDetails() {
			reloadProductionStatus();
			reloadDocuments();
			reloadSolutions();
			reloadProducibility();
		}

		function reloadSolutions(recreate) {
			vm.solutionStatus = {updating: true};
			nuitDataService.replaceOneEntity(vm.solutionsByMachine, {});

			return ProductionOrderViewService.reloadSolutions(vm.order,recreate)
				.then(function (status) {
					vm.solutionStatus = status;

					if (!vm.solutionStatus.updating) {
						categorizeSolutions();
					}

					return vm.solutionPoll.process(
						status.updating,
						reloadSolutions,
						2500
					);
				})
				.catch(function () {
					return false;
				});
		}

		function recreateSolutions() {
			nuitUtils.showConfirmationDialog('PRODUCTION_ORDERS.CONFIRM_SOLUTION_RECREATION.TITLE', 'PRODUCTION_ORDERS.CONFIRM_SOLUTION_RECREATION.CONTENT')
				.then(function() {
					reloadSolutions(true)
						.then(function(){
							reloadSolutions()
								.then(function(){
									reloadProducibility();
								});
							reloadDocuments();
						});
				});
		}

		function reloadDocuments() {
			vm.documentStatus = {updating: true};

			return ProductionOrdersService.reloadDocuments(vm.order)
				.then(function (status) {
					vm.documentStatus = status;
					return vm.documentPoll.process(
						status.updating,
						reloadDocuments,
						2500
					);
				})
				.catch(function () {
					return false;
				});
		}

		function isShopOrderInProduction(shopOrder) {
			return OrderService.getStatusById(shopOrder.status).type === 'production';
		}

		function moveShopOrderToNextStatus(shopOrder) {
			if (isShopOrderInProduction(shopOrder)) {
				OrderService.moveToNextStatus(shopOrder);
			}
		}

		function formatPercentage(percentage) {
			return percentage.toLocaleString($translate.use(), {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}) + '%';
		}

		function resetOrderInProgress() {
			vm.orderProgessState = 'NONE';
		}

		function categorizeSolutions() {
			nuitDataService.replaceOneEntity(vm.solutionsByMachine, {});
			vm.machineCount = 0;

			for (var i = 0; i < vm.order.solutions.length; i++) {
				var solution = vm.order.solutions[i];

				if (!vm.solutionsByMachine.hasOwnProperty(solution.machineId)) {
					vm.solutionsByMachine[solution.machineId] = {
						machineId: solution.machineId,
						list: []
					};
					vm.machineCount++;
				}

				vm.solutionsByMachine[solution.machineId].list.push(solution);
			}
		}

		function expandErrors() {
			vm.expanded = !vm.expanded;
		}

		function getProductTranslation() {
			return $translate.instant('MATERIALS.ARTICLES_NAV') + ' (' + vm.products.length + ')';
		}

		function search(){
			$state.go('app.production-orders.details', {searchId: vm.searchId});
		}

		function hasPartId(parts){
			if($state.params.searchId && $state.params.searchId.length>0){
				for(var i=0;i<parts.length;i++) {
					if (parts[i].id.toString().startsWith($state.params.searchId)) {
						return true;
					}
				}
			} else{
				return true;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.factory('TransferService', TransferService);

	/** @ngInject */
	function TransferService(nuitApi, nuitApiProxy, nuitDataService) {
		var service = initService();
		service.tokens = {};

		return service;

		function initService() {
			return {
				remove: remove,
				isDefined: isDefined,
				save: save,
				getTransferFormat: getTransferFormat,
				sanitizeTransferFormat: sanitizeTransferFormat
			};
		}

		function remove(machineId, transfers,index)
		{
			nuitApiProxy('bendingmachine.transfer',machineId, transfers[index].id).delete()
				.then(function(){
					transfers.splice(index,1);
				});
		}

		function isDefined(value)
		{
			return typeof value !== 'undefined';
		}

		function save(machineId, transfer){
			if(transfer.id){
				return update(machineId, transfer);
			}else{
				return create(machineId, transfer);
			}
		}

		function update(machineId, transfer){
			return nuitApiProxy('bendingmachine.transfer', machineId, transfer.id).put(transfer)
				.then(function(response){
					nuitDataService.replaceOneEntity(transfer, response.data);
				});
		}

		function create(machineId, transfer){
			return nuitApiProxy('bendingmachine.transfer.add', machineId).post(transfer)
				.then(function(response){
					nuitDataService.replaceOneEntity(transfer, response.data);
				});
		}

		function getTransferFormat(type){
			switch (type) {
				case 'smb':
					return {type: 'smb', path: ''}; //name: '',
				case 'nusync':
					return {name: '', type: 'nusync', token: '', path: ''}; //name: '',
				default:
					return {name: '', type: 'ftp', host: '', path: '', user: '', pwd: ''}; //name: '',
			}
		}

		function sanitizeTransferFormat(transfer){
			var format = getTransferFormat(transfer.type);

			for(var key in transfer){
				if(key!=='id' && !format.hasOwnProperty(key)){
					delete transfer[key];
				}
			}

			return transfer;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.controller('PunchingMachineListController', PunchingMachineListController);

	/** @ngInject */
	function PunchingMachineListController($state, $mdDialog, $mdToast, $translate, PunchingMachineService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.punchingMachines = PunchingMachineService.getMachines();
		vm.loadingPunchingMachines = true;
		vm.selectedMachines = [];
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openMachine = openMachine;
		vm.isSelected = isSelected;
		vm.selectAll = selectAll;
		vm.deselectAll = deselectAll;
		vm.deleteSelected = deleteSelected;
		vm.toggleSelectedTemplate = toggleSelectedTemplate;
		vm.toggleSelectedTemplates = toggleSelectedTemplates;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorLoadingToast(translateKey) {
			return $mdToast
				.simple()
				.textContent($translate.instant(translateKey))
				.position('bottom right')
				.hideDelay(5000);
		}
		function createConfirmDeleteDialog() {
			return $mdDialog
				.confirm()
				.title($translate.instant('MACHINE.CONFIRM_DELETE_MACHINE'))
				.ok($translate.instant('APP.OK'))
				.cancel($translate.instant('APP.CANCEL'))
				.clickOutsideToClose(true);
		}

		function createErrorDeletingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_DELETING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createDeleteSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.DELETE_MACHINE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			// Reload all templates

			PunchingMachineService.reload()
				.catch(function () {
					$mdToast.show(createErrorLoadingToast('MACHINES.ERROR_LOADING_PUNCHING_MACHINES'));
				})
				.finally(function () {
					vm.loadingPunchingMachines = false;
				});
		}

		/**
		 * Selectes all elements.
		 */
		function selectAll() {
			deselectAll();

			angular.forEach(vm.punchingMachines, function (template) {
				vm.selectedMachines.push(template);
			});
		}

		/**
		 * Deselects all templates.
		 */
		function deselectAll() {
			vm.selectedMachines.splice(0, vm.selectedMachines.length);
		}

		/**
		 * Returns true if the given template is selected.
		 * @param {Object} templateId - id of the template to check
		 * @returns {Boolean} True, if template is currently selected
		 */
		function isSelected(templateId) {
			return vm.selectedMachines.indexOf(templateId) >= 0;
		}

		/**
		 * Toggles all templates off if at least one template is selected
		 * or selects all templates if none has been selected before.
		 * @returns {undefined}
		 */
		function toggleSelectedTemplates() {
			if (vm.selectedMachines.length > 0) {
				deselectAll();
			} else {
				selectAll();
			}
		}

		/**
		 * Toggles the selection of the given template.
		 * @param {String} id - id of the given template
		 * @param {Object} $event - event data
		 */
		function toggleSelectedTemplate(id, $event) {
			$event.stopPropagation();

			var position = vm.selectedMachines.indexOf(id);

			if (position >= 0) {
				vm.selectedMachines.splice(position, 1);
			} else {
				vm.selectedMachines.push(id);
			}
		}

		/**
		 * Opens the template with the given id.
		 * @param {String} machineId - id of the template
		 */
		function openMachine(machineId) {
			$state.go('app.production.machines.detail', {machineId: machineId}, {inherit: false});
		}

		/**
		 * Deletes all selected templates.
		 */
		function deleteSelected() {
			$mdDialog
				.show(createConfirmDeleteDialog())
				.then(function () {
					return angular.forEach(vm.selectedMachines, function (machine) {
						PunchingMachineService.deleteMachine(machine.id);
					});
				})
				.then(function () {
					$mdToast.show(createDeleteSuccessfullToast());
					deselectAll();
				})
				.catch(function (err) {
					if(err){
						$mdToast.show(createErrorDeletingMachineToast());
					}
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.controller('PunchingMachineDetailsController', PunchingMachineDetailsController);

	/** @ngInject */
	function PunchingMachineDetailsController($mdToast, $mdDialog, $translate, $stateParams, $state, nuitUtils, nuitConfig, nuitUnits, PunchingMachineService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.machine = {};
		vm.config = nuitConfig.getCurrent();
		vm.loading = true;
		vm.nuitUnits = nuitUnits;
		vm.brands = PunchingMachineService.brands;

		//*******************************************
		// METHODS EXPOSURE
		//*******************************************
		vm.save = save;
		vm.del = del;

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorLoadingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_LOADING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createErrorUpdatingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_UPDATING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createUpdateSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.UPDATE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createConfirmDeleteDialog() {
			return $mdDialog
				.confirm()
				.title($translate.instant('APP.CONFIRM_DELETE_TITLE'))
				.textContent($translate.instant('MACHINE.CONFIRM_DELETE_MACHINE'))
				.ok($translate.instant('APP.OK'))
				.cancel($translate.instant('APP.CANCEL'))
				.clickOutsideToClose(true);
		}

		function createErrorDeletingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_DELETING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createDeleteSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.DELETE_MACHINE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			PunchingMachineService.reloadBrands();
			PunchingMachineService
				.getById($stateParams.machineId)
				.then(function (machine) {
					vm.machine = machine;
				})
				.catch(function () {
					$mdToast.show(createErrorLoadingMachineToast());
				})
				.finally(function () {
					vm.loading = false;
				});
		}

		function save() {
			PunchingMachineService
				.updateMachine(vm.machine)
				.then(function (machine) {
					$mdToast.show(createUpdateSuccessfullToast());
					vm.machine = machine;
					vm.machineForm.$setPristine();
				})
				.catch(function () {
					$mdToast.show(createErrorUpdatingMachineToast());
				});
		}

		function del() {
			$mdDialog
				.show(createConfirmDeleteDialog())
				.then(function () {
					return PunchingMachineService.deleteMachine(vm.machine.id);
				})
				.then(function () {
					$mdToast.show(createDeleteSuccessfullToast());
					$state.go('app.machines');
				})
				.catch(function (err) {
					if(err){
						$mdToast.show(createErrorDeletingMachineToast());
					}
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.controller('CoilMachineListController', CoilMachineListController);

	/** @ngInject */
	function CoilMachineListController($state, $mdDialog, $mdToast, $translate, CoilMachineService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.coilMachines = CoilMachineService.getMachines();
		vm.loadingCoilMachines = true;

		vm.selectedMachines = [];
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openMachine = openMachine;
		vm.isSelected = isSelected;
		vm.selectAll = selectAll;
		vm.deselectAll = deselectAll;
		vm.deleteSelected = deleteSelected;
		vm.toggleSelectedTemplate = toggleSelectedTemplate;
		vm.toggleSelectedTemplates = toggleSelectedTemplates;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorLoadingToast(translateKey) {
			return $mdToast
				.simple()
				.textContent($translate.instant(translateKey))
				.position('bottom right')
				.hideDelay(5000);
		}
		function createConfirmDeleteDialog() {
			return $mdDialog
				.confirm()
				.title($translate.instant('MACHINE.CONFIRM_DELETE_MACHINE'))
				.ok($translate.instant('APP.OK'))
				.cancel($translate.instant('APP.CANCEL'))
				.clickOutsideToClose(true);
		}

		function createErrorDeletingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_DELETING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createDeleteSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.DELETE_MACHINE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			// Reload all templates

			CoilMachineService.reload()
				.catch(function () {
					$mdToast.show(createErrorLoadingToast('MACHINES.ERROR_LOADING_COIL_MACHINES'));
				})
				.finally(function () {
					vm.loadingCoilMachines = false;
				});
		}

		/**
		 * Selectes all elements.
		 */
		function selectAll() {
			deselectAll();

			angular.forEach(vm.coilMachines, function (template) {
				vm.selectedMachines.push(template);
			});
		}

		/**
		 * Deselects all templates.
		 */
		function deselectAll() {
			vm.selectedMachines.splice(0, vm.selectedMachines.length);
		}

		/**
		 * Returns true if the given template is selected.
		 * @param {Object} templateId - id of the template to check
		 * @returns {Boolean} True, if template is currently selected
		 */
		function isSelected(templateId) {
			return vm.selectedMachines.indexOf(templateId) >= 0;
		}

		/**
		 * Toggles all templates off if at least one template is selected
		 * or selects all templates if none has been selected before.
		 * @returns {undefined}
		 */
		function toggleSelectedTemplates() {
			if (vm.selectedMachines.length > 0) {
				deselectAll();
			} else {
				selectAll();
			}
		}

		/**
		 * Toggles the selection of the given template.
		 * @param {String} id - id of the given template
		 * @param {Object} $event - event data
		 */
		function toggleSelectedTemplate(id, $event) {
			$event.stopPropagation();

			var position = vm.selectedMachines.indexOf(id);

			if (position >= 0) {
				vm.selectedMachines.splice(position, 1);
			} else {
				vm.selectedMachines.push(id);
			}
		}

		/**
		 * Opens the template with the given id.
		 * @param {String} machineId - id of the template
		 */
		function openMachine(machineId) {
			$state.go('app.production.machines.detail', {machineId: machineId}, {inherit: false});
		}

		/**
		 * Deletes all selected templates.
		 */
		function deleteSelected() {
			$mdDialog
				.show(createConfirmDeleteDialog())
				.then(function () {
					return angular.forEach(vm.selectedMachines, function (machine) {
						CoilMachineService.deleteMachine(machine.id);
					});
				})
				.then(function () {
					$mdToast.show(createDeleteSuccessfullToast());
					deselectAll();
				})
				.catch(function (err) {
					if(err){
						$mdToast.show(createErrorDeletingMachineToast());
					}
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.controller('CoilMachineDetailsController', CoilMachineDetailsController);

	/** @ngInject */
	function CoilMachineDetailsController($mdToast, $mdDialog, $translate, $stateParams, $state, nuitApi, nuitApiProxy, nuitUtils, nuitConfig, nuitUnits, CoilMachineService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.machine = {};
		vm.config = nuitConfig.getCurrent();
		vm.loading = true;
		vm.nuitUnits = nuitUnits;
		vm.brands = CoilMachineService.brands;
		vm.cutModes = CoilMachineService.cutModes;
		vm.blankOptions = CoilMachineService.blankOptions;
		vm.nuSyncToken = '';
		vm.loadingNuSyncToken = false;

		//*******************************************
		// METHODS EXPOSURE
		//*******************************************
		vm.save = save;
		vm.del = del;
		vm.deleteJobs = deleteJobs;
		vm.updateConnectionType = updateConnectionType;

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorLoadingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_LOADING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createErrorUpdatingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_UPDATING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createUpdateSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.UPDATE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createConfirmDeleteDialog() {
			return $mdDialog
				.confirm()
				.title($translate.instant('APP.CONFIRM_DELETE_TITLE'))
				.textContent($translate.instant('MACHINE.CONFIRM_DELETE_MACHINE'))
				.ok($translate.instant('APP.OK'))
				.cancel($translate.instant('APP.CANCEL'))
				.clickOutsideToClose(true);
		}

		function createErrorDeletingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_DELETING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createDeleteSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.DELETE_MACHINE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			CoilMachineService
				.getById($stateParams.machineId)
				.then(function (machine) {
					vm.machine = machine;
					updateConnectionType();
				})
				.catch(function () {
					$mdToast.show(createErrorLoadingMachineToast());
				})
				.finally(function () {
					vm.loading = false;
				});

			CoilMachineService.getBrands();
			CoilMachineService.getCutModes();
		}

		function save() {
			CoilMachineService
				.updateMachine(vm.machine)
				.then(function (machine) {
					$mdToast.show(createUpdateSuccessfullToast());
					vm.machine = machine;
					vm.machineForm.$setPristine();
					updateConnectionType();
				})
				.catch(function () {
					$mdToast.show(createErrorUpdatingMachineToast());
				});
		}

		function del() {
			$mdDialog
				.show(createConfirmDeleteDialog())
				.then(function () {
					return CoilMachineService.deleteMachine(vm.machine.id);
				})
				.then(function () {
					$mdToast.show(createDeleteSuccessfullToast());
					$state.go('app.machines')
				})
				.catch(function (err) {
					if(err){
						$mdToast.show(createErrorDeletingMachineToast());
					}
				});
		}

		function deleteJobs()
		{
			nuitUtils.showDeleteMultiConfirm()
				.then(function(){
					CoilMachineService.deleteJobs(vm.machine.id);
				});
		}

		function updateConnectionType(){
			if(!vm.machine.connection.type){
				vm.machine.connection.type=null;
			}

			switch(vm.machine.connection.type){
				case '':
				case null:
					//delete vm.machine.connection.host;
					//delete vm.machine.connection.user;
					//delete vm.machine.connection.pwd;
					vm.nuSyncToken = '';
					break;
				case 'nusync':
					loadNuSyncToken();
					break;
			}
		}

		function loadNuSyncToken(){
			vm.loadingNuSyncToken = true;
			nuitApiProxy('coilmachine.nusync.token',vm.machine.id)
				.get()
				.then(function(response){
					if(response.data && response.data.token){
						vm.nuSyncToken = response.data.token;
					}else{
						vm.nuSyncToken = '';
					}
				})
				.catch(function(error){
					vm.nuSyncToken = '';
				})
				.finally(function(){
					vm.loadingNuSyncToken = false;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.controller('BendingMachineListController', BendingMachineListController);

	/** @ngInject */
	function BendingMachineListController($state, $mdDialog, $mdToast, $translate, BendingMachineService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.bendingMachines = BendingMachineService.getMachines();
		vm.brands = BendingMachineService.brands;
		vm.loadingBendingMachines = true;

		vm.selectedMachines = [];
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openMachine = openMachine;
		vm.isSelected = isSelected;
		vm.selectAll = selectAll;
		vm.deselectAll = deselectAll;
		vm.deleteSelected = deleteSelected;
		vm.toggleSelectedTemplate = toggleSelectedTemplate;
		vm.toggleSelectedTemplates = toggleSelectedTemplates;
		vm.openTwinDebug = openTwinDebug;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorLoadingToast(translateKey) {
			return $mdToast
				.simple()
				.textContent($translate.instant(translateKey))
				.position('bottom right')
				.hideDelay(5000);
		}
		function createConfirmDeleteDialog() {
			return $mdDialog
				.confirm()
				.title($translate.instant('MACHINE.CONFIRM_DELETE_MACHINE'))
				.ok($translate.instant('APP.OK'))
				.cancel($translate.instant('APP.CANCEL'))
				.clickOutsideToClose(true);
		}

		function createErrorDeletingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_DELETING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createDeleteSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.DELETE_MACHINE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			// Reload all templates
			BendingMachineService.reload()
				.catch(function () {
					$mdToast.show(createErrorLoadingToast('MACHINES.ERROR_LOADING_BENDING_MACHINES'));
				})
				.finally(function () {
					vm.loadingBendingMachines = false;
				});

			BendingMachineService.reloadBrands();

		}

		/**
		 * Selectes all elements.
		 */
		function selectAll() {
			vm.deselectAll();
			angular.forEach(vm.bendingMachines, function(template) {
				vm.selectedMachines.push(template);
			});
		}

		/**
		 * Deselects all templates.
		 */
		function deselectAll() {
			vm.selectedMachines.splice(0, vm.selectedMachines.length);
		}

		/**
		 * Returns true if the given template is selected.
		 * @param {Object} templateId - id of the template to check
		 * @returns {Boolean} True, if template is currently selected
		 */
		function isSelected(templateId) {
			return vm.selectedMachines.indexOf(templateId) >= 0;
		}

		/**
		 * Toggles all templates off if at least one template is selected
		 * or selects all templates if none has been selected before.
		 * @returns {undefined}
		 */
		function toggleSelectedTemplates() {
			if (vm.selectedMachines.length > 0) {
				vm.deselectAll();
			} else {
				vm.selectAll();
			}
		}

		/**
		 * Toggles the selection of the given template.
		 * @param {String} id - id of the given template
		 * @param {Object} $event - event data
		 */
		function toggleSelectedTemplate(id, $event) {
			$event.stopPropagation();

			var position = vm.selectedMachines.indexOf(id);

			if (position >= 0) {
				vm.selectedMachines.splice(position, 1);
			} else {
				vm.selectedMachines.push(id);
			}
		}

		/**
		 * Opens the template with the given id.
		 * @param {String} machineId - id of the template
		 */
		function openMachine(machineId) {
			$state.go('app.production.machines.detail', {machineId: machineId}, {inherit: false});
		}

		/**
		 * POC: opens the embedded machineui (nuLink Twin) in a dialog.
		 * @param {Object} $event
		 */
		function openTwinDebug($event) {
			$mdDialog.show({
				controller: 'TwinDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/production.machines/dialogs/twin/twin.html',
				targetEvent: $event,
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				escapeToClose: false
			});
		}

		/**
		 * Deletes all selected templates.
		 */
		function deleteSelected() {
			$mdDialog
				.show(createConfirmDeleteDialog())
				.then(function () {
					return angular.forEach(vm.selectedMachines, function (machine) {
						BendingMachineService.deleteMachine(machine.id);
					});
				})
				.then(function () {
					$mdToast.show(createDeleteSuccessfullToast());
					deselectAll();
				})
				.catch(function (err) {
					if(err){
						$mdToast.show(createErrorDeletingMachineToast());
					}
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.controller('BendingMachineDetailsController', BendingMachineDetailsController);

	/** @ngInject */
	function BendingMachineDetailsController(nuitApi, nuitApiProxy, $mdToast, $mdDialog, $translate, $stateParams, $state, BendingMachineService, TransferService, nuitDataService, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.machine = {};
		vm.brands = BendingMachineService.brands;
		vm.sizingModes = BendingMachineService.sizingModes;
		vm.loading = true;
		vm.transferService = TransferService;
		//*******************************************
		// METHODS EXPOSURE
		//*******************************************
		vm.save = save;
		vm.del = del;
		vm.addTransfer = addTransfer;
		vm.removeTransfer = removeTransfer;
		vm.openTransferDialog = openTransferDialog;
		//*******************************************
		// INITIALIZE
		//*******************************************
		init();

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorLoadingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_LOADING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createErrorUpdatingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_UPDATING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createUpdateSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.UPDATE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createConfirmDeleteDialog() {
			return $mdDialog
				.confirm()
				.title($translate.instant('MACHINE.CONFIRM_DELETE_MACHINE'))
				.ok($translate.instant('APP.OK'))
				.cancel($translate.instant('APP.CANCEL'))
				.clickOutsideToClose(true);
		}

		function createErrorDeletingMachineToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.ERROR_DELETING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createDeleteSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINE.DELETE_MACHINE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			BendingMachineService
				.getById($stateParams.machineId)
				.then(function (machine) {
					vm.machine = machine;

					if (vm.machine.transfers === undefined || vm.machine.transfers === null) {
						vm.machine['transfers'] = [];
					}
				})
				.catch(function () {
					$mdToast.show(createErrorLoadingMachineToast());
				})
				.finally(function () {
					vm.loading = false;
				});

			BendingMachineService.reloadBrands();
		}

		function save() {
			BendingMachineService
				.updateMachine(vm.machine)
				.then(function (machine) {
					$mdToast.show(createUpdateSuccessfullToast());
					vm.machine = machine;
					vm.machineForm.$setPristine();
				})
				.catch(function () {
					$mdToast.show(createErrorUpdatingMachineToast());
				});
		}

		function del() {
			$mdDialog
				.show(createConfirmDeleteDialog())
				.then(function () {
					return BendingMachineService.deleteMachine(vm.machine.id);
				})
				.then(function () {
					$mdToast.show(createDeleteSuccessfullToast());
					$state.go('app.machines');
				})
				.catch(function (err) {
					if (err) {
						$mdToast.show(createErrorDeletingMachineToast());
					}
				});
		}

		function addTransfer(type) {
			var transfer = TransferService.getTransferFormat(type);

			switch (type) {
				case 'nusync':
					nuitApiProxy('machines.nusync.token', vm.machine.id)
						.get()
						.then(function (response) {
							transfer.token = response.data.token;
							openTransferDialog(transfer);
						});
					break;
				default:
					openTransferDialog(transfer);
					break;
			}
		}

		function removeTransfer(index) {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					vm.transferService.remove(vm.machine.id, vm.machine.transfers, index);
				});
		}

		function openTransferDialog(transfer) {
			$mdDialog.show({
				controller: 'TransferDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/production.machines/dialogs/category/transfer.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Transfer: angular.copy(transfer)
				}
			})
				.then(function (newTransfer) {
					vm.transferService.save(vm.machine.id, newTransfer);
					nuitDataService.upsertOne(vm.machine.transfers, newTransfer);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.controller('AddPunchingMachineController', AddPunchingMachineController);

	/** @ngInject */
	function AddPunchingMachineController($state, $mdToast, $translate, nuitUnits, PunchingMachineService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.machine = {};
		vm.machine.enabled = false;
		vm.machine.manualMachine = false;
		vm.nuitUnits = nuitUnits;
		vm.brands = PunchingMachineService.brands;
        //*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.save = save;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		init();

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorLoadingToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINES.ERROR_ADDING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createInvalidFormToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINES.INVALID_FORM'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createAddSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINES.ADD_MACHINE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Saves the current template and returns to the documents overview.
         */
		function init() {
			PunchingMachineService.reloadBrands();
		}

		function save() {
			if(vm.machineForm.$invalid){
				return $mdToast.show(createInvalidFormToast());
			}

			PunchingMachineService.addMachine(vm.machine)
				.then(function () {
					$mdToast.show(createAddSuccessfullToast());
					$state.go('app.machines.punching');
				})
				.catch(function () {
					$mdToast.show(createErrorLoadingToast());
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.controller('AddCoilMachineController', AddCoilMachineController);

	/** @ngInject */
	function AddCoilMachineController($state, $mdToast, $translate, nuitUnits, CoilMachineService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.machine = {};
		vm.machine.enabled = false;
		vm.machine.manualWork = false;
		vm.nuitUnits = nuitUnits;
		vm.brands = CoilMachineService.brands;
		vm.cutModes = CoilMachineService.cutModes;
		vm.blankOptions = CoilMachineService.blankOptions;
        //*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.save = save;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		init();

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorLoadingToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINES.ERROR_ADDING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createInvalidFormToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINES.INVALID_FORM'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createAddSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINES.ADD_MACHINE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Saves the current template and returns to the documents overview.
         */
		function init() {
			CoilMachineService.getBrands();
			CoilMachineService.getCutModes();
		}

		function save() {
			if(vm.machineForm.$invalid){
				return $mdToast.show(createInvalidFormToast());
			}

			CoilMachineService.addMachine(vm.machine)
				.then(function () {
					$mdToast.show(createAddSuccessfullToast());
					$state.go('app.machines.coil');
				})
				.catch(function () {
					$mdToast.show(createErrorLoadingToast());
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.controller('AddBendingMachineController', AddBendingMachineController);

	/** @ngInject */
	function AddBendingMachineController($state, $mdToast, $translate, BendingMachineService, TransferService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.machine = {};
		vm.machine.transfers = [];
		vm.brands = BendingMachineService.brands;
		vm.transferService = TransferService;
        //*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.save = save;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorLoadingToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINES.ERROR_ADDING_MACHINE'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createInvalidFormToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINES.INVALID_FORM'))
				.position('bottom right')
				.hideDelay(5000);
		}

		function createAddSuccessfullToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('MACHINES.ADD_MACHINE_SUCCESSFULL'))
				.position('bottom right')
				.hideDelay(5000);
		}

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Saves the current template and returns to the documents overview.
         */
		function init() {
			BendingMachineService.reloadBrands();
		}

		function save() {
			if(vm.machineForm.$invalid){
				return $mdToast.show(createInvalidFormToast());
			}

			BendingMachineService.addMachine(vm.machine)
				.then(function () {
					$mdToast.show(createAddSuccessfullToast());
					$state.go('app.machines.bending');
				})
				.catch(function () {
					$mdToast.show(createErrorLoadingToast());
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.factory('PostalCodeDelayService', PostalCodeDelayService);

	/** @ngInject */
	function PostalCodeDelayService(nuitApi, $log, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _postalCodeDelays = [] ;
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			addDelay: addDelay,
			updateDelay: updateDelay,
			deleteDelay: deleteDelay,
		};

		Object.defineProperty(service, 'postalCodeDelays', {
			get: function () {
				return _postalCodeDelays;
			}
		});

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function reload() {
			return nuitApi('postalcodedelays')
				.get()
				.then(function (response) {
					nuitDataService.replaceAll(_postalCodeDelays, response.data);
					return _postalCodeDelays;
				})
				.catch(function (error) {
					$log.error('Error loading postal code delay');
					throw error;
				});
		}


		function addDelay(delay) {
			return nuitApi('postalcodedelays')
				.post(delay)
				.then(function (response) {
					console.log(response);
					nuitDataService.addOne(_postalCodeDelays, response.data);
					return _postalCodeDelays;
				});
		}

		function updateDelay(delay) {
			return nuitApi('postalcodedelays.one', delay.id)
				.put(delay)
				.then(function (response) {
					return nuitDataService.updateOneEntity(delay, response.data);
				});

		}

		function deleteDelay(id) {
			return nuitApi('postalcodedelays.one', id)
				.delete()
				.then(function (response) {
					nuitDataService.removeOneByKeys(_postalCodeDelays, {id: id});
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.general')
		.factory('ForwarderService', ForwarderService);

	/** @ngInject */
	function ForwarderService($log, $mdDialog, RoleService, nuitUtils, nuitApi, nuitDataService) {

		var _forwarders = [];

		var service = initService();

		Object.defineProperty(service, 'forwarders', {
			get: function () {
				return _forwarders;
			}
		});

		return service;

		function initService() {
			return {
				add: add,
				reload: reload,
				getById: getById,
				getByUserId: getByUserId,
				getOneById: getOneById,
				getByIdOffline: getByIdOffline,
				update: update,
				del: del,
				addPerson: addPerson,
				updatePerson: updatePerson,
				delPerson: delPerson,
				getAllOffline: getAllOffline,
				getRoleName: getRoleName,
				searchPerson: searchPerson,
				addAddress: addAddress,
				editAddress: editAddress,
				deleteAddress: deleteAddress,
				setAutoNotification: setAutoNotification
			};
		}



		function getAllOffline() {
			return _forwarders;
		}

		function reload(params) {

			return RoleService.reload()
				.then(function () {
					return nuitApi('forwarders')
						.get(params)
						.then(function (response) {
							return nuitDataService.replaceAll(_forwarders, response.data);
						})
						.catch(function (error) {
							$log.error('Failed to load forwarders!');
							throw error;
						});
				});
		}

		function getById(id) {
			var forwarder = getByIdOffline(id);

			return nuitApi('forwarders.one', id).get()
				.then(function (response) {
					if (!response.data.hasOwnProperty('users')) {
						response.data.users = [];
					}
					if(!response.data.hasOwnProperty('addresses') || response.data.addresses===null){
						response.data.addresses = [];
					}
					if(!response.data.hasOwnProperty('deliveryAddresses') || response.data.deliveryAddresses===null){
						response.data.deliveryAddresses = [];
					}
					return nuitDataService.upsertOne(_forwarders, response.data);
				}).catch(function (e) {
					e.data = id;
					throw e;
				});
		}

		function getByIdOffline(id) {
			return nuitDataService.getOne(_forwarders, parseInt(id, 10));
		}

		function getOneById(id) {
			return nuitApi('forwarders.one', id).get()
				.then (function (response) {
					return response.data;
				});
		}

		function add(forwarder) {
			return nuitApi('forwarders.add')
				.post(forwarder)
				.then(function (response) {
					return nuitDataService.addOne(_forwarders, response.data);
				});
		}

		function update(id, forwarder) {
			return nuitApi('forwarders.one', id)
				.put(forwarder)
				.then(function (response) {
					return nuitDataService.updateOneEntity(forwarder, response.data);
				});
		}

		function del(id) {
			return nuitApi('forwarders.one', id)
				.delete()
				.then(function (response) {
					nuitDataService.removeOneByKeys(_forwarders, {id: id});
				});
		}

		function addPerson(companyId, person) {
			if(!person.notification){
				person.notification = {};
				person.notification.email = false;
				person.notification.sms = false;
			}
			return nuitApi('forwarders.users', companyId)
				.post(person)
				.then(function (response) {
					return nuitDataService.addOne(getByIdOffline(companyId).users, response.data);
				});
		}

		function updatePerson(forwarderId, personId, person) {
			return nuitApi('users.one', personId)
				.put(person)
				.then(function (response) {
					return nuitDataService.updateOne(getByIdOffline(forwarderId).users, response.data);
				});
		}

		function delPerson(forwarderId, personId) {
			return nuitApi('forwarders.users.one', forwarderId, personId)
				.delete()
				.then(function (response) {
					nuitDataService.removeOneByKeys(getByIdOffline(forwarderId).users, {id: personId});
				});
		}

		function getRoleName(person) {
			var role = RoleService.getRoleById(person.roleId);
			if (role) {
				return role.name;
			} else {
				return '';
			}
		}


		function searchPerson(person, limit) {
			var params = {};

			params['userSearch'] = person;
			params['limit'] = limit;

			return nuitApi('forwarders')
				.get(params)
				.then(function (response) {
					for (var i = 0; i < response.data.length; i++) {
						var forwarder = response.data[i];
						forwarder._partial = false;
						nuitDataService.upsertOne(_forwarders, forwarder);
					}

					return _forwarders;
				});
		}

		function addAddress(forwarder,type){
			return getAddress(null,type)
				.then(function(address){
					console.log(address);
					return nuitApi('forwarders.addresses', forwarder.id)
						.post(address)
						.then(function(response){
							forwarder[type].push(response.data);
						});
				});
		}

		function editAddress(forwarder,address,type){
			return getAddress(address, type)
				.then(function(newAddress){
					return nuitApi('forwarders.addresses.one',forwarder.id, address.id)
						.put(newAddress)
						.then(function(response){
							var addresses = angular.copy(forwarder[type]);
							nuitDataService.replaceOne(addresses,response.data);
							nuitDataService.replaceAll(forwarder[type],addresses);
						});
				});
		}

		function deleteAddress(forwarder,addressId,type){
			nuitUtils.showDeleteConfirmation()
				.then(function(){
					return nuitApi('forwarders.addresses.one',forwarder.id, addressId)
						.delete()
						.then(function(){
							nuitDataService.removeOne(forwarder[type],addressId);
						});
				});
		}

		function getAddress(address, type) {
			return $mdDialog.show(
				{
					controller: 'NewAddressController',
					controllerAs: 'vm',
					templateUrl: 'app/main/partners.general/dialogs/new-address/new-address.html',
					clickOutsideToClose: true,
					locals: {
						address: address,
						type: type
					}
				}
			)
				.then(function(address){
					return address;
				});
		}

		function getByUserId() {
			return nuitApi('forwarders')
				.get({})
				.then(function (response) {
					return nuitDataService.replaceAll(_forwarders, response.data);
				})
				.catch(function (error) {
					$log.error('Failed to load forwarders!');
					throw error;
				});
		}

		function setAutoNotification (carrierId, userId, notification) {
			return nuitApi('forwarders.users.notification', carrierId, userId)
				.put(notification)
				.then(function (res) {
					console.log(res);
					return res;
				})
				.catch(function () {

				});
		}

	}
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.service('DeliveryBoardService', DeliveryBoardService);

	/** @ngInject */
	function DeliveryBoardService($filter, DeliveryService, DeliveryWorkdayService, nuitDataService, OrderService, nuitConfig, ForwarderService, $q, CompanyService, AddressWrapperService) {

		var DATE_OFFSET_START = 60 * 86400;
		var DATE_OFFSET_LAST = 60 * 86400;
		var config = nuitConfig.current;
		var validWorkDays = DeliveryWorkdayService.deliveryWorkDays;
		var statusFields = DeliveryService.statusFields;
		var STATUS = '2,3,4';
		var _order = {};

		var _deliveries = [];
		var _preparedDeliveries = [];
		var _groupedDeliveries = {};
		var _companyAddresses = {};
		var _companiesToLoad = {};

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			incrementStatusAndReload: incrementStatusAndReload
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'groupedDeliveries', {
			get: function () {
				return _groupedDeliveries;
			}
		});

		var DELIVERY_TYPES = {
			DELIVERY: 'DELIVERY',
			PICKUP: 'PICKUP'
		};

		service.DELIVERY_TYPES = DELIVERY_TYPES;

		return service;

		//*******************************************
		// METHODS
		//*******************************************
		function reload(startDate, endDate, carrierId) {
			return DeliveryWorkdayService.loadDay()
				.then(function () {
					return DeliveryService.reloadStatus()
						.then(function () {
							nuitDataService.replaceAll(_deliveries, []);
							nuitDataService.replaceOneEntity(_groupedDeliveries, {});
							return DeliveryService.reload(startDate, endDate, STATUS, carrierId)
								.then(function (deliveries) {
									nuitDataService.replaceAll(_deliveries, angular.copy(deliveries));
									//return DeliveryService.reload(firstDay - DATE_OFFSET_START, lastDay + DATE_OFFSET_LAST, STATUS, carrierId)
									//.then(function (deliveries) {
									//	for (var i = 0; i < deliveries.length; i++) {
									//		nuitDataService.upsertOne(_deliveries, angular.copy(deliveries[i]));
									//	}
									return sanitizeDeliveries()
										.then(function () {
											return groupByDate()
												.then(function () {
													return _groupedDeliveries;
												});
										});
								});
							//});
						});
				});
		}

		function sanitizeDeliveries() {
			_companiesToLoad = {};
			nuitDataService.replaceAll(_preparedDeliveries, angular.copy(_deliveries));
			var forwarders = ForwarderService.forwarders;
			return ForwarderService.reload().then(function () {
				for (var i = 0; i < _preparedDeliveries.length; i++) {
					var delivery = angular.copy(_preparedDeliveries[i]);
					var carrier = '';
					var now = new Date();
					now.setHours(0, 0, 0, 0);
					var slotDate = new Date(delivery.shippingDate * 1000);
					var deliveryType = DELIVERY_TYPES.DELIVERY;
					var dueDate = new Date(delivery.deliveryDate * 1000);
					var isPickedup = delivery.pickedupDate > 0 || delivery.pickedupDate !== null;
					var overdueDays = null;
					if (delivery.deliveryType === 1) {
						deliveryType = DELIVERY_TYPES.PICKUP;
						slotDate = new Date(delivery.deliveryDate * 1000);

						if(!_companiesToLoad.hasOwnProperty(delivery.companyId)){
							_companiesToLoad[delivery.companyId] = [];
						}

						_companiesToLoad[delivery.companyId].push(delivery.id);
					}
					dueDate.setHours(0, 0, 0, 0);
					slotDate.setHours(0, 0, 0, 0);

					if (isPickedup) {
						slotDate = new Date(delivery.pickedupDate * 1000);
						slotDate.setHours(0, 0, 0, 0);
					} else {
						if (now >= dueDate) {
							slotDate = now;
							overdueDays = parseInt(slotDate / 1000 / 60 / 60 / 24) - parseInt(dueDate / 1000 / 60 / 60 / 24);
						}
						if (now >= slotDate) {
							slotDate = now;
						}
					}

					for (var x = 0; x < forwarders.length; x++) {
						if (forwarders[x].id === delivery.carrierId) {
							carrier = forwarders[x].name;
						}
					}
					var statusType = '';
					for (var y = 0; y < statusFields.length; y++) {
						if (delivery.status === statusFields[y].id) {
							statusType = statusFields[y].type.toUpperCase();
						}
					}
					slotDate = setToWorkDay(slotDate);

					nuitDataService.replaceOne(
						_preparedDeliveries,
						{
							id: delivery.id,
							number: delivery.number,
							status: delivery.status,
							statusType: statusType,
							shippingDate: delivery.shippingDate,
							deliveryDate: delivery.deliveryDate,
							deliveryType: deliveryType,
							carrier: carrier,
							carrierId: delivery.carrierId,
							overdueDays: overdueDays,
							//weight: _order.sales.weight,
							orderId: delivery.orderId,
							orderNumber: delivery.orderNumber,
							dimension: delivery.dimension,
							packageUnits: delivery.packageUnits,
							address: delivery.shippingAddress,
							name: delivery.name,
							slotDateFormatted: $filter('nuitDatetime')(slotDate.getTime() / 1000, 'date')
						}
					);
				}

				var promises = [];

				for(var key in _companiesToLoad){
						promises.push(
							getCompanyAddress(parseInt(key))
								.then(function (data) {
									if (data) {
										for (var i = 0; i < data.keys.length; i++) {
											var copy = angular.copy(nuitDataService.getOne(_preparedDeliveries, data.keys[i]));
											copy.address = AddressWrapperService.companyToOrder(data.address);
											nuitDataService.replaceOne(_preparedDeliveries, copy);
										}
									}
									return;
								})
						);
				}

				return $q.all(promises);
			});
		}

		function getCompanyAddress(companyId) {
			if(_companyAddresses.hasOwnProperty(companyId)){
				return $q.resolve({address:_companyAddresses[companyId],keys:_companiesToLoad[companyId]});
			}else{
				return CompanyService.getById(companyId)
					.then(function (company) {
						if(company) {
							_companyAddresses[companyId] = nuitDataService.getOne(company.addresses, company.addressId);
							return {address: _companyAddresses[companyId], keys: _companiesToLoad[companyId]};
						}else{
							return;
						}
					});

			}


		}



		function setToWorkDay(date) {

			var workDay = date.getDay();

			if (validWorkDays.includes(workDay)) {
				return date;
			} else {
				var next = -1;
				var prev = -1;

				for (var day = 6; day >= 0; day--) {
					if (validWorkDays.includes(day)) {
						var newDate = new Date(date.getTime());
						newDate.setDate(date.getDate() - workDay + day);

						if (newDate.getTime() > date.getTime()) {
							next = newDate.getTime();
						} else if (prev < newDate.getTime()) {
							prev = newDate.getTime();
						}
					}
				}

				if (next !== -1 && prev !== -1) {
					var diffPrev = Math.abs(date.getTime() - prev);
					var diffNext = Math.abs(date.getTime() - next);

					if (diffNext <= diffPrev) {
						return new Date(next);
					} else {
						return new Date(prev);
					}

				} else if (next !== -1) {
					return new Date(next);
				} else if (prev !== -1) {
					return new Date(prev);
				}
			}

			return date;
		}


		function groupByDate() {
			var promises = [];
			for (var i = 0; i < _preparedDeliveries.length; i++) {
				var delivery = _preparedDeliveries[i];


				if (typeof _groupedDeliveries[delivery.slotDateFormatted] === 'undefined') {
					_groupedDeliveries[delivery.slotDateFormatted] = [];
				}

				promises.push(_groupedDeliveries[delivery.slotDateFormatted].push(delivery));
			}
			return $q.all(promises);
		}

		function getOrder(id) {
			OrderService.loadOrder()
				.then(function (order) {
					_order = order;
				});
		}

		function incrementStatusAndReload(deliveries, statusID, pickedUp) {
			var promises = [];
			for (var i = 0; i < deliveries.length; i++) {
				var delivery = deliveries[i];
				promises.push(
					DeliveryService.incrementStatusForBoard(delivery, statusID, pickedUp)
						.then(function (delivery) {
							nuitDataService.replaceOne(_deliveries, delivery);
							nuitDataService.replaceOneEntity(_groupedDeliveries, {});
						})
				);
			}
			return $q.all(promises)
				.then(function () {
					return sanitizeDeliveries()
						.then(function () {
							return groupByDate()
								.then(function () {
									return _groupedDeliveries;
								});
						});

				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.factory('DeliveryService', DeliveryService);

	/** @ngInject */
	function DeliveryService(nuitApi, $log, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _deliveries = [] ;
		var _deliveriesPerCarrier = [];
		var _statusFields = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			addDelivery: addDelivery,
			updateDelivery: updateDelivery,
			deleteDelivery: deleteDelivery,
			loadOne: loadOne,
			loadCarrierDeliveries: loadCarrierDeliveries,
			incrementStatus: incrementStatus,
			incrementOneStatus: incrementOneStatus,
			incrementStatusForBoard: incrementStatusForBoard,
			reloadStatus: reloadStatus,
			updatePickedUpDate: updatePickedUpDate,
			updateOnePickedUpDate: updateOnePickedUpDate

		};

		Object.defineProperty(service, 'deliveries', {
			get: function () {
				return _deliveries;
			}
		});

		Object.defineProperty(service, 'deliveriesPerCarrier', {
			get: function () {
				return _deliveriesPerCarrier;
			}
		});

		Object.defineProperty(service, 'statusFields', {
			get: function () {
				return _statusFields;
			}
		});

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function reload(firstDay, lastDay, status, carrierId) {
			return nuitApi('deliveries')
				.get({
					start: firstDay,
					end: lastDay,
					status: status,
					carrier: carrierId

				})
				.then(function (response) {
					nuitDataService.replaceAll(_deliveries, response.data);
					return _deliveries;
				})
				.catch(function (error) {
					$log.error('Error loading deliveries');
					throw error;
				});
		}


		function addDelivery(delivery, orderId) {
			console.log(delivery);
			console.log(orderId);

			return nuitApi('deliveries')
				.post(delivery, {order: orderId})
				.then(function (response) {
					nuitDataService.addOne(_deliveries, response.data);
					return response.data;
				});

		}

		function updateDelivery(delivery, params) {
			return nuitApi('deliveries.one', delivery.id)
				.put(delivery, params)
				.then(function (response) {
					 nuitDataService.updateOneEntity(delivery, response.data);
					 return response.data;

				});

		}

		function deleteDelivery(id) {
			return nuitApi('deliveries.one', id)
				.delete()
				.then(function (response) {
					nuitDataService.removeOneByKeys(_deliveries, {id: id});
				});
		}

		function loadOne(id, order) {

			return nuitApi('deliveries.one', id)
				.get({order: order})
				.then(function (response) {
					return response.data;
				});
		}

		function loadCarrierDeliveries(carrierId) {
			return nuitApi('deliveries')
				.get({carrier:  carrierId})
				.then(function (response) {
					nuitDataService.replaceAll(_deliveriesPerCarrier, response.data);
					return _deliveriesPerCarrier;
				});
		}

		function incrementStatus(delivery, statusID) {
			return nuitApi('deliveries.one', delivery.id).patch({status: statusID})
				.then(function (response) {
					return nuitDataService.replaceOne(_deliveries, response.data);
				});
		}
		function incrementOneStatus(delivery, statusID) {
			return nuitApi('deliveries.one', delivery.id).patch({status: statusID})
				.then(function (response) {
					return response.data.status;
				});
		}
		function incrementStatusForBoard(delivery, statusID, pickedUp) {
			return nuitApi('deliveries.one', delivery.id).patch({status: statusID, pickedupDate: pickedUp})
				.then(function (response) {
					return response.data;
				});
		}

		function reloadStatus() {
			return nuitApi('deliveries.status')
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(_statusFields, response.data);
				});
		}

		function updatePickedUpDate(delivery, pickedUp) {
			return nuitApi('deliveries.one', delivery.id).patch({pickedupDate: pickedUp})
				.then(function (response) {
					return nuitDataService.replaceOne(_deliveries, response.data);
				});
		}
		function updateOnePickedUpDate(delivery, pickedUp) {
			return nuitApi('deliveries.one', delivery.id).patch({pickedupDate: pickedUp})
				.then(function (response) {
					return response.data.pickedupDate;
				});
		}

	}
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.factory('DeliveryWorkdayService', DeliveryWorkdayService);

	/** @ngInject */
	function DeliveryWorkdayService(nuitApi, $log, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _deliveryWorkDays = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			loadDay: loadDay,
			addWorkday: addWorkday,
			updateWorkday: updateWorkday,
			deleteWorkday: deleteWorkday
		};

		Object.defineProperty(service, 'deliveryWorkDays', {
			get: function () {
				return _deliveryWorkDays;
			}
		});

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function reload() {
			return nuitApi('deliveryworkdays')
				.get()
				.then(function (response) {
					nuitDataService.replaceAll(_deliveryWorkDays, response.data);
					return _deliveryWorkDays;
				})
				.catch(function (error) {
					$log.error('Error loading workdays');
					throw error;
				});
		}
		function loadDay() {
			return nuitApi('deliveryworkdays')
				.get()
				.then(function (response) {
					var days= [];
					for (var x = 0; x < response.data.length; x++){
						days.push(response.data[x].weekday);
					}
					nuitDataService.replaceAll(_deliveryWorkDays, days);
					return _deliveryWorkDays;
				})
				.catch(function (error) {
					$log.error('Error loading workdays');
					throw error;
				});
		}

		function addWorkday(weekday, start, end) {
			var day = {weekday: weekday, start: start, end: end};

			return nuitApi('deliveryworkdays')
				.post(day)
				.then(function (response) {
					nuitDataService.addOne(_deliveryWorkDays, response.data);
					return _deliveryWorkDays;
				});

		}

		function updateWorkday(workday) {
			return nuitApi('deliveryworkdays.one', workday.id)
				.put(workday)
				.then(function (response) {
					return nuitDataService.updateOneEntity(_deliveryWorkDays, response.data);
				});

		}

		function deleteWorkday(id) {
			return nuitApi('deliveryworkdays.one', id)
				.delete()
				.then(function (response) {
					nuitDataService.removeOneByKeys(_deliveryWorkDays, {id: id});
				});
		}

	}
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.factory('DeliveryNumberService', DeliveryNumberService);

	/** @ngInject */
	function DeliveryNumberService(nuitApi, $log, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _deliveryNumbers = [] ;
		var _templateFields = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			addDeliveryNumber: addDeliveryNumber,
			updateDeliveryNumber: updateDeliveryNumber,
			deleteDeliveryNumber: deleteDeliveryNumber,
			reloadTpl: reloadTpl
		};

		Object.defineProperty(service, 'deliveryNumbers', {
			get: function () {
				return _deliveryNumbers;
			}
		});

		Object.defineProperty(service, 'templateFields', {
			get: function () {
				return _templateFields;
			}
		});

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function reload() {
			return nuitApi('deliverynumbers')
				.get()
				.then(function (response) {
					nuitDataService.replaceAll(_deliveryNumbers, response.data);
					return _deliveryNumbers;
				})
				.catch(function (error) {
					$log.error('Error loading postal code delay');
					throw error;
				});
		}


		function addDeliveryNumber(deliveryNumber) {
			return nuitApi('deliverynumbers')
				.post(deliveryNumber)
				.then(function (response) {
					console.log(response);
					nuitDataService.addOne(_deliveryNumbers, response.data);
					return _deliveryNumbers;
				});
		}

		function updateDeliveryNumber(deliveryNumber) {
			return nuitApi('deliverynumbers.one', deliveryNumber.id)
				.put(deliveryNumber)
				.then(function (response) {
					return nuitDataService.updateOneEntity(deliveryNumber, response.data);

				});

		}

		function deleteDeliveryNumber(id) {
			return nuitApi('deliverynumbers.one', id)
				.delete()
				.then(function (response) {
					nuitDataService.removeOneByKeys(_deliveryNumbers, {id: id});
				});
		}

		function reloadTpl(){
			return nuitApi('deliverynumbertemplates')
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(_templateFields, response.data);
				});
		}
	}
}());

(function () {
		'use strict';

		angular
			.module('app.transport')
			.controller('ForwardersListController', ForwardersListController);

		/** @ngInject */
		function ForwardersListController($state,
										 $scope,
										 $filter,
										 $window,
										 $rootScope,
										 nuitUtils,
										 ForwarderService,
										 nuitConfig,
										 nuitDataService,
										 ListSelectionService,
										 CustomerService) {

			var vm = this;
			vm.unregisterConfigListener = null;

			init();

			function init() {
				initVariables();
				initMethodes();
				initEvents();

				if(nuitConfig.isReady()) {
					reloadForwarders();
				}else{
					vm.unregisterConfigListener = $rootScope.$on('config::config.loaded',reloadForwarders);
				}
			}

			function reloadForwarders(){
				var additionalParams = null;

				//for existing forwarder numbers/ids
				if(vm.config.ims.transport.forwarder.customerId.enabled){
					additionalParams = [];
					additionalParams.push(vm.config.ims.transport.forwarder.customerId.field);
				}

				ForwarderService
					.reload(true, additionalParams)
					.then(function (forwarders) {
						vm.entities = forwarders;
						filterAll();
					})
					.catch(function () {
						nuitUtils.showErrorToast();
					})
					.finally(function () {
						vm.loadingEntities = false;
					});

				if(vm.unregisterConfigListener!==null){
					vm.unregisterConfigListener();
				}
			}

			function initVariables() {
				vm.searchTypes = ['forwarder','person'];
				vm.entities = [];
				vm.currentPage = [];
				vm.filteredEntities = [];
				vm.currentPageEntities = [];
				vm.loadingEntities = true;
				vm.term = ''; //search term
				vm.mode = vm.searchTypes[0];
				vm.selection = ListSelectionService.get('forwarder', true);
				vm.config = nuitConfig.getCurrent();
				vm.paginationTerm = {};
				vm.selectedChar = null;

				vm.chars = [''];

				for(var i=65;i<=90;i++){
					vm.chars.push(String.fromCharCode(i));
				}
			}

			function initMethodes() {
				vm.search = search;
				vm.openDetail = openDetail;
				vm.getSelectedPersons = getSelectedPersons;
				vm.updateMode = updateMode;
				vm.delForwarder = delForwarder;

				vm.getSelected = vm.selection.getSelected;
				vm.isSelected = vm.selection.isSelected;
				vm.toggleSelected = vm.selection.toggleSelectedEntity;
				vm.toggleSelectedEntities = toggleSelectedEntities;
				vm.deleteSelection = deleteSelection;
				vm.getRoleName = ForwarderService.getRoleName;
				vm.loadForwarder = loadForwarder;
				vm.updatePaginationTerm = updatePaginationTerm;
				vm.getStandardAddress = getStandardAddress;
				vm.getCustomerId = CustomerService.getCustomerId;
			}

			function initEvents() {
				$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
			}

			function onStateChangeSuccess(event, toState, toParams, fromState, fromParams) {
				vm.term = $state.params.term || '';
				vm.mode = $state.params.mode || 'forwarder';

				filterAll();

				if ($state.params.page && $state.params.page !== vm.currentPage) {
					vm.currentPage = $state.params.page;
				}
			}

			function filterAll() {
				if(vm.searchTypes.indexOf(vm.mode)>=0) {
					if(vm.mode==='person' && vm.term!==''){
						ForwarderService.searchPerson(vm.term, vm.config.ims.transport.forwarder.search.limit)
							.then(filterAllInternal);
					}else{
						filterAllInternal();
					}
				}
			}

			function filterAllInternal() {
				vm.filteredEntities = [];

				for (var i = 0; i < vm.entities.length; i++) {
					var forwarder = vm.entities[i];
					if (filter(forwarder)) {
						vm.filteredEntities.push(forwarder);
					}
				}

				vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, 'name');

			}

			function filter(forwarder) {
				if (vm.term === '') {
					return true;
				}

				if (vm.mode === 'forwarder' &&
					(
						(forwarder.address && forwarder.address.name && forwarder.address.name.toLowerCase().indexOf(vm.term.toLowerCase()) !== -1) ||
						(forwarder.name && forwarder.name.toLowerCase().indexOf(vm.term.toLowerCase()) !== -1) ||
						(vm.config.ims.transport.forwarder.customerId.enabled && vm.getCustomerId(forwarder).toLowerCase().indexOf(vm.term.toLowerCase())!==-1)
					)) {
					return true;
				}

				if (vm.mode === 'person') {
					if (!forwarder.users) {
						return false;
					} else {
						for (var i = 0; i < forwarder.users.length; i++) {
							if (personMatchesSearchTerm(forwarder.users[i])) {
								return true;
							}
						}
					}
				}

				return false;
			}

			function personMatchesSearchTerm(person) {
				return person.lastName.toLowerCase().indexOf(vm.term.toLowerCase()) !== -1 ||
					person.firstName.toLowerCase().indexOf(vm.term.toLowerCase()) !== -1;
			}

			function getSelectedPersons(forwarder) {
				if (!forwarder.users) {
					return [];
				} else if (vm.mode === 'person') {
					var selectedPersons = [];

					for (var i = 0; i < forwarder.users.length; i++) {
						{
							if (personMatchesSearchTerm(forwarder.users[i])) {
								selectedPersons.push(forwarder.users[i]);
							}
						}
					}

					return selectedPersons;
				}
				else {
					return forwarder.users;
				}
			}

			function openDetail(forwarderId) {
				$state.go('app.transport.details', {
					forwarderId: forwarderId,
					page: vm.currentPage
				}, {inherit: false});
			}

			function search() {
				$state.go('app.transport', {term: vm.term, mode: vm.mode});
				vm.selection.deselectAll();
			}

			function updateMode() {
				filterAll();
			}

			function delForwarder(forwarder) {
				nuitUtils.showDeleteConfirmation().then(function () {
					ForwarderService.del(forwarder.id)
						.then(function (forwarder) {
							filterAll();
							nuitUtils.showSuccessToast();
						})
						.catch(function (error) {
							nuitUtils.showErrorToast();
						});
				});
			}

			function deleteSelection() {
				nuitUtils.showDeleteConfirmation().then(function () {
					var selected = vm.getSelected();
					vm.selection.deselectAll();
					for (var i = 0; i < selected.length; i++) {
						ForwarderService.del(selected[i].id)
							.then(function (forwarder) {
								filterAll();
							})
							.catch(function (error) {
								nuitUtils.showErrorToast();
							});
					}
				});
			}

			function toggleSelectedEntities() {
				vm.selection.toggleSelectedEntities(vm.currentPageEntities);
			}


			function loadForwarder(forwarder) {
				return ForwarderService.getById(forwarder.id);
			}

			function updatePaginationTerm(){
				if(vm.selectedChar!=='') {
					vm.paginationTerm = {name: vm.selectedChar};
				}
			}

			function getStandardAddress(forwarder){
				if(forwarder.addressId!==null){
					var address = nuitDataService.getOne(forwarder.addresses,forwarder.addressId);
					if(address){
						return address;
					}else{
						return getFirstAddress(forwarder.addresses);
					}
				}else if(angular.isArray(forwarder.addresses) && forwarder.addresses.length>0){
					return forwarder.addresses[0];
				}else{
					return getFirstAddress(forwarder.addresses);
				}
			}

			function getFirstAddress(addresses){
				if(angular.isArray(addresses) && addresses.length>0) {
					return addresses[0];
				}else{
					return null;
				}
			}
		}
	}

	()
);

(function () {
	'use strict';

	angular
		.module('app.transport')
		.controller('ForwarderDetailsController', ForwarderDetailsController);

	function ForwarderDetailsController($mdDialog,
										$state,
										$translate,
										imsConfig,
										nuitConfig,
										nuitUtils,
										ForwarderService,
										PAYMENT,
										DeliveryService,
										nuitAuth,
										imsUtils) {

		var vm = this;

		init();

		function init() {
			initVariables();
			initMethodes();

			loading();

		}

		function initVariables() {
			vm.config = imsConfig.getCurrent();
			vm.loadingCompany = true;
			vm.forwarder = null;
			vm.forwarderId = $state.params.forwarderId;
			vm.selectedLanguage = $translate.use();
			vm.nameFormat = 'lastName# #firstName';
			vm.PROPORTIONS = PAYMENT.PROPORTIONS;
			vm.currentTab = $state.params.active;
			vm.currentPage = [];
			vm.currentPageEntities = [];
			vm.loadingEntities = true;
			vm.autoMail = true;
			vm.deliveries = DeliveryService.deliveriesPerCarrier;
			vm.orderDetail = vm.config.ims.accounting.orderNameFormat;
			vm.statusFields = DeliveryService.statusFields;

		}

		function initMethodes() {
			vm.updateForwarder = updateForwarder;
			vm.showPersonDialog = showPersonDialog;
			vm.delPerson = delPerson;
			vm.getRoleName = ForwarderService.getRoleName;
			vm.addAddress = ForwarderService.addAddress;
			vm.editAddress = ForwarderService.editAddress;
			vm.deleteAddress = ForwarderService.deleteAddress;
			vm.isStandardAddress = isStandardAddress;
			vm.setStandardAddress = setStandardAddress;
			vm.setAutoNotification = setAutoNotification;
			vm.getDocumentURL = imsUtils.getDocumentURL;
			vm.getStatusName = getStatusName;
		}

		function loading() {
			ForwarderService
				.getById(vm.forwarderId)
				.then(function (forwarder) {
					vm.forwarder = forwarder;
					DeliveryService.loadCarrierDeliveries(vm.forwarder.id)
						.then(function (response) {
							DeliveryService.reloadStatus();
						});
					vm.orderDetail = vm.orderDetail.replace('details.', '');

				})
				.catch(function () {
					nuitUtils.showErrorToast();
				})
				.finally(function () {
					vm.loadingForwarder = false;
				});
		}

		function updateForwarder() {
			if (vm.forwarderForm.$invalid) {
				return;
			}

			ForwarderService.update(vm.forwarder.id, vm.forwarder)
				.then(function (response) {
					vm.forwarder = response;
					vm.forwarderForm.$setPristine();
					vm.forwarderForm.$setUntouched();
					nuitUtils.showSuccessToast();
				})
				.catch(function (err) {
					nuitUtils.showErrorToast();
				});
		}

		function delPerson(personId) {
			nuitUtils.showDeleteConfirmation().then(function () {
				ForwarderService.delPerson(vm.forwarderId, personId)
					.then(function (response) {
						nuitUtils.showSuccessToast();
					})
					.catch(function (err) {
						nuitUtils.showErrorToast();
					});
			});
		}

		function showPersonDialog(person) {
			$mdDialog.show({
				controller: 'PersonComposeController',
				controllerAs: 'vm',
				locals: {company: vm.forwarder, person: person, type: 'forwarder'},
				templateUrl: 'app/main/partners.general/views/person-compose.html',
				clickOutsideToClose: true
			});
		}


		function isStandardAddress(addressId, type) {
			return vm.forwarder[type] === addressId;
		}

		function setStandardAddress(addressId, type) {
			vm.forwarder[type] = addressId;
			vm.forwarderForm.$setDirty();
		}

		function setAutoNotification(person, key) {
			var email = person.notification.email;
			var sms = person.notification.sms;
			var notification = {};
			if (key === 'email') {
				email = !person.notification.email;
				notification = {email: email, sms: sms};
				ForwarderService.setAutoNotification(vm.forwarder.id, person.id, notification)
					.then(function () {
						loading();
					});
			}
			if (key === 'sms') {
				sms = !person.notification.sms;
				notification = {email: email, sms: sms};
				ForwarderService.setAutoNotification(vm.forwarder.id, person.id, notification)
					.then(function () {
						loading();
					});
			}

		}

		function getStatusName(id) {
			if (id) {
				for (var i = 0; i < vm.statusFields.length; i++) {
					if (vm.statusFields[i].id === id) {
						var text = vm.statusFields[i].type;
						return $translate.instant('TRANSPORT.' + text.toUpperCase());
					}
				}
			}
		}

	}
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.controller('DeliveryBoardController', DeliveryBoardController);

	/** @ngInject */
	function DeliveryBoardController(
		$rootScope,
		$scope,
		$state,
		$translate,
		$q,
		$mdDialog,
		$filter,
		nuitConfig,
		nuitAuth,
		nuitDataService,
		nuitUtils,
		DeliveryService,
		ForwarderService,
		DeliveryBoardService,
		DeliveryWorkdayService,
		RoleService,
		DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.deliveries = DeliveryBoardService.groupedDeliveries;
		vm.currentWeek = [];
		vm.selectedItems = [];
		vm.config = nuitConfig.current;
		vm.unregisterConfigListener = null;
		vm.statis = DeliveryService.statusFields;
		vm.disable = [];
		vm.currentDay = parseInt(moment().valueOf() / 1000);
		vm.loadedDaysBefore = vm.config.ims.transport.deliveryCalendar.loadDaysBefore;
		vm.calendarWeek = 0;
		vm.currentCalendarWeek = 0;
		vm.loading = true;
		vm.validWorkDays = DeliveryWorkdayService.deliveryWorkDays;
		vm.userId = null;
		vm.user = nuitAuth.getUser();
		vm.carrier = ForwarderService.forwarders;
		vm.carrierId = null;
		vm.deliveryCompanies = ForwarderService.forwarders;
		vm.searchForwarder = 'all';
		vm.deliverySearchTerm = '';
		vm.statusSelection = 'all';
		//*******************************************

		//*******************************************

		//*******************************************
		// METHOD EXPOSURE
		//*******************************************
		vm.previousWeek = previousWeek;
		vm.nextWeek = nextWeek;
		vm.showCurrentWeek = showCurrentWeek;
		vm.isSelected = isSelected;
		vm.toggleEvent = toggleEvent;
		vm.openEventDetail = openEventDetail;
		vm.flipWidget = flipWidget;
		vm.changeStatus = changeStatus;
		vm.openDetails = openDetails;
		vm.onChangeForwarderSearch = onChangeForwarderSearch;
		vm.searchForDelivery = searchForDelivery;

		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {

			var params = {};

			RoleService.reload()
				.then(function () {
					var role = RoleService.getRoleById(vm.user.roleId);

					if (vm.user.id!==4 && role.type === 2) {
						params = {user: vm.user.id};
						getCarrierId(params)
							.then(function () {
								load();
							});
					} else {
						load();
					}
				})
				.catch(function (error) {
					vm.loading = false;
					console.error(error);
				})
		}

		function load() {
			DeliveryWorkdayService.loadDay()
				.then(function () {

					if (nuitConfig.isReady()) {
						initializePlanningWeek();
					} else {
						vm.unregisterConfigListener = $rootScope.$on('config::config.loaded', initializePlanningWeek);
					}
					//DeliveryService.reloadStatus();
					var today = new Date();
					today.setHours(0, 0, 0, 0);
					vm.currentDay = parseInt(today.valueOf() / 1000);
				});
		}

		function getCarrierId(params) {
			return ForwarderService.reload(params)
				.then(function () {
					if(vm.carrier.length>0 && vm.carrier[0].id !== null) {
						vm.carrierId = vm.carrier[0].id;
					}else{
						vm.carrierId = -1;
					}
					return vm.carrierId;
				});
		}

		function openEventDetail($event, planningBoardEvent) {
			var origin = $state.current.name + '({ index: \'' + $state.params.index + '\'})';
			$state.go('app.invoices.details', {orderId: planningBoardEvent.id, origin: origin});
		}

		function flipWidget(event) {
			if (!event.hasDetails) {
				//ProductionPlanningService.getEventDetails(event);
			}
		}

		function isSelected(planningBoardEvent) {
			return vm.selectedItems.indexOf(planningBoardEvent) >= 0;
		}

		function toggleEvent(planningBoardEvent) {
			var index = vm.selectedItems.indexOf(planningBoardEvent);

			if (index >= 0) {
				vm.selectedItems.splice(index, 1);
			} else {
				vm.selectedItems.push(planningBoardEvent);
			}

			if (vm.selectedItems.length === 1) {
				if (vm.disable.length === 0) {
					vm.statis.forEach(function (status) {
						vm.disable.push(status.id);
					});
				}
				var start = (vm.selectedItems[0].status);
				var ind = vm.disable.indexOf(start).toString();
				DotNotationService.remove(vm.disable, ind);
			} else if (vm.selectedItems.length === 0) {
				vm.disable = [];
			}
		}

		function nextWeek() {
			setupWeek(7, 'd');
		}

		function previousWeek() {
			setupWeek(-7, 'd');
		}

		function showCurrentWeek() {
			var today = new Date();
			today.setHours(0, 0, 0, 0);
			var now = moment(today);
			var currentDayOfWeek = now.day();
			var startDayOfWeek = vm.config.ims.accounting.calendar.startDayOfWeek;
			var startDate = null;
			if ($state.params.start) {
				startDate = moment(new Date($state.params.start * 1000));
			} else {
				startDate = startDayOfWeek > currentDayOfWeek ?
					now.subtract(7 - (startDayOfWeek - currentDayOfWeek), 'd') :
					now.subtract(currentDayOfWeek - startDayOfWeek, 'd');
			}
			var currentDate = moment(vm.currentWeek[0].timestampMin * 1000);
			var offset = (currentDate.diff(startDate, 'days')) * -1;
			setupWeek(offset, 'd');
		}

		function setupWeek(offset, timeFrame) {
			var today = new Date();
			var startLoadingDate = moment(today).subtract(vm.loadedDaysBefore, 'd');
			startLoadingDate = new Date(startLoadingDate);
			var startCurrentWeekDate = moment(vm.currentWeek[0].timestamp).add(offset, timeFrame);
			startCurrentWeekDate = new Date(startCurrentWeekDate);
			startCurrentWeekDate.setHours(0, 0, 0, 0);

			if (startCurrentWeekDate < startLoadingDate) {
				startLoadingDate = moment(startLoadingDate).subtract(vm.config.ims.transport.deliveryCalendar.loadDaysBefore, 'd');
				var lastDate = moment(today).add(vm.config.ims.transport.deliveryCalendar.loadDaysAfter, 'd');
				startLoadingDate = new Date(startLoadingDate);
				startLoadingDate.setHours(0,0,0, 0);
				lastDate = new Date(lastDate);
				lastDate.setHours(23, 59, 59, 0);
				DeliveryBoardService.reload(parseInt(startLoadingDate.valueOf() / 1000), parseInt(lastDate.valueOf() / 1000), vm.carrierId)
					.then(function () {
						fillNewWeek(offset, timeFrame);
						vm.loadedDaysBefore += vm.loadedDaysBefore;
					});
			} else {
				fillNewWeek(offset, timeFrame);
			}
		}

		function fillNewWeek(offset, timeFrame) {
			for (var i = 0; i < vm.currentWeek.length; i++) {
				var date = moment(vm.currentWeek[i].timestamp).add(offset, timeFrame);
				var today = new Date(date);
				today.setHours(0, 0, 0, 0);
				var dateFormatted = $filter('nuitDatetime')(date.valueOf() / 1000, 'date');

				var deliveries = getPlanningBoardEvents(dateFormatted);

				vm.currentWeek[i].timestamp = date.valueOf();
				vm.currentWeek[i].timestampMin = parseInt(today.valueOf() / 1000);
				vm.currentWeek[i].dateFormatted = dateFormatted;
				vm.currentWeek[i].deliveries = deliveries;
				vm.currentWeek[i].estimatedTime = 0;
			}
			searchForDelivery();
			setPlanningTimeframe();
		}

		function initializePlanningWeek() {
			if (vm.unregisterConfigListener !== null) {
				vm.unregisterConfigListener();
			}
			vm.currentCalendarWeek = $filter('date')(new Date(), 'w');

			var now = moment();
			var currentDayOfWeek = now.day();
			var startDayOfWeek = vm.config.ims.accounting.calendar.startDayOfWeek;
			var startDay = null;
			if ($state.params.start) {
				startDay = moment(new Date($state.params.start * 1000));
			} else {
				startDay = startDayOfWeek > currentDayOfWeek ?
					now.subtract(7 - (startDayOfWeek - currentDayOfWeek), 'd') :
					now.subtract(currentDayOfWeek - startDayOfWeek, 'd');
			}
			var lastDay = moment(startDay).add(6, 'd');
			startDay = new Date(startDay);
			lastDay = new Date(lastDay);
			startDay.setHours(0, 0, 0, 0);
			lastDay.setHours(23, 59, 59, 0);

			var startDate = moment(now).subtract(vm.config.ims.transport.deliveryCalendar.loadDaysBefore, 'd');
			var endDate = moment(now).add(vm.config.ims.transport.deliveryCalendar.loadDaysAfter, 'd');
			startDate = new Date(startDate);
			startDate.setHours(0, 0, 0,0);
			endDate = new Date(endDate);
			endDate.setHours(23,59,59,0);

			DeliveryBoardService.reload(parseInt(startDate.valueOf() / 1000), parseInt(endDate.valueOf() / 1000), vm.carrierId)
				.then(function () {
					for (var i = 0; i < 7; i++) {
						var date = moment(startDay).add(i, 'd');

						if (vm.validWorkDays.indexOf(date.day()) !== -1) {
							var dayTranslation = 'APP.' + date.format('dddd').toUpperCase();
							var dateFormatted = $filter('nuitDatetime')(date.valueOf() / 1000, 'date');
							var deliveries = getPlanningBoardEvents(dateFormatted);
							var today = new Date(date);
							today.setHours(0, 0, 0, 0);

							vm.currentWeek.push({
								translationKey: dayTranslation,
								timestamp: date.valueOf(),
								timestampMin: parseInt(today.valueOf() / 1000),
								dateFormatted: dateFormatted,
								deliveries: deliveries,
							});
						}
					}
					setPlanningTimeframe();
				});
		}

		function getPlanningBoardEvents(date) {
			if (!vm.deliveries[date]) {
				vm.deliveries[date] = [];
			}
			return filterDeliveries(vm.deliveries[date]);
		}

		function setPlanningTimeframe() {
			vm.planningTimeframe = vm.currentWeek[0].dateFormatted + ' - ' + $filter('nuitDatetime')(vm.currentWeek[0].timestamp / 1000 + 86400 * 6, 'date');
			vm.calendarWeek = $filter('date')(vm.currentWeek[0].timestamp, 'w');
			vm.loading = false;
		}


		function createChangeStatusDialog(startStatus) {
			return {
				controller: 'ChangeDeliveryStatusDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/partners.transport/views/dialogs/change-status/change-delivery-status.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Status: angular.copy(startStatus)
				}
			};
		}

		function changeStatus(delivery) {
			var startStatus = delivery[0].status;
			var statis = [];
			for (var i = 0; i < delivery.length; i++) {
				if (delivery[i].status === startStatus) {
					statis.push(delivery[i].status);
				}
			}
			if (statis.length === delivery.length) {
				$mdDialog
					.show(createChangeStatusDialog(startStatus))
					.then(function (result) {
						var status = result[0];
						var pickedUp = result[1];
						var deliveries = vm.selectedItems;
						if (status !== 4) {
							pickedUp = null;
						}
						DeliveryBoardService.incrementStatusAndReload(deliveries, status, pickedUp)
							.then(function () {
								vm.onChangeForwarderSearch();
								vm.selectedItems = [];
								vm.disable = [];
								nuitUtils.showSuccessToast();
							}).catch(nuitUtils.showErrorToast);
					}).catch(angular.noop);
			} else {
				nuitUtils.showErrorToast('ACCOUNTING.DIFFERENT_STATIS');
			}
		}


		function openDetails(id) {
			var origin = $state.current.name;
			$state.go('app.transport-board.detail', {
				orderId: id,
				origin: origin
			});
		}

		function onChangeForwarderSearch() {
			for (var i = 0; i < vm.currentWeek.length; i++) {
				var day = vm.currentWeek[i];
				vm.currentWeek[i].deliveries = [];
				var deliveries = getPlanningBoardEvents(day.dateFormatted);
				if (vm.searchForwarder === 'all' && vm.statusSelection === 'all') {
					for (var y = 0; y < deliveries.length; y++) {
						vm.currentWeek[i].deliveries.push(deliveries[y]);
					}
				} else {
					nuitDataService.replaceAll(vm.currentWeek[i].deliveries, filterDeliveries(deliveries));
				}
			}
			searchForDelivery();
		}

		function searchForDelivery() {
			if (vm.deliverySearchTerm !== '' || vm.deliverySearchTerm !== undefined) {
				for (var i = 0; i < vm.currentWeek.length; i++) {
					var day = vm.currentWeek[i];
					vm.currentWeek[i].deliveries = [];
					var deliveries = getPlanningBoardEvents(day.dateFormatted);
					for (var x = 0; x < deliveries.length; x++) {
						if (vm.deliverySearchTerm !== '') {
							try
							{
								if (searchIn(deliveries[x])) {
									vm.currentWeek[i].deliveries.push(deliveries[x]);
								}
							}catch(e){
								console.log(e, deliveries[x]);
							}
						} else if (vm.deliverySearchTerm === '' || vm.deliverySearchTerm === undefined) {
							vm.currentWeek[i].deliveries.push(deliveries[x]);
						}
					}
				}
			}
		}

		function searchIn(delivery) {
			var searchTerm = vm.deliverySearchTerm.toLowerCase();
			return (delivery.address && Object.keys(delivery.address).includes('companyname') && delivery.address.companyname.toLowerCase().includes(searchTerm)) ||
				(delivery.name && delivery.name.toLowerCase().includes(searchTerm)) ||
				(delivery.orderId && delivery.orderId.toString().includes(searchTerm)) ||
				(delivery.orderNumber && delivery.orderNumber.toLowerCase().includes(searchTerm)) ||
				(delivery.address && Object.keys(delivery.address).includes('zip') && delivery.address.zip.toString().includes(searchTerm)) ||
				(delivery.number && delivery.number.toString().includes(searchTerm));
		}

		function filterDeliveries(deliveries) {
			if (vm.searchForwarder !== 'all' || vm.statusSelection !== 'all') {
				var filteredDeliveries = [];
				for (var x = 0; x < deliveries.length; x++) {
					if (deliveries[x].carrierId === vm.searchForwarder && deliveries[x].deliveryType === 'DELIVERY' &&
						vm.statusSelection === 'all' ||
						deliveries[x].status === vm.statusSelection && vm.searchForwarder === 'all' ||
						deliveries[x].carrierId === vm.searchForwarder && deliveries[x].deliveryType === 'DELIVERY' &&
						deliveries[x].status === vm.statusSelection) {
						filteredDeliveries.push(deliveries[x]);
					}
				}
				return filteredDeliveries;
			} else {
				return deliveries;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.controller('DeliveryConfigurationController', DeliveryConfigurationController);

	/** @ngInject */
	function DeliveryConfigurationController($log, $q, $state, $translate,
											 $document, $mdDialog, $scope,
											 nuitConfig, nuitApi,
											 nuitUtils, imsTranslationService,
											 DotNotationService, PostalCodeDelayService,
											 nuitDataService, DeliveryWorkdayService,
											 ListSelectionService, FilterCountService,
											 DeliveryNumberService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.currentTab = $state.params.active;
		vm.loading = true;
		vm.postalCodeDelays = PostalCodeDelayService.postalCodeDelays;
		vm.deliveryWorkdays = DeliveryWorkdayService.deliveryWorkDays;
		vm.deletedWorkdays = [];
		vm.initWorkdays = [];
		vm.deliveryTimes = [];
		vm.startDeliveryTime = 0;
		vm.endDeliveryTime = 86399;
		vm.selected = [];
		vm.workDays = [
			{id: 1, name: 'APP.MONDAY'},
			{id: 2, name: 'APP.TUESDAY'},
			{id: 3, name: 'APP.WEDNESDAY'},
			{id: 4, name: 'APP.THURSDAY'},
			{id: 5, name: 'APP.FRIDAY'},
			{id: 6, name: 'APP.SATURDAY'},
			{id: 0, name: 'APP.SUNDAY'}];

		vm.deliveryNumbers = DeliveryNumberService.deliveryNumbers;
		vm.selection = ListSelectionService.get('partners.delivery-numbers');
		vm.filterCount = FilterCountService.get('partners.delivery-numbers');


		//*******************************************

		//*******************************************
		// METHODS EXPOSURE
		//*******************************************
		//tab postal code delay
		vm.editPostalCodeDelay = editPostalCodeDelay;
		vm.deletePostalCodeDelay = deletePostalCodeDelay;
		vm.addPostalCodeDelay = addPostalCodeDelay;
		vm.getDelay = getDelay;

		//tab delivery work days
		vm.toggle = toggle;
		vm.exists = exists;
		vm.saveDeliveryWorkDays = saveDeliveryWorkDays;

		//tab delivery numbers
		vm.addDeliveryNumber = addDeliveryNumber;
		vm.deleteDeliveryNumber = deleteDeliveryNumber;
		vm.editDeliveryNumber = editDeliveryNumber;

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		function onStateChangeSuccess() {
			vm.currentTab = $state.params.active;
		}


		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************


		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			loadPostalCodeDelays();
			vm.deliveryTimes = [];

			for (var i = 0; i < 96; i++) {
				var sec = 60 * 15 * i;
				var newTime = new Date();
				newTime.setHours(0, 0, sec, 0);
				var time = newTime.toLocaleTimeString();

				vm.deliveryTimes.push({time: time, sec: sec});
			}
			reloadWorkdays();

			reloadDeliveryNumbers();

		}


		function reloadWorkdays() {
			DeliveryWorkdayService.reload()
				.then(function () {
					if (vm.deliveryWorkdays.length !== 0) {
						for (var idx = 0; idx < vm.deliveryWorkdays.length; idx++) {
							vm.selected.push(vm.deliveryWorkdays[idx].weekday);
							//vm.initWorkdays.push(vm.deliveryWorkdays[idx].weekday);
						}
					}
				});
		}

		function loadPostalCodeDelays() {
			PostalCodeDelayService.reload();
		}

		function reloadDeliveryNumbers() {
			DeliveryNumberService.reload();
		}


		function addPostalCodeDelay() {
			$mdDialog
				.show(createPostalCodeDelayDialog())
				.then(function (result) {
					PostalCodeDelayService.addDelay(result)
						.then(function () {
							nuitUtils.showSuccessToast();
						})
						.catch(function () {
							nuitUtils.showErrorToast();
						});
				}).catch(angular.noop);
		}

		function createPostalCodeDelayDialog(delay) {
			return {
				controller: 'PostalCodeDelayDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/partners.transport/views/dialogs/postal-code-delays/postal-code-delay-dialog.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Delay: angular.copy(delay)
				}
			};
		}

		function editPostalCodeDelay(postalCodeDelay) {
			$mdDialog
				.show(createPostalCodeDelayDialog(postalCodeDelay))
				.then(function (result) {
					PostalCodeDelayService.updateDelay(result)
						.then(function () {
							loadPostalCodeDelays();
							nuitUtils.showSuccessToast();
						})
						.catch(function () {
							nuitUtils.showErrorToast();
						});
				})
				.catch(angular.noop);

		}

		function deletePostalCodeDelay(postalCodeDelay) {
			PostalCodeDelayService.deleteDelay(postalCodeDelay.id)
				.then(function () {
					nuitUtils.showSuccessToast();
				})
				.catch(function () {
					nuitUtils.showErrorToast();
				});
		}

		function getDelay(delayTime) {
			var days = Math.ceil(delayTime / 86400);
			var daysText = $translate.instant('TIME.DAYS');
			if (days === 1) {
				daysText = $translate.instant('CALENDAR.DAY');
			}
			return days + ' ' + daysText;
		}


		function toggle(item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
				list.splice(idx, 1);
				for(var i = 0; i< vm.deliveryWorkdays.length; i++){
					if(vm.deliveryWorkdays[i].weekday === item) {
						DeliveryWorkdayService.deleteWorkday(vm.deliveryWorkdays[i].id)
							.then(function () {
								nuitUtils.showSuccessToast();
							})
							.catch(function () {
								nuitUtils.showErrorToast();
							});
					}
				}
			} else {
				list.push(item);
				DeliveryWorkdayService.addWorkday(item, vm.startDeliveryTime, vm.endDeliveryTime)
					.then(function () {
						nuitUtils.showSuccessToast();
					})
					.catch(function () {
						nuitUtils.showErrorToast();
					});
			}
		}

		function exists(item, list) {
			return list.indexOf(item) > -1;
		}


		//**************************************************************************************************************
		//**************************************************************************************************************
		//more complexity for working-times per day and form with save button
		function saveDeliveryWorkDays() {
			//var days = [];
			//var stIdx = vm.startDeliveryTime.length;
			//var endIdx = vm.endDeliveryTime.length;
			//var idx = 0;
			/*if (stIdx >= endIdx) {
				idx = stIdx;
			} else {
				idx = endIdx;
			}
			console.log(vm.selected);
			 */
			//
			/*
			for(var i= 0; i<idx; i++){
				if(vm.startDeliveryTime[i] !== undefined && vm.endDeliveryTime[i] !== undefined){
					days.push({weekday: i, start: vm.startDeliveryTime[i], end: vm.endDeliveryTime[i] });
				}
				if(vm.startDeliveryTime[i] && vm.endDeliveryTime[i] === undefined || vm.startDeliveryTime[i] === undefined && vm.endDeliveryTime[i]){
					nuitUtils.showErrorToast('TRANSPORT.DELIVERY_WORKDAY_ONE_TIME_IS_MISSING');
				}
			}
			*/

			//**only for use without workday-time selection**
			vm.startDeliveryTime = 0;
			vm.endDeliveryTime = 86399;

			checkInitWorkday()
				.then(function () {
					var promises = [];
					for (var i = 0; i < vm.selected.length; i++) {
						if (!vm.initWorkdays.includes(vm.selected[i])) {
							promises.push(DeliveryWorkdayService.addWorkday(vm.selected[i], vm.startDeliveryTime, vm.endDeliveryTime));
						}
					}
					return $q.all(promises);
				})
				.finally(function () {
					reloadWorkdays();
					vm.deliveryWorkdaysForm.$setPristine();
				});
		}

		function checkInitWorkday() {
			var promises = [];
			for (var indx = 0; indx < vm.initWorkdays.length; indx++) {
				var id = vm.initWorkdays[indx];
				var index = null;
				for (var y = 0; y < vm.deliveryWorkdays.length; y++) {
					if (vm.deliveryWorkdays[y].weekday === id) {
						index = vm.deliveryWorkdays.indexOf(vm.deliveryWorkdays[y]);
					}
				}
				if (!vm.selected.includes(vm.initWorkdays[indx])) {
					promises.push(DeliveryWorkdayService.deleteWorkday(vm.deliveryWorkdays[index].id));
				} else {
					// ** use this if working-time is activated **
					// promises.push(DeliveryWorkdayService.updateWorkday(vm.deliveryWorkdays[index]));
				}
			}

			return $q.all(promises);

		}
		//**************************************************************************************************************
		//**************************************************************************************************************


		function addDeliveryNumber() {
			$mdDialog
				.show(createDeliveryNumberDialog())
				.then(function (result) {
					result.start.setHours(0,0,0,0);
					result.end.setHours(23,59,59,0);
					result.start = Date.parse(result.start) / 1000;
					result.end = Date.parse(result.end) / 1000;
					DeliveryNumberService.addDeliveryNumber(result)
						.then(function () {
							reloadDeliveryNumbers();
							nuitUtils.showSuccessToast();
						})
						.catch(function () {
							nuitUtils.showErrorToast();
						});
				}).catch(angular.noop);

		}
		function createDeliveryNumberDialog(number) {
			return {
				controller: 'DeliveryNumberDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/partners.transport/views/dialogs/delivery-numbers/delivery-number-dialog.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					DeliveryNumber: angular.copy(number)
				}
			};
		}

		function deleteDeliveryNumber(deliveryNumber) {
			DeliveryNumberService.deleteDeliveryNumber(deliveryNumber.id)
				.then(function () {
					if(vm.deliveryNumbers.length === 1 && !vm.deliveryNumbers[0].autoRenew){
						vm.deliveryNumbers[0].autoRenew = true;
						DeliveryNumberService.updateDeliveryNumber(vm.deliveryNumbers[0])
							.then(function () {
								reloadDeliveryNumbers();
							});
					}
					nuitUtils.showSuccessToast();
				})
				.catch(function () {
					nuitUtils.showErrorToast();
				});
		}

		function editDeliveryNumber(deliveryNumber) {
			$mdDialog
				.show(createDeliveryNumberDialog(deliveryNumber))
				.then(function (result) {
					result.start.setHours(0,0,0,0);
					result.end.setHours(23,59,59,0);
					result.start = Date.parse(result.start) / 1000;
					result.end = Date.parse(result.end) / 1000;
					DeliveryNumberService.updateDeliveryNumber(result)
						.then(function () {
							reloadDeliveryNumbers();
							nuitUtils.showSuccessToast();
						})
						.catch(function () {
							nuitUtils.showErrorToast();
						});
				}).catch(angular.noop);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.general')
		.factory('ShopOrderDetailsService', ShopOrderDetailsService);

	/** @ngInject */
	function ShopOrderDetailsService($mdDialog, nuitUtils, OrderService) {
		return initService();

		function initService() {
			return {
				open: open,
				openById: openById,
				editOrDeleteById: editOrDeleteById,
				getDefaultDialogConfig: getDefaultDialogConfig
			};
		}

		function open(order,dialogConfig) {
			var copy = angular.copy(order);
			copy.tags = copy.tags.map(function(entity){return entity.id;});

			return $mdDialog.show({
				controller: 'ShopOrderDetailController',
				controllerAs: 'vm',
				templateUrl: 'app/main/production.general/views/shop-order-detail.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
                multiple: true,
				locals: {
					Order: copy,
					DialogConfig: typeof dialogConfig==='undefined'?getDefaultDialogConfig():dialogConfig,
					CancelOnClose: false
				}
			});
		}

		function openNew(order, dialogConfig){
			var copy = angular.copy(order);
			copy.tags = copy.tags.map(function(entity){return entity.id;});

			return $mdDialog.show({
				controller: 'ShopOrderDetailController',
				controllerAs: 'vm',
				templateUrl: 'app/main/production.general/views/shop-order-detail.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				multiple: true,
				locals: {
					Order: copy,
					DialogConfig: typeof dialogConfig==='undefined'?getDefaultDialogConfig():dialogConfig,
					CancelOnClose: true
				}
			});
		}

		function getDefaultDialogConfig()
		{
			return {
				details:{
					editButton: false,
					completionDatePicker: false
				},
				positions:{
					profileEditable: false,
					nameEditable: false,
					remarkEditable: false,
					add: true, //true means read only
					remove: true, //true means read only
					quantity: true, //true means read only
					length: true, //true means read only
					prices: true, //true means read only
					specials: true, //true means read only
					specialsPrice: true, //true means read only
					positionCheck: true, //true means read only
					positionMarkForCheck: true //true means read only
				},
				products: false, //true means read only
				specials: false, //true means read only
				prices:{
					show: true
				}
			};
		}

		function openById(orderId,dialogConfig) {
			return OrderService.loadOrder(orderId)
				.then(function (response) {
					if (angular.isNumber(response.details.completionDate)) {
						response.details.completionDate = new Date(response.details.completionDate * 1000);
					}
					return open(response,dialogConfig);
				})
				.catch(nuitUtils.showErrorToast);
		}

		function editOrDeleteById(orderId, dialogConfig){
			return OrderService.loadOrder(orderId)
				.then(function (response) {
					if (!response.details.completionDate) {
						response.details.completionDate = new Date();
					}else if (angular.isNumber(response.details.completionDate)) {
						response.details.completionDate = new Date(response.details.completionDate * 1000);
					}
					return openNew(response,dialogConfig);
				})
				.catch(function(){
					OrderService.deleteOrder({id:orderId});
					throw new Error('Order deleted');
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.general')
		.factory('BendFileDownloadService', BendFileDownloadService);

	/** @ngInject */
	function BendFileDownloadService($mdDialog, nuitApi, nuitApiProxy, nuitAuth) {
		return initService();

		function initService() {
			return {
				open: open,
				download: download,
				downloadUrl: downloadUrl
			};
		}

		function open(profile) {
			$mdDialog.show({
				controller: 'BendFileDownloadController',
				controllerAs: 'vm',
				templateUrl: 'app/main/production.general/dialogs/bendFileDownload/bend-file-download.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				multiple: true,
				locals: {
					Profile: angular.copy(profile)
				}
			})
				.then(function () {

				});
		}

		function download(machineId,profile){
			return nuitApiProxy('download.bending.program',machineId).get({profile: profile});
		}

		function downloadUrl(machineId, profileId)
		{
			// built by hand because the caller needs a plain URL, not a request;
			// machine-v2 serves this under /machine/v2 and expects a profile uuid.
			var prefix = nuitAuth.getEvoVersion() === 3 ? 'machine/v2/' : 'machine/';
			return nuitApi.getBaseUrl() + prefix + 'bendingmachines/' + machineId + '/bendingfiles?profileId=' + profileId + '&access-token=' + nuitAuth.getToken();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.general')
		.controller('ShopOrderDetailController', ShopOrderDetailController);

	/** @ngInject */
	function ShopOrderDetailController(
										$q,
										$state,
									   $mdToast,
									   $mdDialog,
									   nuitConfig,
									   nuitAuth,
									   nuitUtils,
									   OrderService,
									   imsColors,
									   imsMaterials,
									   imsTranslation,
									   imsUtils,
									   Order,
									   DialogConfig,
									   CancelOnClose,
									   AddressService,
									   OrderViewService,
									   CART_SHIPPING_TYPES,
										nuitProfiles,
									   BendFileDownloadService,
									   nuitProfile,
									   nuitEditor,
									   OrderSpecialService,
										EVOConfigService,
										OrderQueryService,
										OrderTagsViewService,
										OrderTagsService,
										PositionsService,
										nuitDataService,
										ProjectService,
										ProjectsViewService,
										imsNextChannel
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();                            // Contains the nuit config
		vm.dialogConfig = DialogConfig;
		vm.cancelOnClose = CancelOnClose;
		vm.currentTab = $state.params.active;
		vm.order = Order;                            // Contains current order
		vm.groups = [];
		vm.materials = imsMaterials.materials;
		vm.colors = imsColors.colors;
		vm.currentLanguage = imsTranslation.language;
		vm.showPrices = vm.config.evo.cart.showPrices && vm.dialogConfig.prices.show;
		vm.shippingTypes = CART_SHIPPING_TYPES;
		vm.showBendingProgramDownload = vm.config.ims.queue.bendingProgramDownload;
		vm.openBendFileDialog = BendFileDownloadService.open;
		vm.getSearchResults = OrderTagsViewService.getSearchResults;
		vm.inProgress = false;
		vm.projects = ProjectService.projects;

		vm.showProfileDetailsButton = nuitAuth.getEvoVersion() === 3;
		vm.imsNextChannel = imsNextChannel;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.markModified = markModified;
		vm.markModifiedProduct = markModifiedProduct;
		vm.updateOrder = updateOrder;
		vm.getMaterialById = imsMaterials.getMaterialById;
		vm.openEditor = openEditor;
		vm.getDocumentURL = imsUtils.getDocumentURL;
		vm.downloadDocument = imsUtils.downloadDocument;
		vm.openDocument = imsUtils.openDocument;
		vm.filterMaterialsForAttribute = filterMaterialsForAttribute;
		vm.filterColorsForAttribute = filterColorsForAttribute;
		vm.hide = hide;
		vm.showSaveButton = showSaveButton;
		vm.openImage = imsUtils.openImage;
		vm.isEditable = isEditable;
		vm.editAddress = AddressService.openAndSave;
		vm.addAttachment = function(){OrderViewService.addAttachment(vm);};
		vm.addProduct = OrderViewService.addProduct;
		vm.addProfile = OrderViewService.addProfile;
		vm.onFlatProfilesUpdated = function(profiles) {
			vm.markModified();
		};
		vm.addSpecial = OrderViewService.addSpecial;
		vm.canSave = canSave;
		vm.displayPayment = function(){
			return false;
		};
		vm.getPerson = function(id){
			return nuitDataService.getOne(OrderViewService.assignedUsers, id);
		};
		vm.ASSIGNEES_NAME = OrderViewService.ASSIGNEES_NAME;

		vm.isConical = nuitProfiles.isConical;
		vm.hasCuts = nuitProfiles.hasCuts;
		vm.hasStamps = nuitProfiles.hasStamps;
		vm.getPunchCount = nuitProfiles.getPunchCount;
		vm.isHoliday = EVOConfigService.isHoliday;
		vm.getTitle = OrderQueryService.getTitle;
		vm.showPosNumber = OrderQueryService.showPosNumber;
		vm.allMarkedForDeletion = PositionsService.allMarkedForDeletion;
		vm.focusProjectSearch = ProjectsViewService.focusSearch;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorUpdatingItemToast() {
			return $mdToast
				.simple()
				.textContent('Error updating cart')
				.position('bottom right')
				.hideDelay(500);
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Sets all required variables which are needed by the view and loads current material into scope
		 */
		function init() {
			if (isMaterialRequired()) {
				imsMaterials.reload();
			}
			if (isColorRequired()) {
				imsColors.reload();
			}
			OrderViewService.setApi('OrderService');
			OrderTagsService.reload();
			ProjectService.reload();

			if(vm.config.evo.cart && vm.config.evo.cart.assignee && vm.config.evo.cart.assignee.enabled){
				OrderViewService.loadAssignees(vm.config.evo.cart.assignee.users);
			}
		}

		/**
		 * Returns true if a material is required in any attribute.
		 * @returns {Boolean}
		 */
		function isMaterialRequired() {
			if (vm.order.profiles.length > 0) {
				return true;
			}
			for (var j in vm.order.products) {
				if(vm.order.products[j].type==='profile'){
					return true;
				}

				for (var i in vm.order.products[j].attributes) {
					if (vm.order.products[j].attributes[i].type === 'material') {
						return true;
					}
				}
			}
			return false;
		}

		/**
		 * Returns true if a material is required in any attribute.
		 * @returns {Boolean}
		 */
		function isColorRequired() {
			for (var j in vm.order.products) {
				for (var i in vm.order.products[j].attributes) {
					if (vm.order.products[j].attributes[i].type === 'color') {
						return true;
					}
				}
			}
			return false;
		}

		function filterMaterialsForAttribute(attribute) {
			var blacklist = !!attribute.restrictions.blacklist;
			return function (material) {
				var matches = attribute.restrictions.materials.indexOf(material.id) >= 0 || attribute.restrictions.groups.indexOf(material.rawMaterialId) >= 0;
				return matches !== blacklist;
			};
		}

		function filterColorsForAttribute(attribute) {
			var blacklist = !!attribute.restrictions.blacklist;
			return function (color) {
				var matches = attribute.restrictions.colors.indexOf(color.id) >= 0;
				return matches !== blacklist;
			};
		}

		function markModified(position) {
			vm.orderForm.$setDirty();
		}

		function markModifiedProduct(product, index) {
			vm.orderForm.$setDirty();
		}

		/**
		 * Sends updated material to remote server
		 */
		function updateOrder() {
			vm.inProgress = true;
			OrderSpecialService.batchAddFlatProfiles(vm.order)
				.then(function() {
					if (angular.isDate(vm.order.details.completionDate)) {
						vm.order.details.completionDate = parseInt(vm.order.details.completionDate.getTime() / 1000);
					}

					var wrappedOrder = angular.copy(vm.order);
					wrappedOrder.tags = wrappedOrder.tags.map(function(entity){return {id:entity};});

					return OrderService
						.updateOrder(wrappedOrder)
						.then(function (response) {
							response.tags = response.tags.map(function(entity){return entity.id;});

							vm.order.profiles.splice(0, vm.order.profiles.length);
							angular.merge(vm.order, response);
							vm.orderForm.$setPristine();
							if (vm.cancelOnClose) {
								$mdDialog.hide(vm.order);
							}
						})
						.catch(function () {
							$mdToast.show(createErrorUpdatingItemToast());
						});
				})
				.finally(function() {
					vm.inProgress = false;
				});
		}

		function openEditor(profile) {
			var remark = profile.remark;
			var posNumber = profile.posNumber;
			imsUtils.openEditorAndSaveMultipleDefault(profile)
				.then(function (newProfile) {
					profile.positions[0].length = newProfile.length;
					profile.remark = remark;
					profile.posNumber = posNumber;
					vm.orderForm.$setDirty();
				});
		}

		function hide() {
			if(vm.cancelOnClose){
				$mdDialog.cancel();
			}else {
				if (angular.isDate(vm.order.details.completionDate)) {
					vm.order.details.completionDate = parseInt(vm.order.details.completionDate.getTime() / 1000);
				}
				$mdDialog.hide(vm.order);
			}
		}

		function showSaveButton() {
			return !vm.dialogConfig.positions.length || !vm.dialogConfig.positions.quantity;
		}

		function isEditable(attribute) {
			if (typeof attribute === 'boolean') {
				return attribute;
			} else if (typeof vm.dialogConfig.positions === 'boolean') {
				return !vm.dialogConfig.positions;
			} else {
				return false;
			}
		}

		function canSave(){
			if(vm.cancelOnClose){
				if(vm.config.ims.orders.easy.enabled){
					return (OrderSpecialService.flatProfiles.length>0 || vm.order.profiles.length>0) && vm.orderForm.$valid;
				}else{
					return vm.orderForm.$valid;
				}
			}else {
				return vm.orderForm.$valid && vm.orderForm.$dirty;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.general')
		.factory('CompanyService', CompanyService);

	/** @ngInject */
	function CompanyService($log, $mdDialog, RoleService, nuitUtils, nuitApi, nuitDataService) {

		var _companies = [];

		var service = initService();

		return service;

		function initService() {
			return {
				add: add,
				reload: reload,
				getById: getById,
				getByIdOffline: getByIdOffline,
				getUsers: getUsers,
				update: update,
				del: del,
				addPerson: addPerson,
				updatePerson: updatePerson,
				restorePerson: restorePerson,
				delPerson: delPerson,
				getAllOffline: getAllOffline,
				getRoleName: getRoleName,
				getEvoUrl: getEvoUrl,
				searchPerson: searchPerson,
				addAddress: addAddress,
				editAddress: editAddress,
				deleteAddress: deleteAddress
			};
		}

		function getAllOffline() {
			return _companies;
		}

		function reload(partial, additionalParams) {
			var params = partial ? {partial: 'id,name'} : {};

			if(partial && additionalParams && angular.isArray(additionalParams) && additionalParams.length>0){
				params.partial += ',' + additionalParams.join(',');
			}

			return RoleService.reload()
				.then(function () {
					return nuitApi('companies')
						.get(params)
						.then(function (response) {
							if(response.data) {
								if (partial) {
									for (var i = 0; i < response.data.length; i++) {
										response.data[i]._partial = true;
									}
								}

								return nuitDataService.replaceAll(_companies, response.data);
							}else{
								return _companies;
							}
						})
						.catch(function (error) {
							$log.error('Failed to load companies!');
							throw error;
						});
				});
		}

		function getById(id) {
			var company = getByIdOffline(id);
			var users = [];
			return getUsers(id).then(function (res) {
				users = res;
				if (company) {
					company._partial = false;
				}

				return nuitApi('companies.one', id).get()
					.then(function (response) {
						response.data._partial = false;
						response.data.users = users;
						if(!response.data.hasOwnProperty('addresses') || response.data.addresses===null){
							response.data.addresses = [];
						}
						if(!response.data.hasOwnProperty('deliveryAddresses') || response.data.deliveryAddresses===null){
							response.data.deliveryAddresses = [];
						}
						return nuitDataService.upsertOne(_companies, response.data);
					}).catch(function (e) {
						if (company) {
							company._partial = true;
						}
						e.data = id;
						throw e;
					});
			}).catch(function (e) {
				console.log(e);
			});
		}

		function getByIdOffline(id) {
			return nuitDataService.getOne(_companies, parseInt(id, 10));
		}

		function getUsers(id, params) {
			return nuitApi('companies.users', id).get(params)
				.then(function (response) {
					return response.data;
				});
		}

		function add(company) {
			return nuitApi('companies.add')
				.post(company)
				.then(function (response) {
					return nuitDataService.addOne(_companies, response.data);
				});
		}

		function update(id, company) {
			return nuitApi('companies.one', id)
				.put(company)
				.then(function (response) {
					return nuitDataService.updateOneEntity(company, response.data);
				});
		}

		function del(id) {
			return nuitApi('companies.one', id)
				.delete()
				.then(function (response) {
					nuitDataService.removeOneByKeys(_companies, {id: id});
				});
		}

		function addPerson(companyId, person) {
			return nuitApi('companies.users', companyId)
				.post(person)
				.then(function (response) {
					return nuitDataService.addOne(getByIdOffline(companyId).users, response.data);
				});
		}

		function updatePerson(companyId, personId, person, params) {
			return nuitApi('users.one', personId)
				.put(person,params)
				.then(function (response) {
					return nuitDataService.updateOne(getByIdOffline(companyId).users, response.data);
				});
		}

		function restorePerson(companyId, personId, person, params) {
			return nuitApi('companies.users.one', companyId, personId)
				.put(person,params)
				.then(function (response) {
					return nuitDataService.addOne(getByIdOffline(companyId).users, response.data);
				});
		}

		function delPerson(companyId, personId) {
			return nuitApi('companies.users.one', companyId, personId)
				.delete()
				.then(function (response) {
					nuitDataService.removeOneByKeys(getByIdOffline(companyId).users, {id: personId});
				});
		}

		function getRoleName(person) {
			var role = RoleService.getRoleById(person.roleId);
			if (role) {
				return role.name;
			} else {
				return '';
			}
		}

		function getEvoUrl(companyId, personId) {
			return nuitApi('companies.users.urls', companyId, personId)
				.get()
				.then(function (response) {
					return response.data.evoUrl;
				})
				.catch(function () {
					return null;
				});
		}

		function searchPerson(person, limit) {
			var params = {};

			params['userSearch'] = person;
			params['limit'] = limit;

			return nuitApi('companies')
				.get(params)
				.then(function (response) {
					for (var i = 0; i < response.data.length; i++) {
						var company = response.data[i];
						company._partial = false;
						nuitDataService.upsertOne(_companies, company);
					}

					return _companies;
				});
		}

		function addAddress(company,type){
			return getAddress(null,type)
				.then(function(address){
					return nuitApi('companies.' + type,company.id)
						.post(address)
						.then(function(response){
							company[type].push(response.data);
						});
				});
		}

		function editAddress(company,address,type){
			return getAddress(address, type)
				.then(function(newAddress){
					return nuitApi(type +'.one',address.id)
						.put(newAddress)
						.then(function(response){
							var addresses = angular.copy(company[type]);
							nuitDataService.replaceOne(addresses,response.data);
							nuitDataService.replaceAll(company[type],addresses);
						});
				});
		}

		function deleteAddress(company,addressId,type){
			nuitUtils.showDeleteConfirmation()
				.then(function(){
					return nuitApi(type+'.one',addressId)
						.delete()
						.then(function(){
							nuitDataService.removeOne(company[type],addressId);
						});
				});
		}

		function getAddress(address, type) {
			return $mdDialog.show(
				{
					controller: 'NewAddressController',
					controllerAs: 'vm',
					templateUrl: 'app/main/partners.general/dialogs/new-address/new-address.html',
					clickOutsideToClose: true,
					locals: {
						address: address,
						type: type
					}
				}
			)
				.then(function(address){
					return address;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.service('CompanyNumberService', CompanyNumberService);

	/** @ngInject */
	function CompanyNumberService($q, $timeout, nuitApi, nuitDataService) {
		var _companyNumbers = [];
		var _templateFields = [];

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			createCompanyNumber: createCompanyNumber,
			reload: reload,
			updateCompanyNumber: updateCompanyNumber,
			loadOneCompanyNumber: loadOneCompanyNumber,
			deleteCompanyNumber: deleteCompanyNumber,
			reloadTpl: reloadTpl
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'companyNumbers', {
			get: function () {
				return _companyNumbers;
			}
		});
		Object.defineProperty(service, 'templateFields', {
			get: function () {
				return _templateFields;
			}
		});

		return service;

		//*******************************************
		// METHODS
		//*******************************************
		function createCompanyNumber(companynumber) {

			return nuitApi('companies.companynumbers').post(companynumber)
				.then(function (response) {
					_companyNumbers.push(response.data);
				})
				.catch(function (error) {
					throw error;
				});
		}

		function loadOneCompanyNumber(id){
			return nuitApi('companies.companynumbers.one', id)
				.get()
				.then(function (response) {
					var companyNumber = response.data;
					return companyNumber;

				});
		}

		function reload(){
			return nuitApi('companies.companynumbers')
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(_companyNumbers, response.data);
				});
		}

		function updateCompanyNumber(companynumber){

			return nuitApi('companies.companynumbers.one',companynumber.id)
				.put(companynumber)
				.then(function(response){
					return nuitDataService.replaceOne(_companyNumbers, response.data);
				});
		}

		function deleteCompanyNumber(companynumber){
			return nuitApi('companies.companynumbers.one', companynumber.id)
				.delete()
				.then(function (response) {
					return nuitDataService.removeOne(_companyNumbers, response.data);
				});
		}

		function reloadTpl(){
			return nuitApi('companies.companynumbers.tpl')
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(_templateFields, response.data);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.controller('PersonComposeController', PersonComposeController);

	/** @ngInject */
	function PersonComposeController($mdDialog,
									 UserService,
									 CompanyService,
									 ForwarderService,
									 nuitDataService,
									 nuitConfig,
									 nuitUtils,
									 nuitApi,
									 company,
									 person,
									 type) {

		var vm = this;

		init();

		function init() {
			console.log(person);
			initVariables();
			initMethodes();
		}

		function initVariables() {
			vm.company = company;
			vm.newPerson = person === null;
			vm.person = vm.newPerson ? {} : angular.copy(person);
			vm.config = nuitConfig.getCurrent();
			vm.forwarder = type === 'forwarder';
			vm.deletedUser = null;
			vm.loadingDeletedUser = false;
		}

		function initMethodes() {
			vm.init = init;
			vm.savePerson = savePerson;
			vm.restorePerson = restorePerson;
			vm.updateCachedPerson = updateCachedPerson;
			vm.updateEmailState = updateEmailState;
			vm.hide = hide;
		}

		function savePerson() {
			if (vm.personForm.$invalid) {
				console.log('invalid');
				return;
			}

			if (vm.person.password && vm.person.password.length > 0) {
				if (!nuitUtils.isValidPassword(vm.person.password) || vm.person.password !== vm.person.passwordRepeat) {
					return;
				}
			}

			if (vm.newPerson) {
				console.log('new person');
				addPerson();
			} else {
				console.log('update person');
				updatePerson();
			}
		}

		function addPerson() {
			if (vm.forwarder) {
				ForwarderService.addPerson(vm.company.id, vm.person)
					.then(function (response) {
						vm.company = response;
						hide();
						nuitUtils.showSuccessToast();
					})
					.catch(function (err) {
						nuitUtils.showErrorToast();
					});

			} else {
				CompanyService.addPerson(vm.company.id, vm.person)
					.then(function (response) {
						vm.company = response;
						hide();
						nuitUtils.showSuccessToast();
					})
					.catch(function (err) {
						nuitUtils.showErrorToast();
					});

			}
		}

		function updatePerson() {
			delete vm.person['password'];
			delete vm.person['passwordRepeat'];

			if (vm.forwarder) {
				ForwarderService.updatePerson(vm.company.id, vm.person.id, vm.person)
					.then(function (response) {
						vm.company = response;
						hide();
						nuitUtils.showSuccessToast();
					})
					.catch(function (err) {
						nuitUtils.showErrorToast();
					});
			} else {
				CompanyService.updatePerson(vm.company.id, vm.person.id, vm.person)
					.then(function (response) {
						vm.company = response;
						hide();
						nuitUtils.showSuccessToast();
					})
					.catch(function (err) {
						nuitUtils.showErrorToast();
					});
			}
		}

		function restorePerson(){
			if(!vm.forwarder && vm.deletedUser){
				CompanyService.restorePerson(vm.company.id, vm.deletedUser.id, vm.person,{undelete:true})
					.then(function (response) {
						vm.company = response;
						hide();
						nuitUtils.showSuccessToast();
					})
					.catch(function (err) {
						nuitUtils.showErrorToast();
					});
			}
		}

		function hide() {
			$mdDialog.cancel();
		}

		function updateCachedPerson() {
			if(vm.forwarder){
				nuitDataService.updateOne(ForwarderService.getByIdOffline(vm.company.id).users, vm.person);
			}else{
				nuitDataService.updateOne(CompanyService.getByIdOffline(vm.company.id).users, vm.person);
			}
			hide();
		}

		function updateEmailState(){
			if(!vm.forwarder && vm.newPerson){
				vm.loadingDeletedUser = true;
				UserService.getUserById(vm.person.email,{email:true,deleted:true})
					.then(function(user){
						vm.deletedUser = user;
					})
					.catch(function(){
						vm.deletedUser = null;
					})
					.finally(function(){
						vm.loadingDeletedUser = false;
					});
			}
		}
	}
}());

(function () {
    'use strict';
    angular
        .module('app.partners.general')
        .component('nuitPhone', {
            templateUrl: 'app/main/partners.general/components/nuit-phone.html',
            controllerAs: 'vm',
            bindings: {
                phone: '<',
                addLabel: '<'
            }
        });
}());

(function () {
	'use strict';
	angular
		.module('app.partners.general')
		.component('nuitPersonForm', {
			templateUrl: 'app/main/partners.general/components/nuit-person.form.html',
			controller: PersonFormController,
			controllerAs: 'vm',
			bindings: {
				person: '=',
				mandatoryPassword: '<',
				onPersonUpdated: '&',
				onEmailChanged: '&',
				showRestoreUserWarning: '<',
				forwarder: '<'
			}
		});

	/** @ngInject */
	function PersonFormController($translate, nuitUtils, nuitConfig, nuitApi, RoleService, imsTranslation) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.roles = RoleService.roles;
		vm.config = nuitConfig.getCurrent();
		vm.translation = imsTranslation;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = init;
		vm.onDisableLogin = onDisableLogin;
		vm.showPasswordInput = showPasswordInput;
		vm.isEmailChangeable = isEmailChangeable;
		vm.isPasswordChangeable = isPasswordChangeable;
		vm.updatePassword = updatePassword;
		vm.changeEmail = changeEmail;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			if (typeof vm.person.locale === 'undefined') {
				vm.person.locale = $translate.use();
			}

			vm.changePassword = false;
			RoleService.reload();

		}

		//*******************************************

		function onDisableLogin() {
			if (vm.disableLogin) {
				vm.person.status = 3;
			} else if (vm.person.status) {
				delete vm.person.status;
			}
		}

		function showPasswordInput(){
			return true;
			//return vm.person.id===undefined || vm.person.status!==3;
		}

		function isPasswordChangeable() {
			return angular.isString(vm.person.password) && vm.person.password.length >= 3 && vm.person.password === vm.person.passwordRepeat;
		}

		function isEmailChangeable()
		{
			return angular.isString(vm.newEmail) && vm.newEmail.length>3 &&
				angular.isString(vm.passwordForEmail) && vm.passwordForEmail.length >= 3 &&
				angular.isString(vm.passwordRepeatForEmail) && vm.passwordRepeatForEmail.length >= 3 &&
				vm.passwordForEmail === vm.passwordRepeatForEmail;
		}

		function updatePassword() {
			if (nuitUtils.isValidPassword(vm.person.password)) {
				var promise;
				if(vm.person.status===3){
					promise = nuitApi('users.one', vm.person.id)
						.patch({password: vm.person.password})
						.then(function(response){
							vm.person.status = response.data.status;
						});
				}else{
					promise = nuitApi('user.password', vm.person.id)
						.put({password: vm.person.password});
				}

				promise
					.then(function () {
						nuitUtils.showSuccessToast();
						vm.person.password = '';
						vm.person.passwordRepeat = '';
						updateParent();
					})
					.catch(nuitUtils.showErrorToast);
			}
		}

		function changeEmail() {
			if (nuitUtils.isValidPassword(vm.passwordForEmail)) {
				nuitApi('user.password', vm.person.id)
					.put({
						password: vm.passwordForEmail,
						email: vm.person.email,
						newEmail: vm.newEmail
					})
					.then(function () {
						nuitUtils.showSuccessToast();
						vm.person.email = vm.newEmail;
						vm.passwordForEmail = '';
						vm.passwordRepeatForEmail = '';
						vm.newEmail = '';
						updateParent();
					})
					.catch(nuitUtils.showErrorToast);
			}
		}

		function updateParent(){
			vm.changePassword = false;
			if(vm.onPersonUpdated){
				vm.onPersonUpdated();
			}
		}
	}
}());

(function () {
    'use strict';
    angular
        .module('app.partners.general')
        .component('nuitEmail', {
            templateUrl: 'app/main/partners.general/components/nuit-email.html',
            controllerAs: 'vm',
            bindings: {
                email: '<',
                addLabel: '<'
            }
        });
}());

(function () {
	'use strict';

	angular
		.module('app.orders.settings', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, ORDERS_SETTINGS_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.order_number', {
				url: '/order_number',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.settings/views/number-list.html',
						controller: 'NumberController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.orderSettings.orderNumbers.enabled'
			})
			.state('app.order_number.order_number_details', {
				url: '/:numberId',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.settings/views/partials/number-details.html',
						controller: 'NumberDetailsController as vm'
					}
				},
				permission: 'ims.orderSettings.orderNumbers.enabled'
			})

			.state('app.offer_number', {
					url: '/offer_number',
					views: {
						'content@app': {
							templateUrl: 'app/main/orders.settings/views/number-list.html',
							controller: 'NumberController as vm'
						}
					},
					reloadOnSearch: false,
					permissions: 'ims.orderSettings.offerNumbers.enabled'
				})
			.state('app.offer_number.offer_number_details', {
				url: '/:numberId',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.settings/views/partials/number-details.html',
						controller: 'NumberDetailsController as vm'
					}
				},
				permission: 'ims.orderSettings.offerNumbers.enabled'
			})
			.state('app.order_tags', {
				url: '/order_tags',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.settings/views/tag-list.html',
						controller: 'OrderTagListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.orderSettings.tags.enabled'
			})
		;
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('orders.settings', {
			title: 'Settings',
			icon: 'icon-cog',
			translate: 'APP.SETTINGS_NAV',
			weight: 100,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.orderSettings.enabled;
			}
		});

		msNavigationServiceProvider.saveItem('orders.settings.order_configuration', {
			title: 'order_configuration',
			icon: 'icon-numeric',
			state: 'app.order_number',
			translate: 'ORDER.ORDER_CONFIG_NAV',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.orderSettings.orderNumbers.enabled;
			}
		});
		msNavigationServiceProvider.saveItem('orders.settings.offer_configuration', {
			title: 'offer_configuration',
			icon: 'icon-numeric',
			state: 'app.offer_number',
			translate: 'ORDER.OFFER_CONFIG_NAV',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.orderSettings.offerNumbers.enabled;
			}
		});
		msNavigationServiceProvider.saveItem('orders.settings.tags', {
			title: 'order-tags',
			icon: 'icon-tag',
			state: 'app.order_tags',
			translate: 'ORDER.TAGS',
			weight: 0,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.orderSettings.enabled || !nuitConfigProvider.getCurrent().ims.orderSettings.tags.enabled;
			}
		});
        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(ORDERS_SETTINGS_SETTINGS);
		//*******************************************

		//*******************************************
		// ROUTES
		//*******************************************
		nuitApiProvider.register('order.ordernumbers', 'shop/orders/numbers', {allow: ['post','get']});
		nuitApiProvider.register('order.ordernumbers.one', 'shop/orders/numbers/:id', {allow: ['get','put','delete']});
		nuitApiProvider.register('order.ordernumbers.tpl', 'shop/orders/numbers/templates', {allow: ['get']});
		nuitApiProvider.register('offer.offernumbers', 'shop/offers/numbers', {allow: ['post','get']});
		nuitApiProvider.register('offer.offernumbers.one', 'shop/offers/numbers/:id', {allow: ['get','put','delete']});
		nuitApiProvider.register('offer.offernumbers.tpl', 'shop/offers/numbers/templates', {allow: ['get']});

		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders.settings')
		.service('OrderTagsViewService', OrderTagsViewService);

	/** @ngInject */
	function OrderTagsViewService($q, $mdSelect, $timeout, $filter, nuitApi, nuitDataService, nuitUtils, OrderTagsService) {
		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			createEditTagDialog:createEditTagDialog,
			getSearchResults:getSearchResults,
			openTags: openTags,
			containsSearchTerm: containsSearchTerm,
			addTag: addTag
		};

		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************


		return service;

		//*******************************************
		// METHODS
		//*******************************************
		function openTags(event,selected, setDirty){
			if(event.target.classList.contains('md-text')){
				selected.splice($(event.target).index(),1);
				if(setDirty) {
					setDirty();
				}
				event.preventDefault();
				event.stopPropagation();
				$('md-select-menu').css('display','none');
				$timeout(function(){
					$mdSelect.hide();
				},10);
				$timeout(function(){
					$('md-select-menu').css('display','block');
				},500);
			}else{
				$timeout(function(){
					$('#search').focus();
				},100);
			}
		}
		 function containsSearchTerm(tag,searchText,exactMatch){
			var name = $filter('nuitTranslate')(tag.localizedName,tag.name);

			if(searchText==='' || searchText===undefined){
				return true;
			}

			if(exactMatch){
				return name.toLowerCase()===searchText.toLowerCase();
			}else{
				return name.toLowerCase().indexOf(searchText.toLowerCase())!==-1;
			}
		}

		 function getSearchResults(searchText, exactMatch){
			var tags = [];

			if(OrderTagsService.tags) {
				for (var i = 0; i < OrderTagsService.tags.length; i++) {
					var tag = OrderTagsService.tags[i];
					if (containsSearchTerm(tag, searchText, exactMatch)) {
						tags.push(tag);
					}
				}
			}

			return tags;
		}

		 function addTag(orderOrOffer, name){

			var tag = nuitDataService.getOneByKeys(OrderTagsService.tags,{name: name});
			//console.error($('#tagSelect'));
			//$('body').focus();

			//$mdDialog
			//	.show(OrderTagsViewService.createEditTagDialog({name:name}))
			//	.then(function (result) {

			 var internalAddTag = function(tag) {
				 if (!orderOrOffer.tags) {
					 orderOrOffer.tags = [];
				 }

				 orderOrOffer.tags.push(tag.id);
			 };

			 if(tag) {
				 internalAddTag(tag);
			 }else{
				 OrderTagsService.add({name: name})
					 .then(function (result) {
						 internalAddTag(result);
					 })
					 .catch(nuitUtils.showErrorToast);
			 }
			//});
		}

		function createEditTagDialog(tag) {
			return {
				controller: 'EditOrderTagDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/orders.settings/dialogs/edit-order-tag/edit-order-tag.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Tag: angular.copy(tag)
				}
			};
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders.settings')
		.service('NumberConfigService', NumberConfigService);

	/** @ngInject */
	function NumberConfigService($q, $timeout, nuitApi, nuitDataService) {
		var _numbers = [];
		var _templateFields = [];

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			createNumber: createNumber,
			reload: reload,
			updateNumber: updateNumber,
			loadOneNumber: loadOneNumber,
			deleteNumber: deleteNumber,
			reloadTpl: reloadTpl
		};

		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'numbers', {
			get: function () {
				return _numbers;
			}
		});
		Object.defineProperty(service, 'templateFields', {
			get: function () {
				return _templateFields;
			}
		});

		return service;

		//*******************************************
		// METHODS
		//*******************************************
		function createNumber(number, type) {

			return nuitApi(type +'.'+ type +'numbers').post(number)
				.then(function (response) {
					_numbers.push(response.data);
				})
				.catch(function (error) {
					throw error;
				});
		}

		function loadOneNumber(id, type){
			console.log(type +'.'+ type +'numbers.one', id);
			return nuitApi(type +'.'+ type +'numbers.one', id)
				.get()
				.then(function (response) {
					var number = response.data;
					return number;

				});
		}

		function reload(type){
			return nuitApi(type +'.'+ type +'numbers')
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(_numbers, response.data);
				});
		}

		function updateNumber(number, type){

			return nuitApi(type +'.'+ type +'numbers.one',number.id)
				.put(number)
				.then(function(response){
					return nuitDataService.replaceOne(_numbers, response.data);
				});
		}

		function deleteNumber(number, type){
			return nuitApi(type +'.'+ type +'numbers.one', number.id)
				.delete()
				.then(function (response) {
					return nuitDataService.removeOne(_numbers, response.data);
				});
		}

		function reloadTpl(type){
			return nuitApi(type +'.'+ type + 'numbers.tpl')
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(_templateFields, response.data);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products.tags', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.tags', {
				url: '/tags',
				views: {
					'content@app': {
						templateUrl: 'app/main/merchandising.products.tags/views/tags.html',
						controller: 'TagsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.products.tags.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('merchandising.settings.tags', {
			title: 'Tags',
			icon: 'icon-ticket',
			state: 'app.tags',
			translate: 'PRODUCTS.TAGS_NAV',
			weight: 30,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.products.enabled ||
					   !nuitConfigProvider.getCurrent().ims.products.tags.enabled;
			}
		});
        //*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('product.tags', 'shop/tags', {allow: ['get', 'post']});
        nuitApiProvider.register('product.tag', 'shop/tags/:id', {allow: ['put', 'delete']});
        //*******************************************
	}
}());

(function () {
    'use strict';

    angular
        .module('app.products.tags')
        .controller('OrderTagListController', TagsController);

    /** @ngInject */
    function TagsController($mdDialog, imsTranslation, nuitApi, nuitUtils, OrderTagsService, OrderTagsViewService) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        vm.tags = OrderTagsService.tags;
        vm.selectedTag = null;
        vm.term = '';
        //*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        vm.addTag = addTag;
        vm.editTag = editTag;
        vm.deleteTag = deleteTag;
        //*******************************************

        //*******************************************
        // INITIALIZATION
        //*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // OBJECT CONSTANTS
        //*******************************************
        /**
         * Creates a new dialog which can be used to create or edit tags.
         * @param {Object} tag - existing tag or null
         * @returns {Object}
         */

        //*******************************************
        // METHODS
        //*******************************************
        /**
         * Initializes this controller.
         */
        function init() {
            OrderTagsService.reload();
        }
        /**
         * Shows the add tag dialog.
         */
        function addTag() {
            $mdDialog
                .show(OrderTagsViewService.createEditTagDialog())
                .then(function (result) {
					OrderTagsService.add(result)
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast);
                });
        }
        /**
         * Shows the edit tag dialog.
         * @param {Object} tag - tag object
         * @param {Object} $event - event data
         */
        function editTag(tag) {
            $mdDialog
                .show(OrderTagsViewService.createEditTagDialog(tag))
                .then(function (result) {
                    OrderTagsService.update(result)
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast);
                });
        }
        /**
         * Deletes the given tag.
         * @param {Object} tag - tag object
         * @param {Object} $event - event data
         */
        function deleteTag(tag, $event) {
            $event.stopPropagation();
            nuitUtils
                .showDeleteConfirmation()
                .then(function () {
					OrderTagsService.remove(tag.id)
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast);
                });
        }
    }
}());

(function () {
	'use strict';

	angular
		.module('app.orders.settings')
		.controller('NumberController', NumberController);

	/** @ngInject */
	function NumberController($q,
								   $state,
								   $timeout,
								   $scope,
								   $filter,
								   $interval,
								   OrderService,
							       OfferService,
								   nuitConfig,
								   nuitUtils,
								   ListSelectionService,
								   FormatterService,
								   OrderViewService,
								   FilterCountService,
								   NumberConfigService,
								   nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.loadingItems = true;
		vm.config = nuitConfig.getCurrent();
		vm.searchText = $state.params.term || '';
		vm.updateTimeout = null;
		vm.selection = ListSelectionService.get('numbers');
		vm.filterCount = FilterCountService.get('numbers');
		vm.orders = OrderService.orders;
		vm.offers = OfferService.offers;
		vm.numbers = [];
		vm.numberType = '';
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************

		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.toggleSelectNumber = vm.selection.toggleSelectedEntity;
		vm.toggleSelectedNumbers = toggleSelectedNumbers;
		vm.getFilterCount = vm.filterCount.get;
		vm.addNumber = addNumber;
		vm.deselectAll = vm.selection.deselectAll;
		vm.deleteSelected = deleteSelected;
		vm.openDetails = openDetails;
		vm.hasSelectableNumbers = hasSelectableNumbers;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		$scope.$on('$destroy', onDestroy);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {
			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}


		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			var startIndex = $state.current.name.indexOf('.');
			var endIndex = $state.current.name.indexOf('_');
			vm.numberType = $state.current.name.slice(startIndex+1,endIndex);
			console.log(vm.numberType);

			NumberConfigService.reload(vm.numberType)
				.then(function () {
					vm.numbers = NumberConfigService.numbers;
					vm.loadingItems = false;
				});
		}

		function stopRefreshing() {
			if (vm.updateTimeout !== null) {
				$interval.cancel(vm.updateTimeout);
			}
		}

		function onDestroy() {
			stopRefreshing();
		}

		/**
		 * Toggles the selected orders.
		 */
		function toggleSelectedNumbers() {
			vm.selection.toggleSelectedEntities(vm.numbers.filter(function (number) { return number.number === 0;}));
		}

		function hasSelectableNumbers(){
			return vm.numbers.filter(function (number) { return number.number === 0;}).length > 0;
		}


		function addNumber() {
			$state.go('app.'+vm.numberType+'_number.'+vm.numberType+'_number_details', {numberId: null});
		}

		function deleteSelected() {
			var promise;
			if (vm.getSelected().length > 1) {
				promise = nuitUtils.showDeleteMultiConfirm();
			} else if (vm.getSelected().length === 1) {
				promise = nuitUtils.showDeleteConfirmation();
			} else {
				return;
			}

			promise.then(function () {
				var promises = [];
				angular.forEach(vm.getSelected(), function (number) {
					var deletePromise = NumberConfigService
						.deleteNumber(number, vm.numberType)
						.then(function () {
							NumberConfigService.reload(vm.numberType);
						});
					promises.push(deletePromise);
				});
				vm.deselectAll();
				$q
					.all(promises)
					.then(nuitUtils.showSuccessToast)
					.catch(nuitUtils.showErrorToast);
			});

		}

		function openDetails(number) {
			$state.go('app.'+vm.numberType+'_number.'+vm.numberType+'_number_details', {
				numberId: number
			});

		}


	}
}());

(function () {
	'use strict';

	angular
		.module('app.credit')
		.controller('NumberDetailsController', NumberDetailsController);

	/** @ngInject */
	function NumberDetailsController($state,
										   $timeout,
										   $scope,
										   $filter,
										   $interval,
										   OrderService,
										   nuitConfig,
										   nuitUtils,
										   NumberConfigService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.numbers = NumberConfigService.numbers;
		vm.tplFields = [];
		vm.updatePossible = true;
		vm.requiredField = true;
		vm.showNumbers = false;
		vm.numberType = '';
		vm.loadingItems = true;

		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.updateNumber = updateNumber;
		vm.saveNumber = saveNumber;
		vm.setTpl = setTpl;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * These event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {


		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			var startIndex = $state.current.name.indexOf('.');
			var endIndex = $state.current.name.indexOf('_');
			vm.numberType = $state.current.name.slice(startIndex+1,endIndex);
			console.log(vm.numberType);
			NumberConfigService.reload(vm.numberType).then(function () {
				vm.numbers = NumberConfigService.numbers;

				NumberConfigService.reloadTpl(vm.numberType).then(function () {
					vm.tplFields = NumberConfigService.templateFields;
					var templateFields = angular.copy(vm.tplFields);
					vm.tplFields = [];
					templateFields.forEach(function (tplField) {
						tplField = tplField.replace(/{{|}}/gi, '');
						vm.tplFields.push(tplField);
					});
				});


				var tplFields = NumberConfigService.templateFields;

				var id = parseInt($state.params.numberId);
				var autoRenew = 0;

				if (id) {
					vm.showNumbers = true;

					vm.numbers.forEach(function (number) {
						if (number.autoRenew) {
							autoRenew += 1;
							if (autoRenew > 1) {
								vm.requiredField = false;
							}
						}

						if (number.id === id) {
							vm.numbers = number;
							vm.numbers.end = new Date((vm.numbers.end * 1000));
							vm.numbers.start = new Date((vm.numbers.start * 1000));
							if (number.number > 0) {
								vm.updatePossible = false;
							}
							if (!number.autoRenew) {
								vm.requiredField = false;
							}
						}
					});
				} else {

					vm.numbers.forEach(function (number) {
						if (number.autoRenew) {
							vm.requiredField = false;
						}
					});

					vm.numbers.autoRenew = undefined;

					if (vm.numbers.autoRenew === undefined) {
						if (vm.numbers.length === 0) {
							vm.numbers.autoRenew = true;
						} else {
							vm.numbers.autoRenew = false;
						}
					}

					vm.numbers.end = undefined;
					vm.numbers.start = undefined;
					vm.numbers.offset = undefined;
					vm.numbers.number = undefined;
					vm.numbers.renewOffset = undefined;
					vm.numbers.size = undefined;
					vm.numbers.tpl = undefined;

					if (vm.numbers.number === undefined) {
						vm.numbers.number = 0;
					}
				}
				vm.loadingItems = false;
			});
		}


		function setTpl(key) {
			if (vm.numbers.tpl === undefined) {
				vm.numbers.tpl = '';
			}
			vm.numbers.tpl = vm.numbers.tpl + '{{' + key + '}}';
			vm.numbersForm.$setDirty();
		}


		function updateNumber() {
			vm.numbers.start = Date.parse(vm.numbers.start) / 1000;
			vm.numbers.end = Date.parse(vm.numbers.end) / 1000;

			NumberConfigService
				.updateNumber(vm.numbers, vm.numberType)
				.then(function () {
					nuitUtils.showSuccessToast();
					$state.go('app.'+vm.numberType+'_number');
				})
				.catch(nuitUtils.showErrorToast);
		}

		function saveNumber() {
			var id = parseInt($state.params.numberId);

			if (id) {
				updateNumber(id);
			} else {
				vm.numbers.start = Date.parse(vm.numbers.start) / 1000;
				vm.numbers.end = Date.parse(vm.numbers.end) / 1000;
				vm.numbers.offset = vm.numbers.offset;
				if (vm.numbers.offset === undefined) {
					vm.numbers.offset = 0;
				}
				vm.numbers.size = vm.numbers.size;
				if (vm.numbers.size === undefined) {
					vm.numbers.size = 0;
				}
				vm.numbers.renewOffset = vm.numbers.renewOffset;
				if (vm.numbers.renewOffset === undefined) {
					vm.numbers.renewOffset = 0;
				}
				vm.numbers =
					{
						start: vm.numbers.start,
						end: vm.numbers.end,
						tpl: vm.numbers.tpl,
						offset: vm.numbers.offset,
						size: vm.numbers.size,
						number: vm.numbers.number,
						autoRenew: vm.numbers.autoRenew,
						renewOffset: vm.numbers.renewOffset
					};

				NumberConfigService
					.createNumber(vm.numbers, vm.numberType)
					.then(function () {
						vm.numbers = {};
						vm.numbersForm.$setPristine();
						nuitUtils.showSuccessToast();
						$state.go('app.'+vm.numberType+'_number');
					})
					.catch(function(error){
						if(error.data.error.includes('range')){
							nuitUtils.showErrorToast('APP.'+vm.numberType.toUpperCase()+'_NUMBER.ERROR_RANGE');
						}else{
							nuitUtils.showErrorToast();
						}
					});
			}

		}


	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies.admin', ['app.partners.general'])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.partners-companies-admin', {
				url: '/companies-admin',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/partners.companies.admin/views/partners.companies.admin.html',
                        controller: 'CompanyAdminDetailsController as vm'
                    }
                },
                reloadOnSearch: false
            });

        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('partners.companies-admin', {
			title: 'companies',
			icon: 'icon-domain',
			state: 'app.partners-companies-admin',
			translate: 'PARTNERS.COMPANIES_ADMIN_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.companies.admin.enabled;
			}
		});
        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
			ims:{
                companies: {
                    admin: {
                    	enabled: false
					}
                }
			}
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
    'use strict';

    angular
        .module('app.partners.companies.admin')
        .controller('CompanyAdminDetailsController', CompanyAdminDetailsController);

    function CompanyAdminDetailsController(
        $mdDialog,
        $scope,
        $translate,
        imsConfig,
        nuitUtils,
        CompanyService
    ) {

        var vm = this;

        init();

        function init() {
            initVariables();
            initMethodes();

            CompanyService
                .getById(vm.companyId)
                .then(function (company) {
                    vm.company = company;
                })
                .catch(function () {
					nuitUtils.showErrorToast();
                })
                .finally(function () {
                    vm.loadingCompany = false;
                });
        }

        function initVariables() {
        	vm.companyId = '25';
            vm.config = imsConfig.getCurrent();
            vm.conditions = [];
            vm.deadlines = [];

            vm.loadingCompany = true;
            vm.company = null;
            vm.selectedLanguage = $translate.use();
            vm.nameFormat = 'lastName# #firstName';
        }

        function initMethodes() {
            vm.updateCompany = updateCompany;
            vm.showPersonDialog = showPersonDialog;
            vm.delPerson = delPerson;
        }

        function updateCompany() {
            if (vm.companyForm.$invalid) {
                return;
            }

            CompanyService.update(vm.company.id, vm.company)
                .then(function (response) {
                    vm.company = response;
                    vm.companyForm.$setPristine();
                    vm.companyForm.$setUntouched();
                })
                .catch(function (err) {
					nuitUtils.showErrorToast();
                });
        }

        function delPerson(personId) {
            nuitUtils.showDeleteConfirmation().then(function() {
                CompanyService.delPerson(vm.companyId, personId)
                    .then(function (response) {
                        vm.company = response;
                    })
                    .catch(function (err) {
						nuitUtils.showErrorToast();
                    });
            });
        }

        function showPersonDialog(person) {

            $mdDialog.show({
                controller: 'PersonComposeController',
                controllerAs: 'vm',
                locals: {company: vm.company, person: person},
                templateUrl: 'app/main/partners.general/views/person-compose.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {

                }, function () {

                });
        }
    }
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.factory('RawMaterialDiscount', RawMaterialDiscount);

	/** @ngInject */
	function RawMaterialDiscount($q, $mdDialog, nuitApi, nuitDataService, imsMaterials, nuitUtils) {

		var _rawMaterials = [];

		var service = initService();

		Object.defineProperty(service, 'rawMaterials', {
			get: function () {
				return _rawMaterials;
			}
		});

		return service;

		function initService() {
			return {
				edit: edit,
				remove: remove,
				reload: reload
			};
		}

		function edit(company, discount, currentDiscounts) {
			var discountsCopy = angular.copy(currentDiscounts);

			if(discount) {
				nuitDataService.removeOneByKeys(discountsCopy, {rawMaterialId: discount.rawMaterialId});
			}

			return $mdDialog.show({
				controller: 'RawMaterialDiscountController',
				controllerAs: 'vm',
				locals: {discount: discount, currentDiscounts: discountsCopy},
				templateUrl: 'app/main/partners.companies/dialogs/raw-material-discount/raw-material-discount.html',
				clickOutsideToClose: false
			})
				.then(function(newEntity){
					return nuitApi('companies.discounts.rawmaterial', company.id, newEntity.rawMaterialId).put(newEntity)
						.then(function(response){
							var data = response.data;
							data.group = newEntity.group;
							return response.data;
						});
				});
		}

		function remove(company, index){
			return nuitUtils.showDeleteConfirmation()
				.then(function(){
					return nuitApi('companies.discounts.rawmaterial', company.id, company.discounts.rawMaterials[index].rawMaterialId).delete()
						.then(function(response){
							return true;
						});
				});
		}

		function reload(blackList){
			return imsMaterials.reloadGroups()
				.then(function(groups){
					if(blackList) {
						var filtered = [];
						for (var i = 0; i < groups.length; i++) {
							var material = groups[i];
							if (!nuitDataService.getOneByKeys(blackList, {rawMaterialId: material.id})) {
								filtered.push(material);
							}
						}
						return nuitDataService.replaceAll(_rawMaterials, filtered);
					}else{
						return nuitDataService.replaceAll(_rawMaterials, groups);
					}
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.factory('CompanyNotification', CompanyNotification);

	/** @ngInject */
	function CompanyNotification($q, $mdDialog, nuitApi, nuitDataService, imsMaterials, nuitUtils, CompanyService, DotNotationService) {
		var triggerTypes = ['accounting'];
		var _triggers = [];

		var service = initService();

		Object.defineProperty(service, 'triggers', {
			get: function () {
				return _triggers;
			}
		});

		return service;

		function initService() {
			return {
				add: add,
				update: update,
				remove: remove,
				reload: reload,
				addUser: addUser,
				getValidUsers: getValidUsers,
				addAdditional: addAdditional
			};
		}

		function add(company) {
			return $mdDialog.show({
				controller: 'AddTriggerController',
				controllerAs: 'vm',
				locals:{Company: company},
				templateUrl: 'app/main/partners.companies/dialogs/add-trigger/add-trigger.html',
				clickOutsideToClose: false
			})
				.then(function(trigger){
					if(company.notification){
						DotNotationService.add(
							company,
							'notification.trigger.'+trigger,
							{
								disableDefaultNotifications: false,
								receivers: []
							}
							);
					}
					return update(company);
				});
		}

		function addUser(trigger, company) {
			var users = getValidUsers(company, trigger);

			return $mdDialog.show({
				controller: 'AddNotificationUser',
				controllerAs: 'vm',
				locals:{Users: users},
				templateUrl: 'app/main/partners.companies/dialogs/add-notification-user/add-notification-user.html',
				clickOutsideToClose: false
			})
				.then(function(id){
					return id;
				});
		}

		function getValidUsers(company, trigger){
			var users = [];
			for(var i=0; i<company.users.length;i++){
				if(!nuitDataService.getOneByKeys(company.notification.trigger[trigger].receivers,{userId: company.users[i].id})){
					users.push(company.users[i]);
				}
			}

			return users;
		}

		function addAdditional(trigger, company) {
			return $mdDialog.show({
				controller: 'AddNotificationAdditional',
				controllerAs: 'vm',
				templateUrl: 'app/main/partners.companies/dialogs/add-notification-additional/add-notification-additional.html',
				clickOutsideToClose: false
			})
				.then(function(data){
					return data;
				});
		}

		function remove(company, trigger){
			return nuitUtils.showDeleteConfirmation()
				.then(function(){
					delete company.notification.trigger[trigger];
					return update(company);
				});
		}

		function reload(){
			var promises = [];

			for(var i=0;i<triggerTypes.length;i++){
				promises.push(
					nuitApi('companies.triggers').get({prefix:triggerTypes[i]})
				);
			}

			return $q.all(promises)
				.then(function(){

				})
				.catch(function(){
					return nuitDataService.replaceAll(_triggers, ['accountingInvoiceStatusChanged']);
				});
		}

		function update(company){
			return CompanyService.update(company.id, company)
				.then(function(updatedCompany){
					return nuitDataService.updateOneEntity(company, updatedCompany);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.controller('PartnersCompaniesController', PartnersCompaniesController);

	/** @ngInject */
	function PartnersCompaniesController() {
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.controller('CompanyComposeController', CompanyComposeController);

	/** @ngInject */
	function CompanyComposeController($translate,
									  $state,
									  CompanyService,
									  ForwarderService,
									  nuitConfig,
									  nuitUtils) {

		var vm = this;

		init();

		function init() {
			initVariables();
			initMethodes();
			console.log($state.params.type);
		}

		function initVariables() {
			vm.company = {};
			vm.company.type = 1;
			vm.company.users = [];
			vm.company.active = true;
			vm.company.admin = {};
			vm.company.showPrices = true;
			if($state.params.type === 'companies'){
				vm.companyCompose = true;
			}
			if($state.params.type === 'forwarders'){
				vm.companyCompose = false;
			}


			vm.config = nuitConfig.getCurrent();
			vm.selectedLanguage = $translate.use();
		}

		function initMethodes() {
			vm.init = init;
			vm.saveCompany = saveCompany;
		}

		function saveCompany() {
			if (vm.companyForm.$invalid) {
				return;
			}
			if($state.params.type === 'companies'){
				CompanyService.add(vm.company)
					.then(function (company) {
						nuitUtils.showSuccessToast();
						$state.go('app.partners-companies.details', {companyId: company.id}, {inherit: false});
					})
					.catch(function (error) {
						nuitUtils.showErrorToast();
					});
			}

			if($state.params.type === 'forwarders'){
				ForwarderService.add(vm.company)
					.then(function (forwarder) {
						nuitUtils.showSuccessToast();
						$state.go('app.transport.details', {forwarderId: forwarder.id}, {inherit: false});
					})
					.catch(function (error) {
						nuitUtils.showErrorToast();
					});
			}


		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.controller('CompanyNumbersDetailsController', CompanyNumbersDetailsController);

	/** @ngInject */
	function CompanyNumbersDetailsController($state, $timeout, $scope, $filter, $interval, OrderService, nuitConfig, nuitUtils, FormatterService,
											 OrderViewService, FilterCountService, nuitDataService, CompanyNumberService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.companyNumbers = [];
		vm.tplFields = [];
		vm.requiredField = true;
		vm.companyNumberId = parseInt($state.params.companynumberId);

		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.updateCompanyNumber = updateCompanyNumber;
		vm.saveCompanyNumber = saveCompanyNumber;
		vm.setTpl = setTpl;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {


		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			CompanyNumberService.reload().then(function () {
				vm.companyNumbers = CompanyNumberService.companyNumbers;

				CompanyNumberService.reloadTpl().then(function () {
					vm.tplFields = CompanyNumberService.templateFields;
					var templateFields = angular.copy(vm.tplFields);
					vm.tplFields = [];
					templateFields.forEach(function (tplField) {
						tplField = tplField.replace(/{{|}}/gi, '');
						vm.tplFields.push(tplField);
					});
				});


				var tplFields = CompanyNumberService.templateFields;

				var id = parseInt($state.params.companynumberId);
				var autoRenew = 0;

				if (id) {
					vm.companyNumbers.forEach(function (companynumber) {
						if (companynumber.autoRenew) {
							autoRenew += 1;
							if (autoRenew > 1) {
								vm.requiredField = false;
							}
						}
						if (companynumber.id === id) {
							vm.companyNumbers = companynumber;
							vm.companyNumbers.end = new Date((vm.companyNumbers.end * 1000));
							vm.companyNumbers.start = new Date((vm.companyNumbers.start * 1000));

							if (!companynumber.autoRenew) {
								vm.requiredField = false;
							}
						}
					});
				} else {
					/*vm.companyNumbers.forEach(function (companynumber) {
						if (companynumber.autoRenew) {
							vm.requiredField = false;
						}
					});*/

					//vm.companyNumbers.autoRenew = undefined;

					/*if (vm.companyNumbers.autoRenew === undefined) {
						if (vm.companyNumbers.length === 0) {
							vm.companyNumbers.autoRenew = true;
						} else {
							vm.companyNumbers.autoRenew = false;
						}
					}*/

					//vm.companyNumbers.end = undefined;
					//vm.companyNumbers.start = undefined;
					vm.companyNumbers.offset = undefined;
					vm.companyNumbers.number = undefined;
					//vm.companyNumbers.renewOffset = undefined;
					vm.companyNumbers.size = undefined;
					vm.companyNumbers.tpl = undefined;

					if (vm.companyNumbers.number === undefined) {
						vm.companyNumbers.number = 0;
					}
				}
			});
		}


		function setTpl(key) {
			if (vm.companyNumbers.tpl === undefined) {
				vm.companyNumbers.tpl = '';
			}
			vm.companyNumbers.tpl = vm.companyNumbers.tpl + '{{' + key + '}}';
			vm.companyNumbersForm.$setDirty();
		}


		function updateCompanyNumber() {
			vm.companyNumbers.start = Date.parse(vm.companyNumbers.start) / 1000;
			vm.companyNumbers.end = Date.parse(vm.companyNumbers.end) / 1000;

			CompanyNumberService
				.updateCompanyNumber(vm.companyNumbers)
				.then(function () {
					nuitUtils.showSuccessToast();
					$state.go('app.partners-companynumbers');
				})
				.catch(nuitUtils.showErrorToast);
		}

		function saveCompanyNumber() {
			var id = parseInt($state.params.companynumberId);

			if (id) {
				updateCompanyNumber(id);
			} else {

				/*vm.companyNumbers.start = Date.parse(vm.companyNumbers.start) / 1000;
				vm.companyNumbers.end = Date.parse(vm.companyNumbers.end) / 1000;
				vm.companyNumbers.offset = vm.companyNumbers.offset;
				if (vm.companyNumbers.offset === undefined) {
					vm.companyNumbers.offset = 0;
				}
				vm.companyNumbers.size = vm.companyNumbers.size;
				if (vm.companyNumbers.size === undefined) {
					vm.companyNumbers.size = 0;
				}
				vm.companyNumbers.renewOffset = vm.companyNumbers.renewOffset;
				if (vm.companyNumbers.renewOffset === undefined) {
					vm.companyNumbers.renewOffset = 0;
				}*/
				vm.companyNumbers =
					{
						//start: vm.companyNumbers.start,
						//end: vm.companyNumbers.end,
						tpl: vm.companyNumbers.tpl,
						offset: vm.companyNumbers.offset,
						size: vm.companyNumbers.size,
						number: vm.companyNumbers.number,
						//autoRenew: vm.companyNumbers.autoRenew,
						//renewOffset: vm.companyNumbers.renewOffset
					};

				CompanyNumberService
					.createCompanyNumber(vm.companyNumbers)
					.then(function () {
						vm.companyNumbers = {};
						vm.companyNumbersForm.$setPristine();
						nuitUtils.showSuccessToast();
						$state.go('app.partners-companynumbers');
					})
					.catch(function(error){
						if(error.data.error.includes('range')){
							nuitUtils.showErrorToast('APP.INVOICE_NUMBER.ERROR_RANGE');
						}else{
							nuitUtils.showErrorToast();
						}
					});
			}

		}


	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.controller('CompanyNumbersController', CompanyNumbersController);

	/** @ngInject */
	function CompanyNumbersController($q, $state, $timeout, $scope, $filter, $interval,
									  OrderService, nuitConfig, nuitUtils, ListSelectionService,
									  FormatterService, FilterCountService,
									  nuitDataService, CompanyNumberService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.loading = true;
		vm.config = nuitConfig.getCurrent();
		vm.orders = OrderService.orders;
		vm.searchText = $state.params.term || '';
		vm.updateTimeout = null;
		vm.selection = ListSelectionService.get('companies.company-numbers');
		vm.filterCount = FilterCountService.get('companies.company-numbers');
		vm.ordersToProcess = 0;
		vm.companyNumbers = CompanyNumberService.companyNumbers;;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************

		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.toggleSelectCompanyNumber = vm.selection.toggleSelectedEntity;
		vm.toggleSelectedCompanyNumbers = toggleSelectedCompanyNumbers;
		vm.getFilterCount = vm.filterCount.get;
		vm.addCompanyNumber = addCompanyNumber;
		vm.deselectAll = vm.selection.deselectAll;
		vm.deleteSelected = deleteSelected;
		vm.openDetails = openDetails;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		$scope.$on('$destroy', onDestroy);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * This event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {
			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}


		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {

			CompanyNumberService.reload();
		}

		function stopRefreshing() {
			if (vm.updateTimeout !== null) {
				$interval.cancel(vm.updateTimeout);
			}
		}

		function onDestroy() {
			stopRefreshing();
		}

		/**
		 * Toggles the selected .
		 */
		function toggleSelectedCompanyNumbers() {
			vm.selection.toggleSelectedEntities(vm.companyNumbers);
		}


		function addCompanyNumber() {
			$state.go('app.partners-companynumbers.details', { companynumberId: null});

		}

		function deleteSelected() {
			var promise;
			if (vm.getSelected().length > 1) {
				promise = nuitUtils.showDeleteMultiConfirm();
			} else if (vm.getSelected().length === 1) {
				promise = nuitUtils.showDeleteConfirmation();
			} else {
				return;
			}

			promise.then(function () {
				var promises = [];
				angular.forEach(vm.getSelected(), function (companyNumber) {
					var deletePromise = CompanyNumberService
						.deleteCompanyNumber(companyNumber)
						.then(function () {
							CompanyNumberService.reload();
						});
					promises.push(deletePromise);
				});
				vm.deselectAll();
				$q
					.all(promises)
					.then(nuitUtils.showSuccessToast)
					.catch(nuitUtils.showErrorToast);
			});

		}

		function openDetails(companyNumber) {
			$state.go('app.partners-companynumbers.details', {
				companynumberId: companyNumber
			});

		}


	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.controller('CompanyDetailsController', CompanyDetailsController);

	function CompanyDetailsController($mdDialog,
									  $q,
									  $state,
									  $translate,
									  imsConfig,
									  imsUtils,
									  nuitConfig,
									  nuitUtils,
									  nuitApi,
									  CompanyService,
									  PAYMENT,
									  InvoiceService,
									  RawMaterialDiscount,
									  nuitDataService,
									  $filter,
									  CreditService,
									  CompanyNotification,
									  UserService,
									  ListSelectionService) {

		var vm = this;

		init();

		function init() {
			initVariables();
			initProperties();
			initMethodes();

			CompanyService
				.getById(vm.companyId)
				.then(function (company) {
					vm.company = company;
					if(vm.config.ims.companies.rawMaterialDiscounts.enabled){
						RawMaterialDiscount.reload()
							.then(function () {
								vm.loadingRawMaterialDiscount = false;

								for(var i=0;i<RawMaterialDiscount.rawMaterials.length;i++){
									var rawMaterial = RawMaterialDiscount.rawMaterials[i];
									var discount = nuitDataService.getOneByKeys(vm.company.discounts.rawMaterials, {rawMaterialId: rawMaterial.id});
									if(discount){
										rawMaterial.discount = discount.percent;
										rawMaterial.oldDiscount = discount.percent;
									}else{
										rawMaterial.discount = 0;
										rawMaterial.oldDiscount = 0;
									}
								}
							});
					}

					if(vm.config.evo.cart && vm.config.evo.cart.payment && vm.config.evo.cart.payment.enabled) {
						for(var i=0;i<vm.config.evo.cart.payment.options.length;i++){
							var option = vm.config.evo.cart.payment.options[i];
							vm.paymentOptions.push(
								{
									enabled: option.enabled,
									id: option.id
								}
							);
							if(option.enabled){
								vm.defaultPaymentOptions.push(option.id);
							}
						}


						if (!vm.company.payment) {
							vm.company.payment = {
								override: false,
								options: angular.copy(vm.defaultPaymentOptions)
							};
						}
					}
				})
				.catch(function () {
					nuitUtils.showErrorToast();
				})
				.finally(function () {
					vm.loadingCompany = false;
				});

			if (vm.config.ims.accounting.enabled) {
				if ($state.params.invoiceId) {
					vm.originFromInvoice = true;
				}
				InvoiceService.reloadByCompanyId(null, null, null, vm.companyId)
					.then(function () {
						InvoiceService.reloadStatus();
						vm.orderDetail = vm.orderDetail.replace('details.', '');
						calculateSums();
						vm.companyInvoices = $filter('orderBy')(vm.companyInvoices, 'id', true);
						vm.loadingEntities = false;
					});
			}

			if (vm.config.ims.credit.enabled) {
				CreditService.reloadByCompanyId(vm.companyId)
					.then(function () {
						CreditService.reloadStatus();
						vm.orderDetail = vm.orderDetail.replace('details.', '');
						calculateCreditSums();
						vm.companyCredits = $filter('orderBy')(vm.companyCredits, 'id', true);
						vm.loadingCreditEntities = false;
					});
			}

		}

		function initVariables() {
			vm.config = imsConfig.getCurrent();
			vm.conditions =
				[
					{id: PAYMENT.IN_ADVANCE, formattedText: $translate.instant('COMPANY.PAYMENT_IN_ADVANCE')},
					{id: PAYMENT.ON_DELIVERY, formattedText: $translate.instant('COMPANY.PAYMENT_ON_DELIVERY')},
					{id: PAYMENT.PROPORTIONS, formattedText: $translate.instant('COMPANY.PAYMENT_PROPORTIONS')}
				];

			vm.deadlines = [];

			vm.loadingCompany = true;
			vm.company = null;
			vm.companyId = $state.params.companyId;
			vm.selectedLanguage = $translate.use();
			vm.nameFormat = 'lastName# #firstName';
			vm.PROPORTIONS = PAYMENT.PROPORTIONS;
			vm.companyInvoices = InvoiceService.invoices;
			vm.companyCredits = CreditService.credits;
			vm.selectedOrderBy = 'id';
			vm.selectedCreditOrderBy = 'id';
			vm.reverse = true;
			vm.reverseCredit = true;
			vm.currentTab = $state.params.active;
			vm.enableInvoiceTab = nuitConfig.getCurrent().ims.accounting.enabled;
			vm.enableCreditTab = nuitConfig.getCurrent().ims.credit.enabled;
			vm.statis = InvoiceService.statusFields;
			vm.creditStatus = CreditService.statusFields;
			vm.orderDetail = vm.config.ims.accounting.orderNameFormat;
			vm.sumUnpaid = null;
			vm.sumPaid = null;
			vm.creditSumTotalAmount = null;
			vm.creditSumRedeemed = null;
			vm.originFromInvoice = false;
			vm.currentPage = [];
			vm.currentCreditPage = [];
			vm.currentPageEntities = [];
			vm.currentCreditPageEntities = [];
			vm.loadingEntities = true;
			vm.loadingCreditEntities = true;

			vm.rawMaterials = RawMaterialDiscount.rawMaterials;
			vm.loadingRawMaterialDiscount = true;

			vm.paymentOptions = [];
			vm.defaultPaymentOptions = [];
		}

		function initProperties() {
			Object.defineProperty(vm, 'paymentCondition', {get: getCurrentCondition, set: setCurrentCondition});
		}

		function initMethodes() {
			vm.updateCompany = updateCompany;
			vm.saveNotificationSettings = saveNotificationSettings;
			vm.showPersonDialog = showPersonDialog;
			vm.delPerson = delPerson;
			vm.validatePaymentCondition = validatePaymentCondition;
			vm.getRoleName = CompanyService.getRoleName;
			vm.addAddress = CompanyService.addAddress;
			vm.editAddress = CompanyService.editAddress;
			vm.deleteAddress = CompanyService.deleteAddress;
			vm.isStandardAddress = isStandardAddress;
			vm.setStandardAddress = setStandardAddress;
			vm.orderBy = orderBy;
			vm.creditOrderBy = creditOrderBy;
			vm.showDetails = showDetails;
			vm.showCreditDetails = showCreditDetails;
			vm.goToOrigin = goToOrigin;
			vm.showAddButton = showAddButton;
			vm.showSignupButton = showSignupButton;
			vm.openSignup = openSignup;
			vm.showRestoreButton = showRestoreButton;
			vm.editEntity = editEntity;
			vm.deleteDiscount = deleteDiscount;
			vm.getRawMaterialName = getRawMaterialName;
			vm.openCredit = openCredit;
			vm.openRestoreDialog = openRestoreDialog;
			vm.togglePayment = togglePayment;
			vm.updateDiscount = updateDiscount;
		}

		function calculateSums() {
			vm.companyInvoices.forEach(function (invoice) {
				if (invoice.status === 2) {
					vm.sumUnpaid += invoice.sumGrossPrice;
				}
				if (invoice.status === 3) {
					vm.sumPaid += invoice.sumGrossPrice;
				}
			});
		}

		function calculateCreditSums() {
			vm.companyCredits.forEach(function (credit) {
				if(credit.status !== 4){
					vm.creditSumRedeemed += credit.sumRedeemed;
					vm.creditSumTotalAmount += credit.sumAmount;
				}
			});
		}

		function updateCompany() {
			if (vm.companyForm.$invalid) {
				return;
			}

			var discountPromises = [];

			if(vm.config.ims.companies.rawMaterialDiscounts.enabled){
				for(var i=0; i<vm.rawMaterials.length; i++){
					var rawMaterial = vm.rawMaterials[i];

					if(rawMaterial.hasChanged){
						delete rawMaterial.hasChanged;
						rawMaterial.oldDiscount = rawMaterial.discount;
							if(rawMaterial.discount===0){
								discountPromises.push(nuitApi('companies.discounts.rawmaterial', vm.company.id, rawMaterial.id).delete()
									.then(function(response){
										nuitDataService.removeOneByKeys(vm.company.discounts.rawMaterials, {rawMaterialId: rawMaterial.id});
									})
								);
							}else {
								discountPromises.push(nuitApi('companies.discounts.rawmaterial', vm.companyId, rawMaterial.id).put({
									rawMaterialId: rawMaterial.id,
									percent: rawMaterial.discount
								})
									.then(function (response) {
										if (!vm.company.discounts.rawMaterials) {
											vm.company.discounts.rawMaterials = [];
										}
										if (nuitDataService.getOneByKeys(vm.company.discounts.rawMaterials, {rawMaterialId: response.data.rawMaterialId})) {
											nuitDataService.replaceOneByKeys(vm.company.discounts.rawMaterials, response.data, {rawMaterialId: response.data.rawMaterialId});
										} else {
											vm.company.discounts.rawMaterials.push(response.data);
										}
									}));
							}
					}
				}
			}

			$q.all(discountPromises).then(function (response) {
				CompanyService.update(vm.company.id, vm.company)
					.then(function (response) {
						vm.company = response;
						vm.companyForm.$setPristine();
						vm.companyForm.$setUntouched();
						nuitUtils.showSuccessToast();
					})
					.catch(function (err) {
						nuitUtils.showErrorToast();
					});
			});
		}

		function saveNotificationSettings() {
			return CompanyService.update(vm.company.id, vm.company)
				.then(function (response) {
					vm.company = response;
					nuitUtils.showSuccessToast();
				})
				.catch(function () {
					nuitUtils.showErrorToast();
				});
		}

		function delPerson(personId) {
			nuitUtils.showDeleteConfirmation().then(function () {
				CompanyService.delPerson(vm.companyId, personId)
					.then(function (response) {
						nuitUtils.showSuccessToast();
					})
					.catch(function (err) {
						nuitUtils.showErrorToast();
					});
			});
		}

		function showPersonDialog(person) {
			$mdDialog.show({
				controller: 'PersonComposeController',
				controllerAs: 'vm',
				locals: {company: vm.company, person: person, type: ''},
				templateUrl: 'app/main/partners.general/views/person-compose.html',
				clickOutsideToClose: true
			});
		}

		function getCurrentCondition() {
			if (!vm.company) {
				return PAYMENT.ON_DELIVERY;
			}

			if (vm.company.paymentCondition === PAYMENT.IN_ADVANCE_PERCENTAGE) {
				return PAYMENT.IN_ADVANCE;
			} else if (vm.company.paymentCondition === PAYMENT.ON_DELIVERY_PERCENTAGE) {
				return PAYMENT.ON_DELIVERY;
			} else {
				return PAYMENT.PROPORTIONS;
			}
		}

		function setCurrentCondition(id) {
			if (id === PAYMENT.IN_ADVANCE) {
				vm.company.paymentCondition = PAYMENT.IN_ADVANCE_PERCENTAGE;
			} else if (id === PAYMENT.ON_DELIVERY) {
				vm.company.paymentCondition = PAYMENT.ON_DELIVERY_PERCENTAGE;
			} else if (id === PAYMENT.PROPORTIONS) {
				vm.company.paymentCondition = PAYMENT.PROPORTIONS_PERCENTAGE;
			}
		}

		function validatePaymentCondition() {
			if (typeof vm.company.paymentCondition === 'undefined') {
				vm.company.paymentCondition = PAYMENT.PROPORTIONS_PERCENTAGE;
			}

			vm.company.paymentCondition = Math.max(PAYMENT.ON_DELIVERY_PERCENTAGE, Math.min(vm.company.paymentCondition, PAYMENT.IN_ADVANCE_PERCENTAGE));
		}

		function isStandardAddress(addressId, type) {
			return vm.company[type] === addressId;
		}

		function setStandardAddress(addressId, type) {
			vm.company[type] = addressId;
			vm.companyForm.$setDirty();
		}

		function orderBy(key) {
			vm.selectedOrderBy = key;
			vm.reverse = !vm.reverse;
			vm.companyInvoices = $filter('orderBy')(vm.companyInvoices, key, vm.reverse);
		}

		function creditOrderBy(key) {
			vm.selectedCreditOrderBy = key;
			vm.reverseCredit = !vm.reverseCredit;
			vm.companyCredits = $filter('orderBy')(vm.companyCredits, key, vm.reverseCredit);
		}

		function showDetails(id) {
			$state.go('app.partners-companies.details.invoice_details', {
				invoiceId: id,
				invoiceOrigin: 'app.partners-companies.details'
			});
		}

		function showCreditDetails(id) {
			$state.go('app.partners-companies.details.credit_details', {
				creditId: id,
				companyId: vm.company.id,
				origin: 'app.partners-companies.details'
			});
		}

		function goToOrigin() {

			if (angular.isArray($state.params.invoiceOrigin)) {
				$state.params.invoiceOrigin = $state.params.invoiceOrigin[0];
				console.log($state.params.invoiceOrigin);
			}

			if ($state.params.invoiceOrigin === 'app.partners-companies.details') {
				$state.go('app.partners-companies', {
					page: $state.params.page
				}, {inherit: false});
			} else {
				$state.go('app.invoices.details', {
					invoiceId: $state.params.invoiceId,
					invoiceOrigin: $state.params.invoiceOrigin,
					start: $state.params.start
				}, {inherit: false});
			}
		}

		function showSignupButton(){
			return $state.params.active==='persons' && vm.config.ims.users.allowSignup;
		}

		function showAddButton(){
			switch($state.params.active){
				case 'persons':
				//case 'rawMaterialDiscount':
				case 'credit':
				case 'notifications':
					return true;

				default:
					return false;
			}
		}

		function showRestoreButton(){
			return $state.params.active==='persons';
		}

		function editEntity(entity){
			switch($state.params.active){
				case 'persons':
					vm.showPersonDialog(entity);
					return;
				case 'rawMaterialDiscount':
					RawMaterialDiscount.edit(this.company, entity, vm.company.discounts.rawMaterials)
						.then(function(newEntity){
							if(!vm.company.discounts.rawMaterials){
								vm.company.discounts.rawMaterials = [];
							}
							if(nuitDataService.getOneByKeys(vm.company.discounts.rawMaterials, {rawMaterialId: newEntity.rawMaterialId})){
								nuitDataService.replaceOneByKeys(vm.company.discounts.rawMaterials, newEntity,{rawMaterialId: newEntity.rawMaterialId});
							}else{
								vm.company.discounts.rawMaterials.push(newEntity);
							}
						});
					return;
				case 'credit':
					vm.openCredit(null);
					return;
				case 'notifications':
					CompanyNotification.add(this.company);
					return;
			}
		}

		function deleteDiscount(index){
			RawMaterialDiscount.remove(this.company,index)
				.then(function(){
					vm.company.discounts.rawMaterials.splice(index,1);
				});
		}

		function getRawMaterialName(id) {
			for(var i=0; i< vm.rawMaterials.length; i++){
				var material = vm.rawMaterials[i];
				if(material.id === id){
					return material.name;
				}
			}
		}

		function openCredit(id) {
				$state.go('app.partners-companies.details.credit_details', {
					creditId: id,
					companyId: vm.company.id,
					origin: '^',
				});
		}

		function openRestoreDialog(){
			CompanyService.getUsers(vm.company.id,{deleted: true})
				.then(function(users){
					imsUtils.openUserSelection([], {header:'APP.RESTORE',cancel:'APP.CANCEL',confirm:'APP.OK'})
						.then(function(selectedUsers){
							var promises = [];
							for (var i = 0; i < selectedUsers.length; i++) {
								promises.push(UserService.restoreUser(selectedUsers[i]));
							}
							$q.all(promises)
								.then(function(){
									CompanyService
										.getById(vm.companyId)
										.then(function (company) {
											vm.company = company;
										});
									nuitUtils.showSuccessToast();
								})
								.catch(function(){
									nuitUtils.showErrorToast();
								});
						});
				});
		}

		function togglePayment(on){
			if(on){
				for(var i=0;i<vm.paymentOptions.length;i++){
					if(vm.paymentOptions[i].enabled){
						vm.company.payment.options.push(vm.paymentOptions[i].id);
					}
				}
			}else{
				vm.company.payment.options = angular.copy(vm.defaultPaymentOptions);
			}
		}

		function openSignup(){
			imsUtils.openUserSignup(1, vm.company.id);
		}

		function updateDiscount(material){
			if(material.discount!==material.oldDiscount) {
				material.hasChanged = true;
			}
		}
	}
}());

(function () {
		'use strict';

		angular
			.module('app.partners.companies')
			.controller('CompaniesListController', CompaniesListController);

		/** @ngInject */
		function CompaniesListController($state,
										 $scope,
										 $filter,
										 $window,
										 $rootScope,
										 nuitUtils,
										 CompanyService,
										 nuitConfig,
										 nuitDataService,
										 ListSelectionService,
										 CustomerService) {

			var vm = this;
			vm.unregisterConfigListener = null;

			init();

			function init() {
				initVariables();
				initMethodes();
				initEvents();

				if(nuitConfig.isReady()) {
					reloadCompanies();
				}else{
					vm.unregisterConfigListener = $rootScope.$on('config::config.loaded',reloadCompanies);
				}
			}

			function reloadCompanies(){
				var additionalParams = null;

				if(vm.config.ims.companies.customerId.enabled){
					additionalParams = [];
					additionalParams.push(vm.config.ims.companies.customerId.field);
				}

				CompanyService
					.reload(true, additionalParams)
					.then(function (companies) {
						vm.entities = companies;
						filterAll();
					})
					.catch(function () {
						nuitUtils.showErrorToast();
					})
					.finally(function () {
						vm.loadingEntities = false;
					});

				if(vm.unregisterConfigListener!==null){
					vm.unregisterConfigListener();
				}
			}

			function initVariables() {
				vm.searchTypes = ['company','person'];
				vm.entities = [];
				vm.currentPage = [];
				vm.filteredEntities = [];
				vm.currentPageEntities = [];
				vm.loadingEntities = true;
				vm.term = ''; //search term
				vm.mode = vm.searchTypes[0];
				vm.selection = ListSelectionService.get('company', true);
				vm.config = nuitConfig.getCurrent();
				vm.paginationTerm = {};
				vm.selectedChar = null;

				vm.chars = [''];

				for(var i=65;i<=90;i++){
					vm.chars.push(String.fromCharCode(i));
				}
			}

			function initMethodes() {
				vm.search = search;
				vm.openDetail = openDetail;
				vm.getSelectedPersons = getSelectedPersons;
				vm.updateMode = updateMode;
				vm.delCompany = delCompany;

				vm.getSelected = vm.selection.getSelected;
				vm.isSelected = vm.selection.isSelected;
				vm.toggleSelected = vm.selection.toggleSelectedEntity;
				vm.toggleSelectedEntities = toggleSelectedEntities;
				vm.deleteSelection = deleteSelection;
				vm.getRoleName = CompanyService.getRoleName;
				vm.openEvoForUser = openEvoForUser;
				vm.loadCompany = loadCompany;
				vm.updatePaginationTerm = updatePaginationTerm;
				vm.getStandardAddress = getStandardAddress;
				vm.getCustomerId = CustomerService.getCustomerId;
			}

			function initEvents() {
				$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
			}

			function onStateChangeSuccess(event, toState, toParams, fromState, fromParams) {
				vm.term = $state.params.term || '';
				vm.mode = $state.params.mode || 'company';

				filterAll();

				if ($state.params.page && $state.params.page !== vm.currentPage) {
					vm.currentPage = $state.params.page;
				}
			}

			function filterAll() {
				if(vm.searchTypes.indexOf(vm.mode)>=0) {
					if(vm.mode==='person' && vm.term!==''){
						CompanyService.searchPerson(vm.term, vm.config.ims.companies.search.limit)
							.then(filterAllInternal);
					}else{
						filterAllInternal();
					}
				}
			}

			function filterAllInternal() {
				vm.filteredEntities = [];

				for (var i = 0; i < vm.entities.length; i++) {
					var company = vm.entities[i];
					if (filter(company)) {
						vm.filteredEntities.push(company);
					}
				}

				vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, 'name');
			}

			function filter(company) {
				if (vm.term === '') {
					return true;
				}

				if (vm.mode === 'company' &&
					(
						(company.address && company.address.name && company.address.name.toLowerCase().indexOf(vm.term.toLowerCase()) !== -1) ||
						(company.name && company.name.toLowerCase().indexOf(vm.term.toLowerCase()) !== -1) ||
						(vm.config.ims.companies.customerId.enabled && vm.getCustomerId(company).toLowerCase().indexOf(vm.term.toLowerCase())!==-1)
					)) {
					return true;
				}

				if (vm.mode === 'person') {
					if (!company.users) {
						return false;
					} else {
						for (var i = 0; i < company.users.length; i++) {
							if (personMatchesSearchTerm(company.users[i])) {
								return true;
							}
						}
					}
				}

				return false;
			}

			function personMatchesSearchTerm(person) {
				return person.lastName.toLowerCase().indexOf(vm.term.toLowerCase()) !== -1 ||
					person.firstName.toLowerCase().indexOf(vm.term.toLowerCase()) !== -1;
			}

			function getSelectedPersons(company) {
				if (!company.users) {
					return [];
				} else if (vm.mode === 'person') {
					var selectedPersons = [];

					for (var i = 0; i < company.users.length; i++) {
						{
							if (personMatchesSearchTerm(company.users[i])) {
								selectedPersons.push(company.users[i]);
							}
						}
					}

					return selectedPersons;
				}
				else {
					return company.users;
				}
			}

			function openDetail(companyId) {
				$state.go('app.partners-companies.details', {
					term: vm.term,
					companyId: companyId,
					mode: vm.mode,
					page: vm.currentPage
				}, {inherit: false});
			}

			function search() {
				$state.go('app.partners-companies', {term: vm.term, mode: vm.mode});
				vm.selection.deselectAll();
			}

			function updateMode() {
				filterAll();
			}

			function delCompany(company) {
				nuitUtils.showDeleteConfirmation().then(function () {
					CompanyService.del(company.id)
						.then(function (company) {
							filterAll();
							nuitUtils.showSuccessToast();
						})
						.catch(function (error) {
							nuitUtils.showErrorToast();
						});
				});
			}

			function deleteSelection() {
				nuitUtils.showDeleteConfirmation().then(function () {
					var selected = vm.getSelected();
					vm.selection.deselectAll();
					for (var i = 0; i < selected.length; i++) {
						CompanyService.del(selected[i].id)
							.then(function (company) {
								filterAll();
							})
							.catch(function (error) {
								nuitUtils.showErrorToast();
							});
					}
				});
			}

			function toggleSelectedEntities() {
				vm.selection.toggleSelectedEntities(vm.currentPageEntities);
			}

			function openEvoForUser(companyId, personId) {
				CompanyService.getEvoUrl(companyId, personId)
					.then(function (url) {
						$window.open(url, '_blank');
					})
					.catch(nuitUtils.showErrorToast);
			}

			function loadCompany(company) {
				return CompanyService.getById(company.id);
			}

			function updatePaginationTerm(){
				if(vm.selectedChar!=='') {
					vm.paginationTerm = {name: vm.selectedChar};
				}
			}

			function getStandardAddress(company){
				if(company.addressId!==null){
					var address = nuitDataService.getOne(company.addresses,company.addressId);
					if(address){
						return address;
					}else{
						return getFirstAddress(company.addresses);
					}
				}else if(angular.isArray(company.addresses) && company.addresses.length>0){
					return company.addresses[0];
				}else{
					return getFirstAddress(company.addresses);
				}
			}

			function getFirstAddress(addresses){
				if(angular.isArray(addresses) && addresses.length>0) {
					return addresses[0];
				}else{
					return null;
				}
			}
		}
	}

	()
);

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.constant('PAYMENT',
			{
				IN_ADVANCE: 1,
				ON_DELIVERY: 2,
				PROPORTIONS: 3,
				IN_ADVANCE_PERCENTAGE: 100,
				ON_DELIVERY_PERCENTAGE: 0,
				PROPORTIONS_PERCENTAGE: 50
			});
}());

(function () {
	'use strict';

	angular
		.module('app.orders', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, ORDERS_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.orders', {
				url: '/orders?group&status?page?term?startFilterDate?endFilterDate',
				views: {
					'content@app': {
						//template:'<vue-frame route="/invoices"></vue-frame>',
						templateUrl: 'app/main/orders.orders/views/orders.html',
						controller: 'OrdersController as vm'
					},
					'body@app.orders': {
						templateUrl: 'app/main/orders.orders/views/order-list.html',
						controller: 'OrderListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.orders.enabled'
			})
			.state('app.orders.detail', {
				url: '/:orderId?active?origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.orders/views/order-details.html',
						controller: 'OrderDetailsController as vm'
					},
					'forwarding@app.orders.detail':{
						templateUrl: 'app/main/orders.orders/views/partials/forwarding-details.html',
						controller: 'OrderForwardingDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.orders.enabled',
				data: {api: 'OrderService'}
			})
			.state('app.orders.detail.invoice', {
				url: '/invoice/:invoiceId?invoiceOrigin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.accounting/views/partials/invoice-details.html',
						controller: 'InvoiceDetailsController as vm'
					}
				},
				permission: 'ims.accounting.enabled'
			})
			.state('app.orders.detail.invoice.credit', {
				url: '/credits/:creditId?invoiceId?origin?invoiceOrigin?companyId',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.credit/views/partials/credit-details.html',
						controller: 'CreditDetailsController as vm'
					}
				},
				permission: 'ims.accounting.enabled'
			});

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('orders.orders', {
			title: 'orders',
			icon: 'icon-clipboard-check',
			state: 'app.orders',
			translate: 'ORDERS.ORDERS_NAV',
			weight: 20,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.orders.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(ORDERS_SETTINGS);
		//*******************************************
	}
})();

(function () {
	'use strict';

	angular
		.module('app.orders')
		.controller('OfferListController', OfferListController);

	/** @ngInject */
	function OfferListController($q, $rootScope, $state, $timeout, $scope, $filter, $interval, OfferService, nuitConfig, nuitUtils, ListSelectionService, FormatterService, OrderViewService, FilterCountService, nuitDataService, DateSearchService, OfferQueryService, CaseService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		OrderViewService.setApi('OfferService');
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.lastLoadedPage = -1;
		vm.currentPage = $state.params.page || 0;
		vm.currentPageEntities = [];
		vm.pagesLoading = [];
		vm.loading = true;
		vm.config = nuitConfig.getCurrent();
		vm.offers = OfferService.orders; // --- change to offers
		vm.meta = OfferService.meta;
		vm.searchText = $state.params.term || '';
		vm.statusFilter = $state.params.status || '0';
		vm.updateTimeout = null;
		vm.selection = ListSelectionService.get('order.offers', true);
		vm.offerStatus = [];
		vm.offerFilters = [];
		vm.status = {id: vm.statusFilter};
		vm.ordersToProcess = 0;
		vm.hasOrder = 0;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openDetails = openDetails;
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.search = search;
		vm.getStatusById = OfferService.getStatusById;
		vm.deleteSelected = OrderViewService.deleteSelected;
		vm.canBeDeleted = function(){return vm.ordersToProcess===0 && OrderViewService.canBeDeleted(vm, vm.config.ims.offers.canDeleteConditions);};
		vm.toggleSelectOffer = vm.selection.toggleSelectedEntity;
		vm.toggleSelectedOffers = toggleSelectedOffers;
		vm.isIndeterminate = function(entities){
			return vm.selection.isIndeterminate(entities.map(function(entity){return entity.id;}));
		};
		vm.moveToNextState = function() {
			OrderViewService.moveToNextState(vm)
				.then(function () {
					if (OfferQueryService.useBackend) {
						reloadOffers();
					} else {
						updateFilterCount();
						vm.selection.deselectAll();
					}
				});
		};
		vm.moveToPreviousState = function() {
			OrderViewService.moveToPreviousState(vm)
				.then(function () {
					if (OfferQueryService.useBackend) {
						reloadOffers();
					} else {
						updateFilterCount();
						vm.selection.deselectAll();
					}
				});
		};
		vm.loadPage = function(data){
			if(OfferQueryService.useBackend && vm.lastLoadedPage!==data.page+1) {
				reloadOffers({page: data.page+1})
					.then(function(){
						if(vm.meta.pagination.total_pages>=data.page+2) {
							reloadOffers({page: data.page + 2, skipSettingLastLoaded: true})
								.then(function(){
									if (data.page > 0) {
										reloadOffers({page: data.page, skipSettingLastLoaded: true});
									}
								});
						}
					});
			}
		};


		vm.getPreviousStatus = OrderViewService.api.getPreviousStatus;
		vm.getOrderPositions = OfferService.getOrderPositions;
		vm.setStatusFilter = setStatusFilter;
		vm.filterAll = filterAll;
		vm.isFilterSelected = isFilterSelected;
		vm.showStatusChangeButton = showStatusChangeButton;
		vm.getTitle = OfferQueryService.getTitle;
		vm.getTitleById = OfferQueryService.getTitleById;
		vm.dateFilterChanged = dateFilterChanged;
		Object.defineProperty(vm, 'nameFormat',{
			get: function(){
				return vm.config.ims.offers.nameFormat.length>0?vm.config.ims.offers.nameFormat:vm.config.ims.orders.nameFormat;
			}
		});

		vm.unregisterConfigListener = null;
		var now = new Date().getTime();
		vm.startFilterDate = new Date(now);
		vm.endFilterDate = new Date(now);
		vm.getFilterCount = getFilterCount;
		vm.updateFilterCount = updateFilterCount;
		vm.getPerson = function(id){
			return nuitDataService.getOne(OrderViewService.assignedUsers, id);
		};
		vm.ASSIGNEES_NAME = OrderViewService.ASSIGNEES_NAME;
		vm.loadAssignees = loadAssignees;
		vm.toggleOrderFilter = toggleOrderFilter;

		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		$scope.$on('$destroy', onDestroy);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		if(nuitConfig.isReady()) {
			init();
		}else{
			vm.unregisterConfigListener = $rootScope.$on('config::config.loaded',init);
		}
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {
			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}

			if ($state.params.page && $state.params.page !== vm.currentPage) {
				vm.currentPage = $state.params.page || 0;
			}

			if (typeof $state.params.status !== 'undefined') {
				vm.statusFilter = $state.params.status;
				vm.status = {id: $state.params.status};
			}else{
				vm.statusFilter = '0';
				vm.status = {id: vm.statusFilter};
			}

			if($state.params.startFilterDate && $state.params.endFilterDate){
				vm.startFilterDate = new Date(parseInt($state.params.startFilterDate));
				vm.endFilterDate = new Date(parseInt($state.params.endFilterDate));
				DateSearchService.setDates(vm.startFilterDate,vm.endFilterDate);
				DateSearchService.enabled = true;
			}

			filterAll();

			if(OfferQueryService.useBackend){
				if(vm.offerFilters.length>0) {
					vm.lastLoadedPage = -1;
					vm.currentPage = parseInt($state.params.page) || 0;
					OfferService.clear();
					vm.loadPage({page: vm.currentPage});
					updateFilterCount();
				}
			}else if(vm.statusFilter === '-1'){
				reloadOffers();
			}
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */

		function init() {
			DateSearchService.initDates(
				vm.config.ims.offers.list.dateFilter.startOffset,
				vm.config.ims.offers.list.dateFilter.endOffset
			);

			vm.startFilterDate = DateSearchService.startDate;
			vm.endFilterDate = DateSearchService.endDate;

			if (vm.unregisterConfigListener !== null) {
				vm.unregisterConfigListener();
			}

			updateFilterCount();

			OfferService.reloadConfig()
				.then(function(){
					nuitDataService.replaceAll(vm.offerFilters,OfferService.offerFilters);

					if(vm.statusFilter === '-1'){
						vm.status = {id:'-1'};
					}
					else if(vm.statusFilter === '0'){
						vm.status = vm.offerFilters[0];
					}else{
						vm.status = vm.offerFilters.find(function (filter){return filter.id === vm.status.id;});
					}
					vm.statusFilter = vm.status.id;
				});

			if (OfferService.statusLoading) {
				OfferService.statusLoading.then(reloadOffers);
			} else {
				reloadOffers();
			}

			if (angular.isNumber(vm.config.ims.orders.refreshInterval) && vm.config.ims.orders.refreshInterval > 0) {
				vm.updateTimeout = $interval(function () {
					reloadOffers();
				}, Math.max(2000, vm.config.ims.orders.refreshInterval));
			}
		}

		function reloadOffers(override) {
			if (!angular.isNumber(vm.config.ims.orders.refreshInterval) || vm.config.ims.orders.refreshInterval <= 0) {
				stopRefreshing();
				return;
			}

			vm.offerStatus = OfferService.getStatisByType('proposal');

			if (vm.offerStatus.length>0) {
				var filter = {view:'essential'};
				var allIds = vm.offerStatus.map(function (e) {
					return e.id;
				}).join(',');

				if(OfferQueryService.useBackend){
					filter.page = (override && override.page)?override.page:(parseInt(vm.currentPage) + 1);
					filter.sort_by = CaseService.snakeToCamelCase(vm.config.ims.offers.list.orderBy);
					filter.status = filter.status = vm.statusFilter==='-1'?allIds:vm.statusFilter;

					if(vm.searchText && vm.searchText.length>0){
						filter.title = vm.searchText;
					}

					if(DateSearchService.enabled && vm.config.ims.offers.list.dateFilter.enabled){
						var splitName = vm.config.ims.offers.list.dateFilter.filterDate.split('.');
						filter[splitName[splitName.length-1]] = [
							'gte:' +  Math.round(DateSearchService.startTimestamp/1000),
							'lte:' + Math.round(DateSearchService.endTimestamp/1000)
						];
					}
				}else{
					filter.status = allIds;
				}

				if(OfferQueryService.useBackend) {
					filter.hasOrder = vm.hasOrder; //this should get rid of offers that have an order
					if(vm.pagesLoading.indexOf(filter.page)!==-1){
						var deferred = $q.defer();
						deferred.resolve();
						return deferred.promise;
					}else {
						vm.pagesLoading.push(filter.page);
					}
				}

				return OfferQueryService
					.reload(filter)
					.then(function () {
						if(filter.page && !(override && override.skipSettingLastLoaded)) {
							vm.lastLoadedPage = filter.page;
						}

						var selected = vm.selection.getSelected();
						vm.selection.deselectAll();
						filterAll();
						$timeout(function () {
							for (var index in vm.filteredEntities) {
								if (selected.indexOf(vm.filteredEntities[index].id) >= 0) {
									vm.toggleSelectOffer(vm.filteredEntities[index].id);
								}
							}
						});
						vm.loading = false;

						if(!override) {
							updateFilterCount();
						}

						if(vm.config.evo.cart && vm.config.evo.cart.assignee && vm.config.evo.cart.assignee.enabled){
							vm.offers.forEach(function (order) {
								if (!order.hasOwnProperty('_partial')) {
									order._partial = true;
								}
							});
						}
					})
					.finally(function(){
						var pageIndex = vm.pagesLoading.indexOf(filter.page);
						if(pageIndex!==-1){
							vm.pagesLoading.splice(pageIndex,1);
						}
					});
			}
		}

		function stopRefreshing() {
			if (vm.updateTimeout !== null) {
				$interval.cancel(vm.updateTimeout);
			}
		}

		function onDestroy() {
			stopRefreshing();
		}

		function toggleOrderFilter(){
			vm.hasOrder = vm.hasOrder===1?0:1;
			reloadOffers();
			updateFilterCount();
		}

		/**
		 * Toggles the selected orders.
		 */
		function toggleSelectedOffers() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities.map(function (entity) {
				return entity.id;
			}));
		}

		function filterAll() {
			if(!OfferQueryService.useBackend) {
				vm.filteredEntities = [];

				for (var i = 0; i < vm.offers.length; i++) {
					var offer = vm.offers[i];
					if (dateInBetween(offer) && matchesSearchTerm(offer)) {
						vm.filteredEntities.push(offer);
					}
				}

				vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, vm.config.ims.offers.list.orderBy, true);
			}else{
				vm.filteredEntities = [];
				for (var j = 0; j < vm.offers.length; j++) {
					vm.filteredEntities.push(vm.offers[j]);
				}
			}
		}

		function matchesSearchTerm(offer) {
			return (vm.status.id==='-1' || vm.status.id===offer.status) && nuitDataService.getOne(vm.offerStatus,offer.status) !== null && (vm.searchText === '' || FormatterService.matches(vm.nameFormat, offer, vm.searchText));
		}

		function dateInBetween(offer){
			if(vm.config.ims.offers.list.dateFilter.enabled){
				return DateSearchService.inBetween(offer, vm.config.ims.offers.list.dateFilter.filterDate);
			}else{
				return true;
			}
		}

		function openDetails(itemId) {
			$state.go('app.offers.detail', {
				offerId: itemId,
				page: vm.currentPage,
				term: vm.searchText,
				status: vm.status.id,
				origin: 'app.offers',
				startFilterDate: DateSearchService.enabled?DateSearchService.startTimestamp:undefined,
				endFilterDate: DateSearchService.enabled?DateSearchService.endTimestamp:undefined
			}, {inherit: false});
		}

		function search() {
			if(OfferQueryService.useBackend) {
				vm.currentPage = 0;
				OfferService.clear();
			}

			$state.go('app.offers', {term: vm.searchText, page: vm.currentPage, status: vm.status.id});
		}

		function dateFilterChanged(){
			if(OfferQueryService.useBackend){
				vm.currentPage = 0;
				OfferService.clear();
				$state.go('app.offers', {
					term: vm.searchText,
					page: vm.currentPage,
					status: vm.status.id,
					startFilterDate: DateSearchService.enabled?DateSearchService.startTimestamp:undefined,
					endFilterDate: DateSearchService.enabled?DateSearchService.endTimestamp:undefined
				});
			}else{
				filterAll();
			}
		}


		function setStatusFilter(id) {
			if(OfferQueryService.useBackend){
				OfferService.clear();
			}

			if (vm.statusFilter === String(id)) {
				return;
			}
			vm.statusFilter = String(id);
			vm.selection.deselectAll();
			$state.go('.', {
				status: vm.statusFilter,
				page: 0,
				term: vm.searchText
			})
				.then(function(){
					if(!OfferQueryService.useBackend && vm.statusFilter==='-1'){
						vm.loading = true;
					}
				});
			filterAll();
		}

		function isFilterSelected(id) {
			return vm.status.id === id;
		}

		function showStatusChangeButton(item) {
			return vm.ordersToProcess === 0;
			/*return vm.config.ims.orders.denyTransitionFromStatus.indexOf(vm.statusFilter) === -1 &&
				disableInProductionMode() &&
				vm.statusFilter > -1 &&
				vm.statusFilter < OfferService.queue.length &&
				OfferService.queue[vm.statusFilter].type !== 'archive'*/
		}

		function updateFilterCount(){
			OfferService.offerCountByStatus({hasOrder: vm.hasOrder}); //this should get rid of offers that have an order
		}

		function getFilterCount(id) {
			return OfferService.getStatusCountById(id);
		}

		function loadAssignees(offer) {
			if(vm.config.evo.cart && vm.config.evo.cart.assignee && vm.config.evo.cart.assignee.enabled){
				OrderViewService.loadAssignees(offer[vm.ASSIGNEES_NAME]);
			}

			var deferred = $q.defer();
			deferred.resolve(offer);
			return deferred.promise;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders')
		.controller('OfferDetailsController', OfferDetailsController);

	/** @ngInject */
	function OfferDetailsController(
		$q,
		$filter,
		$translate,
		$state,
		$mdToast,
		nuitUnits,
		nuitConfig,
		nuitAuth,
		FixedTimeService,
		nuitProducts,
		imsColors,
		imsMaterials,
		imsUtils,
		nuitDataService,
		AddressService,
		ConditionCheckService,
		CART_SHIPPING_TYPES,
		nuitUtils,
		OrderViewService,
		$mdDialog,
		nuitApi,
		nuitProfiles,
		SalesObject,
		OrderSpecialService,
		EVOConfigService,
		OfferQueryService,
		OrderTagsService,
		OrderTagsViewService,
		PositionsService,
		NodeRedService,
		ProjectService,
		ProjectsViewService,
		imsNextChannel
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		OrderViewService.setApi($state.current.data.api);
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();                            // Contains the nuit config
		vm.queue = OrderViewService.api.queue;
		vm.offerId = $state.params.offerId;               // ID of current material
		vm.loadingItem = true;                          // Indicator if a loading process is running
		vm.currentTab = $state.params.active;
		vm.order = OrderViewService.order;                            // Contains current order
		vm.groups = [];
		vm.materials = imsMaterials.materials;
		vm.colors = imsColors.colors;
		vm.editDetails = false;
		vm.showPrices = false;
		vm.dialogConfig = {};
		vm.origin = $state.params.origin?$state.params.origin:'app.offers';
		vm.shippingTypes = CART_SHIPPING_TYPES;
		vm.editable = true;
		vm.ordersOrOffer = OrderViewService.ordersOrOffer;
		vm.projects = ProjectService.projects;

		vm.showProfileDetailsButton = nuitAuth.getEvoVersion() === 3;
		vm.imsNextChannel = imsNextChannel;

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.reloadOrder = reloadOrder;
		vm.markModified = markModified;
		vm.markModifiedProduct = markModifiedProduct;
		vm.markModifiedSketch = markModifiedSketch;
		vm.updateOrder = updateOrder;
		vm.getMaterialById = imsMaterials.getMaterialById;
		vm.openEditor = openEditor;
		vm.getDocumentURL = imsUtils.getDocumentURL;
		vm.downloadDocument = imsUtils.downloadDocument;
		vm.openDocument = imsUtils.openDocument;
		vm.filterMaterialsForAttribute = filterMaterialsForAttribute;
		vm.filterColorsForAttribute = filterColorsForAttribute;
		vm.isDefinedAndNotNull = isDefinedAndNotNull;
		vm.openImage = imsUtils.openImage;
		vm.updateFixedTime = updateFixedTime;
		vm.addLeadingZero = addLeadingZero;
		vm.isEditable = isEditable;
		vm.getFormattedTolerance = getFormattedTolerance;
		vm.symbolInFront = symbolInFront;
		vm.getSymbolForKey = getSymbolForKey;
		vm.needsInputConversion = needsInputConversion;
		vm.getInputConversionType = getInputConversionType;
		vm.writeToOverride = writeToOverride;
		vm.hasOverrideValue = hasOverrideValue;
		vm.onChangeOverrideValue = onChangeOverrideValue;
		vm.deleteOverride = deleteOverride;
		vm.getTitle = OfferQueryService.getTitle;
		vm.editAddress = vm.editAddress = function(parent, addressKey, company, addressType){
			AddressService.openAndSave(parent, addressKey, company, addressType)
				.then(function(){
					vm.offerForm.$setDirty();
				});
		};
		vm.showShippingAddress = showShippingAddress;
		vm.getStatusById = OrderViewService.api.getStatusById;
		vm.getPreviousStatus = OrderViewService.api.getPreviousStatus;
		vm.moveToNextState = OrderViewService.moveToNextState;
		vm.moveToPreviousState = OrderViewService.moveToPreviousState;
		vm.showStatusChangeButton = OrderViewService.showStatusChangeButton;
		vm.showStatus = function (type){ return type === 'proposal'; };

		vm.deleteSelected = OrderViewService.deleteSelected;
		vm.canBeDeleted = function(){return OrderViewService.canBeDeleted(vm);};

		vm.getValue = getValue;
		vm.addAttachment = function(){OrderViewService.addAttachment(vm);};

		vm.isConical = nuitProfiles.isConical;
		vm.hasCuts = nuitProfiles.hasCuts;
		vm.hasStamps = nuitProfiles.hasStamps;
		vm.getPunchCount = nuitProfiles.getPunchCount;

		vm.addProduct = OrderViewService.addProduct;
		vm.addProfile = OrderViewService.addProfile;
		vm.addSpecial = OrderViewService.addSpecial;

		vm.getSalesPosition = SalesObject.getPosition;
		vm.showSalesPosition = SalesObject.showPosition;
		vm.setDirty = setDirty;

		vm.onFlatProfilesUpdated = function() {
			vm.setDirty();
		};
		vm.isHoliday = EVOConfigService.isHoliday;
		vm.displayPayment = function(){
			return false;
		};
		vm.getPerson = function(id){
			return nuitDataService.getOne(OrderViewService.assignedUsers, id);
		};
		vm.ASSIGNEES_NAME = OrderViewService.ASSIGNEES_NAME;

		vm.getSearchResults = OrderTagsViewService.getSearchResults;
		vm.openTags = OrderTagsViewService.openTags;
		vm.addTag = OrderTagsViewService.addTag;
		vm.showPosNumber = OfferQueryService.showPosNumber;
		vm.allMarkedForDeletion = PositionsService.allMarkedForDeletion;
		vm.exportToJobBoss = exportToJobBoss;

		vm.focusProjectSearch = ProjectsViewService.focusSearch;

		Object.defineProperty(vm, 'inProduction', {
			get: function () {
				if (!vm.order.status) {
					return false;
				} else {
					return OrderViewService.api.isInProduction(vm.order.status);
				}
			}
		});
		Object.defineProperty(vm, 'nameFormat',{
			get: function(){
				return vm.config.ims.offers.nameFormat.length>0?vm.config.ims.offers.nameFormat:vm.config.ims.orders.nameFormat;
			}
		});

		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createErrorUpdatingItemToast() {
			return $mdToast
				.simple()
				.textContent('Error updating cart')
				.position('bottom right')
				.hideDelay(500);
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Sets all required variables which are needed by the view and loads current material into scope
		 */
		function init() {
			if (angular.isArray(vm.origin)) {
				vm.origin = vm.origin[0];
			}
			reloadOrder();
			OrderTagsService.reload();
			ProjectService.reload();
		}

		function reloadOrder() {
			// Loads order
			OrderViewService.reload(vm.offerId)
				.then(function (order) {
					vm.fixedTime = order.details.hasOwnProperty('fixedTime');
					vm.hasFixedTime = vm.fixedTime;
					if (angular.isNumber(vm.order.details.completionDate)) {
						vm.order.details.completionDate = new Date(vm.order.details.completionDate * 1000);
					} else {
						vm.order.details.completionDate = new Date();
					}

					if (isMaterialRequired()) {
						imsMaterials.reload();
					}
					if (isColorRequired()) {
						imsColors.reload();
					}

					vm.editable = true;
					var hasPostProductionReadOnlyStatus = false;

					angular.forEach(vm.config.ims.orders.readOnlyStatis, function (status) {
						vm.editable = vm.editable && status.toString() !== vm.order.status;
						hasPostProductionReadOnlyStatus = hasPostProductionReadOnlyStatus || OrderViewService.api.isInPostProduction(status.toString());
					});

					vm.editable = vm.editable && !ConditionCheckService.matchesAll(vm.config.ims.orders.readOnlyConditions, vm.order, false);

					if (vm.editable) {
						//Production Status always overrules readOnlyStatis!!
						vm.editable = !OrderViewService.api.isInProduction(vm.order.status);
					}

					if(vm.editable && !hasPostProductionReadOnlyStatus){
						//if no post-production read only statis are set we default to FALSE for post-production
						vm.editable = !OrderViewService.api.isInPostProduction(vm.order.status);
					}

					angular.merge(
						vm.dialogConfig,
						{
							details:
								{
									editButton: vm.editable,
									completionDatePicker: vm.editable
								},
							positions:
								{
									add: !vm.editable, //true means read only
									remove: !vm.editable, //true means read only
									quantity: !vm.editable, //true means read only
									length: !vm.editable, //true means read only
									prices: !vm.editable, //true means read only
									specials: !vm.editable, //true means read only
									specialsPrice: !vm.editable, //true means read only
									positionCheck: !vm.editable, //true means read only
									positionMarkForCheck: !vm.editable, //true means read only
									profileEditable: vm.editable,
									nameEditable: vm.editable,
									remarkEditable: vm.editable,
								},
							specials: !vm.editable, //true means read only
							products: !vm.editable, //true means read only
							prices: {
								show: true
							}
						}
					);

					vm.showPrices = vm.config.evo.cart.showPrices && vm.dialogConfig.prices.show;

					vm.loadingItem = false;

					if(vm.config.evo.cart && vm.config.evo.cart.assignee && vm.config.evo.cart.assignee.enabled){
						OrderViewService.loadAssignees(vm.config.evo.cart.assignee.users);
					}
				})
				.catch(imsUtils.showErrorToast);
		}

		/**
		 * Returns true if a material is required in any attribute.
		 * @returns {Boolean}
		 */
		function isMaterialRequired() {
			if (vm.order.profiles.length > 0) {
				return true;
			}
			for (var j in vm.order.products) {
				if(vm.order.products[j].type==='profile'){
					return true;
				}

				for (var i in vm.order.products[j].attributes) {
					if (vm.order.products[j].attributes[i].type === 'material') {
						return true;
					}
				}
			}
			return false;
		}

		/**
		 * Returns true if a material is required in any attribute.
		 * @returns {Boolean}
		 */
		function isColorRequired() {
			for (var j in vm.order.products) {
				for (var i in vm.order.products[j].attributes) {
					if (vm.order.products[j].attributes[i].type === 'color') {
						return true;
					}
				}
			}
			return false;
		}

		function filterMaterialsForAttribute(attribute) {
			var blacklist = !!attribute.restrictions.blacklist;
			return function (material) {
				var matches = attribute.restrictions.materials.indexOf(material.id) >= 0 || attribute.restrictions.groups.indexOf(material.rawMaterialId) >= 0;
				return matches !== blacklist;
			};
		}

		function filterColorsForAttribute(attribute) {
			var blacklist = !!attribute.restrictions.blacklist;
			return function (color) {
				var matches = attribute.restrictions.colors.indexOf(color.id) >= 0;
				return matches !== blacklist;
			};
		}

		function markModified(position) {
			vm.offerForm.$setDirty();
			if (position && position.state && position.state === 'NEW') {
				updateOrder();
			}
		}

		function markModifiedProduct(product, index) {
			if (product.positions.length === 0) {
				nuitDataService.removeOne(vm.order.products, product.id);
				updateOrder();
			} else {
				product.state = 'CHANGED';
				vm.offerForm.$setDirty();
			}
		}

		function markModifiedSketch(sketch) {
			sketch.state = 'CHANGED';
			vm.offerForm.$setDirty();
		}

		/**
		 * Sends updated material to remote server. Edited sketch name/remark
		 * ride along in the offer body and are persisted server-side.
		 */
		function updateOrder() {
			OrderSpecialService.batchAddFlatProfiles(vm.order)
				.then(function(){
					var order = angular.copy(vm.order);

					if (!angular.isNumber(order.details.completionDate)) {
						order.details.completionDate = parseInt(order.details.completionDate.getTime() / 1000);
					}

					OrderViewService
						.updateOrder(order)
						.then(function (response) {
							var state = (vm.origin ? vm.origin : 'app.offers') + '.detail';
							$state.go(state, {
								offerId: response.id
							});
							vm.offerForm.$setPristine();
							if (angular.isNumber(vm.order.details.completionDate)) {
								vm.order.details.completionDate = new Date(vm.order.details.completionDate * 1000);
							}
							nuitUtils.showSuccessToast();
						})
						.catch(function () {
							$mdToast.show(createErrorUpdatingItemToast());
						});
				});
		}

		function isDefinedAndNotNull(object) {
			return typeof object !== 'undefined' && object !== null;
		}

		function openEditor(profile) {
			var remark = profile.remark;
			var posNumber = profile.posNumber;
			var materialId = angular.copy(profile.materialId);
			imsUtils
				.openEditorAndSaveMultipleDefault(profile)
				.then(function (newProfile) {
					OrderViewService.updatePositionsAfterEditor(profile, newProfile.materialId!==materialId);
					profile.remark = remark;
					profile.posNumber = posNumber;
					vm.offerForm.$setDirty();
				});

		}

		function updateFixedTime() {
			if (vm.fixedTime) {
				vm.order.details.fixedTime = {
					hour: vm.config.evo.cart.fixedTime.hours[0],
					minute: vm.config.evo.cart.fixedTime.minutes[0],
					tolerance: vm.config.evo.cart.fixedTime.tolerances[0]
				};
			} else if (vm.order.details.fixedTime) {
				delete vm.order.details.fixedTime;
			}

			vm.fixedTime = vm.order.details.hasOwnProperty('fixedTime');
			vm.hasFixedTime = vm.fixedTime;
		}

		function addLeadingZero(number) {
			var postfix = number < 9 ? '0' : '';
			return postfix + number.toString();
		}

		function isEditable(attribute) {
			if (typeof attribute === 'boolean') {
				return attribute;
			} else if (typeof vm.dialogConfig.positions === 'boolean') {
				return !vm.dialogConfig.positions;
			} else {
				return false;
			}
		}

		function getFormattedTolerance(hour, minute, tolerance) {
			if (angular.isNumber(hour) && angular.isNumber(minute) && angular.isNumber(tolerance)) {
				return $translate.instant('ORDERS.TOLERANCE', {
					tolerance: FixedTimeService.getFormattedTolerance({
						hour: hour,
						minute: minute,
						tolerance: tolerance
					})
				});
			} else {
				return '-';
			}
		}

		function symbolInFront(key) {
			var lowerCase = key.toLowerCase();

			if (lowerCase.includes('price') || lowerCase.includes('taxes') || lowerCase.includes('fee') || lowerCase.includes('discount')) {
				return vm.config.localization.currencySymbolInFront;
			} else {
				return false;
			}
		}

		function getSymbolForKey(key) {
			var lowerCase = key.toLowerCase();

			if (lowerCase.includes('price') || lowerCase.includes('taxes') || lowerCase.includes('fee') || lowerCase.includes('discount')) {
				return vm.config.localization.currency.symbol;
			} else if (lowerCase.includes('weight')) {
				return nuitUnits('weight').symbol;
			} else if (lowerCase.includes('length')) {
				return nuitUnits('length').symbol;
			} else if (lowerCase.includes('percent')) {
				return '%';
			} else {
				return '???';
			}
		}

		function needsInputConversion(key) {
			var lowerCase = key.toLowerCase();

			if (lowerCase.includes('weight') || lowerCase.includes('length')) {
				return true;
			} else {
				return false;
			}
		}

		function getInputConversionType(key) {
			var lowerCase = key.toLowerCase();

			if (lowerCase.includes('weight')) {
				return 'weight';
			} else if (lowerCase.includes('length')) {
				return 'length';
			} else {
				return '???';
			}
		}

		function writeToOverride(key){
			switch (key){
				case 'logisticPrice':
					return true;
				default:
					return false;
			}
		}

		function deleteOverride(key){
			if(hasOverrideValue(key)){
				delete vm.order.sales.overrides[key];
				vm.offerForm.$setDirty();
			}
		}

		function hasOverrideValue(key){
			return vm.order.sales.overrides && vm.order.sales.overrides[key]!==undefined;
		}

		function onChangeOverrideValue(key){
			if(writeToOverride(key)) {
				if (vm.order.sales.overrides === undefined) {
					vm.order.sales.overrides = {};
				}

				if (!hasOverrideValue(key)) {
					vm.order.sales.overrides[key] = vm.order.sales[key];
				}
			}
		}

		function getValue(value, key) {
			if (needsInputConversion(key)) {
				return $filter('nuitUnit')(value, getInputConversionType(key), true);
			} else {
				return $filter('nuitNumber')(value);
			}
		}

		function showShippingAddress() {
			return true;
		}

		function setDirty(){
			if(vm.offerForm) {
				vm.offerForm.$setDirty();
			}
		}

		function exportToJobBoss(){
			nuitUtils.showConfirmationDialog(
				'JOBBOSS.CONFIRM_OFFER_OVERRIDE_TITLE',
				'JOBBOSS.CONFIRM_OFFER_OVERRIDE_CONTENT'
			)
				.then(function(){
					NodeRedService.get(vm.config.ims.exchange.jobBoss.order.export.appId)
						.execute(
							vm.config.ims.exchange.jobBoss.offer.export.flowId,
							{
								offerId: vm.offerId
							});
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders')
		.controller('ProposalListController', ProposalListController);

	/** @ngInject */
	function ProposalListController($state, $timeout, $scope, $filter, $interval, OrderService, nuitConfig, nuitUtils, ListSelectionService, FormatterService, OrderViewService, FilterCountService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.ALL_STATUS = {id:'-1'};

		vm.filteredEntities = [];
		vm.currentPage = [];
		vm.currentPageEntities = [];
		vm.loading = true;
		vm.config = nuitConfig.getCurrent();
		vm.orders = OrderService.orders;
		vm.searchText = $state.params.term || '';
		vm.updateTimeout = null;
		vm.selection = ListSelectionService.get('order.proposals', true);
		vm.filterCount = FilterCountService.get('order.proposals', true);
		vm.ordersToProcess = 0;
		vm.proposalStatis = [];
		vm.proposalFilters = [];
		vm.status = vm.ALL_STATUS;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openDetails = openDetails;
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.search = search;
		vm.getStatusById = OrderService.getStatusById;
		vm.deleteSelected = OrderViewService.deleteSelected;
		vm.canBeDeleted = function(){return OrderViewService.canBeDeleted(vm, vm.config.ims.proposals.canDeleteConditions);};
		vm.toggleSelectOrder = vm.selection.toggleSelectedEntity;
		vm.toggleSelectedOrders = toggleSelectedOrders;
		vm.moveToNextState = OrderViewService.moveToNextState;
		vm.getOrderPositions = OrderService.getOrderPositions;
		vm.showStatusChangeButton = showStatusChangeButton;
		vm.setStatusFilter = setStatusFilter;
		vm.filterAll = filterAll;
		vm.isFilterSelected = isFilterSelected;
		vm.getFilterCount = vm.filterCount.get;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		$scope.$on('$destroy', onDestroy);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {
			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}

			if ($state.params.page && $state.params.page !== vm.currentPage) {
				vm.currentPage = $state.params.page;
			}

			filterAll();
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			OrderService.reloadConfig()
				.then(function(){
					nuitDataService.replaceAll(vm.proposalFilters,OrderService.proposalFilters);
					vm.status = vm.proposalFilters[0];
				})

			if (OrderService.statusLoading) {
				OrderService.statusLoading.then(reloadOrders);
			} else {
				reloadOrders();
			}

			if (angular.isNumber(vm.config.ims.orders.refreshInterval) && vm.config.ims.orders.refreshInterval > 0) {
				vm.updateTimeout = $interval(function () {
					reloadOrders();
				}, Math.max(2000, vm.config.ims.orders.refreshInterval));
			}
		}

		function reloadOrders() {
			if (!angular.isNumber(vm.config.ims.orders.refreshInterval) || vm.config.ims.orders.refreshInterval <= 0) {
				stopRefreshing();
				return;
			}

			vm.proposalStatis = OrderService.getStatisByType('proposal');

			if (vm.proposalStatis.length>0) {
				var ids = vm.proposalStatis.map(function (e) {
					return e.id;
				});

				OrderService
					.reload({status: ids.join(','),view:'essential'})
					.then(function () {
						var selected = vm.selection.getSelected();
						selected = selected.map(function (e) {
							return e.id;
						});
						vm.selection.deselectAll();
						filterAll();
						$timeout(function () {
							for (var index in vm.currentPageEntities) {
								if (selected.indexOf(String(vm.currentPageEntities[index].id)) >= 0) {
									vm.toggleSelectOrder(vm.currentPageEntities[index]);
								}
							}
						});
						vm.loading = false;
					});
			}
		}

		function stopRefreshing() {
			if (vm.updateTimeout !== null) {
				$interval.cancel(vm.updateTimeout);
			}
		}

		function onDestroy() {
			stopRefreshing();
		}

		/**
		 * Toggles the selected orders.
		 */
		function toggleSelectedOrders() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

		function filterAll() {
			vm.filterCount.resetAll();
			vm.filteredEntities = [];

			for (var i = 0; i < vm.orders.length; i++) {
				var order = vm.orders[i];
				if (matchesSearchTerm(order)) {
					vm.filteredEntities.push(order);
				}
				vm.filterCount.increment(vm.orders[i].status);
			}

			vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, vm.config.ims.proposals.list.orderBy, true);
		}

		function matchesSearchTerm(order) {
			return (vm.status.id==='-1' || vm.status.id===order.status) && nuitDataService.getOne(vm.proposalStatis,order.status) !== null && (vm.searchText === '' || FormatterService.matches(vm.config.ims.orders.nameFormat, order, vm.searchText));
		}

		function openDetails(itemId) {
			$state.go('app.proposals.detail', {
				orderId: itemId,
				page: vm.currentPage,
				term: vm.searchText,
				origin: 'app.proposals'
			}, {inherit: false});
		}

		function search() {
			$state.go('app.proposals', {term: vm.searchText, page: vm.currentPage, status: vm.status});
		}

		function showStatusChangeButton() {
			return vm.ordersToProcess === 0;
		}

		function setStatusFilter(status) {
			if (vm.status.id === status.id) {
				return;
			}
			vm.status = status;
			vm.selection.deselectAll();
			$state.go('.', {
				status: parseInt(status.id,10) >= 0 ? vm.status.id : undefined,
				page: 0,
				term: vm.searchText
			});
			filterAll();
		}

		function isFilterSelected(id) {
			return vm.status.id === id;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.credit')
		.service('CreditService', CreditService);

	/** @ngInject */
	function CreditService($q, $timeout, nuitApi, nuitDataService) {
		var _credits = [];
		var _statusFields = [];

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			createCredit: createCredit,
			reload: reload,
			reloadByCompanyId: reloadByCompanyId,
			incrementStatus: incrementStatus,
			getCreditById: getCreditById,
			updateOneCredit: updateOneCredit,
			reloadStatus: reloadStatus,
			updateSumRedeemed: updateSumRedeemed,
			updateStatusAndSumRedeemed: updateStatusAndSumRedeemed
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'credits', {
			get: function () {
				return _credits;
			}
		});
		Object.defineProperty(service, 'statusFields', {
			get: function () {
				return _statusFields;
			}
		});

		return service;

		//*******************************************
		// METHODS
		//*******************************************
		function createCredit(credit) {

			credit.status = 1;
			return nuitApi('credit.credits').post(credit)
				.then(function (response) {
					_credits.push(response.data);
					return response.data;
				});
		}

		function reload(firstDay, lastDay, status) {
			return nuitApi('credit.credits').get({
				start: firstDay,
				end: lastDay,
				status: (status === -1 ? null : status)
			})
				.then(function (response) {
					return nuitDataService.replaceAll(_credits, response.data);
				});
		}

		function reloadByCompanyId(companyId) {
			return nuitApi('credit.credits').get({
				company: companyId
			})
				.then(function (response) {
					return nuitDataService.replaceAll(_credits, response.data);
				});
		}

		function incrementStatus(credit, statusID) {
			return nuitApi('credit.credits.one.update', credit.id).patch({status: statusID})
				.then(function (response) {
					nuitDataService.replaceOne(_credits, response.data);
					return response.data;
				});
		}

		function updateSumRedeemed(creditId, amount) {
			return nuitApi('credit.credits.one.update', creditId).patch({sumRedeemed: amount})
				.then(function (response) {
					nuitDataService.replaceOne(_credits, response.data);
					return response.data;
				});
		}

		function updateStatusAndSumRedeemed(creditId, status, amount) {
			return nuitApi('credit.credits.one.update', creditId).patch({status: status, sumRedeemed: amount})
				.then(function (response) {
					nuitDataService.replaceOne(_credits, response.data);
					return response.data;
				});
		}

		function getCreditById(creditId) {
			return nuitApi('credit.credits.one.update', creditId)
				.get()
				.then(function (response) {
					var invoice = response.data;
					return invoice;
				});
		}

		function updateOneCredit(credit) {
			return nuitApi('credit.credits.one.update', credit.id)
				.put(credit)
				.then(function (response) {
					nuitDataService.replaceOne(_credits, response.data);
					return response.data;
				});

		}

		function reloadStatus() {
			return nuitApi('credit.credits.status')
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(_statusFields, response.data);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.credit')
		.controller('CreditsController', CreditsController);

	/** @ngInject */
	function CreditsController(
		$state,
		$timeout,
		$translate,
		$scope,
		$filter,
		$interval,
		$q,
		$mdDialog,
		OrderService,
		nuitConfig,
		nuitUtils,
		nuitAuth,
		ListSelectionService,
		FormatterService,
		OrderViewService,
		FilterCountService,
		nuitDataService,
		CreditService,
		DotNotationService,
		nuitApi,
		CompanyService
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.currentPage = [];
		vm.currentPageEntities = [];
		vm.loading = false;
		vm.config = nuitConfig.getCurrent();
		vm.orders = OrderService.orders;
		vm.searchText = $state.params.term || '';
		vm.selection = ListSelectionService.get('order.credits', true);
		vm.filterCount = FilterCountService.get('order.credits', true);
		vm.creditsToProcess = 0;
		vm.creditStatis = [];
		vm.credits = CreditService.credits;
		vm.years = [];
		vm.selectedYear = null;
		vm.months = [];
		vm.statis = CreditService.statusFields;
		vm.selectedStatus = vm.statis.id;
		vm.selectedOrderBy = 'id';
		vm.reverse = true;
		vm.collapse = false;
		vm.disable = [];
		vm.companyNamePool = [];
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openDetails = openDetails;
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.search = search;
		vm.getStatusById = OrderService.getStatusById;
		vm.toggleSelectCredit = toggleSelectedCredit;
		vm.toggleSelectedCredits = toggleSelectedCredits;
		vm.moveToNextState = OrderViewService.moveToNextState;
		vm.getOrderPositions = OrderService.getOrderPositions;
		vm.showStatusChangeButton = showStatusChangeButton;
		vm.filterAll = filterAll;
		vm.getFilterCount = vm.filterCount.get;
		vm.changeStatus = changeStatus;
		vm.reloadCredits = reloadCredits;
		vm.sumOf = sumOf;
		vm.orderBy = orderBy;
		vm.updateSumRedeemed = updateSumRedeemed;
		vm.getCompanyName = getCompanyName;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {
			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}

			if ($state.params.page && $state.params.page !== vm.currentPage) {
				vm.currentPage = $state.params.page;
			}

			filterAll();
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			CreditService.reloadStatus();
			generateFilterContent();
			reloadCredits();
		}

		function generateFilterContent() {
			var currentYear = (new Date()).getFullYear();

			var lastYear = currentYear + vm.config.ims.credit.filters.year.endOffset;
			var firstYear = currentYear + vm.config.ims.credit.filters.year.startOffset;

			for (var i = firstYear; i <= lastYear; i++) {
				vm.years.push(i);
			}

			if ($state.params.start) {
				vm.selectedMonth = new Date($state.params.start * 1000).getMonth();
				vm.selectedYear = new Date($state.params.start * 1000).getFullYear();
			} else {
				vm.selectedYear = vm.years.indexOf(currentYear) !== -1 ? currentYear : vm.years[vm.years.length - 1];
				vm.selectedMonth = (new Date()).getMonth();
			}

			for (var i = 0; i < months.length; i++) {
				vm.months.push(
					{
						value: i,
						translation: 'APP.' + months[i].toUpperCase()
					}
				);
			}
		}

		function reloadCredits() {
			if (!vm.loading) {
				$state.go('app.credit', {year: vm.selectedYear, month: vm.selectedMonth});

				var firstDay = new Date(vm.selectedYear, vm.selectedMonth, 1,0,0,0).getTime() / 1000;
				var lastDay = new Date(vm.selectedYear, vm.selectedMonth + 1, 1, 0,0,0).getTime() / 1000;

				vm.loading = true;

				CreditService.reload(firstDay, lastDay, vm.selectedStatus)
					.then(function () {
						getCompanyById()
							.then(function () {
								vm.loading = false;
								vm.orderBy('id', true);
							});
					});
			}
		}

		/**
		 * Toggles the selected orders.
		 */
		function toggleSelectedCredits() {
			if (vm.selection.getSelected().length > 0) {
				vm.selection.toggleSelectedEntities(vm.currentPageEntities);
				nuitDataService.replaceAll(vm.disable, []);
			}
		}

		function toggleSelectedCredit(credit, $event) {
			vm.selection.toggleSelectedEntity(credit, $event);

			if (vm.selection.getSelected().length === 1 && vm.disable.length === 0) {
				vm.statis.forEach(function (status) {
					vm.disable.push(status.id);
				});

				var start = (vm.selection.getSelected()[0].status);
				var index = vm.disable.indexOf(start).toString();
				DotNotationService.remove(vm.disable, index);
			} else if (vm.selection.getSelected().length === 0) {
				nuitDataService.replaceAll(vm.disable, []);
			}
		}

		function filterAll() {
			vm.filterCount.resetAll();
			vm.filteredEntities = [];

			for (var i = 0; i < vm.credits.length; i++) {
				var credit = vm.credits[i];
				if (matchesSearchTerm(credit)) {
					vm.filteredEntities.push(credit);
				}
				vm.filterCount.increment(vm.credits[i].status);
			}
		}

		function matchesSearchTerm(credit) {
			if (vm.searchText === '') {
				return true;
			} else {
				vm.searchText = vm.searchText.toLowerCase();
				if (credit.number.includes(vm.searchText) || credit.number === vm.searchText ) {
					return true;
				} else {
					for (var i in vm.statis) {
						if (credit.status === vm.statis[i].id) {
							var status = 'CREDIT.STATUS_' + vm.statis[i].type.toUpperCase();
							status = $translate.instant(status);
							status = status.toLowerCase();
							if (status.includes(vm.searchText)) {
								return true;
							}
						}
					}
					var createdAt = $filter('nuitDatetime')(credit.createdAt, 'date');
					var dueDate = $filter('nuitDatetime')(credit.dueDate, 'date');
					if(createdAt.includes(vm.searchText) || dueDate.includes(vm.searchText)){
						return true;
					}
					for (var x in vm.companyNamePool) {
						var companyName = vm.companyNamePool[x].name.toLowerCase();
						if(companyName.includes(vm.searchText)){
							if(vm.companyNamePool[x].id === credit.companyId){
								return true;
							}
						}
					}
				}
			}
		}

		function openDetails(credit) {
			var start = new Date(vm.selectedYear, vm.selectedMonth, 1, 0,0,0).getTime() / 1000;

			$state.go('app.credit.details', {
				creditId: credit.id,
				companyId: credit.companyId,
				origin: 'app.credit',
				start: start
			},{inherit: false});
		}

		function search() {
			$state.go('app.credit', {term: vm.searchText, page: vm.currentPage});
		}

		function showStatusChangeButton() {
			return vm.creditsToProcess === 0;
		}

		function createChangeStatusDialog(credit) {
			return {
				controller: 'ChangeCreditStatusDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/orders.credit/views/dialogs/change-status/change-status.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Credit: angular.copy(credit)
				}
			};
		}

		function changeStatus(credit) {
			$mdDialog
				.show(createChangeStatusDialog(credit[0]))
				.then(function (result) {
					var status = result[0];
					var sumRedeemed = result[1];
					var selected = vm.selection.getSelected();
					for (var i = 0; i < selected.length; i++) {
						var credit = selected[i];
						if (status === 4) {
							CreditService.incrementStatus(credit, status)
								.then(function () {
									vm.selection.deselectAll();
									nuitDataService.replaceAll(vm.disable, []);
									filterAll();
									reloadCredits();
								})
								.catch(nuitUtils.showErrorToast);
						} else {
							CreditService.updateStatusAndSumRedeemed(credit.id, status, sumRedeemed)
									.then(function () {
										vm.selection.deselectAll();
										nuitDataService.replaceAll(vm.disable, []);
										filterAll();
										reloadCredits();
									}).catch(nuitUtils.showErrorToast);
						}
					}
					nuitUtils.showSuccessToast();
				}).catch(angular.noop);

		}

		function sumOf(key) {
			var sum = 0;

			for (var i = 0; i < vm.filteredEntities.length; i++) {
				if (vm.filteredEntities[i].hasOwnProperty(key) && vm.filteredEntities[i].status !== 4) {
					sum += vm.filteredEntities[i][key];
				}
				if(key === 'open' && vm.filteredEntities[i].status !== 4){
					sum += (vm.filteredEntities[i].sumAmount - vm.filteredEntities[i].sumRedeemed);
				}
			}
			return sum;
		}

		function orderBy(key, initial) {
			vm.selectedOrderBy = key;
			if (!initial){
				vm.reverse = !vm.reverse;
			}else{
				vm.reverse = initial;
			}
			filterAll();
			vm.filteredEntities = $filter('orderBy')(angular.copy(vm.filteredEntities), key, vm.reverse);
		}

		function updateSumRedeemed(credit) {
			$mdDialog
				.show(createUpdateSumRedeemedDialog(credit[0].sumRedeemed, credit[0].id))
				.then(function () {
					reloadCredits();
				})
				.catch(angular.noop);
		}

		function createUpdateSumRedeemedDialog(sum, id) {
			return {
				controller: 'UpdateSumRedeemedDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/orders.credit/views/dialogs/update-sum-redeemed/update-sum-redeemed.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Sum: angular.copy(sum),
					Credit: angular.copy(id)
				}
			};
		}

		function getCompanyName(companyId) {
			var company = vm.companyNamePool.filter(function(item){ return companyId === item.id;});
			return company[0].name;
		}

		function getCompanyById() {
			var promises = [];
			var allCompanyIds = [];
			for (var i = 0; i < vm.credits.length; i++) {
				allCompanyIds.push(vm.credits[i].companyId);
			}
			allCompanyIds = allCompanyIds.filter(function(item, index){ return allCompanyIds.indexOf(item) === index; });
			for( var x = 0; x < allCompanyIds.length; x++){
				promises.push(CompanyService.getById(allCompanyIds[x])
					.then(function (res) {
						vm.companyNamePool.push({id: res.id, name: res.name});
					}));
			}
			return $q.all(promises);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.credit')
		.controller('CreditDetailsController', CreditDetailsController);

	/** @ngInject */
	function CreditDetailsController(
		$state,
		$timeout,
		$scope,
		$filter,
		$interval,
		$mdDialog,
		OrderService,
		nuitConfig,
		nuitUtils,
		ListSelectionService,
		FormatterService,
		OrderViewService,
		FilterCountService,
		nuitDataService,
		CreditService,
		InvoiceService,
		$stateParams,
		nuitAuth,
		CompanyService,
		imsUtils
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.credit = {};
		vm.origin = $state.params.origin;
		vm.creditId = parseInt($state.params.creditId);
		vm.invoiceId = parseInt($state.params.invoiceId);
		vm.companyId = parseInt($state.params.companyId);
		vm.company = null;
		vm.orders = [];
		vm.statis = [];
		vm.allStatus = CreditService.statusFields;
		vm.selectedStatus = null;
		vm.showCompanyButton = true;
		vm.loading = true;
		vm.updateCreditPossible = true;
		vm.updateSumRedeemedPossible = true;
		vm.invoiceNumber = null;

		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************

		vm.reloadCredits = reloadCredits;
		vm.updateCredit = updateCredit;
		vm.updateSumRedeemed = updateSumRedeemed;
		vm.selectableDays = selectableDays;
		vm.getDocumentURL = imsUtils.getDocumentURL;

		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************

		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			console.log(vm.origin);
			if (angular.isArray(vm.origin)) {
				vm.origin = vm.origin[0];
			}
			if (vm.origin === 'app.partners-companies.details') {
				vm.showCompanyButton = false;
			}
			CreditService.reloadStatus();
			CompanyService
				.getById(vm.companyId)
				.then(function (company) {
					vm.company = company;
					if (vm.creditId) {
						vm.updateCreditPossible = false;
						reloadCredits()
							.then(function () {
								if(vm.credit.invoiceId){
									vm.invoiceId = vm.credit.invoiceId;
									InvoiceService.getInvoiceById(vm.invoiceId)
										.then(function (invoice) {
											vm.invoiceNumber = invoice.number;
										})
										.catch(nuitUtils.showErrorToast);
								}
							});
					} else {
						vm.updateSumRedeemedPossible = false;
						vm.credit.positions = [];
						vm.credit.companyId = vm.companyId;
						if(vm.invoiceId){
							vm.credit.invoiceId = vm.invoiceId;
							InvoiceService.getInvoiceById(vm.invoiceId)
								.then(function (invoice) {
									vm.credit.vatPercent = invoice.vatPercents[0];
									vm.invoiceNumber = invoice.number;
								})
								.catch(nuitUtils.showErrorToast);
						}else{
							vm.credit.vatPercent = vm.company.vat;
						}
					}
				})
				.catch(nuitUtils.showErrorToast)
				.finally(function () {
					vm.loading = false;
				});

		}


		function reloadCredits() {
			return CreditService.getCreditById(vm.creditId)
				.then(function (credit) {
					vm.credit = credit;
					if (vm.credit.status === 3 || vm.credit.status === 4){
						vm.updateSumRedeemedPossible = false;
					}
				})
				.catch(nuitUtils.showErrorToast);
		}


		function updateCredit() {
			if (vm.creditId) {
				CreditService
					.updateOneCredit(vm.credit)
					.then(function (response) {
						console.log(response);
						vm.credit = response;
						if (vm.credit.status === 3 || vm.credit.status === 4){
							vm.updateSumRedeemedPossible = false;
						}else{
							vm.updateSumRedeemedPossible = true;
						}
						vm.creditDetailForm.$setPristine();
						nuitUtils.showSuccessToast();
					})
					.catch(nuitUtils.showErrorToast);
			} else {
				CreditService.createCredit(vm.credit)
					.then(function (credit) {
						vm.credit = credit;
						vm.creditDetailForm.$setPristine();
						nuitUtils.showSuccessToast();
						vm.updateCreditPossible = false;
						vm.updateSumRedeemedPossible = true;
					})
					.catch(nuitUtils.showErrorToast);
			}
		}


		function updateSumRedeemed() {
			$mdDialog
				.show(createUpdateSumRedeemedDialog())
				.then(function (response) {
					console.log(response);
						var status = response[0];
						var sumRedeemed = response[1];
						if (status === 4) {
							CreditService.incrementStatus(vm.credit, status)
								.then(function (res) {
									console.log(res);
									vm.credit = res;
								})
								.catch(nuitUtils.showErrorToast);
						} else {
							CreditService.updateStatusAndSumRedeemed(vm.credit.id, status, sumRedeemed)
								.then(function (res) {
									console.log(res);
									vm.credit = res;
								}).catch(nuitUtils.showErrorToast);
						}
						nuitUtils.showSuccessToast();
				})
				.catch(angular.noop);
		}

		function createUpdateSumRedeemedDialog() {
			return {
				controller: 'ChangeCreditStatusDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/orders.credit/views/dialogs/change-status/change-status.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Credit: angular.copy(vm.credit)
				}
			};
		}

		function selectableDays(date) {
			if (vm.config.ims.accounting.details.datepickerFilter) {
				var day = date.getDay();
				return vm.config.ims.accounting.calendar.workDays.includes(day);
			} else {
				return true;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders')
		.factory('OrderDownloadService', OrderDownloadService);

	/** @ngInject */
	function OrderDownloadService($window, nuitConfig, nuitApi, nuitAuth) {
		return initService();

		function initService() {
			return {
				downloadUrl: downloadUrl
			};
		}

		function downloadUrl(status,startFilterDate,endFilterDate,appId,flowId){
			return nuitApi.getBaseUrl() + 'exchange/apps/'+appId+'/nodered/flows/'+flowId + '/execute?startFilterDate=' + startFilterDate + '&endFilterDate=' + endFilterDate + '&status=' + status + '&access-token=' + nuitAuth.getToken();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue')
		.service('OrderViewService', OrderViewService);

	/** @ngInject */
	function OrderViewService($q, $injector, $state, nuitDataService, nuitUtils, ConditionCheckService, nuitOrders, OrderSpecialService, UserService) {
		//*******************************************
		// SERVICE
		//*******************************************
		var _api = null;
		var _order = {};
		var _loadingOrder = null;
		var _ordersOrOffer = {};
		var _assignedUsers = [];
		var _ASSIGNEES_NAME = 'assignees';

		var service = {
			setApi: setApi,
			reload: reload,
			updateOrder: updateOrder,
			hasNextStatus: hasNextStatus,
			moveToNextState: moveToNextState,
			moveToPreviousState: moveToPreviousState,
			canBeDeleted: canBeDeleted,
			deleteSelected: deleteSelected,
			showStatusChangeButton: showStatusChangeButton,
			updatePositionsAfterEditor: updatePositionsAfterEditor,
			addAttachment: addAttachment,
			openSpecialDialog: OrderSpecialService.open,
			addProfile: function(order){
				OrderSpecialService.addProfile(order)
					.then(function(){service.reload(_order.id);});
			},
			addProduct: function(order){
				OrderSpecialService.addProduct(order)
					.then(function(){service.reload(_order.id);});
			},
			addSpecial: function(order){
				OrderSpecialService.addSpecial(order)
					.then(function(){service.reload(_order.id);});
			},
			loadAssignees: loadAssignees
		};
		//*******************************************

		Object.defineProperty(service, 'api', {
			get: function () {
				return _api;
			}
		});

		Object.defineProperty(service, 'order', {
			get: function () {
				return _order;
			}
		});

		Object.defineProperty(service, 'loadingOrder', {
			get: function () {
				return _loadingOrder;
			}
		});

		Object.defineProperty(service, 'hasQueue', {
			get: function () {
				return _api?_api.queue.length>0:false;
			}
		});

		Object.defineProperty(service, 'ordersOrOffer', {
			get: function () {
				return _ordersOrOffer;
			}
		});

		Object.defineProperty(service, 'assignedUsers', {
			get: function () {
				return _assignedUsers;
			}
		});

		Object.defineProperty(service, 'ASSIGNEES_NAME', {
			get: function () {
				return _ASSIGNEES_NAME;
			}
		});

		return service;

		//*******************************************
		// METHODS
		//*******************************************
		function setApi(name){
			_api = $injector.get(name);
			OrderSpecialService.setApi(_api);
		}

		function reload(id){
			angular.copy({}, _ordersOrOffer);
			angular.copy({},_order);

			if(service.hasQueue){
				return reloadInternal(id);
			}else if (_api.statusLoading) {
				_loadingOrder = _api.statusLoading.then(function(){return reloadInternal(id);});
				return _loadingOrder;
			} else {
				return _api.reloadConfig()
					.then(function(){return reloadInternal(id);});
			}
		}

		function loadAssignees(ids){
			if(ids) {
				for (var i = 0; i < ids.length; i++) {
					var id = ids[i];
					if(!nuitDataService.getOne(_assignedUsers, id)){
						nuitDataService.addOne(_assignedUsers,{id:id});
						UserService.getUserById(id)
							.then(function(user){
								nuitDataService.replaceOne(_assignedUsers,user);
							});
					}
				}
			}
		}

		function reloadInternal(id){
			 _loadingOrder = _api.loadOrder(id)
				.then(function (order) {
					order.tags = order.tags.map(function(entity){return entity.id;});

					if(order.projectId===null){ order.projectId = ''; }

					loadAssignees(order[_ASSIGNEES_NAME]);

					angular.copy(order, _order);
					if(_api.hasRelations(order)){
						_api.loadRelations(order)
							.then(function (res){
								angular.copy(res, _ordersOrOffer);
							});
					}
					_loadingOrder = null;
					return _order;
				});

			return _loadingOrder;
		}

		function updateOrder(order){
			var wrappedOrder = {};
			angular.copy(order, wrappedOrder);

			wrappedOrder.tags = order.tags.map(function(entity){return {id:entity};});

			return _api.updateOrder(wrappedOrder)
				.then(function (response) {
					response.tags = response.tags.map(function(entity){return entity.id;});
					nuitDataService.replaceOneEntity(_order, response);
					return _order;
				});
		}

		function moveToNextState(vm) {
			if (vm.getSelected) {
				var orders = vm.getSelected();
				vm.ordersToProcess = orders.length;
				var promisses = [];
				angular.forEach(orders, function (order) {
					var fullOrder;

					if(angular.isNumber(order)){
						fullOrder = nuitDataService.getOne(service.api.orders, order);
					}else{
						fullOrder = order;
					}

					promisses.push(service.api.moveToNextStatus(fullOrder)
						.then(function () {

						})
						.finally(function () {
							vm.ordersToProcess--;
							vm.filterAll();
							vm.selection.deselectAll();
						})
					);
				});
				return $q.all(promisses);
			} else {
				return service.api.moveToNextStatus(_order)
					.then(function () {

					})
					.finally(function () {
						service.reload(_order.id);
						nuitUtils.showSuccessToast('APP.STATUS_CHANGED');
					});
			}
		}

		function moveToPreviousState(vm) {
			if (vm.getSelected) {
				var orders = vm.getSelected();
				vm.ordersToProcess = orders.length;
				var promisses = [];
				angular.forEach(orders, function (order) {
					var fullOrder;

					if(angular.isNumber(order)){
						fullOrder = nuitDataService.getOne(service.api.orders, order);
					}else{
						fullOrder = order;
					}

					promisses.push(service.api.moveToPreviousStatus(fullOrder)
						.then(function () {

						})
						.finally(function () {
							vm.ordersToProcess--;
							vm.filterAll();
							vm.selection.deselectAll();
						})
					);
				});
				return $q.all(promisses);
			} else {
				return service.api.moveToPreviousStatus(_order)
					.then(function () {

					})
					.finally(function () {
						service.reload(_order.id);
						nuitUtils.showSuccessToast('APP.STATUS_CHANGED');
					});
			}
		}

		function hasNextStatus(){
			return service.api.hasNextStatus(_order.status);
		}

		function canBeDeleted(vm, conditions) {
			if (conditions) {
				var canBeDelete = vm.getSelected().length > 0;

				angular.forEach(vm.selection.getSelected(), function (order) {
					if(angular.isNumber(order)){
						var fullOrder = nuitDataService.getOne(service.api.orders, order);
						canBeDelete = canBeDelete && ConditionCheckService.matchesAll(conditions, fullOrder);
					}else{
						canBeDelete = canBeDelete && ConditionCheckService.matchesAll(conditions, order);
					}
				});
				return canBeDelete;
			} else {
				if (service.api.getStatusById(_order.status)) {
					if (service.api.getStatusById(_order.status).type === 'proposal') {
						return ConditionCheckService.matchesAll(vm.config.ims.proposals.canDeleteConditions, _order);
					} else {
						return ConditionCheckService.matchesAll(vm.config.ims.orders.canDeleteConditions, _order);
					}
				}
			}

		}

		function deleteSelected(vm) {
			if (vm.getSelected) {
				nuitUtils.showDeleteMultiConfirm()
					.then(function () {
						angular.forEach(vm.selection.getSelected(), function (order) {
							var fullOrder;

							if(angular.isNumber(order)){
								fullOrder = nuitDataService.getOne(service.api.orders, order);
							}else{
								fullOrder = order;
							}

							service.api.deleteOrder(fullOrder)
								.then(function () {
									vm.selection.deselectAll();
									vm.filterAll();
									if(vm.updateFilterCount) {
										vm.updateFilterCount();
									}
								});
						});
					});
			} else {
				nuitUtils.showDeleteConfirmation()
					.then(function () {
						service.api.deleteOrder(_order)
							.then(function () {
								if(vm.updateFilterCount) {
									vm.updateFilterCount();
								}
								$state.go(vm.origin ? vm.origin : 'app.orders');
							});
					});
			}
		}

		function showStatusChangeButton(vm) {
			if (_order) {
				var status = service.api.getStatusById(_order.status);
				if (status) {
					return !vm.config.ims.orders.denyTransitionFromStatus.includes(status.id) &&
						disableInProductionMode() &&
						status.id > -1 &&
						status.type !== 'archive';
				}
			}
		}

		function disableInProductionMode() {
			var nextStatus = service.api.getNextStatus(_order.status);
			var status = service.api.getStatusById(_order.status);
			var previousStatus = service.api.getPreviousStatus(_order.status);

			return (status.type !== 'production' || (previousStatus === null || previousStatus.type === 'production')) &&
					(nextStatus === null || nextStatus.type !== 'production');
		}

		function updatePositionsAfterEditor(profile, materialChanged){
			if(profile.positions[0].length!==profile.length || materialChanged){
				profile.positions[0].state = 'CHANGED';
			}

			if(profile.positions[0].length!== profile.length){
				profile.positions[0].length = profile.length;
				addReason(profile.positions[0],'length');
			}

			if(materialChanged){
				for(var i=0;i<profile.positions.length;i++){
					profile.positions[i].state = 'CHANGED';
					addReason(profile.positions[i],'material');
				}
			}
		}

		function addReason(position,reason){
			if(!position.stateChangeReasons){
				position.stateChangeReasons = [];
			}

			if(position.stateChangeReasons.indexOf(reason)===-1){
				position.stateChangeReasons.push(reason);
			}
		}

		function addAttachment(orderController){
			nuitUtils.showImageUploadDialog('order.attachment', true)
				.then(function(data){
					data.name = '';
					data.desc = '';
					orderController.order.attachments.push(data);
					if(orderController.orderForm) {
						orderController.orderForm.$setDirty();
					}else if(orderController.offerForm){
						orderController.offerForm.$setDirty();
					}
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue')
		.service('OrderDetailsViewService', OrderDetailsViewService);

	/** @ngInject */
	function OrderDetailsViewService($q, $filter, $injector, $state, nuitAuth, nuitDataService, nuitUtils, nuitUnits, nuitConfig, OrderViewService, DeliveryService) {
		//*******************************************
		// SERVICE
		//*******************************************
		var _delivery = {};
		var config = nuitConfig.getCurrent();

		var service = {
			symbolInFront: symbolInFront,
			getSymbolForKey: getSymbolForKey,
			needsInputConversion: needsInputConversion,
			getInputConversionType: getInputConversionType,
			getValue: getValue,
			reloadDeliveryObject: reloadDeliveryObject,
			updateDeliveryObject: updateDeliveryObject,
			clearDeliveryObject: function(){ angular.copy({}, _delivery); },
			update: update,
			showDeliveryError: showDeliveryError,
			onStatusChange: onStatusChange

		};
		//*******************************************

		Object.defineProperty(service, 'delivery', {
			get: function () {
				return _delivery;
			}
		});

		return service;

		//*******************************************
		// METHODS
		//*******************************************

		function symbolInFront(key) {
			var lowerCase = key.toLowerCase();

			if (lowerCase.includes('price') || lowerCase.includes('taxes') || lowerCase.includes('fee') || lowerCase.includes('discount')) {
				return config.localization.currencySymbolInFront;
			} else {
				return false;
			}
		}

		function getSymbolForKey(key) {
			var lowerCase = key.toLowerCase();

			if (lowerCase.includes('price') || lowerCase.includes('taxes') || lowerCase.includes('fee') || lowerCase.includes('discount')) {
				return config.localization.currency.symbol;
			} else if (lowerCase.includes('weight')) {
				return nuitUnits('weight').symbol;
			} else if (lowerCase.includes('length')) {
				return nuitUnits('length').symbol;
			} else if (lowerCase.includes('percent')) {
				return '%';
			} else {
				return '???';
			}
		}

		function needsInputConversion(key) {
			var lowerCase = key.toLowerCase();

			if (lowerCase.includes('weight') || lowerCase.includes('length')) {
				return true;
			} else {
				return false;
			}
		}

		function getInputConversionType(key) {
			var lowerCase = key.toLowerCase();

			if (lowerCase.includes('weight')) {
				return 'weight';
			} else if (lowerCase.includes('length')) {
				return 'length';
			} else {
				return '???';
			}
		}

		function getValue(value, key) {
			if (needsInputConversion(key)) {
				return $filter('nuitUnit')(value, getInputConversionType(key), true);
			} else {
				return $filter('nuitNumber')(value);
			}
		}

		function reloadDeliveryObject(){
			var order = OrderViewService.order;
			return DeliveryService.loadOne(order.id, true)
				.then(function (delivery){
					angular.copy(delivery, _delivery);
					return _delivery;
			});
		}

		function updateDeliveryObject(delivery, params){
			if(delivery.id){
				var order = OrderViewService.order;
				delivery.name = angular.copy(order.details.orderProjectName);

				if (order.status === '0') {
					delivery.status = 1;
				}

				if(delivery.desiredDate) {
					delivery.desiredDate.setHours(0, 0, 0, 0);
					delivery.desiredDate = Date.parse(delivery.desiredDate) / 1000;
				}

				if (delivery.shippingDate) {
					delivery.shippingDate.setHours(0, 0, 0, 0);
					delivery.shippingDate = Date.parse(delivery.shippingDate) / 1000;
				}
				if (delivery.deliveryDate) {
					delivery.deliveryDate.setHours(0, 0, 0, 0);
					delivery.deliveryDate = Date.parse(delivery.deliveryDate) / 1000;
				}
				if (delivery.pickedupDate) {
					delivery.pickedupDate.setHours(0, 0, 0, 0);
					delivery.pickedupDate = Date.parse(delivery.pickedupDate) / 1000;
				}

				return DeliveryService.updateDelivery(delivery, params)
					.then(function (response) {

						//vm.delivery = response;
						if (angular.isNumber(response.shippingDate)) {
							response.shippingDate = new Date(response.shippingDate * 1000);
							response.shippingDate.setHours(0, 0, 0, 0);
						}
						if (angular.isNumber(response.deliveryDate)) {
							response.deliveryDate = new Date(response.deliveryDate * 1000);
							response.deliveryDate.setHours(0, 0, 0, 0);
						}
						if (angular.isNumber(response.desiredDate)) {
							response.desiredDate = new Date(response.desiredDate * 1000);
							response.desiredDate.setHours(0, 0, 0, 0);
						}
						if (response.pickedupDate && angular.isNumber(response.pickedupDate)) {
							response.pickedupDate = new Date(response.pickedupDate * 1000);
							response.pickedupDate.setHours(0, 0, 0, 0);
						}

						angular.copy(response,_delivery);
						return;

					});
			}else{
				return $q.resolve();
			}
		}

		function update(tab, order){
			if (tab === 'forwarding') {
				return updateDeliveryObject(_delivery)
					.catch(function () {
						nuitUtils.showErrorToast('TRANSPORT.UPDATING_ERROR');
					});
			} else if(tab === 'detail'){
				return OrderViewService.updateOrder(order)
					.then(function (){
						return updateDeliveryObject(_delivery)
							.catch(function () {
									nuitUtils.showErrorToast('Delivery Object failed to update');
								});
					})
					.catch(function () {
						nuitUtils.showErrorToast('Error updating order');
					});
			} else {
				return OrderViewService.updateOrder(order)
					.catch(function () {
						nuitUtils.showErrorToast('Error updating order');
					});
			}
		}

		function showDeliveryError(){
			if (config.ims.transport.delivery.warning && _delivery.deliveryType === 2 ) {
				if (!_delivery.dimension || _delivery.carrierId === 0) {
					return true;
				}
			} else {
				return false;
			}
		}

		function onStatusChange() {
			return config.ims.transport.delivery.allDetailsBefore && showDeliveryError() ||
				_delivery.deliveryType === 2 && config.ims.transport.delivery.allDetailsBefore && (!_delivery.dimension || _delivery.carrierId === 0);
		}

	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders')
		.service('FixedTimeService', FixedTimeService);

	/** @ngInject */
	function FixedTimeService() {
		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			get: get,
			getFormattedTolerance: getFormattedTolerance
		};
		//*******************************************

		return service;

		//*******************************************
		// METHODS
		//*******************************************
		function get(order) {
			if (order.details.fixedTime) {
				var date = new Date(order.details.completionDate * 1000);
				date.setHours(order.details.fixedTime.hour);
				date.setMinutes(order.details.fixedTime.minute);

				return date.getTime() / 1000;
			} else {
				return order.details.completionDate;
			}
		}

		function getFormattedTolerance(fixedTime) {
			if (!fixedTime.tolerance) {
				return '-';
			} else {
				var sum = (fixedTime.hour + fixedTime.tolerance) * 60 + fixedTime.minute;
				var hours = Math.floor(sum / 60);
				var minutes = sum - hours * 60;
				return (hours < 10 ? '0' + hours : hours.toString()) + ':' + (minutes < 10 ? '0' + minutes : minutes.toString());
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders')
		.controller('OrdersController', OrdersController);

	/** @ngInject */
	function OrdersController(nuitConfig, imsTranslation, OrderService, OrderQueryService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.config = nuitConfig.getCurrent();
        vm.translation = imsTranslation;
        vm.OrderService = OrderService;
		vm.useBackend = OrderQueryService.useBackend;
        //*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders')
		.controller('OrderListController', OrderListController);

	/** @ngInject */
	function OrderListController($rootScope, ShopOrderDetailsService, $state, $timeout, $scope, $filter, $interval, OrderService, imsTranslation, nuitConfig,
								 nuitUtils, ListSelectionService, FilterCountService, FormatterService, nuitDataService,
								 OrderViewService, OrderDownloadService, FixedTimeService, DeliveryService, DateSearchService, OrderQueryService, CaseService, PaymentService, $q) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		OrderViewService.setApi('OrderService');
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.currentPage = $state.params.page || 0;
		vm.lastLoadedPage = -1;
		vm.pagesLoading = [];
		vm.currentPageEntities = [];
		vm.loading = true;
		vm.loadingArchive = false;
		vm.config = nuitConfig.getCurrent();
		vm.orders = OrderService.orders;
		vm.meta = OrderService.meta;
		vm.queue = OrderService.queue;
		vm.translation = imsTranslation;
		vm.searchText = $state.params.term || '';
		vm.statusFilter = $state.params.status || '0';
		vm.updateTimeout = null;
		vm.selection = ListSelectionService.get('order.orders', true);
		vm.ordersToProcess = 0;
		vm.unregisterConfigListener = null;
		vm.paymentStatus = [];
		vm.deliveryWarning = vm.config.ims.transport.delivery.warning;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openItem = openItem;
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.search = search;
		vm.getStatusById = OrderService.getStatusById;
		vm.deleteSelected = OrderViewService.deleteSelected;
		vm.canBeDeleted = function () {
			return vm.ordersToProcess === 0 && OrderViewService.canBeDeleted(vm, vm.config.ims.orders.canDeleteConditions);
		};
		vm.toggleSelectOrder = vm.selection.toggleSelectedEntity;
		vm.toggleSelectedOrders = toggleSelectedOrders;
		vm.isIndeterminate = function(entities){
			return vm.selection.isIndeterminate(entities.map(function(entity){return entity.id;}));
		};
		vm.moveToNextState = function(){
			OrderViewService.moveToNextState(vm)
				.then(function(){
					if(OrderQueryService.useBackend) {
						reloadOrders();
					}else{
						updateFilterCount();
						vm.selection.deselectAll();
					}
				});
		};
		vm.getOrderPositions = OrderService.getOrderPositions;
		vm.showStatusChangeButton = showStatusChangeButton;
		$scope.$parent.vm.setStatusFilter = setStatusFilter;
		$scope.$parent.vm.isFilterSelected = isFilterSelected;
		$scope.$parent.vm.getFilterCount = getFilterCount;
		vm.disableSelection = disableSelection;
		vm.filterAll = filterAll;
		vm.dateFilterChanged = dateFilterChanged;
		vm.getFixedTime = FixedTimeService.get;
		vm.getFormattedTolerance = FixedTimeService.getFormattedTolerance;
		vm.showDownloadButton = showDownloadButton;

		vm.checkDeliveryObject = checkDeliveryObject;
		vm.getPaymentStatus = getPaymentStatus;
		vm.loadPage = function(data){
			if(OrderQueryService.useBackend && vm.lastLoadedPage!==data.page+1) {
				reloadOrders({page: data.page+1})
					.then(function(){
						if(vm.meta.pagination.total_pages>=data.page+2) {
							reloadOrders({page: data.page + 2, skipSettingLastLoaded: true})
								.then(function(){
									if (data.page > 0) {
										reloadOrders({page: data.page, skipSettingLastLoaded: true});
									}
								});
						}
					});
			}
		};
		vm.getTitle = OrderQueryService.getTitle;
		vm.getTitleById = OrderQueryService.getTitleById;
		vm.getTotal = function(){
			if(vm.meta && vm.meta.pagination && vm.meta.pagination.count){
				return vm.meta.pagination.total;
			}else{
				return -1;
			}
		};
		vm.createOrder = createOrder;
		vm.updateFilterCount = updateFilterCount;
		vm.getPerson = function(id){
			return nuitDataService.getOne(OrderViewService.assignedUsers, id);
		};
		vm.ASSIGNEES_NAME = OrderViewService.ASSIGNEES_NAME;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		$scope.$on('$destroy', onDestroy);

		var now = new Date().getTime();
		vm.startFilterDate = new Date(now);
		vm.endFilterDate = new Date(now);

		vm.downloadUrl = function(appId, flowId){
			var status = vm.statusFilter==='-1'?OrderService.getStatusQueryParams(OrderService.queue):OrderQueryService.getStatusArrayForLoading(vm.statusFilter).join(',');
			return OrderDownloadService.downloadUrl(status,Math.round(DateSearchService.startTimestamp/1000),Math.round(DateSearchService.endTimestamp/1000),appId,flowId);
		};
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {
			var status = null;
			vm.loadingArchive = false;

			if (typeof $state.params.status !== 'undefined') {
				vm.statusFilter = $state.params.status;
				status = vm.getStatusById(vm.statusFilter);
			}

			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}

			if ($state.params.page && $state.params.page !== vm.currentPage) {
				vm.currentPage = $state.params.page || 0;
			}

			if ((!OrderQueryService.useBackend && vm.statusFilter === '-1') || (!OrderQueryService.useBackend && (status !== null && status.type === 'archive'))) {
				vm.loadingArchive = true;

				OrderQueryService.reload({status: OrderService.getStatusQueryParams(OrderService.queue),view:'essential', title:vm.searchText})
					.then(function () {
						filterAll();
						vm.loadingArchive = false;
					});
			} else {
				filterAll();
			}

			if($state.params.startFilterDate && $state.params.endFilterDate){
				vm.startFilterDate = new Date(parseInt($state.params.startFilterDate));
				vm.endFilterDate = new Date(parseInt($state.params.endFilterDate));
				DateSearchService.setDates(vm.startFilterDate,vm.endFilterDate);
				DateSearchService.enabled = true;
			}

			if(OrderQueryService.useBackend){
				vm.lastLoadedPage = -1;
				vm.currentPage = parseInt($state.params.page) || 0;
				OrderService.clear();
				vm.loadPage({page:vm.currentPage});
				updateFilterCount();
			}
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			if (nuitConfig.isReady()) {
				delayedInit();
			} else {
				vm.unregisterConfigListener = $rootScope.$on('config::config.loaded', delayedInit);
			}
		}

		function delayedInit() {
			if (nuitConfig.current.ims.orders.enabled) {
				if (OrderService.statusLoading) {
					OrderService.statusLoading.then(function(){
							return reloadOrders();
					});
				} else {
					reloadOrders();
				}

				if (angular.isNumber(vm.config.ims.orders.refreshInterval) && vm.config.ims.orders.refreshInterval > 0) {
					vm.updateTimeout = $interval(function () {
						reloadOrders();
					}, Math.max(2000, vm.config.ims.orders.refreshInterval));
				}

				DateSearchService.initDates(
					vm.config.ims.orders.list.dateFilter.startOffset,
					vm.config.ims.orders.list.dateFilter.endOffset
				);

				vm.startFilterDate = DateSearchService.startDate;
				vm.endFilterDate = DateSearchService.endDate;

				if (vm.unregisterConfigListener !== null) {
					vm.unregisterConfigListener();
				}
			}
		}

		function reloadOrders(override) {
			if (!angular.isNumber(vm.config.ims.orders.refreshInterval) || vm.config.ims.orders.refreshInterval <= 0) {
				stopRefreshing();
				return;
			}

			var status = vm.getStatusById(vm.statusFilter);

			var filter = {view:'essential'};

			if(OrderQueryService.useBackend){
				filter.page = (override && override.page)?override.page:(parseInt(vm.currentPage) + 1);
				filter.status = vm.statusFilter==='-1'?OrderService.getStatusQueryParams(OrderService.queue):OrderQueryService.getStatusArrayForLoading(vm.statusFilter).join(',');

				filter.sort_by = CaseService.snakeToCamelCase(vm.config.ims.orders.list.orderBy);

				if(vm.searchText && vm.searchText.length>0){
					filter.title = vm.searchText;
				}

				if(DateSearchService.enabled && vm.config.ims.orders.list.dateFilter.enabled){
					var splitName = vm.config.ims.orders.list.dateFilter.filterDate.split('.');
					filter[splitName[splitName.length-1]] = [
						'gte:' +  Math.round(DateSearchService.startTimestamp/1000),
						'lte:' + Math.round(DateSearchService.endTimestamp/1000)
					];
				}
			}else{
				var whichStatisToReload = null;

				if (vm.statusFilter === '-1' || status.type === 'archive') {
					whichStatisToReload = OrderService.getStatusQueryParams(OrderService.queue);
				} else {
					whichStatisToReload = OrderService.getStatusQueryParams(OrderService.queue, {type: 'archive'});
				}

				filter.status = whichStatisToReload;
			}

			/*if(filter.page){
				if(vm.pageLoadInProgress.indexOf(filter.page)!==-1){
					var deferred = $q.defer();
					deferred.resolve();
					return deferred.promise;
				}else {
					vm.pageLoadInProgress.push(filter.page);
				}
			}*/

			if(OrderQueryService.useBackend) {
				if(vm.pagesLoading.indexOf(filter.page)!==-1){
					var deferred = $q.defer();
					deferred.resolve();
					return deferred.promise;
				}else {
					vm.pagesLoading.push(filter.page);
				}
			}

			return OrderQueryService.reload(filter)
				.then(function () {
					if(filter.page && !(override && override.skipSettingLastLoaded)) {
						/*var index = vm.pageLoadInProgress.indexOf(filter.page);
						if(index!==-1) {
							vm.pageLoadInProgress.splice(index, 1);
						}*/
						vm.lastLoadedPage = filter.page;
					}

					if (vm.config.ims.transport.enabled || (vm.config.evo.cart && vm.config.evo.cart.payment && vm.config.evo.cart.payment.enabled)) {
						vm.orders.forEach(function (order) {
							if (!order.hasOwnProperty('_partial')) {
								order._partial = true;
							}
						});
					}
					var selected = vm.selection.getSelected();
					vm.selection.deselectAll();
					filterAll();

					$timeout(function () {
						for (var index in vm.filteredEntities) {
							if (selected.indexOf(vm.filteredEntities[index].id) >= 0) {
								vm.toggleSelectOrder(vm.filteredEntities[index].id);
							}
						}
					});
					if (!vm.config.ims.transport.enabled || vm.filteredEntities.length===0 || OrderQueryService.useBackend) {
						vm.loading = false;
					}

					if(!override) {
						updateFilterCount();
					}
				})
				.finally(function(){
						var pageIndex = vm.pagesLoading.indexOf(filter.page);
						if(pageIndex!==-1){
							vm.pagesLoading.splice(pageIndex,1);
						}
					});
				/*.then(function(){
					if(filter.page) {
						filter.page++;
						OrderQueryService.reload(filter);
					}
				})*/
		}

		function stopRefreshing() {
			if (vm.updateTimeout !== null) {
				$interval.cancel(vm.updateTimeout);
			}
		}

		function onDestroy() {
			stopRefreshing();
		}

		/**
		 * Toggles the selected orders.
		 */
		function toggleSelectedOrders() {
			var ordersNotInProduction = [];

			for (var i in vm.currentPageEntities) {
				if (vm.disableSelection(vm.currentPageEntities[i].status)) {
					continue;
				}

				ordersNotInProduction.push(vm.currentPageEntities[i].id);
			}

			vm.selection.toggleSelectedEntities(ordersNotInProduction);
		}

		function setStatusFilter(id) {
			OrderService.clear();
			if (vm.statusFilter === String(id)) {
				return;
			}
			vm.statusFilter = String(id);
			vm.selection.deselectAll();
			$state.go('.', {
				status: id >= 0 ? vm.statusFilter : undefined,
				page: 0,
				term: vm.searchText
			})
				.then(function(){
					if(!OrderQueryService.useBackend && vm.statusFilter!=='-1'){
						vm.loading = true;
						reloadOrders();
					}
				});
			filterAll();
		}

		function isFilterSelected(id) {
			return vm.statusFilter === id.toString();
		}

		function getFilterCount(id) {
			var statusForCounting = OrderQueryService.getStatusArrayForLoading(id);

			var count = 0;

			for(var i=0; i<statusForCounting.length;i++){
				count += OrderService.getStatusCountById(statusForCounting[i]);
			}

			return count;
		}

		function filterAll() {
			if(!OrderQueryService.useBackend) {
				vm.filteredEntities = [];

				for (var i = 0; i < vm.orders.length; i++) {
					var order = vm.orders[i];
					if (filter(order)) {
						vm.filteredEntities.push(order);
					}
				}

				vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, vm.config.ims.orders.list.orderBy, true);
			}else{
				vm.filteredEntities = [];
				for (var j = 0; j < vm.orders.length; j++) {
					vm.filteredEntities.push(vm.orders[j]);
				}
			}
		}

		function updateFilterCount(){
			OrderService.orderCountByStatus();
		}

		function filter(order) {
			if (vm.statusFilter < 0) {
				return dateInBetween(order) && matchesSearchTerm(order);
			} else {
				var nextStatus = OrderService.getNextStatus(vm.statusFilter);

				if (nextStatus != null && nextStatus.type === 'production') {
					return dateInBetween(order) && matchesSearchTerm(order) && (order.status === vm.statusFilter || (OrderService.getStatusById(order.status) !== null && OrderService.getStatusById(order.status).type === 'production'));
				} else {
					return dateInBetween(order) && matchesSearchTerm(order) && order.status === vm.statusFilter;
				}
			}
		}

		function matchesSearchTerm(order) {
			return vm.searchText === '' || FormatterService.matches(vm.config.ims.orders.nameFormat, order, vm.searchText);
		}

		function dateInBetween(offer){
			if(vm.config.ims.orders.list.dateFilter.enabled){
				return DateSearchService.inBetween(offer, vm.config.ims.orders.list.dateFilter.filterDate);
			}else{
				return true;
			}
		}

		function openItem(itemId) {
			$state.go('app.orders.detail', {
				orderId: itemId,
				page: vm.currentPage,
				status: vm.statusFilter,
				term: vm.searchText,
				startFilterDate: DateSearchService.enabled?DateSearchService.startTimestamp:undefined,
				endFilterDate: DateSearchService.enabled?DateSearchService.endTimestamp:undefined
			}, {inherit: false});
		}

		function search() {
			if(OrderQueryService.useBackend) {
				vm.currentPage = 0;
				OrderService.clear();
			}
			$state.go('app.orders', {term: vm.searchText, page: vm.currentPage, status: vm.status});
		}

		function dateFilterChanged(){
			if(OrderQueryService.useBackend){
				vm.currentPage = 0;
				OrderService.clear();
				$state.go('app.orders', {
					term: vm.searchText,
					page: vm.currentPage,
					status: vm.status, startFilterDate: DateSearchService.enabled?DateSearchService.startTimestamp:undefined,
					endFilterDate: DateSearchService.enabled?DateSearchService.endTimestamp:undefined
				});
			}else{
				filterAll();
			}
		}

		function showDownloadButton(){
			return 	DateSearchService.enabled &&
					vm.statusFilter === '-1' &&
					vm.config.ims.orders.list.download.enabled &&
					vm.config.ims.orders.list.download.appId!=='' &&
					vm.config.ims.orders.list.download.flowId!=='';
		}

		function showStatusChangeButton(item) {
			if(vm.ordersToProcess!==0){
				return false;
			}

			var status = OrderService.getStatusById(vm.statusFilter);

			if(status) {
				return vm.config.ims.orders.denyTransitionFromStatus.indexOf(vm.statusFilter) === -1 &&
					disableInProductionMode() &&
					status.id > -1 &&
					//vm.statusFilter < OrderService.queue.length &&
					status.type !== 'archive' &&
					vm.ordersToProcess === 0 && disableForDeliveryWarning(item) &&
					OrderService.getNextStatus(vm.statusFilter)!==null;
			}else{
				return false;
			}
		}

		function disableForDeliveryWarning(item) {
			if(vm.config.ims.transport.enabled){
				var orderIds = item.getSelected();
				var show = true;
				angular.forEach(orderIds, function (orderId) {
					var order = nuitDataService.getOne(vm.currentPageEntities, orderId);
					if(order && order.deliveryRequired) {
						show = false;
					}
				});
				return show;
			}else{
				return true;
			}
		}

		function disableInProductionMode() {
			var nextStatus = OrderService.getNextStatus(vm.statusFilter);
			var status = OrderService.getStatusById(vm.statusFilter);
			var previousStatus = OrderService.getPreviousStatus(vm.statusFilter);

			return (status.type !== 'production' || (previousStatus === null || previousStatus.type === 'production')) &&
				(nextStatus === null || nextStatus.type !== 'production');
		}

		function disableSelection(status) {
			var currentStatus = OrderService.getStatusById(status);
			return currentStatus !== null && currentStatus.type === 'production';
		}

		function getPaymentStatus(order){
			var payment = nuitDataService.getOne(vm.paymentStatus,order.id);

			if(payment){
				return payment.status;
			}else{
				return 'none';
			}
		}

		function checkDeliveryObject(order) {
			if(vm.config.evo.cart && vm.config.evo.cart.assignee && vm.config.evo.cart.assignee.enabled){
				OrderViewService.loadAssignees(order[vm.ASSIGNEES_NAME]);
			}

			if(vm.config.evo.cart && vm.config.evo.cart.payment && vm.config.evo.cart.payment.enabled){
				PaymentService.getPaymentStatus(order.id)
					.then(function(data){
						nuitDataService.upsertOne(vm.paymentStatus,data);
					});
			}

			if (vm.config.ims.transport.enabled) {
				order.deliveryWarning = false;
				order.deliveryRequired = false;
				return DeliveryService.loadOne(order.id, true)
					.then(function (delivery) {
						if(delivery.deliveryType === 2){
							if(!delivery.dimension || !delivery.packageUnits || delivery.carrierId === 0){
								if(vm.deliveryWarning){
									order.deliveryWarning = true;
								}
								if(vm.config.ims.transport.delivery.allDetailsBefore){
									order.deliveryRequired = true;
								}
							}
						}
						return order;
					})
					.catch(function (e) {
						if(e.status !== 400){
							nuitUtils.showErrorToast();
						}
					})
					.finally(function () {
						vm.loading = false;
					});
			}else{
				var deferred = $q.defer();
				deferred.resolve(order);
				return deferred.promise;
			}
		}
		function createOrder(){
			return OrderService.createOrder(
				{
					details: {
						orderProjectName: '-',
						//completionDate: new Date().getTime() / 1000
					},
					status: 0
				}
			)
				.then(function(order){
					var config = ShopOrderDetailsService.getDefaultDialogConfig();

					config.details.editButton = true;
					config.details.completionDatePicker = true;

					config.positions = false;
					config.specials = false;
					config.products = false;
					config.products = false;

					config.prices.show = false;

					ShopOrderDetailsService.editOrDeleteById(order.id, config)
						.then(function (order) {
							reloadOrders();
						});
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders')
		.controller('OrderForwardingDetailsController', OrderForwardingDetailsController);

	/** @ngInject */
	function OrderForwardingDetailsController(
		$filter,
		$translate,
		$state,
		$scope,
		$mdToast,
		nuitUnits,
		nuitConfig,
		nuitAuth,
		FixedTimeService,
		nuitProducts,
		imsColors,
		imsMaterials,
		imsUtils,
		nuitDataService,
		AddressService,
		ForwarderService,
		ConditionCheckService,
		CART_SHIPPING_TYPES,
		DeliveryService,
		nuitUtils,
		OrderViewService,
		$mdDialog,
		nuitApi,
		DeliveryWorkdayService,
		OrderDetailsViewService,
		EVOConfigService
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();                            // Contains the nuit config
		vm.orderId = $state.params.orderId;               // ID of current material
		vm.currentTab = $state.params.active;
		vm.order = OrderViewService.order;                            // Contains current order
		vm.origin = $state.params.origin;
		//********************************************
		//*Transport Module
		vm.deliveryCompanies = ForwarderService.forwarders;
		vm.delivery = {};
		vm.dateLink = true;
		vm.desiredDateLink = true;
		vm.loadingForwarding = true;
		vm.loadingOrder = OrderViewService.loadingOrder;
		vm.statusFields = DeliveryService.statusFields;
		vm.deliveryTypes = [
			{id: 1, name: 'TRANSPORT.PICKUP'},
			{id: 2, name: 'TRANSPORT.DELIVERY'}
		];
		vm.deliveryWorkDays = DeliveryWorkdayService.deliveryWorkDays;
		vm.validWorkDays = [];
		//transport Warning
		vm.deliveryWarning = vm.config.ims.transport.delivery.warning;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.reloadDelivery = reloadDelivery;
		vm.getDocumentURL = imsUtils.getDocumentURL;
		vm.openImage = imsUtils.openImage;
		vm.symbolInFront = OrderDetailsViewService.symbolInFront;
		vm.getSymbolForKey = OrderDetailsViewService.getSymbolForKey;
		vm.editAddress = vm.editAddress = function(parent, addressKey, company, addressType){
			AddressService.openAndSave(parent, addressKey, company, addressType)
				.then(function(){
					$scope.$parent.vm.orderForm.$setDirty();
				});
		};
		vm.getStatusById = OrderViewService.api.getStatusById;

		vm.moveToNextState = OrderViewService.moveToNextState;
		vm.showStatusChangeButton = OrderViewService.showStatusChangeButton;
		vm.deleteSelected = OrderViewService.deleteSelected;
		vm.canBeDeleted = function(){return OrderViewService.canBeDeleted(vm);};
		vm.isEditable = isEditable;

		vm.getStatusName = getStatusName;
		vm.showDeliveryError = OrderDetailsViewService.showDeliveryError;
		vm.calculateDays = calculateDays;
		vm.validDate = validDate;
		vm.changeDeliveryStatus = changeDeliveryStatus;
		vm.setCarrierId = setCarrierId;
		vm.filterDeliveryDates = filterDeliveryDates;
		vm.addAttachment = function(){OrderViewService.addAttachment(vm);};

		vm.needsInputConversion = OrderDetailsViewService.needsInputConversion;
		vm.getInputConversionType = OrderDetailsViewService.getInputConversionType;
		vm.getValue = OrderDetailsViewService.getValue;

		vm.isHoliday = EVOConfigService.isHoliday;

		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************
		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Sets all required variables which are needed by the view and loads current material into scope
		 */
		function init() {
			$scope.$watch('vm.delivery', function(){
				//console.error('updating watch!!',vm.delivery.postalcodeDelay);
				updateLinks();
				updateDates();
			},true);

			if (angular.isArray(vm.origin)) {
				vm.origin = vm.origin[0];
			}
			if(vm.loadingOrder){
				return vm.loadingOrder.then(function (){return reloadDelivery();});
			}else{
				return reloadDelivery();
			}
		}

		function isEditable(){
			return $scope.$parent.vm.dialogConfig.details.editButton ;
		}


		function reloadDelivery() {
			if (vm.config.ims.transport.enabled && vm.order.companyId) {
				ForwarderService.reload();
				DeliveryWorkdayService.reload()
					.then(function (){
						vm.deliveryWorkDays.forEach(function (day) {
							vm.validWorkDays.push(day.weekday);
						});
					});
				DeliveryService.reloadStatus();
				OrderDetailsViewService.reloadDeliveryObject()
					.then(function (response) {
						vm.delivery = response;
						updateLinks();
						updateDates();
					})
					.finally(function () {
						vm.loadingForwarding = false;
					});
			}else{
				OrderDetailsViewService.clearDeliveryObject();
			}
		}

		function updateLinks(){
			vm.dateLink = true;
			vm.desiredDateLink = true;

			//console.error('update links',vm.delivery.postalcodeDelay);

			if (angular.isNumber(vm.delivery.deliveryDate) && angular.isNumber(vm.delivery.shippingDate)) {
				if ((vm.delivery.deliveryDate - vm.delivery.shippingDate) !== vm.delivery.postalcodeDelay) {
					vm.dateLink = false;
				}
			}else if (vm.delivery.deliveryDate && vm.delivery.shippingDate && (vm.delivery.deliveryDate.getTime() - vm.delivery.shippingDate.getTime()) !== vm.delivery.postalcodeDelay*1000) {
				vm.dateLink = false;
			}
			if(angular.isNumber(vm.delivery.desiredDate) && angular.isNumber(vm.delivery.deliveryDate)) {
				if (vm.delivery.desiredDate !== vm.delivery.deliveryDate) {
					vm.desiredDateLink = false;
				} else {
					vm.desiredDateLink = true;
				}
			}else if(vm.delivery.desiredDate && vm.delivery.deliveryDate) {
				vm.desiredDateLink = vm.delivery.desiredDate.getTime() === vm.delivery.deliveryDate.getTime();
			}else{
				vm.desiredDateLink = false;
			}

			if(angular.isNumber(vm.delivery.desiredDate) && angular.isNumber(vm.delivery.deliveryDate)) {
				if (vm.delivery.desiredDate !== vm.delivery.deliveryDate && vm.delivery.deliveryType === 2) {
					vm.desiredDateLink = false;
				}
			}else if (vm.delivery.deliveryDate && vm.delivery.deliveryDate && vm.delivery.desiredDate.getTime() !== vm.delivery.deliveryDate.getTime() && vm.delivery.deliveryType === 2) {
				vm.desiredDateLink = false;
			}
		}

		function updateDates(){
			if (angular.isNumber(vm.delivery.shippingDate)) {
				vm.delivery.shippingDate = new Date(vm.delivery.shippingDate * 1000);
				vm.delivery.shippingDate.setHours(0, 0, 0, 0);
			}
			if (angular.isNumber(vm.delivery.desiredDate)) {
				vm.delivery.desiredDate = new Date(vm.delivery.desiredDate * 1000);
				vm.delivery.desiredDate.setHours(0, 0, 0, 0);
			}
			if (angular.isNumber(vm.delivery.deliveryDate)) {
				vm.delivery.deliveryDate = new Date(vm.delivery.deliveryDate * 1000);
				vm.delivery.deliveryDate.setHours(0, 0, 0, 0);
			}
			if (vm.delivery.pickedupDate && angular.isNumber(vm.delivery.pickedupDate)) {
				vm.delivery.pickedupDate = new Date(vm.delivery.pickedupDate * 1000);
				vm.delivery.pickedupDate.setHours(0, 0, 0, 0);
			}
		}


		function calculateDays(key) {
			updateLinks();
			updateDates();

			if (key === 'shipping') {
				var shipping = angular.copy(vm.delivery.shippingDate);
				vm.delivery.deliveryDate = new Date(shipping.setSeconds(vm.delivery.postalcodeDelay));
				if (parseInt(vm.delivery.deliveryDate / 1000 / 60 / 60 / 24) === parseInt(vm.delivery.desiredDate / 1000 / 60 / 60 / 24)) {
					vm.desiredDateLink = true;
				} else {
					vm.desiredDateLink = false;
				}
				if(!vm.validWorkDays.includes(vm.delivery.deliveryDate.getDay())){
					vm.delivery.deliveryDate = adjustDay(vm.delivery.deliveryDate, 'plus');
				}

			}
			if (key === 'delivery') {
				var delivery = angular.copy(vm.delivery.deliveryDate);
				vm.delivery.shippingDate = new Date(delivery.setSeconds((vm.delivery.postalcodeDelay * -1)));
				if(!vm.validWorkDays.includes(vm.delivery.shippingDate.getDay())){
					vm.delivery.shippingDate = adjustDay(vm.delivery.shippingDate, 'minus');
				}
			}
			if (key === 'desired') {
				var desired = angular.copy(vm.delivery.desiredDate);
				vm.delivery.deliveryDate = desired;
				var desiredDelivery = angular.copy(desired);
				vm.delivery.shippingDate = new Date(desiredDelivery.setSeconds((vm.delivery.postalcodeDelay * -1)));
				vm.desiredDateLink = true;
				if(!vm.validWorkDays.includes(vm.delivery.shippingDate.getDay())){
					vm.delivery.shippingDate = adjustDay(vm.delivery.shippingDate, 'minus');
				}
			}
			if (key === 'desiredPickup') {
				var desiredPickup = angular.copy(vm.delivery.desiredDate);
				vm.delivery.shippingDate = desiredPickup;
				vm.delivery.deliveryDate = desiredPickup;
				vm.desiredDateLink = true;
			}
			vm.dateLink = true;
			$scope.$parent.vm.orderForm.$setDirty();
		}

		function adjustDay(date, sign){
			var newDate = angular.copy(date);
			if(!vm.validWorkDays.includes(date.getDay())){
				if(sign === 'minus'){
					newDate = new Date(date.setSeconds(86400 * -1));
				} else if(sign === 'plus') {
					newDate = new Date(date.setSeconds(86400));
				}
				return adjustDay(newDate, sign);
			} else {
				return newDate;
			}
		}

		function filterDeliveryDates(date) {
			if(vm.validWorkDays.length===0){
				return true;
			}else {
				return vm.validWorkDays.includes(date.getDay());
			}
		}

		function validDate() {
			return vm.delivery.deliveryDate < vm.delivery.shippingDate;
		}

		function getStatusName(id) {
			if (id) {
				for (var i = 0; i < vm.statusFields.length; i++) {
					if (vm.statusFields[i].id === id) {
						var text = vm.statusFields[i].type;
						return $translate.instant('TRANSPORT.' + text.toUpperCase());
					}
				}
			}
		}

		function changeDeliveryStatus(delivery) {
			$mdDialog
				.show(createChangeStatusDialog(delivery.status))
				.then(function (result) {
					var status = result[0];
					var pickedUp = result[1];
					if (status === 4) {
						DeliveryService.incrementOneStatus(delivery, status)
							.then(function (newStatus) {
								vm.delivery.status = newStatus;
								DeliveryService.updateOnePickedUpDate(delivery, pickedUp)
									.then(function (newPickedupDate) {
										vm.delivery.pickedupDate = new Date(newPickedupDate * 1000);
										vm.delivery.pickedupDate.setHours(0, 0, 0, 0);
									})
									.catch(nuitUtils.showErrorToast);
							})
							.catch(nuitUtils.showErrorToast);
					} else {
						DeliveryService.incrementOneStatus(delivery, status)
							.then(function (newStatus) {
								vm.delivery.status = newStatus;
								if (status === 2 && delivery.pickedupDate > 0 || status === 3 && delivery.pickedupDate > 0) {
									DeliveryService.updateOnePickedUpDate(delivery, null)
										.then(function (newPickedupDate) {
											vm.delivery.pickedupDate = newPickedupDate;
										});
								}
							})
							.catch(nuitUtils.showErrorToast);
					}
					nuitUtils.showSuccessToast();
				}).catch(angular.noop);
		}

		function createChangeStatusDialog(startStatus) {
			return {
				controller: 'ChangeDeliveryStatusDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/partners.transport/views/dialogs/change-status/change-delivery-status.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Status: angular.copy(startStatus)
				}
			};
		}

		function setCarrierId() {
			if(vm.delivery.deliveryType === 1){
				vm.delivery.carrierId = 0;
			}
		}

	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders')
		.controller('OrderDetailsController', OrderDetailsController);

	/** @ngInject */
	function OrderDetailsController(
		$q,
		$filter,
		$translate,
		$state,
		$mdToast,
		nuitUnits,
		nuitConfig,
		nuitAuth,
		FixedTimeService,
		nuitProducts,
		imsColors,
		imsMaterials,
		imsUtils,
		nuitDataService,
		AddressService,
		ForwarderService,
		ConditionCheckService,
		CART_SHIPPING_TYPES,
		nuitUtils,
		OrderViewService,
		$mdDialog,
		nuitApi,
		InvoiceService,
		nuitProfiles,
		SalesObject,
		OrderDetailsViewService,
		QuickbooksService,
		OrderSpecialService,
		EVOConfigService,
		OrderQueryService,
		PaymentService,
		OrderTagsService,
		OrderTagsViewService,
		PositionsService,
		NodeRedService,
		ProjectService,
		ProjectsViewService,
		XeroService,
		imsNextChannel
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		OrderViewService.setApi($state.current.data.api);
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.service = $state.current.data.api;
		vm.config = nuitConfig.getCurrent();                            // Contains the nuit config
		vm.queue = OrderViewService.api.queue;
		vm.orderId = $state.params.orderId;               // ID of current material
		vm.loadingItems = true;                          // Indicator if a loading process is running
		vm.currentTab = $state.params.active;
		vm.order = OrderViewService.order;                            // Contains current order
		vm.groups = [];
		vm.materials = imsMaterials.materials;
		vm.colors = imsColors.colors;
		vm.editDetails = false;
		vm.showPrices = false;
		vm.dialogConfig = {};
		vm.origin = $state.params.origin;
		vm.shippingTypes = CART_SHIPPING_TYPES;
		vm.editable = true;
		vm.ordersOrOffer = OrderViewService.ordersOrOffer;
		vm.payment = {status:'none'};
		vm.displayPayment = function(){
			return vm.config && vm.config.evo && vm.config.evo.cart && vm.config.evo.cart.payment && vm.config.evo.cart.payment.enabled;
		};
		vm.getSearchResults = OrderTagsViewService.getSearchResults;
		vm.openTags = OrderTagsViewService.openTags;
		vm.addTag = OrderTagsViewService.addTag;
		vm.projects = ProjectService.projects;

		vm.showProfileDetailsButton = nuitAuth.getEvoVersion() === 3;
		vm.imsNextChannel = imsNextChannel;

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.getTitle = OrderQueryService.getTitle;
		vm.reloadOrder = reloadOrder;
		vm.markModified = markModified;
		vm.markModifiedProduct = markModifiedProduct;
		vm.markModifiedSketch = markModifiedSketch;
		vm.updateOrder = updateOrder;
		vm.getMaterialById = imsMaterials.getMaterialById;
		vm.openEditor = openEditor;
		vm.getDocumentURL = imsUtils.getDocumentURL;
		vm.downloadDocument = imsUtils.downloadDocument;
		vm.openDocument = imsUtils.openDocument;
		vm.filterMaterialsForAttribute = filterMaterialsForAttribute;
		vm.filterColorsForAttribute = filterColorsForAttribute;
		vm.isDefinedAndNotNull = isDefinedAndNotNull;
		vm.openImage = imsUtils.openImage;
		vm.updateFixedTime = updateFixedTime;
		vm.addLeadingZero = addLeadingZero;
		vm.isEditable = isEditable;
		vm.getFormattedTolerance = getFormattedTolerance;
		vm.symbolInFront = OrderDetailsViewService.symbolInFront;
		vm.getSymbolForKey = OrderDetailsViewService.getSymbolForKey;
		vm.needsInputConversion = OrderDetailsViewService.needsInputConversion;
		vm.getInputConversionType = OrderDetailsViewService.getInputConversionType;
		vm.writeToOverride = writeToOverride;
		vm.hasOverrideValue = hasOverrideValue;
		vm.onChangeOverrideValue = onChangeOverrideValue;
		vm.deleteOverride = deleteOverride;
		vm.editAddress = function(parent, addressKey, company, addressType){
			AddressService.openAndSave(parent, addressKey, company, addressType)
				.then(function(){
					vm.orderForm.$setDirty();
				});
		};
		vm.showShippingAddress = showShippingAddress;
		vm.getStatusById = OrderViewService.api.getStatusById;

		vm.moveToNextState = OrderViewService.moveToNextState;
		vm.showStatusChangeButton = function(vm){
			return OrderViewService.hasNextStatus() &&
					OrderViewService.showStatusChangeButton(vm);
		};
		vm.deleteSelected = OrderViewService.deleteSelected;
		vm.canBeDeleted = function(){return OrderViewService.canBeDeleted(vm);};

		vm.onStatusChange = OrderDetailsViewService.onStatusChange;
		vm.showDeliveryError = OrderDetailsViewService.showDeliveryError;
		vm.showStatus = function (type){ return type !== 'proposal' && type!=='production'; };

		vm.getValue = OrderDetailsViewService.getValue;
		vm.addAttachment = function(){OrderViewService.addAttachment(vm);};

		vm.isConical = nuitProfiles.isConical;
		vm.hasCuts = nuitProfiles.hasCuts;
		vm.hasStamps = nuitProfiles.hasStamps;
		vm.getPunchCount = nuitProfiles.getPunchCount;

		vm.addProduct = OrderViewService.addProduct;
		vm.addProfile = OrderViewService.addProfile;
		vm.addSpecial = OrderViewService.addSpecial;

		vm.getSalesPosition = SalesObject.getPosition;
		vm.showSalesPosition = function(key, object){
			var overrideEntry = nuitDataService.getOne(vm.config.ims.orders.sales.showConditions, key);
			return SalesObject.showPosition(key, object, overrideEntry);
		};
		vm.setDirty = setDirty;
		vm.exportToQuickbooks = exportToQuickbooks;
		vm.onFlatProfilesUpdated = function() {
			vm.setDirty();
		};
		vm.openPayment = function(){
			if(vm.payment.lastPayment) {
				window.open(vm.payment.lastPayment.url, '_blank');
			}else{
				console.error('last payment is undefined');
			}
		};
		vm.getPerson = function(id){
			return nuitDataService.getOne(OrderViewService.assignedUsers, id);
		};
		vm.ASSIGNEES_NAME = OrderViewService.ASSIGNEES_NAME;

		vm.isHoliday = EVOConfigService.isHoliday;
		vm.showPosNumber = OrderQueryService.showPosNumber;
		vm.allMarkedForDeletion = PositionsService.allMarkedForDeletion;
		vm.exportToJobBoss = exportToJobBoss;
		vm.exportAsOfferToJobBoss = exportAsOfferToJobBoss;
		vm.exportToXero = exportToXero;

		vm.focusProjectSearch = ProjectsViewService.focusSearch;


		Object.defineProperty(vm, 'inProduction', {
			get: function () {
				if (!vm.order.status) {
					return false;
				} else {
					return OrderViewService.api.isInProduction(vm.order.status);
				}
			}
		});

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Sets all required variables which are needed by the view and loads current material into scope
		 */
		function init() {
			if (angular.isArray(vm.origin)) {
				vm.origin = vm.origin[0];
			}
			if (!vm.currentTab){
				vm.currentTab = 'detail';
			}
			reloadOrder();
			OrderTagsService.reload();
			ProjectService.reload();
		}

		function reloadOrder() {
			// Loads order
			OrderViewService.reload(vm.orderId)
				.then(function (order) {
					vm.fixedTime = order.details.hasOwnProperty('fixedTime');
					vm.hasFixedTime = vm.fixedTime;
					if (angular.isNumber(vm.order.details.completionDate)) {
						vm.order.details.completionDate = new Date(vm.order.details.completionDate * 1000);
					} else {
						vm.order.details.completionDate = new Date();
					}

					if (isMaterialRequired()) {
						imsMaterials.reload();
					}
					if (isColorRequired()) {
						imsColors.reload();
					}

					vm.editable = true;
					var hasPostProductionReadOnlyStatus = false;

					angular.forEach(vm.config.ims.orders.readOnlyStatis, function (status) {
						vm.editable = vm.editable && status.toString() !== vm.order.status;
						hasPostProductionReadOnlyStatus = hasPostProductionReadOnlyStatus || OrderViewService.api.isInPostProduction(status.toString());
					});

					vm.editable = vm.editable && !ConditionCheckService.matchesAll(vm.config.ims.orders.readOnlyConditions, vm.order, false);

					if (vm.editable) {
						//Production Status always overrules readOnlyStatis!!
						vm.editable = !OrderViewService.api.isInProduction(vm.order.status);
					}

					if(vm.editable && !hasPostProductionReadOnlyStatus){
						//if no post-production read only statis are set we default to FALSE for post-production
						vm.editable = !OrderViewService.api.isInPostProduction(vm.order.status);
					}

					angular.merge(
						vm.dialogConfig,
						{
							details:
								{
									editButton: vm.editable,
									completionDatePicker: vm.editable
								},
							positions:
								{
									add: !vm.editable, //true means read only
									remove: !vm.editable, //true means read only
									quantity: !vm.editable, //true means read only
									length: !vm.editable, //true means read only
									prices: !vm.editable, //true means read only
									specials: !vm.editable, //true means read only
									specialsPrice: !vm.editable, //true means read only
									positionCheck: !vm.editable, //true means read only
									positionMarkForCheck: !vm.editable, //true means read only
									profileEditable: vm.editable,
									nameEditable: vm.editable,
									remarkEditable: vm.editable,
								},
							specials: !vm.editable, //true means read only
							products: !vm.editable, //true means read only
							prices: {
								show: true
							}
						}
					);

					vm.showPrices = vm.config.evo.cart.showPrices && vm.dialogConfig.prices.show;

					if(vm.config.ims.accounting.enabled && vm.order.invoiceId){
						nuitApi('accounting.invoices').get({numbers: [vm.order.invoiceId]})
							.then(function(response){
								if(angular.isArray(response.data) && response.data.length===1) {
									vm.invoice = response.data[0];
								}
							});
					}

					if(vm.config.evo.cart && vm.config.evo.cart.payment && vm.config.evo.cart.payment.enabled){
						PaymentService.getPaymentStatus(order.id)
							.then(function(data){
								vm.payment = data;
							});
					}

					if(vm.config.evo.cart && vm.config.evo.cart.assignee && vm.config.evo.cart.assignee.enabled){
						OrderViewService.loadAssignees(vm.config.evo.cart.assignee.users);
					}
				})
				.catch(imsUtils.showErrorToast)
				.finally(vm.loadingItems = false);
		}

		/**
		 * Returns true if a material is required in any attribute.
		 * @returns {Boolean}
		 */
		function isMaterialRequired() {
			if (vm.order.profiles.length > 0) {
				return true;
			}
			for (var j in vm.order.products) {
				if(vm.order.products[j].type==='profile'){
					return true;
				}

				for (var i in vm.order.products[j].attributes) {
					if (vm.order.products[j].attributes[i].type === 'material') {
						return true;
					}
				}
			}
			return false;
		}

		/**
		 * Returns true if a material is required in any attribute.
		 * @returns {Boolean}
		 */
		function isColorRequired() {
			for (var j in vm.order.products) {
				for (var i in vm.order.products[j].attributes) {
					if (vm.order.products[j].attributes[i].type === 'color') {
						return true;
					}
				}
			}
			return false;
		}

		function filterMaterialsForAttribute(attribute) {
			var blacklist = !!attribute.restrictions.blacklist;
			return function (material) {
				var matches = attribute.restrictions.materials.indexOf(material.id) >= 0 || attribute.restrictions.groups.indexOf(material.rawMaterialId) >= 0;
				return matches !== blacklist;
			};
		}

		function filterColorsForAttribute(attribute) {
			var blacklist = !!attribute.restrictions.blacklist;
			return function (color) {
				var matches = attribute.restrictions.colors.indexOf(color.id) >= 0;
				return matches !== blacklist;
			};
		}

		function markModified(position) {
			vm.orderForm.$setDirty();
			if (position && position.state && position.state === 'NEW') {
				updateOrder();
			}
		}

		function markModifiedProduct(product, index) {
			if (product.positions.length === 0) {
				nuitDataService.removeOne(vm.order.products, product.id);
				updateOrder();
			} else {
				product.state = 'CHANGED';
				vm.orderForm.$setDirty();
			}
		}

		function markModifiedSketch(sketch) {
			sketch.state = 'CHANGED';
			vm.orderForm.$setDirty();
		}

		/**
		 * Sends updated material to remote server. Edited sketch name/remark
		 * ride along in the order body and are persisted server-side.
		 */
		function updateOrder() {
			OrderSpecialService.batchAddFlatProfiles(vm.order)
				.then(function(){
					var order = angular.copy(vm.order);
					if (!angular.isNumber(order.details.completionDate)) {
						order.details.completionDate = parseInt(order.details.completionDate.getTime() / 1000);
					}

					OrderDetailsViewService.update($state.params.active, order)
						.then(function (response) {
							vm.orderForm.$setPristine();
							if (angular.isNumber(vm.order.details.completionDate)) {
								vm.order.details.completionDate = new Date(vm.order.details.completionDate * 1000);
							}
							nuitUtils.showSuccessToast();
						});
				});
		}

		function isDefinedAndNotNull(object) {
			return typeof object !== 'undefined' && object !== null;
		}

		function openEditor(profile) {
			var remark = profile.remark;
			var posNumber = profile.posNumber;
			var materialId = angular.copy(profile.materialId);
			imsUtils
				.openEditorAndSaveMultipleDefault(profile)
				.then(function (newProfile) {
					OrderViewService.updatePositionsAfterEditor(profile, newProfile.materialId!==materialId);
					profile.remark = remark;
					profile.posNumber = posNumber;
					vm.orderForm.$setDirty();
				});

		}

		function updateFixedTime() {
			if (vm.fixedTime) {
				vm.order.details.fixedTime = {
					hour: vm.config.evo.cart.fixedTime.hours[0],
					minute: vm.config.evo.cart.fixedTime.minutes[0],
					tolerance: vm.config.evo.cart.fixedTime.tolerances[0]
				};
			} else if (vm.order.details.fixedTime) {
				delete vm.order.details.fixedTime;
			}

			vm.fixedTime = vm.order.details.hasOwnProperty('fixedTime');
			vm.hasFixedTime = vm.fixedTime;
		}

		function addLeadingZero(number) {
			var postfix = number < 9 ? '0' : '';
			return postfix + number.toString();
		}

		function isEditable(attribute) {
			if (typeof attribute === 'boolean') {
				return attribute;
			} else if (typeof vm.dialogConfig.positions === 'boolean') {
				return !vm.dialogConfig.positions;
			} else {
				return false;
			}
		}

		function getFormattedTolerance(hour, minute, tolerance) {
			if (angular.isNumber(hour) && angular.isNumber(minute) && angular.isNumber(tolerance)) {
				return $translate.instant('ORDERS.TOLERANCE', {
					tolerance: FixedTimeService.getFormattedTolerance({
						hour: hour,
						minute: minute,
						tolerance: tolerance
					})
				});
			} else {
				return '-';
			}
		}

		function writeToOverride(key){
			switch (key){
				case 'logisticPrice':
					return true;
				default:
					return false;
			}
		}

		function deleteOverride(key){
			if(hasOverrideValue(key)){
				delete vm.order.sales.overrides[key];
				vm.orderForm.$setDirty();
			}
		}

		function hasOverrideValue(key){
			return vm.order.sales.overrides && vm.order.sales.overrides[key]!==undefined;
		}

		function onChangeOverrideValue(key){
			if(writeToOverride(key)) {
				if (vm.order.sales.overrides === undefined) {
					vm.order.sales.overrides = {};
				}

				if (!hasOverrideValue(key)) {
					vm.order.sales.overrides[key] = vm.order.sales[key];
				}
			}
		}

		function showShippingAddress(){
			return !vm.config.ims.transport.enabled || vm.config.ims.transport.enabled && !vm.order.companyId;
		}

		function setDirty(){
			if(vm.orderForm) {
				vm.orderForm.$setDirty();
			}
		}

		function exportToQuickbooks(){
			var promise;

			if(vm.order.externalData.qbInvoiceId && vm.order.externalData.qbInvoiceId.length>0){
				promise = nuitUtils.showConfirmationDialog(
					'QUICKBOOKS.CONFIRM_INVOICE_OVERRIDE_TITLE',
					'QUICKBOOKS.CONFIRM_INVOICE_OVERRIDE_CONTENT'
				);
			}else{
				promise = $q.resolve();
			}

			promise.then(function(){
				return QuickbooksService.get(vm.config.ims.exchange.quickbooks.invoice.export.appId).invoiceExport(vm.orderId)
					.then(function(data){
						vm.order.externalData.qbInvoiceId = data.qbInvoiceId;
						vm.order.externalData.qbInvoiceUrl = data.qbInvoiceUrl;
						nuitUtils.showSuccessToast();
					})
					.catch(nuitUtils.showErrorToast);
				}
			);
		}

		function exportToJobBoss(){
			nuitUtils.showConfirmationDialog(
				'JOBBOSS.CONFIRM_ORDER_OVERRIDE_TITLE',
				'JOBBOSS.CONFIRM_ORDER_OVERRIDE_CONTENT'
			)
				.then(function(){
				NodeRedService.get(vm.config.ims.exchange.jobBoss.order.export.appId)
					.execute(
						vm.config.ims.exchange.jobBoss.order.export.flowId,
						{
							orderId: vm.orderId
						});
			});
		}

		function exportAsOfferToJobBoss(){
			nuitUtils.showConfirmationDialog(
				'JOBBOSS.CONFIRM_OFFER_OVERRIDE_TITLE',
				'JOBBOSS.CONFIRM_OFFER_OVERRIDE_CONTENT'
			)
				.then(function(){
					NodeRedService.get(vm.config.ims.exchange.jobBoss.order.exportAsOffer.appId)
						.execute(
							vm.config.ims.exchange.jobBoss.order.exportAsOffer.flowId,
							{
								orderId: vm.orderId
							});
				});
		}

		function exportToXero(){
			var promise;

			if(vm.order.externalData.xeroInvoiceId && vm.order.externalData.xeroInvoiceId.length>0){
				promise = nuitUtils.showConfirmationDialog(
					'XERO.CONFIRM_INVOICE_OVERRIDE_TITLE',
					'XERO.CONFIRM_INVOICE_OVERRIDE_CONTENT'
				);
			}else{
				promise = $q.resolve();
			}

			promise.then(function(){
					return XeroService.get(vm.config.ims.exchange.xero.invoice.export.appId).invoiceExport(vm.orderId)
						.then(function(data){
							vm.order.externalData.xeroInvoiceId = data.xeroInvoiceId;
							vm.order.externalData.xeroInvoiceUrl = data.xeroInvoiceUrl;
							nuitUtils.showSuccessToast();
						})
						.catch(nuitUtils.showErrorToast);
				}
			);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.service('InvoiceService', InvoiceService);

	/** @ngInject */
	function InvoiceService($q, $timeout, nuitApi, nuitDataService) {
		var _invoices = [];
		var _statusFields = [];

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			createInvoice: createInvoice,
			reload: reload,
			reloadByCompanyId: reloadByCompanyId,
			getInvoiceById: getInvoiceById,
			updateOneInvoice: updateOneInvoice,
			reloadStatus: reloadStatus,
			getCreditsByInvoiceId: getCreditsByInvoiceId,
			partialInvoiceUpdate: partialInvoiceUpdate
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'invoices', {
			get: function () {
				return _invoices;
			}
		});
		Object.defineProperty(service, 'statusFields', {
			get: function () {
				return _statusFields;
			}
		});

		return service;

		//*******************************************
		// METHODS
		//*******************************************
		function createInvoice(orders) {
			var selectedIds = orders.map(function (order) {
				return order.id;
			});

			return nuitApi('accounting.invoices').post({}, {orders: selectedIds.join(',')})
				.then(function (response) {
					_invoices.push(response.data);
					return _invoices[_invoices.length - 1];
				});
		}

		function reload(firstDay, lastDay, status) {
			return nuitApi('accounting.invoices').get({
				start: firstDay,
				end: lastDay,
				status: (status === -1 ? null : status)
			})
				.then(function (response) {
					return nuitDataService.replaceAll(_invoices, response.data);
				});
		}

		function reloadByCompanyId(firstDay, lastDay, status, companyId) {
			return nuitApi('accounting.invoices').get({
				start: firstDay,
				end: lastDay,
				status: (status === -1 ? null : status),
				company: companyId
			})
				.then(function (response) {
					return nuitDataService.replaceAll(_invoices, response.data);
				});
		}

		function partialInvoiceUpdate(invoice, update) {
			return nuitApi('accounting.invoices.one.update', invoice.id).patch(update)
				.then(function (response) {
					return nuitDataService.replaceOne(_invoices, response.data);
				});
		}

		function getInvoiceById(invoiceId) {
			return nuitApi('accounting.invoices.one.update', invoiceId)
				.get()
				.then(function (response) {
					var invoice = response.data;
					return invoice;
				});
		}

		function updateOneInvoice(invoice) {
			return nuitApi('accounting.invoices.one.update', invoice.id)
				.put(invoice)
				.then(function (response) {
					return nuitDataService.replaceOne(_invoices, response.data);
				});

		}

		function reloadStatus() {
			return nuitApi('accounting.invoices.status')
				.get()
				.then(function (response) {
					return nuitDataService.replaceAll(_statusFields, response.data);
				});
		}

		function getCreditsByInvoiceId(id) {
			return nuitApi('credit.credits')
				.get({invoice: id})
				.then(function (response) {
					return response.data;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.service('InvoiceRemarkService', InvoiceRemarkService);

	/** @ngInject */
	function InvoiceRemarkService($q, $timeout, nuitApi, nuitDataService) {
		var _remarks = [];
		var _remarkType = [];

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			reloadType: reloadType,
			createRemark: createRemark,
			updateRemark: updateRemark,
			loadOneRemark: loadOneRemark
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'remarks', {
			get: function () {
				return _remarks;
			}
		});
		Object.defineProperty(service, 'remarkType', {
			get: function () {
				return _remarkType;
			}
		});

		return service;

		//*******************************************
		// METHODS
		//*******************************************


		function reload(invoiceId) {
			return nuitApi('accounting.invoices.remarks', invoiceId).get()
				.then(function (response) {
					return nuitDataService.replaceAll(_remarks, response.data);
				});
		}
		function loadOneRemark(invoiceId, id) {
			return nuitApi('accounting.invoices.remarks.one', invoiceId, id)
				.get()
				.then(function (response) {
					console.log(response.data);
					return response.data;
				});
		}

		function reloadType() {
			return nuitApi('accounting.invoices.remarks.type').get()
				.then(function (response) {
					return nuitDataService.replaceAll(_remarkType, response.data);
				});
		}

		function createRemark(remark, invoiceId) {
			console.log(invoiceId);
			return nuitApi('accounting.invoices.remarks', invoiceId).post({
				type: remark.type,
				remark: remark.remark
			})
				.then(function (response) {
					return _remarks.push(response.data);
				});

		}
		function updateRemark(invoiceId, remark) {
			return nuitApi('accounting.invoices.remarks.one',invoiceId, remark.id).patch({
				type: remark.type,
				remark: remark.remark
			})
				.then(function (response) {
					return nuitDataService.replaceOne(_remarks, response.data);
				});

		}

	}
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.service('InvoiceBoardService', InvoiceBoardService);

	/** @ngInject */
	function InvoiceBoardService($filter, InvoiceService, nuitDataService, InvoiceRemarkService, nuitConfig, $q) {

		var config = nuitConfig.current;

		var _invoices = [];
		var _groupedInvoices = {};

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			reload: reload
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'groupedInvoices', {
			get: function () {
				return _groupedInvoices;
			}
		});

		var PAYMENT_STATES = {
			CREATED: 'CREATED',
			DISCOUNTED: 'DISCOUNTED',
			REGULAR: 'REGULAR',
			OVERDUE: 'OVERDUE',
			PAID: 'PAID'
		};

		service.PAYMENT_STATES = PAYMENT_STATES;

		return service;

		//*******************************************
		// METHODS
		//*******************************************
		function reload(firstDay, lastDay) {
			nuitDataService.replaceAll(_invoices, []);
			return InvoiceService.reload(firstDay - (config.ims.accounting.calendar.loadDaysBefore * 86400), lastDay + (config.ims.accounting.calendar.loadDaysAfter * 86400), null)
				.then(function (invoices) {
					nuitDataService.replaceOneEntity(_groupedInvoices, {});
					nuitDataService.replaceAll(_invoices, angular.copy(invoices));
					return InvoiceRemarkService.reloadType().then(function () {
						for (var i = 0; i < invoices.length; i++) {
							nuitDataService.upsertOne(_invoices, angular.copy(invoices[i]));
						}
						return sanitizeInvoices()
							.then(function () {
								return groupByDate()
									.then(function () {
										return _groupedInvoices;
									});
							});
					});
				});
			//});
		}

		function sanitizeInvoices() {
			var promises = [];

			for (var i = 0; i < _invoices.length; i++) {
				var invoice = _invoices[i];

				var now = new Date();
				now.setHours(0, 0, 0, 0);
				var slotDate = new Date(invoice.createdAt * 1000);
				var paymentState = PAYMENT_STATES.CREATED;
				var discountDate = new Date(invoice.discountDate * 1000);
				discountDate.setHours(0, 0, 0, 0);
				var dueDate = new Date(invoice.dueDate * 1000);
				dueDate.setHours(0, 0, 0, 0);
				var isPaid = invoice.paidAt > 0;
				var overdueDays = null;
				var remark = [];


				if (isPaid) {
					slotDate = new Date(invoice.paidAt * 1000);
					slotDate.setHours(0, 0, 0, 0);
					paymentState = PAYMENT_STATES.PAID;
				} else if (invoice.status === 2) {
					if (now > dueDate) {
						slotDate = now;
						paymentState = PAYMENT_STATES.OVERDUE;
						overdueDays = parseInt(slotDate / 1000 / 60 / 60 / 24) - parseInt(dueDate / 1000 / 60 / 60 / 24);

						if (invoice.invoiceRemarks.length > 0) {
							for (var r = 0; r < invoice.invoiceRemarks.length; r++) {
								if (invoice.invoiceRemarks[r].type !== 6) {
									var rem = [];
									rem.push(filterRemark(invoice.invoiceRemarks[r]));
									nuitDataService.replaceAll(remark, rem);
								}
							}
						}
					} else if (now <= discountDate) {
						slotDate = discountDate;
						paymentState = PAYMENT_STATES.DISCOUNTED;

					} else {
						paymentState = PAYMENT_STATES.REGULAR;
						slotDate = dueDate;
					}
				}
				slotDate = setToWorkDay(slotDate);
				promises.push(
					nuitDataService.replaceOne(
						_invoices,
						{
							id: invoice.id,
							number: invoice.number,
							status: invoice.status,
							createdAt: invoice.createdAt,
							dueDate: invoice.dueDate,
							discountDate: invoice.discountDate,
							paymentState: paymentState,
							sumNetPrice: invoice.sumNetPrice,
							company: invoice.company.name,
							remark: remark,
							overdueDays: overdueDays,
							slotDateFormatted: $filter('nuitDatetime')(slotDate.getTime() / 1000, 'date')
						}
					)
			);
			}

			return $q.all(promises);
		}


		function setToWorkDay(date) {
			var validWorkDays = config.ims.accounting.calendar.workDays;

			var workDay = date.getDay();

			if (validWorkDays.includes(workDay)) {
				return date;
			} else {
				var next = -1;
				var prev = -1;

				for (var day = 6; day >= 0; day--) {
					if (validWorkDays.includes(day)) {
						var newDate = new Date(date.getTime());
						newDate.setDate(date.getDate() - workDay + day);

						if (newDate.getTime() > date.getTime()) {
							next = newDate.getTime();
						} else if (prev < newDate.getTime()) {
							prev = newDate.getTime();
						}
					}
				}

				if (next !== -1 && prev !== -1) {
					var diffPrev = Math.abs(date.getTime() - prev);
					var diffNext = Math.abs(date.getTime() - next);

					if (diffNext <= diffPrev) {
						return new Date(next);
					} else {
						return new Date(prev);
					}

				} else if (next !== -1) {
					return new Date(next);
				} else if (prev !== -1) {
					return new Date(prev);
				}
			}

			return date;
		}


		function filterRemark(invoiceremark) {
			var remarkType = InvoiceRemarkService.remarkType;
			for (var rt = 0; rt < remarkType.length; rt++) {
				if (invoiceremark.type === remarkType[rt].id ) {
					return remarkType[rt].type.toUpperCase();
				}
			}
		}

		function groupByDate() {
			var promises = [];
			for (var i = 0; i < _invoices.length; i++) {
				var invoice = _invoices[i];

				if (typeof _groupedInvoices[invoice.slotDateFormatted] === 'undefined') {
					_groupedInvoices[invoice.slotDateFormatted] = [];
				}

				promises.push(_groupedInvoices[invoice.slotDateFormatted].push(invoice));
			}
			return $q.all(promises);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.controller('InvoicesController', InvoicesController);

	/** @ngInject */
	function InvoicesController(
		$state,
		$timeout,
		$translate,
		$scope,
		$filter,
		$q,
		$interval,
		$mdDialog,
		OrderService,
		nuitConfig,
		nuitUtils,
		nuitAuth,
		ListSelectionService,
		FormatterService,
		OrderViewService,
		FilterCountService,
		nuitDataService,
		InvoiceService,
		DotNotationService,
		nuitApi
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.currentPage = [];
		vm.currentPageEntities = [];
		vm.loading = false;
		vm.config = nuitConfig.getCurrent();
		vm.orders = OrderService.orders;
		vm.searchText = $state.params.term || '';
		vm.selection = ListSelectionService.get('order.invoices', true);
		vm.filterCount = FilterCountService.get('order.invoices', true);
		vm.invoicesToProcess = 0;
		vm.invoiceStatis = [];
		vm.invoices = InvoiceService.invoices;
		vm.years = [];
		vm.selectedYear = null;
		vm.months = [];
		vm.statis = InvoiceService.statusFields;
		vm.selectedStatus = vm.statis.id;
		vm.selectedOrderBy = 'id';
		vm.reverse = true;
		vm.orderDetail = vm.config.ims.accounting.orderNameFormat;
		vm.collapse = false;
		vm.disable = [];
		vm.downloadOptions = vm.config.ims.accounting.list.exportOptions;

		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openDetails = openDetails;
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.search = search;
		vm.getStatusById = OrderService.getStatusById;
		vm.toggleSelectInvoice = toggleSelectedInvoice;
		vm.toggleSelectedInvoices = toggleSelectedInvoices;
		vm.isIndeterminate = vm.selection.isIndeterminate;
		vm.moveToNextState = OrderViewService.moveToNextState;
		vm.getOrderPositions = OrderService.getOrderPositions;
		vm.showStatusChangeButton = showStatusChangeButton;
		vm.filterAll = filterAll;
		vm.getFilterCount = vm.filterCount.get;
		vm.changeStatus = changeStatus;
		vm.canChangeStatus = canChangeStatus;
		vm.reloadInvoices = reloadInvoices;
		vm.sumOf = sumOf;
		vm.orderBy = orderBy;
		vm.downloadInvoices = downloadInvoices;
		vm.getName = function(invoice) {
			return invoice.number;
		};
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {
			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}

			if ($state.params.page && $state.params.page !== vm.currentPage) {
				vm.currentPage = $state.params.page;
			}

			filterAll();
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			InvoiceService.reloadStatus();
			generateFilterContent();
			reloadInvoices();
			vm.orderDetail = vm.orderDetail.replace('details.', '');

		}

		function generateFilterContent() {
			var currentYear = (new Date()).getFullYear();

			var lastYear = currentYear + vm.config.ims.accounting.filters.year.endOffset;
			var firstYear = currentYear + vm.config.ims.accounting.filters.year.startOffset;

			for (var i = firstYear; i <= lastYear; i++) {
				vm.years.push(i);
			}

			if ($state.params.start) {
				vm.selectedMonth = new Date($state.params.start * 1000).getMonth();
				vm.selectedYear = new Date($state.params.start * 1000).getFullYear();
			} else {
				vm.selectedYear = vm.years.indexOf(currentYear) !== -1 ? currentYear : vm.years[vm.years.length - 1];
				vm.selectedMonth = (new Date()).getMonth();
			}

			for (var i = 0; i < months.length; i++) {
				vm.months.push(
					{
						value: i,
						translation: 'APP.' + months[i].toUpperCase()
					}
				);
			}
		}

		function reloadInvoices() {
			if (!vm.loading) {
				$state.go('app.invoices', {year: vm.selectedYear, month: vm.selectedMonth});

				var firstDay = new Date(vm.selectedYear, vm.selectedMonth, 1,0,0,0).getTime() / 1000;
				var lastDay = new Date(vm.selectedYear, vm.selectedMonth + 1, 1, 0,0,0).getTime() / 1000;

				vm.loading = true;

				InvoiceService.reload(firstDay, lastDay, vm.selectedStatus)
					.then(function () {
						vm.loading = false;
						vm.orderBy('id', true);
					});
			}
		}

		/**
		 * Toggles the selected orders.
		 */
		function toggleSelectedInvoices() {
			//if (vm.selection.getSelected().length > 0) {
				vm.selection.toggleSelectedEntities(vm.currentPageEntities);
				nuitDataService.replaceAll(vm.disable, []);
			//}
		}

		function toggleSelectedInvoice(invoice, $event) {
			vm.selection.toggleSelectedEntity(invoice, $event);

			if (vm.selection.getSelected().length === 1 && vm.disable.length === 0) {
				vm.statis.forEach(function (status) {
					vm.disable.push(status.id);
				});

				var start = (vm.selection.getSelected()[0].status);
				var index = vm.disable.indexOf(start).toString();
				DotNotationService.remove(vm.disable, index);
			} else if (vm.selection.getSelected().length === 0) {
				nuitDataService.replaceAll(vm.disable, []);
			}
		}

		function filterAll() {
			vm.filterCount.resetAll();
			vm.filteredEntities = [];

			for (var i = 0; i < vm.invoices.length; i++) {
				var order = vm.invoices[i];
				if (matchesSearchTerm(order)) {
					vm.filteredEntities.push(order);
				}
				vm.filterCount.increment(vm.invoices[i].status);
			}
		}

		function matchesSearchTerm(invoice) {
			if (vm.searchText === '') {
				return true;
			} else {
				var company = invoice.company.name.toLowerCase();
				vm.searchText = vm.searchText.toLowerCase();
				if (invoice.number.includes(vm.searchText) || invoice.number === vm.searchText || company.includes(vm.searchText)) {
					return true;
				} else {
					for (var i in vm.statis) {
						if (invoice.status === vm.statis[i].id) {
							var status = 'INVOICE.STATUS_' + vm.statis[i].type.toUpperCase();
							status = $translate.instant(status);
							status = status.toLowerCase();
							if (status.includes(vm.searchText)) {
								return true;
							}
						}
					}
					var createdAt = $filter('nuitDatetime')(invoice.createdAt, 'date');
					var dueDate = $filter('nuitDatetime')(invoice.dueDate, 'date');
					if(createdAt.includes(vm.searchText) || dueDate.includes(vm.searchText)){
						return true;
					}
				}
			}
		}

		function openDetails(id) {
			var start = new Date(vm.selectedYear, vm.selectedMonth, 1, 0,0,0).getTime() / 1000;

			$state.go('app.invoices.details', {
				invoiceId: id,
				invoiceOrigin: 'app.invoices',
				start: start
			}, {inherit: false});
		}

		function search() {
			$state.go('app.invoices', {term: vm.searchText, page: vm.currentPage});
		}

		function showStatusChangeButton() {
			return vm.invoicesToProcess === 0;
		}

		function createChangeStatusDialog(invoice) {
			console.log(invoice);
			return {
				controller: 'ChangeStatusDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/orders.accounting/views/dialogs/change-status/change-status.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Status: angular.copy(invoice)
				}
			};
		}

		function canChangeStatus() {
			if(vm.selection.getSelected().length>1) {
				var firstStatus = vm.selection.getSelected()[0].status;

				for (var i = 0; i < vm.selection.getSelected().length; i++) {
					if(vm.selection.getSelected()[i].status !== firstStatus){
						return false;
					}
				}

				return true;
			}
			else{
				return true;
			}
		}

		function changeStatus(invoice) {
			console.log(invoice);
			var startStatus = invoice[0].status;
			var statis = [];
			for (var i = 0; i < invoice.length; i++) {
				console.log(invoice[i].status);
				if (invoice[i].status === startStatus) {
					statis.push(invoice[i].status);
				}
			}
			if (statis.length === invoice.length) {
				$mdDialog
					.show(createChangeStatusDialog(startStatus))
					.then(function (result) {
						var status = result[0];
						var paidAt = result[1];
						var selected = vm.selection.getSelected();
						var promises = [];

						for (var i = 0; i < selected.length; i++) {
							var invoice = selected[i];
							if (status === 3) {
								promises.push(InvoiceService.partialInvoiceUpdate(invoice, {paidAt: paidAt, status: status})
									.catch(nuitUtils.showErrorToast));

							} else {
								promises.push(InvoiceService.partialInvoiceUpdate(invoice, {status: status})
									.then(function () {
										if (status === 1 || status === 2) {
											InvoiceService.partialInvoiceUpdate(invoice, {paidAt: 0});
										}
									})
									.catch(nuitUtils.showErrorToast));
							}
						}
						$q
							.all(promises)
							.then(function (){
								vm.selection.deselectAll();
								nuitDataService.replaceAll(vm.disable, []);
								filterAll();
								reloadInvoices();
							})
							.catch(nuitUtils.showErrorToast);
						nuitUtils.showSuccessToast();
					}).catch(angular.noop);
			} else {
				nuitUtils.showErrorToast('ACCOUNTING.DIFFERENT_STATIS');
			}

		}

		function sumOf(key) {
			var sum = 0;

			for (var i = 0; i < vm.filteredEntities.length; i++) {
				if (vm.filteredEntities[i].hasOwnProperty(key) && vm.filteredEntities[i].status !== 4) {
					sum += vm.filteredEntities[i][key];
				}
			}
			return sum;
		}

		function orderBy(key, initial) {
			vm.selectedOrderBy = key;
			if (!initial){
				vm.reverse = !vm.reverse;
			}else{
				vm.reverse = initial;
			}
			filterAll();
			vm.filteredEntities = $filter('orderBy')(angular.copy(vm.filteredEntities), key, vm.reverse);
		}

		function downloadInvoices(format) {
			var firstDay = new Date(vm.selectedYear, vm.selectedMonth, 1, 0,0,0).getTime() / 1000;
			var lastDay = new Date(vm.selectedYear, vm.selectedMonth + 1, 1, 0,0,0).getTime() / 1000;
			var status = vm.selectedStatus;
			if(!status){
				status = null;
			}
			var url = nuitApi.getBaseUrl() + 'exchange/export/' +format + '?start=' + firstDay + '&end=' + lastDay + '&status=' + status + '&access-token=' + nuitAuth.getToken();
			return url;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.controller('InvoiceBoardController', InvoiceBoardController);

	/** @ngInject */
	function InvoiceBoardController(
		$rootScope,
		$scope,
		$state,
		$translate,
		$q,
		$mdDialog,
		$filter,
		nuitConfig,
		nuitDataService,
		nuitUtils,
		InvoiceBoardService,
		InvoiceService,
		DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.invoices = InvoiceBoardService.groupedInvoices;
		vm.currentWeek = [];
		vm.selectedItems = [];
		vm.config = nuitConfig.current;
		vm.unregisterConfigListener = null;
		vm.statis = InvoiceService.statusFields;
		vm.disable = [];
		vm.currentDay = parseInt(moment().valueOf() / 1000);
		vm.calendarWeek = 0;
		vm.weekSumPaid = 0;
		vm.weekSumUnpaid = 0;
		vm.currentCalendarWeek = 0;
		vm.loading = true;
		vm.today = new Date();
		vm.today.setHours(0,0,0,0);
		vm.loadToday = false;

		//*******************************************

		//*******************************************

		//*******************************************
		// METHOD EXPOSURE
		//*******************************************
		vm.previousWeek = previousWeek;
		vm.nextWeek = nextWeek;
		vm.showCurrentWeek = showCurrentWeek;
		vm.isSelected = isSelected;
		vm.toggleEvent = toggleEvent;
		vm.openEventDetail = openEventDetail;
		vm.flipWidget = flipWidget;
		vm.changeStatus = changeStatus;
		vm.openDetails = openDetails;

		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {

			if (nuitConfig.isReady()) {
				initializePlanningWeek();
			} else {
				vm.unregisterConfigListener = $rootScope.$on('config::config.loaded', initializePlanningWeek);
			}
			InvoiceService.reloadStatus();
			var today = new Date();
			today.setHours(0,0,0,0);
			vm.currentDay = parseInt(today.valueOf() / 1000);
		}

		function openEventDetail($event, planningBoardEvent) {
			var origin = $state.current.name + '({ index: \'' + $state.params.index + '\'})';
			$state.go('app.invoices.details', {orderId: planningBoardEvent.id, origin: origin});
		}

		function flipWidget(event) {
		}

		function isSelected(planningBoardEvent) {
			return vm.selectedItems.indexOf(planningBoardEvent) >= 0;
		}

		function toggleEvent(planningBoardEvent) {
			var index = vm.selectedItems.indexOf(planningBoardEvent);

			if (index >= 0) {
				vm.selectedItems.splice(index, 1);
			} else {
				vm.selectedItems.push(planningBoardEvent);
			}

			if (vm.selectedItems.length === 1) {
				if (vm.disable.length === 0) {
					vm.statis.forEach(function (status) {
						vm.disable.push(status.id);
					});
				}
				var start = (vm.selectedItems[0].status);
				var ind = vm.disable.indexOf(start).toString();
				DotNotationService.remove(vm.disable, ind);
			} else if (vm.selectedItems.length === 0) {
				vm.disable = [];
			}
		}

		function nextWeek() {
			setupWeek(7, 'd');
		}

		function previousWeek() {
			setupWeek(-7, 'd');
		}

		function showCurrentWeek() {
			vm.loadToday = true;
			var now = moment(vm.today);
			var currentDayOfWeek = now.day();
			var startDayOfWeek = vm.config.ims.accounting.calendar.startDayOfWeek;
			var startDate = startDayOfWeek > currentDayOfWeek ?
				now.subtract(7 - (startDayOfWeek - currentDayOfWeek), 'd') :
				now.subtract(currentDayOfWeek - startDayOfWeek, 'd');
			var currentDate = moment(vm.currentWeek[0].timestampMin* 1000);
			var offset = (currentDate.diff(startDate, 'days'))*-1;
			setupWeek(offset, 'd');
		}

		function setupWeek(offset, timeFrame) {

			var startDate = moment(vm.currentWeek[0].timestamp).add(offset, timeFrame);

			InvoiceBoardService.reload(parseInt(startDate.valueOf() / 1000), parseInt(startDate.add(6, 'd').valueOf() / 1000))
				.then(function () {
					for (var i = 0; i < vm.currentWeek.length; i++) {
						nuitDataService.replaceAll(vm.currentWeek[i].invoices, []);
						var date = moment(vm.currentWeek[i].timestamp).add(offset, timeFrame);
						var today = new Date(date);
						today.setHours(0,0,0,0);
						var dateFormatted = $filter('nuitDatetime')(date.valueOf() / 1000, 'date');

						var invoices = getPlanningBoardEvents(dateFormatted);
						var daySum = 0;
						var daySumUnpaid = 0;
						for (var x = invoices.length - 1; x >= 0; x--) {
							if (invoices[x].status === 3) {
								daySum = daySum + invoices[x].sumNetPrice;
							}
							if (invoices[x].status === 2) {
								daySumUnpaid = daySumUnpaid + invoices[x].sumNetPrice;
							}
							if (invoices[x].status === 1 || invoices[x].status === 4 || invoices[x].status === 5) {
								invoices.splice(x, 1);
							}
						}

						vm.currentWeek[i].timestamp = date.valueOf();
						vm.currentWeek[i].timestampMin = parseInt(today.valueOf() / 1000);
						vm.currentWeek[i].dateFormatted = dateFormatted;
						vm.currentWeek[i].invoices = invoices;
						vm.currentWeek[i].estimatedTime = 0;
						vm.currentWeek[i].daySum = daySum;
						vm.currentWeek[i].daySumUnpaid = daySumUnpaid;
					}

					setPlanningTimeframe();
					setWeekSums();
					vm.loadToday = false;
				});
		}

		function initializePlanningWeek() {
			if (vm.unregisterConfigListener !== null) {
				vm.unregisterConfigListener();
			}
			vm.currentCalendarWeek = $filter('date')(new Date(), 'w');

			var now = moment();
			var currentDayOfWeek = now.day();
			var startDayOfWeek = vm.config.ims.accounting.calendar.startDayOfWeek;
			var workDays = vm.config.ims.accounting.calendar.workDays;
			var startDate = null;
			if ($state.params.start) {
				startDate = moment(new Date($state.params.start * 1000));
			} else {
				startDate = startDayOfWeek > currentDayOfWeek ?
					now.subtract(7 - (startDayOfWeek - currentDayOfWeek), 'd') :
					now.subtract(currentDayOfWeek - startDayOfWeek, 'd');
			}

			InvoiceBoardService.reload(parseInt(startDate.valueOf() / 1000), parseInt(moment(startDate).add(6, 'd').valueOf() / 1000))
				.then(function () {
					for (var i = 0; i < 7; i++) {
						var date = moment(startDate).add(i, 'd');

						if (workDays.indexOf(date.day()) !== -1) {
							var dayTranslation = 'APP.' + date.format('dddd').toUpperCase();
							var dateFormatted = $filter('nuitDatetime')(date.valueOf() / 1000, 'date');
							var invoices = getPlanningBoardEvents(dateFormatted);
							var daySum = 0;
							var daySumUnpaid = 0;
							var today = new Date(date);
							today.setHours(0,0,0,0);

							for (var x = invoices.length - 1; x >= 0; x--) {
								if (invoices[x] !== undefined) {
									if (invoices[x].status === 3) {
										daySum = daySum + invoices[x].sumNetPrice;
									}
									if (invoices[x].status === 2) {
										daySumUnpaid = daySumUnpaid + invoices[x].sumNetPrice;
									}
									if (invoices[x].status === 1 || invoices[x].status === 4 || invoices[x].status === 5) {
										invoices.splice(x, 1);
									}
								}
							}


							vm.currentWeek.push({
								translationKey: dayTranslation,
								timestamp: date.valueOf(),
								timestampMin: parseInt(today.valueOf() / 1000),
								dateFormatted: dateFormatted,
								invoices: invoices,
								daySum: daySum,
								daySumUnpaid: daySumUnpaid
							});
						}
					}
					setPlanningTimeframe();
					setWeekSums();
					vm.loading = false;
				});
		}

		function getPlanningBoardEvents(date) {
			if (!vm.invoices[date]) {
				vm.invoices[date] = [];
			}

			return vm.invoices[date];
		}

		function setPlanningTimeframe() {
			vm.planningTimeframe = vm.currentWeek[0].dateFormatted + ' - ' + $filter('nuitDatetime')(vm.currentWeek[0].timestamp / 1000 + 86400 * 6, 'date');
			vm.calendarWeek = $filter('date')(vm.currentWeek[0].timestamp, 'w');
		}

		function setWeekSums() {
			vm.weekSumUnpaid = 0;
			vm.weekSumPaid = 0;
			for (var x = 0; x < vm.currentWeek.length; x++) {
				vm.weekSumPaid += vm.currentWeek[x].daySum;
				vm.weekSumUnpaid += vm.currentWeek[x].daySumUnpaid;
			}
		}


		function createChangeStatusDialog(invoice) {
			return {
				controller: 'ChangeStatusDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/orders.accounting/views/dialogs/change-status/change-status.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Status: angular.copy(invoice)
				}
			};
		}

		function changeStatus(invoice) {
			var startStatus = invoice[0].status;
			var statis = [];
			for (var i = 0; i < invoice.length; i++) {
				if (invoice[i].status === startStatus) {
					statis.push(invoice[i].status);
				}
			}
			if (statis.length === invoice.length) {
				$mdDialog
					.show(createChangeStatusDialog(startStatus))
					.then(function (result) {
						var status = result[0];
						var paidAt = result[1];
						var selected = vm.selectedItems;
						var promises = [];

						for (var i = 0; i < selected.length; i++) {
							var invoice = selected[i];
							if (status === 3) {
								promises.push(InvoiceService.partialInvoiceUpdate(invoice, {paidAt: paidAt, status: status})
									.catch(nuitUtils.showErrorToast));
							} else {
								promises.push(InvoiceService.partialInvoiceUpdate(invoice, {status: status})
									.then(function () {
										if (status === 1 || status === 2) {
											InvoiceService.partialInvoiceUpdate(invoice, {paidAt: 0})
												.catch(nuitUtils.showErrorToast);
										}
									})
									.catch(nuitUtils.showErrorToast));
							}
						}
						$q
							.all(promises)
							.then(function (){
								vm.selectedItems = [];
								vm.disable = [];
								setupWeek(0, 'd');
								nuitUtils.showSuccessToast();
							})
							.catch(nuitUtils.showErrorToast);
					}).catch(angular.noop);
			} else {
				nuitUtils.showErrorToast('ACCOUNTING.DIFFERENT_STATIS');
			}

		}

		function openDetails(id) {

			var start = parseInt(vm.currentWeek[0].timestamp / 1000);

			var origin = $state.current.name;
			$state.go('app.invoice_board.details', {
				invoiceId: id,
				invoiceOrigin: origin,
				start: start
			});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.controller('InvoiceDetailsController', InvoiceDetailsController);

	/** @ngInject */
	function InvoiceDetailsController(
		$state,
		$timeout,
		$scope,
		$filter,
		$interval,
		$mdDialog,
		OrderService,
		nuitConfig,
		nuitUtils,
		ListSelectionService,
		FormatterService,
		OrderViewService,
		FilterCountService,
		nuitDataService,
		InvoiceService,
		$stateParams,
		InvoiceRemarkService,
		nuitAuth,
		SalesObject,
		imsUtils
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.companyConfig = vm.config.ims.accounting.details.company;
		vm.invoice = [];
		vm.origin = $state.params.invoiceOrigin;
		vm.invoiceId = parseInt($state.params.invoiceId);
		vm.orders = [];
		vm.credits = [];
		vm.statis =[];
		vm.allStatus = InvoiceService.statusFields;
		vm.selectedStatus = null;
		vm.remarks = InvoiceRemarkService.remarks;
		vm.remarkType = InvoiceRemarkService.remarkType;
		vm.showCompanyButton = true;
		vm.loading = true;
		vm.getSalesPosition = SalesObject.getPosition;
		vm.showSalesPosition = function(key, object){
			var overrideEntry = nuitDataService.getOne(vm.config.ims.orders.sales.showConditions, key);
			return SalesObject.showPosition(key, object, overrideEntry);
		};


		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************

		vm.reloadInvoices = reloadInvoices;
		vm.openOrder = openOrder;
		vm.openCredit = openCredit;
		vm.updateInvoice = updateInvoice;
		vm.statusUpdate = statusUpdate;
		vm.openCompany = openCompany;
		vm.addRemark = addRemark;
		vm.getStatusForRemark = getStatusForRemark;
		vm.getTypeForRemark = getTypeForRemark;
		vm.updateRemark = updateRemark;
		vm.selectableDays = selectableDays;
		vm.getDocumentURL = imsUtils.getDocumentURL;

		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************

		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			reloadInvoices();

			if (angular.isArray(vm.origin)) {
				vm.origin = vm.origin[0];
			}
			if (vm.origin === 'app.partners-companies.details') {
				vm.showCompanyButton = false;
			}

			reloadRemarks();

		}

		function reloadRemarks() {
			InvoiceRemarkService.reload(vm.invoiceId)
				.then(function () {
					InvoiceService.reloadStatus().then(function () {
						vm.statis = angular.copy(vm.allStatus);
						for(var x = vm.statis.length-1; x >= 0; x--) {
							if(vm.statis[x].id < vm.invoice.status){
								vm.statis.splice(x, 1);
							}
						}
					});
				});
			InvoiceRemarkService.reloadType();
		}


		function reloadInvoices() {
			InvoiceService.getInvoiceById(vm.invoiceId).then(function (invoice) {
				vm.invoice = invoice;
				vm.invoice.dueDate = new Date(vm.invoice.dueDate * 1000);
				vm.invoice.discountDate = new Date((vm.invoice.discountDate * 1000));
				if (vm.invoice.paidAt !== 0) {
					vm.invoice.paidAt = new Date((vm.invoice.paidAt * 1000));
				}
				if (vm.invoice.paidAt === 0) {
					vm.invoice.paidAt = null;
				}
				vm.invoice.orders.forEach(function (order) {
					vm.orders.push(order);

				});
				if(vm.config.ims.credit.enabled){
					InvoiceService.getCreditsByInvoiceId(vm.invoiceId)
						.then(function (credits) {
							vm.credits = credits;
						});
				}
			}).finally(function () {
				vm.loading = false;
			});
		}

		function openOrder(id) {
			var parentState = $stateParams.invoiceOrigin;
			if (angular.isArray(parentState)) {
				parentState = parentState[0];
			}
			if (parentState === 'app.partners-companies.details') {
				$state.go('app.partners-companies.details.invoice_details.order', {
					orderId: id,
					origin: '^',
				});
			} else if (parentState === 'app.invoices') {
				$state.go('app.invoices.details.detail', {
					orderId: id,
					origin: 'app.invoices.details',
				});
			} else if (parentState === 'app.invoice_board') {
				$state.go('app.invoice_board.details.detail', {
					orderId: id,
					origin: 'app.invoice_board.details',
				});
			} else if(parentState === 'app.orders.detail'){
				$state.go('app.orders.detail',{
					orderId: id
				});
			}
		}

		function openCredit(id) {
			var parentState = $stateParams.invoiceOrigin;
			if (angular.isArray(parentState)) {
				parentState = parentState[0];
			}
			if (parentState === 'app.partners-companies.details') {
				$state.go('app.partners-companies.details.credit_details', {
					creditId: id,
					invoiceId: vm.invoiceId,
					companyId: vm.invoice.company.id,
					origin: '^',
				});
			} else if (parentState === 'app.invoices') {
				$state.go('app.invoices.details.credit', {
					creditId: id,
					invoiceId: vm.invoiceId,
					companyId: vm.invoice.company.id,
					origin: '^',
				});
			} else if (parentState === 'app.invoice_board') {
				$state.go('app.invoice_board.details.credit', {
					creditId: id,
					invoiceId: vm.invoiceId,
					companyId: vm.invoice.company.id,
					origin: '^',
				});
			} else if(parentState === 'app.orders.detail'){
				$state.go('app.orders.detail.invoice.credit',{
					creditId: id,
					origin: '^',
					companyId: vm.invoice.company.id,
					invoiceId: vm.invoiceId,
					invoiceOrigin: parentState
				});
			}
		}



		function updateInvoice() {

			vm.invoice.dueDate = Date.parse(vm.invoice.dueDate) / 1000;
			vm.invoice.discountDate = Date.parse(vm.invoice.discountDate) / 1000;
			if (vm.invoice.paidAt != null) {
				vm.invoice.paidAt = Date.parse(vm.invoice.paidAt) / 1000;
			} else if (vm.invoice.paidAt === null) {
				vm.invoice.paidAt = 0;
			}
			if (vm.invoice.vatPercents === null) {
				vm.invoice.vatPercents = [];
			}

			InvoiceService
				.updateOneInvoice(vm.invoice)
				.then(function (response) {
					nuitDataService.replaceOneEntity(vm.invoice, response);
					vm.invoice.dueDate = new Date(vm.invoice.dueDate * 1000);
					vm.invoice.discountDate = new Date((vm.invoice.discountDate * 1000));
					if (vm.invoice.paidAt !== 0) {
						vm.invoice.paidAt = new Date((vm.invoice.paidAt * 1000));
					}
					if (vm.invoice.paidAt === 0) {
						vm.invoice.paidAt = null;
					}
					reloadRemarks();
					vm.invoiceDetailForm.$setPristine();
					nuitUtils.showSuccessToast();
				})
				.catch(nuitUtils.showErrorToast);
		}

		function statusUpdate(statusPlace, status) {
			if (statusPlace === 'date') {
				if (vm.invoice.status !== 3) {
					vm.invoice.status = 3;
				}
			}
			if (statusPlace === 'status') {
				if (status === 1 || status === 2) {
					vm.invoice.paidAt = null;
				}
			}
		}

		function openCompany(id) {
			$state.go('app.partners-companies.details', {
				companyId: id,
				invoiceId: vm.invoiceId,
				invoiceOrigin: vm.origin,
				start: $state.params.start
			});
		}

		function getStatusForRemark(id) {
			var statusText = '';

			vm.allStatus.forEach(function (status) {
				if (status.id === id) {
					statusText = status.type;
				}
			});
			return 'INVOICE.STATUS_' + statusText.toUpperCase();
		}

		function getTypeForRemark(id) {
			var typeText = '';
			vm.remarkType.forEach(function (type) {
				if (type.id === id) {
					typeText = type.type;
				}
			});
			return 'INVOICE.REMARK_' + typeText.toUpperCase();
		}

		function addRemark() {
			$mdDialog
				.show(createAddRemarkDialog())
				.then(function (remark) {
					InvoiceRemarkService.createRemark(remark, vm.invoiceId)
						.catch(function () {
							nuitUtils.showErrorToast();
						});
				}).catch(angular.noop);
		}

		function updateRemark(remark) {
			$mdDialog
				.show(createAddRemarkDialog(remark))
				.then(function (remark) {
					InvoiceRemarkService.updateRemark(vm.invoiceId, remark)
						.then(function () {
							vm.getTypeForRemark(remark.type);
						})
						.catch(function () {
							nuitUtils.showErrorToast();
						});
				})
				.catch(angular.noop);
		}

		function createAddRemarkDialog(remark) {
			return {
				controller: 'AddRemarkDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/orders.accounting/views/dialogs/add-remark/add-remark.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Remark: angular.copy(remark),
					Invoice: angular.copy(vm.invoiceId)
				}
			};
		}

		function selectableDays(date) {
			if (vm.config.ims.accounting.details.datepickerFilter) {
				var day = date.getDay();
				return vm.config.ims.accounting.calendar.workDays.includes(day);
			}else{
				return true;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.controller('InvoiceCreationController', InvoiceCreationController);

	/** @ngInject */
	function InvoiceCreationController($q, $state, $timeout, DotNotationService, $scope, $filter, $interval, OrderService, nuitConfig, nuitUtils, ListSelectionService, FormatterService, OrderViewService, FilterCountService, nuitDataService, InvoiceService, CompanyService, OrderQueryService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.currentPage = [];
		vm.currentPageEntities = [];
		vm.loading = true;
		vm.config = nuitConfig.getCurrent();
		vm.orders = OrderService.orders;
		vm.orderDetails = {};
		vm.searchText = $state.params.term || '';
		vm.updateTimeout = null;
		vm.selection = ListSelectionService.get('order.invoices', true);
		vm.filterCount = FilterCountService.get('order.invoices', true);
		vm.ordersToProcess = 0;
		vm.invoiceStatis = [];
		vm.invoices = InvoiceService.invoices;
		vm.companyIds = [];
		vm.companies = [];
		vm.company = null;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openDetails = openDetails;
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.search = search;
		vm.getStatusById = OrderService.getStatusById;
		vm.toggleSelectOrder = vm.selection.toggleSelectedEntity;
		vm.toggleSelectedOrders = toggleSelectedOrders;
		vm.isIndeterminate = function(entities){
			return vm.selection.isIndeterminate(entities.map(function(entity){return entity.id;}));
		};
		vm.moveToNextState = OrderViewService.moveToNextState;
		vm.getOrderPositions = OrderService.getOrderPositions;
		vm.showStatusChangeButton = showStatusChangeButton;
		vm.filterAll = filterAll;
		vm.getFilterCount = vm.filterCount.get;
		vm.createInvoices = createInvoices;
		vm.checkCheckbox = checkCheckbox;
		vm.getTitle = OrderQueryService.getTitle;
		vm.getTitleById = OrderQueryService.getTitleById;
		vm.loadSalesDetails = loadSalesDetails;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		$scope.$on('$destroy', onDestroy);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {
			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}

			if ($state.params.page && $state.params.page !== vm.currentPage) {
				vm.currentPage = $state.params.page;
			}

			filterAll();
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			OrderService.clear();

			if (OrderService.statusLoading) {
				OrderService.statusLoading.then(reloadOrders);
			} else {
				reloadOrders();
			}

			if (angular.isNumber(vm.config.ims.orders.refreshInterval) && vm.config.ims.orders.refreshInterval > 0) {
				vm.updateTimeout = $interval(function () {
					reloadOrders();
				}, Math.max(2000, vm.config.ims.orders.refreshInterval));
			}
		}

		function reloadOrders() {
			if (!angular.isNumber(vm.config.ims.orders.refreshInterval) || vm.config.ims.orders.refreshInterval <= 0) {
				stopRefreshing();
				return;
			}

			var status = OrderService.getStatusById(vm.config.ims.accounting.minOrderStatus);
			var maxStatus = OrderService.getStatusById(vm.config.ims.accounting.maxOrderStatus);
			var invoiceStatis = [];
			invoiceStatis.push(status.id);
			while (status !== maxStatus ) {
				status = OrderService.getNextStatus(status.id);
				if(status){
					invoiceStatis.push(status.id);
				}
			}

			OrderService
				.reload({status: invoiceStatis.join(','),view:'essential'})
				.then(function () {
					vm.orders.forEach(function (order) {
						if (!order.hasOwnProperty('_partial')) {
							order._partial = true;
						}
					});
					var selected = vm.selection.getSelected();
					vm.selection.deselectAll();
					filterAll();
					$timeout(function () {
						for (var index in vm.filteredEntities) {
							if (selected.indexOf(vm.filteredEntities[index].id) >= 0) {
								vm.toggleSelectOrder(vm.filteredEntities[index].id);
							}
						}
					});
					vm.loading = false;
				});
		}

		function loadSalesDetails(order) {
			OrderService.loadOrder(order.id)
				.then(function (response) {
					vm.orderDetails[order.id] = response;
				});

			var deferred = $q.defer();
			deferred.resolve(order);
			return deferred.promise;
		}

		function stopRefreshing() {
			if (vm.updateTimeout !== null) {
				$interval.cancel(vm.updateTimeout);
			}
		}

		function onDestroy() {
			stopRefreshing();
		}

		/**
		 * Toggles the selected orders.
		 */
		function toggleSelectedOrders() {
			var orders = [];
			var wasEmpty = vm.selection.getSelected().length === 0;

			for (var i in vm.currentPageEntities) {
				var order = vm.currentPageEntities[i];
				if(orders.length===0){
					vm.toggleSelectOrder(order.id);
					orders.push(vm.currentPageEntities[i].id);
				}else if(!checkCheckbox(order.id)){
					orders.push(vm.currentPageEntities[i].id);
				}
			}

			if(wasEmpty){
				vm.selection.deselectAll();
			}

			vm.selection.toggleSelectedEntities(orders);
		}

		function checkCheckbox(orderId) {
			if(!vm.orderDetails[orderId]){
				return true;
			}

			var companyId = vm.orderDetails[orderId].companyId;
			var vatPercent = vm.orderDetails[orderId].sales?vm.orderDetails[orderId].sales.vatPercent:0;

			var compareCompanyId = null;
			var compareVatPercent = null;

			if (vm.selection.getSelected().length >= 1) {
				var order = vm.orderDetails[vm.selection.getSelected()[0]];
				if(order) {
					compareCompanyId = order.companyId;
					compareVatPercent = order.sales?order.sales.vatPercent:0;
				}
				return companyId !== compareCompanyId || vatPercent !== compareVatPercent;
			} else if (vm.selection.getSelected().length === 0) {
				return false;
			}
		}


		function filterAll() {
			vm.filterCount.resetAll();
			var preSelectedEntities = [];
			vm.filteredEntities = [];
			vm.companyIds = [];
			vm.companies = [];

			for (var i = 0; i < vm.orders.length; i++) {
				var order = vm.orders[i];
				if (matchesSearchTerm(order)) {
					preSelectedEntities.push(order);

					if(vm.companyIds.indexOf(order.companyId)===-1){
						vm.companyIds.push(order.companyId);
					}
				}

				vm.filterCount.increment(vm.orders[i].status);
			}

			if(vm.company!==null){
				for(var j=0;j<preSelectedEntities.length;j++){
					if(vm.company.id===preSelectedEntities[j].companyId)
					{
						vm.filteredEntities.push(preSelectedEntities[j]);
					}
				}
			}else{
				vm.filteredEntities = preSelectedEntities;
			}

			vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, 'createDate', true);

			for(var k=0;k<vm.companyIds.length;k++){
				var company = CompanyService.getByIdOffline(vm.companyIds[k]);

				if(company){
					vm.companies.push(company);
				}else {
					CompanyService.getById(vm.companyIds[k])
						.then(function (response) {
							vm.companies.push(response);
						});
				}
			}
		}

		function matchesSearchTerm(order) {
			return order.companyId && !order.invoiceId && (vm.searchText === '' || FormatterService.matches(vm.config.ims.orders.nameFormat, order, vm.searchText));
		}

		function openDetails(itemId) {
			$state.go('app.invoice_creation.detail', {
				orderId: itemId,
				page: vm.currentPage,
				term: vm.searchText,
				origin: 'app.invoice_creation'
			}, {inherit: false});
		}

		function search() {
			$state.go('app.invoice_creation', {term: vm.searchText, page: vm.currentPage});
		}

		function showStatusChangeButton() {
			return vm.ordersToProcess === 0;
		}

		function createInvoices() {
			var orders = [];

			for(var i = 0; i < vm.selection.getSelected().length; i++){
				var order = nuitDataService.getOne(vm.orders, vm.selection.getSelected()[i]);
				if(order) {
					orders.push(order);
				}
			}

			var companyId = orders[0].companyId;
			var companies = [];
			orders.forEach(function (order) {
				if (order.companyId === companyId) {
					companies.push(order.companyId);
				}
			});

			if (companies.length === orders.length) {
				vm.ordersToProcess = 1;
				InvoiceService.createInvoice(orders)
					.then(function (invoice) {
						for (var i = 0; i < orders.length; i++) {
							orders[i].invoiceId = invoice.id;
							nuitDataService.updateOne(OrderService.orders, orders[i]);
						}
						filterAll();
					})
					.catch(function (error) {
						if (error.data.error.includes('range')) {
							nuitUtils.showErrorToast('APP.INVOICE_NUMBER.ERROR_NO_TEMPLATE');
						} else {
							nuitUtils.showErrorToast();
						}
						filterAll();
					})
					.finally(function(){
						vm.ordersToProcess--;
						vm.selection.deselectAll();
					});
				//vm.selection.deselectAll();
			} else {
				nuitUtils.showErrorToast('APP.INVOICE_CREATION.MULTIPLE_COMPANIES');
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('nuit.solution', ['app.core'])
		.config(config);

	function config($stateProvider) {
	}
}());

(function () {
	'use strict';

	angular
		.module('nuit.solution')
		.service('ToggleService', ToggleService);

	/** @ngInject */
	function ToggleService(PixiUtils) {

		var _toggleInstances = {};

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			get: get
		};

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function get(id, deselectOthers, scope) {
			if (!_toggleInstances[id]) {
				_toggleInstances[id] = initInstance();
			} else {
				_toggleInstances[id].reset();
			}

			_toggleInstances[id].scope = scope;
			_toggleInstances[id].deselectOthers = deselectOthers;

			return _toggleInstances[id];
		}

		function initInstance() {
			var instance = init();

			instance.selectedId = -1;
			instance.selectedData = {};
			instance.toggles = [];

			return instance;

			function init() {
				return {
					clear: clear,
					clearElement: clearElement,
					reset: reset,
					add: add,
					update: update,
					toggleOnByFilter: toggleOnByFilter,
					matchesFilter: matchesFilter
				};
			}

			function clear() {
				instance.toggles.splice(0, instance.toggles.length);
			}

			function clearElement() {
				instance.selectedId = -1;
				instance.selectedData = {};
			}

			function reset() {
				instance.clear();
				instance.clearElement();
			}

			function add(toggle) {
				instance.toggles.push(toggle);
			}

			function update(event, matches, shift) {
				if (!shift || (shift && matches)) {
					if (shift === undefined) {
						shift = false;
					}

					var id = event ? event.currentTarget.customId : instance.selectedId;

					defaultSelect(event, id, shift);

					if (event) {
						instance.scope.$digest();
					}

					PixiUtils.render();
				}
			}

			function defaultSelect(event, id, shift) {
				var lastSelected = null;

				for (var i = 0; i < instance.toggles.length; i++) {
					var button = instance.toggles[i];
					if (button.customId.toString() === id.toString()) {
						button.customData.group = (button.customData.hasOwnProperty('group') && event) ? !button.customData.group : true;

						if (button.customData.group) {
							button.toggleOn();
							instance.selectedData = event ? event.currentTarget.customData : button.customData;
							instance.selectedId = id;
						} else {
							button.toggleOff();
							instance.selectedData = {};
							instance.selectedId = -1;
						}
					} else if (!shift) {
						button.customData.group = false;
						button.toggleOff();
					} else if (button.customData.group) {
						lastSelected = button;
						button.toggleOn(0xe6ffe6);
					}
				}

				if (instance.selectedId === -1) {
					instance.selectedId = lastSelected ? lastSelected.customId : -1;
					instance.selectedData = lastSelected ? lastSelected.customData : {};
					if (lastSelected) {
						lastSelected.toggleOn();
					}
				}
			}

			function toggleOnByFilter(filter, additive) {
				if (additive === undefined) {
					additive = false;
				}

				for (var i = 0; i < instance.toggles.length; i++) {
					var button = instance.toggles[i];

					if (matchesFilter(filter, button.customData) || (additive && button.customData.group)) {
						button.customData.group = true;
						button.toggleOn(button.customId === instance.selectedId ? undefined : 0xe6ffe6);
					} else {
						button.customData.group = false;
						button.toggleOff();
					}
				}
			}

			function matchesFilter(filter, object) {
				var matches = filter ? true : false;

				if (filter) {
					for (var i = 0; i < filter.length; i++) {
						var key = filter[i];
						matches = matches && instance.selectedData[key] === object[key];
					}
				}

				return matches;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('nuit.solution')
		.factory('PixiUtils', PixiUtils);

	/** @ngInject */
	function PixiUtils(nuitUnits) {
		//*******************************************
		// SERVICE
		//*******************************************

		var service = {
			createRenderer: createRenderer,
			createBgContainer: createBgContainer,
			createBasicContainer: createBasicContainer,
			createDraggable: createDraggable,
			createButton: createButton,
			addText: addText,
			render: render,
			screenshot: screenshot,
			destroy: destroy
		};

		service.renderer = null;
		service.pattern = {};
		service.pendingAnimation = null;

		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODES
		//*******************************************
		function createRenderer(minWidth, minHeight, bgColor, resolution, forceCanvas) {
			service.destroy();

			var conf = {
				backgroundColor: bgColor,
				antialias: true,
				resolution: resolution,
				autoResize: true,
				forceCanvas: forceCanvas
			};

			service.renderer = new PIXI.Application(minWidth, minHeight, conf);
			return service.renderer;
		}

		function createBgContainer(parentContainer, position, bg) {
			var data = {
				container: new PIXI.Container(),
				background: new PIXI.Graphics(),
				mask: new PIXI.Graphics(),
				content: new PIXI.Graphics(),
				overlay: new PIXI.Graphics(),
				setSize: function (width, height) {
					data.mask.clear();
					data.mask.drawRect(0, 0, width, height);
					data.background.clear();
					data.background.drawRect(0, 0, width, height);
					data.container.hitArea = new PIXI.Rectangle(0, 0, width, height);
				},
				clear: function () {
					var children = data.content.children;
					for(var i=0;i<children.length;i++){
						children[i].destroy({children:true});
					}
					data.content.clear();
					data.content.removeChildren(0, data.content.children.length);
				},
				addRect: function (rect, bg, line) {
					data.content.beginFill(bg.color, bg.alpha);
					data.content.lineStyle(line.thickness, line.color, line.alpha);
					return data.content.drawRect(rect.x, rect.y, rect.width, rect.height);
				},
				addContainer: function(x, y){
					var container = new PIXI.Container();
					container.position.x = x;
					container.position.y = y;
					data.content.addChild(container);
					return container;
				},
				addButton: function (rect, bg, selectedBg, line, id, customData, clickFn) {
					return createButton(data.content, rect, bg, selectedBg, line, id, customData, clickFn);
				},
				addText: function (text, size, position, angle) {
					return addText(data.content, text, size, position, angle);
				},
				addLine: function (line, start, end) {
					data.content.lineStyle(line.thickness, line.color, line.alpha);
					data.content.moveTo(start.x, start.y);
					data.content.lineTo(end.x, end.y);
				}
			};

			data.background.beginFill(bg.color, bg.alpha);
			setPosition(data.container, position);
			data.container.mask = data.mask;
			data.container.addChild(data.background);
			data.container.addChild(data.content);
			data.container.addChild(data.overlay);
			data.overlay.alpha = 0.4;

			data.mask.beginFill(0xFFFFFF, 0);
			data.mask.position = data.container.position;
			data.mask.endFill();

			parentContainer.addChild(data.container);

			return data;
		}

		function createBasicContainer(parentContainer, position, bg) {
			var data = {
				container: new PIXI.Container(),
				content: new PIXI.Graphics(),
				redraw: function (width, height) {
					var children = data.content.children;
					for(var i=0;i<children.length;i++){
						children[i].destroy({children:true});
					}
					data.content.clear();
					data.content.drawRect(0, 0, width, height);
					data.content.removeChildren(0, data.content.children.length);
				}
			}

			data.content.beginFill(bg.color, bg.alpha);
			setPosition(data.container, position);
			data.container.addChild(data.content);

			parentContainer.addChild(data.container);

			return data;
		}

		function createDraggable(parentContainer, rect, bg, downFn, dragFn, upFn) {
			var draggable = new PIXI.Graphics();
			parentContainer.addChild(draggable);
			draggable.beginFill(bg.color, bg.alpha);
			draggable.drawRect(rect.x, rect.y, rect.width, rect.height);
			draggable.buttonMode = true;
			draggable.interactive = true;

			observe(draggable, ['pointerdown'], downFn);
			observe(draggable, ['pointermove'], dragFn);
			observe(draggable, ['pointerup', 'pointerupoutside'], upFn);

			return draggable;
		}

		function createButton(parentContainer, rect, bg, selectedBg, line, id, customData, clickFn) {
			var button = new PIXI.Graphics();
			parentContainer.addChild(button);
			button.beginFill(0xFFFFFF, bg.alpha);
			if (line) {
				button.lineStyle(line.thickness, line.color, line.alpha);
			}
			button.drawRect(rect.x, rect.y, rect.width, rect.height);
			button.tint = bg.color;
			button.buttonMode = true;
			button.interactive = true;
			button.customId = id;
			button.customData = customData;
			button.endFill();
			addPattern(button, rect);

			button.toggleOn = function (customColor) {
				button.tint = customColor ? customColor : selectedBg.color;
			};
			button.toggleOff = function () {
				button.tint = bg.color;
			};

			observe(button, ['pointerup'], clickFn);

			return button;
		}

		function addPattern(button, rect) {
			if (rect.pattern) {
				var texture = getPattern(rect.pattern);

				if (texture !== null) {
					var pattern = new PIXI.extras.TilingSprite(texture);
					pattern.x = rect.x;
					pattern.y = rect.y;
					pattern.width = rect.width;
					pattern.height = rect.height;
					button.addChild(pattern);
				}
			}
		}

		function observe(observable, events, fn) {
			for (var i = 0; i < events.length; i++) {
				observable.on(events[i], fn);
			}
		}

		function setPosition(container, position) {
			container.position.x = position.x;
			container.position.y = position.y;
		}

		function addText(parent, text, size, position, angle) {
			var style = {fontSize: size};
			var textLabel = new PIXI.Text(angular.isNumber(text) ? (text / nuitUnits('length').factor).toFixed(nuitUnits('length').decimals) : text, style);
			textLabel.position.x = position.x;
			textLabel.position.y = position.y;
			textLabel.pivot.x = textLabel.width / 2;
			textLabel.pivot.y = textLabel.height / 2;

			if (angle) {
				textLabel.rotation = angle * Math.PI / 180;
			}

			parent.addChild(textLabel);

			return textLabel;
		}

		function render() {
			if (service.pendingAnimation) {
				cancelAnimationFrame(service.pendingAnimation);
			}

			service.pendingAnimation = requestAnimationFrame(function () {
				if (service.renderer != null) {
					service.renderer.render();
				}
				service.pendingAnimation = null;
			});
		}

		function screenshot(container) {
			return service.renderer.renderer.extract.base64(container);
		}

		function destroy() {
			if (service.renderer !== null) {
				service.renderer.destroy(true,{children:true});
				service.renderer = null;
			}
		}

		function getPattern(type) {
			if (!type || type === '') {
				return null;
			} else {
				if (!service.pattern.hasOwnProperty(type)) {
					service.pattern[type] = getTexture(type);
				}
				return service.pattern[type];
			}
		}

		function getTexture(type) {
			var split = type.split('-');
			var size = split.length > 1 ? parseInt(split[1], 10) : 10;

			var pattern = new PIXI.Graphics();
			pattern.beginFill(0x000000, 0.075);

			switch (split[0]) {
				case 'checker':
					for (var i = 0; i < 2; i++) {
						pattern.drawRect(size * i, size * i, size, size);
					}
					break;
				case 'triangle':
					pattern.drawPolygon([0, 0, 0, size, size, 0]);
					break;
				case 'slope':
					pattern.drawPolygon([size * 0.5, 0, size, 0, 0, size, 0, size * 0.5]);
					pattern.drawPolygon([size, size * 0.5, size, size, size * 0.5, size]);
					break;
				case 'slope_reverse':
					pattern.drawPolygon([0, 0, size * 0.5, 0, size, size * 0.5, size, size]);
					pattern.drawPolygon([0, size * 0.5, 0, size, size * 0.5, size]);
					break;
			}

			pattern.endFill();

			return pattern.generateCanvasTexture(1, 1);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('nuit.solution')
		.service('DragService', DragService);

	/** @ngInject */
	function DragService(PixiUtils) {
		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			update: update,
			onDown: onDown,
			onMove: onMove,
			onUp: onUp,
			onScroll: onScroll
		};

		service.content = null;
		service.knob = null;
		service.style = null;
		service.width = null;
		service.position = null;
		service.startPosition = null;
		service.isDragging = false;

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function update(knob,content, width, style){
			service.content = content;
			service.knob = knob;
			service.style = style;
			service.width = width;
		}

		function onDown(e) {
			service.position = e.data.global.x;
			service.startPosition = service.content.x
			service.knobStart = service.knob.x;
			service.isDragging = true;
		}

		function onMove(e) {
			if (service.isDragging) {
				var maxScrolling = service.width - service.style.rulerSizeY - service.content.width;
				var deltaX = service.position - e.data.global.x;

				var travelDistance = service.width - service.style.rulerSizeY - service.knob.width;

				var mapping = Math.abs(maxScrolling / travelDistance);

				service.content.x = Math.min(
					0,
					Math.max(maxScrolling, service.startPosition + deltaX * mapping)
				);

				service.knob.x = Math.min(
					Math.max(0, service.knobStart - service.position + e.data.global.x),
					travelDistance
				);
				PixiUtils.render();
			}
		}

		function onUp(e) {
			service.isDragging = false;
			service.positon = null;
			service.startPosition = null;
			service.knobStart = null;
		}

		function onScroll(e) {
			onDown({data: {global: {x: 0}}});
			onMove({data: {global: {x: e.originalEvent.deltaY}}});
			onUp();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('nuit.solution')
		.service('Base64DownloadService', Base64DownloadService);

	/** @ngInject */
	function Base64DownloadService($timeout) {
		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			download: download,
			downloadFile: downloadFile
		};

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function download(base64,filename){
			b64toBlob(base64,
				function (blob) {
					var url = window.URL.createObjectURL(blob);
					if (window.navigator.msSaveOrOpenBlob) {
						window.navigator.msSaveOrOpenBlob(blob, filename);
					} else {
						var a = document.createElement('a');
						document.body.appendChild(a);
						var url = window.URL.createObjectURL(blob);
						a.href = url;
						a.download = filename;
						a.click();
						$timeout(function () {
							window.URL.revokeObjectURL(url);
							document.body.removeChild(a);
						}, 0);
					}
				},
				function (error) {
					console.log(error);
				}
			);
		}

		function b64toBlob(b64, onsuccess, onerror) {
			var img = new Image();

			img.onerror = onerror;

			img.onload = function onload() {
				var canvas = document.createElement('canvas');
				canvas.width = img.width;
				canvas.height = img.height;

				var ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

				canvas.toBlob(onsuccess);
			};

			img.src = b64;
		}

		function downloadFile(data, contentType, fileName){
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveBlob(data, fileName);
			}
			else{
				var downloadLink = window.document.createElement('a');
				downloadLink.href = window.URL.createObjectURL(new Blob([data]));
				downloadLink.download = fileName;
				document.body.appendChild(downloadLink);
				downloadLink.click();
				document.body.removeChild(downloadLink);
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('nuit.solution')
		.controller('nuitSolutionController', nuitSolutionController);

	/** @ngInject */
	function nuitSolutionController(NUIT_SOLUTION_CONFIG, NUIT_SOLUTION_PRINT_CONFIG, nuitUnits, $rootScope, $scope, $window, $element, $timeout, PixiUtils, ToggleService, DragService, ListSelectionService, Base64DownloadService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// CONSTANTS
		//*******************************************
		var PIXEL_RATIO = window.devicePixelRatio;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.conf = angular.copy(NUIT_SOLUTION_CONFIG);
		vm.element = null;
		vm.root = null;
		vm.rendererHeight = 0;
		vm.rendererWidth = 0;
		vm.bgContainer = null;
		vm.rulerY = null;
		vm.scrollBar = null;
		vm.lengthScaleFactor = 1;
		vm.jobButtons = ToggleService.get('solution.jobs', true, $scope);
		vm.elementButtons = ToggleService.get('solution.elements', false, $scope);
		vm.touchedElements = ListSelectionService.get('solution.touchedElements', true);

		vm.minLengthScaleFactor = 0;
		vm.manualFreezeScaling = false;
		vm.isFirstChange = true;

		vm.matchingKeysBatch = ['originalLength', 'originalHeight', 'originalManualWork', 'isWaste'];

		//*******************************************
		// LIEFCYCLE HOOKS
		//*******************************************
		vm.$onInit = onInit;
		vm.$onChange = onChange;
		vm.$onChanges = onChanges;
		vm.$onDestroy = onDestroy;
		vm.redrawSolution = redrawSolution;
		vm.rescaleAndRedrawSolution = rescaleAndRedrawSolution;
		vm.next = next;
		vm.prev = prev;
		vm.focus = focus;
		vm.touchedElement = touchedElement;
		vm.resetElement = resetElement;
		vm.clearElement = clearElement;
		vm.hasChanged = hasChanged;
		vm.canMoveJobs = canMoveJobs;
		vm.screenshot = screenshot;
		vm.selectSimilar = selectSimilar;
		vm.loseContext = loseContext;
		vm.createContainer = createContainer;

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// LIFECYCLE METHODS
		//*******************************************
		function onInit() {
			// setup config
			//*******************************************
			setupConfig();

			// init pixi.js
			//*******************************************
			vm.element = angular.element($element[0]).find(vm.conf.canvasContainerSelector);

			vm.root = PixiUtils.createRenderer(
				vm.conf.renderer.minWidth,
				vm.conf.renderer.minHeight,
				vm.conf.renderer.backgroundColor,
				PIXEL_RATIO, vm.conf.forceCanvas);
			vm.root.ticker.stop();
			vm.stage = vm.root.stage;
			vm.view = vm.root.view;
			vm.renderer = vm.root.renderer;
			vm.element.append(vm.view);

			angular.element(vm.view).on("webglcontextlost", restoreContextListener);

			// bind events
			//*******************************************
			angular.element($window).on('resize', onWindowResize);
			angular.element(vm.view).on('mousewheel', DragService.onScroll);

			for (var i = 0; i < vm.solution.jobs.length; i++) {
				var job = vm.solution.jobs[i];

				if (!job.hasOwnProperty('id')) {
					vm.solution.jobs[i].id = i;
				}
			}

			if (vm.limitJobsConfig) {
				vm.limitJobs = true;
				vm.start = vm.limitJobsConfig.start;
				vm.count = vm.limitJobsConfig.count;
			}

			// init surface
			//*******************************************
			createContainer();

			// resize to real size
			//*******************************************
			resize(vm.conf.firstResizeTimeout);
		}

		function restoreContextListener(e){
			console.error('context lost :(');
			vm.jobButtons.reset();
			vm.elementButtons.reset();
			e.preventDefault();  // allows the context to be restored
			angular.element(vm.view).off('mousewheel', DragService.onScroll);
			angular.element(vm.element).empty();
			vm.root = PixiUtils.createRenderer(
				vm.conf.renderer.minWidth,
				vm.conf.renderer.minHeight,
				vm.conf.renderer.backgroundColor,
				PIXEL_RATIO, vm.conf.forceCanvas);
			vm.root.ticker.stop();
			vm.stage = vm.root.stage;
			vm.view = vm.root.view;
			angular.element(vm.view).on("webglcontextlost", restoreContextListener);
			vm.renderer = vm.root.renderer;
			vm.element.append(vm.view);
			angular.element(vm.view).on('mousewheel', DragService.onScroll);
			vm.createContainer();
			resize(vm.conf.firstResizeTimeout);
		}

		function onChange() {
			// update config
			//*******************************************
			setupConfig();
		}

		function onChanges(changes) {
			if (!vm.isFirstChange) {
				if (changes.limitJobsConfig && changes.limitJobsConfig.currentValue !== null) {
					vm.limitJobs = true;
					vm.start = vm.limitJobsConfig.start;
					vm.count = vm.limitJobsConfig.count;
				} else {
					vm.limitJobs = false;
				}
			}

			if (changes.solution || changes.limitJobsConfig) {
				if (!vm.isFirstChange) {
					vm.touchedElements.deselectAll();
					vm.jobButtons.clearElement();
					vm.elementButtons.clearElement();
					rescaleAndRedrawSolution();
					resize();
				}
				vm.solution.originalHeight = vm.solution.height;
			}

			vm.isFirstChange = false;
		}

		function redrawSolution() {
			var currentScrollX = vm.knob.x

			vm.freezeScaling = true;

			if (vm.bgContainer.content) {
				vm.bgContainer.content.x = 0;
				vm.knob.x = 0;
			}

			drawSolution(true);
			drawScrollbar(true);

			vm.freezeScaling = false;
			DragService.onScroll({originalEvent: {deltaY: currentScrollX}});

			PixiUtils.render();
		}

		function rescaleAndRedrawSolution() {
			if (!vm.manualFreezeScaling) {
				vm.lengthScaleFactor = 0;
			}
			redrawSolution();
		}

		function onDestroy() {
			// unsetEvents
			//*******************************************
			angular.element($window).off('resize', onWindowResize);
			PixiUtils.destroy();
		}

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		function onWindowResize() {
			resize();
		}

		//*******************************************
		// METHODS
		//*******************************************
		function setupConfig() {
			vm.solutionConfig = vm.printStyle ? angular.merge(NUIT_SOLUTION_CONFIG, NUIT_SOLUTION_PRINT_CONFIG) : NUIT_SOLUTION_CONFIG;
			vm.conf = angular.merge({}, vm.solutionConfig, vm.config);
		}

		function createContainer() {
			vm.bgContainer = PixiUtils.createBgContainer(
				vm.stage,
				{x: vm.conf.style.rulerSizeY, y: 0},
				{color: vm.conf.style.solutionBackgroundColor, alpha: 1}
			);

			vm.rulerY = PixiUtils.createBasicContainer(
				vm.stage,
				{x: 0, y: vm.conf.style.rulerSizeX},
				{color: vm.conf.style.rulerBackgroundColor, alpha: 1}
			);

			vm.scrollBar = PixiUtils.createBasicContainer(
				vm.stage,
				{x: vm.conf.style.rulerSizeY, y: 0},
				{color: vm.conf.style.scrollbarBackgroundColor, alpha: 1}
			);
		}

		function loseContext(){
			console.log(angular.element(vm.view)[0].getContext('webgl'));
			angular.element(vm.view)[0].getContext('webgl').getExtension('WEBGL_lose_context').loseContext();
		}

		function resize(customTimeout) {
			if (!vm.renderer) {
				return;
			}

			// clear previous timeouts
			$timeout.cancel(vm.resizeTimeout);
			vm.renderer.resize(vm.conf.renderer.minWidth, vm.conf.renderer.minHeight);

			// set new timeout
			vm.resizeTimeout = $timeout(function () {
				var width = Math.max(vm.element.width(), vm.conf.renderer.minWidth);
				var height = Math.max(vm.element.height(), vm.conf.renderer.minHeight);

				vm.renderer.resize(width, height);

				vm.rendererWidth = vm.renderer.width / PIXEL_RATIO;
				vm.rendererHeight = vm.renderer.height / PIXEL_RATIO;

				drawAll(true);
			}, customTimeout || vm.conf.resizeTimeout);


			vm.resizeTimeout.then(
				function () {
					PixiUtils.render();
					if (!vm.isFirstChange) {
						$rootScope.$broadcast('nuitSolution::rendered');
					}
				}).catch(angular.noop);
		}

		function drawAll(redrawBackground) {
			if (redrawBackground) {
				vm.rulerY.redraw(
					vm.conf.style.rulerSizeY,
					vm.rendererHeight - vm.conf.style.rulerSizeX - vm.conf.style.scrollbarHeight
				);
			}

			drawSolution(redrawBackground);
			drawScrollbar(redrawBackground);
		}

		function drawSolution() {
			var solutionContainerWidth, solutionContainerHeight,
				solutionLength, solutionHeight, scaledSolutionHeight,
				heightScaleFactor, jobSpacing, elementSpacing;

			var start = 1;
			var count = vm.solution.jobs.length;

			if (vm.limitJobs) {
				start = vm.start = Math.min(count, Math.max(1, vm.start));
				count = vm.count = Math.max(1, Math.min(vm.count, count));
			} else {
				vm.start = 1;
				vm.count = vm.solution.jobs.length;
			}

			jobSpacing = vm.conf.style.solutionJobSpacing;
			elementSpacing = vm.conf.style.solutionElementSpacing;


			// Recalculate solution container sizes
			//*******************************************
			solutionContainerWidth = vm.rendererWidth - vm.conf.style.rulerSizeY;
			solutionContainerHeight = vm.rendererHeight - vm.conf.style.scrollbarHeight - vm.conf.style.rulerSizeX;

			// Recalculate solution sizes and factors
			//*******************************************
			solutionHeight = vm.solution.originalHeight;

			if (vm.rulerY.container.children.length === 1) {
				PixiUtils.addText(vm.rulerY.container, vm.solution.originalHeight, vm.conf.style.fontSize + 1, {
					x: 0,
					y: 0
				}, 270);
			}

			var jobHeightText = vm.rulerY.container.getChildAt(1);
			jobHeightText.position.x = vm.rulerY.content.width / 2;
			jobHeightText.position.y = vm.rulerY.content.height / 2;

			if (vm.solution.originalHeight !== vm.solution.height) {
				jobHeightText.text = '\u270E' + (vm.solution.originalHeight / nuitUnits('length').factor).toFixed(nuitUnits('length').decimals);
			} else {
				jobHeightText.text = (vm.solution.originalHeight / nuitUnits('length').factor).toFixed(nuitUnits('length').decimals);
			}

			solutionLength = vm.solution.jobs.reduce(function (currentValue, job, index) {
				if (index >= start - 1 && index < start + count - 1) {
					return job.length + currentValue;
				} else {
					return currentValue;
				}
			}, 0);

			heightScaleFactor = solutionContainerHeight / solutionHeight;

			vm.minLengthScaleFactor = (solutionContainerWidth + 2 * jobSpacing - 4 * vm.conf.style.solutionElementBorderThickness) / solutionLength;

			if (!vm.manualFreezeScaling) {
				vm.lengthScaleFactor = Math.max(vm.minLengthScaleFactor, vm.lengthScaleFactor);
			}

			if (!vm.freezeScaling) {
				vm.lengthScaleFactor = vm.minLengthScaleFactor;
			}

			scaledSolutionHeight = solutionHeight * heightScaleFactor;

			// Redraw solution mask
			//*******************************************
			vm.bgContainer.setSize(solutionContainerWidth + vm.conf.style.rulerSizeY, solutionContainerHeight + vm.conf.style.rulerSizeX);

			// Redraw solution
			//*******************************************
			vm.bgContainer.clear();

			var currXJobOffset = -jobSpacing;

			vm.bgContainer.addRect(
				{x: 0, y: 0, width: vm.lengthScaleFactor * solutionLength, height: vm.conf.style.rulerSizeX},
				{color: vm.conf.style.rulerBackgroundColor, alpha: 1},
				{
					thickness: vm.conf.style.solutionSliceBorderThickness,
					color: vm.conf.style.solutionSliceBorderColor,
					alpha: 1
				});

			var lastSelectedJobId = vm.jobButtons.selectedId;
			vm.jobButtons.clear();

			var lastSelectedElementIds = vm.elementButtons.toggles.map(function(toggle){return toggle.customData.group?toggle.customData.id:null;});
			vm.elementButtons.clear();

			for (var i in vm.solution.jobs) {
				if (vm.limitJobs && (i < start - 1 || i >= start + count - 1)) {
					continue;
				}

				var job, jobLength, currYJobOffset;

				job = vm.solution.jobs[i];
				jobLength = job.length * vm.lengthScaleFactor;
				currYJobOffset = scaledSolutionHeight + vm.conf.style.rulerSizeX;

				vm.jobButtons.add(PixiUtils.createButton(
					vm.bgContainer.content,
					{x: currXJobOffset + 1, y: 4, width: jobLength - 2, height: vm.conf.style.rulerSizeX - 8},
					{color: vm.conf.style.rulerForegroundColor, alpha: 1},
					{color: vm.conf.style.rulerForegroundSelectedColor, alpha: 1},
					null,
					job.id,
					{group: lastSelectedJobId===job.id},
					function(event){
						vm.elementButtons.clearElement();
						vm.elementButtons.update(null, false);
						vm.jobButtons.update(event,false);
					}
				));

				var hasJobLabel = false;

				if (vm.conf.style.showJobId && job.name !== '') {
					var label = vm.bgContainer.addText(job.name + '\n' + (job.length / nuitUnits('length').factor).toFixed(nuitUnits('length').decimals), vm.conf.style.fontSize + 1, {
						x: currXJobOffset + jobLength / 2,
						y: vm.conf.style.rulerSizeX / 2
					});

					label.style.align = 'center';
					label.visible = label.width + 8 <= jobLength;
					hasJobLabel = label.visible;
				}

				if (!hasJobLabel) {
					var labelSmall = vm.bgContainer.addText((job.length / nuitUnits('length').factor).toFixed(nuitUnits('length').decimals), vm.conf.style.fontSize + 1, {
						x: currXJobOffset + jobLength / 2,
						y: vm.conf.style.rulerSizeX / 2
					});

					labelSmall.visible = labelSmall.width <= jobLength;
				}

				for (var j in job.slits) {
					var slit, slitLength, slitHeight, currXSlitOffset, currXElementOffset;

					slit = job.slits[j];
					slitLength = slit.length * vm.lengthScaleFactor - 2 * jobSpacing;
					slitHeight = slit.height * heightScaleFactor;
					currXSlitOffset = currXJobOffset + jobSpacing;

					currXElementOffset = currXSlitOffset;
					currYJobOffset -= slitHeight;

					/*vm.bgContainer.addRect(
						{x: currXSlitOffset, y: currYJobOffset, width: slitLength, height: slitHeight},
						{color: vm.conf.style.solutionSliceBackgroundColor, alpha: 1},
						{
							thickness: vm.conf.style.solutionSliceBorderThickness,
							color: vm.conf.style.solutionSliceBorderColor,
							alpha: 1
						}
					);*/

					for (var k in slit.elements) {
						var element, elementWidth, elementHeight;

						element = slit.elements[k];

						if (!element.group && !isWaste(element)) {
							element.group = lastSelectedElementIds.includes(element.id);
						}

						copyOriginalValues(element);
						elementWidth = (slitLength - elementSpacing) * element.originalLength / slit.length - elementSpacing;
						elementHeight = element.originalHeight * heightScaleFactor - elementSpacing * 2;

						currXElementOffset += elementSpacing;

						element.globalX = currXElementOffset;
						element.globalY = currYJobOffset + elementSpacing;

						var elementButton = vm.bgContainer.addButton(
							{
								x: currXElementOffset,
								y: (currYJobOffset + elementSpacing),
								width: elementWidth,
								height: elementHeight,
								pattern: selectElementColor(element, vm.conf.style.solutionElementPattern, vm.conf.style.solutionWastePattern, vm.conf.style.solutionManualWorkPattern)
							},
							{
								color: selectElementColor(element, vm.conf.style.solutionElementBackgroundColor, vm.conf.style.solutionWasteBackgroundColor, vm.conf.style.solutionManualWorkBackgroundColor),
								alpha: 1
							},
							{
								color: selectElementColor(element, vm.conf.style.solutionElementBackgroundSelectedColor, vm.conf.style.solutionWasteBackgroundSelectedColor, vm.conf.style.solutionManualWorkBackgroundSelectedColor),
								alpha: 1
							},
							{
								thickness: isWaste(element) ? vm.conf.style.solutionWasteBorderThickness : vm.conf.style.solutionElementBorderThickness,
								color: vm.conf.style.solutionSliceBorderColor,
								alpha: 1
							},
							element.id,
							element,
							function (event) {
								vm.jobButtons.clearElement();
								vm.jobButtons.update(null,false);

								if (event.data.originalEvent.shiftKey && isWaste(event.currentTarget.customData)) {
									return;
								}

								vm.elementButtons.update(
									event,
									vm.elementButtons.matchesFilter(event.data.originalEvent.shiftKey?vm.matchingKeysBatch:null, event.currentTarget.customData),
									event.data.originalEvent.shiftKey && vm.elementButtons.selectedId!==-1
								);
								touchedElement();
							}
						);

						vm.elementButtons.add(elementButton);

						if (!isWaste(element)) {
							var test = vm.bgContainer.addContainer(currXElementOffset + elementWidth - 10, currYJobOffset + elementHeight - 10 - (vm.conf.style.showElementId ? vm.conf.style.fontSize - 2 : 0));


							elementButton.pencilIcon = vm.bgContainer.addText('\u270E', 16, {
								x: 0,
								y: 0
							}, 0);
							elementButton.pencilIcon.visible = hasChanged(element);

							test.addChild(elementButton.pencilIcon);
						}

						if (!isWaste(element) || vm.conf.style.showWasteSize) {
							var lengthLabel = vm.bgContainer.addText(element.originalLength, vm.conf.style.fontSize, {
								x: currXElementOffset + elementWidth / 2,
								y: currYJobOffset + vm.conf.style.fontSize / 2
							});

							lengthLabel.visible = lengthLabel.width < elementWidth;

							var heightLabel = vm.bgContainer.addText(element.originalHeight, vm.conf.style.fontSize, {
								x: currXElementOffset + vm.conf.style.fontSize / 2,
								y: currYJobOffset + elementHeight / 2
							}, 270);

							heightLabel.visible = heightLabel.height <= elementWidth;

							if (vm.conf.style.showElementId) {
								var idLabel = vm.bgContainer.addText('#' + element[vm.conf.style.elementId] + '', vm.conf.style.fontSize, {
									x: currXElementOffset + elementWidth,
									y: currYJobOffset + elementHeight - vm.conf.style.fontSize / 2
								});

								idLabel.pivot.x = idLabel.width;
								idLabel.visible = idLabel.width <= elementWidth && idLabel.height <= elementHeight;
							}
						}

						currXElementOffset += elementWidth;
					}
				}

				currXJobOffset += jobLength;

				// Draw job cutting line
				if (i < vm.solution.jobs.length - 1) {
					vm.bgContainer.addLine(
						{
							thickness: vm.conf.style.solutionJobBorderThickness,
							color: vm.conf.style.solutionJobBorderColor,
							alpha: 1
						},
						{x: currXJobOffset, y: vm.conf.style.rulerSizeX}, {
							x: currXJobOffset,
							y: scaledSolutionHeight + vm.conf.style.rulerSizeX
						}
					);
				}


			}

			vm.bgContainer.overlay.clear();
			vm.bgContainer.overlay.beginFill(vm.conf.style.minDistanceColor);
			vm.bgContainer.overlay.drawRect(
				0,
				vm.conf.style.rulerSizeX + scaledSolutionHeight - heightScaleFactor * vm.solution.minDistance,
				vm.rendererWidth - vm.conf.style.rulerSizeY,
				heightScaleFactor * vm.solution.minDistance
			);

			if (vm.enableUi) {
				vm.jobButtons.update(null, false);

				if(vm.elementButtons.selectedId!==-1){
					vm.elementButtons.update(null, true, true);
				}else{
					vm.elementButtons.update(null, false);
				}
			}
		}

		function copyOriginalValues(element) {
			copyOriginalValue(element, 'length');
			copyOriginalValue(element, 'height');
			copyOriginalValue(element, 'manualWork');
		}

		function copyOriginalValue(element, key) {
			var camelCasedKey = 'original' + key.charAt(0).toUpperCase() + key.slice(1);

			if (!element.hasOwnProperty(camelCasedKey)) {
				element[camelCasedKey] = element[key];
			}
		}

		function resetValue(element, key) {
			var camelCasedKey = 'original' + key.charAt(0).toUpperCase() + key.slice(1);
			element[key] = element[camelCasedKey];
		}

		function hasChanged(element) {
			return element.length !== element.originalLength ||
				element.height !== element.originalHeight ||
				element.manualWork !== element.originalManualWork;
		}

		function selectElementColor(element, normal, waste, manual) {
			if (isWaste(element)) {
				return waste;
			} else if (element.originalManualWork) {
				return manual;
			} else {
				return normal;
			}
		}

		function isWaste(element) {
			if (element.hasOwnProperty('is_waste')) {
				return element.is_waste;
			} else if (element.hasOwnProperty('isWaste')) {
				return element.isWaste;
			}

			return false;
		}

		function next() {
			change(1);
		}

		function prev() {
			change(-1);
		}

		function focus() {
			vm.limitJobs = !vm.limitJobs;

			if (vm.limitJobs === true) {
				if (vm.jobButtons.selectedId !== -1) {
					for (var i = 0; i < vm.jobButtons.toggles.length; i++) {
						if (vm.jobButtons.toggles[i].customId === vm.jobButtons.selectedId) {
							vm.start = i + 1;
							vm.count = 1;
							break;
						}
					}
				} else if (vm.elementButtons.selectedId !== -1) {
					for (var i = 0; i < vm.solution.jobs.length; i++) {
						for (var j = 0; j < vm.solution.jobs[i].slits.length; j++) {
							var slit = vm.solution.jobs[i].slits[j];

							for (var k = 0; k < slit.elements.length; k++) {
								if (slit.elements[k].id === vm.elementButtons.selectedId) {
									vm.start = i + 1;
									vm.count = 1;
									break;
								}
							}
						}
					}
				}
			}

			vm.rescaleAndRedrawSolution();
		}

		function change(amount) {
			var oldIndex = 0;

			for (var i = 0; i < vm.jobButtons.toggles.length; i++) {
				if (vm.jobButtons.toggles[i].customId === vm.jobButtons.selectedId) {
					oldIndex = i;
					break;
				}
			}

			var newIndex = validateNewIndex(oldIndex + amount);

			move(vm.start - 1 + oldIndex, vm.start - 1 + newIndex);
			redrawSolution();
		}

		function validateNewIndex(newIndex) {
			if (newIndex > vm.jobButtons.toggles.length - 1) {
				return 0;
			} else if (newIndex < 0) {
				return vm.jobButtons.toggles.length - 1;
			}

			return newIndex;
		}

		function move(fromIndex, toIndex) {
			var element = vm.solution.jobs[fromIndex];
			vm.solution.jobs.splice(fromIndex, 1);
			vm.solution.jobs.splice(toIndex, 0, element);
		}

		function drawScrollbar(redrawBackground) {
			var scrollbarWidth, scrollbarHeight;

			scrollbarWidth = vm.rendererWidth - vm.conf.style.rulerSizeY;
			scrollbarHeight = vm.conf.style.scrollbarHeight;

			vm.scrollBar.container.position.y = vm.rendererHeight - vm.conf.style.scrollbarHeight;

			if (redrawBackground) {
				var width =
					scrollbarWidth < vm.bgContainer.content.width ?
						Math.max(vm.conf.style.scrollbarKnobWidth, scrollbarWidth - (vm.bgContainer.content.width - scrollbarWidth)) : 0;

				vm.scrollBar.redraw(scrollbarWidth, scrollbarHeight);

				var knob = PixiUtils.createDraggable(
					vm.scrollBar.content,
					{x: 0, y: 0, width: width, height: vm.conf.style.scrollbarHeight},
					{color: vm.conf.style.scrollbarForegroundColor, alpha: 1},
					DragService.onDown, DragService.onMove, DragService.onUp
				);

				vm.knob = knob;

				DragService.update(vm.knob, vm.bgContainer.content, vm.rendererWidth, vm.conf.style);
			}
		}

		function touchedElement() {
			for (var i = 0; i < vm.elementButtons.toggles.length; i++) {
				var button = vm.elementButtons.toggles[i];
				updateTouchedElement(button.customData);
				toggleEditIcon(button.customId, button.customData);
			}

			PixiUtils.render();
		}

		function updateTouchedElement(data) {
			if (!vm.touchedElements.isSelected(data)) {
				vm.touchedElements.toggleSelectedEntity(data);
			} else if (vm.touchedElements.isSelected(data) && !hasChanged(data)) {
				vm.touchedElements.toggleSelectedEntity(data);
			}

			if (data.group) {
				data.length = vm.elementButtons.selectedData.length;
				data.height = vm.elementButtons.selectedData.height;
				data.manualWork = vm.elementButtons.selectedData.manualWork;
			}
		}

		function toggleEditIcon(id, data) {
			var button = nuitDataService.getOneByKeys(vm.elementButtons.toggles, {customId: id});

			if (button && button.pencilIcon) {
				button.pencilIcon.visible = hasChanged(data);
			}
		}

		function resetElement() {
			for (var i = 0; i < vm.elementButtons.toggles.length; i++) {
				var button = vm.elementButtons.toggles[i];
				if (button.customData.group) {
					updateResetElement(button.customData);
					toggleEditIcon(button.customId, button.customData);
				}
			}

			PixiUtils.render();
		}

		function updateResetElement(data) {
			resetValue(data, 'length');
			resetValue(data, 'height');
			resetValue(data, 'manualWork');
			if (vm.touchedElements.isSelected(data)) {
				vm.touchedElements.toggleSelectedEntity(data);
			}
		}

		function clearElement() {
			vm.elementButtons.clearElement();
			redrawSolution();
		}

		function canMoveJobs() {
			var selected = vm.touchedElements.getSelected();
			var elementsChanged = false;

			for (var i = 0; i < selected.length; i++) {
				if (hasChanged(selected[i])) {
					elementsChanged = elementsChanged || true;
				}
			}

			return !elementsChanged && vm.jobButtons.selectedId >= 0 && vm.count > 1 && vm.solution.height === vm.solution.originalHeight;
		}

		function screenshot() {
			vm.manualFreezeScaling = false;
			rescaleAndRedrawSolution();
			var savedMask = vm.bgContainer.container.mask;
			vm.bgContainer.container.mask = null;
			PixiUtils.render();
			var base64 = PixiUtils.screenshot(vm.stage);
			vm.bgContainer.container.mask = savedMask;
			redrawSolution();
			Base64DownloadService.download(base64, vm.solution.id + '.png');
		}

		function selectSimilar(event, additionalKey){
			var keys = vm.matchingKeysBatch.concat([additionalKey]);
			vm.elementButtons.toggleOnByFilter(keys, event.originalEvent.shiftKey);
			PixiUtils.render();
		}
	}
}());


(function () {
	'use strict';

	angular
		.module('nuit.solution')
		.controller('nuitSolutionSvgController', nuitSolutionSvgController);

	/** @ngInject */
	function nuitSolutionSvgController(NUIT_SOLUTION_CONFIG, NUIT_SOLUTION_PRINT_CONFIG, nuitUnits, $filter, $rootScope, $scope, $window, $mdDialog, $element, $interval, $timeout, PixiUtils, ToggleService, DragService, ListSelectionService, Base64DownloadService, ProductionOrderViewService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// CONSTANTS
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.conf = angular.copy(NUIT_SOLUTION_CONFIG);
		vm.rendererHeight = 0;
		vm.rendererWidth = 0;
		vm.lengthScaleFactor = 1;
		vm.touchedElements = ListSelectionService.get('solution.touchedElements', true);
		vm.isFirstChange = true;

		vm.minLengthScaleFactor = 0;
		vm.manualFreezeScaling = false;
		vm.elementsById = [];
		vm.recalculating = true;
		vm.scrollPosition = 0;
		vm.dragPositionX = 0;
		vm.dragPositionY = 0;
		vm.newJob = null;
		vm.draggedElements = null;
		vm.draggingInitialized = null;

		vm.matchingKeysBatch = ['originalLength', 'originalHeight', 'originalManualWork', 'isWaste'];

		//*******************************************
		// LIEFCYCLE HOOKS
		//*******************************************
		vm.$onInit = onInit;
		vm.$onChange = onChange;
		vm.$onChanges = onChanges;
		vm.$onDestroy = onDestroy;
		vm.next = next;
		vm.prev = prev;
		vm.focus = focus;
		vm.touchedElement = touchedElement;
		vm.resetElement = resetElement;
		vm.hasChanged = hasChanged;
		vm.canMoveJobs = canMoveJobs;
		vm.screenshot = screenshot;
		vm.selectSimilar = selectSimilar;
		vm.createContainer = createContainer;
		vm.resize = resize;
		vm.showText = showText;
		vm.elementLabel = elementLabel;
		vm.getMinRounded = getMinRounded;
		vm.selectElementColor = selectElementColor;
		vm.hasAdjustment = hasAdjustment;
		vm.adjustmentLabel = adjustmentLabel;
		vm.adjustmentTitle = adjustmentTitle;
		vm.getConverted = getConverted;
		vm.dragStart = dragStart;
		vm.dragMove = dragMove;
		vm.dragEnd = dragEnd;
		vm.complain = complain;
		vm.canComplain = canComplain;
		vm.hide = $mdDialog.hide;
		vm.filter = $filter;

		vm.selectElement = function(id,event){
			vm.selectedJobIds.length = 0;

			if(vm.selectedElementIds.length>0 && event.originalEvent.shiftKey){
				var currentElement = vm.elementsById[id];
				for(var i in vm.matchingKeysBatch){
					var key = vm.matchingKeysBatch[i];
					if(currentElement[key]!==vm.firstSelectedElement[key]){
						return;
					}
				}
			}


			var index = vm.selectedElementIds.indexOf(id);

			if(!event.originalEvent.shiftKey && vm.selectedElementIds.length>=1){
				vm.selectedElementIds.length = 0;
			}

			if(index===-1){
				vm.selectedElementIds.unshift(id);
			}else{
				vm.selectedElementIds.splice(index,1);
			}
		};

		vm.selectJob = function(id,event){
			vm.selectedElementIds.length = 0;
			vm.selectedJobIds.length = 0;

			var index = vm.selectedJobIds.indexOf(id);

			if(!event.originalEvent.shiftKey && vm.selectedJobIds.length>=1){
				vm.selectedJobIds.length = 0;
			}

			if(index===-1){
				vm.selectedJobIds.push(id);
			}else{
				vm.selectedJobIds.splice(index,1);
			}
		};

		vm.sizeXPercent = 0.01;
		vm.sizeYPercent = 0.1;
		vm.selectedElementIds = [];
		vm.selectedJobIds = [];

		Object.defineProperty(vm,'limitedJobs',{get: function(){
				if(vm.limitJobs && vm.count && vm.start){
					return vm.solution.jobs.slice(vm.start-1,vm.start-1+vm.count);
				}else{
					return vm.solution.jobs;
				}
			}});

		Object.defineProperty(vm,'length',{get: function () {
				if(vm.limitedJobs.length===0){
					return 0;
				}

						return vm.limitedJobs.map(
				function(job) {return job.length;})
							.reduce(function (accumulator, length) {
								return accumulator + length;
			});}}
		);

		Object.defineProperty(vm,'height',{get: function () {
				if(vm.limitedJobs.length===0){
					return 0;
				}

						return vm.limitedJobs.map(
					function(job) {return job.height;})
							.reduce(function (accumulator, length) {
								return Math.max(accumulator, length);
					});}}
		);

		Object.defineProperty(vm,'firstSelectedElement',{get: function () {
				if(vm.selectedElementIds.length>0){
					return vm.elementsById[vm.selectedElementIds[0]];
				}else{
					return null;
				}
			}}
		);

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// LIFECYCLE METHODS
		//*******************************************
		function onInit() {
			setupConfig();

			angular.element(function(){
				vm.view = angular.element('#svgRoot');

				angular.element($window).on('resize', onWindowResize);
				angular.element(vm.view).on('mousewheel', onMouseWheel);
				angular.element(vm.view).on('scroll', scrolling);
				resize();
			});

			for (var i = 0; i < vm.solution.jobs.length; i++) {
				var job = vm.solution.jobs[i];

				if (!job.hasOwnProperty('id')) {
					vm.solution.jobs[i].id = i;
				}
			}

			if (vm.limitJobsConfig) {
				vm.limitJobs = true;
				vm.start = vm.limitJobsConfig.start;
				vm.count = vm.limitJobsConfig.count;
			}
		}

		function scrolling(){
			$timeout(function(){
				vm.scrollPosition = vm.view.scrollLeft();
			});
		}

		function onChange() {
			// update config
			//*******************************************
			setupConfig();
		}

		function onChanges(changes) {
			if (changes.solution && vm.solution.height){
				vm.solution.originalHeight = vm.solution.height;
			}

			if (!vm.isFirstChange) {
				if (changes.limitJobsConfig && changes.limitJobsConfig.currentValue !== null) {
					vm.limitJobs = true;
					vm.start = vm.limitJobsConfig.start;
					vm.count = vm.limitJobsConfig.count;
				} else {
					vm.limitJobs = false;
				}

				if (changes.solution || changes.limitJobsConfig) {
					vm.touchedElements.deselectAll();
					vm.selectedJobIds.splice(0,vm.selectedJobIds.length);
					vm.selectedElementIds.splice(0,vm.selectedElementIds.length);
				}

				$timeout(resize,vm.conf.resizeTimeout);
			}else{
				$timeout(resize,vm.conf.firstResizeTimeout);
			}

			vm.isFirstChange = false;
			resize();
		}

		function updateOffsets(){
			vm.elementsById = {};

			var xOffset = 0;

			for (var i=0;i<vm.limitedJobs.length;i++) {
				vm.limitedJobs[i].xOffset = xOffset;
				xOffset += vm.limitedJobs[i].length;

				var yOffset = 0;

				for (var j = vm.limitedJobs[i].slits.length - 1; j >= 0; j--) {
					vm.limitedJobs[i].slits[j].yOffset = yOffset;
					var xOffsetElement = 0;
					for (var k=0;k<vm.limitedJobs[i].slits[j].elements.length;k++) {
						vm.limitedJobs[i].slits[j].elements[k].xOffset = xOffsetElement;
						vm.limitedJobs[i].slits[j].elements[k].globalY = yOffset;
						vm.limitedJobs[i].slits[j].elements[k].globalX = xOffset + xOffsetElement;
						xOffsetElement += vm.limitedJobs[i].slits[j].elements[k].length;
						var id = vm.limitedJobs[i].slits[j].elements[k].id;
						copyOriginalValues(vm.limitedJobs[i].slits[j].elements[k]);
						vm.elementsById[id] = vm.limitedJobs[i].slits[j].elements[k];
					}
					yOffset += vm.limitedJobs[i].slits[j].height;
				}
			}
		}

		function onDestroy() {
			angular.element($window).off('resize', onWindowResize);
			angular.element(vm.view).off('mousewheel', onMouseWheel);
			angular.element(vm.view).off('scroll', scrolling);
		}

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		function onWindowResize() {
			resize();
		}

		function onMouseWheel(event){
			vm.view.scrollLeft(vm.view.scrollLeft() + event.originalEvent.deltaY);
			event.preventDefault();
			scrolling();
		}

		//*******************************************
		// METHODS
		//*******************************************
		function setupConfig() {
			vm.solutionConfig = vm.printStyle ? angular.merge(NUIT_SOLUTION_CONFIG, NUIT_SOLUTION_PRINT_CONFIG) : NUIT_SOLUTION_CONFIG;
			vm.conf = angular.merge({}, vm.solutionConfig, vm.config);
		}

		function createContainer() {
			vm.bgContainer = PixiUtils.createBgContainer(
				vm.stage,
				{x: vm.conf.style.rulerSizeY, y: 0},
				{color: vm.conf.style.solutionBackgroundColor, alpha: 1}
			);

			vm.rulerY = PixiUtils.createBasicContainer(
				vm.stage,
				{x: 0, y: vm.conf.style.rulerSizeX},
				{color: vm.conf.style.rulerBackgroundColor, alpha: 1}
			);

			vm.scrollBar = PixiUtils.createBasicContainer(
				vm.stage,
				{x: vm.conf.style.rulerSizeY, y: 0},
				{color: vm.conf.style.scrollbarBackgroundColor, alpha: 1}
			);
		}

		function resize() {
			vm.recalculating = true;

			if(!vm.view || vm.limitedJobs.length===0){
				$timeout(resize,vm.conf.resizeTimeout);
			}else {
				vm.start = Math.min(vm.solution.jobs.length, Math.max(1, Number.isNaN(vm.start) ? 1 : vm.start));
				vm.count = Math.max(1, Math.min(Number.isNaN(vm.count) ? vm.solution.jobs.length : vm.count, vm.solution.jobs.length));

				updateOffsets();

				vm.rendererWidth = Math.max(vm.view.width() - vm.conf.style.rulerSizeY, vm.conf.renderer.minWidth);
				vm.rendererHeight = Math.max(vm.view.height() - vm.conf.style.rulerSizeX, vm.conf.renderer.minHeight);

				if (!vm.manualFreezeScaling) {
					vm.sizeXPercent = vm.rendererWidth / vm.length;
				}

				vm.sizeYPercent = (vm.rendererHeight - 20) / vm.height;
				vm.minLengthScaleFactor = vm.rendererWidth / vm.length;

				vm.recalculating = false;

				$timeout(function () {
					$rootScope.$broadcast('nuitSolution::rendered');
				});
			}
		}

		function dragStart(event){
			/*var element = vm.elementsById[event.target.dataset.id];
			if(!vm.draggingInitialized && element && !isWaste(element)) {
				var id = parseInt(event.target.dataset.id);
				if(vm.selectedElementIds.indexOf(id)!==-1){
					vm.draggingInitialized = vm.selectedElementIds;
				}else {
					vm.draggingInitialized = [parseInt(event.target.dataset.id)];
				}
			}*/
		}

		function dragMove(event){
			/*if(vm.draggingInitialized) {
				if(!vm.newJob){
					vm.newJob = {elements:[]};
				}

				vm.draggedElements = [];
				for(var i=0;i<vm.draggingInitialized.length;i++){
					vm.draggedElements.push(vm.elementsById[vm.draggingInitialized[i]]);
				}
				vm.dragPositionX = event.originalEvent.offsetX - 50;
				vm.dragPositionY = event.originalEvent.offsetY;
			}*/
		}

		function dragEnd(event){
			/*if(event.target.dataset.job==='new'){
				for(var i=0;i<vm.draggedElements.length;i++){
					if(vm.newJob.elements.indexOf(vm.draggedElements[i].id)===-1) {
						vm.newJob.elements.push(vm.draggedElements[i].id);
					}
				}
			}else{
				for(var i=0;i<vm.draggingInitialized.length;i++){
					var index = vm.newJob.elements.indexOf(vm.draggingInitialized[i]);
					if(index>=0){
						vm.newJob.elements.splice(index,1);
					}
				}
			}

			vm.draggingInitialized = null;
			vm.draggedElements = null;*/
		}

		function copyOriginalValues(element) {
			copyOriginalValue(element, 'length');
			copyOriginalValue(element, 'height');
			copyOriginalValue(element, 'manualWork');
		}

		function copyOriginalValue(element, key) {
			var camelCasedKey = 'original' + key.charAt(0).toUpperCase() + key.slice(1);

			if (!element.hasOwnProperty(camelCasedKey)) {
				element[camelCasedKey] = element[key];
			}
		}

		function resetValue(element, key) {
			var camelCasedKey = 'original' + key.charAt(0).toUpperCase() + key.slice(1);
			element[key] = element[camelCasedKey];
		}

		function hasChanged(element) {
			return element.length !== element.originalLength ||
				element.height !== element.originalHeight ||
				element.manualWork !== element.originalManualWork;
		}

		/**
		 * True when the optimizer resized the piece within a tolerance band.
		 * 'adjustment' is absent on unadjusted pieces, and a zero delta is none.
		 */
		function hasAdjustment(element) {
			return !!element.adjustment &&
				(!!element.adjustment.height || !!element.adjustment.length);
		}

		/**
		 * A signed delta, in the length unit of the drawing but rounded with the
		 * thickness unit's decimals — tolerances are fractions of a millimetre
		 * and the length unit's precision would round them away.
		 */
		function adjustmentSigned(value) {
			var converted = Math.abs(value) / nuitUnits('length').factor;

			return (value > 0 ? '+' : '−') +
				converted.toFixed(nuitUnits('thickness').decimals);
		}

		/**
		 * The deltas next to the delta sign. The optimizer's 'height' is the
		 * machine's width, hence 'w'; unit is in the tooltip.
		 */
		function adjustmentLabel(element) {
			if (!hasAdjustment(element)) {
				return '';
			}

			var parts = [];

			if (element.adjustment.height) {
				parts.push('w ' + adjustmentSigned(element.adjustment.height));
			}

			if (element.adjustment.length) {
				parts.push('l ' + adjustmentSigned(element.adjustment.length));
			}

			return ' ' + parts.join(' / ');
		}

		/**
		 * Native tooltip for an adjusted piece: the deltas named per axis.
		 * The optimizer's 'height' is the machine's width, hence the label.
		 */
		function adjustmentTitle(element) {
			if (!hasAdjustment(element)) {
				return '';
			}

			var symbol = nuitUnits('length').symbol;
			var parts = [];

			if (element.adjustment.height) {
				parts.push($filter('translate')('PRODUCTION_ORDERS.WIDTH') + ' ' +
					adjustmentSigned(element.adjustment.height) + ' ' + symbol);
			}

			if (element.adjustment.length) {
				parts.push($filter('translate')('PRODUCTION_ORDERS.LENGTH') + ' ' +
					adjustmentSigned(element.adjustment.length) + ' ' + symbol);
			}

			return parts.join('   ');
		}

		function selectElementColor(element) {
			if(vm.draggingInitialized && vm.draggingInitialized.indexOf(element.id)!==-1){
				return '#'+(vm.conf.style.solutionElementBackgroundSelectedColor+0x330033).toString(16);
			}else if(vm.newJob && vm.newJob.elements.indexOf(element.id)!==-1){
					return 'grey';
			} else if(vm.selectedElementIds.indexOf(element.id)>=0){
				if(vm.firstSelectedElement && element.id===vm.firstSelectedElement.id){
					return '#'+vm.conf.style.solutionElementBackgroundSelectedColor.toString(16);
				}else{
					return '#'+(vm.conf.style.solutionElementBackgroundSelectedColor+0x200020).toString(16);
				}
			}else if (element.meta && element.meta.part && element.meta.part.complainOrderId) {
				return 'orange';
			}else if (isWaste(element)) {
				return 'url(#diagonalHatch)';
			} else if (element.originalManualWork) {
				return 'url(#diagonalHatchReverse)';
			} else if (hasAdjustment(element)) {
				return '#'+vm.conf.style.solutionElementBackgroundAdjustedColor.toString(16);
			} else {
				return 'white';
			}
		}

		function isWaste(element) {
			if (element.hasOwnProperty('is_waste')) {
				return element.is_waste;
			} else if (element.hasOwnProperty('isWaste')) {
				return element.isWaste;
			}

			return false;
		}

		function next() {
			change(1);
		}

		function prev() {
			change(-1);
		}

		function focus() {
			vm.limitJobs = !vm.limitJobs;

			if (vm.limitJobs === true) {
				if (vm.selectedJobIds.length===1) {
					for (var i = 0; i < vm.limitedJobs.length; i++) {
						if (vm.limitedJobs[i].id === vm.selectedJobIds[0]) {
							vm.start = i + 1;
							vm.count = 1;
							break;
						}
					}
				} else if (vm.selectedElementIds.length===1) {
					for (var i = 0; i < vm.solution.jobs.length; i++) {
						for (var j = 0; j < vm.solution.jobs[i].slits.length; j++) {
							var slit = vm.solution.jobs[i].slits[j];

							for (var k = 0; k < slit.elements.length; k++) {
								if (slit.elements[k].id === vm.selectedElementIds[0]) {
									vm.start = i + 1;
									vm.count = 1;
									break;
								}
							}
						}
					}
				}
			}else{
				vm.start = 1;
				vm.count = vm.solution.jobs.length;
			}

			resize();
		}

		function change(amount) {
			var oldIndex = 0;

			for (var i = 0; i < vm.solution.jobs.length; i++) {
				if (vm.solution.jobs[i].id === vm.selectedJobIds[0]) {
					oldIndex = i;
					break;
				}
			}

			move(oldIndex, validateNewIndex(oldIndex + amount));
			updateOffsets();
		}

		function validateNewIndex(newIndex) {
			if (newIndex > vm.solution.jobs.length - 1) {
				return 0;
			} else if (newIndex < 0) {
				return vm.solution.jobs.length - 1;
			}

			return newIndex;
		}

		function move(fromIndex, toIndex) {
			var element = vm.solution.jobs[fromIndex];
			vm.solution.jobs.splice(fromIndex, 1);
			vm.solution.jobs.splice(toIndex, 0, element);
		}

		function touchedElement() {
			var sourceElement = vm.elementsById[vm.selectedElementIds[0]];

			for(var i=0;i<vm.selectedElementIds.length;i++){
				var element = vm.elementsById[vm.selectedElementIds[i]];
				element.length = sourceElement.length;
				element.height = sourceElement.height;
				element.manualWork = sourceElement.manualWork;

				if(hasChanged(element) && !vm.touchedElements.isSelected(element)){
					vm.touchedElements.toggleSelectedEntity(element);
				}else if (!hasChanged(element) && vm.touchedElements.isSelected(element)) {
					vm.touchedElements.toggleSelectedEntity(element);
				}
			}
		}

		function resetElement() {
			for (var i = 0; i < vm.selectedElementIds.length; i++) {
				var element = vm.elementsById[vm.selectedElementIds[i]];

				resetValue(element, 'length');
				resetValue(element, 'height');
				resetValue(element, 'manualWork');

				if (vm.touchedElements.isSelected(element)) {
					vm.touchedElements.toggleSelectedEntity(element);
				}
			}
		}

		function canMoveJobs() {
			var selected = vm.touchedElements.getSelected();
			var elementsChanged = false;

			for (var i = 0; i < selected.length; i++) {
				if (hasChanged(selected[i])) {
					elementsChanged = elementsChanged || true;
				}
			}

			return !elementsChanged && vm.selectedJobIds.length > 0 && vm.limitedJobs.length > 1 && vm.solution.height === vm.solution.originalHeight;
		}

		function screenshot() {
			console.log(vm.view[0].innerHTML);
			Base64DownloadService.download('data:image/svg+xml;base64,' + window.btoa(new XMLSerializer().serializeToString( vm.view[0].children[0] )), vm.solution.id + '.png');
		}

		function selectSimilar(event, additionalKey){
			if(!event.originalEvent.shiftKey && vm.selectedElementIds.length>1){
				vm.selectedElementIds.splice(1,vm.selectedElementIds.length);
			}

			var keys = vm.matchingKeysBatch.concat([additionalKey]);

			for(var id in vm.elementsById){
				var element = vm.elementsById[id];
				var matches = true;

				for(var key in keys){
					var attribute = keys[key];
					matches = matches && vm.firstSelectedElement[attribute]===element[attribute];
				}

				if(matches && vm.selectedElementIds.indexOf(element.id)===-1){
					vm.selectedElementIds.push(element.id);
				}
			}
		}

		function elementLabel(element) {
			// waste elements belong to no profile, so there is no shortName/profileId to show
			if (element && element.isWaste) { return $filter('translate')('PRODUCTION_ORDERS.CUTTING_WASTE'); }
			return $filter('shortName')(element, '#{' + vm.conf.style.elementId + '}');
		}

		function showText(text,width){
			if(text.length*10<width){
				return text;
			}else{
				return '';
			}
		}

		function getMinRounded(value1, value2){
			return Math.min(Math.round(value1), Math.round(value2));
		}

		function getConverted(rawValue){
			return (rawValue/nuitUnits('length').factor).toFixed(nuitUnits('length').decimals);
		}

		function complain(){
			if(vm.firstSelectedElement!==null) {
				ProductionOrderViewService.complain({id:vm.firstSelectedElement.partId})
					.then(function(part){
						vm.firstSelectedElement.meta['part'] = {
							complainOrderId: part.complainOrderId,
							complainPartId: part.complainPartId
						};
						vm.selectedElementIds.length = 0;
					});
			}
		}

		function canComplain(){
			return vm.selectedElementIds.length===1 &&
				!vm.firstSelectedElement.isWaste &&
				(!vm.firstSelectedElement.meta || !vm.firstSelectedElement.meta.part || !vm.firstSelectedElement.meta.part.complainPartId);
		}
	}
}());


(function () {
	'use strict';

	angular
		.module('nuit.solution')
		.constant('NUIT_SOLUTION_PRINT_CONFIG', {
			style: {
				fontSize: 16,
				rulerSizeX: 46,
				scrollbarHeight: 0,
				minDistanceColor: 0x000000
			}
		});
}());


(function () {
	'use strict';

	angular
		.module('nuit.solution')
		.constant('NUIT_SOLUTION_CONFIG', {
			forceCanvas: false,
			resizeTimeout: 100,
			firstResizeTimeout: 500,
			canvasContainerSelector: '.solutionContainer',
			renderer: {
				tag: 'svg',
				backgroundColor: 0xFFFFFF,
				minHeight: 200,
				minWidth: 600
			},
			style: {
				fontSize: 12,
				rulerBackgroundColor: 0xCCCCCC,
				rulerForegroundColor: 0xAAAAAA,
				rulerForegroundSelectedColor: 0xeef442,
				rulerSizeX: 40,
				rulerSizeY: 24,
				scrollbarBackgroundColor: 0xFFFFFF,
				scrollbarForegroundColor: 0x555555,
				scrollbarHeight: 20,
				scrollbarKnobWidth: 60,
				solutionBackgroundColor: 0xEAEAEA,
				solutionSliceBackgroundColor: 0xAAAAAA,
				solutionSliceBorderColor: 0x000000,
				solutionSliceBorderThickness: 0,
				solutionJobBorderColor: 0x000000,
				solutionJobBorderThickness: 1,
				solutionJobSpacing: 0,
				solutionElementBackgroundColor: 0xFFFFFF,
				solutionElementBackgroundSelectedColor: 0xBBFFBB,
				// element the optimizer resized within a tolerance band
				solutionElementBackgroundAdjustedColor: 0xDDEBF7,
				solutionElementBorderColor: 0x000000,
				solutionElementBorderThickness: 1,
				solutionElementPattern: '',
				solutionWasteBackgroundColor: 0xFFFFFF,
				solutionWasteBackgroundSelectedColor: 0xEAFFEA,
				solutionManualWorkBackgroundColor: 0xDDDDDD,
				solutionManualWorkBackgroundSelectedColor: 0x00CC00,
				solutionManualWorkPattern: 'slope_reverse-20',
				solutionWasteBorderColor: 0x000000,
				solutionWasteBorderThickness: 0,
				solutionWastePattern: 'slope-20',
				solutionElementSpacing: 0,
				showWasteSize: false,
				minDistanceColor: 0xFF0000,
				showElementId: true,
				elementId: 'profileId',
				showJobId: true
			}
		});
}());

(function () {
	'use strict';

	angular
		.module('nuit.solution')
		.component('nuitSolution', {
			templateUrl: function(NUIT_SOLUTION_ROOT){
				'ngInject';
				return NUIT_SOLUTION_ROOT + '/components/nuit-solution.html';
			},
			controller: 'nuitSolutionController',
			controllerAs: 'vm',
			bindings: {
				config: '<',
				solution: '<',
				printStyle: '<',
				onSolutionChanged: '&',
				enableTools: '<',
				enableUi: '<',
				limitJobsConfig: '<'
			}
		});
}());

(function () {
	'use strict';

	angular
		.module('nuit.solution')
		.component('nuitSolutionSvg', {
			templateUrl: function(NUIT_SOLUTION_ROOT){
				'ngInject';
				return NUIT_SOLUTION_ROOT + '/components/nuit-solution-svg.html';
			},
			controller: 'nuitSolutionSvgController',
			controllerAs: 'vm',
			bindings: {
				config: '<',
				solution: '<',
				printStyle: '<',
				onSolutionChanged: '&',
				enableTools: '<',
				enableUi: '<',
				enableComplain: '<',
				limitJobsConfig: '<'
			}
		});
}());

"use strict";!function(){function e(e){var i=e.resourceUrlWhitelist();i.push("nuit::**"),e.resourceUrlWhitelist(i)}e.$inject=["$sceDelegateProvider"],angular.module("nuit.editor",["ngMaterial"]).config(e)}();
/*!
 * pixi.js - v4.8.8
 * Compiled Sun, 02 Jun 2019 22:37:26 UTC
 *
 * pixi.js is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.PIXI=t()}}(function(){var t;return function(){function t(e,r,n){function i(s,a){if(!r[s]){if(!e[s]){var u="function"==typeof require&&require;if(!a&&u)return u(s,!0);if(o)return o(s,!0);var h=new Error("Cannot find module '"+s+"'");throw h.code="MODULE_NOT_FOUND",h}var l=r[s]={exports:{}};e[s][0].call(l.exports,function(t){var r=e[s][1][t];return i(r||t)},l,l.exports,t,e,r,n)}return r[s].exports}for(var o="function"==typeof require&&require,s=0;s<n.length;s++)i(n[s]);return i}return t}()({1:[function(t,e,r){"use strict";"use restrict";function n(t){var e=32;return t&=-t,t&&e--,65535&t&&(e-=16),16711935&t&&(e-=8),252645135&t&&(e-=4),858993459&t&&(e-=2),1431655765&t&&(e-=1),e}r.INT_BITS=32,r.INT_MAX=2147483647,r.INT_MIN=-1<<31,r.sign=function(t){return(t>0)-(t<0)},r.abs=function(t){var e=t>>31;return(t^e)-e},r.min=function(t,e){return e^(t^e)&-(t<e)},r.max=function(t,e){return t^(t^e)&-(t<e)},r.isPow2=function(t){return!(t&t-1||!t)},r.log2=function(t){var e,r;return e=(t>65535)<<4,t>>>=e,r=(t>255)<<3,t>>>=r,e|=r,r=(t>15)<<2,t>>>=r,e|=r,r=(t>3)<<1,t>>>=r,(e|=r)|t>>1},r.log10=function(t){return t>=1e9?9:t>=1e8?8:t>=1e7?7:t>=1e6?6:t>=1e5?5:t>=1e4?4:t>=1e3?3:t>=100?2:t>=10?1:0},r.popCount=function(t){return t-=t>>>1&1431655765,16843009*((t=(858993459&t)+(t>>>2&858993459))+(t>>>4)&252645135)>>>24},r.countTrailingZeros=n,r.nextPow2=function(t){return t+=0===t,--t,t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,(t|=t>>>16)+1},r.prevPow2=function(t){return t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,(t|=t>>>16)-(t>>>1)},r.parity=function(t){return t^=t>>>16,t^=t>>>8,t^=t>>>4,27030>>>(t&=15)&1};var i=new Array(256);!function(t){for(var e=0;e<256;++e){var r=e,n=e,i=7;for(r>>>=1;r;r>>>=1)n<<=1,n|=1&r,--i;t[e]=n<<i&255}}(i),r.reverse=function(t){return i[255&t]<<24|i[t>>>8&255]<<16|i[t>>>16&255]<<8|i[t>>>24&255]},r.interleave2=function(t,e){return t&=65535,t=16711935&(t|t<<8),t=252645135&(t|t<<4),t=858993459&(t|t<<2),t=1431655765&(t|t<<1),e&=65535,e=16711935&(e|e<<8),e=252645135&(e|e<<4),e=858993459&(e|e<<2),e=1431655765&(e|e<<1),t|e<<1},r.deinterleave2=function(t,e){return t=t>>>e&1431655765,t=858993459&(t|t>>>1),t=252645135&(t|t>>>2),t=16711935&(t|t>>>4),(t=65535&(t|t>>>16))<<16>>16},r.interleave3=function(t,e,r){return t&=1023,t=4278190335&(t|t<<16),t=251719695&(t|t<<8),t=3272356035&(t|t<<4),t=1227133513&(t|t<<2),e&=1023,e=4278190335&(e|e<<16),e=251719695&(e|e<<8),e=3272356035&(e|e<<4),e=1227133513&(e|e<<2),t|=e<<1,r&=1023,r=4278190335&(r|r<<16),r=251719695&(r|r<<8),r=3272356035&(r|r<<4),r=1227133513&(r|r<<2),t|r<<2},r.deinterleave3=function(t,e){return t=t>>>e&1227133513,t=3272356035&(t|t>>>2),t=251719695&(t|t>>>4),t=4278190335&(t|t>>>8),(t=1023&(t|t>>>16))<<22>>22},r.nextCombination=function(t){var e=t|t-1;return e+1|(~e&-~e)-1>>>n(t)+1}},{}],2:[function(t,e,r){"use strict";function n(t,e,r){r=r||2;var n=e&&e.length,o=n?e[0]*r:t.length,a=i(t,0,o,r,!0),u=[];if(!a||a.next===a.prev)return u;var h,l,d,f,p,v,g;if(n&&(a=c(t,e,a,r)),t.length>80*r){h=d=t[0],l=f=t[1];for(var y=r;y<o;y+=r)p=t[y],v=t[y+1],p<h&&(h=p),v<l&&(l=v),p>d&&(d=p),v>f&&(f=v);g=Math.max(d-h,f-l),g=0!==g?1/g:0}return s(a,u,r,h,l,g),u}function i(t,e,r,n,i){var o,s;if(i===A(t,e,r,n)>0)for(o=e;o<r;o+=n)s=P(o,t[o],t[o+1],s);else for(o=r-n;o>=e;o-=n)s=P(o,t[o],t[o+1],s);return s&&T(s,s.next)&&(C(s),s=s.next),s}function o(t,e){if(!t)return t;e||(e=t);var r,n=t;do{if(r=!1,n.steiner||!T(n,n.next)&&0!==x(n.prev,n,n.next))n=n.next;else{if(C(n),(n=e=n.prev)===n.next)break;r=!0}}while(r||n!==e);return e}function s(t,e,r,n,i,c,d){if(t){!d&&c&&v(t,n,i,c);for(var f,p,g=t;t.prev!==t.next;)if(f=t.prev,p=t.next,c?u(t,n,i,c):a(t))e.push(f.i/r),e.push(t.i/r),e.push(p.i/r),C(t),t=p.next,g=p.next;else if((t=p)===g){d?1===d?(t=h(t,e,r),s(t,e,r,n,i,c,2)):2===d&&l(t,e,r,n,i,c):s(o(t),e,r,n,i,c,1);break}}}function a(t){var e=t.prev,r=t,n=t.next;if(x(e,r,n)>=0)return!1;for(var i=t.next.next;i!==t.prev;){if(_(e.x,e.y,r.x,r.y,n.x,n.y,i.x,i.y)&&x(i.prev,i,i.next)>=0)return!1;i=i.next}return!0}function u(t,e,r,n){var i=t.prev,o=t,s=t.next;if(x(i,o,s)>=0)return!1;for(var a=i.x<o.x?i.x<s.x?i.x:s.x:o.x<s.x?o.x:s.x,u=i.y<o.y?i.y<s.y?i.y:s.y:o.y<s.y?o.y:s.y,h=i.x>o.x?i.x>s.x?i.x:s.x:o.x>s.x?o.x:s.x,l=i.y>o.y?i.y>s.y?i.y:s.y:o.y>s.y?o.y:s.y,c=y(a,u,e,r,n),d=y(h,l,e,r,n),f=t.prevZ,p=t.nextZ;f&&f.z>=c&&p&&p.z<=d;){if(f!==t.prev&&f!==t.next&&_(i.x,i.y,o.x,o.y,s.x,s.y,f.x,f.y)&&x(f.prev,f,f.next)>=0)return!1;if(f=f.prevZ,p!==t.prev&&p!==t.next&&_(i.x,i.y,o.x,o.y,s.x,s.y,p.x,p.y)&&x(p.prev,p,p.next)>=0)return!1;p=p.nextZ}for(;f&&f.z>=c;){if(f!==t.prev&&f!==t.next&&_(i.x,i.y,o.x,o.y,s.x,s.y,f.x,f.y)&&x(f.prev,f,f.next)>=0)return!1;f=f.prevZ}for(;p&&p.z<=d;){if(p!==t.prev&&p!==t.next&&_(i.x,i.y,o.x,o.y,s.x,s.y,p.x,p.y)&&x(p.prev,p,p.next)>=0)return!1;p=p.nextZ}return!0}function h(t,e,r){var n=t;do{var i=n.prev,o=n.next.next;!T(i,o)&&w(i,n,n.next,o)&&S(i,o)&&S(o,i)&&(e.push(i.i/r),e.push(n.i/r),e.push(o.i/r),C(n),C(n.next),n=t=o),n=n.next}while(n!==t);return n}function l(t,e,r,n,i,a){var u=t;do{for(var h=u.next.next;h!==u.prev;){if(u.i!==h.i&&b(u,h)){var l=M(u,h);return u=o(u,u.next),l=o(l,l.next),s(u,e,r,n,i,a),void s(l,e,r,n,i,a)}h=h.next}u=u.next}while(u!==t)}function c(t,e,r,n){var s,a,u,h,l,c=[];for(s=0,a=e.length;s<a;s++)u=e[s]*n,h=s<a-1?e[s+1]*n:t.length,l=i(t,u,h,n,!1),l===l.next&&(l.steiner=!0),c.push(m(l));for(c.sort(d),s=0;s<c.length;s++)f(c[s],r),r=o(r,r.next);return r}function d(t,e){return t.x-e.x}function f(t,e){if(e=p(t,e)){var r=M(e,t);o(r,r.next)}}function p(t,e){var r,n=e,i=t.x,o=t.y,s=-1/0;do{if(o<=n.y&&o>=n.next.y&&n.next.y!==n.y){var a=n.x+(o-n.y)*(n.next.x-n.x)/(n.next.y-n.y);if(a<=i&&a>s){if(s=a,a===i){if(o===n.y)return n;if(o===n.next.y)return n.next}r=n.x<n.next.x?n:n.next}}n=n.next}while(n!==e);if(!r)return null;if(i===s)return r.prev;var u,h=r,l=r.x,c=r.y,d=1/0;for(n=r.next;n!==h;)i>=n.x&&n.x>=l&&i!==n.x&&_(o<c?i:s,o,l,c,o<c?s:i,o,n.x,n.y)&&((u=Math.abs(o-n.y)/(i-n.x))<d||u===d&&n.x>r.x)&&S(n,t)&&(r=n,d=u),n=n.next;return r}function v(t,e,r,n){var i=t;do{null===i.z&&(i.z=y(i.x,i.y,e,r,n)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,g(i)}function g(t){var e,r,n,i,o,s,a,u,h=1;do{for(r=t,t=null,o=null,s=0;r;){for(s++,n=r,a=0,e=0;e<h&&(a++,n=n.nextZ);e++);for(u=h;a>0||u>0&&n;)0!==a&&(0===u||!n||r.z<=n.z)?(i=r,r=r.nextZ,a--):(i=n,n=n.nextZ,u--),o?o.nextZ=i:t=i,i.prevZ=o,o=i;r=n}o.nextZ=null,h*=2}while(s>1);return t}function y(t,e,r,n,i){return t=32767*(t-r)*i,e=32767*(e-n)*i,t=16711935&(t|t<<8),t=252645135&(t|t<<4),t=858993459&(t|t<<2),t=1431655765&(t|t<<1),e=16711935&(e|e<<8),e=252645135&(e|e<<4),e=858993459&(e|e<<2),e=1431655765&(e|e<<1),t|e<<1}function m(t){var e=t,r=t;do{e.x<r.x&&(r=e),e=e.next}while(e!==t);return r}function _(t,e,r,n,i,o,s,a){return(i-s)*(e-a)-(t-s)*(o-a)>=0&&(t-s)*(n-a)-(r-s)*(e-a)>=0&&(r-s)*(o-a)-(i-s)*(n-a)>=0}function b(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!E(t,e)&&S(t,e)&&S(e,t)&&O(t,e)}function x(t,e,r){return(e.y-t.y)*(r.x-e.x)-(e.x-t.x)*(r.y-e.y)}function T(t,e){return t.x===e.x&&t.y===e.y}function w(t,e,r,n){return!!(T(t,e)&&T(r,n)||T(t,n)&&T(r,e))||x(t,e,r)>0!=x(t,e,n)>0&&x(r,n,t)>0!=x(r,n,e)>0}function E(t,e){var r=t;do{if(r.i!==t.i&&r.next.i!==t.i&&r.i!==e.i&&r.next.i!==e.i&&w(r,r.next,t,e))return!0;r=r.next}while(r!==t);return!1}function S(t,e){return x(t.prev,t,t.next)<0?x(t,e,t.next)>=0&&x(t,t.prev,e)>=0:x(t,e,t.prev)<0||x(t,t.next,e)<0}function O(t,e){var r=t,n=!1,i=(t.x+e.x)/2,o=(t.y+e.y)/2;do{r.y>o!=r.next.y>o&&r.next.y!==r.y&&i<(r.next.x-r.x)*(o-r.y)/(r.next.y-r.y)+r.x&&(n=!n),r=r.next}while(r!==t);return n}function M(t,e){var r=new R(t.i,t.x,t.y),n=new R(e.i,e.x,e.y),i=t.next,o=e.prev;return t.next=e,e.prev=t,r.next=i,i.prev=r,n.next=r,r.prev=n,o.next=n,n.prev=o,n}function P(t,e,r,n){var i=new R(t,e,r);return n?(i.next=n.next,i.prev=n,n.next.prev=i,n.next=i):(i.prev=i,i.next=i),i}function C(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ)}function R(t,e,r){this.i=t,this.x=e,this.y=r,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1}function A(t,e,r,n){for(var i=0,o=e,s=r-n;o<r;o+=n)i+=(t[s]-t[o])*(t[o+1]+t[s+1]),s=o;return i}e.exports=n,e.exports.default=n,n.deviation=function(t,e,r,n){var i=e&&e.length,o=i?e[0]*r:t.length,s=Math.abs(A(t,0,o,r));if(i)for(var a=0,u=e.length;a<u;a++){var h=e[a]*r,l=a<u-1?e[a+1]*r:t.length;s-=Math.abs(A(t,h,l,r))}var c=0;for(a=0;a<n.length;a+=3){var d=n[a]*r,f=n[a+1]*r,p=n[a+2]*r;c+=Math.abs((t[d]-t[p])*(t[f+1]-t[d+1])-(t[d]-t[f])*(t[p+1]-t[d+1]))}return 0===s&&0===c?0:Math.abs((c-s)/s)},n.flatten=function(t){for(var e=t[0][0].length,r={vertices:[],holes:[],dimensions:e},n=0,i=0;i<t.length;i++){for(var o=0;o<t[i].length;o++)for(var s=0;s<e;s++)r.vertices.push(t[i][o][s]);i>0&&(n+=t[i-1].length,r.holes.push(n))}return r}},{}],3:[function(t,e,r){"use strict";function n(){}function i(t,e,r){this.fn=t,this.context=e,this.once=r||!1}function o(){this._events=new n,this._eventsCount=0}var s=Object.prototype.hasOwnProperty,a="~";Object.create&&(n.prototype=Object.create(null),(new n).__proto__||(a=!1)),o.prototype.eventNames=function(){var t,e,r=[];if(0===this._eventsCount)return r;for(e in t=this._events)s.call(t,e)&&r.push(a?e.slice(1):e);return Object.getOwnPropertySymbols?r.concat(Object.getOwnPropertySymbols(t)):r},o.prototype.listeners=function(t,e){var r=a?a+t:t,n=this._events[r];if(e)return!!n;if(!n)return[];if(n.fn)return[n.fn];for(var i=0,o=n.length,s=new Array(o);i<o;i++)s[i]=n[i].fn;return s},o.prototype.emit=function(t,e,r,n,i,o){var s=a?a+t:t;if(!this._events[s])return!1;var u,h,l=this._events[s],c=arguments.length;if(l.fn){switch(l.once&&this.removeListener(t,l.fn,void 0,!0),c){case 1:return l.fn.call(l.context),!0;case 2:return l.fn.call(l.context,e),!0;case 3:return l.fn.call(l.context,e,r),!0;case 4:return l.fn.call(l.context,e,r,n),!0;case 5:return l.fn.call(l.context,e,r,n,i),!0;case 6:return l.fn.call(l.context,e,r,n,i,o),!0}for(h=1,u=new Array(c-1);h<c;h++)u[h-1]=arguments[h];l.fn.apply(l.context,u)}else{var d,f=l.length;for(h=0;h<f;h++)switch(l[h].once&&this.removeListener(t,l[h].fn,void 0,!0),c){case 1:l[h].fn.call(l[h].context);break;case 2:l[h].fn.call(l[h].context,e);break;case 3:l[h].fn.call(l[h].context,e,r);break;case 4:l[h].fn.call(l[h].context,e,r,n);break;default:if(!u)for(d=1,u=new Array(c-1);d<c;d++)u[d-1]=arguments[d];l[h].fn.apply(l[h].context,u)}}return!0},o.prototype.on=function(t,e,r){var n=new i(e,r||this),o=a?a+t:t;return this._events[o]?this._events[o].fn?this._events[o]=[this._events[o],n]:this._events[o].push(n):(this._events[o]=n,this._eventsCount++),this},o.prototype.once=function(t,e,r){var n=new i(e,r||this,!0),o=a?a+t:t;return this._events[o]?this._events[o].fn?this._events[o]=[this._events[o],n]:this._events[o].push(n):(this._events[o]=n,this._eventsCount++),this},o.prototype.removeListener=function(t,e,r,i){var o=a?a+t:t;if(!this._events[o])return this;if(!e)return 0==--this._eventsCount?this._events=new n:delete this._events[o],this;var s=this._events[o];if(s.fn)s.fn!==e||i&&!s.once||r&&s.context!==r||(0==--this._eventsCount?this._events=new n:delete this._events[o]);else{for(var u=0,h=[],l=s.length;u<l;u++)(s[u].fn!==e||i&&!s[u].once||r&&s[u].context!==r)&&h.push(s[u]);h.length?this._events[o]=1===h.length?h[0]:h:0==--this._eventsCount?this._events=new n:delete this._events[o]}return this},o.prototype.removeAllListeners=function(t){var e;return t?(e=a?a+t:t,this._events[e]&&(0==--this._eventsCount?this._events=new n:delete this._events[e])):(this._events=new n,this._eventsCount=0),this},o.prototype.off=o.prototype.removeListener,o.prototype.addListener=o.prototype.on,o.prototype.setMaxListeners=function(){return this},o.prefixed=a,o.EventEmitter=o,void 0!==e&&(e.exports=o)},{}],4:[function(e,r,n){!function(e){function n(t,e){return t.test(e)}function i(t){var e=t||("undefined"!=typeof navigator?navigator.userAgent:""),r=e.split("[FBAN");void 0!==r[1]&&(e=r[0]),void 0!==(r=e.split("Twitter"))[1]&&(e=r[0]);var i={apple:{phone:n(o,e)&&!n(d,e),ipod:n(s,e),tablet:!n(o,e)&&n(a,e)&&!n(d,e),device:(n(o,e)||n(s,e)||n(a,e))&&!n(d,e)},amazon:{phone:n(l,e),tablet:!n(l,e)&&n(c,e),device:n(l,e)||n(c,e)},android:{phone:!n(d,e)&&n(l,e)||!n(d,e)&&n(u,e),tablet:!n(d,e)&&!n(l,e)&&!n(u,e)&&(n(c,e)||n(h,e)),device:!n(d,e)&&(n(l,e)||n(c,e)||n(u,e)||n(h,e))},windows:{phone:n(d,e),tablet:n(f,e),device:n(d,e)||n(f,e)},other:{blackberry:n(p,e),blackberry10:n(v,e),opera:n(g,e),firefox:n(m,e),chrome:n(y,e),device:n(p,e)||n(v,e)||n(g,e)||n(m,e)||n(y,e)}};return i.any=i.apple.device||i.android.device||i.windows.device||i.other.device,i.phone=i.apple.phone||i.android.phone||i.windows.phone,i.tablet=i.apple.tablet||i.android.tablet||i.windows.tablet,i}var o=/iPhone/i,s=/iPod/i,a=/iPad/i,u=/\bAndroid(?:.+)Mobile\b/i,h=/Android/i,l=/\bAndroid(?:.+)SD4930UR\b/i,c=/\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,d=/Windows Phone/i,f=/\bWindows(?:.+)ARM\b/i,p=/BlackBerry/i,v=/BB10/i,g=/Opera Mini/i,y=/\b(CriOS|Chrome)(?:.+)Mobile/i,m=/\Mobile(?:.+)Firefox\b/i;void 0!==r&&r.exports&&"undefined"==typeof window?r.exports=i:void 0!==r&&r.exports&&"undefined"!=typeof window?r.exports=i():"function"==typeof t&&t.amd?t([],e.isMobile=i()):e.isMobile=i()}(this)},{}],5:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){return t._head?(t._tail._next=e,e._prev=t._tail,t._tail=e):(t._head=e,t._tail=e),e._owner=t,e}Object.defineProperty(r,"__esModule",{value:!0});var o=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),s=function(){function t(e,r,i){void 0===r&&(r=!1),n(this,t),this._fn=e,this._once=r,this._thisArg=i,this._next=this._prev=this._owner=null}return o(t,[{key:"detach",value:function(){return null!==this._owner&&(this._owner.detach(this),!0)}}]),t}(),a=function(){function t(){n(this,t),this._head=this._tail=void 0}return o(t,[{key:"handlers",value:function(){var t=!(arguments.length<=0||void 0===arguments[0])&&arguments[0],e=this._head;if(t)return!!e;for(var r=[];e;)r.push(e),e=e._next;return r}},{key:"has",value:function(t){if(!(t instanceof s))throw new Error("MiniSignal#has(): First arg must be a MiniSignalBinding object.");return t._owner===this}},{key:"dispatch",value:function(){var t=this._head;if(!t)return!1;for(;t;)t._once&&this.detach(t),t._fn.apply(t._thisArg,arguments),t=t._next;return!0}},{key:"add",value:function(t){var e=arguments.length<=1||void 0===arguments[1]?null:arguments[1];if("function"!=typeof t)throw new Error("MiniSignal#add(): First arg must be a Function.");return i(this,new s(t,!1,e))}},{key:"once",value:function(t){var e=arguments.length<=1||void 0===arguments[1]?null:arguments[1];if("function"!=typeof t)throw new Error("MiniSignal#once(): First arg must be a Function.");return i(this,new s(t,!0,e))}},{key:"detach",value:function(t){if(!(t instanceof s))throw new Error("MiniSignal#detach(): First arg must be a MiniSignalBinding object.");return t._owner!==this?this:(t._prev&&(t._prev._next=t._next),t._next&&(t._next._prev=t._prev),t===this._head?(this._head=t._next,null===t._next&&(this._tail=null)):t===this._tail&&(this._tail=t._prev,this._tail._next=null),t._owner=null,this)}},{key:"detachAll",value:function(){var t=this._head;if(!t)return this;for(this._head=this._tail=null;t;)t._owner=null,t=t._next;return this}}]),t}();a.MiniSignalBinding=s,r.default=a,e.exports=r.default},{}],6:[function(t,e,r){"use strict";function n(t){if(null===t||void 0===t)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(t)}var i=Object.getOwnPropertySymbols,o=Object.prototype.hasOwnProperty,s=Object.prototype.propertyIsEnumerable;e.exports=function(){try{if(!Object.assign)return!1;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return!1;for(var e={},r=0;r<10;r++)e["_"+String.fromCharCode(r)]=r;if("0123456789"!==Object.getOwnPropertyNames(e).map(function(t){return e[t]}).join(""))return!1;var n={};return"abcdefghijklmnopqrst".split("").forEach(function(t){n[t]=t}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},n)).join("")}catch(t){return!1}}()?Object.assign:function(t,e){for(var r,a,u=n(t),h=1;h<arguments.length;h++){r=Object(arguments[h]);for(var l in r)o.call(r,l)&&(u[l]=r[l]);if(i){a=i(r);for(var c=0;c<a.length;c++)s.call(r,a[c])&&(u[a[c]]=r[a[c]])}}return u}},{}],7:[function(t,e,r){"use strict";e.exports=function(t,e){e=e||{};for(var r={key:["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],q:{name:"queryKey",parser:/(?:^|&)([^&=]*)=?([^&]*)/g},parser:{strict:/^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,loose:/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/}},n=r.parser[e.strictMode?"strict":"loose"].exec(t),i={},o=14;o--;)i[r.key[o]]=n[o]||"";return i[r.q.name]={},i[r.key[12]].replace(r.q.parser,function(t,e,n){e&&(i[r.q.name][e]=n)}),i}},{}],8:[function(t,e,r){(function(t){function e(t,e){for(var r=0,n=t.length-1;n>=0;n--){var i=t[n];"."===i?t.splice(n,1):".."===i?(t.splice(n,1),r++):r&&(t.splice(n,1),r--)}if(e)for(;r--;r)t.unshift("..");return t}function n(t,e){if(t.filter)return t.filter(e);for(var r=[],n=0;n<t.length;n++)e(t[n],n,t)&&r.push(t[n]);return r}var i=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,o=function(t){return i.exec(t).slice(1)};r.resolve=function(){for(var r="",i=!1,o=arguments.length-1;o>=-1&&!i;o--){var s=o>=0?arguments[o]:t.cwd();if("string"!=typeof s)throw new TypeError("Arguments to path.resolve must be strings");s&&(r=s+"/"+r,i="/"===s.charAt(0))}return r=e(n(r.split("/"),function(t){return!!t}),!i).join("/"),(i?"/":"")+r||"."},r.normalize=function(t){var i=r.isAbsolute(t),o="/"===s(t,-1);return t=e(n(t.split("/"),function(t){return!!t}),!i).join("/"),t||i||(t="."),t&&o&&(t+="/"),(i?"/":"")+t},r.isAbsolute=function(t){return"/"===t.charAt(0)},r.join=function(){var t=Array.prototype.slice.call(arguments,0);return r.normalize(n(t,function(t,e){if("string"!=typeof t)throw new TypeError("Arguments to path.join must be strings");return t}).join("/"))},r.relative=function(t,e){function n(t){for(var e=0;e<t.length&&""===t[e];e++);for(var r=t.length-1;r>=0&&""===t[r];r--);return e>r?[]:t.slice(e,r-e+1)}t=r.resolve(t).substr(1),e=r.resolve(e).substr(1);for(var i=n(t.split("/")),o=n(e.split("/")),s=Math.min(i.length,o.length),a=s,u=0;u<s;u++)if(i[u]!==o[u]){a=u;break}for(var h=[],u=a;u<i.length;u++)h.push("..");return h=h.concat(o.slice(a)),h.join("/")},r.sep="/",r.delimiter=":",r.dirname=function(t){var e=o(t),r=e[0],n=e[1];return r||n?(n&&(n=n.substr(0,n.length-1)),r+n):"."},r.basename=function(t,e){var r=o(t)[2];return e&&r.substr(-1*e.length)===e&&(r=r.substr(0,r.length-e.length)),r},r.extname=function(t){return o(t)[3]};var s="b"==="ab".substr(-1)?function(t,e,r){return t.substr(e,r)}:function(t,e,r){return e<0&&(e=t.length+e),t.substr(e,r)}}).call(this,t("_process"))},{_process:26}],9:[function(t,e,r){var n=new ArrayBuffer(0),i=function(t,e,r,i){this.gl=t,this.buffer=t.createBuffer(),this.type=e||t.ARRAY_BUFFER,this.drawType=i||t.STATIC_DRAW,this.data=n,r&&this.upload(r),this._updateID=0};i.prototype.upload=function(t,e,r){r||this.bind();var n=this.gl;t=t||this.data,e=e||0,this.data.byteLength>=t.byteLength?n.bufferSubData(this.type,e,t):n.bufferData(this.type,t,this.drawType),this.data=t},i.prototype.bind=function(){this.gl.bindBuffer(this.type,this.buffer)},i.createVertexBuffer=function(t,e,r){return new i(t,t.ARRAY_BUFFER,e,r)},i.createIndexBuffer=function(t,e,r){return new i(t,t.ELEMENT_ARRAY_BUFFER,e,r)},i.create=function(t,e,r,n){return new i(t,e,r,n)},i.prototype.destroy=function(){this.gl.deleteBuffer(this.buffer)},e.exports=i},{}],10:[function(t,e,r){var n=t("./GLTexture"),i=function(t,e,r){this.gl=t,this.framebuffer=t.createFramebuffer(),this.stencil=null,this.texture=null,this.width=e||100,this.height=r||100};i.prototype.enableTexture=function(t){var e=this.gl;this.texture=t||new n(e),this.texture.bind(),this.bind(),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,this.texture.texture,0)},i.prototype.enableStencil=function(){if(!this.stencil){var t=this.gl;this.stencil=t.createRenderbuffer(),t.bindRenderbuffer(t.RENDERBUFFER,this.stencil),t.framebufferRenderbuffer(t.FRAMEBUFFER,t.DEPTH_STENCIL_ATTACHMENT,t.RENDERBUFFER,this.stencil),t.renderbufferStorage(t.RENDERBUFFER,t.DEPTH_STENCIL,this.width,this.height)}},i.prototype.clear=function(t,e,r,n){this.bind();var i=this.gl;i.clearColor(t,e,r,n),i.clear(i.COLOR_BUFFER_BIT|i.DEPTH_BUFFER_BIT)},i.prototype.bind=function(){var t=this.gl;t.bindFramebuffer(t.FRAMEBUFFER,this.framebuffer)},i.prototype.unbind=function(){var t=this.gl;t.bindFramebuffer(t.FRAMEBUFFER,null)},i.prototype.resize=function(t,e){var r=this.gl;this.width=t,this.height=e,this.texture&&this.texture.uploadData(null,t,e),this.stencil&&(r.bindRenderbuffer(r.RENDERBUFFER,this.stencil),r.renderbufferStorage(r.RENDERBUFFER,r.DEPTH_STENCIL,t,e))},i.prototype.destroy=function(){var t=this.gl;this.texture&&this.texture.destroy(),t.deleteFramebuffer(this.framebuffer),this.gl=null,this.stencil=null,this.texture=null},i.createRGBA=function(t,e,r,o){var s=n.fromData(t,null,e,r);s.enableNearestScaling(),s.enableWrapClamp();var a=new i(t,e,r);return a.enableTexture(s),a.unbind(),a},i.createFloat32=function(t,e,r,o){var s=new n.fromData(t,o,e,r);s.enableNearestScaling(),s.enableWrapClamp();var a=new i(t,e,r);return a.enableTexture(s),a.unbind(),a},e.exports=i},{"./GLTexture":12}],11:[function(t,e,r){var n=t("./shader/compileProgram"),i=t("./shader/extractAttributes"),o=t("./shader/extractUniforms"),s=t("./shader/setPrecision"),a=t("./shader/generateUniformAccessObject"),u=function(t,e,r,u,h){this.gl=t,u&&(e=s(e,u),r=s(r,u)),this.program=n(t,e,r,h),this.attributes=i(t,this.program),this.uniformData=o(t,this.program),this.uniforms=a(t,this.uniformData)};u.prototype.bind=function(){return this.gl.useProgram(this.program),this},u.prototype.destroy=function(){this.attributes=null,this.uniformData=null,this.uniforms=null,this.gl.deleteProgram(this.program)},e.exports=u},{"./shader/compileProgram":17,"./shader/extractAttributes":19,"./shader/extractUniforms":20,"./shader/generateUniformAccessObject":21,"./shader/setPrecision":25}],12:[function(t,e,r){var n=function(t,e,r,n,i){this.gl=t,this.texture=t.createTexture(),this.mipmap=!1,this.premultiplyAlpha=!1,this.width=e||-1,this.height=r||-1,this.format=n||t.RGBA,this.type=i||t.UNSIGNED_BYTE};n.prototype.upload=function(t){this.bind();var e=this.gl;e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,this.premultiplyAlpha);var r=t.videoWidth||t.width,n=t.videoHeight||t.height;n!==this.height||r!==this.width?e.texImage2D(e.TEXTURE_2D,0,this.format,this.format,this.type,t):e.texSubImage2D(e.TEXTURE_2D,0,0,0,this.format,this.type,t),this.width=r,this.height=n};var i=!1;n.prototype.uploadData=function(t,e,r){this.bind();var n=this.gl;if(t instanceof Float32Array){if(!i){if(!n.getExtension("OES_texture_float"))throw new Error("floating point textures not available");i=!0}this.type=n.FLOAT}else this.type=this.type||n.UNSIGNED_BYTE;n.pixelStorei(n.UNPACK_PREMULTIPLY_ALPHA_WEBGL,this.premultiplyAlpha),e!==this.width||r!==this.height?n.texImage2D(n.TEXTURE_2D,0,this.format,e,r,0,this.format,this.type,t||null):n.texSubImage2D(n.TEXTURE_2D,0,0,0,e,r,this.format,this.type,t||null),this.width=e,this.height=r},n.prototype.bind=function(t){var e=this.gl;void 0!==t&&e.activeTexture(e.TEXTURE0+t),e.bindTexture(e.TEXTURE_2D,this.texture)},n.prototype.unbind=function(){var t=this.gl;t.bindTexture(t.TEXTURE_2D,null)},n.prototype.minFilter=function(t){var e=this.gl;this.bind(),this.mipmap?e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,t?e.LINEAR_MIPMAP_LINEAR:e.NEAREST_MIPMAP_NEAREST):e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,t?e.LINEAR:e.NEAREST)},n.prototype.magFilter=function(t){var e=this.gl;this.bind(),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,t?e.LINEAR:e.NEAREST)},n.prototype.enableMipmap=function(){var t=this.gl;this.bind(),this.mipmap=!0,t.generateMipmap(t.TEXTURE_2D)},n.prototype.enableLinearScaling=function(){this.minFilter(!0),this.magFilter(!0)},n.prototype.enableNearestScaling=function(){this.minFilter(!1),this.magFilter(!1)},n.prototype.enableWrapClamp=function(){var t=this.gl;this.bind(),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.CLAMP_TO_EDGE),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.CLAMP_TO_EDGE)},n.prototype.enableWrapRepeat=function(){var t=this.gl;this.bind(),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.REPEAT),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.REPEAT)},n.prototype.enableWrapMirrorRepeat=function(){var t=this.gl;this.bind(),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.MIRRORED_REPEAT),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.MIRRORED_REPEAT)},n.prototype.destroy=function(){this.gl.deleteTexture(this.texture)},n.fromSource=function(t,e,r){var i=new n(t);return i.premultiplyAlpha=r||!1,i.upload(e),i},n.fromData=function(t,e,r,i){var o=new n(t);return o.uploadData(e,r,i),o},e.exports=n},{}],13:[function(t,e,r){function n(t,e){if(this.nativeVaoExtension=null,n.FORCE_NATIVE||(this.nativeVaoExtension=t.getExtension("OES_vertex_array_object")||t.getExtension("MOZ_OES_vertex_array_object")||t.getExtension("WEBKIT_OES_vertex_array_object")),this.nativeState=e,this.nativeVaoExtension){this.nativeVao=this.nativeVaoExtension.createVertexArrayOES();var r=t.getParameter(t.MAX_VERTEX_ATTRIBS);this.nativeState={tempAttribState:new Array(r),attribState:new Array(r)}}this.gl=t,this.attributes=[],this.indexBuffer=null,this.dirty=!1}var i=t("./setVertexAttribArrays");n.prototype.constructor=n,e.exports=n,n.FORCE_NATIVE=!1,n.prototype.bind=function(){if(this.nativeVao){if(this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao),this.dirty)return this.dirty=!1,this.activate(),this;this.indexBuffer&&this.indexBuffer.bind()}else this.activate();return this},n.prototype.unbind=function(){return this.nativeVao&&this.nativeVaoExtension.bindVertexArrayOES(null),this},n.prototype.activate=function(){for(var t=this.gl,e=null,r=0;r<this.attributes.length;r++){var n=this.attributes[r];e!==n.buffer&&(n.buffer.bind(),e=n.buffer),t.vertexAttribPointer(n.attribute.location,n.attribute.size,n.type||t.FLOAT,n.normalized||!1,n.stride||0,n.start||0)}return i(t,this.attributes,this.nativeState),this.indexBuffer&&this.indexBuffer.bind(),this},n.prototype.addAttribute=function(t,e,r,n,i,o){return this.attributes.push({buffer:t,attribute:e,location:e.location,type:r||this.gl.FLOAT,normalized:n||!1,stride:i||0,start:o||0}),this.dirty=!0,this},n.prototype.addIndex=function(t){return this.indexBuffer=t,this.dirty=!0,this},n.prototype.clear=function(){return this.nativeVao&&this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao),this.attributes.length=0,this.indexBuffer=null,this},n.prototype.draw=function(t,e,r){var n=this.gl;return this.indexBuffer?n.drawElements(t,e||this.indexBuffer.data.length,n.UNSIGNED_SHORT,2*(r||0)):n.drawArrays(t,r,e||this.getSize()),this},n.prototype.destroy=function(){this.gl=null,this.indexBuffer=null,this.attributes=null,this.nativeState=null,this.nativeVao&&this.nativeVaoExtension.deleteVertexArrayOES(this.nativeVao),this.nativeVaoExtension=null,this.nativeVao=null},n.prototype.getSize=function(){var t=this.attributes[0];return t.buffer.data.length/(t.stride/4||t.attribute.size)}},{"./setVertexAttribArrays":16}],14:[function(t,e,r){var n=function(t,e){var r=t.getContext("webgl",e)||t.getContext("experimental-webgl",e);if(!r)throw new Error("This browser does not support webGL. Try using the canvas renderer");return r};e.exports=n},{}],15:[function(t,e,r){var n={createContext:t("./createContext"),setVertexAttribArrays:t("./setVertexAttribArrays"),GLBuffer:t("./GLBuffer"),GLFramebuffer:t("./GLFramebuffer"),GLShader:t("./GLShader"),GLTexture:t("./GLTexture"),VertexArrayObject:t("./VertexArrayObject"),shader:t("./shader")};void 0!==e&&e.exports&&(e.exports=n),"undefined"!=typeof window&&(window.PIXI=window.PIXI||{},window.PIXI.glCore=n)},{"./GLBuffer":9,"./GLFramebuffer":10,"./GLShader":11,"./GLTexture":12,"./VertexArrayObject":13,"./createContext":14,"./setVertexAttribArrays":16,"./shader":22}],16:[function(t,e,r){var n=function(t,e,r){var n;if(r){var i=r.tempAttribState,o=r.attribState;for(n=0;n<i.length;n++)i[n]=!1;for(n=0;n<e.length;n++)i[e[n].attribute.location]=!0;for(n=0;n<o.length;n++)o[n]!==i[n]&&(o[n]=i[n],r.attribState[n]?t.enableVertexAttribArray(n):t.disableVertexAttribArray(n))}else for(n=0;n<e.length;n++){var s=e[n];t.enableVertexAttribArray(s.attribute.location)}};e.exports=n},{}],17:[function(t,e,r){var n=function(t,e,r,n){var o=i(t,t.VERTEX_SHADER,e),s=i(t,t.FRAGMENT_SHADER,r),a=t.createProgram();if(t.attachShader(a,o),t.attachShader(a,s),n)for(var u in n)t.bindAttribLocation(a,n[u],u);return t.linkProgram(a),t.getProgramParameter(a,t.LINK_STATUS)||(console.error("Pixi.js Error: Could not initialize shader."),console.error("gl.VALIDATE_STATUS",t.getProgramParameter(a,t.VALIDATE_STATUS)),console.error("gl.getError()",t.getError()),""!==t.getProgramInfoLog(a)&&console.warn("Pixi.js Warning: gl.getProgramInfoLog()",t.getProgramInfoLog(a)),t.deleteProgram(a),a=null),t.deleteShader(o),t.deleteShader(s),a},i=function(t,e,r){var n=t.createShader(e);return t.shaderSource(n,r),t.compileShader(n),t.getShaderParameter(n,t.COMPILE_STATUS)?n:(console.log(t.getShaderInfoLog(n)),null)};e.exports=n},{}],18:[function(t,e,r){var n=function(t,e){switch(t){case"float":return 0;case"vec2":return new Float32Array(2*e);case"vec3":return new Float32Array(3*e);case"vec4":return new Float32Array(4*e);case"int":case"sampler2D":return 0;case"ivec2":return new Int32Array(2*e);case"ivec3":return new Int32Array(3*e);case"ivec4":return new Int32Array(4*e);case"bool":return!1;case"bvec2":return i(2*e);case"bvec3":return i(3*e);case"bvec4":return i(4*e);case"mat2":return new Float32Array([1,0,0,1]);case"mat3":return new Float32Array([1,0,0,0,1,0,0,0,1]);case"mat4":return new Float32Array([1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1])}},i=function(t){for(var e=new Array(t),r=0;r<e.length;r++)e[r]=!1;return e};e.exports=n},{}],19:[function(t,e,r){var n=t("./mapType"),i=t("./mapSize"),o=function(t,e){for(var r={},o=t.getProgramParameter(e,t.ACTIVE_ATTRIBUTES),a=0;a<o;a++){var u=t.getActiveAttrib(e,a),h=n(t,u.type);r[u.name]={type:h,size:i(h),location:t.getAttribLocation(e,u.name),pointer:s}}return r},s=function(t,e,r,n){gl.vertexAttribPointer(this.location,this.size,t||gl.FLOAT,e||!1,r||0,n||0)};e.exports=o},{"./mapSize":23,"./mapType":24}],20:[function(t,e,r){var n=t("./mapType"),i=t("./defaultValue"),o=function(t,e){for(var r={},o=t.getProgramParameter(e,t.ACTIVE_UNIFORMS),s=0;s<o;s++){var a=t.getActiveUniform(e,s),u=a.name.replace(/\[.*?\]/,""),h=n(t,a.type);r[u]={type:h,size:a.size,location:t.getUniformLocation(e,u),value:i(h,a.size)}}return r};e.exports=o},{"./defaultValue":18,"./mapType":24}],21:[function(t,e,r){function n(t,e){return function(r){this.data[t].value=r;var n=this.data[t].location;1===e.size?a[e.type](this.gl,n,r):u[e.type](this.gl,n,r)}}function i(t,e){for(var r=e,n=0;n<t.length-1;n++){var i=r[t[n]]||{data:{}};r[t[n]]=i,r=i}return r}var o=function(t,e){var r={data:{}};r.gl=t
;for(var o=Object.keys(e),a=0;a<o.length;a++){var u=o[a],h=u.split("."),l=h[h.length-1],c=i(h,r),d=e[u];c.data[l]=d,c.gl=t,Object.defineProperty(c,l,{get:s(l),set:n(l,d)})}return r},s=function(t){return function(){return this.data[t].value}},a={float:function(t,e,r){t.uniform1f(e,r)},vec2:function(t,e,r){t.uniform2f(e,r[0],r[1])},vec3:function(t,e,r){t.uniform3f(e,r[0],r[1],r[2])},vec4:function(t,e,r){t.uniform4f(e,r[0],r[1],r[2],r[3])},int:function(t,e,r){t.uniform1i(e,r)},ivec2:function(t,e,r){t.uniform2i(e,r[0],r[1])},ivec3:function(t,e,r){t.uniform3i(e,r[0],r[1],r[2])},ivec4:function(t,e,r){t.uniform4i(e,r[0],r[1],r[2],r[3])},bool:function(t,e,r){t.uniform1i(e,r)},bvec2:function(t,e,r){t.uniform2i(e,r[0],r[1])},bvec3:function(t,e,r){t.uniform3i(e,r[0],r[1],r[2])},bvec4:function(t,e,r){t.uniform4i(e,r[0],r[1],r[2],r[3])},mat2:function(t,e,r){t.uniformMatrix2fv(e,!1,r)},mat3:function(t,e,r){t.uniformMatrix3fv(e,!1,r)},mat4:function(t,e,r){t.uniformMatrix4fv(e,!1,r)},sampler2D:function(t,e,r){t.uniform1i(e,r)}},u={float:function(t,e,r){t.uniform1fv(e,r)},vec2:function(t,e,r){t.uniform2fv(e,r)},vec3:function(t,e,r){t.uniform3fv(e,r)},vec4:function(t,e,r){t.uniform4fv(e,r)},int:function(t,e,r){t.uniform1iv(e,r)},ivec2:function(t,e,r){t.uniform2iv(e,r)},ivec3:function(t,e,r){t.uniform3iv(e,r)},ivec4:function(t,e,r){t.uniform4iv(e,r)},bool:function(t,e,r){t.uniform1iv(e,r)},bvec2:function(t,e,r){t.uniform2iv(e,r)},bvec3:function(t,e,r){t.uniform3iv(e,r)},bvec4:function(t,e,r){t.uniform4iv(e,r)},sampler2D:function(t,e,r){t.uniform1iv(e,r)}};e.exports=o},{}],22:[function(t,e,r){e.exports={compileProgram:t("./compileProgram"),defaultValue:t("./defaultValue"),extractAttributes:t("./extractAttributes"),extractUniforms:t("./extractUniforms"),generateUniformAccessObject:t("./generateUniformAccessObject"),setPrecision:t("./setPrecision"),mapSize:t("./mapSize"),mapType:t("./mapType")}},{"./compileProgram":17,"./defaultValue":18,"./extractAttributes":19,"./extractUniforms":20,"./generateUniformAccessObject":21,"./mapSize":23,"./mapType":24,"./setPrecision":25}],23:[function(t,e,r){var n=function(t){return i[t]},i={float:1,vec2:2,vec3:3,vec4:4,int:1,ivec2:2,ivec3:3,ivec4:4,bool:1,bvec2:2,bvec3:3,bvec4:4,mat2:4,mat3:9,mat4:16,sampler2D:1};e.exports=n},{}],24:[function(t,e,r){var n=function(t,e){if(!i){var r=Object.keys(o);i={};for(var n=0;n<r.length;++n){var s=r[n];i[t[s]]=o[s]}}return i[e]},i=null,o={FLOAT:"float",FLOAT_VEC2:"vec2",FLOAT_VEC3:"vec3",FLOAT_VEC4:"vec4",INT:"int",INT_VEC2:"ivec2",INT_VEC3:"ivec3",INT_VEC4:"ivec4",BOOL:"bool",BOOL_VEC2:"bvec2",BOOL_VEC3:"bvec3",BOOL_VEC4:"bvec4",FLOAT_MAT2:"mat2",FLOAT_MAT3:"mat3",FLOAT_MAT4:"mat4",SAMPLER_2D:"sampler2D"};e.exports=n},{}],25:[function(t,e,r){var n=function(t,e){return"precision"!==t.substring(0,9)?"precision "+e+" float;\n"+t:t};e.exports=n},{}],26:[function(t,e,r){function n(){throw new Error("setTimeout has not been defined")}function i(){throw new Error("clearTimeout has not been defined")}function o(t){if(c===setTimeout)return setTimeout(t,0);if((c===n||!c)&&setTimeout)return c=setTimeout,setTimeout(t,0);try{return c(t,0)}catch(e){try{return c.call(null,t,0)}catch(e){return c.call(this,t,0)}}}function s(t){if(d===clearTimeout)return clearTimeout(t);if((d===i||!d)&&clearTimeout)return d=clearTimeout,clearTimeout(t);try{return d(t)}catch(e){try{return d.call(null,t)}catch(e){return d.call(this,t)}}}function a(){g&&p&&(g=!1,p.length?v=p.concat(v):y=-1,v.length&&u())}function u(){if(!g){var t=o(a);g=!0;for(var e=v.length;e;){for(p=v,v=[];++y<e;)p&&p[y].run();y=-1,e=v.length}p=null,g=!1,s(t)}}function h(t,e){this.fun=t,this.array=e}function l(){}var c,d,f=e.exports={};!function(){try{c="function"==typeof setTimeout?setTimeout:n}catch(t){c=n}try{d="function"==typeof clearTimeout?clearTimeout:i}catch(t){d=i}}();var p,v=[],g=!1,y=-1;f.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)e[r-1]=arguments[r];v.push(new h(t,e)),1!==v.length||g||o(u)},h.prototype.run=function(){this.fun.apply(null,this.array)},f.title="browser",f.browser=!0,f.env={},f.argv=[],f.version="",f.versions={},f.on=l,f.addListener=l,f.once=l,f.off=l,f.removeListener=l,f.removeAllListeners=l,f.emit=l,f.prependListener=l,f.prependOnceListener=l,f.listeners=function(t){return[]},f.binding=function(t){throw new Error("process.binding is not supported")},f.cwd=function(){return"/"},f.chdir=function(t){throw new Error("process.chdir is not supported")},f.umask=function(){return 0}},{}],27:[function(e,r,n){(function(e){!function(i){function o(t){throw new RangeError(L[t])}function s(t,e){for(var r=t.length,n=[];r--;)n[r]=e(t[r]);return n}function a(t,e){var r=t.split("@"),n="";return r.length>1&&(n=r[0]+"@",t=r[1]),t=t.replace(D,"."),n+s(t.split("."),e).join(".")}function u(t){for(var e,r,n=[],i=0,o=t.length;i<o;)e=t.charCodeAt(i++),e>=55296&&e<=56319&&i<o?(r=t.charCodeAt(i++),56320==(64512&r)?n.push(((1023&e)<<10)+(1023&r)+65536):(n.push(e),i--)):n.push(e);return n}function h(t){return s(t,function(t){var e="";return t>65535&&(t-=65536,e+=k(t>>>10&1023|55296),t=56320|1023&t),e+=k(t)}).join("")}function l(t){return t-48<10?t-22:t-65<26?t-65:t-97<26?t-97:w}function c(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function d(t,e,r){var n=0;for(t=r?B(t/M):t>>1,t+=B(t/e);t>N*S>>1;n+=w)t=B(t/N);return B(n+(N+1)*t/(t+O))}function f(t){var e,r,n,i,s,a,u,c,f,p,v=[],g=t.length,y=0,m=C,_=P;for(r=t.lastIndexOf(R),r<0&&(r=0),n=0;n<r;++n)t.charCodeAt(n)>=128&&o("not-basic"),v.push(t.charCodeAt(n));for(i=r>0?r+1:0;i<g;){for(s=y,a=1,u=w;i>=g&&o("invalid-input"),c=l(t.charCodeAt(i++)),(c>=w||c>B((T-y)/a))&&o("overflow"),y+=c*a,f=u<=_?E:u>=_+S?S:u-_,!(c<f);u+=w)p=w-f,a>B(T/p)&&o("overflow"),a*=p;e=v.length+1,_=d(y-s,e,0==s),B(y/e)>T-m&&o("overflow"),m+=B(y/e),y%=e,v.splice(y++,0,m)}return h(v)}function p(t){var e,r,n,i,s,a,h,l,f,p,v,g,y,m,_,b=[];for(t=u(t),g=t.length,e=C,r=0,s=P,a=0;a<g;++a)(v=t[a])<128&&b.push(k(v));for(n=i=b.length,i&&b.push(R);n<g;){for(h=T,a=0;a<g;++a)(v=t[a])>=e&&v<h&&(h=v);for(y=n+1,h-e>B((T-r)/y)&&o("overflow"),r+=(h-e)*y,e=h,a=0;a<g;++a)if(v=t[a],v<e&&++r>T&&o("overflow"),v==e){for(l=r,f=w;p=f<=s?E:f>=s+S?S:f-s,!(l<p);f+=w)_=l-p,m=w-p,b.push(k(c(p+_%m,0))),l=B(_/m);b.push(k(c(l,0))),s=d(r,y,n==i),r=0,++n}++r,++e}return b.join("")}function v(t){return a(t,function(t){return A.test(t)?f(t.slice(4).toLowerCase()):t})}function g(t){return a(t,function(t){return I.test(t)?"xn--"+p(t):t})}var y="object"==typeof n&&n&&!n.nodeType&&n,m="object"==typeof r&&r&&!r.nodeType&&r,_="object"==typeof e&&e;_.global!==_&&_.window!==_&&_.self!==_||(i=_);var b,x,T=2147483647,w=36,E=1,S=26,O=38,M=700,P=72,C=128,R="-",A=/^xn--/,I=/[^\x20-\x7E]/,D=/[\x2E\u3002\uFF0E\uFF61]/g,L={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},N=w-E,B=Math.floor,k=String.fromCharCode;if(b={version:"1.4.1",ucs2:{decode:u,encode:h},decode:f,encode:p,toASCII:g,toUnicode:v},"function"==typeof t&&"object"==typeof t.amd&&t.amd)t("punycode",function(){return b});else if(y&&m)if(r.exports==y)m.exports=b;else for(x in b)b.hasOwnProperty(x)&&(y[x]=b[x]);else i.punycode=b}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],28:[function(t,e,r){"use strict";function n(t,e){return Object.prototype.hasOwnProperty.call(t,e)}e.exports=function(t,e,r,o){e=e||"&",r=r||"=";var s={};if("string"!=typeof t||0===t.length)return s;var a=/\+/g;t=t.split(e);var u=1e3;o&&"number"==typeof o.maxKeys&&(u=o.maxKeys);var h=t.length;u>0&&h>u&&(h=u);for(var l=0;l<h;++l){var c,d,f,p,v=t[l].replace(a,"%20"),g=v.indexOf(r);g>=0?(c=v.substr(0,g),d=v.substr(g+1)):(c=v,d=""),f=decodeURIComponent(c),p=decodeURIComponent(d),n(s,f)?i(s[f])?s[f].push(p):s[f]=[s[f],p]:s[f]=p}return s};var i=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)}},{}],29:[function(t,e,r){"use strict";function n(t,e){if(t.map)return t.map(e);for(var r=[],n=0;n<t.length;n++)r.push(e(t[n],n));return r}var i=function(t){switch(typeof t){case"string":return t;case"boolean":return t?"true":"false";case"number":return isFinite(t)?t:"";default:return""}};e.exports=function(t,e,r,a){return e=e||"&",r=r||"=",null===t&&(t=void 0),"object"==typeof t?n(s(t),function(s){var a=encodeURIComponent(i(s))+r;return o(t[s])?n(t[s],function(t){return a+encodeURIComponent(i(t))}).join(e):a+encodeURIComponent(i(t[s]))}).join(e):a?encodeURIComponent(i(a))+r+encodeURIComponent(i(t)):""};var o=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)},s=Object.keys||function(t){var e=[];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.push(r);return e}},{}],30:[function(t,e,r){"use strict";r.decode=r.parse=t("./decode"),r.encode=r.stringify=t("./encode")},{"./decode":28,"./encode":29}],31:[function(t,e,r){"use strict";e.exports=function(t,e,r){var n,i=t.length;if(!(e>=i||0===r)){r=e+r>i?i-e:r;var o=i-r;for(n=e;n<o;++n)t[n]=t[n+r];t.length=o}}},{}],32:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0,r.Loader=void 0;var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("mini-signals"),u=n(a),h=t("parse-uri"),l=n(h),c=t("./async"),d=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(c),f=t("./Resource"),p=/(#[\w-]+)?$/,v=r.Loader=function(){function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:10;i(this,t),this.baseUrl=r,this.progress=0,this.loading=!1,this.defaultQueryString="",this._beforeMiddleware=[],this._afterMiddleware=[],this._resourcesParsing=[],this._boundLoadResource=function(t,r){return e._loadResource(t,r)},this._queue=d.queue(this._boundLoadResource,n),this._queue.pause(),this.resources={},this.onProgress=new u.default,this.onError=new u.default,this.onLoad=new u.default,this.onStart=new u.default,this.onComplete=new u.default;for(var o=0;o<t._defaultBeforeMiddleware.length;++o)this.pre(t._defaultBeforeMiddleware[o]);for(var s=0;s<t._defaultAfterMiddleware.length;++s)this.use(t._defaultAfterMiddleware[s])}return t.prototype.add=function(t,e,r,n){if(Array.isArray(t)){for(var i=0;i<t.length;++i)this.add(t[i]);return this}if("object"===(void 0===t?"undefined":o(t))&&(n=e||t.callback||t.onComplete,r=t,e=t.url,t=t.name||t.key||t.url),"string"!=typeof e&&(n=r,r=e,e=t),"string"!=typeof e)throw new Error("No url passed to add resource to loader.");if("function"==typeof r&&(n=r,r=null),this.loading&&(!r||!r.parentResource))throw new Error("Cannot add resources while the loader is running.");if(this.resources[t])throw new Error('Resource named "'+t+'" already exists.');if(e=this._prepareUrl(e),this.resources[t]=new f.Resource(t,e,r),"function"==typeof n&&this.resources[t].onAfterMiddleware.once(n),this.loading){for(var s=r.parentResource,a=[],u=0;u<s.children.length;++u)s.children[u].isComplete||a.push(s.children[u]);var h=s.progressChunk*(a.length+1),l=h/(a.length+2);s.children.push(this.resources[t]),s.progressChunk=l;for(var c=0;c<a.length;++c)a[c].progressChunk=l;this.resources[t].progressChunk=l}return this._queue.push(this.resources[t]),this},t.prototype.pre=function(t){return this._beforeMiddleware.push(t),this},t.prototype.use=function(t){return this._afterMiddleware.push(t),this},t.prototype.reset=function(){this.progress=0,this.loading=!1,this._queue.kill(),this._queue.pause();for(var t in this.resources){var e=this.resources[t];e._onLoadBinding&&e._onLoadBinding.detach(),e.isLoading&&e.abort()}return this.resources={},this},t.prototype.load=function(t){if("function"==typeof t&&this.onComplete.once(t),this.loading)return this;if(this._queue.idle())this._onStart(),this._onComplete();else{for(var e=this._queue._tasks.length,r=100/e,n=0;n<this._queue._tasks.length;++n)this._queue._tasks[n].data.progressChunk=r;this._onStart(),this._queue.resume()}return this},t.prototype._prepareUrl=function(t){var e=(0,l.default)(t,{strictMode:!0}),r=void 0;if(r=e.protocol||!e.path||0===t.indexOf("//")?t:this.baseUrl.length&&this.baseUrl.lastIndexOf("/")!==this.baseUrl.length-1&&"/"!==t.charAt(0)?this.baseUrl+"/"+t:this.baseUrl+t,this.defaultQueryString){var n=p.exec(r)[0];r=r.substr(0,r.length-n.length),-1!==r.indexOf("?")?r+="&"+this.defaultQueryString:r+="?"+this.defaultQueryString,r+=n}return r},t.prototype._loadResource=function(t,e){var r=this;t._dequeue=e,d.eachSeries(this._beforeMiddleware,function(e,n){e.call(r,t,function(){n(t.isComplete?{}:null)})},function(){t.isComplete?r._onLoad(t):(t._onLoadBinding=t.onComplete.once(r._onLoad,r),t.load())},!0)},t.prototype._onStart=function(){this.progress=0,this.loading=!0,this.onStart.dispatch(this)},t.prototype._onComplete=function(){this.progress=100,this.loading=!1,this.onComplete.dispatch(this,this.resources)},t.prototype._onLoad=function(t){var e=this;t._onLoadBinding=null,this._resourcesParsing.push(t),t._dequeue(),d.eachSeries(this._afterMiddleware,function(r,n){r.call(e,t,n)},function(){t.onAfterMiddleware.dispatch(t),e.progress=Math.min(100,e.progress+t.progressChunk),e.onProgress.dispatch(e,t),t.error?e.onError.dispatch(t.error,e,t):e.onLoad.dispatch(e,t),e._resourcesParsing.splice(e._resourcesParsing.indexOf(t),1),e._queue.idle()&&0===e._resourcesParsing.length&&e._onComplete()},!0)},s(t,[{key:"concurrency",get:function(){return this._queue.concurrency},set:function(t){this._queue.concurrency=t}}]),t}();v._defaultBeforeMiddleware=[],v._defaultAfterMiddleware=[],v.pre=function(t){return v._defaultBeforeMiddleware.push(t),v},v.use=function(t){return v._defaultAfterMiddleware.push(t),v}},{"./Resource":33,"./async":34,"mini-signals":5,"parse-uri":7}],33:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(){}function s(t,e,r){e&&0===e.indexOf(".")&&(e=e.substring(1)),e&&(t[e]=r)}function a(t){return t.toString().replace("object ","")}r.__esModule=!0,r.Resource=void 0;var u=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),h=t("parse-uri"),l=n(h),c=t("mini-signals"),d=n(c),f=!(!window.XDomainRequest||"withCredentials"in new XMLHttpRequest),p=null,v=r.Resource=function(){function t(e,r,n){if(i(this,t),"string"!=typeof e||"string"!=typeof r)throw new Error("Both name and url are required for constructing a resource.");n=n||{},this._flags=0,this._setFlag(t.STATUS_FLAGS.DATA_URL,0===r.indexOf("data:")),this.name=e,this.url=r,this.extension=this._getExtension(),this.data=null,this.crossOrigin=!0===n.crossOrigin?"anonymous":n.crossOrigin,this.timeout=n.timeout||0,this.loadType=n.loadType||this._determineLoadType(),this.xhrType=n.xhrType,this.metadata=n.metadata||{},this.error=null,this.xhr=null,this.children=[],this.type=t.TYPE.UNKNOWN,this.progressChunk=0,this._dequeue=o,this._onLoadBinding=null,this._elementTimer=0,this._boundComplete=this.complete.bind(this),this._boundOnError=this._onError.bind(this),this._boundOnProgress=this._onProgress.bind(this),this._boundOnTimeout=this._onTimeout.bind(this),this._boundXhrOnError=this._xhrOnError.bind(this),this._boundXhrOnTimeout=this._xhrOnTimeout.bind(this),this._boundXhrOnAbort=this._xhrOnAbort.bind(this),this._boundXhrOnLoad=this._xhrOnLoad.bind(this),this.onStart=new d.default,this.onProgress=new d.default,this.onComplete=new d.default,this.onAfterMiddleware=new d.default}return t.setExtensionLoadType=function(e,r){s(t._loadTypeMap,e,r)},t.setExtensionXhrType=function(e,r){s(t._xhrTypeMap,e,r)},t.prototype.complete=function(){this._clearEvents(),this._finish()},t.prototype.abort=function(e){if(!this.error){if(this.error=new Error(e),this._clearEvents(),this.xhr)this.xhr.abort();else if(this.xdr)this.xdr.abort();else if(this.data)if(this.data.src)this.data.src=t.EMPTY_GIF;else for(;this.data.firstChild;)this.data.removeChild(this.data.firstChild);this._finish()}},t.prototype.load=function(e){var r=this;if(!this.isLoading){if(this.isComplete)return void(e&&setTimeout(function(){return e(r)},1));switch(e&&this.onComplete.once(e),this._setFlag(t.STATUS_FLAGS.LOADING,!0),this.onStart.dispatch(this),!1!==this.crossOrigin&&"string"==typeof this.crossOrigin||(this.crossOrigin=this._determineCrossOrigin(this.url)),this.loadType){case t.LOAD_TYPE.IMAGE:this.type=t.TYPE.IMAGE,this._loadElement("image");break;case t.LOAD_TYPE.AUDIO:this.type=t.TYPE.AUDIO,this._loadSourceElement("audio");break;case t.LOAD_TYPE.VIDEO:this.type=t.TYPE.VIDEO,this._loadSourceElement("video");break;case t.LOAD_TYPE.XHR:default:f&&this.crossOrigin?this._loadXdr():this._loadXhr()}}},t.prototype._hasFlag=function(t){return 0!=(this._flags&t)},t.prototype._setFlag=function(t,e){this._flags=e?this._flags|t:this._flags&~t},t.prototype._clearEvents=function(){clearTimeout(this._elementTimer),this.data&&this.data.removeEventListener&&(this.data.removeEventListener("error",this._boundOnError,!1),this.data.removeEventListener("load",this._boundComplete,!1),this.data.removeEventListener("progress",this._boundOnProgress,!1),this.data.removeEventListener("canplaythrough",this._boundComplete,!1)),this.xhr&&(this.xhr.removeEventListener?(this.xhr.removeEventListener("error",this._boundXhrOnError,!1),this.xhr.removeEventListener("timeout",this._boundXhrOnTimeout,!1),this.xhr.removeEventListener("abort",this._boundXhrOnAbort,!1),this.xhr.removeEventListener("progress",this._boundOnProgress,!1),this.xhr.removeEventListener("load",this._boundXhrOnLoad,!1)):(this.xhr.onerror=null,this.xhr.ontimeout=null,this.xhr.onprogress=null,this.xhr.onload=null))},t.prototype._finish=function(){if(this.isComplete)throw new Error("Complete called again for an already completed resource.");this._setFlag(t.STATUS_FLAGS.COMPLETE,!0),this._setFlag(t.STATUS_FLAGS.LOADING,!1),this.onComplete.dispatch(this)},t.prototype._loadElement=function(t){this.metadata.loadElement?this.data=this.metadata.loadElement:"image"===t&&void 0!==window.Image?this.data=new Image:this.data=document.createElement(t),this.crossOrigin&&(this.data.crossOrigin=this.crossOrigin),this.metadata.skipSource||(this.data.src=this.url),this.data.addEventListener("error",this._boundOnError,!1),this.data.addEventListener("load",this._boundComplete,!1),this.data.addEventListener("progress",this._boundOnProgress,!1),this.timeout&&(this._elementTimer=setTimeout(this._boundOnTimeout,this.timeout))},t.prototype._loadSourceElement=function(t){if(this.metadata.loadElement?this.data=this.metadata.loadElement:"audio"===t&&void 0!==window.Audio?this.data=new Audio:this.data=document.createElement(t),null===this.data)return void this.abort("Unsupported element: "+t);if(this.crossOrigin&&(this.data.crossOrigin=this.crossOrigin),!this.metadata.skipSource)if(navigator.isCocoonJS)this.data.src=Array.isArray(this.url)?this.url[0]:this.url;else if(Array.isArray(this.url))for(var e=this.metadata.mimeType,r=0;r<this.url.length;++r)this.data.appendChild(this._createSource(t,this.url[r],Array.isArray(e)?e[r]:e));else{var n=this.metadata.mimeType;this.data.appendChild(this._createSource(t,this.url,Array.isArray(n)?n[0]:n))}this.data.addEventListener("error",this._boundOnError,!1),this.data.addEventListener("load",this._boundComplete,!1),this.data.addEventListener("progress",this._boundOnProgress,!1),this.data.addEventListener("canplaythrough",this._boundComplete,!1),this.data.load(),this.timeout&&(this._elementTimer=setTimeout(this._boundOnTimeout,this.timeout))},t.prototype._loadXhr=function(){"string"!=typeof this.xhrType&&(this.xhrType=this._determineXhrType());var e=this.xhr=new XMLHttpRequest;e.open("GET",this.url,!0),e.timeout=this.timeout,this.xhrType===t.XHR_RESPONSE_TYPE.JSON||this.xhrType===t.XHR_RESPONSE_TYPE.DOCUMENT?e.responseType=t.XHR_RESPONSE_TYPE.TEXT:e.responseType=this.xhrType,e.addEventListener("error",this._boundXhrOnError,!1),e.addEventListener("timeout",this._boundXhrOnTimeout,!1),e.addEventListener("abort",this._boundXhrOnAbort,!1),e.addEventListener("progress",this._boundOnProgress,!1),e.addEventListener("load",this._boundXhrOnLoad,!1),e.send()},t.prototype._loadXdr=function(){"string"!=typeof this.xhrType&&(this.xhrType=this._determineXhrType());var t=this.xhr=new XDomainRequest;t.timeout=this.timeout||5e3,t.onerror=this._boundXhrOnError,t.ontimeout=this._boundXhrOnTimeout,t.onprogress=this._boundOnProgress,t.onload=this._boundXhrOnLoad,t.open("GET",this.url,!0),setTimeout(function(){return t.send()},1)},t.prototype._createSource=function(t,e,r){r||(r=t+"/"+this._getExtension(e));var n=document.createElement("source");return n.src=e,n.type=r,n},t.prototype._onError=function(t){this.abort("Failed to load element using: "+t.target.nodeName)},t.prototype._onProgress=function(t){t&&t.lengthComputable&&this.onProgress.dispatch(this,t.loaded/t.total)},t.prototype._onTimeout=function(){this.abort("Load timed out.")},t.prototype._xhrOnError=function(){var t=this.xhr;this.abort(a(t)+" Request failed. Status: "+t.status+', text: "'+t.statusText+'"')},t.prototype._xhrOnTimeout=function(){var t=this.xhr;this.abort(a(t)+" Request timed out.")},t.prototype._xhrOnAbort=function(){var t=this.xhr;this.abort(a(t)+" Request was aborted by the user.")},t.prototype._xhrOnLoad=function(){var e=this.xhr,r="",n=void 0===e.status?200:e.status;if(""!==e.responseType&&"text"!==e.responseType&&void 0!==e.responseType||(r=e.responseText),0===n&&(r.length>0||e.responseType===t.XHR_RESPONSE_TYPE.BUFFER)?n=200:1223===n&&(n=204),2!=(n/100|0))return void this.abort("["+e.status+"] "+e.statusText+": "+e.responseURL);if(this.xhrType===t.XHR_RESPONSE_TYPE.TEXT)this.data=r,this.type=t.TYPE.TEXT;else if(this.xhrType===t.XHR_RESPONSE_TYPE.JSON)try{this.data=JSON.parse(r),this.type=t.TYPE.JSON}catch(t){return void this.abort("Error trying to parse loaded json: "+t)}else if(this.xhrType===t.XHR_RESPONSE_TYPE.DOCUMENT)try{if(window.DOMParser){var i=new DOMParser;this.data=i.parseFromString(r,"text/xml")}else{var o=document.createElement("div");o.innerHTML=r,this.data=o}this.type=t.TYPE.XML}catch(t){return void this.abort("Error trying to parse loaded xml: "+t)}else this.data=e.response||r;this.complete()},t.prototype._determineCrossOrigin=function(t,e){if(0===t.indexOf("data:"))return"";if(window.origin!==window.location.origin)return"anonymous";e=e||window.location,p||(p=document.createElement("a")),p.href=t,t=(0,l.default)(p.href,{strictMode:!0});var r=!t.port&&""===e.port||t.port===e.port,n=t.protocol?t.protocol+":":"";return t.host===e.hostname&&r&&n===e.protocol?"":"anonymous"},t.prototype._determineXhrType=function(){return t._xhrTypeMap[this.extension]||t.XHR_RESPONSE_TYPE.TEXT},t.prototype._determineLoadType=function(){return t._loadTypeMap[this.extension]||t.LOAD_TYPE.XHR},t.prototype._getExtension=function(){var t=this.url,e="";if(this.isDataUrl){var r=t.indexOf("/");e=t.substring(r+1,t.indexOf(";",r))}else{var n=t.indexOf("?"),i=t.indexOf("#"),o=Math.min(n>-1?n:t.length,i>-1?i:t.length);t=t.substring(0,o),e=t.substring(t.lastIndexOf(".")+1)}return e.toLowerCase()},t.prototype._getMimeFromXhrType=function(e){switch(e){case t.XHR_RESPONSE_TYPE.BUFFER:return"application/octet-binary";case t.XHR_RESPONSE_TYPE.BLOB:return"application/blob";case t.XHR_RESPONSE_TYPE.DOCUMENT:return"application/xml";case t.XHR_RESPONSE_TYPE.JSON:return"application/json";case t.XHR_RESPONSE_TYPE.DEFAULT:case t.XHR_RESPONSE_TYPE.TEXT:default:return"text/plain"}},u(t,[{key:"isDataUrl",get:function(){return this._hasFlag(t.STATUS_FLAGS.DATA_URL)}},{key:"isComplete",get:function(){return this._hasFlag(t.STATUS_FLAGS.COMPLETE)}},{key:"isLoading",get:function(){return this._hasFlag(t.STATUS_FLAGS.LOADING)}}]),t}();v.STATUS_FLAGS={NONE:0,DATA_URL:1,COMPLETE:2,LOADING:4},v.TYPE={UNKNOWN:0,JSON:1,XML:2,IMAGE:3,AUDIO:4,VIDEO:5,TEXT:6},v.LOAD_TYPE={XHR:1,IMAGE:2,AUDIO:3,VIDEO:4},v.XHR_RESPONSE_TYPE={DEFAULT:"text",BUFFER:"arraybuffer",BLOB:"blob",DOCUMENT:"document",JSON:"json",TEXT:"text"},v._loadTypeMap={gif:v.LOAD_TYPE.IMAGE,png:v.LOAD_TYPE.IMAGE,bmp:v.LOAD_TYPE.IMAGE,jpg:v.LOAD_TYPE.IMAGE,jpeg:v.LOAD_TYPE.IMAGE,tif:v.LOAD_TYPE.IMAGE,tiff:v.LOAD_TYPE.IMAGE,webp:v.LOAD_TYPE.IMAGE,tga:v.LOAD_TYPE.IMAGE,svg:v.LOAD_TYPE.IMAGE,"svg+xml":v.LOAD_TYPE.IMAGE,mp3:v.LOAD_TYPE.AUDIO,ogg:v.LOAD_TYPE.AUDIO,wav:v.LOAD_TYPE.AUDIO,mp4:v.LOAD_TYPE.VIDEO,webm:v.LOAD_TYPE.VIDEO},v._xhrTypeMap={xhtml:v.XHR_RESPONSE_TYPE.DOCUMENT,html:v.XHR_RESPONSE_TYPE.DOCUMENT,htm:v.XHR_RESPONSE_TYPE.DOCUMENT,xml:v.XHR_RESPONSE_TYPE.DOCUMENT,tmx:v.XHR_RESPONSE_TYPE.DOCUMENT,svg:v.XHR_RESPONSE_TYPE.DOCUMENT,tsx:v.XHR_RESPONSE_TYPE.DOCUMENT,gif:v.XHR_RESPONSE_TYPE.BLOB,png:v.XHR_RESPONSE_TYPE.BLOB,bmp:v.XHR_RESPONSE_TYPE.BLOB,jpg:v.XHR_RESPONSE_TYPE.BLOB,jpeg:v.XHR_RESPONSE_TYPE.BLOB,tif:v.XHR_RESPONSE_TYPE.BLOB,tiff:v.XHR_RESPONSE_TYPE.BLOB,webp:v.XHR_RESPONSE_TYPE.BLOB,tga:v.XHR_RESPONSE_TYPE.BLOB,json:v.XHR_RESPONSE_TYPE.JSON,text:v.XHR_RESPONSE_TYPE.TEXT,txt:v.XHR_RESPONSE_TYPE.TEXT,ttf:v.XHR_RESPONSE_TYPE.BUFFER,otf:v.XHR_RESPONSE_TYPE.BUFFER},v.EMPTY_GIF="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",void 0!==e&&(e.exports.default=v)},{"mini-signals":5,"parse-uri":7}],34:[function(t,e,r){"use strict";function n(){}function i(t,e,r,n){var i=0,o=t.length;!function s(a){if(a||i===o)return void(r&&r(a));n?setTimeout(function(){e(t[i++],s)},1):e(t[i++],s)}()}function o(t){return function(){if(null===t)throw new Error("Callback was already called.");var e=t;t=null,e.apply(this,arguments)}}function s(t,e){function r(t,e,r){if(null!=r&&"function"!=typeof r)throw new Error("task callback must be a function");if(a.started=!0,null==t&&a.idle())return void setTimeout(function(){return a.drain()},1);var i={data:t,callback:"function"==typeof r?r:n};e?a._tasks.unshift(i):a._tasks.push(i),setTimeout(function(){return a.process()},1)}function i(t){return function(){s-=1,t.callback.apply(t,arguments),null!=arguments[0]&&a.error(arguments[0],t.data),s<=a.concurrency-a.buffer&&a.unsaturated(),a.idle()&&a.drain(),a.process()}}if(null==e)e=1;else if(0===e)throw new Error("Concurrency must not be zero");var s=0,a={_tasks:[],concurrency:e,saturated:n,unsaturated:n,buffer:e/4,empty:n,drain:n,error:n,started:!1,paused:!1,push:function(t,e){r(t,!1,e)},kill:function(){s=0,a.drain=n,a.started=!1,a._tasks=[]},unshift:function(t,e){r(t,!0,e)},process:function(){for(;!a.paused&&s<a.concurrency&&a._tasks.length;){var e=a._tasks.shift();0===a._tasks.length&&a.empty(),s+=1,s===a.concurrency&&a.saturated(),t(e.data,o(i(e)))}},length:function(){return a._tasks.length},running:function(){return s},idle:function(){return a._tasks.length+s===0},pause:function(){!0!==a.paused&&(a.paused=!0)},resume:function(){if(!1!==a.paused){a.paused=!1;for(var t=1;t<=a.concurrency;t++)a.process()}}};return a}r.__esModule=!0,r.eachSeries=i,r.queue=s},{}],35:[function(t,e,r){"use strict";function n(t){for(var e="",r=0;r<t.length;){for(var n=[0,0,0],o=[0,0,0,0],s=0;s<n.length;++s)r<t.length?n[s]=255&t.charCodeAt(r++):n[s]=0;o[0]=n[0]>>2,o[1]=(3&n[0])<<4|n[1]>>4,o[2]=(15&n[1])<<2|n[2]>>6,o[3]=63&n[2];switch(r-(t.length-1)){case 2:o[3]=64,o[2]=64;break;case 1:o[3]=64}for(var a=0;a<o.length;++a)e+=i.charAt(o[a])}return e}r.__esModule=!0,r.encodeBinary=n;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0!==e&&(e.exports.default=n)},{}],36:[function(t,e,r){"use strict";var n=t("./Loader").Loader,i=t("./Resource").Resource,o=t("./async"),s=t("./b64");n.Resource=i,n.async=o,n.encodeBinary=s,n.base64=s,e.exports=n,e.exports.Loader=n,e.exports.default=n},{"./Loader":32,"./Resource":33,"./async":34,"./b64":35}],37:[function(t,e,r){"use strict";function n(){return function(t,e){if(!t.data)return void e();if(t.xhr&&t.xhrType===i.Resource.XHR_RESPONSE_TYPE.BLOB)if(window.Blob&&"string"!=typeof t.data){if(0===t.data.type.indexOf("image")){var r=s.createObjectURL(t.data);return t.blob=t.data,t.data=new Image,t.data.src=r,t.type=i.Resource.TYPE.IMAGE,void(t.data.onload=function(){s.revokeObjectURL(r),t.data.onload=null,e()})}}else{var n=t.xhr.getResponseHeader("content-type");if(n&&0===n.indexOf("image"))return t.data=new Image,t.data.src="data:"+n+";base64,"+(0,o.encodeBinary)(t.xhr.responseText),t.type=i.Resource.TYPE.IMAGE,void(t.data.onload=function(){t.data.onload=null,e()})}e()}}r.__esModule=!0,r.blobMiddlewareFactory=n;var i=t("../../Resource"),o=t("../../b64"),s=window.URL||window.webkitURL},{"../../Resource":33,"../../b64":35}],38:[function(t,e,r){"use strict";function n(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}function i(t,e,r){if(t&&h.isObject(t)&&t instanceof n)return t;var i=new n;return i.parse(t,e,r),i}function o(t){return h.isString(t)&&(t=i(t)),t instanceof n?t.format():n.prototype.format.call(t)}function s(t,e){return i(t,!1,!0).resolve(e)}function a(t,e){return t?i(t,!1,!0).resolveObject(e):e}var u=t("punycode"),h=t("./util");r.parse=i,r.resolve=s,r.resolveObject=a,r.format=o,r.Url=n;var l=/^([a-z0-9.+-]+:)/i,c=/:[0-9]*$/,d=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,f=["<",">",'"',"`"," ","\r","\n","\t"],p=["{","}","|","\\","^","`"].concat(f),v=["'"].concat(p),g=["%","/","?",";","#"].concat(v),y=["/","?","#"],m=/^[+a-z0-9A-Z_-]{0,63}$/,_=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,b={javascript:!0,"javascript:":!0},x={javascript:!0,"javascript:":!0},T={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},w=t("querystring");n.prototype.parse=function(t,e,r){if(!h.isString(t))throw new TypeError("Parameter 'url' must be a string, not "+typeof t);var n=t.indexOf("?"),i=-1!==n&&n<t.indexOf("#")?"?":"#",o=t.split(i),s=/\\/g;o[0]=o[0].replace(s,"/"),t=o.join(i);var a=t;if(a=a.trim(),!r&&1===t.split("#").length){var c=d.exec(a);if(c)return this.path=a,this.href=a,this.pathname=c[1],c[2]?(this.search=c[2],this.query=e?w.parse(this.search.substr(1)):this.search.substr(1)):e&&(this.search="",this.query={}),this}var f=l.exec(a);if(f){f=f[0];var p=f.toLowerCase();this.protocol=p,a=a.substr(f.length)}if(r||f||a.match(/^\/\/[^@\/]+@[^@\/]+/)){var E="//"===a.substr(0,2);!E||f&&x[f]||(a=a.substr(2),this.slashes=!0)}if(!x[f]&&(E||f&&!T[f])){for(var S=-1,O=0;O<y.length;O++){var M=a.indexOf(y[O]);-1!==M&&(-1===S||M<S)&&(S=M)}var P,C;C=-1===S?a.lastIndexOf("@"):a.lastIndexOf("@",S),-1!==C&&(P=a.slice(0,C),a=a.slice(C+1),this.auth=decodeURIComponent(P)),S=-1;for(var O=0;O<g.length;O++){var M=a.indexOf(g[O]);-1!==M&&(-1===S||M<S)&&(S=M)}-1===S&&(S=a.length),this.host=a.slice(0,S),a=a.slice(S),this.parseHost(),this.hostname=this.hostname||"";var R="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!R)for(var A=this.hostname.split(/\./),O=0,I=A.length;O<I;O++){var D=A[O];if(D&&!D.match(m)){for(var L="",N=0,B=D.length;N<B;N++)D.charCodeAt(N)>127?L+="x":L+=D[N];if(!L.match(m)){var k=A.slice(0,O),F=A.slice(O+1),j=D.match(_);j&&(k.push(j[1]),F.unshift(j[2])),F.length&&(a="/"+F.join(".")+a),this.hostname=k.join(".");break}}}
this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),R||(this.hostname=u.toASCII(this.hostname));var U=this.port?":"+this.port:"",X=this.hostname||"";this.host=X+U,this.href+=this.host,R&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==a[0]&&(a="/"+a))}if(!b[p])for(var O=0,I=v.length;O<I;O++){var G=v[O];if(-1!==a.indexOf(G)){var W=encodeURIComponent(G);W===G&&(W=escape(G)),a=a.split(G).join(W)}}var H=a.indexOf("#");-1!==H&&(this.hash=a.substr(H),a=a.slice(0,H));var Y=a.indexOf("?");if(-1!==Y?(this.search=a.substr(Y),this.query=a.substr(Y+1),e&&(this.query=w.parse(this.query)),a=a.slice(0,Y)):e&&(this.search="",this.query={}),a&&(this.pathname=a),T[p]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){var U=this.pathname||"",V=this.search||"";this.path=U+V}return this.href=this.format(),this},n.prototype.format=function(){var t=this.auth||"";t&&(t=encodeURIComponent(t),t=t.replace(/%3A/i,":"),t+="@");var e=this.protocol||"",r=this.pathname||"",n=this.hash||"",i=!1,o="";this.host?i=t+this.host:this.hostname&&(i=t+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(i+=":"+this.port)),this.query&&h.isObject(this.query)&&Object.keys(this.query).length&&(o=w.stringify(this.query));var s=this.search||o&&"?"+o||"";return e&&":"!==e.substr(-1)&&(e+=":"),this.slashes||(!e||T[e])&&!1!==i?(i="//"+(i||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):i||(i=""),n&&"#"!==n.charAt(0)&&(n="#"+n),s&&"?"!==s.charAt(0)&&(s="?"+s),r=r.replace(/[?#]/g,function(t){return encodeURIComponent(t)}),s=s.replace("#","%23"),e+i+r+s+n},n.prototype.resolve=function(t){return this.resolveObject(i(t,!1,!0)).format()},n.prototype.resolveObject=function(t){if(h.isString(t)){var e=new n;e.parse(t,!1,!0),t=e}for(var r=new n,i=Object.keys(this),o=0;o<i.length;o++){var s=i[o];r[s]=this[s]}if(r.hash=t.hash,""===t.href)return r.href=r.format(),r;if(t.slashes&&!t.protocol){for(var a=Object.keys(t),u=0;u<a.length;u++){var l=a[u];"protocol"!==l&&(r[l]=t[l])}return T[r.protocol]&&r.hostname&&!r.pathname&&(r.path=r.pathname="/"),r.href=r.format(),r}if(t.protocol&&t.protocol!==r.protocol){if(!T[t.protocol]){for(var c=Object.keys(t),d=0;d<c.length;d++){var f=c[d];r[f]=t[f]}return r.href=r.format(),r}if(r.protocol=t.protocol,t.host||x[t.protocol])r.pathname=t.pathname;else{for(var p=(t.pathname||"").split("/");p.length&&!(t.host=p.shift()););t.host||(t.host=""),t.hostname||(t.hostname=""),""!==p[0]&&p.unshift(""),p.length<2&&p.unshift(""),r.pathname=p.join("/")}if(r.search=t.search,r.query=t.query,r.host=t.host||"",r.auth=t.auth,r.hostname=t.hostname||t.host,r.port=t.port,r.pathname||r.search){var v=r.pathname||"",g=r.search||"";r.path=v+g}return r.slashes=r.slashes||t.slashes,r.href=r.format(),r}var y=r.pathname&&"/"===r.pathname.charAt(0),m=t.host||t.pathname&&"/"===t.pathname.charAt(0),_=m||y||r.host&&t.pathname,b=_,w=r.pathname&&r.pathname.split("/")||[],p=t.pathname&&t.pathname.split("/")||[],E=r.protocol&&!T[r.protocol];if(E&&(r.hostname="",r.port=null,r.host&&(""===w[0]?w[0]=r.host:w.unshift(r.host)),r.host="",t.protocol&&(t.hostname=null,t.port=null,t.host&&(""===p[0]?p[0]=t.host:p.unshift(t.host)),t.host=null),_=_&&(""===p[0]||""===w[0])),m)r.host=t.host||""===t.host?t.host:r.host,r.hostname=t.hostname||""===t.hostname?t.hostname:r.hostname,r.search=t.search,r.query=t.query,w=p;else if(p.length)w||(w=[]),w.pop(),w=w.concat(p),r.search=t.search,r.query=t.query;else if(!h.isNullOrUndefined(t.search)){if(E){r.hostname=r.host=w.shift();var S=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@");S&&(r.auth=S.shift(),r.host=r.hostname=S.shift())}return r.search=t.search,r.query=t.query,h.isNull(r.pathname)&&h.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.href=r.format(),r}if(!w.length)return r.pathname=null,r.search?r.path="/"+r.search:r.path=null,r.href=r.format(),r;for(var O=w.slice(-1)[0],M=(r.host||t.host||w.length>1)&&("."===O||".."===O)||""===O,P=0,C=w.length;C>=0;C--)O=w[C],"."===O?w.splice(C,1):".."===O?(w.splice(C,1),P++):P&&(w.splice(C,1),P--);if(!_&&!b)for(;P--;P)w.unshift("..");!_||""===w[0]||w[0]&&"/"===w[0].charAt(0)||w.unshift(""),M&&"/"!==w.join("/").substr(-1)&&w.push("");var R=""===w[0]||w[0]&&"/"===w[0].charAt(0);if(E){r.hostname=r.host=R?"":w.length?w.shift():"";var S=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@");S&&(r.auth=S.shift(),r.host=r.hostname=S.shift())}return _=_||r.host&&w.length,_&&!R&&w.unshift(""),w.length?r.pathname=w.join("/"):(r.pathname=null,r.path=null),h.isNull(r.pathname)&&h.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.auth=t.auth||r.auth,r.slashes=r.slashes||t.slashes,r.href=r.format(),r},n.prototype.parseHost=function(){var t=this.host,e=c.exec(t);e&&(e=e[0],":"!==e&&(this.port=e.substr(1)),t=t.substr(0,t.length-e.length)),t&&(this.hostname=t)}},{"./util":39,punycode:27,querystring:30}],39:[function(t,e,r){"use strict";e.exports={isString:function(t){return"string"==typeof t},isObject:function(t){return"object"==typeof t&&null!==t},isNull:function(t){return null===t},isNullOrUndefined:function(t){return null==t}}},{}],40:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var o=t("../core"),s=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(o),a=t("ismobilejs"),u=n(a),h=t("./accessibleTarget"),l=n(h);s.utils.mixins.delayMixin(s.DisplayObject.prototype,l.default);var c=100,d=0,f=0,p=2,v=function(){function t(e){i(this,t),!u.default.tablet&&!u.default.phone||navigator.isCocoonJS||this.createTouchHook();var r=document.createElement("div");r.style.width=c+"px",r.style.height=c+"px",r.style.position="absolute",r.style.top=d+"px",r.style.left=f+"px",r.style.zIndex=p,this.div=r,this.pool=[],this.renderId=0,this.debug=!1,this.renderer=e,this.children=[],this._onKeyDown=this._onKeyDown.bind(this),this._onMouseMove=this._onMouseMove.bind(this),this.isActive=!1,this.isMobileAccessabillity=!1,window.addEventListener("keydown",this._onKeyDown,!1)}return t.prototype.createTouchHook=function(){var t=this,e=document.createElement("button");e.style.width="1px",e.style.height="1px",e.style.position="absolute",e.style.top="-1000px",e.style.left="-1000px",e.style.zIndex=2,e.style.backgroundColor="#FF0000",e.title="HOOK DIV",e.addEventListener("focus",function(){t.isMobileAccessabillity=!0,t.activate(),document.body.removeChild(e)}),document.body.appendChild(e)},t.prototype.activate=function(){this.isActive||(this.isActive=!0,window.document.addEventListener("mousemove",this._onMouseMove,!0),window.removeEventListener("keydown",this._onKeyDown,!1),this.renderer.on("postrender",this.update,this),this.renderer.view.parentNode&&this.renderer.view.parentNode.appendChild(this.div))},t.prototype.deactivate=function(){this.isActive&&!this.isMobileAccessabillity&&(this.isActive=!1,window.document.removeEventListener("mousemove",this._onMouseMove,!0),window.addEventListener("keydown",this._onKeyDown,!1),this.renderer.off("postrender",this.update),this.div.parentNode&&this.div.parentNode.removeChild(this.div))},t.prototype.updateAccessibleObjects=function(t){if(t.visible){t.accessible&&t.interactive&&(t._accessibleActive||this.addChild(t),t.renderId=this.renderId);for(var e=t.children,r=0;r<e.length;r++)this.updateAccessibleObjects(e[r])}},t.prototype.update=function(){if(this.renderer.renderingToScreen){this.updateAccessibleObjects(this.renderer._lastObjectRendered);var t=this.renderer.view.getBoundingClientRect(),e=t.width/this.renderer.width,r=t.height/this.renderer.height,n=this.div;n.style.left=t.left+"px",n.style.top=t.top+"px",n.style.width=this.renderer.width+"px",n.style.height=this.renderer.height+"px";for(var i=0;i<this.children.length;i++){var o=this.children[i];if(o.renderId!==this.renderId)o._accessibleActive=!1,s.utils.removeItems(this.children,i,1),this.div.removeChild(o._accessibleDiv),this.pool.push(o._accessibleDiv),o._accessibleDiv=null,i--,0===this.children.length&&this.deactivate();else{n=o._accessibleDiv;var a=o.hitArea,u=o.worldTransform;o.hitArea?(n.style.left=(u.tx+a.x*u.a)*e+"px",n.style.top=(u.ty+a.y*u.d)*r+"px",n.style.width=a.width*u.a*e+"px",n.style.height=a.height*u.d*r+"px"):(a=o.getBounds(),this.capHitArea(a),n.style.left=a.x*e+"px",n.style.top=a.y*r+"px",n.style.width=a.width*e+"px",n.style.height=a.height*r+"px",n.title!==o.accessibleTitle&&null!==o.accessibleTitle&&(n.title=o.accessibleTitle),n.getAttribute("aria-label")!==o.accessibleHint&&null!==o.accessibleHint&&n.setAttribute("aria-label",o.accessibleHint))}}this.renderId++}},t.prototype.capHitArea=function(t){t.x<0&&(t.width+=t.x,t.x=0),t.y<0&&(t.height+=t.y,t.y=0),t.x+t.width>this.renderer.width&&(t.width=this.renderer.width-t.x),t.y+t.height>this.renderer.height&&(t.height=this.renderer.height-t.y)},t.prototype.addChild=function(t){var e=this.pool.pop();e||(e=document.createElement("button"),e.style.width=c+"px",e.style.height=c+"px",e.style.backgroundColor=this.debug?"rgba(255,0,0,0.5)":"transparent",e.style.position="absolute",e.style.zIndex=p,e.style.borderStyle="none",navigator.userAgent.toLowerCase().indexOf("chrome")>-1?e.setAttribute("aria-live","off"):e.setAttribute("aria-live","polite"),navigator.userAgent.match(/rv:.*Gecko\//)?e.setAttribute("aria-relevant","additions"):e.setAttribute("aria-relevant","text"),e.addEventListener("click",this._onClick.bind(this)),e.addEventListener("focus",this._onFocus.bind(this)),e.addEventListener("focusout",this._onFocusOut.bind(this))),t.accessibleTitle&&null!==t.accessibleTitle?e.title=t.accessibleTitle:t.accessibleHint&&null!==t.accessibleHint||(e.title="displayObject "+t.tabIndex),t.accessibleHint&&null!==t.accessibleHint&&e.setAttribute("aria-label",t.accessibleHint),t._accessibleActive=!0,t._accessibleDiv=e,e.displayObject=t,this.children.push(t),this.div.appendChild(t._accessibleDiv),t._accessibleDiv.tabIndex=t.tabIndex},t.prototype._onClick=function(t){var e=this.renderer.plugins.interaction;e.dispatchEvent(t.target.displayObject,"click",e.eventData)},t.prototype._onFocus=function(t){t.target.getAttribute("aria-live","off")||t.target.setAttribute("aria-live","assertive");var e=this.renderer.plugins.interaction;e.dispatchEvent(t.target.displayObject,"mouseover",e.eventData)},t.prototype._onFocusOut=function(t){t.target.getAttribute("aria-live","off")||t.target.setAttribute("aria-live","polite");var e=this.renderer.plugins.interaction;e.dispatchEvent(t.target.displayObject,"mouseout",e.eventData)},t.prototype._onKeyDown=function(t){9===t.keyCode&&this.activate()},t.prototype._onMouseMove=function(t){0===t.movementX&&0===t.movementY||this.deactivate()},t.prototype.destroy=function(){this.div=null;for(var t=0;t<this.children.length;t++)this.children[t].div=null;window.document.removeEventListener("mousemove",this._onMouseMove,!0),window.removeEventListener("keydown",this._onKeyDown),this.pool=null,this.children=null,this.renderer=null},t}();r.default=v,s.WebGLRenderer.registerPlugin("accessibility",v),s.CanvasRenderer.registerPlugin("accessibility",v)},{"../core":65,"./accessibleTarget":41,ismobilejs:4}],41:[function(t,e,r){"use strict";r.__esModule=!0,r.default={accessible:!1,accessibleTitle:null,accessibleHint:null,tabIndex:0,_accessibleActive:!1,_accessibleDiv:!1}},{}],42:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0;var i=t("./accessibleTarget");Object.defineProperty(r,"accessibleTarget",{enumerable:!0,get:function(){return n(i).default}});var o=t("./AccessibilityManager");Object.defineProperty(r,"AccessibilityManager",{enumerable:!0,get:function(){return n(o).default}})},{"./AccessibilityManager":40,"./accessibleTarget":41}],43:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var o=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),s=t("./autoDetectRenderer"),a=t("./display/Container"),u=n(a),h=t("./ticker"),l=t("./settings"),c=n(l),d=t("./const"),f=function(){function t(e,r,n,o,a){i(this,t),"number"==typeof e&&(e=Object.assign({width:e,height:r||c.default.RENDER_OPTIONS.height,forceCanvas:!!o,sharedTicker:!!a},n)),this._options=e=Object.assign({autoStart:!0,sharedTicker:!1,forceCanvas:!1,sharedLoader:!1},e),this.renderer=(0,s.autoDetectRenderer)(e),this.stage=new u.default,this._ticker=null,this.ticker=e.sharedTicker?h.shared:new h.Ticker,e.autoStart&&this.start()}return t.prototype.render=function(){this.renderer.render(this.stage)},t.prototype.stop=function(){this._ticker.stop()},t.prototype.start=function(){this._ticker.start()},t.prototype.destroy=function(t,e){if(this._ticker){var r=this._ticker;this.ticker=null,r.destroy()}this.stage.destroy(e),this.stage=null,this.renderer.destroy(t),this.renderer=null,this._options=null},o(t,[{key:"ticker",set:function(t){this._ticker&&this._ticker.remove(this.render,this),this._ticker=t,t&&t.add(this.render,this,d.UPDATE_PRIORITY.LOW)},get:function(){return this._ticker}},{key:"view",get:function(){return this.renderer.view}},{key:"screen",get:function(){return this.renderer.screen}}]),t}();r.default=f},{"./autoDetectRenderer":45,"./const":46,"./display/Container":48,"./settings":101,"./ticker":121}],44:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e){if(t instanceof Array){if("precision"!==t[0].substring(0,9)){var r=t.slice(0);return r.unshift("precision "+e+" float;"),r}}else if("precision"!==t.trim().substring(0,9))return"precision "+e+" float;\n"+t;return t}r.__esModule=!0;var a=t("pixi-gl-core"),u=t("./settings"),h=function(t){return t&&t.__esModule?t:{default:t}}(u),l=function(t){function e(r,o,a,u,l){return n(this,e),i(this,t.call(this,r,s(o,l||h.default.PRECISION_VERTEX),s(a,l||h.default.PRECISION_FRAGMENT),void 0,u))}return o(e,t),e}(a.GLShader);r.default=l},{"./settings":101,"pixi-gl-core":15}],45:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e,r,n){var i=t&&t.forceCanvas;return void 0!==n&&(i=n),!i&&s.isWebGLSupported()?new l.default(t,e,r):new u.default(t,e,r)}r.__esModule=!0,r.autoDetectRenderer=i;var o=t("./utils"),s=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(o),a=t("./renderers/canvas/CanvasRenderer"),u=n(a),h=t("./renderers/webgl/WebGLRenderer"),l=n(h)},{"./renderers/canvas/CanvasRenderer":77,"./renderers/webgl/WebGLRenderer":84,"./utils":125}],46:[function(t,e,r){"use strict";r.__esModule=!0;r.VERSION="4.8.8",r.PI_2=2*Math.PI,r.RAD_TO_DEG=180/Math.PI,r.DEG_TO_RAD=Math.PI/180,r.RENDERER_TYPE={UNKNOWN:0,WEBGL:1,CANVAS:2},r.BLEND_MODES={NORMAL:0,ADD:1,MULTIPLY:2,SCREEN:3,OVERLAY:4,DARKEN:5,LIGHTEN:6,COLOR_DODGE:7,COLOR_BURN:8,HARD_LIGHT:9,SOFT_LIGHT:10,DIFFERENCE:11,EXCLUSION:12,HUE:13,SATURATION:14,COLOR:15,LUMINOSITY:16,NORMAL_NPM:17,ADD_NPM:18,SCREEN_NPM:19},r.DRAW_MODES={POINTS:0,LINES:1,LINE_LOOP:2,LINE_STRIP:3,TRIANGLES:4,TRIANGLE_STRIP:5,TRIANGLE_FAN:6},r.SCALE_MODES={LINEAR:0,NEAREST:1},r.WRAP_MODES={CLAMP:0,REPEAT:1,MIRRORED_REPEAT:2},r.GC_MODES={AUTO:0,MANUAL:1},r.URL_FILE_EXTENSION=/\.(\w{3,4})(?:$|\?|#)/i,r.DATA_URI=/^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i,r.SVG_SIZE=/<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i,r.SHAPES={POLY:0,RECT:1,CIRC:2,ELIP:3,RREC:4},r.PRECISION={LOW:"lowp",MEDIUM:"mediump",HIGH:"highp"},r.TRANSFORM_MODE={STATIC:0,DYNAMIC:1},r.TEXT_GRADIENT={LINEAR_VERTICAL:0,LINEAR_HORIZONTAL:1},r.UPDATE_PRIORITY={INTERACTION:50,HIGH:25,NORMAL:0,LOW:-25,UTILITY:-50}},{}],47:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../math"),o=function(){function t(){n(this,t),this.minX=1/0,this.minY=1/0,this.maxX=-1/0,this.maxY=-1/0,this.rect=null}return t.prototype.isEmpty=function(){return this.minX>this.maxX||this.minY>this.maxY},t.prototype.clear=function(){this.updateID++,this.minX=1/0,this.minY=1/0,this.maxX=-1/0,this.maxY=-1/0},t.prototype.getRectangle=function(t){return this.minX>this.maxX||this.minY>this.maxY?i.Rectangle.EMPTY:(t=t||new i.Rectangle(0,0,1,1),t.x=this.minX,t.y=this.minY,t.width=this.maxX-this.minX,t.height=this.maxY-this.minY,t)},t.prototype.addPoint=function(t){this.minX=Math.min(this.minX,t.x),this.maxX=Math.max(this.maxX,t.x),this.minY=Math.min(this.minY,t.y),this.maxY=Math.max(this.maxY,t.y)},t.prototype.addQuad=function(t){var e=this.minX,r=this.minY,n=this.maxX,i=this.maxY,o=t[0],s=t[1];e=o<e?o:e,r=s<r?s:r,n=o>n?o:n,i=s>i?s:i,o=t[2],s=t[3],e=o<e?o:e,r=s<r?s:r,n=o>n?o:n,i=s>i?s:i,o=t[4],s=t[5],e=o<e?o:e,r=s<r?s:r,n=o>n?o:n,i=s>i?s:i,o=t[6],s=t[7],e=o<e?o:e,r=s<r?s:r,n=o>n?o:n,i=s>i?s:i,this.minX=e,this.minY=r,this.maxX=n,this.maxY=i},t.prototype.addFrame=function(t,e,r,n,i){var o=t.worldTransform,s=o.a,a=o.b,u=o.c,h=o.d,l=o.tx,c=o.ty,d=this.minX,f=this.minY,p=this.maxX,v=this.maxY,g=s*e+u*r+l,y=a*e+h*r+c;d=g<d?g:d,f=y<f?y:f,p=g>p?g:p,v=y>v?y:v,g=s*n+u*r+l,y=a*n+h*r+c,d=g<d?g:d,f=y<f?y:f,p=g>p?g:p,v=y>v?y:v,g=s*e+u*i+l,y=a*e+h*i+c,d=g<d?g:d,f=y<f?y:f,p=g>p?g:p,v=y>v?y:v,g=s*n+u*i+l,y=a*n+h*i+c,d=g<d?g:d,f=y<f?y:f,p=g>p?g:p,v=y>v?y:v,this.minX=d,this.minY=f,this.maxX=p,this.maxY=v},t.prototype.addVertices=function(t,e,r,n){for(var i=t.worldTransform,o=i.a,s=i.b,a=i.c,u=i.d,h=i.tx,l=i.ty,c=this.minX,d=this.minY,f=this.maxX,p=this.maxY,v=r;v<n;v+=2){var g=e[v],y=e[v+1],m=o*g+a*y+h,_=u*y+s*g+l;c=m<c?m:c,d=_<d?_:d,f=m>f?m:f,p=_>p?_:p}this.minX=c,this.minY=d,this.maxX=f,this.maxY=p},t.prototype.addBounds=function(t){var e=this.minX,r=this.minY,n=this.maxX,i=this.maxY;this.minX=t.minX<e?t.minX:e,this.minY=t.minY<r?t.minY:r,this.maxX=t.maxX>n?t.maxX:n,this.maxY=t.maxY>i?t.maxY:i},t.prototype.addBoundsMask=function(t,e){var r=t.minX>e.minX?t.minX:e.minX,n=t.minY>e.minY?t.minY:e.minY,i=t.maxX<e.maxX?t.maxX:e.maxX,o=t.maxY<e.maxY?t.maxY:e.maxY;if(r<=i&&n<=o){var s=this.minX,a=this.minY,u=this.maxX,h=this.maxY;this.minX=r<s?r:s,this.minY=n<a?n:a,this.maxX=i>u?i:u,this.maxY=o>h?o:h}},t.prototype.addBoundsArea=function(t,e){var r=t.minX>e.x?t.minX:e.x,n=t.minY>e.y?t.minY:e.y,i=t.maxX<e.x+e.width?t.maxX:e.x+e.width,o=t.maxY<e.y+e.height?t.maxY:e.y+e.height;if(r<=i&&n<=o){var s=this.minX,a=this.minY,u=this.maxX,h=this.maxY;this.minX=r<s?r:s,this.minY=n<a?n:a,this.maxX=i>u?i:u,this.maxY=o>h?o:h}},t}();r.default=o},{"../math":70}],48:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../utils"),u=t("./DisplayObject"),h=function(t){return t&&t.__esModule?t:{default:t}}(u),l=function(t){function e(){n(this,e);var r=i(this,t.call(this));return r.children=[],r}return o(e,t),e.prototype.onChildrenChange=function(){},e.prototype.addChild=function(t){var e=arguments.length;if(e>1)for(var r=0;r<e;r++)this.addChild(arguments[r]);else t.parent&&t.parent.removeChild(t),t.parent=this,t.transform._parentID=-1,this.children.push(t),this._boundsID++,this.onChildrenChange(this.children.length-1),t.emit("added",this);return t},e.prototype.addChildAt=function(t,e){if(e<0||e>this.children.length)throw new Error(t+"addChildAt: The index "+e+" supplied is out of bounds "+this.children.length);return t.parent&&t.parent.removeChild(t),t.parent=this,t.transform._parentID=-1,this.children.splice(e,0,t),this._boundsID++,this.onChildrenChange(e),t.emit("added",this),t},e.prototype.swapChildren=function(t,e){if(t!==e){var r=this.getChildIndex(t),n=this.getChildIndex(e);this.children[r]=e,this.children[n]=t,this.onChildrenChange(r<n?r:n)}},e.prototype.getChildIndex=function(t){var e=this.children.indexOf(t);if(-1===e)throw new Error("The supplied DisplayObject must be a child of the caller");return e},e.prototype.setChildIndex=function(t,e){if(e<0||e>=this.children.length)throw new Error("The index "+e+" supplied is out of bounds "+this.children.length);var r=this.getChildIndex(t);(0,a.removeItems)(this.children,r,1),this.children.splice(e,0,t),this.onChildrenChange(e)},e.prototype.getChildAt=function(t){if(t<0||t>=this.children.length)throw new Error("getChildAt: Index ("+t+") does not exist.");return this.children[t]},e.prototype.removeChild=function(t){var e=arguments.length;if(e>1)for(var r=0;r<e;r++)this.removeChild(arguments[r]);else{var n=this.children.indexOf(t);if(-1===n)return null;t.parent=null,t.transform._parentID=-1,(0,a.removeItems)(this.children,n,1),this._boundsID++,this.onChildrenChange(n),t.emit("removed",this)}return t},e.prototype.removeChildAt=function(t){var e=this.getChildAt(t);return e.parent=null,e.transform._parentID=-1,(0,a.removeItems)(this.children,t,1),this._boundsID++,this.onChildrenChange(t),e.emit("removed",this),e},e.prototype.removeChildren=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments[1],r=t,n="number"==typeof e?e:this.children.length,i=n-r,o=void 0;if(i>0&&i<=n){o=this.children.splice(r,i);for(var s=0;s<o.length;++s)o[s].parent=null,o[s].transform&&(o[s].transform._parentID=-1);this._boundsID++,this.onChildrenChange(t);for(var a=0;a<o.length;++a)o[a].emit("removed",this);return o}if(0===i&&0===this.children.length)return[];throw new RangeError("removeChildren: numeric values are outside the acceptable range.")},e.prototype.updateTransform=function(){this._boundsID++,this.transform.updateTransform(this.parent.transform),this.worldAlpha=this.alpha*this.parent.worldAlpha;for(var t=0,e=this.children.length;t<e;++t){var r=this.children[t];r.visible&&r.updateTransform()}},e.prototype.calculateBounds=function(){this._bounds.clear(),this._calculateBounds();for(var t=0;t<this.children.length;t++){var e=this.children[t];e.visible&&e.renderable&&(e.calculateBounds(),e._mask?(e._mask.calculateBounds(),this._bounds.addBoundsMask(e._bounds,e._mask._bounds)):e.filterArea?this._bounds.addBoundsArea(e._bounds,e.filterArea):this._bounds.addBounds(e._bounds))}this._lastBoundsID=this._boundsID},e.prototype._calculateBounds=function(){},e.prototype.renderWebGL=function(t){if(this.visible&&!(this.worldAlpha<=0)&&this.renderable)if(this._mask||this._filters)this.renderAdvancedWebGL(t);else{this._renderWebGL(t);for(var e=0,r=this.children.length;e<r;++e)this.children[e].renderWebGL(t)}},e.prototype.renderAdvancedWebGL=function(t){t.flush();var e=this._filters,r=this._mask;if(e){this._enabledFilters||(this._enabledFilters=[]),this._enabledFilters.length=0;for(var n=0;n<e.length;n++)e[n].enabled&&this._enabledFilters.push(e[n]);this._enabledFilters.length&&t.filterManager.pushFilter(this,this._enabledFilters)}r&&t.maskManager.pushMask(this,this._mask),this._renderWebGL(t);for(var i=0,o=this.children.length;i<o;i++)this.children[i].renderWebGL(t);t.flush(),r&&t.maskManager.popMask(this,this._mask),e&&this._enabledFilters&&this._enabledFilters.length&&t.filterManager.popFilter()},e.prototype._renderWebGL=function(t){},e.prototype._renderCanvas=function(t){},e.prototype.renderCanvas=function(t){if(this.visible&&!(this.worldAlpha<=0)&&this.renderable){this._mask&&t.maskManager.pushMask(this._mask),this._renderCanvas(t);for(var e=0,r=this.children.length;e<r;++e)this.children[e].renderCanvas(t);this._mask&&t.maskManager.popMask(t)}},e.prototype.destroy=function(e){t.prototype.destroy.call(this);var r="boolean"==typeof e?e:e&&e.children,n=this.removeChildren(0,this.children.length);if(r)for(var i=0;i<n.length;++i)n[i].destroy(e)},s(e,[{key:"width",get:function(){return this.scale.x*this.getLocalBounds().width},set:function(t){var e=this.getLocalBounds().width;this.scale.x=0!==e?t/e:1,this._width=t}},{key:"height",get:function(){return this.scale.y*this.getLocalBounds().height},set:function(t){var e=this.getLocalBounds().height;this.scale.y=0!==e?t/e:1,this._height=t}}]),e}(h.default);r.default=l,l.prototype.containerUpdateTransform=l.prototype.updateTransform},{"../utils":125,"./DisplayObject":49}],49:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),u=t("eventemitter3"),h=n(u),l=t("../const"),c=t("../settings"),d=n(c),f=t("./TransformStatic"),p=n(f),v=t("./Transform"),g=n(v),y=t("./Bounds"),m=n(y),_=t("../math"),b=function(t){function e(){i(this,e);var r=o(this,t.call(this)),n=d.default.TRANSFORM_MODE===l.TRANSFORM_MODE.STATIC?p.default:g.default;return r.tempDisplayObjectParent=null,r.transform=new n,r.alpha=1,r.visible=!0,r.renderable=!0,r.parent=null,r.worldAlpha=1,r.filterArea=null,r._filters=null,r._enabledFilters=null,r._bounds=new m.default,r._boundsID=0,r._lastBoundsID=-1,r._boundsRect=null,r._localBoundsRect=null,r._mask=null,r._destroyed=!1,r}return s(e,t),e.prototype.updateTransform=function(){this.transform.updateTransform(this.parent.transform),this.worldAlpha=this.alpha*this.parent.worldAlpha,this._bounds.updateID++},e.prototype._recursivePostUpdateTransform=function(){this.parent?(this.parent._recursivePostUpdateTransform(),this.transform.updateTransform(this.parent.transform)):this.transform.updateTransform(this._tempDisplayObjectParent.transform)},e.prototype.getBounds=function(t,e){return t||(this.parent?(this._recursivePostUpdateTransform(),this.updateTransform()):(this.parent=this._tempDisplayObjectParent,this.updateTransform(),this.parent=null)),this._boundsID!==this._lastBoundsID&&this.calculateBounds(),e||(this._boundsRect||(this._boundsRect=new _.Rectangle),e=this._boundsRect),this._bounds.getRectangle(e)},e.prototype.getLocalBounds=function(t){var e=this.transform,r=this.parent;this.parent=null,this.transform=this._tempDisplayObjectParent.transform,t||(this._localBoundsRect||(this._localBoundsRect=new _.Rectangle),t=this._localBoundsRect);var n=this.getBounds(!1,t);return this.parent=r,this.transform=e,n},e.prototype.toGlobal=function(t,e){return arguments.length>2&&void 0!==arguments[2]&&arguments[2]||(this._recursivePostUpdateTransform(),this.parent?this.displayObjectUpdateTransform():(this.parent=this._tempDisplayObjectParent,this.displayObjectUpdateTransform(),this.parent=null)),this.worldTransform.apply(t,e)},e.prototype.toLocal=function(t,e,r,n){return e&&(t=e.toGlobal(t,r,n)),n||(this._recursivePostUpdateTransform(),this.parent?this.displayObjectUpdateTransform():(this.parent=this._tempDisplayObjectParent,this.displayObjectUpdateTransform(),this.parent=null)),this.worldTransform.applyInverse(t,r)},e.prototype.renderWebGL=function(t){},e.prototype.renderCanvas=function(t){},e.prototype.setParent=function(t){if(!t||!t.addChild)throw new Error("setParent: Argument must be a Container");return t.addChild(this),t},e.prototype.setTransform=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,o=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,s=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0,a=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0,u=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0;return this.position.x=t,this.position.y=e,this.scale.x=r||1,this.scale.y=n||1,this.rotation=i,this.skew.x=o,this.skew.y=s,this.pivot.x=a,this.pivot.y=u,this},e.prototype.destroy=function(){this.removeAllListeners(),this.parent&&this.parent.removeChild(this),this.transform=null,this.parent=null,this._bounds=null,this._currentBounds=null,this._mask=null,this.filterArea=null,this.interactive=!1,this.interactiveChildren=!1,this._destroyed=!0},a(e,[{key:"_tempDisplayObjectParent",get:function(){return null===this.tempDisplayObjectParent&&(this.tempDisplayObjectParent=new e),this.tempDisplayObjectParent}},{key:"x",get:function(){return this.position.x},set:function(t){this.transform.position.x=t}},{key:"y",get:function(){return this.position.y},set:function(t){this.transform.position.y=t}},{key:"worldTransform",get:function(){return this.transform.worldTransform}},{key:"localTransform",get:function(){return this.transform.localTransform}},{key:"position",get:function(){return this.transform.position},set:function(t){this.transform.position.copy(t)}},{key:"scale",get:function(){return this.transform.scale},set:function(t){this.transform.scale.copy(t)}},{key:"pivot",get:function(){return this.transform.pivot},set:function(t){this.transform.pivot.copy(t)}},{key:"skew",get:function(){return this.transform.skew},set:function(t){this.transform.skew.copy(t)}},{key:"rotation",get:function(){return this.transform.rotation},set:function(t){this.transform.rotation=t}},{key:"worldVisible",get:function(){var t=this;do{if(!t.visible)return!1;t=t.parent}while(t);return!0}},{key:"mask",get:function(){return this._mask},set:function(t){this._mask&&(this._mask.renderable=!0,this._mask.isMask=!1),this._mask=t,this._mask&&(this._mask.renderable=!1,this._mask.isMask=!0)}},{key:"filters",get:function(){return this._filters&&this._filters.slice()},set:function(t){this._filters=t&&t.slice()}}]),e}(h.default);r.default=b,b.prototype.displayObjectUpdateTransform=b.prototype.updateTransform},{"../const":46,"../math":70,"../settings":101,"./Bounds":47,"./Transform":50,"./TransformStatic":52,eventemitter3:3}],50:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}
function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../math"),u=t("./TransformBase"),h=function(t){return t&&t.__esModule?t:{default:t}}(u),l=function(t){function e(){n(this,e);var r=i(this,t.call(this));return r.position=new a.Point(0,0),r.scale=new a.Point(1,1),r.skew=new a.ObservablePoint(r.updateSkew,r,0,0),r.pivot=new a.Point(0,0),r._rotation=0,r._cx=1,r._sx=0,r._cy=0,r._sy=1,r}return o(e,t),e.prototype.updateSkew=function(){this._cx=Math.cos(this._rotation+this.skew._y),this._sx=Math.sin(this._rotation+this.skew._y),this._cy=-Math.sin(this._rotation-this.skew._x),this._sy=Math.cos(this._rotation-this.skew._x)},e.prototype.updateLocalTransform=function(){var t=this.localTransform;t.a=this._cx*this.scale.x,t.b=this._sx*this.scale.x,t.c=this._cy*this.scale.y,t.d=this._sy*this.scale.y,t.tx=this.position.x-(this.pivot.x*t.a+this.pivot.y*t.c),t.ty=this.position.y-(this.pivot.x*t.b+this.pivot.y*t.d)},e.prototype.updateTransform=function(t){var e=this.localTransform;e.a=this._cx*this.scale.x,e.b=this._sx*this.scale.x,e.c=this._cy*this.scale.y,e.d=this._sy*this.scale.y,e.tx=this.position.x-(this.pivot.x*e.a+this.pivot.y*e.c),e.ty=this.position.y-(this.pivot.x*e.b+this.pivot.y*e.d);var r=t.worldTransform,n=this.worldTransform;n.a=e.a*r.a+e.b*r.c,n.b=e.a*r.b+e.b*r.d,n.c=e.c*r.a+e.d*r.c,n.d=e.c*r.b+e.d*r.d,n.tx=e.tx*r.a+e.ty*r.c+r.tx,n.ty=e.tx*r.b+e.ty*r.d+r.ty,this._worldID++},e.prototype.setFromMatrix=function(t){t.decompose(this)},s(e,[{key:"rotation",get:function(){return this._rotation},set:function(t){this._rotation=t,this.updateSkew()}}]),e}(h.default);r.default=l},{"../math":70,"./TransformBase":51}],51:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../math"),o=function(){function t(){n(this,t),this.worldTransform=new i.Matrix,this.localTransform=new i.Matrix,this._worldID=0,this._parentID=0}return t.prototype.updateLocalTransform=function(){},t.prototype.updateTransform=function(t){var e=t.worldTransform,r=this.worldTransform,n=this.localTransform;r.a=n.a*e.a+n.b*e.c,r.b=n.a*e.b+n.b*e.d,r.c=n.c*e.a+n.d*e.c,r.d=n.c*e.b+n.d*e.d,r.tx=n.tx*e.a+n.ty*e.c+e.tx,r.ty=n.tx*e.b+n.ty*e.d+e.ty,this._worldID++},t}();r.default=o,o.prototype.updateWorldTransform=o.prototype.updateTransform,o.IDENTITY=new o},{"../math":70}],52:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../math"),u=t("./TransformBase"),h=function(t){return t&&t.__esModule?t:{default:t}}(u),l=function(t){function e(){n(this,e);var r=i(this,t.call(this));return r.position=new a.ObservablePoint(r.onChange,r,0,0),r.scale=new a.ObservablePoint(r.onChange,r,1,1),r.pivot=new a.ObservablePoint(r.onChange,r,0,0),r.skew=new a.ObservablePoint(r.updateSkew,r,0,0),r._rotation=0,r._cx=1,r._sx=0,r._cy=0,r._sy=1,r._localID=0,r._currentLocalID=0,r}return o(e,t),e.prototype.onChange=function(){this._localID++},e.prototype.updateSkew=function(){this._cx=Math.cos(this._rotation+this.skew._y),this._sx=Math.sin(this._rotation+this.skew._y),this._cy=-Math.sin(this._rotation-this.skew._x),this._sy=Math.cos(this._rotation-this.skew._x),this._localID++},e.prototype.updateLocalTransform=function(){var t=this.localTransform;this._localID!==this._currentLocalID&&(t.a=this._cx*this.scale._x,t.b=this._sx*this.scale._x,t.c=this._cy*this.scale._y,t.d=this._sy*this.scale._y,t.tx=this.position._x-(this.pivot._x*t.a+this.pivot._y*t.c),t.ty=this.position._y-(this.pivot._x*t.b+this.pivot._y*t.d),this._currentLocalID=this._localID,this._parentID=-1)},e.prototype.updateTransform=function(t){var e=this.localTransform;if(this._localID!==this._currentLocalID&&(e.a=this._cx*this.scale._x,e.b=this._sx*this.scale._x,e.c=this._cy*this.scale._y,e.d=this._sy*this.scale._y,e.tx=this.position._x-(this.pivot._x*e.a+this.pivot._y*e.c),e.ty=this.position._y-(this.pivot._x*e.b+this.pivot._y*e.d),this._currentLocalID=this._localID,this._parentID=-1),this._parentID!==t._worldID){var r=t.worldTransform,n=this.worldTransform;n.a=e.a*r.a+e.b*r.c,n.b=e.a*r.b+e.b*r.d,n.c=e.c*r.a+e.d*r.c,n.d=e.c*r.b+e.d*r.d,n.tx=e.tx*r.a+e.ty*r.c+r.tx,n.ty=e.tx*r.b+e.ty*r.d+r.ty,this._parentID=t._worldID,this._worldID++}},e.prototype.setFromMatrix=function(t){t.decompose(this),this._localID++},s(e,[{key:"rotation",get:function(){return this._rotation},set:function(t){this._rotation!==t&&(this._rotation=t,this.updateSkew())}}]),e}(h.default);r.default=l},{"../math":70,"./TransformBase":51}],53:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("../display/Container"),u=n(a),h=t("../textures/RenderTexture"),l=n(h),c=t("../textures/Texture"),d=n(c),f=t("./GraphicsData"),p=n(f),v=t("../sprites/Sprite"),g=n(v),y=t("../math"),m=t("../utils"),_=t("../const"),b=t("../display/Bounds"),x=n(b),T=t("./utils/bezierCurveTo"),w=n(T),E=t("../renderers/canvas/CanvasRenderer"),S=n(E),O=void 0,M=new y.Matrix,P=new y.Point,C=new Float32Array(4),R=new Float32Array(4),A=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]&&arguments[0];i(this,e);var n=o(this,t.call(this));return n.fillAlpha=1,n.lineWidth=0,n.nativeLines=r,n.lineColor=0,n.lineAlignment=.5,n.graphicsData=[],n.tint=16777215,n._prevTint=16777215,n.blendMode=_.BLEND_MODES.NORMAL,n.currentPath=null,n._webGL={},n.isMask=!1,n.boundsPadding=0,n._localBounds=new x.default,n.dirty=0,n.fastRectDirty=-1,n.clearDirty=0,n.boundsDirty=-1,n.cachedSpriteDirty=!1,n._spriteRect=null,n._fastRect=!1,n._prevRectTint=null,n._prevRectFillColor=null,n}return s(e,t),e.prototype.clone=function(){var t=new e;t.renderable=this.renderable,t.fillAlpha=this.fillAlpha,t.lineWidth=this.lineWidth,t.lineColor=this.lineColor,t.lineAlignment=this.lineAlignment,t.tint=this.tint,t.blendMode=this.blendMode,t.isMask=this.isMask,t.boundsPadding=this.boundsPadding,t.dirty=0,t.cachedSpriteDirty=this.cachedSpriteDirty;for(var r=0;r<this.graphicsData.length;++r)t.graphicsData.push(this.graphicsData[r].clone());return t.currentPath=t.graphicsData[t.graphicsData.length-1],t.updateLocalBounds(),t},e.prototype._quadraticCurveLength=function(t,e,r,n,i,o){var s=t-2*r+i,a=e-2*n+o,u=2*r-2*t,h=2*n-2*e,l=4*(s*s+a*a),c=4*(s*u+a*h),d=u*u+h*h,f=2*Math.sqrt(l+c+d),p=Math.sqrt(l),v=2*l*p,g=2*Math.sqrt(d),y=c/p;return(v*f+p*c*(f-g)+(4*d*l-c*c)*Math.log((2*p+y+f)/(y+g)))/(4*v)},e.prototype._bezierCurveLength=function(t,e,r,n,i,o,s,a){for(var u=0,h=0,l=0,c=0,d=0,f=0,p=0,v=0,g=0,y=0,m=0,_=t,b=e,x=1;x<=10;++x)h=x/10,l=h*h,c=l*h,d=1-h,f=d*d,p=f*d,v=p*t+3*f*h*r+3*d*l*i+c*s,g=p*e+3*f*h*n+3*d*l*o+c*a,y=_-v,m=b-g,_=v,b=g,u+=Math.sqrt(y*y+m*m);return u},e.prototype._segmentsCount=function(t){var r=Math.ceil(t/e.CURVES.maxLength);return r<e.CURVES.minSegments?r=e.CURVES.minSegments:r>e.CURVES.maxSegments&&(r=e.CURVES.maxSegments),r},e.prototype.lineStyle=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:.5;if(this.lineWidth=t,this.lineColor=e,this.lineAlpha=r,this.lineAlignment=n,this.currentPath)if(this.currentPath.shape.points.length){var i=new y.Polygon(this.currentPath.shape.points.slice(-2));i.closed=!1,this.drawShape(i)}else this.currentPath.lineWidth=this.lineWidth,this.currentPath.lineColor=this.lineColor,this.currentPath.lineAlpha=this.lineAlpha,this.currentPath.lineAlignment=this.lineAlignment;return this},e.prototype.moveTo=function(t,e){var r=new y.Polygon([t,e]);return r.closed=!1,this.drawShape(r),this},e.prototype.lineTo=function(t,e){var r=this.currentPath.shape.points,n=r[r.length-2],i=r[r.length-1];return n===t&&i===e||(r.push(t,e),this.dirty++),this},e.prototype.quadraticCurveTo=function(t,r,n,i){this.currentPath?0===this.currentPath.shape.points.length&&(this.currentPath.shape.points=[0,0]):this.moveTo(0,0);var o=this.currentPath.shape.points,s=0,a=0;0===o.length&&this.moveTo(0,0);for(var u=o[o.length-2],h=o[o.length-1],l=e.CURVES.adaptive?this._segmentsCount(this._quadraticCurveLength(u,h,t,r,n,i)):20,c=1;c<=l;++c){var d=c/l;s=u+(t-u)*d,a=h+(r-h)*d,o.push(s+(t+(n-t)*d-s)*d,a+(r+(i-r)*d-a)*d)}return this.dirty++,this},e.prototype.bezierCurveTo=function(t,r,n,i,o,s){this.currentPath?0===this.currentPath.shape.points.length&&(this.currentPath.shape.points=[0,0]):this.moveTo(0,0);var a=this.currentPath.shape.points,u=a[a.length-2],h=a[a.length-1];a.length-=2;var l=e.CURVES.adaptive?this._segmentsCount(this._bezierCurveLength(u,h,t,r,n,i,o,s)):20;return(0,w.default)(u,h,t,r,n,i,o,s,l,a),this.dirty++,this},e.prototype.arcTo=function(t,e,r,n,i){this.currentPath?0===this.currentPath.shape.points.length&&this.currentPath.shape.points.push(t,e):this.moveTo(t,e);var o=this.currentPath.shape.points,s=o[o.length-2],a=o[o.length-1],u=a-e,h=s-t,l=n-e,c=r-t,d=Math.abs(u*c-h*l);if(d<1e-8||0===i)o[o.length-2]===t&&o[o.length-1]===e||o.push(t,e);else{var f=u*u+h*h,p=l*l+c*c,v=u*l+h*c,g=i*Math.sqrt(f)/d,y=i*Math.sqrt(p)/d,m=g*v/f,_=y*v/p,b=g*c+y*h,x=g*l+y*u,T=h*(y+m),w=u*(y+m),E=c*(g+_),S=l*(g+_),O=Math.atan2(w-x,T-b),M=Math.atan2(S-x,E-b);this.arc(b+t,x+e,i,O,M,h*l>c*u)}return this.dirty++,this},e.prototype.arc=function(t,r,n,i,o){var s=arguments.length>5&&void 0!==arguments[5]&&arguments[5];if(i===o)return this;!s&&o<=i?o+=_.PI_2:s&&i<=o&&(i+=_.PI_2);var a=o-i,u=e.CURVES.adaptive?this._segmentsCount(Math.abs(a)*n):40*Math.ceil(Math.abs(a)/_.PI_2);if(0===a)return this;var h=t+Math.cos(i)*n,l=r+Math.sin(i)*n,c=this.currentPath?this.currentPath.shape.points:null;if(c){var d=Math.abs(c[c.length-2]-h),f=Math.abs(c[c.length-1]-l);d<.001&&f<.001||c.push(h,l)}else this.moveTo(h,l),c=this.currentPath.shape.points;for(var p=a/(2*u),v=2*p,g=Math.cos(p),y=Math.sin(p),m=u-1,b=m%1/m,x=0;x<=m;++x){var T=x+b*x,w=p+i+v*T,E=Math.cos(w),S=-Math.sin(w);c.push((g*E+y*S)*n+t,(g*-S+y*E)*n+r)}return this.dirty++,this},e.prototype.beginFill=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;return this.filling=!0,this.fillColor=t,this.fillAlpha=e,this.currentPath&&this.currentPath.shape.points.length<=2&&(this.currentPath.fill=this.filling,this.currentPath.fillColor=this.fillColor,this.currentPath.fillAlpha=this.fillAlpha),this},e.prototype.endFill=function(){return this.filling=!1,this.fillColor=null,this.fillAlpha=1,this},e.prototype.drawRect=function(t,e,r,n){return this.drawShape(new y.Rectangle(t,e,r,n)),this},e.prototype.drawRoundedRect=function(t,e,r,n,i){return this.drawShape(new y.RoundedRectangle(t,e,r,n,i)),this},e.prototype.drawCircle=function(t,e,r){return this.drawShape(new y.Circle(t,e,r)),this},e.prototype.drawEllipse=function(t,e,r,n){return this.drawShape(new y.Ellipse(t,e,r,n)),this},e.prototype.drawPolygon=function(t){var e=t,r=!0;if(e instanceof y.Polygon&&(r=e.closed,e=e.points),!Array.isArray(e)){e=new Array(arguments.length);for(var n=0;n<e.length;++n)e[n]=arguments[n]}var i=new y.Polygon(e);return i.closed=r,this.drawShape(i),this},e.prototype.drawStar=function(t,e,r,n,i){var o=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;i=i||n/2;for(var s=-1*Math.PI/2+o,a=2*r,u=_.PI_2/a,h=[],l=0;l<a;l++){var c=l%2?i:n,d=l*u+s;h.push(t+c*Math.cos(d),e+c*Math.sin(d))}return this.drawPolygon(h)},e.prototype.clear=function(){return(this.lineWidth||this.filling||this.graphicsData.length>0)&&(this.lineWidth=0,this.lineAlignment=.5,this.filling=!1,this.boundsDirty=-1,this.canvasTintDirty=-1,this.dirty++,this.clearDirty++,this.graphicsData.length=0),this.currentPath=null,this._spriteRect=null,this},e.prototype.isFastRect=function(){return 1===this.graphicsData.length&&this.graphicsData[0].shape.type===_.SHAPES.RECT&&!this.graphicsData[0].lineWidth},e.prototype._renderWebGL=function(t){this.dirty!==this.fastRectDirty&&(this.fastRectDirty=this.dirty,this._fastRect=this.isFastRect()),this._fastRect?this._renderSpriteRect(t):(t.setObjectRenderer(t.plugins.graphics),t.plugins.graphics.render(this))},e.prototype._renderSpriteRect=function(t){var e=this.graphicsData[0].shape;this._spriteRect||(this._spriteRect=new g.default(new d.default(d.default.WHITE)));var r=this._spriteRect,n=this.graphicsData[0].fillColor;if(16777215===this.tint)r.tint=n;else if(this.tint!==this._prevRectTint||n!==this._prevRectFillColor){var i=C,o=R;(0,m.hex2rgb)(n,i),(0,m.hex2rgb)(this.tint,o),i[0]*=o[0],i[1]*=o[1],i[2]*=o[2],r.tint=(0,m.rgb2hex)(i),this._prevRectTint=this.tint,this._prevRectFillColor=n}r.alpha=this.graphicsData[0].fillAlpha,r.worldAlpha=this.worldAlpha*r.alpha,r.blendMode=this.blendMode,r._texture._frame.width=e.width,r._texture._frame.height=e.height,r.transform.worldTransform=this.transform.worldTransform,r.anchor.set(-e.x/e.width,-e.y/e.height),r._onAnchorUpdate(),r._renderWebGL(t)},e.prototype._renderCanvas=function(t){!0!==this.isMask&&t.plugins.graphics.render(this)},e.prototype._calculateBounds=function(){this.boundsDirty!==this.dirty&&(this.boundsDirty=this.dirty,this.updateLocalBounds(),this.cachedSpriteDirty=!0);var t=this._localBounds;this._bounds.addFrame(this.transform,t.minX,t.minY,t.maxX,t.maxY)},e.prototype.containsPoint=function(t){this.worldTransform.applyInverse(t,P);for(var e=this.graphicsData,r=0;r<e.length;++r){var n=e[r];if(n.fill&&(n.shape&&n.shape.contains(P.x,P.y))){if(n.holes)for(var i=0;i<n.holes.length;i++){var o=n.holes[i];if(o.contains(P.x,P.y))return!1}return!0}}return!1},e.prototype.updateLocalBounds=function(){var t=1/0,e=-1/0,r=1/0,n=-1/0;if(this.graphicsData.length)for(var i=0,o=0,s=0,a=0,u=0,h=0;h<this.graphicsData.length;h++){var l=this.graphicsData[h],c=l.type,d=l.lineWidth,f=l.lineAlignment,p=d*f;if(i=l.shape,c===_.SHAPES.RECT||c===_.SHAPES.RREC)o=i.x-p,s=i.y-p,a=i.width+2*p,u=i.height+2*p,t=o<t?o:t,e=o+a>e?o+a:e,r=s<r?s:r,n=s+u>n?s+u:n;else if(c===_.SHAPES.CIRC)o=i.x,s=i.y,a=i.radius+p,u=i.radius+p,t=o-a<t?o-a:t,e=o+a>e?o+a:e,r=s-u<r?s-u:r,n=s+u>n?s+u:n;else if(c===_.SHAPES.ELIP)o=i.x,s=i.y,a=i.width+p,u=i.height+p,t=o-a<t?o-a:t,e=o+a>e?o+a:e,r=s-u<r?s-u:r,n=s+u>n?s+u:n;else for(var v=i.points,g=0,y=0,m=0,b=0,x=0,T=0,w=0,E=0,S=0;S+2<v.length;S+=2)o=v[S],s=v[S+1],g=v[S+2],y=v[S+3],m=Math.abs(g-o),b=Math.abs(y-s),u=2*p,(a=Math.sqrt(m*m+b*b))<1e-9||(x=(u/a*b+m)/2,T=(u/a*m+b)/2,w=(g+o)/2,E=(y+s)/2,t=w-x<t?w-x:t,e=w+x>e?w+x:e,r=E-T<r?E-T:r,n=E+T>n?E+T:n)}else t=0,e=0,r=0,n=0;var O=this.boundsPadding;this._localBounds.minX=t-O,this._localBounds.maxX=e+O,this._localBounds.minY=r-O,this._localBounds.maxY=n+O},e.prototype.drawShape=function(t){this.currentPath&&this.currentPath.shape.points.length<=2&&this.graphicsData.pop(),this.currentPath=null;var e=new p.default(this.lineWidth,this.lineColor,this.lineAlpha,this.fillColor,this.fillAlpha,this.filling,this.nativeLines,t,this.lineAlignment);return this.graphicsData.push(e),e.type===_.SHAPES.POLY&&(e.shape.closed=e.shape.closed,this.currentPath=e),this.dirty++,e},e.prototype.generateCanvasTexture=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=this.getLocalBounds(),n=l.default.create(r.width,r.height,t,e);O||(O=new S.default),this.transform.updateLocalTransform(),this.transform.localTransform.copy(M),M.invert(),M.tx-=r.x,M.ty-=r.y,O.render(this,n,!0,M);var i=d.default.fromCanvas(n.baseTexture._canvasRenderTarget.canvas,t,"graphics");return i.baseTexture.resolution=e,i.baseTexture.update(),i},e.prototype.closePath=function(){var t=this.currentPath;return t&&t.shape&&t.shape.close(),this},e.prototype.addHole=function(){var t=this.graphicsData.pop();return this.currentPath=this.graphicsData[this.graphicsData.length-1],this.currentPath.addHole(t.shape),this.currentPath=null,this},e.prototype.destroy=function(e){t.prototype.destroy.call(this,e);for(var r=0;r<this.graphicsData.length;++r)this.graphicsData[r].destroy();for(var n in this._webGL)for(var i=0;i<this._webGL[n].data.length;++i)this._webGL[n].data[i].destroy();this._spriteRect&&this._spriteRect.destroy(),this.graphicsData=null,this.currentPath=null,this._webGL=null,this._localBounds=null},e}(u.default);r.default=A,A._SPRITE_TEXTURE=null,A.CURVES={adaptive:!1,maxLength:10,minSegments:8,maxSegments:2048}},{"../const":46,"../display/Bounds":47,"../display/Container":48,"../math":70,"../renderers/canvas/CanvasRenderer":77,"../sprites/Sprite":102,"../textures/RenderTexture":113,"../textures/Texture":115,"../utils":125,"./GraphicsData":54,"./utils/bezierCurveTo":56}],54:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(e,r,i,o,s,a,u,h,l){n(this,t),this.lineWidth=e,this.lineAlignment=l,this.nativeLines=u,this.lineColor=r,this.lineAlpha=i,this._lineTint=r,this.fillColor=o,this.fillAlpha=s,this._fillTint=o,this.fill=a,this.holes=[],this.shape=h,this.type=h.type}return t.prototype.clone=function(){return new t(this.lineWidth,this.lineColor,this.lineAlpha,this.fillColor,this.fillAlpha,this.fill,this.nativeLines,this.shape,this.lineAlignment)},t.prototype.addHole=function(t){this.holes.push(t)},t.prototype.destroy=function(){this.shape=null,this.holes=null},t}();r.default=i},{}],55:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../../renderers/canvas/CanvasRenderer"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=t("../../const"),a=function(){function t(e){n(this,t),this.renderer=e}return t.prototype.render=function(t){var e=this.renderer,r=e.context,n=t.worldAlpha,i=t.transform.worldTransform,o=e.resolution;r.setTransform(i.a*o,i.b*o,i.c*o,i.d*o,i.tx*o,i.ty*o),t.canvasTintDirty===t.dirty&&t._prevTint===t.tint||this.updateGraphicsTint(t),e.setBlendMode(t.blendMode);for(var a=0;a<t.graphicsData.length;a++){var u=t.graphicsData[a],h=u.shape,l=u._fillTint,c=u._lineTint;if(r.lineWidth=u.lineWidth,u.type===s.SHAPES.POLY){r.beginPath();var d=h.points,f=u.holes,p=void 0,v=void 0,g=void 0,y=void 0;r.moveTo(d[0],d[1]);for(var m=2;m<d.length;m+=2)r.lineTo(d[m],d[m+1]);if(h.closed&&r.closePath(),f.length>0){p=0,g=d[0],y=d[1];for(var _=2;_+2<d.length;_+=2)p+=(d[_]-g)*(d[_+3]-y)-(d[_+2]-g)*(d[_+1]-y);for(var b=0;b<f.length;b++)if(d=f[b].points){v=0,g=d[0],y=d[1];for(var x=2;x+2<d.length;x+=2)v+=(d[x]-g)*(d[x+3]-y)-(d[x+2]-g)*(d[x+1]-y);if(v*p<0){r.moveTo(d[0],d[1]);for(var T=2;T<d.length;T+=2)r.lineTo(d[T],d[T+1])}else{r.moveTo(d[d.length-2],d[d.length-1]);for(var w=d.length-4;w>=0;w-=2)r.lineTo(d[w],d[w+1])}f[b].close&&r.closePath()}}u.fill&&(r.globalAlpha=u.fillAlpha*n,r.fillStyle="#"+("00000"+(0|l).toString(16)).substr(-6),r.fill()),u.lineWidth&&(r.globalAlpha=u.lineAlpha*n,r.strokeStyle="#"+("00000"+(0|c).toString(16)).substr(-6),r.stroke())}else if(u.type===s.SHAPES.RECT)(u.fillColor||0===u.fillColor)&&(r.globalAlpha=u.fillAlpha*n,r.fillStyle="#"+("00000"+(0|l).toString(16)).substr(-6),r.fillRect(h.x,h.y,h.width,h.height)),u.lineWidth&&(r.globalAlpha=u.lineAlpha*n,r.strokeStyle="#"+("00000"+(0|c).toString(16)).substr(-6),r.strokeRect(h.x,h.y,h.width,h.height));else if(u.type===s.SHAPES.CIRC)r.beginPath(),r.arc(h.x,h.y,h.radius,0,2*Math.PI),r.closePath(),u.fill&&(r.globalAlpha=u.fillAlpha*n,r.fillStyle="#"+("00000"+(0|l).toString(16)).substr(-6),r.fill()),u.lineWidth&&(r.globalAlpha=u.lineAlpha*n,r.strokeStyle="#"+("00000"+(0|c).toString(16)).substr(-6),r.stroke());else if(u.type===s.SHAPES.ELIP){var E=2*h.width,S=2*h.height,O=h.x-E/2,M=h.y-S/2;r.beginPath();var P=E/2*.5522848,C=S/2*.5522848,R=O+E,A=M+S,I=O+E/2,D=M+S/2;r.moveTo(O,D),r.bezierCurveTo(O,D-C,I-P,M,I,M),r.bezierCurveTo(I+P,M,R,D-C,R,D),r.bezierCurveTo(R,D+C,I+P,A,I,A),r.bezierCurveTo(I-P,A,O,D+C,O,D),r.closePath(),u.fill&&(r.globalAlpha=u.fillAlpha*n,r.fillStyle="#"+("00000"+(0|l).toString(16)).substr(-6),r.fill()),u.lineWidth&&(r.globalAlpha=u.lineAlpha*n,r.strokeStyle="#"+("00000"+(0|c).toString(16)).substr(-6),r.stroke())}else if(u.type===s.SHAPES.RREC){var L=h.x,N=h.y,B=h.width,k=h.height,F=h.radius,j=Math.min(B,k)/2|0;F=F>j?j:F,r.beginPath(),r.moveTo(L,N+F),r.lineTo(L,N+k-F),r.quadraticCurveTo(L,N+k,L+F,N+k),r.lineTo(L+B-F,N+k),r.quadraticCurveTo(L+B,N+k,L+B,N+k-F),r.lineTo(L+B,N+F),r.quadraticCurveTo(L+B,N,L+B-F,N),r.lineTo(L+F,N),r.quadraticCurveTo(L,N,L,N+F),r.closePath(),(u.fillColor||0===u.fillColor)&&(r.globalAlpha=u.fillAlpha*n,r.fillStyle="#"+("00000"+(0|l).toString(16)).substr(-6),r.fill()),u.lineWidth&&(r.globalAlpha=u.lineAlpha*n,r.strokeStyle="#"+("00000"+(0|c).toString(16)).substr(-6),r.stroke())}}},t.prototype.updateGraphicsTint=function(t){t._prevTint=t.tint,t.canvasTintDirty=t.dirty;for(var e=(t.tint>>16&255)/255,r=(t.tint>>8&255)/255,n=(255&t.tint)/255,i=0;i<t.graphicsData.length;++i){var o=t.graphicsData[i],s=0|o.fillColor,a=0|o.lineColor;o._fillTint=((s>>16&255)/255*e*255<<16)+((s>>8&255)/255*r*255<<8)+(255&s)/255*n*255,o._lineTint=((a>>16&255)/255*e*255<<16)+((a>>8&255)/255*r*255<<8)+(255&a)/255*n*255}},t.prototype.renderPolygon=function(t,e,r){r.moveTo(t[0],t[1]);for(var n=1;n<t.length/2;++n)r.lineTo(t[2*n],t[2*n+1]);e&&r.closePath()},t.prototype.destroy=function(){this.renderer=null},t}();r.default=a,o.default.registerPlugin("graphics",a)},{"../../const":46,"../../renderers/canvas/CanvasRenderer":77}],56:[function(t,e,r){"use strict";function n(t,e,r,n,i,o,s,a,u){var h=arguments.length>9&&void 0!==arguments[9]?arguments[9]:[],l=0,c=0,d=0,f=0,p=0;h.push(t,e);for(var v=1,g=0;v<=u;++v)g=v/u,l=1-g,c=l*l,d=c*l,f=g*g,p=f*g,h.push(d*t+3*c*g*r+3*l*f*i+p*s,d*e+3*c*g*n+3*l*f*o+p*a);return h}r.__esModule=!0,r.default=n},{}],57:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("../../utils"),u=t("../../const"),h=t("../../renderers/webgl/utils/ObjectRenderer"),l=n(h),c=t("../../renderers/webgl/WebGLRenderer"),d=n(c),f=t("./WebGLGraphicsData"),p=n(f),v=t("./shaders/PrimitiveShader"),g=n(v),y=t("./utils/buildPoly"),m=n(y),_=t("./utils/buildRectangle"),b=n(_),x=t("./utils/buildRoundedRectangle"),T=n(x),w=t("./utils/buildCircle"),E=n(w),S=function(t){function e(r){i(this,e);var n=o(this,t.call(this,r));return n.graphicsDataPool=[],n.primitiveShader=null,n.gl=r.gl,n.CONTEXT_UID=0,n}return s(e,t),e.prototype.onContextChange=function(){this.gl=this.renderer.gl,this.CONTEXT_UID=this.renderer.CONTEXT_UID,this.primitiveShader=new g.default(this.gl)},e.prototype.destroy=function(){l.default.prototype.destroy.call(this);for(var t=0;t<this.graphicsDataPool.length;++t)this.graphicsDataPool[t].destroy();this.graphicsDataPool=null},e.prototype.render=function(t){var e=this.renderer,r=e.gl,n=void 0,i=t._webGL[this.CONTEXT_UID];i&&t.dirty===i.dirty||(this.updateGraphics(t),i=t._webGL[this.CONTEXT_UID]);var o=this.primitiveShader;e.bindShader(o),e.state.setBlendMode(t.blendMode);for(var s=0,u=i.data.length;s<u;s++){n=i.data[s];var h=n.shader;e.bindShader(h),h.uniforms.translationMatrix=t.transform.worldTransform.toArray(!0),h.uniforms.tint=(0,a.hex2rgb)(t.tint),h.uniforms.alpha=t.worldAlpha,e.bindVao(n.vao),n.nativeLines?r.drawArrays(r.LINES,0,n.points.length/6):n.vao.draw(r.TRIANGLE_STRIP,n.indices.length)}},e.prototype.updateGraphics=function(t){var e=this.renderer.gl,r=t._webGL[this.CONTEXT_UID];if(r||(r=t._webGL[this.CONTEXT_UID]={lastIndex:0,data:[],gl:e,clearDirty:-1,dirty:-1}),r.dirty=t.dirty,t.clearDirty!==r.clearDirty){r.clearDirty=t.clearDirty;for(var n=0;n<r.data.length;n++)this.graphicsDataPool.push(r.data[n]);r.data.length=0,r.lastIndex=0}for(var i=void 0,o=void 0,s=r.lastIndex;s<t.graphicsData.length;s++){var a=t.graphicsData[s];i=this.getWebGLData(r,0),a.nativeLines&&a.lineWidth&&(o=this.getWebGLData(r,0,!0),r.lastIndex++),a.type===u.SHAPES.POLY&&(0,m.default)(a,i,o),a.type===u.SHAPES.RECT?(0,b.default)(a,i,o):a.type===u.SHAPES.CIRC||a.type===u.SHAPES.ELIP?(0,E.default)(a,i,o):a.type===u.SHAPES.RREC&&(0,T.default)(a,i,o),r.lastIndex++}this.renderer.bindVao(null);for(var h=0;h<r.data.length;h++)i=r.data[h],i.dirty&&i.upload()},e.prototype.getWebGLData=function(t,e,r){var n=t.data[t.data.length-1];return(!n||n.nativeLines!==r||n.points.length>32e4)&&(n=this.graphicsDataPool.pop()||new p.default(this.renderer.gl,this.primitiveShader,this.renderer.state.attribsState),n.nativeLines=r,n.reset(e),t.data.push(n)),n.dirty=!0,n},e}(l.default);r.default=S,d.default.registerPlugin("graphics",S)},{"../../const":46,"../../renderers/webgl/WebGLRenderer":84,"../../renderers/webgl/utils/ObjectRenderer":94,"../../utils":125,"./WebGLGraphicsData":58,"./shaders/PrimitiveShader":59,"./utils/buildCircle":60,"./utils/buildPoly":62,"./utils/buildRectangle":63,"./utils/buildRoundedRectangle":64}],58:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("pixi-gl-core"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=function(){function t(e,r,i){n(this,t),this.gl=e,this.color=[0,0,0],this.points=[],this.indices=[],this.buffer=o.default.GLBuffer.createVertexBuffer(e),this.indexBuffer=o.default.GLBuffer.createIndexBuffer(e),this.dirty=!0,this.nativeLines=!1,this.glPoints=null,this.glIndices=null,this.shader=r,this.vao=new o.default.VertexArrayObject(e,i).addIndex(this.indexBuffer).addAttribute(this.buffer,r.attributes.aVertexPosition,e.FLOAT,!1,24,0).addAttribute(this.buffer,r.attributes.aColor,e.FLOAT,!1,24,8)}return t.prototype.reset=function(){this.points.length=0,this.indices.length=0},t.prototype.upload=function(){this.glPoints=new Float32Array(this.points),this.buffer.upload(this.glPoints),this.glIndices=new Uint16Array(this.indices),this.indexBuffer.upload(this.glIndices),this.dirty=!1},t.prototype.destroy=function(){this.color=null,this.points=null,this.indices=null,this.vao.destroy(),this.buffer.destroy(),this.indexBuffer.destroy(),this.gl=null,this.buffer=null,this.indexBuffer=null,this.glPoints=null,this.glIndices=null},t}();r.default=s},{"pixi-gl-core":15}],59:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=t("../../../Shader"),a=function(t){return t&&t.__esModule?t:{default:t}}(s),u=function(t){function e(r){return n(this,e),i(this,t.call(this,r,["attribute vec2 aVertexPosition;","attribute vec4 aColor;","uniform mat3 translationMatrix;","uniform mat3 projectionMatrix;","uniform float alpha;","uniform vec3 tint;","varying vec4 vColor;","void main(void){","   gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);","   vColor = aColor * vec4(tint * alpha, alpha);","}"].join("\n"),["varying vec4 vColor;","void main(void){","   gl_FragColor = vColor;","}"].join("\n")))}return o(e,t),e}(a.default);r.default=u},{"../../../Shader":44}],60:[function(t,e,r){"use strict";function n(t,e,r){var n=t.shape,i=n.x,u=n.y,h=void 0,l=void 0;if(t.type===s.SHAPES.CIRC?(h=n.radius,l=n.radius):(h=n.width,l=n.height),0!==h&&0!==l){var c=Math.floor(30*Math.sqrt(n.radius))||Math.floor(15*Math.sqrt(n.width+n.height)),d=2*Math.PI/c;if(t.fill){var f=(0,a.hex2rgb)(t.fillColor),p=t.fillAlpha,v=f[0]*p,g=f[1]*p,y=f[2]*p,m=e.points,_=e.indices,b=m.length/6;_.push(b);for(var x=0;x<c+1;x++)m.push(i,u,v,g,y,p),m.push(i+Math.sin(d*x)*h,u+Math.cos(d*x)*l,v,g,y,p),_.push(b++,b++);_.push(b-1)}if(t.lineWidth){var T=t.points;t.points=[];for(var w=0;w<c;w++)t.points.push(i+Math.sin(d*-w)*h,u+Math.cos(d*-w)*l);t.points.push(t.points[0],t.points[1]),(0,o.default)(t,e,r),t.points=T}}}r.__esModule=!0,r.default=n;var i=t("./buildLine"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=t("../../../const"),a=t("../../../utils")},{"../../../const":46,"../../../utils":125,"./buildLine":61}],61:[function(t,e,r){"use strict";function n(t,e){var r=t.points;if(0!==r.length){var n=new o.Point(r[0],r[1]),i=new o.Point(r[r.length-2],r[r.length-1]);if(n.x===i.x&&n.y===i.y){r=r.slice(),r.pop(),r.pop(),i=new o.Point(r[r.length-2],r[r.length-1]);var a=i.x+.5*(n.x-i.x),u=i.y+.5*(n.y-i.y);r.unshift(a,u),r.push(a,u)}var h=e.points,l=e.indices,c=r.length/2,d=r.length,f=h.length/6,p=t.lineWidth/2,v=(0,s.hex2rgb)(t.lineColor),g=t.lineAlpha,y=v[0]*g,m=v[1]*g,_=v[2]*g,b=r[0],x=r[1],T=r[2],w=r[3],E=0,S=0,O=-(x-w),M=b-T,P=0,C=0,R=0,A=0,I=Math.sqrt(O*O+M*M);O/=I,M/=I,O*=p,M*=p;var D=t.lineAlignment,L=2*(1-D),N=2*D;h.push(b-O*L,x-M*L,y,m,_,g),h.push(b+O*N,x+M*N,y,m,_,g);for(var B=1;B<c-1;++B){b=r[2*(B-1)],x=r[2*(B-1)+1],T=r[2*B],w=r[2*B+1],E=r[2*(B+1)],S=r[2*(B+1)+1],O=-(x-w),M=b-T,I=Math.sqrt(O*O+M*M),O/=I,M/=I,O*=p,M*=p,P=-(w-S),C=T-E,I=Math.sqrt(P*P+C*C),P/=I,C/=I,P*=p,C*=p;var k=-M+x-(-M+w),F=-O+T-(-O+b),j=(-O+b)*(-M+w)-(-O+T)*(-M+x),U=-C+S-(-C+w),X=-P+T-(-P+E),G=(-P+E)*(-C+w)-(-P+T)*(-C+S),W=k*X-U*F;if(Math.abs(W)<.1)W+=10.1,h.push(T-O*L,w-M*L,y,m,_,g),h.push(T+O*N,w+M*N,y,m,_,g);else{var H=(F*G-X*j)/W,Y=(U*j-k*G)/W;(H-T)*(H-T)+(Y-w)*(Y-w)>196*p*p?(R=O-P,A=M-C,
I=Math.sqrt(R*R+A*A),R/=I,A/=I,R*=p,A*=p,h.push(T-R*L,w-A*L),h.push(y,m,_,g),h.push(T+R*N,w+A*N),h.push(y,m,_,g),h.push(T-R*N*L,w-A*L),h.push(y,m,_,g),d++):(h.push(T+(H-T)*L,w+(Y-w)*L),h.push(y,m,_,g),h.push(T-(H-T)*N,w-(Y-w)*N),h.push(y,m,_,g))}}b=r[2*(c-2)],x=r[2*(c-2)+1],T=r[2*(c-1)],w=r[2*(c-1)+1],O=-(x-w),M=b-T,I=Math.sqrt(O*O+M*M),O/=I,M/=I,O*=p,M*=p,h.push(T-O*L,w-M*L),h.push(y,m,_,g),h.push(T+O*N,w+M*N),h.push(y,m,_,g),l.push(f);for(var V=0;V<d;++V)l.push(f++);l.push(f-1)}}function i(t,e){var r=0,n=t.points;if(0!==n.length){var i=e.points,o=n.length/2,a=(0,s.hex2rgb)(t.lineColor),u=t.lineAlpha,h=a[0]*u,l=a[1]*u,c=a[2]*u;for(r=1;r<o;r++){var d=n[2*(r-1)],f=n[2*(r-1)+1],p=n[2*r],v=n[2*r+1];i.push(d,f),i.push(h,l,c,u),i.push(p,v),i.push(h,l,c,u)}}}r.__esModule=!0,r.default=function(t,e,r){t.nativeLines?i(t,r):n(t,e)};var o=t("../../../math"),s=t("../../../utils")},{"../../../math":70,"../../../utils":125}],62:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e,r){t.points=t.shape.points.slice();var n=t.points;if(t.fill&&n.length>=6){for(var i=[],o=t.holes,u=0;u<o.length;u++){var l=o[u];i.push(n.length/2),n=n.concat(l.points)}var c=e.points,d=e.indices,f=n.length/2,p=(0,a.hex2rgb)(t.fillColor),v=t.fillAlpha,g=p[0]*v,y=p[1]*v,m=p[2]*v,_=(0,h.default)(n,i,2);if(!_)return;for(var b=c.length/6,x=0;x<_.length;x+=3)d.push(_[x]+b),d.push(_[x]+b),d.push(_[x+1]+b),d.push(_[x+2]+b),d.push(_[x+2]+b);for(var T=0;T<f;T++)c.push(n[2*T],n[2*T+1],g,y,m,v)}t.lineWidth>0&&(0,s.default)(t,e,r)}r.__esModule=!0,r.default=i;var o=t("./buildLine"),s=n(o),a=t("../../../utils"),u=t("earcut"),h=n(u)},{"../../../utils":125,"./buildLine":61,earcut:2}],63:[function(t,e,r){"use strict";function n(t,e,r){var n=t.shape,i=n.x,a=n.y,u=n.width,h=n.height;if(t.fill){var l=(0,s.hex2rgb)(t.fillColor),c=t.fillAlpha,d=l[0]*c,f=l[1]*c,p=l[2]*c,v=e.points,g=e.indices,y=v.length/6;v.push(i,a),v.push(d,f,p,c),v.push(i+u,a),v.push(d,f,p,c),v.push(i,a+h),v.push(d,f,p,c),v.push(i+u,a+h),v.push(d,f,p,c),g.push(y,y,y+1,y+2,y+3,y+3)}if(t.lineWidth){var m=t.points;t.points=[i,a,i+u,a,i+u,a+h,i,a+h,i,a],(0,o.default)(t,e,r),t.points=m}}r.__esModule=!0,r.default=n;var i=t("./buildLine"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=t("../../../utils")},{"../../../utils":125,"./buildLine":61}],64:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e,r){var n=t.shape,i=n.x,o=n.y,a=n.width,h=n.height,d=n.radius,f=[];if(f.push(i+d,o),s(i+a-d,o,i+a,o,i+a,o+d,f),s(i+a,o+h-d,i+a,o+h,i+a-d,o+h,f),s(i+d,o+h,i,o+h,i,o+h-d,f),s(i,o+d,i,o,i+d+1e-10,o,f),t.fill){for(var p=(0,c.hex2rgb)(t.fillColor),v=t.fillAlpha,g=p[0]*v,y=p[1]*v,m=p[2]*v,_=e.points,b=e.indices,x=_.length/6,T=(0,u.default)(f,null,2),w=0,E=T.length;w<E;w+=3)b.push(T[w]+x),b.push(T[w]+x),b.push(T[w+1]+x),b.push(T[w+2]+x),b.push(T[w+2]+x);for(var S=0,O=f.length;S<O;S++)_.push(f[S],f[++S],g,y,m,v)}if(t.lineWidth){var M=t.points;t.points=f,(0,l.default)(t,e,r),t.points=M}}function o(t,e,r){return t+(e-t)*r}function s(t,e,r,n,i,s){for(var a=arguments.length>6&&void 0!==arguments[6]?arguments[6]:[],u=a,h=0,l=0,c=0,d=0,f=0,p=0,v=0,g=0;v<=20;++v)g=v/20,h=o(t,r,g),l=o(e,n,g),c=o(r,i,g),d=o(n,s,g),f=o(h,c,g),p=o(l,d,g),u.push(f,p);return u}r.__esModule=!0,r.default=i;var a=t("earcut"),u=n(a),h=t("./buildLine"),l=n(h),c=t("../../../utils")},{"../../../utils":125,"./buildLine":61,earcut:2}],65:[function(t,e,r){"use strict";function n(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}function i(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0,r.autoDetectRenderer=r.Application=r.Filter=r.SpriteMaskFilter=r.Quad=r.RenderTarget=r.ObjectRenderer=r.WebGLManager=r.Shader=r.CanvasRenderTarget=r.TextureUvs=r.VideoBaseTexture=r.BaseRenderTexture=r.RenderTexture=r.BaseTexture=r.TextureMatrix=r.Texture=r.Spritesheet=r.CanvasGraphicsRenderer=r.GraphicsRenderer=r.GraphicsData=r.Graphics=r.TextMetrics=r.TextStyle=r.Text=r.SpriteRenderer=r.CanvasTinter=r.CanvasSpriteRenderer=r.Sprite=r.TransformBase=r.TransformStatic=r.Transform=r.Container=r.DisplayObject=r.Bounds=r.glCore=r.WebGLRenderer=r.CanvasRenderer=r.ticker=r.utils=r.settings=void 0;var o=t("./const");Object.keys(o).forEach(function(t){"default"!==t&&"__esModule"!==t&&Object.defineProperty(r,t,{enumerable:!0,get:function(){return o[t]}})});var s=t("./math");Object.keys(s).forEach(function(t){"default"!==t&&"__esModule"!==t&&Object.defineProperty(r,t,{enumerable:!0,get:function(){return s[t]}})});var a=t("pixi-gl-core");Object.defineProperty(r,"glCore",{enumerable:!0,get:function(){return i(a).default}});var u=t("./display/Bounds");Object.defineProperty(r,"Bounds",{enumerable:!0,get:function(){return i(u).default}});var h=t("./display/DisplayObject");Object.defineProperty(r,"DisplayObject",{enumerable:!0,get:function(){return i(h).default}});var l=t("./display/Container");Object.defineProperty(r,"Container",{enumerable:!0,get:function(){return i(l).default}});var c=t("./display/Transform");Object.defineProperty(r,"Transform",{enumerable:!0,get:function(){return i(c).default}});var d=t("./display/TransformStatic");Object.defineProperty(r,"TransformStatic",{enumerable:!0,get:function(){return i(d).default}});var f=t("./display/TransformBase");Object.defineProperty(r,"TransformBase",{enumerable:!0,get:function(){return i(f).default}});var p=t("./sprites/Sprite");Object.defineProperty(r,"Sprite",{enumerable:!0,get:function(){return i(p).default}});var v=t("./sprites/canvas/CanvasSpriteRenderer");Object.defineProperty(r,"CanvasSpriteRenderer",{enumerable:!0,get:function(){return i(v).default}});var g=t("./sprites/canvas/CanvasTinter");Object.defineProperty(r,"CanvasTinter",{enumerable:!0,get:function(){return i(g).default}});var y=t("./sprites/webgl/SpriteRenderer");Object.defineProperty(r,"SpriteRenderer",{enumerable:!0,get:function(){return i(y).default}});var m=t("./text/Text");Object.defineProperty(r,"Text",{enumerable:!0,get:function(){return i(m).default}});var _=t("./text/TextStyle");Object.defineProperty(r,"TextStyle",{enumerable:!0,get:function(){return i(_).default}});var b=t("./text/TextMetrics");Object.defineProperty(r,"TextMetrics",{enumerable:!0,get:function(){return i(b).default}});var x=t("./graphics/Graphics");Object.defineProperty(r,"Graphics",{enumerable:!0,get:function(){return i(x).default}});var T=t("./graphics/GraphicsData");Object.defineProperty(r,"GraphicsData",{enumerable:!0,get:function(){return i(T).default}});var w=t("./graphics/webgl/GraphicsRenderer");Object.defineProperty(r,"GraphicsRenderer",{enumerable:!0,get:function(){return i(w).default}});var E=t("./graphics/canvas/CanvasGraphicsRenderer");Object.defineProperty(r,"CanvasGraphicsRenderer",{enumerable:!0,get:function(){return i(E).default}});var S=t("./textures/Spritesheet");Object.defineProperty(r,"Spritesheet",{enumerable:!0,get:function(){return i(S).default}});var O=t("./textures/Texture");Object.defineProperty(r,"Texture",{enumerable:!0,get:function(){return i(O).default}});var M=t("./textures/TextureMatrix");Object.defineProperty(r,"TextureMatrix",{enumerable:!0,get:function(){return i(M).default}});var P=t("./textures/BaseTexture");Object.defineProperty(r,"BaseTexture",{enumerable:!0,get:function(){return i(P).default}});var C=t("./textures/RenderTexture");Object.defineProperty(r,"RenderTexture",{enumerable:!0,get:function(){return i(C).default}});var R=t("./textures/BaseRenderTexture");Object.defineProperty(r,"BaseRenderTexture",{enumerable:!0,get:function(){return i(R).default}});var A=t("./textures/VideoBaseTexture");Object.defineProperty(r,"VideoBaseTexture",{enumerable:!0,get:function(){return i(A).default}});var I=t("./textures/TextureUvs");Object.defineProperty(r,"TextureUvs",{enumerable:!0,get:function(){return i(I).default}});var D=t("./renderers/canvas/utils/CanvasRenderTarget");Object.defineProperty(r,"CanvasRenderTarget",{enumerable:!0,get:function(){return i(D).default}});var L=t("./Shader");Object.defineProperty(r,"Shader",{enumerable:!0,get:function(){return i(L).default}});var N=t("./renderers/webgl/managers/WebGLManager");Object.defineProperty(r,"WebGLManager",{enumerable:!0,get:function(){return i(N).default}});var B=t("./renderers/webgl/utils/ObjectRenderer");Object.defineProperty(r,"ObjectRenderer",{enumerable:!0,get:function(){return i(B).default}});var k=t("./renderers/webgl/utils/RenderTarget");Object.defineProperty(r,"RenderTarget",{enumerable:!0,get:function(){return i(k).default}});var F=t("./renderers/webgl/utils/Quad");Object.defineProperty(r,"Quad",{enumerable:!0,get:function(){return i(F).default}});var j=t("./renderers/webgl/filters/spriteMask/SpriteMaskFilter");Object.defineProperty(r,"SpriteMaskFilter",{enumerable:!0,get:function(){return i(j).default}});var U=t("./renderers/webgl/filters/Filter");Object.defineProperty(r,"Filter",{enumerable:!0,get:function(){return i(U).default}});var X=t("./Application");Object.defineProperty(r,"Application",{enumerable:!0,get:function(){return i(X).default}});var G=t("./autoDetectRenderer");Object.defineProperty(r,"autoDetectRenderer",{enumerable:!0,get:function(){return G.autoDetectRenderer}});var W=t("./utils"),H=n(W),Y=t("./ticker"),V=n(Y),z=t("./settings"),q=i(z),K=t("./renderers/canvas/CanvasRenderer"),Z=i(K),J=t("./renderers/webgl/WebGLRenderer"),Q=i(J);r.settings=q.default,r.utils=H,r.ticker=V,r.CanvasRenderer=Z.default,r.WebGLRenderer=Q.default},{"./Application":43,"./Shader":44,"./autoDetectRenderer":45,"./const":46,"./display/Bounds":47,"./display/Container":48,"./display/DisplayObject":49,"./display/Transform":50,"./display/TransformBase":51,"./display/TransformStatic":52,"./graphics/Graphics":53,"./graphics/GraphicsData":54,"./graphics/canvas/CanvasGraphicsRenderer":55,"./graphics/webgl/GraphicsRenderer":57,"./math":70,"./renderers/canvas/CanvasRenderer":77,"./renderers/canvas/utils/CanvasRenderTarget":79,"./renderers/webgl/WebGLRenderer":84,"./renderers/webgl/filters/Filter":86,"./renderers/webgl/filters/spriteMask/SpriteMaskFilter":89,"./renderers/webgl/managers/WebGLManager":93,"./renderers/webgl/utils/ObjectRenderer":94,"./renderers/webgl/utils/Quad":95,"./renderers/webgl/utils/RenderTarget":96,"./settings":101,"./sprites/Sprite":102,"./sprites/canvas/CanvasSpriteRenderer":103,"./sprites/canvas/CanvasTinter":104,"./sprites/webgl/SpriteRenderer":106,"./text/Text":108,"./text/TextMetrics":109,"./text/TextStyle":110,"./textures/BaseRenderTexture":111,"./textures/BaseTexture":112,"./textures/RenderTexture":113,"./textures/Spritesheet":114,"./textures/Texture":115,"./textures/TextureMatrix":116,"./textures/TextureUvs":117,"./textures/VideoBaseTexture":118,"./ticker":121,"./utils":125,"pixi-gl-core":15}],66:[function(t,e,r){"use strict";function n(t){return t<0?-1:t>0?1:0}r.__esModule=!0;var i=t("./Matrix"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=[1,1,0,-1,-1,-1,0,1,1,1,0,-1,-1,-1,0,1],a=[0,1,1,1,0,-1,-1,-1,0,1,1,1,0,-1,-1,-1],u=[0,-1,-1,-1,0,1,1,1,0,1,1,1,0,-1,-1,-1],h=[1,1,0,-1,-1,-1,0,1,-1,-1,0,1,1,1,0,-1],l=[],c=[];!function(){for(var t=0;t<16;t++){var e=[];c.push(e);for(var r=0;r<16;r++)for(var i=n(s[t]*s[r]+u[t]*a[r]),d=n(a[t]*s[r]+h[t]*a[r]),f=n(s[t]*u[r]+u[t]*h[r]),p=n(a[t]*u[r]+h[t]*h[r]),v=0;v<16;v++)if(s[v]===i&&a[v]===d&&u[v]===f&&h[v]===p){e.push(v);break}}for(var g=0;g<16;g++){var y=new o.default;y.set(s[g],a[g],u[g],h[g],0,0),l.push(y)}}();var d={E:0,SE:1,S:2,SW:3,W:4,NW:5,N:6,NE:7,MIRROR_VERTICAL:8,MIRROR_HORIZONTAL:12,uX:function(t){return s[t]},uY:function(t){return a[t]},vX:function(t){return u[t]},vY:function(t){return h[t]},inv:function(t){return 8&t?15&t:7&-t},add:function(t,e){return c[t][e]},sub:function(t,e){return c[t][d.inv(e)]},rotate180:function(t){return 4^t},isVertical:function(t){return 2==(3&t)},byDirection:function(t,e){return 2*Math.abs(t)<=Math.abs(e)?e>=0?d.S:d.N:2*Math.abs(e)<=Math.abs(t)?t>0?d.E:d.W:e>0?t>0?d.SE:d.SW:t>0?d.NE:d.NW},matrixAppendRotationInv:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,i=l[d.inv(e)];i.tx=r,i.ty=n,t.append(i)}};r.default=d},{"./Matrix":67}],67:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),o=t("./Point"),s=function(t){return t&&t.__esModule?t:{default:t}}(o),a=t("../const"),u=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1,s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;n(this,t),this.a=e,this.b=r,this.c=i,this.d=o,this.tx=s,this.ty=a,this.array=null}return t.prototype.fromArray=function(t){this.a=t[0],this.b=t[1],this.c=t[3],this.d=t[4],this.tx=t[2],this.ty=t[5]},t.prototype.set=function(t,e,r,n,i,o){return this.a=t,this.b=e,this.c=r,this.d=n,this.tx=i,this.ty=o,this},t.prototype.toArray=function(t,e){this.array||(this.array=new Float32Array(9));var r=e||this.array;return t?(r[0]=this.a,r[1]=this.b,r[2]=0,r[3]=this.c,r[4]=this.d,r[5]=0,r[6]=this.tx,r[7]=this.ty,r[8]=1):(r[0]=this.a,r[1]=this.c,r[2]=this.tx,r[3]=this.b,r[4]=this.d,r[5]=this.ty,r[6]=0,r[7]=0,r[8]=1),r},t.prototype.apply=function(t,e){e=e||new s.default;var r=t.x,n=t.y;return e.x=this.a*r+this.c*n+this.tx,e.y=this.b*r+this.d*n+this.ty,e},t.prototype.applyInverse=function(t,e){e=e||new s.default;var r=1/(this.a*this.d+this.c*-this.b),n=t.x,i=t.y;return e.x=this.d*r*n+-this.c*r*i+(this.ty*this.c-this.tx*this.d)*r,e.y=this.a*r*i+-this.b*r*n+(-this.ty*this.a+this.tx*this.b)*r,e},t.prototype.translate=function(t,e){return this.tx+=t,this.ty+=e,this},t.prototype.scale=function(t,e){return this.a*=t,this.d*=e,this.c*=t,this.b*=e,this.tx*=t,this.ty*=e,this},t.prototype.rotate=function(t){var e=Math.cos(t),r=Math.sin(t),n=this.a,i=this.c,o=this.tx;return this.a=n*e-this.b*r,this.b=n*r+this.b*e,this.c=i*e-this.d*r,this.d=i*r+this.d*e,this.tx=o*e-this.ty*r,this.ty=o*r+this.ty*e,this},t.prototype.append=function(t){var e=this.a,r=this.b,n=this.c,i=this.d;return this.a=t.a*e+t.b*n,this.b=t.a*r+t.b*i,this.c=t.c*e+t.d*n,this.d=t.c*r+t.d*i,this.tx=t.tx*e+t.ty*n+this.tx,this.ty=t.tx*r+t.ty*i+this.ty,this},t.prototype.setTransform=function(t,e,r,n,i,o,s,a,u){return this.a=Math.cos(s+u)*i,this.b=Math.sin(s+u)*i,this.c=-Math.sin(s-a)*o,this.d=Math.cos(s-a)*o,this.tx=t-(r*this.a+n*this.c),this.ty=e-(r*this.b+n*this.d),this},t.prototype.prepend=function(t){var e=this.tx;if(1!==t.a||0!==t.b||0!==t.c||1!==t.d){var r=this.a,n=this.c;this.a=r*t.a+this.b*t.c,this.b=r*t.b+this.b*t.d,this.c=n*t.a+this.d*t.c,this.d=n*t.b+this.d*t.d}return this.tx=e*t.a+this.ty*t.c+t.tx,this.ty=e*t.b+this.ty*t.d+t.ty,this},t.prototype.decompose=function(t){var e=this.a,r=this.b,n=this.c,i=this.d,o=-Math.atan2(-n,i),s=Math.atan2(r,e),u=Math.abs(o+s);return u<1e-5||Math.abs(a.PI_2-u)<1e-5?(t.rotation=s,t.skew.x=t.skew.y=0):(t.rotation=0,t.skew.x=o,t.skew.y=s),t.scale.x=Math.sqrt(e*e+r*r),t.scale.y=Math.sqrt(n*n+i*i),t.position.x=this.tx,t.position.y=this.ty,t},t.prototype.invert=function(){var t=this.a,e=this.b,r=this.c,n=this.d,i=this.tx,o=t*n-e*r;return this.a=n/o,this.b=-e/o,this.c=-r/o,this.d=t/o,this.tx=(r*this.ty-n*i)/o,this.ty=-(t*this.ty-e*i)/o,this},t.prototype.identity=function(){return this.a=1,this.b=0,this.c=0,this.d=1,this.tx=0,this.ty=0,this},t.prototype.clone=function(){var e=new t;return e.a=this.a,e.b=this.b,e.c=this.c,e.d=this.d,e.tx=this.tx,e.ty=this.ty,e},t.prototype.copy=function(t){return t.a=this.a,t.b=this.b,t.c=this.c,t.d=this.d,t.tx=this.tx,t.ty=this.ty,t},i(t,null,[{key:"IDENTITY",get:function(){return new t}},{key:"TEMP_MATRIX",get:function(){return new t}}]),t}();r.default=u},{"../const":46,"./Point":69}],68:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),o=function(){function t(e,r){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;n(this,t),this._x=i,this._y=o,this.cb=e,this.scope=r}return t.prototype.clone=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return new t(e||this.cb,r||this.scope,this._x,this._y)},t.prototype.set=function(t,e){var r=t||0,n=e||(0!==e?r:0);this._x===r&&this._y===n||(this._x=r,this._y=n,this.cb.call(this.scope))},t.prototype.copy=function(t){this._x===t.x&&this._y===t.y||(this._x=t.x,this._y=t.y,this.cb.call(this.scope))},t.prototype.equals=function(t){return t.x===this._x&&t.y===this._y},i(t,[{key:"x",get:function(){return this._x},set:function(t){this._x!==t&&(this._x=t,this.cb.call(this.scope))}},{key:"y",get:function(){return this._y},set:function(t){this._y!==t&&(this._y=t,this.cb.call(this.scope))}}]),t}();r.default=o},{}],69:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;n(this,t),this.x=e,this.y=r}return t.prototype.clone=function(){return new t(this.x,this.y)},t.prototype.copy=function(t){this.set(t.x,t.y)},t.prototype.equals=function(t){return t.x===this.x&&t.y===this.y},t.prototype.set=function(t,e){this.x=t||0,this.y=e||(0!==e?this.x:0)},t}();r.default=i},{}],70:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0;var i=t("./Point");Object.defineProperty(r,"Point",{enumerable:!0,get:function(){return n(i).default}});var o=t("./ObservablePoint");Object.defineProperty(r,"ObservablePoint",{enumerable:!0,get:function(){return n(o).default}});var s=t("./Matrix");Object.defineProperty(r,"Matrix",{enumerable:!0,get:function(){return n(s).default}});var a=t("./GroupD8");Object.defineProperty(r,"GroupD8",{enumerable:!0,get:function(){return n(a).default}});var u=t("./shapes/Circle");Object.defineProperty(r,"Circle",{enumerable:!0,get:function(){return n(u).default}});var h=t("./shapes/Ellipse");Object.defineProperty(r,"Ellipse",{enumerable:!0,get:function(){return n(h).default}});var l=t("./shapes/Polygon");Object.defineProperty(r,"Polygon",{enumerable:!0,get:function(){return n(l).default}});var c=t("./shapes/Rectangle");Object.defineProperty(r,"Rectangle",{enumerable:!0,get:function(){return n(c).default}});var d=t("./shapes/RoundedRectangle");Object.defineProperty(r,"RoundedRectangle",{enumerable:!0,get:function(){return n(d).default}})},{"./GroupD8":66,"./Matrix":67,"./ObservablePoint":68,"./Point":69,"./shapes/Circle":71,"./shapes/Ellipse":72,"./shapes/Polygon":73,"./shapes/Rectangle":74,"./shapes/RoundedRectangle":75}],71:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("./Rectangle"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=t("../../const"),a=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;n(this,t),this.x=e,this.y=r,this.radius=i,this.type=s.SHAPES.CIRC}return t.prototype.clone=function(){return new t(this.x,this.y,this.radius)},t.prototype.contains=function(t,e){if(this.radius<=0)return!1;var r=this.radius*this.radius,n=this.x-t,i=this.y-e;return n*=n,i*=i,n+i<=r},t.prototype.getBounds=function(){return new o.default(this.x-this.radius,this.y-this.radius,2*this.radius,2*this.radius)},t}();r.default=a},{"../../const":46,"./Rectangle":74}],72:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("./Rectangle"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=t("../../const"),a=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;n(this,t),this.x=e,this.y=r,this.width=i,this.height=o,this.type=s.SHAPES.ELIP}return t.prototype.clone=function(){return new t(this.x,this.y,this.width,this.height)},t.prototype.contains=function(t,e){if(this.width<=0||this.height<=0)return!1;var r=(t-this.x)/this.width,n=(e-this.y)/this.height;return r*=r,n*=n,r+n<=1},t.prototype.getBounds=function(){return new o.default(this.x-this.width,this.y-this.height,this.width,this.height)},t}();r.default=a},{"../../const":46,"./Rectangle":74}],73:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../Point"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=t("../../const"),a=function(){function t(){for(var e=arguments.length,r=Array(e),i=0;i<e;i++)r[i]=arguments[i];if(n(this,t),Array.isArray(r[0])&&(r=r[0]),r[0]instanceof o.default){for(var a=[],u=0,h=r.length;u<h;u++)a.push(r[u].x,r[u].y);r=a}this.closed=!0,this.points=r,this.type=s.SHAPES.POLY}return t.prototype.clone=function(){return new t(this.points.slice())},t.prototype.close=function(){var t=this.points;t[0]===t[t.length-2]&&t[1]===t[t.length-1]||t.push(t[0],t[1])},t.prototype.contains=function(t,e){for(var r=!1,n=this.points.length/2,i=0,o=n-1;i<n;o=i++){var s=this.points[2*i],a=this.points[2*i+1],u=this.points[2*o],h=this.points[2*o+1];a>e!=h>e&&t<(e-a)/(h-a)*(u-s)+s&&(r=!r)}return r},t}();r.default=a},{"../../const":46,"../Point":69}],74:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),o=t("../../const"),s=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,s=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;n(this,t),this.x=Number(e),this.y=Number(r),this.width=Number(i),this.height=Number(s),this.type=o.SHAPES.RECT}return t.prototype.clone=function(){return new t(this.x,this.y,this.width,this.height)},t.prototype.copy=function(t){return this.x=t.x,this.y=t.y,this.width=t.width,this.height=t.height,this},t.prototype.contains=function(t,e){return!(this.width<=0||this.height<=0)&&(t>=this.x&&t<this.x+this.width&&e>=this.y&&e<this.y+this.height)},t.prototype.pad=function(t,e){t=t||0,e=e||(0!==e?t:0),this.x-=t,this.y-=e,this.width+=2*t,this.height+=2*e},t.prototype.fit=function(t){var e=Math.max(this.x,t.x),r=Math.min(this.x+this.width,t.x+t.width),n=Math.max(this.y,t.y),i=Math.min(this.y+this.height,t.y+t.height);this.x=e,this.width=Math.max(r-e,0),this.y=n,this.height=Math.max(i-n,0)},t.prototype.enlarge=function(t){var e=Math.min(this.x,t.x),r=Math.max(this.x+this.width,t.x+t.width),n=Math.min(this.y,t.y),i=Math.max(this.y+this.height,t.y+t.height);this.x=e,this.width=r-e,this.y=n,this.height=i-n},t.prototype.ceil=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:.001,r=Math.ceil((this.x+this.width-e)*t)/t,n=Math.ceil((this.y+this.height-e)*t)/t;this.x=Math.floor((this.x+e)*t)/t,this.y=Math.floor((this.y+e)*t)/t,this.width=r-this.x,this.height=n-this.y},i(t,[{key:"left",get:function(){return this.x}},{key:"right",get:function(){return this.x+this.width}},{key:"top",get:function(){return this.y}},{key:"bottom",get:function(){return this.y+this.height}}],[{key:"EMPTY",get:function(){return new t(0,0,0,0)}}]),t}();r.default=s},{"../../const":46}],75:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../../const"),o=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,s=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,a=arguments.length>4&&void 0!==arguments[4]?arguments[4]:20;n(this,t),this.x=e,this.y=r,this.width=o,this.height=s,this.radius=a,this.type=i.SHAPES.RREC}return t.prototype.clone=function(){return new t(this.x,this.y,this.width,this.height,this.radius)},t.prototype.contains=function(t,e){if(this.width<=0||this.height<=0)return!1;if(t>=this.x&&t<=this.x+this.width&&e>=this.y&&e<=this.y+this.height){if(e>=this.y+this.radius&&e<=this.y+this.height-this.radius||t>=this.x+this.radius&&t<=this.x+this.width-this.radius)return!0;var r=t-(this.x+this.radius),n=e-(this.y+this.radius),i=this.radius*this.radius;if(r*r+n*n<=i)return!0;if((r=t-(this.x+this.width-this.radius))*r+n*n<=i)return!0;if(n=e-(this.y+this.height-this.radius),r*r+n*n<=i)return!0;if((r=t-(this.x+this.radius))*r+n*n<=i)return!0}return!1},t}();r.default=o},{"../../const":46}],76:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),u=t("../utils"),h=t("../math"),l=t("../const"),c=t("../settings"),d=n(c),f=t("../display/Container"),p=n(f),v=t("../textures/RenderTexture"),g=n(v),y=t("eventemitter3"),m=n(y),_=new h.Matrix,b=function(t){function e(r,n,s,a){i(this,e);var c=o(this,t.call(this));return(0,u.sayHello)(r),"number"==typeof n&&(n=Object.assign({width:n,height:s||d.default.RENDER_OPTIONS.height},a)),n=Object.assign({},d.default.RENDER_OPTIONS,n),c.options=n,c.type=l.RENDERER_TYPE.UNKNOWN,c.screen=new h.Rectangle(0,0,n.width,n.height),c.view=n.view||document.createElement("canvas"),c.resolution=n.resolution||d.default.RESOLUTION,c.transparent=n.transparent,c.autoResize=n.autoResize||!1,c.blendModes=null,c.preserveDrawingBuffer=n.preserveDrawingBuffer,c.clearBeforeRender=n.clearBeforeRender,c.roundPixels=n.roundPixels,c._backgroundColor=0,c._backgroundColorRgba=[0,0,0,0],c._backgroundColorString="#000000",c.backgroundColor=n.backgroundColor||c._backgroundColor,c._tempDisplayObjectParent=new p.default,c._lastObjectRendered=c._tempDisplayObjectParent,c}return s(e,t),e.prototype.resize=function(t,e){this.screen.width=t,this.screen.height=e,this.view.width=t*this.resolution,this.view.height=e*this.resolution,this.autoResize&&(this.view.style.width=t+"px",this.view.style.height=e+"px")},e.prototype.generateTexture=function(t,e,r,n){n=n||t.getLocalBounds();var i=g.default.create(0|n.width,0|n.height,e,r);return _.tx=-n.x,_.ty=-n.y,this.render(t,i,!1,_,!!t.parent),i},e.prototype.destroy=function(t){t&&this.view.parentNode&&this.view.parentNode.removeChild(this.view),this.type=l.RENDERER_TYPE.UNKNOWN,this.view=null,this.screen=null,this.resolution=0,this.transparent=!1,this.autoResize=!1,this.blendModes=null,this.options=null,this.preserveDrawingBuffer=!1,this.clearBeforeRender=!1,this.roundPixels=!1,this._backgroundColor=0,this._backgroundColorRgba=null,this._backgroundColorString=null,this._tempDisplayObjectParent=null,this._lastObjectRendered=null},a(e,[{key:"width",get:function(){return this.view.width}},{key:"height",get:function(){return this.view.height}},{key:"backgroundColor",get:function(){return this._backgroundColor},set:function(t){this._backgroundColor=t,this._backgroundColorString=(0,u.hex2string)(t),(0,u.hex2rgb)(t,this._backgroundColorRgba)}}]),e}(m.default);r.default=b},{"../const":46,"../display/Container":48,"../math":70,"../settings":101,"../textures/RenderTexture":113,"../utils":125,eventemitter3:3}],77:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("../SystemRenderer"),u=n(a),h=t("./utils/CanvasMaskManager"),l=n(h),c=t("./utils/CanvasRenderTarget"),d=n(c),f=t("./utils/mapCanvasBlendModesToPixi"),p=n(f),v=t("../../utils"),g=t("../../const"),y=t("../../settings"),m=n(y),_=function(t){function e(r,n,s){i(this,e);var a=o(this,t.call(this,"Canvas",r,n,s));return a.type=g.RENDERER_TYPE.CANVAS,a.rootContext=a.view.getContext("2d",{alpha:a.transparent}),a.context=a.rootContext,a.refresh=!0,a.maskManager=new l.default(a),a.smoothProperty="imageSmoothingEnabled",a.rootContext.imageSmoothingEnabled||(a.rootContext.webkitImageSmoothingEnabled?a.smoothProperty="webkitImageSmoothingEnabled":a.rootContext.mozImageSmoothingEnabled?a.smoothProperty="mozImageSmoothingEnabled":a.rootContext.oImageSmoothingEnabled?a.smoothProperty="oImageSmoothingEnabled":a.rootContext.msImageSmoothingEnabled&&(a.smoothProperty="msImageSmoothingEnabled")),a.initPlugins(),a.blendModes=(0,p.default)(),a._activeBlendMode=null,a.renderingToScreen=!1,a.resize(a.options.width,a.options.height),a}return s(e,t),e.prototype.render=function(t,e,r,n,i){if(this.view){this.renderingToScreen=!e,this.emit("prerender");var o=this.resolution;e?(e=e.baseTexture||e,e._canvasRenderTarget||(e._canvasRenderTarget=new d.default(e.width,e.height,e.resolution),e.source=e._canvasRenderTarget.canvas,e.valid=!0),this.context=e._canvasRenderTarget.context,this.resolution=e._canvasRenderTarget.resolution):this.context=this.rootContext;var s=this.context;if(e||(this._lastObjectRendered=t),!i){var a=t.parent,u=this._tempDisplayObjectParent.transform.worldTransform;n?(n.copy(u),this._tempDisplayObjectParent.transform._worldID=-1):u.identity(),t.parent=this._tempDisplayObjectParent,t.updateTransform(),t.parent=a}s.save(),s.setTransform(1,0,0,1,0,0),s.globalAlpha=1,this._activeBlendMode=g.BLEND_MODES.NORMAL,s.globalCompositeOperation=this.blendModes[g.BLEND_MODES.NORMAL],
navigator.isCocoonJS&&this.view.screencanvas&&(s.fillStyle="black",s.clear()),(void 0!==r?r:this.clearBeforeRender)&&this.renderingToScreen&&(this.transparent?s.clearRect(0,0,this.width,this.height):(s.fillStyle=this._backgroundColorString,s.fillRect(0,0,this.width,this.height)));var h=this.context;this.context=s,t.renderCanvas(this),this.context=h,s.restore(),this.resolution=o,this.emit("postrender")}},e.prototype.clear=function(t){var e=this.context;t=t||this._backgroundColorString,!this.transparent&&t?(e.fillStyle=t,e.fillRect(0,0,this.width,this.height)):e.clearRect(0,0,this.width,this.height)},e.prototype.setBlendMode=function(t){this._activeBlendMode!==t&&(this._activeBlendMode=t,this.context.globalCompositeOperation=this.blendModes[t])},e.prototype.destroy=function(e){this.destroyPlugins(),t.prototype.destroy.call(this,e),this.context=null,this.refresh=!0,this.maskManager.destroy(),this.maskManager=null,this.smoothProperty=null},e.prototype.resize=function(e,r){t.prototype.resize.call(this,e,r),this.smoothProperty&&(this.rootContext[this.smoothProperty]=m.default.SCALE_MODE===g.SCALE_MODES.LINEAR)},e.prototype.invalidateBlendMode=function(){this._activeBlendMode=this.blendModes.indexOf(this.context.globalCompositeOperation)},e}(u.default);r.default=_,v.pluginTarget.mixin(_)},{"../../const":46,"../../settings":101,"../../utils":125,"../SystemRenderer":76,"./utils/CanvasMaskManager":78,"./utils/CanvasRenderTarget":79,"./utils/mapCanvasBlendModesToPixi":81}],78:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../../../const"),o=function(){function t(e){n(this,t),this.renderer=e}return t.prototype.pushMask=function(t){var e=this.renderer;e.context.save();var r=t.alpha,n=t.transform.worldTransform,i=e.resolution;e.context.setTransform(n.a*i,n.b*i,n.c*i,n.d*i,n.tx*i,n.ty*i),t._texture||(this.renderGraphicsShape(t),e.context.clip()),t.worldAlpha=r},t.prototype.renderGraphicsShape=function(t){var e=this.renderer.context,r=t.graphicsData.length;if(0!==r){e.beginPath();for(var n=0;n<r;n++){var o=t.graphicsData[n],s=o.shape;if(o.type===i.SHAPES.POLY){var a=s.points,u=o.holes,h=void 0,l=void 0;e.moveTo(a[0],a[1]);for(var c=2;c<a.length;c+=2)e.lineTo(a[c],a[c+1]);if(a[0]===a[a.length-2]&&a[1]===a[a.length-1]&&e.closePath(),u.length>0){h=0;for(var d=0;d<a.length;d+=2)h+=a[d]*a[d+3]-a[d+1]*a[d+2];for(var f=0;f<u.length;f++){a=u[f].points,l=0;for(var p=0;p<a.length;p+=2)l+=a[p]*a[p+3]-a[p+1]*a[p+2];if(e.moveTo(a[0],a[1]),l*h<0)for(var v=2;v<a.length;v+=2)e.lineTo(a[v],a[v+1]);else for(var g=a.length-2;g>=2;g-=2)e.lineTo(a[g],a[g+1])}}}else if(o.type===i.SHAPES.RECT)e.rect(s.x,s.y,s.width,s.height),e.closePath();else if(o.type===i.SHAPES.CIRC)e.arc(s.x,s.y,s.radius,0,2*Math.PI),e.closePath();else if(o.type===i.SHAPES.ELIP){var y=2*s.width,m=2*s.height,_=s.x-y/2,b=s.y-m/2,x=y/2*.5522848,T=m/2*.5522848,w=_+y,E=b+m,S=_+y/2,O=b+m/2;e.moveTo(_,O),e.bezierCurveTo(_,O-T,S-x,b,S,b),e.bezierCurveTo(S+x,b,w,O-T,w,O),e.bezierCurveTo(w,O+T,S+x,E,S,E),e.bezierCurveTo(S-x,E,_,O+T,_,O),e.closePath()}else if(o.type===i.SHAPES.RREC){var M=s.x,P=s.y,C=s.width,R=s.height,A=s.radius,I=Math.min(C,R)/2|0;A=A>I?I:A,e.moveTo(M,P+A),e.lineTo(M,P+R-A),e.quadraticCurveTo(M,P+R,M+A,P+R),e.lineTo(M+C-A,P+R),e.quadraticCurveTo(M+C,P+R,M+C,P+R-A),e.lineTo(M+C,P+A),e.quadraticCurveTo(M+C,P,M+C-A,P),e.lineTo(M+A,P),e.quadraticCurveTo(M,P,M,P+A),e.closePath()}}}},t.prototype.popMask=function(t){t.context.restore(),t.invalidateBlendMode()},t.prototype.destroy=function(){},t}();r.default=o},{"../../../const":46}],79:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),o=t("../../../settings"),s=function(t){return t&&t.__esModule?t:{default:t}}(o),a=function(){function t(e,r,i){n(this,t),this.canvas=document.createElement("canvas"),this.context=this.canvas.getContext("2d"),this.resolution=i||s.default.RESOLUTION,this.resize(e,r)}return t.prototype.clear=function(){this.context.setTransform(1,0,0,1,0,0),this.context.clearRect(0,0,this.canvas.width,this.canvas.height)},t.prototype.resize=function(t,e){this.canvas.width=t*this.resolution,this.canvas.height=e*this.resolution},t.prototype.destroy=function(){this.context=null,this.canvas=null},i(t,[{key:"width",get:function(){return this.canvas.width},set:function(t){this.canvas.width=t}},{key:"height",get:function(){return this.canvas.height},set:function(t){this.canvas.height=t}}]),t}();r.default=a},{"../../../settings":101}],80:[function(t,e,r){"use strict";function n(t){var e=document.createElement("canvas");e.width=6,e.height=1;var r=e.getContext("2d");return r.fillStyle=t,r.fillRect(0,0,6,1),e}function i(){if("undefined"==typeof document)return!1;var t=n("#ff00ff"),e=n("#ffff00"),r=document.createElement("canvas");r.width=6,r.height=1;var i=r.getContext("2d");i.globalCompositeOperation="multiply",i.drawImage(t,0,0),i.drawImage(e,2,0);var o=i.getImageData(2,0,1,1);if(!o)return!1;var s=o.data;return 255===s[0]&&0===s[1]&&0===s[2]}r.__esModule=!0,r.default=i},{}],81:[function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];return(0,s.default)()?(t[i.BLEND_MODES.NORMAL]="source-over",t[i.BLEND_MODES.ADD]="lighter",t[i.BLEND_MODES.MULTIPLY]="multiply",t[i.BLEND_MODES.SCREEN]="screen",t[i.BLEND_MODES.OVERLAY]="overlay",t[i.BLEND_MODES.DARKEN]="darken",t[i.BLEND_MODES.LIGHTEN]="lighten",t[i.BLEND_MODES.COLOR_DODGE]="color-dodge",t[i.BLEND_MODES.COLOR_BURN]="color-burn",t[i.BLEND_MODES.HARD_LIGHT]="hard-light",t[i.BLEND_MODES.SOFT_LIGHT]="soft-light",t[i.BLEND_MODES.DIFFERENCE]="difference",t[i.BLEND_MODES.EXCLUSION]="exclusion",t[i.BLEND_MODES.HUE]="hue",t[i.BLEND_MODES.SATURATION]="saturate",t[i.BLEND_MODES.COLOR]="color",t[i.BLEND_MODES.LUMINOSITY]="luminosity"):(t[i.BLEND_MODES.NORMAL]="source-over",t[i.BLEND_MODES.ADD]="lighter",t[i.BLEND_MODES.MULTIPLY]="source-over",t[i.BLEND_MODES.SCREEN]="source-over",t[i.BLEND_MODES.OVERLAY]="source-over",t[i.BLEND_MODES.DARKEN]="source-over",t[i.BLEND_MODES.LIGHTEN]="source-over",t[i.BLEND_MODES.COLOR_DODGE]="source-over",t[i.BLEND_MODES.COLOR_BURN]="source-over",t[i.BLEND_MODES.HARD_LIGHT]="source-over",t[i.BLEND_MODES.SOFT_LIGHT]="source-over",t[i.BLEND_MODES.DIFFERENCE]="source-over",t[i.BLEND_MODES.EXCLUSION]="source-over",t[i.BLEND_MODES.HUE]="source-over",t[i.BLEND_MODES.SATURATION]="source-over",t[i.BLEND_MODES.COLOR]="source-over",t[i.BLEND_MODES.LUMINOSITY]="source-over"),t[i.BLEND_MODES.NORMAL_NPM]=t[i.BLEND_MODES.NORMAL],t[i.BLEND_MODES.ADD_NPM]=t[i.BLEND_MODES.ADD],t[i.BLEND_MODES.SCREEN_NPM]=t[i.BLEND_MODES.SCREEN],t}r.__esModule=!0,r.default=n;var i=t("../../../const"),o=t("./canUseNewCanvasBlendModes"),s=function(t){return t&&t.__esModule?t:{default:t}}(o)},{"../../../const":46,"./canUseNewCanvasBlendModes":80}],82:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../../const"),o=t("../../settings"),s=function(t){return t&&t.__esModule?t:{default:t}}(o),a=function(){function t(e){n(this,t),this.renderer=e,this.count=0,this.checkCount=0,this.maxIdle=s.default.GC_MAX_IDLE,this.checkCountMax=s.default.GC_MAX_CHECK_COUNT,this.mode=s.default.GC_MODE}return t.prototype.update=function(){this.count++,this.mode!==i.GC_MODES.MANUAL&&++this.checkCount>this.checkCountMax&&(this.checkCount=0,this.run())},t.prototype.run=function(){for(var t=this.renderer.textureManager,e=t._managedTextures,r=!1,n=0;n<e.length;n++){var i=e[n];!i._glRenderTargets&&this.count-i.touched>this.maxIdle&&(t.destroyTexture(i,!0),e[n]=null,r=!0)}if(r){for(var o=0,s=0;s<e.length;s++)null!==e[s]&&(e[o++]=e[s]);e.length=o}},t.prototype.unload=function(t){var e=this.renderer.textureManager;t._texture&&t._texture._glRenderTargets&&e.destroyTexture(t._texture,!0);for(var r=t.children.length-1;r>=0;r--)this.unload(t.children[r])},t}();r.default=a},{"../../const":46,"../../settings":101}],83:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("pixi-gl-core"),o=t("../../const"),s=t("./utils/RenderTarget"),a=function(t){return t&&t.__esModule?t:{default:t}}(s),u=t("../../utils"),h=function(){function t(e){n(this,t),this.renderer=e,this.gl=e.gl,this._managedTextures=[]}return t.prototype.bindTexture=function(){},t.prototype.getTexture=function(){},t.prototype.updateTexture=function(t,e){var r=this.gl,n=!!t._glRenderTargets;if(!t.hasLoaded)return null;var s=this.renderer.boundTextures;if(void 0===e){e=0;for(var u=0;u<s.length;++u)if(s[u]===t){e=u;break}}s[e]=t,r.activeTexture(r.TEXTURE0+e);var h=t._glTextures[this.renderer.CONTEXT_UID];if(h)n?t._glRenderTargets[this.renderer.CONTEXT_UID].resize(t.width,t.height):h.upload(t.source);else{if(n){var l=new a.default(this.gl,t.width,t.height,t.scaleMode,t.resolution);l.resize(t.width,t.height),t._glRenderTargets[this.renderer.CONTEXT_UID]=l,h=l.texture,this.renderer._activeRenderTarget.root||this.renderer._activeRenderTarget.frameBuffer.bind()}else h=new i.GLTexture(this.gl,null,null,null,null),h.bind(e),h.premultiplyAlpha=!0,h.upload(t.source);t._glTextures[this.renderer.CONTEXT_UID]=h,t.on("update",this.updateTexture,this),t.on("dispose",this.destroyTexture,this),this._managedTextures.push(t),t.isPowerOfTwo?(t.mipmap&&h.enableMipmap(),t.wrapMode===o.WRAP_MODES.CLAMP?h.enableWrapClamp():t.wrapMode===o.WRAP_MODES.REPEAT?h.enableWrapRepeat():h.enableWrapMirrorRepeat()):h.enableWrapClamp(),t.scaleMode===o.SCALE_MODES.NEAREST?h.enableNearestScaling():h.enableLinearScaling()}return h},t.prototype.destroyTexture=function(t,e){if(t=t.baseTexture||t,t.hasLoaded){var r=this.renderer,n=r.CONTEXT_UID,i=t._glTextures,o=t._glRenderTargets;if(i[n]&&(r.unbindTexture(t),i[n].destroy(),t.off("update",this.updateTexture,this),t.off("dispose",this.destroyTexture,this),delete i[n],!e)){var s=this._managedTextures.indexOf(t);-1!==s&&(0,u.removeItems)(this._managedTextures,s,1)}o&&o[n]&&(r._activeRenderTarget===o[n]&&r.bindRenderTarget(r.rootRenderTarget),o[n].destroy(),delete o[n])}},t.prototype.removeAll=function(){for(var t=0;t<this._managedTextures.length;++t){var e=this._managedTextures[t];e._glTextures[this.renderer.CONTEXT_UID]&&delete e._glTextures[this.renderer.CONTEXT_UID]}},t.prototype.destroy=function(){for(var t=0;t<this._managedTextures.length;++t){var e=this._managedTextures[t];this.destroyTexture(e,!0),e.off("update",this.updateTexture,this),e.off("dispose",this.destroyTexture,this)}this._managedTextures=null},t}();r.default=h},{"../../const":46,"../../utils":125,"./utils/RenderTarget":96,"pixi-gl-core":15}],84:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("../SystemRenderer"),u=n(a),h=t("./managers/MaskManager"),l=n(h),c=t("./managers/StencilManager"),d=n(c),f=t("./managers/FilterManager"),p=n(f),v=t("./utils/RenderTarget"),g=n(v),y=t("./utils/ObjectRenderer"),m=n(y),_=t("./TextureManager"),b=n(_),x=t("../../textures/BaseTexture"),T=n(x),w=t("./TextureGarbageCollector"),E=n(w),S=t("./WebGLState"),O=n(S),M=t("./utils/mapWebGLDrawModesToPixi"),P=n(M),C=t("./utils/validateContext"),R=n(C),A=t("../../utils"),I=t("pixi-gl-core"),D=n(I),L=t("../../const"),N=0,B=function(t){function e(r,n,s){i(this,e);var a=o(this,t.call(this,"WebGL",r,n,s));return a.legacy=a.options.legacy,a.legacy&&(D.default.VertexArrayObject.FORCE_NATIVE=!0),a.type=L.RENDERER_TYPE.WEBGL,a.handleContextLost=a.handleContextLost.bind(a),a.handleContextRestored=a.handleContextRestored.bind(a),a.view.addEventListener("webglcontextlost",a.handleContextLost,!1),a.view.addEventListener("webglcontextrestored",a.handleContextRestored,!1),a._contextOptions={alpha:a.transparent,antialias:a.options.antialias,premultipliedAlpha:a.transparent&&"notMultiplied"!==a.transparent,stencil:!0,preserveDrawingBuffer:a.options.preserveDrawingBuffer,powerPreference:a.options.powerPreference},a._backgroundColorRgba[3]=a.transparent?0:1,a.maskManager=new l.default(a),a.stencilManager=new d.default(a),a.emptyRenderer=new m.default(a),a.currentRenderer=a.emptyRenderer,a.textureManager=null,a.filterManager=null,a.initPlugins(),a.options.context&&(0,R.default)(a.options.context),a.gl=a.options.context||D.default.createContext(a.view,a._contextOptions),a.CONTEXT_UID=N++,a.state=new O.default(a.gl),a.renderingToScreen=!0,a.boundTextures=null,a._activeShader=null,a._activeVao=null,a._activeRenderTarget=null,a._initContext(),a.drawModes=(0,P.default)(a.gl),a._nextTextureLocation=0,a.setBlendMode(0),a}return s(e,t),e.prototype._initContext=function(){var t=this.gl;t.isContextLost()&&t.getExtension("WEBGL_lose_context")&&t.getExtension("WEBGL_lose_context").restoreContext();var e=t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);this._activeShader=null,this._activeVao=null,this.boundTextures=new Array(e),this.emptyTextures=new Array(e),this._unknownBoundTextures=!1,this.textureManager=new b.default(this),this.filterManager=new p.default(this),this.textureGC=new E.default(this),this.state.resetToDefault(),this.rootRenderTarget=new g.default(t,this.width,this.height,null,this.resolution,!0),this.rootRenderTarget.clearColor=this._backgroundColorRgba,this.bindRenderTarget(this.rootRenderTarget);var r=new D.default.GLTexture.fromData(t,null,1,1),n={_glTextures:{}};n._glTextures[this.CONTEXT_UID]={};for(var i=0;i<e;i++){var o=new T.default;o._glTextures[this.CONTEXT_UID]=r,this.boundTextures[i]=n,this.emptyTextures[i]=o,this.bindTexture(null,i)}this.emit("context",t),this.resize(this.screen.width,this.screen.height)},e.prototype.render=function(t,e,r,n,i){if(this.renderingToScreen=!e,this.emit("prerender"),this.gl&&!this.gl.isContextLost()){if(this._nextTextureLocation=0,e||(this._lastObjectRendered=t),!i){var o=t.parent;t.parent=this._tempDisplayObjectParent,t.updateTransform(),t.parent=o}this.bindRenderTexture(e,n),this.currentRenderer.start(),(void 0!==r?r:this.clearBeforeRender)&&this._activeRenderTarget.clear(),t.renderWebGL(this),this.currentRenderer.flush(),this.textureGC.update(),this.emit("postrender")}},e.prototype.setObjectRenderer=function(t){this.currentRenderer!==t&&(this.currentRenderer.stop(),this.currentRenderer=t,this.currentRenderer.start())},e.prototype.flush=function(){this.setObjectRenderer(this.emptyRenderer)},e.prototype.resize=function(t,e){u.default.prototype.resize.call(this,t,e),this.rootRenderTarget.resize(t,e),this._activeRenderTarget===this.rootRenderTarget&&(this.rootRenderTarget.activate(),this._activeShader&&(this._activeShader.uniforms.projectionMatrix=this.rootRenderTarget.projectionMatrix.toArray(!0)))},e.prototype.setBlendMode=function(t){this.state.setBlendMode(t)},e.prototype.clear=function(t){this._activeRenderTarget.clear(t)},e.prototype.setTransform=function(t){this._activeRenderTarget.transform=t},e.prototype.clearRenderTexture=function(t,e){var r=t.baseTexture,n=r._glRenderTargets[this.CONTEXT_UID];return n&&n.clear(e),this},e.prototype.bindRenderTexture=function(t,e){var r=void 0;if(t){var n=t.baseTexture;n._glRenderTargets[this.CONTEXT_UID]||this.textureManager.updateTexture(n,0),this.unbindTexture(n),r=n._glRenderTargets[this.CONTEXT_UID],r.setFrame(t.frame)}else r=this.rootRenderTarget;return r.transform=e,this.bindRenderTarget(r),this},e.prototype.bindRenderTarget=function(t){return t!==this._activeRenderTarget&&(this._activeRenderTarget=t,t.activate(),this._activeShader&&(this._activeShader.uniforms.projectionMatrix=t.projectionMatrix.toArray(!0)),this.stencilManager.setMaskStack(t.stencilMaskStack)),this},e.prototype.bindShader=function(t,e){return this._activeShader!==t&&(this._activeShader=t,t.bind(),!1!==e&&(t.uniforms.projectionMatrix=this._activeRenderTarget.projectionMatrix.toArray(!0))),this},e.prototype.bindTexture=function(t,e,r){if(t=t||this.emptyTextures[e],t=t.baseTexture||t,t.touched=this.textureGC.count,r)e=e||0;else{for(var n=0;n<this.boundTextures.length;n++)if(this.boundTextures[n]===t)return n;void 0===e&&(this._nextTextureLocation++,this._nextTextureLocation%=this.boundTextures.length,e=this.boundTextures.length-this._nextTextureLocation-1)}var i=this.gl,o=t._glTextures[this.CONTEXT_UID];return o?(this.boundTextures[e]=t,i.activeTexture(i.TEXTURE0+e),i.bindTexture(i.TEXTURE_2D,o.texture)):this.textureManager.updateTexture(t,e),e},e.prototype.unbindTexture=function(t){var e=this.gl;if(t=t.baseTexture||t,this._unknownBoundTextures){this._unknownBoundTextures=!1;for(var r=0;r<this.boundTextures.length;r++)this.boundTextures[r]===this.emptyTextures[r]&&(e.activeTexture(e.TEXTURE0+r),e.bindTexture(e.TEXTURE_2D,this.emptyTextures[r]._glTextures[this.CONTEXT_UID].texture))}for(var n=0;n<this.boundTextures.length;n++)this.boundTextures[n]===t&&(this.boundTextures[n]=this.emptyTextures[n],e.activeTexture(e.TEXTURE0+n),e.bindTexture(e.TEXTURE_2D,this.emptyTextures[n]._glTextures[this.CONTEXT_UID].texture));return this},e.prototype.createVao=function(){return new D.default.VertexArrayObject(this.gl,this.state.attribState)},e.prototype.bindVao=function(t){return this._activeVao===t?this:(t?t.bind():this._activeVao&&this._activeVao.unbind(),this._activeVao=t,this)},e.prototype.reset=function(){this.setObjectRenderer(this.emptyRenderer),this.bindVao(null),this._activeShader=null,this._activeRenderTarget=this.rootRenderTarget,this._unknownBoundTextures=!0;for(var t=0;t<this.boundTextures.length;t++)this.boundTextures[t]=this.emptyTextures[t];return this.rootRenderTarget.activate(),this.state.resetToDefault(),this},e.prototype.handleContextLost=function(t){t.preventDefault()},e.prototype.handleContextRestored=function(){this.textureManager.removeAll(),this.filterManager.destroy(!0),this._initContext()},e.prototype.destroy=function(e){this.destroyPlugins(),this.view.removeEventListener("webglcontextlost",this.handleContextLost),this.view.removeEventListener("webglcontextrestored",this.handleContextRestored),this.textureManager.destroy(),t.prototype.destroy.call(this,e),this.uid=0,this.maskManager.destroy(),this.stencilManager.destroy(),this.filterManager.destroy(),this.maskManager=null,this.filterManager=null,this.textureManager=null,this.currentRenderer=null,this.handleContextLost=null,this.handleContextRestored=null,this._contextOptions=null,this.gl.useProgram(null),this.gl.getExtension("WEBGL_lose_context")&&this.gl.getExtension("WEBGL_lose_context").loseContext(),this.gl=null},e}(u.default);r.default=B,A.pluginTarget.mixin(B)},{"../../const":46,"../../textures/BaseTexture":112,"../../utils":125,"../SystemRenderer":76,"./TextureGarbageCollector":82,"./TextureManager":83,"./WebGLState":85,"./managers/FilterManager":90,"./managers/MaskManager":91,"./managers/StencilManager":92,"./utils/ObjectRenderer":94,"./utils/RenderTarget":96,"./utils/mapWebGLDrawModesToPixi":99,"./utils/validateContext":100,"pixi-gl-core":15}],85:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("./utils/mapWebGLBlendModesToPixi"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=function(){function t(e){n(this,t),this.activeState=new Uint8Array(16),this.defaultState=new Uint8Array(16),this.defaultState[0]=1,this.stackIndex=0,this.stack=[],this.gl=e,this.maxAttribs=e.getParameter(e.MAX_VERTEX_ATTRIBS),this.attribState={tempAttribState:new Array(this.maxAttribs),attribState:new Array(this.maxAttribs)},this.blendModes=(0,o.default)(e),this.nativeVaoExtension=e.getExtension("OES_vertex_array_object")||e.getExtension("MOZ_OES_vertex_array_object")||e.getExtension("WEBKIT_OES_vertex_array_object")}return t.prototype.push=function(){var t=this.stack[this.stackIndex];t||(t=this.stack[this.stackIndex]=new Uint8Array(16)),++this.stackIndex;for(var e=0;e<this.activeState.length;e++)t[e]=this.activeState[e]},t.prototype.pop=function(){var t=this.stack[--this.stackIndex];this.setState(t)},t.prototype.setState=function(t){this.setBlend(t[0]),this.setDepthTest(t[1]),this.setFrontFace(t[2]),this.setCullFace(t[3]),this.setBlendMode(t[4])},t.prototype.setBlend=function(t){t=t?1:0,this.activeState[0]!==t&&(this.activeState[0]=t,this.gl[t?"enable":"disable"](this.gl.BLEND))},t.prototype.setBlendMode=function(t){if(t!==this.activeState[4]){this.activeState[4]=t;var e=this.blendModes[t];2===e.length?this.gl.blendFunc(e[0],e[1]):this.gl.blendFuncSeparate(e[0],e[1],e[2],e[3])}},t.prototype.setDepthTest=function(t){t=t?1:0,this.activeState[1]!==t&&(this.activeState[1]=t,this.gl[t?"enable":"disable"](this.gl.DEPTH_TEST))},t.prototype.setCullFace=function(t){t=t?1:0,this.activeState[3]!==t&&(this.activeState[3]=t,this.gl[t?"enable":"disable"](this.gl.CULL_FACE))},t.prototype.setFrontFace=function(t){t=t?1:0,this.activeState[2]!==t&&(this.activeState[2]=t,this.gl.frontFace(this.gl[t?"CW":"CCW"]))},t.prototype.resetAttributes=function(){for(var t=0;t<this.attribState.tempAttribState.length;t++)this.attribState.tempAttribState[t]=0;for(var e=0;e<this.attribState.attribState.length;e++)this.attribState.attribState[e]=0;for(var r=1;r<this.maxAttribs;r++)this.gl.disableVertexAttribArray(r)},t.prototype.resetToDefault=function(){this.nativeVaoExtension&&this.nativeVaoExtension.bindVertexArrayOES(null),this.resetAttributes();for(var t=0;t<this.activeState.length;++t)this.activeState[t]=32;this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL,!1),this.setState(this.defaultState)},t}();r.default=s},{"./utils/mapWebGLBlendModesToPixi":98}],86:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var o=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),s=t("./extractUniformsFromSrc"),a=n(s),u=t("../../../utils"),h=t("../../../const"),l=t("../../../settings"),c=n(l),d={},f=function(){function t(e,r,n){i(this,t),this.vertexSrc=e||t.defaultVertexSrc,this.fragmentSrc=r||t.defaultFragmentSrc,this._blendMode=h.BLEND_MODES.NORMAL,this.uniformData=n||(0,a.default)(this.vertexSrc,this.fragmentSrc,"projectionMatrix|uSampler"),this.uniforms={};for(var o in this.uniformData)this.uniforms[o]=this.uniformData[o].value,this.uniformData[o].type&&(this.uniformData[o].type=this.uniformData[o].type.toLowerCase());this.glShaders={},d[this.vertexSrc+this.fragmentSrc]||(d[this.vertexSrc+this.fragmentSrc]=(0,u.uid)()),this.glShaderKey=d[this.vertexSrc+this.fragmentSrc],this.padding=4,this.resolution=c.default.FILTER_RESOLUTION,this.enabled=!0,this.autoFit=!0}return t.prototype.apply=function(t,e,r,n,i){t.applyFilter(this,e,r,n)},o(t,[{key:"blendMode",get:function(){return this._blendMode},set:function(t){this._blendMode=t}}],[{key:"defaultVertexSrc",get:function(){return["attribute vec2 aVertexPosition;","attribute vec2 aTextureCoord;","uniform mat3 projectionMatrix;","uniform mat3 filterMatrix;","varying vec2 vTextureCoord;","varying vec2 vFilterCoord;","void main(void){","   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);","   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;","   vTextureCoord = aTextureCoord ;","}"].join("\n")}},{key:"defaultFragmentSrc",get:function(){return["varying vec2 vTextureCoord;","varying vec2 vFilterCoord;","uniform sampler2D uSampler;","uniform sampler2D filterSampler;","void main(void){","   vec4 masky = texture2D(filterSampler, vFilterCoord);","   vec4 sample = texture2D(uSampler, vTextureCoord);","   vec4 color;","   if(mod(vFilterCoord.x, 1.0) > 0.5)","   {","     color = vec4(1.0, 0.0, 0.0, 1.0);","   }","   else","   {","     color = vec4(0.0, 1.0, 0.0, 1.0);","   }","   gl_FragColor = mix(sample, masky, 0.5);","   gl_FragColor *= sample.a;","}"].join("\n")}}]),t}();r.default=f},{"../../../const":46,"../../../settings":101,"../../../utils":125,"./extractUniformsFromSrc":87}],87:[function(t,e,r){"use strict";function n(t,e,r){var n=i(t),o=i(e);return Object.assign(n,o)}function i(t){for(var e=new RegExp("^(projectionMatrix|uSampler|filterArea|filterClamp)$"),r={},n=void 0,i=t.replace(/\s+/g," ").split(/\s*;\s*/),o=0;o<i.length;o++){var s=i[o].trim();if(s.indexOf("uniform")>-1){var u=s.split(" "),h=u[1],l=u[2],c=1;l.indexOf("[")>-1&&(n=l.split(/\[|]/),l=n[0],c*=Number(n[1])),l.match(e)||(r[l]={value:a(h,c),name:l,type:h})}}return r}r.__esModule=!0,r.default=n;var o=t("pixi-gl-core"),s=function(t){return t&&t.__esModule?t:{default:t}}(o),a=s.default.shader.defaultValue},{"pixi-gl-core":15}],88:[function(t,e,r){"use strict";function n(t,e,r){var n=t.identity();return n.translate(e.x/r.width,e.y/r.height),n.scale(r.width,r.height),n}function i(t,e,r){var n=t.identity();n.translate(e.x/r.width,e.y/r.height);var i=r.width/e.width,o=r.height/e.height;return n.scale(i,o),n}function o(t,e,r,n){var i=n._texture.orig,o=t.set(r.width,0,0,r.height,e.x,e.y),a=n.worldTransform.copy(s.Matrix.TEMP_MATRIX);return a.invert(),o.prepend(a),o.scale(1/i.width,1/i.height),o.translate(n.anchor.x,n.anchor.y),o}r.__esModule=!0,r.calculateScreenSpaceMatrix=n,r.calculateNormalizedScreenSpaceMatrix=i,r.calculateSpriteMatrix=o;var s=t("../../../math")},{"../../../math":70}],89:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("../Filter"),u=n(a),h=t("../../../../math"),l=(t("path"),t("../../../../textures/TextureMatrix")),c=n(l),d=function(t){function e(r){i(this,e);var n=new h.Matrix,s=o(this,t.call(this,"attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n","varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\nuniform vec4 maskClamp;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(maskClamp.x, vMaskCoord.x) +\n        step(maskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, maskClamp.z) +\n        step(vMaskCoord.y, maskClamp.w));\n\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n\n    original *= (masky.r * masky.a * alpha * clip);\n\n    gl_FragColor = original;\n}\n"));return r.renderable=!1,s.maskSprite=r,s.maskMatrix=n,s}return s(e,t),e.prototype.apply=function(t,e,r,n){var i=this.maskSprite,o=this.maskSprite.texture;o.valid&&(o.transform||(o.transform=new c.default(o,0)),o.transform.update(),this.uniforms.mask=o,this.uniforms.otherMatrix=t.calculateSpriteMatrix(this.maskMatrix,i).prepend(o.transform.mapCoord),this.uniforms.alpha=i.worldAlpha,this.uniforms.maskClamp=o.transform.uClampFrame,t.applyFilter(this,e,r,n))},e}(u.default);r.default=d},{"../../../../math":70,"../../../../textures/TextureMatrix":116,"../Filter":86,path:8}],90:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var a=t("./WebGLManager"),u=n(a),h=t("../utils/RenderTarget"),l=n(h),c=t("../utils/Quad"),d=n(c),f=t("../../../math"),p=t("../../../Shader"),v=n(p),g=t("../filters/filterTransforms"),y=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(g),m=t("bit-twiddle"),_=n(m),b=function(){function t(){s(this,t),this.renderTarget=null,this.target=null,this.resolution=1,this.sourceFrame=new f.Rectangle,this.destinationFrame=new f.Rectangle,this.filters=[]}return t.prototype.clear=function(){this.filters=null,this.target=null,this.renderTarget=null},t}(),x=function(t){function e(r){s(this,e);var n=i(this,t.call(this,r));return n.gl=n.renderer.gl,n.quad=new d.default(n.gl,r.state.attribState),n.shaderCache={},n.pool={},n.filterData=null,n.managedFilters=[],n.renderer.on("prerender",n.onPrerender,n),n._screenWidth=r.view.width,n._screenHeight=r.view.height,n}return o(e,t),e.prototype.pushFilter=function(t,e){var r=this.renderer,n=this.filterData;if(!n){n=this.renderer._activeRenderTarget.filterStack;var i=new b;i.sourceFrame=i.destinationFrame=this.renderer._activeRenderTarget.size,i.renderTarget=r._activeRenderTarget,this.renderer._activeRenderTarget.filterData=n={index:0,stack:[i]},this.filterData=n}var o=n.stack[++n.index],s=n.stack[0].destinationFrame;o||(o=n.stack[n.index]=new b);var a=t.filterArea&&0===t.filterArea.x&&0===t.filterArea.y&&t.filterArea.width===r.screen.width&&t.filterArea.height===r.screen.height,u=e[0].resolution,h=0|e[0].padding,l=a?r.screen:t.filterArea||t.getBounds(!0),c=o.sourceFrame,d=o.destinationFrame;c.x=(l.x*u|0)/u,c.y=(l.y*u|0)/u,c.width=(l.width*u|0)/u,c.height=(l.height*u|0)/u,a||(n.stack[0].renderTarget.transform||e[0].autoFit&&c.fit(s),c.pad(h)),d.width=c.width,d.height=c.height;var f=this.getPotRenderTarget(r.gl,c.width,c.height,u);o.target=t,o.filters=e,o.resolution=u,o.renderTarget=f,f.setFrame(d,c),r.bindRenderTarget(f),f.clear()},e.prototype.popFilter=function(){var t=this.filterData,e=t.stack[t.index-1],r=t.stack[t.index];this.quad.map(r.renderTarget.size,r.sourceFrame).upload();var n=r.filters;if(1===n.length)n[0].apply(this,r.renderTarget,e.renderTarget,!1,r),this.freePotRenderTarget(r.renderTarget);else{var i=r.renderTarget,o=this.getPotRenderTarget(this.renderer.gl,r.sourceFrame.width,r.sourceFrame.height,r.resolution);o.setFrame(r.destinationFrame,r.sourceFrame),o.clear();var s=0;for(s=0;s<n.length-1;++s){n[s].apply(this,i,o,!0,r);var a=i;i=o,o=a}n[s].apply(this,i,e.renderTarget,!1,r),this.freePotRenderTarget(i),this.freePotRenderTarget(o)}r.clear(),
0===--t.index&&(this.filterData=null)},e.prototype.applyFilter=function(t,e,r,n){var i=this.renderer,o=i.gl,s=t.glShaders[i.CONTEXT_UID];s||(t.glShaderKey?(s=this.shaderCache[t.glShaderKey])||(s=new v.default(this.gl,t.vertexSrc,t.fragmentSrc),t.glShaders[i.CONTEXT_UID]=this.shaderCache[t.glShaderKey]=s,this.managedFilters.push(t)):(s=t.glShaders[i.CONTEXT_UID]=new v.default(this.gl,t.vertexSrc,t.fragmentSrc),this.managedFilters.push(t)),i.bindVao(null),this.quad.initVao(s)),i.bindVao(this.quad.vao),i.bindRenderTarget(r),n&&(o.disable(o.SCISSOR_TEST),i.clear(),o.enable(o.SCISSOR_TEST)),r===i.maskManager.scissorRenderTarget&&i.maskManager.pushScissorMask(null,i.maskManager.scissorData),i.bindShader(s);var a=this.renderer.emptyTextures[0];this.renderer.boundTextures[0]=a,this.syncUniforms(s,t),i.state.setBlendMode(t.blendMode),o.activeTexture(o.TEXTURE0),o.bindTexture(o.TEXTURE_2D,e.texture.texture),this.quad.vao.draw(this.renderer.gl.TRIANGLES,6,0),o.bindTexture(o.TEXTURE_2D,a._glTextures[this.renderer.CONTEXT_UID].texture)},e.prototype.syncUniforms=function(t,e){var r=e.uniformData,n=e.uniforms,i=1,o=void 0;if(t.uniforms.filterArea){o=this.filterData.stack[this.filterData.index];var s=t.uniforms.filterArea;s[0]=o.renderTarget.size.width,s[1]=o.renderTarget.size.height,s[2]=o.sourceFrame.x,s[3]=o.sourceFrame.y,t.uniforms.filterArea=s}if(t.uniforms.filterClamp){o=o||this.filterData.stack[this.filterData.index];var a=t.uniforms.filterClamp;a[0]=0,a[1]=0,a[2]=(o.sourceFrame.width-1)/o.renderTarget.size.width,a[3]=(o.sourceFrame.height-1)/o.renderTarget.size.height,t.uniforms.filterClamp=a}for(var u in r)if(t.uniforms.data[u]){var h=r[u].type;if("sampler2d"===h&&0!==n[u]){if(n[u].baseTexture)t.uniforms[u]=this.renderer.bindTexture(n[u].baseTexture,i);else{t.uniforms[u]=i;var l=this.renderer.gl;this.renderer.boundTextures[i]=this.renderer.emptyTextures[i],l.activeTexture(l.TEXTURE0+i),n[u].texture.bind()}i++}else if("mat3"===h)void 0!==n[u].a?t.uniforms[u]=n[u].toArray(!0):t.uniforms[u]=n[u];else if("vec2"===h)if(void 0!==n[u].x){var c=t.uniforms[u]||new Float32Array(2);c[0]=n[u].x,c[1]=n[u].y,t.uniforms[u]=c}else t.uniforms[u]=n[u];else"float"===h?t.uniforms.data[u].value!==r[u]&&(t.uniforms[u]=n[u]):t.uniforms[u]=n[u]}},e.prototype.getRenderTarget=function(t,e){var r=this.filterData.stack[this.filterData.index],n=this.getPotRenderTarget(this.renderer.gl,r.sourceFrame.width,r.sourceFrame.height,e||r.resolution);return n.setFrame(r.destinationFrame,r.sourceFrame),n},e.prototype.returnRenderTarget=function(t){this.freePotRenderTarget(t)},e.prototype.calculateScreenSpaceMatrix=function(t){var e=this.filterData.stack[this.filterData.index];return y.calculateScreenSpaceMatrix(t,e.sourceFrame,e.renderTarget.size)},e.prototype.calculateNormalizedScreenSpaceMatrix=function(t){var e=this.filterData.stack[this.filterData.index];return y.calculateNormalizedScreenSpaceMatrix(t,e.sourceFrame,e.renderTarget.size,e.destinationFrame)},e.prototype.calculateSpriteMatrix=function(t,e){var r=this.filterData.stack[this.filterData.index];return y.calculateSpriteMatrix(t,r.sourceFrame,r.renderTarget.size,e)},e.prototype.destroy=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this.renderer,r=this.managedFilters;e.off("prerender",this.onPrerender,this);for(var n=0;n<r.length;n++)t||r[n].glShaders[e.CONTEXT_UID].destroy(),delete r[n].glShaders[e.CONTEXT_UID];this.shaderCache={},t?this.pool={}:this.emptyPool()},e.prototype.getPotRenderTarget=function(t,e,r,n){var i="screen";e*=n,r*=n,e===this._screenWidth&&r===this._screenHeight||(e=_.default.nextPow2(e),r=_.default.nextPow2(r),i=(65535&e)<<16|65535&r),this.pool[i]||(this.pool[i]=[]);var o=this.pool[i].pop();if(!o){var s=this.renderer.boundTextures[0];t.activeTexture(t.TEXTURE0),o=new l.default(t,e,r,null,1),t.bindTexture(t.TEXTURE_2D,s._glTextures[this.renderer.CONTEXT_UID].texture)}return o.resolution=n,o.defaultFrame.width=o.size.width=e/n,o.defaultFrame.height=o.size.height=r/n,o.filterPoolKey=i,o},e.prototype.emptyPool=function(){for(var t in this.pool){var e=this.pool[t];if(e)for(var r=0;r<e.length;r++)e[r].destroy(!0)}this.pool={}},e.prototype.freePotRenderTarget=function(t){this.pool[t.filterPoolKey].push(t)},e.prototype.onPrerender=function(){if(this._screenWidth!==this.renderer.view.width||this._screenHeight!==this.renderer.view.height){this._screenWidth=this.renderer.view.width,this._screenHeight=this.renderer.view.height;var t=this.pool.screen;if(t)for(var e=0;e<t.length;e++)t[e].destroy(!0);this.pool.screen=[]}},e}(u.default);r.default=x},{"../../../Shader":44,"../../../math":70,"../filters/filterTransforms":88,"../utils/Quad":95,"../utils/RenderTarget":96,"./WebGLManager":93,"bit-twiddle":1}],91:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("./WebGLManager"),u=n(a),h=t("../filters/spriteMask/SpriteMaskFilter"),l=n(h),c=function(t){function e(r){i(this,e);var n=o(this,t.call(this,r));return n.scissor=!1,n.scissorData=null,n.scissorRenderTarget=null,n.enableScissor=!0,n.alphaMaskPool=[],n.alphaMaskIndex=0,n}return s(e,t),e.prototype.pushMask=function(t,e){if(e.texture)this.pushSpriteMask(t,e);else if(this.enableScissor&&!this.scissor&&this.renderer._activeRenderTarget.root&&!this.renderer.stencilManager.stencilMaskStack.length&&e.isFastRect()){var r=e.worldTransform,n=Math.atan2(r.b,r.a);n=Math.round(n*(180/Math.PI)),n%90?this.pushStencilMask(e):this.pushScissorMask(t,e)}else this.pushStencilMask(e)},e.prototype.popMask=function(t,e){e.texture?this.popSpriteMask(t,e):this.enableScissor&&!this.renderer.stencilManager.stencilMaskStack.length?this.popScissorMask(t,e):this.popStencilMask(t,e)},e.prototype.pushSpriteMask=function(t,e){var r=this.alphaMaskPool[this.alphaMaskIndex];r||(r=this.alphaMaskPool[this.alphaMaskIndex]=[new l.default(e)]),r[0].resolution=this.renderer.resolution,r[0].maskSprite=e;var n=t.filterArea;t.filterArea=e.getBounds(!0),this.renderer.filterManager.pushFilter(t,r),t.filterArea=n,this.alphaMaskIndex++},e.prototype.popSpriteMask=function(){this.renderer.filterManager.popFilter(),this.alphaMaskIndex--},e.prototype.pushStencilMask=function(t){this.renderer.currentRenderer.stop(),this.renderer.stencilManager.pushStencil(t)},e.prototype.popStencilMask=function(){this.renderer.currentRenderer.stop(),this.renderer.stencilManager.popStencil()},e.prototype.pushScissorMask=function(t,e){e.renderable=!0;var r=this.renderer._activeRenderTarget,n=e.getBounds();n.fit(r.size),e.renderable=!1,this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST);var i=this.renderer.resolution;this.renderer.gl.scissor(n.x*i,(r.root?r.size.height-n.y-n.height:n.y)*i,n.width*i,n.height*i),this.scissorRenderTarget=r,this.scissorData=e,this.scissor=!0},e.prototype.popScissorMask=function(){this.scissorRenderTarget=null,this.scissorData=null,this.scissor=!1;var t=this.renderer.gl;t.disable(t.SCISSOR_TEST)},e}(u.default);r.default=c},{"../filters/spriteMask/SpriteMaskFilter":89,"./WebGLManager":93}],92:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=t("./WebGLManager"),a=function(t){return t&&t.__esModule?t:{default:t}}(s),u=function(t){function e(r){n(this,e);var o=i(this,t.call(this,r));return o.stencilMaskStack=null,o}return o(e,t),e.prototype.setMaskStack=function(t){this.stencilMaskStack=t;var e=this.renderer.gl;0===t.length?e.disable(e.STENCIL_TEST):e.enable(e.STENCIL_TEST)},e.prototype.pushStencil=function(t){this.renderer.setObjectRenderer(this.renderer.plugins.graphics),this.renderer._activeRenderTarget.attachStencilBuffer();var e=this.renderer.gl,r=this.stencilMaskStack.length;0===r&&e.enable(e.STENCIL_TEST),this.stencilMaskStack.push(t),e.colorMask(!1,!1,!1,!1),e.stencilFunc(e.EQUAL,r,this._getBitwiseMask()),e.stencilOp(e.KEEP,e.KEEP,e.INCR),this.renderer.plugins.graphics.render(t),this._useCurrent()},e.prototype.popStencil=function(){this.renderer.setObjectRenderer(this.renderer.plugins.graphics);var t=this.renderer.gl,e=this.stencilMaskStack.pop();0===this.stencilMaskStack.length?(t.disable(t.STENCIL_TEST),t.clear(t.STENCIL_BUFFER_BIT),t.clearStencil(0)):(t.colorMask(!1,!1,!1,!1),t.stencilOp(t.KEEP,t.KEEP,t.DECR),this.renderer.plugins.graphics.render(e),this._useCurrent())},e.prototype._useCurrent=function(){var t=this.renderer.gl;t.colorMask(!0,!0,!0,!0),t.stencilFunc(t.EQUAL,this.stencilMaskStack.length,this._getBitwiseMask()),t.stencilOp(t.KEEP,t.KEEP,t.KEEP)},e.prototype._getBitwiseMask=function(){return(1<<this.stencilMaskStack.length)-1},e.prototype.destroy=function(){a.default.prototype.destroy.call(this),this.stencilMaskStack.stencilStack=null},e}(a.default);r.default=u},{"./WebGLManager":93}],93:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(e){n(this,t),this.renderer=e,this.renderer.on("context",this.onContextChange,this)}return t.prototype.onContextChange=function(){},t.prototype.destroy=function(){this.renderer.off("context",this.onContextChange,this),this.renderer=null},t}();r.default=i},{}],94:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=t("../managers/WebGLManager"),a=function(t){return t&&t.__esModule?t:{default:t}}(s),u=function(t){function e(){return n(this,e),i(this,t.apply(this,arguments))}return o(e,t),e.prototype.start=function(){},e.prototype.stop=function(){this.flush()},e.prototype.flush=function(){},e.prototype.render=function(t){},e}(a.default);r.default=u},{"../managers/WebGLManager":93}],95:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var o=t("pixi-gl-core"),s=n(o),a=t("../../../utils/createIndicesForQuads"),u=n(a),h=function(){function t(e,r){i(this,t),this.gl=e,this.vertices=new Float32Array([-1,-1,1,-1,1,1,-1,1]),this.uvs=new Float32Array([0,0,1,0,1,1,0,1]),this.interleaved=new Float32Array(16);for(var n=0;n<4;n++)this.interleaved[4*n]=this.vertices[2*n],this.interleaved[4*n+1]=this.vertices[2*n+1],this.interleaved[4*n+2]=this.uvs[2*n],this.interleaved[4*n+3]=this.uvs[2*n+1];this.indices=(0,u.default)(1),this.vertexBuffer=s.default.GLBuffer.createVertexBuffer(e,this.interleaved,e.STATIC_DRAW),this.indexBuffer=s.default.GLBuffer.createIndexBuffer(e,this.indices,e.STATIC_DRAW),this.vao=new s.default.VertexArrayObject(e,r)}return t.prototype.initVao=function(t){this.vao.clear().addIndex(this.indexBuffer).addAttribute(this.vertexBuffer,t.attributes.aVertexPosition,this.gl.FLOAT,!1,16,0).addAttribute(this.vertexBuffer,t.attributes.aTextureCoord,this.gl.FLOAT,!1,16,8)},t.prototype.map=function(t,e){var r=0,n=0;return this.uvs[0]=r,this.uvs[1]=n,this.uvs[2]=r+e.width/t.width,this.uvs[3]=n,this.uvs[4]=r+e.width/t.width,this.uvs[5]=n+e.height/t.height,this.uvs[6]=r,this.uvs[7]=n+e.height/t.height,r=e.x,n=e.y,this.vertices[0]=r,this.vertices[1]=n,this.vertices[2]=r+e.width,this.vertices[3]=n,this.vertices[4]=r+e.width,this.vertices[5]=n+e.height,this.vertices[6]=r,this.vertices[7]=n+e.height,this},t.prototype.upload=function(){for(var t=0;t<4;t++)this.interleaved[4*t]=this.vertices[2*t],this.interleaved[4*t+1]=this.vertices[2*t+1],this.interleaved[4*t+2]=this.uvs[2*t],this.interleaved[4*t+3]=this.uvs[2*t+1];return this.vertexBuffer.upload(this.interleaved),this},t.prototype.destroy=function(){var t=this.gl;t.deleteBuffer(this.vertexBuffer),t.deleteBuffer(this.indexBuffer)},t}();r.default=h},{"../../../utils/createIndicesForQuads":123,"pixi-gl-core":15}],96:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../../../math"),o=t("../../../const"),s=t("../../../settings"),a=function(t){return t&&t.__esModule?t:{default:t}}(s),u=t("pixi-gl-core"),h=function(){function t(e,r,s,h,l,c){n(this,t),this.gl=e,this.frameBuffer=null,this.texture=null,this.clearColor=[0,0,0,0],this.size=new i.Rectangle(0,0,1,1),this.resolution=l||a.default.RESOLUTION,this.projectionMatrix=new i.Matrix,this.transform=null,this.frame=null,this.defaultFrame=new i.Rectangle,this.destinationFrame=null,this.sourceFrame=null,this.stencilBuffer=null,this.stencilMaskStack=[],this.filterData=null,this.filterPoolKey="",this.scaleMode=void 0!==h?h:a.default.SCALE_MODE,this.root=c||!1,this.root?(this.frameBuffer=new u.GLFramebuffer(e,100,100),this.frameBuffer.framebuffer=null):(this.frameBuffer=u.GLFramebuffer.createRGBA(e,100,100),this.scaleMode===o.SCALE_MODES.NEAREST?this.frameBuffer.texture.enableNearestScaling():this.frameBuffer.texture.enableLinearScaling(),this.texture=this.frameBuffer.texture),this.setFrame(),this.resize(r,s)}return t.prototype.clear=function(t){var e=t||this.clearColor;this.frameBuffer.clear(e[0],e[1],e[2],e[3])},t.prototype.attachStencilBuffer=function(){this.root||this.frameBuffer.enableStencil()},t.prototype.setFrame=function(t,e){this.destinationFrame=t||this.destinationFrame||this.defaultFrame,this.sourceFrame=e||this.sourceFrame||this.destinationFrame},t.prototype.activate=function(){var t=this.gl;this.frameBuffer.bind(),this.calculateProjection(this.destinationFrame,this.sourceFrame),this.transform&&this.projectionMatrix.append(this.transform),this.destinationFrame!==this.sourceFrame?(t.enable(t.SCISSOR_TEST),t.scissor(0|this.destinationFrame.x,0|this.destinationFrame.y,this.destinationFrame.width*this.resolution|0,this.destinationFrame.height*this.resolution|0)):t.disable(t.SCISSOR_TEST),t.viewport(0|this.destinationFrame.x,0|this.destinationFrame.y,this.destinationFrame.width*this.resolution|0,this.destinationFrame.height*this.resolution|0)},t.prototype.calculateProjection=function(t,e){var r=this.projectionMatrix;e=e||t,r.identity(),this.root?(r.a=1/t.width*2,r.d=-1/t.height*2,r.tx=-1-e.x*r.a,r.ty=1-e.y*r.d):(r.a=1/t.width*2,r.d=1/t.height*2,r.tx=-1-e.x*r.a,r.ty=-1-e.y*r.d)},t.prototype.resize=function(t,e){if(t|=0,e|=0,this.size.width!==t||this.size.height!==e){this.size.width=t,this.size.height=e,this.defaultFrame.width=t,this.defaultFrame.height=e,this.frameBuffer.resize(t*this.resolution,e*this.resolution);var r=this.frame||this.size;this.calculateProjection(r)}},t.prototype.destroy=function(){this.frameBuffer.stencil&&this.gl.deleteRenderbuffer(this.frameBuffer.stencil),this.frameBuffer.destroy(),this.frameBuffer=null,this.texture=null},t}();r.default=h},{"../../../const":46,"../../../math":70,"../../../settings":101,"pixi-gl-core":15}],97:[function(t,e,r){"use strict";function n(t,e){var r=!e;if(r){var n=document.createElement("canvas");n.width=1,n.height=1,e=s.default.createContext(n)}for(var o=e.createShader(e.FRAGMENT_SHADER);;){var u=a.replace(/%forloop%/gi,i(t));if(e.shaderSource(o,u),e.compileShader(o),e.getShaderParameter(o,e.COMPILE_STATUS))break;t=t/2|0}return r&&e.getExtension("WEBGL_lose_context")&&e.getExtension("WEBGL_lose_context").loseContext(),t}function i(t){for(var e="",r=0;r<t;++r)r>0&&(e+="\nelse "),r<t-1&&(e+="if(test == "+r+".0){}");return e}r.__esModule=!0,r.default=n;var o=t("pixi-gl-core"),s=function(t){return t&&t.__esModule?t:{default:t}}(o),a=["precision mediump float;","void main(void){","float test = 0.1;","%forloop%","gl_FragColor = vec4(0.0);","}"].join("\n")},{"pixi-gl-core":15}],98:[function(t,e,r){"use strict";function n(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];return e[i.BLEND_MODES.NORMAL]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.ADD]=[t.ONE,t.ONE],e[i.BLEND_MODES.MULTIPLY]=[t.DST_COLOR,t.ONE_MINUS_SRC_ALPHA,t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.SCREEN]=[t.ONE,t.ONE_MINUS_SRC_COLOR,t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.OVERLAY]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.DARKEN]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.LIGHTEN]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.COLOR_DODGE]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.COLOR_BURN]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.HARD_LIGHT]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.SOFT_LIGHT]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.DIFFERENCE]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.EXCLUSION]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.HUE]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.SATURATION]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.COLOR]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.LUMINOSITY]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.NORMAL_NPM]=[t.SRC_ALPHA,t.ONE_MINUS_SRC_ALPHA,t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.BLEND_MODES.ADD_NPM]=[t.SRC_ALPHA,t.ONE,t.ONE,t.ONE],e[i.BLEND_MODES.SCREEN_NPM]=[t.SRC_ALPHA,t.ONE_MINUS_SRC_COLOR,t.ONE,t.ONE_MINUS_SRC_ALPHA],e}r.__esModule=!0,r.default=n;var i=t("../../../const")},{"../../../const":46}],99:[function(t,e,r){"use strict";function n(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return e[i.DRAW_MODES.POINTS]=t.POINTS,e[i.DRAW_MODES.LINES]=t.LINES,e[i.DRAW_MODES.LINE_LOOP]=t.LINE_LOOP,e[i.DRAW_MODES.LINE_STRIP]=t.LINE_STRIP,e[i.DRAW_MODES.TRIANGLES]=t.TRIANGLES,e[i.DRAW_MODES.TRIANGLE_STRIP]=t.TRIANGLE_STRIP,e[i.DRAW_MODES.TRIANGLE_FAN]=t.TRIANGLE_FAN,e}r.__esModule=!0,r.default=n;var i=t("../../../const")},{"../../../const":46}],100:[function(t,e,r){"use strict";function n(t){t.getContextAttributes().stencil||console.warn("Provided WebGL context does not have a stencil buffer, masks may not render correctly")}r.__esModule=!0,r.default=n},{}],101:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0;var i=t("./utils/maxRecommendedTextures"),o=n(i),s=t("./utils/canUploadSameBuffer"),a=n(s);r.default={TARGET_FPMS:.06,MIPMAP_TEXTURES:!0,RESOLUTION:1,FILTER_RESOLUTION:1,SPRITE_MAX_TEXTURES:(0,o.default)(32),SPRITE_BATCH_SIZE:4096,RETINA_PREFIX:/@([0-9\.]+)x/,RENDER_OPTIONS:{view:null,antialias:!1,forceFXAA:!1,autoResize:!1,transparent:!1,backgroundColor:0,clearBeforeRender:!0,preserveDrawingBuffer:!1,roundPixels:!1,width:800,height:600,legacy:!1},TRANSFORM_MODE:0,GC_MODE:0,GC_MAX_IDLE:3600,GC_MAX_CHECK_COUNT:600,WRAP_MODE:0,SCALE_MODE:0,PRECISION_VERTEX:"highp",PRECISION_FRAGMENT:"mediump",CAN_UPLOAD_SAME_BUFFER:(0,a.default)(),MESH_CANVAS_PADDING:0}},{"./utils/canUploadSameBuffer":122,"./utils/maxRecommendedTextures":127}],102:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),u=t("../math"),h=t("../utils"),l=t("../const"),c=t("../textures/Texture"),d=n(c),f=t("../display/Container"),p=n(f),v=new u.Point,g=function(t){function e(r){i(this,e);var n=o(this,t.call(this));return n._anchor=new u.ObservablePoint(n._onAnchorUpdate,n,r?r.defaultAnchor.x:0,r?r.defaultAnchor.y:0),n._texture=null,n._width=0,n._height=0,n._tint=null,n._tintRGB=null,n.tint=16777215,n.blendMode=l.BLEND_MODES.NORMAL,n.shader=null,n.cachedTint=16777215,n.texture=r||d.default.EMPTY,n.vertexData=new Float32Array(8),n.vertexTrimmedData=null,n._transformID=-1,n._textureID=-1,n._transformTrimmedID=-1,n._textureTrimmedID=-1,n.pluginName="sprite",n}return s(e,t),e.prototype._onTextureUpdate=function(){this._textureID=-1,this._textureTrimmedID=-1,this.cachedTint=16777215,this._width&&(this.scale.x=(0,h.sign)(this.scale.x)*this._width/this._texture.orig.width),this._height&&(this.scale.y=(0,h.sign)(this.scale.y)*this._height/this._texture.orig.height)},e.prototype._onAnchorUpdate=function(){this._transformID=-1,this._transformTrimmedID=-1},e.prototype.calculateVertices=function(){if(this._transformID!==this.transform._worldID||this._textureID!==this._texture._updateID){this._transformID=this.transform._worldID,this._textureID=this._texture._updateID;var t=this._texture,e=this.transform.worldTransform,r=e.a,n=e.b,i=e.c,o=e.d,s=e.tx,a=e.ty,u=this.vertexData,h=t.trim,l=t.orig,c=this._anchor,d=0,f=0,p=0,v=0;h?(f=h.x-c._x*l.width,d=f+h.width,v=h.y-c._y*l.height,p=v+h.height):(f=-c._x*l.width,d=f+l.width,v=-c._y*l.height,p=v+l.height),u[0]=r*f+i*v+s,u[1]=o*v+n*f+a,u[2]=r*d+i*v+s,u[3]=o*v+n*d+a,u[4]=r*d+i*p+s,u[5]=o*p+n*d+a,u[6]=r*f+i*p+s,u[7]=o*p+n*f+a}},e.prototype.calculateTrimmedVertices=function(){if(this.vertexTrimmedData){if(this._transformTrimmedID===this.transform._worldID&&this._textureTrimmedID===this._texture._updateID)return}else this.vertexTrimmedData=new Float32Array(8);this._transformTrimmedID=this.transform._worldID,this._textureTrimmedID=this._texture._updateID;var t=this._texture,e=this.vertexTrimmedData,r=t.orig,n=this._anchor,i=this.transform.worldTransform,o=i.a,s=i.b,a=i.c,u=i.d,h=i.tx,l=i.ty,c=-n._x*r.width,d=c+r.width,f=-n._y*r.height,p=f+r.height;e[0]=o*c+a*f+h,e[1]=u*f+s*c+l,e[2]=o*d+a*f+h,e[3]=u*f+s*d+l,e[4]=o*d+a*p+h,e[5]=u*p+s*d+l,e[6]=o*c+a*p+h,e[7]=u*p+s*c+l},e.prototype._renderWebGL=function(t){this.calculateVertices(),t.setObjectRenderer(t.plugins[this.pluginName]),t.plugins[this.pluginName].render(this)},e.prototype._renderCanvas=function(t){t.plugins[this.pluginName].render(this)},e.prototype._calculateBounds=function(){var t=this._texture.trim,e=this._texture.orig;!t||t.width===e.width&&t.height===e.height?(this.calculateVertices(),this._bounds.addQuad(this.vertexData)):(this.calculateTrimmedVertices(),this._bounds.addQuad(this.vertexTrimmedData))},e.prototype.getLocalBounds=function(e){return 0===this.children.length?(this._bounds.minX=this._texture.orig.width*-this._anchor._x,this._bounds.minY=this._texture.orig.height*-this._anchor._y,this._bounds.maxX=this._texture.orig.width*(1-this._anchor._x),this._bounds.maxY=this._texture.orig.height*(1-this._anchor._y),e||(this._localBoundsRect||(this._localBoundsRect=new u.Rectangle),e=this._localBoundsRect),this._bounds.getRectangle(e)):t.prototype.getLocalBounds.call(this,e)},e.prototype.containsPoint=function(t){this.worldTransform.applyInverse(t,v);var e=this._texture.orig.width,r=this._texture.orig.height,n=-e*this.anchor.x,i=0;return v.x>=n&&v.x<n+e&&(i=-r*this.anchor.y,v.y>=i&&v.y<i+r)},e.prototype.destroy=function(e){if(t.prototype.destroy.call(this,e),this._texture.off("update",this._onTextureUpdate,this),this._anchor=null,"boolean"==typeof e?e:e&&e.texture){var r="boolean"==typeof e?e:e&&e.baseTexture;this._texture.destroy(!!r)}this._texture=null,this.shader=null},e.from=function(t){return new e(d.default.from(t))},e.fromFrame=function(t){var r=h.TextureCache[t];if(!r)throw new Error('The frameId "'+t+'" does not exist in the texture cache');return new e(r)},e.fromImage=function(t,r,n){return new e(d.default.fromImage(t,r,n))},a(e,[{key:"width",get:function(){return Math.abs(this.scale.x)*this._texture.orig.width},set:function(t){var e=(0,h.sign)(this.scale.x)||1;this.scale.x=e*t/this._texture.orig.width,this._width=t}},{key:"height",get:function(){return Math.abs(this.scale.y)*this._texture.orig.height},set:function(t){var e=(0,h.sign)(this.scale.y)||1;this.scale.y=e*t/this._texture.orig.height,this._height=t}},{key:"anchor",get:function(){return this._anchor},set:function(t){this._anchor.copy(t)}},{key:"tint",get:function(){return this._tint},set:function(t){this._tint=t,this._tintRGB=(t>>16)+(65280&t)+((255&t)<<16)}},{key:"texture",get:function(){return this._texture},set:function(t){this._texture!==t&&(this._texture=t||d.default.EMPTY,this.cachedTint=16777215,this._textureID=-1,this._textureTrimmedID=-1,t&&(t.baseTexture.hasLoaded?this._onTextureUpdate():t.once("update",this._onTextureUpdate,this)))}}]),e}(p.default);r.default=g},{"../const":46,"../display/Container":48,"../math":70,"../textures/Texture":115,"../utils":125}],103:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var o=t("../../renderers/canvas/CanvasRenderer"),s=n(o),a=t("../../const"),u=t("../../math"),h=t("./CanvasTinter"),l=n(h),c=new u.Matrix,d=function(){function t(e){i(this,t),this.renderer=e}return t.prototype.render=function(t){var e=t._texture,r=this.renderer,n=e._frame.width,i=e._frame.height,o=t.transform.worldTransform,s=0,h=0;if(!(e.orig.width<=0||e.orig.height<=0)&&e.baseTexture.source&&(r.setBlendMode(t.blendMode),e.valid)){r.context.globalAlpha=t.worldAlpha;var d=e.baseTexture.scaleMode===a.SCALE_MODES.LINEAR;r.smoothProperty&&r.context[r.smoothProperty]!==d&&(r.context[r.smoothProperty]=d),e.trim?(s=e.trim.width/2+e.trim.x-t.anchor.x*e.orig.width,h=e.trim.height/2+e.trim.y-t.anchor.y*e.orig.height):(s=(.5-t.anchor.x)*e.orig.width,h=(.5-t.anchor.y)*e.orig.height),e.rotate&&(o.copy(c),o=c,u.GroupD8.matrixAppendRotationInv(o,e.rotate,s,h),s=0,h=0),s-=n/2,h-=i/2,r.roundPixels?(r.context.setTransform(o.a,o.b,o.c,o.d,o.tx*r.resolution|0,o.ty*r.resolution|0),s|=0,h|=0):r.context.setTransform(o.a,o.b,o.c,o.d,o.tx*r.resolution,o.ty*r.resolution);var f=e.baseTexture.resolution;16777215!==t.tint?(t.cachedTint===t.tint&&t.tintedTexture.tintId===t._texture._updateID||(t.cachedTint=t.tint,t.tintedTexture=l.default.getTintedTexture(t,t.tint)),r.context.drawImage(t.tintedTexture,0,0,n*f,i*f,s*r.resolution,h*r.resolution,n*r.resolution,i*r.resolution)):r.context.drawImage(e.baseTexture.source,e._frame.x*f,e._frame.y*f,n*f,i*f,s*r.resolution,h*r.resolution,n*r.resolution,i*r.resolution)}},t.prototype.destroy=function(){this.renderer=null},t}();r.default=d,s.default.registerPlugin("sprite",d)},{"../../const":46,"../../math":70,"../../renderers/canvas/CanvasRenderer":77,"./CanvasTinter":104}],104:[function(t,e,r){"use strict";r.__esModule=!0;var n=t("../../utils"),i=t("../../renderers/canvas/utils/canUseNewCanvasBlendModes"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s={getTintedTexture:function(t,e){var r=t._texture;e=s.roundColor(e);var n="#"+("00000"+(0|e).toString(16)).substr(-6);r.tintCache=r.tintCache||{};var i=r.tintCache[n],o=void 0;if(i){if(i.tintId===r._updateID)return r.tintCache[n];o=r.tintCache[n]}else o=s.canvas||document.createElement("canvas");if(s.tintMethod(r,e,o),o.tintId=r._updateID,s.convertTintToImage){var a=new Image;a.src=o.toDataURL(),r.tintCache[n]=a}else r.tintCache[n]=o,s.canvas=null;return o},tintWithMultiply:function(t,e,r){var n=r.getContext("2d"),i=t._frame.clone(),o=t.baseTexture.resolution;i.x*=o,i.y*=o,i.width*=o,i.height*=o,r.width=Math.ceil(i.width),r.height=Math.ceil(i.height),n.save(),n.fillStyle="#"+("00000"+(0|e).toString(16)).substr(-6),n.fillRect(0,0,i.width,i.height),n.globalCompositeOperation="multiply",n.drawImage(t.baseTexture.source,i.x,i.y,i.width,i.height,0,0,i.width,i.height),n.globalCompositeOperation="destination-atop",n.drawImage(t.baseTexture.source,i.x,i.y,i.width,i.height,0,0,i.width,i.height),n.restore()},tintWithOverlay:function(t,e,r){var n=r.getContext("2d"),i=t._frame.clone(),o=t.baseTexture.resolution;i.x*=o,i.y*=o,i.width*=o,i.height*=o,r.width=Math.ceil(i.width),r.height=Math.ceil(i.height),n.save(),n.globalCompositeOperation="copy",n.fillStyle="#"+("00000"+(0|e).toString(16)).substr(-6),n.fillRect(0,0,i.width,i.height),n.globalCompositeOperation="destination-atop",n.drawImage(t.baseTexture.source,i.x,i.y,i.width,i.height,0,0,i.width,i.height),n.restore()},tintWithPerPixel:function(t,e,r){var i=r.getContext("2d"),o=t._frame.clone(),s=t.baseTexture.resolution;o.x*=s,o.y*=s,o.width*=s,o.height*=s,r.width=Math.ceil(o.width),r.height=Math.ceil(o.height),i.save(),i.globalCompositeOperation="copy",i.drawImage(t.baseTexture.source,o.x,o.y,o.width,o.height,0,0,o.width,o.height),i.restore();for(var a=(0,n.hex2rgb)(e),u=a[0],h=a[1],l=a[2],c=i.getImageData(0,0,o.width,o.height),d=c.data,f=0;f<d.length;f+=4)d[f+0]*=u,d[f+1]*=h,d[f+2]*=l;i.putImageData(c,0,0)},roundColor:function(t){var e=s.cacheStepsPerColorChannel,r=(0,n.hex2rgb)(t);return r[0]=Math.min(255,r[0]/e*e),r[1]=Math.min(255,r[1]/e*e),r[2]=Math.min(255,r[2]/e*e),(0,n.rgb2hex)(r)},cacheStepsPerColorChannel:8,convertTintToImage:!1,canUseMultiply:(0,o.default)(),tintMethod:0};s.tintMethod=s.canUseMultiply?s.tintWithMultiply:s.tintWithPerPixel,r.default=s},{"../../renderers/canvas/utils/canUseNewCanvasBlendModes":80,"../../utils":125}],105:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(e){n(this,t),this.vertices=new ArrayBuffer(e),this.float32View=new Float32Array(this.vertices),this.uint32View=new Uint32Array(this.vertices)}return t.prototype.destroy=function(){this.vertices=null,this.positions=null,this.uvs=null,this.colors=null},t}();r.default=i},{}],106:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0
;var a=t("../../renderers/webgl/utils/ObjectRenderer"),u=n(a),h=t("../../renderers/webgl/WebGLRenderer"),l=n(h),c=t("../../utils/createIndicesForQuads"),d=n(c),f=t("./generateMultiTextureShader"),p=n(f),v=t("../../renderers/webgl/utils/checkMaxIfStatmentsInShader"),g=n(v),y=t("./BatchBuffer"),m=n(y),_=t("../../settings"),b=n(_),x=t("../../utils"),T=t("pixi-gl-core"),w=n(T),E=t("bit-twiddle"),S=n(E),O=0,M=0,P=function(t){function e(r){i(this,e);var n=o(this,t.call(this,r));n.vertSize=5,n.vertByteSize=4*n.vertSize,n.size=b.default.SPRITE_BATCH_SIZE,n.buffers=[];for(var s=1;s<=S.default.nextPow2(n.size);s*=2)n.buffers.push(new m.default(4*s*n.vertByteSize));n.indices=(0,d.default)(n.size),n.shader=null,n.currentIndex=0,n.groups=[];for(var a=0;a<n.size;a++)n.groups[a]={textures:[],textureCount:0,ids:[],size:0,start:0,blend:0};return n.sprites=[],n.vertexBuffers=[],n.vaos=[],n.vaoMax=2,n.vertexCount=0,n.renderer.on("prerender",n.onPrerender,n),n}return s(e,t),e.prototype.onContextChange=function(){var t=this.renderer.gl;this.renderer.legacy?this.MAX_TEXTURES=1:(this.MAX_TEXTURES=Math.min(t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS),b.default.SPRITE_MAX_TEXTURES),this.MAX_TEXTURES=(0,g.default)(this.MAX_TEXTURES,t)),this.shader=(0,p.default)(t,this.MAX_TEXTURES),this.indexBuffer=w.default.GLBuffer.createIndexBuffer(t,this.indices,t.STATIC_DRAW),this.renderer.bindVao(null);for(var e=this.shader.attributes,r=0;r<this.vaoMax;r++){var n=this.vertexBuffers[r]=w.default.GLBuffer.createVertexBuffer(t,null,t.STREAM_DRAW),i=this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(n,e.aVertexPosition,t.FLOAT,!1,this.vertByteSize,0).addAttribute(n,e.aTextureCoord,t.UNSIGNED_SHORT,!0,this.vertByteSize,8).addAttribute(n,e.aColor,t.UNSIGNED_BYTE,!0,this.vertByteSize,12);e.aTextureId&&i.addAttribute(n,e.aTextureId,t.FLOAT,!1,this.vertByteSize,16),this.vaos[r]=i}this.vao=this.vaos[0],this.currentBlendMode=99999,this.boundTextures=new Array(this.MAX_TEXTURES)},e.prototype.onPrerender=function(){this.vertexCount=0},e.prototype.render=function(t){this.currentIndex>=this.size&&this.flush(),t._texture._uvs&&(this.sprites[this.currentIndex++]=t)},e.prototype.flush=function(){if(0!==this.currentIndex){var t=this.renderer.gl,e=this.MAX_TEXTURES,r=S.default.nextPow2(this.currentIndex),n=S.default.log2(r),i=this.buffers[n],o=this.sprites,s=this.groups,a=i.float32View,u=i.uint32View,h=this.boundTextures,l=this.renderer.boundTextures,c=this.renderer.textureGC.count,d=0,f=void 0,p=void 0,v=1,g=0,y=s[0],m=void 0,_=void 0,T=x.premultiplyBlendMode[o[0]._texture.baseTexture.premultipliedAlpha?1:0][o[0].blendMode];y.textureCount=0,y.start=0,y.blend=T,O++;var E=void 0;for(E=0;E<e;++E){var P=l[E];P._enabled!==O?(h[E]=P,P._virtalBoundId=E,P._enabled=O):h[E]=this.renderer.emptyTextures[E]}for(O++,E=0;E<this.currentIndex;++E){var C=o[E];o[E]=null,f=C._texture.baseTexture;var R=x.premultiplyBlendMode[Number(f.premultipliedAlpha)][C.blendMode];if(T!==R&&(T=R,p=null,g=e,O++),p!==f&&(p=f,f._enabled!==O)){if(g===e&&(O++,y.size=E-y.start,g=0,y=s[v++],y.blend=T,y.textureCount=0,y.start=E),f.touched=c,-1===f._virtalBoundId)for(var A=0;A<e;++A){var I=(A+M)%e,D=h[I];if(D._enabled!==O){M++,D._virtalBoundId=-1,f._virtalBoundId=I,h[I]=f;break}}f._enabled=O,y.textureCount++,y.ids[g]=f._virtalBoundId,y.textures[g++]=f}if(m=C.vertexData,_=C._texture._uvs.uvsUint32,this.renderer.roundPixels){var L=this.renderer.resolution;a[d]=(m[0]*L|0)/L,a[d+1]=(m[1]*L|0)/L,a[d+5]=(m[2]*L|0)/L,a[d+6]=(m[3]*L|0)/L,a[d+10]=(m[4]*L|0)/L,a[d+11]=(m[5]*L|0)/L,a[d+15]=(m[6]*L|0)/L,a[d+16]=(m[7]*L|0)/L}else a[d]=m[0],a[d+1]=m[1],a[d+5]=m[2],a[d+6]=m[3],a[d+10]=m[4],a[d+11]=m[5],a[d+15]=m[6],a[d+16]=m[7];u[d+2]=_[0],u[d+7]=_[1],u[d+12]=_[2],u[d+17]=_[3];var N=Math.min(C.worldAlpha,1),B=N<1&&f.premultipliedAlpha?(0,x.premultiplyTint)(C._tintRGB,N):C._tintRGB+(255*N<<24);u[d+3]=u[d+8]=u[d+13]=u[d+18]=B,a[d+4]=a[d+9]=a[d+14]=a[d+19]=f._virtalBoundId,d+=20}if(y.size=E-y.start,b.default.CAN_UPLOAD_SAME_BUFFER)this.vertexBuffers[this.vertexCount].upload(i.vertices,0,!0);else{if(this.vaoMax<=this.vertexCount){this.vaoMax++;var k=this.shader.attributes,F=this.vertexBuffers[this.vertexCount]=w.default.GLBuffer.createVertexBuffer(t,null,t.STREAM_DRAW),j=this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(F,k.aVertexPosition,t.FLOAT,!1,this.vertByteSize,0).addAttribute(F,k.aTextureCoord,t.UNSIGNED_SHORT,!0,this.vertByteSize,8).addAttribute(F,k.aColor,t.UNSIGNED_BYTE,!0,this.vertByteSize,12);k.aTextureId&&j.addAttribute(F,k.aTextureId,t.FLOAT,!1,this.vertByteSize,16),this.vaos[this.vertexCount]=j}this.renderer.bindVao(this.vaos[this.vertexCount]),this.vertexBuffers[this.vertexCount].upload(i.vertices,0,!1),this.vertexCount++}for(E=0;E<e;++E)l[E]._virtalBoundId=-1;for(E=0;E<v;++E){for(var U=s[E],X=U.textureCount,G=0;G<X;G++)p=U.textures[G],l[U.ids[G]]!==p&&this.renderer.bindTexture(p,U.ids[G],!0),p._virtalBoundId=-1;this.renderer.state.setBlendMode(U.blend),t.drawElements(t.TRIANGLES,6*U.size,t.UNSIGNED_SHORT,6*U.start*2)}this.currentIndex=0}},e.prototype.start=function(){this.renderer.bindShader(this.shader),b.default.CAN_UPLOAD_SAME_BUFFER&&(this.renderer.bindVao(this.vaos[this.vertexCount]),this.vertexBuffers[this.vertexCount].bind())},e.prototype.stop=function(){this.flush()},e.prototype.destroy=function(){for(var e=0;e<this.vaoMax;e++)this.vertexBuffers[e]&&this.vertexBuffers[e].destroy(),this.vaos[e]&&this.vaos[e].destroy();this.indexBuffer&&this.indexBuffer.destroy(),this.renderer.off("prerender",this.onPrerender,this),t.prototype.destroy.call(this),this.shader&&(this.shader.destroy(),this.shader=null),this.vertexBuffers=null,this.vaos=null,this.indexBuffer=null,this.indices=null,this.sprites=null;for(var r=0;r<this.buffers.length;++r)this.buffers[r].destroy()},e}(u.default);r.default=P,l.default.registerPlugin("sprite",P)},{"../../renderers/webgl/WebGLRenderer":84,"../../renderers/webgl/utils/ObjectRenderer":94,"../../renderers/webgl/utils/checkMaxIfStatmentsInShader":97,"../../settings":101,"../../utils":125,"../../utils/createIndicesForQuads":123,"./BatchBuffer":105,"./generateMultiTextureShader":107,"bit-twiddle":1,"pixi-gl-core":15}],107:[function(t,e,r){"use strict";function n(t,e){var r=a;r=r.replace(/%count%/gi,e),r=r.replace(/%forloop%/gi,i(e));for(var n=new s.default(t,"precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = aColor;\n}\n",r),o=[],u=0;u<e;u++)o[u]=u;return n.bind(),n.uniforms.uSamplers=o,n}function i(t){var e="";e+="\n",e+="\n";for(var r=0;r<t;r++)r>0&&(e+="\nelse "),r<t-1&&(e+="if(vTextureId < "+r+".5)"),e+="\n{",e+="\n\tcolor = texture2D(uSamplers["+r+"], vTextureCoord);",e+="\n}";return e+="\n",e+="\n"}r.__esModule=!0,r.default=n;var o=t("../../Shader"),s=function(t){return t&&t.__esModule?t:{default:t}}(o),a=(t("path"),["varying vec2 vTextureCoord;","varying vec4 vColor;","varying float vTextureId;","uniform sampler2D uSamplers[%count%];","void main(void){","vec4 color;","%forloop%","gl_FragColor = color * vColor;","}"].join("\n"))},{"../../Shader":44,path:8}],108:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),u=t("../sprites/Sprite"),h=n(u),l=t("../textures/Texture"),c=n(l),d=t("../math"),f=t("../utils"),p=t("../const"),v=t("../settings"),g=n(v),y=t("./TextStyle"),m=n(y),_=t("./TextMetrics"),b=n(_),x=t("../utils/trimCanvas"),T=n(x),w={texture:!0,children:!1,baseTexture:!0},E=function(t){function e(r,n,s){i(this,e),s=s||document.createElement("canvas"),s.width=3,s.height=3;var a=c.default.fromCanvas(s,g.default.SCALE_MODE,"text");a.orig=new d.Rectangle,a.trim=new d.Rectangle;var u=o(this,t.call(this,a));return c.default.addToCache(u._texture,u._texture.baseTexture.textureCacheIds[0]),u.canvas=s,u.context=u.canvas.getContext("2d"),u.resolution=g.default.RESOLUTION,u._text=null,u._style=null,u._styleListener=null,u._font="",u.text=r,u.style=n,u.localStyleID=-1,u}return s(e,t),e.prototype.updateText=function(t){var e=this._style;if(this.localStyleID!==e.styleID&&(this.dirty=!0,this.localStyleID=e.styleID),this.dirty||!t){this._font=this._style.toFontString();var r=this.context,n=b.default.measureText(this._text,this._style,this._style.wordWrap,this.canvas),i=n.width,o=n.height,s=n.lines,a=n.lineHeight,u=n.lineWidths,h=n.maxLineWidth,l=n.fontProperties;this.canvas.width=Math.ceil((Math.max(1,i)+2*e.padding)*this.resolution),this.canvas.height=Math.ceil((Math.max(1,o)+2*e.padding)*this.resolution),r.scale(this.resolution,this.resolution),r.clearRect(0,0,this.canvas.width,this.canvas.height),r.font=this._font,r.strokeStyle=e.stroke,r.lineWidth=e.strokeThickness,r.textBaseline=e.textBaseline,r.lineJoin=e.lineJoin,r.miterLimit=e.miterLimit;var c=void 0,d=void 0;if(e.dropShadow){r.fillStyle=e.dropShadowColor,r.globalAlpha=e.dropShadowAlpha,r.shadowBlur=e.dropShadowBlur,e.dropShadowBlur>0&&(r.shadowColor=e.dropShadowColor);for(var f=Math.cos(e.dropShadowAngle)*e.dropShadowDistance,p=Math.sin(e.dropShadowAngle)*e.dropShadowDistance,v=0;v<s.length;v++)c=e.strokeThickness/2,d=e.strokeThickness/2+v*a+l.ascent,"right"===e.align?c+=h-u[v]:"center"===e.align&&(c+=(h-u[v])/2),e.fill&&(this.drawLetterSpacing(s[v],c+f+e.padding,d+p+e.padding),e.stroke&&e.strokeThickness&&(r.strokeStyle=e.dropShadowColor,this.drawLetterSpacing(s[v],c+f+e.padding,d+p+e.padding,!0),r.strokeStyle=e.stroke))}r.shadowBlur=0,r.globalAlpha=1,r.fillStyle=this._generateFillStyle(e,s);for(var g=0;g<s.length;g++)c=e.strokeThickness/2,d=e.strokeThickness/2+g*a+l.ascent,"right"===e.align?c+=h-u[g]:"center"===e.align&&(c+=(h-u[g])/2),e.stroke&&e.strokeThickness&&this.drawLetterSpacing(s[g],c+e.padding,d+e.padding,!0),e.fill&&this.drawLetterSpacing(s[g],c+e.padding,d+e.padding);this.updateTexture()}},e.prototype.drawLetterSpacing=function(t,e,r){var n=arguments.length>3&&void 0!==arguments[3]&&arguments[3],i=this._style,o=i.letterSpacing;if(0===o)return void(n?this.context.strokeText(t,e,r):this.context.fillText(t,e,r));for(var s=String.prototype.split.call(t,""),a=e,u=0,h="";u<t.length;)h=s[u++],n?this.context.strokeText(h,a,r):this.context.fillText(h,a,r),a+=this.context.measureText(h).width+o},e.prototype.updateTexture=function(){var t=this.canvas;if(this._style.trim){var e=(0,T.default)(t);e.data&&(t.width=e.width,t.height=e.height,this.context.putImageData(e.data,0,0))}var r=this._texture,n=this._style,i=n.trim?0:n.padding,o=r.baseTexture;o.hasLoaded=!0,o.resolution=this.resolution,o.realWidth=t.width,o.realHeight=t.height,o.width=t.width/this.resolution,o.height=t.height/this.resolution,r.trim.width=r._frame.width=t.width/this.resolution,r.trim.height=r._frame.height=t.height/this.resolution,r.trim.x=-i,r.trim.y=-i,r.orig.width=r._frame.width-2*i,r.orig.height=r._frame.height-2*i,this._onTextureUpdate(),o.emit("update",o),this.dirty=!1},e.prototype.renderWebGL=function(e){this.resolution!==e.resolution&&(this.resolution=e.resolution,this.dirty=!0),this.updateText(!0),t.prototype.renderWebGL.call(this,e)},e.prototype._renderCanvas=function(e){this.resolution!==e.resolution&&(this.resolution=e.resolution,this.dirty=!0),this.updateText(!0),t.prototype._renderCanvas.call(this,e)},e.prototype.getLocalBounds=function(e){return this.updateText(!0),t.prototype.getLocalBounds.call(this,e)},e.prototype._calculateBounds=function(){this.updateText(!0),this.calculateVertices(),this._bounds.addQuad(this.vertexData)},e.prototype._onStyleChange=function(){this.dirty=!0},e.prototype._generateFillStyle=function(t,e){if(!Array.isArray(t.fill))return t.fill;if(navigator.isCocoonJS)return t.fill[0];var r=void 0,n=void 0,i=void 0,o=void 0,s=this.canvas.width/this.resolution,a=this.canvas.height/this.resolution,u=t.fill.slice(),h=t.fillGradientStops.slice();if(!h.length)for(var l=u.length+1,c=1;c<l;++c)h.push(c/l);if(u.unshift(t.fill[0]),h.unshift(0),u.push(t.fill[t.fill.length-1]),h.push(1),t.fillGradientType===p.TEXT_GRADIENT.LINEAR_VERTICAL){r=this.context.createLinearGradient(s/2,0,s/2,a),n=(u.length+1)*e.length,i=0;for(var d=0;d<e.length;d++){i+=1;for(var f=0;f<u.length;f++)o="number"==typeof h[f]?h[f]/e.length+d/e.length:i/n,r.addColorStop(o,u[f]),i++}}else{r=this.context.createLinearGradient(0,a/2,s,a/2),n=u.length+1,i=1;for(var v=0;v<u.length;v++)o="number"==typeof h[v]?h[v]:i/n,r.addColorStop(o,u[v]),i++}return r},e.prototype.destroy=function(e){"boolean"==typeof e&&(e={children:e}),e=Object.assign({},w,e),t.prototype.destroy.call(this,e),this.context=null,this.canvas=null,this._style=null},a(e,[{key:"width",get:function(){return this.updateText(!0),Math.abs(this.scale.x)*this._texture.orig.width},set:function(t){this.updateText(!0);var e=(0,f.sign)(this.scale.x)||1;this.scale.x=e*t/this._texture.orig.width,this._width=t}},{key:"height",get:function(){return this.updateText(!0),Math.abs(this.scale.y)*this._texture.orig.height},set:function(t){this.updateText(!0);var e=(0,f.sign)(this.scale.y)||1;this.scale.y=e*t/this._texture.orig.height,this._height=t}},{key:"style",get:function(){return this._style},set:function(t){t=t||{},t instanceof m.default?this._style=t:this._style=new m.default(t),this.localStyleID=-1,this.dirty=!0}},{key:"text",get:function(){return this._text},set:function(t){t=String(""===t||null===t||void 0===t?" ":t),this._text!==t&&(this._text=t,this.dirty=!0)}}]),e}(h.default);r.default=E},{"../const":46,"../math":70,"../settings":101,"../sprites/Sprite":102,"../textures/Texture":115,"../utils":125,"../utils/trimCanvas":130,"./TextMetrics":109,"./TextStyle":110}],109:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(e,r,i,o,s,a,u,h,l){n(this,t),this.text=e,this.style=r,this.width=i,this.height=o,this.lines=s,this.lineWidths=a,this.lineHeight=u,this.maxLineWidth=h,this.fontProperties=l}return t.measureText=function(e,r,n){var i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:t._canvas;n=void 0===n||null===n?r.wordWrap:n;var o=r.toFontString(),s=t.measureFont(o),a=i.getContext("2d");a.font=o;for(var u=n?t.wordWrap(e,r,i):e,h=u.split(/(?:\r\n|\r|\n)/),l=new Array(h.length),c=0,d=0;d<h.length;d++){var f=a.measureText(h[d]).width+(h[d].length-1)*r.letterSpacing;l[d]=f,c=Math.max(c,f)}var p=c+r.strokeThickness;r.dropShadow&&(p+=r.dropShadowDistance);var v=r.lineHeight||s.fontSize+r.strokeThickness,g=Math.max(v,s.fontSize+r.strokeThickness)+(h.length-1)*(v+r.leading);return r.dropShadow&&(g+=r.dropShadowDistance),new t(e,r,p,g,h,l,v+r.leading,c,s)},t.wordWrap=function(e,r){for(var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t._canvas,i=n.getContext("2d"),o=0,s="",a="",u={},h=r.letterSpacing,l=r.whiteSpace,c=t.collapseSpaces(l),d=t.collapseNewlines(l),f=!c,p=r.wordWrapWidth+h,v=t.tokenize(e),g=0;g<v.length;g++){var y=v[g];if(t.isNewline(y)){if(!d){a+=t.addLine(s),f=!c,s="",o=0;continue}y=" "}if(c){var m=t.isBreakingSpace(y),_=t.isBreakingSpace(s[s.length-1]);if(m&&_)continue}var b=t.getFromCache(y,h,u,i);if(b>p)if(""!==s&&(a+=t.addLine(s),s="",o=0),t.canBreakWords(y,r.breakWords))for(var x=y.split(""),T=0;T<x.length;T++){for(var w=x[T],E=1;x[T+E];){var S=x[T+E],O=w[w.length-1];if(t.canBreakChars(O,S,y,T,r.breakWords))break;w+=S,E++}T+=w.length-1;var M=t.getFromCache(w,h,u,i);M+o>p&&(a+=t.addLine(s),f=!1,s="",o=0),s+=w,o+=M}else{s.length>0&&(a+=t.addLine(s),s="",o=0);var P=g===v.length-1;a+=t.addLine(y,!P),f=!1,s="",o=0}else b+o>p&&(f=!1,a+=t.addLine(s),s="",o=0),(s.length>0||!t.isBreakingSpace(y)||f)&&(s+=y,o+=b)}return a+=t.addLine(s,!1)},t.addLine=function(e){var r=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return e=t.trimRight(e),e=r?e+"\n":e},t.getFromCache=function(t,e,r,n){var i=r[t];if(void 0===i){var o=t.length*e;i=n.measureText(t).width+o,r[t]=i}return i},t.collapseSpaces=function(t){return"normal"===t||"pre-line"===t},t.collapseNewlines=function(t){return"normal"===t},t.trimRight=function(e){if("string"!=typeof e)return"";for(var r=e.length-1;r>=0;r--){var n=e[r];if(!t.isBreakingSpace(n))break;e=e.slice(0,-1)}return e},t.isNewline=function(e){return"string"==typeof e&&t._newlines.indexOf(e.charCodeAt(0))>=0},t.isBreakingSpace=function(e){return"string"==typeof e&&t._breakingSpaces.indexOf(e.charCodeAt(0))>=0},t.tokenize=function(e){var r=[],n="";if("string"!=typeof e)return r;for(var i=0;i<e.length;i++){var o=e[i];t.isBreakingSpace(o)||t.isNewline(o)?(""!==n&&(r.push(n),n=""),r.push(o)):n+=o}return""!==n&&r.push(n),r},t.canBreakWords=function(t,e){return e},t.canBreakChars=function(t,e,r,n,i){return!0},t.measureFont=function(e){if(t._fonts[e])return t._fonts[e];var r={},n=t._canvas,i=t._context;i.font=e;var o=t.METRICS_STRING+t.BASELINE_SYMBOL,s=Math.ceil(i.measureText(o).width),a=Math.ceil(i.measureText(t.BASELINE_SYMBOL).width),u=2*a;a=a*t.BASELINE_MULTIPLIER|0,n.width=s,n.height=u,i.fillStyle="#f00",i.fillRect(0,0,s,u),i.font=e,i.textBaseline="alphabetic",i.fillStyle="#000",i.fillText(o,0,a);var h=i.getImageData(0,0,s,u).data,l=h.length,c=4*s,d=0,f=0,p=!1;for(d=0;d<a;++d){for(var v=0;v<c;v+=4)if(255!==h[f+v]){p=!0;break}if(p)break;f+=c}for(r.ascent=a-d,f=l-c,p=!1,d=u;d>a;--d){for(var g=0;g<c;g+=4)if(255!==h[f+g]){p=!0;break}if(p)break;f-=c}return r.descent=d-a,r.fontSize=r.ascent+r.descent,t._fonts[e]=r,r},t.clearMetrics=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";e?delete t._fonts[e]:t._fonts={}},t}();r.default=i;var o=document.createElement("canvas");o.width=o.height=10,i._canvas=o,i._context=o.getContext("2d"),i._fonts={},i.METRICS_STRING="|Éq",i.BASELINE_SYMBOL="M",i.BASELINE_MULTIPLIER=1.4,i._newlines=[10,13],i._breakingSpaces=[9,32,8192,8193,8194,8195,8196,8197,8198,8200,8201,8202,8287,12288]},{}],110:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t){return"number"==typeof t?(0,l.hex2string)(t):("string"==typeof t&&0===t.indexOf("0x")&&(t=t.replace("0x","#")),t)}function o(t){if(Array.isArray(t)){for(var e=0;e<t.length;++e)t[e]=i(t[e]);return t}return i(t)}function s(t,e){if(!Array.isArray(t)||!Array.isArray(e))return!1;if(t.length!==e.length)return!1;for(var r=0;r<t.length;++r)if(t[r]!==e[r])return!1;return!0}function a(t,e,r){for(var n in r)Array.isArray(e[n])?t[n]=e[n].slice():t[n]=e[n]}r.__esModule=!0;var u=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),h=t("../const"),l=t("../utils"),c={align:"left",breakWords:!1,dropShadow:!1,dropShadowAlpha:1,dropShadowAngle:Math.PI/6,dropShadowBlur:0,dropShadowColor:"black",dropShadowDistance:5,fill:"black",fillGradientType:h.TEXT_GRADIENT.LINEAR_VERTICAL,fillGradientStops:[],fontFamily:"Arial",fontSize:26,fontStyle:"normal",fontVariant:"normal",fontWeight:"normal",letterSpacing:0,lineHeight:0,lineJoin:"miter",miterLimit:10,padding:0,stroke:"black",strokeThickness:0,textBaseline:"alphabetic",trim:!1,whiteSpace:"pre",wordWrap:!1,wordWrapWidth:100,leading:0},d=["serif","sans-serif","monospace","cursive","fantasy","system-ui"],f=function(){function t(e){n(this,t),this.styleID=0,this.reset(),a(this,e,e)}return t.prototype.clone=function(){var e={};return a(e,this,c),new t(e)},t.prototype.reset=function(){a(this,c,c)},t.prototype.toFontString=function(){var t="number"==typeof this.fontSize?this.fontSize+"px":this.fontSize,e=this.fontFamily;Array.isArray(this.fontFamily)||(e=this.fontFamily.split(","));for(var r=e.length-1;r>=0;r--){var n=e[r].trim();!/([\"\'])[^\'\"]+\1/.test(n)&&d.indexOf(n)<0&&(n='"'+n+'"'),e[r]=n}return this.fontStyle+" "+this.fontVariant+" "+this.fontWeight+" "+t+" "+e.join(",")},u(t,[{key:"align",get:function(){return this._align},set:function(t){this._align!==t&&(this._align=t,this.styleID++)}},{key:"breakWords",get:function(){return this._breakWords},set:function(t){this._breakWords!==t&&(this._breakWords=t,this.styleID++)}},{key:"dropShadow",get:function(){return this._dropShadow},set:function(t){this._dropShadow!==t&&(this._dropShadow=t,this.styleID++)}},{key:"dropShadowAlpha",get:function(){return this._dropShadowAlpha},set:function(t){this._dropShadowAlpha!==t&&(this._dropShadowAlpha=t,this.styleID++)}},{key:"dropShadowAngle",get:function(){return this._dropShadowAngle},set:function(t){this._dropShadowAngle!==t&&(this._dropShadowAngle=t,this.styleID++)}},{key:"dropShadowBlur",get:function(){return this._dropShadowBlur},set:function(t){this._dropShadowBlur!==t&&(this._dropShadowBlur=t,this.styleID++)}},{key:"dropShadowColor",get:function(){return this._dropShadowColor},set:function(t){var e=o(t);this._dropShadowColor!==e&&(this._dropShadowColor=e,this.styleID++)}},{key:"dropShadowDistance",get:function(){return this._dropShadowDistance},set:function(t){this._dropShadowDistance!==t&&(this._dropShadowDistance=t,this.styleID++)}},{key:"fill",get:function(){return this._fill},set:function(t){var e=o(t);this._fill!==e&&(this._fill=e,this.styleID++)}},{key:"fillGradientType",get:function(){return this._fillGradientType},set:function(t){this._fillGradientType!==t&&(this._fillGradientType=t,this.styleID++)}},{key:"fillGradientStops",get:function(){return this._fillGradientStops},set:function(t){s(this._fillGradientStops,t)||(this._fillGradientStops=t,this.styleID++)}},{key:"fontFamily",get:function(){return this._fontFamily},set:function(t){this.fontFamily!==t&&(this._fontFamily=t,this.styleID++)}},{key:"fontSize",get:function(){return this._fontSize},set:function(t){this._fontSize!==t&&(this._fontSize=t,this.styleID++)}},{key:"fontStyle",get:function(){return this._fontStyle},set:function(t){this._fontStyle!==t&&(this._fontStyle=t,this.styleID++)}},{key:"fontVariant",get:function(){return this._fontVariant},set:function(t){this._fontVariant!==t&&(this._fontVariant=t,this.styleID++)}},{key:"fontWeight",get:function(){return this._fontWeight},set:function(t){this._fontWeight!==t&&(this._fontWeight=t,this.styleID++)}},{key:"letterSpacing",get:function(){return this._letterSpacing},set:function(t){this._letterSpacing!==t&&(this._letterSpacing=t,this.styleID++)}},{key:"lineHeight",get:function(){return this._lineHeight},set:function(t){this._lineHeight!==t&&(this._lineHeight=t,this.styleID++)}},{key:"leading",get:function(){return this._leading},set:function(t){this._leading!==t&&(this._leading=t,this.styleID++)}},{key:"lineJoin",get:function(){return this._lineJoin},set:function(t){this._lineJoin!==t&&(this._lineJoin=t,this.styleID++)}},{key:"miterLimit",get:function(){return this._miterLimit},set:function(t){this._miterLimit!==t&&(this._miterLimit=t,this.styleID++)}},{key:"padding",get:function(){return this._padding},set:function(t){this._padding!==t&&(this._padding=t,this.styleID++)}},{key:"stroke",get:function(){return this._stroke},set:function(t){var e=o(t);this._stroke!==e&&(this._stroke=e,this.styleID++)}},{key:"strokeThickness",get:function(){return this._strokeThickness},set:function(t){this._strokeThickness!==t&&(this._strokeThickness=t,this.styleID++)}},{key:"textBaseline",get:function(){return this._textBaseline},set:function(t){this._textBaseline!==t&&(this._textBaseline=t,this.styleID++)}},{key:"trim",get:function(){return this._trim},set:function(t){this._trim!==t&&(this._trim=t,this.styleID++)}},{key:"whiteSpace",get:function(){return this._whiteSpace},set:function(t){this._whiteSpace!==t&&(this._whiteSpace=t,this.styleID++)}},{key:"wordWrap",get:function(){return this._wordWrap},set:function(t){this._wordWrap!==t&&(this._wordWrap=t,this.styleID++)}},{key:"wordWrapWidth",get:function(){return this._wordWrapWidth},set:function(t){this._wordWrapWidth!==t&&(this._wordWrapWidth=t,this.styleID++)}}]),t}();r.default=f},{"../const":46,"../utils":125}],111:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("./BaseTexture"),u=n(a),h=t("../settings"),l=n(h),c=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:100,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:100,s=arguments[2],a=arguments[3];i(this,e);var u=o(this,t.call(this,null,s));return u.resolution=a||l.default.RESOLUTION,u.width=Math.ceil(r),u.height=Math.ceil(n),u.realWidth=u.width*u.resolution,u.realHeight=u.height*u.resolution,u.scaleMode=void 0!==s?s:l.default.SCALE_MODE,u.hasLoaded=!0,u._glRenderTargets={},u._canvasRenderTarget=null,u.valid=!1,u}return s(e,t),e.prototype.resize=function(t,e){t=Math.ceil(t),e=Math.ceil(e),t===this.width&&e===this.height||(this.valid=t>0&&e>0,this.width=t,this.height=e,this.realWidth=this.width*this.resolution,this.realHeight=this.height*this.resolution,this.valid&&this.emit("update",this))},e.prototype.destroy=function(){t.prototype.destroy.call(this,!0),this.renderer=null},e}(u.default);r.default=c},{"../settings":101,"./BaseTexture":112}],112:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("../utils"),u=t("../settings"),h=n(u),l=t("eventemitter3"),c=n(l),d=t("../utils/determineCrossOrigin"),f=n(d),p=t("bit-twiddle"),v=n(p),g=function(t){function e(r,n,s){i(this,e);var u=o(this,t.call(this));return u.uid=(0,a.uid)(),u.touched=0,u.resolution=s||h.default.RESOLUTION,u.width=100,u.height=100,u.realWidth=100,u.realHeight=100,u.scaleMode=void 0!==n?n:h.default.SCALE_MODE,u.hasLoaded=!1,u.isLoading=!1,u.source=null,u.origSource=null,u.imageType=null,u.sourceScale=1,u.premultipliedAlpha=!0,u.imageUrl=null,u.isPowerOfTwo=!1,u.mipmap=h.default.MIPMAP_TEXTURES,u.wrapMode=h.default.WRAP_MODE,u._glTextures={},u._enabled=0,u._virtalBoundId=-1,u._destroyed=!1,u.textureCacheIds=[],r&&u.loadSource(r),u}return s(e,t),e.prototype.update=function(){"svg"!==this.imageType&&(this.realWidth=this.source.naturalWidth||this.source.videoWidth||this.source.width,this.realHeight=this.source.naturalHeight||this.source.videoHeight||this.source.height,this._updateDimensions()),this.emit("update",this)},e.prototype._updateDimensions=function(){this.width=this.realWidth/this.resolution,this.height=this.realHeight/this.resolution,this.isPowerOfTwo=v.default.isPow2(this.realWidth)&&v.default.isPow2(this.realHeight)},e.prototype.loadSource=function(t){var e=this.isLoading;this.hasLoaded=!1,this.isLoading=!1,e&&this.source&&(this.source.onload=null,this.source.onerror=null);var r=!this.source;if(this.source=t,(t.src&&t.complete||t.getContext)&&t.width&&t.height)this._updateImageType(),"svg"===this.imageType?this._loadSvgSource():this._sourceLoaded(),r&&this.emit("loaded",this);else if(!t.getContext){this.isLoading=!0;var n=this;if(t.onload=function(){if(n._updateImageType(),t.onload=null,t.onerror=null,n.isLoading){if(n.isLoading=!1,n._sourceLoaded(),"svg"===n.imageType)return void n._loadSvgSource();n.emit("loaded",n)}},t.onerror=function(){t.onload=null,t.onerror=null,n.isLoading&&(n.isLoading=!1,n.emit("error",n))},t.complete&&t.src){if(t.onload=null,t.onerror=null,"svg"===n.imageType)return void n._loadSvgSource();this.isLoading=!1,t.width&&t.height?(this._sourceLoaded(),e&&this.emit("loaded",this)):e&&this.emit("error",this)}}},e.prototype._updateImageType=function(){if(this.imageUrl){var t=(0,a.decomposeDataUri)(this.imageUrl),e=void 0;if(t&&"image"===t.mediaType){var r=t.subType.split("+")[0];if(!(e=(0,a.getUrlFileExtension)("."+r)))throw new Error("Invalid image type in data URI.")}else(e=(0,a.getUrlFileExtension)(this.imageUrl))||(e="png");this.imageType=e}},e.prototype._loadSvgSource=function(){if("svg"===this.imageType){var t=(0,a.decomposeDataUri)(this.imageUrl);t?this._loadSvgSourceUsingDataUri(t):this._loadSvgSourceUsingXhr()}},e.prototype._loadSvgSourceUsingDataUri=function(t){var e=void 0;if("base64"===t.encoding){if(!atob)throw new Error("Your browser doesn't support base64 conversions.");e=atob(t.data)}else e=t.data;this._loadSvgSourceUsingString(e)},e.prototype._loadSvgSourceUsingXhr=function(){var t=this,e=new XMLHttpRequest;e.onload=function(){if(e.readyState!==e.DONE||200!==e.status)throw new Error("Failed to load SVG using XHR.");t._loadSvgSourceUsingString(e.response)},e.onerror=function(){return t.emit("error",t)},e.open("GET",this.imageUrl,!0),e.send()},e.prototype._loadSvgSourceUsingString=function(t){var r=(0,a.getSvgSize)(t),n=r.width,i=r.height;if(!n||!i)throw new Error("The SVG image must have width and height defined (in pixels), canvas API needs them.");this.realWidth=Math.round(n*this.sourceScale),this.realHeight=Math.round(i*this.sourceScale),this._updateDimensions();var o=document.createElement("canvas");o.width=this.realWidth,o.height=this.realHeight,o._pixiId="canvas_"+(0,a.uid)(),o.getContext("2d").drawImage(this.source,0,0,n,i,0,0,this.realWidth,this.realHeight),this.origSource=this.source,this.source=o,e.addToCache(this,o._pixiId),this.isLoading=!1,this._sourceLoaded(),this.emit("loaded",this)},e.prototype._sourceLoaded=function(){this.hasLoaded=!0,this.update()},e.prototype.destroy=function(){this.imageUrl&&(delete a.TextureCache[this.imageUrl],this.imageUrl=null,navigator.isCocoonJS||(this.source.src="")),this.source=null,this.dispose(),e.removeFromCache(this),this.textureCacheIds=null,this._destroyed=!0},e.prototype.dispose=function(){this.emit("dispose",this)},e.prototype.updateSourceImage=function(t){this.source.src=t,this.loadSource(this.source)},e.fromImage=function(t,r,n,i){var o=a.BaseTextureCache[t];if(!o){var s=new Image;void 0===r&&0!==t.indexOf("data:")?s.crossOrigin=(0,f.default)(t):r&&(s.crossOrigin="string"==typeof r?r:"anonymous"),o=new e(s,n),o.imageUrl=t,i&&(o.sourceScale=i),o.resolution=(0,
a.getResolutionOfUrl)(t),s.src=t,e.addToCache(o,t)}return o},e.fromCanvas=function(t,r){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"canvas";t._pixiId||(t._pixiId=n+"_"+(0,a.uid)());var i=a.BaseTextureCache[t._pixiId];return i||(i=new e(t,r),e.addToCache(i,t._pixiId)),i},e.from=function(t,r,n){if("string"==typeof t)return e.fromImage(t,void 0,r,n);if(t instanceof HTMLImageElement){var i=t.src,o=a.BaseTextureCache[i];return o||(o=new e(t,r),o.imageUrl=i,n&&(o.sourceScale=n),o.resolution=(0,a.getResolutionOfUrl)(i),e.addToCache(o,i)),o}return t instanceof HTMLCanvasElement?e.fromCanvas(t,r):t},e.addToCache=function(t,e){e&&(-1===t.textureCacheIds.indexOf(e)&&t.textureCacheIds.push(e),a.BaseTextureCache[e]=t)},e.removeFromCache=function(t){if("string"==typeof t){var e=a.BaseTextureCache[t];if(e){var r=e.textureCacheIds.indexOf(t);return r>-1&&e.textureCacheIds.splice(r,1),delete a.BaseTextureCache[t],e}}else if(t&&t.textureCacheIds){for(var n=0;n<t.textureCacheIds.length;++n)delete a.BaseTextureCache[t.textureCacheIds[n]];return t.textureCacheIds.length=0,t}return null},e}(c.default);r.default=g},{"../settings":101,"../utils":125,"../utils/determineCrossOrigin":124,"bit-twiddle":1,eventemitter3:3}],113:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("./BaseRenderTexture"),u=n(a),h=t("./Texture"),l=n(h),c=function(t){function e(r,n){i(this,e);var s=null;if(!(r instanceof u.default)){var a=arguments[1],h=arguments[2],l=arguments[3],c=arguments[4];console.warn("Please use RenderTexture.create("+a+", "+h+") instead of the ctor directly."),s=arguments[0],n=null,r=new u.default(a,h,l,c)}var d=o(this,t.call(this,r,n));return d.legacyRenderer=s,d.valid=!0,d._updateUvs(),d}return s(e,t),e.prototype.resize=function(t,e,r){t=Math.ceil(t),e=Math.ceil(e),this.valid=t>0&&e>0,this._frame.width=this.orig.width=t,this._frame.height=this.orig.height=e,r||this.baseTexture.resize(t,e),this._updateUvs()},e.create=function(t,r,n,i){return new e(new u.default(t,r,n,i))},e}(l.default);r.default=c},{"./BaseRenderTexture":111,"./Texture":115}],114:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),o=t("../"),s=t("../utils"),a=function(){function t(e,r){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;n(this,t),this.baseTexture=e,this.textures={},this.animations={},this.data=r,this.resolution=this._updateResolution(i||this.baseTexture.imageUrl),this._frames=this.data.frames,this._frameKeys=Object.keys(this._frames),this._batchIndex=0,this._callback=null}return i(t,null,[{key:"BATCH_SIZE",get:function(){return 1e3}}]),t.prototype._updateResolution=function(t){var e=this.data.meta.scale,r=(0,s.getResolutionOfUrl)(t,null);return null===r&&(r=void 0!==e?parseFloat(e):1),1!==r&&(this.baseTexture.resolution=r,this.baseTexture.update()),r},t.prototype.parse=function(e){this._batchIndex=0,this._callback=e,this._frameKeys.length<=t.BATCH_SIZE?(this._processFrames(0),this._processAnimations(),this._parseComplete()):this._nextBatch()},t.prototype._processFrames=function(e){for(var r=e,n=t.BATCH_SIZE,i=this.baseTexture.sourceScale;r-e<n&&r<this._frameKeys.length;){var s=this._frameKeys[r],a=this._frames[s],u=a.frame;if(u){var h=null,l=null,c=!1!==a.trimmed&&a.sourceSize?a.sourceSize:a.frame,d=new o.Rectangle(0,0,Math.floor(c.w*i)/this.resolution,Math.floor(c.h*i)/this.resolution);h=a.rotated?new o.Rectangle(Math.floor(u.x*i)/this.resolution,Math.floor(u.y*i)/this.resolution,Math.floor(u.h*i)/this.resolution,Math.floor(u.w*i)/this.resolution):new o.Rectangle(Math.floor(u.x*i)/this.resolution,Math.floor(u.y*i)/this.resolution,Math.floor(u.w*i)/this.resolution,Math.floor(u.h*i)/this.resolution),!1!==a.trimmed&&a.spriteSourceSize&&(l=new o.Rectangle(Math.floor(a.spriteSourceSize.x*i)/this.resolution,Math.floor(a.spriteSourceSize.y*i)/this.resolution,Math.floor(u.w*i)/this.resolution,Math.floor(u.h*i)/this.resolution)),this.textures[s]=new o.Texture(this.baseTexture,h,d,l,a.rotated?2:0,a.anchor),o.Texture.addToCache(this.textures[s],s)}r++}},t.prototype._processAnimations=function(){var t=this.data.animations||{};for(var e in t){this.animations[e]=[];for(var r=t[e],n=Array.isArray(r),i=0,r=n?r:r[Symbol.iterator]();;){var o;if(n){if(i>=r.length)break;o=r[i++]}else{if(i=r.next(),i.done)break;o=i.value}var s=o;this.animations[e].push(this.textures[s])}}},t.prototype._parseComplete=function(){var t=this._callback;this._callback=null,this._batchIndex=0,t.call(this,this.textures)},t.prototype._nextBatch=function(){var e=this;this._processFrames(this._batchIndex*t.BATCH_SIZE),this._batchIndex++,setTimeout(function(){e._batchIndex*t.BATCH_SIZE<e._frameKeys.length?e._nextBatch():(e._processAnimations(),e._parseComplete())},0)},t.prototype.destroy=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];for(var e in this.textures)this.textures[e].destroy();this._frames=null,this._frameKeys=null,this.data=null,this.textures=null,t&&this.baseTexture.destroy(),this.baseTexture=null},t}();r.default=a},{"../":65,"../utils":125}],115:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){t.destroy=function(){},t.on=function(){},t.once=function(){},t.emit=function(){}}r.__esModule=!0;var u=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),h=t("./BaseTexture"),l=n(h),c=t("./VideoBaseTexture"),d=n(c),f=t("./TextureUvs"),p=n(f),v=t("eventemitter3"),g=n(v),y=t("../math"),m=t("../utils"),_=t("../settings"),b=n(_),x=function(t){function e(r,n,s,a,u,h){i(this,e);var l=o(this,t.call(this));if(l.noFrame=!1,n||(l.noFrame=!0,n=new y.Rectangle(0,0,1,1)),r instanceof e&&(r=r.baseTexture),l.baseTexture=r,l._frame=n,l.trim=a,l.valid=!1,l.requiresUpdate=!1,l._uvs=null,l.orig=s||n,l._rotate=Number(u||0),!0===u)l._rotate=2;else if(l._rotate%2!=0)throw new Error("attempt to use diamond-shaped UVs. If you are sure, set rotation manually");return r.hasLoaded?(l.noFrame&&(n=new y.Rectangle(0,0,r.width,r.height),r.on("update",l.onBaseTextureUpdated,l)),l.frame=n):r.once("loaded",l.onBaseTextureLoaded,l),l.defaultAnchor=h?new y.Point(h.x,h.y):new y.Point(0,0),l._updateID=0,l.transform=null,l.textureCacheIds=[],l}return s(e,t),e.prototype.update=function(){this.baseTexture.update()},e.prototype.onBaseTextureLoaded=function(t){this._updateID++,this.noFrame?this.frame=new y.Rectangle(0,0,t.width,t.height):this.frame=this._frame,this.baseTexture.on("update",this.onBaseTextureUpdated,this),this.emit("update",this)},e.prototype.onBaseTextureUpdated=function(t){this._updateID++,this._frame.width=t.width,this._frame.height=t.height,this.emit("update",this)},e.prototype.destroy=function(t){this.baseTexture&&(t&&(m.TextureCache[this.baseTexture.imageUrl]&&e.removeFromCache(this.baseTexture.imageUrl),this.baseTexture.destroy()),this.baseTexture.off("update",this.onBaseTextureUpdated,this),this.baseTexture.off("loaded",this.onBaseTextureLoaded,this),this.baseTexture=null),this._frame=null,this._uvs=null,this.trim=null,this.orig=null,this.valid=!1,e.removeFromCache(this),this.textureCacheIds=null},e.prototype.clone=function(){return new e(this.baseTexture,this.frame,this.orig,this.trim,this.rotate,this.defaultAnchor)},e.prototype._updateUvs=function(){this._uvs||(this._uvs=new p.default),this._uvs.set(this._frame,this.baseTexture,this.rotate),this._updateID++},e.fromImage=function(t,r,n,i){var o=m.TextureCache[t];return o||(o=new e(l.default.fromImage(t,r,n,i)),e.addToCache(o,t)),o},e.fromFrame=function(t){var e=m.TextureCache[t];if(!e)throw new Error('The frameId "'+t+'" does not exist in the texture cache');return e},e.fromCanvas=function(t,r){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"canvas";return new e(l.default.fromCanvas(t,r,n))},e.fromVideo=function(t,r,n,i){return"string"==typeof t?e.fromVideoUrl(t,r,n,i):new e(d.default.fromVideo(t,r,i))},e.fromVideoUrl=function(t,r,n,i){return new e(d.default.fromUrl(t,r,n,i))},e.from=function(t){if("string"==typeof t){var r=m.TextureCache[t];if(!r){return null!==t.match(/\.(mp4|webm|ogg|h264|avi|mov)$/)?e.fromVideoUrl(t):e.fromImage(t)}return r}return t instanceof HTMLImageElement?new e(l.default.from(t)):t instanceof HTMLCanvasElement?e.fromCanvas(t,b.default.SCALE_MODE,"HTMLCanvasElement"):t instanceof HTMLVideoElement?e.fromVideo(t):t instanceof l.default?new e(t):t},e.fromLoader=function(t,r,n){var i=new l.default(t,void 0,(0,m.getResolutionOfUrl)(r)),o=new e(i);return i.imageUrl=r,n||(n=r),l.default.addToCache(o.baseTexture,n),e.addToCache(o,n),n!==r&&(l.default.addToCache(o.baseTexture,r),e.addToCache(o,r)),o},e.addToCache=function(t,e){e&&(-1===t.textureCacheIds.indexOf(e)&&t.textureCacheIds.push(e),m.TextureCache[e]=t)},e.removeFromCache=function(t){if("string"==typeof t){var e=m.TextureCache[t];if(e){var r=e.textureCacheIds.indexOf(t);return r>-1&&e.textureCacheIds.splice(r,1),delete m.TextureCache[t],e}}else if(t&&t.textureCacheIds){for(var n=0;n<t.textureCacheIds.length;++n)m.TextureCache[t.textureCacheIds[n]]===t&&delete m.TextureCache[t.textureCacheIds[n]];return t.textureCacheIds.length=0,t}return null},u(e,[{key:"frame",get:function(){return this._frame},set:function(t){this._frame=t,this.noFrame=!1;var e=t.x,r=t.y,n=t.width,i=t.height,o=e+n>this.baseTexture.width,s=r+i>this.baseTexture.height;if(o||s){var a=o&&s?"and":"or",u="X: "+e+" + "+n+" = "+(e+n)+" > "+this.baseTexture.width,h="Y: "+r+" + "+i+" = "+(r+i)+" > "+this.baseTexture.height;throw new Error("Texture Error: frame does not fit inside the base Texture dimensions: "+u+" "+a+" "+h)}this.valid=n&&i&&this.baseTexture.hasLoaded,this.trim||this.rotate||(this.orig=t),this.valid&&this._updateUvs()}},{key:"rotate",get:function(){return this._rotate},set:function(t){this._rotate=t,this.valid&&this._updateUvs()}},{key:"width",get:function(){return this.orig.width}},{key:"height",get:function(){return this.orig.height}}]),e}(g.default);r.default=x,x.EMPTY=new x(new l.default),a(x.EMPTY),a(x.EMPTY.baseTexture),x.WHITE=function(){var t=document.createElement("canvas");t.width=10,t.height=10;var e=t.getContext("2d");return e.fillStyle="white",e.fillRect(0,0,10,10),new x(new l.default(t))}(),a(x.WHITE),a(x.WHITE.baseTexture)},{"../math":70,"../settings":101,"../utils":125,"./BaseTexture":112,"./TextureUvs":117,"./VideoBaseTexture":118,eventemitter3:3}],116:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),o=t("../math/Matrix"),s=function(t){return t&&t.__esModule?t:{default:t}}(o),a=new s.default,u=function(){function t(e,r){n(this,t),this._texture=e,this.mapCoord=new s.default,this.uClampFrame=new Float32Array(4),this.uClampOffset=new Float32Array(2),this._lastTextureID=-1,this.clampOffset=0,this.clampMargin=void 0===r?.5:r}return t.prototype.multiplyUvs=function(t,e){void 0===e&&(e=t);for(var r=this.mapCoord,n=0;n<t.length;n+=2){var i=t[n],o=t[n+1];e[n]=i*r.a+o*r.c+r.tx,e[n+1]=i*r.b+o*r.d+r.ty}return e},t.prototype.update=function(t){var e=this._texture;if(!e||!e.valid)return!1;if(!t&&this._lastTextureID===e._updateID)return!1;this._lastTextureID=e._updateID;var r=e._uvs;this.mapCoord.set(r.x1-r.x0,r.y1-r.y0,r.x3-r.x0,r.y3-r.y0,r.x0,r.y0);var n=e.orig,i=e.trim;i&&(a.set(n.width/i.width,0,0,n.height/i.height,-i.x/i.width,-i.y/i.height),this.mapCoord.append(a));var o=e.baseTexture,s=this.uClampFrame,u=this.clampMargin/o.resolution,h=this.clampOffset;return s[0]=(e._frame.x+u+h)/o.width,s[1]=(e._frame.y+u+h)/o.height,s[2]=(e._frame.x+e._frame.width-u+h)/o.width,s[3]=(e._frame.y+e._frame.height-u+h)/o.height,this.uClampOffset[0]=h/o.realWidth,this.uClampOffset[1]=h/o.realHeight,!0},i(t,[{key:"texture",get:function(){return this._texture},set:function(t){this._texture=t,this._lastTextureID=-1}}]),t}();r.default=u},{"../math/Matrix":67}],117:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../math/GroupD8"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=function(){function t(){n(this,t),this.x0=0,this.y0=0,this.x1=1,this.y1=0,this.x2=1,this.y2=1,this.x3=0,this.y3=1,this.uvsUint32=new Uint32Array(4)}return t.prototype.set=function(t,e,r){var n=e.width,i=e.height;if(r){var s=t.width/2/n,a=t.height/2/i,u=t.x/n+s,h=t.y/i+a;r=o.default.add(r,o.default.NW),this.x0=u+s*o.default.uX(r),this.y0=h+a*o.default.uY(r),r=o.default.add(r,2),this.x1=u+s*o.default.uX(r),this.y1=h+a*o.default.uY(r),r=o.default.add(r,2),this.x2=u+s*o.default.uX(r),this.y2=h+a*o.default.uY(r),r=o.default.add(r,2),this.x3=u+s*o.default.uX(r),this.y3=h+a*o.default.uY(r)}else this.x0=t.x/n,this.y0=t.y/i,this.x1=(t.x+t.width)/n,this.y1=t.y/i,this.x2=(t.x+t.width)/n,this.y2=(t.y+t.height)/i,this.x3=t.x/n,this.y3=(t.y+t.height)/i;this.uvsUint32[0]=(65535&Math.round(65535*this.y0))<<16|65535&Math.round(65535*this.x0),this.uvsUint32[1]=(65535&Math.round(65535*this.y1))<<16|65535&Math.round(65535*this.x1),this.uvsUint32[2]=(65535&Math.round(65535*this.y2))<<16|65535&Math.round(65535*this.x2),this.uvsUint32[3]=(65535&Math.round(65535*this.y3))<<16|65535&Math.round(65535*this.x3)},t}();r.default=s},{"../math/GroupD8":66}],118:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t,e){if(!e){var r=t.split("?").shift().toLowerCase();e="video/"+r.substr(r.lastIndexOf(".")+1)}var n=document.createElement("source");return n.src=t,n.type=e,n}r.__esModule=!0;var u=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),h=t("./BaseTexture"),l=n(h),c=t("../utils"),d=t("../ticker"),f=t("../const"),p=t("../utils/determineCrossOrigin"),v=n(p),g=function(t){function e(r,n){var s=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];if(i(this,e),!r)throw new Error("No video source element specified.");(r.readyState===r.HAVE_ENOUGH_DATA||r.readyState===r.HAVE_FUTURE_DATA)&&r.width&&r.height&&(r.complete=!0);var a=o(this,t.call(this,r,n));return a.width=r.videoWidth,a.height=r.videoHeight,a._autoUpdate=!0,a._isAutoUpdating=!1,a.autoPlay=s,a.update=a.update.bind(a),a._onCanPlay=a._onCanPlay.bind(a),r.addEventListener("play",a._onPlayStart.bind(a)),r.addEventListener("pause",a._onPlayStop.bind(a)),a.hasLoaded=!1,a.__loaded=!1,a._isSourceReady()?a._onCanPlay():(r.addEventListener("canplay",a._onCanPlay),r.addEventListener("canplaythrough",a._onCanPlay)),a}return s(e,t),e.prototype._isSourcePlaying=function(){var t=this.source;return t.currentTime>0&&!1===t.paused&&!1===t.ended&&t.readyState>2},e.prototype._isSourceReady=function(){return 3===this.source.readyState||4===this.source.readyState},e.prototype._onPlayStart=function(){this.hasLoaded||this._onCanPlay(),!this._isAutoUpdating&&this.autoUpdate&&(d.shared.add(this.update,this,f.UPDATE_PRIORITY.HIGH),this._isAutoUpdating=!0)},e.prototype._onPlayStop=function(){this._isAutoUpdating&&(d.shared.remove(this.update,this),this._isAutoUpdating=!1)},e.prototype._onCanPlay=function(){this.hasLoaded=!0,this.source&&(this.source.removeEventListener("canplay",this._onCanPlay),this.source.removeEventListener("canplaythrough",this._onCanPlay),this.width=this.source.videoWidth,this.height=this.source.videoHeight,this.__loaded||(this.__loaded=!0,this.emit("loaded",this)),this._isSourcePlaying()?this._onPlayStart():this.autoPlay&&this.source.play())},e.prototype.destroy=function(){this._isAutoUpdating&&d.shared.remove(this.update,this),this.source&&this.source._pixiId&&(l.default.removeFromCache(this.source._pixiId),delete this.source._pixiId,this.source.pause(),this.source.src="",this.source.load()),t.prototype.destroy.call(this)},e.fromVideo=function(t,r,n){t._pixiId||(t._pixiId="video_"+(0,c.uid)());var i=c.BaseTextureCache[t._pixiId];return i||(i=new e(t,r,n),l.default.addToCache(i,t._pixiId)),i},e.fromUrl=function(t,r,n,i){var o=document.createElement("video");o.setAttribute("webkit-playsinline",""),o.setAttribute("playsinline","");var s=Array.isArray(t)?t[0].src||t[0]:t.src||t;if(void 0===n&&0!==s.indexOf("data:")?o.crossOrigin=(0,v.default)(s):n&&(o.crossOrigin="string"==typeof n?n:"anonymous"),Array.isArray(t))for(var u=0;u<t.length;++u)o.appendChild(a(t[u].src||t[u],t[u].mime));else o.appendChild(a(s,t.mime));return o.load(),e.fromVideo(o,r,i)},u(e,[{key:"autoUpdate",get:function(){return this._autoUpdate},set:function(t){t!==this._autoUpdate&&(this._autoUpdate=t,!this._autoUpdate&&this._isAutoUpdating?(d.shared.remove(this.update,this),this._isAutoUpdating=!1):this._autoUpdate&&!this._isAutoUpdating&&(d.shared.add(this.update,this,f.UPDATE_PRIORITY.HIGH),this._isAutoUpdating=!0))}}]),e}(l.default);r.default=g,g.fromUrls=g.fromUrl},{"../const":46,"../ticker":121,"../utils":125,"../utils/determineCrossOrigin":124,"./BaseTexture":112}],119:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var o=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),s=t("../settings"),a=n(s),u=t("../const"),h=t("./TickerListener"),l=n(h),c=function(){function t(){var e=this;i(this,t),this._head=new l.default(null,null,1/0),this._requestId=null,this._maxElapsedMS=100,this.autoStart=!1,this.deltaTime=1,this.elapsedMS=1/a.default.TARGET_FPMS,this.lastTime=-1,this.speed=1,this.started=!1,this._tick=function(t){e._requestId=null,e.started&&(e.update(t),e.started&&null===e._requestId&&e._head.next&&(e._requestId=requestAnimationFrame(e._tick)))}}return t.prototype._requestIfNeeded=function(){null===this._requestId&&this._head.next&&(this.lastTime=performance.now(),this._requestId=requestAnimationFrame(this._tick))},t.prototype._cancelIfNeeded=function(){null!==this._requestId&&(cancelAnimationFrame(this._requestId),this._requestId=null)},t.prototype._startIfPossible=function(){this.started?this._requestIfNeeded():this.autoStart&&this.start()},t.prototype.add=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:u.UPDATE_PRIORITY.NORMAL;return this._addListener(new l.default(t,e,r))},t.prototype.addOnce=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:u.UPDATE_PRIORITY.NORMAL;return this._addListener(new l.default(t,e,r,!0))},t.prototype._addListener=function(t){var e=this._head.next,r=this._head;if(e){for(;e;){if(t.priority>e.priority){t.connect(r);break}r=e,e=e.next}t.previous||t.connect(r)}else t.connect(r);return this._startIfPossible(),this},t.prototype.remove=function(t,e){for(var r=this._head.next;r;)r=r.match(t,e)?r.destroy():r.next;return this._head.next||this._cancelIfNeeded(),this},t.prototype.start=function(){this.started||(this.started=!0,this._requestIfNeeded())},t.prototype.stop=function(){this.started&&(this.started=!1,this._cancelIfNeeded())},t.prototype.destroy=function(){this.stop();for(var t=this._head.next;t;)t=t.destroy(!0);this._head.destroy(),this._head=null},t.prototype.update=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:performance.now(),e=void 0;if(t>this.lastTime){e=this.elapsedMS=t-this.lastTime,e>this._maxElapsedMS&&(e=this._maxElapsedMS),this.deltaTime=e*a.default.TARGET_FPMS*this.speed;for(var r=this._head,n=r.next;n;)n=n.emit(this.deltaTime);r.next||this._cancelIfNeeded()}else this.deltaTime=this.elapsedMS=0;this.lastTime=t},o(t,[{key:"FPS",get:function(){return 1e3/this.elapsedMS}},{key:"minFPS",get:function(){return 1e3/this._maxElapsedMS},set:function(t){var e=Math.min(Math.max(0,t)/1e3,a.default.TARGET_FPMS);this._maxElapsedMS=1/e}}]),t}();r.default=c},{"../const":46,"../settings":101,"./TickerListener":120}],120:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,o=arguments.length>3&&void 0!==arguments[3]&&arguments[3];n(this,t),this.fn=e,this.context=r,this.priority=i,this.once=o,this.next=null,this.previous=null,this._destroyed=!1}return t.prototype.match=function(t,e){return e=e||null,this.fn===t&&this.context===e},t.prototype.emit=function(t){this.fn&&(this.context?this.fn.call(this.context,t):this.fn(t));var e=this.next;return this.once&&this.destroy(!0),this._destroyed&&(this.next=null),e},t.prototype.connect=function(t){this.previous=t,t.next&&(t.next.previous=this),this.next=t.next,t.next=this},t.prototype.destroy=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this._destroyed=!0,this.fn=null,this.context=null,this.previous&&(this.previous.next=this.next),this.next&&(this.next.previous=this.previous);var e=this.next;return this.next=t?null:e,this.previous=null,e},t}();r.default=i},{}],121:[function(t,e,r){"use strict";r.__esModule=!0,r.Ticker=r.shared=void 0;var n=t("./Ticker"),i=function(t){return t&&t.__esModule?t:{default:t}}(n),o=new i.default;o.autoStart=!0,o.destroy=function(){},r.shared=o,r.Ticker=i.default},{"./Ticker":119}],122:[function(t,e,r){"use strict";function n(){return!(!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform))}r.__esModule=!0,r.default=n},{}],123:[function(t,e,r){"use strict";function n(t){for(var e=6*t,r=new Uint16Array(e),n=0,i=0;n<e;n+=6,i+=4)r[n+0]=i+0,r[n+1]=i+1,r[n+2]=i+2,r[n+3]=i+0,r[n+4]=i+2,r[n+5]=i+3;return r}r.__esModule=!0,r.default=n},{}],124:[function(t,e,r){"use strict";function n(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:window.location;if(0===t.indexOf("data:"))return"";e=e||window.location,s||(s=document.createElement("a")),s.href=t,t=o.default.parse(s.href);var r=!t.port&&""===e.port||t.port===e.port;return t.hostname===e.hostname&&r&&t.protocol===e.protocol?"":"anonymous"}r.__esModule=!0,r.default=n;var i=t("url"),o=function(t){return t&&t.__esModule?t:{default:t}}(i),s=void 0},{url:38}],125:[function(t,e,r){"use strict";function n(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}function i(t){return t&&t.__esModule?t:{default:t}}function o(){return++U}function s(t,e){return e=e||[],e[0]=(t>>16&255)/255,e[1]=(t>>8&255)/255,e[2]=(255&t)/255,e}function a(t){return t=t.toString(16),"#"+(t="000000".substr(0,6-t.length)+t)}function u(t){return(255*t[0]<<16)+(255*t[1]<<8)+(255*t[2]|0)}function h(t,e){var r=S.default.RETINA_PREFIX.exec(t);return r?parseFloat(r[1]):void 0!==e?e:1}function l(t){var e=w.DATA_URI.exec(t);if(e)return{mediaType:e[1]?e[1].toLowerCase():void 0,subType:e[2]?e[2].toLowerCase():void 0,charset:e[3]?e[3].toLowerCase():void 0,encoding:e[4]?e[4].toLowerCase():void 0,data:e[5]}}function c(t){var e=w.URL_FILE_EXTENSION.exec(t);if(e)return e[1].toLowerCase()}function d(t){var e=w.SVG_SIZE.exec(t),r={};return e&&(r[e[1]]=Math.round(parseFloat(e[3])),r[e[5]]=Math.round(parseFloat(e[7]))),r}function f(){X=!0}function p(t){if(!X){if(navigator.userAgent.toLowerCase().indexOf("chrome")>-1){var e=["\n %c %c %c PixiJS "+w.VERSION+" - ✰ "+t+" ✰  %c  %c  http://www.pixijs.com/  %c %c ♥%c♥%c♥ \n\n","background: #ff66a5; padding:5px 0;","background: #ff66a5; padding:5px 0;","color: #ff66a5; background: #030307; padding:5px 0;","background: #ff66a5; padding:5px 0;","background: #ffc3dc; padding:5px 0;","background: #ff66a5; padding:5px 0;","color: #ff2424; background: #fff; padding:5px 0;","color: #ff2424; background: #fff; padding:5px 0;","color: #ff2424; background: #fff; padding:5px 0;"];window.console.log.apply(console,e)}else window.console&&window.console.log("PixiJS "+w.VERSION+" - "+t+" - http://www.pixijs.com/");X=!0}}function v(){var t={stencil:!0,failIfMajorPerformanceCaveat:!0};try{if(!window.WebGLRenderingContext)return!1;var e=document.createElement("canvas"),r=e.getContext("webgl",t)||e.getContext("experimental-webgl",t),n=!(!r||!r.getContextAttributes().stencil);if(r){var i=r.getExtension("WEBGL_lose_context");i&&i.loseContext()}return r=null,n}catch(t){return!1}}function g(t){return 0===t?0:t<0?-1:1}function y(){var t=void 0;for(t in G)G[t].destroy();for(t in W)W[t].destroy()}function m(){var t=void 0;for(t in G)delete G[t];for(t in W)delete W[t]}function _(t,e){return H[e?1:0][t]}function b(t,e){if(1===e)return(255*e<<24)+t;if(0===e)return 0;var r=t>>16&255,n=t>>8&255,i=255&t;return r=r*e+.5|0,n=n*e+.5|0,i=i*e+.5|0,(255*e<<24)+(r<<16)+(n<<8)+i}function x(t,e,r,n){return r=r||new Float32Array(4),n||void 0===n?(r[0]=t[0]*e,r[1]=t[1]*e,r[2]=t[2]*e):(r[0]=t[0],r[1]=t[1],r[2]=t[2]),r[3]=e,r}function T(t,e,r,n){return r=r||new Float32Array(4),r[0]=(t>>16&255)/255,r[1]=(t>>8&255)/255,r[2]=(255&t)/255,(n||void 0===n)&&(r[0]*=e,r[1]*=e,r[2]*=e),r[3]=e,r}r.__esModule=!0,r.premultiplyBlendMode=r.BaseTextureCache=r.TextureCache=r.earcut=r.mixins=r.pluginTarget=r.EventEmitter=r.removeItems=r.isMobile=void 0,r.uid=o,r.hex2rgb=s,r.hex2string=a,r.rgb2hex=u,r.getResolutionOfUrl=h,r.decomposeDataUri=l,r.getUrlFileExtension=c,r.getSvgSize=d,r.skipHello=f,r.sayHello=p,r.isWebGLSupported=v,r.sign=g,r.destroyTextureCache=y,r.clearTextureCache=m,r.correctBlendMode=_,r.premultiplyTint=b,r.premultiplyRgba=x,r.premultiplyTintToRgba=T;var w=t("../const"),E=t("../settings"),S=i(E),O=t("eventemitter3"),M=i(O),P=t("./pluginTarget"),C=i(P),R=t("./mixin"),A=n(R),I=t("ismobilejs"),D=n(I),L=t("remove-array-items"),N=i(L),B=t("./mapPremultipliedBlendModes"),k=i(B),F=t("earcut"),j=i(F),U=0,X=!1;r.isMobile=D,r.removeItems=N.default,r.EventEmitter=M.default,r.pluginTarget=C.default,r.mixins=A,r.earcut=j.default;var G=r.TextureCache=Object.create(null),W=r.BaseTextureCache=Object.create(null),H=r.premultiplyBlendMode=(0,k.default)()},{"../const":46,"../settings":101,"./mapPremultipliedBlendModes":126,"./mixin":128,"./pluginTarget":129,earcut:2,eventemitter3:3,ismobilejs:4,"remove-array-items":31}],126:[function(t,e,r){"use strict";function n(){for(var t=[],e=[],r=0;r<32;r++)t[r]=r,e[r]=r;t[i.BLEND_MODES.NORMAL_NPM]=i.BLEND_MODES.NORMAL,t[i.BLEND_MODES.ADD_NPM]=i.BLEND_MODES.ADD,t[i.BLEND_MODES.SCREEN_NPM]=i.BLEND_MODES.SCREEN,e[i.BLEND_MODES.NORMAL]=i.BLEND_MODES.NORMAL_NPM,e[i.BLEND_MODES.ADD]=i.BLEND_MODES.ADD_NPM,e[i.BLEND_MODES.SCREEN]=i.BLEND_MODES.SCREEN_NPM;var n=[];return n.push(e),n.push(t),n}r.__esModule=!0,r.default=n;var i=t("../const")},{"../const":46}],127:[function(t,e,r){"use strict";function n(t){return o.default.tablet||o.default.phone?4:t}r.__esModule=!0,r.default=n;var i=t("ismobilejs"),o=function(t){return t&&t.__esModule?t:{default:t}}(i)},{ismobilejs:4}],128:[function(t,e,r){"use strict";function n(t,e){if(t&&e)for(var r=Object.keys(e),n=0;n<r.length;++n){var i=r[n];Object.defineProperty(t,i,Object.getOwnPropertyDescriptor(e,i))}}function i(t,e){s.push(t,e)}function o(){for(var t=0;t<s.length;t+=2)n(s[t],s[t+1]);s.length=0}r.__esModule=!0,r.mixin=n,r.delayMixin=i,r.performMixins=o;var s=[]},{}],129:[function(t,e,r){"use strict";function n(t){t.__plugins={},t.registerPlugin=function(e,r){t.__plugins[e]=r},t.prototype.initPlugins=function(){this.plugins=this.plugins||{};for(var e in t.__plugins)this.plugins[e]=new t.__plugins[e](this)},t.prototype.destroyPlugins=function(){for(var t in this.plugins)this.plugins[t].destroy(),this.plugins[t]=null;this.plugins=null}}r.__esModule=!0,r.default={mixin:function(t){n(t)}}},{}],130:[function(t,e,r){"use strict";function n(t){var e=t.width,r=t.height,n=t.getContext("2d"),i=n.getImageData(0,0,e,r),o=i.data,s=o.length,a={top:null,left:null,right:null,bottom:null},u=null,h=void 0,l=void 0,c=void 0;for(h=0;h<s;h+=4)0!==o[h+3]&&(l=h/4%e,c=~~(h/4/e),null===a.top&&(a.top=c),null===a.left?a.left=l:l<a.left&&(a.left=l),null===a.right?a.right=l+1:a.right<l&&(a.right=l+1),null===a.bottom?a.bottom=c:a.bottom<c&&(a.bottom=c));return null!==a.top&&(e=a.right-a.left,r=a.bottom-a.top+1,u=n.getImageData(a.left,a.top,e,r)),{height:r,width:e,data:u}}r.__esModule=!0,r.default=n},{}],131:[function(t,e,r){"use strict";function n(t){if(!o[t]){var e=(new Error).stack;void 0===e?console.warn("Deprecation Warning: ",t):(e=e.split("\n").splice(3).join("\n"),console.groupCollapsed?(console.groupCollapsed("%cDeprecation Warning: %c%s","color:#614108;background:#fffbe6","font-weight:normal;color:#614108;background:#fffbe6",t),console.warn(e),console.groupEnd()):(console.warn("Deprecation Warning: ",t),console.warn(e))),o[t]=!0}}function i(t){var e=t.mesh,r=t.particles,i=t.extras,o=t.filters,s=t.prepare,a=t.loaders,u=t.interaction;Object.defineProperties(t,{SpriteBatch:{get:function(){throw new ReferenceError("SpriteBatch does not exist any more, please use the new ParticleContainer instead.")}},AssetLoader:{get:function(){throw new ReferenceError("The loader system was overhauled in PixiJS v3, please see the new PIXI.loaders.Loader class.")}},Stage:{get:function(){return n("You do not need to use a PIXI Stage any more, you can simply render any container."),t.Container}},DisplayObjectContainer:{get:function(){return n("DisplayObjectContainer has been shortened to Container, please use Container from now on."),t.Container}},Strip:{get:function(){
return n("The Strip class has been renamed to Mesh and moved to mesh.Mesh, please use mesh.Mesh from now on."),e.Mesh}},Rope:{get:function(){return n("The Rope class has been moved to mesh.Rope, please use mesh.Rope from now on."),e.Rope}},ParticleContainer:{get:function(){return n("The ParticleContainer class has been moved to particles.ParticleContainer, please use particles.ParticleContainer from now on."),r.ParticleContainer}},MovieClip:{get:function(){return n("The MovieClip class has been moved to extras.AnimatedSprite, please use extras.AnimatedSprite."),i.AnimatedSprite}},TilingSprite:{get:function(){return n("The TilingSprite class has been moved to extras.TilingSprite, please use extras.TilingSprite from now on."),i.TilingSprite}},BitmapText:{get:function(){return n("The BitmapText class has been moved to extras.BitmapText, please use extras.BitmapText from now on."),i.BitmapText}},blendModes:{get:function(){return n("The blendModes has been moved to BLEND_MODES, please use BLEND_MODES from now on."),t.BLEND_MODES}},scaleModes:{get:function(){return n("The scaleModes has been moved to SCALE_MODES, please use SCALE_MODES from now on."),t.SCALE_MODES}},BaseTextureCache:{get:function(){return n("The BaseTextureCache class has been moved to utils.BaseTextureCache, please use utils.BaseTextureCache from now on."),t.utils.BaseTextureCache}},TextureCache:{get:function(){return n("The TextureCache class has been moved to utils.TextureCache, please use utils.TextureCache from now on."),t.utils.TextureCache}},math:{get:function(){return n("The math namespace is deprecated, please access members already accessible on PIXI."),t}},AbstractFilter:{get:function(){return n("AstractFilter has been renamed to Filter, please use PIXI.Filter"),t.Filter}},TransformManual:{get:function(){return n("TransformManual has been renamed to TransformBase, please update your pixi-spine"),t.TransformBase}},TARGET_FPMS:{get:function(){return n("PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS"),t.settings.TARGET_FPMS},set:function(e){n("PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS"),t.settings.TARGET_FPMS=e}},FILTER_RESOLUTION:{get:function(){return n("PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION"),t.settings.FILTER_RESOLUTION},set:function(e){n("PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION"),t.settings.FILTER_RESOLUTION=e}},RESOLUTION:{get:function(){return n("PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION"),t.settings.RESOLUTION},set:function(e){n("PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION"),t.settings.RESOLUTION=e}},MIPMAP_TEXTURES:{get:function(){return n("PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES"),t.settings.MIPMAP_TEXTURES},set:function(e){n("PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES"),t.settings.MIPMAP_TEXTURES=e}},SPRITE_BATCH_SIZE:{get:function(){return n("PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE"),t.settings.SPRITE_BATCH_SIZE},set:function(e){n("PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE"),t.settings.SPRITE_BATCH_SIZE=e}},SPRITE_MAX_TEXTURES:{get:function(){return n("PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES"),t.settings.SPRITE_MAX_TEXTURES},set:function(e){n("PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES"),t.settings.SPRITE_MAX_TEXTURES=e}},RETINA_PREFIX:{get:function(){return n("PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX"),t.settings.RETINA_PREFIX},set:function(e){n("PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX"),t.settings.RETINA_PREFIX=e}},DEFAULT_RENDER_OPTIONS:{get:function(){return n("PIXI.DEFAULT_RENDER_OPTIONS has been deprecated, please use PIXI.settings.DEFAULT_RENDER_OPTIONS"),t.settings.RENDER_OPTIONS}}});for(var h=[{parent:"TRANSFORM_MODE",target:"TRANSFORM_MODE"},{parent:"GC_MODES",target:"GC_MODE"},{parent:"WRAP_MODES",target:"WRAP_MODE"},{parent:"SCALE_MODES",target:"SCALE_MODE"},{parent:"PRECISION",target:"PRECISION_FRAGMENT"}],l=0;l<h.length;l++)!function(e){var r=h[e];Object.defineProperty(t[r.parent],"DEFAULT",{get:function(){return n("PIXI."+r.parent+".DEFAULT has been deprecated, please use PIXI.settings."+r.target),t.settings[r.target]},set:function(e){n("PIXI."+r.parent+".DEFAULT has been deprecated, please use PIXI.settings."+r.target),t.settings[r.target]=e}})}(l);Object.defineProperties(t.settings,{PRECISION:{get:function(){return n("PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT"),t.settings.PRECISION_FRAGMENT},set:function(e){n("PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT"),t.settings.PRECISION_FRAGMENT=e}}}),i.AnimatedSprite&&Object.defineProperties(i,{MovieClip:{get:function(){return n("The MovieClip class has been renamed to AnimatedSprite, please use AnimatedSprite from now on."),i.AnimatedSprite}}}),i&&Object.defineProperties(i,{TextureTransform:{get:function(){return n("The TextureTransform class has been renamed to TextureMatrix, please use PIXI.TextureMatrix from now on."),t.TextureMatrix}}}),t.DisplayObject.prototype.generateTexture=function(t,e,r){return n("generateTexture has moved to the renderer, please use renderer.generateTexture(displayObject)"),t.generateTexture(this,e,r)},t.Graphics.prototype.generateTexture=function(t,e){return n("graphics generate texture has moved to the renderer. Or to render a graphics to a texture using canvas please use generateCanvasTexture"),this.generateCanvasTexture(t,e)},t.GroupD8.isSwapWidthHeight=function(e){return n("GroupD8.isSwapWidthHeight was renamed to GroupD8.isVertical"),t.GroupD8.isVertical(e)},t.RenderTexture.prototype.render=function(t,e,r,i){this.legacyRenderer.render(t,this,r,e,!i),n("RenderTexture.render is now deprecated, please use renderer.render(displayObject, renderTexture)")},t.RenderTexture.prototype.getImage=function(t){return n("RenderTexture.getImage is now deprecated, please use renderer.extract.image(target)"),this.legacyRenderer.extract.image(t)},t.RenderTexture.prototype.getBase64=function(t){return n("RenderTexture.getBase64 is now deprecated, please use renderer.extract.base64(target)"),this.legacyRenderer.extract.base64(t)},t.RenderTexture.prototype.getCanvas=function(t){return n("RenderTexture.getCanvas is now deprecated, please use renderer.extract.canvas(target)"),this.legacyRenderer.extract.canvas(t)},t.RenderTexture.prototype.getPixels=function(t){return n("RenderTexture.getPixels is now deprecated, please use renderer.extract.pixels(target)"),this.legacyRenderer.pixels(t)},t.Sprite.prototype.setTexture=function(t){this.texture=t,n("setTexture is now deprecated, please use the texture property, e.g : sprite.texture = texture;")},i.BitmapText&&(i.BitmapText.prototype.setText=function(t){this.text=t,n("setText is now deprecated, please use the text property, e.g : myBitmapText.text = 'my text';")}),t.Text.prototype.setText=function(t){this.text=t,n("setText is now deprecated, please use the text property, e.g : myText.text = 'my text';")},t.Text.calculateFontProperties=function(e){return n("Text.calculateFontProperties is now deprecated, please use the TextMetrics.measureFont"),t.TextMetrics.measureFont(e)},Object.defineProperties(t.Text,{fontPropertiesCache:{get:function(){return n("Text.fontPropertiesCache is deprecated"),t.TextMetrics._fonts}},fontPropertiesCanvas:{get:function(){return n("Text.fontPropertiesCanvas is deprecated"),t.TextMetrics._canvas}},fontPropertiesContext:{get:function(){return n("Text.fontPropertiesContext is deprecated"),t.TextMetrics._context}}}),t.Text.prototype.setStyle=function(t){this.style=t,n("setStyle is now deprecated, please use the style property, e.g : myText.style = style;")},t.Text.prototype.determineFontProperties=function(e){return n("determineFontProperties is now deprecated, please use TextMetrics.measureFont method"),t.TextMetrics.measureFont(e)},t.Text.getFontStyle=function(e){return n("getFontStyle is now deprecated, please use TextStyle.toFontString() instead"),e=e||{},e instanceof t.TextStyle||(e=new t.TextStyle(e)),e.toFontString()},Object.defineProperties(t.TextStyle.prototype,{font:{get:function(){n("text style property 'font' is now deprecated, please use the 'fontFamily', 'fontSize', 'fontStyle', 'fontVariant' and 'fontWeight' properties from now on");var t="number"==typeof this._fontSize?this._fontSize+"px":this._fontSize;return this._fontStyle+" "+this._fontVariant+" "+this._fontWeight+" "+t+" "+this._fontFamily},set:function(t){n("text style property 'font' is now deprecated, please use the 'fontFamily','fontSize',fontStyle','fontVariant' and 'fontWeight' properties from now on"),t.indexOf("italic")>1?this._fontStyle="italic":t.indexOf("oblique")>-1?this._fontStyle="oblique":this._fontStyle="normal",t.indexOf("small-caps")>-1?this._fontVariant="small-caps":this._fontVariant="normal";var e=t.split(" "),r=-1;this._fontSize=26;for(var i=0;i<e.length;++i)if(e[i].match(/(px|pt|em|%)/)){r=i,this._fontSize=e[i];break}this._fontWeight="normal";for(var o=0;o<r;++o)if(e[o].match(/(bold|bolder|lighter|100|200|300|400|500|600|700|800|900)/)){this._fontWeight=e[o];break}if(r>-1&&r<e.length-1){this._fontFamily="";for(var s=r+1;s<e.length;++s)this._fontFamily+=e[s]+" ";this._fontFamily=this._fontFamily.slice(0,-1)}else this._fontFamily="Arial";this.styleID++}}}),t.Texture.prototype.setFrame=function(t){this.frame=t,n("setFrame is now deprecated, please use the frame property, e.g: myTexture.frame = frame;")},t.Texture.addTextureToCache=function(e,r){t.Texture.addToCache(e,r),n("Texture.addTextureToCache is deprecated, please use Texture.addToCache from now on.")},t.Texture.removeTextureFromCache=function(e){return n("Texture.removeTextureFromCache is deprecated, please use Texture.removeFromCache from now on. Be aware that Texture.removeFromCache does not automatically its BaseTexture from the BaseTextureCache. For that, use BaseTexture.removeFromCache"),t.BaseTexture.removeFromCache(e),t.Texture.removeFromCache(e)},Object.defineProperties(o,{AbstractFilter:{get:function(){return n("AstractFilter has been renamed to Filter, please use PIXI.Filter"),t.AbstractFilter}},SpriteMaskFilter:{get:function(){return n("filters.SpriteMaskFilter is an undocumented alias, please use SpriteMaskFilter from now on."),t.SpriteMaskFilter}},VoidFilter:{get:function(){return n("VoidFilter has been renamed to AlphaFilter, please use PIXI.filters.AlphaFilter"),o.AlphaFilter}}}),t.utils.uuid=function(){return n("utils.uuid() is deprecated, please use utils.uid() from now on."),t.utils.uid()},t.utils.canUseNewCanvasBlendModes=function(){return n("utils.canUseNewCanvasBlendModes() is deprecated, please use CanvasTinter.canUseMultiply from now on"),t.CanvasTinter.canUseMultiply};var c=!0;if(Object.defineProperty(t.utils,"_saidHello",{set:function(t){t&&(n("PIXI.utils._saidHello is deprecated, please use PIXI.utils.skipHello()"),this.skipHello()),c=t},get:function(){return c}}),s.BasePrepare&&(s.BasePrepare.prototype.register=function(t,e){return n("renderer.plugins.prepare.register is now deprecated, please use renderer.plugins.prepare.registerFindHook & renderer.plugins.prepare.registerUploadHook"),t&&this.registerFindHook(t),e&&this.registerUploadHook(e),this}),s.canvas&&Object.defineProperty(s.canvas,"UPLOADS_PER_FRAME",{set:function(){n("PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please set renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer")},get:function(){return n("PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please use renderer.plugins.prepare.limiter"),NaN}}),s.webgl&&Object.defineProperty(s.webgl,"UPLOADS_PER_FRAME",{set:function(){n("PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please set renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer")},get:function(){return n("PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please use renderer.plugins.prepare.limiter"),NaN}}),a.Loader){var d=a.Resource,f=a.Loader;Object.defineProperties(d.prototype,{isJson:{get:function(){return n("The isJson property is deprecated, please use `resource.type === Resource.TYPE.JSON`."),this.type===d.TYPE.JSON}},isXml:{get:function(){return n("The isXml property is deprecated, please use `resource.type === Resource.TYPE.XML`."),this.type===d.TYPE.XML}},isImage:{get:function(){return n("The isImage property is deprecated, please use `resource.type === Resource.TYPE.IMAGE`."),this.type===d.TYPE.IMAGE}},isAudio:{get:function(){return n("The isAudio property is deprecated, please use `resource.type === Resource.TYPE.AUDIO`."),this.type===d.TYPE.AUDIO}},isVideo:{get:function(){return n("The isVideo property is deprecated, please use `resource.type === Resource.TYPE.VIDEO`."),this.type===d.TYPE.VIDEO}}}),Object.defineProperties(f.prototype,{before:{get:function(){return n("The before() method is deprecated, please use pre()."),this.pre}},after:{get:function(){return n("The after() method is deprecated, please use use()."),this.use}}})}u.interactiveTarget&&Object.defineProperty(u.interactiveTarget,"defaultCursor",{set:function(t){n("Property defaultCursor has been replaced with 'cursor'. "),this.cursor=t},get:function(){return n("Property defaultCursor has been replaced with 'cursor'. "),this.cursor}}),u.InteractionManager&&(Object.defineProperty(u.InteractionManager,"defaultCursorStyle",{set:function(t){n("Property defaultCursorStyle has been replaced with 'cursorStyles.default'. "),this.cursorStyles.default=t},get:function(){return n("Property defaultCursorStyle has been replaced with 'cursorStyles.default'. "),this.cursorStyles.default}}),Object.defineProperty(u.InteractionManager,"currentCursorStyle",{set:function(t){n("Property currentCursorStyle has been removed.See the currentCursorMode property, which works differently."),this.currentCursorMode=t},get:function(){return n("Property currentCursorStyle has been removed.See the currentCursorMode property, which works differently."),this.currentCursorMode}}))}r.__esModule=!0,r.default=i;var o={}},{}],132:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../../core"),o=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(i),s=new o.Rectangle,a=function(){function t(e){n(this,t),this.renderer=e,e.extract=this}return t.prototype.image=function(t){var e=new Image;return e.src=this.base64(t),e},t.prototype.base64=function(t){return this.canvas(t).toDataURL()},t.prototype.canvas=function(t){var e=this.renderer,r=void 0,n=void 0,i=void 0,a=void 0;t&&(a=t instanceof o.RenderTexture?t:e.generateTexture(t)),a?(r=a.baseTexture._canvasRenderTarget.context,n=a.baseTexture._canvasRenderTarget.resolution,i=a.frame):(r=e.rootContext,n=e.resolution,i=s,i.width=this.renderer.width,i.height=this.renderer.height);var u=i.width*n,h=i.height*n,l=new o.CanvasRenderTarget(u,h,1),c=r.getImageData(i.x*n,i.y*n,u,h);return l.context.putImageData(c,0,0),l.canvas},t.prototype.pixels=function(t){var e=this.renderer,r=void 0,n=void 0,i=void 0,a=void 0;return t&&(a=t instanceof o.RenderTexture?t:e.generateTexture(t)),a?(r=a.baseTexture._canvasRenderTarget.context,n=a.baseTexture._canvasRenderTarget.resolution,i=a.frame):(r=e.rootContext,i=s,i.width=e.width,i.height=e.height),r.getImageData(0,0,i.width*n,i.height*n).data},t.prototype.destroy=function(){this.renderer.extract=null,this.renderer=null},t}();r.default=a,o.CanvasRenderer.registerPlugin("extract",a)},{"../../core":65}],133:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0;var i=t("./webgl/WebGLExtract");Object.defineProperty(r,"webgl",{enumerable:!0,get:function(){return n(i).default}});var o=t("./canvas/CanvasExtract");Object.defineProperty(r,"canvas",{enumerable:!0,get:function(){return n(o).default}})},{"./canvas/CanvasExtract":132,"./webgl/WebGLExtract":134}],134:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../../core"),o=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(i),s=new o.Rectangle,a=function(){function t(e){n(this,t),this.renderer=e,e.extract=this}return t.prototype.image=function(t){var e=new Image;return e.src=this.base64(t),e},t.prototype.base64=function(t){return this.canvas(t).toDataURL()},t.prototype.canvas=function(t){var e=this.renderer,r=void 0,n=void 0,i=void 0,a=!1,u=void 0,h=!1;t&&(t instanceof o.RenderTexture?u=t:(u=this.renderer.generateTexture(t),h=!0)),u?(r=u.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID],n=r.resolution,i=u.frame,a=!1):(r=this.renderer.rootRenderTarget,n=r.resolution,a=!0,i=s,i.width=r.size.width,i.height=r.size.height);var l=i.width*n,c=i.height*n,d=new o.CanvasRenderTarget(l,c,1);if(r){e.bindRenderTarget(r);var f=new Uint8Array(4*l*c),p=e.gl;p.readPixels(i.x*n,i.y*n,l,c,p.RGBA,p.UNSIGNED_BYTE,f);var v=d.context.getImageData(0,0,l,c);v.data.set(f),d.context.putImageData(v,0,0),a&&(d.context.scale(1,-1),d.context.drawImage(d.canvas,0,-c))}return h&&u.destroy(!0),d.canvas},t.prototype.pixels=function(t){var e=this.renderer,r=void 0,n=void 0,i=void 0,a=void 0,u=!1;t&&(t instanceof o.RenderTexture?a=t:(a=this.renderer.generateTexture(t),u=!0)),a?(r=a.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID],n=r.resolution,i=a.frame):(r=this.renderer.rootRenderTarget,n=r.resolution,i=s,i.width=r.size.width,i.height=r.size.height);var h=i.width*n,l=i.height*n,c=new Uint8Array(4*h*l);if(r){e.bindRenderTarget(r);var d=e.gl;d.readPixels(i.x*n,i.y*n,h,l,d.RGBA,d.UNSIGNED_BYTE,c)}return u&&a.destroy(!0),c},t.prototype.destroy=function(){this.renderer.extract=null,this.renderer=null},t}();r.default=a,o.WebGLRenderer.registerPlugin("extract",a)},{"../../core":65}],135:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=function(t){function e(r,o){n(this,e);var s=i(this,t.call(this,r[0]instanceof u.Texture?r[0]:r[0].texture));return s._textures=null,s._durations=null,s.textures=r,s._autoUpdate=!1!==o,s.animationSpeed=1,s.loop=!0,s.updateAnchor=!1,s.onComplete=null,s.onFrameChange=null,s.onLoop=null,s._currentTime=0,s.playing=!1,s}return o(e,t),e.prototype.stop=function(){this.playing&&(this.playing=!1,this._autoUpdate&&u.ticker.shared.remove(this.update,this))},e.prototype.play=function(){this.playing||(this.playing=!0,this._autoUpdate&&u.ticker.shared.add(this.update,this,u.UPDATE_PRIORITY.HIGH))},e.prototype.gotoAndStop=function(t){this.stop();var e=this.currentFrame;this._currentTime=t,e!==this.currentFrame&&this.updateTexture()},e.prototype.gotoAndPlay=function(t){var e=this.currentFrame;this._currentTime=t,e!==this.currentFrame&&this.updateTexture(),this.play()},e.prototype.update=function(t){var e=this.animationSpeed*t,r=this.currentFrame;if(null!==this._durations){var n=this._currentTime%1*this._durations[this.currentFrame];for(n+=e/60*1e3;n<0;)this._currentTime--,n+=this._durations[this.currentFrame];var i=Math.sign(this.animationSpeed*t);for(this._currentTime=Math.floor(this._currentTime);n>=this._durations[this.currentFrame];)n-=this._durations[this.currentFrame]*i,this._currentTime+=i;this._currentTime+=n/this._durations[this.currentFrame]}else this._currentTime+=e;this._currentTime<0&&!this.loop?(this.gotoAndStop(0),this.onComplete&&this.onComplete()):this._currentTime>=this._textures.length&&!this.loop?(this.gotoAndStop(this._textures.length-1),this.onComplete&&this.onComplete()):r!==this.currentFrame&&(this.loop&&this.onLoop&&(this.animationSpeed>0&&this.currentFrame<r?this.onLoop():this.animationSpeed<0&&this.currentFrame>r&&this.onLoop()),this.updateTexture())},e.prototype.updateTexture=function(){this._texture=this._textures[this.currentFrame],this._textureID=-1,this.cachedTint=16777215,this.updateAnchor&&this._anchor.copy(this._texture.defaultAnchor),this.onFrameChange&&this.onFrameChange(this.currentFrame)},e.prototype.destroy=function(e){this.stop(),t.prototype.destroy.call(this,e)},e.fromFrames=function(t){for(var r=[],n=0;n<t.length;++n)r.push(u.Texture.fromFrame(t[n]));return new e(r)},e.fromImages=function(t){for(var r=[],n=0;n<t.length;++n)r.push(u.Texture.fromImage(t[n]));return new e(r)},s(e,[{key:"totalFrames",get:function(){return this._textures.length}},{key:"textures",get:function(){return this._textures},set:function(t){if(t[0]instanceof u.Texture)this._textures=t,this._durations=null;else{this._textures=[],this._durations=[];for(var e=0;e<t.length;e++)this._textures.push(t[e].texture),this._durations.push(t[e].time)}this.gotoAndStop(0),this.updateTexture()}},{key:"currentFrame",get:function(){var t=Math.floor(this._currentTime)%this._textures.length;return t<0&&(t+=this._textures.length),t}}]),e}(u.Sprite);r.default=h},{"../core":65}],136:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),u=t("../core"),h=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(u),l=t("../core/math/ObservablePoint"),c=n(l),d=t("../core/utils"),f=t("../core/settings"),p=n(f),v=function(t){function e(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};i(this,e);var s=o(this,t.call(this));return s._textWidth=0,s._textHeight=0,s._glyphs=[],s._font={tint:void 0!==n.tint?n.tint:16777215,align:n.align||"left",name:null,size:0},s.font=n.font,s._text=r,s._maxWidth=0,s._maxLineHeight=0,s._letterSpacing=0,s._anchor=new c.default(function(){s.dirty=!0},s,0,0),s.dirty=!1,s.updateText(),s}return s(e,t),e.prototype.updateText=function(){for(var t=e.fonts[this._font.name],r=this._font.size/t.size,n=new h.Point,i=[],o=[],s=this.text.replace(/(?:\r\n|\r)/g,"\n"),a=s.length,u=this._maxWidth*t.size/this._font.size,l=null,c=0,d=0,f=0,p=-1,v=0,g=0,y=0,m=0;m<a;m++){var _=s.charCodeAt(m),b=s.charAt(m);if(/(?:\s)/.test(b)&&(p=m,v=c),"\r"!==b&&"\n"!==b){var x=t.chars[_];x&&(l&&x.kerning[l]&&(n.x+=x.kerning[l]),i.push({texture:x.texture,line:f,charCode:_,position:new h.Point(n.x+x.xOffset+this._letterSpacing/2,n.y+x.yOffset)}),n.x+=x.xAdvance+this._letterSpacing,c=n.x,y=Math.max(y,x.yOffset+x.texture.height),l=_,-1!==p&&u>0&&n.x>u&&(++g,h.utils.removeItems(i,1+p-g,1+m-p),m=p,p=-1,o.push(v),d=Math.max(d,v),f++,n.x=0,n.y+=t.lineHeight,l=null))}else o.push(c),d=Math.max(d,c),++f,++g,n.x=0,n.y+=t.lineHeight,l=null}var T=s.charAt(s.length-1);"\r"!==T&&"\n"!==T&&(/(?:\s)/.test(T)&&(c=v),o.push(c),d=Math.max(d,c));for(var w=[],E=0;E<=f;E++){var S=0;"right"===this._font.align?S=d-o[E]:"center"===this._font.align&&(S=(d-o[E])/2),w.push(S)}for(var O=i.length,M=this.tint,P=0;P<O;P++){var C=this._glyphs[P];C?C.texture=i[P].texture:(C=new h.Sprite(i[P].texture),this._glyphs.push(C)),C.position.x=(i[P].position.x+w[i[P].line])*r,C.position.y=i[P].position.y*r,C.scale.x=C.scale.y=r,C.tint=M,C.parent||this.addChild(C)}for(var R=O;R<this._glyphs.length;++R)this.removeChild(this._glyphs[R]);if(this._textWidth=d*r,this._textHeight=(n.y+t.lineHeight)*r,0!==this.anchor.x||0!==this.anchor.y)for(var A=0;A<O;A++)this._glyphs[A].x-=this._textWidth*this.anchor.x,this._glyphs[A].y-=this._textHeight*this.anchor.y;this._maxLineHeight=y*r},e.prototype.updateTransform=function(){this.validate(),this.containerUpdateTransform()},e.prototype.getLocalBounds=function(){return this.validate(),t.prototype.getLocalBounds.call(this)},e.prototype.validate=function(){this.dirty&&(this.updateText(),this.dirty=!1)},e.registerFont=function(t,r){var n={},i=t.getElementsByTagName("info")[0],o=t.getElementsByTagName("common")[0],s=t.getElementsByTagName("page"),a=(0,d.getResolutionOfUrl)(s[0].getAttribute("file"),p.default.RESOLUTION),u={};n.font=i.getAttribute("face"),n.size=parseInt(i.getAttribute("size"),10),n.lineHeight=parseInt(o.getAttribute("lineHeight"),10)/a,n.chars={},r instanceof h.Texture&&(r=[r]);for(var l=0;l<s.length;l++){var c=s[l].getAttribute("id"),f=s[l].getAttribute("file");u[c]=r instanceof Array?r[l]:r[f]}for(var v=t.getElementsByTagName("char"),g=0;g<v.length;g++){var y=v[g],m=parseInt(y.getAttribute("id"),10),_=y.getAttribute("page")||0,b=new h.Rectangle(parseInt(y.getAttribute("x"),10)/a+u[_].frame.x/a,parseInt(y.getAttribute("y"),10)/a+u[_].frame.y/a,parseInt(y.getAttribute("width"),10)/a,parseInt(y.getAttribute("height"),10)/a);n.chars[m]={xOffset:parseInt(y.getAttribute("xoffset"),10)/a,yOffset:parseInt(y.getAttribute("yoffset"),10)/a,xAdvance:parseInt(y.getAttribute("xadvance"),10)/a,kerning:{},texture:new h.Texture(u[_].baseTexture,b),page:_}}for(var x=t.getElementsByTagName("kerning"),T=0;T<x.length;T++){var w=x[T],E=parseInt(w.getAttribute("first"),10)/a,S=parseInt(w.getAttribute("second"),10)/a,O=parseInt(w.getAttribute("amount"),10)/a;n.chars[S]&&(n.chars[S].kerning[E]=O)}return e.fonts[n.font]=n,n},a(e,[{key:"tint",get:function(){return this._font.tint},set:function(t){this._font.tint="number"==typeof t&&t>=0?t:16777215,this.dirty=!0}},{key:"align",get:function(){return this._font.align},set:function(t){this._font.align=t||"left",this.dirty=!0}},{key:"anchor",get:function(){return this._anchor},set:function(t){"number"==typeof t?this._anchor.set(t):this._anchor.copy(t)}},{key:"font",get:function(){return this._font},set:function(t){t&&("string"==typeof t?(t=t.split(" "),this._font.name=1===t.length?t[0]:t.slice(1).join(" "),this._font.size=t.length>=2?parseInt(t[0],10):e.fonts[this._font.name].size):(this._font.name=t.name,this._font.size="number"==typeof t.size?t.size:parseInt(t.size,10)),this.dirty=!0)}},{key:"text",get:function(){return this._text},set:function(t){t=t.toString()||" ",this._text!==t&&(this._text=t,this.dirty=!0)}},{key:"maxWidth",get:function(){return this._maxWidth},set:function(t){this._maxWidth!==t&&(this._maxWidth=t,this.dirty=!0)}},{key:"maxLineHeight",get:function(){return this.validate(),this._maxLineHeight}},{key:"textWidth",get:function(){return this.validate(),this._textWidth}},{key:"letterSpacing",get:function(){return this._letterSpacing},set:function(t){this._letterSpacing!==t&&(this._letterSpacing=t,this.dirty=!0)}},{key:"textHeight",get:function(){return this.validate(),this._textHeight}}]),e}(h.Container);r.default=v,v.fonts={}},{"../core":65,"../core/math/ObservablePoint":68,"../core/settings":101,"../core/utils":125}],137:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=t("../core/sprites/canvas/CanvasTinter"),l=function(t){return t&&t.__esModule?t:{default:t}}(h),c=new u.Point,d=function(t){function e(r){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:100,s=arguments.length>2&&void 0!==arguments[2]?arguments[2]:100;n(this,e);var a=i(this,t.call(this,r));return a.tileTransform=new u.TransformStatic,a._width=o,a._height=s,a._canvasPattern=null,a.uvTransform=r.transform||new u.TextureMatrix(r),a.pluginName="tilingSprite",a.uvRespectAnchor=!1,a}return o(e,t),e.prototype._onTextureUpdate=function(){this.uvTransform&&(this.uvTransform.texture=this._texture),this.cachedTint=16777215},e.prototype._renderWebGL=function(t){var e=this._texture;e&&e.valid&&(this.tileTransform.updateLocalTransform(),this.uvTransform.update(),t.setObjectRenderer(t.plugins[this.pluginName]),t.plugins[this.pluginName].render(this))},e.prototype._renderCanvas=function(t){var e=this._texture;if(e.baseTexture.hasLoaded){var r=t.context,n=this.worldTransform,i=t.resolution,o=2===e.rotate,s=e.baseTexture,a=s.resolution,h=this.tilePosition.x/this.tileScale.x%e.orig.width*a,c=this.tilePosition.y/this.tileScale.y%e.orig.height*a;if(this._textureID!==this._texture._updateID||this.cachedTint!==this.tint){this._textureID=this._texture._updateID;var d=new u.CanvasRenderTarget(e.orig.width,e.orig.height,a);if(16777215!==this.tint)this.tintedTexture=l.default.getTintedTexture(this,this.tint),d.context.drawImage(this.tintedTexture,0,0);else{var f=e._frame.x*a,p=e._frame.y*a,v=e._frame.width*a,g=e._frame.height*a,y=(e.trim?e.trim.width:e.orig.width)*a,m=(e.trim?e.trim.height:e.orig.height)*a,_=(e.trim?e.trim.x:0)*a,b=(e.trim?e.trim.y:0)*a;o?(d.context.rotate(-Math.PI/2),d.context.translate(-m,0),d.context.drawImage(s.source,f,p,v,g,-b,_,m,y)):d.context.drawImage(s.source,f,p,v,g,_,b,y,m)}this.cachedTint=this.tint,this._canvasPattern=d.context.createPattern(d.canvas,"repeat")}r.globalAlpha=this.worldAlpha,r.setTransform(n.a*i,n.b*i,n.c*i,n.d*i,n.tx*i,n.ty*i),t.setBlendMode(this.blendMode),r.fillStyle=this._canvasPattern,r.scale(this.tileScale.x/a,this.tileScale.y/a);var x=this.anchor.x*-this._width*a,T=this.anchor.y*-this._height*a;this.uvRespectAnchor?(r.translate(h,c),
r.fillRect(-h+x,-c+T,this._width/this.tileScale.x*a,this._height/this.tileScale.y*a)):(r.translate(h+x,c+T),r.fillRect(-h,-c,this._width/this.tileScale.x*a,this._height/this.tileScale.y*a))}},e.prototype._calculateBounds=function(){var t=this._width*-this._anchor._x,e=this._height*-this._anchor._y,r=this._width*(1-this._anchor._x),n=this._height*(1-this._anchor._y);this._bounds.addFrame(this.transform,t,e,r,n)},e.prototype.getLocalBounds=function(e){return 0===this.children.length?(this._bounds.minX=this._width*-this._anchor._x,this._bounds.minY=this._height*-this._anchor._y,this._bounds.maxX=this._width*(1-this._anchor._x),this._bounds.maxY=this._height*(1-this._anchor._y),e||(this._localBoundsRect||(this._localBoundsRect=new u.Rectangle),e=this._localBoundsRect),this._bounds.getRectangle(e)):t.prototype.getLocalBounds.call(this,e)},e.prototype.containsPoint=function(t){this.worldTransform.applyInverse(t,c);var e=this._width,r=this._height,n=-e*this.anchor._x;if(c.x>=n&&c.x<n+e){var i=-r*this.anchor._y;if(c.y>=i&&c.y<i+r)return!0}return!1},e.prototype.destroy=function(e){t.prototype.destroy.call(this,e),this.tileTransform=null,this.uvTransform=null},e.from=function(t,r,n){return new e(u.Texture.from(t),r,n)},e.fromFrame=function(t,r,n){var i=u.utils.TextureCache[t];if(!i)throw new Error('The frameId "'+t+'" does not exist in the texture cache '+this);return new e(i,r,n)},e.fromImage=function(t,r,n,i,o){return new e(u.Texture.fromImage(t,i,o),r,n)},s(e,[{key:"clampMargin",get:function(){return this.uvTransform.clampMargin},set:function(t){this.uvTransform.clampMargin=t,this.uvTransform.update(!0)}},{key:"tileScale",get:function(){return this.tileTransform.scale},set:function(t){this.tileTransform.scale.copy(t)}},{key:"tilePosition",get:function(){return this.tileTransform.position},set:function(t){this.tileTransform.position.copy(t)}},{key:"width",get:function(){return this._width},set:function(t){this._width=t}},{key:"height",get:function(){return this._height},set:function(t){this._height=t}}]),e}(u.Sprite);r.default=d},{"../core":65,"../core/sprites/canvas/CanvasTinter":104}],138:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var o=t("../core"),s=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(o),a=t("../core/textures/Texture"),u=n(a),h=t("../core/textures/BaseTexture"),l=n(h),c=t("../core/utils"),d=s.DisplayObject,f=new s.Matrix;d.prototype._cacheAsBitmap=!1,d.prototype._cacheData=!1;var p=function t(){i(this,t),this.textureCacheId=null,this.originalRenderWebGL=null,this.originalRenderCanvas=null,this.originalCalculateBounds=null,this.originalGetLocalBounds=null,this.originalUpdateTransform=null,this.originalHitTest=null,this.originalDestroy=null,this.originalMask=null,this.originalFilterArea=null,this.sprite=null};Object.defineProperties(d.prototype,{cacheAsBitmap:{get:function(){return this._cacheAsBitmap},set:function(t){if(this._cacheAsBitmap!==t){this._cacheAsBitmap=t;var e=void 0;t?(this._cacheData||(this._cacheData=new p),e=this._cacheData,e.originalRenderWebGL=this.renderWebGL,e.originalRenderCanvas=this.renderCanvas,e.originalUpdateTransform=this.updateTransform,e.originalCalculateBounds=this.calculateBounds,e.originalGetLocalBounds=this.getLocalBounds,e.originalDestroy=this.destroy,e.originalContainsPoint=this.containsPoint,e.originalMask=this._mask,e.originalFilterArea=this.filterArea,this.renderWebGL=this._renderCachedWebGL,this.renderCanvas=this._renderCachedCanvas,this.destroy=this._cacheAsBitmapDestroy):(e=this._cacheData,e.sprite&&this._destroyCachedDisplayObject(),this.renderWebGL=e.originalRenderWebGL,this.renderCanvas=e.originalRenderCanvas,this.calculateBounds=e.originalCalculateBounds,this.getLocalBounds=e.originalGetLocalBounds,this.destroy=e.originalDestroy,this.updateTransform=e.originalUpdateTransform,this.containsPoint=e.originalContainsPoint,this._mask=e.originalMask,this.filterArea=e.originalFilterArea)}}}}),d.prototype._renderCachedWebGL=function(t){!this.visible||this.worldAlpha<=0||!this.renderable||(this._initCachedDisplayObject(t),this._cacheData.sprite.transform._worldID=this.transform._worldID,this._cacheData.sprite.worldAlpha=this.worldAlpha,this._cacheData.sprite._renderWebGL(t))},d.prototype._initCachedDisplayObject=function(t){if(!this._cacheData||!this._cacheData.sprite){var e=this.alpha;this.alpha=1,t.currentRenderer.flush();var r=this.getLocalBounds().clone();if(this._filters&&this._filters.length){var n=this._filters[0].padding;r.pad(n)}r.ceil(s.settings.RESOLUTION);var i=t._activeRenderTarget,o=t.filterManager.filterStack,a=s.RenderTexture.create(r.width,r.height),h="cacheAsBitmap_"+(0,c.uid)();this._cacheData.textureCacheId=h,l.default.addToCache(a.baseTexture,h),u.default.addToCache(a,h);var d=f;d.tx=-r.x,d.ty=-r.y,this.transform.worldTransform.identity(),this.renderWebGL=this._cacheData.originalRenderWebGL,t.render(this,a,!0,d,!0),t.bindRenderTarget(i),t.filterManager.filterStack=o,this.renderWebGL=this._renderCachedWebGL,this.updateTransform=this.displayObjectUpdateTransform,this.calculateBounds=this._calculateCachedBounds,this.getLocalBounds=this._getCachedLocalBounds,this._mask=null,this.filterArea=null;var p=new s.Sprite(a);p.transform.worldTransform=this.transform.worldTransform,p.anchor.x=-r.x/r.width,p.anchor.y=-r.y/r.height,p.alpha=e,p._bounds=this._bounds,this._cacheData.sprite=p,this.transform._parentID=-1,this.parent?this.updateTransform():(this.parent=t._tempDisplayObjectParent,this.updateTransform(),this.parent=null),this.containsPoint=p.containsPoint.bind(p)}},d.prototype._renderCachedCanvas=function(t){!this.visible||this.worldAlpha<=0||!this.renderable||(this._initCachedDisplayObjectCanvas(t),this._cacheData.sprite.worldAlpha=this.worldAlpha,this._cacheData.sprite._renderCanvas(t))},d.prototype._initCachedDisplayObjectCanvas=function(t){if(!this._cacheData||!this._cacheData.sprite){var e=this.getLocalBounds(),r=this.alpha;this.alpha=1;var n=t.context;e.ceil(s.settings.RESOLUTION);var i=s.RenderTexture.create(e.width,e.height),o="cacheAsBitmap_"+(0,c.uid)();this._cacheData.textureCacheId=o,l.default.addToCache(i.baseTexture,o),u.default.addToCache(i,o);var a=f;this.transform.localTransform.copy(a),a.invert(),a.tx-=e.x,a.ty-=e.y,this.renderCanvas=this._cacheData.originalRenderCanvas,t.render(this,i,!0,a,!1),t.context=n,this.renderCanvas=this._renderCachedCanvas,this.updateTransform=this.displayObjectUpdateTransform,this.calculateBounds=this._calculateCachedBounds,this.getLocalBounds=this._getCachedLocalBounds,this._mask=null,this.filterArea=null;var h=new s.Sprite(i);h.transform.worldTransform=this.transform.worldTransform,h.anchor.x=-e.x/e.width,h.anchor.y=-e.y/e.height,h.alpha=r,h._bounds=this._bounds,this._cacheData.sprite=h,this.transform._parentID=-1,this.parent?this.updateTransform():(this.parent=t._tempDisplayObjectParent,this.updateTransform(),this.parent=null),this.containsPoint=h.containsPoint.bind(h)}},d.prototype._calculateCachedBounds=function(){this._bounds.clear(),this._cacheData.sprite.transform._worldID=this.transform._worldID,this._cacheData.sprite._calculateBounds(),this._lastBoundsID=this._boundsID},d.prototype._getCachedLocalBounds=function(){return this._cacheData.sprite.getLocalBounds()},d.prototype._destroyCachedDisplayObject=function(){this._cacheData.sprite._texture.destroy(!0),this._cacheData.sprite=null,l.default.removeFromCache(this._cacheData.textureCacheId),u.default.removeFromCache(this._cacheData.textureCacheId),this._cacheData.textureCacheId=null},d.prototype._cacheAsBitmapDestroy=function(t){this.cacheAsBitmap=!1,this.destroy(t)}},{"../core":65,"../core/textures/BaseTexture":112,"../core/textures/Texture":115,"../core/utils":125}],139:[function(t,e,r){"use strict";var n=t("../core"),i=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(n);i.DisplayObject.prototype.name=null,i.Container.prototype.getChildByName=function(t){for(var e=0;e<this.children.length;e++)if(this.children[e].name===t)return this.children[e];return null}},{"../core":65}],140:[function(t,e,r){"use strict";var n=t("../core"),i=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(n);i.DisplayObject.prototype.getGlobalPosition=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new i.Point,e=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return this.parent?this.parent.toGlobal(this.position,t,e):(t.x=this.position.x,t.y=this.position.y),t}},{"../core":65}],141:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0,r.BitmapText=r.TilingSpriteRenderer=r.TilingSprite=r.AnimatedSprite=void 0;var i=t("./AnimatedSprite");Object.defineProperty(r,"AnimatedSprite",{enumerable:!0,get:function(){return n(i).default}});var o=t("./TilingSprite");Object.defineProperty(r,"TilingSprite",{enumerable:!0,get:function(){return n(o).default}});var s=t("./webgl/TilingSpriteRenderer");Object.defineProperty(r,"TilingSpriteRenderer",{enumerable:!0,get:function(){return n(s).default}});var a=t("./BitmapText");Object.defineProperty(r,"BitmapText",{enumerable:!0,get:function(){return n(a).default}}),t("./cacheAsBitmap"),t("./getChildByName"),t("./getGlobalPosition")},{"./AnimatedSprite":135,"./BitmapText":136,"./TilingSprite":137,"./cacheAsBitmap":138,"./getChildByName":139,"./getGlobalPosition":140,"./webgl/TilingSpriteRenderer":142}],142:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=t("../../core"),a=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(s),u=t("../../core/const"),h=(t("path"),new a.Matrix),l=function(t){function e(r){n(this,e);var o=i(this,t.call(this,r));return o.shader=null,o.simpleShader=null,o.quad=null,o}return o(e,t),e.prototype.onContextChange=function(){var t=this.renderer.gl;this.shader=new a.Shader(t,"attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n","varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = mod(vTextureCoord - uClampOffset, vec2(1.0, 1.0)) + uClampOffset;\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 sample = texture2D(uSampler, coord);\n    gl_FragColor = sample * uColor;\n}\n"),this.simpleShader=new a.Shader(t,"attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n","varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 sample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = sample * uColor;\n}\n"),this.renderer.bindVao(null),this.quad=new a.Quad(t,this.renderer.state.attribState),this.quad.initVao(this.shader)},e.prototype.render=function(t){var e=this.renderer,r=this.quad;e.bindVao(r.vao);var n=r.vertices;n[0]=n[6]=t._width*-t.anchor.x,n[1]=n[3]=t._height*-t.anchor.y,n[2]=n[4]=t._width*(1-t.anchor.x),n[5]=n[7]=t._height*(1-t.anchor.y),t.uvRespectAnchor&&(n=r.uvs,n[0]=n[6]=-t.anchor.x,n[1]=n[3]=-t.anchor.y,n[2]=n[4]=1-t.anchor.x,n[5]=n[7]=1-t.anchor.y),r.upload();var i=t._texture,o=i.baseTexture,s=t.tileTransform.localTransform,l=t.uvTransform,c=o.isPowerOfTwo&&i.frame.width===o.width&&i.frame.height===o.height;c&&(o._glTextures[e.CONTEXT_UID]?c=o.wrapMode!==u.WRAP_MODES.CLAMP:o.wrapMode===u.WRAP_MODES.CLAMP&&(o.wrapMode=u.WRAP_MODES.REPEAT));var d=c?this.simpleShader:this.shader;e.bindShader(d);var f=i.width,p=i.height,v=t._width,g=t._height;h.set(s.a*f/v,s.b*f/g,s.c*p/v,s.d*p/g,s.tx/v,s.ty/g),h.invert(),c?h.prepend(l.mapCoord):(d.uniforms.uMapCoord=l.mapCoord.toArray(!0),d.uniforms.uClampFrame=l.uClampFrame,d.uniforms.uClampOffset=l.uClampOffset),d.uniforms.uTransform=h.toArray(!0),d.uniforms.uColor=a.utils.premultiplyTintToRgba(t.tint,t.worldAlpha,d.uniforms.uColor,o.premultipliedAlpha),d.uniforms.translationMatrix=t.transform.worldTransform.toArray(!0),d.uniforms.uSampler=e.bindTexture(i),e.setBlendMode(a.utils.correctBlendMode(t.blendMode,o.premultipliedAlpha)),r.vao.draw(this.renderer.gl.TRIANGLES,6,0)},e}(a.ObjectRenderer);r.default=l,a.WebGLRenderer.registerPlugin("tilingSprite",l)},{"../../core":65,"../../core/const":46,path:8}],143:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=(t("path"),function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;n(this,e);var o=i(this,t.call(this,"attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}","varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float uAlpha;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;\n}\n"));return o.alpha=r,o.glShaderKey="alpha",o}return o(e,t),s(e,[{key:"alpha",get:function(){return this.uniforms.uAlpha},set:function(t){this.uniforms.uAlpha=t}}]),e}(u.Filter));r.default=h},{"../../core":65,path:8}],144:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),u=t("../../core"),h=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(u),l=t("./BlurXFilter"),c=n(l),d=t("./BlurYFilter"),f=n(d),p=function(t){function e(r,n,s,a){i(this,e);var u=o(this,t.call(this));return u.blurXFilter=new c.default(r,n,s,a),u.blurYFilter=new f.default(r,n,s,a),u.padding=0,u.resolution=s||h.settings.RESOLUTION,u.quality=n||4,u.blur=r||8,u}return s(e,t),e.prototype.apply=function(t,e,r){var n=t.getRenderTarget(!0);this.blurXFilter.apply(t,e,n,!0),this.blurYFilter.apply(t,n,r,!1),t.returnRenderTarget(n)},a(e,[{key:"blur",get:function(){return this.blurXFilter.blur},set:function(t){this.blurXFilter.blur=this.blurYFilter.blur=t,this.padding=2*Math.max(Math.abs(this.blurXFilter.strength),Math.abs(this.blurYFilter.strength))}},{key:"quality",get:function(){return this.blurXFilter.quality},set:function(t){this.blurXFilter.quality=this.blurYFilter.quality=t}},{key:"blurX",get:function(){return this.blurXFilter.blur},set:function(t){this.blurXFilter.blur=t,this.padding=2*Math.max(Math.abs(this.blurXFilter.strength),Math.abs(this.blurYFilter.strength))}},{key:"blurY",get:function(){return this.blurYFilter.blur},set:function(t){this.blurYFilter.blur=t,this.padding=2*Math.max(Math.abs(this.blurXFilter.strength),Math.abs(this.blurYFilter.strength))}},{key:"blendMode",get:function(){return this.blurYFilter._blendMode},set:function(t){this.blurYFilter._blendMode=t}}]),e}(h.Filter);r.default=p},{"../../core":65,"./BlurXFilter":145,"./BlurYFilter":146}],145:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),u=t("../../core"),h=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(u),l=t("./generateBlurVertSource"),c=n(l),d=t("./generateBlurFragSource"),f=n(d),p=t("./getMaxBlurKernelSize"),v=n(p),g=function(t){function e(r,n,s,a){i(this,e),a=a||5;var u=(0,c.default)(a,!0),l=(0,f.default)(a),d=o(this,t.call(this,u,l));return d.resolution=s||h.settings.RESOLUTION,d._quality=0,d.quality=n||4,d.strength=r||8,d.firstRun=!0,d}return s(e,t),e.prototype.apply=function(t,e,r,n){if(this.firstRun){var i=t.renderer.gl,o=(0,v.default)(i);this.vertexSrc=(0,c.default)(o,!0),this.fragmentSrc=(0,f.default)(o),this.firstRun=!1}if(this.uniforms.strength=1/r.size.width*(r.size.width/e.size.width),this.uniforms.strength*=this.strength,this.uniforms.strength/=this.passes,1===this.passes)t.applyFilter(this,e,r,n);else{for(var s=t.getRenderTarget(!0),a=e,u=s,h=0;h<this.passes-1;h++){t.applyFilter(this,a,u,!0);var l=u;u=a,a=l}t.applyFilter(this,a,r,n),t.returnRenderTarget(s)}},a(e,[{key:"blur",get:function(){return this.strength},set:function(t){this.padding=2*Math.abs(t),this.strength=t}},{key:"quality",get:function(){return this._quality},set:function(t){this._quality=t,this.passes=t}}]),e}(h.Filter);r.default=g},{"../../core":65,"./generateBlurFragSource":147,"./generateBlurVertSource":148,"./getMaxBlurKernelSize":149}],146:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),u=t("../../core"),h=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(u),l=t("./generateBlurVertSource"),c=n(l),d=t("./generateBlurFragSource"),f=n(d),p=t("./getMaxBlurKernelSize"),v=n(p),g=function(t){function e(r,n,s,a){i(this,e),a=a||5;var u=(0,c.default)(a,!1),l=(0,f.default)(a),d=o(this,t.call(this,u,l));return d.resolution=s||h.settings.RESOLUTION,d._quality=0,d.quality=n||4,d.strength=r||8,d.firstRun=!0,d}return s(e,t),e.prototype.apply=function(t,e,r,n){if(this.firstRun){var i=t.renderer.gl,o=(0,v.default)(i);this.vertexSrc=(0,c.default)(o,!1),this.fragmentSrc=(0,f.default)(o),this.firstRun=!1}if(this.uniforms.strength=1/r.size.height*(r.size.height/e.size.height),this.uniforms.strength*=this.strength,this.uniforms.strength/=this.passes,1===this.passes)t.applyFilter(this,e,r,n);else{for(var s=t.getRenderTarget(!0),a=e,u=s,h=0;h<this.passes-1;h++){t.applyFilter(this,a,u,!0);var l=u;u=a,a=l}t.applyFilter(this,a,r,n),t.returnRenderTarget(s)}},a(e,[{key:"blur",get:function(){return this.strength},set:function(t){this.padding=2*Math.abs(t),this.strength=t}},{key:"quality",get:function(){return this._quality},set:function(t){this._quality=t,this.passes=t}}]),e}(h.Filter);r.default=g},{"../../core":65,"./generateBlurFragSource":147,"./generateBlurVertSource":148,"./getMaxBlurKernelSize":149}],147:[function(t,e,r){"use strict";function n(t){for(var e=i[t],r=e.length,n=o,s="",a="gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;",u=void 0,h=0;h<t;h++){var l=a.replace("%index%",h);u=h,h>=r&&(u=t-h-1),l=l.replace("%value%",e[u]),s+=l,s+="\n"}return n=n.replace("%blur%",s),n=n.replace("%size%",t)}r.__esModule=!0,r.default=n;var i={5:[.153388,.221461,.250301],7:[.071303,.131514,.189879,.214607],9:[.028532,.067234,.124009,.179044,.20236],11:[.0093,.028002,.065984,.121703,.175713,.198596],13:[.002406,.009255,.027867,.065666,.121117,.174868,.197641],15:[489e-6,.002403,.009246,.02784,.065602,.120999,.174697,.197448]},o=["varying vec2 vBlurTexCoords[%size%];","uniform sampler2D uSampler;","void main(void)","{","    gl_FragColor = vec4(0.0);","    %blur%","}"].join("\n")},{}],148:[function(t,e,r){"use strict";function n(t,e){var r=Math.ceil(t/2),n=i,o="",s=void 0;s=e?"vBlurTexCoords[%index%] = aTextureCoord + vec2(%sampleIndex% * strength, 0.0);":"vBlurTexCoords[%index%] = aTextureCoord + vec2(0.0, %sampleIndex% * strength);";for(var a=0;a<t;a++){var u=s.replace("%index%",a);u=u.replace("%sampleIndex%",a-(r-1)+".0"),o+=u,o+="\n"}return n=n.replace("%blur%",o),n=n.replace("%size%",t)}r.__esModule=!0,r.default=n;var i=["attribute vec2 aVertexPosition;","attribute vec2 aTextureCoord;","uniform float strength;","uniform mat3 projectionMatrix;","varying vec2 vBlurTexCoords[%size%];","void main(void)","{","gl_Position = vec4((projectionMatrix * vec3((aVertexPosition), 1.0)).xy, 0.0, 1.0);","%blur%","}"].join("\n")},{}],149:[function(t,e,r){"use strict";function n(t){for(var e=t.getParameter(t.MAX_VARYING_VECTORS),r=15;r>e;)r-=2;return r}r.__esModule=!0,r.default=n},{}],150:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=(t("path"),function(t){function e(){n(this,e);var r=i(this,t.call(this,"attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}","varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\nuniform float uAlpha;\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n\n    if (uAlpha == 0.0) {\n        gl_FragColor = c;\n        return;\n    }\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n\n    vec4 result;\n\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    gl_FragColor = vec4(rgb, result.a);\n}\n"));return r.uniforms.m=[1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0],r.alpha=1,r}return o(e,t),e.prototype._loadMatrix=function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],r=t;e&&(this._multiply(r,this.uniforms.m,t),r=this._colorMatrix(r)),this.uniforms.m=r},e.prototype._multiply=function(t,e,r){return t[0]=e[0]*r[0]+e[1]*r[5]+e[2]*r[10]+e[3]*r[15],t[1]=e[0]*r[1]+e[1]*r[6]+e[2]*r[11]+e[3]*r[16],t[2]=e[0]*r[2]+e[1]*r[7]+e[2]*r[12]+e[3]*r[17],t[3]=e[0]*r[3]+e[1]*r[8]+e[2]*r[13]+e[3]*r[18],t[4]=e[0]*r[4]+e[1]*r[9]+e[2]*r[14]+e[3]*r[19]+e[4],t[5]=e[5]*r[0]+e[6]*r[5]+e[7]*r[10]+e[8]*r[15],t[6]=e[5]*r[1]+e[6]*r[6]+e[7]*r[11]+e[8]*r[16],t[7]=e[5]*r[2]+e[6]*r[7]+e[7]*r[12]+e[8]*r[17],t[8]=e[5]*r[3]+e[6]*r[8]+e[7]*r[13]+e[8]*r[18],t[9]=e[5]*r[4]+e[6]*r[9]+e[7]*r[14]+e[8]*r[19]+e[9],t[10]=e[10]*r[0]+e[11]*r[5]+e[12]*r[10]+e[13]*r[15],t[11]=e[10]*r[1]+e[11]*r[6]+e[12]*r[11]+e[13]*r[16],t[12]=e[10]*r[2]+e[11]*r[7]+e[12]*r[12]+e[13]*r[17],t[13]=e[10]*r[3]+e[11]*r[8]+e[12]*r[13]+e[13]*r[18],t[14]=e[10]*r[4]+e[11]*r[9]+e[12]*r[14]+e[13]*r[19]+e[14],t[15]=e[15]*r[0]+e[16]*r[5]+e[17]*r[10]+e[18]*r[15],t[16]=e[15]*r[1]+e[16]*r[6]+e[17]*r[11]+e[18]*r[16],t[17]=e[15]*r[2]+e[16]*r[7]+e[17]*r[12]+e[18]*r[17],t[18]=e[15]*r[3]+e[16]*r[8]+e[17]*r[13]+e[18]*r[18],t[19]=e[15]*r[4]+e[16]*r[9]+e[17]*r[14]+e[18]*r[19]+e[19],t},e.prototype._colorMatrix=function(t){var e=new Float32Array(t);return e[4]/=255,e[9]/=255,e[14]/=255,e[19]/=255,e},e.prototype.brightness=function(t,e){var r=[t,0,0,0,0,0,t,0,0,0,0,0,t,0,0,0,0,0,1,0];this._loadMatrix(r,e)},e.prototype.greyscale=function(t,e){var r=[t,t,t,0,0,t,t,t,0,0,t,t,t,0,0,0,0,0,1,0];this._loadMatrix(r,e)},e.prototype.blackAndWhite=function(t){var e=[.3,.6,.1,0,0,.3,.6,.1,0,0,.3,.6,.1,0,0,0,0,0,1,0];this._loadMatrix(e,t)},e.prototype.hue=function(t,e){t=(t||0)/180*Math.PI;var r=Math.cos(t),n=Math.sin(t),i=Math.sqrt,o=1/3,s=i(o),a=r+(1-r)*o,u=o*(1-r)-s*n,h=o*(1-r)+s*n,l=o*(1-r)+s*n,c=r+o*(1-r),d=o*(1-r)-s*n,f=o*(1-r)-s*n,p=o*(1-r)+s*n,v=r+o*(1-r),g=[a,u,h,0,0,l,c,d,0,0,f,p,v,0,0,0,0,0,1,0];this._loadMatrix(g,e)},e.prototype.contrast=function(t,e){var r=(t||0)+1,n=-.5*(r-1),i=[r,0,0,0,n,0,r,0,0,n,0,0,r,0,n,0,0,0,1,0];this._loadMatrix(i,e)},e.prototype.saturate=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments[1],r=2*t/3+1,n=-.5*(r-1),i=[r,n,n,0,0,n,r,n,0,0,n,n,r,0,0,0,0,0,1,0];this._loadMatrix(i,e)},e.prototype.desaturate=function(){this.saturate(-1)},e.prototype.negative=function(t){var e=[-1,0,0,1,0,0,-1,0,1,0,0,0,-1,1,0,0,0,0,1,0];this._loadMatrix(e,t)},e.prototype.sepia=function(t){var e=[.393,.7689999,.18899999,0,0,.349,.6859999,.16799999,0,0,.272,.5339999,.13099999,0,0,0,0,0,1,0];this._loadMatrix(e,t)},e.prototype.technicolor=function(t){var e=[1.9125277891456083,-.8545344976951645,-.09155508482755585,0,11.793603434377337,-.3087833385928097,1.7658908555458428,-.10601743074722245,0,-70.35205161461398,-.231103377548616,-.7501899197440212,1.847597816108189,0,30.950940869491138,0,0,0,1,0];this._loadMatrix(e,t)},e.prototype.polaroid=function(t){var e=[1.438,-.062,-.062,0,0,-.122,1.378,-.122,0,0,-.016,-.016,1.483,0,0,0,0,0,1,0];this._loadMatrix(e,t)},e.prototype.toBGR=function(t){var e=[0,0,1,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,1,0];this._loadMatrix(e,t)},e.prototype.kodachrome=function(t){var e=[1.1285582396593525,-.3967382283601348,-.03992559172921793,0,63.72958762196502,-.16404339962244616,1.0835251566291304,-.05498805115633132,0,24.732407896706203,-.16786010706155763,-.5603416277695248,1.6014850761964943,0,35.62982807460946,0,0,0,1,0];this._loadMatrix(e,t)},e.prototype.browni=function(t){var e=[.5997023498159715,.34553243048391263,-.2708298674538042,0,47.43192855600873,-.037703249837783157,.8609577587992641,.15059552388459913,0,-36.96841498319127,.24113635128153335,-.07441037908422492,.44972182064877153,0,-7.562075277591283,0,0,0,1,0];this._loadMatrix(e,t)},e.prototype.vintage=function(t){var e=[.6279345635605994,.3202183420819367,-.03965408211312453,0,9.651285835294123,.02578397704808868,.6441188644374771,.03259127616149294,0,7.462829176470591,.0466055556782719,-.0851232987247891,.5241648018700465,0,5.159190588235296,0,0,0,1,0];this._loadMatrix(e,t)},e.prototype.colorTone=function(t,e,r,n,i){t=t||.2,e=e||.15,r=r||16770432,n=n||3375104;var o=(r>>16&255)/255,s=(r>>8&255)/255,a=(255&r)/255,u=(n>>16&255)/255,h=(n>>8&255)/255,l=(255&n)/255,c=[.3,.59,.11,0,0,o,s,a,t,0,u,h,l,e,0,o-u,s-h,a-l,0,0];this._loadMatrix(c,i)},e.prototype.night=function(t,e){t=t||.1;var r=[-2*t,-t,0,0,0,-t,0,t,0,0,0,t,2*t,0,0,0,0,0,1,0];this._loadMatrix(r,e)},e.prototype.predator=function(t,e){
var r=[11.224130630493164*t,-4.794486999511719*t,-2.8746118545532227*t,0*t,.40342438220977783*t,-3.6330697536468506*t,9.193157196044922*t,-2.951810836791992*t,0*t,-1.316135048866272*t,-3.2184197902679443*t,-4.2375030517578125*t,7.476448059082031*t,0*t,.8044459223747253*t,0,0,0,1,0];this._loadMatrix(r,e)},e.prototype.lsd=function(t){var e=[2,-.4,.5,0,0,-.5,2,-.4,0,0,-.4,-.5,3,0,0,0,0,0,1,0];this._loadMatrix(e,t)},e.prototype.reset=function(){var t=[1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0];this._loadMatrix(t,!1)},s(e,[{key:"matrix",get:function(){return this.uniforms.m},set:function(t){this.uniforms.m=t}},{key:"alpha",get:function(){return this.uniforms.uAlpha},set:function(t){this.uniforms.uAlpha=t}}]),e}(u.Filter));r.default=h,h.prototype.grayscale=h.prototype.greyscale},{"../../core":65,path:8}],151:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=(t("path"),function(t){function e(r,o){n(this,e);var s=new u.Matrix;r.renderable=!1;var a=i(this,t.call(this,"attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nvoid main(void)\n{\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n   vTextureCoord = aTextureCoord;\n}","varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\n\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform vec4 filterArea;\nuniform vec4 filterClamp;\n\nvoid main(void)\n{\n  vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n  map -= 0.5;\n  map.xy *= scale / filterArea.xy;\n\n  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), filterClamp.xy, filterClamp.zw));\n}\n"));return a.maskSprite=r,a.maskMatrix=s,a.uniforms.mapSampler=r._texture,a.uniforms.filterMatrix=s,a.uniforms.scale={x:1,y:1},null!==o&&void 0!==o||(o=20),a.scale=new u.Point(o,o),a}return o(e,t),e.prototype.apply=function(t,e,r){this.uniforms.filterMatrix=t.calculateSpriteMatrix(this.maskMatrix,this.maskSprite),this.uniforms.scale.x=this.scale.x,this.uniforms.scale.y=this.scale.y,t.applyFilter(this,e,r)},s(e,[{key:"map",get:function(){return this.uniforms.mapSampler},set:function(t){this.uniforms.mapSampler=t}}]),e}(u.Filter));r.default=h},{"../../core":65,path:8}],152:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=t("../../core"),a=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(s),u=(t("path"),function(t){function e(){return n(this,e),i(this,t.call(this,"\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nuniform vec4 filterArea;\n\nvarying vec2 vTextureCoord;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= filterArea.xy;\n    coord += filterArea.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= filterArea.zw;\n    coord /= filterArea.xy;\n\n    return coord;\n}\n\nvoid texcoords(vec2 fragCoord, vec2 resolution,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    vec2 inverseVP = 1.0 / resolution.xy;\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n   vTextureCoord = aTextureCoord;\n\n   vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n   texcoords(fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}",'varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform vec4 filterArea;\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it\'s\n unsupported by WebGL.\n \n --\n \n From:\n https://github.com/mitsuhiko/webgl-meincraft\n \n Copyright (c) 2011 by Armin Ronacher.\n \n Some rights reserved.\n \n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n \n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n \n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n \n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n \n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 resolution,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    mediump vec2 inverseVP = vec2(1.0 / resolution.x, 1.0 / resolution.y);\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n    \n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n    \n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n    \n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n    \n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n    \n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n      vec4 color;\n\n    color = fxaa(uSampler, fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n'))}return o(e,t),e}(a.Filter));r.default=u},{"../../core":65,path:8}],153:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0;var i=t("./fxaa/FXAAFilter");Object.defineProperty(r,"FXAAFilter",{enumerable:!0,get:function(){return n(i).default}});var o=t("./noise/NoiseFilter");Object.defineProperty(r,"NoiseFilter",{enumerable:!0,get:function(){return n(o).default}});var s=t("./displacement/DisplacementFilter");Object.defineProperty(r,"DisplacementFilter",{enumerable:!0,get:function(){return n(s).default}});var a=t("./blur/BlurFilter");Object.defineProperty(r,"BlurFilter",{enumerable:!0,get:function(){return n(a).default}});var u=t("./blur/BlurXFilter");Object.defineProperty(r,"BlurXFilter",{enumerable:!0,get:function(){return n(u).default}});var h=t("./blur/BlurYFilter");Object.defineProperty(r,"BlurYFilter",{enumerable:!0,get:function(){return n(h).default}});var l=t("./colormatrix/ColorMatrixFilter");Object.defineProperty(r,"ColorMatrixFilter",{enumerable:!0,get:function(){return n(l).default}});var c=t("./alpha/AlphaFilter");Object.defineProperty(r,"AlphaFilter",{enumerable:!0,get:function(){return n(c).default}})},{"./alpha/AlphaFilter":143,"./blur/BlurFilter":144,"./blur/BlurXFilter":145,"./blur/BlurYFilter":146,"./colormatrix/ColorMatrixFilter":150,"./displacement/DisplacementFilter":151,"./fxaa/FXAAFilter":152,"./noise/NoiseFilter":154}],154:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=(t("path"),function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:.5,o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Math.random();n(this,e);var s=i(this,t.call(this,"attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}","precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) * uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    gl_FragColor = color;\n}\n"));return s.noise=r,s.seed=o,s}return o(e,t),s(e,[{key:"noise",get:function(){return this.uniforms.uNoise},set:function(t){this.uniforms.uNoise=t}},{key:"seed",get:function(){return this.uniforms.uSeed},set:function(t){this.uniforms.uSeed=t}}]),e}(u.Filter));r.default=h},{"../../core":65,path:8}],155:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),o=t("../core"),s=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(o),a=function(){function t(){n(this,t),this.global=new s.Point,this.target=null,this.originalEvent=null,this.identifier=null,this.isPrimary=!1,this.button=0,this.buttons=0,this.width=0,this.height=0,this.tiltX=0,this.tiltY=0,this.pointerType=null,this.pressure=0,this.rotationAngle=0,this.twist=0,this.tangentialPressure=0}return t.prototype.getLocalPosition=function(t,e,r){return t.worldTransform.applyInverse(r||this.global,e)},t.prototype.copyEvent=function(t){t.isPrimary&&(this.isPrimary=!0),this.button=t.button,this.buttons=Number.isInteger(t.buttons)?t.buttons:t.which,this.width=t.width,this.height=t.height,this.tiltX=t.tiltX,this.tiltY=t.tiltY,this.pointerType=t.pointerType,this.pressure=t.pressure,this.rotationAngle=t.rotationAngle,this.twist=t.twist||0,this.tangentialPressure=t.tangentialPressure||0},t.prototype.reset=function(){this.isPrimary=!1},i(t,[{key:"pointerId",get:function(){return this.identifier}}]),t}();r.default=a},{"../core":65}],156:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(){n(this,t),this.stopped=!1,this.target=null,this.currentTarget=null,this.type=null,this.data=null}return t.prototype.stopPropagation=function(){this.stopped=!0},t.prototype.reset=function(){this.stopped=!1,this.currentTarget=null,this.target=null},t}();r.default=i},{}],157:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},u=t("../core"),h=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(u),l=t("./InteractionData"),c=n(l),d=t("./InteractionEvent"),f=n(d),p=t("./InteractionTrackingData"),v=n(p),g=t("eventemitter3"),y=n(g),m=t("./interactiveTarget"),_=n(m);h.utils.mixins.delayMixin(h.DisplayObject.prototype,_.default);var b=1,x={target:null,data:{global:null}},T=function(t){function e(r,n){i(this,e);var s=o(this,t.call(this));return n=n||{},s.renderer=r,s.autoPreventDefault=void 0===n.autoPreventDefault||n.autoPreventDefault,s.interactionFrequency=n.interactionFrequency||10,s.mouse=new c.default,s.mouse.identifier=b,s.mouse.global.set(-999999),s.activeInteractionData={},s.activeInteractionData[b]=s.mouse,s.interactionDataPool=[],s.eventData=new f.default,s.interactionDOMElement=null,s.moveWhenInside=!1,s.eventsAdded=!1,s.mouseOverRenderer=!1,s.supportsTouchEvents="ontouchstart"in window,s.supportsPointerEvents=!!window.PointerEvent,s.onPointerUp=s.onPointerUp.bind(s),s.processPointerUp=s.processPointerUp.bind(s),s.onPointerCancel=s.onPointerCancel.bind(s),s.processPointerCancel=s.processPointerCancel.bind(s),s.onPointerDown=s.onPointerDown.bind(s),s.processPointerDown=s.processPointerDown.bind(s),s.onPointerMove=s.onPointerMove.bind(s),s.processPointerMove=s.processPointerMove.bind(s),s.onPointerOut=s.onPointerOut.bind(s),s.processPointerOverOut=s.processPointerOverOut.bind(s),s.onPointerOver=s.onPointerOver.bind(s),s.cursorStyles={default:"inherit",pointer:"pointer"},s.currentCursorMode=null,s.cursor=null,s._tempPoint=new h.Point,s.resolution=1,s.setTargetElement(s.renderer.view,s.renderer.resolution),s}return s(e,t),e.prototype.hitTest=function(t,e){return x.target=null,x.data.global=t,e||(e=this.renderer._lastObjectRendered),this.processInteractive(x,e,null,!0),x.target},e.prototype.setTargetElement=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;this.removeEvents(),this.interactionDOMElement=t,this.resolution=e,this.addEvents()},e.prototype.addEvents=function(){this.interactionDOMElement&&(h.ticker.shared.add(this.update,this,h.UPDATE_PRIORITY.INTERACTION),window.navigator.msPointerEnabled?(this.interactionDOMElement.style["-ms-content-zooming"]="none",this.interactionDOMElement.style["-ms-touch-action"]="none"):this.supportsPointerEvents&&(this.interactionDOMElement.style["touch-action"]="none"),this.supportsPointerEvents?(window.document.addEventListener("pointermove",this.onPointerMove,!0),this.interactionDOMElement.addEventListener("pointerdown",this.onPointerDown,!0),this.interactionDOMElement.addEventListener("pointerleave",this.onPointerOut,!0),this.interactionDOMElement.addEventListener("pointerover",this.onPointerOver,!0),window.addEventListener("pointercancel",this.onPointerCancel,!0),window.addEventListener("pointerup",this.onPointerUp,!0)):(window.document.addEventListener("mousemove",this.onPointerMove,!0),this.interactionDOMElement.addEventListener("mousedown",this.onPointerDown,!0),this.interactionDOMElement.addEventListener("mouseout",this.onPointerOut,!0),this.interactionDOMElement.addEventListener("mouseover",this.onPointerOver,!0),window.addEventListener("mouseup",this.onPointerUp,!0)),this.supportsTouchEvents&&(this.interactionDOMElement.addEventListener("touchstart",this.onPointerDown,!0),this.interactionDOMElement.addEventListener("touchcancel",this.onPointerCancel,!0),this.interactionDOMElement.addEventListener("touchend",this.onPointerUp,!0),this.interactionDOMElement.addEventListener("touchmove",this.onPointerMove,!0)),this.eventsAdded=!0)},e.prototype.removeEvents=function(){this.interactionDOMElement&&(h.ticker.shared.remove(this.update,this),window.navigator.msPointerEnabled?(this.interactionDOMElement.style["-ms-content-zooming"]="",this.interactionDOMElement.style["-ms-touch-action"]=""):this.supportsPointerEvents&&(this.interactionDOMElement.style["touch-action"]=""),this.supportsPointerEvents?(window.document.removeEventListener("pointermove",this.onPointerMove,!0),this.interactionDOMElement.removeEventListener("pointerdown",this.onPointerDown,!0),this.interactionDOMElement.removeEventListener("pointerleave",this.onPointerOut,!0),this.interactionDOMElement.removeEventListener("pointerover",this.onPointerOver,!0),window.removeEventListener("pointercancel",this.onPointerCancel,!0),window.removeEventListener("pointerup",this.onPointerUp,!0)):(window.document.removeEventListener("mousemove",this.onPointerMove,!0),this.interactionDOMElement.removeEventListener("mousedown",this.onPointerDown,!0),this.interactionDOMElement.removeEventListener("mouseout",this.onPointerOut,!0),this.interactionDOMElement.removeEventListener("mouseover",this.onPointerOver,!0),window.removeEventListener("mouseup",this.onPointerUp,!0)),this.supportsTouchEvents&&(this.interactionDOMElement.removeEventListener("touchstart",this.onPointerDown,!0),this.interactionDOMElement.removeEventListener("touchcancel",this.onPointerCancel,!0),this.interactionDOMElement.removeEventListener("touchend",this.onPointerUp,!0),this.interactionDOMElement.removeEventListener("touchmove",this.onPointerMove,!0)),this.interactionDOMElement=null,this.eventsAdded=!1)},e.prototype.update=function(t){if(this._deltaTime+=t,!(this._deltaTime<this.interactionFrequency)&&(this._deltaTime=0,this.interactionDOMElement)){if(this.didMove)return void(this.didMove=!1);this.cursor=null;for(var e in this.activeInteractionData)if(this.activeInteractionData.hasOwnProperty(e)){var r=this.activeInteractionData[e];if(r.originalEvent&&"touch"!==r.pointerType){var n=this.configureInteractionEventForDOMEvent(this.eventData,r.originalEvent,r);this.processInteractive(n,this.renderer._lastObjectRendered,this.processPointerOverOut,!0)}}this.setCursorMode(this.cursor)}},e.prototype.setCursorMode=function(t){if(t=t||"default",this.currentCursorMode!==t){this.currentCursorMode=t;var e=this.cursorStyles[t];if(e)switch(void 0===e?"undefined":a(e)){case"string":this.interactionDOMElement.style.cursor=e;break;case"function":e(t);break;case"object":Object.assign(this.interactionDOMElement.style,e)}else"string"!=typeof t||Object.prototype.hasOwnProperty.call(this.cursorStyles,t)||(this.interactionDOMElement.style.cursor=t)}},e.prototype.dispatchEvent=function(t,e,r){r.stopped||(r.currentTarget=t,r.type=e,t.emit(e,r),t[e]&&t[e](r))},e.prototype.mapPositionToPoint=function(t,e,r){var n=void 0;n=this.interactionDOMElement.parentElement?this.interactionDOMElement.getBoundingClientRect():{x:0,y:0,width:0,height:0};var i=navigator.isCocoonJS?this.resolution:1/this.resolution;t.x=(e-n.left)*(this.interactionDOMElement.width/n.width)*i,t.y=(r-n.top)*(this.interactionDOMElement.height/n.height)*i},e.prototype.processInteractive=function(t,e,r,n,i){if(!e||!e.visible)return!1;var o=t.data.global;i=e.interactive||i;var s=!1,a=i,u=!0;if(e.hitArea?(n&&(e.worldTransform.applyInverse(o,this._tempPoint),e.hitArea.contains(this._tempPoint.x,this._tempPoint.y)?s=!0:(n=!1,u=!1)),a=!1):e._mask&&n&&(e._mask.containsPoint(o)||(n=!1,u=!1)),u&&e.interactiveChildren&&e.children)for(var h=e.children,l=h.length-1;l>=0;l--){var c=h[l],d=this.processInteractive(t,c,r,n,a);if(d){if(!c.parent)continue;a=!1,d&&(t.target&&(n=!1),s=!0)}}return i&&(n&&!t.target&&!e.hitArea&&e.containsPoint&&e.containsPoint(o)&&(s=!0),e.interactive&&(s&&!t.target&&(t.target=e),r&&r(t,e,!!s))),s},e.prototype.onPointerDown=function(t){if(!this.supportsTouchEvents||"touch"!==t.pointerType){var e=this.normalizeToPointerData(t);this.autoPreventDefault&&e[0].isNormalized&&t.preventDefault();for(var r=e.length,n=0;n<r;n++){var i=e[n],o=this.getInteractionDataForPointerId(i),s=this.configureInteractionEventForDOMEvent(this.eventData,i,o);if(s.data.originalEvent=t,this.processInteractive(s,this.renderer._lastObjectRendered,this.processPointerDown,!0),this.emit("pointerdown",s),"touch"===i.pointerType)this.emit("touchstart",s);else if("mouse"===i.pointerType||"pen"===i.pointerType){var a=2===i.button;this.emit(a?"rightdown":"mousedown",this.eventData)}}}},e.prototype.processPointerDown=function(t,e,r){var n=t.data,i=t.data.identifier;if(r)if(e.trackedPointers[i]||(e.trackedPointers[i]=new v.default(i)),this.dispatchEvent(e,"pointerdown",t),"touch"===n.pointerType)this.dispatchEvent(e,"touchstart",t);else if("mouse"===n.pointerType||"pen"===n.pointerType){var o=2===n.button;o?e.trackedPointers[i].rightDown=!0:e.trackedPointers[i].leftDown=!0,this.dispatchEvent(e,o?"rightdown":"mousedown",t)}},e.prototype.onPointerComplete=function(t,e,r){for(var n=this.normalizeToPointerData(t),i=n.length,o=t.target!==this.interactionDOMElement?"outside":"",s=0;s<i;s++){var a=n[s],u=this.getInteractionDataForPointerId(a),h=this.configureInteractionEventForDOMEvent(this.eventData,a,u);if(h.data.originalEvent=t,this.processInteractive(h,this.renderer._lastObjectRendered,r,e||!o),this.emit(e?"pointercancel":"pointerup"+o,h),"mouse"===a.pointerType||"pen"===a.pointerType){var l=2===a.button;this.emit(l?"rightup"+o:"mouseup"+o,h)}else"touch"===a.pointerType&&(this.emit(e?"touchcancel":"touchend"+o,h),this.releaseInteractionDataForPointerId(a.pointerId,u))}},e.prototype.onPointerCancel=function(t){this.supportsTouchEvents&&"touch"===t.pointerType||this.onPointerComplete(t,!0,this.processPointerCancel)},e.prototype.processPointerCancel=function(t,e){var r=t.data,n=t.data.identifier;void 0!==e.trackedPointers[n]&&(delete e.trackedPointers[n],this.dispatchEvent(e,"pointercancel",t),"touch"===r.pointerType&&this.dispatchEvent(e,"touchcancel",t))},e.prototype.onPointerUp=function(t){this.supportsTouchEvents&&"touch"===t.pointerType||this.onPointerComplete(t,!1,this.processPointerUp)},e.prototype.processPointerUp=function(t,e,r){var n=t.data,i=t.data.identifier,o=e.trackedPointers[i],s="touch"===n.pointerType,a="mouse"===n.pointerType||"pen"===n.pointerType,u=!1;if(a){var h=2===n.button,l=v.default.FLAGS,c=h?l.RIGHT_DOWN:l.LEFT_DOWN,d=void 0!==o&&o.flags&c;r?(this.dispatchEvent(e,h?"rightup":"mouseup",t),d&&(this.dispatchEvent(e,h?"rightclick":"click",t),u=!0)):d&&this.dispatchEvent(e,h?"rightupoutside":"mouseupoutside",t),o&&(h?o.rightDown=!1:o.leftDown=!1)}r?(this.dispatchEvent(e,"pointerup",t),s&&this.dispatchEvent(e,"touchend",t),o&&(a&&!u||this.dispatchEvent(e,"pointertap",t),s&&(this.dispatchEvent(e,"tap",t),o.over=!1))):o&&(this.dispatchEvent(e,"pointerupoutside",t),s&&this.dispatchEvent(e,"touchendoutside",t)),o&&o.none&&delete e.trackedPointers[i]},e.prototype.onPointerMove=function(t){if(!this.supportsTouchEvents||"touch"!==t.pointerType){var e=this.normalizeToPointerData(t);"mouse"!==e[0].pointerType&&"pen"!==e[0].pointerType||(this.didMove=!0,this.cursor=null);for(var r=e.length,n=0;n<r;n++){var i=e[n],o=this.getInteractionDataForPointerId(i),s=this.configureInteractionEventForDOMEvent(this.eventData,i,o);s.data.originalEvent=t;var a="touch"!==i.pointerType||this.moveWhenInside;this.processInteractive(s,this.renderer._lastObjectRendered,this.processPointerMove,a),this.emit("pointermove",s),"touch"===i.pointerType&&this.emit("touchmove",s),"mouse"!==i.pointerType&&"pen"!==i.pointerType||this.emit("mousemove",s)}"mouse"===e[0].pointerType&&this.setCursorMode(this.cursor)}},e.prototype.processPointerMove=function(t,e,r){var n=t.data,i="touch"===n.pointerType,o="mouse"===n.pointerType||"pen"===n.pointerType;o&&this.processPointerOverOut(t,e,r),this.moveWhenInside&&!r||(this.dispatchEvent(e,"pointermove",t),i&&this.dispatchEvent(e,"touchmove",t),o&&this.dispatchEvent(e,"mousemove",t))},e.prototype.onPointerOut=function(t){if(!this.supportsTouchEvents||"touch"!==t.pointerType){var e=this.normalizeToPointerData(t),r=e[0];"mouse"===r.pointerType&&(this.mouseOverRenderer=!1,this.setCursorMode(null));var n=this.getInteractionDataForPointerId(r),i=this.configureInteractionEventForDOMEvent(this.eventData,r,n);i.data.originalEvent=r,this.processInteractive(i,this.renderer._lastObjectRendered,this.processPointerOverOut,!1),this.emit("pointerout",i),"mouse"===r.pointerType||"pen"===r.pointerType?this.emit("mouseout",i):this.releaseInteractionDataForPointerId(n.identifier)}},e.prototype.processPointerOverOut=function(t,e,r){var n=t.data,i=t.data.identifier,o="mouse"===n.pointerType||"pen"===n.pointerType,s=e.trackedPointers[i];r&&!s&&(s=e.trackedPointers[i]=new v.default(i)),void 0!==s&&(r&&this.mouseOverRenderer?(s.over||(s.over=!0,this.dispatchEvent(e,"pointerover",t),o&&this.dispatchEvent(e,"mouseover",t)),o&&null===this.cursor&&(this.cursor=e.cursor)):s.over&&(s.over=!1,this.dispatchEvent(e,"pointerout",this.eventData),o&&this.dispatchEvent(e,"mouseout",t),s.none&&delete e.trackedPointers[i]))},e.prototype.onPointerOver=function(t){var e=this.normalizeToPointerData(t),r=e[0],n=this.getInteractionDataForPointerId(r),i=this.configureInteractionEventForDOMEvent(this.eventData,r,n);i.data.originalEvent=r,"mouse"===r.pointerType&&(this.mouseOverRenderer=!0),this.emit("pointerover",i),"mouse"!==r.pointerType&&"pen"!==r.pointerType||this.emit("mouseover",i)},e.prototype.getInteractionDataForPointerId=function(t){var e=t.pointerId,r=void 0;return e===b||"mouse"===t.pointerType?r=this.mouse:this.activeInteractionData[e]?r=this.activeInteractionData[e]:(r=this.interactionDataPool.pop()||new c.default,r.identifier=e,this.activeInteractionData[e]=r),r.copyEvent(t),r},e.prototype.releaseInteractionDataForPointerId=function(t){var e=this.activeInteractionData[t];e&&(delete this.activeInteractionData[t],e.reset(),this.interactionDataPool.push(e))},e.prototype.configureInteractionEventForDOMEvent=function(t,e,r){return t.data=r,this.mapPositionToPoint(r.global,e.clientX,e.clientY),navigator.isCocoonJS&&"touch"===e.pointerType&&(r.global.x=r.global.x/this.resolution,r.global.y=r.global.y/this.resolution),"touch"===e.pointerType&&(e.globalX=r.global.x,e.globalY=r.global.y),r.originalEvent=e,t.reset(),t},e.prototype.normalizeToPointerData=function(t){var e=[];if(this.supportsTouchEvents&&t instanceof TouchEvent)for(var r=0,n=t.changedTouches.length;r<n;r++){var i=t.changedTouches[r];void 0===i.button&&(i.button=t.touches.length?1:0),void 0===i.buttons&&(i.buttons=t.touches.length?1:0),void 0===i.isPrimary&&(i.isPrimary=1===t.touches.length&&"touchstart"===t.type),void 0===i.width&&(i.width=i.radiusX||1),void 0===i.height&&(i.height=i.radiusY||1),void 0===i.tiltX&&(i.tiltX=0),void 0===i.tiltY&&(i.tiltY=0),void 0===i.pointerType&&(i.pointerType="touch"),void 0===i.pointerId&&(i.pointerId=i.identifier||0),void 0===i.pressure&&(i.pressure=i.force||.5),void 0===i.twist&&(i.twist=0),void 0===i.tangentialPressure&&(i.tangentialPressure=0),void 0===i.layerX&&(i.layerX=i.offsetX=i.clientX),void 0===i.layerY&&(i.layerY=i.offsetY=i.clientY),i.isNormalized=!0,e.push(i)}else!(t instanceof MouseEvent)||this.supportsPointerEvents&&t instanceof window.PointerEvent?e.push(t):(void 0===t.isPrimary&&(t.isPrimary=!0),void 0===t.width&&(t.width=1),void 0===t.height&&(t.height=1),void 0===t.tiltX&&(t.tiltX=0),
void 0===t.tiltY&&(t.tiltY=0),void 0===t.pointerType&&(t.pointerType="mouse"),void 0===t.pointerId&&(t.pointerId=b),void 0===t.pressure&&(t.pressure=.5),void 0===t.twist&&(t.twist=0),void 0===t.tangentialPressure&&(t.tangentialPressure=0),t.isNormalized=!0,e.push(t));return e},e.prototype.destroy=function(){this.removeEvents(),this.removeAllListeners(),this.renderer=null,this.mouse=null,this.eventData=null,this.interactionDOMElement=null,this.onPointerDown=null,this.processPointerDown=null,this.onPointerUp=null,this.processPointerUp=null,this.onPointerCancel=null,this.processPointerCancel=null,this.onPointerMove=null,this.processPointerMove=null,this.onPointerOut=null,this.processPointerOverOut=null,this.onPointerOver=null,this._tempPoint=null},e}(y.default);r.default=T,h.WebGLRenderer.registerPlugin("interaction",T),h.CanvasRenderer.registerPlugin("interaction",T)},{"../core":65,"./InteractionData":155,"./InteractionEvent":156,"./InteractionTrackingData":158,"./interactiveTarget":160,eventemitter3:3}],158:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),o=function(){function t(e){n(this,t),this._pointerId=e,this._flags=t.FLAGS.NONE}return t.prototype._doSet=function(t,e){this._flags=e?this._flags|t:this._flags&~t},i(t,[{key:"pointerId",get:function(){return this._pointerId}},{key:"flags",get:function(){return this._flags},set:function(t){this._flags=t}},{key:"none",get:function(){return this._flags===this.constructor.FLAGS.NONE}},{key:"over",get:function(){return 0!=(this._flags&this.constructor.FLAGS.OVER)},set:function(t){this._doSet(this.constructor.FLAGS.OVER,t)}},{key:"rightDown",get:function(){return 0!=(this._flags&this.constructor.FLAGS.RIGHT_DOWN)},set:function(t){this._doSet(this.constructor.FLAGS.RIGHT_DOWN,t)}},{key:"leftDown",get:function(){return 0!=(this._flags&this.constructor.FLAGS.LEFT_DOWN)},set:function(t){this._doSet(this.constructor.FLAGS.LEFT_DOWN,t)}}]),t}();r.default=o,o.FLAGS=Object.freeze({NONE:0,OVER:1,LEFT_DOWN:2,RIGHT_DOWN:4})},{}],159:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0;var i=t("./InteractionData");Object.defineProperty(r,"InteractionData",{enumerable:!0,get:function(){return n(i).default}});var o=t("./InteractionManager");Object.defineProperty(r,"InteractionManager",{enumerable:!0,get:function(){return n(o).default}});var s=t("./interactiveTarget");Object.defineProperty(r,"interactiveTarget",{enumerable:!0,get:function(){return n(s).default}});var a=t("./InteractionTrackingData");Object.defineProperty(r,"InteractionTrackingData",{enumerable:!0,get:function(){return n(a).default}});var u=t("./InteractionEvent");Object.defineProperty(r,"InteractionEvent",{enumerable:!0,get:function(){return n(u).default}})},{"./InteractionData":155,"./InteractionEvent":156,"./InteractionManager":157,"./InteractionTrackingData":158,"./interactiveTarget":160}],160:[function(t,e,r){"use strict";r.__esModule=!0,r.default={interactive:!1,interactiveChildren:!0,hitArea:null,get buttonMode(){return"pointer"===this.cursor},set buttonMode(t){t?this.cursor="pointer":"pointer"===this.cursor&&(this.cursor=null)},cursor:null,get trackedPointers(){return void 0===this._trackedPointers&&(this._trackedPointers={}),this._trackedPointers},_trackedPointers:void 0}},{}],161:[function(t,e,r){"use strict";function n(t,e){t.bitmapFont=a.BitmapText.registerFont(t.data,e)}r.__esModule=!0,r.parse=n,r.default=function(){return function(t,e){if(!t.data||t.type!==s.Resource.TYPE.XML)return void e();if(0===t.data.getElementsByTagName("page").length||0===t.data.getElementsByTagName("info").length||null===t.data.getElementsByTagName("info")[0].getAttribute("face"))return void e();var r=t.isDataUrl?"":o.dirname(t.url);t.isDataUrl&&("."===r&&(r=""),this.baseUrl&&r&&"/"===this.baseUrl.charAt(this.baseUrl.length-1)&&(r+="/")),(r=r.replace(this.baseUrl,""))&&"/"!==r.charAt(r.length-1)&&(r+="/");for(var i=t.data.getElementsByTagName("page"),a={},u=function(r){a[r.metadata.pageFile]=r.texture,Object.keys(a).length===i.length&&(n(t,a),e())},h=0;h<i.length;++h){var l=i[h].getAttribute("file"),c=r+l,d=!1;for(var f in this.resources){var p=this.resources[f];if(p.url===c){p.metadata.pageFile=l,p.texture?u(p):p.onAfterMiddleware.add(u),d=!0;break}}if(!d){var v={crossOrigin:t.crossOrigin,loadType:s.Resource.LOAD_TYPE.IMAGE,metadata:Object.assign({pageFile:l},t.metadata.imageMetadata),parentResource:t};this.add(c,v,u)}}}};var i=t("path"),o=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(i),s=t("resource-loader"),a=t("../extras")},{"../extras":141,path:8,"resource-loader":36}],162:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0,r.shared=r.Resource=r.textureParser=r.getResourcePath=r.spritesheetParser=r.parseBitmapFontData=r.bitmapFontParser=r.Loader=void 0;var i=t("./bitmapFontParser");Object.defineProperty(r,"bitmapFontParser",{enumerable:!0,get:function(){return n(i).default}}),Object.defineProperty(r,"parseBitmapFontData",{enumerable:!0,get:function(){return i.parse}});var o=t("./spritesheetParser");Object.defineProperty(r,"spritesheetParser",{enumerable:!0,get:function(){return n(o).default}}),Object.defineProperty(r,"getResourcePath",{enumerable:!0,get:function(){return o.getResourcePath}});var s=t("./textureParser");Object.defineProperty(r,"textureParser",{enumerable:!0,get:function(){return n(s).default}});var a=t("resource-loader");Object.defineProperty(r,"Resource",{enumerable:!0,get:function(){return a.Resource}});var u=t("../core/Application"),h=n(u),l=t("./loader"),c=n(l);r.Loader=c.default;var d=new c.default;d.destroy=function(){},r.shared=d;var f=h.default.prototype;f._loader=null,Object.defineProperty(f,"loader",{get:function(){if(!this._loader){var t=this._options.sharedLoader;this._loader=t?d:new c.default}return this._loader}}),f._parentDestroy=f.destroy,f.destroy=function(t,e){this._loader&&(this._loader.destroy(),this._loader=null),this._parentDestroy(t,e)}},{"../core/Application":43,"./bitmapFontParser":161,"./loader":163,"./spritesheetParser":164,"./textureParser":165,"resource-loader":36}],163:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("resource-loader"),u=n(a),h=t("resource-loader/lib/middlewares/parsing/blob"),l=t("eventemitter3"),c=n(l),d=t("./textureParser"),f=n(d),p=t("./spritesheetParser"),v=n(p),g=t("./bitmapFontParser"),y=n(g),m=function(t){function e(r,n){i(this,e);var s=o(this,t.call(this,r,n));c.default.call(s);for(var a=0;a<e._pixiMiddleware.length;++a)s.use(e._pixiMiddleware[a]());return s.onStart.add(function(t){return s.emit("start",t)}),s.onProgress.add(function(t,e){return s.emit("progress",t,e)}),s.onError.add(function(t,e,r){return s.emit("error",t,e,r)}),s.onLoad.add(function(t,e){return s.emit("load",t,e)}),s.onComplete.add(function(t,e){return s.emit("complete",t,e)}),s}return s(e,t),e.addPixiMiddleware=function(t){e._pixiMiddleware.push(t)},e.prototype.destroy=function(){this.removeAllListeners(),this.reset()},e}(u.default);r.default=m;for(var _ in c.default.prototype)m.prototype[_]=c.default.prototype[_];m._pixiMiddleware=[h.blobMiddlewareFactory,f.default,v.default,y.default];var b=u.default.Resource;b.setExtensionXhrType("fnt",b.XHR_RESPONSE_TYPE.DOCUMENT)},{"./bitmapFontParser":161,"./spritesheetParser":164,"./textureParser":165,eventemitter3:3,"resource-loader":36,"resource-loader/lib/middlewares/parsing/blob":37}],164:[function(t,e,r){"use strict";function n(t,e){return t.isDataUrl?t.data.meta.image:s.default.resolve(t.url.replace(e,""),t.data.meta.image)}r.__esModule=!0,r.default=function(){return function(t,e){var r=t.name+"_image";if(!t.data||t.type!==i.Resource.TYPE.JSON||!t.data.frames||this.resources[r])return void e();var o={crossOrigin:t.crossOrigin,metadata:t.metadata.imageMetadata,parentResource:t},s=n(t,this.baseUrl);this.add(r,s,o,function(r){if(r.error)return void e(r.error);var n=new a.Spritesheet(r.texture.baseTexture,t.data,t.url);n.parse(function(){t.spritesheet=n,t.textures=n.textures,e()})})}},r.getResourcePath=n;var i=t("resource-loader"),o=t("url"),s=function(t){return t&&t.__esModule?t:{default:t}}(o),a=t("../core")},{"../core":65,"resource-loader":36,url:38}],165:[function(t,e,r){"use strict";r.__esModule=!0,r.default=function(){return function(t,e){t.data&&t.type===n.Resource.TYPE.IMAGE&&(t.texture=o.default.fromLoader(t.data,t.url,t.name)),e()}};var n=t("resource-loader"),i=t("../core/textures/Texture"),o=function(t){return t&&t.__esModule?t:{default:t}}(i)},{"../core/textures/Texture":115,"resource-loader":36}],166:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=t("../core/textures/Texture"),l=function(t){return t&&t.__esModule?t:{default:t}}(h),c=new u.Point,d=new u.Polygon,f=function(t){function e(r,o,s,a,h){n(this,e);var c=i(this,t.call(this));return c._texture=r||l.default.EMPTY,c.uvs=s||new Float32Array([0,0,1,0,1,1,0,1]),c.vertices=o||new Float32Array([0,0,100,0,100,100,0,100]),c.indices=a||new Uint16Array([0,1,3,2]),c.dirty=0,c.indexDirty=0,c.vertexDirty=0,c.autoUpdate=!0,c.blendMode=u.BLEND_MODES.NORMAL,c.canvasPadding=u.settings.MESH_CANVAS_PADDING,c.drawMode=h||e.DRAW_MODES.TRIANGLE_MESH,c.shader=null,c.tintRgb=new Float32Array([1,1,1]),c._glDatas={},c._uvTransform=new u.TextureMatrix(c._texture),c.uploadUvTransform=!1,c.pluginName="mesh",c}return o(e,t),e.prototype._renderWebGL=function(t){this.refresh(),t.setObjectRenderer(t.plugins[this.pluginName]),t.plugins[this.pluginName].render(this)},e.prototype._renderCanvas=function(t){this.refresh(),t.plugins[this.pluginName].render(this)},e.prototype._onTextureUpdate=function(){this._uvTransform.texture=this._texture,this.refresh()},e.prototype.multiplyUvs=function(){this.uploadUvTransform||this._uvTransform.multiplyUvs(this.uvs)},e.prototype.refresh=function(t){this.autoUpdate&&this.vertexDirty++,this._uvTransform.update(t)&&this._refresh()},e.prototype._refresh=function(){},e.prototype._calculateBounds=function(){this._bounds.addVertices(this.transform,this.vertices,0,this.vertices.length)},e.prototype.containsPoint=function(t){if(!this.getBounds().contains(t.x,t.y))return!1;this.worldTransform.applyInverse(t,c);for(var r=this.vertices,n=d.points,i=this.indices,o=this.indices.length,s=this.drawMode===e.DRAW_MODES.TRIANGLES?3:1,a=0;a+2<o;a+=s){var u=2*i[a],h=2*i[a+1],l=2*i[a+2];if(n[0]=r[u],n[1]=r[u+1],n[2]=r[h],n[3]=r[h+1],n[4]=r[l],n[5]=r[l+1],d.contains(c.x,c.y))return!0}return!1},e.prototype.destroy=function(e){for(var r in this._glDatas){var n=this._glDatas[r];n.destroy?n.destroy():(n.vertexBuffer&&(n.vertexBuffer.destroy(),n.vertexBuffer=null),n.indexBuffer&&(n.indexBuffer.destroy(),n.indexBuffer=null),n.uvBuffer&&(n.uvBuffer.destroy(),n.uvBuffer=null),n.vao&&(n.vao.destroy(),n.vao=null))}this._glDatas=null,t.prototype.destroy.call(this,e)},s(e,[{key:"texture",get:function(){return this._texture},set:function(t){this._texture!==t&&(this._texture=t,t&&(t.baseTexture.hasLoaded?this._onTextureUpdate():t.once("update",this._onTextureUpdate,this)))}},{key:"tint",get:function(){return u.utils.rgb2hex(this.tintRgb)},set:function(t){this.tintRgb=u.utils.hex2rgb(t,this.tintRgb)}}]),e}(u.Container);r.default=f,f.DRAW_MODES={TRIANGLE_MESH:0,TRIANGLES:1}},{"../core":65,"../core/textures/Texture":115}],167:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),u=t("./Plane"),h=n(u),l=t("../core/sprites/canvas/CanvasTinter"),c=n(l),d=10,f=function(t){function e(r,n,s,a,u){i(this,e);var h=o(this,t.call(this,r,4,4));return h._origWidth=r.orig.width,h._origHeight=r.orig.height,h._width=h._origWidth,h._height=h._origHeight,h._leftWidth=void 0!==n?n:d,h._rightWidth=void 0!==a?a:d,h._topHeight=void 0!==s?s:d,h._bottomHeight=void 0!==u?u:d,h._cachedTint=16777215,h._tintedTexture=null,h._canvasUvs=null,h.refresh(!0),h}return s(e,t),e.prototype.updateHorizontalVertices=function(){var t=this.vertices,e=this._topHeight+this._bottomHeight,r=this._height>e?1:this._height/e;t[9]=t[11]=t[13]=t[15]=this._topHeight*r,t[17]=t[19]=t[21]=t[23]=this._height-this._bottomHeight*r,t[25]=t[27]=t[29]=t[31]=this._height},e.prototype.updateVerticalVertices=function(){var t=this.vertices,e=this._leftWidth+this._rightWidth,r=this._width>e?1:this._width/e;t[2]=t[10]=t[18]=t[26]=this._leftWidth*r,t[4]=t[12]=t[20]=t[28]=this._width-this._rightWidth*r,t[6]=t[14]=t[22]=t[30]=this._width},e.prototype._renderCanvas=function(t){var e=t.context,r=this.worldTransform,n=t.resolution,i=16777215!==this.tint,o=this._texture;i&&this._cachedTint!==this.tint&&(this._cachedTint=this.tint,this._tintedTexture=c.default.getTintedTexture(this,this.tint));var s=i?this._tintedTexture:o.baseTexture.source;this._canvasUvs||(this._canvasUvs=[0,0,0,0,0,0,0,0]);var a=this.vertices,u=this._canvasUvs,h=i?0:o.frame.x,l=i?0:o.frame.y,d=h+o.frame.width,f=l+o.frame.height;u[0]=h,u[1]=h+this._leftWidth,u[2]=d-this._rightWidth,u[3]=d,u[4]=l,u[5]=l+this._topHeight,u[6]=f-this._bottomHeight,u[7]=f;for(var p=0;p<8;p++)u[p]*=o.baseTexture.resolution;e.globalAlpha=this.worldAlpha,t.setBlendMode(this.blendMode),t.roundPixels?e.setTransform(r.a*n,r.b*n,r.c*n,r.d*n,r.tx*n|0,r.ty*n|0):e.setTransform(r.a*n,r.b*n,r.c*n,r.d*n,r.tx*n,r.ty*n);for(var v=0;v<3;v++)for(var g=0;g<3;g++){var y=2*g+8*v,m=Math.max(1,u[g+1]-u[g]),_=Math.max(1,u[v+5]-u[v+4]),b=Math.max(1,a[y+10]-a[y]),x=Math.max(1,a[y+11]-a[y+1]);e.drawImage(s,u[g],u[v+4],m,_,a[y],a[y+1],b,x)}},e.prototype._refresh=function(){t.prototype._refresh.call(this);var e=this.uvs,r=this._texture;this._origWidth=r.orig.width,this._origHeight=r.orig.height;var n=1/this._origWidth,i=1/this._origHeight;e[0]=e[8]=e[16]=e[24]=0,e[1]=e[3]=e[5]=e[7]=0,e[6]=e[14]=e[22]=e[30]=1,e[25]=e[27]=e[29]=e[31]=1,e[2]=e[10]=e[18]=e[26]=n*this._leftWidth,e[4]=e[12]=e[20]=e[28]=1-n*this._rightWidth,e[9]=e[11]=e[13]=e[15]=i*this._topHeight,e[17]=e[19]=e[21]=e[23]=1-i*this._bottomHeight,this.updateHorizontalVertices(),this.updateVerticalVertices(),this.dirty++,this.multiplyUvs()},a(e,[{key:"width",get:function(){return this._width},set:function(t){this._width=t,this._refresh()}},{key:"height",get:function(){return this._height},set:function(t){this._height=t,this._refresh()}},{key:"leftWidth",get:function(){return this._leftWidth},set:function(t){this._leftWidth=t,this._refresh()}},{key:"rightWidth",get:function(){return this._rightWidth},set:function(t){this._rightWidth=t,this._refresh()}},{key:"topHeight",get:function(){return this._topHeight},set:function(t){this._topHeight=t,this._refresh()}},{key:"bottomHeight",get:function(){return this._bottomHeight},set:function(t){this._bottomHeight=t,this._refresh()}}]),e}(h.default);r.default=f},{"../core/sprites/canvas/CanvasTinter":104,"./Plane":168}],168:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=t("./Mesh"),a=function(t){return t&&t.__esModule?t:{default:t}}(s),u=function(t){function e(r,o,s){n(this,e);var u=i(this,t.call(this,r));return u._ready=!0,u.verticesX=o||10,u.verticesY=s||10,u.drawMode=a.default.DRAW_MODES.TRIANGLES,u.refresh(),u}return o(e,t),e.prototype._refresh=function(){for(var t=this._texture,e=this.verticesX*this.verticesY,r=[],n=[],i=[],o=[],s=this.verticesX-1,a=this.verticesY-1,u=t.width/s,h=t.height/a,l=0;l<e;l++){var c=l%this.verticesX,d=l/this.verticesX|0;r.push(c*u,d*h),i.push(c/s,d/a)}for(var f=s*a,p=0;p<f;p++){var v=p%s,g=p/s|0,y=g*this.verticesX+v,m=g*this.verticesX+v+1,_=(g+1)*this.verticesX+v,b=(g+1)*this.verticesX+v+1;o.push(y,m,_),o.push(m,b,_)}this.vertices=new Float32Array(r),this.uvs=new Float32Array(i),this.colors=new Float32Array(n),this.indices=new Uint16Array(o),this.dirty++,this.indexDirty++,this.multiplyUvs()},e.prototype._onTextureUpdate=function(){a.default.prototype._onTextureUpdate.call(this),this._ready&&this.refresh()},e}(a.default);r.default=u},{"./Mesh":166}],169:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=t("./Mesh"),a=function(t){return t&&t.__esModule?t:{default:t}}(s),u=function(t){function e(r,o){n(this,e);var s=i(this,t.call(this,r));return s.points=o,s.vertices=new Float32Array(4*o.length),s.uvs=new Float32Array(4*o.length),s.colors=new Float32Array(2*o.length),s.indices=new Uint16Array(2*o.length),s.autoUpdate=!0,s.refresh(),s}return o(e,t),e.prototype._refresh=function(){var t=this.points;if(!(t.length<1)&&this._texture._uvs){this.vertices.length/4!==t.length&&(this.vertices=new Float32Array(4*t.length),this.uvs=new Float32Array(4*t.length),this.colors=new Float32Array(2*t.length),this.indices=new Uint16Array(2*t.length));var e=this.uvs,r=this.indices,n=this.colors;e[0]=0,e[1]=0,e[2]=0,e[3]=1,n[0]=1,n[1]=1,r[0]=0,r[1]=1;for(var i=t.length,o=1;o<i;o++){var s=4*o,a=o/(i-1);e[s]=a,e[s+1]=0,e[s+2]=a,e[s+3]=1,s=2*o,n[s]=1,n[s+1]=1,s=2*o,r[s]=s,r[s+1]=s+1}this.dirty++,this.indexDirty++,this.multiplyUvs(),this.refreshVertices()}},e.prototype.refreshVertices=function(){var t=this.points;if(!(t.length<1))for(var e=t[0],r=void 0,n=0,i=0,o=this.vertices,s=t.length,a=0;a<s;a++){var u=t[a],h=4*a;r=a<t.length-1?t[a+1]:u,i=-(r.x-e.x),n=r.y-e.y;var l=10*(1-a/(s-1));l>1&&(l=1);var c=Math.sqrt(n*n+i*i),d=this._texture.height/2;n/=c,i/=c,n*=d,i*=d,o[h]=u.x+n,o[h+1]=u.y+i,o[h+2]=u.x-n,o[h+3]=u.y-i,e=u}},e.prototype.updateTransform=function(){this.autoUpdate&&this.refreshVertices(),this.containerUpdateTransform()},e}(a.default);r.default=u},{"./Mesh":166}],170:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=t("../../core"),o=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(i),s=t("../Mesh"),a=function(t){return t&&t.__esModule?t:{default:t}}(s),u=function(){function t(e){n(this,t),this.renderer=e}return t.prototype.render=function(t){var e=this.renderer,r=e.context,n=t.worldTransform,i=e.resolution;e.roundPixels?r.setTransform(n.a*i,n.b*i,n.c*i,n.d*i,n.tx*i|0,n.ty*i|0):r.setTransform(n.a*i,n.b*i,n.c*i,n.d*i,n.tx*i,n.ty*i),e.context.globalAlpha=t.worldAlpha,e.setBlendMode(t.blendMode),t.drawMode===a.default.DRAW_MODES.TRIANGLE_MESH?this._renderTriangleMesh(t):this._renderTriangles(t)},t.prototype._renderTriangleMesh=function(t){for(var e=t.vertices.length/2,r=0;r<e-2;r++){var n=2*r;this._renderDrawTriangle(t,n,n+2,n+4)}},t.prototype._renderTriangles=function(t){for(var e=t.indices,r=e.length,n=0;n<r;n+=3){var i=2*e[n],o=2*e[n+1],s=2*e[n+2];this._renderDrawTriangle(t,i,o,s)}},t.prototype._renderDrawTriangle=function(t,e,r,n){var i=this.renderer.context,o=t.uvs,s=t.vertices,a=t._texture;if(a.valid){var u=a.baseTexture,h=u.source,l=u.width,c=u.height,d=void 0,f=void 0,p=void 0,v=void 0,g=void 0,y=void 0;if(t.uploadUvTransform){var m=t._uvTransform.mapCoord;d=(o[e]*m.a+o[e+1]*m.c+m.tx)*u.width,f=(o[r]*m.a+o[r+1]*m.c+m.tx)*u.width,p=(o[n]*m.a+o[n+1]*m.c+m.tx)*u.width,v=(o[e]*m.b+o[e+1]*m.d+m.ty)*u.height,g=(o[r]*m.b+o[r+1]*m.d+m.ty)*u.height,y=(o[n]*m.b+o[n+1]*m.d+m.ty)*u.height}else d=o[e]*u.width,f=o[r]*u.width,p=o[n]*u.width,v=o[e+1]*u.height,g=o[r+1]*u.height,y=o[n+1]*u.height;var _=s[e],b=s[r],x=s[n],T=s[e+1],w=s[r+1],E=s[n+1],S=t.canvasPadding/this.renderer.resolution;if(S>0){var O=S/Math.abs(t.worldTransform.a),M=S/Math.abs(t.worldTransform.d),P=(_+b+x)/3,C=(T+w+E)/3,R=_-P,A=T-C,I=Math.sqrt(R*R+A*A);_=P+R/I*(I+O),T=C+A/I*(I+M),R=b-P,A=w-C,I=Math.sqrt(R*R+A*A),b=P+R/I*(I+O),w=C+A/I*(I+M),R=x-P,A=E-C,I=Math.sqrt(R*R+A*A),x=P+R/I*(I+O),E=C+A/I*(I+M)}i.save(),i.beginPath(),i.moveTo(_,T),i.lineTo(b,w),i.lineTo(x,E),i.closePath(),i.clip();var D=d*g+v*p+f*y-g*p-v*f-d*y,L=_*g+v*x+b*y-g*x-v*b-_*y,N=d*b+_*p+f*x-b*p-_*f-d*x,B=d*g*x+v*b*p+_*f*y-_*g*p-v*f*x-d*b*y,k=T*g+v*E+w*y-g*E-v*w-T*y,F=d*w+T*p+f*E-w*p-T*f-d*E,j=d*g*E+v*w*p+T*f*y-T*g*p-v*f*E-d*w*y;i.transform(L/D,k/D,N/D,F/D,B/D,j/D),i.drawImage(h,0,0,l*u.resolution,c*u.resolution,0,0,l,c),i.restore(),this.renderer.invalidateBlendMode()}},t.prototype.renderMeshFlat=function(t){var e=this.renderer.context,r=t.vertices,n=r.length/2;e.beginPath();for(var i=1;i<n-2;++i){var o=2*i,s=r[o],a=r[o+1],u=r[o+2],h=r[o+3],l=r[o+4],c=r[o+5];e.moveTo(s,a),e.lineTo(u,h),e.lineTo(l,c)}e.fillStyle="#FF0000",e.fill(),e.closePath()},t.prototype.destroy=function(){this.renderer=null},t}();r.default=u,o.CanvasRenderer.registerPlugin("mesh",u)},{"../../core":65,"../Mesh":166}],171:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0;var i=t("./Mesh");Object.defineProperty(r,"Mesh",{enumerable:!0,get:function(){return n(i).default}});var o=t("./webgl/MeshRenderer");Object.defineProperty(r,"MeshRenderer",{enumerable:!0,get:function(){return n(o).default}});var s=t("./canvas/CanvasMeshRenderer");Object.defineProperty(r,"CanvasMeshRenderer",{enumerable:!0,get:function(){return n(s).default}});var a=t("./Plane");Object.defineProperty(r,"Plane",{enumerable:!0,get:function(){return n(a).default}});var u=t("./NineSlicePlane");Object.defineProperty(r,"NineSlicePlane",{enumerable:!0,get:function(){return n(u).default}});var h=t("./Rope");Object.defineProperty(r,"Rope",{enumerable:!0,get:function(){return n(h).default}})},{"./Mesh":166,"./NineSlicePlane":167,"./Plane":168,"./Rope":169,"./canvas/CanvasMeshRenderer":170,"./webgl/MeshRenderer":172}],172:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("../../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=t("pixi-gl-core"),l=n(h),c=t("../Mesh"),d=n(c),f=(t("path"),u.Matrix.IDENTITY),p=function(t){function e(r){i(this,e);var n=o(this,t.call(this,r));return n.shader=null,n}return s(e,t),e.prototype.onContextChange=function(){var t=this.renderer.gl;this.shader=new u.Shader(t,"attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n","varying vec2 vTextureCoord;\nuniform vec4 uColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;\n}\n")},e.prototype.render=function(t){var e=this.renderer,r=e.gl,n=t._texture;if(n.valid){var i=t._glDatas[e.CONTEXT_UID];i||(e.bindVao(null),i={shader:this.shader,vertexBuffer:l.default.GLBuffer.createVertexBuffer(r,t.vertices,r.STREAM_DRAW),uvBuffer:l.default.GLBuffer.createVertexBuffer(r,t.uvs,r.STREAM_DRAW),indexBuffer:l.default.GLBuffer.createIndexBuffer(r,t.indices,r.STATIC_DRAW),vao:null,dirty:t.dirty,indexDirty:t.indexDirty,vertexDirty:t.vertexDirty},i.vao=new l.default.VertexArrayObject(r).addIndex(i.indexBuffer).addAttribute(i.vertexBuffer,i.shader.attributes.aVertexPosition,r.FLOAT,!1,8,0).addAttribute(i.uvBuffer,i.shader.attributes.aTextureCoord,r.FLOAT,!1,8,0),t._glDatas[e.CONTEXT_UID]=i),e.bindVao(i.vao),t.dirty!==i.dirty&&(i.dirty=t.dirty,i.uvBuffer.upload(t.uvs)),t.indexDirty!==i.indexDirty&&(i.indexDirty=t.indexDirty,i.indexBuffer.upload(t.indices)),t.vertexDirty!==i.vertexDirty&&(i.vertexDirty=t.vertexDirty,i.vertexBuffer.upload(t.vertices)),e.bindShader(i.shader),i.shader.uniforms.uSampler=e.bindTexture(n),e.state.setBlendMode(u.utils.correctBlendMode(t.blendMode,n.baseTexture.premultipliedAlpha)),i.shader.uniforms.uTransform&&(t.uploadUvTransform?i.shader.uniforms.uTransform=t._uvTransform.mapCoord.toArray(!0):i.shader.uniforms.uTransform=f.toArray(!0)),i.shader.uniforms.translationMatrix=t.worldTransform.toArray(!0),i.shader.uniforms.uColor=u.utils.premultiplyRgba(t.tintRgb,t.worldAlpha,i.shader.uniforms.uColor,n.baseTexture.premultipliedAlpha);var o=t.drawMode===d.default.DRAW_MODES.TRIANGLE_MESH?r.TRIANGLE_STRIP:r.TRIANGLES;i.vao.draw(o,t.indices.length,0)}},e}(u.ObjectRenderer);r.default=p,u.WebGLRenderer.registerPlugin("mesh",p)},{"../../core":65,"../Mesh":166,path:8,"pixi-gl-core":15}],173:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),a=t("../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=t("../core/utils"),l=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1500,o=arguments[1],s=arguments.length>2&&void 0!==arguments[2]?arguments[2]:16384,a=arguments.length>3&&void 0!==arguments[3]&&arguments[3];n(this,e);var h=i(this,t.call(this));return s>16384&&(s=16384),s>r&&(s=r),h._properties=[!1,!0,!1,!1,!1],h._maxSize=r,h._batchSize=s,h._glBuffers={},h._bufferUpdateIDs=[],h._updateID=0,h.interactiveChildren=!1,h.blendMode=u.BLEND_MODES.NORMAL,h.autoResize=a,h.roundPixels=!0,h.baseTexture=null,h.setProperties(o),h._tint=0,h.tintRgb=new Float32Array(4),h.tint=16777215,h}return o(e,t),e.prototype.setProperties=function(t){t&&(this._properties[0]="vertices"in t||"scale"in t?!!t.vertices||!!t.scale:this._properties[0],this._properties[1]="position"in t?!!t.position:this._properties[1],this._properties[2]="rotation"in t?!!t.rotation:this._properties[2],this._properties[3]="uvs"in t?!!t.uvs:this._properties[3],this._properties[4]="tint"in t||"alpha"in t?!!t.tint||!!t.alpha:this._properties[4])},e.prototype.updateTransform=function(){this.displayObjectUpdateTransform()},e.prototype.renderWebGL=function(t){var e=this;this.visible&&!(this.worldAlpha<=0)&&this.children.length&&this.renderable&&(this.baseTexture||(this.baseTexture=this.children[0]._texture.baseTexture,this.baseTexture.hasLoaded||this.baseTexture.once("update",function(){return e.onChildrenChange(0)})),t.setObjectRenderer(t.plugins.particle),t.plugins.particle.render(this))},e.prototype.onChildrenChange=function(t){for(var e=Math.floor(t/this._batchSize);this._bufferUpdateIDs.length<e;)this._bufferUpdateIDs.push(0);this._bufferUpdateIDs[e]=++this._updateID},e.prototype.renderCanvas=function(t){if(this.visible&&!(this.worldAlpha<=0)&&this.children.length&&this.renderable){var e=t.context,r=this.worldTransform,n=!0,i=0,o=0,s=0,a=0;t.setBlendMode(this.blendMode),e.globalAlpha=this.worldAlpha,this.displayObjectUpdateTransform();for(var u=0;u<this.children.length;++u){var h=this.children[u];if(h.visible){var l=h._texture.frame;if(e.globalAlpha=this.worldAlpha*h.alpha,h.rotation%(2*Math.PI)==0)n&&(e.setTransform(r.a,r.b,r.c,r.d,r.tx*t.resolution,r.ty*t.resolution),n=!1),i=h.anchor.x*(-l.width*h.scale.x)+h.position.x+.5,
o=h.anchor.y*(-l.height*h.scale.y)+h.position.y+.5,s=l.width*h.scale.x,a=l.height*h.scale.y;else{n||(n=!0),h.displayObjectUpdateTransform();var c=h.worldTransform;t.roundPixels?e.setTransform(c.a,c.b,c.c,c.d,c.tx*t.resolution|0,c.ty*t.resolution|0):e.setTransform(c.a,c.b,c.c,c.d,c.tx*t.resolution,c.ty*t.resolution),i=h.anchor.x*-l.width+.5,o=h.anchor.y*-l.height+.5,s=l.width,a=l.height}var d=h._texture.baseTexture.resolution;e.drawImage(h._texture.baseTexture.source,l.x*d,l.y*d,l.width*d,l.height*d,i*t.resolution,o*t.resolution,s*t.resolution,a*t.resolution)}}}},e.prototype.destroy=function(e){if(t.prototype.destroy.call(this,e),this._buffers)for(var r=0;r<this._buffers.length;++r)this._buffers[r].destroy();this._properties=null,this._buffers=null,this._bufferUpdateIDs=null},s(e,[{key:"tint",get:function(){return this._tint},set:function(t){this._tint=t,(0,h.hex2rgb)(t,this.tintRgb)}}]),e}(u.Container);r.default=l},{"../core":65,"../core/utils":125}],174:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0;var i=t("./ParticleContainer");Object.defineProperty(r,"ParticleContainer",{enumerable:!0,get:function(){return n(i).default}});var o=t("./webgl/ParticleRenderer");Object.defineProperty(r,"ParticleRenderer",{enumerable:!0,get:function(){return n(o).default}})},{"./ParticleContainer":173,"./webgl/ParticleRenderer":176}],175:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var o=t("pixi-gl-core"),s=n(o),a=t("../../core/utils/createIndicesForQuads"),u=n(a),h=function(){function t(e,r,n,o){i(this,t),this.gl=e,this.size=o,this.dynamicProperties=[],this.staticProperties=[];for(var s=0;s<r.length;++s){var a=r[s];a={attribute:a.attribute,size:a.size,uploadFunction:a.uploadFunction,unsignedByte:a.unsignedByte,offset:a.offset},n[s]?this.dynamicProperties.push(a):this.staticProperties.push(a)}this.staticStride=0,this.staticBuffer=null,this.staticData=null,this.staticDataUint32=null,this.dynamicStride=0,this.dynamicBuffer=null,this.dynamicData=null,this.dynamicDataUint32=null,this._updateID=0,this.initBuffers()}return t.prototype.initBuffers=function(){var t=this.gl,e=0;this.indices=(0,u.default)(this.size),this.indexBuffer=s.default.GLBuffer.createIndexBuffer(t,this.indices,t.STATIC_DRAW),this.dynamicStride=0;for(var r=0;r<this.dynamicProperties.length;++r){var n=this.dynamicProperties[r];n.offset=e,e+=n.size,this.dynamicStride+=n.size}var i=new ArrayBuffer(this.size*this.dynamicStride*4*4);this.dynamicData=new Float32Array(i),this.dynamicDataUint32=new Uint32Array(i),this.dynamicBuffer=s.default.GLBuffer.createVertexBuffer(t,i,t.STREAM_DRAW);var o=0;this.staticStride=0;for(var a=0;a<this.staticProperties.length;++a){var h=this.staticProperties[a];h.offset=o,o+=h.size,this.staticStride+=h.size}var l=new ArrayBuffer(this.size*this.staticStride*4*4);this.staticData=new Float32Array(l),this.staticDataUint32=new Uint32Array(l),this.staticBuffer=s.default.GLBuffer.createVertexBuffer(t,l,t.STATIC_DRAW),this.vao=new s.default.VertexArrayObject(t).addIndex(this.indexBuffer);for(var c=0;c<this.dynamicProperties.length;++c){var d=this.dynamicProperties[c];d.unsignedByte?this.vao.addAttribute(this.dynamicBuffer,d.attribute,t.UNSIGNED_BYTE,!0,4*this.dynamicStride,4*d.offset):this.vao.addAttribute(this.dynamicBuffer,d.attribute,t.FLOAT,!1,4*this.dynamicStride,4*d.offset)}for(var f=0;f<this.staticProperties.length;++f){var p=this.staticProperties[f];p.unsignedByte?this.vao.addAttribute(this.staticBuffer,p.attribute,t.UNSIGNED_BYTE,!0,4*this.staticStride,4*p.offset):this.vao.addAttribute(this.staticBuffer,p.attribute,t.FLOAT,!1,4*this.staticStride,4*p.offset)}},t.prototype.uploadDynamic=function(t,e,r){for(var n=0;n<this.dynamicProperties.length;n++){var i=this.dynamicProperties[n];i.uploadFunction(t,e,r,i.unsignedByte?this.dynamicDataUint32:this.dynamicData,this.dynamicStride,i.offset)}this.dynamicBuffer.upload()},t.prototype.uploadStatic=function(t,e,r){for(var n=0;n<this.staticProperties.length;n++){var i=this.staticProperties[n];i.uploadFunction(t,e,r,i.unsignedByte?this.staticDataUint32:this.staticData,this.staticStride,i.offset)}this.staticBuffer.upload()},t.prototype.destroy=function(){this.dynamicProperties=null,this.dynamicBuffer.destroy(),this.dynamicBuffer=null,this.dynamicData=null,this.dynamicDataUint32=null,this.staticProperties=null,this.staticBuffer.destroy(),this.staticBuffer=null,this.staticData=null,this.staticDataUint32=null},t}();r.default=h},{"../../core/utils/createIndicesForQuads":123,"pixi-gl-core":15}],176:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var a=t("../../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=t("./ParticleShader"),l=n(h),c=t("./ParticleBuffer"),d=n(c),f=t("../../core/utils"),p=function(t){function e(r){i(this,e);var n=o(this,t.call(this,r));return n.shader=null,n.indexBuffer=null,n.properties=null,n.tempMatrix=new u.Matrix,n.CONTEXT_UID=0,n}return s(e,t),e.prototype.onContextChange=function(){var t=this.renderer.gl;this.CONTEXT_UID=this.renderer.CONTEXT_UID,this.shader=new l.default(t),this.properties=[{attribute:this.shader.attributes.aVertexPosition,size:2,uploadFunction:this.uploadVertices,offset:0},{attribute:this.shader.attributes.aPositionCoord,size:2,uploadFunction:this.uploadPosition,offset:0},{attribute:this.shader.attributes.aRotation,size:1,uploadFunction:this.uploadRotation,offset:0},{attribute:this.shader.attributes.aTextureCoord,size:2,uploadFunction:this.uploadUvs,offset:0},{attribute:this.shader.attributes.aColor,size:1,unsignedByte:!0,uploadFunction:this.uploadTint,offset:0}]},e.prototype.start=function(){this.renderer.bindShader(this.shader)},e.prototype.render=function(t){var e=t.children,r=t._maxSize,n=t._batchSize,i=this.renderer,o=e.length;if(0!==o){o>r&&(o=r);var s=t._glBuffers[i.CONTEXT_UID];s||(s=t._glBuffers[i.CONTEXT_UID]=this.generateBuffers(t));var a=e[0]._texture.baseTexture;this.renderer.setBlendMode(u.utils.correctBlendMode(t.blendMode,a.premultipliedAlpha));var h=i.gl,l=t.worldTransform.copy(this.tempMatrix);l.prepend(i._activeRenderTarget.projectionMatrix),this.shader.uniforms.projectionMatrix=l.toArray(!0),this.shader.uniforms.uColor=u.utils.premultiplyRgba(t.tintRgb,t.worldAlpha,this.shader.uniforms.uColor,a.premultipliedAlpha),this.shader.uniforms.uSampler=i.bindTexture(a);for(var c=!1,d=0,f=0;d<o;d+=n,f+=1){var p=o-d;if(p>n&&(p=n),f>=s.length){if(!t.autoResize)break;s.push(this._generateOneMoreBuffer(t))}var v=s[f];v.uploadDynamic(e,d,p);var g=t._bufferUpdateIDs[f]||0;c=c||v._updateID<g,c&&(v._updateID=t._updateID,v.uploadStatic(e,d,p)),i.bindVao(v.vao),v.vao.draw(h.TRIANGLES,6*p)}}},e.prototype.generateBuffers=function(t){for(var e=this.renderer.gl,r=[],n=t._maxSize,i=t._batchSize,o=t._properties,s=0;s<n;s+=i)r.push(new d.default(e,this.properties,o,i));return r},e.prototype._generateOneMoreBuffer=function(t){var e=this.renderer.gl,r=t._batchSize,n=t._properties;return new d.default(e,this.properties,n,r)},e.prototype.uploadVertices=function(t,e,r,n,i,o){for(var s=0,a=0,u=0,h=0,l=0;l<r;++l){var c=t[e+l],d=c._texture,f=c.scale.x,p=c.scale.y,v=d.trim,g=d.orig;v?(a=v.x-c.anchor.x*g.width,s=a+v.width,h=v.y-c.anchor.y*g.height,u=h+v.height):(s=g.width*(1-c.anchor.x),a=g.width*-c.anchor.x,u=g.height*(1-c.anchor.y),h=g.height*-c.anchor.y),n[o]=a*f,n[o+1]=h*p,n[o+i]=s*f,n[o+i+1]=h*p,n[o+2*i]=s*f,n[o+2*i+1]=u*p,n[o+3*i]=a*f,n[o+3*i+1]=u*p,o+=4*i}},e.prototype.uploadPosition=function(t,e,r,n,i,o){for(var s=0;s<r;s++){var a=t[e+s].position;n[o]=a.x,n[o+1]=a.y,n[o+i]=a.x,n[o+i+1]=a.y,n[o+2*i]=a.x,n[o+2*i+1]=a.y,n[o+3*i]=a.x,n[o+3*i+1]=a.y,o+=4*i}},e.prototype.uploadRotation=function(t,e,r,n,i,o){for(var s=0;s<r;s++){var a=t[e+s].rotation;n[o]=a,n[o+i]=a,n[o+2*i]=a,n[o+3*i]=a,o+=4*i}},e.prototype.uploadUvs=function(t,e,r,n,i,o){for(var s=0;s<r;++s){var a=t[e+s]._texture._uvs;a?(n[o]=a.x0,n[o+1]=a.y0,n[o+i]=a.x1,n[o+i+1]=a.y1,n[o+2*i]=a.x2,n[o+2*i+1]=a.y2,n[o+3*i]=a.x3,n[o+3*i+1]=a.y3,o+=4*i):(n[o]=0,n[o+1]=0,n[o+i]=0,n[o+i+1]=0,n[o+2*i]=0,n[o+2*i+1]=0,n[o+3*i]=0,n[o+3*i+1]=0,o+=4*i)}},e.prototype.uploadTint=function(t,e,r,n,i,o){for(var s=0;s<r;++s){var a=t[e+s],u=a._texture.baseTexture.premultipliedAlpha,h=a.alpha,l=h<1&&u?(0,f.premultiplyTint)(a._tintRGB,h):a._tintRGB+(255*h<<24);n[o]=l,n[o+i]=l,n[o+2*i]=l,n[o+3*i]=l,o+=4*i}},e.prototype.destroy=function(){this.renderer.gl&&this.renderer.gl.deleteBuffer(this.indexBuffer),t.prototype.destroy.call(this),this.shader.destroy(),this.indices=null,this.tempMatrix=null},e}(u.ObjectRenderer);r.default=p,u.WebGLRenderer.registerPlugin("particle",p)},{"../../core":65,"../../core/utils":125,"./ParticleBuffer":175,"./ParticleShader":177}],177:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}r.__esModule=!0;var s=t("../../core/Shader"),a=function(t){return t&&t.__esModule?t:{default:t}}(s),u=function(t){function e(r){return n(this,e),i(this,t.call(this,r,["attribute vec2 aVertexPosition;","attribute vec2 aTextureCoord;","attribute vec4 aColor;","attribute vec2 aPositionCoord;","attribute float aRotation;","uniform mat3 projectionMatrix;","uniform vec4 uColor;","varying vec2 vTextureCoord;","varying vec4 vColor;","void main(void){","   float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);","   float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);","   vec2 v = vec2(x, y);","   v = v + aPositionCoord;","   gl_Position = vec4((projectionMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);","   vTextureCoord = aTextureCoord;","   vColor = aColor * uColor;","}"].join("\n"),["varying vec2 vTextureCoord;","varying vec4 vColor;","uniform sampler2D uSampler;","void main(void){","  vec4 color = texture2D(uSampler, vTextureCoord) * vColor;","  gl_FragColor = color;","}"].join("\n")))}return o(e,t),e}(a.default);r.default=u},{"../../core/Shader":44}],178:[function(t,e,r){"use strict";Math.sign||(Math.sign=function(t){return t=Number(t),0===t||isNaN(t)?t:t>0?1:-1})},{}],179:[function(t,e,r){"use strict";Number.isInteger||(Number.isInteger=function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t})},{}],180:[function(t,e,r){"use strict";var n=t("object-assign"),i=function(t){return t&&t.__esModule?t:{default:t}}(n);Object.assign||(Object.assign=i.default)},{"object-assign":6}],181:[function(t,e,r){"use strict";t("./Object.assign"),t("./requestAnimationFrame"),t("./Math.sign"),t("./Number.isInteger"),window.ArrayBuffer||(window.ArrayBuffer=Array),window.Float32Array||(window.Float32Array=Array),window.Uint32Array||(window.Uint32Array=Array),window.Uint16Array||(window.Uint16Array=Array)},{"./Math.sign":178,"./Number.isInteger":179,"./Object.assign":180,"./requestAnimationFrame":182}],182:[function(t,e,r){(function(t){"use strict";if(Date.now&&Date.prototype.getTime||(Date.now=function(){return(new Date).getTime()}),!t.performance||!t.performance.now){var e=Date.now();t.performance||(t.performance={}),t.performance.now=function(){return Date.now()-e}}for(var r=Date.now(),n=["ms","moz","webkit","o"],i=0;i<n.length&&!t.requestAnimationFrame;++i){var o=n[i];t.requestAnimationFrame=t[o+"RequestAnimationFrame"],t.cancelAnimationFrame=t[o+"CancelAnimationFrame"]||t[o+"CancelRequestAnimationFrame"]}t.requestAnimationFrame||(t.requestAnimationFrame=function(t){if("function"!=typeof t)throw new TypeError(t+"is not a function");var e=Date.now(),n=16+r-e;return n<0&&(n=0),r=e,setTimeout(function(){r=Date.now(),t(performance.now())},n)}),t.cancelAnimationFrame||(t.cancelAnimationFrame=function(t){return clearTimeout(t)})}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],183:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){var r=!1;if(t&&t._textures&&t._textures.length)for(var n=0;n<t._textures.length;n++)if(t._textures[n]instanceof d.Texture){var i=t._textures[n].baseTexture;-1===e.indexOf(i)&&(e.push(i),r=!0)}return r}function o(t,e){return t instanceof d.BaseTexture&&(-1===e.indexOf(t)&&e.push(t),!0)}function s(t,e){if(t._texture&&t._texture instanceof d.Texture){var r=t._texture.baseTexture;return-1===e.indexOf(r)&&e.push(r),!0}return!1}function a(t,e){return e instanceof d.Text&&(e.updateText(!0),!0)}function u(t,e){if(e instanceof d.TextStyle){var r=e.toFontString();return d.TextMetrics.measureFont(r),!0}return!1}function h(t,e){if(t instanceof d.Text){-1===e.indexOf(t.style)&&e.push(t.style),-1===e.indexOf(t)&&e.push(t);var r=t._texture.baseTexture;return-1===e.indexOf(r)&&e.push(r),!0}return!1}function l(t,e){return t instanceof d.TextStyle&&(-1===e.indexOf(t)&&e.push(t),!0)}r.__esModule=!0;var c=t("../core"),d=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(c),f=t("./limiters/CountLimiter"),p=function(t){return t&&t.__esModule?t:{default:t}}(f),v=d.ticker.shared;d.settings.UPLOADS_PER_FRAME=4;var g=function(){function t(e){var r=this;n(this,t),this.limiter=new p.default(d.settings.UPLOADS_PER_FRAME),this.renderer=e,this.uploadHookHelper=null,this.queue=[],this.addHooks=[],this.uploadHooks=[],this.completes=[],this.ticking=!1,this.delayedTick=function(){r.queue&&r.prepareItems()},this.registerFindHook(h),this.registerFindHook(l),this.registerFindHook(i),this.registerFindHook(o),this.registerFindHook(s),this.registerUploadHook(a),this.registerUploadHook(u)}return t.prototype.upload=function(t,e){"function"==typeof t&&(e=t,t=null),t&&this.add(t),this.queue.length?(e&&this.completes.push(e),this.ticking||(this.ticking=!0,v.addOnce(this.tick,this,d.UPDATE_PRIORITY.UTILITY))):e&&e()},t.prototype.tick=function(){setTimeout(this.delayedTick,0)},t.prototype.prepareItems=function(){for(this.limiter.beginFrame();this.queue.length&&this.limiter.allowedToUpload();){var t=this.queue[0],e=!1;if(t&&!t._destroyed)for(var r=0,n=this.uploadHooks.length;r<n;r++)if(this.uploadHooks[r](this.uploadHookHelper,t)){this.queue.shift(),e=!0;break}e||this.queue.shift()}if(this.queue.length)v.addOnce(this.tick,this,d.UPDATE_PRIORITY.UTILITY);else{this.ticking=!1;var i=this.completes.slice(0);this.completes.length=0;for(var o=0,s=i.length;o<s;o++)i[o]()}},t.prototype.registerFindHook=function(t){return t&&this.addHooks.push(t),this},t.prototype.registerUploadHook=function(t){return t&&this.uploadHooks.push(t),this},t.prototype.add=function(t){for(var e=0,r=this.addHooks.length;e<r&&!this.addHooks[e](t,this.queue);e++);if(t instanceof d.Container)for(var n=t.children.length-1;n>=0;n--)this.add(t.children[n]);return this},t.prototype.destroy=function(){this.ticking&&v.remove(this.tick,this),this.ticking=!1,this.addHooks=null,this.uploadHooks=null,this.renderer=null,this.completes=null,this.queue=null,this.limiter=null,this.uploadHookHelper=null},t}();r.default=g},{"../core":65,"./limiters/CountLimiter":186}],184:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e){if(e instanceof u.BaseTexture){var r=e.source,n=0===r.width?t.canvas.width:Math.min(t.canvas.width,r.width),i=0===r.height?t.canvas.height:Math.min(t.canvas.height,r.height);return t.ctx.drawImage(r,0,0,n,i,0,0,t.canvas.width,t.canvas.height),!0}return!1}r.__esModule=!0;var a=t("../../core"),u=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(a),h=t("../BasePrepare"),l=function(t){return t&&t.__esModule?t:{default:t}}(h),c=16,d=function(t){function e(r){n(this,e);var o=i(this,t.call(this,r));return o.uploadHookHelper=o,o.canvas=document.createElement("canvas"),o.canvas.width=c,o.canvas.height=c,o.ctx=o.canvas.getContext("2d"),o.registerUploadHook(s),o}return o(e,t),e.prototype.destroy=function(){t.prototype.destroy.call(this),this.ctx=null,this.canvas=null},e}(l.default);r.default=d,u.CanvasRenderer.registerPlugin("prepare",d)},{"../../core":65,"../BasePrepare":183}],185:[function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}r.__esModule=!0;var i=t("./webgl/WebGLPrepare");Object.defineProperty(r,"webgl",{enumerable:!0,get:function(){return n(i).default}});var o=t("./canvas/CanvasPrepare");Object.defineProperty(r,"canvas",{enumerable:!0,get:function(){return n(o).default}});var s=t("./BasePrepare");Object.defineProperty(r,"BasePrepare",{enumerable:!0,get:function(){return n(s).default}});var a=t("./limiters/CountLimiter");Object.defineProperty(r,"CountLimiter",{enumerable:!0,get:function(){return n(a).default}});var u=t("./limiters/TimeLimiter");Object.defineProperty(r,"TimeLimiter",{enumerable:!0,get:function(){return n(u).default}})},{"./BasePrepare":183,"./canvas/CanvasPrepare":184,"./limiters/CountLimiter":186,"./limiters/TimeLimiter":187,"./webgl/WebGLPrepare":188}],186:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(e){n(this,t),this.maxItemsPerFrame=e,this.itemsLeft=0}return t.prototype.beginFrame=function(){this.itemsLeft=this.maxItemsPerFrame},t.prototype.allowedToUpload=function(){return this.itemsLeft-- >0},t}();r.default=i},{}],187:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.__esModule=!0;var i=function(){function t(e){n(this,t),this.maxMilliseconds=e,this.frameStart=0}return t.prototype.beginFrame=function(){this.frameStart=Date.now()},t.prototype.allowedToUpload=function(){return Date.now()-this.frameStart<this.maxMilliseconds},t}();r.default=i},{}],188:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e){return e instanceof l.BaseTexture&&(e._glTextures[t.CONTEXT_UID]||t.textureManager.updateTexture(e),!0)}function a(t,e){return e instanceof l.Graphics&&((e.dirty||e.clearDirty||!e._webGL[t.plugins.graphics.CONTEXT_UID])&&t.plugins.graphics.updateGraphics(e),!0)}function u(t,e){return t instanceof l.Graphics&&(e.push(t),!0)}r.__esModule=!0;var h=t("../../core"),l=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(h),c=t("../BasePrepare"),d=function(t){return t&&t.__esModule?t:{default:t}}(c),f=function(t){function e(r){n(this,e);var o=i(this,t.call(this,r));return o.uploadHookHelper=o.renderer,o.registerFindHook(u),o.registerUploadHook(s),o.registerUploadHook(a),o}return o(e,t),e}(d.default);r.default=f,l.WebGLRenderer.registerPlugin("prepare",f)},{"../../core":65,"../BasePrepare":183}],189:[function(t,e,r){(function(e){"use strict";function n(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}r.__esModule=!0,r.loader=r.prepare=r.particles=r.mesh=r.loaders=r.interaction=r.filters=r.extras=r.extract=r.accessibility=void 0;var i=t("./polyfill");Object.keys(i).forEach(function(t){"default"!==t&&"__esModule"!==t&&Object.defineProperty(r,t,{enumerable:!0,get:function(){return i[t]}})});var o=t("./core");Object.keys(o).forEach(function(t){"default"!==t&&"__esModule"!==t&&Object.defineProperty(r,t,{enumerable:!0,get:function(){return o[t]}})});var s=t("./deprecation"),a=function(t){return t&&t.__esModule?t:{default:t}}(s),u=t("./accessibility"),h=n(u),l=t("./extract"),c=n(l),d=t("./extras"),f=n(d),p=t("./filters"),v=n(p),g=t("./interaction"),y=n(g),m=t("./loaders"),_=n(m),b=t("./mesh"),x=n(b),T=t("./particles"),w=n(T),E=t("./prepare"),S=n(E);o.utils.mixins.performMixins();var O=_.shared||null;r.accessibility=h,r.extract=c,r.extras=f,r.filters=v,r.interaction=y,r.loaders=_,r.mesh=x,r.particles=w,r.prepare=S,r.loader=O,"function"==typeof a.default&&(0,a.default)(r),e.PIXI=r}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./accessibility":42,"./core":65,"./deprecation":131,"./extract":133,"./extras":141,"./filters":153,"./interaction":159,"./loaders":162,"./mesh":171,"./particles":174,"./polyfill":181,"./prepare":185}]},{},[189])(189)});
//# sourceMappingURL=pixi.min.js.map

"use strict";angular.module("nuit.editor").constant("nuitEditorEvents",Object.freeze({profileLoaded:"nuitEditor::profileLoaded",profileCleared:"nuitEditor::profileCleared",editorRegistered:"nuitEditor::editorRegistered",editorUnregistered:"nuitEditor::editorUnregistered",editorChanged:"nuitEditor::editorChanged",init:"nuitEditor::init",reset:"nuitEditor::reset",render:"nuitEditor::render",rendered:"nuitEditor::rendered",segmentAdded:"nuitEditor::segmentAdded",segmentRemoved:"nuitEditor::segmentRemoved",segmentAligned:"nuitEditor::segmentAligned",segmentLengthChanged:"nuitEditor::segmentLengthChanged",segmentAngleChanged:"nuitEditor::segmentAngleChanged",segmentConicalChanged:"nuitEditor::segmentConicalChanged",conicalBaseChanged:"nuitEditor::conicalBaseChanged",segmentMeasureChanged:"nuitEditor::segmentMeasureChanged",segmentBendingChanged:"nuitEditor::segmentBendingChanged",segmentCloseChanged:"nuitEditor::segmentCloseChanged",segmentDepthChanged:"nuitEditor::segmentDepthChanged",segmentFocused:"nuitEditor::segmentFocused",angleFocused:"nuitEditor::angleFocused",clearSelection:"nuitEditor::clearSelection",materialChanged:"nuitEditor::materialChanged",visibleSideChanged:"nuitEditor::visibleSideChanged",stampingLineAdded:"nuitEditor::stampingLineAdded",stampingLineFocused:"nuitEditor::stampingLineFocused",stampingLineFocusCleared:"nuitEditor::stampingLineFocusCleared",cuttingAdded:"nuitEditor::cuttingAdded",cuttingRemoved:"nuitEditor::cuttingRemoved",setType:"nuitEditor::setType"}));
"use strict";angular.module("nuit.editor").constant("NUIT_PROFILE_SETTINGS",{editor:{defaultMaterialId:null,limits:{segmentLength:{min:10,max:1e4,default:100},hemLength:{min:1,max:50,default:10},thickness:{min:1,max:10},profileDepth:{min:500,max:1e4,default:3e3}}}});
"use strict";!function(){function g(){var e=this;e.$onChanges=angular.noop,e.$onPreRender=angular.noop,e.$onPostRender=angular.noop,e.$onMouseWheel=angular.noop,e.$onResize=angular.noop,e.$onInput=angular.noop,e.$onUse=angular.noop}function e(S,e,w,C){var t="nuit-draw-2d",r=t,o={},a=null,E=null,O=!1,P=null,x=null;S.$on(w.segmentAdded,s),S.$on(w.segmentRemoved,s),S.$on(w.segmentAligned,s),S.$on(w.segmentCloseChanged,s),S.$on(w.segmentConicalChanged,s),S.$on(w.segmentBendingChanged,s),S.$on(w.segmentLengthChanged,s),S.$on(w.segmentAngleChanged,s),S.$on(w.segmentDepthChanged,s),S.$on(w.conicalBaseChanged,s),S.$on(w.profileCleared,s),S.$on(w.setType,s);var n={Manager:g,init:function(e){r=e.defaultEditor||t,a=null,S.$broadcast(w.init)},reset:function(){for(var e in function(){a=null}(),a=null,o)delete o[e];S.$broadcast(w.reset)},listEditors:function(){return Object.keys(o)},hasEditor:d,getEditor:u,useEditor:i,registerEditor:function(e,t,n){if(d(e))throw new Error("Editor with id "+e+" has already been registered");if(!n)throw new Error("Editor with id '"+e+"' has no scene");o[e]={id:e,manager:t,scene:n},S.$broadcast(w.editorRegistered,e),a&&e!==r||i(e)},unregisterEditor:function(e){if(!d(e))return;S.$broadcast(w.editorUnregistered,e),e===a&&i(r);delete o[e]},getCurrentEditorId:function(){return a},getManager:l,render:s,importProfile:function(e,t,n){E=e.name,O=e.saved||!0,P=e.id,x=e.externalId,C.clear(C.keepMaterial&&!n,t,!n),C.keepMaterial&&!n||C.setMaterial(e.material);C.keepLength&&!n||(C.depth=e.length);e.geometry&&(C.setVisibleSide(e.geometry.frontFace),C.importSegments(e.geometry.segments),e.geometry.left?C.getFirstOffset().left=e.geometry.offset:C.getFirstOffset().right=e.geometry.offset);"number"==typeof e.conicalBase&&C.setConicalBase(e.conicalBase);if(C.addHoles(e.stamp),e.stamps){var r=!0,o=!1,a=void 0;try{for(var i,s=e.stamps[Symbol.iterator]();!(r=(i=s.next()).done);r=!0){var l=i.value;C.addStampingLine(l)}}catch(e){o=!0,a=e}finally{try{!r&&s.return&&s.return()}finally{if(o)throw a}}}if(e.punches){var u=!0,d=!1,g=void 0;try{for(var f,c=e.punches[Symbol.iterator]();!(u=(f=c.next()).done);u=!0){var m=f.value;C.addStampingLine(m,"simple")}}catch(e){d=!0,g=e}finally{try{!u&&c.return&&c.return()}finally{if(d)throw g}}}if(e.cuts){Array.isArray(e.cuts)||(e.cuts=[e.cuts]);var h=!0,p=!1,y=void 0;try{for(var $,v=e.cuts[Symbol.iterator]();!(h=($=v.next()).done);h=!0){var b=$.value;C.addCutting(b)}}catch(e){p=!0,y=e}finally{try{!h&&v.return&&v.return()}finally{if(p)throw y}}}e.customData&&C.setCustomData(e.customData);e.specials&&C.setSpecials(e.specials);C.forceRefresh(),S.$broadcast(w.profileLoaded)},exportProfile:function(){var e=C.getFirstOffset(),t=angular.copy(C.getMaterial());t&&(t.thickness=C.getOriginalThickness());return{id:P,externalId:x,length:C.depth,material:t,stamp:C.getHoles(),stamps:C.getStampingLines("default"),punches:C.getStampingLines("simple"),cuts:JSON.parse(JSON.stringify(C.getCuttings())),conicalBase:C.getConicalBase(),geometry:{segments:C.exportSegments(),frontFace:C.getVisibleSide(),offset:Math.max(e.left,e.right),left:e.left>e.right},name:E,customData:C.getCustomData(),specials:C.getSpecials()}},clearProfile:function(){O=!1,x=P=E=null},isSaved:function(){return O},setName:function(e){E=e},getName:function(){return E},setSaved:function(e){O=e},generateLegacyProfile:function(){return{length:C.depth,frontFace:C.getVisibleSide(),material:C.getMaterial(),segments:C.exportSegments(),name:name,firstOffset:{left:C.getFirstOffset().left,right:C.getFirstOffset().right}}}};return Object.defineProperty(n,"defaultEditor",{get:function(){return r},set:function(e){if(!e)throw new Error("Default editor cannot be null");console.warn("You changed the default editor. Unexpected behaviour can occur"),r=e.toString()}}),Object.defineProperty(n,"manager",{get:l}),Object.defineProperty(n,"currentEditor",{get:u,set:i}),n;function i(e){d(e)?(a=e,S.$broadcast(w.editorChanged,e)):console.error("Unknown editor with id "+e)}function s(){S.$broadcast(w.render)}function l(e){if(d(e=e||a))return u(e).manager}function u(e){if(!(e=e||a))return!1;if(!d(e))throw new Error("no editor with id "+e+" found");return o[e]}function d(e){return o.hasOwnProperty(e)}}e.$inject=["$rootScope","$timeout","nuitEditorEvents","nuitProfile"],angular.module("nuit.editor").factory("nuitEditor",e)}();
"use strict";angular.module("nuit.editor").factory("nuitmath",function(){var t=180/Math.PI,n=Math.PI/180,r=.5*Math.PI,u=2*Math.PI;return{DEG2RAD:n,RAD2DEG:t,PI_HALF:r,TWO_PI:u,clamp:function(t,n,r){return t<n?n:r<t?r:t},loop:function(t,n){return(t%n+n)%n}}});
"use strict";var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};!function(){function e(g,s,l,e,u){var i=2*Math.PI,a=Math.PI/2,f=Math.PI/180,c=180/Math.PI,t=e,o={Outer:-1,Inner:1},d={RESET:"reset",ADD_SEGMENT:"addSegment",REMOVE_SEGMENT:"removeSegment",SEGMENT_LENGTH_CHANGED:"segmentLengthChanged",SEGMENT_ANGLE_ADDED:"segmentAngleAdded",SEGMENT_ANGLE_CHANGED:"segmentAngleChanged",SEGMENT_BENDING_CHANGED:"segmentBdirChanged",SEGMENT_MEASURE_CHANGED:"segmentMeasureChanged",SEGMENT_CONICAL_CHANGED:"segmentConicalChanged",SEGMENT_CLOSE_CHANGED:"segmentCloseChanged",SET_MATERIAL:"setMaterial"},h=[],m=[],p=[],E=[],b=[],x=[],y=0,n=!1,M=new function(){var t=this;t.x={min:0,max:0},t.y={min:0,max:0},t.ensure=function(e){t.x.min=Math.min(t.x.min,e.x),t.y.min=Math.min(t.y.min,e.y),t.x.max=Math.max(t.x.max,e.x),t.y.max=Math.max(t.y.max,e.y)},t.ensureRect=function(e){t.x.min=Math.min(t.x.min,e.x),t.y.min=Math.min(t.y.min,e.y),t.x.max=Math.max(t.x.max,e.x+e.width),t.y.max=Math.max(t.y.max,e.y+e.height)},t.getCenterX=function(){return isFinite(t.x.min)&&isFinite(t.x.max)?t.x.min+.5*(t.x.max-t.x.min):0},t.getCenterY=function(){return isFinite(t.y.min)&&isFinite(t.y.max)?t.y.min+.5*(t.y.max-t.y.min):0},t.getWidth=function(){return t.x.max-t.x.min},t.getHeight=function(){return t.y.max-t.y.min},t.reset=function(){t.x.min=Number.POSITIVE_INFINITY,t.x.max=Number.NEGATIVE_INFINITY,t.y.min=Number.POSITIVE_INFINITY,t.y.max=Number.NEGATIVE_INFINITY}},S=null,A={left:0,right:0},v=-1,N=0,D=0,C=0,T=!0,G=angular.copy(t),O=G.editor.limits,L=new Se(0,0),_=new Se(0,0),k=null,I=[],r={MEASURE:o,DEG2RAD:f,RAD2DEG:c,PI_HALF:a,TWO_PI:i,add:J,addStampingLine:function(e,t){switch(t){case"simple":return function(e){return e.punchType="simple",b.push(e)-1}(e);default:return function(e){return b.push(e)-1}(e)}},addWrap:function(e,t){if(h.length<=0)return;var n=isFinite(t)?t:10,a=e?Math.PI:$().angle+Math.PI,r=J(n,a,e?h.length:0,e?-1:1);return r.forcedWrap=!0,r.close=!!G.editor.closeHem,r},addHistory:w,align:function(e){if(!ue(e))return;var t=pe(R(e).getAngleSum(),i),n=Math.PI-t;Math.round(n*c)%180==0?n=Math.PI:Math.abs(n)>a&&(n+=Math.PI);ee(0,n),g.$broadcast(l.segmentAligned,{baseIndex:e})},clamp:me,clear:z,clearStampingLines:function(){b.length=0},count:function(){return h.length},exportSegments:ie,first:$,forceRefresh:q,get:R,getAll:function(){return h},getAngle:function(e){return ue(e)?h[e].angle:0},getBounds:function(){return M},getConicalBase:U,getDepth:function(){return C},getFirstOffset:function(){return A},getFirstOffsetLeft:function(){return A.left},getFirstOffsetRight:function(){return A.right},getIntersections:function(){return p},getMaterial:function(){return S},getThickness:X,getOriginalThickness:function(){return S&&S.originalThickness?S.originalThickness:X()},getStampingLines:function(e){{if(e){var t=[],n=!0,a=!1,r=void 0;try{for(var i,o=b[Symbol.iterator]();!(n=(i=o.next()).done);n=!0){var s=i.value;(s.punchType||"default"!==e)&&e!==s.punchType||("simple"===s.punchType?t.push(u.toSimpleStamping(s)):t.push(s))}}catch(e){a=!0,r=e}finally{try{!n&&o.return&&o.return()}finally{if(a)throw r}}return t}return b}},getTotalLength:function(){return N},getTotalLengthWithoutOffset:function(){return D},getVisibleSide:function(){return T},hasIntersections:function(){return 0<p.length},historyBack:function(){if(!H())return;n=!0;var e=E[--y];switch(e.type){case d.ADD_SEGMENT:K(e.data.index);break;case d.REMOVE_SEGMENT:var t=J(e.data.segment.length,e.data.segment.angle,e.data.index,e.data.segment.bendingDir);t.conical=e.data.segment.conical,t.backLength=e.data.segment.backLength,t.measureSide=e.data.segment.measureSide,t.close=e.data.segment.close,t.forcedWrap=e.data.segment.forcedWrap;break;case d.SEGMENT_LENGTH_CHANGED:Q(e.data.index,e.data.from.front),Q(e.data.index,e.data.from.back,!0);break;case d.SEGMENT_ANGLE_CHANGED:Z(e.data.index,e.data.from);break;case d.SEGMENT_ANGLE_ADDED:ee(e.data.index,-e.data.value);break;case d.SEGMENT_BENDING_CHANGED:te(e.data.index);break;case d.SEGMENT_MEASURE_CHANGED:ne(e.data.index);break;case d.SEGMENT_CONICAL_CHANGED:ae(e.data.index),Q(e.data.index,e.data.prevBackLength,!0);break;case d.SEGMENT_CLOSE_CHANGED:re(e.data.index);break;case d.RESET:oe(e.data);break;case d.SET_MATERIAL:}n=!1,g.$broadcast(l.render)},historyBackAvailable:H,historyForward:function(){if(!P())return;n=!0;var e=E[y];switch(e.type){case d.ADD_SEGMENT:var t=J(e.data.segment.length,e.data.segment.angle,e.data.index,e.data.segment.bendingDir);t.conical=e.data.segment.conical,t.backLength=e.data.segment.backLength,t.measureSide=e.data.segment.measureSide,t.close=e.data.segment.close,t.forcedWrap=e.data.segment.forcedWrap;break;case d.REMOVE_SEGMENT:K(e.data.index);break;case d.SEGMENT_LENGTH_CHANGED:Q(e.data.index,e.data.to.front),Q(e.data.index,e.data.to.back,!0);break;case d.SEGMENT_ANGLE_CHANGED:Z(e.data.index,e.data.to);break;case d.SEGMENT_ANGLE_ADDED:ee(e.data.index,e.data.value);break;case d.SEGMENT_BENDING_CHANGED:te(e.data.index);break;case d.SEGMENT_MEASURE_CHANGED:ne(e.data.index);break;case d.SEGMENT_CONICAL_CHANGED:ae(e.data.index),Q(e.data.index,e.data.prevBackLength,!0);break;case d.SEGMENT_CLOSE_CHANGED:re(e.data.index);break;case d.RESET:oe(e.data);break;case d.SET_MATERIAL:}n=!1,y++,g.$broadcast(l.render)},historyForwardAvailable:P,importSegments:oe,replaceSegments:se,intersectsAny:function(e,t,n,a){var r=$();L.x=e,L.y=t,_.x=n,_.y=a;for(;!r.isLast();){var i=Me(L,_,r.start,r.end);if(i)return i;r=r.next}return null},isConical:function(e){return!!ue(e)&&R(e).isConical()},isEmpty:F,isWrap:B,last:Y,loop:pe,removeAt:K,removeStampingLine:function(e){b.splice(e,1)},rotate:function(e){if(h.length<=0)return;ee(0,e)},setAngle:Z,setWrap:function(e,t,n,a){var r=R(e);r.bendingDir=a,r.angleOffset=0,r.forcedWrap=t,r.close=n},setConicalBase:j,addAngle:ee,Segment:Ae,setConfig:function(e){G=angular.merge({},t,e),O=G.editor.limits,F()&&W(O.profileDepth.default);G.editor.nuitDrawStampingRework.tools&&u.setTools(G.editor.nuitDrawStampingRework.tools);G.editor.nuitDrawStampingRework.areas&&u.setArea(G.editor.nuitDrawStampingRework.areas);return G},setDepth:W,setLength:Q,setMaterial:function(e,t){t&&S||(S=e&&e.id?e:null);g.$broadcast(l.materialChanged,S)},setVisibleSide:function(e){T=e},toggleBending:te,toggleClose:re,toggleConical:ae,toggleMeasure:ne,setType:function(e,t){if(!ue(e))return;var n,a=R(e),r=G.evo.editor.customSegments.types.map(function(e){return e.type});if(t=t||a.getType()){e=r.indexOf(a.type);n=-1===e||e>=r.length-1?r[0]:r[e+1]}else n=0<r.length?r[0]:void 0;var i=G.evo.editor.customSegments.types.find(function(e){return e.type===n});i&&(a.length=i.length,a.backLength=i.length);a.setType(n),ce(0),g.$broadcast(l.setType,{segment:a})},toggleVisibleSide:V,invertOrder:function(){var e=$(),t=[],n=U();for(;null!==e;){var a={angle:e.next?e.next.angleOffset:s.loop(2*e.bendingDir*Math.PI-e.absoluteAngle,2*Math.PI),wrap:e.isWrap(),bendingDir:e.bendingDir,bendingDirBool:1===e.bendingDir};t.push(a),e=e.next}var r=ie();t.reverse(),r.reverse();for(var i=void 0,o=0;o<r.length;o++)r[o].wrap&&0<o&&(r[o].bdir=t[o-1].bendingDirBool,r[o].angle=Math.round(t[o].angle*(r[o].bdir?1:-1)*s.RAD2DEG)),i&&i.wrap?(r[o].bdir=!i.bdir,r[o].angle=Math.round(t[o].angle*(r[o].bdir?1:-1)*s.RAD2DEG)):(r[o].angle=Math.round(t[o].angle*(r[o].bdir?1:-1)*s.RAD2DEG),r[o].angle<0&&0!==r[o].angle&&!r[o].wrap&&(r[o].bdir=!r[o].bdir,r[o].angle=-r[o].angle)),i=r[o];se(r),V(),j(-1===n?9999:9999===n?-1:r.length-n);q()},setCustomData:function(e){k=angular.copy(e)},getCustomData:function(){return k},setSpecials:function(e){I=angular.copy(e)},getSpecials:function(){return I},updateStampingLine:function(e,t){if(!b[e])throw new Error("Unknown index "+e+" in stampings");b[e]=t},resetStampingLines:function(){b.splice(0,b.length)},hasStampingLines:function(){return 0<b.length},addCutting:function(e){return x.push(e)},removeCutting:function(e){x.splice(e,1)},getCuttings:function(){return x},setCutting:function(e,t){x[e]=t},addHole:le,addHoles:function(e){if(!e||!angular.isArray(e))return;var t=!0,n=!1,a=void 0;try{for(var r,i=e[Symbol.iterator]();!(t=(r=i.next()).done);t=!0){var o=r.value;m.push(o)}}catch(e){n=!0,a=e}finally{try{!t&&i.return&&i.return()}finally{if(n)throw a}}},getHoles:function(){return m},generateHoles:function(e){ge();var t=!0,n=!1,a=void 0;try{for(var r,i=e[Symbol.iterator]();!(t=(r=i.next()).done);t=!0)for(var o=r.value,s=o.distanceFirst;s<C-o.distanceLast;s+=o.distanceBetween){le(s,o.offsetTop,o.tool).lineId=o.id}}catch(e){n=!0,a=e}finally{try{!t&&i.return&&i.return()}finally{if(n)throw a}}},resetStamping:ge};return Object.defineProperty(r,"totalLength",{get:r.getTotalLength}),Object.defineProperty(r,"totalLengthWithoutOffset",{get:r.getTotalLengthWithoutOffset}),Object.defineProperty(r,"depth",{get:r.getDepth,set:r.setDepth}),Object.defineProperty(r,"keepMaterial",{get:function(){return G.editor.keepMaterial}}),Object.defineProperty(r,"keepLength",{get:function(){return G.editor.keepLength}}),r;function w(e,t){n||(E.length=y,E.push({type:e,data:angular.copy(t)}),y=E.length)}function H(){return 0<y}function P(){return y<E.length}function F(){return h.length<=0}function R(e){return ue(e)?h[e]:null}function B(e){return!!ue(e)&&R(e).isWrap()}function W(e){var t=O.profileDepth.min,n=O.profileDepth.max;S&&S.restrictions&&(S.restrictions.maxLength&&(n=S.restrictions.maxLength),S.restrictions.minLength&&(t=S.restrictions.minLength)),C=me(e,t,n),g.$broadcast(l.segmentDepthChanged,e)}function $(){return h.length<1?null:h[0]}function Y(){return h.length<1?null:h[h.length-1]}function V(){return T=!T,g.$broadcast(l.visibleSideChanged,T),T}function X(){return S?S.thickness:1}function j(e){v=e,de(),g.$broadcast(l.conicalBaseChanged,v)}function U(){return v}function z(e,t,n){for(var a=ie(),r=$();r;)r.prev=null,r=r.next;h.length=0,b.length=0,x.length=0,m.length=0,A.left=0,A.right=0,e||(S=null),D=N=0,M.reset(),p.length=0,T||V(),n||(k=null),I=[],t?(E.length=0,y=0):(w(d.RESET,a),g.$broadcast(l.profileCleared,a))}function q(){ce(0),he()}function J(e,t,n,a){if("number"!=typeof n)n=h.length;else if(n<0||n>h.length)return null;"number"==typeof a&&(a=0<a?1:-1);var r=new Ae(e,t=Math.round(pe(t*c,360))*f,n);if(0!==n&&180===Math.round(t*c)&&r.wrap(a),h.splice(n,0,r),fe(r,R(n+1)),fe(R(n-1),r),r.isFirst())for(var i=r.getAngleSum(),o=0,s=r.next;s;)o=s.angle,s.setAngle(s.angle-i),i+=s.angle-o,s=s.next;return ce(Math.max(0,n-1)),he(),w(d.ADD_SEGMENT,{index:n,segment:r}),g.$broadcast(l.segmentAdded,r),r}function K(e){if(e<0||e>=h.length)return null;var t=h.splice(e,1)[0];if(w(d.REMOVE_SEGMENT,{index:e,segment:t}),g.$broadcast(l.segmentRemoved,t),0<h.length){if(fe(R(e-1),R(e)),0===e?($().addAngle(t.angle),ce(0)):ce(e-1),h.length<=2&&B($().index)&&B(Y().index))return z(!0,!0),t;he()}return t}function Q(e,t,n){if(ue(e)){var a=R(e),r=O.segmentLength;a.isWrap()&&(r=O.hemLength),(!isFinite(t)||t<r.min)&&(t=r.min),t>r.max&&(t=r.max);var i=a.length,o=a.backLength;n&&a.conical?a.backLength=t:a.length=t,a.conical||(a.backLength=t),ce(e),he(),w(d.SEGMENT_LENGTH_CHANGED,{index:e,from:{front:i,back:o},to:{front:a.length,back:a.backLength}}),g.$broadcast(l.segmentLengthChanged,{segment:a,prevLength:i,prevBackLength:o})}}function Z(e,t){if(ue(e)){var n=R(e),a=n.angle;n.setAngle(t),ce(e-1),he(),w(d.SEGMENT_ANGLE_CHANGED,{index:e,from:a,to:n.angle}),g.$broadcast(l.segmentAngleChanged,{segment:n,prevAngle:a})}}function ee(e,t){if(ue(e)){var n=R(e),a=n.angle;n.addAngle(t),ce(e),he(),w(d.SEGMENT_ANGLE_ADDED,{index:e,value:t}),g.$broadcast(l.segmentAngleChanged,{segment:n,prevAngle:a})}}function te(e){if(ue(e)){var t=R(e);t.toggleBending(),ce(e),w(d.SEGMENT_BENDING_CHANGED,e),g.$broadcast(l.segmentBendingChanged,{segment:t})}}function ne(e){if(ue(e)){var t=R(e);t.toggleMeasure(),ce(e),w(d.SEGMENT_MEASURE_CHANGED,{index:e}),g.$broadcast(l.segmentMeasureChanged,{segment:t})}}function ae(e){if(ue(e)){var t=R(e),n=t.prevBackLength;t.toggleConical(),he(),ce(e),w(d.SEGMENT_CONICAL_CHANGED,{index:e,prevBackLength:n}),g.$broadcast(l.segmentConicalChanged,t)}}function re(e){if(ue(e)){var t=R(e);t.toggleClose(),w(d.SEGMENT_CLOSE_CHANGED,{index:e}),g.$broadcast(l.segmentCloseChanged,t)}}function ie(){for(var e=$(),t=[];null!==e;){var n={length:{front:e.length,back:e.backLength},angle:Math.round(Math.abs(180*e.angleOffset/Math.PI)),bdir:-1===e.bendingDir,wrap:e.isWrap(),conical:e.isConical(),mass:e.measureSide===o.Inner,close:e.isClosed(),type:e.getType()};t.push(n),e=e.next}return t}function oe(e){for(var t in e){var n=e[t],a=n.angle*(!0===n.bdir?-1:1)*Math.PI/180+Math.PI,r=new Ae(n.length.front,a,t);r.index=t,r.backLength=n.length.back,r.forcedWrap=n.wrap,r.bendingDir=n.bdir?-1:1,r.conical=n.conical,r.measureSide=n.mass?o.Inner:o.Outer,r.close=n.close,r.type=n.type?n.type:void 0,h.push(r),0<t&&(r.prev=h[t-1],r.prev.next=r)}g.$broadcast(l.profileLoaded)}function se(e){for(var t=$();t;)t.prev=null,t=t.next;h.length=0,oe(e)}function ge(){m.splice(0,m.length)}function le(e,t,n){if("object"!==(void 0===n?"undefined":_typeof(n)))return console.log("Invalid stamping tool specified!"),void console.log(n);var a={x:e,y:t,shape:n.shape},r=1;return n.scale&&(r=n.scale),n.width?a.width=n.width*r:n.size&&(a.width=n.size),n.height?a.height=n.height*r:n.size&&(a.height=n.size),n.radius?a.radius=n.radius*r:n.size&&(a.radius=n.size),n.id&&(a.stampId=n.id),m.push(a),a}function ue(e){return 0<=e&&e<h.length}function fe(e,t){null!==e&&(e.next=t),null!==t&&(t.prev=e)}function ce(e){if(!(e<0||e>=h.length)){for(var t=R(e),n=t.getAngleSum(),a=Math.max(1,X()),r=1<X()?X():0;t.index=e,t.absoluteAngle=n,Ee(t,a),ye(t,a),be(t),xe(t,r),n=pe(n+=null!==t.next?t.next.angle:0,i),e++,t=t.next;);de()}}function de(){for(var e=0,t=0;t<=v;t++){var n=R(t);if(!n)break;if(n.isConical()){var a=n.length-n.backLength;t===v&&(a/=2),e+=a}}var r=0,i=0;for(var o in 0<e?i+=e:e<0&&(r-=e),h){var s=R(o);s.offsetFront=r,s.offsetBack=i,r+=s.length,i+=s.backLength}}function he(){if(p.length=0,M.reset(),!(h.length<=0)){for(var e=$(),t=null,n=e.getOffsetFront(),a=e.getOffsetFront(),r=e.getOffsetBack(),i=e.getOffsetBack();!e.isLast();){for(M.ensure(e.start),M.ensure(e.end),n+=e.length,r+=e.backLength,t=e.next;!t.isLast();){t=t.next;var o=e.intersectsWith(t);o&&p.push(o)}e=e.next}n+=e.length,r+=e.backLength,M.ensure(e.start),M.ensure(e.end),N=Math.max(n,r),D=Math.max(n-a,r-i)}}function me(e,t,n){return e<t?t:n<e?n:e}function pe(e,t){return(e%t+t)%t}function Ee(e,t){if(e.bendingOffset.reset(),e.bendingArcCenter.reset(),!e.isFirst())if(Math.abs(e.angleOffset)<a)e.bendingOffset.polarOffset(-t,e.prev.absoluteAngle),e.bendingOffset.polarOffset(t,e.prev.absoluteAngle-a*e.bendingDir),e.bendingArcCenter.set(e.bendingOffset).add(e.prev.end),e.bendingOffset.polarOffset(t,e.absoluteAngle+a*e.bendingDir),e.bendingOffset.polarOffset(-t,e.absoluteAngle);else{var n=t/Math.cos(.5*(Math.PI-Math.abs(e.angleOffset)));e.bendingArcCenter.polarOffset(-n,e.prev.absoluteAngle+.5*e.angleOffset).add(e.prev.end)}}function be(e){e.isFirst()?(e.start.x=0,e.start.y=0):(e.start.x=e.prev.end.x+e.bendingOffset.x,e.start.y=e.prev.end.y+e.bendingOffset.y)}function xe(e,t){e.isFirst()||e.isLast()?(e.end.x=e.start.x+(e.length+t*e.measureSide*.5)*Math.cos(e.absoluteAngle),e.end.y=e.start.y+(e.length+t*e.measureSide*.5)*Math.sin(e.absoluteAngle)):(e.end.x=e.start.x+(e.length+t*e.measureSide)*Math.cos(e.absoluteAngle),e.end.y=e.start.y+(e.length+t*e.measureSide)*Math.sin(e.absoluteAngle))}function ye(e,t){Math.abs(e.angleOffset)<a?e.lengthOffset=-t:Math.abs(e.angleOffset)<Math.PI?e.lengthOffset=-Math.abs(t/Math.tan(.5*e.angleOffset)):e.lengthOffset=0}function Me(e,t,n,a){var r=t.x-e.x,i=t.y-e.y,o=a.x-n.x,s=a.y-n.y,g=-o*i+r*s,l=(-i*(e.x-n.x)+r*(e.y-n.y))/g,u=(o*(e.y-n.y)-s*(e.x-n.x))/g;return 0<=l&&l<=1&&0<=u&&u<=1&&new Se(e.x+u*r,e.y+u*i)}function Se(e,t){var n=this;n.x=e,n.y=t,n.add=function(e){return n.x+=e.x,n.y+=e.y,n},n.set=function(e){return n.x=e.x,n.y=e.y,n},n.reset=function(){return n.x=0,n.y=0,n},n.polarOffset=function(e,t){return n.x+=e*Math.cos(t),n.y+=e*Math.sin(t),n}}function Ae(e,t,n){var a=this;a.angle=t,a.absoluteAngle=t,a.angleOffset=t-Math.PI,a.length=e,a.backLength=e,a.lengthOffset=0,a.index=n,a.start=new Se(0,0),a.end=new Se(0,0),a.next=null,a.prev=null,a.bendingOffset=new Se(0,0),a.bendingArcCenter=new Se(0,0),a.bendingDir=0<=this.angleOffset?1:-1,a.measureSide=o.Outer,a.forcedWrap=!1,a.conical=!1,a.close=!1,a.offsetFront=0,a.offsetBack=0,a.type=void 0,a.isFirst=function(){return null===a.prev},a.isLast=function(){return null===a.next},a.isInner=function(){return null!==a.prev&&null!==a.next},a.isWrap=function(){return a.forcedWrap},a.isClosed=function(){return a.isWrap()&&a.close},a.isConical=function(){return a.conical},a.intersectsWith=function(e){return void 0===e.getType()&&void 0===a.getType()&&Me(a.start,a.end,e.start,e.end)},a.deltaX=function(){return a.getEndX()-a.getStartX()},a.deltaY=function(){return a.getEndY()-a.getStartY()},a.getIndex=function(){return a.index},a.getXAt=function(e){return a.getStartX()+e*Math.cos(a.getAngleSum())},a.getYAt=function(e){return a.getStartY()+e*Math.sin(a.getAngleSum())},a.getCenterX=function(){return a.getStartX()+.5*a.deltaX()},a.getCenterY=function(){return a.getStartY()+.5*a.deltaY()},a.getEndX=function(){return a.end.x},a.getEndY=function(){return a.end.y},a.getStartX=function(){return a.start.x},a.getStartY=function(){return a.start.y},a.getAngle=function(){return a.angle},a.getAngleSum=function(){return a.absoluteAngle},a.getOffsetFront=function(){return a.offsetFront},a.getOffsetBack=function(){return a.offsetBack},a.setAngle=function(e){e=Number.parseFloat(e),isFinite(e)||(e=0);e=Math.round(e*c)*f,a.angle=pe(e,i),a.angleOffset=Math.round(a.angle*c-180)*f,a.bendingDir=0<a.angleOffset?1:a.angleOffset<0?-1:a.bendingDir,a.absoluteAngle=a.angle},a.addAngle=function(e){a.setAngle(a.angle+e)},a.getDisplayAngle=function(){return Math.abs(a.angleOffset)},a.toggleBending=function(){if(Math.round(a.angleOffset*c)%180!=0)return;a.bendingDir*=-1},a.toggleClose=function(){a.close=!!a.forcedWrap&&!a.close},a.toggleConical=function(){a.conical=!a.conical,a.conical||(a.backLength=a.length)},a.toggleMeasure=function(){a.measureSide=a.measureSide===o.Outer?o.Inner:o.Outer},a.wrap=function(e){a.angle=Math.PI,a.angleOffset=0,a.bendingDir=e},a.getType=function(){return a.type},a.setType=function(e){a.type=e},Object.defineProperty(a,"angleOffsetProp",{get:function(){return G.editor&&G.editor.nuitDraw2d&&G.editor.nuitDraw2d.style&&!1===G.editor.nuitDraw2d.style.angleDirection?(console.log("get",Math.round(this.angleOffset*c)),Math.PI*Math.sign(this.angleOffset)-this.angleOffset):this.angleOffset},set:function(e){G.editor&&G.editor.nuitDraw2d&&G.editor.nuitDraw2d.style&&!1===G.editor.nuitDraw2d.style.angleDirection&&(console.log("set",Math.round(e*c)),e=Math.PI-e),r.setAngle(a.index,e+Math.PI)}})}}e.$inject=["$rootScope","nuitmath","nuitEditorEvents","NUIT_PROFILE_SETTINGS","nuitSimplePunching"],angular.module("nuit.editor").factory("nuitProfile",e)}();
"use strict";!function(){function n(n,r){var u={symbol:"mm",factor:1,decimals:0},i=[],e=n.current,o={round:function(n,t){switch(o.symbol(t)){case"inch":return n;default:return Math.round(n)}},floor:function(n,t){switch(o.symbol(t)){case"inch":return n;default:return Math.floor(n)}},ceil:function(n,t){switch(o.symbol(t)){case"inch":return n;default:return Math.ceil(n)}},symbol:function(n){var t=r.getOne(i,n);{return t?t.symbol:(o=void 0===e.units?(console.error("No unit config found!"),u):void 0===e.units[n]?(console.error("No unit config for '"+n+"' found!"),u):e.units[n],i.push({id:n,symbol:o.symbol}),o.symbol);var o}}};return o}n.$inject=["nuitConfig","nuitDataService"],angular.module("nuit.editor").factory("nuitPunchingMath",n)}();
"use strict";angular.module("nuit.editor").factory("nuitSimplePunching",function(){var y=[],f=null,v=0,e={toDefaultStamping:function(e,t){if(e.shape){var a=function(e){var t=!0,a=!1,i=void 0;try{for(var r,n=y[Symbol.iterator]();!(t=(r=n.next()).done);t=!0){var l=r.value;if(l.type===e.type){var s=!1;switch(l.type){case"circle":s=e.radius===l.radius;break;case"rectangle":case"oblong":s=e.length===l.width&&e.width===l.height}if(s)return l}}}catch(e){a=!0,i=e}finally{try{!t&&n.return&&n.return()}finally{if(a)throw i}}return null}(e.shape),i=void 0;if(null===a){var r=0,n=0,l=0,s=0;switch(e.shape.type){case"circle":r=n=parseFloat(new Decimal(e.shape.radius).times(2)),l=e.shape.radius,s=r;break;case"rectangle":r=e.shape.length,n=e.shape.width,s=Math.max(e.shape.length,e.shape.width);break;case"oblong":r=e.shape.length,n=e.shape.width,l=parseFloat(new Decimal(Math.min(e.shape.length,e.shape.width)).times(.5)),s=Math.max(e.shape.length,e.shape.width)}a=w(i={id:"embedded_"+t,shapes:[{x:0,y:0,width:r,height:n,radius:l}],name:{en:"-"},sizes:[{value:s,name:"-",id:"embedded_size_"+t}],distance:{min:0,max:1e4}})[0]}var o=e.x.length,d=e.x[0],h=e.x[o-1],c=0,u="distance";1<o&&(c=e.x[1]-e.x[0]);for(var p=0;p<e.x.length-1;p++){var m=e.x[p+1]-e.x[p];if(1e-5<Math.abs(c-m)){u="readOnly";break}}return{punchType:"simple",y:e.y,meta:{shape:e.shape,x:e.x,type:u,amount:o,fixedAmount:!0,area:{id:f.id,index:v},distBetweenStamps:c},tool:{id:a.tool.id,size:a.sizeIndex,sizeId:a.sizeId},embeddedTool:i,first:d,last:h,amount:o,bounds:{max:a.tool.distance.max,min:a.tool.distance.min}}}return e},toSimpleStamping:function(e){if(e.shape)return e;var t=void 0!==e.embeddedTool;return{y:e.y,x:e.meta.x,shape:function(e,t){var a=t||y,i=!0,r=!1,n=void 0;try{for(var l,s=a[Symbol.iterator]();!(i=(l=s.next()).done);i=!0){var o=l.value;if(e.id===o.tool.id&&e.sizeId===o.sizeId){var d={type:o.type};switch(d.type){case"circle":d.radius=o.radius;break;case"rectangle":case"oblong":d.length=o.width,d.width=o.height}return d}}}catch(e){r=!0,n=e}finally{try{!i&&s.return&&s.return()}finally{if(r)throw n}}return null}(e.tool,t?w(e.embeddedTool):void 0)}},setTools:function(e){var t=!(y.length=0),a=!1,i=void 0;try{for(var r,n=e[Symbol.iterator]();!(t=(r=n.next()).done);t=!0){var l=r.value;if(1===l.shapes.length&&0===l.shapes[0].x&&0===l.shapes[0].y){var s=!0,o=!1,d=void 0;try{for(var h,c=w(l)[Symbol.iterator]();!(s=(h=c.next()).done);s=!0){var u=h.value;y.push(u)}}catch(e){o=!0,d=e}finally{try{!s&&c.return&&c.return()}finally{if(o)throw d}}}else console.error("can not add combi-tool ",l.id)}}catch(e){a=!0,i=e}finally{try{!t&&n.return&&n.return()}finally{if(a)throw i}}},setArea:function(e){if(0<e.length){var t=!(v=0),a=!1,i=void 0;try{for(var r,n=e[Symbol.iterator]();!(t=(r=n.next()).done);t=!0){var l=r.value;if(!(l.isTop||l.isBottom||l.isLeft||l.isRight||0!==l.x.from||0!==l.y.from||0!==l.x.to||0!==l.y.to)){f=l;break}v++}}catch(e){a=!0,i=e}finally{try{!t&&n.return&&n.return()}finally{if(a)throw i}}}}};return Object.defineProperty(e,"supportedShapes",{get:function(){return y}}),e;function w(e){var t=[],a=e.shapes[0],i=1,r=1,n=parseFloat(new Decimal(a.width).dividedBy(a.height));n<1?i=parseFloat(new Decimal(i).times(n)):r=parseFloat(new Decimal(r).dividedBy(n));var l,s=!0,o=!1,d=void 0;try{for(var h,c=e.sizes[Symbol.iterator]();!(s=(h=c.next()).done);s=!0){var u=h.value,p={type:(l=a,l.width===l.height&&l.width===parseFloat(new Decimal(l.radius).times(2))?"circle":0===l.radius?"rectangle":l.width===parseFloat(new Decimal(l.radius).times(2))||l.height===parseFloat(new Decimal(l.radius).times(2))?"oblong":null),sizeId:u.id,sizeIndex:e.sizes.indexOf(u),tool:e};if(p.type){switch(p.type){case"circle":p.radius=parseFloat(new Decimal(i).times(u.value).times(.5));break;case"rectangle":case"oblong":p.width=parseFloat(new Decimal(i).times(u.value)),p.height=parseFloat(new Decimal(r).times(u.value))}t.push(p)}}}catch(e){o=!0,d=e}finally{try{!s&&c.return&&c.return()}finally{if(o)throw d}}return t}});
"use strict";!function(){function e(e,n,t,i){var a=this;function r(n){return n?a.manager.tools.find(function(e){return e.id===n}):null}function l(){var e={startX:0,endX:i.getDepth,startY:0,endY:i.totalLength};if(a.line.meta&&a.line.meta.area&&"number"==typeof a.line.meta.area.index){var n=a.manager.areas[a.line.meta.area.index];e.startX=n.unscaledStartX,e.endX=n.unscaledEndX,e.startY=n.unscaledStartY,e.endY=n.unscaledEndY}return e}a.line={meta:{}},a.manager=t.getManager("nuit-draw-stamping-rework"),Object.defineProperty(a,"firstStampMinVal",{get:function(){return Math.round(l().startX)}}),Object.defineProperty(a,"firstStampMaxVal",{get:function(){return Math.round(Math.min(l().endX,a.line.last||Number.MAX_VALUE))}}),Object.defineProperty(a,"lastStampMinVal",{get:function(){return Math.round(Math.max(l().startX,a.line.first||Number.MIN_VALUE))}}),Object.defineProperty(a,"lastStampMaxVal",{get:function(){return Math.round(l().endX)}}),Object.defineProperty(a,"offsetMinVal",{get:function(){return l().startY}}),Object.defineProperty(a,"offsetMaxVal",{get:function(){return l().endY}}),a.close=function(){n.hide()},a.submit=function(e){e&&e.preventDefault();if(a.form.$invalid)return;n.hide(a.line)},a.setToolProperties=function(){if(!a.line.tool||!a.line.tool.id)return;var e=r(a.line.tool.id);a.line.tool.size?a.line.tool.size=Math.min(a.line.tool.size,e.sizes.length-1):a.line.tool.size=0;a.line.tool.sizeId=e.sizes[a.line.tool.size].id,a.line.bounds||(a.line.bounds={});a.line.bounds.min||(a.line.bounds.min=e.distance.min);a.line.bounds.max||(a.line.bounds.max=e.distance.max)},a.getToolById=r,a.getSelectedAreaLabel=function(){if(a.line.meta&&a.line.meta.area&&"number"==typeof a.line.meta.area.index)return e("nuitTranslate")(a.manager.areas[a.line.meta.area.index].name);return e("translate")("PROFILE.SELECT_AREA")},a.setAreaProperties=function(){var e=l();a.line.first||(a.line.first=e.startX);a.line.last||(a.line.last=e.endX);a.offsetMinVal===a.offsetMaxVal&&(a.line.y=a.offsetMinVal);a.line.meta.area.id=a.manager.areas[a.line.meta.area.index].id},a.getAvailableTools=function(){return a.line.meta&&a.line.meta.area&&"number"==typeof a.line.meta.area.index?a.manager.tools.filter(function(e){return 0<=e.sizes.findIndex(function(e){return a.manager.areas[a.line.meta.area.index].isToolAllowed(e.id)})}):[]},a.getAvailableSizes=function(){if(!a.line.tool)return[];var e=a.getToolById(a.line.tool.id).sizes;return a.line.meta&&a.line.meta.area&&"number"==typeof a.line.meta.area.index?e.filter(function(e,n){return e.index=n,a.manager.areas[a.line.meta.area.index].isToolAllowed(e.id)}):e},a.updateAmount=function(){a.line.amount=Math.floor((a.line.last-a.line.first)/a.line.meta.distBetweenStamps)}}e.$inject=["$filter","$mdDialog","nuitEditor","nuitProfile"],angular.module("nuit.editor").controller("AddStampingLineDialogController",e)}();
"use strict";!function(){function n(o,l,e,u,n){var c=this;c.dynamicSegments=n,c.languages=["en"],c.currLang="en",c.close=function(){o.hide()},c.submit=function(n){n&&n.preventDefault();return e(function(n,e){return c.form.$invalid?function(){var n="Unresolved Errors",e="There are unresolved errors. Do you wish to continue? Unexpected behaviour may occur.",t="Yes",r="No";if(l.has("$translate")){var a=l.get("$translate");n=a.instant("ERRORS.UNKNOWN_ERROR"),e=a.instant("ERRORS.UNRESOLVED_ERROR_CONFIRMATION"),t=a.instant("APP.YES"),r=a.instant("APP.NO")}var i=o.confirm({multiple:!0}).title(n).textContent(e).ok(t).cancel(r);return o.show(i)}().then(n).catch(e):n()}).then(function(){var n=!0,e=!1,t=void 0;try{for(var r,a=c.dynamicSegments[Symbol.iterator]();!(n=(r=a.next()).done);n=!0){delete r.value._originalSegment}}catch(n){e=!0,t=n}finally{try{!n&&a.return&&a.return()}finally{if(e)throw t}}o.hide(c.dynamicSegments)}).catch(angular.noop)},function(){if(l.has("$translate")){var n=l.get("$translate");c.languages=n.getAvailableLanguageKeys(),c.currLang=n.use()}var e=!0,t=!1,r=void 0;try{for(var a,i=c.dynamicSegments[Symbol.iterator]();!(e=(a=i.next()).done);e=!0){var o=a.value;o._originalSegment=u.get(o.index)}}catch(n){t=!0,r=n}finally{try{!e&&i.return&&i.return()}finally{if(t)throw r}}}()}n.$inject=["$mdDialog","$injector","$q","nuitProfile","DynamicSegments"],angular.module("nuit.editor").controller("DynamicSegmentsDialogController",n)}();
"use strict";!function(){function n(u){return{restrict:"A",transclude:!0,require:"ngModel",scope:{nuitAngle:"&nuitAngle"},link:function(e,n,t,r){r.$parsers.push(function(n){n=u.clamp(parseInt(n),-180,180),r.$setViewValue(Math.round(Math.abs(n))),r.$render();var t=u.get(e.nuitAngle());return n*=t.bendingDir*u.DEG2RAD}),r.$formatters.push(function(n){return Math.abs(Math.round(n*u.RAD2DEG))})}}}n.$inject=["nuitProfile"],angular.module("nuit.editor").directive("nuitAngle",n)}();
"use strict";!function(){function n(s){return{restrict:"A",scope:{ngHold:"&",ngHoldDone:"&"},controller:["$scope","$element","$attrs",function(t,n,o){var l=[],e=null,c=0,u=0;function r(){console.log("Interaction start"),u=c=0,e=s(i)}function a(){e&&(s.cancel(e),t.$eval(t.ngHoldDone),e=null)}function i(){console.log("Interval tick oida"),t.$eval(t.ngHold);var n=l[c][0],o=l[c][1];++u===o&&(c=Math.min(c+1,l.length-1),u=0),e=s(i,n)}n.on("mousedown",r),n.on("touchstart",r),n.on("mouseup",a),n.on("touchend",a),n.on("mouseleave",a),n.on("touchcancel",a),(o.ngHoldInterval||"500").split(",").forEach(function(n){var o=n.split(":"),t=parseInt(o[0]),e=parseInt(o[1])||1;l.push([t,e])})}]}}n.$inject=["$timeout"],angular.module("nuit.editor").directive("ngHold",n)}();
"use strict";angular.module("nuit.editor").component("nuitDraw",{templateUrl:"_nuit_/components/nuit-draw/nuit-draw.template.html",controller:"nuitDrawController",controllerAs:"vm",transclude:!0,bindings:{editorConfig:"<",onConfigChanged:"&"}});
"use strict";angular.module("nuit.editor").constant("NUIT_DRAW_SETTINGS",{editor:{closeHem:!1,fullWidth:!1,rendering:{forceCanvas:!1,maxFPS:75},keepMaterial:!1,keepLength:!1},units:{length:{factor:1,decimals:0,symbol:"mm"}}});
"use strict";!function(){function e(n,e,r,t,o,i,u){var a=this,d=50,c=u;function l(e){e.preventDefault(),a.currentEditor.manager.$onMouseWheel&&a.currentEditor.manager.$onMouseWheel(e),n.$apply()}function s(e){a.currentEditor.manager.$onInput&&a.currentEditor.manager.$onInput(e)}function g(){a.renderer&&(clearTimeout(a.resizeTimeoutID),a.renderer.resize(0,0),a.resizeTimeoutID=setTimeout(function(){a.renderer.resize(a.element.clientWidth,a.element.clientHeight),a.currentEditor.manager.$onResize&&a.currentEditor.manager.$onResize(),f()},d))}function f(e){a.renderer&&a.currentEditor&&(null!==a.fpsSyncTimeoutID||e||(0<a.config.editor.rendering.maxFPS?a.fpsSyncTimeoutID=setTimeout(m,1e3/a.config.editor.rendering.maxFPS):m()))}function m(){clearTimeout(a.fpsSyncTimeoutID),a.fpsSyncTimeoutID=null,a.currentEditor.manager.$onPreRender&&a.currentEditor.manager.$onPreRender(),a.renderer.render(a.root),r.$broadcast(t.rendered),a.currentEditor.manager.$onPostRender&&a.currentEditor.manager.$onPostRender()}function E(){a.config=i.setConfig(angular.merge({},c,a.editorConfig)),a.onConfigChanged&&a.onConfigChanged({config:a.config})}a.config=angular.copy(c),a.element=null,a.renderer=null,a.root=new PIXI.Container,a.fpsSyncTimeoutID=null,a.resizeTimeoutID=null,Object.defineProperty(a,"currentEditor",{get:o.getEditor,set:o.useEditor}),n.$on(t.editorChanged,function(){a.root.removeChildren(0),a.root.addChildAt(a.currentEditor.scene,0),a.currentEditor.manager.$onUse&&a.currentEditor.manager.$onUse();f()}),n.$on(t.render,function(){f()}),a.$onInit=function(){E(),PIXI.utils.skipHello(),a.element=document.querySelector(".nuit-draw"),a.renderer=function(){var e={backgroundColor:16777215,antialias:!0};if(a.config.editor.rendering.forceCanvas)return console.warn("Deprecated canvas renderer forced"),new PIXI.CanvasRenderer(100,100,e);return PIXI.autoDetectRenderer(100,100,e)}(),a.element.appendChild(a.renderer.view),a.element.querySelector("canvas").setAttribute("touch-action","none"),angular.element(window).on("resize",g),angular.element("body").on("input",s),a.element.addEventListener("mousewheel",l,!1),a.element.addEventListener("DOMMouseScroll",l,!1),o.init(a.config),g()},a.$onChanges=function(e){if(!e.editorConfig||e.editorConfig.isFirstChange())return;E(),a.currentEditor.manager.$onChanges&&a.currentEditor.manager.$onChanges(e);f()},a.$onDestroy=function(){angular.element(window).off("resize",g),angular.element("body").off("keydown").off("input"),a.renderer.destroy(),a.renderer=null,o.reset()},a.render=f}e.$inject=["$scope","$log","$rootScope","nuitEditorEvents","nuitEditor","nuitProfile","NUIT_DRAW_SETTINGS"],angular.module("nuit.editor").controller("nuitDrawController",e)}();
"use strict";angular.module("nuit.editor").component("nuitDraw2d",{templateUrl:"_nuit_/components/nuit-draw-2d/nuit-draw-2d.template.html",controller:"nuitDraw2dController",controllerAs:"vm",transclude:!0,require:{editorCtrl:"^nuitDraw"}});
"use strict";angular.module("nuit.editor").constant("NUIT_DRAW_2D_SETTINGS",{editor:{nuitDraw2d:{style:{showArrows:!0,arrowColor:9047844,arrowThickness:1,arrowOpacity:.3,arrowHeight:20,arrowWidth:20,showGrid:!0,gridColor:14540253,gridWidth:20,gridPixelToMM:1,segmentColor:4473924,segmentFont:"Arial",segmentFontSize:14,segmentTextColor:21122,segmentTextDistanceFactor:1,segmentTextOffset:2,segmentTextBackgroundColor:16777215,segmentTextHightlightBackgroundColor:15658734,segmentPointerColor:0,segmentPointerOpacity:.2,segmentBorderThickness:3,segmentBackgroundColor:11184895,angleColor:9047844,angleFont:"Arial",angleFontSize:14,angleTextColor:9047844,angleBorderThickness:2,angleBorderOpacity:.3,angleDirection:!0,rulerFont:"Arial",rulerFontSize:14,rulerTextColor:255,rulerLineColor:0,rulerTextboxOffset:2,circleRulerRadius:20,circleRulerFillColor:16767232,circleRulerBorderColor:20864,circleRulerCrossColor:0,circleNewSegmentRadius:20,circleNewSegmentStroke:5,circleNewSegmentFillColor:16767232,circleNewSegmentBorderColor:20864,markStart:!1,markLineWidth:2,markLineColor:4473924,markWidth:15,showCircles:!0,hideBlank:!1,minMaterialThickness:1,rendererOffset:100},labels:{charInner:"I",charOuter:"A"},input:{wheelZoomFactor:1.1,initialZoomFactor:1.75,rulerSnappingDistance:10},rotationPerTick:1}}});
"use strict";!function(){function e(f,e,C,P,t,m,i){var D=this,n=i,T=10;function r(e){if(e.editorConfig){if(e.editorConfig.isFirstChange())return;y(),x(),W()}}function l(){D.grid.isDirty&&function(){if(!D.grid||D.scaleMultiplicator<=0)return;var e=Math.max(D.style.gridWidth*D.style.gridPixelToMM*D.scaleMultiplicator,1),t=new PIXI.Point(-2*e,-2*e),i=new PIXI.Point(D.editorCtrl.renderer.width+2*e,D.editorCtrl.renderer.height+2*e);D.grid.clear(),D.grid.lineStyle(1,D.style.gridColor);var n=t.x;for(;D.grid.moveTo(n,t.y),D.grid.lineTo(n,i.y),n+=e,n<=i.x;);var r=t.y;for(;D.grid.moveTo(t.x,r),D.grid.lineTo(i.x,r),r+=e,r<=i.y;);D.grid.x=C.loop(D.scene.x,e),D.grid.y=C.loop(D.scene.y,e),D.grid.isDirty=!1}(),D.requireRefresh&&(z(),D.requireRefresh=!1)}function s(){v(!0)}function a(e){var t=window.event||e;return t.preventDefault(),t.stopPropagation(),_(C.clamp(t.wheelDelta||-t.detail,-1,1)*D.config.editor.nuitDraw2d.input.wheelZoomFactor),!1}function o(e){if(0<=D.selection.index)if("segment"===D.selection.type){var t=D.visualSegments[D.selection.index];if(t){var i=document.activeElement;t.textLength.text=""===i.value?"???":i.value.substring(0,0<=i.value.indexOf(".")?i.value.indexOf(".")+3:i.value.length),Y()}}else if("angle"===D.selection.type){var n=D.visualSegments[D.selection.index];if(n){var r=document.activeElement;n.textAngle.text=""===r.value?"???°":r.value+"°",Y()}}}function g(){D.rootHitbox.width=D.renderer.width,D.rootHitbox.height=D.renderer.height,angular.element(D.editorCtrl.element).is(":visible")&&(A(),D.grid.isDirty=!0,W())}function c(e){console.error("set conicalbase:",e),P.setConicalBase(e)}function h(){return P.getConicalBase()}function d(e,t){return P.setType(e,t)}function u(){var i=this;function e(){var e=new PIXI.Graphics;e.lineStyle(5,D.style.circleRulerBorderColor,.1),e.beginFill(D.style.circleRulerFillColor,.1),e.drawCircle(0,0,D.style.circleRulerRadius),e.endFill(),e.lineStyle(1,D.style.circleRulerCrossColor,.5),e.moveTo(-D.style.circleRulerRadius,0),e.lineTo(D.style.circleRulerRadius,0),e.moveTo(0,-D.style.circleRulerRadius),e.lineTo(0,D.style.circleRulerRadius);var t=new PIXI.Container;return t.interactive=!0,t.buttonMode=!0,t.addChild(e),t.hitArea=t.getBounds(),t.alpha=1,oe(t,le),ce(t,ae),t}i.graphics=new PIXI.Graphics,i.circleStart=e(),i.circleEnd=e(),i.isMeasuring=!1,i.text=new PIXI.Text("0",{fontFamily:D.style.rulerFont,fontSize:D.style.rulerFontSize,fill:D.style.rulerTextColor,align:"center"}),i.graphics.addChild(i.circleStart),i.graphics.addChild(i.circleEnd),i.performMeasurement=function(){var e=we(i.circleStart,i.circleEnd)/D.scaleMultiplicator;e=.1*Math.round(10*e),i.text.text=xe(e)},i.showText=function(){if(2<i.graphics.children.length)return;i.refreshText(),i.graphics.addChild(i.text)},i.hideText=function(){if(i.graphics.children.length<=2)return;i.graphics.clear(),i.graphics.removeChildAt(2)},i.refreshText=function(){i.text.position.x=i.circleStart.x+.5*(i.circleEnd.x-i.circleStart.x-i.text.width),i.text.position.y=i.circleStart.y+.5*(i.circleEnd.y-i.circleStart.y-i.text.height),i.graphics.clear(),i.graphics.lineStyle(1,D.style.rulerLineColor,1),i.graphics.moveTo(i.circleStart.x,i.circleStart.y),i.graphics.lineTo(i.circleEnd.x,i.circleEnd.y),i.graphics.beginFill(16777215),i.graphics.drawRect(i.text.position.x-2*D.style.rulerTextboxOffset,i.text.position.y-D.style.rulerTextboxOffset,i.text.width+4*D.style.rulerTextboxOffset,i.text.height+2*D.style.rulerTextboxOffset)},i.setStart=function(e,t){i.circleStart.x=e,i.circleStart.y=t},i.setEnd=function(e,t){i.circleEnd.x=e,i.circleEnd.y=t},i.scale=function(e){i.circleStart.x*=e,i.circleStart.y*=e,i.circleEnd.x*=e,i.circleEnd.y*=e}}function p(){var x=this;x.segment=null;var r=new PIXI.Text("",{fontFamily:D.style.segmentFont,fontSize:D.style.segmentFontSize,fill:D.style.segmentTextColor,align:"center"}),t=new PIXI.Graphics;t.interactive=!0,t.buttonMode=!0,t.pointertap=d,t.pointerover=c,t.pointerout=h;var y=new PIXI.Text("",{fontFamily:D.style.angleFont,fontSize:D.style.angleFontSize,fill:D.style.angleTextColor,align:"center"});y.interactive=!0,y.buttonMode=!0,y.pointertap=u,y.pointerover=o,y.pointerout=g;var i=new PIXI.Graphics;i.interactive=!0,i.buttonMode=!0,i.pointerover=c,i.pointerout=h,i.pointertap=d;var n=new PIXI.Graphics;function l(){return x.segment.index===D.selection.index&&"angle"===D.selection.type}function s(){return x.segment.index===D.selection.index&&"segment"===D.selection.type}function e(e){t.clear(),t.lineStyle(1,D.style.segmentPointerColor,D.style.segmentPointerOpacity),e||s()?(t.beginFill(D.style.segmentTextHightlightBackgroundColor,1),i.alpha=.5):(t.beginFill(D.style.segmentTextBackgroundColor,1),q()?i.alpha=.3:i.alpha=0),t.drawRect(r.x-2*D.style.segmentTextOffset,r.y-D.style.segmentTextOffset,r.width+4*D.style.segmentTextOffset,x.textLength.height+2*D.style.segmentTextOffset),t.endFill(),Y()}function a(e){e||l()?n.alpha=.3:n.alpha=0,Y()}function o(){a(!0)}function g(){a()}function c(){e(!0)}function h(){e()}function d(){var e=x.segment.index;if(D.isAligning)return X(!1),O(),P.align(e),void v(!0);f.$broadcast(m.segmentFocused,{index:e,payload:{direction:"front"}})}function u(){f.$broadcast(m.angleFocused,x.segment.index)}n.interactive=!0,n.buttonMode=!0,n.pointerover=o,n.pointerout=g,n.pointertap=u,x.textAngle=y,x.textLength=r,x.angleHitbox=n,x.segmentHitbox=i,x.textLengthHitbox=t,x.assign=function(e){if(x.segment===e)return;x.segment=e},x.isAngleHighlighted=l,x.isSegmentHighlighted=s,x.redrawAngle=function(e){if(this.segment.isFirst())return;var t=Math.min(.5*x.segment.length-10/D.scaleMultiplicator,.5*x.segment.prev.length-10/D.scaleMultiplicator),i=Math.min(100/D.scaleMultiplicator,t),n=C.loop(x.segment.getAngleSum()-.5*x.segment.angleOffset,C.TWO_PI);if(0===Math.round(x.segment.angleOffset*C.RAD2DEG))y.text="";else{var r=Math.abs(Math.round(x.segment.angleOffset*C.RAD2DEG));D.style.angleDirection||(r=180-r),y.text=r+"°"}var l=y.getBounds(),s=Math.sqrt(Math.pow(i,2)-Math.pow(i,2)*Math.cos(Math.abs(x.segment.angleOffset)))*D.scaleMultiplicator,a=Math.asin(l.width/Math.hypot(l.width,l.height)),o=void 0,g=void 0,c=C.loop(n,Math.PI);g=c<a||c>Math.PI-a?(o=Math.hypot(l.height,Math.cos(n)*l.height),Math.hypot(l.width,Math.sin(n)*l.width)):(o=Math.hypot(l.width,Math.cos(n)*l.width),Math.hypot(l.height,Math.sin(n)*l.height));g-=10;var h=void 0,d=void 0;d=s>(o-=10)&&g<i||!D.style.angleDirection?(h=.5*i*Math.cos(n),.5*i*Math.sin(n)):(h=(-.5*l.width/D.scaleMultiplicator-2)*Math.cos(n),(-.5*l.height/D.scaleMultiplicator-2)*Math.sin(n));D.style.angleDirection||(h*=-1,d*=-1);Math.abs(x.segment.angleOffset)<C.PI_HALF?(y.x=x.segment.bendingArcCenter.x+h,y.y=x.segment.bendingArcCenter.y+d):(y.x=x.segment.getStartX()+h,y.y=x.segment.getStartY()+d);if(y.x*=D.scaleMultiplicator,y.y*=D.scaleMultiplicator,y.x-=.5*l.width,y.y-=.5*l.height,!D.style.angleDirection)return;var u=C.loop(x.segment.getAngleSum(),C.TWO_PI),f=C.loop(u-x.segment.angleOffset,C.TWO_PI),m=new PIXI.Point;Math.abs(x.segment.angleOffset)<C.PI_HALF?(m.x=x.segment.bendingArcCenter.x,m.y=x.segment.bendingArcCenter.y):(m.x=x.segment.getStartX(),m.y=x.segment.getStartY());if(m.x*=D.scaleMultiplicator,m.y*=D.scaleMultiplicator,Math.abs(x.segment.angleOffset)>=5*C.DEG2RAD){var p=-1===x.segment.bendingDir;e.lineStyle(D.style.angleBorderThickness,D.style.angleColor,D.style.angleBorderOpacity),e.moveTo(m.x+i*D.scaleMultiplicator*Math.cos(f),m.y+i*D.scaleMultiplicator*Math.sin(f)),e.arc(m.x,m.y,i*D.scaleMultiplicator,f,u,p)}},x.redrawArrow=function(e){var t=void 0;t=P.getVisibleSide()?ue(x.segment.getAngleSum()):ue(x.segment.getAngleSum()-Math.PI);t.position.x=this.segment.getCenterX()*D.scaleMultiplicator,t.position.y=this.segment.getCenterY()*D.scaleMultiplicator,e.addChild(t)},x.redrawTextboxTarget=function(e){var t=x.segment.getCenterX()*D.scaleMultiplicator,i=x.segment.getCenterY()*D.scaleMultiplicator;e.lineStyle(1,D.style.segmentPointerColor,D.style.segmentPointerOpacity),e.moveTo(x.textLength.x+.5*x.textLength.width,x.textLength.y+.5*x.textLength.height),e.lineTo(t,i)},x.refreshAngleHitbox=function(){if(x.segment.isFirst()||!D.style.angleDirection)return;var e=Math.min(.5*x.segment.length-10/D.scaleMultiplicator,.5*x.segment.prev.length-10/D.scaleMultiplicator),t=Math.min(100/D.scaleMultiplicator,e),i=-1===x.segment.bendingDir;n.clear(),n.lineStyle(D.style.angleBorderThickness,D.style.angleColor,1),n.beginFill(D.style.angleColor,.4),n.moveTo(0,0),n.arc(0,0,t*D.scaleMultiplicator,C.loop(x.segment.prev.getAngleSum()-Math.PI,C.TWO_PI),C.loop(x.segment.getAngleSum(),C.TWO_PI),i),n.endFill(),Math.abs(x.segment.angleOffset)<C.PI_HALF?(n.x=x.segment.bendingArcCenter.x*D.scaleMultiplicator,n.y=x.segment.bendingArcCenter.y*D.scaleMultiplicator):(n.x=x.segment.getStartX()*D.scaleMultiplicator,n.y=x.segment.getStartY()*D.scaleMultiplicator);a()},x.refreshSegmentHitbox=function(){if(i.clear(),void 0===x.segment.getType()){i.lineStyle(D.style.segmentBorderThickness,D.style.segmentBackgroundColor,1),i.beginFill(D.style.segmentBackgroundColor,.8);i.drawRoundedRect(.5*-x.segment.length*D.scaleMultiplicator,-5*D.scaleMultiplicator,x.segment.length*D.scaleMultiplicator,10*D.scaleMultiplicator,5*D.scaleMultiplicator),i.endFill(),i.x=x.segment.getCenterX()*D.scaleMultiplicator,i.y=x.segment.getCenterY()*D.scaleMultiplicator,i.rotation=x.segment.getAngleSum()}e()},x.refreshText=function(){var e=xe(x.segment.length);x.segment.backLength!==x.segment.length&&(e+=" ("+xe(x.segment.backLength)+")");null!==P.getMaterial()&&-1!==P.getMaterial().id&&P.getOriginalThickness()>=D.config.editor.innerOuterThicknessThreshold&&(x.segment.measureSide===P.MEASURE.Outer?e+=" "+D.config.editor.nuitDraw2d.labels.charOuter:e+=" "+D.config.editor.nuitDraw2d.labels.charInner);void 0!==x.segment.getType()?r.text=x.segment.getType():r.text=e;var t=r.getBounds();r.x=x.segment.getCenterX()*D.scaleMultiplicator-.5*t.width,r.y=x.segment.getCenterY()*D.scaleMultiplicator-.5*t.height;var i=this.segment.getAngleSum();this.segment.isLast()?i+=C.PI_HALF*x.segment.bendingDir:x.segment.isFirst()&&null!==x.segment.next?i+=C.PI_HALF*x.segment.next.bendingDir:0===x.segment.angleOffset&&-1===x.segment.bendingDir||!x.segment.isLast()&&0===x.segment.next.angleOffset&&-1===x.segment.next.bendingDir?i+=Math.PI+C.PI_HALF:x.segment.isInner()?this.segment.bendingDir===x.segment.next.bendingDir&&-1===x.segment.bendingDir?i+=Math.PI+C.PI_HALF:x.segment.bendingDir!==x.segment.next.bendingDir?Math.abs(x.segment.angleOffset)>Math.abs(x.segment.next.angleOffset)?(i+=C.PI_HALF*x.segment.next.bendingDir,n*=Math.sin(C.clamp(Math.abs(x.segment.angleOffset),0,C.PI_HALF))):Math.abs(this.segment.angleOffset)<Math.abs(x.segment.next.angleOffset)?(i-=C.PI_HALF*x.segment.next.bendingDir,n*=Math.sin(C.clamp(Math.abs(x.segment.next.angleOffset),0,C.PI_HALF))):(i-=C.PI_HALF*x.segment.next.bendingDir*(x.segment.next.length>x.segment.prev.length?1:-1),n*=.5):i+=C.PI_HALF:i+=C.PI_HALF;var n=Math.max(t.width,t.height)+Math.max(D.style.arrowWidth,D.style.arrowHeight);n=Math.min(100,n),r.x+=n*D.style.segmentTextDistanceFactor*Math.cos(i),r.y+=n*D.style.segmentTextDistanceFactor*Math.sin(i),r.x=Math.round(r.x),r.y=Math.round(r.y)},x.setSegmentHighlight=e,x.setAngleHighlight=a}function x(){N(),D.style.showGrid&&D.root.addChild(D.grid),D.root.addChild(D.rootHitbox),D.root.addChild(D.scene),Y()}function y(){D.config=angular.merge({},n,D.editorCtrl.config),D.style=D.config.editor.nuitDraw2d.style}function M(e){var t=new PIXI.Graphics;t.lineStyle(D.style.circleNewSegmentStroke,D.style.circleNewSegmentBorderColor,1),t.beginFill(D.style.circleNewSegmentFillColor,1),t.drawCircle(0,0,D.style.circleNewSegmentRadius);var i=new PIXI.Container;return i.interactive=!0,i.buttonMode=!0,i.isEnd=e,i.hitArea=new PIXI.Circle(0,0,20),i.alpha=.5,oe(i,J),ce(i,ee),i.fakeOnCircleDragEnd=ee,i.addChild(t),i}function w(e){P.rotate(e*Math.PI/180*D.config.editor.nuitDraw2d.rotationPerTick),E(!1),v(!0)}function v(e){if(P.isEmpty())return U(D.config.editor.nuitDraw2d.input.initialZoomFactor),V(1),Z(0,0),void Y();var a=P.getBounds();if(e){var o=0,g=0;D.visualSegments.forEach(function(e){var t=-1*(e.textLength.x/D.scaleMultiplicator-a.x.min),i=(e.textLength.x+e.textLengthHitbox.width)/D.scaleMultiplicator-a.x.max,n=Math.round(Math.max(t,i));o<n&&(o=n);var r=-1*(e.textLength.y/D.scaleMultiplicator-a.y.min),l=(e.textLength.y+e.textLengthHitbox.height)/D.scaleMultiplicator-a.y.max,s=Math.round(Math.max(r,l));g<s&&(g=s)}),o*=2*D.style.segmentTextDistanceFactor,g*=2*D.style.segmentTextDistanceFactor,E(!1),V(Math.min((D.renderer.width-D.style.rendererOffset)/(a.getWidth()+o),(D.renderer.height-D.style.rendererOffset)/(a.getHeight()+g))),1!==D.scaleFactor&&U(1-.01*D.scaleFactor)}Z(a.getCenterX(),a.getCenterY()),W(),Y()}function A(){var e,i,n,r,l,s;(U(D.config.editor.nuitDraw2d.input.initialZoomFactor),V(1),Z(0,0),P.isEmpty())?Y():function(){var t=P.getBounds();for(e=D.scaleFactor,i=0;i<=10&&(s=l=r=n=0,D.visualSegments.forEach(function(e){[e.textLength,e.textAngle].forEach(function(e){n=I(t.x.min,e.x,n),s=I(t.y.min,e.y,s),r=b(t.x.max,e.x+e.width,r),l=b(t.y.max,e.y+e.height,l)})}),[n,s,r,l].forEach(function(e){D.style.segmentTextDistanceFactor}),E(!1),V(Math.min((D.renderer.width-D.style.rendererOffset)/(t.getWidth()+(n+r)),(D.renderer.height-D.style.rendererOffset)/(t.getHeight()+(l+s)))),1!==D.scaleFactor&&U(1-.01*D.scaleFactor),Z(t.getCenterX()+.5*(-n+r),t.getCenterY()+.5*(l-s)),e!==D.scaleFactor);i++)10===i?(V(Math.min(D.scaleFactor,e)),U(1-.01*D.scaleFactor)):(z(),e=D.scaleFactor);Y()}()}function I(e,t,i){return t/D.scaleMultiplicator<e?Math.round(Math.max(e-t/D.scaleMultiplicator,i)):i}function b(e,t,i){return t/D.scaleMultiplicator>e?Math.round(Math.max(t/D.scaleMultiplicator-e,i)):i}function _(e){0<e?U(D.zoomFactor*e)&&D.ruler.scale(e):e<0&&U(D.zoomFactor/Math.abs(e))&&D.ruler.scale(1/Math.abs(e)),v()}function S(e){e=parseInt(e),isNaN(e)||"segment"===D.selection.type&&D.selection.index===e||D.visualSegments.length<=e||(O(),D.selection.type="segment",D.selection.index=e,D.visualSegments[D.selection.index].setSegmentHighlight(),W(),Y())}function F(e){e=parseInt(e),isNaN(e)||"angle"===D.selection.type&&(D.selection.index===e||D.visualSegments.length<=e)||(O(),D.selection.type="angle",D.selection.index=e,D.visualSegments[D.selection.index].angleHitbox.alpha=1,D.visualSegments[D.selection.index].textAngle.style.stroke=D.style.angleTextHighlightColor,D.visualSegments[D.selection.index].textAngle.style.strokeThickness=6,W(),Y())}function O(){if(!(D.selection.index<0&&D.selection.index>=D.visualSegments.length)){var e=D.selection.index,t=D.selection.type;D.selection.type="none",D.selection.index=-1,"angle"===t?(D.visualSegments[e].angleHitbox.alpha=0,D.visualSegments[e].textAngle.style.strokeThickness=0):"segment"===t&&D.visualSegments[e].setSegmentHighlight(),Y()}}function L(){D.ruler&&E(!D.ruler.isMeasuring)}function E(e){D.ruler.isMeasuring!==e&&(e?(D.isAligning&&X(!1),D.ruler.isMeasuring=!0,D.ruler.setStart(-D.scene.x+1*D.renderer.width/3,-D.scene.y+.5*D.renderer.height),D.ruler.setEnd(-D.scene.x+2*D.renderer.width/3,-D.scene.y+.5*D.renderer.height),D.ruler.performMeasurement(),D.ruler.showText(),D.scene.addChild(D.ruler.graphics)):(D.ruler.isMeasuring=!1,D.ruler.hideText(),D.scene.removeChild(D.ruler.graphics)),W(),Y())}function G(){return X(!D.isAligning),this}function X(e){D.isAligning!==e&&(D.isAligning=e,D.isAligning&&(O(),E(!1)),W(),Y())}function H(){P.toggleVisibleSide(),W(),Y()}function R(){D._conicalMode=!D._conicalMode}function k(){!function(e){if(D.visualSegments.length>e)D.visualSegments.length=e;else if(D.visualSegments.length<e)for(;D.visualSegments.length<e;)D.visualSegments.push(new p)}(P.count()),D.scene.addChild(D.profileGraphics),D.profileGraphics.clear(),D.profileGraphics.removeChildren();for(var e=P.first(),t=null,i=1<P.getThickness()?P.getThickness():0,n=Math.max(1,P.getThickness()),r=0,l=0;e;){(t=D.visualSegments[e.index]).assign(e);var s=e.getAngleSum();if(D.profileGraphics.lineStyle(de(),D.style.segmentColor,1),e.isLast()?(l=e.close?(r=n*Math.cos(s-C.PI_HALF*e.bendingDir),n*Math.sin(s-C.PI_HALF*e.bendingDir)):r=0,void 0!==e.getType()?fe(D.profileGraphics,e.getXAt(-e.lengthOffset-.1),e.getYAt(-e.lengthOffset-.1),e.end.x+r-.5*e.deltaX(),e.end.y+l-.5*e.deltaY()):fe(D.profileGraphics,e.getXAt(-e.lengthOffset-.1),e.getYAt(-e.lengthOffset-.1),e.end.x+r,e.end.y+l)):e.isFirst()?(l=e.close?(r=n*Math.cos(s-C.PI_HALF*e.next.bendingDir),n*Math.sin(s-C.PI_HALF*e.next.bendingDir)):r=0,void 0!==e.getType()?fe(D.profileGraphics,e.getCenterX()+r,e.getCenterY()+l,e.getXAt(e.length+e.next.lengthOffset-.5*i+.1),e.getYAt(e.length+e.next.lengthOffset-.5*i+.1)):fe(D.profileGraphics,e.getStartX()+r,e.getStartY()+l,e.getXAt(e.length+e.next.lengthOffset-.5*i+.1),e.getYAt(e.length+e.next.lengthOffset-.5*i+.1))):fe(D.profileGraphics,e.getXAt(-e.lengthOffset-.1),e.getYAt(-e.lengthOffset-.1),e.getXAt(e.length+e.next.lengthOffset-i+.1),e.getYAt(e.length+e.next.lengthOffset-i+.1)),D.style.showArrows&&t.redrawArrow(D.profileGraphics),!e.isFirst()){var a=e.bendingArcCenter.x*D.scaleMultiplicator,o=e.bendingArcCenter.y*D.scaleMultiplicator,g=s-e.angleOffset-C.PI_HALF*e.bendingDir,c=s+C.PI_HALF*e.bendingDir;D.profileGraphics.moveTo(e.prev.getXAt(e.prev.length+e.lengthOffset-i*(e.prev.isFirst()?.5:1))*D.scaleMultiplicator,e.prev.getYAt(e.prev.length+e.lengthOffset-i*(e.prev.isFirst()?.5:1))*D.scaleMultiplicator),D.profileGraphics.arc(a,o,de(),g,c,1===e.bendingDir),t.redrawAngle(D.profileGraphics)}t.refreshText(),t.redrawTextboxTarget(D.profileGraphics),t.refreshSegmentHitbox(),D.scene.addChild(t.segmentHitbox),e.isFirst()||(t.refreshAngleHitbox(),D.scene.addChild(t.angleHitbox)),e=e.next}for(e=P.first();null!==e;)t=D.visualSegments[e.index],e.isFirst()||D.profileGraphics.addChild(t.textAngle),D.profileGraphics.addChild(t.textLengthHitbox),D.profileGraphics.addChild(t.textLength),e=e.next}function z(){if(D.scene.removeChildren(),!P.isEmpty()&&(k(),P.first().isWrap()||(D.style.showCircles&&D.scene.addChild(D.circleStart),D.style.markStart&&D.scene.addChild(D.startMark)),!P.last().isWrap()&&D.style.showCircles&&(D.scene.addChild(D.circleEnd),D.circleEnd.x=P.last().end.x*D.scaleMultiplicator,D.circleEnd.y=P.last().end.y*D.scaleMultiplicator),D.ruler.isMeasuring&&(D.ruler.performMeasurement(),D.ruler.refreshText(),D.ruler.showText(),D.scene.addChild(D.ruler.graphics)),P.hasIntersections())){var e=P.getIntersections();D.profileGraphics.lineStyle(1*D.scaleMultiplicator,16711680,.6),D.profileGraphics.beginFill(16711680,.1);var t=!0,i=!1,n=void 0;try{for(var r,l=e[Symbol.iterator]();!(t=(r=l.next()).done);t=!0){var s=r.value;D.profileGraphics.drawCircle(s.x*D.scaleMultiplicator,s.y*D.scaleMultiplicator,7*D.scaleMultiplicator)}}catch(e){i=!0,n=e}finally{try{!t&&l.return&&l.return()}finally{if(i)throw n}}D.profileGraphics.endFill()}}function W(){D.requireRefresh=!0}function Y(){D.editorCtrl.render()}function B(){D.scaleMultiplicator=D.scaleFactor*D.zoomFactor,D.grid.isDirty=!0}function N(){D.scene.removeChildren(),D.zoomFactor=D.config.editor.nuitDraw2d.input.initialZoomFactor,E(!(D.scaleFactor=1)),Z(0,0),B(),X(!1),W()}function q(){return D.isAligning}function j(){return!!D.ruler&&D.ruler.isMeasuring}function Z(e,t){D.cameraPos.x=e,D.cameraPos.y=t,D.scene.x=.5*D.renderer.width-e*D.scaleMultiplicator,D.scene.y=.5*D.renderer.height-t*D.scaleMultiplicator,D.grid.x=C.loop(D.scene.x,D.style.gridWidth*D.style.gridPixelToMM*D.scaleMultiplicator),D.grid.y=C.loop(D.scene.y,D.style.gridWidth*D.style.gridPixelToMM*D.scaleMultiplicator)}function U(e){return e=C.clamp(e,.05,6),D.zoomFactor!==e&&(D.zoomFactor=e,B(),!0)}function V(e){D.scaleFactor!==e&&(D.scaleFactor=Math.max(.01,e),B())}function K(){return!P.isEmpty()}function J(e){this.data=e.data,this.dragging=!0,O(),he(this,Q),ge(this,Q)}function Q(e){var t=0,i=0,n=de(),r=0,l=!1;if(this.dragging){var s=this.data.getLocalPosition(this.parent);D.newLine.clear(),D.newLine.lineStyle(de(),D.style.segmentColor,1),D.scene.addChild(D.newLine),D.newLine.moveTo(this.x,this.y),this.new_line_x=s.x,this.new_line_y=s.y,i=Math.round(Math.sqrt((this.y-this.new_line_y)*(this.y-this.new_line_y)+(this.x-this.new_line_x)*(this.x-this.new_line_x))/D.scaleMultiplicator),this.isEnd&&(t=P.last().getAngleSum()*C.RAD2DEG);var a=Math.atan2(this.new_line_y-this.y,this.new_line_x-this.x);e.data.originalEvent.shiftKey&&(a=this.isEnd?ye(pe(ye(a-P.last().absoluteAngle)*C.RAD2DEG)*C.DEG2RAD+P.last().absoluteAngle):ye(pe(ye(a-P.first().absoluteAngle)*C.RAD2DEG)*C.DEG2RAD+P.first().absoluteAngle)),this.raw_new_angle=a,l=0<=(r=this.isEnd?Me(180-a*C.RAD2DEG+t):Me(180+a*C.RAD2DEG-Math.abs(P.first().angleOffset*C.RAD2DEG)*P.first().bendingDir)),D.isAligning||(i=Math.max(T,i),r<=5&&-5<r&&(r=0)),this.isEnd||(l=!l),this.bdir=l,this.new_angle=r,this.new_length=i,a=this.isEnd?(180-r+t)*C.DEG2RAD:(r-180+Math.abs(P.first().angleOffset*C.RAD2DEG)*P.first().bendingDir)*C.DEG2RAD;var o=0,g=0;if(0===r){g=l?(o=n*Math.cos(a-C.PI_HALF),n*Math.sin(a-C.PI_HALF)):(o=n*Math.cos(a+C.PI_HALF),n*Math.sin(a+C.PI_HALF));var c=me(a-C.PI_HALF,n);D.newLine.moveTo(this.x+c.x,this.y+c.y),D.newLine.arc(this.x+o,this.y+g,n,a-C.PI_HALF+5*C.DEG2RAD,a+C.PI_HALF-5*C.DEG2RAD,1),D.newLine.moveTo(this.x+2*o,this.y+2*g)}this.new_d_x=i*D.scaleMultiplicator*Math.cos(a),this.new_d_y=i*D.scaleMultiplicator*Math.sin(a);var h=this.x+this.new_d_x+o,d=this.y+this.new_d_y+g;D.newLine.lineTo(h,d);var u=new PIXI.Text(xe(i),{fontFamily:D.style.segmentFont,fontSize:D.style.segmentFontSize,fill:D.style.segmentTextColor,align:"center"});u.position.x=this.x+.5*(h-this.x)-u.width/2,u.position.y=this.y+.5*(d-this.y)-u.height/2,D.newLine.removeChildren(),D.newLine.addChild(u);var f=Math.min(i/2,100),m=Math.min(100,f*D.scaleFactor);D.newLine.lineStyle(2,D.style.angleColor,.3);var p=0,x=0,y=1,M=0;p=(x=this.isEnd?ye((P.last().getAngleSum()*C.RAD2DEG+180)*C.DEG2RAD):-1===P.first().bendingDir?ye((180-Math.abs(P.first().angleOffset*C.RAD2DEG))*C.DEG2RAD):ye((180+Math.abs(P.first().angleOffset*C.RAD2DEG))*C.DEG2RAD),ye(a)),0<=Math.sin(x-p)?(y=0,x<p&&(M=Math.PI)):p<x&&(M=Math.PI),M+=p+(x-p)/2;var w=me(p,m);D.newLine.moveTo(this.x+w.x,this.y+w.y),D.newLine.arc(this.x,this.y,m,p,x,y);var v=.5*m*Math.cos(M),A=.5*m*Math.sin(M),I=new PIXI.Text(Math.abs(Math.round(r))+"°",{fontFamily:D.style.angleFont,fontSize:D.style.angleFontSize,fill:D.style.angleTextColor,align:"center"});I.position.x=this.x+v-I.width/2,I.position.y=this.y+A-I.height/2,D.newLine.addChild(I)}Y()}function ee(){if(this.dragging)if(he(this,Q),W(),void 0===this.new_length||void 0===this.new_angle||this.new_length<T)this.new_length=0;else{if(this.isEnd)this.raw_new_angle=C.loop(this.raw_new_angle-P.last().getAngleSum(),C.TWO_PI),this.raw_new_angle*=C.RAD2DEG,this.raw_new_angle=Math.round(this.raw_new_angle),175<this.raw_new_angle&&this.raw_new_angle<185&&(this.bdir=180<this.raw_new_angle?1:-1,this.raw_new_angle=180),this.raw_new_angle*=C.DEG2RAD,P.add(this.new_length,this.raw_new_angle,P.count(),this.bdir);else{this.raw_new_angle+=Math.PI,this.raw_new_angle=C.loop(this.raw_new_angle,C.TWO_PI);var e=C.loop(Math.abs(this.raw_new_angle+C.TWO_PI-P.first().angle),C.TWO_PI);e>175*C.DEG2RAD&&e<185*C.DEG2RAD&&(P.first().bendingDir=e>Math.PI?-1:1,this.raw_new_angle=P.first().angle+Math.PI),P.add(this.new_length,this.raw_new_angle,0,this.bdir);var t=this.data.getLocalPosition(this.parent);D.ruler.setStart(D.ruler.circleStart.x-t.x,D.ruler.circleStart.y-t.y),D.ruler.setEnd(D.ruler.circleEnd.x-t.x,D.ruler.circleEnd.y-t.y)}delete this.dragging,delete this.data,delete this.new_length}}function te(e){if(he(this,ie),ge(this,ie),e.data.originalEvent.touches&&1<e.data.originalEvent.touches.length){var t=new PIXI.Point(e.data.originalEvent.touches[0].clientX,e.data.originalEvent.touches[0].clientY),i=new PIXI.Point(e.data.originalEvent.touches[1].clientX,e.data.originalEvent.touches[1].clientY);return this.pinch_start_dist=we(t,i),void(this.zoomlevel_old=D.zoomFactor)}this.data=e.data,this.isDragging=!0,K()?(this.pointerOrigin=this.data.getLocalPosition(this.parent),this.cameraOrigin=D.cameraPos.clone(),O()):(this.pointerOrigin=this.data.getLocalPosition(D.scene),D.scene.addChild(D.newLine),D.newLine.clear())}function ie(e){if(e.data.originalEvent.touches){var t=e.data.originalEvent.touches;if(1<t.length){var i=new PIXI.Point(t[0].clientX,t[0].clientY),n=new PIXI.Point(t[1].clientX,t[1].clientY);return U(this.zoomlevel_old*we(i,n)/this.pinch_start_dist),void v()}}if(this.isDragging)if(K()){var r=this.data.getLocalPosition(this.parent),l=r.x-this.pointerOrigin.x,s=r.y-this.pointerOrigin.y;Z(this.cameraOrigin.x-l/D.scaleMultiplicator,this.cameraOrigin.y-s/D.scaleMultiplicator)}else{var a=this.data.getLocalPosition(D.scene);l=a.x-this.pointerOrigin.x,s=a.y-this.pointerOrigin.y;this.segmentAngle=Math.atan2(s,l),e.data.originalEvent.shiftKey&&(this.segmentAngle=pe(this.segmentAngle*C.RAD2DEG)*C.DEG2RAD);var o=Math.max(T,we(this.pointerOrigin,a));a.x=this.pointerOrigin.x+o*Math.cos(this.segmentAngle),a.y=this.pointerOrigin.y+o*Math.sin(this.segmentAngle),this.segmentLength=o/D.scaleMultiplicator,this.segmentLength=function(e){var t=D.config.units.length?D.config.units.length.factor:1,i=D.config.units.length?D.config.units.length.decimals:0;return 0===i&&1===t?Math.round(e):parseFloat((e/t).toFixed(i))*t}(this.segmentLength);var g=new PIXI.Text(xe(this.segmentLength),{fontFamily:D.style.angleFont,fontSize:D.style.angleFontSize,fill:D.style.angleTextColor,align:"center"});g.position.x=this.pointerOrigin.x+.5*(l-g.width),g.position.y=this.pointerOrigin.y+.5*(s-g.height),D.newLine.clear(),D.newLine.lineStyle(de(),D.style.segmentColor,1),D.newLine.moveTo(this.pointerOrigin.x,this.pointerOrigin.y),D.newLine.lineTo(a.x,a.y),D.newLine.removeChildren(),D.newLine.addChild(g)}Y()}function ne(e){if(re(D.circleStart,e),re(D.circleEnd,e),he(this,ie),this.isDragging){if(K())Y(),delete this.cameraOrigin;else{if(isNaN(this.segmentLength))return;this.segmentLength>=T&&(P.add(this.segmentLength,this.segmentAngle),Z(-this.pointerOrigin.x/D.scaleMultiplicator,-this.pointerOrigin.y/D.scaleMultiplicator)),delete this.segmentAngle,delete this.segmentLength}delete this.pointerOrigin,delete this.isDragging,delete this.data,W(),Y()}}function re(e,t){e.dragging&&e.fakeOnCircleDragEnd(t)}function le(e){$("a").first().focus(),he(this,se),ge(this,se),this.eventData=e.data,this.isDragging=!0,O(),D.ruler.hideText(),Y()}function se(){if(this.isDragging){var e=this.eventData.getLocalPosition(this.parent);this.x=e.x,this.y=e.y,function(e,t){{if(t*=t,ve(e,D.circleEnd)<=t)return e.x=D.circleEnd.x,e.y=D.circleEnd.y;for(var i=P.first(),n=new PIXI.Point(0,0);i;){if(n.x=i.start.x*D.scaleMultiplicator,n.y=i.start.y*D.scaleMultiplicator,ve(e,n)<=t)return e.x=n.x,e.y=n.y;i=i.next}}}(this,D.config.editor.nuitDraw2d.input.rulerSnappingDistance),Y()}}function ae(){he(this,se),D.ruler.performMeasurement(),D.ruler.showText(),D.scene.addChild(D.ruler.graphics),Y(),delete this.isDragging,delete this.eventData}function oe(e,t){e.on("pointerdown",t)}function ge(e,t){e.on("pointermove",t)}function ce(e,t){e.on("pointerup",t).on("pointerupoutside",t)}function he(e,t){e.off("pointermove",t)}function de(){return Math.max(D.style.minMaterialThickness,P.getThickness())*D.scaleMultiplicator}function ue(e,t){var i=.5*de();t?t.clear():t=new PIXI.Graphics;var n=D.style.arrowHeight/2+i,r=D.style.arrowHeight+i,l=D.style.arrowWidth/2,s=D.style.arrowWidth/4;return t.lineStyle(D.style.arrowThickness,D.style.arrowColor,D.style.arrowOpacity),t.moveTo(0,i),t.lineTo(l,n),t.lineTo(s,n),t.lineTo(s,r),t.lineTo(-s,r),t.lineTo(-s,n),t.lineTo(-l,n),t.lineTo(0,i),t.rotation=e,t}function fe(e,t,i,n,r){e.moveTo(t*D.scaleMultiplicator,i*D.scaleMultiplicator),e.lineTo(n*D.scaleMultiplicator,r*D.scaleMultiplicator)}function me(e,t){return new PIXI.Point(Math.cos(e)*t,Math.sin(e)*t)}function pe(e){return 85<e&&e<95?e=90:-95<e&&e<-85?e=-90:e<-175||175<e?e=180:-5<e&&e<5&&(e=0),e}function xe(e){var t=D.config.units.length?D.config.units.length.factor:1,i=D.config.units.length?D.config.units.length.decimals:0;return(e/t).toFixed(i)}function ye(e){return C.loop(e+Math.PI,C.TWO_PI)-Math.PI}function Me(e){return C.loop(e+180,360)-180}function we(e,t){var i=t.x-e.x,n=t.y-e.y;return Math.sqrt(i*i+n*n)}function ve(e,t){var i=t.x-e.x,n=t.y-e.y;return i*i+n*n}D.config=angular.copy(n),D.style=D.config.editor.nuitDraw2d.style,D.root=new PIXI.Container,D.rootHitbox=new PIXI.Container,D.scene=new PIXI.Container,D.rotationTimeoutID=null,D.selection={type:"none",index:-1},D.isAligning=!1,D.cameraPos=new PIXI.Point(0,0),D.zoomFactor=1,D.scaleFactor=1,D.scaleMultiplicator=D.zoomFactor*D.scaleFactor,D.grid=new PIXI.Graphics,D.profileGraphics=new PIXI.Graphics,D.visualSegments=[],D.container=new PIXI.Container,D.newLine=new PIXI.Graphics,D.ruler=null,D.circleStart=null,D.circleEnd=null,D.startMark=null,D.manager=null,D.requireRefresh=!1,D._conicalMode=!1,Object.defineProperty(D,"totalLength",{get:function(){return P.totalLength}}),Object.defineProperty(D,"totalLengthWithoutOffset",{get:function(){return P.totalLengthWithoutOffset}}),Object.defineProperty(D,"renderer",{get:function(){return D.editorCtrl.renderer}}),D.$onInit=function(){y(),D.rootHitbox=function(){var e=new PIXI.Container;return e.interactive=!0,e.width=100,e.height=100,e.buttonMode=!0,e.hitArea=new PIXI.Circle(0,0,1e4),oe(e,te),ce(e,ne),e}(),D.ruler=new u,D.circleStart=M(0),D.circleEnd=M(1),D.startMark=function(){var e=D.style.markWidth/2,t=new PIXI.Graphics;t.lineStyle(D.style.markLineWidth,D.style.markLineColor,1),t.moveTo(-e,-e),t.lineTo(e,e),t.moveTo(e,-e),t.lineTo(-e,e);var i=new PIXI.Container;return i.addChild(t),i}(),x(),function(){var e=new t.Manager;e.$onChanges=r,e.$onPreRender=l,e.$onMouseWheel=a,e.$onResize=g,e.$onInput=o,e.$onUse=s,e.toggleRuler=L,e.setRuler=E,e.center=v,e.iterativeCenter=A,e.zoom=_,e.clear=N,e.refresh=z,e.isAligning=q,e.toggleAligning=G,e.toggleVisibleSide=H,e.toggleConicalMode=R,e.isMeasuring=j,e.highlightSegment=S,e.highlightAngle=F,e.rotate=w,e.setConicalBase=c,e.getConicalBase=h,e.invertOrder=function(){P.invertOrder(),A()},e.setType=d,Object.defineProperty(e,"conicalMode",{get:function(){return D._conicalMode}}),D.manager=Object.freeze(e)}(),t.registerEditor("nuit-draw-2d",D.manager,D.root)},D.$onChanges=r,D.$onDestroy=function(){t.unregisterEditor("nuit-draw-2d")},D.refresh=z,e.$on(m.segmentFocused,function(e,t){S(t.index)}),e.$on(m.angleFocused,function(e,t){F(t)}),e.$on(m.clearSelection,function(){O()}),e.$on(m.segmentAdded,function(e,t){if(t.isFirst()){var i={x:D.cameraPos.x,y:D.cameraPos.y};Z(i.x+t.deltaX(),i.y+t.deltaY())}W()}),e.$on(m.segmentRemoved,function(e,t){if(t.isFirst()){var i={x:D.cameraPos.x,y:D.cameraPos.y};Z(i.x-t.deltaX(),i.y-t.deltaY())}W()}),e.$on(m.segmentLengthChanged,W),e.$on(m.segmentAngleChanged,W),e.$on(m.segmentBendingChanged,W),e.$on(m.segmentCloseChanged,W),e.$on(m.segmentConicalChanged,W),e.$on(m.segmentMeasureChanged,W),e.$on(m.profileCleared,W),e.$on(m.setType,W)}e.$inject=["$rootScope","$scope","nuitmath","nuitProfile","nuitEditor","nuitEditorEvents","NUIT_DRAW_2D_SETTINGS"],angular.module("nuit.editor").controller("nuitDraw2dController",e)}();
"use strict";angular.module("nuit.editor").component("nuitDrawStamping",{template:"",controller:"nuitDrawStampingController",controllerAs:"vm",transclude:!0,require:{editorCtrl:"^nuitDraw"}});
"use strict";angular.module("nuit.editor").constant("NUIT_DRAW_STAMPING_SETTINGS",{editor:{nuitDrawStamping:{style:{rendererOffset:100,wasteBorderWidth:1,wasteBorderColor:16711680,wasteBorderOpacity:1,wasteFillColor:16751001,wasteFillOpacity:1,segmentBorderWidth:1,segmentBorderColor:0,segmentBorderOpacity:1,segmentFillColor:15395562,segmentFillOpacity:1,segmentHoverColor:14737632,segmentHoverOpacity:1,segmentConicalColor:14342874,segmentConicalOpacity:1,segmentConicalHoverColor:13684944,segmentConicalHoverOpacity:1,segmentConicalBaseColor:13290186,segmentConicalBaseOpacity:1,segmentConicalBaseHoverColor:12632256,segmentConicalBaseHoverOpacity:1,wrapFillColor:14540287,wrapFillOpacity:1,showWrapText:!1,fontFamily:"Arial",fontSize:19,fontOffset:15,fontStrokeColor:15705360,fontStrokeThickness:3}}}});
"use strict";!function(){function e(e,t,o,i,r,l){var n=this,a=l;function c(){n.scene.x=n.renderer.width/2,n.scene.y=n.renderer.height/2}function s(e){e.preventDefault(),e.stopPropagation();var t=r.clamp(e.wheelDelta||-e.detail,-1,1);n.tool.scale+=Math.sign(t),n.tool.scale=Math.max(1,n.tool.scale),n.editorCtrl.render()}function h(){n.scale=Math.min((n.renderer.width-120)/r.depth,(n.renderer.height-120)/r.totalLength),c(),function(){n.profileGraphics.clear(),n.profileGraphics.lineStyle(1,0,1),n.profileGraphics.beginFill(11184810,1);var e=0;for(var t in r.getAll()){var o=r.getAll()[t].length;if(n.profileGraphics.drawRect(-r.depth/2*n.scale,(-r.totalLength/2+e)*n.scale,r.depth*n.scale,o*n.scale),n.profileGraphics.children.length<=t){n.config.units||(n.config.units={length:{factor:1}});var i=new PIXI.Text(r.getAll()[t].length/n.config.units.length.factor,{fontFamily:"Arial",fontSize:14,fill:526344,align:"center"});i.interactive=!1,i.hitArea=new PIXI.Rectangle(0,0,0,0),i.rotation=Math.PI/2,n.profileGraphics.addChild(i)}var l=(-r.totalLength/2+e+o/2)*n.scale-n.profileGraphics.getChildAt(t).width/2;n.profileGraphics.getChildAt(t).position=new PIXI.Point(.5*r.depth*n.scale+24,l),e+=o}n.profileGraphics.endFill(),P(1),P(0),n.profileGraphics.children.length>r.getAll().length&&n.profileGraphics.removeChildren(r.getAll().length)}(),function(){if(n.toolGraphics.clear(),!n.isToolActive)return;if(n.toolGraphics.lineStyle(1,0,.5),n.toolGraphics.moveTo(-r.depth/2*n.scale,n.toolPointer.y),n.toolGraphics.lineTo(r.depth/2*n.scale,n.toolPointer.y),n.toolGraphics.moveTo(n.toolPointer.x,-r.totalLength/2*n.scale),n.toolGraphics.lineTo(n.toolPointer.x,r.totalLength/2*n.scale),n.config.editor.nuitDrawStamping.allowFreePlacement){if(n.toolGraphics.lineStyle(1,0,.4),n.toolGraphics.beginFill(16711680,.7),n.focusedHole){var e=n.toolPointer.pX-n.focusedHole.x;if(Math.abs(e)>=w())for(var t=n.toolPointer.x;Math.abs(t)/n.scale+.5*y()<r.depth/2;t+=e*n.scale)"circle"===n.tool.shape?n.toolGraphics.drawCircle(t,n.toolPointer.y,y()*n.scale):"roundedrect"===n.tool.shape?n.toolGraphics.drawRoundedRect(t-.5*y()*n.scale,n.toolPointer.y-.5*w()*n.scale,y()*n.scale,w()*n.scale,n.tool.radius*n.tool.scale*n.scale):n.toolGraphics.drawRect(t-.5*y()*n.scale,n.toolPointer.y-.5*w()*n.scale,y()*n.scale,w()*n.scale)}else"circle"===n.tool.shape?n.toolGraphics.drawCircle(n.toolPointer.x,n.toolPointer.y,y()*n.scale):"roundedrect"===n.tool.shape?n.toolGraphics.drawRoundedRect(n.toolPointer.x-.5*y()*n.scale,n.toolPointer.y-.5*w()*n.scale,y()*n.scale,w()*n.scale,n.tool.radius*n.tool.scale*n.scale):n.toolGraphics.drawRect(n.toolPointer.x-.5*y()*n.scale,n.toolPointer.y-.5*w()*n.scale,n.tool.heíght*n.scale,w()*n.scale);n.toolGraphics.endFill()}if(n.focusedHole){e=n.toolPointer.pX-n.focusedHole.x;n.textXmin.text=Math.abs(Math.round(e/n.config.units.length.factor)),n.textXmin.x=n.toolPointer.x-.5*e*n.scale-.5*n.textXmin.width,n.textXmin.y=n.toolPointer.y-16}else n.textXmin.text=Math.round(n.toolPointer.pX/n.config.units.length.factor),n.textXmin.x=.5*-r.depth*n.scale+.5*n.toolPointer.x+.25*r.depth*n.scale-.5*n.textXmin.width,n.textXmin.y=n.toolPointer.y-16;n.textYmin.text=Math.round(n.toolPointer.pY/n.config.units.length.factor),n.textYmin.x=n.toolPointer.x-16,n.textYmin.y=.5*-r.totalLength*n.scale+.5*n.toolPointer.y+.25*r.totalLength*n.scale+.5*n.textYmin.height}()}function d(){n.profileGraphics.removeChildren(),n.editorCtrl.render()}function p(){if(n.config.editor.nuitDrawStamping.allowFreePlacement&&n.isToolActive){if(n.focusedHole){var e=n.toolPointer.pX-n.focusedHole.x;if(Math.abs(e)>=w())for(var t=n.toolPointer.x;Math.abs(t)/n.scale+.5*y()<r.depth/2;t+=e*n.scale)r.addHole(t/n.scale+.5*r.depth,n.toolPointer.pY,n.tool)}else r.addHole(n.toolPointer.pX,n.toolPointer.pY,n.tool);n.editorCtrl.render()}}function f(e){if(n.isToolActive){if(n.toolPointer.x=e.data.global.x-n.scene.x,n.toolPointer.y=e.data.global.y-n.scene.y,e.data.originalEvent.shiftKey){var t=-1,o=25;for(var i in r.getHoles()){var l=Math.abs(r.getHoles()[i].y-n.toolPointer.pY);l<o&&(o=l,t=i)}0<=t?(n.focusedHole=r.getHoles()[t],n.toolPointer.y=(r.getHoles()[t].y-.5*r.totalLength)*n.scale):n.focusedHole=null}else n.focusedHole=null;n.editorCtrl.render()}}function u(){n.isToolActive=!1,n.textXmin.visible=!1,n.textYmin.visible=!1,n.editorCtrl.render()}function g(e){n.isToolActive=!0,n.toolPointer.x=e.data.global.x-n.scene.x,n.toolPointer.y=e.data.global.y-n.scene.y,n.textXmin.visible=!0,n.textYmin.visible=!0,n.editorCtrl.render()}function P(e){for(var t in n.profileGraphics.lineStyle(1,0,e),n.profileGraphics.beginFill(16777215,1),r.getHoles()){var o=r.getHoles()[t];if("circle"===o.shape){var i=Math.round((o.x-.5*r.depth)*n.scale),l=Math.round((o.y-.5*r.totalLength)*n.scale);n.profileGraphics.drawCircle(i,l,Math.round(2*o.radius*n.scale))}else if("roundedrect"===o.shape){i=Math.round((o.x-.5*r.depth-.5*o.width)*n.scale),l=Math.round((o.y-.5*r.totalLength-.5*o.height)*n.scale);n.profileGraphics.drawRoundedRect(i,l,o.width*n.scale,o.height*n.scale,o.radius*n.scale)}else{i=Math.round((o.x-.5*r.depth-.5*o.width)*n.scale),l=Math.round((o.y-.5*r.totalLength-.5*o.height)*n.scale);n.profileGraphics.drawRect(i,l,o.width*n.scale,o.height*n.scale)}}n.profileGraphics.endFill()}function x(e){n.tool=angular.copy(e),n.tool.scale||(n.tool.scale=1)}function m(){r.resetStamping(),n.editorCtrl.render()}function G(e){return e===n.tool.shape}function y(){switch(n.tool.shape){case"square":return n.tool.width*n.tool.scale;case"circle":return 2*n.tool.radius*n.tool.scale;case"roundedrect":return n.tool.width*n.tool.scale}return 0}function w(){switch(n.tool.shape){case"square":return n.tool.height*n.tool.scale;case"circle":return 2*n.tool.radius*n.tool.scale;case"roundedrect":return n.tool.height*n.tool.scale}return 0}n.config=angular.copy(a),n.style=n.config.editor.nuitDrawStamping.style,n.scene=new PIXI.Container,n.manager=null,n.textXmin=null,n.textYmin=null,n.profileGraphics=new PIXI.Graphics,n.toolGraphics=new PIXI.Graphics,n.toolPointer=new PIXI.Point,n.isToolActive=!1,n.tool={shape:"circle",radius:6,scale:1},n.scale=1,Object.defineProperty(n,"screenWidthHalf",{get:function(){return.5*n.editorCtrl.renderer.width}}),Object.defineProperty(n,"screenHeightHalf",{get:function(){return.5*n.editorCtrl.renderer.height}}),Object.defineProperty(n.toolPointer,"pX",{get:function(){return this.x/n.scale+.5*r.depth}}),Object.defineProperty(n.toolPointer,"pY",{get:function(){return this.y/n.scale+.5*r.totalLength}}),Object.defineProperty(n,"renderer",{get:function(){return n.editorCtrl.renderer}}),n.$onInit=function(){n.config=angular.merge({},a,n.editorCtrl.config),n.style=n.config.editor.nuitDrawStamping.style,n.profileGraphics.interactive=!0,n.profileGraphics.pointermove=f,n.profileGraphics.pointerout=u,n.profileGraphics.pointercancel=u,n.profileGraphics.pointerover=g,n.profileGraphics.pointertap=p,n.textXmin=new PIXI.Text("0",{fontFamily:"Arial",fontSize:14,fill:526344,align:"center"}),n.textXmin.visible=!1,n.toolGraphics.addChild(n.textXmin),n.textYmin=new PIXI.Text("0",{fontFamily:"Arial",fontSize:14,fill:526344,align:"center"}),n.textYmin.visible=!1,n.textYmin.rotation=-Math.PI/2,n.toolGraphics.addChild(n.textYmin),n.scene.addChild(n.profileGraphics),n.scene.addChild(n.toolGraphics),c(),function(){var e=new o.Manager;e.$onPreRender=h,e.$onUse=d,e.$onMouseWheel=s,e.$onResize=c,e.setTool=x,e.resetStamping=m,e.isTool=G,n.manager=Object.freeze(e)}(),o.registerEditor("nuit-draw-stamping",n.manager,n.scene)},n.$onDestroy=function(){o.unregisterEditor("nuit-draw-stamping")},n.setTool=x}e.$inject=["$scope","$rootScope","nuitEditor","nuitEditorEvents","nuitProfile","NUIT_DRAW_STAMPING_SETTINGS"],angular.module("nuit.editor").controller("nuitDrawStampingController",e)}();
"use strict";angular.module("nuit.editor").component("nuitDrawTop",{template:"",controller:"nuitDrawTopController",controllerAs:"vm",transclude:!0,require:{editorCtrl:"^nuitDraw"}});
"use strict";angular.module("nuit.editor").constant("NUIT_DRAW_TOP_SETTINGS",{editor:{nuitDrawTop:{style:{rendererOffset:100,wasteBorderWidth:1,wasteBorderColor:16711680,wasteBorderOpacity:1,wasteFillColor:16751001,wasteFillOpacity:1,segmentBorderWidth:1,segmentBorderColor:0,segmentBorderOpacity:1,segmentFillColor:15395562,segmentFillOpacity:1,segmentHoverColor:14737632,segmentHoverOpacity:1,segmentConicalColor:14342874,segmentConicalOpacity:1,segmentConicalHoverColor:13684944,segmentConicalHoverOpacity:1,segmentConicalBaseColor:13290186,segmentConicalBaseOpacity:1,segmentConicalBaseHoverColor:12632256,segmentConicalBaseHoverOpacity:1,wrapFillColor:14540287,wrapFillOpacity:1,showWrapText:!1,fontFamily:"Arial",fontSize:19,fontOffset:15,fontStrokeColor:15705360,fontStrokeThickness:3}}}});
"use strict";!function(){function e(e,h,t,n,c,d,i,o){var f=this,r=i,l={STRETCHED:"s",PROPORTIONAL:"p"};function s(){var e=f.renderer.width-2*f.style.rendererOffset,t=f.renderer.height-2*f.style.rendererOffset,n=c.getDepth(),i=c.getTotalLength();f.heightScale=t/i,f.widthScale=e/n;var o=f.style.rendererOffset,r=f.style.rendererOffset;if(f.zoomStyle===l.PROPORTIONAL){var s=Math.min(f.heightScale,f.widthScale);f.heightScale=s,f.widthScale=s}f.scaledWidth=n*f.widthScale,f.scaledHeight=i*f.heightScale,f.zoomStyle===l.PROPORTIONAL&&(o+=(e-f.scaledWidth)/2,r+=(t-f.scaledHeight)/2),f.scene.x=o,f.scene.y=r}function a(){var e=!0,t=!1,n=void 0;try{for(var i,o=f.visualSegments[Symbol.iterator]();!(e=(i=o.next()).done);e=!0){i.value.unhighlight()}}catch(e){t=!0,n=e}finally{try{!e&&o.return&&o.return()}finally{if(t)throw n}}}function g(){s(),T()}function u(){f.refreshRequired&&(C(),f.refreshRequired=!1)}function m(){T()}function y(e){return e.data.getLocalPosition(f.waste).y<f.waste.height/2?c.setConicalBase(-1):c.setConicalBase(9999)}function v(){f.waste.clear(),function(){for(var e=0;e<c.count();e++)if(c.isConical(e))return!0;return!1}()&&(f.waste.lineStyle(f.style.wasteBorderWidth,f.style.wasteBorderColor,f.style.wasteBorderOpacity),f.waste.beginFill(f.style.wasteFillColor,f.style.wasteFillOpacity),f.waste.drawRect(0,0,f.scaledWidth,f.scaledHeight),f.waste.endFill())}function S(e){(isNaN(e)||e<0||e>c.count())&&(e=0),f.profile.removeChildren(),function(){var e=c.count();if(f.visualSegments.length>e)f.visualSegments.length=e;else if(f.visualSegments.length<e)for(;f.visualSegments.length<e;)f.visualSegments.push(new P);for(var t in f.visualSegments)f.visualSegments[t].assign(c.get(t))}();for(var t=e;t<c.count();t++){var n=f.visualSegments[t];n.refresh(),f.profile.addChild(n.segmentGraphics),f.profile.addChild(n.textLeft),f.profile.addChild(n.textRight)}}function C(){s(),v(),function(){f.texts.removeChildren();var e=new PIXI.Text(t("translate")("PROFILE.COLOR_SIDE")+": "+(c.getVisibleSide()?"DOWN":"UP"),{fontFamily:f.style.fontFamily,fontSize:f.style.fontSize,stroke:f.style.fontStrokeColor});e.buttonMode=!0,e.interactive=!0,e.position.y=-e.height,e.position.x=.5*f.scaledWidth+.5*-e.width,f.texts.addChild(e)}(),S()}function T(){f.refreshRequired=!0}function p(){f.zoomStyle!==l.STRETCHED&&(f.zoomStyle=l.STRETCHED,C(),n.render())}function w(){f.zoomStyle!==l.PROPORTIONAL&&(f.zoomStyle=l.PROPORTIONAL,C(),n.render())}function O(){return f.zoomStyle===l.STRETCHED}function x(){return f.zoomStyle===l.PROPORTIONAL}function P(){var o=this;o.segment=null,o.hovered=!1,o.leftTextHighlighted=!1,o.rightTextHighlighted=!1;var e=new PIXI.Text("---",{fontFamily:f.style.fontFamily,fontSize:f.style.fontSize,stroke:f.style.fontStrokeColor});e.buttonMode=!0,e.interactive=!0,e.on("click",i),e.on("tap",i);var t=new PIXI.Text("---",{fontFamily:f.style.fontFamily,fontSize:f.style.fontSize,stroke:f.style.fontStrokeColor});t.buttonMode=!0,t.interactive=!0,t.on("click",s),t.on("tap",s);var r=new PIXI.Graphics;function n(){c.setConicalBase(o.segment.index)}function i(){h.$emit(d.segmentFocused,{index:o.segment.index,payload:{direction:"front"}})}function s(){h.$emit(d.segmentFocused,{index:o.segment.index,payload:{direction:"back"}})}function l(){r.clear(),r.lineStyle(0),o.segment.isWrap()?r.beginFill(f.style.wrapFillColor,f.style.wrapFillOpacity):o.hovered?(r.beginFill(f.style.segmentHoverColor,f.style.segmentHoverOpacity),o.segment.isConical()&&r.beginFill(f.style.segmentConicalHoverColor,f.style.segmentConicalHoverOpacity),o.segment.index===c.getConicalBase()&&r.beginFill(f.style.segmentConicalBaseHoverColor,f.style.segmentConicalBaseHoverOpacity)):(r.beginFill(f.style.segmentFillColor,f.style.segmentFillOpacity),o.segment.isConical()&&r.beginFill(f.style.segmentConicalColor,f.style.segmentConicalOpacity),o.segment.index===c.getConicalBase()&&r.beginFill(f.style.segmentConicalBaseColor,f.style.segmentConicalBaseOpacity));var e=o.segment.getOffsetFront()*f.heightScale,t=o.segment.getOffsetBack()*f.heightScale,n=e+o.segment.length*f.heightScale,i=t+o.segment.backLength*f.heightScale;r.drawPolygon([new PIXI.Point(0,e),new PIXI.Point(f.scaledWidth,t),new PIXI.Point(f.scaledWidth,i),new PIXI.Point(0,n)]),r.lineStyle(f.style.segmentBorderWidth,f.style.segmentBorderColor,f.style.segmentBorderOpacity),r.moveTo(0,e),r.lineTo(0,n),r.moveTo(f.scaledWidth,t),r.lineTo(f.scaledWidth,i),1===o.segment.bendingDir||o.segment.isFirst()?(r.moveTo(0,e),r.lineTo(f.scaledWidth,t)):function(e,t,n,i,o,r){for(var s=i-t,l=o-n,a=Math.atan(l/s),g=Math.sqrt(Math.pow(s,2)+Math.pow(l,2)),h=Math.ceil(g/(2*r)),c=Math.cos(a)*r*2,d=Math.sin(a)*r*2,f=0;f<h;f++){var u=t+c*f,m=n+d*f,y=u+c/2,v=Math.min(y,i),S=v/y*d/2+m;e.moveTo(u,m),e.lineTo(v,S)}}(r,0,e,f.scaledWidth,t,10),o.segment.isLast()&&(r.moveTo(0,n),r.lineTo(f.scaledWidth,i))}function a(){if(o.segment.isWrap()&&!f.style.showWrapText)return e.visible=!1,void(t.visible=!1);e.text=g(o.segment.length),e.style.strokeThickness=0,e.visible=!0,o.leftTextHighlighted&&(e.style.strokeThickness=f.style.fontStrokeThickness),e.position.y=(o.segment.getOffsetFront()+o.segment.length/2)*f.heightScale-e.height/2,e.position.x=-e.width-f.style.fontOffset,t.text=g(o.segment.backLength),t.style.strokeThickness=0,t.visible=!0,o.rightTextHighlighted&&(t.style.strokeThickness=f.style.fontStrokeThickness),t.position.y=(o.segment.getOffsetBack()+o.segment.backLength/2)*f.heightScale-t.height/2,t.position.x=f.scaledWidth+f.style.fontOffset}function g(e){var t=f.config.units.length?f.config.units.length.factor:1,n=f.config.units.length?f.config.units.length.decimals:0;return(e/t).toFixed(n)}r.on("pointerover",function(){o.hovered=!0,l(),f.editorCtrl.render()}),r.on("pointerout",function(){o.hovered=!1,l(),f.editorCtrl.render()}),r.on("click",n),r.on("tap",n),o.textLeft=e,o.textRight=t,o.segmentGraphics=r,o.refresh=function(){l(),a()},o.refreshSegment=l,o.refreshText=a,o.assign=function(e){if(e===o.segment)return;o.segment=e,o.segment.isWrap()?(r.interactive=!1,r.buttonMode=!1):(r.interactive=!0,r.buttonMode=!0)},o.unhighlight=function(){if(!o.rightTextHighlighted&&!o.leftTextHighlighted)return;o.leftTextHighlighted=!1,o.rightTextHighlighted=!1,a()},o.highlightLeftText=function(){if(o.leftTextHighlighted)return;o.leftTextHighlighted=!0,a()},o.highlightRightText=function(){if(o.rightTextHighlighted)return;o.rightTextHighlighted=!0,a()}}f.config=angular.copy(r),f.style=f.config.editor.nuitDrawTop.style,f.scene=new PIXI.Container,f.waste=new PIXI.Graphics,f.texts=new PIXI.Container,f.profile=new PIXI.Container,f.manager=null,f.zoomStyle=l.PROPORTIONAL,f.heightScale=1,f.widthScale=1,f.scaledWidth=0,f.scaledHeight=0,f.visualSegments=[],f.refreshRequired=!1,Object.defineProperty(f,"renderer",{get:function(){return f.editorCtrl.renderer}}),h.$on(d.segmentDepthChanged,T),h.$on(d.segmentAdded,T),h.$on(d.segmentRemoved,T),h.$on(d.segmentLengthChanged,T),h.$on(d.segmentConicalChanged,T),h.$on(d.segmentBendingChanged,T),h.$on(d.conicalBaseChanged,T),h.$on(d.segmentFocused,function(e,t){var n=f.visualSegments[t.index];if(!n)return;a(),"front"===t.payload.direction?n.highlightLeftText():n.highlightRightText();f.editorCtrl.render()}),h.$on(d.clearSelection,function(){a(),f.editorCtrl.render()}),f.$onInit=function(){f.config=angular.merge({},r,f.editorCtrl.config),f.waste.interactive=!0,f.waste.buttonMode=!0,f.waste.on("click",y),f.waste.on("tap",y),f.scene.addChild(f.waste),f.scene.addChild(f.profile),f.scene.addChild(f.texts),function(){var e=new n.Manager;e.$onResize=g,e.$onPreRender=u,e.$onUse=m,e.showStretched=p,e.showProportional=w,e.isStretched=O,e.isProportional=x,e.invertOrder=function(){c.invertOrder(),e.refresh()},e.refresh=C,f.manager=Object.freeze(e)}(),n.registerEditor("nuit-draw-top",f.manager,f.scene)},f.$onDestroy=function(){n.unregisterEditor("nuit-draw-top")},f.showStretched=p,f.showProportional=w}e.$inject=["$rootScope","$scope","$filter","nuitEditor","nuitProfile","nuitEditorEvents","NUIT_DRAW_TOP_SETTINGS","nuitmath"],angular.module("nuit.editor").controller("nuitDrawTopController",e)}();
"use strict";angular.module("nuit.editor").component("nuitEditor",{templateUrl:"_nuit_/components/nuit-editor/nuit-editor.template.html",controller:"nuitEditorController",controllerAs:"vm",transclude:!0,bindings:{editorConfig:"<",openProfileDialog:"<",openProfileState:"@",saveProfileDialog:"<",selectMaterialDialog:"<",finishAction:"<",languageKey:"<",validate:"<",readOnlyCheck:"<"}});
"use strict";angular.module("nuit.editor").constant("NUIT_EDITOR_SETTINGS",{editor:{innerOuterThicknessThreshold:1.5,nuitDraw2d:{enabled:!0},nuitDrawStamping:{enabled:!1},nuitDrawStampingRework:{enabled:!1},nuitDrawTop:{enabled:!0},nuitDrawCutting:{enabled:!1},style:{menubar:{enabled:!0,showNewProfileButton:!0,showOpenProfileButton:!0,showSaveProfileButton:!0,showMaterialButton:!0,showFinalActionButton:!0,enableHistory:!0},sidebar:{enabled:!0,tabOrder:{nuitDrawTop:1,nuitDrawStamping:2,nuitDrawStampingRework:3,nuitDrawCutting:4}},toolbox:{enabled:!0}},allowDynamicSegments:!1,lockMaterial:!1}});
"use strict";var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};!function(){function t(t,n,i,a,r,e,u,o,s,l,c){var d=this,g=c;function f(t,e){d.preventNextEventTrigger?d.preventNextEventTrigger=!1:i.$broadcast(o.angleFocused,e)}function m(t){var e=s.get(t),n=e?e.angle:0,i=d.config.editor.limits.segmentLength.default;s.add(i,n,t),s.setAngle(t+1,0),d.reValidate()}function p(t){t=t||d.dynamicSegments;var e={controller:"DynamicSegmentsDialogController",controllerAs:"vm",templateUrl:"nuit::/dialogs/dynamic-segments/dynamic-segments.dialog.html",multiple:!0,locals:{DynamicSegments:angular.copy(t)}};a.show(e).then(function(t){if(t){var e=!0,n=!1,i=void 0;try{for(var r,o=t[Symbol.iterator]();!(e=(r=o.next()).done);e=!0){for(var a=r.value,u=!1,s=0;s<d.dynamicSegments.length&&!u;s++)if(d.dynamicSegments[s].index===a.index){u=!0,d.dynamicSegments[s]=a;break}u||d.dynamicSegments.push(a)}}catch(t){n=!0,i=t}finally{try{!e&&o.return&&o.return()}finally{if(n)throw i}}}}).catch(function(t){return t&&console.warn(t),O()})}function h(){if(s.clear(!0,!0),l.clearProfile(),l.hasEditor("nuit-draw-2d")){var t=l.getManager("nuit-draw-2d");t.setRuler(!1),t.clear(),l.useEditor("nuit-draw-2d")}l.render()}function y(){return!!d.validate}function b(e){return!!d.dynamicSegments.find(function(t){return t.index===e})}function v(){return s.count()}function w(){return d.openProfileDialog&&!d.openProfileStateAvailable()}function S(){return!!d.saveProfileDialog}function x(){return!!d.selectMaterialDialog}function A(){return!!d.finishAction}function E(){d.config=angular.merge({},g,d.editorConfig),d.style=d.config.editor.style,d.tools=d.config.editor.nuitDrawStamping.tools,d.generators=d.config.editor.nuitDrawStamping.generators,d.limits=d.config.editor.limits,d.units=d.config.units,d.tabIndex=d.config.editor.style.sidebar.tabOrder,d.tabs=[{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-2d.html",index:0},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-top.html",index:d.tabIndex.nuitDrawTop},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-stamping.html",index:d.tabIndex.nuitDrawStamping},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-stamping-rework.html",index:d.tabIndex.nuitDrawStampingRework},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-cutting.html",index:d.tabIndex.nuitDrawCutting}]}function D(){"$apply"!==i.$root.$$phase&&"$digest"!==i.$root.$$phase&&i.$apply()}function O(){var t="Error",e="An unknown error occured. Please try again later",n="OK";if(u.has("$translate")){var i=u.get("$translate");t=i.instant("ERROR.TITLE"),e=i.instant("ERROR.UNKNOWN_ERROR"),n=i.instant("APP.OK")}var r=a.alert({multiple:!0}).title(t).textContent(e).ok(n);return a.show(r)}d.config=angular.copy(g),d.style=d.config.editor.style,d.tools=d.config.editor.nuitDrawStamping.tools,d.generators=d.config.editor.nuitDrawStamping.generators,d.generatorValues=[],d.units=d.config.units,d.limits=d.config.editor.limits,d.dynamicSegments=[],d.media=e,d.preventNextEventTrigger=!1,d.MEASURE=s.MEASURE,d.openStampings=null,d.tabIndex=d.config.editor.style.sidebar.tabOrder,d.tabs=[{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-2d.html",index:0},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-top.html",index:d.tabIndex.nuitDrawTop},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-stamping.html",index:d.tabIndex.nuitDrawStamping},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-stamping-rework.html",index:d.tabIndex.nuitDrawStampingRework},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-cutting.html",index:d.tabIndex.nuitDrawCutting}],d.selectedIndex=0,Object.defineProperty(d,"manager",{get:l.getManager}),Object.defineProperty(d,"segments",{get:s.getAll}),Object.defineProperty(d,"material",{get:s.getMaterial}),Object.defineProperty(d,"originalThickness",{get:s.getOriginalThickness}),Object.defineProperty(d,"historyBackAvailable",{get:s.historyBackAvailable}),Object.defineProperty(d,"historyForwardAvailable",{get:s.historyForwardAvailable}),Object.defineProperty(d,"depth",{get:s.getDepth,set:function(t){if(s.hasStampingLines()){var e=a.confirm().multiple(!0).title(r.instant("PROFILE.MODIFY_PUNCHINGS_HEADER")).htmlContent(r.instant("PROFILE.MODIFY_PUNCHINGS_CONTENT")).ok(r.instant("APP.OK")).cancel(r.instant("APP.CANCEL"));a.show(e).then(function(){d.selectedIndex=d.tabIndex.nuitDrawStampingRework,d.useEditor("nuit-draw-stamping-rework"),s.setDepth(t),l.getManager("nuit-draw-stamping-rework").requireRefresh()})}else s.setDepth(t)}}),Object.defineProperty(d,"name",{get:l.getName}),d.$onInit=function(){E(),angular.element(t).trigger("resize")},d.$onChanges=function(t){if(!t.editorConfig||t.editorConfig.isFirstChange())return;E()},d.addWrap=function(t){var e=d.config.editor.limits.hemLength.default;s.addWrap(0!==t,e),l.render(),d.reValidate()},d.addSegment=m,d.hasSegments=function(){return!s.isEmpty()},d.hasMaterial=function(){return!!s.getMaterial()},d.addAttribute=function(){if(!d.selectedAttribute)return;if(0<=d.currentProduct.attributes.indexOf(d.selectedAttribute))return;d.currentProduct.attributes.push(d.selectedAttribute),!d.selectedAttribute.hasAttributeValue&&d.selectedAttribute.value&&delete d.selectedAttribute.value;d.selectedAttribute=null},d.removeAttribute=function(t){d.currentProduct.attributes.splice(d.currentProduct.attributes.indexOf(t),1)},d.historyBack=function(){return s.historyBack()},d.historyForward=function(){return s.historyForward()},d.showNewProfileDialog=function(){var t="Delete profile",e="Please confirm this step. Are you sure?",n="YES",i="CANCEL";if(u.has("$translate")){var r=u.get("$translate");t=r.instant("PROFILE.CLEAR_TITLE"),e=r.instant("PROFILE.CLEAR_TEXT"),n=r.instant("PROFILE.CLEAR_YES"),i=r.instant("APP.CANCEL")}var o=a.confirm({multiple:!0,clickOutsideToClose:!0}).title(t).textContent(e).ok(n).cancel(i);return a.show(o).then(h).catch(function(t){t&&console.error(t)})},d.isView=function(t){return t===l.getCurrentEditorId()},d.highlightSegment=function(t,e){if(d.preventNextEventTrigger)return void(d.preventNextEventTrigger=!1);i.$broadcast(o.segmentFocused,{index:t,payload:e})},d.highlightStampingLine=function(t,e){if(d.preventNextEventTrigger)return void(d.preventNextEventTrigger=!1);i.$broadcast(o.stampingLineFocused,e)},d.unhighlightAll=function(){i.$broadcast(o.clearSelection)},d.unhighlightStampings=function(){i.$broadcast(o.stampingLineFocusCleared)},d.highlightAngle=f,d.isWrap=function(t){return s.isWrap(t)},d.segmentCount=v,d.isWrapMode=function(t,e,n){if(!d.isWrap(t))return!1;var i=s.get(t);return(i.isFirst()?-1===i.next.bendingDir:1===i.bendingDir)===e&&i.close===n},d.toggleMeasure=function(t){s.toggleMeasure(t),l.render()},d.toggleClose=function(t){s.toggleClose(t)},d.toggleBdir=function(t){s.toggleBending(t)},d.toggleConical=function(t){s.toggleConical(t)},d.setType=function(t,e){s.setType(t,e)},d.refreshFrontLength=function(t,e){s.setLength(e,t.length)},d.refreshBackLength=function(t,e){s.setLength(e,t.backLength,!0)},d.removeSegment=function(t){s.removeAt(t),d.reValidate()},d.useEditor=function(t){l.useEditor(t)},d.inheritConfig=function(t){angular.merge(d.config,t),d.style=d.config.editor.style,d.tools=d.config.editor.nuitDrawStamping.tools,d.generators=d.config.editor.nuitDrawStamping.generators,d.limits=d.config.editor.limits,d.tabIndex=d.config.editor.style.sidebar.tabOrder,d.tabs=[{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-2d.html",index:0},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-top.html",index:d.tabIndex.nuitDrawTop},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-stamping.html",index:d.tabIndex.nuitDrawStamping},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-stamping-rework.html",index:d.tabIndex.nuitDrawStampingRework},{src:"_nuit_/components/nuit-editor/sidebars/nuit-draw-cutting.html",index:d.tabIndex.nuitDrawCutting}]},d.getLanguage=function(t,e){if(!t)return e||t;if("object"!==(void 0===t?"undefined":_typeof(t)))return t;if(t[d.languageKey])return t[d.languageKey];if(t.en)return t.en;var n=Object.keys(t);if(0<n.length)return t[n[0]];return e},d.openProfileDialogAvailable=w,d.openProfileStateAvailable=function(){return d.openProfileState&&u.has("$state")},d.saveProfileAvailable=S,d.selectMaterialAvailable=x,d.finalActionAvailable=A,d.openProfileDialog=function(){return w()?d.openProfileDialog().then(function(t){s.importProfile(t),l.render()}).catch(function(t){if(t)return console.error(t),O()}):void 0},d.saveProfile=function(){if(!S())return;var t=l.exportProfile();return d.saveProfileDialog(t).then(h).then(function(){}).catch(function(t){if(t)return console.error(t),O()})},d.selectMaterial=function(){return x()?d.selectMaterialDialog().then(function(t){if(t){var e=angular.copy(t);return e.originalThickness=t.thickness,e.thickness=s.clamp(t.thickness,1,50),s.setMaterial(e),s.forceRefresh(),l.hasEditor("nuit-draw-2d")&&l.getManager("nuit-draw-2d").refresh(),d.reValidate(),e}}).catch(function(t){if(t)return console.error(t),O()}):$q.reject("No material dialog available")},d.finalAction=function(){if(!A())return;var t=l.exportProfile();return d.finishAction(t).then(function(t){!0!==t&&h()}).catch(function(t){if(t&&t instanceof Error)return console.error(t),O()})},d.reValidate=function(){y()&&d.validate()},d.reValidateAvailable=y,d.getMaterial=function(){return s.getMaterial()},d.addDynamicSegment=function(t){if(b(t))return;return p([{name:{},index:t,min:null,max:null}])},d.removeDynamicSegment=function(e){if(!b(e))return;d.dynamicSegments.splice(d.dynamicSegments.findIndex(function(t){return t.index===e}),1)},d.isDynamic=b,d.hasDynamicSegments=function(){return 0<d.dynamicSegments.length},d.showDynamicSegmentsDialog=p,d.showAddStampingLineDialog=function(){a.show({controller:"AddStampingLineDialogController",controllerAs:"vm",templateUrl:"_nuit_/dialogs/add-stamping-line/view.html",multiple:!0}).then(function(t){t.punchType="default"!==d.config.editor.nuitDrawStampingRework.punchType?d.config.editor.nuitDrawStampingRework.punchType:void 0,l.getManager("nuit-draw-stamping-rework").addStampingLine(t)}).catch(function(t){return t&&console.warn(t),O()})},d.shortCutAction=function(t){var e=v();t.target.id!=="length-"+(e-1)||9!==t.keyCode||t.shiftKey||(m(e),n(function(){f(t,e)},100),t.preventDefault())},d.hasHoles=function(){return 0<s.getHoles().length},d.getToolById=function(t){var e=!0,n=!1,i=void 0;try{for(var r,o=d.tools[Symbol.iterator]();!(e=(r=o.next()).done);e=!0){var a=r.value;if(a.id===t)return a}}catch(t){n=!0,i=t}finally{try{!e&&o.return&&o.return()}finally{if(n)throw i}}return!1},d.generateStampings=function(){var t=[],e=!0,n=!1,i=void 0;try{for(var r,o=d.generatorValues[Symbol.iterator]();!(e=(r=o.next()).done);e=!0){var a=r.value;if(a.distanceFirst&&(a.distanceLast&&a.distanceSide&&a.tool)){if(a.count){var u=s.depth-a.distanceFirst-a.distanceLast;a.tool.width?u-=a.tool.width*(a.count-1):a.tool.radius&&(u-=2*a.tool.radius*(a.count-1)),a.distanceBetween=u/(a.count-1)}a.distanceBetween&&(a.offsetTop="top"===a.attachedTo?a.distanceSide:s.totalLength-a.distanceSide,t.push(a))}}}catch(t){n=!0,i=t}finally{try{!e&&o.return&&o.return()}finally{if(n)throw i}}s.generateHoles(t),l.render()},d.show3d=function(){return"nuit-draw-stamping-rework"!==l.getCurrentEditorId()},d.isReadOnlyMaterial=function(){return d.readOnlyCheck&&d.readOnlyCheck("material")||d.config.editor.lockMaterial},d.isReadOnly=function(t){return!!d.readOnlyCheck&&d.readOnlyCheck(t)},d.ZOOM_IN_FACTOR=1.1,d.ZOOM_OUT_FACTOR=-1.1,d.ROTATION_CLOCKWISE=1,d.ROTATION_CCLOCKWISE=-1,i.$on(o.segmentAdded,D),i.$on(o.segmentRemoved,D),i.$on(o.segmentAligned,D),i.$on(o.stampingLineAdded,D),i.$on(o.segmentFocused,function(t,e){n(function(){d.preventNextEventTrigger=!0,e.payload&&"back"===e.payload.direction&&s.isConical(e.index)?angular.element("[data-backlength-focus="+e.index+"]").focus().select():angular.element("[data-length-focus="+e.index+"]").focus().select()},10)}),i.$on(o.angleFocused,function(t,e){n(function(){d.preventNextEventTrigger=!0,angular.element("[data-angle-focus="+e+"]").focus().select()},10)}),i.$on(o.clearSelection,function(){document.activeElement&&document.activeElement.blur()}),i.$on(o.stampingLineAdded,function(){d.openStampings=l.getManager("nuit-draw-stamping-rework").stampingLines.length-1,i.$apply()}),i.$on(o.cuttingAdded,D),i.$on(o.cuttingRemoved,D)}t.$inject=["$window","$timeout","$scope","$mdDialog","$translate","$mdMedia","$injector","nuitEditorEvents","nuitProfile","nuitEditor","NUIT_EDITOR_SETTINGS"],angular.module("nuit.editor").controller("nuitEditorController",t)}();
"use strict";angular.module("nuit.editor").run(["$templateCache",function(t){t.put("_nuit_/components/nuit-draw-2d/nuit-draw-2d.template.html",'<md-button aria-label="Cutting" class="md-raised blank" ng-if="!vm.style.hideBlank">\n\t<span translate="PROFILE.CUTTING">Zuschnitt</span> {{vm.totalLengthWithoutOffset|nuitUnit:\'length\'}}\n</md-button>\n'),t.put("_nuit_/components/nuit-draw/nuit-draw.template.html","<div class=\"nuit-draw\" layout-fill flex ng-class=\"{'no-padding': vm.fullWidth,'no-margin': vm.fullWidth}\">\n\t<ng-transclude></ng-transclude>\n</div>\n"),t.put("_nuit_/components/nuit-draw-cutting/nuit-draw-cutting.template.html",'<div ng-if="vm.editorCtrl.currentEditor.id === \'nuit-draw-cutting\' && !vm.hideUi">\n\t\x3c!-- ANGLE SELECTION --\x3e\n\t<div style="position:absolute;top:0;left:30px;" layout="row">\n\n\t\t<md-input-container style="width:100px;">\n\t\t\t<md-icon md-svg-src="_nuit_/assets/angle-acute.svg"></md-icon>\n\t\t\t<input type="number" ng-model="vm.angle" step="1">\n\t\t</md-input-container>\n\n\t</div>\n\t\x3c!-- / ANGLE SELECTION --\x3e\n\n\t<div style="position:absolute;bottom:50px;left:50px;" layout="row">\n\t\t\x3c!-- SHOW COMPRESSED --\x3e\n\t\t<md-button class="md-icon-button md-primary" ng-click="vm.showStretched()" aria-label="n"\n\t\t           ng-class="{\'md-raised\':vm.isStretched()}">\n\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_image_aspect_ratio_black_24px.svg"></md-icon>\n\t\t\t<md-tooltip md-direction="bottom">\n\t\t\t\t<span translate="MENUBAR.SHOW_STRETCHED">Show stretched</span>\n\t\t\t</md-tooltip>\n\t\t</md-button>\n\t\t\x3c!-- / SHOW COMPRESSED --\x3e\n\n\t\t\x3c!-- SHOW ORIGINAL --\x3e\n\t\t<md-button class="md-icon-button md-primary" ng-click="vm.showProportional()" aria-label="n"\n\t\t           ng-class="{\'md-raised\':vm.isProportional()}">\n\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_photo_size_select_small_black_24px.svg"></md-icon>\n\t\t\t<md-tooltip md-direction="bottom">\n\t\t\t\t<span translate="MENUBAR.SHOW_ORIGINAL">Show proportional</span>\n\t\t\t</md-tooltip>\n\t\t</md-button>\n\t\t\x3c!-- / SHOW ORIGINAL --\x3e\n\n\t</div>\n\n</div>\n'),t.put("_nuit_/components/nuit-draw-stamping-rework/nuit-draw-stamping.template.html",'<div style="position:absolute;bottom:50px;left:50px;" ng-if="vm.editorCtrl.currentEditor.id === \'nuit-draw-stamping-rework\' && !vm.hideUi" layout="row">\n\t\x3c!-- SHOW COMPRESSED --\x3e\n\t<md-button class="md-icon-button md-primary" ng-click="vm.manager.showStretched()" aria-label="n"\n\t           ng-class="{\'md-raised\':vm.manager.isStretched()}">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_image_aspect_ratio_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="bottom">\n\t\t\t<span translate="MENUBAR.SHOW_STRETCHED">Show stretched</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / SHOW COMPRESSED --\x3e\n\n\t\x3c!-- SHOW ORIGINAL --\x3e\n\t<md-button class="md-icon-button md-primary" ng-click="vm.manager.showProportional()" aria-label="n"\n\t           ng-class="{\'md-raised\':vm.manager.isProportional()}">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_photo_size_select_small_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="bottom">\n\t\t\t<span translate="MENUBAR.SHOW_ORIGINAL">Show proportional</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / SHOW ORIGINAL --\x3e\n\n</div>\n\n\x3c!-- TOOL SIZE SELECT --\x3e\n<div style="position:absolute;top:0;left:30px;" ng-if="vm.editorCtrl.currentEditor.id === \'nuit-draw-stamping-rework\' && !vm.hideUi"\n     layout="row">\n\t<md-input-container ng-if="!vm.manager.toolGroupsEnabled">\n\t\t<md-select ng-model="vm.manager.selectedSize">\n\t\t\t<md-option ng-repeat="size in vm.manager.selectedTool.sizes" ng-value="$index">\n\t\t\t\t{{size.name | nuitTranslate}} ({{size.value | nuitUnit:\'length\'}})\n\t\t\t</md-option>\n\t\t</md-select>\n\t</md-input-container>\n\t<md-input-container ng-if="vm.manager.toolGroupsEnabled && vm.manager.getSupportedShapesByType(vm.manager.selectedToolType).length>0">\n\t\t<md-select ng-model="vm.manager.selectedShape">\n\t\t\t<md-option ng-repeat="shape in vm.manager.getSupportedShapesByType(vm.manager.selectedToolType)" ng-value="shape">\n\t\t\t\t{{shape.sizeId}}\n\t\t\t</md-option>\n\t\t</md-select>\n\t</div>\n</div>\n\x3c!-- / TOOL SIZE SELECT --\x3e\n'),t.put("_nuit_/components/nuit-editor/nuit-editor.template.html",'<div layout="column" layout-fill>\n\n\t\x3c!-- MENUBAR --\x3e\n\t<md-toolbar class="editor-menubar md-primary" ng-if="vm.style.menubar.enabled">\n\t\t<div class="md-toolbar-tools">\n\t\t\t\x3c!-- RESET PROFILE --\x3e\n\t\t\t<md-button class="md-icon-button" ng-click="vm.showNewProfileDialog();" aria-label="Neu"\n\t\t\t           ng-disabled="!vm.hasSegments() || vm.isReadOnly(\'newProfile\')" ng-if="vm.style.menubar.showNewProfileButton">\n\t\t\t\t<md-icon md-svg-src="_nuit_/assets/file-outline.svg"></md-icon>\n\t\t\t\t<md-tooltip>\n\t\t\t\t\t<span translate="MENUBAR.NEW">New</span>\n\t\t\t\t</md-tooltip>\n\t\t\t</md-button>\n\t\t\t\x3c!-- / RESET PROFILE --\x3e\n\n\t\t\t\x3c!-- OPEN PROFILE DIALOG --\x3e\n\t\t\t<md-button class="md-icon-button" ng-disabled="vm.isReadOnly(\'openProfile\')" ng-click="vm.openProfileDialog()" aria-label="n"\n\t\t\t           ng-if="vm.openProfileDialogAvailable() && vm.style.menubar.showOpenProfileButton">\n\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_folder_open_black_24px.svg"></md-icon>\n\t\t\t\t<md-tooltip>\n\t\t\t\t\t<span translate="MENUBAR.OPEN">Open Profile</span>\n\t\t\t\t</md-tooltip>\n\t\t\t</md-button>\n\t\t\t\x3c!-- / OPEN PROFILE DIALOG --\x3e\n\n\t\t\t\x3c!-- OPEN PROFILE STATE --\x3e\n\t\t\t<md-button class="md-icon-button" ng-disabled="vm.isReadOnly(\'openProfile\')" ui-sref="{{vm.openProfileState}}" aria-label="n"\n\t\t\t           ng-if="vm.openProfileStateAvailable() && vm.style.menubar.showOpenProfileButton">\n\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_folder_open_black_24px.svg"></md-icon>\n\t\t\t\t<md-tooltip>\n\t\t\t\t\t<span translate="MENUBAR.OPEN">Open Profile</span>\n\t\t\t\t</md-tooltip>\n\t\t\t</md-button>\n\t\t\t\x3c!-- / OPEN PROFILE STATE --\x3e\n\n\t\t\t\x3c!-- SAVE PROFILE --\x3e\n\t\t\t<md-button class="md-icon-button" ng-click="vm.saveProfile()" aria-label="n" ng-disabled="!vm.hasSegments() || vm.isReadOnly(\'saveProfile\')"\n\t\t\t           ng-if="vm.saveProfileAvailable() && vm.style.menubar.showSaveProfileButton">\n\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_save_black_24px.svg"></md-icon>\n\t\t\t\t<md-tooltip>\n\t\t\t\t\t<span translate="MENUBAR.SAVE">Save</span>\n\t\t\t\t</md-tooltip>\n\t\t\t</md-button>\n\t\t\t\x3c!-- / SAVE PROFILE --\x3e\n\n\t\t\t<md-divider class="vertical-divider"></md-divider>\n\n\t\t\t\x3c!-- HISTORY BACK --\x3e\n\t\t\t<md-button ng-disabled="!vm.historyBackAvailable" aria-label="n" class="md-icon-button"\n\t\t\t           ng-click="vm.historyBack()" ng-if="vm.style.menubar.enableHistory">\n\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_undo_black_24px.svg"></md-icon>\n\t\t\t\t<md-tooltip>\n\t\t\t\t\t<span translate="MENUBAR.BACK">Back</span>\n\t\t\t\t</md-tooltip>\n\t\t\t</md-button>\n\t\t\t\x3c!-- / HISTORY BACK --\x3e\n\n\t\t\t\x3c!-- HISTORY FORWARD --\x3e\n\t\t\t<md-button ng-disabled="!vm.historyForwardAvailable" aria-label="n" class="md-icon-button"\n\t\t\t           ng-click="vm.historyForward()" ng-if="vm.style.menubar.enableHistory">\n\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_redo_black_24px.svg"></md-icon>\n\t\t\t\t<md-tooltip>\n\t\t\t\t\t<span translate="MENUBAR.FORWARD">Forward</span>\n\t\t\t\t</md-tooltip>\n\t\t\t</md-button>\n\t\t\t\x3c!-- / HISTORY FORWARD --\x3e\n\n\t\t\t<span flex class="text-center text-truncate">{{vm.name | nuitTranslate}}</span>\n\n\t\t\t\x3c!-- SHOW DYNAMIC SEGMENTS DIALOG --\x3e\n\t\t\t<md-button class="md-raised" ng-click="vm.showDynamicSegmentsDialog()" aria-label="n"\n\t\t\t           ng-if="vm.config.editor.allowDynamicSegments" ng-disabled="!vm.hasDynamicSegments()">\n\t\t\t\t<span>Dynamic segment settings</span>\n\t\t\t</md-button>\n\t\t\t\x3c!-- / SHOW DYNAMIC SEGMENTS DIALOG --\x3e\n\n\t\t\t\x3c!-- SHOW MATERIAL DIALOG --\x3e\n\t\t\t<md-button class="md-raised" ng-click="vm.selectMaterial($event)" aria-label="n"\n\t\t\t           ng-if="vm.selectMaterialAvailable() && vm.style.menubar.showMaterialButton"\n\t\t\t           ng-disabled="vm.isReadOnlyMaterial()" ng-class="{\'md-warn\': !vm.hasMaterial()}">\n\n\t\t\t\t<md-icon ng-if="vm.material.colors.front.hex" md-svg-src="_nuit_/assets/checkbox-blank.svg"\n\t\t\t\t         ng-style="{color: vm.material.colors.front.hex}"></md-icon>\n\n\t\t\t\t<md-tooltip>\n\t\t\t\t\t<span translate="PROFILE.SELECT_MATERIAL">Select material</span>\n\t\t\t\t</md-tooltip>\n\n\t\t\t\t<span ng-if="!vm.material.name" translate="PROFILE.SELECT_MATERIAL">Select material</span>\n\n\t\t\t\t<span ng-if="vm.material.name">{{vm.material.name | nuitTranslate}}</span>\n\n\t\t\t\t<md-icon md-font-icon="icon-alert" style="color: #c00; margin-left: 0.5em;"\n\t\t\t\t         ng-if="vm.material.orderable === false"></md-icon>\n\n\t\t\t</md-button>\n\t\t\t\x3c!-- / SHOW MATERIAL DIALOG --\x3e\n\n\t\t\t\x3c!-- SHOW FINAL ACTION DIALOG --\x3e\n\t\t\t<md-button class="md-raised md-warn" ng-click="vm.finalAction($event)" aria-label="n"\n\t\t\t           ng-if="vm.finalActionAvailable() && vm.style.menubar.showFinalActionButton"\n\t\t\t           ng-disabled=" !vm.hasSegments() && !vm.hasMaterial() || !vm.hasSegments() || !vm.hasMaterial() ">\n\t\t\t\t<md-icon md-svg-src="_nuit_/assets/baseline-add_shopping_cart-24px.svg"></md-icon>\n\t\t\t\t<span translate="PROFILE.ADD_TO_CART">Add to cart</span>\n\t\t\t</md-button>\n\t\t\t\x3c!-- / SHOW FINAL ACTION DIALOG --\x3e\n\n\t\t</div>\n\t</md-toolbar>\n\t\x3c!-- / MENUBAR --\x3e\n\n\t\x3c!-- MAIN --\x3e\n\t<div layout="row" id="editor" flex layout-fill>\n\n\t\t\x3c!-- TOOLBOX --\x3e\n\t\t<md-content ms-scroll ng-if="vm.style.toolbox.enabled" class="editor-toolbox md-whiteframe-3dp">\n\n\t\t\t\x3c!-- 2D TOOLS --\x3e\n\t\t\t<ng-include src="\'_nuit_/components/nuit-editor/toolbars/nuit-draw-2d.html\'"></ng-include>\n\t\t\t\x3c!-- / 2D TOOLS --\x3e\n\n\t\t\t\x3c!-- CONICAL TOOLS --\x3e\n\t\t\t<ng-include src="\'_nuit_/components/nuit-editor/toolbars/nuit-draw-top.html\'"></ng-include>\n\t\t\t\x3c!-- / CONICAL TOOLS --\x3e\n\n\t\t\t\x3c!-- LEGACY STAMPING TOOLS --\x3e\n\t\t\t<ng-include src="\'_nuit_/components/nuit-editor/toolbars/nuit-draw-stamping.html\'"></ng-include>\n\t\t\t\x3c!-- / LEGACY STAMPING TOOLS --\x3e\n\n\t\t\t\x3c!-- STAMPING TOOLS --\x3e\n\t\t\t<ng-include src="\'_nuit_/components/nuit-editor/toolbars/nuit-draw-stamping-rework.html\'"></ng-include>\n\t\t\t\x3c!-- / STAMPING TOOLS --\x3e\n\n\t\t\t\x3c!-- CUTTING --\x3e\n\t\t\t<ng-include src="\'_nuit_/components/nuit-editor/toolbars/nuit-draw-cutting.html\'"></ng-include>\n\t\t\t\x3c!-- / CUTTING --\x3e\n\n\t\t</md-content>\n\t\t\x3c!-- / TOOLBOX --\x3e\n\n\t\t\x3c!-- EDITOR --\x3e\n\t\t<div flex layout-fill>\n\t\t\t<nuit-draw editor-config="vm.config" on-config-changed="vm.inheritConfig(config)" layout-fill flex>\n\n\t\t\t\t\x3c!-- 2D DRAWING --\x3e\n\t\t\t\t<nuit-draw-2d ng-if="vm.config.editor.nuitDraw2d.enabled"></nuit-draw-2d>\n\t\t\t\t\x3c!-- / 2D DRAWING --\x3e\n\n\t\t\t\t\x3c!-- TOP VIEW --\x3e\n\t\t\t\t<nuit-draw-top ng-if="vm.config.editor.nuitDrawTop.enabled"></nuit-draw-top>\n\t\t\t\t\x3c!-- / TOP VIEW --\x3e\n\n\t\t\t\t\x3c!-- LEGACY PUNCHING --\x3e\n\t\t\t\t<nuit-draw-stamping ng-if="vm.config.editor.nuitDrawStamping.enabled"></nuit-draw-stamping>\n\t\t\t\t\x3c!-- / LEGACY PUNCHING --\x3e\n\n\t\t\t\t\x3c!-- PUNCHING --\x3e\n\t\t\t\t<nuit-draw-stamping-rework ng-if="vm.config.editor.nuitDrawStampingRework.enabled" hide-ui="false"></nuit-draw-stamping-rework>\n\t\t\t\t\x3c!-- / PUNCHING --\x3e\n\n\t\t\t\t\x3c!-- CUTTING --\x3e\n\t\t\t\t<nuit-draw-cutting ng-if="vm.config.editor.nuitDrawCutting.enabled" hide-ui="false"></nuit-draw-cutting>\n\t\t\t\t\x3c!-- / CUTTING --\x3e\n\n\t\t\t</nuit-draw>\n\t\t</div>\n\t\t\x3c!-- / EDITOR --\x3e\n\n\t\t\x3c!-- SIDEBAR --\x3e\n\t\t<md-sidenav class="md-sidenav-right editor-sidebar md-whiteframe-3dp" md-is-locked-open="true" layout="column"\n\t\t            layout-align="start stretch" layout-fill>\n\n\t\t\t\x3c!-- PROFILE DEPTH --\x3e\n\t\t\t<div class="profile-depth" layout-padding layout="row" layout-align="space-between center"\n\t\t\t     md-colors="{background:\'default-background\'}">\n\t\t\t\t<span translate="PROFILE.LENGTH">Länge</span>\n\n\t\t\t\t<md-input-container class="no-error-spacer">\n\t\t\t\t\t<input ng-disabled="vm.isReadOnly(\'length\')" type="number" ng-model="vm.depth" ng-model-options="{ updateOn:\'change\' }" aria-label="n"\n\t\t\t\t\t       nuit-unit-input="length" ng-change="vm.reValidate()">\n\t\t\t\t</md-input-container>\n\t\t\t</div>\n\t\t\t\x3c!-- / PROFILE DEPTH --\x3e\n\n\t\t\t\x3c!-- EDITOR OPTIONS --\x3e\n\t\t\t<md-tabs md-border-bottom md-selected="vm.selectedIndex" md-stretch-tabs="never" flex>\n\n\t\t\t\t<div ng-repeat="tab in vm.tabs | orderBy: \'index\' track by tab.index">\n\t\t\t\t\t<ng-include src="tab.src"></ng-include>\n\t\t\t\t</div>\n\n\t\t\t</md-tabs>\n\t\t\t\x3c!-- / EDITOR OPTIONS --\x3e\n\n\t\t\t\x3c!-- 3D PREVIEW --\x3e\n\t\t\t<ng-transclude ng-if="vm.show3d()"></ng-transclude>\n\t\t\t\x3c!-- / 3D PREVIEW --\x3e\n\n\t\t</md-sidenav>\n\t\t\x3c!-- / SIDEBAR --\x3e\n\n\t</div>\n\t\x3c!-- / MAIN --\x3e\n\n</div>\n'),t.put("_nuit_/dialogs/add-stamping-line/view.html",'<md-dialog aria-label="n" class="add-stamping-line-dialog">\n\t\x3c!-- TOOLBAR --\x3e\n\t<md-toolbar class="md-accent-bg">\n\t\t<div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n\t\t\t<span class="title" translate="PROFILE.ADD_STAMPING_LINE">Add Stamping Line</span>\n\t\t</div>\n\t</md-toolbar>\n\t\x3c!-- / TOOLBAR --\x3e\n\n\t<form name="vm.form" ng-submit="vm.submit($event)">\n\n\t\t\x3c!-- CONTENT --\x3e\n\t\t<md-dialog-content class="md-dialog-content">\n\n\t\t\t\x3c!-- STAMPING AREA --\x3e\n\t\t\t<md-input-container style="display:block;">\n\t\t\t\t<md-select ng-model="vm.line.meta.area.index" required\n\t\t\t\t           md-selected-text="vm.getSelectedAreaLabel()" ng-change="vm.setAreaProperties()">\n\t\t\t\t\t<md-option ng-repeat="area in vm.manager.areas" ng-if="area.isVisible" ng-value="$index">{{area.name | nuitTranslate}}</md-option>\n\t\t\t\t</md-select>\n\t\t\t</md-input-container>\n\t\t\t\x3c!-- / STAMPING AREA --\x3e\n\n\t\t\t\x3c!-- TOOL SELECTION --\x3e\n\t\t\t<div layout="column" layout-align="start stretch" ng-show="vm.line.meta.area.index >= 0">\n\n\t\t\t\t\x3c!-- HEADING --\x3e\n\t\t\t\t<span class="md-body-2" style="font-weight:bold" translate="PROFILE.TOOL_SELECTION">Tool Selection</span>\n\t\t\t\t\x3c!-- / HEADING --\x3e\n\n\t\t\t\t\x3c!-- TOOL & SIZE --\x3e\n\t\t\t\t<div layout="row" layout-align="stretch center" class="no-error-spacer">\n\n\t\t\t\t\t\x3c!-- TOOL --\x3e\n\t\t\t\t\t<md-input-container flex="50">\n\t\t\t\t\t\t<label translate="PROFILE.TOOL">Tool</label>\n\t\t\t\t\t\t<md-select ng-model="vm.line.tool.id"\n\t\t\t\t\t\t           aria-label="n" ng-change="vm.setToolProperties()" required>\n\t\t\t\t\t\t\t<md-option ng-repeat="tool in vm.getAvailableTools() track by tool.id"\n\t\t\t\t\t\t\t           ng-value="tool.id">{{tool.name | nuitTranslate}}\n\t\t\t\t\t\t\t</md-option>\n\t\t\t\t\t\t</md-select>\n\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\x3c!-- / TOOL --\x3e\n\n\t\t\t\t\t\x3c!-- SIZE --\x3e\n\t\t\t\t\t<md-input-container flex="50">\n\t\t\t\t\t\t<label translate="PROFILE.TOOL_SIZE">Size</label>\n\t\t\t\t\t\t<md-select ng-model="vm.line.tool.size" aria-label="n" required ng-disabled="!vm.line.tool.id">\n\t\t\t\t\t\t\t<md-option ng-repeat="size in vm.getAvailableSizes() track by size.index"\n\t\t\t\t\t\t\t           ng-value="size.index">\n\t\t\t\t\t\t\t\t{{size.name | nuitTranslate}} ({{size.value | nuitUnit:\'length\'}})\n\t\t\t\t\t\t\t</md-option>\n\t\t\t\t\t\t</md-select>\n\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\x3c!-- / SIZE --\x3e\n\n\t\t\t\t</div>\n\t\t\t\t\x3c!-- / TOOL & SIZE --\x3e\n\n\t\t\t\t\x3c!-- BOUNDS --\x3e\n\t\t\t\t<div layout="row" layout-align="stretch center" class="no-error-spacer"\n\t\t\t\t     ng-model-options="{updateOn: \'change click\'}" ng-if="vm.manager.showToolDistances">\n\n\t\t\t\t\t\x3c!-- MIN --\x3e\n\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t<label translate="PROFILE.MIN_DISTANCE">Min</label>\n\t\t\t\t\t\t<input type="number" ng-model="vm.line.bounds.min" nuit-unit-input="length" required ng-disabled="!vm.line.tool.id">\n\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\x3c!-- / MIN --\x3e\n\n\t\t\t\t\t\x3c!-- MAX --\x3e\n\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t<label translate="PROFILE.MAX_DISTANCE">Max</label>\n\t\t\t\t\t\t<input type="number" ng-model="vm.line.bounds.max" nuit-unit-input="length" required ng-disabled="!vm.line.tool.id">\n\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\x3c!-- / MAX --\x3e\n\n\t\t\t\t</div>\n\t\t\t\t\x3c!-- / BOUNDS --\x3e\n\n\t\t\t</div>\n\t\t\t\x3c!-- / TOOL SELECTION --\x3e\n\n\t\t\t\x3c!-- DISTANCES --\x3e\n\t\t\t<div layout="column" layout-align="start stretch" ng-show="vm.line.tool.id"\n\t\t\t     ng-model-options="{updateOn: \'change click\'}">\n\n\t\t\t\t\x3c!-- HEADING --\x3e\n\t\t\t\t<span class="md-body-2" style="font-weight:bold" translate="PROFILE.STAMPING_POSITIONS">Positions</span>\n\t\t\t\t\x3c!-- / HEADING --\x3e\n\n\t\t\t\t\x3c!-- FIRST & LAST STAMPING --\x3e\n\t\t\t\t<div layout="row" layout-align="space-between center" class="no-error-spacer">\n\n\t\t\t\t\t\x3c!-- FIRST DISTANCE --\x3e\n\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t<label translate="PROFILE.FIRST_STAMPING">First stamping</label>\n\t\t\t\t\t\t<input type="number" ng-model="vm.line.first" nuit-unit-input="length" ng-min="vm.firstStampMinVal"\n\t\t\t\t\t\t       ng-max="vm.firstStampMaxVal" required>\n\t\t\t\t\t\t<div class="hint"><span translate="APP.MIN"></span> {{vm.firstStampMinVal | nuitUnit:\'length\'}}, <span translate="APP.MAX"></span> {{vm.firstStampMaxVal | nuitUnit:\'length\'}}</div>\n\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\x3c!-- / FIRST DISTANCE --\x3e\n\n\t\t\t\t\t\x3c!-- / LAST DISTANCE --\x3e\n\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t<label translate="PROFILE.LAST_STAMPING">Last stamping</label>\n\t\t\t\t\t\t<input type="number" ng-model="vm.line.last" nuit-unit-input="length" ng-min="vm.lastStampMinVal"\n\t\t\t\t\t\t       ng-max="vm.lastStampMaxVal"\n\t\t\t\t\t\t       ng-required="vm.line.meta.type === \'amount\'">\n\t\t\t\t\t\t<div class="hint"><span translate="APP.MIN"></span> {{vm.lastStampMinVal | nuitUnit:\'length\'}}, <span translate="APP.MAX"></span> {{vm.lastStampMaxVal | nuitUnit:\'length\'}}</div>\n\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\x3c!-- / LAST DISTANCE --\x3e\n\n\t\t\t\t</div>\n\t\t\t\t\x3c!-- / FIRST & LAST STAMPING --\x3e\n\n\t\t\t\t\x3c!-- LAST STAMPING / AMOUNT SWITCH --\x3e\n\t\t\t\t<md-radio-group ng-model="vm.line.meta.type" layout="row" layout-align="space-between start"\n\t\t\t\t                layout-wrap ng-init="vm.line.meta.type=vm.line.meta.type || \'amount\'">\n\n\t\t\t\t\t\x3c!-- AMOUNT --\x3e\n\t\t\t\t\t<md-radio-button value="amount" aria-label="n" flex="noshrink">\n\t\t\t\t\t\t<span translate="PROFILE.AMOUNT_TYPE">Amount</span>\n\t\t\t\t\t</md-radio-button>\n\t\t\t\t\t\x3c!-- / AMOUNT --\x3e\n\n\t\t\t\t\t\x3c!-- LAST STAMPING --\x3e\n\t\t\t\t\t<md-radio-button value="distance" aria-label="n" flex="noshrink">\n\t\t\t\t\t\t<span translate="PROFILE.DISTANCE_BETWEEN_TYPE">Distance between</span>\n\t\t\t\t\t</md-radio-button>\n\t\t\t\t\t\x3c!-- / LAST STAMPING --\x3e\n\n\t\t\t\t</md-radio-group>\n\t\t\t\t\x3c!-- / LAST STAMPING / AMOUNT SWITCH --\x3e\n\n\t\t\t\t\x3c!-- AMOUNT & DIST BETWEEN --\x3e\n\t\t\t\t<div layout="row" layout-align="space-between center" class="no-error-spacer"\n\t\t\t\t     ng-model-options="{updateOn: \'change click\'}">\n\n\t\t\t\t\t\x3c!-- AMOUNT --\x3e\n\t\t\t\t\t<div layout="row" layout-align="space-between center" flex="50">\n\n\t\t\t\t\t\t\x3c!-- AMOUNT INPUT --\x3e\n\t\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t\t<label translate="PROFILE.STAMPING_AMOUNT">Amount</label>\n\t\t\t\t\t\t\t<input type="number" ng-model="vm.line.amount" ng-disabled="!vm.line.meta.fixedAmount && vm.line.meta.type !== \'distance\'" ng-required="vm.line.meta.fixedAmount || vm.line.meta.type === \'distance\'">\n\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\x3c!-- / AMOUNT INPUT --\x3e\n\n\t\t\t\t\t\t\x3c!-- AMOUNT LOCK OPTION --\x3e\n\t\t\t\t\t\t<md-button ng-click="vm.line.meta.fixedAmount = !vm.line.meta.fixedAmount" flex="nogrow"\n\t\t\t\t\t\t           ng-class="{\'md-raised md-primary\': vm.line.meta.fixedAmount}" class="md-icon-button"\n\t\t\t\t\t\t           aria-label="n">\n\t\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_lock_outline_black_24px.svg"\n\t\t\t\t\t\t\t         ng-if="!vm.line.meta.fixedAmount"></md-icon>\n\t\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_lock_open_black_24px.svg"\n\t\t\t\t\t\t\t         ng-if="vm.line.meta.fixedAmount"></md-icon>\n\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\x3c!-- / AMOUNT LOCK OPTION --\x3e\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / AMOUNT --\x3e\n\n\t\t\t\t\t\x3c!-- DIST BETWEEN --\x3e\n\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t<label translate="PROFILE.DISTANCE_BETWEEN">Distance between</label>\n\t\t\t\t\t\t<input type="number" ng-model="vm.line.meta.distBetweenStamps"\n\t\t\t\t\t\t\t   nuit-unit-input="length"\n\t\t\t\t\t\t       ng-disabled="vm.line.meta.type === \'amount\'"\n\t\t\t\t\t\t       ng-required="vm.line.meta.type === \'distance\'"\n\t\t\t\t\t\t\t\tng-change="vm.updateAmount()">\n\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\x3c!-- / DIST BETWEEN --\x3e\n\n\t\t\t\t</div>\n\t\t\t\t\x3c!-- / AMOUNT & DIST BETWEEN --\x3e\n\n\t\t\t\t\x3c!-- OFFSET TOP --\x3e\n\t\t\t\t<md-input-container flex="50"\n\t\t\t\t                    ng-model-options="{updateOn: \'change click\'}">\n\t\t\t\t\t<label translate="PROFILE.OFFSET_TOP">Offset top</label>\n\t\t\t\t\t<input type="number" ng-model="vm.line.y" nuit-unit-input="length" required ng-min="vm.offsetMinVal"\n\t\t\t\t\t       ng-max="vm.offsetMaxVal">\n\t\t\t\t\t<div class="hint"><span translate="APP.MIN"></span> {{vm.offsetMinVal | nuitUnit:\'length\'}}, <span translate="APP.MAX"></span> {{vm.offsetMaxVal | nuitUnit:\'length\'}}</div>\n\t\t\t\t</md-input-container>\n\t\t\t\t\x3c!-- / OFFSET TOP --\x3e\n\n\t\t\t</div>\n\t\t\t\x3c!-- / DISTANCES --\x3e\n\n\t\t</md-dialog-content>\n\t\t\x3c!-- / CONTENT --\x3e\n\n\t\t\x3c!-- ACTION BUTTONS --\x3e\n\t\t<md-dialog-actions layout="row">\n\t\t\t<md-button type="submit" class="md-raised md-primary" aria-label="n" translate="APP.SAVE">Save</md-button>\n\t\t\t<md-button type="button" class="md-warning" aria-label="n" ng-click="vm.close()" translate="APP.CANCEL">Cancel</md-button>\n\t\t</md-dialog-actions>\n\t\t\x3c!-- / ACTION BUTTONS --\x3e\n\n\t</form>\n</md-dialog>\n'),t.put("_nuit_/dialogs/dynamic-segments/dynamic-segments.dialog.html",'<md-dialog aria-label="n" class="dynamic-segments-dialog">\n\n\t\x3c!-- TOOLBAR --\x3e\n\t<md-toolbar class="md-accent-bg">\n\t\t<div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n\t\t\t<span class="title" translate="EDITOR.DYNAMIC_SEGMENTS_DIALOG_TITLE">Dynamic Segments</span>\n\t\t\t<md-button class="md-icon-button md-raised md-accent" ng-click="vm.close()" aria-label="n">\n\t\t\t\t<md-icon md-svg-src="nuit::/assets/ic_close_black_24px.svg"></md-icon>\n\t\t\t\t<md-tooltip md-direction="bottom">\n\t\t\t\t\t<span translate="APP.CLOSE">Close</span>\n\t\t\t\t</md-tooltip>\n\t\t\t</md-button>\n\t\t</div>\n\t</md-toolbar>\n\t\x3c!-- / TOOLBAR --\x3e\n\n\t\x3c!-- CONTENT --\x3e\n\t<md-dialog-content class="md-dialog-content">\n\t\t<ng-form layout="row" layout-align="space-between center" layout-padding name="vm.form"\n\t\t      ng-repeat="segment in vm.dynamicSegments track by segment.index" ng-submit="vm.submit($event)">\n\n\t\t\t\x3c!-- INDEX --\x3e\n\t\t\t<span># {{segment.index+1}}</span>\n\t\t\t\x3c!-- / INDEX --\x3e\n\n\t\t\t\x3c!-- NAME --\x3e\n\t\t\t<div layout="row" layout-align="center center">\n\t\t\t\t<md-input-container class="no-error-spacer">\n\t\t\t\t\t<label translate="APP.NAME">Name</label>\n\t\t\t\t\t<input type="text" name="name" ng-model="segment.name[vm.currLang]" required>\n\t\t\t\t</md-input-container>\n\t\t\t\t<md-select ng-model="vm.currLang" md-selected-text="vm.currLang.toUpperCase()" aria-label="n">\n\t\t\t\t\t<md-option ng-repeat="lang in vm.languages" ng-value="lang">\n\t\t\t\t\t\t<span class="text-uppercase">{{lang}}</span>\n\t\t\t\t\t</md-option>\n\t\t\t\t</md-select>\n\t\t\t</div>\n\t\t\t\x3c!-- / NAME --\x3e\n\n\t\t\t\x3c!-- DEFAULT LENGTH --\x3e\n\t\t\t<md-input-container class="no-error-spacer">\n\t\t\t\t<label translate="PRODUCTS.SEGMENT_LENGTH">Length</label>\n\t\t\t\t<input type="number" name="length" ng-model="segment._originalSegment.length" readonly>\n\t\t\t</md-input-container>\n\t\t\t\x3c!-- / DEFAULT LENGTH --\x3e\n\n\t\t\t\x3c!-- MIN --\x3e\n\t\t\t<md-input-container class="no-error-spacer">\n\t\t\t\t<label translate="APP.MIN">Min</label>\n\t\t\t\t<input type="number" name="min" ng-model="segment.min" ng-min="0"\n\t\t\t\t       ng-max="segment._originalSegment.length"\n\t\t\t\t       nuit-unit-input="length">\n\t\t\t</md-input-container>\n\t\t\t\x3c!-- / MIN --\x3e\n\n\t\t\t\x3c!-- MAX --\x3e\n\t\t\t<md-input-container class="no-error-spacer">\n\t\t\t\t<label translate="APP.MAX">Max</label>\n\t\t\t\t<input type="number" name="max" ng-min="segment._originalSegment.length" ng-model="segment.max"\n\t\t\t\t       nuit-unit-input="length">\n\t\t\t</md-input-container>\n\t\t\t\x3c!-- / MAX --\x3e\n\n\t\t</ng-form>\n\t</md-dialog-content>\n\t\x3c!-- / CONTENT --\x3e\n\n\t\x3c!-- ACTIONS --\x3e\n\t<md-dialog-actions layout="row" layout-align="end center">\n\t\t<md-button ng-click="vm.close()" aria-label="n">\n\t\t\t<span translate="APP.CANCEL">Cancel</span>\n\t\t</md-button>\n\t\t<md-button ng-click="vm.submit()" class="md-accent md-raised" aria-label="n">\n\t\t\t<span translate="APP.SAVE">Save</span>\n\t\t</md-button>\n\t</md-dialog-actions>\n\t\x3c!-- / ACTIONS --\x3e\n\n</md-dialog>\n'),t.put("_nuit_/components/nuit-editor/sidebars/nuit-draw-2d.html",'<md-tab md-on-select="vm.useEditor(\'nuit-draw-2d\');" ng-if="vm.config.editor.nuitDraw2d.enabled">\n\t<md-tab-label>\n\t\t<span translate="PROFILE.PROFILE_EDITOR">Profildetails</span>\n\t</md-tab-label>\n\t<md-tab-body>\n\t\t<md-content ms-scroll layout-fill flex class="editor-sidebar-2d">\n\n\t\t\t\x3c!-- PREPEND NEW SEGMENT, ADD FIRST WRAP --\x3e\n\t\t\t<div layout="row" layout-align="space-between center" ng-if="!vm.isWrap(0) && !vm.manager.conicalMode"\n\t\t\t     class="addSegment">\n\n\t\t\t\t\x3c!-- ADD NEW SEGMENT --\x3e\n\t\t\t\t<md-button class="md-primary" ng-click="vm.addSegment(0);" aria-label="n">\n\t\t\t\t\t<span translate="SEGMENT.ADD">Add segment</span>\n\t\t\t\t</md-button>\n\t\t\t\t\x3c!-- / ADD NEW SEGMENT --\x3e\n\n\t\t\t\t\x3c!-- ADD NEW WRAP --\x3e\n\t\t\t\t<md-button class="md-secondary md-icon-button" ng-click="vm.addWrap(0)"\n\t\t\t\t           ng-if="vm.hasSegments()" aria-label="n">\n\n\t\t\t\t\t<md-tooltip>\n\t\t\t\t\t\t<span translate="NUIT_PROFIL.HEM.ADD"></span>\n\t\t\t\t\t</md-tooltip>\n\n\t\t\t\t\t\x3c!-- OPEN WRAP --\x3e\n\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/umschlag_offen.svg"\n\t\t\t\t\t         ng-if="!vm.config.editor.closeHem"></md-icon>\n\t\t\t\t\t\x3c!-- / OPEN WRAP --\x3e\n\n\t\t\t\t\t\x3c!-- CLOSED WRAP --\x3e\n\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/umschlag_geschlossen.svg"\n\t\t\t\t\t         ng-if="vm.config.editor.closeHem"></md-icon>\n\t\t\t\t\t\x3c!-- / CLOSED WRAP --\x3e\n\n\t\t\t\t</md-button>\n\t\t\t\t\x3c!-- / ADD NEW WRAP --\x3e\n\n\t\t\t\t\x3c!-- ADD CUSTOM SEGMENT --\x3e\n\t\t\t\t<md-button class="md-secondary md-icon-button" ng-click="vm.addWrap(0);vm.setType(0)"\n\t\t\t\t\t\t   ng-if="vm.hasSegments() && vm.config.evo.editor.customSegments.enabled" aria-label="n">\n\n\t\t\t\t\t<md-tooltip>\n\t\t\t\t\t\t<span translate="NUIT_PROFIL.CUSTOM_SEGMENT.ADD"></span>\n\t\t\t\t\t</md-tooltip>\n\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/curl.svg"></md-icon>\n\t\t\t\t</md-button>\n\t\t\t\t\x3c!-- ADD CUSTOM SEGMENT --\x3e\n\n\t\t\t</div>\n\t\t\t\x3c!-- / PREPEND NEW SEGMENT, ADD FIRST WRAP --\x3e\n\n\t\t\t\x3c!-- HEADINGS --\x3e\n\t\t\t<div layout="row" layout-align="space-between center" class="mr-20" ng-if="vm.manager.conicalMode">\n\t\t\t\t<span></span>\n\t\t\t\t<span translate="SEGMENT.FRONT">Vorderlänge</span>\n\t\t\t\t<span translate="SEGMENT.BACK">Hinterlänge</span>\n\t\t\t\t<span></span>\n\t\t\t</div>\n\t\t\t\x3c!-- / HEADINGS --\x3e\n\n\t\t\t\x3c!-- SEGMENT LIST --\x3e\n\t\t\t<md-list>\n\n\t\t\t\t\x3c!-- SEGMENT --\x3e\n\t\t\t\t<md-list-item ng-if="vm.manager.conicalMode">\n\t\t\t\t\t\x3c!-- CONICAL BASE --\x3e\n\t\t\t\t\t<div flex class="m-0 p-0" ng-show="vm.manager.conicalMode">\n\t\t\t\t\t\t\x3c!-- ICON MEASURE INNER --\x3e\n\t\t\t\t\t\t<md-button class="measure"\n\t\t\t\t\t\t\t\t   ng-click="vm.manager.setConicalBase(-1);">\n\t\t\t\t\t\t\t<md-icon class="m-0 p-0"\n\t\t\t\t\t\t\t\t\t md-font-icon="{{(vm.manager.getConicalBase()===-1?\'icon-chevron-double-right\':\'icon-chevron-down\')}}"\n\t\t\t\t\t\t\t\t\t class="inner">\n\t\t\t\t\t\t\t\t<md-tooltip md-direction="bottom">\n\t\t\t\t\t\t\t\t\t<span translate="EDITOR.CONICAL_BASE">CONICAL BASE</span>\n\t\t\t\t\t\t\t\t</md-tooltip>\n\t\t\t\t\t\t\t</md-icon>\n\t\t\t\t\t\t</md-button>\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- /  CONICAL BASE --\x3e\n\t\t\t\t</md-list-item>\n\t\t\t\t<md-list-item ng-repeat="segment in vm.segments" class="segment"\n\t\t\t\t              ng-class="{ \'wrap\': segment.isWrap() }"\n\t\t\t\t              ng-model-options="{updateOn : \'change\'}">\n\t\t\t\t\t<div layout="row" flex layout-align="space-between center">\n\n\t\t\t\t\t\t\x3c!-- LEFT --\x3e\n\t\t\t\t\t\t<div layout="row" layout-align="start center" class="left">\n\n\t\t\t\t\t\t\t\x3c!-- MEASURE IO ICONS --\x3e\n\t\t\t\t\t\t\t<div flex class="m-0 p-0" ng-show="vm.material && (vm.originalThickness >= vm.config.editor.innerOuterThicknessThreshold) && !vm.manager.conicalMode">\n\t\t\t\t\t\t\t\t\x3c!-- ICON MEASURE INNER --\x3e\n\t\t\t\t\t\t\t\t<md-button class="measure"\n\t\t\t\t\t\t\t\t           ng-if="segment.measureSide === vm.MEASURE.Outer"\n\t\t\t\t\t\t\t\t           ng-click="vm.toggleMeasure($index);">\n\t\t\t\t\t\t\t\t\t<md-icon class="m-0 p-0"\n\t\t\t\t\t\t\t\t\t         md-svg-src="_nuit_/assets/ic_code_black_24px.svg"\n\t\t\t\t\t\t\t\t\t         class="inner">\n\t\t\t\t\t\t\t\t\t\t<md-tooltip md-direction="bottom">\n\t\t\t\t\t\t\t\t\t\t\t<span translate="EDITOR.MEASURE_OUTER">Außenmaß</span>\n\t\t\t\t\t\t\t\t\t\t</md-tooltip>\n\t\t\t\t\t\t\t\t\t</md-icon>\n\t\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\t\x3c!-- / ICON MEASURE INNER --\x3e\n\n\t\t\t\t\t\t\t\t\x3c!-- ICON MEASURE INNER --\x3e\n\t\t\t\t\t\t\t\t<md-button class="measure"\n\t\t\t\t\t\t\t\t           ng-if="segment.measureSide === vm.MEASURE.Inner"\n\t\t\t\t\t\t\t\t           ng-click="vm.toggleMeasure($index);">\n\t\t\t\t\t\t\t\t\t<md-icon class="m-0 p-0"\n\t\t\t\t\t\t\t\t\t         md-svg-src="_nuit_/assets/ic_inner_black_24px.svg"\n\t\t\t\t\t\t\t\t\t         class="inner">\n\t\t\t\t\t\t\t\t\t\t<md-tooltip md-direction="bottom">\n\t\t\t\t\t\t\t\t\t\t\t<span translate="EDITOR.MEASURE_INNER">Innenmaß</span>\n\t\t\t\t\t\t\t\t\t\t</md-tooltip>\n\t\t\t\t\t\t\t\t\t</md-icon>\n\t\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\t\x3c!-- / ICON MEASURE INNER --\x3e\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\x3c!-- / MEASURE IO ICONS --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- CONICAL BASE --\x3e\n\t\t\t\t\t\t\t<div flex class="m-0 p-0" ng-show="vm.manager.conicalMode">\n\t\t\t\t\t\t\t\t\x3c!-- ICON MEASURE INNER --\x3e\n\t\t\t\t\t\t\t\t<md-button class="measure"\n\t\t\t\t\t\t\t\t\t\t   ng-click="vm.manager.setConicalBase($index);">\n\t\t\t\t\t\t\t\t\t<md-icon class="m-0 p-0"\n\t\t\t\t\t\t\t\t\t\t\t md-font-icon="{{($index===vm.manager.getConicalBase()?\'icon-chevron-double-right\':\'icon-chevron-down\')}}"\n\t\t\t\t\t\t\t\t\t\t\t class="inner">\n\t\t\t\t\t\t\t\t\t\t<md-tooltip md-direction="bottom">\n\t\t\t\t\t\t\t\t\t\t\t<span translate="EDITOR.CONICAL_BASE">CONICAL BASE</span>\n\t\t\t\t\t\t\t\t\t\t</md-tooltip>\n\t\t\t\t\t\t\t\t\t</md-icon>\n\t\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\x3c!-- /  CONICAL BASE --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- LENGTH --\x3e\n\t\t\t\t\t\t\t<div class="length">\n\t\t\t\t\t\t\t\t<input type="number"\n\t\t\t\t\t\t\t\t       ng-model="segment.length"\n\t\t\t\t\t\t\t\t\t   ng-disabled="segment.getType()!==undefined"\n\t\t\t\t\t\t\t\t       ng-change="vm.refreshFrontLength(segment, $index)"\n\t\t\t\t\t\t\t\t       ng-blur="vm.unhighlightAll()"\n\t\t\t\t\t\t\t\t       ng-focus="vm.highlightSegment($index, {direction:\'front\'});"\n\t\t\t\t\t\t\t\t       aria-label="n"\n\t\t\t\t\t\t\t\t\t   id="length-front-{{segment.index}}"\n\t\t\t\t\t\t\t\t\t   nuit-unit-input="length"\n\t\t\t\t\t\t\t\t\t   data-length-focus="{{$index}}" tabindex="{{$index*2+1}}"\n\t\t\t\t\t\t\t\t\t   ng-keydown="vm.shortCutAction($event)">\n\t\t\t\t\t\t\t\t<span class="unit">{{vm.config.units.length.symbol}}</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\x3c!-- / LENGTH --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- TOGGLE CONICAL SETTING --\x3e\n\t\t\t\t\t\t\t<md-button class="md-icon-button" aria-label="n" ng-if="!segment.isWrap() && vm.manager.conicalMode"\n\t\t\t\t\t\t\t\t\t   ng-click="vm.toggleConical($index)"\n\t\t\t\t\t\t\t\t\t   ng-class="{\'md-raised md-primary\':segment.isConical()}"\n\t\t\t\t\t\t\t\t\t   tabindex="-1">\n\t\t\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_lock_open_black_24px.svg"\n\t\t\t\t\t\t\t\t\t\t ng-if="segment.isConical()"></md-icon>\n\t\t\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_lock_outline_black_24px.svg"\n\t\t\t\t\t\t\t\t\t\t ng-if="!segment.isConical()"></md-icon>\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\x3c!-- TOGGLE CONICAL SETTING --\x3e\n\n\t\t\t\t\t\t\t<div class="length" ng-if="vm.manager.conicalMode">\n\t\t\t\t\t\t\t\t<input type="number"\n\t\t\t\t\t\t\t\t\t   ng-disabled="!segment.isConical()"\n\t\t\t\t\t\t\t\t\t   ng-model="segment.backLength"\n\t\t\t\t\t\t\t\t\t   ng-change="vm.refreshBackLength(segment, $index)"\n\t\t\t\t\t\t\t\t\t   ng-blur="vm.unhighlightAll()"\n\t\t\t\t\t\t\t\t\t   ng-focus="vm.highlightSegment($index, {direction:\'back\'});"\n\t\t\t\t\t\t\t\t\t   aria-label="n"\n\t\t\t\t\t\t\t\t\t   id="length-back-{{segment.index}}"\n\t\t\t\t\t\t\t\t\t   nuit-unit-input="length"\n\t\t\t\t\t\t\t\t\t   data-backlength-focus="{{$index}}" tabindex="{{$index*2+1}}">\n\t\t\t\t\t\t\t\t<span class="unit">{{vm.config.units.length.symbol}}</span>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\x3c!-- ANGLE --\x3e\n\t\t\t\t\t\t\t<div class="angle" ng-if="$index>0 && !vm.manager.conicalMode">\n\t\t\t\t\t\t\t\t<input type="number" min="-179" max="180"\n\t\t\t\t\t\t\t\t       ng-model="segment.angleOffsetProp"\n\t\t\t\t\t\t\t\t\t   ng-change="vm.reValidate()"\n\t\t\t\t\t\t\t\t       ng-blur="vm.unhighlightAll()"\n\t\t\t\t\t\t\t\t       ng-focus="vm.highlightAngle($event, $index);"\n\t\t\t\t\t\t\t\t       aria-label="n" nuit-angle="$index"\n\t\t\t\t\t\t\t\t       data-angle-focus="{{$index}}" tabindex="{{$index*2}}">\n\t\t\t\t\t\t\t\t<span class="unit">°</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\x3c!-- / ANGLE --\x3e\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\x3c!-- / LEFT --\x3e\n\n\t\t\t\t\t\t\x3c!-- RIGHT --\x3e\n\t\t\t\t\t\t<div layout="row" layout-align="end center" class="buttons-no-margin right">\n\n\t\t\t\t\t\t\t\x3c!-- TOGGLE FIRST BENDING DIR --\x3e\n\t\t\t\t\t\t\t<md-button class="md-icon-button" tabindex="-1" aria-label="n"\n\t\t\t\t\t\t\t           ng-if="vm.isWrap($index) && $index === 0"\n\t\t\t\t\t\t\t           ng-click="vm.toggleBdir($index+1);"\n\t\t\t\t\t\t\t\t\t   style="transform: rotate(90deg);">\n\n\t\t\t\t\t\t\t\t<md-tooltip>\n\t\t\t\t\t\t\t\t\t<span translate="NUIT_PROFILE.SETTINGS.HEM_DIRECTION.CHANGE"></span>\n\t\t\t\t\t\t\t\t</md-tooltip>\n\n\t\t\t\t\t\t\t\t<md-icon\n\t\t\t\t\t\t\t\t\tmd-svg-src="_nuit_/assets/ic_swap_horiz_black_24px.svg"></md-icon>\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\x3c!-- / TOGGLE FIRST BENDING DIR --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- TOGGLE LAST BENDING DIR --\x3e\n\t\t\t\t\t\t\t<md-button class="md-icon-button" tabindex="-1" aria-label="n"\n\t\t\t\t\t\t\t           ng-if="vm.isWrap($index) && $index > 0"\n\t\t\t\t\t\t\t           ng-click="vm.toggleBdir($index);"\n\t\t\t\t\t\t\t\t\t   style="transform: rotate(90deg);">\n\t\t\t\t\t\t\t\t<md-tooltip>\n\t\t\t\t\t\t\t\t\t<span translate="NUIT_PROFILE.SETTINGS.HEM_DIRECTION.CHANGE"></span>\n\t\t\t\t\t\t\t\t</md-tooltip>\n\n\t\t\t\t\t\t\t\t<md-icon\n\t\t\t\t\t\t\t\t\tmd-svg-src="_nuit_/assets/ic_swap_horiz_black_24px.svg"></md-icon>\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\x3c!-- / TOGGLE LAST BENDING DIR --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- TOGGLE CLOSE MODE --\x3e\n\t\t\t\t\t\t\t<md-button class="md-icon-button" tabindex="-1" aria-label="n"\n\t\t\t\t\t\t\t           ng-click="vm.toggleClose($index)"\n\t\t\t\t\t\t\t           ng-if="vm.isWrapMode($index, true, true) && segment.getType()===undefined">\n\t\t\t\t\t\t\t\t<md-tooltip><span translate="NUIT_PROFIL.HEM.OPEN"></span></md-tooltip>\n\t\t\t\t\t\t\t\t<md-icon style="transform: scale(-1);"\n\t\t\t\t\t\t\t\t\tmd-svg-src="_nuit_/assets/umschlag_geschlossen_gesp.svg"></md-icon>\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t<md-button class="md-icon-button" tabindex="-1" aria-label="n"\n\t\t\t\t\t\t\t           ng-click="vm.toggleClose($index)"\n\t\t\t\t\t\t\t           ng-if="vm.isWrapMode($index, true, false) && segment.getType()===undefined">\n\t\t\t\t\t\t\t\t<md-tooltip><span translate="NUIT_PROFIL.HEM.CLOSE"></span></md-tooltip>\n\t\t\t\t\t\t\t\t<md-icon style="transform: scale(-1);"\n\t\t\t\t\t\t\t\t\tmd-svg-src="_nuit_/assets/umschlag_offen_gesp.svg"></md-icon>\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t<md-button class="md-icon-button" tabindex="-1" aria-label="n"\n\t\t\t\t\t\t\t           ng-click="vm.toggleClose($index)"\n\t\t\t\t\t\t\t           ng-if="vm.isWrapMode($index, false, false) && segment.getType()===undefined">\n\t\t\t\t\t\t\t\t<md-tooltip><span translate="NUIT_PROFIL.HEM.CLOSE"></span></md-tooltip>\n\t\t\t\t\t\t\t\t<md-icon style="transform: scale(-1);"\n\t\t\t\t\t\t\t\t\tmd-svg-src="_nuit_/assets/umschlag_offen.svg"></md-icon>\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t<md-button class="md-icon-button" tabindex="-1" aria-label="n"\n\t\t\t\t\t\t\t           ng-click="vm.toggleClose($index)"\n\t\t\t\t\t\t\t           ng-if="vm.isWrapMode($index, false, true) && segment.getType()===undefined">\n\t\t\t\t\t\t\t\t<md-tooltip><span translate="NUIT_PROFIL.HEM.OPEN"></span></md-tooltip>\n\t\t\t\t\t\t\t\t<md-icon style="transform: scale(-1);"\n\t\t\t\t\t\t\t\t\tmd-svg-src="_nuit_/assets/umschlag_geschlossen.svg"></md-icon>\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\x3c!-- / TOGGLE CLOSE MODE --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- TOGGLE TYPE --\x3e\n\t\t\t\t\t\t\t<md-button class="md-icon-button" tabindex="-1" aria-label="n"\n\t\t\t\t\t\t\t\t\t   ng-if="vm.isWrap($index) && vm.config.evo.editor.customSegments.enabled && segment.getType()!==undefined"\n\t\t\t\t\t\t\t\t\t   ng-click="vm.setType($index);"\n\t\t\t\t\t\t\t\t\t   style="transform: rotate(90deg);">\n\n\t\t\t\t\t\t\t\t<md-tooltip>\n\t\t\t\t\t\t\t\t\t<span translate="NUIT_PROFILE.SETTINGS.SET_TYPE"></span>\n\t\t\t\t\t\t\t\t</md-tooltip>\n\n\t\t\t\t\t\t\t\t{{segment.getType()}}\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\x3c!-- / TOGGLE TYPE --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- SET DYNAMIC SEGMENT --\x3e\n\t\t\t\t\t\t\t<md-button class="md-button" ng-click="vm.addDynamicSegment($index)"\n\t\t\t\t\t\t\t           ng-if="!vm.isDynamic($index) && !vm.hasHoles() && vm.config.editor.allowDynamicSegments"\n\t\t\t\t\t\t\t           tabindex="-1" aria-label="n">\n\t\t\t\t\t\t\t\t<md-icon\n\t\t\t\t\t\t\t\t\tmd-svg-src="_nuit_/assets/ic_star_border_black_24px.svg"></md-icon>\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\x3c!-- / SET DYNAMIC SEGMENT --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- UNSET DYNAMIC SEGMENT --\x3e\n\t\t\t\t\t\t\t<md-button class="md-icon-button" ng-click="vm.removeDynamicSegment($index)"\n\t\t\t\t\t\t\t           ng-if="vm.isDynamic($index) && !vm.hasHoles() && vm.config.editor.allowDynamicSegments"\n\t\t\t\t\t\t\t           tabindex="-1" aria-label="n">\n\t\t\t\t\t\t\t\t<md-icon class="yellow-700-fg"\n\t\t\t\t\t\t\t\t         md-svg-src="_nuit_/assets/ic_star_black_24px.svg"></md-icon>\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\x3c!-- / UNSET DYNAMIC CONTENT --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- REMOVE SEGMENT --\x3e\n\t\t\t\t\t\t\t<md-button class="md-icon-button" ng-click="vm.removeSegment($index)"\n\t\t\t\t\t\t\t           tabindex="-1" aria-label="n">\n\t\t\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_close_black_24px.svg"></md-icon>\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\x3c!-- / REMOVE SEGMENT --\x3e\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\x3c!-- / RIGHT --\x3e\n\n\t\t\t\t\t</div>\n\t\t\t\t</md-list-item>\n\t\t\t\t<md-list-item ng-if="vm.manager.conicalMode">\n\t\t\t\t\t\x3c!-- CONICAL BASE --\x3e\n\t\t\t\t\t<div flex class="m-0 p-0" ng-show="vm.manager.conicalMode">\n\t\t\t\t\t\t\x3c!-- ICON MEASURE INNER --\x3e\n\t\t\t\t\t\t<md-button class="measure"\n\t\t\t\t\t\t\t\t   ng-click="vm.manager.setConicalBase(9999);">\n\t\t\t\t\t\t\t<md-icon class="m-0 p-0"\n\t\t\t\t\t\t\t\t\t md-font-icon="{{(vm.manager.getConicalBase()===9999?\'icon-chevron-double-right\':\'icon-chevron-down\')}}"\n\t\t\t\t\t\t\t\t\t class="inner">\n\t\t\t\t\t\t\t\t<md-tooltip md-direction="bottom">\n\t\t\t\t\t\t\t\t\t<span translate="EDITOR.CONICAL_BASE">CONICAL BASE</span>\n\t\t\t\t\t\t\t\t</md-tooltip>\n\t\t\t\t\t\t\t</md-icon>\n\t\t\t\t\t\t</md-button>\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- /  CONICAL BASE --\x3e\n\t\t\t\t</md-list-item>\n\t\t\t\t\x3c!-- / SEGMENT --\x3e\n\n\t\t\t</md-list>\n\t\t\t\x3c!-- / SEGMENT LIST --\x3e\n\n\t\t\t\x3c!-- APPEND NEW SEGMENT, ADD LAST WRAP --\x3e\n\t\t\t<div layout="row" layout-align="space-between center" class="addSegment"\n\t\t\t     ng-if="vm.hasSegments() && !vm.isWrap(vm.segmentCount() - 1) && !vm.manager.conicalMode && !segment.getType()">\n\n\t\t\t\t\x3c!-- ADD NEW SEGMENT --\x3e\n\t\t\t\t<md-button class="md-primary" ng-click="vm.addSegment(vm.segmentCount())"\n\t\t\t\t           aria-label="n">\n\t\t\t\t\t<span translate="SEGMENT.ADD">Add segment</span>\n\t\t\t\t</md-button>\n\t\t\t\t\x3c!-- / ADD NEW SEGMENT --\x3e\n\n\t\t\t\t\x3c!-- ADD LAST WRAP --\x3e\n\t\t\t\t<md-button class="md-secondary md-icon-button" aria-label="n"\n\t\t\t\t           ng-click="vm.addWrap(vm.segmentCount())">\n\n\t\t\t\t\t<md-tooltip >\n\t\t\t\t\t\t<span translate="NUIT_PROFIL.HEM.ADD"></span>\n\t\t\t\t\t</md-tooltip>\n\n\t\t\t\t\t\x3c!-- OPEN WRAP --\x3e\n\t\t\t\t\t<md-icon style="transform: scale(-1);" md-svg-src="_nuit_/assets/umschlag_offen.svg"\n\t\t\t\t\t         ng-if="!vm.config.editor.closeHem"></md-icon>\n\t\t\t\t\t\x3c!-- / OPEN WRAP --\x3e\n\n\t\t\t\t\t\x3c!-- CLOSED WRAP --\x3e\n\t\t\t\t\t<md-icon style="transform: scale(-1);" md-svg-src="_nuit_/assets/umschlag_geschlossen.svg"\n\t\t\t\t\t         ng-if="vm.config.editor.closeHem"></md-icon>\n\t\t\t\t\t\x3c!-- / CLOSED WRAP --\x3e\n\n\t\t\t\t</md-button>\n\t\t\t\t\x3c!-- / ADD LAST WRAP --\x3e\n\n\t\t\t\t\x3c!-- ADD CUSTOM SEGMENT --\x3e\n\t\t\t\t<md-button class="md-secondary md-icon-button" ng-click="vm.addWrap(vm.segmentCount());vm.setType(vm.segmentCount()-1)"\n\t\t\t\t\t\t   ng-if="vm.hasSegments() && vm.config.evo.editor.customSegments.enabled" aria-label="n">\n\n\t\t\t\t\t<md-tooltip>\n\t\t\t\t\t\t<span translate="NUIT_PROFIL.CUSTOM_SEGMENT.ADD"></span>\n\t\t\t\t\t</md-tooltip>\n\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/curl.svg"></md-icon>\n\t\t\t\t</md-button>\n\t\t\t\t\x3c!-- ADD CUSTOM SEGMENT --\x3e\n\n\t\t\t</div>\n\t\t\t\x3c!-- / APPEND NEW SEGMENT, ADD LAST WRAP --\x3e\n\n\t\t</md-content>\n\t</md-tab-body>\n</md-tab>\n'),t.put("_nuit_/components/nuit-editor/sidebars/nuit-draw-cutting.html",'<md-tab md-on-select="vm.useEditor(\'nuit-draw-cutting\')"\n\t\tng-if="vm.config.editor.nuitDrawCutting.enabled" ng-disabled="!vm.hasSegments()">\n\t<md-tab-label>\n\t\t<span translate="PROFILE.CUTTING">Cutting</span>\n\t</md-tab-label>\n\t<md-tab-body>\n\t\t<md-content ms-scroll layout-fill flex class="editor-sidebar-cutting">\n\n\t\t\t\x3c!-- CUTTING CONTAINER --\x3e\n\t\t\t<div class="md-whiteframe-1dp" style="margin-bottom:20px;" ng-repeat="cutting in vm.manager.cuttings">\n\n\t\t\t\t\x3c!-- TITLE --\x3e\n\t\t\t\t<span class="md-title" style="padding:10px 20px;" layout layout-align="space-between center"\n\t\t\t\t\t  ng-click="vm.openCuttings = vm.openCuttings === $index ? null : $index">\n\n\t\t\t\t\t\x3c!-- LINE TITLE --\x3e\n\t\t\t\t\t<span>\n\t\t\t\t\t\t<span translate="PROFILE.CUTTING">Cutting</span> #{{$index}}\n\t\t\t\t\t</span>\n\t\t\t\t\t\x3c!-- / LINE TITLE --\x3e\n\n\t\t\t\t\t\x3c!-- DELETE BUTTON --\x3e\n\t\t\t\t\t<md-button class="md-icon-button" aria-label="n" ng-click="vm.manager.removeCutting($index)">\n\t\t\t\t\t\t<md-tooltip md-direction="left" translate="MENUBAR.DELETE">Delete</md-tooltip>\n\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/baseline-delete_forever-24px.svg"></md-icon>\n\t\t\t\t\t</md-button>\n\t\t\t\t\t\x3c!-- / DELETE BUTTON --\x3e\n\n\t\t\t\t</span>\n\t\t\t\t\x3c!-- / TITLE --\x3e\n\n\t\t\t\t\x3c!-- CARD CONTENT --\x3e\n\t\t\t\t<div ng-show="vm.openCuttings === $index">\n\n\t\t\t\t\t\x3c!-- CUTTING DETAILS --\x3e\n\t\t\t\t\t<div style="border-top:1px solid rgba(0,0,0,.12);padding:20px;" layout="column"\n\t\t\t\t\t\t layout-align="start stretch" class="no-error-spacer">\n\n\t\t\t\t\t\t\x3c!-- ANGLE --\x3e\n\t\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t\t<label translate="CUTTING.ANGLE">Angle</label>\n\t\t\t\t\t\t\t<input type="number" ng-model="cutting.angle" step="1">\n\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\x3c!-- / ANGLE --\x3e\n\n\t\t\t\t\t\t\x3c!-- SEGMENT & DISTANCE --\x3e\n\t\t\t\t\t\t<div layout="row" layout-align="space-between center">\n\n\t\t\t\t\t\t\t\x3c!-- REFERENCED SEGMENT --\x3e\n\t\t\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t\t\t<label translate="CUTTING.REFERENCED_BENDING_LINE">Referenced Bending Line</label>\n\t\t\t\t\t\t\t\t<input type="number" ng-model="cutting.referenceSegment" min="0" step="1">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\x3c!-- / REFERENCED SEGMENT --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- DISTANCE --\x3e\n\t\t\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t\t\t<label translate="CUTTING.DISTANCE_FROM_START">Distance from start</label>\n\t\t\t\t\t\t\t\t<input type="number" ng-model="cutting.start" min="0" step="1">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\x3c!-- / DISTANCE --\x3e\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\x3c!-- / SEGMENT & DISTANCE --\x3e\n\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / CUTTING DETAILS --\x3e\n\n\t\t\t\t</div>\n\t\t\t\t\x3c!-- / CARD CONTENT --\x3e\n\n\t\t\t</div>\n\t\t\t\x3c!-- / CUTTING CONTAINER --\x3e\n\n\t\t</md-content>\n\t</md-tab-body>\n</md-tab>\n'),t.put("_nuit_/components/nuit-editor/sidebars/nuit-draw-stamping-rework.html",'<md-tab md-on-select="vm.useEditor(\'nuit-draw-stamping-rework\')"\n        ng-if="vm.config.editor.nuitDrawStampingRework.enabled" ng-disabled="!vm.hasSegments()">\n\t<md-tab-label>\n\t\t<span translate="PROFILE.PUNCHINGS">Punching</span>\n\t</md-tab-label>\n\t<md-tab-body>\n\t\t<md-content ms-scroll layout-fill flex class="editor-sidebar-stamping"\n\t\t            ng-model-options="{updateOn: \'change click\'}">\n\n\t\t\t\x3c!-- STAMPING LINE CONTAINER --\x3e\n\t\t\t<div class="md-whiteframe-1dp" style="margin-bottom:20px;" ng-repeat="line in vm.manager.stampingLines"\n\t\t\t     ng-mouseenter="vm.highlightStampingLine($event, $index)"\n\t\t\t     ng-mouseleave="vm.unhighlightStampings()">\n\n\t\t\t\t\x3c!-- TITLE --\x3e\n\t\t\t\t<span class="md-title" style="padding:10px 20px;" layout layout-align="space-between center"\n\t\t\t\t      ng-click="vm.openStampings = vm.openStampings === $index ? null : $index">\n\n\t\t\t\t\t\x3c!-- LINE TITLE --\x3e\n\t\t\t\t\t<span>\n\t\t\t\t\t\t<span translate="EDITOR.STAMPING_HEADER">Punching</span> #{{$index + 1}}\n\t\t\t\t\t\t\x3c!--<span ng-if="vm.manager.isDisabledByType(line.type)" translate="PROFILE.STAMPING_TEMPLATE">Template</span>--\x3e\n\t\t\t\t\t\t<span style="opacity:.7;font-size:.8em;font-style:italic;">({{line.area | nuitTranslate}})</span>\n\t\t\t\t\t</span>\n\t\t\t\t\t\x3c!-- / LINE TITLE --\x3e\n\n\t\t\t\t\t\x3c!-- DELETE BUTTON --\x3e\n\t\t\t\t\t<md-button class="md-icon-button" aria-label="n" ng-click="vm.manager.deleteStampingLine($index)">\n\t\t\t\t\t\t<md-tooltip md-direction="left">Delete</md-tooltip>\n\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/baseline-delete_forever-24px.svg"></md-icon>\n\t\t\t\t\t</md-button>\n\t\t\t\t\t\x3c!-- / DELETE BUTTON --\x3e\n\n\t\t\t\t</span>\n\t\t\t\t\x3c!-- / TITLE --\x3e\n\n\t\t\t\t\x3c!-- CARD CONTENT --\x3e\n\t\t\t\t<div ng-show="vm.openStampings === $index">\n\t\t\t\t\t\x3c!-- STAMPING LINE DETAILS --\x3e\n\t\t\t\t\t<div style="border-top:1px solid rgba(0,0,0,.12);padding:20px;" layout="column"\n\t\t\t\t\t     layout-align="start stretch" class="no-error-spacer">\n\n\t\t\t\t\t\t<span class="mb-10">\n\t\t\t\t\t\t\t<span>{{line.tool.name | nuitTranslate}}</span>\n\t\t\t\t\t\t\t<span>{{line.tool.sizes[line.size].name | nuitTranslate}}</span>\n\t\t\t\t\t\t\t<span>({{line.tool.sizes[line.size].value | nuitUnit:\'length\'}})</span>\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\x3c!-- FIRST & LAST DISTANCE --\x3e\n\t\t\t\t\t\t<div layout="row" layout-align="space-between center">\n\n\t\t\t\t\t\t\t\x3c!-- FIRST DISTANCE --\x3e\n\t\t\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t\t\t<label translate="PROFILE.FIRST_STAMPING">First stamping</label>\n\t\t\t\t\t\t\t\t<input type="number" ng-model="line.first" nuit-unit-input="length" ng-disabled="vm.manager.isDisabledByType(line.type)" ng-blur="vm.manager.requireRefresh()">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\x3c!-- / FIRST DISTANCE --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- / LAST DISTANCE --\x3e\n\t\t\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t\t\t<label translate="PROFILE.LAST_STAMPING">Last stamping</label>\n\t\t\t\t\t\t\t\t<input type="number" ng-model="line.last" nuit-unit-input="length" ng-disabled="vm.manager.isDisabledByType(line.type)" ng-blur="vm.manager.requireRefresh()">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\x3c!-- / LAST DISTANCE --\x3e\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\x3c!-- / FIRST & LAST DISTANCE --\x3e\n\n\t\t\t\t\t\t\x3c!-- LAST STAMPING / AMOUNT SWITCH --\x3e\n\t\t\t\t\t\t<md-radio-group ng-model="line.type" layout="row" layout-align="space-between start"\n\t\t\t\t\t\t                layout-wrap ng-disabled="vm.manager.isDisabledByType(line.type)" ng-change="vm.manager.requireRefresh()">\n\n\t\t\t\t\t\t\t\x3c!-- AMOUNT --\x3e\n\t\t\t\t\t\t\t<md-radio-button value="amount" aria-label="n" flex="noshrink">\n\t\t\t\t\t\t\t\t<span>Amount</span>\n\t\t\t\t\t\t\t</md-radio-button>\n\t\t\t\t\t\t\t\x3c!-- / AMOUNT --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- LAST STAMPING --\x3e\n\t\t\t\t\t\t\t<md-radio-button value="distance" aria-label="n" flex="noshrink">\n\t\t\t\t\t\t\t\t<span>Distance between</span>\n\t\t\t\t\t\t\t</md-radio-button>\n\t\t\t\t\t\t\t\x3c!-- / LAST STAMPING --\x3e\n\n\t\t\t\t\t\t</md-radio-group>\n\t\t\t\t\t\t\x3c!-- / LAST STAMPING / AMOUNT SWITCH --\x3e\n\n\t\t\t\t\t\t<div layout="row" layout-align="space-between center">\n\n\t\t\t\t\t\t\t\x3c!-- AMOUNT --\x3e\n\t\t\t\t\t\t\t<div layout="row" layout-align="space-between center" flex="50">\n\n\t\t\t\t\t\t\t\t\x3c!-- AMOUNT INPUT --\x3e\n\t\t\t\t\t\t\t\t<md-input-container flex>\n\t\t\t\t\t\t\t\t\t<label translate="PROFILE.STAMPING_AMOUNT">Amount</label>\n\t\t\t\t\t\t\t\t\t<input type="number" ng-model="line.amount"\n\t\t\t\t\t\t\t\t\t       ng-disabled="!line.fixedAmount || vm.manager.isDisabledByType(line.type)" ng-blur="vm.manager.requireRefresh()">\n\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\t\x3c!-- / AMOUNT INPUT --\x3e\n\n\t\t\t\t\t\t\t\t\x3c!-- ENABLE/DISABLE AMOUNT OPTION --\x3e\n\t\t\t\t\t\t\t\t<md-button ng-click="line.fixedAmount = !line.fixedAmount; vm.manager.requireRefresh();" flex="nogrow"\n\t\t\t\t\t\t\t\t           ng-class="{\'md-raised md-primary\':line.fixedAmount}"\n\t\t\t\t\t\t\t\t           class="md-icon-button" aria-label="n" ng-disabled="vm.manager.isDisabledByType(line.type)">\n\t\t\t\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_lock_outline_black_24px.svg"\n\t\t\t\t\t\t\t\t\t         ng-if="!line.fixedAmount"></md-icon>\n\t\t\t\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_lock_open_black_24px.svg"\n\t\t\t\t\t\t\t\t\t         ng-if="line.fixedAmount"></md-icon>\n\t\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\t\x3c!-- / ENABLE/DISABLE AMOUNT OPTION --\x3e\n\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\x3c!-- / AMOUNT --\x3e\n\n\t\t\t\t\t\t\t\x3c!-- DISTANCE BETWEEN --\x3e\n\t\t\t\t\t\t\t<md-input-container flex="50">\n\t\t\t\t\t\t\t\t<label translate="PROFILE.DISTANCE_BETWEEN">Distance between</label>\n\t\t\t\t\t\t\t\t<input type="number" ng-model="line.distBetweenStamps" nuit-unit-input="length"\n\t\t\t\t\t\t\t\t       ng-disabled="line.type !== \'distance\' || vm.manager.isDisabledByType(line.type)" ng-blur="vm.manager.requireRefresh()">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\x3c!-- / DISTANCE BETWEEN --\x3e\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\x3c!-- OFFSET TOP --\x3e\n\t\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t\t<label translate="PROFILE.OFFSET_TOP">Offset top</label>\n\t\t\t\t\t\t\t<input type="number" ng-model="line.y" nuit-unit-input="length" ng-disabled="vm.manager.isDisabledByType(line.type)"  ng-blur="vm.manager.requireRefresh()">\n\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\x3c!-- / OFFSET TOP --\x3e\n\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / STAMPING LINE DETAILS --\x3e\n\n\t\t\t\t\t\x3c!-- TOOL DETAILS --\x3e\n\t\t\t\t\t<div style="border-top:1px solid rgba(0,0,0,.12);padding:20px;" ng-if="vm.manager.showToolDistances">\n\t\t\t\t\t\t<span class="md-body-2" style="font-weight:bold" translate="PROFILE.TOOL_SELECTION">Tool Selection</span>\n\n\t\t\t\t\t\t\x3c!--<div layout layout-align="start center" class="no-error-spacer">\n\t\t\t\t\t\t\t<md-input-container style="margin-bottom:0;">\n\t\t\t\t\t\t\t\t<label>Tool</label>\n\t\t\t\t\t\t\t\t<input ng-model="line.tool.name" disabled>\n\t\t\t\t\t\t\t</md-input-container>\n\n\t\t\t\t\t\t\t<md-input-container style="margin-bottom:0;">\n\t\t\t\t\t\t\t\t<label>Size</label>\n\t\t\t\t\t\t\t\t<input ng-model="line.tool.sizes[line.size].name" aria-label="n" disabled>\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t</div>--\x3e\n\n\t\t\t\t\t\t<div layout layout-align="start center" class="no-error-spacer" ng-if="vm.manager.showToolDistances">\n\t\t\t\t\t\t\t<md-input-container style="margin-bottom:0;">\n\t\t\t\t\t\t\t\t<label translate="PROFILE.MIN_DISTANCE">Min</label>\n\t\t\t\t\t\t\t\t<input type="number" ng-model="line.min" nuit-unit-input="length" ng-disabled="vm.manager.isDisabledByType(line.type)" ng-blur="vm.manager.requireRefresh()">\n\t\t\t\t\t\t\t</md-input-container>\n\n\t\t\t\t\t\t\t<md-input-container style="margin-bottom:0;">\n\t\t\t\t\t\t\t\t<label translate="PROFILE.MAX_DISTANCE">Max</label>\n\t\t\t\t\t\t\t\t<input type="number" ng-model="line.max" nuit-unit-input="length" ng-disabled="vm.manager.isDisabledByType(line.type)" ng-blur="vm.manager.requireRefresh()">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / TOOL DETAILS --\x3e\n\n\t\t\t\t</div>\n\t\t\t\t\x3c!-- / CARD CONTENT --\x3e\n\n\t\t\t</div>\n\t\t\t\x3c!-- / STAMPING LINE CONTAINER --\x3e\n\n\t\t\t<md-button class="md-raised md-primary" style="padding:0 10px;" ng-click="vm.showAddStampingLineDialog();" translate="EDITOR.ADD_STAMPING">\n\t\t\t\tAdd Stampings\n\t\t\t</md-button>\n\t\t\t<md-button ng-disabled="vm.manager.usesTemplate(template.config.id)" class="md-raised md-primary" style="padding:0 10px;" ng-repeat="template in vm.manager.templates" ng-click="vm.manager.generateTemplateStampingLine(template.config)">\n\t\t\t\t{{template.config.name | nuitTranslate}}\n\t\t\t</md-button>\n\n\t\t</md-content>\n\t</md-tab-body>\n</md-tab>\n'),t.put("_nuit_/components/nuit-editor/sidebars/nuit-draw-stamping.html",'<md-tab md-on-select="vm.useEditor(\'nuit-draw-stamping\')"\n        ng-if="vm.config.editor.nuitDrawStamping.enabled" ng-disabled="!vm.hasSegments()">\n\t<md-tab-label>\n\t\t<span translate="PROFILE.PUNCHINGS">Punching</span>\n\t</md-tab-label>\n\t<md-tab-body>\n\t\t<md-content ms-scroll layout-fill flex class="editor-sidebar-stamping">\n\t\t\t<form name="holesform" ng-submit="vm.generateStampings()">\n\n\t\t\t\t\x3c!-- GENERATOR --\x3e\n\t\t\t\t<div layout="column" ng-repeat="generator in vm.generators"\n\t\t\t\t     class="generator md-whiteframe-1dp"\n\t\t\t\t     ng-init="console.log(\'i bim da\',currGenerator);currGenerator={id:generator.id,attachedTo:generator.attachedTo};vm.generatorValues.push(currGenerator);">\n\n\t\t\t\t\t\x3c!-- GENERATOR NAME --\x3e\n\t\t\t\t\t<span class="md-title">{{ vm.getLanguage(generator.name, \'Generator\') }}</span>\n\t\t\t\t\t\x3c!-- / GENERATOR NAME --\x3e\n\n\t\t\t\t\t\x3c!-- SET GENERATOR TYPE --\x3e\n\t\t\t\t\t<div layout="column" layout-align="start center">\n\t\t\t\t\t\t<span translate="STAMPING.GENERATOR_TYPE">Generator type</span>\n\n\t\t\t\t\t\t<md-radio-group ng-model="currGenerator.type" layout="row"\n\t\t\t\t\t\t                layout-align="space-between center" layout-wrap\n\t\t\t\t\t\t                ng-init="currGenerator.type=\'distBetween\'">\n\n\t\t\t\t\t\t\t<md-radio-button flex value="distBetween">\n\t\t\t\t\t\t\t\t<span translate="STAMPING.GENERATOR_TYPE_DISTANCE_BETWEEN">Distance between</span>\n\t\t\t\t\t\t\t</md-radio-button>\n\n\t\t\t\t\t\t\t<md-radio-button flex value="count">\n\t\t\t\t\t\t\t\t<span translate="STAMPING.GENERATOR_TYPE_COUNT">Count</span>\n\t\t\t\t\t\t\t</md-radio-button>\n\t\t\t\t\t\t</md-radio-group>\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / SET GENERATOR TYPE --\x3e\n\n\t\t\t\t\t\x3c!-- SIDE DISTANCE --\x3e\n\t\t\t\t\t<div layout="row" layout-align="space-between center"\n\t\t\t\t\t     ng-init="distName=vm.getLanguage(generator.nameDist, \'Top/Bottom Distance\')">\n\n\t\t\t\t\t\t\x3c!-- TITLE --\x3e\n\t\t\t\t\t\t<span class="title" md-truncate title="{{ distName }}">{{ distName }}</span>\n\t\t\t\t\t\t\x3c!-- / TITLE --\x3e\n\n\t\t\t\t\t\t\x3c!-- VALUE --\x3e\n\t\t\t\t\t\t<div layout="row" layout-align="start center" class="value" flex="none">\n\t\t\t\t\t\t\t<md-input-container class="no-error-spacer">\n\t\t\t\t\t\t\t\t<input type="number" aria-label="n" nuit-unit-input="length"\n\t\t\t\t\t\t\t\t       ng-model="currGenerator.distanceSide"\n\t\t\t\t\t\t\t\t       ng-disabled="generator.restrictionsDist.type===\'locked\'"\n\t\t\t\t\t\t\t\t       ng-init="currGenerator.distanceSide=generator.restrictionsDist.value"\n\t\t\t\t\t\t\t\t       ng-min="generator.restrictionsDist.min"\n\t\t\t\t\t\t\t\t       ng-max="generator.restrictionsDist.max">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t<span>{{ vm.units.length.symbol}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\x3c!-- / VALUE --\x3e\n\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / SIDE DISTANCE --\x3e\n\n\t\t\t\t\t\x3c!-- FIRST DISTANCE --\x3e\n\t\t\t\t\t<div layout="row" layout-align="space-between center"\n\t\t\t\t\t     ng-init="distNameFirst=vm.getLanguage(generator.nameDistFirst, \'First Distance\')">\n\n\t\t\t\t\t\t\x3c!-- TITLE --\x3e\n\t\t\t\t\t\t<span class="title" md-truncate\n\t\t\t\t\t\t      title="{{ distNameFirst }}">{{ distNameFirst }}</span>\n\t\t\t\t\t\t\x3c!-- / TITLE --\x3e\n\n\t\t\t\t\t\t\x3c!-- VALUE --\x3e\n\t\t\t\t\t\t<div layout="row" layout-align="start center" class="value" flex="none">\n\t\t\t\t\t\t\t<md-input-container class="no-error-spacer">\n\t\t\t\t\t\t\t\t<input type="number" nuit-unit-input="length" aria-label="n"\n\t\t\t\t\t\t\t\t       ng-model="currGenerator.distanceFirst"\n\t\t\t\t\t\t\t\t       ng-min="generator.distFirstMin" ng-max="generator.distFirstMax">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t<span>{{vm.units.length.symbol}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\x3c!-- / VALUE --\x3e\n\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / FIRST DISTANCE --\x3e\n\n\t\t\t\t\t\x3c!-- DISTANCE BETWEEN --\x3e\n\t\t\t\t\t<div layout="row" layout-align="space-between center"\n\t\t\t\t\t     ng-if="currGenerator.type===\'distBetween\'"\n\t\t\t\t\t     ng-init="distNameBetween=vm.getLanguage(generator.nameDistBetween, \'Distance Between\')">\n\n\t\t\t\t\t\t\x3c!-- TITLE --\x3e\n\t\t\t\t\t\t<span class="title" md-truncate title="{{ distNameBetween }}">{{ distNameBetween }}</span>\n\t\t\t\t\t\t\x3c!-- / TITLE --\x3e\n\n\t\t\t\t\t\t\x3c!-- VALUE --\x3e\n\t\t\t\t\t\t<div layout="row" layout-align="start center" class="value" flex="none">\n\t\t\t\t\t\t\t<md-input-container class="no-error-spacer">\n\t\t\t\t\t\t\t\t<input type="number" nuit-unit-input="length" aria-label="n"\n\t\t\t\t\t\t\t\t       ng-model="currGenerator.distanceBetween"\n\t\t\t\t\t\t\t\t       ng-min="generator.distBetweenMin"\n\t\t\t\t\t\t\t\t       ng-max="generator.distBetweenMax">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t<span>{{vm.units.length.symbol}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\x3c!-- / VALUE --\x3e\n\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / DISTANCE BETWEEN --\x3e\n\n\t\t\t\t\t\x3c!-- LAST DISTANCE --\x3e\n\t\t\t\t\t<div layout="row" layout-align="space-between center"\n\t\t\t\t\t     ng-init="distNameLast=vm.getLanguage(generator.nameDistLast, \'Last Distance\')">\n\n\t\t\t\t\t\t\x3c!-- TITLE --\x3e\n\t\t\t\t\t\t<span class="title" md-truncate\n\t\t\t\t\t\t      title="{{ distNameLast }}">{{ distNameLast }}</span>\n\t\t\t\t\t\t\x3c!-- / TITLE --\x3e\n\n\t\t\t\t\t\t\x3c!-- VALUE --\x3e\n\t\t\t\t\t\t<div layout="row" layout-align="start center" class="value" flex="none">\n\t\t\t\t\t\t\t<md-input-container class="no-error-spacer">\n\t\t\t\t\t\t\t\t<input type="number" nuit-unit-input="length" aria-label="n"\n\t\t\t\t\t\t\t\t       ng-model="currGenerator.distanceLast"\n\t\t\t\t\t\t\t\t       ng-min="generator.distLastMin" ng-max="generator.distLastMax">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t<span>{{vm.units.length.symbol}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\x3c!-- / VALUE --\x3e\n\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / LAST DISTANCE --\x3e\n\n\t\t\t\t\t\x3c!-- COUNT --\x3e\n\t\t\t\t\t<div layout="row" layout-align="space-between center"\n\t\t\t\t\t     ng-if="currGenerator.type===\'count\'">\n\n\t\t\t\t\t\t<span class="title" translate="STAMPING.COUNT" md-truncate>Count</span>\n\n\t\t\t\t\t\t<div layout="row" layout-align="start center" class="value" flex="none">\n\t\t\t\t\t\t\t<md-input-container class="no-error-spacer">\n\t\t\t\t\t\t\t\t<input type="number" ng-model="currGenerator.count" aria-label="n"\n\t\t\t\t\t\t\t\t       step="1" min="0">\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / COUNT --\x3e\n\n\t\t\t\t\t\x3c!-- TOOL --\x3e\n\t\t\t\t\t<div layout="row" layout-align="space-between center">\n\n\t\t\t\t\t\t\x3c!-- TITLE --\x3e\n\t\t\t\t\t\t<span translate="PUNCHING.TOOL" class="title" md-truncate>Tool</span>\n\t\t\t\t\t\t\x3c!-- / TITLE --\x3e\n\n\t\t\t\t\t\t\x3c!-- VALUE --\x3e\n\t\t\t\t\t\t<md-input-container class="no-error-spacer" flex="50">\n\t\t\t\t\t\t\t<md-select ng-model="currGenerator.tool" aria-label="n">\n\t\t\t\t\t\t\t\t<md-option ng-repeat="toolId in generator.tools" class="value"\n\t\t\t\t\t\t\t\t           ng-init="tool=vm.getToolById(toolId)" ng-value="tool">\n\t\t\t\t\t\t\t\t\t{{ vm.getLanguage(tool.name) }}\n\t\t\t\t\t\t\t\t</md-option>\n\t\t\t\t\t\t\t</md-select>\n\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\x3c!-- / VALUE --\x3e\n\n\t\t\t\t\t</div>\n\t\t\t\t\t\x3c!-- / TOOL --\x3e\n\n\t\t\t\t</div>\n\t\t\t\t\x3c!-- / GENERATOR --\x3e\n\n\t\t\t\t\x3c!-- GENERATE BUTTON --\x3e\n\t\t\t\t<md-button class="md-accent md-raised" type="submit" aria-label="n">\n\t\t\t\t\t<span translate="HOLES.GENERATE">Generate Holes</span>\n\t\t\t\t</md-button>\n\t\t\t\t\x3c!-- / GENERATE BUTTON --\x3e\n\n\t\t\t</form>\n\t\t</md-content>\n\t</md-tab-body>\n</md-tab>\n'),t.put("_nuit_/components/nuit-editor/sidebars/nuit-draw-top.html",'<md-tab md-on-select="vm.useEditor(\'nuit-draw-top\');" ng-if="vm.config.editor.nuitDrawTop.enabled"\n        ng-disabled="!vm.hasSegments()">\n\t<md-tab-label>\n\t\t<span translate="PROFILE.SPECIALS">Sonderbearbeitung</span>\n\t</md-tab-label>\n\t<md-tab-body>\n\t\t<md-content ms-scroll layout-fill flex class="editor-sidebar-top">\n\n\t\t\t\x3c!-- HEADINGS --\x3e\n\t\t\t<div layout="row" layout-align="space-between center">\n\t\t\t\t<span translate="SEGMENT.FRONT">Vorderlänge</span>\n\t\t\t\t<span translate="SEGMENT.BACK">Hinterlänge</span>\n\t\t\t</div>\n\t\t\t\x3c!-- / HEADINGS --\x3e\n\n\t\t\t\x3c!-- SEGMENT LIST --\x3e\n\t\t\t<md-list>\n\n\t\t\t\t\x3c!-- SEGMENT --\x3e\n\t\t\t\t<md-list-item ng-repeat="segment in vm.segments" class="segment"\n\t\t\t\t              ng-model-options="{updateOn : \'change\'}">\n\t\t\t\t\t<div layout="row" flex layout-align="space-between center">\n\n\t\t\t\t\t\t\x3c!-- FRONT LENGTH --\x3e\n\t\t\t\t\t\t<div class="length">\n\t\t\t\t\t\t\t<input type="number"\n\t\t\t\t\t\t\t       ng-model="segment.length"\n\t\t\t\t\t\t\t       ng-change="vm.refreshFrontLength(segment, $index)"\n\t\t\t\t\t\t\t       ng-blur="vm.unhighlightAll()"\n\t\t\t\t\t\t\t       ng-focus="vm.highlightSegment($index, {direction:\'front\'});"\n\t\t\t\t\t\t\t       aria-label="n"\n\t\t\t\t\t\t\t       id="length-front-{{segment.index}}"\n\t\t\t\t\t\t\t       nuit-unit-input="length"\n\t\t\t\t\t\t\t       data-length-focus="{{$index}}" tabindex="{{$index*2+1}}">\n\t\t\t\t\t\t\t<span class="unit">{{vm.config.units.length.symbol}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\x3c!-- / FRONT LENGTH --\x3e\n\n\t\t\t\t\t\t\x3c!-- TOGGLE CONICAL SETTING --\x3e\n\t\t\t\t\t\t<md-button class="md-icon-button" aria-label="n" ng-if="!segment.isWrap()"\n\t\t\t\t\t\t           ng-click="vm.toggleConical($index)"\n\t\t\t\t\t\t           ng-class="{\'md-raised md-primary\':segment.isConical()}"\n\t\t\t\t\t\t           tabindex="-1">\n\t\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_lock_open_black_24px.svg"\n\t\t\t\t\t\t\t         ng-if="segment.isConical()"></md-icon>\n\t\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_lock_outline_black_24px.svg"\n\t\t\t\t\t\t\t         ng-if="!segment.isConical()"></md-icon>\n\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\x3c!-- TOGGLE CONICAL SETTING --\x3e\n\n\t\t\t\t\t\t\x3c!-- IS WRAP --\x3e\n\t\t\t\t\t\t<md-button class="md-icon-button" aria-label="n" tabindex="-1"\n\t\t\t\t\t\t           ng-if="segment.isWrap()" disabled>\n\t\t\t\t\t\t\t<md-icon md-svg-src="_nuit_/assets/umschlag_offen.svg"\n\t\t\t\t\t\t\t         md-colors="{color:\'default-primary\'}"></md-icon>\n\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\x3c!-- / IS WRAP --\x3e\n\n\t\t\t\t\t\t\x3c!-- BACK LENGTH --\x3e\n\t\t\t\t\t\t<div class="length">\n\t\t\t\t\t\t\t<input type="number" aria-label="n"\n\t\t\t\t\t\t\t       ng-model="segment.backLength"\n\t\t\t\t\t\t\t       ng-disabled="!segment.isConical()"\n\t\t\t\t\t\t\t       ng-change="vm.refreshBackLength(segment, $index)"\n\t\t\t\t\t\t\t       ng-blur="vm.unhighlightAll()"\n\t\t\t\t\t\t\t       ng-focus="vm.highlightSegment($index, {direction:\'back\'});"\n\t\t\t\t\t\t\t       id="length-back-{{segment.index}}"\n\t\t\t\t\t\t\t       nuit-unit-input="length"\n\t\t\t\t\t\t\t       data-backlength-focus="{{$index}}" tabindex="{{$index*2+1}}">\n\t\t\t\t\t\t\t<span class="unit">{{vm.config.units.length.symbol}}</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\x3c!-- / BACK LENGTH --\x3e\n\n\t\t\t\t\t</div>\n\t\t\t\t</md-list-item>\n\t\t\t\t\x3c!-- / SEGMENT --\x3e\n\n\t\t\t</md-list>\n\t\t\t\x3c!-- / SEGMENT LIST --\x3e\n\n\t\t</md-content>\n\t</md-tab-body>\n</md-tab>\n'),t.put("_nuit_/components/nuit-editor/toolbars/nuit-draw-2d.html",'<div layout="column" layout-align="start start" ng-if="vm.isView(\'nuit-draw-2d\')">\n\n\t\x3c!-- ZOOM TO FIT --\x3e\n\t<md-button class="md-icon-button" ng-click="vm.manager.iterativeCenter()" aria-label="n">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_aspect_ratio_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.FIT">Darstellung anpassen</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / ZOOM TO FIT --\x3e\n\n\t\x3c!-- ZOOM OUT --\x3e\n\t<md-button class="md-icon-button" ng-hold="vm.manager.zoom(vm.ZOOM_OUT_FACTOR)"\n\t           ng-hold-interval="400:10, 150" aria-label="n">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_zoom_out_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.ZOOM_OUT">Ansicht verkleinern</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / ZOOM OUT --\x3e\n\n\t\x3c!-- ZOOM IN --\x3e\n\t<md-button class="md-icon-button" ng-hold="vm.manager.zoom(vm.ZOOM_IN_FACTOR)"\n\t           ng-hold-interval="400:1, 150" aria-label="n">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_zoom_in_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.ZOOM_IN">Ansicht vergrößern</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / ZOOM OUT --\x3e\n\n\t<md-divider style="width:100%;"></md-divider>\n\n\t\x3c!-- ALIGN --\x3e\n\t<md-button class="md-icon-button md-primary" ng-click="vm.manager.toggleAligning()"\n\t           ng-disabled="!vm.hasSegments()"\n\t           ng-class="{\'md-raised\': vm.manager.isAligning()}">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_vertical_align_center_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.ALIGN">Ausrichten</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- ALIGN --\x3e\n\n\t\x3c!-- ROTATE LEFT --\x3e\n\t<md-button class="md-icon-button" ng-hold="vm.manager.rotate(vm.ROTATION_CCLOCKWISE)" aria-label="n"\n\t           ng-disabled="!vm.hasSegments()" ng-hold-interval="400:1, 16">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_rotate_left_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.ROTATE_LEFT">Nach links drehen</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / ROTATE LEFT --\x3e\n\n\t\x3c!-- ROTATE RIGHT --\x3e\n\t<md-button class="md-icon-button" ng-hold="vm.manager.rotate(vm.ROTATION_CLOCKWISE)" aria-label="n"\n\t           ng-disabled="!vm.hasSegments()" ng-hold-interval="400:1, 16">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_rotate_right_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.ROTATE_RIGHT">Nach rechts drehen</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / ROTATE RIGHT --\x3e\n\n\t<md-divider></md-divider>\n\n\t\x3c!-- RULER --\x3e\n\t<md-button class="md-icon-button md-primary" ng-click="vm.manager.toggleRuler()" aria-label="n"\n\t           ng-class="{\'md-raised\': vm.manager.isMeasuring()}">\n\t\t<md-icon md-svg-icon="_nuit_/assets/ic_straighten_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.RULER">Ruler</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / RULER --\x3e\n\n\t\x3c!-- CHANGE VISIBLE SIDE --\x3e\n\t<md-button class="md-icon-button" ng-click="vm.manager.toggleVisibleSide()" aria-label="n"\n\t           ng-disabled="!vm.hasSegments()">\n\t\t<md-icon md-svg-icon="_nuit_/assets/ic_swap_horiz_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="PROFILE.TOGGLE_VISIBLE_SIDE">Toggle visible side</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / CHANGE VISIBLE SIDE --\x3e\n\n\t\x3c!-- CHANGE CONICAL MODE --\x3e\n\t\x3c!--<md-button class="md-icon-button md-primary" ng-click="vm.manager.toggleConicalMode()" aria-label="n"\n\t\t\t   ng-class="{\'md-raised\': vm.manager.conicalMode,\'md-accent\': vm.manager.conicalMode}"\n\t\t\t   ng-disabled="!vm.hasSegments()">\n\t\t<md-icon md-font-icon="icon-send"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="PROFILE.TOGGLE_CONICAL_MODE">Toggle visible side</span>\n\t\t</md-tooltip>\n\t</md-button>--\x3e\n\t\x3c!-- / CHANGE CONICAL MODE --\x3e\n\t\x3c!--<md-button class="md-icon-button" ng-click="vm.manager.invertOrder()"\n\t\t\t   ng-hold-interval="400:1, 150" aria-label="n">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_3d_rotation_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.INVERT_ORDER">Ansicht vergrößern</span>\n\t\t</md-tooltip>\n\t</md-button>--\x3e\n</div>\n'),t.put("_nuit_/components/nuit-editor/toolbars/nuit-draw-cutting.html",'<div layout="column" layout-align="start start" ng-if="vm.isView(\'nuit-draw-cutting\')" style="width:52px;">\n\n\n\n</div>\n'),t.put("_nuit_/components/nuit-editor/toolbars/nuit-draw-stamping-rework.html",'<div layout="column" layout-align="start start" ng-if="vm.isView(\'nuit-draw-stamping-rework\')">\n\t<div ng-if="vm.manager.toolGroupsEnabled">\n\t\t<div ng-repeat="type in vm.manager.toolGroupsAvailable">\n\t\t\t<div ng-if="vm.manager.getSupportedShapesByType(type).length>0">\n\t\t\t\t<md-button class="md-icon-button md-primary" ng-class="{\'md-raised\': vm.manager.selectedToolType === type}" ng-click="vm.manager.selectedToolType = type">\n\t\t\t\t\t<svg ng-if="type===\'oblong\'" width="24" height="24" viewBox="0 0 30 30"\n\t\t\t\t\t\t xmlns="http://www.w3.org/2000/svg">\n\n\t\t\t\t\t\t<rect x="0" y="10" width="30" height="10" rx="5" ry="5"/>\n\t\t\t\t\t</svg>\n\t\t\t\t\t<svg ng-if="type===\'rectangle\'" width="24" height="24" viewBox="0 0 30 30"\n\t\t\t\t\t\t xmlns="http://www.w3.org/2000/svg">\n\n\t\t\t\t\t\t<rect x="0" y="0" width="30" height="30"/>\n\t\t\t\t\t</svg>\n\t\t\t\t\t<svg ng-if="type===\'circle\'" width="24" height="24" viewBox="0 0 30 30"\n\t\t\t\t\t\t xmlns="http://www.w3.org/2000/svg">\n\n\t\t\t\t\t\t<rect x="0" y="0" width="30" height="30" rx="15" ry="15"/>\n\t\t\t\t\t</svg>\n\t\t\t\t</md-button>\n\t\t\t</div>\n\n\t\t</div>\n\t</div>\n\t\x3c!-- TOOLS --\x3e\n\t<div ng-if="!vm.manager.toolGroupsEnabled" ng-repeat="tool in vm.manager.tools">\n\n\t\t\x3c!-- SHAPE --\x3e\n\t\t<md-button class="md-icon-button md-primary" ng-click="vm.manager.selectedTool = $index"\n\t\t           aria-label="n" ng-class="{\'md-raised\': vm.manager.selectedTool === tool}">\n\n\t\t\t<svg width="24" height="24" viewBox="0 0 1 1">\n\t\t\t\t<g ng-repeat="shape in tool.icon">\n\t\t\t\t\t<rect ng-attr-width="{{shape.width}}" ng-attr-height="{{shape.height}}"\n\t\t\t\t\t      ng-attr-rx="{{shape.radius}}" ng-attr-ry="{{shape.radius}}"\n\t\t\t\t\t      ng-attr-x="{{shape.x - shape.width / 2 + 0.5}}" ng-attr-y="{{shape.y}}"></rect>\n\t\t\t\t</g>\n\n\t\t\t</svg>\n\n\t\t\t<md-tooltip md-direction="right">\n\t\t\t\t{{tool.name | nuitTranslate}}\n\t\t\t</md-tooltip>\n\t\t</md-button>\n\t\t\x3c!-- / SHAPE --\x3e\n\n\t</div>\n\t\x3c!-- / TOOLS  --\x3e\n\n\t<md-divider></md-divider>\n\n\t\x3c!-- RESET SHAPE --\x3e\n\t<md-button class="md-icon-button" ng-click="vm.manager.resetStamping()" aria-label="n">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_close_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.RESET">Reset</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / RESET SHAPE --\x3e\n\n</div>\n'),t.put("_nuit_/components/nuit-editor/toolbars/nuit-draw-stamping.html",'<div layout="column" layout-align="start start" ng-if="vm.isView(\'nuit-draw-stamping\')">\n\n\t\x3c!-- TOOLS --\x3e\n\t<div ng-repeat="tool in vm.tools">\n\n\t\t\x3c!-- SHAPE CIRCLE --\x3e\n\t\t<md-button class="md-icon-button md-primary" ng-click="vm.manager.setTool(tool)"\n\t\t           aria-label="n" ng-class="{\'md-raised\': vm.manager.isTool(\'circle\')}"\n\t\t           ng-if="tool.shape===\'circle\'">\n\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_radio_button_unchecked_black_24px.svg"></md-icon>\n\t\t\t<md-tooltip md-direction="right">\n\t\t\t\t<span translate="MENUBAR.CIRCLE_TOOL">Kreis-Werkzeug</span>\n\t\t\t</md-tooltip>\n\t\t</md-button>\n\t\t\x3c!-- / SHAPE CIRCLE --\x3e\n\n\t\t\x3c!-- SHAPE SQUARE --\x3e\n\t\t<md-button class="md-icon-button md-primary" ng-click="vm.manager.setTool(tool)"\n\t\t           aria-label="n" ng-class="{\'md-raised\': vm.manager.isTool(\'square\')}"\n\t\t           ng-if="tool.shape===\'square\'">\n\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_check_box_outline_blank_black_24px.svg"></md-icon>\n\t\t\t<md-tooltip md-direction="right">\n\t\t\t\t<span translate="MENUBAR.QUAD_TOOL">Quadrat-Werkzeug</span>\n\t\t\t</md-tooltip>\n\t\t</md-button>\n\t\t\x3c!-- / SHAPE SQUARE --\x3e\n\n\t\t\x3c!-- SHAPE ROUNDEDRECT --\x3e\n\t\t<md-button class="md-icon-button md-primary" ng-click="vm.manager.setTool(tool)"\n\t\t           aria-label="n" ng-class="{\'md-raised\': vm.manager.isTool(\'roundedrect\')}"\n\t\t           ng-if="tool.shape===\'roundedrect\'">\n\t\t\t<md-icon md-svg-src="_nuit_/assets/ic_crop_16_9_black_24px.svg"></md-icon>\n\t\t\t<md-tooltip md-direction="right">\n\t\t\t\t<span translate="MENUBAR.ROUNDEDRECT_TOOL">Langloch-Werkzeug</span>\n\t\t\t</md-tooltip>\n\t\t</md-button>\n\t\t\x3c!-- / SHAPE ROUNDEDRECT --\x3e\n\n\t</div>\n\t\x3c!-- / TOOLS  --\x3e\n\n\t<md-divider></md-divider>\n\n\t\x3c!-- RESET SHAPE --\x3e\n\t<md-button class="md-icon-button" ng-click="vm.manager.resetStamping()" aria-label="n">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_close_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.RESET">Reset</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / RESET SHAPE --\x3e\n\n</div>\n'),t.put("_nuit_/components/nuit-editor/toolbars/nuit-draw-top.html",'<div layout="column" layout-align="start start" ng-if="vm.isView(\'nuit-draw-top\')">\n\n\t\x3c!-- SHOW COMPRESSED --\x3e\n\t<md-button class="md-icon-button md-primary" ng-click="vm.manager.showStretched()" aria-label="n"\n\t           ng-class="{\'md-raised\':vm.manager.isStretched()}">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_image_aspect_ratio_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.SHOW_STRETCHED">Show stretched</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / SHOW COMPRESSED --\x3e\n\n\t\x3c!-- SHOW ORIGINAL --\x3e\n\t<md-button class="md-icon-button md-primary" ng-click="vm.manager.showProportional()" aria-label="n"\n\t           ng-class="{\'md-raised\':vm.manager.isProportional()}">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_photo_size_select_small_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.SHOW_ORIGINAL">Show proportional</span>\n\t\t</md-tooltip>\n\t</md-button>\n\t\x3c!-- / SHOW ORIGINAL --\x3e\n\n\t\x3c!--<md-button class="md-icon-button" ng-click="vm.manager.invertOrder()"\n\t\t\t   ng-hold-interval="400:1, 150" aria-label="n">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_3d_rotation_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.INVERT_ORDER">Ansicht vergrößern</span>\n\t\t</md-tooltip>\n\t</md-button>--\x3e\n\n\t\x3c!--<md-button class="md-icon-button" ng-click="vm.manager.invertOrder(true)"\n\t\t\t   ng-hold-interval="400:1, 150" aria-label="n">\n\t\t<md-icon md-svg-src="_nuit_/assets/ic_zoom_in_black_24px.svg"></md-icon>\n\t\t<md-tooltip md-direction="right">\n\t\t\t<span translate="MENUBAR.INVERT_ORDER">Ansicht vergrößern</span>\n\t\t</md-tooltip>\n\t</md-button>--\x3e\n</div>\n'),t.put("_nuit_/assets/angle-acute.svg",'<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M20,19H4.09L14.18,4.43L15.82,5.57L11.28,12.13C12.89,12.96 14,14.62 14,16.54C14,16.7 14,16.85 13.97,17H20V19M7.91,17H11.96C12,16.85 12,16.7 12,16.54C12,15.28 11.24,14.22 10.14,13.78L7.91,17Z" /></svg>'),t.put("_nuit_/assets/baseline-add_shopping_cart-24px.svg",'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0zm18.31 6l-2.76 5z" fill="none"/>\n    <path d="M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z"/>\n</svg>\n'),t.put("_nuit_/assets/baseline-delete_forever-24px.svg",'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"/><path fill="none" d="M0 0h24v24H0z"/></svg>'),t.put("_nuit_/assets/checkbox-blank.svg",'<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" /></svg>'),t.put("_nuit_/assets/curl.svg",'<?xml version="1.0" encoding="utf-8"?>\n\x3c!-- Generator: Adobe Illustrator 27.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t viewBox="0 0 32.2 21.1" style="enable-background:new 0 0 32.2 21.1;" xml:space="preserve">\n<path d="M32.2,18.2v2.9H11.6c-6.1,0-10-4.7-10-10c0-6.8,5-10.5,11-10.5c5.4,0,9,5.6,9,8.4l-2.7,0.2c0,0-1.4-5.7-6.5-5.7\n\tc-5.2,0-7.5,3.9-7.5,7.5c0,3.7,2.8,7.3,6.6,7.3L32.2,18.2z"/>\n</svg>\n'),t.put("_nuit_/assets/file-outline.svg",'<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M11,4H6V20H11L18,20V11H11V4Z" /></svg>'),t.put("_nuit_/assets/hem.svg",'<?xml version="1.0" encoding="utf-8"?>\n    \x3c!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32.2 10.8" style="enable-background:new 0 0 32.2 10.8;" xml:space="preserve">\n\n        <path class="st0" d="M3.6,234.8c-0.3,0-2.1-0.1-3.4-1.3c-0.6-0.6-1.2-1.6-1.2-3.2c0-2,0.8-3,1.5-3.6c1.4-1.2,3.3-0.9,3.5-0.9l17.7,3\n\tl-0.5,2.9h10v3H3.6C3.7,234.8,3.7,234.8,3.6,234.8z M3.2,228.8c-0.2,0-0.6,0-0.9,0.2c-0.3,0.3-0.4,0.8-0.4,1.3c0,0.7,0.3,0.9,0.3,1\n\tc0.5,0.4,1.3,0.5,1.3,0.5l0,0H21l-17.6-3C3.4,228.8,3.3,228.8,3.2,228.8z" />\n        <path class="st0" d="M4.6,10.8c-0.3,0-2.1-0.1-3.4-1.3C0.7,8.9,0,7.9,0,6.3c0-3,2.9-4.2,4.5-4.5L22.3,0l0.3,3L4.8,4.8c0,0,0,0,0,0\n\tc0,0-1.8,0.3-1.8,1.5c0,0.7,0.3,0.9,0.3,1c0.5,0.4,1.3,0.5,1.3,0.5l0,0h27.5v3H4.6C4.7,10.8,4.7,10.8,4.6,10.8z" />\n        <path class="st1" d="M3.6,54.8c-0.3,0-2.1-0.1-3.4-1.3C-0.3,52.9-1,51.9-1,50.3c0-3,2.9-4.2,4.5-4.5L21.3,44l0.3,3L3.8,48.8\n\tc0,0,0,0,0,0c0,0-1.8,0.3-1.8,1.5c0,0.7,0.3,0.9,0.3,1c0.5,0.4,1.3,0.5,1.3,0.5l0,0h27.5v3H3.6C3.7,54.8,3.7,54.8,3.6,54.8z" />\n    </svg>\n'),t.put("_nuit_/assets/ic_3d_rotation_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z"/>\n</svg>'),t.put("_nuit_/assets/ic_add_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_add_circle_outline_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>'),t.put("_nuit_/assets/ic_aspect_ratio_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_build_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path clip-rule="evenodd" d="M0 0h24v24H0z" fill="none"/>\n    <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>\n</svg>'),t.put("_nuit_/assets/ic_check_box_outline_blank_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_clear_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_close_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_code_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>\n</svg>'),t.put("_nuit_/assets/ic_compare_arrows_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <defs>\n        <path d="M0 0h24v24H0V0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"/>\n</svg>'),t.put("_nuit_/assets/ic_content_copy_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>\n</svg>'),t.put("_nuit_/assets/ic_create_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_crop_16_9_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"/>\n</svg>'),t.put("_nuit_/assets/ic_delete_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_done_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>\n</svg>'),t.put("_nuit_/assets/ic_folder_open_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"/>\n</svg>'),t.put("_nuit_/assets/ic_image_aspect_ratio_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"/>\n</svg>'),t.put("_nuit_/assets/ic_inner_black_24px.svg",'<?xml version="1.0" encoding="utf-8"?>\n    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">\n        <path d="M22,16.6L17.4,12L22,7.4L20.6,6l-6,6l6,6L22,16.6z M2,16.6L6.6,12L2,7.4L3.4,6l6,6l-6,6C3.4,18,2,16.6,2,16.6z" />\n    </svg>\n'),t.put("_nuit_/assets/ic_insert_drive_file_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_lock_open_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"/>\n</svg>'),t.put("_nuit_/assets/ic_lock_outline_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z"/>\n</svg>'),t.put("_nuit_/assets/ic_photo_size_select_small_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0V0zm24 24H0V0h24v24z" fill="none"/>\n    <path d="M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"/>\n</svg>'),t.put("_nuit_/assets/ic_radio_button_unchecked_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_redo_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"/>\n</svg>'),t.put("_nuit_/assets/ic_rotate_left_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"/>\n</svg>'),t.put("_nuit_/assets/ic_rotate_right_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"/>\n</svg>'),t.put("_nuit_/assets/ic_save_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/>\n</svg>'),t.put("_nuit_/assets/ic_space_bar_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M18 9v4H6V9H4v6h16V9z"/>\n</svg>'),t.put("_nuit_/assets/ic_star_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_star_border_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_straighten_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"/>\n</svg>'),t.put("_nuit_/assets/ic_swap_horiz_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_undo_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"/>\n</svg>'),t.put("_nuit_/assets/ic_vertical_align_center_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_wrap_text_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),t.put("_nuit_/assets/ic_zoom_in_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>'),t.put("_nuit_/assets/ic_zoom_out_black_24px.svg",'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"/>\n</svg>'),t.put("_nuit_/assets/kein_umschlag.svg",'<?xml version="1.0" encoding="utf-8"?>\n\x3c!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t viewBox="0 0 34.1 14.3" style="enable-background:new 0 0 34.1 14.3;" xml:space="preserve">\n<style type="text/css">\n\t.st0{fill:#2EA4E0;}\n\t.st1{fill:#EDEDEE;}\n</style>\n<path class="st0" d="M7.8,55.3c-0.3,0-2.1-0.1-3.4-1.3c-0.6-0.6-1.2-1.6-1.2-3.2c0-2,0.8-3,1.5-3.6c1.4-1.2,3.3-0.9,3.5-0.9l17.7,3\n\tl-0.5,2.9h10v3H7.8C7.9,55.3,7.9,55.3,7.8,55.3z M7.4,49.3c-0.2,0-0.6,0-0.9,0.2c-0.3,0.3-0.4,0.8-0.4,1.3c0,0.7,0.3,0.9,0.3,1\n\tc0.5,0.4,1.3,0.5,1.3,0.5l0,0h17.4l-17.6-3C7.6,49.3,7.5,49.3,7.4,49.3z"/>\n<path class="st0" d="M8.8-168.7c-0.3,0-2.1-0.1-3.4-1.3c-0.6-0.6-1.2-1.6-1.2-3.2c0-3,2.9-4.2,4.5-4.5l17.8-1.8l0.3,3L9-174.7\n\tc0,0,0,0,0,0c0,0-1.8,0.3-1.8,1.5c0,0.7,0.3,0.9,0.3,1c0.5,0.4,1.3,0.5,1.3,0.5l0,0h27.5v3H8.8C8.9-168.7,8.9-168.7,8.8-168.7z"/>\n<path class="st1" d="M7.8-124.7c-0.3,0-2.1-0.1-3.4-1.3c-0.6-0.6-1.2-1.6-1.2-3.2c0-3,2.9-4.2,4.5-4.5l17.8-1.8l0.3,3L8-130.7\n\tc0,0,0,0,0,0c0,0-1.8,0.3-1.8,1.5c0,0.7,0.3,0.9,0.3,1c0.5,0.4,1.3,0.5,1.3,0.5l0,0h27.5v3H7.8C7.9-124.7,7.9-124.7,7.8-124.7z"/>\n<g>\n\t<polygon class="st1" points="34.1,0.8 33.3,0 29.8,3.5 26.3,0 25.5,0.8 29,4.3 25.5,7.8 26.3,8.6 29.8,5.1 33.3,8.6 34.1,7.8 \n\t\t30.6,4.3 \t"/>\n\t<path class="st1" d="M3.3,10.9C3.3,10.8,3,10.5,3,9.8c0-1.2,1.9-1.5,1.8-1.5c0,0,0,0,0,0l17.8-1.8l-0.3-3L4.5,5.3\n\t\tC2.9,5.6,0,6.8,0,9.8c0,1.6,0.7,2.6,1.2,3.2c1.3,1.3,3.1,1.3,3.4,1.3c0,0,0,0,0,0h27.7v-3H4.7C4.6,11.3,3.8,11.3,3.3,10.9z"/>\n</g>\n</svg>\n'),t.put("_nuit_/assets/lock-reset.svg",'<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M12.63,2C18.16,2 22.64,6.5 22.64,12C22.64,17.5 18.16,22 12.63,22C9.12,22 6.05,20.18 4.26,17.43L5.84,16.18C7.25,18.47 9.76,20 12.64,20A8,8 0 0,0 20.64,12A8,8 0 0,0 12.64,4C8.56,4 5.2,7.06 4.71,11H7.47L3.73,14.73L0,11H2.69C3.19,5.95 7.45,2 12.63,2M15.59,10.24C16.09,10.25 16.5,10.65 16.5,11.16V15.77C16.5,16.27 16.09,16.69 15.58,16.69H10.05C9.54,16.69 9.13,16.27 9.13,15.77V11.16C9.13,10.65 9.54,10.25 10.04,10.24V9.23C10.04,7.7 11.29,6.46 12.81,6.46C14.34,6.46 15.59,7.7 15.59,9.23V10.24M12.81,7.86C12.06,7.86 11.44,8.47 11.44,9.23V10.24H14.19V9.23C14.19,8.47 13.57,7.86 12.81,7.86Z" /></svg>'),t.put("_nuit_/assets/umschlag_geschlossen.svg",'<?xml version="1.0" encoding="utf-8"?>\n    \x3c!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32.2 9" style="enable-background:new 0 0 32.2 9;" xml:space="preserve">\n\n        <path class="st0" d="M4.6,9C4.3,9,2.5,9,1.2,7.7C0.7,7.2,0,6.2,0,4.5c0-2,0.8-3,1.5-3.6C2.9-0.3,4.7,0,4.9,0.1l17.7,3L22.2,6h10v3\n\tH4.6C4.7,9,4.7,9,4.6,9z M4.2,3C4,3,3.6,3,3.4,3.2C3.1,3.5,3,4.1,3,4.5c0,0.7,0.3,0.9,0.3,1C3.8,6,4.6,6,4.7,6l0,0H22L4.4,3\n\tC4.4,3,4.3,3,4.2,3z" />\n        <path class="st0" d="M5.6-215c-0.3,0-2.1-0.1-3.4-1.3c-0.6-0.6-1.2-1.6-1.2-3.2c0-3,2.9-4.2,4.5-4.5l17.8-1.8l0.3,3L5.8-221\n\tc0,0,0,0,0,0c0,0-1.8,0.3-1.8,1.5c0,0.7,0.3,0.9,0.3,1c0.5,0.4,1.3,0.5,1.3,0.5l0,0h27.5v3H5.6C5.7-215,5.7-215,5.6-215z" />\n        <path class="st1" d="M4.6-171c-0.3,0-2.1-0.1-3.4-1.3c-0.6-0.6-1.2-1.6-1.2-3.2c0-3,2.9-4.2,4.5-4.5l17.8-1.8l0.3,3L4.8-177\n\tc0,0,0,0,0,0c0,0-1.8,0.3-1.8,1.5c0,0.7,0.3,0.9,0.3,1c0.5,0.4,1.3,0.5,1.3,0.5l0,0h27.5v3H4.6C4.7-171,4.7-171,4.6-171z" />\n    </svg>\n'),t.put("_nuit_/assets/umschlag_geschlossen_gesp.svg",'<?xml version="1.0" encoding="utf-8"?>\n    \x3c!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32.4 9" style="enable-background:new 0 0 32.4 9;" xml:space="preserve">\n\n        <path class="st0" d="M4.7,0h27.7v3H22.2l0.5,2.9L4.9,9C4.7,9,2.9,9.3,1.5,8.1C0.8,7.5,0,6.4,0,4.5c0-1.6,0.7-2.6,1.2-3.2\n\tC2.5,0,4.3,0,4.7,0C4.7,0,4.7,0,4.7,0z M4.4,6L22,3H4.7l0,0c0,0-0.9,0-1.3,0.5C3.3,3.5,3,3.8,3,4.5c0,0.4,0.1,1,0.4,1.3\n\tC3.6,6,4,6,4.2,6C4.3,6,4.4,6,4.4,6z" />\n    </svg>\n'),t.put("_nuit_/assets/umschlag_offen.svg",'<?xml version="1.0" encoding="utf-8"?>\n\x3c!-- Generator: Adobe Illustrator 21.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t viewBox="0 0 32.2 10.8" style="enable-background:new 0 0 32.2 10.8;" xml:space="preserve">\n<path d="M3.6,234.8c-0.3,0-2.1-0.1-3.4-1.3c-0.6-0.6-1.2-1.6-1.2-3.2c0-2,0.8-3,1.5-3.6c1.4-1.2,3.3-0.9,3.5-0.9l17.7,3l-0.5,2.9h10\n\tv3H3.6C3.7,234.8,3.7,234.8,3.6,234.8z M3.2,228.8c-0.2,0-0.6,0-0.9,0.2c-0.3,0.3-0.4,0.8-0.4,1.3c0,0.7,0.3,0.9,0.3,1\n\tc0.5,0.4,1.3,0.5,1.3,0.5l0,0H21l-17.6-3C3.4,228.8,3.3,228.8,3.2,228.8z"/>\n<path d="M4.7,10.8c-0.3,0-2.1-0.1-3.4-1.3C0.8,8.9,0.1,7.9,0.1,6.3c0-1.8,1-2.9,2.1-3.6c1-0.6,2.3-0.9,3.5-0.9l17.1,0l0,3\n\tc0,0-13.6,0-18,0C4.3,4.8,3.1,5,3.1,6.2c0,0.7,0.1,0.9,0.3,1.1c0.5,0.5,1.3,0.5,1.3,0.5l0,0h27.5v3H4.7C4.8,10.8,4.8,10.8,4.7,10.8z\n\t"/>\n<path d="M3.6,54.8c-0.3,0-2.1-0.1-3.4-1.3C-0.3,52.9-1,51.9-1,50.3c0-3,2.9-4.2,4.5-4.5L21.3,44l0.3,3L3.8,48.8l0,0\n\tc0,0-1.8,0.3-1.8,1.5c0,0.7,0.3,0.9,0.3,1c0.5,0.4,1.3,0.5,1.3,0.5l0,0h27.5v3H3.6C3.7,54.8,3.7,54.8,3.6,54.8z"/>\n</svg>\n'),t.put("_nuit_/assets/umschlag_offen_gesp.svg",'<?xml version="1.0" encoding="utf-8"?>\n\x3c!-- Generator: Adobe Illustrator 21.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t viewBox="0 0 32.2 11" style="enable-background:new 0 0 32.2 11;" xml:space="preserve">\n<path d="M4.7,0l27.5,0v3H4.7l0,0c0,0-0.8,0-1.3,0.5C3.2,3.7,3.1,3.9,3.1,4.6C3.1,5.8,4.3,6,4.9,6c4.4,0,18,0,18,0l0,3L5.7,9\n\tC4.5,9,3.3,8.7,2.2,8.1C1.1,7.4,0.1,6.2,0.1,4.5c0-1.6,0.7-2.6,1.2-3.2C2.6,0.1,4.4,0,4.7,0C4.8,0,4.8,0,4.7,0z"/>\n</svg>\n')}]);
"use strict";
"use strict";angular.module("nuit.editor").component("nuitDrawStampingRework",{templateUrl:"_nuit_/components/nuit-draw-stamping-rework/nuit-draw-stamping.template.html",controller:"nuitDrawStampingReworkController",controllerAs:"vm",transclude:!0,require:{editorCtrl:"^nuitDraw"},bindings:{hideUi:"<"}});
"use strict";angular.module("nuit.editor").constant("NUIT_DRAW_STAMPING_REWORK_SETTINGS",{editor:{nuitDrawStampingRework:{style:{rendererOffset:100,cuttingBorderWidth:1,cuttingBorderColor:16764108,cuttingBorderOpacity:1,cuttingFillColor:16751001,cuttingFillOpacity:1,segmentBorderWidth:1,segmentBorderColor:0,segmentBorderOpacity:1,segmentFillColor:15395562,segmentFillOpacity:1,segmentConicalColor:14342874,segmentConicalOpacity:1,wrapFillColor:14540287,wrapFillOpacity:1,showWrapText:!1,fontFamily:"Arial",fontSize:14,fontOffset:15,fontStrokeColor:15705360,fontStrokeThickness:3},texts:[],toolGroups:{enabled:!1,available:[]},showToolDistances:!1,allowTemplateEditing:!0,punchType:"default",tools:[],areas:[],templates:[]}}});
"use strict";var STAMPING_LINE_TYPE,_createClass=function(){function n(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(t,e,i){return e&&n(t.prototype,e),i&&n(t,i),t}}();function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}!function(t){t.AMOUNT="amount",t.DISTANCE="distance",t.READ_ONLY="readOnly"}(STAMPING_LINE_TYPE=STAMPING_LINE_TYPE||{}),function(){function t(t,l,e,m,i,v,n,s,c){var a,d=this,u=void 0;(a=u=u||{}).STRETCHED="s",a.PROPORTIONAL="p";var f=angular.copy(n),g=f.editor.nuitDrawStampingRework.style,r=f.editor.nuitDrawStampingRework.showToolDistances,o=null,p=u.PROPORTIONAL,w=1,_=1,y=0,x=0,h=!1,S=!1,T=null,C=null,L=null,I=null,k=0,b=0,P=0,M=null,R=null,A={fontFamily:g.fontFamily,fontSize:g.fontSize,stroke:g.fontStrokeColor},E=[],O=[],X=[],z=[],N=[],D=new PIXI.Container,F=new PIXI.Graphics,Y=new PIXI.Container,B=new PIXI.Graphics,G=new PIXI.filters.AlphaFilter(1),$=new PIXI.Graphics,j=new PIXI.Container,U=new PIXI.Graphics,V=new PIXI.Graphics,W=new PIXI.Graphics,H=new PIXI.Container,q=new PIXI.Text("---",A),K=new PIXI.Text("---",A),J=new PIXI.Text("---",A),Q=new PIXI.Text("---",A),Z=new PIXI.Graphics,tt=new PIXI.Text("---",A),et=new PIXI.Text("",{align:"center"});et.alpha=.3,et.pivot.x=.5*et.width,et.pivot.y=et.height;var it=new PIXI.Text("",{align:"center"});function nt(){f=angular.merge({},n,d.editorCtrl.config),at()}function at(){h=!0}function rt(){var t=d.renderer.width-2*g.rendererOffset,e=d.renderer.height-2*g.rendererOffset,i=v.getDepth(),n=v.getTotalLength();w=e/n,_=t/i;var a=g.rendererOffset,r=g.rendererOffset;if(p===u.PROPORTIONAL){var s=Math.min(w,_);_=w=s}y=i*_,x=n*w,p===u.PROPORTIONAL&&(a+=(t-y)/2,r+=(e-x)/2),D.x=a,D.y=r;var o=f.editor.nuitDrawStampingRework.texts.find(function(t){return"top_machine"===t.id}),h=f.editor.nuitDrawStampingRework.texts.find(function(t){return"bottom_machine"===t.id});et.y=-50,et.text=l("nuitTranslate")(o?o.text:{},""),et.pivot.x=.5*et.width,it.text=l("nuitTranslate")(h?h.text:{},""),it.y=v.totalLength*w+50,it.pivot.x=.5*it.width,et.x=it.x=t/2}function st(){rt(),function(){var t=!(z.length=0),e=!1,i=void 0;try{for(var n,a=f.editor.nuitDrawStampingRework.tools[Symbol.iterator]();!(t=(n=a.next()).done);t=!0){var r=n.value;z.push(new Dt(r))}}catch(t){e=!0,i=t}finally{try{!t&&a.return&&a.return()}finally{if(e)throw i}}if(0===z.length)throw new Error("No tools defined");f.editor.nuitDrawStampingRework.toolGroups.enabled&&0<s.supportedShapes.length?o.selectedToolType||(o.selectedToolType=s.supportedShapes[0].type,o.selectedShape=s.supportedShapes[0]):(I=I||0,k=0)}(),function(){var t=!(N.length=0),e=!1,i=void 0;try{for(var n,a=f.editor.nuitDrawStampingRework.templates[Symbol.iterator]();!(t=(n=a.next()).done);t=!0){var r=n.value;N.push(new jt(r))}}catch(t){e=!0,i=t}finally{try{!t&&a.return&&a.return()}finally{if(e)throw i}}0===N.length&&console.log("No templates defined")}(),function(){var t=!(X.length=0),e=!1,i=void 0;try{for(var n,a=f.editor.nuitDrawStampingRework.areas[Symbol.iterator]();!(t=(n=a.next()).done);t=!0){var r=n.value;X.push(new Gt(r))}}catch(t){e=!0,i=t}finally{try{!t&&a.return&&a.return()}finally{if(e)throw i}}}()}function ot(t){j.visible=!0,ht(t),Y.on("pointermove",ht)}function ht(t){var e=Mt(t);t.data.originalEvent.ctrlKey||(e=vt(e)),ct(e.x,e.y)}function lt(){L||(C=null,j.visible=!1),Y.off("pointermove",ht),m.render()}function dt(t){var e=Mt(t);t.data.originalEvent.ctrlKey||(e=vt(e));var i=bt(e.x,e.y);if(L){if(i===C){xt(L.x,e.x/_,L.y,C);var n=Rt(L.x,e.x/_,void 0,void 0,z[I].distance.default?z[I].distance.default:void 0),a=E[E.length-1];a.fixedAmount=!0,a.amount=n.length,a.distBetweenStamps=n[1]-n[0],a.assign(E.length-1,a.config),setTimeout(function(){Tt(E.length-1),St(a.config),o.requireRefresh()})}L=null}else{if(null===i)return;L={x:c.round(e.x/_,"length"),y:c.round(e.y/w,"length")}}S=!0,ct(e.x,e.y)}function ut(){rt(),at()}function gt(){h&&(st(),S=!(h=!1)),function(){S&&(function(t){(isNaN(t)||t<0||t>v.count())&&(t=0);Y.removeChildren(),Y.addChild(B),B.clear(),function(){var t=v.count();if(O.length>t)O.length=t;else for(;O.length<t;)O.push(new zt);for(var e in O)O[e].assign(v.get(e))}();for(var e=t;e<v.count();e++){var i=O[e];i.refresh(),Y.addChild(i.textRight)}}(),mt(),Y.hitArea=new PIXI.Rectangle(-g.rendererOffset,Y.x,Y.width+2*g.rendererOffset,Y.height),pt());S=!1}()}function ft(){at()}function ct(t,e){var i=0<arguments.length&&void 0!==t?t:b,n=1<arguments.length&&void 0!==e?e:P;i=v.clamp(i,0,v.depth*_),L&&(n=L.y*w),L||(C=bt(i,n)),G.alpha=null!==C?1:.3,b=i,P=n,L&&(null===C&&console.error("First stamping set, but no active stamping area set. Propably some errors will happen now"),i=Math.min(i,X[C].endX)),U.clear(),U.lineStyle(1,16711680),U.moveTo(0,n),U.lineTo(y,n),U.moveTo(i,0),U.lineTo(i,x);var a=y;if(V.clear(),Z.clear(),L){var r=Math.round(L.x*_),s=L.y*w,o=Math.round(i/_),h=Rt(L.x,o,void 0,void 0,z[I].distance.default?z[I].distance.default:void 0);V.lineStyle(.8,16711680),V.beginFill(16777215,.5),h.forEach(function(t){z[I].size=k,z[I].render(V,t*_,n)});var l=h[1]-h[0],d=h[1];d<=L.x&&(d=h[h.length-2]),d*=_,tt.visible=!0,tt.text=Lt(Math.abs(l)),tt.y=n-20-tt.height/2,tt.x=r+(d-r)/2-tt.width/2,Z.lineStyle(1,0,1),Z.moveTo(r,s),Z.lineTo(r,s-20),Z.lineTo(d,s-20),Z.lineTo(d,s),Z.beginFill(16777215,1),Z.drawRect(tt.x-2,tt.y-1,tt.width+4,tt.height+2)}else 0<=i&&i<=a&&(z[I].size=k,z[I].render(V,i,n),tt.visible=!1);W.clear(),W.lineStyle(1,7829367),W.moveTo(0,0),W.lineTo(-20,0),W.lineTo(-20,n),W.lineTo(0,n),W.moveTo(0,0),W.lineTo(0,-20),W.lineTo(i,-20),W.lineTo(i,0),W.moveTo(i,-20),W.lineTo(y,-20),W.lineTo(y,0),q.text=Lt(n/w),q.x=-q.width-30,q.y=(n-q.height)/2,J.text=Lt(i/_),J.x=(i-J.width)/2,J.y=-J.height-30,Q.text=Lt(v.depth-i/_),Q.x=i+(v.depth*_-i-J.width)/2,Q.y=-Q.height-30;var u=function(t){for(var e=t/w,i=-1,n=0;n<v.count()&&i<0;n++){var a=v.get(n);a.offsetFront<e&&a.offsetFront+a.length>e&&(i=a.index)}return i}(n),g=v.first();if(0<u||0<g.offsetFront&&0<=u){var f=v.get(u).offsetFront*w;W.moveTo(0,f),W.lineTo(-10,f),W.lineTo(-10,n);var c=n-f;K.visible=!0,K.text=Lt(c/w),K.x=-K.width-30,K.y=f+(c-K.height)/2}else K.visible=!1;mt(),m.render()}function mt(){$.clear(),$.lineStyle(0),z[I].size=k;var t=z[I].sizes[z[I].size].id;for(var e in X)X[e].isVisible&&X[e].isAvailable&&X[e].isToolAllowed(t)&&(C===parseInt(e)?$.beginFill(255,.2):$.beginFill(255,.1),$.drawRect(X[e].startX,X[e].startY,X[e].width,X[e].height))}function pt(){for(var t in H.removeChildren(),function(){var t=v.getStampingLines();if(E.length>t.length)E.length=t.length;else for(;E.length<t.length;)E.push(new Yt);for(var e in E)E[e].assign(parseInt(e),t[e].punchType&&"simple"===t[e].punchType?s.toDefaultStamping(t[e],e):t[e])}(),E)E[t].refresh(parseInt(t)===T),H.addChild(E[t].graphics)}function _t(){p!==u.STRETCHED&&(p=u.STRETCHED,at(),m.render())}function yt(){p!==u.PROPORTIONAL&&(p=u.PROPORTIONAL,at(),m.render())}function vt(t,e){var i=1<arguments.length&&void 0!==e?e:10,n=t.x,a=t.y,r=!0,s=!1,o=void 0;try{for(var h,l=X[Symbol.iterator]();!(r=(h=l.next()).done);r=!0){var d=h.value;if((a=Pt(a=Pt(a,d.startY,i),d.endY,i))!==t.y)break}}catch(t){s=!0,o=t}finally{try{!r&&l.return&&l.return()}finally{if(s)throw o}}var u=!0,g=!1,f=void 0;try{for(var c,m=X[Symbol.iterator]();!(u=(c=m.next()).done);u=!0){var p=c.value;if((n=Pt(n=Pt(n,p.startX,i),p.endX,i))!==t.x)break}}catch(t){g=!0,f=t}finally{try{!u&&m.return&&m.return()}finally{if(g)throw f}}if(a===t.y)for(var _=0;_<v.count();_++){var y=v.get(_);a=Pt(a=Pt(a,(y.offsetFront+y.length)*w,i),(y.offsetBack+y.backLength)*w,i)}return{x:n,y:a}}function wt(t){for(var e=I,i=k,n=0;n<t.lines.length;n++){for(var a=t.lines[n],r=null,s=-1,o=0;o<X.length;o++)if(a.areaId===X[o].id){r=X[o],s=o;break}for(var h=null,l=0;l<z.length;l++)if(a.toolId===z[l].id){h=z[l],I=l;break}if(h)for(var d=0;d<h.sizes.length;d++)if(a.toolSizeId===h.sizes[d].id){h.size=d,k=d;break}if(r&&h){var u=0;"relative"===a.y.position?u=c.round(r.unscaledStartY+(r.unscaledEndY-r.unscaledStartY)*a.y.value,"length"):console.warn("Only PositionType RELATIVE is implemented for Y-Positioning!");var g=angular.copy(h),f=void 0;a.distance&&(f=h.distance.min,f="absolute"===a.distance.position?a.distance.value:(r.unscaledEndX-r.unscaledStartX)*a.distance.value),xt(r.unscaledStartX,r.unscaledEndX,u,s,g,t.id,f)}}I=e,k=i}function xt(t,e,i,n,a,r,s){var o=e-t;o=Math.max(Math.abs(o),1)*Math.sign(o);var h=angular.copy(a);s&&(h.distance.min=s,h.distance.max=s);var l=Rt(t,e,void 0,h);if(0!==l.length){var d=Math.min(l[0],l[l.length-1]),u=Math.max(l[0],l[l.length-1]),g=(Math.sign(o),a?a.sizes[k].id:z[I].sizes[k].id);St({punchType:"default"!==f.editor.nuitDrawStampingRework.punchType?f.editor.nuitDrawStampingRework.punchType:void 0,first:d,last:u,y:i,bounds:{min:a?a.distance.min:z[I].distance.min,max:a?a.distance.max:z[I].distance.max},amount:l.length,tool:{id:a?a.id:z[I].id,rotation:0,size:k,sizeId:g},meta:{type:r||void 0,distBetweenStamps:s||void 0,area:{index:n,id:X[n].id}}})}else console.warn("zero stamping")}function St(t){E.push(new Yt(t)),e.$broadcast(i.stampingLineAdded),at(),m.render()}function Tt(t){v.removeStampingLine(t),at(),m.render()}function Ct(){v.clearStampingLines(),S=!0,m.render()}function Lt(t){var e=f.units.length?f.units.length.factor:1,i=f.units.length?f.units.length.decimals:0;return(t/e).toFixed(i)}function It(){return p===u.STRETCHED}function kt(){return p===u.PROPORTIONAL}function bt(t,e){var i=z[I].sizes[z[I].size].id;for(var n in X)if(X[n].isToolAllowed(i)&&X[n].isVisible&&X[n].isAvailable&&e>=X[n].startY&&e<=X[n].endY&&t>=X[n].startX&&t<=X[n].endX)return parseInt(n);return null}function Pt(t,e,i){return Math.abs(t-e)<=i?e:t}function Mt(t){return{x:t.data.global.x-Y.worldTransform.tx,y:t.data.global.y-Y.worldTransform.ty}}function Rt(t,e,i,n,a){if(e<t){var r=t;t=e,e=r}var s=[],o=(n||z[I]).distance,h=e-t;if(a)a=v.clamp(a,o.min,o.max),i=Math.floor(h/a);else{var l=Math.floor(h/o.min),d=Math.ceil(h/o.max);i=i?v.clamp(i,d,l):l}var u=o.min;o.min!==o.max&&(u=c.round(h/Math.max(1,i)));for(var g=0;g<=i;g++)s.push(t+g*u);return s}function At(t){for(var e=0;e<E.length;e++)if(E[e].type===t)return!0;return!1}function Et(t){for(var e=0;e<N.length;e++)if(N[e].config.id===t)return!0;return!1}function Ot(t){return"readOnly"===t||!!Et(t)&&!f.editor.nuitDrawStampingRework.allowTemplateEditing}function Xt(t){for(var e=[],i=0;i<s.supportedShapes.length;i++)s.supportedShapes[i].type===t&&e.push(s.supportedShapes[i]);return e}it.alpha=.3,it.pivot.x=.5*it.width,it.pivot.y=0,Object.defineProperty(d,"renderer",{get:function(){return d.editorCtrl.renderer}}),Object.defineProperty(d,"showToolDistances",{get:function(){return r}}),t.$on(i.segmentDepthChanged,at),t.$on(i.segmentAdded,at),t.$on(i.segmentRemoved,at),t.$on(i.segmentLengthChanged,at),t.$on(i.segmentConicalChanged,at),t.$on(i.segmentBendingChanged,at),t.$on(i.conicalBaseChanged,at),t.$on(i.stampingLineFocused,function(t,e){T=e,S=!0,m.render()}),t.$on(i.stampingLineFocusCleared,function(){T=null,S=!0,m.render()}),t.$on(i.profileLoaded,at),e.$on(i.editorChanged,nt),d.$onInit=function(){nt(),Y.interactive=!0,Y.buttonMode=!0,Y.on("pointerover",ot),Y.on("pointerout",lt),Y.on("pointerup",dt),D.addChild(F),D.addChild(Y),D.addChild($),D.addChild(H),D.addChild(et),D.addChild(it),j.visible=!1,j.filters=[G],j.addChild(W),j.addChild(Z),j.addChild(K),j.addChild(q),j.addChild(J),j.addChild(Q),j.addChild(tt),j.addChild(U),j.addChild(V),D.addChild(j),Z.filters=[new PIXI.filters.AlphaFilter(.6)],function(){var i=new m.Manager;i.$onPreRender=gt,i.$onUse=ft,i.$onResize=ut,i.showStretched=_t,i.showProportional=yt,i.isStretched=It,i.isProportional=kt,i.deleteStampingLine=Tt,i.resetStamping=Ct,i.addStampingLine=St,i.generateTemplateStampingLine=wt,i.usesTemplate=At,i.isTemplate=Et,i.isDisabledByType=Ot,i.showToolDistances=d.showToolDistances,i.requireRefresh=function(){for(var t=0;t<E.length;t++)E[t].last=Math.min(E[t].last,v.depth),E[t].first=Math.min(E[t].first,v.depth);pt(),at(),m.render()},i.supportedShapes=s.supportedShapes,i.getSupportedShapesByType=Xt,Object.defineProperty(i,"tools",{get:function(){return z}}),Object.defineProperty(i,"areas",{get:function(){return X}}),Object.defineProperty(i,"selectedTool",{get:function(){return I?z[I]:z[0]},set:function(t){I!==t&&(I=t,S=!0,m.render())}}),Object.defineProperty(i,"selectedSize",{get:function(){return k?z[I].size:0},set:function(t){k=t,S=!0,m.render()}}),Object.defineProperty(i,"stampingLines",{get:function(){return E}}),Object.defineProperty(i,"templates",{get:function(){return N}}),Object.defineProperty(i,"selectedToolType",{get:function(){return M},set:function(t){return i.selectedShape=Xt(t)[0],M=t}}),Object.defineProperty(i,"selectedShape",{get:function(){return R},set:function(t){var e=void 0;for(e=0;e<z.length&&z[e].id!==t.tool.id;e++);return i.selectedSize=t.sizeIndex,i.selectedTool=e,R=t}}),Object.defineProperty(i,"toolGroupsEnabled",{get:function(){return!(!f.editor.nuitDrawStampingRework||!f.editor.nuitDrawStampingRework.toolGroups)&&f.editor.nuitDrawStampingRework.toolGroups.enabled}}),Object.defineProperty(i,"toolGroupsAvailable",{get:function(){return f.editor.nuitDrawStampingRework&&f.editor.nuitDrawStampingRework.toolGroups&&f.editor.nuitDrawStampingRework.toolGroups.available&&f.editor.nuitDrawStampingRework.toolGroups.available?f.editor.nuitDrawStampingRework.toolGroups.available:[]}}),d.manager=o=Object.freeze(i)}(),m.registerEditor("nuit-draw-stamping-rework",o,D)},d.$onDestroy=function(){m.unregisterEditor("nuit-draw-stamping-rework")},d.manager=o;var zt=(_createClass(Nt,[{key:"refresh",value:function(){this._refreshSegment(),this._refreshText()}},{key:"assign",value:function(t){t!==this.segment&&(this.segment=t)}},{key:"_refreshSegment",value:function(){B.lineStyle(0),this.segment.isWrap()?B.beginFill(g.wrapFillColor,g.wrapFillOpacity):this.segment.isConical()?B.beginFill(g.segmentConicalColor,g.segmentConicalOpacity):B.beginFill(g.segmentFillColor,g.segmentFillOpacity);var t=this.segment.getOffsetFront()*w,e=this.segment.getOffsetBack()*w,i=t+this.segment.length*w,n=e+this.segment.backLength*w;B.drawPolygon([new PIXI.Point(0,t),new PIXI.Point(y,e),new PIXI.Point(y,n),new PIXI.Point(0,i)]),B.lineStyle(g.segmentBorderWidth,g.segmentBorderColor,g.segmentBorderOpacity),B.moveTo(0,t),B.lineTo(0,i),B.moveTo(y,e),B.lineTo(y,n),1===this.segment.bendingDir||this.segment.isFirst()?(B.moveTo(0,t),B.lineTo(y,e)):Nt._drawDashedLine(B,0,t,y,e,10),this.segment.isLast()&&(B.moveTo(0,i),B.lineTo(y,n))}},{key:"_refreshText",value:function(){!this.segment.isWrap()||g.showWrapText?(this.textRight.text=Lt(this.segment.length),this.segment.isConical()&&this.segment.length!==this.segment.backLength&&(this.textRight.text+="\n("+Lt(this.segment.backLength)+")"),this.textRight.style.strokeThickness=0,this.textRight.visible=!0,this.textRight.position.y=(this.segment.getOffsetBack()+this.segment.backLength/2)*w-this.textRight.height/2,this.textRight.position.x=y+g.fontOffset):this.textRight.visible=!1}}],[{key:"_drawDashedLine",value:function(t,e,i,n,a,r){for(var s=n-e,o=a-i,h=Math.atan(o/s),l=Math.sqrt(Math.pow(s,2)+Math.pow(o,2)),d=Math.ceil(l/(2*r)),u=Math.cos(h)*r*2,g=Math.sin(h)*r*2,f=0;f<d;f++){var c=e+u*f,m=i+g*f,p=c+u/2,_=Math.min(p,n),y=_/p*g/2+m;t.moveTo(c,m),t.lineTo(_,y)}}}]),Nt);function Nt(){_classCallCheck(this,Nt),this.segment=null,this.textRight=new PIXI.Text("---",{fontFamily:g.fontFamily,fontSize:g.fontSize,stroke:g.fontStrokeColor})}var Dt=(_createClass(Ft,[{key:"_recalculate",value:function(t){var s=this,e=Number.MAX_VALUE,i=Number.MAX_VALUE,n=Number.MIN_VALUE,a=Number.MIN_VALUE,o=[];t.forEach(function(t){e=Math.min(t.x,e),i=Math.min(t.y,i),n=Math.max(t.x+t.width,n),a=Math.max(t.y+t.height,a)}),this._width=n-e,this._height=a-i,this._widthScale=1,this._heightScale=1;var r=this._width/this._height;r<1?this._widthScale=r:this._heightScale=1/r,t.forEach(function(t){var e=t.x/s._width,i=t.y/s._height,n=t.width/s._width,a=t.height/s._height,r=t.radius/s._width;o.push({x:e,y:i,width:n,height:a,radius:r})}),this._shapes=o,this._iconShape=this._shapes.map(function(t){return{x:t.x*s._widthScale,y:t.y*s._heightScale,width:t.width*s._widthScale,height:t.height*s._heightScale,radius:t.radius*s._widthScale}})}},{key:"render",value:function(e,i,n,t){var a=this._sizes[this._selectedSize].value,r=Math.max(a*_,5)*this._widthScale,s=Math.max(a*w,5)*this._heightScale;e.lineStyle(0),e.beginFill(16777215),t&&e.beginFill(16776960),this._shapes.forEach(function(t){e.drawRoundedRect(i+t.x*r-r/2,n+t.y*s-s/2,t.width*r,t.height*s,t.radius*r)})}},{key:"size",get:function(){return this._selectedSize},set:function(t){this._selectedSize=v.loop(t,this._sizes.length)}},{key:"sizes",get:function(){return this._sizes}},{key:"id",get:function(){return this._toolId}},{key:"icon",get:function(){return this._iconShape}},{key:"name",get:function(){return this._name}},{key:"distance",get:function(){return this._distance}},{key:"shape",get:function(){return this._shape}}]),Ft);function Ft(t){if(_classCallCheck(this,Ft),this._toolId=null,this._sizes=[],this._shapes=[],this._iconShape=[],this._name={},this._selectedSize=0,this._width=null,this._height=null,this._widthScale=null,this._heightScale=null,this._shape=[],this._distance={min:1,max:Number.POSITIVE_INFINITY},!t.id)throw new Error("Tool id is NOT set");if(this._toolId=t.id,!Array.isArray(t.sizes)||0===t.shapes.length)throw new Error("No tool sizes defined");if(this._sizes=t.sizes,t.name||console.warn("No tool name set"),this._name=t.name,t.distance||console.warn("No tool distance set"),this._distance=t.distance,!Array.isArray(t.shapes)||0===t.shapes.length)throw new Error("No tool shape defined");this._shape=t.shapes,this._recalculate(t.shapes)}var Yt=(_createClass(Bt,[{key:"assign",value:function(t,e){if(this._stampingLine=e,this._tool=e.embeddedTool?new Dt(e.embeddedTool):z.find(function(t){return t.id===e.tool.id}),this._lineIndex=t,!this._tool)throw new Error("Cannot find tool");this._stampingLine.meta||(this._stampingLine.meta={}),this._stampingLine.meta.type||(this._stampingLine.meta.type=STAMPING_LINE_TYPE.AMOUNT),this._stampingLine.meta.area&&(this._stampingArea=X[this._stampingLine.meta.area.index]),this._update()}},{key:"refresh",value:function(e){var i=this;this._graphics.clear(),this._graphics.removeChildren(),("readOnly"!==this.type?Rt(this._stampingLine.first,this._stampingLine.last,this._stampingLine.amount-1,this._tool):this._stampingLine.meta.x).forEach(function(t){i._tool.size=i._stampingLine.tool.size,i._tool.render(i._graphics,t*_,i._stampingLine.y*w,e)}),this._drawDimensions(this._graphics,{x:0,y:this._stampingLine.y*w})}},{key:"_update",value:function(){if(this.type!==STAMPING_LINE_TYPE.READ_ONLY){var t=this._stampingLine.bounds,e=Math.max(this._stampingLine.amount-1,1);if(this.type!==STAMPING_LINE_TYPE.AMOUNT&&this.distBetweenStamps){var i=e*this.distBetweenStamps+this.first;i>v.depth&&(e=Math.floor((v.depth-this.first)/this.distBetweenStamps))<1&&(this._stampingLine.meta.distBetweenStamps=v.depth-this.first),this._stampingLine.last=i}else{var n=this._stampingLine.last-this._stampingLine.first,a=Math.floor(n/t.min),r=Math.ceil(n/t.max);e=this._stampingLine.meta.fixedAmount?v.clamp(e,r,a):a,this._stampingLine.meta.distBetweenStamps=0==n?0:n/e}this._stampingLine.amount=e+1,Array.isArray(this._stampingLine.meta.x)||(this._stampingLine.meta.x=[]);for(var s=this.last>this.first?(this.last-this.first)/(this.amount-1):0,o=this._stampingLine.meta.x.length=0;o<this.amount;o++)this._stampingLine.meta.x.push(this.first+o*s)}this._save()}},{key:"_save",value:function(){v.updateStampingLine(this._lineIndex,this._stampingLine),m.render()}},{key:"_drawDimensions",value:function(t,e,i,n){var a=new PIXI.Text(Lt(this._stampingLine.first)+"|"+Lt(this.distBetweenStamps)+"x"+this.amount,A);a.y=e.y,a.x=-a.width-6,t.addChild(a);var r=a.width+20;t.moveTo(e.x,e.y),t.beginFill(0),t.lineStyle(1,0,.7,.5),t.lineTo(this._stampingLine.first*_,e.y),t.endFill(),t.beginFill(0),t.moveTo(e.x-r+3,e.y-3),t.lineTo(e.x-r,e.y-13),t.lineTo(e.x-r+6,e.y-13),t.endFill();var s=new PIXI.Text(Lt(this._stampingLine.y),A);s.y=e.y-16,s.x=a.x,t.addChild(s),t.moveTo(e.x-r,e.y),t.lineTo(e.x,e.y),t.beginFill(0),t.moveTo(e.x-r+10,e.y+8),t.lineTo(e.x-r,e.y+3+8),t.lineTo(e.x-r,e.y-3+8),t.endFill()}},{key:"graphics",get:function(){return this._graphics}},{key:"first",set:function(t){this._stampingLine.first=v.clamp(t,this._stampingArea.unscaledStartX,this._stampingArea.unscaledEndX),this._update()},get:function(){return this._stampingLine.first}},{key:"last",set:function(t){this._stampingLine.last=v.clamp(t,this._stampingArea.unscaledStartX,this._stampingArea.unscaledEndX),this.type!==STAMPING_LINE_TYPE.DISTANCE||this.fixedAmount||(this._stampingLine.amount=this.last>this.first?Math.floor((this.last-this.first)/this.distBetweenStamps):1),this._update()},get:function(){return this._stampingLine.last}},{key:"amount",set:function(t){this._stampingLine.amount=Math.round(t),this._update()},get:function(){return this._stampingLine.amount}},{key:"fixedAmount",get:function(){return Boolean(this._stampingLine.meta.fixedAmount)},set:function(t){this._stampingLine.meta.fixedAmount=t,this._update()}},{key:"distBetweenStamps",get:function(){return this._stampingLine.meta.distBetweenStamps},set:function(t){this._stampingLine.meta.distBetweenStamps=v.clamp(t,this.min,this.max),this.fixedAmount||(this._stampingLine.amount=this.last>this.first?Math.floor((this.last-this.first)/this.distBetweenStamps):1),this._update()}},{key:"y",set:function(t){this._stampingLine.y=t,this._update()},get:function(){return this._stampingLine.y}},{key:"tool",set:function(t){this._tool=t,this._stampingLine.tool.id=t.id,this._stampingLine.tool.shape=t.shape,this._stampingLine.tool.size>=t.sizes.length&&(this._stampingLine.tool.size=t.sizes.length-1),this._save()},get:function(){return this._tool}},{key:"size",set:function(t){this._stampingLine.tool.size=t},get:function(){return this._stampingLine.tool.size}},{key:"min",set:function(t){this._stampingLine.bounds.min=Math.max(t,1),this._update()},get:function(){return this._stampingLine.bounds.min}},{key:"max",set:function(t){this._stampingLine.bounds.max=Math.max(t,this._stampingLine.bounds.min),this._update()},get:function(){return this._stampingLine.bounds.max}},{key:"type",get:function(){return this._stampingLine.meta.type},set:function(t){this._stampingLine.meta.type=t,this._update()}},{key:"area",get:function(){return this._stampingArea?this._stampingArea.name:{en:"Unknown"}}},{key:"config",get:function(){return this._stampingLine}}]),Bt);function Bt(t){if(_classCallCheck(this,Bt),this._graphics=new PIXI.Graphics,t){var e=v.addStampingLine(t,t.punchType?t.punchType:void 0);this.assign(e,t)}}var Gt=(_createClass($t,[{key:"isToolAllowed",value:function(t){return!Array.isArray(this._areaConfig.allow)||0<=this._areaConfig.allow.indexOf(t)}},{key:"unscaledStartX",get:function(){var t=this._areaConfig.x.from;return this._areaConfig.isRight?t=v.depth-Math.max(this._areaConfig.x.from,this._areaConfig.x.to):this._areaConfig.isLeft&&(t=Math.min(this._areaConfig.x.from,this._areaConfig.x.to)),Math.max(t,0)}},{key:"startX",get:function(){return this.unscaledStartX*_}},{key:"unscaledEndX",get:function(){var t=v.depth-this._areaConfig.x.to;return this._areaConfig.isRight?t=v.depth-Math.min(this._areaConfig.x.from,this._areaConfig.x.to):this._areaConfig.isLeft&&(t=Math.max(this._areaConfig.x.from,this._areaConfig.x.to)),Math.min(t,v.depth)}},{key:"endX",get:function(){return this.unscaledEndX*_}},{key:"unscaledStartY",get:function(){if("longestSegment"===this._areaConfig.selectorY){var t=$t.getLongestSegment(),e=$t.getStartYofSegment(t);return this._areaConfig.isBottom?e=e+t.length-Math.max(this._areaConfig.y.from,this._areaConfig.y.to):this._areaConfig.isTop?e+=Math.min(this._areaConfig.y.from,this._areaConfig.y.to):e+=this._areaConfig.y.from,Math.max(e,0)}var i=this._areaConfig.y.from;return this._areaConfig.isBottom?i=v.totalLength-Math.max(this._areaConfig.y.from,this._areaConfig.y.to):this._areaConfig.isTop&&(i=Math.min(this._areaConfig.y.from,this._areaConfig.y.to)),Math.max(i,0)}},{key:"startY",get:function(){return this.unscaledStartY*w}},{key:"unscaledEndY",get:function(){if("longestSegment"===this._areaConfig.selectorY){var t=$t.getLongestSegment(),e=$t.getStartYofSegment(t);return this._areaConfig.isTop?e+=Math.max(this._areaConfig.y.from,this._areaConfig.y.to):e=this._areaConfig.isBottom?e+t.length-Math.min(this._areaConfig.y.from,this._areaConfig.y.to):e+t.length-this._areaConfig.y.to,Math.min(v.totalLength,e)}var i=v.totalLength-this._areaConfig.y.to;return this._areaConfig.isBottom?i=v.totalLength-Math.min(this._areaConfig.y.from,this._areaConfig.y.to):this._areaConfig.isTop&&(i=Math.max(this._areaConfig.y.from,this._areaConfig.y.to)),Math.min(v.totalLength,i)}},{key:"endY",get:function(){return this.unscaledEndY*w}},{key:"width",get:function(){var t=v.depth*_,e=this.endX-this.startX,i=t-this.startX;return v.clamp(e,1,i)}},{key:"height",get:function(){var t=v.totalLength*w,e=this.endY-this.startY,i=t-this.startY;return v.clamp(e,1,i)}},{key:"isVisible",get:function(){return void 0!==this._areaConfig.isVisible&&this._areaConfig.isVisible}},{key:"isAvailable",get:function(){return 0<=this.endY-this.startY}},{key:"name",get:function(){return this._areaConfig.name}},{key:"id",get:function(){return this._areaConfig.id}}],[{key:"getLongestSegment",value:function(){for(var t=v.getAll(),e=t.length,i=0<e?t[0]:null,n=1;n<e;n++)i.length<=t[n].length&&(i=t[n]);return i}},{key:"getStartYofSegment",value:function(t){for(var e=0,i=t;i.prev;)e+=i.prev.length,i=i.prev;return e}}]),$t);function $t(t){_classCallCheck(this,$t),this._areaConfig=null,t.isBottom&&t.isTop&&console.error("Area-configuration has isBottom and isTop set to true. Unexpected behavior can occur!"),t.isLeft&&t.isRight&&console.error("Area-configuration has isLeft and isRight set to true. Unexpected behavior can occur!"),this._areaConfig=t}var jt=function t(e){_classCallCheck(this,t),this.config=e}}t.$inject=["$scope","$filter","$rootScope","nuitEditor","nuitEditorEvents","nuitProfile","NUIT_DRAW_STAMPING_REWORK_SETTINGS","nuitSimplePunching","nuitPunchingMath"],angular.module("nuit.editor").controller("nuitDrawStampingReworkController",t)}();
"use strict";var SelectorY,PositionType;!function(e){e.none="none",e.longestSegment="longestSegment"}(SelectorY=SelectorY||{}),function(e){e.relative="relative",e.absolute="absolute"}(PositionType=PositionType||{});
"use strict";angular.module("nuit.editor").component("nuitDrawCutting",{templateUrl:"_nuit_/components/nuit-draw-cutting/nuit-draw-cutting.template.html",controller:"nuitDrawCuttingController",controllerAs:"vm",transclude:!0,require:{editorCtrl:"^nuitDraw"},bindings:{hideUi:"<"}});
"use strict";angular.module("nuit.editor").constant("NUIT_DRAW_CUTTING_SETTINGS",{editor:{nuitDrawCutting:{style:{rendererOffset:100,cuttingBorderWidth:1,cuttingBorderColor:16764108,cuttingBorderOpacity:1,cuttingFillColor:16751001,cuttingFillOpacity:1,segmentBorderWidth:1,segmentBorderColor:0,segmentBorderOpacity:1,segmentFillColor:15395562,segmentFillOpacity:1,segmentConicalColor:14342874,segmentConicalOpacity:1,wrapFillColor:14540287,wrapFillOpacity:1,showWrapText:!1,fontFamily:"Arial",fontSize:14,fontOffset:15,fontStrokeColor:15705360,fontStrokeThickness:3}}}});
"use strict";var _createClass=function(){function i(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(e,t,n){return t&&i(e.prototype,t),n&&i(e,n),e}}();function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}!function(){function e(t,g,e,n,i,r){var s,a=this,h=void 0;(s=h=h||{}).STRETCHED="s",s.PROPORTIONAL="p";var o=angular.copy(e),l=o.editor.nuitDrawCutting.style,c=null,u=!1,f=h.PROPORTIONAL,d=1,m=1,v=0,_=0,p=null,y=new PIXI.Container,x=new PIXI.Container,P=new PIXI.Graphics,C=new PIXI.Graphics,I=new PIXI.Container,S=new PIXI.Graphics,w=[],T=[];function k(e){p.visuals.visible=!0,C.visible=!0,x.on("pointermove",b),b(e)}function M(){p.visuals.visible=!1,C.visible=!1,x.off("pointermove",b),F()}function O(){E(p.export().meta)}function b(e){var i=function(e){return{x:e.data.global.x-x.worldTransform.tx,y:e.data.global.y-x.worldTransform.ty}}(e),t=w.findIndex(function(e){var t=e.getYonX(i.x/m)*d,n=e.getHeightOnX(i.x/m)*d;return i.y>=t&&i.y<t+n}),n=w[t];if(n){var r=[],s=n.offsetFront*d,o=n.offsetBack*d,a=g.depth*m;r.push(new PIXI.Point(0,s)),r.push(new PIXI.Point(a,o)),r.push(new PIXI.Point(a,o+n.backHeight*d)),r.push(new PIXI.Point(0,s+n.frontHeight*d)),C.clear(),C.beginFill(16776960,.3),C.drawPolygon(r),p.referenceSegment=t,p.start=i.x/m,F()}}function R(e){var t=o.units.length?o.units.length.factor:1,n=o.units.length?o.units.length.decimals:0;return(e/t).toFixed(n)}function X(){u=!0,F()}function F(){t.render()}function L(e){e<0||e>=T.length||(g.removeCutting(e),T.splice(e,1),i.$broadcast(r.cuttingRemoved),F())}function E(e){var t=new z(e);t.index=g.addCutting(t.export()),T.push(t),i.$broadcast(r.cuttingAdded),F()}function A(){!function(){var e=g.count();if(w.length>e)w.length=e;else for(;w.length<e;)w.push(new N);for(var t in w)w[t].assign(g.get(t))}(),T.length=0,g.getCuttings().forEach(function(e,t){e.meta&&0!==e.meta.angle&&e.meta.referenceSegment&&-1!==e.meta.referenceSegment||(e.meta=z.createMetaFromPoints(w,e.points,e.meta));var n=new z(e.meta,-1===e.meta.referenceSegment?z.sanitizePoints(w,e.points):void 0);n.index=t,T.push(n)}),function(){var e=a.renderer.width-2*l.rendererOffset,t=a.renderer.height-2*l.rendererOffset,n=g.getDepth(),i=g.getTotalLength();d=t/i,m=e/n;var r=l.rendererOffset,s=l.rendererOffset;if(f===h.PROPORTIONAL){var o=Math.min(d,m);m=d=o}v=n*m,_=i*d,f===h.PROPORTIONAL&&(r+=(e-v)/2,s+=(t-_)/2);y.x=r,y.y=s}(),p.recalculate(),T.forEach(function(e){return e.recalculate})}function $(){!function(e){(isNaN(e)||e<0||e>g.count())&&(e=0);x.removeChildren(),x.addChild(P),P.clear();for(var t=e;t<g.count();t++){var n=w[t];n.refresh(),x.addChild(n.textRight)}S.clear(),S.beginFill(16777215),S.lineStyle(0),S.drawRect(P.x,P.y-3,P.width,P.height+6)}(),p.render(!0),I.removeChildren(),T.forEach(function(e){e.render(),I.addChild(e.visuals)})}function D(){X()}function G(e){p.angle+=5*Math.sign(e.deltaY),F()}function H(){u&&(u=!1,A()),$()}Object.defineProperty(a,"renderer",{get:function(){return a.editorCtrl.renderer}}),Object.defineProperty(a,"angle",{get:function(){return p.angle},set:function(e){return p.angle=e}}),a.isStretched=function(){return f===h.STRETCHED},a.isProportional=function(){return f===h.PROPORTIONAL},a.showStretched=function(){if(f===h.STRETCHED)return;f=h.STRETCHED,X(),t.render()},a.showProportional=function(){if(f===h.PROPORTIONAL)return;f=h.PROPORTIONAL,X(),t.render()},a.$onInit=function(){o=angular.merge({},e,a.editorCtrl.config),x.interactive=!0,x.buttonMode=!0,x.on("pointerover",k),x.on("pointerout",M),x.on("pointercancel",M),x.on("pointerup",O),y.addChild(x),C.visible=!1,y.addChild(C),(p=new z).visuals.visible=!1,y.addChild(p.visuals),y.addChild(I),y.addChild(S),function(){var e=new t.Manager;e.$onUse=D,e.$onPreRender=H,e.$onMouseWheel=G,e.addCutting=E,e.removeCutting=L,Object.defineProperty(e,"cuttings",{get:function(){return T}}),c=e}(),t.registerEditor("nuit-draw-cutting",c,y)},a.$onDestroy=function(){t.unregisterEditor("nuit-draw-cutting")},n.$on(r.segmentDepthChanged,X),n.$on(r.segmentAdded,X),n.$on(r.segmentRemoved,X),n.$on(r.segmentLengthChanged,X),n.$on(r.segmentConicalChanged,X),n.$on(r.segmentBendingChanged,X),n.$on(r.conicalBaseChanged,X),n.$on(r.profileLoaded,X);var N=(_createClass(B,[{key:"refresh",value:function(){this._refreshSegment(),this._refreshText()}},{key:"assign",value:function(e){e!==this.segment&&(this.segment=e)}},{key:"getYonX",value:function(e){var t=e/g.depth,n=1-t,i=(this.segment.getOffsetFront()+Math.sin(this.offsetAngle)*e)*n,r=(this.segment.getOffsetBack()-Math.sin(this.offsetAngle)*(g.depth-e))*t;return Math.round(i+r)}},{key:"getHeightOnX",value:function(e){if(!this.segment.isConical())return this.segment.length;var t=e/g.depth,n=1-t;return(this.segment.length+Math.sin(this.conicalAngle)*e)*n+(this.segment.backLength-Math.sin(this.conicalAngle)*(g.depth-e))*t}},{key:"_refreshSegment",value:function(){P.lineStyle(0),this.segment.isWrap()?P.beginFill(l.wrapFillColor,l.wrapFillOpacity):this.segment.isConical()?P.beginFill(l.segmentConicalColor,l.segmentConicalOpacity):P.beginFill(l.segmentFillColor,l.segmentFillOpacity);var e=this.segment.getOffsetFront()*d,t=this.segment.getOffsetBack()*d,n=e+this.segment.length*d,i=t+this.segment.backLength*d;P.drawPolygon([new PIXI.Point(0,e),new PIXI.Point(v,t),new PIXI.Point(v,i),new PIXI.Point(0,n)]),P.lineStyle(l.segmentBorderWidth,l.segmentBorderColor,l.segmentBorderOpacity),P.moveTo(0,e),P.lineTo(0,n),P.moveTo(v,t),P.lineTo(v,i),1===this.segment.bendingDir||this.segment.isFirst()?(P.moveTo(0,e),P.lineTo(v,t)):B._drawDashedLine(P,0,e,v,t,10),this.segment.isLast()&&(P.moveTo(0,n),P.lineTo(v,i))}},{key:"_refreshText",value:function(){!this.segment.isWrap()||l.showWrapText?(this.textRight.text=R(this.segment.length),this.segment.isConical()&&this.segment.length!==this.segment.backLength&&(this.textRight.text+="\n("+R(this.segment.backLength)+")"),this.textRight.style.strokeThickness=0,this.textRight.visible=!0,this.textRight.position.y=(this.segment.getOffsetBack()+this.segment.backLength/2)*d-this.textRight.height/2,this.textRight.position.x=v+l.fontOffset):this.textRight.visible=!1}},{key:"offsetFront",get:function(){return this.segment.getOffsetFront()}},{key:"offsetBack",get:function(){return this.segment.getOffsetBack()}},{key:"frontHeight",get:function(){return this.segment.length}},{key:"backHeight",get:function(){return this.segment.backLength}},{key:"angle",get:function(){return this.segment.absoluteAngle}},{key:"offsetAngle",get:function(){var e=this.segment.getOffsetBack()-this.segment.getOffsetFront();return Math.atan(e/g.depth)}},{key:"conicalAngle",get:function(){var e=this.segment.backLength-this.segment.length;return Math.atan(e/g.depth)}}],[{key:"_drawDashedLine",value:function(e,t,n,i,r,s){for(var o=i-t,a=r-n,h=Math.atan(a/o),l=Math.sqrt(Math.pow(o,2)+Math.pow(a,2)),g=Math.ceil(l/(2*s)),c=Math.cos(h)*s*2,u=Math.sin(h)*s*2,f=0;f<g;f++){var d=t+c*f,m=n+u*f,v=d+c/2,_=Math.min(v,i),p=_/v*u/2+m;e.moveTo(d,m),e.lineTo(_,p)}}}]),B);function B(){_classCallCheck(this,B),this.segment=null,this.textRight=new PIXI.Text("---",{fontFamily:l.fontFamily,fontSize:l.fontSize,stroke:l.fontStrokeColor})}var z=(_createClass(W,[{key:"render",value:function(e){for(var n=this,i=0<arguments.length&&void 0!==e&&e,t=0;t<this._dimensionTexts.length;t++)this._dimensionTexts[t].destroy();for(t=this._dimensionTexts.length=0;t<this._points.length;t++)this._dimensionTexts.push(new j(this._visuals,this._dimensionGraphics,this._fontSettings));if(this._cuttingLine.clear(),this._dimensionGraphics.clear(),this._points.forEach(function(e,t){if(i&&t!==n._referenceSegment&&t!==n._referenceSegment+1||n._dimensionTexts[t].draw(e),n._cuttingLine.lineStyle(1,65280,t===n._referenceSegment+1?1:.5),0===t)return n._cuttingLine.moveTo(e.x*m,e.y*d);n._cuttingLine.lineTo(e.x*m,e.y*d)}),-1<this._referenceSegment){var r=this._points[this._referenceSegment],s=W._scalePoint(r),o=this._points[this._referenceSegment+1],a=W._scalePoint(o);this._dimensionGraphics.beginFill(0),this._dimensionGraphics.drawCircle(a.x,a.y,3),this._dimensionGraphics.drawCircle(s.x,s.y,3),this._dimensionGraphics.endFill()}}},{key:"recalculate",value:function(){if(-1<this._referenceSegment){if(0===this._angle&&this._points.length>this._referenceSegment&&(this._angle=Math.atan((this._points[this._referenceSegment+1].y-this._points[this._referenceSegment].y)/(this._points[this._referenceSegment+1].x-this._points[this._referenceSegment].x)),this._startX=this._points[this._referenceSegment].x),(this._points.length=0)===w.length)return;var e=w[this._referenceSegment].angle,t=[],n=this._startX,i=Math.tan(this._angle);t.push(n);for(var r=n,s=this._referenceSegment-1;0<=s;s--)r=W._calculateSegmentPoint(s,e,i,r,!1),t.unshift(r);r=n;for(var o=this._referenceSegment;o<w.length;o++)r=W._calculateSegmentPoint(o,e,i,r),t.push(r);for(var a in t){var h=w[Math.min(parseInt(a),w.length-1)],l=h.getYonX(t[a]);parseInt(a)===w.length&&(l+=h.getHeightOnX(t[a])),this._points.push({x:t[a],y:l})}}"number"==typeof this._cuttingIndex&&g.setCutting(this._cuttingIndex,this.export()),F()}},{key:"export",value:function(){return{points:this._points,meta:{angle:this._angle,referenceSegment:this._referenceSegment,start:this._startX}}}},{key:"visuals",get:function(){return this._visuals}},{key:"start",get:function(){return this._startX},set:function(e){this._startX=Math.round(e),this.recalculate()}},{key:"angle",get:function(){return Math.round(this._angle*g.RAD2DEG)},set:function(e){this._angle=g.loop(e*g.DEG2RAD,2*Math.PI),this.recalculate()}},{key:"referenceSegment",get:function(){return this._referenceSegment},set:function(e){this._referenceSegment=g.clamp(e,0,g.count()-1),this.recalculate()}},{key:"index",set:function(e){this._cuttingIndex=e}}],[{key:"_calculateSegmentPoint",value:function(e,t,n,i,r){var s=!(4<arguments.length&&void 0!==r)||r,o=w[Math.min(e,w.length-1)],a=Math.cos(o.angle-t),h=o.frontHeight*a*(s?1:-1),l=Math.sin((s?1:-1)*o.conicalAngle)*a,g=-Math.round(n*i);return Math.round((g-h)/(l-n))}},{key:"_scalePoint",value:function(e){return{x:g.clamp(e.x,0,g.depth)*m,y:e.y*d}}},{key:"createMetaFromPoints",value:function(e,t,n){if(t.length<2)return null;var i=W.sanitizePoints(e,t),r=n&&n.referenceSegment&&0<=n.referenceSegment?n.referenceSegment:W._findReferenceSegment(e,i);return{start:-1!==r?Math.round(i[r].x):i[0].x,referenceSegment:r,angle:-1!==r?Math.atan((i[r+1].y-i[r].y)/(i[r+1].x-i[r].x)):0}}},{key:"sanitizePoints",value:function(e,t){for(var n=angular.copy(t),i=0;i<t.length;i++)n[i].x=Math.round(t[i].x),0===i?n[i].y=0:i<t.length-1?n[i].y=e[i].offsetFront:n[i].y=e[i-1].offsetFront+e[i-1].frontHeight;return n}},{key:"_findReferenceSegment",value:function(e,t){if(e.length+1!==t.length)return console.warn("cutting point-count and segment-count do not match"),0;for(var n={},i=0;i<e.length;i++){var r=[],s=e[i].angle,o=[],a=t[i].x,h=(t[i+1].y-t[i].y)/(t[i+1].x-t[i].x),l=180*Math.atan(h)/Math.PI;if(90!=l&&180!=l){n[i]=0,o.push(a);for(var g=a,c=i-1;0<=c;c--)g=W._calculateSegmentPoint(c,s,h,g,!1),o.unshift(g);g=a;for(var u=i;u<e.length;u++)g=W._calculateSegmentPoint(u,s,h,g),o.push(g);for(var f in o){var d=w[Math.min(parseInt(f),w.length-1)],m=d.getYonX(o[f]);parseInt(f)===w.length&&(m+=d.getHeightOnX(o[f])),r.push({x:o[f],y:m})}for(var v=!0,_=0;_<r.length;_++)n[i]+=Math.abs(r[_].x-t[_].x),v=v&&r[_].x===t[_].x&&r[_].y===t[_].y;if(v)return i}}var p=Number.MAX_VALUE,y=-1;for(var x in n)n[x]<p&&(p=n[x],y=parseInt(x));return p/e.length<=2?y:-1}}]),W);function W(e,t){var n=this;_classCallCheck(this,W),this._startX=0,this._angle=Math.atan(1),this._points=[],this._referenceSegment=0,this._dimensionTexts=[],this._cuttingIndex=null,this._fontSettings={fontSize:14},this._visuals=new PIXI.Container,this._cuttingLine=new PIXI.Graphics,this._cuttingLine.mask=S,this._dimensionGraphics=new PIXI.Graphics,this._visuals.addChild(this._dimensionGraphics),this._visuals.addChild(this._cuttingLine),t&&t.forEach(function(e){n._points.push({x:Math.round(e.x),y:Math.round(e.y)})}),e&&(this._startX=e.start,this._angle=g.loop(e.angle,2*Math.PI),this._referenceSegment=e.referenceSegment,this.recalculate())}var j=(_createClass(Y,[{key:"destroy",value:function(){this.container.removeChild(this.left),this.container.removeChild(this.right),this.left.destroy(),this.right.destroy()}},{key:"draw",value:function(e){this.left.text=Math.round(e.x).toString(),this.right.text=Math.round(g.depth-e.x).toString(),Y._draw(this.graphic,z._scalePoint(e),{left:this.left,right:this.right})}}],[{key:"_draw",value:function(e,t,n,i){var r=3<arguments.length&&void 0!==i?i:1;if(0!==(r=Math.sign(r))){var s={x:t.x,y:t.y},o=Math.max(n.left.height,n.right.height)+2,a=Math.max(n.left.width,n.right.width)+4;e.moveTo(t.x,t.y),e.lineTo(s.x,s.y+o*-r),e.beginFill(0),e.moveTo(s.x-a,s.y),e.lineTo(s.x-a+10,s.y+3),e.lineTo(s.x-a+10,s.y-3),e.endFill(),e.moveTo(s.x-a,s.y),e.lineTo(s.x+a,s.y),e.beginFill(0),e.moveTo(s.x+a,s.y),e.lineTo(s.x+a-10,s.y+3),e.lineTo(s.x+a-10,s.y-3),e.endFill(),n.left.x=s.x-2-n.left.width,n.right.x=s.x+2,n.left.y=s.y-2*r,n.right.y=s.y-2*r,0<r&&(n.left.y-=n.left.height,n.right.y-=n.right.height)}else console.error("Factor must not be 0")}}]),Y);function Y(e,t,n){_classCallCheck(this,Y),this.container=e,this.graphic=t,this.left=new PIXI.Text("",n),this.right=new PIXI.Text("",n),this.container.addChild(this.left),this.container.addChild(this.right)}}e.$inject=["nuitEditor","nuitProfile","NUIT_DRAW_CUTTING_SETTINGS","$scope","$rootScope","nuitEditorEvents"],angular.module("nuit.editor").controller("nuitDrawCuttingController",e)}();
"use strict";
//# sourceMappingURL=nuit-editor.js.map

(function () {
    'use strict';

    angular
        .module('app.products.tags')
        .controller('TagsController', TagsController);

    /** @ngInject */
    function TagsController($mdDialog, imsTranslation, nuitApi, nuitUtils) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        vm.tags = [];
        vm.selectedTag = null;
        vm.term = '';
        //*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        vm.addTag = addTag;
        vm.editTag = editTag;
        vm.deleteTag = deleteTag;
        vm.toggleSelectionForTag = toggleSelectionForTag;
        vm.matchesFilter = matchesFilter;
        //*******************************************

        //*******************************************
        // INITIALIZATION
        //*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // OBJECT CONSTANTS
        //*******************************************
        /**
         * Creates a new dialog which can be used to create or edit tags.
         * @param {Object} tag - existing tag or null
         * @returns {Object}
         */
        function createEditTagDialog(tag) {
            return {
                controller: 'EditTagDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/merchandising.products.tags/dialogs/edit-tag/edit-tag.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    Tag: angular.copy(tag)
                }
            };
        }

        //*******************************************
        // METHODS
        //*******************************************
        /**
         * Initializes this controller.
         */
        function init() {
            nuitApi('product.tags')
                .get()
                .then(function (response) {
                    vm.tags.splice(0, vm.tags.length);
                    angular.merge(vm.tags, response.data);
                });
        }
        /**
         * Shows the add tag dialog.
         */
        function addTag() {
            var tag = null;
            $mdDialog
                .show(createEditTagDialog())
                .then(function (result) {
                    return nuitApi('product.tags').post(result);
                })
                .then(function (response) {
                    tag = response.data;
                    vm.tags.push(tag);
                    tag._isLoading = true;
                    nuitUtils.showSuccessToast();
                    return imsTranslation.refresh();
                })
                .finally(function () {
                    if (tag !== null && tag._isLoading !== undefined) {
                        delete tag._isLoading;
                    }
                });
        }
        /**
         * Shows the edit tag dialog.
         * @param {Object} tag - tag object
         * @param {Object} $event - event data
         */
        function editTag(tag, $event) {
            if(tag === undefined) { return; }
            
            $event.stopPropagation();
            $mdDialog
                .show(createEditTagDialog(tag))
                .then(function (result) {
                    return nuitApi('product.tag',result.id).put(result);
                })
                .then(function (response) {
                    tag._isLoading = true;
                    vm.tags.splice(vm.tags.indexOf(tag), 1, response.data)
                    nuitUtils.showSuccessToast();
                    return imsTranslation.refresh();
                })
                .catch(angular.noop)
                .finally(function () {
                    if (tag !== null && tag._isLoading !== undefined) {
                        delete tag._isLoading;
                    }
                });
        }
        /**
         * Deletes the given tag.
         * @param {Object} tag - tag object
         * @param {Object} $event - event data
         */
        function deleteTag(tag, $event) {
            $event.stopPropagation();
            nuitUtils
                .showDeleteConfirmation()
                .then(function () {
                    nuitApi('product.tag', tag.id)
                        .delete()
                        .then(function (response) {
                            vm.tags.splice(vm.tags.indexOf(tag), 1);
                            nuitUtils.showSuccessToast();
                        }).catch(nuitUtils.showErrorToast);
                });
        }
        /**
         * Toggles the selection for the given tag.
         * @param {Object} tag
         */
        function toggleSelectionForTag(tag) {
            if (vm.selectedTag === tag) {
                vm.selectedTag = null;
            } else {
                vm.selectedTag = tag;
            }
        }
        /**
         * Returns true if the given tag matches
         * all existing search filters.
         * @param {Object} tag
         * @returns {Boolean}
         */
        function matchesFilter(tag) {
            return vm.term === undefined || tag.name[imsTranslation.language].toLowerCase().includes(vm.term.toLowerCase());
        }
    }
}());

(function () {
	'use strict';

	angular
		.module('app.products.attributes')
		.controller('AttributesController', AttributesController);

	/** @ngInject */
	function AttributesController($mdDialog, imsTranslation, nuitUtils, ProductAttributes) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.term = '';
		vm.attributes = ProductAttributes.all;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.addAttribute = addAttribute;
        vm.editAttribute = editAttribute;
        vm.deleteAttribute = deleteAttribute;
        vm.filterAttribute = filterAttribute;
        vm.toggleVisibility = toggleVisibility;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function showEditAttributeDialog(attribute) {
			return $mdDialog.show({
				controller: 'EditAttributeDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/merchandising.products.attributes/dialogs/edit-attribute/edit-attribute.html',
				parent: angular.element(document.body),
				locals: {
					Attribute: angular.copy(attribute)
				}
			});
		}
        
		//*******************************************
		// METHODS
		//*******************************************
        function init() {
            ProductAttributes.reload();
        }
        
        function addAttribute() {
            showEditAttributeDialog()
                .then(function (result) {
                    ProductAttributes.add(result)
                    .then(nuitUtils.showSuccessToast)
                    .catch(nuitUtils.showErrorToast);
                })
                .catch(angular.noop);
        }
        
        function editAttribute(attribute) {
            showEditAttributeDialog(attribute)
                .then(function (result) {
                    ProductAttributes
                    .update(result)
                    .then(nuitUtils.showSuccessToast)
                    .catch(nuitUtils.showErrorToast);
                })
                .catch(angular.noop);;
        }
        
        function toggleVisibility(attribute) {
            ProductAttributes
                .toggleVisibility(attribute)
                .catch(nuitUtils.showErrorToast);
        }
        
        function deleteAttribute(attribute) {
            nuitUtils.showDeleteConfirmation()
                .then(function () {
                    ProductAttributes
                        .delete(attribute)
                        .then(nuitUtils.showSuccessToast)
                        .catch(nuitUtils.showErrorToast);
                })
                .catch(angular.noop);
        }
        
        function filterAttribute(attribute) {
            return vm.term === '' || attribute.name[imsTranslation.language].toLowerCase().includes(vm.term.toLowerCase());
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products')
		.factory('ProfileImageService', ProfileImageService);

	/** @ngInject */
	function ProfileImageService(nuitProfiles, nuitUtils) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			set: set,
			update: update
		};
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS (Public)
		//*******************************************
		function set(product, vm) {
			return nuitUtils.showConfirmationDialog('PRODUCT.SET_PROFILE_IMAGE_TITLE', 'PRODUCT.SET_PROFILE_IMAGE_CONTENT')
				.then(function () {
					product.image = vm.imagePath;
				});
		}

		function update(vm,profile, showSetDialog) {
			return nuitProfiles.getImage(profile)
				.then(function (image) {
					vm.base64 = image.base64;
					vm.imagePath = image.path;

					if(showSetDialog) {
						set(vm.currentProduct, vm);
					}
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products')
		.factory('ProductService', ProductService);

	/** @ngInject */
	function ProductService($rootScope, $log, $q, nuitApi, nuitConfig, SalesService, nuitProfiles, imsMaterials, imsTranslation, nuitUtils, nuitProducts, nuitDataService) {
        //*******************************************
		// CONSTANTS
		//*******************************************
        var PRICE_RULE_TYPES = initPriceRuleTypes();
		// Unique attributes the backend treats '' as a real value for (and rejects
		// duplicates of) - empty/blank strings are saved as null instead.
		var EMPTY_AS_NULL_ATTRIBUTES = ['externalId'];
		var MATERIAL_ATTRIBUTE_BASE = 'basePrice';
        var PRICE_MODIFIERS = initPriceModifiers();
        var PRICE_MODIFIER_TYPES = initPriceModifierTypes();
        var PRODUCT_PROPERTIES = initProductProperties();
        var RULE_NUMERIC_COMBINATORS = initNumericCombinators();
        var RULE_BOOLEAN_COMPARATORS = initBooleanComparators();
        var RULE_NUMERIC_COMPARATORS = initNumericComparators();
        var RULE_STRING_COMPARATORS = initStringComparators();
        var EVENT_CATEGORIES_RELOADED = 'products::categories.reloaded';
        var EVENT_CATEGORY_ADDED = 'products::category.added';
        var EVENT_CATEGORY_DELETED = 'products::category.deleted';
        var EVENT_CATEGORY_UPDATED = 'products::category.updated';
        //*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        /**
         * Contains all loaded products of the current environment.
         * @type Array
         */
		var _products = [];
		var _pages = {};
		var _meta = {pagination:{total:0, current_page:1, per_page: 20, total_pages: 1}};
        /**
         * True when _products holds the complete, non-paged product list
         * (loaded via reloadProducts). False while products are loaded
         * page-by-page (reloadPaged), where _products only holds the loaded
         * pages plus placeholders. Consumers that need every product (e.g.
         * the product-selection dialog) can check this to avoid reloading
         * the full list when it is already present.
         * @type Boolean
         */
        var _allLoaded = false;
        /**
         * Contains all product categories of the current environment.
         * @type Array
         */
		var _categories = [];
        /**
         * Contains all product tags of the current environment.
         * @type Array
         */
        var _tags = [];
		//*******************************************

        //*******************************************
        // ENUMS
        //*******************************************
        // Enum that contains all events of this service.
        var EVENTS = {
            CategoriesReloaded: EVENT_CATEGORIES_RELOADED,
            CategoryAdded: EVENT_CATEGORY_ADDED,
            CategoryDeleted: EVENT_CATEGORY_DELETED,
            CategoryUpdated: EVENT_CATEGORY_UPDATED
        };
        //*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			// Categories
			addCategory: addCategory,
			deleteCategory: deleteCategory,
            reloadCategories: reloadCategories,
            updateCategory: updateCategory,
			moveCategory: moveCategory,
            getCategoryById: getCategoryById,
            getFlatifiedCategories: getFlatifiedCategories,

			// Products
			addProduct: addProduct,
            deleteProduct: deleteProduct,
			loadProduct: loadProduct,
			updateProduct: updateProduct,
            reloadProducts: reloadProducts,
            reloadPaged: reloadPaged,
            clear: clear,
            isPageLoaded: isPageLoaded,
            isFullyLoaded: isFullyLoaded,
            isProductInCategoryId: isProductInCategoryId,
            getProductPrice: getProductPrice,
            getExtendedProductPrice: getExtendedProductPrice,
            getRuleTypeKey: getRuleTypeKey,
            getPriceModifierSymbol: getPriceModifierSymbol,
            getBooleanComparatorKey: getBooleanComparatorKey,
            getNumericComparatorKey: getNumericComparatorKey,
            getProductPropertyKey: getProductPropertyKey,

            // Attributes
            hasAttribute: hasAttribute,
            getAttributeCountByType: getAttributeCountByType,
            getTranslationKeyOfType: getTranslationKeyOfType,

            // Tags
            reloadTags: reloadTags,
            getTagById: getTagById,

			//evo stuff
			isProductInCategory: nuitProducts.isProductInCategory,
			hasTags: nuitProducts.hasTags,

            // Events
            EVENTS: EVENTS
		};
        //*******************************************

        //*******************************************
        // PROPERTIES
        //*******************************************
        Object.defineProperty(service, 'products', { get: function() { return _products; } });
        Object.defineProperty(service, 'meta', { get: function() { return _meta; } });
        Object.defineProperty(service, 'categories', { get: function() { return _categories; } });
        Object.defineProperty(service, 'tags', { get: function() { return _tags; } });
        Object.defineProperty(service, 'priceModifiers', { get: function() { return PRICE_MODIFIERS; } });
        Object.defineProperty(service, 'priceModifierTypes', { get: function() { return PRICE_MODIFIER_TYPES; } });
        Object.defineProperty(service, 'priceRuleTypes', { get: function() { return PRICE_RULE_TYPES; } });
        Object.defineProperty(service, 'materialAttributeBase', { get: function() { return MATERIAL_ATTRIBUTE_BASE; } });
        Object.defineProperty(service, 'productProperties', { get: function() { return PRODUCT_PROPERTIES; } });
        Object.defineProperty(service, 'numericCombinators', { get: function() { return RULE_NUMERIC_COMBINATORS; } });
        Object.defineProperty(service, 'booleanComparators', { get: function() { return RULE_BOOLEAN_COMPARATORS; } });
        Object.defineProperty(service, 'numericComparators', { get: function() { return RULE_NUMERIC_COMPARATORS; } });
        Object.defineProperty(service, 'stringComparators', { get: function() { return RULE_STRING_COMPARATORS; } });
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        function initPriceRuleTypes() {
            return [
                {
                    value: 'attribute',
                    key: 'PRODUCT.RULE_ATTRIBUTE',
                    disabled: function (product) {
                        return product.attributes.length < 1;
                    }
                }, {
                    value: 'combination',
                    key: 'PRODUCT.RULE_COMBINATION',
                    disabled: function (product) {
                        return getAttributeCountByType(product, ['number', 'length'], true) < 2;
                    }
                }, {
                    value: 'productdata',
                    key: 'PRODUCT.RULE_PRODUCTDATA'
                }
            ];
        }

        function initProductProperties() {
            return [{
               key: 'APP.GENERAL',
               properties: [{
                       key: 'APP.QUANTITY',
                       id: 'general.quantity'
               }]
            },{
               key: 'PRODUCT.PROFILE',
               properties: [{
                       key: 'PROFILE.BLANK',
                       id: 'profile.blank',
                       disabled: function (product) {
                           return product.data.profile === undefined;
                       }
               },{
                       key: 'PROFILE.LENGTH',
                       id: 'profile.length',
                       disabled: function (product) {
                           return product.data.profile === undefined;
                       }
               },{
                       key: 'PROFILE.MATERIAL',
                       id: 'profile.material',
                       disabled: function (product) {
                           return product.data.profile === undefined;
                       }
               },{
                       key: 'PROFILE.MATERIAL_GROUP',
                       id: 'profile.materialgroup',
                       disabled: function (product) {
                           return product.data.profile === undefined;
                       }
               }]
            }];
        }

        function initPriceModifiers() {
            return [
                { value: '+', symbol: '+' },
                { value: '-', symbol: '-' },
                { value: '=', symbol: '=' }
            ];
        }

        function initPriceModifierTypes() {
            return [
                { value: 'currency', symbol: '$' },
                { value: 'percent', symbol: '%' }
            ];
        }

        function initNumericCombinators() {
            return [
                {
                    value: '+',
                    symbol: '+'
                }, {
                    value: '-',
                    symbol: '-'
                }, {
                    value: '*',
                    symbol: 'x'
                }, {
                    value: '/',
                    symbol: '/'
                }
            ];
        }

        function initBooleanComparators() {
            return [
                {
                    condition: 'if',
                    key: 'CONDITION.IF'
                }, {
                    condition: 'not',
                    key: 'CONDITION.IF_NOT'
                }, {
                    condition: 'if_multi',
                    key: 'CONDITION.IF_MULTIPLE'
                }, {
                    condition: 'not_multi',
                    key: 'CONDITION.IF_NOT_MULTIPLE'
                }
            ];
        }

        function initNumericComparators() {
            return [
                {
                    condition: '=',
                    key: 'CONDITION.EQUAL'
                },{
                    condition: '!=',
                    key: 'CONDITION.NOT_EQUAL'
                },{
                    condition: '>',
                    key: 'CONDITION.GREATER'
                }, {
                    condition: '>=',
                    key: 'CONDITION.GEQUAL'
                }, {
                    condition: '<',
                    key: 'CONDITION.LOWER'
                }, {
                    condition: '<=',
                    key: 'CONDITION.LEQUAL'
                }, {
                    condition: '/',
                    key: 'CONDITION.DIVISION'
                }, {
                    condition: '$',
                    key: 'CONDITION.STEPS'
                }
            ];
        }

        function initStringComparators() {
            return [
                {
                    condition: '=',
                    key: 'CONDITION.EQUAL'
                },{
                    condition: '!=',
                    key: 'CONDITION.NOT_EQUAL'
                },{
                    condition: '.=',
                    key: 'CONDITION.STARTS_WITH'
                },{
                    condition: '!.=',
                    key: 'CONDITION.STARTS_NOT_WITH'
                }, {
                    condition: '=.',
                    key: 'CONDITION.ENDS_WITH'
                }, {
                    condition: '=.',
                    key: 'CONDITION.ENDS_NOT_WITH'
                }, {
                    condition: '|',
                    key: 'CONDITION.CONTAINS'
                }, {
                    condition: '!|',
                    key: 'CONDITION.CONTAINS_NOT'
                },{
                    condition: '&',
                    key: 'CONDITION.MATCHES_REGEX'
                }
            ];
        }

        function getBooleanComparatorKey(comparator) {
            for(var index in RULE_BOOLEAN_COMPARATORS) {
                if(RULE_BOOLEAN_COMPARATORS[index].condition === comparator) {
                    return RULE_BOOLEAN_COMPARATORS[index].key;
                }
            }
            return comparator;
        }

        function getNumericComparatorKey(comparator) {
            for(var index in RULE_NUMERIC_COMPARATORS) {
                if(RULE_NUMERIC_COMPARATORS[index].condition === comparator) {
                    return RULE_NUMERIC_COMPARATORS[index].key;
                }
            }
            return comparator;
        }

        function getProductPropertyKey(propertyId) {
            for(var i in PRODUCT_PROPERTIES) {
                for(var index in PRODUCT_PROPERTIES[i].properties) {
                    var property = PRODUCT_PROPERTIES[i].properties[index];
                    if(property.id === propertyId) {
                        return property.key;
                    }
                }
            }
            return propertyId;
        }

        function getAttributeCountByType(product, type, includeConstants) {
            if(!angular.isArray(type)) { type = [type]; }
            var count = 0;
            for(var index in product.attributes) {
                if((!product.attributes[index].value || includeConstants) && type.indexOf(product.attributes[index].type) >= 0) {
                    count++;
                }
            }
            return count;
        }

        /**
         * Reloads all products.
         * @returns {Promise}
         */
        function reloadProducts() {
            return nuitApi('products.list')
                .get()
                .then(function(response) {
                    _products.splice(0,_products.length);
                    angular.merge(_products, response.data);
                    _pages = {};
                    _allLoaded = true;
                    return _products;
            });
        }
        /**
         * Reloads products using the paginated v2 endpoint.
         * Stores the response in a page-indexed cache (_pages) and rebuilds
         * _products as a flat array sized to pagination.total with skeleton
         * placeholders for unloaded slots. This keeps nuit-pagination's
         * page-count math correct while remaining robust when total shifts
         * between requests.
         * @param {Object} filter - query params (page, name, categoryId, etc.)
         * @returns {Promise}
         */
        function reloadPaged(filter) {
            return nuitApi('products.list.v2')
                .get(filter)
                .then(function (response) {
                    if (!response || !response.data || !response.data.data || !response.data.meta) {
                        return $q.reject(new Error('Invalid pagination response'));
                    }
                    angular.extend(_meta, response.data.meta);
                    _pages[_meta.pagination.current_page] = response.data.data;
                    _allLoaded = false;
                    rebuildProducts();
                });
        }
        function rebuildProducts() {
            var perPage = _meta.pagination.per_page;
            var total = _meta.pagination.total;
            _products.splice(0, _products.length);
            for (var i = 0; i < total; i++) {
                _products.push(makePlaceholder(i));
            }
            angular.forEach(_pages, function (pageProducts, pageStr) {
                var startIndex = (parseInt(pageStr, 10) - 1) * perPage;
                for (var j = 0; j < pageProducts.length; j++) {
                    if (startIndex + j < total) {
                        _products[startIndex + j] = pageProducts[j];
                    }
                }
            });
        }
        function makePlaceholder(index) {
            return {id: -(index + 1), name: {}, _placeholder: true};
        }
        /**
         * Clears all loaded products and the page cache.
         */
        function clear() {
            _pages = {};
            _products.splice(0, _products.length);
            _allLoaded = false;
        }
        function isPageLoaded(pageNum) {
            return !!_pages[pageNum];
        }
        /**
         * Returns true when the complete, non-paged product list is loaded.
         * @returns {Boolean}
         */
        function isFullyLoaded() {
            return _allLoaded;
        }
        /**
         * Reloads all categories.
         * @returns {Promise}
         */
        function reloadCategories() {
            return nuitApi('products.categories')
                .get()
                .then(function(response) {
                    _categories.splice(0, _categories.length);
                    angular.merge(_categories, response.data);
                    $rootScope.$broadcast(EVENTS.CategoriesReloaded);
            });
        }
        /**
         * Reloads all tags.
         * @returns {Promise}
         */
        function reloadTags() {
            return nuitApi('products.tags')
                .get()
                .then(function(response) {
                    _tags.splice(0, _tags.length);
                    angular.merge(_tags, response.data);
            });
        }
        /**
         * Returns the tag with the given id.
         * @param {Number} id
         * @returns {Tag}
         */
        function getTagById(id) {
            for(var index in _tags) {
                if(_tags[index].id === id) {
                    return _tags[index];
                }
            }
            return null;
        }
        /**
         * Returns the category with the given id.
         * @param {Number} id
         * @returns {Category}
         */
        function getCategoryById(id) {
			var result = recursiveSearch(_categories, id);
			return result;

			function recursiveSearch(array, id) {
				if (id === null) {
					return null;
				}
				if (array === null) {
					return null;
				}
				if (array.length <= 0) {
					return null;
				}
				for (var index in array) {
					if (array[index].id === id) {
						return array[index];
					}

					if (array[index].children) {
						var result = recursiveSearch(array[index].children, id);
						if (result !== null) {
							return result;
						}
					}
				}
				return null;
			}
        }
        /**
         * Returns true if the given product is in the category with the given id.
         * @param {Object} product
         * @param {Number} categoryId
         */
        function isProductInCategoryId(product, categoryId) {
            for(var index in product.categories) {
                if(String(product.categories[index].id) === String(categoryId)) {
                    return true;
                }
            }
            return false;
        }
        /**
         * Returns true if the product contains the given attribute.
         * @param {Object} product
         * @param {Object} attribute
         * @return {Boolean}
         */
        function hasAttribute(product, attribute) {
            return getProductAttribute(product, attribute.id) !== null;
        }
        /**
         * Returns the assigned attribute with the given id of the product
         * or null otherwise.
         * @param {Object} product
         * @param {Object} attributeId
         * @return {Object}
         */
        function getProductAttribute(product, attributeId) {
            for(var index in product.attributes) {
                if(product.attributes[index].id === attributeId) {
                    return product.attributes[index];
                }
            }
            return null;
        }
        /**
         * Returns the translation key of the given attribute type.
         * @param {String} attributeType
         * @return {String}
         */
        function getTranslationKeyOfType(attributeType) {
            var key = '';
            switch (attributeType) {
                //case 'exception': <-- Insert exceptions here
                //    key = 'APP.EXAMPLE';
                //    break;
                default:
                    key = 'APP.' + attributeType.toUpperCase();
                    break;
            }
            return key;
        }
        /**
         * Registers a new product category.
         * @param {Object} category - category object
         * @returns {Promise}
         */
		function addCategory(category) {
			return nuitApi('products.categories')
				.post(category)
				.then(function (response) {
                    category = response.data;
                    if (category.parent) {
						var parent = getCategoryById(category.parent);
						if(!parent.children) { parent.children = []; }
						parent.children.push(category);
                    } else {
                        _categories.push(response.data);
                    }
                    $rootScope.$broadcast(EVENTS.CategoryAdded, { category: category });
					return response.data;
				})
				.catch(function (error) {
					$log.warn('Error while creating new group', error);
					throw new Error('Error creating new group');
				});
		}
        /**
         * Deletes the category with the given id.
         * @param {Number} id
         * @returns {Promise}
         */
		function deleteCategory(id) {
            return nuitApi('products.category', id)
                .delete()
                .then(function(response) {
						var categoryToDelete = getCategoryById(id);

                        if(categoryToDelete.parent) {
							var parent = getCategoryById(categoryToDelete.parent);
							var i = parent.children.indexOf(categoryToDelete);
                            var cat = parent.children.splice(i, 1);
							$rootScope.$broadcast(EVENTS.CategoryDeleted, {category: categoryToDelete});
                            return response;
                        } else {
                            var i = _categories.indexOf(categoryToDelete);
							_categories.splice(i, 1);
							$rootScope.$broadcast(EVENTS.CategoryDeleted, {category: categoryToDelete});
                        }
                    return response;
            });
		}
        /**
         * Returns a new flatified array of all categories.
         * Flatified means that all categories (including children)
         * are listed in the resulting array.
         * @return {Array}
         */
        function getFlatifiedCategories() {
            var result = [];
            var cat = null;
            var child = null;

			var flatify = function(categories, result) {
				for (var index in categories) {
					cat = categories[index];
					result.push(cat);
					if (cat.children) {
						flatify(cat.children, result);
					}
				}
			};

			flatify(_categories, result);

            return result;
        }
		/**
		 * Sends the given category to the API via a PUT call.
		 * @param category
         * @returns {Promise}
		 */
		function updateCategory(category) {
			return nuitApi('products.category',category.id)
                .put(category)
                .then(function(response) {
                    var cat = getCategoryById(response.data.id);
					var oldParent = cat.parent || null;
					var newParent = response.data.parent || null;
					var children = cat.children;
                    nuitUtils.clearObj(cat);
                    angular.merge(cat, response.data, {children: children});

                    if (oldParent !== newParent) {
                        detachCategory(cat, oldParent);
                        attachCategory(cat, newParent);
                    }

                    $rootScope.$broadcast(EVENTS.CategoryUpdated, { category: cat });
                    return cat;
            });
		}
        /**
         * Removes the given category node from its current location in the tree
         * (its parent's children, or the root list when it has no parent).
         * @param {Object} category
         * @param {Number} parentId - id of the category's current parent or null for root
         */
        function detachCategory(category, parentId) {
            var parent = parentId ? getCategoryById(parentId) : null;
            var container = parent ? parent.children : _categories;
            if (container) {
                var index = container.indexOf(category);
                if (index >= 0) { container.splice(index, 1); }
            }
        }
        /**
         * Inserts the given category node under its new parent (or the root list
         * when it has no parent).
         * @param {Object} category
         * @param {Number} parentId - id of the new parent or null for root
         */
        function attachCategory(category, parentId) {
            var parent = parentId ? getCategoryById(parentId) : null;
            if (parent) {
                if (!parent.children) { parent.children = []; }
                parent.children.push(category);
            } else {
                _categories.push(category);
            }
        }

		function moveCategory(category, oldParent) {

			return nuitApi('products.category',category.id)
				.put(category)
				.then(function(response) {
					var cat = getCategoryById(response.data.id);
					nuitUtils.clearObj(cat);

					return angular.merge(cat, response.data);
				});
		}

		/**
		 * Returns loaded product or if unknown loads product from remote server
		 * @param id
		 * @return {Promise} requested product
		 */
		function loadProduct(id) {
			return nuitApi('products.single', id)
                .get()
				.then(function (response) {
					var product = response.data;
					return product;
				});
		}
        /**
         * Adds the given product to the database.
         * @param {Object} product
         * @return {Promise}
         */
		function addProduct(product) {
			if(!product.description.hasOwnProperty(imsTranslation.language)){
				product.description[imsTranslation.language] = ' ';
			}

			normalizeEmptyAttributes(product);

			return nuitApi('products.list').post(product)
				.then(function (response) {
                    _products.push(response.data);
                    _pages = {};
				});
		}
        /**
         * Returns the translation key of the given price-rule type.
         * @param {String} type
         * @return {String}
         */
        function getRuleTypeKey(type) {
            for(var index in PRICE_RULE_TYPES) {
                if(PRICE_RULE_TYPES[index].value === type) {
                    return PRICE_RULE_TYPES[index].key;
                }
            }
            return '';
        }
        /**
         * Returns the symbol of the given pricemodifier.
         * @param {String} type
         * @return {String}
         */
        function getPriceModifierSymbol(type) {
            for(var index in PRICE_MODIFIER_TYPES) {
                if(PRICE_MODIFIER_TYPES[index].value === type) {
                    var symbol = PRICE_MODIFIER_TYPES[index].symbol;
                    if(symbol.indexOf('$') >= 0) { symbol = symbol.replace('$', nuitConfig.current.localization.currency.symbol); }
                    return symbol;
                }
            }
            return '';
        }
        /**
         * [PRIVATE METHOD]
         *
         * Applies the given price rule to the given product
         * and returns an Object representing the effect of the rule on the
         * given product.
         * @param {Object} product
         * @param {Object} rule
         * @param {Object} currentValue
         * @return {Object}
         */
        function applyPriceRule(product, rule, currentValue, material) {
            var result = Number.NaN;
            var perUnit = true;
            var success = false;

            if(!angular.isNumber(currentValue)) { currentValue = 0.0; }

			if(rule.priceModifierType === MATERIAL_ATTRIBUTE_BASE && material){
				result = material.basePrice + material.extraCharge;
			}else {
				switch (rule.type) {
					case 'attribute':
						var attr = getProductAttribute(product, rule.attributeId);
                    if(attr === null) { break; }

						result = _applyPriceCondition(rule, attr.value);
						break;
					case 'combination':
						var lhattr = getProductAttribute(product, rule.lhAttributeId);
						var rhattr = getProductAttribute(product, rule.rhAttributeId);
                    if(lhattr === null || rhattr === null) { break; }

						var value = _performOperation(lhattr.value, rule.combinationType, rhattr.value) || 0.0;

						result = _applyPriceCondition(rule, value);
						break;
					case 'productdata':
						switch (rule.property) {
                        case 'general.quantity': result = _applyPriceCondition(rule, product.quantity); perUnit = false; break;
                        case 'profile.material': result = _applyPriceCondition(rule,  product.data.profile.materialId); break;
							case 'profile.materialgroup':
								var mat = imsMaterials.getMaterialById(product.data.profile.materialId);
                            if(mat === null) { break; }
								result = _applyPriceCondition(rule, mat.rawMaterialId);
								break;
                        case 'profile.length': if(product.data.profile) { result = _applyPriceCondition(rule, product.data.profile.length); } break;
                        case 'profile.blank': result = _applyPriceCondition(rule, nuitProfiles.getBlank(product.data.profile)); break;
						}
						break;
				}
			}

            // Check success
            success = !isNaN(result);
            result = result || 0.0;

            // Apply limits
            if(angular.isNumber(rule.priceModifierMin)) { result = Math.max(rule.priceModifierMin, result); }
            if(angular.isNumber(rule.priceModifierMax)) { result = Math.min(rule.priceModifierMax, result); }

            // Apply price modifier
             if(rule.priceModifier === '-') { result *= -1.0; }
            switch(rule.priceModifierType) {
                case 'percent':
                    result *= currentValue * 0.01;
                    break;
            }

            return {
                value: result,
                perUnit: perUnit,
                modifier: rule.priceModifier,
                type: rule.priceModifierType,
                success: success
            };
        }

        /**
         * [PRIVATE METHOD]
         *
         * Performs the given operation on the two values.
         * Returns NaN if the operator is invalid or the result
         * of the calculation is NaN.
         *
         * @param {Number} lh_value
         * @param {String} operator
         * @param {Number} rh_value
         *
         * @return {Number|Number.NaN}
         */
        function _performOperation(lh_value, operator, rh_value) {
            switch(operator) {
                case '+': return lh_value + rh_value;
                case '-': return lh_value - rh_value;
                case '*':
                case 'x': return lh_value * rh_value;
                case '/': return lh_value / rh_value;
                case '%': return lh_value % rh_value;
                case '|': return (lh_value + rh_value) * 0.5;
                case '=': return rh_value;
            }
            return Number.NaN;
        }

        /**
         * [PRIVATE METHOD]
         *
         * Applies the given price condition to the supplied product value.
         * If the condition is met, the price modifier value will be returned.
         * Otherwise the return value is NaN.
         *
         * @param {Object} rule
         * @param {Any} productConditionValue
         * @return {Number.NaN|Number}
         */
        function _applyPriceCondition(rule, productConditionValue) {
            switch(rule.conditionType) {
                case 'if':
                case '=': if(rule.conditionValue === productConditionValue) { return rule.priceModifierValue; } break;
                case 'not':
                case '!=': if(rule.conditionValue !== productConditionValue) { return rule.priceModifierValue; } break;
                case 'if_multi': if(rule.conditionValue.indexOf(productConditionValue) >= 0) { return rule.priceModifierValue; } break;
                case 'not_multi': if(rule.conditionValue.indexOf(productConditionValue) < 0) { return rule.priceModifierValue; } break;
                case '>': if(productConditionValue > rule.conditionValue) { return rule.priceModifierValue; } break;
                case '>=': if(productConditionValue >= rule.conditionValue) { return rule.priceModifierValue; } break;
                case '<': if(productConditionValue < rule.conditionValue) { return rule.priceModifierValue; } break;
                case '<=': if(productConditionValue <= rule.conditionValue) { return rule.priceModifierValue; } break;
                case '/':
                case '$':
                    if(rule.conditionStart === undefined || productConditionValue >= rule.conditionStart) {
                        var val = productConditionValue;
                        if(rule.conditionStart !== undefined) { val -= rule.conditionStart; }

                        val /= rule.conditionValue;
                        if(rule.conditionType === '$') { val = Math.ceil(val); }

                        return rule.priceModifierValue * val;
                    }
                    break;
            }
            return Number.NaN;
        }

        /**
         * Calculates the price of the given product.
         *
         * @param {Object} product
         * @return {Number}
         */
        function getProductPrice(product) {
            var price = getExtendedProductPrice(product);
            if(price === null) { return 0.0; }
            return price.value;
        }

        /**
         * Calculates the price of the given product and
         * returns all rules affecting the price.
         *
         * @param {Object} product
         * @return {Object}
         */
        function getExtendedProductPrice(product, material) {
            if (!angular.isObject(product)) {
                return null;
            }

            var result = product.price;
            var extra = 0.0;
            var rules = [];
            var quantity = angular.isNumber(product.quantity) ? product.quantity : 1;

            var allRules = [];
            if (product.salesData !== undefined && angular.isArray(product.salesData.priceRules)) {
                for (var index in product.salesData.priceRules) {
                    allRules.push(product.salesData.priceRules[index]);
                }
            }
            for (var index in SalesService.priceRules) { allRules.push(SalesService.priceRules[index]); }

            for (var index in allRules) {
                try {
                    var rule = allRules[index];
                    var price = applyPriceRule(product, rule, result, material);

                    if (!price.success) {
                        continue;
                    }

                    if (price.modifier === '=') {
                        result = price.value;
                    } else if (price.perUnit) {
                        result += price.value;
                    } else {
                        extra += price.value * (price.type === 'percent' ? quantity : 1);
                    }

                    if (price.value !== 0.0) {
                        rules.push(rule);
                    }
                } catch (ex) {
                    console.log(ex);
                }
            }

            result *= quantity;
            result += extra;

            if(angular.isNumber(product.deliveryPrice)) { result += product.deliveryPrice; }
            if(!angular.isNumber(result)) { result = 0.0; }

            return { value: result, rules: rules };
        }

		/**
		 * Sends updated product to remote server
		 * @param product
		 */
		function updateProduct(product) {
			normalizeEmptyAttributes(product);

			return nuitApi('products.single', product.id)
                .put(product)
				.then(function (response) {
                    for(var i = 0;i < _products.length;i++) {
                        if(_products[i].id === product.id) {
                            for (var prop in _products[i]) { delete _products[i][prop]; }
                            angular.merge(_products[i], product);
                            break;
                        }
                    }
                    _pages = {};
				});
		}
		function normalizeEmptyAttributes(product) {
			EMPTY_AS_NULL_ATTRIBUTES.forEach(function (attribute) {
				if (angular.isString(product[attribute]) && product[attribute].trim() === '') {
					product[attribute] = null;
				}
			});
		}

        /**
         * Deletes the product with the given id
         * permanently.
         * @param {Object} product
         * @returns {Promise}
         */
        function deleteProduct(product) {
            return nuitApi('products.single', product.id)
                .delete()
                .then(function(response) {
                    for(var i = 0;i < _products.length;i++) {
                        if(_products[i].id === product.id) {
                            _products.splice(i, 1);
                            break;
                        }
                    }
                    _pages = {};
                    return product;
            });
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products')
		.factory('ProductQueryService', ProductQueryService);

	/** @ngInject */
	function ProductQueryService(nuitAuth, nuitConfig, ProductService, imsTranslation, $filter) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _config = nuitConfig.current;
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			getTitle: getTitle
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'useBackend', {
			get: function () {
				return _config.ims.products.backendQuery;
			}
		});

		/*
		 * Language for backend queries: the JWT user locale, since
		 * $translate.use() still returns the browser language on hard
		 * reload until the toolbar applies the user locale.
		 */
		Object.defineProperty(service, 'queryLanguage', {
			get: function () {
				return (nuitAuth.getUser() || {}).locale || imsTranslation.language;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		/**
		 * Reloads products. Delegates to the appropriate method
		 * based on whether backend query is enabled.
		 * @param {Object} filter
		 * @returns {Promise}
		 */
		function reload(filter) {
			if (!service.useBackend) {
				return ProductService.reloadProducts(filter);
			} else {
				// TODO (release after next): apply the user locale at boot
				// in a run block and drop the hardcoded setLanguage("en")
				// in toolbar.controller.js — then this override can go.
				filter = filter || {};
				filter.language = service.queryLanguage || filter.language;
				return ProductService.reloadPaged(filter);
			}
		}

		function getTitle(product) {
			return $filter('nuitTranslate')(product.name);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products')
		.factory('ProductAttributes', factory);

	/** @ngInject */
	function factory(nuitApi, nuitUtils) {
		//*******************************************
		// VARIABLES
		//*******************************************
        /**
         * Contains all product attributes of the current environment.
         * @type Array
         */
        var _attributes = [];
        //*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
            add: add,
            delete: _delete,
            update: update,
            getById: getById,
            getByType: getByType,
            reload: reload,
            isNumeric: isNumeric,
            toggleVisibility: toggleVisibility
		};
        //*******************************************

        //*******************************************
        // PROPERTIES
        //*******************************************
        Object.defineProperty(service, 'all', { get: function() { return _attributes; } });
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************        
        function reload() {
            return nuitApi('product.attributes')
                .get()
                .then(function(response) {
                    _attributes.splice(0, _attributes.length);
                    angular.merge(_attributes, response.data);
            });
        }
        
        function isNumeric(attribute) {
            switch(attribute.type) {
                case 'number':
                case 'length':
                        return true;
            }
            return false;
        }
        
        function getByType(type) {
            var result = [];
            for(var index in _attributes) {
                if(_attributes[index].type === type) {
                    result.push(_attributes[index]);
                }
            }
            return result;
        }
        
        function getById(id) {
            for(var index in _attributes) {
                if(_attributes[index].id === id) {
                    return _attributes[index];
                }
            }
            return null;
        }
        
        function add(attribute) {
            return nuitApi('product.attributes')
                .post(attribute)
                .then(function (response) {
                    _attributes.push(response.data);
                });
        }
        
        function update(attribute) {
            return nuitApi('product.attribute', attribute.id)
                .put(attribute)
                .then(function (response) {
                    var newAttr = response.data;
                    var attr = getById(newAttr.id);
                    
                    nuitUtils.clearObj(attr);
                    angular.merge(attr, newAttr);
                });
        }
        
        function _delete(attributeId) {
            if(angular.isObject(attributeId)) { attributeId = attributeId.id; }
            return nuitApi('product.attribute', attributeId)
                .delete()
                .then(function(response) {
                    for(var index in _attributes) {
                        if(_attributes[index].id === attributeId) {
                            _attributes.splice(index, 1);
                            break;
                        }
                    }
            });
        }
        
        function toggleVisibility(attribute) {
            var oldValue = attribute.restrictions.hidden;
            attribute.restrictions.hidden = !attribute.restrictions.hidden;

            return update(attribute).catch(function () {
                attribute.restrictions.hidden = oldValue;
            });
        }
	}
}());
(function () {
	'use strict';

	angular
		.module('app.products')
		.factory('MaterialSelectionService', MaterialSelectionService);

	/** @ngInject */
	function MaterialSelectionService(imsUtils, nuitDataService, imsMaterials) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			add: add,
			remove: remove,
			refreshMaterialsForView: refreshMaterialsForView
		};
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS (Public)
		//*******************************************
		function add(profileMaterials, materialsForView, multipleMaterials, selectedGroups){
			imsUtils.showMaterialDialogWithPreselect(multipleMaterials, profileMaterials, selectedGroups).then(
				function(materials){
					if(angular.isArray(materials)) {
						var ids = materials.map(function(material){return material.id;});
						nuitDataService.replaceAll(
							profileMaterials,
							ids
						);
					}
					else if(angular.isDefined(materials)) {
						nuitDataService.replaceAll(profileMaterials,[materials.id]);
					}

					refreshMaterialsForView(profileMaterials,materialsForView);
				}
			);
		}

		function refreshMaterialsForView(profileMaterials,materialsForView)
		{
			nuitDataService.replaceAll(materialsForView,[]);

			for(var i=0;i<profileMaterials.length;i++){
				var material = imsMaterials.getMaterialById(profileMaterials[i]);

				if(material!==null) {
					materialsForView.push(material);
				}
			}
		}

		function remove(profileMaterials, materialsForView, index){
			profileMaterials.splice(index,1);
			materialsForView.splice(index,1);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products')
		.factory('AttachmentService', AttachmentService);

	/** @ngInject */
	function AttachmentService(imsUtils, nuitAuth) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			add: add,
			remove: remove,
			getUrl: getUrl
		};
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS (Public)
		//*******************************************
		function add(product) {
			if(!angular.isArray(product.attachments)) {
				product.attachments = [];
			}
			imsUtils.uploadProductAttachment()
				.then(function(url)
				{
					var parts = url.split('.');

					product.attachments.push({
						link: url,
						type: parts[parts.length-1],
						name: {}
					});
				});
		}

		function remove(product,index) {
            if(!angular.isArray(product.attachments)) {
				product.attachments = [];
			}
			product.attachments.splice(index,1);
		}

		function getUrl(attachment)
		{
			return attachment + '?access-token=' + nuitAuth.getToken();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products')
		.controller('ProductsController', ProductsController);

	/** @ngInject */
	function ProductsController($scope, $state, $filter, $mdSidenav, $mdDialog, nuitUtils, ProductService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.categories = [];
		vm.categoriesEditMode = false;
		vm.categoriesLoading = true;
		vm.selectedCategory = null;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.addCategory = addCategory;
		vm.deleteCategory = deleteCategory;
		vm.editCategory = editCategory;
		vm.moveCategory = moveCategory;
        vm.toggleDropdownOrEditGroup = toggleDropdownOrEditGroup;
		vm.toggleEditing = toggleEditing;
		vm.toggleSidenav = toggleSidenav;
		vm.refreshCategories = refreshCategories;
		vm.treeOptions = createTreeOptions();
		vm.showSelected = function(node){$state.go('app.products', {category:node?node.id:undefined});};
		vm.orderTree = orderTree;
		vm.$state = $state;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on(ProductService.EVENTS.CategoryAdded, vm.refreshCategories);
		$scope.$on(ProductService.EVENTS.CategoryDeleted, vm.refreshCategories);
		$scope.$on(ProductService.EVENTS.CategoryUpdated, vm.refreshCategories);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
        /**
		 * Creates a category edit dialog. Can be used for creating a category too.
		 * @param {Object} initialValue - category to edit or null/undefined for new
		 * @returns {Dialog}
		 */
		function showCategoryEditDialog(initialValue,parentCategoryId) {
			return $mdDialog.show({
				controller: 'CategoryDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/merchandising.products/dialogs/category/category.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				multiple: true,
				locals: {
					Category: (initialValue === undefined ? undefined : angular.copy(initialValue)),
					ParentCategoryId: parentCategoryId
				}
			});
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			ProductService.reloadCategories().then(function () {
				vm.categories = $filter('nuitTranslatedTreeSort')(ProductService.categories);
				vm.categoriesLoading = false;
				if($state.params.category) {
					vm.selectedCategory = ProductService.getFlatifiedCategories().find(function (item) { return item.id===parseInt($state.params.category);});
				}
			});
		}

		/**
		 * Opens the add category dialog and
		 * adds a new product category to the system
		 * on success.
		 */
		function addCategory(parentCategory) {
			showCategoryEditDialog(undefined, parentCategory ? parentCategory.id : undefined)
				.then(function (result) {
					return ProductService.addCategory(result);
				})
                .then(function (result) {
                })
				.catch(function (rejection) {
					if (rejection) {
                        nuitUtils.showErrorToast();
					}
				});
		}

		/**
		 * Deletes the given category.
		 * @param {Category} category - category which should be deleted
		 * @param {Object} $event - event data
		 */
		function deleteCategory(category, $event) {
			$event.stopPropagation();
			$event.preventDefault();

            nuitUtils
                .showDeleteConfirmation('CATEGORY.DELETE')
				.then(function () {
					return ProductService.deleteCategory(category.id);
				})
				.then(nuitUtils.showSuccessToast)
				.catch(function (rejection) {
					if (rejection) {
                        nuitUtils.showErrorToast();
					}
				});
		}

        /**
         * Opens a dialog which allows to edit the given category.
         * Submits it to the api afterwards.
         * @param {Object} category
         * @param {Object} $event
         */
		function editCategory(category, $event) {
			if($event) { $event.preventDefault(); }

			showCategoryEditDialog(category)
				.then(function (result) {
                    return ProductService.updateCategory(result);
				})
				.then(function (response) {
                    nuitUtils.showSuccessToast();
				})
				.catch(function (rejection) {
					if (rejection) {
                        nuitUtils.showErrorToast();
					}
				});
		}

		function moveCategory(category, $event) {
			$event.stopPropagation();

			var dialog = {
				controller: 'SelectParentCategory',
				controllerAs: 'vm',
				templateUrl: 'app/main/merchandising.products/dialogs/select-parent-category/select-parent-category.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: false,
				autoWrap: false,
				multiple: true,
				locals: {
					Categories: vm.categories,
					ParentCategoryId: category.parent
				}
			};

			return $mdDialog.show(dialog)
				.then(function (selected) {
					var oldParent = category.parent;
					category.parent = selected?selected.id:null;
					return ProductService.moveCategory(category, oldParent);
				});
		}

		/**
		 * Toggles the category editing mode.
		 */
		function toggleEditing() {
			vm.categoriesEditMode = !vm.categoriesEditMode;
		}

		/**
		 * Toggles the side navigation on or off.
		 * @param {Number} sidenavId - id of the sidenav to toggle
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}

        /**
         * Called when clicking on a category.
         * If the sidenav is currently in edit mode then
         * the edit category dialog will open, otherwise
         * the category will either show or hide all children.
         * @param {Object} category
         * @param {Object} $event
         */
		function toggleDropdownOrEditGroup(category, $event) {
            $event.stopPropagation();
			if (vm.categoriesEditMode) {
				vm.editCategory(category, $event);
			} else {
				category._open = !category._open;
			}
		}

		function refreshCategories() {
			vm.categories = $filter('nuitTranslatedTreeSort')(ProductService.categories);
		}

		function createTreeOptions() {
			return {
				nodeChildren: 'children',
				dirSelectable: true,
				injectClasses: {
					ul: 'a1',
					li: 'a2',
					liSelected: 'a7',
					iExpanded: 'a3',
					iCollapsed: 'a4',
					iLeaf: 'a5',
					label: 'a6',
					labelSelected: 'a8'
				},
				allowDeselect: false,
				orderBy: ' | orderByTranslated:"name"'
			};
		}

		function orderTree(entity){
			if(vm.config.ims.profiles.sortByName) {
				return $filter('nuitTranslate')(entity.name, '???');
			}else{
				return entity.position;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products')
		.controller('ProductListController', ProductListController);

	/** @ngInject */
	function ProductListController($rootScope, $state, $scope, $translate, $filter, $q, $timeout, $log, DotNotationService, ProductService, ProductQueryService, imsTranslation, ListSelectionService, imsMaterials, nuitUtils, FavoriteService, nuitConfig, nuitProfiles) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// CONSTANTS
		//*******************************************
		// Attributes removed from a product before its copy is saved (dot notation
		// supported, e.g. 'customData.foo') - add anything that must stay unique.
		var COPY_EXCLUDED_ATTRIBUTES = ['id', 'externalId'];

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.currentPage = $state.params.page ? parseInt($state.params.page) || 0 : 0;
		vm.pagesLoading = {};
		vm.currentPageEntities = [];
		vm.selection = ListSelectionService.get('merchandising.products', true);
		vm.isLoading = true;
		vm.meta = ProductService.meta;
		vm.term = angular.isDefined($state.params.term) ? $state.params.term : '';
		vm.products = ProductService.products;
		vm.materials = imsMaterials.materials;
		vm.allowAdd = nuitConfig.current.ims.products.list.allowAdd;
		vm.lang = nuitConfig.current.languages;
		vm.isConical = nuitProfiles.isConical;
		vm.hasCuts = nuitProfiles.hasCuts;
		vm.hasStamps = nuitProfiles.hasStamps;
		vm.getPunchCount = nuitProfiles.getPunchCount;
		vm.config = nuitConfig.current;
		vm.selectedCategory = $state.params.category?parseInt($state.params.category):undefined;
		// Seed prev with the same parsed form so the first onStateChangeSuccess
		// doesn't spuriously detect a "category change" and fire a duplicate load.
		vm.prevSelectedCategory = vm.selectedCategory;
		vm.unregisterConfigListener = null;
		// Language the loaded pages were queried with.
		var loadedQueryLanguage = ProductQueryService.queryLanguage;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.deselectAll = vm.selection.deselectAll;
		vm.deleteSelected = deleteSelected;
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.openProduct = openProduct;
		vm.search = search;
		vm.toggleSelectProduct = vm.selection.toggleSelectedEntity;
		vm.toggleSelectedProducts = toggleSelectedProducts;
		vm.isIndeterminate = vm.selection.isIndeterminate;
		vm.toggleSidenav = $scope.$parent.vm.toggleSidenav;
		vm.filterProduct = filterProduct;
		vm.getMaterialById = imsMaterials.getMaterialById;
		vm.copySelected = copySelected;
		vm.getName = function (product) {
			if (!product || product._placeholder) { return ''; }
			return ProductQueryService.getTitle(product);
		};
		vm.loadPage = function (data) {
			if (!ProductQueryService.useBackend) { return; }

			// Gate every entry point on $translate.onReady so filter.language
			// is always defined before we hit the server — otherwise the
			// server sorts by its default locale on hard reload.
			$translate.onReady().then(function () {
				var target = data.page + 1;
				if (ProductService.isPageLoaded(target)) {
					filterProducts();
					vm.isLoading = false;
					prefetchNeighbors(target);
					return;
				}

				return reloadProducts({page: target})
					.then(function () {
						prefetchNeighbors(target);
					});
			}).catch(function (err) {
				// reloadProducts already surfaced user-facing errors; this
				// terminal catch prevents unhandled rejections from reaching
				// $exceptionHandler and guarantees the spinner is cleared
				// even if the fast-path throws synchronously.
				$log.error('loadPage failed', err);
				vm.isLoading = false;
			});
		};
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		$scope.$watch('vm.currentPage', onCurrentPageChanged);
		// angular-translate $emits on $rootScope.
		var unregisterTranslateListener = $rootScope.$on('$translateChangeSuccess', onTranslateChangeSuccess);
		$scope.$on('$destroy', unregisterTranslateListener);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			if (nuitConfig.isReady()) {
				delayedInit();
			} else {
				vm.unregisterConfigListener = $rootScope.$on('config::config.loaded', delayedInit);
			}

			imsMaterials.reload();
		}

		function delayedInit() {
			if (ProductQueryService.useBackend) {
				ProductService.clear();
				vm.loadPage({page: vm.currentPage});
			} else {
				ProductService
					.reloadProducts()
					.then(filterProducts)
					.catch(function (err) {
						$log.error('initial reloadProducts failed', err);
						nuitUtils.showErrorToast();
					})
					.finally(function () {
						vm.isLoading = false;
					});
			}

			if (vm.unregisterConfigListener !== null) {
				vm.unregisterConfigListener();
			}
		}

		/**
		 * Reloads products from the backend with the given filter override.
		 * Concurrent callers for the same page share the in-flight promise so
		 * they observe the same resolution or rejection.
		 * @param {Object} [override] { page?: number, isPrefetch?: boolean }
		 * @returns {Promise}
		 */
		function reloadProducts(override) {
			if (!ProductQueryService.useBackend) {
				return ProductService.reloadProducts()
					.then(filterProducts)
					.catch(function (err) {
						$log.error('reloadProducts failed', err);
						nuitUtils.showErrorToast();
					})
					.finally(function () {
						vm.isLoading = false;
					});
			}

			var filter = {};
			filter.page = (override && override.page) ? override.page : (parseInt(vm.currentPage) + 1);
			filter.sort_by = '-favorite,name';
			filter.language = imsTranslation.language;

			if (vm.term && vm.term.length > 0) {
				filter.name = vm.term;
			}

			if (vm.selectedCategory) {
				filter.categoryId = vm.selectedCategory;
			}

			if (vm.pagesLoading[filter.page]) {
				return vm.pagesLoading[filter.page];
			}

			var isPrefetch = !!(override && override.isPrefetch);

			var promise = ProductQueryService.reload(filter)
				.then(filterProducts)
				.catch(function (err) {
					$log.error('reloadProducts failed (page ' + filter.page + ')', err);
					if (!isPrefetch) {
						nuitUtils.showErrorToast();
					}
					return $q.reject(err);
				})
				.finally(function () {
					vm.isLoading = false;
					delete vm.pagesLoading[filter.page];
				});

			vm.pagesLoading[filter.page] = promise;
			return promise;
		}

		/**
		 * Prefetches the next and previous pages around the target so page
		 * navigation feels instant. Failures are swallowed (logged by the
		 * callee) — a failed prefetch must not toast or block the user.
		 */
		function prefetchNeighbors(target) {
			var next = target + 1;
			var prev = target - 1;

			if (vm.meta.pagination.total_pages >= next && !ProductService.isPageLoaded(next)) {
				reloadProducts({page: next, isPrefetch: true}).catch(angular.noop);
			}
			if (prev >= 1 && !ProductService.isPageLoaded(prev)) {
				reloadProducts({page: prev, isPrefetch: true}).catch(angular.noop);
			}
		}

		/**
		 * Opens the product in a separate state for editing.
		 * @param {Object} product
		 */
		function openProduct(product) {
			if (!product || product._placeholder) { return; }
			$state.go('app.products.detail', {
				itemId: product.id,
				active: 'general',
				externalId: product.externalId,
				index: vm.products_from,
				term: vm.term,
				category: vm.selectedCategory,
				page: vm.currentPage
			}, {inherit: false});
		}

		/**
		 * Deletes all selected products.
		 */
		function deleteSelected() {
			var promise;
			if (vm.getSelected().length > 1) {
				promise = nuitUtils.showDeleteMultiConfirm();
			} else if (vm.getSelected().length === 1) {
				promise = nuitUtils.showDeleteConfirmation();
			} else {
				return;
			}

			promise.then(function () {
				var promises = [];
				angular.forEach(vm.getSelected(), function (product) {
					var deletePromise = ProductService.deleteProduct(product)
						.then(function () {
							// In local mode rebuild the filtered list per delete;
							// in backend mode _products is a sparse rebuilt array
							// and the in-place splice inside deleteProduct corrupts
							// slot positions, so we clear+reload after all deletes.
							if (!ProductQueryService.useBackend) {
								filterProducts();
							}
						});
					promises.push(deletePromise);
				});
				vm.deselectAll();
				$q.all(promises)
					.then(function () {
						if (ProductQueryService.useBackend) {
							ProductService.clear();
							vm.loadPage({page: vm.currentPage});
						}
						nuitUtils.showSuccessToast();
					})
					.catch(nuitUtils.showErrorToast);
			});
		}


		function copySelected() {
			var prod = angular.copy(vm.getSelected()[0]);

			COPY_EXCLUDED_ATTRIBUTES.forEach(function (attribute) {
				DotNotationService.remove(prod, attribute);
			});

			imsTranslation
				.getTranslationsOfKey('APP.DUPLICATE')
				.then(function (translations) {
					for (var l in vm.lang) {
						var currentLang = vm.lang[l];
						if (DotNotationService.hasKey(prod.name, currentLang) && DotNotationService.hasKey(translations, currentLang)) {
							prod.name[currentLang] = prod.name[currentLang] + ' _' + translations[currentLang];
						}
					}

					ProductService
						.addProduct(prod)
						.then(function () {
							if (ProductQueryService.useBackend) {
								ProductService.clear();
								vm.loadPage({page: vm.currentPage});
								nuitUtils.showSuccessToast();
								vm.deselectAll();
							} else {
								ProductService
									.reloadProducts()
									.then(function () {
										$timeout(function () {
											filterProducts();
											nuitUtils.showSuccessToast();
											vm.deselectAll();
										}, 200);
									}).catch(nuitUtils.showErrorToast);
							}
						}).catch(nuitUtils.showErrorToast);
				});
		}

		/**
		 * Performs a search operation.
		 * Uses backend query when enabled, otherwise filters locally.
		 */
		function search() {
			if (ProductQueryService.useBackend) {
				vm.currentPage = 0;
				ProductService.clear();
				$state.go('app.products', {term: vm.term, page: vm.currentPage, category: vm.selectedCategory});
				vm.loadPage({page: vm.currentPage});
			} else {
				$state.go('app.products', {term: vm.term, index: undefined});
				filterProducts();
			}
		}

		/**
		 * Filters all products based on the selected category and search term.
		 */
		function filterProducts() {
			if (ProductQueryService.useBackend) {
				// Backend mode: selection tracks entity references, and _pages
				// holds stable refs across rebuilds, so selection persists
				// naturally across page loads and prefetches.
				vm.filteredEntities = vm.products.slice();
			} else {
				var filtered = [];
				for (var i in vm.products) {
					if (filterProduct(vm.products[i])) {
						filtered.push(vm.products[i]);
					}
				}
				vm.filteredEntities = FavoriteService.sort($filter('orderByNuitTranslated')(filtered, 'name'));
				vm.deselectAll();
			}
		}

		/**
		 * Performs a filter operation on a single product and returns true if the product
		 * matches all filter parameters.
		 * @param {Product} product
		 * @return {Boolean} True, if product matches filter
		 */
		function filterProduct(product) {
			if (!product || product._placeholder) { return true; }
			return (vm.selectedCategory === undefined || ProductService.isProductInCategoryId(product, vm.selectedCategory))
				&& (vm.term === '' || (product.name[imsTranslation.language] && product.name[imsTranslation.language].toLowerCase().includes(vm.term.toLowerCase())));
		}


		/**
		 * Toggles the selection of all selected products
		 * between selecting all products of the current page
		 * and no products.
		 */
		function toggleSelectedProducts() {
			var real = [];
			for (var i = 0; i < vm.currentPageEntities.length; i++) {
				var p = vm.currentPageEntities[i];
				if (p && !p._placeholder) { real.push(p); }
			}
			vm.selection.toggleSelectedEntities(real);
		}

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Reloads the list when the backend query language changed —
		 * loaded pages keep the sort order they were queried with.
		 */
		function onTranslateChangeSuccess() {
			if (!ProductQueryService.useBackend) { return; }

			var language = ProductQueryService.queryLanguage;
			if (language === loadedQueryLanguage) { return; }

			loadedQueryLanguage = language;
			vm.isLoading = true;
			vm.pagesLoading = {};
			ProductService.clear();
			vm.loadPage({page: vm.currentPage});
		}

		/**
		 * Mirrors the current page into the URL so a reload restores it.
		 * reloadOnSearch: false keeps the controller alive.
		 */
		function onCurrentPageChanged(newPage, oldPage) {
			if (newPage === oldPage) { return; }

			var urlPage = $state.params.page ? parseInt($state.params.page) || 0 : 0;
			if (urlPage !== newPage) {
				$state.go('app.products', {page: newPage});
			}
		}

		/**
		 * This event is fired whenever the state changes
		 * @param fromState
		 * @param toState
		 */
		function onStateChangeSuccess(fromState, toState) {
			vm.term = $state.params.term || '';

			var nextPage = $state.params.page ? parseInt($state.params.page) || 0 : 0;
			var pageChanged = nextPage !== vm.currentPage;
			vm.currentPage = nextPage;

			if (ProductQueryService.useBackend) {
				var nextCategory = $state.params.category ? parseInt($state.params.category) : undefined;
				var categoryChanged = nextCategory !== vm.prevSelectedCategory;
				vm.selectedCategory = nextCategory;

				if (categoryChanged) {
					vm.prevSelectedCategory = nextCategory;
					vm.currentPage = 0;
					ProductService.clear();
					vm.loadPage({page: vm.currentPage});
				} else if (pageChanged) {
					// Page changed via URL (back/forward, deep link).
					vm.loadPage({page: vm.currentPage});
				}
			} else {
				vm.selectedCategory = $state.params.category;

				if ($state.params.category !== vm.prevSelectedCategory) {
					filterProducts();
					vm.prevSelectedCategory = $state.params.category;
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products')
		.controller('ProductDetailsController', productDetailsController);

	/** @ngInject */
	function productDetailsController($controller, $log, $state, $scope, ProductService, nuitDataService, imsUtils, nuitApi, MaterialSelectionService, ProfileImageService, CompanyService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
        $controller('ProductDetailBaseController', { parentVM: vm, $scope: $scope });
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.itemId = $state.params.itemId;
		vm.currentProduct = {};
		vm.isLoading = true;
		vm.favorites = vm.config.ims.products.favorites;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.updateProduct = updateProduct;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			vm.reload();

			if (angular.isDefined(vm.externalId) && vm.config.ims.products.externalAPI.enabled) {
				var apiConfig = vm.config.ims.products.externalAPI;
				nuitApi.resolve(apiConfig.retrieveURL, $state.params.externalId)
					.get()
					.then(function (response) {
						return response.data;
					})
					.then(finalizeProduct)
					.catch(onError);
			} else {
				ProductService
                    .loadProduct(vm.itemId)
					.then(finalizeProduct)
					.catch(onError);
			}
		}

        function onError(response) {
            $log.warn(response);
            imsUtils.showErrorToast();
            $state.go('app.products');
        }

		function finalizeProduct(product) {
			vm.currentProduct = product;

			if(vm.currentProduct.companies){
				vm.currentProduct.companies.forEach(function(companyId){
					CompanyService.getById(companyId)
						.then(function(company){
							vm.selectedCompanies.push(company);
						});
				});
			}

            if(vm.currentProduct.data === undefined) { vm.currentProduct.data = {}; }
			vm.isLoading = false;

			if (product.name === '' || product.name === null) {
                vm.currentProduct.name = {};
				vm.currentProduct.name[vm.selectedLanguage] = vm.currentProduct.externalData[vm.config.ims.products.externalAPI.remoteAttributesRoot][vm.config.ims.products.externalAPI.nameProp];
			}
			if (vm.currentProduct.type === 'profile') {
				nuitDataService.replaceAll(vm.profileMaterials,vm.currentProduct.data.materials);
				MaterialSelectionService.refreshMaterialsForView(vm.profileMaterials,vm.materialsForView);
				ProfileImageService.update(vm,vm.currentProduct.data.profile);

				vm.profileGroups = vm.currentProduct.data.groups;
				if (!angular.isArray(vm.profileGroups)) {
					vm.profileGroups = [];
				}
                if (vm.currentProduct.data !== undefined && vm.currentProduct.data.length) {
                    if (vm.currentProduct.data.length.value) {
                        vm.profileLength = vm.currentProduct.data.length.value;
                        vm.profileLengthFixed = true;
                    } else {
                        vm.profileLengthMin = vm.currentProduct.data.length.min;
                        vm.profileLengthMax = vm.currentProduct.data.length.max;
                    }
                }
			}
            if(!angular.isObject(vm.currentProduct.salesData) || angular.isArray(vm.currentProduct.salesData)) {
                vm.currentProduct.salesData = {};
            }
			if (vm.config.ims.products.externalAPI.enabled) {
				vm.updateConditionals();
			}
		}

		function updateProduct() {
            if(vm.currentProduct.data === undefined) { vm.currentProduct.data = {}; }

			if (vm.currentProduct.data.profile) {
				vm.currentProduct.type = 'profile';
				vm.currentProduct.data.materials = vm.profileMaterials;
				if (!angular.isArray(vm.currentProduct.data.materials)) {
					vm.currentProduct.data.materials = [vm.currentProduct.data.materials];
				}
				vm.currentProduct.data.groups = vm.profileGroups;
				vm.currentProduct.data.length = {};
				if (vm.profileLengthFixed) {
					vm.currentProduct.data.length.value = vm.profileLength;
				} else {
					vm.currentProduct.data.length.min = vm.profileLengthMin;
					vm.currentProduct.data.length.max = vm.profileLengthMax;
				}
			} else {
                vm.currentProduct.type = null;
                vm.currentProduct.data = {};
            }

			if (!angular.isDefined(vm.externalId) || !vm.config.ims.products.externalAPI.enabled) {
				ProductService
                    .updateProduct(vm.currentProduct)
                    .then(vm.backToList);
			} else {
				vm.currentProduct.externalId = vm.externalId;
				nuitApi
                    .resolve(vm.config.ims.products.externalAPI.updateURL, $state.params.externalId)
                    .put(vm.currentProduct)
                    .then(vm.backToList);
			}
		}
	}
}());

(function () {
    'use strict';

    angular
        .module('app.products')
        .controller('ProductDetailBaseController', controller);

    function controller(parentVM, $filter, $rootScope, $scope, $state, nuitDataService, CompanyService, ProductService, ProductAttributes, SalesService, imsMaterials, imsTranslation, imsUtils, imsColors, nuitUtils, nuitUnits, nuitConfig, AttachmentService, MaterialSelectionService, ProfileImageService, nuitProfiles) {

    	//*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = parentVM;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        vm.$state = $state;
        vm.nuitUnits = nuitUnits;
        vm.externalId = $state.params.externalId;
        vm.config = nuitConfig.current;
        vm.translation = imsTranslation;
		vm.attributes = ProductAttributes.all;
		vm.categories = ProductService.categories;
        vm.tags = ProductService.tags;
		vm.groups = imsMaterials.groups;
		vm.materials = imsMaterials.materials;
        vm.colors = imsColors.colors;
		vm.attributeMaterials = [];
		vm.attributeColors = [];
		vm.profileGroups = [];
		vm.profileMaterials = [];
		vm.materialsForView = [];
		vm.effectors = [];
        vm.globalRules = SalesService.priceRules;
        vm.priceRuleTypes = ProductService.priceRuleTypes;
		vm.materialAttributeBase = ProductService.materialAttributeBase;
		vm.priceModifiers = ProductService.priceModifiers;
        vm.priceModifierTypes = ProductService.priceModifierTypes;
        vm.numericCombinators = ProductService.numericCombinators;
        vm.productProperties = ProductService.productProperties;
        vm.booleanComparators = ProductService.booleanComparators;
        vm.numericComparators = ProductService.numericComparators;
        vm.selectedLanguage = imsTranslation.language;
        vm.currentTab = $state.params.active;
        vm.salesRule = {};
        vm.companiesLoaded = false;
        vm.currentCompanyId = null;
        vm.searchText = "";
        vm.companies = [];
        vm.selectedCompanies = [];
        //*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        vm.toggleSidenav = $scope.$parent.vm.toggleSidenav;

        vm.getColorById = imsColors.getColorById;
        vm.getMaterialById = imsMaterials.getMaterialById;
        vm.reloadMaterials = imsMaterials.reload;
        vm.reloadGroups = imsMaterials.reloadGroups;

        vm.addAttachment = addAttachment;
        vm.getUrl = AttachmentService.getUrl;

		vm.openImage = imsUtils.openImage;
		vm.setProfileImage = ProfileImageService.set;

        vm.addAttribute = addAttribute;
        vm.hasAttribute = ProductService.hasAttribute;
        vm.getAttributeById = ProductAttributes.getById;
        vm.getTranslationKeyOfType = ProductService.getTranslationKeyOfType;
        vm.filterColorsForAttribute = filterColorsForAttribute;
        vm.removeAttribute = removeAttribute;
        vm.removeAttachment = removeAttachment;

        // Pricerules
        vm.createPriceRule = createPriceRule;
        vm.isRuleValid = isRuleValid;
        vm.showRuleLimitations = showRuleLimitations;
        vm.showRulePriceModifier = showRulePriceModifier;
        vm.showNumberCondition = showNumberCondition;
        vm.showLengthCondition = showLengthCondition;
        vm.showAreaCondition = showAreaCondition;
        vm.showColorCondition = showColorCondition;
        vm.showMaterialCondition = showMaterialCondition;
        vm.showMaterialGroupCondition = showMaterialGroupCondition;
        vm.getRuleConditionDisplayValue = getRuleConditionDisplayValue;
        vm.getRuleComparatorType = getRuleComparatorType;
        vm.getProductTestPrice = getProductTestPrice;
        vm.reloadEnumSelection = reloadEnumSelection;
        vm.ruleTypeToKey = ProductService.getRuleTypeKey;
        vm.getComparatorKey = getComparatorKey;
        vm.priceModifierTypeToSymbol = ProductService.getPriceModifierSymbol;
        vm.getProductPropertyKey = ProductService.getProductPropertyKey;
        vm.movePriceRule = movePriceRule;
        vm.editPriceRule = editPriceRule;
        vm.deletePriceRule = deletePriceRule;
        vm.resetRule = resetRule;

        vm.openEditor = openEditor;
        vm.isRule = isRule;
        vm.applyEffector = applyEffector;
        vm.reload = reload;
        vm.backToList = backToList;
        vm.refreshCategories = refreshCategories;
        vm.reloadAttributeMaterials = reloadAttributeMaterials;
        vm.reloadAttributeColors = reloadAttributeColors;
        vm.addMaterials = addMaterials;
        vm.removeMaterial = removeMaterial;
        vm.addDetail = addDetail;
        vm.removeDetail = removeDetail;
        vm.uploadImage = uploadImage;
        vm.updateConditionals = updateConditionals;
        vm.finalizeProduct = finalizeProduct;
        vm.canSubmit = canSubmit;
        vm.supportsLengthRange = nuitProfiles.supportsPositions;
        vm.getSegmentCount = nuitProfiles.getSegmentCount;
        vm.reloadCompanies = reloadCompanies;
        vm.selectCompany = selectCompany;
        vm.removeCompany = removeCompany;
		vm.getProfileTestMaterials = getProfileTestMaterials;
		vm.$onDestroy = onDestroy;
		vm.moveElement = function(index, step, array){
			var copy = angular.copy(array[index]);
			array[index] = angular.copy(array[index+step]);
			array[index+step] = copy;
			vm.itemForm.$setDirty();
		};
        //*******************************************

        //*******************************************
        // EVENTS
        //*******************************************
        $scope.$on(ProductService.EVENTS.CategoriesReloaded, vm.refreshCategories);
        $scope.$on(ProductService.EVENTS.CategoryAdded, vm.refreshCategories);
        $scope.$on(ProductService.EVENTS.CategoryDeleted, vm.refreshCategories);
		var unregisterSelectedLanguage = $rootScope.$on('$translateChangeSuccess', onTranslateChangeSuccess);
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // METHODS
        //*******************************************

		function onTranslateChangeSuccess(){
			vm.selectedLanguage = imsTranslation.language;
		}

		function onDestroy(){
			unregisterSelectedLanguage();
		}

        function reload() {
            ProductService.reloadCategories().then(vm.refreshCategories);
            ProductService.reloadTags();
            ProductAttributes.reload();

            imsMaterials.reload()
                .then(function () {
                    MaterialSelectionService.refreshMaterialsForView(vm.profileMaterials, vm.materialsForView);
                });

            imsMaterials.reloadGroups();

            imsColors.reloadColors();

            SalesService.reload();
        }

        function reloadCompanies(){
			if(vm.config.ims.companies.enabled && !vm.companiesLoaded){
				CompanyService.reload()
					.then(function(companies){
						vm.companiesLoaded = true;
						vm.companies = companies;
						//$scope.$broadcast('$md-resize');
					});
			}
		}

		function selectCompany(){
			if(!vm.currentProduct.companies){
				vm.currentProduct.companies = [];
			}

			if(vm.currentProduct.companies.indexOf(vm.currentCompanyId)===-1) {
				var company = CompanyService.getByIdOffline(vm.currentCompanyId);

				vm.currentProduct.companies.push(company.id);
				vm.selectedCompanies.push(company);
				vm.currentCompanyId = null;
				vm.itemForm.$setDirty();
			}
		}

		function removeCompany(index){
			vm.selectedCompanies.splice(index,1);
			vm.currentProduct.companies.splice(index,1);
			vm.itemForm.$setDirty();
		}

        /**
         * Returns true if the current product is valid for submition to the api.
         * @return {Boolean}
         */
        function canSubmit() {
            return (!vm.config.ims.products.profiles.required || vm.currentProduct.data.profile !== undefined);
        }

        function addAttachment(product) {
            AttachmentService.add(product);
            vm.itemForm.$setDirty();
        }

        function refreshCategories() {
            vm.categories = ProductService.getFlatifiedCategories();
        }

        function backToList() {
            $state.go('app.products');
        }

        function addMaterials() {
            MaterialSelectionService.add(vm.profileMaterials, vm.materialsForView, !isRule('PROFILE_MATERIAL_SINGLE'), vm.profileGroups);
            vm.itemForm.$setDirty();
        }

        function removeMaterial(index) {
            MaterialSelectionService.remove(vm.profileMaterials, vm.materialsForView, index);
            vm.itemForm.$setDirty();
        }

        function addDetail() {
            if(!angular.isArray(vm.currentProduct.details)) {
                vm.currentProduct.details = [];
            }
            vm.currentProduct.details.push({ name: {}});
        }

		function removeDetail(detail) {
			vm.currentProduct.details.splice(vm.currentProduct.details.indexOf(detail), 1);
			vm.itemForm.$setDirty();
		}

        function uploadImage() {
            imsUtils.uploadProductImage()
                .then(function (url) {
                    vm.currentProduct.image = url;

                    vm.itemForm.$setDirty();
                });
        }

        function reloadAttributeMaterials() {
            return imsMaterials
                .reload()
                .then(function(mats) {
                    vm.attributeMaterials = [];
                    var blacklist = !!vm.selectedAttribute.restrictions.blacklist;
                    if(vm.selectedAttribute.restrictions.materials === undefined) { vm.selectedAttribute.restrictions.materials = []; }
                    if(vm.selectedAttribute.restrictions.groups === undefined) { vm.selectedAttribute.restrictions.groups = []; }
                    for(var i in mats) {
                        var matches = vm.selectedAttribute.restrictions.materials.indexOf(mats[i].id) >= 0 || vm.selectedAttribute.restrictions.groups.indexOf(mats[i].rawMaterialId >= 0);
                        if(matches !== blacklist) {
                            vm.attributeMaterials.push(mats[i]);
                        }
                    }
            });
        }
        function reloadAttributeColors() {
            return imsColors.reloadColors()
                .then(function(colors) {
                    vm.attributeColors = [];
                    var blacklist = !!vm.selectedAttribute.restrictions.blacklist;
                    if(vm.selectedAttribute.restrictions.colors === undefined) { vm.selectedAttribute.restrictions.colors = []; }
                    for(var i in colors) {
                        var matches = vm.selectedAttribute.restrictions.colors.indexOf(colors[i].id) >= 0;
                        if(matches !== blacklist) {
                            vm.attributeColors.push(colors[i]);
                        }
                    }
            });
        }

        function filterColorsForAttribute(attribute) {
            return function (color) {
                var blacklist = !!attribute.restrictions.blacklist;
                if (attribute.restrictions.colors === undefined) {
                    attribute.restrictions.colors = [];
                }

                var matches = attribute.restrictions.colors.indexOf(color.id) >= 0;
                if (angular.isArray(attribute.restrictions.subset) && attribute.restrictions.subset.length > 0) {
                    matches = attribute.restrictions.subset.indexOf(color.id) >= 0;
                    blacklist = false;
                }
                return matches !== blacklist;
            };
        }

		function addAttribute() {
			if (!vm.selectedAttribute) {
				return;
			}
			if (vm.currentProduct.attributes.indexOf(vm.selectedAttribute) >= 0) {
				return;
			}

			vm.currentProduct.attributes.push(vm.selectedAttribute);
			if (!vm.selectedAttribute.hasAttributeValue && vm.selectedAttribute.value !== undefined) {
                if(!angular.isNumber(vm.selectedAttribute.value) &&
                    angular.isNumber(vm.selectedAttribute.value.min) &&
                    angular.isNumber(vm.selectedAttribute.value.max)) {
                    vm.selectedAttribute.restrictions.min = vm.selectedAttribute.value.min;
                    vm.selectedAttribute.restrictions.max = vm.selectedAttribute.value.max;
                }
				delete vm.selectedAttribute.value;
			} else if (vm.selectedAttribute.hasAttributeValue) {
				delete vm.selectedAttribute.subset;
			}

			vm.selectedAttribute = null;
            vm.itemForm.$setDirty();
		}

		function removeAttribute(attribute) {
			vm.currentProduct.attributes.splice(vm.currentProduct.attributes.indexOf(attribute), 1);
			vm.itemForm.$setDirty();
		}

		function removeAttachment(product,index) {
			AttachmentService.remove(product,index);
			vm.itemForm.$setDirty();
		}

        function openEditor() {
        	if(vm.currentProduct.data.profile && vm.profileLengthFixed){
        		vm.currentProduct.data.profile.length = vm.profileLength;
			}

            imsUtils
                .openEditor(vm.currentProduct.data.profile, false)
                .then(function(profile) {
                    if(profile === undefined) { return; }

                    if(!vm.supportsLengthRange(profile) || vm.profileLengthFixed){
                    	vm.profileLengthFixed = true;
						vm.profileLength = profile.length;
                    }

                    vm.currentProduct.data.profile = profile;
					vm.itemForm.$setDirty();
					ProfileImageService.update(vm,vm.currentProduct.data.profile, true);
            });
        }

		function isRule(value) {
            return vm.effectors.indexOf(value) >= 0;
        }
        function applyEffector(value) {
            switch(value) {
                case 'PROFILE_LENGTH_FIXED':
                    vm.profileLengthFixed = true;
                    break;
                case 'PROFILE_MATERIAL_SINGLE':
                    vm.profileGroups.splice(0, vm.profileGroups.length);
                    if(vm.profileMaterials.length > 1) { vm.profileMaterials.splice(1, vm.profileMaterials.length - 1); }
                    //if(vm.profileMaterials.length === 1) { vm.profileMaterials = vm.profileMaterials[0]; }
                    break;
            }
        }

		function updateConditionals() {
			vm.effectors.splice(0, vm.effectors.length);
			for (var i in vm.config.ims.products.externalAPI.conditionals) {
				var trigger = vm.config.ims.products.externalAPI.conditionals[i];
				if (vm.currentProduct.externalData[vm.config.ims.products.externalAPI.remoteAttributesRoot][trigger.property] === trigger.value) {
					angular.merge(vm.effectors, trigger.effectors);
				}
			}

			for (var effector in vm.effectors) {
				applyEffector(vm.effectors[effector]);
			}
		}

		function finalizeProduct(product) {
			vm.currentProduct = product;
            if(vm.currentProduct.data === undefined) { vm.currentProduct.data = {}; }

			vm.isLoading = false;

			if (product.name === '' || product.name === null) {
				vm.currentProduct.name[vm.selectedLanguage] = vm.currentProduct.externalData[vm.config.ims.products.externalAPI.remoteAttributesRoot][vm.config.ims.products.externalAPI.nameProp];
			}
			if (vm.currentProduct.type === 'profile') {
				vm.profile = vm.currentProduct.data.profile;
				vm.profileMaterials = vm.currentProduct.data.materials;
				vm.profileGroups = vm.currentProduct.data.groups;

				if(vm.profile) {
					ProfileImageService.update(vm, vm.currentProduct.data.profile);
				}

				if (!angular.isArray(vm.profileGroups)) {
					vm.profileGroups = [];
				}
				if (vm.currentProduct.data.length.value) {
					vm.profileLength = vm.currentProduct.data.length.value;
                    vm.profileLengthFixed = true;
				} else {
					vm.profileLengthMin = vm.currentProduct.data.length.min;
					vm.profileLengthMax = vm.currentProduct.data.length.max;
				}
			}
            if(!angular.isObject(vm.currentProduct.salesData) || angular.isArray(vm.currentProduct.salesData)) {
                vm.currentProduct.salesData = {};
            }
			if (vm.config.ims.products.externalAPI.enabled) {
				updateConditionals();
			}
		}

        function isRuleValid() {
             if(vm.salesRule.type === undefined) { return false; }

			if(vm.salesRule.priceModifierType===vm.materialAttributeBase && angular.isString(vm.salesRule.priceModifier)){
				return true;
			}

			if(!angular.isString(vm.salesRule.priceModifier)
             || !angular.isNumber(vm.salesRule.priceModifierValue)
             || !angular.isString(vm.salesRule.priceModifierType)) {
                return false;
             }

             switch(vm.salesRule.type) {
                 case 'attribute':
                    if(vm.salesRule.attribute === undefined
                    || vm.salesRule.conditionType === undefined
                    || vm.salesRule.conditionValue === undefined) {
                        return false;
                    }
                    return true;
                case 'combination':
                    if(vm.salesRule.lh_attribute === undefined
                    || vm.salesRule.rh_attribute === undefined
                    || vm.salesRule.combinationType === undefined) {
                        return false;
                    }
                    return true;
                case 'productdata':
                    if(vm.salesRule.property === undefined
                    || vm.salesRule.conditionType === undefined
                    || vm.salesRule.conditionValue === undefined) {
                        return false;
                    }
                    return true;
                default:
                    return false;
             }
        }

        function showRuleLimitations() {
            if(vm.salesRule.priceModifier === undefined ||
                vm.salesRule.priceModifierValue === undefined ||
                vm.salesRule.priceModifierType === undefined) {
                return false;
            }
            switch(vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined
                        && (vm.salesRule.attribute.type === 'number' || vm.salesRule.attribute.type === 'length')
                        && (vm.salesRule.conditionType === '/' || vm.salesRule.conditionType === '$');
                case 'combination':
                    return vm.salesRule.lh_attribute !== undefined && vm.salesRule.rh_attribute !== undefined && vm.salesRule.combinationType !== undefined;
                case 'productdata':
                    return (vm.salesRule.conditionType === '/' || vm.salesRule.conditionType === '$');
                default:
                    return false;
            }
        }

        function showNumberCondition() {
            switch (vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined
                        && vm.salesRule.attribute.type === 'number';
                case 'combination':
                    return vm.salesRule.lh_attribute !== undefined
                        && vm.salesRule.rh_attribute !== undefined
                        && vm.salesRule.combinationType !== undefined
                        && vm.salesRule.lh_attribute.type === 'number'
                        && vm.salesRule.rh_attribute.type === 'number';
                case 'productdata':
                    return vm.salesRule.property === 'general.quantity';
                default:
                    return false;
            }
        }

        function showLengthCondition() {
            switch (vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined
                        && vm.salesRule.attribute.type === 'length';
                case 'combination':
                    return vm.salesRule.lh_attribute !== undefined
                        && vm.salesRule.rh_attribute !== undefined
                        && vm.salesRule.combinationType !== undefined
                        && ((vm.salesRule.lh_attribute.type === 'length' && vm.salesRule.rh_attribute.type === 'number')
                        || (vm.salesRule.lh_attribute.type === 'number' && vm.salesRule.rh_attribute.type === 'length'));
                case 'productdata':
                    return vm.salesRule.property === 'profile.blank' ||
                        vm.salesRule.property === 'profile.length';

                default:
                    return false;
            }
        }

        function showAreaCondition() {
            switch (vm.salesRule.type) {
                case 'combination':
                    return vm.salesRule.lh_attribute !== undefined
                        && vm.salesRule.rh_attribute !== undefined
                        && vm.salesRule.combinationType !== undefined
                        && vm.salesRule.lh_attribute.type === 'length'
                        && vm.salesRule.rh_attribute.type === 'length';
                default:
                    return false;
            }
        }

        function showMaterialCondition() {
            switch (vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined
                        && vm.salesRule.attribute.type === 'material';
                case 'productdata':
                    return vm.salesRule.property === 'profile.material';
                default:
                    return false;
            }
        }

        function showColorCondition() {
            switch (vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined
                        && vm.salesRule.attribute.type === 'color';
                default:
                    return false;
            }
        }

        function showMaterialGroupCondition() {
            switch (vm.salesRule.type) {
                case 'productdata':
                    return vm.salesRule.property === 'profile.materialgroup';
                default:
                    return false;
            }
        }

        function getComparatorKey(rule) {
            var type = getRuleComparatorType(rule);
            switch(type) {
                case 'boolean':
                    return ProductService.getBooleanComparatorKey(rule.conditionType);
                case 'numeric':
                    return ProductService.getNumericComparatorKey(rule.conditionType);
                case 'string':
                    return rule.conditionType;
            }
            return rule.conditionType;
        }

        function getRuleConditionDisplayValue(rule) {
            switch(rule.type) {
                case 'attribute':
                    var attr = ProductAttributes.getById(rule.attributeId);
                    switch (attr.type) {
                        case 'color':
                            return $filter('nuitTranslate')(nuitDataService.getOne(vm.colors,rule.conditionValue).name, '???');
                        case 'material':
							if(rule.priceModifierType===vm.materialAttributeBase){
								return $filter('translate')('SALES.ATTRIBUTE_BASE_PRICE');
							}

                        	if(angular.isArray(rule.conditionValue)){
								var result = '\r\n';
								for(var index in rule.conditionValue) {
									result += $filter('nuitTranslate')(nuitDataService.getOne(vm.materials,rule.conditionValue[index]).name, '???') + '\r\n';
								}
								return result;
							}else {
								return $filter('nuitTranslate')(nuitDataService.getOne(vm.materials, rule.conditionValue).name, '???');
							}
						case 'length':
							return $filter('nuitUnit')(rule.conditionValue,'length');
                    }
                    break;
                case 'combination':
                    break;
                case 'productdata':
                    switch(rule.property) {
                        case 'profile.material':
							if(rule.priceModifierType===vm.materialAttributeBase){
								return $filter('translate')('SALES.ATTRIBUTE_BASE_PRICE');
							}

                            if(angular.isArray(rule.conditionValue)){
                                var result = '\r\n';
                                for(var index in rule.conditionValue) {
									result += $filter('nuitTranslate')(nuitDataService.getOne(vm.materials,rule.conditionValue[index]).name, '???') + '\r\n';
                                }
                                return result;
                            } else {
								return $filter('nuitTranslate')(nuitDataService.getOne(vm.materials,rule.conditionValue).name, '???');
                            }
                        case 'profile.materialgroup':
                         if(angular.isArray(rule.conditionValue)){
                             var result = '\r\n';
                             for(var index in rule.conditionValue) {
								 result += $filter('nuitTranslate')(nuitDataService.getOne(vm.groups,rule.conditionValue[index]).name, '???') + '\r\n';
                             }
                             return result;
                         } else {
							 return $filter('nuitTranslate')(nuitDataService.getOne(vm.groups,rule.conditionValue).name, '???');
                         }
						case 'profile.length':
						case 'profile.blank':
							return $filter('nuitUnit')(rule.conditionValue,'length');
                    }
            }
            return rule.conditionValue;
        }

        function showRulePriceModifier() {
            switch(vm.salesRule.type) {
                case 'attribute':
                    return vm.salesRule.attribute !== undefined;
                case 'combination':
                    return vm.salesRule.lh_attribute !== undefined && vm.salesRule.rh_attribute !== undefined && vm.salesRule.combinationType !== undefined;
                case 'productdata':
                    return vm.salesRule.property !== undefined;
                default:
                    return false;
            }
        }

        function reloadEnumSelection() {
            if(vm.priceRuleEnum === undefined) { vm.priceRuleEnum = []; }
            vm.priceRuleEnum.splice(0, vm.priceRuleEnum.length);

            switch(vm.salesRule.type) {
                case 'attribute':
                    switch(vm.salesRule.attribute.type) {
                        case 'color':
                            var blacklist = !!vm.salesRule.attribute.restrictions.blacklist;
                            if (vm.salesRule.attribute.restrictions.colors === undefined) {
                                vm.salesRule.attribute.restrictions.colors = [];
                            }
                            for (var i in imsColors.colors) {
                                var matches = vm.salesRule.attribute.restrictions.colors.indexOf(imsColors.colors[i].id) >= 0;
                                if(angular.isArray(vm.salesRule.attribute.restrictions.subset) && vm.salesRule.attribute.restrictions.subset.length > 0) {
                                    matches = vm.salesRule.attribute.restrictions.subset.indexOf(imsColors.colors[i].id) >= 0;
                                    blacklist = false;
                                }
                                if (matches !== blacklist) {
                                    vm.priceRuleEnum.push(imsColors.colors[i]);
                                }
                            }
                            break;
                        case 'material':
                            var hashMap = {};

                            var allMaterials = imsMaterials.materials;
							var blacklist = !!vm.salesRule.attribute.restrictions.blacklist;

                            for(var index in allMaterials) {
                                var material = allMaterials[index];
								var matches = vm.salesRule.attribute.restrictions.materials.indexOf(material.id) >= 0 || vm.salesRule.attribute.restrictions.groups.indexOf(material.rawMaterialId)  >= 0;

                                if(hashMap[material.id] !== undefined || matches===blacklist) { continue; }

                                hashMap[material.id] = material;
                                vm.priceRuleEnum.push(material);
                            }
                            break;
                    }
                    break;
                case 'productdata':
                    switch(vm.salesRule.property) {
                        case 'profile.material':
                            var hashMap = {};

                            for(var index in vm.materialsForView) {
                                hashMap[vm.materialsForView[index].id] = vm.materialsForView[index];
                                vm.priceRuleEnum.push(vm.materialsForView[index]);
                            }
                            var allMaterials = imsMaterials.materials;
                            for(var index in allMaterials) {
                                var material = allMaterials[index];
                                if(hashMap[material.id] !== undefined
                                    || vm.profileGroups.indexOf(material.rawMaterialId) < 0) { continue; }
                                hashMap[material.id] = material;
                                vm.priceRuleEnum.push(material);
                            }

							if(vm.materialsForView.length === 0 && vm.profileGroups.length === 0){
								for(var index in allMaterials) {
									vm.priceRuleEnum.push(allMaterials[index]);
								}
							}
                    }
                    break;
            }
        }

        function getRuleComparatorType(rule) {
            switch(rule.type) {
                case 'attribute':
                    var attr = ProductAttributes.getById(rule.attributeId);
                    switch(attr.type) {
                        case 'enum':
                        case 'material':
                        case 'color':
                            return 'boolean';
                        case 'length':
                        case 'number':
                            return 'numeric';
                        case 'string':
                            return 'string';
                    }
                    break;
                case 'combination':
                    return 'numeric';
                case 'productdata':
                    switch(rule.property) {
                        case 'general.quantity':
                        case 'profile.blank':
                        case 'profile.length':
                            return 'numeric';
                        case 'profile.material':
                        case 'profile.materialgroup':
                            return 'boolean';
                    }
                    break;
            }
            return '';
        }

        function movePriceRule(index, offset) {
            var rule = vm.currentProduct.salesData.priceRules.splice(index, 1)[0];
            vm.currentProduct.salesData.priceRules.splice(index + offset, 0, rule);
            vm.itemForm.$setDirty();
        }

        function editPriceRule(index) {
            vm.editedPriceRule = vm.currentProduct.salesData.priceRules[index];
            vm.salesRule = angular.copy(vm.currentProduct.salesData.priceRules[index]);

            switch(vm.salesRule.type) {
                case 'attribute':
                    vm.salesRule.attribute = ProductAttributes.getById(vm.salesRule.attributeId);
                    break;
                case 'combination':
                    vm.salesRule.lh_attribute = ProductAttributes.getById(vm.salesRule.lhAttributeId);
                    vm.salesRule.rh_attribute = ProductAttributes.getById(vm.salesRule.rhAttributeId);
                    break;
            }
        }

        function deletePriceRule(index) {
            nuitUtils.showDeleteConfirmation()
                .then(function () {
                    var deleted = vm.currentProduct.salesData.priceRules.splice(index, 1)[0];
                    if (vm.editedPriceRule === deleted) {
                        resetRule();
                    }
                    vm.itemForm.$setDirty();
                });
        }

        function resetRule() {
            delete vm.editedPriceRule;
            vm.salesRule = {};
        }

        function createPriceRule() {
            if(!isRuleValid()) { return; }

            var rule = {
                type: vm.salesRule.type,
                priceModifier: vm.salesRule.priceModifier,
                priceModifierValue: vm.salesRule.priceModifierValue,
                priceModifierType: vm.salesRule.priceModifierType,
                priceModifierMin: vm.salesRule.priceModifierMin,
                priceModifierMax: vm.salesRule.priceModifierMax
            };

            switch(vm.salesRule.type) {
                case 'attribute':
                    rule.attributeId = vm.salesRule.attribute.id;
                    switch (vm.salesRule.attribute.type) {
                        case 'material':
                        case 'color':
                        case 'enum':
                            rule.conditionType = vm.salesRule.conditionType;
                            rule.conditionValue = vm.salesRule.conditionValue;
                            break;
                        case 'length':
                        case 'number':
                            rule.conditionType = vm.salesRule.conditionType;
                            rule.conditionValue = vm.salesRule.conditionValue;
                            rule.conditionStart = vm.salesRule.conditionStart;
                            break;
                    }
                    break;
                case 'combination':
                    rule.lhAttributeId = vm.salesRule.lh_attribute.id;
                    rule.rhAttributeId = vm.salesRule.rh_attribute.id;
                    rule.combinationType = vm.salesRule.combinationType;
                    rule.conditionType = vm.salesRule.conditionType;
                    rule.conditionValue = vm.salesRule.conditionValue;
                    rule.conditionStart = vm.salesRule.conditionStart;
                    break;
                case 'productdata':
                    rule.property = vm.salesRule.property;
                    switch (vm.salesRule.property) {
                        case 'general.quantity':
                        case 'profile.blank':
                        case 'profile.length':
                            rule.conditionType = vm.salesRule.conditionType;
                            rule.conditionValue = vm.salesRule.conditionValue;
                            rule.conditionStart = vm.salesRule.conditionStart;
                            break;
                        case 'profile.material':
                        case 'profile.materialgroup':
                            rule.conditionType = vm.salesRule.conditionType;
                            rule.conditionValue = vm.salesRule.conditionValue;
                            break;
                    }
                    break;
            }

            if(vm.currentProduct.salesData === undefined) { vm.currentProduct.salesData = {}; }
            if(vm.currentProduct.salesData.priceRules === undefined) { vm.currentProduct.salesData.priceRules = []; }

            if (vm.editedPriceRule) {
                nuitUtils.clearObj(vm.editedPriceRule);
                angular.merge(vm.editedPriceRule, rule);
                delete vm.editedPriceRule;
            } else {
                vm.currentProduct.salesData.priceRules.push(rule);
            }

            vm.salesRule = {};
            vm.itemForm.$setDirty();
        }

        function getProductTestPrice() {
            var copy = angular.copy(vm.currentProduct);
            copy.salesData.priceRules = vm.currentProduct.salesData.priceRules;
			var material;
            for(var index in copy.attributes) {
                if(copy.attributes[index].value === undefined) {
                    copy.attributes[index].value = copy.attributes[index]._tempValue;
                }
				if(copy.attributes[index].type === 'material') {
					material = vm.getMaterialById(copy.attributes[index]._tempValue);
				}
            }

            if(copy.data.profile !== undefined) {
                copy.data.profile.length = copy.data.profile._tempLength;
                copy.data.profile.materialId = copy.data.profile._tempMaterialId;

				material = vm.getMaterialById(copy.data.profile._tempMaterialId);
            }

            vm.lastPriceTest = ProductService.getExtendedProductPrice(copy, material);
            return isNaN(vm.lastPriceTest.value) ? 0 : vm.lastPriceTest.value;
        }

		function getProfileTestMaterials(){
			var materials = [];

			var showAllMaterials = vm.materialsForView.length === 0 && vm.profileGroups.length === 0;


			for(var i=0; i<vm.materialsForView.length;i++){
				materials.push(vm.materialsForView[i]);
			}

			for(var i=0; i<vm.materials.length;i++){
				if(vm.profileGroups.indexOf(vm.materials[i].rawMaterialId) > -1 || showAllMaterials){
					materials.push(vm.materials[i]);
				}
			}

			return $filter('orderByNuitTranslated')(materials, 'name');
		}
    }
}());


(function () {
	'use strict';

	angular
		.module('app.products')
		.controller('ProductComposeController', ProductComposeController);

	/** @ngInject */
	function ProductComposeController($location, $controller, $scope, $state, ProductService, nuitConfig, nuitApi, nuitAuth, imsUtils, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
        $controller('ProductDetailBaseController', { parentVM: vm, $scope: $scope });
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.currentProduct = { name: {}, description: {}, attributes: [], data: {}, salesData: {}, price: 0.0 };
		vm.favorites = vm.config.ims.products.favorites;
        //*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.saveProduct = saveProduct;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
            vm.reload();

            // Redirects to login screen if not authenticated (for abas product view)
            if(!nuitAuth.isAuthenticated()) {
                var path = {target: $location.url()};
                $location.path('/login').search(path);
                return;
            }

            nuitConfig
                .reload()
                .then(function() {
                    if(!vm.config.ims.products.externalAPI.enabled) { return; }
                    if ($state.params.externalId === undefined) { return; }

                    var apiConfig = vm.config.ims.products.externalAPI;
                    nuitApi.resolve(apiConfig.retrieveURL, $state.params.externalId)
                        .get()
                        .then(function (response) {
                            vm.currentProduct = angular.isString(apiConfig.retrieveProperty) ? response.data[apiConfig.retrieveProperty] : response.data;
                            vm.finalizeProduct(vm.currentProduct);
                        })
                        .catch(function(error) {
                            console.log(error);
                            imsUtils.showErrorToast();
                        })
                        .finally(function () {
                        	if(vm.currentProduct.name==='' || vm.currentProduct.name === null) {
								vm.currentProduct.name = {};
								vm.currentProduct.name[vm.selectedLanguage] = vm.currentProduct.externalData[apiConfig.remoteAttributesRoot][apiConfig.nameProp];
							}
                            vm.isReady = true;
                            vm.updateConditionals();
                        });
            });
		}

		function saveProduct() {
            for(var i in vm.currentProduct.attributes) {
                var attribute = { id: vm.currentProduct.attributes[i].id };
                if(vm.currentProduct.attributes[i].value) {
                    attribute.value = vm.currentProduct.attributes[i].value;
                }
                if(vm.currentProduct.attributes[i].restrictions) {
                    attribute.restrictions = vm.currentProduct.attributes[i].restrictions;
                }
                vm.currentProduct.attributes[i] = attribute;
            }
            vm.currentProduct.customData = {};

            if(vm.currentProduct.data.profile) {
                vm.currentProduct.type = 'profile';
                vm.currentProduct.data.materials = vm.profileMaterials;
                if(!angular.isArray(vm.currentProduct.data.materials)) {
                    vm.currentProduct.data.materials = [vm.currentProduct.data.materials];
                    vm.currentProduct.data.profile.materialId = vm.profileMaterials;
                }
                vm.currentProduct.data.groups = vm.profileGroups;
                vm.currentProduct.data.length = {};
                if(vm.profileLengthFixed) {
                    vm.currentProduct.data.length.value = vm.profileLength;
                } else {
                    vm.currentProduct.data.length.min = vm.profileLengthMin;
                    vm.currentProduct.data.length.max = vm.profileLengthMax;
                }
            }

            var promise = null;
            if(vm.config.ims.products.externalAPI.enabled && $state.params && $state.params.externalId) {
                promise = submitExternalProduct(vm.currentProduct);
            } else {
                promise = ProductService.addProduct(vm.currentProduct);
            }

            promise.then(vm.backToList);
		}
        function submitExternalProduct(product) {
            // TODO: TEMP
            /*var data = {};
            for(var prop in vm.config.ims.products.externalAPI.creationData) {
                var props = vm.config.ims.products.externalAPI.creationData[prop].split('.');
                var obj = product;
                for(var i = 0; i < props.length; i++) {
                    obj = obj[props[i]];
                }
                data[prop] = obj;
            }*/
            product.externalId = $state.params.externalId;

            return nuitApi.resolve(vm.config.ims.products.externalAPI.creationURL, $state.params.externalId).put(product);
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials.sales')
		.controller('MaterialSalesController', MaterialSalesController);

	/** @ngInject */
	function MaterialSalesController(nuitApi, $state, $mdSidenav, $filter, $stateParams, $mdDialog, $translate, imsMaterials, nuitUtils, nuitConfig, ListSelectionService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.currentPage = [];
		vm.currentPageEntities = [];
		vm.searchText = $state.params.term || '';
		vm.selection = ListSelectionService.get('material.sales', true);
		vm.materials = imsMaterials.materials;
		vm.rawMaterials = imsMaterials.groups;
		vm.selectedRawMaterials = [];
		vm.thicknesses = [];
		vm.selectedThicknesses = [];
		vm.colors = [];
		vm.selectedColors = [];
		vm.editValue = 0;
		vm.config = nuitConfig.current;
		vm.loading = true;
		vm.reverse = false;
		vm.selectedOrderBy = 'basePrice';
		vm.mods = ['+','=','%'];
		vm.modifications = {
			basePrice:{
				mod: '%',
				value: 0,
			},
			basePriceWeight:{
				mod: '%',
				value: 0
			},
			extraCharge:{
				mod: '%',
				value: 0
			},
			extraChargeRelative:{
				mod: '%',
				value: 0
			}
		};
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.toggleSelected = vm.selection.toggleSelectedEntity;
		vm.toggleAllSelected = toggleAllSelected;
		vm.isIndeterminate = vm.selection.isIndeterminate;
		vm.filterAll = filterAll;
		vm.getValue = getValue;
		vm.calculate = calculate;
		vm.getSelectedText = getSelectedText;
		vm.getBasePrice = getBasePrice;
		vm.getBasePriceWeight = getBasePriceWeight;
		vm.getExtraCharge = getExtraCharge;
		vm.getExtraChargeRelative = getExtraChargeRelative;
		vm.getOriginalExtraChargeRelative = getOriginalExtraChargeRelative;
		vm.isModified = isModified;
		vm.orderBy = orderBy;
		vm.canSave = canSave;
		vm.getSelectedThicknessesText = getSelectedThicknessesText;
		vm.getSelectedColorsText = getSelectedColorsText;
		vm.getTotalPrice = getTotalPrice;
		vm.sanatizeMods = sanatizeMods;
		vm.getName = function(material){
			return $filter('nuitTranslate')(material.name);
		};
		//*******************************************

		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		/**
		 * Creates a new material group dialog.
		 * If no material group has been passed as argument
		 * it simply acts as a create-new dialog.
		 * @param {Group} group - material group
		 * @returns {Object}
		 */
		function createGroupEditDialog(group) {
			return {
				controller: 'MaterialSalesChangeDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/merchandising.materials.sales/dialogs/material-sales-change/material-sales-change.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Group: angular.copy(group)
				}
			};
		}


		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			imsMaterials
				.reloadGroups()
				.then(function(){
					return imsMaterials
						.reload()
						.then(function(){
							for(var i=0;i<vm.materials.length;i++){
								vm.materials[i]._partial = true;
							}
							filterAll();
							vm.loading=false;
						});
				})
				.catch(nuitUtils.showErrorToast);
		}

		function toggleAllSelected() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

		function filterAll() {
			vm.selection.deselectAll();
			vm.filteredEntities = [];
			vm.thicknesses = [];
			vm.colors = [];

			for (var i = 0; i < vm.materials.length; i++) {
				var material = vm.materials[i];
				if (matches(material)) {
					vm.filteredEntities.push(material);
				}

				if(vm.thicknesses.indexOf(material.thickness)===-1){
					vm.thicknesses.push(material.thickness);
				}

				if(material.colors.front) {
					nuitDataService.upsertOne(vm.colors, material.colors.front);
				}
			}

			vm.thicknesses.sort();
			vm.filteredEntities = $filter('orderBy')(angular.copy(vm.filteredEntities), vm.selectedOrderBy, vm.reverse);
		}

		function matches(material){
			if (vm.searchText === '' && vm.selectedRawMaterials.length===0 && vm.selectedThicknesses.length===0 && vm.selectedColors.length===0) {
					return true;
			} else {
				return (
					$filter('nuitTranslate')(material.name, '???').toLowerCase().includes(vm.searchText.toLowerCase()) &&
					(vm.selectedRawMaterials.length===0 || vm.selectedRawMaterials.indexOf(material.rawMaterialId)!==-1) &&
					(vm.selectedThicknesses.length===0 || vm.selectedThicknesses.indexOf(material.thickness)!==-1) &&
					(vm.selectedColors.length===0 || (material.colors.front && vm.selectedColors.indexOf(material.colors.front.id)!==-1))
				);
			}
		}

		function getBasePrice(material){
			var weight = material.weight?material.weight:0;

			if(vm.modifications.basePrice.value!==0){
				return getValue(material.basePrice,vm.modifications.basePrice);
			}else if(vm.modifications.basePriceWeight.value!==0){
				return getBasePriceWeight(material)*weight;
			}else{
				return material.basePrice;
			}
		}

		function getBasePriceWeight(material){
			var weight = material.weight?material.weight:0;

			if(weight===0){
				return 0;
			}else if(vm.modifications.basePrice.value!==0){
				return getValue(material.basePrice,vm.modifications.basePrice)/material.weight;
			}else if(vm.modifications.basePriceWeight.value!==0){
				return getValue(material.basePrice/material.weight,vm.modifications.basePriceWeight);
			}else{
				return toPrecision(material.basePrice/material.weight);
			}
		}

		function getExtraCharge(material){
			if(vm.modifications.extraCharge.value!==0){
				return getValue(material.extraCharge,vm.modifications.extraCharge);
			}else if(vm.modifications.extraChargeRelative.value!==0){
				var basePrice = getBasePrice(material);
				return toPrecision(basePrice*getExtraChargeRelative(material)/100);
			}
			else{
				return material.extraCharge;
			}
		}

		function getExtraChargeRelative(material){
			var basePrice = material.basePrice;
			var extraCharge = material.extraCharge?material.extraCharge:0;


			if(vm.modifications.basePrice.value!==0 || vm.modifications.basePriceWeight.value!==0){
				basePrice = getBasePrice(material);
			}

			if(basePrice===0){
				return 0;
			}else if(vm.modifications.extraCharge.value!==0){
				return toPrecision(getValue(extraCharge,vm.modifications.extraCharge, false) / basePrice * 100.0);
			}else if(vm.modifications.extraChargeRelative.value!==0){
				return toPrecision(getValue(extraCharge/basePrice*100,vm.modifications.extraChargeRelative, false));
			} else{
				return toPrecision(extraCharge / basePrice * 100.0);
			}
		}

		function getOriginalExtraChargeRelative(material){
			if(material.extraCharge===0 || material.extraCharge===null || material.basePrice===0 || material.basePrice===null)
			{
				return 0;
			}else {
				return toPrecision(material.extraCharge / material.basePrice * 100.0);
			}
		}

		function isModified(mods){
			for(var i=0;i<mods.length;i++){
				var mod = vm.modifications[mods[i]];
				if(mod.value!==0){
					return true;
				}
			}
			return false;
		}

		function getTotalPrice(material){
			return this.getBasePrice(material) + this.getExtraCharge(material);
		}

		function getValue(price, mod, round){
			var doRound = round!==undefined?round:true;

			switch (mod.mod){
				case '+':
					var plusResult = Math.max(0,price + mod.value);
					return doRound?toPrecision(plusResult):plusResult;
				case '=':
					return mod.value;
				case '%':
					var percentResult = Math.max(0,price + mod.value/100*price);
					return doRound?toPrecision(percentResult):percentResult;
				default:
					return 0;
			}
		}

		function toPrecision(number){
			var result = $filter('nuitUnit')(number,'materialprice',true);

			result = result.replace(vm.config.units.formats.number.groupSeperator, '');
			result = result.replace(vm.config.units.formats.number.decimalSeperator, '.');

			return parseFloat(result);
		}

		function calculate(){
			nuitUtils.showConfirmationDialog('MATERIAL.UPDATE_PRICE_TITLE',"MATERIAL.UPDATE_PRICE_CONTENT")
				.then(function(){
					var selected = vm.selection.getSelected();
					var toUpdate = [];

					for(var i=0;i<selected.length;i++){
						var material = selected[i];
						var patchMaterial = {id:material.id}

						var oldBasePrice = material.basePrice?material.basePrice:0;
						var oldExtraCharge = material.extraCharge?material.extraCharge:0;
						var basePrice = getBasePrice(material);
						var extraCharge = getExtraCharge(material);

						var needsUpdate = false;

						if(oldBasePrice!==basePrice){
							patchMaterial.basePrice = basePrice;
							needsUpdate = needsUpdate || true;
						}

						if(oldExtraCharge!==extraCharge){
							patchMaterial.extraCharge = extraCharge;
							needsUpdate = needsUpdate || true;
						}

						if(needsUpdate){
							toUpdate.push(patchMaterial);
						}
					}

					nuitApi('materials.patch').patch(toUpdate)
						.then(function(result){
							for(var i=0;i<result.data.length;i++){
								nuitDataService.updateOne(vm.materials,result.data[i]);
							}
							filterAll();
							return nuitUtils.showSuccessToast();
						})
						.catch(nuitUtils.showErrorToast)
						.finally(function(){
							Object.keys(vm.modifications).forEach(function(key){
								vm.modifications[key].value = 0;
							});
						});
				});
		}

		function getSelectedText(){
			if(vm.selectedRawMaterials.length===0){
				return $translate.instant('MATERIAL.GROUPS_NAV');
			}else{
				var texts = [];
				for(var i=0;i<vm.selectedRawMaterials.length;i++){
					texts.push($filter('nuitTranslate')(nuitDataService.getOne(vm.rawMaterials,vm.selectedRawMaterials[i]).name,''));
				}
				return texts.join(', ');
			}
		}

		function getSelectedThicknessesText(){
			if(vm.selectedThicknesses.length===0){
				return $translate.instant('MATERIAL.THICKNESSES');
			}else{
				var texts = [];
				for(var i=0;i<vm.selectedThicknesses.length;i++){
					texts.push($filter('nuitUnit')(vm.selectedThicknesses[i],'thickness'));
				}
				return texts.join(' ');
			}
		}

		function getSelectedColorsText(){
			if(vm.selectedColors.length===0){
				return $translate.instant('MATERIAL.COLOR_FRONT');
			}else{
				var texts = [];
				for(var i=0;i<vm.selectedColors.length;i++){
					texts.push($filter('nuitTranslate')(nuitDataService.getOne(vm.colors,vm.selectedColors[i]).name,''));
				}
				return texts.join(', ');
			}
		}

		function orderBy(key, initial) {
			vm.selectedOrderBy = key;
			if (!initial){
				vm.reverse = !vm.reverse;
			}else{
				vm.reverse = initial;
			}
			filterAll();
		}

		function canSave(){
			return vm.selection.getSelected().length>0 && isModified(['basePrice','basePriceWeight', 'extraCharge', 'extraChargeRelative']);
		}

		function sanatizeMods(){
			Object.keys(vm.modifications).forEach(function(key){
				if(vm.modifications[key].value===null) {
					vm.modifications[key].value = 0;
				}
			});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials.groups')
		.controller('MaterialGroupsController', MaterialGroupsController);

	/** @ngInject */
	function MaterialGroupsController($mdSidenav, $filter, $stateParams, $mdDialog, $translate, imsMaterials, nuitUtils, nuitConfig) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.term = '';
		vm.groups = imsMaterials.groups;
		vm.currentLanguage = $translate.use();
		vm.config = nuitConfig.current;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.addGroup = addGroup;
		vm.deleteGroup = deleteGroup;
		vm.updateGroup = updateGroup;
		vm.toggleSidenav = toggleSidenav;
		vm.isGroupActive = isGroupActive;
		vm.filterGroups = filterGroups;
		//*******************************************

		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		/**
		 * Creates a new material group dialog.
		 * If no material group has been passed as argument
		 * it simply acts as a create-new dialog.
		 * @param {Group} group - material group
		 * @returns {Object}
		 */
		function createGroupEditDialog(group) {
			return {
				controller: 'RawMaterialDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/merchandising.materials.groups/dialogs/raw-material/raw-material.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Group: angular.copy(group)
				}
			};
		}


		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			imsMaterials
				.reloadGroups()
				.catch(nuitUtils.showErrorToast);
		}
		/**
		 * Toggles the sidebar navigation.
		 * @param {String} sidenavId
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}


		/**
		 * Returns true if the given group is active.
		 * @param {Group} group
		 * @returns {Boolean}
		 */
		function isGroupActive(group) {
			return group.id.toString() === $stateParams.group;
		}
		/**
		 * Creates an add group dialog.
		 */
		function addGroup() {
			$mdDialog
				.show(createGroupEditDialog())
				.then(imsMaterials.addGroup)
				.then(nuitUtils.showSuccessToast)
				.catch(angular.noop);
		}
		/**
		 * Creates a delete group dialog.
		 * @param {Group} group - group to delete
		 * @param {Object} $event - event data
		 */
		function deleteGroup(group, $event) {

			$event.stopPropagation();
			$event.preventDefault();

			nuitUtils
				.showDeleteConfirmation()
				.then(function () {
					return imsMaterials.deleteGroup(group.id);
				})
				.then(nuitUtils.showSuccessToast)
				.catch(angular.noop);
		}
		/**
		 * Updates the given group.
		 * @param {Group} group
		 * @param {Object} $event
		 */
		function updateGroup(group, $event) {

			$event.stopPropagation();
			$event.preventDefault();

			$mdDialog
				.show(createGroupEditDialog(group))
				.then(imsMaterials.updateGroup)
				.then(function () {
					$translate.refresh();
					nuitUtils.showSuccessToast();
				})
				.catch(angular.noop);
		}

		function filterGroups(groups) {
			var name = $filter('nuitTranslate')(groups.name);
			return vm.term === '' || (typeof name !== 'undefined' && name.toLowerCase().includes(vm.term.toLowerCase()));

		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.products.attributes')
		.controller('MaterialAttributesController', Controller);

	/** @ngInject */
	function Controller($mdDialog, $translate, nuitApi, nuitUtils, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.term = '';
		vm.attributes = [];
		vm.currentLanguage = $translate.use();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.addAttribute = addAttribute;
		vm.editAttribute = editAttribute;
		vm.deleteAttribute = deleteAttribute;
		vm.filterAttribute = filterAttribute;
		vm.toggleVisibility = toggleVisibility;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createEditAttributeDialog(attribute) {
			return {
				controller: 'EditMaterialAttributeDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/merchandising.materials.attributes/dialogs/edit-attribute/edit-attribute.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Attribute: angular.copy(attribute)
				}
			};
		}

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			reloadAttributes();
		}

		function addAttribute() {
			$mdDialog
				.show(createEditAttributeDialog())
				.then(function (result) {
					nuitApi('material.attributes').post(result)
						.then(function (response) {
							nuitDataService.addOne(vm.attributes, response.data);
							nuitUtils.showSuccessToast();
						})
						.catch(nuitUtils.showErrorToast);
				}).catch(angular.noop);
		}

		function editAttribute(attribute) {
			$mdDialog
				.show(createEditAttributeDialog(attribute))
				.then(function (result) {
					nuitApi('material.attribute', attribute.id)
						.put(result)
						.then(function (response) {
							nuitDataService.updateOne(vm.attributes,response.data);
						}).catch(nuitUtils.showErrorToast);
				}).catch(angular.noop);
		}

		function toggleVisibility(attribute) {
			attribute.restrictions.hidden = !attribute.restrictions.hidden;
			return nuitApi('material.attribute', attribute.id)
				.put(attribute)
				.then(function (response) {
					nuitDataService.updateOne(vm.attributes,response.data);
				});
		}

		function filterAttribute(attribute) {
			return vm.term === '' || (typeof attribute.name[vm.currentLanguage] !== 'undefined' && attribute.name[vm.currentLanguage].toLowerCase().includes(vm.term.toLowerCase()));
		}

		function reloadAttributes() {
			return nuitApi('material.attributes')
				.get()
				.then(function (response) {
					nuitDataService.replaceAll(vm.attributes,response.data);
				});
		}

		function deleteAttribute(attribute) {
			nuitUtils.showDeleteConfirmation()
				.then(function() {
					return nuitApi('material.attribute', attribute.id)
						.delete()
						.then(function () {
							nuitDataService.removeOne(vm.attributes,attribute.id);
							nuitUtils.showSuccessToast();
						})
						.catch(nuitUtils.showErrorToast);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.factory('CuttingsService', CuttingsService);

	/** @ngInject */
	function CuttingsService($log, nuitApi, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _coils = {};
		var _sheets = {};

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			getSheets: getSheets,
			reloadSheets: reloadSheets,
			addSheet: addSheet,
			updateSheet: updateSheet,
			deleteSheet: deleteSheet,

			getCoils: getCoils,
			reloadCoils: reloadCoils,
			addCoil: addCoil,
			updateCoil: updateCoil,
			deleteCoil: deleteCoil
		};

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// SHEET METHODS
		//*******************************************
		function getSheets(materialId) {
			if(!_sheets[materialId]){
				_sheets[materialId] = [];
			}
			return _sheets[materialId];
		}

		function reloadSheets(materialId) {
			return nuitApi('materials.sheets', materialId).get()
				.then(function (response) {
					angular.forEach(response.data, function (sheet) {
						sheet.type = 'sheet';
					});
					return nuitDataService.replaceAll(getSheets(materialId),response.data);;
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Cannot load sheets for material with id ' + materialId);
				});
		}

		function addSheet(materialId, sheet) {
			return nuitApi('materials.sheets', materialId).post(sheet)
				.then(function (response) {
					response.data.type = 'sheet';
					return nuitDataService.addOne(getSheets(materialId),response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error adding new sheet to material with id ' + materialId);
				});
		}

		function updateSheet(sheet) {
			return nuitApi('materials.sheets.one', sheet.materialId, sheet.id).put(sheet)
				.then(function (response) {
					response.data.type = 'sheet';
					return nuitDataService.updateOne(getSheets(sheet.materialId),response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error updating sheet with id ' + sheet.id);
				});
		}

		function deleteSheet(sheet) {
			return nuitApi('materials.sheets.one', sheet.materialId, sheet.id).delete()
				.then(function () {
					return nuitDataService.removeOne(getSheets(sheet.materialId),sheet.id);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error deleting sheet with id ' + sheet.id);
				});
		}

		//*******************************************
		// COIL METHODS
		//*******************************************
		function getCoils(materialId) {
			if(!_coils[materialId]){
				_coils[materialId] = [];
			}
			return _coils[materialId];
		}

		function reloadCoils(materialId) {
			return nuitApi('materials.coils.all', materialId).get()
				.then(function (response) {
					angular.forEach(response.data, function (coil) {
						coil.type = 'coil';
					});
					return nuitDataService.replaceAll(getCoils(materialId),response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Cannot load coils for material with id ' + materialId);
				});
		}

		function addCoil(materialId, coil) {
			return nuitApi('materials.coils.one', materialId, coil.machineId).post(coil)
				.then(function (response) {
					response.data.type = 'coil';
					return nuitDataService.upsertOne(getCoils(materialId),response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error adding new coil to material with id ' + materialId);
				});
		}

		function updateCoil(coil) {
			return nuitApi('materials.coils.one', coil.materialId, coil.machineId).put(coil)
				.then(function (response) {
					response.data.type = 'coil';
					return nuitDataService.updateOne(getCoils(coil.materialId),response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error updating coil with id ' + coil.machineId);
				});
		}

		function deleteCoil(coil) {
			return nuitApi('materials.coils.one', coil.materialId, coil.machineId).delete()
				.then(function () {
					return nuitDataService.removeOne(getCoils(coil.materialId),coil.id);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error deleting coil with id ' + coil.machineId);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.factory('MaterialAttributesService', Service);

	/** @ngInject */
	function Service($translate, nuitApi, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
        var _attributes = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			add: add,
			remove: remove,
			getName: getName
		};
        //*******************************************

        //*******************************************
        // PROPERTIES
        //*******************************************
        Object.defineProperty(service, 'attributes', { get: function() { return _attributes; } });
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS (Public)
		//*******************************************

        /**
         * Reloads all attributes.
         * @returns {Promise}
         */
        function reload() {
            return nuitApi('material.attributes')
                .get()
                .then(function(response) {
                	nuitDataService.replaceAll(_attributes,response.data);
            });
        }

		function add(material,attribute) {
			if (!attribute || nuitDataService.getOne(material.attributes,attribute.id)!==null) {
				return;
			}
			else{
				if(!angular.isArray(material.attributes)){
					material.attributes = [];
				}

				material.attributes.push({id:attribute.id,value:attribute.value});
			}
		}

		function remove(material,index)
		{
			material.attributes.splice(index,1);
		}

		function getName(id)
		{
			var attribute = nuitDataService.getOne(_attributes,id);
			return attribute!=null?attribute.name[$translate.use()]:"";
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.controller('MaterialsController', MaterialsController);

	/** @ngInject */
	function MaterialsController($mdSidenav, $stateParams, $mdDialog, $translate, imsMaterials, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.groups = imsMaterials.groups;

		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.toggleSidenav = toggleSidenav;
        vm.isGroupActive = isGroupActive;
		//*******************************************

		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////



		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			imsMaterials
				.reloadGroups()
				.catch(nuitUtils.showErrorToast);
		}
		/**
		 * Toggles the sidebar navigation.
		 * @param {String} sidenavId
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}

        /**
         * Returns true if the given group is active.
         * @param {Group} group
         * @returns {Boolean}
         */
        function isGroupActive(group) {
            return group.id.toString() === $stateParams.group;
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.controller('MaterialListController', MaterialListController);

	/** @ngInject */
	function MaterialListController($q, $timeout, $state, $scope, $translate, $filter, imsTranslation, DotNotationService, imsMaterials, nuitConfig, nuitUtils, MaterialAttributesService, FavoriteService, ListSelectionService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.currentPage = 0;
		vm.currentPageEntities = [];
		vm.selection = ListSelectionService.get('merchandising.materials', true);
		vm.config = nuitConfig.getCurrent();
		vm.loadingMaterials = true;                         // True if materials are currently reloading
		vm.materials = imsMaterials.materials;              // Contains all materials
		vm.term = '';                                       // Contains the search term
		vm.prevSelectedGroup = null;                        // Contains the previously selected group to determine if the group has been changed
		vm.attributes = MaterialAttributesService.attributes;
		vm.selectedAttributes = [];
		vm.allowAdd = vm.config.ims.materials.list.allowAdd;
		vm.lang = nuitConfig.current.languages;
		vm.inProgress = false;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.getGroupById = imsMaterials.getGroupById;
		vm.openMaterial = openMaterial;
		vm.search = search;
		vm.deleteSelection = deleteSelection;
		vm.copySelection = copySelection;
		vm.toggleActive = toggleActive;
		vm.toggleSelectMaterial = vm.selection.toggleSelectedEntity;
		vm.toggleSelectedMaterials = toggleSelectedMaterials;
		vm.isIndeterminate = vm.selection.isIndeterminate;
		vm.toggleSidenav = $scope.$parent.vm.toggleSidenav;
		vm.filterMaterial = filterMaterial;
		vm.deselectAll = vm.selection.deselectAll;
		vm.toggleAttribute = toggleAttribute;
		vm.getName = function(material){
			return $filter('nuitTranslate')(material.name);
		};

		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(vm, 'materials_per_page', {
			get: function () {
				return vm.config.ims.materials.itemsPerPage === undefined ? 1 : Math.max(1, vm.config.ims.materials.itemsPerPage);
			}
		});
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		function onStateChangeSuccess(event, toState, toParams, fromState, fromParams) {
			vm.term = $state.params.term || '';

			if ($state.params.group !== vm.prevSelectedGroup) {
				filterMaterials();
				vm.prevSelectedGroup = $state.params.group;
			}

			if ($state.params.page && $state.params.page !== vm.currentPage) {
				vm.currentPage = $state.params.page;
			}


			if (angular.isDefined($state.params.attributes)) {
				vm.selectedAttributes.splice(0, vm.selectedAttributes.length);

				if (angular.isString($state.params.attributes)) {
					vm.selectedAttributes.push(Number.parseInt($state.params.attributes));
				} else {
					$state.params.attributes.forEach(function (number) {
						vm.selectedAttributes.push(Number.parseInt(number));
					});
				}
			}
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			if (vm.materials.length > 0) {
				vm.loadingMaterials = false;
			}
			imsMaterials
				.reload()
				.then(function () {
					filterMaterials();

				})
				.finally(function () {
					vm.loadingMaterials = false;
				});

			MaterialAttributesService.reload();
		}


		/**
		 * Toggles the selection for all materials..
		 */
		function toggleSelectedMaterials() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

		/**
		 * Filters all materials.
		 */
		function filterMaterials() {

			var i;
			vm.filteredEntities.splice(0, vm.filteredEntities.length);
			for (i in vm.materials) {
				if (filterMaterial(vm.materials[i])) {
					vm.filteredEntities.push(vm.materials[i]);
				}
			}

			vm.filteredEntities = FavoriteService.sort($filter('orderByNuitTranslated')(vm.filteredEntities, 'name'));

			vm.deselectAll();
		}


		function filterMaterial(material) {
			return ($state.params.group === undefined || $state.params.group === material.rawMaterialId.toString()) &&
				hasAttribute(material) &&
				(vm.term === '' || $filter('nuitTranslate')(material.name, '???').toLowerCase().includes(vm.term.toLowerCase()));
		}

		function hasAttribute(material) {
			if (vm.selectedAttributes.length > 0) {
				if (angular.isArray(material.attributes)) {
					var matched = 0;

					material.attributes.forEach(function (attribute) {
						if (vm.selectedAttributes.filter(function (selectedAttributeId) {
							return selectedAttributeId === attribute.id;
						}).length > 0) {
							matched++;
						}
					});

					return matched === vm.selectedAttributes.length;
				} else {
					return false;
				}
			} else {
				return true;
			}
		}


		function openMaterial(materialId) {
			$state.go('app.materials.detail', {
				materialId: materialId,
				attributes: vm.selectedAttributes,
				page: vm.currentPage
			});
		}

		function deleteSelection() {
			nuitUtils
				.showDeleteMultiConfirm()
				.then(function () {
					var promises = [];
					angular.forEach(vm.getSelected(), function (material) {
						promises.push(imsMaterials.deleteMaterial(material.id));
					});
					vm.deselectAll();
					$q.all(promises)
						.then(filterMaterials)
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast);
				});
		}

		function copySelection() {
			var mat = angular.copy(vm.getSelected()[0]);
			delete mat.id;
			delete mat.externalId;

			imsTranslation
				.getTranslationsOfKey('APP.DUPLICATE')
				.then(function (translations) {
					for (var l in vm.lang) {
						var currentLang = vm.lang[l];
						if (DotNotationService.hasKey(mat.name, currentLang) && DotNotationService.hasKey(translations, currentLang)) {
							mat.name[currentLang] = mat.name[currentLang] + ' _' + translations[currentLang];
						}
					}

					imsMaterials
						.add(mat)
						.then(function () {
							imsMaterials
								.reload()
								.then(function () {
									$timeout(function () {
										filterMaterials();
										nuitUtils.showSuccessToast();
										vm.deselectAll();
									}, 200);
								}).catch(nuitUtils.showErrorToast);
						}).catch(nuitUtils.showErrorToast);
				});
		}

		function search() {
			$state.go('app.materials', {term: vm.term, index: null, attributes: vm.selectedAttributes});
			filterMaterials();
		}

		function toggleActive(material, $event) {
			$event.stopPropagation();
			$event.preventDefault();
			vm.inProgress = true;

			imsMaterials
				.patchMaterial({id: material.id, active: !material.active})
				.then(function(newMaterial){
					angular.merge(material, newMaterial);
					vm.inProgress = false;
				})
				.catch(nuitUtils.showErrorToast);
		}


		function toggleAttribute(id) {
			var index = vm.selectedAttributes.indexOf(id);

			if (index !== -1) {
				vm.selectedAttributes.splice(index, 1);
			} else {
				vm.selectedAttributes.push(id);
			}

			search();
		}
	}
}());

(function () {
		'use strict';

		angular
			.module('app.materials')
			.controller('MaterialDetailsController', MaterialDetailsController);

		function MaterialDetailsController($mdDialog,
										   $state,
										   $scope,
										   $q,
										   $timeout,
										   $translate,
										   $filter,
										   imsConfig,
										   imsColors,
										   imsMaterials,
										   nuitUtils,
										   nuitUnits,
										   imsTranslation,
										   CuttingsService,
										   MaterialAttributesService,
										   CoilMachineService,
										   CompanyService,
										   FormatterService) {
			//*******************************************
			// VIEWMODEL
			//*******************************************
			var vm = this;
			//*******************************************

			//*******************************************
			// VARIABLES
			//*******************************************
			vm.coils = [];                                              // Array with coils for current material
			vm.colors = imsColors.colors;                               // Array with all possible rals
			vm.config = imsConfig.getCurrent();                         // Contains the nuit config
			vm.currentTab = $state.params.active;                       // Current state name
			vm.groups = imsMaterials.groups;                            // Array with all possible raw materials
			vm.loadingMaterial = true;                                  // Indicator if a loading process is running
			vm.material = {};                                           // Contains current material
			vm.materialId = $state.params.materialId;                   // ID of current material
			vm.selectedBackColor = null;                                // Selected back color object
			vm.selectedFrontColor = null;                               // Selected front color object
			vm.selectedLanguage = imsTranslation.language;              // Indicates language which shall be used for multi-lingual inputs
			//vm.sheets = [];                                             // Array with sheets for current material
			vm.unit = nuitUnits;                                          // Utility object to retrieve units and step
			vm.attributes = MaterialAttributesService.attributes;
			vm.selectedAttribute = null;
			vm.coilMachines = CoilMachineService.getMachines();
			vm.favorites = vm.config.ims.materials.details.favorites;
			vm.searchTerm = '';
			vm.companiesLoaded = false;
			vm.currentCompanyId = null;
			vm.searchText = "";
			vm.companies = [];
			vm.selectedCompanies = [];
			//*******************************************

			//*******************************************
			// METHODS (Exposure)
			//*******************************************
			vm.updateMaterial = updateMaterial;
			vm.updateName = updateName;
			vm.searchColors = searchColors;
			vm.toggleSidenav = $scope.$parent.vm.toggleSidenav;
			vm.showAddCuttingDialog = showAddCuttingDialog;
			vm.editCutting = editCutting;
			vm.deleteCutting = deleteCutting;
			vm.resetFrontColor = resetFrontColor;
			vm.resetBackColor = resetBackColor;
			vm.getColorById = imsColors.getColorById;
			vm.getColorNameString = getColorNameString;
			vm.updatePrice = updatePrice;
			vm.addAttribute = MaterialAttributesService.add;
			vm.removeAttribute = removeAttribute;
			vm.getAttributeName = MaterialAttributesService.getName;
			vm.getCoilMachineName = CoilMachineService.getNameById;
			vm.updateBasePrice = updateBasePrice;
			vm.updateConvertedPrice = updateConvertedPrice;
			vm.clearSearchTerm = clearSearchTerm;
			vm.reloadCompanies = reloadCompanies;
			vm.selectCompany = selectCompany;
			vm.removeCompany = removeCompany;
			//*******************************************

			//*******************************************
			// EVENTS
			//*******************************************
			$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
			//*******************************************

			//*******************************************
			// INITIALIZATION
			//*******************************************
			init();
			//*******************************************

			////////////////////////////////////////////////////////////////////////

			//*******************************************
			// EVENT HANDLER
			//*******************************************
			function onStateChangeSuccess(fromState, toState) {
				vm.currentState = toState.name;
			}

			//*******************************************
			// OBJECT CONSTANTS
			//*******************************************
			function createCuttingDialog(cutting) {
				return {
					controller: 'CuttingDialogController',
					controllerAs: 'vm',
					templateUrl: 'app/main/merchandising.materials/dialogs/cutting/cutting-dialog.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					locals: {
						Cutting: angular.extend({}, cutting),
						Coils: vm.coils
					}
				};
			}

			//*******************************************
			// METHODS
			//*******************************************
			function init() {
				// Set vm.currentState depending by the currently active state
				var currentTab = $state.params.active;
				if (currentTab === 'production') {
					vm.selectedTab = 1;
				} else if (currentTab === 'sales') {
					vm.selectedTab = 2;
				}

				vm.coils = CuttingsService.getCoils(vm.materialId);
				//vm.sheets = CuttingsService.getSheets(vm.materialId);

				// Loads material from material service
				imsMaterials
					.loadMaterial(vm.materialId)
					.then(function (material) {
						vm.material = material;
						vm.extraChargeAbsolute = vm.material.extraCharge;
						updatePrice('extraChargeAbsolute');
						updateConvertedPrice();
						loadSelectedCompanies();
					})
					.catch(function () {
						nuitUtils.showErrorToast('MATERIALS.ERROR_LOADING_MATERIAL');
					})
					.finally(function () {
						vm.loadingMaterial = false;
					});

				// Loads raw materials from material service
				imsMaterials
					.reloadGroups()
					.catch(function () {
						nuitUtils.showErrorToast('MATERIALS.ERROR_LOADING_RAW_MATERIALS');
					});

				// Loads colors from imsColorsService
				imsColors
					.reloadColors()
					.catch(function () {
						nuitUtils.showErrorToast('MATERIALS.ERROR_LOADING_COLORS');
					});

				// Loads sheets from CuttingService
				/*CuttingsService
                    .reloadSheets(vm.materialId)
                    .catch(function () {
                        nuitUtils.showErrorToast('MATERIALS.ERROR_LOADING_SHEETS');
                    });*/


				CoilMachineService.reload().then(function () {
					// Loads coils from CuttingService
					CuttingsService
						.reloadCoils(vm.materialId)
						.catch(function () {
							nuitUtils.showErrorToast('MATERIALS.ERROR_LOADING_COILS');
						});
				});

				MaterialAttributesService.reload();
			}

			/**
			 * Refreshes the name of the material.
			 */
			function updateName() {
				if (!angular.isDefined(vm.material.rawMaterialId)
					|| !angular.isDefined(vm.material.thickness)
					|| vm.material.customData.customName) {
					return;
				}
				var frontColor = imsColors.getColorById(vm.material.colorFront);
				var translatedGroup = $filter('nuitTranslate')(imsMaterials.getGroupById(vm.material.rawMaterialId).name, '???');
				var fallbackGroupTranslation = translatedGroup['en'] || $filter('nuitTranslate')(imsMaterials.getGroupById(vm.material.rawMaterialId).name, '???');
				var fallbackColorTranslation = null;
				if(frontColor === null){
					fallbackColorTranslation = '';
				}else {
					fallbackColorTranslation = frontColor.name['en'] || frontColor.name[0];
				}


				if (!vm.material.name) {
					vm.material.name = {};
				}

				for (var i in vm.config.languages) {
					var currLang = vm.config.languages[i];
					var currGroup = translatedGroup[currLang] || fallbackGroupTranslation;
					var currColor = null;
					if(frontColor === null){
						currColor = '';
					}else{
						currColor =  frontColor.name[currLang] || fallbackColorTranslation ;
					}


					var length = $filter('nuitUnit')(vm.material.thickness, 'thickness');
					var result = vm.config.ims.materials.nameFormat;
					if(frontColor === null){
						result = result
							.replace('#group', currGroup)
							.replace('#thickness', length)
							.replace('#colorFront', currColor);
						vm.material.name[currLang] = result;
					}else{
					result = result
						.replace('#group', currGroup)
						.replace('#thickness', length)
						.replace('#colorFront', imsColors.getColorById(vm.material.colorFront).code + ' - ' + currColor);
					vm.material.name[currLang] = result;
					}
				}
			}

			function updatePrice(origin) {
				switch (origin) {
					case 'basePrice':
						updateBasePriceDependencies();
						updateConvertedPrice();
						break;
					case 'extraChargeAbsolute':
						vm.extraChargeRelative = vm.extraChargeAbsolute / vm.material.basePrice * 100.0;
						vm.sellingPrice = vm.material.basePrice + vm.extraChargeAbsolute;
						break;
					case 'extraChargeRelative':
						vm.extraChargeAbsolute = vm.material.basePrice * vm.extraChargeRelative * 0.01;
						vm.sellingPrice = vm.material.basePrice + vm.extraChargeAbsolute;
						break;
					case 'sellingPrice':
						vm.extraChargeAbsolute = vm.sellingPrice - vm.material.basePrice;
						vm.extraChargeRelative = vm.extraChargeAbsolute / vm.material.basePrice * 100.0;
						break;
				}

				vm.material.extraCharge = vm.extraChargeAbsolute;
			}

			function updateBasePriceDependencies() {
				vm.extraChargeAbsolute = vm.material.basePrice * vm.extraChargeRelative * 0.01;
				vm.sellingPrice = vm.material.basePrice + vm.extraChargeAbsolute;
			}

			function updateBasePrice() {
				//var equation = FormatterService.format(vm.config.ims.materials.priceConversion.toBasePrice, vm.material);
				vm.material.basePrice = vm.material.convertedPrice * vm.material.weight;
				updateBasePriceDependencies();
				vm.material.extraCharge = vm.extraChargeAbsolute;
			}

			function updateConvertedPrice() {
				if (vm.config.ims.materials.priceConversion.enabled) {
					//var equation = FormatterService.format(vm.config.ims.materials.priceConversion.toConversionPrice, vm.material);
					vm.material.convertedPrice = vm.material.basePrice / vm.material.weight;
				}
			}

			function updateMaterial() {
				if (vm.materialForm.$invalid) {
					return;
				}

				imsMaterials.updateMaterial(vm.material)
					.then(function (response) {
						vm.material = response;
						$translate.refresh();
						$state.go('app.materials');
					})
					.catch(function (err) {
						nuitUtils.showErrorToast('MATERIALS.ERROR_UPDATING_MATERIAL');
					});
			}

			/**
			 * Searches the color with the given name or code.
			 * @param {String} term - search term
			 * @returns {Array}
			 */
			function searchColors(term) {
				// Generate container for results
				var results = [];

				// Search for match
				term = term.toLowerCase();
				for (var i in vm.colors) {
					if (getColorNameString(vm.colors[i]).toLowerCase().indexOf(term) >= 0) {
						results.push(vm.colors[i]);
					}
				}

				// If no match then add everything
				if (results.length === 0) {
					return vm.colors;
				} else{
					return results;
				}
			}

			/**
			 * Returns the name-string of the given color
			 * @param {Color} color
			 * @returns {String}
			 */
			function getColorNameString(color) {
				return color.code + ' - ' + $filter('nuitTranslate')(color.name);
			}

			/**
			 * Resets the front color.
			 */
			function resetFrontColor() {
				vm.material.colorFront = null;
				vm.materialForm.$setDirty();
				vm.updateName();
			}

			/**
			 * Resets the back color.
			 */
			function resetBackColor() {
				vm.material.colorBack = null;
				vm.materialForm.$setDirty();
			}

			function showAddCuttingDialog() {
				$mdDialog.show(createCuttingDialog())
					.then(function (cutting) {
						if (cutting.type === 'coil') {
							return CuttingsService.addCoil(vm.materialId, cutting);
						}
						return CuttingsService.addSheet(vm.materialId, cutting);
					})
					.then(function () {
						nuitUtils.showSuccessToast('MATERIALS.CUTTING_ADDED_SUCCESSFULLY');
					})
					.catch(function (err) {
						if (!err) {
							return;
						}
						nuitUtils.showErrorToast('MATERIALS.ERROR_ADDING_CUTTING');
					});
			}

			function editCutting(cutting) {
				$mdDialog.show(createCuttingDialog(cutting))
					.then(function (updatedCutting) {
						if (updatedCutting.type === 'coil') {
							return CuttingsService.updateCoil(updatedCutting);
						}
						return CuttingsService.updateSheet(updatedCutting);
					})
					.then(function () {
						nuitUtils.showSuccessToast('MATERIALS.CUTTING_UPDATE_SUCCESSFULL');
					})
					.catch(function (err) {
						if (!err) {
							return;
						}
						nuitUtils.showErrorToast('MATERIALS.ERROR_UPDATING_CUTTING');
					});
			}

			function deleteCutting(cutting) {
				nuitUtils.showDeleteConfirmation()
					.then(function () {
						if (cutting.type === 'coil') {
							return CuttingsService.deleteCoil(cutting);
						}
						return CuttingsService.deleteSheet(cutting);
					})
					.then(function () {
						nuitUtils.showSuccessToast('MATERIALS.DELETE_CUTTING_SUCCESSFULL');
					})
					.catch(function (err) {
						if (!err) {
							return;
						}
						nuitUtils.showErrorToast('MATERIALS.ERROR_DELETING_CUTTING');
					});
			}

			function removeAttribute(index) {
				MaterialAttributesService.remove(vm.material, index);
				vm.materialForm.$setDirty();
			}

			function reloadCompanies() {
				if (vm.config.ims.companies.enabled && !vm.companiesLoaded) {
					CompanyService.reload()
						.then(function (companies) {
							vm.companiesLoaded = true;
							vm.companies = companies;
						});
				}
			}

			function loadSelectedCompanies() {
				// companies may be null instead of an array on migrated materials
				if (!vm.config.ims.companies.enabled || !angular.isArray(vm.material.companies)) {
					return;
				}

				vm.material.companies.forEach(function (companyId, index) {
					CompanyService.getById(companyId)
						.then(function (company) {
							vm.selectedCompanies[index] = company;
						});
				});
			}

			function selectCompany() {
				if (!vm.material.companies) {
					vm.material.companies = [];
				}

				if (vm.material.companies.indexOf(vm.currentCompanyId) === -1) {
					var company = CompanyService.getByIdOffline(vm.currentCompanyId);

					vm.material.companies.push(company.id);
					vm.selectedCompanies.push(company);
					vm.currentCompanyId = null;
					vm.materialForm.$setDirty();
				}
			}

			function removeCompany(index) {
				vm.selectedCompanies.splice(index, 1);
				vm.material.companies.splice(index, 1);
				vm.materialForm.$setDirty();
			}

			function clearSearchTerm() {
				vm.searchTerm = '';
			}
		}
	}

	()
);

(function () {
	'use strict';

	angular
		.module('app.materials')
		.controller('MaterialDetailsBendingController', MaterialDetailsBendingController);

	function MaterialDetailsBendingController(
		$mdDialog,
		$state,
		nuitUtils,
		BendingMachineService
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.materialId = $state.params.materialId;
		vm.machines = BendingMachineService.machines;        // Array with available bending machines
		vm.materials = BendingMachineService.materials;
		vm.bendings = BendingMachineService.bendings;
		vm.availableMachines = BendingMachineService.availableMachines;
        //*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.getMachineName = getMachineName;
		vm.getMetaData = getMetaData;
		vm.showAddBendingDialog = showAddBendingDialog;
		vm.editBending = editBending;
		vm.deleteBending = deleteBending;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createBendingDialog(bending) {
			return {
				controller: 'BendingDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/merchandising.materials/dialogs/bending/bending-dialog.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					Bending: angular.extend({}, bending)
				}
			};
		}

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			BendingMachineService
				.reload()
				.then(function(){
					BendingMachineService.reloadBendings(vm.materialId)
						.then(function(){
							BendingMachineService.updateAvailableMachines();
						});
				})
				.catch(function () {
					nuitUtils.showErrorToast('MATERIALS.ERROR_LOADING_BENDING_MACHINES');
				});
		}

		function getMachineName(id)
		{
			for(var i=0;i<vm.machines.length;i++)
			{
				if(id===vm.machines[i].id){
					return vm.machines[i].name;
				}
			}

			return '-';
		}

		function getMetaData(bending)
		{
			return bending.bendingMaterialId?bending.bendingMaterialId:'-';
		}

		function showAddBendingDialog() {
			$mdDialog.show(createBendingDialog())
				.then(function () {
					nuitUtils.showSuccessToast('MATERIALS.CUTTING_ADDED_SUCCESSFULLY');
				})
				.catch(function (err) {
					if (!err) {
						return;
					}
					nuitUtils.showErrorToast('MATERIALS.ERROR_ADDING_CUTTING');
				});
		}

		function editBending(bending) {
			$mdDialog.show(createBendingDialog(bending))
				.then(function () {
					nuitUtils.showSuccessToast('MATERIALS.CUTTING_ADDED_SUCCESSFULLY');
				})
				.catch(function (err) {
					if (!err) {
						return;
					}
					nuitUtils.showErrorToast('MATERIALS.ERROR_ADDING_CUTTING');
				});
		}

		function deleteBending(bending) {
			nuitUtils.showDeleteConfirmation().then(function () {
				BendingMachineService.deleteBending(vm.materialId,bending.bendingMachineId)
					.then(function (response) {
						BendingMachineService.updateAvailableMachines();
						nuitUtils.showSuccessToast();
					})
					.catch(function (err) {
						nuitUtils.showErrorToast();
					});
			});
		}
	}
}());

(function () {
    'use strict';

    angular
        .module('app.materials')
        .controller('MaterialComposeController', MaterialComposeController);

    /** @ngInject */
    function MaterialComposeController($scope, $q, $timeout, $state, $filter, imsMaterials, imsColors, nuitUnits, imsTranslation, nuitConfig, nuitUtils, MaterialAttributesService) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        vm.config = nuitConfig.getCurrent();                    // Contains the nuit config
        vm.colors = imsColors.colors;                           // Array with all possible rals
        vm.groups = imsMaterials.groups;                        // Array with all possible raw materials
        vm.material = {customData: {customName: false}};                                       // Contains new material
        vm.selectedLanguage = imsTranslation.language;          // Contains the currently selected language
        vm.selectedFrontColor = null;                           // The selected front color
        vm.selectedBackColor = null;                            // The selected back color
        vm.editFrontColor = false;                              // True if front color is editable
        vm.editBackColor = false;                               // True if back color is editable
        vm.unit = nuitUnits;                                      // Utility object to retrieve units and step
		vm.attributes = MaterialAttributesService.attributes;
		vm.selectedAttribute = null;
		vm.favorites = vm.config.ims.materials.details.favorites;
		vm.searchTerm = '';
		//*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        vm.init = init;
        vm.saveMaterial = saveMaterial;
        vm.updateName = updateName;
        vm.searchColors = searchColors;
        vm.resetFrontColor = resetFrontColor;
        vm.resetBackColor = resetBackColor;
        vm.getColorNameString = getColorNameString;
        vm.getColorById = imsColors.getColorById;
        vm.toggleSidenav = $scope.$parent.vm.toggleSidenav;
		vm.addAttribute = MaterialAttributesService.add;
		vm.removeAttribute = removeAttribute;
		vm.getAttributeName = MaterialAttributesService.getName;
		vm.clearSearchTerm = clearSearchTerm;
		//*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // METHODS
        //*******************************************
        /**
         * Initializes this controller.
         */
        function init() {
            // Reloads all required elements
            imsMaterials.reloadGroups();
            imsColors.reload();
            MaterialAttributesService.reload();
        }
        /**
         * Sends and stores the new material in the
         * customer database. Changes the app state
         * on success.
         */
        function saveMaterial() {
            // Return if form is invalid
            if (vm.materialForm.$invalid) {
                return;
            }

            // Stores the material in the database
            imsMaterials
                .add(vm.material)
                .then(function (material) {
                    $state.go('app.materials.detail', {materialId: material.id});
                    nuitUtils.showSuccessToast();
                })
                .catch(nuitUtils.showErrorToast);
        }
        /**
         * Updates the dynamically generated name.
         * @returns {Promise}
         */
        /*
        function updateName() {
            if (!angular.isDefined(vm.material.rawMaterialId)
                || !angular.isDefined(vm.material.thickness)
                || !angular.isDefined(vm.material.colorFront)
                || vm.customName) {
                return;
            }

            return $timeout(function () {
                var groupTranslationKey = imsMaterials.getGroupById(vm.material.rawMaterialId).translation;
                var frontColor = imsColors.getColorById(vm.material.colorFront);

                return imsTranslation
                    .getTranslationsOfKeys(groupTranslationKey)
                    .then(function (translations) {
                        var translatedGroup = translations[0];

                        var fallbackGroupTranslation = translatedGroup['en'] || translatedGroup[Object.keys(translatedGroup)[0]];
                        var fallbackColorTranslation = frontColor.name['en'] || frontColor.name[0];

                        if (!vm.material.name) {
                            vm.material.name = {};
                        }

                        for (var i in vm.config.languages) {
                            var currLang = vm.config.languages[i];
                            var currGroup = translatedGroup[currLang] || fallbackGroupTranslation;
                            var currColor = frontColor.name[currLang] || fallbackColorTranslation;

                            var length = $filter('nuitUnit')(vm.material.thickness, 'thickness');
                            var result = vm.config.ims.materials.nameFormat;
                            result = result
                                .replace('#group', currGroup)
                                .replace('#thickness', length)
                                .replace('#colorFront', imsColors.getColorById(vm.material.colorFront).code + ' - ' + currColor);
                            vm.material.name[currLang] = result;
                        }
                    })
                    .catch(nuitUtils.showErrorToast);
            });
        }*/
		function updateName() {
			if (!angular.isDefined(vm.material.rawMaterialId)
				|| !angular.isDefined(vm.material.thickness)
				|| vm.material.customData.customName) {
				return;
			}

			var frontColor = imsColors.getColorById(vm.material.colorFront);
			var translatedGroup = $filter('nuitTranslate')(imsMaterials.getGroupById(vm.material.rawMaterialId).name, '???');

			var fallbackGroupTranslation = translatedGroup['en'] || $filter('nuitTranslate')(imsMaterials.getGroupById(vm.material.rawMaterialId).name, '???');
			var fallbackColorTranslation = null;
			if (frontColor === undefined){
				console.log('why');
				fallbackColorTranslation = frontColor.name['en'] || frontColor.name[0];
			}
			if(frontColor == null){
				fallbackColorTranslation = '';
				console.log('hier null');
			}

			if (!vm.material.name) {
				vm.material.name = {};
			}
			console.log(frontColor);
			console.log('name upgedated');

			for (var i in vm.config.languages) {
				var currLang = vm.config.languages[i];
				var currGroup = translatedGroup[currLang] || fallbackGroupTranslation;
				var currColor =  '';
				if(frontColor === null){
					currColor = fallbackColorTranslation;
				}else{
					currColor = frontColor.name[currLang];
				}

				var length = $filter('nuitUnit')(vm.material.thickness, 'thickness');
				var result = vm.config.ims.materials.nameFormat;
				if (frontColor !== null){
					result = result
						.replace('#group', currGroup)
						.replace('#thickness', length)
						.replace('#colorFront', imsColors.getColorById(vm.material.colorFront).code + ' - ' + currColor);
					vm.material.name[currLang] = result;
				}else{
					result = result
						.replace('#group', currGroup)
						.replace('#thickness', length)
						.replace('#colorFront', '');
					vm.material.name[currLang] = result;
				}
			}
		}
        /**
         * Resets the front color.
         */
        function resetFrontColor() {
            vm.material.colorFront = null;
            vm.frontColorText = '';
            vm.selectedFrontColor = null;
            vm.editFrontColor = false;
            vm.materialForm.$setDirty();
			vm.updateName();
        }
        /**
         * Resets the back color.
         */
        function resetBackColor() {
            vm.material.colorBack = null;
            vm.backColorText = '';
            vm.selectedBackColor = null;
            vm.editBackColor = false;
            vm.materialForm.$setDirty();
        }
        /**
         * Filters all colors and returns all colors
         * which include the given string either in
         * their name or in their code.
         * @param {String} term - search term
         * @returns {Array}
         */
        function searchColors(term) {
                // Generate container for results
                var results = [];

                // Search for match
                term = term.toLowerCase();
                for (var i in vm.colors) {
                    if (getColorNameString(vm.colors[i]).toLowerCase().indexOf(term) >= 0) {
                        results.push(vm.colors[i]);
                    }
                }

                // If no match then add everything
                if (results.length === 0) {
					return vm.colors;
                } else{
					return results;
				}
        }
        /**
         * Returns the name-string of the given color.
         * @param {Color} color
         * @returns {String}
         */
        function getColorNameString(color) {
            return color.code + ' - ' + $filter('nuitTranslate')(color.name);
        }

		function removeAttribute(index)
		{
			MaterialAttributesService.remove(vm.material,index);
			vm.materialForm.$setDirty();
		}
		function clearSearchTerm() {
			vm.searchTerm = '';
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.errors', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider) {
		$stateProvider
			.state('app.errors', {
				views: {
					'main@': {
						templateUrl: 'app/ims/layouts/content-only.html',
						controller: 'ErrorsController as vm'
					}
				}
			})
			.state('app.errors.error-500', {
				views: {
					'content@app.errors': {
						templateUrl: 'app/main/error/views/error-500.html'
					}
				}
			})
			.state('app.errors.error-403', {
				views: {
					'content@app.errors': {
						templateUrl: 'app/main/error/views/error-403.html'
					}
				}
			})
			.state('app.errors.placeholder', {
				url: '/ims-next-placeholder',
				views: {
					'content@app.errors': {
						templateUrl: 'app/main/error/views/placeholder.html'
					}
				}
			});
	}
}());

(function () {
	'use strict';

	angular
		.module('app.errors')
		.controller('ErrorsController', ErrorsController);

	/** @ngInject */
	function ErrorsController($scope, $rootScope, $window) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// EVENTS
		//*******************************************
		var unregisterViewContentAnimationEndedEvent = $scope.$on('$viewContentAnimationEnded', onViewContentAnimationEnded);

		//*******************************************
		// EXPOSE METHODS
		//*******************************************
		vm.historyBack = historyBack;

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		function onViewContentAnimationEnded(event) {
			if (event.targetScope.$id === $scope.$id) {
				// Remove the splash screen
				$rootScope.$broadcast('msSplashScreen::remove');

				// Unregister event handler
				unregisterViewContentAnimationEndedEvent();
			}
		}

		//*******************************************
		// METHODS
		//*******************************************
		function historyBack() {
			$window.history.back();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.printer', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider, PRINTER_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.printer', {
				url: '/printer',
				views: {
					'content@app': {
						templateUrl: 'app/main/devices.printer/views/printer.html'
					},
					'body@app.printer': {
						templateUrl: 'app/main/devices.printer/views/printer-list.html',
						controller: 'PrinterListController as vm'
					}
				},
				permissions: 'ims.printer.enabled'
			})
			.state('app.printer.compose', {
				url: '/add',
				views: {
					'body@app.printer': {
						templateUrl: 'app/main/devices.printer/views/printer-details.html',
						controller: 'PrinterDetailsController as vm'
					}
				},
				permissions: 'ims.printer.enabled'
			})
			.state('app.printer.detail', {
				url: '/:printerId',
				views: {
					'body@app.printer': {
						templateUrl: 'app/main/devices.printer/views/printer-details.html',
						controller: 'PrinterDetailsController as vm'
					}
				},
				permissions: 'ims.printer.enabled'
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
        msNavigationServiceProvider.saveItem('devices.printer', {
			title: 'Printer',
			icon: 'icon-printer',
			state: 'app.printer',
			translate: 'PRINTER.PRINTER',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.printer.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// API ROUTES
		//*******************************************
		nuitApiProvider.register('printer.types', '/printer/types', { allow: ['get'] });
		nuitApiProvider.register('printer.printers', '/printer/printers', { allow: ['get'] });
		nuitApiProvider.register('printers.one', '/printer/printers/:id', { allow: ['get', 'put', 'delete'] });
		nuitApiProvider.register('printers.create', '/printer/printers', { allow: ['post'] });
		nuitApiProvider.register('printer.jobs.create', 'printer/jobs', { allow: ['post'] });

		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(PRINTER_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.printer')
		.factory('PrinterService', PrinterService);

	/** @ngInject */
	function PrinterService(nuitApi, $log) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _printers = [];
		//*******************************************
		
		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			getPrinterTypes: getPrinterTypes,
			getPrinters: getPrinters,
			getPrinterById: getPrinterById,
			addPrinter: addPrinter,
			updatePrinter: updatePrinter,
			deletePrinter: deletePrinter,
			addPrintJob: addPrintJob
		};

		//*******************************************
		/// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'printers', {
			get: getPrintersProperty
		});

		//*******************************************
		return service;
		//*******************************************

		//*******************************************
        // PUBLIC METHODS
		//*******************************************
		function getPrintersProperty() {
			return _printers;
		}

		function getPrinterTypes() {
			return nuitApi('printer.types')
				.get()
				.then(function (response) {
					return response.data;
				})
				.catch(function (error) {
					$log.warn('Error loading printer types', error);
					throw new Error('Error loading printer types');
				});
		}

		function getPrinters() {
			return nuitApi('printer.printers')
				.get()
				.then(function (response) {
					var printers = response.data;
					_printers.splice(0, _printers.length);

					for (var i in printers) {
						_printers.push(printers[i]);
					}

					return printers;
				})
				.catch(function (error) {
					$log.warn('Error loading printers', error);
					throw new Error('Error loading printers');
				});
		}

		function getPrinterById(printerId) {
			return nuitApi('printers.one', printerId)
				.get()
				.then(function (response) {
					return response.data;
				})
				.catch(function (error) {
					$log.warn('Error loading printer with id ' + printerId, error);
					throw new Error('Error loading printer with id' + printerId);
				});
		}

		function addPrinter(printer) {
			return nuitApi('printers.create')
				.post(printer)
				.then(function (response) {
					_printers.push(response.data);
					
					return response.data;
				})
				.catch(function (error) {
					$log.warn('Error creating printer', error);
					throw new Error('Error creating printer');
				});
		}

		function updatePrinter(printer) {
			return nuitApi('printers.one', printer.id)
				.put(printer)
				.then(function (response) {
					var updatedPrinter = response.data;
					angular.merge(printer, updatedPrinter);
					
					return printer;
				})
				.catch(function (error) {
					$log.warn('Error updating printer', error);
					throw new Error('Error updating printer');
				});
		}

		function deletePrinter(printer) {
			return nuitApi('printers.one', printer.id)
				.delete()
				.then(function (response) {
					var index = _printers.indexOf(printer);
					_printers.splice(index, 1);

					return _printers;
				})
				.catch(function (error) {
					$log.warn('Error deleting printer', error);
					throw new Error('Error deleting printer');
				});
		}

		function addPrintJob(printJob) {
			return nuitApi('printer.jobs.create')
				.post(printJob)
				.then(function (response) {
					return response.data;
				})
				.catch(function (error) {
					$log.warn('Error creating print job', error);
					throw new Error('Error creating print job');
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.printer')
		.controller('PrinterListController', PrinterListController);

	/** @ngInject */
	function PrinterListController($state, $scope, nuitUtils, imsTranslation, PrinterService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.items = [];
		vm.translation = imsTranslation;
		vm.loadingItems = false;
		vm.term = '';

		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openItem = openItem;
		vm.deleteSelectedItems = deleteSelectedItems;
		vm.matchesFilter = matchesFilter;

		//*******************************************


		//*******************************************
		// INITIALIZATION
		//*******************************************

		init();

		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			vm.loadingItems = true;

			PrinterService.getPrinters()
				.then(function (response) {
					vm.items = response;
				})
				.finally(function () {
					vm.loadingItems = false;
				});
		}

		function openItem(item) {
			$state.go('app.printer.detail', { printerId: item.id });
		}

		function deleteSelectedItems(item) {
			nuitUtils.showDeleteConfirmation()
				.then(function() {

					PrinterService.deletePrinter(item)
						.then(function (response) {
							vm.items = response;
						});

			});
		}

		function matchesFilter(item) {
			return vm.term === '' || item.name.toLowerCase().includes(vm.term.toLowerCase());
		}
	}
}());

(function () {
    'use strict';  

	angular
		.module('app.printer')
        .controller('PrinterDetailsController', PrinterDetailsController);
        
    /** @ngInject */
	function PrinterDetailsController($state, $q, nuitUtils, imsTranslation, PrinterService) {
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
        //*******************************************
        
        vm.printerId = $state.params.printerId;
        vm.loadingItem = false;
        vm.printer = {};
        vm.printerTypes = [];
        vm.translation = imsTranslation;
        
        //*******************************************

		//*******************************************
		// METHODS (Exposure)
        //*******************************************
        
        vm.savePrinter = savePrinter;

        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        
        init();
        
        //*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
        //*******************************************
        
        function init() {
            vm.loadingItem = true;

            var promises = [];

            promises.push(PrinterService.getPrinterTypes()
                .then(function (response) {
                    vm.printerTypes = response;
                    return response;
                }));
            
            if (vm.printerId && vm.printerId > 0) {
                promises.push(PrinterService.getPrinterById(vm.printerId)
                    .then(function (response) {
                        vm.printer = response;
                        return response;
                    }));
            }

            $q.all(promises)
                .catch(function() {
                    nuitUtils.showErrorToast();
                    $state.go('app.printer');
                })
                .finally(function() {
                    vm.loadingItem = false;
                });
        }

        function savePrinter() {
            var promise = null;

            if (vm.printerId && vm.printerId > 0) {
                // Update existing printer
                promise = PrinterService.updatePrinter(vm.printer);    
            }
            else {
                // Create new printer
                promise = PrinterService.addPrinter(vm.printer);
            }

            promise
                .then(function (response) {
                    nuitUtils.showSuccessToast();
                    $state.go('app.printer');
                })
                .catch(function (error) {
                    nuitUtils.showErrorToast();
                });
        }

        //*******************************************
    }
})();
(function () {
	'use strict';

	angular
		.module('app.controlling.user', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider,nuitApiProvider, CONTROLLING_USERS) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.controlling', {
				url: '/controlling'
			})
			.state('app.controlling.user', {
				url: '/controlling/users?term',
				views: {
					'content@app': {
						templateUrl: 'app/main/controlling.users/views/user-list.html',
						controller: 'UsersListController as vm'
					}
				},
				reloadOnSearch: false
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('controlling.user', {
			title: 'users',
			icon: 'icon-chart-bar',
			state: 'app.controlling.user',
			translate: 'CONTROLLING.USERS_NAV',
			weight: 20,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.usersControlling.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(CONTROLLING_USERS);
		//*******************************************

		//*******************************************
		// ROUTES
		//*******************************************
		nuitApiProvider.register('controlling.users', '/controlling/orders?view=user', {allow: ['get']});

		//*******************************************

	}
}());

(function () {
	'use strict';

	angular
		.module('app.controlling.user')
		.service('ControllingUsersService', ControllingUsersService);

	/** @ngInject */
	function ControllingUsersService($q, $timeout, nuitApi, nuitDataService) {
		var _userData = [];

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			reload: reload
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'userData', {
			get: function () {
				return _userData;
			}
		});

		return service;

		//*******************************************
		// METHODS
		//*******************************************


		function reload(firstDay, lastDay) {
			return nuitApi('controlling.users').get({
				start: firstDay,
				end: lastDay
			})
				.then(function (response) {
					return nuitDataService.replaceAll(_userData, response.data);
				});
		}

	}
}());

(function () {
	'use strict';

	angular
		.module('app.controlling.user')
		.controller('UsersListController', UsersListController);

	/** @ngInject */
	function UsersListController(
		$state,
		$timeout,
		DotNotationService,
		$scope,
		$q,
		$filter,
		$interval,
		OrderService,
		nuitConfig,
		nuitUtils,
		ListSelectionService,
		FormatterService,
		FilterCountService,
		nuitDataService,
		ControllingUsersService,
		UserService,
		RoleService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.filteredEntities = [];
		vm.currentPage = [];
		vm.currentPageEntities = [];
		vm.loading = true;
		vm.config = nuitConfig.getCurrent();
		vm.allData = ControllingUsersService.userData;
		vm.userData = [];
		vm.searchText = $state.params.term || '';
		vm.filterCount = FilterCountService.get('controlling.users', true);
		vm.roles = RoleService.roles;
		vm.filterRole = 'all';
		vm.startFilterDate = '';
		vm.endFilterDate = '';
		vm.selectStartAndEnd = false;
		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************
		vm.getPercent = getPercent;
		vm.search = search;
		vm.changeFilterDate = changeFilterDate;
		vm.filterUsers = filterUsers;
		vm.checkEndFilterDate = checkEndFilterDate;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Thes event is fired whenever the state (or its params) change, including the initial state change
		 */
		function onStateChangeSuccess() {
			if (typeof $state.params.term !== 'undefined') {
				vm.searchText = $state.params.term;
			}
			filterAll();
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			setInitialDate();
			loadData().then(function () {
				filterAll();
				vm.loading = false;
			});
		}

		function setInitialDate() {
			vm.startFilterDate = new Date();
			vm.endFilterDate = new Date();
			vm.startFilterDate.setMonth(0);
			vm.startFilterDate.setDate(1);
			vm.startFilterDate.setHours(0,0,0,0);
			vm.endFilterDate.setMonth(12);
			vm.endFilterDate.setDate(0);
			vm.endFilterDate.setHours(23,59,59,0);
		}

		function loadData() {
			vm.startFilterDate.setHours(0,0,0,0);
			vm.endFilterDate.setHours(23,59,59,0);
			var start = angular.copy(parseInt( vm.startFilterDate.getTime()/1000));
			var end = angular.copy(parseInt( vm.endFilterDate.getTime()/1000));
			vm.userData = [];
			return ControllingUsersService.reload(start, end)
				.then(function () {
					var promises = [];
					promises.push(RoleService.reload());
					angular.forEach(vm.allData[1], function (data) {
						promises.push(UserService.getUserById(data.userId)
							.then(function (user) {
								vm.userData.push({
									user: user,
									id: data.userId,
									ordersCount: data.ordersCount
								});
							})
							.catch(function () {
								vm.userData.push({id: data.userId, ordersCount: data.ordersCount});
							}));
					});
					return $q.all(promises);
				});
		}

		function getPercent(count) {
			var all = vm.allData[0];
			return parseFloat((count / all * 100)).toFixed(2);
		}

		function search() {
			$state.go('app.controlling.user', {term: vm.searchText, mode: vm.mode});
		}

		function filterAll() {
			vm.filterCount.resetAll();
			vm.filteredEntities = [];

			for (var i = 0; i < vm.userData.length; i++) {

				var user = vm.userData[i];
				if (matchesSearchTerm(user)) {
					vm.filteredEntities.push(user);
				}
				vm.filterCount.increment(vm.userData[i].id);
			}
			vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, 'ordersCount', true);
		}

		function matchesSearchTerm(user) {
			if (vm.searchText === '') {
				return true;
			} else {
				if (user.user !== undefined) {
					var firstName = user.user.firstName.toLowerCase();
					var lastName = user.user.lastName.toLowerCase();
					vm.searchText = vm.searchText.toLowerCase();
					if (firstName.includes(vm.searchText) || lastName.includes(vm.searchText)) {
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
		}

		function changeFilterDate() {
			vm.selectStartAndEnd = !vm.selectStartAndEnd;
			if (!vm.selectStartAndEnd) {
				vm.loading= true;
				loadData().then(function () {
					filterAll();
					filterUsers();
					vm.loading = false;
				});
			}
		}

		function filterUsers() {
			vm.filterCount.resetAll();
			vm.filteredEntities = [];

			for (var i = 0; i < vm.userData.length; i++) {
				var user = vm.userData[i];
				if(vm.filterRole === 'all'){
					vm.filteredEntities.push(user);
				}
				var role = parseInt(vm.filterRole);
				if (user.user && user.user.roleId === role ) {
					vm.filteredEntities.push(user);
				}
				vm.filterCount.increment(vm.userData[i].id);
			}
			vm.filteredEntities = $filter('orderBy')(vm.filteredEntities, 'ordersCount', true);
		}

		function checkEndFilterDate() {
			var start = angular.copy(parseInt( vm.startFilterDate.getTime()/1000));
			var end = angular.copy(parseInt( vm.endFilterDate.getTime()/1000));
			if(start > end){
				vm.endFilterDate = new Date(start*1000);
			}
		}
	}
}());

(function () {
    'use strict';

    angular
        .module('app.auth', [])
        .config(config);

    /** @ngInject */
    function config($translateProvider, $stateProvider) {
        //*******************************************
		// TRANSLATIONS (DEFAULT)
        //*******************************************
//        $translateProvider.translations('en',{
//            'LOGIN.TITLE': 'Please enter your data',
//            'LOGIN.EMAIL': 'Email',
//            'LOGIN.PASSWORD': 'Password',
//            'LOGIN.LOG_IN': 'Login'
//        });
//        $translateProvider.translations('de',{
//            'LOGIN.TITLE': 'Bitte melden Sie sich an',
//            'LOGIN.EMAIL': 'E-Mail',
//            'LOGIN.PASSWORD': 'Passwort',
//            'LOGIN.LOG_IN': 'Anmelden'
//        });
        //*******************************************

        //*******************************************
        // STATES
        //*******************************************
        $stateProvider
            .state('app.auth', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/ims/layouts/content-only.html',
                        controller: 'IndexController as vm'
                    }
                },
                bodyClass: 'login'
            })
            .state('app.auth.login', {
                url: '/login?target&token&mode',
                views: {
                    'content@app.auth': {
                        templateUrl: 'app/main/auth/views/login.html',
                        controller: 'LoginController as vm'
                    }
                },
                params: {
                    target: null,
					mode: null
                },
				onEnter: function ($window, $timeout, $location, $state, $translate, nuitAuth, msUtils, nuitConfig) {
					var browser = msUtils.detectBrowser();
					var mode = new URLSearchParams(location.search).get('mode');

					if(mode){
						$window.sessionStorage.setItem('mode', mode);
					}else{
						$window.sessionStorage.removeItem('mode');
					}

					// Leave the login area if the user is already logged in
					$timeout(function () {
						if ($state.params.token !== undefined) {
							nuitAuth
								.loginWithToken($state.params.token, true)
						}
					}, ($state.params.token !== null && browser.browser !== 'chrome') ? 5000 : 750);
				}
            })
            .state('app.auth.reset', {
                url: '/password-reset',
                views: {
                    'content@app.auth': {
                        templateUrl: 'app/main/auth/views/reset.html',
                        controller: 'PasswordResetController as vm'
                    }
                }
            })
			.state('app.auth.create', {
				url: '/create-env?key',
				views: {
					'content@app.auth': {
						templateUrl: 'app/main/auth/views/create.html',
						controller: 'CreateController as vm'
					}
				}
			});
        //*******************************************
    }
})();

(function () {
	'use strict';

	angular
		.module('app.auth')
		.controller('PasswordResetController', PasswordResetController);

	/** @ngInject */
	function PasswordResetController(nuitAuth) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.error = null;
		vm.form = {};

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.reset = reset;

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Creates login attempt and shows according error
		 */
		function reset() {
			vm.error = null;

			nuitAuth
				.login({
					email: vm.form.email,
					password: vm.form.password
				})
				.catch(function (response) {
					if (response.data && response.data.result) {
						vm.error = response.data.result.message;
					}
				});
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('app.auth')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($timeout, nuitAuth, $state) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        vm.error = null;
        vm.form = {};
        vm.environments = [];
        //*******************************************

        //*******************************************
        // EXPOSURE
        //*******************************************
        vm.login = login;

		vm.contentOnly = $state.params.mode==='content' && window.self !== window.top;

		//hiding login if we are in content mode, only show it after some time as fallback
		if(vm.contentOnly) {
			$timeout(function () {
				vm.contentOnly = false;
			}, 5000);
		}
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // METHODS
        //*******************************************
        /**
         * Creates login attempt and shows according error.
         */
        function login() {
            vm.error = null;

            nuitAuth
                .login({
                    email: vm.form.email,
                    password: vm.form.password,
                    environment: vm.form.environment
                })
                .catch(function (response) {
                    if (response.status === 400 && Array.isArray(response.data)) {
                        vm.environments = response.data;
                        $timeout(function(){
							$('#environments').click();
							$timeout(function(){
								$('#search').focus();
							},100);
						},100);
                    }else{
						vm.error = response.data.message;
					}
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth')
        .controller('CreateController', CreateController);

    /** @ngInject */
    function CreateController($timeout,$state,nuitAuth, $filter) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        vm.error = null;
        vm.form = {
			user:{
				email: '',
				password: ''
			},
			name: '',
			key: $state.params.key
		};
        vm.language = window.navigator.language.split('-')[0].toLowerCase();

		if(['en','de'].indexOf(vm.language)===-1){
			vm.language = 'en';
		}

		vm.translations = {
			title:{
				en: 'Please enter your data',
				de: 'Bitte geben Sie Ihre Daten ein'
			},
			key:{
				en: 'Key',
				de: 'Key'
			},
			environment:{
				en: 'Environment Name',
				de: 'Umgebungsname'
			},
			email:{
				en: 'Email',
				de: 'Email'
			},
			password:{
				en: 'Password',
				de: 'Passwort'
			},
			create:{
				en: 'Create',
				de: 'Anlegen'
			},
			error:{
				en: 'An error has occured',
				de: 'Ein Fehler ist aufgetreten'
			}
		};
		vm.inProgress = false;
        //*******************************************

        //*******************************************
        // EXPOSURE
        //*******************************************
        vm.create = create;
		vm.getTranslation = getTranslation;
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // METHODS
        //*******************************************
        function create() {
            vm.error = null;
			vm.inProgress = true;

            nuitAuth
                .create(vm.form)
				.then(function(){
					window.setTimeout(getStatusCreate,1000);
				})
                .catch(function () {
					vm.error = $filter('nuitTranslate')(vm.translations.error,undefined,vm.language);
					vm.inProgress = false;
                });
        }

		function getStatusCreate(){
			nuitAuth.getStatusCreate(vm.form.key)
				.then(function (data){
					if(data.status==='created'){
						$state.go('app.auth.login');
						vm.inProgress = false;
					}else if(data.status==='creating'){
						window.setTimeout(getStatusCreate,5000);
					}else if(data.status==='error'){
						vm.error = data.err;
						vm.inProgress = false;
					}else{
						console.error('received invalid status', data);
						vm.inProgress = false;
					}
				})
				.catch(function(){
					vm.error = $filter('nuitTranslate')(vm.translations.error,undefined,vm.language);
				});
		}

		function getTranslation(object){
			return object[vm.language];
		}
    }
})();

(function () {
	'use strict';

	angular
		.module('app.admin.translations', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider, nuitApiProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.adminTranslations', {
				url: '/admin/translations/',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.translations/views/admin-translations.html',
						controller: 'adminTranslationsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.translations.enabled'
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('admin.translations', {
			title: 'Translations',
			icon: 'icon-earth',
			state: 'app.adminTranslations',
			translate: 'ADMIN.TRANSLATIONS_NAV',
			weight: 40,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().admin.translations.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// API
		//*******************************************
		nuitApiProvider.register('translations.languages', '/languages', {allow: ['get']});
		nuitApiProvider.register('translations.all', '/translations?scope=global&enDefault=false', {allow: ['get']});
		nuitApiProvider.register('translations.add', '/translations?scope=global', {allow: ['post']});
		nuitApiProvider.register('translations.update', '/translations/:key', {
			allow: ['put'],
			params: {scope: 'global'}
		});
		nuitApiProvider.register('translations.delete', '/translations/:key', {
			allow: ['delete'],
			params: {scope:'global'}
		});
		nuitApiProvider.register('translations.csv', '/translation/import?scope=global', {allow: ['post']});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
			admin: {
				translations: {
					enabled: false
				}
			}
		};

		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
})();

(function () {
	'use strict';

	angular
		.module('app.admin.translations')
		.factory('nuitLanguage', nuitLanguage);

	function nuitLanguage(nuitApi, $log) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var table = {};
		var languages = [];
		var keyCount = 0;
		//*******************************************

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			addKey: addKey,
			deleteKey: deleteKey,
			reload: reload,
			getKeys: getKeys,
			getTable: getTable,
			getLanguages: getLanguages,
			getKeyCount: getKeyCount,
			updateKey: updateKey,
			uploadTranslations: uploadTranslations
		};
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		/**
		 * Initializes the service.
		 */
		function init() {
			nuitApi('translations.languages').get().then(function (response) {
				angular.forEach(response.data, function (langKey) {
					languages.push(langKey);
				});
			});

			reload();
		}

		function reload() {
			return nuitApi('translations.all')
				.get()
				.then(function (response) {
                    keyCount = 0;

                    // Delete all keys without changing pointer
                    var keys = getKeys();
                    for (var i = 0; i < keys.length; i++) {
                        delete table[keys[i]];
                    }

					var all = response.data;
					angular.forEach(all, function (pair, lang) {
						angular.forEach(pair, function (value, key) {
							if (!table[key]) {
								table[key] = {};
								keyCount++;
							}
							table[key][lang] = value;
						});
					});
					return table;
				})
				.catch(function (error) {
					$log.error('Error loading translations from remote server');
					throw error;
				});
		}

		function addKey(key, lang, value) {
			return nuitApi('translations.add')
				.post({key: key, lang: lang, value: value})
				.then(function () {
					if (!table[key]) {
						table[key] = {};
						keyCount++;
					}

					table[key][lang] = value;
					return table;
				})
				.catch(function (error) {
					$log.error('Error inserting translation key');
					throw error;
				});
		}

		function updateKey(key, lang, value) {
			return nuitApi('translations.update', key)
				.put({value: value, lang: lang},{scope:'global'})
				.then(function () {
					table[key][lang] = value;
					return table;
				})
				.catch(function (error) {
					$log.error('Error updating translation key');
					throw error;
				});
		}

		function deleteKey(key) {
			return nuitApi('translations.delete', key)
				.delete({scope:'global'})
				.then(function () {
					delete table[key];
					keyCount--;
					return table;
				})
				.catch(function (error) {
					$log.error('Error deleting translation key');
					throw error;
				});
		}

		function getTable() {
			return table;
		}

		function getLanguages() {
			return languages;
		}

		function getKeyCount() {
			return keyCount;
		}

		function getKeys() {
			return Object.keys(table);
		}

		function uploadTranslations(fileData) {
			var uploadPromise = nuitApi('translations.csv')
				.post(fileData, {}, {
					headers: {
						'Content-Type': undefined
					}
				});

			return uploadPromise
				.then(function () {
					// TODO: Backend should return inserted / updated translations to prevent the need of reloading all translations
					return reload();
				})
				.catch(function (error) {
					$log.error('Failed to upload translations!');
					throw error;
				});
		}
	}
})();

(function () {
    'use strict';

    angular
            .module('app.system')
            .controller('AdminTranslationsEditController', AdminTranslationsEditController);

    /** @ngInject */
    function AdminTranslationsEditController($mdDialog, nuitLanguage, Translation, Key, $translate) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.translation = Translation;
		vm.key = Key;
		vm.availableLanguages = $translate.getAvailableLanguageKeys();
		vm.newKey = !vm.key;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			$mdDialog.hide({
				translation: vm.translation,
				key: vm.key
			});
		}
    }
}());

(function () {
	'use strict';

	angular
		.module('app.admin.translations')
		.controller('adminTranslationsController', adminTranslationsController);

	/** @ngInject */
	function adminTranslationsController($scope, $mdDialog, $document, $translate, $q, $log, $mdToast, nuitLanguage, nuitUtils, imsTranslationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.loading = true;
		vm.languages = [];
		vm.translations = {};
		vm.nuitLanguage = nuitLanguage;
        vm.searchText = '';
        vm.filteredTranslations = [];
        vm.currentPageEntities = [];
        vm.currentPage = 0;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.isLoading = isLoading;
        vm.filterAll = filterAll;
		vm.showNewTranslationDialog = showNewTranslationDialog;
		vm.getTranslationCount = getTranslationCount;
		vm.showEditTranslationDialog = showEditTranslationDialog;
		vm.showImportTranslationsDialog = showImportTranslationsDialog;
		vm.deleteTranslation = deleteTranslation;
		vm.containsSearchText = containsSearchText;
		//*******************************************
        
        //*******************************************
		// INIT
		//*******************************************
		init();
		//*******************************************

        ////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createTranslateEditDialog(key) {
			return {
				controller: 'AdminTranslationsEditController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.translations/dialogs/translations.edit.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					Translation: angular.extend({}, vm.translations[key]),
					Key: key
				}
			};
		}

		function createTranslationsImportDialog() {
			return {
                controller: 'CsvImportController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/csv.import/csv.import.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					title: 'TRANSLATIONS.IMPORT_TRANSLATIONS',
					fileName: 'translations'
				}
            };
		}

		function createTranslationAddedToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('ADMIN.TRANSLATION_ADD_SUCCESS'))
				.position('right bottom');
		}

		function createTranslationEditedToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('ADMIN.TRANSLATION_EDIT_SUCCESS'))
				.position('right bottom');
		}

		function createTranslationEditFailedToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('ADMIN.TRANSLATION_EDIT_FAILED'))
				.position('right bottom');
		}

		function createTranslationDeleteFailedToast() {
			return $mdToast
				.simple()
				.textContent($translate.instant('ADMIN.TRANSLATION_DELETE_FAILED'))
				.position('right bottom');
		}

		function createTranslateDeleteConfirmDialog() {
			return $mdDialog.confirm()
				.title($translate.instant('APP.SURE_QUESTION_TITLE'))
				.htmlContent($translate.instant('APP.SURE_QUESTION_CONTENT'))
				.ok($translate.instant('APP.OK'))
				.cancel($translate.instant('APP.CANCEL'));
		}

		function init() {
			vm.languages = nuitLanguage.getLanguages();
			vm.translations = nuitLanguage.getTable();
            
            vm.nuitLanguage.reload().then(function () {
				vm.loading = false;
                filterAll();
			});
		}

		/**
		 * Returns true if the controller is still loading remote resources.
		 * Does not return true if cached values exist.
		 * @returns {Boolean}
		 */
		function isLoading() {
			return vm.loading && vm.nuitLanguage.getKeyCount() <= 0;
		}

		/**
		 * Displays the add translation dialog.
		 */
		function showNewTranslationDialog() {
			$mdDialog.show(createTranslateEditDialog())
				.then(function (newTranslation) {
					var key = newTranslation.key;
					var values = newTranslation.translation;
					var promises = [];

					angular.forEach(values, function (value, lang) {
						var promise = vm.nuitLanguage.addKey(key, lang, value);

						promise.catch(function (error) {
							console.log(error);
						});

						promises.push(promise);
					});

					$q.all(promises)
						.then(function () {
							$mdToast.show(createTranslationAddedToast());
							$translate.refresh();
                            filterAll();
						})
						.catch(function () {
							$log.error('Error updating translation');
							// TODO: update toast function
							$mdToast.show(createTranslationEditFailedToast());
						});
				})
				.catch(angular.noop);
		}

		function showEditTranslationDialog(key) {
			$mdDialog.show(createTranslateEditDialog(key))
				.then(function (newTranslation) {
					var key = newTranslation.key;
					var values = newTranslation.translation;
					var promises = [];

					angular.forEach(values, function (value, lang) {
						var promise = vm.nuitLanguage.updateKey(key, lang, value);

						promises.push(promise);
					});

					$q.all(promises)
						.then(function () {
							$mdToast.show(createTranslationEditedToast());
							$translate.refresh();
                            filterAll();
						})
						.catch(function () {
							$mdToast.show(createTranslationEditFailedToast());
						});
				})
				.catch(angular.noop);
		}

		function showImportTranslationsDialog() {
            $mdDialog
                .show(createTranslationsImportDialog())
                .then(function(fileData) {
					nuitLanguage
						.uploadTranslations(fileData)
						.then(function (response) {
							// Translations have been reloaded, need to set reference again
							vm.translations = nuitLanguage.getTable();
							$translate.refresh();
							nuitUtils.showSuccessToast();
                            filterAll();
						})
						.catch(function (error) {
							$log.error(error);
							nuitUtils.showErrorToast();
						});
                })
                .catch(angular.noop);
        }


		function deleteTranslation(key) {
			$mdDialog
				.show(createTranslateDeleteConfirmDialog())
				.then(function () {
					return vm.nuitLanguage.deleteKey(key);
				})
                .then(function () {
                    filterAll();
                })
				.catch(function (err) {
					if(err) {
						$mdToast.show(createTranslationDeleteFailedToast());
					}
				});
		}

		function containsSearchText(translation) {
			return imsTranslationService.containsSearchText(translation, vm.searchText);
		}

		/**
		 * Returns the total amount of translation keys.
		 * @returns {Integer}
		 */
		function getTranslationCount() {
			return nuitLanguage.getKeyCount();
		}
        
        function filterAll() {
            vm.filteredTranslations = [];
            for(var key in vm.translations) {
                if(vm.containsSearchText({key: key, values: vm.translations[key]})) {
                    vm.filteredTranslations.push({key: key, values: vm.translations[key] });
                }
            }
            console.log(vm.filteredTranslations);
        }
	}
})();



(function () {
	'use strict';

	angular
		.module('app.admin.status', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitApiProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.adminStatus', {
				url: '/admin/status',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.status/views/admin-status.html',
						controller: 'adminStatusController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.status.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('admin.status', {
			title: 'status',
			icon: 'icon-chart-bar',
			state: 'app.adminStatus',
			translate: 'STATUS.STATUS_NAV',
			weight: 100,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().admin.status.enabled;
			}
		});
        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
			admin: {
                status: {
                    enabled: false
                }
			}
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

/* global Chartist */

(function () {
	'use strict';

	angular
		.module('app.admin.status')
		.controller('adminStatusController', adminStatusController);

	function adminStatusController($sce, nuitApi, nuitAuth, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.dd = digitalDocuments();
        vm.sp = smartProductions();
        vm.sales = sales();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.rebuildEVO = rebuildEVO;
        vm.rebuildIMS = rebuildIMS;
        vm.getShopDebugURL = getShopDebugURL;
        vm.getDocumentDebugURL = getDocumentDebugURL;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////
        
        function init() {
        }
        
        function getShopDebugURL() {
            return $sce.trustAsResourceUrl(nuitApi.getBaseUrl() + 'shop/admin?access-token=' + nuitAuth.getToken());
        }

        function getDocumentDebugURL() {
            return $sce.trustAsResourceUrl(nuitApi.getBaseUrl() + 'document/admin?access-token=' + nuitAuth.getToken());
        }
        
        function rebuildEVO() {
            nuitApi('admin.update')
                .post({
                    token: "bJagpMCfwFDPG6su90fCStbxPf9VV3vEh7HrGpoN",
                    service: "evo"
                })
                .then(nuitUtils.showSuccessToast)
                .catch(nuitUtils.showErrorToast);
        }
        
        function rebuildIMS() {
            nuitApi('admin.update')
                .post( {
                    token: "bJagpMCfwFDPG6su90fCStbxPf9VV3vEh7HrGpoN",
                    service: "ims"
                })
                .then(nuitUtils.showSuccessToast)
                .catch(nuitUtils.showErrorToast);
        }
        
        function digitalDocuments() {
            return {
                progress: 100,
                polishing: 75
            };
        }
        
        function smartProductions() {
            return {
                progress: 82,
                polishing: 17
            };
        }
        
        function sales() {
            return {
                progress: 25,
                polishing: 0
            };
        }
	}
})();



(function () {
	'use strict';

	angular
		.module('app.admin.setup')
		.controller('AdminSetupListController', controller);

	/** @ngInject */
	function controller($filter, $mdSidenav, $state, $scope, nuitUtils, imsTranslation, SetupTemplates, SetupDefinitions, ListSelectionService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.templates = SetupTemplates.templates;
        vm.categories = SetupDefinitions.categories;
        vm.filteredTemplates = [];
        vm.currentPage = [];
		vm.currentPageEntities = [];
        vm.selection = ListSelectionService.get('setup.templates', true);
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.filterAll = filterAll;
        vm.getCategoryById = getCategoryById;
        vm.isSelected = vm.selection.isSelected;
        vm.getSelected = vm.selection.getSelected;
        vm.deleteSelected = deleteSelected;
        vm.copySelected = copySelected;
        vm.toggleSelect = vm.selection.toggleSelectedEntity;
        vm.toggleSelection = toggleSelection;
		vm.toggleSidenav = toggleSidenav;
        vm.openTemplate = openTemplate;
		vm.getName = function(template){
			return $filter('nuitTranslate')(template.name);
		};
		vm.isIndeterminate = vm.selection.isIndeterminate;
		//*******************************************

        //*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
            SetupDefinitions.reloadCategories();
            SetupTemplates.reload()
                .then(function() {
                    filterAll();
            });

            $scope.$watchCollection('vm.templates', function() { filterAll(); });
		}

        function onStateChangeSuccess() {
            filterAll();
        }

        function getCategoryById(id) {
            for(var index in vm.categories) {
                if(parseInt(vm.categories[index].id,10) === parseInt(id,10)) {
                    return vm.categories[index];
                }
            }
            return null;
        }

        /**
         * Opens the edit screen of the given template.
         *
         * @param {Object} template
         */
        function openTemplate(template) {
            $state.go('app.adminSetup.detail', {
				id: template.id
			}, {inherit: false});
        }

        function copySelected() {
            SetupTemplates
                .loadTemplate(vm.selection.getSelected()[0].id)
                .then(function(response) {
                    var copy = angular.copy(response);
                    delete copy.id;
                    for(var prop in copy.name) {
                        copy.name[prop] += " - Copy";
                    }
                    SetupTemplates
                        .addTemplate(copy)
                        .then(function() {
                            nuitUtils.showSuccessToast();
                            vm.selection.deselectAll();
                    })
                        .catch(nuitUtils.showErrorToast);
            });
        }

        /**
         * Deletes all selected templates.
         */
        function deleteSelected() {
            var promise = null;
            if (vm.selection.getSelected().length > 1) {
                promise = nuitUtils.showDeleteMultiConfirm();
            } else {
                promise = nuitUtils.showDeleteConfirmation();
            }

            promise.then(function () {
                angular.forEach(vm.selection.getSelected(), function (template) {
                    SetupTemplates.deleteTemplate(template.id)
                        .then(function () {
                            vm.selection.deselectAll();
                            nuitUtils.showSuccessToast();
                            //filterAll();
                        })
                        .catch(nuitUtils.showErrorToast);
                });
            });
        }

        function filterAll() {
            vm.filteredTemplates = [];

            var term = angular.isString(vm.term) ? vm.term.toLowerCase() : vm.term;
            for(var index in vm.templates) {
                var tmp = vm.templates[index];
                if((!angular.isString(term) || term === '' || tmp.name[imsTranslation.language].toLowerCase().indexOf(term) >= 0)
                    && ($state.params.category === undefined || String(tmp.meta.category) === String($state.params.category))) {
                    vm.filteredTemplates.push(tmp);
                }
            }
        }

        function toggleSelection() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

		/**
		 * Toggles the side navigation on or off.
		 * @param {Number} sidenavId - id of the sidenav to toggle
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.setup')
		.controller('AdminSetupEditController', controller);

	/** @ngInject */
	function controller($scope, $stateParams, $state, $mdSidenav, $filter, SetupTemplates, SetupDefinitions, nuitUtils, DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.template = SetupTemplates.createEmptyTemplate();
        vm.categories = SetupDefinitions.categories;
        vm.currencies = SetupDefinitions.currencies;
        vm.lengths = SetupDefinitions.lengths;
        vm.weights = SetupDefinitions.weights;
        vm.areas = SetupDefinitions.areas;
        vm.pressures = SetupDefinitions.pressures;
        vm.densities = SetupDefinitions.densities;
        vm.languages = SetupDefinitions.languages;
        vm.timeformats = SetupDefinitions.timeformats;
        vm.timezones = SetupDefinitions.timezones;
        vm.themecolors = SetupDefinitions.themecolors;
        vm.modules = SetupDefinitions.modules;
        vm.evostates = SetupDefinitions.evostates;
        vm.searchTerm = '';
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.onLanguageSelect = onLanguageSelect;
		vm.toggleSidenav = toggleSidenav;
        vm.getDateFormatPreview = getDateFormatPreview;
        vm.showEditUnitDialog = SetupDefinitions.showEditUnitDialog;
        vm.showEditFormatDialog = SetupDefinitions.showEditFormatDialog;
        vm.save = save;
        vm.isLoading = isLoading;
        vm.propagateToServer = propagateToServer;
        vm.updateSearch = updateSearch;
		vm.moduleGroups = SetupDefinitions.moduleGroups;
		vm.getGroups = SetupDefinitions.getGroups;
		vm.getGroupHeader = SetupDefinitions.getGroupHeader;
		vm.getGroupIndex = SetupDefinitions.getGroupIndex;
		vm.onChange = onChange;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        Object.defineProperty(vm, 'config', {
            get: function () {
                return vm.template.config;
            }
        });
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
            if(vm.languages.length > 0) {
                vm.currentLanguage = vm.languages[0].value.code;
            }

            SetupTemplates.loadTemplate($stateParams.id).then(function (template) {
                vm.template = angular.merge(vm.template, template);
                SetupDefinitions.reload()
                    .then(function() {
                    	SetupDefinitions.updateModuleGroups();
                        vm.currentLanguage = vm.languages[0].value.code;
                });
            });

            vm.currentTab = $state.params.active;
		}

		function onStateChangeSuccess(){
			vm.updateSearch();
		}

        function onLanguageSelect(newValue) {
            if(angular.isString(newValue) && newValue.startsWith('$')) {
                SetupDefinitions.showAddLanguageDialog();
                vm.currentLanguage = vm.languages[0];
            }
        }

        function getDateFormatPreview(format) {
            return moment().format(format);
        }

		/**
		 * Toggles the side navigation on or off.
		 * @param {Number} sidenavId - id of the sidenav to toggle
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}

        function save() {
            SetupTemplates.updateTemplate(vm.template)
                .then(function() {
                    nuitUtils.showSuccessToast();
                vm.itemForm.$setPristine();

            })
            .catch(nuitUtils.showErrorToast);
        }

        function isLoading(){
			return false;
		}

		function propagateToServer(){
        	return false;
		}

		function updateSearch(){
			if(vm[$state.params.active]) {
				if (vm.searchTerm === '') {
					vm[$state.params.active].collapseAll();
				} else {
					vm[$state.params.active].expandAll();
				}
			}
		}

		function onChange(module) {
			if (!vm.config[module.moduleType][module.moduleName]) {
				DotNotationService.set(vm.config, module.key + '.type', 4);
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.setup')
		.controller('AdminSetupController', controller);

	/** @ngInject */
	function controller($mdSidenav, $mdDialog, SetupTemplates, SetupDefinitions, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.categories = SetupDefinitions.categories;
        vm.categoryEditing = false;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.addSetup = addSetup;
        vm.addCategory = addCategory;
		vm.deleteCategory = deleteCategory;
		vm.editCategory = editCategory;
		vm.toggleEditing = toggleEditing;
		vm.toggleSidenav = toggleSidenav;
        vm.manageDefinitions = manageDefinitions;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createAddSetupDialog() {
			return {
				controller: 'AddSetupDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.setup/dialogs/add-setup/add-setup.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true
			};
		}
        
		function createEditCategoryDialog(category) {
			return {
				controller: 'EditCategoryDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.setup/dialogs/edit-category/edit-category.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
                locals: {
                    Category: category
                }
			};
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
            SetupDefinitions.reloadCategories();
		}
        
        function manageDefinitions() {
            SetupDefinitions.showEditDefinitionsDialog();
        }

		function addSetup() {
            $mdDialog
                .show(createAddSetupDialog())
                .then(function(template) {
                    SetupTemplates.addTemplate(template);
            });
		}
        
        function addCategory() {
			$mdDialog.show(createEditCategoryDialog())
				.then(function (result) {
                    return SetupDefinitions.addCategory(result);
				})
				.then(function (response) {
                    nuitUtils.showSuccessToast();
				})
				.catch(function (rejection) {
					if (rejection) {
                        nuitUtils.showErrorToast();
					}
				});
        }

		/**
		 * Deletes the given category.
		 * @param {Category} category - category which should be deleted
		 * @param {Object} $event - event data
		 */
		function deleteCategory(category, $event) {
			$event.stopPropagation();
			$event.preventDefault();

            nuitUtils
                .showDeleteConfirmation('CATEGORY.DELETE')
				.then(function () {
					return SetupDefinitions.deleteCategory(category.id);
				})
				.then(nuitUtils.showSuccessToast)
				.catch(function (rejection) {
					if (rejection) {
                        nuitUtils.showErrorToast();
					}
				});
		}

        /**
         * Opens a dialog which allows to edit the given category.
         * Submits it to the api afterwards.
         * @param {Object} category
         * @param {Object} $event
         */
		function editCategory(category, $event) {
			if (!vm.categoryEditing) {
				return;
			}

			if($event) { $event.preventDefault(); }

			$mdDialog.show(createEditCategoryDialog(category.value))
				.then(function (result) {
                    result = {
                        id: category.id,
                        value: result
                    };
                    return SetupDefinitions.updateCategory(result);
				})
				.then(function (response) {
                    nuitUtils.showSuccessToast();
				})
				.catch(function (rejection) {
					if (rejection) {
                        nuitUtils.showErrorToast();
					}
				});
		}

		/**
		 * Toggles the category editing mode.
		 */
		function toggleEditing() {
			vm.categoryEditing = !vm.categoryEditing;
		}

		/**
		 * Toggles the side navigation on or off.
		 * @param {Number} sidenavId - id of the sidenav to toggle
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.factory('SettingsTreeService', SettingsTreeService);

	/** @ngInject */
	function SettingsTreeService(DotNotationService) {
		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			get: get,
		};
        //*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		//*******************************************
		return service;
		//*******************************************

        ////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {

		}

        function get(defaultSettings, currentSettings, root, settingsName) {
				var tree = [];
				convert(defaultSettings,'', 0);
				removeUnneededDepth(tree, root);
				minimizeDepth(tree);
				insertSections(tree);
				return tree;

				function convert(config, keyChain, depth) {
					for(var key in config) {
						if(angular.isDefined(config[key]) && angular.isDefined(config[key].value) && angular.isDefined(config[key].type)) {
							var data = DotNotationService.hasKey(currentSettings,keyChain+'.'+key)?DotNotationService.get(currentSettings,keyChain+'.'+key):config[key];
							var name = getName(keyChain,key, root);
							tree.push(
								{
									name: name,
									translation: getTranslationKey(name,settingsName),
									model: keyChain + '.' + key,
									type: config[key].type,
									data: data,
									defaultData: angular.copy(DotNotationService.get(defaultSettings,keyChain+'.'+key+'.value')),
									depth: depth,
									showSection: false,
									settingsName: settingsName
								});
						} else if(angular.isObject(config[key])) {
							convert(config[key],keyChain!==''?keyChain+'.'+key:key, depth + 1);
						}
					}
				}
        }

        function getName(keyChain, key, root){
			var reducedChain = keyChain.replace(root,'');
			if(reducedChain[0]==='.') {
				reducedChain = reducedChain.substring(1);
			}
			reducedChain += reducedChain.length>0?'.'+key:key;

			return reducedChain;
		}

		function getTranslationKey(name,setting){

				return setting.replace('_ROLE','') + '.' + name.split(/(?=[A-Z][a-z])/).join('_').toUpperCase();
		}

		function removeUnneededDepth(tree, root){
			if(tree.length===1)
			{
				return;
			}else{
				var keyToDelete = root + '.' + 'enabled';

				for (var i = 0; i < tree.length; i++) {
					if (tree[i].model === keyToDelete) {
						tree.splice(i, 1);
						break;
					}
				}
			}
		}

		function minimizeDepth(tree){
			var minDepth = 10000;
			for(var i=0;i<tree.length;i++){
				minDepth = Math.min(minDepth,tree[i].depth);
			}

			for(var i=0;i<tree.length;i++){
				tree[i].depth -= minDepth;
			}
		}

		function insertSections(tree){
			var sections = {};

			for(var i=0;i<tree.length;i++){
				var node = tree[i];
				var keyArray = node.name.split('.');
				if(!sections.hasOwnProperty(keyArray[0])){
					sections[keyArray[0]] = {count:0,name:getTranslationKey(keyArray[0],node.settingsName),first: true, isVisible: false, children: []};
				}
				sections[keyArray[0]].count ++;
				sections[keyArray[0]].children.push(node);
				node.section = sections[keyArray[0]];
			}

			var sortedSections = [];

			for(var key in sections){
				sortedSections.push(sections[key]);
			}

			sortedSections.sort(function(a,b){
				return a.count - b.count;
			});

			tree.splice(0,tree.length);

			for(var i=0;i<sortedSections.length;i++){
				for(var j=0;j<sortedSections[i].children.length;j++){
					tree.push(sortedSections[i].children[j]);
				}
			}

			for(var i=0;i<tree.length;i++){
				var node = tree[i];
				if(node.section.count>1 && tree.length>node.section.count){
					node.name = node.name.split('.').splice(1).join('.');
					if(node.section.first){
						node.section.first = false;
						node.section.firstDepth = node.depth;
						node.showSection = true;
						node.depth = 0;
						if(node.name==='enabled'){
							node.section.enabled = node.data;
						}else{
							node.section.enabled = {value: true};
						}
					}else
					{
						node.depth -= node.section.firstDepth;
					}
				}else{
					node.section.isVisible = true;
					node.section.enabled = {value: true};
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.factory('MaintenanceService', MaintenanceService);

	/** @ngInject */
	function MaintenanceService(nuitApi) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			recreateProfileImages: recreateProfileImages,
			downloadUserCount: downloadUserCount
		};
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function recreateProfileImages() {
			return nuitApi('profiles.recreate')
				.get();
		}

		function downloadUserCount(){
			return nuitApi('user.count')
				.get(undefined,{
					responseType: 'arraybuffer'
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.factory('ConfigEditorInputMapping', ConfigEditorInputMapping);

	/** @ngInject */
	function ConfigEditorInputMapping(CONFIG_EDITOR_INPUT_MAPPING) {

		var mapping = {};

		var service = {
			get: get,
		};

		init();

		return service;

		function init() {
			for (var key in CONFIG_EDITOR_INPUT_MAPPING) {
				var inputMapping = CONFIG_EDITOR_INPUT_MAPPING[key];
				for (var i = 0; i < inputMapping.length; i++) {
					mapping[inputMapping[i]] = key;
				}
			}
		}

		function get() {
			return mapping;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.factory('AdminConfig', AdminConfigService);

	/** @ngInject */
	function AdminConfigService($q, nuitApi) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _config = {};
		var _sanitizedConfig = {};
		var _default = {};
		var _isLoading = true;
		var _toDelete = {};
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			setDefaultConfig: setDefaultConfig,
			deleteConfigWithKey: deleteConfigWithKey,
			addConfig: addConfig,
			markForDeletion: markForDeletion,
			unmarkForDeletion: unmarkForDeletion,
			deleteMarked: deleteMarked
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'config', {
			get: function () {
				return _config;
			}
		});
		Object.defineProperty(service, 'sanitizedConfig', {
			get: function () {
				return _sanitizedConfig;
			}
		});
		Object.defineProperty(service, 'isLoading', {
			get: function () {
				return _isLoading;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function reload() {
			_isLoading = true;

			return nuitApi('config')
				.get({scope: 'environment'})
				.then(function (response) {
					for (var i in _config) {
						delete _config[i];
					}
					for (var i in _sanitizedConfig) {
						delete _sanitizedConfig[i];
					}
					angular.merge(_config, _default, response.data);
					angular.merge(_sanitizedConfig, sanitizeConfig(_config));

					return _config;
				})
				.finally(function(){
					_isLoading = false;
					_toDelete = {};
				});
		}

		function setDefaultConfig(defaultConfig) {
			_default = defaultConfig;
		}

		function sanitizeConfig(config, prefix, result, parent) {
            if(angular.isUndefined(config) || config === null) {
                return result;
            }

			if (prefix === undefined) {
				prefix = '';
			}
			if (result === undefined) {
				result = [];
			}

			if (Object.keys(config).length > 0 && !angular.isString(config) && !angular.isArray(config)) {
				if (prefix.length !== 0) {
					prefix += ".";
				}
				for (var key in config) {
					sanitizeConfig(config[key], prefix + key, result, config);
				}
			} else if (!prefix.endsWith('type')) {
				result.push({
					key: prefix,
					type: parent.type,
					parent: parent
				});
			}

			return result;
		}

		/**
		 * Deletes the config with the given key.
		 * @param {String} key - config key
		 * @returns {Promise}
		 */
		function deleteConfigWithKey(key) {
			return nuitApi('config.single', key)
				.delete({}, {
					params: {
						scope: 'environment'
					}
				})
				.then(function () {
					reload();
				});
		}

		function markForDeletion(key){
			_toDelete[key] = true;
		}

		function unmarkForDeletion(key){
			if(_toDelete.hasOwnProperty(key)) {
				delete _toDelete[key];
			}
		}

		function deleteMarked(){
			var promises = [];

			for(var key in _toDelete){
				promises.push(deleteConfigWithKey(key));
			}

			return $q.all(promises);
		}

		function addConfig(config) {
			return nuitApi('config.add')
				.post(config)
				.then(function () {
					reload();
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.constant('DEFAULT_PRODUCTION_ORDER_QUEUE',
			[
				{
					'color': 'orange-900-fg',
					'icon': 'icon-bookmark',
					'name': {
						'de': 'Eingang',
						'en': 'New'
					},
					'id': 0,
					'transitionText': {
						'de': 'Freigeben',
						'en': 'Confirm'
					},
					'transitionTo': 1,
					'type': 'default'
				},
				{
					'color': 'lime-900-fg',
					'icon': 'icon-verified',
					'name': {
						'de': 'Freigegeben',
						'en': 'Confirmed'
					},
					'id': 1,
					'transitionText': {
						'de': 'Abschließen',
						'en': 'Complete'
					},
					'transitionTo': 4,
					'type': 'default'
				},
				{
					'color': 'blue-500-fg',
					'icon': 'icon-thumb-up',
					'name': {
						'de': 'Abgeschlossen',
						'en': 'Completed'
					},
					'id': 2,
					'transitionText': {
						'de': 'Archivieren',
						'en': 'Archive'
					},
					'transitionTo': 3,
					'type': 'default'
				},
				{
					'color': 'brown-500-fg',
					'icon': 'icon-archive',
					'name': {
						'de': 'Archiviert',
						'en': 'Archived'
					},
					'id': 3,
					'type': 'archive'
				},
				{
					'color': 'red-500-fg',
					'icon': 'icon-cog',
					'productionRef': 0,
					'name': {
						'de': 'In Produktion',
						'en': 'In Production'
					},
					'id': 4,
					'transitionText': {
						'de': 'Produziert',
						'en': 'Produced'
					},
					'transitionTo': 5,
					'type': 'production'
				},
				{
					'color': 'light-green-700-fg',
					'icon': 'icon-check-all',
					'productionRef': 2,
					'name': {
						'de': 'Produziert',
						'en': 'Produced'
					},
					'id': 5,
					'transitionText': {
						'de': 'Abgeschlossen',
						'en': 'Finished'
					},
					'transitionTo': 2,
					'type': 'default'
				}
			]
		);
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.constant('DEFAULT_ORDER_QUEUE',
			[
				{
					'color': 'orange-900-fg',
					'icon': 'icon-bookmark',
					'name': {
						'de': 'Eingang',
						'en': 'New'
					},
					'id': 0,
					'transitionText': {
						'de': 'Freigeben',
						'en': 'Confirm'
					},
					'transitionTo': 1,
					'type': 'default'
				},
				{
					'color': 'lime-900-fg',
					'icon': 'icon-verified',
					'name': {
						'de': 'Freigegeben',
						'en': 'Confirmed'
					},
					'id': 1,
					'transitionText': {
						'de': 'Abschließen',
						'en': 'Complete'
					},
					'transitionTo': 2,
					'type': 'default'
				},
				{
					'color': 'blue-500-fg',
					'icon': 'icon-thumb-up',
					'name': {
						'de': 'Abgeschlossen',
						'en': 'Completed'
					},
					'id': 2,
					'transitionText': {
						'de': 'Archivieren',
						'en': 'Archive'
					},
					'transitionTo': 3,
					'type': 'default'
				},
				{
					'color': 'brown-500-fg',
					'icon': 'icon-archive',
					'name': {
						'de': 'Archiviert',
						'en': 'Archived'
					},
					'id': 3,
					'type': 'archive'
				}
			]
		);
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.constant('CONFIG_EDITOR_INPUT_MAPPING',
			{
				favorites: [
					'ims.materials.details.favorites',
					'ims.products.favorites'
				],
				filters: [
					'ims.queue.filters',
					'evo.products.list.filters',
					'evo.material.customFilters'
				],
				customFields: [
					'ims.orders.details.customFields.top',
					'ims.orders.details.customFields.details',
					'ims.orders.details.customFields.customer',
					'ims.orders.positions.customFields.top',
					'ims.orders.positions.customFields.tags',
					'ims.orders.positions.products.customFields.top',
					'ims.orders.positions.customFields.details',
					'ims.queue.list.customFields',
					'evo.products.list.customFields',
					'ims.materials.details.customFields.top',
					'ims.materials.list.customFields',
					'evo.material.details.customFields.top',
					'evo.material.details.customFields.bottom',
					'evo.cart.customFields.details.top',
					'evo.cart.profile.customTags',
					'evo.cart.product.customTags',
					'ims.productionOrders.productionProfile.partsMode.customFields',
					'ims.productionOrders.productionProfile.geometryMode.customFields'
				],
				customAttributes: [
					'ims.productionOrders.productionProfile.partsMode.customData.checkBoxes'
				],
				readOnlyConditions: [
					'ims.orders.readOnlyConditions',
					'ims.orders.canDeleteConditions',
					'ims.proposals.canDeleteConditions',
					'ims.offers.canDeleteConditions',
					'evo.editor.addProfileDialog.customCartConditions',
					'evo.editor.addProfileDialog.customCartConditionsRequired',
					'ims.queue.list.canDeleteConditions',
					'evo.cart.emptyCartCheckoutConditions',
					'evo.cart.hideOfferCondition',
					'evo.cart.hideOrderCondition',
					'evo.toolbar.externalField.showCondition',
					'evo.cart.checkout.afterBlock.showConditions',
					'evo.cart.checkout.profileCheckoutConditions',
					'evo.cart.profile.positions.readOnlyConditions.name',
					'evo.cart.profile.positions.readOnlyConditions.length',
					'evo.cart.profile.positions.readOnlyConditions.quantity',
					'evo.cart.profile.positions.readOnlyConditions.remove',
					'evo.cart.profile.positions.readOnlyConditions.add',
					'evo.cart.profile.positions.readOnlyConditions.specials',
					'evo.cart.profile.positions.readOnlyConditions.remarks',
					'evo.editor.conditions.readOnlyMaterial',
					'evo.editor.conditions.readOnlyLength',
					'evo.editor.conditions.disableNewProfile',
					'evo.editor.conditions.disableOpenProfile',
					'evo.editor.conditions.disableSaveProfile',
					'evo.editor.conditions.disableSaveProfileToCart',
					'ims.users.details.readOnlyConditions.externalId',
					'ims.materials.details.readOnlyConditions.externalId',
					'ims.products.details.readOnlyConditions.externalId',
					'ims.projects.details.readOnlyConditions.externalId',
					'ims.projects.details.readOnlyConditions.status'
				],
				readOnlyStatis: [
					'ims.orders.readOnlyStatis',
					'ims.orders.denyTransitionFromStatus',
					'ims.queue.list.canDeleteStatis',
					'evo.documents.proposals.allowTransitionFromStatus',
					'evo.documents.offers.allowTransitionFromStatus',
					'ims.orders.list.status.prepend',
					'ims.queue.list.status.prepend'
				],
				disableInvoiceStatis: [
					'ims.accounting.disabledStatis'
				],
				disableRemarkType: [
					'ims.accounting.disabledRemarks'
				],
				conditionalStyle: [
					'evo.products.list.conditionalStyle'
				],
				customFieldsEvoCart: [
					'evo.cart.fields'
				],
				productFilters: [
					'evo.products.filters'
				],
				materialFilters: [
					'evo.material.filters'
				],
				holidays: [
					'evo.cart.delivery.bankHolidays'
				],
				workdays: [
					'ims.planning.boards.workDays',
					'ims.accounting.calendar.workDays'
				],
				formatWithLineBreaks: [
					'evo.cart.addressFormat',
					'ims.orders.details.customer.addressFormat',
					'ims.companies.details.addressFormat'
				],
				addressesByCountry: [
					'ims.orders.details.customer.addressFormatByCountry',
					'evo.cart.addressFormatByCountry',
					'ims.companies.details.addressFormatByCountry'
				],
				proposalStatus:[
					'evo.cart.proposalCheckoutStatus'
				],
				stampingTools:[
					'editor.nuitDrawStampingRework.tools'
				],
				stampingAreas:[
					'editor.nuitDrawStampingRework.areas'
				],
				stampingTemplates:[
					'editor.nuitDrawStampingRework.templates'
				],
				exportOptions: [
					'ims.accounting.list.exportOptions'
				],
				imageUpload:[
					'documents.logo',
					'evo.toolbar.logo'
				],
				mimeType:[
					'evo.cart.attachments.acceptedMimeTypes',
					'ims.attachments.acceptedMimeTypes',
					'ims.queue.list.upload.acceptedMimeTypes'
				],
				salesOrder:[
					'evo.cart.layout.sales.order'
				],
				salesOrderOverrides:[
					'ims.orders.sales.showConditions'
				],
				toolType:[
					'editor.nuitDrawStampingRework.toolGroups.available'
				],
				translationArray:[
					'editor.nuitDrawStampingRework.texts'
				],
				enableSelection:[
					'evo.cart.payment.options'
				],
				tagGroupSelection:[
					'evo.cart.tags.selectable'
				],
				exchangeAppIdQuickbook:[
					'ims.exchange.quickbooks.invoice.export.appId'
				],
				exchangeAppIdNodeRed:[
					'ims.orders.list.download.appId',
					'ims.queue.list.upload.appId',
					'ims.exchange.jobBoss.order.export.appId',
					'ims.exchange.jobBoss.order.exportAsOffer.appId',
					'ims.exchange.jobBoss.offer.export.appId'
				],
				exchangeAppIdXero:[
					'ims.exchange.xero.invoice.export.appId'
				],
				exchangeFlowId:[
					'ims.orders.list.download.flowId',
					'ims.queue.list.upload.flowId',
					'ims.exchange.jobBoss.order.export.flowId',
					'ims.exchange.jobBoss.order.exportAsOffer.flowId',
					'ims.exchange.jobBoss.offer.export.flowId'
				],
				colorSelection:[
					'evo.theme.primary',
					'evo.theme.accent',
					'evo.theme.navbar'
				],
				userArray:[
					'evo.cart.assignee.users'
				],
				stateSelection:[
					'ims.routes.login'
				]
			}
		);
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.controller('MaintenanceController', MaintenanceController);

	/** @ngInject */
	function MaintenanceController(MaintenanceService, Base64DownloadService,nuitUtils, imsUtils, nuitLog,EnvironmentService, $mdDialog) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.recreationInProgress = false;

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.recreateProfileImages = recreateProfileImages;
		vm.copyEnvFolders = copyEnvFolders;
		vm.logTestMessage = logTestMessage;
		vm.logTestError = logTestError;
		vm.openEvoVersion = openEvoVersion;
		vm.downloadUserCount = downloadUserCount;
		vm.openTestRequest = openTestRequest;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {

		}

		function recreateProfileImages()
		{
			vm.recreationInProgress = true;

			MaintenanceService.recreateProfileImages()
				.then(nuitUtils.showSuccessToast)
				.catch(function(){
					vm.recreationInProgress = false;
					nuitUtils.showErrorToast();
				});
		}

		function copyEnvFolders()
		{
			imsUtils.openFolderCopy();
		}

		function openEvoVersion(){
			imsUtils.openEvoVersionDialog();
		}

		function logTestError(){
			nuitLog.error(new Error('testError'));
		}

		function logTestMessage(){
			nuitLog.error('testMessage');
		}

		function downloadUserCount(){
			MaintenanceService.downloadUserCount()
				.then(function(response){
					Base64DownloadService.downloadFile(response.data, response.headers('Content-Type'), 'users.xlsx');
				});
		}

		function openTestRequest(){
			$mdDialog.show(
			{
				controller: 'TestRequestController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.environment/dialogs/test.request/test.request.html',
				clickOutsideToClose: true,
				multiple: false,
			}
			);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.controller('ConfigComposeController', ConfigComposeController);

	/** @ngInject */
	function ConfigComposeController($mdDialog, AdminConfig, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = {};

		vm.types = [
			{id: 1, name: 'Integer'},
			{id: 2, name: 'String'},
			{id: 3, name: 'JSON'},
			{id: 4, name: 'Boolean'},
			{id: 5, name: 'Float'}
		];

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.hide = hide;
		vm.save = save;
		vm.resetValue = resetValue;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {

		}

		function hide() {
			$mdDialog.hide();
		}

		function save() {
			switch(vm.config.type)
			{
				case 1:
					vm.config.value = parseInt(vm.config.value,10);
					break;
				case 3:
					vm.config.value = JSON.parse(vm.config.value);
					break;
				case 4:
					if(typeof vm.config.value === 'undefined')
					{
						vm.config.value = false;
					}
					break;
				case 5:
					vm.config.value = parseFloat(vm.config.value);
					break;
			}

			AdminConfig
				.addConfig(vm.config)
				.then(function(){
					nuitUtils.showSuccessToast();
					hide();
				})
				.catch(nuitUtils.showErrorToast);
		}

		function resetValue()
		{
			delete vm.config.value;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.environment')
		.controller('adminEnvironmentController', adminEnvironmentController);

	function adminEnvironmentController($scope, SalesService, $document, $q, $filter, nuitShop, $mdDialog, $timeout, $state, SetupDefinitions, SetupTemplates, nuitConfig, nuitApi, nuitAuth, nuitUtils, imsUtils, AdminConfig, DotNotationService, OrderService, DEFAULT_PRODUCTION_ORDER_QUEUE, DEFAULT_ORDER_QUEUE) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.css = "";
		vm.orderQueue = OrderService.queue;
		vm.currentTab = $state.params.active;
		vm.config = AdminConfig.config;
		vm.shopConfig = SalesService.shopConfig;
		vm.sanitizedConfig = AdminConfig.sanitizedConfig;
		vm.categories = SetupDefinitions.categories;
		vm.currencies = SetupDefinitions.currencies;
		vm.lengths = SetupDefinitions.lengths;
		vm.weights = SetupDefinitions.weights;
		vm.areas = SetupDefinitions.areas;
		vm.pressures = SetupDefinitions.pressures;
		vm.densities = SetupDefinitions.densities;
		vm.languages = SetupDefinitions.languages;
		vm.timeformats = SetupDefinitions.timeformats;
		vm.timezones = SetupDefinitions.timezones;
		vm.themecolors = SetupDefinitions.themecolors;
		vm.modules = SetupDefinitions.modules;
		vm.evostates = SetupDefinitions.evostates;
		vm.jsonOptions = {mode: 'tree'};
		vm.deleter = nuitShop.deleter;
		//vm.logos = [];
		vm.searchTerm = '';
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.save = save;
		vm.getDateFormatPreview = getDateFormatPreview;
		vm.addOrderStatus = addOrderStatus;
		vm.showEditUnitDialog = SetupDefinitions.showEditUnitDialog;
		vm.showEditFormatDialog = SetupDefinitions.showEditFormatDialog;
		vm.moveOrderStatusUp = moveOrderStatusUp;
		vm.moveOrderStatusDown = moveOrderStatusDown;
		vm.deleteOrderStatus = deleteOrderStatus;
		vm.editOrderStatus = editOrderStatus;
		vm.deleteConfig = deleteConfig;
		vm.showConfigAddDialog = showConfigAddDialog;
		vm.uploadImage = uploadImage;
		vm.setDefaultProductionOrderQueue = setDefaultProductionOrderQueue;
		vm.setDefaultOrderQueue = setDefaultOrderQueue;
		vm.isLoading = isLoading;
		vm.propagateToServer = propagateToServer;
		vm.updateDeleter = updateDeleter;
		vm.removeDeleter = nuitShop.removeDeleter;
		vm.hasDeleter = nuitShop.hasDeleter;
		vm.updateSearch = updateSearch;
		vm.moduleGroups = SetupDefinitions.moduleGroups;
		vm.getGroups = SetupDefinitions.getGroups;
		vm.getGroupHeader = SetupDefinitions.getGroupHeader;
		vm.getGroupIndex = SetupDefinitions.getGroupIndex;
		vm.onChange = onChange;
		vm.onDeleteShopConfigKey = onDeleteShopConfigKey;
		//*******************************************

		//*******************************************
		// EVENTS
		//*******************************************
		$scope.$on('$stateChangeSuccess', onStateChangeSuccess);
		//*******************************************

		//*******************************************
		// INIT
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// DIALOGS
		//*******************************************
		function generateOrdersEditStatusDialog(status) {
			return {
				controller: 'OrdersEditStatusController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.environment/dialogs/orders.edit-status/orders.edit-status.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					Status: status
				}
			};
		}

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			vm.currentTab = $state.params.active;
			SetupDefinitions.reload()
				.then(SetupDefinitions.updateModuleGroups);
			OrderService.reload();
			nuitShop.reload();
			AdminConfig.setDefaultConfig(angular.merge(SetupTemplates.createDefaultConfig(), createDefaultConfig()));
			if (nuitConfig.isReady()) {
				AdminConfig.reload().then(initLogos);
			} else {
				nuitConfig
					.reload(true)
					.then(AdminConfig.reload)
					.then(initLogos);
			}

			SalesService.reload();

			nuitApi('theme.css')
				.get({environment: nuitAuth.getEnvironmentId()})
				.then(function (response) {
					vm.css = response.data;
				});
		}

		function onStateChangeSuccess() {
			vm.updateSearch($state.params.active);
		}

		function initLogos() {
			/*vm.logos = [
				{model: vm.config.evo.toolbar.logo, key: 'evo.toolbar.logo', translation: 'APP.LOGO'},
				{model: vm.config.documents.logo, key: 'documents.logo', translation: 'APP.LOGO_DOCUMENTS'}
			];

			for (var i = 0; i < vm.logos.length; i++) {
				var key = vm.logos[i].key;
				if (!DotNotationService.hasKey(vm.config, key)) {
					DotNotationService.add(vm.config, key, {type: 2, value: ''});
					vm.logos[i].model = DotNotationService.get(key);
				}
			}*/
		}

		function addOrderStatus() {
			$mdDialog.show(generateOrdersEditStatusDialog())
				.then(function (status) {
					OrderService.addStatus(status);
				})
				.catch(angular.noop);
		}

		function editOrderStatus(index) {
			var status = angular.copy(vm.orderQueue[index]);
			$mdDialog.show(generateOrdersEditStatusDialog(status))
				.then(function (newStatus) {
					OrderService.updateStatus(newStatus);
				})
				.catch(angular.noop);
		}

		function deleteOrderStatus(status) {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					OrderService.deleteStatus(status);
					nuitUtils.showSuccessToast();
				});
		}

		function moveOrderStatusUp(index) {
			var status = vm.orderQueue.splice(index, 1)[0];
			vm.orderQueue.splice(index - 1, 0, status);
		}

		function moveOrderStatusDown(index) {
			var status = vm.orderQueue.splice(index, 1)[0];
			vm.orderQueue.splice(index + 1, 0, status);
		}

		function getDateFormatPreview(format) {
			return moment().format(format);
		}

		function updateDeleter() {
			if (!angular.isNumber(vm.deleter.days)) {
				return;
			}
			if (vm.deleter.status === undefined) {
				return;
			}
			nuitShop.updateDeleter().then(nuitUtils.showSuccessToast);
		}

		function createDefaultConfig() {
			return {
				localization: {
					dateFormat: {value: 'YYYY-MM-DD', type: 2},
					dateTimeFormat: {value: 'YYYY-MM-DD hh:mm:ss', type: 2},
					timeFormat: {value: 'hh:mm:ss', type: 2},
					currency: {
						symbol: {value: '€', type: 2},
						icon: {value: 'icon-currency-eur', type: 2}
					}
				},
				admin: {
					clients: {
						enabled: {value: false, type: 4}
					},
					environment: {
						enabled: {value: false, type: 4}
					},
					documents: {
						enabled: {value: false, type: 4}
					},
					status: {
						enabled: {value: false, type: 4}
					},
					translations: {
						enabled: {value: false, type: 4}
					},
					setup: {
						enabled: {value: false, type: 4}
					}
				},
				defaults: {
					profile: {
						length: {value: 3000, type: 5},
						hem: {
							length: {
								'default': {value: 10, type: 5}
							}
						}
					},
					length: {value: 100, type: 5}
				}
				/*
				documents: {
					logo: {value: '', type: 2}
				}
				*/
			};
		}

		function save() {
			AdminConfig.deleteMarked()
				.then(function () {
					var configPromise = nuitApi('config').put(vm.config);
					var themePromise = nuitApi('theme.css').put(vm.css, {}, {params: {environment: nuitAuth.getEnvironmentId()}});
					var shopPromise = SalesService.save();

					$q.all([configPromise, themePromise, shopPromise])
						.then(function () {
							return nuitConfig.reload(true);
						})
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast)
						.finally(function (response) {
							$timeout();
						});
				});
		}

		function deleteConfig(key) {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					AdminConfig
						.deleteConfigWithKey(key.slice(0, key.lastIndexOf('.')))
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast);
				});
		}

		function showConfigAddDialog() {

			$mdDialog.show({
				controller: 'ConfigComposeController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.environment/views/config-compose.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true
			})
				.then(function (answer) {

				}, function () {

				});
		}

		function uploadImage(logo) {
			imsUtils.uploadEnvImage()
				.then(function (url) {
					if (!logo.model) {
						DotNotationService.add(vm.config, logo.key, {value: angular.copy(url), type: 2});
						logo.model = DotNotationService.get(vm.config, logo.key);
					} else {
						logo.model.value = angular.copy(url);
					}
				});
		}

		function setDefaultProductionOrderQueue() {
			setQueue(DEFAULT_PRODUCTION_ORDER_QUEUE);
		}

		function setDefaultOrderQueue() {
			setQueue(DEFAULT_ORDER_QUEUE);
		}

		function setQueue(data) {
			for (var index in data) {
				OrderService.addStatus(data[index]);
			}
		}

		function isLoading() {
			return AdminConfig.isLoading;
		}

		function propagateToServer() {
			return true;
		}

		function updateSearch() {
			if (vm[$state.params.active]) {
				if (vm.searchTerm === '') {
					vm[$state.params.active].collapseAll();
				} else {
					vm[$state.params.active].expandAll();
				}
			}
		}

		function onChange(module) {
			if(!vm.config[module.moduleType]){
				vm.config[module.moduleType] = {};
			}

			if (!vm.config[module.moduleType][module.moduleName]) {
				DotNotationService.set(vm.config, module.key + '.type', 4);
			}
		}

		function onDeleteShopConfigKey(key){
			nuitApi('sales.config.key',key).delete()
				.then(nuitUtils.showSuccessToast)
				.catch(nuitUtils.showErrorToast);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.factory('TemplateService', TemplateService);

	/** @ngInject */
	function TemplateService(GenericRequestService) {

		//*******************************************
		/// SERVICE
		//*******************************************
		return GenericRequestService.get(
			'notification.templates',
			{
				getAll: 'notification.templates',
				get: 'notification.templates.one',
				add: 'notification.templates.add',
				update: 'notification.templates.one',
				remove: 'notification.templates.one'
			},
			true
		);
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.factory('GlobalTemplateService', GlobalTemplateService);

	/** @ngInject */
	function GlobalTemplateService(GenericRequestService) {

		//*******************************************
		/// SERVICE
		//*******************************************
		return GenericRequestService.get(
			'notification.global.templates',
			{
				getAll: 'notification.global.templates',
				get: 'notification.global.templates.one',
				add: 'notification.global.templates.add',
				update: 'notification.global.templates.one',
				remove: 'notification.global.templates.one'
			},
			true
		);
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.factory('EventService', EventService);

	/** @ngInject */
	function EventService(GenericRequestService) {

		//*******************************************
		/// SERVICE
		//*******************************************
		return GenericRequestService.get(
			'notification.events',
			{
				getAll: 'notification.events',
				get: 'notification.events.one',
				add: 'notification.events.add',
				update: 'notification.events.one',
				remove: 'notification.events.one'
			},
			true
		);
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.factory('ChannelService', ChannelService);

	/** @ngInject */
	function ChannelService(GenericRequestService) {

		//*******************************************
		/// SERVICE
		//*******************************************
		return GenericRequestService.get(
			'notification.channels',
			{
				getAll: 'notification.channels',
				add: 'notification.channels.add',
				update: 'notification.channels.one',
				remove: 'notification.channels.one'
			},
			true
		);
	}
}());

/* global Chartist */

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('TemplateListController', TemplateListController);

	function TemplateListController($state, $mdDialog, nuitUtils, TemplateService, GlobalTemplateService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.loading = true;
		vm.global = $state.current.data.global;

		vm.templateService = vm.global?GlobalTemplateService:TemplateService;
		vm.entities = vm.templateService.entities;
		vm.header = 'NOTIFICATIONS.TEMPLATES' + (vm.global?'_GLOBAL':'');
		vm.noEntities = 'NOTIFICATIONS.NO_TEMPLATES' + (vm.global?'_GLOBAL':'');
		vm.htmlTemplate = 'templates';
		vm.flex = '30';
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.add = add;
		vm.editTemplate = editTemplate;
		vm.removeTemplate = removeTemplate;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        function init() {
			vm.templateService.getAll()
				.then(function(){
					vm.loading = false;
				});
        }

        function add(){
			openEditTemplate(null)
				.then(function(newTemplate){
					vm.templateService.add(newTemplate);
				});
		}

		function editTemplate(template){
			openEditTemplate(template)
				.then(function(newTemplate){
					vm.templateService.update(newTemplate);
				});
		}

		function removeTemplate(template){
        	nuitUtils.showDeleteConfirmation()
				.then(function(){
					vm.templateService.remove(template);
				});
		}

		function openEditTemplate(template){
			return $mdDialog.show({
					controller: 'EditTemplateController',
					controllerAs: 'vm',
					locals: {template:template, global: vm.global},
					templateUrl: 'app/main/admin.notifications/dialogs/edit-template/edit-template.html',
					clickOutsideToClose: true
				});
		}
	}
})();



/* global Chartist */

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EventUserListController', EventUserListController);

	function EventUserListController($state, $mdDialog, nuitUtils, GenericRequestService, UserService, EventService, RoleService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.loading = true;
		vm.event = null;
		vm.allUsers = UserService.users;
		vm.eventUsers = GenericRequestService.get(
			'notification.events.users',
			{
				add: 'notification.events.users',
				update: 'notification.events.users',
				remove: 'notification.events.users'
			},
			true
		);

		vm.header = "NOTIFICATIONS.USERS";
		vm.noEntities = "NOTIFICATIONS.NO_USERS";
		vm.htmlTemplate = 'event-users';
		vm.hasParent = true;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.add = add;
		vm.edit = edit;
		vm.remove = remove;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init() {
			EventService.get($state.params.eventId)
				.then(function (event) {
					vm.event = event;
					vm.entities = vm.event.users;
					vm.header = vm.event.name;

					RoleService.reload()
						.then(function () {
							var roleIds = [];
							for (var i = 0; i < RoleService.roles.length; i++) {
								if (RoleService.roles[i].type === 0) {
									roleIds.push(RoleService.roles[i].id);
								}
							}
							UserService.getUsers({roleIds: roleIds})
								.then(function () {
									for(var i=0;i<vm.entities.length;i++){
										vm.entities[i].user = nuitDataService.getOne(vm.allUsers, vm.entities[i].userId);
									}
									vm.loading = false;
								});
						});
				});
		}

		function add() {
			openEditUser(null)
				.then(function (user) {
					vm.eventUsers.add(user, vm.event.id)
						.then(function (user) {
							if (vm.event.users === null) {
								vm.event.users = [];
								vm.entities = vm.event.users;
							}
							user.user = nuitDataService.getOne(vm.allUsers, user.userId);
							nuitDataService.addOne(vm.event.users, user);
						});
				});
		}

		function edit(user) {
			openEditUser(user)
				.then(function (newUser) {
					vm.eventUsers.update(newUser)
						.then(function(){
							nuitDataService.replaceOne(vm.event.users,newUser);
						});
				});
		}

		function remove(user) {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					vm.eventUsers.remove(user)
						.then(function () {
							nuitDataService.removeOne(vm.event.users, user.id);
						});
				});
		}

		function openEditUser(user) {
			return $mdDialog.show({
				controller: 'EditEventUserController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.notifications/dialogs/edit-user/edit-user.html',
				clickOutsideToClose: true,
				locals: {user:user, users: UserService.users}
			});
		}
	}
})();



/* global Chartist */

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EventTriggerListController', EventTriggerListController);

	function EventTriggerListController($state, $mdDialog, nuitUtils, GenericRequestService, UserService, EventService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.loading = true;
		vm.event = null;
		vm.allUsers = UserService.users;
		vm.eventTriggers = GenericRequestService.get(
			'notification.events.triggers',
			{
				add: 'notification.events.triggers',
				update: 'notification.events.triggers.one',
				remove: 'notification.events.triggers.one'
			},
			true
		);

		vm.header = "NOTIFICATIONS.TRIGGERS";
		vm.noEntities = "NOTIFICATIONS.NO_TRIGGERS";
		vm.htmlTemplate = 'event-triggers';
		vm.hasParent = true;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.add = add;
		vm.remove = remove;
		vm.edit = edit;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        function init() {
        	EventService.get($state.params.eventId)
				.then(function(event){
					vm.event = event;
					vm.entities = vm.event.triggers;

					for(var i=0;i<vm.entities.length;i++){
						var entity = vm.entities[i];
						if(angular.equals(entity.conditions,{})) {
							entity.prettyConditions = '';
						}else{
							entity.prettyConditions = JSON.stringify(entity.conditions, null, 2);
						}
					}

					vm.header = vm.event.name;
					UserService.getUsers()
						.then(function(){
							vm.loading = false;
						});
				});
        }

        function add(){
			openEditUser(null)
				.then(function(trigger){
					trigger.eventId = vm.event.id;
					vm.eventTriggers.add(trigger)
						.then(function(trigger)
						{
							if(vm.event.triggers===null){
								vm.event.triggers = [];
								vm.entities = vm.event.triggers;
							}
							nuitDataService.addOne(vm.event.triggers,trigger);
						});
				});
		}

		function edit(trigger) {
			openEditUser(trigger)
				.then(function (newTrigger) {
					var trigger = newTrigger;
					vm.eventTriggers.update(newTrigger)
						.then(function(){
							trigger.prettyConditions = JSON.stringify(trigger.conditions, null, 2);
							nuitDataService.replaceOne(vm.event.triggers, trigger);
						});
				});
		}

		function remove(trigger){
        	nuitUtils.showDeleteConfirmation()
				.then(function(){
					vm.eventTriggers.remove(trigger)
						.then(function(){
							nuitDataService.removeOne(vm.event.triggers, trigger.id);
						});
				});
		}

		function openEditUser(trigger){
			return $mdDialog.show({
					controller: 'EditTriggerController',
					controllerAs: 'vm',
					locals: {trigger: trigger},
					templateUrl: 'app/main/admin.notifications/dialogs/edit-trigger/edit-trigger.html',
					clickOutsideToClose: true
				});
		}
	}
})();



/* global Chartist */

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EventRoleListController', EventRoleListController);

	function EventRoleListController($state, $mdDialog, nuitUtils, GenericRequestService, RoleService, EventService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.loading = true;
		vm.event = null;
		vm.allRoles = RoleService.roles;
		vm.eventRoles = GenericRequestService.get(
			'notification.events.roles',
			{
				add: 'notification.events.roles',
				update: 'notification.events.roles',
				remove: 'notification.events.roles'
			},
			true
		);

		vm.header = "NOTIFICATIONS.ROLES";
		vm.noEntities = "NOTIFICATIONS.NO_ROLES";
		vm.htmlTemplate = 'event-roles';
		vm.hasParent = true;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.add = add;
		vm.edit = edit;
		vm.remove = remove;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init() {
			EventService.get($state.params.eventId)
				.then(function (event) {
					vm.event = event;
					vm.entities = vm.event.roles;
					vm.header = vm.event.name;
					RoleService.reload()
						.then(function () {
							for(var i=0;i<vm.entities.length;i++){
								vm.entities[i].role = nuitDataService.getOne(vm.allRoles, vm.entities[i].roleId);
							}
							vm.loading = false;
						});
				});
		}

		function add() {
			openEditRole(null)
				.then(function (role) {
					vm.eventRoles.add(role, vm.event.id)
						.then(function (role) {
							if (vm.event.roles === null) {
								vm.event.roles = [];
								vm.entities = vm.event.roles;
							}
							role.role = nuitDataService.getOne(vm.allRoles, role.roleId);
							nuitDataService.addOne(vm.event.roles, role);
						});
				});
		}

		function edit(role) {
			openEditRole(role)
				.then(function (newRole) {
					vm.eventRoles.update(newRole)
						.then(function(){
							nuitDataService.replaceOne(vm.event.roles,newRole);
						});
				});
		}

		function remove(role) {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					vm.eventRoles.remove(role)
						.then(function () {
							nuitDataService.removeOne(vm.event.roles, role.id);
						});
				});
		}

		function openEditRole(role) {
			return $mdDialog.show({
				controller: 'EditEventRoleController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.notifications/dialogs/edit-role/edit-role.html',
				clickOutsideToClose: true,
				locals: {role: role}
			});
		}
	}
})();



/* global Chartist */

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EventListController', EventListController);

	function EventListController($mdDialog, nuitUtils, EventService, TemplateService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.loading = true;
		vm.templates = TemplateService.entities;

		vm.entities = EventService.entities;
		vm.header = "NOTIFICATIONS.EVENTS";
		vm.noEntities = "NOTIFICATIONS.NO_EVENTS";
		vm.htmlTemplate = 'events';
		vm.flex = '30';
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.add = add;
		vm.editEvent = editEvent;
		vm.removeEvent = removeEvent;
		vm.getTemplateName = getTemplateName;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init() {
			EventService.getAll()
				.then(function () {
					TemplateService.getAll()
						.then(function () {
							vm.loading = false;
						});
				});
		}

		function add() {
			openEditEvent(null)
				.then(function (event) {
					EventService.add(event);
				});
		}

		function editEvent(event) {
			openEditEvent(event)
				.then(function (newEvent) {
					EventService.update(newEvent);
				});
		}

		function removeEvent(event) {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					EventService.remove(event);
				});
		}

		function openEditEvent(event) {
			return $mdDialog.show({
				controller: 'EditEventController',
				controllerAs: 'vm',
				locals: {event: event},
				templateUrl: 'app/main/admin.notifications/dialogs/edit-event/edit-event.html',
				clickOutsideToClose: true
			});
		}

		function getTemplateName(event) {
			var template = nuitDataService.getOne(vm.templates, event.templateId);
			return template ? template.name : '-';
		}
	}
})();



/* global Chartist */

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EventCustomListController', EventCustomListController);

	function EventCustomListController($state, $mdDialog, nuitUtils, GenericRequestService, EventService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.loading = true;
		vm.event = null;
		vm.eventCustom = GenericRequestService.get(
			'notification.events.custom',
			{
				add: 'notification.events.custom',
				update: 'notification.events.custom',
				remove: 'notification.events.custom'
			},
			true
		);

		vm.header = "NOTIFICATIONS.CUSTOM";
		vm.noEntities = "NOTIFICATIONS.NO_CUSTOM";
		vm.htmlTemplate = 'event-custom';
		vm.hasParent = true;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.add = add;
		vm.edit = edit;
		vm.remove = remove;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init() {
			EventService.get($state.params.eventId)
				.then(function (event) {
					vm.event = event;
					vm.entities = vm.event.custom;
					vm.header = vm.event.name;
					vm.loading = false;
				});
		}

		function add() {
			openEditCustom(null)
				.then(function (custom) {
					vm.eventCustom.add(custom, vm.event.id)
						.then(function(newCustom){
							if(vm.event.custom===null){
								vm.event.custom = [];
								vm.entities = vm.event.custom;
							}

							nuitDataService.addOne(vm.event.custom, newCustom);
						});
				});
		}

		function edit(custom) {
			openEditCustom(custom)
				.then(function (newCustom) {
					vm.eventCustom.update(newCustom)
						.then(function(){
							nuitDataService.replaceOne(vm.event.custom,newCustom);
						});
				});
		}

		function remove(custom) {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					vm.eventCustom.remove(custom)
						.then(function(){
							nuitDataService.removeOne(vm.event.custom,custom.id);
						});
				});
		}

		function openEditCustom(custom) {
			return $mdDialog.show({
				controller: 'EditCustomController',
				controllerAs: 'vm',
				locals: {custom: custom},
				templateUrl: 'app/main/admin.notifications/dialogs/edit-custom/edit-custom.html',
				clickOutsideToClose: true
			});
		}
	}
})();



/* global Chartist */

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('EventAdditionalListController', EventAdditionalListController);

	function EventAdditionalListController($state, $mdDialog, nuitUtils, GenericRequestService, EventService, nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.loading = true;
		vm.event = null;
		vm.eventAdditional = GenericRequestService.get(
			'notification.events.additional',
			{
				add: 'notification.events.additional',
				update: 'notification.events.additional',
				remove: 'notification.events.additional'
			},
			true
		);

		vm.header = "NOTIFICATIONS.ADDITIONAL";
		vm.noEntities = "NOTIFICATIONS.NO_ADDITIONAL";
		vm.htmlTemplate = 'event-additional';
		vm.hasParent = true;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.add = add;
		vm.edit = edit;
		vm.remove = remove;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init() {
			EventService.get($state.params.eventId)
				.then(function (event) {
					vm.event = event;
					vm.entities = vm.event.additional;
					vm.header = vm.event.name;
					vm.loading = false;
				});
		}

		function add() {
			openEditAdditional(null)
				.then(function (additional) {
					vm.eventAdditional.add(additional, vm.event.id)
						.then(function(additional){
							if(vm.event.additional===null){
								vm.event.additional = [];
								vm.entities = vm.event.additional;
							}

							nuitDataService.addOne(vm.event.additional, additional);
						});
				});
		}

		function edit(additional) {
			openEditAdditional(additional)
				.then(function (newAdditional) {
					vm.eventAdditional.update(newAdditional)
						.then(function(){
							nuitDataService.replaceOne(vm.event.additional,newAdditional);
						});
				});
		}

		function remove(additional) {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					vm.eventAdditional.remove(additional)
						.then(function(){
							nuitDataService.removeOne(vm.event.additional,additional.id);
						});
				});
		}

		function openEditAdditional(additional) {
			return $mdDialog.show({
				controller: 'EditAdditionalController',
				controllerAs: 'vm',
				locals: {additional: additional},
				templateUrl: 'app/main/admin.notifications/dialogs/edit-additional/edit-additional.html',
				clickOutsideToClose: true
			});
		}
	}
})();



/* global Chartist */

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('ContentListController', ContentListController);

	function ContentListController($sce, $state, $mdDialog, nuitUtils, GenericRequestService, TemplateService, GlobalTemplateService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.loading = true;
		vm.template = null;
		vm.global = $state.current.data.global;
		vm.templateService = vm.global?GlobalTemplateService:TemplateService;

		vm.contentService = GenericRequestService.get(
			getRouteName(''),
			{
				getAll: getRouteName(''),
				add: getRouteName('.add'),
				update: getRouteName('.one'),
				remove: getRouteName('.one')
			},
			true
		);

		vm.entities = vm.contentService.entities;
		vm.header = 'NOTIFICATIONS.CONTENTS';
		vm.noEntities = 'NOTIFICATIONS.NO_CONTENT';
		vm.htmlTemplate = 'contents';
		vm.flex = '100'
		vm.hasParent = true;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.add = add;
		vm.editContent = editContent;
		vm.removeContent = removeContent;
		vm.renderContent = renderContent;
		vm.insertBreaks = insertBreaks;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init($state.params.templateId);
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function init(templateId) {
			vm.templateService.get(templateId)
				.then(function(template){
					vm.template = template;
					vm.header = vm.template.name;
					vm.contentService.getAll(vm.template.id)
						.then(function () {
							vm.loading = false;
						});
				});
		}

		function getRouteName(name){
			return 'notification' + (vm.global?'.global':'') + '.contents' + name;
		}

		function add() {
			openEditContent(null)
				.then(function (newContent) {
					vm.contentService.add(newContent, vm.template.id);
				});
		}

		function editContent(content) {
			openEditContent(content)
				.then(function (newContent) {
					vm.contentService.update(newContent);
				});
		}

		function removeContent(content) {
			nuitUtils.showDeleteConfirmation()
				.then(function () {
					vm.contentService.remove(content);
				});
		}

		function openEditContent(content) {
			return $mdDialog.show({
				controller: 'EditContentController',
				controllerAs: 'vm',
				locals: {content: content},
				templateUrl: 'app/main/admin.notifications/dialogs/edit-content/edit-content.html',
				clickOutsideToClose: true
			});
		}

		function renderContent(content){
			return $sce.trustAsHtml(content);
		}

		function insertBreaks(content){
			return content.replace(/(?:\r\n|\r|\n)/g, '<br>');
		}
	}
})();



/* global Chartist */

(function () {
	'use strict';

	angular
		.module('app.admin.notifications')
		.controller('ChannelListController', ChannelListController);

	function ChannelListController($mdDialog, nuitUtils, nuitApi, ChannelService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.loading = true;

		vm.entities = ChannelService.entities;
		vm.header = "NOTIFICATIONS.CHANNELS";
		vm.noEntities = "NOTIFICATIONS.NO_CHANNELS";
		vm.htmlTemplate = 'channels';
		vm.flex = '30';
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.add = add;
		vm.editChannel = editChannel;
		vm.removeChannel = removeChannel;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        function init() {
			ChannelService.getAll()
				.then(function(){
					vm.loading = false;
				});
        }

        function add(){
			openEditChannel(null)
				.then(function(newChannel){
					ChannelService.add(newChannel);
				});
		}

		function editChannel(channel){
        	openEditChannel(channel)
				.then(function(newChannel){
					ChannelService.update(newChannel);
				});
		}

		function removeChannel(channel){
        	nuitUtils.showDeleteConfirmation()
				.then(function(){
					ChannelService.remove(channel);
				});
		}

		function openEditChannel(channel){
			return $mdDialog.show({
					controller: 'EditChannelController',
					controllerAs: 'vm',
					locals: {channel:channel},
					templateUrl: 'app/main/admin.notifications/dialogs/edit-channel/edit-channel.html',
					clickOutsideToClose: true
				});
		}
	}
})();



(function () {
	'use strict';

	angular
		.module('app.admin.documents')
		.factory('DocumentsService', DocumentsService);

	/** @ngInject */
	function DocumentsService($window, nuitApiProxy, nuitUtils, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _templates = [];
        var _envTemplates = [];
		var _orderDocuments = [];
		var _offerDocuments = [];
        var _productionDocuments = [];
        var _accountingDocuments = [];
        var _creditDocuments = [];
        var _deliveryDocuments = [];
		//*******************************************

		var _documentRoutes = [
			{name:'order',documents:_orderDocuments},
			{name:'offer', documents: _offerDocuments},
			{name:'production',documents:_productionDocuments},
			{name:'accounting',documents: _accountingDocuments},
			{name:'credit',documents: _creditDocuments},
			{name:'delivery',documents:_deliveryDocuments}
			];

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			addTemplate: addTemplate,
            reloadTemplates: reloadTemplates,
            reloadEnvTemplates: reloadEnvTemplates,
            loadTemplate: loadTemplate,
            deleteTemplate: deleteTemplate,
            previewTemplate: previewTemplate,
            previewHTML: previewHTML,
            updateTemplate: updateTemplate,
            getIndexOfTemplate: getIndexOfTemplate
		};

		for(var i=0;i<_documentRoutes.length;i++){
			var route = _documentRoutes[i];
			service[route.name] = getRoute(route.name,route.documents);
		}

        //*******************************************

        //*******************************************
        // PROPERTIES
        //*******************************************
        Object.defineProperty(service, 'templates', { get: function() { return _templates; } });
        Object.defineProperty(service, 'envTemplates', { get: function() { return _envTemplates; } });
		Object.defineProperty(service, 'documentRoutes', { get: function() { return _documentRoutes; } });
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
        /**
         * Reloads all templates.
         * @returns {Promise}
         */
        function reloadTemplates() {
            // Reload templates
            return nuitApiProxy('templates.all')
                .get()
                .then(function(response){
                    // Clear array (but keep reference)
                    _templates.splice(0, _templates.length);

                    // Inject new data
                    for(var prop in response.data) {
                        for(var index in response.data[prop]) {
                            response.data[prop][index].lang = prop;
                            _templates.push(response.data[prop][index]);
                        }
                    }
            });
        }
        /**
         * Reloads all environment templates.
         * @returns {Promise}
         */
        function reloadEnvTemplates() {
            return nuitApiProxy('templates.env.all')
                .get()
                .then(function(response){
                    // Clear array (but keep _envTemplates)
                    _envTemplates.splice(0, _templates.length);

                    // Inject new data
                    for(var prop in response.data) {
                        for(var index in response.data[prop]) {
                            response.data[prop][index].lang = prop;
                            _envTemplates.push(response.data[prop][index]);
                        }
                    }
            });
        }

        function reloadDocumentsInternal(array,route){
			return nuitApiProxy(route)
				.get()
				.then(function(response){
					nuitDataService.replaceAll(array,response.data);
				});
		}

        /**
         * Creates a new template with the given name and content.
         * @param {Template} template
         * @returns {Promise}
         */
		function addTemplate(template, local) {
			return nuitApiProxy(local ? 'templates.env' : 'templates', template.key).post(template.html, getTemplateParams(template));
		}
        /**
         * Updates the given template.
         * @param {Template} template
         * @returns {Promise}
         */
        function updateTemplate(template, local) {
            return nuitApiProxy(local ? 'templates.env' : 'templates', template.key).put(template.html, getTemplateParams(template));
        }
        /**
         * Builds the query parameters for a template upsert.
         * `orientation` is only sent when explicitly chosen: the document service keeps an
         * existing template's orientation untouched when the parameter is absent (new templates
         * default to Portrait server-side).
         * @param {Template} template
         * @returns {Object}
         */
        function getTemplateParams(template) {
            var params = { name: template.name, lang: template.lang };
            if(template.orientation) {
                params.orientation = template.orientation;
            }
            return params;
        }
        /**
         * Deletes the given template.
         * @param {String} template - template to delete
         * @returns {Promise or NULL if template does not exist}
         */
        function deleteTemplate(template, local) {
            var index = local ? getIndexOfEnvTemplate(template) : getIndexOfTemplate(template);
            if(index >= 0) {
                return nuitApiProxy(local ? 'templates.env' : 'templates', template.key)
                    .delete({name: template.name, lang: template.lang})
                    .then(function() {
                        if(local) {
                            _envTemplates.splice(index, 1);
                        } else {
                            _templates.splice(index, 1);
                        }
                });
            } else {
                return null;
            }
        }
        /**
         * Returns the index of the given template.
         * @param {Object} template
         * @return {Number}
         */
        function getIndexOfTemplate(template) {
            for(var index in _templates) {
                if(_templates[index].key === template.key) {
                    return index;
                }
            }
            return -1;
        }

        function getIndexOfEnvTemplate(template) {
            for(var index in _envTemplates) {
                if(_envTemplates[index].key === template.key) {
                    return index;
                }
            }
            return -1;
        }
        /**
         * Loads the template with the given key.
         * @param {String} key - template key
         * @returns {Promise}
         */
        function loadTemplate(key, lang, local) {
            return nuitApiProxy(local ? 'templates.env' : 'templates',key+".json")
                .get({lang: lang})
                .then(function(response) {
                    var template = response.data;
                    return template;
            });
        }
        /**
         * Previews the template with the given id.
         * @param {String} id
         * @param {String} lang
         * @returns {Promise}
         */
		function previewTemplate(id, lang, local) {
            var w = $window.open('', '_blank');
            return nuitApiProxy(local ? 'templates.env.preview' : 'templates.preview',id)
                .get({model: 'order', lang: lang})
                .then(function(response){
                    previewHTML(response.data, w);
            });
		}
        /**
         * Previews the given html.
         * @param {String} html
         * @param {Window} window
         */
        function previewHTML(html, window) {
            if(window === undefined) { window = $window.open('', '_blank'); }
            window.document.body.innerHTML = html;
        }

		function addDocumentInternal(array, document, route){
			return nuitApiProxy(route)
				.post(document)
				.then(function(response) {
					nuitDataService.addOne(array,response.data);
				});
		}

        function updateDocumentInternal(array,document,route){
			return nuitApiProxy(route, document.id)
				.put(document)
				.then(function(response) {
					nuitDataService.replaceOne(array,response.data);
				});
		}

        function deleteDocumentInternal(array, document, route){
			return nuitApiProxy(route, document.id)
				.delete()
				.then(function(response) {
					nuitDataService.removeOne(array,document.id);
				});
		}

		function getRoute(name, array){
        	var routes = {
        		reload: function(){return reloadDocumentsInternal(array,name + '.documents.all');},
				add: function(document){return addDocumentInternal(array,document,name + '.documents.all');},
				update: function(document){return updateDocumentInternal(array,document,name + '.documents.single');},
				delete: function(document){return deleteDocumentInternal(array,document,name + '.documents.single');}
			};

			Object.defineProperty(routes, 'documents', { get: function() { return array; } });

        	return routes;
		}
	}
}());

(function () {
	//'use strict';

	angular
		.module('app.admin.documents')
		.controller('AdminDocumentListController', controller);

	/** @ngInject */
	function controller($q, $filter, $state, $document, $mdDialog, nuitUtils, DocumentsService, ListSelectionService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.templates = DocumentsService.templates;
		vm.localTemplates = DocumentsService.envTemplates;
		vm.loading = true;

		vm.templateSelection = ListSelectionService.get('documents.templates', true);
		vm.localTemplateSelection = ListSelectionService.get('documents.templates.local', true);
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.openTemplate = openTemplate;

		//templates
		vm.isSelected = vm.templateSelection.isSelected;
		vm.deselectAll = vm.templateSelection.deselectAll;
		vm.deleteSelected = deleteSelected;
		vm.toggleSelectedTemplate = vm.templateSelection.toggleSelectedEntity;
		vm.toggleSelectedTemplates = toggleSelectedTemplates;

		//local templates
		vm.isLocalTemplateSelected = vm.localTemplateSelection.isSelected;
		vm.deselectLocalTemplates = vm.localTemplateSelection.deselectAll;
		vm.deleteSelectedLocalTemplates = deleteSelectedLocalTemplates;
		vm.toggleSelectedLocalTemplate = vm.localTemplateSelection.toggleSelectedEntity;
		vm.toggleSelectedLocalTemplates = toggleSelectedLocalTemplates;

		vm.preview = preview;

		vm.getName = function(document){
			return $filter('nuitTranslate')(document.name);
		};

		vm.documentObjects = [];

		for(var i=0;i<DocumentsService.documentRoutes.length;i++){
			vm.documentObjects.push(getDocumentsObject(DocumentsService.documentRoutes[i].name));
		}


		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// DIALOGS
		//*******************************************
		function generateDocumentsEditDialog(document) {
			return {
				controller: 'DocumentsEditController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.documents/dialogs/documents.edit/documents.edit.html',
				parent: angular.element($document.body),
				clickOutsideToClose: false,
				locals: {
					Document: document
				}
			};
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
			// Disable loading indicator if there are cached templates
			if (vm.templates.length > 0) {
				vm.loading = false;
			}

			// Reload all templates
			DocumentsService.reloadTemplates().then(function () {
				vm.loading = false;
			});
			DocumentsService.reloadEnvTemplates();

			for(var i=0;i<DocumentsService.documentRoutes.length;i++){
				DocumentsService[DocumentsService.documentRoutes[i].name].reload();
			};
		}

		function addDocumentInternal(api) {
			$mdDialog.show(generateDocumentsEditDialog())
				.then(function (document) {
					api(document)
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast);
				});
		}

		function editDocumentInternal(api, oldDocument) {
			$mdDialog.show(generateDocumentsEditDialog(angular.copy(oldDocument)))
				.then(function (newDocument) {
					api(newDocument)
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast);
				});
		}


		/**
		 * Toggles all templates off if at least one template is selected
		 * or selects all templates if none has been selected before.
		 * @returns {undefined}
		 */
		function toggleSelectedTemplates() {
			vm.templateSelection.toggleSelectedEntities(vm.templates);
		}

		function toggleSelectedLocalTemplates() {
			vm.localTemplateSelection.toggleSelectedEntities(vm.localTemplates);
		}

		/**
		 * Opens the template with the given id.
		 * @param {String} templateKey - id of the template
		 * @param {Boolean} local - if the document is a local one
		 */
		function openTemplate(template, local) {
			$state.go('app.adminDocuments.detail', {
				templateKey: template.key.split('.')[0],
				lang: template.lang,
				local: local
			}, {inherit: false});
		}

		/**
		 * Deletes all selected templates.
		 */
		function deleteSelected() {
			if (vm.templateSelection.getSelected().length < 1) {
				return;
			}

			openConfirmation(vm.templateSelection.getSelected().length).then(function () {
				var promises = [];
				angular.forEach(vm.templateSelection.getSelected(), function (template) {
					promises.push(DocumentsService.deleteTemplate(template));
				});
				$q.all(promises)
					.then(function () {
						nuitUtils.showSuccessToast();
						vm.templateSelection.deselectAll();
					})
					.catch(nuitUtils.showErrorToast);
			});
		}

		function deleteSelectedLocalTemplates() {
			if (vm.localTemplateSelection.getSelected().length < 1) {
				return;
			}

			openConfirmation(vm.localTemplateSelection.getSelected().length).then(function () {
				var promises = [];
				angular.forEach(vm.localTemplateSelection.getSelected(), function (template) {
					promises.push(DocumentsService.deleteTemplate(template, true));
				});
				$q.all(promises)
					.then(function () {
						nuitUtils.showSuccessToast();
						vm.localTemplateSelection.deselectAll();
					})
					.catch(nuitUtils.showErrorToast);
			});
		}

		function openConfirmation(deleteCount) {
			if (deleteCount === 1) {
				return nuitUtils.showDeleteConfirmation();
			} else {
				return nuitUtils.showDeleteMultiConfirm();
			}
		}

		/**
		 * Opens a preview of the template with the given id.
		 * @param {String} id - unique template id
		 * @param {String} lang - template language
		 * @param {Object} $event - event data
		 */
		function preview(id, lang, $event, local) {
			if ($event) {
				$event.stopPropagation();
			}

			DocumentsService.previewTemplate(id.split('.')[0], lang, local);
		}

		function getDocumentsObject(name){
			var object = {
				key: 'DOCUMENTS.' + name.toUpperCase() + '_DOCUMENTS',
				documents: DocumentsService[name].documents,
				selection: ListSelectionService.get(name + '.documents', true),
				reload: DocumentsService[name].reload,
				add: function(){addDocumentInternal(DocumentsService[name].add);},
				edit: function(document){editDocumentInternal(DocumentsService[name].update,document);}
			};

			object.toggleSelected = function(){
				object.selection.toggleSelectedEntities(object.documents);
			};

			object.deleteSelection = function(){
				if (object.selection.getSelected().length < 1) {
					return;
				}

				openConfirmation(object.selection.getSelected().length).then(function () {
					var promises = [];
					angular.forEach(object.selection.getSelected(), function (document) {
						promises.push(DocumentsService[name].delete(document));
					});
					$q.all(promises)
						.then(function () {
							nuitUtils.showSuccessToast();
							object.selection.deselectAll();
						})
						.catch(nuitUtils.showErrorToast);
					});
			};

			return object;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.documents')
		.controller('AdminDocumentDetailsController', AdminDocumentDetailsController);

	/** @ngInject */
	function AdminDocumentDetailsController($state, nuitUtils, DocumentsService) {
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.templateKey = $state.params.templateKey;                   // ID of current template
        vm.lang = $state.params.lang;
		vm.loading = false;                                 // Indicator if a loading process is running
		vm.template = {};
        vm.templateForm = {};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.saveTemplate = saveTemplate;
        vm.preview = preview;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////
        
		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Sets all required variables which are needed by the view and loads current material into scope
		 */
		function init() {
			vm.loading = true;

			DocumentsService
				.loadTemplate($state.params.templateKey, vm.lang, $state.params.local)
				.then(function (template) {
					// Older document-service versions don't return the orientation; fall back to the server default
					if(!template.orientation) { template.orientation = 'Portrait'; }
					vm.template = template;
				})
				.catch(function (error) {
                    console.log(error);
					vm.error = error;
				})
				.finally(function () {
					vm.loading = false;
				});

		}

		/**
		 * Sends updated material to remote server
		 */
		function saveTemplate() {
            DocumentsService
                .updateTemplate(vm.template, $state.params.local)
                .then(function() {
                vm.templateForm.$setPristine();
                vm.templateForm.$setUntouched();
                nuitUtils.showSuccessToast();
            })
                .catch(nuitUtils.showErrorToast);
		}
        
		function preview($event) {
			if($event) { $event.stopPropagation(); }
            
            DocumentsService.previewHTML(vm.template.html);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.documents')
		.controller('AdminDocumentAddController', AdminDocumentAddController);

	/** @ngInject */
	function AdminDocumentAddController($state, nuitUtils, DocumentsService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.template = { orientation: 'Portrait' };      // Contains the new template (server default orientation preselected)
        vm.templateForm = {};                           // Contains the DOM form
        //*******************************************
        
		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.saveTemplate = saveTemplate;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        /**
         * Saves the current template and returns to the documents overview.
         */
		function saveTemplate() {
			DocumentsService.addTemplate(vm.template, $state.params.local).then(function () {
                nuitUtils.showSuccessToast();
                goBack();
            }).catch(nuitUtils.showErrorToast);
		}
        /**
         * Returns to the overview.
         */
        function goBack() {
            $state.go('app.adminDocuments');
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.clients', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider, nuitApiProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.adminClients', {
				url: '/admin/clients',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin.clients/views/admin-clients.html',
						controller: 'AdminClientsController as vm'
					},
					'body@app.adminClients': {
						templateUrl: 'app/main/admin.clients/views/admin-clients.list.html',
						controller: 'AdminClientsListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.clients.enabled'
			}).state('app.adminClients.detail', {
				url: '/:id',
				views: {
					'body@app.adminClients': {
						templateUrl: 'app/main/admin.clients/views/admin-clients.detail.html',
						controller: 'AdminClientsDetailController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'admin.clients.enabled'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('admin.clients', {
			title: 'clients',
			icon: 'icon-radioactive',
			state: 'app.adminClients',
			translate: 'CLIENTS.CLIENTS_NAV',
			weight: 20,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().admin.clients.enabled;
			}
		});
        //*******************************************

		//*******************************************
		// API
		//*******************************************
        nuitApiProvider.register('environments', 'setup/environments', { allow: ['post','get'] });
        nuitApiProvider.register('environment.user', 'admin/users', { allow: ['post'] });
        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
			admin: {
                clients: {
                    enabled: false
                }
			}
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.clients')
		.factory('ClientsService', ClientsService);

	/** @ngInject */
	function ClientsService(nuitApi, $log) {
		//*******************************************
		// VARIABLES
		//*******************************************
        var environments = [];
        var users = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
            addEnvironment: addEnvironment,
            reloadEnvironments: reloadEnvironments,
		};
        //*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'environments', {
			get: function() { return environments; }
		});
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        function reloadEnvironments() {
            return nuitApi('environments')
                .get()
                .then(function(response) {
                    environments.splice(0, environments.length);
                    angular.merge(environments,response.data);

                    refreshEnvironmentStructure();
            });
        }

        function addEnvironment(env) {
            return nuitApi('environments')
                .post(env)
                .then(function(response) {
                    environments.push(response.data);

                    refreshEnvironmentStructure();
                    return response.data;
            }).catch(function() {
                reloadEnvironments();
            });
        }

        function refreshEnvironmentStructure() {
            for(var i in environments) {
                environments[i].users = [];
                for(var j in users) {
                    for(var k in users[j].environments) {
                        if(users[j].environments[k].id === environments[i].id) {
                            environments[i].users.push(users[j]);
                            break;
                        }
                    }
                }
            }
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.clients')
		.controller('AdminClientsListController', controller);

	/** @ngInject */
	function controller($mdSidenav, $state, $scope, nuitUtils, ClientsService, SetupTemplates, ListSelectionService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.environments = ClientsService.environments;
        vm.templates = SetupTemplates.templates;
        vm.filteredEnvironments = [];
        vm.currentPage = [];
		vm.currentPageEntities = [];
        vm.selection = ListSelectionService.get('clients.clients', true);
        vm.isLoading = ClientsService.environments.length === 0;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.isSelected = vm.selection.isSelected;
        vm.getSelected = vm.selection.getSelected;
        vm.deleteSelected = deleteSelected;
        vm.toggleSelect = vm.selection.toggleSelectedEntity;
		vm.isIndeterminate = vm.selection.isIndeterminate;
        vm.toggleSelection = toggleSelection;
		vm.toggleSidenav = toggleSidenav;
        vm.openClient = openClient;
        vm.filterAll = filterAll;
		vm.getName = function(client){
			return client.name;
		};
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
            ClientsService.reloadEnvironments()
                .then(function() {
                    filterAll();
                vm.isLoading = false;
            });

            SetupTemplates.reload();

            $scope.$watchCollection('vm.environments', function() { filterAll(); });
		}

        function openClient(client) {
            $state.go('app.adminClients.detail', {
				id: client.id
			}, {inherit: false});
        }

        function filterAll() {
            vm.filteredEnvironments = [];

            var term = angular.isString(vm.term) ? vm.term.toLowerCase() : vm.term;
            for(var index in vm.environments) {
                var env = vm.environments[index];
                if(!angular.isString(term) || term === '' || env.name.toLowerCase().indexOf(term) >= 0) {
                    vm.filteredEnvironments.push(vm.environments[index]);
                }
            }
        }

        function deleteSelected() {
            var promise = null;
            if (vm.selection.getSelected().length > 1) {
                promise = nuitUtils.showDeleteMultiConfirm();
            } else {
                promise = nuitUtils.showDeleteConfirmation();
            }

            promise.then(function () {
                angular.forEach(vm.selection.getSelected(), function (client) {
                    ClientsService.deleteClient(client.id)
                        .then(function () {
                            vm.selection.deselectAll();
                            nuitUtils.showSuccessToast();
                            //filterAll();
                        })
                        .catch(nuitUtils.showErrorToast);
                });
            });
        }

        function toggleSelection() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

		/**
		 * Toggles the side navigation on or off.
		 * @param {Number} sidenavId - id of the sidenav to toggle
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.clients')
		.controller('AdminClientsDetailController', controller);

	/** @ngInject */
	function controller($mdSidenav, $state, nuitUtils, SetupTemplates, ListSelectionService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.templates = SetupTemplates.templates;
        vm.selection = ListSelectionService.get('setup.templates', true);
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.isSelected = vm.selection.isSelected;
        vm.getSelected = vm.selection.getSelected;
        vm.deleteSelected = deleteSelected;
        vm.toggleSelect = vm.selection.toggleSelectedEntity;
		vm.toggleSidenav = toggleSidenav;
        vm.openTemplate = openTemplate;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this controller.
		 */
		function init() {
            SetupTemplates.reload();
		}
        
        /**
         * Opens the edit screen of the given template.
         * 
         * @param {Object} template
         */
        function openTemplate(template) {
            $state.go('app.adminSetup.detail', {
				id: template.id
			}, {inherit: false});
        }
        
        function deleteSelected() {
            var promise = null;
            if (vm.selection.getSelected().length > 1) {
                promise = nuitUtils.showDeleteMultiConfirm();
            } else {
                promise = nuitUtils.showDeleteConfirmation();
            }

            promise.then(function () {
                angular.forEach(vm.selection.getSelected(), function (client) {
                    
                });
            });
        }

		/**
		 * Toggles the side navigation on or off.
		 * @param {Number} sidenavId - id of the sidenav to toggle
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.clients')
		.controller('AdminClientsController', controller);

	function controller($mdDialog, ClientsService, nuitApi, nuitAuth, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.term = '';
        vm.environments = ClientsService.environments;
        vm.auth = nuitAuth;
        vm.selectedEnvironment = null;
        //*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.showAddEnvironmentDialog = showAddEnvironmentDialog;
        vm.assignToEnvironment = assignToEnvironment;
        vm.isUserInEnvironment = isUserInEnvironment;
        vm.toggleSelectEnvironment = toggleSelectEnvironment;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        function init() {
            ClientsService.reloadEnvironments();
        }

        function toggleSelectEnvironment(environment) {
            if(vm.selectedEnvironment === environment) {
                vm.selectedEnvironment = null;
            } else {
                vm.selectedEnvironment = environment;
            }
        }

        function assignToEnvironment(env) {
            nuitApi('environment.user')
                .post({
                    email: nuitAuth.getUser().email,
                    status: 2
            },{
                environment: env.id
            }).then(function(response) {
                nuitApi('user.environment.config')
                    .put({
                        admin: {
                            clients: { enabled: { value: true, type: 4 } },
                            environment: { enabled: { value: true, type: 4 } },
                            documents: { enabled: { value: true, type: 4 } },
                            translations: { enabled: { value: true, type: 4 } },
                            status: { enabled: { value: true, type: 4 } }
                    }
                },{},{params: {
                        scope: 'user',
                        environment: env.id,
                        user: nuitAuth.getUser().id
                }}).then(function() {
                nuitUtils.showSuccessToast();
                    if(!isUserInEnvironment(nuitAuth.getUser(), env)) {
                        env.users.push(nuitAuth.getUser());
                    }
                })
                .catch(nuitUtils.showErrorToast);
        });
        }

		function createAddEnvironmentDialog() {
			return {
				controller: 'AddEnvironmentDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.clients/dialogs/add-environment/add-environment.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true
			};
		}

        function isUserInEnvironment(user, environment) {
            if(environment === null) { return true; }

            for(var i in environment.users) {
                if(environment.users[i].id.toString() === user.id.toString()) {
                    return true;
                }
            }
            return false;
        }

        function showAddEnvironmentDialog() {
			$mdDialog.show(createAddEnvironmentDialog());
        }
	}
})();



(function () {
	'use strict';

	angular
		.module('ims', [
			// 3rd Party Dependecies
			'vAccordion',
			'textAngular',
			'angular.img',
            'treeControl',
			'angular-inview',
			angularDragula(angular),
			'datatables',
			// IMS
			'nuit.editor',
			'app.core',
			'app.navigation',
			'app.toolbar',

			// Main Modules
			'app.auth',
			'app.errors',
            'app.dashboard',
			'app.orders',
			'app.products',
			'app.roles',
			'app.materials',
			'app.users',
			'app.system',
			'app.profiles',
            'app.orders.proposals',
            'app.orders.offers',
            'app.orders.settings',
            'app.accounting',
            'app.credit',
            'app.partners.companies',
			'app.partners.companies.admin',
            'app.partners.suppliers',
			'app.transport',
			'app.production.orders',
			'app.production.planning',
            'app.production.easy',
            'app.production.queue',
            'app.production.machines',
            'app.controlling.sales',
            'app.controlling.user',
            'app.controlling.material',
			'app.system.sales',
			'app.printer',
			'app.exchange',
			'app.projects',
			'app.production.punchTools',

			// Admin Modules
            'app.admin.clients',
            'app.admin.environment',
			'app.admin.translations',
			'app.admin.documents',
            'app.admin.setup',
            'app.admin.status',
			'app.admin.notifications',
			'app.admin.operations',
			'ui.router.state.events'
		]);
})();

(function () {
	'use strict';

	// Like the third-party `http-src` directive, but routes the fetch through imsUtils so
	// oversized sketch SVGs are cropped to their content before being displayed. Sets the
	// element's `src` to an object URL and revokes it when the source changes or the scope
	// is destroyed. `data:` URLs are passed through untouched.
	angular
		.module('ims')
		.directive('nuitDocSrc', nuitDocSrc);

	/** @ngInject */
	function nuitDocSrc(imsUtils) {
		return {
			restrict: 'A',
			link: function (scope, elem, attrs) {
				var objectURL = null;
				var requestId = 0;

				function revoke() {
					if (objectURL) {
						window.URL.revokeObjectURL(objectURL);
						objectURL = null;
					}
				}

				attrs.$observe('nuitDocSrc', function (url) {
					// Bump the token so a slower in-flight fetch can't overwrite a newer one.
					var token = ++requestId;
					revoke();

					if (!url) {
						elem.attr('src', '');
						return;
					}
					if (url.indexOf('data:') === 0) {
						elem.attr('src', url);
						return;
					}
					imsUtils.fetchDocumentBlob(url).then(function (doc) {
						if (token !== requestId) { return; }
						objectURL = window.URL.createObjectURL(doc.blob);
						elem.attr('src', objectURL);
					});
				});

				scope.$on('$destroy', revoke);
			}
		};
	}
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService) {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass: 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort: function () {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init() {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response) {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if (vm.shortcuts.length > 0) {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old) {
                if (angular.isUndefined(current)) {
                    return;
                }

                if (angular.equals(current, old)) {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response) {
                        vm.results = response;
                    },
                    // Error
                    function () {
                        vm.results = [];
                    }
                ).finally(
                    function () {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults() {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if (vm.query) {
                results = results.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1) {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for (var i = 0; i < results.length; i++) {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for (var y = 0; y < vm.shortcuts.length; y++) {
                        if (vm.shortcuts[y]._id === results[i]._id) {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            } else {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if (vm.shortcuts.length > 0) {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function () {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if (angular.isUndefined(shortcuts)) {
                shortcuts = [

                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function () {
                deferred.resolve({
                    'success': true
                });
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item) {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item) {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for (var x = 0; x < vm.shortcuts.length; x++) {
                if (vm.shortcuts[x]._id === item._id) {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if (!vm.query) {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if (vm.shortcuts.length === 0) {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else {
                            if (x >= vm.shortcuts.length) {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item) {
            // Add or remove the shortcut
            if (item.hasShortcut) {
                vm.removeShortcut(item);
            } else {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event) {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if (keys.indexOf(keyCode) > -1) {
                event.preventDefault();
            }

            switch (keyCode) {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                    // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if (vm.selectedResultIndex - 1 >= 0) {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                    // Down Arrow
                case 40:

                    // Increase the selected result index
                    if (vm.selectedResultIndex + 1 < vm.results.length) {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index) {
            if (vm.ignoreMouseEvents) {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function () {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible() {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if (resultsEl && selectedItemEl) {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if (resultsEl.scrollTop() > top) {
                    resultsEl.scrollTop(top);
                }

                if (bottom > (resultsEl.height() + resultsEl.scrollTop())) {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar() {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective() {
        return {
            restrict: 'E',
            scope: {},
            require: 'msShortcuts',
            controller: 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl: 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile: function (tElement) {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement) {
                    // Data

                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('ims')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
            	var childHeight;

                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }


	            childHeight = Math.max.apply(Math, referenceArr);
                vm.container.height(childHeight);
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
		.directive('iframeOnload', function(){
		return {
			restrict: 'A',
			scope: {
				callback: '<iframeOnload'
			},
			link: function(scope, elements, attrs){
				for (var i = 0; i < elements.length; i++) {
					var currentIndex = i;
					scope.callback(elements[currentIndex]);
					elements[currentIndex].onload = function () {
						scope.callback(elements[currentIndex]);
					};
				}
			}
		};});
})();

(function () {
	'use strict';

	angular
		.module('ims')
		.filter('shortName', shortName);

	function shortName() {
		// Returns obj.shortName when present, otherwise renders the given
		// fallback template with {key} placeholders resolved from obj.
		//
		// Usage:
		//   {{ profile.profile | shortName }}                    -> shortName, falls back to id
		//   {{ material         | shortName:'#{id}' }}           -> shortName, falls back to "#42"
		//   {{ profile.profile  | shortName:'{number}-{name}' }} -> shortName, falls back to "P12-Frame"
		return function (obj, template) {
			if (!obj) { return ''; }
			if (obj.shortName) { return obj.shortName; }
			return formatTemplate(template || '{id}', obj);
		};

		function formatTemplate(template, obj) {
			return String(template).replace(/\{([^{}]+)\}/g, function (match, key) {
				var value = obj[key];
				return value == null ? '' : value;
			});
		}
	}
}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('nuitDate', nuitDate)
        .filter('nuitTime', nuitTime);

    function nuitDate() {
        return function (value) {
            var arr = (new Date(value)).toLocaleDateString().split('.');
            for (var i = 0; i < arr.length; i++) {
                var s = arr[i] + '';
                if (s.length < 2) {
                    arr[i] = '0' + arr[i];
                }
            }
            return arr.join('.');
        };
    }

    function nuitTime() {
        return function (value) {
            return (new Date(value)).toLocaleTimeString();
        };
    }
}());

(function () {
	'use strict';

	// DEPRECATED. Use nuitUnit filter instead

	angular
		.module('ims')
		.filter('imsUnit', imsUnit);

	/** @ngInject */
	function imsUnit(imsConfig, $translate) {
		var config = imsConfig.getCurrent();
		var _unitMapping = {
			length: {
				symbol: config.units.length.symbol || 'mm',
				factor: config.units.length.factor || 1,
				decimals: config.units.length.decimals || 1
			},
			weight: {
				symbol: config.units.weight.symbol || 'kg',
				factor: 1
			},
			density: {
				symbol: config.units.pressure.symbol || 'kg/m²',
				factor: 1
			}
		};

		return function (value, unit, appendSymbol) {
			var numericValue = Number(value);

			if (isNaN(numericValue) && !unit) {
				unit = value;
			}

			if (!_unitMapping.hasOwnProperty(unit)) {
				throw new Error('Unknown unit ' + unit);
			}

			var unitObject = _unitMapping[unit];

			if (!isNaN(numericValue)) {
				var localStringOptions = {};

				if (unitObject.hasOwnProperty('decimals')) {
					localStringOptions.minimumFractionDigits = unitObject.decimals;
					localStringOptions.maximumFractionDigits = unitObject.decimals;
				}

				var convertedValue = (numericValue / unitObject.factor).toLocaleString($translate.use(), localStringOptions);

				if (appendSymbol) {
					convertedValue += ' ' + unitObject.symbol;
				}

				return convertedValue;
			}

			return unitObject.symbol;
		};
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.filter('imsLanguageFallback', imsLanguageFallback);

	/** @ngInject */
	function imsLanguageFallback($translate, nuitConfig) {
		/**
		 * Opt-in alternative to the core languageFilter.
		 *
		 * Reduces translated entities to one entry per entity, picking the best
		 * available language: the active one first, then the fallback language,
		 * then the environment languages, then whatever exists at all.
		 *
		 * Unlike languageFilter this groups per entity, so an entity missing the
		 * active language neither disappears nor hides the entities that do have
		 * it. Currently used for production order documents only - the core
		 * filter keeps its previous behaviour for every other consumer.
		 *
		 * @param {Array} array entities carrying a language property
		 * @param {String} languageKey name of the language property, e.g. 'lang'
		 * @param {String} [groupKey='id'] property identifying one entity across languages
		 * @returns {Array} one entity per group
		 */
		return function (array, languageKey, groupKey) {
			if (!angular.isArray(array)) {
				return [];
			}

			var identity = groupKey || 'id';
			var preferences = buildPreferences();
			var groups = {};
			var groupIds = [];
			var result = [];
			var i;

			for (i = 0; i < array.length; i++) {
				var entity = array[i];
				var id = angular.isUndefined(entity[identity]) || entity[identity] === null
					? entity[languageKey]
					: entity[identity];

				if (!groups.hasOwnProperty(id)) {
					groups[id] = [];
					groupIds.push(id);
				}

				groups[id].push(entity);
			}

			for (i = 0; i < groupIds.length; i++) {
				var pick = pickPreferred(groups[groupIds[i]]);
				if (pick) {
					result.push(pick);
				}
			}

			return result;

			function buildPreferences() {
				var config = nuitConfig.getCurrent() || {};
				var list = [];

				add($translate.use());
				add($translate.fallbackLanguage ? $translate.fallbackLanguage() : null);
				add(config.languages);

				return list;

				function add(language) {
					if (angular.isArray(language)) {
						for (var l = 0; l < language.length; l++) {
							add(language[l]);
						}
					} else if (language && list.indexOf(language) === -1) {
						list.push(language);
					}
				}
			}

			function pickPreferred(entities) {
				for (var p = 0; p < preferences.length; p++) {
					for (var e = 0; e < entities.length; e++) {
						if (entities[e][languageKey] === preferences[p]) {
							return entities[e];
						}
					}
				}

				// no known language matched - show the next best thing we have
				return entities[0];
			}
		};
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('UserSelectionController', UserSelectionController);

	/** @ngInject */
	function UserSelectionController($q, $scope, $mdDialog, Users, RoleService, DialogConfig, nuitConfig,ListSelectionService, nuitUtils, nuitDataService){
		var vm = this;

		vm.users = Users;
		vm.dialogConfig = DialogConfig;
		vm.config = nuitConfig.getCurrent();
		vm.selection = ListSelectionService.get('user.selection', true);
		vm.searchText = '';

		vm.submit = submit;
		vm.cancel = cancel;

		vm.filteredEntities = [];
		vm.currentPage = 0;
		vm.currentPageEntities = [];
		vm.isLoading = false;
		vm.roles = RoleService.roles;

		vm.deselectAll = vm.selection.deselectAll;
		vm.deleteSelected = deleteSelected;
		vm.isSelected = vm.selection.isSelected;
		vm.getSelected = vm.selection.getSelected;
		vm.toggleSelected = toggleSelected;
		vm.toggleAllSelected = toggleAllSelected;
		vm.isIndeterminate = vm.selection.isIndeterminate;
		vm.filterAll = filterAll;

		vm.getName = function(user){
			return user.lastName + ' ' + user.firstName;
		};

		init();

		function init(){
			vm.isLoading = true;

			RoleService.reload()
				.then(function(){
					if(vm.roles.length>0){
						for(var i=0;i<vm.roles.length;i++){
							if(vm.roles[i].type===0){
								vm.roleId = vm.roles[i].id;
								break;
							}
						}
					}

					for(var i=0;i<vm.users.length;i++){
						if(vm.users[i].hasNoRole){
							var oldRowId = vm.users[i].roleId;
							vm.users[i].roleId = vm.roleId;
						}
					}
					vm.isLoading = false;
					filterAll();
				});
		}

		function filterAll(){
			var entities = [];

			var i;
			for (i in vm.users) {
				if (filterUser(vm.users[i])) {
					entities.push(vm.users[i]);
				}
			}

			vm.filteredEntities = entities;

			vm.deselectAll();
		}

		function filterUser(user) {
			if (vm.searchText === '') {
				return true;
			} else {
				var firstName = user.firstName?user.firstName.toLowerCase():'';
				var lastName = user.lastName?user.lastName.toLowerCase():'';
				var email = user.email?user.email.toLowerCase():'';
				vm.searchText = vm.searchText.toLowerCase();
				if (firstName.includes(vm.searchText) || lastName.includes(vm.searchText) || email.includes(vm.searchText)) {
					return true;
				} else {
					return false;
				}
			}
		}

		function deleteSelected() {
			var promise;
			if (vm.getSelected().length > 1) {
				promise = nuitUtils.showDeleteMultiConfirm();
			} else if (vm.getSelected().length === 1) {
				promise = nuitUtils.showDeleteConfirmation();
			} else {
				return;
			}
		}

		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			$mdDialog.hide({users:vm.selection.getSelected(),roleId: vm.roleId});
		}

		function toggleAllSelected() {
			vm.selection.toggleSelectedEntities(vm.currentPageEntities);
		}

		function toggleSelected(user){
			if(vm.dialogConfig.singleSelect) {
				vm.selection.deselectAll();
			}
			vm.selection.toggleSelectedEntity(user);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('SignupController', SignupController);

	/** @ngInject */
	function SignupController($mdDialog,nuitConfig,RoleService,imsTranslation, RoleType, CompanyId, nuitApi) {

		var vm = this;
		vm.translation = imsTranslation;
		vm.config = nuitConfig.getCurrent();
		vm.languages = vm.config.languages;
		vm.locale = vm.config.localization.defaultLanguage;
		vm.roleType = RoleType;
		vm.error = null;

		init();

		function init() {
			initVariables();
			initMethodes();
		}

		function initVariables() {
			vm.email = '';
			vm.roleId = '';
			vm.roles = RoleService.roles;
			RoleService.reload();
		}

		function initMethodes() {
			vm.savePerson = savePerson;
			vm.hide = hide;
		}

		function savePerson() {
			vm.error = null;

			var data = {
				email: vm.email,
				roleId: vm.roleId,
				locale: vm.locale
			};
			if (CompanyId) { data.companyId = CompanyId; }

			nuitApi('signup').post(data)
				.then(function (response) {
					$mdDialog.hide(response);
				})
				.catch(function (response) {
					vm.error = response.data.error || response.data.message;
				});
		}

		function hide(){
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('OrderSpecialController', OrderSpecialController);

	/** @ngInject */
	function OrderSpecialController($scope, $mdDialog, Special, nuitConfig){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.special = Special?angular.copy(Special):{};
		vm.config = nuitConfig.getCurrent();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {

        }
		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			if(!vm.special.description){
				vm.special.description = '';
			}
			$mdDialog.hide(vm.special);
		}

	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.controller('ImageController', ImageController);

	/** @ngInject */
	function ImageController($mdDialog, image) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.image = image;

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function close() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.controller('GlbDialogController', GlbDialogController)
		// Sets <model-viewer src> directly on the DOM node. Avoids AngularJS routing the `src`
		// attribute of a non-media element through $sce (which rejects blob: URLs as RESOURCE_URL).
		.directive('modelViewerSrc', modelViewerSrc);

	/** @ngInject */
	function modelViewerSrc() {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				scope.$watch(attrs.modelViewerSrc, function (value) {
					if (value) {
						element[0].setAttribute('src', value);
					}
				});
			}
		};
	}

	/** @ngInject */
	function GlbDialogController($scope, $http, $q, $window, url) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.loading = true;
		vm.error = false;
		vm.src = null;

		//*******************************************
		// INIT
		//*******************************************
		ensureModelViewer()
			.then(loadModel)
			.catch(fail);

		// Free the blob URL when the dialog closes (also covers click-outside, which cancels
		// the dialog without going through a button handler).
		$scope.$on('$destroy', function () {
			if (vm.src) {
				$window.URL.revokeObjectURL(vm.src);
			}
		});

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		// Fetch the GLB through Angular's $http so the auth interceptor adds the token (same
		// proven cross-origin path as the http-src directive), then hand model-viewer a local
		// blob URL - that way model-viewer never needs credentials or CORS of its own.
		function loadModel() {
			return $http.get(url, { responseType: 'arraybuffer' })
				.then(function (response) {
					var blob = new $window.Blob([response.data], { type: 'model/gltf-binary' });
					vm.src = $window.URL.createObjectURL(blob);
					vm.loading = false;
				}, fail);
		}

		function fail() {
			vm.loading = false;
			vm.error = true;
		}

		// Lazily load the (large) model-viewer module only when a GLB is first opened.
		function ensureModelViewer() {
			var customElements = $window.customElements;
			if (!customElements || !customElements.whenDefined) {
				return $q.reject('Custom elements are not supported by this browser.');
			}

			if (!$window.document.getElementById('model-viewer-script')) {
				var script = $window.document.createElement('script');
				script.id = 'model-viewer-script';
				script.type = 'module';
				script.src = 'assets/vendor/model-viewer.min.js';
				$window.document.head.appendChild(script);
			}

			return $q.when(customElements.whenDefined('model-viewer'));
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('FolderCopyController', FolderCopyController);

	/** @ngInject */
	function FolderCopyController($mdDialog, EnvironmentService, nuitApi, nuitUtils) {
		var vm = this;


		vm.submit = submit;
		vm.cancel = cancel;
		vm.environments = EnvironmentService.environments;
		vm.fromEnv = null;
		vm.toEnv = null;
		vm.inProgress = false;

		init();

		function init(){
			EnvironmentService.reload();
		}

		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			nuitUtils.showConfirmationDialog('MAINTENANCE.CONFIRM_COPY_ENV_FOLDERS_TITLE','MAINTENANCE.CONFIRM_COPY_ENV_FOLDERS_CONTENT').then(
				function () {
					vm.inProgress = true;
					nuitApi('profiles.copy.admin').post({
						fromEnvId: vm.fromEnv.toString(),
						toEnvId: vm.toEnv.toString()
					})
						.then(function () {
								$mdDialog.hide();
							}
						)
						.catch(nuitUtils.showErrorToast)
						.finally(function () {
							vm.inProgress = false;
						});
				}
			);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('EvoVersionController', EvoVersionController);

	/** @ngInject */
	function EvoVersionController(nuitDataService, $mdDialog, EnvironmentService, nuitUtils) {
		var vm = this;

		vm.inProgress = false;
		vm.environment = {evoVersion:1};
		vm.evoVersions = [EnvironmentService.evoVersions[1],EnvironmentService.evoVersions[2],EnvironmentService.evoVersions[3]];

		vm.cancel = cancel;
		vm.submit = submit;

		init();

		function init(){
			vm.inProgress = true;
			EnvironmentService.getCurrent()
				.then(function(environment){
					vm.inProgress = false;
					nuitDataService.replaceOneEntity(vm.environment, environment);
				});
		}

		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			EnvironmentService.updateCurrent(vm.environment)
				.then($mdDialog.hide)
				.catch(nuitUtils.showErrorToast);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.controller('EditorDialogController', EditorDialogController);

	/** @ngInject */
	function EditorDialogController(
		$interval,
		$q,
		$sce,
		$sceDelegate,
		nuitApi,
		nuitAuth,
		$scope,
		$timeout,
		$mdDialog,
		nuitConfig,
		imsUtils,
		Profile,
		ShowMaterials,
		MaterialRequired,
		nuitEditor,
		nuitProfile,
		nuitProfiles,
		nuitEditorEvents,
		ProfileValidateService,
		ProfileName,
		Options
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;


		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();
		vm.profile = Profile;
		vm.showMaterials = ShowMaterials;
		vm.materialRequired = MaterialRequired;
		vm.errors = ProfileValidateService.errors;
		vm.allowSave = Options.allowSave;
		vm.allowOpen = Options.allowOpen;
		vm.editorNextChannel = null;

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.showMaterialDialog = showMaterialDialog;
		vm.submit = submit;
		vm.closeDialog = closeDialog;
		vm.validate = function () {
			$timeout(ProfileValidateService.validate);
		};
		vm.materialValid = materialValid;
		vm.saveProfile = saveProfile;
		vm.openProfile = openProfile;
		vm.iframeLoaded = iframeLoaded;
		vm.editorLocation = editorLocation;
		vm.useNewEditor = useNewEditor;
		//*******************************************

		//*******************************************
		// INIT
		//*******************************************
		init();

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			//profile.init(vm.config);
			if (vm.profile) {
				nuitEditor.importProfile(vm.profile, true);
			} else {
				nuitProfile.clear(false, true);
			}
			addListener();
		}

		function addListener() {
			$scope.$on(nuitEditorEvents.segmentAdded, vm.validate);
			$scope.$on(nuitEditorEvents.segmentRemoved, vm.validate);
			$scope.$on(nuitEditorEvents.segmentLengthChanged, vm.validate);
			$scope.$on(nuitEditorEvents.segmentAngleChanged, vm.validate);
			$scope.$on(nuitEditorEvents.segmentBendingChanged, vm.validate);
			$scope.$on(nuitEditorEvents.segmentCloseChanged, vm.validate);
			$scope.$on(nuitEditorEvents.segmentConicalChanged, vm.validate);
			$scope.$on(nuitEditorEvents.segmentMeasureChanged, vm.validate);
			$scope.$on(nuitEditorEvents.profileCleared, vm.validate);
			$scope.$on(nuitEditorEvents.materialChanged, vm.validate);
			$scope.$on(nuitEditorEvents.segmentDepthChanged, vm.validate);
			$scope.$on(nuitEditorEvents.visibleSideChanged, vm.validate);
			$scope.$on(nuitEditorEvents.conicalBaseChanged, vm.validate);
			$scope.$on(nuitEditorEvents.rendered, vm.validate);
		}

		/**
		 * Displays the material selection dialog.
		 */
		function showMaterialDialog() {
			return imsUtils.openMaterialSelectionDialog();
		}

		/**
		 * Displays the new profile confirmation dialog.
		 */
		function showNewProfileDialog() {
			// Show dialog
			$mdDialog
				.show(createConfirmClearDialog())
				.then(reset);
		}

		/**
		 * Select material
		 */
		function submit() {
			if (vm.errors.length > 0) {
				return;
			}

			new Promise(function (resolve, reject) {
				if (vm.editorNextChannel) {
					vm.editorNextChannel.saveProfile().then(function (profile) {
						if (profile) {
							nuitProfiles.logGeometryShape(profile, 'editor iframe -> IMS (saveProfile)');
							resolve(profile);
						} else {
							reject(profile);
						}
					}).catch(reject);
				} else {
					resolve(nuitEditor.exportProfile());
				}
			}).then(function (tempProfile) {
				ProfileName.update(tempProfile);
				$mdDialog.hide(tempProfile).then(nuitEditor.clearProfile);
			}).catch(function (error) {
				if(error) {
					console.error(error);
				}
			});
		}

		function materialValid() {
			if(vm.useNewEditor()) {
				return true;
			}
			if (vm.materialRequired) {
				return nuitProfile.getMaterial() !== null;
			} else {
				return true;
			}
		}

		/**
		 * Closes this dialog.
		 */
		function closeDialog() {
			vm.errors.length = 0;
			$mdDialog.cancel().then(nuitEditor.clearProfile);
		}

		function saveProfile($event) {
			return $mdDialog.show(createSaveDialog($event));
		}

		function createSaveDialog($event) {
			return {
				controller: 'SaveDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/core/dialogs/save-profile/save-dialog.html',
				targetEvent: $event,
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				multiple: true,
				locals: {
					profileObject: nuitEditor.exportProfile()
				}
			};
		}

		function openProfile($event) {
			return $mdDialog.show(createOpenDialog($event))
				.then(function (profile) {
					nuitEditor.importProfile(profile);
					nuitEditor.manager.iterativeCenter();
					return profile;
				});
		}

		function createOpenDialog($event) {
			return {
				controller: 'OpenDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/core/dialogs/open-profile/open-dialog.html',
				targetEvent: $event,
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				multiple: true,
				locals: {
					profileObject: nuitEditor.exportProfile()
				}
			};
		}

		function iframeLoaded(iframe) {
			if(vm.editorNextChannel) {
				return;
			}
			vm.editorNextChannel = window.IFrameChannel.createIFrameChannel('evo-ims', iframe);

			vm.editorNextChannel.addEventListener('editorReady', function () {
				vm.editorNextChannel.setConfig({
					allowOpen: vm.allowOpen,
					allowSave: vm.allowSave,
					showMaterials: vm.showMaterials,
					materialRequired: vm.materialRequired
				});

				nuitProfiles.logGeometryShape(vm.profile, 'IMS -> editor iframe (setProfile)');
				vm.editorNextChannel.setProfile(vm.profile);
			});

			vm.editorNextChannel.addEventListener('close', function() {
				vm.closeDialog();
			});
		}

		function useNewEditor() {
			return nuitAuth.getEvoVersion() >= 2;
		}

		function editorLocation() {
			var baseUrl = window.location.origin;

			baseUrl = baseUrl.replace('ims-v1', 'evo-v2');
			baseUrl = baseUrl.replace('ims', 'evo-v2');
			if (!window.location.hostname.endsWith('.local')) {
				baseUrl = baseUrl.replace('://', '://nosw-');
			}
			baseUrl = baseUrl.replace('nu-it.at', 'nu-it.com');

			if(window.location.origin.includes('localhost')) {
				baseUrl = 'https://nosw-dev-evo-v2.nu-it.com';

				// Uncomment for local development
				// baseUrl = 'http://localhost:8080';
			}

			var editorUrl = new URL('/auth/embedded/ims', baseUrl);
			editorUrl.searchParams.set('token', nuitAuth.getToken());

			return $sce.trustAsResourceUrl(editorUrl.toString());
		}
	}

})();

(function () {
	'use strict';

	angular
		.module('ims')
		.controller('CsvImportController', CsvImportController);

	/** @ngInject */
	function CsvImportController($scope, $mdDialog, title, fileName){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.title = title;
		vm.fileName = fileName;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {

        }
		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			vm.isLoading = true;
			$mdDialog.hide(new FormData($('#colorUploadForm')[0]));
        }

	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.component('vueFrame', {
			templateUrl: 'app/ims/components/vue-frame/vue-frame.component.html',
			controller: VueFrameController,
			controllerAs: 'vm',
			bindings: {
				route: '@'
			}
		});

	/** @ngInject */
	function VueFrameController($sce, nuitConfig) {
		var vm = this;
		vm.config = nuitConfig.getCurrent();
		vm.iframeLoaded = iframeLoaded;
		vm.location = location;

		function iframeLoaded(iframes){
			console.error('iframe loaded', iframes);
		}

		function location(){
			console.error('route: ', $sce.trustAsResourceUrl(vm.config.ims.system.newEditor.location) + vm.route);
			return $sce.trustAsResourceUrl(vm.config.ims.system.newEditor.location + vm.route) ;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.component('nuitTeaserMachine', {
			templateUrl: 'app/ims/components/nuit-teaser-machine/nuit-teaser-machine.html',
			controller: NuitTeaserMachine,
			controllerAs: 'vm',
			bindings: {
				data: '<',
			}
		});

	/** @ngInject */
	function NuitTeaserMachine() {
		//*******************************************
		// CONTROLLER
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.$onInit = init;
		vm.openLink = openLink;

		function init(){

		}

		function openLink(){
			window.open(this.data.link, '_blank');
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.component('nuitStamps', {
			templateUrl: 'app/ims/components/nuit-stamps/nuit-stamps.html',
			controller: NuitStamps,
			controllerAs: 'vm',
			bindings: {
				stamps: '<',
			}
		});

	/** @ngInject */
	function NuitStamps() {
		//*******************************************
		// CONTROLLER
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.$onInit = init;

		function init(){
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.component('nuitStamp', {
			templateUrl: 'app/ims/components/nuit-stamp/nuit-stamp.html',
			controller: NuitStamp,
			controllerAs: 'vm',
			bindings: {
				stamp: '<',
			}
		});

	/** @ngInject */
	function NuitStamp(nuitSimplePunching) {
		//*******************************************
		// CONTROLLER
		//*******************************************
		var vm = this;
		vm.internalPunch = null;

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.$onInit = init;

		function init(){
			if(vm.stamp.shape){
				vm.internalPunch = nuitSimplePunching.toDefaultStamping(vm.stamp);
			}else{
				vm.internalPunch = this.stamp;
			}
		}
	}
}());

(function () {
	'use strict';

	/**
	 * Wraps a profile preview image (passed in as transcluded content) and overlays an attachment
	 * badge in the lower-right corner. When the profile has attachments beyond the one already shown
	 * as the preview, the badge shows their count and opens a thumbnail menu; clicking a thumbnail
	 * previews images in a dialog and GLBs in the in-app 3D viewer.
	 *
	 * Usage:
	 *   <nuit-profile-preview profile="profile">
	 *       <img http-src="{{ profile | profileImage }}" ...>
	 *   </nuit-profile-preview>
	 */
	angular
		.module('ims')
		.component('nuitProfilePreview', {
			templateUrl: 'app/ims/components/nuit-profile-preview/nuit-profile-preview.html',
			controller: controller,
			controllerAs: 'vm',
			transclude: true,
			bindings: {
				profile: '<'
			}
		});

	/** @ngInject */
	function controller(nuitProfiles, imsUtils, nuitAuth) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.getAttachments = getAttachments;
		vm.getAttachmentLabel = nuitProfiles.getAttachmentLabel;
		vm.isGlb = nuitProfiles.isGlbAttachment;
		vm.getThumbUrl = getThumbUrl;
		vm.openAttachment = openAttachment;

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		// Attachments excluding the one already shown as the preview image.
		function getAttachments() {
			return nuitProfiles.getSecondaryAttachments(vm.profile);
		}

		// Plain <img>-loadable URL with the access token in the query string (the http-src
		// directive's XHR loading does not work reliably inside md-menu content).
		function getThumbUrl(attachment) {
			var url = nuitProfiles.getAttachmentUrl(attachment);
			if (!url) { return ''; }
			return url + (url.indexOf('?') === -1 ? '?' : '&') + 'access-token=' + nuitAuth.getToken();
		}

		function openAttachment(attachment) {
			var url = nuitProfiles.getAttachmentUrl(attachment);
			if (!url) { return; }

			if (nuitProfiles.isGlbAttachment(attachment)) {
				imsUtils.openGlb(url);
				return;
			}

			imsUtils.openImage(url);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.component('nuitFields', {
			templateUrl: 'app/ims/components/nuit-fields/nuit-fields.html',
			controller: NuitFields,
			controllerAs: 'vm',
			bindings: {
				parent: '=',
				field: '<',
				onChange: '&'
			}
		});

	/** @ngInject */
	function NuitFields() {
		//*******************************************
		// CONTROLLER
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.$onInit = init;
		vm.isPrimitiveType = isPrimitiveType;
		vm.hasChanged = hasChanged

		function init(){
			if(vm.parent && !vm.parent[vm.field.name]){
				if(vm.field.type==='array'){
					vm.parent[vm.field.name] = [];
				}else if(!isPrimitiveType(vm.field.type)) {
					vm.parent[vm.field.name] = {};
				}
			}
		}

		function isPrimitiveType(type){
			switch(type){
				case 'text':
				case 'number':
				case 'password':
				case 'number':
				case 'select':
				case 'array':
					return true;
				default:
					return false;
			}
		}

		function hasChanged(){
			vm.onChange();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.component('nuitField', {
			templateUrl: 'app/ims/components/nuit-field/nuit-field.html',
			controller: NuitField,
			controllerAs: 'vm',
			bindings: {
				parent: '=',
				field: '<',
				onChange: '&'
			}
		});

	/** @ngInject */
	function NuitField($translate) {
		//*******************************************
		// CONTROLLER
		//*******************************************
		var vm = this;

		//*******************************************
		// VARIABLES
		//*******************************************

		vm.$onInit = init;
		vm.formatName = formatName;
		vm.addDataEntry = addDataEntry;
		vm.hasChanged = hasChanged;

		function init(){
			if(vm.parent!==null && vm.parent[vm.field.name]===undefined){
				var value = null;

				if(vm.field.default){
					value = vm.field.default;
				}else if(vm.field.type==='array'){
					value = [];
				}

				vm.parent[vm.field.name] = value;
			}
		}

		function formatName(value){
			return angular.isString(value)?value:$translate.instant(value.translation);
		}

		function addDataEntry(){
			if(!vm.parent[vm.field.name]){
				vm.parent[vm.field.name] = [];
			}

			var object = {}

			for(var i=0;i<vm.field.array_objects.fields.length;i++){
				var field = vm.field.array_objects.fields[i];
				object[field.name] = field.default?field.default:null;
			}

			vm.parent[vm.field.name].push(object);
		}

		function hasChanged(){
			vm.onChange();
		}
	}
}());

(function () {
	'use strict';
	angular
		.module('ims')
		.component('nuitFavorites', {
			templateUrl: 'app/ims/components/nuit-favorites/nuit-favorites.html',
			controller: FavoritesController,
			controllerAs: 'vm',
			transclude: true,
			bindings: {
				favorites: '<',
				selectedFavorite: '='
			}
		});

	/** @ngInject */
	function FavoritesController() {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************


		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = $onInit;
		vm.onFavChange = onFavChange;

		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************

		function $onInit() {
		}

		function onFavChange() {
			if (angular.isString(vm.selectedFavorite)) {
				vm.selectedFavorite = 0;
			}
		}

		//*******************************************
	}
}());

(function () {
	'use strict';
	angular
		.module('ims')
		.component('nuitExchangeConnection', {
			templateUrl: 'app/ims/components/nuit-exchange-connection/nuit-exchange-connection.html',
			controller: NuitExchangeConnectionController,
			controllerAs: 'vm',
			transclude: true,
			bindings: {
				config: '=',
				transferInfo: '<',
				header: '@'
			}
		});

	/** @ngInject */
	function NuitExchangeConnectionController(nuitDataService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = $onInit;
		vm.isDefined = isDefined;
		vm.changeType = changeType;
		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************

		function $onInit() {
			vm.connectionTypes = nuitDataService.getOneByKeys(vm.transferInfo.fields,{name:'conn'}).values;
			vm.connectionAttributes = [];
			vm.attributes = [];

			if(!vm.config){
				vm.type = null;
			}else{
				for(var i=0;i<vm.connectionTypes.length;i++){
					if(vm.config.type===vm.connectionTypes[i].name){
						vm.type = vm.connectionTypes[i];
						updateConnectionAttributes(vm.type);
						updateAttributes();
						break;
					}else{
						vm.type = null;
					}
				}
			}
		}

		function isDefined(value) {
			return typeof value !== 'undefined';
		}

		function changeType(type){
			if(!type){
				vm.config = null;
			}else{
				if(!vm.config) {
					vm.config = {conn:{}};
				}

				vm.config.type = type.name;
			}

			updateConnectionAttributes(type);
			updateAttributes();
		}

		function updateConnectionAttributes(type){
			vm.connectionAttributes = [];

			if(vm.config) {
				for (var i = 0; i < type.fields.length; i++) {
					var field = type.fields[i];
					vm.connectionAttributes.push(field);
				}
			}
		}

		function updateAttributes(){
			var defaultAttributes = ['conn','type']
			vm.attributes.splice(0,vm.attributes.length);

			if(vm.config) {
				for (var i = 0; i < vm.transferInfo.fields.length; i++) {
					var attribute = vm.transferInfo.fields[i];
					if (defaultAttributes.indexOf(attribute.name) === -1) {
						vm.attributes.push(attribute);
					}
				}
			}
		}
	}
}());

(function () {
	'use strict';
	angular
		.module('ims')
		.component('nuitConnection', {
			templateUrl: 'app/ims/components/nuit-connection/nuit-connection.html',
			controller: NuitConnectionController,
			controllerAs: 'vm',
			transclude: true,
			bindings: {
				config: '=',
				header: '@',
				hasPath: '<',
				hasContentType: '<',
				connectionTypes: '<',
				requireAll: '<'
			}
		});

	/** @ngInject */
	function NuitConnectionController() {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		vm.configCopy = null;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = $onInit;
		vm.$onChanges = $onChanges;
		vm.isDefined = isDefined;
		vm.changeType = changeType;
		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************

		function $onInit() {
			vm.customAttributes = [];

			if(!vm.config){
				vm.type = null;
			}else{
				for(var i=0;i<vm.connectionTypes.length;i++){
					if(vm.config.type===vm.connectionTypes[i].type){
						vm.type = vm.connectionTypes[i];
						updateCustomFields();
						vm.configCopy = angular.copy(vm.config);
						break;
					}else{
						vm.type = null;
					}
				}
			}
		}

		function $onChanges(changes) {
			if (changes.editorConfig) {

			}
		}

		function isDefined(value) {
			return typeof value !== 'undefined';
		}

		function changeType(type){
			if(!type){
				vm.config = null;
			}else{
				if(!vm.config) {
					vm.config = {};
				}

				vm.config.type = type.type;
				vm.config.conn = angular.copy(type.conn);
				updateCustomFields();
				vm.configCopy = angular.copy(vm.config);
			}
		}

		function updateCustomFields(){
			var defaultAttributes = ['host','port','path', 'user', 'pwd', 'disableEPSV', 'provider']
			vm.customAttributes.splice(0,vm.customAttributes.length);

			for(var key in vm.config.conn){
				if(defaultAttributes.indexOf(key)===-1){
					vm.customAttributes.push(key);
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.component('imsMultilang', {
			templateUrl: 'app/ims/components/ims-multilang/ims-multilang.component.html',
			controller: ImsMultilangController,
			controllerAs: 'vm',
			bindings: {
				ngModel: '=',
				title: '<'
			}
		});

	/** @ngInject */
	function ImsMultilangController($translate, nuitConfig) {
		//*******************************************
		// CONTROLLER
		//*******************************************
		var $ctrl = this;

		//*******************************************
		// VARIABLES
		//*******************************************
		$ctrl.config = nuitConfig.getCurrent();
		$ctrl.currentLanguage = $translate.use();
	}
}());
(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('nuitUnitInput', nuitUnitInput);

    // Still under construction but can already be used!
	/** @ngInject */
	function nuitUnitInput(nuitConfig) {
		return {
			restrict: 'A',
			require: 'ngModel',
            scope: {
                unitConfig: '=',
				limitMin: '&',
				limitMax: '&',
                invert: '<',
				customUpdateOn: '<'
            },
			link: function (scope, element, attr, model) {
                //*******************************************
                // VIEWMODEL
                //*******************************************
                var vm = scope;
                //*******************************************

                //*******************************************
                // VARIABLES
                //*******************************************
                vm.config = nuitConfig.current;
                vm.unit = 'length';
                //*******************************************

                //*******************************************
                // EVENTS
                //*******************************************
                scope.$on(nuitConfig.EVENTS.ConfigLoaded, onConfigLoaded);
                //*******************************************

                //*******************************************
                // INITIALIZATION
                //*******************************************
                init();
                //*******************************************

                ////////////////////////////////////////////////////////////////

                /**
                 * Initializes this directive.
                 */
                function init() {
                    // $options is sometimes not initialised
                    if(!model.$options) { model.$options = {}; }

                    // model has to update even on focus left
                    model.$options.updateOn = attr.customUpdateOn?attr.customUpdateOn:'blur change';

	                // update ngModel options in angular 1.6+
	                if(angular.isFunction(model.$overrideModelOptions)) {
						model.$overrideModelOptions({
							updateOn: attr.customUpdateOn?attr.customUpdateOn:'blur change'
						});
					}

                    model.$parsers.push(fromUI);
                    model.$formatters.push(toUI);
                    if(attr.nuitUnitInput) {
                        vm.unit = attr.nuitUnitInput;
                    }
                    attr.$set('step', getStep());

                    // cheap 'hack' to recognize enter keypress
                    element.on('keydown keypress', onKeyPress);
                }

                function getDecimals() {
                    return vm.config.units[vm.unit].decimals;
                }

                function getStep() {
                    return Math.pow(0.1,getDecimals());
                }

                function getFactor() {
                    return attr.invert === "true" ? 1.0 / vm.config.units[vm.unit].factor : vm.config.units[vm.unit].factor;
                }

				function fromUI(value) {
                    if(angular.isUndefined(value) || value === null) {
                        return 0;
                    }

					value = parseFloat(value);

                    var newValue = parseFloat(value.toFixed(getDecimals()));
					if(angular.isNumber(vm.limitMin()) && newValue * getFactor() < vm.limitMin()) { newValue = vm.limitMin() / getFactor(); }
					else if(angular.isNumber(vm.limitMax()) && newValue * getFactor() > vm.limitMax()) { newValue = vm.limitMax() / getFactor(); }

                    if (value !== newValue) {
                        model.$setViewValue(newValue);
                        model.$render();
                    }

                    if(vm.config.units.precision && vm.config.units.precision.high){
						return parseFloat(new Decimal(newValue).times(getFactor()));
					}else{
						return newValue * getFactor();
					}
				}

				function toUI(value) {
					if (angular.isUndefined(value)) {
						return value;
					} else if (angular.isString(value)) {
						value = parseFloat(value);
					}

					if(vm.config.units.precision && vm.config.units.precision.high){
						return parseFloat(new Decimal(value).dividedBy(getFactor()).toFixed(getDecimals()));
					}else{
						value = value / getFactor();
						return parseFloat(value.toFixed(getDecimals()));
					}
				}

                /**
                 * This event is fired whenever a key is pressed
                 * while the element with this directive is focused.
                 * @param {Object} e - event data
                 */
                function onKeyPress(e) {
                    // 13 = Enter Key
                    if (e.keyCode === 13) {
						model.$commitViewValue();
					}
                }

                function onConfigLoaded() {
                    model.$setViewValue(toUI(model.$modelValue));
                    model.$render();
                    attr.$set('step', getStep());
                }
			}
		};
	}
}());

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .directive('ngScrollEnd', directive);

	/** @ngInject */
	function directive() {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {

				var doc = element[0];
				element.bind("scroll", function () {
					if (doc.scrollTop + doc.offsetHeight >= doc.scrollHeight - 100) {
						scope.$apply(attrs.ngScrollEnd);
					}
				});
			}
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ngEnter', directive);

    /** @ngInject */
    function directive($parse) {
        return {
            restrict: 'A',
			compile: function($element, attr) {
				var fn = $parse(attr['ngEnter'], null, true);
				
				return ngEventHandler;
				
				////////////////////////////////////////////////////////////////
				
				function ngEventHandler(scope, element) {
					  element.bind('keydown keypress', function (event) {
						  if (event.which === 13) {
							  event.preventDefault();

							  var callback = function() {
								  fn(scope, {'$event': event});
							  };
							  scope.$apply(callback);
						  }
					  });
				  };
			  }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link: link
        };

        function link(scope, iElement) {
            var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
            {
                $animate.leave(iElement).then(function ()
                {
                    // De-register scope event
                    splashScreenRemoveEvent();

                    // Null-ify everything else
                    scope = iElement = null;
                });
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, nuitConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( nuitConfig.current.fuse.disableCustomScrollbars)
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( nuitConfig.current.fuse.disableCustomScrollbarsOnMobile && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider);

    /** @ngInject */
    function msNavigationServiceProvider() {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        // Vertical
        .directive('msNavigation', msNavigationDirective);

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('MsNavigationController', MsNavigationController);

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService) {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        // Vertical
        .directive('msNavigationNode', msNavigationNodeDirective);

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function (scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        // Vertical
        .controller('MsNavigationNodeController', MsNavigationNodeController);


    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        // Vertical
        .directive('msNavigationItem', msNavigationItemDirective);
    
    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function (scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective);

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function (scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        //Horizontal
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective);

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        //Horizontal
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController);

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;
        vm.isHidden = isHidden;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
        
        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        //Horizontal
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function (scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('fallbackSrc', function () {
            var fallbackSrc = {
                link: function postLink(scope, iElement, iAttrs) {
                    iElement.bind('error', function () {
                        angular.element(this).attr("src", iAttrs.fallbackSrc);
                    });
                }
            };
            return fallbackSrc;
        });
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('SpecialProcessingController', controller);

	/** @ngInject */
	function controller($mdDialog, $scope, Special, Selection, ReadOnly, Template, CurrentSelection, nuitDataService, $translate, $filter) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.special = Special ? angular.copy(Special) : {};
		vm.readOnly = ReadOnly;
		if (Special) {
			vm.remark = vm.special.remark;
			var tmpSpecial = nuitDataService.getOne(Selection, vm.special.id);
			vm.removable = tmpSpecial ? tmpSpecial.removable : true;
		} else {
			vm.removable = true;
		}

		vm.selection = [];
		vm.selectedSpecial = nuitDataService.getOne(vm.selection, vm.special.id);
		vm.template = 'app/core/dialogs/special-processing/' + (Template ? Template : 'default') + '.html';

		if (CurrentSelection && CurrentSelection.length > 0) {
			for (var i = 0; i < Selection.length; i++) {
				var entry = Selection[i];
				if (nuitDataService.getOne(CurrentSelection, entry.id) === null && entry.selectable || vm.special.id === entry.id) {
					vm.selection.push(entry);
					if (!vm.special.id && Template === 'default') {
						vm.special.id = entry.id;
					}
				}
			}
		} else {
			for (var i = 0; i < Selection.length; i++) {
				var entry = Selection[i];

				if (entry.selectable) {
					vm.selection.push(entry);
				}
			}

			if (Template === 'default') {
				vm.special.id = vm.selection[0].id;
			}
		}

		onChange(vm.special.id);

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.cancel = cancel;
		vm.onChange = onChange;

		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************

		function close() {
			var special = vm.selectedSpecial;
			special.remark = vm.remark;
			special.price = 0;
			$mdDialog.hide({
				id: special.id,
				name: special.name,
				remark: vm.remark
			});
		}

		function cancel() {
			$mdDialog.cancel();
		}

		function onChange(selectedID) {
			vm.selectedSpecial = angular.copy(nuitDataService.getOne(vm.selection, selectedID));

		}

	}
}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('SaveDialogController', SaveDialogController);

    /** @ngInject */
    function SaveDialogController(profileObject, nuitProfile, $mdDialog, $translate, nuitApi, nuitAuth, nuitConfig, nuitUtils, nuitProfiles, nuitEditor, ProfileFolders) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        vm.profile = profileObject;
		vm.config = nuitConfig.current;
		vm.selectedLanguage = $translate.use();
        vm.saveform = {};
        vm.folders = [];
        vm.hasPrivateFolder = false;
		vm.privateFolderName = null;
		vm.selectedFolderLanguage = $translate.use();
        vm.expandedFolders = [];
        vm.selectedFolder = null;

        vm.treeOptions = {
            nodeChildren: 'children',
            dirSelectable: true,
            injectClasses: {
                ul: 'a1',
                li: 'a2',
                liSelected: 'a7',
                iExpanded: 'a3',
                iCollapsed: 'a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'a8'
            },
            allowDeselect: false
        };
        //*******************************************

        //*******************************************
        // EXPOSURE (Methods)
        //*******************************************
        vm.init = init;
        vm.submit = submit;
		vm.magnifyImage = nuitUtils.magnifyImage;
        vm.isSelected = isSelected;
        vm.toggleSelectFolder = toggleSelectFolder;
        vm.closeDialog = closeDialog;
		vm.updateReplace = updateReplace;
		vm.addFolder = addFolder;
        //*******************************************

        //*******************************************
        // INITIALIZATION
        //*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        /**
         * Initializes the controller.
         */
        function init() {
            reloadFolders();

			if(angular.isArray(vm.config.evo.editor.customData) && vm.config.evo.editor.customData.length > 0) {
				vm.customData = vm.config.evo.editor.customData;
				for(var i in vm.customData) {
					var cData = vm.customData[i];
					if(angular.isString(cData.url)) {
						nuitApi.resolve(cData.url)
						.get()
						.then(function(response) {
							cData.options = response.data;
						});
					}
				}
			} else {
				vm.customData = undefined;
			}

			if(vm.profile.image === undefined) {
				vm.isImageLoading = true;
				nuitProfiles.getImage(vm.profile).then(function(image) {
					vm.profile.image = image.path;
					vm.isImageLoading = false;
				});
			}
        }

        function reloadFolders(){
			// load groups and subgroups
			nuitApi('profiles.folders')
				.get({ origin: 'production', userId: nuitAuth.getUserId() })
				.then(function(response) {
					vm.folders = unpackage(response.data.user,true,false).concat(unpackage(response.data.environment,true,true));
					vm.hasPrivateFolder = vm.folders.filter(
						function(prev,current){
							return !prev.public;
						}).length>0;

					function unpackage(obj, root, pub) {
						var result = [];
						if(obj !== null) {
							angular.forEach(obj, function(value, key) {
								if(value === null) { return; }
								if(!vm.config.evo.account.folders.allowPublicFileEditing && pub){ return; }
								value.public = pub;
								value.root = root;
								value.children = unpackage(value.children, false, pub);
								result.push(value);
							});
						}
						return result;
					}
				});
		}

		function addFolder(){
			ProfileFolders.addFolder(vm.privateFolderName, undefined, false)
				.then(function(){
					vm.privateFolderName = null;
					reloadFolders();
				})
		}

		function updateReplace(customData) {
			if (angular.isArray(customData.replace) && customData.replace.length > 0) {
				for (var index in customData.replace) {
					var rData = customData.replace[index];
					if (propertyMatchesCondition(rData.condition, vm.saveform[rData.property])) {
						vm.saveform[rData.property] = customData.value[customData.nameProperty];
						nuitEditor.setName(vm.saveform[rData.property]);
					}
				}
			}
		}

		function propertyMatchesCondition(condition, property) {
			switch (condition) {
				default:
				case 'always':
					return true;
				case 'empty':
					return !property;
				case 'defined':
					return angular.isDefined(property);
				case 'never':
					return false;
			}
			return false;
		}

        function submit() {
            nuitEditor.setName(vm.saveform.name);
            var data = nuitEditor.exportProfile();
            data.materialId = nuitProfile.getMaterial() ? nuitProfile.getMaterial().id : null;

			if(data.id !== undefined) {
				delete data.id;
			}

			if(vm.customData !== undefined && vm.customData.length > 0) {
				if(!angular.isObject(data.customData)) {
					data.customData = {};
				}

				for(var i in vm.customData) {
					var cData = vm.customData[i];
					if(angular.isDefined(cData.value)) {
						data.customData[cData.property] = cData.value;
					}
				}
			}

			// TODO: add offline support

            nuitApi('profile.save')
                .post(data, {folder: vm.selectedFolder.id})
                .then(function(response) {
                    $mdDialog.hide(vm.saveform);
                    nuitUtils.showSuccessToast();})
                .catch(function(response) {
                    nuitUtils.showErrorToast();
                });
        }

        function toggleSelectFolder(node) {
			if (vm.selectedFolder !== node) {
				vm.selectedFolder = node;
			} else {
				vm.selectedFolder = null;
			}
		}

        function isSelected(node) {
            return vm.selectedFolder === node;
        }
        /**
         * Closes the dialog.
         */
        function closeDialog() {
            $mdDialog.cancel();
        }
    }

})();

(function () {
    'use strict';

    angular
            .module('app.products')
            .controller('ProductTableDialogController', controller);

    /** @ngInject */
    function controller(Product, $mdDialog) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
		vm.product = Product;
        //*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        vm.closeDialog = closeDialog;
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // METHODS
        //*******************************************
        function closeDialog() {
            $mdDialog.hide();
        }
    }

})();

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .controller('ProductSelectionDialogController', controller);

	/** @ngInject */
	function controller($mdDialog, ShowPrices) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.addToOrder = addToOrder;
		vm.showPrices = ShowPrices;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes the controller.
		 */
		function init() {
		}
		/**
		 * Submits the product and adds it to the cart.
		 */
		function addToOrder(product) {
			$mdDialog.hide(product);
		}
		/**
		 * Closes the product dialog.
		 */
		function close() {
			$mdDialog.cancel();
		}
	}

})();

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .controller('ProductDialogController', controller);

	/** @ngInject */
	function controller($timeout, Product, Filters, IsBeforeCart, ShowPrices, $mdDialog, $stateParams, nuitProducts, nuitApi, nuitAuth, nuitColors, nuitMaterials, nuitUtils, nuitConfig, nuitDataService, DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.isBeforeCart = IsBeforeCart;
		vm.notes = false;
		vm.product = Product;
		vm.showPricesConfig = ShowPrices;
		vm.materials = nuitMaterials.materials;
		vm.positionAttributes = [];
		vm.colors = nuitColors.all;
		vm.config = nuitConfig.current;
		vm.auth = nuitAuth;
		vm.result = {
			type: vm.product.type,
			id: vm.product.id,
			_displayPrice: vm.product.price,
			quantity: 1,
			remark: vm.product.remark,
			attributes: vm.product.attributes,
			positions: vm.product.positions,
			customData: angular.copy(vm.product.customData)
		};

		if(vm.product.externalData){
			vm.result.externalData = angular.copy(vm.product.externalData);
		}

		if(vm.product.basePrice!==undefined){
			vm.result.basePrice = angular.copy(vm.product.basePrice);
			vm.result.price = angular.copy(vm.product.price);
		}

		vm.notes = vm.product.remark !== undefined;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		vm.submit = submit;
		vm.addNotes = addNotes;
		vm.getProductPrice = getProductPrice;
		vm.removeNotes = removeNotes;
		vm.isMaterialRequired = isMaterialRequired;
		vm.isColorRequired = isColorRequired;
		vm.filterColorsForAttribute = filterColorsForAttribute;
		vm.getPositionAttributes = getPositionAttributes;
		vm.getMaterialById = nuitMaterials.getMaterialById;
		vm.filterMaterialsForList = filterMaterialsForList;
		vm.showDetails = showDetails;
		vm.magnifyImage = nuitUtils.magnifyImage;
		vm.showPrices = showPrices;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes the controller.
		 */
		function init() {
			// Set given product as baseProduct to ensure that item can be added to cart when offline
			vm.baseProduct = Product;

			nuitProducts
			  .loadProduct(vm.product.id)
			  .then(function (product) {
				  vm.baseProduct = product;

				  if (!angular.isObject(vm.baseProduct.data)) {
					  vm.baseProduct.data = {};
				  }
				  for (var i in vm.baseProduct.attributes) {
					  if (vm.baseProduct.attributes[i].value !== undefined) {
						  vm.result.attributes[i].constant = true;
					  } else {
						  delete vm.result.attributes[i].constant;
					  }
					  if (vm.baseProduct.attributes[i].restrictions && vm.baseProduct.attributes[i].restrictions.usesPositions) {
						  vm.positionAttributes.push(vm.result.attributes[i]);
					  }
				  }
				  if (vm.baseProduct.type === 'profile') {
					  if (!angular.isArray(vm.baseProduct.data.materials)) {
						  vm.baseProduct.data.materials = [];
					  }
					  if (!angular.isArray(vm.baseProduct.data.groups)) {
						  vm.baseProduct.data.groups = [];
					  }

					  vm.result.data = {};
					  vm.result.data.profile = angular.merge({}, angular.copy(vm.product.data.profile));

					  // Extract default length
					  if (!angular.isNumber(vm.result.data.profile.length)) {
						  if (vm.baseProduct.data.length === undefined) {
							  vm.result.data.profile.length = vm.config.defaults.profile.length;
							  vm.baseProduct.data.length = {};
						  } else if (vm.baseProduct.data.length.value !== undefined) {
							  vm.result.data.profile.length = vm.baseProduct.data.length.value;
						  } else {
							  vm.result.data.profile.length = vm.baseProduct.data.length.min;
						  }
					  }

					  // Cap limits
					  if (!angular.isNumber(vm.baseProduct.data.length.min) || vm.baseProduct.data.length.min < 1) {
						  vm.baseProduct.data.length.min = 1;
					  }
					  if (!angular.isNumber(vm.baseProduct.data.length.max) || vm.baseProduct.data.length.max > 1000000) {
						  vm.baseProduct.data.length.max = 1000000;
					  }

					  // Cap length
					  if (angular.isNumber(vm.result.data.profile.length)) {
						  var min = vm.baseProduct.data.length.min;
						  var max = vm.baseProduct.data.length.max;
						  vm.result.data.profile.length = vm.result.data.profile.length > max ? max : vm.result.data.profile.length < min ? min : vm.result.data.profile.length;
					  }

					  // Preselect if only one material is selectable
					  if (vm.baseProduct.data.materials.length === 1) {
						  vm.result.data.profile.materialId = vm.baseProduct.data.materials[0];
						  fetchMaterial();
					  }

					  for (var index in Filters) {
						  var filter = Filters[index];
						  if (filter.type === 'generic_colors' && filter.value !== undefined) {
							  for (var matIndex in vm.baseProduct.data.materials) {
								  var material = nuitMaterials.getMaterialById(vm.baseProduct.data.materials[matIndex]);
								  if (material.colorFront === filter.value.id) {
									  vm.result.data.profile.materialId = material.id;
									  break;
								  }
							  }
						  }
					  }
				  } else {
					  for (var index in Filters) {
						  var filter = Filters[index];
						  if (filter.type === 'generic_colors' && filter.value !== undefined) {
							  for (var attrIndex in vm.result.attributes) {
								  var attribute = vm.result.attributes[attrIndex];
								  if (attribute.type === 'color' && !attribute.constant) {
									  var colors = attribute.restrictions.colors || [];
									  var blacklist = attribute.restrictions.blacklist === true;
									  if (attribute.restrictions.subset !== undefined) {
										  blacklist = false;
										  colors = attribute.restrictions.subset;
									  }
									  if ((!blacklist && colors.indexOf(filter.value.id) >= 0) || (blacklist && colors.indexOf(filter.value.id) < 0)) {
										  attribute.value = filter.value.id;
										  break;
									  }
								  }

							  }
						  }
					  }
				  }

				  if (isMaterialRequired()) {
					  nuitMaterials.reload();
				  }
				  if (isColorRequired()) {
					  nuitColors.reload();
				  }
			  });
		}

		function fetchMaterial(){
			$timeout(function(){
				nuitMaterials.getMaterialByIdFromServer(vm.result.data.profile.materialId)
					.then(function(material){vm.result.data.profile.material = material});
			});
		}

		function getProductPrice() {
			fetchMaterial();

			return nuitApi('products.price')
			  .post(angular.merge({}, vm.baseProduct, vm.result))
			  .then(function (response) {
				  vm.result._displayPrice = response.data.price;

				  if(vm.result.basePrice!==undefined) {
					  vm.result.basePrice = response.data.basePrice;
					  vm.result.price = response.data.price;
				  }

				  for(var i=0;i<response.data.positions.length;i++){
						if(response.data.positions[i].remark===""){
							delete response.data.positions[i].remark;

							if(vm.config.evo.cart.productPositionCheck.enabled){
								DotNotationService.set(
									response.data.positions[i],
									vm.config.evo.cart.productPositionCheck.key,
									DotNotationService.get(vm.result.positions[i],vm.config.evo.cart.productPositionCheck.key,false)
								);
							}
						}
				  }

				  if(vm.result.positions){
				  	nuitDataService.replaceAll(vm.result.positions,response.data.positions);
				  }
			  });
		}

		function showDetails($event) {
			$mdDialog.show({
				controller: 'ProductTableDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/core/dialogs/product-table/product-table-dialog.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				multiple: true,
				clickOutsideToClose: true,
				locals: {
					Product: vm.baseProduct
				}
			});
		}

		/**
		 * Returns true if a material is required in any attribute.
		 * @returns {Boolean}
		 */
		function isMaterialRequired() {
			if (vm.baseProduct.type === 'profile' &&
			  (vm.baseProduct.data.materials.length > 1 || (vm.baseProduct.data.groups !== null && vm.baseProduct.data.groups.length > 0))) {
				return true;
			}

			for (var i in vm.baseProduct.attributes) {
				if (vm.baseProduct.attributes[i].type === 'material') {
					return true;
				}
			}
			return false;
		}
		/**
		 * Returns a collection of all attributes
		 * which require or use the positioning feature.
		 * Each position can have a seperate value.
		 * @return {Array}
		 */
		function getPositionAttributes() {
			return vm.positionAttributes;
		}
		/**
		 * Returns true if a material is required in any attribute.
		 * @returns {Boolean}
		 */
		function isColorRequired() {
			for (var i in vm.baseProduct.attributes) {
				if (vm.baseProduct.attributes[i].type === 'color') {
					return true;
				}
			}
			return false;
		}

		function addNotes() {
			vm.notes = true;
		}

		function removeNotes() {
			vm.notes = false;
			delete vm.result.remark;
		}

		/**
		 * Returns a function which checks if the given color
		 * matches the attribute filter restricitions.
		 * @param {Object} attribute - a products attribute
		 * @returns {Function}
		 */
		function filterColorsForAttribute(attribute) {
			var blacklist = !!attribute.restrictions.blacklist;
			if (!angular.isArray(attribute.restrictions.colors)) {
				attribute.restrictions.colors = [];
			}
			return function (color) {
				if (angular.isArray(attribute.restrictions.subset)) {
					return attribute.restrictions.subset.indexOf(color.id) >= 0;
				} else {
					var matches = attribute.restrictions.colors.indexOf(color.id) >= 0;
					return matches !== blacklist;
				}
			};
		}

		function filterMaterialsForList(list, grouplist) {
			return function (material) {
				return list.indexOf(material.id) >= 0 || isMaterialInAnyGroup(material, grouplist);
			};
		}

		function isMaterialInAnyGroup(material, groups) {
			if (groups === null || groups === undefined) {
				return true;
			}

			return groups.indexOf(material.rawMaterialId) >= 0;
		}

		function showPrices(){
			return vm.showPricesConfig;
		}

		/**
		 * Submits the product and adds it to the cart.
		 */
		function submit() {
			var data = {
				type: 'product',
				item: vm.result
			};

			if (data.item.type === 'profile'
			  && !angular.isNumber(data.item.data.profile.materialId)
			  && angular.isArray(data.item.data.materials)) {
				data.item.data.profile.materialId = data.item.data.materials[0];
			}

			$mdDialog.hide({data: data, product: angular.merge({}, vm.baseProduct, vm.result)});
		}
		/**
		 * Closes the product dialog.
		 */
		function close() {
			$stateParams.product = null;
			$mdDialog.cancel();
		}
	}

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('OrderAddressDialogController', OrderAddressDialogController);

	/** @ngInject */
	function OrderAddressDialogController($mdSidenav, $mdDialog, $timeout, Address, Addresses, AddressService, AddressApi, msUtils, $translate, Countries, AddressWrapperService, nuitDataService, nuitApi, nuitUtils, nuitConfig) {
		var vm = this;

		// Data
		vm.title = $translate.instant('ADDRESS.EDIT');
		vm.address = angular.copy(Address);

		var hasConfig = nuitConfig.current.localization.address!==undefined;

		vm.maxZipLength = (hasConfig && nuitConfig.current.localization.address.zipCode.max) || 5;

		vm.minZipLength = (hasConfig && nuitConfig.current.localization.address.zipCode.min) || 4;

		var numbersOnly = true;

		if(hasConfig && nuitConfig.current.localization.address.zipCode.numbersOnly!==undefined){
			numbersOnly = nuitConfig.current.localization.address.zipCode.numbersOnly;
		}

		vm.zipPattern = numbersOnly?/^\d+$/:undefined;

		vm.defaultCountry =
			(
				nuitConfig.current.environment &&
				nuitConfig.current.environment.companyData &&
				nuitConfig.current.environment.companyData.countryCode
			)?
				nuitConfig.current.environment.companyData.countryCode:'AT';

		if(vm.address.country===undefined){
			vm.address.country = vm.defaultCountry;
		}

		vm.addresses = Addresses;
		vm.newAddressMode = false;
		vm.inProgress = false;

		// Methods
		vm.addNewAddress = addNewAddress;
		vm.closeDialog = closeDialog;
		vm.toggleInArray = msUtils.toggleInArray;
		vm.exists = msUtils.exists;
		vm.setNewAddress = setNewAddress;
		vm.equalsAddress = equalsAddress;
		vm.isNewAddress = isNewAddress;
		vm.saveAddress = saveAddress;
		vm.deleteAddress = deleteAddress;
		vm.toggleSideNav = toggleSideNav;
		vm.newAddress = newAddress;
		vm.cancelAddress = cancelAddress;
		vm.closeSideNav = closeSideNav();
		vm.getCompanyAddressFormat = AddressService.getCompanyAddressFormat;
		vm.getCompanyAddressFormatByCountry = AddressService.getCompanyAddressFormatByCountry;

		vm.countries = Countries;

		////////////////////////////////////////////////////////////////////////

		/**
		 * Add new address
		 */
		function addNewAddress() {
			$mdDialog.hide(vm.address);
		}

		/**
		 * Close dialog
		 */
		function closeDialog() {
			$mdDialog.cancel();
		}

		function setNewAddress(address) {
			nuitDataService.updateOneEntity(vm.address, AddressWrapperService.companyToOrder(address));
			vm.addressForm.$setDirty();
			closeSideNav();
		}

		function equalsAddress(address) {
			var orderAddress = AddressWrapperService.companyToOrder(address)

			for (var key in orderAddress) {
				if (orderAddress[key] !== vm.address[key]) {
					return false;
				}
			}

			return true;
		}

		function isNewAddress() {
			if(angular.isArray(vm.addresses)) {
				for (var i = 0; i < vm.addresses.length; i++) {
					if (equalsAddress(vm.addresses[i])) {
						return false;
					}
				}

				return true;
			}else{
				return false;
			}
		}

		function saveAddress(){
			$mdSidenav('left').open();
			vm.inProgress = true;

			$timeout(
				function(){
					nuitApi('companies.'+AddressApi.api,AddressApi.companyId).post(AddressWrapperService.orderToCompany(vm.address))
						.then(function(response){
							vm.addresses.push(response.data);
							vm.newAddressMode = false;
							vm.inProgress = false;
							$timeout(function(){
								$mdSidenav('left').close();
							},300);
						});
				},
				500
			);

			vm.addressForm.$setDirty();
		}

		function cancelAddress(){
			vm.address = vm.oldAddress;
			vm.newAddressMode = false;
		}

		function deleteAddress(addressId){
			nuitUtils.showDeleteConfirmation()
				.then(function(){
					return nuitApi(AddressApi.api + '.one',addressId)
						.delete()
						.then(function(){
							nuitDataService.removeOne(vm.addresses,addressId);
						});
				});
		}

		function toggleSideNav(){
			$mdSidenav('left').toggle();
		}

		function newAddress(){
			vm.oldAddress = angular.copy(vm.address);
			vm.address = {};
			vm.address.country = vm.defaultCountry;
			vm.newAddressMode = true;
		}

		function closeSideNav(){
			$mdSidenav('left').close();
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('OpenDialogController', OpenDialogController);

    /** @ngInject */
    function OpenDialogController($filter, nuitProfile, $mdDialog, $translate, nuitApi, nuitAuth, nuitConfig, nuitUtils, nuitProfiles, nuitEditor, ProfileFolders) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        vm.profiles = [];
		vm.term = '';
		vm.filteredProfiles = [];
		vm.currentPage = 0;
		vm.currentPageEntities = [];
		vm.config = nuitConfig.current;
		vm.selectedLanguage = $translate.use();
        vm.saveform = {};
		vm.privateFolders = ProfileFolders.privateFolders;
		vm.publicFolders = ProfileFolders.publicFolders;
		vm.privateFolderName = null;
		vm.selectedFolderLanguage = $translate.use();
        vm.expandedFolders = [];
        vm.selectedFolder = null;

        vm.treeOptions = {
            nodeChildren: 'children',
            dirSelectable: true,
            injectClasses: {
                ul: 'a1',
                li: 'a2',
                liSelected: 'a7',
                iExpanded: 'a3',
                iCollapsed: 'a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'a8'
            },
            allowDeselect: false
        };
        //*******************************************

        //*******************************************
        // EXPOSURE (Methods)
        //*******************************************
        vm.init = init;
        vm.submit = submit;
		vm.magnifyImage = nuitUtils.magnifyImage;
        vm.isSelected = isSelected;
        vm.showSelected = showSelected;
        vm.closeDialog = closeDialog;
		vm.openProfile = openProfile;
		vm.filterProfiles = filterProfiles;
        //*******************************************

        //*******************************************
        // INITIALIZATION
        //*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        /**
         * Initializes the controller.
         */
        function init() {
            reloadFolders();

			if(angular.isArray(vm.config.evo.editor.customData) && vm.config.evo.editor.customData.length > 0) {
				vm.customData = vm.config.evo.editor.customData;
				for(var i in vm.customData) {
					var cData = vm.customData[i];
					if(angular.isString(cData.url)) {
						nuitApi.resolve(cData.url)
						.get()
						.then(function(response) {
							cData.options = response.data;
						});
					}
				}
			} else {
				vm.customData = undefined;
			}
        }

        function reloadFolders(){
			ProfileFolders.reload();
		}

		function addFolder(){
			ProfileFolders.addFolder(vm.privateFolderName, undefined, false)
				.then(function(){
					vm.privateFolderName = null;
					reloadFolders();
				})
		}

		function updateReplace(customData) {
			if (angular.isArray(customData.replace) && customData.replace.length > 0) {
				for (var index in customData.replace) {
					var rData = customData.replace[index];
					if (propertyMatchesCondition(rData.condition, vm.saveform[rData.property])) {
						vm.saveform[rData.property] = customData.value[customData.nameProperty];
						nuitEditor.setName(vm.saveform[rData.property]);
					}
				}
			}
		}

		function propertyMatchesCondition(condition, property) {
			switch (condition) {
				default:
				case 'always':
					return true;
				case 'empty':
					return !property;
				case 'defined':
					return angular.isDefined(property);
				case 'never':
					return false;
			}
			return false;
		}

        function submit() {
            nuitEditor.setName(vm.saveform.name);
            var data = nuitEditor.exportProfile();
            data.materialId = nuitProfile.getMaterial() ? nuitProfile.getMaterial().id : null;

			if(data.id !== undefined) {
				delete data.id;
			}

			if(vm.customData !== undefined && vm.customData.length > 0) {
				if(!angular.isObject(data.customData)) {
					data.customData = {};
				}

				for(var i in vm.customData) {
					var cData = vm.customData[i];
					if(angular.isDefined(cData.value)) {
						data.customData[cData.property] = cData.value;
					}
				}
			}

			// TODO: add offline support

            nuitApi('profile.save')
                .post(data, {folder: vm.selectedFolder.id})
                .then(function(response) {
                    $mdDialog.hide(vm.saveform);
                    nuitUtils.showSuccessToast();})
                .catch(function(response) {
                    nuitUtils.showErrorToast();
                });
        }

        function showSelected(node) {
			vm.selectedFolder = node;
			reloadFolderProfiles(node);
		}

		function reloadFolderProfiles(folder) {
			return nuitApi('profiles.list', folder.id)
				.get()
				.then(function (response) {
					vm.profiles = !angular.isArray(response.data) ? [] : response.data;
					filterProfiles();
				});
		}

        function isSelected(node) {
            return vm.selectedFolder === node;
        }
        /**
         * Closes the dialog.
         */
        function closeDialog() {
            $mdDialog.cancel();
        }

		function openProfile(profile){
			if(profile.name && !angular.isString(profile.name)){
				profile.name = $filter('nuitTranslate')(profile.name, '');
			}
			return $mdDialog.hide(profile);
		}

		function filterProfiles() {
			console.error('filter filter',vm.term);
			vm.filteredProfiles = [];
			for (var index in vm.profiles) {
				if (matchesFilter(vm.profiles[index].data)) {
					vm.filteredProfiles.push(vm.profiles[index]);
				}
			}
		}

		function matchesFilter(profile) {
			return profile !== undefined &&
				profile !== null &&
				(vm.term === undefined ||
					vm.term === null ||
					vm.term === '' ||
					$filter('nuitTranslate')(profile.name, '???').toLowerCase().indexOf(vm.term.toLowerCase()) >= 0) &&
				!profile.deleted;
		}
    }

})();

/* global angular */
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('ProfileMoveController', ProfileMoveController);

    /** @ngInject */
    function ProfileMoveController($mdDialog, PublicFolders, PrivateFolders) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
        var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.groups = [];
        vm.selectedGroup = null;
        vm.expandedGroups = [];
        vm.folder = null;
        vm.form = {};
        vm.treeOptions = {
            templateUrl: 'core/components/nuit-profile-selection/main-tree.html',
            nodeChildren: 'children',
            dirSelectable: true,
            injectClasses: {
                ul: "a1",
                li: "a2",
                liSelected: "a7",
                iExpanded: "a3",
                iCollapsed: "a4",
                iLeaf: "a5",
                label: "a6",
                labelSelected: "a8"
            },
            allowDeselect: false
        };
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.submit = submit;
        vm.close = close;
        vm.showSelected = showSelected;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
		//*******************************************

        ////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        function init() {
			vm.publicFolders = PublicFolders || [];
			vm.privateFolders = PrivateFolders || [];
			vm.selectedGroup = vm.privateFolders[0] || vm.publicFolders[0];
		}

        function showSelected(node) {
            vm.folder = node;
        }

        function submit() {
            $mdDialog.hide(vm.folder);
        }

        function close() {
            $mdDialog.cancel();
        }
    }

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('MaterialDialogController', MaterialDialogController);

	/** @ngInject */
	function MaterialDialogController(Multiple, SelectedMaterialIds, UnavailableGroups, MaterialWhitelist, GroupWhitelist, $translate, $mdDialog, $filter, nuitMaterials, nuitConfig, FavoriteService, ComparatorService, nuitDataService, nuitFilterService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.term = '';
		vm.group = null;
		vm.material = null;
		vm.materials = [];
		vm.multiple = Multiple !== undefined ? Multiple : false;
		vm.selectedMaterials = [];
		vm.selectedMaterialIds = angular.copy(SelectedMaterialIds);
		vm.unavailableGroups = angular.copy(UnavailableGroups);
		vm.materialWhitelist = angular.copy(MaterialWhitelist);
		vm.groupWhitelist = angular.copy(GroupWhitelist);
		vm.limit = 10;
		vm.groups = [];
		vm.thicknesses = [];
		vm.colors = [];
		vm.filteredMaterials = [];
		vm.extendedMaterials = [];
		vm.filters = (vm.config.evo && vm.config.evo.material && vm.config.evo.material.filters)?angular.copy(nuitConfig.current.evo.material.filters):[];
		vm.comparatorData = [['=', '<='], ['<=', '>='], ['>=', '=']];

		vm.prefilteredEntities = [];
		vm.customFilters = (vm.config.evo && vm.config.evo.material && vm.config.evo.material.customFilters)?angular.copy(vm.config.evo.material.customFilters):[];
		vm.filterValues = {};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.selectGroup = selectGroup;
		vm.selectMaterial = selectMaterial;
		vm.isSelected = isSelected;
		vm.submit = submit;
		vm.toggleOpenState = toggleOpenState;
		vm.isExtended = isExtended;
		vm.groupChange = load;
		vm.filterMaterial = filterMaterial;
		vm.closeDialog = closeDialog;
		vm.filterChanged = filterChanged;
		vm.isAnyFilterSet = isAnyFilterSet;
		vm.resetFilters = resetFilters;
		vm.toggleMaterial = toggleMaterial;
		vm.countMaterialsWithThickness = countMaterialsWithThickness;
		vm.countMaterialsInGroup = countMaterialsInGroup;
		vm.countMaterialsWithColor = countMaterialsWithColor;
		vm.selectAll = selectAll;
		vm.clearSelection = clearSelection;
		vm.clearAll = clearAll;
		vm.quickMaterial = quickMaterial;
		vm.updateComparator = updateComparator;
		vm.filterControls = filterControls;
		vm.filterMaterials = filterMaterials;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		/**
		 * Initializes this controller.
		 */
		function init() {
			load();
			resetComparators();
		}

		function resetComparators() {
			for (var i = 0; i < vm.filters.length; i++) {
				vm.filters[i].comparator = '=';
			}
			vm.thicknessComparator = "=";
		}

		/**
		 * Toggle material open state
		 *
		 * @param material
		 * @param event
		 */
		function toggleOpenState(material, event) {
			//material.open = !!!material.open;

			if (event) {
				event.stopPropagation();
			}

			if (vm.extendedMaterials.indexOf(material) > -1) {
				vm.extendedMaterials.splice(vm.extendedMaterials.indexOf(material), 1);
			} else {
				vm.extendedMaterials.push(material);
			}
		}

		function filterChanged(filter) {
			if (filter !== undefined && filter.value === null) {
				delete filter.value;
			}

			filterMaterials();
		}

		function filterMaterials() {
			vm.prefilteredEntities = [];
			vm.filteredMaterials = [];
			vm.thicknesses = [];
			vm.colors = [];
			vm.limit = 50;
			if (vm.selectedThickness !== undefined) {
				vm.thicknesses.push(vm.selectedThickness);
			}
			for (var i in vm.materials) {
				if (filterMaterial(vm.materials[i])) {
					var material = vm.materials[i];

					vm.prefilteredEntities.push(material);

					if (nuitFilterService.matches(vm.customFilters, vm.filterValues, material))
					{
						vm.filteredMaterials.push(material);
					}
				}
				if (vm.thicknesses.indexOf(vm.materials[i].thickness) < 0) {
					vm.thicknesses.push(vm.materials[i].thickness);
				}
				if (vm.materials[i].colors.front !== null && vm.materials[i].colors.front !== undefined && arrayObjectIndexOf(vm.colors, vm.materials[i].colors.front.id, 'id') < 0) {
					vm.colors.push(vm.materials[i].colors.front);
				}
			}
			vm.thicknesses.sort(sortNumber);
			vm.colors.sort(sortByCode);
			vm.filteredMaterials = FavoriteService.sort($filter('orderByNuitTranslated')(vm.filteredMaterials, 'name'));
		}

		function arrayObjectIndexOf(myArray, searchTerm, property) {
			for (var i = 0, len = myArray.length; i < len; i++) {
				if (myArray[i][property] === searchTerm) return i;
			}
			return -1;
		}

		function resetFilters() {
			if(vm.customFilterControls) {
				vm.customFilterControls.reset();
			}

			vm.selectedColor = undefined;
			vm.selectedThickness = undefined;
			vm.isPowderCoated = undefined;
			vm.hasProtectionFilm = undefined;
			vm.group = null;
			for (var index in vm.filters) {
				delete vm.filters[index].value;
			}
			resetComparators();
			filterMaterials();
		}

		function selectAll() {
			for (var index in vm.filteredMaterials) {
				var material = vm.filteredMaterials[index];
				if (!isSelected(material)) {
					vm.selectedMaterials.splice(0, 0, material);
				}
			}
		}

		function clearSelection() {
			for (var index in vm.filteredMaterials) {
				var material = vm.filteredMaterials[index];
				if (isSelected(material)) {
					nuitDataService.removeOne(vm.selectedMaterials, material.id);
				}
			}
		}

		function clearAll() {
			nuitDataService.replaceAll(vm.selectedMaterials, []);
		}

		function sortByCode(a, b) {
			if (a.code < b.code)
				return -1;
			if (a.code > b.code)
				return 1;
			return 0;
		}

		function sortNumber(a, b) {
			return a - b;
		}

		function selectGroup(group) {
			vm.group = group;
			filterChanged();
		}

		function countMaterialsInGroup(group) {
			var result = 0;
			for (var i in vm.materials) {
				if ((group === null || isMaterialInGroup(vm.materials[i], group)) && filterMaterial(vm.materials[i], true)) {
					result++;
				}
			}
			return result;
		}

		function countMaterialsWithThickness(thickness) {
			var result = 0;
			for (var i in vm.materials) {
				if (matchesThickness(vm.materials[i].thickness, thickness) && filterMaterial(vm.materials[i], false, true)) {
					result++;
				}
			}
			return result;
		}

		function countMaterialsWithColor(colorId) {
			var result = 0;
			for (var i in vm.materials) {
				if (vm.materials[i].colors.front !== null && vm.materials[i].colors.front !== undefined && vm.materials[i].colors.front.id === colorId && filterMaterial(vm.materials[i], false, false, true)) {
					result++;
				}
			}
			return result;
		}

		function load() {
			nuitMaterials.reloadGroups()
				.then(function (response) {
					for (var i = 0; i < nuitMaterials.groups.length; i++) {
						if (vm.unavailableGroups.indexOf(nuitMaterials.groups[i].id) === -1) {
							vm.groups.push(nuitMaterials.groups[i]);
						}
					}
				});
			vm.isLoadingMaterials = true;
			nuitMaterials.reload()
				.then(function (response) {
					vm.materials.splice(0, vm.materials.length);

					for (var i = 0; i < nuitMaterials.materials.length; i++) {
						if (nuitMaterials.isMaterialInGroups(nuitMaterials.materials[i], vm.unavailableGroups)) {
							continue;
						} else if (angular.isArray(vm.materialWhitelist) && vm.materialWhitelist.indexOf(nuitMaterials.materials[i].id) < 0) {
							continue;
						} else if (angular.isArray(vm.groupWhitelist) && vm.groupWhitelist.indexOf(nuitMaterials.materials[i].rawMaterialId) < 0) {
							continue;
						} else {
							vm.materials.push(nuitMaterials.materials[i]);
						}
					}

					vm.materialsError = false;

					while (vm.selectedMaterialIds.length > 0) {
						var material = nuitMaterials.getMaterialById(vm.selectedMaterialIds.shift());
						if (material !== null) {
							selectMaterial(material);
						}
					}

					filterChanged();
				})
				.catch(function () {
					vm.materialsError = true;
				})
				.finally(function () {
					vm.isLoadingMaterials = false;
					if (vm.materials === null) {
						vm.materials = [];
					}
				});
		}


		function quickMaterial(material, $event) {
			$event.stopPropagation();
			selectMaterial(material);
			if (!vm.multiple) {
				submit();
			}
		}

		function selectMaterial(material) {
			if (vm.multiple) {
				toggleMaterial(material);
			} else {
				vm.material = material;
			}
		}

		function toggleMaterial(material) {
			var index = vm.selectedMaterials.indexOf(material);
			if (index >= 0) {
				vm.selectedMaterials.splice(index, 1);
			} else {
				vm.selectedMaterials.splice(0, 0, material);
			}
		}

		function isSelected(material) {
			if (vm.multiple) {
				return vm.selectedMaterials.indexOf(material) >= 0;
			} else {
				return material === vm.material;
			}
		}

		function isExtended(material) {
			return vm.extendedMaterials.indexOf(material) > -1;
		}

		function isMaterialInGroup(material, group) {
			return group === null || material.rawMaterialId === group.id;
		}

		function isAnyFilterSet() {
			for (var index in vm.filters) {
				if (vm.filters[index].value !== undefined) {
					return true;
				}
			}

			for(var key in vm.filterValues){
				return true;
			}

			return vm.group !== null || vm.selectedThickness !== undefined || vm.selectedColor !== undefined || vm.isPowderCoated !== undefined || vm.hasProtectionFilm !== undefined;
		}

		function filterMaterial(material, ignoreGroup, ignoreThickness, ignoreColor) {
			if (!((isMaterialInGroup(material, vm.group) || ignoreGroup === true)
				&& (vm.term === '' || $filter('nuitTranslate')(material.name, '???').toLowerCase().includes(vm.term.toLowerCase()))
				&& (vm.hasProtectionFilm === undefined || material.protectionFilm === vm.hasProtectionFilm)
				&& (vm.isPowderCoated === undefined || material.powderCoated === vm.isPowderCoated)
				&& (vm.selectedThickness === undefined || matchesThickness(material.thickness, vm.selectedThickness) || ignoreThickness === true)
				&& (vm.selectedColor === undefined || (material.colors.front !== null && material.colors.front !== undefined && material.colors.front.id === vm.selectedColor) || ignoreColor === true)))
			{
				return false;
			}

			var showInactive = true;

			if(vm.config.evo && vm.config.evo.material && vm.config.evo.material.details && vm.config.evo.material.details.hasOwnProperty('showInactive')){
				showInactive = vm.config.evo.material.details.showInactive;
			}

			if(!material.active && !showInactive){
				return false;
			}

			// Filters
			var filters = vm.filters;
			var filter = null;
			var attr = null;

			for (var index in filters) {
				filter = filters[index];
				if (filter.value === undefined || filter.value === null || filter.value === '') {
					continue;
				}
				var found = false;
				if (material.attributes !== null && material.attributes.length > 0) {
					for (var attrIndex in material.attributes) {
						attr = material.attributes[attrIndex];
						if (attributeMatchesFilter(attr, filter)) {
							found = true;
							break;
						}
					}
				}
				if (!found) {
					return false;
				}
			}

			return true;
		}

		function matchesThickness(thickness, thicknessToMatch) {
			switch (vm.thicknessComparator) {
				case '=':
					return thickness === thicknessToMatch;
				case '<=':
					return thickness <= thicknessToMatch;
				case '>=':
					return thickness >= thicknessToMatch;
				default:
					return false;
			}
		}

		function attributeMatchesFilter(attr, filter) {
			if (attr.value) {
				if (attr.id === filter.id && attr.value) {
					if (filter.useComparator) {
						return ComparatorService.matches(filter.comparator, filter.value, attr.value);
					} else {
						return String(attr.value).toLowerCase().indexOf(String(filter.value).toLowerCase()) >= 0;
					}
				} else if (filter.type === 'generic_materialgroup' && attr.type === 'material' && isMaterialInGroup(attr.value, filter.value.id)) {
					if (filter.subvalue === undefined || filter.subvalue.id === attr.value) {
						return true;
					}
				}
			} else if (attr.restrictions && attr.restrictions.options) {
				return attr.restrictions.options.indexOf(filter.value) >= 0;
			}
			return false;
		}

		/**
		 * Select material
		 */
		function submit() {
			$mdDialog.hide(vm.multiple ? vm.selectedMaterials : vm.material);
		}

		/**
		 * Closes this dialog.
		 */
		function closeDialog() {
			$mdDialog.hide();
		}

		function updateComparator(filter, value) {
			filter.comparator = value[1];
			filterChanged(filter);
		}

		function filterControls(controls){
			vm.customFilterControls = controls;
		}
	}

})();

(function () {
    'use strict';

    angular
            .module('app.core')
            .controller('LoadingController', controller);

    /** @ngInject */
    function controller(Deferred, $mdDialog) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
		vm.promise = Deferred.promise;
        //*******************************************

        //*******************************************
        // INITIALIZATION
        //*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {
			if(!angular.isObject(vm.promise)) {
				$mdDialog.hide();
			} else {
				vm.promise.finally(function() {
					$mdDialog.hide();
				});
			}
        }
    }

})();

/* global angular */
(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('ItemRenameController', controller);

    /** @ngInject */
    function controller(Name, Locales, $mdDialog, $translate, nuitConfig) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.selectedLanguage = $translate.use();
		vm.locales = Locales;

		if(angular.isString(Name)){
			vm.name = {};
			vm.name[vm.selectedLanguage] = angular.copy(Name);
		}else{
			vm.name = angular.copy(Name);
		}
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        function submit() {
            $mdDialog.hide(vm.name);
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }

})();

(function () {
    'use strict';

    angular
            .module('app.core')
            .controller('BlockerController', controller);

    /** @ngInject */
    function controller(Options, $mdDialog, nuitAuth) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        vm.text = Options.text;
        //*******************************************

		vm.hide = hide;

        //*******************************************
        // INITIALIZATION
        //*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

		function init(){

		}

        function hide(){
        	if(Options){
        		if(Options.canHide) {
					$mdDialog.hide();

					switch(Options.hideAction){
						case 'logout':
							nuitAuth.logout();
							break;
					}
        		}
			}
		}
    }

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('ImageUploadController', ImageUploadController);

	/** @ngInject */
	function ImageUploadController(nuitUtils, $rootScope, $scope, $mdDialog, nuitApi, Route, Arguments, IncludeAllResponseData, FileRestrictions, MaxFileSize, MaxImageWidth, MaxImageHeight){
        //*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.fileData = null;
        vm.fileSize = -1;
        vm.FileRestrictions = FileRestrictions;
        vm.MaxFileSize = MaxFileSize;
		vm.MaxImageWidth = MaxImageWidth;
		vm.MaxImageHeight = MaxImageHeight;
		vm.Arguments = Arguments;
		vm.image = {hasImage: false, width:0, height: 0};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.cancel = cancel;
		vm.isValid = isValid;
		vm.hasProperSize = hasProperSize;
		vm.hasMaxFileSize = hasMaxFileSize;
		vm.getMaxFileSize = getMaxFileSize;
		vm.fulfillsImageRestriction = fulfillsImageRestriction;
        $scope.setFile = setFile;
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

		////////////////////////////////////////////////////////////////////////

        /**
         * Initializes this controller.
         */
        function init() {

        }
		/**
		 * Closes the current dialog.
		 */
		function cancel() {
			$mdDialog.cancel();
		}
        /**
         * Sets the form data to the given one.
         * @param {Object} files - file data
         */
        function setFile(files) {
        	if(files.length>0) {
				vm.image.hasImage = false;
				vm.fileData = new FormData();

				var key = (Route && Route.indexOf('image') !== -1) ? 'image' : 'attachment';

				vm.fileData.append(key, files[0]);
				vm.fileSize = files[0].size;

				var reader;

				reader = new FileReader();

				reader.onload = function(file) {
					var image = new Image();
					image.onload = function(){
						vm.image.hasImage = true;
						vm.image.width = image.width;
						vm.image.height = image.height;
						$scope.$digest();
					};
						image.src = file.target.result;
					};

				reader.readAsDataURL(files[0]);
				$scope.$digest();
			}
        	else{
        		vm.fileSize = -1;
        		vm.fileData = null;
				vm.image.hasImage = false;
				vm.image.width = 0;
				vm.image.height = 0;
			}

        	$scope.$apply();
        }

        function isValid(){
			return vm.importForm.$valid && (vm.fileData!==null && vm.fileData!==undefined) && vm.hasProperSize() && vm.fulfillsImageRestriction();
		}

		/**
		 * Submits the dialog form.
		 */
		function submit() {
			if(isValid()) {
				if(Route) {
					vm.isLoading = true;

					var api;

					if(Arguments){
						switch(Arguments.length){
							case 3:
								api = nuitApi(Route,Arguments[0],Arguments[1],Arguments[1]);
								break;
							case 2:
								api = nuitApi(Route,Arguments[0],Arguments[1]);
								break;
							default:
								api = nuitApi(Route,Arguments[0]);
								break;
						}
					}else{
						api = nuitApi(Route);
					}




					api
						.post(vm.fileData, {}, {
							headers: {
								'Content-Type': undefined
							}
						}).then(function (response) {
							var path = response.data.path?response.data.path:response.data.url;
							$mdDialog.hide(IncludeAllResponseData?response.data:path);
						})
						.catch(nuitUtils.showErrorToast)
						.finally(function (error) {
						vm.isLoading = false;
					});
				}
				else{
					$mdDialog.hide(vm.fileData.get('attachment'));
				}
			}
		}

		function hasMaxFileSize(){
			return vm.MaxFileSize!==-1;
		}

		function getMaxFileSize(){
			return hasMaxFileSize()?Math.round((vm.MaxFileSize)*100/(1024*1024))/100:0;
		}

		function hasProperSize(){
			if(vm.MaxFileSize===-1){
				return true;
			}else{
				return vm.fileSize<=vm.MaxFileSize;
			}
		}

		function fulfillsImageRestriction(){
			if(vm.hasMaxFileSize() && vm.image.hasImage) {
				return vm.image.width <= vm.MaxImageWidth && vm.image.height <= vm.MaxImageHeight;
			}else{
				return true;
			}
		}
	}
}());

/* global angular */
(function () {
	'use strict';

	angular
	  .module('app.core')
	  .controller('FolderRenameController', controller);

	/** @ngInject */
	function controller(Header, Caption, Button, Name, $mdDialog, $translate, nuitConfig) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.name = Name?Name:{};
		vm.header = Header;
		vm.caption = Caption;
		vm.button = Button
		vm.config = nuitConfig.current;
		vm.selectedLanguage = $translate.use();
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.submit = submit;
		vm.hide = hide;
		vm.cancel = cancel;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function submit() {
			$mdDialog.hide(vm.name);
		}

		function hide() {
			$mdDialog.hide();
		}

		function cancel() {
			$mdDialog.cancel();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('FeedbackController', controller);

	/** @ngInject */
	function controller($mdDialog, OldProfile, NewProfile, ProductionProfile, FeedbackService, nuitConfig) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.getCurrent();
		vm.oldProfile = OldProfile;
		vm.newProfile = NewProfile;
		vm.productionProfile = ProductionProfile;
		vm.notes = FeedbackService.notes;
		vm.userRequest = false;
		vm.feedback = {
			machineId: vm.productionProfile.bendingMachineId,
			producible: false,
			noteIds: [],
			geometryId: vm.oldProfile.geometry.id,
			materialId: vm.oldProfile.materialId
		};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.save = save;
		vm.isRequired = isRequired;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************

		init();

		function init(){
			FeedbackService.reload();
		}

		function save() {
			if(!vm.userRequest) {
				FeedbackService.postFeedback(vm.feedback);
			}
			$mdDialog.hide();
		}

		function isRequired(){
			return !vm.userRequest && vm.config.ims.productionOrders.feedback.notes.required;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('ImageDialogController', controller);

	/** @ngInject */
	function controller($mdDialog, image) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.image = image;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.close = close;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function close() {
			$mdDialog.cancel();
		}
	}
}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .component('nuitTags', {
            transclude: true,
            templateUrl: 'app/core/components/nuit-tags/nuit-tags.component.html',
            controller: ComponentController
        });

    function ComponentController() {
        var vm = this;

        // Data
    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .component('nuitTagMaterial', {
            templateUrl: 'app/core/components/nuit-tag-material/nuit-tag-material.component.html',
            controller: ComponentController,
			transclude: true,
            bindings: {
                material: '<',
				ignoreActive: '<'
            }
        });

    function ComponentController(nuitMaterials) {
	    //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
		//*******************************************
		
		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.getStyle = getStyle;
		//*******************************************
		
		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************
		
		////////////////////////////////////////////////////////////////////////
		
		function init() {
			if(angular.isNumber(vm.material)) {
				vm.material = nuitMaterials.getMaterialById(vm.material);
			}
		}
		
		function getStyle() {
			if(vm.material.active === false && vm.ignoreActive !== true) {
				return {
					'background-color': '#FFEEEE',
					'border-color': '#FF9999',
					'border-style': 'dotted',
					'border-width': '2px',
					'padding': '1px 6px'
				};
			} else {
				return {};
			}

		}
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .component('nuitTagCutting', {
            templateUrl: 'app/core/components/nuit-tag-cutting/nuit-tag-cutting.component.html',
            controller: ComponentController,
            bindings: {
                cutting: '<'
            }
        });

    function ComponentController() {
        var vm = this;
    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .component('nuitTagAttribute', {
            templateUrl: 'app/core/components/nuit-tag-attribute/nuit-tag-attribute.component.html',
            controller: ComponentController,
            bindings: {
                attribute: '<'
            }
        });

    function ComponentController() {
        var vm = this;
    }

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.component('nuitTag', {
			templateUrl: 'app/core/components/nuit-tag/nuit-tag.component.html',
			controller: TagComponentController,
			transclude: true,
			bindings: {
				model: '<',
				nameProperty: '@'
			}
		});

	function TagComponentController(nuitColors, nuitMaterials) {
		var vm = this;
		vm.customData = null;

		if(!vm.nameProperty) {
			vm.nameProperty = 'name';
		}

		vm.$onInit = init;
		vm.$onChanges = onChanges;

		function init(){
		}

		function onChanges(changes) {
			if (changes.model) {
				updateColor();
				updateMaterial();
			}
		}

		function updateColor(){
			if(vm.model && vm.model.type==='color'){
				nuitColors.getCachedColorById(vm.model.value)
					.then(function(color){
						vm.customData = color;
					});
			}
		}

		function updateMaterial(){
			if(vm.model && vm.model.type==='material'){
				nuitMaterials.getCachedMaterialById(vm.model.value)
					.then(function(material){
						vm.customData = material;
					});
			}
		}
	}
})();

(function () {
	'use strict';
	angular
	  .module('app.core')
	  .component('nuitProfileTags', {
		  templateUrl: 'app/core/components/nuit-profile-tags/nuit-profile-tags.html',
		  controller: controller,
		  controllerAs: 'vm',
		  bindings: {
			  profile: '='
		  }
	  });

	/** @ngInject */
	function controller(nuitConfig, nuitProfiles, nuitShop, nuitAuth) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.getBlank = nuitProfiles.getBlank;
		vm.isConical = nuitProfiles.isConical;
		vm.hasCuts = nuitProfiles.hasCuts;
		vm.hasStamps = nuitProfiles.hasStamps;
		vm.getPunchCount = nuitProfiles.getPunchCount;
		vm.getBendings = getBendings;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function getBendings() {
			if(nuitAuth.getEvoVersion() !== 3) {
				var bendings = 0;
				for (var index = 0; index < vm.profile.geometry.segments.length; index++) {
					var segment = vm.profile.geometry.segments[index];
					if (segment.wrap) {
						bendings += nuitShop.config('sales.wrapCount');
					} else {
						bendings += 1;
					}
				}
				return Math.max(1, bendings - 1);
			}else{
				return (vm.profile.bendCount - vm.profile.hemCount) + vm.profile.hemCount*nuitShop.config('sales.wrapCount');
			}
		}
		//*******************************************
	}
}());

(function () {
	'use strict';
	angular
		.module('app.core')
		.component('nuitSelectionIndicator', {
			templateUrl: 'app/core/components/nuit-selection-indicator/nuit-selection-indicator.html',
			controller: SelectionIndicator,
			controllerAs: 'vm',
			bindings: {
				selection:'<',
				getName:'<'
			}
		});

	/** @ngInject */
	function SelectionIndicator(nuitDataService, $attrs) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onChanges = updateOnChange;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************



		function updateOnChange(changes) {

		}
	}
}());

(function () {
	'use strict';
	angular
	  .module('app.core')
	  .component('nuitProfileSection', {
		  templateUrl: 'app/core/components/nuit-profile-section/nuit-profile-section.html',
		  controller: controller,
		  controllerAs: 'vm',
		  bindings: {
			  profile: '=',
			  readOnly: '<',
			  selectable: '<',
			  showPrices: '<',
			  minPositions: '<',
			  maxPositions: '<',
			  isSelected: '&',
			  offlineId: '<',
			  onSelectionClick: '&',
			  onImageClick: '&',
			  onDataChanged: '&',
			  onPositionAdded: '&',
			  onPositionRemoved: '&',
			  onPositionChanged: '&',
			  showPosNumber: '<'
		  }
	  });

	/** @ngInject */
	function controller(nuitMaterials, nuitConfig) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.baseProduct = null;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = $onInit;
		vm.update = update;
		vm.getMaterialById = nuitMaterials.getMaterialById;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function $onInit() {
			if(vm.minPositions === undefined) { vm.minPositions = 0; }
			if(vm.showPrices === undefined) { vm.showPrices = vm.config.evo.cart.showPrices; }
			if(!angular.isObject(vm.readOnly)) { vm.readOnly = {}; }

			if(!vm.profile.image){
				vm.profile.image = 'assets/images/logos/logo_grau_100x100.jpg';
			}
		}
		function update() {
			vm.onPositionChanged({profile:vm.profile});
		}
		//*******************************************
	}
}());

(function () {
	'use strict';
	angular
	  .module('app.core')
	  .component('nuitProfilePositions', {
		  templateUrl: 'app/core/components/nuit-profile-positions/nuit-profile-positions.html',
		  controller: controller,
		  controllerAs: 'vm',
		  bindings: {
			  profile: '=',
              readOnly: '<',
			  showPrices: '<',
			  showWeight: '<',
			  minPositions: '<',
			  maxPositions: '<',
			  maxQuantity: '<',
              softDelete: '<',
			  onPositionAdded: '&',
			  onPositionRemoved: '&',
			  onPositionChanged: '&'
		  }
	  });

	/** @ngInject */
	function controller(msUtils, $translate, $scope, $mdDialog, nuitProfiles, PositionsService, nuitDataService, nuitConfig, SpecialProcessing, DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.updateInputOnChange = msUtils.detectBrowser().browser.toLowerCase().indexOf('firefox') > -1;
		// stable reference for $watchCollection
		var NO_SPECIALS = [];
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
        vm.$onInit = $onInit;
		vm.canAdd = canAdd;
		vm.addPosition = addPosition;
		vm.addSpecial = addSpecial;
		vm.canRemoveSpecial = canRemoveSpecial;
		vm.removeSpecial = removeSpecial;
		vm.hasMoreSpecials = hasMoreSpecials;
		vm.canRemove = canRemove;
		vm.getProfileCount = getProfileCount;
		vm.getSpecialsCount = getSpecialsCount;
		vm.canEditPrices = canEditPrices;
		vm.canEditLength = canEditLength;
		vm.canEditQuantity = canEditQuantity;
		vm.removePosition = removePosition;
		vm.updatePosition = updatePosition;
		vm.getProfilePositionPrice = getProfilePositionPrice;
		vm.supportsPositions = nuitProfiles.supportsPositions;
		vm.isBox = isBox;
		vm.visibleSpecials = visibleSpecials;
		vm.getTableWidth = getTableWidth;
		vm.getSpecialColspan = getSpecialColspan;
		vm.getRemarkColspan = getRemarkColspan;
		vm.getTableHeight = getTableHeight;
		vm.isReadOnly = isReadOnly;
		vm.togglePositionChecked = togglePositionChecked;
		vm.togglePositionMarkForCheck = togglePositionMarkForCheck;
		vm.getMaxQuantity = getMaxQuantity;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function $onInit() {
			if(vm.minPositions === undefined) { vm.minPositions = 0; }
			if(vm.maxPositions === undefined) { vm.maxPositions = 9999; }
            if(vm.readOnly === undefined) { vm.readOnly = false; }

            if(vm.config.evo.cart.allowSpecials){
            	SpecialProcessing.reload();
			}
		}

		function canEditLength() {
			return vm.supportsPositions(vm.profile) && vm.profile._dirty !== true && isReadOnly('length') !== true;
		}

		function canEditQuantity() {
			return vm.profile._dirty !== true && isReadOnly('quantity') !== true;
		}

		function canEditPrices() {
			return !isReadOnly('prices');
		}

		function canAdd() {
			return getSpecialsCount()===0 && vm.supportsPositions(vm.profile) && vm.profile.positions.length < vm.maxPositions && vm.profile._dirty !== true && isReadOnly('add') !== true;
		}

		function canRemove() {
			return vm.profile.positions.length > vm.minPositions && vm.profile._dirty !== true && isReadOnly('remove') !== true;
		}

		function isBox() {
			return nuitProfiles.isBox(vm.profile);
		}

		// Conditions belong here, not in an ng-if on the ng-repeat-start: that
		// would hide only that row and leave the ng-repeat-end behind.
		function visibleSpecials(position) {
			if(!position || position.state === 'DELETED') { return NO_SPECIALS; }
			return vm.profile.specials || NO_SPECIALS;
		}

		function getProfileCount(){
			var count = 0;

			for(var i=0;i<vm.profile.positions.length;i++){
				if(vm.profile.positions[i].state !== 'DELETED'){
					count ++;
				}
			}

			return count;
		}

		function getSpecialsCount(){
			if(vm.profile.specials) {
				return vm.profile.specials.length;
			}
			else{
				return 0;
			}
		}

        function isReadOnly(property) {
            return angular.isObject(vm.readOnly) ? vm.readOnly[property] : (vm.readOnly === true);
        }

		function createDeleteProfileDialog() {
			return $mdDialog.confirm({multiple: true})
				.title($translate.instant('CART.DELETE_PROFILE_CONFIRM'))
				.textContent($translate.instant('CART.DELETE_PROFILE_CONFIRM_HTML'))
				.ariaLabel('Delete confirmation')
				.ok($translate.instant('APP.OK'))
				.cancel($translate.instant('APP.CANCEL'));
		}

		function getProfilePositionPrice(profile) {
			var result = 0.00;

			for(var i in profile.specials){
				var special = profile.specials[i];
				result += ((special.sales && special.sales.price) ? special.sales.price : 0);
			}

			for (var i in profile.positions) {
				var position = profile.positions[i];
				result += (position.price ? position.price : 0);
			}
			return result;
		}

		function addPosition(profile) {
			if(!canAdd()) { return; }

			var length;

			if(profile.material && profile.material.restrictions && profile.material.restrictions.maxLength){
				length = profile.material.restrictions.maxLength;
			}else{
				length = vm.config.defaults.profile.length;
			}

			var obj = {
				length: length,
				quantity: 1,
                state: 'NEW'
			};

            if(canEditPrices()) { obj.pricePerUnit = 0.0; }

			vm.profile.positions.push(obj);
			vm.onPositionAdded({position: vm.profile.positions[vm.profile.positions.length - 1], profile: vm.profile});
		}

		function addSpecial(special){
			var position = getFirstPosition();

			if(position){
				SpecialProcessing.showSelection(special?special:null, vm.profile.specials, isReadOnly('specials'))
					.then(function(newSpecial){
						if(!vm.profile.specials){
							vm.profile.specials = [];
						}

						if(special){
							nuitDataService.replaceOneEntity(special, newSpecial);
						}else {
							nuitDataService.upsertOne(vm.profile.specials, newSpecial);
						}

						updatePosition(0);
					});
			}
		}

		function getFirstPosition(){
			for(var i=0;i<vm.profile.positions.length;i++){
				if(vm.profile.positions[i].state!=='DELETED'){
					return vm.profile.positions[i];
				}
			}

			return null;
		}

		function hasMoreSpecials(){
			var position = getFirstPosition();

			var specialCount = 0;
			var selectedSpecialCount = 0;

			for(var i=0;i<SpecialProcessing.specials.length;i++){
				if(SpecialProcessing.specials[i].selectable){
					specialCount++;
				}

				if(vm.profile.specials){
				  var special =  nuitDataService.getOne(vm.profile.specials,SpecialProcessing.specials[i].id);
				  if(special && SpecialProcessing.specials[i].selectable){
				  	selectedSpecialCount++;
				  }
				}
			}


			if(position && vm.profile.specials){
				return selectedSpecialCount < specialCount;
			}else{
				return specialCount > 0;
			}
		}

		function canRemoveSpecial(special){
			var data = nuitDataService.getOne(SpecialProcessing.specials, special.id);

			if(!data){
				return !vm.isReadOnly('specials');
			}else{
				return data.removable && !vm.isReadOnly('specials');
			}
		}

		function removeSpecial(position, index){
			vm.profile.specials.splice(index,1);
			updatePosition(0);
		}

		function updatePosition(index, reason) {
			if(!$scope.profileForm.$valid) { return; }

            if(vm.profile.positions[index].state === undefined) {
                vm.profile.positions[index].state = 'CHANGED';
				vm.profile.positions[index].stateChangeReasons = [];
            }

            if(reason && vm.profile.positions[index].stateChangeReasons && vm.profile.positions[index].stateChangeReasons.indexOf(reason)===-1){
				vm.profile.positions[index].stateChangeReasons.push(reason);
			}

            vm.profile.positions[index].quantity = Math.round(vm.profile.positions[index].quantity);

			vm.onPositionChanged({position: vm.profile.positions[index], profile: vm.profile});
		}

		function removePosition(index) {
			if(!canRemove()) { return; }

			if (PositionsService.markedForDeletionCount(vm.profile.positions)===vm.profile.positions.length-1) {
				var confirm = createDeleteProfileDialog();

				$mdDialog.show(confirm)
				  .then(function () {
					  _deletePosition(index);
				  });
			} else {
				_deletePosition(index);
			}
		}

		function _deletePosition(index) {
            if(vm.softDelete !== true || vm.profile.positions[index].state === 'NEW') {
                vm.profile.positions.splice(index, 1);
            } else {
                vm.profile.positions[index].state = 'DELETED';
            }
			vm.onPositionRemoved({index: index, profile: vm.profile});
		}
		//*******************************************

		function getTableWidth() {
			if(isBox()) {
				// weight, price per piece + position price (when prices), quantity, actions
				return (vm.showWeight ? 1 : 0) + (vm.showPrices ? 2 : 0) + 2;
			}
			var weight = vm.showWeight ? 1 : 0;
			return (vm.showPrices ? 7 : 4) + weight;
		}

		// Special name row: the remove cell sits right of it, plus the spanning
		// position-price cell unless this is a box.
		function getSpecialColspan() {
			if(isBox()) { return getTableWidth() - 1; }
			return getTableWidth() - 2;
		}

		function getRemarkColspan() {
			if(isBox()) { return getTableWidth() - 1; }	// remark row ends with one empty trailing <td>, reserve a column for it
			return getTableWidth() - (vm.showPrices ? 2 : 0);
		}

		function getTableHeight() {
			var count = getProfileCount() + getSpecialsCount()*2;

			for(var index in vm.profile.positions) {
				if(vm.profile.positions[index].remark !== undefined && vm.profile.positions[index].remark !== null && vm.config.evo.cart.profilePositionRemarks === true) {
					count += 1;
				}
			}
			return count;
		}

		function togglePositionChecked(position){
			DotNotationService.set(
				position,
				vm.config.evo.cart.profilePositionCheck.key,
				!DotNotationService.get(position, vm.config.evo.cart.profilePositionCheck.key,false)
			);
		}

		function togglePositionMarkForCheck(position){
			DotNotationService.set(
				position,
				vm.config.evo.cart.profilePositionMarkForCheck.key,
				!DotNotationService.get(position, vm.config.evo.cart.profilePositionMarkForCheck.key,false)
			);
		}

		function getMaxQuantity(profile, position){
			if(vm.maxQuantity){
				return vm.maxQuantity;
			}else if(vm.config.evo.cart && vm.config.evo.cart.quantity) {
				return vm.config.evo.cart.quantity.profile.max;
			}else{
				return 9999;
			}
		}
	}
}());

(function () {
	'use strict';
	angular
	  .module('app.core')
	  .component('nuitProductTags', {
		  templateUrl: 'app/core/components/nuit-product-tags/nuit-product-tags.html',
		  controller: controller,
		  controllerAs: 'vm',
		  bindings: {
			  product: '='
		  }
	  });

	/** @ngInject */
	function controller($scope, nuitConfig, nuitMaterials, nuitProfiles) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.getMaterialById = nuitMaterials.getMaterialById;
		vm.isConical = nuitProfiles.isConical;
		vm.hasCuts = nuitProfiles.hasCuts;
		vm.hasStamps = nuitProfiles.hasStamps;
		vm.getPunchCount = nuitProfiles.getPunchCount;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************

		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.component('nuitProductSelection', {
			templateUrl: 'app/core/components/nuit-product-selection/nuit-product-selection.html',
			controller: controller,
			controllerAs: 'vm',
			bindings: {
				showPrices: '<',
				onProductSelected: '&',
				addButtonTranslation: '@'
			}
		});

	/** @ngInject */
	function controller($scope, $translate, $timeout, $filter, $q, $state, $stateParams, $mdSidenav, nuitProducts, nuitMaterials, nuitColors, nuitConfig, nuitUtils, nuitApi, ProductService, FavoriteService, nuitFilterService, ConditionCheckService, DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;

		vm.filters = DotNotationService.hasKey(vm.config,'evo.products.filters')?angular.copy(vm.config.evo.products.filters):[];
		vm.categories = [];
		vm.products = ProductService.products;
		vm.filteredProducts = [];
		vm.tags = ProductService.tags;
		vm.materials = nuitMaterials.materials;
		vm.colors = nuitColors.all;

		vm.isLoading = false;
		vm.materialgroups = nuitMaterials.groups;
		vm.overviewCategory = {id: -1, key: 'APP.SHOW_ALL'};
		vm.selectedCategory = null;
		vm.selectedTags = [];
		vm.term = '';
		vm.treeOptions = categoryTreeSettings();
		vm.prefilteredEntities = [];
		vm.listFilters = DotNotationService.hasKey(vm.config,'evo.products.list.filters')?angular.copy(vm.config.evo.products.list.filters):[];
		vm.filterValues = {};
		vm.currentPageEntities = [];
		vm.page = 0;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.showProductDialog = showProductDialog;
		vm.showSelected = showSelected;
		vm.searchChanged = searchChanged;
		vm.filterChanged = filterChanged;
		vm.magnifyImage = nuitUtils.magnifyImage;
		vm.isFiltered = isFiltered;
		vm.resetFilters = resetFilters;
		vm.matchesAllFilters = matchesAllFilters;
		vm.isTagSelected = isTagSelected;
		vm.getMaterialById = nuitMaterials.getMaterialById;
		vm.toggleSelectionForTag = toggleSelectionForTag;
		vm.filterControls = filterControls;
		vm.filterProducts = filterProducts;
		vm.getStyle = getStyle;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes the controller.
		 */
		function init() {
			// Extract search term from URL
			vm.term = $stateParams.term;

			// Reload everything
			if (ProductService.categories.length === 0 || !ProductService.isFullyLoaded()) {
				vm.isLoading = true;

				var productsPromise = ProductService.reloadProducts();

				var categoryPromise = ProductService.reloadCategories().then(function () {
					vm.categories = $filter('nuitTranslatedTreeSort')(ProductService.categories);
					vm.selectedCategory = vm.overviewCategory;
				});

				var tagsPromise = ProductService.reloadTags();
				var materialgroupsPromise = loadMaterialgroups();
				loadMaterials();

				// Wait for all promises to resolve
				$q
					.all([productsPromise, categoryPromise, tagsPromise, materialgroupsPromise])
					.finally(function () {
						vm.isLoading = false;
						filterProducts();
					});
			} else {
				vm.categories = $filter('nuitTranslatedTreeSort')(ProductService.categories);
				vm.selectedCategory = vm.overviewCategory;
				resetFilters();
				filterProducts();
			}

			nuitColors.reload();

			nuitConfig.reload().then(function (config) {
				vm.filters = DotNotationService.hasKey(vm.config,'evo.products.filters')?angular.copy(vm.config.evo.products.filters):[];
				vm.listFilters = DotNotationService.hasKey(vm.config,'evo.products.list.filters')?angular.copy(vm.config.evo.products.list.filters):[];
			});
		}

		function categoryTreeSettings() {
			return {
				templateUrl: 'core/components/nuit-profile-selection/main-tree.html',
				nodeChildren: 'children',
				dirSelectable: true,
				injectClasses: {
					ul: 'a1',
					li: 'a2',
					liSelected: 'a7',
					iExpanded: 'a3',
					iCollapsed: 'a4',
					iLeaf: 'a5',
					label: 'a6',
					labelSelected: 'a8'
				},
				allowDeselect: false
			};
		}

		/**
		 * Shows the cart-dialog for a single product.
		 * @param {Object} $event - event data
		 * @param {Object} product - product to display
		 */
		function showProductDialog($event, product) {
			$scope.product = product;

			nuitProducts.showProductDialog(product, vm.filters, true, vm.showPrices, $event)
				.then(function (data) {
					if (!angular.isObject(data)) {
						return;
					}
					vm.onProductSelected({product: data.data});
				});
		}

		function loadMaterials() {
			return nuitMaterials.reload();
		}

		function loadMaterialgroups() {
			return nuitMaterials.reloadGroups();
		}

		function toggleSelectionForTag(tag) {
			var index = vm.selectedTags.indexOf(tag);
			if (index >= 0) {
				vm.selectedTags.splice(index, 1);
			} else {
				vm.selectedTags.push(tag);
			}
			filterProducts();
		}

		function isTagSelected(tag) {
			return vm.selectedTags.indexOf(tag) >= 0;
		}

		function isMaterialInGroup(materialId, groupId) {
			for (var i in vm.materials) {
				if (vm.materials[i].id === materialId && vm.materials[i].rawMaterialId === groupId) {
					return true;
				}
			}
			return false;
		}

		/**
		 * Checks if the given product matches all filters.
		 * @param {Object} product
		 * @returns {Boolean}
		 */
		function matchesAllFilters(product) {
			//purchasable
			if(!product.purchasable && !vm.config.evo.products.showUnpurchasable){
				return false;
			}

			// Category
			if (!ProductService.isProductInCategory(product, vm.selectedCategory)) {
				return false;
			}

			// Tags
			if (!ProductService.hasTags(product, vm.selectedTags)) {
				return false;
			}
			// Filters
			var filters = vm.filters;
			var filter = null;
			var attr = null;

			for (var index in filters) {
				filter = filters[index];
				if (filter.value === undefined || filter.value === null || filter.value === '') {
					continue;
				}
				var found = false;
				if (product.attributes.length > 0) {
					for (var attrIndex in product.attributes) {
						attr = product.attributes[attrIndex];
						if (attributeMatchesFilter(attr, filter)) {
							found = true;
							break;
						}
					}
				}
				if (product.type === 'profile' && filter.type === 'generic_colors') {
					if (angular.isArray(product.data.materials)) {
						found = nuitMaterials.isColorInMaterials(filter.value.id, product.data.materials);
					} else if (angular.isArray(product.data.groups)) {
						found = nuitMaterials.isColorInGroups(filter.value.id, product.data.groups);
					}

				}
				if (!found) {
					return false;
				}
			}

			var name = product.name[$translate.use()];

			// Search term
			if (vm.term && vm.term !== '' && (!name || !name.toLowerCase().includes(vm.term.toLowerCase()))) {
				return false;
			}

			return true;
		}

		function attributeMatchesFilter(attr, filter) {
			if (attr.value) {
				if (String(attr.id) === String(filter.id) && attr.value
					&& String(attr.value) === String(filter.value)) {
					return true;
				} else if (filter.type === 'generic_materialgroup' && attr.type === 'material'
					&& isMaterialInGroup(attr.value, filter.value.id)) {
					if (filter.subvalue === undefined || filter.subvalue.id === attr.value) {
						return true;
					}
				} else if (filter.type === 'generic_colors') {
					if (attr.type === 'material') {
						var mat = nuitMaterials.getMaterialById(attr.value);
						if (mat !== null && (mat.colorFront === filter.value.id || mat.colorBack === filter.value.id)) {
							return true;
						}
					} else if (attr.type === 'color') {
						if (attr.value === filter.value.id) {
							return true;
						}
					}
				}
			} else if (filter.type === 'generic_colors') {
				if (attr.type === 'color') {
					var colors = attr.restrictions.colors || [];
					var blacklist = attr.restrictions.blacklist === true;
					if (attr.restrictions.subset !== undefined) {
						blacklist = false;
						colors = attr.restrictions.subset;
					}
					if ((!blacklist && colors.indexOf(filter.value.id) >= 0) || (blacklist && colors.indexOf(filter.value.id) < 0)) {
						return true;
					}
				}
			} else if (attr.restrictions.options) {
				return attr.restrictions.options.indexOf(filter.value) >= 0;
			}
			return false;
		}

		function showSelected(node) {
			vm.term = '';

			var params = $state.params;
			params.page = 1;
			params.group = node.id;
			params.term = vm.term;

			$state.go('.', params, {
				notify: false
			});

			$timeout(function () {
				filterProducts();
			});

			if ($mdSidenav('sidenav').isOpen()) {
				$mdSidenav('sidenav').toggle();
			}
		}

		function searchChanged() {
			var params = $state.params;
			params.term = vm.term;

			$state.go('.', params, {
				notify: false
			});

			filterProducts();
		}

		function isFiltered() {
			var isFiltered = false;
			angular.forEach(vm.filters, function (filter) {
				if (!isFiltered) {
					isFiltered = filter.value !== null && filter.value !== undefined;
				}
			});

			for(var key in vm.filterValues){
				isFiltered = true;
			}

			return isFiltered || vm.selectedTags.length > 0;
		}

		function filterChanged(filter) {
			if (filter && filter.type === 'generic_materialgroup') {
				reloadMaterials(filter);
			}

			filterProducts();
		}

		function filterProducts() {
			vm.filteredProducts = [];
			vm.prefilteredEntities = [];

				for (var i in vm.products) {
					var product = vm.products[i];

						if (matchesAllFilters(product)) {
							vm.prefilteredEntities.push(product);

							if(vm.listFilters) {
								if (nuitFilterService.matches(vm.listFilters, vm.filterValues, product)) {
									vm.filteredProducts.push(product);
								}
							}else{
								vm.filteredProducts.push(product);
							}
						}
				}

			vm.filteredProducts = FavoriteService.sort($filter('orderBy')(vm.filteredProducts, 'name.' + $translate.use()));

			$timeout();
		}

		function reloadMaterials(filter) {
			filter.materials = [];
			filter.subvalue = undefined;
			if (!filter.value) {
				return;
			}

			for (var i in vm.materials) {
				if (vm.materials[i].rawMaterialId === filter.value.id) {
					filter.materials.push(vm.materials[i]);
				}
			}
		}

		function resetFilters() {
			if(vm.customFilterControls) {
				vm.customFilterControls.reset();
			}

			vm.selectedTags.splice(0, vm.selectedTags.length);

			angular.forEach(vm.filters, function (filter) {
				delete filter.value;
			});

			var params = $state.params;
			vm.term = null;
			params.term = null;
			params.page = 1;
			params.filter = null;
			params.group = -1;

			$state.go('.', params, {
				notify: false
			});

			filterProducts();
		}

		function filterControls(controls){
			vm.customFilterControls = controls;
		}

		function getStyle(product){
			var style = {};

			for(var i=0;i<vm.config.evo.products.list.conditionalStyle.length; i++){
				var conditionalStyle = vm.config.evo.products.list.conditionalStyle[i];

				if(ConditionCheckService.matches(conditionalStyle, product)){
					style = angular.merge(style, conditionalStyle.style);
				}
			}

			return style;
		}
	}

})();

(function () {
	'use strict';
	angular
		.module('app.core')
		.component('nuitPagination', {
			templateUrl: 'app/core/components/nuit-pagination/nuit-pagination.html',
			controller: PaginationController,
			controllerAs: 'vm',
			bindings: {
				allEntities: '<',
				entitiesPerPage: '<',
				currentPage: '=',
				currentPageEntities: '=',
				lacyLoadEntity: '&',
				termToSet: '<',
				allowSkipping: '<',
				loadPage: '&'
			}
		});

	/** @ngInject */
	function PaginationController(nuitDataService, $attrs) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		var pages = [];
		var _currentPageInternal = 0;
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(vm, 'currentPage', {get: getCurrentPage, set: setCurrentPage});
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onChanges = updateOnChange;
		vm.nextPage = nextPage;
		vm.prevPage = prevPage;
		vm.allowNextPage = allowNextPage;
		vm.allowPrevPage = allowPrevPage;
		vm.getStartIndex = getStartIndex;
		vm.getEndIndex = getEndIndex;
		vm.getEntitiesCount = getEntitiesCount;
		vm.getPageCount = getPageCount;
		vm.getLastPage = getLastPage;
		vm.getFirstPage = getFirstPage;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************

		function divideIntoPages(entities) {
			var localEntities = angular.copy(entities);

			pages = [];

			var pageCount = vm.entitiesPerPage > 0 ? Math.ceil(localEntities.length / vm.entitiesPerPage) : 0;

			for (var page = 0; page < pageCount; page++) {
				pages.push(localEntities.splice(0, Math.min(vm.entitiesPerPage, localEntities.length)));
			}
		}

		function nextPage() {
			if (allowNextPage()) {
				preload(vm.currentPage + 1);
				return setPage(vm.currentPage + 1);
			}

			return [];
		}

		function prevPage() {
			if (allowPrevPage()) {
				preload(vm.currentPage - 1);
				return setPage(vm.currentPage - 1);
			}

			return [];
		}

		function allowNextPage() {
			return !pagesEmpty() && vm.currentPage < pages.length - 1;
		}

		function allowPrevPage() {
			return !pagesEmpty() && vm.currentPage > 0;
		}

		function setPage(page) {
			var oldCurrentPage = vm.currentPage;
			vm.currentPage = !pagesEmpty() ? Math.max(0, Math.min(pages.length - 1, page)) : page;

			if (!angular.isArray(vm.currentPageEntities)) {
				vm.currentPageEntities = [];
			}
			vm.currentPageEntities.splice(0, vm.currentPageEntities.length);
			for (var i in pages[vm.currentPage]) {
				var entity = pages[vm.currentPage][i];
				vm.currentPageEntities.push(entity);

				if ($attrs.lacyLoadEntity && entity._partial && entity.id>0) {
					loadEntity(entity);
				}
			}

			return vm.currentPageEntities;
		}

		function preload(page){
			if ($attrs.loadPage && vm.loadPage) {
				var data = {page:page};
				vm.loadPage({data: data});
			}
		}

		function loadEntity(entity) {
			entity._partial = false;
			vm.lacyLoadEntity({entity: entity})
				.then(function (newEntity) {
					nuitDataService.replaceOne(vm.currentPageEntities, angular.copy(newEntity));
				})
				.catch(function (e) {
					var oldEntity = nuitDataService.getOne(vm.currentPageEntities, e.data);

					if (oldEntity) {
						oldEntity._partial = true;
					}
				});
		}

		function refresh() {
			setPage(vm.currentPage);
		}

		function update(entities) {
			divideIntoPages(entities);
			refresh();
		}

		function getStartIndex() {
			return !pagesEmpty() ? vm.currentPage * vm.entitiesPerPage + 1 : 0;
		}

		function getEndIndex() {
			return vm.currentPage * vm.entitiesPerPage +
				Math.min(
					vm.entitiesPerPage,
					vm.currentPageEntities ? vm.currentPageEntities.length : 0
				);
		}

		function getEntitiesCount() {
			var count = 0;

			for (var i = 0; i < pages.length; i++) {
				count += pages[i].length;
			}

			return count;
		}

		function updateOnChange(changes) {
			if (changes.allEntities || changes.entitiesPerPage) {
				update(vm.allEntities);
			}

			if(changes.termToSet){
				setToTerm();
			}
		}

		function getCurrentPage() {
			return _currentPageInternal;
		}

		function setCurrentPage(newVal) {
			var oldVal = _currentPageInternal;

			_currentPageInternal = newVal;

			if (oldVal !== newVal) {
				setPage(_currentPageInternal);
			}
		}

		function pagesEmpty() {
			return getPageCount() === 0;
		}

		function getPageCount(){
			return pages.length;
		}

		function setToTerm(){
			if(vm.termToSet) {
				var key = Object.keys(vm.termToSet)[0];
				for (var i = 0; i < getPageCount(); i++) {
					for (var j = 0; j < pages[i].length; j++) {
						var entity = pages[i][j];
						if (entity.hasOwnProperty(key) && pages[i][j].name.toLowerCase().startsWith(vm.termToSet[key].toLowerCase())) {
							setPage(i);
							return;
						}
					}
				}
			}
		}

		//*******************************************

		function getFirstPage() {
			return setPage(0);
		}
		function getLastPage() {
			return setPage(pages.length);

		}
	}
}());

(function () {
	'use strict';
	angular
	  .module('app.core')
	  .component('nuitProductSection', {
		  templateUrl: 'app/core/components/nuit-product-section/nuit-product-section.html',
		  controller: controller,
		  controllerAs: 'vm',
		  bindings: {
		  	  customFields: '<',
			  product: '=',
			  readOnly: '<',
			  allowEdit: '<',
			  selectable: '<',
			  showPrices: '<',
			  showBasePrice: '<',
			  minPositions: '<',
			  maxPositions: '<',
			  softDelete: '<',
			  isSelected: '&',
			  onSelectionClick: '&',
			  onImageClick: '&',
			  onProductUpdated: '&',
			  onPositionAdded: '&',
			  onPositionRemoved: '&',
			  onPositionChanged: '&',
			  showPosNumber: '<'
		  }
	  });

	/** @ngInject */
	function controller(nuitProducts, nuitMaterials, nuitConfig, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.baseProduct = null;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = $onInit;
		vm.$doCheck = $doCheck;
        vm.isReadOnly = isReadOnly;
		vm.update = update;
		vm.editProduct = editProduct;
        vm.getReadOnlyPositions = getReadOnlyPositions;
		vm.getMaterialById = nuitMaterials.getMaterialById;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function $onInit() {
			nuitProducts.reload();
			if(vm.minPositions === undefined) { vm.minPositions = 0; }
			if(vm.showPrices === undefined) { vm.showPrices = vm.config.evo.cart.showPrices; }
			if(vm.showBasePrice === undefined)	{ vm.showBasePrice = false;}
			if(vm.softDelete === undefined){ vm.softDelete = false; }
			if(vm.customFields === undefined){ vm.customFields = []; }

		}

		function $doCheck() {
			if(vm.baseProduct === null || vm.baseProduct.id !== vm.product.id) {
				vm.baseProduct = nuitProducts.getProductById(vm.product.id);
				for (var i in vm.product.attributes) {
					if (vm.product.attributes[i].value !== undefined) {
						vm.product.attributes[i].constant = true;
					}
				}
			}
		}

        function getReadOnlyPositions() {
            if(vm.readOnly === true) { return true; }
            return angular.isObject(vm.readOnly) ? vm.readOnly.positions : false;
        }

        function isReadOnly(property) {
            return angular.isObject(vm.readOnly) ? vm.readOnly[property] : (vm.readOnly === true);
        }

		function update() {
			vm.onProductUpdated({product: angular.copy(vm.product)});
		}

		function editProduct(product) {
			var posNumber = product.posNumber;

			nuitProducts
			  .showProductDialog(product, [], false)
			  .then(function (data) {
				  if(!angular.isObject(data)) { return; }
				  nuitUtils.clearObj(vm.product);
				  angular.merge(vm.product, data.product);
				  vm.product.posNumber = posNumber;
				  vm.update();
			  });
		}
		//*******************************************
	}
}());

(function () {
	'use strict';
	angular
	  .module('app.core')
	  .component('nuitProductPositions', {
		  templateUrl: 'app/core/components/nuit-product-positions/nuit-product-positions.html',
		  controller: controller,
		  controllerAs: 'vm',
		  bindings: {
			  product: '=',
			  readOnly: '<',
			  showPrices: '<',
			  showBasePrice: '<',
			  minPositions: '<',
			  maxPositions: '<',
			  maxQuantity: '<',
			  softDelete: '<',
			  onPositionAdded: '&',
			  onPositionRemoved: '&',
			  onPositionChanged: '&'
		  }
	  });

	/** @ngInject */
	function controller($mdDialog, $translate, nuitProducts, nuitConfig, nuitProfiles, DotNotationService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.baseProduct = null;
		vm.positionAttributes = [];
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = $onInit;
		vm.$doCheck = $doCheck;
		vm.canAdd = canAdd;
		vm.canEditLength = canEditLength;
		vm.canEditQuantity = canEditQuantity;
		vm.isReadOnly = isReadOnly;
		vm.isProfile = isProfile;
		vm.isBox = isBox;
		vm.isProfileLengthFixed = isProfileLengthFixed;
		vm.getTableWidth = getTableWidth;
		vm.getRemarkColspan = getRemarkColspan;
		vm.getTableHeight = getTableHeight;
		vm.addPosition = addPosition;
		vm.updateProduct = updateProduct;
		vm.removePosition = removePosition;
		vm.supportsPositions = supportsPositions;
		vm.togglePositionChecked = togglePositionChecked;
		vm.togglePositionMarkForCheck = togglePositionMarkForCheck;
		vm.getMaxQuantity = getMaxQuantity;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function $onInit() {
			nuitProducts.reload();
		}

		function $doCheck() {
			// Ensure positions
		    if(!angular.isArray(vm.product.positions)) {
				vm.product.positions = [];
			}

			// Load base product
			if(vm.baseProduct === null || vm.baseProduct.id !== vm.product.id) {
				vm.baseProduct = nuitProducts.getProductById(vm.product.id);
				vm.positionAttributes.splice(0, vm.positionAttributes.length);
				for (var i in vm.product.attributes) {
					if (vm.product.attributes[i].value !== undefined) {
						vm.product.attributes[i].constant = true;
					}
					if (vm.product.attributes[i].restrictions && vm.product.attributes[i].restrictions.usesPositions) {
						vm.positionAttributes.push(vm.product.attributes[i]);
						if(vm.product.attributes[i].value === undefined) {
							vm.product.attributes[i].value = angular.isNumber(vm.product.attributes[i].restrictions.min) ? vm.product.attributes[i].restrictions.min : 1;
						}
					}
				}
			}

			// Ensure at least one position
			if(vm.product.positions.length < 1) {
				var pos = { quantity: 1, attributes: {} };
				_setupPosition(pos);
				vm.product.positions.push(pos);
			}
		}

		function isProfile() {
			return vm.product.type === 'profile';
		}

		function isBox() {
			return isProfile() && vm.baseProduct && angular.isObject(vm.baseProduct.data) && nuitProfiles.isBox(vm.baseProduct.data.profile);
		}

		function isProfileLengthFixed() {
			return isProfile() && vm.baseProduct !== null && angular.isObject(vm.baseProduct.data) && angular.isObject(vm.baseProduct.data.length) && vm.baseProduct.data.length.value !== undefined;
		}

		function canEditLength() {
			return vm.product._dirty !== true && !isProfileLengthFixed() && isReadOnly('length') !== true;
		}

		function canEditQuantity() {
			return vm.product._dirty !== true && isReadOnly('quantity') !== true && (vm.baseProduct === null || vm.baseProduct.quantityAdjustable !== false);
		}

		function isReadOnly(property) {
            return angular.isObject(vm.readOnly) ? vm.readOnly[property] : (vm.readOnly === true);
        }

		function supportsPositions() {
			return (vm.isProfile() && vm.baseProduct && !vm.isProfileLengthFixed() && nuitProfiles.supportsPositions(vm.baseProduct.data.profile)) || vm.positionAttributes.length > 0;
		}

		function updateProduct(product, form) {
			if(!form.$valid) { return; }

			if(product.state === undefined) {
				product.state = 'CHANGED';
			}

			for(var index in vm.product.positions) {
				vm.product.positions[index].quantity = Math.round(vm.product.positions[index].quantity);
			}

			vm.onPositionChanged({product: vm.product});
		}

		function getTableWidth() {
			if(isBox()) {
				// attribute columns + single price (per piece) + position price (when prices), quantity, actions
				return vm.positionAttributes.length + (vm.showPrices ? 2 : 0) + 2;
			}
			return vm.positionAttributes.length + (vm.isProfile() ? 1 : 0) + (vm.showPrices ? 3 : 0) + 2;
		}

		function getRemarkColspan() {
			if(isBox()) { return getTableWidth() - 1; }	// remark row ends with one empty trailing <td>, reserve a column for it
			return getTableWidth() - (vm.showPrices ? 2 : 1);
		}

		function getTableHeight() {
			var count = vm.product.positions.length;
			if(vm.readOnly !== true && (vm.isProfile() || vm.positionAttributes.length > 0)) {
				count += 1;
			}
			for(var index in vm.product.positions) {
				if(vm.product.positions[index].remark !== undefined && vm.product.positions[index].remark !== null && vm.config.evo.cart.productPositionRemarks === true) {
					count += 1;
				}
			}
			return count;
		}

		function canAdd() {
			return supportsPositions() && vm.product.positions.length < vm.maxPositions && vm.product._dirty !== true;
		}

		function canRemove() {
			return vm.product.positions.length > vm.minPositions && vm.product._dirty !== true && isReadOnly('remove') !== true;
		}

		function addPosition() {
			if(!canAdd()) { return; }

			var obj = {
				quantity: 1,
				attributes: {},
                state: 'NEW'
			};
			_setupPosition(obj);

			vm.product.positions.push(obj);
			vm.onPositionAdded({position: vm.product.positions[vm.product.positions.length - 1], product: vm.product});
		}

		function _setupPosition(pos) {
			if(!angular.isObject(pos.attributes) || angular.isArray(pos.attributes)) {
				pos.attributes = {};
			}

			if(vm.isProfile()) {
				pos.length = vm.isProfileLengthFixed() ? vm.baseProduct.data.length.value : vm.config.defaults.profile.length;
				if(angular.isNumber(vm.baseProduct.data.length.min) && vm.baseProduct.data.length.min > pos.length) { pos.length = vm.baseProduct.data.length.min; }
				if(angular.isNumber(vm.baseProduct.data.length.max) && vm.baseProduct.data.length.max < pos.length) { pos.length = vm.baseProduct.data.length.max; }

				if(!angular.isNumber(pos.length)) { pos.length = 1; }
			}

			for(var index in vm.positionAttributes) {
				var attribute = vm.positionAttributes[index];
				pos.attributes[attribute.id] =  angular.isNumber(attribute.restrictions.min) ? attribute.restrictions.min : 1;
			}
		}

		function createDeleteProductDialog() {
			return $mdDialog.confirm({multiple: true})
				.title($translate.instant('CART.DELETE_PRODUCT_CONFIRM'))
				.textContent($translate.instant('CART.DELETE_PRODUCT_CONFIRM_HTML'))
				.ariaLabel('Lucky day')
				//.targetEvent(ev)
				.ok($translate.instant('APP.OK'))
				.cancel($translate.instant('APP.CANCEL'));
		}

		function removePosition(index) {
			if(!canRemove()) { return; }

			if (vm.product.positions.length <= 1) {
				var confirm = createDeleteProductDialog();

				$mdDialog.show(confirm)
				  .then(function () {
					  _deletePosition(index);
				  });
			} else {
				_deletePosition(index);
			}
		}

		function _deletePosition(index) {
            if(vm.softDelete !== true || vm.product.positions[index].state === 'NEW') {
                vm.product.positions.splice(index, 1);
            } else {
                vm.product.positions[index].state = 'DELETED';
            }
			vm.onPositionRemoved({index: index, product: vm.product});
		}

		function togglePositionChecked(position){
			DotNotationService.set(
				position,
				vm.config.evo.cart.productPositionCheck.key,
				!DotNotationService.get(position, vm.config.evo.cart.productPositionCheck.key,false)
			);
		}

		function togglePositionMarkForCheck(position){
			DotNotationService.set(
				position,
				vm.config.evo.cart.productPositionMarkForCheck.key,
				!DotNotationService.get(position, vm.config.evo.cart.productPositionMarkForCheck.key,false)
			);
		}

		function getMaxQuantity(product, position){
			if(vm.maxQuantity){
				return vm.maxQuantity;
			}else if(vm.config.evo.cart && vm.config.evo.cart.quantity) {
				return vm.config.evo.cart.quantity.product.max;
			}else{
				return 9999;
			}
		}
	}
}());

(function () {
	'use strict';
	angular
		.module('app.core')
		.component('nuitPosNumber', {
			templateUrl: 'app/core/components/nuit-pos-number/nuit-pos-number.html',
			controller: PosNumberController,
			controllerAs: 'vm',
			bindings: {
				number: '<'
			}
		});

	/** @ngInject */
	function PosNumberController() {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
	}
}());

(function () {
    'use strict';
    angular
        .module('app.core')
        .component('nuitPersonName', {
            templateUrl: 'app/core/components/nuit-person-name/nuit-person.name.html',
            controllerAs: 'vm',
            bindings: {
                person: '<'
            }
        });
}());

(function () {
	'use strict';
	angular
	  .module('app.core')
	  .component('nuitMaxCountRestriction', {
		  templateUrl: 'app/core/components/nuit-max-count-restriction/nuit-max-count-restriction.html',
		  controller: controller,
		  controllerAs: 'vm',
		  bindings: {
			  maxCount: '<',
			  currentCount: '<',
			  warnOffset: '<',
			  text:'<',
			  link:'<'
		  }
	  });

	/** @ngInject */
	function controller() {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.openLink = openLink;

		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function openLink() {
			window.open(vm.link?vm.link:'https://www.cidanmachinery.com', '_blank');
		}
	}
}());

(function () {
	'use strict';
	angular
	  .module('app.core')
	  .component('nuitMaterialSelection', {
		  templateUrl: 'app/core/components/nuit-material-selection/nuit-material-selection.html',
		  transclude: true,
		  controller: controller,
		  controllerAs: 'vm',
		  bindings: {
			  selection: '=',
			  valueType: '<',
			  materials: '<',
			  groups: '<',
			  whitelist: '<',
			  multiple: '<',
			  disabled: '<',
			  bgColor: '<',
			  onSelected: '&',
			  showArrows: '<',
			  isRequired: '<'
		  }
	  });

	/** @ngInject */
	function controller($scope, $timeout, nuitConfig, nuitMaterials, nuitUtils) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = $onInit;
		vm.openDialog = openDialog;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function $onInit() {
			if(vm.isRequired === undefined){
				vm.isRequired = true;
			}

			if(vm.materials === undefined) {
				vm.materials = null;
			}
			if(vm.groups === undefined) {
				vm.groups = null;
			}

			$scope.$watch('vm.selection', function(newVal, oldVal, scope) {
				if(angular.isNumber(newVal)) {
					vm._internal = nuitMaterials.getMaterialById(newVal);
				} else {
					vm._internal = newVal;
				}
			});
		}

		function openDialog() {
			var whitelist = [];

		    if(angular.isArray(vm.materials)) {	whitelist = whitelist.concat(vm.materials); }
			if(angular.isArray(vm.groups)) {
				for(var index in vm.groups) {
					whitelist = whitelist.concat(nuitMaterials.getMaterialsInGroup(vm.groups[index]));
				}
			}
			for(var index in whitelist) {
				if(!angular.isNumber(whitelist[index])) {
					whitelist[index] = whitelist[index].id;
				}
			}

			nuitUtils
			  .showMaterialDialogWithWhitelist(vm.multiple, whitelist.length > 0 ? whitelist : null, null, angular.isArray(vm.selection) ? vm.selection : angular.isObject(vm.selection) ? [vm.selection.id] : [], [])
			  .then(function (material) {
				  vm._internal = material;
				  switch (vm.valueType) {
					  case 'id':
						  vm.selection = material.id;
						  break;
					  default:
						  vm.selection = material;
						  break;
				  }
				  $timeout(function(){
					  vm.onSelected({material: material});
				  })
			  });
		}
		//*******************************************
	}
}());

(function () {
	'use strict';
	angular
	  .module('app.core')
	  .component('nuitFlatProfile', {
		  templateUrl: 'app/core/components/nuit-flat-profile/nuit-flat-profile.html',
		  transclude: true,
		  controller: controller,
		  controllerAs: 'vm',
		  bindings: {
			  onUpdated: '&',
			  hashPrefix: '@'
		  }
	  });

	/** @ngInject */
	function controller($scope, $location, $anchorScroll, nuitConfig, nuitProfile, nuitEditor, nuitUtils, OrderSpecialService
	) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.config = nuitConfig.current;
		vm.material = null;
		vm.length = 10000;
		vm.width = 0;
		vm.quantity = 1;
		vm.name = '';
		vm.remark = '';
		vm.inProgress = false;
		vm.addedProfiles = OrderSpecialService.flatProfiles;
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onInit = $onInit;
		vm.add = add;
		vm.resetLength = resetLength;
		vm.resetQuantity = resetQuantity;
		vm.resetWidth = resetWidth;
		vm.isValid = isValid;
		vm.focusProfile = focusProfile;
		vm.removeProfile = function(index){OrderSpecialService.removeFlatProfile(index);};
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function $onInit() {
			resetAll();
		}

		function add() {
			nuitProfile.clear();
			nuitProfile.depth = vm.length;
			nuitProfile.add(vm.width, 0, 0, 1);
			var profile = nuitEditor.exportProfile();
			profile.blank = vm.width;
			profile.positions = [{length: vm.length, quantity: vm.quantity}];
			profile.material = vm.material;
			profile.name = vm.name;
			profile.remark = vm.remark;


			OrderSpecialService.addFlatProfile(profile);

			vm.name = '';
			vm.remark = '';

			if(vm.onUpdated) {
				vm.onUpdated();
			}
		}

		function resetQuantity(){
			vm.quantity = 1;
		}

		function resetWidth(){
			vm.width = 100;
		}

		function resetLength(){
			//vm.length = vm.config.defaults.profile.length;
			if(vm.material && vm.material.restrictions && vm.material.restrictions.maxLength){
				vm.length = Math.min(vm.length,vm.material.restrictions.maxLength);
			}else{
				vm.length = Math.min(vm.length,vm.config.defaults.profile.length);
			}
		}

		function resetAll(){
			vm.resetQuantity();
			vm.resetWidth();
			vm.resetLength();
		}

		function isValid(){
			return vm.material &&
				vm.quantity>=1 &&
				vm.length>=1 &&
				vm.width>=1 &&
				!vm.inProgress;
		}

		function focusProfile(id){
			var element = document.querySelector('#' + vm.hashPrefix + 'profile_'+id);
			if(element) {
				$location.hash(element.id);
				$anchorScroll();
			}
		}
	}
}());

/*
vm.moreFilters = [
			{
				id: 0,
				inputType: 'group', //'map','string','group'
				name: {de:'de',en:'en',fr: 'fr'},
				value: '',
				//values: null,
				attribute: 'price',
				//attributeFilter: 'nuitCurrency'
				displayFilter: 'nuitCurrency'
			},
			{
				id: 1,
				inputType: 'string', //'map','string','group'
				name: {de:'de',en:'en',fr: 'fr'},
				value: '',
				//values: null,
				attribute: 'name',
				attributeFilter: 'nuitTranslate',
				exactMatch: true
			}
		];
 */


(function () {
	'use strict';

	angular
		.module('app.core')
		.component('nuitFilters', {
			transclude: true,
			templateUrl: 'app/core/components/nuit-filters/nuit-filters.component.html',
			controller: ComponentController,
			controllerAs: 'vm',
			bindings: {
				filters: '<',
				filterValues: '=',
				entities: '<',
				onChange: '&',
				onInit: '&',
				hideReset: '<'
			}
		});

	function ComponentController($rootScope, $timeout, $filter, nuitDataService, nuitFilterService, DotNotationService) {
		var vm = this;
		vm.show = false;

		vm.filterChanged = filterChanged;
		vm.reset = reset;
		vm.$onChanges = onChanges;
		vm.$onDestroy = onDestroy;
		vm.$onInit = init;

		var unregisterSelectedLanguage = $rootScope.$on('$translateChangeSuccess', refresh);

		function init() {
			if (vm.onInit) {
				vm.onInit({controls:{reset: reset, refresh: refresh}});
			}
		}

		function filterChanged() {
			if (vm.onChange) {
				vm.onChange();
			}
		}

		function onChanges(changes) {
			if (changes.entities || changes.filters) {
				vm.groups = {};
				for (var i = 0; i < vm.entities.length; i++) {
					updateGroups(vm.entities[i]);
				}

				if(changes.filters) {
					refresh();
				}
			}
		}

		function refresh() {
			vm.show = false;
			$timeout(
				function () {
					vm.show = true;
				},
				10
			);
		}

		function onDestroy() {
			unregisterSelectedLanguage();
		}

		function updateGroups(entity) {
			for (var i = 0; i < vm.filters.length; i++) {
				var filter = vm.filters[i];

				if (filter.inputType === 'group') {
					if (!vm.groups[filter.id]) {
						vm.groups[filter.id] = [];
					}

					var attribute = nuitFilterService.getAttribute(filter, entity);

					if (attribute && !groupHasAttribute(vm.groups[filter.id], attribute)) {
						vm.groups[filter.id].push({
							value: attribute,
							displayValue: getDisplayValue(filter, entity)
						});
					}
				}
			}
		}

		function groupHasAttribute(group, attribute) {
			for (var i = 0; i < group.length; i++) {
				if (group[i].value === attribute) {
					return true;
				}
			}

			return false;
		}

		function getDisplayValue(filter, entity) {
			var attribute = DotNotationService.get(entity, filter.attribute);

			if (filter.displayFilter) {
				if (filter.displayFilter === 'nuitFormatter') {
					return $filter(filter.displayFilter)(filter.displayFilterFormat, attribute);
				} else {
					return $filter(filter.displayFilter)(attribute);
				}
			} else {
				return attribute;
			}
		}

		function reset() {
			nuitDataService.replaceOneEntity(vm.filterValues, {});
			if (vm.onChange) {
				vm.onChange();
			}
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('app.core')
		.component('nuitDateSearch', {
			templateUrl: 'app/core/components/nuit-date-search/nuit-date-search.html',
			controller: nuitDateSearchController,
			controllerAs: 'vm',
			bindings: {
				startDate: '<',
				endDate: '<',
				onChange: '&'
			}
		});

	/** @ngInject */
	function nuitDateSearchController($scope, $document, $mdUtil, $animate, DateSearchService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.selectStartAndEnd = false;
		vm.dateSearch = DateSearchService;
		vm.backdrop = null;

		var now = new Date().getTime();
		vm.startFilterDate = new Date(now);
		vm.endFilterDate = new Date(now);
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onChanges = $onChanges;
		vm.$onDestroy = removeBackdrop;
		vm.toggleStartEnd = toggleStartEnd;

		vm.toggleDateFilter = function(){
			DateSearchService.enabled = !DateSearchService.enabled;

			if(vm.onChange)
			{
				vm.onChange();
			}
		};
		vm.validateDates = function(){
			var result = DateSearchService.setDates(vm.startFilterDate, vm.endFilterDate);
			vm.startFilterDate = result.startDate;
			vm.endFilterDate = result.endDate;
		};

		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init(){
			vm.validateDates();
			vm.backdrop = $mdUtil.createBackdrop($scope,'dateFilterToggleButtonBackdrop');
		}

		function $onChanges(changes) {
			if(changes.startDate || changes.endDate){
				DateSearchService.setDates(
					changes.startDate.currentValue,
					changes.endDate.currentValue
				);
				vm.startFilterDate = DateSearchService.startDate;
				vm.endFilterDate = DateSearchService.endDate;
			}
		}

		function toggleStartEnd(){
			vm.selectStartAndEnd = !vm.selectStartAndEnd;
			if(vm.selectStartAndEnd){
				var parent = document.querySelector('#NuitDateSearch');
				$animate.enter(vm.backdrop, parent, null, {duration: 0});
				vm.backdrop.on('click', vm.toggleStartEnd);
			}else{
				removeBackdrop();
				$scope.$apply();
			}
		}

		function removeBackdrop(){
			vm.backdrop.off('click', vm.toggleStartEnd);
			vm.backdrop.remove();
		}
	}
}());

(function () {
	'use strict';
	angular
		.module('app.core')
		.component('nuitAddress', {
			templateUrl: 'app/core/components/nuit-address/nuit-address.html',
			controller: AddressController,
			controllerAs: 'vm',
			bindings: {
				address: '<',
				person: '<',
				addressFormat: '<',
				addressFormatByCountry: '<',
				showAddressName: '<'
			}
		});

	/** @ngInject */
	function AddressController() {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		vm.addressCopy = {};
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onChanges = $onChanges;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function $onChanges() {
			vm.addressCopy = angular.copy(vm.address);

			if(!vm.showAddressName && vm.addressCopy){
				delete vm.addressCopy.name;
				delete vm.addressCopy.nameAddition;
			}
		}
	}
}());

(function () {
	'use strict';
	angular
		.module('app.core')
		.component('nuitBackendPagination', {
			templateUrl: 'app/core/components/nuit-backend-pagination/nuit-backend-pagination.html',
			controller: BackendPaginationController,
			controllerAs: 'vm',
			bindings: {
				allEntitiesCount: '<',
				entitiesPerPage: '<',
				currentPage: '=',
				currentPageEntities: '=',
				lacyLoadEntity: '&',
				termToSet: '<',
				allowSkipping: '<',
				loadPage: '&'
			}
		});

	/** @ngInject */
	function BackendPaginationController(nuitDataService, $attrs) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		var pages = [];
		var _currentPageInternal = 0;
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(vm, 'currentPage', {get: getCurrentPage, set: setCurrentPage});
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		vm.$onChanges = updateOnChange;
		vm.nextPage = nextPage;
		vm.prevPage = prevPage;
		vm.allowNextPage = allowNextPage;
		vm.allowPrevPage = allowPrevPage;
		vm.getStartIndex = getStartIndex;
		vm.getEndIndex = getEndIndex;
		vm.getEntitiesCount = getEntitiesCount;
		vm.getPageCount = getPageCount;
		vm.getLastPage = getLastPage;
		vm.getFirstPage = getFirstPage;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************

		function divideIntoPages(totalCount) {
			pages = [];

			var pageCount = vm.entitiesPerPage > 0 ? Math.ceil(totalCount / vm.entitiesPerPage) : 0;

			var count = 0;

			for (var page = 0; page < pageCount; page++) {
				pages.push([]);
				for(var index = 0;index<vm.entitiesPerPage;index++){
					pages[page].push({index:count});
					count++;
					if(count>=totalCount){
						break;
					}
				}
			}
		}

		function nextPage() {
			if (allowNextPage()) {
				setPage(vm.currentPage + 1);
			}

			return [];
		}

		function prevPage() {
			if (allowPrevPage()) {
				return setPage(vm.currentPage - 1);
			}
		}

		function allowNextPage() {
			return !pagesEmpty() && vm.currentPage < pages.length - 1;
		}

		function allowPrevPage() {
			return !pagesEmpty() && vm.currentPage > 0;
		}

		function setPage(page) {
			vm.currentPage = !pagesEmpty() ? Math.max(0, Math.min(pages.length - 1, page)) : page;

			if (!angular.isArray(vm.currentPageEntities)) {
				vm.currentPageEntities = [];
			}
			vm.currentPageEntities.splice(0, vm.currentPageEntities.length);

			if(pages.length>0) {
				if ($attrs.loadPage) {
					var data = {start: vm.currentPage*vm.entitiesPerPage, end:(vm.currentPage+1)*vm.entitiesPerPage-1};
					return vm.loadPage({data: data})
						.then(function(response){
							vm.currentPageEntities = response;

							for (var i in pages[vm.currentPage]) {
								var entity = pages[vm.currentPage][i];

								if ($attrs.lacyLoadEntity && entity._partial) {
									loadEntity(entity);
								}
							}

							return vm.currentPageEntities;
						});
				}
			}
		}

		function loadEntity(entity) {
			entity._partial = false;
			vm.lacyLoadEntity({entity: entity})
				.then(function (newEntity) {
					nuitDataService.replaceOne(vm.currentPageEntities, angular.copy(newEntity));
				})
				.catch(function (e) {
					var oldEntity = nuitDataService.getOne(vm.currentPageEntities, e.data);

					if (oldEntity) {
						oldEntity._partial = true;
					}
				});
		}

		function refresh() {
			setPage(vm.currentPage);
		}

		function update(allEntitiesCount) {
			divideIntoPages(allEntitiesCount);
			refresh();
		}

		function getStartIndex() {
				return !pagesEmpty() ? vm.currentPage * vm.entitiesPerPage + 1 : 0;
		}

		function getEndIndex() {
			return vm.currentPage * vm.entitiesPerPage +
				Math.min(
					vm.entitiesPerPage,
					vm.currentPageEntities ? vm.currentPageEntities.length : 0
				);
		}

		function getEntitiesCount() {
			return $attrs.allEntitiesCount;
		}

		function updateOnChange(changes) {
			if (changes.allEntitiesCount || changes.entitiesPerPage) {
				update(vm.allEntitiesCount);
			}

			if(changes.termToSet){
				setToTerm();
			}
		}

		function getCurrentPage() {
			return _currentPageInternal;
		}

		function setCurrentPage(newVal) {
			var oldVal = _currentPageInternal;

			_currentPageInternal = newVal;

			if (oldVal !== newVal) {
				setPage(_currentPageInternal);
			}
		}

		function pagesEmpty() {
			return getPageCount() === 0;
		}

		function getPageCount(){
			return pages.length;
		}

		function setToTerm(){
			if(vm.termToSet) {
				var key = Object.keys(vm.termToSet)[0];
				for (var i = 0; i < getPageCount(); i++) {
					for (var j = 0; j < pages[i].length; j++) {
						var entity = pages[i][j];
						if (entity.hasOwnProperty(key) && pages[i][j].name.toLowerCase().startsWith(vm.termToSet[key].toLowerCase())) {
							setPage(i);
							return;
						}
					}
				}
			}
		}

		//*******************************************

		function getFirstPage() {
			setPage(0);
		}
		function getLastPage() {
			setPage(pages.length);

		}
	}
}());

(function () {
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config(nuitApiProvider, nuitConfigProvider) {
        //*******************************************
        // API
        //*******************************************
        nuitApiProvider.register('user.locale', 'users/:id', { allow: ['patch'] });
		nuitApiProvider.register('account.password', 'auth/:id', { allow: ['put'] });
        //*******************************************

        //*******************************************
        // SETTINGS
        //*******************************************
        var options = {
            toolbar: {
                languages: {
                    enabled: true
                }
            }
        };

        nuitConfigProvider.injectIntoDefault(options);
        //*******************************************
    }
})();

(function () {
	'use strict';

	angular
		.module('app.toolbar')
		.controller('ToolbarController', ToolbarController);

	/** @ngInject */
	function ToolbarController($mdDialog, $scope, $mdSidenav, $translate, msNavigationService, nuitAuth, nuitConfig, EVOConfigService, nuitApi, nuitShop, OrderService) {
		//*******************************************
		// VIEWMODEL
		//*******************************************
		var vm = this;
        //*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
        vm.config = null;
		vm.user = null;
        vm.languages = {};
        //*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		vm.toggleSidenav = toggleSidenav;
		vm.setLanguage = setLanguage;
        vm.changeLanguage = changeLanguage;
		vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
		vm.logout = logout;
		vm.getActiveHeadline = getActiveHeadline;
		vm.getActiveIcon = getActiveIcon;
		vm.showAccount = showAccount;
        //*******************************************

        //*******************************************
		// EVENTS
        //*******************************************
        $scope.$on(nuitAuth.EVENTS.LoginSuccess, onLoginSuccess);
        $scope.$on(nuitConfig.EVENTS.ConfigLoaded, onConfigLoaded);
        //*******************************************

		//*******************************************
		// INITIALIZE
		//*******************************************
		init();
		//*******************************************

        ////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initialize toolbar
		 */
		function init() {
            OrderService.reloadConfig();
            nuitConfig
                .reload(true)
                .then(function (config) {
                    if (nuitAuth.isAuthenticated()) {
                        vm.user = nuitAuth.getUser();
                        if(!vm.user.locale) {
                            vm.user.locale = config.languages[0];
                        }
                        setLanguage(vm.user.locale);
                    } else {
                        vm.user = null;
                        setLanguage(config.languages[0]);
                    }
                });
            nuitShop.reload();
		}

		/**
		 * Toggle sidenav
		 *
		 * @param sidenavId
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}
        /**
         * Logout
         */
        function logout() {
            vm.user = null;

            nuitAuth.logout();

            nuitConfig.reload().then(function (config) {
                config.user = null;
            });
        }
        /**
         * Sets the current language to the given one.
         * @param {String} locale
         */
        function setLanguage(locale) {
            if(locale === undefined) { return; }
            changeLanguage({
                code: locale,
                flag: locale
            });
        }

        /**
         * Changes the current language and applies it to the UI.
         * @param {String} lang
         */
        function changeLanguage(lang) {
			if(!vm.languages[lang.code]) {
                console.log("Missing language: " + lang.code);
                return;
            }

            vm.user.locale = lang.code;

            if (vm.selectedLanguage !== lang) {
                nuitApi('user.locale', vm.user.id).patch({locale: vm.user.locale} );
            }
            vm.selectedLanguage = lang;

            // Change the language
            $translate.use(lang.code);
        }

		/**
		 * Toggle msNavigation folded
		 */
		function toggleMsNavigationFolded() {
			msNavigationService.toggleFolded();
		}

		function getActiveHeadline() {
			return msNavigationService.getActiveItem().node.translate;
		}
		function getActiveIcon() {
			return msNavigationService.getActiveItem().node.icon;
		}

        //*******************************************
		// EVENTS
        //*******************************************
        /**
         * This event is fired after a successful login attempt.
         * @param {Object} event - event data
         */
        function onLoginSuccess (event) {
            nuitConfig.reload(true);
            vm.user = nuitAuth.getUser();
            setLanguage("en");
        }
        /**
         * This event is fired whenever the config has been reloaded.
         * @param {Object} event - event data
         * @param {Object} config - config data
         */
        function onConfigLoaded(event, config) {
            vm.config = config;
            // Rebuild languages array
            vm.languages = {};
            angular.forEach(config.languages, function (lang) {
                vm.languages[lang] = {
                    'title': lang,
                    'translation': 'APP.LANG_' + lang.toUpperCase(),
                    'code': lang,
                    'flag': lang
                };
            });
			EVOConfigService.getHolidays();
        }

		function showAccount(){
			return $mdDialog.show({
				controller: 'AccountController',
				controllerAs: 'vm',
				templateUrl: 'app/main/toolbar/views/account.html',
				parent: document.body,
				multiple: false
			});
		}
	}

})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('AccountController', AccountController);

    /** @ngInject */
    function AccountController($http, $scope, $mdDialog, $translate, $stateParams, nuitUtils, msUtils, nuitConfig, nuitApi, nuitAuth, CompanyService, nuitDataService, AddressService) {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        vm.config = nuitConfig.current;
        vm.user = null;
        vm.password = null;
        vm.passwordRepeat = null;
        //*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        vm.updateUser = updateUser;
        vm.changePassword = changePassword;
        vm.passwordChangeable = passwordChangeable;
        vm.updateSettings = updateSettings;
        vm.uploadImage = uploadImage;
		vm.close = close;
        //*******************************************

        //*******************************************
        // INITIALIZATION
        //*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // METHODS
        //*******************************************
        /**
         * Initializes the controller.
         */
        function init() {
			loadUserdata();
        }

        /**
         * Update settings
         */
        function updateSettings() {
            $http.put(nuitApi.getBaseUrl() + 'account', {
                //taborder: parseInt(vm.settings.taborder)
            });
        }

        function changePassword() {
            if (vm.password !== vm.passwordRepeat) {
                return;
            }

            if (nuitUtils.isValidPassword(vm.password)) {
				nuitApi('account.password', vm.user.id)
				  .put({password: vm.password})
				  .then(nuitUtils.showSuccessToast)
				  .catch(nuitUtils.showErrorToast);

				vm.password = null;
				vm.passwordRepeat = null;
			}
        }

        function passwordChangeable() {
            if (vm.password === null || !vm.password) {
                return false;
            }
            return vm.password === vm.passwordRepeat;
        }

        /**
         * Reloads the user data.
         */
        function loadUserdata() {
            nuitAuth.reloadUserData().then(function() {
                vm.user = angular.copy(nuitAuth.getUser());
            });
        }
        /**
         * Updates the user and submits the form data to the API.
         */
        function updateUser() {
            // Merge data with current user
            angular.merge(nuitAuth.getUser(), vm.user);

            // Submit to API
            nuitAuth.updateUserData().then(function () {
                nuitUtils.showSuccessToast();
            });

            // Reset form
            vm.userForm.$setPristine();
            vm.userForm.$setUntouched();
        }

		function uploadImage() {
			nuitUtils.showImageUploadDialog('env.image')
				.then(function(url){
					vm.user.avatar = url;
					vm.userForm.$setDirty();
				})
		}

		function close(){
			$mdDialog.hide();
		}
    }

})();

(function () {
	'use strict';

	angular
		.module('app.users')
		.constant('USERS_SETTINGS_ROLE',
			{
				ims: {
					users: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.users')
		.constant('USERS_SETTINGS',
			{
				ims: {
					users: {
						enabled: false,
						details: {
							readOnlyConditions: {
								externalId: []
							}
						},
						restrictions:{
							enabled: false,
							warnOffset: 2,
							maxUsers:10,
							link:'https://www.cidanmachinery.com'
						},
						allowSignup: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.constant('SYSTEM_SETTINGS_ROLE',
			{
				ims: {
					system: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.system')
		.constant('SYSTEM_SETTINGS',
			{
				ims: {
					system: {
						enabled: false,
						evoSettings: {
							enabled: true
						},
						imsSettings: {
							enabled: false
						},
						translations: {
							enabled: true
						},
						companySettings: {
							enabled: true
						},
						colorSettings: {
							enabled: true
						},
						bankHolidaySettings: {
							enabled: true
						},
						importExport: {
							enabled: false
						},
						newEditor: {
							//enabled: false,
							//location: '',
							config: {
								camera: {
									wheel: {
										precision: 10
									},
									panning: {
										sensibility: 1000
									},
									angular: {
										sensibility: {
											x: 500,
											y: 500
										}
									},
									pinch: {
										precision: 1200
									},
									inertia: {
										global: 0
									}
								},
								editing: {
									defaultLength: 3000,
									defaultFacing: 'top',
									defaultDistance: 300,
									endOnHem: false,
									macros: [
										{
											'id': 'curl',
											'mode': '2d',
											'formulas': [
												'radius = diameter/2.0',
												'r1$radius = radius',
												'circumspace = unfold-tail-radius',
												'r1$angle = (circumspace/radius)*RAD2DEG',
												'b0$segment = radius',
												'b1$segment = tail'
											],
											'lookUp': [
												{
													'variable': 'diameter',
													'table': [
														{
															'value': 21.0,
															'formulas': [
																'unfold = 68',
																'fold = 21',
																'tail = 7'
															]
														},
														{
															'value': 25.0,
															'formulas': [
																'unfold = 85',
																'fold = 25',
																'tail = 8'
															]
														},
														{
															'value': 30.0,
															'formulas': [
																'unfold = 95',
																'fold = 30',
																'tail = 10'
															]
														}
													]
												}
											],
											'variables': {
												'r1$bdir': 1,
												'b1$bdir': 1,
												'b1$segment': 0,
												'b0$bdir': 1,
												'error': 0
											},
											'items': [
												{
													'type': 'bend',
													'id': 'b0',
													'angle': 0.0,
													'segment': 0.0,
													'bDir': 0,
													'bendable': false,
													'calculate': true,
													'askForValue': [],
													'special': []
												},
												{
													'type': 'radius',
													'id': 'r1',
													'segment': 0.0,
													'angle': 0.0,
													'radius': 0.0,
													'steps': 32,
													'bDir': 0,
													'granularity': 'free',
													'bendable': false,
													'calculate': false,
													'askForValue': [],
													'special': []
												},
												{
													'type': 'bend',
													'id': 'b1',
													'angle': 90.0,
													'segment': 0.0,
													'bDir': 0,
													'bendable': false,
													'calculate': true,
													'askForValue': [],
													'special': []
												}
											]
										}
									],
								},
								menu: {
									segment: {
										enabled: true,
										defaults: {
											length: 100,
											angle: 90
										}
									},
									radius: {
										enabled: true,
										defaults: {
											radius: 50,
											angle: 90,
											steps: 8,
											granularity: 'free'
										}
									},
									hem: {
										enabled: true,
										defaults: {
											length: 10,
											initial: 'open'
										}
									},
									curl: {
										enabled: false
									}
								},
								mode: {
									displayMode: 'default',
									style: {
										centerScaleFactor: 1.2,
										/*uiScaleFactor: 1,
										fontSizeBig: '16px',
										fontSizeSmall: '14px',
										iconSizeSmall: '40px',
										iconSizeBig: '90px',
										menuSize: '20px',
										menuStroke: '1px',
										menuBoundingMargin: 5*/
									}
								},
								style: {
									applyDefaults: true,
									angle: 'inner',
									grid: {
										width: 20,
										majorInterval: 5,
										opacity: 0.5,
									}
								},
								visualisation: {
									hems: {
										closed: {
											innerRadius: 0.1
										},
										open: {
											innerRadius: 1
										},
										teardrop: {
											innerRadius: 3
										}
									},
									bends: {
										innerRadius: 0.1
									}
								},
								engine: {
									antialiasing: true,
									adaptToDeviceRatio: false
								}
							},
							features: {
								generators: {
									enabled: false,
									box: {
										enabled: false
									},
									windowsill: {
										enabled: false,
									},
									trapezoid: {
										enabled: false
									}
								}
							}
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.system.sales')
		.constant('SALES_SETTINGS_ROLE',
			{
				ims: {
					sales: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.system.sales')
		.constant('SALES_SETTINGS',
			{
				ims: {
					sales: {
						enabled: false,
                        bending: { enabled: true },
                        deductibles: { enabled: true },
						surcharges: { enabled: true },
                        general: { enabled: false },
                        products: { enabled: false },
                        logistics: { enabled: true, zip: { required: true } },
                        specials: { enabled: false },
                        fixedTimePrices: { enabled: false }
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.profiles')
		.constant('PROFILES_SETTINGS_ROLE',
			{
				ims: {
					profiles: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.profiles')
		.constant('PROFILES_SETTINGS',
			{
				ims: {
					profiles: {
						enabled: false,
						sortByName: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.roles')
		.constant('ROLES_SETTINGS_ROLE',
			{
				ims: {
					roles: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.roles')
		.constant('ROLES_SETTINGS',
			{
				ims: {
					roles: {
						enabled: false,
						showInMenu: true,
						showInUsers: true
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.roles')
		.constant('ROLES_CONSTANTS',
			[
				'IMS_SETTINGS_ROLE',
				'ROLES_SETTINGS_ROLE',
				'ORDERS_SETTINGS_ROLE',
				'PRODUCTS_SETTINGS_ROLE',
				'MATERIALS_SETTINGS_ROLE',
				'PRODUCTION_ORDERS_SETTINGS_ROLE',
				'PRODUCTION_QUEUE_SETTINGS_ROLE',
				'PARTNERS_COMPANIES_SETTINGS_ROLE',
				'SALES_SETTINGS_ROLE',
				'USERS_SETTINGS_ROLE',
				'SYSTEM_SETTINGS_ROLE',
				'PRODUCTION_PLANNING_SETTINGS_ROLE',
				'PRODUCTION_MACHINES_SETTINGS_ROLE',
				'ORDERS_PROPOSALS_SETTINGS_ROLE',
				'ORDERS_OFFERS_SETTINGS_ROLE',
				'EXCHANGE_SETTINGS_ROLE',
				'ACCOUNTING_SETTINGS_ROLE',
				'PRINTER_SETTINGS_ROLE',
				'EVO_ACCOUNT_SETTINGS_ROLE',
				'EVO_CART_SETTINGS_ROLE',
				'CONTROLLING_USERS_SETTINGS_ROLE',
				'TRANSPORT_SETTINGS_ROLE',
				'PROFILES_SETTINGS_ROLE',
				'PROJECTS_SETTINGS_ROLE',
				'PUNCH_TOOLS_SETTINGS_ROLE'
				/*
				'CONTROLLING_MATERIAL_SETTINGS_ROLE',
				'CONTROLLING_SALES_SETTINGS_ROLE',
				'PARTNERS_SUPPLIERS_SETTINGS_ROLE',
				*/
			]);
}());

(function () {
	'use strict';

	angular
		.module('app.roles')
		.constant('EVO_CART_SETTINGS_ROLE', {
			evo: {
				cart: {
					enabled: true,
					checkout: {
						enabled: true
					},
					assignee: {
						enabled: false
					}
				}
			}
		});
}());

(function () {
	'use strict';

	angular
		.module('app.roles')
		.constant('EVO_ACCOUNT_SETTINGS_ROLE',
			{
				evo: {
					account: {
						personalData: {
							allowPasswordChange: true
						},
						folders: {
							allowPublicFolderEditing: false,
							allowPublicFileEditing: true
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.constant('EXCHANGE_SETTINGS_ROLE',
			{
				ims: {
					exchange: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.exchange')
		.constant('EXCHANGE_SETTINGS',
			{
				ims: {
					exchange: {
						enabled: false,
						refreshInterval: 10000,
						quickbooks:{
							enabled: false,
							invoice:{
								export: {
									manual: true,
									appId: ''
								}
							}
						},
						jobBoss:{
							enabled: false,
							order:{
								export: {
									manual: false,
									appId: '',
									flowId: ''
								},
								exportAsOffer: {
									manual: false,
									appId: '',
									flowId: ''
								}
							},
							offer:{
								export: {
									manual: false,
									appId: '',
									flowId: ''
								}
							}
						},
						nodered:{
							enabled: false
						},
						xero:{
							enabled: false,
							invoice:{
								export: {
									manual: true,
									appId: ''
								}
							}
						},
						sage:{
							enabled: false
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue')
		.constant('PRODUCTION_QUEUE_SETTINGS_ROLE',
			{
				ims: {
					queue: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.queue')
		.constant('PRODUCTION_QUEUE_SETTINGS',
			{
				ims: {
					queue: {
						enabled: false,
						bendingProgramDownload: false,
						list: {
							orderBy: 'ordered_on',
							canDeleteStatis: [],
							canDeleteConditions: [],
							customFields:[

							],
							dateFilter:{
								enabled: false,
								filterDate: 'details.completionDate',
								startOffset: -30,
								endOffset: 30
							},
							status: {
								prepend:[]
							},
							upload:{
								enabled: false,
								appId: '',
								flowId: '',
								acceptedMimeTypes: [],
								maxSize: 1024*1024*1024
							},
						},
						productionOrderName:{
							format: '',
							shopOrderFormat: ''
						},
						filters: [
							/*{
								id: 0,
								inputType: 'string', //'enum','string','group'
								name: {de:'nummer',en:'en',fr: 'fr'},
								attribute: 'id',
								//exactMatch: true,
								attributeFilter: 'nuitFormatter',
								attributeFilterFormat: '{{lastName}} {{firstName}}',
								displayFilter: 'nuitFormatter',
								displayFilterFormat: '{{lastName}} {{firstName}}'
							},
							{
								id: 1,
								inputType: 'group', //'map','string','group'
								name: {de:'status',en:'en',fr: 'fr'},
								attribute: 'status',
							}*/
						]
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.projects', [])
		.config(config);

	/** @ngInject */
	function config(nuitConfigProvider, PROJECTS_SETTINGS) {
		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(PROJECTS_SETTINGS);
        //*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.projects')
		.constant('PROJECTS_SETTINGS_ROLE',
			{
				ims: {
					projects: {
						enabled: false
					},
				},
			});
}());

(function () {
	'use strict';

	angular
		.module('app.projects')
		.constant('PROJECTS_SETTINGS',
			{
				ims: {
					projects: {
						enabled: false,
						details: {
							readOnlyConditions: {
								externalId: [],
								status: []
							}
						}
					}
				},
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.punchTools', [])
		.config(config);

	/** @ngInject */
	function config(nuitConfigProvider, PUNCH_TOOLS_SETTINGS) {
		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(PUNCH_TOOLS_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.production.punchTools')
		.constant('PUNCH_TOOLS_SETTINGS_ROLE',
			{
				ims: {
					punchTools: {
						enabled: false,
						externalId: {
							enabled: false
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.punchTools')
		.constant('PUNCH_TOOLS_SETTINGS',
			{
				ims: {
					punchTools: {
						enabled: false,
						externalId: {
							enabled: false
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.planning')
		.constant('PRODUCTION_PLANNING_SETTINGS_ROLE',
			{
				ims: {
					planning: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.planning')
		.constant('PRODUCTION_PLANNING_SETTINGS',
			{
				ims: {
					planning: {
						enabled: false,
						boards: {
							enabled: true,
							workDays: [
								1
							],
							startDayOfWeek: 1,
							showOldPendingOrdersToday: false,
							overview: {
								material: false,
								estimatedTime: true
							}
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.constant('PRODUCTION_ORDERS_SETTINGS_ROLE',
			{
				ims: {
					productionOrders: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.orders')
		.constant('PRODUCTION_ORDERS_SETTINGS',
			{
				ims: {
					productionOrders: {
						enabled: false,
						details: {
							enabled: true,
							showDocuments: false
						},
						profiles: {
							enabled: true
						},
						cuttings: {
							enabled: false
						},
						production: {
							enabled: true
						},
						planning: {
							enabled: true
						},
						feedback: {
							enabled: false,
							successProbability: 80,
							notes:{
								required: false
							}
						},
						search:{
							enabled: false
						},
						solutionToggle: {
							enabled: false,
							key: 'roma.lastSlitOnWaste'
						},
						productionProfile: {
							label: {
								enabled: false,
								manualPrinter: {
									enabled: false
								},
								tpl: 'labelOne',
								lang: 'en'
							},
							partsMode: {
								enabled: false,
								navBar: {
									enabled: true,
									virtual: false,
									itemCount: 3
								},
								autoCollapseParts: true,
								customData:{
									checkBoxes: []
								},
								list:{
									slitLength: false,
									//complain: false
								},
								profileName: true,
								projectName: true,
								profileRemark: true,
								customFields:[]
							},
							geometryMode: {
								enabled: false,
								customFields:[],
								producedCheckbox: {
									enabled: false
								}
							},
							complain:{
								enabled: false,
								nameFormat: []
							},
							bendingMachineConfig: {
								enabled: false
							},
							coilMachineConfig: {
								enabled: false
							},
							punchingMachineConfig: {
								enabled: false
							},
							punches: {
								enabled: true
							},
							profileEditable: {
								enabled: false
							}
						},
						list: {
							orderBy: 'createdAt',
							showPlanningBoardTag: false,
							showMaterial: true,
							dateFilter:{
								enabled: false,
								filterDate: 'completionDate',
								startOffset: -30,
								endOffset: 30
							},
							allowAdd: false
						},
						time: {
							setup: 900,
							firstBend: 30,
							bend: 10
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.constant('PRODUCTION_MACHINES_SETTINGS_ROLE',
			{
				ims: {
					machines: {
						enabled: false,
						allowDeleteJobs: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.machines')
		.constant('PRODUCTION_MACHINES_SETTINGS',
			{
				ims: {
					machines: {
						enabled: false,
						coil: {
							enabled: true
						},
						bending: {
							enabled: true
						},
						punching: {
							enabled: false
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.constant('TRANSPORT_SETTINGS_ROLE',
			{
				ims: {
					transport: {
						enabled: false,
						forwarder: {
							enabled: true,
						},
						delivery: {
							enabled: true,
						},
						deliveryCalendar: {
							enabled: true
						},
						deliveryConfig: {
							enabled: true
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.transport')
		.constant('TRANSPORT_SETTINGS',
			{
				ims: {
					transport: {
						enabled: false,
						forwarder: {
							enabled: true,
							search: {
								limit: 50,
								paginationTerm: true
							},
							customerId:{
								enabled: false,
								field: 'customerId',
								format: '{{formattedCustomerId}}',
								size: 0,
								offset: 0
							},
							details:{
								addressFormat: '' +
									'{{name}}\n' +
									'{{nameAddition}}\n' +
									'{{street}}\n' +
									'{{countryCode}}-{{zipCode}} {{city}}',
								addressFormatByCountry: []
							}
						},
						delivery: {
							enabled: true,
							warning: true,
							allDetailsBefore: false,
							details:{
								addressFormat: '' +
									'{{companyname}}\n' +
									'{{additional_companyname}}\n' +
									'{{street}}\n' +
									'{{country}}-{{zip}} {{city}}',
								addressFormatByCountry: []
							},
							showNotAtProposals: true
						},
						deliveryCalendar: {
							enabled: true,
							loadDaysBefore: 365,
							loadDaysAfter: 7
						},
						deliveryConfig: {
							enabled: true
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.orders.settings')
		.constant('ORDERS_SETTINGS_SETTINGS',
			{
				ims: {
					orderSettings:{
						enabled: false,
						orderNumbers:{
							enabled: true
						},
						offerNumbers:{
							enabled: true
						},
						tags:{
							enabled: true
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.orders.settings')
		.constant('ORDERS_SETTINGS_SETTINGS',
			{
				ims: {
					orderSettings:{
						enabled: false,
						orderNumbers:{
							enabled: true
						},
						offerNumbers:{
							enabled: true
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.constant('PARTNERS_COMPANIES_SETTINGS_ROLE',
			{
				ims: {
					companies: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.partners.companies')
		.constant('PARTNERS_COMPANIES_SETTINGS',
			{
				ims: {
					companies: {
						enabled: false,
						companyNumbersEnabled: false,
						bankAccountEnabled: false,
						deliveryCostEnabled: false,
						volumeDiscountEnabled: false,
						printLabel: false,
						eInvoice: false,
						igl: false,
						search: {
							limit: 50,
							paginationTerm: true
						},
						customerId:{
							enabled: false,
							field: 'customerId',
							format: '{{formattedCustomerId}}',
							size: 0,
							offset: 0
						},
						details:{
							addressFormat: '' +
								'{{name}}\n' +
								'{{nameAdditional}}\n' +
								'{{street}}\n' +
								'{{countryCode}}-{{zipCode}} {{city}}',
							addressFormatByCountry: []
						},
						invoices: {
							invoicesPerPage: 50
						},
						credits: {
							creditsPerPage: 50
						},
						rawMaterialDiscounts: {
							enabled: false
						},
						notification:{
							enabled: false
						},
						list:{
							allowAdd: true,
							allowDelete: true
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.orders.offers', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider, ORDERS_OFFERS_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.offers', {
				url: '/offers?term?page?status?startFilterDate?endFilterDate',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.offers/views/offer-list.html',
						controller: 'OfferListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.offers.enabled'
			})
			.state('app.offers.detail', {
				url: '/:offerId?active?origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.offers/views/offer-details.html',
						controller: 'OfferDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.offers.enabled',
				data: {api: 'OfferService'}
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('orders.offers', {
			title: 'offers',
			icon: 'icon-clipboard-outline',
			state: 'app.offers',
			translate: 'OFFERS.OFFERS_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.offers.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(ORDERS_OFFERS_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders.offers')
		.constant('ORDERS_OFFERS_SETTINGS_ROLE',
			{
				ims: {
					offers: {
						enabled: false,
						allowPrevStatus: false,
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.orders.offers')
		.constant('ORDERS_OFFERS_SETTINGS',
			{
				ims: {
					offers: {
						enabled: false,
						backendQuery: true,
						allowPrevStatus: false,
						list: {
							orderBy: '-ordered_on',
							dateFilter:{
								enabled: false,
								filterDate: 'details.completionDate',
								startOffset: -30,
								endOffset: 30
							}
						},
						canDeleteConditions: [],
						nameFormat: '',
						v2: {
							enabled: false
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.orders.proposals', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider, ORDERS_PROPOSALS_SETTINGS) {
		//*******************************************
		// STATES
		//*******************************************
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.proposals', {
				url: '/proposals?term?page?status',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.proposals/views/proposal-list.html',
						controller: 'ProposalListController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.proposals.enabled'
			})
			.state('app.proposals.detail', {
				url: '/:orderId?active?origin',
				views: {
					'content@app': {
						templateUrl: 'app/main/orders.orders/views/order-details.html',
						controller: 'OrderDetailsController as vm'
					}
				},
				reloadOnSearch: false,
				permissions: 'ims.proposals.enabled',
				data: {api: 'OrderService'}
			});
		//*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('orders.proposals', {
			title: 'proposals',
			icon: 'icon-clipboard-outline',
			state: 'app.proposals',
			translate: 'PROPOSALS.PROPOSALS_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.proposals.enabled;
			}
		});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		nuitConfigProvider.injectIntoDefault(ORDERS_PROPOSALS_SETTINGS);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.orders.proposals')
		.constant('ORDERS_PROPOSALS_SETTINGS_ROLE',
			{
				ims: {
					proposals: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.orders.proposals')
		.constant('ORDERS_PROPOSALS_SETTINGS',
			{
				ims: {
					proposals: {
						enabled: false,
						list: {
							orderBy: 'ordered_on'
						},
						canDeleteConditions: []
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.credit')
		.constant('CREDIT_SETTINGS_ROLE',
			{
				ims: {
					credit: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.credit')
		.constant('CREDIT_SETTINGS',
			{
				ims: {
					credit: {
						enabled: false,
						orderNameFormat: '{{details.orderProjectName}}',
						filters: {
							year: {
								startOffset: -10,
								endOffset: 0
							}
						},
						list: {
							companyFormat: '{{number}} {{status}}',
							entitiesPerPage: 100
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.orders')
		.constant('ORDERS_SETTINGS_ROLE',
			{
				ims: {
					orders: {
						enabled: false,
						admin: false,
						sales:{ enabled: false}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.orders')
		.constant('ORDERS_SETTINGS',
			{
				ims: {
					orders: {
						enabled: true,
						admin: false,
						refreshInterval: 30000,
						positions: {
							enabled: true,
							customFields: {
								top: [],
								tags: [],
								details: []
							},
							products:{
								customFields:{
									top: []
								}
							},
							addNewProfile: false,
							addNewFlatProfile: false,
							addNewProduct: false,
							addNewSpecial: false
						},
						details: {
							enabled: true,
							completionDate: true,
							customer: {
								name: true,
								email: true,
								phone: true,
								shippingType: true,
								addressFormat: '' +
									'{{companyname}}\n' +
									'{{additional_companyname}}\n' +
									'{{contact_name}}\n' +
									'{{street}}\n' +
									'{{country}}-{{zip}} {{city}}',
								addressFormatByCountry: [],
								address: true,
								shippingAddress: true,
								addressRemark: true
							},
							customFields: {
								top: [],
								details: [],
								customer: []
							},
							allowTagAdding: true,
							enableProject: false,
						},
						sales: {
							enabled: false,
							editable: [],
							showConditions:[]
						},
						easy: {
							enabled: false
						},
						nameFormat: '{{details.orderProjectName}} | {{ordered_by.lastName}}, {{ordered_by.firstName}}',
						denyTransitionFromStatus: [],
						readOnlyStatis: [],
						readOnlyConditions: [/*{
							attribute: 'externalId',
							type: 'isNotSet',
							value: ''
						}*/],
						canDeleteConditions: [],
						backendQuery: true,
						list: {
							orderBy: '-ordered_on',
							dateFilter:{
								enabled: true,
								filterDate: 'details.completionDate',
								startOffset: -30,
								endOffset: 30
							},
							download:{
								enabled: false,
								appId: '',
								flowId: ''
							},
							status: {
								prepend:[]
							},
							allowAdd: false
						},
						v2:{
							enabled: false,
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.constant('ACCOUNTING_SETTINGS_ROLE',
			{
				ims: {
					accounting: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.accounting')
		.constant('ACCOUNTING_SETTINGS',
			{
				ims: {
					accounting: {
						enabled: false,
						minOrderStatus: '5',
						maxOrderStatus: '',
						disabledStatis: [],
						disabledRemarks: [],
						orderNameFormat: '{{details.orderProjectName}}',
						filters: {
							year: {
								startOffset: -10,
								endOffset: 0
							}
						},
						list: {
							companyFormat: '{{number}} {{status}}',
							entitiesPerPage: 100,
							exportOptions: [{name: {de: 'Rechnungen'}, format: 'invoices/nuit'},
											{name: {de: 'Kunden'}, format: 'invoicecompanies/nuit'}],
							showOrderFee: true
						},
						details: {
							company: {
								address: true,
								iban: true,
								bic: true,
								customerId: true,
								taxId: true
							},
							datepickerFilter: false
						},
						calendar: {
							workDays: [
								1
							],
							startDayOfWeek: 1,
							loadDaysBefore: 30,
							loadDaysAfter: 30
						},
						zugferd: {
							enabled: false,
							currencyRef: 'EUR',
							seller: {
								vatId: '',
								taxNumber: ''
							}
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.navigation', [])
		.config(config);

	/** @ngInject */
	function config() {

	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function () {
	'use strict';

	angular
		.module('app.products')
		.constant('PRODUCTS_SETTINGS_ROLE',
			{
				ims: {
					products: {
						enabled: false,
						sales: {
							enabled: false
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.products')
		.constant('PRODUCTS_SETTINGS',
			{
				ims: {
					products: {
						enabled: false,
						backendQuery: true,
						favorites: [],
						list: {
							allowAdd: true,
							allowDelete: true
						},
						sales: {
							enabled: false
						},
						profiles: {
							enabled: false,
							required: false,
							allowDynamicSegments: false
						},
						details:{
							readOnlyConditions:{
								externalId: []
							},
						},
						externalAPI: {
							enabled: false,
							retrieveURL: 'abas/articles/:id',
							retrieveProperty: null,
							creationURL: 'abas/articles/:id',
							creationMethod: 'PUT',
							updateURL: 'abas/articles/:id',
							updateMethod: 'PUT',
							externalID: 'abasArticleId',
							nameProp: 'abasDesc',
							/*creationData: {
                                'productId':'id',
                                'savedProfileId':'custom_data.profileId'
                            },*/
							remoteAttributesRoot: 'abasArticle',
							remoteAttributes: [
								/*'abasArticleId',
								'abasArticleNumber',
								'abasArticleType',
								'abasDesc',
								'abasDescInternal',
								'abasMaterialId',
								'abasSalesBriefDesc',
								'abasSalesDesc',
								'abasSearchTerm',
								'alphaAngle'*/
							],
							conditionals: [
								/*{
									property: 'abasArticleType',
									value: 2,
									effectors: [
										'PROFILE_LENGTH_FIXED',
										'PROFILE_MATERIAL_SINGLE'
									]
								}*/
							]
						},
						attributes:{
							enabled: true
						},
						tags: {
							enabled: true
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.constant('MATERIALS_SETTINGS_ROLE',
			{
				ims: {
					materials: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.materials')
		.constant('MATERIALS_SETTINGS',
			{
				ims: {
					materials: {
						enabled: false,
						isWeightRequired: false,
						nameFormat: '#group | #thickness | #colorFront',
						itemsPerPage: 10,
						list: {
							allowAdd: true,
							customFields: []
						},
						inventoryControl: false,             // Enables or disables the "Warenwirtschaft"-Parts for DD+
						details: {
							general: {
								enabled: true
							},
							production: {
								enabled: false,
								rawMaterials: false          // Enables or disables the "Werkstoffe"-Section
							},
							sales: {
								enabled: false,
								logistics: false            // Enables logistics settings in the sales-tab
							},
							favorites: [					 // set Option to favour a material, multiple Options are possible
								/*{							 // (switch for one option and dropdown for multiple options)
								name: {de: 'etwas'},
								weight: 50
								}*/
							],
							customFields: {
								top: []
							},
							readOnlyConditions:{
								externalId: []
							}
						},
						priceConversion: {
							enabled: false,
							symbol: '€/kg',
							//toConversionPrice: '{{basePrice}}/{{weight}}',
							//toBasePrice: '{{convertedPrice}}*{{weight}}'
						},
						batchEditing:{
							price: false
						},
						attributes:{
							enabled: true
						},
						groups:{
							enabled: true,
							preDefinedLengths:{
								enabled: false
							}
						}
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.printer')
		.constant('PRINTER_SETTINGS_ROLE',
			{
				ims: {
					printer: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.printer')
		.constant('PRINTER_SETTINGS',
			{
				ims: {
					printer: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.controlling.user')
		.constant('CONTROLLING_USERS_SETTINGS_ROLE',
			{
				ims: {
					usersControlling: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.controlling.user')
		.constant('CONTROLLING_USERS',
			{
				ims: {
					usersControlling: {
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('SetupTemplates', service);

	/** @ngInject */
	function service(nuitApi) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _templates = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			createEmptyTemplate: createEmptyTemplate,
			reload: reload,
			addTemplate: addTemplate,
			loadTemplate: loadTemplate,
			updateTemplate: updateTemplate,
			deleteTemplate: deleteTemplate,
			createDefaultConfig: createDefaultConfig,
			getTemplateById: getTemplateById
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'templates', {
			get: function () {
				return _templates;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function createEmptyTemplate() {
			var template = {
				config: createDefaultConfig(),
				style: {},
				meta: {}
			};

			return template;
		}

		function createDefaultConfig() {
			var config = {
				admin: {},
				units: {
					precision:{
						high:{value: false, type: 4}
					},
					length: {
						symbol: {value: 'mm', type: 2},
						factor: {value: 1, type: 5},
						decimals: {value: 0, type: 1}
					},
					thickness: {
						symbol: {value: 'mm', type: 2},
						factor: {value: 1, type: 5},
						decimals: {value: 2, type: 1}
					},
					runningmeter: {
						symbol: {value: 'm', type: 2},
						factor: {value: 1, type: 5},
						decimals: {value: 2, type: 1}
					},
					perLengthUnitConversion: {
						symbol: {value: 'm', type: 2},
						factor: {value: 1000, type: 5},
						decimals: {value: 2, type: 1}
					},
					weight: {
						symbol: {value: 'kg', type: 2},
						factor: {value: 1, type: 5},
						decimals: {value: 2, type: 1}
					},
					pressure: {
						symbol: {value: 'kg/m²', type: 2},
						factor: {value: 1, type: 5},
						decimals: {value: 2, type: 1},
						isVolume: {value: false, type: 4}
					},
					materialprice: {
						symbol: {value: '€/m²', type: 2},
						factor: {value: 1, type: 5},
						decimals: {value: 2, type: 1}
					},
					area: {
						symbol: {value: 'm²', type: 2},
						factor: {value: 1, type: 5},
						decimals: {value: 2, type: 1}
					},
					density: {
						symbol: {value: 'kg/m³', type: 2},
						factor: {value: 1, type: 5},
						decimals: {value: 3, type: 1}
					},
					formats: {
						number: {
							decimalSeperator: {value: '.', type: 2},
							groupSeperator: {value: ',', type: 2}
						}
					}
				},
				languages: {value: [], type: 3},
				localization: {
					dateFormat: {type: 2},
					dateTimeFormat: {type: 2},
					timeFormat: {type: 2},
					defaultLanguage: {type: 2},
					timeZone: {value: null, type: 3},
					currency: null,
					currencySymbolInFront: {value: false, type: 4},
					currencySpaceBetween: {value: true, type: 4}
				},
				themeConstants: {
					primary: {
						name: {
							value: 'palette-primary',
							type: 2
						},
						hues: {
							'default': {
								value: '500',
								type: 2
							},
							'hue-1': {
								value: '400',
								type: 2
							},
							'hue-2': {
								value: '600',
								type: 2
							},
							'hue-3': {
								value: '700',
								type: 2
							}
						}
					},
					accent: {
						name: {
							value: 'palette-accent',
							type: 2
						},
						hues: {
							'default': {
								value: '500',
								type: 2
							},
							'hue-1': {
								value: '400',
								type: 2
							},
							'hue-2': {
								value: '700',
								type: 2
							},
							'hue-3': {
								value: 'A100',
								type: 2
							}
						}
					},
					warn: {
						name: {
							value: 'palette-accent',
							type: 2
						}
					},
					background: {
						name: {
							value: 'grey',
							type: 2
						},
						hues: {
							'default': {
								value: 'A100',
								type: 2
							},
							'hue-1': {
								value: 'A100',
								type: 2
							},
							'hue-2': {
								value: '100',
								type: 2
							},
							'hue-3': {
								value: '300',
								type: 2
							}
						}
					}
				},
				themePalettes: {
					value: [{"name": "palette-primary",
						"options": {
							"50": "#e0eaf0",
							"100": "#b3cbd9",
							"200": "#80a8bf",
							"300": "#4d85a5",
							"400": "#266b92",
							"500": "#00517f",
							"600": "#004a77",
							"700": "#00406c",
							"800": "#003762",
							"900": "#00274f",
							"A100": "#82b4ff",
							"A200": "#4f95ff",
							"A400": "#1c76ff",
							"A700": "#0367ff",
							"contrastDefaultColor": "light",
							"contrastDarkColors": "50 100 200 A100 A200",
							"contrastLightColors": "300 400 500 600 700 800 900 A400 A700"
						}
					}, {"name": "palette-accent",
						"options": {
							"50": "#f1e2e5",
							"100": "#dbb7bd",
							"200": "#c38892",
							"300": "#ab5866",
							"400": "#993445",
							"500": "#871024",
							"600": "#7f0e20",
							"700": "#740c1b",
							"800": "#6a0916",
							"900": "#57050d",
							"A100": "#ff8a90",
							"A200": "#ff5760",
							"A400": "#ff2430",
							"A700": "#ff0a18",
							"contrastDefaultColor": "light",
							"contrastDarkColors": "50 100 200 A100 A200",
							"contrastLightColors": "300 400 500 600 700 800 900 A400 A700"
						}
					}],
					type: 3
				}
			};

			angular.merge(config, createDeprecatedConfig());
			return config;
		}


		function createDeprecatedConfig() {
			var config = {};
			config.defaults = {
				profile: {
					segment: {
						length: {
							value: 100,
							type: 5
						},
						angle: {
							value: 180,
							type: 5
						}
					},
					hem: {
						length: {
							min: {
								value: 10,
								type: 5
							},
							max: {
								value: 30,
								type: 5
							}
						},
						angle: {
							min: {
								value: 0,
								type: 5
							},
							max: {
								value: 20,
								type: 5
							},
							'default': {
								value: 0,
								type: 5
							}
						},
						closed: {
							value: true,
							type: 4
						}
					}
				},
				angle: {
					value: 180,
					type: 5
				},
				measureIO: {
					value: false,
					type: 4
				},
				material: {
					thickness: {
						value: 1,
						type: 5
					}
				}
			};
			config.limits = {
				angle: {
					min: {
						value: -Math.PI,
						type: 5
					},
					max: {
						value: Math.PI,
						type: 5
					}
				},
				length: {
					min: {
						value: 10,
						type: 5
					},
					max: {
						value: 10000,
						type: 5
					}
				},
				segments: {
					min: {
						value: 10,
						type: 5
					},
					max: {
						value: 1250,
						type: 5
					}
				},
				material: {
					min: {
						value: 1,
						type: 5
					}
				},
				wrap: {
					length: {
						min: {
							value: 12,
							type: 5
						},
						max: {
							value: 50,
							type: 5
						}
					},
					angle: {
						min: {
							value: 0,
							type: 5
						},
						max: {
							value: 20,
							type: 5
						}
					}
				}
			};
			return config;
		}

		function reload() {
			return nuitApi('admin.templates')
				.get()
				.then(function (response) {
					_templates.splice(0, _templates.length);
					angular.extend(_templates, response.data);
					return _templates;
				});
		}

		function loadTemplate(id) {
			return nuitApi('admin.template', id)
				.get()
				.then(function (response) {
					return response.data;
				});
		}

		function updateTemplate(template) {
			return nuitApi('admin.template', template.id)
				.put(template)
				.then(function (response) {
					for (var index in _templates) {
						var tmpl = _templates[index];
						if (tmpl.id === template.id) {
							for (var prop in tmpl) {
								delete tmpl[prop];
							}
							angular.merge(tmpl, response.data);
						}
						for (var prop in template) {
							delete template[prop];
						}
						angular.merge(template, response.data);
					}
					return response.data;
				});
		}

		function addTemplate(template) {
			return nuitApi('admin.templates')
				.post(template)
				.then(function (response) {
					_templates.push(response.data);
					return _templates;
				});
		}

		function getTemplateById(id) {
			for (var index in _templates) {
				if (_templates[index].id === id) {
					return _templates[index];
				}
			}
			return null;
		}

		function deleteTemplate(id) {
			return nuitApi('admin.template', id)
				.delete()
				.then(function () {
					for (var index in _templates) {
						if (_templates[index].id === id) {
							_templates.splice(index, 1);
							return;
						}
					}
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('SetupDefinitions', service);

	/** @ngInject */
	function service($q, $mdDialog, $mdSelect, nuitApi, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
        var definitions = {};
        var _moduleGroups = {};
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
            reload: reload,
            registerDefinition: registerDefinition,
            addDefinition: addDefinition,
            updateDefinition: updateDefinition,
            deleteDefinition: deleteDefinition,
            showAddLanguageDialog: showAddLanguageDialog,
            showEditUnitDialog: showEditUnitDialog,
            showEditFormatDialog: showEditFormatDialog,
            showEditDefinitionsDialog: showEditDefinitionsDialog,
			updateModuleGroups: updateModuleGroups,
			getGroups: getGroups,
			getGroupHeader: getGroupHeader,
			getGroupIndex: getGroupIndex,
			reloadModules: reloadModules
        };
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
        Object.defineProperty(service, "definitions", {
            get: function () { return definitions; }
        });
		Object.defineProperty(service, "moduleGroups", {
			get: function () { return _moduleGroups; }
		});
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
        init();
        //*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
        function init() {
            registerDefinition('language', 'languages');
            registerDefinition('length', 'lengths');
            registerDefinition('weight', 'weights');
            registerDefinition('area', 'areas');
            registerDefinition('pressure', 'pressures');
            registerDefinition('density', 'densities');
            registerDefinition('category', 'categories');
            registerDefinition('currency', 'currencies');
            registerDefinition('timezone', 'timezones');
            registerDefinition('timeformat', 'timeformats');
            registerDefinition('themecolor', 'themecolors');
            registerDefinition('module', 'modules');
            registerDefinition('evostate', 'evostates');
        }

		function reload() {
            var promises = [];

            for(var key in definitions) {
                promises.push(reloadDefinition(key, definitions[key]));
            }

            return $q.all(promises);
		}

		function reloadModules(){
        	return reloadDefinition('module',definitions);
		}

        function registerDefinition(key, plural) {
            var upPlural = plural.charAt(0).toUpperCase() + plural.substring(1).toLowerCase();
            var upKey = key.charAt(0).toUpperCase() + key.substring(1).toLowerCase();

            definitions[key] = [];

            service['reload'+ upPlural] = function() {
                return reloadDefinition(key, definitions[key]);
            };

            service['delete' + upKey] = function(id) {
                return deleteDefinition(key, id);
            };

            service['update' + upKey] = function(value) {
                return updateDefinition(key, value);
            };

            service['add' + upKey] = function (value) {
                var definition = {
                    key: key,
                    value: value
                };

                return nuitApi('admin.definitions')
                    .post(definition)
                    .then(function (response) {
                        definitions[key].splice(0, definitions[key].length);
                        angular.extend(definitions[key], response.data.items);
                        return definitions[key];
                    });
            };

            Object.defineProperty(service, plural.toLowerCase(), {
                get: function () { return definitions[key]; }
            });
        }

        function updateModuleGroups(){
        	_moduleGroups = nuitDataService.replaceOneEntity(_moduleGroups,{});

			for (var i = 0; i < service.modules.length; i++) {
				var module = service.modules[i].value;
				var moduleKey;
				var moduleRootKey;
				var moduleType;

				var types = [['ims.admin','admin'],['ims','ims'],['evo','evo']];

				for(var j=0;j<types.length;j++){
					if(module.location.startsWith(types[j][0])){
						moduleType = types[j][1];
						moduleRootKey = [moduleType, module.enabledProperty].join('.');
						moduleKey = [moduleType, module.enabledProperty, 'enabled'].join('.');
						break;
					}
				}

				if (moduleKey) {
					if (!_moduleGroups[module.location]) {
						_moduleGroups[module.location] = [];
					}

					_moduleGroups[module.location].push({
						name: module.name,
						key: moduleKey,
						rootKey: moduleRootKey,
						moduleName: module.enabledProperty,
						moduleType: moduleType
					});
				}
			}
		}

		function getGroups(){
			return Object.keys(_moduleGroups);
		}

		function getGroupHeader(moduleKey){

			switch(moduleKey){
				case 'ims.orders':
					return 'ORDERMANAGEMENT.ORDERMANAGEMENT_NAV';
				case 'ims.production':
					return 'PRODUCTION.PRODUCTION_NAV';
				case 'ims.accounting':
					return 'ACCOUNTING.ACCOUNTING_NAV';
				case 'ims.transport':
					return 'TRANSPORT.TRANSPORT_NAV';
				case 'ims.partners':
					return 'PARTNERS.PARTNERS_NAV';
				case 'ims.merchandising':
					return 'MERCHANDISING.MERCHANDISING_NAV';
				case 'ims.controlling':
					return 'CONTROLLING.CONTROLLING_NAV';
				case 'ims.devices':
					return 'DEVICES.DEVICES_NAV';
				case 'ims.system':
					return 'SYSTEM.SYSTEM_NAV';
				case 'ims.admin':
					return 'ADMIN.ADMIN_NAV';
				case 'evo':
					return 'APP.EVO';
				default:
					return '-';
			}
		}

		function getGroupIndex (moduleKey){

			switch(moduleKey){
				case 'evo':
					return -1;
				case 'ims.general':
					return 0;
				case 'ims.production':
					return 1;
				case 'ims.accounting':
					return 2;
				case 'ims.partners':
					return 3;
				case 'ims.merchandising':
					return 4;
				case 'ims.controlling':
					return 5;
				case 'ims.devices':
					return 6;
				case 'ims.system':
					return 7;
				case 'ims.admin':
					return 8;
				case 'ims.transport':
					return 9;
				default:
					return '';
			}
		}

        function addDefinition(value, key) {
            var definition = {
                key: key,
                value: value
            };

            return nuitApi('admin.definitions')
                .post(definition)
                .then(function (response) {
                    definitions[key].splice(0, definitions[key].length);
                    angular.extend(definitions[key], response.data.items);
                    return definitions[key];
                });
        }

        function deleteDefinition(key, id) {
            return nuitApi('admin.definition.specific', key, id).delete()
                .then(function(response) {
                    for(var index in definitions[key]) {
                        var definition = definitions[key][index];
                        if(definition.id === id) {
                            definitions[key].splice(index, 1);
                            break;
                        }
                    }
            });
        }

        function updateDefinition(key, value) {
            return nuitApi('admin.definition.specific', key, value.id)
                .put(value)
                .then(function(response) {
                    for(var index in definitions[key]) {
                        var definition = definitions[key][index];
                        if(definition.id === value.id) {
                            angular.merge(definition, response.data);
                            break;
                        }
                    }
            });
        }

        function reloadDefinition(key, target) {
            return nuitApi('admin.definition', key)
				.get()
				.then(function (response) {
					target.splice(0, target.length);
					angular.extend(target, response.data.items);
					return target;
				});
        }

        function createAddLanguageDialog() {
			return {
				controller: 'AddLanguageDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.setup/dialogs/add-language/add-language.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
                multiple: true
			};
		}

        function createEditDefinitionsDialog() {
			return {
				controller: 'EditDefinitionsDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.setup/dialogs/edit-definitions/edit-definitions.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
                multiple: true
			};
		}

        function createEditUnitDialog(unit, unitName) {
			return {
				controller: 'EditUnitDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.setup/dialogs/edit-unit/edit-unit.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
                multiple: true,
                locals: {
                    Unit: angular.copy(unit),
                    UnitName: unitName
                }
			};
		}

        function createEditFormatDialog(format, formatType) {
			return {
				controller: 'EditFormatDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin.setup/dialogs/edit-format/edit-format.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
                multiple: true,
                locals: {
                    Format: format,
                    FormatType: formatType
                }
			};
		}

        function showAddLanguageDialog() {
            $mdSelect.hide();
            $mdDialog.show(createAddLanguageDialog());
        }

        function showEditDefinitionsDialog() {
            $mdSelect.hide();
            $mdDialog.show(createEditDefinitionsDialog());
        }

        function showEditUnitDialog(unit, unitType) {
            $mdSelect.hide();
            $mdDialog.show(createEditUnitDialog(unit, unitType));
        }

        function showEditFormatDialog(format, type) {
            $mdSelect.hide();
            $mdDialog.show(createEditFormatDialog(format, type));
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('PunchingMachineService', PunchingMachineService);

	/** @ngInject */
	function PunchingMachineService($log, $q, nuitApiProxy, nuitAuth, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _machines = [];
		var _mappedMachines = [];
		var _materials = []; //materials for a certain machine
		var _brands = [];
		var V1_BRANDS = [{id:'prima_power',name:'Prima Power'}]; // v1 legacy, see V1 LEGACY block
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			getById: getById,
			getByIdOffline: getByIdOffline,
			getMachines: getMachines,
			getMachinesMapped: function(){ return nuitAuth.getEvoVersion()===3?_mappedMachines:getMachines();},
			addMachine: addMachine,
			updateMachine: updateMachine,
			deleteMachine: deleteMachine,
			getMaterials: getMaterials,
			reloadMaterials: reloadMaterials,
			reloadBrands: reloadBrands,
			getProgramStatus: getProgramStatus
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'machines', {
			get: getMachines
		});

		Object.defineProperty(service, 'brands', {
			get: getBrands
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Reloads all coil machines.
		 * @returns {Promise}
		 */
		function reload() {
			return nuitApiProxy('machines.punching-machines').get()
				.then(function (response) {
					// Clear cached machines
					_machines.splice(0, _machines.length);
					_mappedMachines.splice(0, _mappedMachines.length);

					// Save new machines
					var machines = response.data;
					angular.forEach(machines, function (machine) {
						fromApi(machine);
						_machines.push(machine);
						_mappedMachines.push(Object.assign({}, machine, {id: machine.id.toString()}));
					});

					return response;
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error loading punching machines');
				});
		}

		function getMachines() {
			return _machines;
		}

		function getBrands(){
			return _brands;
		}

		function reloadBrands() {
			if (isV1()) {
				return $q.when(nuitDataService.replaceAll(_brands, V1_BRANDS));
			}

			return nuitApiProxy('machines.punching-machines.brands').get()
				.then(function (response) {
					return nuitDataService.replaceAll(_brands, response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error loading punching machine brands');
				});
		}

		//*******************************************
		// V1 LEGACY
		// The service and views work on the machine-v2 model ('brand').
		// v1 differences are mapped here only - once v1 is gone, drop this
		// block, V1_BRANDS and the isV1() branches (reloadBrands, reloadMaterials,
		// getProgramStatus).
		//*******************************************
		function isV1() {
			return nuitAuth.getEvoVersion() !== 3;
		}

		function fromApi(machine) {
			if (isV1() && machine) {
				machine.brand = machine.manufacturer;
				delete machine.manufacturer;
			}
			return machine;
		}

		function toApi(machine) {
			if (!isV1()) {
				return machine;
			}
			var data = angular.copy(machine);
			data.manufacturer = data.brand;
			delete data.brand;
			return data;
		}
		//*******************************************

		function getByIdOffline(id) {
			return nuitDataService.getOne(_machines, id);
		}

		function getById(id) {
			return nuitApiProxy('machines.punching-machines.one', id).get()
				.then(function (response) {
					var loadedMachine = fromApi(response.data);

					angular.forEach(_machines, function (machine) {
						if (machine.id === loadedMachine.id) {
							angular.merge(machine, loadedMachine);
						}
					});

					return loadedMachine;
				})
				.catch(function (error) {
					$log.debug(error);
					throw new Error('Cannot load machine with id ' + id);
				});
		}

		function addMachine(machine) {
			return nuitApiProxy('machines.punching-machines').post(toApi(machine))
				.then(function (response) {
					var newMachine = fromApi(response.data);

					_machines.push(newMachine);

					return newMachine;
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error adding new coil machine');
				})
		}

		function updateMachine(machine) {
			return nuitApiProxy('machines.punching-machines.one', machine.id).put(toApi(machine))
				.then(function (response) {
					var loadedMachine = fromApi(response.data);

					angular.forEach(_machines, function (machine) {
						if (machine.id === loadedMachine.id) {
							angular.merge(machine, loadedMachine);
						}
					});

					return loadedMachine;
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error updating machine with id ' + machine.id);
				});
		}

		function deleteMachine(id) {
			return nuitApiProxy('machines.punching-machines.one', id).delete()
				.then(function (response) {
					return nuitDataService.removeOne(_machines, id);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error deleting machine with id ' + id);
				});
		}

		function reloadMaterials(machineId)
		{
			// machine-v2 has no punching materials
			if (!isV1()) {
				return $q.when(nuitDataService.replaceAll(_materials, []));
			}

			return nuitApiProxy('machine.punching-machines.material',machineId).get()
				.then(function (response) {
					return nuitDataService.replaceAll(_materials,response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error loading brands');
				});
		}

		function getMaterials() {
			return _materials;
		}

		function getProgramStatus(profileId){
			if (!isV1()) {
				return nuitApiProxy('productionprofiles.get.one', profileId).get();
			}

			return nuitApiProxy('machine.punching-machines.status',profileId).get();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('PollRequestService', PollRequestService);

	/** @ngInject */
	function PollRequestService($timeout) {
		var _pollInstances = {};

		var service = initService();

		return service;

		function initService() {
			return {
				get: get
			};
		}

		function get(id, cancel) {
			if (!_pollInstances[id]) {
				_pollInstances[id] = initInstance();
			}

			if (cancel) {
				_pollInstances[id].cancel();
			}

			return _pollInstances[id];
		}

		function initInstance() {
			var _timeout = null;

			return init();

			function init() {
				return {
					cancel: cancel,
					start: start,
					process: process
				};
			}

			function start(pollFn, delay) {
				if (_timeout) {
					cancel();
				}

				_timeout = $timeout(
					function () {
						pollFn().then(
							function (repeat) {
								if (repeat) {
									start(pollFn, delay);
								}
							}
						);
					}, delay);
			}

			function cancel() {
				$timeout.cancel(_timeout);
				_timeout = null;
			}

			function process(process, pollFn, delay){
				if(process){
					start(pollFn,delay);
				}else{
					cancel();
				}

				return process;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('OrderSpecialService', OrderSpecialService);

	/** @ngInject */
	function OrderSpecialService($q, $document, $mdDialog, imsUtils, nuitProducts, nuitDataService, nuitApi, nuitConfig, SpecialProcessing) {
		var _api = null;
		var _flatProfiles = [];

		var service = {
			setApi: setApi,
			open: open,
			addProfile: addProfile,
			addProfileInternal: addProfileInternal,
			addFlatProfile: addFlatProfile,
			removeFlatProfile: removeFlatProfile,
			batchAddFlatProfiles: batchAddFlatProfiles,
			batchAddProfilesInternal: batchAddProfilesInternal,
			addProduct: addProduct,
			addSpecial: addSpecial
		};

		Object.defineProperty(service, 'flatProfiles', {
			get: function () {
				return _flatProfiles;
			}
		});

		return service;

		function setApi(api){
			_api = api;
			_flatProfiles.splice(0,_flatProfiles.length);
		}

		function open(special){
			return $mdDialog.show(createOrderSpecialDialog(special))
				.then(function (newSpecial) {
					return newSpecial;
				})
				.catch(angular.noop);
		}

		function createOrderSpecialDialog(special){
			return {
				controller: 'OrderSpecialController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/order.special/order.special.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					Special: special
				}
			};
		}

		function addProfile(order){
			return imsUtils.openEditor(null,true, true,false,true)
				.then(function(profile){
					profile.positions = [{
						length: profile.length,
						quantity: 1
					}];
					delete profile.id;
					if (nuitConfig.current.evo.cart.allowSpecials) {
						return SpecialProcessing.applySpecials(profile)
							.then(function(){
		  						return addProfileInternal(order, profile);
							});
					}else{
						return addProfileInternal(order, profile);
					}
				});
		}

		function addProfileInternal(order, profile) {
			return _api.addProfile(order, profile)
				.then(function (newProfile) {
					order.profiles.push(newProfile);
					return newProfile;
				});
		}

		function batchAddFlatProfiles(order){
			return batchAddProfilesInternal(order,_flatProfiles)
				.then(function(result){
					_flatProfiles.splice(0,_flatProfiles.length);
					return result;
				});
		}

		function batchAddProfilesInternal(order, profiles){
			var promises = [];

			angular.forEach(profiles, function (profile) {
				promises.push(addProfileInternal(order,profile));
			});

			return $q.all(promises);
		}

		function addFlatProfile(profile){
			_flatProfiles.push(profile);
		}

		function removeFlatProfile(index){
			_flatProfiles.splice(index,1);
		}

		function addProduct(order){
			return nuitProducts.showProductSelectionDialog(nuitConfig.current.evo.products.showPrices)
				.then(function(product){
					return _api.addProduct(order, product.item)
						.then(function(newProduct){
							order.products.push(newProduct);
							return newProduct;
						});
				});
		}

		function addSpecial(order, special){
			return open(special)
				.then(function(newSpecial){
					return _api.addSpecial(order, newSpecial)
						.then(function(updatedSpecial) {
							order.specials.push(updatedSpecial);
							return updatedSpecial;
						});
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('OrderService', OrderService);

	/** @ngInject */
	function OrderService(nuitApi, $log, $filter, nuitConfig, nuitUtils, nuitDataService, nuitOrders) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _orders = [];
		var _meta = {pagination:{total:0, current_page:1, per_page: 20}};
		var _config = nuitConfig.current;
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			// Orders
			reload: reload,
			reloadPaged: reloadPaged,
			clear: clear,
			hasRelations: hasRelations,
			loadRelations: loadRelations,
			loadOrder: loadOrder,
			createOrder: createOrder,
			deleteOrder: deleteOrder,
			updateOrder: updateOrder,
			getOrderPositions: getOrderPositions,
			hasNextStatus: hasNextStatus,
			moveToNextStatus: moveToNextStatus,

			// Status
			reloadConfig: nuitOrders.reloadConfig,
			addStatus: addStatus,
			deleteStatus: deleteStatus,
			updateStatus: updateStatus,
			getStatusById: nuitOrders.getStatusById,
			getPreviousStatus: getPreviousStatus,
			getNextStatus: nuitOrders.getNextStatus,
			getOrderFilters: getOrderFilters,
			getQueueFilters: getQueueFilters,
			getStatusByMappedProdStatus: getStatusByMappedProdStatus,
			updateLocalOrderStatus: updateLocalOrderStatus,
			getPreProductionState: getPreProductionState,
			isInProduction: isInProduction,
			isInPostProduction: isInPostProduction,
			getArchiveId: getArchiveId,
			getStatusQueryParams: getStatusQueryParams,
			getStatusByType: nuitOrders.getStatusByType,
			getStatisByType: nuitOrders.getStatisByType,
			addProfile: addProfile,
			addProduct: addProduct,
			addSpecial: addSpecial,
			orderCountByStatus: nuitOrders.orderCountByStatus,
			getStatusCountById: nuitOrders.getStatusCountById
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'orders', {
			get: function () {
				return _orders;
			}
		});
		Object.defineProperty(service, 'meta', {
			get: function () {
				return _meta;
			}
		});

		Object.defineProperty(service, 'orderFilters', {get: getOrderFilters});
		Object.defineProperty(service, 'queueFilters', {get: getQueueFilters});
		Object.defineProperty(service, 'proposalFilters', {get: getProposalFilters});

		Object.defineProperty(service, 'queue', {
			get: function () {
				return nuitOrders.queue;
			}
		});
		Object.defineProperty(service, 'statusLoading', {
			get: function () {
				return nuitOrders.statusLoading;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		/**
		 * Reloads all orders.
		 * @returns {Promise}
		 */
		function reload(filter) {
			return nuitApi('orders.all')
				.get(filter)
				.then(function (response) {
					_orders.splice(0, _orders.length);
					angular.extend(_orders, response.data);
					return _orders;
				});
		}

		function reloadPaged(filter){
			return nuitApi('orders.all.v2')
				.get(filter)
				.then(function (response) {
					var oldOrders = [];
					angular.copy(_orders,oldOrders);
					if(response.data.meta){
						angular.extend(_meta,response.data.meta);
					}
					_orders.splice(0,_orders.length);
					if(response.data.data) {
						var startIndex = (_meta.pagination.current_page-1)*_meta.pagination.per_page
						var endIndex = startIndex + _meta.pagination.per_page - 1;
						for(var i=0;i<_meta.pagination.total;i++){
							var oldOrder = oldOrders.shift();
							if(i>=startIndex && i<=endIndex){
								_orders.push(response.data.data.shift());
								//oldOrders.shift();
							}else {
								if(oldOrder) {
									_orders.push(oldOrder);
								}else{
									_orders.push({id:-i});
								}
							}
						}
					}
				});
		}

		function clear(){
			_orders.splice(0, _orders.length);
			angular.extend(_orders, []);
		}

		function hasRelations(order){
			return order.offerId !== null;
		}

		function loadRelations(order){
			var offers =
			{
				title: 'ORDERS.RELATED_OFFER',
				state: 'app.offers.detail',
				urlId: 'offerId',
				getTitle: function(offer){
						if(_config.ims.offers.backendQuery){
							return offer.title;
						}else{
							var format = _config.ims.offers.nameFormat.length>0?_config.ims.offers.nameFormat:_config.ims.orders.nameFormat;
							return $filter('nuitFormatter')(format,offer);
						}
					},
				ordersOrOffer:[]
			};

			return nuitApi('offer.detail', order.offerId)
				.get()
				.then(function (response){
					offers.ordersOrOffer.push(response.data);
					return offers;
				});


		}

		function addStatus(status) {
			return nuitApi('order.status')
				.post(status)
				.then(function (response) {
					nuitOrders.queue.push(response.data);
				});
		}

		function updateStatus(status) {
			return nuitApi('order.status.one', status.id)
				.put(status)
				.then(function (response) {
					nuitDataService.updateOne(nuitOrders.queue, response.data);
				});
		}

		function deleteStatus(status) {
			return nuitApi('order.status.one', status.id)
				.delete()
				.then(function (response) {
					nuitDataService.removeOne(nuitOrders.queue, status.id);
				});
		}

		function createOrder(order){
			return nuitApi('order.create')
				.post(order)
				.then(function(response){
					return nuitDataService.addOne(_orders, response.data);
				});
		}

		/**
		 * Deletes the given order.
		 * @param {Object} order
		 * @returns {Promise}
		 */
		function deleteOrder(order) {
			return nuitApi('order.detail', order.id)
				.delete()
				.then(function (response) {
					return nuitDataService.removeOne(_orders, order.id);
				});
		}

		/**
		 * Returns the order with the given id.
		 * @param id - id of the order
		 * @return {Promise}
		 */
		function loadOrder(id) {
			return nuitApi('order.detail', id)
				.get()
				.then(function (response) {
					return response.data;
				})
				.catch(function (error) {
					$log.warn('Error loading cart details');
					throw new Error(error);
				});
		}

		/**
		 * Sends updated order to remote server.
		 * @param {Object} order
		 */
		function updateOrder(order) {
			return nuitOrders.updateOrder(order)
				.then(function(newOrder){
					return nuitDataService.updateOne(_orders, newOrder);
				});
		}

		/**
		 * Returns the number of positions inside an order.
		 * @param {Object} order
		 * @returns {Number}
		 */
		function getOrderPositions(order) {
			var count = 0;

			if (angular.isArray(order.products)) {
				count += order.products.length;
			}else if(order.profilesCount){
				count += order.profilesCount;
			}

			if (angular.isArray(order.profiles)) {
				count += order.profiles.length;
			}else if(order.productsCount){
				count += order.productsCount;
			}

			return count;
		}

		/**
		 * Returns the status config object which is one step
		 * bevor the one with the given id or null if no such
		 * status config exists.
		 * @param {Number} id - status id
		 * @return {Object}
		 */
		function getPreviousStatus(id) {
			for (var i in service.queue) {
				var statusConfig = service.queue[i];
				if (statusConfig.transitionTo === id) {
					return statusConfig;
				}
			}

			return null;
		}

		function isInPostProduction(id) {
			var statusObj = nuitOrders.getStatusById(id);
			while (statusObj !== null && !isInProduction(statusObj.id)) {
				statusObj = getPreviousStatus(statusObj.id);
			}

			return statusObj !== null;
		}

		/**
		 * Moves the given order to the next state.
		 * @param {Object} order
		 * @return {Promises}
		 */
		function moveToNextStatus(order) {
			return nuitOrders.moveToNextStatus(order)
				.then(function(newOrder){return nuitDataService.updateOne(_orders,newOrder);});
		}

		function hasNextStatus(id){
			return nuitOrders.hasNextStatus(id);
		}

		/**
		 * Returns an array containing all
		 * statis which should be displayed
		 * as filters in the orders list
		 * ordered by their status.
		 * @return {Array}
		 */
		function getOrderFilters() {
			var result = [];

			if (service.queue.length > 0) {

				for(var i=0;i<_config.ims.orders.list.status.prepend.length;i++) {
					var prependStatus = nuitOrders.getStatusById(_config.ims.orders.list.status.prepend[i]);

					if (prependStatus) {
						result.push(prependStatus);
					}
				}

				var status = getFirstStatus();
				while (validStatus(status)) {
					if (status.type !== 'production') {
						result.push(status);
					}
					if (status.transitionTo === undefined) {
						status = nuitOrders.getStatusById(service.queue.indexOf(status) + 1);
					} else {
						status = nuitOrders.getStatusById(status.transitionTo);
					}
				}

				if(status) {
					result.push(status);
				}
			}

			return result;
		}

		function validStatus(status){
			return status!==null && status.type !== 'archive';
		}

		/**
		 * Returns an array containing all
		 * statis which should be displayed
		 * as filters in the production queue list
		 * ordered by their status.
		 * @return {Array}
		 */
		function getQueueFilters() {
			var result = [];

			if (service.queue.length > 0) {
				for(var i=0;i<_config.ims.orders.list.status.prepend.length;i++) {
					var prependStatus = nuitOrders.getStatusById(_config.ims.queue.list.status.prepend[i]);

					if (prependStatus) {
						result.push(prependStatus);
					}
				}

				var status = getFirstStatus();
				while (validStatus(status)) {
					var nextStatus = null;
					var previousStatus = null;
					if (status.transitionTo === undefined) {
						var currentStatusIndex = service.queue.indexOf(status);
						nextStatus = nuitOrders.getStatusById(currentStatusIndex + 1);
						previousStatus = currentStatusIndex === 0 ? null : nuitOrders.getStatusById(currentStatusIndex - 1);
					} else {
						nextStatus = nuitOrders.getStatusById(status.transitionTo);
						previousStatus = getPreviousStatus(status.id);
					}

					if (
						(status && !nextStatus) || (
						status.type === 'production' ||
						nextStatus.type === 'production' ||
						(previousStatus !== null && previousStatus.type === 'production'))) {
						result.push(status);
					}

					status = nextStatus;
				}
			}

			return result;
		}

		function getProposalFilters() {
			var result = [];

			var firstStatus = getFirstStatus();
			var previousStatus = getPreviousStatus(firstStatus.id);


			while (previousStatus !== null) {
				if (previousStatus.type === 'proposal') {
					result.unshift(previousStatus);
				}
				previousStatus = getPreviousStatus(previousStatus.id);
			}

			return result;
		}

		function getFirstStatus() {
			for (var i = 0; i < service.queue.length; i++) {
				var status = service.queue[i];
				if (status.type === 'default') {
					return status;
				}
			}

			return service.queue[0];
		}

		function getStatusByMappedProdStatus(productionOrderStatus) {
			for (var i = 0; i < service.queue.length; i++) {
				var statusObject = service.queue[i];

				if (statusObject.productionRef === productionOrderStatus && statusObject.id !== null) {
					return statusObject.id;
				}
			}

			return null;
		}

		function getPreProductionState() {
			for (var i = 0; i < service.queue.length; i++) {
				if (nuitOrders.getNextStatus(service.queue[i].id).type === 'production') {
					return service.queue[i].id;
				}
			}

			return 1;
		}

		function updateLocalOrderStatus(orderIds, status) {
			for (var i = 0; i < _orders.length; i++) {
				var order = _orders[i];
				if (orderIds.indexOf(parseInt(order.id, 10)) !== -1) {
					order.status = status.toString();
				}
			}
		}

		function isInProduction(status) {
			return nuitOrders.getStatusById(status).type === 'production';
		}

		function getStatusQueryParams(array, excludeByAttribute) {
			var ids = [];

			for (var i = 0; i < array.length; i++) {
				var status = array[i];
				var valid = true;

				for (var key in excludeByAttribute) {
					valid = valid && status[key] !== excludeByAttribute[key] && status.type !== 'proposal';
				}

				if (valid) {
					ids.push(status.id);
				}
			}

			return ids.join(',');
		}

		function getArchiveId() {
			var status = nuitOrders.getStatusByType('archive');
			return status !== null ? status.id : -1;
		}

		function addProfile(order, profile) {
			return nuitApi('order.profile.add', order.id).post(profile)
				.then(function (response) {
					return response.data;
				});
		}

		function addProduct(order, product){
			return nuitApi('order.product.add',order.id).post(product)
				.then(function(response){
					return response.data;
				});
		}

		function addSpecial(order, special){
			return nuitApi('order.special.add',order.id).post(special)
				.then(function(response) {
					return response.data;
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('OrderQueryService', OrderQueryService);

	/** @ngInject */
	function OrderQueryService(nuitConfig, nuitAuth, OrderService, $filter, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _config = nuitConfig.current;
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			// Orders
			reload: reload,
			getTitle: getTitle,
			getTitleById: getTitleById,
			getStatusArrayForLoading: getStatusArrayForLoading
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'useBackend', {
			get: function () {
				return _config.ims.orders.backendQuery;
			}
		});
		Object.defineProperty(service, 'showPosNumber', {
			get: function(){
				return nuitAuth.getEvoVersion()===2;
			}
		});
		//************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		/**
		 * Reloads all orders.
		 * @returns {Promise}
		 */
		function reload(filter) {
			if(!service.useBackend){
				return OrderService.reload(filter);
			}else{
				return OrderService.reloadPaged(filter);
			}
		}

		function getTitle(order){
			if(service.useBackend){
				return order.title;
			}else{
				return $filter('nuitFormatter')(_config.ims.orders.nameFormat,order);
			}
		}

		function getTitleById(orderId){
			var order = nuitDataService.getOne(OrderService.orders,orderId);
			if(order) {
				return getTitle(order);
			}else{
				return '-';
			}
		}

		function getStatusArrayForLoading(statusId){
			var status = [statusId];

			var nextStatus = OrderService.getNextStatus(statusId);

			while(nextStatus!==null && nextStatus.type === 'production') {
				status.push(nextStatus.id);
				nextStatus = OrderService.getNextStatus(nextStatus.id);
			}

			return status;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('OfferService', OfferService);

	/** @ngInject */
	function OfferService(nuitApi, $log, $filter, nuitConfig, nuitUtils, nuitDataService, nuitOrders, $q, $state) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _orders = [];
		var _meta = {pagination:{total:0, current_page:1, per_page: 20}};
		var _config = nuitConfig.current;
		var _statusCount = [];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			// Orders
			reload: reload,
			reloadPaged: reloadPaged,
			hasRelations: hasRelations,
			loadRelations: loadRelations,
			loadOrder: loadOrder,
			deleteOrder: deleteOrder,
			updateOrder: updateOrder,
			getOrderPositions: getOrderPositions,
			moveToNextStatus: moveToNextStatus,
			moveToPreviousStatus: moveToPreviousStatus,
			// Status
			reloadConfig: nuitOrders.reloadConfig,
			addStatus: addStatus,
			deleteStatus: deleteStatus,
			updateStatus: updateStatus,
			getStatusById: nuitOrders.getStatusById,
			getPreviousStatus: getPreviousStatus,
			getNextStatus: nuitOrders.getNextStatus,
			getOrderFilters: getOrderFilters,
			getQueueFilters: getQueueFilters,
			getStatusByMappedProdStatus: getStatusByMappedProdStatus,
			updateLocalOrderStatus: updateLocalOrderStatus,
			getPreProductionState: getPreProductionState,
			isInProduction: isInProduction,
			isInPostProduction: isInPostProduction,
			getArchiveId: getArchiveId,
			getStatusQueryParams: getStatusQueryParams,
			getStatusByType: nuitOrders.getStatusByType,
			getStatisByType: nuitOrders.getStatisByType,
			addProfile: addProfile,
			addProduct: addProduct,
			addSpecial: addSpecial,
			offerCountByStatus: offerCountByStatus,
			getStatusCountById: getStatusCountById,
			clear: clear
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'orders', {
			get: function () {
				return _orders;
			}
		});
		Object.defineProperty(service, 'meta', {
			get: function () {
				return _meta;
			}
		});

		Object.defineProperty(service, 'orderFilters', {get: getOrderFilters});
		Object.defineProperty(service, 'queueFilters', {get: getQueueFilters});
		Object.defineProperty(service, 'offerFilters', {get: getOfferFilters});

		Object.defineProperty(service, 'queue', {
			get: function () {
				return nuitOrders.queue;
			}
		});
		Object.defineProperty(service, 'statusLoading', {
			get: function () {
				return nuitOrders.statusLoading;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		/**
		 * Reloads all orders.
		 * @returns {Promise}
		 */
		function reload(filter) {
			return nuitApi('offer.all')
				.get(filter)
				.then(function (response) {
					_orders.splice(0, _orders.length);
					angular.extend(_orders, response.data);
					return _orders;
				});
		}

		function reloadPaged(filter) {
			/*return nuitApi('offer.all')
				.get(filter)
				.then(function (response) {
					_orders.splice(0, _orders.length);
					angular.extend(_orders, response.data);
					return _orders;
				});*/


			return nuitApi('offer.all.v2')
				.get(filter)
				.then(function (response) {
					var oldOffers = [];
					angular.copy(_orders,oldOffers);
					if(response.data.meta){
						angular.extend(_meta,response.data.meta);
					}
					_orders.splice(0,_orders.length);
					if(response.data.data) {
						var startIndex = (_meta.pagination.current_page-1)*_meta.pagination.per_page
						var endIndex = startIndex + _meta.pagination.per_page - 1;
						for(var i=0;i<_meta.pagination.total;i++){
							var oldOrder = oldOffers.shift();
							if(i>=startIndex && i<=endIndex){
								_orders.push(response.data.data.shift());
							}else {
								if(oldOrder) {
									_orders.push(oldOrder);
								}else{
									_orders.push({id:-i});
								}
							}
						}
					}
				});
		}

		function clear(){
			_orders.splice(0, _orders.length);
			angular.extend(_orders, []);
		}

		function hasRelations(offer){
			return offer.orderIds.length > 0;
		}

		function loadRelations(offer){
			var promises = [];
			var orders = {
				title: 'OFFERS.CREATED_ORDERS',
				state: 'app.orders.detail',
				urlId: 'orderId',
				getTitle: function(order){
						if(_config.ims.orders.backendQuery){
							return order.title;
						}else{
							return $filter('nuitFormatter')(_config.ims.orders.nameFormat,order);
						}
					},
				ordersOrOffer:[]
			};

			for (var i in offer.orderIds){
				promises.push(
					 nuitApi('order.detail', offer.orderIds[i])
					.get()
					.then(function (response){
							orders.ordersOrOffer.push(response.data);
					})
				);
			}
			return $q.all(promises)
				.then(function (){
					return orders;
				});

		}

		function addStatus(status) {
			return nuitApi('offer.status')
				.post(status)
				.then(function (response) {
					nuitOrders.queue.push(response.data);
				});
		}

		function updateStatus(status) {
			return nuitApi('offer.status.one', status.id)
				.put(status)
				.then(function (response) {
					nuitDataService.updateOne(nuitOrders.queue, response.data);
				});
		}

		function deleteStatus(status) {
			return nuitApi('offer.status.one', status.id)
				.delete()
				.then(function (response) {
					nuitDataService.removeOne(nuitOrders.queue, status.id);
				});
		}

		/**
		 * Deletes the given order.
		 * @param {Object} order
		 * @returns {Promise}
		 */
		function deleteOrder(order) {
			return nuitApi('offer.detail', order.id)
				.delete()
				.then(function (response) {
					return nuitDataService.removeOne(_orders, order.id);
				});
		}

		/**
		 * Returns the order with the given id.
		 * @param id - id of the order
		 * @return {Promise}
		 */
		function loadOrder(id) {
			return nuitApi('offer.detail', id)
				.get()
				.then(function (response) {
					return response.data;
				})
				.catch(function (error) {
					$log.warn('Error loading cart details');
					throw new Error(error);
				});
		}

		/**
		 * Sends updated order to remote server.
		 * @param {Object} order
		 */
		function updateOrder(order) {
			return nuitApi('offer.update', order.id)
				.put(order)
				.then(function (response) {
					return nuitDataService.updateOne(_orders, response.data);
				});
		}

		/**
		 * Returns the number of positions inside an order.
		 * @param {Object} order
		 * @returns {Number}
		 */
		function getOrderPositions(order) {
			var count = 0;

			if (angular.isArray(order.products)) {
				count += order.products.length;
			}else if(order.profilesCount){
				count += order.profilesCount;
			}

			if (angular.isArray(order.profiles)) {
				count += order.profiles.length;
			}else if(order.productsCount){
				count += order.productsCount;
			}

			return count;
		}

		/**
		 * Returns the status config object which is one step
		 * bevor the one with the given id or null if no such
		 * status config exists.
		 * @param {Number} id - status id
		 * @return {Object}
		 */
		function getPreviousStatus(id) {
			for (var i in service.queue) {
				var statusConfig = service.queue[i];
				if (statusConfig.transitionTo === id) {
					return statusConfig;
				}
			}

			return null;
		}

		function isInPostProduction(id) {
			var statusObj = nuitOrders.getStatusById(id);
			while (statusObj !== null && !isInProduction(statusObj.id)) {
				statusObj = getPreviousStatus(statusObj.id);
			}

			return statusObj !== null;
		}

		/**
		 * Moves the given order to the next state.
		 * @param {Object} order
		 * @return {Promises}
		 */
		function moveToNextStatus(order) {
			var state = nuitOrders.getNextStatus(order.status);

			if(state.type !== 'proposal'){
				return nuitApi('offer.toOrder', order.id)
					.post()
					.then(function (res){
						$state.go('app.orders.detail', {orderId: res.data.id});
					});

			}else{
				return nuitApi('offer.update.status', order.id)
					.put({status: String(state.id)})
					.then(function(response){
						return nuitDataService.updateOne(_orders,response.data);
					});
			}


		}

		function moveToPreviousStatus(order) {
			var state = getPreviousStatus(order.status);

			return nuitApi('offer.update.status', order.id)
				.put({status: String(state.id)})
				.then(function(response){
					return nuitDataService.updateOne(_orders,response.data);
				});
		}

		/**
		 * Returns an array containing all
		 * statis which should be displayed
		 * as filters in the orders list
		 * ordered by their status.
		 * @return {Array}
		 */
		function getOrderFilters() {
			var result = [];

			if (service.queue.length > 0) {
				var status = getFirstStatus();
				while (validStatus(status)) {
					if (status.type !== 'production') {
						result.push(status);
					}
					if (status.transitionTo === undefined) {
						status = nuitOrders.getStatusById(service.queue.indexOf(status) + 1);
					} else {
						status = nuitOrders.getStatusById(status.transitionTo);
					}
				}

				if(status) {
					result.push(status);
				}
			}

			return result;
		}

		function validStatus(status){
			return status!==null && status.type !== 'archive';
		}

		/**
		 * Returns an array containing all
		 * statis which should be displayed
		 * as filters in the production queue list
		 * ordered by their status.
		 * @return {Array}
		 */
		function getQueueFilters() {
			var result = [];

			if (service.queue.length > 0) {
				var status = getFirstStatus();
				while (validStatus(status)) {
					var nextStatus = null;
					var previousStatus = null;
					if (status.transitionTo === undefined) {
						var currentStatusIndex = service.queue.indexOf(status);
						nextStatus = nuitOrders.getStatusById(currentStatusIndex + 1);
						previousStatus = currentStatusIndex === 0 ? null : nuitOrders.getStatusById(currentStatusIndex - 1);
					} else {
						nextStatus = nuitOrders.getStatusById(status.transitionTo);
						previousStatus = getPreviousStatus(status.id);
					}

					if (
						(status && !nextStatus) || (
						status.type === 'production' ||
						nextStatus.type === 'production' ||
						(previousStatus !== null && previousStatus.type === 'production'))) {
						result.push(status);
					}

					status = nextStatus;
				}
			}

			return result;
		}

		function getOfferFilters() {
			var result = [];

			var firstStatus = getFirstStatus();
			var previousStatus = getPreviousStatus(firstStatus.id);


			while (previousStatus !== null) {
				if (previousStatus.type === 'proposal') {
					result.unshift(previousStatus);
				}
				previousStatus = getPreviousStatus(previousStatus.id);
			}

			return result;
		}

		function getFirstStatus() {
			for (var i = 0; i < service.queue.length; i++) {
				var status = service.queue[i];
				if (status.type === 'default') {
					return status;
				}
			}

			return service.queue[0];
		}

		function getStatusByMappedProdStatus(productionOrderStatus) {
			for (var i = 0; i < service.queue.length; i++) {
				var statusObject = service.queue[i];

				if (statusObject.productionRef === productionOrderStatus && statusObject.id !== null) {
					return statusObject.id;
				}
			}

			return null;
		}

		function getPreProductionState() {
			for (var i = 0; i < service.queue.length; i++) {
				if (nuitOrders.getNextStatus(service.queue[i].id).type === 'production') {
					return service.queue[i].id;
				}
			}

			return 1;
		}

		function updateLocalOrderStatus(orderIds, status) {
			for (var i = 0; i < _orders.length; i++) {
				var order = _orders[i];
				if (orderIds.indexOf(parseInt(order.id, 10)) !== -1) {
					order.status = status.toString();
				}
			}
		}

		function isInProduction(status) {
			return nuitOrders.getStatusById(status).type === 'production';
		}

		function getStatusQueryParams(array, excludeByAttribute) {
			var ids = [];

			for (var i = 0; i < array.length; i++) {
				var status = array[i];
				var valid = true;

				for (var key in excludeByAttribute) {
					valid = valid && status[key] !== excludeByAttribute[key] && status.type !== 'proposal';
				}

				if (valid) {
					ids.push(status.id);
				}
			}

			return ids.join(',');
		}

		function getArchiveId() {
			var status = nuitOrders.getStatusByType('archive');
			return status !== null ? status.id : -1;
		}

		function addProfile(order, profile) {
			return nuitApi('offer.profile.add', order.id).post(profile)
				.then(function (response) {
					return response.data;
				});
		}

		function addProduct(order, product){
			return nuitApi('offer.product.add',order.id).post(product)
				.then(function(response){
					return response.data;
				});
		}

		function addSpecial(order, special){
			return nuitApi('offer.special.add',order.id).post(special)
				.then(function(response) {
					return response.data;
				});
		}

		function offerCountByStatus(queryParams){
			return nuitApi('offer.count.by.status').get(queryParams)
				.then(function(response){
					return nuitDataService.replaceAll(_statusCount, response.data);
				});
		}

		function getStatusCountById(id){
			for(var i=0;i<_statusCount.length;i++){
				var statusCount = _statusCount[i];
				if(statusCount.status===id){
					return statusCount.offers;
				}
			}

			return 0;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('OfferQueryService', OfferQueryService);

	/** @ngInject */
	function OfferQueryService(nuitConfig,nuitAuth,OfferService, $filter, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _config = nuitConfig.current;
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			// Orders
			reload: reload,
			getTitle: getTitle,
			getTitleById: getTitleById
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'useBackend', {
			get: function () {
				return _config.ims.offers.backendQuery;
			}
		});
		Object.defineProperty(service, 'showPosNumber', {
			get: function(){
				return nuitAuth.getEvoVersion()===2;
			}
		});
		//************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		/**
		 * Reloads all orders.
		 * @returns {Promise}
		 */
		function reload(filter) {
			if(!service.useBackend){
				return OfferService.reload(filter);
			}else{
				return OfferService.reloadPaged(filter);
			}
		}

		function getTitle(order){
			if(service.useBackend){
				return order.title;
			}else{
				return $filter('nuitFormatter')(_config.ims.offers.nameFormat.length>0?_config.ims.offers.nameFormat:_config.ims.orders.nameFormat,order);
			}
		}

		function getTitleById(orderId){
			var order = nuitDataService.getOne(OfferService.orders,orderId);
			if(order) {
				return getTitle(order);
			}else{
				return '-';
			}
		}


	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('imsUtils', imsUtilsService);

	/** @ngInject */
	function imsUtilsService($mdDialog, $http, $timeout, nuitUtils, nuitApi, nuitApiProxy, nuitConfig, SpecialProcessing, nuitAuth) {
		// Feature flag: crop oversized sketch SVGs to their content's bounding box on
		// download / open / preview. Disabled for now — flip to true to re-enable.
		var CROP_SVG_WHITESPACE = false;

		//*******************************************
		// SERVICE
		//*******************************************
		var service = angular.copy(nuitUtils);
		service.openEditor = openEditor;
		service.openEditorAndSave = openEditorAndSave;
		service.openEditorAndSaveMultiple = openEditorAndSaveMultiple;
		service.openEditorAndSaveMultipleDefault = openEditorAndSaveMultipleDefault;
		service.openMaterialSelectionDialog = nuitUtils.showMaterialDialog;
		service.uploadEnvImage = uploadEnvImage;
		service.uploadProductImage = uploadProductImage;
		service.uploadProductAttachment = uploadProductAttachment;
		service.uploadToNodeRedFlow = uploadToNodeRedFlow;
		service.openImage = openImage;
		service.openGlb = openGlb;
		service.showImageUploadDialog = nuitUtils.showImageUploadDialog;
		service.openUserSelection = openUserSelection;
		service.getDocumentURL = getDocumentURL;
		service.downloadDocument = downloadDocument;
		service.openDocument = openDocument;
		service.fetchDocumentBlob = fetchDocumentBlob;
		service.openUserSignup = openUserSignup;
		service.openFolderCopy = openFolderCopy;
		service.openEvoVersionDialog = openEvoVersionDialog;
		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// OBJECT CONSTANTS
		//*******************************************
		function createEditorDialog(profile, showMaterials, materialRequired, allowSave, allowOpen) {
			return {
				controller: 'EditorDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/editor/editor-dialog.html',
				parent: document.body,
				clickOutsideToClose: false,
				autoWrap: false,
				multiple: true,
				locals: {
					Profile: profile,
					ShowMaterials: showMaterials!==undefined?showMaterials:true,
					MaterialRequired: materialRequired!==undefined?materialRequired: false,
					Options:{
						allowSave: allowSave!==undefined?allowSave:false,
						allowOpen: allowOpen!==undefined?allowOpen:false
					}
				}
			};
		}

		//*******************************************
		// METHODS
		//*******************************************
		function openEditor(profile,showMaterials, materialRequired, allowSave, allowOpen) {
			return $mdDialog.show(createEditorDialog(profile,showMaterials, materialRequired, allowSave, allowOpen));
		}

		function openEditorAndSave(profile,showMaterials, materialRequired, allowSave, allowOpen) {
			return openEditor(angular.copy(profile),showMaterials, materialRequired, allowSave,allowOpen)
				.then(function (newProfile) {
					if (typeof newProfile !== 'undefined') {
						newProfile.materialId = newProfile.material.id;

						if (nuitConfig.current.evo.cart.allowSpecials) {
							SpecialProcessing.applySpecials(newProfile);
						}

						return nuitApi('profiles.update.one', profile.id).put(newProfile)
							.then(function (response) {
								return updateProfile(profile,response.data);
							});
					}
				});
		}

		function updateProfile(oldProfile,newProfile)
		{
			for (var prop in oldProfile) {
				if (prop === 'positions') {
					continue;
				}
				else {
					delete oldProfile[prop];
				}
			}

			angular.merge(oldProfile, newProfile);

			return oldProfile;
		}

		function openEditorAndSaveMultipleDefault(profile,allowSave, allowOpen)
		{
			var positions = [];

			for(var i=0;i<profile.positions.length;i++)
			{
				if(profile.positions[i].hasOwnProperty('id')) {
					positions.push(profile.positions[i]);
				}
			}

			return openEditorAndSaveMultiple(profile,positions,allowSave, allowOpen);
		}

		function openEditorAndSaveMultiple(profile,positions, allowSave, allowOpen)
		{
			var profileCopy = angular.copy(profile);

			if(profile.positions) {
				profileCopy.length = profile.positions[0].length;
			}
			
			return openEditor(profileCopy,undefined,true,allowSave,allowOpen)
				.then(function(newProfile){
					if(typeof newProfile!=='undefined')
					{
						newProfile.materialId = newProfile.material.id;

						if (nuitConfig.current.evo.cart.allowSpecials) {
							SpecialProcessing.applySpecials(newProfile);
						}

						positions[0].length = newProfile.length;

						return nuitApiProxy('profiles.update.multiple').put({positions:positions,profile:newProfile})
							.then(function(response){
								return updateProfile(profile,response.data[0]);
							});
					}
				});
		}

		function uploadProductImage(includeAllResponseData)
		{
			return service.showImageUploadDialog('products.image',includeAllResponseData, nuitConfig.current.ims.attachments.acceptedMimeTypes, nuitConfig.current.ims.attachments.maxSize);
		}

		function uploadProductAttachment(includeAllResponseData)
		{
			return service.showImageUploadDialog('products.attachment',includeAllResponseData, nuitConfig.current.ims.attachments.acceptedMimeTypes, nuitConfig.current.ims.attachments.maxSize);
		}

		function uploadToNodeRedFlow(routeArguments, acceptedMimeTypes, maxSize)
		{
			return service.showImageUploadDialog('exchange.apps.nodered.flow.upload',false, acceptedMimeTypes, maxSize,routeArguments);
		}

		function uploadEnvImage(includeAllResponseData)
		{
			return service.showImageUploadDialog('env.image',includeAllResponseData, nuitConfig.current.ims.attachments.acceptedMimeTypes, nuitConfig.current.ims.attachments.maxSize);
		}

		function openImage(image) {
			$mdDialog.show(createProfileDialog(image));
		}

		function openGlb(url) {
			return $mdDialog.show({
				controller: 'GlbDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/glb/glb.html',
				clickOutsideToClose: true,
				multiple: true,
				locals: {
					url: url
				}
			});
		}

		function createProfileDialog(image) {
			return {
				controller: 'ImageController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/image/image.html',
				clickOutsideToClose: true,
				multiple: true,
				locals: {
					image: image
				}
			};
		}

		function openUserSelection(users,dialogConfig){
			return $mdDialog.show(createUserSelection(users,dialogConfig));
		}

		function createUserSelection(users, dialogConfig) {
			return {
				controller: 'UserSelectionController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/user.selection/user.selection.html',
				clickOutsideToClose: true,
				multiple: true,
				locals: {
					Users: users,
					DialogConfig: dialogConfig
				}
			};
		}

		function getDocumentURL(documentObj) {
			if (documentObj && documentObj.url) {
				return buildUrl(documentObj.url);
			} else if (documentObj && documentObj.href) {
				return buildUrl(documentObj.href);
			} else {
				return '';
			}
		}

		function buildUrl(url) {
			return url + '?access-token=' + nuitAuth.getToken();
		}

		// Fetches a resource as a blob (auth via the http interceptor, like the http-src
		// directive). When CROP_SVG_WHITESPACE is on, oversized sketch SVGs are cropped to
		// their content's bounding box so they don't render as mostly empty space.
		// Resolves with { blob, contentType, name, serverName } - serverName is the
		// Content-Disposition filename, or null if missing or not exposed via CORS.
		function fetchDocumentBlob(url, filename) {
			return $http.get(url, { responseType: 'arraybuffer' }).then(function (response) {
				var contentType = response.headers('Content-Type');
				var data = response.data;
				if (contentType && contentType.indexOf('svg') !== -1) {
					contentType = 'image/svg+xml';
					if (CROP_SVG_WHITESPACE) {
						data = cropSvgWhitespace(arrayBufferToUtf8(response.data));
					}
				}
				var name = filename || 'download';
				if (contentType && name.indexOf('.') === -1) {
					var ext = contentType.split(';')[0].split('/')[1].split('+')[0];
					if (ext) { name += '.' + ext; }
				}
				return {
					blob: new Blob([data], { type: contentType }),
					contentType: contentType,
					name: name,
					serverName: parseDispositionFilename(response.headers('Content-Disposition'))
				};
			});
		}

		// Reads the filename from a Content-Disposition header, preferring the
		// RFC 5987 form (filename*=UTF-8''...). Returns null if there is none.
		function parseDispositionFilename(disposition) {
			if (!disposition) { return null; }

			var extended = /filename\*\s*=\s*([^']*)''([^;]+)/i.exec(disposition);
			if (extended) {
				try {
					return decodeURIComponent(extended[2].trim());
				} catch (e) {
					// malformed encoding - fall through to the plain filename
				}
			}

			var plain = /filename\s*=\s*("([^"]*)"|[^;]+)/i.exec(disposition);
			if (plain) {
				var value = (angular.isDefined(plain[2]) ? plain[2] : plain[1]).trim();
				return value || null;
			}

			return null;
		}

		// Fetches the resource as a blob and triggers a client-side download. Needed because
		// the plain "download" attribute is ignored for cross-origin URLs (the API host), so
		// the browser would just navigate to the file instead of saving it.
		// With options.preferServerName the Content-Disposition filename wins over
		// `filename`, which then only serves as fallback.
		function downloadDocument(url, filename, options) {
			if (!url) { return; }
			return fetchDocumentBlob(url, filename).then(function (doc) {
				if (options && options.preferServerName && doc.serverName) {
					doc.name = doc.serverName;
				}

				if (window.navigator.msSaveOrOpenBlob) {
					window.navigator.msSaveOrOpenBlob(doc.blob, doc.name);
				} else {
					var objectURL = window.URL.createObjectURL(doc.blob);
					var a = document.createElement('a');
					a.href = objectURL;
					a.download = doc.name;
					document.body.appendChild(a);
					a.click();
					$timeout(function () {
						window.URL.revokeObjectURL(objectURL);
						document.body.removeChild(a);
					}, 0);
				}
			});
		}

		// Opens the resource in a new tab. With cropping off there's nothing to rewrite, so we
		// open the URL directly — the original, reliable native path (no blob/popup quirks).
		// With cropping on we fetch, rewrite, and show the result as a blob URL; the blank tab
		// is opened synchronously (before the async fetch) so the browser keeps it tied to the
		// user gesture and doesn't block it.
		function openDocument(url, filename) {
			if (!url) { return; }
			if (!CROP_SVG_WHITESPACE) {
				window.open(getDocumentURL({ url: url }), '_blank');
				return;
			}
			var tab = window.open('', '_blank');
			return fetchDocumentBlob(url, filename).then(function (doc) {
				var objectURL = window.URL.createObjectURL(doc.blob);
				if (tab) {
					tab.location.href = objectURL;
				} else {
					window.open(objectURL, '_blank');
				}
				// Give the tab time to load before releasing the blob URL.
				$timeout(function () { window.URL.revokeObjectURL(objectURL); }, 60000);
			});
		}

		// Decode an ArrayBuffer of UTF-8 text (SVG markup) into a string.
		function arrayBufferToUtf8(buffer) {
			if (typeof TextDecoder !== 'undefined') {
				return new TextDecoder('utf-8').decode(new Uint8Array(buffer));
			}
			var bytes = new Uint8Array(buffer);
			var chars = [];
			for (var i = 0; i < bytes.length; i++) {
				chars.push(String.fromCharCode(bytes[i]));
			}
			return decodeURIComponent(escape(chars.join('')));
		}

		// Crops an SVG's viewBox/width/height to the tight bounding box of its content,
		// removing the surrounding whitespace. getBBox() requires the node to be rendered,
		// so we measure it off-screen. Returns the original markup if anything goes wrong.
		function cropSvgWhitespace(svgText, padding) {
			var pad = padding == null ? 8 : padding;
			var host = null;
			try {
				var doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');
				var svg = doc.documentElement;
				if (!svg || svg.nodeName.toLowerCase() !== 'svg' ||
					doc.getElementsByTagName('parsererror').length) {
					return svgText;
				}
				var node = document.importNode(svg, true);
				host = document.createElement('div');
				host.style.cssText = 'position:absolute;left:-99999px;top:0;width:0;height:0;overflow:hidden;';
				host.appendChild(node);
				document.body.appendChild(host);

				var box = node.getBBox();
				if (!box || !isFinite(box.width) || !isFinite(box.height) ||
					box.width === 0 || box.height === 0) {
					return svgText;
				}
				var x = box.x - pad;
				var y = box.y - pad;
				var w = box.width + pad * 2;
				var h = box.height + pad * 2;
				node.setAttribute('viewBox', x + ' ' + y + ' ' + w + ' ' + h);
				node.setAttribute('width', w);
				node.setAttribute('height', h);
				return new XMLSerializer().serializeToString(node);
			} catch (e) {
				return svgText;
			} finally {
				if (host && host.parentNode) { document.body.removeChild(host); }
			}
		}

		function openUserSignup(roleType, companyId){
			return $mdDialog.show({
				controller: 'SignupController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/registration/signup.html',
				clickOutsideToClose: true,
				multiple: true,
				locals: {
					RoleType: roleType,
					CompanyId: companyId || null
				}
			});
		}
		function openFolderCopy(){
			return $mdDialog.show(createFolderCopyDialog());
		}

		function createFolderCopyDialog() {
			return {
				controller: 'FolderCopyController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/folder.copy/folder.copy.html',
				clickOutsideToClose: true,
				multiple: false,
			};
		}

		function openEvoVersionDialog(){
			return $mdDialog.show(createEvoVersionDialog());
		}

		function createEvoVersionDialog() {
			return {
				controller: 'EvoVersionController',
				controllerAs: 'vm',
				templateUrl: 'app/ims/dialogs/evo.version/evo.version.html',
				clickOutsideToClose: true,
				multiple: false,
			};
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('imsUnit', imsUnitService);

	/** @ngInject */
	function imsUnitService(nuitConfig) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var config = {};
        //*******************************************
        
		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			getLength: getLength,
			getWeight: getWeight,
			getWeight2: getWeight2
		};
        //*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
        Object.defineProperty(service, 'thickness', {
			get: getThickness
		});
        Object.defineProperty(service, 'thicknessStep', {
			get: getThicknessStep
		});
        Object.defineProperty(service, 'pressure', {
			get: getPressure
		});
        Object.defineProperty(service, 'pressureStep', {
			get: getPressureStep
		});
		Object.defineProperty(service, 'length', {
			get: getLength
		});
		Object.defineProperty(service, 'weight', {
			get: getWeight
		});
		Object.defineProperty(service, 'weight2', {
			get: getWeight2
		});
        //*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
        //*******************************************

		//*******************************************
		return service;
		//*******************************************

        ////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			config = nuitConfig.getCurrent();
		}
        
        function getThickness() {
            return config.units.thickness.symbol;
        }
        
        function getThicknessStep() {
            return (1 / Math.pow(10, config.units.thickness.decimals)).toString();
        }
        
		function getLength() {
			return config.unit || 'mm';
		}
        
        function getPressure() {
            return config.units.pressure.symbol;
        }
        
        function getPressureStep() {
            return (1 / Math.pow(10, config.units.pressure.decimals)).toString();
        }

		function getWeight() {
			return config.units.weight.symbol || 'kg';
		}

		function getWeight2() {
			return config.units.pressure.symbol || 'kg/m²';
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('imsTranslationService', ImsTranslationService);

	function ImsTranslationService() {

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			containsSearchText: containsSearchText
		};

		//*******************************************
		return service;
		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************
		function containsSearchText(translation, searchText) {
			searchText = searchText.toLowerCase();

			if (searchText === undefined || searchText === '' || translation.key.toLowerCase().indexOf(searchText) >= 0) {
                return true;
            }

			for (var languageCode in translation.values) {
				if (translation.values[languageCode].toLowerCase().indexOf(searchText) >= 0) {
					return true;
				}   
			}

			return false;
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('imsNextChannel', ImsNextChannelService);

	/** @ngInject */
	function ImsNextChannelService($rootScope, $window, nuitAuth, nuitConfig) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var channel = window.IFrameChannel.createIFrameChannel('ims-navigation', {
			autoConnect: false
		});
		var lastLoadedConfig = null;

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			isConnected: isConnected,
			navigateTo: navigateTo
		};

		//*******************************************
		// GETTERS
		//*******************************************
		Object.defineProperty(service, 'channel', {
			get: function () {
				return channel
			}
		})

		//*******************************************
		// EVENTS
		//*******************************************
		$rootScope.$on(nuitAuth.EVENTS.LoginSuccess, onLoginSuccess);
		$rootScope.$on(nuitConfig.EVENTS.ConfigLoaded, onConfigLoaded);

		//*******************************************
		return service;
		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************
		function connect() {
			channel.$.connect()
		}

		/**
		 * Whether ims is rendered inside the ims next iframe.
		 * @returns {boolean}
		 */
		function isEmbedded() {
			return $window.self !== $window.top && $window.sessionStorage.getItem('mode') === 'content';
		}

		/**
		 * Whether ims is embedded into ims next and the channel is ready.
		 * @returns {boolean}
		 */
		function isConnected() {
			return channel.$.status === 'connected';
		}

		/**
		 * Asks the embedding host (ims next) to navigate to the given path.
		 * @param {string} path
		 * @returns {boolean} true if the host took over the navigation
		 */
		function navigateTo(path) {
			if (!isConnected()) {
				return false;
			}

			channel.navigation(encodeURIComponent(path));

			return true;
		}

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Connects to the embedding host (ims next) only once the session of the login url is in place. Until then the
		 * token of a previous session may still be stored and a navigation request from the host would load its data.
		 */
		function onLoginSuccess() {
			if (isEmbedded()) {
				connect();
			}
		}

		/**
		 * Notifies the embedding host (ims next) whenever a reloaded config differs from the last one it has been told about.
		 * @param {Object} event
		 * @param {Object} config
		 */
		function onConfigLoaded(event, config) {
			var loadedConfig = angular.toJson(config);

			if (lastLoadedConfig === null) {
				lastLoadedConfig = loadedConfig;
				return;
			}

			if (loadedConfig === lastLoadedConfig || !isConnected()) {
				return;
			}

			lastLoadedConfig = loadedConfig;
			channel.configurationChanged();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('imsConfig', ImsConfigService);

	/** @ngInject */
	function ImsConfigService(nuitConfig,OrderService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var config = nuitConfig.getCurrent();

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			getDecimals: getDecimals,
            isProductionStatus: isProductionStatus,
            isQueueStatus: isQueueStatus,
			hasPermissions: hasPermissions,
			getCurrent: nuitConfig.getCurrent,
			reload: nuitConfig.reload
		};

		//*******************************************
		return service;
		//*******************************************

		//*******************************************
		// METHODS
		//*******************************************
		function getDecimals(key) {
			return nuitConfig.getCurrent().decimals[key];
		}

        function isProductionStatus(index) {
            index = parseInt(index);
            if(index < 0 || index >= OrderService.queue.length) { return false; }
            return OrderService.queue[index].type === 'production';
        }

        function isQueueStatus(index) {
            index = parseInt(index);
            return isProductionStatus(index) || isProductionStatus(index+1);
        }

		function hasPermissions(permission) {
			var currentConfig = nuitConfig.getCurrent();
			var keys = permission.toString().split('.');
			var result = currentConfig;

			for(var i in keys){
				result = result[keys[i]];
			}

			return result;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('GenericRequestService', GenericRequestService);

	/** @ngInject */
	function GenericRequestService(nuitApi, nuitDataService, nuitUtils) {
		var _serviceInstances = {};

		var service = initService();

		return service;

		function initService() {
			return {
				get: get
			};
		}

		/**
		 * @param id to return distinct selector instances
		 * @param routes, get,add,update,remove routes {getAll: '', add:'', update:'', remove:''}
		 * @param clearEntities clear previously requested entities
		 * @returns {Service}
		 */
		function get(id, routes, clearEntities) {
			if (!_serviceInstances[id]) {
				_serviceInstances[id] = initInstance(routes);
			}

			if (clearEntities) {
				_serviceInstances[id].entities = [];
			}

			return _serviceInstances[id];
		}

		function initInstance(routes) {

			return init();

			function init() {
				var instance = {};

				instance._routes = routes;
				instance._entities = [];

				Object.defineProperty(instance, 'entities', {
					get: function () {
						return instance._entities;
					},
					set: function (value) {
						nuitDataService.replaceAll(instance._entities, value);
					}
				});

				var standardRoutes = {
					getAll: getAll,
					get: get,
					add: add,
					update: update,
					remove: remove
				}

				for (var key in standardRoutes) {
					if (instance._routes.hasOwnProperty(key)) {
						instance[key] = standardRoutes[key];
					}
				}

				return instance;

				function getAll(parentId) {
					return getRoute(instance._routes.getAll, undefined, parentId)
						.get()
						.then(function (response) {
							return nuitDataService.replaceAll(instance._entities, response.data);
						})
						.catch(nuitUtils.showErrorToast);
				}

				function get(entityId, parentId) {
					return getRoute(instance._routes.get, entityId, parentId)
						.get()
						.then(function (response) {
							var entity = nuitDataService.getOne(instance._entities, entityId);

							if (entity) {
								return nuitDataService.replaceOneEntity(entity, response.data);
							} else {
								return nuitDataService.addOne(instance._entities, response.data);
							}
						})
						.catch(nuitUtils.showErrorToast);
				}

				function add(entity, parentId) {
					return getRoute(instance._routes.add, entity.id, parentId)
						.post(entity)
						.then(function (response) {
							return nuitDataService.addOne(instance._entities, response.data);
						})
						.catch(nuitUtils.showErrorToast);
				}

				function update(entity, parentId) {
					return getRoute(instance._routes.update, entity.id, parentId)
						.put(entity)
						.then(function (response) {
							return nuitDataService.replaceOne(instance._entities, response.data);
						})
						.catch(nuitUtils.showErrorToast);
				}

				function remove(entity, parentId) {
					return getRoute(instance._routes.remove, entity.id, parentId)
						.delete()
						.then(function (response) {
							return nuitDataService.removeOne(instance._entities, entity.id);
						})
						.catch(nuitUtils.showErrorToast);
				}
			}
		}

		function getRoute(route, entityId, parentId) {
			var hasEntityId = entityId !== undefined;
			var hasParentId = parentId !== undefined;

			if (hasEntityId && hasParentId) {
				return nuitApi(route, parentId, entityId);
			} else if (hasEntityId) {
				return nuitApi(route, entityId);
			} else if (hasParentId) {
				return nuitApi(route, parentId);
			} else {
				return nuitApi(route);
			}
		}
	}
}());

(function () {
    'use strict';

    angular
        .module('ims')
        .factory('FilterCountService', FilterCountService);

    /** @ngInject */
    function FilterCountService() {
		var _filterCountInstances = {};

        var service = initService();

        return service;

        function initService()
		{
			return{
				get: get
			};
		}

		function get(id,resetCounts)
		{
			if(!_filterCountInstances[id])
			{
				_filterCountInstances[id] = initInstance();
			}

			if(resetCounts) {
				_filterCountInstances[id].resetAll();
			}

			return _filterCountInstances[id];
		}

        function initInstance() {
			var _filterCount = {};

			return init();

			function init() {
				return {
					resetAll: resetAll,
					increment: increment,
					get: get,
					set: set
				};
			}

			function resetAll()
			{
				for(var key in _filterCount) {
					_filterCount[key] = 0;
				}
			}

			function increment(id)
			{
				if(!_filterCount.hasOwnProperty(id))
				{
					_filterCount[id] = 0;
				}

				_filterCount[id] += 1;
			}

			function get(id)
			{
				return _filterCount.hasOwnProperty(id)?_filterCount[id]:0;
			}

			function set(id, value){
				_filterCount[id] = value;
			}
		}
    }
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('EnvironmentService', EnvironmentService);

	/** @ngInject */
	function EnvironmentService(nuitApi, nuitDataService, nuitAuth) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _environments = [];
		var _evoVersions = [
			{value:0, key: 'APP.NONE', label: null},
			{value:1, key: null, label: 'v1'},
			{value:2, key: null, label: 'v2'},
			{value:3, key: null, label: 'v3'}
		];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			getCurrent: getCurrent,
			updateCurrent: updateCurrent
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'environments', {
			get: function () {
				return _environments;
			}
		});
		Object.defineProperty(service, 'evoVersions', {
			get: function () {
				return _evoVersions;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		/**
		 * Reloads all orders.
		 * @returns {Promise}
		 */
		function reload(filter) {
			return nuitApi('environments.all')
				.get(filter)
				.then(function (response) {
					return nuitDataService.replaceAll(_environments, response.data);
				});
		}

		function getCurrent(){
			return nuitApi('environments.one',nuitAuth.getEnvironmentId())
				.get()
				.then(function(response){
					return response.data;
				});
		}

		function updateCurrent(environment){
			return nuitApi('environments.one',nuitAuth.getEnvironmentId())
				.put(environment);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('CustomerService', CustomerService);

	/** @ngInject */
	function CustomerService(nuitConfig, FormatterService) {

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			getCustomerId: getCustomerId,
		};
		//*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function init() {
			service.config = nuitConfig.getCurrent();
		}

		function getCustomerId(company) {
			var field = service.config.ims.companies.customerId.field;

			if (company[field] === null) {
				return '-';
			} else if(!company['formattedCustomerId']) {
				var id = parseInt(company[field], 10);

				id += service.config.ims.companies.customerId.offset;
				id = pad(id, service.config.ims.companies.customerId.size);

				var data = {};
				data[field] = id;

				company['formattedCustomerId'] = id;
			}

			return FormatterService.format(service.config.ims.companies.customerId.format, company);
		}

		function pad(num, size) {
			var s = num + '';
			while (s.length < size) {
				s = '0' + s;
			}
			return s;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('CoilMachineService', CoilMachineService);

	/** @ngInject */
	function CoilMachineService($log, nuitApi, nuitApiProxy, nuitAuth, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _machines = [];
		var _mappedMachines = [];
		var _brands = [];
		var _cutModes = [];
		var _blankOptions = [
			{key:'MACHINE.BLANK_OPTION.IDEAL', value:0},
			{key:'MACHINE.BLANK_OPTION.NUIT_DEFAULT', value:1}
		];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			getById: getById,
			getByIdOffline: getByIdOffline,
			getMachines: getMachines,
			getMachinesMapped: function(){ return nuitAuth.getEvoVersion()===3?_mappedMachines:getMachines();},
			addMachine: addMachine,
			updateMachine: updateMachine,
			deleteMachine: deleteMachine,
			deleteJobs: deleteJobs,
			getNameById: getNameById,
			getBrands: getBrands,
			getCutModes: getCutModes
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'machines', {
			get: getMachines
		});
		Object.defineProperty(service, 'brands', {
			get: function () {
				return _brands;
			}
		});
		Object.defineProperty(service, 'cutModes', {
			get: function () {
				return _cutModes;
			}
		});
		Object.defineProperty(service, 'blankOptions', {
			get: function () {
				return _blankOptions;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Reloads all coil machines.
		 * @returns {Promise}
		 */
		function reload() {
			return nuitApiProxy('machines.coil-machines').get()
				.then(function (response) {
					// Clear cached machines
					_machines.splice(0, _machines.length);
					_mappedMachines.splice(0, _mappedMachines.length);

					// Save new machines
					var machines = response.data;
					angular.forEach(machines, function (machine) {
						_machines.push(machine);
						_mappedMachines.push(Object.assign({}, machine, {id: machine.id.toString()}));
					});

					return response;
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error loading coil machines');
				});
		}

		function getMachines() {
			return _machines;
		}

		function getByIdOffline(id) {
			return nuitDataService.getOne(_machines, id);
		}

		function getById(id) {
			return nuitApiProxy('machines.coil-machines.one', id).get()
				.then(function (response) {
					var loadedMachine = response.data;

					// TODO: remove this when api is updated
					// Quickfix for api. If connection or restrictions is null, it will throw an bad-request-error
					if (!loadedMachine.connection) {
						loadedMachine.connection = {};
					}

					if (!loadedMachine.restrictions) {
						loadedMachine.restrictions = {};
					}

					angular.forEach(_machines, function (machine) {
						if (machine.id === loadedMachine.id) {
							angular.merge(machine, loadedMachine);
						}
					});

					return loadedMachine;
				})
				.catch(function (error) {
					$log.debug(error);
					throw new Error('Cannot load machine with id ' + id);
				});
		}

		function addMachine(machine) {
			return nuitApiProxy('machines.coil-machines').post(machine)
				.then(function (response) {
					var newMachine = response.data;

					_machines.push(newMachine);

					return newMachine;
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error adding new coil machine');
				})
		}

		function updateMachine(machine) {
			return nuitApiProxy('machines.coil-machines.one', machine.id).put(machine)
				.then(function (response) {
					var loadedMachine = response.data;

					// TODO: remove this when api is updated
					// Quickfix for api. If connection or restrictions is null, it will throw an bad-request-error
					if (!loadedMachine.connection) {
						loadedMachine.connection = {};
					}

					if (!loadedMachine.restrictions) {
						loadedMachine.restrictions = {};
					}

					angular.forEach(_machines, function (machine) {
						if (machine.id === loadedMachine.id) {
							angular.merge(machine, loadedMachine);
						}
					});

					return loadedMachine;
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error updating machine with id ' + machine.id);
				});
		}

		function deleteMachine(id) {
			return nuitApiProxy('machines.coil-machines.one', id).delete()
				.then(function (response) {
					return nuitDataService.removeOne(_machines, id);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error deleting machine with id ' + id);
				});
		}

		function deleteJobs(id) {
			return nuitApiProxy('machines.coil-machines.one.jobs', id).delete();
		}

		function getNameById(machineId) {
			var machine = nuitDataService.getOne(_machines, machineId);

			if (machine) {
				return machine.name;
			} else {
				return null;
			}
		}

		function getBrands() {
			return nuitApiProxy('machines.coil-machines.brands').get()
				.then(function (response) {
					return nuitDataService.replaceAll(_brands, response.data);
				}).catch(function (err) {
					throw new Error("Error couldn't get coil machine brands");
				});
		}

		function getCutModes() {
			return nuitApiProxy('machines.coil-machines.cutModes').get()
				.then(function (response) {
					return nuitDataService.replaceAll(_cutModes, response.data);
				}).catch(function (err) {
					throw new Error("Error couldn't get coil machine cut modes");
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.factory('BendingMachineService', BendingMachineService);

	/** @ngInject */
	function BendingMachineService($log, nuitApi, nuitApiProxy, nuitAuth, nuitUtils,nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var _machines = []; //all machines
		var _mappedMachines = [];
		var _brands = []; //available machine brands
		var _materials = []; //materials for a certain machine
		var _bendings = []; //bendings for a certain machine
		var _availableMachines = []; //machines that are not part of a bending config yet (for the given material)
		var _sizingModes = [
			{
				type: 'Default',
				id: 0
			},
			{
				type: 'Neutral',
				id: 1
			},
			{
				type: 'Inner',
				id: 2
			},
			{
				type: 'Outer',
				id: 3
			}
		];
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			getById: getById,
			getByIdOffline: getByIdOffline,
			getMachines: getMachines,
			getMachinesMapped: function(){ return nuitAuth.getEvoVersion()===3?_mappedMachines:getMachines();},
			addMachine: addMachine,
			updateMachine: updateMachine,
			deleteMachine: deleteMachine,
			reloadBrands: reloadBrands,
			reloadMaterials: reloadMaterials,
			reloadBendings: reloadBendings,
			addBending: addBending,
			deleteBending: deleteBending,
			updateBending: updateBending,
			updateAvailableMachines: updateAvailableMachines
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'machines', {
			get: getMachines
		});
		Object.defineProperty(service, 'brands', {
			get: getBrands
		});
		Object.defineProperty(service, 'materials', {
			get: getMaterials
		});
		Object.defineProperty(service, 'bendings', {
			get: getBendings
		});
		Object.defineProperty(service, 'availableMachines', {
			get: getAvailableMachines
		});
		Object.defineProperty(service, 'sizingModes', {
			get: function(){return _sizingModes;}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function reload() {
			return nuitApiProxy('machines.bending-machines').get()
				.then(function (response) {
					_mappedMachines.splice(0, _mappedMachines.length);
					angular.forEach(response.data, function (machine) {
						_mappedMachines.push(Object.assign({}, machine, {id: machine.id.toString()}));
					});

					return nuitDataService.replaceAll(_machines,response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error loading bending machines');
				});
		}

		function getMachines() {
			return _machines;
		}

		function getById(id) {
			return nuitApiProxy('machines.bending-machines.one', id).get()
				.then(function (response) {
					var loadedMachine = response.data;
					addMachineQuickfix(loadedMachine);
					return nuitDataService.upsertOne(_machines,loadedMachine);
				})
				.catch(function (error) {
					$log.debug(error);
					throw new Error('Cannot load machine with id ' + id);
				});
		}

		function getByIdOffline(id) {
			return nuitDataService.getOne(_machines, id);
		}

		function addMachine(machine) {
			return nuitApiProxy('machines.bending-machines').post(machine)
				.then(function (response) {
					return nuitDataService.addOne(_machines,response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error adding new bending machine');
				});
		}

		function updateMachine(machine) {
			return nuitApiProxy('machines.bending-machines.one', machine.id).put(machine)
				.then(function (response) {
					var loadedMachine = response.data;
					addMachineQuickfix(loadedMachine);
					return nuitDataService.updateOne(_machines,loadedMachine);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error updating machine with id ' + machine.id);
				});
		}

		function addMachineQuickfix(machine)
		{
			// TODO: remove this when api is updated
			// Quickfix for api. If connection or restrictions is null, it will throw an bad-request-error
			if (!machine.connection) {
				machine.connection = {};
			}

			if (!machine.restrictions) {
				machine.restrictions = {};
			}
		}

		function deleteMachine(id) {
			return nuitApiProxy('machines.bending-machines.one', id).delete()
				.then(function (response) {
					return nuitDataService.removeOne(_machines,id);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error deleting machine with id ' + id);
				});
		}

		function reloadBrands() {
			return nuitApiProxy('machines.bending-machines.brand').get()
				.then(function (response) {
					return nuitDataService.mergeAll(_brands,response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error loading brands');
				});
		}

		function getBrands() {
			return _brands;
		}

		function reloadMaterials(machineId)
		{
			return nuitApiProxy('machine.bending-machines.material',machineId).get()
				.then(function (response) {
					return nuitDataService.replaceAll(_materials,response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error loading brands');
				});
		}

		function getMaterials() {
			return _materials;
		}

		function addBending(materialId, bendingMaterialId, bendingMachineId) {
			return nuitApi('machine.bending-machines.material.one', materialId, bendingMachineId).post({bendingMaterialId: bendingMaterialId})
				.then(function (response) {
					return nuitDataService.addOne(_bendings,response.data);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error loading brands');
				});
		}

		// v1 ids are ints, machine-v2 ids are uuid strings - coerce only digits,
		// otherwise parseInt would turn '01a0335a-...' into 1.
		function idKey(value) {
			return /^-?\d+$/.test(String(value)) ? parseInt(value, 10) : value;
		}

		function deleteBending(materialId, bendingMachineId) {
			return nuitApi('machine.bending-machines.material.one', materialId, bendingMachineId).delete()
				.then(function (response) {
					return nuitDataService.removeOneByKeys(_bendings,{materialId:idKey(materialId),bendingMachineId:idKey(bendingMachineId)});
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error loading brands');
				});
		}

		function updateBending(materialId, bendingMaterialId, bendingMachineId) {
			materialId = idKey(materialId);
			bendingMachineId = idKey(bendingMachineId);

			return nuitApi('machine.bending-machines.material.one', materialId, bendingMachineId).put({bendingMaterialId: bendingMaterialId})
				.then(function (response) {
					return nuitDataService.updateOneByKeys(_bendings,response.data,['materialId','bendingMachineId']);
				})
				.catch(function (err) {
					$log.debug(err);
					throw new Error('Error updating bending');
				});
		}

		function reloadBendings(materialId) {
			return nuitApi('materials.bendings', materialId).get()
				.then(function (response) {
					return nuitDataService.replaceAll(_bendings,response.data);
				})
				.catch(function (err) {
					nuitUtils.showErrorToast();
				});
		}

		function getBendings() {
			return _bendings;
		}

		function updateAvailableMachines() {
			_availableMachines.splice(0,_availableMachines.length);

			for(var i=0;i<_machines.length;i++)
			{
				var inUse = false;

				for(var j=0;j<_bendings.length;j++)
				{
					inUse = inUse || _bendings[j].bendingMachineId === _machines[i].id;
				}

				if(!inUse) {
					_availableMachines.push(_machines[i]);
				}
			}
		}

		function getAvailableMachines()
		{
			return _availableMachines;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.provider('imsTranslation', ImsTranslationProvider);

	/** @ngInject */
	function ImsTranslationProvider(nuitApiProvider) {
		//*******************************************
		// PROVIDER
		//*******************************************
		var provider = this;
        //*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		provider.$get = ImsTranslationService;
        //*******************************************
        
		//*******************************************
		// INIT
		//*******************************************
		init();
        //*******************************************
        
        ////////////////////////////////////////////////////////////////////////
        
		//*******************************************
		// METHODS
		//*******************************************
		function init() {
			nuitApiProvider.register('translation.one', '/translations/:key', {allow: ['get']});
		}
        //*******************************************

		//*******************************************
		// IMS TRANSLATION SERVICE
		//*******************************************
		/** @ngInject */
		function ImsTranslationService($log, $q, $translate, nuitApi) {
			//*******************************************
			// SERVICE
			//*******************************************
			var service = {
                get: get,
				getTranslationsOfKey: getTranslationsOfKey,
				getTranslationsOfKeys: getTranslationsOfKeys,
                refresh: refresh
			};
            
            //*******************************************
			// PROPERTIES
			//*******************************************
            /*
             * Returns the currently active language.
             */
            Object.defineProperty(service, 'language', { get: function() { return $translate.use(); } });
            //*******************************************

			//*******************************************
			return service;
			//*******************************************

            ////////////////////////////////////////////////////////////////////

			//*******************************************
			// METHODS
			//*******************************************
            function refresh() {
                return $translate.refresh();
            }
            
			function getTranslationsOfKey(key) {
				return nuitApi('translation.one', key)
					.get()
					.then(function (response) {
						var output = {};
						var result = response.data;

						for (var i in result) {
							output[i] = result[i][key];
						}

						return output;
					})
					.catch(function (error) {
						$log.error('Error loading translations of key ' + key);
						throw error;
					});
			}

			function getTranslationsOfKeys() {
				var promises = [];
				var keys = arguments;

				for (var i in keys) {
					promises.push(getTranslationsOfKey(keys[i]));
				}

				return $q.all(promises)
					.catch(function (err) {
						$log.error('Error loading translations');
						throw err;
					});
			}
            
            function get(key, lang) {
                return $translate.instant(key, null, null, lang);
            }
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.provider('imsMaterials', ImsMaterialsProvider);

	/** @ngInject */
	function ImsMaterialsProvider(nuitApiProvider) {
		//*******************************************
		// PROVIDER
		//*******************************************
		var provider = this;
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		provider.$get = imsMaterialsService;
		//*******************************************

		//*******************************************
		// INIT
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this provider.
		 */
		function init() {
			nuitApiProvider.register('materials.production.coils', 'machine/coilmachines/:id/materials', {allow: ['get'], versions: [2]});
			nuitApiProvider.register('materials.csv', 'exchange/import/materials/nuit', {allow: ['put', 'get']});
		}

		//*******************************************
		// SERVICE
		//*******************************************
		/** @ngInject */
		function imsMaterialsService($log, $translate, imsTranslation, nuitApi, nuitApiProxy, nuitMaterials) {
			//*******************************************
			// SERVICE
			//*******************************************
			var service = {
				add: add,
				loadMaterial: loadMaterial,
				updateMaterial: updateMaterial,
				patchMaterial: patchMaterial,
				deleteMaterial: deleteMaterial,
				addGroup: addGroup,
				updateGroup: updateGroup,
				deleteGroup: deleteGroup,
				reload: nuitMaterials.reload,
				reloadGroups: nuitMaterials.reloadGroups,
				getMaterialsOfCoilMachine: getMaterialsOfCoilMachine,
				getMaterialById: nuitMaterials.getMaterialById,
				getGroupById: nuitMaterials.getGroupById,
				reset: nuitMaterials.reset,
				uploadMaterials: uploadMaterials,
				downloadMaterials: downloadMaterials
			};

			//*******************************************

			//*******************************************
			// PROPERTIES
			//*******************************************
			Object.defineProperty(service, 'materials', {
				get: function () {
					return nuitMaterials.materials;
				}
			});
			Object.defineProperty(service, 'groups', {
				get: function () {
					return nuitMaterials.groups;
				}
			});
			//*******************************************

			//*******************************************
			return service;
			//*******************************************

			////////////////////////////////////////////////////////////////////////

			/**
			 * Returns all production materials of the machine
			 * with the given id.
			 * @param {Number} id - machine id
			 * @returns {Promise}
			 */
			function getMaterialsOfCoilMachine(id) {
				return nuitApiProxy('materials.production.coils', id)
					.get()
					.then(function (response) {
						return response.data;
					});
			}

			/**
			 * Adds the given material to the material database.
			 * @param {Material} material - material to add
			 * @returns {Promise}
			 */
			function add(material) {
				return nuitApi('materials')
					.post(material)
					.then(function (response) {
						if (angular.isObject(response.data)) {
							var newMaterial = response.data;
							service.materials.push(newMaterial);
							$translate.refresh();
							return newMaterial;
						} else {
							throw 'Invalid API response!';
						}
					})
					.catch(function (error) {
						$log.error('Error adding new material!');
						throw error;
					});
			}

			/**
			 * Sends the updated material to remote server.
			 * @param {Material} material
			 */
			function updateMaterial(material) {
				return nuitApi('materials.single', material.id)
					.put(material)
					.then(function (response) {
						return response.data;
					})
					.then(function (newMaterial) {
						for (var i in service.materials) {
							if (service.materials[i].id === newMaterial.id) {
								newMaterial = angular.merge(service.materials[i], newMaterial);
								break;
							}
						}
						return newMaterial;
					})
					.catch(function (error) {
						$log.error('Error updating material!');
						throw error;
					});
			}

			/**
			 * Sends the updated material to remote server.
			 * @param {Material} material
			 */
			function patchMaterial(material) {
				return nuitApi('materials.single', material.id)
					.patch(material)
					.then(function (response) {
						return response.data;
					})
					.then(function (newMaterial) {
						for (var i in service.materials) {
							if (service.materials[i].id === newMaterial.id) {
								var oldMaterial = service.materials[i];
								newMaterial = angular.merge(oldMaterial, newMaterial);
								break;
							}
						}
						return newMaterial;
					})
					.catch(function (error) {
						$log.error('Error patching material!');
						throw error;
					});
			}


			/**
			 * Loads the material with the given id.
			 * @param {Integer} id - material id
			 * @returns {Material}
			 */
			function loadMaterial(id) {
				id = parseInt(id);

				return nuitApi('materials.single', id)
					.get()
					.then(function (result) {
						var material = result.data;
						if (angular.isObject(material)) {
							return material;
						}
						return null;
					})
					.catch(function (error) {
						$log.error('Error loading material with id ' + id + '!');
						throw error;
					});
			}

			/**
			 * Deletes the material with the given id.
			 * @param {Number} id - material id
			 * @returns {Promise}
			 */
			function deleteMaterial(id) {
				return nuitApi('materials.single', id)
					.delete()
					.then(function () {
						var index = getMaterialIndexById(id);
						if (index >= 0) {
							service.materials.splice(index, 1);
						}
					})
					.catch(function (error) {
						$log.error('Error deleting material!');
						throw error;
					});
			}

			/**
			 * Creates and adds a new material group with the given name.
			 * @param {Group} group - group name
			 * @returns {Promise}
			 */
			function addGroup(group) {
				return nuitApi('materials.raw')
					.post(group)
					.then(function (response) {
						if (angular.isObject(response.data)) {
							group = response.data;
							group._isLoading = true;
							service.groups.push(group);
							return $translate.refresh();
						} else {
							throw 'Invalid API response!';
						}
					})
					.finally(function () {
						delete group._isLoading;
					})
					.catch(function (error) {
						$log.error('Error adding new material group!');
						throw error;
					});
			}

			/**
			 * Updates the database entry of the given group.
			 * @param {Group} group
			 * @returns {Promise}
			 */
			function updateGroup(group) {
				return nuitApi('materials.raw.single', group.id)
					.patch(group)
					.then(function (response) {
						var updatedGroup = response.data;

						if (angular.isObject(updatedGroup) && updatedGroup.id !== undefined) {
							for (var i in service.groups) {
								if (service.groups[i].id === updatedGroup.id) {
									for(var prop in service.groups[i]) {
										delete service.groups[i][prop];
									}

									return angular.merge(service.groups[i], updatedGroup);
								}
							}
						}
						return updatedGroup;
					})
					.catch(function (error) {
						$log.error('Error updating raw material!');
						throw error;
					});
			}

			/**
			 * Deletes the group with the given id.
			 * @param {Number} id - group id
			 * @returns {Promise}
			 */
			function deleteGroup(id) {
				return nuitApi('materials.raw.single', id)
					.delete()
					.then(function (response) {
						var index = getGroupIndexById(id);
						if (index >= 0) {
							service.groups.splice(index, 1);
						}
					})
					.catch(function (error) {
						$log.error('Error deleting material group!');
						throw error;
					});
			}

			/**
			 * Returns the index of the group with the given id
			 * or -1 if the group does not exist.
			 * @param {Number} id - group id
			 * @returns {Number}
			 */
			function getGroupIndexById(id) {
				for (var index = 0; index < service.groups.length; index++) {
					if (service.groups[index].id === id) {
						return index;
					}
				}
				return -1;
			}

			/**
			 * Returns the index of the material with the given id
			 * or -1 if the material does not exist.
			 * @param {Number} id - material id
			 * @returns {Number}
			 */
			function getMaterialIndexById(id) {
				for (var index = 0; index < service.materials.length; index++) {
					if (service.materials[index].id === id) {
						return index;
					}
				}
				return -1;
			}


			function uploadMaterials(fileData) {
				return nuitApi('materials.csv')
					.put(fileData, null, {
						headers: {
							'Content-Type': undefined
						}
					})
					.then(function (response) {
						if (angular.isArray(response.data)) {
							for (var i in response.data) {
								service.materials.push(response.data[i]);
							}
							return response.data;
						}
						return [];
					})
					.catch(function (error) {
						$log.error('Failed to upload materials!');
						throw error;
					});
			}

			function downloadMaterials() {
				return nuitApi('materials.csv')
					.get()
					.then(function (result) {

					})
					.catch(function (error) {
						$log.error('Error downloading material!');
						throw error;
					});
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('ims')
		.provider('imsColors', ImsColorsProvider);

	/** @ngInject */
	function ImsColorsProvider(nuitApiProvider) {
		//*******************************************
		// PROVIDER
		//*******************************************
		var provider = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		var _colors = [];
		//*******************************************

		//*******************************************
		// EXPOSURE
		//*******************************************
		provider.$get = imsColorsService;
		provider.isColor = isColor;
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(provider, 'colors', {
			get: function () {
				return _colors;
			}
		});
		//*******************************************

		//*******************************************
		// INIT
		//*******************************************
		init();
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Initializes this provider.
		 */
		function init() {
			nuitApiProvider.register('colors.all', 'color/colors', {allow: ['get', 'post']});
			nuitApiProvider.register('colors.csv', 'exchange/colors/nuit', {allow: ['put']});
		}

		/**
		 * Returns true if the given object is a color.
		 * @param {Object} color
		 * @returns {Boolean}
		 */
		function isColor(color) {
			return angular.isObject(color)
				&& angular.isString(color.code)
				&& angular.isString(color.hex)
				&& angular.isNumber(color.id)
				&& angular.isObject(color.name)
				&& angular.isString(color.rgb);
		}

		//*******************************************
		// SERVICE
		//*******************************************
		/** @ngInject */
		function imsColorsService($log, nuitApi) {
			//*******************************************
			// SERVICE
			//*******************************************
			var service = {
				reload: reload,
				addColor: addColor,
				addColors: addColors,
				getColorById: getColorById,
				uploadColors: uploadColors,
				deleteColor: deleteColor,
				updateColor: updateColor,
				reset: reset,
				isColor: isColor,

				// Deprecated
				reloadColors: reloadColors
			};
			//*******************************************

			//*******************************************
			// PROPERTIES
			//*******************************************
			Object.defineProperty(service, 'colors', {
				get: function () {
					return _colors;
				}
			});
			//*******************************************

			//*******************************************
			return service;
			//*******************************************

			////////////////////////////////////////////////////////////////////////

			//*******************************************
			// METHODS
			//*******************************************
			/**
			 * Reloads all colors by performing a call to the API.
			 * @returns {Promise}
			 */
			function reload() {
				return nuitApi('colors.all')
					.get()
					.then(function (response) {
						// Clear colors
						reset();

						if (angular.isArray(response.data)) {
							angular.merge(_colors, response.data);
						}
						return _colors;
					})
					.catch(function (error) {
						$log.error('Failed to load colors!');
						throw error;
					});
			}

			/**
			 * Resets the color array and removes all elements.
			 */
			function reset() {
				_colors.splice(0, _colors.length);
			}

			/**
			 * Adds the given color to the collection
			 * and informs the API about it.
			 * @param {Color} color
			 * @returns {Promise}
			 */
			function addColor(color) {
				return nuitApi('colors.all')
					.post(color, {lang: 'en'})
					.then(function (response) {
						if (angular.isObject(response.data)) {
							_colors.push(response.data);
							return response.data;
						} else {
							return null;
						}
					})
					.catch(function (error) {
						$log.error('Failed to add color!');
						throw error;
					});
			}

			/**
			 * Returns the color with the given id or null if the
			 * color does not exist.
			 * @param {Number} id
			 * @returns {Color}
			 */
			function getColorById(id) {
				var i;
				for (i in _colors) {
					if (_colors[i].id === id) {
						return _colors[i];
					}
				}
				return null;
			}

			/**
			 * Uploads the colors specified in the given form file data.
			 * The promise returns either all added colors or an empty array.
			 * @param {Object} fileData - file data extracted from a form
			 * @returns {Promise}
			 */
			function uploadColors(fileData) {
				return nuitApi('colors.csv')
					.put(fileData, null, {
						headers: {
							'Content-Type': undefined
						}
					})
						.then(function (response) {
							if (angular.isArray(response.data)) {
								for (var i in response.data) {
									_colors.push(response.data[i]);
								}
								return response.data;
							}
							return [];
						})
						.catch(function (error) {
							$log.error('Failed to upload colors!');
							throw error;
						});
			}

			/**
			 * Adds the given array of colors to the local
			 * collection. Performs no API call!
			 * @param {Array} colors
			 */
			function addColors(colors) {
				if (!angular.isArray(colors)) {
					$log.error('Cannot add non-array type to colors via "addColors(...)"!');
					return;
				}

				for (var i in colors) {
					_colors.push(colors[i]);
				}
			}

			/**
			 * Updates the given color by sending it to the API.
			 * @param {Color} color
			 * @returns {Promise}
			 */
			function updateColor(color) {
				return nuitApi('colors.single', color.id)
					.put(color)
					.catch(function (error) {
						$log.error('Failed to update color!');
						throw error;
					});
			}

			/**
			 * Deletes the given color.
			 * @param {Color} color
			 * @returns {Promise}
			 */
			function deleteColor(color) {
				return nuitApi('colors.single', color.id)
					.delete()
					.then(function () {
						for (var i = 0; i < _colors.length; i++) {
							if (_colors[i].id === color.id) {
								_colors.splice(i, 1);
								break;
							}
						}
					});
			}

			//*******************************************
			// DEPRECATED
			//*******************************************
			/**
			 * Deprecated! Please use imsColors.reload() instead!
			 * @returns {Promise}
			 */
			function reloadColors() {
				return reload();
			}
		}
	}
})();

// # Angular-Inview
// - Author: [Nicola Peduzzi](https://github.com/thenikso)
// - Repository: https://github.com/thenikso/angular-inview
// - Install with: `npm install angular-inview`
// - Version: **3.0.0**
(function() {
'use strict';

// An [angular.js](https://angularjs.org) directive to evaluate an expression if
// a DOM element is or not in the current visible browser viewport.
// Use it in your AngularJS app by including the javascript and requireing it:
//
// `angular.module('myApp', ['angular-inview'])`
var moduleName = 'angular-inview';
angular.module(moduleName, [])

// ## in-view directive
//
// ### Usage
// ```html
// <any in-view="{expression}" [in-view-options="{object}"]></any>
// ```
.directive('inView', ['$parse', inViewDirective])

// ## in-view-container directive
.directive('inViewContainer', inViewContainerDirective);

// ## Implementation
function inViewDirective ($parse) {
  return {
    // Evaluate the expression passet to the attribute `in-view` when the DOM
    // element is visible in the viewport.
    restrict: 'A',
    require: '?^^inViewContainer',
    link: function inViewDirectiveLink (scope, element, attrs, container) {
      // in-view-options attribute can be specified with an object expression
      // containing:
      //   - `offset`: An array of values to offset the element position.
      //     Offsets are expressed as arrays of 4 numbers [top, right, bottom, left].
      //     Like CSS, you can also specify only 2 numbers [top/bottom, left/right].
      //     Instead of numbers, some array elements can be a string with a percentage.
      //     Positive numbers are offsets outside the element rectangle and
      //     negative numbers are offsets to the inside.
      //   - `viewportOffset`: Like the element offset but appied to the viewport.
      //   - `generateDirection`: Indicate if the `direction` information should
      //     be included in `$inviewInfo` (default false).
      //   - `generateParts`: Indicate if the `parts` information should
      //     be included in `$inviewInfo` (default false).
      //   - `throttle`: Specify a number of milliseconds by which to limit the
      //     number of incoming events.
      var options = {};
      if (attrs.inViewOptions) {
        options = scope.$eval(attrs.inViewOptions);
      }
      if (options.offset) {
        options.offset = normalizeOffset(options.offset);
      }
      if (options.viewportOffset) {
        options.viewportOffset = normalizeOffset(options.viewportOffset);
      }

      // Build reactive chain from an initial event
      var viewportEventSignal = signalSingle({ type: 'initial' })

      // Merged with the window events
      .merge(signalFromEvent(window, 'checkInView click ready wheel mousewheel DomMouseScroll MozMousePixelScroll resize scroll touchmove mouseup keydown'))

      // Merge with container's events signal
      if (container) {
        viewportEventSignal = viewportEventSignal.merge(container.eventsSignal);
      }

      // Throttle if option specified
      if (options.throttle) {
        viewportEventSignal = viewportEventSignal.throttle(options.throttle);
      }

      // Map to viewport intersection and in-view informations
      var inviewInfoSignal = viewportEventSignal

      // Inview information structure contains:
      //   - `inView`: a boolean value indicating if the element is
      //     visible in the viewport;
      //   - `changed`: a boolean value indicating if the inview status
      //     changed after the last event;
      //   - `event`: the event that initiated the in-view check;
      .map(function(event) {
        var viewportRect;
        if (container) {
          viewportRect = container.getViewportRect();
          // TODO merge with actual window!
        } else {
          viewportRect = getViewportRect();
        }
        viewportRect = offsetRect(viewportRect, options.viewportOffset);
        var elementRect = offsetRect(element[0].getBoundingClientRect(), options.offset);
        var isVisible = !!(element[0].offsetWidth || element[0].offsetHeight || element[0].getClientRects().length);
        var info = {
          inView: isVisible && intersectRect(elementRect, viewportRect),
          event: event,
          element: element,
          elementRect: elementRect,
          viewportRect: viewportRect
        };
        // Add inview parts
        if (options.generateParts && info.inView) {
          info.parts = {};
          info.parts.top = elementRect.top >= viewportRect.top;
          info.parts.left = elementRect.left >= viewportRect.left;
          info.parts.bottom = elementRect.bottom <= viewportRect.bottom;
          info.parts.right = elementRect.right <= viewportRect.right;
        }
        return info;
      })

      // Add the changed information to the inview structure.
      .scan({}, function (lastInfo, newInfo) {
        // Add inview direction info
        if (options.generateDirection && newInfo.inView && lastInfo.elementRect) {
          newInfo.direction = {
            horizontal: newInfo.elementRect.left - lastInfo.elementRect.left,
            vertical: newInfo.elementRect.top - lastInfo.elementRect.top
          };
        }
        // Calculate changed flag
        newInfo.changed =
          newInfo.inView !== lastInfo.inView ||
          !angular.equals(newInfo.parts, lastInfo.parts) ||
          !angular.equals(newInfo.direction, lastInfo.direction);
        return newInfo;
      })

      // Filters only informations that should be forwarded to the callback
      .filter(function (info) {
        // Don't forward if no relevant infomation changed
        if (!info.changed) {
          return false;
        }
        // Don't forward if not initially in-view
        if (info.event.type === 'initial' && !info.inView) {
          return false;
        }
        return true;
      });

      // Execute in-view callback
      var inViewExpression = $parse(attrs.inView);
      var dispose = inviewInfoSignal.subscribe(function (info) {
        scope.$applyAsync(function () {
          inViewExpression(scope, {
            '$inview': info.inView,
            '$inviewInfo': info
          });
        });
      });

      // Dispose of reactive chain
      scope.$on('$destroy', dispose);
    }
  }
}

function inViewContainerDirective () {
  return {
    restrict: 'A',
    controller: ['$element', function ($element) {
      this.element = $element;
      this.eventsSignal = signalFromEvent($element, 'scroll');
      this.getViewportRect = function () {
        return $element[0].getBoundingClientRect();
      };
    }]
  }
}

// ## Utilities

function getViewportRect () {
  var result = {
    top: 0,
    left: 0,
    width: window.innerWidth,
    right: window.innerWidth,
    height: window.innerHeight,
    bottom: window.innerHeight
  };
  if (result.height) {
    return result;
  }
  var mode = document.compatMode;
  if (mode === 'CSS1Compat') {
    result.width = result.right = document.documentElement.clientWidth;
    result.height = result.bottom = document.documentElement.clientHeight;
  } else {
    result.width = result.right = document.body.clientWidth;
    result.height = result.bottom = document.body.clientHeight;
  }
  return result;
}

function intersectRect (r1, r2) {
  return !(r2.left > r1.right ||
           r2.right < r1.left ||
           r2.top > r1.bottom ||
           r2.bottom < r1.top);
}

function normalizeOffset (offset) {
  if (!angular.isArray(offset)) {
    return [offset, offset, offset, offset];
  }
  if (offset.length == 2) {
    return offset.concat(offset);
  }
  else if (offset.length == 3) {
    return offset.concat([offset[1]]);
  }
  return offset;
}

function offsetRect (rect, offset) {
  if (!offset) {
    return rect;
  }
  var offsetObject = {
    top: isPercent(offset[0]) ? (parseFloat(offset[0]) * rect.height / 100) : offset[0],
    right: isPercent(offset[1]) ? (parseFloat(offset[1]) * rect.width / 100) : offset[1],
    bottom: isPercent(offset[2]) ? (parseFloat(offset[2]) * rect.height / 100) : offset[2],
    left: isPercent(offset[3]) ? (parseFloat(offset[3]) * rect.width / 100) : offset[3]
  };
  // Note: ClientRect object does not allow its properties to be written to therefore a new object has to be created.
  return {
    top: rect.top - offsetObject.top,
    left: rect.left - offsetObject.left,
    bottom: rect.bottom + offsetObject.bottom,
    right: rect.right + offsetObject.right,
    height: rect.height + offsetObject.top + offsetObject.bottom,
    width: rect.width + offsetObject.left + offsetObject.right
  };
}

function isPercent (n) {
  return angular.isString(n) && n.indexOf('%') > 0;
}

// ## QuickSignal FRP
// A quick and dirty implementation of Rx to have a streamlined code in the
// directives.

// ### QuickSignal
//
// - `didSubscribeFunc`: a function receiving a `subscriber` as described below
//
// Usage:
//     var mySignal = new QuickSignal(function(subscriber) { ... })
function QuickSignal (didSubscribeFunc) {
  this.didSubscribeFunc = didSubscribeFunc;
}

// Subscribe to a signal and consume the steam of data.
//
// Returns a function that can be called to stop the signal stream of data and
// perform cleanup.
//
// A `subscriber` is a function that will be called when a new value arrives.
// a `subscriber.$dispose` property can be set to a function to be called uppon
// disposal. When setting the `$dispose` function, the previously set function
// should be chained.
QuickSignal.prototype.subscribe = function (subscriber) {
  this.didSubscribeFunc(subscriber);
  var dispose = function () {
    if (subscriber.$dispose) {
      subscriber.$dispose();
      subscriber.$dispose = null;
    }
  }
  return dispose;
}

QuickSignal.prototype.map = function (f) {
  var s = this;
  return new QuickSignal(function (subscriber) {
    subscriber.$dispose = s.subscribe(function (nextValue) {
      subscriber(f(nextValue));
    });
  });
};

QuickSignal.prototype.filter = function (f) {
  var s = this;
  return new QuickSignal(function (subscriber) {
    subscriber.$dispose = s.subscribe(function (nextValue) {
      if (f(nextValue)) {
        subscriber(nextValue);
      }
    });
  });
};

QuickSignal.prototype.scan = function (initial, scanFunc) {
  var s = this;
  return new QuickSignal(function (subscriber) {
    var last = initial;
    subscriber.$dispose = s.subscribe(function (nextValue) {
      last = scanFunc(last, nextValue);
      subscriber(last);
    });
  });
}

QuickSignal.prototype.merge = function (signal) {
  return signalMerge(this, signal);
};

QuickSignal.prototype.throttle = function (threshhold) {
  var s = this, last, deferTimer;
  return new QuickSignal(function (subscriber) {
    var chainDisposable = s.subscribe(function () {
      var now = +new Date,
          args = arguments;
      if (last && now < last + threshhold) {
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          subscriber.apply(null, args);
        }, threshhold);
      } else {
        last = now;
        subscriber.apply(null, args);
      }
    });
    subscriber.$dispose = function () {
      clearTimeout(deferTimer);
      if (chainDisposable) chainDisposable();
    };
  });
};

function signalMerge () {
  var signals = arguments;
  return new QuickSignal(function (subscriber) {
    var disposables = [];
    for (var i = signals.length - 1; i >= 0; i--) {
      disposables.push(signals[i].subscribe(function () {
        subscriber.apply(null, arguments);
      }));
    }
    subscriber.$dispose = function () {
      for (var i = disposables.length - 1; i >= 0; i--) {
        if (disposables[i]) disposables[i]();
      }
    }
  });
}

// Returns a signal from DOM events of a target.
function signalFromEvent (target, event) {
  return new QuickSignal(function (subscriber) {
    var handler = function (e) {
      subscriber(e);
    };
    var el = angular.element(target);
    event.split(' ').map(function(e){el[0].addEventListener(e, handler, true);});
    subscriber.$dispose = function () {
      event.split(' ').map(function(e){el[0].removeEventListener(e, handler, true);});
    };
  });
}

function signalSingle (value) {
  return new QuickSignal(function (subscriber) {
    setTimeout(function() { subscriber(value); });
  });
}

// Module loaders exports
if (typeof define === 'function' && define.amd) {
  define(['angular'], moduleName);
} else if (typeof module !== 'undefined' && module && module.exports) {
  module.exports = moduleName;
}

})();

(function () {
	'use strict';

	angular
		.module('ims')
		.constant('ims', {
			DEFAULT_LOGIN_STATE: 'app.orders',
			DEFAULT_LOGOUT_STATE: 'app.auth.login'
		});
}());

(function () {
    'use strict';
    angular
        .module('ims')
        .component('nuitSelectById', {
            templateUrl: 'app/ims/components/nuit-select.by.id.html',
            controller: SelectByIdController,
            controllerAs: 'vm',
            transclude: true,
            bindings: {
                currentId: '=',
                list: '<',
                entityFormat: '@',
				onChange: '<',
				required: '<'
            }
        });

    /** @ngInject */
    function SelectByIdController() {
        //*******************************************
        // VIEWMODEL
        //*******************************************
        var vm = this;
        //*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        vm.$onInit = $onInit;
        vm.formatEntity = formatEntity;
        vm.selectionChanged = selectionChanged;
        //*******************************************

        //*******************************************
        // METHODS
        //*******************************************

        function $onInit()
        {
            vm.entityFormatArray = vm.entityFormat.split('#');
            if(vm.required===undefined){
            	vm.required = false;
			}
        }

        function formatEntity(entity)
        {
            var text = '';

            for(var i=0;i<vm.entityFormatArray.length;i++)
            {
                var key = vm.entityFormatArray[i];
                var attribute = entity[key];

                if(!attribute) {
					text += key;
				}
                else {
					text += attribute;
				}
            }

            text = text.replace( /\s\s+/g, ' ' ); //removing unnecessary spaces

            return text;
        }

        function selectionChanged()
		{
			if(typeof vm.onChange !=='undefined')
			{
				vm.onChange(vm.currentId);
			}
		}

        //*******************************************
    }
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('SpecialProcessing', SpecialProcessing);

	/** @ngInject */
	function SpecialProcessing($q, $mdDialog, nuitApi, nuitConfig, nuitDataService, nuitProfiles) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var CONICAL = 'conical';
		var CUT = 'cut';

		var specialsToApply = [CONICAL, CUT];

		var specials = [];
		var hasLoadedOnce = false;
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reload: reload,
			showSelection: showSelection,
			applySpecials: applySpecials
		};
		//*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		Object.defineProperty(service, 'specials', {
			get: function () {
				return specials;
			}
		});
		//*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
		}

		function reload() {
			if (hasLoadedOnce) {
				var deferred = $q.defer();
				deferred.resolve();
				return deferred.promise;
			} else {
				hasLoadedOnce = true;
				return nuitApi('special.processing').get()
					.then(function (response) {
						nuitDataService.replaceAll(specials, response.data);
					});
			}
		}

		function showSelection(special, currentSelection, readOnly) {
			return $mdDialog.show({
				controller: 'SpecialProcessingController',
				controllerAs: 'vm',
				templateUrl: 'app/core/dialogs/special-processing/special-processing.html',
				parent: angular.element(document.body),
				multiple: true,
				locals: {
					Special: special,
					CurrentSelection: angular.copy(currentSelection),
					Selection: angular.copy(specials),
					ReadOnly: readOnly,
					Template: nuitConfig.current.evo.cart.specialsTemplate
				},
				clickOutsideToClose: true
			})
				.then(function (special) {
					return special;
				});
		}

		function applySpecials(profile) {
			if (hasLoadedOnce) {
				var deferred = $q.defer();
				deferred.resolve();
				applyInternal(profile)
				return deferred.promise;
			} else {
				return reload()
					.then(function () {
						applyInternal(profile);
					});
			}
		}

		function applyInternal(profile) {
			if (specials.length > 0) {
				if (!profile.positions || profile.positions.length === 1) {
					if (!profile.specials) {
						profile.specials = [];
					}

					angular.forEach(specialsToApply, function (special) {
						var currentSpecial = nuitDataService.getOne(profile.specials, special)
						var specialToApply = nuitDataService.getOne(specials, special);

						if (!currentSpecial && specialToApply && fulfillsApplyCondition(profile, special)) {
							profile.specials.push(
								{
									id: specialToApply.id,
									name: specialToApply.name
								});
						}

						if(currentSpecial && specialToApply && !fulfillsApplyCondition(profile, special)){
							nuitDataService.removeOne(profile.specials, specialToApply.id);
						}
					});
				}
			}
			;
		}

		function fulfillsApplyCondition(profile, special) {
			switch (special) {
				case CONICAL:
					return nuitProfiles.isConical(profile);
				case CUT:
					return nuitProfiles.hasCuts(profile);
				default:
					return false;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('SalesObject', SalesObject);

	/** @ngInject */
	function SalesObject($rootScope, nuitConfig, DotNotationService, ConditionCheckService, nuitDataService) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			getPosition: getPosition,
			showPosition: showPosition,
			getDefaultSalesObject: getDefaultSalesObject
		};
		//*******************************************
		var salesOrder = [];
		var salesConfig = getDefaultSalesObject();

		//*******************************************
		/// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function init() {
			if(nuitConfig.isReady()) {
				setSalesConfig();
			}else{
				$rootScope.$on('config::config.loaded',setSalesConfig);
			}

			setSalesOrder();
		}

		function setSalesConfig(){
			if(DotNotationService.hasKey(nuitConfig.current, 'evo.cart.layout.sales.order') && nuitConfig.current.evo.cart.layout.sales.order.length>0){
				nuitDataService.replaceAll(salesConfig, nuitConfig.current.evo.cart.layout.sales.order);
				setSalesOrder();
			}
		}

		function setSalesOrder(){
			var newSalesOrder = [];
			for(var i=0;i<salesConfig.length;i++){
				newSalesOrder.push(salesConfig[i].id);
			}

			nuitDataService.replaceAll(salesOrder, newSalesOrder);
		}

		function getPosition(key, offset) {
			var index = salesOrder.indexOf(key);

			if(index>=0){
				return -19 + index*4 +(offset?offset:0);
			}else{
				return 20;
			}
		}

		function showPosition(key, object, overrideEntry){
			var index = salesOrder.indexOf(key);

			if(index>=0){
				var entry = overrideEntry?overrideEntry:salesConfig[index];
				return entry.visible && ConditionCheckService.matchesAll(entry.conditions,object);
			}else{
				return false;
			}
		}

		function getDefaultSalesObject(){
			return [
				{
					id: 'basePrice',
					visible: true,
					conditions:[]
				},
				{
					id: 'globalDiscount',
					visible: true,
					conditions:[
						{type: 'isNotEqual', attribute: 'sales.globalDiscount', value: 0, operator: 'and'}
					]
				},
				{
					id: 'onlineDiscount',
					visible: true,
					conditions:[
						{type: 'isNotEqual', attribute: 'sales.onlineDiscount', value: 0, operator:'and'},
						{type: 'isEqual', attribute: 'sales.discounts.applyOnlineDiscount', value: true, operator:'and'}
					]
				},
				{
					id: 'minPrice',
					visible: true,
					conditions: [
						{type: 'isSet', attribute: 'sales.minPriceDifference', operator:'and'},
						{type: 'isNotEqual', attribute: 'sales.minPriceDifference', value: 0, operator:'and'},
					]
				},
				{
					id: 'orderFee',
					visible: true,
					conditions: [
						{type: 'isSet', attribute: 'sales.orderFee', operator:'and'},
						{type: 'isNotEqual', attribute: 'sales.orderFee', value: 0, operator:'and'},
					]
				},
				{
					id: 'logisticPrice',
					visible: true,
					conditions: [
						{type: 'isEqual', attribute: 'details.shippingType', value: "delivery", operator:'and'},]
				},
				{
					id: 'netPrice',
					visible: true,
					conditions:[]
				},
				{
					id: 'taxes',
					visible: true,
					conditions:[]
				},
				{
					id: 'grossPrice',
					visible: true,
					conditions:[]
				}
			];
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('ProjectsViewService', ProjectsViewService);

	/** @ngInject */
	function ProjectsViewService($q, $mdSelect, $timeout) {
		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			focusSearch:focusSearch,
		};

		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************


		return service;

		//*******************************************
		// METHODS
		//*******************************************
		function focusSearch() {
			$timeout(function(){$('#searchProject').focus();},100);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('ProjectService', factory);

	/** @ngInject */
	function factory(nuitApi, nuitUtils, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
        var _projects = [];
        //*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
            add: add,
			remove: remove,
            update: update,
			patch: patch,
            getByUuid: getByUuid,
            reload: reload,
		};
        //*******************************************

        //*******************************************
        // PROPERTIES
        //*******************************************
        Object.defineProperty(service, 'projects', { get: function() { return _projects; } });
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        function reload() {
            return nuitApi('project.projects')
                .get()
                .then(function(response) {
					return nuitDataService.replaceAll(_projects,response.data);
            	});
        }

        function getByUuid(uuid) {
			return nuitDataService.getOneByKeys(_projects, {uuid: uuid});
        }

        function add(tag) {
            return nuitApi('project.add')
                .post(tag)
                .then(function (response) {
					return nuitDataService.addOne(_projects,response.data);
                });
        }

        function update(tag) {
            return nuitApi('project.single', tag.id)
                .put(tag)
                .then(function (response) {
					return nuitDataService.updateOne(_projects,response.data);
                });
        }

		function patch(tag){
			return nuitApi('project.single', tag.id)
				.patch(tag)
				.then(function (response){
					return nuitDataService.updateOne(_projects, response.data);
				});
		}

        function remove(id) {
            return nuitApi('project.single', id)
                .delete()
                .then(function(response) {
					return nuitDataService.removeOne(_projects,id);
            	});
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('ProfileFolders', factory);

	function factory($window, $filter, nuitApiProxy, nuitAuth, nuitUtils, nuitDataService) {
		//*******************************************
		// CONSTANTS
		//*******************************************
		var STORAGE_SELECTED_FOLDER = "@editor.profiles#selectedFolder";
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		var privateFolders = [];
		var publicFolders = [];
		var indexedProfiles = {};
		var profiles = [];
		var _isReloading = false;
		//*******************************************

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			addFolder: addFolder,
			swapFolder: swapFolder,
			reloadProfiles: reloadProfiles,
			cacheSelectedFolder: cacheSelectedFolder,
			getSelectedFolderFromCache: getSelectedFolderFromCache,
			getFolderById: getFolderById,
			reload: reload,
			updateProfile: updateProfile,
			deleteProfile: deleteProfile,
			doesProfileExist: doesProfileExist,
			parseFolderId: parseFolderId,
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'privateFolders', {
			get: function () {
				return privateFolders;
			}
		});
		Object.defineProperty(service, 'publicFolders', {
			get: function () {
				return publicFolders;
			}
		});
		Object.defineProperty(service, 'profiles', {
			get: function () {
				return profiles;
			}
		});
		Object.defineProperty(service, 'indexedProfiles', {
			get: function () {
				return indexedProfiles;
			}
		});
		Object.defineProperty(service, 'isReloading', {
			get: function () {
				return _isReloading;
			}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		/////////////////////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function reload(folder) {
			_isReloading = true;
			return nuitApiProxy('profiles.folders')
				.get({origin: 'production', user: nuitAuth.getUserId()})
				.then(function (response) {
					privateFolders.splice(0, privateFolders.length);
					publicFolders.splice(0, publicFolders.length);

					angular.merge(privateFolders, unpackage(response.data.user, true, false));
					angular.merge(publicFolders, unpackage(response.data.environment, true, true));

					function unpackage(obj, root, pub) {
						$filter('orderBy')(obj, 'position');
						if (obj !== null) {
							var length = obj ? obj.length : 0;
							for (var index in obj) {
								var intIndex = parseInt(index, 10);

								var folder = obj[index];

								folder.prevId = intIndex > 0 ? obj[intIndex - 1].id : null;
								folder.nextId = intIndex < length - 1 ? obj[intIndex + 1].id : null;

								folder.public = pub;
								folder.root = root;

								if (folder.children) {
									unpackage(folder.children, false, pub);
								}
							}
						}
						return obj;
					}
				})
				.finally(function(){
					_isReloading = false;
				});
		}

		function cacheSelectedFolder(folder) {
			try {
				$window.sessionStorage.setItem(STORAGE_SELECTED_FOLDER + "." + nuitAuth.getEnvironmentId(), folder.id);
			} catch (ex) {
				console.log(ex);
			}
		}

		function getSelectedFolderFromCache() {
			try {
				return $window.sessionStorage.getItem(STORAGE_SELECTED_FOLDER + "." + nuitAuth.getEnvironmentId());
			} catch (ex) {
				console.log(ex);
				return undefined;
			}
		}

		function updateProfile(profile) {
			return nuitApiProxy('profiles.single', profile.id)
				.put(profile)
				.then(function (response) {
					var oldProfile = null;
					if (doesProfileExist(profile)) {
						oldProfile = indexedProfiles[profile.id];
					}
					if(oldProfile) {
						nuitUtils.clearObj(oldProfile);
						angular.merge(oldProfile, response.data);
					}
				});
		}

		function deleteProfile(profileId) {
			return nuitApiProxy('profiles.single', profileId)
				.delete()
				.then(function () {
						nuitDataService.removeOne(profiles,profileId);
						delete indexedProfiles[profileId];
				});
		}

		function reloadProfiles() {
			return nuitApiProxy('profiles.all')
				.get({user: nuitAuth.getUserId(), format: 'folder'})
				.then(function (response) {
					profiles.splice(0, profiles.length);
					angular.merge(profiles, response.data);
					nuitUtils.clearObj(indexedProfiles);
					for (var index in profiles) {
						indexedProfiles[profiles[index].id] = profiles[index];
					}
				});
		}

		function doesProfileExist(profile) {
			return indexedProfiles[profile.id] !== undefined;
		}

		function addFolder(name, parentId, pub) {
			var data = {
				name: name,
				origin: 'production'
			};

			if(!pub){
				data.userId = nuitAuth.getUserId();
			}

			if (parentId) {
				data.parentId = parseFolderId(parentId);
				//delete data.origin;
			}

			return nuitApiProxy('profiles.folders')
				.post(data)
				.then(function (response) {
					response.data.public = pub;
					if (response.data.name === null) {
						response.data.name = name;
					}
					if (data.parent) {
						response.data.root = false;
						var folder = getFolderById(data.parent);
						if (!angular.isArray(folder.children)) {
							folder.children = [];
						}
						folder.children.push(response.data);
					} else {
						response.data.root = true;

						if (pub) {
							publicFolders.push(response.data);
						} else {
							privateFolders.push(response.data);
						}
					}

					reload();
				});
		}

		function swapFolder(folder, secondFolder) {
			return nuitApiProxy('profiles.folders.swap', folder.id)
				.post({folderId: secondFolder.id})
				.then(function () {
					var copy = {
						prevId: angular.copy(folder.prevId),
						nextId: angular.copy(folder.nextId),
						position: angular.copy(folder.position)
					};

					var down = folder.position<secondFolder.position;

					if(down){
						folder.prevId = folder.nextId;
						folder.nextId = secondFolder.nextId;

						secondFolder.nextId = secondFolder.prevId;
						secondFolder.prevId = copy.prevId;

					}else{
						folder.nextId = folder.prevId;
						folder.prevId = secondFolder.prevId;

						secondFolder.prevId = secondFolder.nextId;
						secondFolder.nextId = copy.nextId;
					}

					folder.position = secondFolder.position;
					secondFolder.position = copy.position;

					return reload();
				})
		}

		function getFolderById(id) {
			var result = recursiveSearch(privateFolders, id);
			if (result !== null) {
				return result;
			}

			result = recursiveSearch(publicFolders, id);
			return result;

			function recursiveSearch(array, id) {
				if (id === null) {
					return null;
				}
				if (array === null) {
					return null;
				}
				if (array.length <= 0) {
					return null;
				}
				for (var index in array) {
					if (array[index].id === id) {
						return array[index];
					}

					if (array[index].children) {
						var result = recursiveSearch(array[index].children, id);
						if (result !== null) {
							return result;
						}
					}
				}
				return null;
			}
		}

		function parseFolderId(id){
			var integerPattern = /^[+-]?\d+$/;
			return integerPattern.test(id)?parseInt(id):id;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('ProfileValidateService', ProfileValidateService);

	function ProfileValidateService($translate, $filter, $rootScope, nuitProfile, nuitConfig,
									EVO_EDITOR_SETTINGS, nuitDataService ) {

		var _errors = [];
		var config = {};

		var service = {
			validate: validate
		};

		Object.defineProperty(service, 'errors', {
			get: function () {
				return _errors;
			}
		});

		init();

		return service;



		function init() {
			if(nuitConfig.isReady()) {
				reloadConfig();
			}else{
				$rootScope.$on('config::config.loaded',reloadConfig);
			}
		}

		function reloadConfig() {

			config = angular.copy(nuitConfig.current.evo.editor.validation);
			var configFallback = EVO_EDITOR_SETTINGS.evo.editor.validation;
			if(!config){
				config = configFallback;
			}
			angular.forEach(configFallback, function (value, key) {
				if (!config.hasOwnProperty(key)){
					config[key] = value;
				}
			});

		}


		function validate() {
			clearErrors();
			if (nuitProfile.count() > 0 && nuitProfile.getMaterial()) {
				checkIntersections();
				if (config.blank) {
					checkTotalLength();
				}
				if (config.length) {
					checkTotalDepth();
				}
				if (config.segmentLength) {
					checkSegmentLength();
				}
				if (config.hem) {
					checkHem();
				}
				if (nuitProfile.count() > 1) {
					if (config.bendingAngle) {
						checkMinAngle();
					}
				}
			}
			var filteredArray = _errors.filter(function(item, pos){
				return _errors.indexOf(item)=== pos;
			});
			nuitDataService.replaceAll(_errors, filteredArray);

			return _errors.length === 0;
		}

		function checkIntersections() {
			if (nuitProfile.hasIntersections()) {
				_errors.push($translate.instant('PROFILE.ERROR_DRAWING'));
			}
		}

		function checkTotalLength() {
			if (nuitProfile.getMaterial().restrictions.maxBlank &&
				greaterThan(nuitProfile.getTotalLength(), parseFloat(nuitProfile.getMaterial().restrictions.maxBlank))) {
				_errors.push($translate.instant('PROFILE.ERROR_HIGH_BLANK',
					{maxBlank: $filter('nuitUnit')(nuitProfile.getMaterial().restrictions.maxBlank, 'length')}));
			} else if (nuitProfile.getMaterial().restrictions.minBlank &&
				smallerThan(nuitProfile.getTotalLength(), parseFloat(nuitProfile.getMaterial().restrictions.minBlank))) {
				_errors.push($translate.instant('PROFILE.ERROR_LOW_BLANK',
					{minBlank: $filter('nuitUnit')(nuitProfile.getMaterial().restrictions.minBlank, 'length')}));
			}
		}

		function checkTotalDepth() {
			if (nuitProfile.getMaterial().restrictions.maxLength &&
				greaterThan(nuitProfile.getDepth(), parseFloat(nuitProfile.getMaterial().restrictions.maxLength))) {
				_errors.push($translate.instant('PROFILE.ERROR_HIGH_LENGTH',
					{maxLength: $filter('nuitUnit')(nuitProfile.getMaterial().restrictions.maxLength, 'length')}));
			} else if (nuitProfile.getMaterial().restrictions.minLength &&
				smallerThan(nuitProfile.getDepth(), parseFloat(nuitProfile.getMaterial().restrictions.minLength))) {
				_errors.push($translate.instant('PROFILE.ERROR_LOW_LENGTH',
					{minLength: $filter('nuitUnit')(nuitProfile.getMaterial().restrictions.minLength, 'length')}));
			}
		}

		function checkMinAngle() {
			for (var i = 1; i < nuitProfile.count(); i++) {
				var keyLow = 'PROFILE.ERROR_LOW_ANGLE';
				var wrap = nuitProfile.get(i).isWrap();
				if (nuitProfile.get(i - 1).isWrap()) {
					wrap = true;
				}
				var grad = Math.round(nuitProfile.get(i).getDisplayAngle() * nuitProfile.RAD2DEG);
				if (nuitProfile.getMaterial().restrictions.minBendingAngle &&
					grad < parseFloat(nuitProfile.getMaterial().restrictions.minBendingAngle) && !wrap) {
					_errors.push($translate.instant(keyLow, {minAngle: nuitProfile.getMaterial().restrictions.minBendingAngle}));
				}
			}
		}

		function checkSegmentLength() {
			for (var x = 0; x < nuitProfile.count(); x++) {
				var length = nuitProfile.get(x).length;
				var wrap = nuitProfile.get(x).isWrap();
				var lowSegmentKey = 'PROFILE.ERROR_LOW_SEGMENT_LENGTH';
				var highSegmentKey = 'PROFILE.ERROR_HIGH_SEGMENT_LENGTH';
				if (nuitProfile.getMaterial().restrictions.minSegmentLength &&
					smallerThan(length, parseFloat(nuitProfile.getMaterial().restrictions.minSegmentLength)) && !wrap) {
					_errors.push($translate.instant(lowSegmentKey,
						{minSegmentLength: $filter('nuitUnit')(nuitProfile.getMaterial().restrictions.minSegmentLength, 'length')}));
				}
				if (nuitProfile.getMaterial().restrictions.maxSegmentLength &&
					greaterThan(length, parseFloat(nuitProfile.getMaterial().restrictions.maxSegmentLength)) && !wrap) {
					_errors.push($translate.instant(highSegmentKey,
						{maxSegmentLength: $filter('nuitUnit')(nuitProfile.getMaterial().restrictions.maxSegmentLength, 'length')}));
				}
			}
		}

		function checkHem() {
			for (var x = 0; x < nuitProfile.count(); x++) {
				var hemKey = 'PROFILE.ERROR_HEM_NOT_ALLOW';
				var lowHemKey = 'PROFILE.ERROR_LOW_HEM_LENGTH';
				var highHemKey = 'PROFILE.ERROR_HIGH_HEM_LENGTH';
				var hemAllow = nuitProfile.getMaterial().restrictions.hem;
				if (nuitProfile.get(x).isWrap()) {
					if (!hemAllow ) {
						_errors.push($translate.instant(hemKey));
					}
					if (config.hemLength) {
						var hem = nuitProfile.get(x).length;
						if (nuitProfile.getMaterial().restrictions.minHemLength &&
							smallerThan(hem, parseFloat(nuitProfile.getMaterial().restrictions.minHemLength)) && hemAllow) {
							_errors.push($translate.instant(lowHemKey,
								{minHemLength: $filter('nuitUnit')(nuitProfile.getMaterial().restrictions.minHemLength, 'length')}));
						}
						if (nuitProfile.getMaterial().restrictions.maxHemLength &&
							greaterThan(hem, parseFloat(nuitProfile.getMaterial().restrictions.maxHemLength)) && hemAllow) {
							_errors.push($translate.instant(highHemKey,
								{maxHemLength: $filter('nuitUnit')(nuitProfile.getMaterial().restrictions.maxHemLength, 'length')}));
						}
					}
				}
			}
		}

		function clearErrors() {
			nuitDataService.replaceAll(_errors, []) ;
		}

		function smallerThan(a,b, delta){
			return !isInDeltaRange(a,b, delta) && a < b;
		}

		function greaterThan(a,b, delta){
			return !isInDeltaRange(a,b, delta) && a > b;
		}

		function isInDeltaRange(a,b, delta){
			if(delta === undefined){
				delta = 0.0000001;
			}
			return Math.abs(a-b) < delta;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('ProfileName', ProfileName);

	/** @ngInject */
	function ProfileName($filter, nuitConfig, DotNotationService, FormatterService) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			update: update,
		};

		//*******************************************
		/// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function init() {
		}

		function update(profile) {
			if(!profile){
				return;
			}

			var config = nuitConfig.current;
			if(DotNotationService.hasKey(config, 'evo.editor.defaultProfileName.enabled') && config.evo.editor.defaultProfileName.enabled) {
				if (!profile.name || config.evo.editor.defaultProfileName.forceOverrideOnUpdate) {
					var prefix = config.evo.editor.defaultProfileName.preFix?$filter('nuitFormatter')(config.evo.editor.defaultProfileName.preFix, profile, true, config.evo.editor.defaultProfileName.separator):'';
					var main = config.evo.editor.defaultProfileName.template?$filter('nuitFormatter')(config.evo.editor.defaultProfileName.template, profile, true, config.evo.editor.defaultProfileName.separator):'';
					var postFix = config.evo.editor.defaultProfileName.postFix?$filter('nuitFormatter')(config.evo.editor.defaultProfileName.postFix, profile, true, config.evo.editor.defaultProfileName.separator):'';

					profile.name = FormatterService.trim(prefix + ' ' + main + ' ' + postFix);

					if (profile.name.length > config.evo.cart.profileTitleMaxLength) {
						profile.name = profile.name.substring(0, config.evo.cart.profileTitleMaxLength - 3) + '...';
					}
				} else if (profile.name && !config.evo.editor.defaultProfileName.forceOverrideOnUpdate) {
					profile.name = $filter('nuitTranslate')(profile.name);
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('ProfileFoldersView', factory);

	function factory($q, $translate, $window, $filter, nuitApiProxy, nuitAuth, nuitUtils, nuitProfiles, $mdDialog, ProfileFolders) {
		//*******************************************
		// CONSTANTS
		//*******************************************

		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			rename: rename,
			createRenameDialog: createRenameDialog,
			move: move,
			moveMultiple: moveMultiple,
			remove: remove,
			openFolderDialog: openFolderDialog,
			addRootFolder: addRootFolder,
			addFolder: addFolder,
			swapFolder: swapFolder,
			moveFolder: moveFolder,
			deleteFolder: deleteFolder,
			renameFolder: renameFolder,
			exportProfile: exportProfile,
			importProfile: importProfile
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		/////////////////////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function rename($event, profile) {
				return $mdDialog
					.show(createRenameDialog($event,profile.name))
					.then(function (name) {
						profile.name = name;
						nuitProfiles.logGeometryShape(profile, 'folder rename -> profiles.single PUT');
						ProfileFolders
							.updateProfile(profile)
							.then(nuitUtils.showSuccessToast)
							.catch(nuitUtils.showErrorToast);
					});
		}

		function createRenameDialog($event, name, header, confirm){
			return {
				controller: 'ItemRenameController',
				controllerAs: 'vm',
				templateUrl: 'app/core/dialogs/item-rename/item-rename.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: false,
				autoWrap: false,
				locals: {
					Name: name,
					Locales:{
						header: header?header:'PROFILE.RENAME',
						confirm: confirm?confirm:'PROFILE.RENAME'
					}
				}
			};
		}

		function move($event, folderProfile, selectedFolder, publicFolders, privateFolders) {
			return $mdDialog.show(createMoveDialog($event,selectedFolder,publicFolders, privateFolders))
				.then(function (group) {
					return nuitApiProxy('profiles.update', folderProfile.folderId, folderProfile.data.id)
						.put({folderId: group.id})
						.then(function(){nuitUtils.showSuccessToast();return folderProfile.folderId!==group.id;})
						.catch(nuitUtils.showErrorToast);
				});
		}

		function moveMultiple($event, folderProfiles, selectedFolder, publicFolders, privateFolders){
			return $mdDialog.show(createMoveDialog($event,selectedFolder,publicFolders, privateFolders))
				.then(function (group) {
					if(group.id!==selectedFolder.id) {
						var promises = [];

						for (var i = 0; i < folderProfiles.length; i++) {
							var folderProfile = folderProfiles[i];
							var request = nuitApiProxy('profiles.update', folderProfile.folderId, folderProfile.data.id)
								.put({folderId: group.id});
							promises.push(request);
						}

						return $q.all(promises)
							.catch(nuitUtils.showErrorToast);
					}else{
						throw new Error('source and target folder are the same');
					}
				});
		}

		function createMoveDialog($event, selectedFolder, publicFolders, privateFolders){
			return {
				controller: 'ProfileMoveController',
				controllerAs: 'vm',
				templateUrl: 'app/core/dialogs/move-to-folder/move-to-folder.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: false,
				autoWrap: false,
				locals: {
					PublicFolders: selectedFolder.public ? angular.copy(publicFolders) : null,
					PrivateFolders: selectedFolder.public ? null : angular.copy(privateFolders)
				}
			};
		}

		function remove(profile) {
			return nuitUtils
				.showDeleteConfirmation('PROFILES.DELETE_PROFILE', 'PROFILES.DELETE_PROFILE_HTML')
				.then(function () {
					ProfileFolders
						.deleteProfile(profile.id)
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast);
				});
		}

		function openFolderDialog(header, caption, button, folder, $event) {
			return {
				controller: 'FolderRenameController',
				controllerAs: 'vm',
				templateUrl: 'app/core/dialogs/folder-rename/folder-rename.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: false,
				autoWrap: false,
				locals: {
					Name: folder ? angular.copy(folder.name) : null,
					Header: header,
					Caption: caption,
					Button: button
				}
			};
		}

		function addRootFolder($event) {
			$event.preventDefault();

			return $mdDialog.show(openFolderDialog('FOLDER.ADD', 'FOLDER.NAME', 'APP.SAVE', null, $event))
				.then(function (name) {
					var data = {
						name: name,
						origin: 'production',
						userId: nuitAuth.getUserId()
					};
					return nuitApiProxy('profiles.folders').post(data);
				})
				.then(nuitUtils.showSuccessToast)
				.catch(nuitUtils.showErrorToast);
		}

		function addFolder($event, selectedFolder, pub) {
			$event.preventDefault();

			$mdDialog.show(openFolderDialog('FOLDER.ADD', 'FOLDER.NAME', 'APP.SAVE', null, $event))
				.then(function (name) {
					ProfileFolders
						.addFolder(name, selectedFolder?selectedFolder.id:undefined, pub)
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast);
				});
		}

		function swapFolder(currentFolder, swapId) {
			if (swapId !== null && currentFolder!==null) {
				var folder = ProfileFolders.getFolderById(swapId);
				return ProfileFolders.swapFolder(currentFolder, folder)
					.then(function () {
						return ProfileFolders.getFolderById(currentFolder.id);
					});
			}
		}

		function moveFolder($event, folder, publicFolders, privateFolders) {
			$event.stopPropagation();

			var dialog = {
				controller: 'ProfileMoveController',
				controllerAs: 'vm',
				templateUrl: 'app/core/dialogs/move-to-folder/move-to-folder.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: false,
				autoWrap: false,
				locals: {
					PublicFolders: publicFolders,
					PrivateFolders: privateFolders
				}
			};

			return $mdDialog.show(dialog)
				.then(function (selected) {
					if (selected && selected.id && selected.id !== folder.id) {
						var position = 0;

						if (selected.children) {
							for (var i = 0; i < selected.children.length; i++) {
								position = Math.max(position, selected.children[i].position);
							}
						}

						position++;

						return nuitApiProxy('profiles.folders.single', folder.id).put({
							parentId: selected.id,
							position: position
						});
					}
				});
		}

		function deleteFolder($event, folder) {
			$event.stopPropagation();

			return nuitUtils
				.showDeleteConfirmation('PROFILES.DELETE_FOLDER', 'PROFILES.DELETE_FOLDER_HTML')
				.then(function () {
					return nuitApiProxy('profiles.folders.single', folder.id)
						.delete()
				});
		}

		function renameFolder($event, folder) {
			$event.stopPropagation();

			return $mdDialog
				.show(openFolderDialog('FOLDER.RENAME', 'FOLDER.RENAME_NAME', 'FOLDER.RENAME', folder, $event))
				.then(function (newName) {
					return nuitApiProxy('profiles.folders.single', folder.id)
						.put({name: newName})
						.then(function (response) {
							folder.name = response.data.name;
							nuitUtils.showSuccessToast();
						})
						.catch(nuitUtils.showErrorToast);
				});
		}

		function exportProfile(profile) {
			var profileCopy = angular.copy(profile);

			if (profileCopy.material) {
				delete profileCopy.material;
			}
			if (profileCopy.id) {
				delete profileCopy.id;
			}
			if (profileCopy.updatedAt) {
				delete profileCopy.updatedAt;
			}
			if (profileCopy.image) {
				delete profileCopy.image;
			}
			if (!angular.isArray(profileCopy.stamp)) {
				delete profileCopy.stamp;
			}

			var confirm = $mdDialog.prompt()
				.title($translate.instant('PROFILE.EXPORT'))
				.initialValue(JSON.stringify(profileCopy))
				.ok($translate.instant('APP.OK'));
			return $mdDialog.show(confirm);
		}

		function importProfile(folder) {
			var confirm = $mdDialog.prompt()
				.title($translate.instant('PROFILE.IMPORT'))
				.ok($translate.instant('APP.OK'))
				.cancel($translate.instant('APP.CANCEL'));
			return $mdDialog.show(confirm)
				.then(function (profileData) {
					try {
						nuitProfiles.logGeometryShape(JSON.parse(profileData), 'JSON import -> profile.save');
					} catch (e) {
						console.warn('[geometry-shape] JSON import -> profile.save: not parseable', e);
					}

					nuitApiProxy('profile.save')
						.post(profileData, {folder: folder.id})
						.then(nuitUtils.showSuccessToast)
						.catch(nuitUtils.showErrorToast);
				});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('PositionsService', PositionsService);

	/** @ngInject */
	function PositionsService() {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			markedForDeletionCount: markedForDeletionCount,
			allMarkedForDeletion: allMarkedForDeletion
		};
		//*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************

		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************

		function markedForDeletionCount(positions){
			var deleteCount = 0;
			for(var i=0;i<positions.length;i++){
				if(positions[i].state==='DELETED'){
					deleteCount++;
				}
			}
			return deleteCount;
		}

		function allMarkedForDeletion(positions){
			return markedForDeletionCount(positions)===positions.length;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('PaymentService', factory);

	function factory($window, $filter, nuitApi) {
		//*******************************************
		// CONSTANTS
		//*******************************************

		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// SERVICE
		//*******************************************
		var service = {
			getPaymentByOrderId: getPaymentByOrderId,
			getPaymentStatus: getPaymentStatus
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		/////////////////////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************

		function getPaymentByOrderId(id) {
			return nuitApi('payments.by.order',id).get()
				.then(function(response){
					if(response.data===null){
						return [];
					}else {
						return response.data;
					}
				});
		}

		function getPaymentStatus(id) {
			return getPaymentByOrderId(id)
				.then(function(payments){
					var attempts = {id:id, successful: 0, failed:0, payments:payments, status:'none'};
					var lastPayment;
					var lastPaymentTime = 0;
					for(var i=0;i<payments.length;i++){
						var payment = payments[i];

						var date = new Date(payment.createdAt);

						if(date.getTime()>lastPaymentTime){
							lastPaymentTime = date.getTime();
							lastPayment = payment;
						}

						switch (payment.status){
							case 'paid':
								attempts.successful++;
								break;
							case 'not paid':
								attempts.failed++;
								break;
						}
					}
					if(attempts.successful>0){
						attempts.status = 'successful';
					}else if(attempts.failed>0){
						attempts.status = 'failed';
					}
					attempts.lastPayment = lastPayment;
					return attempts;
				});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('OrderTagsService', factory);

	/** @ngInject */
	function factory(nuitApi, nuitUtils, nuitDataService) {
		//*******************************************
		// VARIABLES
		//*******************************************
        /**
         * Contains all product attributes of the current environment.
         * @type Array
         */
        var _tags = [];
        //*******************************************

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
            add: add,
			remove: remove,
            update: update,
			patch: patch,
            getById: getById,
            getByGroup: getByGroup,
            reload: reload,
		};
        //*******************************************

        //*******************************************
        // PROPERTIES
        //*******************************************
        Object.defineProperty(service, 'tags', { get: function() { return _tags; } });
        //*******************************************

        //*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
        function reload() {
            return nuitApi('order.tags')
                .get()
                .then(function(response) {
					return nuitDataService.replaceAll(_tags,response.data.data);
            	});
        }

        function getByGroup(group) {
            var result = [];
            for(var index in _tags) {
                if(_tags[index].group === group) {
                    result.push(_tags[index]);
                }
            }
            return result;
        }

        function getById(id) {
			return nuitDataService.getOne(_tags,id);
        }

        function add(tag) {
            return nuitApi('order.tags')
                .post(tag)
                .then(function (response) {
					return nuitDataService.addOne(_tags,response.data);
                });
        }

        function update(tag) {
            return nuitApi('order.tags.single', tag.id)
                .put(tag)
                .then(function (response) {
					return nuitDataService.updateOne(_tags,response.data);
                });
        }

		function patch(tag){
			return nuitApi('order.tags.single', tag.id)
				.patch(tag)
				.then(function (response){
					return nuitDataService.updateOne(_tags, response.data);
				});
		}

        function remove(id) {
            return nuitApi('order.tags.single', id)
                .delete()
                .then(function(response) {
					return nuitDataService.removeOne(_tags,id);
            	});
        }
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('nuitUnits', factory);

	/**
	 * Provides shortcut to units.
	 */
	function factory($log, nuitConfig) {
		//*******************************************
		// CONSTANTS
		//*******************************************
        var SILENT = true;
        //*******************************************
        
		//*******************************************
		// VARIABLES
		//*******************************************
        var config = nuitConfig.current;
        //*******************************************

		//*******************************************
		// SERVICE
		//*******************************************
		var service = resolve;

		return service;
        //*******************************************

        ////////////////////////////////////////////////////////////////////////
        
        function resolve(key) {
            if(config.units === undefined) {
                if(!SILENT) { $log.warn('No unit config found!'); }
                return { symbol: '?', factor: 1, decimals: 0 };
            }
            else if(config.units[key] === undefined) {
                if(!SILENT) { $log.warn('No unit config for \''+key+'\' found!'); }
                return { symbol: '?', factor: 1, decimals: 0 };
            }
            
            return config.units[key];
        }
    }

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('nuitLog', nuitLogService);

	function nuitLogService($log) {
		var hasRaven = typeof Raven !== 'undefined';

		var service = {
			error: error,
			message: message,
			userContext: userContext,
			resetUserContext: resetUserContext
		};

		return service;

		function error(error) {
			if (hasRaven) {
				Raven.captureException(error);
			}
			else{
				ravenNotConfigured();
			}
		}

		function message(message) {
			if (hasRaven) {
				Raven.captureMessage(message);
			}else{
				ravenNotConfigured();
			}

		}

		function userContext(context) {
			if (hasRaven) {
				Raven.setUserContext(context);
			}else{
				ravenNotConfigured();
			}
		}

		function resetUserContext() {
			if (hasRaven) {
				Raven.setUserContext({});
			}else{
				ravenNotConfigured();
			}
		}

		function ravenNotConfigured(){
			//$log.log('raven not configured');
		}
	}

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('nuitFilterService', nuitFilterService);

	function nuitFilterService($filter, DotNotationService) {

		var service = {
			matches: matches,
			getAttribute: getAttribute,
			getInputTypes: getInputTypes
		};

		return service;

		function matches(filters, filterValues, entity) {
			for (var i = 0; i < filters.length; i++) {
				var filter = filters[i];
				var value = filterValues[filter.id];

				if (value && value !== '' && !matchesFilter(filter, value,entity)) {
					return false;
				}
			}

			return true;
		}

		function matchesFilter(filter, value, entity){
			var attribute = getAttribute(filter, entity);

			if(!attribute){
				return false;
			}
			else if(filter.inputType==='group' || filter.inputType==='map' || filter.exactMatch){
				if(filter.caseInsensitive && attribute && value){
					return attribute.toLowerCase()===value.toString().toLowerCase();
				}else {
					return attribute === value.toString();
				}
			}else{
				if(filter.caseInsensitive && attribute && value){
					return attribute.toLowerCase().indexOf(value.toString().toLowerCase())>=0;
				}else{
					return attribute.indexOf(value.toString()) >= 0;
				}
			}
		}

		function getAttribute(filter, entity){
			var attribute = DotNotationService.get(entity, filter.attribute);

			if (filter.attributeFilter) {
				if(filter.attributeFilter==='nuitFormatter'){
					return $filter(filter.attributeFilter)(filter.attributeFilterFormat, attribute);
				}else{
					return $filter(filter.attributeFilter)(attribute).toString();
				}
			} else {
				return attribute?attribute.toString():null;
			}
		}

		function getInputTypes () {
			return ['map','group','string'];

			//Define here input types for the filter service

		}
	}

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('nuitErrorService', nuitErrorService);

	function nuitErrorService($mdDialog, $translate, nuitConfig) {

		var service = {
			handle: handle
		};

		return service;

		function handle(error) {
			return showErrorDialog(
				$translate.instant('ERROR.TITLE'),
				getContent(error)
			);
		}

		function getContent(error) {
			return $translate.instant(
				((error && error.code) ? 'ERROR.' + error.code.toUpperCase() : 'ERROR.GENERIC'),
				(error && error.data) ? error.data : null
			) + appendDevMessage(error);
		}

		function appendDevMessage(error)
		{
			return (error && error.msg && nuitConfig.current.servererror)?'<div>'+error.msg + '</div>':'';
		}

		function showErrorDialog(title, content) {
			var alert = $mdDialog.alert({
				title: title,
				htmlContent: content,
				ok: $translate.instant('APP.OK')
			});

			return $mdDialog.show(alert);
		}
	}

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('nuitDataService', nuitDataService);

	/**
	 *unified data manipulation for object arrays that commonly identify objects by an 'id' field or multiple key fields
	 */
	function nuitDataService() {
		var STANDARD_ID = 'id';

		var service = {
			replaceAll: replaceAll,
			mergeAll: mergeAll,
			addOne: addOne,
			removeOne: removeOne,
			removeOneByKeys: removeOneByKeys,
			updateOne: updateOne,
			replaceOne: replaceOne,
			replaceOneByKeys: replaceOneByKeys,
			updateOneByKeys: updateOneByKeys,
			updateOneEntity: updateOneEntity,
			replaceOneEntity: replaceOneEntity,
			getOne: getOne,
			getOneByKeys: getOneByKeys,
			upsertOne: upsertOne,
			getUnique: getUnique,
			getUniqueByKeys: getUniqueByKeys,
            searchFor: searchFor
		};

		return service;

		/**
		 * @param {Array} array will be replaced by newArray
		 * @param {Array} newArray is the new data for array
		 * @returns {Array} updated array
		 */
		function replaceAll(array, newArray) {
			array.splice(0, array.length);

			angular.forEach(newArray, function (entry) {
				array.push(entry);
			});

			return array;
		}


        function searchFor(group, property, value, returnProperty) {
            if(!angular.isArray(group) && !angular.isObject(group)) { return null; }
            if(!angular.isString(property)) { return null; }
            if(returnProperty === undefined) { returnProperty = property; }

            for(var index in group) {
                if(group[index][property] === value) {
                    return group[index][returnProperty];
                }
            }
            return null;
        }

		/**
		 * @param {Array} array that gets a new entry
		 * @param {Object} entry that gets added to the array
		 * @returns {Object} added entry
		 */
		function addOne(array, entry) {
			array.push(entry);
			return entry;
		}

		/**
		 * @param {Array} array that still includes entry
		 * @param {Object} id key of object that needs to be delete
		 * @returns {Object} deleted entry
		 */
		function removeOne(array, id) {
			return removeOneByKeys(
				array,
				buildStandardKey(id)
			);
		}

		/**
		 * @param {Array} array to find entry
		 * @param {Object} keys includes keys for comparison e.g.: {id:1,secondId:2}
		 * @returns {Object} deleted entry
		 */
		function removeOneByKeys(array, keys) {
			var deletedEntry = null;

			angular.forEach(array, function (entry, index) {
				if (isValidObject(entry, keys)) {
					array.splice(index, 1);
					deletedEntry = entry;
				}
			});

			return deletedEntry;
		}

		/**
		 * @param {Array} array old array
		 * @param {Arra} newArray new data for old array
		 * @returns {Array} merged array
		 */
		function mergeAll(array, newArray) {
			if (angular.isArray(newArray)) {
				angular.merge(array, newArray);
			}

			return array;
		}

		/**
		 * @param {Array} array that includes entry that needs to update
		 * @param {Array} updatedEntry entry with changes
		 * @param {string} [keyName] optional comparison key
		 * @return {Object} updated Entry
		 */
		function updateOne(array, updatedEntry, keyName) {
			return updateInternal(
				array,
				updatedEntry,
				buildKeys(updatedEntry, [validateKeyName(keyName)])
			);
		}

		/**
		 * @param {Array} array that includes entry that needs to update
		 * @param {Object} updatedEntry entry with changes
		 * @param {Array} [keyArray] keys that need to be compared
		 * @return {Object} updated Entry
		 */
		function updateOneByKeys(array, updatedEntry, keyArray) {
			return updateInternal(
				array,
				updatedEntry,
				buildKeys(updatedEntry, keyArray)
			);
		}

		/**
		 * @param {Object} entry old entry
		 * @param {Object} newEntry entry that gets merged with old entry
		 * @returns {Object} updated entry
		 */
		function updateOneEntity(entry, newEntry) {
			angular.merge(entry, newEntry);
			return entry;
		}

		/**
		 *
		 * @param {Array} array
		 * @param {Object} updatedEntry
		 * @param {Object} keys to find valid object
		 * @returns {Object} updatedEntry
		 */
		function updateInternal(array, updatedEntry, keys) {
			angular.forEach(array, function (entry) {
				if (isValidObject(entry, keys)) {
					angular.merge(entry, updatedEntry);
				}
			});

			return updatedEntry;
		}

		/**
		 *
		 * @param {Array} searchable data
		 * @param {Object} newEntry
		 * @returns {Object} updatedEntry
		 */
		function replaceOne(array, newEntry){
			return replaceOneByKeys(array,newEntry,buildStandardKey(newEntry.id));
		}

		/**
		 *
		 * @param {Array} searchable data
		 * @param {Object} newEntry
		 * @param {Object} keys to search
		 * @returns {Object} updatedEntry
		 */
		function replaceOneByKeys(array, newEntry, keys){
			var entry = getOneByKeys(array,keys);

			if(entry!==null){
				return replaceOneEntity(entry,newEntry);
			}
			else{
				return entry;
			}
		}

		/**
		 *
		 * @param {Array} oldEntry
		 * @param {Object} newEntry
		 * @returns {Object} updatedEntry
		 */
		function replaceOneEntity(entry, newEntry){
			var prop;

			for(prop in entry) {
				delete entry[prop];
			}

			return angular.merge(entry, newEntry);
		}

		/**
		 * @param {Array} array searchable data
		 * @param {Object} id to select object
		 * @returns {Object} selected object
		 */
		function getOne(array, id) {
			return getOneByKeys(array, buildStandardKey(id));
		}

		/**
		 * @param {Array} array searchable data
		 * @param {Object} keys to find an suitable comparison object
		 * @returns {Object}
		 */
		function getOneByKeys(array, keys) {
			var selectedEntry = null;

			angular.forEach(array, function (entry) {
				if (isValidObject(entry, keys)) {
					selectedEntry = entry;
				}
			});

			return selectedEntry;
		}

		/**
		 * @param {Array} array of searchable data
		 * @param {Object} updatedEntry
		 * @param {Array} [keyArray] to compare objects
		 * @returns {Object} updated entry
		 */
		function upsertOne(array, updatedEntry, keyArray) {
			var currentEntry = getOneByKeys(array, buildKeys(updatedEntry, keyArray));

			if (currentEntry !== null) {
				return updateOneEntity(currentEntry, updatedEntry);
			}
			else {
				return addOne(array, updatedEntry);
			}
		}

		/**
		 * @param {string} keyName passed key name (may be undefined)
		 * @returns {string} valid key
		 */
		function validateKeyName(keyName) {
			if (typeof keyName === 'undefined') {
				keyName = STANDARD_ID;
			}

			return keyName;
		}

		/**
		 * @param {Object} entry that will be checked for valid keys
		 * @param {Object} keys match criterias for entry
		 * @returns {boolean} returns if entry matches search criterias
		 */
		function isValidObject(entry, keys) {
			var isValid = true;

			for (var key in keys) {
				if (keys.hasOwnProperty(key)) {
					isValid = isValid && entry[key] === keys[key];
				}
			}

			return isValid;
		}

		/**
		 * @param {Object} entry to build keys object from
		 * @param {Array} keyArray keys in use
		 */
		function buildKeys(entry, keyArray) {
			if (typeof keyArray === 'undefined') {
				keyArray = [STANDARD_ID];
			}

			var keys = {};

			for (var i = 0; i < keyArray.length; i++) {
				keys[keyArray[i]] = entry[keyArray[i]];
			}

			return keys;
		}

		/**
		 * @param id
		 * @returns {{}}
		 */
		function buildStandardKey(id)
		{
			var keys = {};
			keys[STANDARD_ID] = id;
			return keys;
		}

		/**
		 * @param {Array} array with duplicates
		 * @returns {Array} array that only has entries with unique 'id'
		 */
		function getUnique(array)
		{
			return getUniqueByKeys(array);
		}

		/**
		 * @param {Array} array with duplicates
		 * @param {Array} array with key ids
		 * @returns {Array} array that only has entries with unique ids (defined in keyArray)
		 */
		function getUniqueByKeys(array, keyArray)
		{
			var uniques = [];

			if (typeof keyArray === 'undefined') {
				keyArray = [STANDARD_ID];
			}

			for(var i=0;i<array.length;i++){
				if(getOneByKeys(uniques,buildKeys(array[i],keyArray))===null){
					uniques.push(array[i]);
				}
			}

			return uniques;
		}
	}

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('nuitApiProxy', nuitApiProxy);

	/** @ngInject */
	function nuitApiProxy(nuitApi, nuitAuth) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = resolve;
		//*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************

		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************

		function resolve() {
			var args, name, params;

			args = Array.prototype.slice.call(arguments);

			name = args.shift();
			params = args;

			var apiVersion = nuitAuth.getEvoVersion()===3?2:1;

			if (apiVersion>=2) {
				while(apiVersion>1) {
					var versionName = name + '.v' + apiVersion;
					if (nuitApi.hasRoute(versionName)) {
						name = versionName;
						break;
					}
					apiVersion--;
				}
			}

			return nuitApi.apply(null,[name].concat(params));
		}
	}
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('missingTranslationHandler', missingTranslationHandler);
    
    function missingTranslationHandler() {
        return function(translationId) {
            
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('ListSelectionService', ListSelection);

    /** @ngInject */
    function ListSelection() {
		var _selectionInstances = {};

        var service = initService();

        return service;

        function initService()
		{
			return{
				get: get
			};
		}

		/**
		 *
		 * @param id to return distinct selector instances
		 * @param deselectPreviouslySelected, clears previous selected entities if TRUE
		 * @returns {listSelectorInstance}
		 */
		function get(id,deselectPreviouslySelected)
		{
			if(!_selectionInstances[id])
			{
				_selectionInstances[id] = initInstance();
			}

			if(deselectPreviouslySelected) {
				_selectionInstances[id].deselectAll();
			}

			return _selectionInstances[id];
		}

        function initInstance() {
			var _selectedEntities = [];

			return init();

			function init() {
				return {
					isSelected: isSelected,
					toggleSelectedEntity: toggleSelectedEntity,
					selectAll: selectAll,
					deselectAll: deselectAll,
					toggleSelectedEntities: toggleSelectedEntities,
					getSelected: getSelected,
					allSelected: allSelected,
					allUnselected: allUnselected,
					oneSelected: oneSelected,
					toggleOffSelectedEntities: toggleOffSelectedEntities,
					toggleOnSelectedEntities:toggleOnSelectedEntities,
					toggleIndeterminateSelection:toggleIndeterminateSelection,
					isIndeterminate:isIndeterminate
				};
			}

			/**
			 * toggles selected entity
			 * @param {Object} entity which needs to be added or removed from the current list selection
			 * @param {Event} $event which needs to be canceled in order to prevent multiple click events
			 */
			function toggleSelectedEntity(entity, $event) {
				if(typeof $event !== 'undefined') {
					$event.stopPropagation();
				}

				var position = _selectedEntities.indexOf(entity);

				if (position >= 0) {
					_selectedEntities.splice(position, 1);
				} else {
					_selectedEntities.push(entity);
				}
			}

			/**
			 * returns if an entity is selected
			 * @param {Object} entity to check if selected or not
			 * @returns {boolean} is selected
			 */
			function isSelected(entity) {
				return _selectedEntities.indexOf(entity) >= 0;
			}

			/**
			 * deselects all selected entities
			 */
			function deselectAll() {
				_selectedEntities = [];
			}

			/**
			 * adds all entities to the current selection
			 * @param {Array} entities array of all entities of a list
			 */
			function selectAll(entities) {
				deselectAll();
				angular.forEach(entities, function (entity) {
					_selectedEntities.push(entity);
				});
			}

			/**
			 * toggles all entities to be selected/deselected
			 * @param entities all selectable entities
			 */
			function toggleSelectedEntities(entities,onOffBehaviour) {
				if(onOffBehaviour) {
					if (_selectedEntities.length > 0) {
						deselectAll();
					} else {
						selectAll(entities);
					}
				}else{
					toggleIndeterminateSelection(entities);
				}
			}

			function toggleOffSelectedEntities(entities) {
				for(var i=0;i<entities.length;i++) {
					if(isSelected(entities[i])) {
						toggleSelectedEntity(entities[i]);
					}
				}
			}

			function toggleOnSelectedEntities(entities) {
				for(var i=0;i<entities.length;i++) {
					if(!isSelected(entities[i])) {
						toggleSelectedEntity(entities[i]);
					}
				}
			}

			function toggleIndeterminateSelection(entities) {
				if(!allSelected(entities)) {
					toggleOnSelectedEntities(entities);
				}else{
					toggleOffSelectedEntities(entities);
				}
			}

			function isIndeterminate(entities) {
				return !allSelected(entities) && _selectedEntities.length !==  0;
			}

			function allUnselected(entities) {
				var allUnselected = true;

				for (var i = 0; i < entities.length; i++) {
					var entity = entities[i];
					var position = _selectedEntities.indexOf(entity);

					if (position >= 0) {
						allUnselected = false;
					}
				}

				return allUnselected;
			}

			function allSelected(entities) {
				for (var i = 0; i < entities.length; i++) {
					var entity = entities[i];
					var position = _selectedEntities.indexOf(entity);

					if (position < 0) {
						return false;
					}
				}

				return true;
			}

			function oneSelected(entities) {
				for (var i = 0; i < entities.length; i++) {
					var entity = entities[i];
					var position = _selectedEntities.indexOf(entity);

					if (position >= 0) {
						return true;
					}
				}

				return false;
			}

				/**
			 * returns all selected entities
			 * @returns {Array}
			 */
			function getSelected() {
				return _selectedEntities;
			}
		}
    }
}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($log, $rootScope, $mdTheming, nuitConfig) {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba: rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate() {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy($mdTheming.THEMES);
            var registeredPalettes = angular.copy($mdTheming.PALETTES);

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme) {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName) {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name': colorType.name,
                        'levels': {
                            'default': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            nuitConfig.reload()
			  .finally(function() {
				  $rootScope.$broadcast("themeSet");
			});

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName) {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName) {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName) {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName) {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars) {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched) {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel) {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if (color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255) {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if (contrastLevel) {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if (color.length === 3) {
                return 'rgb(' + color.join(',') + ')';
            } else if (color.length === 4) {
                return 'rgba(' + color.join(',') + ')';
            } else {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel) {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if (color[0] === 255 && color[1] === 255 && color[2] === 255) {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if (color[0] === 0 && color[1] === 0 && color[2] === 0) {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('FormatterService', FormatterService);

	/** @ngInject */
	function FormatterService(DotNotationService, ConditionCheckService) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			format: format,
			matches: matches,
			trim: trim
		};
		//*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function init() {
		}

		function format(format, data, trim, separator) {
			if(angular.isArray(data)){
				return formatArray(format, data, trim, separator?separator:' ');
			}else {
				var conditionParts = format.split('[??]');
				var selectedFormat = format;

				if (conditionParts.length === 3) {
					var conditionJson;

					try {
						conditionJson = JSON.parse(conditionParts[0]);
					} catch (error) {
						conditionJson = [];
					}

					selectedFormat = ConditionCheckService.matchesAll(conditionJson, data, false) ? conditionParts[1] : conditionParts[2];
				}

				var relevantData = gatherData(data, selectedFormat.match(/\{{(.*?)\}}/g));
				var formatted = angular.copy(selectedFormat);

				for (var key in relevantData) {
					if(angular.isArray(relevantData[key])){
						formatted = formatArray(format, relevantData[key], trim, separator?separator:' ');
					}else {
						var toSubstitute = '{{' + key + '}}';
						while (formatted.indexOf(toSubstitute) >= 0) {
							formatted = formatted.replace(toSubstitute, relevantData[key]);
						}
					}
				}

				return trimFormatted(formatted, trim);
			}
		}

		function formatArray(stringFormat, array, trim, separator) {
			var result = [];

			for (var i = 0; i < array.length; i++) {
				result.push(format(stringFormat, array[i], trim));
			}

			return trimFormatted(result.join(separator), trim);
		}

		function trimFormatted(formatted, doTrim) {
			if (doTrim) {
				return trim(formatted);
			} else {
				return formatted;
			}
		}

		function trim(value){
			return value.trim().replace(/\n+\n+/g, "\n");
		}

		function gatherData(data, keys) {
			var relevantData = {};

			if (keys) {
				for (var i = 0; i < keys.length; i++) {
					var keyWithBrackets = keys[i];
					var key = keyWithBrackets.substring(2, keyWithBrackets.length - 2);
					var keySplit = key.split('|');

					var subData = DotNotationService.get(data, keySplit[0]);

					if(angular.isArray(subData)) {
						relevantData[key] = subData;
					}else if(typeof subData === 'boolean'){
						var values = ['true', 'false'];

						if(keySplit[1]){
							values = keySplit[1].split(':');
						}

						relevantData[key] = subData?values[0]:values[1];
					}else if (subData) {
						relevantData[key] = subData.toString();
					} else {
						relevantData[key] = '';
					}
				}
			}

			return relevantData;
		}

		function matches(format, data, searchTerm) {
			var relevantData = gatherData(data, format.match(/\{{(.*?)\}}/g));

			for (var key in relevantData) {
				if (relevantData[key] && relevantData[key].toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0) {
					return true;
				}
			}

			return service.format(format, data).toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('FeedbackService', FeedbackService);

	/** @ngInject */
	function FeedbackService($q, nuitDataService, nuitApi, BendingMachineService) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var _notes = [];
		var _queue = [];
		var USE_QUEUE = false;

		var service = {
			reload: reload,
			postFeedback: postFeedback,
			getFeedback: getFeedback
		};
		//*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************
		Object.defineProperty(service, 'notes', {
			get: function(){return _notes;}
		});
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function reload(){
			return nuitApi('feedback.notes').get()
				.then(function(response){
					nuitDataService.replaceAll(_notes,response.data);
					return _notes;
				});
		}

		function postFeedback(feedback){
			return nuitApi('feedback.create').post(feedback);
		}


		function getFeedback(productionProfile){
			var machine = BendingMachineService.getByIdOffline(productionProfile.bendingMachineId);

			if(machine.customData && machine.customData.wikant) {
				var id = [
							productionProfile.profile.geometryId,
							productionProfile.bendingMachineId,
							productionProfile.profile.materialId
						].join('_');

				var entry = nuitDataService.getOne(_queue,id);

				if(entry){
					return entry.deferred.promise;
				}else{
					var deferred = $q.defer();
					_queue.push({id: id, deferred: deferred, profile: productionProfile, inProgress: false});
					processQueue();
					return deferred.promise;
				}
			}else{
				throw new Error('no wikant machine data');
			}
		}

		function processQueue(){
			if(USE_QUEUE) {
				if (_queue.length === 0) {
					return;
				} else if (!_queue[0].inProgress) {
					resolveRequest(_queue[0])
						.finally(function () {
							_queue.shift();
							processQueue();
						});
				}
			}else{
				resolveRequest(_queue.shift());
			}
		}

		function resolveRequest(entry){
			entry.inProgress = true;
			var profile = entry.profile;
			var deferred = entry.deferred;

			return nuitApi('feedback.get', profile.bendingMachineId, profile.profile.geometryId, profile.profile.materialId).get()
				.then(function (response) {
					deferred.resolve({
						geometryId: profile.profile.geometryId,
						machineId: profile.bendingMachineId,
						materialId: profile.profile.materialId,
						manufacturable: response.data.manufacturable === 1,
						probability: Math.round(response.data.probability * 100 * 100) / 100
					});
				})
				.catch(function (error) {
					deferred.reject(error);
				});
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('FavoriteService', FavoriteService);

	/** @ngInject */
	function FavoriteService($filter) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			sort: sort
		};
		//*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function init() {
		}

		function sort(array) {
			var sorted = [];
			var lookup = {};

			for (var i = 0; i < array.length; i++) {
				var entity = array[i];

				var weight = entity.favorite?entity.favorite:0;

				if (!lookup[weight]) {
					sorted.push({weight: weight, array: []});
					lookup[weight] = sorted[sorted.length-1].array;
				}

				lookup[weight].push(entity);
			}

			sorted = $filter('orderBy')(sorted, 'weight', true);

			var result = []

			for(var i = 0; i< sorted.length; i ++){
				result = result.concat(sorted[i].array);
			}

			return result;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('DotNotationService', DotNotationService);

	/** @ngInject */
	function DotNotationService() {
		var service = init();

		return service;

		function init() {
			return {
				hasKey: hasKey,
				get: get,
				add: add,
				set: set,
				remove: remove
			};

			function hasKey(object, dotNotation) {
				if (isValid(object)) {
					return hasKeyRecursive(object, dotNotation.split('.'), 0);
				}
				else {
					return false;
				}
			}

			function isValid(object) {
				return typeof object !== 'undefined' && object !== null;
			}

			function hasKeyRecursive(object, keys, index) {
				if (isQuery(object, keys[index])) {
					return hasQueryValue(object, keys[index]);
				} else if (object !== null && (object.hasOwnProperty(keys[index]))) {
					return hasKeyRecursive(object[keys[index]], keys, ++index);
				}
				else {
					return keys.length === index;
				}
			}

			function isQuery(object, query) {
				return object && query && query[0] === '?';
			}

			function hasQueryValue(object, query) {
				return getQueryValue(object, query) !== undefined;
			}

			function get(object, dotNotation, defaultValue) {
				if (hasKey(object, dotNotation)) {
					return getByKeyRecursive(object, dotNotation.split('.'));
				}
				else {
					return typeof defaultValue === 'undefined' ? null : defaultValue;
				}
			}

			function getQueryValue(object, query) {
				var split = query.substr(1, query.length - 1).split('=');

				for (var key in object) {
					var subObject = object[key];

					if (subObject[split[0]] && subObject[split[0]].toString() === split[1]) {
						return subObject;
					}
				}

				return undefined;
			}

			function getByKeyRecursive(object, keys) {
				if (keys.length === 0) {
					return object;
				}
				else {
					if (isQuery(object, keys[0])) {
						return getByKeyRecursive(getQueryValue(object, keys.shift()), keys);
					} else {
						return getByKeyRecursive(object[keys.shift()], keys);
					}
				}
			}

			function add(object, dotNotation, value) {
				if (isValid(object)) {
					addRecursive(object, dotNotation.split('.'), value, 0);
					return true;
				}
				else {
					return false;
				}
			}

			function addRecursive(object, keys, value, index) {
				var key = keys[index];

				if (!object.hasOwnProperty(key) || !isValid(object[key])) {
					object[key] = {};
				}

				if (keys.length - 1 === index) {
					if (isQuery(object, key)) {
						throw new Error('Adding to query object is not supported');
					} else {
						object[key] = value;
					}
				}
				else {
					if (isQuery(object, key)) {
						addRecursive(getQueryValue(object, key), keys, value, ++index);
					} else {
						addRecursive(object[key], keys, value, ++index);
					}
				}
			}

			function remove(object, dotNotation) {
				if (hasKey(object, dotNotation)) {
					removeInternal(object, dotNotation.split('.'));
					return true;
				}
				else {
					return false;
				}
			}

			function removeInternal(object, keys) {
				while (keys.length > 1) {
					if (isQuery(object, keys[0])) {
						object = getQueryValue(object, keys.shift());
					} else {
						object = object[keys.shift()];
					}
				}

				if (isQuery(object, keys[0])) {
					throw new Error('Deleting query object is not supported');
				} else {
					delete object[keys.shift()];
				}
			}

			function set(object, dotNotation, value) {
				if (hasKey(object, dotNotation)) {
					return setByKeyRecursive(object, dotNotation.split('.'), value);
				} else {
					return addRecursive(object, dotNotation.split('.'), value, 0);
				}
			}

			function setByKeyRecursive(object, keys, value) {
				if (keys.length === 1) {
					if (isQuery(object, keys[0])) {
						throw new Error('Setting query object is not supported');
					} else {
						object[keys[0]] = value;
						return true;
					}
				}
				else {
					if (isQuery(object, keys[0])) {
						return setByKeyRecursive(getQueryValue(object, keys.shift()), keys, value);
					} else {
						return setByKeyRecursive(object[keys.shift()], keys, value);
					}
				}
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('DateSearchService', DateSearchService);

	/** @ngInject */
	function DateSearchService(DotNotationService) {
		var _enabled = false;
		var _startDate = new Date();
		var _endDate = new Date();

		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			reset: reset,
			initDates: initDates,
			setDates: setDates,
			inBetween: inBetween,
			validateStartDate: validateStartDate,
			validateEndDate: validateEndDate
		};
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(service, 'enabled',
			{
				get: function(){return _enabled;},
				set: function(value){ _enabled = value;}
			});
		Object.defineProperty(service, 'startTimestamp', {get:function(){return _startDate.getTime();}});
		Object.defineProperty(service, 'endTimestamp', {get:function(){return _endDate.getTime();}});
		Object.defineProperty(service, 'startDate', {get:function(){return _startDate;}});
		Object.defineProperty(service, 'endDate', {get:function(){return _endDate;}});
		//*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function init() {
		}

		function initDates(startOffset, endOffset){
			reset();
			var now = Date.now();
			var result = setDates(
				new Date(now + (startOffset?startOffset:0)*86400000),
				new Date(now + (endOffset?endOffset:0)*86400000)
			);

			return result;
		}

		function setDates(startDate,endDate){
			_startDate = validateStartDate(startDate);
			_endDate = validateEndDate(startDate,endDate);
			return {startDate:_startDate, endDate:_endDate};
		}

		function inBetween(entity,attribute) {
			if(_enabled && DotNotationService.hasKey(entity,attribute)){
				var value = DotNotationService.get(entity,attribute,0);
				return value >= _startDate.getTime()/1000 && value	<= _endDate.getTime()/1000;
			}
			return true;
		}

		function validateStartDate(start){
			var startDate = new Date(start.getTime());
			startDate.setHours(0,0,0,0);
			return startDate;
		}

		function validateEndDate(start, end) {
			var startTimestamp = start.getTime();
			var endTimeStamp = end.getTime();
			if(startTimestamp > endTimeStamp){
				endTimeStamp = startTimestamp;
			}

			var endDate = new Date(endTimeStamp);
			endDate.setHours(23,59,59,999);
			return endDate;
		}

		function reset(){
			_enabled = false;
			_startDate = new Date();
			_endDate = new Date();
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('ConditionCheckService', ConditionCheck);

	/** @ngInject */
	function ConditionCheck(DotNotationService) {
		var service = {
			matches: matches,
			matchesAll: matchesAll,
			getConditions: getConditions,
			getOperators: getOperators
		};

		return service;

		function matches(condition, object) {
			switch (condition.type) {
				case 'isSet':
					return DotNotationService.get(object, condition.attribute, null) !== null;
				case 'isNotSet':
					return DotNotationService.get(object, condition.attribute, null) === null;
				case 'isEqual':
					return isEqual(condition, object);
				case 'isNotEqual':
					return !isEqual(condition, object);
				case 'true':
					return true;
				case 'false':
					return false;
				default:
					return false;
			}
		}

		function matchesAll(conditions, object, defaultReturnValue) {
			var matchesAll = true;
			var lastOperator = 'and';

			angular.forEach(conditions, function(condition){
				switch(lastOperator){
					case 'or':
						matchesAll = matchesAll || matches(condition, object);
						break;
					default:
						matchesAll = matchesAll && matches(condition, object);
						break;
				}

				lastOperator = condition.operator;
			});

			return (conditions.length===0 && defaultReturnValue!==undefined)?defaultReturnValue:matchesAll;
		}

		function isEqual(condition, object){
			var objectValue = DotNotationService.get(object, condition.attribute, null);

			if(objectValue!==null && condition.value!==null){
				return objectValue.toString() === condition.value.toString();
			}else{
				return false;
			}
		}

		function getConditions() {
			return ['isSet', 'isNotSet', 'isEqual', 'isNotEqual', 'true', 'false'];
		}

		function getOperators(){
			return ['and', 'or'];
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('ComparatorService', ComparatorService);

	function ComparatorService() {

		var service = {
			matches: matches
		};

		return service;

		function matches(comparator, filter, value) {
			switch(comparator){
				case '<':
					return value<filter;
				case '<=':
					return value<=filter;
				case '=':
					return value===filter;
				case '>':
					return value>filter;
				case '>=':
					return value>=filter;
			}
		}
	}

})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('CaseService', CaseService);

	/** @ngInject */
	function CaseService() {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			snakeToCamelCase: snakeToCamelCase,
		};
		//*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************

		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************

		function snakeToCamelCase(snakeCasedString){
			var split = snakeCasedString.split('_');
			for(var i=1;i<split.length;i++){
				split[i] = split[i][0].toUpperCase() + split[i].substring(1,split[i].length);
			}
			var camelCasedString = split.join('');

			return camelCasedString;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.factory('CalendarTranslation', CalendarTranslation);

	/** @ngInject */
	function CalendarTranslation($translate, $mdDateLocale) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			update: update
		};

		return service;

		function update(){
			$mdDateLocale.months = [
				getMonth('January'),
				getMonth('February'),
				getMonth('March'),
				getMonth('April'),
				getMonth('May'),
				getMonth('June'),
				getMonth('July'),
				getMonth('August'),
				getMonth('September'),
				getMonth('October'),
				getMonth('November'),
				getMonth('December'),
			];

			$mdDateLocale.shortMonths.splice(0,$mdDateLocale.shortMonths.length);

			for(var i=0;i<$mdDateLocale.months.length;i++){
				$mdDateLocale.shortMonths.push($mdDateLocale.months[i].substr(0,3));
			}

			$mdDateLocale.days = [
				getDay('Sunday'),
				getDay('Monday'),
				getDay('Tuesday'),
				getDay('Wednesday'),
				getDay('Thursday'),
				getDay('Friday'),
				getDay('Saturday'),
			];

			$mdDateLocale.shortDays.splice(0,$mdDateLocale.shortDays.length);

			for(var i=0;i<$mdDateLocale.days.length;i++){
				$mdDateLocale.shortDays.push($mdDateLocale.days[i].substr(0,1));
			}

			$mdDateLocale.monthHeaderFormatter = function(date) {
				return $mdDateLocale.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
			};
		}

		function getMonth(defaultValue){
			var key = 'APP.' + defaultValue.toUpperCase();

			var translation = $translate.instant(key);

			if(key===translation){
				return defaultValue;
			}else{
				return translation;
			}
		}

		function getDay(value){
			var key = 'APP.' + value.toUpperCase();

			var translation = $translate.instant(key);

			if(key===translation){
				return value;
			}else{
				return translation;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('AddressService', AddressService);

	/** @ngInject */
	function AddressService($rootScope, $mdDialog, nuitDataService, nuitConfig, DotNotationService) {
		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			openDialog: openDialog,
			openAndSave: openAndSave,
			getCompanyAddressFormat: getCompanyAddressFormat,
			getCompanyAddressFormatByCountry: getCompanyAddressFormatByCountry
		};
		//*******************************************

		var addressFormat = '{{name}}\n{{nameAdditional}}\n{{street}}\n{{countryCode}}-{{zipCode}} {{city}}';
		var addressFormatByCountry = [];

		//*******************************************
		/// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function init() {
			if(nuitConfig.isReady()) {
				setAddressFormat();
			}else{
				$rootScope.$on('config::config.loaded',setAddressFormat);
			}
		}

		function setAddressFormat(){
			if(DotNotationService.hasKey(nuitConfig.current, 'ims.companies.details.addressFormat')){
				addressFormat = nuitConfig.current.ims.companies.details.addressFormat;
			}
			if(DotNotationService.hasKey(nuitConfig.current, 'ims.companies.details.addressFormatByCountry')){
				addressFormatByCountry = nuitConfig.current.ims.companies.details.addressFormatByCountry;
			}
		}

		function openDialog(currentAddress, company, addressType) {
			return $mdDialog.show({
				controller: 'OrderAddressDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/core/dialogs/order-address/order-address-dialog.html',
				clickOutsideToClose: false,
				locals: {
					Address: currentAddress,
					Addresses: company ? company[addressType] : null,
					AddressApi: company ? {api: addressType, companyId: company.id} : null
				}
			});
		}

		function openAndSave(parent, addressKey, company, addressType){
			if(!parent[addressKey]){
				parent[addressKey] = {};
			}

			return openDialog(parent[addressKey], company, addressType)
				.then(function(address){
					if(address){
						nuitDataService.replaceOneEntity(parent[addressKey], address);
					}
				});
		}

		function getCompanyAddressFormat(){
			return addressFormat;
		}

		function getCompanyAddressFormatByCountry(){
			return addressFormatByCountry;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.service('AddressWrapperService', AddressWrapperService);

	/** @ngInject */
	function AddressWrapperService(DotNotationService) {
		var conversion = [
			['companyname', 'name'],
			['additional_companyname', 'nameAddition'],
			['contact_name', 'customData.order.contactName'],
			['contact_phone', 'customData.order.contactPhone'],
			['street', 'street'],
			['country', 'countryCode'],
			['area', 'area'],
			['zip', 'zipCode'],
			['city', 'city']
		];


		//*******************************************
		/// SERVICE
		//*******************************************
		var service = {
			orderToCompany: orderToCompany,
			companyToOrder: companyToOrder,
			areOrderAddressesEqual: areOrderAddressesEqual,
			isOrderAddressEqualToCompanyAddress: isOrderAddressEqualToCompanyAddress
		};
		//*******************************************

		//*******************************************
		/// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		return service;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// PUBLIC METHODS
		//*******************************************
		function init() {
		}

		function orderToCompany(orderAddress) {
			var companyAddress = {};

			for (var i = 0; i < conversion.length; i++) {
				DotNotationService.set(
					companyAddress,
					conversion[i][1],
					DotNotationService.get(orderAddress, conversion[i][0], null)
				);
			}

			return companyAddress;
		}

		function companyToOrder(companyAddress) {
			var orderAddress = {};

			for (var i = 0; i < conversion.length; i++) {
				DotNotationService.set(
					orderAddress,
					conversion[i][0],
					DotNotationService.get(companyAddress, conversion[i][1], null)
				);
			}

			return orderAddress;
		}

		function isOrderAddressEqualToCompanyAddress(orderAddress,companyAddress){
			return areOrderAddressesEqual(orderAddress,companyToOrder(companyAddress));
		}

		function areOrderAddressesEqual(orderAddress1,orderAddress2){
			var valuesToCompare = [
				'companyname',
				'additional_companyname',
				'street',
				'country',
				'area',
				'zip',
				'city'
			];

			for (var i = 0; i < valuesToCompare.length; i++) {
				var key = valuesToCompare[i];
				if(orderAddress1[key] !== orderAddress2[key]){
					return false;
				}
			}

			return true;
		}
	}
}());

(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('nuitUtils', nuitUtilsProvider);

    /** @ngInject */
    function nuitUtilsProvider() {
        //*******************************************
        // PROVIDER
        //*******************************************
        var provider = this;
        //*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        provider.$get = nuitUtils;
        //*******************************************

        //*******************************************
        // SERVICE
        //*******************************************
        /** @ngInject */
        function nuitUtils($window, $q, $mdToast, $mdDialog, $translate) {
            //*******************************************
            // SERVICE
            //*******************************************
            var service = {
				showLoadingScreen: showLoadingScreen,
				showBlocker: showBlocker,
                showSuccessToast: showSuccessToast,
                showErrorToast: showErrorToast,
                showDeleteConfirmation: showDeleteConfirmation,
                showDeleteMultiConfirm: showDeleteMultiConfirm,
                showConfirmationDialog: showConfirmationDialog,
				showMaterialDialog: showMaterialDialog,
				showMaterialDialogWithPreselect: showMaterialDialogWithPreselect,
				showMaterialDialogWithWhitelist: showMaterialDialogWithWhitelist,
				showImageUploadDialog: showImageUploadDialog,
				showFeedbackDialog: showFeedbackDialog,
				isValidPassword: isValidPassword,
				magnifyImage: magnifyImage,
				clearObj: clearObj,
				showAttachment: showAttachment
            };

            return service;
            //*******************************************

            ////////////////////////////////////////////////////////////////////////

			/**
			 * Displays a loading screen until the given promise has been resolved.
			 * @param {Promise} promise
			 * @return {Promise}
			 */
			function showLoadingScreen(promise) {
				var deferred = $q.defer();
				promise.finally(function() {
					deferred.resolve();
				});
				return $mdDialog.show({
					controller: 'LoadingController',
					controllerAs: 'vm',
					templateUrl: 'app/core/dialogs/loading/loading.html',
					parent: document.body,
					multiple: true,
					locals: {
						Deferred: deferred
					}
				});
			}

			function
			showBlocker(options) {
				return $mdDialog.show({
					controller: 'BlockerController',
					controllerAs: 'vm',
					templateUrl: 'app/core/dialogs/blocker/blocker.html',
					parent: document.body,
					multiple: true,
					locals: {
						Options: options
					}
				});
			}

            /**
             * Shows a delete confirmation dialog which should
             * be displayed before a delete action is being done.
             * @param {String} title - translation string for the dialog title
             * @param {String} content - translation string for the dialog body
             * @returns {Promise}
             */
            function showDeleteConfirmation(title, content) {
                if(!title) { title = 'APP.DELETE'; }
                if(!content) { content = 'DELETE.CONFIRM'; }

                return showConfirmationDialog(title, content);
            }

            /**
             * Shows a delete confirmation dialog which should
             * be displayed before a delete action is being done where
             * multiple elements are being deleted.
             * @param {String} title - translation string for the dialog title
             * @param {String} content - translation string for the dialog body
             * @returns {Promise}
             */
            function showDeleteMultiConfirm(title, content) {
                if(!title) { title = 'APP.DELETE_MULTIPLE'; }
                if(!content) { content = 'DELETE.CONFIRM_MULTIPLE'; }

                return showConfirmationDialog(title, content);
            }

            /**
             * Shows a confirmation dialog which should
             * be displayed before a critical action is being done.
             * @param {String} title - translation string for the dialog title
             * @param {String} content - translation string for the dialog body
             * @returns {Promise}
             */
            function showConfirmationDialog(title, content) {
                var confirm = $mdDialog.confirm()
                .title($translate.instant(title))
                .htmlContent($translate.instant(content))
                .ariaLabel(content)
                .ok($translate.instant('APP.OK'))
                .cancel($translate.instant('APP.CANCEL'));

                confirm._options.multiple = true;

                return $mdDialog.show(confirm);
            }

            /**
             * Displays a success toast at the bottom right corner.
             * Usually used after successful API calls.
             * @param {String} message - translation key override (default: 'MESSAGE.SUCCESS')
             * @return {Promise} Toast promise
             */
            function showSuccessToast(message) {
                if(!angular.isString(message)) { message = 'MESSAGE.SUCCESS'; }
                return $mdToast.show($mdToast
                    .simple()
                    .position('bottom right')
                    .textContent($translate.instant(message)));
            }

            /**
             * Displays a red error toast at the bottom right corner.
             * Usually used after cancled or erroneous API calls.
             * @param {String} message - translation key override (default: 'MESSAGE.ERROR')
             * @return {Promise} Toast promise
             */
             function showErrorToast(message) {
                if(!angular.isString(message)) { message = 'MESSAGE.ERROR'; }
                return $mdToast.show($mdToast
                    .simple()
                    .toastClass('md-toast-error')
                    .position('bottom right')
                    .textContent($translate.instant(message)));
            }

			/** Checks if a password has a valid format and if it doesn't shows an popup*/
			function isValidPassword(password)
			{
				var reg = new RegExp('^\s*([0-9a-zA-Z!$@]*)\s*$');

				if(password.match(reg))
				{
					return true;
				}
				else
				{
					var popup = $mdDialog.alert()
						.title($translate.instant('ERROR.TITLE'))
						.htmlContent($translate.instant('ERROR.PASSWORD_INVALID_CHARACTERS'))
						.ok($translate.instant('APP.OK'));

					$mdDialog.show(popup);
					return false;
				}
			}

			/**
			 * Displays the material selection dialog.
			 * @param {Boolean} multiple - true if user should be able to select multiple materials
			 * @return {Promise}
			 */
			function showMaterialDialog(multiple, $event) {
				return showMaterialDialogInternal(
					{
						Multiple: multiple
					},
					$event);
			}

			function showMaterialDialogWithWhitelist(multiple, whitelistMaterials, whitelistGroups, selectedMaterialIds, $event) {
				return showMaterialDialogInternal(
					{
						Multiple: multiple,
						SelectedMaterialIds: angular.isArray(selectedMaterialIds) ? selectedMaterialIds : [],
						MaterialWhitelist: angular.isArray(whitelistMaterials) ? whitelistMaterials : null,
						GroupWhitelist: angular.isArray(whitelistGroups) ? whitelistGroups : null
					},
					$event);
			}

			function showMaterialDialogWithPreselect(multiple,selectedMaterialIds, unavailableGroups, $event){
				return showMaterialDialogInternal(
					{
						Multiple: multiple,
						SelectedMaterialIds: selectedMaterialIds,
						UnavailableGroups: unavailableGroups
					},
					$event);
			}

			function showMaterialDialogInternal(locals,$event){
                if(!angular.isDefined(locals.SelectedMaterialIds)) { locals.SelectedMaterialIds = []; }
                if(!angular.isDefined(locals.UnavailableGroups)) { locals.UnavailableGroups = []; }
                if(!angular.isDefined(locals.MaterialWhitelist)) { locals.MaterialWhitelist = null; }
                if(!angular.isDefined(locals.GroupWhitelist)) { locals.GroupWhitelist = null; }

				return $mdDialog.show({
					controller: 'MaterialDialogController',
					controllerAs: 'vm',
					templateUrl: 'app/core/dialogs/material/material-dialog.html',
					parent: document.body,
					targetEvent: $event,
					clickOutsideToClose: true,
					multiple: true,
					locals: locals
				});
			}

			/**
			 * Displays an image upload dialog.
			 * Usually used after successful API calls.
			 * @return {Promise} promise and "url" on success
			 */
			function showImageUploadDialog(route, includeAllResponseData, fileRestrictions, maxFileSize, routeArguments) {
				return $mdDialog
					.show(
						{
							controller: 'ImageUploadController',
							controllerAs: 'vm',
							templateUrl: 'app/core/dialogs/image.upload/image.upload.html',
							clickOutsideToClose: true,
							multiple: true,
							locals : {
								Route : route,
								IncludeAllResponseData: includeAllResponseData?includeAllResponseData:false,
								FileRestrictions: fileRestrictions?fileRestrictions:[],
								MaxFileSize: maxFileSize?maxFileSize:-1,
								MaxImageWidth: 2048,
								MaxImageHeight: 2048,
								Arguments: routeArguments?routeArguments:undefined
							}
						}
					);
			}

			function createImageDialog(image, $event) {
				return {
					controller: 'ImageDialogController',
					controllerAs: 'vm',
					templateUrl: 'app/core/dialogs/image/image.html',
					clickOutsideToClose: true,
					targetEvent: $event,
					multiple: true,
					locals: {
						image: image
					}
				};
			}

			function magnifyImage(image, $event) {
				if (!angular.isString(image)) {
					return;
				}
				return $mdDialog.show(createImageDialog(image, $event));
			}

			/**
			 * Deletes all properties of an object.
			 * @param {Object} obj
			 * @return {Object}
			 */
			function clearObj(obj) {
				var prop;
				for(prop in obj) {
					delete obj[prop];
				}
				return obj;
			}

			/**
			embeds base64 data in a new window/iframe
			 */
			function showAttachment(data){
				var window = $window.open();
				window.document.write("<iframe style='border:0' width='100%' height='100%' src="+ data.toString() + "></iframe>");
				window.document.body.style='margin:0';
			}

			function showFeedbackDialog(oldProfile, newProfile, productionProfile) {
				return $mdDialog
					.show(
						{
							controller: 'FeedbackController',
							controllerAs: 'vm',
							templateUrl: 'app/core/dialogs/feedback/feedback.html',
							clickOutsideToClose: true,
							multiple: true,
							locals : {
								OldProfile : oldProfile,
								NewProfile : newProfile,
								ProductionProfile: productionProfile
							}
						}
					);
			}
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('nuitTheme', nuitThemeProvider);

    /** @ngInject */
    function nuitThemeProvider($mdThemingProvider) {
        //*******************************************
        // PROVIDER
        //*******************************************
        var provider = this;
        //*******************************************
        
        //*******************************************
        // VARIABLES
        //*******************************************
        var pageHeader = angular.element('head');
        var pageStyle = angular.element('<style type="text/css"></style>');
        //*******************************************
        
        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        provider.$get = nuitTheme;
        provider.insertPalette = insertPalette;
        provider.insertTheme = insertTheme;
        provider.sanitizePalette = sanitizePalette;
        provider.insertCSS = insertCSS;
        //*******************************************

        //*******************************************
        // INITIALIZATION
        //*******************************************
        init();
        //*******************************************
        
        //*******************************************
        // METHODS
        //*******************************************
        /**
         * Initializes the theme provider.
         */
        function init() {
            pageHeader.append(pageStyle);
            $mdThemingProvider.alwaysWatchTheme(true);
        }
        /**
         * Inserts a palette into the theming provider.
         * @param {Object} palette - palette object
         */
        function insertPalette(palette) {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        }
        /**
         * Inserts a theme into the theming provider.
         * @param {Object} theme - theme object
         * @param {String} themeName - name of the theme
         */
        function insertTheme(theme, themeName) {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        }
        /**
         * Inserts css data to the page
         * @param {type} css
         * @param {Boolean} clear - true, if css should be cleared beforehand
         * @returns {undefined}
         */
        function insertCSS(css, clear) {
            if(clear) { pageStyle.html(''); }
            pageStyle.append(css);
        }
        /**
         * Sanitizes a palette. (From angular materials.)
         * @param {type} palette
         * @param {type} name
         * @returns {undefined}
         */
        function sanitizePalette(palette, name) {
            var DARK_CONTRAST_COLOR = [0,0,0,0.87];
            var LIGHT_CONTRAST_COLOR = [255,255,255,0.87];
            var STRONG_LIGHT_CONTRAST_COLOR = [255,255,255];
            var defaultContrast = palette.contrastDefaultColor;
            var lightColors = palette.contrastLightColors || [];
            var strongLightColors = palette.contrastStrongLightColors || [];
            var darkColors = palette.contrastDarkColors || [];

            // These colors are provided as space-separated lists
            if (typeof lightColors === 'string')
                lightColors = lightColors.split(' ');
            if (typeof strongLightColors === 'string')
                strongLightColors = strongLightColors.split(' ');
            if (typeof darkColors === 'string')
                darkColors = darkColors.split(' ');

            // Cleanup after ourselves
            delete palette.contrastDefaultColor;
            delete palette.contrastLightColors;
            delete palette.contrastStrongLightColors;
            delete palette.contrastDarkColors;

            // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
            angular.forEach(palette, function (hueValue, hueName) {
                if (angular.isObject(hueValue))
                    return; // Already converted
                // Map everything to rgb colors
                var rgbValue = colorToRgbaArray(hueValue);
                if (!rgbValue) {
                    throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
                        .replace('%1', hueValue)
                        .replace('%2', palette.name)
                        .replace('%3', hueName));
                }

                palette[hueName] = {
                    hex: palette[hueName],
                    value: rgbValue,
                    contrast: getContrastColor()
                };
                function getContrastColor() {
                    if (defaultContrast === 'light') {
                        if (darkColors.indexOf(hueName) > -1) {
                            return DARK_CONTRAST_COLOR;
                        } else {
                            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
                                : LIGHT_CONTRAST_COLOR;
                        }
                    } else {
                        if (lightColors.indexOf(hueName) > -1) {
                            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
                                : LIGHT_CONTRAST_COLOR;
                        } else {
                            return DARK_CONTRAST_COLOR;
                        }
                    }
                }
            });
        }
        /**
         * Converts hex color string to a color array. (From angular materials.)
         * @param {String} clr
         * @returns {Array|undefined|nuit-theme.providerL#1.nuitThemeProvider.colorToRgbaArray.clr}
         */
        function colorToRgbaArray(clr) {
            if (angular.isArray(clr) && clr.length === 3)
                return clr;
            if (/^rgb/.test(clr)) {
                return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function (value, i) {
                    return i === 3 ? parseFloat(value, 10) : parseInt(value, 10);
                });
            }
            if (clr.charAt(0) === '#')
                clr = clr.substring(1);
            if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr))
                return;

            var dig = clr.length / 3;
            var red = clr.substr(0, dig);
            var grn = clr.substr(dig, dig);
            var blu = clr.substr(dig * 2);
            if (dig === 1) {
                red += red;
                grn += grn;
                blu += blu;
            }
            return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
        }
        //*******************************************
        
        //*******************************************
        // SERVICE
        //*******************************************
        /** @ngInject */
        function nuitTheme($mdTheming) {            
            //*******************************************
            // SERVICE
            //*******************************************
            var service = {
                insertPalette: insertPalette,
                registerTheme: registerTheme,
                insertCSS: insertCSS,
                sanitizePalette: sanitizePalette
            };
            
            return service;
            //*******************************************

            ////////////////////////////////////////////////////////////////////////
			
			function registerTheme(themeName, theme) {
				$mdTheming.defineTheme(themeName, {
					primary: theme.primary.name,
					accent: theme.accent.name,
					warn: theme.warn.name,
					background: theme.background.name
				});
			}
        }
    }
})();


(function () {
	'use strict';

	angular
	  .module('app.core')
	  .provider('nuitShop', provider);

	/** @ngInject */
	function provider() {
		//*******************************************
		// PROVIDER
		//*******************************************
		var provider = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		provider.$get = factory;
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************


		//*******************************************
		// SERVICE
		//*******************************************
		/** @ngInject */
		function factory($q, nuitApi, nuitUtils) {
			//*******************************************
			// VARIABLES
			//*******************************************
            var deleterExists = false;
            var deleter = {};
            var config = {};
			//*******************************************

			//*******************************************
			// SERVICE
			//*******************************************
			var service = {
                reload: reload,
                config: _config,
                removeDeleter: removeDeleter,
                updateDeleter: updateDeleter,
                hasDeleter: hasDeleter
			};
			//*******************************************

			//*******************************************
			// PROPERTIES
			//*******************************************
            Object.defineProperty(service, 'deleter', {get: function () {
                    return deleter;
                }});
			//*******************************************

			//*******************************************
			return service;
			//*******************************************

			////////////////////////////////////////////////////////////////////////

			//*******************************************
			// METHODS
			//*******************************************
            function reload() {
                var promises = [];

                promises.push(nuitApi('shop.config')
                    .get()
                    .then(function (response) {
                        nuitUtils.clearObj(config);
                        angular.merge(config, response.data);
                    }));

                promises.push(nuitApi('shop.config.deleter')
                    .get()
                    .then(function (response) {
                        deleter.days = response.data.days;
                        deleter.status = response.data.status;
                        deleterExists = response.data.exists === true;
                    }));

                return $q.all(promises);
            }
            
            function _config(key) {
                if(config[key] !== undefined) { return config[key]; }
                switch(key) {
                    case 'sales.enabled': return false;
                    case 'sales.wrapCount': return 1;
                    case 'sales.minPrice': return 0;
                }
                return null;
            }
            
            function hasDeleter() { return deleterExists; }
            
            function updateDeleter() {
                return nuitApi('shop.config.deleter')
                    .post(deleter)
                    .then(function() {
                        deleterExists = true;
                });
            }
            
            function removeDeleter() {
                return nuitApi('shop.config.deleter')
                    .delete()
                    .then(function () {
                        deleterExists = false;
                    });
            }
		}
	}
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('nuitProfiles', provider);

    /** @ngInject */
    function provider() {
        //*******************************************
        // PROVIDER
        //*******************************************
        var provider = this;
        //*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        provider.$get = factory;
        //*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // METHODS
        //*******************************************

        //*******************************************
        // SERVICE
        //*******************************************
        /** @ngInject */
        function factory(nuitApi, nuitAuth, PROFILE_BLANK_FIELDS, DotNotationService) {
            //*******************************************
            // SERVICE
            //*******************************************
            var service = {
				isProfile: isProfile,
				isBox: isBox,
				isConical: isConical,
				hasStamps: hasStamps,
				hasCuts: hasCuts,
				getBendCount: getBendCount,
				getSegmentCount: getSegmentCount,
				getPunchCount: getPunchCount,
				supportsPositions: supportsPositions,
				getImage: getImage,
				getDisplayImage: getDisplayImage,
				getAttachments: getAttachments,
				getSecondaryAttachments: getSecondaryAttachments,
				getAttachmentUrl: getAttachmentUrl,
				getAttachmentLabel: getAttachmentLabel,
				isGlbAttachment: isGlbAttachment,
                getBlank: getBlank,
				getGeometryShape: getGeometryShape,
				logGeometryShape: logGeometryShape
            };
			//*******************************************

            //*******************************************
            // PROPERTIES
            //*******************************************

            //*******************************************

			//*******************************************
            return service;
            //*******************************************

            ////////////////////////////////////////////////////////////////////////

            //*******************************************
            // METHODS
            //*******************************************
            // Blank length ("Zuschnitt"). Which property is read is configured in
            // PROFILE_BLANK_FIELDS.length (core/constants/profile.blank.fields.constant.js).
            function getBlank(profile) {
                if(isV3()) { return numberOrZero(firstNumber(profile, PROFILE_BLANK_FIELDS.length)); }

                var lFront = 0;
                var lBack = 0;

                if(profile.geometry) {
					for (var index in profile.geometry.segments) {
						var segment = profile.geometry.segments[index];
						lFront += segment.length.front;
						lBack += segment.length.back;
					}
				}

                var sum = Math.max(lFront, lBack);

                // no segments (or all zero): fall back to the stored value
                return sum > 0 ? sum : numberOrZero(firstNumber(profile, PROFILE_BLANK_FIELDS.length));
            }

			// First numeric value found under the given dot-notation paths, else undefined.
			function firstNumber(source, paths) {
				for(var i = 0; i < paths.length; i++) {
					var value = DotNotationService.get(source, paths[i]);
					if(angular.isNumber(value)) { return value; }
				}
				return undefined;
			}

			function isProfile(profile) {
				// TODO: Needs validation to check if something is a profile
				return angular.isObject(profile) && angular.isDefined(profile.geometry) && profile.geometry!==null;
			}

			// Single point of truth for "is this profile a box?". Conceptually a box is a
			// 3D / multi-directional bent profile for which length-based positions don't make
			// sense; concretely it is identified by the (not-yet-finalised) profile.box flag
			// below. Every consumer routes through this function, so update detection here.
			// Single switch for the v3 profile format; the deprecated aliases
			// (blank, length, m2, hemsCount, tiltingsCount) stay for v1/v2.
			function isV3() {
				return nuitAuth.getEvoVersion() === 3;
			}

			function numberOrZero(value) {
				return angular.isNumber(value) ? value : 0;
			}

			function getBendCount(profile) {
				if(!isProfile(profile)) { return 0; }
				return numberOrZero(isV3() ? profile.bendCount : profile.tiltingsCount);
			}

			// v1/v2 carried punches under three different keys over time; treat them
			// as alternatives like hasStamps() does, do not sum them.
			function getPunchCount(profile) {
				if(!isProfile(profile)) { return 0; }
				if(isV3()) { return numberOrZero(profile.punchCount); }

				var keys = ['punches', 'stamps', 'stamp'];

				for(var i = 0; i < keys.length; i++) {
					if(angular.isArray(profile[keys[i]]) && profile[keys[i]].length > 0) {
						return profile[keys[i]].length;
					}
				}

				return 0;
			}

			function getSegmentCount(profile) {
				if(!isProfile(profile)) { return 0; }
				if(isV3()) { return numberOrZero(profile.segmentCount); }
				return angular.isArray(profile.geometry.segments) ? profile.geometry.segments.length : 0;
			}

			function isBox(profile) {
				if(!isProfile(profile)) { return false; }
				return profile.multiSide === true;
			}

			function isConical(profile) {
				if(!isProfile(profile)) { return false; }
				if(isV3()) { return profile.tapered === true; }

				for(var index in profile.geometry.segments) {
					if(profile.geometry.segments[index].conical) {
						return true;
					}
				}
				return false;
			}

			function hasStamps(profile) {
				if(!isProfile(profile)) { return false; }
				if(isV3()) { return profile.punchCount > 0; }
				return (angular.isArray(profile.stamp) && profile.stamp.length > 0) || (angular.isArray(profile.punches) && profile.punches.length > 0) || (angular.isArray(profile.stamps) && profile.stamps.length > 0);
			}

			function hasCuts(profile){
				if(!isProfile(profile)){ return false; }
				// notchCount and bevelCutCount are separate concerns, not summed in here.
				if(isV3()) { return profile.cutCount > 0; }
				return angular.isArray(profile.cuts) && profile.cuts.length > 0;
			}

			function supportsPositions(profile) {
				if(!isProfile(profile)) { return false; }

				return !hasStamps(profile) && !isConical(profile) && !isBox(profile);
			}

			function getImage(profile) {
				if(isV3()) { return getPreviewImage(profile); }

				return nuitApi('profile.images')
				  .get({profile: JSON.stringify(profile)}, {headers: {Accept: 'application/json'}})
				  .then(function (response) {
					  return response.data;
				  });
			}

			// v3 has no /images route; the preview returns the profile with image/attachments.
			// Resolves to the legacy {base64, path} shape (both the display url).
			function getPreviewImage(profile) {
				var body = {
					name: profile.name,
					remark: profile.remark,
					geometry: profile.geometry && profile.geometry.data !== undefined ? profile.geometry : {data: profile.geometry},
					materialId: profile.materialId || null,
					customData: profile.customData,
					externalData: profile.externalData
				};

				return nuitApi(body.materialId ? 'profile.preview.material' : 'profile.preview')
					.post(body)
					.then(function (response) {
						var url = getDisplayImage(response.data);
						return {base64: url, path: url};
					});
			}

			function getDisplayImage(profile) {
				if(!profile) { return undefined; }

				if(angular.isArray(profile.attachments)) {
					for(var i = 0; i < profile.attachments.length; i++) {
						var attachment = profile.attachments[i];
						if(attachment && attachment.primary === true && attachment.storageKey) {
							return nuitApi.getBaseUrl() + attachment.storageKey.replace(/^\//, '');
						}
					}
					for(var j = 0; j < profile.attachments.length; j++) {
						var att = profile.attachments[j];
						if(att && att.kind === 'production-profile-sideview' && att.storageKey) {
							return nuitApi.getBaseUrl() + att.storageKey.replace(/^\//, '');
						}
					}
				}

				return profile.image;
			}

			function getAttachments(profile) {
				if(profile && angular.isArray(profile.attachments)) {
					return profile.attachments;
				}
				return [];
			}

			// Attachments excluding the one already shown as the main preview (primary / sideview).
			function getSecondaryAttachments(profile) {
				var shown = getDisplayImage(profile);
				return getAttachments(profile).filter(function (attachment) {
					return getAttachmentUrl(attachment) !== shown;
				});
			}

			function getAttachmentUrl(attachment) {
				if(!attachment) { return undefined; }
				if(attachment.storageKey) {
					return nuitApi.getBaseUrl() + attachment.storageKey.replace(/^\//, '');
				}
				return attachment.link || attachment.url;
			}

			function getAttachmentLabel(attachment) {
				if(!attachment) { return ''; }
				if(angular.isString(attachment.name) && attachment.name.length > 0) {
					return attachment.name;
				}
				var key = attachment.storageKey || attachment.link || attachment.url || '';
				var filename = key.split('?')[0].split('/').pop();
				if(filename) {
					try { return decodeURIComponent(filename); } catch(e) { return filename; }
				}
				return attachment.kind || '';
			}

			// 'envelope' (geometry.data), 'flat' (nugeometry fields directly in geometry), 'empty', 'none'
			function getGeometryShape(profile) {
				if(!isProfile(profile)) { return 'none'; }

				var geometry = profile.geometry;

				if(angular.isObject(geometry.data) && !angular.isArray(geometry.data)) {
					return 'envelope';
				}

				var flatKeys = ['version', 'facing', 'points', 'shape', 'bends', 'punches'];
				for(var i = 0; i < flatKeys.length; i++) {
					if(angular.isDefined(geometry[flatKeys[i]])) { return 'flat'; }
				}

				return 'empty';
			}

			function logGeometryShape(profile, context) {
				var shape = getGeometryShape(profile);
				var prefix = '[geometry-shape] ' + (context || '') + ': ' + shape;
				var id = isProfile(profile) ? profile.geometry.id : undefined;

				if(shape === 'none') { return shape; }

				if(isV3() && shape !== 'envelope') {
					console.warn(prefix + ' - expected envelope (geometry.data) for production-v2, profile save will be rejected', {geometryId: id, geometry: profile.geometry});
				} else {
					console.debug(prefix, {geometryId: id});
				}

				return shape;
			}

			function isGlbAttachment(attachment) {
				if(!attachment) { return false; }
				var key = (attachment.storageKey || attachment.link || attachment.url || '').toLowerCase();
				var mime = (attachment.mimetype || attachment.mimeType || attachment.contentType || '').toLowerCase();
				return /\.glb(\?|$)/.test(key) || mime.indexOf('gltf-binary') !== -1 || mime.indexOf('model/') === 0;
			}
        }
    }
})();


(function () {
	'use strict';

	angular
	  .module('app.core')
	  .provider('nuitProducts', provider);

	/** @ngInject */
	function provider() {
		//*******************************************
		// PROVIDER
		//*******************************************
		var provider = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		var _products = [];
		var _forceCache = false;
		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		provider.$get = factory;
		provider.forceCache = forceCache;
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(provider, 'all', {get: function () {
				return _products;
			}});
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************
		function forceCache(val) {
			_forceCache = val;
		}

		//*******************************************
		// SERVICE
		//*******************************************
		/** @ngInject */
		function factory($log, $q, $mdDialog, nuitApi) {
			//*******************************************
			// VARIABLES
			//*******************************************
			var reloadPromise = null;
			//*******************************************

			//*******************************************
			// SERVICE
			//*******************************************
			var service = {
				reload: reload,
				showProductDialog: showProductDialog,
				showProductSelectionDialog: showProductSelectionDialog,
				loadProduct: loadProduct,
				getProductById: getProductById,
				isProductInCategory: isProductInCategory,
				hasTags: hasTags
			};
			//*******************************************

			//*******************************************
			// PROPERTIES
			//*******************************************
			Object.defineProperty(service, 'all', {get: function () {
					return _products;
				}});
			//*******************************************

			//*******************************************
			return service;
			//*******************************************

			////////////////////////////////////////////////////////////////////////

			//*******************************************
			// METHODS
			//*******************************************
			/**
			 * Reloads all products by performing a call to the API.
			 * @param {Boolean} forceReload
			 * @returns {Promise}
			 */
			function reload(forceReload) {
				if (_forceCache && !forceReload && _products.length > 0) {
					return $q.when(_products);
				} else if (reloadPromise === null) {
					reloadPromise = nuitApi('products')
					  .get()
					  .then(function (response) {
						  _products.splice(0, _products.length);
						  angular.merge(_products, response.data);
						  reloadPromise = null;
					  })
					  .catch(function () {
						  $log.error('Failed to reload products!');
					  });
				}
				return reloadPromise;
			}

			/**
			 * Shows the edit-dialog for a single product.
			 * @param {Object} product - product to display
			 * @param {Object} filters - product filters (prefills attributes)
			 * @param {Boolean} isBeforeCart - replaces the submit button if true
			 * @param {Object} $event - event data
			 */
			function showProductDialog(product, filters, isBeforeCart, showPrices, $event) {
				return $mdDialog.show({
					controller: 'ProductDialogController',
					controllerAs: 'vm',
					templateUrl: 'app/core/dialogs/product/product-dialog.html',
					parent: angular.element(document.body),
					targetEvent: $event,
                    multiple: true,
					clickOutsideToClose: true,
					locals: {
						Product: angular.copy(product),
						Filters: filters,
						IsBeforeCart: isBeforeCart,
						ShowPrices: showPrices
					}
				});
			}

			function showProductSelectionDialog(showPrices){
					return $mdDialog.show({
						controller: 'ProductSelectionDialogController',
						controllerAs: 'vm',
						templateUrl: 'app/core/dialogs/product-selection/product-selection-dialog.html',
						locals: {
							ShowPrices: showPrices
						}
					});
			}

			/**
			 * Returns loaded product or if unknown loads product from remote server
			 * @param id
			 * @return {Promise} requested product
			 */
			function loadProduct(id) {
				return nuitApi('products.one', id)
					.get()
					.then(function (response) {
						var product = response.data;
						return product;
					});
			}

			function getProductById(id) {
				for(var index in _products) {
					if(_products[index].id === id) {
						return _products[index];
					}
				}
				return null;
			}

			/**
			 * Returns true if the product is inside the given category
			 * or if the category is null.
			 * @param {Object} product
			 * @param {Object} category
			 * @returns {Boolean}
			 */
			function isProductInCategory(product, category) {
				if(category === null || category < 0 || category.id < 0) { return true; }

				var i;
				for(i = 0; i < product.categories.length;i++) {
					if(product.categories[i].id === category.id) {
						return true;
					}
				}
				return false;
			}

			/**
			 * Returns true if the given product contains all tags
			 * insided the provided array.
			 * @param {Object} product
			 * @param {Array} tags
			 * @return {Boolean}
			 */
			function hasTags(product, tags) {
				if(!angular.isArray(tags) || tags.length < 1) { return true; }

				for (var index in tags) {
					var found = false;
					for (var i in product.tags) {
						if (product.tags[i].id === tags[index].id) {
							found = true;
							break;
						}
					}
					if (!found) {
						return false;
					}
				}
				return true;
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.provider('nuitOrders', provider);

	/** @ngInject */
	function provider() {
		//*******************************************
		// PROVIDER
		//*******************************************
		var provider = this;
		//*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************

		//*******************************************

		//*******************************************
		// METHODS (Exposure)
		//*******************************************
		provider.$get = factory;
		//*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************

		//*******************************************

		////////////////////////////////////////////////////////////////////////

		//*******************************************
		// METHODS
		//*******************************************


		//*******************************************
		// SERVICE
		//*******************************************
		/** @ngInject */
		function factory(nuitApi, nuitDataService) {
			//*******************************************
			// VARIABLES
			//*******************************************
			var _statusQueue = [];
			var _statusCount = [];
			var _statusLoading = null;
			//*******************************************

			//*******************************************
			// SERVICE
			//*******************************************
			var service = {

				reloadConfig: reloadConfig,
				getStatusById: getStatusById,
				getStatusByType: getStatusByType,
				getStatisByType: getStatisByType,
				getFirstTwoProposalStatis: getFirstTwoProposalStatis,
				moveToNextStatus: moveToNextStatus,
				getNextStatus: getNextStatus,
				hasNextStatus: hasNextStatus,
				updateOrder: updateOrder,
				orderCountByStatus: orderCountByStatus,
				getStatusCountById: getStatusCountById
			};
			//*******************************************

			//*******************************************
			// PROPERTIES
			//*******************************************
			Object.defineProperty(service, 'queue', {
				get: function () {
					return _statusQueue;
				}
			});
			Object.defineProperty(service, 'statusCount', {
				get: function () {
					return _statusCount;
				}
			});
			Object.defineProperty(service, 'statusLoading', {
				get: function () {
					return _statusLoading;
				}
			});
			//*******************************************

			//*******************************************
			return service;
			//*******************************************

			////////////////////////////////////////////////////////////////////////

			//*******************************************
			// METHODS
			//*******************************************
			/**
			 * Reloads the shop config.
			 * @return {Promise}
			 */
			function reloadConfig() {

				if(!_statusLoading) {
					_statusLoading = nuitApi('orders.status')
						.get()
						.then(function (response) {
							_statusQueue.splice(0, _statusQueue.length);
							angular.merge(_statusQueue, response.data);
							return response.data;
						})
						.finally(function(){
							_statusLoading = null;
						});

				}

				return _statusLoading;
			}

			/**
			 * Returns the status config object with the given id or null if no
			 * status config with the given id exists.
			 * @param {Number} id - status id
			 * @return {Object}
			 */
			function getStatusById(id) {
				if (angular.isNumber(id)) {
					id = String(id);
				}

				for (var i in _statusQueue) {
					var statusConfig = _statusQueue[i];
					if (String(statusConfig.id) === id) {
						return statusConfig;
					}
				}

				return null;
			}

			function getStatusByType(type){
				for(var i=0;i<_statusQueue.length;i++){
					var status = _statusQueue[i];
					if(status.type===type){
						return status;
					}
				}

				return null;
			}

			function getStatisByType(type){
				var statis = [];

				for(var i=0;i<_statusQueue.length;i++){
					var status = _statusQueue[i];
					if(status.type===type){
						statis.push(status);
					}
				}

				return statis;
			}

			function getFirstTwoProposalStatis(){
				var proposalStatis = getStatisByType('proposal');

				if(proposalStatis.length<=1){
					return proposalStatis;
				}else{
					var currentStatus = null;
					for(var i=0;i<proposalStatis.length;i++){
						currentStatus = proposalStatis[i];
						var isFirst = true;
						for(var j=0;j<proposalStatis.length;j++) {
							var compareStatus = proposalStatis[j];
							isFirst = isFirst && (compareStatus.id===currentStatus.id || compareStatus.transitionTo!==currentStatus.id);
						}

						if(isFirst){
							break;
						}
					}

					var result = [];

					result.push(currentStatus);

					var secondStatus = null;

					for(var i=0;i<proposalStatis.length;i++){
						if(currentStatus.transitionTo===proposalStatis[i].id){
							secondStatus = proposalStatis[i];
							break;
						}
					}

					result.push(secondStatus===null?currentStatus:secondStatus);

					return result;
				}
			}

			/**
			 * Moves the given order to the next state.
			 * @param {Object} order
			 * @return {Promises}
			 */
			function moveToNextStatus(order) {
				var state = getNextStatus(order.status);

				return nuitApi('order.update.status', order.id)
					.put({status: String(state.id)})
					.then(function(response){
						return response.data;
					});
			}

			function hasNextStatus(id){
				var nextStatus = getNextStatus(id);
				return nextStatus !== null;
			}

			/**
			 * Returns the status config object which is one step
			 * ahead of the one with the given id or null if no such
			 * status config exists.
			 * @param {Number} id - status id
			 * @return {Object}
			 */
			function getNextStatus(id) {
				var status = getStatusById(id);

				if(status && status.transitionTo && status.transitionTo.length>0) {
					for (var i in service.queue) {
						var statusConfig = service.queue[i];

						if (status.transitionTo === statusConfig.id) {
							return statusConfig;
						}
					}
				}

				return null;
			}

			/**
			 * Sends updated order to remote server.
			 * @param {Object} order
			 */
			function updateOrder(order) {
				return nuitApi('order.update', order.id)
					.put(order)
					.then(function (response) {
						return response.data;
					});
			}

			function orderCountByStatus(){
				return nuitApi('order.count.by.status').get()
					.then(function(response){
						return nuitDataService.replaceAll(_statusCount, response.data);
					});
			}

			function getStatusCountById(id){
				for(var i=0;i<_statusCount.length;i++){
					var statusCount = _statusCount[i];
					if(statusCount.status===id){
						return statusCount.orders;
					}
				}

				return 0;
			}
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('nuitMaterials', provider);

    /** @ngInject */
    function provider() {
        //*******************************************
        // PROVIDER
        //*******************************************
        var provider = this;
        //*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		var _materials = [];
		var _groups = [];
		var _singleMaterialCache = [];
		var _forceCache = false;
		//*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        provider.$get = factory;
		provider.forceCache = forceCache;
        //*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(provider, 'materials', { get: function() { return _materials; } });
		Object.defineProperty(provider, 'groups', { get: function() { return _groups; } });
		//*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // METHODS
        //*******************************************
		function forceCache(val) {
			_forceCache = val;
		}

        //*******************************************
        // SERVICE
        //*******************************************
        /** @ngInject */
        function factory($log, $q, nuitApi) {
            //*******************************************
            // SERVICE
            //*******************************************
            var service = {
				reload: reload,
				reloadGroups: reloadGroups,
				getMaterialById: getMaterialById,
				getCachedMaterialById: getCachedMaterialById,
				getMaterialByIdFromServer: getMaterialByIdFromServer,
				getGroupById: getGroupById,
				getMaterialsInGroup: getMaterialsInGroup,
				getMaterialsInGroups: getMaterialsInGroups,
				isMaterialInGroups: isMaterialInGroups,
                isColorInGroups: isColorInGroups,
				isColorInMaterials: isColorInMaterials,
				reset: reset,
				resetMaterials: resetMaterials,
				resetGroups: resetGroups
            };
			//*******************************************

            //*******************************************
            // PROPERTIES
            //*******************************************
            Object.defineProperty(service, 'materials', { get: function() { return _materials; } });
            Object.defineProperty(service, 'groups', { get: function() { return _groups; } });
            //*******************************************

			//*******************************************
            return service;
            //*******************************************

            ////////////////////////////////////////////////////////////////////////

            //*******************************************
            // METHODS
            //*******************************************
            /**
             * Reloads all materials by performing a call to the API.
			 * @param {Boolean} forceReload
             * @returns {Promise}
             */
            function reload(forceReload) {
				if(_forceCache && !forceReload && _materials.length > 0) {
					return $q.when(_materials);
				} else {
					return nuitApi('materials')
					  .get()
					  .then(function (response) {
						  // Clear materials
						  resetMaterials();

						  // Merge with existing
						  if (angular.isArray(response.data)) {
							  angular.merge(_materials, response.data);
						  }

						  return _materials;
					  })
					  .catch(function (error) {
						  $log.error('Failed to load materials!');
						  throw error;
					  });
				}
            }
            /**
             * Reloads all material groups by performing a call to the API.
			 * @param {Boolean} forceReload
             * @returns {Promise}
             */
            function reloadGroups(forceReload) {
				if (_forceCache && !forceReload && _groups.length > 0) {
					return $q.when(_groups);
				} else {
					return nuitApi('materials.raw')
					  .get()
					  .then(function (response) {
						  // Clear groups
						  _groups.splice(0, _groups.length);

						  // Merge with existing
						  if (angular.isArray(response.data)) {
							  angular.merge(_groups, response.data);
						  }

						  return _groups;
					  })
					  .catch(function (error) {
						  $log.error('Failed to load materialgroups!');
						  throw error;
					  });
				}
            }
			/**
			 * Returns the material with the given id or null
			 * if no material with the given id exists.
			 * (Performs a linear search at the moment.)
			 * @param {Number} id
			 * @return {Object|Material}
			 */
			function getMaterialById(id) {
				if(id === undefined) { return null; }
				if(!angular.isNumber(id)) {
					var copy = angular.copy(id);
					id = parseInt(id, 10);
					if (isNaN(id)) {
						$log.warn('getMaterialById: \'id\' has to be a number or something that can be parsed to a number! (Given: \'' + copy + '\')');
						return null;
					}
				}

				var index = 0;
				for(index in _materials) {
					if(_materials[index].id === id) {
						return _materials[index];
					}
				}
				return null;
			}

			function getCachedMaterialById(id){
				var deferred = $q.defer();

				var material;

				for(var i=0;i<_singleMaterialCache.length;i++){
					if(_singleMaterialCache[i].id===id){
						material = _singleMaterialCache[i];
						break;
					}
				}

				if(!material){
					material = getMaterialById(id);
				}

				if(material){
					deferred.resolve(material);
				}else {
					nuitApi('materials.single', id)
						.get()
						.then(function (response) {
							var updated = false;

							for(var i=0;i<_singleMaterialCache.length;i++){
								if(_singleMaterialCache[i].id===id){
									angular.merge(_singleMaterialCache[i],response.data);
									updated = true;
									break;
								}
							}

							if(!updated){
								_singleMaterialCache.push(response.data);
							}

							deferred.resolve(response.data);
						})
						.catch(function (error) {
							deferred.reject(error);
						});
				}

				return deferred.promise;
			}

			function getMaterialByIdFromServer(id){
				return nuitApi('materials.single', id)
					.get()
					.then(function (response) {
						return response.data;
					});
			}



			/**
			 * Returns the group with the given id or null
			 * if no group with the given id exists.
			 * (Performs a linear search at the moment.)
			 * @param {Number} id
			 * @return {Object|Group}
			 */
			function getGroupById(id) {
				if(!angular.isNumber(id)) {
					id = parseInt(id, 10);
					if (isNaN(id)) {
						$log.warn('getGroupById: \'id\' has to be a number or something that can be parsed to a number!');
						return null;
					}
				}

				var index = 0;
				for(index in _groups) {
					if(_groups[index].id === id) {
						return _groups[index];
					}
				}
				return null;
			}
			/**
			 * Returns all materials inside the given group.
			 * @param {Number} id - group id
			 * @return {Array}
			 */
			function getMaterialsInGroup(id) {
				if(!angular.isNumber(id)) {
					id = parseInt(id, 10);
					if (isNaN(id)) {
						$log.warn('getMaterialsInGroup: \'id\' has to be a number or something that can be parsed to a number!');
						return null;
					}
				}

				return _filterMaterials([], [id], true);
			}

			/**
			 * Returns all materials inside the given groups. Group array must only consist of group ids.
			 * @param {Array} groups
			 * @return {Array}
			 */
			function getMaterialsInGroups(groups) {
				if(!angular.isArray(groups)) {
					$log.warn('getMaterialsInGroups: \'groups\' has to be an array!');
					return null;
				}

				return _filterMaterials([], groups, true);
			}

			/**
			 * Returns true if the given material is inside any of the given groups.
			 * @param {Object} material
			 * @param {Array} groups
			 * @return {Boolean}
			 */
			function isMaterialInGroups(material, groups) {
				return groups.indexOf(material.rawMaterialId) >= 0;
			}
            /**
             * Returns true if the given color exists within the given material groups.
             * @param {Integer} colorId
             * @param {Array} groups
             * @return {Boolean}
             */
            function isColorInGroups(colorId, groups) {
                for(var index in _materials) {
                    var mat = _materials[index];
                    if(groups.indexOf(mat.rawMaterialId) >= 0 && (mat.colorFront === colorId || mat.colorBack === colorId)) {
                        return true;
                    }
                }
                return false;
            }
			/**
			 * Returns true if the given color exists within the given material array.
			 * @param {Integer} colorId
			 * @param {Array} materials
			 * @return {Boolean}
			 */
			function isColorInMaterials(colorId, materials) {
				for (var index in materials) {
					var mat = materials[index];
					if(angular.isNumber(mat)) { mat = getMaterialById(mat); }
					if (mat !== null && (mat.colorFront === colorId || mat.colorBack === colorId)) {
						return true;
					}
				}
				return false;
			}
            /**
             * Resets the materials and groups array by removing all elements.
             */
            function reset() {
				resetMaterials();
				resetGroups();
            }

            /**
             * Resets the materials array and removes all elements.
             */
            function resetMaterials() {
                _materials.splice(0, _materials.length);
            }

            /**
             * Resets the groups array and removes all elements.
             */
            function resetGroups() {
                _groups.splice(0, _groups.length);
            }

			/**
			 * Internal filter method which returns all materials with the groups inside the given group filter.
			 * Can be inverted via the whitelist parameter. Returns the array provided as the first parameter
			 * or a new array if the first parameter is not specified.
			 *
			 * @param {Array} target
			 * @param {Array} groupFilter
			 * @param {Boolean} whitelist
			 * @return {Array}
			 */
			function _filterMaterials(target, groupFilter, whitelist) {
				if(!angular.isArray(target)) { target = []; }
				if(!angular.isArray(groupFilter)) { groupFilter = []; }

				var index = 0;
				for(index in _materials) {
					if((groupFilter.indexOf(_materials[index].rawMaterialId) >=  0) === whitelist) {
						target.push(_materials[index]);
					}
				}

				return target;
			}
        }
    }
})();


(function () {
    'use strict';

    angular
            .module('app.core')
            .provider('nuitConfig', nuitConfigProvider);

    /** @ngInject */
    function nuitConfigProvider() {
        //*******************************************
        // PROVIDER
        //*******************************************
        var provider = this;
        //*******************************************

        //*******************************************
        // CONSTANTS
        //*******************************************
        var EVENT_CONFIG_LOADED = "config::config.loaded";
        //*******************************************

        //*******************************************
        // ENUMS
        //*******************************************
        // Enum that contains all events of this service.
        var EVENTS = {
            ConfigLoaded: EVENT_CONFIG_LOADED
        };
        // The various config types specified by the API.
        // https://bitbucket.org/nuitdevelopers/configuration
        var CONFIG_TYPE = {
            INTEGER: 1,
            STRING: 2,
            JSON: 3,
            BOOL: 4,
            FLOAT: 5
        };
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        /**
         * Contains the default config.
         * @type nuit-config.serviceL#3.nuitConfig.DefaultConfig
         */
        var defaultConfig = new DefaultConfig();
        /**
         * Contains an editable copy of the default config.
         * @type nuit-config.providerL#1.nuitConfigProvider.DefaultConfig
         */
        var defaultConfigCopy = new DefaultConfig;
        /**
         * Contains the currently used nuit-config.
         * @type Object
         */
        var current = {};
        /**
         * Is set to true after the nuit-config has been loaded for the first time.
         * @type Boolean
         */
        var _isReady = false;
        //*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        provider.$get = nuitConfig;
        provider.getCurrent = getCurrent;
        provider.isReady = isReady;
        provider.injectIntoDefault = injectIntoDefault;
        provider.toAPIConfig = toAPIConfig;
        provider.fromAPIConfig = fromAPIConfig;
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // ACCESSORS
        //*******************************************
        /**
         * Returns the current active evo-config.
         * @returns {nuit-config.serviceL#3.nuitConfig.current}
         */
        function getCurrent() {
            return current;
        }
        /**
         * Returns true if the nuit-config has been loaded
         * at least once.
         * @returns {Boolean}
         */
        function isReady() {
            return _isReady;
        }
        //*******************************************

        //*******************************************
        // METHODS
        //*******************************************
        /**
         * Injects the given object into the default config.
         * @param {Object} config
         */
        function injectIntoDefault(config) {
            angular.merge(defaultConfig, config);
            angular.merge(current, defaultConfig);
            defaultConfigCopy = angular.copy(defaultConfig);
        }

        function toAPIConfig(config, keyList) {
            if(!angular.isArray(keyList)) { keyList = [];  }

            return convert(config, '', keyList);

            function convert(config, keychain, keylist) {
                for (var key in config) {
                    var keyString = (keychain === '') ? key : keychain + '.' + key;
                    var type = -1;
                    if (angular.isNumber(config[key])) {
                        if (config[key] === parseInt(config[key], 10)) {
                            type = CONFIG_TYPE.INTEGER;
                        } else {
                            type = CONFIG_TYPE.FLOAT;
                        }
                    } else if (angular.isString(config[key]) || config[key] === null) {
                        type = CONFIG_TYPE.STRING;
                    } else if (angular.isArray(config[key])) {
                        type = CONFIG_TYPE.JSON;
                    } else if (config[key] === true || config[key] === false) {
                        type = CONFIG_TYPE.BOOL;
                    } else if (angular.isObject(config[key])) {
                        if(keylist.indexOf(keyString) >= 0) {
                            type = CONFIG_TYPE.JSON;
                        } else if(angular.isDefined(config[key].value) && angular.isDefined(config[key].type)) {
                            continue;
                        } else {
                            convert(config[key],keyString, keyList);
                            continue;
                        }
                    }
                    config[key] = {
                        value: config[key],
                        type: type
                    };
                }
                return config;
            }
        }

        function fromAPIConfig(config) {
            return convert(config);

            function convert(config) {
                for(var key in config) {
                    if(angular.isDefined(config[key].value) && angular.isDefined(config[key].type)) {
                        config[key] = config[key].value;
                    } else if(angular.isObject(config[key])) {
                        convert(config[key]);
                    }
                }
                return config;
            }
        }
        //*******************************************

        //*******************************************
        // COMPONENTS
        //*******************************************
        /**
         * Creates a new default config file which has to be merged with the remote config.
         * @returns {nuit-config.serviceL#3.nuitConfig.DefaultConfig}
         */
        function DefaultConfig() {
        }
        //*******************************************

        //*******************************************
        // SERVICE
        //*******************************************
        /** @ngInject */
        function nuitConfig($rootScope, $log, $cacheFactory, nuitApi) {
            //*******************************************
            // SERVICE
            //*******************************************
            var service = {
                EVENTS: EVENTS,
                CONFIG_TYPE: CONFIG_TYPE,
                isReady: isReady,
                getCurrent: getCurrent,
                injectIntoDefault: injectIntoDefault,
                reload: reload,
                reset: reset,
                toAPIConfig: toAPIConfig,
                fromAPIConfig: fromAPIConfig
            };

            //*******************************************
			// PROPERTIES
			//*******************************************
            /*
             * Returns a copy of the default config.
             */
            Object.defineProperty(service, 'default', { get: function() { return defaultConfigCopy; } });
            /*
             * Returns the current config. Should never be edited directly!
             */
            Object.defineProperty(service, 'current', { get: function() { return current; } });
            //*******************************************

            return service;
            //*******************************************

            ////////////////////////////////////////////////////////////////////////

            //*******************************************
            // METHODS
            //*******************************************
            /**
             * Reloads the nuit-config from the remote server.
             * @param {Boolean} disableCache - true if request should not rely on cached values
             * @returns {Promise}
             */
            function reload(disableCache) {
                if(disableCache) {
                    $cacheFactory.get('$http').remove(nuitApi.getBaseUrl()+"configurations?format=compact");
                }

                return nuitApi.resolve('configurations')
                  .get({format: 'compact'}, {cache: !disableCache})
                  .then(function (response) {
                      if (disableCache) {
                          reset();
                      }
                      return response;
                  })
                  .then(onConfigReceived)
                  .catch(onConfigError);
            }
            /**
             * Resets the entire config service back to its
             * default state after all default configs have been injected.
             */
            function reset() {
                // Delete all properties to keep reference
                var prop;
                for(prop in current) {
                    delete current[prop];
                }

                // Merge with default config
                angular.merge(current, defaultConfig);

				_isReady = false;
            }

            //*******************************************
            // EVENTS
            //*******************************************
            /**
             * This event is called whenever the config is being reloaded.
             * @param {Object} response - response data including new config
             * @returns {Config}
             */
            function onConfigReceived(response) {
                // Ensure config is not null
                var config = angular.extend({}, defaultConfig, response.data);

                // Merge config with current config
                angular.merge(current, config);
                _isReady = true;

                // Broadcast config event
                $rootScope.$broadcast(EVENT_CONFIG_LOADED, current);

                // Return config
                return current;
            }
            /**
             * This event is fired whenever there is an error during the config
             * reload call.
             * @param {Object} error
             */
            function onConfigError(error) {
                if(error.status === 403) {
                    // No permission to download config.
                } else {
                    $log.warn('Error while trying to get config from remote server');
                    throw new Error(error);
                }
            }
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('nuitColors', provider);

    /** @ngInject */
    function provider() {
        //*******************************************
        // PROVIDER
        //*******************************************
        var provider = this;
        //*******************************************

		//*******************************************
		// VARIABLES
		//*******************************************
		var _colors = [];
		var _singleColorCache = [];
		var _forceCache = false;
		//*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        provider.$get = factory;
		provider.forceCache = forceCache;
        //*******************************************

		//*******************************************
		// PROPERTIES
		//*******************************************
		Object.defineProperty(provider, 'all', { get: function() { return _colors; } });
		//*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // METHODS
        //*******************************************
		function forceCache(val) {
			_forceCache = val;
		}

        //*******************************************
        // SERVICE
        //*******************************************
        /** @ngInject */
        function factory($log, $q, nuitApi, nuitDataService) {
            //*******************************************
            // SERVICE
            //*******************************************
            var service = {
				reload: reload,
				getColorById: getColorById,
				getCachedColorById: getCachedColorById,
				reset: reset
            };
			//*******************************************

            //*******************************************
            // PROPERTIES
            //*******************************************
            Object.defineProperty(service, 'all', { get: function() { return _colors; } });
            //*******************************************

			//*******************************************
            return service;
            //*******************************************

            ////////////////////////////////////////////////////////////////////////

            //*******************************************
            // METHODS
            //*******************************************
            /**
             * Reloads all colors by performing a call to the API.
			 * @param {Boolean} forceReload
             * @returns {Promise}
             */
            function reload(forceReload) {
				if(_forceCache && !forceReload && _colors.length > 0) {
					return $q.when(_colors);
				} else {
					return nuitApi('colors')
					  .get()
					  .then(function (response) {
						  // Clear colors
						  reset();

						  // Merge with existing
						  if (angular.isArray(response.data)) {
							  angular.merge(_colors, response.data);
						  }

						  return _colors;
					  })
					  .catch(function (error) {
						  $log.error('Failed to load colors!');
						  throw error;
					  });
				}
            }
			/**
			 * Returns the color with the given id or null
			 * if no color with the given id exists.
			 * (Performs a linear search at the moment.)
			 * @param {Number} id
			 * @return {Object|Color}
			 */
			function getColorById(id) {
				if(id === undefined) { return null; }
				if(!angular.isNumber(id)) {
					var copy = angular.copy(id);
					id = parseInt(id, 10);
					if (isNaN(id)) {
						$log.warn('getColorById: \'id\' has to be a number or something that can be parsed to a number! (Given: \'' + copy + '\')');
						return null;
					}
				}

				var index = 0;
				for(index in _colors) {
					if(_colors[index].id === id) {
						return _colors[index];
					}
				}
				return null;
			}


			function getCachedColorById(id){
				var deferred = $q.defer();

				var color = nuitDataService.getOne(_singleColorCache, id);

				if(!color){
					color = getColorById(id);
				}

				if(color){
					deferred.resolve(color);
				}else {
					nuitApi('colors.single', id)
						.get()
						.then(function (response) {
							nuitDataService.upsertOne(_singleColorCache,response.data);
							deferred.resolve(response.data);
						})
						.catch(function (error) {
							deferred.reject(error);
						});
				}

				return deferred.promise;
			}

            /**
             * Resets the colors by removing all elements.
             */
            function reset() {
				_colors.splice(0, _colors.length);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('app.core')
            .provider('nuitAuth', nuitAuthProvider);

    /** @ngInject */
    function nuitAuthProvider($windowProvider, $httpProvider) {
        //*******************************************
        // PROVIDER
        //*******************************************
        var provider = this;
        //*******************************************

        //*******************************************
        // CONSTANTS
        //*******************************************
        var EVENT_USER_LOGIN_SUCCESS = 'user::user.login.success';
        var EVENT_USER_LOGIN_FAILED = 'user::user.login.failed';
        var EVENT_USER_LOGIN_ERROR = 'user::user.login.error';
        var EVENT_USER_LOGOUT = 'user::user.logout';
        var EVENT_USER_PASSWORD_RESET = 'user::user.password.reset';
        var EVENT_USER_PASSWORD_RESET_ERROR = 'user::user.password.reset.error';
        var STORAGE_NAME = "userToken";
        var HEADER_NAME = 'Access-Token';
        var TOKEN_PREFIX = undefined;
        //*******************************************

        //*******************************************
        // ENUMS
        //*******************************************
        // Enum that contains all events of this service.
        var EVENTS = {
            LoginSuccess: EVENT_USER_LOGIN_SUCCESS,
            LoginFailed: EVENT_USER_LOGIN_FAILED,
            LoginError: EVENT_USER_LOGIN_ERROR,
            Logout: EVENT_USER_LOGOUT,
            PasswordReset: EVENT_USER_PASSWORD_RESET,
            PasswordResetError: EVENT_USER_PASSWORD_RESET_ERROR
        };
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        var user = {};
        var company = null;
        var $window = $windowProvider.$get();
		var isRelocating = false;
        //*******************************************

        //*******************************************
        // METHODS (Exposure)
        //*******************************************
        provider.$get = nuitAuth;
        provider.getUser = getUser;
		provider.getUserId = getUserId;
		provider.getOriginUserId = getOriginUserId;
        provider.getToken = getToken;
        provider.isGuest = isGuest;
        provider.isAuthenticated = isAuthenticated;
        provider.getEnvironmentId = getEnvironmentId;
		provider.hasCompany = hasCompany;
        provider.EVENTS = EVENTS;
        //*******************************************

        //*******************************************
        // INIT
        //*******************************************
        init();
        //*******************************************

        ////////////////////////////////////////////////////////////////////////

        //*******************************************
        // METHODS
        //*******************************************
        /**
         * Initializes provider
         */
        function init() {
            $httpProvider.interceptors.push(AuthInterceptor);
        }
        /**
         * Returns true if the current user is a guest.
         * @returns {Boolean}
         */
        function isGuest() {
            return user === null || angular.isUndefined(user.id);
        }
        /**
         * Returns the current user.
         * @returns {nuit-auth.providerL#1.nuitAuthProvider.user}
         */
        function getUser() {
            return user;
        }
        /**
         * Returns stored token
         * @return {String} saved json token
         */
        function getToken() {
            return $window.localStorage.getItem(STORAGE_NAME);
        }
        function hasCompany(){
        	return company!==null;
		}

		function companyInactive(){
			return hasCompany() && !company.active;
		}

        /**
         * Returns the current environment id.
         * @returns {Number}
         */
        function getEnvironmentId() {
            if(!isAuthenticated()) { return -1; }
            var id = JSON.parse($window.atob(getToken().split('.')[1])).environmentId;
            return parseInt(id);
        }
        /**
         * Returns the current environment id.
         * @returns {Number}
         */
        function getUserId() {
            if(!isAuthenticated()) { return -1; }
            var id = JSON.parse($window.atob(getToken().split('.')[1])).userId;
            return parseInt(id);
        }
		/**
         * Returns the current origin id of the alias user.
         * @returns {Number}
         */
        function getOriginUserId() {
            if(!isAuthenticated()) { return -1; }
            var id = JSON.parse($window.atob(getToken().split('.')[1])).originUserId;
            return parseInt(id);
        }
        /**
         * Returns true if the current user is authenticated.
         * @returns {Boolean}
         */
		function getEvoVersion() {
			if(!isAuthenticated()) { return -1; }
			var id = JSON.parse($window.atob(getToken().split('.')[1])).evoVersion;
			return parseInt(id);
		}
        function isAuthenticated() {
            try {
                return !!($window.localStorage.getItem(STORAGE_NAME) || $window.sessionStorage.getItem(STORAGE_NAME)) && (JSON.parse($window.atob(getToken().split('.')[1])).exp*1000 > (new Date()).getTime());
            } catch (ex) {
                console.log("Browser does not support local storage or session storage or no token has been found!");
                return false;
            }
        }
        //*******************************************

		function isAuthorizedForEvo(config){
        	return (config.evo.editor.enabled || config.evo.cart.enabled || config.evo.products.enabled) && (company===null || company.active);
		}

		function setRelocating(){
			isRelocating = true;
		}

		function getRelocating(){
			return isRelocating;
		}

        //*******************************************
        // SERVICE
        //*******************************************
        /** @ngInject */
        function nuitAuth($rootScope, $window, $log, $injector, nuitLog) {
            //*******************************************
            // SERVICE
            //*******************************************
            var service = {
                isGuest: isGuest,
                isAuthenticated: isAuthenticated,
				isAuthorizedForEvo: isAuthorizedForEvo,
				getUserId: getUserId,
				getOriginUserId: getOriginUserId,
				getEvoVersion: getEvoVersion,
                getUser: getUser,
                getToken: getToken,
                reloadUserData: reloadUserData,
                updateUserData: updateUserData,
                getEnvironmentId: getEnvironmentId,
                login: login,
				loginWithToken: loginWithToken,
                logout: logout,
				hasCompany: hasCompany,
				companyInactive: companyInactive,
				create: create,
				getStatusCreate: getStatusCreate,
				getRelocating: getRelocating,
				setRelocating: setRelocating,
                EVENTS: EVENTS
            };

            return service;
            //*******************************************

            ////////////////////////////////////////////////////////////////////////

            //*******************************************
            // METHODS
            //*******************************************
            /**
             * Logs in a new user.
             * @param {type} data - user data including an email, a password and an optional environment.
             * @returns {Promise}
             */
            function login(data,checkCompany) {
                var nuitApi = $injector.get('nuitApi');
                return nuitApi
                        .resolve('/login')
                        .post({environmentId: parseInt(data.environment)}, {}, {
                            headers: {
                                Authorization: 'Basic ' + btoa(data.email.toLowerCase() + ':' + data.password)
                            }
                        })
                        .then(function(response){onLoginSuccess(response,checkCompany)})
                        .catch(onLoginError);
            }
			/**
			 * Logs in with a json webtoken and reload the user data.
			 * @param {Object} token
			 * @returns {Promise}
			 */
			function loginWithToken(token,checkCompany) {
				$window.localStorage.setItem(STORAGE_NAME, token);
                $window.sessionStorage.setItem(STORAGE_NAME, token);

                return reloadUserData(checkCompany).then(function () {
                    $rootScope.$broadcast(EVENT_USER_LOGIN_SUCCESS, user);
                });
			}
            /**
             * Logs the current user out.
             */
            function logout(redirectToLogin, frontendOnly) {
				var token = getToken();
				$window.localStorage.removeItem(STORAGE_NAME);
				$window.sessionStorage.removeItem(STORAGE_NAME);

            	if(typeof redirectToLogin === 'undefined'){
            		redirectToLogin = true;
				}

				if(!frontendOnly){
					var nuitApi = $injector.get('nuitApi');
					nuitApi
						.resolve('/logout')
						.post(
							undefined,
							{},
							{
								headers: {
									'Access-Token': token
								}
							}
						)
						.finally(function () {
							angular.forEach(Object.keys(user), function (key) {
								delete user[key];
							});

							// a listener may take over the navigation by calling event.preventDefault()
							var logoutEvent = $rootScope.$broadcast(EVENTS.Logout);

							if (redirectToLogin && !logoutEvent.defaultPrevented) {
								var $timeout = $injector.get('$timeout');
								$timeout(function () {
									$window.location.reload();
								}, 150);
							}
						});
				}
            }

            /**
             * Reloads the user data by making a request to the API.
             * @returns {Promise}
             */
            function reloadUserData(checkCompany) {
                var nuitApi = $injector.get('nuitApi');
                var token = $window.localStorage.getItem(STORAGE_NAME) || $window.sessionStorage.getItem(STORAGE_NAME);
                if (!token) {
                    return;
                }
                var user = JSON.parse($window.atob(token.split('.')[1]));
                return nuitApi('user.data', user.userId)
                        .get()
                        .then(function(response){
                        	onUserDataReceived(response);
                        	if(checkCompany) {
								return nuitApi('companies').get({user: user.userId})
									.then(function (response) {
										if (angular.isArray(response.data) && response.data.length > 0) {
											company = response.data[0];
										} else {
											return null;
										}
									})
							}
						})
            }
            /**
             * Remotly updates the user data by sending the current user back to the API.
             * @returns {Promise}
             */
            function updateUserData() {
                var nuitApi = $injector.get('nuitApi');
                return nuitApi('user.data', user.id)
                        .put(user);
            }
            //*******************************************
            // EVENTS
            //*******************************************
            /**
             * This event is fired whenever a successful login attempt was made.
             * @param {Object} response
             */
            function onLoginSuccess(response,checkCompany) {
                $window.localStorage.setItem(STORAGE_NAME, response.data.token);
                $window.sessionStorage.setItem(STORAGE_NAME, response.data.token);

                reloadUserData(checkCompany).then(function () {
                    $rootScope.$broadcast(EVENT_USER_LOGIN_SUCCESS, user);
                });
            }
            /**
             * This event is fired whenever a login attempt has failed.
             * @param {Object} response
             */
            function onLoginFailed(response) {
                $rootScope.$broadcast(EVENT_USER_LOGIN_FAILED, response);
            }
            /**
             * This event is fired whenever a login attempt has been aborted
             * due to an error.
             * @param {Object} error
             */
            function onLoginError(error) {
                if (error.data && error.data.message) {
                    $log.error(error.data.message, error.status);
                }
                $rootScope.$broadcast(EVENT_USER_LOGIN_ERROR, error);
	            throw error;
            }
            /**
             * This event is fired whenever the user data has been refreshed.
             * @param {Object} response
             */
            function onUserDataReceived(response) {
                angular.merge(user, response.data);
				nuitLog.userContext(user);
            }
			function create(data) {
				var nuitApi = $injector.get('nuitApi');
				return nuitApi
					.resolve('/master/public/env/envs')
					.post(data)
					.then(function(response){return response.data;});
			}

			function getStatusCreate(key){
				var nuitApi = $injector.get('nuitApi');
				return nuitApi
					.resolve('/master/public/env/create-status/'+key)
					.get()
					.then(function(response){return response.data;});
			}
        }

        //*******************************************
        // AUTH INTERCEPTOR
        //*******************************************
        /** @ngInject */
        function AuthInterceptor(nuitAuth) {
            //*******************************************
            // SERVICE
            //*******************************************
            var service = {
                'request': requestHandler,
                'responseError': responseErrorHandler
            };

            //*******************************************
            return service;
            //*******************************************

            ////////////////////////////////////////////////////////////////////////

            //*******************************************
            // METHODS
            //*******************************************
            /**
             * Add authorization header to given request
             * @param request
             * @returns {*}
             */
            function requestHandler(request) {
                if (request.skipAuthorization) {
                    return request;
                }

                if (nuitAuth.isAuthenticated()) {
                    var token = TOKEN_PREFIX ? TOKEN_PREFIX + ' ' + nuitAuth.getToken() : nuitAuth.getToken();
                    request.headers[HEADER_NAME] = token;
                }

                return request;
            }

            /**
             * Handles error response
             * @param rejection
             * @returns {*}
             */
            function responseErrorHandler(rejection) {
                if (rejection.status === 403 && isAuthenticated() && wasSentWithToken(rejection)) {
					if(rejection.config === undefined || rejection.config.url === undefined || rejection.config.url.indexOf('images') < 0) {
						nuitAuth.logout();
					}
                }

                throw rejection;
            }

            /**
             * A 403 only indicates a dead session if the request actually carried a token. Bootstrap requests
             * leave before the token from the login URL is installed - logging out on their 403 invalidates a
             * valid token and reloads into the same race.
             *
             * @param rejection
             * @returns {Boolean}
             */
            function wasSentWithToken(rejection) {
                return !!(rejection.config && rejection.config.headers && rejection.config.headers[HEADER_NAME]);
            }
        }
    }
})();


(function () {
    'use strict';

    //*******************************************
    // WIKI
    // https://bitbucket.org/nu-it/ims.nu-it.at/wiki/Core/Services/nuitApi
    //*******************************************

    angular
            .module('app.core')
            .provider('nuitApi', ApiProvider);

    /** @ngInject */
    function ApiProvider(coreConstants, $cookiesProvider) {
        //*******************************************
        // PROVIDER
        //*******************************************
        var provider = this;

		$cookiesProvider.defaults.samesite = 'lax';
		$cookiesProvider.defaults.secure = false;
        //*******************************************

        //*******************************************
        // VARIABLES
        //*******************************************
        var baseUrl = coreConstants.apiURL;
        var registeredRoutes = {};
        var baseUrlHasChanged = false;
        //*******************************************

        //*******************************************
        // EXPOSE
        //*******************************************
        provider.$get = ApiService;
        provider.getBaseUrl = getBaseUrl;
        provider.register = register;
        provider.setBaseUrl = setBaseUrl;
        //*******************************************

        //*******************************************
        // METHODS
        //*******************************************
        /**
         * Returns currently set base url
         * @param {Boolean} [skipTrailingSlash=false] - True if base url without trailing slash is required
         * @return {string}
         */
        function getBaseUrl(skipTrailingSlash) {
            if (skipTrailingSlash) {
                return baseUrl;
            }

            return baseUrl + '/';
        }

        /**
         * Registers a new route for later usage. Add ":" before every dynamic route parameter.
         * @param {String} name
         * @param {String} url
         * @param {Object} [config]
         * @param {Array} [config.allow=['get','post','put','delete']]
         * @param {Array} [config.versions=[]]
         * @param {Boolean} [config.cache=false]
		 * @param {Array} [versions] - Array of versions to register.
         */
        function register(name, url, config) {
            if (registeredRoutes.hasOwnProperty(name)) {
                throw new Error('Routename already in use');
            }

            registeredRoutes[name] = {
                url: url,
                config: config
            };

			if(config && config.versions) {
				var versions = config.versions;
				delete config.versions;

				for (var i in versions) {
					var version = versions[i];
					var splitUrl = url.split('/');

					if(Number.isInteger(version)) {
						splitUrl[0] += '/v' + version;
						register(name + '.v' + version, splitUrl.join('/'), config);
					}else if(Number.isInteger(version.number) && version.path){
						splitUrl[0] += version.path;
						register(name + '.v' + version.number, splitUrl.join('/'), config);
					}else{
						console.error('Invalid version format for route ' + name + ': ' + version);
					}
				}
			}
        }

		function hasRoute(name) {
			return registeredRoutes.hasOwnProperty(name);
		}

        /**
         * Sets new base url which will be used by all api calls. The base url should not be changed multiple times.
         * @param {String} url
         */
        function setBaseUrl(url) {
            if (baseUrlHasChanged) {
                console.warn('Base url has been changed multiple times');
            }

            if (url.charAt(url.length - 1) === '/') {
                url = url.slice(0, -1);
            }

            baseUrlHasChanged = true;
            baseUrl = url;
        }

        //*******************************************
        // API SERVICE
        //*******************************************
        /** @ngInject */
        function ApiService($http) {
            //*******************************************
            // VARIABLES
            //*******************************************
            var routes = {};

            //*******************************************
            // Service
            //*******************************************
            var service = resolveRegisteredRoute;
            service.getBaseUrl = getBaseUrl;
            service.resolve = resolve;
			service.hasRoute = hasRoute;

            //*******************************************
            // INIT
            //*******************************************
            init();

            //*******************************************
            // RETURN SERVICE
            //*******************************************
            return service;
            //*******************************************

            //*******************************************
            // CLASSES
            //*******************************************
            /**
             * Provides REST-Functions to communicate with remote api
             * @param {String} url
             * @param {Object} [config] See nuApiProvider.register for further details
             * @constructor
             */
            function RESTObject(url, config) {
                var rest = this;
                var defaultConfig;
                var currentConfig;

                defaultConfig = {
                    allow: ['get', 'post', 'put', 'delete'],
                    cache: false,
					withCredentials: true,
					credentials: "include",
                    params: {}
                };

                currentConfig = angular.extend(defaultConfig, config);

                if (currentConfig.allow.indexOf('get') >= 0) {
                    /**
                     * Sends get-request to remote server
                     * @param {Object} [params] query parameters
                     * @param {Object} [config] config for $http service
                     * @return {Promise}
                     */
                    rest.get = function (params, config) {
                        // Make sure 'config' is an object, even if given value is undefined and inject given params
                        config = angular.extend({params: params, cache: defaultConfig.cache, withCredentials: defaultConfig.withCredentials,credentials: defaultConfig.credentials}, config);
                        return $http.get(url, config);
                    };
                }

                if (currentConfig.allow.indexOf('post') >= 0) {
                    /**
                     * Sends post-request to remote server
                     * @param {*} [data] data to send as request body
                     * @param {Object} [params] query parameters
                     * @param {Object} [config] config for $http service
                     * @return {Promise}
                     */
                    rest.post = function (data, params, config) {
                        // Make sure 'config' is an object, even if given value is undefined and inject given params
                        config = angular.extend({params: params, withCredentials: defaultConfig.withCredentials,credentials: defaultConfig.credentials}, config);
                        return $http.post(url, data, config);
                    };
                }

                if (currentConfig.allow.indexOf('put') >= 0) {
                    /**
                     * Sends put-request to remote server
                     * @param {*} [data] data to send as request body
                     * @param {Object} [params] query parameters
                     * @param {Object} [config] config for $http service
                     * @return {Promise}
                     */
                    rest.put = function (data, params, config) {
                        // Make sure 'config' is an object, even if given value is undefined and inject given params
                        config = angular.merge({params: params, withCredentials: defaultConfig.withCredentials,credentials: defaultConfig.credentials}, {params: currentConfig.params}, config);
						return $http.put(url, data, config);
                    };
                }

				if (currentConfig.allow.indexOf('patch') >= 0) {
					/**
					 * Sends patch-request to remote server
					 * @param {*} [data] data to send as request body
					 * @param {Object} [params] query parameters
					 * @param {Object} [config] config for $http service
					 * @return {Promise}
					 */
					rest.patch = function (data, params, config) {
						// Make sure 'config' is an object, even if given value is undefined and inject given params
						config = angular.merge({params: params, withCredentials: defaultConfig.withCredentials,credentials: defaultConfig.credentials}, {params: currentConfig.params}, config);
						return $http.patch(url, data, config);
					};
				}

                if (currentConfig.allow.indexOf('delete') >= 0) {
                    /**
                     * Sends delete-request to remote server
                     * @param {Object} [params] query parameters
                     * @param {Object} [config] config for $http service
                     * @return {Promise}
                     */
                    rest.delete = function (params, config) {
                        // Make sure 'config' is an object, even if given value is undefined and inject given params
                        config = angular.extend({params: params, withCredentials: defaultConfig.withCredentials,credentials: defaultConfig.credentials}, config);
                        return $http.delete(url, config);
                    };
                }

                /**
                 * Returns resolved url
                 * @return {String}
                 */
                rest.getUrl = function () {
                    return url;
                };
            }

            /**
             * Prepares route for being used with dynamic parameters
             * @param {String} url
             * @param {Object} [config] See nuApiProvider.register
             * @constructor
             */
            function Route(url, config) {
                var route = this;

                // Remove slash at begin to prevent empty array item when splitting url
                if (url.charAt(0) === '/') {
                    url = url.substr(1);
                }

                // Remove slash at the end to prevent empty array items when splitting url
                if (url.charAt(url.length - 1) === '/') {
                    url = url.substr(-1);
                }

                var splittedUrl = url.split('/');
                var urlParams = [];

                // Split url into pieces and save dynamic part positions into array
                for (var i in splittedUrl) {
                    if (splittedUrl[i].charAt(0) === ':') {
                        urlParams.push(i);
                    }
                }

                /**
                 * Injects parameters into url and generates new RESTObject
                 * @param {Array} params
                 * @param {Object} [options]
                 * @param {String} [options.noBaseUrl=false] - If the base url should be prepended
                 * @return {RESTObject}
                 */
                route.generateRESTObject = function (params, options) {
                    var splittedUrlCopy, generatedUrl;

                    if (params.length !== urlParams.length) {
                        throw new Error('Given params amount is not equal with required params');
                    }

                    // Make sure options is an object - even if 'options' is empty
                    options = angular.extend({}, options);

                    // Fastest way to clone an array
                    splittedUrlCopy = splittedUrl.slice();

                    // Inject params into url
                    for (var i in urlParams) {
                        splittedUrlCopy[urlParams[i]] = params[i];
                    }

                    generatedUrl = '/' + splittedUrlCopy.join('/');

                    if (!options.noBaseUrl) {
                        generatedUrl = baseUrl + generatedUrl;
                    }

                    return new RESTObject(generatedUrl, config);
                };
            }

            //*******************************************
            // METHODS
            //*******************************************
            /**
             * This function will be called whenever the service gets initialized
             */
            function init() {
                // Turns all registered routes into Route-instances
                for (var i in registeredRoutes) {
                    routes[i] = new Route(registeredRoutes[i].url, registeredRoutes[i].config);
                }
            }

            /**
             * This function resolves a given url and parameters
             * @param {String} Url - The url which should be resolved
             * @param {...String|Number} [Parameters] - Params that should be injected into given url
             * @param {Object} [Config] - How to resolve given url
             * @param {Boolean} [Config.noBaseUrl=false] - Wether the base url should be prepended or not. Should be true if url begins with http(s)://...
             * @return {RESTObject}
             */
            function resolve() {
                var url, params, route, args, config;

                // Turn arguments into array
                args = Array.prototype.slice.call(arguments);

                if (args.length < 1) {
                    throw new Error('Route url required');
                }

                url = args.shift();

                if (typeof args[args.length - 1] === 'object') {
                    config = args.pop();
                }

                params = args;
                route = new Route(url);

                return route.generateRESTObject(params, config);
            }

            /**
             * This function resolves a registered route with given parameters
             * @param {String} Name - The name of the route
             * @param {...String|Number} [Parameters] - Params that should be injected into route url
             * @return {RESTObject}
             */
            function resolveRegisteredRoute() {
				var name, params, route, args;

                // Turn arguments into array
                args = Array.prototype.slice.call(arguments);

                if (args.length < 1) {
                    throw new Error('Route name required');
                }

                name = args.shift();
                params = args;
                route = routes[name];

                if (!route) {
                    throw new Error('Trying to call unknown route');
                }

                return route.generateRESTObject(params);
            }
        }
    }
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('profileImage', filter);

	/** @ngInject */
	function filter(nuitProfiles) {
		return function (profile) {
			return nuitProfiles.getDisplayImage(profile);
		};
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('orderByTranslated', orderByTranslated); 

	function orderByTranslated($translate, $filter) {
		return function (array, objKey, i18nKeyPrefix) {
			var result = [];
			var translated = [];
			if(i18nKeyPrefix === undefined) { i18nKeyPrefix = ''; }
			angular.forEach(array, function (value) {
				var i18nKeySuffix = objKey ? value[objKey] : value;
				translated.push({
					key: value,
					label: $translate.instant(i18nKeyPrefix + i18nKeySuffix)
				});
			});
			angular.forEach($filter('orderBy')(translated, 'label'), function (sortedObject) {
				result.push(sortedObject.key);
			});
			return result;
		};
	};
}());
(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('orderBySavedProfileName', orderBySavedProfileName);

	function orderBySavedProfileName($translate, $filter) {
		return function (array) {
			var result = [];
			var translated = [];
			angular.forEach(array, function (value) {
				if(value.data && value.data.name) {
					translated.push({
						key: value,
						label: angular.isObject(value.data.name) ? $filter('nuitTranslate')(value.data.name, '???') : value.data.name
					});
				}else{
					translated.push({
						key: value,
						label: value.name
					});
				}
			});
			angular.forEach($filter('orderBy')(translated, 'label'), function (sortedObject) {
				result.push(sortedObject.key);
			});
			return result;
		};
	};
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('orderByNuitTranslated', orderByNuitTranslated);

	function orderByNuitTranslated($translate, $filter) {
		return function (array, objKey) {
			var result = [];
			var translated = [];
			angular.forEach(array, function (value) {
				translated.push({
					key: value,
					label: $filter('nuitTranslate')(value[objKey], '???')
				});
			});
			angular.forEach($filter('orderBy')(translated, 'label'), function (sortedObject) {
				result.push(sortedObject.key);
			});
			return result;
		};
	};
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitUnit', nuitUnit);

	/** @ngInject */
	function nuitUnit($log, $translate, nuitConfig) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var config = nuitConfig.current;
		//*******************************************

		//*******************************************
		// FILTER
		//*******************************************
		return filter;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function filter(value, unitConfig, hideUnit, invert, returnValue, decimalMod) {
			if(returnValue === undefined){
				returnValue = false;
			}

			if(unitConfig !== undefined) {
				if(angular.isString(unitConfig)) {
					if(config.units[unitConfig] !== undefined) {
						unitConfig = config.units[unitConfig];
					} else {
						unitConfig = {};
					}
				} else {
					unitConfig = {};
				}

				if(!angular.isString(unitConfig.symbol)) { unitConfig.symbol = '?'; $log.warn('No symbol defined in nuitUnit filter! Using "?" instead!'); }
				if(!angular.isNumber(unitConfig.factor)) { unitConfig.factor = 1; $log.warn('No factor defined in nuitUnit filter! Using "1" instead!'); }
				if(!angular.isNumber(unitConfig.decimals)) { unitConfig.decimals = 0; $log.warn('No decimals defined in nuitUnit filter! Using "0" instead!'); }
			}

			if(!angular.isNumber(value)) {
				value = parseFloat(value);

				if(isNaN(value)){
					value = 0;
				}
			}

			var factor = invert === true ? 1.0 / unitConfig.factor : unitConfig.factor;
			value = value / factor;

			if(returnValue){
				return value;
			}else{
				var result = value.toLocaleString('en-GB', {
					minimumFractionDigits: (unitConfig.decimals + (decimalMod?decimalMod:0)),
					maximumFractionDigits: (unitConfig.decimals + (decimalMod?decimalMod:0))
				});

				result = result.replace(new RegExp(',', 'g'), 'g');
				result = result.replace('.', 'f');

				result = result.replace(new RegExp('g', 'g'), config.units.formats.number.groupSeperator);
				result = result.replace('f', config.units.formats.number.decimalSeperator);

				if(!hideUnit) {
					result += " " + unitConfig.symbol;
				}

				return result;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitTranslatedTreeSort', filter);

	/** @ngInject */
	function filter($filter) {
		//*******************************************
		// FILTER
		//*******************************************
		return filter;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function filter(children, attribute) {
			return recursiveSort(children, attribute);
		}

		function recursiveSort(children, attribute){
			if(!angular.isArray(children)){
				return children;
			}

			if(!attribute){
				attribute = 'name';
			}

			for(var i = 0;i<children.length;i++){
				children[i].children = recursiveSort(children[i].children);
			}

			return $filter('orderByNuitTranslated')(children, attribute);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitTranslate', filter);

	/** @ngInject */
	function filter($translate, nuitAuth) {
		//*******************************************
		// FILTER
		//*******************************************
		return filter;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function filter(value, fallbackString, fallbackLang) {
            if(!angular.isObject(value)) { return value; }
			if(value === undefined || value === null || value === '') { return ''; }

			var locale = nuitAuth.getUser().locale;

            if(locale === undefined || value[locale] === undefined || value[locale] === null || value[locale] === '')
			{
				if(fallbackLang === undefined) { fallbackLang = 'en'; }
				if(angular.isString(value[fallbackLang]) && value[fallbackLang] !== '') { return value[fallbackLang]; }
				return angular.isString(fallbackString) ? fallbackString : '';
			}

			return value[locale];
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitEvoNormalize', nuitEvoNormalize);

	/**
	 * Normalizes values delivered by evo v3 to the base unit of older evo versions,
	 * so they can be passed on to the nuitUnit filter.
	 * Usage: {{ value | nuitEvoNormalize:'area' | nuitUnit:'area' }}
	 */
	/** @ngInject */
	function nuitEvoNormalize(nuitAuth) {
		//*******************************************
		// CONSTANTS
		//*******************************************
		// divisor from evo v3 unit to the unit of older versions
		var V3_DIVISORS = {
			area: 1000000 // mm² -> m²
		};
		//*******************************************

		//*******************************************
		// FILTER
		//*******************************************
		return filter;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function filter(value, unitKey) {
			if(!angular.isNumber(value) || !V3_DIVISORS[unitKey] || nuitAuth.getEvoVersion() !== 3) {
				return value;
			}

			return value / V3_DIVISORS[unitKey];
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitDatetime', nuitDatetime);

	/** @ngInject */
	function nuitDatetime(nuitConfig) {
        var config = nuitConfig.current;

		return filter;

        function filter(value, format) {
			var result = toDate(value);

			if(config.localization) {
				switch (format) {
					case 'datetime':
						format = config.localization.dateTimeFormat;
						break;
					case 'date':
						format = config.localization.dateFormat;
						break;
					case 'time':
						format = config.localization.timeFormat;
						break;
				}
			}

            if(format) {
                return moment(result).format(format);
            }
            return result;
        }

		// Unix seconds (v1 routes) or ISO-8601 (v2). Sub-millisecond digits get
		// truncated. Anything unparseable stays at the epoch, as before.
		function toDate(value) {
			if (value instanceof Date) {
				return value;
			}

			if (!angular.isNumber(value)) {
				var text = value === null || angular.isUndefined(value) ? '' : String(value).trim();

				if (text && !/^-?\d+(\.\d+)?$/.test(text)) {
					var parsed = moment(text, moment.ISO_8601, true);
					return parsed.isValid() ? parsed.toDate() : new Date(0);
				}

				value = parseInt(text, 10);

				if (isNaN(value)) {
					value = 0;
				}
			}

			return new Date(value * 1000);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitCurrency', filter);

	/** @ngInject */
	function filter($filter, nuitConfig) {
		//*******************************************
		// VARIABLES
		//*******************************************
		var config = nuitConfig.current;
		//*******************************************

		//*******************************************
		// FILTER
		//*******************************************
		return filter;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function filter(value) {
			var symbol = config.localization.currency.symbol;
			var space = config.localization.currencySpaceBetween !== false ? ' ' : '';
			var symbolInFront = config.localization.currencySymbolInFront === true;

			if (value === undefined || value === null) {
				value = 0.0;
			}
			if (!angular.isNumber(value) && value !== '') {
				value = parseFloat(value.replace(',', '.'));
			}

			if (angular.isNumber(value)) {
				value = value.toLocaleString('en-GB', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			}

			value = value.replace(new RegExp(',', 'g'), 'g');
			value = value.replace('.', 'f');

			value = value.replace(new RegExp('g', 'g'), config.units.formats.number.groupSeperator);
			value = value.replace('f', config.units.formats.number.decimalSeperator);

			if (symbolInFront) {
				return symbol + space + value;
			} else {
				return value + space + symbol;
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitBlank', nuitBlank);

	/** @ngInject */
	function nuitBlank($filter, $log, PROFILE_BLANK_FIELDS, DotNotationService, nuitProfiles) {
		//*******************************************
		// CONFIGURATION - property names live in PROFILE_BLANK_FIELDS
		// (core/constants/profile.blank.fields.constant.js), the single blank value
		// comes from nuitProfiles.getBlank(); only formatting is set up here.
		//*******************************************
		var SEPARATOR = ' × ';
		var UNIT = 'length';
		var VARIANTS = {										// decimals on top of the unit's own
			nominal: {decimals: 0},
			production: {decimals: 1}						// with bending allowance
		};
		var DEFAULT_VARIANT = 'nominal';
		//*******************************************

		return filter;

		////////////////////////////////////////////////////////////////////////

		/**
		 * "X × Y unit" for multiSide, otherwise the single blank value.
		 * Takes the object, not the scalar:
		 *
		 *   {{ geometry.profile | nuitBlank }}
		 *   {{ geometry.productionProfile | nuitBlank:'production' }}
		 *
		 * @param {Object} source profile or production profile
		 * @param {String} [variant] key from VARIANTS, defaults to 'nominal'
		 * @param {String} [unit] overrides UNIT
		 * @returns {String}
		 */
		function filter(source, variant, unit) {
			var decimals = variantDecimals(variant);

			if (!angular.isObject(source)) {
				return format(source, decimals, unit);
			}

			if (isMultiSide(source)) {
				var pair = firstPair(source);

				if (pair) {
					return format(pair[0], decimals, unit, true) + SEPARATOR +
						format(pair[1], decimals, unit);
				}
			}

			return format(nuitProfiles.getBlank(source), decimals, unit);
		}

		function variantDecimals(variant) {
			var key = variant || DEFAULT_VARIANT;

			if (!VARIANTS.hasOwnProperty(key)) {
				$log.warn('Unknown variant "' + key + '" in nuitBlank filter! Using "' +
					DEFAULT_VARIANT + '" instead!');
				key = DEFAULT_VARIANT;
			}

			return VARIANTS[key].decimals;
		}

		function format(value, decimals, unit, hideUnit) {
			return $filter('nuitUnit')(value, unit || UNIT, !!hideUnit, undefined, undefined, decimals);
		}

		function isMultiSide(source) {
			for (var i = 0; i < PROFILE_BLANK_FIELDS.multiSide.length; i++) {
				var value = DotNotationService.get(source, PROFILE_BLANK_FIELDS.multiSide[i]);

				if (angular.isDefined(value) && value !== null) {
					return !!value;
				}
			}

			return false;
		}

		function firstPair(source) {
			for (var i = 0; i < PROFILE_BLANK_FIELDS.pairs.length; i++) {
				var x = DotNotationService.get(source, PROFILE_BLANK_FIELDS.pairs[i][0]);
				var y = DotNotationService.get(source, PROFILE_BLANK_FIELDS.pairs[i][1]);

				if (angular.isNumber(x) && angular.isNumber(y)) {
					return [x, y];
				}
			}

			return null;
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitNumber', nuitNumber);

	/** @ngInject */
	function nuitNumber(nuitConfig) {
		var config = nuitConfig.current;

		return function (value, digits) {
			if(typeof value !== 'number'){
				value = parseFloat(value);

				if(isNaN(value)){
					return 'NaN';
				}
			}

			if(!digits){
				digits = 2;
			}

			if (angular.isNumber(value)) {
				value = value.toLocaleString('en-GB', {
					minimumFractionDigits: digits,
					maximumFractionDigits: digits
				});
			}

			value = value.replace(new RegExp(',', 'g'), config.units.formats.number.groupSeperator);
			value = value.replace('.', config.units.formats.number.decimalSeperator);

			return value;
		};
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitFormatter', nuitFormatter);

	/** @ngInject */
	function nuitFormatter(FormatterService) {
		//*******************************************
		// FILTER
		//*******************************************
		return filter;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function filter(nameFormat, object, trim, separator) {
			if(!angular.isString(nameFormat)){return nameFormat;}
			return FormatterService.format(nameFormat, object, trim, separator);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitAddressFormatter', nuitAddressFormatter);

	/** @ngInject */
	function nuitAddressFormatter(FormatterService) {
		//*******************************************
		// FILTER
		//*******************************************
		return filter;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function filter(address, defaultFormat, countryFormats, trim, countryAttribute) {
			if(!address){
				return '';
			}else {
				if (!countryAttribute) {
					countryAttribute = 'country';
				}

				var selectedFormat = defaultFormat;

				if (angular.isArray(countryFormats) && address[countryAttribute]) {
					for (var i = 0; i < countryFormats.length; i++) {
						var format = countryFormats[i];
						if (format.country === address[countryAttribute]) {
							selectedFormat = format.address;
							break;
						}
					}
				}

				if (!angular.isString(selectedFormat)) {
					return address;
				}
				return FormatterService.format(selectedFormat, address, trim);
			}
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('languageFilter', languageFilter);

	function languageFilter($translate, nuitConfig) {
		return function (array, languageKey) {
			var result = [];

			if (array) {

				var language = $translate.use();

				var perLanguage = {};
				var config = nuitConfig.getCurrent();

				for (var i = 0; i < array.length; i++) {
					var entity = array[i];
					if (!perLanguage.hasOwnProperty(entity[languageKey])) {
						perLanguage[entity[languageKey]] = [];
					}

					perLanguage[entity[languageKey]].push(entity);
				}

				if (perLanguage.hasOwnProperty(language)) {
					result = perLanguage[language];
				} else {
					for (var j = 0; j < config.languages.length; j++) {
						if (perLanguage.hasOwnProperty(config.languages[j])) {
							return perLanguage[language];
						}
					}
				}
			}

			return result;
		};
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitDotNotation', filter);

	/** @ngInject */
	function filter(DotNotationService) {
		function filter(object, dotNotation, defaultValue) {
			filter.$stateful = true;

			if(!dotNotation){
				return defaultValue;
			}else {
				return DotNotationService.get(object, dotNotation, defaultValue);
			}
		}

		return filter;
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('dateDistance', filter);

	/** @ngInject */
	function filter($translate, $filter) {
		//*******************************************
		// FILTER
		//*******************************************
		filter.$stateful = true;
		
		return filter;
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		function filter(value, defaultFormat) {
			if(angular.isNumber(value)) { value = new Date(value*1000); }
            if(!angular.isDate(value)) { return value; }
			
			var diff = new Date() - value;
			var distance = { days: 0, hours: 0, minutes: 0, seconds: 0};
			
			distance.days = Math.floor(diff / (1000 * 60 * 60 * 24));
			diff -=  distance.days * (1000 * 60 * 60 * 24);

			distance.hours = Math.floor(diff / (1000 * 60 * 60));
			diff -= distance.hours * (1000 * 60 * 60);

			distance.minutes = Math.floor(diff / (1000 * 60));
			diff -= distance.minutes * (1000 * 60);

			distance.seconds = Math.floor(diff / (1000));
			diff -= distance.seconds * (1000);
			
			distance.months = Math.floor(distance.days / 30);
			distance.weeks = Math.floor(distance.days / 7);
			distance.months = Math.floor(distance.days / 30);
			
		    if(distance.days <= 0 && distance.hours <= 0 && distance.minutes <= 0 && distance.seconds <= 0) {
				return $translate.instant('TIME.JUST_NOW');
			} else if(distance.days < 1) {
				if(distance.hours < 1) {
					if(distance.minutes < 1) {
						return $translate.instant('TIME.SECONDS_AGO', distance);
					} else {
						return $translate.instant('TIME.MINUTES_AGO', distance);
					}
				} else {
					return $translate.instant('TIME.HOURS_AGO', distance);
				}
			} else if(distance.days === 1) {
				return $translate.instant('TIME.YESTERDAY');
			} else if(distance.days <= 6) {
				return $translate.instant('TIME.DAYS_AGO', distance);
			} else if(distance.days <= 30) {
				return $translate.instant('TIME.WEEKS_AGO', distance);
			} else if(distance.days <= 365) {
				return $translate.instant('TIME.MONTHS_AGO', distance);
			}
			
			return $filter('date')(value.getTime(), defaultFormat);
		}
	}
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.filter('nuitConditionCheck', filter);

	/** @ngInject */
	function filter(ConditionCheckService) {
		function filter(object, conditions, defaultValue) {
			filter.$stateful = true;
			return ConditionCheckService.matchesAll(conditions, object, defaultValue);
		}

		return filter;
	}
}());

(function () {
	'use strict';

	/**
	 * Single place to configure which profile / production profile properties
	 * represent the blank ("Zuschnitt"). Consumers:
	 *
	 *   - nuitBlank filter (display: "X × Y unit" or single length)
	 *   - nuitProfiles.getBlank() (numeric blank length for v3 profiles, tags, price rules)
	 *
	 * Property paths are resolved with dot notation ("profile.multiSide").
	 * See docs/production-v2-order-sample.json and the production-v2 openapi.yaml
	 * for the available fields:
	 *
	 *   Profile            dimX/dimY                            bounding box of the flat blank (the cut rectangle)
	 *                      lengthX1/lengthX2/lengthY1/lengthY2  bumper-to-bumper, X2/Y2 = second parallel (tapered)
	 *                      blank                                deprecated alias of lengthX1
	 *   ProductionProfile  stretchedDimX/stretchedDimY          flat dims incl. bending allowance
	 *                      blank                                unfolded blank length incl. bending allowance
	 */
	angular
		.module('app.core')
		.constant('PROFILE_BLANK_FIELDS', {
			// Marks a source as box / multiSide. First defined path wins.
			multiSide: ['multiSide', 'profile.multiSide'],

			// X × Y pairs for multiSide sources. First all-numeric pair wins.
			pairs: [
				['stretchedDimX', 'stretchedDimY'],
				['dimX', 'dimY']
			],

			// Single blank length. First numeric path wins.
			length: ['dimX', 'blank']
		});
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.constant('EVO_TOOLBAR_SETTINGS', {
			evo: {
				toolbar: {
					logo: '',
					showLogo: true,
					showEnvironment: true,
					showCalculator: false,
					showAvatar: true,
					languages: {
						enabled: true,
						flags: true,
						hideIfSingle: false
					},
					externalField: {
						enabled: false,
						nameFormat: '',
						showCondition: []
					}
				}
			}
		});
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.constant('EVO_SKETCHES_SETTINGS', {
			evo: {
				sketches: {
					enabled: false
				}
			}
		});
}());

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .constant('EVO_SETTINGS', {
		  evo: {
			  title: 'nu EVOLUTION',
			  defaultState: 'app.editor',
			  theme: {
				  primary: '#00517F',
				  accent: '#871024',
				  navbar: '#ffffff',
			  }
		  },
		  localization:{
			  address: {
				  zipCode: {
					  min: 4,
					  max: 5,
					  numbersOnly: true
				  }
			  }
		  }
	  });
}());

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .constant('EVO_SERVICEWORKER_SETTINGS', {
		  evo: {
			  serviceworker: {
				  enabled: false
			  }
		  }
	  });
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.constant('EVO_PRODUCTS_SETTINGS', {
			evo: {
				products: {
					enabled: true,
					filters: [],
					navigationWeight: 2,
					showPrices: false,
					showUnpurchasable: true,
					showDefaultGridView: true, // EvoNext default value for grid/list view
					inventory: {
						enabled: false,
						showAmount: false
					},
					list: {
						customFields: [
							/*{
								name: {de: 'Suchwort'},
								format: '{{externalData.abasArticle.abasSearchTerm}}'
							},
							{
								name: {de: 'MaterialId'},
								format: '{{externalData.abasArticle.abasMaterialId}}'
							},
							{
								name: {de: 'Länge'},
								format: '{{externalData.abasArticle.length}}'
							}*/
						],
						filters: [
							/*{
								id: 1,
								inputType: 'map', //'enum','string','group', 'map'
								name: {de: 'status', en: 'en', fr: 'fr'},
								attribute: 'externalData.abasArticle.abasArticleType',
								values: [{id: 1, name: 'test1'}, {id: 2, name: 'test2'}]
								//displayFilter: 'nuitCurrency'
							}*/
						],
						conditionalStyle: [
							/*{
								attribute: 'externalId',
								type: 'isEqual',
								value: 's1',
								style: {
									'background-color': '#AAAAAA'
								}
							}*/
						]
					}
				}
			}
		});
}());

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .constant('EVO_MATERIAL_SETTINGS', {
		  evo: {
			  material: {
					showGroupFilter: true,
					showThicknessFilter: true,
					showThicknessFilterComparator: false,
					showColorFrontFilter: true,
					showProtectiveFilmFilter: true,
					details: {
						showColorFront: true,
						showColorBack: true,
						showLength: true,
						showCutting: true,
						showThickness: true,
						showWeight: true,
						showPowderCoated: true,
						showProtectiveFilm: true,
						showInactive: true,
						customFields: {
							top: [],
							bottom: []
						}
					},
					filters: [],
				  	customFilters: []
				}
		  }
	  });
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.constant('EVO_EDITOR_SETTINGS', {
			evo: {
				editor: {
					enabled: true,
					show3DPreview: true,
					hideProfileImport: true,
					hideProfileExport: true,
					hideStepImport: true,
					navigationWeight: 1,
					lockMaterial: false,
					conditions:{
						readOnlyMaterial:[],
						readOnlyLength:[],
						disableNewProfile:[],
						disableOpenProfile:[],
						disableSaveProfile:[],
						disableSaveProfileToCart:[]
					},
					skipCartDialog: false,
					reloadAfterSubmit: false,
					clearedParamsAfterSubmit:[],
					profileCache: {
						enabled: false,
						//type: 'localStorage' // 'default' or 'localStorage'
					},
					stamping: {
						enabled: false
					},
					wraps: {
						defaultClosed: true
					},
					style: {
						gridWidth: 20
					},
					validation: {
						length: true,
						blank: true,
						segmentLength: true,
						hem: false,
						hemLength: true,
						bendingAngle: true
					},
					externalAPI: {
						profiles: {
//							foreignName: 'ABAS'
						},
						loadUrl: null,
						addToCartUrl: null
					},
					customData: [
//						{ EXAMPLE
//							key: 'ABAS.ARTICLE_ID',
//							url: '/abas/articleids',
//							type: 'select',
//							required: true,
//							property: 'abasArticleId',
//							nameProperty: '?',
//							replace: [{
//								property: 'title',
//								condition: 'empty'
//							}]
//						}
					],
					addProfileDialog: {
						customCartConditions: [
							//{"attribute":"externalId","type":"isSet"}
						],
						customCartConditionsRequired: [
							//{"attribute":"externalId","type":"isSet"}
						]
					},
					defaultProfileName:{
						enabled: false,
						preFix: '',
						template: '',
						postFix: '',
						separator: '',
						forceOverrideOnUpdate: false,
						forceClear: false
					},
					customSegments:
						{
							enabled: false,
							types: []
						}
				},
				profiles: {
					showDefaultGridView: true, // EvoNext default value for grid/list view
				}
			}
		});
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.constant('EVO_DOCUMENTS_SETTINGS', {
			evo: {
				documents: {
					orders: {
						enabled: true,
						allowReorder: true,
						allowCancel: false
					},
					proposals: {
						enabled: false,
						allowTransitionFromStatus: [],
						allowReorder: true
					},
					offers: {
						enabled: false,
						allowTransitionFromStatus: [],
						allowReorder: true
					},
					invoices: {
						enabled: false,
						orderNameFormat: '{{orderProjectName}}'
					}
				}
			}
		});
}());

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .constant('EVO_DEBUG_SETTINGS', {
		  evo: {
			  debug: {
				  enabled: false
			  }
		  }
	  });
}());

(function () {
	'use strict';

	angular
		.module('app.core')
		.constant('EVO_CART_SETTINGS', {
			evo: {
				cart: {
					enabled: true,
					finalStep: 2,
					fields: [],
					showPrices: false,
					showBadge: false,
					badgeColor: '#25ae93',
					navigationWeight: 3,
					profileTitleMaxLength: 50,
					profileTitleMultiline: false,
					requireProfileTitle: false,
					cartURL: 'shop/carts/:id',
					duplicateProfileUrl: 'shop/carts/:cartId/profiles/:id/duplicate',
					cartPositionURL: 'shop/carts/:cartId/:pos',
					cartProfileURL: 'shop/carts/:cartId/profiles/:id',
					cartCheckoutURL: 'shop/carts/:id/checkout',
					payment:{
						enabled: false,
						default: 'invoice',
						options:[
							{
								id: 'invoice',
								enabled: true
							},
							{
								id: 'stripe',
								enabled: true,
								checkoutURL: 'payment/cart/:id/checkout',
								retryCheckoutURL: 'payment/order/:id/checkout'
							}
						]
					},
					externalCartURL: '',
					productPositionRemarks: false,
					profilePositionRemarks: false,
					profilePositionCheck:
						{
							enabled: false,
							key: 'customData.checked' //'externalData.abasPosition.abasPositionChecked'
						},
					profilePositionMarkForCheck:
						{
							enabled: false,
							key: 'customData.markForCheck'
						},
					productPositionCheck:
						{
							enabled: false,
							key: 'customData.checked' //'externalData.abasPosition.abasPositionChecked'
						},
					productPositionMarkForCheck:
						{
							enabled: false,
							key: 'customData.markForCheck'
						},
					profileCheck: false,
					allowSpecials: false,
					specialsTemplate: 'default',
					allowCartDeletion: true,
					allowImport: false,
					allowCopy: true,
					allowProposal: false,
					proposalCheckoutStatus: '',
					allowAddressEditing: true,
					allowDeliveryAddressEditing: true,
					forceShowDeliveryAddress: false,
					mandatoryShippingAddress: true,
					checkCompanyAddressEquality: false,
					emptyCartCheckoutConditions: [],
					hideOrderCondition: [],
					hideOfferCondition: [],
					addressFormat: '' +
						'{{companyname}}\n' +
						'{{additional_companyname}}\n' +
						'{{contact_name}}\n' +
						'{{street}}\n' +
						'{{country}}-{{zip}} {{city}}',
					addressFormatByCountry: [],
					delivery: {
						minDateOffset: 0,
						extendedMinDateOffsetStart: '',
						extendedMinDateOffsetDays: 0,
						minDateOffsetPickup: 0,
						extendedMinDateOffsetPickupStart: '',
						extendedMinDateOffsetPickupDays: 0,
						bankHolidays: [],
						defaultCompletionDate: true
					},
					components: {
						deliverySettings: false, // Type of shipping field, shipping date field
						showAddress: true,
						showCompletionDate: true,
						showNumberOfPositions: true, // Show number of positions
						showNumberOfArticles: true, // Show number of articles
						showNumberOfParts: true, // Show number of parts
						showMaximumLength: true, // Show maximum length
						showTotalWeight: true, // Show total weight
						showSaveProposal: false,
						showSaveProposalInfo: true,
						showOrderInfo: false,
						showShippingAddress: true,
						showShippingType: true
					},
					layout: { //order of elements in step 2 of cart
						forceMobile: false,
						root: {
							layout: 'row',
							order: ['overview','form']
						},
						overview: {
							layout: 'column',
							order: ['price','details']
						},
						form: {
							layout: 'column',
							order: ['address','fields']
						},
						address: {
							order: ['addresses', 'shippingType']
						},
						sales: {
							order: []
						}
					},
					fixedTime: { //allow fixed time for order
						enabled: false,
						hours: [],
						minutes: [],
						enableTolerances: true,
						tolerances: [],
						maxTime: '17:00'
					},
					agbs: {
						enabled: false,
						agbsLinkURL: 'https://evo.nu-it.at'
					},
					customFields: {
						details: {
							top:[]
						}
					},
					profile: {
						customTags: [],
						positions:{
							readOnlyConditions:{
								name: [],
								length:[],
								quantity:[],
								remove:[],
								add:[],
								specials:[],
								remarks:[]
							}
						},
						showDetailsDialog: false
					},
					product: {
						customTags: []
					},
					checkout: {
						enabled: true,
						useOfferType: true,
						afterBlock: {
							enabled: false,
							showConditions: []
						},
						profileCheckoutConditions: []
					},
					attachments:{
						enabled: false,
						acceptedMimeTypes: [],
						maxSize: 5242880
					},
					tags:{
						enabled: false,
						selectable:[]
					},
					quantity:{
						product: {
							max: 9999
						},
						profile: {
							max: 9999
						}
					},
					assignee:{
						enabled: false,
						required: false,
						multiple: false,
						users:[]
					},
					project: {
						enabled: false,
						required: false
					}
				}
			}
		});
}());

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .constant('EVO_ACCOUNT_SETTINGS', {
		  evo: {
				account: {
					personalData: {
						enabled: true,
						allowPasswordChange: true
					},
					deliveryAddresses: {
						enabled: false
					},
					settings: {
						enabled: false
					},
					carts: {
						enabled: false
					},
					folders:{
						allowPublicFolderEditing: false,
						allowPublicFileEditing: true,
						sortByName: false
					},
					files:{
						sortByName: false
					}
				}
			}
	  });
}());

(function () {
    'use strict';
    angular
        .module('app.core')
        .constant('Countries', constant());

		function constant() {
			return [ 
				{name: 'Afghanistan', code: 'AF'}, 
				{name: 'Åland Islands', code: 'AX'}, 
				{name: 'Albania', code: 'AL'}, 
				{name: 'Algeria', code: 'DZ'}, 
				{name: 'American Samoa', code: 'AS'}, 
				{name: 'AndorrA', code: 'AD'}, 
				{name: 'Angola', code: 'AO'}, 
				{name: 'Anguilla', code: 'AI'}, 
				{name: 'Antarctica', code: 'AQ'}, 
				{name: 'Antigua and Barbuda', code: 'AG'}, 
				{name: 'Argentina', code: 'AR'}, 
				{name: 'Armenia', code: 'AM'}, 
				{name: 'Aruba', code: 'AW'}, 
				{name: 'Australia', code: 'AU'}, 
				{name: 'Austria', code: 'AT'}, 
				{name: 'Azerbaijan', code: 'AZ'}, 
				{name: 'Bahamas', code: 'BS'}, 
				{name: 'Bahrain', code: 'BH'}, 
				{name: 'Bangladesh', code: 'BD'}, 
				{name: 'Barbados', code: 'BB'}, 
				{name: 'Belarus', code: 'BY'}, 
				{name: 'Belgium', code: 'BE'}, 
				{name: 'Belize', code: 'BZ'}, 
				{name: 'Benin', code: 'BJ'}, 
				{name: 'Bermuda', code: 'BM'}, 
				{name: 'Bhutan', code: 'BT'}, 
				{name: 'Bolivia', code: 'BO'}, 
				{name: 'Bosnia and Herzegovina', code: 'BA'}, 
				{name: 'Botswana', code: 'BW'}, 
				{name: 'Bouvet Island', code: 'BV'}, 
				{name: 'Brazil', code: 'BR'}, 
				{name: 'British Indian Ocean Territory', code: 'IO'}, 
				{name: 'Brunei Darussalam', code: 'BN'}, 
				{name: 'Bulgaria', code: 'BG'}, 
				{name: 'Burkina Faso', code: 'BF'}, 
				{name: 'Burundi', code: 'BI'}, 
				{name: 'Cambodia', code: 'KH'}, 
				{name: 'Cameroon', code: 'CM'}, 
				{name: 'Canada', code: 'CA'}, 
				{name: 'Cape Verde', code: 'CV'}, 
				{name: 'Cayman Islands', code: 'KY'}, 
				{name: 'Central African Republic', code: 'CF'}, 
				{name: 'Chad', code: 'TD'}, 
				{name: 'Chile', code: 'CL'}, 
				{name: 'China', code: 'CN'}, 
				{name: 'Christmas Island', code: 'CX'}, 
				{name: 'Cocos (Keeling) Islands', code: 'CC'}, 
				{name: 'Colombia', code: 'CO'}, 
				{name: 'Comoros', code: 'KM'}, 
				{name: 'Congo', code: 'CG'}, 
				{name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
				{name: 'Cook Islands', code: 'CK'}, 
				{name: 'Costa Rica', code: 'CR'}, 
				{name: 'Cote D\'Ivoire', code: 'CI'}, 
				{name: 'Croatia', code: 'HR'}, 
				{name: 'Cuba', code: 'CU'}, 
				{name: 'Cyprus', code: 'CY'}, 
				{name: 'Czech Republic', code: 'CZ'}, 
				{name: 'Denmark', code: 'DK'}, 
				{name: 'Djibouti', code: 'DJ'}, 
				{name: 'Dominica', code: 'DM'}, 
				{name: 'Dominican Republic', code: 'DO'}, 
				{name: 'Ecuador', code: 'EC'}, 
				{name: 'Egypt', code: 'EG'}, 
				{name: 'El Salvador', code: 'SV'}, 
				{name: 'Equatorial Guinea', code: 'GQ'}, 
				{name: 'Eritrea', code: 'ER'}, 
				{name: 'Estonia', code: 'EE'}, 
				{name: 'Ethiopia', code: 'ET'}, 
				{name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
				{name: 'Faroe Islands', code: 'FO'}, 
				{name: 'Fiji', code: 'FJ'}, 
				{name: 'Finland', code: 'FI'}, 
				{name: 'France', code: 'FR'}, 
				{name: 'French Guiana', code: 'GF'}, 
				{name: 'French Polynesia', code: 'PF'}, 
				{name: 'French Southern Territories', code: 'TF'}, 
				{name: 'Gabon', code: 'GA'}, 
				{name: 'Gambia', code: 'GM'}, 
				{name: 'Georgia', code: 'GE'}, 
				{name: 'Germany', code: 'DE'}, 
				{name: 'Ghana', code: 'GH'}, 
				{name: 'Gibraltar', code: 'GI'}, 
				{name: 'Greece', code: 'GR'}, 
				{name: 'Greenland', code: 'GL'}, 
				{name: 'Grenada', code: 'GD'}, 
				{name: 'Guadeloupe', code: 'GP'}, 
				{name: 'Guam', code: 'GU'}, 
				{name: 'Guatemala', code: 'GT'}, 
				{name: 'Guernsey', code: 'GG'}, 
				{name: 'Guinea', code: 'GN'}, 
				{name: 'Guinea-Bissau', code: 'GW'}, 
				{name: 'Guyana', code: 'GY'}, 
				{name: 'Haiti', code: 'HT'}, 
				{name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
				{name: 'Holy See (Vatican City State)', code: 'VA'}, 
				{name: 'Honduras', code: 'HN'}, 
				{name: 'Hong Kong', code: 'HK'}, 
				{name: 'Hungary', code: 'HU'}, 
				{name: 'Iceland', code: 'IS'}, 
				{name: 'India', code: 'IN'}, 
				{name: 'Indonesia', code: 'ID'}, 
				{name: 'Iran, Islamic Republic Of', code: 'IR'}, 
				{name: 'Iraq', code: 'IQ'}, 
				{name: 'Ireland', code: 'IE'}, 
				{name: 'Isle of Man', code: 'IM'}, 
				{name: 'Israel', code: 'IL'}, 
				{name: 'Italy', code: 'IT'}, 
				{name: 'Jamaica', code: 'JM'}, 
				{name: 'Japan', code: 'JP'}, 
				{name: 'Jersey', code: 'JE'}, 
				{name: 'Jordan', code: 'JO'}, 
				{name: 'Kazakhstan', code: 'KZ'}, 
				{name: 'Kenya', code: 'KE'}, 
				{name: 'Kiribati', code: 'KI'}, 
				{name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
				{name: 'Korea, Republic of', code: 'KR'}, 
				{name: 'Kuwait', code: 'KW'}, 
				{name: 'Kyrgyzstan', code: 'KG'}, 
				{name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
				{name: 'Latvia', code: 'LV'}, 
				{name: 'Lebanon', code: 'LB'}, 
				{name: 'Lesotho', code: 'LS'}, 
				{name: 'Liberia', code: 'LR'}, 
				{name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
				{name: 'Liechtenstein', code: 'LI'}, 
				{name: 'Lithuania', code: 'LT'}, 
				{name: 'Luxembourg', code: 'LU'}, 
				{name: 'Macao', code: 'MO'}, 
				{name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
				{name: 'Madagascar', code: 'MG'}, 
				{name: 'Malawi', code: 'MW'}, 
				{name: 'Malaysia', code: 'MY'}, 
				{name: 'Maldives', code: 'MV'}, 
				{name: 'Mali', code: 'ML'}, 
				{name: 'Malta', code: 'MT'}, 
				{name: 'Marshall Islands', code: 'MH'}, 
				{name: 'Martinique', code: 'MQ'}, 
				{name: 'Mauritania', code: 'MR'}, 
				{name: 'Mauritius', code: 'MU'}, 
				{name: 'Mayotte', code: 'YT'}, 
				{name: 'Mexico', code: 'MX'}, 
				{name: 'Micronesia, Federated States of', code: 'FM'}, 
				{name: 'Moldova, Republic of', code: 'MD'}, 
				{name: 'Monaco', code: 'MC'}, 
				{name: 'Mongolia', code: 'MN'}, 
				{name: 'Montserrat', code: 'MS'}, 
				{name: 'Morocco', code: 'MA'}, 
				{name: 'Mozambique', code: 'MZ'}, 
				{name: 'Myanmar', code: 'MM'}, 
				{name: 'Namibia', code: 'NA'}, 
				{name: 'Nauru', code: 'NR'}, 
				{name: 'Nepal', code: 'NP'}, 
				{name: 'Netherlands', code: 'NL'}, 
				{name: 'Netherlands Antilles', code: 'AN'}, 
				{name: 'New Caledonia', code: 'NC'}, 
				{name: 'New Zealand', code: 'NZ'}, 
				{name: 'Nicaragua', code: 'NI'}, 
				{name: 'Niger', code: 'NE'}, 
				{name: 'Nigeria', code: 'NG'}, 
				{name: 'Niue', code: 'NU'}, 
				{name: 'Norfolk Island', code: 'NF'}, 
				{name: 'Northern Mariana Islands', code: 'MP'}, 
				{name: 'Norway', code: 'NO'}, 
				{name: 'Oman', code: 'OM'}, 
				{name: 'Pakistan', code: 'PK'}, 
				{name: 'Palau', code: 'PW'}, 
				{name: 'Palestinian Territory, Occupied', code: 'PS'}, 
				{name: 'Panama', code: 'PA'}, 
				{name: 'Papua New Guinea', code: 'PG'}, 
				{name: 'Paraguay', code: 'PY'}, 
				{name: 'Peru', code: 'PE'}, 
				{name: 'Philippines', code: 'PH'}, 
				{name: 'Pitcairn', code: 'PN'}, 
				{name: 'Poland', code: 'PL'}, 
				{name: 'Portugal', code: 'PT'}, 
				{name: 'Puerto Rico', code: 'PR'}, 
				{name: 'Qatar', code: 'QA'}, 
				{name: 'Reunion', code: 'RE'}, 
				{name: 'Romania', code: 'RO'}, 
				{name: 'Russian Federation', code: 'RU'}, 
				{name: 'RWANDA', code: 'RW'}, 
				{name: 'Saint Helena', code: 'SH'}, 
				{name: 'Saint Kitts and Nevis', code: 'KN'}, 
				{name: 'Saint Lucia', code: 'LC'}, 
				{name: 'Saint Pierre and Miquelon', code: 'PM'}, 
				{name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
				{name: 'Samoa', code: 'WS'}, 
				{name: 'San Marino', code: 'SM'}, 
				{name: 'Sao Tome and Principe', code: 'ST'}, 
				{name: 'Saudi Arabia', code: 'SA'}, 
				{name: 'Senegal', code: 'SN'}, 
				{name: 'Serbia and Montenegro', code: 'CS'}, 
				{name: 'Seychelles', code: 'SC'}, 
				{name: 'Sierra Leone', code: 'SL'}, 
				{name: 'Singapore', code: 'SG'}, 
				{name: 'Slovakia', code: 'SK'}, 
				{name: 'Slovenia', code: 'SI'}, 
				{name: 'Solomon Islands', code: 'SB'}, 
				{name: 'Somalia', code: 'SO'}, 
				{name: 'South Africa', code: 'ZA'}, 
				{name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
				{name: 'Spain', code: 'ES'}, 
				{name: 'Sri Lanka', code: 'LK'}, 
				{name: 'Sudan', code: 'SD'}, 
				{name: 'Suriname', code: 'SR'}, 
				{name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
				{name: 'Swaziland', code: 'SZ'}, 
				{name: 'Sweden', code: 'SE'}, 
				{name: 'Switzerland', code: 'CH'}, 
				{name: 'Syrian Arab Republic', code: 'SY'}, 
				{name: 'Taiwan, Province of China', code: 'TW'}, 
				{name: 'Tajikistan', code: 'TJ'}, 
				{name: 'Tanzania, United Republic of', code: 'TZ'}, 
				{name: 'Thailand', code: 'TH'}, 
				{name: 'Timor-Leste', code: 'TL'}, 
				{name: 'Togo', code: 'TG'}, 
				{name: 'Tokelau', code: 'TK'}, 
				{name: 'Tonga', code: 'TO'}, 
				{name: 'Trinidad and Tobago', code: 'TT'}, 
				{name: 'Tunisia', code: 'TN'}, 
				{name: 'Turkey', code: 'TR'}, 
				{name: 'Turkmenistan', code: 'TM'}, 
				{name: 'Turks and Caicos Islands', code: 'TC'}, 
				{name: 'Tuvalu', code: 'TV'}, 
				{name: 'Uganda', code: 'UG'}, 
				{name: 'Ukraine', code: 'UA'}, 
				{name: 'United Arab Emirates', code: 'AE'}, 
				{name: 'United Kingdom', code: 'GB'}, 
				{name: 'United States', code: 'US'}, 
				{name: 'United States Minor Outlying Islands', code: 'UM'}, 
				{name: 'Uruguay', code: 'UY'}, 
				{name: 'Uzbekistan', code: 'UZ'}, 
				{name: 'Vanuatu', code: 'VU'}, 
				{name: 'Venezuela', code: 'VE'}, 
				{name: 'Viet Nam', code: 'VN'}, 
				{name: 'Virgin Islands, British', code: 'VG'}, 
				{name: 'Virgin Islands, U.S.', code: 'VI'}, 
				{name: 'Wallis and Futuna', code: 'WF'}, 
				{name: 'Western Sahara', code: 'EH'}, 
				{name: 'Yemen', code: 'YE'}, 
				{name: 'Zambia', code: 'ZM'}, 
				{name: 'Zimbabwe', code: 'ZW'} 
			  ];
		}
})();
(function () {
	'use strict';

	angular
	  .module('app.core')
	  .constant('CART_SHIPPING_TYPES', [
	  		'pickup',
		  	'delivery'
	  ]);
}());

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .config(config);

	/** @ngInject */
	function config(nuitApiProvider) {
		//*******************************************
		// API
		//*******************************************
        nuitApiProvider.register('shop.config', '/shop/config', {allow: ['get', 'post', 'delete']});
		nuitApiProvider.register('shop.config.deleter', 'shop/config/orders/deleter', { allow: ['get', 'delete', 'post'] });
		nuitApiProvider.register('shop.profile.price', 'shop/price/profile', { allow: ['post'] });
		//*******************************************
	}
})();

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .config(config);

	/** @ngInject */
	function config(nuitApiProvider) {
		//*******************************************
		// API
		//*******************************************
		nuitApiProvider.register('products', 'shop/products', { allow: ['get'] });
		nuitApiProvider.register('products.one', 'shop/products/:id', { allow: ['get', 'put', 'delete'] });
		nuitApiProvider.register('products.price', 'shop/products/test', {allow: ['post']});
		//*******************************************
	}
})();
(function () {
	'use strict';

	angular
	  .module('app.core')
	  .config(config);

	/** @ngInject */
	function config(nuitApiProvider) {
		//*******************************************
		// API
		//*******************************************
		nuitApiProvider.register('orders.status', 'shop/config/orders/status', {allow: ['get', 'post']});
		//*******************************************
	}
})();

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .config(config);

	/** @ngInject */
	function config(nuitApiProvider) {
		//*******************************************
		// API
		//*******************************************
		nuitApiProvider.register('materials', '/material/materials', {allow: ['get', 'post']});
		nuitApiProvider.register('materials.single', '/material/materials/:id', {allow: ['delete', 'put', 'get', 'patch']});
		nuitApiProvider.register('materials.raw', '/material/rawmaterials', {allow: ['get', 'post']});
		nuitApiProvider.register('materials.raw.single', '/material/rawmaterials/:id', {allow: ['delete', 'patch']});
		//*******************************************
	}
})();

(function () {
	'use strict';

	angular
	  .module('app.core')
	  .config(config);

	/** @ngInject */
	function config(nuitApiProvider) {
		//*******************************************
		// API
		//*******************************************
		nuitApiProvider.register('colors', 'color/colors', {allow: ['get']});
        nuitApiProvider.register('colors.single', 'color/colors/:id', {allow: ['get', 'put', 'delete']});
		//*******************************************
	}
})();

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cronstrue", [], factory);
	else if(typeof exports === 'object')
		exports["cronstrue"] = factory();
	else
		root["cronstrue"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var expressionDescriptor_1 = __webpack_require__(1);
	var allLocalesLoader_1 = __webpack_require__(6);
	expressionDescriptor_1.ExpressionDescriptor.initialize(new allLocalesLoader_1.allLocalesLoader());
	module.exports = expressionDescriptor_1.ExpressionDescriptor;


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var stringUtilities_1 = __webpack_require__(2);
	var cronParser_1 = __webpack_require__(3);
	var ExpressionDescriptor = (function () {
	    function ExpressionDescriptor(expression, options) {
	        this.expression = expression;
	        this.options = options;
	        this.expressionParts = new Array(5);
	        if (ExpressionDescriptor.locales[options.locale]) {
	            this.i18n = ExpressionDescriptor.locales[options.locale];
	        }
	        else {
	            console.warn("Locale '" + options.locale + "' could not be found; falling back to 'en'.");
	            this.i18n = ExpressionDescriptor.locales["en"];
	        }
	        if (options.use24HourTimeFormat === undefined) {
	            options.use24HourTimeFormat = this.i18n.use24HourTimeFormatByDefault();
	        }
	    }
	    ExpressionDescriptor.toString = function (expression, _a) {
	        var _b = _a === void 0 ? {} : _a, _c = _b.throwExceptionOnParseError, throwExceptionOnParseError = _c === void 0 ? true : _c, _d = _b.verbose, verbose = _d === void 0 ? false : _d, _e = _b.dayOfWeekStartIndexZero, dayOfWeekStartIndexZero = _e === void 0 ? true : _e, use24HourTimeFormat = _b.use24HourTimeFormat, _f = _b.locale, locale = _f === void 0 ? "en" : _f;
	        var options = {
	            throwExceptionOnParseError: throwExceptionOnParseError,
	            verbose: verbose,
	            dayOfWeekStartIndexZero: dayOfWeekStartIndexZero,
	            use24HourTimeFormat: use24HourTimeFormat,
	            locale: locale
	        };
	        var descripter = new ExpressionDescriptor(expression, options);
	        return descripter.getFullDescription();
	    };
	    ExpressionDescriptor.initialize = function (localesLoader) {
	        ExpressionDescriptor.specialCharacters = ["/", "-", ",", "*"];
	        localesLoader.load(ExpressionDescriptor.locales);
	    };
	    ExpressionDescriptor.prototype.getFullDescription = function () {
	        var description = "";
	        try {
	            var parser = new cronParser_1.CronParser(this.expression, this.options.dayOfWeekStartIndexZero);
	            this.expressionParts = parser.parse();
	            var timeSegment = this.getTimeOfDayDescription();
	            var dayOfMonthDesc = this.getDayOfMonthDescription();
	            var monthDesc = this.getMonthDescription();
	            var dayOfWeekDesc = this.getDayOfWeekDescription();
	            var yearDesc = this.getYearDescription();
	            description += (timeSegment + dayOfMonthDesc + dayOfWeekDesc + monthDesc + yearDesc);
	            description = this.transformVerbosity(description, this.options.verbose);
	            description = description.charAt(0).toLocaleUpperCase() + description.substr(1);
	        }
	        catch (ex) {
	            if (!this.options.throwExceptionOnParseError) {
	                description = this.i18n.anErrorOccuredWhenGeneratingTheExpressionD();
	            }
	            else {
	                throw "" + ex;
	            }
	        }
	        return description;
	    };
	    ExpressionDescriptor.prototype.getTimeOfDayDescription = function () {
	        var secondsExpression = this.expressionParts[0];
	        var minuteExpression = this.expressionParts[1];
	        var hourExpression = this.expressionParts[2];
	        var description = "";
	        if (!stringUtilities_1.StringUtilities.containsAny(minuteExpression, ExpressionDescriptor.specialCharacters)
	            && !stringUtilities_1.StringUtilities.containsAny(hourExpression, ExpressionDescriptor.specialCharacters)
	            && !stringUtilities_1.StringUtilities.containsAny(secondsExpression, ExpressionDescriptor.specialCharacters)) {
	            description += this.i18n.atSpace() + this.formatTime(hourExpression, minuteExpression, secondsExpression);
	        }
	        else if (minuteExpression.indexOf("-") > -1
	            && !(minuteExpression.indexOf(",") > -1)
	            && !stringUtilities_1.StringUtilities.containsAny(hourExpression, ExpressionDescriptor.specialCharacters)) {
	            var minuteParts = minuteExpression.split("-");
	            description += stringUtilities_1.StringUtilities.format(this.i18n.everyMinutebetweenX0AndX1(), this.formatTime(hourExpression, minuteParts[0], ""), this.formatTime(hourExpression, minuteParts[1], ""));
	        }
	        else if (hourExpression.indexOf(",") > -1 && !stringUtilities_1.StringUtilities.containsAny(minuteExpression, ExpressionDescriptor.specialCharacters)) {
	            var hourParts = hourExpression.split(",");
	            description += this.i18n.at();
	            for (var i = 0; i < hourParts.length; i++) {
	                description += " ";
	                description += this.formatTime(hourParts[i], minuteExpression, "");
	                if (i < (hourParts.length - 2)) {
	                    description += ",";
	                }
	                if (i == hourParts.length - 2) {
	                    description += this.i18n.spaceAnd();
	                }
	            }
	        }
	        else {
	            var secondsDescription = this.getSecondsDescription();
	            var minutesDescription = this.getMinutesDescription();
	            var hoursDescription = this.getHoursDescription();
	            description += secondsDescription;
	            if (description.length > 0) {
	                description += ", ";
	            }
	            description += minutesDescription;
	            if (description.length > 0) {
	                description += ", ";
	            }
	            description += hoursDescription;
	        }
	        return description;
	    };
	    ExpressionDescriptor.prototype.getSecondsDescription = function () {
	        var _this = this;
	        var description = this.getSegmentDescription(this.expressionParts[0], this.i18n.everysecond(), function (s) { return s; }, function (s) { return stringUtilities_1.StringUtilities.format(_this.i18n.everyX0Seconds(), s); }, function (s) { return _this.i18n.secondsX0ThroughX1PastTheMinute(); }, function (s) {
	            return s == "0" ? "" : parseInt(s) < 20
	                ? _this.i18n.atX0SecondsPastTheMinute()
	                : _this.i18n.atX0SecondsPastTheMinuteGt20() || _this.i18n.atX0SecondsPastTheMinute();
	        });
	        return description;
	    };
	    ExpressionDescriptor.prototype.getMinutesDescription = function () {
	        var _this = this;
	        var description = this.getSegmentDescription(this.expressionParts[1], this.i18n.everyMinute(), function (s) { return s; }, function (s) { return stringUtilities_1.StringUtilities.format(_this.i18n.everyX0Minutes(), s); }, function (s) { return _this.i18n.minutesX0ThroughX1PastTheHour(); }, function (s) {
	            try {
	                return s == "0" ? "" : parseInt(s) < 20
	                    ? _this.i18n.atX0MinutesPastTheHour()
	                    : _this.i18n.atX0MinutesPastTheHourGt20() || _this.i18n.atX0MinutesPastTheHour();
	            }
	            catch (e) {
	                return _this.i18n.atX0MinutesPastTheHour();
	            }
	        });
	        return description;
	    };
	    ExpressionDescriptor.prototype.getHoursDescription = function () {
	        var _this = this;
	        var expression = this.expressionParts[2];
	        var description = this.getSegmentDescription(expression, this.i18n.everyHour(), function (s) { return _this.formatTime(s, "0", ""); }, function (s) { return stringUtilities_1.StringUtilities.format(_this.i18n.everyX0Hours(), s); }, function (s) { return _this.i18n.betweenX0AndX1(); }, function (s) { return _this.i18n.atX0(); });
	        return description;
	    };
	    ExpressionDescriptor.prototype.getDayOfWeekDescription = function () {
	        var _this = this;
	        var daysOfWeekNames = this.i18n.daysOfTheWeek();
	        var description = this.getSegmentDescription(this.expressionParts[5], this.i18n.commaEveryDay(), function (s) {
	            var exp = s;
	            if (s.indexOf("#") > -1) {
	                exp = s.substr(0, s.indexOf("#"));
	            }
	            else if (s.indexOf("L") > -1) {
	                exp = exp.replace("L", "");
	            }
	            return daysOfWeekNames[parseInt(exp)];
	        }, function (s) { return stringUtilities_1.StringUtilities.format(_this.i18n.commaEveryX0daysOfTheWeek(), s); }, function (s) { return _this.i18n.commaX0ThroughX1(); }, function (s) {
	            var format = null;
	            if (s.indexOf("#") > -1) {
	                var dayOfWeekOfMonthNumber = s.substring(s.indexOf("#") + 1);
	                var dayOfWeekOfMonthDescription = null;
	                switch (dayOfWeekOfMonthNumber) {
	                    case "1":
	                        dayOfWeekOfMonthDescription = _this.i18n.first();
	                        break;
	                    case "2":
	                        dayOfWeekOfMonthDescription = _this.i18n.second();
	                        break;
	                    case "3":
	                        dayOfWeekOfMonthDescription = _this.i18n.third();
	                        break;
	                    case "4":
	                        dayOfWeekOfMonthDescription = _this.i18n.forth();
	                        break;
	                    case "5":
	                        dayOfWeekOfMonthDescription = _this.i18n.fifth();
	                        break;
	                }
	                format = _this.i18n.commaOnThe() + dayOfWeekOfMonthDescription + _this.i18n.spaceX0OfTheMonth();
	            }
	            else if (s.indexOf("L") > -1) {
	                format = _this.i18n.commaOnTheLastX0OfTheMonth();
	            }
	            else {
	                format = _this.i18n.commaOnlyOnX0();
	            }
	            return format;
	        });
	        return description;
	    };
	    ExpressionDescriptor.prototype.getMonthDescription = function () {
	        var _this = this;
	        var monthNames = this.i18n.monthsOfTheYear();
	        var description = this.getSegmentDescription(this.expressionParts[4], "", function (s) { return monthNames[(parseInt(s) - 1)]; }, function (s) { return stringUtilities_1.StringUtilities.format(_this.i18n.commaEveryX0Months(), s); }, function (s) { return _this.i18n.commaMonthX0ThroughMonthX1() || _this.i18n.commaX0ThroughX1(); }, function (s) { return _this.i18n.commaOnlyInX0(); });
	        return description;
	    };
	    ExpressionDescriptor.prototype.getDayOfMonthDescription = function () {
	        var _this = this;
	        var description = null;
	        var expression = this.expressionParts[3];
	        switch (expression) {
	            case "L":
	                description = this.i18n.commaOnTheLastDayOfTheMonth();
	                break;
	            case "WL":
	            case "LW":
	                description = this.i18n.commaOnTheLastWeekdayOfTheMonth();
	                break;
	            default:
	                var matches = expression.match(/(\d{1,2}W)|(W\d{1,2})/);
	                if (matches) {
	                    var dayNumber = parseInt(matches[0].replace("W", ""));
	                    var dayString = dayNumber == 1 ? this.i18n.firstWeekday() :
	                        stringUtilities_1.StringUtilities.format(this.i18n.weekdayNearestDayX0(), dayNumber.toString());
	                    description = stringUtilities_1.StringUtilities.format(this.i18n.commaOnTheX0OfTheMonth(), dayString);
	                    break;
	                }
	                else {
	                    description = this.getSegmentDescription(expression, this.i18n.commaEveryDay(), function (s) { return s; }, function (s) {
	                        return s == "1" ? _this.i18n.commaEveryDay() :
	                            _this.i18n.commaEveryX0Days();
	                    }, function (s) { return _this.i18n.commaBetweenDayX0AndX1OfTheMonth(); }, function (s) { return _this.i18n.commaOnDayX0OfTheMonth(); });
	                    break;
	                }
	        }
	        return description;
	    };
	    ExpressionDescriptor.prototype.getYearDescription = function () {
	        var _this = this;
	        var description = this.getSegmentDescription(this.expressionParts[6], "", function (s) { return /^\d+$/.test(s) ? new Date(parseInt(s), 1).getFullYear().toString() : s; }, function (s) { return stringUtilities_1.StringUtilities.format(_this.i18n.commaEveryX0Years(), s); }, function (s) { return _this.i18n.commaYearX0ThroughYearX1() || _this.i18n.commaX0ThroughX1(); }, function (s) { return _this.i18n.commaOnlyInX0(); });
	        return description;
	    };
	    ExpressionDescriptor.prototype.getSegmentDescription = function (expression, allDescription, getSingleItemDescription, getIntervalDescriptionFormat, getBetweenDescriptionFormat, getDescriptionFormat) {
	        var _this = this;
	        var description = null;
	        if (!expression) {
	            description = "";
	        }
	        else if (expression === "*") {
	            description = allDescription;
	        }
	        else if (!stringUtilities_1.StringUtilities.containsAny(expression, ["/", "-", ","])) {
	            description = stringUtilities_1.StringUtilities.format(getDescriptionFormat(expression), getSingleItemDescription(expression));
	        }
	        else if (expression.indexOf("/") > -1) {
	            var segments = expression.split("/");
	            description = stringUtilities_1.StringUtilities.format(getIntervalDescriptionFormat(segments[1]), getSingleItemDescription(segments[1]));
	            if (segments[0].indexOf("-") > -1) {
	                var betweenSegmentDescription = this.generateBetweenSegmentDescription(segments[0], getBetweenDescriptionFormat, getSingleItemDescription);
	                if (betweenSegmentDescription.indexOf(", ") != 0) {
	                    description += ", ";
	                }
	                description += betweenSegmentDescription;
	            }
	            else if (!stringUtilities_1.StringUtilities.containsAny(segments[0], ["*", ","])) {
	                var rangeItemDescription = stringUtilities_1.StringUtilities.format(getDescriptionFormat(segments[0]), getSingleItemDescription(segments[0]));
	                rangeItemDescription = rangeItemDescription.replace(", ", "");
	                description += stringUtilities_1.StringUtilities.format(this.i18n.commaStartingX0(), rangeItemDescription);
	            }
	        }
	        else if (expression.indexOf(",") > -1) {
	            var segments = expression.split(',');
	            var descriptionContent = "";
	            for (var i = 0; i < segments.length; i++) {
	                if (i > 0 && segments.length > 2) {
	                    descriptionContent += ",";
	                    if (i < segments.length - 1) {
	                        descriptionContent += " ";
	                    }
	                }
	                if (i > 0 && segments.length > 1 && (i == segments.length - 1 || segments.length == 2)) {
	                    descriptionContent += this.i18n.spaceAndSpace();
	                }
	                if (segments[i].indexOf("-") > -1) {
	                    var betweenSegmentDescription = this.generateBetweenSegmentDescription(segments[i], (function (s) { return _this.i18n.commaX0ThroughX1(); }), getSingleItemDescription);
	                    betweenSegmentDescription = betweenSegmentDescription.replace(", ", "");
	                    descriptionContent += betweenSegmentDescription;
	                }
	                else {
	                    descriptionContent += getSingleItemDescription(segments[i]);
	                }
	            }
	            description = stringUtilities_1.StringUtilities.format(getDescriptionFormat(expression), descriptionContent);
	        }
	        else if (expression.indexOf("-") > -1) {
	            description = this.generateBetweenSegmentDescription(expression, getBetweenDescriptionFormat, getSingleItemDescription);
	        }
	        return description;
	    };
	    ExpressionDescriptor.prototype.generateBetweenSegmentDescription = function (betweenExpression, getBetweenDescriptionFormat, getSingleItemDescription) {
	        var description = "";
	        var betweenSegments = betweenExpression.split('-');
	        var betweenSegment1Description = getSingleItemDescription(betweenSegments[0]);
	        var betweenSegment2Description = getSingleItemDescription(betweenSegments[1]);
	        betweenSegment2Description = betweenSegment2Description.replace(":00", ":59");
	        var betweenDescriptionFormat = getBetweenDescriptionFormat(betweenExpression);
	        description += stringUtilities_1.StringUtilities.format(betweenDescriptionFormat, betweenSegment1Description, betweenSegment2Description);
	        return description;
	    };
	    ExpressionDescriptor.prototype.formatTime = function (hourExpression, minuteExpression, secondExpression) {
	        var hour = parseInt(hourExpression);
	        var period = "";
	        if (!this.options.use24HourTimeFormat) {
	            period = (hour >= 12) ? " PM" : " AM";
	            if (hour > 12) {
	                hour -= 12;
	            }
	        }
	        var minute = minuteExpression;
	        var second = "";
	        if (secondExpression) {
	            second = ":" + ("00" + secondExpression).substring(secondExpression.length);
	        }
	        return ("00" + hour.toString()).substring(hour.toString().length) + ":" + ("00" + minute.toString()).substring(minute.toString().length) + second + period;
	    };
	    ExpressionDescriptor.prototype.transformVerbosity = function (description, useVerboseFormat) {
	        if (!useVerboseFormat) {
	            description = description.replace(new RegExp(this.i18n.commaEveryMinute(), 'g'), "");
	            description = description.replace(new RegExp(this.i18n.commaEveryHour(), 'g'), "");
	            description = description.replace(new RegExp(this.i18n.commaEveryDay(), 'g'), "");
	        }
	        return description;
	    };
	    ExpressionDescriptor.locales = {};
	    return ExpressionDescriptor;
	}());
	exports.ExpressionDescriptor = ExpressionDescriptor;


/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	var StringUtilities = (function () {
	    function StringUtilities() {
	    }
	    StringUtilities.format = function (template) {
	        var values = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            values[_i - 1] = arguments[_i];
	        }
	        return template.replace(/%s/g, function () {
	            return values.shift();
	        });
	    };
	    StringUtilities.containsAny = function (text, searchStrings) {
	        return searchStrings.some(function (c) { return text.indexOf(c) > -1; });
	    };
	    return StringUtilities;
	}());
	exports.StringUtilities = StringUtilities;


/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	var CronParser = (function () {
	    function CronParser(expression, dayOfWeekStartIndexZero) {
	        if (dayOfWeekStartIndexZero === void 0) { dayOfWeekStartIndexZero = true; }
	        this.expression = expression;
	        this.dayOfWeekStartIndexZero = dayOfWeekStartIndexZero;
	    }
	    CronParser.prototype.parse = function () {
	        if (!this.expression) {
	            throw new Error("Expression is empty");
	        }
	        var parsed = this.expression.trim().split(' ');
	        if (parsed.length < 5) {
	            throw new Error("Expression only has " + parsed.length + " parts.  At least 5 part are required.");
	        }
	        else if (parsed.length == 5) {
	            parsed.unshift("");
	            parsed.push("");
	        }
	        else if (parsed.length == 6) {
	            if (/\d{4}$/.test(parsed[5])) {
	                parsed.unshift('');
	            }
	            else {
	                parsed.push('');
	            }
	        }
	        else if (parsed.length > 7) {
	            throw new Error("Expression has " + parsed.length + " parts; too many!");
	        }
	        this.normalizeExpression(parsed);
	        return parsed;
	    };
	    CronParser.prototype.normalizeExpression = function (expressionParts) {
	        var _this = this;
	        expressionParts[3] = expressionParts[3].replace("?", "*");
	        expressionParts[5] = expressionParts[5].replace("?", "*");
	        if (expressionParts[0].indexOf("0/") == 0) {
	            expressionParts[0] = expressionParts[0].replace("0/", "*/");
	        }
	        if (expressionParts[1].indexOf("0/") == 0) {
	            expressionParts[1] = expressionParts[1].replace("0/", "*/");
	        }
	        if (expressionParts[2].indexOf("0/") == 0) {
	            expressionParts[2] = expressionParts[2].replace("0/", "*/");
	        }
	        if (expressionParts[3].indexOf("1/") == 0) {
	            expressionParts[3] = expressionParts[3].replace("1/", "*/");
	        }
	        if (expressionParts[4].indexOf("1/") == 0) {
	            expressionParts[4] = expressionParts[4].replace("1/", "*/");
	        }
	        if (expressionParts[5].indexOf("1/") == 0) {
	            expressionParts[5] = expressionParts[5].replace("1/", "*/");
	        }
	        if (expressionParts[6].indexOf("1/") == 0) {
	            expressionParts[6] = expressionParts[6].replace("1/", "*/");
	        }
	        expressionParts[5] = expressionParts[5].replace(/(^\d)|([^#/\s]\d)+/g, function (t) {
	            var dowDigits = t.replace(/\D/, "");
	            var dowDigitsAdjusted = dowDigits;
	            if (_this.dayOfWeekStartIndexZero) {
	                if (dowDigits == "7") {
	                    dowDigitsAdjusted = "0";
	                }
	            }
	            else {
	                dowDigitsAdjusted = (parseInt(dowDigits) - 1).toString();
	            }
	            return t.replace(dowDigits, dowDigitsAdjusted);
	        });
	        if (expressionParts[3] == "?") {
	            expressionParts[3] = "*";
	        }
	        if (expressionParts[3].indexOf('W') > -1 && (expressionParts[3].indexOf(',') > -1 || expressionParts[3].indexOf('-') > -1)) {
	            throw new Error("The 'W' character can be specified only when the day-of-month is a single day, not a range or list of days.");
	        }
	        var days = {
	            "SUN": 0, "MON": 1, "TUE": 2, "WED": 3, "THU": 4, "FRI": 5, "SAT": 6
	        };
	        for (var day in days) {
	            expressionParts[5] = expressionParts[5].replace(new RegExp(day, "g"), days[day].toString());
	        }
	        var months = {
	            "JAN": 1, "FEB": 2, "MAR": 3, "APR": 4, "MAY": 5, "JUN": 6, "JUL": 7, "AUG": 8, "SEP": 9, "OCT": 10, "NOV": 11, "DEC": 12
	        };
	        for (var month in months) {
	            expressionParts[4] = expressionParts[4].replace(new RegExp(month, "g"), months[month].toString());
	        }
	        if (expressionParts[0] == "0") {
	            expressionParts[0] = "";
	        }
	        for (var i = 0; i < expressionParts.length; i++) {
	            if (expressionParts[i] == "*/1") {
	                expressionParts[i] = "*";
	            }
	            if (expressionParts[i].indexOf("/") > -1
	                && !(/^\*|\-|\,/.test(expressionParts[i]))) {
	                var stepRangeThrough = null;
	                switch (i) {
	                    case 4:
	                        stepRangeThrough = "12";
	                        break;
	                    case 5:
	                        stepRangeThrough = "6";
	                        break;
	                    case 6:
	                        stepRangeThrough = "9999";
	                        break;
	                    default:
	                        stepRangeThrough = null;
	                        break;
	                }
	                if (stepRangeThrough != null) {
	                    var parts = expressionParts[i].split("/");
	                    expressionParts[i] = parts[0] + "-" + stepRangeThrough + "/" + parts[1];
	                }
	            }
	        }
	    };
	    return CronParser;
	}());
	exports.CronParser = CronParser;


/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports) {

	"use strict";
	var en = (function () {
	    function en() {
	    }
	    en.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    en.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    en.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    en.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    en.prototype.use24HourTimeFormatByDefault = function () { return false; };
	    en.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "An error occured when generating the expression description.  Check the cron expression syntax.";
	    };
	    ;
	    en.prototype.everyMinute = function () {
	        return "every minute";
	    };
	    ;
	    en.prototype.everyHour = function () {
	        return "every hour";
	    };
	    ;
	    en.prototype.atSpace = function () {
	        return "At ";
	    };
	    ;
	    en.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "Every minute between %s and %s";
	    };
	    ;
	    en.prototype.at = function () {
	        return "At";
	    };
	    ;
	    en.prototype.spaceAnd = function () {
	        return " and";
	    };
	    ;
	    en.prototype.everysecond = function () {
	        return "every second";
	    };
	    ;
	    en.prototype.everyX0Seconds = function () {
	        return "every %s seconds";
	    };
	    ;
	    en.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "seconds %s through %s past the minute";
	    };
	    ;
	    en.prototype.atX0SecondsPastTheMinute = function () {
	        return "at %s seconds past the minute";
	    };
	    ;
	    en.prototype.everyX0Minutes = function () {
	        return "every %s minutes";
	    };
	    ;
	    en.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "minutes %s through %s past the hour";
	    };
	    ;
	    en.prototype.atX0MinutesPastTheHour = function () {
	        return "at %s minutes past the hour";
	    };
	    ;
	    en.prototype.everyX0Hours = function () {
	        return "every %s hours";
	    };
	    ;
	    en.prototype.betweenX0AndX1 = function () {
	        return "between %s and %s";
	    };
	    ;
	    en.prototype.atX0 = function () {
	        return "at %s";
	    };
	    ;
	    en.prototype.commaEveryDay = function () {
	        return ", every day";
	    };
	    ;
	    en.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", every %s days of the week";
	    };
	    ;
	    en.prototype.commaX0ThroughX1 = function () {
	        return ", %s through %s";
	    };
	    ;
	    en.prototype.first = function () {
	        return "first";
	    };
	    ;
	    en.prototype.second = function () {
	        return "second";
	    };
	    ;
	    en.prototype.third = function () {
	        return "third";
	    };
	    ;
	    en.prototype.forth = function () {
	        return "forth";
	    };
	    ;
	    en.prototype.fifth = function () {
	        return "fifth";
	    };
	    ;
	    en.prototype.commaOnThe = function () {
	        return ", on the ";
	    };
	    ;
	    en.prototype.spaceX0OfTheMonth = function () {
	        return " %s of the month";
	    };
	    ;
	    en.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", on the last %s of the month";
	    };
	    ;
	    en.prototype.commaOnlyOnX0 = function () {
	        return ", only on %s";
	    };
	    ;
	    en.prototype.commaEveryX0Months = function () {
	        return ", every %s months";
	    };
	    ;
	    en.prototype.commaOnlyInX0 = function () {
	        return ", only in %s";
	    };
	    ;
	    en.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", on the last day of the month";
	    };
	    ;
	    en.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", on the last weekday of the month";
	    };
	    ;
	    en.prototype.firstWeekday = function () {
	        return "first weekday";
	    };
	    ;
	    en.prototype.weekdayNearestDayX0 = function () {
	        return "weekday nearest day %s";
	    };
	    ;
	    en.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", on the %s of the month";
	    };
	    ;
	    en.prototype.commaEveryX0Days = function () {
	        return ", every %s days";
	    };
	    ;
	    en.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", between day %s and %s of the month";
	    };
	    ;
	    en.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", on day %s of the month";
	    };
	    ;
	    en.prototype.spaceAndSpace = function () {
	        return " and ";
	    };
	    ;
	    en.prototype.commaEveryMinute = function () {
	        return ", every minute";
	    };
	    ;
	    en.prototype.commaEveryHour = function () {
	        return ", every hour";
	    };
	    ;
	    en.prototype.commaEveryX0Years = function () {
	        return ", every %s years";
	    };
	    ;
	    en.prototype.commaStartingX0 = function () {
	        return ", starting %s";
	    };
	    ;
	    en.prototype.daysOfTheWeek = function () {
	        return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	    };
	    en.prototype.monthsOfTheYear = function () {
	        return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	    };
	    return en;
	}());
	exports.en = en;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var allLocales = __webpack_require__(7);
	var allLocalesLoader = (function () {
	    function allLocalesLoader() {
	    }
	    allLocalesLoader.prototype.load = function (availableLocales) {
	        for (var property in allLocales) {
	            if (allLocales.hasOwnProperty(property)) {
	                availableLocales[property] = new (allLocales[property]);
	                ;
	            }
	        }
	    };
	    return allLocalesLoader;
	}());
	exports.allLocalesLoader = allLocalesLoader;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var en_1 = __webpack_require__(5);
	exports.en = en_1.en;
	var de_1 = __webpack_require__(8);
	exports.de = de_1.de;
	var es_1 = __webpack_require__(9);
	exports.es = es_1.es;
	var fr_1 = __webpack_require__(10);
	exports.fr = fr_1.fr;
	var it_1 = __webpack_require__(11);
	exports.it = it_1.it;
	var nl_1 = __webpack_require__(12);
	exports.nl = nl_1.nl;
	var nb_1 = __webpack_require__(13);
	exports.nb = nb_1.nb;
	var pl_1 = __webpack_require__(14);
	exports.pl = pl_1.pl;
	var pt_BR_1 = __webpack_require__(15);
	exports.pt_BR = pt_BR_1.pt_BR;
	var ro_1 = __webpack_require__(16);
	exports.ro = ro_1.ro;
	var ru_1 = __webpack_require__(17);
	exports.ru = ru_1.ru;
	var tr_1 = __webpack_require__(18);
	exports.tr = tr_1.tr;
	var uk_1 = __webpack_require__(19);
	exports.uk = uk_1.uk;
	var zh_CN_1 = __webpack_require__(20);
	exports.zh_CN = zh_CN_1.zh_CN;


/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	var de = (function () {
	    function de() {
	    }
	    de.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    de.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    de.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    de.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    de.prototype.use24HourTimeFormatByDefault = function () { return true; };
	    de.prototype.everyMinute = function () {
	        return "jede Minute";
	    };
	    de.prototype.everyHour = function () {
	        return "jede Stunde";
	    };
	    de.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "An error occured when generating the expression description.  Check the cron expression syntax.";
	    };
	    de.prototype.atSpace = function () {
	        return "Um ";
	    };
	    de.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "Jede Minute zwischen %s und %s";
	    };
	    de.prototype.at = function () {
	        return "Um";
	    };
	    de.prototype.spaceAnd = function () {
	        return " und";
	    };
	    de.prototype.everysecond = function () {
	        return "Jede Sekunde";
	    };
	    de.prototype.everyX0Seconds = function () {
	        return "alle %s Sekunden";
	    };
	    de.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "Sekunden %s bis %s";
	    };
	    de.prototype.atX0SecondsPastTheMinute = function () {
	        return "bei Sekunde %s";
	    };
	    de.prototype.everyX0Minutes = function () {
	        return "alle %s Minuten";
	    };
	    de.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "Minuten %s bis %s";
	    };
	    de.prototype.atX0MinutesPastTheHour = function () {
	        return "bei Minute %s";
	    };
	    de.prototype.everyX0Hours = function () {
	        return "alle %s Stunden";
	    };
	    de.prototype.betweenX0AndX1 = function () {
	        return "zwischen %s und %s";
	    };
	    de.prototype.atX0 = function () {
	        return "um %s";
	    };
	    de.prototype.commaEveryDay = function () {
	        return ", jeden Tag";
	    };
	    de.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", every %s days of the week";
	    };
	    de.prototype.commaX0ThroughX1 = function () {
	        return ", %s bis %s";
	    };
	    de.prototype.first = function () {
	        return "ersten";
	    };
	    de.prototype.second = function () {
	        return "zweiten";
	    };
	    de.prototype.third = function () {
	        return "dritten";
	    };
	    de.prototype.forth = function () {
	        return "vierten";
	    };
	    de.prototype.fifth = function () {
	        return "fünften";
	    };
	    de.prototype.commaOnThe = function () {
	        return ", am ";
	    };
	    de.prototype.spaceX0OfTheMonth = function () {
	        return " %s des Monats";
	    };
	    de.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", am letzten %s des Monats";
	    };
	    de.prototype.commaOnlyOnX0 = function () {
	        return ", nur am %s";
	    };
	    de.prototype.commaEveryX0Months = function () {
	        return ", alle %s Monate";
	    };
	    de.prototype.commaOnlyInX0 = function () {
	        return ", nur im %s";
	    };
	    de.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", am letzten Tag des Monats";
	    };
	    de.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", am letzten Werktag des Monats";
	    };
	    de.prototype.firstWeekday = function () {
	        return "ersten Werktag";
	    };
	    de.prototype.weekdayNearestDayX0 = function () {
	        return "Werktag am nächsten zum %s Tag";
	    };
	    de.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", am %s des Monats";
	    };
	    de.prototype.commaEveryX0Days = function () {
	        return ", alle %s Tage";
	    };
	    de.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", zwischen Tag %s und %s des Monats";
	    };
	    de.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", am %s Tag des Monats";
	    };
	    de.prototype.spaceAndSpace = function () {
	        return " und ";
	    };
	    de.prototype.commaEveryMinute = function () {
	        return ", jede Minute";
	    };
	    de.prototype.commaEveryHour = function () {
	        return ", jede Stunde";
	    };
	    de.prototype.commaEveryX0Years = function () {
	        return ", alle %s Jahre";
	    };
	    de.prototype.commaStartingX0 = function () {
	        return ", beginnend %s";
	    };
	    de.prototype.daysOfTheWeek = function () {
	        return ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
	    };
	    de.prototype.monthsOfTheYear = function () {
	        return ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
	    };
	    return de;
	}());
	exports.de = de;


/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	var es = (function () {
	    function es() {
	    }
	    es.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    es.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    es.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    es.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    es.prototype.use24HourTimeFormatByDefault = function () { return false; };
	    es.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "Ocurrió un error mientras se generaba la descripción de la expresión. Revise la sintaxis de la expresión de cron.";
	    };
	    ;
	    es.prototype.at = function () {
	        return "A las";
	    };
	    ;
	    es.prototype.atSpace = function () {
	        return "A las ";
	    };
	    ;
	    es.prototype.atX0 = function () {
	        return "a las %s";
	    };
	    ;
	    es.prototype.atX0MinutesPastTheHour = function () {
	        return "a los %s minutos de la hora";
	    };
	    ;
	    es.prototype.atX0SecondsPastTheMinute = function () {
	        return "a los %s segundos del minuto";
	    };
	    ;
	    es.prototype.betweenX0AndX1 = function () {
	        return "entre las %s y las %s";
	    };
	    ;
	    es.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", entre los días %s y %s del mes";
	    };
	    ;
	    es.prototype.commaEveryDay = function () {
	        return ", cada día";
	    };
	    ;
	    es.prototype.commaEveryHour = function () {
	        return ", cada hora";
	    };
	    ;
	    es.prototype.commaEveryMinute = function () {
	        return ", cada minuto";
	    };
	    ;
	    es.prototype.commaEveryX0Days = function () {
	        return ", cada %s días";
	    };
	    ;
	    es.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", cada %s días de la semana";
	    };
	    ;
	    es.prototype.commaEveryX0Months = function () {
	        return ", cada %s meses";
	    };
	    ;
	    es.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", el día %s del mes";
	    };
	    ;
	    es.prototype.commaOnlyInX0 = function () {
	        return ", sólo en %s";
	    };
	    ;
	    es.prototype.commaOnlyOnX0 = function () {
	        return ", sólo el %s";
	    };
	    ;
	    es.prototype.commaOnThe = function () {
	        return ", en el ";
	    };
	    ;
	    es.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", en el último día del mes";
	    };
	    ;
	    es.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", en el último día de la semana del mes";
	    };
	    ;
	    es.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", en el último %s del mes";
	    };
	    ;
	    es.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", en el %s del mes";
	    };
	    ;
	    es.prototype.commaX0ThroughX1 = function () {
	        return ", de %s a %s";
	    };
	    ;
	    es.prototype.everyHour = function () {
	        return "cada hora";
	    };
	    ;
	    es.prototype.everyMinute = function () {
	        return "cada minuto";
	    };
	    ;
	    es.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "cada minuto entre las %s y las %s";
	    };
	    ;
	    es.prototype.everysecond = function () {
	        return "cada segundo";
	    };
	    ;
	    es.prototype.everyX0Hours = function () {
	        return "cada %s horas";
	    };
	    ;
	    es.prototype.everyX0Minutes = function () {
	        return "cada %s minutos";
	    };
	    ;
	    es.prototype.everyX0Seconds = function () {
	        return "cada %s segundos";
	    };
	    ;
	    es.prototype.fifth = function () {
	        return "quinto";
	    };
	    ;
	    es.prototype.first = function () {
	        return "primero";
	    };
	    ;
	    es.prototype.firstWeekday = function () {
	        return "primer día de la semana";
	    };
	    ;
	    es.prototype.forth = function () {
	        return "cuarto";
	    };
	    ;
	    es.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "del minuto %s al %s pasada la hora";
	    };
	    ;
	    es.prototype.second = function () {
	        return "segundo";
	    };
	    ;
	    es.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "En los segundos %s al %s de cada minuto";
	    };
	    ;
	    es.prototype.spaceAnd = function () {
	        return " y";
	    };
	    ;
	    es.prototype.spaceAndSpace = function () {
	        return " y ";
	    };
	    ;
	    es.prototype.spaceX0OfTheMonth = function () {
	        return " %s del mes";
	    };
	    ;
	    es.prototype.third = function () {
	        return "tercer";
	    };
	    ;
	    es.prototype.weekdayNearestDayX0 = function () {
	        return "día de la semana más próximo al %s";
	    };
	    ;
	    es.prototype.commaEveryX0Years = function () {
	        return ", cada %s años";
	    };
	    ;
	    es.prototype.commaStartingX0 = function () {
	        return ", comenzando %s";
	    };
	    ;
	    es.prototype.daysOfTheWeek = function () {
	        return ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
	    };
	    es.prototype.monthsOfTheYear = function () {
	        return ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
	    };
	    return es;
	}());
	exports.es = es;


/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	var fr = (function () {
	    function fr() {
	    }
	    fr.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    fr.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    fr.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    fr.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    fr.prototype.use24HourTimeFormatByDefault = function () { return false; };
	    fr.prototype.everyMinute = function () {
	        return "toutes les minutes";
	    };
	    fr.prototype.everyHour = function () {
	        return "toutes les heures";
	    };
	    fr.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "Une erreur est survenue en générant la description de l'expression cron. Vérifiez sa syntaxe.";
	    };
	    fr.prototype.atSpace = function () {
	        return "À ";
	    };
	    fr.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "Toutes les minutes entre %s et %s";
	    };
	    fr.prototype.at = function () {
	        return "À";
	    };
	    fr.prototype.spaceAnd = function () {
	        return " et";
	    };
	    fr.prototype.everysecond = function () {
	        return "toutes les secondes";
	    };
	    fr.prototype.everyX0Seconds = function () {
	        return "toutes les %s secondes";
	    };
	    fr.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "les secondes entre %s et %s après la minute";
	    };
	    fr.prototype.atX0SecondsPastTheMinute = function () {
	        return "%s secondes après la minute";
	    };
	    fr.prototype.everyX0Minutes = function () {
	        return "toutes les %s minutes";
	    };
	    fr.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "les minutes entre %s et %s après l'heure";
	    };
	    fr.prototype.atX0MinutesPastTheHour = function () {
	        return "%s minutes après l'heure";
	    };
	    fr.prototype.everyX0Hours = function () {
	        return "toutes les %s heures";
	    };
	    fr.prototype.betweenX0AndX1 = function () {
	        return "de %s à %s";
	    };
	    fr.prototype.atX0 = function () {
	        return "à %s";
	    };
	    fr.prototype.commaEveryDay = function () {
	        return ", tous les jours";
	    };
	    fr.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", every %s days of the week";
	    };
	    fr.prototype.commaX0ThroughX1 = function () {
	        return ", de %s à %s";
	    };
	    fr.prototype.first = function () {
	        return "premier";
	    };
	    fr.prototype.second = function () {
	        return "second";
	    };
	    fr.prototype.third = function () {
	        return "troisième";
	    };
	    fr.prototype.forth = function () {
	        return "quatrième";
	    };
	    fr.prototype.fifth = function () {
	        return "cinquième";
	    };
	    fr.prototype.commaOnThe = function () {
	        return ", le ";
	    };
	    fr.prototype.spaceX0OfTheMonth = function () {
	        return " %s du mois";
	    };
	    fr.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", le dernier %s du mois";
	    };
	    fr.prototype.commaOnlyOnX0 = function () {
	        return ", uniquement le %s";
	    };
	    fr.prototype.commaEveryX0Months = function () {
	        return ", tous les %s mois";
	    };
	    fr.prototype.commaOnlyInX0 = function () {
	        return ", uniquement en %s";
	    };
	    fr.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", le dernier jour du mois";
	    };
	    fr.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", le dernier jour ouvrable du mois";
	    };
	    fr.prototype.firstWeekday = function () {
	        return "premier jour ouvrable";
	    };
	    fr.prototype.weekdayNearestDayX0 = function () {
	        return "jour ouvrable le plus proche du %s";
	    };
	    fr.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", le %s du mois";
	    };
	    fr.prototype.commaEveryX0Days = function () {
	        return ", tous les %s jours";
	    };
	    fr.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", du %s au %s du mois";
	    };
	    fr.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", le %s du mois";
	    };
	    fr.prototype.spaceAndSpace = function () {
	        return " et ";
	    };
	    fr.prototype.commaEveryMinute = function () {
	        return ", toutes les minutes";
	    };
	    fr.prototype.commaEveryHour = function () {
	        return ", toutes les heures";
	    };
	    fr.prototype.commaEveryX0Years = function () {
	        return ", tous les %s ans";
	    };
	    fr.prototype.commaDaysX0ThroughX1 = function () {
	        return ", du %s au %s";
	    };
	    fr.prototype.weekSpaceAndSpace = function () {
	        return " et le ";
	    };
	    fr.prototype.commaStartingX0 = function () {
	        return ", départ %s";
	    };
	    fr.prototype.daysOfTheWeek = function () {
	        return ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
	    };
	    fr.prototype.monthsOfTheYear = function () {
	        return ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
	    };
	    return fr;
	}());
	exports.fr = fr;


/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	var it = (function () {
	    function it() {
	    }
	    it.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    it.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    it.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    it.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    it.prototype.use24HourTimeFormatByDefault = function () { return true; };
	    it.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "È verificato un errore durante la generazione la descrizione espressione. Controllare la sintassi delle espressioni cron.";
	    };
	    it.prototype.at = function () {
	        return "Alle";
	    };
	    it.prototype.atSpace = function () {
	        return "Alle ";
	    };
	    it.prototype.atX0 = function () {
	        return "alle %s";
	    };
	    it.prototype.atX0MinutesPastTheHour = function () {
	        return "al %s minuto passata l'ora";
	    };
	    it.prototype.atX0SecondsPastTheMinute = function () {
	        return "al %s secondo passato il minuto";
	    };
	    it.prototype.betweenX0AndX1 = function () {
	        return "tra le %s e le %s";
	    };
	    it.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", tra il giorno %s e %s del mese";
	    };
	    it.prototype.commaEveryDay = function () {
	        return ", ogni giorno";
	    };
	    it.prototype.commaEveryHour = function () {
	        return ", ogni ora";
	    };
	    it.prototype.commaEveryMinute = function () {
	        return ", ogni minuto";
	    };
	    it.prototype.commaEveryX0Days = function () {
	        return ", ogni %s giorni";
	    };
	    it.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", ogni %s giorni della settimana";
	    };
	    it.prototype.commaEveryX0Months = function () {
	        return ", ogni %s mesi";
	    };
	    it.prototype.commaEveryX0Years = function () {
	        return ", ogni %s anni";
	    };
	    it.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", il giorno %s del mese";
	    };
	    it.prototype.commaOnlyInX0 = function () {
	        return ", solo in %s";
	    };
	    it.prototype.commaOnlyOnX0 = function () {
	        return ", solo il %s";
	    };
	    it.prototype.commaOnThe = function () {
	        return ", il ";
	    };
	    it.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", l'ultimo giorno del mese";
	    };
	    it.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", nell'ultima settimana del mese";
	    };
	    it.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", l'ultimo %s del mese";
	    };
	    it.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", il %s del mese";
	    };
	    it.prototype.commaX0ThroughX1 = function () {
	        return ", %s al %s";
	    };
	    it.prototype.everyHour = function () {
	        return "ogni ora";
	    };
	    it.prototype.everyMinute = function () {
	        return "ogni minuto";
	    };
	    it.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "Ogni minuto tra le %s e le %s";
	    };
	    it.prototype.everysecond = function () {
	        return "ogni secondo";
	    };
	    it.prototype.everyX0Hours = function () {
	        return "ogni %s ore";
	    };
	    it.prototype.everyX0Minutes = function () {
	        return "ogni %s minuti";
	    };
	    it.prototype.everyX0Seconds = function () {
	        return "ogni %s secondi";
	    };
	    it.prototype.fifth = function () {
	        return "quinto";
	    };
	    it.prototype.first = function () {
	        return "primo";
	    };
	    it.prototype.firstWeekday = function () {
	        return "primo giorno della settimana";
	    };
	    it.prototype.forth = function () {
	        return "quarto";
	    };
	    it.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "minuti %s al %s dopo l'ora";
	    };
	    it.prototype.second = function () {
	        return "secondo";
	    };
	    it.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "secondi %s al %s oltre il minuto";
	    };
	    it.prototype.spaceAnd = function () {
	        return " e";
	    };
	    it.prototype.spaceAndSpace = function () {
	        return " e ";
	    };
	    it.prototype.spaceX0OfTheMonth = function () {
	        return " %s del mese";
	    };
	    it.prototype.third = function () {
	        return "terzo";
	    };
	    it.prototype.weekdayNearestDayX0 = function () {
	        return "giorno della settimana più vicino al %s";
	    };
	    it.prototype.commaStartingX0 = function () {
	        return ", a partire %s";
	    };
	    it.prototype.daysOfTheWeek = function () {
	        return ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
	    };
	    it.prototype.monthsOfTheYear = function () {
	        return ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];
	    };
	    return it;
	}());
	exports.it = it;


/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	var nl = (function () {
	    function nl() {
	    }
	    nl.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    nl.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    nl.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    nl.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    nl.prototype.use24HourTimeFormatByDefault = function () { return false; };
	    nl.prototype.everyMinute = function () {
	        return "elke minuut";
	    };
	    nl.prototype.everyHour = function () {
	        return "elk uur";
	    };
	    nl.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "Er is een fout opgetreden bij het vertalen van de gegevens. Controleer de gegevens.";
	    };
	    nl.prototype.atSpace = function () {
	        return "Op ";
	    };
	    nl.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "Elke minuut tussen %s en %s";
	    };
	    nl.prototype.at = function () {
	        return "Op";
	    };
	    nl.prototype.spaceAnd = function () {
	        return " en";
	    };
	    nl.prototype.everysecond = function () {
	        return "elke seconde";
	    };
	    nl.prototype.everyX0Seconds = function () {
	        return "elke %s seconden";
	    };
	    nl.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "seconden %s t/m %s na de minuut";
	    };
	    nl.prototype.atX0SecondsPastTheMinute = function () {
	        return "op %s seconden na de minuut";
	    };
	    nl.prototype.everyX0Minutes = function () {
	        return "elke %s minuten";
	    };
	    nl.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "minuut %s t/m %s na het uur";
	    };
	    nl.prototype.atX0MinutesPastTheHour = function () {
	        return "op %s minuten na het uur";
	    };
	    nl.prototype.everyX0Hours = function () {
	        return "elke %s uur";
	    };
	    nl.prototype.betweenX0AndX1 = function () {
	        return "tussen %s en %s";
	    };
	    nl.prototype.atX0 = function () {
	        return "op %s";
	    };
	    nl.prototype.commaEveryDay = function () {
	        return ", elke dag";
	    };
	    nl.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", elke %s dagen van de week";
	    };
	    nl.prototype.commaX0ThroughX1 = function () {
	        return ", %s t/m %s";
	    };
	    nl.prototype.first = function () {
	        return "eerste";
	    };
	    nl.prototype.second = function () {
	        return "tweede";
	    };
	    nl.prototype.third = function () {
	        return "derde";
	    };
	    nl.prototype.forth = function () {
	        return "vierde";
	    };
	    nl.prototype.fifth = function () {
	        return "vijfde";
	    };
	    nl.prototype.commaOnThe = function () {
	        return ", op de ";
	    };
	    nl.prototype.spaceX0OfTheMonth = function () {
	        return " %s van de maand";
	    };
	    nl.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", op de laatste %s van de maand";
	    };
	    nl.prototype.commaOnlyOnX0 = function () {
	        return ", alleen op %s";
	    };
	    nl.prototype.commaEveryX0Months = function () {
	        return ", elke %s maanden";
	    };
	    nl.prototype.commaOnlyInX0 = function () {
	        return ", alleen in %s";
	    };
	    nl.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", op de laatste dag van de maand";
	    };
	    nl.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", op de laatste werkdag van de maand";
	    };
	    nl.prototype.firstWeekday = function () {
	        return "eerste werkdag";
	    };
	    nl.prototype.weekdayNearestDayX0 = function () {
	        return "werkdag dichtst bij dag %s";
	    };
	    nl.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", op de %s van de maand";
	    };
	    nl.prototype.commaEveryX0Days = function () {
	        return ", elke %s dagen";
	    };
	    nl.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", tussen dag %s en %s van de maand";
	    };
	    nl.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", op dag %s van de maand";
	    };
	    nl.prototype.spaceAndSpace = function () {
	        return " en ";
	    };
	    nl.prototype.commaEveryMinute = function () {
	        return ", elke minuut";
	    };
	    nl.prototype.commaEveryHour = function () {
	        return ", elk uur";
	    };
	    nl.prototype.commaEveryX0Years = function () {
	        return ", elke %s jaren";
	    };
	    nl.prototype.commaStartingX0 = function () {
	        return ", beginnend %s";
	    };
	    nl.prototype.daysOfTheWeek = function () {
	        return ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
	    };
	    nl.prototype.monthsOfTheYear = function () {
	        return ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
	    };
	    return nl;
	}());
	exports.nl = nl;


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	var nb = (function () {
	    function nb() {
	    }
	    nb.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    nb.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    nb.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    nb.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    nb.prototype.use24HourTimeFormatByDefault = function () { return false; };
	    nb.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "En feil intraff ved generering av uttrykksbeskrivelse. Sjekk cron syntaks.";
	    };
	    nb.prototype.at = function () {
	        return "På";
	    };
	    nb.prototype.atSpace = function () {
	        return "På ";
	    };
	    nb.prototype.atX0 = function () {
	        return "på %s";
	    };
	    nb.prototype.atX0MinutesPastTheHour = function () {
	        return "på %s minutter etter timen";
	    };
	    nb.prototype.atX0SecondsPastTheMinute = function () {
	        return "på %s sekunder etter minuttet";
	    };
	    nb.prototype.betweenX0AndX1 = function () {
	        return "mellom %s og %s";
	    };
	    nb.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", mellom dag %s og %s av måneden";
	    };
	    nb.prototype.commaEveryDay = function () {
	        return ", hver dag";
	    };
	    nb.prototype.commaEveryHour = function () {
	        return ", hver time";
	    };
	    nb.prototype.commaEveryMinute = function () {
	        return ", hvert minutt";
	    };
	    nb.prototype.commaEveryX0Days = function () {
	        return ", hver %s dag";
	    };
	    nb.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", hver %s ukedag";
	    };
	    nb.prototype.commaEveryX0Months = function () {
	        return ", hver %s måned]";
	    };
	    nb.prototype.commaEveryX0Years = function () {
	        return ", hvert %s år";
	    };
	    nb.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", på dag %s av måneden";
	    };
	    nb.prototype.commaOnlyInX0 = function () {
	        return ", bare i %s";
	    };
	    nb.prototype.commaOnlyOnX0 = function () {
	        return ", bare på %s";
	    };
	    nb.prototype.commaOnThe = function () {
	        return ", på den ";
	    };
	    nb.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", på den siste dagen i måneden";
	    };
	    nb.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", på den siste ukedagen i måneden";
	    };
	    nb.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", på den siste %s av måneden";
	    };
	    nb.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", på den %s av måneden";
	    };
	    nb.prototype.commaX0ThroughX1 = function () {
	        return ", %s til og med %s";
	    };
	    nb.prototype.everyHour = function () {
	        return "hver time";
	    };
	    nb.prototype.everyMinute = function () {
	        return "hvert minutt";
	    };
	    nb.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "Hvert minutt mellom %s og %s";
	    };
	    nb.prototype.everysecond = function () {
	        return "hvert sekund";
	    };
	    nb.prototype.everyX0Hours = function () {
	        return "hver %s time";
	    };
	    nb.prototype.everyX0Minutes = function () {
	        return "hvert %s minutt";
	    };
	    nb.prototype.everyX0Seconds = function () {
	        return "hvert %s sekund";
	    };
	    nb.prototype.fifth = function () {
	        return "femte";
	    };
	    nb.prototype.first = function () {
	        return "første";
	    };
	    nb.prototype.firstWeekday = function () {
	        return "første ukedag";
	    };
	    nb.prototype.forth = function () {
	        return "fjede";
	    };
	    nb.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "minuttene fra %s til og med %s etter timen";
	    };
	    nb.prototype.second = function () {
	        return "sekund";
	    };
	    nb.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "sekundene fra %s til og med %s etter minuttet";
	    };
	    nb.prototype.spaceAnd = function () {
	        return " og";
	    };
	    nb.prototype.spaceAndSpace = function () {
	        return " og ";
	    };
	    nb.prototype.spaceX0OfTheMonth = function () {
	        return " %s av måneden";
	    };
	    nb.prototype.third = function () {
	        return "tredje";
	    };
	    nb.prototype.weekdayNearestDayX0 = function () {
	        return "ukedag nærmest dag %s";
	    };
	    nb.prototype.commaStartingX0 = function () {
	        return ", starter %s";
	    };
	    nb.prototype.daysOfTheWeek = function () {
	        return ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"];
	    };
	    nb.prototype.monthsOfTheYear = function () {
	        return ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"];
	    };
	    return nb;
	}());
	exports.nb = nb;


/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	var pl = (function () {
	    function pl() {
	    }
	    pl.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    pl.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    pl.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    pl.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    pl.prototype.use24HourTimeFormatByDefault = function () { return true; };
	    pl.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "Wystąpił błąd podczas generowania opisu wyrażenia cron. Sprawdź składnię wyrażenia cron.";
	    };
	    pl.prototype.at = function () {
	        return "O";
	    };
	    pl.prototype.atSpace = function () {
	        return "O ";
	    };
	    pl.prototype.atX0 = function () {
	        return "o %s";
	    };
	    pl.prototype.atX0MinutesPastTheHour = function () {
	        return "w %s minucie";
	    };
	    pl.prototype.atX0SecondsPastTheMinute = function () {
	        return "w %s sekundzie";
	    };
	    pl.prototype.betweenX0AndX1 = function () {
	        return "od %s do %s";
	    };
	    pl.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", od %s-ego do %s-ego dnia miesiąca";
	    };
	    pl.prototype.commaEveryDay = function () {
	        return ", co dzień";
	    };
	    pl.prototype.commaEveryHour = function () {
	        return ", co godzinę";
	    };
	    pl.prototype.commaEveryMinute = function () {
	        return ", co minutę";
	    };
	    pl.prototype.commaEveryX0Days = function () {
	        return ", co %s dni";
	    };
	    pl.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", co %s dni tygodnia";
	    };
	    pl.prototype.commaEveryX0Months = function () {
	        return ", co %s miesięcy";
	    };
	    pl.prototype.commaEveryX0Years = function () {
	        return ", co %s lat";
	    };
	    pl.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", %s-ego dnia miesiąca";
	    };
	    pl.prototype.commaOnlyInX0 = function () {
	        return ", tylko %s";
	    };
	    pl.prototype.commaOnlyOnX0 = function () {
	        return ", tylko %s";
	    };
	    pl.prototype.commaOnThe = function () {
	        return ", ";
	    };
	    pl.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", ostatni dzień miesiąca";
	    };
	    pl.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", ostatni dzień roboczy miesiąca";
	    };
	    pl.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", ostatni %s miesiąca";
	    };
	    pl.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", %s miesiąca";
	    };
	    pl.prototype.commaX0ThroughX1 = function () {
	        return ", od %s do %s";
	    };
	    pl.prototype.everyHour = function () {
	        return "co godzinę";
	    };
	    pl.prototype.everyMinute = function () {
	        return "co minutę";
	    };
	    pl.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "Co minutę od %s do %s";
	    };
	    pl.prototype.everysecond = function () {
	        return "co sekundę";
	    };
	    pl.prototype.everyX0Hours = function () {
	        return "co %s godzin";
	    };
	    pl.prototype.everyX0Minutes = function () {
	        return "co %s minut";
	    };
	    pl.prototype.everyX0Seconds = function () {
	        return "co %s sekund";
	    };
	    pl.prototype.fifth = function () {
	        return "piąty";
	    };
	    pl.prototype.first = function () {
	        return "pierwszy";
	    };
	    pl.prototype.firstWeekday = function () {
	        return "pierwszy dzień roboczy";
	    };
	    pl.prototype.forth = function () {
	        return "czwarty";
	    };
	    pl.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "minuty od %s do %s";
	    };
	    pl.prototype.second = function () {
	        return "drugi";
	    };
	    pl.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "sekundy od %s do %s";
	    };
	    pl.prototype.spaceAnd = function () {
	        return " i";
	    };
	    pl.prototype.spaceAndSpace = function () {
	        return " i ";
	    };
	    pl.prototype.spaceX0OfTheMonth = function () {
	        return " %s miesiąca";
	    };
	    pl.prototype.third = function () {
	        return "trzeci";
	    };
	    pl.prototype.weekdayNearestDayX0 = function () {
	        return "dzień roboczy najbliższy %s-ego dnia";
	    };
	    pl.prototype.commaStartingX0 = function () {
	        return ", startowy %s";
	    };
	    pl.prototype.daysOfTheWeek = function () {
	        return ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"];
	    };
	    pl.prototype.monthsOfTheYear = function () {
	        return ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"];
	    };
	    return pl;
	}());
	exports.pl = pl;


/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";
	var pt_BR = (function () {
	    function pt_BR() {
	    }
	    pt_BR.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    pt_BR.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    pt_BR.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    pt_BR.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    pt_BR.prototype.use24HourTimeFormatByDefault = function () { return false; };
	    pt_BR.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "Ocorreu um erro ao gerar a descrição da expressão Cron.";
	    };
	    pt_BR.prototype.at = function () {
	        return "às";
	    };
	    pt_BR.prototype.atSpace = function () {
	        return "às ";
	    };
	    pt_BR.prototype.atX0 = function () {
	        return "Às %s";
	    };
	    pt_BR.prototype.atX0MinutesPastTheHour = function () {
	        return "aos %s minutos da hora";
	    };
	    pt_BR.prototype.atX0SecondsPastTheMinute = function () {
	        return "aos %s segundos do minuto";
	    };
	    pt_BR.prototype.betweenX0AndX1 = function () {
	        return "entre %s e %s";
	    };
	    pt_BR.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", entre os dias %s e %s do mês";
	    };
	    pt_BR.prototype.commaEveryDay = function () {
	        return ", a cada dia";
	    };
	    pt_BR.prototype.commaEveryHour = function () {
	        return ", a cada hora";
	    };
	    pt_BR.prototype.commaEveryMinute = function () {
	        return ", a cada minuto";
	    };
	    pt_BR.prototype.commaEveryX0Days = function () {
	        return ", a cada %s dias";
	    };
	    pt_BR.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", a cada %s dias de semana";
	    };
	    pt_BR.prototype.commaEveryX0Months = function () {
	        return ", a cada %s meses";
	    };
	    pt_BR.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", no dia %s do mês";
	    };
	    pt_BR.prototype.commaOnlyInX0 = function () {
	        return ", somente em %s";
	    };
	    pt_BR.prototype.commaOnlyOnX0 = function () {
	        return ", somente de %s";
	    };
	    pt_BR.prototype.commaOnThe = function () {
	        return ", na ";
	    };
	    pt_BR.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", no último dia do mês";
	    };
	    pt_BR.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", no último dia da semana do mês";
	    };
	    pt_BR.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", na última %s do mês";
	    };
	    pt_BR.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", no %s do mês";
	    };
	    pt_BR.prototype.commaX0ThroughX1 = function () {
	        return ", de %s a %s";
	    };
	    pt_BR.prototype.everyHour = function () {
	        return "a cada hora";
	    };
	    pt_BR.prototype.everyMinute = function () {
	        return "a cada minuto";
	    };
	    pt_BR.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "a cada minuto entre %s e %s";
	    };
	    pt_BR.prototype.everysecond = function () {
	        return "a cada segundo";
	    };
	    pt_BR.prototype.everyX0Hours = function () {
	        return "a cada %s horas";
	    };
	    pt_BR.prototype.everyX0Minutes = function () {
	        return "a cada %s minutos";
	    };
	    pt_BR.prototype.everyX0Seconds = function () {
	        return "a cada %s segundos";
	    };
	    pt_BR.prototype.fifth = function () {
	        return "quinta";
	    };
	    pt_BR.prototype.first = function () {
	        return "primeira";
	    };
	    pt_BR.prototype.firstWeekday = function () {
	        return "primeiro dia da semana";
	    };
	    pt_BR.prototype.forth = function () {
	        return "quarta";
	    };
	    pt_BR.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "do minuto %s até %s de cada hora";
	    };
	    pt_BR.prototype.second = function () {
	        return "segunda";
	    };
	    pt_BR.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "No segundo %s até %s de cada minuto";
	    };
	    pt_BR.prototype.spaceAnd = function () {
	        return " e";
	    };
	    pt_BR.prototype.spaceAndSpace = function () {
	        return " e ";
	    };
	    pt_BR.prototype.spaceX0OfTheMonth = function () {
	        return " %s do mês";
	    };
	    pt_BR.prototype.third = function () {
	        return "terceira";
	    };
	    pt_BR.prototype.weekdayNearestDayX0 = function () {
	        return "dia da semana mais próximo do dia %s";
	    };
	    pt_BR.prototype.commaEveryX0Years = function () {
	        return ", a cada %s anos";
	    };
	    pt_BR.prototype.commaStartingX0 = function () {
	        return ", iniciando %s";
	    };
	    pt_BR.prototype.daysOfTheWeek = function () {
	        return ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];
	    };
	    pt_BR.prototype.monthsOfTheYear = function () {
	        return ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
	    };
	    return pt_BR;
	}());
	exports.pt_BR = pt_BR;


/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	var ro = (function () {
	    function ro() {
	    }
	    ro.prototype.use24HourTimeFormatByDefault = function () { return true; };
	    ro.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "Eroare la generarea descrierii. Verificați sintaxa.";
	    };
	    ro.prototype.at = function () {
	        return "La";
	    };
	    ro.prototype.atSpace = function () {
	        return "La ";
	    };
	    ro.prototype.atX0 = function () {
	        return "la %s";
	    };
	    ro.prototype.atX0MinutesPastTheHour = function () {
	        return "la și %s minute";
	    };
	    ro.prototype.atX0SecondsPastTheMinute = function () {
	        return "la și %s secunde";
	    };
	    ro.prototype.betweenX0AndX1 = function () {
	        return "între %s și %s";
	    };
	    ro.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", între zilele %s și %s ale lunii";
	    };
	    ro.prototype.commaEveryDay = function () {
	        return ", în fiecare zi";
	    };
	    ro.prototype.commaEveryHour = function () {
	        return ", în fiecare oră";
	    };
	    ro.prototype.commaEveryMinute = function () {
	        return ", în fiecare minut";
	    };
	    ro.prototype.commaEveryX0Days = function () {
	        return ", la fiecare %s zile";
	    };
	    ro.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", la fiecare a %s-a zi a săptămânii";
	    };
	    ro.prototype.commaEveryX0Months = function () {
	        return ", la fiecare %s luni";
	    };
	    ro.prototype.commaEveryX0Years = function () {
	        return ", o dată la %s ani";
	    };
	    ro.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", în ziua %s a lunii";
	    };
	    ro.prototype.commaOnlyInX0 = function () {
	        return ", doar în %s";
	    };
	    ro.prototype.commaOnlyOnX0 = function () {
	        return ", doar %s";
	    };
	    ro.prototype.commaOnThe = function () {
	        return ", în ";
	    };
	    ro.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", în ultima zi a lunii";
	    };
	    ro.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", în ultima zi lucrătoare a lunii";
	    };
	    ro.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", în ultima %s a lunii";
	    };
	    ro.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", în %s a lunii";
	    };
	    ro.prototype.commaX0ThroughX1 = function () {
	        return ", de %s până %s";
	    };
	    ro.prototype.everyHour = function () {
	        return "în fiecare oră";
	    };
	    ro.prototype.everyMinute = function () {
	        return "în fiecare minut";
	    };
	    ro.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "În fiecare minut între %s și %s";
	    };
	    ro.prototype.everysecond = function () {
	        return "în fiecare secundă";
	    };
	    ro.prototype.everyX0Hours = function () {
	        return "la fiecare %s ore";
	    };
	    ro.prototype.everyX0Minutes = function () {
	        return "la fiecare %s minute";
	    };
	    ro.prototype.everyX0Seconds = function () {
	        return "la fiecare %s secunde";
	    };
	    ro.prototype.fifth = function () {
	        return "a cincea";
	    };
	    ro.prototype.first = function () {
	        return "prima";
	    };
	    ro.prototype.firstWeekday = function () {
	        return "prima zi a săptămânii";
	    };
	    ro.prototype.forth = function () {
	        return "a patra";
	    };
	    ro.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "între minutele %s și %s";
	    };
	    ro.prototype.second = function () {
	        return "a doua";
	    };
	    ro.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "între secunda %s și secunda %s";
	    };
	    ro.prototype.spaceAnd = function () {
	        return " și";
	    };
	    ro.prototype.spaceAndSpace = function () {
	        return " și ";
	    };
	    ro.prototype.spaceX0OfTheMonth = function () {
	        return " %s a lunii";
	    };
	    ro.prototype.third = function () {
	        return "a treia";
	    };
	    ro.prototype.weekdayNearestDayX0 = function () {
	        return "cea mai apropiată zi a săptămânii de ziua %s";
	    };
	    ro.prototype.ComaMinX0ThroughMinX1 = function () {
	        return ", de la %s până la %s";
	    };
	    ro.prototype.commaMonthX0ThroughMonthX1 = function () {
	        return ", din %s până în %s";
	    };
	    ro.prototype.commaYearX0ThroughYearX1 = function () {
	        return ", din %s până în %s";
	    };
	    ro.prototype.atX0MinutesPastTheHourGt20 = function () {
	        return "la și %s de minute";
	    };
	    ro.prototype.atX0SecondsPastTheMinuteGt20 = function () {
	        return "la și %s de secunde";
	    };
	    ro.prototype.commaStartingX0 = function () {
	        return ", pornire %s";
	    };
	    ro.prototype.daysOfTheWeek = function () {
	        return ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"];
	    };
	    ro.prototype.monthsOfTheYear = function () {
	        return ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"];
	    };
	    return ro;
	}());
	exports.ro = ro;


/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	var ru = (function () {
	    function ru() {
	    }
	    ru.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    ru.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    ru.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    ru.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    ru.prototype.use24HourTimeFormatByDefault = function () { return true; };
	    ru.prototype.everyMinute = function () {
	        return "каждую минуту";
	    };
	    ru.prototype.everyHour = function () {
	        return "каждый час";
	    };
	    ru.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "Произошла ошибка во время генерации описания выражения. Проверьте синтаксис крон-выражения.";
	    };
	    ru.prototype.atSpace = function () {
	        return "В ";
	    };
	    ru.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "Каждую минуту с %s по %s";
	    };
	    ru.prototype.at = function () {
	        return "В";
	    };
	    ru.prototype.spaceAnd = function () {
	        return " и";
	    };
	    ru.prototype.everysecond = function () {
	        return "каждую секунду";
	    };
	    ru.prototype.everyX0Seconds = function () {
	        return "каждые %s секунд";
	    };
	    ru.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "секунды с %s по %s";
	    };
	    ru.prototype.atX0SecondsPastTheMinute = function () {
	        return "в %s секунд";
	    };
	    ru.prototype.everyX0Minutes = function () {
	        return "каждые %s минут";
	    };
	    ru.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "минуты с %s по %s";
	    };
	    ru.prototype.atX0MinutesPastTheHour = function () {
	        return "в %s минут";
	    };
	    ru.prototype.everyX0Hours = function () {
	        return "каждые %s часов";
	    };
	    ru.prototype.betweenX0AndX1 = function () {
	        return "с %s по %s";
	    };
	    ru.prototype.atX0 = function () {
	        return "в %s";
	    };
	    ru.prototype.commaEveryDay = function () {
	        return ", каждый день";
	    };
	    ru.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", каждые %s дней недели";
	    };
	    ru.prototype.commaX0ThroughX1 = function () {
	        return ", %s по %s";
	    };
	    ru.prototype.first = function () {
	        return "первый";
	    };
	    ru.prototype.second = function () {
	        return "второй";
	    };
	    ru.prototype.third = function () {
	        return "третий";
	    };
	    ru.prototype.forth = function () {
	        return "четвертый";
	    };
	    ru.prototype.fifth = function () {
	        return "пятый";
	    };
	    ru.prototype.commaOnThe = function () {
	        return ", в ";
	    };
	    ru.prototype.spaceX0OfTheMonth = function () {
	        return " %s месяца";
	    };
	    ru.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", в последний %s месяца";
	    };
	    ru.prototype.commaOnlyOnX0 = function () {
	        return ", только в %s";
	    };
	    ru.prototype.commaEveryX0Months = function () {
	        return ", каждые %s месяцев";
	    };
	    ru.prototype.commaOnlyInX0 = function () {
	        return ", только в %s";
	    };
	    ru.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", в последний день месяца";
	    };
	    ru.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", в последний будний день месяца";
	    };
	    ru.prototype.firstWeekday = function () {
	        return "первый будний день";
	    };
	    ru.prototype.weekdayNearestDayX0 = function () {
	        return "ближайший будний день к %s";
	    };
	    ru.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", в %s месяца";
	    };
	    ru.prototype.commaEveryX0Days = function () {
	        return ", каждые %s дней";
	    };
	    ru.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", с %s по %s число месяца";
	    };
	    ru.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", в %s число месяца";
	    };
	    ru.prototype.spaceAndSpace = function () {
	        return " и ";
	    };
	    ru.prototype.commaEveryMinute = function () {
	        return ", каждую минуту";
	    };
	    ru.prototype.commaEveryHour = function () {
	        return ", каждый час";
	    };
	    ru.prototype.commaEveryX0Years = function () {
	        return ", каждые %s лет";
	    };
	    ru.prototype.commaStartingX0 = function () {
	        return ", начало %s";
	    };
	    ru.prototype.daysOfTheWeek = function () {
	        return ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"];
	    };
	    ru.prototype.monthsOfTheYear = function () {
	        return ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"];
	    };
	    return ru;
	}());
	exports.ru = ru;


/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	var tr = (function () {
	    function tr() {
	    }
	    tr.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    tr.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    tr.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    tr.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    tr.prototype.use24HourTimeFormatByDefault = function () { return true; };
	    tr.prototype.everyMinute = function () {
	        return "her dakika";
	    };
	    tr.prototype.everyHour = function () {
	        return "her saat";
	    };
	    tr.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "İfade açıklamasını oluştururken bir hata oluştu. Cron ifadesini gözden geçirin.";
	    };
	    tr.prototype.atSpace = function () {
	        return "Saat ";
	    };
	    tr.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "Saat %s ve %s arasındaki her dakika";
	    };
	    tr.prototype.at = function () {
	        return "Saat";
	    };
	    tr.prototype.spaceAnd = function () {
	        return " ve";
	    };
	    tr.prototype.everysecond = function () {
	        return "her saniye";
	    };
	    tr.prototype.everyX0Seconds = function () {
	        return "her %s saniyede bir";
	    };
	    tr.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "dakikaların %s. ve %s. saniyeleri arası";
	    };
	    tr.prototype.atX0SecondsPastTheMinute = function () {
	        return "dakikaların %s. saniyesinde";
	    };
	    tr.prototype.everyX0Minutes = function () {
	        return "her %s dakikada bir";
	    };
	    tr.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "saatlerin %s. ve %s. dakikaları arası";
	    };
	    tr.prototype.atX0MinutesPastTheHour = function () {
	        return "saatlerin %s. dakikasında";
	    };
	    tr.prototype.everyX0Hours = function () {
	        return "her %s saatte";
	    };
	    tr.prototype.betweenX0AndX1 = function () {
	        return "%s ile %s arasında";
	    };
	    tr.prototype.atX0 = function () {
	        return "saat %s";
	    };
	    tr.prototype.commaEveryDay = function () {
	        return ", her gün";
	    };
	    tr.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", ayın her %s günü";
	    };
	    tr.prototype.commaX0ThroughX1 = function () {
	        return ", %s ile %s arasında";
	    };
	    tr.prototype.first = function () {
	        return "ilk";
	    };
	    tr.prototype.second = function () {
	        return "ikinci";
	    };
	    tr.prototype.third = function () {
	        return "üçüncü";
	    };
	    tr.prototype.forth = function () {
	        return "dördüncü";
	    };
	    tr.prototype.fifth = function () {
	        return "beşinci";
	    };
	    tr.prototype.commaOnThe = function () {
	        return ", ayın ";
	    };
	    tr.prototype.spaceX0OfTheMonth = function () {
	        return " %s günü";
	    };
	    tr.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", ayın son %s günü";
	    };
	    tr.prototype.commaOnlyOnX0 = function () {
	        return ", sadece %s günü";
	    };
	    tr.prototype.commaEveryX0Months = function () {
	        return ", %s ayda bir";
	    };
	    tr.prototype.commaOnlyInX0 = function () {
	        return ", sadece %s için";
	    };
	    tr.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", ayın son günü";
	    };
	    tr.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", ayın son iş günü";
	    };
	    tr.prototype.firstWeekday = function () {
	        return "ilk iş günü";
	    };
	    tr.prototype.weekdayNearestDayX0 = function () {
	        return "%s. günü sonrasındaki ilk iş günü";
	    };
	    tr.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", ayın %s";
	    };
	    tr.prototype.commaEveryX0Days = function () {
	        return ", %s günde bir";
	    };
	    tr.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", ayın %s. ve %s. günleri arası";
	    };
	    tr.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", ayın %s. günü";
	    };
	    tr.prototype.spaceAndSpace = function () {
	        return " ve ";
	    };
	    tr.prototype.commaEveryMinute = function () {
	        return ", her dakika";
	    };
	    tr.prototype.commaEveryHour = function () {
	        return ", her saat";
	    };
	    tr.prototype.commaEveryX0Years = function () {
	        return ", %s yılda bir";
	    };
	    tr.prototype.commaStartingX0 = function () {
	        return ", başlangıç %s";
	    };
	    tr.prototype.daysOfTheWeek = function () {
	        return ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
	    };
	    tr.prototype.monthsOfTheYear = function () {
	        return ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
	    };
	    return tr;
	}());
	exports.tr = tr;


/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	var uk = (function () {
	    function uk() {
	    }
	    uk.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    uk.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    uk.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    uk.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    uk.prototype.use24HourTimeFormatByDefault = function () { return true; };
	    uk.prototype.everyMinute = function () {
	        return "щохвилини";
	    };
	    uk.prototype.everyHour = function () {
	        return "щогодини";
	    };
	    uk.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "ВІдбулася помилка підчас генерації опису. Перевірта правильність написання cron виразу.";
	    };
	    uk.prototype.atSpace = function () {
	        return "О ";
	    };
	    uk.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "Щохвилини між %s та %s";
	    };
	    uk.prototype.at = function () {
	        return "О";
	    };
	    uk.prototype.spaceAnd = function () {
	        return " та";
	    };
	    uk.prototype.everysecond = function () {
	        return "Щосекунди";
	    };
	    uk.prototype.everyX0Seconds = function () {
	        return "кожні %s секунд";
	    };
	    uk.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "з %s по %s секунду";
	    };
	    uk.prototype.atX0SecondsPastTheMinute = function () {
	        return "о %s секунді";
	    };
	    uk.prototype.everyX0Minutes = function () {
	        return "кожні %s хвилин";
	    };
	    uk.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "з %s по %s хвилину";
	    };
	    uk.prototype.atX0MinutesPastTheHour = function () {
	        return "о %s хвилині";
	    };
	    uk.prototype.everyX0Hours = function () {
	        return "кожні %s годин";
	    };
	    uk.prototype.betweenX0AndX1 = function () {
	        return "між %s та %s";
	    };
	    uk.prototype.atX0 = function () {
	        return "о %s";
	    };
	    uk.prototype.commaEveryDay = function () {
	        return ", щоденно";
	    };
	    uk.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", кожен %s день тижня";
	    };
	    uk.prototype.commaX0ThroughX1 = function () {
	        return ", %s по %s";
	    };
	    uk.prototype.first = function () {
	        return "перший";
	    };
	    uk.prototype.second = function () {
	        return "другий";
	    };
	    uk.prototype.third = function () {
	        return "третій";
	    };
	    uk.prototype.forth = function () {
	        return "четвертий";
	    };
	    uk.prototype.fifth = function () {
	        return "п'ятий";
	    };
	    uk.prototype.commaOnThe = function () {
	        return ", в ";
	    };
	    uk.prototype.spaceX0OfTheMonth = function () {
	        return " %s місяця";
	    };
	    uk.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", в останній %s місяця";
	    };
	    uk.prototype.commaOnlyOnX0 = function () {
	        return ", тільки в %s";
	    };
	    uk.prototype.commaEveryX0Months = function () {
	        return ", кожен %s місяць";
	    };
	    uk.prototype.commaOnlyInX0 = function () {
	        return ", тільки в %s";
	    };
	    uk.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", в останній день місяця";
	    };
	    uk.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", в останній будень місяця";
	    };
	    uk.prototype.firstWeekday = function () {
	        return "перший будень";
	    };
	    uk.prototype.weekdayNearestDayX0 = function () {
	        return "будень найближчий до %s дня";
	    };
	    uk.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", в %s місяця";
	    };
	    uk.prototype.commaEveryX0Days = function () {
	        return ", кожен %s день";
	    };
	    uk.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", між %s та %s днями місяця";
	    };
	    uk.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", на %s день місяця";
	    };
	    uk.prototype.spaceAndSpace = function () {
	        return " та ";
	    };
	    uk.prototype.commaEveryMinute = function () {
	        return ", щохвилини";
	    };
	    uk.prototype.commaEveryHour = function () {
	        return ", щогодини";
	    };
	    uk.prototype.commaEveryX0Years = function () {
	        return ", кожні %s роки";
	    };
	    uk.prototype.commaStartingX0 = function () {
	        return ", початок %s";
	    };
	    uk.prototype.daysOfTheWeek = function () {
	        return ["неділя", "понеділок", "вівторок", "середа", "четвер", "п'ятниця", "субота"];
	    };
	    uk.prototype.monthsOfTheYear = function () {
	        return ["січень", "лютий", "березень", "квітень", "травень", "червень", "липень", "серпень", "вересень", "жовтень", "листопад", "грудень"];
	    };
	    return uk;
	}());
	exports.uk = uk;


/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	var zh_CN = (function () {
	    function zh_CN() {
	    }
	    zh_CN.prototype.atX0SecondsPastTheMinuteGt20 = function () { return null; };
	    zh_CN.prototype.atX0MinutesPastTheHourGt20 = function () { return null; };
	    zh_CN.prototype.commaMonthX0ThroughMonthX1 = function () { return null; };
	    zh_CN.prototype.commaYearX0ThroughYearX1 = function () { return null; };
	    zh_CN.prototype.use24HourTimeFormatByDefault = function () { return false; };
	    zh_CN.prototype.everyMinute = function () {
	        return "每分钟";
	    };
	    zh_CN.prototype.everyHour = function () {
	        return "每小时";
	    };
	    zh_CN.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function () {
	        return "生成表达式描述时发生了错误，请检查cron表达式语法。";
	    };
	    zh_CN.prototype.atSpace = function () {
	        return "在 ";
	    };
	    zh_CN.prototype.everyMinutebetweenX0AndX1 = function () {
	        return "在 %s 和 %s 之间的每分钟";
	    };
	    zh_CN.prototype.at = function () {
	        return "在";
	    };
	    zh_CN.prototype.spaceAnd = function () {
	        return " 和";
	    };
	    zh_CN.prototype.everysecond = function () {
	        return "每秒";
	    };
	    zh_CN.prototype.everyX0Seconds = function () {
	        return "每 %s 秒";
	    };
	    zh_CN.prototype.secondsX0ThroughX1PastTheMinute = function () {
	        return "在每分钟的 %s 到 %s 秒";
	    };
	    zh_CN.prototype.atX0SecondsPastTheMinute = function () {
	        return "在每分钟的 %s 秒";
	    };
	    zh_CN.prototype.everyX0Minutes = function () {
	        return "每 %s 分钟";
	    };
	    zh_CN.prototype.minutesX0ThroughX1PastTheHour = function () {
	        return "在每小时的 %s 到 %s 分钟";
	    };
	    zh_CN.prototype.atX0MinutesPastTheHour = function () {
	        return "在每小时的 %s 分";
	    };
	    zh_CN.prototype.everyX0Hours = function () {
	        return "每 %s 小时";
	    };
	    zh_CN.prototype.betweenX0AndX1 = function () {
	        return "在 %s 和 %s 之间";
	    };
	    zh_CN.prototype.atX0 = function () {
	        return "在 %s";
	    };
	    zh_CN.prototype.commaEveryDay = function () {
	        return ", 每天";
	    };
	    zh_CN.prototype.commaEveryX0daysOfTheWeek = function () {
	        return ", 每周的每 %s 天";
	    };
	    zh_CN.prototype.commaX0ThroughX1 = function () {
	        return ", %s 到 %s";
	    };
	    zh_CN.prototype.first = function () {
	        return "第一个";
	    };
	    zh_CN.prototype.second = function () {
	        return "第二个";
	    };
	    zh_CN.prototype.third = function () {
	        return "第三个";
	    };
	    zh_CN.prototype.forth = function () {
	        return "第四个";
	    };
	    zh_CN.prototype.fifth = function () {
	        return "第五个";
	    };
	    zh_CN.prototype.commaOnThe = function () {
	        return ", 在 ";
	    };
	    zh_CN.prototype.spaceX0OfTheMonth = function () {
	        return "%s 每月";
	    };
	    zh_CN.prototype.commaOnTheLastX0OfTheMonth = function () {
	        return ", 每月的最后一个 %s ";
	    };
	    zh_CN.prototype.commaOnlyOnX0 = function () {
	        return ", 仅在 %s";
	    };
	    zh_CN.prototype.commaEveryX0Months = function () {
	        return ", 每 %s 月";
	    };
	    zh_CN.prototype.commaOnlyInX0 = function () {
	        return ", 仅在 %s";
	    };
	    zh_CN.prototype.commaOnTheLastDayOfTheMonth = function () {
	        return ", 每月的最后一天";
	    };
	    zh_CN.prototype.commaOnTheLastWeekdayOfTheMonth = function () {
	        return ", 每月的最后一个平日";
	    };
	    zh_CN.prototype.firstWeekday = function () {
	        return "第一个平日";
	    };
	    zh_CN.prototype.weekdayNearestDayX0 = function () {
	        return "最接近 %s 号的平日";
	    };
	    zh_CN.prototype.commaOnTheX0OfTheMonth = function () {
	        return ", 每月的 %s ";
	    };
	    zh_CN.prototype.commaEveryX0Days = function () {
	        return ", 每 %s 天";
	    };
	    zh_CN.prototype.commaBetweenDayX0AndX1OfTheMonth = function () {
	        return ", 在每月的 %s 和 %s 号之间";
	    };
	    zh_CN.prototype.commaOnDayX0OfTheMonth = function () {
	        return ", 每月的 %s 号";
	    };
	    zh_CN.prototype.spaceAndSpace = function () {
	        return " 和 ";
	    };
	    zh_CN.prototype.commaEveryMinute = function () {
	        return ", 每分钟";
	    };
	    zh_CN.prototype.commaEveryHour = function () {
	        return ", 每小时";
	    };
	    zh_CN.prototype.commaEveryX0Years = function () {
	        return ", 每 %s 年";
	    };
	    zh_CN.prototype.commaStartingX0 = function () {
	        return ", 开始 %s";
	    };
	    zh_CN.prototype.daysOfTheWeek = function () {
	        return ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
	    };
	    zh_CN.prototype.monthsOfTheYear = function () {
	        return ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
	    };
	    return zh_CN;
	}());
	exports.zh_CN = zh_CN;


/***/ }
/******/ ])
});
;
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .run(runBlock);

    /** @ngInject */
    function runBlock($locale, $rootScope, $mdSidenav, msUtils, nuitAuth, nuitConfig, CalendarTranslation)
    {
        //*******************************************
        // AUTHENTICATION
        //*******************************************
        if (nuitAuth.isAuthenticated()) {
            nuitAuth.reloadUserData();
        }
        //*******************************************

        //*******************************************
        // FUSE
        //*******************************************
        if (msUtils.isMobile())
        {
            /**
             * Disable md-ink-ripple effects on mobile
             * if 'disableMdInkRippleOnMobile' config enabled
             */
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
            /**
             * Put isMobile() to the html as a class
             */
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if (browserInfo)
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
        //*******************************************

        //*******************************************
        // EVENTS
        //*******************************************
		var unregisterToggleSidenav = $rootScope.$on('toggleSidenav', onToggleSidenav);
        var unregisterDestroy = $rootScope.$on('$destroy', onDestroy);
		var unregisterLangListener = $rootScope.$on('$translateChangeSuccess', CalendarTranslation.update);
		var unregisterSeperators = $rootScope.$on('config::config.loaded', updateSeparators);
		//*******************************************

		////////////////////////////////////////////////////////////////////////

		/**
		 * This event is fired whenever a sidenav is being toggled.
		 * @param {String} $event
		 * @param {String} param
		 */
		function onToggleSidenav($event, sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}

		function updateSeparators(){
			$locale.NUMBER_FORMATS.DECIMAL_SEP = nuitConfig.current.units.formats.number.decimalSeperator;
			$locale.NUMBER_FORMATS.GROUP_SEP = nuitConfig.current.units.formats.number.groupSeperator;
		}

        /**
         * This event is fired when the root scope is being destroyed.
         */
        function onDestroy() {
			unregisterToggleSidenav();
			unregisterDestroy();
			unregisterLangListener();
			unregisterSeperators();
        }
    }
})();

(function ()
{
    'use strict';

    // Create default config
    var env = {};

	var origin = window.location.origin;

	if(origin.includes('localhost')) {
		env.apiURL = 'https://dev-api.nu-it.at';
	}else{
		var replacements = [
			'evo-v1',
			'kantteile-v1',
			'ims-v1',
			'evo',
			'ims'
		];

		var replacementLookup = {
			'kantteile-dachprofi-v1':'api-dachprofi'
		}

		for(var i = 0; i<Object.keys(replacementLookup).length; i++){
			if(origin.includes(Object.keys(replacementLookup)[i])) {
				origin = origin.replace(Object.keys(replacementLookup)[i], replacementLookup[Object.keys(replacementLookup)[i]]);
				break;
			}
		}


		for(var i= 0; i<Object.keys(replacements).length; i++){
			if(origin.includes(replacements[i])) {
				origin = origin.replace(replacements[i], 'api');
				break;
			}
		}

		console.log('api:',origin);

		env.apiURL = origin;
	}

    angular
        .module('app.core')
        .constant('coreConstants', env);
})();

(function () {
	'use strict';

	angular
		.module('app.core')
		.config(config);

	/** @ngInject */
	function config($ariaProvider, $translateProvider, $mdDateLocaleProvider, msScrollConfigProvider, nuitConfigProvider, nuitApiProvider, $mdAriaProvider) {
		//*******************************************
		// ARIA
		//*******************************************
		/*eslint-disable */
		// ng-aria configuration
		$ariaProvider.config({
			tabindex: false
		});
		$mdAriaProvider.disableWarnings();
		//*******************************************

		//*******************************************
		// MS-SCROLL
		//*******************************************
		msScrollConfigProvider.config({
			wheelPropagation: true
		});
		/*eslint-enable */
		//*******************************************

		//*******************************************
		// TRANSLATION
		//*******************************************
		var languages = ['en', 'de', 'sv', 'it', 'fr', 'es', 'tr', 'nl', 'fi', 'da','hu','no', 'cs', 'pl', 'lt', 'sk'];
		var filters =  {
			'en*': 'en',
			'de*': 'de',
			'sv*': 'sv',
			'it*': 'it',
			'fr*': 'fr',
			'es*': 'es',
			'tr*': 'tr',
			'nl*': 'nl',
			'fi*': 'fi',
			'da*': 'da',
			'hu*': 'hu',
			'no*': 'no',
			'cs*': 'cs',
			'pl*': 'pl',
			'lt*': 'lt',
			'sk*': 'sk'
		};
		$translateProvider.useSanitizeValueStrategy('escape');
		$translateProvider.useUrlLoader(nuitApiProvider.getBaseUrl() + 'translations');
		$translateProvider.useMissingTranslationHandler('missingTranslationHandler');
		$translateProvider.registerAvailableLanguageKeys(languages, filters);
		$translateProvider.determinePreferredLanguage();
		$translateProvider.fallbackLanguage('en');
		//*******************************************

		//*******************************************
		// DATE LOCALIZATION
		//*******************************************
		$mdDateLocaleProvider.firstDayOfWeek = 1;
		$mdDateLocaleProvider.formatDate = function (date) {
			if(date) {
				return moment(date).format(nuitConfigProvider.getCurrent().localization.dateFormat);
			}else{
				return '';
			}
		};

		$mdDateLocaleProvider.parseDate = function (date) {
			if(date) {
				return moment(date, nuitConfigProvider.getCurrent().localization.dateFormat).toDate();
			}else{
				return new Date();
			}
		};

		//*******************************************

		//*******************************************
		// API
		//*******************************************
		nuitApiProvider.register('user.data', 'users/:id', {allow: ['get', 'put']});
		// Profiles
		nuitApiProvider.register('profile.images','images',{allow: ['get']});
		// v3: preview (statistics + image/attachments), profiles/preview when a material is set
		nuitApiProvider.register('profile.preview','production/v2/profile/savedprofiles/preview',{allow: ['post']});
		nuitApiProvider.register('profile.preview.material','production/v2/profile/profiles/preview',{allow: ['post']});

		nuitApiProvider.register('special.processing', '/shop/config/profiles/special', {allow: ['get']});

		nuitApiProvider.register('order.update', 'shop/orders/:id', {allow: ['put']});
		nuitApiProvider.register('order.update.status', 'shop/orders/:id/status', {allow: ['put']});
		nuitApiProvider.register('order.count.by.status','shop/orders/status',{allow:['get']});

		nuitApiProvider.register('offer.update', 'shop/offers/:id', {allow: ['put']});
		nuitApiProvider.register('offer.update.status', 'shop/offers/:id/status', {allow: ['put']});
		nuitApiProvider.register('offer.toOrder', 'shop/offers/:id/order', {allow: ['post']});
		nuitApiProvider.register('offer.count.by.status','shop/offers/status',{allow:['get']});

		nuitApiProvider.register('feedback.create', 'production/wikant/producible', {allow: ['post']});
		nuitApiProvider.register('feedback.get', 'production/wikant/predictions/machine/:machineId/geometry/:geometryId/material/:materialId', {allow: ['get']});
		nuitApiProvider.register('feedback.notes', 'production/wikant/notes', {allow: ['get']});

		nuitApiProvider.register('profiles.list', 'folder/folders/:id/items', {allow: ['get'], versions:[2] });
		nuitApiProvider.register('profiles.all', 'production/savedprofiles', {allow: ['get'] , versions: [{number: 2, path:'/v2/profile'}]});
		nuitApiProvider.register('profiles.single', 'production/savedprofiles/:id', {allow: ['delete', 'put'], versions: [{number: 2, path:'/v2/profile'}]});
		nuitApiProvider.register('profiles.folders', 'folder/folders', {allow: ['get','post'], versions: [2]});
		nuitApiProvider.register('profiles.folders.single', 'folder/folders/:id', {allow: ['delete','put'], versions:[2]});
		nuitApiProvider.register('profiles.folders.swap', 'folder/folders/:id/swap', {allow: ['post'], versions:[2]});
		nuitApiProvider.register('profiles.update', 'folder/folders/:folderId/items/:itemId', {allow: ['put'], versions:[2]});

		nuitApiProvider.register('profile.single', 'production/savedprofiles/:id', {allow: ['get', 'put'], versions: [{number: 2, path:'/v2/profile'}]});
		nuitApiProvider.register('profile.save', 'production/savedprofiles', {allow: ['post'], versions: [{number: 2, path:'/v2/profile'}]});

		nuitApiProvider.register('payments.by.order', 'payment/payments/order/:id', {allow: ['get']});

		nuitApiProvider.register('order.tags','/shop/v2/tags',{allow: ['get','post']});
		nuitApiProvider.register('order.tags.single','/shop/v2/tags/:id',{allow: ['put','patch','delete']});

		nuitApiProvider.register('project.projects','/project/projects',{allow: ['get','post']});
		//*******************************************

		//*******************************************
		// SETTINGS
		//*******************************************
		var options = {
			fuse: {
				disableCustomScrollbars: false,
				disableCustomScrollbarsOnMobile: true
			},
			units: {
				length: {
					symbol: 'mm',
					factor: 1.0,
					decimals: 0
				},
				runningmeter: {
					symbol: 'm',
					factor: 1,
					decimals: 2
				},
				perLengthUnitConversion: {
					symbol: 'm',
					factor: 1000,
					decimals: 2
				},
				area: {
					symbol: 'm²',
					factor: 1,
					decimals: 2
				},
				thickness: {
					symbol: 'mm',
					factor: 1,
					decimals: 2
				},
				weight: {
					symbol: 'kg',
					factor: 1,
					decimals: 2
				},
				pressure: {
					symbol: 'kg/m²',
					factor: 1,
					decimals: 2
				},
				density: {
					symbol: 'kg/m³',
					factor: 1,
					decimals: 3
				},
				formats: {
					number: {
						decimalSeperator: '.',
						groupSeperator: ','
					}
				}
			}
		};

		nuitConfigProvider.injectIntoDefault(options);
		//*******************************************
	}
})();

(function () {
	'use strict';

	angular
		.module('ims')
		.constant('IMS_SETTINGS_ROLE',
			{
				ims: {
					routes:{
						login: 'app.orders'
					},
					account:{
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.constant('IMS_SETTINGS',
			{
				ims: {
					routes:{
						login: 'app.orders'
					},
					account:{
						enabled: false
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.run(runBlock);

	/** @ngInject */
	function runBlock($rootScope, $translate, $log, $state, $location, $window, ims, nuitAuth, nuitConfig, imsConfig, fuseGenerator) {
		//*******************************************
		// EVENTS
		//*******************************************
		var unregisterNuitAuthLoginEvent = $rootScope.$on(nuitAuth.EVENTS.LoginSuccess, onAuthLogin);
		var unregisterNuitAuthLogoutEvent = $rootScope.$on(nuitAuth.EVENTS.Logout, onAuthLogout);
		var unregisterTranslateChangeSuccessEvent = $rootScope.$on('$translateChangeSuccess', onTranslateChangeSuccess);
		var unregisterLocationChangeSuccessEvent = $rootScope.$on('$locationChangeSuccess', onLocationChangeSuccess);
		var unregisterStateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', onStateChangeSuccess);
		var unregisterConfigReloadEvent = $rootScope.$on(nuitConfig.EVENTS.ConfigLoaded, onConfigLoaded);
		$rootScope.$on('$destroy', onDestroy);
		var cachedStateChangeEvent = null;
		var cachedState = null;
		//*******************************************

		//*******************************************
		// INITIALIZATION
		//*******************************************
		init();
		//*******************************************

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * This event is fired whenever the user has been successfully logged-in
		 */
		function onAuthLogin() {
			nuitConfig.reset();
			nuitConfig.reload(true);
			if ($state.params && $state.params.target) {
				$location.url($state.params.target);
			} else {
				$state.go(ims.DEFAULT_LOGIN_STATE);
			}

			$translate.refresh();
		}

		/**
		 * Forwards users of ims-v1 to ims-next (same domain, TLD is kept). Not done when embedded in an iframe,
		 * as ims-next itself embeds ims-v1.
		 */
		function redirectToImsNext() {
			var host = $window.location.hostname;

			if (host.indexOf('ims-v1') < 0 || $window.self !== $window.top) {
				return false;
			}

			$window.location.replace($window.location.protocol + '//' + host.replace('ims-v1', 'ims'));
			return true;
		}

		/**
		 * This event is fired whenever the user has been successfully logged out
		 */
		function onAuthLogout(event) {
			if (redirectToImsNext()) {
				// prevents nuitAuth from reloading the page, which would cancel the redirect
				event.preventDefault();
				return;
			}

			$state.go(ims.DEFAULT_LOGOUT_STATE);
		}

		/**
		 * Gets fired whenever the language has been changed.
		 *
		 * $translate emits events only in $rootScope, so this is a workaround and broadcasts 'translateChangeSuccess'
		 * globally, so controllers can listen on it using local $scope and do not need
		 * to take care of cleaning up $rootScope
		 */
		function onTranslateChangeSuccess() {
			$rootScope.$broadcast('translateChangeSuccess');
		}

		/**
		 * Gets fired whenever the url has changed - including query parameters
		 */
		function onLocationChangeSuccess() {
			$rootScope.$broadcast('$stateChangeSuccess', $state.current, $state.params);
		}

		function onStateChangeSuccess(event, toState) {
			cachedState = null;
			cachedStateChangeEvent = null;

			if (toState.permissions) {
				if (!nuitAuth.isAuthenticated()) {
					event.preventDefault();
					$state.go(ims.DEFAULT_LOGOUT_STATE);
					return;
				}

				if (!nuitConfig.isReady()) {
					cachedState = toState;
					cachedStateChangeEvent = event;
					return;
				}

				var requiredPermissions = toState.permissions;
				var allowed = true;

				if (!Array.isArray(requiredPermissions)) {
					requiredPermissions = [requiredPermissions];
				}

				for (var i in requiredPermissions) {
					if (!imsConfig.hasPermissions(requiredPermissions[i])) {
						allowed = false;
						break;
					}
				}

				if (!allowed) {
					if(nuitConfig.isReady() && toState.name===ims.DEFAULT_LOGIN_STATE && nuitConfig.current.ims.routes.login!==ims.DEFAULT_LOGIN_STATE){
						$state.go(nuitConfig.current.ims.routes.login);
					}else {
						event.preventDefault();
						$state.go('app.errors.error-403');
					}
				}
			}
		}

		function onConfigLoaded() {
			if (!nuitConfig.current.editor) {
				nuitConfig.current.editor = {};
			}
			if (!nuitConfig.current.editor.nuitDrawStamping) {
				nuitConfig.current.editor.nuitDrawStamping = {};
			}

			try
			{
				if (!nuitConfig.current.editor.nuitDrawStamping.generators || nuitConfig.current.editor.nuitDrawStamping.generators.length === 0) {
					nuitConfig.current.editor.nuitDrawStamping.generators = nuitConfig.current.evo.editor.stamping.generators;
				}
				if (!nuitConfig.current.editor.nuitDrawStamping.tools || nuitConfig.current.editor.nuitDrawStamping.generators.tools === 0) {
					nuitConfig.current.editor.nuitDrawStamping.tools = nuitConfig.current.evo.editor.stamping.tools;
				}
			}catch(e){
				console.warn('could not move legacy stamping generator config');
			}

			if (cachedStateChangeEvent !== null || cachedState!== null) {
				onStateChangeSuccess(cachedStateChangeEvent, cachedState);
			}
		}

		/**
		 * This event is fired whenever the root scope is being destroyed.
		 */
		function onDestroy() {
			// Unregister events
			unregisterNuitAuthLoginEvent();
			unregisterNuitAuthLogoutEvent();
			unregisterTranslateChangeSuccessEvent();
			unregisterLocationChangeSuccessEvent();
			unregisterStateChangeSuccessEvent();
			unregisterConfigReloadEvent();
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Gets executed when run-block gets initialized
		 */
		function init() {
			/**
			 * Generate extra classes based on registered themes so we
			 * can use same colors with non-angular-material elements
			 */
			fuseGenerator.generate();

			/**
			 * Load config from remote server
			 */
			nuitConfig
				.reload()
				.catch(function () {
					$log.error('Error loading config');
				});
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('ims')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, IMS_ATTACHMENT_SETTINGS, IMS_SETTINGS, DOCUMENTS_SETTINGS, nuitConfigProvider) {
        // Configure location provider
        $locationProvider.html5Mode(true);

        // Configure url routing provider
        $urlRouterProvider.otherwise('/orders');

        // Configure state
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/ims/layouts/vertical-navigation.html',
                        controller: 'IndexController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: 'app/main/toolbar/views/toolbar.html',
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: 'app/main/navigation/layouts/vertical-navigation/navigation.html',
                        controller: 'NavigationController as vm'
                    }
                }
            });

		nuitConfigProvider.injectIntoDefault(IMS_ATTACHMENT_SETTINGS);
		nuitConfigProvider.injectIntoDefault(IMS_SETTINGS);
		nuitConfigProvider.injectIntoDefault(DOCUMENTS_SETTINGS);
    }
})();

(function () {
	'use strict';

	angular
		.module('ims')
		.controller('IndexController', IndexController);

	var isIFrameInitialized = false;

	/** @ngInject */
	function IndexController($state, $stateParams, $scope, $rootScope, $document, $mdDialog, nuitAuth, nuitConfig, $urlService, $window, $translate, imsNextChannel) {
		var vm = this;

		if(window.self !== window.top){
			vm.contentOnly = $window.sessionStorage.getItem('mode') === 'content';
		}else{
			vm.contentOnly = false;
		}

		//*******************************************
		// EVENTS
		//*******************************************
		var unregisterViewContentAnimationEndedEvent = $scope.$on('$viewContentAnimationEnded', onViewContentAnimationEnded);
        $scope.$on(nuitConfig.EVENTS.ConfigLoaded, onConfigLoaded);

		//*******************************************
		// NAVIGATION SYNC WITH IMS NEXT
		//*******************************************
		if(!isIFrameInitialized) {
			imsNextChannel.channel.addEventListener('navigation', function (location) {
				var decodedLocation = decodeURIComponent(location);
				$rootScope.$apply(function () {
					cancelOpenDialogs();
					if (decodedLocation !== $urlService.url()) {
						$urlService.url(decodedLocation, true);
					}
				});
			});

			imsNextChannel.channel.addEventListener('locale', function (locale) {
				$translate.use(locale);
			});

			var lastSentUrl = null;
			$rootScope.$on('$stateChangeSuccess', function () {
				var newUrl = $urlService.url();
				if (newUrl !== lastSentUrl && imsNextChannel.channel.$.status === 'connected') {
					imsNextChannel.channel.navigation(encodeURIComponent(newUrl));
					lastSentUrl = newUrl;
				}
			});

			isIFrameInitialized = true;
		}

		//*******************************************
		// METHODS
		//*******************************************
		/**
		 * Cancels every open dialog, e.g. when the embedding host (ims next) navigates away from the current view.
		 */
		function cancelOpenDialogs() {
			var openDialogCount = $document[0].querySelectorAll('.md-dialog-container').length;

			for (var i = 0; i < openDialogCount; i++) {
				$mdDialog.cancel();
			}
		}

		//*******************************************
		// EVENT HANDLER
		//*******************************************
		/**
		 * Gets fired whenever a view has been loaded
		 * @param event
		 */
		function onViewContentAnimationEnded(event) {
			if (event.targetScope.$id === $scope.$id) {
				// Remove the splash screen
				$rootScope.$broadcast('msSplashScreen::remove');

				// Unregister event handler
				unregisterViewContentAnimationEndedEvent();
			}
		}
        /**
         * This event is fired whenever the config is being reloaded.
         * @param {Object} event
         * @param {Object} config
         */
        function onConfigLoaded(event, config) {
            if(nuitAuth.isAuthenticated()) {
                if(config.ims && config.ims.enabled === false) {
                    nuitAuth.logout();
                    $state.go('app.login');
                }
            }
        }
	}
})();

(function () {
	'use strict';

	angular
		.module('ims')
		.config(config);

	/** @ngInject */
	function config($provide, $compileProvider, $logProvider, msNavigationServiceProvider, nuitConfigProvider, nuitThemeProvider, nuitApiProvider) {
		//*******************************************
		// COMPILING
		//*******************************************
		// Required for smart productions in order to open urls without a protocol
		$compileProvider.aHrefSanitizationWhitelist(/./);
		//*******************************************

		//*******************************************
		// LOGGING
		//*******************************************
		$logProvider.debugEnabled(true);
		//*******************************************

		//*******************************************
		// TEXT-ANGULAR SETTINGS
		//*******************************************
		$provide.decorator('taOptions', ['$delegate', function (taOptions) {
			taOptions.toolbar = [
				['bold', 'italics', 'underline', 'ul', 'ol', 'quote', 'html']
			];
			return taOptions;
		}]);

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('orders', {
			title: 'Auftragsabwicklung',
			group: true,
			translate: 'ORDERMANAGEMENT.ORDERMANAGEMENT_NAV',
			weight: 10,
			hidden: function () {
				return nuitConfigProvider.getCurrent().ims.orders.enabled === false
					&& nuitConfigProvider.getCurrent().ims.accounting.enabled === false
					&& nuitConfigProvider.getCurrent().ims.proposals.enabled === false;
			}
		});

		msNavigationServiceProvider.saveItem('production', {
			title: 'Produktion',
			group: true,
			translate: 'PRODUCTION.PRODUCTION_NAV',
			weight: 20,
			hidden: function () {
				return nuitConfigProvider.getCurrent().ims.planning.enabled === false
					&& nuitConfigProvider.getCurrent().ims.productionEasy.enabled === false
					&& nuitConfigProvider.getCurrent().ims.machines.enabled === false
					&& nuitConfigProvider.getCurrent().ims.productionOrders.enabled === false
					&& nuitConfigProvider.getCurrent().ims.queue.enabled === false;
			}
		});

		msNavigationServiceProvider.saveItem('accounting', {
			title: 'Rechnungswesen',
			group: true,
			translate: 'ACCOUNTING.ACCOUNTING_NAV',
			weight: 25,
			hidden: function () {
				return nuitConfigProvider.getCurrent().ims.accounting.enabled === false
			}
		});

		msNavigationServiceProvider.saveItem('partners', {
			title: 'Handelspartner',
			group: true,
			translate: 'PARTNERS.PARTNERS_NAV',
			weight: 30,
			hidden: function () {
				return nuitConfigProvider.getCurrent().ims.companies.enabled === false
					&& nuitConfigProvider.getCurrent().ims.suppliers.enabled === false
					&& nuitConfigProvider.getCurrent().ims.companies.admin.enabled === false;
			}
		});
		msNavigationServiceProvider.saveItem('transport', {
			title: 'Transport',
			group: true,
			translate: 'TRANSPORT.TRANSPORT_NAV',
			weight: 30,
			hidden: function () {
				return nuitConfigProvider.getCurrent().ims.transport.enabled === false;
			}
		});

		msNavigationServiceProvider.saveItem('merchandising', {
			title: 'Warenwirtschaft',
			group: true,
			translate: 'MERCHANDISING.MERCHANDISING_NAV',
			weight: 40,
			hidden: function () {
				return nuitConfigProvider.getCurrent().ims.products.enabled === false
					&& nuitConfigProvider.getCurrent().ims.materials.enabled === false;
			}
		});

		msNavigationServiceProvider.saveItem('controlling', {
			title: 'Controlling',
			group: true,
			translate: 'CONTROLLING.CONTROLLING_NAV',
			weight: 50,
			hidden: function () {
				return nuitConfigProvider.getCurrent().ims.controllingSales.enabled === false
					&& nuitConfigProvider.getCurrent().ims.materialControlling.enabled === false
					&& nuitConfigProvider.getCurrent().ims.usersControlling.enabled === false;
			}
		});

		msNavigationServiceProvider.saveItem('devices', {
			title: 'Devices',
			group: true,
			translate: 'DEVICES.DEVICES_NAV',
			weight: 60,
			hidden: function () {
				return nuitConfigProvider.getCurrent().ims.printer.enabled === false;
			}
		});

		msNavigationServiceProvider.saveItem('system', {
			title: 'System',
			group: true,
			translate: 'SYSTEM.SYSTEM_NAV',
			weight: 70,
			hidden: function () {
				return nuitConfigProvider.getCurrent().ims.users.enabled === false
					&& nuitConfigProvider.getCurrent().ims.system.enabled === false
					&& nuitConfigProvider.getCurrent().ims.roles.enabled === false
					&& nuitConfigProvider.getCurrent().ims.sales.enabled === false
					&& nuitConfigProvider.getCurrent().ims.profiles.enabled === false;
			}
		});

		msNavigationServiceProvider.saveItem('admin', {
			title: 'Admin',
			group: true,
			translate: 'ADMIN.ADMIN_NAV',
			weight: 100,
			hidden: function () {
				return nuitConfigProvider.getCurrent().admin.translations.enabled === false
					&& nuitConfigProvider.getCurrent().admin.clients.enabled === false
					&& nuitConfigProvider.getCurrent().admin.environment.enabled === false
					&& nuitConfigProvider.getCurrent().admin.documents.enabled === false;
			}
		});

		//*******************************************
		// API ROUTES
		//*******************************************
		// Machines
		nuitApiProvider.register('machines.bending-machines', 'machine/bendingmachines', {allow: ['get', 'post'], versions: [2]});
		nuitApiProvider.register('machines.bending-machines.one', 'machine/bendingmachines/:id', {allow: ['get', 'put', 'delete'], versions: [2]});
		nuitApiProvider.register('machines.bending-machines.brand', 'machine/brands/bending', {allow: ['get']});
		// v2 scopes definitions per domain; the v1 alias is not ported.
		nuitApiProvider.register('machines.bending-machines.brand.v2', 'machine/v2/bendingmachines/definitions/types', {allow: ['get']});

		nuitApiProvider.register('machine.bending-machines.material', 'machine/bendingmachines/:id/materials', {allow: ['get'], versions: [2]});
		nuitApiProvider.register('machine.bending-machines.material.one', '/material/materials/:materialId/bendings/machines/:bendingMachineId', {allow: ['post', 'put', 'delete']});
		nuitApiProvider.register('materials.bendings', '/material/materials/:id/bendings', {allow: ['get']});

		nuitApiProvider.register('machines.coil-machines', 'machine/coilmachines', {allow: ['get', 'post'], versions: [2]});
		nuitApiProvider.register('machines.coil-machines.brands', 'machine/brands/coil', {allow: ['get']});
		nuitApiProvider.register('machines.coil-machines.brands.v2', 'machine/v2/coilmachines/definitions/types', {allow: ['get']});
		nuitApiProvider.register('machines.coil-machines.cutModes', 'machine/cutmodes', {allow: ['get']});
		nuitApiProvider.register('machines.coil-machines.cutModes.v2', 'machine/v2/coilmachines/definitions/cutmodes', {allow: ['get']});
		nuitApiProvider.register('machines.coil-machines.blankOptions.v2', 'machine/v2/coilmachines/definitions/blankoptions', {allow: ['get']});
		nuitApiProvider.register('machines.coil-machines.one', 'machine/coilmachines/:id', {allow: ['get', 'put', 'delete'], versions: [2]});
		nuitApiProvider.register('machines.coil-machines.one.jobs', 'machine/coilmachines/:id/machinejobs', {allow: ['delete'], versions: [2]});

		nuitApiProvider.register('machines.punching-machines', 'machine/punchingmachines', {allow: ['get', 'post'], versions: [2]});
		nuitApiProvider.register('machines.punching-machines.one', 'machine/punchingmachines/:id', {allow: ['get', 'put', 'delete'], versions: [2]});
		nuitApiProvider.register('machine.punching-machines.material', 'machine/punchingmachines/:id/materials', {allow: ['get'], versions: [2]});
		// v1 has no brand endpoint (brands are static in PunchingMachineService).
		nuitApiProvider.register('machines.punching-machines.brands.v2', 'machine/v2/punchingmachines/definitions/types', {allow: ['get']});
		// v1 only - production-v2 returns the program status with the production profile.
		nuitApiProvider.register('machine.punching-machines.status', 'production/productionprofiles/:id/punchingmachine', {allow: ['get']});

		// Orders
		nuitApiProvider.register('orders.all', 'shop/orders', {allow: ['get']});
		nuitApiProvider.register('orders.all.v2', 'shop/v2/orders', {allow: ['get']});
		nuitApiProvider.register('order.detail', 'shop/orders/:id', {allow: ['get', 'put', 'delete']});
		nuitApiProvider.register('order.create', 'shop/orders', {allow: ['post']});
		nuitApiProvider.register('order.attachment', 'image/attachments/order', {allow: ['post']});
		nuitApiProvider.register('order.profile.add', 'shop/orders/:id/profile', {allow: ['post']});
		nuitApiProvider.register('order.product.add', 'shop/orders/:id/product', {allow: ['post']});
		nuitApiProvider.register('order.special.add', 'shop/orders/:id/special', {allow: ['post']});
		//nuitApiProvider.register('document.update', 'shop/orders/documents', {allow: ['put']});
		nuitApiProvider.register('order.status', 'shop/config/orders/status', {allow: ['get', 'post']});
		nuitApiProvider.register('order.status.one', 'shop/config/orders/status/:id', {allow: ['get', 'put', 'delete']});
		nuitApiProvider.register('order.export', 'exchange/shop/orders', {allow: ['get']});

		nuitApiProvider.register('offer.all', 'shop/offers', {allow: ['get']});
		nuitApiProvider.register('offer.all.v2', 'shop/v2/offers', {allow: ['get']});
		nuitApiProvider.register('offer.detail', 'shop/offers/:id', {allow: ['get', 'put', 'delete']});
		nuitApiProvider.register('offer.profile.add', 'shop/offers/:id/profile', {allow: ['post']});
		nuitApiProvider.register('offer.product.add', 'shop/offers/:id/product', {allow: ['post']});
		nuitApiProvider.register('offer.special.add', 'shop/offers/:id/special', {allow: ['post']});
		nuitApiProvider.register('offer.status', 'shop/config/orders/status', {allow: ['get', 'post']});
		nuitApiProvider.register('offer.status.one', 'shop/config/orders/status/:id', {allow: ['get', 'put', 'delete']});

		// Profiles
		nuitApiProvider.register('profiles.update.one', 'production/profiles/:id', {allow: ['put'], versions:[{number:2, path:'/v2/profile'}]});
		nuitApiProvider.register('profiles.update.multiple', 'production/profiles', {allow: ['put'], versions:[{number:2, path:'/v2/profile'}]});

		// Images
		nuitApiProvider.register('products.image', 'images/products', {allow: ['post']});
		nuitApiProvider.register('products.attachment', '/attachments/products', {allow: ['post']});
		nuitApiProvider.register('env.image', 'images/env', {allow: ['post']});

		nuitApiProvider.register('images', 'images', {allow: ['get']});
		nuitApiProvider.register('environments.all', '/auth/environments', {allow: ['get']});
		nuitApiProvider.register('environments.one', '/environment/:id', {allow: ['get','put']});
		nuitApiProvider.register('user.count', 'auth/countusers', {allow: ['get']});


		nuitApiProvider.register('signup', '/auth/email/signup', {allow: ['post']});

		//*******************************************
		// DEFAULT CONFIG
		//*******************************************
		var config = {
			languages: ['EN'],
			decimals: {
				materials: {
					blank: 3,
					hem: 3,
					length: 3,
					thickness: 2,
					weight: 2
				}
			}
		};
		nuitConfigProvider.injectIntoDefault(config);

		//*******************************************
		// THEMING CONFIGURATION
		//*******************************************
		var themePalette = {
			name: 'fuse-paleblue',
			options: {
				'50': '#ececee',
				'100': '#c5c6cb',
				'200': '#9ea1a9',
				'300': '#7d818c',
				'400': '#5c616f',
				'500': '#3c4252',
				'600': '#353a48',
				'700': '#2d323e',
				'800': '#262933',
				'900': '#1e2129',
				'A100': '#c5c6cb',
				'A200': '#9ea1a9',
				'A400': '#5c616f',
				'A700': '#2d323e',
				'contrastDefaultColor': 'light',
				'contrastDarkColors': '50 100 200 A100',
				'contrastStrongLightColors': '300 400'
			}
		};
		var cidanPalette = {
			name: 'cidan-green',
			options: {
				'50': '#ecf3d1',
				'100': '#d9e8a3',
				'200': '#c6dc75',
				'300': '#b3d147',
				'400': '#a0c519',
				'500': '#789413',
				'600': '#50630d',
				'700': '#283106',

				'800': '#000',
				'900': '#000',
				'A100': '#b3d147',
				'A200': '#a0c519',
				'A400': '#789413',
				'A700': '#50630d',
				'contrastDefaultColor': 'light',
				'contrastDarkColors': '50 100 200 A100',
				'contrastStrongLightColors': '300 400'
			}
		};
		var cidanPaletteBlue = {
			name: 'cidan-blue',
			options: {
				'50': '#e3eff5',
				'100': '#c7e0ea',
				'200': '#aad0e0',
				'300': '#8ec1d5',
				'400': '#72b1cb',
				'500': '#568598',
				'600': '#395966',
				'700': '#1c2c33',

				'800': '#000',
				'900': '#000',
				'A100': '#c7e0ea',
				'A200': '#8ec1d5',
				'A400': '#72b1cb',
				'A700': '#568598',
				'contrastDefaultColor': 'light',
				'contrastDarkColors': '50 100 200 A100',
				'contrastStrongLightColors': '300 400'
			}
		};

		var defaultTheme = {
			primary: {
				name: 'fuse-paleblue',
				hues: {
					'default': '700',
					'hue-1': '500',
					'hue-2': '600',
					'hue-3': '400'
				}
			},
			accent: {
				name: 'cidan-blue',
				hues: {
					'default': '400',
					'hue-1': '500',
					'hue-2': '300',
					'hue-3': '200'
				}
			},
			warn: {
				name: 'red'
			},
			background: {
				name: 'grey',
				hues: {
					'default': 'A100',
					'hue-1': 'A100',
					'hue-2': '100',
					'hue-3': '300'
				}
			}
		};
		nuitThemeProvider.sanitizePalette(themePalette.options);
		nuitThemeProvider.insertPalette(themePalette);
		nuitThemeProvider.sanitizePalette(cidanPalette.options);
		nuitThemeProvider.insertPalette(cidanPalette);
		nuitThemeProvider.sanitizePalette(cidanPaletteBlue.options);
		nuitThemeProvider.insertPalette(cidanPaletteBlue);
		nuitThemeProvider.insertTheme(defaultTheme, 'default');

		// Quickfix for materialdialog. If you find a better solution, feel free to implement it
		nuitThemeProvider.insertTheme(defaultTheme, 'nuit');
	}

})();

(function () {
	'use strict';

	angular
		.module('ims')
		.constant('DOCUMENTS_SETTINGS',
			{
				documents: {
					logo: ''
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('ims')
		.constant('IMS_ATTACHMENT_SETTINGS',
			{
				ims: {
					attachments:{
						acceptedMimeTypes: [],
						maxSize: 5242880
					}
				}
			});
}());

(function () {
	'use strict';

	angular
		.module('app.production.easy', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.production.easy', {
				url: '/production/easy'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('production.easy', {
			title: 'easy',
			icon: 'icon-fast-forward',
			state: 'app.production.easy',
			translate: 'PRODUCTION_EASY.PRODUCTION_EASY_NAV',
			weight: 40,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.productionEasy.enabled;
			}
		});
        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
            ims: {
                productionEasy: {
                    enabled: false
                }
            }
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.partners.suppliers', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.partners.suppliers', {
				url: '/suppliers'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('partners.suppliers', {
			title: 'suppliers',
			icon: 'icon-truck',
			state: 'app.partners.suppliers',
			translate: 'SUPPLIERS.SUPPLIERS_NAV',
			weight: 30,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.suppliers.enabled;
			}
		});
        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
            ims: {
                suppliers: {
                    enabled: false
                }
            }
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.dashboard', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.dashboard', {
				url: '/dashboard'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('dashboard', {
			title: 'dashboard',
			icon: 'icon-tile-four',
			state: 'app.dashboard',
			translate: 'DASHBOARD.DASHBOARD_NAV',
			weight: 1,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.dashboard.enabled;
			}
		});
        //*******************************************
        
        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
            ims: {
                dashboard: {
                    enabled: false
                }
            }
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.controlling.sales', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.controlling.sales', {
				url: '/sales'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('controlling.sales', {
			title: 'sales',
			icon: 'icon-chart-line',
			state: 'app.controlling.sales',
			translate: 'CONTROLLING.SALES_NAV',
			weight: 10,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.controllingSales.enabled;
			}
		});
        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
            ims: {
                controllingSales: {
                    enabled: false
                }
            }
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.controlling.material', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock($stateProvider, msNavigationServiceProvider, nuitConfigProvider) {
		//*******************************************
		// STATES
		//*******************************************
		$stateProvider
			.state('app.controlling.material', {
				url: '/controlling/material'
			});
        //*******************************************

		//*******************************************
		// NAVIGATION
		//*******************************************
		msNavigationServiceProvider.saveItem('controlling.material', {
			title: 'material',
			icon: 'icon-chart-pie',
			state: 'app.controlling.material',
			translate: 'CONTROLLING.MATERIAL_NAV',
			weight: 20,
			hidden: function () {
				return !nuitConfigProvider.getCurrent().ims.materialControlling.enabled;
			}
		});
        //*******************************************

        //*******************************************
		// SETTINGS
		//*******************************************
		var settings = {
            ims: {
                materialControlling: {
                    enabled: false
                }
            }
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

(function () {
	'use strict';

	angular
		.module('app.admin.operations', [])
		.config(configBlock);

	/** @ngInject */
	function configBlock(nuitConfigProvider) {
		//*******************************************
		// SETTINGS
		//*******************************************
		// The operations module itself is implemented in ims-next. Only the
		// configuration path is registered here so the module toggle
		// (admin.operations.enabled) exists in the environment config.
		var settings = {
			admin: {
				operations: {
					enabled: false
				}
			}
		};
		nuitConfigProvider.injectIntoDefault(settings);
		//*******************************************
	}
}());

angular.module("ims").run(["$templateCache", function($templateCache) {$templateCache.put("app/ims/components/nuit-select.by.id.html","<md-select ng-change=\"vm.selectionChanged()\" ng-model=\"vm.currentId\" ng-required=\"vm.required\"><md-option \nng-value=\"entity.id\" ng-repeat=\"entity in vm.list track by entity.id\" ng-transclude>{{vm.formatEntity(entity)}}\n</md-option></md-select>");
$templateCache.put("app/ims/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/ims/layouts/vertical-navigation.html","<div ng-if=\"!vm.contentOnly\" layout=\"column\" flex><div id=\"layout-vertical-navigation\" class=\"template-layout\" \nlayout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" \nmd-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex \nlayout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar>\n<md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div>\n<md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div><nuit-footer></nuit-footer></div><div ng-if=\"vm.contentOnly\" \nid=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-toolbar style=\"display:none\" id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/ims/components/ims-multilang/ims-multilang.component.html","<div layout=\"row\" flex><md-input-container flex><label translate=\"MATERIAL.NAME\">Name</label><input type=\"text\" \nname=\"name\" ng-model=\"vm.material.name[vm.selectedLanguage]\" ng-disabled=\"!vm.material.custom_name\" \naria-label=\"Material Name\"></md-input-container><md-input-container><label translate=\"APP.LANG\">Lang</label><md-select \nng-model=\"vm.selectedLanguage\"><md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span \nclass=\"text-uppercase\">{{ lang }}</span></md-option></md-select></md-input-container></div>");
$templateCache.put("app/ims/components/nuit-connection/nuit-connection.html","<h2 translate=\"{{vm.header}}\"></h2><md-select ng-model=\"vm.type\" ng-change=\"vm.changeType(vm.type)\" \nng-required=\"vm.requireAll\"><md-option ng-value=\"null\"><span translate=\"EXCHANGE.TYPE_NONE\"></span></md-option>\n<md-option ng-repeat=\"type in vm.connectionTypes\" ng-value=\"type\" class=\"text-uppercase\">{{type.name}}</md-option>\n</md-select><div layout=\"row\" flex ng-if=\"vm.type!==null\"><md-input-container flex ng-if=\"vm.hasPath\"><label \ntranslate=\"EXCHANGE.PATH\">Host</label><input type=\"text\" name=\"connection_path\" ng-model=\"vm.config.path\" \nng-required=\"vm.requireAll\"></md-input-container><md-input-container flex ng-if=\"vm.hasContentType\"><label \ntranslate=\"EXCHANGE.CONTENT_TYPE\">Host</label><input type=\"text\" name=\"content_type\" ng-model=\"vm.config.contentType\" \nng-required=\"vm.requireAll\"></md-input-container></div><div layout=\"row\" flex ng-if=\"vm.config.conn!==null\">\n<md-input-container flex ng-if=\"vm.isDefined(vm.configCopy.conn.host)\"><label translate=\"EXCHANGE.CONNECTION_HOST\">Host\n</label><input type=\"text\" name=\"connection_host\" ng-model=\"vm.config.conn.host\" aria-label=\"Host\" \nng-required=\"vm.requireAll\"></md-input-container><md-input-container flex \nng-if=\"vm.isDefined(vm.configCopy.conn.port)\"><label translate=\"EXCHANGE.CONNECTION_PORT\">Host</label><input \ntype=\"text\" name=\"connection_host\" ng-model=\"vm.config.conn.port\" aria-label=\"Host\" ng-required=\"vm.requireAll\">\n</md-input-container></div><div layout=\"row\" flex ng-if=\"vm.isDefined(vm.configCopy.conn.path)\"><md-input-container \nflex><label translate=\"EXCHANGE.CONNECTION_PATH\">Path</label><input type=\"text\" name=\"connection_path\" \nng-model=\"vm.config.conn.path\" aria-label=\"User\" ng-required=\"vm.requireAll\"></md-input-container></div><div \nlayout=\"row\" flex ng-if=\"vm.isDefined(vm.configCopy.conn.user) && vm.isDefined(vm.configCopy.conn.pwd)\">\n<md-input-container flex ng-if=\"vm.isDefined(vm.configCopy.conn.user)\"><label translate=\"EXCHANGE.CONNECTION_USER\">User\n</label><input type=\"text\" name=\"connection_user\" ng-model=\"vm.config.conn.user\" aria-label=\"User\" \nng-required=\"vm.requireAll\"></md-input-container><md-input-container flex ng-if=\"vm.isDefined(vm.configCopy.conn.pwd)\">\n<label translate=\"EXCHANGE.CONNECTION_PASSWORD\">Password</label><input type=\"password\" name=\"connection_password\" \nng-model=\"vm.config.conn.pwd\" aria-label=\"Password\" ng-required=\"vm.requireAll\"></md-input-container></div><div flex \nng-if=\"vm.configCopy.conn!==null && vm.isDefined(vm.configCopy.conn.disableEPSV)\" layout=\"row\" \nlayout-align=\"start center\"><label translate=\"EXCHANGE.CONNECTION_DISABLE_EPSV\" class=\"mr-20\">Host</label><md-checkbox \nclass=\"no-label\" ng-model=\"vm.config.conn.disableEPSV\" ng-required=\"vm.requireAll\"></md-checkbox></div><div \nlayout=\"column\" flex ng-if=\"vm.configCopy.conn!==null\"><md-input-container flex \nng-if=\"vm.isDefined(vm.configCopy.conn[attribute])\" ng-repeat=\"attribute in vm.customAttributes\"><label>\n{{(\'EXCHANGE.CONNECTION_\' + attribute.toUpperCase()) | translate}}</label><input \ntype=\"{{::attribute.toLowerCase().indexOf(\'pwd\')!==-1?\'password\':\'text\'}}\" ng-model=\"vm.config.conn[attribute]\" \naria-label=\"Host\" ng-required=\"vm.requireAll\"></md-input-container></div>");
$templateCache.put("app/ims/components/nuit-exchange-connection/nuit-exchange-connection.html","<h2 translate=\"{{vm.header}}\"></h2><md-select ng-model=\"vm.type\" ng-change=\"vm.changeType(vm.type)\"><md-option \nng-value=\"null\"><span translate=\"EXCHANGE.TYPE_NONE\"></span></md-option><md-option \nng-repeat=\"type in vm.connectionTypes\" ng-value=\"type\" class=\"text-uppercase\">{{type.name}}</md-option></md-select><div\n layout=\"row\" flex layout-wrap><nuit-field parent=\"vm.config\" field=\"field\" ng-repeat=\"field in vm.attributes\" \nflex=\"100\" layout=\"row\"></nuit-field><nuit-field parent=\"vm.config.conn\" field=\"field\" \nng-repeat=\"field in vm.connectionAttributes\" flex=\"100\" layout=\"row\"></nuit-field></div>");
$templateCache.put("app/ims/components/nuit-favorites/nuit-favorites.html","<div layout-align=\"start center\" layout=\"row\" class=\"ml-10 pb-0\" \nng-if=\"vm.favorites !== undefined && vm.favorites.length > 0\"><div \nng-if=\"vm.selectedFavorite === 0 || vm.selectedFavorite == undefined\"><md-icon class=\"mh-8\" \nmd-font-icon=\"icon-star-outline\"></md-icon></div><div \nng-if=\"vm.selectedFavorite !== 0 && vm.selectedFavorite != undefined\"><md-icon class=\"mh-8 md-accent\" \nmd-font-icon=\"icon-star\"></md-icon></div><div ng-if=\"vm.favorites.length === 1\" class=\"mb-8\"><md-switch \nng-model=\"vm.selectedFavorite\" ng-true-value=\"{{vm.favorites[0].weight}}\" ng-false-value=\"0\" class=\"mt-24\"><span \ntranslate=\"MATERIAL.FAVORITE\">Favorisieren</span></md-switch></div><md-input-container ng-if=\"vm.favorites.length > 1\" \nstyle=\"width: 150px\"><label translate=\"MATERIAL.FAVORITE\">Favorisieren</label><md-select \nng-model=\"vm.selectedFavorite\" md-on-close=\"vm.onFavChange()\"><md-option>{{\'APP.NONE\' | translate}}</md-option>\n<md-option ng-repeat=\"fav in vm.favorites track by fav.weight \" ng-value=\"fav.weight\"><span>\n{{fav.name | nuitTranslate}}</span></md-option></md-select></md-input-container></div>");
$templateCache.put("app/ims/components/nuit-field/nuit-field.html","<div ng-switch=\"vm.field.type\" flex layout=\"row\"><md-input-container flex ng-switch-when=\"select\"><label>\n{{vm.field.translation | translate}}</label><md-select ng-model=\"vm.parent[vm.field.name]\" ng-change=\"vm.hasChanged()\">\n<md-option ng-repeat=\"value in vm.field.values\" ng-value=\"value\">{{vm.formatName(value)}}</md-option></md-select>\n</md-input-container><div ng-switch-when=\"array\" flex class=\"grey-100-bg\" layout=\"column\"><div flex>\n{{vm.field.translation | translate}}</div><div ng-repeat=\"data in vm.parent[vm.field.name]\" layout=\"row\" flex>\n<nuit-field parent=\"data\" field=\"format\" on-change=\"vm.hasChanged()\" \nng-repeat=\"format in vm.field.array_objects.fields\" flex></nuit-field></div><md-button ng-click=\"vm.addDataEntry()\" \nflex><label translate=\"APP.ADD\"></label></md-button></div><div ng-switch-when=\"object\" flex class=\"grey-100-bg mb-10\" \nlayout=\"column\"><label class=\"mb-40\">{{vm.field.translation | translate}}</label><nuit-field \nparent=\"vm.parent[vm.field.name]\" field=\"field\" ng-repeat=\"field in vm.field.fields\" flex=\"100\" layout=\"row\">\n</nuit-field></div><md-input-container flex ng-switch-default><label>{{vm.field.translation | translate}}</label><input\n type=\"{{vm.field.type}}\" name=\"{{vm.field.name}}\" ng-model=\"vm.parent[vm.field.name]\" ng-change=\"vm.hasChanged()\">\n</md-input-container></div>");
$templateCache.put("app/ims/components/nuit-fields/nuit-fields.html","<div layout=\"column\" flex><h3 flex ng-if=\"!vm.isPrimitiveType(vm.field.type)\">{{vm.field.translation | translate}}</h3>\n<nuit-field flex ng-if=\"vm.isPrimitiveType(vm.field.type)\" parent=\"vm.parent\" field=\"vm.field\" \non-change=\"vm.hasChanged()\"></nuit-field><div flex ng-repeat=\"field in vm.field.fields\"><nuit-fields \nng-if=\"vm.field.fields\" parent=\"vm.parent[vm.field.name]\" field=\"field\" on-change=\"vm.hasChanged()\"></nuit-fields>\n</div></div>");
$templateCache.put("app/ims/components/nuit-profile-preview/nuit-profile-preview.html","<div class=\"nuit-profile-preview\" style=\"position:relative;display:inline-block\"><ng-transclude></ng-transclude></div>");
$templateCache.put("app/ims/components/nuit-stamp/nuit-stamp.html","<div class=\"b m-10\"><table><tbody><tr><td class=\"text-center text-bold\" colspan=\"2\"><span \ntranslate=\"EDITOR.STAMPING_HEADER\">Punching</span> ({{vm.internalPunch.meta.area.id}})</td></tr><tr><td><span \ntranslate=\"PROFILE.TOOL\"></span><span>:</span></td><td class=\"text-center\">\n{{vm.internalPunch.tool.id}} ({{vm.internalPunch.tool.sizeId}})</td></tr><tr><td class=\"text-left\"><md-icon \nmd-font-icon=\"icon-menu-down\" class=\"s24\"></md-icon>{{vm.internalPunch.y | nuitUnit:\'length\'}}</td><td \nclass=\"text-left\"><md-icon md-font-icon=\"icon-menu-right\" class=\"s24\"></md-icon>\n{{vm.internalPunch.first | nuitUnit:\'length\'}} | {{vm.internalPunch.meta.distBetweenStamps | nuitUnit:\'length\'}}x{{vm.internalPunch.amount}}\n</td></tr><tr></tr></tbody></table></div>");
$templateCache.put("app/ims/components/nuit-stamps/nuit-stamps.html","<div layout=\"row\" layout-align=\"left center\"><div layout=\"row\"><nuit-stamp stamp=\"stamp\" \nng-repeat=\"stamp in vm.stamps track by $index\"></nuit-stamp></div></div>");
$templateCache.put("app/ims/components/nuit-teaser-machine/nuit-teaser-machine.html","<div class=\"text-bold grey-100-bg pl-4\" style=\"padding-left: 2px\" translate=\"{{vm.data.header}}\"></div><image \nclass=\"mt-10\" src=\"{{vm.data.imageUrl}}\" http-src=\"{{vm.data.imageUrl}}\" \nfallback-src=\"assets/images/avatars/profile.jpg\"></image><div class=\"mt-10 mb-10\" translate=\"{{vm.data.details}}\">\n</div><md-button class=\"md-raised md-accent md-accent-bg text-truncate\" ng-click=\"vm.openLink()\"><span \ntranslate=\"APP.DETAILS\"></span></md-button>");
$templateCache.put("app/ims/components/vue-frame/vue-frame.component.html","<iframe style=\"width: 100%; height: 100%; overflow:hidden\" iframe-onload=\"vm.iframeLoaded\" src=\"{{::vm.location()}}\">\n</iframe>");
$templateCache.put("app/ims/dialogs/csv.import/csv.import.html","<md-dialog aria-label=\"CSV Import\" id=\"csv-import-dialog\"><form id=\"colorUploadForm\" name=\"vm.importForm\" \nng-submit=\"vm.submit()\" novalidate enctype=\"multipart/form-data\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"{{ vm.title }}\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><input type=\"file\" \nname=\"{{vm.fileName}}\" ng-if=\"!vm.isLoading\" onchange=\"vm.setFile()\"><md-progress-circular ng-if=\"vm.isLoading\" \nmd-mode=\"indeterminate\"></md-progress-circular></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\"><md-button \nclass=\"md-warn\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nclass=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"vm.importForm.$invalid || vm.formData === null\"><span \ntranslate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/ims/dialogs/editor/editor-dialog.html","<md-dialog class=\"editor-dialog\" aria-label=\"Select material\"><md-toolbar layout=\"column\" class=\"md-accent\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n<span translate=\"PROFILE.EDIT\">Profil bearbeiten</span></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"APP.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div ng-if=\"vm.errors.length > 0\" layout=\"row\" \nlayout-align=\"space-between center\" class=\"errors\"><div layout=\"row\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"error in vm.errors\"><div flex=\"noshrink\" class=\"ph-10 pv-5\">{{error}}</div>\n</div></div><span flex></span></div><md-dialog-content class=\"md-dialog-content\" style=\"padding: 0\" layout=\"column\" \nlayout-fill><nuit-editor ng-if=\"!vm.useNewEditor()\" editor-config=\"vm.config\" \nopen-profile-dialog=\"vm.allowOpen?vm.openProfile:undefined\" \nsave-profile-dialog=\"vm.allowSave?vm.saveProfile:undefined\" \nselect-material-dialog=\"(vm.showMaterials?vm.showMaterialDialog:null)\" validate=\"vm.validate\" flex></nuit-editor>\n<iframe ng-if=\"vm.useNewEditor()\" name=\"iframe\" id=\"editor-iframe\" src=\"{{vm.editorLocation()}}\" \nstyle=\"border:none;background: white; width: 100%; height: 100%\" iframe-onload=\"vm.iframeLoaded\"></iframe>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" class=\"bt\"><span></span><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.submit()\" class=\"md-accent md-raised\" \naria-label=\"SAVE\" ng-disabled=\"!vm.materialValid()\"><span translate=\"APP.SAVE\">SELECT</span></md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/ims/dialogs/evo.version/evo.version.html","<md-dialog><form name=\"vm.form\"><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"MAINTENANCE.CHANGE_EVO_VERSION\"></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content class=\"p-0\"><div layout=\"column\" layout-margin><div layout=\"row\" \nng-if=\"vm.inProgress\" layout-align=\"space-between center\" flex><div flex></div><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div flex></div></div><div layout=\"row\" flex \nng-if=\"!vm.inProgress\"><md-input-container flex><label>Evo Version</label><md-select \nng-model=\"vm.environment.evoVersion\"><md-option ng-repeat=\"entry in vm.evoVersions\" ng-value=\"entry.value\">\n{{entry.key?(entry.key | translate):entry.label}}</md-option></md-select></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.inProgress\"><div layout=\"row\">\n<md-button class=\"md-raised\" ng-click=\"vm.cancel()\" type=\"reset\"><span translate=\"APP.CANCEL\"></span></md-button>\n<md-button ng-disabled=\"vm.form.$invalid || vm.inProgress\" class=\"md-raised\" ng-click=\"vm.submit()\"><span \ntranslate=\"APP.CONFIRM\"></span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/ims/dialogs/folder.copy/folder.copy.html","<md-dialog><form name=\"vm.form\"><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"MAINTENANCE.COPY_ENV_FOLDERS\"></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content class=\"p-0\"><div layout=\"column\" layout-margin><div layout=\"row\" \nng-if=\"vm.inProgress\" layout-align=\"space-between center\" flex><div flex></div><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div flex></div></div><div layout=\"row\" \nng-if=\"!vm.inProgress\"><md-input-container class=\"md-block p-0\" md-no-float ng-if=\"vm.environments.length\" flex>\n<md-label translate=\"MAINTENANCE.FROM_ENV\">from env</md-label><md-select id=\"from_env\" ng-model=\"vm.fromEnv\" required \nname=\"environment\"><md-select-header class=\"select-header p-10\"><input id=\"search_from\" ng-model=\"searchText\" \ntype=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search\"><md-icon \nng-show=\"searchText && searchText.length>0\" md-font-icon=\"icon-close\" ng-click=\"searchText=\'\';\"></md-icon>\n</md-select-header><md-option \nng-if=\"searchText===\'\' || searchText===undefined || env.name.toLowerCase().indexOf(searchText.toLowerCase())>=0\" \nng-repeat=\"env in vm.environments track by env.id\" ng-value=\"env.id\">{{env.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block p-0\" md-no-float ng-if=\"vm.environments.length\" flex><md-label\n translate=\"MAINTENANCE.TO_ENV\">to env</md-label><md-select id=\"to_env\" ng-model=\"vm.toEnv\" required \nname=\"environment\"><md-select-header class=\"select-header p-10\"><input id=\"search_to\" ng-model=\"searchText\" \ntype=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search\"><md-icon \nng-show=\"searchText && searchText.length>0\" md-font-icon=\"icon-close\" ng-click=\"searchText=\'\';\"></md-icon>\n</md-select-header><md-option \nng-if=\"searchText===\'\' || searchText===undefined || env.name.toLowerCase().indexOf(searchText.toLowerCase())>=0\" \nng-repeat=\"env in vm.environments track by env.id\" ng-value=\"env.id\">{{env.name}}</md-option></md-select>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" \nng-if=\"!vm.inProgress\"><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"vm.cancel()\" type=\"reset\"><span \ntranslate=\"APP.CANCEL\"></span></md-button><md-button ng-disabled=\"vm.form.$invalid || vm.inProgress\" class=\"md-raised\" \nng-click=\"vm.submit()\"><span translate=\"APP.CONFIRM\"></span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/ims/dialogs/glb/glb.html","<md-dialog aria-label=\"3D model\"><md-dialog-content class=\"md-dialog-content\" layout=\"column\" \nlayout-align=\"center center\" layout-fill style=\"padding:0\"><div ng-if=\"vm.loading\" class=\"m-8\" layout=\"column\" \nlayout-align=\"center center\" style=\"width:500px;height:500px\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-if=\"vm.error\" class=\"m-8\" layout=\"column\" layout-align=\"center center\" \nstyle=\"width:500px;height:500px\"><md-icon md-font-icon=\"icon-alert\" class=\"red-500-fg s48\"></md-icon><span \nclass=\"mt-8\" translate=\"APP.ERROR_LOADING\">Could not load the 3D model.</span></div><model-viewer \nng-if=\"vm.src && !vm.error\" model-viewer-src=\"vm.src\" camera-controls auto-rotate shadow-intensity=\"0\" \norientation=\"0deg 0deg 180deg\" style=\"display:block;width:500px;height:500px;--poster-color:transparent\">\n</model-viewer></md-dialog-content></md-dialog>");
$templateCache.put("app/ims/dialogs/image/image.html","<md-dialog><md-dialog-content class=\"md-dialog-content\" layout=\"column\" layout-align=\"center center\" layout-fill><img \nnuit-doc-src=\"{{vm.image}}\" alt=\"\" fallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\" \nclass=\"w-500 m-8\"></md-dialog-content></md-dialog>");
$templateCache.put("app/ims/dialogs/order.special/order.special.html","<md-dialog aria-label=\"Special Controller\" id=\"order-special\"><form name=\"specialForm\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ORDER.SPECIAL\">Spezialposition</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout=\"column\"><md-input-container flex><label translate=\"PRODUCT.NAME\"></label><input required type=\"text\" \nng-model=\"vm.special.title\"></md-input-container><md-input-container flex><label translate=\"PRODUCT.REMARK\"></label>\n<input type=\"text\" ng-model=\"vm.special.remark\"></md-input-container></div><div layout=\"row\"><md-input-container flex>\n<label translate=\"SALES.QUANTITY\"></label><input required type=\"number\" ng-model=\"vm.special.quantity\">\n</md-input-container><md-input-container flex><label><span translate=\"PRODUCT.BASE_PRICE\"></span>\n ({{vm.config.localization.currency.symbol}})</label><input required type=\"number\" ng-model=\"vm.special.basePrice\">\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\"><md-button \nclass=\"md-raised\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.submit()\" ng-disabled=\"!specialForm.$valid\"><span translate=\"APP.SAVE\">SUBMIT</span>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/ims/dialogs/registration/signup.html","<md-dialog id=\"signup-dialog\" style=\"width:400px\"><md-toolbar class=\"md-accent-bg pl-24\" layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"vm.person.id == null\"><span class=\"title\" translate=\"APP.SIGNUP\"></span></div>\n</md-toolbar><form style=\"margin-top:20px\" name=\"vm.personForm\" novalidate ng-model-options=\"{debounce:200}\" \nng-submit=\"vm.savePerson()\"><md-content><div layout=\"column\" layout-margin><div class=\"error\" ng-if=\"vm.error\" \nlayout=\"row\" layout-align=\"center start\"><p translate=\"MESSAGE.ERROR\"></p></div><md-input-container \nng-if=\"vm.languages.length > 1\" flex><label translate=\"APP.LANG\">Lang</label><md-select class=\"mb-20\" \nng-model=\"vm.locale\" required><md-option ng-repeat=\"lang in vm.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">\n{{ lang }}</span></md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"ACCOUNT.USER_EMAIL\">Email</label><input required type=\"email\" name=\"email\" ng-model=\"vm.email\">\n</md-input-container><md-input-container flex ng-if=\"vm.roles.length > 0\"><label translate=\"ACCOUNT.USER_ROLE\">Role\n</label><md-select ng-model=\"vm.roleId\" required><md-option ng-repeat=\"role in vm.roles track by role.id\" \nng-value=\"role.id\" ng-if=\"vm.roleType===role.type\">{{ role.name[vm.translation.language]}}</md-option></md-select>\n</md-input-container></div></md-content><md-dialog-actions><div layout=\"row\" layout-align=\"space-between start\">\n<md-button class=\"md-raised\" ng-click=\"vm.hide()\" translate=\"APP.CANCEL\">Cancel</md-button><md-button \nng-if=\"!vm.deletedUser\" class=\"md-warn md-raised\" ng-disabled=\"!vm.personForm.$valid || vm.loadingDeletedUser\" \ntype=\"submit\" translate=\"APP.SAVE\">Save</md-button><md-button ng-if=\"vm.deletedUser\" class=\"md-warn md-raised\" \ntype=\"submit\" translate=\"APP.RESTORE\" ng-disabled=\"!vm.personForm.$valid || vm.loadingDeletedUser\">Restore</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/ims/dialogs/user.selection/user.selection.html","<md-dialog style=\"height:95vh; width:40vw; min-width:600px\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.dialogConfig.header | translate}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content class=\"toolbar ph-24 pv-10 bb\" \nstyle=\"overflow: visible\" layout=\"row\" layout-align=\"start center\" style=\"height: 65px\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.dialogConfig.singleSelect\"><md-checkbox \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" class=\"no-label\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nng-click=\"vm.toggleAllSelected()\"></md-checkbox></div><div flex layout=\"row\" layout-align=\"center center\">\n<nuit-selection-indicator ng-if=\"!vm.dialogConfig.singleSelect\" selection=\"vm.selection\" get-name=\"vm.getName\">\n</nuit-selection-indicator><md-icon class=\"icon s24 ml-8\" md-font-icon=\"icon-magnify\"></md-icon><input flex \nng-change=\"vm.filterAll()\" ng-model=\"vm.searchText\" ng-model-options=\"{debounce:200}\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" type=\"text\"></div><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page=\"vm.currentPage\" current-page-entities=\"vm.currentPageEntities\" entities-per-page=\"10\"></nuit-pagination>\n</div></div></div></md-content><md-dialog-content class=\"p-0\" flex><div class=\"ph-24 no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill ng-if=\"vm.users.length === 0 && !vm.isLoading\"><span \ntranslate=\"USER.NO_USERS\">Es wurden keine Produkte gefunden! Möchten sie ein</span></div><div \nclass=\"ph-24 thread unread bb pv-5\" ng-class=\"{\'selected\': vm.isSelected(user),\'green-50-bg\':vm.isSelected(user)}\" \nng-if=\"!vm.isLoading\" ng-repeat=\"user in vm.currentPageEntities track by user.id\" flex><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><md-checkbox aria-label=\"{{vm.isSelected(user) ? \'Deselect\' : \'Select\'}}\" \nclass=\"no-label\" ng-checked=\"vm.isSelected(user)\" ng-click=\"vm.toggleSelected(user, $event)\"></md-checkbox><div \nclass=\"info mr-10\" flex layout=\"column\"><span class=\"name text-truncate\" flex><nuit-person-name class=\"text-bold\" \nperson=\"user\"></nuit-person-name><nuit-email email=\"user.email\" flex layout-fill></nuit-email></span></div><div \nlayout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.isSelected(user) && user.hasNoRole\"><md-input-container flex \nng-if=\"vm.roles.length > 0\"><label translate=\"USERS.ROLES\">Roles</label><md-select ng-model=\"user.roleId\" \nng-model-options=\"{\'trackby\':\'$value.id\'}\"><md-option ng-repeat=\"role in vm.roles track by role.id\" \nng-show=\"role.type===0\" ng-value=\"role.id\">{{ role.name | nuitTranslate }}</md-option></md-select></md-input-container>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\">\n<md-button class=\"md-raised\" ng-click=\"vm.cancel()\" type=\"reset\"><span>{{vm.dialogConfig.cancel | translate}}</span>\n</md-button><md-button class=\"md-raised\" ng-click=\"vm.submit()\" ng-disabled=\"vm.getSelected().length===0\"><span>\n{{vm.dialogConfig.confirm | translate}}</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/ims/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/ims/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/ims/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/ims/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/components/nuit-address/nuit-address.html","<div class=\"address-field\"><div class=\"person\" ng-if=\"vm.person\"><nuit-person-name person=\"vm.person\">\n</nuit-person-name></div><div style=\"white-space: pre-line\">\n{{vm.addressCopy | nuitAddressFormatter:vm.addressFormat:vm.addressFormatByCountry:true:\'countryCode\'}}</div></div>");
$templateCache.put("app/core/components/nuit-date-search/nuit-date-search.html","<div class=\"pl-10\" layout=\"row\" layout-align=\"start center\" id=\"NuitDateSearch\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.dateSearch.enabled\" ng-click=\"vm.toggleDateFilter()\"></md-checkbox><md-button \nid=\"dateFilterToggleButton\" class=\"m-0 font-size-12 mr-10\" layout=\"row\" \nng-click=\"vm.dateSearch.enabled = true;vm.toggleStartEnd();vm.onChange()\"><div class=\"mr-10\" translate=\"APP.PERIOD\">\n</div><div ng-class=\"{\'grey-500-fg\':!vm.dateSearch.enabled,\'text-bold\':vm.dateSearch.enabled}\"><span>\n{{vm.dateSearch.startTimestamp/1000 | nuitDatetime:\'date\'}}</span> - <span>\n{{vm.dateSearch.endTimestamp/1000 | nuitDatetime:\'date\'}}</span></div></md-button><div \nstyle=\"top:88px;right:50px; z-index: 60\" ng-if=\"vm.selectStartAndEnd\" layout=\"row\" \nclass=\"datePickerRange md-whiteframe-2dp\"><div class=\"mr-10\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"mv-5\">{{\'APP.START\' | translate}}</div><md-calendar ng-model=\"vm.startFilterDate\" \nng-change=\"vm.validateDates();vm.onChange()\"></md-calendar></div><div class=\"mr-10\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"mv-5\">{{\'APP.END\' | translate}}</div><md-calendar ng-model=\"vm.endFilterDate\" \nng-change=\"vm.validateDates();vm.onChange()\"></md-calendar></div></div></div>");
$templateCache.put("app/core/components/nuit-backend-pagination/nuit-backend-pagination.html","<div layout=\"row\" layout-align=\"center center\"><div flex><span class=\"page-info\">\n{{vm.getStartIndex()}} - {{vm.getEndIndex()}} <span translate=\"PAGINATION.OF\">of</span> {{ vm.getEntitiesCount() }}\n</span></div><div><md-button class=\"md-icon-button\" style=\"margin: 0 !important\" aria-label=\"First Page\" \nng-disabled=\"!vm.allowPrevPage()\" ng-if=\"vm.allowSkipping\" ng-click=\"vm.getFirstPage()\"><md-icon \nmd-font-icon=\"icon-chevron-double-left\"></md-icon><md-tooltip><span translate=\"PAGINATION.FIRST_PAGE\">Previous</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button arrow\" style=\"margin: 0 !important\" aria-label=\"Previous\" \nng-disabled=\"!vm.allowPrevPage()\" ng-click=\"vm.prevPage()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n<md-tooltip><span translate=\"PAGINATION.PREVIOUS\">Previous</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button arrow\" style=\"margin: 0 !important\" aria-label=\"Next\" ng-disabled=\"!vm.allowNextPage()\" \nng-click=\"vm.nextPage()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"PAGINATION.NEXT\">Next</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" \nstyle=\"margin: 0 !important\" aria-label=\"Last Page\" ng-disabled=\"!vm.allowNextPage()\" ng-if=\"vm.allowSkipping\" \nng-click=\"vm.getLastPage()\"><md-icon md-font-icon=\"icon-chevron-double-right\"></md-icon><md-tooltip><span \ntranslate=\"PAGINATION.LAST_PAGE\">Next</span></md-tooltip></md-button></div></div>");
$templateCache.put("app/core/components/nuit-filters/nuit-filters.component.html","<div layout=\"column\" ng-if=\"vm.show\"><md-input-container ng-repeat=\"filter in vm.filters\" flex \nstyle=\"margin-bottom: 0px; height: 40px\"><label>{{ filter.name | nuitTranslate }}</label><input type=\"text\" \nng-model=\"vm.filterValues[filter.id]\" ng-if=\"filter.inputType === \'string\'\" ng-change=\"vm.filterChanged(filter)\"> \n<input type=\"number\" ng-model=\"vm.filterValues[filter.id]\" ng-if=\"filter.inputType === \'number\'\" \nng-change=\"vm.filterChanged(filter)\"><md-select ng-model=\"vm.filterValues[filter.id]\" aria-label=\"filter\" \nng-if=\"filter.inputType === \'map\'\" ng-required=\"filter.required\" ng-change=\"vm.filterChanged(filter)\"><md-option \nng-value=\"\">-</md-option><md-option ng-repeat=\"val in filter.values\" ng-value=\"val.id\">{{ val.name | nuitTranslate }}\n</md-option></md-select><md-select ng-model=\"vm.filterValues[filter.id]\" aria-label=\"filter\" \nng-if=\"filter.inputType === \'group\'\" ng-change=\"vm.filterChanged(filter)\"><md-option ng-value=\"\">-</md-option>\n<md-option ng-repeat=\"val in vm.groups[filter.id]\" ng-value=\"val.value\">{{ val.displayValue }}</md-option></md-select>\n</md-input-container><div ng-if=\"vm.filters.length>0 && !vm.hideReset\" style=\"margin-top: 10px; padding: 4px\"><a \nhref=\"#\" ng-click=\"vm.reset()\" translate=\"PRODUCTS.RESET_FILTERS\"></a></div></div>");
$templateCache.put("app/core/components/nuit-flat-profile/nuit-flat-profile.html","<div layout=\"column\"><div layout=\"row\" layout-fill layout=\"space-between center\"><form name=\"vm.flatInput\" novalidate>\n<md-input-container flex><label translate=\"PROFILE.NAME\"></label><input ng-model=\"vm.name\" type=\"text\">\n</md-input-container><md-input-container flex><label translate=\"PROFILE.REMARK\"></label><input ng-model=\"vm.remark\" \ntype=\"text\"></md-input-container><md-input-container flex><label translate=\"PROFILE.BLANK\"></label><input \nng-model=\"vm.width\" type=\"number\" nuit-unit-input=\"length\" min=\"1\"></md-input-container><md-input-container flex><label\n translate=\"PROFILE.LENGTH\"></label><input ng-model=\"vm.length\" type=\"number\" nuit-unit-input=\"length\" min=\"1\">\n</md-input-container><md-input-container flex><label translate=\"PROFILE.QUANTITY\"></label><input \nng-model=\"vm.quantity\" type=\"number\" min=\"1\"></md-input-container></form><nuit-material-selection flex \nselection=\"vm.material\" on-selected=\"vm.resetLength()\" is-required=\"false\"></nuit-material-selection><div><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.add()\" ng-disabled=\"!vm.isValid()\"><md-icon ng-if=\"!vm.inProgress\" \nmd-font-icon=\"icon-plus\"></md-icon><md-progress-circular ng-if=\"vm.inProgress\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular></md-button></div></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"mb-20\"><table class=\"dataTable border row-border hover\" style=\"text-align: center\" \nflex ng-if=\"vm.addedProfiles.length>0\"><thead><tr><th style=\"text-align: center\" translate=\"PROFILE.NAME\"></th><th \nstyle=\"text-align: center\" translate=\"PROFILE.REMARK\"></th><th style=\"text-align: center\"><span \ntranslate=\"PROFILE.BLANK\"></span> <span>({{ vm.config.units.length.symbol }})</span> <span>x</span> <span \ntranslate=\"PROFILE.LENGTH\"></span> <span>({{ vm.config.units.length.symbol }})</span></th><th \nstyle=\"text-align: center\" translate=\"PROFILE.QUANTITY\"></th><th style=\"text-align: center\" \ntranslate=\"PROFILE.MATERIAL\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"profile in vm.addedProfiles\"><td \nstyle=\"padding:0\">{{profile.name}}</td><td style=\"padding:0\">{{profile.remark}}</td><td style=\"padding:0\">\n{{profile.blank | nuitUnit:\'length\':true}}x{{profile.positions[0].length | nuitUnit:\'length\':true}}</td><td \nstyle=\"padding:0\">{{profile.positions[0].quantity}}</td><td style=\"padding:0\"><md-icon \nmd-font-icon=\"icon-checkbox-blank\" ng-style=\"{color: profile.material.colors.front.hex}\"></md-icon>\n{{profile.material.name | nuitTranslate}}</td><td style=\"padding:0\"><md-button class=\"md-icon-button\" \nng-click=\"vm.removeProfile($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr></tbody></table>\n</div><md-divider class=\"mb-20\"></md-divider></div>");
$templateCache.put("app/core/components/nuit-material-selection/nuit-material-selection.html","<div layout=\"column\" layout-align=\"start start\"><label style=\"color: rgba(0,0,0,0.38);font-size:16px;margin-left: 2px\" \nng-transclude></label><div layout=\"row\" style=\"width: 100%\"><md-icon ng-if=\"!vm._internal.name && vm.showArrows\" \nclass=\"md-accent md-nuit-theme\" md-font-icon=\"icon-arrow-right-bold\"></md-icon><md-button class=\"md-raised\" \nng-hide=\"vm.disabled === true && vm._internal === null\" ng-click=\"vm.openDialog($event)\" \nng-disabled=\"vm.disabled === true\" \nng-class=\"{\'md-accent md-nuit-theme\': vm.bgColor === true && !vm._internal.name, \'grey-200-bg\' : vm.bgColor === true && vm._internal.name}\" \naria-label=\"Material wählen\" translate-attr-aria-label=\"PROFILE.SELECT_MATERIAL\"><div layout=\"row\"><md-icon \nng-if=\"vm._internal.colors.front.hex\" md-font-icon=\"icon-checkbox-blank\" \nng-style=\"{color: vm._internal.colors.front.hex}\"></md-icon><md-tooltip><span class=\"text-size-20\" \ntranslate=\"PROFILE.SELECT_MATERIAL\">Select material</span></md-tooltip><div ng-if=\"!vm._internal.name\" \nstyle=\"overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%\"><span \ntranslate=\"PROFILE.SELECT_MATERIAL\">Select material</span></div><div ng-if=\"vm._internal.name\" \nstyle=\"overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%\" \nng-class=\"{\'black-500-fg\':vm.disabled}\">{{vm._internal.name | nuitTranslate}}</div><md-icon md-font-icon=\"icon-alert\" \nstyle=\"color: #c00; margin-left: 0.5em\" ng-if=\"vm._internal.orderable === false\"></md-icon><input style=\"display:none\" \nng-required=\"vm.isRequired\" type=\"number\" ng-model=\"vm._internal.id\"></div></md-button><md-icon \nng-if=\"!vm._internal.name && vm.showArrows\" class=\"md-accent md-nuit-theme\" md-font-icon=\"icon-arrow-left-bold\">\n</md-icon></div></div>");
$templateCache.put("app/core/components/nuit-max-count-restriction/nuit-max-count-restriction.html","<div layout=\"row\" layout-fill class=\"yellow-100-bg\" layout-padding layout-align=\"center center\"><div><md-icon \nmd-font-icon=\"icon-alert\" \nng-class=\"{\'red-500-fg\':(vm.maxCount<=vm.currentCount),\'orange-500-fg\':(vm.maxCount>vm.currentCount)}\"></md-icon></div>\n<div layout=\"column\"><div>{{vm.text | translate}}</div><div layout=\"row\" flex layout-align=\"center center\"><div \nclass=\"mr-10\"><span translate=\"APP.CURRENT_COUNT\"></span>: <span class=\"text-bold\">{{ vm.currentCount }}</span></div>\n<div><span translate=\"APP.MAX_COUNT\"></span>: <span class=\"text-bold\">{{ vm.maxCount }}</span></div></div></div><div>\n<md-button class=\"md-raised md-accent\" translate=\"APP.DETAILS\" ng-click=\"vm.openLink()\">Details</md-button></div></div>");
$templateCache.put("app/core/components/nuit-pagination/nuit-pagination.html","<div layout=\"row\" layout-align=\"center center\"><div flex><span class=\"page-info\">\n{{vm.getStartIndex()}} - {{vm.getEndIndex()}} <span translate=\"PAGINATION.OF\">of</span> {{ vm.getEntitiesCount() }}\n</span></div><div><md-button class=\"md-icon-button\" style=\"margin: 0 !important\" aria-label=\"First Page\" \nng-disabled=\"!vm.allowPrevPage()\" ng-if=\"vm.allowSkipping\" ng-click=\"vm.getFirstPage()\"><md-icon \nmd-font-icon=\"icon-chevron-double-left\"></md-icon><md-tooltip><span translate=\"PAGINATION.FIRST_PAGE\">Previous</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button arrow\" style=\"margin: 0 !important\" aria-label=\"Previous\" \nng-disabled=\"!vm.allowPrevPage()\" ng-click=\"vm.prevPage()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n<md-tooltip><span translate=\"PAGINATION.PREVIOUS\">Previous</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button arrow\" style=\"margin: 0 !important\" aria-label=\"Next\" ng-disabled=\"!vm.allowNextPage()\" \nng-click=\"vm.nextPage()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"PAGINATION.NEXT\">Next</span></md-tooltip></md-button><md-button class=\"md-icon-button arrow\" \nstyle=\"margin: 0 !important\" aria-label=\"Last Page\" ng-disabled=\"!vm.allowNextPage()\" ng-if=\"vm.allowSkipping\" \nng-click=\"vm.getLastPage()\"><md-icon md-font-icon=\"icon-chevron-double-right\"></md-icon><md-tooltip><span \ntranslate=\"PAGINATION.LAST_PAGE\">Next</span></md-tooltip></md-button></div></div>");
$templateCache.put("app/core/components/nuit-person-name/nuit-person.name.html","{{ vm.person.title!==null ? vm.person.title + \" \" + vm.person.firstName + \" \" + vm.person.lastName : vm.person.firstName + \" \" + vm.person.lastName }}");
$templateCache.put("app/core/components/nuit-pos-number/nuit-pos-number.html","<span class=\"bg\" ng-if=\"vm.number\"><span># {{vm.number}} </span></span>");
$templateCache.put("app/core/components/nuit-product-positions/nuit-product-positions.html","<ng-form name=\"productForm\"><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\" \nng-if=\"vm.showBasePrice && vm.showPrices && !vm.isBox()\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"PROFILE.BASE_PRICE\">Length</span></span></div></th><th class=\"secondary-text\" \nng-if=\"vm.isProfile() && !vm.isBox()\"><div class=\"table-header\"><span class=\"column-title\"><span \ntranslate=\"PROFILE.LENGTH\">Length</span> ({{ vm.config.units.length.symbol }})</span></div></th><th \nclass=\"secondary-text\" ng-repeat=\"attribute in vm.positionAttributes\"><div class=\"table-header\"><span \nclass=\"column-title\"><span>{{ attribute.name | nuitTranslate }}</span></span></div></th><th class=\"secondary-text\" \nng-if=\"vm.showPrices\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PROFILE.SINGLE_PRICE\">Einzelpreis\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PROFILE.QUANTITY\">Menge</span></div></th><th class=\"secondary-text\" ng-if=\"vm.showPrices\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PROFILE.POSITION_PRICE\">Positionspreis</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.showPrices && !vm.isBox()\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PROFILE.TOTAL_PRICE\">Preis</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat-start=\"position in vm.product.positions track by $index\" \nng-if=\"position.state !== \'DELETED\' || vm.softDelete !== true\"><td \nng-show=\"$first && vm.showBasePrice && vm.showPrices && !vm.isBox()\" \nrowspan=\"{{ vm.getTableHeight() - (vm.readOnly !== true && (vm.isProfile() || vm.positionAttributes.length > 0) ? 1 : 0) }}\">\n<input name=\"basePrice\" type=\"number\" ng-model=\"vm.product.basePrice\" onfocus=\"this.select()\" \nng-blur=\"vm.updateProduct(vm.product, productForm)\" ng-enter=\"vm.updateProduct(vm.product, productForm)\" \nng-disabled=\"vm.isReadOnly(\'basePrice\')\" ng-required=\"$first && vm.showBasePrice && vm.showPrices\">\n {{\'\' | nuitCurrency}}</td><td ng-if=\"vm.isProfile() && !vm.isBox()\"><md-icon class=\"mr-5\" \nng-if=\"vm.isProfileLengthFixed()\" style=\"color: grey\" md-font-icon=\"icon-lock\"><md-tooltip><span \ntranslate=\"PRODUCT.PROFILE_LENGTH_CONSTANT\"></span></md-tooltip></md-icon><md-input-container><input \nname=\"pos_attr_profile_{{$index}}\" type=\"number\" ng-min=\"{{vm.baseProduct.data.length.min || 0}}\" \nng-max=\"{{vm.baseProduct.data.length.max}}\" ng-model=\"position.length\" aria-label=\"n\" onfocus=\"this.select()\" \nng-blur=\"vm.updateProduct(vm.product, productForm)\" ng-disabled=\"!vm.canEditLength()\" nuit-unit-input=\"length\" \nng-enter=\"vm.updateProduct(vm.product, productForm)\" required><div \nng-messages=\"productForm[\'pos_attr_profile_\'+$index].$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\"><span traslate=\"APP.REQUIRED_FIELD\">Pflichtfeld</span></div><div ng-message=\"min, max\" \nclass=\"text-center\"><span>{{vm.baseProduct.data.length.min | nuitUnit:\'length\':true }}<span \nng-if=\"vm.baseProduct.data.length.min !== undefined && vm.baseProduct.data.length.max\">&nbsp;-&nbsp;</span>\n{{ vm.baseProduct.data.length.max | nuitUnit:\'length\':true }}</span></div></div></md-input-container></td><td \nng-repeat=\"attribute in vm.positionAttributes\"><md-input-container class=\"md-block\"><input \nng-model=\"position.attributes[attribute.id]\" ng-change=\"vm.updateProduct(vm.product, productForm)\" \nname=\"pos_attr_{{$parent.$index}}_{{$index}}\" type=\"number\" required nuit-unit-input=\"length\" \nng-min=\"attribute.restrictions.min\" ng-max=\"attribute.restrictions.max\" ng-disabled=\"vm.isReadOnly(\'attributes\')\" \naria-label=\"n\" onfocus=\"this.select()\" class=\"text-right\"><div \nng-messages=\"productForm[\'pos_attr_\'+$parent.$index+\'_\'+$index].$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Pflichtfeld</span></div><div ng-message=\"min, max\" \nclass=\"text-center\"><span>{{attribute.restrictions.min | nuitUnit:\'length\':true }}<span \nng-if=\"attribute.restrictions.min !== undefined && attribute.restrictions.max\">&nbsp;-&nbsp;</span>\n{{ attribute.restrictions.max | nuitUnit:\'length\':true }}</span></div></div></md-input-container></td><td \nng-if=\"vm.showPrices\" class=\"text-center\"><span>{{ position.priceForOne | nuitCurrency }}</span></td><td>\n<md-input-container><input type=\"number\" name=\"quantity_{{$index}}\" min=\"1\" \nmax=\"{{vm.getMaxQuantity(vm.product, position)}}\" step=\"1\" ng-model=\"position.quantity\" aria-label=\"n\" \nonfocus=\"this.select()\" ng-blur=\"vm.updateProduct(vm.product, productForm)\" ng-disabled=\"!vm.canEditQuantity()\" \nng-enter=\"vm.updateProduct(vm.product, productForm)\" required><div \nng-messages=\"productForm[\'quantity_\'+$index].$error\" ng-show=\"productForm[\'quantity_\'+$index].$touched\" role=\"alert\">\n<div ng-message=\"min\"><span translate=\"CART.MIN_ERROR\">Value too low.</span></div><div ng-message=\"max\"><span \ntranslate=\"CART.MAX_ERROR\">Value too high.</span></div></div></md-input-container></td><td ng-if=\"vm.showPrices\" \nclass=\"text-center\"><span>{{ position.price | nuitCurrency }}</span></td><td \nng-if=\"$first && vm.showPrices && !vm.isBox()\" \nrowspan=\"{{ vm.getTableHeight() - (vm.readOnly !== true && (vm.isProfile() || vm.positionAttributes.length > 0) ? 1 : 0) }}\" \nclass=\"text-center\"><span>{{ vm.product.price | nuitCurrency }}</span></td><td class=\"text-right\"><md-icon \nclass=\"red-500-fg\" md-font-icon=\"icon-alert\" ng-if=\"position.warnings.length > 0\"><md-tooltip><span \ntranslate=\"{{\'CART_WARNING_\' + position.warnings[0].code}}\"></span></md-tooltip></md-icon><md-button \nng-if=\"(position.remark === undefined || position.remark === null) && vm.config.evo.cart.productPositionRemarks\" \nng-disabled=\"vm.product._dirty === true || vm.isReadOnly(\'remarks\')\" ng-click=\"position.remark = \'\';\" \nstyle=\"margin: 0\" class=\"md-icon-button\"><md-icon class=\"green-500-fg\" md-font-icon=\"icon-comment-plus-outline\">\n</md-icon><md-tooltip><span translate=\"CART.ADD_COMMENT\"></span></md-tooltip></md-button><md-button \nng-if=\"!(position.remark === undefined || position.remark === null) && vm.config.evo.cart.productPositionRemarks\" \nng-click=\"position.remark = null; vm.onPositionChanged({ product: vm.product })\" \nng-disabled=\"vm.product._dirty === true || vm.isReadOnly(\'remarks\')\" style=\"margin: 0\" class=\"md-icon-button\"><md-icon \nclass=\"red-300-fg\" md-font-icon=\"icon-comment-remove-outline\"></md-icon><md-tooltip><span \ntranslate=\"CART.REMOVE_COMMENT\"></span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removePosition($index)\" aria-label=\"n\" style=\"margin: 0\" ng-disabled=\"vm.isReadOnly(\'deleting\')\" \nng-if=\"vm.product._dirty !== true && vm.product.positions.length > vm.minPositions\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button><md-button \nng-if=\"vm.product._dirty !== true && vm.config.evo.cart.productPositionMarkForCheck.enabled\" \nng-disabled=\"vm.isReadOnly(\'positionMarkForCheck\')\" class=\"md-icon-button\" \nng-click=\"vm.togglePositionMarkForCheck(position);vm.updateProduct(vm.product, productForm)\"><md-icon \nclass=\"grey-300-fg\" ng-if=\"!(position | nuitDotNotation:vm.config.evo.cart.productPositionMarkForCheck.key:false)\" \nmd-font-icon=\"icon-eye\"><md-tooltip><span translate=\"PROFILE.POSITION_MARK_FOR_CHECK\"></span></md-tooltip></md-icon>\n<md-icon class=\"orange-500-fg\" \nng-if=\"position | nuitDotNotation:vm.config.evo.cart.productPositionMarkForCheck.key:false\" md-font-icon=\"icon-eye\">\n</md-icon></md-button><md-button ng-if=\"vm.product._dirty !== true && vm.config.evo.cart.productPositionCheck.enabled\" \nng-disabled=\"vm.isReadOnly(\'positionCheck\')\" class=\"md-icon-button\" \nng-click=\"vm.togglePositionChecked(position);vm.updateProduct(vm.product, productForm)\"><md-icon class=\"orange-500-fg\" \nng-if=\"!(position | nuitDotNotation:vm.config.evo.cart.productPositionCheck.key:false)\" \nmd-font-icon=\"icon-alert-circle\"><md-tooltip><span translate=\"PROFILE.POSITION_CHECKED\"></span></md-tooltip></md-icon>\n<md-icon class=\"green-500-fg\" ng-if=\"position | nuitDotNotation:vm.config.evo.cart.productPositionCheck.key:false\" \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon></md-button><md-progress-circular md-diameter=\"20px\" \nstyle=\"margin: 0\" ng-if=\"vm.product._dirty\"></md-progress-circular></td></tr><tr ng-repeat-end \nng-if=\"position.remark !== undefined && position.remark !== null && vm.config.evo.cart.productPositionRemarks\"><td \nclass=\"text-left\" colspan=\"{{ vm.getRemarkColspan() }}\"><div layout=\"row\" layout-align=\"center center\" layout-fill>\n<md-input-container flex class=\"md-block\" style=\"margin-top: 20px\"><label translate=\"PROFILE.REMARK\">Bemerkung</label>\n<textarea name=\"remark_{{$index}}\" ng-model=\"position.remark\" rows=\"1\" md-select-on-focus onfocus=\"this.select()\" \nmd-maxlength=\"150\" maxlength=\"150\" ng-disabled=\"vm.isReadOnly(\'remarks\')\" \nng-blur=\"vm.onPositionChanged({ product: vm.product })\"></textarea><div ng-messages=\"productForm.remark.$error\" \nng-show=\"productForm[\'remark_\'+$index].$touched\" role=\"alert\"><div ng-message=\"md-maxlength\"><span \ntranslate=\"ERROR.MAX_150\">Field can\'t be longer than 150 characters.</span></div></div></md-input-container></div></td>\n<td></td></tr><tr ng-if=\"vm.readOnly !== true && !vm.isBox() && (vm.isProfile() || vm.positionAttributes.length > 0)\">\n<td colspan=\"100\" style=\"padding: 0px !important\"><div layout=\"row\" layout-align=\"center center\"><md-button \nng-if=\"vm.product._dirty !== true && vm.canAdd()\" ng-click=\"vm.addPosition()\" layout-fill><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><span translate=\"CART.ADD_POSITION\"></span></md-button><md-progress-circular \nclass=\"m-0 p-0\" md-diameter=\"24px\" ng-if=\"vm.product._dirty === true\"></md-progress-circular><md-button \nclass=\"pl-15 md-icon-button\" ng-if=\"!vm.canAdd() && vm.isProfile()\" ng-disabled=\"true\"><md-icon style=\"color: red\" \nmd-font-icon=\"icon-block-helper\"></md-icon></md-button><span class=\"pr-15\" ng-if=\"!vm.canAdd() && vm.isProfile()\" \ntranslate=\"PRODUCT.CANNOT_ADD_POSITIONS\"></span></div></td></tr></tbody></table></ng-form>");
$templateCache.put("app/core/components/nuit-product-section/nuit-product-section.html","<div class=\"ph-16 pv-15 mr-15\" layout=\"column\"><ng-form name=\"productForm\"><nuit-pos-number ng-if=\"vm.showPosNumber\" \nnumber=\"vm.product.posNumber\"></nuit-pos-number><div layout=\"row\" layout-wrap \nng-class=\"{\'ml-60\':(vm.selectable===true)}\"><div layout=\"row\" class=\"grey-100-bg p-8 mr-10 mb-10\" \nng-repeat=\"field in vm.customFields\" ng-if=\"::(field.format | nuitFormatter:vm.product).length>0\"><span class=\"mr-10\">\n{{field.name | nuitTranslate}}</span> <span class=\"text-bold\">{{field.format | nuitFormatter:vm.product:true:\'x\'}}\n</span></div></div><div layout=\"column\" flex layout-gt-sm=\"row\" class=\"product-container\" layout-align=\"space-between\" \nlayout-wrap><div layout=\"row\" layout-align=\"start top\" class=\"mb-20\"><md-checkbox class=\"md-primary\" \nng-if=\"vm.selectable === true\" ng-checked=\"vm.isSelected({ product: vm.product })\" \nng-click=\"vm.onSelectionClick({ product: vm.product, $event: $event })\" \naria-label=\"{{vm.isSelected({ product: vm.product }) ? \'Deselect\' : \'Select\'}}\" \nstyle=\"min-height: 180px; max-height:180px; margin-left: 10px; margin-right: 20px\"></md-checkbox><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"border\" layout=\"column\" layout-align=\"start center\"><div class=\"img-container\" \nlayout=\"column\" layout-align=\"center center\" width=\"170\" height=\"170\" \nng-click=\"vm.onImageClick({image: vm.product.image})\"><img fallback-src=\"assets/images/logos/logo_grau_100x100.jpg\" \nalt=\"\" http-src=\"{{ vm.product.image }}\" ng-if=\"vm.product.image\"> <img \nsrc=\"assets/images/logos/logo_grau_100x100.jpg\" width=\"170\" height=\"170\" alt=\"\" ng-if=\"!vm.product.image\"></div><a \nclass=\"p-8 edit\" ng-if=\"vm.allowEdit === true && !vm.isReadOnly(\'product\')\" href=\"#\" \nng-click=\"vm.editProduct(vm.product)\"><span translate=\"PRODUCT.EDIT\">Produkt bearbeiten</span></a></div></div><div \nflex=\"nogrow\" class=\"pl-16 pr-40 description-container\" layout=\"column\"><div class=\"tags pt-8 pb-10\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"p-8 mr-20 border red-100-bg\" ng-if=\"vm.product.warnings.length > 0\">\n<md-icon class=\"red-500-fg\" md-font-icon=\"icon-alert\"></md-icon><md-tooltip><span \ntranslate=\"{{\'CART_WARNING_\' + vm.product.warnings[0].code}}\"></span></md-tooltip></div><nuit-product-tags layout-wrap \nlayout=\"row\" layout-align=\"start start\" product=\"vm.product\"></nuit-product-tags></div><p class=\"md-title mt-0 mb-5\" \ntranslate=\"{{ vm.product.name | nuitTranslate }}\"></p><span translate=\"{{ vm.product.description | nuitTranslate }}\">\n</span><md-input-container class=\"md-block\" ng-if=\"vm.product.remark !== null\"><label translate=\"PROFILE.REMARK\">\nBemerkung</label><textarea name=\"remark\" ng-model=\"vm.product.remark\" rows=\"1\" md-select-on-focus \nonfocus=\"this.select()\" md-maxlength=\"150\" maxlength=\"150\" ng-disabled=\"vm.isReadOnly(\'remark\')\" \nng-blur=\"vm.onProductUpdated({ product: vm.product, $event: $event })\"></textarea><div \nng-messages=\"productForm.remark.$error\" ng-show=\"productForm.remark.$touched\" role=\"alert\"><div \nng-message=\"md-maxlength\"><span translate=\"ERROR.MAX_150\">Field can\'t be longer than 150 characters.</span></div></div>\n</md-input-container></div></div><div class=\"lengths\" layout=\"row\" layout-align=\"start start\" flex><div \nlayout=\"column\" flex layout=\"start start\"><nuit-product-positions product=\"vm.product\" \nread-only=\"vm.getReadOnlyPositions()\" show-prices=\"vm.showPrices\" show-base-price=\"vm.showBasePrice\" \nmin-positions=\"vm.minPositions\" max-positions=\"vm.maxPositions\" soft-delete=\"vm.softDelete\" \non-position-added=\"vm.onPositionAdded({product:product})\" \non-position-changed=\"vm.onPositionChanged({product:product})\" \non-position-removed=\"vm.onPositionRemoved({product:product, index: index})\"></nuit-product-positions><div \nclass=\"pv-8 ph-8 text-right addBox\" ng-if=\"vm.isReadOnly(\'remarkControl\') !== true\" layout=\"column\"><ul><li \nng-if=\"vm.product.remark === null || vm.product.remark === undefined\"><a href=\"#\" ng-click=\"vm.product.remark = \'\'\">\n<span translate=\"CART.ADD_REMARK\">Bemerkung hinzufügen</span></a></li><li \nng-if=\"vm.product.remark !== undefined && vm.product.remark !== null\"><a href=\"#\" \nng-click=\"vm.product.remark = null;vm.update()\"><span translate=\"CART.REMOVE_REMARK\">Bemerkung entfernen</span></a>\n</li></ul></div></div></div></div></ng-form></div>");
$templateCache.put("app/core/components/nuit-product-selection/main-sidenav.html","<div class=\"pt-8 pb-20 pl-15 pr-15\" ng-if=\"vm.filters.length > 0 || vm.listFilters.length > 0\"><div \nng-repeat=\"filter in vm.filters track by filter.id\"><md-input-container class=\"md-block\"><label>\n{{ filter.name | nuitTranslate }}</label><input type=\"text\" ng-model=\"filter.value\" ng-if=\"filter.type === \'string\'\" \nng-change=\"vm.filterChanged()\"> <input type=\"number\" ng-model=\"filter.value\" ng-if=\"filter.type === \'number\'\" \nng-change=\"vm.filterChanged()\"><md-select ng-model=\"filter.value\" aria-label=\"filter\" \nng-if=\"filter.type === \'enum\' && filter.multiple\" ng-required=\"filter.required\" multiple=\"multiple\" \nng-change=\"vm.filterChanged()\"><md-option ng-value=\"\">-</md-option><md-option ng-repeat=\"val in filter.values\" \nng-value=\"val\">{{ val }}</md-option></md-select><md-select ng-model=\"filter.value\" aria-label=\"filter\" \nng-if=\"filter.type === \'material\'\" ng-required=\"filter.required\" ng-change=\"vm.filterChanged()\"><md-option ng-value=\"\">\n-</md-option><md-option ng-repeat=\"val in filter.values\" ng-value=\"val\">{{ val }}</md-option></md-select><md-select \nng-model=\"filter.value\" placeholder=\"{{filter.name | nuitTranslate }}\" aria-label=\"filter\" \nng-if=\"filter.type === \'enum\' && !filter.multiple\" ng-required=\"filter.required\" ng-change=\"vm.filterChanged()\">\n<md-options><md-option ng-value=\"\"></md-option><md-option ng-repeat=\"val in filter.values | orderBy\" ng-value=\"val\">\n{{ val }}</md-option></md-options></md-select><md-select ng-model=\"filter.value\" \nplaceholder=\"{{filter.name | nuitTranslate }}\" aria-label=\"filter\" ng-if=\"filter.type === \'generic_materialgroup\'\" \nng-change=\"vm.filterChanged(filter)\"><md-options><md-option ng-value=\"\"></md-option><md-option \nng-repeat=\"val in vm.materialgroups\" ng-value=\"val\">{{ val.name | nuitTranslate }}</md-option></md-options></md-select>\n<md-select ng-model=\"filter.value\" placeholder=\"{{filter.name | nuitTranslate }}\" aria-label=\"filter\" \nng-if=\"filter.type === \'generic_colors\'\" ng-change=\"vm.filterChanged(filter)\"><md-options><md-option ng-value=\"\">\n</md-option><md-option ng-repeat=\"val in vm.colors | orderByNuitTranslated:\'name\'\" ng-value=\"val\" \nng-if=\"(filter.options.restrictions.indexOf(val.id) >= 0) !== filter.options.blacklist\">{{ val.name | nuitTranslate }}\n</md-option></md-options></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"filter.type === \'generic_materialgroup\' && filter.value !== undefined\"><label translate=\"APP.MATERIAL\"></label>\n<md-select ng-model=\"filter.subvalue\" placeholder=\"{{ \'APP.MATERIAL\' | translate }}\" aria-label=\"filter\" \nng-change=\"vm.filterChanged()\"><md-options><md-option ng-value=\"\"></md-option><md-option \nng-repeat=\"val in filter.materials\" ng-value=\"val\">{{ val.name | nuitTranslate }}</md-option></md-options></md-select>\n</md-input-container></div><nuit-filters class=\"m-8\" entities=\"vm.prefilteredEntities\" on-change=\"vm.filterProducts()\" \nfilters=\"vm.listFilters\" filter-values=\"vm.filterValues\" on-init=\"vm.filterControls(controls)\" hide-reset=\"true\">\n</nuit-filters></div><div ng-if=\"vm.categories.length > 0\" class=\"pb-10 pl-15 pr-15 pt-15\"><treecontrol \nclass=\"tree-classic\" tree-model=\"[vm.overviewCategory]\" options=\"vm.treeOptions\" on-selection=\"vm.showSelected(node)\" \nselected-node=\"vm.selectedCategory\" ng-if=\"vm.categories\"><span class=\"title\" translate=\"{{node.key}}\"></span>\n</treecontrol><treecontrol class=\"tree-classic\" tree-model=\"vm.categories\" options=\"vm.treeOptions\" \non-selection=\"vm.showSelected(node)\" selected-node=\"vm.selectedCategory\" ng-if=\"vm.categories\"><span class=\"title\">\n{{ node.name | nuitTranslate }}</span></treecontrol></div><md-divider ng-if=\"vm.tags.length > 0\"></md-divider><div \nng-if=\"vm.tags.length > 0\" class=\"p-15\"><div class=\"labels pt-8 pb-8\" layout=\"row\" layout-wrap><button \nclass=\"label text-truncate\" \nng-class=\"{\'md-blue-grey-500-bg\': !vm.isTagSelected(tag),\'md-red-500-bg\': vm.isTagSelected(tag)}\" \nng-repeat=\"tag in vm.tags track by tag.id\" ng-click=\"vm.toggleSelectionForTag(tag)\"><span>\n{{ tag.name | nuitTranslate }}</span></button></div></div><md-divider \nng-if=\"vm.tags.length > 0 || vm.categories.length > 0 || vm.filters.length > 0 || vm.listFilters.length > 0\" \nclass=\"mb-16\"></md-divider><div class=\"pl-15\" \nng-if=\"vm.tags.length > 0 || vm.categories.length > 0 || vm.filters.length > 0 || vm.listFilters.length > 0\"><a \nhref=\"#\" class=\"\" ng-click=\"vm.resetFilters()\"><span translate=\"PRODUCTS.RESET_FILTERS\">Reset filters</span></a></div>");
$templateCache.put("app/core/components/nuit-product-selection/main-tree.html","<ul {{options.ulclass}}><li \nng-repeat=\"node in node.{{options.nodeChildren}} | filter:filterExpression:filterComparator {{options.orderBy}}\" \nng-class=\"headClass(node)\" {{options.liclass}} set-node-to-data><i class=\"tree-branch-head\" ng-class=\"iBranchClass()\" \nng-click=\"selectNodeHead(node)\"></i>\' <i class=\"tree-leaf-head {{options.iLeafClass}}\"></i><div \nclass=\"tree-label {{options.labelClass}}\" ng-class=\"[selectedClass(), unselectableClass()]\" \nng-click=\"selectNodeLabel(node)\" tree-transclude></div><treeitem ng-if=\"nodeExpanded()\"></treeitem></li></ul>");
$templateCache.put("app/core/components/nuit-product-selection/nuit-product-selection.html","<md-content flex layout=\"row\" layout-fill><md-sidenav class=\"sidenav border-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" \nng-include=\"\'app/core/components/nuit-product-selection/main-sidenav.html\'\" ms-scroll ms-sidenav-helper flex>\n</md-sidenav><div flex layout=\"column\" class=\"md-padding products\" layout-fill><div layout=\"row\" \nlayout-align=\"center center\"><form name=\"form.search\" novalidate flex layout=\"column\" layout-fill><md-input-container \nmd-no-float class=\"md-block\" ng-model-options=\"{ debounce: 350 }\" style=\"margin:0\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input type=\"text\" ng-model=\"vm.term\" aria-label=\"n\" \nonfocus=\"this.select()\" placeholder=\"Nach Artikel suchen ...\" translate \ntranslate-attr-placeholder=\"PRODUCT.SEARCH_PLACEHOLDER\" ng-change=\"vm.searchChanged()\"></md-input-container></form>\n<nuit-pagination all-entities=\"vm.filteredProducts\" entities-per-page=\"10\" current-page=\"vm.page\" \ncurrent-page-entities=\"vm.currentPageEntities\" ng-if=\"!vm.isLoading\"></nuit-pagination></div><md-progress-linear \nng-if=\"vm.isLoading === true\" md-mode=\"indeterminate\"></md-progress-linear><md-content flex \nng-if=\"vm.isLoading !== true\" layout=\"column\" ms-scroll><md-list ng-if=\"vm.currentPageEntities.length > 0\">\n<md-list-item ng-repeat=\"product in vm.currentPageEntities track by product.id\" class=\"border-bottom product\" \nlayout=\"row\" layout-xs=\"column\" ng-click=\"vm.magnifyImage(product.image)\" flex ng-style=\"::vm.getStyle(product)\"><div \nclass=\"img-container\" layout=\"column\" layout-align=\"center center\" ng-click=\"vm.magnifyImage(product.image)\" \nng-if=\"product.image !== null\"><img fallback-src=\"assets/images/logos/logo_grau_100x100.jpg\" width=\"100\" height=\"100\" \nalt=\"\" http-src=\"{{ ::product.image }}\"></div><div class=\"img-container\" layout=\"column\" layout-align=\"center center\" \nng-click=\"vm.magnifyImage(product.image)\" ng-if=\"product.image === null\"><img \nsrc=\"assets/images/logos/logo_grau_100x100.jpg\" width=\"100\" height=\"100\" alt=\"\" http-src=\"{{ ::product.image }}\"></div>\n<div class=\"md-list-item-text\" flex><small ng-if=\"product.id\">{{::product.id}}</small><div layout=\"row\" flex><h3 \nclass=\"text-truncate\" md-highlight-text=\"vm.term\" md-highlight-flags=\"gi\" style=\"margin: 0\">\n{{ product.name | nuitTranslate }}</h3><span layout=\"row\" \nng-repeat=\"field in vm.config.evo.products.list.customFields\" class=\"mh-10\"><span \nclass=\"grey-100-bg tag-label h-34 md-list-item-text ph-10\" ng-if=\"::(field.format | nuitFormatter:product).length>0\">\n<span>{{::field.name | nuitTranslate}}</span> <span class=\"text-bold\">{{::field.format | nuitFormatter:product}}</span>\n</span></span></div><p class=\"layout-wrap\" ng-if=\"product.description\" flex>{{ product.description | nuitTranslate}}\n</p><nuit-tags><nuit-product-tags product=\"product\"></nuit-product-tags><nuit-tag-attribute \nng-if=\"product.type === \'profile\' && product.data.materials.length === 1\" \nng-repeat=\"attribute in vm.getMaterialById(product.data.materials[0]).attributes\" attribute=\"attribute\">\n</nuit-tag-attribute></nuit-tags></div><div class=\"md-secondary\" layout=\"column\" layout-align=\"center center\" \nflex=\"no-shrink\"><span class=\"font-size-18\" ng-if=\"vm.showPrices\">\n{{::(product.price ? product.price : 0) | nuitCurrency }}</span><md-button ng-if=\"product.purchasable\" \nclass=\"md-raised md-warn\" translate ng-click=\"vm.showProductDialog($event, product);\"><md-icon \nmd-font-icon=\"icon-cart\"></md-icon><span>\n{{(vm.addButtonTranslation?vm.addButtonTranslation:\"PROFILE.ADD_TO_CART\") | translate}}</span></md-button><md-button \nng-if=\"!product.purchasable\" class=\"md-raised\" translate ng-click=\"vm.showProductDialog($event, product);\"><md-icon \nclass=\"md-warn-fg\" md-font-icon=\"icon-alert\"></md-icon><span ng-if=\"!product.purchasable\" \ntranslate=\"PRODUCT.NOT_ORDERABLE\">Not pruchasable</span></md-button></div></md-list-item></md-list><div class=\"pl-10\" \nng-if=\"vm.filteredProducts.length === 0 && (vm.term || vm.term.length>0 || vm.isFiltered())\"><div \ntranslate=\"PRODUCTS.NO_RESULTS\">Ihre Suche ergab leider keine Produkttreffer.</div></div><div class=\"pl-10\" \nng-if=\"(vm.isFiltered() || (vm.term && vm.term.length > 0))\"><a href=\"\" ng-click=\"vm.resetFilters()\" \ntranslate=\"PRODUCTS.RESET_FILTER\">Setzen Sie den Suchfilter zurück</a>&nbsp;<span \ntranslate=\"PRODUCTS.TO_SHOW_ALL_PRODUCTS\">um alle Produkte anzuzeigen.</span></div></md-content></div></md-content>");
$templateCache.put("app/core/components/nuit-product-tags/nuit-product-tags.html","<nuit-tags \nng-if=\"vm.product.type === \'profile\' && vm.product.data && vm.product.data.profile.materialId !== undefined\">\n<nuit-tag-material material=\"vm.getMaterialById(vm.product.data.profile.materialId)\"></nuit-tag-material>\n<nuit-tag-attribute ng-repeat=\"attribute in vm.getMaterialById(vm.product.data.profile.materialId).attributes\" \nattribute=\"attribute\"></nuit-tag-attribute></nuit-tags><nuit-tags><nuit-tag model=\"attribute\" name-property=\"name\" \nng-repeat=\"attribute in vm.product.attributes track by attribute.id\" \nng-if=\"!attribute.restrictions.hidden && attribute.value\"></nuit-tag><nuit-tag model=\"tag\" name-property=\"name\" \nng-repeat=\"tag in vm.product.tags\"></nuit-tag><nuit-tag class=\"tag-container\" \nng-repeat=\"tag in vm.config.evo.cart.product.customTags\"><span>{{tag.name | nuitTranslate}}&nbsp;</span><strong>\n{{ tag.format | nuitFormatter: vm.product }}</strong></nuit-tag><nuit-tag-material ignoreactive=\"true\" \nng-if=\"vm.product.type === \'profile\' && !vm.product.data.profile.materialId && vm.product.data && vm.product.data.materials.length === 1\" \nmaterial=\"vm.getMaterialById(vm.product.data.materials[0])\"></nuit-tag-material><nuit-tag \nng-if=\"vm.product.type === \'profile\' && vm.product.data && vm.hasStamps(vm.product.data.profile)\"><md-icon \nclass=\"black-fg\" style=\"margin-left:4px\" md-font-icon=\"icon-image-filter-center-focus\"></md-icon><strong \nng-if=\"vm.getPunchCount(vm.product.data.profile)\">&nbsp;{{ vm.getPunchCount(vm.product.data.profile) }}</strong>\n</nuit-tag><nuit-tag ng-if=\"vm.product.type === \'profile\' && vm.product.data && vm.hasCuts(vm.product.data.profile)\">\n<md-icon class=\"black-fg\" style=\"margin-left:4px\" md-font-icon=\"icon-content-cut\"></md-icon></nuit-tag><nuit-tag \nng-if=\"vm.product.type === \'profile\' && vm.product.data && vm.isConical(vm.product.data.profile)\"><md-icon \nclass=\"black-fg\" style=\"margin-left:4px\" md-font-icon=\"icon-send\"></md-icon></nuit-tag></nuit-tags>");
$templateCache.put("app/core/components/nuit-profile-positions/nuit-profile-positions.html","<ng-form name=\"profileForm\"><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\" \nng-if=\"vm.showWeight\"><div class=\"table-header\"><span class=\"column-title text-center\"><span translate=\"APP.WEIGHT\">\nGewicht</span>&nbsp;({{ vm.config.units.weight.symbol }})</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.showPrices && !vm.isBox()\"><div class=\"table-header\"><span class=\"column-title text-center text-truncate\" \ntranslate=\"PROFILE.PRICE_PER_M\">Preis / lfm</span></div></th><th class=\"secondary-text\" ng-if=\"!vm.isBox()\"><div \nclass=\"table-header\"><span class=\"column-title text-center\"><span translate=\"PROFILE.LENGTH\">Länge</span>\n&nbsp;({{ vm.config.units.length.symbol }})</span></div></th><th class=\"secondary-text\" ng-if=\"vm.showPrices\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" translate=\"PROFILE.SINGLE_PRICE\">Einzelpreis</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title text-center\" \ntranslate=\"PROFILE.QUANTITY\">Menge</span></div></th><th class=\"secondary-text\" ng-if=\"vm.showPrices\"><div \nclass=\"table-header\"><span class=\"column-title text-center\" translate=\"PROFILE.POSITION_PRICE\">Positionspreis</span>\n</div></th><th class=\"secondary-text\" ng-if=\"vm.showPrices && !vm.isBox()\"><div class=\"table-header\"><span \nclass=\"column-title text-center\" translate=\"PROFILE.TOTAL_PRICE\">Gesamtpreis</span></div></th><th></th></tr></thead>\n<tbody><tr ng-repeat-start=\"position in vm.profile.positions track by $index\" \nng-if=\"position.state !== \'DELETED\' || vm.softDelete !== true\"><td class=\"text-right\" ng-if=\"vm.showWeight\">\n{{(position.weight ? position.weight : 0) | nuitUnit:\'weight\' }}</td><td ng-if=\"vm.showPrices && !vm.isBox()\" \nclass=\"text-right\"><span ng-if=\"!vm.canEditPrices()\">\n{{(position.pricePerUnit ? position.pricePerUnit : 0) | nuitUnit:\'runningmeter\':true:true:true | nuitCurrency }}</span>\n<md-input-container class=\"p-0 md-block\" ng-if=\"vm.canEditPrices()\" ng-init=\"oldPricePerUnit = position.pricePerUnit\">\n<input style=\"margin-right: 0 !important\" name=\"pricePerUnit-{{$index}}\" type=\"number\" min=\"0\" step=\"0.01\" \nng-model=\"position.pricePerUnit\" aria-label=\"n\" onfocus=\"this.select()\" ng-disabled=\"vm.profile._dirty\" \nng-blur=\"vm.updatePosition($index,oldPricePerUnit!==position.pricePerUnit?\'pricePerUnit\':undefined)\" \nng-enter=\"vm.updatePosition($index,oldPricePerUnit!==position.pricePerUnit?\'pricePerUnit\':undefined)\" required>\n</md-input-container></td><td class=\"text-center\" ng-if=\"!vm.isBox()\"><md-input-container class=\"p-0\" \nng-init=\"oldLength = position.length\"><input name=\"profileLength-{{$index}}\" style=\"margin-right: 0 !important\" \ntype=\"number\" ng-model=\"position.length\" min=\"{{vm.profile.material.restrictions.minLength || 0}}\" \nmax=\"{{vm.profile.material.restrictions.maxLength || 99999999}}\" ng-disabled=\"position._dirty || !vm.canEditLength()\" \naria-label=\"n\" onfocus=\"this.select()\" \nng-blur=\"vm.updatePosition($index,oldLength!==position.length?\'length\':undefined)\" \nng-enter=\"vm.updatePosition($index,oldLength!==position.length?\'length\':undefined)\" nuit-unit-input=\"length\" \nng-change=\"vm.updateInputOnChange?vm.updatePosition($index,oldLength!==position.length?\'length\':undefined):undefined\" \nng-model-options=\"{ debounce: vm.updateInputOnChange?200:0 }\" required><div \nng-messages=\"profileForm[\'profileLength-\'+$index].$error\" ng-show=\"profileForm[\'profileLength-\'+$index].$touched\" \nrole=\"alert\"><div ng-message=\"min, max\" class=\"text-center\"><span>\n{{vm.profile.material.restrictions.minLength | nuitUnit:\'length\':true }}<span \nng-if=\"vm.profile.material.restrictions.minLength !== undefined && vm.profile.material.restrictions.maxLength\">\n&nbsp;-&nbsp;</span>{{ vm.profile.material.restrictions.maxLength | nuitUnit:\'length\':true }}</span></div></div>\n</md-input-container></td><td class=\"text-right\" ng-if=\"vm.showPrices\">\n{{(position.priceForOne ? position.priceForOne : 0) | nuitCurrency }}</td><td class=\"text-center\"><ng-form \nname=\"positionForm\">&nbsp;<md-input-container class=\"p-0\" ng-init=\"oldQuantity = position.quantity\"><input \nstyle=\"margin-right: 0 !important\" name=\"quantity\" type=\"number\" min=\"1\" \nmax=\"{{vm.getMaxQuantity(vm.profile, position)}}\" step=\"1\" ng-model=\"position.quantity\" aria-label=\"n\" \nonfocus=\"this.select()\" ng-blur=\"vm.updatePosition($index,oldQuantity!==position.quantity?\'quantity\':undefined)\" \nng-enter=\"vm.updatePosition($index,oldQuantity!==position.quantity?\'quantity\':undefined)\" \nng-disabled=\"position._dirty || !vm.canEditQuantity()\" \nng-change=\"vm.updateInputOnChange?vm.updatePosition($index,oldQuantity!==position.quantity?\'quantity\':undefined):undefined\" \nng-model-options=\"{ debounce: vm.updateInputOnChange?200:0 }\" required><div ng-messages=\"positionForm.quantity.$error\" \nng-show=\"positionForm.quantity.$touched\" role=\"alert\"><div ng-message=\"min\"><span translate=\"CART.MIN_ERROR\">\nValue too low.</span></div><div ng-message=\"max\"><span translate=\"CART.MAX_ERROR\">Value too high.</span></div></div>\n</md-input-container></ng-form></td><td class=\"text-right\" ng-if=\"vm.showPrices\">\n{{(position.price ? position.price : 0) | nuitCurrency}}</td><td ng-if=\"$first && vm.showPrices && !vm.isBox()\" \nrowspan=\"{{vm.getTableHeight()}}\" class=\"text-center\">{{ vm.getProfilePositionPrice(vm.profile) | nuitCurrency}}</td>\n<td class=\"text-right\"><md-icon class=\"red-500-fg\" md-font-icon=\"icon-alert\" ng-if=\"position.warnings.length > 0\">\n<md-tooltip><span translate=\"{{\'CART_WARNING_\' + position.warnings[0].code}}\"></span></md-tooltip></md-icon><md-button \nng-if=\"(position.remark === undefined || position.remark === null) && vm.config.evo.cart.profilePositionRemarks\" \nng-disabled=\"vm.profile._dirty === true || vm.isReadOnly(\'remarks\')\" ng-click=\"position.remark = \'\';\" \nstyle=\"margin: 0\" class=\"md-icon-button\"><md-icon class=\"green-500-fg\" md-font-icon=\"icon-comment-plus-outline\">\n</md-icon><md-tooltip><span translate=\"CART.ADD_COMMENT\"></span></md-tooltip></md-button><md-button \nng-if=\"!(position.remark === undefined || position.remark === null) && vm.config.evo.cart.profilePositionRemarks\" \nng-click=\"position.remark = null; vm.onPositionChanged({ profile: vm.profile })\" \nng-disabled=\"vm.profile._dirty === true || vm.isReadOnly(\'remarks\')\" style=\"margin: 0\" class=\"md-icon-button\"><md-icon \nclass=\"red-300-fg\" md-font-icon=\"icon-comment-remove-outline\"></md-icon><md-tooltip><span \ntranslate=\"CART.REMOVE_COMMENT\"></span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removePosition($index);\" ng-if=\"vm.readOnly !== true\" aria-label=\"n\" ng-disabled=\"!vm.canRemove()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button><md-button \nng-show=\"vm.config.evo.cart.profilePositionMarkForCheck.enabled\" ng-disabled=\"vm.isReadOnly(\'positionMarkForCheck\')\" \nclass=\"md-icon-button\" ng-click=\"vm.togglePositionMarkForCheck(position);vm.updatePosition($index)\"><md-icon \nclass=\"grey-300-fg\" ng-if=\"!(position | nuitDotNotation:vm.config.evo.cart.profilePositionMarkForCheck.key:false)\" \nmd-font-icon=\"icon-eye\"><md-tooltip><span translate=\"PROFILE.POSITION_MARK_FOR_CHECK\"></span></md-tooltip></md-icon>\n<md-icon class=\"orange-500-fg\" \nng-if=\"position | nuitDotNotation:vm.config.evo.cart.profilePositionMarkForCheck.key:false\" md-font-icon=\"icon-eye\">\n</md-icon></md-button><md-button ng-show=\"vm.config.evo.cart.profilePositionCheck.enabled\" \nng-disabled=\"vm.isReadOnly(\'positionCheck\')\" class=\"md-icon-button\" \nng-click=\"vm.togglePositionChecked(position);vm.updatePosition($index)\"><md-icon class=\"orange-500-fg\" \nng-if=\"!(position | nuitDotNotation:vm.config.evo.cart.profilePositionCheck.key:false)\" \nmd-font-icon=\"icon-alert-circle\"><md-tooltip><span translate=\"PROFILE.POSITION_CHECKED\"></span></md-tooltip></md-icon>\n<md-icon class=\"green-500-fg\" ng-if=\"position | nuitDotNotation:vm.config.evo.cart.profilePositionCheck.key:false\" \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon></md-button></td></tr><tr \nng-repeat-start=\"special in vm.visibleSpecials(position)\"><td colspan=\"{{vm.getSpecialColspan()}}\" \nstyle=\"cursor:pointer\" ng-click=\"vm.addSpecial(special)\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"text-bold\">{{special.name | nuitTranslate}}&nbsp;</div><div style=\"max-width: 350px\" class=\"text-truncate\">\n{{special.remark}}</div></div></td><td rowspan=\"{{vm.showPrices?2:1}}\" class=\"mr-40\"><div layout=\"row\" \nlayout-align=\"end center\" ng-style=\"{\'margin-right\':vm.config.evo.cart.profilePositionCheck.enabled?\'55px\':0}\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.removeSpecial(position,$index);;$event.stopPropagation();\" \naria-label=\"n\" ng-disabled=\"!vm.canRemoveSpecial(special)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></td></tr><tr ng-repeat-end ng-click=\"vm.addSpecial(special)\" style=\"cursor:pointer\"><td style=\"border: 0px\" \nng-if=\"vm.showWeight && vm.showPrices\"></td><td class=\"text-right\" style=\"border: 0px\" \nng-if=\"vm.showPrices && !vm.isBox()\"><div \nng-if=\"special.pricePerUnit && special.pricePerUnit>0 && vm.isReadOnly(\'specialsPrice\')\">\n{{(special.pricePerUnit ? special.pricePerUnit : 0) | nuitUnit:\'perLengthUnitConversion\':true:true:true | nuitCurrency }}\n</div><input ng-if=\"special.pricePerUnit && special.pricePerUnit>0 && !vm.isReadOnly(\'specialsPrice\')\" \nng-model=\"special.pricePerUnit\" nuit-unit-input=\"perLengthUnitConversion\" invert=\"true\" type=\"number\" \nng-click=\"$event.stopPropagation()\"></td><td style=\"border: 0px\" ng-if=\"vm.showPrices && !vm.isBox()\"></td><td \nclass=\"text-right\" style=\"border: 0px\" ng-if=\"vm.showPrices\"><div \nng-if=\"vm.isReadOnly(\'specialsPrice\') || (special.pricePerUnit && special.pricePerUnit>0)\">\n{{special.sales.priceForOne | nuitCurrency}}</div><input \nng-if=\"!vm.isReadOnly(\'specialsPrice\') && (!special.pricePerUnit || special.pricePerUnit===0)\" \nng-model=\"special.sales.priceForOne\" type=\"number\" ng-click=\"$event.stopPropagation()\"></td><td style=\"border: 0px\" \nng-if=\"vm.showPrices\"></td><td class=\"text-right\" style=\"border: 0px\" ng-if=\"vm.showPrices\">\n{{special.sales.price | nuitCurrency}}</td></tr><tr ng-repeat-end \nng-if=\"position.remark !== undefined && position.remark !== null && vm.config.evo.cart.profilePositionRemarks\"><td \nclass=\"text-left\" colspan=\"{{vm.getRemarkColspan()}}\"><div layout=\"row\" layout-align=\"center center\" layout-fill>\n<md-input-container flex class=\"p-0 md-block\" style=\"margin-top: 20px\"><label translate=\"PROFILE.REMARK\">Bemerkung\n</label><textarea name=\"remark_{{$index}}\" ng-model=\"position.remark\" rows=\"1\" md-select-on-focus \nonfocus=\"this.select()\" md-maxlength=\"150\" maxlength=\"150\" ng-disabled=\"vm.isReadOnly(\'remarks\')\" \nng-blur=\"vm.onPositionChanged({ profile: vm.profile })\"></textarea><div ng-messages=\"profileForm.remark.$error\" \nng-show=\"profileForm[\'remark_\'+$index].$touched\" role=\"alert\"><div ng-message=\"md-maxlength\"><span \ntranslate=\"ERROR.MAX_150\">Field can\'t be longer than 150 characters.</span></div></div></md-input-container></div></td>\n<td></td></tr><tr ng-if=\"vm.readOnly !== true\"><td colspan=\"{{vm.getTableWidth()}}\" style=\"padding: 0px !important\">\n<div layout=\"row\" layout-align=\"center center\" flex style=\"text-align: left\"><div flex ng-if=\"!vm.isBox()\"><md-button \nng-if=\"vm.canAdd()\" ng-click=\"vm.addPosition(vm.profile)\" layout-fill><md-icon md-font-icon=\"icon-plus\"></md-icon><span\n translate=\"CART.ADD_LENGTH\"></span></md-button><md-progress-circular class=\"m-0 p-0\" md-diameter=\"24px\" \nng-if=\"vm.profile._dirty === true\"></md-progress-circular><div ng-if=\"vm.profile._dirty !== true\" layout=\"row\" \nlayout-align=\"center center\"><md-button style=\"margin: 0 !important\" class=\"pl-10 md-icon-button\" ng-if=\"!vm.canAdd()\" \nng-disabled=\"true\"><md-icon class=\"s16\" style=\"color: red\" md-font-icon=\"icon-block-helper\"></md-icon></md-button><span\n style=\"font-size: 0.85em !important; white-space: normal\" class=\"grey-500-fg\" \nng-if=\"!vm.canAdd() && vm.product._dirty !== true\" translate=\"PROFIL.HAS_SPECIAL\"></span></div></div><div \nng-if=\"!vm.profile._dirty && vm.config.evo.cart.allowSpecials\" class=\"mr-10\" flex><md-button \nng-if=\"vm.getProfileCount() ===1 && vm.hasMoreSpecials()\" ng-click=\"vm.addSpecial()\" layout-fill \nng-disabled=\"vm.isReadOnly(\'specials\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span translate=\"CART.SPECIAL\">\n</span></md-button><div layout=\"row\" layout-align=\"center center\"><md-button style=\"margin: 0 !important\" \nclass=\"md-icon-button\" ng-if=\"!vm.hasMoreSpecials() || vm.getProfileCount() !==1 \" ng-disabled=\"true\"><md-icon \nclass=\"s16\" style=\"color: red\" md-font-icon=\"icon-block-helper\"></md-icon></md-button><span \nstyle=\"font-size: 0.85em !important; white-space: normal\" class=\"grey-500-fg\" ng-if=\"!vm.hasMoreSpecials()\" \ntranslate=\"PROFILE.SPECIAL.ADD_END\">Keine weiteren Spezialproduktionen vorhanden</span> <span \nstyle=\"font-size: 0.85em !important; white-space: normal\" class=\"grey-500-fg\" ng-if=\"vm.getProfileCount() !==1\" \ntranslate=\"PROFILE.SPECIAL.ADD_NOT_AVAILABLE\">Keine Spezialprodution möglich wegen mehrerer Längen</span></div></div>\n</div></td></tr></tbody></table></ng-form>");
$templateCache.put("app/core/components/nuit-profile-section/nuit-profile-section.html","<div class=\"ph-16 pv-15 mr-15\" layout=\"column\" ng-class=\"{\n	 	\'selected\': vm.isSelected({ profile: vm.profile })\n	 }\">\n<ng-form name=\"profileForm\"><nuit-pos-number ng-if=\"vm.showPosNumber\" number=\"vm.profile.posNumber\"></nuit-pos-number>\n<div class=\"profile-container\" flex layout=\"column\" layout-align=\"start\" layout-align-gt-md=\"space-between\" \nlayout-gt-sm=\"row\" layout-wrap><div flex layout=\"column\" layout-gt-sm=\"row\"><div layout=\"row\"><md-checkbox \naria-label=\"{{vm.isSelected({ profile: vm.profile }) ? \'Deselect\' : \'Select\'}}\" class=\"md-primary\" \nng-checked=\"vm.isSelected({ profile: vm.profile })\" \nng-click=\"vm.onSelectionClick({ profile: vm.profile, $event: $event })\" ng-if=\"vm.selectable === true\" \nstyle=\"max-height:200px; margin-left: 10px\"></md-checkbox><div layout=\"row\" layout-gt-sm=\"column\"><div \nclass=\"img-container border editable\"><img alt=\"{{ vm.profile.name}}\" draggable=\"false\" \nfallback-src=\"assets/images/logos/logo_grau_100x100.jpg\" http-src=\"{{ vm.profile | profileImage}}\" \nng-click=\"vm.onImageClick({image: (vm.profile | profileImage)})\" width=\"200\"> <a href=\"#\" ng-if=\"!vm.offlineId\" \nui-sref=\"app.editor({cartProfile: vm.profile.id})\"><span>\n{{(vm.profile.geometry?\'CART.LOAD_PROFILE\':\'CART.CREATE_PROFILE\') | translate}}</span> </a><a href=\"#\" \nng-if=\"vm.offlineId\" ui-sref=\"app.editor({offlineProfile: vm.offlineId})\"><span translate=\"CART.LOAD_OFFLINE_PROFILE\">\nOfflineprofil laden</span></a></div><div class=\"ml-10\" layout=\"column\" layout-align=\"start start\" layout-padding \nng-show=\"vm.config.evo.cart.profileCheck\"><md-checkbox class=\"md-primary m-0\" \nng-disabled=\"vm.profile.customData.checked\" ng-model=\"vm.profile.customData.checkRequested\" ng-change=\"vm.update()\">\n<div class=\"md-truncate\" translate=\"PROFILE.CHECK_REQUESTED\"></div></md-checkbox><md-checkbox class=\"md-primary m-0\" \nng-model=\"vm.profile.customData.checked\" ng-show=\"vm.profile.customData.checkRequested\" \nng-class=\"{\n										 	\'orange-500-fg\': vm.profile.customData.checkRequested && !vm.profile.customData.checked,\n										 	\'green-500-fg\': vm.profile.customData.checked\n										 	}\" \nng-change=\"vm.update()\"><div class=\"md-truncate\" translate=\"PROFILE.CHECKED\"></div></md-checkbox></div></div></div><div\n class=\"description-container\" layout=\"column\"><div class=\"tags pt-8\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap style=\"margin-bottom: 0\"><div class=\"p-8 mr-20 border red-100-bg\" ng-if=\"vm.profile.warnings.length > 0\">\n<md-icon class=\"red-500-fg\" md-font-icon=\"icon-alert\"></md-icon><md-tooltip><span \ntranslate=\"{{\'CART_WARNING_\' + vm.profile.warnings[0].code}}\"></span></md-tooltip></div><nuit-profile-tags \nprofile=\"vm.profile\"></nuit-profile-tags></div><span class=\"grey-500-fg mt-5 mb-10\" ng-if=\"cData.visible === true\" \nng-repeat=\"cData in vm.config.evo.editor.customData track by cData.property\">\n{{ ::vm.profile.customData[cData.property][cData.nameProperty]}}</span><md-input-container class=\"mb-0\"><label \ntranslate=\"PROFILE.NAME\">Bezeichnung</label><input aria-label=\"n\" \nmaxlength=\"{{ vm.config.evo.cart.profileTitleMaxLength}}\" md-maxlength=\"{{ vm.config.evo.cart.profileTitleMaxLength}}\" \nname=\"title\" ng-blur=\"vm.onDataChanged({data: \'name\', profile: vm.profile})\" \nng-enter=\"vm.onDataChanged({data: \'name\', profile: vm.profile})\" ng-if=\"!vm.config.evo.cart.profileTitleMultiline\" \nng-model=\"vm.profile.name\" ng-required=\"vm.config.evo.cart.requireProfileTitle\" onfocus=\"this.select()\" type=\"text\">\n<textarea aria-label=\"n\" maxlength=\"{{ vm.config.evo.cart.profileTitleMaxLength}}\" \nmd-maxlength=\"{{ vm.config.evo.cart.profileTitleMaxLength}}\" name=\"title\" \nng-blur=\"vm.onDataChanged({data: \'name\', profile: vm.profile})\" ng-if=\"vm.config.evo.cart.profileTitleMultiline\" \nng-model=\"vm.profile.name\" ng-required=\"vm.config.evo.cart.requireProfileTitle\" onfocus=\"this.select()\" rows=\"1\">\n</textarea><div ng-messages=\"profileForm.title.$error\" ng-show=\"profileForm.title.$touched\" role=\"alert\"><div \nng-message=\"required\"><span traslate=\"APP.REQUIRED_FIELD\">Pflichtfeld</span></div><div ng-message=\"md-maxlength\"><span \ntranslate=\"ERROR.MAX_50\">Field can\'t be longer than 50 characters.</span></div></div></md-input-container>\n<md-input-container class=\"md-block m-0\" ng-if=\"vm.profile.remark!==null\"><label translate=\"PROFILE.REMARK\">Bemerkung\n</label><textarea maxlength=\"150\" md-maxlength=\"150\" md-select-on-focus name=\"remark\" \nng-blur=\"vm.onDataChanged({data: \'remark\', profile: vm.profile})\" ng-model=\"vm.profile.remark\" onfocus=\"this.select()\">\n</textarea><div ng-messages=\"profileForm.remark.$error\" ng-show=\"profileForm.remark.$touched\" role=\"alert\"><div \nng-message=\"md-maxlength\"><span translate=\"ERROR.MAX_150\">Field can\'t be longer than 150 characters.</span></div></div>\n</md-input-container></div></div><div class=\"lengths\" layout=\"row\" layout-align=\"start start\" flex><div \nlayout=\"column\" flex layout=\"start start\"><nuit-profile-positions profile=\"vm.profile\" \nread-only=\"vm.readOnly.positions\" show-prices=\"vm.showPrices\" show-weight=\"true\" \non-position-added=\"vm.onPositionAdded({index: index, profile: vm.profile})\" \non-position-removed=\"vm.onPositionRemoved({index: index, profile: vm.profile})\" \non-position-changed=\"vm.onPositionChanged({profile:vm.profile})\"></nuit-profile-positions><div \nclass=\"pv-16 text-right addBox\" layout=\"column\" layout-align=\"start end\"><ul><li \nng-if=\"vm.profile.remark === null || vm.profile.remark === undefined\"><a href=\"#\" \nng-click=\"vm.profile.remark = \'\'; vm.update();\"><span translate=\"CART.ADD_REMARK\">Bemerkung hinzuf&uuml;gen</span></a>\n</li><li ng-if=\"vm.profile.remark !== null && vm.profile.remark !== undefined\"><a href=\"#\" \nng-click=\"vm.profile.remark = null; vm.update();\"><span translate=\"CART.REMOVE_REMARK\">Bemerkung entfernen</span></a>\n</li></ul></div></div></div></div></ng-form></div>");
$templateCache.put("app/core/components/nuit-profile-tags/nuit-profile-tags.html","<nuit-tags><nuit-tag-material class=\"tag-container\" material=\"vm.profile.material\"></nuit-tag-material>\n<nuit-tag-cutting class=\"tag-container\" cutting=\"vm.getBlank(vm.profile)\"></nuit-tag-cutting><nuit-tag \nclass=\"tag-container\" ng-if=\"vm.profile.geometry\"><span translate=\"PROFILE.BENDINGS\"></span><strong>\n&nbsp;{{ vm.getBendings() }}</strong></nuit-tag><nuit-tag ng-if=\"vm.hasStamps(vm.profile)\"><md-icon class=\"black-fg\" \nstyle=\"margin-left:4px\" md-font-icon=\"icon-image-filter-center-focus\"></md-icon><strong \nng-if=\"vm.getPunchCount(vm.profile)\">&nbsp;{{ vm.getPunchCount(vm.profile) }}</strong></nuit-tag><nuit-tag \nng-if=\"vm.hasCuts(vm.profile)\"><md-icon class=\"black-fg\" style=\"margin-left:4px\" md-font-icon=\"icon-content-cut\">\n</md-icon></nuit-tag><nuit-tag ng-if=\"vm.isConical(vm.profile)\"><md-icon class=\"black-fg\" style=\"margin-left:4px\" \nmd-font-icon=\"icon-send\"></md-icon></nuit-tag><nuit-tag class=\"tag-container\" \nng-repeat=\"tag in vm.config.evo.cart.profile.customTags\"><span>{{tag.name | nuitTranslate}}&nbsp;</span><strong>\n{{ tag.format | nuitFormatter: vm.profile }}</strong></nuit-tag></nuit-tags>");
$templateCache.put("app/core/components/nuit-selection-indicator/nuit-selection-indicator.html","<div ng-if=\"vm.selection.getSelected().length>0\" style=\"cursor: pointer\" ng-init=\"showToolTip = false\" \nclass=\"text-bold\" ng-mouseover=\"showToolTip=true\" ng-mouseleave=\"showToolTip=false\"><div layout=\"row\" \nclass=\"green-100-bg p-5\" layout-align=\"space-between center\" style=\"min-width: 80px !important\"><span \nstyle=\"text-align: center\" flex>{{vm.selection.getSelected().length}}</span><md-icon \nng-click=\"vm.selection.deselectAll()\" md-font-icon=\"icon-close\"></md-icon></div><div ng-if=\"showToolTip && vm.getName\" \nclass=\"black-500-bg p-8\" \nstyle=\"pointer-events: none; position: absolute; transform:translate(0,10px);z-index: 10;border-radius: 4px\"><div \nclass=\"white-500-fg\" layout=\"row\" cols=\"12\" ng-repeat=\"orderId in vm.selection.getSelected()\">{{vm.getName(orderId)}}\n</div></div></div>");
$templateCache.put("app/core/components/nuit-tag/nuit-tag.component.html","<div class=\"tag\"><div class=\"tag-label\" layout=\"row\" layout-align=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\" ng-transclude></div><span>{{ $ctrl.model[$ctrl.nameProperty] | nuitTranslate }}</span> \n<strong \nng-if=\"$ctrl.model.value !== undefined && $ctrl.model.type !== \'material\'  && $ctrl.model.type!==\'length\' && $ctrl.model.type !== \'color\'\">\n&nbsp;{{ $ctrl.model.value }}</strong> <strong \nng-if=\"$ctrl.model.value !== undefined && $ctrl.model.type === \'material\'\">\n&nbsp;{{$ctrl.customData.name | nuitTranslate}}</strong> <strong \nng-if=\"$ctrl.model.value !== undefined && $ctrl.model.type === \'length\'\">\n&nbsp;{{$ctrl.model.value | nuitUnit:\'length\'}}</strong> <strong \nng-if=\"$ctrl.customData !==undefined && $ctrl.model.value !== undefined && $ctrl.model.type === \'color\'\">\n&nbsp;{{$ctrl.customData.name | nuitTranslate}}</strong></div></div>");
$templateCache.put("app/core/components/nuit-tag-attribute/nuit-tag-attribute.component.html","<div class=\"tag\" ng-if=\"$ctrl.attribute && $ctrl.attribute.restrictions.hidden !== true\"><div class=\"tag-label\"><span>\n{{ $ctrl.attribute.name | nuitTranslate }}</span> <strong>{{ $ctrl.attribute.value | nuitTranslate }}</strong></div>\n</div>");
$templateCache.put("app/core/components/nuit-tag-cutting/nuit-tag-cutting.component.html","<div class=\"tag\" ng-if=\"$ctrl.cutting\"><div class=\"tag-label\"><span translate=\"PROFILE.CUTTING\">Zuschnitt</span> \n<strong>{{ $ctrl.cutting | nuitUnit:\'length\' }}</strong></div></div>");
$templateCache.put("app/core/components/nuit-tag-material/nuit-tag-material.component.html","<div class=\"tag\" ng-if=\"$ctrl.material\" ng-style=\"$ctrl.getStyle()\"><div class=\"tag-label\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-checkbox-blank\" \nng-style=\"{color: $ctrl.material.colors.front.hex}\"></md-icon><span>{{ $ctrl.material.name | nuitTranslate }}</span>\n<md-icon md-font-icon=\"icon-alert\" style=\"color: #c00; margin-left: 0.5em\" \nng-if=\"$ctrl.material.active === false && $ctrl.ignoreActive !== true\"><md-tooltip><span \ntranslate=\"MATERIAL.NOT_ORDERABLE\"></span></md-tooltip></md-icon></div></div>");
$templateCache.put("app/core/components/nuit-tags/nuit-tags.component.html","<div class=\"tags\" layout=\"row\" layout-align=\"start start\" layout-wrap ng-transclude></div>");
$templateCache.put("app/core/dialogs/blocker/blocker.html","<md-dialog md-theme=\"nuit\" aria-label=\"Loading\" ng-click=\"vm.hide()\"><md-dialog-content class=\"md-dialog-content\"><div \nlayout=\"row\" layout-align=\"center center\"><h1 flex>{{vm.text | translate}}</h1></div></md-dialog-content></md-dialog>");
$templateCache.put("app/core/dialogs/folder-rename/folder-rename.html","<md-dialog md-theme=\"nuit\" aria-label=\"Item rename\" class=\"dialog\" flex=\"50\" flex-gt-md=\"40\"><form name=\"renameForm\" \nng-cloak ng-submit=\"vm.submit()\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>\n{{vm.header | translate}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>{{vm.caption | translate}}</label><input \nname=\"title\" ng-model=\"vm.name[vm.selectedLanguage]\" required md-autofocus><div ng-messages=\"renameForm.name.$error\" \nng-show=\"renameForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PROFILE.RENAME_NAME_REQUIRED\">Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.config.languages.length > 1\"><label translate=\"APP.LANG\">Lang</label>\n<md-select ng-model=\"vm.selectedLanguage\"><md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><div \nlayout=\"row\" layout-align=\"start center\" ng-style=\"{\'opacity\': vm.name[lang] ? 1.0 : 0.33}\"><img \nng-if=\"vm.config.evo.toolbar.languages.flags\" class=\"flag mr-10\" ng-src=\"assets/images/flags/{{ lang }}.png\"> <span \nclass=\"text-uppercase\">{{ lang }}</span></div></md-option></md-select></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-primary md-raised\" type=\"submit\" \nng-disabled=\"renameForm.$invalid\"><span>{{vm.button | translate}}</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/core/dialogs/feedback/feedback.html","<md-dialog style=\"min-width: 400px\"><md-toolbar layout=\"column\" class=\"md-accent\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n<span translate=\"FEEDBACK.HEADER\">Feedback</span></span></div></md-toolbar><md-dialog-content \nclass=\"md-dialog-content\" layout=\"row\" layout-fill flex=\"noshrink\"><ng-form name=\"vm.form\"><md-radio-group \nng-model=\"vm.userRequest\" required ng-change=\"vm.form.$setPristine();vm.form.$validate()\"><md-radio-button \nng-value=\"true\"><span translate=\"FEEDBACK.IS_USER_REQUEST\">User Request</span></md-radio-button><div layout=\"row\" \nlayout-align=\"center end\"><md-radio-button ng-value=\"false\" class=\"mb-24\"><span translate=\"FEEDBACK.IS_NOT_PRODUCIBLE\">\nNot Producible</span></md-radio-button><md-input-container flex style=\"min-width: 200px\" class=\"ml-20\"><label \ntranslate=\"FEEDBACK.CHANGE_REASON\">Change Reason</label><md-select ng-model=\"vm.feedback.noteIds\" \nng-change=\"vm.form.$setPristine();vm.form.$validate()\" multiple=\"multiple\" flex ng-disabled=\"vm.userRequest\" \nng-required=\"vm.isRequired()\"><md-option ng-repeat=\"note in vm.notes\" ng-value=\"note.noteID\">{{note.noteText}}\n</md-option></md-select></md-input-container></div></md-radio-group></ng-form></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.save()\" \nng-disabled=\"vm.isRequired() && (!vm.feedback.noteIds || vm.feedback.noteIds.length===0)\"><span translate=\"APP.SAVE\">\nSEND</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/dialogs/image/image.html","<md-dialog style=\"max-height:95vh;max-width:95vh\"><md-dialog-content ng-click=\"vm.close()\" class=\"md-dialog-content\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-content \nstyle=\"background:white;max-height:95vh;max-width:95vh\" layout=\"column\" layout-align=\"center center\" layout-fill><img \nhttp-src=\"{{vm.image}}\" alt=\"\" fallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\"></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/core/dialogs/image.upload/image.upload.html","<md-dialog aria-label=\"New Color\" id=\"system-color-dialog\"><form name=\"vm.importForm\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"IMAGE.UPLOAD\">Bild hochloaden</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nng-if=\"vm.hasMaxFileSize()\" class=\"mb-20\"><span translate=\"UPLOAD.MAX_FILE_SIZE\">Max File Size</span><span \nclass=\"text-bold ml-10\">{{vm.getMaxFileSize()}} MB, {{vm.MaxImageWidth}} x {{vm.MaxImageHeight}} px</span></div><input \ntype=\"file\" accept=\"{{vm.FileRestrictions.join(\',\')}}\" name=\"image\" ng-if=\"!vm.isLoading\" \nonchange=\"angular.element(this).scope().setFile(this.files)\"><md-progress-circular ng-if=\"vm.isLoading\" \nmd-mode=\"indeterminate\"></md-progress-circular><div class=\"red-500-fg mt-8\" \nng-if=\"!vm.isLoading && (!vm.hasProperSize() || !vm.fulfillsImageRestriction())\" translate=\"UPLOAD.NOT_SMALL_ENOUGH\">\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\"><md-button class=\"md-raised\" type=\"reset\" ng-click=\"vm.cancel()\">\n<span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button class=\"md-raised\" ng-disabled=\"!vm.isValid()\" \nng-click=\"vm.submit()\"><span translate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/core/dialogs/item-rename/item-rename.html","<md-dialog md-theme=\"nuit\" aria-label=\"Item rename\" class=\"dialog\" flex=\"100\" flex-gt-md=\"40\"><form name=\"renameForm\" \nng-cloak ng-submit=\"vm.submit()\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"{{vm.locales.header}}\">Rename profile</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"PROFILE.RENAME_NAME\">Enter name\n</label><input name=\"title\" ng-model=\"vm.name[vm.selectedLanguage]\" required md-autofocus><div \nng-messages=\"renameForm.name.$error\" ng-show=\"renameForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PROFILE.RENAME_NAME_REQUIRED\">Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.config.languages.length > 1\" flex><label translate=\"APP.LANG\">Lang\n</label><md-select ng-model=\"vm.selectedLanguage\"><md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\">\n<div layout=\"row\" layout-align=\"start center\" ng-style=\"{\'opacity\': vm.name[lang] ? 1.0 : 0.33}\"><img \nng-if=\"vm.config.evo.toolbar.languages.flags\" class=\"flag mr-10\" ng-src=\"assets/images/flags/{{ lang }}.png\"> <span \nclass=\"text-uppercase\">{{ lang }}</span></div></md-option></md-select></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-primary md-raised\" type=\"submit\" \nng-disabled=\"renameForm.$invalid\"><span translate=\"{{vm.locales.confirm}}\">Rename</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/dialogs/loading/loading.html","<md-dialog md-theme=\"nuit\" class=\"loading-dialog\" aria-label=\"Loading\"><md-dialog-content class=\"md-dialog-content\">\n<div layout=\"row\" layout-align=\"center center\"><md-progress-circular class=\"md-primary\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div></md-dialog-content></md-dialog>");
$templateCache.put("app/core/dialogs/material/material-dialog.html","<md-dialog style=\"max-height:90%;height:90%\" md-theme=\"nuit\" class=\"material-dialog\" ng-class=\"{\'wide\': vm.multiple}\" \naria-label=\"Select material\"><md-toolbar class=\"md-accent-bg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n<span translate=\"PROFILE.SELECT_MATERIAL\">Material wählen</span></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"APP.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\" \nstyle=\"padding-top: 0px !important; padding-bottom: 0px !important\" layout=\"column\" layout-fill><div layout=\"column\" \nlayout-align=\"center center\" flex style=\"text-align:center\" \nng-if=\"vm.isLoadingMaterials !== true && vm.materialsError !== true && vm.materials !== null && vm.materials.length <= 0\">\n<h1 translate=\"ENVIRONMENT.NO_MATERIALS\" style=\"font-size:30px;margin-bottom:4px\">No materials!</h1><h2 \ntranslate=\"ENVIRONMENT.NO_MATERIALS_INFO\" style=\"max-width:400px;text-align:center\" class=\"pb-20 border-bottom\">\nThe current environment has no materials deposited. Please visit the Materials-Module in the IMS to create new materials.\n</h2><md-icon class=\"m-16 text-center w-48 h-48\" style=\"font-size:48px\" md-font-icon=\"icon-texture\"></md-icon></div>\n<div layout=\"column\" ng-if=\"vm.materials.length > 0\" flex><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\" ng-if=\"!vm.materials\"></md-progress-circular><md-input-container md-no-float \nclass=\"md-block\" ng-if=\"vm.materials\"><md-icon class=\"md-nuit-theme\" md-font-icon=\"icon-magnify\"></md-icon><input \nclass=\"term\" ng-model=\"vm.term\" onfocus=\"this.select()\" ng-model-options=\"{ debounce: 200 }\" \nng-change=\"vm.filterChanged()\" type=\"text\" aria-label=\"term\" \nplaceholder=\"{{ \'MATERIAL.SEARCH_PLACEHOLDER\' | translate }}\"></md-input-container><div layout=\"row\" \nlayout-align=\"space-between start\" layout-fill flex ng-if=\"vm.materials\"><md-content layout=\"column\" flex=\"nogrow\" \nstyle=\"height:100%\" ms-scroll><md-input-container class=\"md-block\" ng-if=\"vm.config.evo.material.showGroupFilter\">\n<label translate=\"MATERIAL.GROUP\">Groups</label><md-select ng-model=\"vm.group\" ng-change=\"vm.filterChanged()\">\n<md-option ng-value=\"null\"><span translate=\"APP.SHOW_ALL\"></span>&nbsp;<span class=\"grey-500-fg\">\n({{ vm.countMaterialsInGroup(null) }})</span></md-option><md-option \nng-repeat=\"group in vm.groups | orderByNuitTranslated:\'name\'\" \nng-if=\"vm.countMaterialsInGroup(group) > 0 || vm.group === group\" ng-value=\"group\"><span>\n{{::group.name | nuitTranslate}}</span>&nbsp;<span class=\"grey-500-fg\">({{vm.countMaterialsInGroup(group)}})</span>\n</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button md-raised\" style=\"margin: 0 !important\" ng-repeat=\"value in vm.comparatorData\" \nng-if=\"vm.config.evo.material.showThicknessFilterComparator && vm.selectedThickness && vm.thicknessComparator===value[0]\" \nng-click=\"vm.thicknessComparator=value[1]; vm.filterChanged()\">{{value[0]}}</md-button><md-input-container \nclass=\"md-block\" ng-if=\"vm.config.evo.material.showThicknessFilter\" flex><label translate=\"MATERIAL.THICKNESS\">\nThickness</label><md-select ng-model=\"vm.selectedThickness\" ng-change=\"vm.filterChanged()\"><md-option ng-value=\"\">\n</md-option><md-option ng-repeat=\"thickness in vm.thicknesses track by thickness\" ng-value=\"thickness\"><span>\n{{ thickness | nuitUnit: \'thickness\' }}</span>&nbsp;<span class=\"grey-500-fg\">\n({{ vm.countMaterialsWithThickness(thickness) }})</span></md-option></md-select></md-input-container></div>\n<md-input-container class=\"md-block\" ng-if=\"vm.config.evo.material.showColorFrontFilter\"><label \ntranslate=\"MATERIAL.COLOR_FRONT\">Color</label><md-select ng-model=\"vm.selectedColor\" ng-change=\"vm.filterChanged()\">\n<md-option ng-value=\"\"></md-option><md-option ng-repeat=\"color in vm.colors track by color.id\" \nng-if=\"vm.countMaterialsWithColor(color.id) > 0 || vm.selectedColor === color.id\" ng-value=\"color.id\"><span>\n{{::color.code}}&nbsp;-&nbsp;{{ color.name | nuitTranslate }}</span>&nbsp;<span class=\"grey-500-fg\">\n({{ vm.countMaterialsWithColor(color.id) }})</span></md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"vm.config.evo.material.showProtectiveFilmFilter\"><label translate=\"MATERIAL.PROTECTIVE_FILM\">\nProtection Film</label><md-select ng-model=\"vm.hasProtectionFilm\" ng-change=\"vm.filterChanged()\"><md-option \nng-value=\"\"></md-option><md-option ng-value=\"true\"><span translate=\"APP.YES\"></span></md-option><md-option \nng-value=\"false\"><span translate=\"APP.NO\"></span></md-option></md-select></md-input-container><div \nng-if=\"vm.filters.length > 0\" ng-repeat=\"filter in vm.filters track by filter.id\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button md-raised\" style=\"margin: 0 !important\" \nng-repeat=\"value in vm.comparatorData\" ng-if=\"filter.value && filter.useComparator && filter.comparator===value[0]\" \nng-click=\"vm.updateComparator(filter,value)\">{{value[0]}}</md-button><md-input-container class=\"md-block\" flex><label>\n{{ filter.name | nuitTranslate }}</label><input type=\"text\" ng-model=\"filter.value\" ng-if=\"filter.type === \'string\'\" \nng-change=\"vm.filterChanged(filter)\"> <input type=\"number\" ng-model=\"filter.value\" ng-if=\"filter.type === \'number\'\" \nng-change=\"vm.filterChanged(filter)\"><md-select ng-model=\"filter.value\" aria-label=\"filter\" \nng-if=\"filter.type === \'enum\' && filter.multiple\" ng-required=\"filter.required\" multiple=\"multiple\" \nng-change=\"vm.filterChanged(filter)\"><md-option ng-value=\"\">-</md-option><md-option ng-repeat=\"val in filter.values\" \nng-value=\"val\">{{ val }}</md-option></md-select><md-select ng-model=\"filter.value\" aria-label=\"filter\" \nng-if=\"filter.type === \'material\'\" ng-required=\"filter.required\" ng-change=\"vm.filterChanged(filter)\"><md-option \nng-value=\"\">-</md-option><md-option ng-repeat=\"val in filter.values\" ng-value=\"val\">{{ val }}</md-option></md-select>\n<md-select ng-model=\"filter.value\" placeholder=\"{{filter.name | nuitTranslate }}\" aria-label=\"filter\" \nng-if=\"filter.type === \'enum\' && !filter.multiple\" ng-required=\"filter.required\" ng-change=\"vm.filterChanged(filter)\">\n<md-options><md-option ng-value=\"\"></md-option><md-option ng-repeat=\"val in filter.values | orderBy\" ng-value=\"val\">\n{{ val }}</md-option></md-options></md-select><md-select ng-model=\"filter.value\" \nplaceholder=\"{{filter.name | nuitTranslate }}\" aria-label=\"filter\" ng-if=\"filter.type === \'generic_materialgroup\'\" \nng-change=\"vm.filterChanged(filter)\"><md-options><md-option ng-value=\"\"></md-option><md-option \nng-repeat=\"val in vm.materialgroups\" ng-value=\"val\">{{ val.name | nuitTranslate }}</md-option></md-options></md-select>\n</md-input-container></div><div><nuit-filters entities=\"vm.prefilteredEntities\" on-change=\"vm.filterMaterials()\" \nfilters=\"vm.customFilters\" filter-values=\"vm.filterValues\" on-init=\"vm.filterControls(controls)\" hide-reset=\"true\">\n</nuit-filters></div><a href=\"#\" ng-show=\"vm.isAnyFilterSet()\" class=\"mt-16\" ng-click=\"vm.resetFilters()\"><span \ntranslate=\"MATERIAL.RESET_FILTERS\">Reset filters</span></a></md-content><div layout=\"column\" flex layout-fill><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.multiple\"><md-button class=\"md-raised\" ng-click=\"vm.selectAll()\" \nng-disabled=\"vm.filteredMaterials.length===0\"><span translate=\"APP.SELECT_ALL\"></span></md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.clearSelection()\" \nng-disabled=\"vm.selectedMaterials.length===0 || vm.filteredMaterials.length===0\"><span translate=\"APP.CLEAR_SELECTION\">\n</span></md-button><span flex></span><div layout=\"row\"><span translate=\"MATERIALS.MATERIALS_SELECTED\"></span> <span>\n:&nbsp;{{ vm.selectedMaterials.length }}</span></div><div class=\"ml-20\"><md-button class=\"md-raised\" \nng-if=\"vm.selectedMaterials.length>0\" ng-click=\"vm.clearAll()\"><label translate=\"APP.DELETE_ALL\"></label></md-button>\n</div></div><div layout=\"row\" flex><md-content layout=\"column\" flex><span class=\"text-center\" \nng-if=\"vm.filteredMaterials.length === 0\" translate=\"MATERIAL.NO_MATERIALS_FOUND\"></span><md-content \nms-scroll=\"{suppressScrollX:true}\" ng-scroll-end=\"vm.limit = vm.limit + 10;\"><md-list \nng-if=\"vm.filteredMaterials.length > 0\" flex><md-list-item \nng-repeat=\"material in vm.filteredMaterials | limitTo: vm.limit\" ng-click=\"vm.selectMaterial(material)\" \nclass=\"material border-bottom md-2-line\" ng-dblclick=\"vm.quickMaterial(material, $event)\" \nng-disabled=\"material.active !== true\" \nng-class=\"{\'yellow-100-bg\': vm.isSelected(material),\'red-100-bg\':material.active !== true}\"><md-icon \nclass=\"md-warn-fg mr-0\" ng-if=\"material.active !== true\" md-font-icon=\"icon-alert\"></md-icon><md-icon \nclass=\"md-whiteframe-1dp mr-15\" ng-if=\"material.active === true\" md-font-icon=\"icon-checkbox-blank\" \nng-style=\"{color: material.colors.front.hex}\"></md-icon><div class=\"md-list-item-text pv-5\"><h3 \nmd-highlight-text=\"vm.term\" md-highlight-flags=\"gi\">{{::material.name | nuitTranslate }}</h3><p \nng-if=\"(field.format | nuitFormatter:material).length>0\" \nng-repeat=\"field in vm.config.evo.material.details.customFields.top\">\n{{field.name | nuitTranslate}} {{field.format | nuitFormatter:material}}</p><p \nng-if=\"material.colors.front && vm.config.evo.material.details.showColorFront\"><span translate=\"MATERIAL.VISIBLE_SIDE\">\nSichtseite</span>: <span md-highlight-text=\"vm.term\" md-highlight-flags=\"gi\">{{material.colors.front.code}}, </span>\n<span>{{material.colors.front.name | nuitTranslate}}</span></p><p \nng-if=\"material.colors.back && vm.config.evo.material.details.showColorBack\"><span translate=\"MATERIAL.BACK_SIDE\">\nRückseite</span>: <span md-highlight-text=\"vm.term\" md-highlight-flags=\"gi\">{{material.colors.back.code}},</span><span>\n{{material.colors.back.name | nuitTranslate}}</span></p><p ng-if=\"vm.isExtended(material)\"><span \ntranslate=\"MATERIAL.LENGTH\" ng-if=\"vm.config.evo.material.details.showLength\">Length</span> <span \nng-if=\"vm.config.evo.material.details.showLength\">\n{{material.restrictions.minLength | nuitUnit:\'length\':true}}-{{material.restrictions.maxLength | nuitUnit:\'length\'}} |\n</span> <span translate=\"MATERIAL.CUTTING\" ng-if=\"vm.config.evo.material.details.showCutting\">Cutting</span> <span \nng-if=\"vm.config.evo.material.details.showCutting\">\n{{material.restrictions.minBlank | nuitUnit:\'length\':true}}-{{material.restrictions.maxBlank | nuitUnit:\'length\'}} |\n</span> <span translate=\"MATERIAL.THICKNESS\" ng-if=\"vm.config.evo.material.details.showThickness\">Thickness</span> \n<span ng-if=\"vm.config.evo.material.details.showThickness\">{{material.thickness | nuitUnit:\'thickness\'}} |</span> <span\n translate=\"MATERIAL.WEIGHT\" ng-if=\"vm.config.evo.material.details.showWeight\">Weight</span> <span \nng-if=\"vm.config.evo.material.details.showWeight\">{{ material.weight | nuitUnit:\'pressure\' }}</span><br \nng-if=\"vm.config.evo.material.details.showPowderCoated\"><span ng-if=\"vm.config.evo.material.details.showPowderCoated\" \ntranslate=\"MATERIAL.POWDERCOATED\">Powder coated</span><span ng-if=\"vm.config.evo.material.details.showPowderCoated\">\n: {{ (material.powderCoated ? \'APP.YES\' : \'APP.NO\') | translate }}</span><br \nng-if=\"vm.config.evo.material.details.showProtectiveFilm\"><span \nng-if=\"vm.config.evo.material.details.showProtectiveFilm\" translate=\"MATERIAL.PROTECTIVE_FILM\">Protectionfilm</span>\n<span ng-if=\"vm.config.evo.material.details.showProtectiveFilm\">\n: {{ (material.protectionFilm ? \'APP.YES\' : \'APP.NO\') | translate }}</span></p><p \nng-if=\"(field.format | nuitFormatter:material).length>0 && vm.isExtended(material)\" \nng-repeat=\"field in vm.config.evo.material.details.customFields.bottom\">\n{{field.name | nuitTranslate}} {{field.format | nuitFormatter:material}}</p><p></p><p \nng-if=\"vm.isExtended(material) && attribute.restrictions.hidden !== true\" ng-repeat=\"attribute in material.attributes\" \nlayout=\"row\">{{ attribute.name | nuitTranslate }}:&nbsp;{{ attribute.value }}</p></div><div class=\"md-secondary\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.toggleOpenState(material, $event)\" aria-label=\"toggle state\" \nng-if=\"vm.isExtended(material)\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleOpenState(material, $event)\" aria-label=\"toggle state\" \nng-if=\"!vm.isExtended(material)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></md-list-item>\n</md-list></md-content></md-content><div layout=\"column\" layout-fill flex ng-if=\"vm.multiple\"><md-content \nlayout=\"column\" ms-scroll=\"{suppressScrollX:true}\" style=\"min-width:200px\"><md-list flex=\"noshrink\" \nng-if=\"vm.selectedMaterials.length > 0\"><md-list-item ng-repeat=\"material in vm.selectedMaterials\" \nclass=\"material border-bottom\" ng-click=\"vm.toggleMaterial(material)\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"md-whiteframe-1dp mr-15 mv-0\" md-font-icon=\"icon-checkbox-blank\" \nng-style=\"{color: material.colors.front.hex}\"></md-icon><div class=\"md-list-item-text\"><h3 class=\"text-truncate mv-0\">\n{{::material.name | nuitTranslate }}</h3></div></div></md-list-item></md-list></md-content></div></div></div></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-left: 180px\"><span></span><div layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"!vm.material && vm.selectedMaterials.length === 0\" ng-click=\"vm.submit()\" class=\"md-accent md-raised\" \naria-label=\"SELECT\" translate=\"PROFILE.SELECT_MATERIAL\" translate-attr-aria-label=\"PROFILE.SELECT_MATERIAL\">SELECT\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/dialogs/move-to-folder/move-to-folder.html","<md-dialog md-theme=\"nuit\" aria-label=\"Item rename\" class=\"dialog move-to-folder\" flex=\"100\" flex-gt-md=\"40\"><form \nname=\"form.move\" ng-cloak ng-submit=\"vm.submit()\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"PROFILE.MOVE_SELECT_TARGET\">Select folder</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><treecontrol class=\"tree-classic\" expanded-nodes=\"vm.expandedGroups\" tree-model=\"vm.publicFolders\" \noptions=\"vm.treeOptions\" on-selection=\"vm.showSelected(node)\" selected-node=\"vm.selectedGroup\"><span class=\"title\">\n{{ node.name | nuitTranslate }}</span></treecontrol><md-divider \nng-if=\"vm.publicFolders.length > 0 && vm.privateFolders.length > 0\" style=\"margin-top:1em\"></md-divider><treecontrol \nclass=\"tree-classic\" expanded-nodes=\"vm.expandedGroups\" tree-model=\"vm.privateFolders\" options=\"vm.treeOptions\" \non-selection=\"vm.showSelected(node)\" selected-node=\"vm.selectedGroup\"><span class=\"title\">\n{{ node.name | nuitTranslate }}</span></treecontrol></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button class=\"md-primary md-raised\" ng-disabled=\"vm.folder === null\" type=\"submit\"><span translate=\"APP.OK\">\nOk</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/dialogs/open-profile/open-dialog.html","<md-dialog class=\"profile-save-dialog\" aria-label=\"Save profile\" layout=\"column\" \nstyle=\"min-height:80vh;min-width:80% !important;max-width:95vh\"><md-toolbar class=\"md-accent-bg\"><div \nclass=\"md-toolbar-tools\"><h2 translate=\"PROFILE.OPEN\">Open profile</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-0\" layout=\"row\" layout-fill class=\"grey-100-bg\">\n<md-content ms-scroll flex=\"25\"><treecontrol class=\"tree-classic\" expanded-nodes=\"vm.expandedFolders\" \ntree-model=\"vm.publicFolders\" options=\"vm.treeOptions\" on-selection=\"vm.showSelected(node)\" \nselected-node=\"vm.selectedFolder\"><span class=\"title\">{{node.name?(node.name | nuitTranslate:\'???\'):\'???\'}}</span>\n</treecontrol><md-divider style=\"margin-top:1em\"></md-divider><treecontrol class=\"tree-classic\" \nexpanded-nodes=\"vm.expandedFolders\" tree-model=\"vm.privateFolders\" options=\"vm.treeOptions\" \non-selection=\"vm.showSelected(node)\" selected-node=\"vm.selectedFolder\"><span class=\"title\">\n{{node.name?(node.name | nuitTranslate:\'???\'):\'???\'}}</span></treecontrol></md-content><div layout=\"column\" flex><div \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\" flex layout-fill>\n<md-input-container flex ng-model-options=\"{ debounce: 350 }\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon><input type=\"text\" ng-model=\"vm.term\" aria-label=\"n\" \ntranslate-attr-placeholder=\"PROFILES.SEARCH_PLACEHOLDER\" ng-change=\"vm.filterProfiles()\"></md-input-container>\n<nuit-pagination all-entities=\"vm.filteredProfiles\" current-page=\"vm.currentPage\" \ncurrent-page-entities=\"vm.currentPageEntities\" entities-per-page=\"10\" class=\"mb-16 ml-10\"></nuit-pagination></div>\n</div><md-content ms-scroll flex><md-list class=\"mr-10\"><md-list-item layout=\"column\" flex \nng-if=\"vm.currentPageEntities.length===0\" layout-fill style=\"text-align: center\"><h3 translate=\"APP.EMPTY\">Empty</h3>\n</md-list-item><md-list-item ng-if=\"profile.data !== null && !profile.data.deleted\" \nng-click=\"vm.magnifyImage(profile.data | profileImage)\" \nng-repeat=\"profile in vm.currentPageEntities track by profile.data.id\" class=\"product border-bottom\"><div \nclass=\"pv-15\" layout=\"row\" layout-align=\"start start\" flex><div layout=\"row\" flex class=\"mt-8\" flex><div \nclass=\"b img-container\" style=\"width:100px; height:100px\"><img ng-if=\"profile.data | profileImage\" \nhttp-src=\"{{ profile.data | profileImage }}\" fallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\" \ndraggable=\"false\" alt=\"Image\" ng-click=\"vm.magnifyImage(profile.data | profileImage)\"> <img \nng-if=\"!(profile.data | profileImage)\" src=\"assets/images/ecommerce/product-image-placeholder.jpg\" draggable=\"false\" \nalt=\"Image\"></div><div class=\"md-list-item-text\" flex><nuit-profile-tags profile=\"profile.data\"></nuit-profile-tags><h3\n class=\"text-truncate m-0\" style=\"white-space: normal;font-size: 1.6rem\" md-highlight-text=\"vm.term\" \nmd-highlight-flags=\"gi\">{{ profile.data.name | nuitTranslate:\'???\'}}</h3><p ng-if=\"profile.data.remark\" \nclass=\"text-truncate\" md-highlight-text=\"vm.term\" md-highlight-flags=\"gi\">{{::profile.data.remark}}</p></div></div>\n</div><md-button ng-click=\"vm.openProfile(profile.data)\" translate=\"MENUBAR.OPEN\">load</md-button></md-list-item>\n</md-list></md-content></div></md-dialog-content></md-dialog>");
$templateCache.put("app/core/dialogs/order-address/order-address-dialog.html","<md-dialog md-theme=\"nuit\" class=\"cart-address-dialog\" aria-label=\"New address\" layout=\"column\"><md-toolbar \nclass=\"md-primary\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"APP.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"m-0 p-0\" flex><div \nclass=\"m-10\"><form name=\"vm.addressForm\" novalidate ng-submit=\"vm.addNewAddress()\"><div layout=\"column\" class=\"mt-0\">\n<div layout=\"row\" ng-if=\"vm.addresses\" layout-margin><md-button ng-if=\"vm.addresses.length>0\" \nclass=\"md-icon-button md-raised\" ng-click=\"vm.toggleSideNav()\"><md-icon md-font-icon=\"icon-library-books\"></md-icon>\n<md-tooltip><span translate=\"ACCOUNT.ADDRESSES\"></span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-raised mt-20\" ng-click=\"vm.newAddress()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip><span translate=\"ADDRESS.NEW_ADDRESS\"></span></md-tooltip></md-button></div><div layout=\"column\" flex>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"ADDRESS.COMPANY_NAME\">COMPANY_NAME</label><md-icon\n md-font-icon=\"icon-domain\" class=\"name\"></md-icon><input name=\"company\" ng-model=\"vm.address.companyname\" type=\"text\" \nrequired md-autofocus md-maxlength=\"60\" maxlength=\"60\"><div ng-messages=\"vm.addressForm.company.$error\" \nng-show=\"vm.addressForm.company.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">\nRequired</span></div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"ADDRESS.COMPANY_ADDITION\">COMPANY_ADDITION</label><md-icon></md-icon><input \nng-model=\"vm.address.additional_companyname\" type=\"text\" md-maxlength=\"255\" maxlength=\"255\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"ADDRESS.CONTACT_NAME\">CONTACT_NAME</label><md-icon\n md-font-icon=\"icon-worker\"></md-icon><input ng-model=\"vm.address.contact_name\" type=\"text\" md-maxlength=\"60\" \nmaxlength=\"60\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"ADDRESS.CONTACT_PHONE\">CONTACT_PHONE</label><md-icon></md-icon><input ng-model=\"vm.address.contact_phone\" \ntype=\"text\" md-maxlength=\"60\" maxlength=\"60\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"ADDRESS.STREET\">STREET</label><input name=\"street\" ng-model=\"vm.address.street\" type=\"text\" required \nmd-maxlength=\"120\" maxlength=\"120\"><div ng-messages=\"vm.addressForm.street.$error\" \nng-show=\"vm.addressForm.street.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">\nRequired</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\" flex layout-fill>\n<md-input-container flex-gt-xs=\"20\"><label translate=\"ADDRESS.COUNTRY\">COUNTRY</label><md-select \nng-model=\"vm.address.country\"><md-option ng-repeat=\"country in vm.countries | orderBy:\'code\'\" ng-value=\"country.code\">\n{{country.code}}</md-option></md-select></md-input-container><md-input-container flex-gt-xs flex=\"20\"><label \ntranslate=\"ADDRESS.AREA\">CITY</label><input name=\"area\" ng-model=\"vm.address.area\" type=\"text\" md-maxlength=\"30\" \nmaxlength=\"30\"><div ng-messages=\"vm.addressForm.area.$error\" ng-show=\"vm.addressForm.are.$touched\" role=\"alert\"></div>\n</md-input-container><md-input-container flex-gt-xs=\"20\"><label translate=\"ADDRESS.ZIP\">ZIP</label><input name=\"zip\" \nng-model=\"vm.address.zip\" type=\"text\" required ng-minlength=\"vm.minZipLength\" md-maxlength=\"vm.maxZipLength\" \nmaxlength=\"{{vm.maxZipLength}}\" ng-pattern=\"vm.zipPattern\"><div ng-messages=\"vm.addressForm.zip.$error\" \nng-show=\"vm.addressForm.zip.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">\nRequired</span></div><div ng-message=\"pattern\"><span translate=\"ADDRESS.ZIP_PATTERN_ERROR\">4-5 Ziffern</span></div>\n</div></md-input-container><md-input-container flex-gt-xs flex=\"60\"><label translate=\"ADDRESS.CITY\">CITY</label><input \nname=\"city\" ng-model=\"vm.address.city\" type=\"text\" required md-maxlength=\"50\" maxlength=\"50\"><div \nng-messages=\"vm.addressForm.city.$error\" ng-show=\"vm.addressForm.city.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container></div></div>\n</div></form></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nclass=\"grey-100-bg\"><div layout=\"row\" layout-align=\"end center\" flex><md-button ng-click=\"vm.cancelAddress()\" \nclass=\"send-button md-raised\" ng-show=\"vm.newAddressMode\" ng-disable=\"vm.inProgress\" translate=\"APP.CANCEL\">CANCEL\n</md-button><md-button ng-click=\"vm.saveAddress()\" class=\"send-button md-raised md-accent\" ng-show=\"vm.newAddressMode\" \nng-disabled=\"vm.addressForm.$invalid || vm.addressForm.$pristine || vm.inProgress\" translate=\"APP.SAVE\">CREATE\n</md-button><md-button type=\"submit\" ng-click=\"vm.addNewAddress()\" class=\"send-button md-accent md-raised\" \nng-show=\"!vm.newAddressMode\" ng-disabled=\"vm.addressForm.$invalid || vm.addressForm.$pristine\" aria-label=\"OK\" \ntranslate=\"APP.OK\" translate-attr-aria-label=\"APP.OK\">OK</md-button></div></md-dialog-actions><md-sidenav \nmd-component-id=\"left\" ng-if=\"vm.addresses && (vm.addresses.length>0 || vm.newAddressMode)\" \nng-click=\"vm.closeSideNav()\"><div class=\"mr-20 mv-0\" layout=\"column\" layout-margin layout-align=\"start center\"><div \nclass=\"p-10\" style=\"width: 100%;border-radius: 8px\" \nng-class=\"{\'green-100-bg\':vm.equalsAddress(address),\'grey-100-bg\':!vm.equalsAddress(address)}\" style=\"cursor: pointer\" \nng-repeat=\"address in vm.addresses\" ng-click=\"vm.setNewAddress(address)\"><nuit-address show-address-name=\"true\" \naddress-format=\"vm.getCompanyAddressFormat()\" address-format-by-country=\"vm.getCompanyAddressFormatByCountry()\" \naddress=\"address\" flex></nuit-address><div flex layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"md-raised md-warn md-icon-button\" ng-click=\"vm.deleteAddress(address.id);$event.stopPropagation();\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\"></span></md-tooltip></md-button></div>\n</div></div></md-sidenav></md-dialog>");
$templateCache.put("app/core/dialogs/product/product-dialog.html","<md-dialog md-theme=\"nuit\" class=\"product-dialog\" aria-label=\"Select product\"><form name=\"productForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.submit()\"><md-toolbar class=\"md-primary\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"PRODUCT.PRODUCT\">Product</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"APP.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div class=\"md-title\">\n{{ vm.product.name | nuitTranslate }}</div><span layout=\"row\" \nng-repeat=\"field in vm.config.evo.products.list.customFields\" class=\"mh-10\"><span \nclass=\"grey-100-bg tag-label h-34 md-list-item-text ph-10 md-block\" layout=\"row\" layout-align=\"center center\" \nng-if=\"::(field.format | nuitFormatter:vm.product).length>0\"><span class=\"text mr-10\">{{::field.name | nuitTranslate}}\n</span> <span class=\"text-bold\">{{::field.format | nuitFormatter:vm.product}}</span></span></span></div><p \nng-if=\"vm.product.description\">{{ vm.product.description | nuitTranslate }}</p><nuit-tags><nuit-tag model=\"attribute\" \nname-property=\"name\" ng-repeat=\"attribute in vm.product.attributes\" \nng-if=\"attribute.constant === true && !attribute.restrictions.hidden\"></nuit-tag><nuit-tag model=\"tag\" \nname-property=\"name\" ng-repeat=\"tag in vm.product.tags\"></nuit-tag><nuit-tag-material ignoreactive=\"true\" \nng-if=\"vm.product.type === \'profile\' && vm.product.data.materials.length === 1\" \nmaterial=\"vm.product.data.materials[0]\"></nuit-tag-material><nuit-tag-attribute \nng-if=\"vm.product.type === \'profile\' && vm.result.data.profile.material!==null\" \nng-repeat=\"attribute in vm.getMaterialById(vm.result.data.profile.materialId).attributes\" attribute=\"attribute\">\n</nuit-tag-attribute></nuit-tags><div layout=\"row\" layout-align=\"space-between start\" flex layout-margin><div \nlayout=\"column\"><div flex=\"noshrink\" class=\"mb-16 img-container\" ng-if=\"vm.product.image\"><img \nstyle=\"max-height:100%;max-width:100%;height:auto;width:auto;margin:0 auto;display: inline-block;vertical-align: middle\" \nng-click=\"vm.magnifyImage(vm.product.image)\" fallback-src=\"assets/images/logos/logo_grau_200x200.jpg\" width=\"200\" \nalt=\"Artikelbild\" http-src=\"{{::vm.product.image}}\"></div><div flex=\"noshrink\" class=\"mb-16 img-container\" \nng-if=\"!vm.product.image\"><img \nstyle=\"max-height:100%;max-width:100%;height:auto;width:auto;margin:0 auto;display: inline-block;vertical-align: middle\" \nng-click=\"vm.magnifyImage(vm.product.image)\" src=\"assets/images/logos/logo_grau_200x200.jpg\" width=\"200\" \nalt=\"Artikelbild\"></div><md-content style=\"max-height: 200px;font-size: 0.6em;cursor: zoom-in\" flex ms-scroll \nng-click=\"vm.showDetails()\" ng-if=\"vm.product.details !== null\"><table class=\"m-10 dataTable border row-border hover\">\n<tbody><tr ng-repeat=\"detail in vm.product.details track by $index\"><td class=\"text-right\">\n{{ detail.name | nuitTranslate }}</td><td class=\"text-right\">{{ detail.value }}</td></tr></tbody></table></md-content>\n</div><div flex layout=\"column\"><div ng-repeat=\"attribute in vm.result.attributes track by attribute.id\">\n<nuit-material-selection ng-if=\"attribute.constant !== true && attribute.type === \'material\'\" \nselection=\"attribute.value\" value-type=\"\'id\'\" \nmaterials=\"attribute.restrictions.subset || attribute.restrictions.materials\" groups=\"attribute.restrictions.groups\" \nwhitelist=\"attribute.restrictions.blacklist !== true || attribute.restrictions.subset !== undefined\" \non-selected=\"vm.getProductPrice()\" bg-color=\"true\">{{ attribute.name | nuitTranslate }}&nbsp;<sup>*</sup>\n</nuit-material-selection><md-input-container class=\"md-block\" \nng-if=\"attribute.constant !== true && vm.positionAttributes.indexOf(attribute) < 0 && attribute.type !== \'material\'\">\n<label>{{ attribute.name | nuitTranslate }}</label><input type=\"text\" ng-model=\"attribute.value\" \nng-change=\"vm.getProductPrice()\" ng-required=\"true\" ng-if=\"attribute.type === \'string\'\" ng-readonly=\"attr.readonly\"> \n<input type=\"number\" ng-model=\"attribute.value\" ng-change=\"vm.getProductPrice()\" ng-required=\"true\" \nng-if=\"attribute.type === \'number\'\" min=\"{{attribute.restrictions.min}}\" max=\"{{attribute.restrictions.max}}\"><div \nclass=\"md-char-counter grey-500-fg\" \nng-if=\"attribute.type === \'number\' && attribute.restrictions.min !== undefined && attribute.restrictions.max !== undefined\">\n{{attribute.restrictions.min}}&nbsp;-&nbsp;{{attribute.restrictions.max}}</div><input type=\"number\" \nng-model=\"attribute.value\" ng-change=\"vm.getProductPrice()\" ng-required=\"true\" ng-if=\"attribute.type === \'length\'\" \nng-min=\"attribute.restrictions.min\" ng-max=\"attribute.restrictions.max\" nuit-unit-input=\"length\"><div \nclass=\"md-char-counter grey-500-fg\" \nng-if=\"attribute.type === \'length\' && attribute.restrictions.min !== undefined && attribute.restrictions.max !== undefined\">\n{{attribute.restrictions.min | nuitUnit:\'length\'}}&nbsp;-&nbsp;{{attribute.restrictions.max | nuitUnit:\'length\'}}</div>\n<md-select ng-model=\"attribute.value\" ng-change=\"vm.getProductPrice()\" ng-if=\"attribute.type === \'enum\'\" \nng-required=\"true\"><md-option ng-repeat=\"value in attribute.restrictions.options\" ng-value=\"value\">{{ value }}\n</md-option></md-select><md-select ng-model=\"attribute.value\" ng-change=\"vm.getProductPrice()\" \nng-if=\"attribute.type === \'color\'\" ng-required=\"true\"><md-option \nng-repeat=\"color in vm.colors| filter:vm.filterColorsForAttribute(attribute) track by color.id\" ng-value=\"color.id\">\n{{color.code}}&nbsp;-&nbsp;{{color.name | nuitTranslate}}</md-option></md-select></md-input-container></div><div \nng-if=\"vm.product.type ===\n                    	\'profile\' &&\n                    	(\n                    		(vm.baseProduct.data.materials.length >= 1 || vm.baseProduct.data.groups.length > 0) ||\n                    		(vm.baseProduct.data.materials.length === 0 && vm.baseProduct.data.groups.length === 0)\n                    	)\">\n<nuit-material-selection selection=\"vm.result.data.profile.materialId\" value-type=\"\'id\'\" \ngroups=\"vm.baseProduct.data.groups\" materials=\"vm.baseProduct.data.materials\" \nwhitelist=\"vm.baseProduct.data.materials.length > 1 || vm.baseProduct.data.groups.length > 0\" \ndisabled=\"vm.baseProduct.data.materials.length===1\" on-selected=\"vm.getProductPrice()\" bg-color=\"true\">\n{{ \'PROFILE.MATERIAL\' | translate }}&nbsp;<sup>*</sup></nuit-material-selection></div><div \nng-if=\"vm.result.customData.profileId && vm.result.customData.dynamicSegments.length > 0\" \nng-repeat=\"segment in vm.result.customData.dynamicSegments| orderBy:\'index\' track by segment.index\"><md-input-container\n class=\"md-block\"><label>{{ segment.name | nuitTranslate }}</label><input type=\"number\" ng-model=\"segment.length\" \nng-change=\"vm.getProductPrice()\" ng-required=\"true\" min=\"{{segment.min}}\" max=\"{{segment.max}}\"></md-input-container>\n</div><md-input-container class=\"md-block\" ng-if=\"vm.notes\"><label translate=\"PRODUCT.REMARK\">Bemerkung</label>\n<textarea name=\"notes\" ng-model=\"vm.result.remark\" rows=\"1\" md-select-on-focus onfocus=\"this.select()\" \nmd-maxlength=\"150\" maxlength=\"150\"></textarea><div ng-messages=\"productForm.notes.$error\" \nng-show=\"productForm.notes.$touched\" role=\"alert\"><div ng-message=\"md-maxlength\"><span translate=\"ERROR.MAX_150\">\nField can\'t be longer than 150 characters.</span></div></div></md-input-container></div><div class=\"lengths\" \nlayout=\"column\"><nuit-product-positions product=\"vm.result\" show-prices=\"false\" min-positions=\"1\" max-positions=\"100\" \non-position-changed=\"vm.getProductPrice()\" on-position-added=\"vm.getProductPrice()\" \non-position-removed=\"vm.getProductPrice()\"></nuit-product-positions><table class=\"dataTable row-border hover\" \nng-if=\"vm.showPrices()\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<span translate=\"APP.PRICE\">Preis</span></span></div></th></tr></thead><tbody><tr><td class=\"text-left font-size-18\">\n<span>{{ vm.result._displayPrice | nuitCurrency }}</span></td></tr></tbody></table><a href=\"#\" \nng-click=\"vm.addNotes()\" ng-if=\"!vm.notes\"><span translate=\"CART.ADD_REMARK\">Bemerkung hinzufügen</span> </a><a \nhref=\"#\" ng-click=\"vm.removeNotes()\" ng-if=\"vm.notes\"><span translate=\"CART.REMOVE_REMARK\">Bemerkung entfernen</span>\n</a></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nclass=\"border-top\"><div layout=\"row\" layout-align=\"end center\" flex><div layout=\"row\" layout-align=\"start center\" flex>\n<md-button ng-repeat=\"attachment in vm.baseProduct.attachments track by $index\" \nng-href=\"{{ (attachment.link + \'?access-token=\' + vm.auth.getToken())  }}\" target=\"_blank\" ng-switch=\"attachment.type\" \nclass=\"md-raised md-primary\" aria-label=\"attachment\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-switch-when=\"pdf\" md-font-icon=\"icon-file-pdf\"></md-icon><md-icon ng-switch-when=\"excel\" \nmd-font-icon=\"icon-file-excel\"></md-icon><md-icon ng-switch-default md-font-icon=\"icon-file\"></md-icon><span \nclass=\"text-truncate\">{{ attachment.name | nuitTranslate }}</span></md-button></div><md-button \nng-if=\"vm.baseProduct.purchasable && vm.isBeforeCart !== true\" type=\"submit\" class=\"md-raised md-warn\" md-autofocus \naria-label=\"Save\" translate-attr-aria-label=\"APP.SAVE\" ng-disabled=\"productForm.$invalid\"><md-icon \nmd-font-icon=\"icon-floppy\"></md-icon><span translate=\"APP.SAVE\">Speichern</span></md-button><md-button \nng-if=\"vm.baseProduct.purchasable && vm.isBeforeCart === true\" type=\"submit\" class=\"md-raised md-warn\" md-autofocus \naria-label=\"In den Warenkorb\" translate-attr-aria-label=\"PROFILE.ADD_TO_CART\" ng-disabled=\"productForm.$invalid\">\n<md-icon md-font-icon=\"icon-cart\"></md-icon><span translate=\"PROFILE.ADD_TO_CART\">In den Warenkorb</span></md-button>\n<md-button ng-if=\"!vm.baseProduct.purchasable\" disabled=\"disabled\" class=\"md-raised md-warn\" md-autofocus \naria-label=\"Nicht bestellbar\" translate-attr-aria-label=\"PRODUCT.NOT_ORDERABLE\"><md-icon md-font-icon=\"icon-alert\">\n</md-icon><span translate=\"PRODUCT.NOT_ORDERABLE\">Nicht bestellbar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/core/dialogs/product-selection/product-selection-dialog.html","<md-dialog md-theme=\"nuit\" aria-label=\"Select product\" id=\"product-selection\" \nstyle=\"max-height:95vh;max-width:95%; width: 95%\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ARTICLES.ADD\">\nHINZUFÜGEN</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"width: 100%\" layout=\"row\" layout-fill class=\"p-0\">\n<nuit-product-selection show-prices=\"vm.showPrices\" style=\"width: 100%\" add-button-translation=\"APP.ADD\" \non-product-selected=\"vm.addToOrder(product)\"></nuit-product-selection></md-dialog-content></md-dialog>");
$templateCache.put("app/core/dialogs/product-table/product-table-dialog.html","<md-dialog md-theme=\"nuit\" class=\"product-table-dialog\" aria-label=\"Select product\"><form name=\"productForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.closeDialog()\"><md-toolbar class=\"md-primary\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"PRODUCT.DETAILS\">Details</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"APP.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" ms-scroll><md-content \nstyle=\"font-size: 1.2em\" flex ms-scroll ng-click=\"vm.showDetails()\" ng-if=\"vm.product.details !== null\"><table \nclass=\"m-10 dataTable border row-border hover\"><tbody><tr ng-repeat=\"detail in vm.product.details track by $index\"><td \nclass=\"text-right\">{{ detail.name | nuitTranslate }}</td><td class=\"text-right\">{{ detail.value }}</td></tr></tbody>\n</table></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nclass=\"border-top\"><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" class=\"md-raised md-warn\" \naria-label=\"Close\" translate-attr-aria-label=\"APP.CLOSE\"><span translate=\"APP.CLOSE\">Close</span></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/dialogs/save-profile/save-dialog.html","<md-dialog class=\"profile-save-dialog\" aria-label=\"Save profile\" flex=\"80\" flex-gt-md=\"60\"><form name=\"profileForm\" \nng-submit=\"vm.submit()\" novalidate><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"PROFILE.SAVE\">Save profile</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\"><div class=\"img-container\" layout=\"column\" \nlayout-align=\"center center\" style=\"cursor: zoom-in;min-width: 200px;min-height:200px\" \nng-click=\"vm.magnifyImage(vm.profile | profileImage)\"><md-progress-circular md-diameter=\"32px\" \nng-if=\"vm.isImageLoading\"></md-progress-circular><img fallback-src=\"assets/images/logos/logo_grau_200x200.jpg\" \nng-if=\"(vm.profile | profileImage) !== undefined && !vm.isImageLoading\" width=\"200\" alt=\"\" \nhttp-src=\"{{vm.profile | profileImage}}\"></div><div flex layout=\"column\"><nuit-profile-tags profile=\"vm.profile\">\n</nuit-profile-tags><div layout=\"row\" flex><md-input-container flex><label translate=\"PROFILE.NAME\">Bezeichnung</label>\n<input class=\"title\" type=\"text\" ng-model=\"vm.saveform.name[vm.selectedLanguage]\" aria-label=\"n\" required name=\"title\">\n<div ng-messages=\"profileForm.title.$error\" ng-show=\"profileForm.title.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Das Feld wird benötigt.</span></div><div \nng-message=\"md-maxlength\"><span translate=\"ERROR.MAX_50\">title can\'t be longer than 50 characters.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.config.languages.length > 1\"><label \ntranslate=\"APP.LANG\">Lang</label><md-select ng-model=\"vm.selectedLanguage\"><md-option \nng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><div layout=\"row\" layout-align=\"start center\" \nng-style=\"{\'opacity\': vm.saveform.name[lang] ? 1.0 : 0.33}\"><img ng-if=\"vm.config.evo.toolbar.languages.flags\" \nclass=\"flag mr-10\" ng-src=\"assets/images/flags/{{ lang }}.png\"> <span class=\"text-uppercase\">{{ lang }}</span></div>\n</md-option></md-select></md-input-container></div><md-input-container class=\"md-block\" \nng-repeat=\"data in vm.customData\" ng-switch=\"data.type\"><label>{{ data.key | translate }}</label><md-select \nng-required=\"data.required\" ng-switch-when=\"select\" ng-change=\"vm.updateReplace(data)\" ng-model=\"data.value\">\n<md-select-header class=\"select-header p-10\"><input ng-model=\"searchText\" id=\"search\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"{{\'APP.SEARCH\' | translate}}\"><md-icon \nng-show=\"searchText && searchText.length>0\" md-font-icon=\"icon-close\" ng-click=\"searchText=\'\';\"></md-icon>\n</md-select-header><md-options><md-option \nng-if=\"searchText===\'\' || searchText===undefined || (data.nameProperty !== undefined ? option[data.nameProperty] : option).toLowerCase().indexOf(searchText.toLowerCase())>=0\" \nng-repeat=\"option in data.options\" ng-value=\"option\"><span>\n{{ data.nameProperty !== undefined ? option[data.nameProperty] : option }}</span></md-option></md-options></md-select>\n</md-input-container><treecontrol class=\"tree-classic\" expanded-nodes=\"vm.expandedFolders\" tree-model=\"vm.folders\" \noptions=\"vm.treeOptions\" on-selection=\"vm.toggleSelectFolder(node)\" selected-node=\"vm.selectedFolder\"><md-checkbox \nclass=\"md-primary\" ng-checked=\"vm.isSelected(node)\" aria-label=\"folder\"></md-checkbox><span class=\"title\" \ntranslate=\"{{node.name | nuitTranslate}}\"></span></treecontrol><md-card layout=\"column\" layout-margin \nng-if=\"!vm.hasPrivateFolder\" layout-margin><md-card-header class=\"m-0\"><md-card-header-text><span class=\"md-title\" \ntranslate=\"FOLDER.ADD_PRIVATE\">Title</span></md-card-header-text></md-card-header><md-card-content class=\"m-0 pb-0\" \nlayout=\"row\" layout-align=\"start start\"><md-input-container flex><label translate=\"FOLDER.NAME\"></label><input \nng-model=\"vm.privateFolderName[vm.selectedFolderLanguage]\"></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.config.languages.length > 1\"><label translate=\"APP.LANG\">Lang</label><md-select \nng-model=\"vm.selectedFolderLanguage\"><md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><div \nlayout=\"row\" layout-align=\"start center\"><img ng-if=\"vm.config.evo.toolbar.languages.flags\" class=\"flag mr-10\" \nng-src=\"assets/images/flags/{{ lang }}.png\"> <span class=\"text-uppercase\">{{ lang }}</span></div></md-option>\n</md-select></md-input-container><md-button class=\"md-raised\" ng-click=\"vm.addFolder()\"><label translate=\"APP.ADD\">\n</label></md-button></md-card-content></md-card></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span \nflex></span><md-button type=\"submit\" class=\"md-primary md-raised\" \nng-disabled=\"profileForm.$invalid || vm.selectedFolder === null\"><span translate=\"APP.SAVE\">Speichern</span>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/dialogs/special-processing/default.html","<div></div><div layout=\"row\" layout-wrap layout-align=\"start\" class=\"mb-10 bb grey-100-bg\" style=\"text-align: left\">\n<div ng-repeat=\"option in vm.selection track by option.id\" ng-if=\"vm.removable || vm.readOnly\" style=\"margin: 1px\">\n<md-button class=\"ph-10 m-0 brad-1\" ng-click=\"vm.onChange(option.id)\" \nng-class=\"{\'md-nuit-theme md-raised md-accent\': (vm.selectedSpecial.id == option.id)}\" flex=\"nogrow\"><div layout=\"row\" \nlayout-align=\"center center\" flex><span>{{option.name | nuitTranslate}}</span></div></md-button></div><span \nclass=\"font-size-24 pl-5\" ng-if=\"!vm.removable || vm.readOnly\">{{vm.selectedSpecial.name | nuitTranslate}}</span></div>\n<div layout=\"row\"><div class=\"w-350 h-350 mr-10\"><img class=\"w-350 h-350\" \nng-if=\"vm.selectedSpecial.img && vm.selectedSpecial.img!==\'\'\" http-src=\"{{vm.selectedSpecial.img}}\" \nfallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\"></div><div layout=\"column\" class=\"pv-10\"><div \nstyle=\"max-width: 350px\">{{vm.selectedSpecial.description | nuitTranslate}}</div><div class=\"text-bold pv-20\" \ntranslate=\"SPECIAL_PROCESSING.REMARK\"></div><textarea ng-disabled=\"vm.readOnly\" class=\"b p-10\" rows=\"10\" cols=\"54\" \nng-model=\"vm.remark\"></textarea></div></div>");
$templateCache.put("app/core/dialogs/special-processing/dropdown.html","<div layout=\"row\" class=\"mb-10\" layout-wrap layout-align=\"center center\" style=\"text-align: left\"><div flex=\"nogrow\">\n<md-icon md-font-icon=\"icon-arrow-right-bold\" class=\"md-accent\" ng-if=\"!vm.selectedSpecial\"></md-icon></div>\n<md-input-container flex ng-if=\"vm.removable || vm.readOnly\" class=\"m-0 grey-100-bg\"><label \nng-if=\"!vm.selectedSpecial\" translate=\"APP.SELECT\"></label><md-select ng-model=\"vm.selectedSpecial.id\" \nng-change=\"vm.onChange(vm.selectedSpecial.id)\"><md-option ng-repeat=\"option in vm.selection track by option.id\" \nng-value=\"option.id\"><span class=\"text-bold\">{{option.name | nuitTranslate}}</span></md-option></md-select>\n</md-input-container><div flex=\"nogrow\"><md-icon md-font-icon=\"icon-arrow-left-bold\" class=\"md-accent\" \nng-if=\"!vm.selectedSpecial\"></md-icon></div></div><div><span class=\"font-size-24 pl-5\" style=\"text-align: left\" \nng-if=\"!vm.removable || vm.readOnly\">{{vm.selectedSpecial.name | nuitTranslate}}</span></div><div layout=\"row\"><div \nclass=\"m-30 text-bold\" ng-if=\"!vm.selectedSpecial\"><span translate=\"CART.SPECIAL_SELECT\"></span></div><div \nclass=\"w-350 h-350 mr-10 mt-15\" ng-if=\"vm.selectedSpecial\"><img class=\"w-350 h-350\" \nng-if=\"vm.selectedSpecial.img && vm.selectedSpecial.img!==\'\'\" http-src=\"{{vm.selectedSpecial.img}}\" \nfallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\"></div><div layout=\"column\" class=\"pv-10\" \nng-show=\"vm.selectedSpecial\"><div style=\"max-width: 350px\">{{vm.selectedSpecial.description | nuitTranslate}}</div><div\n class=\"text-bold pv-20\" translate=\"SPECIAL_PROCESSING.REMARK\"></div><textarea ng-disabled=\"vm.readOnly\" \nclass=\"b p-10\" rows=\"10\" cols=\"54\" ng-model=\"vm.remark\"></textarea></div></div>");
$templateCache.put("app/core/dialogs/special-processing/special-processing.html","<md-dialog layout=\"column\"><md-toolbar class=\"md-primary\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"SPECIAL_PROCESSING.HEADER\">Product</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"APP.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" ng-include=\"vm.template\">\n</md-dialog-content><md-dialog-actions><md-button ng-disabled=\"vm.special===null\" ng-if=\"!vm.readOnly\" \nng-click=\"vm.close()\" class=\"md-accent md-raised md-nuit-theme\" aria-label=\"n\"><span translate=\"APP.SAVE\">Save</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.clients/views/admin-clients.detail.html","<div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" \nflex><form name=\"vm.itemForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.adminClients\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span class=\"md-title\">\n{{ vm.template.name | nuitTranslate }}</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.save()\" ng-disabled=\"!vm.itemForm.$valid || !vm.itemForm.$dirty\" \ntranslate=\"APP.SAVE\">Speichern</md-button></div></div><md-content ms-scroll class=\"content-wrapper\" layout=\"column\" \nlayout-fill flex><md-tabs layout-fill md-selected=\"vm.selectedTab\"><md-tab \nlabel=\"{{ \'CLIENTS.MAINTENANCE\' | translate }}\" ui-sref=\"app.adminClients.detail({active:\'maintenance\'})\" \nmd-active=\"vm.currentTab == \'maintenance\'\"><ng-include src=\"\'app/main/admin.clients/views/partials/maintenance.html\'\">\n</ng-include></md-tab><md-tab label=\"{{ \'CLIENTS.STATUS\' | translate }}\" \nui-sref=\"app.adminClients.detail({active:\'status\'})\" md-active=\"vm.currentTab == \'status\'\"><ng-include \nsrc=\"\'app/main/admin.setup/views/partials/status.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'CLIENTS.DOCUMENTS\' | translate }}\" ui-sref=\"app.adminClients.detail({active:\'documents\'})\" \nmd-active=\"vm.currentTab == \'documents\'\"><ng-include src=\"\'app/main/admin.clients/views/partials/documents.html\'\">\n</ng-include></md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/admin.clients/views/admin-clients.html","<div id=\"admin-clients\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\" layout=\"column\" layout-align=\"center center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-radioactive\" class=\"icon\"></md-icon>\n</span><span class=\"logo-text text-truncate\" translate=\"CLIENTS.CLIENTS_NAV\">Clients</span></div></div><md-content \nms-scroll class=\"content\" flex><div class=\"compose-button\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"vm.showAddEnvironmentDialog()\" translate=\"CLIENTS.ADD\">\nADD NEW CLIENT</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-divider></md-divider><div \nng-if=\"vm.categoriesLoading && vm.categories.length === 0\" class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular></div><div class=\"masteritem\" aria-label=\"inbox\"><div layout=\"column\" \nstyle=\"margin: 0; padding: 0\"><md-list-item layout=\"row\" class=\"masteritem-teaser\" style=\"padding: 0\" \nlayout-align=\"space-between center\" layout-fill ui-sref=\"app.adminClients({category:undefined})\" \nui-sref-opts=\"{inherit:false}\" ui-sref-active=\"selected\"><div layout=\"row\" layout-align=\"start center\" flex \nclass=\"pl-8\"><span class=\"title text-truncate\" flex translate=\"APP.SHOW_ALL\"></span></div></md-list-item></div></div>\n<div class=\"masteritem\" aria-label=\"inbox\" ng-repeat=\"category in vm.categories track by category.id\"><div \nlayout=\"column\" style=\"margin: 0; padding: 0\"><md-list-item layout=\"row\" class=\"masteritem-teaser\" style=\"padding: 0\" \nlayout-align=\"space-between center\" layout-fill ui-sref=\"app.adminSetup({category:category.id})\" \nui-sref-opts=\"{inherit:false}\" ui-sref-active=\"selected\"><div layout=\"row\" layout-align=\"start center\" flex \nng-class=\"{\'pl-8\': !vm.categoriesEditMode}\"><md-button ng-click=\"vm.toggleDropdownOrEditGroup(category, $event)\" \nng-if=\"vm.categoriesEditMode\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"><md-tooltip><span \ntranslate=\"APP.EDIT\"></span></md-tooltip></md-icon></md-button><span class=\"title text-truncate\" flex>\n{{ ::category.name | nuitTranslate }}</span><md-button ng-click=\"vm.deleteCategory(category, $event)\" \nng-if=\"vm.categoriesEditMode\" class=\"md-icon-button\"><md-icon ng-if=\"vm.categoriesEditMode\" md-font-icon=\"icon-trash\" \nclass=\"s16\" ng-click=\"vm.deleteCategory(category, $event)\"></md-icon><md-tooltip><span translate=\"APP.DELETE\"></span>\n</md-tooltip></md-button></div><md-button class=\"md-secondary md-icon-button\" \nng-click=\"category._open = !category._open\" ng-if=\"category.child\"><md-icon md-font-icon=\"icon-chevron-right\" \nng-hide=\"category._open\"></md-icon><md-icon md-font-icon=\"icon-chevron-down\" ng-show=\"category._open\"></md-icon>\n</md-button></md-list-item><div layout=\"column\" ng-show=\"category._open\"><md-button class=\"item\" aria-label=\"Child\" \nng-repeat=\"child in category.child track by child.id\" ng-click=\"vm.editCategory(child, $event)\" \nui-sref=\"app.products({category:child.id})\" ui-sref-opts=\"{inherit:false}\" ui-sref-active=\"selected\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-fill><md-icon ng-if=\"vm.categoriesEditMode\" md-font-icon=\"icon-pencil\" \nclass=\"s16 mr-0\"><md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-icon><span \nclass=\"title text-truncate\">{{ child.name | nuitTranslate }}</span><md-icon ng-if=\"vm.categoriesEditMode\" \nmd-font-icon=\"icon-trash\" class=\"s16\" ng-click=\"vm.deleteCategory(child, $event)\"><md-tooltip><span \ntranslate=\"APP.DELETE\"></span></md-tooltip></md-icon></div></md-button></div></div></div></div></md-content>\n</md-sidenav><div class=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/admin.clients/views/admin-clients.list.html","<div class=\"header\" layout=\"row\" layout-align=\"start end\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.term\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.filterAll()\" \nng-model-options=\"{debounce:300}\"></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleSelection()\"></md-checkbox><div \nlayout=\"row\" ng-if=\"vm.getSelected().length > 0\" layout-align=\"center center\"><nuit-selection-indicator \nselection=\"vm.selection\" get-name=\"vm.getName\"></nuit-selection-indicator><md-button class=\"md-icon-button\" \naria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div><div layout=\"row\" layout-align=\"start center\">\n<nuit-pagination all-entities=\"vm.filteredEnvironments\" current-page-entities=\"vm.currentPageEntities\" \ncurrent-page=\"vm.currentPage\" entities-per-page=\"10\"></nuit-pagination></div></div><div class=\"content-wrapper\" \nlayout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.isLoading\" \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...</span></div><div \nng-if=\"vm.filteredEnvironments.length === 0 && !vm.isLoading\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"CLIENTS.EMPTY\">\nEs wurden keine Kunden gefunden!</span></div><div class=\"thread unread\" ng-if=\"!vm.isLoading\" \nng-repeat=\"environment in vm.currentPageEntities track by environment.id\" \nng-class=\"{\'selected\': vm.isSelected(environment)}\" ng-click=\"vm.openClient(environment)\"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(environment)\" \nng-click=\"vm.toggleSelect(environment, $event)\" aria-label=\"{{vm.isSelected(environment) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"avatar\" ng-if=\"environment.image\"><img http-src=\"{{ ::environment.image }}\"></div><div \nclass=\"pl-10\" ng-if=\"!environment.image\"><md-icon ng-if=\"environment.disabled !== 0\" class=\"green-500-fg\" \nmd-font-icon=\"icon-home-variant\"></md-icon><md-icon ng-if=\"environment.disabled === 0\" class=\"red-500-fg\" \nmd-font-icon=\"icon-window-close\"></md-icon></div><div class=\"info\" layout=\"column\" layout-align=\"center start\" flex>\n<span class=\"name text-truncate pt-8\">{{ environment.name }}</span><div class=\"message text-truncate\"><span \nng-if=\"!environment.template\" translate=\"ENVIRONMENT.NO_TEMPLATE\"></span></div></div></div></div></md-content></div>\n</div>");
$templateCache.put("app/main/admin.documents/views/document-add.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" flex><form\n name=\"vm.templateForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.adminDocuments\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span class=\"md-title\" \ntranslate=\"ADMIN.ADD_DOCUMENT\">Neues Dokument</span></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-warn md-raised\" ng-click=\"vm.saveTemplate()\" \nng-disabled=\"!vm.templateForm.$valid || !vm.templateForm.$dirty\" translate=\"APP.SAVE\">Speichern</md-button></div></div>\n<div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex>\n<md-content layout-fill flex ms-scroll><div layout=\"column\" layout-margin class=\"mt-30\"><div layout=\"row\">\n<md-input-container flex><label>Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.template.name\" required>\n</md-input-container><md-input-container><label>Lang</label><input maxlength=\"10\" type=\"text\" name=\"lang\" \nng-model=\"vm.template.lang\"></md-input-container><md-input-container><label translate=\"DOCUMENTS.ORIENTATION\">\nAusrichtung</label><md-select name=\"orientation\" ng-model=\"vm.template.orientation\"><md-option ng-value=\"\'Portrait\'\">\n<span translate=\"DOCUMENTS.ORIENTATION_PORTRAIT\">Hochformat</span></md-option><md-option ng-value=\"\'Landscape\'\"><span \ntranslate=\"DOCUMENTS.ORIENTATION_LANDSCAPE\">Querformat</span></md-option></md-select></md-input-container></div>\n<md-input-container flex><label>Key</label><input type=\"text\" name=\"name\" ng-model=\"vm.template.key\" required>\n</md-input-container><md-input-container flex><label>Template HTML</label><textarea ng-model=\"vm.template.html\" \nmd-select-on-focus></textarea></md-input-container></div></md-content></md-content></div></form></div>");
$templateCache.put("app/main/admin.documents/views/document-details.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" flex><form\n name=\"vm.templateForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.adminDocuments\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.template\"><div class=\"divider-vertical mr-20\"></div><span class=\"md-title\">\n{{ vm.template.name }}</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-primary\" \nng-click=\"vm.preview()\" ng-disabled=\"vm.templateForm.$invalid\" translate=\"DOCUMENT.PREVIEW\">Vorschau</md-button>\n<md-button class=\"md-warn md-raised\" ng-click=\"vm.saveTemplate()\" \nng-disabled=\"vm.templateForm.$invalid || !vm.templateForm.$dirty\" translate=\"APP.SAVE\">Speichern</md-button></div>\n</div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill \nflex><div class=\"content\" ng-if=\"vm.loading\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><div class=\"content\" ng-if=\"vm.error && !vm.loading\" flex><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-icon md-font-icon=\"icon-emoticon-sad\" class=\"m-0\" \nstyle=\"font-size:100px;min-height:100px;min-width:100px\"></md-icon><span class=\"md-block md-headline mt-20\" \ntranslate=\"APP.UNKNOWN_ERROR\">An unexpected error occured</span></div></div><md-content layout-fill flex ms-scroll \nng-if=\"!vm.loading && !vm.error\"><div layout=\"column\" layout-margin class=\"mt-30\"><div layout=\"row\"><md-input-container\n flex><label>Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.template.name\" required></md-input-container>\n<md-input-container><label>Lang</label><input maxlength=\"10\" type=\"text\" name=\"lang\" ng-model=\"vm.template.lang\">\n</md-input-container><md-input-container><label translate=\"DOCUMENTS.ORIENTATION\">Ausrichtung</label><md-select \nname=\"orientation\" ng-model=\"vm.template.orientation\"><md-option ng-value=\"\'Portrait\'\"><span \ntranslate=\"DOCUMENTS.ORIENTATION_PORTRAIT\">Hochformat</span></md-option><md-option ng-value=\"\'Landscape\'\"><span \ntranslate=\"DOCUMENTS.ORIENTATION_LANDSCAPE\">Querformat</span></md-option></md-select></md-input-container></div>\n<md-input-container flex><label>Template HTML</label><textarea ng-model=\"vm.template.html\" md-select-on-focus required>\n</textarea></md-input-container></div></md-content></md-content></div></form></div>");
$templateCache.put("app/main/admin.documents/views/document-list.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"logo-icon\"><md-icon md-font-icon=\"icon-file-document\" class=\"icon\">\n</md-icon></div><span class=\"logo-text\" translate=\"ADMIN.DOCUMENTS_NAV\" flex>Documents</span></div></div><div \nclass=\"content-card\" style=\"margin-top: 4px\" layout=\"column\" flex><md-tabs flex><md-tab \nlabel=\"{{ \'DOCUMENTS.TEMPLATES\' | translate }}\"><md-content ms-scroll layout=\"column\" layout-fill><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" md-indeterminate=\"vm.templateSelection.isIndeterminate(vm.templates)\" \nng-checked=\"!vm.templateSelection.isIndeterminate(vm.templates) && vm.templateSelection.getSelected().length > 0\" \nng-click=\"vm.toggleSelectedTemplates()\"></md-checkbox><div layout=\"row\" \nng-if=\"vm.templateSelection.getSelected().length > 0\" layout-align=\"start center\"><nuit-selection-indicator \nselection=\"vm.templateSelection\" get-name=\"vm.getName\"></nuit-selection-indicator><div class=\"divider-vertical ml-20\">\n</div><md-button class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button>\n</div></div><md-button class=\"md-raised md-accent\" ui-sref=\"app.adminDocuments.compose\" \ntranslate=\"DOCUMENTS.ADD_TEMPLATE\">Add Document</md-button></div><div class=\"content-wrapper\" layout=\"column\" flex><div\n class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div><div ng-if=\"vm.templates.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"DOCUMENTS.EMPTY_LIST\">\nThere are no documents yet!</span></div><div class=\"thread unread\" ng-if=\"!vm.loading\" \nng-repeat=\"template in vm.templates track by $index\" ng-class=\"{\'selected\': vm.isSelected(template)}\" \nng-click=\"vm.openTemplate(template)\"><div layout=\"row\" layout-align=\"start center\" layout-fill><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isSelected(template)\" ng-click=\"vm.toggleSelectedTemplate(template, $event)\" \naria-label=\"{{vm.isSelected(template) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div class=\"info\" layout=\"column\" flex>\n<span class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\">{{ template.name}}<md-icon \nng-if=\"template.orientation && template.orientation !== \'Portrait\'\" class=\"s16 ml-8 grey-500-fg\" \nmd-font-icon=\"icon-crop-landscape\"><md-tooltip>\n{{ \'DOCUMENTS.ORIENTATION_\' + template.orientation.toUpperCase() | translate }}</md-tooltip></md-icon></span><div \nclass=\"message text-truncate\">{{ template.key}}</div></div><div flex></div><div layout=\"column\" \nlayout-align=\"center right\"><md-button class=\"light-blue-50-bg md-raised\" \nng-click=\"vm.preview(template.key, template.lang, $event)\" translate=\"DOCUMENT.PREVIEW\">Vorschau</md-button></div>\n</div></div></div></div></md-content></md-tab><md-tab label=\"{{ \'DOCUMENTS.LOCAL_TEMPLATES\' | translate }}\"><md-content\n ms-scroll layout=\"column\" layout-fill><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \nng-checked=\"!vm.localTemplateSelection.isIndeterminate(vm.localTemplates) && vm.localTemplateSelection.getSelected().length > 0\" \nmd-indeterminate=\"vm.localTemplateSelection.isIndeterminate(vm.localTemplates)\" \nng-click=\"vm.toggleSelectedLocalTemplates()\"></md-checkbox><div layout=\"row\" \nng-if=\"vm.localTemplateSelection.getSelected().length > 0\" layout-align=\"start center\"><nuit-selection-indicator \nselection=\"vm.localTemplateSelection\" get-name=\"vm.getName\"></nuit-selection-indicator><div \nclass=\"divider-vertical ml-20\"></div><md-button class=\"md-icon-button\" aria-label=\"delete\" \nng-click=\"vm.deleteSelectedLocalTemplates()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div><md-button class=\"md-raised md-accent\" \nui-sref=\"app.adminDocuments.compose({local:true})\" translate=\"DOCUMENTS.ADD_LOCAL_TEMPLATE\">Add Local Template\n</md-button></div><div class=\"content-wrapper\" layout=\"column\" flex><div class=\"content thread-list\" ms-scroll flex>\n<div ng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"vm.localTemplates.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"DOCUMENTS.EMPTY_LIST\">There are no documents yet!</span></div><div \nclass=\"thread unread\" ng-if=\"!vm.loading\" ng-repeat=\"template in vm.localTemplates track by $index\" \nng-class=\"{\'selected\': vm.isLocalTemplateSelected(template)}\" ng-click=\"vm.openTemplate(template, true)\"><div \nlayout=\"row\" layout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" \nng-checked=\"vm.isLocalTemplateSelected(template)\" ng-click=\"vm.toggleSelectedLocalTemplate(template, $event)\" \naria-label=\"{{vm.isLocalTemplateSelected(template) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div class=\"info\" \nlayout=\"column\" flex><span class=\"name text-truncate\" layout=\"row\" layout-align=\"start center\">{{ template.name}}\n<md-icon ng-if=\"template.orientation && template.orientation !== \'Portrait\'\" class=\"s16 ml-8 grey-500-fg\" \nmd-font-icon=\"icon-crop-landscape\"><md-tooltip>\n{{ \'DOCUMENTS.ORIENTATION_\' + template.orientation.toUpperCase() | translate }}</md-tooltip></md-icon></span><div \nclass=\"message text-truncate\">{{ template.key}}</div></div><div flex></div><div layout=\"column\" \nlayout-align=\"center right\"><md-button class=\"light-blue-50-bg md-raised\" \nng-click=\"vm.preview(template.key, template.lang, $event, true)\" translate=\"DOCUMENT.PREVIEW\">Vorschau</md-button>\n</div></div></div></div></div></md-content></md-tab><md-tab label=\"{{ docObject[\'key\'] | translate }}\" \nng-repeat=\"docObject in vm.documentObjects\"><md-content ms-scroll layout=\"column\" layout-fill><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" \nng-checked=\"!docObject.selection.isIndeterminate(docObject.documents) && docObject.selection.getSelected().length > 0\" \nmd-indeterminate=\"docObject.selection.isIndeterminate(docObject.documents)\" ng-click=\"docObject.toggleSelected()\">\n</md-checkbox><div layout=\"row\" ng-if=\"docObject.selection.getSelected().length > 0\" layout-align=\"start center\">\n<nuit-selection-indicator selection=\"docObject.selection\" get-name=\"vm.getName\"></nuit-selection-indicator><div \nclass=\"divider-vertical ml-20\"></div><md-button class=\"md-icon-button\" aria-label=\"delete\" \nng-click=\"docObject.deleteSelection()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div><md-button class=\"md-raised md-accent\" \nng-click=\"docObject.add()\" translate=\"DOCUMENTS.ADD_DOCUMENT\">Add Document</md-button></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><div class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.loading\" \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"docObject.documents.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"DOCUMENTS.EMPTY_LIST\">\nThere are no documents yet!</span></div><div class=\"thread unread\" ng-if=\"!vm.loading\" \nng-repeat=\"document in docObject.documents track by $index\" \nng-class=\"{\'selected\': docObject.selection.isSelected(document)}\" ng-click=\"docObject.edit(document)\"><div \nlayout=\"row\" layout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" \nng-checked=\"docObject.selection.isSelected(document)\" \nng-click=\"docObject.selection.toggleSelectedEntity(document, $event)\" \naria-label=\"{{docObject.selection.isSelected(document) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div class=\"info\" \nlayout=\"column\" flex><span class=\"name text-truncate\">{{ document.name | nuitTranslate }}</span><div \nclass=\"message text-truncate\">{{ document.key}}</div></div><div flex></div><div layout=\"column\" \nlayout-align=\"center right\"></div></div></div></div></div></md-content></md-tab></md-tabs></div>");
$templateCache.put("app/main/admin.documents/views/documents.html","<div id=\"admin-documents\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/admin.notifications/views/channels.html","<div layout=\"row\" layout-align=\"start center\"><span class=\"name\" flex><span>{{entity.name}}</span></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.editChannel(entity)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button class=\"md-icon-button md-raised md-warn\" ng-click=\"vm.removeChannel(entity)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div>");
$templateCache.put("app/main/admin.notifications/views/contents.html","<v-accordion><v-pane><div class=\"name\" flex><v-pane-header><div layout=\"row\" layout-align=\"space-between start\"><h3>\n<span class=\"text-bold\">{{entity.lang}}</span> <span>{{entity.contentType}}</span></h3><div layout=\"row\" \nlayout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"vm.editContent(entity);$event.stopPropagation();\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button md-raised md-warn\" \nng-click=\"vm.removeContent(entity);$event.stopPropagation();\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></div></v-pane-header><v-pane-content><h1 class=\"text-italic\" ng-if=\"entity.subject!==\'\'\">{{entity.subject}}</h1>\n<div ng-if=\"entity.contentType===\'text/html\'\" ng-bind-html=\"vm.renderContent(entity.tpl)\"></div><div \nng-if=\"entity.contentType!==\'text/html\'\" ng-bind-html=\"vm.renderContent(vm.insertBreaks(entity.tpl))\"></div>\n</v-pane-content></div></v-pane></v-accordion>");
$templateCache.put("app/main/admin.notifications/views/default.html","<div id=\"notifications\" layout=\"column\" flex><div \nstyle=\"background-image: url(\'/assets/images/backgrounds/header-bg.png\')\" class=\"md-accent-bg\" layout=\"row\" \nlayout-padding flex><div class=\"header\" layout=\"row\" flex><div class=\"logo\" layout=\"row\" layout-align=\"start center\" \nflex><md-button ng-if=\"vm.hasParent\" class=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"^.\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-worker\" class=\"icon\"></md-icon></span><span class=\"logo-text\" flex>{{vm.header | translate}}</span> \n<span flex></span><md-button class=\"md-raised\" ng-click=\"vm.add()\"><label translate=\"APP.ADD\"></label></md-button>\n</div></div></div><md-content ms-scroll flex><div ng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div><div ng-if=\"(vm.entities.length === 0 || vm.entities === null) && !vm.loading\" \nclass=\"no-threads mv-10\" layout=\"column\" layout-align=\"center center\" layout-fill><span class=\"md-headline\">\n{{::vm.noEntities | translate}}</span></div><div ng-if=\"!vm.loading\" layout=\"row\" layout-align=\"space-between\" \nlayout-wrap layout-padding layout-margin><md-card ng-repeat=\"entity in vm.entities track by $index\" \nflex=\"{{vm.flex?vm.flex:\'none\'}}\"><div layout=\"column\"><ng-include \nsrc=\"\'app/main/admin.notifications/views/\' + vm.htmlTemplate + \'.html\'\"></ng-include></div></md-card></div>\n</md-content></div>");
$templateCache.put("app/main/admin.notifications/views/event-additional.html","<div layout=\"row\" layout-align=\"start center\"><span class=\"name\" flex><span>\n{{entity.contactData.email}} {{entity.contactData.phone}} {{entity.contactData.lang}}</span></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.edit(entity)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-raised md-warn\" ng-click=\"vm.remove(entity)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/admin.notifications/views/event-custom.html","<div layout=\"row\" layout-align=\"start center\"><span class=\"name\" flex><span>{{entity.name}}</span></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.edit(entity)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-raised md-warn\" ng-click=\"vm.remove(entity)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/admin.notifications/views/event-roles.html","<div layout=\"row\" layout-align=\"start center\"><span class=\"name\" flex><span>{{entity.role.name | nuitTranslate}}</span>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.edit(entity)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button md-raised md-warn\" ng-click=\"vm.remove(entity)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div>");
$templateCache.put("app/main/admin.notifications/views/event-triggers.html","<div layout=\"row\" layout-align=\"start center\"><span class=\"name\" flex><div>{{entity.type}} {{entity.name}}</div><div>\n{{entity.prettyConditions}}</div></span><md-button class=\"md-icon-button\" ng-click=\"vm.edit(entity)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button md-raised md-warn\" \nng-click=\"vm.remove(entity)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div>");
$templateCache.put("app/main/admin.notifications/views/event-users.html","<div layout=\"row\" layout-align=\"start center\"><span class=\"name\" flex><span>\n{{entity.user.firstName}} {{entity.user.lastName}} {{entity.user.email}}</span></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.edit(entity)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-raised md-warn\" ng-click=\"vm.remove(entity)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/admin.notifications/views/events.html","<div layout=\"row\" layout-padding layout=\"start start\" flex><div flex>{{entity.name}} {{vm.getTemplateName(entity)}}\n</div><md-button class=\"md-icon-button\" ng-click=\"vm.editEvent(entity)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button md-raised md-warn\" ng-click=\"vm.removeEvent(entity)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div><div layout=\"column\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.notification-events.users({eventId:entity.id})\" flex><label translate=\"NOTIFICATIONS.USERS\"></label>\n</md-button><md-button class=\"md-raised md-accent\" ui-sref=\"app.notification-events.roles({eventId:entity.id})\" flex>\n<label translate=\"NOTIFICATIONS.ROLES\"></label></md-button><md-button class=\"md-raised md-accent\" \nui-sref=\"app.notification-events.additional({eventId:entity.id})\" flex><label translate=\"NOTIFICATIONS.ADDITIONAL\">\n</label></md-button><md-button class=\"md-raised md-accent\" \nui-sref=\"app.notification-events.custom({eventId:entity.id})\" flex><label translate=\"NOTIFICATIONS.CUSTOM\"></label>\n</md-button><md-button class=\"md-raised md-accent\" ui-sref=\"app.notification-events.triggers({eventId:entity.id})\" \nflex><label translate=\"NOTIFICATIONS.TRIGGERS\"></label></md-button></div>");
$templateCache.put("app/main/admin.notifications/views/templates.html","<div layout=\"row\" layout=\"center center\" flex layout-margin><span flex>{{entity.name}}</span> <span flex>\n{{entity.schema}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.editTemplate(entity)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button md-raised md-warn\" \nng-click=\"vm.removeTemplate(entity)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div><div \nlayout=\"column\" flex><md-button class=\"md-raised md-accent\" \nui-sref=\"app.notification-templates{{vm.global?\'-global\':\'\'}}.content({templateId:entity.id})\" flex><label \ntranslate=\"NOTIFICATIONS.CONTENT\"></label></md-button></div>");
$templateCache.put("app/main/admin.environment/views/admin-environment.html","<div id=\"admin-environment\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between end\" flex class=\"pb-10\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\" flex><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-home-variant\" class=\"icon\">\n</md-icon></span><span class=\"logo-text\" translate=\"ADMIN.ENVIRONMENT_NAV\" flex>Umgebung</span></div><md-button \nclass=\"md-raised\" ng-click=\"vm.save()\"><span translate=\"APP.SAVE\">Save</span></md-button></div></div><div \nclass=\"content\" flex layout=\"column\"><md-tabs layout-fill flex md-selected=\"vm.currentTab\"><md-tab \nmd-active=\"vm.currentTab === \'general\'\" ui-sref=\"app.adminEnvironment({active:\'general\'})\"><md-tab-label><span \ntranslate=\"APP.GENERAL\">General</span></md-tab-label><md-tab-body layout-fill><ng-include \nsrc=\"\'app/main/admin.environment/views/tabs/general.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nmd-active=\"vm.currentTab === \'css\'\" ui-sref=\"app.adminEnvironment({active:\'css\'})\"><md-tab-label><span \ntranslate=\"APP.CSS\">CSS</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/admin.environment/views/tabs/css.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nlabel=\"{{ \'SETUP.LOCALIZATION\' | translate }}\" ui-sref=\"app.adminEnvironment({active:\'localization\'})\" \nmd-active=\"vm.currentTab == \'localization\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/localization.html\'\">\n</ng-include></md-tab><md-tab md-active=\"vm.currentTab === \'modules\'\" \nui-sref=\"app.adminEnvironment({active:\'modules\'})\"><md-tab-label><span translate=\"APP.MODULES\">Modules</span>\n</md-tab-label><md-tab-body><ng-include src=\"\'app/main/admin.environment/views/tabs/modules.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab label=\"{{ \'SETUP.IMS\' | translate }}\" ui-sref=\"app.adminEnvironment({active:\'ims\'})\" \nmd-active=\"vm.currentTab == \'ims\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/ims.html\'\"></ng-include>\n</md-tab><md-tab label=\"{{ \'SETUP.EVO\' | translate }}\" ui-sref=\"app.adminEnvironment({active:\'evo\'})\" \nmd-active=\"vm.currentTab == \'evo\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/evo.html\'\"></ng-include>\n</md-tab><md-tab label=\"{{ \'SETUP.EDITOR\' | translate }}\" ui-sref=\"app.adminEnvironment({active:\'editor\'})\" \nmd-active=\"vm.currentTab == \'editor\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/editor.html\'\"></ng-include>\n</md-tab><md-tab md-active=\"vm.currentTab === \'theme\'\" ui-sref=\"app.adminEnvironment({active:\'theme\'})\"><md-tab-label>\n<span translate=\"APP.THEME\">Theme</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/admin.environment/views/tabs/theme.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nmd-active=\"vm.currentTab === \'maintenance\'\" ui-sref=\"app.adminEnvironment({active:\'maintenance\'})\"><md-tab-label><span \ntranslate=\"APP.MAINTENANCE\">Maintenance</span></md-tab-label><md-tab-body><div ui-view=\"maintenance\"></div>\n</md-tab-body></md-tab><md-tab md-active=\"vm.currentTab === \'config\'\" \nui-sref=\"app.adminEnvironment({active:\'config\'})\"><md-tab-label><span translate=\"APP.CONFIG\">Config</span>\n</md-tab-label><md-tab-body><ng-include src=\"\'app/main/admin.environment/views/tabs/configuration.html\'\"></ng-include>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/admin.environment/views/config-compose.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\">Add Config</div></md-toolbar><md-content><form class=\"p-10\" \nname=\"vm.configForm\" novalidate ng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\" layout=\"column\">\n<md-input-container required flex><label>Type</label><nuit-select-by-id on-change=\"vm.resetValue\" \ncurrent-id=\"vm.config.type\" list=\"vm.types\" entity-format=\"name\"></nuit-select-by-id></md-input-container>\n<md-input-container flex><label>Key</label><input type=\"text\" required ng-minlength=\"1\" ng-model=\"vm.config.key\">\n</md-input-container><md-input-container ng-if=\"vm.config.type===4\"><label>Value</label><md-switch \nng-model=\"vm.config.value\"></md-switch></md-input-container><md-input-container ng-if=\"vm.config.type!==4\"><label>Value\n</label><input type=\"text\" ng-minlength=\"1\" required ng-model=\"vm.config.value\"></md-input-container></form>\n</md-content><md-dialog-actions><div layout=\"row\" layout-margin layout-align=\"space-between start\"><md-button \nclass=\"md-warn md-raised\" ng-disabled=\"vm.configForm.$invalid || vm.configForm.$pristine\" ng-click=\"vm.save()\" \ntranslate=\"APP.SAVE\">Save</md-button><md-button class=\"md-raised\" ng-click=\"vm.hide()\" translate=\"APP.CANCEL\">Cancel\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.setup/views/edit-setup.html","<div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" \nflex><form name=\"vm.itemForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.adminSetup\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span class=\"md-title mr-15\" \nng-if=\"!vm.editName\">{{ vm.template.name | nuitTranslate }}</span><md-input-container ng-if=\"vm.editName\" \nclass=\"md-block mt-24 mb-0 pt-0 pb-0\"><label translate=\"TEMPLATE.NAME\">Name</label><input type=\"text\" \nng-model=\"vm.template.name[vm.currentLanguage]\" required></md-input-container><md-input-container ng-if=\"vm.editName\" \nclass=\"md-block\"><label translate=\"APP.LANGUAGE\">Lang</label><md-select ng-model=\"vm.currentLanguage\" \nng-change=\"vm.onLanguageSelect(vm.currentLanguage)\"><md-option ng-repeat=\"lang in vm.languages\" \nng-value=\"lang.value.code\"><div layout=\"row\" layout-align=\"start center\"><img class=\"flag mr-10\" \nng-src=\"{{ lang.value.flag }}\"> <span class=\"text-uppercase\">{{ lang.value.code }}</span></div></md-option><md-option \nng-value=\"\'$\'\"><md-icon class=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" \ntranslate=\"SETUP.ADD_LANGUAGE\"></span></md-option></md-select></md-input-container><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Edit\" ng-click=\"vm.editName = !vm.editName\"><md-icon \nng-if=\"!vm.editName\" md-font-icon=\"icon-pencil\"></md-icon><md-icon ng-if=\"vm.editName\" md-font-icon=\"icon-no\">\n</md-icon></md-button></div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-warn md-raised\" \nng-click=\"vm.save()\" ng-disabled=\"!vm.itemForm.$valid || !vm.itemForm.$dirty\" translate=\"APP.SAVE\">Speichern\n</md-button></div></div><md-content ms-scroll class=\"content-wrapper\" layout=\"column\" layout-fill flex><md-tabs \nlayout-fill md-selected=\"vm.selectedTab\"><md-tab label=\"{{ \'SETUP.GENERAL\' | translate }}\" \nui-sref=\"app.adminSetup.detail({active:\'general\'})\" md-active=\"vm.currentTab == \'general\'\"><ng-include \nsrc=\"\'app/main/admin.setup/views/partials/general.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'SETUP.MODULES\' | translate }}\" ui-sref=\"app.adminSetup.detail({active:\'modules\'})\" \nmd-active=\"vm.currentTab == \'modules\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/modules.html\'\">\n</ng-include></md-tab><md-tab label=\"{{ \'SETUP.LOCALIZATION\' | translate }}\" \nui-sref=\"app.adminSetup.detail({active:\'localization\'})\" md-active=\"vm.currentTab == \'localization\'\"><ng-include \nsrc=\"\'app/main/admin.setup/views/partials/localization.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'SETUP.DESIGN\' | translate }}\" ui-sref=\"app.adminSetup.detail({active:\'design\'})\" \nmd-active=\"vm.currentTab == \'design\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/design.html\'\"></ng-include>\n</md-tab><md-tab label=\"{{ \'SETUP.IMS\' | translate }}\" ui-sref=\"app.adminSetup.detail({active:\'ims\'})\" \nmd-active=\"vm.currentTab == \'ims\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/ims.html\'\"></ng-include>\n</md-tab><md-tab label=\"{{ \'SETUP.EVO\' | translate }}\" ui-sref=\"app.adminSetup.detail({active:\'evo\'})\" \nmd-active=\"vm.currentTab == \'evo\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/evo.html\'\"></ng-include>\n</md-tab><md-tab label=\"{{ \'SETUP.EDITOR\' | translate }}\" ui-sref=\"app.adminSetup.detail({active:\'editor\'})\" \nmd-active=\"vm.currentTab == \'editor\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/editor.html\'\"></ng-include>\n</md-tab><md-tab label=\"{{ \'SETUP.DOCUMENTS\' | translate }}\" ui-sref=\"app.adminSetup.detail({active:\'documents\'})\" \nmd-active=\"vm.currentTab == \'documents\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/documents.html\'\">\n</ng-include></md-tab><md-tab label=\"{{ \'SETUP.META\' | translate }}\" ui-sref=\"app.adminSetup.detail({active:\'meta\'})\" \nmd-active=\"vm.currentTab == \'meta\'\"><ng-include src=\"\'app/main/admin.setup/views/partials/meta.html\'\"></ng-include>\n</md-tab></md-tabs></md-content></form></div>");
$templateCache.put("app/main/admin.setup/views/list.html","<div class=\"header\" layout=\"row\" layout-align=\"start end\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.term\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.filterAll()\" \nng-model-options=\"{debounce:300}\"></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleSelection()\"></md-checkbox><div \nlayout=\"row\" ng-if=\"vm.getSelected().length > 0\" layout-align=\"center center\"><nuit-selection-indicator \nselection=\"vm.selection\" get-name=\"vm.getName\"></nuit-selection-indicator><md-button class=\"md-icon-button\" \naria-label=\"copy\" ng-click=\"vm.copySelected()\" ng-disabled=\"vm.getSelected().length > 1\"><md-icon \nmd-font-icon=\"icon-content-copy\"></md-icon><md-tooltip><span translate=\"APP.COPY\">Copy</span></md-tooltip></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button>\n</div></div><div layout=\"row\" layout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredTemplates\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" entities-per-page=\"10\"></nuit-pagination>\n</div></div><div class=\"content-wrapper\" layout=\"column\" flex><div class=\"content thread-list\" ms-scroll flex><div \nng-if=\"vm.isLoading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...</span></div><div \nng-if=\"vm.templates.length === 0 && !vm.isLoading\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"SETUP.EMPTY\">Es wurden keine Templates gefunden!</span></div><div \nclass=\"thread unread\" ng-if=\"!vm.isLoading\" ng-repeat=\"template in vm.currentPageEntities track by template.id\" \nng-class=\"{\'selected\': vm.isSelected(template)}\" ng-click=\"vm.openTemplate(template)\"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(template)\" \nng-click=\"vm.toggleSelect(template, $event)\" aria-label=\"{{vm.isSelected(template) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"avatar\" ng-if=\"template.image\"><img http-src=\"{{ ::template.image }}\"></div><div \nclass=\"pl-10\" ng-if=\"!template.image\"><md-icon md-font-icon=\"icon-book-open\"></md-icon></div><div class=\"info\" \nlayout=\"column\" layout-align=\"center start\" flex><span class=\"name text-truncate pt-8\">\n{{ template.name | nuitTranslate }}</span><div class=\"message text-truncate\" \nng-if=\"template.meta.category !== undefined\"><span>\n{{ vm.getCategoryById(template.meta.category).value.name | nuitTranslate }}</span></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/admin.setup/views/main.html","<div id=\"setup\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav\n class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ms-scroll ms-sidenav-helper><div \nclass=\"header\" layout=\"column\" layout-align=\"center center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-icon\"><md-icon md-font-icon=\"icon-book-open\" class=\"icon\"></md-icon></span><span \nclass=\"logo-text text-truncate\" translate=\"SETUP.SETUP_NAV\">Setup</span></div></div><md-content ms-scroll \nclass=\"content\" flex><div class=\"compose-button\" layout=\"row\" layout-align=\"center\"><md-button \nclass=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"vm.addSetup()\" translate=\"SETUP.ADD\">ADD NEW SETUP\n</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-divider></md-divider><div \nng-if=\"vm.categoriesLoading && vm.categories.length === 0\" class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular></div><div class=\"masteritem\" aria-label=\"inbox\"><div layout=\"column\" \nstyle=\"margin: 0; padding: 0\"><md-list-item layout=\"row\" class=\"masteritem-teaser\" style=\"padding: 0\" \nlayout-align=\"space-between center\" layout-fill ui-sref=\"app.adminSetup({category:undefined})\" \nui-sref-opts=\"{inherit:false}\" ui-sref-active=\"selected\"><div layout=\"row\" layout-align=\"start center\" flex \nclass=\"pl-8\"><span class=\"title text-truncate\" flex translate=\"APP.SHOW_ALL\"></span></div></md-list-item></div></div>\n<div class=\"masteritem\" aria-label=\"inbox\" ng-repeat=\"category in vm.categories track by category.id\"><div \nlayout=\"column\" style=\"margin: 0; padding: 0\"><md-list-item layout=\"row\" class=\"masteritem-teaser\" style=\"padding: 0\" \nlayout-align=\"space-between center\" layout-fill ui-sref=\"app.adminSetup({category:category.id})\" \nui-sref-opts=\"{inherit:false}\" ui-sref-active=\"selected\"><div layout=\"row\" layout-align=\"start center\" flex \nng-class=\"{\'pl-8\': !vm.categoryEditing}\"><md-button ng-click=\"vm.editCategory(category, $event)\" \nng-if=\"vm.categoryEditing\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"><md-tooltip><span \ntranslate=\"APP.EDIT\"></span></md-tooltip></md-icon></md-button><span class=\"title text-truncate\" flex>\n{{ category.value.name | nuitTranslate }}</span><md-button ng-click=\"vm.deleteCategory(category, $event)\" \nng-if=\"vm.categoryEditing\" class=\"md-icon-button\"><md-icon ng-if=\"vm.categoryEditing\" md-font-icon=\"icon-trash\" \nclass=\"s16\" ng-click=\"vm.deleteCategory(category, $event)\"></md-icon><md-tooltip><span translate=\"APP.DELETE\"></span>\n</md-tooltip></md-button></div></md-list-item></div></div><md-button class=\"md-raised md-accent ml-20 mr-20\" \nng-if=\"vm.categoryEditing\" ng-click=\"vm.addCategory()\" translate=\"SETUP.ADD_CATEGORY\">Add category</md-button><div \nclass=\"item subheader\" ng-click=\"vm.toggleEditing()\"><span translate=\"SETUP.EDIT_CATEGORIES\" \nng-if=\"!vm.categoryEditing\">Edit categories</span> <span translate=\"SETUP.VIEW_CATEGORIES\" ng-if=\"vm.categoryEditing\">\nView categories</span></div><md-divider></md-divider><div class=\"compose-button\" layout=\"row\" layout-align=\"center\">\n<md-button class=\"md-accent md-raised text-truncate\" aria-label=\"manage\" ng-click=\"vm.manageDefinitions()\" \ntranslate=\"SETUP.MANAGE_DEFINITIONS\">Manage definitions</md-button></div></div></md-content></md-sidenav><div \nclass=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/admin.status/views/admin-status.html","<div id=\"admin-status\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><div class=\"logo-icon\"><md-icon md-font-icon=\"icon-chart-bar\" \nclass=\"icon\"></md-icon></div><div class=\"logo-text\" translate=\"STATUS.STATUS_NAV\">Clients</div></div><div><md-button \nclass=\"md-raised\" ng-click=\"vm.rebuildEVO()\" translate=\"BUILD.EVO\">Build EVO</md-button><md-button class=\"md-raised\" \nng-click=\"vm.rebuildIMS()\" translate=\"BUILD.IMS\">Build IMS</md-button></div></div><div class=\"content-card\" \nlayout=\"row\" flex><md-tabs layout-fill><md-tab label=\"{{ \'APP.PROGRESS\' | translate }}\"><div layout=\"row\"><div \nclass=\"content-wrapper\" layout=\"column\" layout-padding flex=\"50\"><h2>nuEvolution</h2><strong>Status: Beta</strong> \n<span>Functionality ({{vm.dd.progress}}%)</span><md-progress-linear style=\"max-width:50%\" md-mode=\"determinate\" \nvalue=\"{{vm.dd.progress}}\"></md-progress-linear><span>Polishing ({{vm.dd.polishing}}%)</span><md-progress-linear \nstyle=\"max-width:50%\" md-mode=\"determinate\" value=\"{{vm.dd.polishing}}\"></md-progress-linear><md-list ng-cloak>\n<md-subheader class=\"md-no-sticky\">In progress</md-subheader><md-divider></md-divider><md-list-item ng-click=\"null\">\n<md-icon md-font-icon=\"icon-sim-alert\"></md-icon><p><span style=\"color: green\">EVO</span> - Polishing</p>\n</md-list-item><md-list-item ng-click=\"null\"><md-icon md-font-icon=\"icon-sim-alert\"></md-icon><p><span \nstyle=\"color: green\">IMS</span> - Polishing</p></md-list-item></md-list></div><div class=\"content-wrapper\" \nlayout=\"column\" layout-padding flex=\"50\"><h2>nuProduction</h2><strong>Status: Alpha</strong> <span>\nFunctionality ({{vm.sp.progress}}%)</span><md-progress-linear style=\"max-width:50%\" md-mode=\"determinate\" \nvalue=\"{{vm.sp.progress}}\"></md-progress-linear><span>Polishing ({{vm.sp.polishing}}%)</span><md-progress-linear \nstyle=\"max-width:50%\" md-mode=\"determinate\" value=\"{{vm.sp.polishing}}\"></md-progress-linear><md-list ng-cloak>\n<md-subheader class=\"md-no-sticky\">Missing features</md-subheader><md-divider></md-divider><md-list-item \nng-click=\"null\"><md-icon md-font-icon=\"icon-sim-alert\"></md-icon><p><span style=\"color: red\">IMS</span>\n - Easy Production</p></md-list-item><md-list-item ng-click=\"null\"><md-icon md-font-icon=\"icon-sim-alert\"></md-icon><p>\n<span style=\"color: red\">IMS</span> - Controlling: Material</p></md-list-item></md-list></div><div \nclass=\"content-wrapper\" layout=\"column\" layout-padding flex=\"50\"><h2>nuOrder</h2><strong>Status: Pre-Alpha</strong> \n<span>Functionality ({{vm.sales.progress}}%)</span><md-progress-linear style=\"max-width:50%\" md-mode=\"determinate\" \nvalue=\"{{vm.sales.progress}}\"></md-progress-linear><span>Polishing ({{vm.sales.polishing}}%)</span><md-progress-linear \nstyle=\"max-width:50%\" md-mode=\"determinate\" value=\"{{vm.sales.polishing}}\"></md-progress-linear></div></div></md-tab>\n<md-tab label=\"{{ \'API.SHOP_SERVICE\' | translate }}\"><div style=\"overflow:hidden\" layout-fill layout-padding><iframe \nlayout-fill ng-src=\"{{vm.getShopDebugURL()}}\"></iframe></div></md-tab><md-tab \nlabel=\"{{ \'API.DOCUMENT_SERVICE\' | translate }}\"><div style=\"overflow:hidden\" layout-fill layout-padding><iframe \nlayout-fill ng-src=\"{{vm.getDocumentDebugURL()}}\"></iframe></div></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/admin.translations/dialogs/translations.edit.html","<md-dialog aria-label=\"New Pair\" class=\"admin-translation-add-dialog\"><form name=\"translationForm\" \nng-submit=\"vm.submit()\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-if=\"!vm.newKey\" translate=\"APP.EDIT\">Edit\n</span> <span class=\"title\" ng-if=\"vm.newKey\" translate=\"TRANSLATIONS.ADD_TRANSLATION\">Neue Übersetzung</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label \ntranslate=\"TRANSLATIONS.KEY\">Bezeichnung</label><input type=\"text\" name=\"name\" ng-model=\"vm.key\" md-maxlength=\"100\" \nng-disabled=\"!vm.newKey\"><div ng-messages=\"translationForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container><div \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"lang in vm.availableLanguages\"><span \nclass=\"text-uppercase md-subhead\">{{ lang }}</span><md-input-container md-no-float flex class=\"mb-0 ml-16\"><input \ntype=\"text\" ng-model=\"vm.translation[lang]\" aria-label=\"your translation\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\"><md-button type=\"reset\" ng-click=\"vm.cancel()\"><span \ntranslate=\"APP.CANCEL\">Cancel</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"translationForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/admin.translations/views/admin-translations.html","<div id=\"admin-translations\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\"><div class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-library-books\" class=\"icon\"></md-icon></div><div class=\"logo-text\" translate=\"ADMIN.TRANSLATIONS\">\nTranslations</div></div><div><md-button class=\"md-raised\" ng-click=\"vm.showNewTranslationDialog()\" \ntranslate=\"TRANSLATIONS.ADD_TRANSLATION\" layout-align=\"end center\">Add translation</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.showImportTranslationsDialog()\" translate=\"TRANSLATIONS.IMPORT_TRANSLATIONS\">\nImport translations</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><strong \nclass=\"translation-count\">{{ vm.getTranslationCount()}}</strong> <span class=\"ml-8\" \ntranslate=\"TRANSLATIONS.TRANSLATIONS_FOUND\">Translations found</span></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"search\"><md-icon class=\"\" md-font-icon=\"icon-magnify\"></md-icon><span class=\"mr-10\"><span \ntranslate=\"APP.SEARCH\">Search</span>:</span> <input class=\"md-grey-100-bg\" type=\"text\" ng-model=\"vm.searchText\" \nng-change=\"vm.filterAll()\"></div><div layout=\"row\" layout-align=\"start center\"><nuit-pagination \nall-entities=\"vm.filteredTranslations\" current-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" \nentities-per-page=\"10\"></nuit-pagination></div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content \nclass=\"content\" ms-scroll flex layout-fill layout=\"row\"><div ng-if=\"vm.isLoading()\" class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span \ntranslate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"vm.nuitLanguage.getKeyCount() === 0 && !vm.isLoading()\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"TRANSLATIONS.EMPTY\">\nThere are no translations yet!</span></div><table class=\"simple\" id=\"translationsTable\" ng-if=\"!vm.isLoading()\"><thead>\n<tr><th></th><th>KEY</th><th ng-repeat=\"langKey in vm.languages| orderBy: langKey\" class=\"text-uppercase\">{{::langKey}}\n</th><th></th></tr></thead><tbody><tr ng-repeat=\"entry in vm.currentPageEntities\"><td><md-button \nclass=\"md-icon-button\" ng-click=\"vm.showEditTranslationDialog(entry.key)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><md-tooltip><span translate=\"APP.EDIT\">Edit</span></md-tooltip></md-button></td><td><span \nclass=\"text-truncate\" title=\"{{::entry.key}}\">{{::entry.key}}</span></td><td \nng-repeat=\"langKey in vm.languages| orderBy: langKey\">{{ entry.values[langKey] || \'---\'}}</td><td><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteTranslation(entry.key)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></td></tr></tbody></table></md-content>\n</div></div></div></div>");
$templateCache.put("app/main/auth/views/create.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img width=\"150\" \nheight=\"56\" title=\"\" alt=\"\" \nsrc=\"data:image/png;base64,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\">\n</div><div class=\"title\">{{vm.getTranslation(vm.translations.title)}}</div><form name=\"vm.createEnvForm\" novalidate \nng-submit=\"vm.create()\"><div class=\"error\" ng-if=\"vm.error\" layout=\"row\" layout-align=\"center start\"><p>{{vm.error}}\n</p></div><div ng-if=\"vm.error\">&nbsp;</div><form name=\"vm.key\"><md-input-container class=\"md-block\" md-no-float>\n<label>{{ vm.getTranslation(vm.translations.key) }}</label><input type=\"text\" name=\"key\" ng-model=\"vm.form.key\" \ntranslate required ng-disabled=\"vm.inProgress\" minlength=\"7\"></md-input-container></form><form name=\"vm.name\">\n<md-input-container class=\"md-block\" md-no-float><label>{{ vm.getTranslation(vm.translations.environment) }}</label>\n<input type=\"text\" name=\"name\" ng-model=\"vm.form.name\" translate required ng-disabled=\"vm.inProgress\">\n</md-input-container></form><form name=\"vm.email\"><md-input-container class=\"md-block\" md-no-float><label>\n{{ vm.getTranslation(vm.translations.email)}}</label><input type=\"email\" name=\"email\" ng-model=\"vm.form.user.email\" \nng-pattern=\"/^.+@.+\\..+$/\" required ng-disabled=\"vm.inProgress\"></md-input-container></form><form name=\"vm.password\">\n<md-input-container class=\"md-block\" md-no-float><label>{{ vm.getTranslation(vm.translations.password)}}</label><input \ntype=\"password\" name=\"password\" ng-model=\"vm.form.user.password\" required minlength=\"8\" ng-disabled=\"vm.inProgress\">\n</md-input-container></form><md-button class=\"md-raised md-primary submit-button\" \nng-disabled=\"vm.key.$invalid || vm.email.$invalid || vm.password.$invalid || vm.inProgress\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.create()\"><div layout=\"row\" layout-align=\"center center\"><div>\n{{ vm.getTranslation(vm.translations.create)}}</div><div ng-if=\"vm.inProgress\" style=\"width:10px\"></div>\n<md-progress-circular ng-if=\"vm.inProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"24\">\n</md-progress-circular></div></md-button></form></div></div></div>");
$templateCache.put("app/main/auth/views/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\" ng-if=\"!vm.contentOnly\"><div class=\"logo\">\n<img width=\"150\" height=\"56\" title=\"\" alt=\"\" \nsrc=\"data:image/png;base64,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\">\n</div><div class=\"title\">Please enter your data</div><form name=\"vm.loginForm\" novalidate ng-submit=\"vm.login()\"><div \nclass=\"error\" ng-if=\"vm.error\" layout=\"row\" layout-align=\"center start\"><p>{{vm.error}}</p></div><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"vm.loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email field is required</span></div><div ng-message=\"pattern\"><span>\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \nrequired><div ng-messages=\"vm.loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float \nng-if=\"vm.environments.length\"><md-select id=\"environments\" ng-model=\"vm.form.environment\" required \nplaceholder=\"Environment\" name=\"environment\"><md-select-header class=\"select-header p-10\"><input id=\"search\" \nng-model=\"searchText\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search\"><md-icon \nng-show=\"searchText && searchText.length>0\" md-font-icon=\"icon-close\" ng-click=\"searchText=\'\';\"></md-icon>\n</md-select-header><md-option \nng-if=\"searchText===\'\' || searchText===undefined || env.name.toLowerCase().indexOf(searchText.toLowerCase())>=0\" \nng-repeat=\"env in vm.environments track by env.id\" ng-value=\"env.id\">{{env.name}}</md-option></md-select><div \nng-messages=\"vm.loginForm.environment.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.ENVIRONMENT_REQUIRED\">Environment field is required</span></div></div></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-primary submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"vm.loginForm.$invalid\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form></div><div \nng-if=\"vm.contentOnly\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div></div></div>");
$templateCache.put("app/main/auth/views/reset.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><img width=\"120\" height=\"120\" title=\"\" alt=\"\" \nsrc=\"data:image/png;base64,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\">\n</div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password</div><form name=\"forgotPasswordForm\" \nnovalidate ng-submit=\"resetPassword()\"><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK</md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\"><a class=\"link\" ng-click=\"show(\'login\')\" translate=\"FORGOTPASSWORD.GO_BACK\">\nGo back to login</a></div></div></div></div>");
$templateCache.put("app/main/controlling.users/views/user-list.html","<div id=\"controlling-users\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start end\" \nstyle=\"max-height: 61px !important; min-height: 61px !important\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-chart-bar\" class=\"icon\"></md-icon>\n</span><span class=\"logo-text text-truncate\" translate=\"CONTROLLING_USERS\">Controlling Users</span></div></div><div \nlayout=\"row\" layout-align=\"space-between end\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchText\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" \nng-model-options=\"{debounce:1000}\"></div></div><div style=\"max-width: 420px; min-width: 420px; min-height: 60px\" \nclass=\"md-whiteframe-2dp user-controlling-filter grey-100-bg\" layout=\"row\" flex layout-align=\"space-around start\">\n<md-input-container class=\"mt-15 mb-5\" style=\"min-width: 100px !important\"><label translate=\"ACCOUNT.USER_ROLE\">\n</label><md-select class=\"search-switch\" ng-model=\"vm.filterRole\" md-on-close=\"vm.filterUsers()\"><md-option \nvalue=\"all\" translate=\"APP.ALL\"></md-option><md-option ng-repeat=\"type in vm.roles\" value=\"{{type.id}}\">\n{{type.name | nuitTranslate}}</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"start start\">\n<div><div class=\"mv-5\" translate=\"APP.PERIOD\"></div><span>{{vm.startFilterDate.getTime()/1000 | nuitDatetime:\'date\'}}\n</span> - <span>{{vm.endFilterDate.getTime()/1000 | nuitDatetime:\'date\'}}</span></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.changeFilterDate()\"><md-icon md-font-icon=\"icon-pencil\" \nng-if=\"!vm.selectStartAndEnd\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked-circle md-accent\" \nng-if=\"vm.selectStartAndEnd\"></md-icon></md-button><div ng-if=\"vm.selectStartAndEnd\" layout=\"row\" \nclass=\"datePickerRange md-whiteframe-2dp\"><div class=\"mr-10\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"mv-5\">{{\'APP.START\' | translate}}</div><md-calendar ng-model=\"vm.startFilterDate\" \nng-change=\"vm.checkEndFilterDate()\"></md-calendar></div><div class=\"mr-10\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"mv-5\">{{\'APP.END\' | translate}}</div><md-calendar ng-model=\"vm.endFilterDate\" \nng-change=\"vm.checkEndFilterDate()\"></md-calendar></div></div></div></div><div \nclass=\"md-whiteframe-1dp m-0 ph-20 pv-10 white-bg\" layout=\"column\" flex=\"nogrow\" layout-align=\"center center\"><div \nclass=\"font-size-38 blue-grey-fg\" style=\"line-height: 38px\">{{vm.allData[0]}}</div><div class=\"text-uppercase\" \nstyle=\"color: rgba(0,0,0,0.7)\"><span translate=\"CONTROLLING_USERS.TOTAL_ORDERS\"></span></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.loading\"><div flex=\"33\"><span translate=\"CONTROLLING_USERS.USERS\"></span> <span class=\"pl-5\">\n({{::vm.filteredEntities.length}})</span></div><div flex=\"33\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"CONTROLLING_USERS.PERCENTAGE\"></span></div><div flex=\"33\" class=\"ph-20 text-right\"><span \ntranslate=\"CONTROLLING_USERS.ORDERS_COUNT\"></span></div></div><div class=\"content-wrapper\" layout=\"column\" flex>\n<md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\">Loading ...</span></div><div \nng-if=\"vm.filteredEntities.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"CONTROLLING_USERS.NO_USERS\">\nThere are no orders yet!</span></div><div class=\"thread unread\" ng-if=\"!vm.loading\" \nng-repeat=\"data in vm.filteredEntities| orderBy:\'ordersCount\':(reverse=true) track by data.id \"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><div flex=\"33\"><div ng-if=\"data.user !== undefined\"><span class=\"text-bold\">\n{{data.user.lastName}}</span> <span>{{data.user.firstName}}</span></div><div ng-if=\"data.user === undefined\" \nclass=\"md-warn-fg\"><span translate=\"CONTROLLING_USERS.NO_USER\"></span></div></div><div flex=\"33\" layout=\"column\" \nlayout-align=\"center center\"><div style=\"width: 200px\"><div>{{vm.getPercent(data.ordersCount)}}%</div>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{::vm.getPercent(data.ordersCount)}}\">\n</md-progress-linear></div></div><div class=\"pr-40 text-right\" flex=\"33\"><span>{{data.ordersCount}}</span></div></div>\n</div></md-content></div></div></div></div>");
$templateCache.put("app/main/error/views/error-403.html","<div id=\"error\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">Error 403</div><div class=\"message\">\nYou are not allowed to access this site.</div><div class=\"sub-message\">\nPlease contact your supervisor to get the permissions to view this site.</div><a class=\"report-link md-accent-color\" \nng-click=\"vm.historyBack()\">Back</a></div></div>");
$templateCache.put("app/main/error/views/error-500.html","<div id=\"error\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">Error 500</div><div class=\"message\">\nA critical server error occured. Stay calm and <strong>do not panic!</strong></div><div class=\"sub-message\">\nWe will be back soon. Take a break and have a coffee meanwhile. If you\'re really stressed out and need to do some important stuff, send us a message by using the link below.\n<br>Have a nice day ;)</div><a class=\"report-link md-accent-color\" href=\"https://www.nu-it.at/contact.html\" \ntarget=\"_blank\">Report this problem</a></div></div>");
$templateCache.put("app/main/error/views/placeholder.html","<div><h1>Placeholder view</h1><p>\nThis view should never be visible as it is used for ims-next while an already implemented view is visible.</p></div>");
$templateCache.put("app/main/devices.printer/views/printer-details.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" flex><form\n name=\"vm.itemForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" ng-if=\"vm.sidebarEnabled()\" \nhide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-printer\" aria-label=\"Back\" ui-sref=\"app.printer\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span class=\"md-title\" \nng-if=\"vm.printerId && vm.printerId > 0\">{{ ::vm.printer.name }}</span> <span class=\"md-title\" \nng-if=\"!vm.printerId || vm.printerId <= 0\" translate=\"PRINTER.ADD\">Add printer</span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.savePrinter()\" \nng-disabled=\"!vm.itemForm.$valid || !vm.itemForm.$dirty\" translate=\"APP.SAVE\">Speichern</md-button></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><md-content layout=\"column\" layout-fill flex><div class=\"content\" \nng-if=\"vm.loadingItem\" flex><div class=\"loading-printers\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content \nms-scroll layout-fill ng-if=\"!vm.loadingItem\"><div layout=\"column\" layout-padding layout-margin><div layout=\"row\" \nlayout-margin><md-input-container flex><label translate=\"PRINTER.NAME\">Name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.printer.name\" required></md-input-container><md-input-container flex ng-if=\"vm.printerTypes.length > 0\">\n<label translate=\"PRINTER.TYPE\">Type</label><md-select ng-model=\"vm.printer.type\" required><md-option \nng-repeat=\"printerType in vm.printerTypes\" ng-value=\"printerType.type\">{{ printerType.name }}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-margin><md-input-container flex><label \ntranslate=\"PRINTER.LABEL_WIDTH\">Label width [mm]</label><input type=\"number\" ng-model=\"vm.printer.labelWidth\" \nname=\"labelWidth\" required></md-input-container><md-input-container flex><label translate=\"PRINTER.LABEL_HEIGHT\">\nLabel height [mm]</label><input type=\"number\" ng-model=\"vm.printer.labelHeight\" name=\"labelHeight\" required>\n</md-input-container></div><div layout=\"row\" layout-margin ng-if=\"vm.printer.token\"><md-input-container flex><label \ntranslate=\"PRINTER.TOKEN\">Token</label><input type=\"text\" ng-model=\"vm.printer.token\" name=\"token\" disabled=\"disabled\">\n</md-input-container></div></div></md-content></md-content></div></form></div>");
$templateCache.put("app/main/devices.printer/views/printer-list.html","<div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-printer\" class=\"icon\"></md-icon></span>\n<span class=\"logo-text\" translate=\"PRINTER.PRINTER\">Printer</span></div><div class=\"search-white\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input\" flex ng-model=\"vm.term\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" ng-model-options=\"{debounce:100}\"></div><md-button \nclass=\"md-raised\" ui-sref=\"app.printer.compose\" translate=\"APP.ADD\">Add Printer</md-button></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content-wrapper\" layout=\"column\" flex><div \nclass=\"content printer-list\" ms-scroll flex><div ng-if=\"vm.loadingItems\" class=\"loading-printers\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div><div ng-if=\"vm.items.length === 0 && !vm.loadingItems\" class=\"no-printers\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"PRINTER.NO_PRINTERS\">\nThere are no printers yet!</span></div><div class=\"printer\" ng-repeat=\"item in vm.items track by item.id\" \nng-if=\"vm.matchesFilter(item)\"><div layout=\"row\" layout-align=\"start center\" layout-fill ng-if=\"!vm.loadingItems\"><div \nclass=\"info\" layout=\"column\" flex><span class=\"name text-truncate\">{{ item.name }}</span><div \nclass=\"message text-truncate\"><span>{{ item.labelWidth }} mm x {{ item.labelHeight }} mm</span></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.openItem(item)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"APP.EDIT\">Edit</span></md-tooltip></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelectedItems(item)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/devices.printer/views/printer.html","<div id=\"printer\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/merchandising.materials/views/material-compose.html","<div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" \nflex ui-view=\"body\" ng-init=\"vm.init()\"><form name=\"vm.materialForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\" ng-submit=\"vm.saveMaterial()\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\" translate translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"app.materials\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" hide show-gt-xs><div class=\"divider-vertical mr-20\">\n</div><span class=\"md-title\" translate=\"MATERIALS.NEW_MATERIAL\">Neues Material</span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-warn md-raised\" type=\"submit\" \nng-disabled=\"!vm.materialForm.$dirty || !vm.materialForm.$valid \" translate=\"APP.SAVE\">Speichern</md-button></div>\n</div><md-content class=\"content-wrapper\" layout=\"column\" flex><ng-include \nsrc=\"\'app/main/merchandising.materials/views/partials/general.html\'\"></ng-include></md-content></form></div>");
$templateCache.put("app/main/merchandising.materials/views/material-details-bending.html","<table id=\"formatTable\" class=\"dataTable row-border hover\"><thead><tr><th class=\"text-center\" translate=\"APP.NAME\">\n</th><th class=\"text-center\" translate=\"APP.MATERIAL\"></th><th class=\"text-center\" translate=\"APP.EDIT\"></th><th \nclass=\"text-center\" translate=\"APP.DELETE\"></th></tr></thead><tbody><tr class=\"grey-100-bg\" \nng-repeat=\"bending in vm.bendings\"><td class=\"text-center w-200\">{{vm.getMachineName(bending.bendingMachineId)}}</td>\n<td class=\"text-center\">{{vm.getMetaData(bending)}}</td><td class=\"text-center w-100\"><md-button class=\"m-0\" \nng-click=\"vm.editBending(bending)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td \nclass=\"text-center w-100\"><md-button class=\"m-0\" ng-click=\"vm.deleteBending(bending)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></td></tr></tbody></table><div class=\"m-0 mt-32\" layout=\"row\" \nflex=\"40\"><md-button class=\"md-raised md-accent h-40\" ng-if=\"vm.availableMachines.length>0\" \nng-click=\"vm.showAddBendingDialog()\"><span translate=\"MACHINES.ADD_BENDING_MACHINE\">Neues Biegeformat anlegen</span>\n</md-button></div>");
$templateCache.put("app/main/merchandising.materials/views/material-details.html","<div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex><form name=\"vm.materialForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\" ng-submit=\"vm.updateMaterial()\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\" translate translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"app.materials\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" ng-show=\"vm.material\" hide show-gt-xs><div \nclass=\"divider-vertical mr-20\"></div><span class=\"md-title\">{{vm.material.name | nuitTranslate}}</span></div></div><div\n layout=\"row\" layout-align=\"start center\"><md-button class=\"md-warn md-raised\" type=\"submit\" \nng-disabled=\"!vm.materialForm.$dirty || !vm.materialForm.$valid\" translate=\"APP.SAVE\">Speichern</md-button></div></div>\n<div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex>\n<div class=\"content\" ng-if=\"vm.loadingMaterial\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><md-tabs layout-fill md-selected=\"vm.selectedTab\" ng-if=\"!vm.loadingMaterial\"><md-tab \nlabel=\"{{ \'MATERIALS.GENERAL\' | translate }}\" ui-sref=\"app.materials.detail({active:\'detail\'})\" \nmd-active=\"vm.currentTab == \'detail\'\" ng-if=\"vm.config.ims.materials.details.general.enabled\"><ng-include \nsrc=\"\'app/main/merchandising.materials/views/partials/general.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'MATERIALS.PRODUCTION\' | translate }}\" ui-sref=\"app.materials.detail({active:\'production\'})\" \nmd-active=\"vm.currentTab == \'production\'\" ng-if=\"vm.config.ims.materials.details.production.enabled\"><ng-include \nsrc=\"\'app/main/merchandising.materials/views/partials/production.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'MATERIALS.SALES\' | translate }}\" ui-sref=\"app.materials.detail({active:\'sales\'})\" \nmd-active=\"vm.currentTab == \'sales\'\" ng-if=\"vm.config.ims.materials.details.sales.enabled\"><ng-include \nsrc=\"\'app/main/merchandising.materials/views/partials/sales.html\'\"></ng-include></md-tab></md-tabs></md-content></div>\n</form></div>");
$templateCache.put("app/main/merchandising.materials/views/material-list.html","<div layout=\"row\" layout-align=\"space-between end\"><div layout=\"row\" class=\"mt-45\" layout-wrap><div \nclass=\"md-item-text mr-5 p-8 md-whiteframe-z1\" ng-if=\"!attribute.restrictions.hidden\" layout-wrap \nng-repeat=\"attribute in vm.attributes\" style=\"border-radius: 2px; cursor: pointer; margin-bottom: 6px\" \nng-class=\"{\'grey-900-fg\': vm.selectedAttributes.indexOf(attribute.id) ==-1,\'md-orange-300-bg\': vm.selectedAttributes.indexOf(attribute.id)!==-1,\'grey-200-bg\': vm.selectedAttributes.indexOf(attribute.id)===-1}\" \nng-click=\"vm.toggleAttribute(attribute.id)\">{{attribute.name | nuitTranslate}}</div></div><div class=\"compose-button\">\n<md-button class=\"md-raised\" aria-label=\"compose\" ng-if=\"vm.allowAdd\" ui-sref=\"app.materials.compose\" \ntranslate=\"APP.ADD\">ADD NEW MATERIAL</md-button></div></div><div class=\"\" layout=\"row\" layout-align=\"start end\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nflex ng-model=\"vm.term\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-change=\"vm.search()\" ng-model-options=\"{debounce:100}\"></div></div></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedMaterials.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleSelectedMaterials()\"></md-checkbox>\n<div layout=\"row\" ng-if=\"vm.getSelected().length > 0\" layout-align=\"center center\"><nuit-selection-indicator \nselection=\"vm.selection\" get-name=\"vm.getName\"></nuit-selection-indicator><md-button class=\"md-icon-button\" \naria-label=\"delete\" ng-click=\"vm.deleteSelection()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div><div layout=\"row\" \nng-if=\"vm.getSelected().length === 1\"><md-button class=\"md-icon-button\" aria-label=\"copy\" \nng-click=\"vm.copySelection()\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><md-tooltip><span \ntranslate=\"APP.COPY\">Copy</span></md-tooltip></md-button></div></div><div layout=\"row\" layout-align=\"start center\"><div\n layout=\"row\" layout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" entities-per-page=\"10\"></nuit-pagination>\n</div></div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll \nflex><div ng-if=\"vm.loadingMaterials\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"vm.materials.length === 0 && !vm.loadingMaterials\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"MATERIALS.NO_MATERIALS\">\nThere are no materials yet!</span></div><div class=\"thread unread\" ng-if=\"!vm.loadingMaterials\" \nng-repeat=\"material in vm.currentPageEntities track by material.id\" ng-class=\"{\'selected\': vm.isSelected(material)}\" \nng-click=\"vm.openMaterial(material.id)\"><div layout=\"row\" layout-align=\"start center\" layout-fill><md-checkbox \nclass=\"no-label pr-16\" ng-checked=\"vm.isSelected(material)\" ng-click=\"vm.toggleSelectMaterial(material, $event)\" \naria-label=\"{{vm.isSelected(material) ? \'Deselect\' : \'Select\'}}\" flex=\"noshrink\"></md-checkbox><div class=\"avatar\" \nflex=\"noshrink\" style=\"background:{{material.colors.front.hex}}\"></div><div class=\"info\" layout=\"column\" flex=\"100\">\n<span class=\"name text-truncate\">{{material.name | nuitTranslate}}</span><div class=\"message text-truncate\"><span>\n{{vm.getGroupById(material.rawMaterialId).name | nuitTranslate}}</span></div></div><div class=\"labels\" flex=\"60\" \nlayout=\"row\" layout-align=\"end start\" layout-wrap><div class=\"label md-blue-500-bg text-truncate\"><span \ntranslate=\"MATERIAL.WEIGHT\">Gewicht</span>: {{ ::material.weight | nuitUnit:\'pressure\' }}</div><div \nclass=\"label md-blue-500-bg text-truncate\" ng-class=\"{\'md-red-500-bg\':material.protectionFilm}\"><span \ntranslate=\"MATERIAL.PROTECTIVE_FILM\">Schutzfolie</span>: <span \ntranslate=\"{{::material.protectionFilm ? \'APP.YES\' : \'APP.NO\'}}\">Yes/No</span></div><div \nclass=\"label md-blue-500-bg text-truncate\"><span translate=\"MATERIAL.THICKNESS\">Stärke</span>\n: {{ ::material.thickness | nuitUnit:\'thickness\' }}</div><div class=\"label text-truncate\" \nng-class=\"{\'md-blue-500-bg\': material.active, \'md-red-500-bg\': !material.active}\"><span \ntranslate=\"MATERIAL.ACTIVE_EVO\">Bestellbar</span>: <span translate=\"{{material.active ? \'APP.YES\' : \'APP.NO\'}}\">Yes/No\n</span></div><div class=\"label md-blue-500-bg text-truncate\" ng-if=\"!attribute.restrictions.hidden\" \nng-repeat=\"attribute in material.attributes track by attribute.id\"><span \ntranslate=\"{{ attribute.name | nuitTranslate }}\"></span>: <span>{{attribute.value}}</span><md-tooltip><span \ntranslate=\"APP.ATTRIBUTE\">Attribute</span></md-tooltip></div><div class=\"label md-blue-500-bg text-truncate\" \nng-repeat=\"field in vm.config.ims.materials.list.customFields\" \nng-if=\"(field.format | nuitFormatter:material).length>0\"><span class=\"mr-10\">{{field.name | nuitTranslate}}</span> \n<span class=\"text-bold\">{{field.format | nuitFormatter:material}}</span></div></div><div layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" ng-disabled=\"vm.inProgress\" \nng-click=\"vm.toggleActive(material, $event)\"><md-icon \nmd-font-icon=\"{{material.active?\'icon-check-circle\':\'icon-checkbox-blank-circle-outline\'}}\"></md-icon><md-tooltip>\n<span>{{(material.active?\'APP.ACTIVE\':\'APP.INACTIVE\') | translate}}</span></md-tooltip></md-button></div></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/merchandising.materials/views/materials.html","<div id=\"materials\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\" layout=\"column\" layout-align=\"center center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-texture\" class=\"icon\"></md-icon></span>\n<span class=\"logo-text text-truncate\" translate=\"MATERIALS.MATERIALS_NAV\">Materialien</span></div></div><md-content \nms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" \naria-label=\"inbox\" ui-sref=\"app.materials({group:undefined})\" ui-sref-opts=\"{inherit:false}\" ui-sref-active=\"selected\">\n<div layout=\"row\" layout-align=\"space-between center\" layout-fill><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"title text-truncate\" translate=\"APP.SHOW_ALL\">Group</span></div></div></md-button><md-button class=\"item\" \naria-label=\"inbox\" ng-repeat=\"group in vm.groups | orderByNuitTranslated:\'name\'\" \nng-click=\"vm.updateGroup(group, $event)\" ui-sref=\"app.materials({group:group.id})\" ui-sref-opts=\"{inherit:false}\" \nui-sref-active=\"selected\" ng-class=\"{\'selected\':vm.isGroupActive(group)}\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-fill><div ng-if=\"group._isLoading === true\" layout=\"row\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"16\"></md-progress-circular></div><span ng-if=\"group._isLoading !== true\" class=\"title text-truncate\">\n{{group.name | nuitTranslate}}</span></div></md-button></div></md-content></md-sidenav><div class=\"center\" \nlayout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/merchandising.materials.attributes/views/attributes.html","<div id=\"attributes\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-food-variant\" class=\"icon\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"PRODUCTS.ATTRIBUTES_NAV\">Attributes</span></div><div class=\"search-white\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input\" flex ng-model=\"vm.term\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" ng-model-options=\"{debounce:100}\"></div><md-button \nclass=\"md-raised\" ng-click=\"vm.addAttribute()\" translate=\"APP.ADD\">Add</md-button></div><div class=\"content-card\" \nlayout=\"row\" layout-align=\"center start\" flex><div class=\"content-wrapper\" layout=\"column\" layout-padding flex=\"100\">\n<md-content layout-padding><table class=\"simple\" ng-if=\"!vm.isLoading()\"><thead><tr><th><span \ntranslate=\"ATTRIBUTE.NAME\"></span></th><th><span translate=\"ATTRIBUTE.TYPE\"></span></th><th \nstyle=\"min-width: 48px !important;max-width:48px !important;width:48px !important\"></th><th \nstyle=\"min-width: 48px !important;max-width:48px !important;width:48px !important\"></th><th \nstyle=\"min-width: 48px !important;max-width:48px !important;width:48px !important\"></th></tr></thead><tbody><tr \nng-repeat=\"attribute in vm.attributes | filter: vm.filterAttribute track by attribute.id\"><td \ntranslate=\"{{attribute.name[vm.currentLanguage]}}\"></td><td ng-switch=\"attribute.type\"><span ng-switch-when=\"number\" \ntranslate=\"APP.NUMBER\"></span> <span ng-switch-when=\"string\" translate=\"APP.STRING\"></span></td><td><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleVisibility(attribute)\"><md-icon md-font-icon=\"icon-eye-off red-500-fg\" \nng-if=\"attribute.restrictions.hidden\"></md-icon><md-icon md-font-icon=\"icon-eye blue-grey-400-fg\" \nng-if=\"!attribute.restrictions.hidden\"></md-icon><md-tooltip><span translate=\"ATTRIBUTE.TOGGLE_VISIBILITY\">\nToggle visibility</span></md-tooltip></md-button></td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.editAttribute(attribute)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span \ntranslate=\"APP.EDIT\">Edit</span></md-tooltip></md-button></td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteAttribute(attribute)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></td></tr></tbody></table></md-content></div></div></div>\n</div>");
$templateCache.put("app/main/merchandising.materials.groups/views/material-groups.html","<div id=\"attributes\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-group\" \nclass=\"icon\"></md-icon></span><span class=\"logo-text\" translate=\"MATERIAL.GROUPS_NAV\">Groups</span></div><div \nclass=\"search-white\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input\" flex ng-model=\"vm.term\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" \nng-model-options=\"{debounce:100}\"></div><md-button class=\"md-raised\" ng-click=\"vm.addGroup()\" translate=\"APP.ADD\">Add\n</md-button></div><div class=\"content-card\" layout=\"row\" layout-align=\"center start\" flex><div class=\"content-wrapper\" \nlayout=\"column\" layout-padding flex=\"100\"><md-content layout-padding><table class=\"simple\" ng-if=\"!vm.isLoading()\" \nstyle=\"table-layout: auto\"><tr \nng-repeat=\"group in vm.groups | filter: vm.filterGroups | orderByNuitTranslated:\'name\' track by group.id\"><td>\n{{group.name | nuitTranslate}}</td><td style=\"text-align: right\"><md-button class=\"md-icon-button\" \nng-click=\"vm.updateGroup(group, $event)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span \ntranslate=\"APP.EDIT\">Edit</span></md-tooltip></md-button></td><td flex=\"none\" style=\"text-align: right; width: 25px\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.deleteGroup(group, $event)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></td></tr></table>\n</md-content></div></div></div></div>");
$templateCache.put("app/main/merchandising.materials.sales/views/material-sales.html","<div id=\"materialSales\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div layout=\"row\" class=\"header\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-cash-multiple\" class=\"icon\"></md-icon></span><span class=\"logo-text text-truncate\" \ntranslate=\"MATERIAL.SALES_NAV\">Material Sales</span></div><div></div></div><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\" flex><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nflex ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-change=\"vm.filterAll()\"></div><div style=\"max-width: 620px; min-width: 350px; min-height: 75px\" \nclass=\"md-whiteframe-2dp m-0 p-0 md-blue-grey-50-bg\" layout=\"row\" flex layout-align=\"space-around center\">\n<md-input-container flex ng-if=\"!vm.loading\"><label class=\"blue-grey-700-fg\" translate=\"MATERIAL.GROUPS_NAV\"></label>\n<md-select multiple=\"multiple\" ng-model=\"vm.selectedRawMaterials\" ng-change=\"vm.filterAll()\" \nmd-selected-text=\"vm.getSelectedText()\"><md-option \nng-repeat=\"rawMaterial in vm.rawMaterials | orderByNuitTranslated:\'name\'\" ng-value=\"rawMaterial.id\">\n{{rawMaterial.name | nuitTranslate}}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"!vm.loading\"><label class=\"blue-grey-700-fg\" translate=\"MATERIAL.THICKNESSES\"></label><md-select \nmultiple=\"multiple\" ng-model=\"vm.selectedThicknesses\" ng-change=\"vm.filterAll()\" \nmd-selected-text=\"vm.getSelectedThicknessesText()\"><md-option ng-repeat=\"thickness in vm.thicknesses\" \nng-value=\"thickness\">{{thickness | nuitUnit:\"thickness\"}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if=\"!vm.loading\"><label class=\"blue-grey-700-fg\" translate=\"MATERIAL.COLOR_FRONT\"></label>\n<md-select multiple=\"multiple\" ng-model=\"vm.selectedColors\" ng-change=\"vm.filterAll()\" \nmd-selected-text=\"vm.getSelectedColorsText()\"><md-option ng-repeat=\"color in vm.colors | orderByNuitTranslated:\'name\'\" \nng-value=\"color.id\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-10 mv-0\" \nmd-font-icon=\"icon-checkbox-blank\" ng-style=\"{color: color.hex}\"></md-icon><span flex class=\"text-truncate\">\n{{color.name | nuitTranslate}}</span></div></md-option></md-select></md-input-container></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" style=\"padding-left: 12px !important\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleAllSelected()\"></md-checkbox>\n<nuit-selection-indicator selection=\"vm.selection\" get-name=\"vm.getName\"></nuit-selection-indicator></div><div \nlayout=\"row\" layout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" entities-per-page=\"500\"></nuit-pagination>\n</div></div><div><md-content><div ng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\">Loading ...</span></div><div \nng-if=\"vm.materials.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"MATERIALS.NO_MATERIALS\">There are no materials yet!</span></div><table\n ng-if=\"!vm.loading && vm.materials.length > 0\"><thead><tr class=\"bb\"><th class=\"w-40\"></th><th></th><th \nng-click=\"vm.orderBy(\'basePrice\')\"><button layout=\"row\" layout-align=\"end center\"><span flex></span> <span \ntranslate=\"MATERIALS.PURCHASING_PRICE\"></span><label>({{vm.config.units.materialprice.symbol}})</label><span \nng-if=\"vm.selectedOrderBy !== \'basePrice\'\" style=\"width: 17px\"></span><md-icon \nng-show=\"vm.selectedOrderBy===\'basePrice\' && vm.reverse\" md-font-icon=\"icon-sort-descending\"></md-icon><md-icon \nng-show=\"vm.selectedOrderBy===\'basePrice\' && !vm.reverse\" md-font-icon=\"icon-sort-ascending\"></md-icon></button></th>\n<th><button layout=\"row\" disabled=\"true\" layout-align=\"end center\"><span flex></span> <span \ntranslate=\"MATERIALS.PURCHASING_PRICE\"></span><label>({{vm.config.ims.materials.priceConversion.symbol}})</label>\n</button></th><th><button ng-click=\"vm.orderBy(\'extraCharge\')\" layout=\"row\" layout-align=\"end center\"><span flex>\n</span> <span translate=\"MATERIALS.EXTRA_CHARGE_ABSOLUTE\"></span> <span ng-if=\"vm.selectedOrderBy !== \'extraCharge\'\" \nstyle=\"width: 17px\"></span><md-icon ng-show=\"vm.selectedOrderBy===\'extraCharge\' && vm.reverse\" \nmd-font-icon=\"icon-sort-descending\"></md-icon><md-icon ng-show=\"vm.selectedOrderBy===\'extraCharge\' && !vm.reverse\" \nmd-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th><button layout=\"row\" disabled=\"true\" \nlayout-align=\"end center\"><span flex></span> <span translate=\"MATERIALS.EXTRA_CHARGE_RELATIVE\"></span></button></th>\n<th><button layout=\"row\" disabled=\"true\" layout-align=\"end center\"><span flex></span> <span \ntranslate=\"MATERIALS.PRICE\"></span></button></th></tr></thead><tbody><tr \nng-repeat=\"material in vm.currentPageEntities track by material.id\" ng-class=\"{\'selected\': vm.isSelected(material)}\">\n<td class=\"w-40\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(material)\" \nng-click=\"vm.toggleSelected(material, $event)\" aria-label=\"{{vm.isSelected(material) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox></td><td layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-15 mv-0\" \nmd-font-icon=\"icon-checkbox-blank\" ng-style=\"{color: material.colors.front.hex}\"></md-icon><span flex>\n{{material.name | nuitTranslate}}</span></td><td class=\"text-right\"><span \nng-if=\"vm.isModified([\'basePrice\',\'basePriceWeight\']) && vm.isSelected(material)\"><span class=\"text-right\">\n{{material.basePrice | nuitUnit:\'materialprice\':true }}</span><md-icon md-font-icon=\"icon-arrow-right\"></md-icon><span \nclass=\"text-bold\">{{vm.getBasePrice(material) | nuitUnit:\'materialprice\':true}} </span></span><span \nng-if=\"!vm.isModified([\'basePrice\',\'basePriceWeight\']) || !vm.isSelected(material)\"><span class=\"text-right\">\n{{material.basePrice | nuitUnit:\'materialprice\':true}}</span></span></td><td class=\"text-right\"><span \nng-if=\"!material.weight\">-</span> <span ng-if=\"material.weight\"><span \nng-if=\"vm.isModified([\'basePrice\',\'basePriceWeight\']) && vm.isSelected(material)\"><span class=\"text-right\">\n{{material.basePrice/material.weight | nuitUnit:\'materialprice\':true}}</span><md-icon md-font-icon=\"icon-arrow-right\">\n</md-icon><span class=\"text-bold\">{{vm.getBasePriceWeight(material) | nuitUnit:\'materialprice\':true}} </span></span>\n<span ng-if=\"!vm.isModified([\'basePrice\',\'basePriceWeight\']) || !vm.isSelected(material)\"><span class=\"text-right\">\n{{material.basePrice/material.weight | nuitUnit:\'materialprice\':true}}</span></span></span></td><td class=\"text-right\">\n<span \nng-if=\"material.extraCharge!==vm.getExtraCharge(material) && vm.isModified([\'basePrice\',\'basePriceWeight\', \'extraCharge\', \'extraChargeRelative\']) && vm.isSelected(material)\">\n<span class=\"text-right\">{{material.extraCharge | nuitUnit:\'materialprice\':true}}</span><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><span class=\"text-bold\">\n{{vm.getExtraCharge(material) | nuitUnit:\'materialprice\':true}} </span></span><span \nng-if=\"material.extraCharge===vm.getExtraCharge(material) || !vm.isModified([\'basePrice\',\'basePriceWeight\',\'extraCharge\', \'extraChargeRelative\']) || !vm.isSelected(material)\">\n<span class=\"text-right\">{{material.extraCharge | nuitUnit:\'materialprice\':true}}</span></span></td><td \nclass=\"text-right\"><span \nng-if=\"vm.getOriginalExtraChargeRelative(material)!==vm.getExtraChargeRelative(material) && vm.isModified([\'basePrice\',\'basePriceWeight\', \'extraCharge\', \'extraChargeRelative\']) && vm.isSelected(material)\">\n<span class=\"text-right\">{{vm.getOriginalExtraChargeRelative(material) + \' %\'}}</span><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><span class=\"text-bold\">{{vm.getExtraChargeRelative(material) + \' %\'}} \n</span></span><span \nng-if=\"vm.getOriginalExtraChargeRelative(material)===vm.getExtraChargeRelative(material) || !vm.isModified([\'basePrice\',\'basePriceWeight\',\'extraCharge\', \'extraChargeRelative\']) || !vm.isSelected(material)\">\n<span class=\"text-right\">{{vm.getOriginalExtraChargeRelative(material) + \' %\'}}</span></span></td><td \nclass=\"text-right\"><span><span class=\"text-right\">\n{{(material.basePrice + material.extraCharge) | nuitUnit:\'materialprice\':true}}</span> </span><span \nng-if=\"vm.isSelected(material) && vm.getTotalPrice(material)!==(material.basePrice+material.extraCharge)\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><span class=\"text-right text-bold\">\n{{vm.getTotalPrice(material) | nuitUnit:\'materialprice\':true}}</span></span></td></tr></tbody><tfoot><tr><td \nclass=\"w-40\"></td><td></td><td><div layout=\"row\" layout-align=\"end start\"><md-input-container class=\"margin-0\">\n<md-select ng-model=\"vm.modifications.basePrice.mod\"><md-option ng-repeat=\"mod in vm.mods\" ng-value=\"mod\">{{mod}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block text-right\" \nng-model-options=\"{ debounce: 500 }\" style=\"margin:0\"><input ng-blur=\"vm.sanatizeMods()\" \nng-disabled=\"vm.modifications.basePriceWeight.value!==0\" type=\"number\" ng-model=\"vm.modifications.basePrice.value\">\n</md-input-container></div></td><td><div layout=\"row\" layout-align=\"end start\"><md-input-container class=\"margin-0\">\n<md-select ng-model=\"vm.modifications.basePriceWeight.mod\"><md-option ng-repeat=\"mod in vm.mods\" ng-value=\"mod\">{{mod}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block text-right\" \nng-model-options=\"{ debounce: 500 }\" style=\"margin:0\"><input ng-blur=\"vm.sanatizeMods()\" \nng-disabled=\"vm.modifications.basePrice.value!==0\" type=\"number\" ng-model=\"vm.modifications.basePriceWeight.value\">\n</md-input-container></div></td><td><div layout=\"row\" layout-align=\"end start\"><md-input-container class=\"margin-0\">\n<md-select ng-model=\"vm.modifications.extraCharge.mod\"><md-option ng-repeat=\"mod in vm.mods\" ng-value=\"mod\">{{mod}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block text-right\" \nng-model-options=\"{ debounce: 500 }\" style=\"margin:0\"><input ng-blur=\"vm.sanatizeMods()\" \nng-disabled=\"vm.modifications.extraChargeRelative.value!==0\" type=\"number\" \nng-model=\"vm.modifications.extraCharge.value\"></md-input-container></div></td><td><div layout=\"row\" \nlayout-align=\"end start\"><md-input-container class=\"margin-0\"><md-select \nng-model=\"vm.modifications.extraChargeRelative.mod\"><md-option ng-repeat=\"mod in vm.mods\" ng-value=\"mod\">{{mod}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block text-right\" \nng-model-options=\"{ debounce: 500 }\" style=\"margin:0\"><input ng-blur=\"vm.sanatizeMods()\" \nng-disabled=\"vm.modifications.extraCharge.value!==0\" type=\"number\" \nng-model=\"vm.modifications.extraChargeRelative.value\"></md-input-container></div></td><td></td></tr><tr colspan=\"5\"><td\n layout=\"row\" class=\"pb-8\" layout-align=\"end center\"><md-button ng-disabled=\"!vm.canSave()\" \nclass=\"m-8 md-raised md-accent\" ng-click=\"vm.calculate()\" translate=\"APP.SAVE\"></md-button></td></tr><tr class=\"h-10\">\n</tr></tfoot></table></md-content></div></div></div></div>");
$templateCache.put("app/main/merchandising.products/views/product-compose.html","<div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" \nflex><form name=\"vm.itemForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.products\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span class=\"md-title\" translate=\"ARTICLES.ADD\">\nNeues Produkt</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-warn md-raised\" \nng-click=\"vm.saveProduct()\" ng-disabled=\"!vm.itemForm.$valid || !vm.itemForm.$dirty || !vm.canSubmit()\" \ntranslate=\"APP.SAVE\">Speichern</md-button></div></div><md-content ms-scroll class=\"content-wrapper\" layout=\"column\" \nlayout-fill flex><md-tabs layout-fill md-selected=\"vm.selectedTab\"><md-tab \nlabel=\"{{ \'PRODUCTS.GENERAL\' | translate }}\" ui-sref=\"app.products.compose({active:\'general\'})\" \nmd-active=\"vm.currentTab == \'general\'\"><ng-include src=\"\'app/main/merchandising.products/views/partials/general.html\'\">\n</ng-include></md-tab><md-tab label=\"{{ \'PRODUCTS.PROPERTIES\' | translate }}\" \nui-sref=\"app.products.compose({active:\'properties\'})\" md-active=\"vm.currentTab == \'properties\'\" \nng-if=\"vm.config.ims.products.profiles.enabled\"><ng-include \nsrc=\"\'app/main/merchandising.products/views/partials/properties.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'PRODUCTS.SALES\' | translate }}\" ui-sref=\"app.products.compose({active:\'sales\'})\" \nmd-active=\"vm.currentTab == \'sales\'\" ng-if=\"vm.config.ims.products.sales.enabled\"><ng-include \nsrc=\"\'app/main/merchandising.products/views/partials/sales.html\'\"></ng-include></md-tab></md-tabs></md-content></form>\n</div>");
$templateCache.put("app/main/merchandising.products/views/product-details.html","<div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" \nflex><form name=\"vm.itemForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce: 200}\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.products\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.currentProduct\"><div class=\"divider-vertical mr-20\"></div><span class=\"md-title\">\n{{ vm.currentProduct.name[vm.translation.language]}}</span><div class=\"product-attributes\" layout=\"row\" \nlayout-align=\"end center\" layout-wrap><div class=\"attribute md-blue-500-bg text-truncate\" \nng-repeat=\"attribute in (vm.currentProduct.attributes | filter: { restrictions: { header: true } })\"><span>\n{{ attribute.name | nuitTranslate }}</span> <span \nng-if=\"attribute.value !== undefined && attribute.type !== \'material\'\">: {{ attribute.value }}</span> <span \nng-if=\"attribute.value !== undefined && attribute.type === \'material\'\">\n: {{ vm.getMaterialById(attribute.value).name | nuitTranslate }}</span><md-tooltip><span translate=\"APP.ATTRIBUTE\">\nAttribute</span></md-tooltip></div></div></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.updateProduct()\" \nng-disabled=\"!vm.itemForm.$valid || !vm.itemForm.$dirty || !vm.canSubmit()\" translate=\"APP.SAVE\">Speichern</md-button>\n</div></div><md-content ms-scroll class=\"content-wrapper\" layout=\"column\" layout-fill flex><md-tabs layout-fill \nmd-selected=\"vm.selectedTab\"><md-tab label=\"{{ \'PRODUCTS.GENERAL\' | translate }}\" \nui-sref=\"app.products.detail({active:\'general\'})\" md-active=\"vm.currentTab == \'general\'\"><ng-include \nsrc=\"\'app/main/merchandising.products/views/partials/general.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'PRODUCTS.PROPERTIES\' | translate }}\" ui-sref=\"app.products.detail({active:\'properties\'})\" \nmd-active=\"vm.currentTab == \'properties\'\" ng-if=\"vm.config.ims.products.profiles.enabled\"><ng-include \nsrc=\"\'app/main/merchandising.products/views/partials/properties.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'PRODUCTS.SALES\' | translate }}\" ui-sref=\"app.products.detail({active:\'sales\'})\" \nmd-active=\"vm.currentTab == \'sales\'\" ng-if=\"vm.config.ims.products.sales.enabled\"><ng-include \nsrc=\"\'app/main/merchandising.products/views/partials/sales.html\'\"></ng-include></md-tab></md-tabs></md-content></form>\n</div>");
$templateCache.put("app/main/merchandising.products/views/product-list.html","<div class=\"compose-button\" style=\"padding-top: 37px\" layout-align=\"end end\" layout=\"row\"><md-button \nng-if=\"vm.allowAdd\" class=\"md-raised\" aria-label=\"compose\" ui-sref=\"app.products.compose\" translate=\"APP.ADD\">\nADD NEW PRODUCT</md-button></div><div class=\"header\" layout=\"row\" layout-align=\"start end\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nflex ng-model=\"vm.term\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-change=\"vm.search()\" ng-model-options=\"{debounce:300}\"></div></div></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleSelectedProducts()\"></md-checkbox><div\n layout=\"row\" ng-if=\"vm.getSelected().length > 0 && vm.config.ims.products.list.allowDelete\" \nlayout-align=\"center center\"><nuit-selection-indicator selection=\"vm.selection\" get-name=\"vm.getName\">\n</nuit-selection-indicator><md-button class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected()\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip>\n</md-button></div><div layout=\"row\" ng-if=\"vm.getSelected().length === 1\"><md-button class=\"md-icon-button\" \naria-label=\"copy\" ng-click=\"vm.copySelected()\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon><md-tooltip><span \ntranslate=\"APP.COPY\">Copy</span></md-tooltip></md-button></div></div><div layout=\"row\" layout-align=\"start center\"><div\n layout=\"row\" layout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" entities-per-page=\"20\" \nload-page=\"vm.loadPage(data)\"></nuit-pagination></div></div></div><div class=\"content-wrapper\" layout=\"column\" flex>\n<md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.isLoading\" class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\" \ntranslate=\"APP.LOADING\">Loading ...</span></div><div ng-if=\"vm.products.length === 0 && !vm.isLoading\" \nclass=\"no-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><span class=\"md-headline\" \ntranslate=\"PRODUCTS.EMPTY_FIRST\">Es wurden keine Produkte gefunden! Möchten sie ein </span><a \nui-sref=\"app.products.compose\"><span class=\"md-headline\" translate=\"PRODUCTS.EMPTY_SECOND\">Produkt anlegen?</span></a>\n</div><div class=\"thread unread\" ng-if=\"!vm.isLoading\" \nng-repeat=\"product in vm.currentPageEntities track by product.id\" \nng-class=\"{\'selected\': vm.isSelected(product), \'skeleton\': product._placeholder}\" \nng-click=\"product._placeholder ? null : vm.openProduct(product)\"><div layout=\"row\" layout-align=\"start center\" \nlayout-fill><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(product)\" \nng-click=\"vm.toggleSelectProduct(product, $event)\" ng-disabled=\"product._placeholder\" \naria-label=\"{{vm.isSelected(product) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div class=\"avatar\" \nng-if=\"product.image\"><img http-src=\"{{ ::product.image }}\"></div><div class=\"pl-10\" \nng-if=\"!product.image && !product._placeholder\"><md-icon md-font-icon=\"icon-cube-outline\" class=\"green-500-fg\" \nng-if=\"product.externalId\"><md-tooltip><span translate=\"PRODUCT.EXTERNAL\">External Product</span></md-tooltip>\n</md-icon><md-icon md-font-icon=\"icon-package\" class=\"brown-500-fg\" ng-if=\"!product.externalId\"><md-tooltip><span \ntranslate=\"PRODUCT.DEFAULT\">Default Product</span></md-tooltip></md-icon></div><div class=\"info\" layout=\"column\" flex>\n<span class=\"name text-truncate\" flex>{{ vm.getName(product) }}</span><div class=\"message text-truncate\" flex><span \nng-repeat=\"category in product.categories track by category.id\"><span>{{ category.name | nuitTranslate }}</span>\n{{$last ? \'\' : \', \' }}</span></div></div><div class=\"labels\" layout=\"row\" layout-align=\"end start\" layout-wrap><div \nclass=\"label md-blue-500-bg text-truncate\" ng-repeat=\"attribute in product.attributes track by attribute.id\"><span>\n{{ attribute.name | nuitTranslate }}</span> <span ng-switch=\"attribute.type\" ng-if=\"attribute.value !== undefined\">\n<span ng-switch-when=\"material\">: {{ vm.getMaterialById(attribute.value).name | nuitTranslate }}</span> <span \nng-switch-when=\"length\">: {{ attribute.value | nuitUnit:\'length\' }}</span> <span ng-switch-default>\n: {{ attribute.value }}</span></span><md-tooltip><span translate=\"APP.ATTRIBUTE\">Attribute</span></md-tooltip></div>\n<div class=\"label md-red-500-bg text-truncate\" ng-repeat=\"tag in product.tags track by tag.id\"><span>\n{{ tag.name | nuitTranslate }}</span><md-tooltip><span translate=\"APP.TAG\">Tag</span></md-tooltip></div><nuit-tags \nng-if=\"product.type === \'profile\' && product.data\"><nuit-tag ng-if=\"vm.hasStamps(product.data.profile)\"><md-icon \nclass=\"black-fg\" style=\"margin-left:4px\" md-font-icon=\"icon-image-filter-center-focus\"></md-icon><strong \nng-if=\"vm.getPunchCount(product.data.profile)\">&nbsp;{{ vm.getPunchCount(product.data.profile) }}</strong></nuit-tag>\n<nuit-tag ng-if=\"vm.hasCuts(product.data.profile)\"><md-icon class=\"black-fg\" style=\"margin-left:4px\" \nmd-font-icon=\"icon-content-cut\"></md-icon></nuit-tag><nuit-tag ng-if=\"vm.isConical(product.data.profile)\"><md-icon \nclass=\"black-fg\" style=\"margin-left:4px\" md-font-icon=\"icon-send\"></md-icon></nuit-tag></nuit-tags></div></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/merchandising.products/views/products.html","<div id=\"products\" ng-mouseover=\"vm.hoveredCategory = undefined\" class=\"page-layout carded left-sidenav\" layout=\"row\">\n<div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\">\n<md-icon md-font-icon=\"icon-nutriton\" class=\"icon\"></md-icon></span><span class=\"logo-text text-truncate\" \ntranslate=\"PRODUCT.PRODUCT_NAV\">Products</span></div></div><md-content ms-scroll class=\"content\" flex \nng-mouseover=\"$event.stopPropagation()\"><div class=\"navigation-simple\" layout=\"column\"><div \nng-if=\"vm.categoriesLoading && vm.categories.length === 0\" class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular></div><div layout=\"row\" layout-align=\"center center\" layout-fill \nstyle=\"cursor: pointer\" ng-click=\"vm.showSelected()\" ng-class=\"{\'text-bold\': !vm.$state.params.category}\"><span \nclass=\"ml-20\"><md-icon style=\"margin-bottom: 5px\" md-font-icon=\"icon-label-outline\"></md-icon></span><span \ntranslate=\"APP.SHOW_ALL\" class=\"m-10\">All</span> <span flex layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" ng-click=\"$event.stopPropagation(); vm.addCategory()\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s20\"><md-tooltip><span translate=\"CATEGORIES.ADD\"></span></md-tooltip></md-icon></md-button></span></div>\n<treecontrol class=\"tree-classic\" tree-model=\"vm.categories\" options=\"vm.treeOptions\" \non-selection=\"vm.showSelected(node)\" reverse-order=\"false\" selected-node=\"vm.selectedCategory\"><span \nng-mouseover=\"vm.hoveredCategory = node; $event.stopPropagation()\">\n{{node.name?(node.name | nuitTranslate:\'???\'):\'???\'}}</span> <span style=\"position: absolute; right: -10px; top: -5px\" \nng-if=\"vm.hoveredCategory.id === node.id\"><md-menu><md-button class=\"md-icon-button m0 p0\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"s20\"><md-tooltip><span \ntranslate=\"CATEGORIES.EDIT\"></span></md-tooltip></md-icon></md-button><md-menu-content><md-menu-item><md-button \nng-click=\"vm.addCategory(node, $event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span translate=\"CATEGORIES.ADD\">\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.editCategory(node, $event)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><span translate=\"APP.EDIT\"></span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteCategory(node, $event)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><span \ntranslate=\"APP.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></span></treecontrol></div>\n</md-content></md-sidenav><div class=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/merchandising.products.attributes/views/attributes.html","<div id=\"attributes\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-food-variant\" class=\"icon\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"PRODUCTS.ATTRIBUTES_NAV\">Attributes</span></div><div class=\"search-white\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input\" flex ng-model=\"vm.term\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" ng-model-options=\"{debounce:100}\"></div><md-button \nclass=\"md-raised\" ng-click=\"vm.addAttribute()\" translate=\"APP.ADD\">Add User</md-button></div><div class=\"content-card\" \nlayout=\"row\" layout-align=\"center start\" flex><div class=\"content-wrapper\" layout=\"column\" layout-padding flex=\"100\">\n<md-content layout-padding ms-scroll><table class=\"simple\" ng-if=\"!vm.isLoading()\"><thead><tr><th><span \ntranslate=\"ATTRIBUTE.NAME\"></span></th><th><span translate=\"ATTRIBUTE.TYPE\"></span></th><th><span \ntranslate=\"ATTRIBUTE.OPTIONS\"></span></th><th \nstyle=\"min-width: 48px !important;max-width:48px !important;width:48px !important\"></th><th \nstyle=\"min-width: 48px !important;max-width:48px !important;width:48px !important\"></th><th \nstyle=\"min-width: 48px !important;max-width:48px !important;width:48px !important\"></th></tr></thead><tbody><tr \nng-repeat=\"attribute in vm.attributes | filter: vm.filterAttribute track by attribute.id\"><td flex=\"nogrow\">\n{{ attribute.name | nuitTranslate }}</td><td flex=\"nogrow\" ng-switch=\"attribute.type\"><span ng-switch-when=\"number\" \ntranslate=\"APP.NUMBER\"></span> <span ng-switch-when=\"string\" translate=\"APP.STRING\"></span> <span \nng-switch-when=\"enum\" translate=\"APP.ENUM\"></span> <span ng-switch-when=\"material\" translate=\"APP.MATERIAL\"></span> \n<span ng-switch-when=\"color\" translate=\"APP.COLOR\"></span> <span ng-switch-when=\"length\" translate=\"APP.LENGTH\"></span>\n <span ng-switch-default>{{attribute.type}}</span></td><td ng-if=\"attribute.type === \'string\'\"><div layout=\"row\"><div \nng-repeat=\"regex in attribute.restrictions.regex\"><span>{{regex}}</span></div></div></td><td \nng-if=\"attribute.type === \'enum\'\"><div layout=\"row\" layout-align=\"start center\" layout-wrap><div \nstyle=\"padding: 0; margin: 5px\" ng-repeat=\"option in attribute.restrictions.options\" felx=\"none\"><div \nstyle=\"margin: 0 12px 0 0; padding:2px 4px; border-radius: 2px\" class=\"md-item-text md-grey-300-bg\" \nng-click=\"vm.toggleSelectionForTag(tag)\"><h3 style=\"padding: 0; margin: 0\">{{ option }}</h3></div></div></div></td><td \nng-if=\"attribute.type === \'number\'\"><div \nng-if=\"attribute.restrictions.min !== undefined && attribute.restrictions.max !== undefined\"><span \ntranslate=\"APP.FROM\">von</span>&nbsp; <em style=\"padding: 0; margin: 0\">{{ attribute.restrictions.min }}</em> &nbsp;\n<span translate=\"APP.TO\">bis</span>&nbsp; <em style=\"padding: 0; margin: 0\">{{ attribute.restrictions.max }}</em> <span\n ng-if=\"attribute.restrictions.unit\">&nbsp;({{attribute.restrictions.unit}})</span></div></td><td \nng-if=\"attribute.type === \'length\'\"><div \nng-if=\"attribute.restrictions.min !== undefined && attribute.restrictions.max !== undefined\"><span \ntranslate=\"APP.FROM\">von</span>&nbsp; <em style=\"padding: 0; margin: 0\">\n{{ attribute.restrictions.min | nuitUnit:\'length\' }}</em> &nbsp;<span translate=\"APP.TO\">bis</span>&nbsp; <em \nstyle=\"padding: 0; margin: 0\">{{ attribute.restrictions.max | nuitUnit:\'length\' }}</em></div></td><td \nng-if=\"attribute.type === \'material\'\"><div style=\"white-space: nowrap\" layout=\"row\" layout-wrap><div layout=\"column\">\n<div layout=\"row\"><em>{{ attribute.restrictions.materials.length }}</em>&nbsp;<span \ntranslate=\"ATTRIBUTE.MATERIALS_SELECTED\"></span></div><div layout=\"row\"><em>{{ attribute.restrictions.groups.length }}\n</em>&nbsp;<span translate=\"ATTRIBUTE.GROUPS_SELECTED\"></span></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pl-16\"><span>(<em ng-if=\"attribute.restrictions.blacklist\" \ntranslate=\"APP.EXCLUSIVE\"></em><em ng-if=\"!attribute.restrictions.blacklist\" translate=\"APP.INCLUSIVE\"></em>)</span>\n</div></div></td><td ng-if=\"attribute.type === \'color\'\"><div style=\"white-space: nowrap\" layout=\"row\" layout-wrap><div \nlayout=\"row\"><em ng-if=\"attribute.restrictions.colors && attribute.restrictions.colors.length > 0\">\n{{ attribute.restrictions.colors.length }}</em> <em \nng-if=\"!attribute.restrictions.colors || attribute.restrictions.colors.length === 0\">{{ \'APP.ALL\' | translate }}</em>\n&nbsp;<span translate=\"ATTRIBUTE.COLORS_SELECTED\"></span></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-16\"><span>(<em ng-if=\"attribute.restrictions.blacklist\" translate=\"APP.EXCLUSIVE\"></em><em \nng-if=\"!attribute.restrictions.blacklist\" translate=\"APP.INCLUSIVE\"></em>)</span></div></div></td><td><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleVisibility(attribute)\"><md-icon md-font-icon=\"icon-eye-off red-500-fg\" \nng-if=\"attribute.restrictions.hidden\"></md-icon><md-icon md-font-icon=\"icon-eye blue-grey-400-fg\" \nng-if=\"!attribute.restrictions.hidden\"></md-icon><md-tooltip><span translate=\"ATTRIBUTE.TOGGLE_VISIBILITY\">\nToggle visibility</span></md-tooltip></md-button></td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.editAttribute(attribute)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span \ntranslate=\"APP.EDIT\">Edit</span></md-tooltip></md-button></td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteAttribute(attribute)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></td></tr></tbody></table></md-content></div></div></div>\n</div>");
$templateCache.put("app/main/merchandising.products.tags/views/tags.html","<div id=\"tags\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-ticket\" \nclass=\"icon\"></md-icon></span><span class=\"logo-text\" translate=\"PRODUCTS.TAGS_NAV\">Tags</span></div><div \nclass=\"search-white\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input\" flex ng-model=\"vm.term\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" \nng-model-options=\"{debounce:100}\"></div><md-button class=\"md-raised\" ng-click=\"vm.addTag()\" translate=\"APP.ADD\">\nAdd User</md-button></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content-wrapper\" layout=\"column\" \nfelx><md-content class=\"content thread-list\" ms-scroll flex><div layout=\"column\"><div class=\"thread\" \nng-repeat=\"tag in vm.tags\" ng-if=\"vm.matchesFilter(tag)\" layout-wrap flex=\"grow\"><div ng-if=\"!tag._isLoading\" \nlayout=\"row\" flex><div layout-align=\"start center\" flex=\"grow\"><h3>{{tag.name | nuitTranslate}}</h3></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.editTag(tag, $event)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"APP.EDIT\">Edit</span></md-tooltip></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.deleteTag(tag, $event)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div><div \nng-if=\"tag._isLoading === true\" style=\"padding: 8px; border-radius: 3px\" \nclass=\"md-grey-200-bg md-item-text md-whiteframe-z1\" layout=\"row\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular></div></div>\n</div></md-content></div></div></div></div>");
$templateCache.put("app/main/nuit-editor/docs/Bounds.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: Bounds</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: Bounds</h1><section><header><h2>Bounds</h2></header><article><div class=\"container-overview\">\n<hr><dt><h4 class=\"name\" id=\"Bounds\"><span class=\"type-signature\"></span>new Bounds()</h4></dt><dd><div \nclass=\"description\">Bounds class with minimum and maximum values of two coordinates.</div><dl class=\"details\"></dl>\n</dd></div></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" \nclass=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" id=\"searchResults\"><div \nclass=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \ndata-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">\nSearch results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" \nclass=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span class=\"jsdoc-message\">\nDocumentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Components.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Namespace: Components</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Namespace: Components</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">Editor\n</a>.</span> Components</h2></header><article><div class=\"container-overview\"><div class=\"description\">\nComponents of editor</div><dl class=\"details\"></dl></div><h3 class=\"subsection-title\">Classes</h3><dl><dt><a \nhref=\"Editor.Components.nuitDraw2dComponent.html\">nuitDraw2dComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitDrawComponent.html\">nuitDrawComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitDrawStampingComponent.html\">nuitDrawStampingComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitDrawTopComponent.html\">nuitDrawTopComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitEditorComponent.html\">nuitEditorComponent</a></dt><dd></dd></dl></article></section></div>\n</div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\">\n</div></div></div></div><div class=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div \nclass=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" \naria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Search results</h4></div>\n<div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" \ndata-dismiss=\"modal\">Close</button></div></div></div></div><footer><span class=\"jsdoc-message\">\nDocumentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Components.nuitDraw2dComponent.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitDraw2dComponent</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitDraw2dComponent</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">\nEditor</a><a href=\"Editor.Components.html\">.Components</a>.</span> nuitDraw2dComponent</h2><div \nclass=\"class-description\">Subeditor for 2d drawings</div></header><article><div class=\"container-overview\"><hr><dt><h4 \nclass=\"name\" id=\"nuitDraw2dComponent\"><span class=\"type-signature\"></span>new nuitDraw2dComponent()</h4></dt><dd><dl \nclass=\"details\"></dl><h5>Requires:</h5><ul><li><a href=\"Editor.Components.nuitDrawComponent.html\">nuitDrawComponent \n</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">nuitDraw2dController </a></li></ul><h5>Example</h5>\n<pre class=\"sunlight-highlight-javascript\">\n&lt;nuit-draw ..&gt;\n	&lt;nuit-draw-2d&gt;&lt;/nuit-draw-2d&gt;\n	&lt;!-- other subeditors --&gt;\n&lt;/nuit-draw&gt;\n</pre></dd></div><h3 class=\"subsection-title\">Requires</h3><ul><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nnuitDrawComponent </a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">nuitDraw2dController </a></li>\n</ul></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" \nclass=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" id=\"searchResults\"><div \nclass=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \ndata-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">\nSearch results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" \nclass=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span class=\"jsdoc-message\">\nDocumentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Components.nuitDrawComponent.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitDrawComponent</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitDrawComponent</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">\nEditor</a><a href=\"Editor.Components.html\">.Components</a>.</span> nuitDrawComponent</h2><div \nclass=\"class-description\">Wrappercomponent for all editor-subcomponents</div></header><article><div \nclass=\"container-overview\"><hr><dt><h4 class=\"name\" id=\"nuitDrawComponent\"><span class=\"type-signature\"></span>\nnew nuitDrawComponent(editorConfig)</h4></dt><dd><h5>Parameters:</h5><table class=\"params table table-striped\"><thead>\n<tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\neditorConfig</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\">\nConfig which should be used by the editor</td></tr></tbody></table><dl class=\"details\"></dl><h5>Requires:</h5><ul><li>\n<a href=\"Editor.Controller.nuitDrawController.html\">nuitDrawController</a></li></ul><h5>Example</h5><pre \nclass=\"sunlight-highlight-javascript\">\n&lt;nuit-draw editor-config=&quot;vm.config&quot;&gt;\n	&lt;!-- subeditors --&gt;\n&lt;/nuit-draw&gt;</pre></dd></div><h3\n class=\"subsection-title\">Requires</h3><ul><li><a href=\"Editor.Controller.nuitDrawController.html\">nuitDrawController\n</a></li></ul></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" \nclass=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" id=\"searchResults\"><div \nclass=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \ndata-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">\nSearch results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" \nclass=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span class=\"jsdoc-message\">\nDocumentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Components.nuitDrawStampingComponent.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitDrawStampingComponent</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitDrawStampingComponent</h1><section><header><h2><span class=\"ancestors\"><a \nhref=\"Editor.html\">Editor</a><a href=\"Editor.Components.html\">.Components</a>.</span> nuitDrawStampingComponent</h2>\n<div class=\"class-description\">Subeditor for 2d drawings</div></header><article><div class=\"container-overview\"><hr>\n<dt><h4 class=\"name\" id=\"nuitDrawStampingComponent\"><span class=\"type-signature\"></span>new nuitDrawStampingComponent()\n</h4></dt><dd><dl class=\"details\"></dl><h5>Requires:</h5><ul><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nnuitDrawComponent </a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">nuitDrawStampingController \n</a></li></ul><h5>Example</h5><pre class=\"sunlight-highlight-javascript\">\n&lt;nuit-draw ..&gt;\n	&lt;nuit-draw-stamping&gt;&lt;/nuit-draw-stamping&gt;\n	&lt;!-- other subeditors --&gt;\n&lt;/nuit-draw&gt;\n</pre></dd></div><h3 class=\"subsection-title\">Requires</h3><ul><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nnuitDrawComponent </a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">nuitDrawStampingController \n</a></li></ul></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" \nclass=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" id=\"searchResults\"><div \nclass=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \ndata-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">\nSearch results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" \nclass=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span class=\"jsdoc-message\">\nDocumentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Components.nuitDrawTopComponent.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitDrawTopComponent</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitDrawTopComponent</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">\nEditor</a><a href=\"Editor.Components.html\">.Components</a>.</span> nuitDrawTopComponent</h2><div \nclass=\"class-description\">Editor for conical editing</div></header><article><div class=\"container-overview\"><hr><dt><h4\n class=\"name\" id=\"nuitDrawTopComponent\"><span class=\"type-signature\"></span>new nuitDrawTopComponent()</h4></dt><dd><dl\n class=\"details\"></dl><h5>Requires:</h5><ul><li><a href=\"Editor.Components.nuitDrawComponent.html\">nuitDrawComponent \n</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">nuitDrawTopController </a></li></ul><h5>Example\n</h5><pre class=\"sunlight-highlight-javascript\">\n&lt;nuit-draw&gt;\n	 &lt;nuit-draw-top&gt;&lt;/nuit-draw-top&gt;\n	 &lt;!-- other subeditors --&gt;\n&lt;/nuit-draw&gt;\n</pre></dd></div><h3 class=\"subsection-title\">Requires</h3><ul><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nnuitDrawComponent </a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">nuitDrawTopController </a></li>\n</ul></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" \nclass=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" id=\"searchResults\"><div \nclass=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \ndata-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">\nSearch results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" \nclass=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span class=\"jsdoc-message\">\nDocumentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Components.nuitEditorComponent.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitEditorComponent</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitEditorComponent</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">\nEditor</a><a href=\"Editor.Components.html\">.Components</a>.</span> nuitEditorComponent</h2><div \nclass=\"class-description\">Component which wraps the <a href=\"Editor.Components.nuitDrawComponent.html\">\nnuitDrawComponent</a> with all features, like the sidebar, menubar, etc.</div></header><article><div \nclass=\"container-overview\"><hr><dt><h4 class=\"name\" id=\"nuitEditorComponent\"><span class=\"type-signature\"></span>\nnew nuitEditorComponent(editorConfig, openProfileDialog, openProfileState, saveProfileDialog, selectMaterialDialog, finishAction, languageKey)\n</h4></dt><dd><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>editorConfig</code></td><td class=\"type\">\n<span class=\"param-type\">object</span></td><td class=\"description last\">Config which should be used by the editor</td>\n</tr><tr><td class=\"name\"><code>openProfileDialog</code></td><td class=\"type\"><span class=\"param-type\"><a \nhref=\"Editor.Components.nuitEditorComponent.html#~openProfileDialog\">\nEditor.Components.nuitEditorComponent~openProfileDialog</a></span></td><td class=\"description last\">\nFunction which opens a dialog to select a profile</td></tr><tr><td class=\"name\"><code>openProfileState</code></td><td \nclass=\"type\"><span class=\"param-type\">string</span></td><td class=\"description last\">\nState to navigate to when opening a profile</td></tr><tr><td class=\"name\"><code>saveProfileDialog</code></td><td \nclass=\"type\"><span class=\"param-type\"><a href=\"Editor.Components.nuitEditorComponent.html#~saveProfileDialog\">\nEditor.Components.nuitEditorComponent~saveProfileDialog</a></span></td><td class=\"description last\">\nFunction which opens a dialog to save a given profile</td></tr><tr><td class=\"name\"><code>selectMaterialDialog</code>\n</td><td class=\"type\"><span class=\"param-type\"><a \nhref=\"Editor.Components.nuitEditorComponent.html#~selectMaterialDialog\">\nEditor.Components.nuitEditorComponent~selectMaterialDialog</a></span></td><td class=\"description last\">\nFunction which opens a material</td></tr><tr><td class=\"name\"><code>finishAction</code></td><td class=\"type\"><span \nclass=\"param-type\">Editor.Components.nuitEditorComponent~finishAction</span></td><td class=\"description last\">\nFunction which gets executed when user clicks at \"addToCart\"</td></tr><tr><td class=\"name\"><code>languageKey</code>\n</td><td class=\"type\"><span class=\"param-type\">string</span></td><td class=\"description last\">Language key to apply\n</td></tr></tbody></table><dl class=\"details\"></dl><h5>Requires:</h5><ul><li><a \nhref=\"Editor.Controller.nuitEditorController.html\">nuitEditorController</a></li></ul><h5>Example</h5><pre \nclass=\"sunlight-highlight-javascript\">&lt;nuit-editor editor-config=&quot;vm.config&quot;&gt;&lt;/nuit-editor&gt;</pre>\n</dd></div><h3 class=\"subsection-title\">Requires</h3><ul><li><a href=\"Editor.Controller.nuitEditorController.html\">\nnuitEditorController</a></li></ul><h3 class=\"subsection-title\">Type Definitions</h3><dl><hr><dt><h4 class=\"name\" \nid=\"~finishActionDialog\"><span class=\"type-signature\"></span>finishActionDialog()</h4></dt><dd><div \nclass=\"description\">Function to execute when user clicks \"addToCart\"</div><dl class=\"details\"></dl><h5>Returns:</h5>\n<dl><dt>Type</dt><dd><span class=\"param-type\">Promise</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~openProfileDialog\"><span class=\"type-signature\"></span>openProfileDialog()</h4></dt><dd><div class=\"description\">\nOpen a saved profile</div><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">\nResolves with the opened profile</div><dl><dt>Type</dt><dd><span class=\"param-type\">Promise</span></dd></dl></dd><hr>\n<dt><h4 class=\"name\" id=\"~saveProfileDialog\"><span class=\"type-signature\"></span>saveProfileDialog(profile)</h4></dt>\n<dd><div class=\"description\">Save a given profile</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\nprofile</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\">\nThe profile to save</td></tr></tbody></table><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">\nPromise wether the save process has been successfull</div><dl><dt>Type</dt><dd><span class=\"param-type\">Promise</span>\n</dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~selectMaterialDialog\"><span class=\"type-signature\"></span>\nselectMaterialDialog()</h4></dt><dd><div class=\"description\">Select a material</div><dl class=\"details\"></dl><h5>\nReturns:</h5><div class=\"param-desc\">Promise which resolves the selected material</div><dl><dt>Type</dt><dd><span \nclass=\"param-type\">Promise</span></dd></dl></dd></dl></article></section></div></div><div class=\"clearfix\"></div><div \nclass=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div \nclass=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span>\n</button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Constants.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Namespace: Constants</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Namespace: Constants</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">Editor\n</a>.</span> Constants</h2></header><article><div class=\"container-overview\"><div class=\"description\">\nConstants of editor</div><dl class=\"details\"></dl></div><h3 class=\"subsection-title\">Members</h3><dl><hr><dt \nclass=\"name\" id=\".nuitEditorEvents\"><h4 id=\".nuitEditorEvents\"><span class=\"type-signature\">&lt;static, constant> \n</span>nuitEditorEvents<span class=\"type-signature\"> :string</span></h4></dt><dd><h5>Type:</h5><ul><li><span \nclass=\"param-type\">string</span></li></ul><dl class=\"details\"><h5 class=\"subsection-title\">Properties:</h5><dl><table \nclass=\"props table table-striped\"><thead><tr><th>Name</th><th>Type</th><th>Default</th><th class=\"last\">Description\n</th></tr></thead><tbody><tr><td class=\"name\"><code>profileLoaded</code></td><td class=\"type\"><span class=\"param-type\">\nstring</span></td><td class=\"default\">nuitEditor::profileLoaded</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">nuitEditor::profileLoaded</a></td></tr><tr><td class=\"name\">\n<code>profileCleared</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td class=\"default\">\nnuitEditor::profileCleared</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">nuitEditor::profileCleared</a></td></tr><tr><td \nclass=\"name\"><code>editorRegistered</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::editorRegistered</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">nuitEditor::editorRegistered</a></td></tr><tr><td \nclass=\"name\"><code>editorUnregistered</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::editorUnregistered</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">nuitEditor::editorUnregistered</a></td></tr><tr><td \nclass=\"name\"><code>editorChanged</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::editorChanged</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::editorChanged\">nuitEditor::editorChanged</a></td></tr><tr><td class=\"name\">\n<code>init</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td class=\"default\">nuitEditor::init\n</td><td class=\"description last\"><a href=\"Editor.Events.html#.event:nuitEditor::init\">nuitEditor::init</a></td></tr>\n<tr><td class=\"name\"><code>reset</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::reset</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">nuitEditor::reset</a></td></tr><tr><td class=\"name\"><code>render\n</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td class=\"default\">nuitEditor::render</td><td \nclass=\"description last\"><a href=\"Editor.Events.html#.event:nuitEditor::render\">nuitEditor::render</a></td></tr><tr><td\n class=\"name\"><code>rendered</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::rendered</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">nuitEditor::rendered</a></td></tr><tr><td class=\"name\"><code>\nsegmentAdded</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td class=\"default\">\nnuitEditor::segmentAdded</td><td class=\"description last\"><a href=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">\nnuitEditor::segmentAdded</a></td></tr><tr><td class=\"name\"><code>segmentRemoved</code></td><td class=\"type\"><span \nclass=\"param-type\">string</span></td><td class=\"default\">nuitEditor::segmentRemoved</td><td class=\"description last\"><a\n href=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">nuitEditor::segmentRemoved</a></td></tr><tr><td \nclass=\"name\"><code>segmentAligned</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::segmentAligned</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">nuitEditor::segmentAligned</a></td></tr><tr><td \nclass=\"name\"><code>segmentLengthChanged</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::segmentLengthChanged</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">nuitEditor::segmentLengthChanged</a></td></tr><tr><td\n class=\"name\"><code>segmentAngleChanged</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::segmentAngleChanged</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">nuitEditor::segmentAngleChanged</a></td></tr><tr><td \nclass=\"name\"><code>segmentConicalChanged</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::segmentConicalChanged</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">nuitEditor::segmentConicalChanged</a></td></tr><tr>\n<td class=\"name\"><code>conicalBaseChanged</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::conicalBaseChanged</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">nuitEditor::conicalBaseChanged</a></td></tr><tr><td \nclass=\"name\"><code>segmentMeasureChanged</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::segmentMeasureChanged</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">nuitEditor::segmentMeasureChanged</a></td></tr><tr>\n<td class=\"name\"><code>segmentBendingChanged</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td\n class=\"default\">nuitEditor::segmentBendingChanged</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">nuitEditor::segmentBendingChanged</a>}</td></tr><tr>\n<td class=\"name\"><code>segmentCloseChanged</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::segmentCloseChanged</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">nuitEditor::segmentCloseChanged</a>}</td></tr><tr><td \nclass=\"name\"><code>segmentDepthChanged</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::segmentDepthChanged</td><td class=\"description last\">nuitEditor::segmentDepthChanged</td>\n</tr><tr><td class=\"name\"><code>segmentFocused</code></td><td class=\"type\"><span class=\"param-type\">string</span></td>\n<td class=\"default\">nuitEditor::segmentFocused</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">nuitEditor::segmentFocused</a></td></tr><tr><td \nclass=\"name\"><code>angleFocused</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"default\">nuitEditor::angleFocused</td><td class=\"description last\"><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">nuitEditor::angleFocused</a></td></tr><tr><td class=\"name\">\n<code>clearSelection</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td class=\"default\">\nnuitEditor::clearSelection</td><td class=\"description last\">nuitEditor::clearSelection</td></tr></tbody></table></dl>\n</dl></dd></dl></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" \nclass=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" id=\"searchResults\"><div \nclass=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \ndata-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">\nSearch results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" \nclass=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span class=\"jsdoc-message\">\nDocumentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Controller.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Namespace: Controller</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Namespace: Controller</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">Editor\n</a>.</span> Controller</h2></header><article><div class=\"container-overview\"><div class=\"description\">\nController of editor</div><dl class=\"details\"></dl></div><h3 class=\"subsection-title\">Classes</h3><dl><dt><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">nuitDraw2dController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDrawController.html\">nuitDrawController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDrawStampingController.html\">nuitDrawStampingController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDrawTopController.html\">nuitDrawTopController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitEditorController.html\">nuitEditorController</a></dt><dd></dd></dl></article></section>\n</div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" \nclass=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" id=\"searchResults\"><div \nclass=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \ndata-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">\nSearch results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" \nclass=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span class=\"jsdoc-message\">\nDocumentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Controller.nuitDraw2dController.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitDraw2dController</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitDraw2dController</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">\nEditor</a><a href=\"Editor.Controller.html\">.Controller</a>.</span> nuitDraw2dController</h2><div \nclass=\"class-description\">Controller for <a href=\"Editor.Components.nuitDraw2dComponent.html\">nuitDraw2dComponent</a>\n</div></header><article><div class=\"container-overview\"><hr><dt><h4 class=\"name\" id=\"nuitDraw2dController\"><span \nclass=\"type-signature\"></span>\nnew nuitDraw2dController($rootScope, $scope, nuitmath, nuitProfile, nuitEditor, nuitEditorEvents)</h4></dt><dd><h5>\nParameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>$rootScope</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"https://docs.angularjs.org/api/ng/service/$rootScope\">https://docs.angularjs.org/api/ng/service/$rootScope</a>\n</td></tr><tr><td class=\"name\"><code>$scope</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"https://docs.angularjs.org/api/ng/service/$scope\">\nhttps://docs.angularjs.org/api/ng/service/$scope</a></td></tr><tr><td class=\"name\"><code>nuitmath</code></td><td \nclass=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\">TODO: remove nuitmath dependency\n</td></tr><tr><td class=\"name\"><code>nuitProfile</code></td><td class=\"type\"><span class=\"param-type\">object</span>\n</td><td class=\"description last\"><a href=\"Editor.Services.nuitProfileFactory.html\">Editor.Services.nuitProfileFactory\n</a></td></tr><tr><td class=\"name\"><code>nuitEditor</code></td><td class=\"type\"><span class=\"param-type\">object</span>\n</td><td class=\"description last\"><a href=\"Editor.Services.nuitEditorFactory.html\">Editor.Services.nuitEditorFactory\n</a></td></tr><tr><td class=\"name\"><code>nuitEditorEvents</code></td><td class=\"type\"><span class=\"param-type\">object\n</span></td><td class=\"description last\"><a href=\"Editor.Constants.html#.nuitEditorEvents\">\nEditor.Constants.nuitEditorEvents</a></td></tr></tbody></table><dl class=\"details\"></dl><h5>Listens to Events:</h5><ul>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li></ul></dd></div><h3 \nclass=\"subsection-title\">Members</h3><dl><hr><dt class=\"name\" id=\".renderer\"><h4 id=\".renderer\"><span \nclass=\"type-signature\">&lt;static, readonly> </span>renderer<span class=\"type-signature\"> :PIXI.Renderer</span></h4>\n</dt><dd><div class=\"description\">Proxy variable for nuitDraw.renderer</div><h5>Type:</h5><ul><li><span \nclass=\"param-type\">PIXI.Renderer</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\".totalLength\">\n<h4 id=\".totalLength\"><span class=\"type-signature\">&lt;static, readonly> </span>totalLength<span \nclass=\"type-signature\"> :string</span></h4></dt><dd><div class=\"description\">\nCalculates the total length of the profile and returns a well-formated string</div><h5>Type:</h5><ul><li><span \nclass=\"param-type\">string</span></li></ul><dl class=\"details\"></dl></dd></dl><h3 class=\"subsection-title\">Methods</h3>\n<dl><hr><dt><h4 class=\"name\" id=\"~$onChanges\"><span class=\"type-signature\">&lt;inner> </span>$onChanges(changes)</h4>\n</dt><dd><div class=\"description\">This method is callend when the configuration or any other binding is changed.</div>\n<h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>changes</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl>\n</dd><hr><dt><h4 class=\"name\" id=\"~$onDestroy\"><span class=\"type-signature\">&lt;inner> </span>$onDestroy()</h4></dt>\n<dd><div class=\"description\">This method is called when the component is being destroyed.</div><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\"~$onInit\"><span class=\"type-signature\">&lt;inner> </span>$onInit()</h4></dt><dd>\n<div class=\"description\">This method is called during the initialization of the component.</div><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\"~$onInput\"><span class=\"type-signature\">&lt;inner> </span>$onInput($event)</h4>\n</dt><dd><div class=\"description\">This event is fired whenever the body receives user input.</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>$event</code></td><td class=\"type\"><span class=\"param-type\">Object</span>\n</td><td class=\"description last\">event data</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~$onMouseWheel\"><span class=\"type-signature\">&lt;inner> </span>$onMouseWheel($event)</h4></dt><dd><div\n class=\"description\">This event is fired whenever the mouse wheel is trigger above the canvas.</div><h5>Parameters:\n</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th>\n</tr></thead><tbody><tr><td class=\"name\"><code>$event</code></td><td class=\"type\"><span class=\"param-type\">Object\n</span></td><td class=\"description last\">event data</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~$onPreRender\"><span class=\"type-signature\">&lt;inner> </span>$onPreRender()</h4></dt><dd><div \nclass=\"description\">This method is called by the editor component before the actual rendering starts.</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~$onResize\"><span class=\"type-signature\">&lt;inner> </span>\n$onResize()</h4></dt><dd><div class=\"description\">This event is fired whenever the window is being resized.</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~center\"><span class=\"type-signature\">&lt;inner> </span>\ncenter(shouldScale)</h4></dt><dd><div class=\"description\">Centers and refreshes the screen.</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>shouldScale</code></td><td class=\"type\"><span class=\"param-type\">Boolean\n</span></td><td class=\"description last\">\ntrue if the screen should adjust the scale to fit the whole segment in at the default zoom</td></tr></tbody></table><dl\n class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~clear\"><span class=\"type-signature\">&lt;inner> </span>clear()\n</h4></dt><dd><div class=\"description\">\nClears the drawing area and resets the camera position and the zoom factor to their default values.</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~createCircle\"><span class=\"type-signature\">&lt;inner> </span>\ncreateCircle(isEnd)</h4></dt><dd><div class=\"description\">\nCreates a new circle container & graphics and registers all events</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>isEnd</code></td><td class=\"type\"><span class=\"param-type\">bool</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">\ncircle</div><dl><dt>Type</dt><dd><span class=\"param-type\">PIXI.Container</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~createMark\"><span class=\"type-signature\">&lt;inner> </span>createMark()</h4></dt><dd><div class=\"description\">\nCreates a mark</div><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">mark</div><dl><dt>Type</dt><dd>\n<span class=\"param-type\">PIXI.Container</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~createRootHitbox\"><span \nclass=\"type-signature\">&lt;inner> </span>createRootHitbox()</h4></dt><dd><div class=\"description\">\nCreates the root hitbox</div><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">hitbox</div><dl><dt>Type\n</dt><dd><span class=\"param-type\">PIXI.Container</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~drawArrow\"><span \nclass=\"type-signature\">&lt;inner> </span>drawArrow(rotation, gra)</h4></dt><dd><div class=\"description\">\nDraws an arrow based on the current scale multiplicator. A new PIXI.Graphics object will be generated if no one is proviced.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>rotation</code></td><td class=\"type\"></td>\n<td class=\"description last\"></td></tr><tr><td class=\"name\"><code>gra</code></td><td class=\"type\"></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span\n class=\"param-type\">*</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~ensureSegments\"><span class=\"type-signature\">\n&lt;inner> </span>ensureSegments(count)</h4></dt><dd><div class=\"description\">\nEnsures that a given amount of visual segment is present in the virtual segments collection.</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>count</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td>\n<td class=\"description last\">the amount of visual segments</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr>\n<dt><h4 class=\"name\" id=\"~hasSegments\"><span class=\"type-signature\">&lt;inner> </span>hasSegments()</h4></dt><dd><div \nclass=\"description\">Returns true if at least one segment is present in the current profile.</div><dl class=\"details\">\n</dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Boolean</span></dd></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~highlightAngle\"><span class=\"type-signature\">&lt;inner> </span>highlightAngle(index)</h4></dt><dd>\n<div class=\"description\">Highlightes the angle at the given index.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">type</span></td><td \nclass=\"description last\">index of segment</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~highlightSegment\"><span class=\"type-signature\">&lt;inner> </span>highlightSegment(index)</h4></dt>\n<dd><div class=\"description\">Highlights (selects) the segment at the given index and prepares it for editing.</div><h5>\nParameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">index of segment</td></tr></tbody></table><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~initManager\"><span class=\"type-signature\">&lt;inner> </span>\ninitManager()</h4></dt><dd><div class=\"description\">Initializes the manager.</div><dl class=\"details\"></dl></dd><hr>\n<dt><h4 class=\"name\" id=\"~initRenderContext\"><span class=\"type-signature\">&lt;inner> </span>initRenderContext()</h4>\n</dt><dd><div class=\"description\">Resets the drawing surface and adds all necessary childs</div><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\"~isAlignMode\"><span class=\"type-signature\">&lt;inner> </span>isAlignMode()</h4>\n</dt><dd><div class=\"description\">Returns true if the align-segment mode is active.</div><dl class=\"details\"></dl><h5>\nReturns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Boolean</span> | <span class=\"param-type\">value</span></dd>\n</dl></dd><hr><dt><h4 class=\"name\" id=\"~materialWidth\"><span class=\"type-signature\">&lt;inner> </span>materialWidth()\n</h4></dt><dd><div class=\"description\">Returns the scaled material width.</div><dl class=\"details\"></dl><h5>Returns:\n</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Number</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~onAngleClicked\"><span class=\"type-signature\">&lt;inner> </span>onAngleClicked(event, index)</h4></dt><dd><div \nclass=\"description\">This event get executed whenever an angle has been focused</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>event</code></td><td class=\"type\"><span class=\"param-type\">*</span></td><td \nclass=\"description last\"></td></tr><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span \nclass=\"param-type\">number</span></td><td class=\"description last\">Index of the clicked event</td></tr></tbody></table>\n<dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~onCircleMeasureDragEnd\"><span class=\"type-signature\">\n&lt;inner> </span>onCircleMeasureDragEnd()</h4></dt><dd><div class=\"description\">\nThis event is fired whenever the user releases one end of the ruler. Should never be called manually!</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~onCircleMeasureDragMove\"><span class=\"type-signature\">\n&lt;inner> </span>onCircleMeasureDragMove()</h4></dt><dd><div class=\"description\">\nThis event is fired whenever the user drags one end of the ruler and moves the pointer. Should never be called manually!\n</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~onCircleMeasureDragStart\"><span \nclass=\"type-signature\">&lt;inner> </span>onCircleMeasureDragStart(event)</h4></dt><dd><div class=\"description\">\nThis event is fire whenever the user clicks on one end of the user to initiate a drag event. Should never be called manually!\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>event</code></td><td class=\"type\"><span \nclass=\"param-type\">Object</span></td><td class=\"description last\">contains the event data</td></tr></tbody></table><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~onSegmentClicked\"><span class=\"type-signature\">&lt;inner> \n</span>onSegmentClicked(event, data)</h4></dt><dd><div class=\"description\">\nThis event is executed whenever a segment has been focused</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>event</code></td><td class=\"type\"><span class=\"param-type\">*</span></td><td \nclass=\"description last\"></td></tr><tr><td class=\"name\"><code>data</code></td><td class=\"type\"><span \nclass=\"param-type\">number</span></td><td class=\"description last\">Index of the clicked segment</td></tr></tbody>\n</table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~onSelectionClear\"><span class=\"type-signature\">\n&lt;inner> </span>onSelectionClear()</h4></dt><dd><div class=\"description\">\nThis event gets executed whenever a segment or angle has been unfocused</div><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~polarProjection\"><span class=\"type-signature\">&lt;inner> </span>polarProjection(angle, radius)</h4>\n</dt><dd><div class=\"description\">\nReturns a new PIXI.Point with a location based on the radius and the specified angle. Example: An angle of PI / 4.0 (90°) and a radius of 4.0 yields [~2.828,~2.828] in cartesian coordinates.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>angle</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">direction of offset</td></tr><tr><td class=\"name\">\n<code>radius</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td class=\"description last\">\ndistance of offset</td></tr></tbody></table><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">\nPoint (vector) containing the offset on both axes</div><dl><dt>Type</dt><dd><span class=\"param-type\">PIXI.Point</span>\n</dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~refresh\"><span class=\"type-signature\">&lt;inner> </span>refresh()</h4>\n</dt><dd><div class=\"description\">Refreshes and rebuilds the scene and renders it to the screen afterwards.</div><dl \nclass=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">undefined</span></dd></dl></dd><hr>\n<dt><h4 class=\"name\" id=\"~refreshScale\"><span class=\"type-signature\">&lt;inner> </span>refreshScale()</h4></dt><dd><div\n class=\"description\">Recalculates the scale multiplicator and marks the grid dirty.</div><dl class=\"details\"></dl></dd>\n<hr><dt><h4 class=\"name\" id=\"~renderGrid\"><span class=\"type-signature\">&lt;inner> </span>renderGrid()</h4></dt><dd><div\n class=\"description\">Renders the grid based on the current scale multiplicator.</div><dl class=\"details\"></dl></dd><hr>\n<dt><h4 class=\"name\" id=\"~renderSegments\"><span class=\"type-signature\">&lt;inner> </span>renderSegments()</h4></dt><dd>\n<div class=\"description\">Renders the whole profile and all connected visuals like text, arrows and boxes.</div><dl \nclass=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">undefined</span></dd></dl></dd><hr>\n<dt><h4 class=\"name\" id=\"~rotate\"><span class=\"type-signature\">&lt;inner> </span>rotate(value)</h4></dt><dd><div \nclass=\"description\">Rotates the profile.</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>value</code>\n</td><td class=\"type\"><span class=\"param-type\">Number</span></td><td class=\"description last\">rotation value</td></tr>\n</tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~setAligning\"><span class=\"type-signature\">\n&lt;inner> </span>setAligning(value)</h4></dt><dd><div class=\"description\">Activates or deactivates the align mode.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>value</code></td><td class=\"type\"><span \nclass=\"param-type\">bool</span></td><td class=\"description last\">Wether to activate or deactivate aligning</td></tr>\n</tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~setRuler\"><span class=\"type-signature\">\n&lt;inner> </span>setRuler(value)</h4></dt><dd><div class=\"description\">Enables or disables the ruler</div><h5>\nParameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>value</code></td><td class=\"type\"><span \nclass=\"param-type\">bool</span></td><td class=\"description last\">Wether to activate or deactivate the ruler</td></tr>\n</tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~setupConfig\"><span class=\"type-signature\">\n&lt;inner> </span>setupConfig()</h4></dt><dd><div class=\"description\">Merges default config and given into vm.config\n</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~setZoomFactor\"><span class=\"type-signature\">\n&lt;inner> </span>setZoomFactor(value)</h4></dt><dd><div class=\"description\">Sets the user controlled zoom factor.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>value</code></td><td class=\"type\"></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">\nReturns true if the scale has been refreshed.</div><dl><dt>Type</dt><dd><span class=\"param-type\">boolean</span></dd>\n</dl></dd><hr><dt><h4 class=\"name\" id=\"~snapToSegment\"><span class=\"type-signature\">&lt;inner> </span>\nsnapToSegment(origin, distance)</h4></dt><dd><div class=\"description\">\nSnaps the given object to the closes segment within the given distance.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>origin</code></td><td class=\"type\"><span class=\"param-type\">Object</span></td><td \nclass=\"description last\"></td></tr><tr><td class=\"name\"><code>distance</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl>\n<h5>Returns:</h5><div class=\"param-desc\">- true if snap was successful</div><dl><dt>Type</dt><dd><span \nclass=\"param-type\">Boolean</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~symbolInner\"><span \nclass=\"type-signature\">&lt;inner> </span>symbolInner()</h4></dt><dd><div class=\"description\">\nReturns the symbol for the inner measurement. TODO: Requires localization</div><dl class=\"details\"></dl><h5>Returns:\n</h5><dl><dt>Type</dt><dd><span class=\"param-type\">String</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~symbolOuter\"><span class=\"type-signature\">&lt;inner> </span>symbolOuter()</h4></dt><dd><div class=\"description\">\nReturns the symbol for the outer measurement. TODO: Requires localization</div><dl class=\"details\"></dl><h5>Returns:\n</h5><dl><dt>Type</dt><dd><span class=\"param-type\">String</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~toggleAligning\"><span class=\"type-signature\">&lt;inner> </span>toggleAligning()</h4></dt><dd><div \nclass=\"description\">Toggles the state of the segment aligning mode.</div><dl class=\"details\"></dl><h5>Returns:</h5><div\n class=\"param-desc\">vm</div><dl><dt>Type</dt><dd><span class=\"param-type\">vm</span></dd></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~toggleRuler\"><span class=\"type-signature\">&lt;inner> </span>toggleRuler()</h4></dt><dd><div \nclass=\"description\">Toggles the current state of the ruler and refreshes the screen.</div><dl class=\"details\"></dl>\n</dd><hr><dt><h4 class=\"name\" id=\"~toggleVisibleSide\"><span class=\"type-signature\">&lt;inner> </span>\ntoggleVisibleSide()</h4></dt><dd><div class=\"description\">Toggles visible side</div><dl class=\"details\"></dl></dd><hr>\n<dt><h4 class=\"name\" id=\"~unhighlightAll\"><span class=\"type-signature\">&lt;inner> </span>unhighlightAll()</h4></dt><dd>\n<div class=\"description\">Unhighlights all segments and angles</div><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~zoom\"><span class=\"type-signature\">&lt;inner> </span>zoom(value)</h4></dt><dd><div \nclass=\"description\">\nScales the whole screen up or down and centers it. If the value provided is smaller than zero it performs a zoom out.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>value</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">the zoom factor</td></tr></tbody></table><dl \nclass=\"details\"></dl></dd></dl></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div \nid=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" \nid=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4\n class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button \ntype=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Controller.nuitDrawController.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitDrawController</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitDrawController</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">\nEditor</a><a href=\"Editor.Controller.html\">.Controller</a>.</span> nuitDrawController</h2><div \nclass=\"class-description\">Controller for <a href=\"Editor.Components.nuitDrawComponent.html\">nuitDrawComponent </a>\n</div></header><article><div class=\"container-overview\"><hr><dt><h4 class=\"name\" id=\"nuitDrawController\"><span \nclass=\"type-signature\"></span>\nnew nuitDrawController($scope, $log, $rootScope, nuitEditorEvents, nuitEditor, nuitProfile)</h4></dt><dd><h5>\nParameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>$scope</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"https://docs.angularjs.org/api/ng/service/$scope\">https://docs.angularjs.org/api/ng/service/$scope</a></td></tr>\n<tr><td class=\"name\"><code>$log</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"https://docs.angularjs.org/api/ng/service/$log\">\nhttps://docs.angularjs.org/api/ng/service/$log</a></td></tr><tr><td class=\"name\"><code>$rootScope</code></td><td \nclass=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"https://docs.angularjs.org/api/ng/service/$rootScope\">https://docs.angularjs.org/api/ng/service/$rootScope</a>\n</td></tr><tr><td class=\"name\"><code>nuitEditorEvents</code></td><td class=\"type\"><span class=\"param-type\">object\n</span></td><td class=\"description last\"><a href=\"Editor.Constants.html#.nuitEditorEvents\">nuitEditorEvents </a></td>\n</tr><tr><td class=\"name\"><code>nuitEditor</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"Editor.Services.nuitEditorFactory.html\">nuitEditorFactory </a></td></tr><tr><td \nclass=\"name\"><code>nuitProfile</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"Editor.Services.nuitProfileFactory.html\">nuitProfileFactory </a></td></tr></tbody>\n</table><dl class=\"details\"></dl><h5>Listens to Events:</h5><ul><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li></ul></dd></div><h3 \nclass=\"subsection-title\">Members</h3><dl><hr><dt class=\"name\" id=\".currentEditor\"><h4 id=\".currentEditor\"><span \nclass=\"type-signature\">&lt;static> </span>currentEditor<span class=\"type-signature\"> :string|object</span></h4></dt>\n<dd><div class=\"description\">Wrapper for <a href=\"Editor.Services.nuitEditorFactory.html#.currentEditor\">\nnuitEditor.currentEditor</a></div><h5>Type:</h5><ul><li><span class=\"param-type\">string</span> | <span \nclass=\"param-type\">object</span></li></ul><dl class=\"details\"><dt \nclass=\"tag-see method-doc-label method-doc-details-label\">See:</dt><dd class=\"tag-see\"><ul><li><a \nhref=\"Editor.Services.nuitEditorFactory.html#.currentEditor\">nuitEditor.currentEditor</a></li></ul></dd></dl></dd><hr>\n<dt class=\"name\" id=\".element\"><h4 id=\".element\"><span class=\"type-signature\">&lt;static> </span>element<span \nclass=\"type-signature\"> :*</span></h4></dt><dd><div class=\"description\">Contains the dom element for the view</div><h5>\nType:</h5><ul><li><span class=\"param-type\">*</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" \nid=\".fpsSyncTimeoutID\"><h4 id=\".fpsSyncTimeoutID\"><span class=\"type-signature\">&lt;static> </span>fpsSyncTimeoutID<span\n class=\"type-signature\"> :Timeout|null</span></h4></dt><dd><div class=\"description\">Contains the timeout for fps sync\n</div><h5>Type:</h5><ul><li><span class=\"param-type\">Timeout</span> | <span class=\"param-type\">null</span></li></ul><dl\n class=\"details\"></dl></dd><hr><dt class=\"name\" id=\".renderer\"><h4 id=\".renderer\"><span class=\"type-signature\">\n&lt;static> </span>renderer<span class=\"type-signature\"> :*</span></h4></dt><dd><div class=\"description\">\nContains the PIXI.js renderer</div><h5>Type:</h5><ul><li><span class=\"param-type\">*</span></li></ul><dl \nclass=\"details\"></dl></dd><hr><dt class=\"name\" id=\".resizeTimeoutID\"><h4 id=\".resizeTimeoutID\"><span \nclass=\"type-signature\">&lt;static> </span>resizeTimeoutID<span class=\"type-signature\"> :Timeout|null</span></h4></dt>\n<dd><div class=\"description\">Contains the timeout after each resize to prevent unnecessary resize actions</div><h5>\nType:</h5><ul><li><span class=\"param-type\">Timeout</span> | <span class=\"param-type\">null</span></li></ul><dl \nclass=\"details\"></dl></dd><hr><dt class=\"name\" id=\".root\"><h4 id=\".root\"><span class=\"type-signature\">&lt;static> \n</span>root<span class=\"type-signature\"> :*</span></h4></dt><dd><div class=\"description\">The PIXI.js root container\n</div><h5>Type:</h5><ul><li><span class=\"param-type\">*</span></li></ul><dl class=\"details\"></dl></dd><hr><dt \nclass=\"name\" id=\"~DEFAULT_CONFIG\"><h4 id=\"~DEFAULT_CONFIG\"><span class=\"type-signature\">&lt;inner, constant> </span>\nDEFAULT_CONFIG<span class=\"type-signature\"> :object</span></h4></dt><dd><div class=\"description\">\nContains the default configuration for the nuitDraw Component</div><h5>Type:</h5><ul><li><span class=\"param-type\">\nobject</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~RESIZE_TIMEOUT\"><h4 \nid=\"~RESIZE_TIMEOUT\"><span class=\"type-signature\">&lt;inner, constant> </span>RESIZE_TIMEOUT<span \nclass=\"type-signature\"> :number</span></h4></dt><dd><div class=\"description\">\nContains the timeout in ms after the window resize event</div><h5>Type:</h5><ul><li><span class=\"param-type\">number\n</span></li></ul><dl class=\"details\"><dt class=\"tag-default method-doc-label method-doc-details-label\">Default Value:\n</dt><dd class=\"tag-default\"><ul class=\"dummy\"><li>50</li></ul></dd></dl></dd></dl><h3 class=\"subsection-title\">Methods\n</h3><dl><hr><dt><h4 class=\"name\" id=\".render\"><span class=\"type-signature\">&lt;static> </span>render()</h4></dt><dd>\n<div class=\"description\">Renders the root container to the canvas</div><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~$onChanges\"><span class=\"type-signature\">&lt;inner> </span>$onChanges(changes)</h4></dt><dd><div \nclass=\"description\">Component lifecycle-hook which gets automatically called whenever a parameters gets changed</div>\n<h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>changes</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"description last\">Further details about the changes</td></tr></tbody>\n</table><dl class=\"details\"><dt class=\"tag-see method-doc-label method-doc-details-label\">See:</dt><dd class=\"tag-see\">\n<ul><li><a href=\"https://docs.angularjs.org/guide/component#component-based-application-architecture\">\nAngularJS Component Lifecycles </a></li></ul></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~$onDestroy\"><span \nclass=\"type-signature\">&lt;inner> </span>$onDestroy()</h4></dt><dd><div class=\"description\">\nComponent lifecycle-hook which gets automatically called when the component gets destroyed. This method should be used to unregister all event handler which are listening on DOM elements or on $rootScope\n</div><dl class=\"details\"><dt class=\"tag-see method-doc-label method-doc-details-label\">See:</dt><dd class=\"tag-see\">\n<ul><li><a href=\"https://docs.angularjs.org/guide/component#component-based-application-architecture\">\nAngularJS Component Lifecycles </a></li></ul></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~$onInit\"><span \nclass=\"type-signature\">&lt;inner> </span>$onInit()</h4></dt><dd><div class=\"description\">\nComponent lifecycle-hook which gets automatically called when the component gets initiated. This method should be used to create all DOM depending objects and to add event listeners\n</div><dl class=\"details\"><dt class=\"tag-see method-doc-label method-doc-details-label\">See:</dt><dd class=\"tag-see\">\n<ul><li><a href=\"https://docs.angularjs.org/guide/component#component-based-application-architecture\">\nAngularJS Component Lifecycles </a></li></ul></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~createRenderer\"><span \nclass=\"type-signature\">&lt;inner> </span>createRenderer()</h4></dt><dd><div class=\"description\">\nCreates a new PIXI.JS renderer</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span \nclass=\"param-type\">Renderer</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~onEditorChange\"><span \nclass=\"type-signature\">&lt;inner> </span>onEditorChange()</h4></dt><dd><div class=\"description\">\nSwitches the view to the editor with the given id.</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~onInput\"><span class=\"type-signature\">&lt;inner> </span>onInput($event)</h4></dt><dd><div class=\"description\">\nThis event is fired whenever the body receives user input.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>$event</code></td><td class=\"type\"><span class=\"param-type\">Object</span></td><td \nclass=\"description last\">event data</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~onMouseWheel\"><span class=\"type-signature\">&lt;inner> </span>onMouseWheel($event)</h4></dt><dd><div \nclass=\"description\">This event is fired whenever the mouse wheel is triggered above the canvas.</div><h5>Parameters:\n</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th>\n</tr></thead><tbody><tr><td class=\"name\"><code>$event</code></td><td class=\"type\"><span class=\"param-type\">Object\n</span></td><td class=\"description last\">event data</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~onWindowResize\"><span class=\"type-signature\">&lt;inner> </span>onWindowResize()</h4></dt><dd><div \nclass=\"description\">This event is fired whenever the window is being resized.</div><dl class=\"details\"></dl></dd><hr>\n<dt><h4 class=\"name\" id=\"~render\"><span class=\"type-signature\">&lt;inner> </span>render(force)</h4></dt><dd><div \nclass=\"description\">Starts a new rendercycle</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead>\n<tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>force\n</code></td><td class=\"type\"><span class=\"param-type\">bool</span></td><td class=\"description last\">\nForce an immediate render cycle</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~renderCallback\"><span class=\"type-signature\">&lt;inner> </span>renderCallback()</h4></dt><dd><div \nclass=\"description\">Renders the root container to the canvas.</div><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~setupConfig\"><span class=\"type-signature\">&lt;inner> </span>setupConfig()</h4></dt><dd><div \nclass=\"description\">Merge default config with given config</div><dl class=\"details\"></dl></dd></dl></article></section>\n</div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" \nclass=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" id=\"searchResults\"><div \nclass=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \ndata-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">\nSearch results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" \nclass=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span class=\"jsdoc-message\">\nDocumentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Controller.nuitDrawStampingController.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitDrawStampingController</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitDrawStampingController</h1><section><header><h2><span class=\"ancestors\"><a \nhref=\"Editor.html\">Editor</a><a href=\"Editor.Controller.html\">.Controller</a>.</span> nuitDrawStampingController</h2>\n<div class=\"class-description\">Controller for <a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nnuitDrawStampingComponent</a></div></header><article><div class=\"container-overview\"><hr><dt><h4 class=\"name\" \nid=\"nuitDrawStampingController\"><span class=\"type-signature\"></span>\nnew nuitDrawStampingController($scope, $rootScope, nuitEditor, nuitEditorEvents, nuitProfile)</h4></dt><dd><h5>\nParameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>$scope</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"https://docs.angularjs.org/api/ng/service/$scope\">https://docs.angularjs.org/api/ng/service/$scope</a></td></tr>\n<tr><td class=\"name\"><code>$rootScope</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"https://docs.angularjs.org/api/ng/service/$rootScope\">\nhttps://docs.angularjs.org/api/ng/service/$rootScope</a></td></tr><tr><td class=\"name\"><code>nuitEditor</code></td><td \nclass=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"Editor.Services.nuitEditorFactory.html\">Editor.Services.nuitEditorFactory</a></td></tr><tr><td class=\"name\">\n<code>nuitEditorEvents</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"Editor.Constants.html#.nuitEditorEvents\">Editor.Constants.nuitEditorEvents</a></td>\n</tr><tr><td class=\"name\"><code>nuitProfile</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"Editor.Services.nuitProfileFactory.html\">Editor.Services.nuitProfileFactory</a></td>\n</tr></tbody></table><dl class=\"details\"></dl><h5>Listens to Events:</h5><ul><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li></ul></dd></div><h3 \nclass=\"subsection-title\">Methods</h3><dl><hr><dt><h4 class=\"name\" id=\"~$onDestroy\"><span class=\"type-signature\">\n&lt;inner> </span>$onDestroy()</h4></dt><dd><div class=\"description\">\nThis method is called when the component is being destroyed.</div><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~$onInit\"><span class=\"type-signature\">&lt;inner> </span>$onInit()</h4></dt><dd><div \nclass=\"description\">This method is called during the initialization of the component.</div><dl class=\"details\"></dl>\n</dd><hr><dt><h4 class=\"name\" id=\"~$onMouseWheel\"><span class=\"type-signature\">&lt;inner> </span>$onMouseWheel($event)\n</h4></dt><dd><div class=\"description\">This event is fired whenever the mouse wheel is triggered above the canvas.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>$event</code></td><td class=\"type\"><span \nclass=\"param-type\">Object</span></td><td class=\"description last\">event data</td></tr></tbody></table><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~$onPreRender\"><span class=\"type-signature\">&lt;inner> </span>\n$onPreRender()</h4></dt><dd><div class=\"description\">\nThis method is called by the editor component before the actual rendering starts.</div><dl class=\"details\"></dl></dd>\n<hr><dt><h4 class=\"name\" id=\"~$onResize\"><span class=\"type-signature\">&lt;inner> </span>$onResize()</h4></dt><dd><div \nclass=\"description\">This event is fired whenever the canvas is being resized.</div><dl class=\"details\"></dl><h5>\nReturns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">undefined</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~$onUse\"><span class=\"type-signature\">&lt;inner> </span>$onUse()</h4></dt><dd><div class=\"description\">\nThis event is called whenever this editor becomes active.</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type\n</dt><dd><span class=\"param-type\">undefined</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~initManager\"><span \nclass=\"type-signature\">&lt;inner> </span>initManager()</h4></dt><dd><div class=\"description\">Initializes the manager.\n</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~setupConfig\"><span class=\"type-signature\">&lt;inner> \n</span>setupConfig()</h4></dt><dd><div class=\"description\">Merges default config and given into vm.config</div><dl \nclass=\"details\"></dl></dd></dl></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div \nid=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" \nid=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4\n class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button \ntype=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Controller.nuitDrawTopController.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitDrawTopController</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitDrawTopController</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">\nEditor</a><a href=\"Editor.Controller.html\">.Controller</a>.</span> nuitDrawTopController</h2><div \nclass=\"class-description\">Controller for the <a href=\"Editor.Components.nuitDrawTopComponent.html\">nuitDrawTopComponent\n</a></div></header><article><div class=\"container-overview\"><hr><dt><h4 class=\"name\" id=\"nuitDrawTopController\"><span \nclass=\"type-signature\"></span>new nuitDrawTopController($scope, nuitEditor, nuitProfile, nuitEditorEvents)</h4></dt>\n<dd><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>$scope</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"https://docs.angularjs.org/api/ng/service/$scope\">https://docs.angularjs.org/api/ng/service/$scope</a></td></tr>\n<tr><td class=\"name\"><code>nuitEditor</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"Editor.Services.nuitEditorFactory.html\">nuitEditor</a></td></tr><tr><td class=\"name\">\n<code>nuitProfile</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\">\n<a href=\"Editor.Services.nuitProfileFactory.html\">nuitProfile</a></td></tr><tr><td class=\"name\"><code>nuitEditorEvents\n</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"Editor.Constants.html#.nuitEditorEvents\">Editor.Constants.nuitEditorEvents</a></td></tr></tbody></table><dl \nclass=\"details\"></dl><h5>Listens to Events:</h5><ul><li>Editor.Events.nuitEditor::segmentDepthChanged</li></ul></dd>\n</div><h3 class=\"subsection-title\">Members</h3><dl><hr><dt class=\"name\" id=\"~DEFAULT_CONFIG\"><h4 id=\"~DEFAULT_CONFIG\">\n<span class=\"type-signature\">&lt;inner, constant> </span>DEFAULT_CONFIG<span class=\"type-signature\"> :object</span>\n</h4></dt><dd><div class=\"description\">Contains the default configuration for the nuitDrawTop Subeditor</div><h5>Type:\n</h5><ul><li><span class=\"param-type\">object</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" \nid=\"~ZOOM_TYPE\"><h4 id=\"~ZOOM_TYPE\"><span class=\"type-signature\">&lt;inner, constant> </span>ZOOM_TYPE<span \nclass=\"type-signature\"> :object</span></h4></dt><dd><div class=\"description\">Enum with all possible zoom types</div>\n<h5>Type:</h5><ul><li><span class=\"param-type\">object</span></li></ul><dl class=\"details\"><h5 class=\"subsection-title\">\nProperties:</h5><dl><table class=\"props table table-striped\"><thead><tr><th>Name</th><th>Type</th><th>Default</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>STRETCHED</code></td><td class=\"type\"><span\n class=\"param-type\">object</span></td><td class=\"default\">s</td><td class=\"description last\"></td></tr><tr><td \nclass=\"name\"><code>PROPORTIONAL</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"default\">p</td><td class=\"description last\"></td></tr></tbody></table></dl></dl></dd></dl><h3 \nclass=\"subsection-title\">Methods</h3><dl><hr><dt><h4 class=\"name\" id=\"~$onInit\"><span class=\"type-signature\">\n&lt;inner> </span>$onInit()</h4></dt><dd><div class=\"description\">\nPrepares the subeditor for further usage. This method will be automatically executed whenever the component is loaded\n</div><dl class=\"details\"><dt class=\"tag-see method-doc-label method-doc-details-label\">See:</dt><dd class=\"tag-see\">\n<ul><li><a href=\"https://docs.angularjs.org/guide/component#component-based-application-architecture\">\nAngularJS Component Lifecycles </a></li></ul></dd></dl></dd></dl></article></section></div></div><div class=\"clearfix\">\n</div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div \nclass=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span>\n</button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Controller.nuitEditorController.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitEditorController</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitEditorController</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">\nEditor</a><a href=\"Editor.Controller.html\">.Controller</a>.</span> nuitEditorController</h2><div \nclass=\"class-description\">Controller for <a href=\"Editor.Components.nuitEditorComponent.html\">nuitEditorComponent</a>\n</div></header><article><div class=\"container-overview\"><hr><dt><h4 class=\"name\" id=\"nuitEditorController\"><span \nclass=\"type-signature\"></span>\nnew nuitEditorController($window, $scope, $mdDialog, $mdMedia, $injector, nuitEditorEvents, nuitProfile, nuitEditor)\n</h4></dt><dd><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>$window</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"https://docs.angularjs.org/api/ng/service/$window\">https://docs.angularjs.org/api/ng/service/$window</a></td>\n</tr><tr><td class=\"name\"><code>$scope</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"https://docs.angularjs.org/api/ng/service/$scope\">\nhttps://docs.angularjs.org/api/ng/service/$scope</a></td></tr><tr><td class=\"name\"><code>$mdDialog</code></td><td \nclass=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"https://docs.angularjs.org/api/ng/service/$mdDialog\">https://docs.angularjs.org/api/ng/service/$mdDialog</a></td>\n</tr><tr><td class=\"name\"><code>$mdMedia</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"https://docs.angularjs.org/api/ng/service/$mdMedia\">\nhttps://docs.angularjs.org/api/ng/service/$mdMedia</a></td></tr><tr><td class=\"name\"><code>$injector</code></td><td \nclass=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"https://docs.angularjs.org/api/ng/service/$injector\">https://docs.angularjs.org/api/ng/service/$injector</a></td>\n</tr><tr><td class=\"name\"><code>nuitEditorEvents</code></td><td class=\"type\"><span class=\"param-type\">object</span>\n</td><td class=\"description last\"><a href=\"Editor.Constants.html#.nuitEditorEvents\">nuitEditorEvents </a></td></tr><tr>\n<td class=\"name\"><code>nuitProfile</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"Editor.Services.nuitProfileFactory.html\">nuitProfileFactory </a></td></tr><tr><td \nclass=\"name\"><code>nuitEditor</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><a href=\"Editor.Services.nuitEditorFactory.html\">nuitEditorFactory </a></td></tr></tbody>\n</table><dl class=\"details\"></dl><h5>Listens to Events:</h5><ul><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></dd>\n</div><h3 class=\"subsection-title\">Members</h3><dl><hr><dt class=\"name\" id=\"~DEFAULT_CONFIG\"><h4 id=\"~DEFAULT_CONFIG\">\n<span class=\"type-signature\">&lt;inner, constant> </span>DEFAULT_CONFIG<span class=\"type-signature\"> :object</span>\n</h4></dt><dd><div class=\"description\">Contains default configuration for the nuitEditorComponent</div><h5>Type:</h5>\n<ul><li><span class=\"param-type\">object</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" \nid=\"~ROTATION_CCLOCKWISE\"><h4 id=\"~ROTATION_CCLOCKWISE\"><span class=\"type-signature\">&lt;inner, constant> </span>\nROTATION_CCLOCKWISE<span class=\"type-signature\"> :number</span></h4></dt><dd><div class=\"description\">\nRotation degrees counter clockwise. Used in 2d tools</div><h5>Type:</h5><ul><li><span class=\"param-type\">number</span>\n</li></ul><dl class=\"details\"><dt class=\"tag-default method-doc-label method-doc-details-label\">Default Value:</dt><dd \nclass=\"tag-default\"><ul class=\"dummy\"><li>-90</li></ul></dd></dl></dd><hr><dt class=\"name\" id=\"~ROTATION_CLOCKWISE\"><h4\n id=\"~ROTATION_CLOCKWISE\"><span class=\"type-signature\">&lt;inner, constant> </span>ROTATION_CLOCKWISE<span \nclass=\"type-signature\"> :number</span></h4></dt><dd><div class=\"description\">\nRotation degrees clockwise. Used in 2d tools</div><h5>Type:</h5><ul><li><span class=\"param-type\">number</span></li>\n</ul><dl class=\"details\"><dt class=\"tag-default method-doc-label method-doc-details-label\">Default Value:</dt><dd \nclass=\"tag-default\"><ul class=\"dummy\"><li>90</li></ul></dd></dl></dd><hr><dt class=\"name\" id=\"~ZOOM_IN_FACTOR\"><h4 \nid=\"~ZOOM_IN_FACTOR\"><span class=\"type-signature\">&lt;inner, constant> </span>ZOOM_IN_FACTOR<span \nclass=\"type-signature\"> :number</span></h4></dt><dd><div class=\"description\">Default zoom-in-factor. Used in 2d tools\n</div><h5>Type:</h5><ul><li><span class=\"param-type\">number</span></li></ul><dl class=\"details\"><dt \nclass=\"tag-default method-doc-label method-doc-details-label\">Default Value:</dt><dd class=\"tag-default\"><ul \nclass=\"dummy\"><li>1.1</li></ul></dd></dl></dd><hr><dt class=\"name\" id=\"~ZOOM_OUT_FACTOR\"><h4 id=\"~ZOOM_OUT_FACTOR\">\n<span class=\"type-signature\">&lt;inner, constant> </span>ZOOM_OUT_FACTOR<span class=\"type-signature\"> :number</span>\n</h4></dt><dd><div class=\"description\">Default zoom-out-factor. Used in 2d tools</div><h5>Type:</h5><ul><li><span \nclass=\"param-type\">number</span></li></ul><dl class=\"details\"><dt \nclass=\"tag-default method-doc-label method-doc-details-label\">Default Value:</dt><dd class=\"tag-default\"><ul \nclass=\"dummy\"><li>-1.1</li></ul></dd></dl></dd></dl><h3 class=\"subsection-title\">Methods</h3><dl><hr><dt><h4 \nclass=\"name\" id=\"~$onDestroy\"><span class=\"type-signature\">&lt;inner> </span>$onDestroy()</h4></dt><dd><div \nclass=\"description\">Resets the editor</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~$onInit\"><span \nclass=\"type-signature\">&lt;inner> </span>$onInit()</h4></dt><dd><div class=\"description\">Initializes this controller.\n</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~clearErrors\"><span class=\"type-signature\">&lt;inner> \n</span>clearErrors()</h4></dt><dd><div class=\"description\">Clears all stored errors from the error container array.\n</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~historyBack\"><span class=\"type-signature\">&lt;inner> \n</span>historyBack()</h4></dt><dd><div class=\"description\">Undos the last action of the user.</div><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\"~historyForward\"><span class=\"type-signature\">&lt;inner> </span>historyForward()\n</h4></dt><dd><div class=\"description\">Redos the last action of the user</div><dl class=\"details\"></dl></dd><hr><dt><h4\n class=\"name\" id=\"~isView\"><span class=\"type-signature\">&lt;inner> </span>isView(view)</h4></dt><dd><div \nclass=\"description\">Compares the given view with the current view. Reutrns true if they are equal.</div><h5>Parameters:\n</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th>\n</tr></thead><tbody><tr><td class=\"name\"><code>view</code></td><td class=\"type\"><span class=\"param-type\">String</span>\n</td><td class=\"description last\">string identifier of a view</td></tr></tbody></table><dl class=\"details\"></dl><h5>\nReturns:</h5><div class=\"param-desc\">true if current view equals the provided one</div><dl><dt>Type</dt><dd><span \nclass=\"param-type\">Boolean</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~onAngleFocused\"><span \nclass=\"type-signature\">&lt;inner> </span>onAngleFocused(event, index)</h4></dt><dd><div class=\"description\">\nEvent handler for highlighting an angle</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>event</code>\n</td><td class=\"type\"></td><td class=\"description last\"></td></tr><tr><td class=\"name\"><code>index</code></td><td \nclass=\"type\"></td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~onSegmentFocused\"><span class=\"type-signature\">&lt;inner> </span>onSegmentFocused(event, data)</h4>\n</dt><dd><div class=\"description\">Event handler for highlighting a segment</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>event</code></td><td class=\"type\"></td><td class=\"description last\"></td></tr><tr><td\n class=\"name\"><code>data</code></td><td class=\"type\"></td><td class=\"description last\"></td></tr></tbody></table><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~onSelectionCleared\"><span class=\"type-signature\">&lt;inner> \n</span>onSelectionCleared()</h4></dt><dd><div class=\"description\">Event handler for clearing any selection</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~refreshScope\"><span class=\"type-signature\">&lt;inner> </span>\nrefreshScope()</h4></dt><dd><div class=\"description\">Updates the scope to refresh bindings (e.g. sidebar)</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~reset\"><span class=\"type-signature\">&lt;inner> </span>reset()\n</h4></dt><dd><div class=\"description\">Resets the whole editor back to its default state after loading.</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~selectMaterial\"><span class=\"type-signature\">&lt;inner> </span>\nselectMaterial()</h4></dt><dd><div class=\"description\">\nIf material dialog set, it will open it and apply the resolved variable</div><dl class=\"details\"></dl><h5>Returns:</h5>\n<div class=\"param-desc\">Returns the new material if resolved</div><dl><dt>Type</dt><dd><span class=\"param-type\">Promise\n</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~showNewProfileDialog\"><span class=\"type-signature\">&lt;inner> \n</span>showNewProfileDialog()</h4></dt><dd><div class=\"description\">Displays the new profile confirmation dialog.</div>\n<dl class=\"details\"></dl></dd></dl></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\">\n<div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" \nid=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4\n class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button \ntype=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Directives.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Namespace: Directives</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Namespace: Directives</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">Editor\n</a>.</span> Directives</h2></header><article><div class=\"container-overview\"><div class=\"description\">\nDirectives of editor</div><dl class=\"details\"></dl></div><h3 class=\"subsection-title\">Classes</h3><dl><dt><a \nhref=\"Editor.Directives.ngHoldDirective.html\">ngHoldDirective</a></dt><dd></dd></dl></article></section></div></div>\n<div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div>\n</div></div></div><div class=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span \naria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\">\n</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div>\n</div></div></div><footer><span class=\"jsdoc-message\">Documentation generated by <a \nhref=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a> on 2018-04-10T11:34:23+02:00 using the <a \nhref=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span></footer><script \nsrc=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script type=\"text/javascript\" \nsrc=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Directives.ngHoldDirective.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: ngHoldDirective</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: ngHoldDirective</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">Editor\n</a><a href=\"Editor.Directives.html\">.Directives</a>.</span> ngHoldDirective</h2><div class=\"class-description\">\nDirective for repetitive triggering an event when mouse key is pressed</div></header><article><div \nclass=\"container-overview\"><hr><dt><h4 class=\"name\" id=\"ngHoldDirective\"><span class=\"type-signature\"></span>\nnew ngHoldDirective(ng-hold, ng-hold-interval [, ng-hold-done])</h4></dt><dd><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th>Argument</th><th class=\"last\">Description\n</th></tr></thead><tbody><tr><td class=\"name\"><code>ng-hold</code></td><td class=\"type\"><span class=\"param-type\">\nfunction</span></td><td class=\"attributes\"></td><td class=\"description last\">\nCallback which will be called on every interval tick</td></tr><tr><td class=\"name\"><code>ng-hold-interval</code></td>\n<td class=\"type\"><span class=\"param-type\">string</span> | <span class=\"param-type\">number</span></td><td \nclass=\"attributes\"></td><td class=\"description last\"></td></tr><tr><td class=\"name\"><code>ng-hold-done</code></td><td \nclass=\"type\"><span class=\"param-type\">function</span></td><td class=\"attributes\">&lt;optional><br></td><td \nclass=\"description last\">Callback which will be called when the interaction gets interrupted</td></tr></tbody></table>\n<dl class=\"details\"></dl><h5>Requires:</h5><ul><li><a href=\"https://docs.angularjs.org/api/ng/service/$timeout%20\">\n$timeout</a></li></ul><h5>Example</h5><pre class=\"sunlight-highlight-javascript\">\n&lt;md-button type=&quot;button&quot; ng-hold=&quot;$scope.foo()&quot; ng-hold-interval=&quot;500:1, 150&quot; ng-hold-done=&quot;$scope.bar()&quot;&gt;\n	Press me\n&lt;/md-button&gt;\n</pre></dd></div><h3 class=\"subsection-title\">Requires</h3><ul><li><a \nhref=\"https://docs.angularjs.org/api/ng/service/$timeout%20\">$timeout</a></li></ul></article></section></div></div><div\n class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div>\n</div></div><div class=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span \naria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\">\n</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div>\n</div></div></div><footer><span class=\"jsdoc-message\">Documentation generated by <a \nhref=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a> on 2018-04-10T11:34:23+02:00 using the <a \nhref=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span></footer><script \nsrc=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script type=\"text/javascript\" \nsrc=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Events.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Namespace: Events</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Namespace: Events</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">Editor</a>.\n</span> Events</h2></header><article><div class=\"container-overview\"><div class=\"description\">Events of editor</div><dl\n class=\"details\"></dl></div><h3 class=\"subsection-title\">Events</h3><dl><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::angleFocused\">nuitEditor::angleFocused</h4></dt><dd><div class=\"description\">\nAn angle has been focused</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th>\n<th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>index</code></td><td \nclass=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">Index of the focused angle</td>\n</tr></tbody></table><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">Editor.Controller.nuitDraw2dController</a></li><li><a \nhref=\"Editor.Controller.nuitEditorController.html\">Editor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4\n class=\"name\" id=\".event:nuitEditor::clearSelection\">nuitEditor::clearSelection</h4></dt><dd><div class=\"description\">\nThe selection has been cleared</div><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">Editor.Controller.nuitDraw2dController</a></li><li><a \nhref=\"Editor.Controller.nuitEditorController.html\">Editor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4\n class=\"name\" id=\".event:nuitEditor::conicalBaseChanged\">nuitEditor::conicalBaseChanged</h4></dt><dd><div \nclass=\"description\">The conical base has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td \nclass=\"description last\">The index of the new conicalBase</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr>\n<dt><h4 class=\"name\" id=\".event:nuitEditor::editorChanged\">nuitEditor::editorChanged</h4></dt><dd><div \nclass=\"description\">The view has been changed to another editor</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>id</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a\n href=\"Editor.Controller.nuitDrawController.html\">Editor.Controller.nuitDrawController</a></li></ul></dd><hr><dt><h4 \nclass=\"name\" id=\".event:nuitEditor::editorRegistered\">nuitEditor::editorRegistered</h4></dt><dd><div \nclass=\"description\">A new editor has been registered</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>id</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::editorUnregistered\">nuitEditor::editorUnregistered</h4></dt><dd><div class=\"description\">\nAn editor has been unregistered</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name\n</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>id</code></td><td \nclass=\"type\"><span class=\"param-type\">string</span></td><td class=\"description last\"></td></tr></tbody></table><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::init\">nuitEditor::init</h4></dt><dd><div \nclass=\"description\">The editor has been initialized</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::profileCleared\">nuitEditor::profileCleared</h4></dt><dd><div class=\"description\">\nThe current profile has been deleted</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::profileLoaded\">nuitEditor::profileLoaded</h4></dt><dd><div class=\"description\">\nA new profile has been loaded</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::render\">nuitEditor::render</h4></dt><dd><div class=\"description\">\nA new rendering has been requested</div><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">Editor.Controller.nuitDraw2dController</a></li><li><a \nhref=\"Editor.Controller.nuitDrawController.html\">Editor.Controller.nuitDrawController</a></li><li><a \nhref=\"Editor.Controller.nuitDrawStampingController.html\">Editor.Controller.nuitDrawStampingController</a></li></ul>\n</dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::rendered\">nuitEditor::rendered</h4></dt><dd><div \nclass=\"description\">The editor has been rendered</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::reset\">nuitEditor::reset</h4></dt><dd><div class=\"description\">The editor has been resetted\n</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentAdded\">\nnuitEditor::segmentAdded</h4></dt><dd><div class=\"description\">A new segment has been added</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a \nhref=\"Segment.html\">Segment</a></span></td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\">\n</dl><h5>Listeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::segmentAligned\">nuitEditor::segmentAligned</h4></dt><dd><div class=\"description\">\nA segment has been aligned</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th>\n<th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>eventData</code></td><td \nclass=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>baseIndex\n</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">\nIndex of the aligned segment</td></tr></tbody></table></td></tr></tbody></table><dl class=\"details\"></dl><h5>\nListeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::segmentAngleChanged\">nuitEditor::segmentAngleChanged</h4></dt><dd><div class=\"description\">\nA segment angle has been changed</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name\n</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>eventData</code></td>\n<td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>segment\n</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td><td \nclass=\"description last\">The changed segment</td></tr><tr><td class=\"name\"><code>prevAngle</code></td><td class=\"type\">\n<span class=\"param-type\">number</span></td><td class=\"description last\">The previous angle of the segment</td></tr>\n</tbody></table></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::segmentBendingChanged\">nuitEditor::segmentBendingChanged</h4></dt><dd><div class=\"description\">\nBending direction of a segment has been changed</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\nobject}</code></td><td class=\"type\"></td><td class=\"description last\">eventData</td></tr><tr><td class=\"name\"><code>\neventData.segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td>\n<td class=\"description last\">The changed segment</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\".event:nuitEditor::segmentCloseChanged\">nuitEditor::segmentCloseChanged</h4></dt><dd><div \nclass=\"description\">Close setting of a segment has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\">The changed segment</td></tr></tbody></table><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentConicalChanged\">nuitEditor::segmentConicalChanged</h4>\n</dt><dd><div class=\"description\">Conical setting of a segment has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\">The changed segment</td></tr></tbody></table><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentFocused\">nuitEditor::segmentFocused</h4></dt><dd><div \nclass=\"description\">A segment has been focused</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\ndata</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\">Event data<h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>index</code>\n</td><td class=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">\nIndex of the focused segment</td></tr><tr><td class=\"name\"><code>payload</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"description last\">Individual payload of the event caller<h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>direction\n</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td class=\"description last\">\nWether the front length or the back length has been focused</td></tr></tbody></table></td></tr></tbody></table></td>\n</tr></tbody></table><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">Editor.Controller.nuitDraw2dController</a></li><li><a \nhref=\"Editor.Controller.nuitEditorController.html\">Editor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4\n class=\"name\" id=\".event:nuitEditor::segmentLengthChanged\">nuitEditor::segmentLengthChanged</h4></dt><dd><div \nclass=\"description\">Segment length has been changed</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\neventData</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>segment\n</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td><td \nclass=\"description last\">The changed segment</td></tr><tr><td class=\"name\"><code>prevLength</code></td><td \nclass=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">Previous front length</td></tr>\n<tr><td class=\"name\"><code>prevBackLength</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td \nclass=\"description last\">Previous back length</td></tr></tbody></table></td></tr></tbody></table><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentMeasureChanged\">nuitEditor::segmentMeasureChanged</h4>\n</dt><dd><div class=\"description\">Measure direction of a segment has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>eventData</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><h6 class=\"method-params-label method-subparams-label\">Properties</h6><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\">The changed segment</td></tr></tbody></table></td></tr></tbody>\n</table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentRemoved\">\nnuitEditor::segmentRemoved</h4></dt><dd><div class=\"description\">A segment has been removed</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>removed</code></td><td class=\"type\"><span class=\"param-type\"><a \nhref=\"Segment.html\">Segment</a></span></td><td class=\"description last\">segment</td></tr></tbody></table><dl \nclass=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd></dl></article></section></div></div><div class=\"clearfix\">\n</div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div \nclass=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span>\n</button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Services.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Namespace: Services</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Namespace: Services</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">Editor\n</a>.</span> Services</h2></header><article><div class=\"container-overview\"><div class=\"description\">Services of editor\n</div><dl class=\"details\"></dl></div><h3 class=\"subsection-title\">Classes</h3><dl><dt><a \nhref=\"Editor.Services.nuitEditorFactory.html\">nuitEditorFactory</a></dt><dd></dd><dt><a \nhref=\"Editor.Services.nuitProfileFactory.html\">nuitProfileFactory</a></dt><dd></dd></dl></article></section></div>\n</div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\">\n</div></div></div></div><div class=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div \nclass=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" \naria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Search results</h4></div>\n<div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" \ndata-dismiss=\"modal\">Close</button></div></div></div></div><footer><span class=\"jsdoc-message\">\nDocumentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Services.nuitEditorFactory.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitEditorFactory</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitEditorFactory</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">\nEditor</a><a href=\"Editor.Services.html\">.Services</a>.</span> nuitEditorFactory</h2><div class=\"class-description\">\nService to control the nuitEditor</div></header><article><div class=\"container-overview\"><hr><dt><h4 class=\"name\" \nid=\"nuitEditorFactory\"><span class=\"type-signature\"></span>\nnew nuitEditorFactory($rootScope, $timeout, nuitEditorEvents, nuitProfile)</h4></dt><dd><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>$rootScope</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td\n class=\"description last\"><a href=\"https://docs.angularjs.org/api/ng/service/$rootScope\">\nhttps://docs.angularjs.org/api/ng/service/$rootScope</a></td></tr><tr><td class=\"name\"><code>$timeout</code></td><td \nclass=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"https://docs.angularjs.org/api/ng/services/$timeout\">https://docs.angularjs.org/api/ng/services/$timeout</a></td>\n</tr><tr><td class=\"name\"><code>nuitEditorEvents</code></td><td class=\"type\"><span class=\"param-type\">object</span>\n</td><td class=\"description last\"><a href=\"Editor.Constants.html#.nuitEditorEvents\">Editor.Constants.nuitEditorEvents\n</a></td></tr><tr><td class=\"name\"><code>nuitProfile</code></td><td class=\"type\"><span class=\"param-type\">object</span>\n</td><td class=\"description last\"><a href=\"Editor.Services.nuitProfileFactory.html\">Editor.Services.nuitProfileFactory\n</a></td></tr></tbody></table><dl class=\"details\"></dl></dd></div><h3 class=\"subsection-title\">Members</h3><dl><hr><dt \nclass=\"name\" id=\".currentEditor\"><h4 id=\".currentEditor\"><span class=\"type-signature\">&lt;static> </span>currentEditor\n<span class=\"type-signature\"> :string|object</span></h4></dt><dd><div class=\"description\">\nReturns the current editor object. Can be set with the id of another editor to change the current editor</div><h5>Type:\n</h5><ul><li><span class=\"param-type\">string</span> | <span class=\"param-type\">object</span></li></ul><dl \nclass=\"details\"></dl></dd><hr><dt class=\"name\" id=\".defaultEditor\"><h4 id=\".defaultEditor\"><span \nclass=\"type-signature\">&lt;static> </span>defaultEditor<span class=\"type-signature\"> :string</span></h4></dt><dd><div \nclass=\"description\">Reads or sets the default editor. Must not be null</div><h5>Type:</h5><ul><li><span \nclass=\"param-type\">string</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\".manager\"><h4 \nid=\".manager\"><span class=\"type-signature\">&lt;static, readonly> </span>manager<span class=\"type-signature\"> :object\n</span></h4></dt><dd><div class=\"description\">Contains the managerobject of the currently selected editor</div><h5>\nType:</h5><ul><li><span class=\"param-type\">object</span></li></ul><dl class=\"details\"></dl></dd></dl><h3 \nclass=\"subsection-title\">Methods</h3><dl><hr><dt><h4 class=\"name\" id=\"~clearProfile\"><span class=\"type-signature\">\n&lt;inner> </span>clearProfile()</h4></dt><dd><div class=\"description\">Resets the current profile</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~exportProfile\"><span class=\"type-signature\">&lt;inner> </span>\nexportProfile()</h4></dt><dd><div class=\"description\">\nRetrieves all necessary data from the segments service and fetches them into a profile object</div><dl class=\"details\">\n</dl><h5>Returns:</h5><div class=\"param-desc\">The requested profile</div><dl><dt>Type</dt><dd><span class=\"param-type\">\nobject</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~generateLegacyProfile\"><span class=\"type-signature\">\n&lt;inner> </span>generateLegacyProfile()</h4></dt><dd><div class=\"description\">\nGenerates a new legacy profile for compatibility reasons.</div><dl class=\"details\"><dt \nclass=\"important tag-deprecated method-doc-label method-doc-details-label\">Deprecated:</dt><dd \nclass=\"yes-def tag-deprecated\"><ul class=\"dummy\"><li>Yes</li></ul></dd></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span\n class=\"param-type\">Profile</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getCurrentEditorId\"><span \nclass=\"type-signature\">&lt;inner> </span>getCurrentEditorId()</h4></dt><dd><div class=\"description\">\nReturns the id of the current id</div><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">editor id</div>\n<dl><dt>Type</dt><dd><span class=\"param-type\">string</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getEditor\">\n<span class=\"type-signature\">&lt;inner> </span>getEditor(id)</h4></dt><dd><div class=\"description\">\nGets the editor with given id</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name\n</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>id</code></td><td \nclass=\"type\"><span class=\"param-type\">string</span></td><td class=\"description last\">Id if the editor you want to get\n</td></tr></tbody></table><dl class=\"details\"></dl><h5>Throws:</h5><div class=\"param-desc\">\nThrows an error if no editor with the given id exists</div><h5>Returns:</h5><div class=\"param-desc\">\neditor or false if no active editor was found</div><dl><dt>Type</dt><dd><span class=\"param-type\">object</span> | <span \nclass=\"param-type\">false</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getManager\"><span class=\"type-signature\">\n&lt;inner> </span>getManager(id)</h4></dt><dd><div class=\"description\">Returns the manager of an editor</div><h5>\nParameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th>Argument</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>id</code></td><td class=\"type\"><span \nclass=\"param-type\">string</span></td><td class=\"attributes\">&lt;nullable><br></td><td class=\"description last\">\nid of the editor whose manager you want. If null, the manager of the current editor will be returned</td></tr></tbody>\n</table><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">Manager</div><dl><dt>Type</dt><dd><span \nclass=\"param-type\">object</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~hasEditor\"><span class=\"type-signature\">\n&lt;inner> </span>hasEditor(id)</h4></dt><dd><div class=\"description\">\nA function to check if a specific editor is registered or not</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>id</code></td><td class=\"type\"></td><td class=\"description last\">\nThe id of your desired editor</td></tr></tbody></table><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd>\n<span class=\"param-type\">boolean</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~importProfile\"><span \nclass=\"type-signature\">&lt;inner> </span>importProfile(data)</h4></dt><dd><div class=\"description\">\nLoads a profile and injects it to the segments service</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>data</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\">Profile which should by loaded</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt>\n<h4 class=\"name\" id=\"~init\"><span class=\"type-signature\">&lt;inner> </span>init(config)</h4></dt><dd><div \nclass=\"description\">Initializes a new editor environment and triggers INIT event</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>config</code></td><td class=\"type\"><span class=\"param-type\">Object</span></td><td \nclass=\"description last\">Configuration</td></tr></tbody></table><dl class=\"details\"></dl><h5>Fires:</h5><ul><li>\nnuitEditor::init</li></ul></dd><hr><dt><h4 class=\"name\" id=\"~listEditors\"><span class=\"type-signature\">&lt;inner> \n</span>listEditors()</h4></dt><dd><div class=\"description\">Returns an array with all currently registered editor IDs\n</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Array.&lt;string></span>\n</dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~registerEditor\"><span class=\"type-signature\">&lt;inner> </span>\nregisterEditor(id, manager, scene)</h4></dt><dd><div class=\"description\">Registers a new editor</div><h5>Parameters:\n</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th>\n</tr></thead><tbody><tr><td class=\"name\"><code>id</code></td><td class=\"type\"><span class=\"param-type\">string</span>\n</td><td class=\"description last\">id</td></tr><tr><td class=\"name\"><code>manager</code></td><td class=\"type\"><span \nclass=\"param-type\"><a href=\"Manager.html\">Manager</a></span></td><td class=\"description last\">manager</td></tr><tr><td \nclass=\"name\"><code>scene</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\">scene</td></tr></tbody></table><dl class=\"details\"></dl><h5>Fires:</h5><ul><li>\nnuitEditor::editorRegistered</li></ul><h5>Throws:</h5><div class=\"param-desc\">\nThrows an error if there is already an editor with the given id registered</div></dd><hr><dt><h4 class=\"name\" \nid=\"~render\"><span class=\"type-signature\">&lt;inner> </span>render()</h4></dt><dd><div class=\"description\">\nDemands a new render cycle</div><dl class=\"details\"></dl><h5>Fires:</h5><ul><li>nuitEditor::render</li></ul></dd><hr>\n<dt><h4 class=\"name\" id=\"~reset\"><span class=\"type-signature\">&lt;inner> </span>reset()</h4></dt><dd><div \nclass=\"description\">Resets the config</div><dl class=\"details\"></dl><h5>Fires:</h5><ul><li>nuitEditor::reset</li></ul>\n</dd><hr><dt><h4 class=\"name\" id=\"~unregisterEditor\"><span class=\"type-signature\">&lt;inner> </span>\nunregisterEditor(id)</h4></dt><dd><div class=\"description\">Unregisters an editor with the given id</div><h5>Parameters:\n</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th>\n</tr></thead><tbody><tr><td class=\"name\"><code>id</code></td><td class=\"type\"><span class=\"param-type\">string</span>\n</td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl><h5>Fires:</h5><ul><li>\nnuitEditor::editorUnregistered</li></ul><h5>Throws:</h5><div class=\"param-desc\">\nThrows an error if no editor with given id exists</div></dd><hr><dt><h4 class=\"name\" id=\"~useEditor\"><span \nclass=\"type-signature\">&lt;inner> </span>useEditor(id)</h4></dt><dd><div class=\"description\">\nMakes the editor use the editor with given id</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>id\n</code></td><td class=\"type\"><span class=\"param-type\">String</span></td><td class=\"description last\">\nunique identifier of the editor</td></tr></tbody></table><dl class=\"details\"></dl><h5>Fires:</h5><ul><li>\nnuitEditor::editorChanged</li></ul><h5>Throws:</h5><div class=\"param-desc\">\nThrows an error if no editor with given id exists</div></dd></dl></article></section></div></div><div class=\"clearfix\">\n</div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div \nclass=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span>\n</button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.Services.nuitProfileFactory.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: nuitProfileFactory</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: nuitProfileFactory</h1><section><header><h2><span class=\"ancestors\"><a href=\"Editor.html\">\nEditor</a><a href=\"Editor.Services.html\">.Services</a>.</span> nuitProfileFactory</h2><div class=\"class-description\">\nManages all calculations of one or more segments</div></header><article><div class=\"container-overview\"><hr><dt><h4 \nclass=\"name\" id=\"nuitProfileFactory\"><span class=\"type-signature\"></span>\nnew nuitProfileFactory($rootScope, nuitEditorEvents)</h4></dt><dd><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>$rootScope</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td\n class=\"description last\"><a href=\"https://docs.angularjs.org/api/ng/service/$rootScope\">\nhttps://docs.angularjs.org/api/ng/service/$rootScope</a></td></tr><tr><td class=\"name\"><code>nuitEditorEvents</code>\n</td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><a \nhref=\"Editor.Constants.html#.nuitEditorEvents\">Editor.Constants.nuitEditorEvents</a></td></tr></tbody></table><dl \nclass=\"details\"></dl></dd></div><h3 class=\"subsection-title\">Members</h3><dl><hr><dt class=\"name\" id=\"~_history\"><h4 \nid=\"~_history\"><span class=\"type-signature\">&lt;inner, constant> </span>_history<span class=\"type-signature\"> :Array\n</span></h4></dt><dd><div class=\"description\">Contains the history</div><h5>Type:</h5><ul><li><span class=\"param-type\">\nArray</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~_holes\"><h4 id=\"~_holes\"><span \nclass=\"type-signature\">&lt;inner, constant> </span>_holes<span class=\"type-signature\"> :Array</span></h4></dt><dd><div \nclass=\"description\">Contains all stamping holes.</div><h5>Type:</h5><ul><li><span class=\"param-type\">Array</span></li>\n</ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~_intersections\"><h4 id=\"~_intersections\"><span \nclass=\"type-signature\">&lt;inner, constant> </span>_intersections<span class=\"type-signature\"> :Array</span></h4></dt>\n<dd><div class=\"description\">Contains all intersection points.</div><h5>Type:</h5><ul><li><span class=\"param-type\">\nArray</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~_segments\"><h4 id=\"~_segments\"><span \nclass=\"type-signature\">&lt;inner, constant> </span>_segments<span class=\"type-signature\"> :Array</span></h4></dt><dd>\n<div class=\"description\">Contains all active and visible segments.</div><h5>Type:</h5><ul><li><span class=\"param-type\">\nArray</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~bounds\"><h4 id=\"~bounds\"><span \nclass=\"type-signature\">&lt;inner, constant> </span>bounds<span class=\"type-signature\"> :<a href=\"Bounds.html\">Bounds\n</a></span></h4></dt><dd><div class=\"description\">Contains the bounds for this profile.</div><h5>Type:</h5><ul><li>\n<span class=\"param-type\"><a href=\"Bounds.html\">Bounds</a></span></li></ul><dl class=\"details\"></dl></dd><hr><dt \nclass=\"name\" id=\"~config\"><h4 id=\"~config\"><span class=\"type-signature\">&lt;inner> </span>config<span \nclass=\"type-signature\"> :object</span></h4></dt><dd><div class=\"description\">Contains current config</div><h5>Type:\n</h5><ul><li><span class=\"param-type\">object</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" \nid=\"~conicalBase\"><h4 id=\"~conicalBase\"><span class=\"type-signature\">&lt;inner> </span>conicalBase<span \nclass=\"type-signature\"> :Number</span></h4></dt><dd><div class=\"description\">\nContains the index of the center aligned segment when using conical segments</div><h5>Type:</h5><ul><li><span \nclass=\"param-type\">Number</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~DEFAULT_CONFIG\"><h4 \nid=\"~DEFAULT_CONFIG\"><span class=\"type-signature\">&lt;inner, constant> </span>DEFAULT_CONFIG<span \nclass=\"type-signature\"> :object</span></h4></dt><dd><div class=\"description\">\nContains default configuration for the nuitProfileFactory</div><h5>Type:</h5><ul><li><span class=\"param-type\">object\n</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~depth\"><h4 id=\"~depth\"><span \nclass=\"type-signature\">&lt;inner> </span>depth<span class=\"type-signature\"> :Number</span></h4></dt><dd><div \nclass=\"description\">Contains the depth of the profile.</div><h5>Type:</h5><ul><li><span class=\"param-type\">Number\n</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~firstOffset\"><h4 id=\"~firstOffset\"><span \nclass=\"type-signature\">&lt;inner> </span>firstOffset<span class=\"type-signature\"> :Object</span></h4></dt><dd><div \nclass=\"description\">Contains the left and right offset of the conical editor.</div><h5>Type:</h5><ul><li><span \nclass=\"param-type\">Object</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~historyPointer\"><h4 \nid=\"~historyPointer\"><span class=\"type-signature\">&lt;inner> </span>historyPointer<span class=\"type-signature\"> :number\n</span></h4></dt><dd><div class=\"description\">\nPoints at the current history state. This is necessary for the historyForward feature</div><h5>Type:</h5><ul><li><span \nclass=\"param-type\">number</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~ignoreHistory\"><h4 \nid=\"~ignoreHistory\"><span class=\"type-signature\">&lt;inner> </span>ignoreHistory<span class=\"type-signature\"> :boolean\n</span></h4></dt><dd><div class=\"description\">When true, any changes will not be saved in the history</div><h5>Type:\n</h5><ul><li><span class=\"param-type\">boolean</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" \nid=\"~limits\"><h4 id=\"~limits\"><span class=\"type-signature\">&lt;inner> </span>limits<span class=\"type-signature\">\n :object</span></h4></dt><dd><div class=\"description\">Contains the limit settings of the current config</div><h5>Type:\n</h5><ul><li><span class=\"param-type\">object</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" \nid=\"~material\"><h4 id=\"~material\"><span class=\"type-signature\">&lt;inner> </span>material<span class=\"type-signature\">\n :object</span></h4></dt><dd><div class=\"description\">Contains the currently selected material.</div><h5>Type:</h5><ul>\n<li><span class=\"param-type\">object</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" id=\"~MEASURE\">\n<h4 id=\"~MEASURE\"><span class=\"type-signature\">&lt;inner, constant> </span>MEASURE<span class=\"type-signature\"> :object\n</span></h4></dt><dd><div class=\"description\">Enum that differentiates between outside and inside of a segment.</div>\n<h5>Type:</h5><ul><li><span class=\"param-type\">object</span></li></ul><dl class=\"details\"><h5 class=\"subsection-title\">\nProperties:</h5><dl><table class=\"props table table-striped\"><thead><tr><th>Name</th><th>Type</th><th>Default</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>Outer</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"default\">-1</td><td class=\"description last\"></td></tr><tr><td \nclass=\"name\"><code>Inner</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"default\">1\n</td><td class=\"description last\"></td></tr></tbody></table></dl></dl></dd><hr><dt class=\"name\" id=\"~totalLength\"><h4 \nid=\"~totalLength\"><span class=\"type-signature\">&lt;inner> </span>totalLength<span class=\"type-signature\"> :Number\n</span></h4></dt><dd><div class=\"description\">Contains the total length of the segment chain.</div><h5>Type:</h5><ul>\n<li><span class=\"param-type\">Number</span></li></ul><dl class=\"details\"></dl></dd><hr><dt class=\"name\" \nid=\"~visibleSide\"><h4 id=\"~visibleSide\"><span class=\"type-signature\">&lt;inner> </span>visibleSide<span \nclass=\"type-signature\"> :Boolean</span></h4></dt><dd><div class=\"description\">\nContains the visibile side of the segments.</div><h5>Type:</h5><ul><li><span class=\"param-type\">Boolean</span></li>\n</ul><dl class=\"details\"></dl></dd></dl><h3 class=\"subsection-title\">Methods</h3><dl><hr><dt><h4 class=\"name\" \nid=\"~add\"><span class=\"type-signature\">&lt;inner> </span>add(length, angle, index, bendingDir)</h4></dt><dd><div \nclass=\"description\">\nAdds a new segment to the collection and returns it afterwards. Returns null if no valid segment could be created.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>length</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">the length of the segment in mm</td></tr><tr><td \nclass=\"name\"><code>angle</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">the relative bending angle of the segment in radiant (automatically clamped between [0..PI*2]\n</td></tr><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">the index of the new segment</td></tr><tr><td class=\"name\"><code>bendingDir</code></td><td \nclass=\"type\"><span class=\"param-type\">Number</span></td><td class=\"description last\">\nthe bending dir of the segment (only needed for 0 and PI angle)</td></tr></tbody></table><dl class=\"details\"></dl><h5>\nFires:</h5><ul><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded\n</a></li></ul><h5>Returns:</h5><div class=\"param-desc\">Object</div></dd><hr><dt><h4 class=\"name\" id=\"~addAngle\"><span \nclass=\"type-signature\">&lt;inner> </span>addAngle(index, value)</h4></dt><dd><div class=\"description\">\nAdds the given value to the angle of the segment at the specified index.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">index of segment</td></tr><tr><td class=\"name\"><code>value</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">value to add</td></tr></tbody></table><dl \nclass=\"details\"></dl><h5>Fires:</h5><ul><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">\nEditor.Events.nuitEditor::segmentAngleChanged</a></li></ul></dd><hr><dt><h4 class=\"name\" id=\"~addHistory\"><span \nclass=\"type-signature\">&lt;inner> </span>addHistory({HISTORY, data)</h4></dt><dd><div class=\"description\">\nAdds a new state to the history</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name\n</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>{HISTORY</code></td>\n<td class=\"type\"></td><td class=\"description last\">type</td></tr><tr><td class=\"name\"><code>data</code></td><td \nclass=\"type\"><span class=\"param-type\">any</span></td><td class=\"description last\"></td></tr></tbody></table><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~addHole\"><span class=\"type-signature\">&lt;inner> </span>\naddHole(x, y, tool)</h4></dt><dd><div class=\"description\">Creates a new hole on given position</div><h5>Parameters:\n</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th>\n</tr></thead><tbody><tr><td class=\"name\"><code>x</code></td><td class=\"type\"><span class=\"param-type\">number</span>\n</td><td class=\"description last\"></td></tr><tr><td class=\"name\"><code>y</code></td><td class=\"type\"><span \nclass=\"param-type\">number</span></td><td class=\"description last\"></td></tr><tr><td class=\"name\"><code>tool</code></td>\n<td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"></td></tr></tbody></table><dl \nclass=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">the generated hole</div><dl><dt>Type</dt><dd><span \nclass=\"param-type\">object</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~addHoles\"><span class=\"type-signature\">\n&lt;inner> </span>addHoles(holes)</h4></dt><dd><div class=\"description\">Adds the given holes to the holes collection.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>holes</code></td><td class=\"type\"><span \nclass=\"param-type\">Array</span></td><td class=\"description last\">array containing all the stamping holes</td></tr>\n</tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~addWrap\"><span class=\"type-signature\">\n&lt;inner> </span>addWrap(end, length)</h4></dt><dd><div class=\"description\">Adds a wrap to one of the profiles ends.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>end</code></td><td class=\"type\"><span \nclass=\"param-type\">Boolean</span></td><td class=\"description last\">true if the wrap should be add the end</td></tr><tr>\n<td class=\"name\"><code>length</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">the length of the wrap</td></tr></tbody></table><dl class=\"details\"><dt \nclass=\"tag-see method-doc-label method-doc-details-label\">See:</dt><dd class=\"tag-see\"><ul><li>\nEditor.Services.nuitProfileFactory#add</li></ul></dd></dl><h5>Returns:</h5><div class=\"param-desc\">\nthe new wrapped segment</div><dl><dt>Type</dt><dd><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span>\n</dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~align\"><span class=\"type-signature\">&lt;inner> </span>align(index)</h4>\n</dt><dd><div class=\"description\">\nAligns the full profile clockwise so that the segment at the given index is positioned horizontally.</div><h5>\nParameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">index of segment</td></tr></tbody></table><dl \nclass=\"details\"></dl><h5>Fires:</h5><ul><li>nuitEditor::segmentAligned</li></ul></dd><hr><dt><h4 class=\"name\" \nid=\"~calculateBendingOffset\"><span class=\"type-signature\">&lt;inner> </span>\ncalculateBendingOffset(segment, bendingRadius)</h4></dt><dd><div class=\"description\">\nCalculates the bending offset of the given segment.</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\nsegment</code></td><td class=\"type\"><span class=\"param-type\">type</span></td><td class=\"description last\"></td></tr>\n<tr><td class=\"name\"><code>bendingRadius</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~calculateEnd\"><span class=\"type-signature\">&lt;inner> </span>calculateEnd(segment, thicknessOffset)</h4></dt><dd>\n<div class=\"description\">Calculates the endpoint of the given segment.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\"></td></tr><tr><td class=\"name\"><code>thicknessOffset</code></td><td\n class=\"type\"><span class=\"param-type\">Number</span></td><td class=\"description last\"></td></tr></tbody></table><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~calculateLengthOffset\"><span class=\"type-signature\">&lt;inner> \n</span>calculateLengthOffset(segment, bendingRadius)</h4></dt><dd><div class=\"description\">\nCalculates the length offset of the given segment based on the bending radius caused by the material.</div><h5>\nParameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span \nclass=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td><td class=\"description last\"></td></tr><tr><td \nclass=\"name\"><code>bendingRadius</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~calculateStart\"><span class=\"type-signature\">&lt;inner> </span>calculateStart(segment)</h4></dt><dd><div \nclass=\"description\">Calculates the starting point of the given segment.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4\n class=\"name\" id=\"~checkIntersections\"><span class=\"type-signature\">&lt;inner> </span>checkIntersections()</h4></dt>\n<dd><div class=\"description\">\nPerforms an intersection check through the whole segment chain and recalculates the bounds and the total length.</div>\n<dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~clamp\"><span class=\"type-signature\">&lt;inner> </span>\nclamp(value, min, max)</h4></dt><dd><div class=\"description\">\nClamps the provided value between the given minimum and maximum.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>value</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">value to clamp</td></tr><tr><td class=\"name\"><code>min</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">min value</td></tr><tr><td class=\"name\"><code>max\n</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td class=\"description last\">max value</td>\n</tr></tbody></table><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">\nmin, if value is smaller than min or max, if value is greater than max or otherwise the value itself</div></dd><hr><dt>\n<h4 class=\"name\" id=\"~clear\"><span class=\"type-signature\">&lt;inner> </span>clear(keepMaterial, skipHistory)</h4></dt>\n<dd><div class=\"description\">Removes and deletes all segment data.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>keepMaterial</code></td><td class=\"type\"><span class=\"param-type\">Boolean</span></td>\n<td class=\"description last\"></td></tr><tr><td class=\"name\"><code>skipHistory</code></td><td class=\"type\"><span \nclass=\"param-type\">Boolean</span></td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl>\n</dd><hr><dt><h4 class=\"name\" id=\"~connect\"><span class=\"type-signature\">&lt;inner> </span>connect(first, second)</h4>\n</dt><dd><div class=\"description\">Connects the two given segments.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>first</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\">previous segment</td></tr><tr><td class=\"name\"><code>second</code>\n</td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td><td \nclass=\"description last\">next segment</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~count\"><span class=\"type-signature\">&lt;inner> </span>count()</h4></dt><dd><div class=\"description\">\nReturns the total amount of segments in the current profile.</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>\nType</dt><dd><span class=\"param-type\">Number</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~exportSegments\"><span \nclass=\"type-signature\">&lt;inner> </span>exportSegments()</h4></dt><dd><div class=\"description\">\nGenerates exportable segment data.</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span \nclass=\"param-type\">Array</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~first\"><span class=\"type-signature\">\n&lt;inner> </span>first()</h4></dt><dd><div class=\"description\">Returns the very first segment.</div><dl \nclass=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">segment at index 0 or null if no first segment exists\n</div><dl><dt>Type</dt><dd><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></dd></dl></dd><hr><dt><h4\n class=\"name\" id=\"~forceRefresh\"><span class=\"type-signature\">&lt;inner> </span>forceRefresh()</h4></dt><dd><div \nclass=\"description\">Forces a full refresh.</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~generateHoles\"><span class=\"type-signature\">&lt;inner> </span>generateHoles(generators)</h4></dt><dd><div \nclass=\"description\">Creates a line of holes</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead>\n<tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\ngenerators</code></td><td class=\"type\"><span class=\"param-type\">array</span></td><td class=\"description last\"></td>\n</tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~get\"><span class=\"type-signature\">\n&lt;inner> </span>get(index)</h4></dt><dd><div class=\"description\">\nReturns the segment at the given position in the segment chain.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">index of the requested segment</td></tr></tbody></table><dl class=\"details\"></dl><h5>Returns:\n</h5><div class=\"param-desc\">segment at index or null if index is invalid</div><dl><dt>Type</dt><dd><span \nclass=\"param-type\"><a href=\"Segment.html\">Segment</a></span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getAll\"><span \nclass=\"type-signature\">&lt;inner> </span>getAll()</h4></dt><dd><div class=\"description\">\nReturns the collection which contains all segments. READ-ONLY!</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>\nType</dt><dd><span class=\"param-type\">Array.Segment</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getAngle\"><span \nclass=\"type-signature\">&lt;inner> </span>getAngle(index)</h4></dt><dd><div class=\"description\">\nReturns the angle of the segment at the given index or 0 if the index is invalid.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span\n class=\"param-type\">Number</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getBounds\"><span class=\"type-signature\">\n&lt;inner> </span>getBounds()</h4></dt><dd><div class=\"description\">Returns the bounds of this profile.</div><dl \nclass=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\"><a href=\"Bounds.html\">Bounds</a>\n</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getConicalBase\"><span class=\"type-signature\">&lt;inner> </span>\ngetConicalBase()</h4></dt><dd><div class=\"description\">Returns the conical base. (???)</div><dl class=\"details\"></dl>\n<h5>Returns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Number</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~getDepth\"><span class=\"type-signature\">&lt;inner> </span>getDepth()</h4></dt><dd><div class=\"description\">\nReturns the depth of the segments.</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span \nclass=\"param-type\">Number</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getFirstOffset\"><span \nclass=\"type-signature\">&lt;inner> </span>getFirstOffset()</h4></dt><dd><div class=\"description\">\nReturns the first offset in mm for the left and right side of the conical editing.</div><dl class=\"details\"></dl><h5>\nReturns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Object</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~getFirstOffsetLeft\"><span class=\"type-signature\">&lt;inner> </span>getFirstOffsetLeft()</h4></dt><dd><div \nclass=\"description\">Returns the first offset in mm for the left side of the conical editing.</div><dl class=\"details\">\n</dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Number</span> | <span class=\"param-type\">\nfirstOffset.left</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getFirstOffsetRight\"><span class=\"type-signature\">\n&lt;inner> </span>getFirstOffsetRight()</h4></dt><dd><div class=\"description\">\nReturns the first offset in mm for the right side of the conical editing.</div><dl class=\"details\"></dl><h5>Returns:\n</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Number</span> | <span class=\"param-type\">firstOffset.right</span>\n</dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getHoles\"><span class=\"type-signature\">&lt;inner> </span>getHoles()</h4>\n</dt><dd><div class=\"description\">Returns all stamping holes.</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>\nType</dt><dd><span class=\"param-type\">Array</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getIntersections\"><span \nclass=\"type-signature\">&lt;inner> </span>getIntersections()</h4></dt><dd><div class=\"description\">\nReturns all intersection points.</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span \nclass=\"param-type\">Array</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getMaterial\"><span class=\"type-signature\">\n&lt;inner> </span>getMaterial()</h4></dt><dd><div class=\"description\">Returns the currently assigned material.</div><dl\n class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Material</span></dd></dl></dd><hr>\n<dt><h4 class=\"name\" id=\"~getThickness\"><span class=\"type-signature\">&lt;inner> </span>getThickness()</h4></dt><dd><div\n class=\"description\">Returns the thickness of the currently assigned material.</div><dl class=\"details\"></dl><h5>\nReturns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Number</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~getTotalLength\"><span class=\"type-signature\">&lt;inner> </span>getTotalLength()</h4></dt><dd><div \nclass=\"description\">Returns the total length of the profile.</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>\nType</dt><dd><span class=\"param-type\">Number</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~getVisibleSide\"><span \nclass=\"type-signature\">&lt;inner> </span>getVisibleSide()</h4></dt><dd><div class=\"description\">\nReturns the visible side of the segment chain.</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd>\n<span class=\"param-type\">Boolean</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~hasIntersections\"><span \nclass=\"type-signature\">&lt;inner> </span>hasIntersections()</h4></dt><dd><div class=\"description\">\nReturns true if the segments intersect somewhere.</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd>\n<span class=\"param-type\">Boolean</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~historyBack\"><span \nclass=\"type-signature\">&lt;inner> </span>historyBack()</h4></dt><dd><div class=\"description\">A step back in the history\n</div><dl class=\"details\"></dl><h5>Fires:</h5><ul><li><a href=\"Editor.Events.html#.event:nuitEditor::render\">\nEditor.Events.nuitEditor::render</a></li></ul></dd><hr><dt><h4 class=\"name\" id=\"~historyBackAvailable\"><span \nclass=\"type-signature\">&lt;inner> </span>historyBackAvailable()</h4></dt><dd><div class=\"description\">\nChecks if history-back action is possible</div><dl class=\"details\"></dl><h5>Returns:</h5><dl><dt>Type</dt><dd><span \nclass=\"param-type\">boolean</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~historyForward\"><span \nclass=\"type-signature\">&lt;inner> </span>historyForward()</h4></dt><dd><div class=\"description\">\nA step forward in the history</div><dl class=\"details\"></dl><h5>Fires:</h5><ul><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li></ul></dd><hr><dt><h4 \nclass=\"name\" id=\"~historyForwardAvailable\"><span class=\"type-signature\">&lt;inner> </span>historyForwardAvailable()\n</h4></dt><dd><div class=\"description\">Checks if history-forward action is possible</div><dl class=\"details\"></dl><h5>\nReturns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">boolean</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~importSegments\"><span class=\"type-signature\">&lt;inner> </span>importSegments(segArr)</h4></dt><dd><div \nclass=\"description\">Imports all segments from the given array.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segArr</code></td><td class=\"type\"><span class=\"param-type\">Array</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl><h5>Fires:</h5><ul><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li></ul></dd>\n<hr><dt><h4 class=\"name\" id=\"~intersection\"><span class=\"type-signature\">&lt;inner> </span>intersection()</h4></dt><dd>\n<div class=\"description\">Returns a point if the two given line segments cross each other or false if not.</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~intersectsAny\"><span class=\"type-signature\">&lt;inner> </span>\nintersectsAny(x1, y1, x2, y2)</h4></dt><dd><div class=\"description\">\nReturns true if the given line intersects with any segment.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>x1</code></td><td class=\"type\"><span class=\"param-type\">type</span></td><td \nclass=\"description last\"></td></tr><tr><td class=\"name\"><code>y1</code></td><td class=\"type\"><span class=\"param-type\">\ntype</span></td><td class=\"description last\"></td></tr><tr><td class=\"name\"><code>x2</code></td><td class=\"type\"><span \nclass=\"param-type\">type</span></td><td class=\"description last\"></td></tr><tr><td class=\"name\"><code>y2</code></td><td \nclass=\"type\"><span class=\"param-type\">type</span></td><td class=\"description last\"></td></tr></tbody></table><dl \nclass=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">\nNull, if intersection was unsuccessful, collision point other wise</div><dl><dt>Type</dt><dd><span class=\"param-type\">\nObject</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~isConical\"><span class=\"type-signature\">&lt;inner> </span>\nisConical(index)</h4></dt><dd><div class=\"description\">Returns true if the segment at the given index is conical.</div>\n<h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">index of requested segment</td></tr></tbody></table>\n<dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">\ntrue if segment at given index is conical, false otherwise</div><dl><dt>Type</dt><dd><span class=\"param-type\">Boolean\n</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~isEmpty\"><span class=\"type-signature\">&lt;inner> </span>isEmpty()\n</h4></dt><dd><div class=\"description\">Returns true if the segments collection is empty.</div><dl class=\"details\"></dl>\n<h5>Returns:</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Boolean</span></dd></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~isIndexValid\"><span class=\"type-signature\">&lt;inner> </span>isIndexValid(index)</h4></dt><dd><div \nclass=\"description\">Returns true if the given index is valid and within the array length.</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td>\n<td class=\"description last\">index to test</td></tr></tbody></table><dl class=\"details\"></dl><h5>Returns:</h5><div \nclass=\"param-desc\">true if index is valid, false otherwise</div><dl><dt>Type</dt><dd><span class=\"param-type\">Boolean\n</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~isWrap\"><span class=\"type-signature\">&lt;inner> </span>\nisWrap(index)</h4></dt><dd><div class=\"description\">\nReturns true if the segment at the given index is a wrapped segment.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">index of requested segment</td></tr></tbody></table><dl class=\"details\"></dl><h5>Returns:</h5>\n<div class=\"param-desc\">true if segment at given index is a wrapped one, false otherwise</div><dl><dt>Type</dt><dd>\n<span class=\"param-type\">Boolean</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~last\"><span class=\"type-signature\">\n&lt;inner> </span>last()</h4></dt><dd><div class=\"description\">Returns the very last segment of the segment chain.\n</div><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">last segment or null if no segment is present\n</div><dl><dt>Type</dt><dd><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></dd></dl></dd><hr><dt><h4\n class=\"name\" id=\"~loop\"><span class=\"type-signature\">&lt;inner> </span>loop(value, limit)</h4></dt><dd><div \nclass=\"description\">Loops the given value so it is never lower than 0 or bigger than \'limit\'.</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>value</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td>\n<td class=\"description last\">the value to loop</td></tr><tr><td class=\"name\"><code>limit</code></td><td class=\"type\">\n<span class=\"param-type\">Number</span></td><td class=\"description last\">the limit</td></tr></tbody></table><dl \nclass=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">looped value between [0..limit]</div><dl><dt>Type</dt>\n<dd><span class=\"param-type\">Number</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~refresh\"><span \nclass=\"type-signature\">&lt;inner> </span>refresh(currentIndex)</h4></dt><dd><div class=\"description\">\nRefreshes the segment at the given index and all segments that come afterwards by updating their start- and ending position, their index as well as their bending offset.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>currentIndex</code></td><td class=\"type\">\n<span class=\"param-type\">number</span></td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\"~refreshOffset\"><span class=\"type-signature\">&lt;inner> </span>refreshOffset()\n</h4></dt><dd><div class=\"description\">Recalculates the front- and back-offset</div><dl class=\"details\"></dl></dd><hr>\n<dt><h4 class=\"name\" id=\"~removeAt\"><span class=\"type-signature\">&lt;inner> </span>removeAt(index)</h4></dt><dd><div \nclass=\"description\">\nRemoves the segment at the given index from the segment chain and returns it. Returns null if no segment has been removed or the index was invalid.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">index of segment which should be removed</td></tr>\n</tbody></table><dl class=\"details\"></dl><h5>Fires:</h5><ul><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul><h5>\nReturns:</h5><div class=\"param-desc\">removed segment or null</div><dl><dt>Type</dt><dd><span class=\"param-type\"><a \nhref=\"Segment.html\">Segment</a></span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~resetStamping\"><span \nclass=\"type-signature\">&lt;inner> </span>resetStamping()</h4></dt><dd><div class=\"description\">\nClears all existing stampings</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~rotate\"><span \nclass=\"type-signature\">&lt;inner> </span>rotate(value)</h4></dt><dd><div class=\"description\">\nRotates the whole profile by the given angle in radiant.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>value</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">rotation in radiant</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~setAngle\"><span class=\"type-signature\">&lt;inner> </span>setAngle(index, angle)</h4></dt><dd><div \nclass=\"description\">Sets the relative angle of the segment at the given index to the given value.</div><h5>Parameters:\n</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th>\n</tr></thead><tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">Number</span>\n</td><td class=\"description last\">index of segment</td></tr><tr><td class=\"name\"><code>angle</code></td><td \nclass=\"type\"><span class=\"param-type\">Number</span></td><td class=\"description last\">\nnew relative angle (between [0..PI*2], automatically looped)</td></tr></tbody></table><dl class=\"details\"></dl><h5>\nFires:</h5><ul><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">\nEditor.Events.nuitEditor::segmentAngleChanged</a></li></ul></dd><hr><dt><h4 class=\"name\" id=\"~setConfig\"><span \nclass=\"type-signature\">&lt;inner> </span>setConfig(newConfig)</h4></dt><dd><div class=\"description\">\nMerges given config with the default config</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead>\n<tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>newConfig\n</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"></td></tr></tbody>\n</table><dl class=\"details\"></dl><h5>Returns:</h5><div class=\"param-desc\">updatedConfig</div><dl><dt>Type</dt><dd><span\n class=\"param-type\">object</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~setConicalBase\"><span \nclass=\"type-signature\">&lt;inner> </span>setConicalBase(index)</h4></dt><dd><div class=\"description\">\nSets the segment, which should be conical aligned</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\nindex</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td class=\"description last\"></td></tr>\n</tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~setDepth\"><span class=\"type-signature\">\n&lt;inner> </span>setDepth(value)</h4></dt><dd><div class=\"description\">Sets the depth of the segments.</div><h5>\nParameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">\nDescription</th></tr></thead><tbody><tr><td class=\"name\"><code>value</code></td><td class=\"type\"><span \nclass=\"param-type\">type</span></td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl><h5>\nFires:</h5><ul><li>Editor.Events.nuitEditor::segmentDepthChanged</li></ul><h5>Returns:</h5><dl><dt>Type</dt><dd><span \nclass=\"param-type\">undefined</span></dd></dl></dd><hr><dt><h4 class=\"name\" id=\"~setLength\"><span \nclass=\"type-signature\">&lt;inner> </span>setLength(index, length, back)</h4></dt><dd><div class=\"description\">\nSets the length of the segment at the given index to the given value.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">index of segment</td></tr><tr><td class=\"name\"><code>length</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">new length of the segment</td></tr><tr><td \nclass=\"name\"><code>back</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">true, if the back length should be set</td></tr></tbody></table><dl class=\"details\"></dl><h5>\nFires:</h5><ul><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">\nEditor.Events.nuitEditor::segmentLengthChanged</a></li></ul></dd><hr><dt><h4 class=\"name\" id=\"~setMaterial\"><span \nclass=\"type-signature\">&lt;inner> </span>setMaterial(newMat)</h4></dt><dd><div class=\"description\">\nAssigns the given material to this profile and adjusts the bending positions.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>newMat</code></td><td class=\"type\"><span class=\"param-type\">Material</span></td><td \nclass=\"description last\">the new material</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\"~setVisibleSide\"><span class=\"type-signature\">&lt;inner> </span>setVisibleSide(value)</h4></dt><dd>\n<div class=\"description\">Sets the visible side of the segment chain.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>value</code></td><td class=\"type\"><span class=\"param-type\">Boolean</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\"~toggleBending\"><span class=\"type-signature\">&lt;inner> </span>toggleBending(index)</h4></dt><dd><div \nclass=\"description\">Toggles the bending direction of the segment at the given index.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">index of segment</td></tr></tbody></table><dl class=\"details\"></dl><h5>Fires:</h5><ul><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">Editor.Events.nuitEditor::segmentBendingChanged</a>\n</li></ul></dd><hr><dt><h4 class=\"name\" id=\"~toggleClose\"><span class=\"type-signature\">&lt;inner> </span>\ntoggleClose(index)</h4></dt><dd><div class=\"description\">Toggles the closed state of the segment at the given index.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">index of segment</td></tr></tbody></table><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\"~toggleConical\"><span class=\"type-signature\">&lt;inner> </span>\ntoggleConical(index)</h4></dt><dd><div class=\"description\">Toggles the conical state of the segment at the given index.\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">index of segment</td></tr></tbody></table><dl \nclass=\"details\"></dl><h5>Fires:</h5><ul><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li></ul></dd><hr><dt><h4 class=\"name\" id=\"~toggleMeasure\"><span \nclass=\"type-signature\">&lt;inner> </span>toggleMeasure(index)</h4></dt><dd><div class=\"description\">\nToggles the measure side of the segment at the given index.</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td \nclass=\"description last\">index of segment</td></tr></tbody></table><dl class=\"details\"></dl><h5>Fires:</h5><ul><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">Editor.Events.nuitEditor::segmentMeasureChanged</a>\n</li></ul></dd><hr><dt><h4 class=\"name\" id=\"~toggleVisibleSide\"><span class=\"type-signature\">&lt;inner> </span>\ntoggleVisibleSide()</h4></dt><dd><div class=\"description\">\nToggles the visible side of the segment chain and returns the new state.</div><dl class=\"details\"></dl><h5>Returns:\n</h5><dl><dt>Type</dt><dd><span class=\"param-type\">Boolean</span></dd></dl></dd></dl></article></section></div></div>\n<div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div>\n</div></div></div><div class=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span \naria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\">\n</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div>\n</div></div></div><footer><span class=\"jsdoc-message\">Documentation generated by <a \nhref=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a> on 2018-04-10T11:34:23+02:00 using the <a \nhref=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span></footer><script \nsrc=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script type=\"text/javascript\" \nsrc=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Editor.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Namespace: Editor</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Namespace: Editor</h1><section><header><h2>Editor</h2></header><article><div \nclass=\"container-overview\"><div class=\"description\">Angular Editor Module</div><dl class=\"details\"></dl></div><h3 \nclass=\"subsection-title\">Requires</h3><ul><li>module:ngMaterial</li><li>module:ngHold</li></ul><h3 \nclass=\"subsection-title\">Namespaces</h3><dl><dt><a href=\"namespaces.html#Editor.Components\"><a \nhref=\"Editor.Components.html\">Components</a></a></dt><dd></dd><dt><a href=\"namespaces.html#Editor.Constants\"><a \nhref=\"Editor.Constants.html\">Constants</a></a></dt><dd></dd><dt><a href=\"namespaces.html#Editor.Controller\"><a \nhref=\"Editor.Controller.html\">Controller</a></a></dt><dd></dd><dt><a href=\"namespaces.html#Editor.Directives\"><a \nhref=\"Editor.Directives.html\">Directives</a></a></dt><dd></dd><dt><a href=\"namespaces.html#Editor.Events\"><a \nhref=\"Editor.Events.html\">Events</a></a></dt><dd></dd><dt><a href=\"namespaces.html#Editor.Services\"><a \nhref=\"Editor.Services.html\">Services</a></a></dt><dd></dd></dl><h3 class=\"subsection-title\">Methods</h3><dl><hr><dt><h4\n class=\"name\" id=\".config\"><span class=\"type-signature\">&lt;static> </span>config($sceDelegateProvider)</h4></dt><dd>\n<div class=\"description\">Run function</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\n$sceDelegateProvider</code></td><td class=\"type\"></td><td class=\"description last\"></td></tr></tbody></table><dl \nclass=\"details\"></dl></dd></dl></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div \nid=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" \nid=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4\n class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button \ntype=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Manager.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: Manager</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: Manager</h1><section><header><h2>Manager</h2></header><article><div \nclass=\"container-overview\"><hr><dt><h4 class=\"name\" id=\"Manager\"><span class=\"type-signature\"></span>new Manager()</h4>\n</dt><dd><div class=\"description\">Manager class</div><dl class=\"details\"></dl></dd></div><h3 class=\"subsection-title\">\nMethods</h3><dl><hr><dt><h4 class=\"name\" id=\".$onChanges\"><span class=\"type-signature\">&lt;abstract, static> </span>\n$onChanges()</h4></dt><dd><div class=\"description\">Callback which will be called when the config has changed</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".$onInput\"><span class=\"type-signature\">&lt;abstract, static> \n</span>$onInput()</h4></dt><dd><div class=\"description\">\nCallback which will be called when the user has pressed any keys</div><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\".$onMouseWheel\"><span class=\"type-signature\">&lt;abstract, static> </span>$onMouseWheel()</h4></dt>\n<dd><div class=\"description\">Callback which will be called when the mousewheel event has been triggered</div><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".$onPostRender\"><span class=\"type-signature\">\n&lt;abstract, static> </span>$onPostRender()</h4></dt><dd><div class=\"description\">\nCallback which will be called after rendering has finished</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".$onPreRender\"><span class=\"type-signature\">&lt;abstract, static> </span>$onPreRender()</h4></dt><dd><div \nclass=\"description\">Callback which will be called before rendering starts</div><dl class=\"details\"></dl></dd><hr><dt>\n<h4 class=\"name\" id=\".$onResize\"><span class=\"type-signature\">&lt;abstract, static> </span>$onResize()</h4></dt><dd>\n<div class=\"description\">Callback which will be called when the screen has been resized</div><dl class=\"details\"></dl>\n</dd><hr><dt><h4 class=\"name\" id=\".$onUse\"><span class=\"type-signature\">&lt;abstract, static> </span>$onUse()</h4></dt>\n<dd><div class=\"description\">Callback which will be called when the current editor has been activated</div><dl \nclass=\"details\"></dl></dd></dl></article></section></div></div><div class=\"clearfix\"></div><div class=\"col-md-3\"><div \nid=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div class=\"modal fade\" \nid=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4\n class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button \ntype=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Point.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: Point</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: Point</h1><section><header><h2>Point</h2></header><article><div class=\"container-overview\">\n<hr><dt><h4 class=\"name\" id=\"Point\"><span class=\"type-signature\"></span>new Point(x, y)</h4></dt><dd><div \nclass=\"description\">\nPoint class with coordinates representing a position in two-dimensional horizontally mirrored euclidean space. (Left: -x, Right: +x, Top: -y, Bottom: y+)\n</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th \nclass=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>x</code></td><td class=\"type\"><span \nclass=\"param-type\">Number</span></td><td class=\"description last\">position on the x-axis</td></tr><tr><td class=\"name\">\n<code>y</code></td><td class=\"type\"><span class=\"param-type\">Number</span></td><td class=\"description last\">\nposition on the y-axis</td></tr></tbody></table><dl class=\"details\"></dl></dd></div></article></section></div></div>\n<div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div>\n</div></div></div><div class=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span \naria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\">\n</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div>\n</div></div></div><footer><span class=\"jsdoc-message\">Documentation generated by <a \nhref=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a> on 2018-04-10T11:34:23+02:00 using the <a \nhref=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span></footer><script \nsrc=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script type=\"text/javascript\" \nsrc=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/Segment.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Class: Segment</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Class: Segment</h1><section><header><h2>Segment</h2></header><article><div \nclass=\"container-overview\"><hr><dt><h4 class=\"name\" id=\"Segment\"><span class=\"type-signature\"></span>\nnew Segment(length, angle, index)</h4></dt><dd><div class=\"description\">Segment class</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>length</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td \nclass=\"description last\">length of the segment</td></tr><tr><td class=\"name\"><code>angle</code></td><td class=\"type\">\n<span class=\"param-type\">number</span></td><td class=\"description last\">\nangle offset to the previous segment or the x-axis if no previous segment exists</td></tr><tr><td class=\"name\"><code>\nindex</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">\nposition of the segment</td></tr></tbody></table><dl class=\"details\"></dl></dd></div></article></section></div></div>\n<div class=\"clearfix\"></div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div>\n</div></div></div><div class=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span \naria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\">\n</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div>\n</div></div></div><footer><span class=\"jsdoc-message\">Documentation generated by <a \nhref=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a> on 2018-04-10T11:34:23+02:00 using the <a \nhref=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span></footer><script \nsrc=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script type=\"text/javascript\" \nsrc=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/classes.list.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Classes</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Classes</h1><section><header><h2></h2></header><article><div class=\"container-overview\"><dl \nclass=\"details\"></dl></div><h3 class=\"subsection-title\">Classes</h3><dl><dt><a href=\"Bounds.html\">Bounds</a></dt><dd>\n</dd><dt><a href=\"Editor.Components.nuitDraw2dComponent.html\">nuitDraw2dComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitDrawComponent.html\">nuitDrawComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitDrawStampingComponent.html\">nuitDrawStampingComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitDrawTopComponent.html\">nuitDrawTopComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitEditorComponent.html\">nuitEditorComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">nuitDraw2dController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDrawController.html\">nuitDrawController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDrawStampingController.html\">nuitDrawStampingController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDrawTopController.html\">nuitDrawTopController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitEditorController.html\">nuitEditorController</a></dt><dd></dd><dt><a \nhref=\"Editor.Directives.ngHoldDirective.html\">ngHoldDirective</a></dt><dd></dd><dt><a \nhref=\"Editor.Services.nuitEditorFactory.html\">nuitEditorFactory</a></dt><dd></dd><dt><a \nhref=\"Editor.Services.nuitProfileFactory.html\">nuitProfileFactory</a></dt><dd></dd><dt><a href=\"Manager.html\">Manager\n</a></dt><dd></dd><dt><a href=\"Point.html\">Point</a></dt><dd></dd><dt><a href=\"Segment.html\">Segment</a></dt><dd></dd>\n</dl><h3 class=\"subsection-title\">Namespaces</h3><dl><dt><a href=\"namespaces.html#Editor\"><a href=\"Editor.html\">Editor\n</a></a></dt><dd></dd><dt><a href=\"namespaces.html#Editor.Components\"><a href=\"Editor.Components.html\">Components</a>\n</a></dt><dd></dd><dt><a href=\"namespaces.html#Editor.Constants\"><a href=\"Editor.Constants.html\">Constants</a></a></dt>\n<dd></dd><dt><a href=\"namespaces.html#Editor.Controller\"><a href=\"Editor.Controller.html\">Controller</a></a></dt><dd>\n</dd><dt><a href=\"namespaces.html#Editor.Directives\"><a href=\"Editor.Directives.html\">Directives</a></a></dt><dd></dd>\n<dt><a href=\"namespaces.html#Editor.Events\"><a href=\"Editor.Events.html\">Events</a></a></dt><dd></dd><dt><a \nhref=\"namespaces.html#Editor.Services\"><a href=\"Editor.Services.html\">Services</a></a></dt><dd></dd></dl><h3 \nclass=\"subsection-title\">Events</h3><dl><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::angleFocused\">\nnuitEditor::angleFocused</h4></dt><dd><div class=\"description\">An angle has been focused</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">number</span></td>\n<td class=\"description last\">Index of the focused angle</td></tr></tbody></table><dl class=\"details\"></dl><h5>\nListeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::clearSelection\">nuitEditor::clearSelection</h4></dt><dd><div class=\"description\">\nThe selection has been cleared</div><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">Editor.Controller.nuitDraw2dController</a></li><li><a \nhref=\"Editor.Controller.nuitEditorController.html\">Editor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4\n class=\"name\" id=\".event:nuitEditor::conicalBaseChanged\">nuitEditor::conicalBaseChanged</h4></dt><dd><div \nclass=\"description\">The conical base has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td \nclass=\"description last\">The index of the new conicalBase</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr>\n<dt><h4 class=\"name\" id=\".event:nuitEditor::editorChanged\">nuitEditor::editorChanged</h4></dt><dd><div \nclass=\"description\">The view has been changed to another editor</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>id</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a\n href=\"Editor.Controller.nuitDrawController.html\">Editor.Controller.nuitDrawController</a></li></ul></dd><hr><dt><h4 \nclass=\"name\" id=\".event:nuitEditor::editorRegistered\">nuitEditor::editorRegistered</h4></dt><dd><div \nclass=\"description\">A new editor has been registered</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>id</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::editorUnregistered\">nuitEditor::editorUnregistered</h4></dt><dd><div class=\"description\">\nAn editor has been unregistered</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name\n</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>id</code></td><td \nclass=\"type\"><span class=\"param-type\">string</span></td><td class=\"description last\"></td></tr></tbody></table><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::init\">nuitEditor::init</h4></dt><dd><div \nclass=\"description\">The editor has been initialized</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::profileCleared\">nuitEditor::profileCleared</h4></dt><dd><div class=\"description\">\nThe current profile has been deleted</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::profileLoaded\">nuitEditor::profileLoaded</h4></dt><dd><div class=\"description\">\nA new profile has been loaded</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::render\">nuitEditor::render</h4></dt><dd><div class=\"description\">\nA new rendering has been requested</div><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">Editor.Controller.nuitDraw2dController</a></li><li><a \nhref=\"Editor.Controller.nuitDrawController.html\">Editor.Controller.nuitDrawController</a></li><li><a \nhref=\"Editor.Controller.nuitDrawStampingController.html\">Editor.Controller.nuitDrawStampingController</a></li></ul>\n</dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::rendered\">nuitEditor::rendered</h4></dt><dd><div \nclass=\"description\">The editor has been rendered</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::reset\">nuitEditor::reset</h4></dt><dd><div class=\"description\">The editor has been resetted\n</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentAdded\">\nnuitEditor::segmentAdded</h4></dt><dd><div class=\"description\">A new segment has been added</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a \nhref=\"Segment.html\">Segment</a></span></td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\">\n</dl><h5>Listeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::segmentAligned\">nuitEditor::segmentAligned</h4></dt><dd><div class=\"description\">\nA segment has been aligned</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th>\n<th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>eventData</code></td><td \nclass=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>baseIndex\n</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">\nIndex of the aligned segment</td></tr></tbody></table></td></tr></tbody></table><dl class=\"details\"></dl><h5>\nListeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::segmentAngleChanged\">nuitEditor::segmentAngleChanged</h4></dt><dd><div class=\"description\">\nA segment angle has been changed</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name\n</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>eventData</code></td>\n<td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>segment\n</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td><td \nclass=\"description last\">The changed segment</td></tr><tr><td class=\"name\"><code>prevAngle</code></td><td class=\"type\">\n<span class=\"param-type\">number</span></td><td class=\"description last\">The previous angle of the segment</td></tr>\n</tbody></table></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::segmentBendingChanged\">nuitEditor::segmentBendingChanged</h4></dt><dd><div class=\"description\">\nBending direction of a segment has been changed</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\nobject}</code></td><td class=\"type\"></td><td class=\"description last\">eventData</td></tr><tr><td class=\"name\"><code>\neventData.segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td>\n<td class=\"description last\">The changed segment</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\".event:nuitEditor::segmentCloseChanged\">nuitEditor::segmentCloseChanged</h4></dt><dd><div \nclass=\"description\">Close setting of a segment has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\">The changed segment</td></tr></tbody></table><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentConicalChanged\">nuitEditor::segmentConicalChanged</h4>\n</dt><dd><div class=\"description\">Conical setting of a segment has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\">The changed segment</td></tr></tbody></table><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentFocused\">nuitEditor::segmentFocused</h4></dt><dd><div \nclass=\"description\">A segment has been focused</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\ndata</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\">Event data<h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>index</code>\n</td><td class=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">\nIndex of the focused segment</td></tr><tr><td class=\"name\"><code>payload</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"description last\">Individual payload of the event caller<h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>direction\n</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td class=\"description last\">\nWether the front length or the back length has been focused</td></tr></tbody></table></td></tr></tbody></table></td>\n</tr></tbody></table><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">Editor.Controller.nuitDraw2dController</a></li><li><a \nhref=\"Editor.Controller.nuitEditorController.html\">Editor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4\n class=\"name\" id=\".event:nuitEditor::segmentLengthChanged\">nuitEditor::segmentLengthChanged</h4></dt><dd><div \nclass=\"description\">Segment length has been changed</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\neventData</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>segment\n</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td><td \nclass=\"description last\">The changed segment</td></tr><tr><td class=\"name\"><code>prevLength</code></td><td \nclass=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">Previous front length</td></tr>\n<tr><td class=\"name\"><code>prevBackLength</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td \nclass=\"description last\">Previous back length</td></tr></tbody></table></td></tr></tbody></table><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentMeasureChanged\">nuitEditor::segmentMeasureChanged</h4>\n</dt><dd><div class=\"description\">Measure direction of a segment has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>eventData</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><h6 class=\"method-params-label method-subparams-label\">Properties</h6><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\">The changed segment</td></tr></tbody></table></td></tr></tbody>\n</table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentRemoved\">\nnuitEditor::segmentRemoved</h4></dt><dd><div class=\"description\">A segment has been removed</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>removed</code></td><td class=\"type\"><span class=\"param-type\"><a \nhref=\"Segment.html\">Segment</a></span></td><td class=\"description last\">segment</td></tr></tbody></table><dl \nclass=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd></dl></article></section></div></div><div class=\"clearfix\">\n</div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div \nclass=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span>\n</button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/global.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Global</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Global</h1><section><header><h2></h2></header><article><div class=\"container-overview\"><dl \nclass=\"details\"></dl></div><h3 class=\"subsection-title\">Members</h3><dl><hr><dt class=\"name\" id=\"HISTORY\"><h4 \nid=\"HISTORY\"><span class=\"type-signature\"></span>HISTORY<span class=\"type-signature\"> :string</span></h4></dt><dd><div \nclass=\"description\">Enum with all possible history state types</div><h5>Type:</h5><ul><li><span class=\"param-type\">\nstring</span></li></ul><dl class=\"details\"></dl></dd></dl></article></section></div></div><div class=\"clearfix\"></div>\n<div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div \nclass=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span>\n</button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/index.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Index</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\">\n<section class=\"readme-section\"><article><p>#nuit.editor Module</p><blockquote><p>\nContains all services, components, etc. which are needed for the nuit-editor</p></blockquote><h2>Table of contents</h2>\n<ul><li><a href=\"#installation\">Installation</a></li><li><a href=\"#usage\">Usage</a></li><li><a href=\"#documentation\">\nDocumentation</a></li></ul><h3>Intallation</h3><p>For building the editor, you need <code>nodejs &gt; 8.9.2</code> and \n<code>npm</code> to have installed on machine. After that, make sure you have gulp and bower globally installed with \n<code>npm i -g bower gulp</code>.</p><p>After cloning the repository run <code>npm i &amp;&amp; bower i</code>\n to install all dependencies.</p><h3>Usage</h3><p>\nnuit.editor comes with a few defined gulp tasks, which builds the editor.</p><ul><li><code>gulp build</code><br>\nBuilds all css, js and template files</li><li><code>gulp build:css</code><br>Compiles all scss files into css files\n</li><li><code>gulp build:js</code><br>Concats, minifies and compiles into es2015 all js files</li><li><code>\ngulp build:templates</code><br>Loads all .html and .svg files and loads them into a generated angular templatecache\n</li><li><code>gulp docs</code><br>Generates a documentation with JSDoc</li><li><code>gulp watch</code><br>\nAdds watchers for all js, css and html files and runs all necessary tasks when they are changed</li></ul><h3>\nDocumentation</h3><p>A documentation comes in the /doc folder. You should rebuild it by runnning <code>gulp docs</code>\n to make sure you got a fresh version</p></article></section></div></div><div class=\"clearfix\"></div><div \nclass=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div \nclass=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span>\n</button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/namespaces.list.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><meta name=\"viewport\" content=\"width=device-width\"><title>\nDocumentation Namespaces</title>\n<!--[if lt IE 9]>\n	<script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n	<![endif]--><link \ntype=\"text/css\" rel=\"stylesheet\" href=\"styles/sunlight.default.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"styles/site.simplex.css\"></head><body><div class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\">\n<div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"index.html\">Documentation</a> <button class=\"navbar-toggle\" \ntype=\"button\" data-toggle=\"collapse\" data-target=\"#topNavigation\"><span class=\"icon-bar\"></span> <span \nclass=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse collapse\" \nid=\"topNavigation\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\"><a href=\"namespaces.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Namespaces<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.html\">Editor</a></li><li><a href=\"Editor.Components.html\">Editor.Components</a></li><li><a \nhref=\"Editor.Constants.html\">Editor.Constants</a></li><li><a href=\"Editor.Controller.html\">Editor.Controller</a></li>\n<li><a href=\"Editor.Directives.html\">Editor.Directives</a></li><li><a href=\"Editor.Events.html\">Editor.Events</a></li>\n<li><a href=\"Editor.Services.html\">Editor.Services</a></li></ul></li><li class=\"dropdown\"><a href=\"classes.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Classes<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Bounds.html\">Bounds</a></li><li><a href=\"Editor.Components.nuitDraw2dComponent.html\">\nEditor.Components.nuitDraw2dComponent</a></li><li><a href=\"Editor.Components.nuitDrawComponent.html\">\nEditor.Components.nuitDrawComponent</a></li><li><a href=\"Editor.Components.nuitDrawStampingComponent.html\">\nEditor.Components.nuitDrawStampingComponent</a></li><li><a href=\"Editor.Components.nuitDrawTopComponent.html\">\nEditor.Components.nuitDrawTopComponent</a></li><li><a href=\"Editor.Components.nuitEditorComponent.html\">\nEditor.Components.nuitEditorComponent</a></li><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitDrawController.html\">\nEditor.Controller.nuitDrawController</a></li><li><a href=\"Editor.Controller.nuitDrawStampingController.html\">\nEditor.Controller.nuitDrawStampingController</a></li><li><a href=\"Editor.Controller.nuitDrawTopController.html\">\nEditor.Controller.nuitDrawTopController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li><li><a href=\"Editor.Directives.ngHoldDirective.html\">\nEditor.Directives.ngHoldDirective</a></li><li><a href=\"Editor.Services.nuitEditorFactory.html\">\nEditor.Services.nuitEditorFactory</a></li><li><a href=\"Editor.Services.nuitProfileFactory.html\">\nEditor.Services.nuitProfileFactory</a></li><li><a href=\"Manager.html\">Manager</a></li><li><a href=\"Point.html\">Point\n</a></li><li><a href=\"Segment.html\">Segment</a></li></ul></li><li class=\"dropdown\"><a href=\"events.list.html\" \nclass=\"dropdown-toggle\" data-toggle=\"dropdown\">Events<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::angleFocused\">Editor.Events.nuitEditor::angleFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::clearSelection\">Editor.Events.nuitEditor::clearSelection</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::conicalBaseChanged\">Editor.Events.nuitEditor::conicalBaseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorChanged\">Editor.Events.nuitEditor::editorChanged</a></li><li>\n<a href=\"Editor.Events.html#.event:nuitEditor::editorRegistered\">Editor.Events.nuitEditor::editorRegistered</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::editorUnregistered\">Editor.Events.nuitEditor::editorUnregistered</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::init\">Editor.Events.nuitEditor::init</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileCleared\">Editor.Events.nuitEditor::profileCleared</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::profileLoaded\">Editor.Events.nuitEditor::profileLoaded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::render\">Editor.Events.nuitEditor::render</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::rendered\">Editor.Events.nuitEditor::rendered</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::reset\">Editor.Events.nuitEditor::reset</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAdded\">Editor.Events.nuitEditor::segmentAdded</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAligned\">Editor.Events.nuitEditor::segmentAligned</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentAngleChanged\">Editor.Events.nuitEditor::segmentAngleChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentBendingChanged\">\nEditor.Events.nuitEditor::segmentBendingChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentCloseChanged\">Editor.Events.nuitEditor::segmentCloseChanged</a></li>\n<li><a href=\"Editor.Events.html#.event:nuitEditor::segmentConicalChanged\">\nEditor.Events.nuitEditor::segmentConicalChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentFocused\">Editor.Events.nuitEditor::segmentFocused</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentLengthChanged\">Editor.Events.nuitEditor::segmentLengthChanged</a>\n</li><li><a href=\"Editor.Events.html#.event:nuitEditor::segmentMeasureChanged\">\nEditor.Events.nuitEditor::segmentMeasureChanged</a></li><li><a \nhref=\"Editor.Events.html#.event:nuitEditor::segmentRemoved\">Editor.Events.nuitEditor::segmentRemoved</a></li></ul></li>\n<li class=\"dropdown\"><a href=\"global.html\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Global<b class=\"caret\"></b>\n</a><ul class=\"dropdown-menu\"><li><a href=\"global.html#HISTORY\">HISTORY</a></li></ul></li></ul><div \nclass=\"col-sm-3 col-md-3\"><form class=\"navbar-form\" role=\"search\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control\" placeholder=\"Search\" name=\"q\" id=\"search-input\"><div class=\"input-group-btn\"><button \nclass=\"btn btn-default\" id=\"search-submit\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div></form></div>\n</div></div></div><div class=\"container\" id=\"toc-content\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"main\"><h1 \nclass=\"page-title\">Namespaces</h1><section><header><h2></h2></header><article><div class=\"container-overview\"><dl \nclass=\"details\"></dl></div><h3 class=\"subsection-title\">Classes</h3><dl><dt><a href=\"Bounds.html\">Bounds</a></dt><dd>\n</dd><dt><a href=\"Editor.Components.nuitDraw2dComponent.html\">nuitDraw2dComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitDrawComponent.html\">nuitDrawComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitDrawStampingComponent.html\">nuitDrawStampingComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitDrawTopComponent.html\">nuitDrawTopComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Components.nuitEditorComponent.html\">nuitEditorComponent</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">nuitDraw2dController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDrawController.html\">nuitDrawController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDrawStampingController.html\">nuitDrawStampingController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitDrawTopController.html\">nuitDrawTopController</a></dt><dd></dd><dt><a \nhref=\"Editor.Controller.nuitEditorController.html\">nuitEditorController</a></dt><dd></dd><dt><a \nhref=\"Editor.Directives.ngHoldDirective.html\">ngHoldDirective</a></dt><dd></dd><dt><a \nhref=\"Editor.Services.nuitEditorFactory.html\">nuitEditorFactory</a></dt><dd></dd><dt><a \nhref=\"Editor.Services.nuitProfileFactory.html\">nuitProfileFactory</a></dt><dd></dd><dt><a href=\"Manager.html\">Manager\n</a></dt><dd></dd><dt><a href=\"Point.html\">Point</a></dt><dd></dd><dt><a href=\"Segment.html\">Segment</a></dt><dd></dd>\n</dl><h3 class=\"subsection-title\">Namespaces</h3><dl><dt><a href=\"namespaces.html#Editor\"><a href=\"Editor.html\">Editor\n</a></a></dt><dd></dd><dt><a href=\"namespaces.html#Editor.Components\"><a href=\"Editor.Components.html\">Components</a>\n</a></dt><dd></dd><dt><a href=\"namespaces.html#Editor.Constants\"><a href=\"Editor.Constants.html\">Constants</a></a></dt>\n<dd></dd><dt><a href=\"namespaces.html#Editor.Controller\"><a href=\"Editor.Controller.html\">Controller</a></a></dt><dd>\n</dd><dt><a href=\"namespaces.html#Editor.Directives\"><a href=\"Editor.Directives.html\">Directives</a></a></dt><dd></dd>\n<dt><a href=\"namespaces.html#Editor.Events\"><a href=\"Editor.Events.html\">Events</a></a></dt><dd></dd><dt><a \nhref=\"namespaces.html#Editor.Services\"><a href=\"Editor.Services.html\">Services</a></a></dt><dd></dd></dl><h3 \nclass=\"subsection-title\">Events</h3><dl><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::angleFocused\">\nnuitEditor::angleFocused</h4></dt><dd><div class=\"description\">An angle has been focused</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">number</span></td>\n<td class=\"description last\">Index of the focused angle</td></tr></tbody></table><dl class=\"details\"></dl><h5>\nListeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitDraw2dController.html\">\nEditor.Controller.nuitDraw2dController</a></li><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::clearSelection\">nuitEditor::clearSelection</h4></dt><dd><div class=\"description\">\nThe selection has been cleared</div><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">Editor.Controller.nuitDraw2dController</a></li><li><a \nhref=\"Editor.Controller.nuitEditorController.html\">Editor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4\n class=\"name\" id=\".event:nuitEditor::conicalBaseChanged\">nuitEditor::conicalBaseChanged</h4></dt><dd><div \nclass=\"description\">The conical base has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>index</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td \nclass=\"description last\">The index of the new conicalBase</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr>\n<dt><h4 class=\"name\" id=\".event:nuitEditor::editorChanged\">nuitEditor::editorChanged</h4></dt><dd><div \nclass=\"description\">The view has been changed to another editor</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>id</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a\n href=\"Editor.Controller.nuitDrawController.html\">Editor.Controller.nuitDrawController</a></li></ul></dd><hr><dt><h4 \nclass=\"name\" id=\".event:nuitEditor::editorRegistered\">nuitEditor::editorRegistered</h4></dt><dd><div \nclass=\"description\">A new editor has been registered</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>id</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td \nclass=\"description last\"></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::editorUnregistered\">nuitEditor::editorUnregistered</h4></dt><dd><div class=\"description\">\nAn editor has been unregistered</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name\n</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>id</code></td><td \nclass=\"type\"><span class=\"param-type\">string</span></td><td class=\"description last\"></td></tr></tbody></table><dl \nclass=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::init\">nuitEditor::init</h4></dt><dd><div \nclass=\"description\">The editor has been initialized</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::profileCleared\">nuitEditor::profileCleared</h4></dt><dd><div class=\"description\">\nThe current profile has been deleted</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::profileLoaded\">nuitEditor::profileLoaded</h4></dt><dd><div class=\"description\">\nA new profile has been loaded</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::render\">nuitEditor::render</h4></dt><dd><div class=\"description\">\nA new rendering has been requested</div><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">Editor.Controller.nuitDraw2dController</a></li><li><a \nhref=\"Editor.Controller.nuitDrawController.html\">Editor.Controller.nuitDrawController</a></li><li><a \nhref=\"Editor.Controller.nuitDrawStampingController.html\">Editor.Controller.nuitDrawStampingController</a></li></ul>\n</dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::rendered\">nuitEditor::rendered</h4></dt><dd><div \nclass=\"description\">The editor has been rendered</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::reset\">nuitEditor::reset</h4></dt><dd><div class=\"description\">The editor has been resetted\n</div><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentAdded\">\nnuitEditor::segmentAdded</h4></dt><dd><div class=\"description\">A new segment has been added</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a \nhref=\"Segment.html\">Segment</a></span></td><td class=\"description last\"></td></tr></tbody></table><dl class=\"details\">\n</dl><h5>Listeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::segmentAligned\">nuitEditor::segmentAligned</h4></dt><dd><div class=\"description\">\nA segment has been aligned</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name</th>\n<th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>eventData</code></td><td \nclass=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>baseIndex\n</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">\nIndex of the aligned segment</td></tr></tbody></table></td></tr></tbody></table><dl class=\"details\"></dl><h5>\nListeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::segmentAngleChanged\">nuitEditor::segmentAngleChanged</h4></dt><dd><div class=\"description\">\nA segment angle has been changed</div><h5>Parameters:</h5><table class=\"params table table-striped\"><thead><tr><th>Name\n</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>eventData</code></td>\n<td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>segment\n</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td><td \nclass=\"description last\">The changed segment</td></tr><tr><td class=\"name\"><code>prevAngle</code></td><td class=\"type\">\n<span class=\"param-type\">number</span></td><td class=\"description last\">The previous angle of the segment</td></tr>\n</tbody></table></td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" \nid=\".event:nuitEditor::segmentBendingChanged\">nuitEditor::segmentBendingChanged</h4></dt><dd><div class=\"description\">\nBending direction of a segment has been changed</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\nobject}</code></td><td class=\"type\"></td><td class=\"description last\">eventData</td></tr><tr><td class=\"name\"><code>\neventData.segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td>\n<td class=\"description last\">The changed segment</td></tr></tbody></table><dl class=\"details\"></dl></dd><hr><dt><h4 \nclass=\"name\" id=\".event:nuitEditor::segmentCloseChanged\">nuitEditor::segmentCloseChanged</h4></dt><dd><div \nclass=\"description\">Close setting of a segment has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\">The changed segment</td></tr></tbody></table><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentConicalChanged\">nuitEditor::segmentConicalChanged</h4>\n</dt><dd><div class=\"description\">Conical setting of a segment has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\">The changed segment</td></tr></tbody></table><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentFocused\">nuitEditor::segmentFocused</h4></dt><dd><div \nclass=\"description\">A segment has been focused</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\ndata</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\">Event data<h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>index</code>\n</td><td class=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">\nIndex of the focused segment</td></tr><tr><td class=\"name\"><code>payload</code></td><td class=\"type\"><span \nclass=\"param-type\">object</span></td><td class=\"description last\">Individual payload of the event caller<h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>direction\n</code></td><td class=\"type\"><span class=\"param-type\">string</span></td><td class=\"description last\">\nWether the front length or the back length has been focused</td></tr></tbody></table></td></tr></tbody></table></td>\n</tr></tbody></table><dl class=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a \nhref=\"Editor.Controller.nuitDraw2dController.html\">Editor.Controller.nuitDraw2dController</a></li><li><a \nhref=\"Editor.Controller.nuitEditorController.html\">Editor.Controller.nuitEditorController</a></li></ul></dd><hr><dt><h4\n class=\"name\" id=\".event:nuitEditor::segmentLengthChanged\">nuitEditor::segmentLengthChanged</h4></dt><dd><div \nclass=\"description\">Segment length has been changed</div><h5>Parameters:</h5><table class=\"params table table-striped\">\n<thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>\neventData</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td class=\"description last\"><h6 \nclass=\"method-params-label method-subparams-label\">Properties</h6><table class=\"params table table-striped\"><thead><tr>\n<th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead><tbody><tr><td class=\"name\"><code>segment\n</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">Segment</a></span></td><td \nclass=\"description last\">The changed segment</td></tr><tr><td class=\"name\"><code>prevLength</code></td><td \nclass=\"type\"><span class=\"param-type\">number</span></td><td class=\"description last\">Previous front length</td></tr>\n<tr><td class=\"name\"><code>prevBackLength</code></td><td class=\"type\"><span class=\"param-type\">number</span></td><td \nclass=\"description last\">Previous back length</td></tr></tbody></table></td></tr></tbody></table><dl class=\"details\">\n</dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentMeasureChanged\">nuitEditor::segmentMeasureChanged</h4>\n</dt><dd><div class=\"description\">Measure direction of a segment has been changed</div><h5>Parameters:</h5><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>eventData</code></td><td class=\"type\"><span class=\"param-type\">object</span></td><td \nclass=\"description last\"><h6 class=\"method-params-label method-subparams-label\">Properties</h6><table \nclass=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr></thead>\n<tbody><tr><td class=\"name\"><code>segment</code></td><td class=\"type\"><span class=\"param-type\"><a href=\"Segment.html\">\nSegment</a></span></td><td class=\"description last\">The changed segment</td></tr></tbody></table></td></tr></tbody>\n</table><dl class=\"details\"></dl></dd><hr><dt><h4 class=\"name\" id=\".event:nuitEditor::segmentRemoved\">\nnuitEditor::segmentRemoved</h4></dt><dd><div class=\"description\">A segment has been removed</div><h5>Parameters:</h5>\n<table class=\"params table table-striped\"><thead><tr><th>Name</th><th>Type</th><th class=\"last\">Description</th></tr>\n</thead><tbody><tr><td class=\"name\"><code>removed</code></td><td class=\"type\"><span class=\"param-type\"><a \nhref=\"Segment.html\">Segment</a></span></td><td class=\"description last\">segment</td></tr></tbody></table><dl \nclass=\"details\"></dl><h5>Listeners of This Event:</h5><ul><li><a href=\"Editor.Controller.nuitEditorController.html\">\nEditor.Controller.nuitEditorController</a></li></ul></dd></dl></article></section></div></div><div class=\"clearfix\">\n</div><div class=\"col-md-3\"><div id=\"toc\" class=\"col-md-3 hidden-xs hidden-sm hidden-md\"></div></div></div></div><div \nclass=\"modal fade\" id=\"searchResults\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span>\n</button><h4 class=\"modal-title\">Search results</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><footer><span \nclass=\"jsdoc-message\">Documentation generated by <a href=\"https://github.com/jsdoc3/jsdoc\">JSDoc 3.5.5</a>\n on 2018-04-10T11:34:23+02:00 using the <a href=\"https://github.com/docstrap/docstrap\">DocStrap template</a>.</span>\n</footer><script src=\"scripts/docstrap.lib.js\"></script><script src=\"scripts/toc.js\"></script><script \ntype=\"text/javascript\" src=\"scripts/fulltext-search-ui.js\"></script><script>\n$( function () {\n	$( \"[id*=\'$\']\" ).each( function () {\n		var $this = $( this );\n\n		$this.attr( \"id\", $this.attr( \"id\" ).replace( \"$\", \"__\" ) );\n	} );\n\n	$( \".tutorial-section pre, .readme-section pre, pre.prettyprint.source\" ).each( function () {\n		var $this = $( this );\n\n		var example = $this.find( \"code\" );\n		exampleText = example.html();\n		var lang = /{@lang (.*?)}/.exec( exampleText );\n		if ( lang && lang[1] ) {\n			exampleText = exampleText.replace( lang[0], \"\" );\n			example.html( exampleText );\n			lang = lang[1];\n		} else {\n			var langClassMatch = example.parent()[0].className.match(/lang\\-(\\S+)/);\n			lang = langClassMatch ? langClassMatch[1] : \"javascript\";\n		}\n\n		if ( lang ) {\n\n			$this\n			.addClass( \"sunlight-highlight-\" + lang )\n			.addClass( \"linenums\" )\n			.html( example.html() );\n\n		}\n	} );\n\n	Sunlight.highlightAll( {\n		lineNumbers : false,\n		showMenu : true,\n		enableDoclinks : true\n	} );\n\n	$.catchAnchorLinks( {\n        navbarOffset: 10\n	} );\n	$( \"#toc\" ).toc( {\n		anchorName  : function ( i, heading, prefix ) {\n			return $( heading ).attr( \"id\" ) || ( prefix + i );\n		},\n		selectors   : \"#toc-content h1,#toc-content h2,#toc-content h3,#toc-content h4\",\n		showAndHide : false,\n		smoothScrolling: true\n	} );\n\n	$( \"#main span[id^=\'toc\']\" ).addClass( \"toc-shim\" );\n	$( \'.dropdown-toggle\' ).dropdown();\n\n    $( \"table\" ).each( function () {\n      var $this = $( this );\n      $this.addClass(\'table\');\n    } );\n\n} );\n</script><script type=\"text/javascript\">$(document).ready(function() {\n            SearcherDisplay.init();\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/docs/quicksearch.html","<html><head></head><body style=\"background: transparent\"><script src=\"scripts/docstrap.lib.js\"></script><script \nsrc=\"scripts/lunr.min.js\"></script><script src=\"scripts/fulltext-search.js\"></script><script \ntype=\"text/x-docstrap-searchdb\">\n{\"global.html\":{\"id\":\"global.html\",\"title\":\"Global\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Global Members HISTORY :string Enum with all possible history state types Type: string × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"classes.list.html\":{\"id\":\"classes.list.html\",\"title\":\"Classes\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Classes Classes Bounds nuitDraw2dComponent nuitDrawComponent nuitDrawStampingComponent nuitDrawTopComponent nuitEditorComponent nuitDraw2dController nuitDrawController nuitDrawStampingController nuitDrawTopController nuitEditorController ngHoldDirective nuitEditorFactory nuitProfileFactory Manager Point Segment Namespaces Editor Components Constants Controller Directives Events Services Events nuitEditor::angleFocused An angle has been focused Parameters: Name Type Description index number Index of the focused angle Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitEditorController nuitEditor::clearSelection The selection has been cleared Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitEditorController nuitEditor::conicalBaseChanged The conical base has been changed Parameters: Name Type Description index number The index of the new conicalBase nuitEditor::editorChanged The view has been changed to another editor Parameters: Name Type Description id string Listeners of This Event: Editor.Controller.nuitDrawController nuitEditor::editorRegistered A new editor has been registered Parameters: Name Type Description id string nuitEditor::editorUnregistered An editor has been unregistered Parameters: Name Type Description id string nuitEditor::init The editor has been initialized nuitEditor::profileCleared The current profile has been deleted nuitEditor::profileLoaded A new profile has been loaded nuitEditor::render A new rendering has been requested Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitDrawController Editor.Controller.nuitDrawStampingController nuitEditor::rendered The editor has been rendered nuitEditor::reset The editor has been resetted nuitEditor::segmentAdded A new segment has been added Parameters: Name Type Description segment Segment Listeners of This Event: Editor.Controller.nuitEditorController nuitEditor::segmentAligned A segment has been aligned Parameters: Name Type Description eventData object Properties Name Type Description baseIndex number Index of the aligned segment Listeners of This Event: Editor.Controller.nuitEditorController nuitEditor::segmentAngleChanged A segment angle has been changed Parameters: Name Type Description eventData object Properties Name Type Description segment Segment The changed segment prevAngle number The previous angle of the segment nuitEditor::segmentBendingChanged Bending direction of a segment has been changed Parameters: Name Type Description object} eventData eventData.segment Segment The changed segment nuitEditor::segmentCloseChanged Close setting of a segment has been changed Parameters: Name Type Description segment Segment The changed segment nuitEditor::segmentConicalChanged Conical setting of a segment has been changed Parameters: Name Type Description segment Segment The changed segment nuitEditor::segmentFocused A segment has been focused Parameters: Name Type Description data object Event data Properties Name Type Description index number Index of the focused segment payload object Individual payload of the event caller Properties Name Type Description direction string Wether the front length or the back length has been focused Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitEditorController nuitEditor::segmentLengthChanged Segment length has been changed Parameters: Name Type Description eventData object Properties Name Type Description segment Segment The changed segment prevLength number Previous front length prevBackLength number Previous back length nuitEditor::segmentMeasureChanged Measure direction of a segment has been changed Parameters: Name Type Description eventData object Properties Name Type Description segment Segment The changed segment nuitEditor::segmentRemoved A segment has been removed Parameters: Name Type Description removed Segment segment Listeners of This Event: Editor.Controller.nuitEditorController × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"namespaces.list.html\":{\"id\":\"namespaces.list.html\",\"title\":\"Namespaces\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Namespaces Classes Bounds nuitDraw2dComponent nuitDrawComponent nuitDrawStampingComponent nuitDrawTopComponent nuitEditorComponent nuitDraw2dController nuitDrawController nuitDrawStampingController nuitDrawTopController nuitEditorController ngHoldDirective nuitEditorFactory nuitProfileFactory Manager Point Segment Namespaces Editor Components Constants Controller Directives Events Services Events nuitEditor::angleFocused An angle has been focused Parameters: Name Type Description index number Index of the focused angle Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitEditorController nuitEditor::clearSelection The selection has been cleared Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitEditorController nuitEditor::conicalBaseChanged The conical base has been changed Parameters: Name Type Description index number The index of the new conicalBase nuitEditor::editorChanged The view has been changed to another editor Parameters: Name Type Description id string Listeners of This Event: Editor.Controller.nuitDrawController nuitEditor::editorRegistered A new editor has been registered Parameters: Name Type Description id string nuitEditor::editorUnregistered An editor has been unregistered Parameters: Name Type Description id string nuitEditor::init The editor has been initialized nuitEditor::profileCleared The current profile has been deleted nuitEditor::profileLoaded A new profile has been loaded nuitEditor::render A new rendering has been requested Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitDrawController Editor.Controller.nuitDrawStampingController nuitEditor::rendered The editor has been rendered nuitEditor::reset The editor has been resetted nuitEditor::segmentAdded A new segment has been added Parameters: Name Type Description segment Segment Listeners of This Event: Editor.Controller.nuitEditorController nuitEditor::segmentAligned A segment has been aligned Parameters: Name Type Description eventData object Properties Name Type Description baseIndex number Index of the aligned segment Listeners of This Event: Editor.Controller.nuitEditorController nuitEditor::segmentAngleChanged A segment angle has been changed Parameters: Name Type Description eventData object Properties Name Type Description segment Segment The changed segment prevAngle number The previous angle of the segment nuitEditor::segmentBendingChanged Bending direction of a segment has been changed Parameters: Name Type Description object} eventData eventData.segment Segment The changed segment nuitEditor::segmentCloseChanged Close setting of a segment has been changed Parameters: Name Type Description segment Segment The changed segment nuitEditor::segmentConicalChanged Conical setting of a segment has been changed Parameters: Name Type Description segment Segment The changed segment nuitEditor::segmentFocused A segment has been focused Parameters: Name Type Description data object Event data Properties Name Type Description index number Index of the focused segment payload object Individual payload of the event caller Properties Name Type Description direction string Wether the front length or the back length has been focused Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitEditorController nuitEditor::segmentLengthChanged Segment length has been changed Parameters: Name Type Description eventData object Properties Name Type Description segment Segment The changed segment prevLength number Previous front length prevBackLength number Previous back length nuitEditor::segmentMeasureChanged Measure direction of a segment has been changed Parameters: Name Type Description eventData object Properties Name Type Description segment Segment The changed segment nuitEditor::segmentRemoved A segment has been removed Parameters: Name Type Description removed Segment segment Listeners of This Event: Editor.Controller.nuitEditorController × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"index.html\":{\"id\":\"index.html\",\"title\":\"Index\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY #nuit.editor Module Contains all services, components, etc. which are needed for the nuit-editor Table of contents Installation Usage Documentation IntallationFor building the editor, you need nodejs &gt; 8.9.2 and npm to have installed on machine. After that, make sure you have gulp and bower globally installed with npm i -g bower gulp. After cloning the repository run npm i &amp;&amp; bower i to install all dependencies. Usagenuit.editor comes with a few defined gulp tasks, which builds the editor. gulp build Builds all css, js and template files gulp build:css Compiles all scss files into css files gulp build:js Concats, minifies and compiles into es2015 all js files gulp build:templates Loads all .html and .svg files and loads them into a generated angular templatecache gulp docs Generates a documentation with JSDoc gulp watch Adds watchers for all js, css and html files and runs all necessary tasks when they are changed DocumentationA documentation comes in the /doc folder. You should rebuild it by runnning gulp docs to make sure you got a fresh version × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Bounds.html\":{\"id\":\"Bounds.html\",\"title\":\"Class: Bounds\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: Bounds Bounds new Bounds() Bounds class with minimum and maximum values of two coordinates. × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.html\":{\"id\":\"Editor.html\",\"title\":\"Namespace: Editor\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Namespace: Editor Editor Angular Editor Module Requires module:ngMaterial module:ngHold Namespaces Components Constants Controller Directives Events Services Methods &lt;static&gt; config($sceDelegateProvider) Run function Parameters: Name Type Description $sceDelegateProvider × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Components.html\":{\"id\":\"Editor.Components.html\",\"title\":\"Namespace: Components\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Namespace: Components Editor. Components Components of editor Classes nuitDraw2dComponent nuitDrawComponent nuitDrawStampingComponent nuitDrawTopComponent nuitEditorComponent × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Components.nuitDraw2dComponent.html\":{\"id\":\"Editor.Components.nuitDraw2dComponent.html\",\"title\":\"Class: nuitDraw2dComponent\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitDraw2dComponent Editor.Components. nuitDraw2dComponent Subeditor for 2d drawings new nuitDraw2dComponent() Requires: nuitDrawComponent nuitDraw2dController Example &lt;nuit-draw ..&gt; &lt;nuit-draw-2d&gt;&lt;/nuit-draw-2d&gt; &lt;!-- other subeditors --&gt; &lt;/nuit-draw&gt; Requires nuitDrawComponent nuitDraw2dController × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Components.nuitDrawComponent.html\":{\"id\":\"Editor.Components.nuitDrawComponent.html\",\"title\":\"Class: nuitDrawComponent\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitDrawComponent Editor.Components. nuitDrawComponent Wrappercomponent for all editor-subcomponents new nuitDrawComponent(editorConfig) Parameters: Name Type Description editorConfig object Config which should be used by the editor Requires: nuitDrawController Example &lt;nuit-draw editor-config=&quot;vm.config&quot;&gt; &lt;!-- subeditors --&gt; &lt;/nuit-draw&gt; Requires nuitDrawController × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Components.nuitDrawStampingComponent.html\":{\"id\":\"Editor.Components.nuitDrawStampingComponent.html\",\"title\":\"Class: nuitDrawStampingComponent\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitDrawStampingComponent Editor.Components. nuitDrawStampingComponent Subeditor for 2d drawings new nuitDrawStampingComponent() Requires: nuitDrawComponent nuitDrawStampingController Example &lt;nuit-draw ..&gt; &lt;nuit-draw-stamping&gt;&lt;/nuit-draw-stamping&gt; &lt;!-- other subeditors --&gt; &lt;/nuit-draw&gt; Requires nuitDrawComponent nuitDrawStampingController × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Components.nuitDrawTopComponent.html\":{\"id\":\"Editor.Components.nuitDrawTopComponent.html\",\"title\":\"Class: nuitDrawTopComponent\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitDrawTopComponent Editor.Components. nuitDrawTopComponent Editor for conical editing new nuitDrawTopComponent() Requires: nuitDrawComponent nuitDrawTopController Example &lt;nuit-draw&gt; &lt;nuit-draw-top&gt;&lt;/nuit-draw-top&gt; &lt;!-- other subeditors --&gt; &lt;/nuit-draw&gt; Requires nuitDrawComponent nuitDrawTopController × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Components.nuitEditorComponent.html\":{\"id\":\"Editor.Components.nuitEditorComponent.html\",\"title\":\"Class: nuitEditorComponent\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitEditorComponent Editor.Components. nuitEditorComponent Component which wraps the nuitDrawComponent with all features, like the sidebar, menubar, etc. new nuitEditorComponent(editorConfig, openProfileDialog, openProfileState, saveProfileDialog, selectMaterialDialog, finishAction, languageKey) Parameters: Name Type Description editorConfig object Config which should be used by the editor openProfileDialog Editor.Components.nuitEditorComponent~openProfileDialog Function which opens a dialog to select a profile openProfileState string State to navigate to when opening a profile saveProfileDialog Editor.Components.nuitEditorComponent~saveProfileDialog Function which opens a dialog to save a given profile selectMaterialDialog Editor.Components.nuitEditorComponent~selectMaterialDialog Function which opens a material finishAction Editor.Components.nuitEditorComponent~finishAction Function which gets executed when user clicks at &quot;addToCart&quot; languageKey string Language key to apply Requires: nuitEditorController Example &lt;nuit-editor editor-config=&quot;vm.config&quot;&gt;&lt;/nuit-editor&gt; Requires nuitEditorController Type Definitions finishActionDialog() Function to execute when user clicks &quot;addToCart&quot; Returns: Type Promise openProfileDialog() Open a saved profile Returns: Resolves with the opened profile Type Promise saveProfileDialog(profile) Save a given profile Parameters: Name Type Description profile object The profile to save Returns: Promise wether the save process has been successfull Type Promise selectMaterialDialog() Select a material Returns: Promise which resolves the selected material Type Promise × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Constants.html\":{\"id\":\"Editor.Constants.html\",\"title\":\"Namespace: Constants\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Namespace: Constants Editor. Constants Constants of editor Members &lt;static, constant&gt; nuitEditorEvents :string Type: string Properties: Name Type Default Description profileLoaded string nuitEditor::profileLoaded nuitEditor::profileLoaded profileCleared string nuitEditor::profileCleared nuitEditor::profileCleared editorRegistered string nuitEditor::editorRegistered nuitEditor::editorRegistered editorUnregistered string nuitEditor::editorUnregistered nuitEditor::editorUnregistered editorChanged string nuitEditor::editorChanged nuitEditor::editorChanged init string nuitEditor::init nuitEditor::init reset string nuitEditor::reset nuitEditor::reset render string nuitEditor::render nuitEditor::render rendered string nuitEditor::rendered nuitEditor::rendered segmentAdded string nuitEditor::segmentAdded nuitEditor::segmentAdded segmentRemoved string nuitEditor::segmentRemoved nuitEditor::segmentRemoved segmentAligned string nuitEditor::segmentAligned nuitEditor::segmentAligned segmentLengthChanged string nuitEditor::segmentLengthChanged nuitEditor::segmentLengthChanged segmentAngleChanged string nuitEditor::segmentAngleChanged nuitEditor::segmentAngleChanged segmentConicalChanged string nuitEditor::segmentConicalChanged nuitEditor::segmentConicalChanged conicalBaseChanged string nuitEditor::conicalBaseChanged nuitEditor::conicalBaseChanged segmentMeasureChanged string nuitEditor::segmentMeasureChanged nuitEditor::segmentMeasureChanged segmentBendingChanged string nuitEditor::segmentBendingChanged nuitEditor::segmentBendingChanged} segmentCloseChanged string nuitEditor::segmentCloseChanged nuitEditor::segmentCloseChanged} segmentDepthChanged string nuitEditor::segmentDepthChanged nuitEditor::segmentDepthChanged segmentFocused string nuitEditor::segmentFocused nuitEditor::segmentFocused angleFocused string nuitEditor::angleFocused nuitEditor::angleFocused clearSelection string nuitEditor::clearSelection nuitEditor::clearSelection × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Controller.html\":{\"id\":\"Editor.Controller.html\",\"title\":\"Namespace: Controller\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Namespace: Controller Editor. Controller Controller of editor Classes nuitDraw2dController nuitDrawController nuitDrawStampingController nuitDrawTopController nuitEditorController × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Controller.nuitDraw2dController.html\":{\"id\":\"Editor.Controller.nuitDraw2dController.html\",\"title\":\"Class: nuitDraw2dController\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitDraw2dController Editor.Controller. nuitDraw2dController Controller for nuitDraw2dComponent new nuitDraw2dController($rootScope, $scope, nuitmath, nuitProfile, nuitEditor, nuitEditorEvents) Parameters: Name Type Description $rootScope object https://docs.angularjs.org/api/ng/service/$rootScope $scope object https://docs.angularjs.org/api/ng/service/$scope nuitmath object TODO: remove nuitmath dependency nuitProfile object Editor.Services.nuitProfileFactory nuitEditor object Editor.Services.nuitEditorFactory nuitEditorEvents object Editor.Constants.nuitEditorEvents Listens to Events: Editor.Events.nuitEditor::segmentFocused Editor.Events.nuitEditor::angleFocused Editor.Events.nuitEditor::clearSelection Editor.Events.nuitEditor::render Members &lt;static, readonly&gt; renderer :PIXI.Renderer Proxy variable for nuitDraw.renderer Type: PIXI.Renderer &lt;static, readonly&gt; totalLength :string Calculates the total length of the profile and returns a well-formated string Type: string Methods &lt;inner&gt; $onChanges(changes) This method is callend when the configuration or any other binding is changed. Parameters: Name Type Description changes object &lt;inner&gt; $onDestroy() This method is called when the component is being destroyed. &lt;inner&gt; $onInit() This method is called during the initialization of the component. &lt;inner&gt; $onInput($event) This event is fired whenever the body receives user input. Parameters: Name Type Description $event Object event data &lt;inner&gt; $onMouseWheel($event) This event is fired whenever the mouse wheel is trigger above the canvas. Parameters: Name Type Description $event Object event data &lt;inner&gt; $onPreRender() This method is called by the editor component before the actual rendering starts. &lt;inner&gt; $onResize() This event is fired whenever the window is being resized. &lt;inner&gt; center(shouldScale) Centers and refreshes the screen. Parameters: Name Type Description shouldScale Boolean true if the screen should adjust the scale to fit the whole segment in at the default zoom &lt;inner&gt; clear() Clears the drawing area and resets the camera position and the zoom factor to their default values. &lt;inner&gt; createCircle(isEnd) Creates a new circle container &amp; graphics and registers all events Parameters: Name Type Description isEnd bool Returns: circle Type PIXI.Container &lt;inner&gt; createMark() Creates a mark Returns: mark Type PIXI.Container &lt;inner&gt; createRootHitbox() Creates the root hitbox Returns: hitbox Type PIXI.Container &lt;inner&gt; drawArrow(rotation, gra) Draws an arrow based on the current scale multiplicator. A new PIXI.Graphics object will be generated if no one is proviced. Parameters: Name Type Description rotation gra Returns: Type * &lt;inner&gt; ensureSegments(count) Ensures that a given amount of visual segment is present in the virtual segments collection. Parameters: Name Type Description count Number the amount of visual segments &lt;inner&gt; hasSegments() Returns true if at least one segment is present in the current profile. Returns: Type Boolean &lt;inner&gt; highlightAngle(index) Highlightes the angle at the given index. Parameters: Name Type Description index type index of segment &lt;inner&gt; highlightSegment(index) Highlights (selects) the segment at the given index and prepares it for editing. Parameters: Name Type Description index Number index of segment &lt;inner&gt; initManager() Initializes the manager. &lt;inner&gt; initRenderContext() Resets the drawing surface and adds all necessary childs &lt;inner&gt; isAlignMode() Returns true if the align-segment mode is active. Returns: Type Boolean | value &lt;inner&gt; materialWidth() Returns the scaled material width. Returns: Type Number &lt;inner&gt; onAngleClicked(event, index) This event get executed whenever an angle has been focused Parameters: Name Type Description event * index number Index of the clicked event &lt;inner&gt; onCircleMeasureDragEnd() This event is fired whenever the user releases one end of the ruler. Should never be called manually! &lt;inner&gt; onCircleMeasureDragMove() This event is fired whenever the user drags one end of the ruler and moves the pointer. Should never be called manually! &lt;inner&gt; onCircleMeasureDragStart(event) This event is fire whenever the user clicks on one end of the user to initiate a drag event. Should never be called manually! Parameters: Name Type Description event Object contains the event data &lt;inner&gt; onSegmentClicked(event, data) This event is executed whenever a segment has been focused Parameters: Name Type Description event * data number Index of the clicked segment &lt;inner&gt; onSelectionClear() This event gets executed whenever a segment or angle has been unfocused &lt;inner&gt; polarProjection(angle, radius) Returns a new PIXI.Point with a location based on the radius and the specified angle. Example: An angle of PI / 4.0 (90°) and a radius of 4.0 yields [~2.828,~2.828] in cartesian coordinates. Parameters: Name Type Description angle Number direction of offset radius Number distance of offset Returns: Point (vector) containing the offset on both axes Type PIXI.Point &lt;inner&gt; refresh() Refreshes and rebuilds the scene and renders it to the screen afterwards. Returns: Type undefined &lt;inner&gt; refreshScale() Recalculates the scale multiplicator and marks the grid dirty. &lt;inner&gt; renderGrid() Renders the grid based on the current scale multiplicator. &lt;inner&gt; renderSegments() Renders the whole profile and all connected visuals like text, arrows and boxes. Returns: Type undefined &lt;inner&gt; rotate(value) Rotates the profile. Parameters: Name Type Description value Number rotation value &lt;inner&gt; setAligning(value) Activates or deactivates the align mode. Parameters: Name Type Description value bool Wether to activate or deactivate aligning &lt;inner&gt; setRuler(value) Enables or disables the ruler Parameters: Name Type Description value bool Wether to activate or deactivate the ruler &lt;inner&gt; setupConfig() Merges default config and given into vm.config &lt;inner&gt; setZoomFactor(value) Sets the user controlled zoom factor. Parameters: Name Type Description value Returns: Returns true if the scale has been refreshed. Type boolean &lt;inner&gt; snapToSegment(origin, distance) Snaps the given object to the closes segment within the given distance. Parameters: Name Type Description origin Object distance Number Returns: - true if snap was successful Type Boolean &lt;inner&gt; symbolInner() Returns the symbol for the inner measurement. TODO: Requires localization Returns: Type String &lt;inner&gt; symbolOuter() Returns the symbol for the outer measurement. TODO: Requires localization Returns: Type String &lt;inner&gt; toggleAligning() Toggles the state of the segment aligning mode. Returns: vm Type vm &lt;inner&gt; toggleRuler() Toggles the current state of the ruler and refreshes the screen. &lt;inner&gt; toggleVisibleSide() Toggles visible side &lt;inner&gt; unhighlightAll() Unhighlights all segments and angles &lt;inner&gt; zoom(value) Scales the whole screen up or down and centers it. If the value provided is smaller than zero it performs a zoom out. Parameters: Name Type Description value Number the zoom factor × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Controller.nuitDrawController.html\":{\"id\":\"Editor.Controller.nuitDrawController.html\",\"title\":\"Class: nuitDrawController\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitDrawController Editor.Controller. nuitDrawController Controller for nuitDrawComponent new nuitDrawController($scope, $log, $rootScope, nuitEditorEvents, nuitEditor, nuitProfile) Parameters: Name Type Description $scope object https://docs.angularjs.org/api/ng/service/$scope $log object https://docs.angularjs.org/api/ng/service/$log $rootScope object https://docs.angularjs.org/api/ng/service/$rootScope nuitEditorEvents object nuitEditorEvents nuitEditor object nuitEditorFactory nuitProfile object nuitProfileFactory Listens to Events: Editor.Events.nuitEditor::editorChanged Editor.Events.nuitEditor::render Members &lt;static&gt; currentEditor :string|object Wrapper for nuitEditor.currentEditor Type: string | object See: nuitEditor.currentEditor &lt;static&gt; element :* Contains the dom element for the view Type: * &lt;static&gt; fpsSyncTimeoutID :Timeout|null Contains the timeout for fps sync Type: Timeout | null &lt;static&gt; renderer :* Contains the PIXI.js renderer Type: * &lt;static&gt; resizeTimeoutID :Timeout|null Contains the timeout after each resize to prevent unnecessary resize actions Type: Timeout | null &lt;static&gt; root :* The PIXI.js root container Type: * &lt;inner, constant&gt; DEFAULT_CONFIG :object Contains the default configuration for the nuitDraw Component Type: object &lt;inner, constant&gt; RESIZE_TIMEOUT :number Contains the timeout in ms after the window resize event Type: number Default Value: 50 Methods &lt;static&gt; render() Renders the root container to the canvas &lt;inner&gt; $onChanges(changes) Component lifecycle-hook which gets automatically called whenever a parameters gets changed Parameters: Name Type Description changes object Further details about the changes See: AngularJS Component Lifecycles &lt;inner&gt; $onDestroy() Component lifecycle-hook which gets automatically called when the component gets destroyed. This method should be used to unregister all event handler which are listening on DOM elements or on $rootScope See: AngularJS Component Lifecycles &lt;inner&gt; $onInit() Component lifecycle-hook which gets automatically called when the component gets initiated. This method should be used to create all DOM depending objects and to add event listeners See: AngularJS Component Lifecycles &lt;inner&gt; createRenderer() Creates a new PIXI.JS renderer Returns: Type Renderer &lt;inner&gt; onEditorChange() Switches the view to the editor with the given id. &lt;inner&gt; onInput($event) This event is fired whenever the body receives user input. Parameters: Name Type Description $event Object event data &lt;inner&gt; onMouseWheel($event) This event is fired whenever the mouse wheel is triggered above the canvas. Parameters: Name Type Description $event Object event data &lt;inner&gt; onWindowResize() This event is fired whenever the window is being resized. &lt;inner&gt; render(force) Starts a new rendercycle Parameters: Name Type Description force bool Force an immediate render cycle &lt;inner&gt; renderCallback() Renders the root container to the canvas. &lt;inner&gt; setupConfig() Merge default config with given config × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Controller.nuitDrawStampingController.html\":{\"id\":\"Editor.Controller.nuitDrawStampingController.html\",\"title\":\"Class: nuitDrawStampingController\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitDrawStampingController Editor.Controller. nuitDrawStampingController Controller for nuitDrawStampingComponent new nuitDrawStampingController($scope, $rootScope, nuitEditor, nuitEditorEvents, nuitProfile) Parameters: Name Type Description $scope object https://docs.angularjs.org/api/ng/service/$scope $rootScope object https://docs.angularjs.org/api/ng/service/$rootScope nuitEditor object Editor.Services.nuitEditorFactory nuitEditorEvents object Editor.Constants.nuitEditorEvents nuitProfile object Editor.Services.nuitProfileFactory Listens to Events: Editor.Events.nuitEditor::render Methods &lt;inner&gt; $onDestroy() This method is called when the component is being destroyed. &lt;inner&gt; $onInit() This method is called during the initialization of the component. &lt;inner&gt; $onMouseWheel($event) This event is fired whenever the mouse wheel is triggered above the canvas. Parameters: Name Type Description $event Object event data &lt;inner&gt; $onPreRender() This method is called by the editor component before the actual rendering starts. &lt;inner&gt; $onResize() This event is fired whenever the canvas is being resized. Returns: Type undefined &lt;inner&gt; $onUse() This event is called whenever this editor becomes active. Returns: Type undefined &lt;inner&gt; initManager() Initializes the manager. &lt;inner&gt; setupConfig() Merges default config and given into vm.config × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Controller.nuitDrawTopController.html\":{\"id\":\"Editor.Controller.nuitDrawTopController.html\",\"title\":\"Class: nuitDrawTopController\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitDrawTopController Editor.Controller. nuitDrawTopController Controller for the nuitDrawTopComponent new nuitDrawTopController($scope, nuitEditor, nuitProfile, nuitEditorEvents) Parameters: Name Type Description $scope object https://docs.angularjs.org/api/ng/service/$scope nuitEditor object nuitEditor nuitProfile object nuitProfile nuitEditorEvents object Editor.Constants.nuitEditorEvents Listens to Events: Editor.Events.nuitEditor::segmentDepthChanged Members &lt;inner, constant&gt; DEFAULT_CONFIG :object Contains the default configuration for the nuitDrawTop Subeditor Type: object &lt;inner, constant&gt; ZOOM_TYPE :object Enum with all possible zoom types Type: object Properties: Name Type Default Description STRETCHED object s PROPORTIONAL object p Methods &lt;inner&gt; $onInit() Prepares the subeditor for further usage. This method will be automatically executed whenever the component is loaded See: AngularJS Component Lifecycles × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Controller.nuitEditorController.html\":{\"id\":\"Editor.Controller.nuitEditorController.html\",\"title\":\"Class: nuitEditorController\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitEditorController Editor.Controller. nuitEditorController Controller for nuitEditorComponent new nuitEditorController($window, $scope, $mdDialog, $mdMedia, $injector, nuitEditorEvents, nuitProfile, nuitEditor) Parameters: Name Type Description $window object https://docs.angularjs.org/api/ng/service/$window $scope object https://docs.angularjs.org/api/ng/service/$scope $mdDialog object https://docs.angularjs.org/api/ng/service/$mdDialog $mdMedia object https://docs.angularjs.org/api/ng/service/$mdMedia $injector object https://docs.angularjs.org/api/ng/service/$injector nuitEditorEvents object nuitEditorEvents nuitProfile object nuitProfileFactory nuitEditor object nuitEditorFactory Listens to Events: Editor.Events.nuitEditor::angleFocused Editor.Events.nuitEditor::clearSelection Editor.Events.nuitEditor::segmentAdded Editor.Events.nuitEditor::segmentAligned Editor.Events.nuitEditor::segmentFocused Editor.Events.nuitEditor::segmentRemoved Members &lt;inner, constant&gt; DEFAULT_CONFIG :object Contains default configuration for the nuitEditorComponent Type: object &lt;inner, constant&gt; ROTATION_CCLOCKWISE :number Rotation degrees counter clockwise. Used in 2d tools Type: number Default Value: -90 &lt;inner, constant&gt; ROTATION_CLOCKWISE :number Rotation degrees clockwise. Used in 2d tools Type: number Default Value: 90 &lt;inner, constant&gt; ZOOM_IN_FACTOR :number Default zoom-in-factor. Used in 2d tools Type: number Default Value: 1.1 &lt;inner, constant&gt; ZOOM_OUT_FACTOR :number Default zoom-out-factor. Used in 2d tools Type: number Default Value: -1.1 Methods &lt;inner&gt; $onDestroy() Resets the editor &lt;inner&gt; $onInit() Initializes this controller. &lt;inner&gt; clearErrors() Clears all stored errors from the error container array. &lt;inner&gt; historyBack() Undos the last action of the user. &lt;inner&gt; historyForward() Redos the last action of the user &lt;inner&gt; isView(view) Compares the given view with the current view. Reutrns true if they are equal. Parameters: Name Type Description view String string identifier of a view Returns: true if current view equals the provided one Type Boolean &lt;inner&gt; onAngleFocused(event, index) Event handler for highlighting an angle Parameters: Name Type Description event index &lt;inner&gt; onSegmentFocused(event, data) Event handler for highlighting a segment Parameters: Name Type Description event data &lt;inner&gt; onSelectionCleared() Event handler for clearing any selection &lt;inner&gt; refreshScope() Updates the scope to refresh bindings (e.g. sidebar) &lt;inner&gt; reset() Resets the whole editor back to its default state after loading. &lt;inner&gt; selectMaterial() If material dialog set, it will open it and apply the resolved variable Returns: Returns the new material if resolved Type Promise &lt;inner&gt; showNewProfileDialog() Displays the new profile confirmation dialog. × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Directives.html\":{\"id\":\"Editor.Directives.html\",\"title\":\"Namespace: Directives\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Namespace: Directives Editor. Directives Directives of editor Classes ngHoldDirective × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Directives.ngHoldDirective.html\":{\"id\":\"Editor.Directives.ngHoldDirective.html\",\"title\":\"Class: ngHoldDirective\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: ngHoldDirective Editor.Directives. ngHoldDirective Directive for repetitive triggering an event when mouse key is pressed new ngHoldDirective(ng-hold, ng-hold-interval [, ng-hold-done]) Parameters: Name Type Argument Description ng-hold function Callback which will be called on every interval tick ng-hold-interval string | number ng-hold-done function &lt;optional&gt; Callback which will be called when the interaction gets interrupted Requires: $timeout Example &lt;md-button type=&quot;button&quot; ng-hold=&quot;$scope.foo()&quot; ng-hold-interval=&quot;500:1, 150&quot; ng-hold-done=&quot;$scope.bar()&quot;&gt; Press me &lt;/md-button&gt; Requires $timeout × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Events.html\":{\"id\":\"Editor.Events.html\",\"title\":\"Namespace: Events\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Namespace: Events Editor. Events Events of editor Events nuitEditor::angleFocused An angle has been focused Parameters: Name Type Description index number Index of the focused angle Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitEditorController nuitEditor::clearSelection The selection has been cleared Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitEditorController nuitEditor::conicalBaseChanged The conical base has been changed Parameters: Name Type Description index number The index of the new conicalBase nuitEditor::editorChanged The view has been changed to another editor Parameters: Name Type Description id string Listeners of This Event: Editor.Controller.nuitDrawController nuitEditor::editorRegistered A new editor has been registered Parameters: Name Type Description id string nuitEditor::editorUnregistered An editor has been unregistered Parameters: Name Type Description id string nuitEditor::init The editor has been initialized nuitEditor::profileCleared The current profile has been deleted nuitEditor::profileLoaded A new profile has been loaded nuitEditor::render A new rendering has been requested Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitDrawController Editor.Controller.nuitDrawStampingController nuitEditor::rendered The editor has been rendered nuitEditor::reset The editor has been resetted nuitEditor::segmentAdded A new segment has been added Parameters: Name Type Description segment Segment Listeners of This Event: Editor.Controller.nuitEditorController nuitEditor::segmentAligned A segment has been aligned Parameters: Name Type Description eventData object Properties Name Type Description baseIndex number Index of the aligned segment Listeners of This Event: Editor.Controller.nuitEditorController nuitEditor::segmentAngleChanged A segment angle has been changed Parameters: Name Type Description eventData object Properties Name Type Description segment Segment The changed segment prevAngle number The previous angle of the segment nuitEditor::segmentBendingChanged Bending direction of a segment has been changed Parameters: Name Type Description object} eventData eventData.segment Segment The changed segment nuitEditor::segmentCloseChanged Close setting of a segment has been changed Parameters: Name Type Description segment Segment The changed segment nuitEditor::segmentConicalChanged Conical setting of a segment has been changed Parameters: Name Type Description segment Segment The changed segment nuitEditor::segmentFocused A segment has been focused Parameters: Name Type Description data object Event data Properties Name Type Description index number Index of the focused segment payload object Individual payload of the event caller Properties Name Type Description direction string Wether the front length or the back length has been focused Listeners of This Event: Editor.Controller.nuitDraw2dController Editor.Controller.nuitEditorController nuitEditor::segmentLengthChanged Segment length has been changed Parameters: Name Type Description eventData object Properties Name Type Description segment Segment The changed segment prevLength number Previous front length prevBackLength number Previous back length nuitEditor::segmentMeasureChanged Measure direction of a segment has been changed Parameters: Name Type Description eventData object Properties Name Type Description segment Segment The changed segment nuitEditor::segmentRemoved A segment has been removed Parameters: Name Type Description removed Segment segment Listeners of This Event: Editor.Controller.nuitEditorController × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Services.html\":{\"id\":\"Editor.Services.html\",\"title\":\"Namespace: Services\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Namespace: Services Editor. Services Services of editor Classes nuitEditorFactory nuitProfileFactory × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Services.nuitEditorFactory.html\":{\"id\":\"Editor.Services.nuitEditorFactory.html\",\"title\":\"Class: nuitEditorFactory\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitEditorFactory Editor.Services. nuitEditorFactory Service to control the nuitEditor new nuitEditorFactory($rootScope, $timeout, nuitEditorEvents, nuitProfile) Parameters: Name Type Description $rootScope object https://docs.angularjs.org/api/ng/service/$rootScope $timeout object https://docs.angularjs.org/api/ng/services/$timeout nuitEditorEvents object Editor.Constants.nuitEditorEvents nuitProfile object Editor.Services.nuitProfileFactory Members &lt;static&gt; currentEditor :string|object Returns the current editor object. Can be set with the id of another editor to change the current editor Type: string | object &lt;static&gt; defaultEditor :string Reads or sets the default editor. Must not be null Type: string &lt;static, readonly&gt; manager :object Contains the managerobject of the currently selected editor Type: object Methods &lt;inner&gt; clearProfile() Resets the current profile &lt;inner&gt; exportProfile() Retrieves all necessary data from the segments service and fetches them into a profile object Returns: The requested profile Type object &lt;inner&gt; generateLegacyProfile() Generates a new legacy profile for compatibility reasons. Deprecated: Yes Returns: Type Profile &lt;inner&gt; getCurrentEditorId() Returns the id of the current id Returns: editor id Type string &lt;inner&gt; getEditor(id) Gets the editor with given id Parameters: Name Type Description id string Id if the editor you want to get Throws: Throws an error if no editor with the given id exists Returns: editor or false if no active editor was found Type object | false &lt;inner&gt; getManager(id) Returns the manager of an editor Parameters: Name Type Argument Description id string &lt;nullable&gt; id of the editor whose manager you want. If null, the manager of the current editor will be returned Returns: Manager Type object &lt;inner&gt; hasEditor(id) A function to check if a specific editor is registered or not Parameters: Name Type Description id The id of your desired editor Returns: Type boolean &lt;inner&gt; importProfile(data) Loads a profile and injects it to the segments service Parameters: Name Type Description data object Profile which should by loaded &lt;inner&gt; init(config) Initializes a new editor environment and triggers INIT event Parameters: Name Type Description config Object Configuration Fires: nuitEditor::init &lt;inner&gt; listEditors() Returns an array with all currently registered editor IDs Returns: Type Array.&lt;string&gt; &lt;inner&gt; registerEditor(id, manager, scene) Registers a new editor Parameters: Name Type Description id string id manager Manager manager scene object scene Fires: nuitEditor::editorRegistered Throws: Throws an error if there is already an editor with the given id registered &lt;inner&gt; render() Demands a new render cycle Fires: nuitEditor::render &lt;inner&gt; reset() Resets the config Fires: nuitEditor::reset &lt;inner&gt; unregisterEditor(id) Unregisters an editor with the given id Parameters: Name Type Description id string Fires: nuitEditor::editorUnregistered Throws: Throws an error if no editor with given id exists &lt;inner&gt; useEditor(id) Makes the editor use the editor with given id Parameters: Name Type Description id String unique identifier of the editor Fires: nuitEditor::editorChanged Throws: Throws an error if no editor with given id exists × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Editor.Services.nuitProfileFactory.html\":{\"id\":\"Editor.Services.nuitProfileFactory.html\",\"title\":\"Class: nuitProfileFactory\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: nuitProfileFactory Editor.Services. nuitProfileFactory Manages all calculations of one or more segments new nuitProfileFactory($rootScope, nuitEditorEvents) Parameters: Name Type Description $rootScope object https://docs.angularjs.org/api/ng/service/$rootScope nuitEditorEvents object Editor.Constants.nuitEditorEvents Members &lt;inner, constant&gt; _history :Array Contains the history Type: Array &lt;inner, constant&gt; _holes :Array Contains all stamping holes. Type: Array &lt;inner, constant&gt; _intersections :Array Contains all intersection points. Type: Array &lt;inner, constant&gt; _segments :Array Contains all active and visible segments. Type: Array &lt;inner, constant&gt; bounds :Bounds Contains the bounds for this profile. Type: Bounds &lt;inner&gt; config :object Contains current config Type: object &lt;inner&gt; conicalBase :Number Contains the index of the center aligned segment when using conical segments Type: Number &lt;inner, constant&gt; DEFAULT_CONFIG :object Contains default configuration for the nuitProfileFactory Type: object &lt;inner&gt; depth :Number Contains the depth of the profile. Type: Number &lt;inner&gt; firstOffset :Object Contains the left and right offset of the conical editor. Type: Object &lt;inner&gt; historyPointer :number Points at the current history state. This is necessary for the historyForward feature Type: number &lt;inner&gt; ignoreHistory :boolean When true, any changes will not be saved in the history Type: boolean &lt;inner&gt; limits :object Contains the limit settings of the current config Type: object &lt;inner&gt; material :object Contains the currently selected material. Type: object &lt;inner, constant&gt; MEASURE :object Enum that differentiates between outside and inside of a segment. Type: object Properties: Name Type Default Description Outer object -1 Inner object 1 &lt;inner&gt; totalLength :Number Contains the total length of the segment chain. Type: Number &lt;inner&gt; visibleSide :Boolean Contains the visibile side of the segments. Type: Boolean Methods &lt;inner&gt; add(length, angle, index, bendingDir) Adds a new segment to the collection and returns it afterwards. Returns null if no valid segment could be created. Parameters: Name Type Description length Number the length of the segment in mm angle Number the relative bending angle of the segment in radiant (automatically clamped between [0..PI*2] index Number the index of the new segment bendingDir Number the bending dir of the segment (only needed for 0 and PI angle) Fires: Editor.Events.nuitEditor::segmentAdded Returns: Object &lt;inner&gt; addAngle(index, value) Adds the given value to the angle of the segment at the specified index. Parameters: Name Type Description index Number index of segment value Number value to add Fires: Editor.Events.nuitEditor::segmentAngleChanged &lt;inner&gt; addHistory({HISTORY, data) Adds a new state to the history Parameters: Name Type Description {HISTORY type data any &lt;inner&gt; addHole(x, y, tool) Creates a new hole on given position Parameters: Name Type Description x number y number tool object Returns: the generated hole Type object &lt;inner&gt; addHoles(holes) Adds the given holes to the holes collection. Parameters: Name Type Description holes Array array containing all the stamping holes &lt;inner&gt; addWrap(end, length) Adds a wrap to one of the profiles ends. Parameters: Name Type Description end Boolean true if the wrap should be add the end length Number the length of the wrap See: Editor.Services.nuitProfileFactory#add Returns: the new wrapped segment Type Segment &lt;inner&gt; align(index) Aligns the full profile clockwise so that the segment at the given index is positioned horizontally. Parameters: Name Type Description index Number index of segment Fires: nuitEditor::segmentAligned &lt;inner&gt; calculateBendingOffset(segment, bendingRadius) Calculates the bending offset of the given segment. Parameters: Name Type Description segment type bendingRadius Number &lt;inner&gt; calculateEnd(segment, thicknessOffset) Calculates the endpoint of the given segment. Parameters: Name Type Description segment Segment thicknessOffset Number &lt;inner&gt; calculateLengthOffset(segment, bendingRadius) Calculates the length offset of the given segment based on the bending radius caused by the material. Parameters: Name Type Description segment Segment bendingRadius Number &lt;inner&gt; calculateStart(segment) Calculates the starting point of the given segment. Parameters: Name Type Description segment Segment &lt;inner&gt; checkIntersections() Performs an intersection check through the whole segment chain and recalculates the bounds and the total length. &lt;inner&gt; clamp(value, min, max) Clamps the provided value between the given minimum and maximum. Parameters: Name Type Description value Number value to clamp min Number min value max Number max value Returns: min, if value is smaller than min or max, if value is greater than max or otherwise the value itself &lt;inner&gt; clear(keepMaterial, skipHistory) Removes and deletes all segment data. Parameters: Name Type Description keepMaterial Boolean skipHistory Boolean &lt;inner&gt; connect(first, second) Connects the two given segments. Parameters: Name Type Description first Segment previous segment second Segment next segment &lt;inner&gt; count() Returns the total amount of segments in the current profile. Returns: Type Number &lt;inner&gt; exportSegments() Generates exportable segment data. Returns: Type Array &lt;inner&gt; first() Returns the very first segment. Returns: segment at index 0 or null if no first segment exists Type Segment &lt;inner&gt; forceRefresh() Forces a full refresh. &lt;inner&gt; generateHoles(generators) Creates a line of holes Parameters: Name Type Description generators array &lt;inner&gt; get(index) Returns the segment at the given position in the segment chain. Parameters: Name Type Description index Number index of the requested segment Returns: segment at index or null if index is invalid Type Segment &lt;inner&gt; getAll() Returns the collection which contains all segments. READ-ONLY! Returns: Type Array.Segment &lt;inner&gt; getAngle(index) Returns the angle of the segment at the given index or 0 if the index is invalid. Parameters: Name Type Description index Number Returns: Type Number &lt;inner&gt; getBounds() Returns the bounds of this profile. Returns: Type Bounds &lt;inner&gt; getConicalBase() Returns the conical base. (???) Returns: Type Number &lt;inner&gt; getDepth() Returns the depth of the segments. Returns: Type Number &lt;inner&gt; getFirstOffset() Returns the first offset in mm for the left and right side of the conical editing. Returns: Type Object &lt;inner&gt; getFirstOffsetLeft() Returns the first offset in mm for the left side of the conical editing. Returns: Type Number | firstOffset.left &lt;inner&gt; getFirstOffsetRight() Returns the first offset in mm for the right side of the conical editing. Returns: Type Number | firstOffset.right &lt;inner&gt; getHoles() Returns all stamping holes. Returns: Type Array &lt;inner&gt; getIntersections() Returns all intersection points. Returns: Type Array &lt;inner&gt; getMaterial() Returns the currently assigned material. Returns: Type Material &lt;inner&gt; getThickness() Returns the thickness of the currently assigned material. Returns: Type Number &lt;inner&gt; getTotalLength() Returns the total length of the profile. Returns: Type Number &lt;inner&gt; getVisibleSide() Returns the visible side of the segment chain. Returns: Type Boolean &lt;inner&gt; hasIntersections() Returns true if the segments intersect somewhere. Returns: Type Boolean &lt;inner&gt; historyBack() A step back in the history Fires: Editor.Events.nuitEditor::render &lt;inner&gt; historyBackAvailable() Checks if history-back action is possible Returns: Type boolean &lt;inner&gt; historyForward() A step forward in the history Fires: Editor.Events.nuitEditor::render &lt;inner&gt; historyForwardAvailable() Checks if history-forward action is possible Returns: Type boolean &lt;inner&gt; importSegments(segArr) Imports all segments from the given array. Parameters: Name Type Description segArr Array Fires: Editor.Events.nuitEditor::profileLoaded &lt;inner&gt; intersection() Returns a point if the two given line segments cross each other or false if not. &lt;inner&gt; intersectsAny(x1, y1, x2, y2) Returns true if the given line intersects with any segment. Parameters: Name Type Description x1 type y1 type x2 type y2 type Returns: Null, if intersection was unsuccessful, collision point other wise Type Object &lt;inner&gt; isConical(index) Returns true if the segment at the given index is conical. Parameters: Name Type Description index Number index of requested segment Returns: true if segment at given index is conical, false otherwise Type Boolean &lt;inner&gt; isEmpty() Returns true if the segments collection is empty. Returns: Type Boolean &lt;inner&gt; isIndexValid(index) Returns true if the given index is valid and within the array length. Parameters: Name Type Description index Number index to test Returns: true if index is valid, false otherwise Type Boolean &lt;inner&gt; isWrap(index) Returns true if the segment at the given index is a wrapped segment. Parameters: Name Type Description index Number index of requested segment Returns: true if segment at given index is a wrapped one, false otherwise Type Boolean &lt;inner&gt; last() Returns the very last segment of the segment chain. Returns: last segment or null if no segment is present Type Segment &lt;inner&gt; loop(value, limit) Loops the given value so it is never lower than 0 or bigger than \'limit\'. Parameters: Name Type Description value Number the value to loop limit Number the limit Returns: looped value between [0..limit] Type Number &lt;inner&gt; refresh(currentIndex) Refreshes the segment at the given index and all segments that come afterwards by updating their start- and ending position, their index as well as their bending offset. Parameters: Name Type Description currentIndex number &lt;inner&gt; refreshOffset() Recalculates the front- and back-offset &lt;inner&gt; removeAt(index) Removes the segment at the given index from the segment chain and returns it. Returns null if no segment has been removed or the index was invalid. Parameters: Name Type Description index Number index of segment which should be removed Fires: Editor.Events.nuitEditor::segmentRemoved Returns: removed segment or null Type Segment &lt;inner&gt; resetStamping() Clears all existing stampings &lt;inner&gt; rotate(value) Rotates the whole profile by the given angle in radiant. Parameters: Name Type Description value Number rotation in radiant &lt;inner&gt; setAngle(index, angle) Sets the relative angle of the segment at the given index to the given value. Parameters: Name Type Description index Number index of segment angle Number new relative angle (between [0..PI*2], automatically looped) Fires: Editor.Events.nuitEditor::segmentAngleChanged &lt;inner&gt; setConfig(newConfig) Merges given config with the default config Parameters: Name Type Description newConfig object Returns: updatedConfig Type object &lt;inner&gt; setConicalBase(index) Sets the segment, which should be conical aligned Parameters: Name Type Description index Number &lt;inner&gt; setDepth(value) Sets the depth of the segments. Parameters: Name Type Description value type Fires: Editor.Events.nuitEditor::segmentDepthChanged Returns: Type undefined &lt;inner&gt; setLength(index, length, back) Sets the length of the segment at the given index to the given value. Parameters: Name Type Description index Number index of segment length Number new length of the segment back Number true, if the back length should be set Fires: Editor.Events.nuitEditor::segmentLengthChanged &lt;inner&gt; setMaterial(newMat) Assigns the given material to this profile and adjusts the bending positions. Parameters: Name Type Description newMat Material the new material &lt;inner&gt; setVisibleSide(value) Sets the visible side of the segment chain. Parameters: Name Type Description value Boolean &lt;inner&gt; toggleBending(index) Toggles the bending direction of the segment at the given index. Parameters: Name Type Description index Number index of segment Fires: Editor.Events.nuitEditor::segmentBendingChanged &lt;inner&gt; toggleClose(index) Toggles the closed state of the segment at the given index. Parameters: Name Type Description index Number index of segment &lt;inner&gt; toggleConical(index) Toggles the conical state of the segment at the given index. Parameters: Name Type Description index Number index of segment Fires: Editor.Events.nuitEditor::segmentConicalChanged &lt;inner&gt; toggleMeasure(index) Toggles the measure side of the segment at the given index. Parameters: Name Type Description index Number index of segment Fires: Editor.Events.nuitEditor::segmentMeasureChanged &lt;inner&gt; toggleVisibleSide() Toggles the visible side of the segment chain and returns the new state. Returns: Type Boolean × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Manager.html\":{\"id\":\"Manager.html\",\"title\":\"Class: Manager\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: Manager Manager new Manager() Manager class Methods &lt;abstract, static&gt; $onChanges() Callback which will be called when the config has changed &lt;abstract, static&gt; $onInput() Callback which will be called when the user has pressed any keys &lt;abstract, static&gt; $onMouseWheel() Callback which will be called when the mousewheel event has been triggered &lt;abstract, static&gt; $onPostRender() Callback which will be called after rendering has finished &lt;abstract, static&gt; $onPreRender() Callback which will be called before rendering starts &lt;abstract, static&gt; $onResize() Callback which will be called when the screen has been resized &lt;abstract, static&gt; $onUse() Callback which will be called when the current editor has been activated × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Point.html\":{\"id\":\"Point.html\",\"title\":\"Class: Point\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: Point Point new Point(x, y) Point class with coordinates representing a position in two-dimensional horizontally mirrored euclidean space. (Left: -x, Right: +x, Top: -y, Bottom: y+) Parameters: Name Type Description x Number position on the x-axis y Number position on the y-axis × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"},\"Segment.html\":{\"id\":\"Segment.html\",\"title\":\"Class: Segment\",\"body\":\" Documentation Namespaces EditorEditor.ComponentsEditor.ConstantsEditor.ControllerEditor.DirectivesEditor.EventsEditor.Services Classes BoundsEditor.Components.nuitDraw2dComponentEditor.Components.nuitDrawComponentEditor.Components.nuitDrawStampingComponentEditor.Components.nuitDrawTopComponentEditor.Components.nuitEditorComponentEditor.Controller.nuitDraw2dControllerEditor.Controller.nuitDrawControllerEditor.Controller.nuitDrawStampingControllerEditor.Controller.nuitDrawTopControllerEditor.Controller.nuitEditorControllerEditor.Directives.ngHoldDirectiveEditor.Services.nuitEditorFactoryEditor.Services.nuitProfileFactoryManagerPointSegment Events Editor.Events.nuitEditor::angleFocusedEditor.Events.nuitEditor::clearSelectionEditor.Events.nuitEditor::conicalBaseChangedEditor.Events.nuitEditor::editorChangedEditor.Events.nuitEditor::editorRegisteredEditor.Events.nuitEditor::editorUnregisteredEditor.Events.nuitEditor::initEditor.Events.nuitEditor::profileClearedEditor.Events.nuitEditor::profileLoadedEditor.Events.nuitEditor::renderEditor.Events.nuitEditor::renderedEditor.Events.nuitEditor::resetEditor.Events.nuitEditor::segmentAddedEditor.Events.nuitEditor::segmentAlignedEditor.Events.nuitEditor::segmentAngleChangedEditor.Events.nuitEditor::segmentBendingChangedEditor.Events.nuitEditor::segmentCloseChangedEditor.Events.nuitEditor::segmentConicalChangedEditor.Events.nuitEditor::segmentFocusedEditor.Events.nuitEditor::segmentLengthChangedEditor.Events.nuitEditor::segmentMeasureChangedEditor.Events.nuitEditor::segmentRemoved Global HISTORY Class: Segment Segment new Segment(length, angle, index) Segment class Parameters: Name Type Description length number length of the segment angle number angle offset to the previous segment or the x-axis if no previous segment exists index number position of the segment × Search results Close Documentation generated by JSDoc 3.5.5 on 2018-04-10T11:34:23+02:00 using the DocStrap template. \"}}\n</script><script type=\"text/javascript\">\n$(document).ready(function() {\n            Searcher.init();\n        });\n\n        $(window).on(\"message\", function(msg) {\n            var msgData = msg.originalEvent.data;\n\n            if (msgData.msgid != \"docstrap.quicksearch.start\") {\n                return;\n            }\n\n            var results = Searcher.search(msgData.searchTerms);\n\n            window.parent.postMessage({\"results\": results, \"msgid\": \"docstrap.quicksearch.done\"}, \"*\");\n        });\n</script></body></html>");
$templateCache.put("app/main/nuit-editor/test/nuit-editor.html","<!doctype html><html lang=\"en\" ng-app=\"nuit.editor\"><head><meta charset=\"UTF-8\"><meta name=\"viewport\" \ncontent=\"width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1,minimum-scale=1\"><meta \nhttp-equiv=\"X-UA-Compatible\" content=\"ie=edge\"><title>nuit-editor Component Example</title><link \nhref=\"https://fonts.googleapis.com/css?family=PT+Mono\" rel=\"stylesheet\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"bower_components/angular-material/angular-material.min.css\"><link type=\"text/css\" rel=\"stylesheet\" \nhref=\"../dist/nuit-editor.css\"><style>html {\n			overflow-y: initial !important;\n		}\n\n		body {\n			overflow: hidden;\n		}\n</style></head><body ng-controller=\"MainController as vm\"><nuit-editor editor-config=\"vm.config\"></nuit-editor><script \nsrc=\"bower_components/jquery/dist/jquery.min.js\"></script><script src=\"bower_components/angular/angular.js\"></script>\n<script src=\"bower_components/angular-animate/angular-animate.min.js\"></script><script \nsrc=\"bower_components/angular-aria/angular-aria.min.js\"></script><script \nsrc=\"bower_components/angular-messages/angular-messages.min.js\"></script><script \nsrc=\"bower_components/angular-material/angular-material.min.js\"></script><script src=\"../dist/nuit-editor.js\"></script>\n<script>\nangular.module(\'nuit.editor\')\n		.controller(\'MainController\', function () {\n			const vm = this;\n			const fontFamily = \'PT Mono\';\n			const fontSize = 16;\n\n			vm.config = {\n				editor: {\n					nuitDraw2d: {\n						style: {\n							rulerFont: fontFamily,\n							rulerFontSize: fontSize,\n							angleFont: fontFamily,\n							angleFontSize: fontSize,\n							segmentFont: fontFamily,\n							segmentFontSize: fontSize,\n\n							showCircles: true,\n							markStart: false\n						}\n					},\n					nuitDrawStampingRework: {\n						enabled: true\n					},\n					nuitDrawCutting: {\n						enabled: true\n					}\n				},\n				units: {\n					length: {\n						//decimals: 2,\n						decimals: 0,\n						//factor: 2.54,\n						factor: 1,\n						unit: \'mm\'\n					}\n				}\n			};\n		});\n</script></body></html>");
$templateCache.put("app/main/nuit-solution/components/nuit-solution-svg.html","<div layout=\"column\" layout-fill><div class=\"mb-20 mt-10 grey-100-bg\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.enableUi\"><div class=\"pl-10 pr-10\" flex=\"15\" layout=\"column\"><div layout=\"row\"><div \ntranslate=\"PRODUCTION_ORDERS.MIN_DISTANCE\"></div><span>:&nbsp;</span><div class=\"text-bold\">\n{{vm.solution.minDistance | nuitUnit:\'length\'}}</div></div><div layout=\"row\"><div \ntranslate=\"PRODUCTION_ORDERS.CUTTING_WASTE\"></div><span>:&nbsp;</span><div class=\"text-bold\">\n{{vm.solution.wastePercent.toLocaleString(vm.translate.use(), { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + \'%\'}}\n</div></div></div><div class=\"pl-10 pr-10 br bl\" flex=\"30\" layout=\"row\"><div layout=\"row\" layout-align=\"center center\">\n<div class=\"mr-10\" translate=\"PRODUCTION_ORDERS.FREEZE_SCALING\"></div><md-checkbox class=\"mt-16\" flex \nng-change=\"vm.loseContext()\" ng-model=\"vm.manualFreezeScaling\"></md-checkbox></div><div class=\"ml-10\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!vm.manualFreezeScaling\"><label class=\"mr-10\" flex \ntranslate=\"PRODUCTION_ORDERS.SOLUTION_SCALE\"></label><md-slider max=\"1\" min=\"{{vm.minLengthScaleFactor}}\" \nng-model=\"vm.sizeXPercent\" step=\"0.001\"></md-slider></div></div><div class=\"pl-10 pr-10\" flex=\"55\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.SHOW_LIMITED_JOBS\"></div><md-checkbox class=\"mt-16\" ng-model=\"vm.limitJobs\" \nng-change=\"vm.resize()\"></md-checkbox></div><div layout=\"row\" ng-if=\"vm.limitJobs\"><div class=\"mr-10\" layout=\"row\" \nlayout-align=\"center center\"><label class=\"mr-10\" translate=\"PRODUCTION_ORDERS.JOB_START\"></label><div layout=\"row\" \nlayout-align=\"center center\"><md-slider max=\"{{::vm.solution.jobs.length}}\" md-discrete min=\"1\" ng-model=\"vm.start\" \nng-change=\"vm.resize()\"></md-slider><input class=\"ml-10\" ng-model=\"vm.start\" style=\"max-width:50px\" \nng-change=\"vm.resize()\" type=\"number\"></div></div><div layout=\"row\" layout-align=\"center center\"><label class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.JOB_COUNT\"></label><div layout=\"row\" layout-align=\"center center\"><md-slider \nmax=\"{{::vm.solution.jobs.length}}\" md-discrete min=\"1\" ng-model=\"vm.count\" ng-change=\"vm.resize()\"></md-slider><input \nclass=\"ml-10\" ng-model=\"vm.count\" style=\"max-width:50px\" type=\"number\" ng-change=\"vm.resize()\"></div></div></div><div \nflex></div><md-button class=\"md-raised md-icon-button\" ng-click=\"vm.focus()\" \nng-disabled=\"vm.selectedJobIds.length!==1 && vm.selectedElementIds.length!==1\"><md-icon \nmd-font-icon=\"icon-magnify-minus\" ng-if=\"vm.limitJobs\"></md-icon><md-icon md-font-icon=\"icon-magnify-plus\" \nng-if=\"!vm.limitJobs\"></md-icon></md-button><md-button class=\"md-raised md-icon-button\" ng-click=\"vm.screenshot()\">\n<md-icon md-font-icon=\"icon-download\"></md-icon></md-button></div></div><div width=\"100%\" height=\"100%\" layout=\"row\" \nlayout-fill style=\"overflow-y: hidden\"><div flex id=\"svgRoot\" style=\"overflow-x: scroll;overflow-y: hidden\"><div \nng-if=\"vm.recalculating\" layout=\"column\" layout-fill layout-align=\"center center\"><div flex></div><md-progress-circular\n class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...</span><div flex></div></div><svg \nng-mousemove=\"vm.dragMove($event)\" ng-mousedown=\"vm.dragStart($event)\" ng-mouseup=\"vm.dragEnd($event)\" \nng-if=\"!vm.recalculating\" ng-attr-width=\"{{vm.length*vm.sizeXPercent+vm.conf.style.rulerSizeY}}\" \nng-attr-height=\"{{vm.height*vm.sizeYPercent+vm.conf.style.rulerSizeX}}\"><pattern id=\"diagonalHatch\" \npatternUnits=\"userSpaceOnUse\" width=\"20\" height=\"20\"><rect width=\"20\" height=\"20\" fill=\"#EEEEEE\"></rect><path \nd=\"M-5,5 l10,-10 M0,20 l20,-20 M15,25 l10,-10\" style=\"stroke:white; stroke-width:8\"/></pattern><pattern \npatternTransform=\"rotate(90)\" id=\"diagonalHatchReverse\" patternUnits=\"userSpaceOnUse\" width=\"20\" height=\"20\"><rect \nwidth=\"20\" height=\"20\" fill=\"#EEEEEE\"></rect><path d=\"M-5,5 l10,-10 M0,20 l20,-20 M15,25 l10,-10\" \nstyle=\"stroke:white; stroke-width:8\"/></pattern><svg ng-attr-x=\"{{vm.conf.style.rulerSizeY}}\" y=\"0\" \nng-attr-width=\"{{vm.length*vm.sizeXPercent}}\" ng-attr-height=\"{{vm.height*vm.sizeYPercent+vm.conf.style.rulerSizeX}}\">\n<svg ng-attr-width=\"{{vm.length*vm.sizeXPercent+\'px\'}}\" \nng-attr-height=\"{{(vm.height*vm.sizeYPercent+vm.conf.style.rulerSizeX)+\'px\'}}\"><svg \nng-repeat=\"job in vm.limitedJobs track by job.id\" ng-attr-x=\"{{vm.sizeXPercent*job.xOffset+\'px\'}}\"><svg \nng-attr-width=\"{{vm.sizeXPercent*job.length+\'px\'}}\" ng-attr-height=\"{{vm.conf.style.rulerSizeX+\'px\'}}\"><rect \nwidth=\"100%\" height=\"100%\" ng-attr-fill=\"{{::\'#\' + vm.conf.style.rulerBackgroundColor.toString(16)}}\"></rect></svg> \n<svg x=\"1px\" y=\"4px\" ng-attr-width=\"{{(vm.sizeXPercent*job.length-2)+\'px\'}}\" \nng-attr-height=\"{{(vm.conf.style.rulerSizeX-8)+\'px\'}}\"><rect width=\"100%\" height=\"100%\" \nng-attr-fill=\"{{\'#\' + (vm.selectedJobIds.indexOf(job.id)>=0?vm.conf.style.rulerForegroundSelectedColor.toString(16):vm.conf.style.rulerForegroundColor.toString(16))}}\" \nng-click=\"vm.selectJob(job.id,$event)\"></rect><text style=\"overflow: hidden;pointer-events: none;user-select: none\" \nng-if=\"vm.conf.style.showJobId\" ng-attr-x=\"{{vm.sizeXPercent*job.length*0.5+\'px\'}}\" \nng-attr-y=\"{{(vm.conf.style.fontSize*0.5+6)+\'px\'}}\" fill=\"black\" text-anchor=\"middle\" \nng-attr-font-size=\"{{vm.conf.style.fontSize + 1 + \'px\'}}\">{{vm.showText(job.name,vm.sizeXPercent*job.length-2)}}</text>\n<text style=\"overflow: hidden;pointer-events: none;user-select: none\" \nng-attr-x=\"{{vm.sizeXPercent*job.length*0.5+\'px\'}}\" \nng-attr-y=\"{{(vm.conf.style.rulerSizeX*0.5+vm.conf.style.fontSize*0.5+1)+\'px\'}}\" fill=\"black\" text-anchor=\"middle\" \nng-attr-font-size=\"{{vm.conf.style.fontSize + 1 + \'px\'}}\">\n{{vm.showText(vm.getConverted(job.length),vm.sizeXPercent*job.length-2)}}</text></svg> <svg \nng-attr-y=\"{{vm.conf.style.rulerSizeX+\'px\'}}\"><svg ng-repeat=\"slit in job.slits track by slit.id\" \nng-attr-y=\"{{vm.sizeYPercent*slit.yOffset+\'px\'}}\"><svg ng-repeat=\"element in slit.elements track by element.id\" \nng-attr-x=\"{{element.xOffset*vm.sizeXPercent+\'px\'}}\" y=\"0\"><rect dx=\"0\" dy=\"0\" \nng-attr-stroke=\"{{element.isWaste?\'grey\':\'black\'}}\" ng-attr-fill=\"{{vm.selectElementColor(element)}}\" \nng-attr-width=\"{{element.originalLength*vm.sizeXPercent+\'px\'}}\" \nng-attr-height=\"{{element.originalHeight*vm.sizeYPercent+\'px\'}}\" ng-click=\"vm.selectElement(element.id,$event)\" \nng-attr-data-id=\"{{element.id}}\"><title ng-if=\"vm.hasAdjustment(element)\">{{vm.adjustmentTitle(element)}}</title>\n</rect><g style=\"transform: rotate(-90deg)\"><text ng-attr-font-size=\"{{vm.conf.style.fontSize+\'px\'}}\" \nstyle=\"overflow: hidden;pointer-events: none;user-select: none\" \nng-if=\"!element.isWaste || vm.conf.style.showWasteSize\" \nng-attr-dx=\"{{-element.originalHeight*vm.sizeYPercent*0.5+\'px\'}}\" ng-attr-dy=\"{{vm.conf.style.fontSize+\'px\'}}\" \ntext-anchor=\"middle\">{{ vm.showText(vm.getConverted(element.originalHeight),element.originalHeight*vm.sizeYPercent) }}\n</text></g><text \nng-attr-font-size=\"{{vm.getMinRounded(element.originalHeight*vm.sizeYPercent-2,vm.conf.style.fontSize)+\'px\'}}\" \nstyle=\"overflow: hidden;pointer-events: none;user-select: none\" \nng-if=\"!element.isWaste || vm.conf.style.showWasteSize\" \nng-attr-dy=\"{{vm.getMinRounded(element.originalHeight*vm.sizeYPercent-2,vm.conf.style.fontSize)+\'px\'}}\" \nng-attr-dx=\"{{0.5*element.originalLength*vm.sizeXPercent+\'px\'}}\" dy=\"2px\" text-anchor=\"middle\">\n{{ vm.showText(vm.getConverted(element.originalLength),element.originalLength*vm.sizeXPercent) }}</text><text \nng-attr-font-size=\"{{vm.conf.style.fontSize+\'px\'}}\" style=\"overflow: hidden; pointer-events: none;user-select: none\" \nng-if=\"vm.hasChanged(element)\" ng-attr-dx=\"{{element.originalLength*vm.sizeXPercent-1+\'px\'}}\" \nng-attr-dy=\"{{element.originalHeight*vm.sizeYPercent-1-vm.conf.style.fontSize+\'px\'}}\" text-anchor=\"end\" \nalignment-baseline=\"baseline\">&#x270E</text><text ng-attr-font-size=\"{{vm.conf.style.fontSize+\'px\'}}\" \nstyle=\"overflow: hidden; pointer-events: none;user-select: none\" ng-if=\"vm.hasAdjustment(element)\" \nng-attr-dx=\"{{0.5*element.originalLength*vm.sizeXPercent+\'px\'}}\" ng-attr-dy=\"{{vm.conf.style.fontSize*2+2+\'px\'}}\" \ntext-anchor=\"middle\">&#x0394;{{vm.showText(vm.adjustmentLabel(element),element.originalLength*vm.sizeXPercent-14)}}\n</text><text \nng-attr-font-size=\"{{vm.getMinRounded(element.originalHeight*vm.sizeYPercent-2,vm.conf.style.fontSize)+\'px\'}}\" \nstyle=\"overflow: hidden; pointer-events: none;user-select: none\" \nng-if=\"!element.isWaste && vm.conf.style.showElementId && (!element.meta || !element.meta.part || !element.meta.part.complainOrderId)\" \nng-attr-dx=\"{{element.originalLength*vm.sizeXPercent-1+\'px\'}}\" \nng-attr-dy=\"{{element.originalHeight*vm.sizeYPercent-1+\'px\'}}\" text-anchor=\"end\">\n{{vm.showText(vm.elementLabel(element),element.originalLength*vm.sizeXPercent)}}</text><text \nng-attr-font-size=\"{{vm.conf.style.fontSize+\'px\'}}\" style=\"overflow: hidden; user-select: none\" \nng-if=\"!element.isWaste && vm.conf.style.showElementId && (element.meta && element.meta.part && element.meta.part.complainOrderId)\" \nng-attr-dx=\"{{element.originalLength*vm.sizeXPercent-1+\'px\'}}\" \nng-attr-dy=\"{{element.originalHeight*vm.sizeYPercent-1+\'px\'}}\" text-anchor=\"end\"><a style=\"cursor: pointer\" \nui-sref=\"{orderId: element.meta.part.complainOrderId, searchId: element.meta.part.complainPartId,active:\'profiles\'}\" \nng-click=\"vm.hide()\">\n{{vm.showText(vm.elementLabel(element) + \' &#10132; \' + vm.filter(\'translate\')(\'PRODUCTION_ORDERS.COMPLAINED_ORDER\') + \' \' + element.meta.part.complainOrderId, element.originalLength*vm.sizeXPercent)}}\n</a></text></svg></svg></svg></svg></svg></svg> <svg ng-attr-x=\"{{vm.scrollPosition+\'px\'}}\" \nng-attr-y=\"{{vm.conf.style.rulerSizeX+\'px\'}}\" ng-attr-width=\"{{vm.conf.style.rulerSizeY+100+\'px\'}}\" \nng-attr-height=\"{{vm.height*vm.sizeYPercent+\'px\'}}\"><rect \nng-attr-fill=\"{{\'#\' + vm.conf.style.rulerBackgroundColor.toString(16)}}\" \nng-attr-width=\"{{vm.conf.style.rulerSizeY+\'px\'}}\" ng-attr-height=\"{{vm.height*vm.sizeYPercent+\'px\'}}\"></rect><g \nstyle=\"transform: rotate(-90deg)\"><text text-anchor=\"middle\" style=\"pointer-events: none;user-select: none\" \nng-attr-font-size=\"{{vm.conf.style.fontSize + 1 + \'px\'}}\" \nng-attr-dy=\"{{(vm.conf.style.fontSize + vm.conf.style.rulerSizeY)*0.5+\'px\'}}\" \nng-attr-dx=\"{{-vm.height*vm.sizeYPercent*0.5+\'px\'}}\">{{vm.getConverted(vm.height)}}</text></g><svg ng-if=\"vm.newJob\" \nng-attr-x=\"{{vm.conf.style.rulerSizeY+\'px\'}}\" width=\"100px\" ng-attr-height=\"{{vm.height*vm.sizeYPercent+\'px\'}}\"><rect \nfill=\"white\" style=\"stroke:black; stroke-width:8\" width=\"100%\" height=\"100%\" data-job=\"new\"></rect><text \nng-attr-data-id=\"{{elementId}}\" ng-attr-dy=\"{{($index+1)*vm.config.style.fontSize}}\" text-anchor=\"middle\" \nng-repeat=\"elementId in vm.newJob.elements track by elementId\" x=\"50%\" width=\"100%\" height=\"100%\">\n{{vm.elementLabel(vm.elementsById[elementId])}}</text></svg></svg> <svg><rect style=\"opacity: 0.5\" \nng-attr-x=\"{{vm.conf.style.rulerSizeY+\'px\'}}\" \nng-attr-y=\"{{vm.conf.style.rulerSizeX+((vm.height-vm.solution.minDistance)*vm.sizeYPercent)+\'px\'}}\" \nng-attr-width=\"{{vm.length*vm.sizeXPercent}}\" width=\"100\" height=\"100\" \nng-attr-fill=\"{{::\'#\' + vm.conf.style.minDistanceColor.toString(16)}}\"></rect></svg> <svg style=\"pointer-events: none\" \nng-if=\"vm.draggedElements\" ng-attr-x=\"{{vm.dragPositionX}}\" ng-attr-y=\"{{vm.dragPositionY}}\" width=\"100px\" \nng-attr-height=\"{{vm.config.style.fontSize*vm.draggedElements.length+2+\'px\'}}\"><rect style=\"pointer-events: none\" \nng-attr-fill=\"{{\'#\'+vm.conf.style.solutionElementBackgroundSelectedColor.toString(16)}}\" width=\"100%\" height=\"100%\">\n</rect><text ng-attr-dy=\"{{($index+1)*vm.config.style.fontSize}}\" text-anchor=\"middle\" \nng-repeat=\"draggedElement in vm.draggedElements track by draggedElement.id\" x=\"50%\" width=\"100%\" height=\"100%\" \nstyle=\"pointer-events: none;user-select: none\">{{vm.elementLabel(draggedElement)}}</text></svg></svg></div></div><div \nng-if=\"vm.enableUi && !vm.enableTools && !vm.enableComplain\" style=\"height:63px\"></div><div \nclass=\"grey-100-bg mb-10 h-50\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.enableUi && vm.enableComplain\"><div \nclass=\"pl-10 pr-10 m-0\" layout=\"row\" layout-align=\"center center\"><md-button ng-disabled=\"!vm.canComplain()\" \nng-click=\"vm.complain()\" class=\"md-raised\" layout=\"row\" layout-align=\"center center\" aria-label=\"n\"><md-icon \nmd-font-icon=\"icon-exclamation\"></md-icon><label translate=\"PRODUCTION_ORDERS.COMPLAIN\" class=\"mr-10\"></label>\n</md-button><md-button ng-if=\"vm.firstSelectedElement.meta.part.complainOrderId\" class=\"md-raised\" \nui-sref=\"{orderId: vm.firstSelectedElement.meta.part.complainOrderId, searchId: vm.firstSelectedElement.meta.part.complainPartId,active:\'profiles\'}\" \nng-click=\"vm.hide()\"><label layout=\"row\" layout-align=\"center center\"><div class=\"mr-10\">\n{{vm.elementLabel(vm.firstSelectedElement) + \' &#10132;\' }}</div><div class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.COMPLAINED_ORDER\"></div><div>{{vm.firstSelectedElement.meta.part.complainOrderId}}</div>\n</label></md-button></div></div><div class=\"grey-100-bg mb-10\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.enableUi && vm.enableTools\"><div class=\"pl-10 pr-10\" flex=\"20\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"mr-10\" translate=\"PRODUCTION_ORDERS.SOLUTION_HEIGHT\"></div><input custom-update-on=\"default\" flex \nng-change=\"vm.resize()\" ng-model=\"vm.solution.height\" nuit-unit-input=\"length\" ng-disabled=\"vm.solution.fixedHeight\" \ntype=\"number\"></div><div class=\"pl-10 pr-10 bl br\" layout=\"row\" layout-align=\"start center\"><div class=\"mr-20\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"mr-10\" translate=\"PRODUCTION_ORDERS.LENGTH\"></div><input \ncustom-update-on=\"default\" flex ng-change=\"vm.touchedElement()\" \nng-disabled=\"!vm.firstSelectedElement || vm.firstSelectedElement.isWaste\" ng-model=\"vm.firstSelectedElement.length\" \nnuit-unit-input=\"length\" type=\"number\"></div><div layout=\"row\" layout-align=\"start center\"><div class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.WIDTH\"></div><input custom-update-on=\"default\" flex ng-change=\"vm.touchedElement()\" \nng-disabled=\"!vm.firstSelectedElement || vm.firstSelectedElement.isWaste\" ng-model=\"vm.firstSelectedElement.height\" \nnuit-unit-input=\"length\" type=\"number\"></div><div layout=\"row\" layout-align=\"start center\" layout-margin><div \ntranslate=\"PRODUCTION_ORDERS.MANUAL_WORK\"></div><md-checkbox flex ng-change=\"vm.touchedElement()\" \nng-disabled=\"!vm.firstSelectedElement || vm.firstSelectedElement.isWaste\" \nng-model=\"vm.firstSelectedElement.manualWork\"></md-checkbox></div><md-button aria-label=\"n\" \nclass=\"md-accent md-raised\" ng-click=\"vm.resetElement()\" \nng-disabled=\"!vm.firstSelectedElement || !vm.hasChanged(vm.firstSelectedElement)\"><span translate=\"APP.RESET\">Save\n</span></md-button></div><div class=\"pl-10 pr-10 br m-0\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.selectSimilar($event)\" ng-disabled=\"vm.firstSelectedElement===null\">\n<md-icon md-font-icon=\"icon-arrow-expand\"></md-icon></md-button><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.selectSimilar($event,\'globalX\')\" ng-disabled=\"vm.firstSelectedElement===null\"><md-icon \nmd-font-icon=\"icon-format-line-spacing\"></md-icon></md-button><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.selectSimilar($event, \'globalY\')\" ng-disabled=\"vm.firstSelectedElement===null\"><md-icon \nmd-font-icon=\"icon-format-line-spacing\" \nstyle=\"-ms-transform: rotate(90deg); -webkit-transform: rotate(90deg); transform: rotate(90deg)\"></md-icon></md-button>\n</div><div flex></div><div class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.prev()\" ng-disabled=\"!vm.canMoveJobs()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.next()\" ng-disabled=\"!vm.canMoveJobs()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div></div></div>");
$templateCache.put("app/main/nuit-solution/components/nuit-solution.html","<div layout=\"column\" layout-fill><div class=\"mb-20 mt-10 grey-100-bg\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.enableUi\"><div class=\"pl-10 pr-10\" flex=\"15\" layout=\"column\"><div layout=\"row\"><div \ntranslate=\"PRODUCTION_ORDERS.MIN_DISTANCE\"></div><span>:&nbsp;</span><div class=\"text-bold\">\n{{vm.solution.minDistance | nuitUnit:\'length\'}}</div></div><div layout=\"row\"><div \ntranslate=\"PRODUCTION_ORDERS.CUTTING_WASTE\"></div><span>:&nbsp;</span><div class=\"text-bold\">\n{{vm.solution.wastePercent.toLocaleString(vm.translate.use(), { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + \'%\'}}\n</div></div></div><div class=\"pl-10 pr-10 br bl\" flex=\"30\" layout=\"row\"><div layout=\"row\" layout-align=\"center center\">\n<div class=\"mr-10\" translate=\"PRODUCTION_ORDERS.FREEZE_SCALING\"></div><md-checkbox class=\"mt-16\" flex \nng-change=\"vm.redrawSolution()\" ng-model=\"vm.manualFreezeScaling\"></md-checkbox></div><div class=\"ml-10\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!vm.manualFreezeScaling\"><label class=\"mr-10\" flex \ntranslate=\"PRODUCTION_ORDERS.SOLUTION_SCALE\"></label><md-slider max=\"1\" min=\"{{vm.minLengthScaleFactor}}\" \nng-change=\"vm.redrawSolution()\" ng-model=\"vm.lengthScaleFactor\" step=\"0.01\"></md-slider></div></div><div \nclass=\"pl-10 pr-10\" flex=\"55\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"mr-10\" translate=\"PRODUCTION_ORDERS.SHOW_LIMITED_JOBS\"></div><md-checkbox class=\"mt-16\" \nng-change=\"vm.rescaleAndRedrawSolution()\" ng-model=\"vm.limitJobs\"></md-checkbox></div><div layout=\"row\" \nng-if=\"vm.limitJobs\"><div class=\"mr-10\" layout=\"row\" layout-align=\"center center\"><label class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.JOB_START\"></label><div layout=\"row\" layout-align=\"center center\"><md-slider \nmax=\"{{::vm.solution.jobs.length}}\" md-discrete min=\"1\" ng-change=\"vm.rescaleAndRedrawSolution()\" ng-model=\"vm.start\">\n</md-slider><input class=\"ml-10\" ng-change=\"vm.rescaleAndRedrawSolution()\" ng-model=\"vm.start\" style=\"max-width:50px\" \ntype=\"number\"></div></div><div layout=\"row\" layout-align=\"center center\"><label class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.JOB_COUNT\"></label><div layout=\"row\" layout-align=\"center center\"><md-slider \nmax=\"{{::vm.solution.jobs.length}}\" md-discrete min=\"1\" ng-change=\"vm.rescaleAndRedrawSolution()\" ng-model=\"vm.count\">\n</md-slider><input class=\"ml-10\" ng-change=\"vm.rescaleAndRedrawSolution()\" ng-model=\"vm.count\" style=\"max-width:50px\" \ntype=\"number\"></div></div></div><div flex></div><md-button class=\"md-raised md-icon-button\" ng-click=\"vm.focus()\" \nng-disabled=\"vm.jobButtons.selectedId<0 && vm.elementButtons.selectedId<0  && !vm.limitJobs\"><md-icon \nmd-font-icon=\"icon-magnify-minus\" ng-if=\"vm.limitJobs\"></md-icon><md-icon md-font-icon=\"icon-magnify-plus\" \nng-if=\"!vm.limitJobs\"></md-icon></md-button><md-button class=\"md-raised md-icon-button\" ng-click=\"vm.screenshot()\">\n<md-icon md-font-icon=\"icon-download\"></md-icon></md-button></div></div><div class=\"solutionContainer\" flex \nlayout=\"column\" layout-fill></div><div ng-if=\"vm.enableUi && !vm.enableTools\" style=\"height:63px\"></div><div \nclass=\"grey-100-bg mb-10\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.enableUi && vm.enableTools\"><div \nclass=\"pl-10 pr-10\" flex=\"20\" layout=\"row\" layout-align=\"start center\"><div class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.SOLUTION_HEIGHT\"></div><input custom-update-on=\"default\" flex \nng-change=\"vm.redrawSolution()\" ng-model=\"vm.solution.height\" nuit-unit-input=\"length\" \nng-disabled=\"vm.solution.fixedHeight\" type=\"number\"></div><div class=\"pl-10 pr-10 bl br\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"mr-20\" layout=\"row\" layout-align=\"start center\"><div class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.LENGTH\"></div><input custom-update-on=\"default\" flex ng-change=\"vm.touchedElement()\" \nng-disabled=\"vm.elementButtons.selectedData.isWaste\" ng-model=\"vm.elementButtons.selectedData.length\" \nnuit-unit-input=\"length\" type=\"number\"></div><div layout=\"row\" layout-align=\"start center\"><div class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.WIDTH\"></div><input custom-update-on=\"default\" flex ng-change=\"vm.touchedElement()\" \nng-disabled=\"vm.elementButtons.selectedData.isWaste\" ng-model=\"vm.elementButtons.selectedData.height\" \nnuit-unit-input=\"length\" type=\"number\"></div><div layout=\"row\" layout-align=\"start center\" layout-margin \nng-if=\"!vm.elementButtons.selectedData.isWaste\"><div translate=\"PRODUCTION_ORDERS.MANUAL_WORK\"></div><md-checkbox flex \nng-change=\"vm.touchedElement()\" ng-model=\"vm.elementButtons.selectedData.manualWork\"></md-checkbox></div><md-button \naria-label=\"n\" class=\"md-accent md-raised\" ng-click=\"vm.resetElement()\" \nng-disabled=\"!vm.hasChanged(vm.elementButtons.selectedData)\"><span translate=\"APP.RESET\">Save</span></md-button></div>\n<div class=\"pl-10 pr-10 br m-0\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.selectSimilar($event)\" ng-disabled=\"vm.elementButtons.selectedId===-1\"><md-icon \nmd-font-icon=\"icon-arrow-expand\"></md-icon></md-button><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.selectSimilar($event,\'globalX\')\" ng-disabled=\"vm.elementButtons.selectedId===-1\"><md-icon \nmd-font-icon=\"icon-format-line-spacing\"></md-icon></md-button><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.selectSimilar($event, \'globalY\')\" ng-disabled=\"vm.elementButtons.selectedId===-1\"><md-icon \nmd-font-icon=\"icon-format-line-spacing\" \nstyle=\"-ms-transform: rotate(90deg); -webkit-transform: rotate(90deg); transform: rotate(90deg)\"></md-icon></md-button>\n</div><div flex></div><div class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.prev()\" ng-disabled=\"!vm.canMoveJobs()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.next()\" ng-disabled=\"!vm.canMoveJobs()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div></div></div>");
$templateCache.put("app/main/orders.accounting/views/invoice-board.html","<md-content id=\"accounting\" class=\"page-layout simple tabbed\" flex ng-if=\"!vm.loading\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar\" class=\"icon\"></md-icon>\n</span><span class=\"logo-text\" translate=\"ACCOUNTING.INVOICE_BOARD_NAV\">Invoice boards</span></div></div><div \nclass=\"content-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding: 2px 10px\" flex=\"80\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\" class=\"mr-40\"><div layout=\"row\" class=\"pl-5\"><span translate=\"INVOICE.CALENDAR_WEEK\">KW\n</span> <span class=\"ph-5\">{{vm.calendarWeek}}</span></div><md-button class=\"md-icon-button arrow previous-button\" \nng-click=\"vm.previousWeek()\" aria-label=\"Previous\" style=\"margin-right: 0 !important\" translate \ntranslate-attr-aria-label=\"PLANNING.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"PLANNING.PREVIOUS\"></span></md-tooltip></md-button><md-button class=\"md-icon-button arrow next-button\" \nng-click=\"vm.showCurrentWeek()\" aria-label=\"Next\" ng-disabled=\"vm.loadToday\" \ntranslate-attr-aria-label=\"PLANNING.TODAY\" style=\"margin: 0 !important\"><md-icon md-font-icon=\"icon-calendar-today\">\n</md-icon><md-tooltip><span translate=\"PLANNING.TODAY\"></span></md-tooltip></md-button><md-button \nclass=\"md-icon-button arrow next-button\" ng-click=\"vm.nextWeek()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"PLANNING.NEXT\" style=\"margin-left: 0 !important\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon><md-tooltip><span translate=\"PLANNING.NEXT\"></span></md-tooltip></md-button><div class=\"planning-title\">\n{{ vm.planningTimeframe }}</div></div><div layout=\"row\" layout-align=\"start center\" class=\"text-bold p-5\"><div \nng-if=\"vm.currentCalendarWeek >= vm.calendarWeek\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"INVOICE.WEEK_SUM\"></span>: <span class=\"pl-5 pr-10\">{{vm.weekSumPaid | nuitCurrency}}</span><div \nclass=\"divider-vertical\"></div></div><div ng-if=\"vm.currentCalendarWeek <= vm.calendarWeek\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"pl-10\" translate=\"INVOICE.WEEK_SUM_UNPAID\"></span>: <span class=\"pl-5\">\n{{vm.weekSumUnpaid | nuitCurrency}}</span></div></div></div><div layout=\"row\" layout-align=\"end center\" flex \nng-if=\"vm.selectedItems && vm.selectedItems.length > 0\" class=\"mr-20\"><md-button style=\"margin: 4px !important\" \nclass=\"md-raised md-accent\" ng-click=\"vm.changeStatus(vm.selectedItems)\"><span translate=\"ACCOUNTING.CHANGE_STATUS\">\nUpdate status</span></md-button></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nng-if=\"vm.currentWeek && vm.currentWeek.length > 0\" class=\"planning-week\" ms-scroll><md-card layout=\"column\" \nng-repeat=\"day in vm.currentWeek\" class=\"planning-day\" ng-class=\"{\'current-day\': day.timestampMin === vm.currentDay}\">\n<md-card-header ng-class=\"{\'current-day-header\': day.timestampMin === vm.currentDay}\"><md-card-header-text><span \nclass=\"md-title text-center\">{{ day.translationKey | translate }}, {{ day.dateFormatted }}</span></md-card-header-text>\n</md-card-header><div class=\"grey-200-bg bt bb\" style=\"padding: 5px 8px 5px 8px\" \nng-class=\"{\'current-day-sums\': day.timestampMin === vm.currentDay}\"><div ng-if=\"day.timestampMin <= vm.currentDay\">\n<span translate=\"INVOICE.DAY_SUM\"></span>: <span>{{day.daySum | nuitCurrency}}</span></div><div \nng-if=\"day.timestampMin >= vm.currentDay\"><span translate=\"INVOICE.DAY_SUM_UNPAID\"></span>: <span \nng-class=\"{\'red-700-fg\': day.daySumUnpaid > 0 && day.timestampMin === vm.currentDay}\">\n{{day.daySumUnpaid | nuitCurrency}}</span></div></div><md-content ms-scroll \nstyle=\"background-color: transparent !important\"><md-card-content><div class=\"invoice-widget-container\"><ms-widget \nflippable=\"true\" ng-repeat=\"pe in day.invoices\" flex=\"100\" layout=\"row\" ng-attr-id=\"{{ pe.id }}\"><ms-widget-front \nclass=\"planning-event-entry front\" ng-class=\"pe.statusGroup.planningBgColor\" \nng-click=\"flipWidget();vm.flipWidget(pe);\"><div flex=\"100\" layout=\"row\"><md-checkbox class=\"no-label\" \nng-disabled=\"vm.disable.includes(pe.status)\" ng-checked=\"vm.isSelected(pe)\" \nng-click=\"$event.stopPropagation();vm.toggleEvent(pe)\" aria-label=\"{{ vm.isSelected(pe) ? \'Deselect\' : \'Select\' }}\">\n</md-checkbox><div layout=\"column\" layout-align=\"start start\" flex><div \nng-init=\"group = pe.paymentState.toLowerCase()\" ng-class=\"{\'{{group}}\': group === group}\" \nclass=\"p-5 mr-8 brad-2 pa-text\">{{pe.number}} - {{ \'INVOICE.\' + pe.paymentState | translate }}</div><div class=\"pv-5\" \nstyle=\"font-size: 1.2rem\" layout=\"column\"><div>{{ pe.company }}</div><div layout=\"row\" layout-wrap><div>\n{{pe.sumNetPrice | nuitCurrency}}</div><div ng-if=\"pe.paymentState === \'OVERDUE\'\"><span class=\"ph-5\">|</span> <span>\n{{pe.overdueDays}}</span> <span ng-if=\"pe.overdueDays !== 1\" translate=\"TIME.DAYS\"></span> <span \nng-if=\"pe.overdueDays === 1\" translate=\"CALENDAR.DAY\"></span></div><div ng-if=\"pe.remark.length > 0\"><span \nclass=\"ph-5\">-</span> {{\'INVOICE.REMARK_\' + pe.remark | translate}}</div></div></div></div><md-icon-button \nstyle=\"cursor: pointer\" class=\"m-0 p-0\" ng-click=\"$event.stopPropagation(); vm.openDetails(pe.id)\"><md-icon \nclass=\"m-0\" md-font-icon=\"icon-open-in-new\"></md-icon><md-tooltip><span translate=\"INVOICE.DETAILS\"></span>\n</md-tooltip></md-icon-button></div></ms-widget-front><ms-widget-back flex class=\"planning-event-entry\" \nng-class=\"pe.statusGroup.planningBgColor\" ng-click=\"flipWidget();vm.flipWidget(pe);\"><div layout=\"column\"><div \nlayout=\"row\" flex=\"100\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(pe)\" \nng-click=\"$event.stopPropagation();vm.toggleEvent(pe)\" aria-label=\"{{ vm.isSelected(pe) ? \'Deselect\' : \'Select\' }}\">\n</md-checkbox><div layout=\"column\" layout-align=\"start start\" flex><div \nng-init=\"group = pe.paymentState.toLowerCase()\" ng-class=\"{\'{{group}}\': group === group}\" \nclass=\"p-5 mr-8 brad-2 pa-text\">{{pe.number}} - {{ \'INVOICE.\' + pe.paymentState | translate }}</div></div>\n<md-icon-button style=\"cursor: pointer\" class=\"m-0 p-0\" ng-click=\"$event.stopPropagation(); vm.openDetails(pe.id)\">\n<md-icon class=\"m-0\" md-font-icon=\"icon-open-in-new\"></md-icon><md-tooltip><span translate=\"INVOICE.DETAILS\"></span>\n</md-tooltip></md-icon-button></div><div class=\"mt-10 ml-10\"><div>{{ pe.company}}</div><div>\n{{pe.sumNetPrice | nuitCurrency}}</div><md-divider class=\"mt-10 mb-5\"></md-divider><div ng-if=\"pe.remark.length > 0\">\n{{\'INVOICE.REMARK_\' + pe.remark | translate}}</div><div layout=\"row\"><span translate=\"INVOICE.DUE_DATE\"></span> <span>\n: {{ pe.dueDate | nuitDatetime: vm.config.localization.dateFormat }}</span><div ng-if=\"pe.paymentState === \'OVERDUE\'\">\n<span class=\"ph-5\">|</span> <span>{{pe.overdueDays}}</span> <span ng-if=\"pe.overdueDays !== 1\" translate=\"TIME.DAYS\">\n</span> <span ng-if=\"pe.overdueDays === 1\" translate=\"CALENDAR.DAY\"></span></div></div><div><span \ntranslate=\"INVOICE.DISCOUNT_DATE\"></span> <span>\n: {{ pe.discountDate | nuitDatetime: vm.config.localization.dateFormat }}</span></div></div></div></ms-widget-back>\n</ms-widget></div></md-card-content></md-content></md-card></div></md-content>");
$templateCache.put("app/main/orders.accounting/views/invoice-creation.html","<div id=\"accounting\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clipboard-check\" \nclass=\"icon\"></md-icon></span><span class=\"logo-text text-truncate\" translate=\"ACCOUNTING.INVOICE_CREATION_NAV\">Orders\n</span></div></div><div class=\"md-whiteframe-4dp search-wrapper\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-around center\" flex=\"60\"><div class=\"search\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"></div></div><div \nclass=\"md-blue-grey-50-bg md-whiteframe-4dp ph-10\" style=\"min-width: 200px; min-height: 75px\" layout=\"row\" \nlayout-align=\"space-around center\" flex><md-input-container flex><label class=\"blue-grey-700-fg\" \ntranslate=\"INVOICE.COMPANY\"></label><md-select ng-model=\"vm.company\" ng-change=\"vm.filterAll()\"><md-option \nng-value=\"null\" translate=\"APP.ALL\"></md-option><md-option ng-repeat=\"company in vm.companies track by company.id\" \nng-value=\"company\">{{company.name}}</md-option></md-select></md-input-container></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleSelectedOrders()\"></md-checkbox><div \nlayout=\"row\" ng-if=\"vm.getSelected().length > 0\" layout-align=\"start center\"><nuit-selection-indicator \nselection=\"vm.selection\" get-name=\"vm.getTitleById\"></nuit-selection-indicator><md-progress-circular \nclass=\"md-accent ml-10\" md-mode=\"indeterminate\" md-diameter=\"32\" ng-if=\"vm.ordersToProcess !== 0\">\n</md-progress-circular><md-button ng-click=\"vm.createInvoices()\" ng-if=\"vm.ordersToProcess === 0\" \nclass=\"md-default-theme md-ink-ripple md-whiteframe-2dp\"><span translate=\"ACCOUNTING.CREATE_INVOICE\"></span>\n</md-button></div></div><div layout=\"row\" layout-align=\"start center\"><nuit-pagination \nall-entities=\"vm.filteredEntities\" current-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" \nentities-per-page=\"10\" lacy-load-entity=\"vm.loadSalesDetails(entity)\"></nuit-pagination></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex><div \nng-if=\"vm.loadingItems\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\">Loading ...</span></div><div ng-if=\"vm.orders.length === 0 && !vm.loadingItems\" \nclass=\"no-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><span class=\"md-headline\" \ntranslate=\"ORDERS.NO_ORDERS\">There are no orders yet!</span></div><div class=\"thread unread\" \nng-if=\"!vm.loadingItems && !order.invoiceId\" ng-repeat=\"order in vm.currentPageEntities track by order.id\" \nng-class=\"{\'selected\': vm.isSelected(order.id)}\" ng-click=\"vm.openDetails(order.id)\"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(order.id)\" \nng-disabled=\"vm.checkCheckbox(order.id)\" ng-click=\"vm.toggleSelectOrder(order.id, $event)\" \naria-label=\"{{vm.isSelected(order.id) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div class=\"info\" layout=\"column\" flex>\n<span class=\"name text-truncate\">{{vm.getTitle(order)}}</span><div class=\"message text-truncate\">\n{{ order.ordered_on | nuitDatetime: \'datetime\' }}</div></div><div class=\"labels\" flex=\"nogrow\" layout=\"row\" \nlayout-align=\"end start\" layout-wrap><div ng-show=\"order.origin_user\"><md-icon md-font-icon=\"icon-account-location\">\n<md-tooltip><span translate=\"ORDERS.ORDERED_BY_ORIGIN_USER\"></span></md-tooltip></md-icon></div><div \nclass=\"label white-text text-truncate\" \nng-init=\" color1 = vm.getStatusById(order.status).color; bgColor = color1.replace(\'fg\',\'bg\')\" ng-class=\"bgColor\">\n{{ vm.getStatusById(order.status).name | nuitTranslate}}</div></div></div></div></md-content></div></div></div></div>");
$templateCache.put("app/main/orders.accounting/views/invoices.html","<div id=\"accounting\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div layout=\"row\" class=\"header\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-cash-multiple\" class=\"icon\"></md-icon></span><span class=\"logo-text text-truncate\" \ntranslate=\"ACCOUNTING.INVOICES_NAV\">Orders</span></div><div></div></div><div class=\"search-wrapper md-whiteframe-4dp\" \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"></div><div \nstyle=\"max-width: 420px; min-width: 350px; min-height: 75px\" class=\"md-whiteframe-2dp m-0 p-0 md-blue-grey-50-bg\" \nlayout=\"row\" flex layout-align=\"space-around center\"><md-input-container><label class=\"blue-grey-700-fg\" \ntranslate=\"CALENDAR.YEAR\"></label><md-select ng-model=\"vm.selectedYear\" ng-change=\"vm.reloadInvoices()\"><md-option \nng-repeat=\"year in vm.years\" ng-value=\"year\">{{year}}</md-option></md-select></md-input-container><md-input-container>\n<label class=\"blue-grey-700-fg\" translate=\"CALENDAR.MONTH\"></label><md-select ng-model=\"vm.selectedMonth\" \nng-change=\"vm.reloadInvoices()\"><md-option ng-repeat=\"month in vm.months track by month.value\" ng-value=\"month.value\" \ntranslate=\"{{month.translation}}\"></md-option></md-select></md-input-container><md-input-container><label \nclass=\"blue-grey-700-fg\" translate=\"INVOICE.STATIS\"></label><md-select ng-model=\"vm.selectedStatus\" \nng-change=\"vm.reloadInvoices()\"><md-option ng-value=\"vm.ALL_STATUS.id\" translate=\"INVOICE.STATUS_ALL\"></md-option>\n<md-option ng-repeat=\"status in vm.statis track by status.id\" ng-value=\"status.id\" \nng-if=\"vm.config.ims.accounting.disabledStatis.indexOf(status.id)===-1 \">\n{{(\"INVOICE.STATUS_\" + status.type | uppercase) | translate}}</md-option></md-select></md-input-container><md-menu \nmd-position-mode=\"target-right target\" md-offset=\"-10 0\" style=\"margin-top: -8px\" \nng-if=\"vm.downloadOptions.length !== 0\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Open Download Menu\" style=\"margin: 0 !important\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"item in vm.downloadOptions\"><md-button \nng-href=\"{{vm.downloadInvoices(item.format)}}\" target=\"_blank\"><div layout=\"row\" flex><p flex>\n{{item.name | nuitTranslate}}</p><md-icon md-menu-align-target md-font-icon=\"icon-download\"></md-icon></div>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-card\" layout=\"column\" flex><div \nstyle=\"padding-left: 12px\" class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleSelectedInvoices()\"></md-checkbox><div\n layout=\"row\" ng-if=\"vm.getSelected().length > 0\" layout-align=\"center center\"><md-progress-circular \nclass=\"md-accent ml-10\" md-mode=\"indeterminate\" md-diameter=\"32\" ng-if=\"vm.invoicesToProcess !== 0\">\n</md-progress-circular><nuit-selection-indicator selection=\"vm.selection\" get-name=\"vm.getName\">\n</nuit-selection-indicator><md-button ng-click=\"vm.changeStatus(vm.getSelected())\" \nng-if=\"vm.canChangeStatus() && vm.invoicesToProcess === 0\" class=\"md-default-theme md-ink-ripple md-whiteframe-2dp\">\n<span translate=\"ACCOUNTING.CHANGE_STATUS\"></span></md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" \nentities-per-page=\"vm.config.ims.accounting.list.entitiesPerPage\"></nuit-pagination></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content\" ms-scroll flex><div ng-if=\"vm.loading\" \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\">Loading ...</span></div><div ng-if=\"vm.invoices.length === 0 && !vm.loading\" \nclass=\"no-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><span class=\"md-headline\" \ntranslate=\"INVOICES.NO_INVOICES\">There are no orders yet!</span></div><table \nng-if=\"!vm.loading && vm.invoices.length > 0\" class=\"table-scroll\"><thead><tr class=\"bb pv-10 pl-60 pr-24\"><th></th><th\n class=\"number\"><button ng-click=\"vm.orderBy(\'id\')\" layout=\"row\" layout-align=\"start center\"><span class=\"text-center\" \ntranslate=\"INVOICE.NUMBER\"></span> <span ng-if=\"vm.selectedOrderBy !== \'id\'\" style=\"width: 17px\"></span><md-icon \nng-show=\"vm.selectedOrderBy===\'id\' && vm.reverse\" md-font-icon=\"icon-sort-descending\"></md-icon><md-icon \nng-show=\"vm.selectedOrderBy===\'id\' && !vm.reverse\" md-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th \nclass=\"date-cell\"><button ng-click=\"vm.orderBy(\'createdAt\')\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-center\" translate=\"INVOICE.CREATED_AT\"></span> <span ng-if=\"vm.selectedOrderBy !== \'createdAt\'\" \nstyle=\"width: 17px\"></span><md-icon ng-show=\"vm.selectedOrderBy===\'createdAt\' && vm.reverse\" \nmd-font-icon=\"icon-sort-descending\"></md-icon><md-icon ng-show=\"vm.selectedOrderBy===\'createdAt\' && !vm.reverse\" \nmd-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th class=\"date-cell\"><button \nng-click=\"vm.orderBy(\'dueDate\')\" layout=\"row\" layout-align=\"start center\"><span class=\"text-center\" \ntranslate=\"INVOICE.DUE_DATE\"></span> <span ng-if=\"vm.selectedOrderBy !== \'dueDate\'\" style=\"width: 17px\"></span><md-icon\n ng-show=\"vm.selectedOrderBy===\'dueDate\' && vm.reverse\" md-font-icon=\"icon-sort-descending\"></md-icon><md-icon \nng-show=\"vm.selectedOrderBy===\'dueDate\' && !vm.reverse\" md-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th \nclass=\"status\"><button ng-click=\"vm.orderBy(\'status\')\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-center\" translate=\"INVOICE.STATUS\"></span> <span ng-if=\"vm.selectedOrderBy !== \'status\'\" \nstyle=\"width: 17px\"></span><md-icon ng-show=\"vm.selectedOrderBy===\'status\' && vm.reverse\" \nmd-font-icon=\"icon-sort-descending\"></md-icon><md-icon ng-show=\"vm.selectedOrderBy===\'status\' && !vm.reverse\" \nmd-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th class=\"text-cell\"><button \nng-click=\"vm.orderBy(\'company.name\')\" layout=\"row\" layout-align=\"start center\"><span class=\"text-center pr-5\" \ntranslate=\"INVOICE.COMPANY\"></span> <span ng-if=\"vm.selectedOrderBy !== \'company.name\'\" style=\"width: 17px\"></span>\n<md-icon ng-show=\"vm.selectedOrderBy===\'company.name\' && vm.reverse\" md-font-icon=\"icon-sort-descending\"></md-icon>\n<md-icon ng-show=\"vm.selectedOrderBy===\'company.name\' && !vm.reverse\" md-font-icon=\"icon-sort-ascending\"></md-icon>\n</button></th><th class=\"text-right number-cell\"><span class=\"grey-600-fg text-right\" translate=\"ORDERS.SALES.PRICE\">\n</span></th><th class=\"text-right number-cell\"><span class=\"grey-600-fg text-right\" \ntranslate=\"ORDERS.SALES.LOGISTICPRICE\"></span></th><th class=\"text-right number-cell\" \nng-if=\"vm.config.ims.accounting.list.showOrderFee\"><span class=\"grey-600-fg text-right\" \ntranslate=\"ORDERS.SALES.ORDERFEE\"></span></th><th class=\"text-right number-cell\"><span class=\"grey-600-fg text-right\" \ntranslate=\"ORDERS.SALES.NETPRICE\"></span></th><th class=\"text-right number-cell\"><span class=\"grey-600-fg text-right\" \ntranslate=\"ORDERS.SALES.GROSSPRICE\"></span></th><th class=\"text-right vatpercent\"><span class=\"grey-600-fg text-right\" \ntranslate=\"ORDERS.SALES.VATPERCENT\"></span></th></tr></thead><tbody><tr \nng-repeat=\"invoice in vm.currentPageEntities track by invoice.id\" ng-class=\"{\'selected\': vm.isSelected(invoice)}\" \nng-click=\"vm.openDetails(invoice.id)\"><td><md-checkbox class=\"no-label\" \nng-disabled=\"vm.disable.includes(invoice.status)\" ng-checked=\"vm.isSelected(invoice)\" \nng-click=\"vm.toggleSelectInvoice(invoice, $event)\" aria-label=\"{{vm.isSelected(invoice) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox></td><td class=\"number\"><span class=\"pr-15\">{{invoice.number}}</span></td><td class=\"date-cell\"><span \nclass=\"text-center\">{{invoice.createdAt | nuitDatetime: \'date\'}}</span></td><td class=\"date-cell\"><span \nclass=\"text-center\">{{invoice.dueDate | nuitDatetime: \'date\'}}</span></td><td class=\"status\"><div \nng-repeat=\"status in vm.statis track by status.id\"><span ng-if=\"invoice.status === status.id\">\n{{(\"INVOICE.STATUS_\" + status.type | uppercase) | translate}}</span></div></td><td class=\"text-cell\"><div \nclass=\"text-left company-cell\">{{invoice.company.name}}</div></td><td class=\"currency number-cell\"><span \nclass=\"text-right\">{{invoice.sumPrice | nuitCurrency}}</span></td><td class=\"currency number-cell\"><span \nclass=\"text-right\">{{invoice.sumLogisticPrice | nuitCurrency}}</span></td><td class=\"currency number-cell\" \nng-if=\"vm.config.ims.accounting.list.showOrderFee\"><span class=\"text-right\">{{invoice.sumOrderFee | nuitCurrency}}\n</span></td><td class=\"currency number-cell\"><span class=\"text-right\">{{invoice.sumNetPrice | nuitCurrency}}</span>\n</td><td class=\"currency number-cell\"><span class=\"text-right\">{{invoice.sumGrossPrice | nuitCurrency}}</span></td><td \nclass=\"vatpercent\"><span class=\"text-right\" ng-if=\"invoice.vatPercents.length===1\">{{invoice.vatPercents[0] + \"%\"}}\n</span> <span class=\"text-right\" ng-if=\"invoice.vatPercents.length!==1\">-</span></td></tr></tbody><tfoot><tr \nclass=\"blue-grey-50-bg total-row\"><td colspan=\"5\"></td><td class=\"currency text-right number-cell\"><span>\n{{vm.sumOf(\'sumPrice\') | nuitCurrency}}</span></td><td class=\"currency text-right number-cell\"><span>\n{{vm.sumOf(\'sumLogisticPrice\') | nuitCurrency}}</span></td><td class=\"currency text-right number-cell\" \nng-if=\"vm.config.ims.accounting.list.showOrderFee\"><span>{{vm.sumOf(\'sumOrderFee\') | nuitCurrency}}</span></td><td \nclass=\"currency text-right number-cell\">{{vm.sumOf(\'sumNetPrice\') | nuitCurrency}}</td><td \nclass=\"currency text-right number-cell\">{{vm.sumOf(\'sumGrossPrice\') | nuitCurrency}}</td><td \nclass=\"currency text-right\"></td></tr></tfoot></table></md-content></div></div></div></div>");
$templateCache.put("app/main/orders.credit/views/credits.html","<div id=\"credit\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div layout=\"row\" class=\"header\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-cash-multiple\" class=\"icon\"></md-icon></span><span class=\"logo-text text-truncate\" \ntranslate=\"CREDIT.CREDITS_NAV\">Credits</span></div><div></div></div><div class=\"search-wrapper md-whiteframe-4dp\" \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"></div><div \nstyle=\"max-width: 420px; min-width: 350px; min-height: 75px\" class=\"md-whiteframe-2dp m-0 p-0 md-blue-grey-50-bg\" \nlayout=\"row\" flex layout-align=\"space-around center\"><md-input-container><label class=\"blue-grey-700-fg\" \ntranslate=\"CALENDAR.YEAR\"></label><md-select ng-model=\"vm.selectedYear\" ng-change=\"vm.reloadCredits()\"><md-option \nng-repeat=\"year in vm.years\" ng-value=\"year\">{{year}}</md-option></md-select></md-input-container><md-input-container>\n<label class=\"blue-grey-700-fg\" translate=\"CALENDAR.MONTH\"></label><md-select ng-model=\"vm.selectedMonth\" \nng-change=\"vm.reloadCredits()\"><md-option ng-repeat=\"month in vm.months track by month.value\" ng-value=\"month.value\" \ntranslate=\"{{month.translation}}\"></md-option></md-select></md-input-container><md-input-container><label \nclass=\"blue-grey-700-fg\" translate=\"INVOICE.STATIS\"></label><md-select ng-model=\"vm.selectedStatus\" \nng-change=\"vm.reloadCredits()\"><md-option ng-value=\"vm.ALL_STATUS.id\" translate=\"INVOICE.STATUS_ALL\"></md-option>\n<md-option ng-repeat=\"status in vm.statis track by status.id\" ng-value=\"status.id\">\n{{(\"CREDIT.STATUS_\" + status.type | uppercase) | translate}}</md-option></md-select></md-input-container></div></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" ng-checked=\"vm.getSelected().length > 0\" \nng-click=\"vm.toggleSelectedCredits()\"></md-checkbox><div layout=\"row\" ng-if=\"vm.getSelected().length === 1\">\n<md-progress-circular class=\"md-accent ml-10\" md-mode=\"indeterminate\" md-diameter=\"32\" \nng-if=\"vm.creditsToProcess !== 0\"></md-progress-circular><md-button ng-click=\"vm.changeStatus(vm.getSelected())\" \nng-if=\"vm.creditsToProcess === 0\" class=\"md-default-theme md-ink-ripple md-whiteframe-2dp\"><span \ntranslate=\"CREDIT.UPDATE_CREDIT\"></span></md-button></div></div><div layout=\"row\" layout-align=\"start center\">\n<nuit-pagination all-entities=\"vm.filteredEntities\" current-page-entities=\"vm.currentPageEntities\" \ncurrent-page=\"vm.currentPage\" entities-per-page=\"vm.config.ims.credit.list.entitiesPerPage\"></nuit-pagination></div>\n</div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content\" ms-scroll flex><div \nng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\">Loading ...</span></div><div ng-if=\"vm.credits.length === 0 && !vm.loading\" \nclass=\"no-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><span class=\"md-headline\" \ntranslate=\"CREDITS.NO_CREDITS\">There are no credits yet!</span></div><table \nng-if=\"!vm.loading && vm.credits.length > 0\" class=\"table-scroll\"><thead><tr class=\"bb pv-10 pl-60 pr-24\"><th></th><th \nclass=\"number\"><button ng-click=\"vm.orderBy(\'id\')\" layout=\"row\" layout-align=\"start center\"><span class=\"text-center\" \ntranslate=\"INVOICE.NUMBER\"></span> <span ng-if=\"vm.selectedOrderBy !== \'id\'\" style=\"width: 17px\"></span><md-icon \nng-show=\"vm.selectedOrderBy===\'id\' && vm.reverse\" md-font-icon=\"icon-sort-descending\"></md-icon><md-icon \nng-show=\"vm.selectedOrderBy===\'id\' && !vm.reverse\" md-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th \nclass=\"date-cell\"><button ng-click=\"vm.orderBy(\'createdAt\')\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-center\" translate=\"INVOICE.CREATED_AT\"></span> <span ng-if=\"vm.selectedOrderBy !== \'createdAt\'\" \nstyle=\"width: 17px\"></span><md-icon ng-show=\"vm.selectedOrderBy===\'createdAt\' && vm.reverse\" \nmd-font-icon=\"icon-sort-descending\"></md-icon><md-icon ng-show=\"vm.selectedOrderBy===\'createdAt\' && !vm.reverse\" \nmd-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th class=\"status\"><button ng-click=\"vm.orderBy(\'status\')\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"text-center\" translate=\"INVOICE.STATUS\"></span> <span \nng-if=\"vm.selectedOrderBy !== \'status\'\" style=\"width: 17px\"></span><md-icon \nng-show=\"vm.selectedOrderBy===\'status\' && vm.reverse\" md-font-icon=\"icon-sort-descending\"></md-icon><md-icon \nng-show=\"vm.selectedOrderBy===\'status\' && !vm.reverse\" md-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th \nclass=\"text-cell\"><button ng-click=\"vm.orderBy(\'company.name\')\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-center pr-5\" translate=\"INVOICE.COMPANY\"></span> <span ng-if=\"vm.selectedOrderBy !== \'company.name\'\" \nstyle=\"width: 17px\"></span><md-icon ng-show=\"vm.selectedOrderBy===\'company.name\' && vm.reverse\" \nmd-font-icon=\"icon-sort-descending\"></md-icon><md-icon ng-show=\"vm.selectedOrderBy===\'company.name\' && !vm.reverse\" \nmd-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th class=\"text-right number-cell\"><span \nclass=\"grey-600-fg text-right\" translate=\"CREDIT.TOTAL_AMOUNT\"></span></th><th class=\"text-right number-cell\"><span \nclass=\"grey-600-fg text-right\" translate=\"CREDIT.SUM_REDEEMED\"></span></th><th class=\"text-right number-cell\"><span \nclass=\"grey-600-fg text-right\" translate=\"CREDIT.SUM_OPEN\"></span></th></tr></thead><tbody><tr \nng-repeat=\"credit in vm.currentPageEntities track by credit.id\" ng-class=\"{\'selected\': vm.isSelected(credit)}\" \nng-click=\"vm.openDetails(credit)\"><td><md-checkbox class=\"no-label\" ng-disabled=\"vm.disable.includes(credit.status)\" \nng-checked=\"vm.isSelected(credit)\" ng-click=\"vm.toggleSelectCredit(credit, $event)\" \naria-label=\"{{vm.isSelected(credit) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></td><td class=\"number\"><span \nclass=\"pr-15\">{{credit.number}}</span></td><td class=\"date-cell\"><span class=\"text-center\">\n{{credit.createdAt | nuitDatetime: \'date\'}}</span></td><td class=\"status\"><div \nng-repeat=\"status in vm.statis track by status.id\"><span ng-if=\"credit.status === status.id\">\n{{(\"CREDIT.STATUS_\" + status.type | uppercase) | translate}}</span></div></td><td class=\"text-cell\"><div \nclass=\"text-left company-cell\">{{vm.getCompanyName(credit.companyId)}}</div></td><td class=\"currency number-cell\"><span\n class=\"text-right\">{{credit.sumAmount | nuitCurrency}}</span></td><td class=\"currency number-cell\"><span \nclass=\"text-right\">{{credit.sumRedeemed | nuitCurrency}}</span></td><td class=\"currency number-cell\"><span \nclass=\"text-right\">{{(credit.sumAmount - credit.sumRedeemed) | nuitCurrency}}</span></td></tr></tbody><tfoot><tr \nclass=\"blue-grey-50-bg total-row\"><td colspan=\"3\"></td><td class=\"currency text-right number-cell\">\n{{vm.sumOf(\'sumAmount\') | nuitCurrency}}</td><td class=\"currency text-right number-cell\">\n{{vm.sumOf(\'sumRedeemed\') | nuitCurrency}}</td><td class=\"currency text-right number-cell\">\n{{vm.sumOf(\'open\') | nuitCurrency}}</td></tr></tfoot></table></md-content></div></div></div></div>");
$templateCache.put("app/main/orders.offers/views/offer-details.html","<div id=\"user\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div \nclass=\"content-card\" layout=\"column\" flex><form name=\"vm.offerForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"padding-right: 5px !important\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"{{vm.origin?vm.origin:\'app.offers\'}}\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span class=\"md-title\">{{vm.getTitle(vm.order)}}\n</span> <span ng-class=\"vm.getStatusById(vm.order.status).color.replace(\'fg\',\'bg\')\" class=\"white-text ml-25\" \nstyle=\"padding: 3px 5px\">{{ vm.getStatusById(vm.order.status).name | nuitTranslate }}</span></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.updateOrder()\" \nng-disabled=\"!vm.offerForm.$valid || !vm.offerForm.$dirty\" translate=\"APP.SAVE\">Speichern</md-button><md-menu \nmd-position-mode=\"target-right target\" md-offset=\"11 54\" ng-if=\"vm.showStatusChangeButton(vm) || vm.canBeDeleted()\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item ng-if=\"vm.showStatusChangeButton(vm)\"><md-button aria-label=\"Move to\" \nng-disabled=\"vm.offerForm.$dirty || vm.showDeliveryError()\" ng-click=\"vm.moveToNextState(vm)\" layout=\"row\" \nlayout-align=\"end end\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon>\n{{vm.getStatusById(vm.order.status).transitionText | nuitTranslate }}</md-button></md-menu-item><md-menu-item \nng-if=\"vm.config.ims.offers.allowPrevStatus && vm.getPreviousStatus(vm.order.status)\"><md-button \nng-click=\"vm.moveToPreviousState(vm)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n{{vm.getPreviousStatus(vm.order.status).name | nuitTranslate}}</md-button></md-menu-item><md-menu-item \nng-if=\"vm.canBeDeleted()\"><md-button ng-click=\"vm.deleteSelected(vm)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<span translate=\"APP.DELETE\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.config.ims.exchange.jobBoss.enabled && vm.config.ims.exchange.jobBoss.offer.export.manual\"><md-button \nng-click=\"vm.exportToJobBoss()\"><md-icon md-font-icon=\"icon-receipt\"></md-icon><span translate=\"OFFERS.TO_JOBBOSS\">\n</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" layout=\"column\" \nflex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex><div class=\"content\" ng-if=\"vm.loadingItems\" \nflex><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-tabs \nlayout-fill ng-if=\"!vm.loadingMaterial\"><md-tab label=\"{{ \'ORDERS.DETAILS\' | translate }}\" \nui-sref=\"{{vm.origin?vm.origin:\'app.orders\'}}.detail({active:\'detail\'})\" md-active=\"vm.currentTab === \'detail\'\" \nng-if=\"vm.config.ims.orders.details.enabled\"><ng-include src=\"\'app/main/orders.orders/views/partials/details.html\'\">\n</ng-include></md-tab><md-tab label=\"{{ \'ORDERS.POSITIONS\' | translate }}\" \nui-sref=\"{{vm.origin?vm.origin:\'app.orders\'}}.detail({active:\'positions\'})\" md-active=\"vm.currentTab === \'positions\'\" \nng-if=\"vm.config.ims.orders.positions.enabled\"><ng-include \nsrc=\"\'app/main/orders.orders/views/partials/positions.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'ORDERS.SALES\' | translate }}\" ui-sref=\"{{vm.origin?vm.origin:\'app.orders\'}}.detail({active:\'sales\'})\" \nmd-active=\"vm.currentTab === \'sales\'\" ng-if=\"vm.config.ims.orders.sales.enabled\"><ng-include \nsrc=\"\'app/main/orders.orders/views/partials/sales.html\'\"></ng-include></md-tab><md-tab \nui-sref=\"{{vm.origin?vm.origin:\'app.orders\'}}.detail({active:\'admin\'})\" md-active=\"vm.currentTab === \'admin\'\" \nng-if=\"vm.config.ims.orders.admin\"><md-tab-label>{{\'ADMIN.ADMIN_NAV\' | translate }}</md-tab-label><md-tab-body>\n<ng-include src=\"\'app/main/orders.orders/views/partials/admin.html\'\"></ng-include></md-tab-body></md-tab></md-tabs>\n</md-content></div></form></div></div></div>");
$templateCache.put("app/main/orders.offers/views/offer-list.html","<div id=\"proposals\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\" layout=\"column\" layout-align=\"center center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clipboard-outline\" class=\"icon\">\n</md-icon></span><span class=\"logo-text text-truncate\" translate=\"OFFERS.OFFERS_NAV\">Offers</span></div></div>\n<md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><md-button \nng-repeat=\"status in vm.offerFilters track by status.id\" class=\"item\" ng-click=\"vm.setStatusFilter(status.id)\" \nng-class=\"{\'selected\':vm.isFilterSelected(status.id)}\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-fill><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"{{status.icon}}\" \nng-class=\"status.color\" class=\"s16\"></md-icon><span class=\"title\">{{ status.name | nuitTranslate }}</span> <span \nclass=\"title\">&nbsp;({{vm.getFilterCount(status.id)}})</span></div></div></md-button><md-button class=\"item\" \nng-click=\"vm.setStatusFilter(\'-1\')\" ng-class=\"{\'selected\':vm.isFilterSelected(\'-1\')}\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-fill><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s16 blue-grey-900-fg\"></md-icon><span class=\"title\" \ntranslate=\"APP.SHOW_ALL\">Alle</span></div></div></md-button></div></md-content></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start end\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\" style=\"padding-right: 0\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input class=\"mr-10\" flex ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"><div \nstyle=\"min-height: 60px\" ng-if=\"vm.config.ims.offers.list.dateFilter.enabled\" \nclass=\"md-whiteframe-2dp user-controlling-filter grey-100-bg\" layout=\"row\" layout-align=\"space-around center\">\n<nuit-date-search start-date=\"vm.startFilterDate\" end-date=\"vm.endFilterDate\" on-change=\"vm.dateFilterChanged()\">\n</nuit-date-search></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" aria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleSelectedOffers()\"></md-checkbox><div \nlayout=\"row\" ng-if=\"vm.getSelected().length > 0\" layout-align=\"start center\"><nuit-selection-indicator \nselection=\"vm.selection\" get-name=\"vm.getTitleById\"></nuit-selection-indicator><md-button ng-if=\"vm.canBeDeleted()\" \nclass=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected(vm)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button><md-progress-circular \nclass=\"md-accent ml-10\" md-mode=\"indeterminate\" md-diameter=\"32\" ng-if=\"vm.ordersToProcess !== 0\">\n</md-progress-circular><md-button class=\"md-accent md-raised\" ng-if=\"vm.showStatusChangeButton(vm)\" \naria-label=\"Move to\" ng-click=\"vm.moveToNextState(vm)\" ng-show=\"vm.status.id!==\'-1\'\"><span class=\"ng-scope\">\n{{vm.getStatusById(vm.status.id).transitionText | nuitTranslate}}</span></md-button><md-button class=\"md-raised ml-20\" \nng-if=\"vm.ordersToProcess===0 && vm.config.ims.offers.allowPrevStatus && vm.getPreviousStatus(vm.status.id)\" \nng-click=\"vm.moveToPreviousState(vm)\">{{vm.getPreviousStatus(vm.status.id).name | nuitTranslate}}</md-button></div>\n</div><div layout=\"row\" layout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" entities-per-page=\"20\" \nload-page=\"vm.loadPage(data)\" lacy-load-entity=\"vm.loadAssignees(entity)\"></nuit-pagination></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex><div \nng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...</span></div><div \nng-if=\"vm.filteredEntities.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"PROPOSALS.NO_PROPOSALS\">\nThere are no orders yet!</span></div><div class=\"thread unread\" ng-if=\"!vm.loading\" \nng-repeat=\"offer in vm.currentPageEntities track by offer.id\" ng-class=\"{\'selected\': vm.isSelected(offer.id)}\" \nng-click=\"vm.openDetails(offer.id)\" style=\"min-height: 80px\"><div ng-if=\"offer.id<=0 && $index===0\" layout=\"row\" \nlayout-fill layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"24\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\" layout-fill \nng-if=\"offer.id>=0\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(offer.id)\" \nng-click=\"vm.toggleSelectOffer(offer.id, $event)\" aria-label=\"{{vm.isSelected(offer.id) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" layout=\"column\" flex><div layout=\"row\" flex layout-align=\"start center\"><span \nstyle=\"padding-bottom: 0 !important\" class=\"name text-truncate\">{{vm.getTitle(offer)}}</span><div \nng-if=\"offer[vm.ASSIGNEES_NAME] && offer[vm.ASSIGNEES_NAME].length>0\"><nuit-person-name \nstyle=\"padding: 2px 10px 2px 10px\" class=\"mh-5 label grey-100-bg text-nowrap\" \nng-repeat=\"id in offer[vm.ASSIGNEES_NAME]\" person=\"vm.getPerson(id)\"></nuit-person-name></div><div \nclass=\"ph-5 label grey-100-bg mr-5 text-nowrap\" ng-repeat=\"tag in offer.tags\" ng-class=\"{\'ml-10\':$first}\">\n{{tag.localizedName | nuitTranslate:tag.name}}</div></div><div class=\"message text-truncate\">\n{{ offer.ordered_on | nuitDatetime: \'datetime\' }}</div></div><div class=\"labels\" flex=\"nogrow\" layout=\"row\" \nlayout-align=\"end start\" layout-wrap><div ng-show=\"offer.origin_user\"><md-icon md-font-icon=\"icon-account-location\">\n<md-tooltip><span translate=\"ORDERS.ORDERED_BY_ORIGIN_USER\"></span></md-tooltip></md-icon></div><div \nclass=\"label md-green-600-bg text-truncate\">{{ vm.getStatusById(offer.status).name | nuitTranslate}}</div><div \nclass=\"text-boxed\">{{ vm.getOrderPositions(offer) }}</div></div></div></div></md-content></div></div></div></div>");
$templateCache.put("app/main/orders.orders/views/order-details.html","<div id=\"user\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div \nclass=\"content-card\" layout=\"column\" flex><form name=\"vm.orderForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"padding-right: 5px !important\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"{{vm.origin?vm.origin:\'app.orders\'}}\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span class=\"md-title\">{{vm.getTitle(vm.order)}}\n</span> <span ng-class=\"vm.getStatusById(vm.order.status).color.replace(\'fg\',\'bg\')\" class=\"white-text ml-25\" \nstyle=\"padding: 3px 5px\">{{ vm.getStatusById(vm.order.status).name | nuitTranslate }}</span></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.updateOrder()\" \nng-disabled=\"!vm.orderForm.$valid || !vm.orderForm.$dirty\" translate=\"APP.SAVE\">Speichern</md-button><md-menu \nmd-position-mode=\"target-right target\" md-offset=\"11 54\" ng-if=\"vm.showStatusChangeButton(vm) || vm.canBeDeleted()\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item ng-if=\"vm.showStatusChangeButton(vm)\"><md-button aria-label=\"Move to\" \nng-disabled=\"vm.orderForm.$dirty || vm.showDeliveryError()\" ng-click=\"vm.moveToNextState(vm)\" layout=\"row\" \nlayout-align=\"end end\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon>\n{{vm.getStatusById(vm.order.status).transitionText | nuitTranslate }}</md-button></md-menu-item><md-menu-item \nng-if=\"vm.canBeDeleted()\"><md-button ng-click=\"vm.deleteSelected(vm)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<span translate=\"APP.DELETE\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.exportToQuickbooks && vm.order.companyId!==0 && vm.config.ims.exchange.quickbooks.enabled && vm.config.ims.exchange.quickbooks.invoice.export.manual\">\n<md-button ng-click=\"vm.exportToQuickbooks()\"><md-icon md-font-icon=\"icon-receipt\"></md-icon><span \ntranslate=\"ORDERS.TO_QUICKBOOKS\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.config.ims.exchange.jobBoss.enabled && vm.config.ims.exchange.jobBoss.order.export.manual\"><md-button \nng-click=\"vm.exportToJobBoss()\"><md-icon md-font-icon=\"icon-receipt\"></md-icon><span translate=\"ORDERS.TO_JOBBOSS\">\n</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.config.ims.exchange.jobBoss.enabled && vm.config.ims.exchange.jobBoss.order.exportAsOffer.manual\"><md-button \nng-click=\"vm.exportAsOfferToJobBoss()\"><md-icon md-font-icon=\"icon-receipt\"></md-icon><span \ntranslate=\"OFFERS.TO_JOBBOSS\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.exportToXero && vm.order.companyId!==0 && vm.config.ims.exchange.xero.enabled && vm.config.ims.exchange.xero.invoice.export.manual\">\n<md-button ng-click=\"vm.exportToXero()\"><md-icon md-font-icon=\"icon-receipt\"></md-icon><span \ntranslate=\"ORDERS.TO_XERO\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex><div \nclass=\"content\" ng-if=\"vm.loadingItems\" flex><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n<span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-tabs \nlayout-fill ng-if=\"!vm.loadingItems\"><md-tab label=\"{{ \'ORDERS.DETAILS\' | translate }}\" \nui-sref=\"{{vm.origin?vm.origin:\'app.orders\'}}.detail({active:\'detail\'})\" md-active=\"vm.currentTab === \'detail\'\" \nng-if=\"vm.config.ims.orders.details.enabled\"><ng-include src=\"\'app/main/orders.orders/views/partials/details.html\'\">\n</ng-include></md-tab><md-tab label=\"{{ \'ORDERS.POSITIONS\' | translate }}\" \nui-sref=\"{{vm.origin?vm.origin:\'app.orders\'}}.detail({active:\'positions\'})\" md-active=\"vm.currentTab === \'positions\'\" \nng-if=\"vm.config.ims.orders.positions.enabled\"><ng-include \nsrc=\"\'app/main/orders.orders/views/partials/positions.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'ORDERS.EASY\' | translate }}\" md-active=\"vm.currentTab === \'positions\'\" \nng-if=\"vm.config.ims.orders.easy.enabled\"><ng-include src=\"\'app/main/orders.orders/views/partials/easy.html\'\">\n</ng-include></md-tab><md-tab label=\"{{ \'ORDERS.SALES\' | translate }}\" \nui-sref=\"{{vm.origin?vm.origin:\'app.orders\'}}.detail({active:\'sales\'})\" md-active=\"vm.currentTab === \'sales\'\" \nng-if=\"vm.config.ims.orders.sales.enabled\"><ng-include src=\"\'app/main/orders.orders/views/partials/sales.html\'\">\n</ng-include></md-tab><div id=\"order-forwarding\" ui-view=\"forwarding\"></div><md-tab \nui-sref=\"{{vm.origin?vm.origin:\'app.orders\'}}.detail({active:\'admin\'})\" md-active=\"vm.currentTab === \'admin\'\" \nng-if=\"vm.config.ims.orders.admin\"><md-tab-label>{{\'ADMIN.ADMIN_NAV\' | translate }}</md-tab-label><md-tab-body>\n<ng-include src=\"\'app/main/orders.orders/views/partials/admin.html\'\"></ng-include></md-tab-body></md-tab></md-tabs>\n</md-content></div></form></div></div></div>");
$templateCache.put("app/main/orders.orders/views/order-list.html","<div layout=\"row\" ng-if=\"vm.config.ims.orders.list.allowAdd\" class=\"mt-10 mb-0\"><div flex></div><md-button \nclass=\"md-raised m-0 mb-2\" ng-click=\"vm.createOrder()\">{{ \'ORDERS.ADD\' | translate}}</md-button></div><div \nclass=\"header h-60\" layout=\"row\" layout-align=\"start end\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" hide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-right: 0\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"><div style=\"min-height: 60px\" \nng-if=\"vm.config.ims.orders.list.dateFilter.enabled || vm.showDownloadButton()\" \nclass=\"md-whiteframe-2dp user-controlling-filter grey-100-bg\" layout=\"row\" layout-align=\"space-around center\">\n<nuit-date-search start-date=\"vm.startFilterDate\" end-date=\"vm.endFilterDate\" on-change=\"vm.dateFilterChanged()\">\n</nuit-date-search><md-button class=\"md-icon-button\" target=\"_blank\" \nng-href=\"{{vm.downloadUrl(vm.config.ims.orders.list.download.appId, vm.config.ims.orders.list.download.flowId)}}\" \nng-if=\"vm.showDownloadButton()\"><md-icon md-font-icon=\"icon-box-download\"></md-icon><md-tooltip><span \ntranslate=\"APP.DOWNLOAD\"></span></md-tooltip></md-button></div></div></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nng-click=\"vm.toggleSelectedOrders()\"></md-checkbox><div layout=\"row\" ng-if=\"vm.getSelected().length > 0\" \nlayout-align=\"start center\"><nuit-selection-indicator selection=\"vm.selection\" get-name=\"vm.getTitleById\">\n</nuit-selection-indicator><md-button ng-if=\"vm.canBeDeleted()\" class=\"md-icon-button\" aria-label=\"delete\" \nng-click=\"vm.deleteSelected(vm)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">\nDelete</span></md-tooltip></md-button><md-button class=\"md-accent md-raised\" ng-if=\"vm.showStatusChangeButton(vm)\" \naria-label=\"Move to\" ng-click=\"vm.moveToNextState(vm)\"><span class=\"ng-scope\">\n{{vm.getStatusById(vm.statusFilter).transitionText[vm.translation.language] }}</span></md-button></div>\n<md-progress-circular class=\"md-accent ml-10\" md-mode=\"indeterminate\" md-diameter=\"32\" \nng-if=\"vm.ordersToProcess !== 0\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\">\n<nuit-pagination all-entities=\"vm.filteredEntities\" current-page-entities=\"vm.currentPageEntities\" \ncurrent-page=\"vm.currentPage\" lacy-load-entity=\"vm.checkDeliveryObject(entity)\" entities-per-page=\"20\" \nload-page=\"vm.loadPage(data)\"></nuit-pagination></div></div><div class=\"content-wrapper\" layout=\"column\" flex>\n<md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"(vm.loading || vm.loadingArchive)\" \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...</span></div><div \nng-if=\"(vm.filteredEntities.length === 0 && !vm.loading) && !vm.loadingArchive\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"ORDERS.NO_ORDERS\">\nThere are no orders yet!</span></div><div class=\"thread unread\" ng-if=\"!vm.loading\" \nng-repeat=\"order in vm.currentPageEntities track by order.id\" ng-class=\"{\'selected\': vm.isSelected(order.id)}\" \nng-click=\"vm.openItem(order.id)\" style=\"min-height: 80px\"><div ng-if=\"order.id<=0 && $index===0\" layout=\"row\" \nlayout-fill layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"24\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\" layout-fill \nng-if=\"order.id>0\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(order.id)\" \nng-click=\"vm.toggleSelectOrder(order.id, $event)\" aria-label=\"{{vm.isSelected(order.id) ? \'Deselect\' : \'Select\'}}\" \nng-disabled=\"vm.disableSelection(order.status)\"></md-checkbox><div class=\"info\" layout=\"column\" flex><div layout=\"row\" \nflex layout-align=\"start center\"><span style=\"padding-bottom: 0 !important\" class=\"name text-truncate\">\n{{vm.getTitle(order)}}</span><div ng-if=\"order.deliveryWarning\"><md-icon \nstyle=\"font-size: 20px !important; line-height: 15px !important\" md-font-icon=\"icon-alert\" class=\"md-warn ml-10\">\n</md-icon><md-tooltip><span translate=\"TRANSPORT.DELIVERY_DETAILS_MISSING\"></span></md-tooltip></div><div \nng-if=\"order[vm.ASSIGNEES_NAME] && order[vm.ASSIGNEES_NAME].length>0\"><nuit-person-name \nstyle=\"padding: 2px 10px 2px 10px\" class=\"mh-5 label grey-100-bg text-nowrap\" \nng-repeat=\"id in order[vm.ASSIGNEES_NAME]\" person=\"vm.getPerson(id)\"></nuit-person-name></div><div \nclass=\"ph-5 label grey-100-bg mr-5 text-nowrap\" ng-repeat=\"tag in order.tags\" ng-class=\"{\'ml-10\':$first}\">\n{{tag.localizedName | nuitTranslate:tag.name}}</div></div><div class=\"message text-truncate\">\n{{ order.ordered_on | nuitDatetime: \'datetime\' }}</div></div><div class=\"labels\" flex=\"nogrow\" layout=\"row\" \nlayout-align=\"end start\" layout-wrap><div ng-if=\"order.details.fixedTime\" layout=\"column\" layout-align=\"start center\">\n<div layout=\"row\" layout-align=\"center center\"><md-icon class=\"orange-300-fg\" md-font-icon=\"icon-alarm\"><md-tooltip \nstyle=\"height:auto\"><span translate=\"ORDERS.FIXED_TIME\"></span><br><span>\n{{vm.getFixedTime(order) | nuitDatetime:\'datetime\'}}</span><br><span ng-if=\"order.details.fixedTime.tolerance\" \ntranslate=\"ORDERS.TOLERANCE\" translate-values=\"{tolerance:vm.getFormattedTolerance(order.details.fixedTime)}\"></span>\n</md-tooltip></md-icon></div></div><div ng-if=\"vm.getPaymentStatus(order)!==\'none\'\"><md-icon \nmd-font-icon=\"icon-credit-card\"><md-icon ng-if=\"vm.getPaymentStatus(order)===\'failed\'\" \nstyle=\"position: relative; left: 4px; top: -22px\" class=\"md-warn-fg s16\" md-font-icon=\"icon-alert\" \nng-if=\"vm.getPaymentStatus(order)===\'failed\'\"><md-tooltip><span translate=\"ORDERS.PAYMENT.FAILED\"></span></md-tooltip>\n</md-icon><md-icon ng-if=\"vm.getPaymentStatus(order)===\'successful\'\" style=\"position: relative; left: 4px; top: -24px\" \nclass=\"green-500-fg s16\" md-font-icon=\"icon-checkbox-marked-circle\" ng-if=\"vm.getPaymentStatus(order)===\'failed\'\">\n<md-tooltip><span translate=\"ORDERS.PAYMENT.SUCCESSFUL\"></span></md-tooltip></md-icon></md-icon></div><div \nng-show=\"order.originUser || order.origin_user\"><md-icon md-font-icon=\"icon-account-location\"><md-tooltip><span \ntranslate=\"ORDERS.ORDERED_BY_ORIGIN_USER\"></span></md-tooltip></md-icon></div><div \nclass=\"label text-truncate white-text\" \nng-init=\" color1 = vm.getStatusById(order.status).color; bgColor = color1.replace(\'fg\',\'bg\')\" ng-class=\"bgColor\">\n{{ vm.getStatusById(order.status).name | nuitTranslate }}</div><div class=\"text-boxed\">\n{{ vm.getOrderPositions(order) }}</div></div></div></div></md-content></div></div>");
$templateCache.put("app/main/orders.orders/views/orders.html","<div id=\"orders\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\" layout=\"column\" layout-align=\"center center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clipboard-check\" class=\"icon\">\n</md-icon></span><span class=\"logo-text text-truncate\" translate=\"ORDERS.ORDERS_NAV\">Orders</span></div></div>\n<md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><md-button \nng-repeat=\"status in vm.OrderService.orderFilters track by status.id\" class=\"item\" \nng-click=\"vm.setStatusFilter(status.id)\" ng-class=\"{\'selected\':vm.isFilterSelected(status.id)}\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-fill><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-class=\"status.color\" class=\"s20\"></md-icon><span class=\"title\">\n{{ status.name[vm.translation.language] }}</span> <span class=\"title\">&nbsp;({{vm.getFilterCount(status.id)}})</span>\n</div></div></md-button><md-button class=\"item\" ng-click=\"vm.setStatusFilter(-1)\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-fill><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s20 blue-grey-900-fg\"></md-icon><span class=\"title\" \ntranslate=\"APP.SHOW_ALL\">Alle</span></div></div></md-button><div class=\"item subheader\" ng-click=\"vm.toggleEditing()\" \nng-if=\"false\"><span translate=\"ORDERS.GROUPS.EDIT\" ng-if=\"!vm.groupsEditing\">Edit groups</span> <span \ntranslate=\"ORDERS.GROUPS.VIEW\" ng-if=\"vm.groupsEditing\">View groups</span></div></div></md-content></md-sidenav><div \nclass=\"center mt-32\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/orders.proposals/views/proposal-list.html","<div id=\"proposals\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\" layout=\"column\" layout-align=\"center center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clipboard-outline\" class=\"icon\">\n</md-icon></span><span class=\"logo-text text-truncate\" translate=\"PROPOSALS.PROPOSALS_NAV\">Orders</span></div></div>\n<md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><md-button \nng-repeat=\"status in vm.proposalFilters track by status.id\" class=\"item\" ng-click=\"vm.setStatusFilter(status)\" \nng-class=\"{\'selected\':vm.isFilterSelected(status.id)}\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-fill><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"{{status.icon}}\" \nng-class=\"status.color\" class=\"s16\"></md-icon><span class=\"title\">{{ status.name | nuitTranslate }}</span> <span \nclass=\"title\">&nbsp;({{vm.getFilterCount(status.id)}})</span></div></div></md-button><md-button class=\"item\" \nng-click=\"vm.setStatusFilter(vm.ALL_STATUS)\"><div layout=\"row\" layout-align=\"space-between center\" layout-fill><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-format-list-bulleted\" \nclass=\"s16 blue-grey-900-fg\"></md-icon><span class=\"title\" translate=\"APP.SHOW_ALL\">Alle</span></div></div></md-button>\n</div></md-content></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start end\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex>\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nflex ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"></div></div></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" ng-checked=\"vm.getSelected().length > 0\" \nng-click=\"vm.toggleSelectedOrders()\"></md-checkbox><div layout=\"row\" ng-if=\"vm.getSelected().length > 0\"><md-button \nng-if=\"vm.canBeDeleted()\" class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected(vm)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button>\n<md-progress-circular class=\"md-accent ml-10\" md-mode=\"indeterminate\" md-diameter=\"32\" \nng-if=\"vm.ordersToProcess !== 0\"></md-progress-circular><md-button class=\"md-accent md-raised\" \nng-if=\"vm.showStatusChangeButton()\" aria-label=\"Move to\" ng-click=\"vm.moveToNextState(vm)\" \nng-show=\"vm.status.id!==\'-1\'\"><span class=\"ng-scope\">{{vm.status.transitionText | nuitTranslate}}</span></md-button>\n</div></div><div layout=\"row\" layout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" entities-per-page=\"10\"></nuit-pagination>\n</div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex>\n<div ng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...</span></div><div \nng-if=\"vm.orders.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"PROPOSALS.NO_PROPOSALS\">There are no orders yet!</span></div><div \nclass=\"thread unread\" ng-if=\"!vm.loading\" ng-repeat=\"order in vm.currentPageEntities track by order.id\" \nng-class=\"{\'selected\': vm.isSelected(order)}\" ng-click=\"vm.openDetails(order.id)\"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(order)\" \nng-click=\"vm.toggleSelectOrder(order, $event)\" aria-label=\"{{vm.isSelected(order) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" layout=\"column\" flex><span class=\"name text-truncate\">\n{{vm.config.ims.orders.nameFormat | nuitFormatter: order}}</span><div class=\"message text-truncate\">\n{{ order.ordered_on | nuitDatetime: \'datetime\' }}</div></div><div class=\"labels\" flex=\"nogrow\" layout=\"row\" \nlayout-align=\"end start\" layout-wrap><div ng-show=\"order.origin_user\"><md-icon md-font-icon=\"icon-account-location\">\n<md-tooltip><span translate=\"ORDERS.ORDERED_BY_ORIGIN_USER\"></span></md-tooltip></md-icon></div><div \nclass=\"label md-green-600-bg text-truncate\">{{ vm.getStatusById(order.status).name | nuitTranslate}}</div><div \nclass=\"text-boxed\">{{ vm.getOrderPositions(order) }}</div></div></div></div></md-content></div></div></div></div>");
$templateCache.put("app/main/orders.settings/views/number-list.html","<div id=\"accounting\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-clipboard-alert\" class=\"icon\"></md-icon></span><span class=\"logo-text text-truncate\">\n{{vm.numberType.toUpperCase() +\'.\' + vm.numberType.toUpperCase() + \'_NUMBERS\' |translate}}</span></div><md-button \nclass=\"md-raised\" ng-click=\"vm.addNumber()\" translate=\"APP.ADD\">Add Config</md-button></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" ng-checked=\"vm.getSelected().length > 0\" \nng-click=\"vm.toggleSelectedNumbers()\" ng-if=\"vm.hasSelectableNumbers()\"></md-checkbox><div layout=\"row\" \nng-if=\"vm.getSelected().length > 0\"><md-button class=\"md-icon-button\" aria-label=\"delete\" \nng-click=\"vm.deleteSelected()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">\nDelete</span></md-tooltip></md-button></div></div><div flex layout=\"row\" layout-align=\"start center\" class=\"mh-16\"><div\n flex=\"25\"><h3 class=\"text-truncate\" translate=\"APP.PERIOD\">Zeitraum</h3></div><div flex=\"25\"><h3 \nclass=\"text-truncate\" translate=\"CLIENTS.TEMPLATE\">Template</h3></div><div flex=\"25\"><h3 class=\"text-truncate\" \ntranslate=\"APP.INVOICE_NUMBER.AUTORENEW\"></h3></div><div flex=\"25\"><h3 class=\"text-truncate text-center\" \ntranslate=\"APP.INVOICE_NUMBER_NUMBERS\"></h3></div></div></div><div class=\"content-wrapper\" layout=\"column\" flex>\n<md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.loadingItems\" class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\">Loading ...\n</span></div><div ng-if=\"vm.numbers.length === 0 && !vm.loadingItems\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"ORDERS.NO_ORDER_NUMBERS\">\nThere are no ordernumbers yet!</span></div><div class=\"thread unread\" ng-if=\"!vm.loadingItems \" \nng-repeat=\"number in vm.numbers | orderBy:\'start\'  track by number.id\" ng-class=\"{\'selected\': vm.isSelected(number)}\" \nng-click=\"vm.openDetails(number.id)\"><div layout=\"row\" layout-align=\"start center\" layout-fill><div flex=\"10\">\n<md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(number)\" ng-click=\"vm.toggleSelectNumber(number, $event)\" \naria-label=\"{{vm.isSelected(number) ? \'Deselect\' : \'Select\'}}\" ng-if=\"number.number === 0\"></md-checkbox></div><div \nclass=\"info\" layout=\"row\" flex layout-align=\"start center\"><div flex=\"25\"><span class=\"name\">\n{{number.start * 1000 | nuitDate:\'date\'}} - {{number.end * 1000 | nuitDate:\'date\'}}</span></div><div flex=\"25\"><div>\n<div class=\"name\">{{number.tpl}}<br></div><div class=\"grey-600-fg\"><span translate=\"DOCUMENT.PREVIEW\"></span>: <strong>\n{{number.previewNumber}}</strong></div></div></div><div flex=\"25\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"pl-20\"><md-icon ng-if=\"number.autoRenew\" md-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"md-warn\">\n</md-icon><md-icon ng-if=\"!number.autoRenew\" md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"grey-100\">\n</md-icon><span class=\"name\">{{number.autoRenew}}</span></div></div><div flex=\"25\" layout=\"row\" class=\"pl-70\" \nlayout-align=\"end center\"><div class=\"name\">{{number.number}}</div><div flex=\"60\"></div></div></div></div></div>\n</md-content></div></div></div></div>");
$templateCache.put("app/main/orders.settings/views/tag-list.html","<div id=\"tags\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-tag\" \nclass=\"icon\"></md-icon></span><span class=\"logo-text\" translate=\"ORDER.TAGS\">Tags</span></div><md-button \nclass=\"md-raised\" ng-click=\"vm.addTag()\" translate=\"APP.ADD\">Add User</md-button></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content-wrapper\" layout=\"column\" felx><md-content class=\"content thread-list\" \nms-scroll flex><div layout=\"column\"><div class=\"thread\" ng-repeat=\"tag in vm.tags\" layout-wrap flex=\"grow\"><div \nng-if=\"!tag._isLoading\" layout=\"row\" flex><div layout-align=\"start center\" flex=\"grow\"><h3>{{tag.name | nuitTranslate}}\n</h3></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.editTag(tag, $event)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span \ntranslate=\"APP.EDIT\">Edit</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteTag(tag, $event)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div><div ng-if=\"tag._isLoading === true\" \nstyle=\"padding: 8px; border-radius: 3px\" class=\"md-grey-200-bg md-item-text md-whiteframe-z1\" layout=\"row\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"16\"></md-progress-circular></div></div></div></md-content></div></div></div></div>");
$templateCache.put("app/main/partners.companies/views/companies-list.html","<div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-domain\" class=\"mr-16 md-background-fg\"></md-icon><span \nclass=\"logo-text text-truncate\" translate=\"PARTNERS.PARTNERS_NAV\">Partner</span></div><div class=\"compose-button\" \nng-if=\"vm.config.ims.companies.list.allowAdd\"><md-button class=\"md-raised\" aria-label=\"compose\" \nui-sref=\"app.partners-companies.compose({type: \'companies\'})\" translate=\"APP.ADD\">ADD NEW COMPANY</md-button></div>\n</div><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nflex ng-model=\"vm.term\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"><md-select ng-if=\"vm.searchTypes.length>1\" \nclass=\"search-switch\" ng-model=\"vm.mode\" md-on-close=\"vm.updateMode()\" placeholder=\"\" class=\"md-no-underline\" required \nmd-no-asterisk=\"false\"><md-option ng-repeat=\"type in vm.searchTypes\" value=\"{{type}}\" \ntranslate=\"COMPANY.SEARCH_{{type.toUpperCase()}}\"></md-option></md-select><md-select class=\"search-switch ml-15\" \nng-if=\"vm.config.ims.companies.search.paginationTerm\" ng-model=\"vm.selectedChar\" placeholder=\"ABC\" \nmd-on-close=\"vm.updatePaginationTerm()\"><md-option ng-repeat=\"char in vm.chars\" value=\"{{char}}\">{{char}}</md-option>\n</md-select></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex><span class=\"ml-16 grey-600-fg\" \nflex translate=\"PARTNERS.PARTNERS_NAV\"></span><div class=\"mr-16 grey-600-fg\" flex><span translate=\"APP.ACTIVE\"></span>\n / <span translate=\"APP.INACTIVE\"></span></div><span class=\"ml-16 grey-600-fg\" flex translate=\"APP.PHONE\"></span></div>\n<div layout=\"row\" layout-align=\"end center\" flex=\"35\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" , entities-per-page=\"10\" , \nlacy-load-entity=\"vm.loadCompany(entity)\" term-to-set=\"vm.paginationTerm\" allow-skipping=\"true\"></nuit-pagination>\n</div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex>\n<div ng-if=\"vm.loadingEntities\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"vm.filteredEntities.length === 0\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<span class=\"md-headline\" translate=\"COMPANY.NO_COMPANIES\">There are no partners yet!</span></div><ng-include \nsrc=\"\'app/main/partners.companies/views/partials/company-list-entry.html\'\"></ng-include></md-content></div></div>");
$templateCache.put("app/main/partners.companies/views/company-compose.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" flex \nui-view=\"body\" ng-init=\"vm.init()\"><form name=\"vm.companyForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\" ng-submit=\"vm.saveCompany()\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\" translate translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><md-button ng-if=\"vm.companyCompose\" \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.partners-companies\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><md-button ng-if=\"!vm.companyCompose\" \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.transport\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\" hide show-gt-xs><div class=\"divider-vertical mr-20\"></div><span class=\"md-title\" \ntranslate=\"MENUBAR.NEW\">Neuer Partner</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-warn md-raised\" type=\"submit\" ng-disabled=\"!vm.companyForm.$dirty\" translate=\"APP.SAVE\">Speichern</md-button>\n</div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content ms-scroll layout-fill class=\"thread-detail\" \nflex><div layout=\"column\" layout-padding><ng-include \nsrc=\"\'app/main/partners.general/views/partials/company-address.html\'\"></ng-include></div></md-content></div></form>\n</div>");
$templateCache.put("app/main/partners.companies/views/company-details.html","<div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex><form name=\"vm.companyForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-if=\"!vm.originFromInvoice\" class=\"md-icon-button close-thread\" \naria-label=\"Back\" ui-sref=\"app.partners-companies\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n</md-button><md-button ng-if=\"vm.originFromInvoice\" class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.goToOrigin()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" ng-show=\"vm.company\" hide show-gt-xs><div \nclass=\"divider-vertical mr-20\"></div><span class=\"md-title\">{{vm.company.name}}</span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-warn md-raised\" type=\"submit\" ng-show=\"!vm.showAddButton()\" \nng-disabled=\"!vm.companyForm.$dirty || !vm.companyForm.$valid\" ng-click=\"vm.updateCompany()\" translate=\"APP.SAVE\">\nSpeichern</md-button><md-button class=\"md-raised md-accent\" ng-show=\"vm.showSignupButton()\" ng-click=\"vm.openSignup()\" \ntranslate=\"APP.SIGNUP\">Add</md-button><md-button class=\"md-raised md-accent\" ng-show=\"vm.showAddButton()\" \nng-click=\"vm.editEntity(null)\" translate=\"APP.ADD\">Add</md-button></div></div><div class=\"content-wrapper\" \nlayout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex><div class=\"content\" \nng-if=\"vm.loadingCompanies\" flex><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-tabs \nlayout-fill md-selected=\"vm.selectedTab\" ng-if=\"!vm.loadingMaterial\" flex><md-tab \nlabel=\"{{ \'COMPANY.ADDRESS\' | translate }}\" ui-sref=\"{{\'app.partners-companies\'}}.details({active:\'address\'})\" \nmd-active=\"vm.currentTab === \'address\'\"><ng-include \nsrc=\"\'app/main/partners.general/views/partials/company-address.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'COMPANY.ACCOUNT\' | translate }}\" ui-sref=\"{{\'app.partners-companies\'}}.details({active:\'account\'})\" \nmd-active=\"vm.currentTab === \'account\'\"><ng-include \nsrc=\"\'app/main/partners.companies/views/partials/company-bank-account.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'COMPANY.PERSONS\' | translate }}\" ui-sref=\"{{\'app.partners-companies\'}}.details({active:\'persons\'})\" \nmd-active=\"vm.currentTab === \'persons\'\"><md-tab-body><ng-include \nsrc=\"\'app/main/partners.general/views/partials/company-persons.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nlabel=\"{{ \'COMPANY.ACCOUNTING\' | translate}}\" ui-sref=\"{{\'app.partners-companies\'}}.details({active:\'accounting\'})\" \nmd-active=\"vm.currentTab === \'accounting\'\" ng-if=\"vm.enableInvoiceTab\"><ng-include \nsrc=\"\'app/main/partners.companies/views/partials/company-invoices.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'COMPANY.CREDIT\' | translate}}\" ui-sref=\"{{\'app.partners-companies\'}}.details({active:\'credit\'})\" \nmd-active=\"vm.currentTab === \'credit\'\" ng-if=\"vm.enableCreditTab\"><ng-include \nsrc=\"\'app/main/partners.companies/views/partials/company-credits.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'COMPANY.RAW_MATERIAL_DISCOUNT\' | translate}}\" \nui-sref=\"{{\'app.partners-companies\'}}.details({active:\'rawMaterialDiscount\'})\" \nmd-active=\"vm.currentTab === \'rawMaterialDiscount\'\" ng-if=\"vm.config.ims.companies.rawMaterialDiscounts.enabled\">\n<ng-include src=\"\'app/main/partners.companies/views/partials/company-rawmaterial.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'COMPANY.NOTIFICATIONS\' | translate}}\" \nui-sref=\"{{\'app.partners-companies\'}}.details({active:\'notifications\'})\" md-active=\"vm.currentTab === \'notifications\'\" \nng-if=\"vm.config.ims.companies.notification.enabled\"><ng-include \nsrc=\"\'app/main/partners.companies/views/partials/company-notifications.html\'\"></ng-include></md-tab></md-tabs>\n</md-content></div></form></div>");
$templateCache.put("app/main/partners.companies/views/company-numbers.html","<div id=\"accounting\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-clipboard-alert\" class=\"icon\"></md-icon></span><span class=\"logo-text text-truncate\" \ntranslate=\"COMPANY.COMPANY_NUMBERS\">Orders</span></div><md-button class=\"md-raised\" \nng-disabled=\"vm.companyNumbers.length > 0\" ng-click=\"vm.addCompanyNumber()\" translate=\"APP.ADD\">Add Config</md-button>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><div\n layout=\"row\" layout-align=\"start center\" flex=\"10\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" ng-checked=\"vm.getSelected().length > 0\" \nng-click=\"vm.toggleSelectedCompanyNumbers()\"></md-checkbox><div layout=\"row\" ng-if=\"vm.getSelected().length > 0\">\n<md-progress-circular class=\"md-accent ml-10\" md-mode=\"indeterminate\" md-diameter=\"32\" \nng-if=\"vm.ordersToProcess !== 0\"></md-progress-circular><md-button class=\"md-icon-button\" aria-label=\"delete\" \nng-click=\"vm.deleteSelected()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">\nDelete</span></md-tooltip></md-button></div></div><div flex layout=\"row\" layout-align=\"start center\" class=\"mh-16\"><div\n flex=\"25\"><h3 class=\"text-truncate\" translate=\"CLIENTS.TEMPLATE\">Template</h3></div><div flex=\"25\"><h3 \nclass=\"text-truncate text-center\" translate=\"APP.INVOICE_NUMBER_NUMBERS\"></h3></div></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex><div \nng-if=\"vm.loadingItems\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\">Loading ...</span></div><div \nng-if=\"vm.companyNumbers.length === 0 && !vm.loadingItems\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"ORDERS.NO_ORDERS\">\nThere are no orders yet!</span></div><div class=\"thread unread\" ng-if=\"!vm.loadingItems \" \nng-repeat=\"companynumbers in vm.companyNumbers | orderBy:\'start\'  track by companynumbers.id\" \nng-class=\"{\'selected\': vm.isSelected(companynumbers)}\" ng-click=\"vm.openDetails(companynumbers.id)\"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><div flex=\"10\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isSelected(companynumbers)\" ng-click=\"vm.toggleSelectCompanyNumber(companynumbers, $event)\" \naria-label=\"{{vm.isSelected(companynumbers) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></div><div class=\"info\" \nlayout=\"row\" flex layout-align=\"start center\"><div flex=\"25\"><div><div class=\"name\">{{companynumbers.tpl}}<br></div>\n<div class=\"grey-600-fg\"><span translate=\"DOCUMENT.PREVIEW\"></span>: <strong>{{companynumbers.previewNumber}}</strong>\n</div></div></div><div flex=\"25\" layout=\"row\" class=\"pl-70\" layout-align=\"end center\"><div class=\"name\">\n{{companynumbers.number}}</div><div flex=\"60\"></div></div></div></div></div></md-content></div></div></div></div>");
$templateCache.put("app/main/partners.companies/views/partners.companies.html","<div id=\"companies\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/partners.companies.admin/views/partners.companies.admin.html","<div id=\"companies-admin\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex ui-view=\"body\"><div class=\"content-card\" ng-class=\"vm.currentView\" \nlayout=\"column\" flex><form name=\"vm.companyForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\" \nng-submit=\"vm.updateCompany()\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"action-buttons\" layout=\"row\" layout-align=\"start center\" ng-show=\"vm.company\" \nhide show-gt-xs><span class=\"md-title\">{{vm.company.address.name}}</span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-warn md-raised\" type=\"submit\" ng-show=\"vm.selectedTab != 2\" \nng-disabled=\"!vm.companyForm.$dirty || !vm.companyForm.$valid\" translate=\"APP.SAVE\">Speichern</md-button></div></div>\n<div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex>\n<div class=\"content\" ng-if=\"vm.loadingCompanies\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><md-tabs layout-fill md-selected=\"vm.selectedTab\" ng-if=\"!vm.loadingMaterial\" flex>\n<md-tab label=\"{{ \'COMPANY.ADDRESS\' | translate }}\"><md-tab-body><ng-include \nsrc=\"\'app/main/partners.general/views/partials/company-address.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nlabel=\"{{ \'COMPANY.PERSONS\' | translate }}\"><md-tab-body><ng-include \nsrc=\"\'app/main/partners.general/views/partials/company-persons.html\'\"></ng-include></md-tab-body></md-tab></md-tabs>\n</md-content></div></form></div></div></div>");
$templateCache.put("app/main/partners.general/components/nuit-email.html","<div><span ng-show=\"vm.addLabel===true\"><span translate=\"ACCOUNT.USER_EMAIL\">EMail</span>:</span> <a \nhref=\"mailto:{{vm.email}}\" ng-click=\"$event.stopPropagation()\">{{vm.email}}</a></div>");
$templateCache.put("app/main/partners.general/components/nuit-person.form.html","<div layout=\"row\" layout-margin><md-input-container flex><label translate=\"ACCOUNT.USER_EMAIL\">Email</label><input \ntype=\"email\" name=\"email\" ng-model=\"vm.person.email\" ng-required=\"vm.person.password\" \nng-disabled=\"!vm.mandatoryPassword && vm.showPasswordInput()\" autocomplete=\"new-email\" \nng-change=\"(vm.person.email && vm.person.email.length>0 && vm.onEmailChanged)?vm.onEmailChanged():undefined\" \nng-model-options=\"{ debounce: 350 }\"></md-input-container><div ng-if=\"vm.showRestoreUserWarning\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon class=\"red-500-fg\" md-font-icon=\"icon-alert\"></md-icon><div flex \nclass=\"md-block\" translate=\"ACCOUNT.RESTORE_USER_WARNING\"></div></div></div><div layout=\"row\" layout-margin \nclass=\"pb-20\"><md-input-container flex><label translate=\"APP.LANG\">Lang</label><md-select ng-model=\"vm.person.locale\" \nrequired><md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{ lang }}\n</span></md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.roles.length > 0\"><label \ntranslate=\"ACCOUNT.USER_ROLE\">Role</label><md-select ng-model=\"vm.person.roleId\" required><md-option \nng-repeat=\"role in vm.roles track by role.id\" ng-value=\"role.id\" ng-if=\"role.type===1 && !vm.forwarder\">\n{{ role.name[vm.translation.language]}}</md-option><md-option ng-repeat=\"role in vm.roles track by role.id\" \nng-value=\"role.id\" ng-if=\"role.type===2 && vm.forwarder\">{{ role.name[vm.translation.language]}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-margin><md-input-container flex><label \ntranslate=\"ACCOUNT.USER_FIRSTNAME\">Firstname</label><input type=\"text\" name=\"firstname\" ng-model=\"vm.person.firstName\">\n</md-input-container><md-input-container flex><label translate=\"ACCOUNT.USER_SURNAME\">Lastname</label><input \ntype=\"text\" name=\"lastname\" ng-model=\"vm.person.lastName\"></md-input-container><md-input-container flex><label \ntranslate=\"ACCOUNT.USER_GENDER\">Gender</label><md-select ng-model=\"vm.person.gender\"><md-option ng-value=\"2\" \ntranslate=\"GENDER.MALE\">Male</md-option><md-option ng-value=\"1\" translate=\"GENDER.FEMALE\">Female</md-option><md-option \nng-value=\"0\" translate=\"GENDER.UNKNOWN\">Unknown</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-margin><div layout=\"row\"><md-input-container flex><label translate=\"ACCOUNT.PHONE\">Phone</label><input \ntype=\"text\" name=\"phone\" ng-model=\"vm.person.phone\"></md-input-container><md-input-container flex><label \ntranslate=\"ACCOUNT.MOBILE\">Mobile</label><input type=\"text\" name=\"mobile\" ng-model=\"vm.person.mobile\">\n</md-input-container></div></div><md-switch style=\"padding-left: 8px\" ng-if=\"vm.mandatoryPassword\" \nng-model=\"vm.disableLogin\" flex ng-change=\"vm.onDisableLogin()\"><label translate=\"ACCOUNT.DISABLE_LOGIN\">\nChange password</label></md-switch><div layout=\"column\" layout-margin layout-fill ng-if=\"vm.showPasswordInput()\">\n<md-switch style=\"padding-left: 8px\" ng-if=\"!vm.mandatoryPassword\" ng-model=\"vm.changePassword\" flex><label \ntranslate=\"USERS.SECURITY\">Change password</label></md-switch><div layout=\"column\" \nng-if=\"(vm.mandatoryPassword || vm.changePassword) && !vm.disableLogin\"><h2 ng-if=\"!vm.mandatoryPassword\" \ntranslate=\"USER.LOGIN\" class=\"ng-scope\">Passwort ändern</h2><div layout=\"row\"><md-input-container flex><label \ntranslate=\"ACCOUNT.USER_PASSWORD\">Password</label><input autocomplete=\"new-password\" type=\"password\" name=\"password\" \nng-model=\"vm.person.password\" ng-required=\"vm.mandatoryPassword\"></md-input-container><md-input-container flex \nflex-offset=\"5\"><label translate=\"ACCOUNT.PASSWORD_REPEAT\">Passwort-Repeat</label><input type=\"password\" \nname=\"passwordRepeat\" ng-model=\"vm.person.passwordRepeat\" ng-required=\"vm.mandatoryPassword\"></md-input-container><div>\n<md-button class=\"md-primary md-raised\" aria-label=\"\" translate=\"APP.CHANGE\" ng-if=\"vm.changePassword\" \nng-disabled=\"!vm.isPasswordChangeable()\" ng-click=\"vm.updatePassword()\"></md-button></div></div><div layout=\"row\" \nlayout-margin layout-fill layout-align=\"center center\" \nng-if=\"\n        (vm.changePassword || vm.mandatoryPassword) &&\n            vm.person.password.length>0 &&\n            vm.person.password!==vm.person.passwordRepeat\" \ntranslate=\"ACCOUNT.PASSWORD_MATCH_MANDATORY\" flex>passwords have to match</div><div layout=\"column\" \nng-if=\"!vm.mandatoryPassword\"><h2 translate=\"USER.NEW_EMAIL\">Email ändern</h2><div layout=\"row\"><md-input-container \nflex=\"25\"><label translate=\"ACCOUNT.USER_EMAIL_NEW\">Email new</label><input autocomplete=\"new-email\" type=\"email\" \nname=\"newEmail\" ng-model=\"vm.newEmail\"></md-input-container><md-input-container flex=\"25\" flex-offset=\"5\"><label \ntranslate=\"ACCOUNT.PASSWORD\">Passwort</label><input autocomplete=\"new-password\" type=\"password\" name=\"password\" \nng-model=\"vm.passwordForEmail\"></md-input-container><md-input-container flex=\"25\" flex-offset=\"5\"><label \ntranslate=\"ACCOUNT.PASSWORD_REPEAT\">Passwort</label><input type=\"password\" name=\"passwordRepeat\" \nng-model=\"vm.passwordRepeatForEmail\"></md-input-container><div><md-button class=\"md-primary md-raised\" aria-label=\"\" \ntranslate=\"APP.CHANGE\" ng-disabled=\"!vm.isEmailChangeable()\" ng-click=\"vm.changeEmail()\"></md-button></div></div><div \nlayout=\"row\" layout-margin layout-fill layout-align=\"center center\" \nng-if=\"\n        	vm.changePassword &&\n            vm.passwordForEmail.length>0 &&\n            vm.passwordForEmail!==vm.passwordRepeatForEmail\" \ntranslate=\"ACCOUNT.PASSWORD_MATCH_MANDATORY\" flex>passwords have to match</div></div></div><div layout=\"row\"></div>\n</div>");
$templateCache.put("app/main/partners.general/components/nuit-phone.html","<div><span ng-show=\"vm.addLabel===true\"><span translate=\"ADDRESS.CONTACT_PHONE\">Telephone</span>:</span> <a \nhref=\"tel:{{vm.phone}}\" ng-click=\"$event.stopPropagation()\">{{vm.phone}}</a></div>");
$templateCache.put("app/main/partners.general/views/person-compose.html","<md-dialog id=\"person-dialog\" style=\"width:70%\"><md-toolbar class=\"md-accent-bg pl-24\" layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"vm.person.id == null\"><span class=\"title\" translate=\"APP.ADD\"></span></div><div\n ng-if=\"vm.person.id != null\"><span class=\"title\" translate=\"APP.EDIT\"></span></div></md-toolbar><form \nstyle=\"margin-top:40px\" name=\"vm.personForm\" novalidate ng-model-options=\"{debounce:200}\" \nng-submit=\"vm.deletedUser===null?vm.savePerson():vm.restorePerson()\"><md-content><nuit-person-form person=\"vm.person\" \nmandatory-password=\"vm.newPerson\" forwarder=\"vm.forwarder\" on-person-updated=\"vm.updateCachedPerson()\" \non-email-changed=\"vm.updateEmailState()\" show-restore-user-warning=\"vm.deletedUser!==null\"></nuit-person-form>\n</md-content><md-dialog-actions><div layout=\"row\" layout-align=\"space-between start\"><md-button class=\"md-raised\" \nng-click=\"vm.hide()\" translate=\"APP.CANCEL\">Cancel</md-button><md-button ng-if=\"!vm.deletedUser\" \nclass=\"md-warn md-raised\" ng-disabled=\"!vm.personForm.$valid || vm.loadingDeletedUser\" type=\"submit\" \ntranslate=\"APP.SAVE\">Save</md-button><md-button ng-if=\"vm.deletedUser\" class=\"md-warn md-raised\" type=\"submit\" \ntranslate=\"APP.RESTORE\" ng-disabled=\"!vm.personForm.$valid || vm.loadingDeletedUser\">Restore</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners.transport/views/delivery-configuration.html","<div id=\"system\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\" flex><span \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"TRANSPORT.CONFIGURATION_NAV\" flex>Transport Config</span></div><md-button class=\"md-raised\" \nng-if=\"vm.currentTab === \'delay\'\" ng-click=\"vm.addPostalCodeDelay()\"><span translate=\"TRANSPORT.ADD_DELAY\">\nAdd Translation</span></md-button><md-button class=\"md-raised\" ng-if=\"vm.currentTab === \'number\'\" \nng-click=\"vm.addDeliveryNumber()\"><span translate=\"TRANSPORT.ADD_DELIVERY_NUMBER\">Add delivery number</span>\n</md-button></div><div class=\"content\" flex layout=\"column\"><md-tabs layout-fill flex><md-tab \nmd-active=\"vm.currentTab === \'delay\'\" ui-sref=\"app.transport-config({active:\'delay\'})\"><md-tab-label><span \ntranslate=\"TRANSPORT.DELIVERY_DELAY\">Delivery Delay</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/partners.transport/views/tabs/delivery-delay.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nmd-active=\"vm.currentTab === \'number\'\" ui-sref=\"app.transport-config({active:\'number\'})\"><md-tab-label><span \ntranslate=\"TRANSPORT.DELIVERY_NUMBER\">Liefernummer</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/partners.transport/views/tabs/delivery-number-list.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nmd-active=\"vm.currentTab === \'config\'\" ui-sref=\"app.transport-config({active:\'config\'})\"><md-tab-label><span \ntranslate=\"TRANSPORT.DELIVERY_CONFIG\">Lieferkonfiguration</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/partners.transport/views/tabs/delivery-configuration-configurations.html\'\"></ng-include></md-tab-body>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/partners.transport/views/forwarders-delivery-board.html","<div ng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...</span></div><md-content id=\"delivery-board\" \nclass=\"page-layout simple tabbed\" flex ng-if=\"!vm.loading\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\">\n<md-icon md-font-icon=\"icon-calendar-text\" class=\"icon\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"TRANSPORT.DELIVERY_BOARD\">Invoice boards</span></div><div class=\"search-white\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input\" flex ng-model=\"vm.deliverySearchTerm\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.searchForDelivery()\" ng-model-options=\"{debounce:100}\"></div><div\n layout=\"row\" class=\"delivery-board-filter bb\"><div class=\"mr-15 pt-20\"><md-icon md-font-icon=\"icon-filter\"></md-icon>\n</div><div class=\"mr-20\" ng-if=\"vm.carrierId === null\"><md-input-container style=\"min-width: 150px !important\"><label \ntranslate=\"FORWARDERS.FORWARDERS_NAV\"></label><md-select ng-model=\"vm.searchForwarder\" \nng-change=\"vm.onChangeForwarderSearch()\"><md-option ng-value=\"\'all\'\">All</md-option><md-option \nng-repeat=\"delCompany in vm.deliveryCompanies track by delCompany.id\" ng-value=\"delCompany.id\"><span>\n{{ delCompany.name }}</span></md-option></md-select></md-input-container></div><div><md-input-container \nstyle=\"min-width: 150px !important\"><label translate=\"INVOICE.STATUS\"></label><md-select ng-model=\"vm.statusSelection\" \nng-change=\"vm.onChangeForwarderSearch()\"><md-option ng-value=\"\'all\'\">All</md-option><md-option \nng-repeat=\"status in vm.statis track by status.id\" ng-value=\"status.id\" ng-if=\"status.id !== 1\"><span>\n{{ \'TRANSPORT.\' + status.type.toUpperCase() | translate}}</span></md-option></md-select></md-input-container></div>\n</div></div><div class=\"content-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" style=\"padding: 2px 10px\" flex=\"80\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\" class=\"mr-40\"><div layout=\"row\" class=\"pl-5\"><span translate=\"INVOICE.CALENDAR_WEEK\">KW\n</span> <span class=\"ph-5\">{{vm.calendarWeek}}</span></div><md-button class=\"md-icon-button arrow previous-button\" \nng-click=\"vm.previousWeek()\" aria-label=\"Previous\" style=\"margin-right: 0 !important\" translate \ntranslate-attr-aria-label=\"PLANNING.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"PLANNING.PREVIOUS\"></span></md-tooltip></md-button><md-button class=\"md-icon-button arrow next-button\" \nng-click=\"vm.showCurrentWeek()\" aria-label=\"Next\" translate translate-attr-aria-label=\"PLANNING.TODAY\" \nstyle=\"margin: 0 !important\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span \ntranslate=\"PLANNING.TODAY\"></span></md-tooltip></md-button><md-button class=\"md-icon-button arrow next-button\" \nng-click=\"vm.nextWeek()\" aria-label=\"Next\" translate translate-attr-aria-label=\"PLANNING.NEXT\" \nstyle=\"margin-left: 0 !important\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span \ntranslate=\"PLANNING.NEXT\"></span></md-tooltip></md-button><div class=\"planning-title\">{{ vm.planningTimeframe }}</div>\n</div></div><div layout=\"row\" layout-align=\"end center\" flex ng-if=\"vm.selectedItems && vm.selectedItems.length > 0\" \nclass=\"mr-20\"><md-button style=\"margin: 4px !important\" class=\"md-raised md-accent\" \nng-click=\"vm.changeStatus(vm.selectedItems)\"><span translate=\"ACCOUNTING.CHANGE_STATUS\">Update status</span>\n</md-button></div></div><div layout-gt-sm=\"row\" layout=\"column\" ng-if=\"vm.currentWeek && vm.currentWeek.length > 0\" \nclass=\"planning-week\" ms-scroll><md-card layout=\"column\" ng-repeat=\"day in vm.currentWeek\" class=\"planning-day\" \nng-class=\"{\'current-day\': day.timestampMin === vm.currentDay}\"><md-card-header class=\"bb\" \nng-class=\"{\'current-day-header\': day.timestampMin === vm.currentDay}\"><md-card-header-text><span \nclass=\"md-title text-center\">{{ day.translationKey | translate }}, {{ day.dateFormatted }}</span></md-card-header-text>\n</md-card-header><md-content ms-scroll style=\"background-color: transparent !important\"><md-card-content><div \nclass=\"invoice-widget-container\"><ms-widget flippable=\"true\" \nng-repeat=\"pe in day.deliveries | orderBy:\'statusType\' track by pe.id \" flex=\"100\" layout=\"row\" \nng-attr-id=\"{{ pe.id }}\"><ms-widget-front class=\"front\" ng-click=\"flipWidget();vm.flipWidget(pe);\"><div flex=\"100\" \nlayout=\"row\" class=\"{{pe.statusType.toLowerCase()}} delivery-ticket\"><md-checkbox class=\"no-label\" \nng-if=\"vm.carrierId === null\" ng-disabled=\"vm.disable.includes(pe.status)\" ng-checked=\"vm.isSelected(pe)\" \nng-click=\"$event.stopPropagation();vm.toggleEvent(pe)\" aria-label=\"{{ vm.isSelected(pe) ? \'Deselect\' : \'Select\' }}\">\n</md-checkbox><div layout=\"column\" layout-align=\"start start\" flex><div layout=\"row\" layout-wrap \nclass=\"p-5 mr-8 brad-2 pa-text\" layout-align=\"start center\"><div ng-if=\"vm.carrierId===null\"><md-icon \nng-if=\"pe.deliveryType === \'DELIVERY\'\" md-font-icon=\"icon-truck\" class=\"delivery-fg mr-10\"></md-icon><md-icon \nng-if=\"pe.deliveryType === \'PICKUP\'\" md-font-icon=\"icon-car\" class=\"pickup-fg mr-10\"></md-icon></div><div \nclass=\"{{pe.statusType.toLowerCase()}}-text ph-5 mr-5\">{{pe.number}}</div><div \nng-class=\"{\'overdue\': (pe.overdueDays > 0 && pe.status !== 4)}\">- {{ \'TRANSPORT.\' + pe.statusType | translate }}</div>\n</div><div class=\"pv-5\" style=\"font-size: 1.2rem\" layout=\"column\"><div \nng-if=\"pe.deliveryType === \'DELIVERY\' && vm.carrierId === null\">{{ pe.carrier }}</div><span>\n{{pe.orderNumber ? pe.orderNumber : pe.orderId}} - {{pe.name}}</span><div layout=\"column\"><div>\n{{pe.address.companyname}}</div><div layout=\"row\">{{pe.address.zip}} {{pe.address.city}}</div></div></div></div>\n<md-icon-button style=\"cursor: pointer\" class=\"m-0 p-0\" ng-if=\"vm.carrierId === null\" \nng-click=\"$event.stopPropagation(); vm.openDetails(pe.orderId)\"><md-icon class=\"m-0\" md-font-icon=\"icon-open-in-new\">\n</md-icon><md-tooltip><span translate=\"TRANSPORT.DETAILS\"></span></md-tooltip></md-icon-button></div></ms-widget-front>\n<ms-widget-back flex class=\"\" ng-click=\"flipWidget();vm.flipWidget(pe);\"><div layout=\"column\" \nclass=\"{{pe.statusType.toLowerCase()}}-back delivery-ticket\"><div layout=\"row\" flex=\"100\"><md-checkbox \nclass=\"no-label\" ng-if=\"vm.carrierId === null\" ng-checked=\"vm.isSelected(pe)\" \nng-click=\"$event.stopPropagation();vm.toggleEvent(pe)\" aria-label=\"{{ vm.isSelected(pe) ? \'Deselect\' : \'Select\' }}\">\n</md-checkbox><div layout=\"column\" layout-align=\"start start\" flex><div layout=\"row\" layout-wrap \nclass=\"p-5 mr-8 brad-2 pa-text\" layout-align=\"start center\"><div ng-if=\"vm.carrierId===null\"><md-icon \nng-if=\"pe.deliveryType === \'DELIVERY\'\" md-font-icon=\"icon-truck\" class=\"delivery-fg mr-10\"></md-icon><md-icon \nng-if=\"pe.deliveryType === \'PICKUP\'\" md-font-icon=\"icon-car\" class=\"pickup-fg mr-10\"></md-icon></div><div \nclass=\"{{pe.statusType.toLowerCase()}}-text ph-5 mr-5\">{{pe.number }}</div><div \nng-class=\"{\'overdue\': (pe.overdueDays > 0 && pe.status !== 4)}\">- {{ \'TRANSPORT.\' + pe.statusType | translate }}</div>\n</div></div><md-icon-button style=\"cursor: pointer\" class=\"m-0 p-0\" ng-if=\"vm.carrierId === null\" \nng-click=\"$event.stopPropagation(); vm.openDetails(pe.orderId)\"><md-icon class=\"m-0\" md-font-icon=\"icon-open-in-new\">\n</md-icon><md-tooltip><span translate=\"TRANSPORT.DETAILS\"></span></md-tooltip></md-icon-button></div><div \nclass=\"mt-10 ml-10\"><div layout=\"column\"><div layout=\"row\"><div \nng-if=\"pe.deliveryType === \'DELIVERY\' && vm.carrierId === null\">{{pe.carrier }}</div></div><span>\n{{pe.orderNumber ? pe.orderNumber : pe.orderId}} - {{pe.name}}</span><div ng-if=\"pe.deliveryType === \'PICKUP\'\">\n{{pe.address.companyname}}</div></div><md-divider class=\"mt-10 mb-5\"></md-divider><div layout=\"row\" \nng-if=\"pe.deliveryType === \'DELIVERY\'\"><span translate=\"TRANSPORT.SHIPPING_DATE\"></span> <span>\n: {{ pe.shippingDate | nuitDatetime: vm.config.localization.dateFormat }}</span></div><div layout=\"row\"><span \ntranslate=\"TRANSPORT.DELIVERY_DATE\"></span> <span>\n: {{ pe.deliveryDate | nuitDatetime: vm.config.localization.dateFormat }}</span></div><div layout=\"row\"><span \ntranslate=\"TRANSPORT.DELIVERY_DIMENSION\"></span> <span>: {{pe.dimension}}</span></div><div layout=\"row\" \nng-if=\"pe.weight\"><span translate=\"TRANSPORT.DELIVERY_WEIGHT\"></span> <span>: {{pe.weight | nuitUnit:\'weight\' }}</span>\n</div><div layout=\"row\"><span translate=\"TRANSPORT.DELIVERY_PACKAGE_UNITS\"></span> <span>: {{pe.packageUnits }}</span>\n</div><div layout=\"column\"><div layout=\"row\"><span translate=\"TRANSPORT.DELIVERY_ADDRESS\"></span>:</div><nuit-address \nclass=\"pl-10\" address=\"pe.address\" show-address-name=\"pe.address.companyname === null\" \naddress-format=\"vm.config.ims.transport.delivery.details.addressFormat\" \naddress-format-by-country=\"vm.config.ims.transport.delivery.details.addressFormatByCountry\"></nuit-address></div></div>\n</div></ms-widget-back></ms-widget></div></md-card-content></md-content></md-card></div></md-content>");
$templateCache.put("app/main/partners.transport/views/forwarders-details.html","<div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex><form name=\"vm.forwarderForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"app.transport\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" ng-show=\"vm.forwarder\" hide show-gt-xs><div \nclass=\"divider-vertical mr-20\"></div><span class=\"md-title\">{{vm.forwarder.name}}</span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-warn md-raised\" type=\"submit\" ng-show=\"vm.selectedTab === 0\" \nng-disabled=\"!vm.forwarderForm.$dirty || !vm.forwarderForm.$valid\" ng-click=\"vm.updateForwarder()\" \ntranslate=\"APP.SAVE\">Speichern</md-button><md-button class=\"md-raised md-accent\" ng-show=\"vm.selectedTab === 1\" \nng-click=\"vm.showPersonDialog(null)\" translate=\"APP.ADD\">Add</md-button></div></div><div class=\"content-wrapper\" \nlayout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex><div class=\"content\" \nng-if=\"vm.loadingForwarder\" flex><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-tabs \nlayout-fill md-selected=\"vm.selectedTab\" ng-if=\"!vm.loadingForwarder\" flex><md-tab \nlabel=\"{{ \'COMPANY.ADDRESS\' | translate }}\" ui-sref=\"{{\'app.transport\'}}.details({active:\'address\'})\" \nmd-active=\"vm.currentTab === \'address\'\"><ng-include \nsrc=\"\'app/main/partners.transport/views/partials/forwarders-details-general.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'COMPANY.PERSONS\' | translate }}\" ui-sref=\"{{\'app.transport\'}}.details({active:\'persons\'})\" \nmd-active=\"vm.currentTab === \'persons\'\"><md-tab-body><ng-include \nsrc=\"\'app/main/partners.transport/views/partials/forwarders-details-contactpersons.html\'\"></ng-include></md-tab-body>\n</md-tab><md-tab label=\"{{ \'TRANSPORT.DELIVERY_NOTES\' | translate}}\" \nui-sref=\"{{\'app.transport\'}}.details({active:\'delivery\'})\" md-active=\"vm.currentTab === \'delivery\'\"><ng-include \nsrc=\"\'app/main/partners.transport/views/partials/forwarders-details-deliveries.html\'\"></ng-include></md-tab></md-tabs>\n</md-content></div></form></div>");
$templateCache.put("app/main/partners.transport/views/forwarders-list.html","<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-truck\" \nclass=\"mr-16 md-background-fg\"></md-icon><span class=\"logo-text text-truncate\" translate=\"FORWARDERS.FORWARDERS_NAV\">\nForwarders</span></div><div class=\"compose-button\"><md-button class=\"md-raised\" aria-label=\"compose\" \nui-sref=\"app.transport.compose({type: \'forwarders\'})\" translate=\"APP.ADD\">ADD NEW FORWARDER</md-button></div></div><div\n class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><span class=\"ml-16 grey-600-fg\" flex \ntranslate=\"FORWARDERS.FORWARDERS_NAV\"></span> <span class=\"ml-16 grey-600-fg\" flex translate=\"APP.EMAIL\"></span> <span \nclass=\"ml-16 grey-600-fg\" flex translate=\"APP.PHONE\"></span></div><div layout=\"row\" layout-align=\"end center\" \nflex=\"35\"><nuit-pagination all-entities=\"vm.filteredEntities\" current-page-entities=\"vm.currentPageEntities\" \ncurrent-page=\"vm.currentPage\" , entities-per-page=\"10\" , lacy-load-entity=\"vm.loadForwarder(entity)\" \nterm-to-set=\"vm.paginationTerm\" allow-skipping=\"true\"></nuit-pagination></div></div><div class=\"content-wrapper\" \nlayout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.loadingEntities\" \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"vm.filteredEntities.length === 0 && !vm.filteredEntities\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\">There are no partners yet!</span></div><div \nclass=\"thread unread\" style=\"cursor: default\" ng-if=\"!vm.loadingEntities\" \nng-repeat=\"forwarder in vm.currentPageEntities\" ng-class=\"{\'selected\': vm.isSelected(company)}\"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><div class=\"info\" layout=\"column\" flex><span class=\"text-bold\" \nng-if=\"forwarder.name!==null\">{{forwarder.name}}</span><nuit-address address=\"vm.getStandardAddress(forwarder)\" \nshow-address-name=\"forwarder.name===null\" address-format=\"vm.config.ims.transport.forwarder.details.addressFormat\" \naddress-format-by-country=\"vm.config.ims.transport.forwarder.details.addressFormatByCountry\"></nuit-address></div><div \nclass=\"info\" layout=\"column\" flex><nuit-email email=\"forwarder.email\"></nuit-email></div><div class=\"info\" \nlayout=\"column\" flex><nuit-phone phone=\"forwarder.phone\"></nuit-phone></div><div layout=\"row\" \nlayout-align=\"end center\" flex=\"35\"><div layout=\"row\" ng-show=\"forwarder.users.length>0\"><span \ntranslate=\"COMPANY.PERSONS\"></span> <span>&nbsp;</span> <span>({{forwarder.users.length}})</span></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openDetail(forwarder.id);$event.stopPropagation();\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"APP.EDIT\">Edit</span></md-tooltip></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.delForwarder(forwarder);$event.stopPropagation();\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button>\n</div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/production.general/views/shop-order-detail.html","<md-dialog style=\"width:80%;height:80%\"><div ng-if=\"vm.inProgress\" \nstyle=\"position:absolute; width: 100%; height: 100%; opacity: 0.5; background: white; z-index: 10\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div><form name=\"vm.orderForm\" flex><md-toolbar layout=\"row\" \nlayout-align=\"space-between center\" class=\"md-accent\"><span class=\"md-title pl-16\">{{vm.getTitle(vm.order)}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.hide()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-toolbar><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex><div \nclass=\"content\" ng-if=\"vm.loadingItems\" flex><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n<span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-tabs \nlayout-fill ng-if=\"!vm.loadingMaterial\"><md-tab label=\"{{ \'ORDERS.DETAILS\' | translate }}\" \nmd-active=\"vm.currentTab === \'detail\'\" ng-if=\"vm.config.ims.orders.details.enabled\"><ng-include \nsrc=\"\'app/main/orders.orders/views/partials/details.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'ORDERS.POSITIONS\' | translate }}\" md-active=\"vm.currentTab === \'positions\'\" \nng-if=\"vm.config.ims.orders.positions.enabled\"><ng-include \nsrc=\"\'app/main/orders.orders/views/partials/positions.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'ORDERS.EASY\' | translate }}\" md-active=\"vm.currentTab === \'positions\'\" \nng-if=\"vm.config.ims.orders.easy.enabled\"><ng-include src=\"\'app/main/orders.orders/views/partials/easy.html\'\">\n</ng-include></md-tab></md-tabs></md-content></div></div></div><md-dialog-footer layout=\"row\" class=\"grey-200-bg\" \nlayout-align=\"center center\" ng-if=\"vm.showSaveButton()\"><md-button type=\"reset\" class=\"md-raised\" \nng-click=\"vm.hide()\">{{ (vm.cancelOnClose?\'APP.CANCEL\':\'APP.CLOSE\') | translate }}</md-button><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.updateOrder()\" ng-disabled=\"!vm.canSave()\" translate=\"APP.SAVE\">Speichern\n</md-button></md-dialog-footer></form></md-dialog>");
$templateCache.put("app/main/production.machines/views/bending-machine-list.html","<div id=\"machines\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\" flex><div class=\"logo-icon\"><md-icon md-font-icon=\"icon-oil\" \nclass=\"icon\"></md-icon></div><span class=\"logo-text\" translate=\"MACHINES.BENDING_MACHINES\" flex>Machines</span></div>\n<md-button class=\"md-icon-button\" aria-label=\"nuLink Twin Debug\" ng-click=\"vm.openTwinDebug($event)\"><md-icon \nmd-font-icon=\"icon-bug\"></md-icon><md-tooltip><span>nuLink Twin (Debug)</span></md-tooltip></md-button><md-button \nclass=\"md-raised\" ui-sref=\"app.machines.bending.add\"><span translate=\"MACHINES.ADD_BENDING_MACHINE\">Add Bending Machine\n</span></md-button></div><div layout=\"column\" layout-fill class=\"content-card\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedMachines.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedMachines.length > 0\" ng-click=\"vm.toggleSelectedTemplates()\"></md-checkbox><div layout=\"row\" \nng-if=\"vm.selectedMachines.length > 0\" layout-align=\"start center\"><div class=\"divider-vertical ml-20\"></div><md-button\n class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><div class=\"content\" ms-scroll flex><div class=\"content\" \nng-if=\"vm.loadingBendingMachines\" flex layout-fill><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><md-content ms-scroll ng-if=\"!vm.loading\"><div layout=\"column\" \nng-if=\"vm.bendingMachines.length === 0\" class=\"p-16\"><h1>Woops! No bending machines found. Wanna <a \nui-sref=\"app.machines.bending.add\">create one</a>?</h1></div><div layout=\"column\" \nng-if=\"vm.bendingMachines.length > 0\"><div class=\"ph-24 h-100 bb\" ng-repeat=\"machine in vm.bendingMachines\" \nlayout=\"row\" layout-align=\"start center\" style=\"cursor:pointer\" \nui-sref=\"app.machines.bending.details({machineId:machine.id})\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isSelected(machine)\" ng-click=\"vm.toggleSelectedTemplate(machine, $event)\" \naria-label=\"{{vm.isSelected(machine) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div layout=\"column\" class=\"ml-20\"><div \nlayout=\"row\"><span class=\"md-title mr-10\">{{ machine.name }}</span> <span class=\"md-title\" \nng-if=\"machine.shortName && machine.shortName.length>0\">({{machine.shortName}})</span></div><div \nclass=\"h4 secondary-text text-italic pt-8\"><span ng-if=\"machine.enabled\" translate=\"MACHINE.ENABLED\">Enabled</span> \n<span ng-if=\"!machine.enabled\" translate=\"MACHINE.DISABLED\">Disabled</span></div></div></div></div></md-content></div>\n</div></div></div></div>");
$templateCache.put("app/main/production.machines/views/coil-machine-list.html","<div id=\"machines\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"logo-icon\"><md-icon md-font-icon=\"icon-oil\" class=\"icon\">\n</md-icon></div><span class=\"logo-text\" translate=\"MACHINES.COIL_MACHINES\" flex>Machines</span></div><md-button \nclass=\"md-raised\" ui-sref=\"app.machines.coil.add\"><span translate=\"MACHINES.ADD_COIL_MACHINE\">Add Bending Machine\n</span></md-button></div><div layout=\"column\" layout-fill flex class=\"content-card\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedMachines.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedMachines.length > 0\" ng-click=\"vm.toggleSelectedTemplates()\"></md-checkbox><div layout=\"row\" \nng-if=\"vm.selectedMachines.length > 0\" layout-align=\"start center\"><div class=\"divider-vertical ml-20\"></div><md-button\n class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div></div><md-content \nclass=\"content-wrapper\" layout=\"column\" flex><md-content ms-scroll flex><div class=\"content\" \nng-if=\"vm.loadingCoilMachines\" flex layout-fill><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><div ng-if=\"!vm.loading\" flex><div layout=\"column\" ng-if=\"vm.coilMachines.length === 0\" \nclass=\"p-16\"><h1>Woops! No coil machines found. Wanna <a ui-sref=\"app.machines.coil.add\">create one</a>?</h1></div><div\n layout=\"column\" ng-if=\"vm.coilMachines.length > 0\" class=\"mb-100\"><div class=\"ph-24 h-100 bb\" \nng-repeat=\"machine in vm.coilMachines\" layout=\"row\" layout-align=\"start center\" style=\"cursor:pointer\" \nui-sref=\"app.machines.coil.details({machineId:machine.id})\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isSelected(machine)\" ng-click=\"vm.toggleSelectedTemplate(machine, $event)\" \naria-label=\"{{vm.isSelected(machine) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div layout=\"column\" class=\"ml-20\"><span \nclass=\"md-title\">{{ machine.name }}</span><div class=\"h4 secondary-text text-italic pt-8\"><span \nng-if=\"machine.enabled\" translate=\"MACHINE.ENABLED\">Enabled</span> <span ng-if=\"!machine.enabled\" \ntranslate=\"MACHINE.DISABLED\">Disabled</span></div></div></div></div></div></md-content></md-content></div></div></div>");
$templateCache.put("app/main/production.machines/views/punching-machine-list.html","<div id=\"machines\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"logo-icon\"><md-icon md-font-icon=\"icon-oil\" class=\"icon\">\n</md-icon></div><span class=\"logo-text\" translate=\"MACHINES.PUNCHING_MACHINES\" flex>Machines</span></div><md-button \nclass=\"md-raised\" ui-sref=\"app.machines.punching.add\"><span translate=\"MACHINES.ADD_PUNCHING_MACHINE\">\nAdd Bending Machine</span></md-button></div><div layout=\"column\" layout-fill flex class=\"content-card\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selectedMachines.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedMachines.length > 0\" ng-click=\"vm.toggleSelectedTemplates()\"></md-checkbox><div layout=\"row\" \nng-if=\"vm.selectedMachines.length > 0\" layout-align=\"start center\"><div class=\"divider-vertical ml-20\"></div><md-button\n class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div></div><md-content \nclass=\"content-wrapper\" layout=\"column\" flex><md-content ms-scroll flex><div class=\"content\" \nng-if=\"vm.loadingPunchingMachines\" flex layout-fill><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><div ng-if=\"!vm.loading\" flex><div layout=\"column\" \nng-if=\"vm.punchingMachines.length === 0\" class=\"p-16\"><h1>Woops! No punching machines found. Wanna <a \nui-sref=\"app.machines.punching.add\">create one</a>?</h1></div><div layout=\"column\" \nng-if=\"vm.punchingMachines.length > 0\" class=\"mb-100\"><div class=\"ph-24 h-100 bb\" \nng-repeat=\"machine in vm.punchingMachines\" layout=\"row\" layout-align=\"start center\" style=\"cursor:pointer\" \nui-sref=\"app.machines.punching.details({machineId:machine.id})\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isSelected(machine)\" ng-click=\"vm.toggleSelectedTemplate(machine, $event)\" \naria-label=\"{{vm.isSelected(machine) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div layout=\"column\" class=\"ml-20\"><span \nclass=\"md-title\">{{ machine.name }}</span><div class=\"h4 secondary-text text-italic pt-8\"><span \nng-if=\"machine.enabled\" translate=\"MACHINE.ENABLED\">Enabled</span> <span ng-if=\"!machine.enabled\" \ntranslate=\"MACHINE.DISABLED\">Disabled</span></div></div></div></div></div></md-content></md-content></div></div></div>");
$templateCache.put("app/main/production.orders/views/production-order-part.html","<div id=\"production-order\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"app.production-orders.details({orderId:vm.origin!==null?vm.origin:vm.order.id})\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button></div></div><div class=\"content-wrapper\" layout=\"column\" \nflex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex><div class=\"content\" ng-if=\"vm.loading\" flex>\n<div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><div \nlayout=\"row\" layout-wrap ng-if=\"!vm.loading\"><div layout=\"row\" layout-margin layout-align=\"start start\"><div \nlayout=\"column\" class=\"m-0 p-0\" layout-fill><nuit-profile-preview profile=\"vm.profile.profile\" class=\"m-8\"><img \nhttp-src=\"{{vm.profile.profile | profileImage}}\" alt=\"\" \nfallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\" class=\"w-400 b\" \nng-click=\"vm.openImage(vm.profile.profile | profileImage)\"></nuit-profile-preview></div></div><div layout=\"column\" \nclass=\"mt-10\" flex-grow layout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.PROFILE_ID\">ID</span>: <span class=\"text-bold ml-8\">\n{{::vm.profile.profile | shortName}}</span></div><div layout=\"row\" layout-align=\"start center\" class=\"pl-20 pb-5 h-30\">\n<div class=\"w-15 h-15 b\" style=\"background-color:{{::vm.profile.profile.material.colors.front.hex}}\"></div><span \nclass=\"text-bold ml-8\">{{vm.profile.profile.material.name | nuitTranslate}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.PROFILE_BLANK\">Blank</span>: \n<span class=\"text-bold pl-8\">{{::vm.profile.profile | nuitBlank}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.LENGTH\">Length</span>: <span \nclass=\"text-bold pl-8\">{{::vm.profile.profile.length | nuitUnit:\'length\'}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.WEIGHT\">Weight</span>: <span \nclass=\"text-bold pl-8\">{{::vm.profile.profile.weight | nuitUnit:\'weight\'}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.TILTINGS_COUNT\">tiltings</span>\n: <span class=\"text-bold pl-8\">{{::vm.profile.profile.tiltingsCount}}</span></div></div><div class=\"m-10\" \nlayout=\"column\" layout-margin layout-fill><table id=\"geometryTable\" class=\"dataTable row-border hover\" layout-margin>\n<thead><tr><th translate=\"PRODUCTION_ORDERS.PART_ID\"></th><th translate=\"PRODUCTION_ORDERS.PRODUCTION_TIME\"></th><th \ntranslate=\"PRODUCTION_ORDERS.SLIT_LENGTH\"></th><th ng-if=\"vm.part.cut!==null && vm.order.status===1\"><span \nclass=\"mr-10\" translate=\"PRODUCTION_ORDERS.PROFILE_CUTTING_STATE\"></span></th><th \nng-if=\"vm.part.stamped!==null && vm.order.status===1\"><span class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.PROFILE_PUNCHING_STATE\"></span></th><th \nng-if=\"vm.part.bended!==null && vm.order.status===1\"><span class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.PROFILE_BENDING_STATE\"></span></th><th><span class=\"mr-10\" \ntranslate=\"PRODUCTION_ORDERS.PRIORITY\"></span></th><th><span class=\"mr-10\" translate=\"PRODUCTION_ORDERS.STACK\"></span>\n</th><th translate=\"PRODUCTION_ORDERS.LABEL\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.label.enabled && vm.config.ims.productionOrders.productionProfile.label.manualPrinter.enabled\">\n</th><th translate=\"PRODUCTION_ORDERS.COMPLAIN\"></th></tr></thead><tbody><tr class=\"grey-100-bg\"><td \nclass=\"text-center\">{{vm.part | shortName}}</td><td class=\"text-center\">{{vm.part.productionTime}}s</td><td \nclass=\"text-center\">{{vm.part.slitLength | nuitUnit:\'length\'}}</td><td class=\"text-center\" \nng-if=\"vm.part.cut!==null && vm.order.status===1\"><md-checkbox class=\"mt-16\" ng-model=\"vm.part.cut\" \nng-change=\"vm.add(vm.part,\'cut\')\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"vm.order.status>1\"></md-checkbox>\n</td><td class=\"text-center\" ng-if=\"vm.part.stamped!==null && vm.order.status===1\"><md-checkbox class=\"mt-16\" \nng-model=\"vm.part.stamped\" ng-change=\"vm.add(vm.part,\'stamped\')\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.order.status>1\"></md-checkbox></td><td class=\"text-center\" \nng-if=\"vm.part.bended!==null && vm.order.status===1\"><md-checkbox class=\"mt-16\" ng-model=\"vm.part.bended\" \nng-change=\"vm.add(vm.part,\'bended\')\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"vm.order.status>1\">\n</md-checkbox></td><td class=\"text-center\"><md-checkbox class=\"mt-16\" ng-disabled=\"vm.order.status>0\" \nng-change=\"vm.update(part)\" ng-model=\"part.customData.priority\"></md-checkbox></td><td class=\"text-center\"><md-checkbox\n class=\"mt-16\" ng-disabled=\"vm.order.status>0\" ng-change=\"vm.update(part)\" ng-model=\"part.customData.stack\">\n</md-checkbox></td><td class=\"text-center\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.label.enabled && vm.config.ims.productionOrders.productionProfile.label.manualPrinter.enabled\">\n<md-button ng-click=\"vm.openLabel(vm.part.label)\"><md-icon md-font-icon=\"icon-receipt\"></md-icon></md-button></td><td \nclass=\"text-center\"><md-button ng-click=\"vm.complain(vm.part)\" ng-disabled=\"vm.order.complaint\"><md-icon \nmd-font-icon=\"icon-alert-circle\"></md-icon></md-button></td></tr></tbody></table></div></div></md-content></div></div>\n</div></div>");
$templateCache.put("app/main/production.orders/views/production-orders-detail.html","<div id=\"production-order\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex class=\"mt-20\"><div ng-if=\"vm.config.ims.productionOrders.search.enabled\" \nclass=\"header minified\" layout=\"row\" layout-align=\"center bottom\" style=\"margin-top:30px\"><div class=\"search-white\" \nlayout-align=\"start center\" layout=\"row\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input\n id=\"user\" class=\"search-input\" ng-model=\"vm.searchId\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" ng-model-options=\"{debounce:200}\"></div></div><div \nclass=\"content-card\" layout=\"column\" flex style=\"margin-top:30px\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\" ng-class=\"{\'orange-200-bg\':vm.order.complaint}\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-la bel=\"Back\" ui-sref=\"{{vm.origin}}\">\n<md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.order && vm.order.id\"><div class=\"divider-vertical mr-20\"></div><span \nng-class=\"vm.getGroupById(vm.order.status).bgColor\" class=\"p-5 mr-10 brad-2\">{{vm.order | shortName:\'PA-{id}\'}}</span> \n<span class=\"md-title\">{{ vm.order.name }}</span><md-progress-circular class=\"md-accent ml-10\" md-mode=\"indeterminate\" \nmd-diameter=\"32\" ng-if=\"vm.orderProgessState!==\'NONE\'\"></md-progress-circular></div></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex><div \nclass=\"content\" ng-if=\"vm.loading\" flex><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n<span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><div \nclass=\"content\" ng-if=\"!vm.loading && !vm.order\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-block md-headline\">\nWHOOPS! Something went wrong. Please try again later</span></div></div><md-tabs layout-fill \nmd-selected=\"vm.selectedTab\" ng-if=\"!vm.loading && vm.order\"><md-tab \nlabel=\"{{ \'PRODUCTION_ORDERS.TAB_GENERAL\' | translate }}\" ui-sref=\"app.production-orders.details({active:\'general\'})\" \nmd-active=\"vm.selectedTab === \'general\'\" ng-click=\"vm.reloadDetails()\" \nng-if=\"vm.config.ims.productionOrders.details.enabled\"><ng-include \nsrc=\"\'app/main/production.orders/views/tabs/details.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'PRODUCTION_ORDERS.TAB_PROFILES\' | translate }}\" \nui-sref=\"app.production-orders.details({active:\'profiles\'})\" md-active=\"vm.selectedTab === \'profiles\'\" \nng-if=\"vm.config.ims.productionOrders.profiles.enabled &&\n						        		!vm.config.ims.productionOrders.productionProfile.geometryMode.enabled &&\n										vm.order.productionProfiles.length>0\">\n<div id=\"profiles\" ui-view=\"profiles\"></div></md-tab><md-tab \nlabel=\"{{ \'PRODUCTION_ORDERS.TAB_GEOMETRIES\' | translate }}\" \nui-sref=\"app.production-orders.details({active:\'geometries\'})\" md-active=\"vm.selectedTab === \'geometries\'\" \nng-if=\"vm.config.ims.productionOrders.profiles.enabled &&\n						        		vm.config.ims.productionOrders.productionProfile.geometryMode.enabled &&\n										vm.order.productionProfiles.length>0\">\n<div ui-view=\"geometries\"></div></md-tab><md-tab label=\"{{ \'PRODUCTION_ORDERS.TAB_PRODUCTION\' | translate }}\" \nui-sref=\"app.production-orders.details({active:\'production\'})\" md-active=\"vm.selectedTab === \'production\'\" \nng-if=\"vm.config.ims.productionOrders.production.enabled &&\n								vm.order.status===1  &&\n								vm.order.productionProfiles.length>0\">\n<div ui-view=\"production\"></div></md-tab><md-tab label=\"{{ \'PRODUCTION_ORDERS.TAB_CUTTING\' | translate }}\" \nui-sref=\"app.production-orders.details({active:\'cutting\'})\" md-active=\"vm.selectedTab === \'cutting\'\" \nng-if=\"vm.config.ims.productionOrders.cuttings.enabled\"><ng-include \nsrc=\"\'app/main/production.orders/views/tabs/cuttings.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{vm.getProductTranslation()}}\" ui-sref=\"app.production-orders.details({active:\'products\'})\" \nmd-active=\"vm.selectedTab === \'products\'\" ng-if=\"vm.products.length>0 && !vm.order.complaint\"><ng-include \nsrc=\"\'app/main/production.orders/views/tabs/products.html\'\"></ng-include></md-tab><md-tab \nlabel=\"{{ \'PRODUCTION_ORDERS.TAB_PLANNING\' | translate }}\" \nui-sref=\"app.production-orders.details({active:\'planning\'})\" md-active=\"vm.selectedTab === \'planning\'\" \nng-if=\"vm.config.ims.productionOrders.planning.enabled && vm.config.ims.planning.enabled\"><div ui-view=\"planning\">\n</div></md-tab></md-tabs></md-content></div><md-tabs id=\"profileNav\" class=\"b\" \nmd-selected=\"vm.profileService.currentProfile\" \nng-if=\"vm.selectedTab === 1 && vm.order.productionProfiles.length>1 && vm.config.ims.productionOrders.productionProfile.partsMode.enabled && vm.config.ims.productionOrders.productionProfile.partsMode.navBar.enabled\">\n<md-tab ng-repeat=\"profile in vm.order.productionProfiles\" ng-if=\"vm.hasPartId(profile.parts)\">\n{{profile.profile | shortName}}</md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/production.orders/views/production-orders.html","<div id=\"productionOrdersList\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\" layout=\"column\" layout-align=\"center center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-factory\" class=\"icon\"></md-icon></span>\n<span class=\"logo-text text-truncate\" translate=\"PRODUCTION_ORDERS.PRODUCTION_ORDERS_NAV\">Production Orders</span>\n</div></div><md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item md-primary-fg\" aria-label=\"groups\" ng-repeat=\"group in vm.groups track by group.name\" \nui-sref=\"app.production-orders({group:group.name,term:vm.searchText})\" ui-sref-opts=\"{inherit:false}\" \nng-class=\"{\'selected\':vm.isFilterSelected(group.id)}\"><div layout=\"row\" layout-align=\"start center\" layout-fill>\n<md-icon md-font-icon=\"{{::group.icon}}\" ng-class=\"::group.fgColor\" class=\"s20\"></md-icon><span \nclass=\"title text-truncate\" translate=\"{{::group.translation}}\">Group</span> <span class=\"title text-truncate\" \nng-show=\"!$last\">&nbsp;({{vm.getFilterCount(group.id)}})</span></div></md-button><md-button class=\"item md-primary-fg\" \naria-label=\"groups\" ui-sref=\"app.production-orders({group:\'none\',term:vm.searchText})\" ui-sref-opts=\"{inherit:false}\" \nng-class=\"{\'selected\':vm.isFilterSelected(-1)}\"><div layout=\"row\" layout-align=\"space-between center\" layout-fill><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-format-list-bulleted\" \nclass=\"s20 blue-grey-900-fg\"></md-icon><span class=\"title\" translate=\"APP.SHOW_ALL\">Alle</span></div></div></md-button>\n</div></md-content></md-sidenav><div class=\"center\" layout=\"column\" flex style=\"margin-top: 37px\"><div layout=\"row\" \nng-if=\"vm.config.ims.productionOrders.list.allowAdd\"><div flex></div><md-button \nng-disabled=\"vm.productionOrderInProgress\" class=\"md-raised mb-10 mr-0\" ng-click=\"vm.createOrder()\" layout=\"row\"><div \nng-if=\"vm.productionOrderInProgress\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nstyle=\"margin: 0 4px\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"26\">\n</md-progress-circular></div><span translate=\"PRODUCTION_ORDERS.ADD\"></span></md-button></div><div layout=\"row\" \nlayout-align=\"start end\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex>\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\" style=\"padding-right: 0\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"><div \nstyle=\"min-height: 60px\" ng-if=\"vm.config.ims.productionOrders.list.dateFilter.enabled\" \nclass=\"md-whiteframe-2dp user-controlling-filter grey-100-bg\" layout=\"row\" layout-align=\"space-around center\">\n<nuit-date-search start-date=\"vm.startFilterDate\" end-date=\"vm.endFilterDate\" on-change=\"vm.filterAll()\">\n</nuit-date-search></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" aria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleSelected()\"></md-checkbox><div \nlayout=\"row\" ng-if=\"vm.getSelected().length > 0 && !vm.inProgress\" layout-align=\"center center\">\n<nuit-selection-indicator selection=\"vm.selection\" get-name=\"vm.getName\"></nuit-selection-indicator><md-button \nclass=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.removeSelected()\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.resetSelected()\" ng-if=\"vm.status!==0\"><span translate=\"PRODUCTION_ORDERS.MOVE_BACK\">Move Back</span>\n</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.finishSelected()\" ng-if=\"vm.status===1\"><span \ntranslate=\"PRODUCTION_ORDERS.FINISH\">Finish</span></md-button></div><md-progress-circular class=\"md-accent ml-10\" \nmd-mode=\"indeterminate\" md-diameter=\"32\" ng-if=\"vm.inProgress\"></md-progress-circular></div><div layout=\"row\" \nlayout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" \nlacy-load-entity=\"vm.updateProductionStatus(entity)\" entities-per-page=\"10\"></nuit-pagination></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex><div \nng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...</span></div><div \nng-if=\"vm.orders.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"ORDERS.NO_ORDERS\">There are no orders yet!</span></div><div \nclass=\"thread\" ng-class=\"{\'orange-200-bg\':order.complaint}\" ng-if=\"!vm.loading\" \nng-repeat=\"order in vm.currentPageEntities track by order.id\" ng-class=\"{\'selected\': vm.isSelected(order)}\" \nui-sref=\"app.production-orders.details({orderId:order.id,page:vm.currentPage,startFilterDate: vm.dateSearch.enabled?vm.dateSearch.startTimestamp:undefined,endFilterDate: vm.dateSearch.enabled?vm.dateSearch.endTimestamp:undefined})\" \nlayout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(order)\" \nng-click=\"vm.toggleSelectOrder(order, $event)\" aria-label=\"{{vm.isSelected(order) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" layout=\"column\" flex><span class=\"name text-truncate\" layout=\"row\"><span \nclass=\"text-bold\" flex>{{ ::order.name }}</span> <span class=\"ml-10\" \nng-if=\"vm.config.ims.productionOrders.feedback.enabled\"><span ng-if=\"vm.getManufacturableCount(order,true)>0\"><md-icon \nclass=\"green-500-fg\" md-font-icon=\"icon-check-circle\"></md-icon><label>{{vm.getManufacturableCount(order,true)}}\n</label><md-tooltip md-direction=\"bottom\"><span translate=\"WIKANT.MANUFACTURABLE\">Rating</span></md-tooltip></span>\n<span ng-if=\"vm.getManufacturableCount(order,false)>0\"><md-icon class=\"red-500-fg\" \nmd-font-icon=\"icon-close-circle-outline\"></md-icon><label>{{vm.getManufacturableCount(order,false)}}</label><md-tooltip\n md-direction=\"bottom\"><span translate=\"WIKANT.NOT_MANUFACTURABLE\">Rating</span></md-tooltip></span></span></span><span\n class=\"message text-truncate\"><span translate=\"PRODUCTION_ORDERS.CREATED_AT\">Erstellt am</span>\n: {{ ::order.createdAt | nuitDatetime: vm.config.localization.dateFormat }} - <span \nng-init=\"group = vm.getGroupById(order.status)\" class=\"p-5\" \nng-class=\"{\'red-500-bg white-text\': (order.completionDate <= vm.today && group.id != 2)}\"><span \ntranslate=\"PRODUCTION_ORDERS.FINISHED_AT\">Fertigstellungstermin </span>\n: {{ ::order.completionDate | nuitDatetime: vm.config.localization.dateFormat }}<md-tooltip \nng-if=\"order.completionDate < vm.today && (group.id != 2)\"><span translate=\"PRODUCTION_ORDERS.FINISHED_AT_EXCEEDED\">\nFertigstellungstermin überschritten</span></md-tooltip></span></span></div><div layout=\"column\" flex=\"45\"><div \nlayout=\"row\"><div style=\"max-width: 400px\" class=\"labels text-truncate grey-200-bg h-24\" \nng-if=\"vm.getPlanningBoardName(order) && vm.config.ims.productionOrders.list.showPlanningBoardTag\"><md-icon \nstyle=\"font-size: 20px !important; width: 20px !important; height: 20px !important; min-height: 20px !important; min-width: 20px !important; line-height: 20px !important\" \nmd-font-icon=\"icon-calendar-clock\"></md-icon><span class=\"label\" \nstyle=\"margin: 3px 3px 3px 0; padding: 2px 5px 2px 2px\">{{ vm.getPlanningBoardName(order) | nuitTranslate}}</span>\n</div><div class=\"labels text-truncate h-24\" ng-init=\"group = vm.getGroupById(order.status)\" \nng-class=\"::group.bgColor\"><span class=\"label\" translate=\"{{::group.translation}}\">Groupname</span></div><span \nng-if=\"!vm.config.ims.productionOrders.productionProfile.geometryMode.enabled\" class=\"h4 ml-24\">\n{{ ::order.productionStatus.producedParts }}/{{ ::order.productionStatus.totalParts }} <span \ntranslate=\"PRODUCTION_ORDERS.PRODUCED\">produziert</span></span></div><div class=\"ml-10 mt-10\" layout=\"row\" \nng-if=\"vm.config.ims.productionOrders.list.showMaterial\"><div flex layout=\"column\" layout-wrap style=\"padding: 2px\">\n<div class=\"mr-20\" layout=\"row\" ng-repeat=\"material in order.materialInfos\"><div class=\"w-15 h-15 b mt-4\" \nstyle=\"background-color:{{::material.material.colors.front.hex}}\"></div><span>\n&nbsp;{{material.material.name | nuitTranslate}}</span></div></div></div></div></div></md-content></div></div></div>\n</div>");
$templateCache.put("app/main/production.planning/views/board-details.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" flex><form\n name=\"vm.itemForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" ng-if=\"vm.sidebarEnabled()\" \nhide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-planning-board\" aria-label=\"Back\" ui-sref=\"app.planning\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span class=\"md-title\" \nng-if=\"vm.planningBoardId && vm.planningBoardId > 0\">{{ ::vm.planningBoard.name | nuitTranslate }}</span> <span \nclass=\"md-title\" ng-if=\"!vm.planningBoardId || vm.planningBoardId <= 0\" translate=\"PLANNING.ADD_PLANNING_BOARD\">\nAdd planning board</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.savePlanningBoard()\" ng-disabled=\"!vm.itemForm.$valid || !vm.itemForm.$dirty\" \ntranslate=\"APP.SAVE\">Speichern</md-button></div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content \nlayout=\"column\" layout-fill flex><div class=\"content\" ng-if=\"vm.loadingItem\" flex><div class=\"loading-planning-boards\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span \ntranslate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content ms-scroll layout-fill ng-if=\"!vm.loadingItem\">\n<div layout=\"column\" layout-padding layout-margin><div layout=\"row\" layout-margin><md-input-container flex><label \ntranslate=\"APP.NAME\">Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.planningBoard.name[vm.selectedLanguage]\" \nrequired></md-input-container><md-input-container><label translate=\"APP.LANG\">Lang</label><md-select \nng-model=\"vm.selectedLanguage\"><md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span \nclass=\"text-uppercase\">{{ lang }}</span></md-option></md-select></md-input-container></div></div></md-content>\n</md-content></div></form></div>");
$templateCache.put("app/main/production.planning/views/board-list.html","<div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-factory\" class=\"icon\"></md-icon></span>\n<span class=\"logo-text text-truncate\" translate=\"PLANNING.PLANNING\">Production Planning</span></div><md-button \nclass=\"md-raised\" ui-sref=\"app.planning.compose\" translate=\"APP.ADD\">ADD</md-button></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedItems.length > 0 ? \'Deselect All\' : \'Select All\'}}\" ng-checked=\"vm.selectedItems.length > 0\" \nng-click=\"vm.toggleSelectedItems()\"></md-checkbox><div layout=\"row\" ng-if=\"vm.selectedItems.length > 0\" \nlayout-align=\"start center\"><div class=\"divider-vertical ml-20\"></div><md-button class=\"md-icon-button\" \naria-label=\"delete\" ng-click=\"vm.deleteSelectedItems()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.items.length > 0\"><span class=\"page-info\" hide-sm>{{ 1 }} - {{ vm.items.length }} <span \ntranslate=\"PAGINATION.OF\">of</span> {{ vm.items.length }}</span><md-button class=\"md-icon-button arrow\" \naria-label=\"Previous\" ng-disabled=\"!vm.allowPrevPage || vm.loadingItems\" ng-click=\"vm.prevPage()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"PAGINATION.PREVIOUS\">Previous</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" \nng-disabled=\"!vm.allowNextPage || vm.loadingItems\" ng-click=\"vm.nextPage()\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon><md-tooltip><span translate=\"PAGINATION.NEXT\">Next</span></md-tooltip></md-button></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><div class=\"content planning-board-list\" ms-scroll flex><div \nng-if=\"vm.loadingItems\" class=\"loading-planning-boards\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"(!vm.items || vm.items.length === 0) && !vm.loadingItems\" class=\"no-planning-boards\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"PLANNING.NO_PLANNING_BOARDS\">\nThere are no planning boards yet!</span></div><div class=\"planning-board\" ng-if=\"!vm.loadingItems\" \nng-repeat=\"item in vm.items track by item.id\" ng-class=\"{\'selected\': vm.isSelected(item)}\" \nng-click=\"vm.openItem(item)\"><div layout=\"row\" layout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" \nng-checked=\"vm.isSelected(item)\" ng-click=\"vm.toggleSelectItem(item, $event)\" \naria-label=\"{{vm.isSelected(item) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div class=\"info\" layout=\"column\" flex><span\n class=\"name text-truncate\">{{ item.name | nuitTranslate}}</span></div></div></div></div></div></div>");
$templateCache.put("app/main/production.planning/views/planning.html","<div id=\"production-planning\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/production.planning.boards/views/boards.html","<div id=\"planning\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-calendar-clock\" class=\"icon\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"PLANNING.PLANNING_BOARDS\">Planning boards</span></div></div><div class=\"content\" flex layout=\"column\">\n<md-tabs layout-fill flex ng-if=\"vm.planningBoards && vm.planningBoards.length > 0\"><md-tab \nng-repeat=\"board in vm.planningBoards\" label=\"{{ board.name | nuitTranslate }}\" \nui-sref=\"app.planning-boards({ index: \'{{ $index }}\'})\" md-active=\"vm.selectedIndex === $index\"><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill ng-if=\"vm.loading\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nui-view=\"planningBoard\" onload=\"vm.onLoad(board.id)\" id=\"planningBoard_{{board.id}}\" ng-if=\"!vm.loading\"></div>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/production.queue/views/production-queue.html","<div id=\"productionOrdersList\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\" layout=\"column\" layout-align=\"center center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-clock\" class=\"icon\"></md-icon></span>\n<span class=\"logo-text text-truncate\" translate=\"QUEUE.QUEUE_NAV\">Production Queue</span></div></div><md-content \nms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><md-button \nng-repeat=\"status in vm.OrderService.queueFilters track by $index\" class=\"item\" \nng-click=\"vm.setStatusFilter(status.id)\" ng-class=\"{\'selected\':vm.isFilterSelected(status.id)}\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-fill><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-class=\"status.color\" class=\"s20\"></md-icon><span class=\"title\">\n{{ status.name[vm.translation.language] }}</span> <span class=\"title\">&nbsp;({{vm.getFilterCount(status.id)}})</span>\n</div></div></md-button><md-button class=\"item\" ng-click=\"vm.setStatusFilter(-1)\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-fill><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s16 blue-grey-900-fg\"></md-icon><span class=\"title\" \ntranslate=\"APP.SHOW_ALL\">Alle</span></div></div></md-button><nuit-filters class=\"m-8\" \nentities=\"vm.prefilteredEntities\" on-change=\"vm.filterAll()\" filters=\"vm.filters\" filter-values=\"vm.filterValues\" \non-init=\"vm.filterControls(controls)\"></nuit-filters></div></md-content></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start end\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\" style=\"padding-right: 0\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"><div \nstyle=\"max-width: 540px; min-width: 540px; min-height: 60px\" \nclass=\"md-whiteframe-2dp user-controlling-filter grey-100-bg\" layout=\"row\" flex layout-align=\"space-around center\"><div\n class=\"w-10\"></div><md-checkbox class=\"no-label\" ng-disabled=\"vm.filteredMaterials.length===0\" \nng-checked=\"vm.colorFilterEnabled\" ng-click=\"vm.colorFilterEnabled=!vm.colorFilterEnabled; vm.filterAll()\">\n</md-checkbox><md-input-container flex style=\"min-width: 100px !important; padding-right: 10px\"><label \ntranslate=\"MATERIAL.COLOR_FRONT\"></label><md-select ng-model=\"vm.filteredMaterials\" flex multiple=\"multiple\" \nng-change=\"vm.colorFilterEnabled = vm.filteredMaterials.length>0;vm.filterAll();\"><md-select-header \nclass=\"select-header p-10\"><input id=\"search\" ng-model=\"searchText\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"Search\"><md-icon ng-show=\"searchText && searchText.length>0\" \nmd-font-icon=\"icon-close\" ng-click=\"searchText=\'\';\"></md-icon></md-select-header><md-option \nng-if=\"!searchText || (material.name | nuitTranslate).toLowerCase().startsWith(searchText.toLowerCase())\" \nng-value=\"material.id\" ng-repeat=\"material in vm.usedMaterialInfos | orderByNuitTranslated:\'name\'\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"w-15 h-15 b mr-5\" style=\"background-color:{{::material.colors.front.hex}}\">\n</span> <span>{{material.name | nuitTranslate}}</span></div></md-option></md-select></md-input-container>\n<nuit-date-search ng-if=\"vm.config.ims.queue.list.dateFilter.enabled\" start-date=\"vm.startFilterDate\" \nend-date=\"vm.endFilterDate\" on-change=\"vm.filterAll()\"></nuit-date-search><md-button class=\"md-icon-button\" \nng-click=\"vm.upload()\" ng-if=\"vm.showUploadButton()\"><md-icon md-font-icon=\"icon-box-upload\"></md-icon><md-tooltip>\n<span translate=\"APP.UPLOAD\"></span></md-tooltip></md-button></div></div></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleSelectedOrders()\"></md-checkbox><div \nlayout=\"row\" layout-align=\"start center\"><nuit-selection-indicator ng-if=\"vm.getSelected().length>0\" \nselection=\"vm.selection\" get-name=\"vm.getTitleById\"></nuit-selection-indicator><md-button ng-if=\"vm.enableDelete()\" \nclass=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected(vm)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button><md-button \nng-if=\"vm.enableProductionOrderButton()\" class=\"md-raised md-accent\" ng-click=\"vm.createProductionOrder()\"><span \ntranslate=\"QUEUE.CREATE_PRODUCTION_ORDER\"></span></md-button></div></div><div layout=\"row\" layout-align=\"start center\">\n<nuit-pagination all-entities=\"vm.filteredEntities\" current-page-entities=\"vm.currentPageEntities\" \ncurrent-page=\"vm.currentPage\" , entities-per-page=\"10\"></nuit-pagination></div></div><div class=\"content-wrapper\" \nlayout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.loading\" \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...</span></div><div \nng-if=\"vm.orders.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"ORDERS.NO_ORDERS\">There are no orders yet!</span></div><div \nclass=\"thread\" style=\"padding: 12px; padding-left: 24px\" ng-repeat=\"order in vm.currentPageEntities track by order.id\" \nng-if=\"!vm.loading\" ng-class=\"{\'selected\': vm.isSelected(order.id)}\" ng-click=\"vm.openOrder(order)\" layout=\"row\" \nng-init=\"vm.checkDeliveryObject(order)\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" \nlayout-fill><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(order.id)\" \nng-click=\"vm.toggleSelectOrder(order.id, $event)\" aria-label=\"{{vm.isSelected(order.id) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" layout=\"row\" flex><div layout=\"column\"><div layout=\"row\" style=\"padding-bottom: 4px\" \nlayout-wrap><span class=\"name text-truncate mr-10\" style=\"padding-left: 2px; padding-right: 2px; padding-bottom: 0px\">\n{{vm.getTitle(order)}} </span><span class=\"grey-100-bg tag-label h-34 md-list-item-text ph-10 mr-10\" layout=\"row\" \nlayout-align=\"center center\" ng-repeat=\"field in vm.config.ims.queue.list.customFields\" \nng-if=\"::(field.format | nuitFormatter:order).length>0\"><span class=\"mr-10\">{{field.name | nuitTranslate}}</span> <span\n class=\"text-bold\">{{field.format | nuitFormatter:order}}</span></span></div><div layout=\"row\" flex \nlayout-align=\"start start\"><div class=\"message mr-10\" layout=\"column\"><span \nng-init=\"group = vm.OrderService.getStatusById(order.status)\" style=\"padding: 2px\" \nng-class=\"{\'red-500-bg white-text\': (order.details.completionDate <= vm.today && group.id === vm.startStatus)}\"><span \ntranslate=\"ORDERS.COMPLETION_DATE\">Fertigstellungstermin </span>\n: {{order.details.completionDate | nuitDatetime: \'date\'}}<md-tooltip \nng-if=\"order.details.completionDate < vm.today && (group.id === vm.startStatus)\"><span \ntranslate=\"PRODUCTION_ORDERS.FINISHED_AT_EXCEEDED\">Fertigstellungstermin überschritten</span></md-tooltip></span><span \nstyle=\"padding: 2px\" ng-if=\"vm.getShippingDate(order.id)!==null\"><span translate=\"TRANSPORT.SHIPPING_DATE\">\nFertigstellungstermin </span>: {{vm.getShippingDate(order.id) | nuitDatetime: \'date\'}}</span></div><div flex \nlayout=\"row\" layout-wrap style=\"padding: 2px\"><div class=\"mr-20\" layout=\"row\" \nng-repeat=\"material in vm.materialInfos[order.id]\"><div class=\"w-15 h-15 b mt-4\" \nstyle=\"background-color:{{::material.colors.front.hex}}\"></div><span>&nbsp;{{material.name | nuitTranslate}}</span>\n</div></div></div></div><div flex></div><div class=\"labels\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"label text-truncate white-text\" \nng-init=\" color1 = vm.OrderService.getStatusById(order.status).color; bgColor = color1.replace(\'fg\',\'bg\')\" \nng-class=\"bgColor\">{{ vm.OrderService.getStatusById(order.status).name[vm.translation.language] }}</div><div \nclass=\"text-boxed\">{{ vm.getOrderPositions(order) }}</div></div></div></div></div></md-content></div></div></div></div>");
$templateCache.put("app/main/system.exchange/views/api-details.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" flex><form\n name=\"vm.form\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" ng-if=\"vm.sidebarEnabled()\" \nhide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.exchange-apis\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"divider-vertical mr-20\"></div><span class=\"md-title\" translate=\"EXCHANGE.ADD_APP\"></span></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.save()\" \nng-disabled=\"!vm.form.$valid || !vm.form.$dirty\" translate=\"APP.SAVE\">Speichern</md-button></div></div><div \nlayout=\"column\" flex layout-fill layout-margin class=\"mt-30\"><md-input-container><label translate=\"EXCHANGE.JOB_NAME\">\nFirstname</label><input type=\"text\" ng-model=\"vm.app.name\" required></md-input-container></div></form></div>");
$templateCache.put("app/main/system.exchange/views/api-list.html","<div class=\"header\" layout=\"row\" layout-align=\"space-between end\"><div class=\"pb-10\" layout=\"row\" \nlayout-align=\"space-between end\" flex><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-worker\" class=\"icon\"></md-icon></span><span \nclass=\"logo-text text-truncate\" translate=\"EXCHANGE.APPS\"></span></div><div class=\"compose-button\"><md-button \nclass=\"md-raised\" ui-sref=\"app.exchange-apis.compose\" translate=\"EXCHANGE.ADD_APP\">Add User</md-button></div></div>\n</div><div layout=\"row\" layout-align=\"space-between end\"><div class=\"search-wrapper\" flex><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"option-box\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" hide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"search-icon s24\"></md-icon><input flex ng-model=\"vm.searchText\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" \nng-model-options=\"{debounce:1000}\"></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selection.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selection.getSelected().length > 0\" ng-click=\"vm.toggleSelection()\"></md-checkbox><div layout=\"row\" \nng-if=\"vm.selection.getSelected().length > 0\" layout-align=\"start center\"><div class=\"divider-vertical ml-20\"></div>\n<md-button class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button>\n</div></div><div layout=\"row\" layout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" entities-per-page=\"10\"></nuit-pagination>\n</div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex>\n<div ng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"vm.apps.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"EXCHANGE.NO_APPS\"></span></div><div class=\"thread unread\" \nng-if=\"!vm.loading\" ng-repeat=\"app in vm.currentPageEntities track by app.id\" \nng-class=\"{\'selected\': vm.isSelected(item)}\"><div layout=\"row\" layout-align=\"start center\" layout-fill><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isSelected(app)\" ng-click=\"vm.toggleSelected(app,$event)\" \naria-label=\"{{vm.isSelected(app) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div class=\"info\" layout=\"column\" flex><span \nclass=\"name text-truncate\"><span>{{app.app}}</span></span><div>{{ app.signed }}</div></div></div></div></md-content>\n</div></div>");
$templateCache.put("app/main/system.exchange/views/api.html","<div id=\"exchange\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/system.exchange/views/app-list.html","<div class=\"header\" layout=\"row\" layout-align=\"space-between end\"><div class=\"pb-10\" layout=\"row\" \nlayout-align=\"space-between end\" flex><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-worker\" class=\"icon\"></md-icon></span><span \nclass=\"logo-text text-truncate\" translate=\"EXCHANGE.APPS\"></span></div><div class=\"compose-button\" \nng-if=\"vm.appTypes.length>0\"><md-button class=\"md-raised\" translate=\"APP.ADD\" ng-click=\"vm.showNewAppDialog()\">Add App\n</md-button></div></div></div><div layout=\"row\" layout-align=\"space-between end\"><div class=\"search-wrapper\" flex><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\"><div class=\"option-box\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"search-icon s24\"></md-icon><input \nflex ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"></div></div></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selection.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.selection.getSelected().length > 0\" \nng-click=\"vm.toggleSelection()\"></md-checkbox><div layout=\"row\" ng-if=\"vm.selection.getSelected().length > 0\" \nlayout-align=\"start center\"><div class=\"divider-vertical ml-20\"></div><md-button class=\"md-icon-button\" \naria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div><div layout=\"row\" layout-align=\"start center\">\n<nuit-pagination all-entities=\"vm.filteredEntities\" current-page-entities=\"vm.currentPageEntities\" \ncurrent-page=\"vm.currentPage\" entities-per-page=\"10\"></nuit-pagination></div></div><div class=\"content-wrapper\" \nlayout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.loading\" \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"vm.apps.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"EXCHANGE.NO_APPS\"></span></div><div class=\"thread unread\" \nng-if=\"!vm.loading\" ng-repeat=\"app in vm.filteredEntities track by app.id\" \nng-class=\"{\'selected\': vm.isSelected(item)}\"><div layout=\"row\" layout-align=\"start center\" layout-fill \nng-click=\"vm.state.go(app.details,{appId:app.id})\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(app.id)\" \nng-click=\"vm.toggleSelected(app.id,$event)\" aria-label=\"{{vm.isSelected(app.id) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" layout=\"column\" flex><span><div class=\"name\">{{app.name}}</div><div class=\"message\">\n<span>{{app.type}}</span> <span>({{app.id}})</span></div></span></div><md-button \nng-if=\"app.api.needsConnection() && !app.api.isConnected\" class=\"md-icon-button md-raised\" \nng-click=\"app.api.connect($event)\"><md-icon md-font-icon=\"icon-link-off\"></md-icon><md-tooltip><span \ntranslate=\"APP.CONNECT\">Connect</span></md-tooltip></md-button><md-button \nng-if=\"app.api.needsConnection() && app.api.isConnected\" class=\"md-icon-button\" ng-click=\"app.api.disconnect($event)\">\n<md-icon md-font-icon=\"icon-link\" class=\"green-fg\"></md-icon><md-tooltip><span translate=\"APP.CONNECTED\">Connect</span>\n</md-tooltip></md-button></div></div></md-content></div></div>");
$templateCache.put("app/main/system.exchange/views/app.html","<div id=\"exchange\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/system.exchange/views/exchange.html","<div id=\"exchange\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/system.exchange/views/job-details.html","<div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" \nflex><form name=\"vm.form\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" ng-if=\"vm.sidebarEnabled()\" \nhide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.exchange\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"divider-vertical mr-20\"></div><span class=\"md-title\" ng-if=\"!vm.isExistingJob\" translate=\"EXCHANGE.ADD_JOB\">\nAdd user</span> <span class=\"md-title\" ng-if=\"vm.isExistingJob\">{{ vm.job.name | nuitTranslate}}</span></div></div><div\n layout=\"row\" layout-align=\"start center\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.save()\" \nng-disabled=\"(!vm.form.$valid || !vm.form.$dirty) && !vm.tasksDirty\" translate=\"APP.SAVE\">Speichern</md-button></div>\n</div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill \nflex><div class=\"content\" ng-if=\"vm.loading\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><md-tabs layout-fill flex md-selected=\"vm.selectedTab\" ng-if=\"!vm.loading\"><md-tab \nui-sref=\"app.exchange.detail({active:\'general\'})\" md-active=\"vm.selectedTab === \'general\'\"><md-tab-label><span \ntranslate=\"EXCHANGE.GENERAL\"></span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.exchange/views/partials/general.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nng-if=\"vm.isExistingJob\" ui-sref=\"app.exchange.detail({active:\'triggers\'})\" md-active=\"vm.selectedTab === \'triggers\'\">\n<md-tab-label><span translate=\"EXCHANGE.TRIGGERS\"></span></md-tab-label><md-tab-body><div ui-view=\"triggers\" \nclass=\"content-wrapper\" layout=\"column\" flex></div></md-tab-body></md-tab><md-tab ng-if=\"vm.isExistingJob\" \nui-sref=\"app.exchange.detail({active:\'tasks\'})\" md-active=\"vm.selectedTab === \'tasks\'\"><md-tab-label><span \ntranslate=\"EXCHANGE.TASKS\"></span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.exchange/views/partials/tasks.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nng-if=\"vm.history.length>0\" ui-sref=\"app.exchange.detail({active:\'history\'})\" md-active=\"vm.selectedTab === \'history\'\">\n<md-tab-label><span translate=\"EXCHANGE.HISTORY\"></span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.exchange/views/partials/history.html\'\"></ng-include></md-tab-body></md-tab></md-tabs>\n</md-content></div></form></div>");
$templateCache.put("app/main/system.exchange/views/job-list.html","<div class=\"header\" layout=\"row\" layout-align=\"space-between end\"><div class=\"pb-10\" layout=\"row\" \nlayout-align=\"space-between end\" flex><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-worker\" class=\"icon\"></md-icon></span><span \nclass=\"logo-text text-truncate\" translate=\"EXCHANGE.EXCHANGE\"></span></div><div class=\"compose-button\"><md-button \nclass=\"md-raised\" ui-sref=\"app.exchange.compose_job\" translate=\"EXCHANGE.ADD_JOB\">Add User</md-button></div></div>\n</div><div layout=\"row\" layout-align=\"space-between end\"><div class=\"search-wrapper\" flex><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"option-box\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" hide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"search-icon s24\"></md-icon><input flex ng-model=\"vm.searchText\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" \nng-model-options=\"{debounce:1000}\"></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selection.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selection.getSelected().length > 0\" ng-click=\"vm.toggleSelection()\"></md-checkbox><div layout=\"row\" \nng-if=\"vm.selection.getSelected().length > 0\" layout-align=\"start center\"><div class=\"divider-vertical ml-20\"></div>\n<md-button class=\"md-icon-button\" aria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button>\n</div></div><div layout=\"row\" layout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" entities-per-page=\"10\"></nuit-pagination>\n</div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex>\n<div ng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"vm.jobs.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"EXCHANGE.NO_JOBS\"></span></div><div class=\"thread unread\" \nng-if=\"!vm.loading\" ng-repeat=\"job in vm.currentPageEntities track by job.id\" \nng-class=\"{\'selected\': vm.isSelected(item)}\" ng-click=\"vm.openDetails(job.id)\"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(job)\" \nng-click=\"vm.toggleSelected(job,$event)\" aria-label=\"{{vm.isSelected(job) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div\n class=\"info\" layout=\"column\" flex><span class=\"name text-truncate\"><span>{{job.name | nuitTranslate}}</span></span>\n<div><span translate=\"EXCHANGE.STATUS\"></span> <span class=\"text-uppercase\">: {{job.status}}</span></div></div><div \nflex=\"15\" layout=\"column\" layout-align=\"center center\"><md-checkbox ng-if=\"!vm.canCancelJob(job)\" \nclass=\"m-0 p-0 mb-10\" ng-model=\"job.forceExecution\" ng-click=\"$event.stopPropagation()\" flex><label>force</label>\n</md-checkbox><md-button ng-if=\"!vm.canCancelJob(job)\" class=\"md-raised md-icon-button\" \nng-click=\"vm.runJob(job);$event.stopPropagation()\"><md-icon md-font-icon=\"icon-play\"></md-icon><md-tooltip><span \ntranslate=\"APP.RUN\">Run</span></md-tooltip></md-button><md-button ng-if=\"vm.canCancelJob(job)\" \nclass=\"md-raised md-icon-button\" ng-click=\"vm.cancelJob(job);$event.stopPropagation()\"><md-icon \nmd-font-icon=\"icon-stop\"></md-icon><md-tooltip><span translate=\"APP.CANCEL\">Cancel</span></md-tooltip></md-button>\n</div></div></div></md-content></div></div>");
$templateCache.put("app/main/system.exchange/views/nodered-details.html","<div class=\"header\" layout=\"row\" layout-align=\"space-between end\"><div class=\"pb-10\" layout=\"row\" \nlayout-align=\"space-between end\" flex><div class=\"logo\" layout=\"row\" layout-align=\"start center\"></div><div \nclass=\"compose-button\"><md-button class=\"md-raised\" translate=\"APP.ADD\" ng-click=\"vm.showNewFlowDialog()\">Add App\n</md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex><form name=\"vm.form\" novalidate \nlayout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"^\"><md-icon md-font-icon=\"icon-keyboard-backspace\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span \nclass=\"md-title\">{{vm.nrService.app.name}}</span></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selection.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.selection.getSelected().length > 0\" \nng-click=\"vm.toggleSelection()\"></md-checkbox><div layout=\"row\" ng-if=\"vm.selection.getSelected().length > 0\" \nlayout-align=\"start center\"><div class=\"divider-vertical ml-20\"></div><md-button class=\"md-icon-button\" \naria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div><div layout=\"row\" layout-align=\"start center\">\n<nuit-pagination style=\"font-size: 13px\" all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" entities-per-page=\"10\"></nuit-pagination>\n</div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex>\n<div ng-if=\"vm.loading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"vm.filteredEntities.length === 0 && !vm.loading\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"APP.EMPTY\"></span></div><div \nclass=\"thread unread\" ng-if=\"!vm.loading\" ng-repeat=\"flow in vm.filteredEntities track by flow.id\" \nng-class=\"{\'selected\': vm.isSelected(item)}\"><div layout=\"row\" layout-align=\"start center\" layout-fill><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isSelected(flow.id)\" ng-click=\"vm.toggleSelected(flow.id,$event)\" \naria-label=\"{{vm.isSelected(flow.id) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div class=\"info\" layout=\"column\" flex>\n<span><div class=\"name\">{{flow.name}}</div><div class=\"message\" ng-if=\"flow.url\"><span>{{flow.type}}</span> <span><a \nng-href=\"{{flow.url}}\" target=\"_blank\">{{flow.url}}</a></span></div></span></div></div></div></md-content></div></div>\n</form></div>");
$templateCache.put("app/main/system.exchange/views/quickbook-details.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" flex><form\n name=\"vm.form\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" ng-if=\"vm.sidebarEnabled()\" \nhide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"^\"><md-icon md-font-icon=\"icon-keyboard-backspace\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span \nclass=\"md-title\">{{vm.qbService.app.name}}</span></div></div><div layout=\"row\" layout-align=\"start center\"></div></div>\n<md-tabs layout-fill ng-if=\"!vm.qbService.isLoading && vm.qbService.isConnected\" flex><md-tab \nlabel=\"{{ \'APP.GENERAL\' | translate }}\"><ng-include \nsrc=\"\'app/main/system.exchange/views/partials/quickbook-import.html\'\"></ng-include></md-tab><md-tab \nng-if=\"vm.qbService.config.incomeAccountRef && vm.qbService.config.incomeAccountRef.length>0\" \nlabel=\"{{ \'QUICKBOOKS.CUSTOMERS\' | translate }}\"><div ui-view=\"customers\"></div></md-tab><md-tab \nng-if=\"vm.qbService.config.incomeAccountRef && vm.qbService.config.incomeAccountRef.length>0\" \nlabel=\"{{ \'QUICKBOOKS.ITEMS\' | translate }}\"><div ui-view=\"items\"></div></md-tab></md-tabs><div \nng-if=\"!vm.qbService.isConnected\" layout=\"row\" fill-height layout-align=\"center center\" translate=\"APP.DISCONNECTED\">\nnot connected</div></form></div>");
$templateCache.put("app/main/system.exchange/views/sage-details.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"^\"><md-icon md-font-icon=\"icon-keyboard-backspace\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span \nclass=\"md-title\">{{vm.sageService.app.name}}</span></div></div></div><md-content layout=\"column\" layout-padding flex \nms-scroll><div layout=\"row\" layout-xs=\"column\"><div layout=\"column\" layout-margin flex><md-button class=\"md-raised\" \nlayout=\"row\" layout-align=\"center center\" ng-click=\"vm.importParts()\" ng-disabled=\"vm.importingParts\">\n<md-progress-circular ng-if=\"vm.importingParts\" class=\"md-accent mr-20\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><label translate=\"SAGE.PARTS.IMPORT\">Import Parts</label></md-button></div><div layout=\"column\" \nlayout-margin flex><md-button class=\"md-raised\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.importClients()\" ng-disabled=\"vm.importingClients\"><md-progress-circular ng-if=\"vm.importingClients\" \nclass=\"md-accent mr-20\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular><label \ntranslate=\"SAGE.CLIENTS.IMPORT\">Import Companies</label></md-button></div></div></md-content></div>");
$templateCache.put("app/main/system.exchange/views/xero-details.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" flex><form\n name=\"vm.form\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" ng-if=\"vm.sidebarEnabled()\" \nhide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"^\"><md-icon md-font-icon=\"icon-keyboard-backspace\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span \nclass=\"md-title\">{{vm.qbService.app.name}}</span></div></div><div layout=\"row\" layout-align=\"start center\"></div></div>\n<md-tabs layout-fill ng-if=\"!vm.xeroService.isLoading && vm.xeroService.isConnected\" flex><md-tab \nlabel=\"{{ \'APP.GENERAL\' | translate }}\"><ng-include src=\"\'app/main/system.exchange/views/partials/xero-config.html\'\">\n</ng-include></md-tab><md-tab label=\"{{ \'QUICKBOOKS.CUSTOMERS\' | translate }}\"><div ui-view=\"customers\"></div></md-tab>\n</md-tabs><div ng-if=\"!vm.xeroService.isConnected\" layout=\"row\" fill-height layout-align=\"center center\" \ntranslate=\"APP.DISCONNECTED\">not connected</div></form></div>");
$templateCache.put("app/main/system.profiles/views/profile-list.html","<div class=\"compose-button\" style=\"padding-top: 37px\" layout-align=\"end end\" layout=\"row\"><md-button class=\"md-raised\" \naria-label=\"compose\" ng-click=\"vm.addFolder($event)\" translate=\"FOLDER.ADD\">new Folder</md-button><md-button \nclass=\"md-raised\" aria-label=\"compose\" ng-click=\"vm.newProfile($event)\" ng-disabled=\"!vm.selectedFolder\" \ntranslate=\"PROFILE.ADD\">new Profile</md-button></div><div class=\"header\" \nstyle=\"height:60px; min-height: 60px; max-height: 60px\" layout=\"row\" layout-align=\"start end\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\" style=\"padding-right: 0\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input flex ng-model=\"vm.term\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" ng-model-options=\"{debounce:300}\"><div \nstyle=\"min-height: 60px; padding-left: 10px; padding-top:0; text-align: center\" \nclass=\"md-whiteframe-2dp user-controlling-filter grey-100-bg\" layout=\"row\" layout-align=\"space-around center\" flex><h2 \nclass=\"m-0\" ng-if=\"vm.selectedFolder\" flex justify=\"center\"><md-icon style=\"margin-bottom: 6px\" \nmd-font-icon=\"icon-folder-outline\"></md-icon>{{ vm.selectedFolder.name | nuitTranslate }}</h2><h2 class=\"m-0\" \nng-if=\"!vm.selectedFolder\" flex><md-icon style=\"margin-bottom: 6px\" md-font-icon=\"icon-folder-outline\"></md-icon>\n{{((vm.$state.params.folder && vm.$state.params.folder===\'private\')?\'PROFILES.PRIVATE_FOLDERS\':\'PROFILES.PUBLIC_FOLDERS\') | translate}}\n</h2><md-button ng-disabled=\"!vm.selectedFolder\" class=\"md-icon-button\" \nng-click=\"vm.renameFolder($event,vm.selectedFolder)\"><md-icon class=\"icon\" md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip><span translate=\"FOLDER.RENAME\">Delete</span></md-tooltip></md-button><md-button \nng-if=\"!vm.config.ims.profiles.sortByName\" ng-disabled=\"!vm.selectedFolder || !vm.selectedFolder.prevId\" \nclass=\"md-icon-button\" ng-click=\"vm.swapFolder(vm.selectedFolder, vm.selectedFolder.prevId)\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-arrow-up\"></md-icon><md-tooltip><span translate=\"APP.UP\">Up</span></md-tooltip></md-button>\n<md-button ng-if=\"!vm.config.ims.profiles.sortByName\" ng-disabled=\"!vm.selectedFolder || !vm.selectedFolder.nextId\" \nclass=\"md-icon-button\" ng-click=\"vm.swapFolder(vm.selectedFolder, vm.selectedFolder.nextId)\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-arrow-down\"></md-icon><md-tooltip><span translate=\"APP.DOWN\">Down</span></md-tooltip></md-button>\n<md-button ng-disabled=\"!vm.selectedFolder\" class=\"md-icon-button\" ng-click=\"vm.moveFolder($event)\"><md-icon \nclass=\"icon\" md-font-icon=\"icon-import\"></md-icon><md-tooltip><span translate=\"FOLDER.MOVE\">Move</span></md-tooltip>\n</md-button><md-button ng-disabled=\"!vm.selectedFolder\" class=\"md-icon-button\" ng-click=\"vm.deleteFolder($event)\">\n<md-icon class=\"icon\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"FOLDER.DELETE\">Move</span>\n</md-tooltip></md-button></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nclass=\"no-label\" aria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"!vm.isIndeterminate(vm.currentPageEntities) && vm.getSelected().length > 0\" \nmd-indeterminate=\"vm.isIndeterminate(vm.currentPageEntities)\" ng-click=\"vm.toggleSelectedProfiles()\"></md-checkbox><div\n layout=\"row\" ng-if=\"vm.getSelected().length > 0\" layout-align=\"center center\"><nuit-selection-indicator \nselection=\"vm.selection\" get-name=\"vm.getName\"></nuit-selection-indicator><md-button class=\"md-icon-button\" \naria-label=\"delete\" ng-click=\"vm.moveProfiles($event)\"><md-icon md-font-icon=\"icon-import\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.MOVE\">Verschieben</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.DELETE\">Delete</span></md-tooltip></md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><nuit-pagination \nall-entities=\"vm.filteredEntities\" current-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" \nentities-per-page=\"10\"></nuit-pagination></div></div></div><div class=\"content-wrapper\" layout=\"column\" flex>\n<md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.isLoading\" class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\" \ntranslate=\"APP.LOADING\">Loading ...</span></div><div ng-if=\"vm.profiles.length === 0 && !vm.isLoading\" \nclass=\"no-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><span class=\"md-headline\" \ntranslate=\"APP.EMPTY\">Empty</span></div><div class=\"thread unread\" ng-if=\"!vm.isLoading\" \nng-repeat=\"profile in vm.currentPageEntities track by profile.id\" ng-class=\"{\'selected\': vm.isSelected(profile)}\"><div \nlayout=\"row\" layout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(profile)\" \nng-click=\"vm.toggleSelectProfile(profile, $event)\" aria-label=\"{{vm.isSelected(profile) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"pv-15\" layout=\"row\" layout-align=\"start start\" flex><div layout=\"row\" flex class=\"mt-8\" flex>\n<div class=\"b img-container\" style=\"width:100px; height:100px\"><img ng-if=\"profile.data | profileImage\" \nhttp-src=\"{{ profile.data | profileImage }}\" fallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\" \ndraggable=\"false\" alt=\"Image\" ng-click=\"vm.magnifyImage(profile.data | profileImage)\"> <img \nng-if=\"!(profile.data | profileImage)\" src=\"assets/images/ecommerce/product-image-placeholder.jpg\" draggable=\"false\" \nalt=\"Image\"></div><div class=\"md-list-item-text ml-10\" flex><nuit-profile-tags profile=\"profile.data\">\n</nuit-profile-tags><h3 class=\"text-truncate m-0\" style=\"white-space: normal\" md-highlight-text=\"vm.term\" \nmd-highlight-flags=\"gi\">{{ profile.data.name | nuitTranslate:\'???\'}}</h3><p ng-if=\"profile.data.remark\" \nclass=\"text-truncate\" md-highlight-text=\"vm.term\" md-highlight-flags=\"gi\">{{::profile.data.remark}}</p></div></div>\n</div><div layout=\"column\"><md-button class=\"md-raised\" ng-click=\"vm.openProfile(profile)\" translate=\"MENUBAR.OPEN\">\nload</md-button><md-button class=\"md-raised\" ng-click=\"vm.renameProfile($event,profile.data)\"><div \ntranslate=\"PROFILE.RENAME\"></div></md-button></div></div></div></md-content></div></div>");
$templateCache.put("app/main/system.profiles/views/profiles.html","<div id=\"system\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\" layout=\"column\" layout-align=\"center center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-nutriton\" class=\"icon\"></md-icon>\n</span><span class=\"logo-text text-truncate\" translate=\"EVO.PROFILES\">Profiles</span></div></div><md-content ms-scroll \nclass=\"content\" flex><div class=\"m-10\" style=\"cursor: pointer\" ng-click=\"vm.showSelected({id:\'public\'})\" \nng-class=\"{\'text-bold\': (vm.$state.params.folder && vm.$state.params.folder===\'public\')}\"><md-icon \nstyle=\"margin-bottom: 5px\" md-font-icon=\"icon-folder-outline\"></md-icon><span translate=\"PROFILES.PUBLIC_FOLDERS\">\nPublic</span></div><treecontrol class=\"tree-classic\" expanded-nodes=\"vm.expandedFolders\" tree-model=\"vm.publicFolders\" \noptions=\"vm.treeOptions\" on-selection=\"vm.showSelected(node)\" order-by=\"vm.orderTree\" reverse-order=\"false\" \nselected-node=\"vm.selectedFolder\"><span class=\"title\">{{node.name?(node.name | nuitTranslate:\'???\'):\'???\'}}</span>\n</treecontrol><div style=\"cursor: pointer\" class=\"m-10 mt-20\" ng-click=\"vm.showSelected({id:\'private\'})\" \nng-class=\"{\'text-bold\': (vm.$state.params.folder && vm.$state.params.folder===\'private\')}\"><md-icon \nstyle=\"margin-bottom: 5px\" md-font-icon=\"icon-folder-outline\"></md-icon><span translate=\"PROFILES.PRIVATE_FOLDERS\">\nPrivate</span></div><treecontrol class=\"tree-classic\" expanded-nodes=\"vm.expandedFolders\" \ntree-model=\"vm.privateFolders\" options=\"vm.treeOptions\" on-selection=\"vm.showSelected(node)\" order-by=\"vm.orderTree\" \nreverse-order=\"false\" selected-node=\"vm.selectedFolder\"><span class=\"title\">\n{{node.name?(node.name | nuitTranslate:\'???\'):\'???\'}}</span></treecontrol></md-content></md-sidenav><div \nclass=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/system.roles/views/role-details.html","<div class=\"header\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" flex \nid=\"role-details\"><form name=\"vm.itemForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.roles\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span ng-if=\"!vm.newRole\" class=\"md-title\">\n{{ vm.role.name[vm.selectedLanguage] }}</span> <span ng-if=\"vm.newRole\" class=\"md-title\" translate=\"ROLES.ADD\">\nNeue Benutzerrolle</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.save()\" ng-disabled=\"!vm.itemForm.$valid || !vm.itemForm.$dirty\" \ntranslate=\"APP.SAVE\">Speichern</md-button></div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content \nclass=\"content-tabs\" layout=\"column\" layout-fill flex><div class=\"content\" ng-if=\"vm.isLoading\" flex><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-tabs \nlayout-fill ng-if=\"!vm.isLoading\"><md-tab><md-tab-label><span translate=\"APP.GENERAL\">Module</span></md-tab-label>\n<md-tab-body><ng-include src=\"\'app/main/system.roles/views/partials/general.html\'\"></ng-include></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"APP.MODULES\">Module</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.roles/views/partials/module.html\'\"></ng-include></md-tab-body></md-tab><md-tab><md-tab-label>\n<span translate=\"APP.DETAILS\">Details</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.roles/views/partials/module-details.html\'\"></ng-include></md-tab-body></md-tab></md-tabs>\n</md-content></div></form></div>");
$templateCache.put("app/main/system.roles/views/role-list.html","<div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-people\" class=\"icon\"></md-icon></span>\n<span class=\"logo-text\" translate=\"USERS.ROLES\">Benutzerrollen</span></div><div class=\"search-white\" \nlayout-align=\"start center\" layout=\"row\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon>\n<input id=\"user\" flex class=\"search-input input-placeholder-color\" ng-model=\"vm.searchText\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" \nng-model-options=\"{debounce:1000}\"></div><md-button ui-sref=\"app.roles.compose\" class=\"md-raised\" translate=\"APP.ADD\">\nAdd Role</md-button></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.getSelected().length > 0 ? \'Deselect All\' : \'Select All\'}}\" ng-checked=\"vm.getSelected().length > 0\" \nng-click=\"vm.toggleSelectedRoles()\"></md-checkbox><div layout=\"row\" ng-if=\"vm.getSelected().length > 0\" \nlayout-align=\"start center\"><div class=\"divider-vertical ml-20\"></div><md-button class=\"md-icon-button\" \naria-label=\"delete\" ng-click=\"vm.deleteSelection()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div><div layout=\"row\" layout-align=\"start center\">\n<div layout=\"row\" layout-align=\"start center\"><nuit-pagination all-entities=\"vm.filteredEntities\" \ncurrent-page-entities=\"vm.currentPageEntities\" current-page=\"vm.currentPage\" entities-per-page=\"10\"></nuit-pagination>\n</div></div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll \nflex><div ng-if=\"vm.isLoading\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...</span></div><div \nng-if=\"vm.roles.length === 0 && !vm.isLoading\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"USERROLES.NO_ROLES\">There are no userroles yet!</span></div><div \nclass=\"thread unread\" ng-if=\"!vm.isLoading\" ng-repeat=\"role in vm.currentPageEntities track by role.id\" \nng-class=\"{\'selected\': vm.isSelected(role)}\" ng-click=\"vm.openItem(role.id)\"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(role)\" \nng-click=\"vm.toggleSelectRole(role, $event)\" aria-label=\"{{vm.isSelected(role) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" layout=\"row\" flex layout-align=\"space-between center\"><span class=\"name text-truncate\">\n{{ role.name[vm.translation.language] }} </span><span class=\"text-italic\" translate=\"{{vm.getTypeName(role.type)}}\">\n</span></div></div></div></md-content></div></div>");
$templateCache.put("app/main/system.roles/views/roles.html","<div id=\"roles\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/system.sales/views/system.sales.html","<div id=\"sales\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\" flex><span \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-cart\" class=\"icon\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"SYSTEM.SALES_NAV\" flex>Sales</span></div><md-button class=\"md-raised\" ng-click=\"vm.save()\"><span \ntranslate=\"APP.SAVE\">Speichern</span></md-button></div><div class=\"content\" flex layout=\"column\"><md-tabs layout-fill \nflex><md-tab ng-if=\"vm.config.ims.sales.general.enabled\" md-active=\"vm.currentTab === \'general\'\" \nui-sref=\"app.sales({active:\'general\'})\"><md-tab-label><span translate=\"APP.GENERAL\">General</span></md-tab-label>\n<md-tab-body><ng-include src=\"\'app/main/system.sales/views/tabs/general.html\'\"></ng-include></md-tab-body></md-tab>\n<md-tab ng-if=\"vm.config.ims.sales.deductibles.enabled\" md-active=\"vm.currentTab === \'deductibles\'\" \nui-sref=\"app.sales({active:\'deductibles\'})\"><md-tab-label><span translate=\"SYSTEM.SALES_DEDUCTIBLES\">\nDeductibles (Rabatte)</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.sales/views/tabs/deductibles.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nng-if=\"vm.config.ims.sales.surcharges.enabled\" md-active=\"vm.currentTab === \'surcharges\'\" \nui-sref=\"app.sales({active:\'surcharges\'})\"><md-tab-label><span translate=\"SYSTEM.SALES_SURCHARGES\">Surcharges</span>\n</md-tab-label><md-tab-body><ng-include src=\"\'app/main/system.sales/views/tabs/surcharges.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.config.ims.sales.bending.enabled\" md-active=\"vm.currentTab === \'bending\'\" \nui-sref=\"app.sales({active:\'bending\'})\"><md-tab-label><span translate=\"SYSTEM.SALES_BENDINGPRICES\">Bending Prices\n</span></md-tab-label><md-tab-body><ng-include src=\"\'app/main/system.sales/views/tabs/bending.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.config.ims.sales.products.enabled\" md-active=\"vm.currentTab === \'products\'\" \nui-sref=\"app.sales({active:\'products\'})\"><md-tab-label><span translate=\"SYSTEM.SALES_PRODUCTPRICES\">Product Prices\n</span></md-tab-label><md-tab-body><ng-include src=\"\'app/main/system.sales/views/tabs/products.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.config.ims.sales.logistics.enabled\" md-active=\"vm.currentTab === \'logistics\'\" \nui-sref=\"app.sales({active:\'logistics\'})\"><md-tab-label><span translate=\"SYSTEM.SALES_LOGISTICPRICES\">Logistic Prices\n</span></md-tab-label><md-tab-body><ng-include src=\"\'app/main/system.sales/views/tabs/logistics.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.config.ims.sales.specials.enabled\" md-active=\"vm.currentTab === \'specials\'\" \nui-sref=\"app.sales({active:\'specials\'})\"><md-tab-label><span translate=\"SYSTEM.SALES_SPECIALS\">Special Prices</span>\n</md-tab-label><md-tab-body><ng-include src=\"\'app/main/system.sales/views/tabs/specials.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.config.ims.sales.fixedTimePrices.enabled\" \nmd-active=\"vm.currentTab === \'fixedtimeprices\'\" ui-sref=\"app.sales({active:\'fixedtimeprices\'})\"><md-tab-label><span \ntranslate=\"SYSTEM.SALES_FIXEDTIMEPRICES\">Fixed Time Prices</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.sales/views/tabs/fixedTimePrices.html\'\"></ng-include></md-tab-body></md-tab></md-tabs></div>\n</div>");
$templateCache.put("app/main/system.system/views/system.html","<div id=\"system\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\" flex><span \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"SYSTEM.SYSTEM_NAV\" flex>System</span></div><md-button class=\"md-raised\" \nng-if=\"vm.currentTab === \'translations\'\" ng-click=\"vm.addTranslation()\"><span translate=\"TRANSLATIONS.ADD_TRANSLATION\">\nAdd Translation</span></md-button><md-button class=\"md-raised\" ng-if=\"vm.currentTab === \'translations\'\" \nng-click=\"vm.showImportTranslationsDialog()\"><span translate=\"TRANSLATIONS.IMPORT_TRANSLATIONS\">Import Translations\n</span></md-button><md-button class=\"md-raised\" ng-if=\"vm.currentTab === \'colors\'\" ng-click=\"vm.addColor()\"><span \ntranslate=\"COLORS.ADD_COLOR\">Add Color</span></md-button><md-button class=\"md-raised\" \nng-if=\"vm.currentTab === \'colors\'\" ng-click=\"vm.showImportColorsDialog()\"><span translate=\"COLORS.IMPORT_COLORS\">\nImport Colors</span></md-button></div><div class=\"content\" flex layout=\"column\"><md-tabs layout-fill flex><md-tab \nng-if=\"vm.config.ims.system.evoSettings.enabled\" md-active=\"vm.currentTab === \'evo\'\" \nui-sref=\"app.system({active:\'evo\'})\"><md-tab-label><span translate=\"SYSTEM.EVO_SETTINGS\">Evo Einstellungen</span>\n</md-tab-label><md-tab-body><ng-include src=\"\'app/main/system.system/views/tabs/evo.html\'\"></ng-include></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.config.ims.system.imsSettings.enabled\" md-active=\"vm.currentTab === \'ims\'\" \nui-sref=\"app.system({active:\'ims\'})\"><md-tab-label><span translate=\"SYSTEM.IMS_SETTINGS\">IMS Einstellungen</span>\n</md-tab-label><md-tab-body><ng-include src=\"\'app/main/system.system/views/tabs/ims.html\'\"></ng-include></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.config.ims.system.translations.enabled\" md-active=\"vm.currentTab === \'translations\'\" \nui-sref=\"app.system({active:\'translations\'})\"><md-tab-label><span translate=\"SYSTEM.TRANSLATIONS\">Übersetzungen</span>\n</md-tab-label><md-tab-body><ng-include src=\"\'app/main/system.system/views/tabs/translations.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.config.ims.system.companySettings.enabled\" \nmd-active=\"vm.currentTab === \'company\'\" ui-sref=\"app.system({active:\'company\'})\"><md-tab-label><span \ntranslate=\"SYSTEM.COMPANY\">Unternehmen</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.system/views/tabs/company.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nng-if=\"vm.config.ims.system.colorSettings.enabled\" md-active=\"vm.currentTab === \'colors\'\" \nui-sref=\"app.system({active:\'colors\'})\"><md-tab-label><span translate=\"SYSTEM.COLORS\">Colors</span></md-tab-label>\n<md-tab-body><ng-include src=\"\'app/main/system.system/views/tabs/colors.html\'\"></ng-include></md-tab-body></md-tab>\n<md-tab ng-if=\"vm.config.ims.system.bankHolidaySettings.enabled\" md-active=\"vm.currentTab ===\'holidays\'\" \nui-sref=\"app.system({active:\'holidays\'})\"><md-tab-label><span translate=\"SYSTEM.BANK_HOLIDAYS\"></span></md-tab-label>\n<md-tab-body><div ui-view=\"holidays\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.config.ims.system.importExport.enabled\" md-active=\"vm.currentTab ===\'importExport\'\" \nui-sref=\"app.system({active:\'importExport\'})\"><md-tab-label><span translate=\"SYSTEM.IMPORT_EXPORT\"></span>\n</md-tab-label><md-tab-body><ng-include src=\"\'app/main/system.system/views/tabs/import-export.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.config.ims.system.deliveryDelay.enabled\" \nmd-active=\"vm.currentTab ===\'deliveryDelay\'\" ui-sref=\"app.system({active:\'deliveryDelay\'})\"><md-tab-label><span \ntranslate=\"SYSTEM.DELIVERY_DELAY\"></span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.system/views/tabs/delivery-delay.html\'\"></ng-include></md-tab-body></md-tab></md-tabs></div>\n</div>");
$templateCache.put("app/main/system.users/views/user-details.html","<div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div class=\"content-card\" layout=\"column\" \nflex><form name=\"vm.itemForm\" novalidate layout=\"column\" flex ng-model-options=\"{debounce:200}\"><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"$emit(\'toggleSidenav\',\'main-sidenav\')\" ng-if=\"vm.sidebarEnabled()\" \nhide-gt-md aria-label=\"Toggle Sidenav\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ui-sref=\"app.users\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"divider-vertical mr-20\"></div><span class=\"md-title\" ng-if=\"!vm.isExistingUser\" translate=\"USERS.ADD\">Add user\n</span> <span class=\"md-title\" ng-if=\"vm.isExistingUser\">{{ vm.user.firstName }} {{ vm.user.lastName }}</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.saveUser()\" \nng-disabled=\"!vm.itemForm.$valid || !vm.itemForm.$dirty\" translate=\"APP.SAVE\">Speichern</md-button></div></div><div \nclass=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex><div \nclass=\"content\" ng-if=\"vm.loadingItem\" flex><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n<span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-tabs \nlayout-fill flex md-selected=\"vm.selectedTab\" ng-if=\"!vm.loadingItem\"><md-tab \nui-sref=\"app.users.detail({active:\'general\'})\" md-active=\"vm.selectedTab === \'general\'\"><md-tab-label><span \ntranslate=\"USERS.GENERAL\">General</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.users/views/partials/general.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nng-if=\"vm.isExistingUser\" ui-sref=\"app.users.detail({active:\'security\'})\" md-active=\"vm.selectedTab === \'security\'\">\n<md-tab-label><span translate=\"USERS.SECURITY\">SECURITY</span></md-tab-label><md-tab-body><ng-include \nsrc=\"\'app/main/system.users/views/partials/security.html\'\"></ng-include></md-tab-body></md-tab><md-tab \nng-if=\"vm.config.admin.clients.enabled\" ui-sref=\"app.users.detail({active:\'admin\'})\" \nmd-active=\"vm.selectedTab === \'admin\'\"><md-tab-label><span>{{\'ADMIN.ADMIN_NAV\' | translate }}</span></md-tab-label>\n<md-tab-body><ng-include src=\"\'app/main/system.users/views/partials/admin.html\'\"></ng-include></md-tab-body></md-tab>\n</md-tabs></md-content></div></form></div>");
$templateCache.put("app/main/system.users/views/user-list.html","<div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-worker\" class=\"icon\"></md-icon></span>\n<span class=\"logo-text\" translate=\"USERS.USERS\">Benutzer</span></div><div class=\"search-white\" \nlayout-align=\"start center\" layout=\"row\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon>\n<input id=\"user\" flex class=\"search-input\" ng-model=\"vm.searchText\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" ng-model-options=\"{debounce:1000}\"></div><div \nlayout=\"row\"><md-button class=\"md-raised\" ng-click=\"vm.openUserSignup()\" translate=\"APP.SIGNUP\" \nng-if=\"vm.config.ims.users.allowSignup\">Register User</md-button><md-button class=\"md-raised\" \nui-sref=\"app.users.compose\" translate=\"APP.ADD\" ng-if=\"!vm.disableUserAdding()\">Add User</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openUserSelection()\" translate=\"APP.RESTORE\" ng-if=\"!vm.disableUserAdding()\">Restore\n</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedItems.length > 0 ? \'Deselect All\' : \'Select All\'}}\" ng-checked=\"vm.selectedItems.length > 0\" \nng-click=\"vm.toggleSelectedItems()\"></md-checkbox><div layout=\"row\" ng-if=\"vm.selectedItems.length > 0\" \nlayout-align=\"start center\"><div class=\"divider-vertical ml-20\"></div><md-button class=\"md-icon-button\" \naria-label=\"delete\" ng-click=\"vm.deleteSelected()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div><div layout=\"row\" layout-align=\"start center\">\n<nuit-pagination all-entities=\"vm.filteredEntities\" current-page-entities=\"vm.currentPageEntities\" \ncurrent-page=\"vm.currentPage\" entities-per-page=\"10\"></nuit-pagination></div></div><div class=\"content-wrapper\" \nlayout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.loadingItems\" \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div><div \nng-if=\"vm.items.length === 0 && !vm.loadingItems\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\" translate=\"USERS.NO_USERS\">There are no users yet!</span></div>\n<nuit-max-count-restriction \nng-if=\"vm.config.ims.users.restrictions.enabled && vm.items.length>=vm.config.ims.users.restrictions.maxUsers-vm.config.ims.users.restrictions.warnOffset\" \ncurrent-count=\"vm.items.length\" max-count=\"vm.config.ims.users.restrictions.maxUsers\" \nwarn-offset=\"vm.config.ims.users.restrictions.warnOffset\" text=\"\'USERS.MAX_USERS_WARNING\'\" \nlink=\"vm.config.ims.users.restrictions.link\" layout=\"row\"></nuit-max-count-restriction><div class=\"thread unread\" \nng-if=\"!vm.loadingItems\" ng-repeat=\"item in vm.currentPageEntities track by item.id\" \nng-class=\"{\'selected\': vm.isSelected(item)}\" ng-click=\"vm.openItem(item.id)\"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(item)\" \nng-click=\"vm.toggleSelectItem(item, $event)\" aria-label=\"{{vm.isSelected(item) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"avatar\"><img src=\"{{item.avatar}}\" http-src=\"{{item.avatar}}\" \nfallback-src=\"assets/images/avatars/profile.jpg\" draggable=\"false\" alt=\"user\"></div><div class=\"info\" layout=\"column\" \nflex><span class=\"name text-truncate\">{{item.firstName}} {{item.lastName}}</span><div class=\"message text-truncate\">\n<span>{{ item.email }}</span> <span ng-if=\"item.phone\"><span class=\"ph-8\">~</span> {{item.phone}}</span></div></div>\n<div class=\"labels\" layout=\"row\" layout-align=\"end start\" layout-wrap ng-if=\"item.roleId !== null\"><div \nclass=\"label md-blue-500-bg text-truncate\"><span>{{ vm.getRoleById(item.roleId).name[vm.translation.language] }}</span>\n<md-tooltip><span translate=\"ACCOUNT.USER_ROLE\">Userrole</span></md-tooltip></div></div></div></div></md-content></div>\n</div>");
$templateCache.put("app/main/system.users/views/users.html","<div id=\"user\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex ui-view=\"body\"></div></div>");
$templateCache.put("app/main/toolbar/views/account.html","<md-dialog><md-toolbar layout=\"row\" layout-align=\"center center\"><span translate=\"ACCOUNT.PERSONAL_DATA\"></span>\n</md-toolbar><md-dialog-content class=\"p-12\"><form name=\"vm.userForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" class=\"md-white-bg\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label \ntranslate=\"ACCOUNT.USER_FIRSTNAME\">Firstname</label><md-icon></md-icon><input disabled=\"true\" name=\"firstname\" \ntype=\"text\" ng-model=\"vm.user.firstName\" required md-autofocus md-maxlength=\"30\" maxlength=\"30\"><div \nng-messages=\"vm.userForm.firstname.$error\" ng-show=\"vm.userForm.firstName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\"><label translate=\"ACCOUNT.USER_SURNAME\">Surname</label><md-icon>\n</md-icon><input disabled=\"true\" name=\"surname\" type=\"text\" ng-model=\"vm.user.lastName\" required md-maxlength=\"30\" \nmaxlength=\"30\"><div ng-messages=\"vm.userForm.surname.$error\" ng-show=\"vm.userForm.lastName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label translate=\"ACCOUNT.USER_EMAIL\">Email</label><md-icon\n md-font-icon=\"icon-email\" class=\"name\"></md-icon><input name=\"email\" type=\"email\" ng-model=\"vm.user.email\" \nng-disabled=\"true\" required ng-pattern=\"/^.+@.+\\..+$/\" md-maxlength=\"50\" maxlength=\"50\"><div \nng-messages=\"vm.userForm.email.$error\" ng-show=\"vm.userForm.email.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"50\"><label translate=\"ACCOUNT.PHONE\">Phone</label><md-icon md-font-icon=\"icon-phone\" \nclass=\"name\"></md-icon><input name=\"text\" type=\"phone\" ng-model=\"vm.user.phone\" md-maxlength=\"50\" maxlength=\"50\">\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block mb-0\" \nflex><label translate=\"ACCOUNT.AVATAR\">Avatar</label><md-icon md-font-icon=\"icon-account-circle\" class=\"name\">\n</md-icon><input ng-disabled=\"true\" name=\"avatar\" type=\"text\" ng-model=\"vm.user.avatar\"></md-input-container><div \nclass=\"ml-10\" style=\"width:68px;height:68px\" \nng-class=\"{\'md-whiteframe-5dp\': vm.user.avatar || vm.user.avatar === null}\"><img class=\"md-whiteframe-5dp\" \nstyle=\"max-height:68px;max-width:68px; width: auto; height:auto\" http-src=\"{{vm.user.avatar}}\" \nsrc=\"{{vm.user.avatar}}\" alt=\" \"></div><md-button class=\"md-default-theme md-raised md-fab md-mini\" flex=\"none\" \nng-click=\"vm.uploadImage()\"><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button></div><div layout=\"row\">\n<md-button type=\"submit\" class=\"md-raised\" ng-disabled=\"vm.userForm.$invalid || vm.userForm.$pristine\" \nng-click=\"vm.updateUser()\"><span translate=\"APP.UPDATE\">Aktualisieren</span></md-button><span flex></span></div></div>\n</form><form class=\"mt-40\"><div layout=\"column\" class=\"md-white-bg\"><div layout=\"row\"><md-input-container \nclass=\"md-block mb-0\" flex=\"50\"><label translate=\"ACCOUNT.NEW_PASSWORD\">Neues Passwort</label><input name=\"password\" \ntype=\"password\" ng-model=\"vm.password\"></md-input-container><md-input-container class=\"md-block mb-0\" flex=\"50\"><label \ntranslate=\"ACCOUNT.REPEAT_PASSWORD\">Passwort wiederholen</label><input name=\"password2\" type=\"password\" \nng-model=\"vm.passwordRepeat\"></md-input-container></div><div layout=\"row\"><md-button class=\"md-raised\" \nng-click=\"vm.changePassword()\" ng-disabled=\"!vm.passwordChangeable()\"><span translate=\"ACCOUNT.SET_PASSWORD\">\nSet password</span></md-button><span flex></span></div></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" class=\"border-top\"><div layout=\"row\" layout-align=\"end center\" flex>\n<md-button type=\"submit\" class=\"md-raised md-primary\" aria-label=\"Close\" translate-attr-aria-label=\"APP.CLOSE\" \nng-click=\"vm.close()\"><span translate=\"APP.CLOSE\">Close</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/toolbar/views/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\"><div class=\"pr-10 font-size-18\">\n{{vm.config.environment.companyData.name}}</div><md-button ng-disabled=\"!vm.config.ims.account.enabled\" \nclass=\"pl-16 pr-16 m-0 p-0 h-45\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.showAccount()\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"{{vm.user.avatar}}\" http-src=\"{{vm.user.avatar}}\" \nfallback-src=\"assets/images/avatars/profile.jpg\" fallback-src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" style=\"color:black; font-weight: normal; text-transform: none\" hide show-gt-sm>\n{{ vm.user.lastName}}, {{vm.user.firstName}}</span></md-button><div class=\"toolbar-separator\"></div><md-menu \nid=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-menu-item id=\"logout-button\"><md-button ng-click=\"vm.logout()\"><md-tooltip \nmd-delay=\"200\">Logout</md-tooltip><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon></md-button>\n</md-menu-item></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button white-fg\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button white-fg\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge && node.badge.content\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/admin.clients/dialogs/add-environment/add-environment.html","<md-dialog><form name=\"environmentForm\" ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"CLIENTS.ADD\">Client hinzufügen</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" \nng-disabled=\"vm.isCreating\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"position:relative;min-width:500px\"><div class=\"md-dialog-content\"><div \nlayout=\"column\"><div layout=\"column\"><md-input-container flex><label class=\"w-180 text-uppercase\">Name</label><input \ntype=\"text\" ng-model=\"vm.env.environment\" required></md-input-container><md-input-container flex><label \nclass=\"w-180 text-uppercase\">DB Username</label><input type=\"text\" ng-model=\"vm.env.username\" required>\n</md-input-container><md-input-container flex><label translate=\"CLIENTS.TEMPLATE\">Template</label><md-select \nng-model=\"vm.env.template\"><md-option ng-repeat=\"template in vm.templates\" ng-value=\"template.id\"><div layout=\"row\" \nlayout-align=\"start center\"><span>{{ template.name | nuitTranslate }}</span></div></md-option><md-option ng-value=\"\">\n<span class=\"grey-500-fg\" translate=\"CLIENTS.NO_TEMPLATE\"></span></md-option></md-select></md-input-container></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-progress-circular \nclass=\"md-primary\" md-mode=\"indeterminate\" ng-if=\"vm.isCreating\" md-diameter=\"32\"></md-progress-circular><md-button \nng-click=\"vm.cancel()\" ng-disabled=\"vm.isCreating\"><span translate=\"APP.CANCEL\">Abbrechen</span></md-button><md-button \nng-click=\"vm.create()\" ng-disabled=\"environmentForm.$invalid || vm.isCreating\" class=\"md-accent md-raised\"><span \ntranslate=\"APP.CREATE\">Erstellen</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin.documents/dialogs/documents.edit/documents.edit.html","<md-dialog aria-label=\"New Document\"><form name=\"documentsForm\" ng-submit=\"vm.submit()\" novalidate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" ng-if=\"!vm.isNew\" translate=\"APP.EDIT\">Edit</span> <span class=\"title\" ng-if=\"vm.isNew\" \ntranslate=\"DOCUMENTS.ADD\">New Document</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout=\"row\"><md-input-container><label translate=\"APP.NAME\">Bezeichnung</label><input type=\"text\" name=\"name\" \nng-model=\"vm.document.name[vm.currentLanguage]\" md-maxlength=\"100\" required><div \nng-messages=\"documentsForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">\nRequired</span></div></div></md-input-container><md-input-container><label translate=\"APP.LANGUAGE\">Lang</label>\n<md-select ng-model=\"vm.currentLanguage\"><md-option ng-repeat=\"lang in vm.languages\" ng-value=\"lang\"><span \nclass=\"text-uppercase\">{{lang}}</span></md-option></md-select></md-input-container></div><md-input-container><label \ntranslate=\"APP.NAME\">Bezeichnung</label><input type=\"text\" name=\"name\" \nng-model=\"vm.getDataOfLang(vm.currentLanguage).name\" md-maxlength=\"100\" required><div \nng-messages=\"documentsForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">\nRequired</span></div></div></md-input-container><md-input-container class=\"mb-8\"><label translate=\"DOCUMENTS.HEADER\">\nHeader</label><md-select ng-model=\"vm.getDataOfLang(vm.currentLanguage).header\"><md-option ng-value=\"null\"><span \nclass=\"grey-400-fg\">{{ \'APP.EMPTY\' | translate }}</span></md-option><md-option \nng-repeat=\"template in vm.envTemplates track by template.key+template.lang\" ng-value=\"template.key\">\n{{ template.name | nuitTranslate }}</md-option><md-option \nng-repeat=\"template in vm.templates track by template.key+template.lang\" ng-value=\"template.key\">\n{{ template.name | nuitTranslate }}</md-option></md-select></md-input-container><md-input-container class=\"mb-8\"><label\n translate=\"DOCUMENTS.CONTENT\">Content</label><md-select ng-model=\"vm.getDataOfLang(vm.currentLanguage).content\">\n<md-option ng-value=\"null\"><span class=\"grey-400-fg\">{{ \'APP.EMPTY\' | translate }}</span></md-option><md-option \nng-repeat=\"template in vm.envTemplates track by template.key+template.lang\" ng-value=\"template.key\">\n{{ template.name | nuitTranslate }}<md-icon ng-if=\"template.orientation === \'Landscape\'\" class=\"s16 ml-8 grey-500-fg\" \nmd-font-icon=\"icon-crop-landscape\"></md-icon></md-option><md-option \nng-repeat=\"template in vm.templates track by template.key+template.lang\" ng-value=\"template.key\">\n{{ template.name | nuitTranslate }}<md-icon ng-if=\"template.orientation === \'Landscape\'\" class=\"s16 ml-8 grey-500-fg\" \nmd-font-icon=\"icon-crop-landscape\"></md-icon></md-option></md-select></md-input-container><md-input-container \nclass=\"mb-8\"><label translate=\"DOCUMENTS.FOOTER\">Footer</label><md-select \nng-model=\"vm.getDataOfLang(vm.currentLanguage).footer\"><md-option ng-value=\"null\"><span class=\"grey-400-fg\">\n{{ \'APP.EMPTY\' | translate }}</span></md-option><md-option \nng-repeat=\"template in vm.envTemplates track by template.key+template.lang\" ng-value=\"template.key\">\n{{ template.name | nuitTranslate }}</md-option><md-option \nng-repeat=\"template in vm.templates track by template.key+template.lang\" ng-value=\"template.key\">\n{{ template.name | nuitTranslate }}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"vm.roles.length > 0\"><label translate=\"DOCUMENTS.USER_ROLES\">Roles</label><md-select \nng-model=\"vm.document.roles\" ng-model-options=\"{\'trackby\':\'$value.id\'}\" multiple=\"multiple\"><md-option \nng-repeat=\"role in vm.roles track by role.id\" ng-value=\"role.id\">{{ role.name | nuitTranslate }}</md-option>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\"><md-button \ntype=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nclass=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"documentsForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin.notifications/dialogs/edit-channel/edit-channel.html","<md-dialog style=\"width: 80%; max-width:80%; height:80%; max-height: 80%\"><md-content><form name=\"vm.form\" novalidate \nng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\"><div layout=\"column\" layout-fill layout-padding>\n<nuit-connection config=\"vm.channel\" connection-types=\"vm.channelTypes\" header=\"NOTIFICATIONS.CHANNEL\" \nhas-path=\"false\" has-content-type=\"false\" require-all=\"false\" flex ng-if=\"!vm.loading\"></nuit-connection>\n<md-input-container flex class=\"m-10\"><label translate=\"APP.NAME\"></label><input name=\"name\" type=\"text\" \nng-model=\"vm.channel.name\" required></md-input-container></div></form></md-content><md-dialog-actions><div \nlayout=\"row\" layout-margin layout-align=\"space-between start\"><md-button class=\"md-warn md-raised\" \nng-disabled=\"!vm.form.$dirty\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save</md-button><md-button class=\"md-raised\" \nng-click=\"vm.cancel()\" translate=\"APP.CANCEL\">Cancel</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.notifications/dialogs/edit-content/edit-content.html","<md-dialog style=\"width:98%;max-width:98%; height:98%; max-height:98%\" class=\"grey-50-bg\"><md-content \nclass=\"grey-50-bg\"><form name=\"vm.form\" novalidate ng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\"><div \nlayout=\"row\" layout-fill layout-padding><div layout=\"column\" flex><div layout=\"row\"><md-input-container flex><label \ntranslate=\"APP.LANGUAGE\"></label><md-select ng-model=\"vm.content.lang\" required><md-option \nng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{ lang }}</span></md-option>\n</md-select></md-input-container><md-input-container flex><label translate=\"NOTIFICATIONS.CONTENT_TYPE\"></label>\n<md-select ng-model=\"vm.content.contentType\" required><md-option ng-repeat=\"contentType in vm.contentTypes\" \nng-value=\"contentType\"><span>{{ contentType }}</span></md-option></md-select></md-input-container></div>\n<md-input-container><label translate=\"NOTIFICATIONS.SUBJECT\"></label><input name=\"subject\" type=\"text\" \nng-model=\"vm.content.subject\"></md-input-container><textarea class=\"grey-50-bg\" style=\"min-height:500px\" flex \nname=\"template\" type=\"text\" ng-model=\"vm.content.tpl\" required></textarea></div><div \nng-if=\"vm.content.contentType===\'text/html\'\" style=\"min-width:50%\" class=\"white-bg\" \nng-bind-html=\"vm.renderContent(vm.content.tpl)\"></div></div></form></md-content><md-dialog-actions><div layout=\"row\" \nlayout-margin layout-align=\"space-between start\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.save()\" \ntranslate=\"APP.SAVE\">Save</md-button><md-button class=\"md-raised\" ng-click=\"vm.cancel()\" translate=\"APP.CANCEL\">Cancel\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.notifications/dialogs/edit-custom/edit-custom.html","<md-dialog><md-content><form name=\"vm.form\" novalidate ng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\"><div \nlayout=\"column\" layout-padding><md-input-container><label translate=\"NOTIFICATIONS.CHANNEL\"></label><md-select \nng-model=\"vm.custom.channelId\" required><md-option ng-value=\"channel.id\" ng-repeat=\"channel in vm.channels\">\n{{channel.name}}</md-option></md-select></md-input-container><md-input-container><label translate=\"NOTIFICATIONS.NAME\">\n</label><input name=\"receiver\" type=\"text\" ng-model=\"vm.custom.name\" required></md-input-container><md-input-container>\n<label translate=\"NOTIFICATIONS.RECEIVER\"></label><input name=\"receiver\" type=\"text\" ng-model=\"vm.custom.receiver\" \nrequired></md-input-container></div></form></md-content><md-dialog-actions><div layout=\"row\" layout-margin \nlayout-align=\"space-between start\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save\n</md-button><md-button class=\"md-raised\" ng-click=\"vm.cancel()\" translate=\"APP.CANCEL\">Cancel</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.notifications/dialogs/edit-event/edit-event.html","<md-dialog><md-content><form name=\"vm.form\" novalidate ng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\"><div \nlayout=\"column\" layout-padding><md-input-container flex><label translate=\"NOTIFICATION.TEMPLATE\"></label><md-select \nng-model=\"vm.event.templateId\" required><md-option ng-value=\"template.id\" ng-repeat=\"template in vm.templates\">\n{{template.name}}</md-option></md-select></md-input-container><md-input-container flex><label translate=\"APP.NAME\">\n</label><input name=\"name\" type=\"text\" ng-model=\"vm.event.name\" required></md-input-container></div></form>\n</md-content><md-dialog-actions><div layout=\"row\" layout-margin layout-align=\"space-between start\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save</md-button><md-button class=\"md-raised\" \nng-click=\"vm.cancel()\" translate=\"APP.CANCEL\">Cancel</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.notifications/dialogs/edit-role/edit-role.html","<md-dialog><md-content><form name=\"vm.form\" novalidate ng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\"><div \nlayout=\"column\" layout-padding><md-input-container flex><label translate=\"NOTIFICATIONS.CHANNEL\"></label><md-select \nng-model=\"vm.role.channelId\" required><md-option ng-value=\"channel.id\" ng-repeat=\"channel in vm.channels\">\n{{channel.name}}</md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.newRole\"><label \ntranslate=\"NOTIFICATIONS.ROLE\"></label><md-select ng-model=\"vm.role.roleId\" required><md-option ng-value=\"role.id\" \nng-repeat=\"role in vm.roles\">{{role.name | nuitTranslate}} ({{vm.getTypeName(role.type) | translate}})</md-option>\n</md-select></md-input-container><div ng-if=\"!vm.newRole\">{{vm.role.role.name | nuitTranslate}}</div></div></form>\n</md-content><md-dialog-actions><div layout=\"row\" layout-margin layout-align=\"space-between start\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save</md-button><md-button class=\"md-raised\" \nng-click=\"vm.cancel()\" translate=\"APP.CANCEL\">Cancel</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.notifications/dialogs/edit-trigger/edit-trigger.html","<md-dialog><md-content><form name=\"vm.form\" novalidate ng-submit=\"vm.save()\"><div layout=\"column\" layout-fill \nlayout-padding><div layout=\"row\" flex><md-input-container flex><label translate=\"NOTIFICATIONS.TRIGGER_TYPE\"></label>\n<md-select ng-model=\"vm.trigger.type\" required ng-change=\"vm.updateTriggerNames()\"><md-option \nng-repeat=\"triggerType in vm.triggerTypes\" ng-value=\"triggerType\"><span class=\"text-uppercase\">{{ triggerType }}</span>\n</md-option></md-select></md-input-container></div><md-input-container flex class=\"m-10\"><label translate=\"APP.NAME\">\n</label><md-select ng-model=\"vm.trigger.name\" required><md-option ng-repeat=\"triggerName in vm.triggerNames\" \nng-value=\"triggerName\"><span class=\"text-uppercase\">{{ triggerName }}</span></md-option></md-select>\n</md-input-container><div ng-jsoneditor ng-model=\"vm.trigger.conditions\" options=\"{mode: \'tree\'}\"></div></div></form>\n</md-content><md-dialog-actions><div layout=\"row\" layout-margin layout-align=\"space-between start\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save</md-button><md-button class=\"md-raised\" \nng-click=\"vm.cancel()\" translate=\"APP.CANCEL\">Cancel</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.notifications/dialogs/edit-user/edit-user.html","<md-dialog><md-content><form name=\"vm.form\" novalidate ng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\"><div \nlayout=\"column\" layout-padding><md-input-container flex><label translate=\"NOTIFICATIONS.CHANNEL\"></label><md-select \nng-model=\"vm.user.channelId\" required><md-option ng-value=\"channel.id\" ng-repeat=\"channel in vm.channels\">\n{{channel.name}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.newUser\"><label \ntranslate=\"NOTIFICATIONS.USER\"></label><md-select ng-model=\"vm.user.userId\" required flex><md-option \nng-value=\"user.id\" ng-repeat=\"user in vm.users\">{{user.email}}</md-option></md-select></md-input-container><div \nng-if=\"!vm.newUser\">{{vm.user.user.email}}</div></div></form></md-content><md-dialog-actions><div layout=\"row\" \nlayout-margin layout-align=\"space-between start\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.save()\" \ntranslate=\"APP.SAVE\">Save</md-button><md-button class=\"md-raised\" ng-click=\"vm.cancel()\" translate=\"APP.CANCEL\">Cancel\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.notifications/views/config/config.html","");
$templateCache.put("app/main/admin.environment/components/config-editor/config-editor.component.html","<div layout=\"column\" class=\"mt-20\"><ng-include ng-show=\"vm.listView\" \nsrc=\"\'app/main/admin.environment/components/config-editor/setting.html\'\" ng-init=\"vm.resetDefault();\"></ng-include>\n</div>");
$templateCache.put("app/main/admin.environment/components/config-editor/setting.html","<div ng-repeat=\"model in vm.tree\" layout=\"column\" ng-if=\"vm.containsSearchTerm(model)\" \nng-init=\"customInput = vm.getCustomInput(model.model)\" \nng-class=\"{\'grey-100-bg\': model.section.isVisible && model.section.count>1}\" layout-fill><div flex \nstyle=\"text-align: center; cursor:pointer\" class=\"h3 grey-200-bg p-10 mb-10\" ng-if=\"model.showSection\" \nng-click=\"model.section.isVisible=!model.section.isVisible\" translate=\"{{model.section.name}}\"></div><div layout=\"row\" \nlayout-fill class=\"pl-{{model.section.count>1?model.depth*20+10:10}} mb-10\" \nng-style=\"{opacity: !model.section.enabled.value && !model.showSection?0.4:1}\" \nng-if=\"model.section.isVisible  || vm.hasSearchTerm(model)\"><div flex=\"50\" layout=\"column\" layout-fill><span \nstyle=\"cursor:pointer\" flex=\"30\" class=\"text-bold\" layout=\"row\" ng-init=\"showModel=false\" \nng-click=\"showModel=!showModel\"><span ng-if=\"!showModel\">{{model.name}}</span> <span ng-if=\"showModel\">{{model.model}}\n</span> </span><span flex=\"30\" layout=\"row\" ng-if=\"vm.isInConfig(model[\'model\'])\"><span translate=\"APP.DEFAULT\"></span>\n <span class=\"text-italic\">: {{model.defaultData}}</span></span><div class=\"mr-10\" translate=\"{{model.translation}}\">\n</div></div><div flex layout=\"row\" ng-switch=\"model.type\" layout-align=\"start start\"><md-input-container flex \nclass=\"m-0 p-0\" ng-switch-when=\"4\"><md-switch class=\"m-0 p-0\" ng-disabled=\"!vm.isInConfig(model[\'model\'])\" \nng-model=\"model.data.value\"></md-switch></md-input-container><div ng-switch-when=\"3\" flex><div ng-if=\"!customInput\" \nng-jsoneditor ng-model=\"model.data.value\" options=\"{mode: \'tree\'}\"></div><div ng-if=\"customInput\" \nng-include=\"customInput\"></div></div><md-input-container flex class=\"m-0 p-0\" ng-switch-default><input class=\"m-0 p-0\" \ntype=\"number\" ng-disabled=\"!vm.isInConfig(model[\'model\'])\" ng-model=\"model.data.value\" \nng-change=\"vm.updateNumberType(model)\"></md-input-container><div ng-switch-when=\"2\" flex layout=\"row\">\n<md-input-container flex class=\"m-0 p-0\" ng-if=\"!customInput\"><input class=\"m-0 p-0\" type=\"text\" \nng-disabled=\"!vm.isInConfig(model[\'model\'])\" ng-model=\"model.data.value\"></md-input-container><div ng-if=\"customInput\" \nng-include=\"customInput\" flex></div></div><div class=\"mt-10 text-bold\" \nng-if=\"(model.data.type===1 || model.data.type===5)\">{{model.data.type===1?\'int\':\'float\'}}</div><span \nclass=\"text-bold\" ng-if=\"!vm.isInConfig(model[\'model\'])\"><md-button ng-click=\"vm.addConfig(model[\'model\'])\"><md-icon \nmd-font-icon=\"icon-lock\"></md-icon></md-button></span><span class=\"text-bold\" \nng-if=\"vm.isInConfig(model[\'model\']) && !vm.removeable\"><md-button ng-click=\"vm.removeConfig(model[\'model\'])\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></span></div></div></div>");
$templateCache.put("app/main/admin.environment/components/config-single/config-single.component.html","<div layout=\"row\" layout-fill class=\"pl-10\" ng-init=\"vm.init()\" ng-if=\"vm.containsSearchTerm()\"><div flex=\"50\" \nlayout=\"column\" layout-fill><span flex=\"30\" class=\"text-bold\" layout=\"row\">{{vm.key}} </span><span flex=\"30\" \nlayout=\"row\" ng-if=\"vm.isInConfig() && vm.showDefaultValue\"><span translate=\"APP.DEFAULT\"></span> <span \nclass=\"text-italic\">: {{vm.defaultValue}}</span> </span><span class=\"md-truncate\" translate=\"{{vm.translation}}\">\n</span></div><div flex layout=\"row\" ng-switch=\"vm.type\" layout-align=\"start start\"><md-input-container flex \nclass=\"m-0 p-0\" ng-switch-when=\"4\"><md-switch class=\"m-0 p-0\" ng-disabled=\"!vm.isInConfig()\" ng-model=\"vm.value\" \nng-change=\"vm.updateConfig()\"></md-switch></md-input-container><md-input-container flex class=\"m-0 p-0\" \nng-switch-default><input class=\"m-0 p-0\" type=\"number\" ng-disabled=\"!vm.isInConfig()\" ng-model=\"vm.value\" \nng-change=\"vm.updateConfig()\"></md-input-container><md-input-container flex class=\"m-0 p-0\" ng-switch-when=\"2\"><input \nclass=\"m-0 p-0\" type=\"text\" ng-disabled=\"!vm.isInConfig()\" ng-model=\"vm.value\" ng-change=\"vm.updateConfig()\">\n</md-input-container><span class=\"text-bold\" ng-if=\"!vm.isInConfig()\"><md-button ng-click=\"vm.addConfig()\"><md-icon \nmd-font-icon=\"icon-lock\"></md-icon></md-button></span><span class=\"text-bold\" ng-if=\"vm.isInConfig()\"><md-button \nng-click=\"vm.removeConfig()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></span></div></div>");
$templateCache.put("app/main/admin.environment/components/config-single-type/config-single-type.component.html","<div flex layout=\"row\" layout-fill class=\"pl-10\" ng-init=\"vm.init()\" ng-if=\"vm.isInConfig()\"><div flex layout=\"column\" \nlayout-fill><span flex=\"30\" class=\"text-bold\" layout=\"row\">{{vm.key}} </span><span flex=\"30\" layout=\"row\" \nng-if=\"vm.isInConfig() && vm.showDefaultValue\"><span translate=\"APP.DEFAULT\"></span> <span class=\"text-italic\">\n: {{vm.defaultValue}}</span> </span><span translate=\"{{vm.translation}}\"></span></div><div flex layout=\"row\" \nng-switch=\"vm.type\" layout-align=\"start start\"><md-input-container flex class=\"m-0 p-0\" ng-switch-when=\"4\"><md-switch \nclass=\"m-0 p-0\" ng-disabled=\"!vm.isInConfig()\" ng-model=\"vm.value.value\" ng-change=\"vm.updateConfig()\"></md-switch>\n</md-input-container><md-input-container flex class=\"m-0 p-0\" ng-switch-default><input class=\"m-0 p-0\" type=\"number\" \nng-disabled=\"!vm.isInConfig()\" ng-model=\"vm.value.value\" ng-change=\"vm.updateConfig()\"></md-input-container>\n<md-input-container flex class=\"m-0 p-0\" ng-switch-when=\"2\"><input class=\"m-0 p-0\" type=\"text\" \nng-disabled=\"!vm.isInConfig()\" ng-model=\"vm.value.value\" ng-change=\"vm.updateConfig()\"></md-input-container></div>\n</div>");
$templateCache.put("app/main/admin.environment/dialogs/orders.edit-status/orders.edit-status.html","<md-dialog aria-label=\"New Status\"><form name=\"statusForm\" ng-submit=\"vm.submit()\" novalidate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" ng-if=\"!vm.newStatus\" translate=\"APP.EDIT\">Edit</span> <span class=\"title\" ng-if=\"vm.newStatus\" \ntranslate=\"ORDERS.ADD_STATUS\">Neues Feld</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"space-between stretch\"><div layout=\"column\"><div layout=\"row\"><md-input-container flex=\"85\" class=\"mb-0\">\n<label translate=\"APP.NAME\">Bezeichnung</label><input type=\"text\" name=\"name\" \nng-model=\"vm.status.name[vm.currentLanguage]\" md-maxlength=\"100\" required><div ng-messages=\"statusForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div>\n</md-input-container><md-input-container flex=\"15\" class=\"mb-0\"><label translate=\"APP.LANGUAGE\">Lang</label><md-select \nng-model=\"vm.currentLanguage\"><md-option ng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span \nclass=\"text-uppercase\">{{lang}}</span></md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"85\"><label translate=\"ORDERS.STATUS_TRANSITION\">Übergang</label><input type=\"text\" \nname=\"name\" ng-model=\"vm.status.transitionText[vm.currentLanguage]\" ng-required=\"vm.status.type !== \'archive\'\" \nng-disabled=\"vm.status.type === \'archive\'\" md-maxlength=\"100\"><div ng-messages=\"statusForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container></div>\n<div layout=\"row\"><md-input-container flex><label translate=\"ORDER.STATUS_ID\">ID</label><input type=\"text\" name=\"id\" \nng-model=\"vm.status.id\"></md-input-container><md-input-container flex flex-offset=\"5\"><label \ntranslate=\"ORDER.STATUS_TRANSITION_TO\">ID</label><input type=\"text\" name=\"transition\" \nng-model=\"vm.status.transitionTo\" ng-disabled=\"vm.status.type === \'archive\'\"></md-input-container><md-input-container \nflex flex-offset=\"5\"><label translate=\"ORDER.MAPPED_PROD_STATUS\">ID</label><input type=\"number\" name=\"transition\" \nng-model=\"vm.status.productionRef\" ng-disabled=\"vm.status.type === \'archive\'\"></md-input-container></div><div \nlayout=\"row\"><md-icon md-font-icon=\"{{vm.status.icon}}\" ng-class=\"vm.status.color\" class=\"s32 md-avatar\"></md-icon>\n<md-input-container flex=\"50\"><label translate=\"APP.ICON\">Icon</label><input type=\"text\" name=\"id\" \nng-model=\"vm.status.icon\" md-maxlength=\"50\" required><div ng-messages=\"statusForm.id.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container>\n<md-input-container flex-offset=\"10\" flex=\"50\"><label translate=\"APP.COLOR\">Color</label><input type=\"text\" \nname=\"color\" ng-model=\"vm.status.color\" md-maxlength=\"30\" required></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label translate=\"ORDER.STATUS_TYPE\">Type</label><md-select ng-model=\"vm.status.type\" \ntranslate-attr-placeholder=\"ORDER.STATUS_TYPE\" flex=\"50\" required><md-option ng-value=\"\'default\'\">Standard</md-option>\n<md-option ng-value=\"\'production\'\">Produktion</md-option><md-option ng-value=\"\'archive\'\">Archiv</md-option><md-option \nng-value=\"\'proposal\'\">Angebot</md-option></md-select></md-input-container></div></div><div \nclass=\"ml-24 pl-24 border-left\" layout=\"column\" style=\"min-width:200px\"><md-input-container class=\"mb-8\"><label \ntranslate=\"ORDER.STATUS_DOCUMENTS\">Documents</label><md-select ng-model=\"vm.status.documents\" \nng-model-options=\"{trackBy: \'$value.id\' }\" multiple=\"multiple\"><md-option \nng-repeat=\"document in vm.documents track by document.id\" ng-value=\"{ id: document.id }\">\n{{ document.name | nuitTranslate }}</md-option></md-select></md-input-container><span class=\"border-top\" \nng-repeat=\"document in vm.status.documents\">{{ vm.getDocumentById(document.id).name | nuitTranslate }}</span></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\"><md-button class=\"md-warn\" type=\"reset\" ng-click=\"vm.cancel()\">\n<span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"statusForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/admin.environment/dialogs/test.request/test.request.html","<md-dialog style=\"height:95vh; width:40vw; min-width:600px\"><form name=\"vm.form\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"MAINTENANCE.TEST_URL\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-0\"><div layout=\"column\" \nlayout-margin><label>Use Fetch with targetAddressSpace: \"local\" <input type=\"checkbox\" ng-model=\"vm.useFetch\"></label>\n<md-input-container><input type=\"text\" ng-model=\"vm.testUrl\"></md-input-container><label>Response/Error</label>\n<textarea style=\"min-height: 300px\">\n					{{vm.response}}\n				</textarea></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\" ng-if=\"!vm.inProgress\"><div layout=\"row\"><md-button class=\"md-raised\" \nng-click=\"vm.cancel()\" type=\"reset\"><span translate=\"APP.CANCEL\"></span></md-button><md-button class=\"md-raised\" \nng-click=\"vm.submit()\"><span>Send</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin.notifications/dialogs/edit-template/edit-template.html","<md-dialog><md-content><form name=\"vm.form\" novalidate ng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\"><div \nlayout=\"column\" layout-padding class=\"mt-10\"><md-input-container flex class=\"m-10\"><label translate=\"APP.NAME\"></label>\n<input name=\"vm.template.name\" type=\"text\" ng-model=\"vm.template.name\" required></md-input-container>\n<md-input-container flex class=\"m-10\"><label translate=\"NOTIFICATIONS.TEMPLATE_SCHEMA\"></label><md-select \nng-model=\"vm.template.schema\" ng-change=\"vm.clearParent()\" required><md-option ng-repeat=\"schema in vm.schemas\" \nng-value=\"schema\"><span>{{ schema }}</span></md-option></md-select></md-input-container><md-input-container flex \nclass=\"m-10\" ng-if=\"vm.globalTemplates.length>0\"><label translate=\"NOTIFICATIONS.PARENT_TEMPLATE\"></label><md-select \nng-model=\"vm.template.parent\" required><md-option ng-value=\"0\" translate=\"NOTIFICATIONS.NO_PARENT\"></md-option>\n<md-option ng-repeat=\"template in vm.globalTemplates\" ng-value=\"template.id\" \nng-if=\"vm.template.schema===template.schema\"><span>{{ template.name }}</span></md-option></md-select>\n</md-input-container></div></form></md-content><md-dialog-actions><div layout=\"row\" layout-margin \nlayout-align=\"space-between start\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save\n</md-button><md-button class=\"md-raised\" ng-click=\"vm.cancel()\" translate=\"APP.CANCEL\">Cancel</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.environment/views/tabs/configuration.html","<div layout-fill flex layout=\"column\" ng-if=\"!showEditor\"><md-content ms-scroll class=\"m-24 md-whiteframe-1dp p-16\">\n<div layout=\"row\" layout-align=\"space-between center\"><md-switch ng-model=\"showEditor\"><label \ntranslate=\"APP.JSON_EDITOR\" flex=\"50\"></label></md-switch><md-button class=\"md-raised\" flex=\"50\" translate=\"APP.ADD\" \nflex layout-fill ng-click=\"vm.showConfigAddDialog()\">Hinzufügen</md-button></div><div ng-show=\"showEditor\" \nng-jsoneditor ng-model=\"vm.config\" options=\"vm.jsonOptions\"></div><md-list class=\"md-dense\" \nng-if=\"vm.currentTab === 9\" ng-show=\"!showEditor\"><md-list-item ng-click=\"null\" class=\"md-2-line\" \nng-repeat=\"config in vm.sanitizedConfig\"><div class=\"md-list-item-text\"><h3>{{ config.key }}</h3><div \nng-switch=\"config.type\"><p ng-switch-when=\"1\">Integer</p><p ng-switch-when=\"2\">String</p><p ng-switch-when=\"3\">JSON</p>\n<p ng-switch-when=\"4\">Boolean</p><p ng-switch-when=\"5\">Float</p><p ng-switch-default>Unknown</p></div></div><div \nng-switch=\"config.type\" class=\"md-secondary m-0\"><md-input-container ng-switch-when=\"4\"><md-switch \nng-model=\"config.parent.value\" ng-disabled=\"true\"></md-switch></md-input-container><md-input-container \nng-switch-default><input type=\"text\" ng-model=\"config.parent.value\" ng-disabled=\"true\"></md-input-container></div>\n<md-icon class=\"md-secondary\" ng-click=\"vm.deleteConfig(config.key)\" aria-label=\"Delete\" md-font-icon=\"icon-close\">\n</md-icon></md-list-item></md-list></md-content></div>");
$templateCache.put("app/main/admin.environment/views/tabs/css.html","<md-content ms-scroll class=\"m-24 md-whiteframe-1dp p-16\"><div layout=\"column\" flex layout-margin><span>Style (CSS)\n</span><textarea ng-model=\"vm.css\" style=\"min-height:400px\" flex></textarea></div></md-content>");
$templateCache.put("app/main/admin.environment/views/tabs/general.html","<div layout-fill flex layout=\"column\"><md-content ms-scroll class=\"m-24 md-whiteframe-1dp p-16\"><div class=\"content\" \nms-scroll layout=\"row\"><div layout=\"column\" flex=\"20\"><h4 translate=\"ENVIRONMENT.UNITS_PRESSURE\">Druck</h4><div \nclass=\"ml-20\"><md-checkbox class=\"md-primary\" ng-model=\"vm.config.units.pressure.isVolume.value\"><span \ntranslate=\"APP.UNIT_THICKNESS_VOLUME\"></span></md-checkbox></div></div><div layout=\"column\" flex=\"20\"><h4 \ntranslate=\"ENVIRONMENT.DEFAULT_LENGTHS\">Standardlängen</h4><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"PROFILE.DEFAULT_LENGTH\">Profile Default Length</label><md-icon md-font-icon=\"icon-ruler\" class=\"name\">\n</md-icon><input type=\"number\" aria-label=\"\" ng-model=\"vm.config.defaults.profile.length.value\" \nnuit-unit-input=\"length\"></md-input-container><md-input-container class=\"md-block mb-0 mt-0\"><label \ntranslate=\"PROFILE.DEFAULT_HEM_LENGTH\">Default Hem Length</label><md-icon md-font-icon=\"icon-ruler\" class=\"name\">\n</md-icon><input type=\"number\" aria-label=\"\" ng-model=\"vm.config.defaults.profile.hem.length.default.value\" \nnuit-unit-input=\"length\"></md-input-container><md-input-container class=\"md-block mt-0\"><label \ntranslate=\"PROFILE.DEFAULT_SEGMENT_LENGTH\">Default Segment Length</label><md-icon md-font-icon=\"icon-ruler\" \nclass=\"name\"></md-icon><input type=\"number\" aria-label=\"\" ng-model=\"vm.config.defaults.length.value\" \nnuit-unit-input=\"length\"></md-input-container></div><div layout=\"column\" flex=\"20\"><h4 \ntranslate=\"ENVIRONMENT.UNITS_MATERIALPRICE\">Materialpreis</h4><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"UNIT.MATERIALPRICE\">Materialpreis</label><md-icon md-font-icon=\"icon-weight\" class=\"name\"></md-icon><input \ntype=\"text\" aria-label=\"\" ng-model=\"vm.config.units.materialprice.symbol.value\" maxlength=\"12\"></md-input-container>\n<md-input-container class=\"md-block mb-0 mt-0\" flex=\"20\"><label translate=\"UNIT.MATERIALPRICE.FACTOR\">Faktor</label>\n<md-icon md-font-icon=\"icon-weight\" class=\"name\"></md-icon><input type=\"number\" aria-label=\"\" step=\"0.00001\" \nng-model=\"vm.config.units.materialprice.factor.value\"></md-input-container><md-input-container class=\"md-block mt-0\" \nflex=\"20\"><label translate=\"UNIT.MATERIALPRICE.PRECISION\">Präzision</label><md-icon md-font-icon=\"icon-weight\" \nclass=\"name\"></md-icon><input type=\"number\" aria-label=\"\" ng-model=\"vm.config.units.materialprice.decimals.value\">\n</md-input-container></div><div layout=\"column\" flex=\"20\"><h4 translate=\"ENVIRONMENT.LIMITS\">Begrenzungen</h4>\n<md-input-container class=\"md-block mb-0\"><label translate=\"SEGMENTS.MIN_LENGTH\">Min. Segment-Länge</label><md-icon \nmd-font-icon=\"icon-ruler\" class=\"name\"></md-icon><input type=\"number\" aria-label=\"\" \nng-model=\"vm.config.evo.editor.segments.lengthMin.value\" nuit-unit-input=\"length\"></md-input-container></div></div><h3 \ntranslate=\"ORDERS.ORDERS_NAV\">Orders</h3><div layout=\"row\" layout-wrap><div class=\"content\" ms-scroll layout=\"column\">\n<span translate=\"ORDERS.QUEUE\">Queue</span><div layout=\"row\"><md-button class=\"md-primary md-raised mt-16\" \nng-click=\"vm.addOrderStatus()\" translate=\"ORDERS.ADD_STATUS\"></md-button><md-button class=\"md-primary md-raised mt-16\" \nng-click=\"vm.setDefaultOrderQueue()\" translate=\"ORDERS.SET_DEFAULT_ORDER_QUEUE\"></md-button><md-button \nclass=\"md-primary md-raised mt-16\" ng-click=\"vm.setDefaultProductionOrderQueue()\" \ntranslate=\"ORDERS.SET_DEFAULT_PRODUCTION_ORDER_QUEUE\"></md-button></div><div class=\"content\" ms-scroll layout=\"column\" \nlayout-align=\"start start\" ng-if=\"vm.orderQueue.length > 0\"><md-list><md-list-item \nng-class=\"{\'green-100-bg\': status.type === \'production\', \'orange-100-bg\':status.type === \'archive\'}\" ng-click=\"null\" \nng-repeat=\"status in vm.orderQueue track by $index\"><md-icon md-font-icon=\"{{status.icon}}\" ng-class=\"status.color\" \nclass=\"s32 md-avatar\"></md-icon><p class=\"text-uppercase mr-24 pr-24\">{{ status.name | nuitTranslate }}</p><p \nclass=\"text-uppercase\">{{ status.transition | nuitTranslate }}</p><md-button class=\"md-secondary md-icon-button\" \nng-disabled=\"$first\" ng-click=\"vm.moveOrderStatusUp($index)\" aria-label=\"moveup\"><md-icon md-font-icon=\"icon-arrow-up\">\n</md-icon></md-button><md-button class=\"md-secondary md-icon-button\" ng-disabled=\"$last\" \nng-click=\"vm.moveOrderStatusDown($index)\" aria-label=\"movedown\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon>\n</md-button><md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.editOrderStatus($index)\" aria-label=\"edit\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.deleteOrderStatus(status)\" aria-label=\"delete\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-list-item></md-list></div></div><div layout=\"column\" class=\"ml-15\"><span translate=\"ORDERS.DELETER\">Deleter</span>\n<md-input-container class=\"md-block mv-10 mt-15\"><label translate=\"ORDER.STATUS\">Status</label><md-icon \nmd-font-icon=\"icon-view-dashboard\" class=\"name\"></md-icon><md-select ng-model=\"vm.deleter.status\" \nng-disabled=\"vm.hasDeleter()\"><md-option ng-repeat=\"status in vm.orderQueue track by $index\" \nng-model-options=\"{\'trackBy\':\'$value\'}\" ng-value=\"status.id\"><span class=\"text-uppercase\">\n{{ status.name | nuitTranslate }}</span></md-option></md-select></md-input-container><md-input-container \nclass=\"md-block mv-10\"><label translate=\"TIME.DAYS\"></label><md-icon md-font-icon=\"icon-clock\" class=\"name\"></md-icon>\n<input type=\"number\" aria-label=\"\" min=\"1\" max=\"10950\" ng-model=\"vm.deleter.days\" ng-disabled=\"vm.hasDeleter()\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"vm.updateDeleter()\" ng-if=\"!vm.hasDeleter()\"><span \ntranslate=\"APP.SAVE\"></span></md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.removeDeleter()\" \nng-if=\"vm.hasDeleter()\"><span translate=\"APP.DELETE\"></span></md-button></div></div></md-content></div>");
$templateCache.put("app/main/admin.environment/views/tabs/maintenance.html","<div layout-fill flex layout=\"row\"><md-content ms-scroll class=\"m-24 md-whiteframe-1dp p-16\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.copyEnvFolders()\"><label translate=\"MAINTENANCE.COPY_ENV_FOLDERS\">\nCopy Env Folders</label></md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.recreateProfileImages()\" \nng-disabled=\"vm.recreationInProgress\"><label translate=\"MAINTENANCE.RECREATE_PROFILE_IMAGES\">Recreate profile images\n</label></md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.logTestError()\"><label \ntranslate=\"MAINTENANCE.TEST_ERROR\"></label></md-button><md-button class=\"md-accent md-raised\" \nng-click=\"vm.logTestMessage()\"><label translate=\"MAINTENANCE.TEST_MESSAGE\"></label></md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.openEvoVersion()\"><label translate=\"MAINTENANCE.EVO_VERSION\"></label>\n</md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.downloadUserCount()\"><label \ntranslate=\"MAINTENANCE.USER_COUNT\"></label></md-button><md-button class=\"md-accent md-raised\" \nng-click=\"vm.openTestRequest()\"><label translate=\"MAINTENANCE.TEST_REQUEST\"></label></md-button></md-content></div>");
$templateCache.put("app/main/admin.environment/views/tabs/modules.html","<md-content class=\"m-24 md-whiteframe-1dp p-16\"><div layout=\"row\" layout-margin layout-wrap><div layout=\"column\" \nclass=\"md-whiteframe-z1\" ng-repeat=\"moduleKey in vm.getGroups()\" flex-order=\"{{vm.getGroupIndex(moduleKey)}}\" \nlayout-padding layout-margin ng-if=\"vm.moduleGroups[moduleKey].length>0\"><strong \ntranslate=\"{{vm.getGroupHeader(moduleKey)}}\"></strong><md-switch ng-repeat=\"module in vm.moduleGroups[moduleKey]\" \nng-model=\"vm.config[module.moduleType][module.moduleName].enabled.value\" ng-click=\"vm.onChange(module)\"><span \ntranslate=\"{{module.name }}\"></span></md-switch></div></div></md-content>");
$templateCache.put("app/main/admin.environment/views/tabs/theme.html","<div layout-fill flex layout=\"column\"><md-content ms-scroll class=\"m-24 md-whiteframe-1dp p-16\" layout=\"row\"><div \nlayout=\"column\" layout-fill layout-padding flex=\"30\" \nng-repeat=\"theme in vm.config.themePalettes.value track by theme.name\"><h2>{{::theme.name}}</h2><div \nstyle=\"background-color: {{ option }}\" layout=\"row\" ng-repeat=\"(key, option) in theme.options\"><span>{{ ::key }}</span>\n &nbsp; <span flex-offset=\"30\"><input type=\"text\" ng-model=\"theme.options[key]\"></span></div></div><div \nlayout=\"column\" layout-padding flex-offset=\"5\" flex=\"30\"><h2 translate=\"THEME.SETTINGS\">Theme-Einstellungen</h2>\n<md-input-container class=\"mt-10 mb-10\"><label translate=\"THEME.PRIMARY\">Primary</label><md-select \nng-model=\"vm.config.themeConstants.primary.name.value\"><md-option ng-repeat=\"color in vm.themecolors\" \nng-value=\"color.value\"><span translate=\"{{::color.value}}\"></span></md-option></md-select></md-input-container>\n<md-input-container class=\"mt-10 mb-10\"><label translate=\"THEME.ACCENT\">Accent</label><md-select \nng-model=\"vm.config.themeConstants.accent.name.value\"><md-option ng-repeat=\"color in vm.themecolors\" \nng-value=\"color.value\"><span translate=\"{{::color.value}}\"></span></md-option></md-select></md-input-container>\n<md-input-container class=\"mt-10 mb-10\"><label translate=\"THEME.WARN\">Warn</label><md-select \nng-model=\"vm.config.themeConstants.warn.name.value\"><md-option ng-repeat=\"color in vm.themecolors\" \nng-value=\"color.value\"><span translate=\"{{::color.value}}\"></span></md-option></md-select></md-input-container>\n<md-input-container class=\"mt-10 mb-10\"><label translate=\"THEME.BACKGROUND\">Background</label><md-select \nng-model=\"vm.config.themeConstants.background.name.value\"><md-option ng-repeat=\"color in vm.themecolors\" \nng-value=\"color.value\"><span translate=\"{{::color.value}}\"></span></md-option></md-select></md-input-container></div>\n</md-content></div>");
$templateCache.put("app/main/admin.operations/views/config/config.html","");
$templateCache.put("app/main/admin.notifications/dialogs/edit-additional/edit-additional.html","<md-dialog><md-content><form name=\"vm.form\" novalidate ng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\"><div \nlayout=\"column\" layout-padding><div layout=\"row\"><md-input-container><label translate=\"NOTIFICATIONS.CHANNEL\"></label>\n<md-select ng-model=\"vm.additional.channelId\" required><md-option ng-value=\"channel.id\" \nng-repeat=\"channel in vm.channels\">{{channel.name}}</md-option></md-select></md-input-container><md-input-container \nflex><label translate=\"APP.LANGUAGE\"></label><md-select ng-model=\"vm.additional.contactData.lang\" required><md-option \nng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{ lang }}</span></md-option>\n</md-select></md-input-container></div><md-input-container><label translate=\"APP.EMAIL\"></label><input name=\"email\" \ntype=\"text\" ng-model=\"vm.additional.contactData.email\" required></md-input-container><md-input-container><label \ntranslate=\"APP.PHONE\"></label><input name=\"phone\" type=\"text\" ng-model=\"vm.additional.contactData.phone\" required>\n</md-input-container></div></form></md-content><md-dialog-actions><div layout=\"row\" layout-margin \nlayout-align=\"space-between start\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save\n</md-button><md-button class=\"md-raised\" ng-click=\"vm.cancel()\" translate=\"APP.CANCEL\">Cancel</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.setup/dialogs/add-setup/add-setup.html","<md-dialog><form name=\"setupForm\" ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"SETUP.ADD\">Setup hinzufügen</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"position:relative;min-width:500px\"><div class=\"md-dialog-content\"><div layout=\"column\" layout-margin><div \nlayout=\"row\"><md-input-container flex=\"75\"><label translate=\"TEMPLATE.NAME\">Name</label><input type=\"text\" \nng-model=\"vm.template.name[vm.currentLanguage]\" required></md-input-container><md-input-container flex=\"25\"><label \ntranslate=\"APP.LANGUAGE\">Lang</label><md-select ng-model=\"vm.currentLanguage\" \nng-change=\"vm.onLanguageSelect(vm.currentLanguage)\"><md-option ng-repeat=\"lang in vm.languages\" \nng-value=\"lang.value.code\"><div layout=\"row\" layout-align=\"start center\"><img class=\"flag mr-10\" \nng-src=\"{{ lang.value.flag }}\"> <span class=\"text-uppercase\">{{ lang.value.code }}</span></div></md-option><md-option \nng-value=\"\'$\'\"><md-icon class=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" \ntranslate=\"SETUP.ADD_LANGUAGE\"></span></md-option></md-select></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\"><span \ntranslate=\"APP.CANCEL\">Abbrechen</span></md-button><md-button ng-click=\"vm.create()\" ng-disabled=\"setupForm.$invalid\" \nclass=\"md-warn md-raised\"><span translate=\"APP.CREATE\">Erstellen</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/admin.setup/dialogs/edit-category/edit-category.html","<md-dialog><form name=\"categoryForm\" ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"SETUP.ADD_CATEGORY\" ng-if=\"vm.isNew\">Kategorie hinzufügen</h2><h2 flex translate=\"SETUP.EDIT_CATEGORY\" \nng-if=\"!vm.isNew\">Kategorie bearbeiten</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"position:relative;min-width:500px\"><div class=\"md-dialog-content\"><div layout=\"column\" layout-margin><div \nlayout=\"row\"><md-input-container flex=\"75\"><label translate=\"CATEGORY.NAME\">Name</label><input type=\"text\" \nng-model=\"vm.category.name[vm.currentLanguage]\" required></md-input-container><md-input-container flex=\"25\"><label \ntranslate=\"APP.LANGUAGE\">Lang</label><md-select ng-model=\"vm.currentLanguage\" \nng-change=\"vm.onLanguageSelect(vm.currentLanguage)\"><md-option ng-repeat=\"lang in vm.languages\" \nng-value=\"lang.value.code\"><div layout=\"row\" layout-align=\"start center\"><img class=\"flag mr-10\" \nng-src=\"{{ lang.value.flag }}\"> <span class=\"text-uppercase\">{{ lang.value.code }}</span></div></md-option><md-option \nng-value=\"\'$\'\"><md-icon class=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" \ntranslate=\"SETUP.ADD_LANGUAGE\"></span></md-option></md-select></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\"><span \ntranslate=\"APP.CANCEL\">Abbrechen</span></md-button><md-button ng-click=\"vm.create()\" \nng-disabled=\"categoryForm.$invalid\" class=\"md-warn md-raised\"><span translate=\"APP.SAVE\">Speichern</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin.setup/dialogs/add-language/add-language.html","<md-dialog><form name=\"languageForm\" ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"SETUP.ADD_LANGUAGE\">Sprache hinzufügen</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"position:relative;min-width:500px\"><div class=\"md-dialog-content\"><div layout=\"column\" layout-margin>\n<md-input-container><label translate=\"LANGUAGE.SHORT\">Sprachkürzel</label><input type=\"text\" \nng-model=\"vm.language.code\" ng-change=\"vm.onLanguageChange()\" maxlength=\"2\" required></md-input-container>\n<md-input-container><label translate=\"LANGUAGE.TRANSLATION\">Translation</label><input type=\"text\" \nng-model=\"vm.language.translation\" ng-disabled=\"true\" required></md-input-container><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex><label translate=\"LANGUAGE.FLAG\">Flagge</label><input type=\"text\" \nng-model=\"vm.language.flag\" ng-disabled=\"true\" required></md-input-container><img class=\"flag\" \nng-src=\"{{ vm.language.flag }}\"></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.create()\" ng-disabled=\"languageForm.$invalid\" \nclass=\"md-warn md-raised\"><span translate=\"APP.CREATE\">Erstellen</span></md-button><md-button ng-click=\"vm.cancel()\">\n<span translate=\"APP.CANCEL\">Abbrechen</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin.setup/dialogs/edit-definitions/edit-definitions.html","<md-dialog><form name=\"formatForm\" ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"SETUP.MANAGE_DEFINITIONS\">Definitionen verwalten</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll style=\"position:relative;min-width:80vw;min-height: 600px\"><div class=\"md-dialog-content\" \nstyle=\"min-height:100%\"><md-tabs layout-fill md-dynamic-height md-selected=\"vm.selectedTab\"><md-tab \nng-repeat=\"(key, definition) in vm.definitions track by key\" label=\"{{ key }}\" md-on-select=\"vm.currentTab = key\" \nmd-on-deselect=\"vm.previousTab = key\" md-active=\"vm.currentTab === key\"><div layout=\"column\" \nng-if=\"vm.currentTab === key || vm.previousTab === key\" ng-cloak><md-list><md-list-item \nng-repeat=\"value in definition track by value.id\" ng-click=\"vm.selectDefinition(key, value)\"><p>\n{{ vm.toListEntry(value.value) }}</p><md-icon class=\"md-secondary\" ng-click=\"vm.deleteDefinition(key, value)\" \nmd-font-icon=\"icon-close\"></md-icon></md-list-item></md-list><div layout=\"row\" layout-align=\"start start\">\n<md-input-container flex><label translate=\"APP.JSON\">JSON</label><textarea ng-model=\"vm.compose[key]\"></textarea>\n</md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"vm.addDefinition(key, vm.compose[key])\"><span \ntranslate=\"APP.ADD\">Hinzufügen</span></md-button></div></div></md-tab></md-tabs></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\"><span \ntranslate=\"APP.CLOSE\">Schließen</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin.setup/dialogs/edit-format/edit-format.html","<md-dialog><form name=\"formatForm\" ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"SETUP.ADD_FORMAT\" ng-if=\"vm.isNew\">Format hinzufügen</h2><h2 flex translate=\"SETUP.EDIT_FORMAT\" \nng-if=\"!vm.isNew\">Format bearbeiten</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"position:relative;min-width:500px\"><div class=\"md-dialog-content\"><div layout=\"column\" layout-margin>\n<md-input-container><label translate=\"FORMAT.FORMAT\">Format</label><input type=\"text\" ng-model=\"vm.format.value\" \nrequired></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.create()\" ng-disabled=\"formatForm.$invalid\" \nclass=\"md-warn md-raised\"><span translate=\"APP.CREATE\">Erstellen</span></md-button><md-button ng-click=\"vm.cancel()\">\n<span translate=\"APP.CANCEL\">Abbrechen</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin.setup/dialogs/edit-unit/edit-unit.html","<md-dialog><form name=\"unitForm\" ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"SETUP.ADD_UNIT\" ng-if=\"vm.isNew\">Einheit hinzufügen</h2><h2 flex translate=\"SETUP.EDIT_UNIT\" \nng-if=\"!vm.isNew\">Einheit bearbeiten</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"position:relative;min-width:500px\"><div class=\"md-dialog-content\"><div layout=\"column\" layout-margin>\n<md-input-container><label translate=\"UNIT.SYMBOL\">Symbol</label><input type=\"text\" ng-model=\"vm.unit.symbol.value\" \nrequired></md-input-container><md-input-container><label translate=\"UNIT.FACTOR\">Factor</label><input type=\"number\" \nng-model=\"vm.unit.factor.value\" required></md-input-container><md-input-container><label translate=\"UNIT.DECIMALS\">\nDecimals</label><input type=\"number\" ng-model=\"vm.unit.decimals.value\" required></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.create()\" \nng-disabled=\"unitForm.$invalid\" class=\"md-warn md-raised\"><span translate=\"APP.CREATE\">Erstellen</span></md-button>\n<md-button ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Abbrechen</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/admin.setup/views/config/config.html","");
$templateCache.put("app/main/admin.setup/views/partials/config-search.html","<div style=\"margin: 8px; height:40px\" class=\"search-wrapper md-whiteframe-2dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.updateSearch()\" \nng-model-options=\"{debounce:1000}\"></div></div>");
$templateCache.put("app/main/admin.setup/views/partials/design.html","<md-content><div layout-padding layout-margin layout=\"column\" class=\"md-whiteframe-1dp\"><div layout=\"row\"><div \nlayout=\"column\" layout-padding ng-repeat=\"theme in vm.config.themePalettes.value track by theme.name\"><h2>\n{{ ::theme.name }}</h2><div style=\"background-color: {{ option}}\" layout=\"row\" \nng-repeat=\"(key, option) in theme.options\"><span>{{ ::key}}</span> &nbsp; <span><input type=\"text\" \nng-model=\"theme.options[key]\"></span></div></div><div layout=\"column\" layout-margin flex><h2 \ntranslate=\"THEME.SETTINGS\">Theme-Einstellungen</h2><md-input-container class=\"mt-10 mb-10\"><label \ntranslate=\"THEME.PRIMARY\">Primary</label><md-select ng-model=\"vm.config.themeConstants.primary.name.value\"><md-option \nng-repeat=\"color in vm.themecolors\" ng-value=\"color.value\"><span translate=\"{{::color.value}}\"></span></md-option>\n</md-select></md-input-container><md-input-container class=\"mt-10 mb-10\"><label translate=\"THEME.ACCENT\">Accent</label>\n<md-select ng-model=\"vm.config.themeConstants.accent.name.value\"><md-option ng-repeat=\"color in vm.themecolors\" \nng-value=\"color.value\"><span translate=\"{{::color.value}}\"></span></md-option></md-select></md-input-container>\n<md-input-container class=\"mt-10 mb-10\"><label translate=\"THEME.WARN\">Warn</label><md-select \nng-model=\"vm.config.themeConstants.warn.name.value\"><md-option ng-repeat=\"color in vm.themecolors\" \nng-value=\"color.value\"><span translate=\"{{::color.value}}\"></span></md-option></md-select></md-input-container>\n<md-input-container class=\"mt-10 mb-10\"><label translate=\"THEME.BACKGROUND\">Background</label><md-select \nng-model=\"vm.config.themeConstants.background.name.value\"><md-option ng-repeat=\"color in vm.themecolors\" \nng-value=\"color.value\"><span translate=\"{{::color.value}}\"></span></md-option></md-select></md-input-container></div>\n</div><div layout=\"row\" layout-padding layout-margin layout-wrap><div layout=\"column\" flex layout-margin><label \ntranslate=\"SETUP.CSS\"></label><textarea layout-padding class=\"md-whiteframe-1dp\" ng-model=\"vm.template.style.css\" \nstyle=\"min-height:400px;resize: none\" flex></textarea></div></div></div></md-content>");
$templateCache.put("app/main/admin.setup/views/partials/documents.html","");
$templateCache.put("app/main/admin.setup/views/partials/editor.html","<md-content layout-margin><ng-include src=\"\'app/main/admin.setup/views/partials/config-search.html\'\"></ng-include>\n<v-accordion multiple=\"true\" control=\"vm.editor\"><div class=\"md-background-bg md-whiteframe-1dp p-10 mb-24\"><v-pane>\n<v-pane-header><div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-headline pl-10\" \ntranslate=\"SETUP.GENERAL\"></span></div></v-pane-header><v-pane-content><config-editor ng-show=\"!vm.isLoading()\" \nwhole-config=\"vm.config\" default-root=\"editor\" default-name=\"NUIT_EDITOR_SETTINGS\" controller=\"vm\"></config-editor>\n</v-pane-content></v-pane></div><div class=\"md-background-bg md-whiteframe-1dp p-10 mb-24\" \nng-repeat=\"module in vm.modules\" \nng-if=\"module.value.location.startsWith(\'editor\') && vm.config.editor[module.value.enabledProperty].enabled.value === true\">\n<v-pane><v-pane-header><div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-headline pl-10\" \ntranslate=\"{{module.value.name}}\"></span></div></v-pane-header><v-pane-content><ng-include \nng-if=\"module.value.config !== undefined\" src=\"module.value.config\"></ng-include><div \nng-if=\"module.value.config === undefined\">JSON-Editor</div></v-pane-content></v-pane></div><div \nclass=\"md-background-bg md-whiteframe-1dp p-10 mb-24\" \nng-repeat=\"setting in [{key:\'DRAW\',path:\'editor\'},\n			 						{key:\'DRAW_2D\',path:\'editor.nuitDraw2d\'},\n			 						{key:\'DRAW_TOP\',path:\'editor.nuitDrawTop.style\'},\n			 						{key:\'DRAW_STAMPING\',path:\'editor.nuitDrawStamping\'},\n			 						{key:\'DRAW_STAMPING_REWORK\', path: \'editor.nuitDrawStampingRework\'},\n			 						{key:\'DRAW_CUTTING\', path: \'editor.nuitDrawCutting\'},\n			 						{key:\'PROFILE\',path:\'editor.limits\'}]\">\n<v-pane><v-pane-header><div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-headline pl-10\" \ntranslate=\"EDITOR.NUIT_{{setting.key.toUpperCase()}}_SETTINGS\"></span></div></v-pane-header><v-pane-content>\n<config-editor ng-show=\"!vm.isLoading()\" whole-config=\"vm.config\" default-root=\"{{setting.path}}\" \ndefault-name=\"NUIT_{{setting.key.toUpperCase()}}_SETTINGS\" controller=\"vm\"></config-editor></v-pane-content></v-pane>\n</div></v-accordion></md-content>");
$templateCache.put("app/main/admin.setup/views/partials/evo.html","<md-content layout-margin><ng-include src=\"\'app/main/admin.setup/views/partials/config-search.html\'\"></ng-include>\n<v-accordion multiple=\"true\" control=\"vm.evo\"><div class=\"md-background-bg md-whiteframe-1dp p-10 mb-24\"><v-pane>\n<v-pane-header><div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-headline pl-10\" \ntranslate=\"SETUP.GENERAL\"></span></div></v-pane-header><v-pane-content><div class=\"mb-20\"></div><config-single \nng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"inheritRemark\" type=\"4\" \ndefault-value=\"false\" show-default-value=\"true\" to-default-on-delete=\"true\" translation=\"SALES.INHERIT_REMARK\" \nsearch-term=\"vm.searchTerm\"></config-single><div class=\"mb-20\"></div><config-single ng-if=\"vm.shopConfig\" \nconfig=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"profileMerge\" type=\"4\" default-value=\"false\" \nshow-default-value=\"true\" to-default-on-delete=\"false\" translation=\"ORDERS.PROFILE_MERGE\" search-term=\"vm.searchTerm\" \non-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-editor ng-show=\"!vm.isLoading()\" \nwhole-config=\"vm.config\" default-root=\"evo\" default-name=\"EVO_SETTINGS\" controller=\"vm\"></config-editor>\n</v-pane-content></v-pane></div><div class=\"md-background-bg md-whiteframe-1dp p-10 mb-24\" \nng-repeat=\"module in vm.modules\" \nng-if=\"module.value.location.startsWith(\'evo\') && vm.config.evo[module.value.enabledProperty].enabled.value === true\">\n<v-pane><v-pane-header><div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-headline pl-10\" \ntranslate=\"{{module.value.name}}\"></span></div></v-pane-header><v-pane-content><ng-include \nng-if=\"module.value.config !== undefined\" src=\"module.value.config\"></ng-include><div \nng-if=\"module.value.config === undefined\">JSON-Editor</div></v-pane-content></v-pane></div><div \nclass=\"md-background-bg md-whiteframe-1dp p-10 mb-24\" \nng-repeat=\"setting in [\'account\',\'debug\',\'documents\',\'material\',\'toolbar\', \'serviceworker\']\"><v-pane><v-pane-header>\n<div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-headline pl-10\" \ntranslate=\"EVO.{{setting.toUpperCase()}}_SETTINGS\"></span></div></v-pane-header><v-pane-content><config-editor \nng-show=\"!vm.isLoading()\" whole-config=\"vm.config\" default-root=\"evo.{{setting}}\" \ndefault-name=\"EVO_{{setting.toUpperCase()}}_SETTINGS\" controller=\"vm\"></config-editor></v-pane-content></v-pane></div>\n</v-accordion></md-content>");
$templateCache.put("app/main/admin.setup/views/partials/general.html","<div class=\"content\" ms-scroll layout=\"row\" layout-margin layout-wrap><md-input-container class=\"md-block\"><label \ntranslate=\"BROWSER.TITLE\">Browser Title</label><md-icon md-font-icon=\"icon-file-document-box\" class=\"name\"></md-icon>\n<input type=\"text\" aria-label=\"\" ng-model=\"vm.config.evo.title.value\" md-maxlength=\"200\"></md-input-container></div>");
$templateCache.put("app/main/admin.setup/views/partials/ims.html","<md-content layout-margin><ng-include src=\"\'app/main/admin.setup/views/partials/config-search.html\'\"></ng-include>\n<v-accordion multiple=\"true\" control=\"vm.ims\"><div class=\"md-background-bg md-whiteframe-1dp p-10 mb-24\"><v-pane>\n<v-pane-header><div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-headline pl-10\" \ntranslate=\"SETUP.GENERAL\"></span></div></v-pane-header><v-pane-content><config-editor whole-config=\"vm.config\" \ndefault-root=\"ims.routes\" default-name=\"IMS_SETTINGS\" controller=\"vm\"></config-editor><config-editor \nwhole-config=\"vm.config\" default-root=\"documents\" default-name=\"DOCUMENTS_SETTINGS\" controller=\"vm\"></config-editor>\n<config-editor whole-config=\"vm.config\" default-root=\"ims.attachments\" default-name=\"IMS_ATTACHMENT_SETTINGS\" \ncontroller=\"vm\"></config-editor></v-pane-content></v-pane></div><div \nclass=\"md-background-bg md-whiteframe-1dp p-10 mb-24\" ng-repeat=\"module in vm.modules\" \nng-if=\"module.value.location.startsWith(\'ims\') && vm.config.ims[module.value.enabledProperty].enabled.value === true\">\n<v-pane><v-pane-header><div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-headline pl-10\" \ntranslate=\"{{module.value.name}}\"></span></div></v-pane-header><v-pane-content><ng-include \nng-if=\"module.value.config !== undefined\" src=\"module.value.config\"></ng-include><div \nng-if=\"module.value.config === undefined\">JSON-Editor</div></v-pane-content></v-pane></div></v-accordion></md-content>");
$templateCache.put("app/main/admin.setup/views/partials/localization.html","<md-content><div layout=\"row\" layout-padding layout-margin layout-wrap><div layout=\"column\"><h4 \ntranslate=\"SETUP.UNITS\">Einheiten</h4><md-checkbox ng-model=\"vm.config.units.precision.high.value\"><span \ntranslate=\"ENVIRONMENT.UNITS_HIGH_PRECISION\">Hohe Genauigkeit</span></md-checkbox><md-input-container \nclass=\"md-block mb-0\"><label translate=\"ENVIRONMENT.UNITS_LENGTH\">Einheit (Länge)</label><md-icon \nmd-font-icon=\"icon-ruler\" class=\"name\"></md-icon><md-select ng-model=\"vm.config.units.length\" \nng-model-options=\"{trackBy: \'$value.symbol.value+$value.decimals.value+$value.factor.value\'}\"><md-optgroup \nlabel=\"{{ \'APP.UNITS\' | translate }}\"><md-option ng-value=\"length.value\" ng-repeat=\"length in vm.lengths\"><span>\n{{::length.value.symbol.value}}</span>&nbsp;<span class=\"grey-500-fg\">\n(1:{{ ::length.value.factor.value}})&nbsp;[{{ length.value.decimals.value }}&nbsp;<span translate=\"APP.DECIMALS\">\n</span>]</span></md-option><md-button class=\"h-48\" layout-fill ng-click=\"vm.showEditUnitDialog(undefined, \'length\')\">\n<md-icon class=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" \ntranslate=\"SETUP.ADD_LENGTH_UNIT\"></span></md-button></md-optgroup></md-select></md-input-container><md-input-container\n class=\"md-block mb-0\"><label translate=\"ENVIRONMENT.UNITS_MATERIAL_THICKNESS\">Materialdicke</label><md-icon \nmd-font-icon=\"icon-ruler\" class=\"name\"></md-icon><md-select ng-model=\"vm.config.units.thickness\" \nng-model-options=\"{trackBy: \'$value.symbol.value+$value.decimals.value+$value.factor.value\'}\"><md-optgroup \nlabel=\"{{ \'APP.UNITS\' | translate }}\"><md-option ng-value=\"length.value\" ng-repeat=\"length in vm.lengths\"><span>\n{{::length.value.symbol.value}}</span>&nbsp;<span class=\"grey-500-fg\">\n(1:{{ ::length.value.factor.value}})&nbsp;[{{ length.value.decimals.value }}&nbsp;<span translate=\"APP.DECIMALS\">\n</span>]</span></md-option><md-button class=\"h-48\" layout-fill ng-click=\"vm.showEditUnitDialog(undefined, \'length\')\">\n<md-icon class=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" \ntranslate=\"SETUP.ADD_LENGTH_UNIT\"></span></md-button></md-optgroup></md-select></md-input-container><md-input-container\n class=\"md-block mb-0\"><label translate=\"ENVIRONMENT.UNITS_RUNNINGMETER\">Laufmeter</label><md-icon \nmd-font-icon=\"icon-ruler\" class=\"name\"></md-icon><md-select ng-model=\"vm.config.units.runningmeter\" \nng-model-options=\"{trackBy: \'$value.symbol.value+$value.decimals.value+$value.factor.value\'}\"><md-optgroup \nlabel=\"{{ \'APP.UNITS\' | translate }}\"><md-option ng-value=\"length.value\" ng-repeat=\"length in vm.lengths\"><span>\n{{::length.value.symbol.value}}</span>&nbsp;<span class=\"grey-500-fg\">\n(1:{{ ::length.value.factor.value}})&nbsp;[{{ length.value.decimals.value }}&nbsp;<span translate=\"APP.DECIMALS\">\n</span>]</span></md-option><md-button class=\"h-48\" layout-fill ng-click=\"vm.showEditUnitDialog(undefined, \'length\')\">\n<md-icon class=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" \ntranslate=\"SETUP.ADD_LENGTH_UNIT\"></span></md-button></md-optgroup></md-select></md-input-container><md-input-container\n class=\"md-block mb-0\"><label translate=\"ENVIRONMENT.UNITS_PER_LENGTH_UNIT_CONVERSION\">Laufmeter</label><md-icon \nmd-font-icon=\"icon-ruler\" class=\"name\"></md-icon><md-select ng-model=\"vm.config.units.perLengthUnitConversion\" \nng-model-options=\"{trackBy: \'$value.symbol.value+$value.decimals.value+$value.factor.value\'}\"><md-optgroup \nlabel=\"{{ \'APP.UNITS\' | translate }}\"><md-option ng-value=\"length.value\" ng-repeat=\"length in vm.lengths\"><span>\n{{::length.value.symbol.value}}</span>&nbsp;<span class=\"grey-500-fg\">\n(1:{{ ::length.value.factor.value}})&nbsp;[{{ length.value.decimals.value }}&nbsp;<span translate=\"APP.DECIMALS\">\n</span>]</span></md-option><md-button class=\"h-48\" layout-fill ng-click=\"vm.showEditUnitDialog(undefined, \'length\')\">\n<md-icon class=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" \ntranslate=\"SETUP.ADD_LENGTH_UNIT\"></span></md-button></md-optgroup></md-select></md-input-container><md-input-container\n class=\"md-block mb-0\"><label translate=\"ENVIRONMENT.UNITS_AREA\">Fläche</label><md-icon md-font-icon=\"icon-ruler\" \nclass=\"name\"></md-icon><md-select ng-model=\"vm.config.units.area\" \nng-model-options=\"{trackBy: \'$value.symbol.value+$value.decimals.value+$value.factor.value\'}\"><md-optgroup \nlabel=\"{{ \'APP.UNITS\' | translate }}\"><md-option ng-value=\"area.value\" ng-repeat=\"area in vm.areas\"><span>\n{{:: area.value.symbol.value}}</span>&nbsp;<span class=\"grey-500-fg\">\n(1:{{ :: area.value.factor.value}})&nbsp;[{{ area.value.decimals.value }}&nbsp;<span translate=\"APP.DECIMALS\"></span>]\n</span></md-option><md-button class=\"h-48\" layout-fill ng-click=\"vm.showEditUnitDialog(undefined, \'area\')\"><md-icon \nclass=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" translate=\"SETUP.ADD_AREA_UNIT\">\n</span></md-button></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"ENVIRONMENT.UNITS_WEIGHT\">Einheit (Gewicht)</label><md-icon md-font-icon=\"icon-weight\" class=\"name\">\n</md-icon><md-select ng-model=\"vm.config.units.weight\" \nng-model-options=\"{trackBy: \'$value.symbol.value+$value.decimals.value+$value.factor.value\'}\"><md-optgroup \nlabel=\"{{ \'APP.UNITS\' | translate }}\"><md-option ng-value=\"weight.value\" ng-repeat=\"weight in vm.weights\"><span>\n{{weight.value.symbol.value}}</span>&nbsp;<span class=\"grey-500-fg\">\n(1:{{ weight.value.factor.value}})&nbsp;[{{ weight.value.decimals.value }}&nbsp;<span translate=\"APP.DECIMALS\"></span>]\n</span></md-option><md-button class=\"h-48\" layout-fill ng-click=\"vm.showEditUnitDialog(undefined, \'weight\')\"><md-icon \nclass=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" translate=\"SETUP.ADD_WEIGHT_UNIT\">\n</span></md-button></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"ENVIRONMENT.UNITS_PRESSURE\">Einheit (Druck/Materialgewicht)</label><md-icon md-font-icon=\"icon-weight\" \nclass=\"name\"></md-icon><md-select ng-model=\"vm.config.units.pressure\" \nng-model-options=\"{trackBy: \'$value.symbol.value+$value.decimals.value+$value.factor.value\'}\"><md-optgroup \nlabel=\"{{ \'APP.UNITS\' | translate }}\"><md-option ng-value=\"unit.value\" ng-repeat=\"unit in vm.pressures\"><span>\n{{unit.value.symbol.value}}</span>&nbsp;<span class=\"grey-500-fg\">\n(1:{{ unit.value.factor.value}})&nbsp;[{{ unit.value.decimals.value }}&nbsp;<span translate=\"APP.DECIMALS\"></span>]\n</span></md-option><md-button class=\"h-48\" layout-fill ng-click=\"vm.showEditUnitDialog(undefined, \'pressure\')\"><md-icon\n class=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" translate=\"SETUP.ADD_PRESSURE_UNIT\">\n</span></md-button></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"ENVIRONMENT.UNITS_DENSITY\">Einheit (Dichte)</label><md-icon md-font-icon=\"icon-weight\" class=\"name\">\n</md-icon><md-select ng-model=\"vm.config.units.density\" \nng-model-options=\"{trackBy: \'$value.symbol.value+$value.decimals.value+$value.factor.value\'}\"><md-optgroup \nlabel=\"{{ \'APP.UNITS\' | translate }}\"><md-option ng-value=\"unit.value\" ng-repeat=\"unit in vm.densities\"><span>\n{{unit.value.symbol.value}}</span>&nbsp;<span class=\"grey-500-fg\">\n(1:{{ unit.value.factor.value}})&nbsp;[{{ unit.value.decimals.value }}&nbsp;<span translate=\"APP.DECIMALS\"></span>]\n</span></md-option><md-button class=\"h-48\" layout-fill ng-click=\"vm.showEditUnitDialog(undefined, \'density\')\"><md-icon \nclass=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" translate=\"SETUP.ADD_DENSITY_UNIT\">\n</span></md-button></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"ENVIRONMENT.UNITS_DECIMAL_SEPARATOR\">Dezimal-Trennzeichen</label><md-icon \nmd-font-icon=\"icon-format-align-justify\" class=\"name\"></md-icon><input \nng-model=\"vm.config.units.formats.number.decimalSeperator.value\" type=\"text\"></md-input-container><md-input-container \nclass=\"md-block mb-0\"><label translate=\"ENVIRONMENT.UNITS_GROUP_SEPARATOR\">Gruppen-Trennzeichen</label><md-icon \nmd-font-icon=\"icon-format-align-justify\" class=\"name\"></md-icon><input \nng-model=\"vm.config.units.formats.number.groupSeperator.value\" type=\"text\"></md-input-container></div><div \nlayout=\"column\"><h4 translate=\"SETUP.DATETIME\">Datum/Zeit</h4><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"FORMAT.DATE\">Format (Datum)</label><md-icon md-font-icon=\"icon-calendar\" class=\"name\"></md-icon><md-select \nng-model=\"vm.config.localization.dateFormat.value\" ng-model-options=\"{trackBy: \'$value\'}\"><md-optgroup><md-option \nng-value=\"format.value.value\" ng-repeat=\"format in vm.timeformats track by format.id\"><span>{{format.value.value}}\n</span>&nbsp;<span class=\"grey-500-fg\">({{ vm.getDateFormatPreview(format.value.value) }})</span></md-option><md-button\n class=\"h-48\" layout-fill ng-click=\"vm.showEditFormatDialog(undefined, \'timeformat\')\"><md-icon class=\"grey-500-fg\" \nmd-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" translate=\"SETUP.ADD_TIMEFORMAT\"></span></md-button>\n</md-optgroup></md-select></md-input-container><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"FORMAT.DATETIME\">Format (Datettime)</label><md-icon md-font-icon=\"icon-calendar-clock\" class=\"name\">\n</md-icon><md-select ng-model=\"vm.config.localization.dateTimeFormat.value\" ng-model-options=\"{trackBy: \'$value\'}\">\n<md-option ng-value=\"format.value.value\" ng-repeat=\"format in vm.timeformats track by format.id\"><span>\n{{format.value.value}}</span>&nbsp;<span class=\"grey-500-fg\">({{ vm.getDateFormatPreview(format.value.value) }})</span>\n</md-option><md-button class=\"h-48\" layout-fill ng-click=\"vm.showEditFormatDialog(undefined, \'timeformat\')\"><md-icon \nclass=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" translate=\"SETUP.ADD_TIMEFORMAT\">\n</span></md-button></md-select></md-input-container><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"FORMAT.TIME\">Format (Time)</label><md-icon md-font-icon=\"icon-clock\" class=\"name\"></md-icon><md-select \nng-model=\"vm.config.localization.timeFormat.value\" ng-model-options=\"{trackBy: \'$value\'}\"><md-option \nng-value=\"format.value.value\" ng-repeat=\"format in vm.timeformats track by format.id\"><span>{{format.value.value}}\n</span>&nbsp;<span class=\"grey-500-fg\">({{ vm.getDateFormatPreview(format.value.value) }})</span></md-option><md-button\n class=\"h-48\" layout-fill ng-click=\"vm.showEditFormatDialog(undefined, \'timeformat\')\"><md-icon class=\"grey-500-fg\" \nmd-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" translate=\"SETUP.ADD_TIMEFORMAT\"></span></md-button>\n</md-select></md-input-container><h4 translate=\"SETUP.TIMEZONE\">Zeitzone</h4><md-input-container class=\"md-block mb-0\">\n<label translate=\"ENVIRONMENT.TIMEZONE\">Zeitzone</label><md-icon md-font-icon=\"icon-web\" class=\"name\"></md-icon>\n<md-select ng-model=\"vm.config.localization.timeZone.value\" ng-change=\"vm.onTimezoneSelect()\" \nng-model-options=\"{trackBy: \'$value.code\'}\"><md-option ng-value=\"timezone.value\" \nng-repeat=\"timezone in vm.timezones | orderBy:\'value.code\' track by timezone.id\"><span>\n{{timezone.value.name | nuitTranslate}}</span></md-option><md-option ng-value=\"{ code: \'$\' }\"><md-icon \nclass=\"grey-500-fg\" md-font-icon=\"icon-plus\"></md-icon><span class=\"grey-500-fg\" translate=\"SETUP.ADD_TIMEZONE\"></span>\n</md-option></md-select></md-input-container></div><div layout=\"column\"><h4 translate=\"SETUP.LANGUAGE\">Sprache</h4>\n<md-input-container class=\"md-block\"><label>{{\"APP.LANGUAGES\" | translate}}</label><md-icon md-font-icon=\"icon-earth\" \nclass=\"name\"></md-icon><md-select ng-model=\"vm.config.languages.value\" ng-model-options=\"{trackBy: \'$value\'}\" \nmultiple=\"multiple\"><md-optgroup label=\"{{ \'APP.LANGUAGES\' | translate }}\"><md-option ng-value=\"language.value.code\" \nng-repeat=\"language in vm.languages\"><span translate=\"{{language.value.translation}}\"></span></md-option></md-optgroup>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>{{\"SETUP.DEFAULT_LANGUAGE\" | translate}}\n</label><md-icon md-font-icon=\"icon-earth\" class=\"name\"></md-icon><md-select \nng-model=\"vm.config.localization.defaultLanguage.value\" ng-model-options=\"{trackBy: \'$value\'}\"><md-optgroup \nlabel=\"{{ \'APP.LANGUAGES\' | translate }}\"><md-option ng-value=\"language.value.code\" \nng-repeat=\"language in vm.languages\"><span translate=\"{{language.value.translation}}\"></span></md-option></md-optgroup>\n</md-select></md-input-container><h4 translate=\"SETUP.CURRENCY\">Währung</h4><md-input-container class=\"md-block\">\n<label>{{\"APP.UNIT_CURRENCY\" | translate}}</label><md-icon \nmd-font-icon=\"{{vm.config.localization.currency.icon.value}}\" class=\"name\"></md-icon><md-select \nng-model=\"vm.config.localization.currency\" ng-model-options=\"{trackBy: \'$value.symbol.value\'}\"><md-optgroup \nlabel=\"{{ \'APP.CURRENCIES\' | translate }}\"><md-option ng-value=\"currency.value\" \nng-repeat=\"currency in vm.currencies track by currency.id\"><span ng-bind-html=\"currency.value.name.value\"></span>\n</md-option></md-optgroup></md-select></md-input-container><md-checkbox class=\"md-primary\" \nng-model=\"vm.config.localization.currencySymbolInFront.value\"><span translate=\"SETUP.CURRENCY_INFRONT\"></span>\n</md-checkbox><md-checkbox class=\"md-primary\" ng-model=\"vm.config.localization.currencySpaceBetween.value\"><span \ntranslate=\"SETUP.CURRENCY_SPACE\"></span></md-checkbox></div></div></md-content>");
$templateCache.put("app/main/admin.setup/views/partials/meta.html","<md-content><div layout=\"row\" layout-padding layout-margin layout-wrap><div layout=\"column\" flex><div>\n<md-input-container class=\"mb-0\"><label translate=\"SETUP.META_CATEGORY\">Category</label><md-select \nng-model=\"vm.template.meta.category\" ng-model-options=\"{trackBy: \'$value\'}\"><md-option ng-value=\"category.id\" \nng-repeat=\"category in vm.categories track by category.id\"><span>{{ category.value.name | nuitTranslate }}</span>\n</md-option><md-option ng-value=\"\"></md-option></md-select></md-input-container></div><md-input-container \nclass=\"md-block\"><label translate=\"SETUP.META_DESCRIPTION\"></label><textarea ng-model=\"vm.template.meta.description\" \nmd-maxlength=\"300\" rows=\"5\" md-select-on-focus></textarea></md-input-container></div></div></md-content>");
$templateCache.put("app/main/admin.setup/views/partials/modules.html","<md-content><div layout=\"row\" layout-margin layout-wrap><div layout=\"column\" class=\"md-whiteframe-z1\" \nng-repeat=\"moduleKey in vm.getGroups()\" flex-order=\"{{vm.getGroupIndex(moduleKey)}}\" layout-padding layout-margin \nng-if=\"vm.moduleGroups[moduleKey].length>0\"><strong translate=\"{{vm.getGroupHeader(moduleKey)}}\"></strong><md-switch \nng-repeat=\"module in vm.moduleGroups[moduleKey]\" \nng-model=\"vm.config[module.moduleType][module.moduleName].enabled.value\" ng-click=\"vm.onChange(module)\"><span \ntranslate=\"{{module.name }}\"></span></md-switch></div></div></md-content>");
$templateCache.put("app/main/controlling.material/views/config/config.html","");
$templateCache.put("app/main/controlling.sales/views/config/config.html","");
$templateCache.put("app/main/controlling.users/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.controlling.user\" default-name=\"CONTROLLING_USERS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/devices.printer/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.printer\" default-name=\"PRINTER_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/merchandising.materials/dialogs/bending/bending-dialog.html","<md-dialog><form name=\"vm.bendingForm\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools md-accent\" \ntranslate=\"MACHINES.ADD_BENDING_MACHINE\"></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content w-300 h-180\" layout=\"column\" fill><div layout=\"row\" flex ng-if=\"!vm.machinesLoading\">\n<md-input-container flex required><label translate=\"MACHINE.NAME\">Typ</label><md-select \nng-model=\"vm.bending.bendingMachineId\" ng-change=\"vm.reloadMaterials()\" ng-disabled=\"vm.isEdit\" required=\"true\">\n<md-option ng-value=\"machine.id\" ng-repeat=\"machine in vm.availableMachines\">{{machine.name	}}</md-option></md-select>\n</md-input-container><div ng-if=\"vm.machinesLoading\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"16\"></md-progress-circular></div></div><div layout=\"row\" flex><md-input-container \nng-if=\"vm.bending.bendingMachineId!=null && vm.materials.length>0 && !vm.materialsLoading\" flex><label \ntranslate=\"APP.MATERIAL\">Materials</label><md-select ng-model=\"vm.bending.bendingMaterialId\" required=\"true\"><md-option\n ng-value=\"material.bendingMaterialId\" ng-repeat=\"material in vm.materials\">{{material.name}}</md-option></md-select>\n</md-input-container><div ng-if=\"vm.materialsLoading\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"16\"></md-progress-circular></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Abbrechen</span></md-button>\n<md-button ng-click=\"vm.save()\" class=\"md-warn md-raised\" \nng-disabled=\"vm.bendingForm.$invalid || vm.cuttingForm.$pristine || vm.machinesLoading || vm.materialsLoading\"><span \ntranslate=\"APP.SAVE\">Speichern</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/merchandising.materials/dialogs/cutting/cutting-dialog.html","<md-dialog><form name=\"vm.cuttingForm\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \nng-if=\"vm.cutting.id\">{{vm.cutting.name}}</h2><h2 flex translate=\"MATERIAL.ADD_CUTTING\" ng-if=\"!vm.cutting.id\">\nSpalte hinzufügen</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"md-dialog-content w-500\" \nlayout=\"column\"><div layout=\"row\" flex layout-margin><md-input-container flex class=\"no-error-spacer\"><label \ntranslate=\"APP.NAME\">Name</label><input type=\"text\" ng-model=\"vm.cutting.name\" name=\"name\"></md-input-container>\n<md-input-container flex><label translate=\"MATERIALS.CUTTING_TYPE\">Typ</label><md-select ng-model=\"vm.cutting.type\" \nng-change=\"vm.reloadMachines()\" required name=\"type\" ng-disabled=\"vm.cutting.id\"><md-option value=\"coil\" \nselected=\"selected\"><span translate=\"MATERIALS.CUTTING_TYPE_COIL\">Coil</span></md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex layout-margin><md-input-container flex=\"50\" \nng-if=\"!vm.machinesLoading\"><label translate=\"MATERIALS.CUTTING_MACHINE\">Maschine</label><md-select required \nng-model=\"vm.cutting.machineId\" ng-change=\"vm.reloadCoils()\" name=\"machine\"><md-option \nng-repeat=\"machine in vm.coilMachines\" ng-value=\"machine.id\" ng-if=\"vm.isValidMachine(machine.id)\">{{::machine.name}}\n</md-option></md-select></md-input-container><div flex=\"50\" ng-if=\"vm.machinesLoading\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular></div><md-input-container flex=\"50\" \nng-if=\"vm.coils.length > 0 && vm.cutting.type===\'coil\'\"><label translate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL\">\nMaterial</label><md-select required ng-model=\"vm.selectedCoil\" ng-change=\"vm.onCoilChange()\"><md-option \nng-repeat=\"material in vm.coils track by material.id\" ng-value=\"material\">{{::material.name | nuitTranslate}}&nbsp;\n<span ng-if=\"material.strength\">({{::material.strength}})</span></md-option></md-select></md-input-container><div \nflex=\"50\" ng-if=\"vm.materialsLoading\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"16\">\n</md-progress-circular></div></div><div layout=\"row\" flex layout-margin ng-if=\"vm.cutting.type !== undefined\">\n<md-input-container flex=\"50\"><label><span translate=\"MATERIALS.CUTTING_WIDTH\"></span>&nbsp;<span>\n({{ vm.unit(\'length\').symbol }})</span></label><input type=\"number\" ng-model=\"vm.cutting.width\" \nnuit-unit-input=\"length\" name=\"width\" required></md-input-container><md-input-container \nng-if=\"vm.cutting.type ===\'sheet\'\" flex=\"50\"><label><span translate=\"MATERIALS.CUTTING_LENGTH\"></span>&nbsp;<span>\n({{ vm.unit(\'length\').symbol }})</span></label><input type=\"number\" ng-model=\"vm.cutting.length\" \nnuit-unit-input=\"length\" name=\"length\" required></md-input-container></div></div></md-dialog-content><md-dialog-actions\n layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Abbrechen</span>\n</md-button><md-button ng-click=\"vm.save()\" class=\"md-warn md-raised\" \nng-disabled=\"vm.cuttingForm.$invalid || vm.cuttingForm.$pristine\"><span translate=\"APP.SAVE\">Speichern</span>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/merchandising.materials.attributes/dialogs/edit-attribute/edit-attribute.html","<md-dialog aria-label=\"New Color\" id=\"system-color-dialog\"><form name=\"attributeForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-if=\"!vm.newAttribute\" translate=\"APP.EDIT\">Edit</span> <span\n class=\"title\" ng-if=\"vm.newAttribute\" translate=\"PRODUCTS.ADD_ATTRIBUTE\">Neues Attribut</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\"><div layout=\"row\"><md-input-container flex=\"85\"><label \ntranslate=\"APP.NAME\">Bezeichnung</label><input type=\"text\" name=\"name\" \nng-model=\"vm.attribute.name[vm.currentLanguage]\" md-maxlength=\"100\" required><div ng-messages=\"fieldForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div>\n</md-input-container><md-input-container flex=\"15\"><label translate=\"APP.LANGUAGE\">Lang</label><md-select \nng-model=\"vm.currentLanguage\"><md-option ng-repeat=\"lang in vm.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">\n{{lang}}</span></md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\">\n<label translate=\"ATTRIBUTE.TYPE\">Type</label><md-select ng-model=\"vm.attribute.type\" \nng-disabled=\"vm.attribute.id !== undefined\"><md-option ng-value=\"\'string\'\" translate=\"APP.STRING\">Text</md-option>\n<md-option ng-value=\"\'number\'\" translate=\"APP.NUMBER\">Nummer</md-option></md-select></md-input-container></div><div \nlayout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.attribute.restrictions.hidden\" aria-label=\"Hidden\" \nclass=\"md-warn\">{{ \'ATTRIBUTE.HIDDEN\' | translate }}</md-checkbox></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n</div><div layout=\"row\"><md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel\n</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"attributeForm.$invalid\"><span \ntranslate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/merchandising.materials/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.materials\" default-name=\"MATERIALS_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/merchandising.materials/views/partials/general.html","<md-content ms-scroll layout-fill class=\"thread-detail\"><div layout=\"column\" layout-padding class=\"mt-10\"><div \nclass=\"mh-10\" layout=\"row\" layout-wrap><div layout=\"row\" class=\"grey-100-bg m-10 p-10\" \nng-repeat=\"field in vm.config.ims.materials.details.customFields.top\" \nng-if=\"(field.format | nuitFormatter:vm.material).length>0\"><span class=\"mr-10\">{{field.name | nuitTranslate}}</span> \n<span class=\"text-bold\">{{field.format | nuitFormatter:vm.material}}</span></div></div><div layout=\"row\">\n<nuit-favorites favorites=\"vm.favorites\" selected-favorite=\"vm.material.favorite\"></nuit-favorites></div><div \nlayout=\"row\" layout-margin layout-align=\"space-between start\" class=\"mt-0 bt-0\"><div layout=\"row\" flex class=\"pr-40\" \nlayout-align=\"start\"><md-input-container flex><label translate=\"MATERIAL.NAME\">Name</label><input type=\"text\" \nname=\"name\" ng-model=\"vm.material.name[vm.selectedLanguage]\" ng-disabled=\"!vm.material.customData.customName\" \naria-label=\"Material Name\"></md-input-container><md-input-container ng-if=\"vm.config.languages.length > 1\"><label \ntranslate=\"APP.LANG\">Language</label><md-select ng-model=\"vm.selectedLanguage\"><md-option \nng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{ ::lang }}</span></md-option>\n</md-select></md-input-container></div><md-switch ng-model=\"vm.material.customData.customName\" \nng-change=\"vm.updateName()\" name=\"customName\" class=\"mt-24\"><span translate=\"MATERIAL.OVERWRITE\">Overwrite name</span>\n</md-switch></div><div layout=\"row\" layout-align=\"space-between start\"><div layout=\"row\" layout-margin \nlayout-align=\"space-between start\" flex layout-wrap><md-input-container flex=\"45\"><label translate=\"MATERIAL.GROUP\">\nWerkstoff</label><md-select ng-model=\"vm.material.rawMaterialId\" name=\"rawMaterial\" required aria-label=\"Raw Material\" \nng-change=\"vm.updateName()\"><md-option ng-repeat=\"group in vm.groups | orderByNuitTranslated:\'name\'\" \nng-value=\"group.id\">{{group.name | nuitTranslate }}</md-option></md-select><div \nng-messages=\"vm.materialForm.rawMaterial.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"ERRORS.REQUIRED\">\n</div></div></md-input-container><md-input-container flex=\"45\"><label>\n{{ \'MATERIAL.THICKNESS\' | translate }} {{ \'(\' + vm.unit(\'thickness\').symbol + \')\' }}</label><input type=\"number\" \nname=\"thickness\" ng-model=\"vm.material.thickness\" required nuit-unit-input=\"thickness\" min=\"0\" max=\"10000\" \nng-change=\"vm.updateName()\"><div ng-messages=\"vm.materialForm.thickness.$error\" role=\"alert\"><div ng-message=\"min\" \ntranslate=\"ERRORS.TOO_SMALL\"></div><div ng-message=\"max\" translate=\"ERRORS.TOO_BIG\"></div><div ng-message=\"number\" \ntranslate=\"ERRORS.NUMBER_REQUIRED\"></div><div ng-message=\"required\" translate=\"ERRORS.REQUIRED\"></div></div>\n</md-input-container><div flex=\"100\" layout=\"row\" layout-wrap layout-align=\"space-between start\"><md-switch \nng-model=\"vm.material.active\" flex=\"100\" flex-gt-md=\"45\"><span class=\"md-truncate\" translate=\"MATERIAL.ACTIVE_EVO\">\nBestellbar</span></md-switch><md-switch ng-model=\"vm.material.availableInEditor\" flex=\"100\" flex-gt-md=\"45\"><span \nclass=\"md-truncate\" translate=\"MATERIAL.AVAILABLE_IN_EDITOR\">Im Editor verfügbar</span></md-switch></div></div><div \nlayout=\"column\" flex=\"40\"><div layout=\"row\" layout-align=\"start center\" felx><md-input-container flex><label \ntranslate=\"MATERIAL.COLOR_FRONT\"></label><md-select ng-model=\"vm.material.colorFront\" \nmd-on-close=\"vm.clearSearchTerm()\" name=\"colorFront\" ng-change=\" vm.updateName()\"><md-select-header id=\"searchHeader\">\n<md-icon class=\"ml-0 mr-10 pl-0\" md-font-icon=\"icon-magnify\"></md-icon><input id=\"searchFront\" class=\"search\" \nng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"\" ng-keydown=\"$event.stopPropagation()\"></md-select-header>\n<md-optgroup id=\"colorBox\"><md-option ng-value=\"color.id\" ng-repeat=\"color in vm.searchColors(vm.searchTerm) \"><div \nlayout=\"row\" layout-align=\"start center\"><div \nstyle=\"width:20px;height:20px;border-radius:50%;border:1px solid #eaeaea;background-color:{{color.hex}}\"></div><span \nclass=\"pl-16\">{{ color.code}} - {{ color.name | nuitTranslate }}</span></div></md-option></md-optgroup></md-select>\n</md-input-container><div ng-if=\"vm.material.colorFront != undefined\" style=\"cursor: pointer\"><md-icon-button \nng-click=\"vm.resetFrontColor()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-icon-button></div></div><div \nlayout=\"row\" layout-align=\"start center\" flex><md-input-container flex><label translate=\"MATERIAL.COLOR_BACK\"></label>\n<md-select ng-model=\"vm.material.colorBack\" md-on-close=\"vm.clearSearchTerm()\" name=\"colorBack\"><md-select-header \nid=\"searchHeader\"><md-icon class=\"ml-0 mr-10 pl-0\" md-font-icon=\"icon-magnify\"></md-icon><input id=\"searchBack\" \nclass=\"search\" ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-optgroup id=\"colorBox\"><md-option ng-value=\"color.id\" \nng-repeat=\"color in vm.searchColors(vm.searchTerm)\"><div layout=\"row\" layout-align=\"start center\"><div \nstyle=\"width:20px;height:20px;border-radius:50%;border:1px solid #eaeaea;background-color:{{color.hex}}\"></div><span \nclass=\"pl-16\" md-highlight-text=\"vm.backColorText\">{{ color.code}} - {{ color.name | nuitTranslate }}</span></div>\n</md-option></md-optgroup></md-select></md-input-container><div ng-if=\"vm.material.colorBack != undefined\" \nstyle=\"cursor: pointer\"><md-icon-button ng-click=\"vm.resetBackColor()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-icon-button></div></div></div></div><div layout=\"row\" layout-margin><md-input-container flex><label><span \ntranslate=\"MATERIAL.WEIGHT\">Gewicht</span> [{{ vm.config.units.pressure.symbol }}]</label><input type=\"number\" \nname=\"weight\" min=\"0\" max=\"10000\" ng-required=\"vm.config.ims.materials.isWeightRequired\" nuit-unit-input=\"pressure\" \nng-model=\"vm.material.weight\" ng-change=\"vm.updateConvertedPrice()\"><div ng-messages=\"vm.materialForm.weight.$error\" \nrole=\"alert\"><div ng-message=\"min\" translate=\"ERRORS.TOO_SMALL\"></div><div ng-message=\"max\" translate=\"ERRORS.TOO_BIG\">\n</div><div ng-message=\"number\" translate=\"ERRORS.NUMBER_REQUIRED\"></div><div ng-message=\"required\" \ntranslate=\"ERRORS.REQUIRED\"></div></div></md-input-container><md-input-container flex><label \ntranslate=\"MATERIAL.EXTERNAL_ID\">ExternalId</label><input type=\"text\" name=\"externalId\" \nng-model=\"vm.material.externalId\" \nng-disabled=\"({material: vm.material} | nuitConditionCheck:vm.config.ims.materials.details.readOnlyConditions.externalId:true)\">\n</md-input-container></div><div layout=\"row\" layout-margin ng-if=\"vm.config.ims.materials.inventoryControl\">\n<md-input-container class=\"md-block\" flex><label><span translate=\"MATERIAL.STOCK_MIN\">Bestand-Minimum</span> [kg]\n</label><input type=\"text\" ng-model=\"vm.material.stock_min\"></md-input-container><md-input-container class=\"md-block\" \nflex><label><span translate=\"MATERIAL.STOCK\">Bestand</span> [kg]</label><input type=\"text\" \nng-model=\"vm.material.stock\"></md-input-container><md-input-container class=\"md-block\" flex><label><span \ntranslate=\"MATERIAL.STOCK_MAX\">Bestand-Maximum</span> [kg]</label><input type=\"text\" ng-model=\"vm.material.stock_max\">\n</md-input-container></div><div ng-if=\"!vm.isLoading\"><div layout=\"column\" layout-margin layout-padding><div \nlayout=\"row\"><div layout=\"column\" flex=\"50\" ng-if=\"vm.attributes.length>0\"><div layout=\"row\" layout-align=\"start top\" \nclass=\"secondary-text\"><md-icon md-font-icon=\"icon-bookmark-plus\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex \ntranslate=\"PRODUCT.ADD_ATTRIBUTE\">Attribut hinzufügen</span></div><md-input-container><label \ntranslate=\"PRODUCT.ATTRIBUTES\">Attributes</label><md-select ng-model=\"vm.selectedAttribute\"><md-option \nng-repeat=\"attribute in vm.attributes track by attribute.id\" ng-value=\"attribute\"><span \ntranslate=\"{{attribute.name[vm.selectedLanguage]}}\"></span></md-option></md-select></md-input-container><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"mr-16\" flex \nng-if=\"vm.selectedAttribute!==null && vm.selectedAttribute.type === \'number\'\"><label><span \ntranslate=\"PRODUCT.ATTRIBUTE.VALUE\">Value</span>&nbsp;<span ng-if=\"vm.selectedAttribute.restrictions.unit\">\n({{vm.selectedAttribute.restrictions.unit}})</span></label><input type=\"number\" name=\"attribute_value\" \nng-model=\"vm.selectedAttribute.value\"></md-input-container><md-input-container class=\"mr-16\" flex \nng-if=\"vm.selectedAttribute!==null && vm.selectedAttribute.type === \'string\'\"><label><span \ntranslate=\"PRODUCT.ATTRIBUTE.VALUE\">Value</span></label><input type=\"text\" name=\"attribute_value\" \nng-model=\"vm.selectedAttribute.value\"></md-input-container></div><md-button ng-if=\"vm.selectedAttribute!==null\" \nclass=\"md-primary md-raised\" ng-click=\"vm.addAttribute(vm.material,vm.selectedAttribute);vm.selectedAttribute=null;\" \ntranslate=\"APP.ADD\">Hinzufügen</md-button></div><div layout=\"column\" flex=\"50\" \nng-if=\"vm.material.attributes.length > 0\"><div layout=\"row\" layout-align=\"start top\" class=\"secondary-text\"><md-icon \nmd-font-icon=\"icon-bookmark\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"PRODUCT.ATTRIBUTES\">\nAttribute</span></div><md-list flex-offset=\"5\" flex><md-divider ng-repeat-start=\"attribute in vm.material.attributes\">\n</md-divider><md-list-item class=\"md-2-line\" ng-click=\"null\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{::vm.getAttributeName(attribute.id)}}</h3><h4>{{::attribute.value}}</h4></div><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.removeAttribute($index)\" aria-label=\"delete\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Löschen</span></md-tooltip></md-button>\n</md-list-item><md-divider ng-repeat-end ng-if=\"$last\"></md-divider></md-list></div></div></div></div></div>\n</md-content>");
$templateCache.put("app/main/merchandising.materials/views/partials/production.html","<md-content ms-scroll><div layout=\"column\" layout-padding><div layout=\"row\" layout-align=\"start center\" \nclass=\"secondary-text mt-30 mh-8\" ng-if=\"vm.config.ims.materials.details.production.rawMaterials\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"MATERIALS.PRODUCTION_SETTINGS\">\nSettings</span></div><div layout=\"row\" class=\"ml-8\"><md-switch ng-model=\"vm.material.protectionFilm\"><span \ntranslate=\"MATERIAL.PROTECTIVE_FILM\">Schutzfolien</span></md-switch></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"secondary-text mt-30 mh-8\" \nng-if=\"vm.config.ims.materials.details.production.rawMaterials\"><md-icon md-font-icon=\"icon-content-cut\" class=\"mr-8\">\n</md-icon><span class=\"md-title\" flex translate=\"MATERIALS.CUTTING\">Spalten</span></div><div layout=\"column\" \nlayout-margin layout-align=\"start start\" ng-if=\"vm.config.ims.materials.details.production.rawMaterials\"><md-content>\n<table id=\"formatTable\" class=\"dataTable row-border hover\" ng-if=\"vm.coils.length>0\" ms-scroll><thead><tr><th \nclass=\"text-center\" translate=\"APP.NAME\"></th><th class=\"text-center\" translate=\"MATERIALS.CUTTING_MACHINE\"></th><th \nclass=\"text-center\" translate=\"MATERIALS.CUTTING_WIDTH\"></th><th class=\"text-center\" \ntranslate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL\"></th><th class=\"text-center\" translate=\"APP.DELETE\"></th></tr>\n</thead><tbody><tr class=\"grey-100-bg\" ng-repeat=\"coil in vm.coils track by coil.id\"><td class=\"text-center w-200\">\n{{coil.name}}</td><td class=\"text-center w-200\">{{::vm.getCoilMachineName(coil.machineId)}}</td><td \nclass=\"text-center\">{{coil.width | nuitUnit:\'length\' }}</td><td class=\"text-center\">{{coil.machineMaterialId}}</td><td \nclass=\"text-center w-100\"><md-button class=\"m-0\" ng-click=\"vm.deleteCutting(coil)\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></td></tr></tbody></table></md-content><md-button class=\"md-raised md-accent mt-32 h-40\" \nng-click=\"vm.showAddCuttingDialog()\"><span translate=\"MATERIAL.ADD_CUTTING\">Neues Format anlegen</span></md-button><div\n layout=\"row\" layout-align=\"start center\" class=\"secondary-text mt-30 mh-8\" \nng-if=\"vm.config.ims.materials.details.production.rawMaterials\"><md-icon md-font-icon=\"icon-cube-unfolded\" \nclass=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"MATERIALS.BENDING_MACHINES_HEADING\">Biegen</span></div>\n<div layout=\"column\" layout-margin layout-fill ui-view=\"bending\" class=\"pv-16\" \nng-if=\"vm.config.ims.materials.details.production.rawMaterials\"></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"secondary-text mt-30 mh-8\"><md-icon md-font-icon=\"icon-vector-square\" class=\"mr-8\"></md-icon><span \nclass=\"md-title\" flex translate=\"APP.RESTRICTIONS\">Restrictions</span></div><div layout=\"row\" layout-align=\"start top\" \nlayout-wrap layout-padding><div flex=\"33\" layout-padding><div class=\"md-whiteframe-2dp pt-24\" layout=\"column\"><span \nclass=\"md-title mh-16\" translate=\"MATERIAL.LENGTH\">Length</span><div layout=\"row\" layout-align=\"space-between top\" \nlayout-margin><md-input-container flex><label translate=\"APP.MIN\">Min</label><input type=\"number\" min=\"0\" \nng-model=\"vm.material.restrictions.minLength\" nuit-unit-input=\"length\"><div \nng-messages=\"vm.materialForm.thickness.$error\" role=\"alert\"><div ng-message=\"min\" translate=\"ERRORS.TOO_SMALL\"></div>\n<div ng-message=\"max\" translate=\"ERRORS.TOO_BIG\"></div><div ng-message=\"number\" translate=\"ERRORS.NUMBER_REQUIRED\">\n</div></div></md-input-container><md-input-container flex><label translate=\"APP.MAX\">Max</label><input type=\"number\" \nmin=\"0\" ng-model=\"vm.material.restrictions.maxLength\" nuit-unit-input=\"length\"><div \nng-messages=\"vm.materialForm.thickness.$error\" role=\"alert\"><div ng-message=\"min\" translate=\"ERRORS.TOO_SMALL\"></div>\n<div ng-message=\"max\" translate=\"ERRORS.TOO_BIG\"></div><div ng-message=\"number\" translate=\"ERRORS.NUMBER_REQUIRED\">\n</div></div></md-input-container></div></div></div><div flex=\"33\" layout-padding><div class=\"md-whiteframe-2dp pt-24\" \nlayout=\"column\"><span class=\"md-title mh-16\" translate=\"MATERIAL.CUT_WIDTH\">Blank Limits</span><div layout=\"row\" \nlayout-align=\"space-between top\" layout-margin><md-input-container flex><label translate=\"APP.MIN\">Min</label><input \ntype=\"number\" ng-model=\"vm.material.restrictions.minBlank\" nuit-unit-input=\"length\"><div \nng-messages=\"vm.materialForm.thickness.$error\" role=\"alert\"><div ng-message=\"min\" translate=\"ERRORS.TOO_SMALL\"></div>\n<div ng-message=\"max\" translate=\"ERRORS.TOO_BIG\"></div><div ng-message=\"number\" translate=\"ERRORS.NUMBER_REQUIRED\">\n</div></div></md-input-container><md-input-container flex><label translate=\"APP.MAX\">Max</label><input type=\"number\" \nng-model=\"vm.material.restrictions.maxBlank\" nuit-unit-input=\"length\"><div \nng-messages=\"vm.materialForm.thickness.$error\" role=\"alert\"><div ng-message=\"min\" translate=\"ERRORS.TOO_SMALL\"></div>\n<div ng-message=\"max\" translate=\"ERRORS.TOO_BIG\"></div><div ng-message=\"number\" translate=\"ERRORS.NUMBER_REQUIRED\">\n</div></div></md-input-container></div></div></div><div flex=\"33\" layout-padding><div class=\"md-whiteframe-2dp pt-24\" \nlayout=\"column\"><div layout=\"row\" layout-align=\"space-between top\" class=\"mh-16\"><span class=\"md-title text-truncate\" \ntranslate=\"MATERIAL.HEM_BENDING_ANGLE\">Hem Settings</span><md-switch ng-model=\"vm.material.restrictions.hem\" \nclass=\"no-margin\"><span translate=\"MATERIAL.ALLOW_HEM\">Enabled</span></md-switch></div><div layout=\"row\" \nlayout-align=\"space-between top\" layout-margin><md-input-container flex><label translate=\"APP.MIN\">Min Length</label>\n<input type=\"number\" ng-model=\"vm.material.restrictions.minHemLength\" min=\"0\" nuit-unit-input=\"length\" \nng-disabled=\"!vm.material.restrictions.hem\"><div ng-messages=\"vm.materialForm.thickness.$error\" role=\"alert\"><div \nng-message=\"min\" translate=\"ERRORS.TOO_SMALL\"></div><div ng-message=\"max\" translate=\"ERRORS.TOO_BIG\"></div><div \nng-message=\"number\" translate=\"ERRORS.NUMBER_REQUIRED\"></div></div></md-input-container><md-input-container flex><label\n translate=\"APP.MAX\">Max Length</label><input type=\"number\" ng-model=\"vm.material.restrictions.maxHemLength\" min=\"0\" \nnuit-unit-input=\"length\" ng-disabled=\"!vm.material.restrictions.hem\"><div \nng-messages=\"vm.materialForm.thickness.$error\" role=\"alert\"><div ng-message=\"min\" translate=\"ERRORS.TOO_SMALL\"></div>\n<div ng-message=\"max\" translate=\"ERRORS.TOO_BIG\"></div><div ng-message=\"number\" translate=\"ERRORS.NUMBER_REQUIRED\">\n</div></div></md-input-container></div></div></div><div flex=\"33\" layout-padding><div class=\"md-whiteframe-2dp pt-24\" \nlayout=\"column\"><span class=\"md-title mh-16\" translate=\"MATERIAL.BENDING_ANGLE\">Bending Angle Limits</span>\n<md-input-container flex class=\"mh-16\"><label translate=\"APP.MIN\">Min Angle</label><input type=\"number\" min=\"0\" \nng-model=\"vm.material.restrictions.minBendingAngle\"></md-input-container></div></div><div flex=\"33\" layout-padding><div\n class=\"md-whiteframe-2dp pt-24\" layout=\"column\"><span class=\"md-title mh-16\" translate=\"MATERIAL.SEGMENT_LENGTH\">\nSegment Limits</span><div layout=\"row\" layout-align=\"space-between top\" layout-margin><md-input-container flex><label \ntranslate=\"APP.MIN\">Min Length</label><input type=\"number\" min=\"0\" \nng-model=\"vm.material.restrictions.minSegmentLength\" nuit-unit-input=\"length\"></md-input-container><md-input-container \nflex><label translate=\"APP.MAX\">Max Length</label><input type=\"number\" min=\"0\" \nng-model=\"vm.material.restrictions.maxSegmentLength\" nuit-unit-input=\"length\"></md-input-container></div></div></div>\n</div></div></div></md-content>");
$templateCache.put("app/main/merchandising.materials/views/partials/sales.html","<md-content ms-scroll layout-fill class=\"thread-detail\"><div layout=\"row\" class=\"mt-30\" layout-padding><div \nlayout=\"column\" layout-padding flex=\"50\"><div layout=\"row\" layout-align=\"start center\" class=\"secondary-text mt-30\">\n<md-icon md-font-icon=\"icon-cash-multiple\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex \ntranslate=\"MATERIALS.PRICING\">Pricing</span></div><div layout=\"row\" class=\"m-0 p-0\"><md-input-container flex><label>\n{{ \'MATERIALS.PURCHASING_PRICE\' | translate }} ({{vm.config.units.materialprice.symbol}})</label><input type=\"number\" \nname=\"purchasingPrice\" ng-model=\"vm.material.basePrice\" aria-label=\"n\" ng-change=\"vm.updatePrice(\'basePrice\')\" \nnuit-unit-input=\"materialprice\"></md-input-container><md-input-container \nng-if=\"vm.config.ims.materials.priceConversion.enabled\" flex><label>\n{{ \'MATERIALS.PURCHASING_PRICE\' | translate }} ({{vm.config.ims.materials.priceConversion.symbol}})</label><input \ntype=\"number\" name=\"purchasingPrice\" ng-model=\"vm.material.convertedPrice\" aria-label=\"n\" \nng-change=\"vm.updateBasePrice()\" ng-model-options=\"{debounce:200}\"></md-input-container></div><md-input-container>\n<label translate=\"MATERIALS.EXTRA_CHARGE_ABSOLUTE\">Absoluter Aufschlag/Rabatt</label><input type=\"number\" \nname=\"extraChargeAbsolute\" ng-model=\"vm.extraChargeAbsolute\" ng-change=\"vm.updatePrice(\'extraChargeAbsolute\')\" \nnuit-unit-input=\"materialprice\" aria-label=\"n\"></md-input-container><md-input-container><label><span \ntranslate=\"MATERIALS.EXTRA_CHARGE_RELATIVE\">Relativer Aufschlag/Rabatt</span>&nbsp;(%)</label><input type=\"number\" \nname=\"extraChargeRelative\" ng-model=\"vm.extraChargeRelative\" ng-change=\"vm.updatePrice(\'extraChargeRelative\')\" \naria-label=\"n\"></md-input-container><md-input-container><label>\n{{ \'MATERIALS.PRICE\' | translate }} ({{vm.config.units.materialprice.symbol}})</label><input type=\"number\" \nname=\"price\" ng-model=\"vm.sellingPrice\" aria-label=\"n\" ng-change=\"vm.updatePrice(\'sellingPrice\')\" \nnuit-unit-input=\"materialprice\"></md-input-container><p><strong><span translate=\"MATERIALS.HINT\">Hinweis</span>:\n</strong> <span translate=\"MATERIALS.PRICING_HINT\">\nDie Ermittlung des Gesamtpreises (bei Auftrag) ergibt sich aus: Materialpositionspreis (Materialpreis + Aufschlag) * Länge * Menge + Bearbeitungskosten (\"Kantungspreise\")\n</span></p></div><div layout=\"column\" layout-padding flex=\"50\" ng-if=\"vm.config.ims.materials.details.sales.logistics\">\n<div layout=\"row\" layout-align=\"start center\" class=\"secondary-text mt-30\"><md-icon \nmd-font-icon=\"icon-package-variant\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"MATERIALS.LOGISTICS\">\nLogistics</span></div><md-input-container><label translate=\"MATERIALS.PACKAGE_UNIT\">Verpackungseinheit</label><input \ntype=\"text\" name=\"packageUnit\" ng-model=\"vm.material.packageUnit\" aria-label=\"n\"></md-input-container>\n<md-input-container><label translate=\"MATERIALS.PACKAGE_WEIGHT\">Verpackugnsgewicht</label><input type=\"text\" \nname=\"packageWeight\" ng-model=\"vm.material.packageWeight\" aria-label=\"n\"></md-input-container><md-input-container>\n<label translate=\"MATERIALS.CUSTOM_TARIFF_NUMBER\">Zolltarifnummer</label><input type=\"number\" \nname=\"customTariffNumber\" ng-model=\"vm.material.customTariffNumber\" aria-label=\"n\"></md-input-container>\n<md-input-container><label translate=\"MATERIALS.STANDARD_PART_NUMBER\">Normteilnummer</label><input type=\"number\" \nname=\"standardPartNumber\" ng-model=\"vm.material.standardPartNumber\" aria-label=\"n\"></md-input-container></div></div>\n<div layout=\"column\" layout-padding ng-if=\"vm.config.ims.companies.enabled\"><div layout=\"row\" layout-align=\"start top\" \nlayout-margin class=\"secondary-text mt-16\"><md-icon md-font-icon=\"icon-crosshairs-gps\" class=\"mr-8\"></md-icon><span \nclass=\"md-title\" flex translate=\"SALES.RESTRICTIONS\">Globale Regeln</span></div><div class=\"mb-100 mt-0\"><div \nclass=\"m-10 mt-0 ml-16\"><h2 class=\"mt-0\" translate=\"PARTNERS.COMPANIES_NAV\"></h2></div><div layout=\"column\" \nlayout-margin><table style=\"opacity: 0.75\" class=\"simple mr-16 md-whiteframe-4dp mb-100\"><thead><tr><th \nclass=\"text-center\" translate=\"COMPANY.NAME\"></th><th style=\"width: 120px !important\"></th></tr></thead><tbody><tr \nng-repeat=\"company in vm.selectedCompanies\"><td class=\"text-center\">{{company.name}}</td><td class=\"text-center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.removeCompany($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></td></tr><tr><td><md-select ng-model=\"vm.currentCompanyId\" md-on-open=\"vm.reloadCompanies()\" \nplaceholder=\"{{\'APP.SEARCH\' | translate}}\" flex><md-select-header class=\"select-header p-10\"><div layout=\"row\" \nlayout-align=\"center center\" flex><input flex id=\"search\" ng-model=\"vm.searchText\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"{{\'APP.SEARCH\' | translate}}\"><md-button class=\"md-icon-button\">\n<md-icon ng-show=\"vm.searchText && vm.searchText.length>0\" md-font-icon=\"icon-close\" ng-click=\"vm.searchText=\'\';\">\n</md-icon></md-button></div></md-select-header><div layout=\"row\" layout-align=\"center center\" layout-margin><span \nng-if=\"vm.companiesLoaded && vm.companies.length===0\" translate=\"APP.EMPTY\"></span><md-progress-circular \nclass=\"md-accent\" md-diameter=\"16\" ng-if=\"!vm.companiesLoaded\"></md-progress-circular></div><md-option \nng-value=\"company.id\" \nng-repeat=\"company in vm.companies | filter:{name: vm.searchText} | orderBy:\'name\' | limitTo:100\">{{company.name}}\n</md-option></md-select></td><td class=\"text-center\"><md-button ng-click=\"vm.selectCompany()\" \nclass=\"md-accent md-raised\" ng-disabled=\"!vm.currentCompanyId\" flex><label translate=\"APP.ADD\"></label></md-button>\n</td></tr></tbody></table></div></div></div></md-content>");
$templateCache.put("app/main/merchandising.materials.groups/dialogs/raw-material/raw-material.html","<md-dialog style=\"width:700px\"><form ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"MATERIALS.GROUPS.ADD\">Gruppe hinzufügen</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"position:relative\"><div class=\"md-dialog-content\"><div layout=\"row\"><md-input-container \nng-if=\"vm.languages.length > 1\"><label translate=\"APP.LANG\">Language</label><md-select ng-model=\"vm.selectedLanguage\">\n<md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{ ::lang }}</span>\n</md-option></md-select></md-input-container><md-input-container class=\"mb-0\" flex><label translate=\"APP.NAME\">\n{{ lang }}</label><input type=\"text\" name=\"name[{{lang}}]\" ng-model=\"vm.group.name[vm.selectedLanguage]\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"mb-0\" flex><label><span \ntranslate=\"MATERIALS.TENSILE_STRENGTH\"></span> (MPa)</label><input type=\"number\" name=\"tensileStrength\" \nng-model=\"vm.group.tensileStrength\"></md-input-container></div><div layout=\"row\" flex><div layout=\"column\" flex \nlayout-align=\"start center\" class=\"br pr-5\"><h4 class=\"ml-8\"><span translate=\"MATERIALS.BLANK_STEPS\"></span>\n ({{vm.config.units.length.symbol}})</h4><div class=\"ml-8\" ng-repeat=\"step in vm.group.blankSteps track by $index\" \nlayout=\"row\" layout-align=\"start center\"><input flex type=\"number\" ng-model=\"step.step\" class=\"text-right mr-8\" \nmin=\"0\" nuit-unit-input=\"length\"><md-button class=\"md-icon-button m-0 ml-8\" \nng-click=\"vm.group.blankSteps.splice($index,1);\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.group.blankSteps.push({step: 0});\"><label translate=\"APP.ADD\">\n</label></md-button></div><div layout=\"column\" flex layout-align=\"start center\" class=\"pl-5\"><h4 class=\"ml-8\"><span \ntranslate=\"MATERIALS.LENGTH_STEPS\"></span> ({{vm.config.units.length.symbol}})</h4><div class=\"ml-8\" \nng-repeat=\"step in vm.group.lengthSteps track by $index\" layout=\"row\" layout-align=\"start center\"><input flex \ntype=\"number\" ng-model=\"step.step\" class=\"text-right mr-8\" min=\"0\" nuit-unit-input=\"length\"><md-button \nclass=\"md-icon-button m-0 ml-8\" ng-click=\"vm.group.lengthSteps.splice($index,1);\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-button class=\"md-raised md-accent inline-block\" \nng-click=\"vm.group.lengthSteps.push({step: 0});\"><label translate=\"APP.ADD\"></label></md-button></div><div \nng-if=\"vm.config.ims.materials.groups.preDefinedLengths.enabled\" layout=\"column\" flex layout-align=\"start center\" \nclass=\"pl-5\"><h4 class=\"ml-8\"><span translate=\"MATERIALS.PREDEFINED_LENGTHS\"></span>\n ({{vm.config.units.length.symbol}})</h4><div class=\"ml-8\" \nng-repeat=\"step in vm.group.preDefinedLengths track by $index\" layout=\"row\" layout-align=\"start center\"><input flex \ntype=\"number\" ng-model=\"step.step\" class=\"text-right mr-8\" min=\"0\" nuit-unit-input=\"length\"><md-button \nclass=\"md-icon-button m-0 ml-8\" ng-click=\"vm.group.preDefinedLengths.splice($index,1);\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-button class=\"md-raised md-accent inline-block\" \nng-click=\"vm.group.preDefinedLengths.push({step: 0});\"><label translate=\"APP.ADD\"></label></md-button></div></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">\n<span translate=\"APP.CANCEL\">Abbrechen</span></md-button><md-button ng-click=\"vm.save()\" class=\"md-warn md-raised\">\n<span translate=\"APP.SAVE\">Speichern</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/merchandising.materials.sales/dialogs/material-sales-change/material-sales-change.html","<md-dialog><form ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"MATERIALS.GROUPS.ADD\">Gruppe hinzufügen</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"position:relative\"><div class=\"md-dialog-content\"><div layout=\"row\"><md-input-container \nng-if=\"vm.languages.length > 1\"><label translate=\"APP.LANG\">Language</label><md-select ng-model=\"vm.selectedLanguage\">\n<md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{ ::lang }}</span>\n</md-option></md-select></md-input-container><md-input-container class=\"mb-0\" flex><label class=\"w-100 text-uppercase\" \ntranslate=\"APP.NAME\">{{ lang }}</label><input type=\"text\" name=\"name[{{lang}}]\" \nng-model=\"vm.group.name[vm.selectedLanguage]\"></md-input-container></div><div layout=\"column\" flex><h4 \ntranslate=\"MATERIALS.BLANK_STEPS\"></h4><div ng-repeat=\"step in vm.group.blankSteps track by step.id\" flex layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"number\" ng-model=\"step.step\" class=\"text-right mr-8\" min=\"0\" \nnuit-unit-input=\"length\"> {{vm.config.units.length.symbol}}<md-button class=\"md-icon-button\" \nng-click=\"vm.group.blankSteps.splice($index,1);\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.group.blankSteps.push({id: vm.group.blankSteps.length, step: 0});\">\n<label translate=\"APP.ADD\"></label></md-button></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Abbrechen</span></md-button>\n<md-button ng-click=\"vm.save()\" class=\"md-warn md-raised\"><span translate=\"APP.SAVE\">Speichern</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/merchandising.products/dialogs/category/category.html","<md-dialog aria-label=\"New Group\" id=\"system-color-dialog\"><form name=\"groupsForm\" ng-submit=\"vm.submit()\" novalidate>\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.isNew\" flex \ntranslate=\"PRODUCTS.CATEGORIES_ADD\">Kategorie hinzufügen</h2><h2 ng-if=\"!vm.isNew\" flex \ntranslate=\"PRODUCTS.CATEGORIES_EDIT\">Kategorie bearbeiten</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"md-dialog-content\"><div layout=\"row\"><md-input-container><label translate=\"APP.LANGUAGE\">Lang</label><md-select \nng-model=\"vm.currentLanguage\"><md-option ng-repeat=\"lang in vm.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">\n{{lang}}</span></md-option></md-select></md-input-container><div layout=\"column\" flex><md-input-container><label \ntranslate=\"CART.FIELD.NAME\">Bezeichnung</label><input type=\"text\" name=\"name\" \nng-model=\"vm.category.name[vm.currentLanguage]\" md-maxlength=\"100\" required><div ng-messages=\"fieldForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"PRODUCT.DESCRIPTION\">Beschreibung</label><input \ntype=\"text\" name=\"name\" ng-model=\"vm.category.description[vm.currentLanguage]\" md-maxlength=\"300\"></md-input-container>\n</div></div><md-input-container><label translate=\"APP.PARENT\">Parent</label><md-select \nng-disabled=\"vm.categories.length < 1\" ng-model=\"vm.category.parent\"><md-option ng-value=\"null\"><em>---</em>\n</md-option><md-option ng-repeat=\"category in vm.categories track by $index\" \nng-if=\"!vm.excludedParentIds[category.id]\" ng-value=\"category.id\">{{category.name | nuitTranslate}}</md-option>\n</md-select></md-input-container><div class=\"md-whiteframe-2dp p-10\" layout=\"row\" layout-wrap \nlayout-align=\"start start\" layout-fill><div layout=\"column\" ng-repeat=\"image in vm.category.images\"><img \nhttp-src=\"{{image.url}}\" class=\"w-100 h-100\" ng-click=\"vm.openImage(image.url,$event)\"><md-button class=\"md-raised\" \nng-click=\"vm.deleteImage(image)\"><label translate=\"APP.DELETE\"></label></md-button></div><md-button \nclass=\"md-accent md-raised w-100 h-100 m-0 p-0\" ng-click=\"vm.addImage()\"><label style=\"white-space: normal\" \ntranslate=\"PRODUCTS.CATEGORIES_ADD_IMAGE\"></label></md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\">\n<md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button>\n<md-button class=\"md-accent md-raised\" ng-click=\"vm.save()\" type=\"submit\" ng-disabled=\"groupsForm.$invalid\"><span \ntranslate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/merchandising.products/dialogs/select-parent-category/select-parent-category.html","<md-dialog md-theme=\"nuit\" aria-label=\"Item rename\" class=\"dialog move-to-folder\" flex=\"100\" flex-gt-md=\"40\"><form \nname=\"form.move\" ng-cloak ng-submit=\"vm.submit()\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"PROFILE.MOVE_SELECT_TARGET\">Select folder</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"row\" layout-align=\"center center\" layout-fill style=\"cursor: pointer; margin-bottom: -20px\" \nng-click=\"vm.showSelected()\" ng-class=\"{\'text-bold\': !vm.selectedGroup}\"><span class=\"ml-20\"><md-icon \nstyle=\"margin-bottom: 5px\" md-font-icon=\"icon-label-outline\"></md-icon></span><span translate=\"APP.SHOW_ALL\" \nclass=\"m-10\">All</span> <span flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"$event.stopPropagation(); vm.selectedGroup = null;\"><md-icon md-font-icon=\"icon-plus\" class=\"s20\">\n<md-tooltip><span translate=\"CATEGORIES.ADD\"></span></md-tooltip></md-icon></md-button></span></div><treecontrol \nclass=\"tree-classic\" expanded-nodes=\"vm.expandedGroups\" tree-model=\"vm.categories\" options=\"vm.treeOptions\" \non-selection=\"vm.showSelected(node)\" selected-node=\"vm.selectedGroup\"><span class=\"title\">\n{{ node.name | nuitTranslate }}</span></treecontrol></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button class=\"md-primary md-raised\" ng-disabled=\"vm.folder === null\" type=\"submit\"><span translate=\"APP.OK\">\nOk</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/merchandising.products/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.products\" default-name=\"PRODUCTS_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/merchandising.products/views/partials/general.html","<md-content ms-scroll layout-fill><div class=\"content\" ng-if=\"vm.loadingItems\" flex><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span \ntranslate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content ng-if=\"!vm.isLoading\"><div layout=\"row\" \nlayout-align=\"space-between top\" layout-margin layout-padding layout-wrap layout-fill><div layout=\"column\" \nflex=\"noshrink\" class=\"mb-0 pt-0 pb-0\"><div layout=\"row\" layout-align=\"start top\" class=\"secondary-text mt-16 mb-10\">\n<md-icon md-font-icon=\"icon-menu\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"APP.GENERAL\">General\n</span></div><div layout=\"row\" class=\"mt-5\"><md-input-container class=\"mt-5 mb-5\" flex><label translate=\"PRODUCT.NAME\">\nBezeichnung</label><input type=\"text\" name=\"name\" ng-model=\"vm.currentProduct.name[vm.selectedLanguage]\" required>\n</md-input-container><md-input-container class=\"mt-5 mb-5\" ng-if=\"vm.config.languages.length > 1\"><label \ntranslate=\"APP.LANG\">Lang</label><md-select ng-model=\"vm.selectedLanguage\" \nmd-selected-text=\"vm.selectedLanguage.toUpperCase()\"><md-option ng-repeat=\"lang in vm.config.languages\" \nng-value=\"lang\"><span class=\"text-uppercase\">{{ lang }}</span><span class=\"grey-500-fg\" \nng-if=\"vm.currentProduct.name[lang]\">&nbsp;({{vm.currentProduct.name[lang]}})</span></md-option></md-select>\n</md-input-container></div><md-input-container style=\"margin-top: 0\" class=\"mb-5\"><label \ntranslate=\"PRODUCT.DESCRIPTION\">Description</label><textarea \nng-model=\"vm.currentProduct.description[vm.selectedLanguage]\"></textarea></md-input-container><div layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"min-width:68px;min-height:68px;max-width:68px;max-height:68px\" \nng-class=\"{\'md-whiteframe-5dp\': vm.currentProduct.image === undefined || vm.currentProduct.image === null}\"><img \nclass=\"md-whiteframe-5dp\" style=\"max-height:68px;max-width:68px; width: auto; height:auto\" \nhttp-src=\"{{ vm.currentProduct.image }}\" alt=\" \" ng-click=\"vm.openImage(vm.currentProduct.image)\"></div>\n<md-input-container class=\"m-16\" flex=\"noshrink\"><label translate=\"PRODUCT.IMAGE\">Image</label><input type=\"text\" \nname=\"productImage\" ng-disabled=\"true\" ng-model=\"vm.currentProduct.image\"></md-input-container><md-button \nclass=\"md-primary md-raised md-fab md-mini\" flex=\"none\" ng-click=\"vm.uploadImage()\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex><label translate=\"PRODUCT.EXTERNAL_ID\">ExternalId</label><input type=\"text\" name=\"externalId\" \nng-model=\"vm.currentProduct.externalId\" \nng-disabled=\"({product: vm.product} | nuitConditionCheck:vm.config.ims.products.details.readOnlyConditions.externalId:true)\">\n</md-input-container></div><md-input-container \nng-if=\"vm.config.evo.products.inventory.enabled && vm.currentProduct.inventory\"><label \ntranslate=\"PRODUCT.AVAILABLE_QUANTITY_SETTING\">Verfügbare Menge</label><input type=\"text\" name=\"availableQuantity\" \nng-disabled=\"true\" ng-model=\"vm.currentProduct.inventory.availableQuantity\"></md-input-container></div><div \nlayout=\"column\" flex=\"noshrink\" class=\"mb-0 pt-0 pb-0\"><div layout=\"row\" layout-align=\"start top\" \nclass=\"secondary-text mt-16 mb-10\"><md-icon md-font-icon=\"icon-grid\" class=\"mr-8\"></md-icon><span class=\"md-title\" \nflex translate=\"APP.FILTER\">Filter</span></div><md-input-container class=\"mt-10 mb-10\"><label \ntranslate=\"PRODUCT.CATEGORIES\">Categories</label><md-select ng-disabled=\"vm.categories.length < 1\" \nng-model=\"vm.currentProduct.categories\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\"><md-option \nng-repeat=\"category in vm.categories | orderBy: category.name track by category.id\" ng-value=\"{id: category.id}\"><span>\n{{ category.name | nuitTranslate }}</span></md-option></md-select></md-input-container><md-input-container \nclass=\"mt-20 mb-10\"><label translate=\"PRODUCT.TAGS\">Tags</label><md-select ng-disabled=\"vm.tags.length < 1\" \nng-model=\"vm.currentProduct.tags\" multiple=\"multiple\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"tag in vm.tags| orderBy: tag.id track by tag.id\" ng-value=\"tag\"><span>{{ tag.name | nuitTranslate }}</span>\n</md-option></md-select></md-input-container><md-switch ng-model=\"vm.currentProduct.purchasable\"><span \ntranslate=\"PRODUCT.PURCHASABLE\">Purchasable</span></md-switch><md-switch \nng-model=\"vm.currentProduct.quantityAdjustable\"><span translate=\"PRODUCT.QUANTITY_ADJUSTABLE\">Quantity adjustable\n</span></md-switch><nuit-favorites favorites=\"vm.favorites\" selected-favorite=\"vm.currentProduct.favorite\">\n</nuit-favorites></div></div><div layout=\"row\" layout-align=\"space-between top\" layout-margin layout-padding \nlayout-wrap layout-fill><div layout=\"column\" flex=\"noshrink\" class=\"mb-0 pt-0 pb-0\"><div layout=\"row\" \nlayout-align=\"start top\" class=\"secondary-text mb-10 mt-16\"><md-icon md-font-icon=\"icon-table\" class=\"mr-8\"></md-icon>\n<span class=\"md-title\" flex translate=\"APP.DETAILS\">Details</span></div><div class=\"mt-5\" layout=\"row\" \nng-repeat=\"detail in vm.currentProduct.details\"><md-input-container flex class=\"mt-5 mb-5\"><label \ntranslate=\"PRODUCT.NAME\">Bezeichnung</label><input type=\"text\" name=\"name\" ng-model=\"detail.name[vm.selectedLanguage]\" \nrequired></md-input-container><md-input-container flex class=\"mt-5 mb-5\"><label translate=\"PRODUCT.DETAIL_VALUE\">Wert\n</label><input type=\"text\" name=\"name\" ng-model=\"detail.value\" required></md-input-container><md-button \nclass=\"md-icon-button mt-10\" ng-click=\"vm.removeDetail(detail)\" aria-label=\"delete\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><md-tooltip><span translate=\"APP.DELETE\">Löschen</span></md-tooltip></md-button></div><div><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.addDetail()\" translate=\"PRODUCT.ADD_DETAIL\">Hinzufügen</md-button></div>\n</div><div layout=\"column\" flex=\"noshrink\" class=\"mb-0 pt-0 pb-0\"><div layout=\"row\" layout-align=\"start top\" \nclass=\"secondary-text mb-10 mt-16\"><md-icon md-font-icon=\"icon-attachment\" class=\"mr-8\"></md-icon><span \nclass=\"md-title\" flex translate=\"APP.ATTACHMENTS\">Attachments</span></div><div class=\"mt-5\" layout=\"row\" \nng-repeat=\"attachment in vm.currentProduct.attachments\" layout-align=\"start start\"><a class=\"mt-10\" \nhref=\"{{vm.getUrl(attachment.link)}}\" target=\"_blank\"><md-icon md-font-icon=\"icon-attachment\"></md-icon></a>\n<md-input-container flex class=\"mt-5 mb-5\"><label translate=\"APP.NAME\">Bezeichnung</label><input type=\"text\" \nname=\"name\" ng-model=\"attachment.name[vm.selectedLanguage]\" required></md-input-container><div class=\"mt-10\" \nng-click=\"vm.removeAttachment(vm.currentProduct,$index)\" aria-label=\"delete\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><md-tooltip><span translate=\"APP.DELETE\">Löschen</span></md-tooltip></div></div><div><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.addAttachment(vm.currentProduct)\" translate=\"PRODUCT.ADD_ATTACHMENT\">\nHinzufügen</md-button></div></div><div layout=\"row\" layout-align=\"space-between start\" flex=\"100\" layout-wrap \nclass=\"mb-0 pt-0 pb-0\"><div layout=\"column\" flex=\"noshrink\" layout-align=\"start start\" ng-if=\"vm.attributes.length>0\">\n<div layout=\"row\" layout-align=\"start top\" class=\"secondary-text mt-16 mb-10\"><md-icon \nmd-font-icon=\"icon-bookmark-plus\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"PRODUCT.ADD_ATTRIBUTE\">\nAttribut hinzufügen</span></div><md-input-container><label translate=\"PRODUCT.ATTRIBUTES\">Attributes</label><md-select \nng-model=\"vm.selectedAttribute\" style=\"min-width:300px\"><md-option \nng-repeat=\"attribute in vm.attributes track by attribute.id\" ng-value=\"attribute\" \nng-disabled=\"vm.hasAttribute(vm.currentProduct, attribute)\"><span>{{ attribute.name | nuitTranslate }} </span>&nbsp;\n<span class=\"grey-300-fg\" ng-class=\"{\'grey-500-fg\': !vm.hasAttribute(vm.currentProduct, attribute)}\">(<span \ntranslate=\"{{vm.getTranslationKeyOfType(attribute.type)}}\"></span>)</span></md-option></md-select></md-input-container>\n<div layout=\"row\" layout-align=\"space-around center\" style=\"min-width:300px\"><md-input-container class=\"mr-16\" flex \nng-if=\"vm.selectedAttribute && vm.selectedAttribute.type === \'number\'\"><label><span \ntranslate=\"PRODUCT.ATTRIBUTE.VALUE\">Value</span>&nbsp;<span ng-if=\"vm.selectedAttribute.restrictions.unit\">\n({{vm.selectedAttribute.restrictions.unit}})</span></label><input type=\"number\" name=\"attribute_value\" \nng-model=\"vm.selectedAttribute.value\" min=\"{{vm.selectedAttribute.restrictions.min}}\" \nmax=\"{{vm.selectedAttribute.restrictions.max}}\" ng-disabled=\"!vm.selectedAttribute.hasAttributeValue\"><div \nclass=\"md-char-counter grey-500-fg\" \nng-if=\"vm.selectedAttribute.type === \'number\' && vm.selectedAttribute.restrictions.min !== undefined && vm.selectedAttribute.restrictions.max !== undefined\">\n{{vm.selectedAttribute.restrictions.min}}&nbsp;-&nbsp;{{vm.selectedAttribute.restrictions.max}}</div>\n</md-input-container><md-input-container class=\"mr-16\" flex \nng-if=\"vm.selectedAttribute && vm.selectedAttribute.type === \'length\' && vm.selectedAttribute.hasAttributeValue\">\n<label><span translate=\"PRODUCT.ATTRIBUTE.VALUE\">Value</span>&nbsp;<span>({{vm.nuitUnits(\'length\').symbol}})</span>\n</label><input type=\"number\" name=\"attribute_value\" ng-model=\"vm.selectedAttribute.value\" \nmin=\"{{vm.selectedAttribute.restrictions.min}}\" max=\"{{vm.selectedAttribute.restrictions.max}}\" \nnuit-unit-input=\"length\" ng-disabled=\"!vm.selectedAttribute.hasAttributeValue\"><div \nclass=\"md-char-counter grey-500-fg\" \nng-if=\"vm.selectedAttribute.restrictions.min !== undefined && vm.selectedAttribute.restrictions.max !== undefined\">\n{{vm.selectedAttribute.restrictions.min | nuitUnit:\'length\'}}&nbsp;-&nbsp;{{vm.selectedAttribute.restrictions.max | nuitUnit:\'length\'}}\n</div></md-input-container><md-input-container class=\"mr-16\" flex \nng-if=\"vm.selectedAttribute && vm.selectedAttribute.type === \'length\' && !vm.selectedAttribute.hasAttributeValue\">\n<label><span translate=\"PRODUCT.ATTRIBUTE.MIN\">Value</span>&nbsp;<span>({{vm.nuitUnits(\'length\').symbol}})</span>\n</label><input type=\"number\" name=\"attribute_value_min\" ng-model=\"vm.selectedAttribute.value.min\" \nlimit-min=\"vm.selectedAttribute.restrictions.min\" limit-max=\"vm.selectedAttribute.restrictions.max\" \nnuit-unit-input=\"length\"><div class=\"md-char-counter grey-500-fg\" \nng-if=\"vm.selectedAttribute.restrictions.min !== undefined && vm.selectedAttribute.restrictions.max !== undefined\">\n{{vm.selectedAttribute.restrictions.min | nuitUnit: \'length\'}}&nbsp;-&nbsp;{{vm.selectedAttribute.restrictions.max | nuitUnit: \'length\'}}\n</div></md-input-container><md-input-container class=\"mr-16\" flex \nng-if=\"vm.selectedAttribute && vm.selectedAttribute.type === \'length\' && !vm.selectedAttribute.hasAttributeValue\">\n<label><span translate=\"PRODUCT.ATTRIBUTE.MAX\">Value</span>&nbsp;<span>({{vm.nuitUnits(\'length\').symbol}})</span>\n</label><input type=\"number\" name=\"attribute_value\" ng-model=\"vm.selectedAttribute.value.max\" \nlimit-min=\"vm.selectedAttribute.restrictions.min\" limit-max=\"vm.selectedAttribute.restrictions.max\" \nnuit-unit-input=\"length\"><div class=\"md-char-counter grey-500-fg\" \nng-if=\"vm.selectedAttribute.restrictions.min !== undefined && vm.selectedAttribute.restrictions.max !== undefined\">\n{{vm.selectedAttribute.restrictions.min | nuitUnit: \'length\'}}&nbsp;-&nbsp;{{vm.selectedAttribute.restrictions.max | nuitUnit: \'length\'}}\n</div></md-input-container><md-input-container class=\"mr-16\" flex \nng-if=\"vm.selectedAttribute && vm.selectedAttribute.type === \'string\'\"><label><span \ntranslate=\"PRODUCT.ATTRIBUTE.VALUE\">Value</span></label><input type=\"text\" name=\"attribute_value\" \nng-model=\"vm.selectedAttribute.value\" ng-pattern=\"vm.selectedAttribute.restrictions.regex\" \nng-disabled=\"!vm.selectedAttribute.hasAttributeValue\"></md-input-container><md-input-container class=\"mr-16\" flex \nng-if=\"vm.selectedAttribute && vm.selectedAttribute.type === \'enum\'\"><label><span translate=\"PRODUCT.ATTRIBUTE.VALUE\">\nValue</span></label><md-select ng-model=\"vm.selectedAttribute.value\" \nng-disabled=\"!vm.selectedAttribute.hasAttributeValue\"><md-option \nng-repeat=\"option in vm.selectedAttribute.restrictions.options track by $index\" ng-value=\"option\"><span>{{ option }}\n</span></md-option></md-select></md-input-container><md-input-container class=\"mr-16\" flex \nng-if=\"vm.selectedAttribute && vm.selectedAttribute.type === \'material\'\"><label><span \ntranslate=\"PRODUCT.ATTRIBUTE.VALUE\">Value</span></label><md-select ng-model=\"vm.selectedAttribute.value\" \nmd-on-open=\"vm.reloadAttributeMaterials()\" ng-disabled=\"!vm.selectedAttribute.hasAttributeValue\"><md-option \nng-repeat=\"material in vm.attributeMaterials track by material.id\" ng-value=\"material.id\"><span>\n{{ material.name | nuitTranslate }}</span></md-option></md-select></md-input-container><md-input-container \nclass=\"mr-16\" flex \nng-if=\"vm.selectedAttribute && vm.selectedAttribute.type === \'color\' && vm.selectedAttribute.hasAttributeValue\"><label>\n<span translate=\"PRODUCT.ATTRIBUTE.VALUE\">Value</span></label><md-select ng-model=\"vm.selectedAttribute.value\" \nmd-on-open=\"vm.reloadAttributeColors()\"><md-option ng-repeat=\"color in vm.attributeColors track by color.id\" \nng-value=\"color.id\"><span>{{ color.name | nuitTranslate }}</span></md-option></md-select></md-input-container>\n<md-input-container class=\"mr-16\" flex \nng-if=\"vm.selectedAttribute && vm.selectedAttribute.type === \'color\' && !vm.selectedAttribute.hasAttributeValue\">\n<label><span translate=\"PRODUCT.ATTRIBUTE.SUBSET\">Subset</span></label><md-select \nng-model=\"vm.selectedAttribute.restrictions.subset\" multiple=\"multiple\" md-on-open=\"vm.reloadAttributeColors()\">\n<md-option ng-repeat=\"color in vm.attributeColors track by color.id\" ng-value=\"color.id\"><span>\n{{ color.name | nuitTranslate }}</span></md-option></md-select></md-input-container><md-checkbox flex-offset=\"10\" \nflex=\"initial\" ng-if=\"vm.selectedAttribute\" ng-model=\"vm.selectedAttribute.hasAttributeValue\">\n{{ \'PRODUCT.ATTRIBUTE.FIXED_VALUE\' | translate }}</md-checkbox></div><md-button ng-if=\"vm.selectedAttribute\" \nclass=\"md-primary md-raised\" ng-click=\"vm.addAttribute()\" translate=\"APP.ADD\">Hinzufügen</md-button></div><div \nlayout=\"column\" flex=\"noshrink\" layout-align=\"stretch start\" ng-if=\"vm.currentProduct.attributes.length > 0\"><div \nlayout=\"row\" layout-align=\"start top\" class=\"secondary-text mt-16 mb-10\"><md-icon md-font-icon=\"icon-bookmark\" \nclass=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"PRODUCT.ATTRIBUTES\">Attribute</span></div><md-list flex>\n<md-divider ng-repeat-start=\"attribute in vm.currentProduct.attributes\"></md-divider><md-list-item class=\"md-2-line\" \nng-click=\"null\"><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.moveElement($index, -1, vm.currentProduct.attributes)\" ng-disabled=\"$first\" aria-label=\"moveup\"><md-icon \nmd-font-icon=\"icon-arrow-up\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.moveElement($index, 1, vm.currentProduct.attributes)\" ng-disabled=\"$last\" aria-label=\"movedown\"><md-icon \nmd-font-icon=\"icon-arrow-down\"></md-icon></md-button><md-icon md-font-icon=\"icon-lock red-500-fg\" \nng-if=\"attribute.value !== undefined\"></md-icon><md-icon md-font-icon=\"icon-dice green-500-fg\" \nng-if=\"attribute.value === undefined\"></md-icon><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ attribute.name | nuitTranslate }}</h3><h4 ng-if=\"attribute.value !== undefined && attribute.type === \'length\'\">\n{{attribute.value | nuitUnit:\'length\'}}</h4><h4 \nng-if=\"attribute.value !== null && attribute.type !== \'material\' && attribute.type!==\'length\'\"><span>\n{{ attribute.value}}</span><span ng-if=\"attribute.restrictions.unit\"> {{ attribute.restrictions.unit}}</span></h4><h4 \nng-if=\"attribute.value !== null && attribute.type === \'material\'\"><span>\n{{ vm.getMaterialById(attribute.value).name | nuitTranslate }}</span></h4><h4 \nng-if=\"attribute.restrictions.subset && attribute.type === \'color\'\" \nng-repeat=\"subcolor in attribute.restrictions.subset\"><span>{{ vm.getColorById(subcolor).name | nuitTranslate }}</span>\n</h4><h4 \nng-if=\"attribute.value === undefined && attribute.type === \'length\' && attribute.restrictions.min !== undefined && attribute.restrictions.max !== undefined\">\n<span class=\"grey-500-fg\">\n{{(attribute.restrictions.min | nuitUnit:\'length\') + \' - \' + (attribute.restrictions.max | nuitUnit:\'length\') + \' \' + vm.nuitUnits(\'length\').symbol }}\n</span></h4><h4 \nng-if=\"attribute.value === undefined && attribute.type === \'number\' && attribute.restrictions.min !== undefined && attribute.restrictions.max !== undefined\">\n<span class=\"grey-500-fg\">\n{{ attribute.restrictions.min + \' - \' + attribute.restrictions.max + \' \' + attribute.restrictions.unit }}</span></h4>\n</div><md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.removeAttribute(attribute)\" aria-label=\"delete\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Löschen</span></md-tooltip>\n</md-button></md-list-item><md-divider ng-repeat-end ng-if=\"$last\"></md-divider></md-list></div></div></div><div \nlayout=\"column\" layout-margin layout-wrap layout-padding \nng-if=\"vm.config.ims.products.externalAPI.enabled && vm.$state.params.externalId !== undefined\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"secondary-text mt-30\"><md-icon md-font-icon=\"icon-arrange-send-backward\" \nclass=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"PRODUCTS.EXTERNAL\">External</span></div><div \nlayout=\"column\"><md-input-container class=\"m0 mb-0 pb-0\" \nng-repeat=\"prop in vm.config.ims.products.externalAPI.remoteAttributes\"><label \ntranslate=\"PRODUCTS.{{ prop | uppercase }}\">Name</label><input type=\"text\" name=\"{{ ::prop }}\" \nng-model=\"vm.currentProduct.externalData[vm.config.ims.products.externalAPI.remoteAttributesRoot][prop]\" \nreadonly=\"readonly\" aria-label=\"{{ ::prop }}\"></md-input-container></div></div></md-content></md-content>");
$templateCache.put("app/main/merchandising.products/views/partials/properties.html","<md-content ms-scroll layout-fill><div class=\"content\" ng-if=\"vm.isLoading\" flex><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span \ntranslate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content ng-if=\"!vm.isLoading\"><div layout=\"column\" \nlayout-margin layout-padding><div layout=\"row\" ng-if=\"vm.config.ims.products.profiles.enabled\"><div layout=\"column\" \nflex class=\"mr-20\"><div layout=\"row\" layout-align=\"start top\" class=\"secondary-text\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon><span class=\"md-title ml-8\" flex translate=\"PRODUCTS.PROFILE\">Profil hinterlegen</span></div><div \nlayout=\"row\" class=\"mt-10\"><img class=\"b\" flex style=\"max-height:150px;max-width:150px; width: auto; height:auto\" \nng-if=\"vm.currentProduct.data.profile && vm.base64\" http-src=\"{{vm.base64}}\" ng-click=\"vm.openImage(vm.imagePath)\"><div\n layout=\"column\"><div ng-if=\"vm.currentProduct.data.profile === undefined\" translate=\"PRODUCTS.NO_PROFILE\">\nDieses Produkt hat kein Kantteil hinterlegt!</div><div class=\"ml-10\" layout=\"column\" \nng-if=\"vm.currentProduct.data.profile !== undefined\"><div layout=\"row\" class=\"mv-8\"><span translate=\"APP.SEGMENTS\">\n</span>:&nbsp;<span>{{ vm.getSegmentCount(vm.currentProduct.data.profile) }}</span></div></div></div></div><div \nlayout=\"row\" class=\"mt-10\" layout-wrap><div ng-if=\"vm.currentProduct.data.profile === undefined\"><md-button \nclass=\"md-primary md-raised ml-0\" ng-click=\"vm.openEditor()\" translate=\"PRODUCTS.PROFILE_ADD\">Hinzufügen</md-button>\n</div><div ng-if=\"vm.currentProduct.data.profile !== undefined\"><md-button class=\"md-primary md-raised ml-0\" \nng-click=\"vm.openEditor()\" translate=\"PRODUCTS.PROFILE_EDIT\">Bearbeiten</md-button></div><div \nng-if=\"vm.currentProduct.data.profile !== undefined\"><md-button class=\"md-primary md-raised ml-0\" \nng-click=\"vm.setProfileImage(vm.currentProduct,vm)\" translate=\"PRODUCTS.SET_PRODUCT_IMAGE\">Als Produktbild</md-button>\n</div></div><div layout=\"column\" class=\"mt-20\" ng-if=\"vm.currentProduct.data.profile !== undefined\"><div layout=\"row\" \nlayout-align=\"start top\" class=\"secondary-text\"><md-icon md-font-icon=\"icon-ruler\"></md-icon><span \nclass=\"md-title ml-8\" flex translate=\"APP.LENGTH\">Länge</span></div><div class=\"mt-10\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container ng-if=\"!vm.profileLengthFixed\"><label translate=\"APP.MIN\">Min.</label>\n<input type=\"number\" name=\"name\" ng-model=\"vm.profileLengthMin\" nuit-unit-input=\"length\" required></md-input-container>\n<md-input-container ng-if=\"!vm.profileLengthFixed\"><label translate=\"APP.MAX\">Min.</label><input type=\"number\" \nname=\"name\" ng-model=\"vm.profileLengthMax\" nuit-unit-input=\"length\" required></md-input-container><md-input-container \nng-if=\"vm.profileLengthFixed\"><label translate=\"APP.LENGTH\">Length</label><input type=\"number\" name=\"name\" \nng-model=\"vm.profileLength\" nuit-unit-input=\"length\" \nng-disabled=\"!vm.supportsLengthRange(vm.currentProduct.data.profile)\" required></md-input-container><md-checkbox \nng-model=\"vm.profileLengthFixed\" \nng-disabled=\"vm.isRule(\'PROFILE_LENGTH_FIXED\') || !vm.supportsLengthRange(vm.currentProduct.data.profile)\">\n{{ \'PRODUCT.ATTRIBUTE.FIXED_VALUE\' | translate }}</md-checkbox></div></div></div><div \nng-if=\"vm.currentProduct.data.profile !==undefined\" flex layout=\"column\"><div layout=\"row\" layout-align=\"start top\" \nclass=\"secondary-text\"><md-icon md-font-icon=\"icon-texture\"></md-icon><span class=\"md-title ml-8\" flex \ntranslate=\"APP.MATERIAL\">Profil hinterlegen</span></div><md-input-container \nng-if=\"vm.currentProduct.data.profile !== undefined && !vm.isRule(\'PROFILE_MATERIAL_SINGLE\')\"><label><span \ntranslate=\"PRODUCTS.PROFILE_GROUPS\">Value</span></label><md-select ng-model=\"vm.profileGroups\" \nmd-on-open=\"vm.reloadGroups()\" multiple=\"multiple\"><md-option \nng-repeat=\"group in vm.groups | orderByNuitTranslated:\'name\' track by group.id\" ng-value=\"group.id\"><span>\n{{ group.name | nuitTranslate }}</span></md-option></md-select></md-input-container><table><tr \nng-repeat=\"material in vm.materialsForView \"><td><div class=\"w-15 h-15 b\" \nstyle=\"background-color:{{::material.colors.front.hex}}\"></div></td><td>&nbsp;{{material.name | nuitTranslate}}</td>\n<td><md-button class=\"md-secondary md-icon-button m-0 p-0\" ng-click=\"vm.removeMaterial($index)\" aria-label=\"delete\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr></table><div><md-button \nclass=\"md-primary md-raised m-0\" ng-click=\"vm.addMaterials()\" \nng-disabled=\"vm.profileMaterials.length>0 && vm.isRule(\'PROFILE_MATERIAL_SINGLE\')\"><label translate=\"MATERIAL.ADD\">\n</label></md-button></div></div></div></div></md-content></md-content>");
$templateCache.put("app/main/merchandising.products/views/partials/sales.html","<md-content ms-scroll layout-fill><div class=\"content\" ng-if=\"vm.isLoading\" flex><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span \ntranslate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content ng-if=\"!vm.isLoading\"><div layout=\"column\" \nlayout-margin><div layout=\"row\" layout-align=\"none top\" layout-wrap><div layout=\"column\"><div layout=\"row\" \nlayout-align=\"start top\" layout-margin class=\"secondary-text mt-16\"><md-icon md-font-icon=\"icon-cart\" class=\"mr-8\">\n</md-icon><span class=\"md-title\" flex translate=\"PRODUCT.SALE\">Verkauf</span></div><div layout=\"column\" layout-margin>\n<md-input-container class=\"md-block mt-0\" ng-if=\"!attribute.value\"><label translate=\"PRODUCT.BASE_PRICE\">Grundpreis\n</label><md-select ng-model=\"vm.basePriceType\" ng-init=\"vm.basePriceType = \'fixed\'\"><md-option ng-value=\"\'fixed\'\" \ntranslate=\"PRODUCT.FIXED_VALUE\">Fixwert</md-option><md-option ng-disabled=\"true\" ng-value=\"\'material_area\'\" \ntranslate=\"PRODUCT.PRICE_FACE\">Materialpreis (Fläche)</md-option><md-option ng-disabled=\"true\" \nng-value=\"\'material_running\'\" translate=\"PRODUCT.PRICE_RUNNING_METER\">Materialpreis (Laufmeter)</md-option></md-select>\n</md-input-container><md-input-container class=\"mt-10 mb-0\" flex=\"nogrow\"><label translate=\"PRODUCT.BASE_PRICE\">\nGrundpreis</label><input class=\"text-right\" type=\"number\" min=\"0\" step=\"0.0001\" name=\"price\" \nng-model=\"vm.currentProduct.price\" required><md-icon md-font-icon=\"{{vm.config.localization.currency.icon}}\"></md-icon>\n</md-input-container><md-input-container class=\"mt-0 mb-5\" flex=\"nogrow\"><label translate=\"PRODUCT.DELIVERY_PRICE\">\nLieferpreis</label><input class=\"text-right\" type=\"number\" min=\"0\" step=\"0.0001\" name=\"price\" \nng-model=\"vm.currentProduct.deliveryPrice\"><md-icon md-font-icon=\"{{vm.config.localization.currency.icon}}\"></md-icon>\n</md-input-container></div></div><div layout=\"column\"><div layout=\"row\" layout-align=\"start top\" layout-margin \nclass=\"secondary-text mt-16\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"mr-8\"></md-icon><span class=\"md-title\" \nflex translate=\"PRODUCT.SALE_DETAILS\">Details</span></div><div layout=\"column\" layout-align=\"start top\" layout-margin>\n<p translate=\"PRODUCT.UNIT\">Einheit</p><md-radio-group ng-model=\"vm.currentProduct.salesData.unittype\" \nng-change=\"vm.currentProduct.salesData.unit = undefined\"><md-radio-button><span translate=\"PRODUCT.UNIT_PIECES\"></span>\n</md-radio-button><md-radio-button value=\"weight\"><span translate=\"PRODUCT.UNIT_WEIGHT\"></span></md-radio-button>\n<md-radio-button value=\"custom\"><span translate=\"PRODUCT.UNIT_CUSTOM\"></span></md-radio-button></md-radio-group>\n<md-input-container class=\"mt-5 mb-5\" ng-if=\"vm.currentProduct.salesData.unittype === \'custom\'\"><label \ntranslate=\"PRODUCT.UNIT_NAME\">Einheit</label><input type=\"text\" md-maxlength=\"30\" \nng-model=\"vm.currentProduct.salesData.unit\" required></md-input-container></div></div><div layout=\"column\"><div \nlayout=\"row\" layout-align=\"start top\" layout-margin class=\"secondary-text mt-16\"><md-icon \nmd-font-icon=\"icon-clipboard-check\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex \ntranslate=\"PRODUCT.PRICE_PREVIEW\">Preisvorschau</span></div><div layout=\"row\" layout-fill><md-content \nstyle=\"min-width: 250px\" layout=\"column\" layout-align=\"start top\" layout-margin><p translate=\"APP.GENERAL\">Allgemein\n</p><md-input-container class=\"md-block\"><label translate=\"PROFILE.QUANTITY\">Menge</label><input name=\"quantity\" \nclass=\"quantity\" type=\"number\" min=\"1\" max=\"9999\" step=\"1\" ng-model=\"vm.currentProduct.quantity\"></md-input-container>\n<p ng-if=\"vm.currentProduct.attributes.length > 0\" translate=\"PRODUCT.ATTRIBUTES\">Attributes</p><div \nng-repeat=\"attribute in vm.currentProduct.attributes track by attribute.id\"><md-input-container class=\"md-block mv-0\" \nng-if=\"!attribute.value\"><label>{{ attribute.name | nuitTranslate }}</label><input type=\"text\" \nng-model=\"attribute._tempValue\" ng-if=\"attribute.type === \'string\'\" ng-readonly=\"attr.readonly\"> <input type=\"number\" \nng-model=\"attribute._tempValue\" ng-if=\"attribute.type === \'number\'\" min=\"{{attribute.restrictions.min}}\" \nmax=\"{{attribute.restrictions.max}}\"><div class=\"md-char-counter grey-500-fg\" \nng-if=\"attribute.type === \'number\' && attribute.restrictions.min !== undefined && attribute.restrictions.max !== undefined\">\n{{attribute.restrictions.min}}&nbsp;-&nbsp;{{attribute.restrictions.max}}</div><input type=\"number\" \nng-model=\"attribute._tempValue\" ng-if=\"attribute.type === \'length\'\" min=\"{{attribute.restrictions.min}}\" \nmax=\"{{attribute.restrictions.max}}\" nuit-unit-input=\"length\"><div class=\"md-char-counter grey-500-fg\" \nng-if=\"attribute.type === \'length\' && attribute.restrictions.min !== undefined && attribute.restrictions.max !== undefined\">\n{{attribute.restrictions.min | nuitUnit:\'length\'}}&nbsp;-&nbsp;{{attribute.restrictions.max | nuitUnit:\'length\'}}</div>\n<md-select ng-model=\"attribute._tempValue\" ng-if=\"attribute.type === \'enum\'\"><md-option \nng-repeat=\"value in attribute.restrictions.options\" ng-value=\"value\">{{ value}}</md-option></md-select><md-select \nng-model=\"attribute._tempValue\" ng-if=\"attribute.type === \'material\'\"><md-option \nng-repeat=\"material in vm.materials| filter:vm.filterMaterialsForAttribute(attribute) track by material.id\" \nng-value=\"material.id\">{{ material.name | nuitTranslate }}</md-option></md-select><md-select \nng-model=\"attribute._tempValue\" ng-if=\"attribute.type === \'color\'\"><md-option \nng-repeat=\"color in vm.colors| filter:vm.filterColorsForAttribute(attribute) track by color.id\" ng-value=\"color.id\">\n{{ color.name | nuitTranslate }}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-align=\"start top\" ng-if=\"vm.currentProduct.data.profile !== undefined\"><p>Profile</p><md-input-container \nclass=\"md-block mv-0\"><label translate=\"PROFILE.LENGTH\">Länge</label><input name=\"length\" type=\"number\" min=\"0\" \nmax=\"99999\" nuit-unit-input=\"length\" ng-model=\"vm.currentProduct.data.profile._tempLength\"></md-input-container>\n<md-input-container class=\"md-block mv-0\"><label><span translate=\"PRODUCTS.PROFILE_MATERIALS\">Value</span></label>\n<md-select ng-model=\"vm.currentProduct.data.profile._tempMaterialId\"><md-option \nng-repeat=\"material in vm.getProfileTestMaterials() track by material.id\" ng-value=\"material.id\"><span>\n{{ material.name | nuitTranslate }}</span></md-option></md-select></md-input-container></div></md-content><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"m-24 ph-24 pv-10 md-whiteframe-10dp\" layout=\"column\"><h1>\n{{ vm.getProductTestPrice() | nuitCurrency }}</h1></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"none top\" layout-wrap><div layout=\"column\" layout-align=\"start top\" flex=\"noshrink\"><div layout=\"row\" \nlayout-align=\"start top\" layout-margin class=\"secondary-text mt-16\"><md-icon md-font-icon=\"icon-chart-areaspline\" \nclass=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"PRODUCT.ADVANCED_PRICE_CALCULATION\">\nErweiterte Preisberechnung</span></div><div layout=\"column\" layout-margin><table \nclass=\"simple mr-16 md-whiteframe-4dp\"><thead><tr><th class=\"text-center\" translate=\"PRODUCT.SALES_RULE_TYPE\"></th><th \nclass=\"text-center\" translate=\"PRODUCT.SALES_RULE_OPTIONS\"></th><th class=\"text-center\" \ntranslate=\"PRODUCT.SALES_RULE_FACTOR\"></th><th class=\"text-center\" translate=\"PRODUCT.SALES_RULE_LIMIT\"></th><th \nclass=\"text-center\"></th></tr></thead><tbody><tr \nng-class=\"{\'green-100-bg\': vm.lastPriceTest.rules.indexOf(rule) >= 0,\'orange-200-bg\':vm.editedPriceRule === rule}\" \nng-repeat=\"rule in vm.currentProduct.salesData.priceRules\"><td>{{ vm.ruleTypeToKey(rule.type) | translate}}</td><td>\n<div layout=\"row\" layout-align=\"center center\"><span ng-if=\"rule.type === \'attribute\'\">\n{{ vm.getAttributeById(rule.attributeId).name | nuitTranslate}}</span> <span ng-if=\"rule.type === \'combination\'\">\n{{ (vm.getAttributeById(rule.lhAttributeId).name | nuitTranslate) + \', \' + (vm.getAttributeById(rule.rhAttributeId).name | nuitTranslate)}}\n</span> <span ng-if=\"rule.type === \'productdata\'\">{{ vm.getProductPropertyKey(rule.property) | translate}}</span></div>\n</td><td><span>\n{{ rule.priceModifier}}&nbsp;{{ rule.priceModifierValue.toFixed(2) + vm.priceModifierTypeToSymbol(rule.priceModifierType)}}\n</span><br><span style=\"white-space: pre-line\">\n{{ (vm.getComparatorKey(rule) | translate) + \' \' + vm.getRuleConditionDisplayValue(rule)}}<span \nng-if=\"rule.conditionStart !== undefined\">&nbsp;(>= {{ rule.conditionStart}})</span></span></td><td><span \nng-if=\"rule.priceModifierMin !== undefined\">\n{{ rule.priceModifier}}&nbsp;{{ rule.priceModifierMin}}&nbsp;{{ rule.priceModifierType}}</span><br><span \nng-if=\"rule.priceModifierMax !== undefined\">\n{{ rule.priceModifier}}&nbsp;{{ rule.priceModifierMax}}&nbsp;{{ rule.priceModifierType}}</span></td><td><div \nlayout=\"row\"><md-button ng-disabled=\"$first\" class=\"md-icon-button\" ng-click=\"vm.movePriceRule($index, -1)\"><md-icon \nmd-font-icon=\"icon-arrow-up\"></md-icon></md-button><md-button ng-disabled=\"$last\" class=\"md-icon-button\" \nng-click=\"vm.movePriceRule($index, 1)\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.editPriceRule($index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.deletePriceRule($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><div layout=\"row\" layout-align=\"center center\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span translate=\"{{vm.ruleTypeToKey(vm.salesRule.type)}}\"></span>\n<md-icon class=\"grey-300-fg\" ng-if=\"vm.salesRule.type === undefined\" md-font-icon=\"icon-cursor-pointer\"></md-icon>\n</md-button><md-menu-content><md-menu-item ng-repeat=\"ruletype in vm.priceRuleTypes\"><md-button \nng-click=\"vm.salesRule.type = ruletype.value\" \nng-disabled=\"ruletype.disabled !== undefined && ruletype.disabled(vm.currentProduct) === true\"><span \ntranslate=\"{{::ruletype.key}}\"></span></md-button></md-menu-item></md-menu-content></md-menu></div></td><td><ng-include\n src=\"\'app/main/merchandising.products/views/partials/sales/sales_rule_options.html\'\"></ng-include></td><td><ng-include\n src=\"\'app/main/merchandising.products/views/partials/sales/sales_rule_values.html\'\"></ng-include></td><td><ng-include \nsrc=\"\'app/main/merchandising.products/views/partials/sales/sales_rule_limits.html\'\"></ng-include></td><td><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" \nng-if=\"vm.editedPriceRule === undefined\" ng-disabled=\"!vm.isRuleValid()\" ng-click=\"vm.createPriceRule()\"><span \ntranslate=\"APP.ADD\">Hinzufügen</span></md-button><md-button class=\"md-primary md-raised\" \nng-if=\"vm.editedPriceRule !== undefined\" ng-disabled=\"!vm.isRuleValid()\" ng-click=\"vm.createPriceRule()\"><span \ntranslate=\"APP.EDIT\">Bearbeiten</span></md-button><md-button class=\"md-primary md-raised\" \nng-if=\"vm.editedPriceRule !== undefined\" ng-click=\"vm.resetRule()\"><span translate=\"APP.CANCEL\">Abbrechen</span>\n</md-button></div></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"start top\" layout-margin \nclass=\"secondary-text mt-16\" ng-if=\"vm.globalRules.length > 0\"><md-icon md-font-icon=\"icon-earth\" class=\"mr-8\">\n</md-icon><span class=\"md-title\" flex translate=\"SALES.GLOBAL_PRODUCT_RULES\">Globale Regeln</span></div><div \nlayout=\"column\" layout-margin ng-if=\"vm.globalRules.length > 0\"><table style=\"opacity: 0.75\" \nclass=\"simple mr-16 md-whiteframe-4dp\" ng-if=\"vm.globalRules.length > 0\"><thead><tr><th class=\"text-center\" \ntranslate=\"Typ\"></th><th class=\"text-center\" translate=\"Optionen\"></th><th class=\"text-center\" translate=\"Faktor\"></th>\n<th class=\"text-center\" translate=\"Limit\"></th><th class=\"text-center\"></th></tr></thead><tbody><tr \nng-class=\"{\'green-100-bg\': vm.lastPriceTest.rules.indexOf(rule) >= 0,\'orange-200-bg\':vm.editedPriceRule === rule}\" \nng-repeat=\"rule in vm.globalRules\"><td>{{ vm.ruleTypeToKey(rule.type) | translate}}</td><td><div layout=\"row\" \nlayout-align=\"center center\"><span ng-if=\"rule.type === \'attribute\'\">\n{{ vm.getAttributeById(rule.attributeId).name | nuitTranslate}}</span> <span ng-if=\"rule.type === \'combination\'\">\n{{ (vm.getAttributeById(rule.lhAttributeId).name | nuitTranslate) + \', \' + (vm.getAttributeById(rule.rhAttributeId).name | nuitTranslate)}}\n</span> <span ng-if=\"rule.type === \'productdata\'\">{{ vm.getProductPropertyKey(rule.property) | translate}}</span></div>\n</td><td><span>\n{{ rule.priceModifier}}&nbsp;{{ rule.priceModifierValue.toFixed(2) + vm.priceModifierTypeToSymbol(rule.priceModifierType)}}\n</span><br><span style=\"white-space: pre-line\">\n{{ (vm.getComparatorKey(rule) | translate) + \' \' + vm.getRuleConditionDisplayValue(rule)}}<span \nng-if=\"rule.conditionStart !== undefined\">&nbsp;(>= {{ rule.conditionStart}})</span></span></td><td><span \nng-if=\"rule.priceModifierMin !== undefined\">\n{{ rule.priceModifier}}&nbsp;{{ rule.priceModifierMin}}&nbsp;{{ rule.priceModifierType}}</span><br><span \nng-if=\"rule.priceModifierMax !== undefined\">\n{{ rule.priceModifier}}&nbsp;{{ rule.priceModifierMax}}&nbsp;{{ rule.priceModifierType}}</span></td><td></td></tr>\n</tbody></table></div><div layout=\"row\" layout-align=\"start top\" layout-margin class=\"secondary-text mt-16\" \nng-if=\"vm.config.ims.companies.enabled\"><md-icon md-font-icon=\"icon-crosshairs-gps\" class=\"mr-8\"></md-icon><span \nclass=\"md-title\" flex translate=\"SALES.RESTRICTIONS\">Globale Regeln</span></div><div \nng-if=\"vm.config.ims.companies.enabled\" class=\"mb-100 mt-0\"><div class=\"m-10 mt-0 ml-16\"><h2 class=\"mt-0\" \ntranslate=\"PARTNERS.COMPANIES_NAV\"></h2></div><div layout=\"column\" layout-margin><table style=\"opacity: 0.75\" \nclass=\"simple mr-16 md-whiteframe-4dp mb-100\"><thead><tr><th class=\"text-center\" translate=\"COMPANY.NAME\"></th><th \nstyle=\"width: 120px !important\"></th></tr></thead><tbody><tr ng-repeat=\"company in vm.selectedCompanies\"><td \nclass=\"text-center\">{{company.name}}</td><td class=\"text-center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.removeCompany($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr><tr><td>\n<md-select ng-model=\"vm.currentCompanyId\" md-on-open=\"vm.reloadCompanies()\" placeholder=\"{{\'APP.SEARCH\' | translate}}\" \nflex><md-select-header class=\"select-header p-10\"><div layout=\"row\" layout-align=\"center center\" flex><input flex \nid=\"search\" ng-model=\"vm.searchText\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"{{\'APP.SEARCH\' | translate}}\"><md-button class=\"md-icon-button\"><md-icon \nng-show=\"vm.searchText && vm.searchText.length>0\" md-font-icon=\"icon-close\" ng-click=\"vm.searchText=\'\';\"></md-icon>\n</md-button></div></md-select-header><div layout=\"row\" layout-align=\"center center\" layout-margin><span \nng-if=\"vm.companiesLoaded && vm.companies.length===0\" translate=\"APP.EMPTY\"></span><md-progress-circular \nclass=\"md-accent\" md-diameter=\"16\" ng-if=\"!vm.companiesLoaded\"></md-progress-circular></div><md-option \nng-value=\"company.id\" \nng-repeat=\"company in vm.companies | filter:{name: vm.searchText} | orderBy:\'name\' | limitTo:100\">{{company.name}}\n</md-option></md-select></td><td class=\"text-center\"><md-button ng-click=\"vm.selectCompany()\" \nclass=\"md-accent md-raised\" ng-disabled=\"!vm.currentCompanyId\" flex><label translate=\"APP.ADD\"></label></md-button>\n</td></tr></tbody></table></div></div></div></div></div></md-content></md-content>");
$templateCache.put("app/main/merchandising.products.attributes/dialogs/edit-attribute/edit-attribute.html","<md-dialog aria-label=\"New Color\" id=\"system-color-dialog\"><form name=\"attributeForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-if=\"!vm.newAttribute\" translate=\"APP.EDIT\">Edit</span> <span\n class=\"title\" ng-if=\"vm.newAttribute\" translate=\"PRODUCTS.ADD_ATTRIBUTE\">Neues Attribut</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\"><div layout=\"row\"><md-input-container flex=\"85\"><label \ntranslate=\"CART.FIELD.NAME\">Bezeichnung</label><input type=\"text\" name=\"name\" \nng-model=\"vm.attribute.name[vm.currentLanguage]\" md-maxlength=\"100\" required><div ng-messages=\"fieldForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div>\n</md-input-container><md-input-container flex=\"15\"><label translate=\"APP.LANGUAGE\">Lang</label><md-select \nng-model=\"vm.currentLanguage\"><md-option ng-repeat=\"lang in vm.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">\n{{lang}}</span></md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\">\n<label translate=\"ATTRIBUTE.TYPE\">Type</label><md-select ng-model=\"vm.attribute.type\" \nng-disabled=\"vm.attribute.id !== undefined\"><md-option ng-value=\"\'string\'\" translate=\"APP.STRING\">Text</md-option>\n<md-option ng-value=\"\'number\'\" translate=\"APP.NUMBER\">Nummer</md-option><md-option ng-value=\"\'enum\'\" \ntranslate=\"APP.ENUM\">Auswahl</md-option><md-option ng-value=\"\'material\'\" translate=\"APP.MATERIAL\">Material</md-option>\n<md-option ng-value=\"\'color\'\" translate=\"APP.COLOR\">Farbe</md-option><md-option ng-value=\"\'length\'\" \ntranslate=\"APP.LENGTH\">Länge</md-option></md-select></md-input-container></div><div layout=\"row\" \nng-if=\"vm.attribute.type === \'string\'\"><md-input-container flex=\"40\"><label translate=\"ATTRIBUTE.FIELD.REGEX\">Regex\n</label><input type=\"text\" name=\"regex\" ng-model=\"vm.attribute.restrictions.regex\" md-maxlength=\"24\">\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.attribute.type === \'number\'\"><md-input-container flex=\"30\">\n<label translate=\"ATTRIBUTE.MIN\">Min. length</label><input type=\"number\" min=\"0\" max=\"99999\" name=\"minlength\" \nng-model=\"vm.attribute.restrictions.min\"></md-input-container><md-input-container flex-offset=\"5\" flex=\"30\"><label \ntranslate=\"ATTRIBUTE.MAX\">Max. Length</label><input type=\"number\" min=\"0\" max=\"99999\" name=\"maxlength\" \nng-model=\"vm.attribute.restrictions.max\"></md-input-container><md-input-container flex-offset=\"5\" flex=\"30\"><label \ntranslate=\"ATTRIBUTE.UNIT\">Einheit</label><input type=\"text\" name=\"unit\" ng-model=\"vm.attribute.restrictions.unit\">\n</md-input-container></div><div layout=\"column\" ng-if=\"vm.attribute.type === \'length\'\"><div layout=\"row\">\n<md-input-container flex=\"30\"><label><span translate=\"ATTRIBUTE.MIN\">Min. length</span>&nbsp;<span>\n({{vm.config.units.length.symbol}})</span></label><input type=\"number\" min=\"0\" max=\"99999\" name=\"minlength\" \nnuit-unit-input=\"length\" ng-model=\"vm.attribute.restrictions.min\"></md-input-container><md-input-container \nflex-offset=\"5\" flex=\"30\"><label><span translate=\"ATTRIBUTE.MAX\">Max. Length</span>&nbsp;<span>\n({{vm.config.units.length.symbol}})</span></label><input type=\"number\" min=\"0\" max=\"99999\" name=\"maxlength\" \nnuit-unit-input=\"length\" ng-model=\"vm.attribute.restrictions.max\"></md-input-container></div><md-input-container>\n<md-checkbox ng-model=\"vm.attribute.restrictions.usesPositions\" aria-label=\"Positions\" class=\"md-warn\">\n{{ \'ATTRIBUTE.USES_POSITIONS\' | translate }}</md-checkbox></md-input-container></div><div layout=\"row\" \nng-if=\"vm.attribute.type === \'enum\'\" flex><md-chips style=\"width: 100%\" ng-model=\"vm.attribute.restrictions.options\" \nplaceholder=\"{{ \'ATTRIBUTE.ENUM_HINT\' | translate }}\" md-removable=\"true\"></md-chips></div><div layout=\"row\" \nng-if=\"vm.attribute.type === \'material\'\"><ng-include layout-fill \nsrc=\"\'app/main/merchandising.products.attributes/dialogs/edit-attribute/partials/material.html\'\"></ng-include></div>\n<div layout=\"row\" ng-if=\"vm.attribute.type === \'color\'\"><ng-include layout-fill \nsrc=\"\'app/main/merchandising.products.attributes/dialogs/edit-attribute/partials/color.html\'\"></ng-include></div><div \nlayout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.attribute.restrictions.header\" aria-label=\"Header\">\n{{ \'ATTRIBUTE.DISPLAY_IN_HEADER\' | translate }}</md-checkbox></md-input-container></div><div layout=\"row\">\n<md-input-container><md-checkbox ng-model=\"vm.attribute.restrictions.hidden\" aria-label=\"Hidden\" class=\"md-warn\">\n{{ \'ATTRIBUTE.HIDDEN\' | translate }}</md-checkbox></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n</div><div layout=\"row\"><md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel\n</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"attributeForm.$invalid\"><span \ntranslate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/merchandising.products.tags/dialogs/edit-tag/edit-tag.html","<md-dialog id=\"edit-tag\"><form ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"PRODUCTS.TAGS.ADD\">Tag hinzufügen</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"pb-0\" ms-scroll \nstyle=\"position:relative\"><div class=\"md-dialog-content\"><div layout=\"column\"><div layout=\"row\" \nng-repeat=\"lang in vm.languages\"><md-input-container flex class=\"m-0\"><label class=\"w-100 text-uppercase\">{{ lang }}\n</label><input type=\"text\" name=\"name[{{lang}}]\" ng-model=\"vm.tag.name[lang]\" ng-required=\"lang === vm.currLang\">\n</md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Abbrechen</span></md-button><md-button \nng-click=\"vm.save()\" class=\"md-accent md-raised\" ng-disabled=\"tagForm.$invalid\"><span translate=\"APP.SAVE\">Speichern\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/main/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img src=\"assets/icons/icon-32x32.png\">\n</span><span class=\"logo-text\">{{::vm.applicationName || \'IMS\' }}</span></div><md-icon class=\"fold-toggle s18\" \nmd-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar>\n<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/orders.accounting/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.accounting\" default-name=\"ACCOUNTING_SETTINGS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/orders.accounting/views/partials/invoice-details.html","<div id=\"invoicedetail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div>\n<div class=\"content-card\" layout=\"column\" flex><form name=\"vm.invoiceDetailForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"{{vm.origin}}\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span \nclass=\"md-title\">{{vm.invoice.number}}</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.updateInvoice()\" \nng-disabled=\"!vm.invoiceDetailForm.$valid || !vm.invoiceDetailForm.$dirty\" translate=\"APP.SAVE\">Speichern</md-button>\n</div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content layout=\"column\" class=\"grey-100-bg\" \nlayout-fill flex ms-scroll><div class=\"content\" ng-if=\"vm.loading\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><div layout=\"row\" layout-align=\"start\" ng-if=\"!vm.loading\"><div layout=\"column\" \nlayout-align=\"start\" flex=\"35\"><div layout=\"column\" class=\"md-whiteframe-1dp white-bg mt-10 ml-10 p-20\" \nflex=\"noshrink\"><div layout=\"column\"><div class=\"mb-20\" layout=\"row\" layout-align=\"start end\"><md-icon \nclass=\"ml-0 mr-10\" md-font-icon=\"icon-information-outline\"></md-icon><span translate=\"APP.INFO\">Info</span></div><div \nlayout=\"column\" layout-align=\"start start\"><div layout=\"row\"><span class=\"pt-8\" translate=\"INVOICE.STATUS\">Status\n</span> <span class=\"pr-10 pt-8\">:</span><md-input-container class=\"mv-0 mh-5\"><md-select ng-model=\"vm.invoice.status\">\n<md-option ng-repeat=\"status in vm.statis track by status.id\" ng-value=\"status.id\" \nng-click=\"vm.statusUpdate(\'status\', status.id)\" \nng-if=\"vm.config.ims.accounting.disabledStatis.indexOf(status.id)===-1 \">\n{{(\"INVOICE.STATUS_\" + status.type | uppercase) | translate}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" class=\"mt-20\"><span translate=\"INVOICE.NUMBER\">Invoice Number </span><span class=\"pr-10\">: </span><span>\n{{vm.invoice.number }}</span></div><div layout=\"column\" layout-align=\"end\" class=\"pdf pt-10\"><a \nng-if=\"!vm.documentStatus.error\" \nng-repeat=\"docObj in vm.invoice.documents | languageFilter:\'lang\' | orderByTranslated:\'name\' track by $index\" \nstyle=\"white-space: nowrap\" class=\"message mr-5\" ng-href=\"{{vm.getDocumentURL(docObj)}}\" target=\"_blank\" \nng-click=\"$event.stopPropagation();\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><span>{{docObj.name | translate}}\n</span></a></div><div class=\"mt-20\"><span translate=\"DOCUMENTS.ORDERS\">Order</span>:<div \nng-repeat=\"order in vm.orders\"><md-button ng-click=\"vm.openOrder(order.id)\" class=\"m-0 p-0 md-accent text-left\"><span>\n{{vm.config.ims.accounting.orderNameFormat | nuitFormatter: order}}</span></md-button></div></div><div layout=\"column\" \nclass=\"mt-20\" ng-if=\"vm.config.ims.credit\"><div layout=\"row\"><span translate=\"CREDIT.CREDITS\">Order</span>:</div><div \nng-repeat=\"credit in vm.credits\"><md-button ng-click=\"vm.openCredit(credit.id)\" class=\"m-0 p-0 md-accent text-left\">\n<span>{{credit.number}}</span></md-button></div><md-button ng-click=\"vm.openCredit(null)\" class=\"mt-15 mh-0 md-raised\">\n<span translate=\"CREDIT.ADD_CREDIT\"></span></md-button></div></div></div></div><div layout=\"column\" \nclass=\"white-bg md-whiteframe-1dp mv-10 ml-10 p-20\" flex=\"noshrink\"><div class=\"pb-20\"><md-icon class=\"ml-0 mr-10\" \nmd-font-icon=\"icon-cash-multiple\"></md-icon><span translate=\"ORDERS.SALES\"></span></div><div layout=\"row\" \nlayout-align=\"spacebetween\" ng-if=\"vm.orders.length === 1\"><div layout=\"column\" flex><div \nng-if=\"vm.showSalesPosition(\'basePrice\',vm.orders[0])\" flex-order=\"{{vm.getSalesPosition(\'basePrice\')}}\" class=\"pr-10\" \ntranslate=\"CART.BASE_PRICE\">baseprice</div><div flex-order=\"{{vm.getSalesPosition(\'globalDiscount\')}}\" \nng-if=\"vm.invoice.orders[0].sales.discounts.globalDiscount>0 && vm.showSalesPosition(\'globalDiscount\',vm.orders[0])\">\n<div layout=\"row\"><span class=\"pr-10\" translate=\"CART.GLOBAL_DISCOUNT\">global Discount</span>\n ({{vm.invoice.orders[0].sales.discounts.globalDiscount + \"%\"}})</div><md-divider></md-divider><span class=\"pr-10\" \ntranslate=\"CART.PRICE_GLOBAL_DISCOUNT\">Summe</span></div><div flex-order=\"{{vm.getSalesPosition(\'onlineDiscount\')}}\" \nng-if=\"vm.invoice.orders[0].sales.discounts.applyOnlineDiscount && vm.showSalesPosition(\'onlineDiscount\',vm.orders[0])\">\n<div layout=\"row\"><span class=\"pr-10\" translate=\"CART.ONLINE_DISCOUNT\">onlineDiscount</span>\n ({{vm.invoice.orders[0].sales.discounts.onlineDiscount + \"%\"}})</div><md-divider></md-divider><span class=\"pr-10\" \ntranslate=\"CART.PRICE_ONLINE_DISCOUNT\">Summe</span></div><div flex-order=\"{{vm.getSalesPosition(\'minPrice\', 1)}}\" \nng-if=\"vm.invoice.orders[0].sales.minPriceDifference>0 && vm.showSalesPosition(\'minPrice\',vm.orders[0])\"><span \nclass=\"pr-10\" translate=\"ORDERS.SALES.MINPRICEDIFFERENCE\">Preisaufschlag</span><md-divider></md-divider></div><div \nflex-order=\"{{vm.getSalesPosition(\'minPrice\', 2)}}\" ng-if=\"vm.showSalesPosition(\'minPrice\',vm.orders[0])\" \nclass=\"pr-10\" translate=\"ORDERS.SALES.PRICE\">price</div><div flex-order=\"{{vm.getSalesPosition(\'logisticPrice\')}}\" \nclass=\"pr-10\" ng-if=\"vm.showSalesPosition(\'logisticPrice\',vm.orders[0])\" translate=\"ORDERS.SALES.LOGISTICPRICE\">\nGross Price</div><div flex-order=\"{{vm.getSalesPosition(\'orderFee\')}}\" \nng-if=\"vm.showSalesPosition(\'orderFee\',vm.orders[0])\" class=\"pr-10\" translate=\"ORDERS.SALES.ORDERFEE\">Gross Price</div>\n<md-divider flex-order=\"{{vm.getSalesPosition(\'netPrice\', 1)}}\" ng-if=\"vm.showSalesPosition(\'netPrice\',vm.orders[0])\">\n</md-divider><div flex-order=\"{{vm.getSalesPosition(\'netPrice\', 2)}}\" \nng-if=\"vm.showSalesPosition(\'netPrice\',vm.orders[0])\" class=\"pr-10\" translate=\"ORDERS.SALES.NETPRICE\">Gross Price</div>\n<div layout=\"row\" flex-order=\"{{vm.getSalesPosition(\'taxes\')}}\" ng-if=\"vm.showSalesPosition(\'taxes\',vm.orders[0])\">\n<span class=\"pr-10\" translate=\"ORDERS.SALES.TAXES\">Gross Price </span>({{vm.invoice.vatPercents[0] + \"%\"}})</div>\n<md-divider ng-if=\"vm.showSalesPosition(\'grossPrice\',vm.orders[0])\" \nflex-order=\"{{vm.getSalesPosition(\'grossPrice\', 1)}}\"></md-divider><div \nng-if=\"vm.showSalesPosition(\'grossPrice\',vm.orders[0])\" flex-order=\"{{vm.getSalesPosition(\'grossPrice\', 2)}}\" \nclass=\"pr-10\" translate=\"ORDERS.SALES.GROSSPRICE\">Gross Price</div></div><div layout=\"column\" class=\"text-right\"><div \nng-if=\"vm.showSalesPosition(\'basePrice\',vm.orders[0])\" flex-order=\"{{vm.getSalesPosition(\'basePrice\')}}\">\n{{vm.invoice.orders[0].sales.basePrice | nuitCurrency }}</div><div \nflex-order=\"{{vm.getSalesPosition(\'globalDiscount\')}}\" \nng-if=\"vm.invoice.orders[0].sales.discounts.globalDiscount>0 && vm.showSalesPosition(\'globalDiscount\',vm.orders[0])\">- \n<span>{{vm.invoice.orders[0].sales.globalDiscount | nuitCurrency }}</span><md-divider></md-divider><span>\n{{vm.invoice.orders[0].sales.priceGlobalDiscount | nuitCurrency }}</span></div><div \nflex-order=\"{{vm.getSalesPosition(\'onlineDiscount\')}}\" \nng-if=\"vm.invoice.orders[0].sales.discounts.applyOnlineDiscount && vm.showSalesPosition(\'onlineDiscount\',vm.orders[0])\">\n- <span>{{vm.invoice.orders[0].sales.onlineDiscount | nuitCurrency }}</span><md-divider></md-divider><span>\n{{vm.invoice.orders[0].sales.priceOnlineDiscount | nuitCurrency }}</span></div><div \nflex-order=\"{{vm.getSalesPosition(\'minPrice\', 1)}}\" \nng-if=\"vm.invoice.orders[0].sales.minPriceDifference>0 && vm.showSalesPosition(\'minPrice\',vm.orders[0])\"><span>\n{{vm.invoice.orders[0].sales.minPriceDifference | nuitCurrency }}</span><md-divider></md-divider></div><div \nflex-order=\"{{vm.getSalesPosition(\'minPrice\', 2)}}\" ng-if=\"vm.showSalesPosition(\'minPrice\',vm.orders[0])\">\n{{vm.invoice.sumPrice | nuitCurrency }}</div><div flex-order=\"{{vm.getSalesPosition(\'logisticPrice\')}}\" \nng-if=\"vm.showSalesPosition(\'logisticPrice\',vm.orders[0])\">{{vm.invoice.sumLogisticPrice | nuitCurrency}}</div><div \nflex-order=\"{{vm.getSalesPosition(\'orderFee\')}}\" ng-if=\"vm.showSalesPosition(\'orderFee\',vm.orders[0])\">\n{{vm.invoice.sumOrderFee| nuitCurrency}}</div><md-divider flex-order=\"{{vm.getSalesPosition(\'netPrice\', 1)}}\" \nng-if=\"vm.showSalesPosition(\'netPrice\',vm.orders[0])\"></md-divider><div \nflex-order=\"{{vm.getSalesPosition(\'netPrice\', 2)}}\" ng-if=\"vm.showSalesPosition(\'netPrice\',vm.orders[0])\">\n{{vm.invoice.sumNetPrice | nuitCurrency}}</div><div flex-order=\"{{vm.getSalesPosition(\'taxes\')}}\" \nng-if=\"vm.showSalesPosition(\'taxes\',vm.orders[0])\">{{vm.invoice.sumTaxes | nuitCurrency}}</div><md-divider \nflex-order=\"{{vm.getSalesPosition(\'grossPrice\', 1)}}\" ng-if=\"vm.showSalesPosition(\'grossPrice\',vm.orders[0])\">\n</md-divider><div flex-order=\"{{vm.getSalesPosition(\'grossPrice\', 2)}}\" \nng-if=\"vm.showSalesPosition(\'grossPrice\',vm.orders[0])\">{{vm.invoice.sumGrossPrice | nuitCurrency}}</div></div></div>\n<div ng-if=\"vm.orders.length > 1\" layout-wrap><div layout=\"row\" layout-align=\"space-between\"><span \ntranslate=\"PROFILE.TOTAL_PRICE\"></span> <span>{{vm.invoice.sumGrossPrice | nuitCurrency}}</span></div><md-divider \nclass=\"mb-15\"></md-divider><span translate=\"INVOICE.DETAILS_PRICE.DETAILSINFO\"></span></div></div><div layout=\"column\" \nclass=\"md-whiteframe-1dp white-bg mb-10 ml-10\" flex=\"noshrink\"><div class=\"m-20\" layout=\"column\"><div class=\"mh-8\" \nlayout=\"row\" layout-align=\"space-between start\"><div layout=\"row\" layout-align=\"start end\"><md-icon class=\"ml-0 mr-10\" \nmd-font-icon=\"icon-domain\"></md-icon><span translate=\"INVOICE.COMPANY\">company</span></div><md-icon-button \nng-if=\"vm.showCompanyButton\" style=\"cursor: pointer\" class=\"m-0 p-0\" ng-click=\"vm.openCompany(vm.invoice.company.id)\">\n<md-icon class=\"m-0\" md-font-icon=\"icon-open-in-new\"></md-icon><md-tooltip><span translate=\"COMPANY.DATA\"></span>\n</md-tooltip></md-icon-button></div><div layout=\"column\" layout-align=\"start\" class=\"mv-20 mh-8\"><span class=\"pb-10\">\n{{vm.invoice.company.name }}</span><div ng-if=\"vm.companyConfig.address\" \nng-repeat=\"address in vm.invoice.company.addresses\" layout=\"column\" layout-align=\"start\"><span>{{address.street}}\n</span> <span>{{address.countryCode}}-{{address.zipCode}} {{address.city}}</span></div><md-divider class=\"mv-5\">\n</md-divider><div><div layout=\"row\" ng-if=\"vm.companyConfig.iban\"><span translate=\"COMPANY.IBAN\">IBAN</span> <span>\n: {{vm.invoice.company.iban}}</span></div><div layout=\"row\" ng-if=\"vm.companyConfig.bic\"><span translate=\"COMPANY.BIC\">\nBIC</span> <span>: {{vm.invoice.company.bic}}</span></div><div layout=\"row\" ng-if=\"vm.companyConfig.customerId\"><span \ntranslate=\"COMPANY.CUSTOMER_ID\">Coustomer ID</span> <span>: {{vm.invoice.company.customerId}}</span></div><div \nlayout=\"row\" ng-if=\"vm.companyConfig.taxId\"><span translate=\"COMPANY.TAX_ID\">Tax ID</span> <span>\n: {{vm.invoice.company.taxId}}</span></div></div></div></div></div></div><div layout=\"column\" flex=\"65\"><div \nlayout=\"column\" class=\"white-bg md-whiteframe-1dp m-10\"><div><div class=\"p-20\"><md-icon class=\"ml-0 mr-10\" \nmd-font-icon=\"icon-calendar-multiple\"></md-icon><span translate=\"APP.DATES\"></span></div></div><div layout=\"row\"><div \nclass=\"p-20\" layout=\"column\" style=\"min-width: 220px\"><div layout=\"row\" class=\"mh-8\"><span \ntranslate=\"INVOICE.CREATED_AT\">Start</span></div><div layout=\"row\" layout-align=\"start center\" class=\"mv-20 mh-8\">\n<md-icon class=\"ml-0 mr-10\" md-font-icon=\"icon-calendar\"></md-icon><span>{{vm.invoice.createdAt| nuitDatetime: \'date\'}}\n</span></div></div><div class=\"p-20\" layout=\"column\"><div class=\"mh-8 mb-10\"><span translate=\"INVOICE.DUE_DATE\">\nDue Date</span></div><md-datepicker ng-model=\"vm.invoice.dueDate\" md-date-filter=\"vm.selectableDays\" \nmd-placeholder=\"{{\'APP.SELECT\' | translate}}\" required name=\"dateDue\"></md-datepicker><div class=\"red-fg mh-8\" \nng-messages=\"vm.invoiceDetailForm.dateDue.$error\"><div ng-message=\"required\" \ntranslate=\"APP.INVOICE_NUMBER.REQUIRED_DATE\">This date is required!</div><div ng-message=\"filtered\" \ntranslate=\"INVOICE.DATE_NOT_WORKDAY\">This date is not a Workday!</div><div ng-message=\"valid\" \ntranslate=\"INVOICE.DATE_NOT_VALID\">This date is required!</div></div></div></div><div layout=\"row\"><div class=\"p-20\" \nlayout=\"column\" style=\"min-width: 220px\"><div class=\"mh-8 mb-10\"><span translate=\"INVOICE.DISCOUNT_DATE\">Discount Date\n</span></div><md-datepicker ng-model=\"vm.invoice.discountDate\" md-date-filter=\"vm.selectableDays\" \nmd-placeholder=\"{{\'APP.SELECT\' | translate}}\" name=\"dateDisc\" required></md-datepicker><div class=\"red-fg mh-8\" \nng-messages=\"vm.invoiceDetailForm.dateDisc.$error\"><div ng-message=\"required\" \ntranslate=\"APP.INVOICE_NUMBER.REQUIRED_DATE\">This date is required!</div><div ng-message=\"filtered\" \ntranslate=\"INVOICE.DATE_NOT_WORKDAY\">This date is not a Workday!</div><div ng-message=\"valid\" \ntranslate=\"INVOICE.DATE_NOT_VALID\">This date is required!</div></div></div><div layout=\"column\" class=\"m-20\"><div \nclass=\"mh-8\"><span translate=\"INVOICE.CASH_DISCOUNT_DAYS_DEFAULT\">Discount Days</span></div><div class=\"mh-8 mv-20\">\n<span>{{vm.invoice.company.cashDiscountDays}} </span><span ng-if=\"vm.invoice.company.cashDiscountDays !== 1\" \ntranslate=\"TIME.DAYS\"></span> <span ng-if=\"vm.invoice.company.cashDiscountDays === 1\" translate=\"CALENDAR.DAY\"></span>\n</div></div></div><div layout=\"row\"><div class=\"p-20\" layout=\"column\" style=\"min-width: 220px\"><div class=\"mh-8\"><span \ntranslate=\"INVOICE.UPDATED_DATE\">updated Date</span></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"mv-20 mh-8\"><md-icon class=\"ml-0 mr-10\" md-font-icon=\"icon-calendar\"></md-icon><span \nng-if=\"vm.invoice.updatedAt\">{{vm.invoice.updatedAt | nuitDatetime: \'date\'}}</span></div></div><div class=\"p-20\" \nlayout=\"column\"><div class=\"mh-8 mb-10\"><span translate=\"INVOICE.PAID_AT\">Paid At</span></div><md-datepicker \nng-model=\"vm.invoice.paidAt\" md-date-filter=\"vm.selectableDays\" ng-change=\"vm.statusUpdate(\'date\')\" \nng-required=\"vm.invoice.status === 3\" md-placeholder=\"{{\'APP.SELECT\' | translate}}\" name=\"dateField\"></md-datepicker>\n<div class=\"red-fg mh-8\" ng-messages=\"vm.invoiceDetailForm.dateField.$error\"><div ng-message=\"filtered\" \ntranslate=\"INVOICE.DATE_NOT_WORKDAY\">This date is not a Workday!</div><div ng-message=\"valid\" \ntranslate=\"INVOICE.DATE_NOT_VALID\">This date is required!</div><div ng-message=\"required\" \ntranslate=\"APP.INVOICE_NUMBER.REQUIRED_DATE\">This date is required!</div></div></div></div></div><div layout=\"column\" \nclass=\"white-bg md-whiteframe-1dp mh-10 mb-10\" flex=\"noshrink\"><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"p-20\"><md-icon class=\"ml-0 mr-10\" md-font-icon=\"icon-history\"></md-icon><span translate=\"INVOICE.REMARK\"></span>\n</div><div class=\"p-10\"><md-button ng-click=\"vm.addRemark()\" class=\"md-accent\"><span translate=\"INVOICE.REMARK_ADD\">\n</span></md-button></div></div><md-divider class=\"mh-20\"></md-divider><div class=\"p-20\" layout=\"column\"><div \nng-repeat=\"remark in vm.remarks\" class=\"remarks ph-5\" ng-class=\"{\'grey-A200-bg\': $odd}\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><div flex=\"noshrink\"><span>\n{{remark.createdAt | nuitDatetime : \'date\'}} -</span></div><div layout=\"row\" layout-wrap><span class=\"pl-5\" \ntranslate=\"{{vm.getTypeForRemark(remark.type)}}\"></span><div ng-if=\"remark.type === 6\"><span>: </span><span \nclass=\"pl-10\" translate=\"{{vm.getStatusForRemark(remark.customData.status)}}\"></span></div><div \nng-if=\"remark.remark !== \'\'\" class=\"pl-10\"><span class=\"pr-10\">-</span>{{remark.remark}}</div></div></div><div>\n<md-button ng-if=\"remark.remark === \'\'\" class=\"md-icon-button\" ng-click=\"vm.updateRemark(remark.id)\" \nstyle=\"padding: 0 !important; margin: 0 !important; height: auto !important\"><md-icon \nmd-font-icon=\"icon-comment-plus-outline\"></md-icon><md-tooltip><span translate=\"INVOICE.REMARK_ADD_COMMENT\"></span>\n</md-tooltip></md-button><md-button ng-if=\"remark.remark !== \'\'\" class=\"md-icon-button\" \nng-click=\"vm.updateRemark(remark.id)\" style=\"padding: 0 !important; margin: 0 !important; height: auto !important\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"INVOICE.REMARK_UPDATE\"></span></md-tooltip>\n</md-button></div></div></div></div></div></div></div></md-content></div></form></div></div></div>");
$templateCache.put("app/main/orders.credit/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.credit\" default-name=\"CREDIT_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/orders.credit/views/partials/credit-details.html","<div id=\"invoicedetail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div>\n<div class=\"content-card\" layout=\"column\" flex><form name=\"vm.creditDetailForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"{{vm.origin}}\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\"><div class=\"divider-vertical mr-20\"></div><span \nclass=\"md-title\" ng-if=\"vm.credit.number\">{{vm.credit.number}}</span> <span class=\"md-title\" ng-if=\"!vm.credit.number\" \ntranslate=\"CREDIT.NEW\"></span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.updateCredit()\" \nng-disabled=\"!vm.creditDetailForm.$valid || !vm.creditDetailForm.$dirty\" translate=\"APP.SAVE\">Speichern</md-button>\n</div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content layout=\"column\" class=\"grey-100-bg\" \nlayout-fill flex ms-scroll><div class=\"content\" ng-if=\"vm.loading\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><div layout=\"row\" layout-align=\"start\" ng-if=\"!vm.loading\"><div layout=\"column\" \nlayout-align=\"start\" flex=\"35\"><div class=\"md-whiteframe-1dp white-bg mt-10 mb-10 ml-10 p-20\" layout=\"column\"><div \nlayout=\"row\" layout-align=\"start end\"><md-icon class=\"ml-0 mr-10\" md-font-icon=\"icon-information-outline\"></md-icon>\n<span translate=\"APP.INFO\">Info</span></div><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nng-if=\"vm.credit.status\"><span class=\"pt-8\" translate=\"INVOICE.STATUS\">Status</span> <span class=\"pr-10 pt-8\">:</span>\n<md-input-container class=\"mv-0 mh-5\"><md-select ng-model=\"vm.credit.status\"><md-option \nng-repeat=\"status in vm.allStatus track by status.id\" ng-value=\"status.id\" \nng-click=\"vm.statusUpdate(\'status\', status.id)\" \nng-if=\"vm.config.ims.accounting.disabledStatis.indexOf(status.id)===-1 \">\n{{(\"CREDIT.STATUS_\" + status.type | uppercase) | translate}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" class=\"mt-20\" ng-if=\"vm.credit.number\"><span translate=\"CREDIT.NUMBER\">Invoice Number </span><span \nclass=\"pr-10\">: </span><span>{{vm.credit.number }}</span></div><div layout=\"column\" layout-align=\"end\" \nclass=\"pdf pt-10\" ng-if=\"vm.credit.documents\"><a ng-if=\"!vm.documentStatus.error\" \nng-repeat=\"docObj in vm.credit.documents | languageFilter:\'lang\' | orderByTranslated:\'name\' track by $index\" \nstyle=\"white-space: nowrap\" class=\"message mr-5\" ng-href=\"{{vm.getDocumentURL(docObj)}}\" target=\"_blank\" \nng-click=\"$event.stopPropagation();\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><span>{{docObj.name | translate}}\n</span></a></div><div layout=\"row\" class=\"mt-20\" ng-if=\"vm.credit.createdAt\"><span translate=\"INVOICE.CREATED_AT\">\ncreated at date </span><span class=\"pr-10\">: </span><span>{{vm.credit.createdAt | nuitDatetime: \'date\' }}</span></div>\n<div layout=\"row\" class=\"mt-10\" ng-if=\"vm.credit.invoiceId\"><span translate=\"CREDIT.INVOICE_NUMBER\">Invoice Number \n</span><span class=\"pr-10\">: </span><span>{{vm.invoiceNumber }}</span></div></div></div><div layout=\"column\" \nclass=\"md-whiteframe-1dp white-bg mb-10 ml-10\" flex=\"noshrink\"><div class=\"m-20\" layout=\"column\"><div class=\"mh-8\" \nlayout=\"row\" layout-align=\"space-between start\"><div layout=\"row\" layout-align=\"start end\"><md-icon class=\"ml-0 mr-10\" \nmd-font-icon=\"icon-domain\"></md-icon><span translate=\"INVOICE.COMPANY\">company</span></div></div><div layout=\"column\" \nlayout-align=\"start\" class=\"mv-20 mh-8\"><span class=\"pb-10\">{{vm.company.name }}</span><div \nng-repeat=\"address in vm.company.addresses\" layout=\"column\" layout-align=\"start\" \nng-if=\"address.id === vm.company.addressId\"><span>{{address.street}}</span> <span>\n{{address.countryCode}}-{{address.zipCode}} {{address.city}}</span></div></div></div></div></div><div layout=\"column\" \nflex=\"65\"><div layout=\"column\" class=\"white-bg md-whiteframe-1dp m-10\"><div layout=\"row\" layout-align=\"space-between\">\n<div layout=\"column\" flex=\"70\"><div class=\"p-20\"><md-icon class=\"ml-0 mr-10\" md-font-icon=\"icon-calendar-multiple\">\n</md-icon><span translate=\"APP.DETAILS\"></span></div><div class=\"ph-20\" flex><md-input-container style=\"width: 100%\">\n<label translate=\"CREDIT.REMARK\">Credit Remark</label><input ng-disabled=\"!vm.updateCreditPossible\" \nng-model=\"vm.credit.remark\"></md-input-container></div></div><div class=\"p-20\"><md-button class=\"md-raised\" \nng-click=\"vm.updateSumRedeemed()\" ng-disabled=\"!vm.updateSumRedeemedPossible\" translate=\"CREDIT.UPDATE_SUM_REDEEMED\">\nSpeichern</md-button></div></div><div class=\"p-20\"><md-icon class=\"ml-0 mr-10\" md-font-icon=\"icon-calendar-multiple\">\n</md-icon><span translate=\"CREDIT.POSITION\"></span></div><div layout=\"column\" class=\"grey-50-bg mh-20\"><div \nclass=\"mb-10 pt-15 pl-15\" layout=\"row\"><div layout=\"row\" flex=\"grow\"><div flex=\"50\"><span \ntranslate=\"CREDIT.POSITION_REMARK\"></span></div><div flex=\"50\" class=\"text-right\"><span \ntranslate=\"CREDIT.POSITION_AMOUNT\"></span></div></div><div style=\"width: 90px; min-width: 90px\"></div></div><div \nclass=\"pl-15\" layout=\"row\" layout-align=\"start start\" ng-repeat=\"(index,position) in vm.credit.positions\"><div \nlayout=\"row\" flex=\"grow\"><div flex=\"50\"><md-input-container class=\"m-0\"><input ng-disabled=\"!vm.updateCreditPossible\" \nrequired ng-model=\"position.description\" name=\"description\"><div ng-messages=\"vm.creditDetailForm.description.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"APP.REQUIRED\"></span>\n</div></div></md-input-container></div><div flex=\"50\" layout=\"row\" layout-align=\"end\"><md-input-container class=\"m-0\">\n<input class=\"text-right\" ng-disabled=\"!vm.updateCreditPossible\" type=\"number\" required \nng-pattern=\"/^(?:\\d*\\.\\d{1,2}|\\d+)$/\" ng-model=\"position.netAmount\" name=\"pos_{{index}}\"><div \nng-messages=\"vm.creditDetailForm[\'pos_\'+index].$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" \nclass=\"my-message\"><span translate=\"APP.REQUIRED\"></span></div><div ng-message=\"pattern\" class=\"my-message\"><span \ntranslate=\"CREDIT.ONLY_TWO_DECIMAL_PLACES\"></span></div></div></md-input-container><span style=\"padding-top: 6px\">\n{{vm.config.localization.currency.symbol}}</span></div></div><div flex=\"nogrow\" style=\"width: 90px; min-width: 90px\">\n<md-button ng-click=\"vm.credit.positions.splice(index, 1);\" layout-fill ng-if=\"vm.updateCreditPossible\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div><md-divider></md-divider><div layout=\"row\" \nclass=\"grey-50-bg\"><md-button ng-if=\"vm.updateCreditPossible\" \nng-click=\"vm.credit.positions.push({netAmount: null, description: \'\'});\" layout-fill><md-icon md-font-icon=\"icon-plus\">\n</md-icon><span translate=\"CREDIT.ADD_POSITION\"></span></md-button></div></div><div layout=\"column\" \nclass=\"mh-20 mb-40 pl-15\"><md-input-container ng-if=\"vm.updateCreditPossible\"><span \ntranslate=\"ORDERS.SALES.VATPERCENT\"></span> <input type=\"number\" ng-model=\"vm.credit.vatPercent\"></md-input-container>\n<div ng-if=\"!vm.updateCreditPossible\" class=\"mt-20\" style=\"margin-right: 90px\" layout=\"row\"><div flex=\"50\"><span \ntranslate=\"CREDIT.NET_SUM\"></span></div><div class=\"text-right\" flex=\"50\"><span>{{vm.credit.netAmount | nuitCurrency}}\n</span></div></div><div ng-if=\"!vm.updateCreditPossible\" style=\"margin-right: 90px\" layout=\"row\"><div flex=\"50\"><span \ntranslate=\"ORDERS.SALES.VATPERCENT\"></span></div><div class=\"text-right\" flex=\"50\"><span>{{vm.credit.vatPercent}} %\n</span></div></div><div ng-if=\"!vm.updateCreditPossible\" style=\"margin-right: 90px\" layout=\"row\"><div flex=\"50\"><span \ntranslate=\"ORDERS.SALES.TAXES\"></span></div><div class=\"text-right\" flex=\"50\"><span>\n{{vm.credit.sumTaxes | nuitCurrency}}</span></div></div><div ng-if=\"!vm.updateCreditPossible\" \nstyle=\"margin-right: 90px\" layout=\"row\"><div flex=\"50\"><md-divider></md-divider><span translate=\"CREDIT.TOTAL_SUM\">\n</span></div><div class=\"text-right\" flex=\"50\"><md-divider></md-divider><strong>{{vm.credit.sumAmount | nuitCurrency}}\n</strong></div></div><div class=\"mt-20\" style=\"margin-right: 90px\" layout=\"row\" ng-if=\"vm.credit.sumRedeemed\"><div \nflex=\"50\"><span translate=\"CREDIT.TOTAL_REDEEMED\"></span></div><div class=\"text-right\" flex=\"50\"><strong>\n{{vm.credit.sumRedeemed | nuitCurrency}}</strong></div></div></div></div></div></div></md-content></div></form></div>\n</div></div>");
$templateCache.put("app/main/orders.offers/views/config/config.html","<config-single ng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"offers.nameFormat\" type=\"2\" \ndefault-value=\"\'{{details.orderProjectName}} | {{orderedBy.lastName}}, {{orderedBy.firstName}}\'\" \nshow-default-value=\"true\" to-default-on-delete=\"true\" translation=\"ORDERS_OFFERS_SETTINGS.NAME_FORMAT_BACKEND\" \nsearch-term=\"vm.searchTerm\" on-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-editor \nwhole-config=\"vm.config\" default-root=\"ims.offers\" default-name=\"ORDERS_OFFERS_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/orders.orders/views/config/config.html","<config-single ng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"orders.nameFormat\" type=\"2\" \ndefault-value=\"\'{{details.orderProjectName}} | {{orderedBy.lastName}}, {{orderedBy.firstName}}\'\" \nshow-default-value=\"true\" to-default-on-delete=\"true\" translation=\"ORDERS_SETTINGS.NAME_FORMAT_BACKEND\" \nsearch-term=\"vm.searchTerm\" on-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-editor \nwhole-config=\"vm.config\" default-root=\"ims.orders\" default-name=\"ORDERS_SETTINGS\" controller=\"vm\"></config-editor>");
$templateCache.put("app/main/orders.orders/views/partials/admin.html","<md-content ms-scroll class=\"thread-detail\"><div layout=\"column\" layout-fill class=\"mt-40 ph-16\"><div layout=\"column\" \nlayout-align=\"space-between start\" layout-margin><md-input-container><label translate=\"ORDER.STATUS\"></label><md-select\n ng-model=\"vm.order.status\" ng-if=\"vm.queue[0].id\" ng-disabled=\"vm.inProduction || vm.onStatusChange()\"><md-option \nng-if=\"vm.showStatus(status.type)\" ng-repeat=\"status in vm.queue track by status.id\" ng-value=\"status.id\">\n{{status.name | nuitTranslate}}</md-option></md-select></md-input-container><div ng-if=\"vm.showDeliveryError()\"><span \nclass=\"md-warn-fg\" translate=\"TRANSPORT.TRANSPORT_DETAILS_MUST_BE_DEFINED\"></span></div></div></div></md-content>");
$templateCache.put("app/main/orders.orders/views/partials/details.html","<md-content ms-scroll class=\"thread-detail\"><div class=\"grey-100-bg p-10 m-10\" \nng-if=\"vm.editable && vm.order.invoiceId\" layout=\"row\" layout-align=\"center center\"><span flex></span><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon><span translate=\"ORDERS.INVOICE_WILL_NOT_UPDATE\"></span> \n<span flex></span></div><div class=\"grey-100-bg p-10 m-10\" layout=\"row\" ng-if=\"vm.order.originUser\" \nlayout-align=\"center center\"><span flex></span><md-icon md-font-icon=\"icon-account-location\"></md-icon><span \ntranslate=\"ORDERS.ORIGIN_USER\"></span>: <span>\n&nbsp;{{::\'\\{\\{lastName\\}\\} \\{\\{firstName\\}\\}\' | nuitFormatter: vm.order.originUser}}</span> <span flex></span></div>\n<div class=\"mh-10\" layout=\"row\" layout-wrap><div layout=\"row\" class=\"grey-100-bg m-10 p-10\" \nng-repeat=\"field in vm.config.ims.orders.details.customFields.top\" \nng-if=\"(field.format | nuitFormatter:vm.order).length>0\"><span class=\"mr-10\">{{field.name | nuitTranslate}}</span> \n<span class=\"text-bold\">{{field.format | nuitFormatter:vm.order}}</span></div></div><div layout=\"row\" layout-wrap \nclass=\"mt-20 ph-16\"><div flex-gt-md=\"35\" flex-gt-sm=\"65\" flex=\"100\" flex-order=\"1\" class=\"mb-10\"><div layout=\"row\" \nlayout-align=\"start start\" class=\"secondary-text mb-24\"><md-icon md-font-icon=\"icon-account\" class=\"mr-16\"></md-icon>\n<span class=\"md-title\" flex translate=\"ORDERS.CUSTOMER\">Customer</span></div><table class=\"simple h5\" \nms-responsive-table><tbody><tr ng-if=\"vm.config.ims.orders.details.customer.name\"><td translate=\"ORDERS.NAME\">Name</td>\n<td class=\"text-bold\">{{ ::vm.order.ordered_by.firstName }}&nbsp;{{ ::vm.order.ordered_by.lastName }}</td></tr><tr \nng-if=\"vm.config.ims.orders.details.customer.email\"><td translate=\"ORDERS.EMAIL\">E-Mail</td><td class=\"text-bold\">\n{{ ::vm.order.ordered_by.email }}</td></tr><tr ng-if=\"vm.config.ims.orders.details.customer.phone\"><td \ntranslate=\"ORDERS.PHONE\">Phone</td><td class=\"text-bold\">{{ ::vm.order.ordered_by.phone }}</td></tr><tr \nng-if=\"vm.config.ims.orders.details.customer.shippingType && vm.showShippingAddress()\"><td \ntranslate=\"CART.SHIPPING_TYPE\"></td><td layout=\"row\" layout-align=\"start center\"><div class=\"text-bold\" \nng-if=\"!vm.editShippingType\" flex>{{(\'CART.DELIVERY_TYPE.\' + vm.order.details.shippingType.toUpperCase()) | translate}}\n</div><md-select ng-model=\"vm.order.details.shippingType\" ng-if=\"vm.editShippingType\" class=\"m-0\" flex><md-option \nng-value=\"shippingType\" ng-repeat=\"shippingType in vm.shippingTypes\"><span>\n{{(\'CART.DELIVERY_TYPE.\' + shippingType.toUpperCase()) | translate}}</span></md-option></md-select><button \nng-if=\"vm.dialogConfig.details.editButton\" class=\"md-icon-button md-button md-default-theme md-ink-ripple\" \ntype=\"button\" style=\"width:28px;height:28px;padding:0\" aria-label=\"edit\" \nng-click=\"vm.editShippingType=!vm.editShippingType\"><md-icon \nmd-font-icon=\"{{vm.editShippingType?\'icon-close\':\'icon-pencil\'}}\"></md-icon></button></td></tr><tr \nng-if=\"vm.config.ims.orders.details.customer.address\"><td translate=\"CART.DETAIL_ADDRESS\">Detail Address</td><td \nclass=\"text-bold\"><div layout=\"row\"><div flex style=\"white-space: pre-line\">\n{{vm.config.ims.orders.details.customer.addressFormat | nuitFormatter:vm.order.details.detail_address:true}}</div>\n<button ng-if=\"vm.dialogConfig.details.editButton\" class=\"md-icon-button md-button md-default-theme md-ink-ripple\" \ntype=\"button\" style=\"width:28px;height:28px;padding:0\" aria-label=\"edit\" \nng-click=\"vm.editAddress(vm.order.details, \'detail_address\' ,vm.company,\'addresses\');\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></button></div></td></tr><tr \nng-if=\"vm.config.ims.orders.details.customer.shippingAddress && vm.showShippingAddress()\"><td \ntranslate=\"CART.SHIPPING_ADDRESS\">Detail Address</td><td class=\"text-bold\"><div layout=\"row\"><div flex \nstyle=\"white-space: pre-line\">\n{{vm.config.ims.orders.details.customer.addressFormat | nuitFormatter:vm.order.details.shipping_address:true}}</div>\n<button ng-if=\"vm.dialogConfig.details.editButton\" class=\"md-icon-button md-button md-default-theme md-ink-ripple\" \ntype=\"button\" style=\"width:28px;height:28px;padding:0\" aria-label=\"edit\" \nng-click=\"vm.editAddress(vm.order.details, \'shipping_address\' ,vm.company,\'deliveryAddresses\');\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></button></div></td></tr><tr \nng-if=\"vm.config.ims.orders.details.customer.addressRemark\"><td translate=\"CART.DETAIL_ADDRESS_REMARK\">Detail Address\n</td><td class=\"text-bold\">{{ vm.order.details.detail_address_remark }}</td></tr><tr \nng-repeat=\"field in vm.config.ims.orders.details.customFields.customer\" \nng-if=\"(field.format | nuitFormatter:vm.order).length>0\"><td class=\"mr-10\">{{field.name | nuitTranslate}}</td><td \nclass=\"text-bold\" ng-bind-html=\"field.format | nuitFormatter:vm.order\"></td></tr></tbody></table></div><div \nflex-gt-md=\"35\" flex=\"100\" class=\"mb-10\" flex-offset-gt-md=\"5\" flex-order-gt-md=\"2\" flex-order-gt-sm=\"3\" \nflex-order=\"2\"><div layout=\"row\" layout-align=\"start start\" class=\"secondary-text mb-24\"><md-icon \nmd-font-icon=\"icon-information\" class=\"mr-16\"></md-icon><span class=\"md-title\" flex translate=\"ORDERS.DETAILS\">\nOrder details</span> <button ng-if=\"vm.dialogConfig.details.editButton\" \nclass=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" style=\"width:28px;height:28px;padding:0\" \naria-label=\"edit\" ng-click=\"vm.editDetails = !vm.editDetails\"><md-icon md-font-icon=\"icon-pencil\" \nng-if=\"!vm.editDetails\"></md-icon><md-icon md-font-icon=\"icon-close\" ng-if=\"vm.editDetails\"></md-icon></button></div>\n<table class=\"simple h5\" ms-responsive-table><tbody><tr ng-if=\"vm.order.number\"><td>\n{{(vm.order.orderIds?\'OFFERS.NUMBER\':\'ORDERS.NUMBER\') | translate}}</td><td>{{vm.order.number}}</td></tr><tr \nng-if=\"vm.order.offerId\"><td translate=\"OFFERS.NUMBER\"></td><td>{{vm.order.offerNumber}}</td></tr><tr \nng-repeat=\"field in vm.config.evo.cart.fields track by field.id\"><td>{{ field.name | nuitTranslate }}</td><td \nclass=\"text-bold order-details\"><md-input-container ng-readonly=\"!vm.editDetails\"><input type=\"text\" \nname=\"{{::field.id}}\" ng-model=\"vm.order.details[field.id]\" aria-label=\"n\" onfocus=\"this.select()\" \nng-required=\"field.required\" maxlength=\"{{::field.maxlength}}\" \nminlength=\"{{::(field.minlength ? field.minlength : 0) }}\" ng-pattern=\"{{::field.regex}}\" \nng-disabled=\"(vm.order | nuitConditionCheck:(field.conditions?field.conditions:[]):false)\" \nng-readonly=\"!vm.editDetails\"></md-input-container></td></tr><tr><td translate=\"ORDERS.REMARK\">Remark</td><td \nclass=\"text-bold order-details\"><md-input-container ng-readonly=\"!vm.editDetails\"><input type=\"text\" \nng-model=\"vm.order.details.remark\" ng-readonly=\"!vm.editDetails\"></md-input-container></td></tr><tr \nng-if=\"vm.dialogConfig.details.completionDatePicker && vm.config.ims.orders.details.completionDate && vm.showShippingAddress()\">\n<td translate=\"ORDERS.COMPLETION_DATE\">Completion Date</td><td class=\"text-bold order-details-datepicker\" layout=\"row\">\n<md-datepicker ng-model=\"vm.order.details.completionDate\" style=\"width:100%\" md-hide-icons=\"calendar\" \nng-disabled=\"!vm.editDetails\" md-placeholder=\"Gewünschter Liefertermin\"></md-datepicker><div class=\"ml-10\" \nng-if=\"vm.isHoliday(vm.order.details.completionDate)\" layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"md-warn-fg\" md-font-icon=\"icon-alert\"></md-icon><md-tooltip><div translate=\"ORDERS.IS_BANK_HOLIDAY\"></div>\n</md-tooltip></div></td></tr><tr ng-if=\"vm.config.evo.cart.fixedTime.enabled\"><td translate=\"ORDERS.FIXED_TIME\"></td>\n<td><div ng-if=\"vm.editDetails\"><div layout=\"row\"><md-checkbox ng-disabled=\"!vm.editDetails\" class=\"p-0 m-0\" \nng-model=\"vm.fixedTime\" ng-change=\"vm.updateFixedTime()\"></md-checkbox><div ng-if=\"vm.fixedTime\" layout=\"row\">\n<md-select ng-model=\"vm.order.details.fixedTime.hour\" class=\"m-0\" ng-disabled=\"!vm.editDetails\" flex><md-option \nng-value=\"hour\" ng-repeat=\"hour in vm.config.evo.cart.fixedTime.hours\">{{(hour>9?\'\':\'0\')+ hour}}</md-option>\n</md-select><div>:</div><md-select ng-model=\"vm.order.details.fixedTime.minute\" class=\"m-0 mr-20\" \nng-disabled=\"!vm.editDetails\" flex><md-option ng-value=\"minute\" \nng-repeat=\"minute in vm.config.evo.cart.fixedTime.minutes\">{{(minute>9?\'\':\'0\')+ minute}}</md-option></md-select></div>\n</div><md-select ng-if=\"vm.fixedTime && vm.config.evo.cart.fixedTime.tolerances.length>0\" \nng-model=\"vm.order.details.fixedTime.tolerance\" class=\"m-0\" ng-disabled=\"!vm.editDetails\" flex><md-option \nng-value=\"tolerance\" ng-repeat=\"tolerance in vm.config.evo.cart.fixedTime.tolerances\"><span>\n{{vm.getFormattedTolerance(vm.order.details.fixedTime.hour, vm.order.details.fixedTime.minute, tolerance)}}</span>\n</md-option></md-select></div><div ng-if=\"!vm.editDetails\"><div ng-if=\"vm.fixedTime\"><div><span>\n{{vm.addLeadingZero(vm.order.details.fixedTime.hour)}}</span> : <span>\n{{vm.addLeadingZero(vm.order.details.fixedTime.minute)}}</span></div><span \nng-if=\"vm.fixedTime && vm.config.evo.cart.fixedTime.tolerances.length>0\">\n{{vm.getFormattedTolerance(vm.order.details.fixedTime.hour,vm.order.details.fixedTime.minute,vm.order.details.fixedTime.tolerance)}}\n</span></div><div ng-if=\"!vm.fixedTime\">-</div></div></td></tr><tr \nng-repeat=\"field in vm.config.ims.orders.details.customFields.details\" \nng-if=\"(field.format | nuitFormatter:vm.order).length>0\"><td class=\"mr-10\">{{field.name | nuitTranslate}}</td><td \nclass=\"text-bold\" ng-bind-html=\"field.format | nuitFormatter:vm.order\"></td></tr><tr \nng-if=\"vm.getSearchResults(undefined,false).length>0 || vm.config.ims.orders.details.allowTagAdding\"><td \ntranslate=\"ORDER.TAGS\"></td><td layout=\"row\"><md-input-container flex ng-readonly=\"!vm.editDetails\" class=\"m-0 p-0\">\n<md-select id=\"tagSelect\" ng-class=\"{\'tags-disabled\':!vm.editDetails}\" ng-model=\"vm.order.tags\" multiple=\"multiple\" \nng-disabled=\"!vm.editDetails\" ng-click=\"vm.editDetails?vm.openTags($event,vm.order.tags, vm.setDirty):undefined\" \nmd-on-close=\"searchText=undefined\"><md-select-header class=\"select-header p-10\"><input id=\"search\" \nng-model=\"searchText\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" ng-enter=\"vm.addTag(vm.order, searchText)\">\n<div ng-if=\"vm.getSearchResults(searchText,true).length===0\">{{\'MENUBAR.NEW\' | translate}}</div></md-select-header>\n<md-option ng-value=\"tag.id\" ng-repeat=\"tag in vm.getSearchResults(searchText,false)\">\n{{tag.localizedName | nuitTranslate:tag.name}}</md-option></md-select></md-input-container></td></tr><tr \nng-if=\"vm.config.evo.cart.assignee.enabled\"><td translate=\"APP.ASSIGNEE\"></td><td layout=\"row\"><md-input-container \nflex ng-readonly=\"!vm.editDetails\" class=\"m-0 p-0\"><md-select ng-class=\"{\'tags-disabled\':!vm.editDetails}\" \nng-model=\"vm.order[vm.ASSIGNEES_NAME]\" multiple=\"multiple\" ng-disabled=\"!vm.editDetails\"><md-option ng-value=\"id\" \nng-repeat=\"id in vm.config.evo.cart.assignee.users\"><nuit-person-name person=\"vm.getPerson(id)\"></nuit-person-name>\n</md-option></md-select></md-input-container></td></tr><tr ng-if=\"vm.config.evo.cart.project.enabled\"><td \ntranslate=\"APP.PROJECT\"></td><td layout=\"row\"><md-input-container flex ng-readonly=\"!vm.editDetails\" class=\"m-0 p-0\">\n<md-select id=\"projectSelect\" ng-model=\"vm.order.projectId\" ng-disabled=\"!vm.editDetails\" \nmd-on-close=\"searchProject=undefined\" md-on-open=\"vm.focusProjectSearch()\"><md-select-header \nclass=\"select-header p-10\"><input id=\"searchProject\" ng-model=\"searchProject\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option ng-if=\"!searchProject\" ng-value=\"\'\'\">\n{{\'PROJECT.NONE\' | translate}}</md-option><md-option ng-value=\"project.uuid\" \nng-if=\"searchProject===undefined || project.name.toLowerCase().includes(searchProject.toLowerCase())\" \nng-repeat=\"project in vm.projects\">{{project.name}}</md-option></md-select></md-input-container></td></tr></tbody>\n</table></div><div flex-gt-md=\"20\" flex-gt-sm=\"30\" flex=\"100\" class=\"mb-10\" flex-offset-gt-sm=\"5\" flex-order-gt-md=\"3\" \nflex-order-gt-sm=\"2\" flex-order=\"3\"><div ng-if=\"vm.displayPayment()\" layout=\"row\" layout-align=\"start start\" \nclass=\"secondary-text mb-24\"><md-icon md-font-icon=\"icon-credit-card\" class=\"mr-16\"></md-icon><span class=\"md-title\" \nflex translate=\"ORDERS.PAYMENT\">Documents</span></div><div ng-if=\"vm.displayPayment() && vm.payment.status!==\'none\'\">\n<div class=\"mb-20 pl-30\"><div layout=\"row\"><div class=\"text-bold\" translate=\"CART.PAYMENT.STRIPE\"></div><md-icon \nng-if=\"vm.payment.status===\'successful\'\" class=\"green-500-fg ml-10 h-32\" md-font-icon=\"icon-checkbox-marked-circle\">\n</md-icon><md-icon ng-if=\"vm.payment.status===\'failed\'\" class=\"md-warn-fg ml-10 h-32\" md-font-icon=\"icon-alert\">\n</md-icon></div><a ng-click=\"vm.openPayment()\" style=\"cursor: pointer\"><div layout=\"row\" \nng-if=\"vm.payment.status===\'successful\'\"><div translate=\"ORDERS.PAYMENT.SUCCESSFUL\"></div></div><div layout=\"row\" \nng-if=\"vm.payment.status===\'failed\'\"><div translate=\"ORDERS.PAYMENT.FAILED\"></div></div></a></div></div><div \nng-if=\"vm.displayPayment() && vm.payment.status===\'none\'\"><div class=\"mb-20 pl-30\"><div layout=\"row\"><div \nclass=\"text-bold\" translate=\"CART.PAYMENT.INVOICE\"></div></div></div></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"secondary-text mb-24\"><md-icon md-font-icon=\"icon-clipboard-arrow-down\" \nclass=\"mr-16\"></md-icon><span class=\"md-title\" flex translate=\"ORDERS.DOCUMENTS\">Documents</span></div><div \nclass=\"documents\" flex layout=\"column\"><a \nng-repeat=\"docObj in vm.order.documents | languageFilter:\'lang\' | orderByTranslated:\'name\' track by docObj.key\" \nng-href=\"{{::vm.getDocumentURL(docObj)}}\" target=\"_blank\" ng-click=\"$event.stopPropagation();\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"mr-5\"></md-icon><span>{{::docObj.name | translate}}</span></a><div \nng-if=\"vm.invoice\" \nng-repeat=\"docObj in vm.invoice.documents | languageFilter:\'lang\' | orderByTranslated:\'name\' track by docObj.key\"><a \nflex ng-href=\"{{::vm.getDocumentURL(docObj)}}\" target=\"_blank\" ng-click=\"$event.stopPropagation();\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"mr-5\"></md-icon><span>{{::docObj.name | translate}}</span> </a><a \nui-sref=\"app.orders.detail.invoice({invoiceId: vm.invoice.id,invoiceOrigin: \'app.orders.detail\'})\" \nng-click=\"$event.stopPropagation();\" ng-if=\"!vm.origin\"><md-icon class=\"grey-400-fg\" md-font-icon=\"icon-open-in-new\">\n</md-icon></a></div></div><div ng-if=\"vm.ordersOrOffer.ordersOrOffer.length > 0 \"><div layout=\"row\" \nlayout-align=\"start start\" class=\"secondary-text mt-35 mb-24\"><md-icon md-font-icon=\"icon-document\" class=\"mr-16\">\n</md-icon><span class=\"md-title\" flex>{{vm.ordersOrOffer.title | translate}}</span></div><div \nng-repeat=\"item in vm.ordersOrOffer.ordersOrOffer track by item.id\" class=\"pl-30\"><div ng-if=\"item.id\">\n{{vm.ordersOrOffer.getTitle(item)}} <a ui-sref=\"{{vm.ordersOrOffer.state}}({ {{vm.ordersOrOffer.urlId}}:item.id})\" \nng-click=\"$event.stopPropagation();\"><md-icon class=\"grey-400-fg\" md-font-icon=\"icon-open-in-new\"></md-icon></a></div>\n</div></div><div \nng-if=\"(vm.exportToQuickbooks && vm.config.ims.exchange.quickbooks.enabled) || (vm.exportToXero && vm.config.ims.exchange.xero.enabled)\">\n<div layout=\"row\" layout-align=\"start start\" class=\"secondary-text mb-24 mt-35\"><md-icon md-font-icon=\"icon-data\" \nclass=\"mr-16\"></md-icon><span class=\"md-title\" flex translate=\"ORDERS.CUSTOM\">Documents</span></div><div layout=\"row\" \nng-if=\"vm.exportToQuickbooks && vm.config.ims.exchange.quickbooks.enabled\"><span class=\"ml-32\" \ntranslate=\"QUICKBOOKS.INVOICE_ID\"></span>: <span \nng-if=\"!vm.order.externalData.qbInvoiceId && !vm.order.externalData.qbInvoiceUrl\" class=\"ml-8\">-</span> <span \nng-if=\"vm.order.externalData.qbInvoiceId && !vm.order.externalData.qbInvoiceUrl\" class=\"ml-8\">\n{{vm.order.externalData.qbInvoiceId}}</span> <span \nng-if=\"!vm.order.externalData.qbInvoiceId && vm.order.externalData.qbInvoiceUrl\" class=\"ml-8\"><a target=\"_blank\" \nng-href=\"{{vm.order.externalData.qbInvoiceUrl}}\" translate=\"MENUBAR.OPEN\"></a> </span><span \nng-if=\"vm.order.externalData.qbInvoiceId && vm.order.externalData.qbInvoiceUrl\" class=\"ml-8\"><a target=\"_blank\" \nng-href=\"{{vm.order.externalData.qbInvoiceUrl}}\">{{vm.order.externalData.qbInvoiceId}}</a></span></div><div \nlayout=\"row\" ng-if=\"vm.exportToXero && vm.config.ims.exchange.xero.enabled\"><span class=\"ml-32\" \ntranslate=\"XERO.INVOICE_ID\"></span>: <span \nng-if=\"!vm.order.externalData.xeroInvoiceId && !vm.order.externalData.xeroInvoiceUrl\" class=\"ml-8\">-</span> <span \nng-if=\"vm.order.externalData.xeroInvoiceId && !vm.order.externalData.xeroInvoiceUrl\" class=\"ml-8\">\n{{vm.order.externalData.xeroInvoiceId}}</span> <span \nng-if=\"!vm.order.externalData.xeroInvoiceId && vm.order.externalData.xeroInvoiceUrl\" class=\"ml-8\"><a target=\"_blank\" \nng-href=\"{{vm.order.externalData.xeroInvoiceUrl}}\" translate=\"MENUBAR.OPEN\"></a> </span><span \nng-if=\"vm.order.externalData.xeroInvoiceId && vm.order.externalData.xeroInvoiceUrl\" class=\"ml-8\"><a target=\"_blank\" \nng-href=\"{{vm.order.externalData.xeroInvoiceUrl}}\">{{vm.order.externalData.xeroInvoiceId}}</a></span></div></div></div>\n</div></md-content>");
$templateCache.put("app/main/orders.orders/views/partials/easy.html","<md-content ms-scroll class=\"thread-detail\"><div layout=\"row\" layout-wrap class=\"mt-20 ph-16\"><md-input-container \nflex=\"33\" ng-repeat=\"field in vm.config.evo.cart.fields track by field.id\"><label>{{field.name | nuitTranslate}}\n</label><input type=\"text\" name=\"{{::field.id}}\" ng-model=\"vm.order.details[field.id]\" aria-label=\"n\" \nonfocus=\"this.select()\" ng-required=\"field.required\" maxlength=\"{{::field.maxlength}}\" \nminlength=\"{{::(field.minlength ? field.minlength : 0) }}\" ng-pattern=\"{{::field.regex}}\" \nng-disabled=\"!vm.dialogConfig.details.editButton\"></md-input-container><md-input-container flex=\"33\"><label \ntranslate=\"ORDERS.COMPLETION_DATE\"></label><md-datepicker flex=\"100\" ng-model=\"vm.order.details.completionDate\" \nfill-width=\"100\" md-hide-icons=\"calendar\" ng-disabled=\"!vm.dialogConfig.details.editButton\"></md-datepicker>\n</md-input-container></div><div layout=\"column\" class=\"ph-16\"><div layout=\"column\" \nng-if=\"vm.config.ims.orders.positions.addNewFlatProfile && vm.isEditable(vm.dialogConfig.details.editButton)\"><h2 \ntranslate=\"PROFILE.FLAT\" flex>Profiles</h2><nuit-flat-profile on-updated=\"vm.onFlatProfilesUpdated()\" \nhash-prefix=\"easy_\"></nuit-flat-profile></div><div layout=\"row\" layout-align=\"space-between center\"><h2 \ntranslate=\"PROFILE.PROFILE_NAV\">Profiles</h2><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.addProfile(vm.order)\" \nng-if=\"vm.config.ims.orders.positions.addNewProfile && vm.isEditable(vm.dialogConfig.details.editButton)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div ng-if=\"!vm.allMarkedForDeletion(profile.positions)\" \nclass=\"mb-20 p-16\" id=\"{{::(\'easy_profile_\'+profile.id)}}\" layout-fill layout=\"row\" flex \nng-repeat=\"profile in vm.order.profiles\"><div layout=\"column\" flex><div layout=\"row\" layout-wrap><nuit-pos-number \nng-if=\"vm.showPosNumber\" number=\"profile.posNumber\"></nuit-pos-number><div layout=\"row\" \nclass=\"grey-100-bg p-8 mr-10 mb-10\" ng-repeat=\"field in vm.config.ims.orders.positions.customFields.top\" \nng-if=\"::(field.format | nuitFormatter:profile).length>0\"><span class=\"mr-10\">{{field.name | nuitTranslate}}</span> \n<span class=\"text-bold\">{{field.format | nuitFormatter:profile:true:\'x\'}}</span></div></div><div layout=\"row\"><div \nclass=\"mr-24\" layout=\"column\" layout-align=\"start stretch\"><div class=\"b img-container\"><nuit-profile-preview \nprofile=\"profile\"><img ng-if=\"profile | profileImage\" http-src=\"{{ profile | profileImage }}\" \nfallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\" draggable=\"false\" alt=\"Image\" \nng-click=\"vm.openImage(profile | profileImage)\"> <img ng-if=\"!(profile | profileImage)\" \nsrc=\"assets/images/ecommerce/product-image-placeholder.jpg\" draggable=\"false\" alt=\"Image\"></nuit-profile-preview></div>\n<md-button class=\"b m-0\" ng-if=\"vm.isEditable(vm.dialogConfig.positions.profileEditable)\" \nng-click=\"vm.openEditor(profile)\"><span translate=\"APP.EDIT\">Edit</span></md-button><md-button class=\"b m-0\" \nng-if=\"vm.showBendingProgramDownload\" ng-click=\"vm.openBendFileDialog(profile)\"><span \ntranslate=\"PRODUCTION_QUEUE.GET_BEND_PROGRAM\">Edit</span></md-button></div><div layout=\"column\" flex \nstyle=\"min-width:200px\"><div layout=\"row\" layout-wrap><span class=\"material-tag\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-checkbox-blank\" \nng-style=\"{color: profile.material.colors.front.hex}\"></md-icon><span \ntranslate=\"{{ profile.material.name | nuitTranslate}}\"></span> </span><span class=\"material-tag\" layout=\"row\" \nlayout-align=\"center center\"><span translate=\"MATERIAL.CUTTING\">Blank</span>&nbsp; <span class=\"text-bold\">\n{{ profile | nuitBlank }}</span> </span><span class=\"material-tag\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.hasStamps(profile)\"><md-icon class=\"black-fg s16\" md-font-icon=\"icon-image-filter-center-focus\"></md-icon>\n<strong ng-if=\"vm.getPunchCount(profile)\">&nbsp;{{ vm.getPunchCount(profile) }}</strong></span> <span \nclass=\"material-tag\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.hasCuts(profile)\"><md-icon \nclass=\"black-fg s16\" md-font-icon=\"icon-content-cut\"></md-icon></span><span class=\"material-tag\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.isConical(profile)\"><md-icon class=\"black-fg s16\" md-font-icon=\"icon-send\">\n</md-icon></span><span class=\"material-tag\" layout=\"row\" layout-align=\"center center\" \nng-repeat=\"tag in vm.config.ims.orders.positions.customFields.tags\" \nng-if=\"::(field.format | nuitFormatter:profile).length>0\"><span>{{tag.name | nuitTranslate}}</span>&nbsp; <span \nclass=\"text-bold\">{{ tag.format | nuitFormatter:profile }}</span></span></div><div layout=\"row\"><md-input-container \nflex><label translate=\"PROFILE.NAME\">Name</label><input type=\"text\" ng-model=\"profile.name\" \nng-disabled=\"!vm.isEditable(vm.dialogConfig.positions.nameEditable)\"></md-input-container></div><md-input-container \nclass=\"md-block\"><label translate=\"ORDERS.REMARK\">Remark</label><input type=\"text\" ng-model=\"profile.remark\" \nng-disabled=\"!vm.isEditable(vm.dialogConfig.positions.remarkEditable)\"></md-input-container><div layout=\"column\" \nng-repeat=\"field in vm.config.ims.orders.positions.customFields.details\" flex class=\"m-8\" \nng-if=\"::(field.format | nuitFormatter:profile).length>0\"><div layout=\"row\" flex layout-align=\"space-between start\">\n<span flex=\"20\">{{field.name | nuitTranslate}}</span> <span flex flex-offset=\"5\">\n{{field.format | nuitFormatter:profile}}</span></div></div></div><div class=\"lengths\" layout=\"column\">\n<nuit-profile-positions profile=\"profile\" show-prices=\"vm.showPrices\" show-weight=\"true\" soft-delete=\"true\" \nread-only=\"vm.dialogConfig.positions\" on-position-added=\"vm.markModified(position)\" \non-position-changed=\"vm.markModified(position)\" on-position-removed=\"vm.markModified(position)\">\n</nuit-profile-positions></div></div></div></div><md-divider></md-divider></div></md-content>");
$templateCache.put("app/main/orders.orders/views/partials/forwarding-details.html","<md-tab ui-sref=\"{{vm.origin?vm.origin:\'app.orders\'}}.detail({active:\'forwarding\'})\" \nmd-active=\"vm.currentTab === \'forwarding\'\" ng-if=\"vm.config.ims.transport.enabled && vm.order.companyId\"><md-tab-label>\n{{ \'ORDERS.TRANSPORT\' | translate }}<md-icon ng-if=\"vm.showDeliveryError()\" md-font-icon=\"icon-alert\" class=\"md-warn\">\n</md-icon></md-tab-label><md-tab-body><md-content class=\"thread-detail\" layout=\"column\" ms-scroll \nng-if=\"!vm.loadingForwarding\"><div class=\"p-10 mt-10\" layout=\"row\" ng-if=\"vm.showDeliveryError() \" \nlayout-align=\"center center\"><div class=\"pr-25\"><md-icon md-font-icon=\"icon-alert\" class=\"md-warn\"></md-icon><span \ntranslate=\"TRANSPORT.TRANSPORT_DETAILS_MUST_BE_DEFINED\"></span></div></div><div class=\"grey-100-bg p-10 m-10\" \nlayout=\"row\" layout-align=\"space-between start\" ng-if=\"vm.delivery.id\"><div layout=\"column\"><div layout=\"row\" \nng-if=\"vm.delivery.number\"><span translate=\"TRANSPORT.DELIVERY_NUMBER\"></span>: <span class=\"ml-5\"><strong>\n{{vm.delivery.number}}</strong></span></div><div layout=\"row\" ng-if=\"vm.delivery.status\"><span \ntranslate=\"TRANSPORT.DELIVERY_STATUS\"></span>: <span class=\"ml-5\"><strong>{{vm.getStatusName(vm.delivery.status)}}\n</strong></span></div><div layout=\"row\" ng-if=\"vm.delivery.documents.length > 0 && vm.delivery.status !== 1 \"><span \ntranslate=\"TRANSPORT.DELIVERY_NOTE\"></span>:<div layout=\"column\" layout-align=\"end\" class=\"pdf pl-10\"><a \nng-if=\"!vm.documentStatus.error\" \nng-repeat=\"docObj in vm.delivery.documents | languageFilter:\'lang\' | orderByTranslated:\'name\' track by $index\" \nstyle=\"white-space: nowrap\" class=\"message mr-5\" ng-href=\"{{vm.getDocumentURL(docObj)}}\" target=\"_blank\" \nng-click=\"$event.stopPropagation();\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><span>\n{{::docObj.name | translate}}</span></a></div></div></div><div ng-if=\"vm.delivery.status !== 1\"><md-button \nstyle=\"margin: 4px !important\" class=\"md-raised\" ng-click=\"vm.changeDeliveryStatus(vm.delivery)\"><span \ntranslate=\"ACCOUNTING.CHANGE_STATUS\">Update status</span></md-button></div></div><div class=\"mh-30 mb-30 mt-10\" \nlayout=\"row\"><div flex=\"50\" layout=\"column\" layout-align=\"start start\"><md-input-container class=\"pr-50 mt-30\"><label \ntranslate=\"TRANSPORT.DELIVERY_TYPE\">Auswahl Lieferoption</label><md-select ng-model=\"vm.delivery.deliveryType\" \nng-change=\"vm.setCarrierId()\"><md-option ng-repeat=\"deliveryTyp in vm.deliveryTypes\" ng-value=\"deliveryTyp.id\"><span>\n{{ deliveryTyp.name | translate }}</span></md-option></md-select></md-input-container><div layout=\"column\" \nclass=\"mv-20\" layout-align=\"start start\"><div layout=\"row\" \nng-if=\"vm.delivery.deliveryType === 2 && vm.delivery.number\" class=\"mb-20 ph-15 pv-10 grey-100-bg\"><md-icon \nmd-font-icon=\"icon-timetable\" class=\"mr-10\"></md-icon><span translate=\"TRANSPORT.DELIVERY_DELAY_DAYS\"></span>: <span \nclass=\"pl-5\"><strong>{{Math.ceil(vm.delivery.postalcodeDelay / 86400)}}</strong></span></div><div layout=\"column\"><span\n translate=\"TRANSPORT.DESIRED_DATE\">Wunschdatum</span><div layout=\"row\" class=\"mt-10\"><md-datepicker \nng-model=\"vm.delivery.desiredDate\" md-placeholder=\"{{TRANSPORT.ENTER_DATE | translate }}\" \nmd-date-filter=\"vm.filterDeliveryDates\" ng-change=\"vm.desiredDateLink = false\" name=\"desiredDate\"></md-datepicker><div \nclass=\"ml-10\" ng-if=\"vm.isHoliday(vm.delivery.desiredDate)\" layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"md-warn-fg\" md-font-icon=\"icon-alert\"></md-icon><md-tooltip><div translate=\"ORDERS.IS_BANK_HOLIDAY\"></div>\n</md-tooltip></div><md-button class=\"md-icon-button\" ng-if=\"vm.delivery.deliveryType === 2 && vm.delivery.number\" \nng-click=\"vm.calculateDays(\'desired\')\"><md-icon md-font-icon=\"icon-link\" ng-if=\"vm.desiredDateLink\"></md-icon><md-icon \nmd-font-icon=\"icon-link-off\" ng-if=\"!vm.desiredDateLink\"></md-icon><md-tooltip><span \ntranslate=\"TRANSPORT.CALCULATE_DATE\">Datum neu berechnen</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"vm.delivery.deliveryType === 1 && vm.delivery.number \" \nng-click=\"vm.calculateDays(\'desiredPickup\')\"><md-icon md-font-icon=\"icon-link\" ng-if=\"vm.desiredDateLink\"></md-icon>\n<md-icon md-font-icon=\"icon-link-off\" ng-if=\"!vm.desiredDateLink\"></md-icon><md-tooltip><span \ntranslate=\"TRANSPORT.CALCULATE_DATE\">Datum neu berechnen</span></md-tooltip></md-button></div><div class=\"red-fg mh-8\" \nng-messages=\"vm.orderForm.desiredDate.$error\"><div ng-message=\"required\" translate=\"APP.INVOICE_NUMBER.REQUIRED_DATE\">\nThis date is required!</div><div ng-message=\"valid\" translate=\"INVOICE.DATE_NOT_VALID\">This date is required!</div>\n</div></div><div layout=\"column\" ng-if=\"vm.delivery.number && vm.delivery.deliveryType === 2\" class=\"mt-25\"><span \ntranslate=\"TRANSPORT.SHIPPING_DATE\">Abholdatum</span><div layout=\"row\" class=\"mt-10\"><md-datepicker \nng-model=\"vm.delivery.shippingDate\" md-placeholder=\"{{TRANSPORT.ENTER_DATE | translate }}\" \nng-change=\"vm.dateLink = false\" name=\"shippingDate\" md-date-filter=\"vm.filterDeliveryDates\"></md-datepicker><div \nclass=\"ml-10\" ng-if=\"vm.isHoliday(vm.delivery.shippingDate)\" layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"md-warn-fg\" md-font-icon=\"icon-alert\"></md-icon><md-tooltip><div translate=\"ORDERS.IS_BANK_HOLIDAY\"></div>\n</md-tooltip></div><md-button class=\"md-icon-button\" ng-if=\"vm.delivery.number && vm.delivery.deliveryType === 2\" \nng-click=\"vm.calculateDays(\'shipping\')\"><md-icon md-font-icon=\"icon-link\" ng-if=\"vm.dateLink\"></md-icon><md-icon \nmd-font-icon=\"icon-link-off\" ng-if=\"!vm.dateLink\"></md-icon><md-tooltip><span translate=\"TRANSPORT.CALCULATE_DATE\">\nDatum neu berechnen</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-if=\"vm.delivery.number && vm.delivery.deliveryType === 1\" disabled=\"disabled\"><md-icon md-font-icon=\"icon-link\" \nng-if=\"vm.dateLink\"></md-icon><md-icon md-font-icon=\"icon-link-off\" ng-if=\"!vm.dateLink\"></md-icon><md-tooltip><span \ntranslate=\"TRANSPORT.CALCULATE_DATE\">Datum neu berechnen</span></md-tooltip></md-button></div><div class=\"red-fg mh-8\" \nng-messages=\"vm.orderForm.shippingDate.$error\"><div ng-message=\"required\" translate=\"APP.INVOICE_NUMBER.REQUIRED_DATE\">\nThis date is required!</div><div ng-message=\"valid\" translate=\"INVOICE.DATE_NOT_VALID\">This date is required!</div>\n</div></div><div layout=\"column\" ng-if=\"vm.delivery.number\" class=\"mt-25\"><span translate=\"TRANSPORT.DELIVERY_DATE\">\nZustelldatum</span><div layout=\"row\" class=\"mt-10\"><md-datepicker ng-model=\"vm.delivery.deliveryDate\" \nmd-placeholder=\"{{TRANSPORT.ENTER_DATE | translate }}\" ng-change=\"vm.dateLink = false; vm.desiredDateLink= false;\" \nmd-date-filter=\"vm.filterDeliveryDates\" name=\"deliveryDate\"></md-datepicker><div class=\"ml-10\" \nng-if=\"vm.isHoliday(vm.delivery.deliveryDate)\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"md-warn-fg\" \nmd-font-icon=\"icon-alert\"></md-icon><md-tooltip><div translate=\"ORDERS.IS_BANK_HOLIDAY\"></div></md-tooltip></div>\n<md-button class=\"md-icon-button\" ng-if=\"vm.delivery.number && vm.delivery.deliveryType === 2\" \nng-click=\"vm.calculateDays(\'delivery\')\"><md-icon md-font-icon=\"icon-link\" ng-if=\"vm.dateLink\"></md-icon><md-icon \nmd-font-icon=\"icon-link-off\" ng-if=\"!vm.dateLink\"></md-icon><md-tooltip><span translate=\"TRANSPORT.CALCULATE_DATE\">\nDatum neu berechnen</span></md-tooltip></md-button></div><div class=\"red-fg mh-8\" \nng-messages=\"vm.orderForm.deliveryDate.$error\"><div ng-message=\"valid\" translate=\"INVOICE.DATE_NOT_VALID\">\nThis date is required!</div></div><div class=\"red-fg mh-8\" ng-if=\"vm.validDate()\"><div \ntranslate=\"TRANSPORT.DELIVERY_DATE_MUST_BE_AFTER_SHIPPING_DATE\">This date is required!</div></div></div><div \nlayout=\"column\" ng-if=\"vm.delivery.pickedupDate\" class=\"mt-25\"><span translate=\"TRANSPORT.PICKEDUP_DATE\">Abgeholdatum\n</span><div layout=\"row\" class=\"mt-10\"><md-datepicker ng-model=\"vm.delivery.pickedupDate\" \nmd-placeholder=\"{{TRANSPORT.ENTER_DATE | translate }}\" name=\"pickedupDate\" md-date-filter=\"vm.filterDeliveryDates\">\n</md-datepicker><div class=\"ml-10\" ng-if=\"vm.isHoliday(vm.delivery.pickedupDate)\" layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"md-warn-fg\" md-font-icon=\"icon-alert\"></md-icon><md-tooltip><div \ntranslate=\"ORDERS.IS_BANK_HOLIDAY\"></div></md-tooltip></div></div></div></div></div><div layout=\"column\" flex=\"50\"><div\n layout=\"row\" ng-if=\"vm.delivery.deliveryType === 2\"><md-input-container flex \nng-class=\"{\'transport-warning\': vm.showDeliveryError() && !vm.delivery.carrierId}\"><label \ntranslate=\"TRANSPORT.SELECT_FORWARDER\">Auswahl Speditionsfirma</label><md-select ng-model=\"vm.delivery.carrierId\">\n<md-option ng-repeat=\"delCompany in vm.deliveryCompanies\" ng-value=\"delCompany.id\"><span>{{ delCompany.name }}</span>\n</md-option></md-select><div ng-if=\"vm.showDeliveryError() && !vm.delivery.carrierId\" class=\"md-warn-fg\"><span \ntranslate=\"TRANSPORT.ERROR_CARRIER_REQUIRED\"></span></div></md-input-container></div><span class=\"mt-20 mb-10\" \ntranslate=\"TRANSPORT.DELIVERY_DETAILS\">Lieferdetails</span><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"mv-20\"><label translate=\"APP.WEIGHT\">Gewicht</label><div><span>\n{{(vm.getValue(vm.order.sales.weight,\'weight\') | nuitNumber)}}</span> <span>{{vm.getSymbolForKey(\'weight\')}}</span>\n</div></div><md-input-container><label translate=\"TRANSPORT.DELIVERY_PACKAGE_UNITS\"></label><input type=\"number\" \nname=\"packageUnits\" ng-model=\"vm.delivery.packageUnits\" min=\"1\"><div ng-messages=\"vm.orderForm.packageUnits.$error\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\"><span \ntranslate=\"TRANSPORT.ERROR_PACKAGE_UNITS_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TRANSPORT.ERROR_MIN_PACKAGE_UNITS\"></span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex ng-class=\"{\'transport-warning\': vm.showDeliveryError() && vm.delivery.dimension === \'\'}\">\n<label translate=\"TRANSPORT.DELIVERY_DIMENSION\">X-Dimension / Breite</label><input type=\"text\" name=\"dimension\" \nng-model=\"vm.delivery.dimension\"><div ng-if=\"vm.showDeliveryError() && vm.delivery.dimension === \'\'\" \nclass=\"md-warn-fg\"><span translate=\"TRANSPORT.ERROR_DIMENSION_REQUIRED\"></span></div></md-input-container></div><div>\n<div layout=\"row\" layout-align=\"space-between\"><div translate=\"CART.SHIPPING_ADDRESS\">Detail Address</div><button \nng-if=\"vm.isEditable()\" class=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" \nstyle=\"width:28px;height:28px;padding:0\" aria-label=\"edit\" \nng-click=\"vm.editAddress(vm.delivery, \'shippingAddress\' ,vm.company,\'deliveryAddresses\');\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></button></div><div flex style=\"white-space: pre-line\">\n{{vm.config.ims.orders.details.customer.addressFormat | nuitFormatter:vm.delivery.shippingAddress:true}}</div></div>\n</div></div></md-content></md-tab-body></md-tab>");
$templateCache.put("app/main/orders.orders/views/partials/positions.html","<md-content ms-scroll layout-fill class=\"thread-detail\"><div layout=\"column\" class=\"ph-16\"><div layout=\"column\" \nng-if=\"vm.config.ims.orders.positions.addNewFlatProfile && vm.isEditable(vm.dialogConfig.details.editButton)\"><h2 \ntranslate=\"PROFILE.FLAT\" flex>Profiles</h2><nuit-flat-profile on-updated=\"vm.onFlatProfilesUpdated()\" flex \nhash-prefix=\"pos_\"></nuit-flat-profile></div><div layout=\"row\" layout-align=\"space-between center\"><h2 \ntranslate=\"PROFILE.PROFILE_NAV\">Profiles</h2><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.addProfile(vm.order)\" \nng-if=\"vm.config.ims.orders.positions.addNewProfile && vm.isEditable(vm.dialogConfig.details.editButton)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div ng-if=\"!vm.allMarkedForDeletion(profile.positions)\" \nclass=\"mb-20 p-16\" id=\"{{::(\'pos_profile_\'+profile.id)}}\" layout-fill layout=\"row\" flex \nng-repeat=\"profile in vm.order.profiles\"><div layout=\"column\" flex><div layout=\"row\" layout-wrap><nuit-pos-number \nng-if=\"vm.showPosNumber\" number=\"profile.posNumber\"></nuit-pos-number><div layout=\"row\" \nclass=\"grey-100-bg p-8 mr-10 mb-10\" ng-repeat=\"field in vm.config.ims.orders.positions.customFields.top\" \nng-if=\"::(field.format | nuitFormatter:profile).length>0\"><span class=\"mr-10\">{{field.name | nuitTranslate}}</span> \n<span class=\"text-bold\">{{field.format | nuitFormatter:profile:true:\'x\'}}</span></div></div><div layout=\"row\"><div \nclass=\"mr-24\" layout=\"column\" layout-align=\"start stretch\"><div class=\"b img-container\"><nuit-profile-preview \nprofile=\"profile\"><img ng-if=\"profile | profileImage\" http-src=\"{{ profile | profileImage }}\" \nfallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\" draggable=\"false\" alt=\"Image\" \nng-click=\"vm.openImage(profile | profileImage)\"> <img ng-if=\"!(profile | profileImage)\" \nsrc=\"assets/images/ecommerce/product-image-placeholder.jpg\" draggable=\"false\" alt=\"Image\"></nuit-profile-preview></div>\n<md-button class=\"b m-0\" ng-if=\"vm.isEditable(vm.dialogConfig.positions.profileEditable)\" \nng-click=\"vm.openEditor(profile)\"><span translate=\"APP.EDIT\">Edit</span></md-button><md-button class=\"b m-0\" \nng-if=\"vm.showBendingProgramDownload\" ng-click=\"vm.openBendFileDialog(profile)\"><span \ntranslate=\"PRODUCTION_QUEUE.GET_BEND_PROGRAM\">Edit</span></md-button><md-button class=\"b m-0\" \nng-if=\"vm.showProfileDetailsButton\" \nng-click=\"vm.imsNextChannel.channel.openProfileDetails(profile.id, {shopOrderId: vm.order.id, shopOfferId: vm.offer.id})\">\n<span translate=\"PROFILE.OPEN_DETAILS\">Show Details</span></md-button></div><div layout=\"column\" flex \nstyle=\"min-width:200px\"><div layout=\"row\" layout-wrap><span class=\"material-tag\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-checkbox-blank\" \nng-style=\"{color: profile.material.colors.front.hex}\"></md-icon><span \ntranslate=\"{{ profile.material.name | nuitTranslate}}\"></span> </span><span class=\"material-tag\" layout=\"row\" \nlayout-align=\"center center\"><span translate=\"MATERIAL.CUTTING\">Blank</span>&nbsp; <span class=\"text-bold\">\n{{ profile | nuitBlank }}</span> </span><span class=\"material-tag\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.hasStamps(profile)\"><md-icon class=\"black-fg s16\" md-font-icon=\"icon-image-filter-center-focus\"></md-icon>\n<strong ng-if=\"vm.getPunchCount(profile)\">&nbsp;{{ vm.getPunchCount(profile) }}</strong></span> <span \nclass=\"material-tag\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.hasCuts(profile)\"><md-icon \nclass=\"black-fg s16\" md-font-icon=\"icon-content-cut\"></md-icon></span><span class=\"material-tag\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.isConical(profile)\"><md-icon class=\"black-fg s16\" md-font-icon=\"icon-send\">\n</md-icon></span><span class=\"material-tag\" layout=\"row\" layout-align=\"center center\" \nng-repeat=\"tag in vm.config.ims.orders.positions.customFields.tags\" \nng-if=\"::(field.format | nuitFormatter:profile).length>0\"><span>{{tag.name | nuitTranslate}}</span>&nbsp; <span \nclass=\"text-bold\">{{ tag.format | nuitFormatter:profile }}</span></span></div><div layout=\"row\"><md-input-container \nflex><label translate=\"PROFILE.NAME\">Name</label><input type=\"text\" ng-model=\"profile.name\" \nng-disabled=\"!vm.isEditable(vm.dialogConfig.positions.nameEditable)\"></md-input-container></div><md-input-container \nclass=\"md-block\"><label translate=\"ORDERS.REMARK\">Remark</label><input type=\"text\" ng-model=\"profile.remark\" \nng-disabled=\"!vm.isEditable(vm.dialogConfig.positions.remarkEditable)\"></md-input-container><div layout=\"column\" \nng-repeat=\"field in vm.config.ims.orders.positions.customFields.details\" flex class=\"m-8\" \nng-if=\"::(field.format | nuitFormatter:profile).length>0\"><div layout=\"row\" flex layout-align=\"space-between start\">\n<span flex=\"20\">{{field.name | nuitTranslate}}</span> <span flex flex-offset=\"5\">\n{{field.format | nuitFormatter:profile}}</span></div></div></div><div class=\"lengths\" layout=\"column\">\n<nuit-profile-positions profile=\"profile\" show-prices=\"vm.showPrices\" show-weight=\"true\" soft-delete=\"true\" \nread-only=\"vm.dialogConfig.positions\" on-position-added=\"vm.markModified(position)\" \non-position-changed=\"vm.markModified(position)\" on-position-removed=\"vm.markModified(position)\">\n</nuit-profile-positions></div></div></div></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" \nng-if=\"vm.order.products.length > 0 || vm.config.ims.orders.positions.addNewProduct\"><h2 \ntranslate=\"PRODUCT.PRODUCT_NAV\">Products</h2><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.addProduct(vm.order)\" \nng-if=\"vm.config.ims.orders.positions.addNewProduct && vm.isEditable(vm.dialogConfig.details.editButton)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><nuit-product-section flex \nng-repeat=\"product in vm.order.products track by $index\" \ncustom-fields=\"vm.config.ims.orders.positions.products.customFields.top\" product=\"product\" allow-edit=\"true\" \nshow-prices=\"vm.showPrices\" show-base-price=\"vm.showPrices\" read-only=\"vm.dialogConfig.products\" min-positions=\"0\" \nmax-positions=\"1000\" selectable=\"false\" soft-delete=\"false\" on-image-click=\"vm.openImage(product.image)\" \nng-class=\"{\'mb-50\':$last}\" on-product-updated=\"vm.markModifiedProduct(product)\" \non-position-changed=\"vm.markModifiedProduct(product)\" on-position-added=\"vm.markModifiedProduct(product)\" \non-position-removed=\"vm.markModifiedProduct(product,index)\" show-pos-number=\"vm.showPosNumber\"></nuit-product-section>\n<md-divider ng-if=\"vm.order.sketches.length > 0\"></md-divider><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.order.sketches.length > 0\"><h2 translate=\"SKETCH.SKETCH_NAV\">Sketches</h2></div><div \nng-repeat=\"sketch in vm.order.sketches track by sketch.id\" class=\"mb-20 p-16\" layout-fill layout=\"row\" flex><div \nlayout=\"column\" flex><div layout=\"row\" layout-align=\"start center\" layout-wrap><nuit-pos-number \nng-if=\"vm.showPosNumber\" number=\"sketch.posNumber\"></nuit-pos-number></div><div layout=\"row\"><div class=\"mr-24\" \nlayout=\"column\" layout-align=\"start stretch\"><div class=\"b img-container\"><img ng-if=\"sketch.preview\" \nnuit-doc-src=\"{{ sketch.preview }}\" fallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\" \ndraggable=\"false\" alt=\"Image\" ng-click=\"vm.openImage(sketch.preview)\"> <img ng-if=\"!sketch.preview\" \nsrc=\"assets/images/ecommerce/product-image-placeholder.jpg\" draggable=\"false\" alt=\"Image\"></div><div layout=\"row\" \nng-if=\"sketch.preview\"><md-button class=\"b m-0\" flex ng-click=\"vm.downloadDocument(sketch.preview, sketch.name)\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"APP.DOWNLOAD\">Download</span></md-tooltip>\n</md-button><md-button class=\"b m-0\" flex ng-click=\"vm.openDocument(sketch.preview, sketch.name)\"><md-icon \nmd-font-icon=\"icon-open-in-new\"></md-icon><md-tooltip><span translate=\"APP.NEW_TAB\">Open in new tab</span></md-tooltip>\n</md-button></div></div><div layout=\"column\" flex style=\"min-width:200px\"><md-input-container class=\"md-block\"><label \ntranslate=\"APP.NAME\">Name</label><input type=\"text\" ng-model=\"sketch.name\" ng-change=\"vm.markModifiedSketch(sketch)\" \nng-disabled=\"!vm.isEditable(vm.dialogConfig.positions.nameEditable)\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"ORDERS.REMARK\">Remark</label><input type=\"text\" ng-model=\"sketch.remark\" \nng-change=\"vm.markModifiedSketch(sketch)\" ng-disabled=\"!vm.isEditable(vm.dialogConfig.positions.remarkEditable)\">\n</md-input-container></div></div></div></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.config.ims.orders.positions.addNewSpecial || vm.order.specials.length>0\">\n<h2 translate=\"ORDERS.SPECIALS\">Specials</h2><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.addSpecial(vm.order)\" \nng-if=\"vm.config.ims.orders.positions.addNewSpecial && vm.isEditable(vm.dialogConfig.details.editButton)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nng-if=\"vm.config.ims.orders.positions.addNewSpecial && vm.order.specials.length>0\" class=\"lengths\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\" ng-if=\"vm.showPosNumber\"><div \nclass=\"table-header text-center\"><span class=\"column-title\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\"><span translate=\"PRODUCT.NAME\">Name</span></span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"PRODUCT.REMARK\">Remark</span></div></th><th class=\"secondary-text\"><div class=\"table-header text-center\">\n<span class=\"column-title\" translate=\"SALES.QUANTITY\"></span></div></th><th class=\"secondary-text\" \nng-if=\"vm.showPrices\"><div class=\"table-header text-center\"><span class=\"column-title\" translate=\"PRODUCT.BASE_PRICE\">\nBasePrice</span></div></th><th class=\"secondary-text\" ng-if=\"vm.showPrices\"><div class=\"table-header text-center\"><span\n class=\"column-title\" translate=\"APP.PRICE\">Price</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat-start=\"special in vm.order.specials track by $index\"><td ng-if=\"vm.showPosNumber\" class=\"text-left\">\n<nuit-pos-number number=\"special.posNumber\"></nuit-pos-number></td><td class=\"text-center\"><md-input-container \nstyle=\"min-width: 100% !important; max-width: 100% !important; width:100% !important\"><input type=\"text\" \nclass=\"md-block\" ng-model=\"special.title\" ng-disabled=\"vm.isEditable(vm.dialogConfig.specials)\" \nstyle=\"min-width: 100% !important; max-width: 100% !important; width:100% !important\"></md-input-container></td><td \nclass=\"text-center\"><md-input-container class=\"md-block\" \nstyle=\"min-width: 100% !important; max-width: 100% !important; width:100% !important\"><input type=\"text\" \nng-model=\"special.remark\" ng-disabled=\"vm.isEditable(vm.dialogConfig.specials)\" \nstyle=\"min-width: 100% !important; max-width: 100% !important; width:100% !important\"></md-input-container></td><td \nclass=\"text-center\"><md-input-container><input type=\"number\" ng-model=\"special.quantity\" \nng-disabled=\"vm.isEditable(vm.dialogConfig.specials)\"></md-input-container></td><td class=\"text-center\" \nng-if=\"vm.showPrices\"><md-input-container><input type=\"number\" ng-model=\"special.basePrice\" \nng-disabled=\"vm.isEditable(vm.dialogConfig.specials)\"></md-input-container>{{vm.config.localization.currency.symbol}}\n</td><td class=\"text-center\" ng-if=\"vm.showPrices\">{{special.price | nuitCurrency}}</td><td class=\"text-center\">\n<md-button class=\"md-icon-button\" ng-disabled=\"vm.isEditable(vm.dialogConfig.specials)\"><md-icon \nmd-font-icon=\"icon-close\" ng-click=\"vm.order.specials.splice($index, 1);vm.setDirty();\"></md-icon></md-button></td>\n</tr><tr ng-repeat-end></tr></tbody></table></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\"><h2 flex translate=\"APP.ATTACHMENTS\">Products</h2><div><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.addAttachment()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div></div><div ng-repeat=\"attachment in vm.order.attachments\" layout=\"column\" layout-align=\"center center\" \nclass=\"mh-0 grey-100-bg mb-10\"><div layout=\"row\" layout-align=\"start center\" layout-fill><div \nstyle=\"width: 100px;height: 100px\" layout=\"column\" layout-align=\"center center\" class=\"mh-10\"><img \nng-if=\"attachment.contentType.indexOf(\'image/\')!==-1\" name=\"{{attachment.filename}}\" http-src=\"{{attachment.url}}\" \nstyle=\"cursor: pointer\" ng-click=\"vm.openImage(attachment.url)\"> <a \nng-if=\"attachment.contentType.indexOf(\'image/\')!==-1\" ng-click=\"vm.openImage(attachment.url)\" md-truncate>\n{{attachment.filename}}</a> <a ng-if=\"attachment.contentType.indexOf(\'application/\')!==-1\" md-truncate \nng-href=\"{{vm.getDocumentURL(attachment)}}\" target=\"_blank\">{{attachment.filename}}</a></div><div layout=\"column\" flex \nlayout-fill><md-input-container class=\"mt-20\" flex><label translate=\"APP.NAME\"></label><input maxlength=\"50\" \nmd-maxlength=\"50\" ng-model=\"attachment.name\" ng-blur=\"vm.update()\"></md-input-container><md-input-container \nclass=\"m-0\" flex><label translate=\"APP.DESCRIPTION\"></label><input maxlength=\"150\" md-maxlength=\"150\" \nng-model=\"attachment.desc\" ng-blur=\"vm.update()\"></md-input-container></div><div class=\"ml-10\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.order.attachments.splice($index);vm.setDirty();\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s20\"></md-icon></md-button></div></div></div></div></md-content>");
$templateCache.put("app/main/orders.orders/views/partials/sales.html","<md-content class=\"thread-detail\" id=\"order-details-sales\" layout=\"column\" ms-scroll><div class=\"mh-30 mv-30\" \nlayout=\"row\"><div flex=\"40\" layout=\"column\"><div flex-order=\"-20\" class=\"grey-200-bg p-5 text-bold mb-5\" flex \ntranslate=\"CART.PRICE\"></div><ng-include ng-repeat=\"key in [\'basePrice\']\" ng-if=\"vm.showSalesPosition(key,vm.order)\" \nflex-order=\"{{vm.getSalesPosition(key)}}\" src=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include>\n<ng-include ng-repeat=\"key in [\'globalDiscount\']\" ng-if=\"vm.showSalesPosition(key,vm.order)\" \nflex-order=\"{{vm.getSalesPosition(key)}}\" src=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include>\n<md-divider ng-if=\"vm.showSalesPosition(\'globalDiscount\',vm.order)\" \nflex-order=\"{{vm.getSalesPosition(\'globalDiscount\',1)}}\"></md-divider><ng-include \nng-repeat=\"key in [\'priceGlobalDiscount\']\" ng-if=\"vm.showSalesPosition(\'globalDiscount\',vm.order)\" \nflex-order=\"{{vm.getSalesPosition(\'globalDiscount\', 2)}}\" src=\"\'app/main/orders.orders/views/partials/sales_row.html\'\">\n</ng-include><ng-include ng-repeat=\"key in [\'onlineDiscount\']\" ng-if=\"vm.showSalesPosition(key,vm.order)\" \nflex-order=\"{{vm.getSalesPosition(key)}}\" src=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include>\n<md-divider ng-if=\"vm.showSalesPosition(\'onlineDiscount\',vm.order)\" \nflex-order=\"{{vm.getSalesPosition(\'onlineDiscount\',1)}}\"></md-divider><ng-include \nng-if=\"vm.showSalesPosition(\'onlineDiscount\',vm.order)\" flex-order=\"{{vm.getSalesPosition(\'onlineDiscount\',2)}}\" \nng-repeat=\"key in [\'priceOnlineDiscount\']\" src=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include>\n<ng-include ng-if=\"vm.showSalesPosition(\'minPrice\',vm.order)\" flex-order=\"{{vm.getSalesPosition(\'minPrice\')}}\" \nng-repeat=\"key in [\'minPriceDifference\']\" src=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include>\n<md-divider ng-if=\"vm.showSalesPosition(\'minPrice\',vm.order)\" flex-order=\"{{vm.getSalesPosition(\'minPrice\',1)}}\">\n</md-divider><ng-include ng-if=\"vm.showSalesPosition(\'minPrice\',vm.order)\" \nflex-order=\"{{vm.getSalesPosition(\'minPrice\',2)}}\" ng-repeat=\"key in [\'price\']\" \nsrc=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include><ng-include \nng-if=\"vm.showSalesPosition(key,vm.order)\" flex-order=\"{{vm.getSalesPosition(key)}}\" ng-repeat=\"key in [\'orderFee\']\" \nsrc=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include><ng-include \nng-repeat=\"key in [\'logisticPrice\']\" ng-if=\"vm.showSalesPosition(key,vm.order)\" \nflex-order=\"{{vm.getSalesPosition(key)}}\" src=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include>\n<md-divider ng-if=\"vm.showSalesPosition(\'netPrice\',vm.order)\" flex-order=\"{{vm.getSalesPosition(\'netPrice\')}}\">\n</md-divider><ng-include ng-if=\"vm.showSalesPosition(key,vm.order)\" flex-order=\"{{vm.getSalesPosition(key, 1)}}\" \nng-repeat=\"key in [\'netPrice\']\" src=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include><div \nclass=\"p-5\" layout=\"row\" layout-align=\"space-between\" ng-if=\"vm.showSalesPosition(\'taxes\',vm.order)\" \nflex-order=\"{{vm.getSalesPosition(\'taxes\')}}\"><div layout=\"row\"><div class=\"text-bold\" flex>\n{{\"ORDERS.SALES.TAXES\" | translate}} <span ng-if=\"vm.config.ims.orders.sales.editable.indexOf(\'vatPercent\')===-1\">\n({{vm.order.sales.vatPercent }}%)</span></div><div class=\"pl-5\" layout-align=\"start\" \nng-if=\"vm.config.ims.orders.sales.editable.indexOf(\'vatPercent\')!==-1\"><span>(</span> <input name=\"vatPercent\" \nng-model=\"vm.order.sales.vatPercent\" style=\"width: 30px !important\" type=\"number\"> <span>%)</span></div></div><div><div\n ng-if=\"vm.config.ims.orders.sales.editable.indexOf(\'taxes\')===-1\"><span>{{vm.order.sales.taxes | nuitCurrency}}</span>\n</div><div ng-if=\"vm.config.ims.orders.sales.editable.indexOf(\'taxes\')!==-1\"><span ng-if=\"vm.symbolInFront(\'taxes\')\">\n{{vm.getSymbolForKey(\'taxes\')}}</span> <input name=\"taxes\" ng-model=\"vm.order.sales.taxes\" type=\"number\"> <span \nng-if=\"!vm.symbolInFront(\'taxes\')\">{{vm.getSymbolForKey(\'taxes\')}}</span></div></div></div><md-divider \nng-if=\"vm.showSalesPosition(\'grossPrice\',vm.order)\" flex-order=\"{{vm.getSalesPosition(\'grossPrice\')}}\"></md-divider>\n<ng-include ng-if=\"vm.showSalesPosition(key,vm.order)\" flex-order=\"{{vm.getSalesPosition(key,1)}}\" \nng-repeat=\"key in [\'grossPrice\']\" src=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include></div><div \nclass=\"ml-100\" flex=\"40\" layout=\"column\"><div class=\"grey-200-bg p-5 text-bold mb-5\" translate=\"CART.OVERVIEW\"></div>\n<ng-include ng-repeat=\"key in [\'maxLength\', \'weight\', \'minPrice\']\" \nsrc=\"\'app/main/orders.orders/views/partials/sales_row.html\'\"></ng-include></div></div></md-content>");
$templateCache.put("app/main/orders.orders/views/partials/sales_row.html","<div ng-if=\"vm.order.sales\"><div layout=\"row\" class=\"p-5\"><div class=\"text-bold\" flex><span \ntranslate=\"{{\'ORDERS.SALES.\' + key.toUpperCase() | translate}}\"></span> <span ng-if=\"vm.order.sales.discounts[key]\">\n({{vm.order.sales.discounts[key]}}%)</span></div><div flex=\"nogrow\"><div \nng-if=\"vm.config.ims.orders.sales.editable.indexOf(key)===-1\"><span \nng-if=\"key.toLowerCase().includes(\'discount\') && !key.toLowerCase().includes(\'price\')\">- </span><span \nng-if=\"key.toLowerCase().includes(\'difference\')\">+ </span><span ng-if=\"vm.symbolInFront(key)\">\n{{vm.getSymbolForKey(key).trim()}} </span><span>{{vm.getValue(vm.order.sales[key],key)}}</span> <span \nng-if=\"!vm.symbolInFront(key)\">{{vm.getSymbolForKey(key).trim()}}</span></div><div \nng-if=\"vm.config.ims.orders.sales.editable.indexOf(key)!==-1\"><span \nng-if=\"key.toLowerCase().includes(\'discount\') && !key.toLowerCase().includes(\'price\')\">- </span><span \nng-if=\"key.toLowerCase().includes(\'difference\')\">+ </span><span ng-if=\"vm.symbolInFront(key)\">\n{{vm.getSymbolForKey(key)}}</span> <span \nng-if=\"vm.order.sales.overrides && vm.order.sales.overrides.hasOwnProperty(key)\"><md-icon style=\"cursor: pointer\" \nng-if=\"!vm.needsInputConversion(key)\" md-font-icon=\"icon-lock-unlocked\" ng-click=\"vm.deleteOverride(key)\"></md-icon>\n<input ng-if=\"!vm.needsInputConversion(key)\" name=\"{{key}}\" ng-model=\"vm.order.sales.overrides[key]\" type=\"number\">\n<md-icon style=\"cursor: pointer\" ng-if=\"vm.needsInputConversion(key)\" md-font-icon=\"icon-lock-unlocked\" \nng-click=\"vm.deleteOverride(key)\"></md-icon><input ng-if=\"vm.needsInputConversion(key)\" name=\"{{key}}\" \nng-model=\"vm.order.sales.overrides[key]\" type=\"number\" nuit-unit-input=\"{{::vm.getInputConversionType(key)}}\"> </span>\n<span ng-if=\"!vm.order.sales.overrides || !vm.order.sales.overrides.hasOwnProperty(key)\"><md-icon \nstyle=\"cursor: pointer\" ng-if=\"vm.writeToOverride(key) && !vm.needsInputConversion(key)\" md-font-icon=\"icon-lock\" \nng-click=\"vm.onChangeOverrideValue(key)\"></md-icon><input ng-disabled=\"vm.writeToOverride(key)\" \nng-if=\"!vm.needsInputConversion(key)\" name=\"{{key}}\" ng-model=\"vm.order.sales[key]\" type=\"number\"><md-icon \nstyle=\"cursor: pointer\" ng-if=\"vm.writeToOverride(key) && vm.needsInputConversion(key)\" md-font-icon=\"icon-lock\" \nng-click=\"vm.onChangeOverrideValue(key)\"></md-icon><input ng-disabled=\"vm.writeToOverride(key)\" \nng-if=\"vm.needsInputConversion(key)\" name=\"{{key}}\" ng-model=\"vm.order.sales[key]\" type=\"number\" \nnuit-unit-input=\"{{::vm.getInputConversionType(key)}}\"> </span><span ng-if=\"!vm.symbolInFront(key)\">\n{{vm.getSymbolForKey(key)}}</span></div></div></div></div>");
$templateCache.put("app/main/orders.proposals/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.proposals\" default-name=\"ORDERS_PROPOSALS_SETTINGS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/orders.settings/dialogs/edit-order-tag/edit-order-tag.html","<md-dialog id=\"edit-tag\"><form ng-cloak name=\"tagForm\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 \nflex>{{vm.isNew?\'ORDER.TAG.ADD\':\'ORDER.TAG.UPDATE\' | translate}}</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"pb-0\" ms-scroll style=\"position:relative\"><div class=\"md-dialog-content\"><div layout=\"row\"><md-input-container \nflex><label translate=\"ORDER.TAG.NAME\">Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.tag.name\" required>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"20\"><label translate=\"APP.LANGUAGE\">Lang</label>\n<md-select ng-model=\"vm.currentLanguage\"><md-option ng-repeat=\"lang in vm.languages\" ng-value=\"lang\"><span \nclass=\"text-uppercase\">{{lang}}</span></md-option></md-select></md-input-container><md-input-container flex=\"80\"><label\n translate=\"ORDER.TAG.LOCALIZED_NAME\">Localized Name</label><input type=\"text\" name=\"localizedName\" \nng-model=\"vm.tag.localizedName[vm.currentLanguage]\"></md-input-container></div><div layout=\"row\"><md-input-container \nflex><label translate=\"ORDER.TAG.GROUP\">Group</label><input type=\"text\" name=\"group\" ng-model=\"vm.tag.group\">\n</md-input-container></div></div><div ng-if=\"vm.userSelection\"><div layout=\"row\" layout-align=\"left center\"><h2 flex \ntranslate=\"NOTIFICATIONS.USERS\" class=\"mt-0\"></h2><md-button class=\"md-icon-button\" ng-click=\"vm.openUserSelection()\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"APP.EDIT\">Edit</span></md-tooltip>\n</md-button><md-button ng-if=\"vm.currentUser.id\" class=\"md-icon-button\" ng-click=\"vm.currentUser={}\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button>\n</div><div layout=\"row\" flex><span class=\"name text-truncate\" flex ng-if=\"vm.currentUser.id\"><nuit-person-name \nclass=\"text-bold\" person=\"vm.currentUser\"></nuit-person-name><nuit-email email=\"vm.currentUser.email\" flex layout-fill>\n</nuit-email></span><span flex ng-if=\"!vm.currentUser.id\">-</span></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Abbrechen</span>\n</md-button><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" ng-disabled=\"tagForm.$invalid\"><span \ntranslate=\"APP.SAVE\">Speichern</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/orders.settings/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.order_settings\" default-name=\"ORDERS_SETTINGS_SETTINGS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/orders.settings/views/partials/number-details.html","<div id=\"user\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div \nclass=\"content-card\" layout=\"column\" flex><form name=\"vm.numbersForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"{{vm.origin?vm.origin:\'app.\'+vm.numberType+\'_number\'}}\"><md-icon md-font-icon=\"icon-keyboard-backspace\">\n</md-icon></md-button><div class=\"action-buttons\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"divider-vertical mr-20\"></div><span class=\"md-title\">\n{{vm.numberType.toUpperCase() +\'.\' + vm.numberType.toUpperCase() + \'_NUMBER\' |translate}}</span></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.saveNumber()\" \nng-disabled=\"!vm.numbersForm.$valid || !vm.numbersForm.$dirty\" translate=\"APP.SAVE\">Speichern</md-button></div></div>\n<div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content-tabs\" layout=\"column\" layout-fill flex>\n<div class=\"content\" ng-if=\"vm.loadingItems\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><div layout=\"column\" class=\"mt-10\"><div layout=\"column\" layout-gt-md=\"row\" \nlayout-align=\"start\"><div layout=\"row\"><div class=\"m-20\" layout=\"column\" style=\"min-width: 320px\"><div layout=\"row\">\n<span translate=\"APP.INVOICE_NUMBER.START_DATE\">Start </span><span>*</span></div><md-input-container \nng-if=\"vm.updatePossible\"><md-datepicker class=\"mv-10\" ng-model=\"vm.numbers.start\" md-current-view=\"year\" \nmd-placeholder=\"{{\'APP.SELECT\' | translate}}\" required name=\"dateFieldStart\"></md-datepicker><div \nng-messages=\"vm.numbersForm.dateFieldStart.$error\"><div ng-message=\"valid\" translate=\"APP.INVOICE_NUMBER.INVALID_DATE\">\nThe entered value is not a date!</div><div ng-message=\"required\" translate=\"APP.INVOICE_NUMBER.REQUIRED_DATE\">\nThis date is required!</div></div></md-input-container><div ng-if=\"!vm.updatePossible\" layout=\"row\" \nlayout-align=\"start center\" class=\"mv-20\"><md-icon class=\"ml-0 mr-10\" md-font-icon=\"icon-calendar-check\"></md-icon>\n<span>{{vm.numbers.start | nuitDate:\'date\'}}</span></div></div><div class=\"m-20 mr-80\" layout=\"column\"><div \nlayout=\"row\"><span translate=\"APP.INVOICE_NUMBER.END_DATE\">End </span>*</div><md-input-container><md-datepicker \nclass=\"mt-10\" ng-model=\"vm.numbers.end\" md-current-view=\"year\" md-placeholder=\"{{\'APP.SELECT\' | translate}}\" \nname=\"dateField\" required name=\"dateField\"></md-datepicker><div ng-messages=\"vm.numbersForm.dateField.$error\"><div \nng-message=\"valid\" translate=\"APP.INVOICE_NUMBER.INVALID_DATE\">The entered value is not a date!</div><div \nng-message=\"required\" translate=\"APP.INVOICE_NUMBER.REQUIRED_DATE\">This date is required!</div></div>\n</md-input-container></div></div><div ng-if=\"vm.showNumbers\" class=\"m-20\" flex-order=\"-1\" flex-order-gt-md=\"1\"><div \nclass=\"p-10 blue-grey-50-bg\" layout=\"row\" style=\"width: fit-content\"><span translate=\"APP.INVOICE_NUMBER.NUMBER\">\nAnzahl von Rechnungen (Number)</span> <span>: <strong>{{vm.numbers.number}}</strong></span></div></div></div><div><div \nclass=\"m-20\" layout=\"column\" flex=\"40\"><md-input-container \nstyle=\"width: 680px; margin-top: 0; margin-bottom: 0 !important\"><div style=\"margin-bottom: 18px\"><span \ntranslate=\"APP.TEMPLATE\">Tpl </span>*</div><input name=\"tpl\" type=\"text\" ng-model=\"vm.numbers.tpl\" \nng-disabled=\"!vm.updatePossible\" required><div ng-messages=\"vm.numbersForm.tpl.$error\" role=\"alert\"><div \nng-message=\"required\" class=\"my-message\"><span translate=\"APP.TEMPLETE.ERROR\"></span></div></div></md-input-container>\n<div layout=\"row\"><md-button ng-repeat=\"field in vm.tplFields\" ng-click=\"vm.setTpl(field)\" \nclass=\"md-whiteframe-1dp mh-5\" ng-disabled=\"!vm.updatePossible\"><span>{{(\'APP.\' + (field | uppercase)) | translate }}\n</span></md-button></div></div></div><div layout=\"row\"><div class=\"m-20\" layout=\"column\"><md-input-container \nstyle=\"width: 320px\"><span translate=\"APP.INVOICE_NUMBER.OFFSET\">Offset</span> <input type=\"number\" \nng-model=\"vm.numbers.offset\" ng-disabled=\"!vm.updatePossible\"></md-input-container></div><div class=\"m-20\" \nlayout=\"column\"><md-input-container style=\"width: 320px\"><span translate=\"APP.INVOICE_NUMBER.SIZE\">Size</span> <input \nng-disabled=\"!vm.updatePossible\" type=\"number\" ng-model=\"vm.numbers.size\"></md-input-container></div></div><div \nlayout=\"row\"><div class=\"m-20\" layout=\"column\" style=\"width: 320px\"><md-switch ng-model=\"vm.numbers.autoRenew\" \nng-disabled=\"vm.requiredField\"><span translate=\"APP.INVOICE_NUMBER.AUTORENEW\"></span></md-switch></div><div \nclass=\"m-20\" layout=\"column\" ng-if=\"vm.numbers.autoRenew\"><md-input-container style=\"width: 320px\"><span>RenewOffset\n</span> <input type=\"number\" ng-model=\"vm.numbers.renewOffset\"></md-input-container></div></div></div></md-content>\n</div></form></div></div></div>");
$templateCache.put("app/main/partners.companies/components/company-trigger/company-trigger.html","<md-card ng-repeat=\"(key, value) in vm.company.notification.trigger\" \nng-if=\"vm.company.notification.hasOwnProperty(\'trigger\')\"><md-card-header class=\"ph-20 p-0 mb-0\" layout=\"row\" \nlayout-align=\"center center\"><h2 flex>{{(\'NOTIFICATIONS.TRIGGER.\' + key.toUpperCase()) | translate}}</h2><md-button \nclass=\"md-icon-button md-raised\" ng-click=\"vm.remove(vm.company, key)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-card-header><md-card-content class=\"pt-0\"><md-content class=\"p-10\"><md-checkbox class=\"md-primary\" \nng-model=\"value.disableDefaultNotifications\" ng-change=\"vm.update(vm.company)\"><span \ntranslate=\"NOTIFICATIONS.TRIGGER.DISABLE_DEFAULT_NOTIFICATIONS\"></span></md-checkbox></md-content><div layout=\"row\" \nlayout-align=\"start start\"><md-card flex=\"66\" layout=\"column\" layout-padding><div layout=\"row\" \nlayout-align=\"center center\" class=\"p-0\"><h3 flex translate=\"NOTIFICATIONS.USERS\" flex></h3><md-button \nng-click=\"vm.addUser(key)\" ng-disabled=\"vm.getValidUsers(vm.company, key).length===0\" class=\"md-icon-button md-raised\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content class=\"p-0 bt pv-10\" \nng-repeat=\"(k, receiver) in value.receivers\" layout=\"row\" ng-if=\"receiver.userId && receiver.userId!==0\" \nng-init=\"person = vm.getPerson(receiver.userId)\" layout-align=\"center center\"><div layout=\"column\" class=\"mh-10\">\n<nuit-person-name flex class=\"text-bold\" person=\"person\"></nuit-person-name><nuit-email flex email=\"person.email\" \nlayout-fill></nuit-email></div><nuit-phone flex phone=\"person.phone\" layout-fill></nuit-phone><md-button \nclass=\"md-icon-button\" ng-click=\"vm.removeReceiver(key,$index)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-content></md-card><md-card flex=\"33\" layout=\"column\" layout-padding><div layout=\"row\" \nlayout-align=\"center center\" class=\"p-0\"><h3 flex translate=\"NOTIFICATIONS.ADDITIONAL\"></h3><md-button \nng-click=\"vm.addAdditional(key)\" class=\"md-icon-button md-raised\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><md-content class=\"p-0 bt pv-10\" ng-repeat=\"(k, receiver) in value.receivers\" \nng-if=\"!receiver.userId || receiver.userId===0\" layout=\"row\" layout-align=\"center center\"><nuit-email flex=\"nogrow\" \nemail=\"receiver.contactData.email\" layout-fill></nuit-email><div>({{receiver.contactData.lang}})</div><div flex></div>\n<md-button class=\"md-icon-button\" ng-click=\"vm.removeReceiver(key,$index)\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-content></md-card></div></md-card-content></md-card>");
$templateCache.put("app/main/partners.companies/dialogs/add-notification-additional/add-notification-additional.html","<md-dialog><md-toolbar class=\"md-accent-bg pl-24\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"APP.ADD\"></span></md-toolbar><md-dialog-content class=\"pb-0\"><form name=\"vm.userForm\" novalidate \nng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\" layout=\"row\"><md-input-container flex><label \ntranslate=\"COMPANY.EMAIL\">E-Mail</label><input type=\"text\" name=\"email\" ng-model=\"vm.contactData.email\" required>\n</md-input-container><md-input-container><md-select class=\"m-0\" ng-model=\"vm.contactData.lang\" required flex><md-option\n ng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span>{{(\'APP.LANG_\' + lang.toUpperCase()) | translate}}\n</span></md-option></md-select></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.close()\" aria-label=\"n\"><span \ntranslate=\"APP.CANCEL\">Cancel</span></md-button><md-button ng-disabled=\"!vm.userForm.$valid || !vm.userForm.$dirty\" \nng-click=\"vm.save()\" class=\"md-accent md-raised\"><span translate=\"APP.SAVE\">Save</span></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/partners.companies/dialogs/add-notification-user/add-notification-user.html","<md-dialog><md-toolbar class=\"md-accent-bg pl-24\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"APP.ADD\"></span></md-toolbar><md-dialog-content class=\"pb-0\"><form name=\"vm.userForm\" novalidate \nng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\" flex><div layout=\"row\" flex ng-if=\"vm.users.length > 0\">\n<md-input-container flex class=\"mr-15\"><label translate=\"NOTIFICATIONS.USER\">Name</label><md-select ng-model=\"vm.user\" \nrequired><md-option ng-repeat=\"user in vm.users | orderBy\" ng-value=\"user.id\"><nuit-person-name person=\"user\">\n</nuit-person-name></md-option></md-select></md-input-container></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.close()\" aria-label=\"n\"><span \ntranslate=\"APP.CANCEL\">Cancel</span></md-button><md-button ng-disabled=\"!vm.userForm.$valid || !vm.userForm.$dirty\" \nng-click=\"vm.save()\" class=\"md-accent md-raised\"><span translate=\"APP.SAVE\">Save</span></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/partners.companies/dialogs/add-trigger/add-trigger.html","<md-dialog><md-toolbar class=\"md-accent-bg pl-24\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"APP.ADD\"></span></md-toolbar><md-dialog-content class=\"pb-0\"><form name=\"vm.triggerForm\" novalidate \nng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\" flex><div layout=\"row\" flex \nng-if=\"vm.availableTriggers.length > 0\"><md-input-container flex class=\"mr-15\"><label \ntranslate=\"NOTIFICATIONS.TRIGGERS\">Name</label><md-select ng-model=\"vm.trigger\" required><md-option \nng-repeat=\"trigger in vm.availableTriggers | orderBy\" ng-value=\"trigger\">\n{{(\'NOTIFICATIONS.TRIGGER.\' + trigger.toUpperCase()) | translate}}</md-option></md-select></md-input-container></div>\n<div ng-if=\"vm.availableTriggers.length===0\"><span translate=\"NOTIFICATIONS.NO_TRIGGERS\"></span></div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \nng-click=\"vm.close()\" aria-label=\"n\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nng-disabled=\"!vm.triggerForm.$valid || !vm.triggerForm.$dirty\" ng-click=\"vm.save()\" class=\"md-accent md-raised\"><span \ntranslate=\"APP.SAVE\">Save</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/partners.companies/dialogs/raw-material-discount/raw-material-discount.html","<md-dialog><md-toolbar class=\"md-accent-bg pl-24\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"COMPANIES.RAW_MATERIAL_DISCOUNT\"></span></md-toolbar><md-dialog-content class=\"pb-0\"><form \nname=\"vm.discountForm\" novalidate ng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\" flex><div layout=\"row\" flex \nng-if=\"vm.rawMaterials.length > 0\"><md-input-container flex class=\"mr-15\"><label translate=\"MATERIAL.GROUP\">Name\n</label><md-select ng-model=\"vm.discount.rawMaterialId\" required ng-disabled=\"!vm.isNew\"><md-option \nng-repeat=\"rawMaterial in vm.rawMaterials | orderByNuitTranslated:\'name\'\" ng-value=\"rawMaterial.id\">\n{{rawMaterial.name | nuitTranslate}}</md-option></md-select></md-input-container><md-input-container flex><label><span \ntranslate=\"APP.DISCOUNT\">Rabatt</span>&nbsp;(%)</label><input type=\"number\" name=\"percent\" \nng-model=\"vm.discount.percent\" aria-label=\"percentage\" required step=\"0.01\" max=\"100.00\" min=\"0.00\">\n</md-input-container></div><div ng-if=\"vm.rawMaterials.length === 0\" class=\"m-10\"><span \ntranslate=\"MATERIAL_GROUP.NO_FURTHER_AVAILABLE\"></span></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.close()\" aria-label=\"n\"><span \ntranslate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nng-disabled=\"!vm.discountForm.$valid || !vm.discountForm.$dirty\" ng-click=\"vm.save()\" class=\"md-accent md-raised\"><span\n translate=\"APP.SAVE\">Save</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/partners.companies/views/partials/company-bank-account.html","<div layout=\"row\" layout-margin layout-align=\"space-between start\"><div layout=\"column\" flex><md-input-container \nng-if=\"vm.config.ims.companies.bankAccountEnabled\" flex><label translate=\"COMPANY.IBAN\">Name</label><input type=\"text\" \nname=\"iban\" ng-model=\"vm.company.iban\" aria-label=\"IBAN\"></md-input-container><md-input-container \nng-if=\"vm.config.ims.companies.bankAccountEnabled\" flex><label translate=\"COMPANY.BIC\">Name</label><input type=\"text\" \nname=\"bic\" ng-model=\"vm.company.bic\" aria-label=\"BIC\"></md-input-container><div layout=\"row\"><md-input-container flex>\n<label translate=\"COMPANY.VAT_ID\">VAT</label><input type=\"text\" name=\"taxId\" ng-model=\"vm.company.taxId\" \naria-label=\"TAX_ID\"></md-input-container><md-input-container flex><label translate=\"COMPANY.VAT\">VAT</label><input \ntype=\"number\" name=\"vat\" ng-model=\"vm.company.vat\" aria-label=\"VAT\"></md-input-container></div><md-input-container \nflex><label translate=\"COMPANY.CUSTOMER_ID\">VAT</label><input type=\"text\" name=\"customerId\" \nng-model=\"vm.company.customerId\" aria-label=\"customerId\"></md-input-container><md-input-container flex><label \ntranslate=\"COMPANY.CRN\">CRN</label><input type=\"text\" name=\"crn\" ng-model=\"vm.company.crn\" aria-label=\"UID\">\n</md-input-container><div layout=\"row\" flex><md-input-container flex><label translate=\"COMPANY.GLOBAL_DISCOUNT\">\nglobaler Rabatt %</label><input type=\"number\" name=\"globaldiscount\" ng-model=\"vm.company.globalDiscount\" \naria-label=\"GLOBALDISCOUNT\"></md-input-container><md-input-container flex><label translate=\"COMPANY.ONLINE_DISCOUNT\">\nOnlinerabatt %</label><input type=\"number\" name=\"onlinediscount\" ng-model=\"vm.company.onlineDiscount\" \naria-label=\"ONLINEDISCOUNT\"></md-input-container></div><div layout=\"row\" flex><md-input-container flex><label \ntranslate=\"COMPANY.PROCESSING_DISCOUNT\">Bearbeitungsrabatt %</label><input type=\"number\" name=\"processingdiscount\" \nng-model=\"vm.company.processingDiscount\" aria-label=\"PROCESSINGDISCOUNT\"></md-input-container><md-input-container flex>\n<label translate=\"COMPANY.CUSTOMER_DISCOUNT\">Kundenrabatt %</label><input type=\"number\" name=\"customerdiscount\" \nng-model=\"vm.company.customerDiscount\" aria-label=\"CUSTOMERDISCOUNT\"></md-input-container><md-input-container flex>\n<label translate=\"COMPANY.GLOBAL_PRODUCT_DISCOUNT\">globaler Produkt Rabatt %</label><input type=\"number\" \nname=\"globalproductdiscount\" ng-model=\"vm.company.globalProductDiscount\" aria-label=\"GLOBALPRODUCTDISCOUNT\">\n</md-input-container></div><md-input-container flex ng-show=\"vm.config.ims.companies.volumeDiscountEnabled\"><label \ntranslate=\"COMPANY.VOLUME_DISCOUNT\">Mengenrabatt</label><input type=\"number\" name=\"volumediscount\" \nng-model=\"vm.company.volumeDiscount\" aria-label=\"VOLUMEDISCOUNT\"></md-input-container><md-input-container flex><label \ntranslate=\"COMPANY.MIN_ORDER_VALUE\">Mindestbestellwert</label><input type=\"number\" name=\"minordervalue\" \nng-model=\"vm.company.minOrderValue\" aria-label=\"VOLUMEDISCOUNT\"></md-input-container></div><div layout=\"column\" flex \nlayout-fill><span class=\"selectById\"><md-input-container flex \nng-style=\"{ marginBottom: vm.paymentCondition===vm.PROPORTIONS ? \'0px\' : \'18px\' }\"><label \ntranslate=\"COMPANY.PAYMENT_CONDITION\">Zahlungsbedingung</label><nuit-select-by-id current-id=\"vm.paymentCondition\" \nlist=\"vm.conditions\" entity-format=\"formattedText\"></nuit-select-by-id></md-input-container></span><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.paymentCondition===vm.PROPORTIONS\" layout-fill><span \ntranslate=\"COMPANY.PAYMENT_BEFORE_AFTER\" \ntranslate-values=\"{beforePercentage: vm.company.paymentCondition,afterPercentage: 100-vm.company.paymentCondition}\">\n<span></span></span></div><md-slider-container ng-if=\"vm.paymentCondition===vm.PROPORTIONS\"><md-slider flex min=\"1\" \nmax=\"99\" ng-model=\"vm.company.paymentCondition\"></md-slider><md-input-container><input flex type=\"number\" \nng-model=\"vm.company.paymentCondition\" min=\"1\" max=\"99\" ng-minlength=\"1\" ng-maxlength=\"2\" \nng-blur=\"vm.validatePaymentCondition()\"></md-input-container></md-slider-container><div layout=\"row\" flex layout-fill>\n<md-input-container flex><label translate=\"COMPANY.CASH_DISCOUNT\">Skonto %</label><input flex type=\"number\" \nng-model=\"vm.company.cashDiscount\"></md-input-container><md-input-container flex><label \ntranslate=\"COMPANY.CASH_DISCOUNT_DAYS\">Skontofrist (Tage)</label><input flex type=\"number\" \nng-model=\"vm.company.cashDiscountDays\"></md-input-container><md-input-container flex><label \ntranslate=\"COMPANY.PAYMENT_DEADLINE\">Zahlungsziel (Tage)</label><input flex type=\"number\" \nng-model=\"vm.company.paymentDeadline\"></md-input-container></div><md-input-container flex><label \ntranslate=\"COMPANY.MAX_SALDO\">max. Saldo</label><input type=\"number\" name=\"maxsaldo\" ng-model=\"vm.company.maxSaldo\" \naria-label=\"MAXSALDO\"></md-input-container><md-switch ng-model=\"vm.company.orderFee\"><span \ntranslate=\"COMPANY.ORDER_FEE\">Auftragspauschale</span></md-switch><md-switch ng-model=\"vm.company.printLabel\" \nng-if=\"vm.config.ims.companies.printLabel\" flex><span translate=\"COMPANY.PRINT_LABEL\">Etikette drucken</span>\n</md-switch><md-switch ng-model=\"vm.company.eInvoice\" ng-if=\"vm.config.ims.companies.eInvoice\" flex><span \ntranslate=\"COMPANY.E_INVOICE\">e-Rechnung</span></md-switch><md-switch ng-model=\"vm.company.customData.igl\" \nng-if=\"vm.config.ims.companies.igl\"><span translate=\"COMPANY.IGL\">Innergemeinschaftliche Lieferung</span></md-switch>\n<md-switch ng-model=\"vm.company.showPrices\"><span translate=\"COMPANY.SHOW_PRICES\">Preise anzeigen</span></md-switch>\n<div style=\"margin: 4px\" layout=\"row\" flex layout-fill ng-if=\"vm.config.evo.cart.payment.enabled\" \nlayout-align=\"start center\"><md-switch style=\"margin-right: 10px\" flex ng-model=\"vm.company.payment.override\" \nng-change=\"vm.togglePayment(vm.company.payment.override)\"><span translate=\"COMPANY.OVERRIDE_PAYMENT_OPTIONS\"></span>\n</md-switch><md-select flex ng-disabled=\"!vm.company.payment.override\" multiple=\"multiple\" \nng-model=\"vm.company.payment.options\"><md-option ng-repeat=\"option in vm.paymentOptions\" ng-value=\"option.id\">\n{{ (\'CART.PAYMENT.\' + option.id.toUpperCase()) | translate }}</md-option></md-select></div></div></div>");
$templateCache.put("app/main/partners.companies/views/partials/company-credits.html","<div class=\"content-wrapper\" layout=\"column\" flex ng-if=\"!vm.loadingCreditEntities \"><div \nng-if=\"vm.companyCredits.length === 0\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<span class=\"md-headline\" translate=\"CREDIT.NO_CREDITS\">There are no invoices yet!</span></div><div \nclass=\"blue-grey-A100-bg blue-grey-700-fg mt-10 mh-10 ph-20 pv-10 white-text sumcontainer bb\" layout=\"row\" \nng-if=\"vm.companyCredits.length !== 0\" style=\"cursor: default\" layout-align=\"space-between center\"><div layout=\"row\">\n<div class=\"mr-40\"><span translate=\"CREDIT.TOTAL_SUM_AMOUNT\"></span>: <span class=\"pl-5\">\n{{vm.creditSumTotalAmount | nuitCurrency}}</span></div><div class=\"mr-40\"><span translate=\"CREDIT.TOTAL_SUM_REDEEMED\">\n</span>: <span class=\"pl-5\">{{vm.creditSumRedeemed | nuitCurrency}}</span></div><div class=\"mr-40\"><span \ntranslate=\"CREDIT.TOTAL_SUM_OPEN\"></span>: <span class=\"pl-5\">\n{{(vm.creditSumTotalAmount-vm.creditSumRedeemed) | nuitCurrency}}</span></div></div><div><nuit-pagination \nall-entities=\"vm.companyCredits\" current-page-entities=\"vm.currentCreditPageEntities\" \ncurrent-page=\"vm.currentCreditPage\" entities-per-page=\"vm.config.ims.companies.credits.creditsPerPage\">\n</nuit-pagination></div></div><md-content class=\"content\" ms-scroll flex><table class=\"m-10\" id=\"invoiceTable\" \nng-if=\"vm.companyCredits.length !== 0\"><thead><tr><th><button ng-click=\"vm.creditOrderBy(\'id\')\" layout=\"row\" \nlayout-align=\"start center\" type=\"button\"><span class=\"blue-grey-A400-fg text-center\" translate=\"INVOICE.NUMBER\">\n</span> <span ng-if=\"vm.selectedCreditOrderBy !==\'id\'\" style=\"width: 24px\"></span><md-icon \nng-show=\"vm.selectedCreditOrderBy===\'id\' && vm.reverseCredit\" md-font-icon=\"icon-sort-descending\"></md-icon><md-icon \nng-show=\"vm.selectedCreditOrderBy===\'id\' && !vm.reverseCredit\" md-font-icon=\"icon-sort-ascending\"></md-icon></button>\n</th><th><button ng-click=\"vm.creditOrderBy(\'createdAt\')\" layout=\"row\" layout-align=\"start center\" type=\"button\"><span \nclass=\"blue-grey-A400-fg text-center\" translate=\"INVOICE.CREATED_AT\"></span> <span \nng-if=\"vm.selectedCreditOrderBy !==\'createdAt\'\" style=\"width: 24px\"></span><md-icon \nng-show=\"vm.selectedCreditOrderBy===\'createdAt\' && vm.reverseCredit\" md-font-icon=\"icon-sort-descending\"></md-icon>\n<md-icon ng-show=\"vm.selectedCreditOrderBy===\'createdAt\' && !vm.reverseCredit\" md-font-icon=\"icon-sort-ascending\">\n</md-icon></button></th><th><button ng-click=\"vm.creditOrderBy(\'status\')\" layout=\"row\" layout-align=\"start center\" \ntype=\"button\"><span class=\"blue-grey-A400-fg text-center\" translate=\"INVOICE.STATUS\"></span> <span \nng-if=\"vm.selectedCreditOrderBy !==\'status\'\" style=\"width: 24px\"></span><md-icon \nng-show=\"vm.selectedCreditOrderBy===\'status\' && vm.reverseCredit\" md-font-icon=\"icon-sort-descending\"></md-icon>\n<md-icon ng-show=\"vm.selectedCreditOrderBy===\'status\' && !vm.reverseCredit\" md-font-icon=\"icon-sort-ascending\">\n</md-icon></button></th><th class=\"text-right\"><span translate=\"CREDIT.TOTAL_AMOUNT\"></span></th><th \nclass=\"text-right\"><span translate=\"CREDIT.SUM_REDEEMED\"></span></th><th class=\"text-right\"><span \ntranslate=\"CREDIT.SUM_OPEN\"></span></th></tr></thead><tbody><tr \nng-repeat=\"credit in vm.currentCreditPageEntities track by credit.id\" ng-click=\"vm.showCreditDetails(credit.id)\" \nng-class=\"{\'redeemed\': credit.status === 2 || credit.status === 1}\"><td style=\"width: 220px\"><span>{{credit.number}}\n</span></td><td style=\"width: 220px\"><span>{{credit.createdAt| nuitDatetime: \'date\'}}</span></td><td \nstyle=\"width: 220px\"><div ng-repeat=\"status in vm.creditStatus track by status.id\" class=\"mr-20\"><span \nng-if=\"credit.status === status.id\" ng-class=\"{\'{{status.type}}\': status.type === status.type}\">\n{{(\"CREDIT.STATUS_\" + status.type | uppercase) | translate}}</span></div></td><td class=\"currency number-cell\"><span \nclass=\"text-right\">{{credit.sumAmount | nuitCurrency}}</span></td><td class=\"currency number-cell\"><span \nclass=\"text-right\">{{credit.sumRedeemed | nuitCurrency}}</span></td><td class=\"currency number-cell\"><span \nclass=\"text-right\">{{(credit.sumAmount-credit.sumRedeemed) | nuitCurrency}}</span></td></tr></tbody></table>\n</md-content></div>");
$templateCache.put("app/main/partners.companies/views/partials/company-invoices.html","<div class=\"content-wrapper\" layout=\"column\" flex ng-if=\"!vm.loadingEntities \"><div \nng-if=\"vm.companyInvoices.length === 0\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<span class=\"md-headline\" translate=\"INVOICES.NO_INVOICES\">There are no invoices yet!</span></div><div \nclass=\"blue-grey-A100-bg blue-grey-700-fg mt-10 mh-10 ph-20 pv-10 white-text sumcontainer bb\" layout=\"row\" \nng-if=\"vm.companyInvoices.length !== 0\" style=\"cursor: default\" layout-align=\"space-between center\"><div layout=\"row\">\n<div class=\"mr-40\" ng-class=\"{\'red-900-fg\': vm.sumUnpaid > vm.company.maxSaldo}\"><span translate=\"INVOICE.SUM_UNPAID\">\n</span>: <span class=\"pl-5\">{{vm.sumUnpaid | nuitCurrency}}</span><md-tooltip \nng-if=\"vm.sumUnpaid > vm.company.maxSaldo\"><span translate=\"INVOICE.MAX_SALDO_EXCEEDED\"></span></md-tooltip></div><div>\n<span translate=\"INVOICE.SUM_PAID\"></span>: <span class=\"pl-5\">{{vm.sumPaid | nuitCurrency}}</span></div></div><div>\n<nuit-pagination all-entities=\"vm.companyInvoices\" current-page-entities=\"vm.currentPageEntities\" \ncurrent-page=\"vm.currentPage\" entities-per-page=\"vm.config.ims.companies.invoices.invoicesPerPage\"></nuit-pagination>\n</div></div><md-content class=\"content\" ms-scroll flex><table class=\"m-10\" id=\"invoiceTable\" \nng-if=\"vm.companyInvoices.length !== 0\"><thead><tr><th><button ng-click=\"vm.orderBy(\'id\')\" layout=\"row\" \nlayout-align=\"start center\" type=\"button\"><span class=\"blue-grey-A400-fg text-center\" translate=\"INVOICE.NUMBER\">\n</span> <span ng-if=\"vm.selectedOrderBy !==\'id\'\" style=\"width: 24px\"></span><md-icon \nng-show=\"vm.selectedOrderBy===\'id\' && vm.reverse\" md-font-icon=\"icon-sort-descending\"></md-icon><md-icon \nng-show=\"vm.selectedOrderBy===\'id\' && !vm.reverse\" md-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th>\n<button ng-click=\"vm.orderBy(\'createdAt\')\" layout=\"row\" layout-align=\"start center\" type=\"button\"><span \nclass=\"blue-grey-A400-fg text-center\" translate=\"INVOICE.CREATED_AT\"></span> <span \nng-if=\"vm.selectedOrderBy !==\'createdAt\'\" style=\"width: 24px\"></span><md-icon \nng-show=\"vm.selectedOrderBy===\'createdAt\' && vm.reverse\" md-font-icon=\"icon-sort-descending\"></md-icon><md-icon \nng-show=\"vm.selectedOrderBy===\'createdAt\' && !vm.reverse\" md-font-icon=\"icon-sort-ascending\"></md-icon></button></th>\n<th><button ng-click=\"vm.orderBy(\'dueDate\')\" layout=\"row\" layout-align=\"start center\" type=\"button\"><span \nclass=\"blue-grey-A400-fg text-center\" translate=\"INVOICE.DUE_DATE\"></span> <span \nng-if=\"vm.selectedOrderBy !==\'dueDate\'\" style=\"width: 24px\"></span><md-icon \nng-show=\"vm.selectedOrderBy===\'dueDate\' && vm.reverse\" md-font-icon=\"icon-sort-descending\"></md-icon><md-icon \nng-show=\"vm.selectedOrderBy===\'dueDate\' && !vm.reverse\" md-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th>\n<button ng-click=\"vm.orderBy(\'status\')\" layout=\"row\" layout-align=\"start center\" type=\"button\"><span \nclass=\"blue-grey-A400-fg text-center\" translate=\"INVOICE.STATUS\"></span> <span ng-if=\"vm.selectedOrderBy !==\'status\'\" \nstyle=\"width: 24px\"></span><md-icon ng-show=\"vm.selectedOrderBy===\'status\' && vm.reverse\" \nmd-font-icon=\"icon-sort-descending\"></md-icon><md-icon ng-show=\"vm.selectedOrderBy===\'status\' && !vm.reverse\" \nmd-font-icon=\"icon-sort-ascending\"></md-icon></button></th><th><span class=\"\" translate=\"INVOICE.PROJECT\"></span></th>\n<th><span class=\"\" translate=\"ORDERS.NUMBER\"></span></th><th class=\"text-right\"><span translate=\"ORDERS.SALES.PRICE\">\n</span></th><th class=\"text-right\"><span translate=\"ORDERS.SALES.LOGISTICPRICE\"></span></th><th class=\"text-right\" \nng-if=\"vm.config.ims.accounting.list.showOrderFee\"><span translate=\"ORDERS.SALES.ORDERFEE\"></span></th><th \nclass=\"text-right\"><span class=\"\" translate=\"ORDERS.SALES.NETPRICE\"></span></th><th class=\"text-right\"><span \ntranslate=\"ORDERS.SALES.GROSSPRICE\"></span></th><th class=\"text-right\"><span translate=\"ORDERS.SALES.VATPERCENT\">\n</span></th></tr></thead><tbody><tr ng-repeat=\"invoice in vm.currentPageEntities track by invoice.id\" \nng-click=\"vm.showDetails(invoice.id)\" ng-class=\"{\'paidrow\': invoice.status === 3, \'unpaidrow\': invoice.status === 2}\">\n<td style=\"width: 220px\"><span>{{invoice.number}}</span></td><td style=\"width: 220px\"><span>\n{{invoice.createdAt| nuitDatetime: \'date\'}}</span></td><td style=\"width: 220px\"><span>\n{{invoice.dueDate| nuitDatetime: \'date\'}}</span></td><td style=\"width: 220px\"><div \nng-repeat=\"status in vm.statis track by status.id\" class=\"mr-20\"><span ng-if=\"invoice.status === status.id\" \nng-class=\"{\'{{status.type}}\': status.type === status.type}\">\n{{(\"INVOICE.STATUS_\" + status.type | uppercase) | translate}}</span></div></td><td class=\"text-cell\"><div \nng-repeat=\"details in invoice.orderDetails\"><span class=\"text-center\">{{vm.orderDetail | nuitFormatter: details}}\n</span></div></td><td class=\"text-cell\"><div ng-repeat=\"number in invoice.orderNumbers\" class=\"text-left company-cell\">\n{{number}}</div></td><td class=\"currency number-cell\"><span class=\"text-right\">{{invoice.sumPrice | nuitCurrency}}\n</span></td><td class=\"currency number-cell\"><span class=\"text-right\">{{invoice.sumLogisticPrice | nuitCurrency}}\n</span></td><td class=\"currency number-cell\" ng-if=\"vm.config.ims.accounting.list.showOrderFee\"><span \nclass=\"text-right\">{{invoice.sumOrderFee | nuitCurrency}}</span></td><td class=\"currency number-cell\"><span \nclass=\"text-right\">{{invoice.sumNetPrice | nuitCurrency}}</span></td><td class=\"currency number-cell\"><span \nclass=\"text-right\">{{invoice.sumGrossPrice | nuitCurrency}}</span></td><td class=\"vatpercent number-cell\"><span \nclass=\"text-right\" ng-if=\"invoice.vatPercents.length===1\">{{invoice.vatPercents[0] + \"%\"}}</span> <span \nclass=\"text-right\" ng-if=\"invoice.vatPercents.length!==1\">-</span></td></tr></tbody></table></md-content></div>");
$templateCache.put("app/main/partners.companies/views/partials/company-list-entry.html","<div class=\"thread unread\" ng-if=\"!vm.loadingEntities\" ng-repeat=\"company in vm.currentPageEntities\" \nng-class=\"{\'selected\': vm.isSelected(company)}\" ng-click=\"expanded=!expanded;$event.stopPropagation();\"><div \nlayout=\"row\" layout-align=\"start center\" layout-fill><div class=\"info\" layout=\"column\" flex><span class=\"text-bold\" \nng-if=\"company.name!==null\">{{company.name}}</span><nuit-address address=\"vm.getStandardAddress(company)\" \nshow-address-name=\"company.name===null\" address-format=\"vm.config.ims.companies.details.addressFormat\" \naddress-format-by-country=\"vm.config.ims.companies.details.addressFormatByCountry\"></nuit-address><span \nng-if=\"vm.config.ims.companies.customerId.enabled\"><span translate=\"COMPANY.CUSTOMER_ID_SHORT\"></span>\n: {{vm.getCustomerId(company)}}</span></div><div class=\"info\" layout=\"column\" flex><div class=\"message text-truncate\">\n<span ng-if=\"company.active\" translate=\"APP.ACTIVE\">Active</span> <span ng-if=\"!company.active\" \ntranslate=\"APP.INACTIVE\">Inactive</span></div></div><div class=\"info\" layout=\"column\" flex><nuit-phone \nphone=\"company.phone\"></nuit-phone></div><div layout=\"row\" layout-align=\"end center\" flex=\"35\"><div layout=\"row\" \nng-show=\"company.users.length>0 && vm.mode===\'company\'\"><span translate=\"COMPANY.PERSONS\"></span> <span>&nbsp;</span> \n<span>({{company.users.length}})</span></div><md-button class=\"md-icon-button\" \nng-click=\"vm.openDetail(company.id);$event.stopPropagation();\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip><span translate=\"APP.EDIT\">Edit</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-if=\"vm.config.ims.companies.list.allowDelete\" ng-click=\"vm.delCompany(company);$event.stopPropagation();\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button>\n</div></div><md-grid-list md-cols=\"3\" md-gutter=\"1em\" md-row-height=\"5:2\" class=\"mt-16 mb-16\" \nng-show=\"expanded || vm.mode===\'person\'\"><md-grid-tile class=\"md-whiteframe-2dp p-8 m-16 white-bg\" \nng-repeat=\"person in vm.getSelectedPersons(company)\"><div class=\"p-8 m-8\" layout=\"column\" layout-fill><div \nlayout=\"row\" layout-align=\"start start\"><nuit-person-name class=\"text-bold\" person=\"person\"></nuit-person-name><md-icon\n md-font-icon=\"icon-key-remove\" class=\"m-0 ml-10 grey-500-fg s16\" ng-if=\"person.status===3\"></md-icon></div><div></div>\n<nuit-phone phone=\"person.phone\"></nuit-phone><nuit-email email=\"person.email\"></nuit-email><div>\n{{vm.getRoleName(person) | nuitTranslate}}</div><div flex></div><md-button class=\"md-accent md-raised\" \nng-click=\"vm.openEvoForUser(company.id,person.id);$event.stopPropagation();\"><label translate=\"COMPANY.ORDER_FOR_USER\">\n</label></md-button></div></md-grid-tile></md-grid-list></div>");
$templateCache.put("app/main/partners.companies/views/partials/company-notifications.html","<md-content><md-content class=\"pv-10 pr-10 pl-20\"><md-switch class=\"md-accent\" \nng-model=\"vm.company.disableAllNotifications\" ng-change=\"vm.saveNotificationSettings()\"><span \ntranslate=\"COMPANY.DISABLE_ALL_NOTIFICATIONS\"></span></md-switch></md-content><div \nng-style=\"vm.company.disableAllNotifications && {opacity: 0.4}\"><company-trigger company=\"vm.company\">\n</company-trigger></div></md-content>");
$templateCache.put("app/main/partners.companies/views/partials/company-numbers.details.html","<div id=\"user\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header minified\" layout=\"row\" layout-align=\"start center\"></div><div \nclass=\"content-card\" layout=\"column\" flex><form name=\"vm.companyNumbersForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"{{vm.origin?vm.origin:\'app.partners-companynumbers\'}}\"><md-icon md-font-icon=\"icon-keyboard-backspace\">\n</md-icon></md-button><div class=\"action-buttons\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"divider-vertical mr-20\"></div><span class=\"md-title\" translate=\"COMPANIES.COMPANYNUMBER\"></span></div></div><div\n layout=\"row\" layout-align=\"start center\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.saveCompanyNumber()\" \nng-disabled=\"!vm.companyNumbersForm.$valid || !vm.companyNumbersForm.$dirty || vm.companyNumberId \" \ntranslate=\"APP.SAVE\">Speichern</md-button></div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content \nclass=\"content-tabs\" layout=\"column\" layout-fill flex><div class=\"content\" ng-if=\"vm.loadingItems\" flex><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><div \nlayout=\"column\" class=\"mt-10\"><div><div class=\"m-20\" layout=\"column\" flex=\"40\"><md-input-container \nstyle=\"width: 680px; margin-top: 0; margin-bottom: 0 !important\"><div style=\"margin-bottom: 18px\"><span \ntranslate=\"APP.TEMPLATE\">Tpl </span>*</div><input name=\"tpl\" type=\"text\" ng-model=\"vm.companyNumbers.tpl\" required><div\n ng-messages=\"vm.companyNumbersForm.tpl.$error\" role=\"alert\"><div ng-message=\"required\" class=\"my-message\"><span \ntranslate=\"APP.TEMPLETE.ERROR\"></span></div></div></md-input-container><div layout=\"row\"><md-button \nng-repeat=\"field in vm.tplFields\" ng-click=\"vm.setTpl(field)\" class=\"md-whiteframe-1dp mh-5\"><span>\n{{(\'APP.\' + (field | uppercase)) | translate }}</span></md-button></div></div></div><div layout=\"row\"><div \nclass=\"m-20\" layout=\"column\"><md-input-container style=\"width: 320px\"><span translate=\"APP.INVOICE_NUMBER.OFFSET\">\nOffset</span> <input type=\"number\" ng-model=\"vm.companyNumbers.offset\"></md-input-container></div><div class=\"m-20\" \nlayout=\"column\"><md-input-container style=\"width: 320px\"><span translate=\"APP.INVOICE_NUMBER.SIZE\">Size</span> <input \ntype=\"number\" ng-model=\"vm.companyNumbers.size\"></md-input-container></div></div></div></md-content></div></form></div>\n</div></div>");
$templateCache.put("app/main/partners.companies/views/partials/company-rawmaterial.html","<md-content><table class=\"simple mt-5\" id=\"rawMaterialDiscountTable\" ng-if=\"!vm.loadingRawMaterialDiscount\"><thead><tr>\n<th><span translate=\"MATERIAL.GROUP\"></span></th><th><span translate=\"APP.DISCOUNT\"></span> (%)</th></tr></thead>\n<tbody><tr ng-repeat=\"material in vm.rawMaterials | orderByNuitTranslated:\'name\' track by material.id\"><td><span>\n{{::vm.getRawMaterialName(material.id) | nuitTranslate}}</span></td><td><md-input-container class=\"m-0\" flex><input \ntype=\"number\" name=\"discount\" ng-model=\"material.discount\" ng-change=\"vm.updateDiscount(material)\">\n</md-input-container></td></tr></tbody></table></md-content>");
$templateCache.put("app/main/partners.companies/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.companies\" default-name=\"PARTNERS_COMPANIES_SETTINGS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/partners.companies.admin/views/partials/company-bank-account.html","<div layout=\"row\" layout-margin layout-align=\"space-between start\"><div layout=\"column\" flex><md-input-container \nng-if=\"vm.config.ims.companies.bankAccountEnabled\" flex><label translate=\"COMPANY.IBAN\">Name</label><input type=\"text\" \nname=\"iban\" ng-model=\"vm.company.iban\" aria-label=\"IBAN\"></md-input-container><md-input-container \nng-if=\"vm.config.ims.companies.bankAccountEnabled\" flex><label translate=\"COMPANY.BIC\">Name</label><input type=\"text\" \nname=\"bic\" ng-model=\"vm.company.bic\" aria-label=\"BIC\"></md-input-container><md-input-container flex><label \ntranslate=\"COMPANY.GLOBAL_DISCOUNT\">globaler Rabatt %</label><input type=\"text\" name=\"globaldiscount\" \nng-model=\"vm.company.globalDiscount\" aria-label=\"GLOBALDISCOUNT\"></md-input-container><md-input-container flex><label \ntranslate=\"COMPANY.ONLINE_DISCOUNT\">Onlinerabatt %</label><input type=\"text\" name=\"onlinediscount\" \nng-model=\"vm.company.onlineDiscount\" aria-label=\"ONLINEDISCOUNT\"></md-input-container><md-input-container flex><label \ntranslate=\"COMPANY.PROCESSING_DISCOUNT\">Bearbeitungsrabatt %</label><input type=\"text\" name=\"processingdiscount\" \nng-model=\"vm.company.processingDiscount\" aria-label=\"PROCESSINGDISCOUNT\"></md-input-container><md-input-container flex>\n<label translate=\"COMPANY.CUSTOMER_DISCOUNT\">Kundenrabatt %</label><input type=\"text\" name=\"customerdiscount\" \nng-model=\"vm.company.customerDiscount\" aria-label=\"CUSTOMERDISCOUNT\"></md-input-container><md-input-container flex \nng-show=\"vm.config.ims.companies.volumeDiscountEnabled\"><label translate=\"COMPANY.VOLUME_DISCOUNT\">Name</label><input \ntype=\"text\" name=\"volumedicount\" ng-model=\"vm.company.volumeDiscount\" aria-label=\"VOLUMEDISCOUNT\"></md-input-container>\n</div><div layout=\"column\" flex layout-fill><span class=\"selectById\"><md-input-container flex><label \ntranslate=\"COMPANY.PAYMENT_CONDITION\">Zahlungsbedingung</label><nuit-select-by-id \ncurrent-id=\"vm.company.paymentCondition\" list=\"vm.conditions\" entity-format=\"formattedText\"></nuit-select-by-id>\n</md-input-container></span><span class=\"selectById\"><md-input-container flex><label \ntranslate=\"COMPANY.PAYMENT_DEADLINE\">Zahlungsziel</label><nuit-select-by-id current-id=\"vm.company.paymentDeadline\" \nlist=\"vm.deadlines\" entity-format=\"formattedText\"></nuit-select-by-id></md-input-container></span><md-input-container \nflex><label translate=\"COMPANY.MAX_SALDO\">max. Saldo</label><input type=\"number\" name=\"maxsaldo\" \nng-model=\"vm.company.maxSaldo\" aria-label=\"MAXSALDO\"></md-input-container><span class=\"selectById\"></span><md-switch \nng-model=\"vm.company.printLabel\" ng-if=\"vm.config.ims.companies.printLabel\" flex><span translate=\"COMPANY.PRINT_LABEL\">\nEtikette drucken</span></md-switch><md-switch ng-model=\"vm.company.eInvoice\" ng-if=\"vm.config.ims.companies.eInvoice\" \nflex><span translate=\"COMPANY.E_INVOICE\">e-Rechnung</span></md-switch></div></div>");
$templateCache.put("app/main/partners.general/dialogs/new-address/new-address.html","<md-dialog><md-toolbar class=\"md-accent-bg pl-24\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\n{{vm.header | translate}}</span></md-toolbar><md-dialog-content class=\"md-dialog-content\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><form name=\"vm.addressForm\" novalidate ng-model-options=\"{debounce:200}\" \nng-submit=\"vm.save()\"><div layout=\"column\" flex><div layout=\"row\" flex><md-input-container flex><label \ntranslate=\"ADDRESS.NAME\">Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.address.name\" aria-label=\"NAME\" \nrequired></md-input-container><md-input-container flex><label translate=\"ADDRESS.COMPANY_ADDITION\">Name</label><input \ntype=\"text\" name=\"nameAddition\" ng-model=\"vm.address.nameAddition\" aria-label=\"NAME_ADDITION\"></md-input-container>\n</div><div layout=\"row\" flex><md-input-container flex=\"15\"><label translate=\"COMPANY.COUNTRY_CODE\">Name</label>\n<md-select ng-model=\"vm.address.countryCode\"><md-option ng-repeat=\"country in vm.countries | orderBy:\'code\'\" \nng-value=\"country.code\">{{country.code}}</md-option></md-select></md-input-container><md-input-container flex=\"20\">\n<label translate=\"COMPANY.ADMINISTRATIVE_AREA\">Administrative Area</label><input type=\"text\" \nname=\"administrative_area\" ng-model=\"vm.address.area\" aria-label=\"STREET\"></md-input-container><md-input-container \nflex=\"20\"><label translate=\"COMPANY.ZIP_CODE\">Name</label><input type=\"text\" name=\"zip_code\" \nng-model=\"vm.address.zipCode\" aria-label=\"ZIP_CODE\" required></md-input-container><md-input-container flex><label \ntranslate=\"COMPANY.CITY\">Name</label><input type=\"text\" name=\"city\" ng-model=\"vm.address.city\" aria-label=\"CITY\" \nrequired></md-input-container></div><div layout=\"row\" flex><md-input-container flex><label translate=\"COMPANY.STREET\">\nName</label><input type=\"text\" name=\"street\" ng-model=\"vm.address.street\" aria-label=\"STREET\" required>\n</md-input-container></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-raised\" ng-click=\"vm.close()\" aria-label=\"n\"><span translate=\"APP.CANCEL\">Cancel</span>\n</md-button><md-button ng-disabled=\"!vm.addressForm.$valid || !vm.addressForm.$dirty\" ng-click=\"vm.save()\" \nclass=\"md-accent md-raised\"><span translate=\"APP.SAVE\">Save</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/partners.general/views/partials/company-address.html","<div layout=\"column\" layout-align=\"space-between top\" layout-margin class=\"mr-20\"><div layout=\"row\" layout-fill flex>\n<md-input-container flex><label ng-if=\"vm.companyCompose || vm.company.addresses\" translate=\"COMPANY.NAME\">Name</label>\n<label ng-if=\"!vm.companyCompose && !vm.company.addresses\" translate=\"FORWARDER.NAME\">Name</label><input type=\"text\" \nname=\"name\" ng-model=\"vm.company.name\" aria-label=\"NAME\" required></md-input-container><md-switch \nng-model=\"vm.company.active\" flex=\"10\"><span ng-if=\"vm.company.active\" translate=\"APP.ACTIVE\">Active</span> <span \nng-if=\"!vm.company.active\" translate=\"APP.INACTIVE\">Inactive</span></md-switch></div><div layout=\"row\" \nng-if=\"!vm.companyCompose && !vm.company.addresses\"><md-input-container flex><label translate=\"COMPANY.EMAIL\">E-Mail\n</label><input type=\"text\" name=\"email\" ng-model=\"vm.company.email\" aria-label=\"EMAIL\" required></md-input-container>\n</div><div layout=\"row\" layout-fill flex><md-input-container flex><label translate=\"COMPANY.PHONE\">Phone</label><input \ntype=\"text\" name=\"phone\" ng-model=\"vm.company.phone\" aria-label=\"PHONE\"></md-input-container><md-input-container flex \nclass=\"mh-15\"><label translate=\"COMPANY.MOBILE\">Mobile</label><input type=\"text\" name=\"mobile\" \nng-model=\"vm.company.mobile\" aria-label=\"MOBILE\"></md-input-container><md-input-container flex><label \ntranslate=\"COMPANY.FAX\">Fax</label><input type=\"text\" name=\"fax\" ng-model=\"vm.company.fax\" aria-label=\"FAX\">\n</md-input-container></div><div layout=\"row\" layout-fill flex><md-input-container flex><label \ntranslate=\"COMPANY.REMARK\">Fax</label><input type=\"text\" name=\"remark\" ng-model=\"vm.company.remark\" \naria-label=\"remark\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\" class=\"secondary-text\" \nlayout=\"row\" ng-if=\"vm.company.addresses\"><span class=\"md-title\" flex translate=\"COMPANY.BILLING_ADDRESS\">\nBilling Address</span><md-button class=\"md-raised md-accent\" ng-click=\"vm.addAddress(vm.company,\'addresses\')\"><label \ntranslate=\"APP.ADD\"></label></md-button></div></div><div layout=\"row\" layout-align=\"space-between start\" \nng-if=\"vm.company.addresses\"><div layout=\"column\" flex><div layout=\"row\" layout-wrap layout-margin layout-fill><div \nng-class=\"{\'cidan-green-bg\':vm.isStandardAddress(address.id,\'addressId\')}\" ng-repeat=\"address in vm.company.addresses\" \nlayout=\"column\" class=\"md-whiteframe-2dp\" layout-padding><nuit-address address=\"address\" show-address-name=\"true\" \naddress-format=\"vm.config.ims.companies.details.addressFormat\" \naddress-format-by-country=\"vm.config.ims.companies.details.addressFormatByCountry\" flex></nuit-address><div \nlayout=\"row\" layout-align=\"end start\"><md-button ng-show=\"!vm.isStandardAddress(address.id,\'addressId\')\" \nclass=\"md-raised md-icon-button\" ng-click=\"vm.setStandardAddress(address.id,\'addressId\')\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip><span translate=\"APP.DEFAULT\"></span></md-tooltip></md-button>\n<md-button class=\"md-raised md-icon-button\" ng-click=\"vm.editAddress(vm.company,address,\'addresses\')\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-button><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.deleteAddress(vm.company,address.id,\'addresses\')\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\"></span></md-tooltip></md-button></div>\n</div></div></div></div><div layout-align=\"space-between top\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"secondary-text m-20\" ng-if=\"vm.company.deliveryAddresses\"><span class=\"md-title\" flex \ntranslate=\"COMPANY.DELIVERY_ADDRESS\">DELIVERY ADDRESS</span><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addAddress(vm.company,\'deliveryAddresses\')\"><label translate=\"APP.ADD\"></label></md-button></div><div \nlayout=\"row\" layout-wrap layout-margin layout-fill><div \nng-class=\"{\'cidan-green-bg\':vm.isStandardAddress(address.id,\'deliveryAddressId\')}\" \nng-repeat=\"address in vm.company.deliveryAddresses\" layout=\"column\" class=\"md-whiteframe-2dp\" layout-padding>\n<nuit-address address=\"address\" show-address-name=\"true\" \naddress-format=\"vm.config.ims.companies.details.addressFormat\" \naddress-format-by-country=\"vm.config.ims.companies.details.addressFormatByCountry\" flex></nuit-address><div \nlayout=\"row\" layout-align=\"end start\"><md-button ng-show=\"!vm.isStandardAddress(address.id,\'deliveryAddressId\')\" \nclass=\"md-raised md-icon-button\" ng-click=\"vm.setStandardAddress(address.id,\'deliveryAddressId\')\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip><span translate=\"APP.DEFAULT\"></span></md-tooltip></md-button>\n<md-button class=\"md-raised md-icon-button\" ng-click=\"vm.editAddress(vm.company,address,\'deliveryAddresses\')\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-button><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.deleteAddress(vm.company,address.id,\'deliveryAddresses\')\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\"></span></md-tooltip></md-button></div>\n</div></div></div><div layout=\"row\" layout-margin layout-align=\"space-between start\" \nng-show=\"vm.config.ims.companies.deliveryCostEnabled\"><div layout=\"column\" flex><md-input-container flex><label \ntranslate=\"COMPANY.DELIVERY_COST\">Name</label><input type=\"text\" name=\"DELIVERY_COST\" \nng-model=\"vm.company.deliveryCost\" aria-label=\"DELIVERYCOST\"></md-input-container></div><div layout=\"column\" flex>\n</div></div>");
$templateCache.put("app/main/partners.general/views/partials/company-persons.html","<div class=\"content-wrapper\" layout=\"column\" flex><div class=\"content thread-list\" ms-scroll flex><div \nng-if=\"vm.company.useres.length === 0 && !vm.company.users\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\">There are no persons yet!</span></div><div \nclass=\"thread unread\" ng-repeat=\"person in vm.company.users\"><div layout=\"row\" layout-align=\"start center\" layout-fill>\n<div class=\"info\" layout=\"column\" flex><div class=\"message text-truncate\"><div layout=\"row\" \nlayout-align=\"start center\"><nuit-person-name class=\"text-bold\" person=\"person\"></nuit-person-name><md-icon \nmd-font-icon=\"icon-key-remove\" class=\"m-0 ml-10 grey-500-fg s16\" ng-if=\"person.status===3\"></md-icon></div><nuit-email \nemail=\"person.email\" layout-fill></nuit-email><div>{{vm.getRoleName(person) | nuitTranslate}}</div></div></div><div \nclass=\"info\" layout=\"column\" flex><nuit-phone phone=\"person.phone\"></nuit-phone></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.showPersonDialog(person)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip><span translate=\"APP.EDIT\">Edit</span></md-tooltip></md-button><div flex=\"5\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.delPerson(person.id)\" ng-if=\"vm.company.admin!==person.id\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button>\n</div></div></div></div><div id=\"personPopup\"></div></div>");
$templateCache.put("app/main/partners.transport/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.transport\" default-name=\"TRANSPORT_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/partners.transport/views/partials/forwarders-details-contactpersons.html","<div class=\"content-wrapper\" layout=\"column\" flex><div class=\"content thread-list\" ms-scroll flex><div \nng-if=\"vm.forwarder.users.length === 0 || !vm.forwarder.users\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"start center\" layout-fill><span class=\"md-headline\" translate=\"TRANSPORT.NO_PERSONS_YET\">\nThere are no persons yet!</span></div><div class=\"thread unread\" ng-repeat=\"person in vm.forwarder.users\"><div \nlayout=\"row\" layout-align=\"start center\" layout-fill><div class=\"info\" layout=\"column\" flex><div \nclass=\"message text-truncate\"><div layout=\"row\" layout-align=\"start center\"><nuit-person-name class=\"text-bold\" \nperson=\"person\"></nuit-person-name><md-icon md-font-icon=\"icon-key-remove\" class=\"m-0 ml-10 grey-500-fg s16\" \nng-if=\"person.status===3\"></md-icon></div><nuit-email email=\"person.email\" layout-fill></nuit-email><div>\n{{vm.getRoleName(person) | nuitTranslate}}</div></div></div><div class=\"info\" layout=\"column\" flex><nuit-phone \nphone=\"person.phone\"></nuit-phone></div><md-button class=\"md-icon-button\" \nng-click=\"vm.setAutoNotification(person, \'email\')\"><md-icon md-font-icon=\"icon-email\" \nng-class=\"{\'cidan-green\': person.notification.email}\"></md-icon><md-tooltip><span \ntranslate=\"TRANSPORT.SEND_MAIL_TO_USER\">Edit</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.setAutoNotification(person, \'sms\')\"><md-icon md-font-icon=\"icon-cellphone\" \nng-class=\"{\'cidan-green\': person.notification.sms}\"></md-icon><md-tooltip><span translate=\"TRANSPORT.SEND_SMS_TO_USER\">\nEdit</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.showPersonDialog(person)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"APP.EDIT\">Edit</span></md-tooltip></md-button><div \nflex=\"5\"><md-button class=\"md-icon-button\" ng-click=\"vm.delPerson(person.id)\" ng-if=\"vm.company.admin!==person.id\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip>\n</md-button></div></div></div></div><div id=\"personPopup\"></div></div>");
$templateCache.put("app/main/partners.transport/views/partials/forwarders-details-deliveries.html","<div layout=\"column\" layout-fill flex><md-content ms-scroll class=\"pv-24\"><div layout=\"column\" flex><div \nclass=\"toolbar grey-100-bg\" layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div flex=\"20\"><h3 class=\"text-truncate\" translate=\"APP.NUMBER\">Lieferscheinnummber</h3>\n</div><div flex=\"20\"><h3 class=\"text-truncate\" translate=\"INVOICE.PROJECT\">Bauvorhaben</h3></div><div flex=\"15\"><h3 \nclass=\"text-truncate\" translate=\"INVOICE.STATUS\"></h3></div><div flex=\"15\"><h3 class=\"text-truncate\" \ntranslate=\"TRANSPORT.SHIPPINGDATE\"></h3></div><div flex=\"15\"><h3 class=\"text-truncate\" \ntranslate=\"TRANSPORT.DELIVERYDATE\"></h3></div><div flex=\"15\"><h3 class=\"text-truncate\" \ntranslate=\"TRANSPORT.DELIVERY_NOTES\"></h3></div></div></div><div class=\"content-wrapper mh-24\" layout=\"column\" flex>\n<md-content class=\"content thread-list\" ms-scroll flex><div ng-if=\"vm.loadingItems\" class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\">Loading ...\n</span></div><div ng-if=\"vm.deliveries.length === 0 && !vm.loadingItems\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"TRANSPORT.NO_DELIVERY_NOTES\">\nThere are no orders yet!</span></div><div \nng-repeat=\"delivery in vm.deliveries | orderBy:\'number\'  track by delivery.id\" class=\"mt-20\"><div layout=\"row\" \nlayout-align=\"start center\" layout-fill ng-if=\"delivery.status !== 1\"><div flex=\"20\"><span class=\"name\">\n{{delivery.number}}</span></div><div flex=\"20\"><span>{{delivery.name}}</span><div \nng-repeat=\"details in delivery.order.details\"><span class=\"text-center\">{{vm.orderDetail | nuitFormatter: details}}\n</span></div></div><div flex=\"15\" layout=\"row\" layout-align=\"start center\"><div class=\"name\">\n{{vm.getStatusName(delivery.status)}}</div></div><div flex=\"15\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"name\">{{delivery.shippingDate | nuitDatetime: \'date\'}}</div></div><div flex=\"15\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"name\">{{delivery.deliveryDate | nuitDatetime: \'date\'}}</div></div><div \nflex=\"15\" layout=\"row\" layout-align=\"start\"><div layout=\"column\" layout-align=\"end\" class=\"pdf pt-10\"><a \nng-if=\"!vm.documentStatus.error\" \nng-repeat=\"docObj in delivery.documents | languageFilter:\'lang\' | orderByTranslated:\'name\' track by $index\" \nstyle=\"white-space: nowrap\" class=\"message mr-5\" ng-href=\"{{vm.getDocumentURL(docObj)}}\" target=\"_blank\" \nng-click=\"$event.stopPropagation();\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon></a></div></div></div></div>\n</md-content></div></div></md-content></div>");
$templateCache.put("app/main/partners.transport/views/partials/forwarders-details-general.html","<div layout=\"column\" layout-align=\"space-between top\" layout-margin class=\"mr-20\"><div layout=\"row\" layout-fill flex>\n<md-input-container flex><label translate=\"FORWARDER.NAME\">Name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.forwarder.name\" aria-label=\"NAME\" required></md-input-container><md-switch ng-model=\"vm.forwarder.active\" \nflex=\"10\"><span ng-if=\"vm.forwarder.active\" translate=\"APP.ACTIVE\">Active</span> <span ng-if=\"!vm.forwarder.active\" \ntranslate=\"APP.INACTIVE\">Inactive</span></md-switch></div><div layout=\"row\"><md-input-container flex><label \ntranslate=\"COMPANY.EMAIL\">E-Mail</label><input type=\"text\" name=\"email\" ng-model=\"vm.forwarder.email\" \naria-label=\"EMAIL\" required></md-input-container></div><div layout=\"row\" layout-fill flex><md-input-container flex>\n<label translate=\"COMPANY.PHONE\">Phone</label><input type=\"text\" name=\"phone\" ng-model=\"vm.forwarder.phone\" \naria-label=\"PHONE\"></md-input-container><md-input-container flex class=\"mh-15\"><label translate=\"COMPANY.MOBILE\">Mobile\n</label><input type=\"text\" name=\"mobile\" ng-model=\"vm.forwarder.mobile\" aria-label=\"MOBILE\"></md-input-container>\n<md-input-container flex><label translate=\"COMPANY.FAX\">Fax</label><input type=\"text\" name=\"fax\" \nng-model=\"vm.forwarder.fax\" aria-label=\"FAX\"></md-input-container></div><div layout=\"row\" layout-fill flex>\n<md-input-container flex><label translate=\"COMPANY.REMARK\">Fax</label><input type=\"text\" name=\"remark\" \nng-model=\"vm.forwarder.remark\" aria-label=\"remark\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"secondary-text\" layout=\"row\" ng-if=\"vm.forwarder.addresses\"><span class=\"md-title\" \nflex translate=\"COMPANY.ADDRESS\">Address</span><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addAddress(vm.forwarder, \'addresses\')\"><label translate=\"APP.ADD\"></label></md-button></div></div><div \nlayout=\"row\" layout-align=\"space-between start\" ng-if=\"vm.forwarder.addresses\"><div layout=\"column\" flex><div \nlayout=\"row\" layout-wrap layout-margin layout-fill><div \nng-class=\"{\'cidan-green-bg\':vm.isStandardAddress(address.id,\'defaultAddressId\')}\" \nng-repeat=\"address in vm.forwarder.addresses\" layout=\"column\" class=\"md-whiteframe-2dp\" layout-padding><nuit-address \naddress=\"address\" show-address-name=\"true\" address-format=\"vm.config.ims.transport.forwarder.details.addressFormat\" \naddress-format-by-country=\"vm.config.ims.transport.forwarder.details.addressFormatByCountry\" flex></nuit-address><div \nlayout=\"row\" layout-align=\"end start\"><md-button ng-show=\"!vm.isStandardAddress(address.id,\'defaultAddressId\')\" \nclass=\"md-raised md-icon-button\" ng-click=\"vm.setStandardAddress(address.id,\'defaultAddressId\')\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip><span translate=\"APP.DEFAULT\"></span></md-tooltip></md-button>\n<md-button class=\"md-raised md-icon-button\" ng-click=\"vm.editAddress(vm.forwarder, address,\'addresses\')\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-button><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.deleteAddress(vm.forwarder, address.id,\'addresses\')\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\"></span></md-tooltip></md-button></div>\n</div></div></div></div>");
$templateCache.put("app/main/partners.transport/views/tabs/delivery-configuration-configurations.html","<div layout=\"column\" layout-fill flex><md-content ms-scroll class=\"m-24 md-whiteframe-1dp p-24\"><div layout=\"row\" \nlayout-align=\"space-between center\"><h1 translate=\"TRANSPORT.DELIVERY_WORKDAYS\"></h1></div><div layout=\"row\" \nlayout-align=\"start\" layout-wrap><div layout=\"column\" layout-align=\"start start\" ng-repeat=\"item in vm.workDays\" \nflex=\"20\"><div layout=\"row\" layout-align=\"start end\" class=\"mb-10\" style=\"height: 90px\"><md-checkbox \nng-checked=\"vm.exists(item.id, vm.selected)\" ng-click=\"vm.toggle(item.id, vm.selected)\"><span>{{item.name | translate}}\n</span></md-checkbox></div></div></div><md-divider class=\"mv-20\"></md-divider></md-content></div>");
$templateCache.put("app/main/partners.transport/views/tabs/delivery-delay.html","<div layout=\"column\" layout-fill flex><md-content ms-scroll class=\"m-24 md-whiteframe-1dp ph-24 pb-24 pt-16\"><md-list \nng-cloak><div class=\"toolbar\"><div layout=\"row\" class=\"ph-16 mb-10\"><div flex layout=\"row\"><div flex=\"25\"><h3 \nclass=\"text-truncate pr-10\" translate=\"COMPANY.COUNTRY_CODE\"></h3></div><div flex=\"25\"><h3 class=\"text-truncate pr-10\" \ntranslate=\"COMPANY.ZIP_CODE\"></h3></div><div flex=\"25\"><h3 class=\"text-truncate\" translate=\"TRANSPORT.DELIVERY_DELAY\">\n</h3></div></div><div flex=\"nogrow\" style=\"width: 104px\"></div></div></div><md-list-item \nng-repeat=\"postalCodeDelay in vm.postalCodeDelays | orderBy: \'zipCode\':reverse \"><div layout=\"row\" flex><div flex \nlayout=\"row\"><div flex=\"25\" class=\"pl-10\">{{ postalCodeDelay.countryCode }}</div><div flex=\"25\" class=\"pl-5\">\n{{ postalCodeDelay.zipCode }} <span ng-if=\"postalCodeDelay.zipCodeAsterisk\">*</span></div><div flex=\"25\" class=\"pl-5\">\n{{ vm.getDelay(postalCodeDelay.delay) }}</div></div><div flex=\"nogrow\" layout=\"row\" layout-align=\"end\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.editPostalCodeDelay(postalCodeDelay);$event.stopPropagation();\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deletePostalCodeDelay(postalCodeDelay);$event.stopPropagation();\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></div></div></md-list-item></md-list></md-content></div>");
$templateCache.put("app/main/partners.transport/views/tabs/delivery-number-list.html","<div layout=\"column\" layout-fill flex><md-content ms-scroll class=\"m-24 md-whiteframe-1dp p-24\"><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"row\" layout-align=\"start center\" class=\"mh-5\"><div flex=\"25\"><h3 class=\"text-truncate\" translate=\"APP.PERIOD\">\nZeitraum</h3></div><div flex=\"25\"><h3 class=\"text-truncate\" translate=\"CLIENTS.TEMPLATE\">Template</h3></div><div \nflex=\"25\"><h3 class=\"text-truncate\" translate=\"APP.INVOICE_NUMBER.AUTORENEW\"></h3></div><div flex=\"25\"><h3 \nclass=\"text-truncate\" translate=\"APP.INVOICE_NUMBER_NUMBERS\"></h3></div></div><div flex=\"nogrow\" style=\"width: 104px\">\n</div></div><div class=\"content-wrapper\" layout=\"column\" flex><md-content class=\"content thread-list\" ms-scroll flex>\n<div ng-if=\"vm.loadingItems\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\">Loading ...</span></div><div \nng-if=\"vm.deliveryNumbers.length === 0 && !vm.loadingItems\" class=\"no-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><span class=\"md-headline\" translate=\"ORDERS.NO_ORDERS\">\nThere are no orders yet!</span></div><div \nng-repeat=\"deliverynumbers in vm.deliveryNumbers | orderBy:\'start\'  track by deliverynumbers.id\" class=\"mt-20\"><div \nlayout=\"row\" layout-align=\"start center\" layout-fill><div class=\"info\" layout=\"row\" flex layout-align=\"start center\">\n<div flex=\"25\"><span class=\"name\">\n{{deliverynumbers.start * 1000 | nuitDate:\'date\'}} - {{deliverynumbers.end * 1000 | nuitDate:\'date\'}}</span></div><div \nflex=\"25\"><div><div class=\"name\">{{deliverynumbers.tpl}}<br></div><div class=\"grey-600-fg\"><span \ntranslate=\"DOCUMENT.PREVIEW\"></span>: <strong>{{deliverynumbers.previewNumber}}</strong></div></div></div><div \nflex=\"25\" layout=\"row\" layout-align=\"start center\"><div class=\"pl-5\" ng-if=\"deliverynumbers.autoRenew\"><md-icon \nng-if=\"deliverynumbers.autoRenew\" md-font-icon=\"icon-checkbox-marked-circle-outline\" style=\"color: #a0c519\"></md-icon>\n<span translate=\"APP.ACTIVE\"></span></div><div class=\"pl-5\" ng-if=\"!deliverynumbers.autoRenew\"><md-icon \nng-if=\"!deliverynumbers.autoRenew\" md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"grey-100\"></md-icon><span \ntranslate=\"APP.INACTIVE\"></span></div></div><div flex=\"25\" layout=\"row\" class=\"pl-5\" layout-align=\"start center\"><div \nclass=\"name\">{{deliverynumbers.number}}</div><div flex=\"60\"></div></div></div><div flex=\"nogrow\" layout=\"row\" \nlayout-align=\"end\"><md-button class=\"md-icon-button\" \nng-click=\"vm.editDeliveryNumber(deliverynumbers);$event.stopPropagation();\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteDeliveryNumber(deliverynumbers);$event.stopPropagation();\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></div></div></div></md-content></div></div></md-content></div>");
$templateCache.put("app/main/production.general/dialogs/bendFileDownload/bend-file-download.html","<md-dialog aria-label=\"New Group\" id=\"system-color-dialog\"><form name=\"downloadForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"PRODUCTION_QUEUE.GET_BEND_PROGRAM\">Kategorie bearbeiten</h2></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\"><div layout=\"row\"><md-input-container flex><label \ntranslate=\"PRODUCTION_ORDERS.PROFILE_MACHINE\">Machine</label><md-select ng-model=\"vm.machineId\"><md-option \nng-if=\"machine.enabled && !machine.manualWork\" ng-repeat=\"machine in vm.machines track by machine.id\" \nng-value=\"machine.id\"><span>{{machine.name}}</span></md-option></md-select></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\"><md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span \ntranslate=\"APP.CANCEL\">Cancel</span></md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.save()\" \ntype=\"submit\" ng-href=\"{{ vm.getDownloadUrl()  }}\" target=\"_blank\"><span translate=\"APP.DOWNLOAD\">SUBMIT</span>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/production.machines/dialogs/category/transfer.html","<md-dialog aria-label=\"New Group\" id=\"system-color-dialog\"><form name=\"groupsForm\" ng-submit=\"vm.submit()\" novalidate>\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 ng-if=\"vm.isNew\" flex \ntranslate=\"PRODUCTS.CATEGORIES_ADD\">Kategorie hinzufügen</h2><h2 ng-if=\"!vm.isNew\" flex \ntranslate=\"PRODUCTS.CATEGORIES_EDIT\">Kategorie bearbeiten</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"md-dialog-content\"><div layout=\"row\" flex><md-input-container flex \nng-if=\"vm.transferService.isDefined(vm.transfer.name)\"><label translate=\"MACHINE.CONNECTION_NAME\">Name</label><input \ntype=\"text\" name=\"connection_name\" ng-model=\"vm.transfer.name\" aria-label=\"Host\"></md-input-container>\n<md-input-container flex ng-if=\"vm.transferService.isDefined(vm.transfer.host)\"><label \ntranslate=\"MACHINE.CONNECTION_HOST\">Host</label><input type=\"text\" name=\"connection_host\" ng-model=\"vm.transfer.host\" \naria-label=\"Host\"></md-input-container><md-input-container flex \nng-if=\"vm.transferService.isDefined(vm.transfer.token)\"><label translate=\"MACHINE.CONNECTION_TOKEN\">Host</label><input \ntype=\"text\" name=\"connection_host\" ng-model=\"vm.transfer.token\" aria-label=\"Host\" ng-disabled=\"true\">\n</md-input-container></div><div layout=\"row\" flex ng-if=\"vm.transferService.isDefined(vm.transfer.path)\">\n<md-input-container flex><label translate=\"MACHINE.CONNECTION_PATH\">Path</label><input type=\"text\" \nname=\"connection_path\" ng-model=\"vm.transfer.path\" aria-label=\"User\"></md-input-container></div><div layout=\"row\" flex \nng-if=\"vm.transferService.isDefined(vm.transfer.user) && vm.transferService.isDefined(vm.transfer.pwd)\">\n<md-input-container flex ng-if=\"vm.transferService.isDefined(vm.transfer.user)\"><label \ntranslate=\"MACHINE.CONNECTION_USER\">User</label><input type=\"text\" name=\"connection_user\" ng-model=\"vm.transfer.user\" \naria-label=\"User\"></md-input-container><md-input-container flex ng-if=\"vm.transferService.isDefined(vm.transfer.pwd)\">\n<label translate=\"MACHINE.CONNECTION_PASSWORD\">Password</label><input type=\"text\" name=\"connection_password\" \nng-model=\"vm.transfer.pwd\" aria-label=\"Password\"></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n</div><div layout=\"row\"><md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel\n</span></md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.save()\" type=\"submit\" \nng-disabled=\"groupsForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/production.machines/dialogs/twin/twin.html","<md-dialog class=\"twin-dialog\" aria-label=\"nuLink Twin\" \nstyle=\"width: 90%; height: 90%; max-width: none; max-height: none\"><md-toolbar layout=\"column\" class=\"md-accent\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \nlayout=\"row\" layout-align=\"start center\"><span>nuLink Twin (Debug)</span><md-icon class=\"ml-10 s16\" \nmd-font-icon=\"{{vm.connected ? \'icon-lan-connect\' : \'icon-lan-disconnect\'}}\"></md-icon></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" ng-disabled=\"vm.closing\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"APP.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div ng-if=\"vm.errors.length > 0\" layout=\"row\" layout-align=\"space-between center\" \nclass=\"errors red-500-bg white-text\"><div layout=\"row\" layout-wrap><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"error in vm.errors\"><div flex=\"noshrink\" class=\"ph-10 pv-5\">{{error}}</div></div></div><span flex></span>\n</div><md-dialog-content class=\"md-dialog-content\" style=\"padding: 0; position: relative\" layout=\"column\" flex><div \nng-if=\"vm.loading\" style=\"position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: white; z-index: 1\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\" translate=\"APP.LOADING\">Loading ...\n</span></div><iframe name=\"twin-iframe\" id=\"twin-iframe\" src=\"{{vm.twinLocation()}}\" \nstyle=\"border:none;background: white; width: 100%; height: 100%\" iframe-onload=\"vm.iframeLoaded\"></iframe>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/production.orders/components/batch-updater/batch-updater.html","<div layout=\"row\" layout-align=\"center center\" ng-click=\"vm.open=!vm.open\" style=\"cursor: pointer\"><span><div><md-icon \nclass=\"icon s24\" ng-if=\"vm.open\" md-font-icon=\"icon-minus-box\"></md-icon><md-icon class=\"icon s24\" ng-if=\"!vm.open\" \nmd-font-icon=\"icon-plus-box\"></md-icon></div></span><span flex class=\"h2\" layout=\"row\" layout-align=\"center center\">\n<span translate=\"PRODUCTION_ORDERS.BATCH_MATERIALS\">Materials</span></span></div><div layout=\"row\" layout-wrap \nlayout-margin ng-if=\"vm.open\"><md-content layout=\"column\" style=\"min-width:300px\" flex class=\"grey-50-bg\"><table>\n<thead><tr><td colspan=\"5\" class=\"grey-100-bg p-8 pt-0 text-bold\"><span translate=\"PRODUCTION_ORDERS.SELECT_MATERIALS\">\n</span></td><td></td></tr></thead><tbody><tr ng-repeat=\"(index, materialInfo) in vm.materialInfos\"><td class=\"w-8\">\n</td><td class=\"p-5\"><md-checkbox class=\"no-label\" ng-checked=\"vm.selection.isSelected(materialInfo)\" \nng-click=\"vm.selection.toggleSelectedEntity(materialInfo, $event)\"></md-checkbox></td><td><div \nclass=\"w-15 h-15 b mt-4\" style=\"background-color:{{::materialInfo.material.colors.front.hex}}\"></div></td><td \nclass=\"text-bold\">{{::materialInfo.material.name | nuitTranslate}}</td><td ng-if=\"index===0\" \nrowspan=\"{{vm.materialInfos.length}}\"><md-icon ng-class=\"{\'green-500-fg\': vm.selection.getSelected().length>0}\" \nmd-font-icon=\"icon-arrow-right-bold\" class=\"s20\"></md-icon></td></tr></tbody></table></md-content><md-content \nlayout=\"column\" flex layout-align=\"start top\" style=\"min-width:250px\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.coilMachineConfig.enabled\"><div class=\"grey-100-bg\"><span \nclass=\"margin-5\"></span><md-checkbox class=\"m-8\" ng-model=\"vm.enabledCoil\"></md-checkbox><span class=\"text-bold\" \ntranslate=\"PRODUCTION_ORDERS.CUTTING_MACHINE\"></span></div><md-input-container \nng-if=\"vm.coilMachines && vm.enabledCoil\"><label translate=\"MATERIALS.CUTTING_MACHINE\">Maschine</label><md-select \nng-model=\"vm.coilMachine\" ng-change=\"vm.coilMaterial = undefined;vm.updateCoilMaterials()\" name=\"machine\"><md-option \nng-if=\"machine.enabled\" ng-repeat=\"machine in vm.coilMachines\" ng-value=\"machine\">{{::machine.name}}</md-option>\n</md-select></md-input-container><div layout=\"column\" flex layout-align=\"start top\" ng-if=\"vm.enabledCoil\">\n<md-input-container flex style=\"padding-right: 0px !important\" ng-if=\"!vm.coilMachine.manualWork\"><label \ntranslate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL\">Material</label><md-select ng-model=\"vm.coilMaterial\" \nng-change=\"vm.updateCoil()\"><md-select-header class=\"select-header p-10\"><input ng-model=\"searchText\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"{{\'APP.SEARCH\' | translate}}\" id=\"\'cutMaterialSearchSearch\"><md-icon\n ng-show=\"searchText && searchText.length>0\" md-font-icon=\"icon-close\" ng-click=\"searchText=\'\';\"></md-icon>\n</md-select-header><md-option \nng-if=\"searchText===\'\' || searchText===undefined || vm.getName(material).toLowerCase().indexOf(searchText.toLowerCase())>=0\" \nng-repeat=\"material in vm.coils track by material.id\" ng-value=\"material\">{{::material.name | nuitTranslate}}&nbsp;\n<span ng-if=\"material.strength\">({{::material.strength}})</span> <span class=\"text-bold\" \nng-if=\"vm.isDefaultCoilMaterial(material)\">(<span translate=\"APP.DEFAULT\"></span>)</span></md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"vm.coilMaterial && vm.coilMaterial.coils.length>1\" flex \nstyle=\"padding-right: 0px !important\"><label translate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL_COIL\">Coil</label>\n<md-select flex required ng-model=\"vm.coilId\" id=\"{{\'batchCoilSelect_\'+$index}}\" ng-change=\"vm.updateCoil()\"><md-option\n ng-repeat=\"coil in vm.coilMaterial.coils track by coil.id\" ng-value=\"coil.id.toString()\"><span ng-if=\"coil.name\">\n{{coil.name | nuitTranslate}}</span> <span ng-if=\"!coil.name\">{{coil.machineMaterialId}}</span></md-option></md-select>\n</md-input-container><div ng-if=\"vm.coilMaterial && vm.displaySingleCoil()\"><label \nstyle=\"font-size: 10px; opacity: 0.54\" translate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL_COIL\">Coil</label><div \nclass=\"mb-10\">{{vm.coilMaterial.coils[0].name | nuitTranslate}}</div></div><md-input-container flex><label \ntranslate=\"PRODUCTION_ORDERS.COIL_WIDTH\"></label><input flex type=\"number\" ng-model=\"vm.coilMaterialWidth\" \nnuit-unit-input=\"length\" ng-model-options=\"{ debounce: 200 }\" ng-disabled=\"!vm.coilMachine.manualWork\">\n</md-input-container></div></md-content><div layout=\"column\" flex style=\"min-width:250px\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.bendingMachineConfig.enabled ||\n											vm.getValue(profile.bendingMachineData,\'afterBendingPosition.enabled\',false) ||\n											vm.getValue(profile.bendingMachineData,\'bendingProgram.offset\',false) ||\n											vm.reuseBendingPrograms(profile)\">\n<div class=\"grey-100-bg\"><span class=\"margin-5\"></span><md-checkbox class=\"m-8\" ng-model=\"vm.enabledBend\">\n</md-checkbox><span class=\"text-bold\" translate=\"PRODUCTION_ORDERS.BENDING_MACHINE\"></span></div><div layout=\"column\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.bendingMachineConfig.enabled && vm.enabledBend\">\n<md-input-container><label translate=\"PRODUCTION_ORDERS.PROFILE_MACHINE\">Machine</label><md-select \nng-model=\"vm.bendingMachine\" ng-change=\"vm.updateBendingMaterials()\"><md-option ng-if=\"machine.enabled\" \nng-repeat=\"machine in vm.bendingMachines\" ng-value=\"machine\"><span>{{machine.name}}</span></md-option></md-select>\n</md-input-container><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.reuseBendingPrograms() && vm.bendingMaterials && vm.bendingMaterials.length>0 && !vm.manualBends\">\n<md-input-container flex><label translate=\"PRODUCTION_ORDERS.PROFILE_MACHINE_MATERIAL\">Material</label><md-select \nng-model=\"vm.bendingMaterial\"><md-option ng-repeat=\"material in vm.bendingMaterials\" ng-value=\"material\"><span>\n{{material.name | nuitTranslate}}</span> <span class=\"text-bold\" ng-if=\"vm.isDefaultBendingMaterial(material)\">(<span \ntranslate=\"APP.DEFAULT\"></span>)</span></md-option></md-select></md-input-container></div></div></div><div \nlayout=\"column\" flex style=\"min-width:250px\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.punchingMachineConfig.enabled && vm.punchingMachines\"><div \nclass=\"grey-100-bg\"><span class=\"margin-5\"></span><md-checkbox class=\"m-8\" ng-model=\"vm.enabledPunch\"></md-checkbox>\n<span class=\"text-bold\" translate=\"PRODUCTION_ORDERS.PUNCHING_MACHINE\"></span></div><div layout=\"column\" \nng-if=\"vm.enabledPunch\"><md-input-container><label translate=\"PRODUCTION_ORDERS.PUNCHING_MACHINE\">Machine</label>\n<md-select ng-model=\"vm.punchingMachine\" ng-change=\"vm.updatePunchingMaterials()\"><md-option ng-if=\"machine.enabled\" \nng-repeat=\"machine in vm.punchingMachines\" ng-value=\"machine\"><span>{{machine.name}}</span></md-option></md-select>\n</md-input-container><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.punchingMaterials.length>0\">\n<md-input-container flex><label translate=\"PRODUCTION_ORDERS.PUNCHING_MACHINE_MATERIAL\">Material</label><md-select \nng-model=\"vm.punchingMaterial\"><md-option ng-repeat=\"material in vm.punchingMaterials\" ng-value=\"material\"><span>\n{{material.name}}</span></md-option></md-select></md-input-container><md-input-container \nng-if=\"vm.punchingMaterial && vm.punchingMaterial.thicknesses.length>0\"><label translate=\"MATERIAL.THICKNESS\">Material\n</label><md-select ng-model=\"vm.punchingMaterialThickness\"><md-option \nng-repeat=\"thickness in vm.punchingMaterial.thicknesses | orderBy:\'\' track by $index\" ng-value=\"thickness\"><span>\n{{thickness | nuitUnit:\'thickness\'}}</span></md-option></md-select></md-input-container></div></div></div></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.open\"><md-button class=\"md-raised\" ng-disabled=\"vm.disableSave()\" \nlayout=\"row\" layout-align=\"center center\" ng-click=\"vm.save()\"><span translate=\"APP.SAVE\">Save</span></md-button>\n<md-progress-circular ng-if=\"vm.loading\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"40\">\n</md-progress-circular></div>");
$templateCache.put("app/main/production.machines/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.machines\" default-name=\"PRODUCTION_MACHINES_SETTINGS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/production.machines/views/partials/bending-machine-details.html","<div id=\"machine-details\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><div class=\"logo-icon\"><md-icon md-font-icon=\"icon-oil\" \nclass=\"icon\"></md-icon></div><div class=\"logo-text\" translate=\"MACHINES.BENDING_MACHINES\">Maschinen</div></div></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"app.machines.bending\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"divider-vertical mr-20\"></div><div class=\"md-title grey-700-fg\" translate=\"MACHINES.UPDATE_MACHINE\" \nng-if=\"vm.machine.id\">Update machine</div><div class=\"md-title grey-700-fg\" translate=\"MACHINES.ADD_MACHINE\" \nng-if=\"!vm.machine.id\">ADD machine</div></div><md-button class=\"md-raised md-warn\" ng-click=\"vm.save()\" \ntranslate=\"APP.SAVE\" ng-disabled=\"vm.machineForm.$invalid || vm.machineForm.$pristine\">Speichern</md-button></div><form\n name=\"vm.machineForm\" novalidate layout=\"column\" flex><div class=\"content-wrapper\" layout=\"column\" flex><div \nclass=\"content\" ng-if=\"vm.loading\" flex><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n<span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content\n ms-scroll layout-fill ng-if=\"!vm.loading\" class=\"ph-8\"><div layout=\"row\" layout-align=\"space-between top\" \nlayout-margin class=\"mt-30\"><div layout=\"row\" layout-align=\"start top\" class=\"secondary-text\"><md-icon \nmd-font-icon=\"icon-comment-text-outline\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex>General</span></div></div>\n<div layout=\"row\" layout-margin layout-align=\"start center\"><md-input-container flex><label translate=\"MACHINE.NAME\">\nName</label><input type=\"text\" name=\"name\" ng-model=\"vm.machine.name\" aria-label=\"Product Name\" required>\n</md-input-container><div layout=\"row\" flex=\"70\" layout-align=\"start center\"><md-switch class=\"mt-0\" \nng-model=\"vm.machine.enabled\" flex><span translate=\"MACHINE.ENABLED\">Enabled</span></md-switch><md-switch class=\"mt-0\" \nng-model=\"vm.machine.manualWork\" aria-label=\"Manual Work\" flex><span translate=\"MACHINE.MANUAL_WORK\">Manual Work</span>\n</md-switch><md-switch class=\"mt-0\" ng-model=\"vm.machine.reuseBendingPrograms\" aria-label=\"Manual Work\" flex><span \ntranslate=\"MACHINE.REUSE_BENDING_PROGRAMS\">Reuse bending programs</span></md-switch></div></div><div layout=\"row\" \nlayout-margin layout-align=\"start start\"><md-input-container flex><label translate=\"MACHINE.SHORT_NAME\">Name</label>\n<input type=\"text\" name=\"shortName\" ng-model=\"vm.machine.shortName\" aria-label=\"short name\"></md-input-container>\n<md-input-container flex class=\"pb-0\" required><label translate=\"MACHINE.BRAND\">Brand</label><md-select \nng-model=\"vm.machine.brand\" required><md-option ng-value=\"brand.id\" ng-repeat=\"brand in vm.brands track by brand.id\">\n{{brand.name}}</md-option></md-select></md-input-container><md-input-container flex class=\"pb-0\" \nng-if=\"vm.machine.brand===1\"><label translate=\"MACHINE.SIZING_MODE\">SizingMode</label><md-select \nng-model=\"vm.machine.sizingMode\"><md-option ng-value=\"entity.id\" \nng-repeat=\"entity in vm.sizingModes track by entity.id\">\n{{(\'MACHINE.SIZING_MODE_\' + entity.type.toUpperCase()) | translate}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"MACHINE.RADIUS\">Radius</label><input type=\"number\" min=\"0.1\" name=\"radius\" \nng-model=\"vm.machine.radius\" aria-label=\"radius\"></md-input-container></div><div layout=\"column\" layout-margin \nng-if=\"vm.machine.reuseBendingPrograms\"><md-input-container flex><label translate=\"MACHINE.PROGRAM_PREPARATION_URL\">\nName</label><input type=\"text\" name=\"name\" ng-model=\"vm.machine.programPreparationUrl\" aria-label=\"Product Name\" \nrequired></md-input-container><label translate=\"MACHINE.PROGRAM_SCOPE\">Name</label><div ng-jsoneditor \nng-model=\"vm.machine.programScope\" options=\"{mode:\'tree\'}\" flex=\"100\"></div></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.machine.id\"><div flex layout=\"row\" layout-align=\"start top\" layout-margin \nclass=\"secondary-text mt-30\"><md-icon md-font-icon=\"icon-console\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex \ntranslate=\"MACHINE.TRANSFERS\">Transfers</span></div><md-menu><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button md-raised\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button><md-menu-content><md-menu-item ng-repeat=\"item in [\'ftp\', \'smb\', \'nusync\']\"><md-button \nng-click=\"vm.addTransfer(item)\"><span md-menu-align-target translate=\"MACHINE.ADD_TRANSFER\" \ntranslate-values=\"{transfer:item.toUpperCase()}\">Option</span></md-button></md-menu-item></md-menu-content></md-menu>\n</div><div ng-repeat=\"transfer in vm.machine.transfers\"><md-card class=\"p-16\" layout=\"row\"><div layout=\"column\" flex>\n<div class=\"md-title\">{{transfer.type.toUpperCase()}}</div><div>{{transfer.host + \" \" + transfer.path}}</div></div><div\n layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.openTransferDialog(transfer)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span translate=\"APP.EDIT\">Edit</span></md-tooltip></md-button><div \nflex=\"5\"><md-button class=\"md-icon-button\" ng-click=\"vm.removeTransfer($index)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div></md-card></div>\n<div layout=\"row\" layout-align=\"start top\" layout-margin class=\"secondary-text mt-30\"><md-icon \nmd-font-icon=\"icon-vector-square\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex>Restrictions</span></div><div \nlayout=\"row\" layout-align=\"start top\" layout-wrap layout-padding><div flex=\"33\" layout-padding><div \nclass=\"md-whiteframe-2dp pt-24\" layout=\"column\"><span class=\"md-title mh-16\" translate=\"MACHINE.LIMIT_LENGTH\">\nLength Limits</span><div layout=\"row\" layout-align=\"space-between top\" layout-margin><md-input-container flex><label \ntranslate=\"APP.MIN\">Min</label><input type=\"number\" ng-model=\"vm.machine.restrictions.minLength\" \nnuit-unit-input=\"length\"></md-input-container><md-input-container flex><label translate=\"APP.MAX\">Max</label><input \ntype=\"number\" ng-model=\"vm.machine.restrictions.maxLength\" nuit-unit-input=\"length\"></md-input-container></div></div>\n</div><div flex=\"33\" layout-padding><div class=\"md-whiteframe-2dp pt-24\" layout=\"column\"><span class=\"md-title mh-16\" \ntranslate=\"MACHINE.LIMIT_BLANK\">Blank Limits</span><div layout=\"row\" layout-align=\"space-between top\" layout-margin>\n<md-input-container flex><label translate=\"APP.MIN\">Min</label><input type=\"number\" \nng-model=\"vm.machine.restrictions.minBlank\" nuit-unit-input=\"length\"></md-input-container><md-input-container flex>\n<label translate=\"APP.MAX\">Max</label><input type=\"number\" ng-model=\"vm.machine.restrictions.maxBlank\" \nnuit-unit-input=\"length\"></md-input-container></div></div></div><div flex=\"33\" layout-padding><div \nclass=\"md-whiteframe-2dp pt-24\" layout=\"column\"><div layout=\"row\" layout-align=\"space-between top\" class=\"mh-16\"><span \nclass=\"md-title\" translate=\"MACHINE.LIMIT_HEM\">Hem Settings</span><md-switch ng-model=\"vm.machine.restrictions.hem\" \nclass=\"no-margin\"><span translate=\"MACHINE.HEMS_ENABLED\">Enabled</span></md-switch></div><div layout=\"row\" \nlayout-align=\"space-between top\" layout-margin><md-input-container flex><label translate=\"APP.MIN\">Min Length</label>\n<input type=\"number\" ng-model=\"vm.machine.restrictions.minHemLength\" nuit-unit-input=\"length\" \nng-disabled=\"!vm.machine.restrictions.hem\"></md-input-container><md-input-container flex><label translate=\"APP.MAX\">\nMax Length</label><input type=\"number\" ng-model=\"vm.machine.restrictions.maxHemLength\" nuit-unit-input=\"length\" \nng-disabled=\"!vm.machine.restrictions.hem\"></md-input-container></div></div></div><div flex=\"33\" layout-padding><div \nclass=\"md-whiteframe-2dp pt-24\" layout=\"column\"><span class=\"md-title mh-16\" translate=\"MACHINE.LIMIT_BENDING_ANGLE\">\nBending Angle Limits</span><md-input-container flex class=\"mh-16\"><label translate=\"APP.MIN\">Min Angle</label><input \ntype=\"number\" ng-model=\"vm.machine.restrictions.minBendingAngle\"></md-input-container></div></div><div flex=\"33\" \nlayout-padding><div class=\"md-whiteframe-2dp pt-24\" layout=\"column\"><span class=\"md-title mh-16\" \ntranslate=\"MACHINE.LIMIT_SEGMENTS\">Segment Limits</span><div layout=\"row\" layout-align=\"space-between top\" \nlayout-margin><md-input-container flex><label translate=\"APP.MIN\">Min Length</label><input type=\"number\" \nng-model=\"vm.machine.restrictions.minSegmentLength\" nuit-unit-input=\"length\"></md-input-container><md-input-container \nflex><label translate=\"APP.MAX\">Max Length</label><input type=\"number\" \nng-model=\"vm.machine.restrictions.maxSegmentLength\" nuit-unit-input=\"length\"></md-input-container></div></div></div>\n</div><div ng-click=\"customExpanded=!customExpanded\" layout=\"row\" layout-align=\"start top\" layout-margin \nclass=\"secondary-text mt-30\"><md-icon class=\"icon mr-8\" ng-if=\"customExpanded\" md-font-icon=\"icon-minus-box\"></md-icon>\n<md-icon class=\"icon mr-8\" ng-if=\"!customExpanded\" md-font-icon=\"icon-plus-box\"></md-icon><span class=\"md-title\" flex \ntranslate=\"MACHINE.CUSTOM_DATA\"></span></div><div ng-if=\"customExpanded\" layout=\"row\" layout-align=\"start top\" \nlayout-padding><div ng-jsoneditor ng-model=\"vm.machine.customData\" options=\"{mode:\'tree\'}\" flex=\"100\"></div></div>\n</md-content></div></form></div></div></div>");
$templateCache.put("app/main/production.machines/views/partials/coil-machine-details.html","<div id=\"coil-machine-details\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\"><div class=\"logo-icon\"><md-icon md-font-icon=\"icon-oil\" \nclass=\"icon\"></md-icon></div><div class=\"logo-text\" translate=\"MACHINES.COIL_MACHINES\">Maschinen</div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"app.machines.coil\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"divider-vertical mr-20\"></div><div class=\"md-title grey-700-fg\" translate=\"MACHINES.UPDATE_MACHINE\" \nng-if=\"vm.machine.id\">Update machine</div><div class=\"md-title grey-700-fg\" translate=\"MACHINES.ADD_MACHINE\" \nng-if=\"!vm.machine.id\">ADD machine</div></div><md-button class=\"md-raised md-warn\" ng-click=\"vm.save()\" \ntranslate=\"APP.SAVE\" ng-disabled=\"vm.machineForm.$invalid || vm.machineForm.$pristine\">Speichern</md-button></div><form\n name=\"vm.machineForm\" novalidate layout=\"column\" flex><div class=\"content-wrapper\" layout=\"column\" flex><div \nclass=\"content\" ng-if=\"vm.loading\" flex><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n<span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content\n ms-scroll layout-fill ng-if=\"!vm.loading\" class=\"ph-8\"><div layout=\"row\" layout-align=\"space-between top\" \nlayout-margin class=\"mt-30\"><div layout=\"row\" layout-align=\"start top\" class=\"secondary-text\" flex><md-icon \nmd-font-icon=\"icon-comment-text-outline\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"APP.GENERAL\">\n</span></div><md-button ng-if=\"vm.config.ims.machines.allowDeleteJobs\" class=\"md-raised md-accent\" \nng-click=\"vm.deleteJobs()\" translate=\"MACHINE.DELETE_JOBS\">Delete Jobs</md-button></div><div layout=\"row\" \nlayout-margin><md-input-container flex><label translate=\"MACHINE.NAME\">Name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.machine.name\" aria-label=\"Product Name\" required></md-input-container><div layout=\"row\" flex><md-switch \nng-model=\"vm.machine.enabled\" flex><span translate=\"MACHINE.ENABLED\">Enabled</span></md-switch><md-switch \nng-model=\"vm.machine.manualWork\" aria-label=\"Manual Work\" flex><span translate=\"MACHINE.MANUAL_WORK\">Manual Work</span>\n</md-switch></div></div><div layout=\"row\" layout-margin><md-input-container flex ng-if=\"!vm.machine.manualWork\"><label \ntranslate=\"MACHINE.BRAND\">Brand</label><md-select ng-model=\"vm.machine.brand\" required><md-option ng-value=\"brand.id\" \nng-repeat=\"brand in vm.brands\">{{brand.name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"MACHINE.CUT_MODE\">Cut mode</label><md-select ng-model=\"vm.machine.cutMode\" required><md-option \nng-value=\"cutMode.id\" ng-repeat=\"cutMode in vm.cutModes\">{{cutMode.name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label><span translate=\"MACHINE.DEFAULT_COIL_WIDTH\">Default Coil Width </span><span>\n({{vm.nuitUnits(\'length\').symbol}})</span></label><input type=\"number\" min=\"0\" ng-model=\"vm.machine.defaultCoilWidth\" \nnuit-unit-input=\"length\"></md-input-container></div><div layout=\"row\" layout-margin><md-input-container flex=\"34\">\n<label><span translate=\"MACHINE.MIN_DISTANCE\"></span> <span>({{vm.nuitUnits(\'length\').symbol}})</span></label><input \ntype=\"number\" min=\"0\" ng-model=\"vm.machine.minDistance\" required nuit-unit-input=\"length\" machine.min_distance>\n</md-input-container><md-input-container flex=\"33\"><label translate=\"MACHINE.KNIVES\">Knives</label><input \ntype=\"number\" min=\"1\" ng-model=\"vm.machine.knives\" required></md-input-container><md-input-container flex=\"33\"><label \ntranslate=\"MACHINE.BLANK_OPTION\">Brand</label><md-select ng-model=\"vm.machine.blankOption\" required=\"true\" required>\n<md-option ng-repeat=\"option in vm.blankOptions\" ng-value=\"option.value\" class=\"text-uppercase\">\n{{option.key | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-margin><md-switch\n ng-model=\"vm.machine.rotateParts\" flex><span translate=\"MACHINE.ROTATE_PARTS\">Enabled</span></md-switch></div><div \nflex ng-if=\"!vm.machine.manualWork\"><div layout=\"column\" flex layout-margin class=\"mb-20\"><div layout=\"row\" \nlayout-align=\"start top\" class=\"secondary-text mt-30\"><md-icon md-font-icon=\"icon-console\" class=\"mr-8\"></md-icon><span\n class=\"md-title\" flex translate=\"MACHINE.CONNECTION\"></span></div><md-input-container><md-select \nng-model=\"vm.machine.connection.type\" ng-change=\"vm.updateConnectionType()\"><md-option ng-value=\"null\" \ntranslate=\"MACHINE.CONNECTION_TYPE.DEFAULT\"></md-option><md-option ng-value=\"\'nusync\'\" \ntranslate=\"MACHINE.CONNECTION_TYPE.NUSYNC\"></md-option></md-select></md-input-container></div><div \nng-if=\"vm.machine.connection.type===null || vm.machine.connection.type===\'\'\"><div layout=\"row\" layout-margin>\n<md-input-container flex><label translate=\"MACHINE.CONNECTION_HOST\">Host</label><input type=\"text\" \nname=\"connection_host\" ng-model=\"vm.machine.connection.host\" aria-label=\"Host\"></md-input-container></div><div \nlayout=\"row\" layout-margin><md-input-container flex><label translate=\"MACHINE.CONNECTION_USER\">User</label><input \ntype=\"text\" name=\"connection_user\" ng-model=\"vm.machine.connection.user\" aria-label=\"User\"></md-input-container>\n<md-input-container flex><label translate=\"MACHINE.CONNECTION_PASSWORD\">Password</label><input type=\"text\" \nname=\"connection_password\" ng-model=\"vm.machine.connection.pwd\" aria-label=\"Password\"></md-input-container></div></div>\n<div ng-if=\"vm.machine.connection.type===\'nusync\'\"><div layout=\"row\" layout-margin><div ng-if=\"!vm.loadingNuSyncToken\" \nlayout=\"column\" flex=\"100\"><div class=\"text-bold\" translate=\"MACHINE.TOKEN\"></div><div flex class=\"md-block\" \nstyle=\"overflow-wrap: break-word\" ng-if=\"vm.nuSyncToken.length>0\">{{vm.nuSyncToken}}</div><div \nng-if=\"vm.nuSyncToken.length===0\" flex><md-icon md-font-icon=\"icon-alert\" class=\"red-500-fg\"></md-icon><span \ntranslate=\"MACHINE.NO_TOKEN\"></span></div></div><div ng-if=\"vm.loadingNuSyncToken\" layout=\"row\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular><span class=\"md-block\" \ntranslate=\"APP.LOADING\">Loading ...</span></div></div></div></div><div layout=\"row\" layout-align=\"start top\" \nlayout-margin class=\"secondary-text mt-30\"><md-icon class=\"icon mr-8\" md-font-icon=\"icon-trash\"></md-icon><span \nclass=\"md-title\" flex translate=\"MACHINE.WASTE\"></span></div><div layout=\"column\" layout-margin \nlayout-align=\"start center\" flex><div layout=\"row\" layout-fill layout-align=\"start center\" flex><md-switch \nng-model=\"vm.machine.waste.label.enabled\" style=\"margin-right: 20px\"><span translate=\"MACHINE.WASTE_LABEL_ENABLED\">\n</span></md-switch><md-input-container style=\"margin: 8px\" ng-if=\"vm.machine.waste.label.enabled\" flex><label \ntranslate=\"MACHINE.WASTE_LABEL_TPL\"></label><input type=\"text\" ng-model=\"vm.machine.waste.label.tpl\">\n</md-input-container></div><div layout=\"row\" layout-fill layout-align=\"start center\" flex><md-input-container \nstyle=\"margin: 8px\" flex><label><span translate=\"MACHINE.WASTE_MIN_LENGTH\"></span> <span>\n({{vm.nuitUnits(\'length\').symbol}})</span></label><input type=\"number\" ng-model=\"vm.machine.waste.minLength\" \nnuit-unit-input=\"length\"></md-input-container><md-input-container style=\"margin: 8px\" flex><label><span \ntranslate=\"MACHINE.WASTE_MAX_LENGTH\"></span> <span>({{vm.nuitUnits(\'length\').symbol}})</span></label><input \ntype=\"number\" ng-model=\"vm.machine.waste.maxLength\" nuit-unit-input=\"length\"></md-input-container></div></div><div \nng-click=\"customExpanded=!customExpanded\" layout=\"row\" layout-align=\"start top\" layout-margin \nclass=\"secondary-text mt-30\"><md-icon class=\"icon mr-8\" ng-if=\"customExpanded\" md-font-icon=\"icon-minus-box\"></md-icon>\n<md-icon class=\"icon mr-8\" ng-if=\"!customExpanded\" md-font-icon=\"icon-plus-box\"></md-icon><span class=\"md-title\" flex \ntranslate=\"MACHINE.CUSTOM_DATA\"></span></div><div ng-if=\"customExpanded\" layout=\"row\" layout-align=\"start top\" \nlayout-padding><div ng-jsoneditor ng-model=\"vm.machine.customData\" options=\"{mode:\'tree\'}\" flex=\"100\"></div></div>\n</md-content></div></form></div></div></div>");
$templateCache.put("app/main/production.machines/views/partials/connection.html","<div layout=\"row\" layout-align=\"start top\" layout-margin class=\"secondary-text mt-30\"><md-icon \nmd-font-icon=\"icon-console\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex>Connection</span></div><div \nlayout=\"row\" layout-margin><md-input-container flex><label translate=\"MACHINE.CONNECTION_TYPE\">Type</label><md-select \nng-model=\"vm.machine.connection.type\"><md-option ng-value=\"1\">FTP</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"MACHINE.CONNECTION_HOST\">Host</label><input type=\"text\" \nname=\"connection_host\" ng-model=\"vm.machine.connection.host\" aria-label=\"Host\"></md-input-container></div><div \nlayout=\"row\" layout-margin><md-input-container flex><label translate=\"MACHINE.CONNECTION_USER\">User</label><input \ntype=\"text\" name=\"connection_user\" ng-model=\"vm.machine.connection.user\" aria-label=\"User\"></md-input-container>\n<md-input-container flex><label translate=\"MACHINE.CONNECTION_PASSWORD\">Password</label><input type=\"text\" \nname=\"connection_password\" ng-model=\"vm.machine.connection.pwd\" aria-label=\"Password\"></md-input-container></div>");
$templateCache.put("app/main/production.machines/views/partials/punching-machine-details.html","<div id=\"coil-machine-details\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\"><div class=\"logo-icon\"><md-icon md-font-icon=\"icon-oil\" \nclass=\"icon\"></md-icon></div><div class=\"logo-text\" translate=\"MACHINES.PUNCHING_MACHINES\">Maschinen</div></div></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nui-sref=\"app.machines.punching\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"divider-vertical mr-20\"></div><div class=\"md-title grey-700-fg\" translate=\"MACHINES.UPDATE_MACHINE\" \nng-if=\"vm.machine.id\">Update machine</div><div class=\"md-title grey-700-fg\" translate=\"MACHINES.ADD_MACHINE\" \nng-if=\"!vm.machine.id\">ADD machine</div></div><md-button class=\"md-raised md-warn\" ng-click=\"vm.save()\" \ntranslate=\"APP.SAVE\" ng-disabled=\"vm.machineForm.$invalid || vm.machineForm.$pristine\">Speichern</md-button></div><form\n name=\"vm.machineForm\" novalidate layout=\"column\" flex><div class=\"content-wrapper\" layout=\"column\" flex><div \nclass=\"content\" ng-if=\"vm.loading\" flex><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n<span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content\n ms-scroll layout-fill ng-if=\"!vm.loading\" class=\"ph-8\"><div layout=\"row\" layout-align=\"space-between top\" \nlayout-margin class=\"mt-30\"><div layout=\"row\" layout-align=\"start top\" class=\"secondary-text\" flex><md-icon \nmd-font-icon=\"icon-comment-text-outline\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"APP.GENERAL\">\n</span></div></div><div layout=\"row\" layout-margin><md-input-container flex><label translate=\"MACHINE.NAME\">Name\n</label><input type=\"text\" name=\"name\" ng-model=\"vm.machine.name\" aria-label=\"Product Name\" required>\n</md-input-container><div layout=\"row\" flex><md-switch ng-model=\"vm.machine.enabled\" flex><span \ntranslate=\"MACHINE.ENABLED\">Enabled</span></md-switch><md-switch ng-model=\"vm.machine.manualMachine\" \naria-label=\"Manual Work\" flex><span translate=\"MACHINE.MANUAL_WORK\">Manual Work</span></md-switch></div></div><div \nlayout=\"row\" layout-margin><md-input-container flex><label translate=\"MACHINE.BRAND\">Brand</label><md-select \nng-model=\"vm.machine.brand\" required><md-option ng-value=\"brand.id\" ng-repeat=\"brand in vm.brands\">{{brand.name}}\n</md-option></md-select></md-input-container></div><div ng-click=\"customExpanded=!customExpanded\" layout=\"row\" \nlayout-align=\"start top\" layout-margin class=\"secondary-text mt-30\"><md-icon class=\"icon mr-8\" ng-if=\"customExpanded\" \nmd-font-icon=\"icon-minus-box\"></md-icon><md-icon class=\"icon mr-8\" ng-if=\"!customExpanded\" \nmd-font-icon=\"icon-plus-box\"></md-icon><span class=\"md-title\" flex translate=\"MACHINE.CUSTOM_DATA\"></span></div><div \nng-if=\"customExpanded\" layout=\"row\" layout-align=\"start top\" layout-padding><div ng-jsoneditor \nng-model=\"vm.machine.customData\" options=\"{mode:\'tree\'}\" flex=\"100\"></div></div></md-content></div></form></div></div>\n</div>");
$templateCache.put("app/main/production.orders/dialogs/label/label.html","<md-dialog><md-toolbar class=\"md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span class=\"title\" \ntranslate=\"PRODUCTION_ORDERS.LABEL\">Print label</span></md-toolbar><md-dialog-content class=\"md-dialog-content\" \nlayout=\"column\" layout-align=\"center center\" layout-fill><img http-src=\"{{vm.label}}\" alt=\"\" \nfallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\" class=\"w-500 m-8\"></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"bt\"><md-button ng-click=\"vm.close()\" class=\"md-warn\" \naria-label=\"n\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button ng-click=\"vm.print()\" \nclass=\"md-accent md-raised\" aria-label=\"n\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.label.manualPrinter.enabled\"><span \ntranslate=\"PRODUCTION_ORDERS.PRINT_LABEL\">Save</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/production.orders/dialogs/solution/solution.html","<md-dialog style=\"max-width:96%;width:100%; max-height:96%;height:100%\" layout=\"column\"><div class=\"md-accent-bg p-8\" \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.enableUi\"><span class=\"title\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"mr-8\" translate=\"SOLUTIONS.TITLE\">Solution</span>\n {{::vm.solution | shortName:(vm.solution.name ? \'{name}\' : \'#{id}\')}}</span> <span class=\"ml-20\" \ntranslate=\"SOLUTIONS.OVERALL_LENGTH\"></span> <span class=\"ml-10\">{{vm.overallLength | nuitUnit:\'length\'}}</span><div \nflex></div><div class=\"w-15 h-15 b mr-10 ml-20\" style=\"background-color:{{::vm.solution.material.colors.front.hex}}\">\n</div><div>{{::vm.solution.material.name | nuitTranslate}}</div><div class=\"ml-20\">\n{{::vm.solution.machineMaterialName}}</div><div class=\"ml-20\" \nng-if=\"vm.solution.machineCoilName!==\'\' && vm.solution.machineCoilName!==null && vm.solution.machineMaterialName!==vm.solution.machineCoilName\">\n{{::vm.solution.machineCoilName}}</div></div><div class=\"mt-20\" ng-if=\"!vm.enableUi\"></div><md-dialog-content \nclass=\"pt-0 pb-0\" layout=\"column\" layout-fill flex><nuit-solution ng-if=\"vm.solutionConfig.renderer.tag===\'canvas\'\" \nlayout-fill flex solution=\"vm.solution\" config=\"vm.solutionConfig\" print-style=\"false\" \nenable-tools=\"!vm.showMachineJob && !vm.readOnly\" enable-ui=\"vm.enableUi\" limit-jobs-config=\"vm.limitJobs\">\n</nuit-solution><nuit-solution-svg ng-if=\"vm.solutionConfig.renderer.tag===\'svg\'\" layout-fill flex \nsolution=\"vm.solution\" config=\"vm.solutionConfig\" print-style=\"false\" \nenable-tools=\"!vm.showMachineJob && !vm.readOnly\" enable-ui=\"vm.enableUi\" limit-jobs-config=\"vm.limitJobs\" \nenable-complain=\"vm.enableComplain\"></nuit-solution-svg></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"start space-between\" class=\"bt\"><div flex ng-if=\"!vm.enableUi\"></div><div class=\"grey-100-bg mr-8 ml-8\" \nlayout=\"row\" flex ng-if=\"vm.enableUi\"><div class=\"pl-10 pr-10\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"mr-10\" translate=\"PRODUCTION_ORDERS.SHOW_MACHINE_JOB\"></div><md-checkbox class=\"mt-16\" flex \nng-model=\"vm.showMachineJob\" ng-change=\"vm.toggleMachineJob()\"></md-checkbox></div><div class=\"bl pl-10 pr-10\" \nlayout=\"row\" ng-if=\"vm.oldSolutions.length>1 && !vm.showMachineJob\" layout-align=\"start center\" flex><div \ntranslate=\"PRODUCTION_ORDERS.OPTIMIZATION_HISTORY\"></div><md-tabs md-selected=\"vm.selectedSolutionIndex\" flex><md-tab \nng-repeat=\"solution in vm.oldSolutions\" ng-click=\"vm.setSolution($index)\">{{$index + 1}}</md-tab></md-tabs><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.deleteSolution()\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></div></div><div layout=\"row\" flex-offset=\"5\" ng-if=\"!vm.showMachineJob\"><md-button ng-click=\"vm.close()\" \nclass=\"md-warn\" aria-label=\"n\"><span translate=\"APP.CLOSE\">Cancel</span></md-button><md-button \nng-if=\"!vm.solutionHasChanged() && vm.enableUi && !vm.readOnly\" ng-click=\"vm.submit()\" class=\"md-accent md-raised\" \naria-label=\"n\"><span translate=\"APP.SAVE\">Save</span></md-button><md-button \nng-if=\"vm.solutionHasChanged() && vm.enableUi && !vm.readOnly\" ng-click=\"vm.optimize()\" class=\"md-accent md-raised\" \naria-label=\"n\"><span translate=\"APP.OPTIMIZE\">Save</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/production.orders/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.productionOrders\" default-name=\"PRODUCTION_ORDERS_SETTINGS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/production.orders/views/tabs/cuttings.html","");
$templateCache.put("app/main/production.orders/views/tabs/details.html","<md-content layout-fill flex ms-scroll><div class=\"grey-100-bg\" layout=\"row\" ng-if=\"vm.order.status===0\"><div flex \nlayout=\"column\" layout-margin ng-click=\"vm.expandErrors()\" style=\"min-height: 50px\"><div \nng-if=\"vm.producibleInProgress\" layout=\"row\" layout-align=\"center center\"><span flex></span><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><span flex></span></div><div flex \nng-if=\"!vm.producibleInProgress && !vm.isProducible && vm.producible.length===0\" layout=\"row\" \nlayout-align=\"center center\"><span flex></span><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon>\n<span style=\"margin-left:4px\" translate=\"ERROR.ERROR_ON_UPDATE\"></span> <span flex></span></div><div \nstyle=\"cursor: pointer; min-height: 32px\" ng-if=\"!vm.isProducible && !vm.producibleInProgress\" layout=\"row\" \nlayout-align=\"center center\"><span flex></span><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon>\n<span style=\"margin-left:4px\"><span translate=\"ERRORS.ENCOUNTERED\"></span>: <span class=\"text-bold red-500-fg\">\n{{vm.producible.length}}</span></span> <span flex></span></div><div flex \nng-if=\"vm.producible.length===0 && vm.isProducible && !vm.producibleInProgress\" layout=\"row\" \nlayout-align=\"center center\"><span flex></span><md-icon md-font-icon=\"icon-check-circle\" class=\"green-500-fg\">\n</md-icon><span class=\"text-bold\" style=\"margin-left:4px\" translate=\"PRODUCTION_ORDERS.READY_TO_PRODUCE\"></span> <span \nflex></span></div><div flex ng-if=\"!vm.isProducible && (vm.expanded || vm.producible.length<=8)\" layout=\"row\" \nlayout-wrap layout-align=\"space-between space-between\" layout-padding><span flex=\"noshrink\" \nng-repeat=\"error in vm.producible\">{{\'ERROR.\' + error.code.toUpperCase() | translate:error.data}}</span></div></div>\n<div ng-if=\"!vm.producibleInProgress\" class=\"p-10\"><md-button class=\"md-raised md-icon-button\" \nng-click=\"vm.reloadProducibility()\"><md-icon md-font-icon=\"icon-sync\"></md-icon></md-button></div></div><div \nlayout=\"row\" layout-margin><div layout=\"column\" flex=\"40\" layout-margin><div layout=\"column\"><span \nclass=\"md-subheader mt-10\"><span translate=\"PRODUCTION_ORDERS.CREATED_AT\">Erstellt am</span>\n: {{ vm.order.createdAt | nuitDatetime: vm.config.localization.dateFormat }}</span><div \nng-if=\"vm.order && vm.order.productionStatus\"><div class=\"mt-16\" \nng-if=\"!vm.config.ims.productionOrders.productionProfile.geometryMode.enabled\"><span class=\"text-bold\" layout=\"row\">\n<span flex translate=\"APP.ALL\"></span> <span class=\"text-bold pl-16\">\n{{ vm.order.productionStatus.producedParts }}/{{ vm.order.productionStatus.totalParts }} <span \ntranslate=\"PRODUCTION_ORDERS.PRODUCED\">produziert</span></span></span><md-progress-linear \nclass=\"md-accent productionProgress\" style=\"{\'text-color\'}\" md-mode=\"determinate\" ng-value=\"vm.getProgress()\" flex>\n</md-progress-linear></div><div \nng-if=\"vm.order.productionStatus.machine.bending && vm.order.productionStatus.machine.bending.length>0\" \nclass=\"mt-16 b p-8\"><div class=\"text-bold\" translate=\"MACHINES.BENDING_MACHINES\"></div><div \nng-repeat=\"machine in vm.order.productionStatus.machine.bending | orderBy:\'machineId\'\" class=\"pb-5\"><span layout=\"row\">\n<span flex>{{machine.machine.name}}</span> <span class=\"pl-16\">{{ machine.produced }}/{{ machine.total }} <span \ntranslate=\"PRODUCTION_ORDERS.PRODUCED\">produziert</span></span></span><md-progress-linear \nclass=\"md-accent productionProgress\" style=\"{\'text-color\'}\" md-mode=\"determinate\" \nng-value=\"vm.getDetailProgress(machine.produced,machine.total)\" flex></md-progress-linear></div></div><div \nng-if=\"vm.order.productionStatus.machine.coil && vm.order.productionStatus.machine.coil.length>0\" class=\"mt-16 b p-8\">\n<div class=\"text-bold\" translate=\"MACHINES.COIL_MACHINES\"></div><div \nng-repeat=\"machine in vm.order.productionStatus.machine.coil | orderBy:\'machineId\'\" class=\"pb-5\"><span layout=\"row\">\n<span flex>{{machine.machine.name}}</span> <span class=\"pl-16\">{{ machine.produced }}/{{ machine.total }} <span \ntranslate=\"PRODUCTION_ORDERS.PRODUCED\">produziert</span></span></span><md-progress-linear \nclass=\"md-accent productionProgress\" style=\"{\'text-color\'}\" md-mode=\"determinate\" \nng-value=\"vm.getDetailProgress(machine.produced,machine.total)\" flex></md-progress-linear></div></div><div \nng-if=\"vm.order.productionStatus.machine.punching && vm.order.productionStatus.machine.punching.length>0\" \nclass=\"mt-16 b p-8\"><div class=\"text-bold\" translate=\"MACHINES.PUNCHING_MACHINES\"></div><div \nng-repeat=\"machine in vm.order.productionStatus.machine.punching | orderBy:\'machineId\'\" class=\"pb-5\"><span \nlayout=\"row\"><span flex>...</span> <span class=\"pl-16\">{{ machine.produced }}/{{ machine.total }} <span \ntranslate=\"PRODUCTION_ORDERS.PRODUCED\">produziert</span></span></span><md-progress-linear \nclass=\"md-accent productionProgress\" style=\"{\'text-color\'}\" md-mode=\"determinate\" \nng-value=\"vm.getDetailProgress(machine.produced,machine.total)\" flex></md-progress-linear></div></div></div></div><span\n class=\"h2 mt-32\" translate=\"PRODUCTION_ORDERS.MATERIALS_HEADING\" ng-if=\"vm.order.productionProfiles.length>0\">\nMaterials</span><div layout=\"column\"><table><tbody><tr ng-repeat=\"materialInfo in vm.order.materialInfos\"><td>\n{{materialInfo.weight | nuitUnit:\'weight\' }}</td><td>{{materialInfo.m2 | nuitUnit:\'area\'}}</td><td><div \nclass=\"w-15 h-15 b mt-4\" style=\"background-color:{{::materialInfo.material.colors.front.hex}}\"></div></td><td \nclass=\"text-bold\">{{::materialInfo.material.name | nuitTranslate}}</td></tr></tbody></table></div></div><div \nlayout=\"column\" class=\"bl\" flex layout-margin><span class=\"h2\" translate=\"PRODUCTION_ORDERS.ORDERS\">Aufträge</span><div\n class=\"info ml-0\" layout=\"row\" layout-wrap layout-margin><div flex=\"30\" layout=\"column\" \nlayout-align=\"space-around start\" ng-repeat=\"shopOrder in vm.shopOrders\" ng-click=\"vm.openShopOrder(shopOrder)\" \nstyle=\"cursor:pointer\" flex class=\"p-8 grey-100-bg\"><div layout=\"column\" flex=\"nogrow\"><div \nstyle=\"font-size: 15px;font-weight: 500\">{{vm.config.ims.orders.nameFormat | nuitFormatter: shopOrder}}</div><div \nclass=\"message\" style=\"color: rgba(0, 0, 0, 0.54)\">{{ shopOrder.ordered_on | nuitDatetime: \'datetime\' }}</div>\n<md-divider class=\"pb-8\"></md-divider></div><div layout=\"column\" flex layout-align=\"space-around start\" layout-fill><a \nng-repeat=\"docObj in shopOrder.documents | languageFilter:\'lang\' | orderByTranslated:\'name\' track by $index\" \nstyle=\"white-space: nowrap\" class=\"message mr-5\" ng-href=\"{{::vm.getDocumentURL(docObj)}}\" target=\"_blank\" \nng-click=\"$event.stopPropagation();\" flex><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>{{::docObj.name | translate}}\n</a></div></div></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.config.ims.productionOrders.details.showDocuments\"><span class=\"h2 mr-20\" \ntranslate=\"PRODUCTION_ORDERS.DOCUMENTS\">Aufträge</span> <span><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"20\" ng-if=\"vm.documentStatus.updating\"></md-progress-circular></span></div><div \nlayout=\"row\" layout-align=\"start space-between\" \nng-if=\"!vm.documentStatus.updating && vm.config.ims.productionOrders.details.showDocuments\"><div layout=\"column\" \nlayout-align=\"start start\" class=\"grey-100-bg p-10\"><a ng-if=\"!vm.documentStatus.error\" \nng-repeat=\"docObj in vm.order.documents | imsLanguageFallback:\'lang\' | orderByTranslated:\'name\' track by docObj.key\" \nstyle=\"white-space: nowrap\" class=\"message mr-5\" ng-href=\"{{::vm.getDocumentURL(docObj)}}\" target=\"_blank\" \nng-click=\"$event.stopPropagation();\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>{{::docObj.name | translate}} \n<span class=\"grey-600-fg\" ng-if=\"docObj.lang !== vm.activeLanguage\">({{docObj.lang | uppercase}})</span><md-icon \nclass=\"red-500-fg\" ng-if=\"docObj.error\" md-font-icon=\"icon-alert\"><md-tooltip><span>\n{{docObj.error.code | translate:docObj.error.data}}</span></md-tooltip></md-icon></a><div \nng-if=\"vm.documentStatus.error\">{{vm.documentStatus.error.code | translate:vm.documentStatus.error.data}}</div><div \nclass=\"message\" ng-if=\"!vm.documentStatus.error && !vm.order.documents.length\" translate=\"DOCUMENTS.EMPTY_LIST\">\nKeine Dokumente gefunden!</div></div></div><div class=\"mt-20\" layout=\"column\" \nng-if=\"vm.order.productionProfiles.length>0\"><div class=\"mb-10\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.coilMachineConfig.enabled\"><span class=\"h2 md-title mr-20\" \ntranslate=\"PRODUCTION.CUTTING_HEADER\"></span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"20\" ng-if=\"vm.solutionStatus.updating\"></md-progress-circular><span flex></span> <span \nclass=\"red-fg text-bold mr-20\" ng-if=\"vm.hasErrorType(\'PRODUCTION_SOLUTION_WIDTH_DOES_NOT_EQUAL_COIL_WIDTH\')\" \ntranslate=\"PRODUCTION_ORDERS.SOLUTION_RECREATION_MANDATORY\"></span><md-button \nng-class=\"{\'md-accent\':!vm.hasErrorType(\'PRODUCTION_SOLUTION_WIDTH_DOES_NOT_EQUAL_COIL_WIDTH\'),\'md-warn\':vm.hasErrorType(\'PRODUCTION_SOLUTION_WIDTH_DOES_NOT_EQUAL_COIL_WIDTH\')}\" \nng-click=\"vm.recreateSolutions()\" ng-if=\"!vm.solutionStatus.updating\" class=\"mr-35 md-raised md-accent m-0\"><label \ntranslate=\"APP.RECREATE\"></label></md-button></div><div class=\"grey-100-bg p-10\" ng-if=\"vm.solutionStatus.error\">\n{{vm.solutionStatus.error.code | translate:vm.solutionStatus.error.data}}</div><div ng-if=\"!vm.solutionStatus.error\" \nclass=\"mt-10\" layout=\"row\" layout-fill flex \nng-if=\"vm.config.ims.productionOrders.productionProfile.coilMachineConfig.enabled && !vm.solutionStatus.updating\">\n<table layout-fill><thead><tr><td></td><td class=\"text-bold text-center\" translate=\"APP.MATERIAL\">Material</td><td \nclass=\"text-bold text-center\" translate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL\">Productionsmaterial</td><td \nclass=\"text-bold text-center\" translate=\"PRODUCTION_ORDERS.CUTTING_WASTE\">Verschnitt</td><td \nclass=\"text-bold text-center\" ng-if=\"vm.config.ims.productionOrders.solutionToggle.enabled\" \ntranslate=\"PRODUCTION_ORDERS.SOLUTION_TOGGLE\">Last slit on waste</td><td></td></tr></thead><tbody><tr \nng-repeat-start=\"solutions in vm.solutionsByMachine\"><td class=\"grey-100-bg\" \ncolspan=\"{{vm.config.ims.productionOrders.solutionToggle.enabled ? 6 : 5}}\">\n{{vm.getCoilMachineName(solutions.machineId)}}</td></tr><tr ng-repeat=\"solution in solutions.list\" ng-repeat-end><td \nnowrap=\"nowrap\"><span class=\"md-blue-500-bg p-5 brad-2\">{{solution.name}}</span></td><td><table><tbody><tr><td><div \nclass=\"w-15 h-15 b mt-4\" style=\"background-color:{{solution.material.colors.front.hex}}\"></div></td><td>\n{{solution.material.name | nuitTranslate}}</td></tr></tbody></table></td><td class=\"text-center\"><div>\n{{solution.machineMaterialName!==null?solution.machineMaterialName:\'-\'}}</div><div \nng-if=\"solution.machineCoilName!==\'\' && solution.machineCoilName!==null && solution.machineMaterialName!==solution.machineCoilName\">\n{{solution.machineCoilName}}</div></td><td class=\"text-center\">\n{{solution.waste | nuitEvoNormalize:\'area\' | nuitUnit:\'area\'}} <span class=\"text-italic\">\n({{vm.formatPercentage(solution.wastePercent)}})</span></td><td class=\"text-center\" \nng-if=\"vm.config.ims.productionOrders.solutionToggle.enabled\"><md-checkbox class=\"m-0\" aria-label=\"solution toggle\" \nng-checked=\"solution.customData | nuitDotNotation:vm.config.ims.productionOrders.solutionToggle.key:false\" \nng-click=\"vm.toggleSolution(solution)\" ng-disabled=\"vm.order.status!==0\"></md-checkbox></td><td layout=\"row\" \nclass=\"mr-20\"><div flex></div><md-button class=\"md-accent md-raised\" aria-label=\"n\" \nng-click=\"vm.openSolution(solution)\"><span translate=\"PRODUCTION_ORDERS.VIEW_SOLUTION\">Show solution</span></md-button>\n</td></tr></tbody></table></div></div></div></div><div layout=\"row\" class=\"m-16\" layout-align=\"start top\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.reset()\" ng-if=\"vm.order.status!==0\" \nng-disabled=\"vm.orderProgessState!==\'NONE\' && vm.solutionStatus.updating\"><span \ntranslate=\"PRODUCTION_ORDERS.MOVE_BACK\">Move Back</span></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.produce()\" ng-if=\"vm.order.status===0\" \nng-disabled=\"vm.orderProgessState!==\'NONE\' || vm.solutionStatus.updating\" layout=\"row\"><span \ntranslate=\"PRODUCTION_ORDERS.PRODUCE\">Produzieren</span></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.finish()\" ng-if=\"vm.order.status===1\" \nng-disabled=\"vm.orderProgessState!==\'NONE\' || vm.solutionStatus.updating\"><span translate=\"PRODUCTION_ORDERS.FINISH\">\nFinish</span></md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.remove()\" \nng-disabled=\"vm.orderProgessState!==\'NONE\' || vm.solutionStatus.updating\"><span translate=\"APP.DELETE\">Delete</span>\n</md-button></div></md-content>");
$templateCache.put("app/main/production.orders/views/tabs/geometries.html","<md-content><md-card class=\"m-24 p-20\" \nng-if=\"!vm.reloadingProfiles && vm.order.status===0 && vm.order.productionProfiles.length>0\"><batch-updater \nmaterial-infos=\"vm.order.materialInfos\" coil-machines=\"vm.coilMachines\" bending-machines=\"vm.bendingMachines\" \npunching-machines=\"vm.punchingMachines\" on-save=\"vm.batchUpdateMachines\"></batch-updater></md-card><div \nlayout=\"column\" layout-align=\"start stretch\" ng-repeat=\"geometry in vm.order.geometries\" flex \nclass=\"m-24 md-whiteframe-2dp pv-10\" ms-scroll><div layout=\"row\" class=\"m-0 p-0\" layout-align=\"start top\" layout-fill>\n<div layout=\"column\" class=\"mr-24\" layout-align=\"start top\" layout-fill><div layout=\"row\" layout-wrap layout-fill flex>\n<div layout=\"row\" layout-wrap layout-fill flex=\"35\" style=\"min-width:200px\"><div layout=\"row\" layout-margin \nlayout-align=\"start start\"><div layout=\"column\" class=\"m-0 p-0\"><nuit-profile-preview \nprofile=\"vm.getCurrentImage(geometry).productionProfile.profile\" class=\"m-8\"><img \nhttp-src=\"{{vm.getCurrentImage(geometry).url}}\" alt=\"\" \nfallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\" class=\"w-150 b\" \nng-click=\"vm.openImage(vm.getCurrentImage(geometry).url)\" style=\"cursor:pointer\"></nuit-profile-preview><md-button \nflex ng-click=\"vm.openEditor(geometry)\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.profileEditable.enabled\" ng-disabled=\"vm.order.status!==0\">\n<span translate=\"APP.EDIT\">Edit</span></md-button><md-button class=\"m-0\" ng-if=\"vm.showProfileDetailsButton\" \nng-click=\"vm.imsNextChannel.channel.openProfileDetails(profile.id, {productionOrderId: vm.order.id})\"><span \ntranslate=\"PROFILE.OPEN_DETAILS\">Show Details</span></md-button></div></div><div layout=\"column\" class=\"mt-10\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\" class=\"pl-20 pb-5 h-30\"><div \nclass=\"w-15 h-15 b\" style=\"background-color:{{geometry.material.colors.front.hex}}\"></div><span class=\"text-bold ml-8\">\n{{geometry.material.name | nuitTranslate}}</span></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.PROFILE_BLANK\">Blank</span>: <span class=\"text-bold pl-8\">\n{{geometry.profile | nuitBlank}}</span> <span class=\"text-bold pl-8\">\n({{geometry.productionProfile | nuitBlank:\'production\'}})</span></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.TILTINGS_COUNT\">tiltings</span>: <span \nclass=\"text-bold pl-8\">{{geometry.tiltingsCount}}</span></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-20 mb-8\" ng-repeat=\"field in vm.config.ims.productionOrders.productionProfile.geometryMode.customFields\">\n<span>{{::field.name | nuitTranslate}}</span> <span class=\"text-bold pl-8\">{{::field.format | nuitFormatter:geometry}}\n</span></div><div class=\"pl-20\" layout=\"column\" layout-align=\"start start\" layout-fill \nng-if=\"vm.config.ims.productionOrders.feedback.enabled\"><div ng-if=\"vm.getFeedback(geometry)!==null\" flex \nng-init=\"unlockFeedback = false\"><div class=\"grey-100-bg p-10 pt-0\"><div layout=\"column\" layout-align=\"start start\" \nflex><div layout=\"row\" layout-align=\"start center\" layout-fill><h4 flex class=\"text-bold\" translate=\"WIKANT.RATING\" \nflex></h4><div flex></div><md-button layout=\"row\" class=\"md-icon-button\" ng-click=\"unlockFeedback=!unlockFeedback\">\n<md-icon md-font-icon=\"{{!unlockFeedback?\'icon-pencil\':\'icon-close\'}}\"></md-icon></md-button></div><div \nng-show=\"!unlockFeedback\" layout=\"row\" layout=\"start center\" flex><md-icon \nng-class=\"{\n														\'green-500-fg\':vm.getFeedback(geometry).manufacturable,\n														\'red-500-fg\':!vm.getFeedback(geometry).manufacturable\n														}\" \nmd-font-icon=\"{{vm.getFeedback(geometry).manufacturable?\'icon-check-circle\':\'icon-close-circle-outline\'}}\"></md-icon>\n<div class=\"padding-top-5\" \ntranslate=\"{{vm.getFeedback(geometry).manufacturable?\'WIKANT.MANUFACTURABLE\':\'WIKANT.NOT_MANUFACTURABLE\'}}\"></div>\n</div></div><div ng-show=\"!unlockFeedback\" \nng-if=\"vm.getFeedback(geometry)!==null && !vm.getFeedback(geometry).changed\" layout=\"row\" layout-align=\"start center\" \nflex><md-progress-linear flex class=\"md-accent\" md-mode=\"buffer\" \nng-class=\"{\n																\'green-500-bg\':vm.getFeedback(geometry).probability>=vm.config.ims.productionOrders.feedback.successProbability,\n																\'red-500-bg\':vm.getFeedback(geometry).probability<vm.config.ims.productionOrders.feedback.successProbability\n																}\" \nng-value=\"vm.getFeedback(geometry).probability\"></md-progress-linear><h4 class=\"ml-10\">\n{{vm.getFeedback(geometry).probability}}%</h4></div><div ng-show=\"unlockFeedback\" layout=\"column\"><md-button \nlayout=\"row\" layout-align=\"start center\" class=\"md-raised\" \nng-click=\"unlockFeedback=false;vm.setFeedback(geometry,true)\"><md-icon class=\"green-500-fg\" \nmd-font-icon=\"icon-check-circle\"></md-icon><label flex translate=\"WIKANT.MANUFACTURABLE\">Falsch</label></md-button>\n<md-button layout=\"row\" layout-align=\"start center\" class=\"md-raised\" \nng-click=\"unlockFeedback=false;vm.setFeedback(geometry,false)\"><md-icon class=\"red-500-fg\" \nmd-font-icon=\"icon-close-circle-outline\"></md-icon><label flex translate=\"WIKANT.NOT_MANUFACTURABLE\">Falsch</label>\n</md-button></div></div></div><div ng-if=\"vm.getFeedback(geometry)===null\" layout-fill layout=\"column\" flex><h4 \nclass=\"text-bold\" translate=\"WIKANT.RATING\"></h4><div translate=\"WIKANT.NO_RATING_AVAILABLE\"></div></div></div></div>\n</div><div layout=\"row\" layout-fill layout-wrap flex><div id=\"coilMachineConfig\" flex style=\"min-width:250px\" \nlayout=\"column\" layout-align=\"start top\" class=\"ml-10 pl-10 mt-10 bl\" \nng-if=\"!vm.coilMachineTeaser && vm.config.ims.productionOrders.productionProfile.coilMachineConfig.enabled\"><div \nclass=\"text-bold grey-100-bg pl-4\" style=\"padding-left: 2px\" translate=\"PRODUCTION_ORDERS.CUTTING_MACHINE\">\ncutting maschine</div><md-input-container ng-if=\"!vm.machinesLoading\"><label translate=\"MATERIALS.CUTTING_MACHINE\">\nMaschine</label><md-select required ng-model=\"geometry.cuttingMachineId\" \nng-change=\"vm.updateCuttingMachines(geometry,true)\" name=\"machine\" \nng-disabled=\"vm.order.status!==0 || geometry.manualCutAll\"><md-option ng-if=\"machine.enabled\" \nng-repeat=\"machine in vm.coilMachines\" ng-value=\"machine.id\">{{::machine.name}}</md-option></md-select>\n</md-input-container><div layout=\"row\" layout-align=\"center center\" ng-if=\"!geometry.manualCutAll\"><md-input-container \nng-if=\"geometry.coils.length > 0\" flex style=\"padding-right: 0px !important\"><label \ntranslate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL\">Material</label><md-select required \nng-model=\"geometry.cuttingMaterialId\" id=\"{{\'cutMaterialSelect_\'+$index}}\" \nng-change=\"vm.updateCuttingMachines(geometry,false)\" ng-disabled=\"vm.order.status!==0 || geometry.manualCutAll\">\n<md-select-header class=\"select-header p-10\"><input ng-model=\"searchText\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"{{\'APP.SEARCH\' | translate}}\" id=\"{{\'cutMaterialSearch_\'+$index}}\">\n<md-icon ng-show=\"searchText && searchText.length>0\" md-font-icon=\"icon-close\" ng-click=\"searchText=\'\';\"></md-icon>\n</md-select-header><md-option \nng-if=\"searchText===\'\' || searchText===undefined || vm.getName(material).toLowerCase().indexOf(searchText.toLowerCase())>=0\" \nng-repeat=\"material in geometry.coils track by material.id\" ng-value=\"material.id\">\n{{::material.name | nuitTranslate}}&nbsp;<span ng-if=\"material.strength\">({{::material.strength}})</span> <span \nclass=\"text-bold\" ng-if=\"vm.isDefaultMaterial(geometry,material)\">(<span translate=\"APP.DEFAULT\"></span>)</span>\n</md-option></md-select></md-input-container><md-button ng-if=\"geometry.coils.length > 0\" \nclass=\"md-icon-button m-0 p-0\" ng-click=\"vm.focusSearchField(\'cut\', $index)\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></md-button><md-button ng-if=\"geometry.coils.length > 0\" class=\"md-raised md-accent md-block\" \nstyle=\"max-height: 36px\" ng-disabled=\"geometry.cuttingMaterialId===null\" \nng-click=\"vm.setDefaultCoilMaterial(geometry)\"><label translate=\"APP.DEFAULT\"></label></md-button></div>\n<md-input-container ng-if=\"geometry.cuttingMaterialId && vm.getCoilsByCuttingMaterialId(geometry).length>1\" flex \nstyle=\"padding-right: 0px !important\"><label translate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL_COIL\">Coil</label>\n<md-select required ng-model=\"geometry.cuttingCoilId\" id=\"{{\'cutCoilSelect_\'+$index}}\" \nng-change=\"vm.updateCuttingMachines(geometry,false)\" ng-disabled=\"vm.order.status!==0 || geometry.manualCutAll\">\n<md-option ng-repeat=\"coil in vm.getCoilsByCuttingMaterialId(geometry) track by coil.id\" ng-value=\"coil.id.toString()\">\n<span ng-if=\"coil.name\">{{coil.name | nuitTranslate}}</span> <span ng-if=\"!coil.name\">{{coil.machineMaterialId}}</span>\n</md-option></md-select></md-input-container><div ng-if=\"geometry.cuttingMaterialId && vm.displaySingleCoil(geometry)\">\n<label style=\"font-size: 10px; opacity: 0.54\" translate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL_COIL\">Coil</label><div \nclass=\"mb-10\">{{vm.getCoilsByCuttingMaterialId(geometry)[0].name | nuitTranslate}}</div></div><md-input-container>\n<label translate=\"PRODUCTION_ORDERS.COIL_WIDTH\"></label><input type=\"number\" ng-model=\"geometry.cuttingMaterialWidth\" \nnuit-unit-input=\"length\" ng-model-options=\"{ debounce: 200 }\" \nng-disabled=\"vm.order.status!==0 || !vm.usesManualCoilMachine(geometry)\" ng-change=\"vm.updateCoilWidth(geometry)\">\n</md-input-container></div><nuit-teaser-machine layout=\"column\" flex layout-align=\"start top\" \nclass=\"pl-10 mt-10 bl ml-10\" style=\"min-width:250px\" data=\"vm.coilMachineTeaser\" ng-if=\"vm.coilMachineTeaser\">\n</nuit-teaser-machine><div id=\"bendingMachineConfig\" flex style=\"min-width:250px\" layout=\"column\" \nclass=\"ml-10 pl-10 bl mt-10\" \nng-if=\"!vm.bendMachineTeaser &&vm.config.ims.productionOrders.productionProfile.bendingMachineConfig.enabled\"><div \nclass=\"text-bold grey-100-bg pl-4\" style=\"padding-left: 2px\" translate=\"PRODUCTION_ORDERS.BENDING_MACHINE\">\nbending maschine</div><div layout=\"column\"><md-input-container><label translate=\"PRODUCTION_ORDERS.PROFILE_MACHINE\">\nMachine</label><md-select ng-model=\"geometry.bendingMachineId\" ng-disabled=\"vm.order.status!==0\" \nng-change=\"vm.updateBendingMachines(geometry,true);vm.getFeedback(geometry, true);\"><md-option ng-if=\"machine.enabled\" \nng-repeat=\"machine in vm.bendingMachines\" ng-value=\"machine.id\"><span>{{machine.name}}</span></md-option></md-select>\n</md-input-container><div layout=\"row\" \nng-if=\"vm.reuseBendingPrograms(geometry) && geometry.bendingMaterials && geometry.bendingMaterials.length>0 && !geometry.manualBendAll\">\n<md-input-container><label translate=\"PRODUCTION_ORDERS.PROFILE_MACHINE_MATERIAL\">Material</label><md-select \nng-model=\"geometry.bendingMaterialId\" ng-disabled=\"vm.order.status!==0 || geometry.manualBendAll\" \nng-change=\"vm.onBendingMachineChanged(geometry,true);vm.getFeedback(geometry, true);\"><md-option \nng-repeat=\"material in geometry.bendingMaterials\" ng-value=\"material.bendingMaterialId\"><span>\n{{material.name | nuitTranslate}}</span></md-option></md-select></md-input-container><md-button \nclass=\"md-raised md-accent md-block\" style=\"max-height: 36px\" ng-disabled=\"!vm.canSetDefaultBendings(geometry)\" \nng-click=\"vm.setDefaultBendings(geometry)\"><label translate=\"APP.DEFAULT\"></label></md-button></div></div><div \nlayout=\"row\" layout-align=\"start start\" layout-fill><div layout=\"column\" ng-if=\"vm.reuseBendingPrograms(geometry)\" \nflex><div ng-if=\"vm.getBendingProgramState(geometry)===1\" layout=\"column\"><div class=\"m-10\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon><span \ntranslate=\"PRODUCTION_ORDERS.BENDING_PROGRAM_MISSING\" flex md-truncate>Biegeprogramm fehlt</span></div><md-button \nng-click=\"vm.openExternalUrl(geometry.bendingProgramUrl, geometry)\" class=\"md-raised md-accent md-block\"><span \ntranslate=\"PRODUCTION_ORDERS.CREATE_BENDING_PROGRAM\">Create Bending Program</span></md-button></div><div \nng-if=\"vm.getBendingProgramState(geometry)===2\"><div class=\"m-10\" flex><md-icon md-font-icon=\"icon-check-circle\" \nclass=\"green-500-fg\"></md-icon><span translate=\"PRODUCTION_ORDERS.BENDING_PROGRAM_AVAILABLE\">Biegeprogramm verfügbar\n</span></div><div layout=\"column\"><md-button ng-click=\"vm.openExternalUrl(geometry.bendingProgramUrl, geometry)\" \nclass=\"md-raised md-accent md-block\"><span translate=\"PRODUCTION_ORDERS.OPEN_BENDING_PROGRAM\">Open Bending Program\n</span></md-button><md-button ng-click=\"vm.openExternalUrl(geometry.bendingProgramUrl, geometry, {recreate:true})\" \nclass=\"md-raised md-accent md-block\"><span translate=\"PRODUCTION_ORDERS.RECREATE_BENDING_PROGRAM\">\nRecreate Bending Program</span></md-button></div></div></div></div></div><nuit-teaser-machine layout=\"column\" flex \nclass=\"ml-10 pl-10 bl mt-10\" style=\"min-width:250px\" data=\"vm.bendMachineTeaser\" ng-if=\"vm.bendMachineTeaser\">\n</nuit-teaser-machine><div id=\"punchingMachineConfig\" flex style=\"min-width:250px\" layout=\"column\" \nclass=\"ml-10 pl-10 bl mt-10\" \nng-if=\"!vm.punchingMachineTeaser && vm.config.ims.productionOrders.productionProfile.punchingMachineConfig.enabled && vm.hasPunches(geometry)\">\n<div class=\"text-bold grey-100-bg pl-4\" style=\"padding-left: 2px\" translate=\"PRODUCTION_ORDERS.PUNCHING_MACHINE\">\npunching maschine</div><div layout=\"column\"><md-input-container><label translate=\"PRODUCTION_ORDERS.PUNCHING_MACHINE\">\nMachine</label><md-select ng-model=\"geometry.punchingMachineId\" ng-disabled=\"vm.order.status!==0\" \nng-change=\"vm.updatePunchingMachines(geometry,true)\"><md-option ng-if=\"machine.enabled\" \nng-repeat=\"machine in vm.punchingMachines\" ng-value=\"machine.id\"><span>{{machine.name}}</span></md-option></md-select>\n</md-input-container><div layout=\"row\" layout-align=\"start center\" \nng-if=\"geometry.punchingMaterials && geometry.punchingMaterials.length>0\"><md-input-container flex><label \ntranslate=\"PRODUCTION_ORDERS.PUNCHING_MACHINE_MATERIAL\">Material</label><md-select \nng-model=\"geometry.punchingMaterialId\" ng-disabled=\"vm.order.status!==0\" \nng-change=\"geometry.punchingMaterialThickness=null;vm.onPunchingMachineChanged(geometry,true)\"><md-option \nng-repeat=\"material in geometry.punchingMaterials\" ng-value=\"material.id\"><span>{{material.name}}</span></md-option>\n</md-select></md-input-container><md-input-container ng-if=\"vm.getPunchingThicknesses(geometry).length>0\"><label \ntranslate=\"MATERIAL.THICKNESS\">Material</label><md-select ng-model=\"geometry.punchingMaterialThickness\" \nng-disabled=\"vm.order.status!==0\" ng-change=\"vm.onPunchingMachineChanged(geometry,true)\"><md-option \nng-repeat=\"thickness in vm.getPunchingThicknesses(geometry) track by $index\" ng-value=\"thickness\"><span>\n{{thickness | nuitUnit:\'thickness\'}}</span></md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-align=\"start start\" ng-if=\"geometry.punchingMachineId\"><div layout=\"column\" layout-align=\"start start\" \nng-if=\"!vm.isEvoV2() || vm.hasPunchingProgramsEnabled(geometry)\"><span \nng-if=\"vm.getPunchingProgramState(geometry)===vm.PUNCHING_PROGRAM_STATE.PENDING\" layout=\"row\" \nlayout-align=\"start start\"><md-progress-circular class=\"md-accent mr-20\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><span flex translate=\"PRODUCTION_ORDERS.PUNCHING_PROGRAM_RECREATING\"></span> </span><span \nng-if=\"vm.getPunchingProgramState(geometry)===vm.PUNCHING_PROGRAM_STATE.AVAILABLE\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-check-circle\" class=\"green-500-fg\"></md-icon><span><span \ntranslate=\"PRODUCTION_ORDERS.PUNCHING_PROGRAM_AVAILABLE\">Stanzprogramm verfügbar </span><span class=\"ml-10\">\n(ID: {{geometry.punchingProgramId}})</span></span></span><div flex \nng-if=\"vm.getPunchingProgramState(geometry)===vm.PUNCHING_PROGRAM_STATE.ERROR\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon><div \nlayout=\"column\" flex><span translate=\"PRODUCTION_ORDERS.PUNCHING_PROGRAM_ERROR\"></span> <span flex \nng-if=\"geometry.punchingProgramError\">{{geometry.punchingProgramError}}</span></div></div><div layout=\"column\" \nng-if=\"vm.isEvoV2() && vm.order.status===0\"><md-button flex class=\"mt-10 ml-0 md-raised md-accent md-block\" \nng-if=\"!vm.getPunchingProgramState(geometry)\" ng-disabled=\"geometry._punchingBusy\" \nng-click=\"vm.createPunchingProgram(geometry)\"><span translate=\"PRODUCTION_ORDERS.CREATE_PUNCHING_PROGRAM\">\nCreate punching program</span></md-button><md-button flex class=\"mt-10 ml-0 md-raised md-accent md-block\" \nng-if=\"vm.getPunchingProgramState(geometry)!==vm.PUNCHING_PROGRAM_STATE.AVAILABLE\" \nng-disabled=\"geometry._punchingBusy\" ng-click=\"vm.preparePunchingProgram(geometry)\"><span \ntranslate=\"PRODUCTION_ORDERS.PREPARE_PUNCHING_PROGRAM\">Prepare punching program</span></md-button><md-button flex \nclass=\"mt-10 ml-0 md-raised md-block\" \nng-if=\"geometry.punchingProgramId && vm.getPunchingProgramState(geometry)!==vm.PUNCHING_PROGRAM_STATE.PENDING\" \nng-disabled=\"geometry._punchingBusy\" ng-click=\"vm.deletePunchingProgram(geometry)\"><span \ntranslate=\"PRODUCTION_ORDERS.DELETE_PUNCHING_PROGRAM\">Delete punching program</span></md-button></div></div><md-button \nflex class=\"mt-10 ml-0 md-raised md-accent md-block\" ng-if=\"vm.canDownloadPunchingDxf(geometry)\" \nng-click=\"vm.downloadPunchingDxf(geometry)\"><span translate=\"PRODUCTION_ORDERS.DOWNLOAD_PUNCHING_DXF\">\nDownload punching DXF</span></md-button></div></div></div><nuit-teaser-machine layout=\"column\" flex \nclass=\"ml-10 pl-10 bl mt-10\" style=\"min-width:250px\" data=\"vm.punchingMachineTeaser\" ng-if=\"vm.punchingMachineTeaser\">\n</nuit-teaser-machine></div></div></div></div><div class=\"m-10 p-0 mb-10 mt-10\" layout=\"column\"><div \nng-if=\"vm.config.ims.productionOrders.productionProfile.punches.enabled\"><nuit-stamps \nstamps=\"geometry.productionProfiles[0].profile.stamps\" ng-if=\"geometry.productionProfiles[0].profile.stamps.length>0\">\n</nuit-stamps><nuit-stamps stamps=\"geometry.productionProfiles[0].profile.punches\" \nng-if=\"geometry.productionProfiles[0].profile.punches.length>0\"></nuit-stamps></div><table class=\"mb-20\" \nid=\"geometryTable\" class=\"dataTable row-border hover\" \nng-if=\"geometry.productionProfiles[0].profile.specials && geometry.productionProfiles[0].profile.specials.length>0\">\n<thead><th class=\"text-left\" translate=\"SALES.SPECIAL_NAME\">Name</th><th class=\"text-left\" \ntranslate=\"SPECIAL_PROCESSING.REMARK\">test</th></thead><tr class=\"grey-100-bg\" \nng-repeat=\"special in geometry.productionProfiles[0].profile.specials\"><td><div class=\"m-10\">\n{{special.name | nuitTranslate}}</div></td><td><div class=\"m-10\">{{special.remark}}</div></td></tr></table><table \nid=\"geometryTable\" class=\"dataTable row-border hover\" layout-fill><thead><tr><th \ntranslate=\"PRODUCTION_ORDERS.PROFILE_ID\"></th><th ng-if=\"vm.order.status!==0\" \ntranslate=\"PRODUCTION_ORDERS.PRODUCTION_TIME\">productionTime</th><th translate=\"PROFILE.NAME\">Name</th><th>\n{{vm.config.evo.cart.fields[0].name[vm.selectedLanguage]}}</th><th translate=\"PRODUCTION_ORDERS.PROFILE_QUANTITY\"></th>\n<th ng-if=\"!vm.isBox(geometry.profile)\"><span translate=\"PRODUCTION_ORDERS.LENGTH\"></span>\n ({{vm.unit(\'length\').symbol}})</th><th \nng-if=\"vm.config.ims.productionOrders.productionProfile.coilMachineConfig.enabled\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"mr-10\" translate=\"PRODUCTION_ORDERS.MANUAL_CUTTING\"></span><md-checkbox \nclass=\"mt-16\" ng-model=\"geometry.manualCutAll\" ng-change=\"vm.updateAllManualCuts(geometry)\" \nng-disabled=\"vm.order.status!==0\"></md-checkbox></div></th><th style=\"text-align:center\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.bendingMachineConfig.enabled\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"mr-10\" translate=\"PRODUCTION_ORDERS.MANUAL_BENDING\"></span><md-checkbox \nclass=\"mt-16\" ng-model=\"geometry.manualBendAll\" ng-change=\"vm.updateAllManualBends(geometry)\" \nng-disabled=\"vm.order.status!==0\"></md-checkbox></div></th><th ng-if=\"vm.order.status!==0\" \ntranslate=\"PRODUDCTION_ORDERS.BENDED\">bended</th><th translate=\"ORDERS.REMARK\">Remark</th><th \nng-repeat=\"customField in vm.config.ims.productionOrders.productionProfile.partsMode.customData.checkBoxes\"><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"mr-10\">{{customField.name | nuitTranslate}}</span><md-checkbox \nclass=\"mt-16\" ng-model=\"geometry[customField.attribute+\'All\']\" \nng-change=\"vm.updateAllParts(geometry,\'customData.\'+customField.attribute)\"></md-checkbox></div></th><th \nng-if=\"vm.config.ims.productionOrders.productionProfile.label.enabled\" translate=\"PRODUCTION_ORDERS.LABEL\"></th><th \nng-if=\"vm.order.status===1 && vm.config.ims.productionOrders.productionProfile.geometryMode.producedCheckbox.enabled\">\n<div layout=\"row\" layout-align=\"center center\"><span class=\"mr-10\" translate=\"PRODUCTION_ORDERS.PRODUCED_CHECKBOX\">\n</span><md-checkbox class=\"mt-16\" ng-model=\"geometry.producedAll\" ng-change=\"vm.updateAllProducedStates(geometry)\">\n</md-checkbox></div></th></tr></thead><tbody><tr class=\"grey-100-bg\" \nng-repeat=\"profile in geometry.productionProfiles\"><td class=\"text-center\">{{profile.profile | shortName}}</td><td \nclass=\"text-center\" ng-if=\"vm.order.status!==0\">{{::profile.parts[0].productionTime}}s</td><td class=\"text-center\">\n{{profile.profile.name}}</td><td class=\"text-center\">{{vm.getShopOrderProjectName(profile.shopOrderId)}}</td><td \nclass=\"text-center\"><div class=\"pr-10 pl-10\"><input class=\"text-center\" style=\"min-width:30px;max-width:80px\" \ntype=\"number\" ng-model=\"profile.parts[0].quantity\" min=\"1\" ng-model-options=\"{ debounce: 200 }\" \nng-disabled=\"vm.order.status!==0\" ng-change=\"vm.updateProfile(profile)\"></div></td><td class=\"text-center\" \nng-if=\"!vm.isBox(geometry.profile)\"><div class=\"pr-10 pl-10\"><input class=\"text-center\" \nstyle=\"min-width:30px;max-width:80px\" type=\"number\" ng-model=\"profile.profile.length\" min=\"1\" nuit-unit-input=\"length\" \nng-model-options=\"{ debounce: 200 }\" ng-disabled=\"vm.order.status!==0\" ng-change=\"vm.updateProfile(profile)\"></div>\n</td><td class=\"text-center\" ng-if=\"vm.config.ims.productionOrders.productionProfile.coilMachineConfig.enabled\">\n<md-checkbox class=\"mt-16\" ng-model=\"profile.manualCutsBool\" ng-change=\"vm.updateManualCutsBool(profile,false)\" \nng-disabled=\"vm.order.status!==0\"></md-checkbox><span \nng-if=\"profile.parts[0].quantity>1 && profile.manualCuts>0 && profile.manualCutsBool\"><input style=\"min-width:30px\" \ntype=\"number\" ng-model=\"profile.manualCuts\" min=\"1\" max=\"99999\" ng-model-options=\"{debounce: 1000}\" \nng-change=\"vm.updateManualCuts(profile,false)\" ng-disabled=\"vm.order.status!==0\"> <span>/{{profile.parts[0].quantity}}\n</span></span></td><td class=\"text-center\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.bendingMachineConfig.enabled\"><md-checkbox class=\"mt-16\" \nng-model=\"profile.manualBends\" ng-change=\"vm.updateManualBends(profile)\" ng-disabled=\"vm.order.status!==0\">\n</md-checkbox></td><td class=\"text-center\" ng-if=\"vm.order.status!==0\">{{::profile.parts[0].bended}}</td><td \nclass=\"text-center\">{{profile.profile.remark}}</td><td class=\"text-center\" \nng-repeat=\"customField in vm.config.ims.productionOrders.productionProfile.partsMode.customData.checkBoxes\">\n<md-checkbox class=\"mt-16\" ng-change=\"vm.updatePart(profile.parts[0])\" \nng-model=\"profile.parts[0].customData[customField.attribute]\"></md-checkbox></td><td class=\"text-center\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.label.enabled\"><md-button \nng-click=\"vm.openLabel(profile.parts[0].label)\"><md-icon md-font-icon=\"icon-receipt\"></md-icon></md-button></td><td \nclass=\"text-center\" \nng-if=\"vm.order.status===1 && vm.config.ims.productionOrders.productionProfile.geometryMode.producedCheckbox.enabled\">\n<md-checkbox class=\"mt-16\" ng-change=\"vm.updateProducedState(profile.parts[0])\" ng-model=\"profile.parts[0].produced\">\n</md-checkbox></td></tr></tbody></table></div></div></md-content>");
$templateCache.put("app/main/production.orders/views/tabs/planning.html","<md-content layout-fill flex ms-scroll><form name=\"vm.planningForm\" novalidate layout=\"column\" flex \nng-model-options=\"{debounce:200}\"><div layout=\"row\" layout-margin layout-align=\"space-between start\"><div \nlayout=\"column\" flex-gt-md=\"50\" flex=\"100\"><div layout=\"row\" layout-margin layout-align=\"space-between start\" flex>\n<md-input-container flex=\"30\"><label translate=\"ORDERS.COMPLETION_DATE\"></label><md-datepicker layout-fill \nng-model=\"vm.completionDate\" md-hide-icons=\"calendar\" md-placeholder=\"Completion Date\" \nng-disabled=\"vm.order.status!==0\"></md-datepicker></md-input-container><md-input-container flex><label \ntranslate=\"APP.HOURS\">Stunden</label><input type=\"number\" name=\"hours\" min=\"0\" max=\"59\" ng-model=\"vm.hours\" \nng-disabled=\"vm.order.status!==0\"></md-input-container><md-input-container flex><label translate=\"APP.MINUTES\">Minuten\n</label><input type=\"number\" name=\"minutes\" min=\"0\" max=\"9999\" ng-model=\"vm.minutes\" ng-disabled=\"vm.order.status!==0\">\n</md-input-container></div><div layout=\"row\" layout-margin layout-align=\"space-between start\" flex><md-input-container \nflex=\"30\"><label translate=\"PLANNING.PRODUCTION_DATE\"></label><md-datepicker layout-fill ng-model=\"vm.productionDate\" \nmd-hide-icons=\"calendar\" md-placeholder=\"Production Date\" ng-disabled=\"vm.order.status!==0\" \nmd-date-filter=\"vm.filterDates\"></md-datepicker></md-input-container><md-input-container flex \nng-if=\"vm.planningBoards && vm.planningBoards.length > 0\"><label translate=\"PLANNING.PLANNING_BOARD\">Planning board\n</label><md-select ng-model=\"vm.order.boardId\" ng-disabled=\"vm.order.status!==0\"><md-option \nng-repeat=\"board in vm.planningBoards\" ng-value=\"board.id\"><span translate=\"{{ board.name | nuitTranslate }}\"></span>\n</md-option></md-select></md-input-container></div></div></div></form><div layout=\"row\" layout-margin><md-button \nng-show=\"vm.order.status===0\" class=\"md-raised md-accent\" ng-click=\"vm.updateProductionOrderPlanning()\" \nng-disabled=\"!vm.planningForm.$valid || !vm.planningForm.$dirty\" translate=\"PLANNING.UPDATE_PLANNING\">\nProduktionsplanung aktualisieren</md-button></div></md-content>");
$templateCache.put("app/main/production.orders/views/tabs/production.html","<div layout=\"row\" layout-align=\"space-between center\" layout-margin class=\"grey-100-bg\"><div layout=\"column\"><div \ntranslate=\"JOB.LAST_REFRESH\"></div><div flex class=\"text-bold\">{{vm.lastRefresh}}</div></div><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.reloadJobs()\"><md-icon md-font-icon=\"icon-sync\"></md-icon></md-button>\n</div><div class=\"m-10\" ng-repeat=\"list in vm.jobsByMachine\"><h2>{{list.machine.name}}</h2><table id=\"geometryTable\" \nclass=\"dataTable row-border hover\" layout-fill><thead><tr><th translate=\"JOB.STATUS\"></th><th translate=\"APP.NAME\">\n</th><th><span translate=\"PROFILE.BLANK\"></span> <span>({{vm.nuitUnits(\'length\').symbol}})</span></th><th \ntranslate=\"JOB.QUANTITY\"></th><th translate=\"JOB.TIME\"></th><th translate=\"JOB.SENT\"></th><th translate=\"JOB.VIEW\">\n</th><th translate=\"JOB.RESEND\"></th></tr></thead><tbody><tr class=\"grey-100-bg\" ng-repeat=\"job in list.jobs\"><td \nclass=\"text-center\"><md-icon ng-if=\"job.status===1 && !list.machine.manualWork\" md-font-icon=\"icon-check-circle\" \nclass=\"green-500-fg\"></md-icon><md-icon ng-if=\"job.status===3 && !list.machine.manualWork\" \nmd-font-icon=\"icon-alert-circle\" class=\"red-500-fg\" ng-click=\"vm.showError(job.error)\"></md-icon></td><td \nclass=\"text-center\">{{job.jobName}}</td><td class=\"text-center\">\n{{(job.job.length | nuitUnit:\'length\':true) + \" x \" + (job.job.height | nuitUnit:\'length\':true) }}</td><td \nclass=\"text-center\">{{job.job.quantity}}</td><td class=\"text-center\">\n{{job.sentAt | nuitDatetime: vm.config.localization.dateTimeFormat}}</td><td class=\"text-center\">\n{{job.sentCount + job.errorCount}}<span ng-if=\"job.errorCount>0\"> (<span class=\"text-bold red-500-fg\">\n{{job.errorCount}}</span>)</span></td><td class=\"text-center\"><md-button ng-click=\"vm.showJob(job)\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon></md-button></td><td class=\"text-center\" layout=\"row\" layout-align=\"center center\" \nstyle=\"min-height:48px !important\"><span flex></span><md-progress-circular flex \nng-if=\"vm.resentJob!==null && vm.resentJob.id===job.id\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><md-button ng-if=\"vm.resentJob===null || vm.resentJob.id!==job.id\" \nng-disabled=\"vm.resentJob!==null && vm.resentJob.id!==job.id || list.machine.manualWork\" ng-click=\"vm.resend(job)\">\n<md-icon md-font-icon=\"icon-play\"></md-icon></md-button><span flex></span></td></tr></tbody></table></div>");
$templateCache.put("app/main/production.orders/views/tabs/products.html","<md-content layout-fill flex ms-scroll><nuit-product-section ng-if=\"vm.products.length>0\" show-prices=\"false\" \nproduct=\"product\" min-positions=\"1\" max-positions=\"1\" selectable=\"false\" read-only=\"true\" \non-image-click=\"vm.openImage(product.image)\" ng-class=\"{\'mb-50\':$last}\" \nng-repeat=\"product in vm.products track by $index\"></nuit-product-section></md-content>");
$templateCache.put("app/main/production.orders/views/tabs/profiles.html","<md-content id=\"profileScrollView\" flex><div class=\"grey-100-bg p-10\" ng-if=\"vm.reloadingProfiles\" layout=\"row\" \nlayout-align=\"center center\"><span flex></span><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><span flex></span></div><md-card class=\"m-24 p-20\" \nng-if=\"!vm.reloadingProfiles && vm.order.status===0 && vm.order.productionProfiles.length>0\"><batch-updater \nmaterial-infos=\"vm.order.materialInfos\" coil-machines=\"vm.coilMachines\" bending-machines=\"vm.bendingMachines\" \npunching-machines=\"vm.punchingMachines\" on-save=\"vm.batchUpdateMachines\"></batch-updater></md-card><div \nng-if=\"!vm.reloadingProfiles && vm.hasPartId(profile.parts)\" id=\"{{profile.profile.id}}\" layout=\"column\" \nlayout-align=\"start stretch\" \nng-repeat=\"profile in vm.order.productionProfiles | limitTo:vm.profileCount:vm.startOffset\" flex \nclass=\"m-24 md-whiteframe-2dp pv-10\" ms-scroll><div layout=\"row\" class=\"m-0 p-0\" layout-align=\"start top\" layout-fill>\n<div layout=\"column\" class=\"mr-24\" layout-align=\"start top\" layout-fill><div layout=\"row\" layout-wrap layout-fill flex>\n<div layout=\"row\" layout-wrap layout-fill flex=\"25\" style=\"min-width:200px\"><div layout=\"row\" layout-margin \nlayout-align=\"start start\"><div layout=\"column\" class=\"m-0 p-0\"><nuit-profile-preview profile=\"profile.profile\" \nclass=\"m-8\"><img http-src=\"{{profile.profile | profileImage}}\" alt=\"\" \nfallback-src=\"assets/images/ecommerce/product-image-placeholder.jpg\" class=\"w-150 b\" \nng-click=\"vm.openImage(profile.profile | profileImage)\"></nuit-profile-preview><md-button flex \nng-click=\"vm.openEditor(profile.profile, profile)\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.profileEditable.enabled\"><span translate=\"APP.EDIT\">Edit</span>\n</md-button><md-button class=\"m-0\" ng-if=\"vm.showProfileDetailsButton\" \nng-click=\"vm.imsNextChannel.channel.openProfileDetails(profile.id, {productionOrderId: vm.order.id})\"><span \ntranslate=\"PROFILE.OPEN_DETAILS\">Show Details</span></md-button></div></div><div layout=\"column\" class=\"mt-10\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\" class=\"pl-20 pb-5 h-30\"><span \ntranslate=\"PRODUCTION_ORDERS.PROFILE_ID\">ID</span>: <span class=\"text-bold ml-8\">{{::profile.profile | shortName}}\n</span></div><div layout=\"row\" layout-align=\"start center\" class=\"pl-20 pb-5 h-30\"><div class=\"w-15 h-15 b\" \nstyle=\"background-color:{{profile.profile.material.colors.front.hex}}\"></div><span class=\"text-bold ml-8\">\n{{profile.profile.material.name | nuitTranslate}}</span></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.PROFILE_BLANK\">Blank</span>: <span class=\"text-bold pl-8\">\n{{profile.profile | nuitBlank}}</span> <span class=\"text-bold pl-8\">({{profile | nuitBlank:\'production\'}})</span></div>\n<div layout=\"row\" layout-align=\"start center\" class=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.LENGTH\">Length\n</span>: <span class=\"text-bold pl-8\">{{profile.profile.length | nuitUnit:\'length\'}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.WEIGHT\">Weight</span>: <span \nclass=\"text-bold pl-8\">{{profile.profile.weight | nuitUnit:\'weight\'}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pl-20 pb-5 h-30\"><span translate=\"PRODUCTION_ORDERS.TILTINGS_COUNT\">tiltings</span>\n: <span class=\"text-bold pl-8\">{{profile.profile.tiltingsCount}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"pl-20 pb-5 h-30\" layout-fill><span translate=\"PRODUCTION_ORDERS.PROFILE_PRODUCED\">\nProduziert</span>: <span class=\"text-bold pl-8\">{{vm.getProducedParts(profile)}}/{{::vm.getQuantityParts(profile)}}\n</span></div><div ng-if=\"vm.config.ims.productionOrders.productionProfile.partsMode.projectName\" layout=\"row\" \nlayout-align=\"start center\" class=\"pl-20 pb-5 h-30\" layout-fill><span translate=\"INVOICE.PROJECT\"></span>: <span \nclass=\"text-bold pl-8\">{{vm.getShopOrderProjectName(profile.shopOrderId)}}</span></div><div \nng-if=\"vm.config.ims.productionOrders.productionProfile.partsMode.profileName\" layout=\"row\" \nlayout-align=\"start center\" class=\"pl-20 pb-5 h-30\" layout-fill><span translate=\"PROFILE.NAME\">Name</span>: <span \nclass=\"text-bold pl-8\">{{profile.profile.name}}</span></div><div \nng-if=\"vm.config.ims.productionOrders.productionProfile.partsMode.profileRemark\" layout=\"row\" \nlayout-align=\"start center\" class=\"pl-20 pb-5 h-30\" layout-fill><span translate=\"ORDERS.REMARK\"></span>: <span \nclass=\"text-bold pl-8\">{{profile.profile.remark}}</span></div><div flex layout=\"row\" layout-align=\"start center\" \nclass=\"pl-20 mb-8\" ng-repeat=\"field in vm.config.ims.productionOrders.productionProfile.partsMode.customFields\"><span>\n{{::field.name | nuitTranslate}}</span> <span class=\"text-bold pl-8\">{{::field.format | nuitFormatter:profile}}</span>\n</div><div class=\"pl-20\" layout=\"column\" layout-align=\"start start\" layout-fill \nng-if=\"vm.config.ims.productionOrders.feedback.enabled\"><div ng-if=\"vm.getFeedback(profile)!==null\" flex \nng-init=\"unlockFeedback = false\"><div class=\"grey-100-bg p-10 pt-0\"><div layout=\"column\" layout-align=\"start start\" \nflex><div layout=\"row\" layout-align=\"start center\" layout-fill><h4 flex class=\"text-bold\" translate=\"WIKANT.RATING\" \nflex></h4><div flex></div><md-button layout=\"row\" class=\"md-icon-button\" ng-click=\"unlockFeedback=!unlockFeedback\">\n<md-icon md-font-icon=\"{{!unlockFeedback?\'icon-pencil\':\'icon-close\'}}\"></md-icon></md-button></div><div \nng-show=\"!unlockFeedback\" layout=\"row\" layout=\"start center\" flex><md-icon \nng-class=\"{\n														\'green-500-fg\':vm.getFeedback(profile).manufacturable,\n														\'red-500-fg\':!vm.getFeedback(profile).manufacturable\n														}\" \nmd-font-icon=\"{{vm.getFeedback(profile).manufacturable?\'icon-check-circle\':\'icon-close-circle-outline\'}}\"></md-icon>\n<div class=\"padding-top-5\" \ntranslate=\"{{vm.getFeedback(profile).manufacturable?\'WIKANT.MANUFACTURABLE\':\'WIKANT.NOT_MANUFACTURABLE\'}}\"></div></div>\n</div><div ng-show=\"!unlockFeedback\" ng-if=\"vm.getFeedback(profile)!==null && !vm.getFeedback(profile).changed\" \nlayout=\"row\" layout-align=\"start center\" flex><md-progress-linear flex class=\"md-accent\" md-mode=\"buffer\" \nng-class=\"{\n																\'green-500-bg\':vm.getFeedback(profile).probability>=vm.config.ims.productionOrders.feedback.successProbability,\n																\'red-500-bg\':vm.getFeedback(profile).probability<vm.config.ims.productionOrders.feedback.successProbability\n																}\" \nng-value=\"vm.getFeedback(profile).probability\"></md-progress-linear><h4 class=\"ml-10\">\n{{vm.getFeedback(profile).probability}}%</h4></div><div ng-show=\"unlockFeedback\" layout=\"column\"><md-button \nlayout=\"row\" layout-align=\"start center\" class=\"md-raised\" \nng-click=\"unlockFeedback=false;vm.setFeedback(profile,true)\"><md-icon class=\"green-500-fg\" \nmd-font-icon=\"icon-check-circle\"></md-icon><label flex translate=\"WIKANT.MANUFACTURABLE\">Falsch</label></md-button>\n<md-button layout=\"row\" layout-align=\"start center\" class=\"md-raised\" \nng-click=\"unlockFeedback=false;vm.setFeedback(profile,false)\"><md-icon class=\"red-500-fg\" \nmd-font-icon=\"icon-close-circle-outline\"></md-icon><label flex translate=\"WIKANT.NOT_MANUFACTURABLE\">Falsch</label>\n</md-button></div></div></div><div ng-if=\"vm.getFeedback(profile)===null\" layout-fill layout=\"column\" flex><h4 \nclass=\"text-bold\" translate=\"WIKANT.RATING\"></h4><div translate=\"WIKANT.NO_RATING_AVAILABLE\"></div></div></div></div>\n</div><div layout=\"row\" layout-fill layout-wrap flex><div layout=\"column\" flex layout-align=\"start top\" \nclass=\"pl-10 mt-10 bl ml-10\" style=\"min-width:250px\" \nng-if=\"!vm.coilMachineTeaser && vm.config.ims.productionOrders.productionProfile.coilMachineConfig.enabled\"><div \nclass=\"text-bold grey-100-bg pl-4\" style=\"padding-left: 2px\" translate=\"PRODUCTION_ORDERS.CUTTING_MACHINE\">\ncutting maschine</div><md-input-container ng-if=\"!vm.machinesLoading\"><label translate=\"MATERIALS.CUTTING_MACHINE\">\nMaschine</label><md-select required ng-model=\"profile.cuttingMachineId\" \nng-change=\"vm.onCoilMachineChanged(profile,true)\" name=\"machine\" ng-disabled=\"vm.order.status!==0\"><md-option \nng-if=\"machine.enabled\" ng-repeat=\"machine in vm.coilMachines\" ng-value=\"machine.id\">{{::machine.name}}</md-option>\n</md-select></md-input-container><div layout=\"row\" layout-align=\"start center\" \nng-if=\"profile.coils.length > 0 && vm.getQuantityParts(profile)!==profile.manualCuts\"><md-input-container flex \nstyle=\"padding-right: 0px !important\"><label translate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL\">Material</label>\n<md-select required ng-model=\"profile.cuttingMaterialId\" ng-change=\"vm.updateCuttingMachine(profile)\" \nng-disabled=\"vm.order.status!==0 || vm.getQuantityParts(profile)===profile.manualCuts\" \nid=\"{{\'cutMaterialSelect_\'+$index}}\"><md-select-header class=\"select-header p-10\"><input ng-model=\"searchText\" \ntype=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"{{\'APP.SEARCH\' | translate}}\" \nid=\"{{\'cutMaterialSearch_\'+$index}}\"><md-icon ng-show=\"searchText && searchText.length>0\" md-font-icon=\"icon-close\" \nng-click=\"searchText=\'\';\"></md-icon></md-select-header><md-option \nng-if=\"searchText===\'\' || searchText===undefined || vm.getName(material).toLowerCase().indexOf(searchText.toLowerCase())>=0\" \nng-repeat=\"material in profile.coils track by material.id\" ng-value=\"material.id\">\n{{::material.name | nuitTranslate}}&nbsp;<span ng-if=\"material.strength\">({{::material.strength}})</span> <span \nclass=\"text-bold\" ng-if=\"vm.isDefaultMaterial(profile,material)\">(<span translate=\"APP.DEFAULT\"></span>)</span>\n</md-option></md-select></md-input-container><md-button ng-if=\"profile.coils.length > 0\" \nclass=\"md-icon-button m-0 p-0\" ng-click=\"vm.focusSearchField(\'cut\', $index)\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></md-button><md-button class=\"md-raised md-accent md-block\" style=\"max-height: 36px\" \nng-disabled=\"profile.cuttingMaterialId === null\" ng-click=\"vm.setDefaultMaterial(profile)\"><label \ntranslate=\"APP.DEFAULT\"></label></md-button></div><md-input-container \nng-if=\"profile.cuttingMaterialId && vm.getCoilsByCuttingMaterialId(profile).length>1\" flex \nstyle=\"padding-right: 0px !important\"><label translate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL_COIL\">Coil</label>\n<md-select required ng-model=\"profile.cuttingCoilId\" id=\"{{\'cutCoilSelect_\'+$index}}\" \nng-change=\"vm.updateCuttingMachine(profile)\" \nng-disabled=\"vm.order.status!==0 || vm.getQuantityParts(profile)===profile.manualCuts\"><md-option \nng-repeat=\"coil in vm.getCoilsByCuttingMaterialId(profile) track by coil.id\" ng-value=\"coil.id.toString()\"><span \nng-if=\"coil.name\">{{coil.name | nuitTranslate}}</span> <span ng-if=\"!coil.name\">{{coil.machineMaterialId}}</span>\n</md-option></md-select></md-input-container><div ng-if=\"profile.cuttingMaterialId && vm.displaySingleCoil(profile)\">\n<label style=\"font-size: 10px; opacity: 0.54\" translate=\"MATERIALS.CUTTING_PRODUCTION_MATERIAL_COIL\">Coil</label><div \nclass=\"mb-10\">{{vm.getCoilsByCuttingMaterialId(profile)[0].name | nuitTranslate}}</div></div><md-input-container><label\n translate=\"PRODUCTION_ORDERS.COIL_WIDTH\"></label><input type=\"number\" ng-model=\"profile.cuttingMaterialWidth\" \nnuit-unit-input=\"length\" ng-model-options=\"{ debounce: 200 }\" \nng-disabled=\"vm.order.status!==0 || !vm.usesManualCoilMachine(profile)\" ng-change=\"vm.updateCoilWidth(profile)\">\n</md-input-container><div layout=\"row\"><md-input-container flex><label translate=\"PRODUCTION_ORDERS.MANUAL_CUTS\">\nmanuell spalten:</label><input type=\"number\" ng-model=\"profile.manualCuts\" min=\"0\" \nmax=\"{{vm.getQuantityParts(profile)}}\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.updateCuttingMachine(profile)\" ng-disabled=\"vm.order.status!==0\"></md-input-container><span \nclass=\"mt-30\">/{{vm.getQuantityParts(profile)}}</span></div></div><nuit-teaser-machine layout=\"column\" flex \nlayout-align=\"start top\" class=\"pl-10 mt-10 bl ml-10\" style=\"min-width:250px\" data=\"vm.coilMachineTeaser\" \nng-if=\"vm.coilMachineTeaser\"></nuit-teaser-machine><div layout=\"column\" flex class=\"ml-10 pl-10 bl mt-10\" \nstyle=\"min-width:250px\" \nng-if=\"!vm.bendMachineTeaser && (\n						 			vm.config.ims.productionOrders.productionProfile.bendingMachineConfig.enabled ||\n											vm.getValue(profile.bendingMachineData,\'afterBendingPosition.enabled\',false) ||\n											vm.getValue(profile.bendingMachineData,\'bendingProgram.offset\',false) ||\n											vm.reuseBendingPrograms(profile))\">\n<div class=\"text-bold grey-100-bg pl-4\" style=\"padding-left: 2px\" translate=\"PRODUCTION_ORDERS.BENDING_MACHINE\">\nbending maschine</div><div layout=\"column\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.bendingMachineConfig.enabled\"><md-input-container><label \ntranslate=\"PRODUCTION_ORDERS.PROFILE_MACHINE\">Machine</label><md-select ng-model=\"profile.bendingMachineId\" \nng-disabled=\"vm.order.status!==0\" ng-change=\"vm.updateBendingMachine(profile,true);vm.getFeedback(profile,true);\">\n<md-option ng-if=\"machine.enabled\" ng-repeat=\"machine in vm.bendingMachines\" ng-value=\"machine.id\"><span>\n{{machine.name}}</span></md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.reuseBendingPrograms(profile) && profile.bendingMaterials && profile.bendingMaterials.length>0 && !profile.manualBends\">\n<md-input-container><label translate=\"PRODUCTION_ORDERS.PROFILE_MACHINE_MATERIAL\">Material</label><md-select \nng-model=\"profile.bendingMaterialId\" ng-disabled=\"profile.manualBends || vm.order.status!==0\" \nng-change=\"vm.onBendingMachineChanged(profile,true);vm.getFeedback(profile,true);\"><md-option \nng-repeat=\"material in profile.bendingMaterials\" ng-value=\"material.bendingMaterialId\"><span>\n{{material.name | nuitTranslate}}</span></md-option></md-select></md-input-container><md-button \nclass=\"md-raised md-accent md-block\" style=\"max-height: 36px\" ng-disabled=\"!vm.canSetDefaultBendings(profile)\" \nng-click=\"vm.setDefaultBendings(profile)\"><label translate=\"APP.DEFAULT\"></label></md-button></div><div \nclass=\"pl-5 pb-10 mb-10 bb\"><md-checkbox ng-model=\"profile.manualBends\" ng-change=\"vm.updateBendingMachine(profile)\" \nng-disabled=\"vm.order.status!==0\"><span translate=\"PRODUCTION_ORDERS.MANUAL_BENDING\"></span></md-checkbox></div></div>\n<div class=\"mt-20 mb-10\" ng-if=\"!profile.manualBends && vm.reuseBendingPrograms(profile)\"><div \nng-if=\"vm.getBendingProgramState(profile)===1\"><div layout=\"row\" layout-align=\"start center\" class=\"mb-10\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon><div \ntranslate=\"PRODUCTION_ORDERS.BENDING_PROGRAM_MISSING\" flex>Biegeprogramm fehlt</div></div><md-button \nng-click=\"vm.openExternalUrl(profile.bendingProgramUrl, profile)\" class=\"m-0 md-raised md-accent md-block\"><span \ntranslate=\"PRODUCTION_ORDERS.CREATE_BENDING_PROGRAM\">Create Bending Program</span></md-button></div><div \nng-if=\"vm.getBendingProgramState(profile)===2\"><div layout=\"row\" layout-align=\"start center\" class=\"mb-10\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"green-500-fg\"></md-icon><div \ntranslate=\"PRODUCTION_ORDERS.BENDING_PROGRAM_AVAILABLE\">Biegeprogramm verfügbar</div><div class=\"ml-10\">\n(ID: {{profile.bendingProgramId}})</div><div flex></div></div><div layout=\"column\"><md-button \nng-click=\"vm.openExternalUrl(profile.bendingProgramUrl, profile)\" class=\"m-0 mb-5 md-raised md-accent md-block\"><span \ntranslate=\"PRODUCTION_ORDERS.OPEN_BENDING_PROGRAM\">Open Bending Program</span></md-button><md-button \nng-click=\"vm.openExternalUrl(profile.bendingProgramUrl, profile, {recreate:true})\" \nclass=\"m-0 md-raised md-accent md-block\"><span translate=\"PRODUCTION_ORDERS.RECREATE_BENDING_PROGRAM\">\nRecreate Bending Program</span></md-button></div></div></div><md-input-container \nng-if=\"!profile.manualBends && vm.getValue(profile.bendingMachineData,\'bendingProgram.offset\',false)\"><label><span \ntranslate=\"PRODUCTION_ORDERS.OFFSET_CORRECTION\">Offset Correction</span> ({{vm.config.units.length.symbol}})</label>\n<input ng-blur=\"vm.updateOffset(profile)\" type=\"number\" ng-model=\"profile.customData.offset\" nuit-unit-input=\"length\" \nng-click=\"$event.stopPropagation()\"></md-input-container><md-input-container \nng-if=\"!profile.manualBends && vm.getValue(profile.bendingMachineData,\'afterBendingPosition.enabled\',false)\"><label \ntranslate=\"PRODUCTION_ORDERS.MANUAL_BENDING_MACHINE\">Manual machine</label><md-select \nng-model=\"profile.customData.manualWorkMachine.id\" ng-change=\"vm.updateManualWorkMachine(profile)\"><md-option \nng-repeat=\"machine in profile.manualWorkMachines\" ng-value=\"machine.id\"><span class=\"text-uppercase\">{{machine.name}}\n</span></md-option></md-select></md-input-container></div><nuit-teaser-machine layout=\"column\" flex \nclass=\"ml-10 pl-10 bl mt-10\" style=\"min-width:250px\" data=\"vm.bendMachineTeaser\" ng-if=\"vm.bendMachineTeaser\">\n</nuit-teaser-machine><div layout=\"column\" flex class=\"ml-10 pl-10 bl mt-10\" style=\"min-width:250px\" \nng-if=\"!vm.punchingMachineTeaser && vm.config.ims.productionOrders.productionProfile.punchingMachineConfig.enabled && vm.hasPunches(profile.profile)\">\n<div class=\"text-bold grey-100-bg pl-4\" style=\"padding-left: 2px\" translate=\"PRODUCTION_ORDERS.PUNCHING_MACHINE\">\npunching maschine</div><div layout=\"column\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.punchingMachineConfig.enabled && vm.hasPunches(profile.profile)\">\n<md-input-container><label translate=\"PRODUCTION_ORDERS.PUNCHING_MACHINE\">Machine</label><md-select \nng-model=\"profile.punchingMachineId\" ng-disabled=\"vm.order.status!==0\" \nng-change=\"vm.updatePunchingMachine(profile,true)\"><md-option ng-if=\"machine.enabled\" \nng-repeat=\"machine in vm.punchingMachines\" ng-value=\"machine.id\"><span>{{machine.name}}</span></md-option></md-select>\n</md-input-container><div layout=\"row\" layout-align=\"start center\" \nng-if=\"profile.punchingMaterials && profile.punchingMaterials.length>0\"><md-input-container flex><label \ntranslate=\"PRODUCTION_ORDERS.PUNCHING_MACHINE_MATERIAL\">Material</label><md-select \nng-model=\"profile.punchingMaterialId\" ng-disabled=\"vm.order.status!==0\" \nng-change=\"vm.onPunchingMachineChanged(profile,true,[\'punchingMaterialThickness\'])\"><md-option \nng-repeat=\"material in profile.punchingMaterials\" ng-value=\"material.id\"><span>{{material.name}}</span></md-option>\n</md-select></md-input-container><md-input-container ng-if=\"vm.getPunchingThicknesses(profile).length>0\"><label \ntranslate=\"MATERIAL.THICKNESS\">Material</label><md-select ng-model=\"profile.punchingMaterialThickness\" \nng-disabled=\"vm.order.status!==0\" ng-change=\"vm.onPunchingMachineChanged(profile,true)\"><md-option \nng-repeat=\"thickness in vm.getPunchingThicknesses(profile) track by $index\" ng-value=\"thickness\"><span>\n{{thickness | nuitUnit:\'thickness\'}}</span></md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-align=\"start start\"><span ng-if=\"profile.punchingProgramStatus===0\" layout=\"row\" layout-align=\"start start\">\n<md-progress-circular class=\"md-accent mr-20\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular><span \nflex translate=\"PRODUCTION_ORDERS.PUNCHING_PROGRAM_RECREATING\"></span> </span><span \nng-if=\"profile.punchingProgramStatus===1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"green-500-fg\"></md-icon><span><span \ntranslate=\"PRODUCTION_ORDERS.PUNCHING_PROGRAM_AVAILABLE\">Stanzprogramm verfügbar </span><span class=\"ml-10\">\n(ID: {{profile.punchingProgramId}})</span></span></span><div flex ng-if=\"profile.punchingProgramStatus===2\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-500-fg\"></md-icon><div \nlayout=\"column\" flex><span translate=\"PRODUCTION_ORDERS.PUNCHING_PROGRAM_ERROR\">flex></span> <span flex \nng-if=\"profile.punchingProgramError\">{{profile.punchingProgramError}}</span></div></div><md-button flex \nclass=\"mt-10 ml-0 md-raised md-accent md-block\" ng-disabled=\"profile.punchingProgramStatus===0 || vm.order.status!==0\" \nng-click=\"profile.punchingRecreateProgram=true; vm.onPunchingMachineChanged(profile,true)\"><span \ntranslate=\"APP.RECREATE\">Edit</span></md-button></div></div></div><nuit-teaser-machine layout=\"column\" flex \nclass=\"ml-10 pl-10 bl mt-10\" style=\"min-width:250px\" data=\"vm.punchingMachineTeaser\" ng-if=\"vm.punchingMachineTeaser\">\n</nuit-teaser-machine></div></div></div><div layout=\"column\"><a ng-href=\"{{::document.link}}\" target=\"_blank\" \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"document in ::profile.documents\" ng-class=\"{ \'pb-16\': !$last }\">\n<div class=\"pr-8\"><md-icon md-font-icon=\"icon-file-pdf\" ng-if=\"document.type === \'pdf\'\"></md-icon><md-icon \nmd-font-icon=\"icon-file-xml\" ng-if=\"document.type !== \'pdf\'\"></md-icon>1</div><span \ntranslate=\"{{::document.translation}}\">Document name</span></a></div></div><div class=\"m-10 mt-20\"><div \nng-if=\"vm.config.ims.productionOrders.productionProfile.punches.enabled\"><nuit-stamps stamps=\"profile.profile.stamps\" \nng-if=\"profile.profile.stamps.length>0\"></nuit-stamps><nuit-stamps stamps=\"profile.profile.punches\" \nng-if=\"profile.profile.punches.length>0\"></nuit-stamps></div><div ng-click=\"vm.collapseParts(profile.id)\"><md-icon \nclass=\"icon s24\" ng-if=\"!vm.hasCollapsedId(profile.id)\" md-font-icon=\"icon-minus-box\"></md-icon><md-icon \nclass=\"icon s24\" ng-if=\"vm.hasCollapsedId(profile.id)\" md-font-icon=\"icon-plus-box\"></md-icon></div><table \nid=\"geometryTable\" class=\"dataTable row-border hover\" layout-fill layout-margin ng-if=\"!vm.hasCollapsedId(profile.id)\">\n<thead><tr><th translate=\"PRODUCTION_ORDERS.PART_ID\"></th><th translate=\"PRODUCTION_ORDERS.PRODUCTION_TIME\"></th><th \ntranslate=\"PRODUCTION_ORDERS.SLIT_LENGTH\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.partsMode.list.slitLength\"></th><th \nng-if=\"profile.parts[0].cut!==null && vm.order.status===1\"><div layout=\"row\" layout-align=\"center center\"><span \nclass=\"mr-10\" translate=\"PRODUCTION_ORDERS.PROFILE_CUTTING_STATE\"></span><md-checkbox class=\"mt-16\" \nng-model=\"profile.cutAll\" ng-change=\"vm.updateAllByType(profile,\'cut\')\" ng-disabled=\"vm.order.status>1\"></md-checkbox>\n</div></th><th ng-if=\"profile.parts[0].stamped!==null && vm.order.status===1\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"mr-10\" translate=\"PRODUCTION_ORDERS.PROFILE_PUNCHING_STATE\"></span>\n<md-checkbox class=\"mt-16\" ng-model=\"profile.stampedAll\" ng-change=\"vm.updateAllByType(profile,\'stamped\')\" \nng-disabled=\"vm.order.status>1\"></md-checkbox></div></th><th \nng-if=\"profile.parts[0].bended!==null && vm.order.status===1\"><div layout=\"row\" layout-align=\"center center\"><span \nclass=\"mr-10\" translate=\"PRODUCTION_ORDERS.PROFILE_BENDING_STATE\"></span><md-checkbox class=\"mt-16\" \nng-model=\"profile.bendedAll\" ng-change=\"vm.updateAllByType(profile,\'bended\')\" ng-disabled=\"vm.order.status>1\">\n</md-checkbox></div></th><th \nng-repeat=\"customField in vm.config.ims.productionOrders.productionProfile.partsMode.customData.checkBoxes\"><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"mr-10\">{{customField.name | nuitTranslate}}</span><md-checkbox \nclass=\"mt-16\" ng-model=\"profile[customField.attribute+\'All\']\" \nng-change=\"vm.updateAllParts(profile,\'customData.\'+customField.attribute)\" ng-disabled=\"vm.order.status>0\">\n</md-checkbox></div></th><th translate=\"PRODUCTION_ORDERS.LABEL\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.label.enabled && vm.config.ims.productionOrders.productionProfile.label.manualPrinter.enabled\">\n</th><th translate=\"PRODUCTION_ORDERS.COMPLAIN\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.complain.enabled\"></th></tr></thead><tbody><tr \nstyle=\"height:53px\" ng-repeat=\"part in ::profile.parts\" in-view=\"inview=(profile.parts.length<20 || $inview)\" \nng-class=\"{\'green-100-bg\':vm.hightlightPart(part),\'grey-100-bg\':!vm.hightlightPart(part)}\"><td class=\"text-center\">\n{{::part | shortName}}</td><td class=\"text-center\">{{::part.productionTime}}s</td><td class=\"text-center\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.partsMode.list.slitLength\">\n{{::part.slitLength | nuitUnit:\'length\'}}</td><td class=\"text-center\" ng-if=\"part.cut!==null && vm.order.status===1\">\n<md-checkbox ng-if=\"inview\" class=\"mt-16\" ng-model=\"part.cut\" ng-change=\"vm.add(part,\'cut\')\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"vm.order.status>1\"></md-checkbox></td><td class=\"text-center\" \nng-if=\"part.stamped!==null && vm.order.status===1\"><md-checkbox ng-if=\"inview\" class=\"mt-16\" ng-model=\"part.stamped\" \nng-change=\"vm.add(part,\'stamped\')\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"vm.order.status>1\"></md-checkbox>\n</td><td class=\"text-center\" ng-if=\"part.bended!==null && vm.order.status===1\"><md-checkbox ng-if=\"inview\" \nclass=\"mt-16\" ng-model=\"part.bended\" ng-change=\"vm.add(part,\'bended\')\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"vm.order.status>1\"></md-checkbox></td><td class=\"text-center\" \nng-repeat=\"customField in vm.config.ims.productionOrders.productionProfile.partsMode.customData.checkBoxes\">\n<md-checkbox class=\"mt-16\" ng-if=\"inview\" ng-disabled=\"vm.order.status>0\" ng-change=\"vm.updatePart(part)\" \nng-model=\"part.customData[customField.attribute]\"></md-checkbox></td><td class=\"text-center\" \nng-if=\"vm.config.ims.productionOrders.productionProfile.label.enabled && vm.config.ims.productionOrders.productionProfile.label.manualPrinter.enabled\">\n<md-button ng-if=\"inview\" ng-click=\"vm.openLabel(part.label)\"><md-icon md-font-icon=\"icon-receipt\"></md-icon>\n</md-button></td><td class=\"text-center\" ng-if=\"vm.config.ims.productionOrders.productionProfile.complain.enabled\">\n<md-button ng-if=\"inview && !part.complainOrderId\" ng-disabled=\"vm.order.status!==1\" ng-click=\"vm.complain(part)\">\n<md-icon md-font-icon=\"icon-alert-circle\"></md-icon></md-button><md-button ng-if=\"inview && part.complainOrderId\" \nui-sref=\"{orderId: part.complainOrderId, searchId: part.complainPartId,active:\'profiles\'}\"><span \ntranslate=\"PRODUCTION_ORDERS.COMPLAINED_ORDER\"></span><span> {{part.complainOrderId}}</span></md-button></td></tr>\n</tbody></table></div></div></md-content>");
$templateCache.put("app/main/production.planning/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.planning\" default-name=\"PRODUCTION_PLANNING_SETTINGS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/production.planning.boards/components/planning-event-menu/planning-event-menu.component.html","<md-menu><md-button class=\"md-icon-button\" ng-click=\"$event.stopPropagation();$mdMenu.open()\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content><md-menu-item><md-button \nng-click=\"vm.onDetailClick()\" translate=\"PLANNING.OPEN_PRODUCTION_ORDER\">Produktionauftrag öffnen</md-button>\n</md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/main/production.planning.boards/dialogs/update-planning-board/update-planning-board-dialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"PLANNING.UPDATE_PLANNING_BOARD\">Update planning board</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"md-dialog-content\" layout=\"column\"><md-input-container flex \nng-if=\"vm.planningBoards && vm.planningBoards.length > 1\"><label translate=\"PLANNING.PLANNING_BOARD\">Planning board\n</label><md-select ng-model=\"vm.planningBoardId\" required><md-option ng-repeat=\"board in vm.planningBoards\" \nng-value=\"board.id\">{{ board.name | nuitTranslate}}</md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"bt\"><md-button \nng-click=\"vm.close()\" class=\"md-warn\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nng-click=\"vm.save()\" class=\"md-accent md-raised\"><span translate=\"APP.SAVE\">Save</span></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/production.planning.boards/dialogs/update-production-date/update-production-date-dialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 flex \ntranslate=\"PLANNING.UPDATE_PRODUCTION_DATE\">Update production date</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"md-dialog-content\" layout=\"column\"><md-input-container><label \ntranslate=\"PLANNING.PRODUCTION_DATE\"></label><md-datepicker layout-fill ng-model=\"vm.productionDate\" \nmd-hide-icons=\"calendar\" md-placeholder=\"Production Date\" md-date-filter=\"vm.filterDates\"></md-datepicker>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"bt\">\n<md-button ng-click=\"vm.close()\" class=\"\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nng-click=\"vm.save()\" class=\"md-accent md-raised\"><span translate=\"APP.SAVE\">Save</span></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/production.planning.boards/views/tabs/planning-board.html","<md-content class=\"content-card\" layout-fill flex ng-if=\"!vm.loading\"><div class=\"content-header\" layout=\"row\"><div \nlayout=\"row\" layout-align=\"start center\" layout-fill><md-button class=\"md-icon-button arrow previous-button\" \nng-click=\"vm.previousWeek()\" aria-label=\"Previous\" translate translate-attr-aria-label=\"PLANNING.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button arrow next-button\" \nng-click=\"vm.nextWeek()\" aria-label=\"Next\" translate translate-attr-aria-label=\"PLANNING.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button><div class=\"planning-title\">{{ vm.planningTimeframe }}</div>\n<div flex></div><div class=\"ml-10 bold\"><span translate=\"PLANNING.ESTIMATED_TIME\" class=\"description\"></span> <span \nclass=\"ml-10\">{{vm.getEstimatedWeekTime ( vm.currentWeek )}}</span></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"ml-20\" ng-if=\"vm.selectedItems && vm.selectedItems.length > 0\"><div \nclass=\"divider-vertical\"></div><md-button class=\"md-icon-button\" aria-label=\"delete\" \nng-click=\"vm.deleteSelectedItems()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span \ntranslate=\"APP.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.showUpdatePlanningBoardDialog()\" ng-if=\"vm.planningBoards && vm.planningBoards.length > 1\"><span \ntranslate=\"PLANNING.UPDATE_PLANNING_BOARD\">Update planning board</span></md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.showUpdateProductionDateDialog()\"><span \ntranslate=\"PLANNING.UPDATE_PRODUCTION_DATE\">Update production date</span></md-button></div></div><div \nlayout-gt-sm=\"row\" layout=\"column\" ng-if=\"vm.currentWeek && vm.currentWeek.length > 0\"><md-card flex=\"100\" \nlayout=\"column\" ng-repeat=\"day in vm.currentWeek\" class=\"planning-day\"><md-card-header><md-card-header-text><span \nclass=\"md-title\">{{ day.translationKey | translate }}, {{ day.dateFormatted }}</span><div></div></md-card-header-text>\n</md-card-header><md-card-content><div dragula=\'\"planning-event-bag\"\' dragula-scope=\"$scope.vm\" \ndragula-model=\"day.events\" class=\"planning-event-container\" ng-attr-date=\"{{ day.dateFormatted }}\" \nng-attr-timestamp=\"{{ day.timestamp }}\"><ms-widget flippable=\"true\" ng-repeat=\"pe in day.events\" flex=\"100\" \nlayout=\"row\" ng-attr-id=\"{{ pe.id }}\"><ms-widget-front class=\"planning-event-entry front\" \nng-class=\"pe.statusGroup.planningBgColor\" ng-click=\"flipWidget();vm.flipWidget(pe);\"><div layout=\"row\" flex=\"100\" \nclass=\"m-5\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(pe)\" \nng-click=\"$event.stopPropagation();vm.toggleEvent(pe)\" aria-label=\"{{ vm.isSelected(pe) ? \'Deselect\' : \'Select\' }}\">\n</md-checkbox><div layout=\"row\" layout-align=\"start center\" flex><div class=\"md-blue-500-bg p-5 mr-8 brad-2 pa-text\">\n{{pe | shortName:\'PA-{id}\'}}</div><div>{{ pe.title }}</div></div><div layout=\"row\" layout-align=\"end center\">\n<md-progress-linear md-mode=\"determinate\" class=\"estimated-time-icon\" value=\"{{ pe.estimatedTimeIcon }}\">\n</md-progress-linear><planning-event-menu class=\"planning-event-menu\" is-flipped=\"false\" on-open=\"vm.flipWidget(pe)\" \non-detail-click=\"vm.openEventDetail($event, pe)\"></planning-event-menu></div></div><div \nng-if=\"vm.config.ims.planning.boards.overview.material\" class=\"mt-10\" \nng-if=\"pe.materialInfos && pe.materialInfos.length\"><span translate=\"PLANNING.MATERIALS\" class=\"description\"></span>\n<div layout=\"column\" ng-repeat=\"mi in pe.materialInfos\" ng-class=\"{ \'mb-8\': !$last }\"><span>\n{{ mi.material.name | nuitTranslate }}</span> <span>\n{{ mi.weight | nuitUnit:\'weight\' }}&nbsp;|&nbsp;{{ mi.m2 | nuitUnit:\'area\' }}</span></div></div><div \nng-if=\"vm.config.ims.planning.boards.overview.estimatedTime\" class=\"mt-10\"><span translate=\"PLANNING.ESTIMATED_TIME\" \nclass=\"description\"></span> <span>{{ vm.formatEstimatedTime(pe.estimatedTime) }}</span></div></ms-widget-front>\n<ms-widget-back class=\"planning-event-entry\" ng-class=\"pe.statusGroup.planningBgColor\" \nng-click=\"flipWidget();vm.flipWidget(pe);\"><div class=\"m-5\"><div layout=\"row\" flex=\"100\"><md-checkbox class=\"no-label\" \nng-checked=\"vm.isSelected(pe)\" ng-click=\"$event.stopPropagation();vm.toggleEvent(pe)\" \naria-label=\"{{ vm.isSelected(pe) ? \'Deselect\' : \'Select\' }}\"></md-checkbox><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"md-blue-500-bg p-5 mr-8 brad-2 pa-text\">{{pe | shortName:\'PA-{id}\'}}</div>\n<div>{{ pe.title }}</div></div><div layout=\"row\" layout-align=\"end center\"><md-progress-linear md-mode=\"determinate\" \nclass=\"estimated-time-icon\" value=\"{{ pe.estimatedTimeIcon }}\"></md-progress-linear><planning-event-menu \nclass=\"planning-event-menu\" is-flipped=\"true\" on-detail-click=\"vm.openEventDetail($event, pe)\"></planning-event-menu>\n</div></div><div layout=\"column\" class=\"mt-10\"><span translate=\"CART.PARTS\" class=\"description\"></span> <span>\n{{ pe.totalParts }}</span></div><div layout=\"column\" class=\"mt-10\"><span translate=\"PLANNING.MATERIALS\" \nclass=\"description\"></span><div layout=\"column\" ng-repeat=\"mi in pe.materialInfos\" ng-class=\"{ \'mb-8\': !$last }\"><span>\n{{ mi.material.name | nuitTranslate }}</span> <span>\n{{ mi.weight | nuitUnit:\'weight\' }}&nbsp;|&nbsp;{{ mi.m2 | nuitUnit:\'area\' }}</span></div></div><div layout=\"column\" \nclass=\"mt-10\"><span translate=\"PRODUCTION_ORDERS.ORDERS\" class=\"description\"></span><div layout=\"column\" \nng-repeat=\"order in pe.shopOrders\" ng-class=\"{ \'mb-8\': !$last }\">\n{{ order.number }}&nbsp;|&nbsp;{{ vm.config.ims.orders.nameFormat | nuitFormatter: order }}</div></div><div \nlayout=\"column\" class=\"mt-10\"><span translate=\"PLANNING.ESTIMATED_TIME\" class=\"description\"></span> <span>\n{{ vm.formatEstimatedTime(pe.estimatedTime) }}</span></div></div></ms-widget-back></ms-widget></div></md-card-content>\n<md-card-footer><md-divider class=\"mb-16\"></md-divider><div class=\"estimated-time-sum\"><span \ntranslate=\"PLANNING.ESTIMATED_TIME\"></span></div><div>{{ vm.getEstimatedTime(day.dateFormatted) }}</div>\n</md-card-footer></md-card></div></md-content>");
$templateCache.put("app/main/production.punchTools/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.punchTools\" default-name=\"PUNCH_TOOLS_SETTINGS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/production.queue/dialogs/queue.createOrder/queue.createOrder.html","<md-dialog aria-label=\"New Order\" id=\"system-queueOrder-dialog\"><form name=\"queueOrderForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"QUEUE.NEW_ORDER\">Neuer Auftrag</span></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" ng-if=\"!vm.inProgress\"><div layout=\"row\">\n<md-input-container flex><label translate=\"APP.NAME\">Bezeichnung</label><input type=\"text\" name=\"name\" \nng-model=\"vm.newOrder.name\" md-maxlength=\"255\" maxlength=\"255\"><div ng-messages=\"queueOrderForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"30\"><label translate=\"ORDERS.COMPLETION_DATE\">\n</label><md-datepicker layout-fill ng-model=\"vm.completionDate\" md-hide-icons=\"calendar\" \nmd-placeholder=\"Completion Date\"></md-datepicker></md-input-container><md-input-container flex><label \ntranslate=\"APP.HOURS\">Stunden</label><input type=\"number\" name=\"hours\" min=\"0\" max=\"9999\" ng-model=\"vm.newOrder.hours\">\n</md-input-container><md-input-container flex><label translate=\"APP.MINUTES\">Minuten</label><input type=\"number\" \nname=\"minutes\" min=\"0\" max=\"9999\" ng-model=\"vm.newOrder.minutes\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.config.ims.planning.enabled\"><md-input-container flex=\"30\"><label translate=\"PLANNING.PRODUCTION_DATE\">\n</label><md-datepicker layout-fill ng-model=\"vm.productionDate\" md-hide-icons=\"calendar\" \nmd-placeholder=\"Production Date\"></md-datepicker></md-input-container><md-input-container flex \nng-if=\"vm.planningBoards && vm.planningBoards.length > 1\"><label translate=\"PLANNING.PLANNING_BOARD\">Planning board\n</label><md-select ng-model=\"vm.newOrder.boardId\"><md-option ng-repeat=\"board in vm.planningBoards\" \nng-value=\"board.id\">{{ board.name | nuitTranslate }}</md-option></md-select></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\" ng-if=\"!vm.inProgress\"><md-button class=\"md-warn\" type=\"reset\" \nng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button class=\"md-accent md-raised\" \ntype=\"submit\" ng-disabled=\"queueOrderForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span></md-button></div><div \nng-if=\"vm.inProgress\" class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill>\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/production.queue/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.queue\" default-name=\"PRODUCTION_QUEUE_SETTINGS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/projects.projects/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.projects\" default-name=\"PROJECTS_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/system.exchange/dialogs/error-log/error-log.html","<md-dialog flex=\"80\"><md-content layout=\"column\"><table class=\"dataTable border row-border\" flex><thead><tr><th \ntranslate=\"EXCHANGE.MESSAGE\"></th><th translate=\"EXCHANGE.STARTED_AT\"></th><th translate=\"EXCHANGE.FINISHED_AT\"></th>\n<th translate=\"EXCHANGE.STATUS\"></th><th translate=\"EXCHANGE.SKIPPED_ERROR_COUNT\"></th></tr></thead><tbody><tr><td>\n{{vm.history.message}}</td><td>{{vm.history.taskStartedAt | nuitDate}} {{vm.history.taskStartedAt | nuitTime}}</td><td>\n{{vm.history.taskFinishedAt | nuitDate}} {{vm.history.taskFinishedAt | nuitTime}}</td><td>{{vm.history.status}}</td>\n<td>{{vm.history.skippedErrorCount}}</td></tr></tbody></table><div class=\"mt-20\"></div><table \nclass=\"dataTable border row-border\" flex><tbody><tr ng-if=\"vm.history.result && vm.history.result.error\"><td \nclass=\"text-bold\" translate=\"EXCHANGE.ERROR\"></td><td>{{vm.history.result.error}}</td></tr><tr \nng-if=\"vm.history.result && vm.history.result.formatResult && vm.history.result.formatResult.error\"><td \nclass=\"text-bold\" translate=\"EXCHANGE.FORMAT_ERROR\"></td><td>{{vm.history.result.formatResult.error}}</td></tr><tr \nng-if=\"vm.history.result && vm.history.result.formatResult && vm.history.result.formatResult.skipped\" \nng-repeat=\"(index,error) in vm.history.result.formatResult.skipped\"><td><span class=\"text-bold\" ng-if=\"index===0\" \ntranslate=\"EXCHANGE.SKIPPED_ERROR\"></span></td><td>{{error}}</td></tr></tbody></table></md-content></md-dialog>");
$templateCache.put("app/main/system.exchange/dialogs/new-app/new-app.html","<md-dialog class=\"width-300\"><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"EXCHANGE.ADD_APP\">Neue App</span></div></md-toolbar>\n<md-content><form style=\"margin-top:40px\" name=\"vm.form\" novalidate ng-submit=\"vm.save()\"><div layout=\"column\" \nlayout-margin><md-input-container flex><label translate=\"EXCHANGE.APP_TYPE\"></label><md-select ng-model=\"vm.app.type\" \nrequired><md-option ng-repeat=\"type in vm.types\" ng-value=\"type\">{{type}}</md-option></md-select></md-input-container>\n<div></div><md-input-container flex><label translate=\"APP.NAME\"></label><input type=\"text\" ng-model=\"vm.app.name\" \nname=\"name\" required></md-input-container></div></form></md-content><md-dialog-actions><div layout=\"row\" layout-margin \nlayout-align=\"space-between start\"><md-button class=\"md-warn md-raised\" \nng-disabled=\"!vm.form.$dirty || vm.form.$invalid\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.hide()\" translate=\"APP.CANCEL\">Cancel</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/system.exchange/dialogs/new-flow/new-flow.html","<md-dialog class=\"width-300\"><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"APP.ADD\">Neuer Flow</span></div></md-toolbar>\n<md-content><form style=\"margin-top:40px\" name=\"vm.form\" novalidate ng-submit=\"vm.save()\"><div layout=\"column\" \nlayout-margin><md-input-container><label translate=\"NODE_RED.FLOW_TYPE\">Lang</label><md-select \nng-model=\"vm.selectedType\" ng-change=\"vm.clearFlow\"><md-option ng-repeat=\"type in vm.flowTypes\" ng-value=\"type\"><div \nlayout=\"row\" layout-align=\"start center\">{{\'NODE_RED.FLOW_TYPE.\' + type.toUpperCase() | translate}}</div></md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-margin><md-input-container \nng-if=\"vm.isType(\'global\')\"><label translate=\"APP.TYPE\">Lang</label><md-select ng-model=\"vm.flow.id\" required>\n<md-option ng-repeat=\"flow in vm.globalFlows\" ng-value=\"flow.id\"><div layout=\"row\" layout-align=\"start center\">\n{{flow.name}}</div></md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.isType(\'local\')\">\n<label translate=\"APP.NAME\"></label><input type=\"text\" ng-model=\"vm.flow.name\" name=\"name\" required>\n</md-input-container></div></form></md-content><md-dialog-actions><div layout=\"row\" layout-margin \nlayout-align=\"space-between start\"><md-button class=\"md-warn md-raised\" \nng-disabled=\"!vm.form.$dirty || vm.form.$invalid\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.hide()\" translate=\"APP.CANCEL\">Cancel</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/system.exchange/dialogs/new-task/new-task.html","<md-dialog flex=\"80\" style=\"max-width: 600px\"><md-content><form style=\"margin-top:40px\" name=\"vm.form\" novalidate \nng-model-options=\"{debounce:200}\" ng-submit=\"vm.save()\"><div layout=\"column\" layout-margin><md-input-container flex>\n<label translate=\"EXCHANGE.TASK_TYPE\"></label><md-select ng-model=\"vm.taskType\" required \nng-change=\"vm.taskTypeChanged()\" ng-disabled=\"!vm.newTask\"><md-option ng-repeat=\"type in vm.taskTypes\" ng-value=\"type\">\n{{type}}</md-option></md-select></md-input-container><div layout=\"row\" ng-if=\"vm.taskType===\'format\'\" flex>\n<md-input-container flex><label translate=\"EXCHANGE.TASK_SERVICE\"></label><md-select ng-model=\"vm.service\" \nng-change=\"vm.onServiceChanged()\" required><md-option ng-repeat=\"service in vm.serviceInfo\" ng-value=\"service\">\n{{service.name}}</md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.service\"><label \ntranslate=\"EXCHANGE.TASK_METHOD\"></label><md-select ng-model=\"vm.task.method\" required \nng-change=\"vm.onMethodChanged()\" ng-selected=\"vm.task.method===method\"><md-option \nng-repeat=\"method in vm.service.methods\" ng-value=\"method\">{{method.name}}</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" layout-padding ng-if=\"vm.transferInfoLoaded && vm.task.method && vm.taskType===\'format\'\">\n<nuit-exchange-connection ng-if=\"vm.transferInfoLoaded\" config=\"vm.task.transfer\" transfer-info=\"vm.transferInfo\" \nheader=\"EXCHANGE.SENDER\" flex></nuit-exchange-connection></div><div layout=\"row\" layout-padding \nng-if=\"vm.taskType===\'app\'\"><md-input-container flex><label translate=\"EXCHANGE.APPS\"></label><md-select \nng-model=\"vm.task.app.id\" required ng-change=\"vm.updateAppTasks()\"><md-option ng-repeat=\"app in vm.apps\" \nng-value=\"app.id\">{{app.name}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"EXCHANGE.APPS\"></label><md-select ng-model=\"vm.task.app.taskId\" required><md-option \nng-repeat=\"app in vm.appTasks\" ng-value=\"app.id\">{{app.name}}</md-option></md-select></md-input-container></div></form>\n</md-content><md-dialog-actions><div layout=\"row\" layout-margin layout-align=\"space-between start\"><md-button \nclass=\"md-warn md-raised\" ng-disabled=\"!vm.form.$dirty\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save</md-button>\n<md-button class=\"md-raised\" ng-click=\"vm.hide()\" translate=\"APP.CANCEL\">Cancel</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/system.exchange/dialogs/new-trigger/new-trigger.html","<md-dialog><md-content style=\"min-height:260px\"><form style=\"margin-top:40px\" name=\"vm.form\" novalidate \nng-submit=\"vm.save()\"><div layout=\"column\" layout-margin layout-padding><md-input-container flex><label \ntranslate=\"EXCHANGE.TRIGGER_TYPE\"></label><md-select ng-model=\"vm.trigger.type\" ng-change=\"vm.onTypeChanged()\" \nrequired><md-option ng-repeat=\"type in vm.triggerInfo\" ng-value=\"type\">{{type.id}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"vm.trigger.type && vm.trigger.type.type===\'string\'\"><label \ntranslate=\"EXCHANGE.TRIGGER_VALUE\"></label><input type=\"text\" ng-model=\"vm.trigger.value\" name=\"trigger\">\n</md-input-container><md-input-container flex ng-if=\"vm.trigger.type.id===\'cron\'\"><label translate=\"EXCHANGE.TIMEZONE\">\n</label><md-select ng-model=\"vm.trigger.timezone\" required><md-select-header class=\"select-header p-10\"><input \nng-model=\"searchText\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"{{\'APP.SEARCH\' | translate}}\">\n<md-icon ng-show=\"searchText && searchText.length>0\" md-font-icon=\"icon-close\" ng-click=\"searchText=\'\';\"></md-icon>\n</md-select-header><md-option \nng-if=\"searchText===\'\' || searchText===undefined || timezone.toLowerCase().indexOf(searchText.toLowerCase())>=0\" \nng-value=\"timezone\" ng-repeat=\"timezone in vm.timezones\">{{timezone}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if=\"vm.trigger.type && vm.trigger.type.type===\'enum\'\"><label \ntranslate=\"EXCHANGE.TRIGGER_VALUE\"></label><md-select ng-model=\"vm.trigger.value\" required><md-option \nng-repeat=\"value in vm.trigger.type.values\" ng-value=\"value\">{{value}}</md-option></md-select></md-input-container><div\n ng-if=\"vm.trigger.type.id===\'cron\'\" style=\"max-width: 300px\">{{vm.readableCron(vm.trigger.value)}}</div><div \nng-jsoneditor ng-model=\"vm.trigger.conditions\" options=\"{mode: \'tree\'}\"></div></div></form></md-content>\n<md-dialog-actions><div layout=\"row\" layout-margin layout-align=\"space-between start\"><md-button \nclass=\"md-warn md-raised\" ng-disabled=\"!vm.form.$dirty || vm.form.$invalid\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">\nSave</md-button><md-button class=\"md-raised\" ng-click=\"vm.hide()\" translate=\"APP.CANCEL\">Cancel</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/system.exchange/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.exchange\" default-name=\"EXCHANGE_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/system.exchange/views/partials/general.html","<md-content layout-fill flex ms-scroll><div layout=\"column\" layout-padding layout-margin class=\"mt-30\"><div \nlayout=\"row\" layout-margin layout-align=\"start start\"><md-input-container flex><label translate=\"EXCHANGE.JOB_NAME\">\nFirstname</label><input type=\"text\" ng-model=\"vm.job.name[vm.selectedLanguage]\" required></md-input-container>\n<md-input-container ng-if=\"vm.config.languages.length > 1\"><label translate=\"APP.LANG\">Language</label><md-select \nng-model=\"vm.selectedLanguage\"><md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span \nclass=\"text-uppercase\">{{ ::lang }}</span></md-option></md-select></md-input-container></div></div></md-content>");
$templateCache.put("app/main/system.exchange/views/partials/history.html","<md-content layout-fill flex ms-scroll><table class=\"dataTable border row-border hover\"><thead><tr><th \ntranslate=\"EXCHANGE.MESSAGE\"></th><th translate=\"EXCHANGE.STARTED_AT\"></th><th translate=\"EXCHANGE.FINISHED_AT\"></th>\n<th translate=\"EXCHANGE.STATUS\"></th><th translate=\"EXCHANGE.SKIPPED_ERROR_COUNT\"></th></tr></thead><tbody><tr \nng-repeat=\"history in vm.history\" ng-click=\"vm.showErrorLogDialog(vm.job.id,history.id)\"><td>{{history.message}}</td>\n<td>{{history.taskStartedAt | nuitDate}} {{history.taskStartedAt | nuitTime}}</td><td>\n{{history.taskFinishedAt | nuitDate}} {{history.taskFinishedAt | nuitTime}}</td><td>{{history.status}}</td><td>\n{{history.skippedErrorCount}}</td></tr></tbody></table></md-content>");
$templateCache.put("app/main/system.exchange/views/partials/nodered-general.html","<md-content layout-fill flex ms-scroll><div layout=\"column\" layout-margin ng-if=\"!vm.isLoading\"><div layout=\"row\" \nclass=\"mb-20\"></div><div layout=\"row\"></div><md-card layout=\"column\" layout-margin></md-card></div></md-content>");
$templateCache.put("app/main/system.exchange/views/partials/quickbook-customers.html","<div flex><div layout=\"column\" layout-padding layout-margin><md-button class=\"md-raised\" layout-align=\"center center\" \nlayout=\"row\" ng-click=\"vm.importCustomers(vm.filteredTypes)\" \nng-disabled=\"vm.importingCustomers || vm.unLinkedCompanies.length!==0\"><md-progress-circular \nng-if=\"vm.importingCustomers\" class=\"md-accent mr-20\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular>\n<label translate=\"QUICKBOOKS.CUSTOMERS.IMPORT\"></label></md-button><md-input-container flex><md-label \ntranslate=\"QUICKBOOKS.CUSTOMERS.TYPES\">Type</md-label><md-select multiple=\"multiple\" ng-model=\"vm.filteredTypes\">\n<md-options><md-option ng-repeat=\"val in vm.customerTypes\" ng-value=\"val.typeId\">{{ val.name }}</md-option>\n</md-options></md-select></md-input-container><md-content ms-scroll><div layout=\"row\"><div flex layout=\"column\"><div \nlayout=\"row\" layout-padding layout-align=\"center center\" class=\"text-bold grey-100-bg h-50\"><div flex=\"45\" \ntranslate=\"PARTNERS.COMPANIES_NAV\"></div><div flex=\"10\"></div><div flex=\"45\" translate=\"QUICKBOOKS.CUSTOMERS\"></div>\n</div><div style=\"height:40px\" class=\"search-wrapper\" layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"APP.SEARCH\" ng-model-options=\"{debounce:1000}\"></div></div><div class=\"bt h-50\" \nlayout=\"row\" layout-align=\"start center\" layout-padding flex ng-click=\"vm.selectCompany(company)\" \nng-class=\"{\'md-accent-bg\':vm.selectedCompany && company.id===vm.selectedCompany.id}\" \nng-repeat=\"company in vm.unLinkedCompaniesSearch track by $index\"><div flex=\"45\"><span>{{company.name}}</span></div>\n<div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-button ng-disabled=\"vm.selectedCustomer===null\" \nng-if=\"vm.selectedCompany!==null && company.id===vm.selectedCompany.id\" class=\"md-raised md-accent md-icon-button\" \nng-click=\"vm.link()\"><md-icon md-font-icon=\"icon-link\"></md-icon></md-button></div><div flex=\"45\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.selectedCompany!==null && company.id===vm.selectedCompany.id\"><md-select \nclass=\"m-0\" ng-model=\"vm.selectedCustomer\" flex><md-option ng-click=\"vm.selectedCustomer=customer\" \nng-repeat=\"customer in vm.unLinkedCustomers | orderBy:\'name\'\" ng-value=\"customer\">{{customer.name}}</md-option>\n</md-select></div><div ng-if=\"vm.selectedCompany===null || company.id!==vm.selectedCompany.id\"><md-icon \nclass=\"red-500-fg\" md-font-icon=\"icon-alert\"></md-icon><span translate=\"QUICKBOOKS.NO_CUSTOMER_ASSIGNED\"></span></div>\n</div><div class=\"bt h-50\" layout=\"row\" layout-align=\"start center\" layout-padding flex \nng-click=\"vm.selectCompany(company)\" \nng-class=\"{\'md-accent-bg\':vm.selectedCompany && company.id===vm.selectedCompany.id}\" \nng-repeat=\"company in vm.linkedCompaniesSearch track by $index\"><div flex=\"45\">{{company.name}}</div><div flex=\"10\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.selectedCompany!==company\"><md-icon md-font-icon=\"icon-link\">\n</md-icon></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.selectedCompany===company\">\n<md-button class=\"md-raised md-accent md-icon-button\" ng-click=\"vm.unlink()\"><md-icon md-font-icon=\"icon-link-off\">\n</md-icon></md-button></div><div flex=\"45\">{{vm.getCustomerName(company.externalId)}}</div></div></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/system.exchange/views/partials/quickbook-import.html","<md-content layout-fill flex ms-scroll><div layout=\"column\" layout-margin ng-if=\"!vm.isLoading\"><div layout=\"row\" \nclass=\"mb-20\"><div class=\"mr-10\" translate=\"QUICKBOOK.COMPANY_NAME\"></div><div flex class=\"text-bold\">\n{{vm.qbService.data.qbCompanyName}}</div></div><div layout=\"row\"><md-input-container class=\"mt-5 mb-5\" flex><label \ntranslate=\"QUICKBOOK.ACCOUNT\">Account</label><md-select ng-model=\"vm.qbService.config.incomeAccountRef\" \nng-change=\"vm.changeAccountId()\"><md-option ng-repeat=\"account in vm.qbService.accounts track by account.accountId\" \nng-value=\"account.accountId\"><span class=\"text-bold\">{{account.name}}</span></md-option></md-select>\n</md-input-container></div><md-card layout=\"column\" layout-margin><h1 translate=\"APP.CONFIG\" class=\"mb-20\"></h1>\n<md-input-container flex><label translate=\"QUICKBOOK.STATUS\">Account</label><md-select \nng-model=\"vm.qbService.config.status\" ng-change=\"vm.patchConfig(\'status\')\"><md-option class=\"text-bold\" ng-value=\"\'\'\" \ntranslate=\"APP.NONE\"></md-option><md-option ng-repeat=\"status in vm.orderStatus track by status.id\" \nng-value=\"status.id\"><span class=\"text-bold\">{{status.name | nuitTranslate}}</span></md-option></md-select>\n</md-input-container></md-card></div></md-content>");
$templateCache.put("app/main/system.exchange/views/partials/quickbook-items.html","<div flex><div layout=\"column\" layout-padding layout-margin><md-button class=\"md-raised\" layout-align=\"center center\" \nlayout=\"row\" ng-click=\"vm.importItems(vm.filteredCategories)\" \nng-disabled=\"vm.importingItems || vm.unLinkedProducts.length!==0\"><md-progress-circular ng-if=\"vm.importingItems\" \nclass=\"md-accent mr-20\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular><label \ntranslate=\"QUICKBOOKS.ITEMS.IMPORT\"></label></md-button><md-input-container flex><md-label \ntranslate=\"QUICKBOOKS.ITEMS.TYPES\">Type</md-label><md-select multiple=\"multiple\" ng-model=\"vm.filteredCategories\">\n<md-options><md-option ng-repeat=\"val in vm.itemCategories\" ng-value=\"val.categoryId\">{{ val.name }}</md-option>\n</md-options></md-select></md-input-container><md-content ms-scroll><div layout=\"row\"><div flex layout=\"column\"><div \nlayout=\"row\" layout-padding layout-align=\"center center\" class=\"text-bold grey-100-bg h-50\"><div flex=\"45\" \ntranslate=\"PRODUCT.PRODUCT_NAV\"></div><div flex=\"10\"></div><div flex=\"45\" translate=\"QUICKBOOKS.ITEMS\"></div></div><div\n style=\"height:40px\" class=\"search-wrapper\" layout=\"row\" layout-align=\"start center\" flex><div class=\"search\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" \nng-model-options=\"{debounce:1000}\"></div></div><div class=\"bt h-50\" layout=\"row\" layout-align=\"start center\" \nlayout-padding flex ng-click=\"vm.selectProduct(product)\" \nng-class=\"{\'md-accent-bg\':vm.selectedProduct && product.id===vm.selectedProduct.id}\" \nng-repeat=\"product in vm.unLinkedProductsSearch track by $index\"><div flex=\"45\"><span>{{product.name | nuitTranslate}}\n</span></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-button ng-disabled=\"vm.selectedItem===null\" \nng-if=\"vm.selectedProduct!==null && product.id===vm.selectedProduct.id\" class=\"md-raised md-accent md-icon-button\" \nng-click=\"vm.link()\"><md-icon md-font-icon=\"icon-link\"></md-icon></md-button></div><div flex=\"45\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.selectedProduct!==null && product.id===vm.selectedProduct.id\"><md-select \nclass=\"m-0\" ng-model=\"vm.selectedItem\" flex><md-option ng-click=\"vm.selectedItem=item\" \nng-repeat=\"item in vm.unLinkedItems | orderByNuitTranslated:\'name\'\" ng-value=\"item\">{{item.name}}</md-option>\n</md-select></div><div ng-if=\"vm.selectedProduct===null || product.id!==vm.selectedProduct.id\"><md-icon \nclass=\"red-500-fg\" md-font-icon=\"icon-alert\"></md-icon><span translate=\"QUICKBOOKS.NO_ITEM_ASSIGNED\"></span></div>\n</div><div class=\"bt h-50\" layout=\"row\" layout-align=\"start center\" layout-padding flex \nng-click=\"vm.selectProduct(product)\" \nng-class=\"{\'md-accent-bg\':vm.selectedProduct && product.id===vm.selectedProduct.id}\" \nng-repeat=\"product in vm.linkedProductsSearch track by $index\"><div flex=\"45\">{{product.name | nuitTranslate}}</div>\n<div flex=\"10\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.selectedProduct!==product\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.selectedProduct===product\"><md-button class=\"md-raised md-accent md-icon-button\" ng-click=\"vm.unlink()\">\n<md-icon md-font-icon=\"icon-link-off\"></md-icon></md-button></div><div flex=\"45\">{{vm.getItemName(product.externalId)}}\n</div></div></div></div></md-content></div></div>");
$templateCache.put("app/main/system.exchange/views/partials/tasks.html","<div class=\"content-wrapper\" layout=\"column\" flex><div class=\"content thread-list\" ms-scroll flex><div \nng-if=\"vm.job.tasks.length === 0 && !vm.job.tasks\" class=\"no-threads\" layout=\"column\" layout-align=\"center center\" \nlayout-fill><span class=\"md-headline\">There are no persons yet!</span></div><div class=\"thread unread\" \nng-repeat=\"task in vm.job.tasks\" ng-click=\"vm.showTaskDialog(task)\"><div layout=\"row\" layout-align=\"start end\"><div \nclass=\"info\" layout=\"column\" flex><div ng-if=\"!task.app.id\"><div>{{task.service}} {{task.method}}</div><div \nclass=\"message\">{{task.format}}</div></div><div ng-if=\"task.app.id\"><div>{{task.app.name}}</div><div class=\"message\">\n{{task.app.type}}</div></div></div><div flex=\"5\"><md-button class=\"md-warn md-raised md-icon-button\" \nng-click=\"vm.deleteTask(task.id);$event.stopPropagation()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>\n<span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-button></div></div></div></div><section layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\" layout-wrap><md-button class=\"md-raised\" \nng-click=\"vm.showTaskDialog(null)\" translate=\"APP.ADD\">Add</md-button></section></div>");
$templateCache.put("app/main/system.exchange/views/partials/triggers.html","<div class=\"content thread-list\" ms-scroll flex><div class=\"thread unread\" ng-repeat=\"trigger in vm.job.triggers\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"info\" layout=\"column\" flex><div>{{trigger.type}}</div><div\n ng-if=\"trigger.type===\'cron\'\">{{trigger.timezone}} {{vm.readableCron(trigger.value)}}</div><div \nng-if=\"trigger.type!==\'cron\'\">{{trigger.value}}</div><div>{{trigger.conditions}}</div></div><div layout=\"row\">\n<md-button class=\"md-warn md-raised md-icon-button\" ng-click=\"vm.removeTrigger(trigger);$event.stopPropagation()\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip>\n</md-button></div></div></div></div><section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap>\n<md-button class=\"md-raised\" ng-click=\"vm.showTriggerDialog(null)\" translate=\"APP.ADD\">Add</md-button></section>");
$templateCache.put("app/main/system.exchange/views/partials/xero-config.html","<md-content layout-fill flex ms-scroll><div layout=\"column\" layout-margin ng-if=\"!vm.isLoading\"><div layout=\"row\">\n<md-input-container class=\"mt-5 mb-5\" flex><label translate=\"XERO.TENANT\">Account</label><md-select \nng-model=\"vm.xeroService.data.config.tenantId\" ng-change=\"vm.changeConnectionId()\"><md-option \nng-repeat=\"connection in vm.xeroService.connections track by connection.id\" ng-value=\"connection.tenantId\"><span \nclass=\"text-bold\"><span>{{connection.organisation.name || (connection.tenantId + \' \')}}</span> <span \nng-if=\"connection.organisation.name===\'\'\">(<span translate=\"APP.NO_NAME\"></span>)</span></span></md-option></md-select>\n</md-input-container></div></div></md-content>");
$templateCache.put("app/main/system.exchange/views/partials/xero-customers.html","<div flex><div layout=\"column\" layout-padding layout-margin><md-button class=\"md-raised\" layout-align=\"center center\" \nlayout=\"row\" ng-click=\"vm.importCustomers()\" ng-disabled=\"vm.importingCustomers || vm.unLinkedCompanies.length!==0\">\n<md-progress-circular ng-if=\"vm.importingCustomers\" class=\"md-accent mr-20\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><label translate=\"XERO.CUSTOMERS.IMPORT\"></label></md-button><md-content ms-scroll><div \nlayout=\"row\"><div flex layout=\"column\"><div layout=\"row\" layout-padding layout-align=\"center center\" \nclass=\"text-bold grey-100-bg h-50\"><div flex=\"45\" translate=\"PARTNERS.COMPANIES_NAV\"></div><div flex=\"10\"></div><div \nflex=\"45\" translate=\"XERO.CUSTOMERS\"></div></div><div style=\"height:40px\" class=\"search-wrapper\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-model-options=\"{debounce:1000}\"></div></div>\n<div class=\"bt h-50\" layout=\"row\" layout-align=\"start center\" layout-padding flex ng-click=\"vm.selectCompany(company)\" \nng-class=\"{\'md-accent-bg\':vm.selectedCompany && company.id===vm.selectedCompany.id}\" \nng-repeat=\"company in vm.unLinkedCompaniesSearch track by $index\"><div flex=\"45\"><span>{{company.name}}</span></div>\n<div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-button ng-disabled=\"vm.selectedCustomer===null\" \nng-if=\"vm.selectedCompany!==null && company.id===vm.selectedCompany.id\" class=\"md-raised md-accent md-icon-button\" \nng-click=\"vm.link()\"><md-icon md-font-icon=\"icon-link\"></md-icon></md-button></div><div flex=\"45\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.selectedCompany!==null && company.id===vm.selectedCompany.id\"><md-select \nclass=\"m-0\" ng-model=\"vm.selectedCustomer\" flex><md-option ng-click=\"vm.selectedCustomer=customer\" \nng-repeat=\"customer in vm.unLinkedCustomers | orderBy:\'Name\'\" ng-value=\"customer\">{{customer.Name}}</md-option>\n</md-select></div><div ng-if=\"vm.selectedCompany===null || company.id!==vm.selectedCompany.id\"><md-icon \nclass=\"red-500-fg\" md-font-icon=\"icon-alert\"></md-icon><span translate=\"QUICKBOOKS.NO_CUSTOMER_ASSIGNED\"></span></div>\n</div><div class=\"bt h-50\" layout=\"row\" layout-align=\"start center\" layout-padding flex \nng-click=\"vm.selectCompany(company)\" \nng-class=\"{\'md-accent-bg\':vm.selectedCompany && company.id===vm.selectedCompany.id}\" \nng-repeat=\"company in vm.linkedCompaniesSearch track by $index\"><div flex=\"45\">{{company.name}}</div><div flex=\"10\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.selectedCompany!==company\"><md-icon md-font-icon=\"icon-link\">\n</md-icon></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.selectedCompany===company\">\n<md-button class=\"md-raised md-accent md-icon-button\" ng-click=\"vm.unlink()\"><md-icon md-font-icon=\"icon-link-off\">\n</md-icon></md-button></div><div flex=\"45\">{{vm.getCustomerName(company.externalId)}}</div></div></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/system.profiles/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.profiles\" default-name=\"PROFILES_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/system.roles/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.roles\" default-name=\"ROLES_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/system.roles/views/partials/general.html","<div layout=\"column\"><div layout=\"row\" layout-align=\"start top\" layout-margin class=\"secondary-text mv-16\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"APP.GENERAL\">General</span>\n</div><div layout=\"row\" class=\"mt-5\" layout-margin><md-input-container class=\"mt-5\"><label translate=\"PRODUCT.NAME\">\nBezeichnung</label><input type=\"text\" name=\"name\" ng-model=\"vm.role.name[vm.selectedLanguage]\" required>\n</md-input-container><md-input-container class=\"mt-5\" ng-if=\"vm.config.languages.length > 1\"><label \ntranslate=\"APP.LANG\">Lang</label><md-select ng-model=\"vm.selectedLanguage\"><md-option \nng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{ ::lang }}</span></md-option>\n</md-select></md-input-container><md-input-container class=\"mt-5\"><label translate=\"ROLES.TYPE\"></label><md-select \nng-model=\"vm.role.type\" md-selected=\"$first\" ng-disabled=\"vm.hasUsers\"><md-option ng-repeat=\"type in vm.types\" \nng-value=\"type.id\" ng-if=\"vm.config | nuitDotNotation:type.config:false\"><span class=\"text-uppercase\" \ntranslate=\"{{type.name}}\"></span></md-option></md-select></md-input-container></div></div>");
$templateCache.put("app/main/system.roles/views/partials/module-details.html","<div id=\"role-module-details\"><div layout=\"column\"><div layout=\"row\" layout-align=\"start top\" layout-margin \nclass=\"secondary-text mt-16\"><md-icon md-font-icon=\"icon-account-key\" class=\"mr-8\"></md-icon><span class=\"md-title\" \nflex translate=\"ROLES.PERMISSIONS\">Berechtigungen</span></div></div><div class=\"module-group-details\" flex-gt-sm=\"50\" \nng-if=\"vm.role.config.ims.enabled.value\"><div class=\"md-whiteframe-z1\"><div class=\"group-headline\" translate=\"APP.IMS\">\n</div><config-editor whole-config=\"vm.role.config\" default-root=\"ims.routes\" default-name=\"IMS_SETTINGS_ROLE\" \ncontroller=\"vm\" removeable=\"false\"></config-editor></div></div><div class=\"module-group-details\" flex-gt-sm=\"50\" \nng-if=\"vm.role.config.evo\"><div><div class=\"group-headline\" translate=\"EVO.ACCOUNT_SETTINGS\"></div><config-editor \nwhole-config=\"vm.role.config\" default-root=\"evo.account\" default-name=\"EVO_ACCOUNT_SETTINGS_ROLE\" controller=\"vm\" \nremoveable=\"false\"></config-editor></div></div><div ng-repeat=\"moduleKey in vm.getGroups()\" \nclass=\"module-group-details\" flex-gt-sm=\"50\"><div class=\"md-whiteframe-z1\" \nng-repeat=\"module in vm.moduleGroups[moduleKey]\" ng-if=\"vm.showModule(module)\"><div class=\"group-headline\" \ntranslate=\"{{module.name}}\"></div><config-editor whole-config=\"vm.role.config\" default-root=\"{{module.rootKey}}\" \ndefault-name=\"{{module.constantName}}\" controller=\"vm\" removeable=\"false\"></config-editor></div></div></div>");
$templateCache.put("app/main/system.roles/views/partials/module.html","<div layout=\"column\"><div class=\"secondary-text mt-16\" layout=\"row\" layout-align=\"start top\" layout-margin><md-icon \nclass=\"mr-8\" md-font-icon=\"icon-account-key\"></md-icon><span class=\"md-title\" flex translate=\"ROLES.PERMISSIONS\">\nBerechtigungen</span></div></div><div flex layout=\"column\"><div class=\"mh-15\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div class=\"md-whiteframe-z1\" flex-order=\"{{vm.getGroupIndex(\'ims.general\')}}\" layout=\"column\" \nlayout-margin layout-padding><strong translate=\"APP.IMS\"></strong><md-switch aria-label=\"IMS\" \nng-click=\"vm.onChange({moduleType: \'ims\', moduleName: \'enabled\', key: \'ims.enabled\'})\" \nng-model=\"vm.role.config.ims.enabled.value\"><span translate=\"APP.ACTIVE\"></span></md-switch><md-switch \naria-label=\"Dashboard\" ng-if=\"vm.envConfig.ims.dashboard.enabled\" \nng-model=\"vm.role.config.ims.dashboard.enabled.value\"><span translate=\"DASHBOARD.DASHBOARD_NAV\"></span></md-switch>\n</div><div class=\"md-whiteframe-z1\" flex-order=\"{{vm.getGroupIndex(moduleKey)}}\" layout=\"column\" layout-margin \nlayout-padding ng-if=\"vm.moduleGroups[moduleKey].length>0\" ng-repeat=\"moduleKey in vm.getGroups()\"><strong \ntranslate=\"{{vm.getGroupHeader(moduleKey)}}\"></strong><div ng-repeat=\"module in vm.moduleGroups[moduleKey]\" \nlayout=\"row\" layout-align=\"start center\" class=\"m-0 p-0\"><md-switch \nng-if=\"vm.role.config[module.moduleType][module.moduleName]\" style=\"margin-top: 4px; margin-bottom: 4px\" \nng-click=\"vm.onChange(module)\" ng-if=\"vm.envConfig[module.moduleType][module.moduleName].enabled\" \nng-model=\"vm.role.config[module.moduleType][module.moduleName].enabled.value\"><span translate=\"{{module.name}}\"></span>\n</md-switch><md-switch ng-if=\"!vm.role.config[module.moduleType][module.moduleName]\" \nstyle=\"margin-top: 4px; margin-bottom: 4px\" ng-click=\"vm.onCreate(module)\" ng-model=\"true\" ;><span \ntranslate=\"{{module.name}}\"></span><md-icon class=\"s24\" md-font-icon=\"icon-home-variant\"></md-icon></md-switch></div>\n</div></div></div>");
$templateCache.put("app/main/system.sales/dialogs/logistics.add-table/logistics.add-table.html","<md-dialog aria-label=\"New Logistics\" id=\"system-color-dialog\"><form name=\"logisticsForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"SALES.LOGISTICS_ADD_TABLE\">\nLogistiktabelle hinzufügen</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p \ntranslate=\"SALES.LOGISTICS_TABLE_INFO\"></p><div layout=\"column\" layout-align=\"center start\"><md-input-container><label \ntranslate=\"APP.NAME\">Name</label><input ng-model=\"vm.table.name\" type=\"text\" aria-label=\"\" required>\n</md-input-container><md-checkbox ng-model=\"vm.table.weight\" ng-disabled=\"vm.table.prices\"><span \ntranslate=\"SALES.LOGISTICS_WEIGHT\">Gewicht</span></md-checkbox><md-checkbox ng-model=\"vm.table.lengths\" \nng-disabled=\"vm.table.prices\"><span translate=\"SALES.LOGISTICS_LENGTHS\">Längen</span></md-checkbox><md-checkbox \nng-model=\"vm.table.zips\" ng-disabled=\"vm.table.prices\"><span translate=\"SALES.LOGISTICS_ZIPS\">ZIPs</span></md-checkbox>\n<div class=\"mb-10 bt w-200\"></div><md-checkbox ng-model=\"vm.table.prices\" \nng-disabled=\"vm.table.weight || vm.table.lengths || vm.table.zips\"><span translate=\"SALES.LOGISTICS_PRICES\">Preise\n</span></md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\"><md-button class=\"md-warn\" type=\"reset\" \nng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button class=\"md-accent md-raised\" \ntype=\"submit\" ng-disabled=\"logisticsForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/system.sales/dialogs/raw-material-picker/raw-material-picker.html","<md-dialog aria-label=\"Pick raw material\" class=\"raw-material-picker-dialog\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"MATERIALS.GROUPS.ADD\">Werkstoff auswählen</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"min-width: 360px; max-height: 60vh\"><form name=\"vm.discountForm\" novalidate ng-model-options=\"{debounce:200}\" \nng-submit=\"vm.save()\" flex><div layout=\"row\" flex ng-if=\"vm.groups.length > 0\"><md-input-container flex class=\"mr-15\">\n<label translate=\"MATERIAL.GROUP\">Name</label><md-select ng-model=\"vm.group\" required><md-option \nng-repeat=\"rawMaterial in vm.groups\" ng-value=\"rawMaterial\">{{rawMaterial.label}}</md-option></md-select>\n</md-input-container></div></form><div ng-if=\"vm.groups.length === 0\" class=\"m-10\"><span \ntranslate=\"MATERIAL_GROUP.NO_FURTHER_AVAILABLE\"></span></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.cancel()\" aria-label=\"n\"><span \ntranslate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nng-disabled=\"!vm.discountForm.$valid || !vm.discountForm.$dirty\" ng-click=\"vm.pick()\" class=\"md-accent md-raised\"><span\n translate=\"APP.SAVE\">Save</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/system.sales/views/config/config.html","<div ng-if=\"vm.shopConfig\"><div class=\"mb-10\"></div><config-single ng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" \nuse-dot-notation=\"false\" key=\"sales.enabled\" type=\"4\" default-value=\"false\" show-default-value=\"true\" \nto-default-on-delete=\"true\" translation=\"SALES.ACTIVATE_PRICES_BACKEND\" search-term=\"vm.searchTerm\" \non-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><div class=\"mb-10\"></div><config-single \nng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.priceRound\" type=\"1\" \ndefault-value=\"0\" show-default-value=\"true\" to-default-on-delete=\"true\" \ntranslation=\"SYSTEM.SALES_PRICE_ROUNDING_FACTOR\" search-term=\"vm.searchTerm\" \non-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><div class=\"mb-10\"></div><config-single \nng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.profileRules.materialPrice\" type=\"2\" \ndefault-value=\"\" show-default-value=\"false\" to-default-on-delete=\"false\" \ntranslation=\"SYSTEM.SALES_FORMULA_MATERIAL_PRICE\" search-term=\"vm.searchTerm\" \non-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-single ng-if=\"vm.shopConfig\" \nconfig=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.profileRules.pricePerUnit\" type=\"2\" default-value=\"\" \nshow-default-value=\"false\" to-default-on-delete=\"false\" translation=\"SYSTEM.SALES_FORMULA_PRICE_PER_UNIT\" \nsearch-term=\"vm.searchTerm\" on-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-single \nng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.profileRules.priceForOne\" type=\"2\" \ndefault-value=\"\" show-default-value=\"false\" to-default-on-delete=\"false\" \ntranslation=\"SYSTEM.SALES_FORMULA_PRICE_FOR_ONE\" search-term=\"vm.searchTerm\" \non-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-single ng-if=\"vm.shopConfig\" \nconfig=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.profileRules.discount\" type=\"2\" default-value=\"\" \nshow-default-value=\"false\" to-default-on-delete=\"false\" translation=\"SYSTEM.SALES_FORMULA_DISCOUNT\" \nsearch-term=\"vm.searchTerm\" on-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-single \nng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.profileRules.price\" type=\"2\" \ndefault-value=\"\" show-default-value=\"false\" to-default-on-delete=\"false\" translation=\"SYSTEM.SALES_FORMULA_PRICE\" \nsearch-term=\"vm.searchTerm\" on-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-single \nng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.profileRules.materialCostPriceForOne\" \ntype=\"2\" default-value=\"\" show-default-value=\"false\" to-default-on-delete=\"false\" \ntranslation=\"SYSTEM.SALES_MATERIAL_COST_PRICE_FOR_ONE\" search-term=\"vm.searchTerm\" \non-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-single ng-if=\"vm.shopConfig\" \nconfig=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.profileRules.costPrice\" type=\"2\" default-value=\"\" \nshow-default-value=\"false\" to-default-on-delete=\"false\" translation=\"SYSTEM.SALES_COST_PRICE\" \nsearch-term=\"vm.searchTerm\" on-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-single \nng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.profileRules.prio\" type=\"2\" \ndefault-value=\"\" show-default-value=\"false\" to-default-on-delete=\"false\" translation=\"SYSTEM.SALES_FORMULA_PRIORITY\" \nsearch-term=\"vm.searchTerm\" on-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-single \nng-if=\"vm.shopConfig\" config=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.override.priceperunit\" type=\"4\" \ndefault-value=\"\" show-default-value=\"false\" to-default-on-delete=\"false\" \ntranslation=\"SYSTEM.SALES_OVERRIDE_PRICE_PER_UNIT\" search-term=\"vm.searchTerm\" \non-delete-config=\"vm.onDeleteShopConfigKey\"></config-single><config-single ng-if=\"vm.shopConfig\" \nconfig=\"vm.shopConfig\" use-dot-notation=\"false\" key=\"sales.logistics.tax\" type=\"4\" default-value=\"true\" \nshow-default-value=\"true\" to-default-on-delete=\"true\" translation=\"SALES.LOGISTICS_TAX\" search-term=\"vm.searchTerm\" \non-delete-config=\"vm.onDeleteShopConfigKey\"></config-single></div><config-editor whole-config=\"vm.config\" \ndefault-root=\"ims.sales\" default-name=\"SALES_SETTINGS\" controller=\"vm\"></config-editor>");
$templateCache.put("app/main/system.sales/views/partials/loading.html","<div class=\"content\" ng-if=\"vm.loading\" flex layout-fill><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div>");
$templateCache.put("app/main/system.sales/views/tabs/bending.html","<div layout=\"column\" layout-fill flex><ng-include ng-if=\"vm.loading\" layout-fill \nsrc=\"\'app/main/system.sales/views/partials/loading.html\'\"></ng-include><md-content ms-scroll ng-if=\"!vm.loading\" \nclass=\"m-10 md-whiteframe-1dp\"><div layout=\"column\" layout-padding><div layout=\"row\" layout-align=\"start center\" \nclass=\"raw-material-edge-tabs\"><md-tabs flex md-stretch-tabs=\"never\" md-no-pagination=\"false\" \nclass=\"raw-material-edge-md-tabs\"><md-tab md-active=\"!vm.isMaterialEdgeActive()\" md-on-select=\"vm.selectGeneralEdge()\">\n<md-tab-label><span translate=\"APP.GENERAL\">General</span><md-menu md-position-mode=\"target target\" md-offset=\"0 24\" \nng-if=\"!vm.isMaterialEdgeActive()\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\" class=\"s20 ml-8\" \nstyle=\"cursor:pointer\" ng-click=\"$event.stopPropagation();$mdMenu.open($event)\"></md-icon><md-menu-content>\n<md-menu-item><md-button ng-click=\"vm.duplicateGeneral()\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon>\n<span translate=\"APP.DUPLICATE\">Duplicate</span></md-button></md-menu-item></md-menu-content></md-menu></md-tab-label>\n</md-tab><md-tab ng-repeat=\"entry in vm.rawMaterialEdges | orderBy:vm.entrySortKey track by entry.id\" \nmd-active=\"vm.activeEntry === entry\" md-on-select=\"vm.selectMaterialEdge(entry)\"><md-tab-label>\n{{ vm.getRawMaterialName(entry.id) }}<md-menu md-position-mode=\"target target\" md-offset=\"0 34\" \nng-if=\"vm.activeEntry === entry\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\" class=\"s20 ml-8\" \nstyle=\"cursor:pointer\" ng-click=\"$event.stopPropagation();$mdMenu.open($event)\"></md-icon><md-menu-content>\n<md-menu-item><md-button ng-click=\"vm.duplicateEntry(entry)\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon>\n<span translate=\"APP.DUPLICATE\">Duplicate</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removeEntry(entry)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><span translate=\"APP.DELETE\">Delete\n</span></md-button></md-menu-item></md-menu-content></md-menu></md-tab-label></md-tab></md-tabs><md-button \nclass=\"md-raised md-icon-button\" flex=\"none\" ng-click=\"vm.addRawMaterialEdge()\" aria-label=\"Add raw material\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" layout-wrap layout-align=\"space-around center\">\n<table class=\"simple-table md-whiteframe-4dp\"><thead><tr><th class=\"text-center\" translate=\"SALES.BENDINGS\">Kantungen\n</th><th class=\"text-center\" translate=\"APP.PRICE\">Preis</th><th class=\"text-center\" translate=\"SALES.BENDINGS_LIMIT\">\n</th></tr></thead><tbody><tr ng-repeat=\"price in vm.bendingPrices|limitTo:15 track by $index\" \nng-class=\"{\'grey-300-bg\':!vm.isBendingPriceEditable($index)}\"><td><div class=\"text-center\">{{ $index + 1}}</div></td>\n<td><div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\"><input \nng-model=\"vm.bendingPrices[$index]\" nuit-unit-input=\"runningmeter\" invert=\"true\" \nng-disabled=\"!vm.isBendingPriceEditable($index)\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" type=\"number\" \naria-label=\"\" min=\"0.00\"><md-icon ng-class=\"{\'grey-500-fg\':!vm.isBendingPriceEditable($index)}\" style=\"top: 0\" \nmd-font-icon=\"{{vm.config.localization.currency.icon}}\"></md-icon></md-input-container></div></td><td><div \nlayout=\"row\" layout-align=\"center center\" \nng-if=\"vm.activeEdge.bendingPriceLimit < 0 || vm.activeEdge.bendingPriceLimit === $index\" \nng-click=\"vm.toggleBendingLimit($index)\"><md-icon class=\"h-20\" ng-if=\"vm.activeEdge.bendingPriceLimit !== $index\" \nmd-font-icon=\"icon-radiobox-blank\"></md-icon><md-icon class=\"h-20\" ng-if=\"vm.activeEdge.bendingPriceLimit === $index\" \nmd-font-icon=\"icon-radiobox-marked\"></md-icon></div></td></tr></tbody></table><table \nclass=\"simple-table md-whiteframe-4dp\"><thead><tr><th class=\"text-center\" translate=\"SALES.BENDINGS\">Kantungen</th><th \nclass=\"text-center\" translate=\"APP.PRICE\">Preis</th><th class=\"text-center\" translate=\"SALES.BENDINGS_LIMIT\"></th></tr>\n</thead><tbody><tr ng-repeat=\"price in vm.bendingPrices|limitTo:15:15 track by $index\" \nng-class=\"{\'grey-300-bg\':!vm.isBendingPriceEditable($index + 15)}\"><td><div class=\"text-center\">{{ $index + 16}}</div>\n</td><td><div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\"><input \nng-model=\"vm.bendingPrices[$index + 15]\" nuit-unit-input=\"runningmeter\" invert=\"true\" \nng-disabled=\"!vm.isBendingPriceEditable($index + 15)\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" type=\"number\" \naria-label=\"\" min=\"0.00\"><md-icon ng-class=\"{\'grey-500-fg\':!vm.isBendingPriceEditable($index + 15)}\" style=\"top: 0\" \nmd-font-icon=\"{{vm.config.localization.currency.icon}}\"></md-icon></md-input-container></div></td><td><div \nlayout=\"row\" layout-align=\"center center\" \nng-if=\"vm.activeEdge.bendingPriceLimit < 0 || vm.activeEdge.bendingPriceLimit === $index + 15\" \nng-click=\"vm.toggleBendingLimit($index + 15)\"><md-icon class=\"h-20\" \nng-if=\"vm.activeEdge.bendingPriceLimit !== $index + 15\" md-font-icon=\"icon-radiobox-blank\"></md-icon><md-icon \nclass=\"h-20\" ng-if=\"vm.activeEdge.bendingPriceLimit === $index + 15\" md-font-icon=\"icon-radiobox-marked\"></md-icon>\n</div></td></tr></tbody></table><table class=\"simple-table md-whiteframe-4dp\"><thead><tr><th class=\"text-center\" \ntranslate=\"SALES.BENDINGS\">Kantungen</th><th class=\"text-center\" translate=\"APP.PRICE\">Preis</th><th \nclass=\"text-center\" translate=\"SALES.BENDINGS_LIMIT\"></th></tr></thead><tbody><tr \nng-repeat=\"price in vm.bendingPrices|limitTo:15:30 track by $index\" \nng-class=\"{\'grey-300-bg\':!vm.isBendingPriceEditable($index + 30)}\"><td><div class=\"text-center\">{{ $index + 31}}</div>\n</td><td><div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\"><input \nng-model=\"vm.bendingPrices[$index + 30]\" nuit-unit-input=\"runningmeter\" invert=\"true\" \nng-disabled=\"!vm.isBendingPriceEditable($index + 30)\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" type=\"number\" \naria-label=\"\" min=\"0.00\"><md-icon ng-class=\"{\'grey-500-fg\':!vm.isBendingPriceEditable($index + 30)}\" style=\"top: 0\" \nmd-font-icon=\"{{vm.config.localization.currency.icon}}\"></md-icon></md-input-container></div></td><td><div \nlayout=\"row\" layout-align=\"center center\" \nng-if=\"vm.activeEdge.bendingPriceLimit < 0 || vm.activeEdge.bendingPriceLimit === $index + 30\" \nng-click=\"vm.toggleBendingLimit($index + 30)\"><md-icon class=\"h-20\" \nng-if=\"vm.activeEdge.bendingPriceLimit !== $index + 30\" md-font-icon=\"icon-radiobox-blank\"></md-icon><md-icon \nclass=\"h-20\" ng-if=\"vm.activeEdge.bendingPriceLimit === $index + 30\" md-font-icon=\"icon-radiobox-marked\"></md-icon>\n</div></td></tr></tbody></table><table class=\"simple-table md-whiteframe-4dp\"><thead><tr><th class=\"text-center\" \ntranslate=\"SALES.BENDINGS\">Kantungen</th><th class=\"text-center\" translate=\"APP.PRICE\">Preis</th><th \nclass=\"text-center\" translate=\"SALES.BENDINGS_LIMIT\"></th></tr></thead><tbody><tr \nng-repeat=\"price in vm.bendingPrices|limitTo:15:45 track by $index\" \nng-class=\"{\'grey-300-bg\':!vm.isBendingPriceEditable($index + 45)}\"><td><div class=\"text-center\">{{ $index + 46}}</div>\n</td><td><div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\"><input \nng-model=\"vm.bendingPrices[$index + 45]\" nuit-unit-input=\"runningmeter\" invert=\"true\" \nng-disabled=\"!vm.isBendingPriceEditable($index + 45)\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" type=\"number\" \naria-label=\"\" min=\"0.00\"><md-icon ng-class=\"{\'grey-500-fg\':!vm.isBendingPriceEditable($index + 45)}\" style=\"top: 0\" \nmd-font-icon=\"{{vm.config.localization.currency.icon}}\"></md-icon></md-input-container></div></td><td><div \nlayout=\"row\" layout-align=\"center center\" \nng-if=\"vm.activeEdge.bendingPriceLimit < 0 || vm.activeEdge.bendingPriceLimit === $index + 45\" \nng-click=\"vm.toggleBendingLimit($index + 45)\"><md-icon class=\"h-20\" \nng-if=\"vm.activeEdge.bendingPriceLimit !== $index + 45\" md-font-icon=\"icon-radiobox-blank\"></md-icon><md-icon \nclass=\"h-20\" ng-if=\"vm.activeEdge.bendingPriceLimit === $index + 45\" md-font-icon=\"icon-radiobox-marked\"></md-icon>\n</div></td></tr></tbody></table></div><div layout=\"row\" layout-wrap layout-padding><div layout=\"column\" flex><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"mr-25\" translate=\"SALES.FURTHER_BENDINGS\"></span>\n<md-input-container class=\"h-32\"><input ng-model=\"vm.activeEdge.bendingPricesLinear\" nuit-unit-input=\"runningmeter\" \ninvert=\"true\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" type=\"number\" aria-label=\"\" limit-min=\"0.00\"><md-icon \nstyle=\"top: 0\" md-font-icon=\"{{vm.config.localization.currency.icon}}\"></md-icon></md-input-container></div><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"mr-25\" translate=\"SALES.FIXED_WASTE\"></span><md-input-container \nclass=\"h-32\"><input ng-model=\"vm.activeEdge.fixedWaste\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" \ntype=\"number\" aria-label=\"\" step=\"0.01\" min=\"0.00\"><md-icon style=\"top: 0\" md-font-icon=\"icon-percent\"></md-icon>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.isMaterialEdgeActive()\">\n<md-checkbox class=\"md-primary\" ng-model=\"vm.shopConfig[\'sales.wrapCount\']\" ng-true-value=\"2\" ng-false-value=\"1\"><span \ntranslate=\"SALES.WRAP_COUNTS_TWICE\"></span></md-checkbox></div></div><div layout=\"column\" layout-padding flex><md-card>\n<h2 translate=\"SALES.BENDINGS.COST_PRICE\"></h2><div layout=\"row\" layout-align=\"start center\"><span class=\"mr-25\" \ntranslate=\"SALES.BENDINGS.EDGE_COST_PRICE_ABSOLUTE\"></span><md-input-container class=\"h-32\"><input \nng-model=\"vm.activeEdge.edgeCostPriceAbsolute\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" type=\"number\" \naria-label=\"\" step=\"0.01\" min=\"0.00\"><md-icon style=\"top: 0\" md-font-icon=\"{{vm.config.localization.currency.icon}}\">\n</md-icon></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><span class=\"mr-25\" \ntranslate=\"SALES.BENDINGS.EDGE_COST_PRICE_PERCENT\"></span><md-input-container class=\"h-32\"><input \nng-model=\"vm.activeEdge.edgeCostPricePercent\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" type=\"number\" \naria-label=\"\" step=\"0.01\" min=\"0.00\"><md-icon style=\"top: 0\" md-font-icon=\"icon-percent\"></md-icon>\n</md-input-container></div></md-card></div></div></div></md-content></div>");
$templateCache.put("app/main/system.sales/views/tabs/deductibles.html","<div layout=\"column\" layout-fill flex><ng-include ng-if=\"vm.loading\" layout-fill \nsrc=\"\'app/main/system.sales/views/partials/loading.html\'\"></ng-include><md-content ms-scroll ng-if=\"!vm.loading\" \nclass=\"m-10 md-whiteframe-1dp p-24\"><div layout=\"row\"><div layout=\"column\"><h3 \ntranslate=\"SYSTEM.SALES_QUANTITY_DISCOUNT\">Mengenrabatt</h3><table class=\"simple mr-16 mb-24 md-whiteframe-4dp\"><thead>\n<tr><th class=\"text-center\" translate=\"SALES.QUANTITY\">Menge</th><th class=\"text-center\" translate=\"APP.DISCOUNT\">\nRabatt</th><th class=\"w-80\"></th></tr></thead><tbody><tr ng-repeat=\"position in vm.discounts track by $index\"><td><div \nlayout=\"row\" layout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\"><input \nng-model=\"position.quantity\" style=\"text-align: center;top:0\" class=\"pb-0 pt-0\" type=\"number\" aria-label=\"\" step=\"1\" \nmin=\"0\"></md-input-container></div></td><td><div layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"mt-0 mb-0 pb-0 pt-0 h-20\"><input ng-model=\"position.value\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" \ntype=\"number\" aria-label=\"\" step=\"0.01\" max=\"100.00\" min=\"0.00\"><md-icon style=\"top: 0\" md-font-icon=\"icon-percent\">\n</md-icon></md-input-container></div></td><td><div layout=\"row\" layout-align=\"end center\"><md-button tabindex=\"-1\" \nclass=\"w-24 h-24 m-0\" style=\"border-radius:12px\" ng-click=\"vm.discounts.splice($index, 1)\"><md-tooltip \nmd-direction=\"bottom\"><span translate=\"APP.DELETE\">DELETE</span></md-tooltip><md-icon class=\"s16 red-500-fg\" \nstyle=\"position:absolute;left:4px;top:4px\" md-font-icon=\"icon-close\"></md-icon></md-button></div></td></tr><tr><td \ncolspan=\"3\"><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.discounts.push({quantity: 0, value: 0.00})\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</td></tr></tbody></table></div><div layout=\"column\" class=\"ml-15\"><h3 translate=\"SALES.SPECIAL_DISCOUNTS\"></h3><table \nclass=\"simple mr-16 mb-24 md-whiteframe-4dp\"><thead><tr><th class=\"text-center\"><span translate=\"PROFILE.LENGTH\">Länge\n</span>&nbsp;({{ ::vm.nuitUnits(\'length\').symbol}})</th><th class=\"text-center\"><span translate=\"PROFILE.BLANK\">\nZuschnitt</span>&nbsp;({{ ::vm.nuitUnits(\'length\').symbol}})</th><th class=\"text-center\"><span \ntranslate=\"PROFILE.THICKNESS\">Dicke</span>&nbsp;({{ ::vm.nuitUnits(\'thickness\').symbol}})</th><th class=\"text-center\">\n<span translate=\"APP.DISCOUNT\">Rabatt</span>&nbsp;(%)</th><th class=\"w-80\"></th></tr></thead><tbody><tr \nng-repeat=\"discount in vm.edgeDiscounts track by $index\"><td><div layout=\"row\" layout-align=\"center center\"><md-menu>\n<md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span>{{ discount.length.comparator}}\n</span></md-button><md-menu-content><md-menu-item><md-button ng-click=\"discount.length.comparator = \'>\'\"><span>&gt;\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"discount.length.comparator = \'>=\'\"><span>&gt;=\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"discount.length.comparator = \'<\'\"><span>&lt;\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"discount.length.comparator = \'<=\'\"><span>&lt;=\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"discount.length.comparator = \'=\'\"><span>=</span>\n</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"discount.length.comparator = \'X\';discount.length.value = null\"><span>X</span></md-button></md-menu-item>\n</md-menu-content></md-menu><div layout=\"row\" layout-align=\"center center\" ng-if=\"discount.length.comparator !== \'X\'\">\n<md-input-container class=\"h-20\"><input ng-model=\"discount.length.value\" ng-required=\"true\" nuit-unit-input=\"length\" \nstyle=\"text-align: center;top:0\" class=\"pb-0 pt-0\" type=\"number\" aria-label=\"\" min=\"0\"></md-input-container></div>\n</div></td><td><div layout=\"row\" layout-align=\"center center\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span>{{ discount.blank.comparator}}</span></md-button><md-menu-content><md-menu-item>\n<md-button ng-click=\"discount.blank.comparator = \'>\'\"><span>&gt;</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"discount.blank.comparator = \'>=\'\"><span>&gt;=</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"discount.blank.comparator = \'<\'\"><span>&lt;</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"discount.blank.comparator = \'<=\'\"><span>&lt;=</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"discount.blank.comparator = \'=\'\"><span>=</span></md-button></md-menu-item><md-menu-item><md-button\n ng-click=\"discount.blank.comparator = \'X\';discount.blank.value = null\"><span>X</span></md-button></md-menu-item>\n</md-menu-content></md-menu><div layout=\"row\" layout-align=\"center center\" ng-if=\"discount.blank.comparator !== \'X\'\">\n<md-input-container class=\"h-20\"><input ng-model=\"discount.blank.value\" ng-required=\"true\" nuit-unit-input=\"length\" \nstyle=\"text-align: center;top:0\" class=\"pb-0 pt-0\" type=\"number\" aria-label=\"\" min=\"0\"></md-input-container></div>\n</div></td><td><div layout=\"row\" layout-align=\"center center\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span>{{ discount.materialThickness.comparator}}</span></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"discount.materialThickness.comparator = \'>\'\"><span>&gt;</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"discount.materialThickness.comparator = \'>=\'\"><span>&gt;=</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"discount.materialThickness.comparator = \'<\'\"><span>&lt;\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"discount.materialThickness.comparator = \'<=\'\">\n<span>&lt;=</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"discount.materialThickness.comparator = \'=\'\"><span>=</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"discount.materialThickness.comparator = \'X\';discount.materialThickness.value = null\"><span>X\n</span></md-button></md-menu-item></md-menu-content></md-menu><div layout=\"row\" layout-align=\"center center\" \nng-if=\"discount.materialThickness.comparator !== \'X\'\"><md-input-container class=\"h-20\"><input \nng-model=\"discount.materialThickness.value\" ng-required=\"true\" nuit-unit-input=\"thickness\" \nstyle=\"text-align: center;top:0\" class=\"pb-0 pt-0\" type=\"number\" aria-label=\"\" min=\"0\"></md-input-container></div>\n</div></td><td><div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\">\n<input ng-model=\"discount.percent\" ng-required=\"true\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" type=\"number\" \naria-label=\"\" step=\"0.01\" max=\"100.00\" min=\"0.00\"></md-input-container></div></td><td><div layout=\"row\" \nlayout-align=\"end center\"><md-button tabindex=\"-1\" class=\"w-24 h-24 m-0\" style=\"border-radius:12px\" \nng-click=\"vm.edgeDiscounts.splice($index, 1)\"><md-tooltip md-direction=\"bottom\"><span translate=\"APP.DELETE\">DELETE\n</span></md-tooltip><md-icon class=\"s16 red-500-fg\" style=\"position:absolute;left:4px;top:4px\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></td></tr><tr><td colspan=\"5\"><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.edgeDiscounts.push({length: {comparator: \'X\'}, blank: {comparator: \'X\'}, materialThickness: {comparator: \'X\'}, percent: 0})\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></td></tr></tbody></table></div></div></md-content></div>");
$templateCache.put("app/main/system.sales/views/tabs/fixedTimePrices.html","<div layout=\"column\" layout-fill flex><div class=\"content\" ng-if=\"vm.loading\" flex layout-fill><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content \nms-scroll ng-if=\"!vm.loading\" class=\"m-10 p-10 md-whiteframe-1dp\"><table class=\"dataTable border\" \nstyle=\"max-width:460px;text-align: start\"><thead><tr><th translate=\"FIXED_TIME.TOLERANCE\"></th><th \ntranslate=\"FIXED_TIME.PRICE\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"price in vm.surcharge.fixedTime\"><td><div\n layout=\"row\" layout-align=\"start start\"><md-input-container class=\"m-0\"><input style=\"text-align: right\" \ntype=\"number\" ng-model=\"price.tolerance\"></md-input-container><span class=\"mt-10\">h</span></div></td><td>\n<md-input-container class=\"m-0\"><input style=\"text-align: right\" type=\"number\" ng-model=\"price.price\">\n</md-input-container><md-icon style=\"margin-top: 10px;vertical-align: top\" \nmd-font-icon=\"{{vm.config.localization.currency.icon}}\"></md-icon></td><td style=\"width:30px\"><md-button \nstyle=\"margin-left: 0\" class=\"md-icon-button mr-16\" ng-click=\"vm.surcharge.fixedTime.splice($index,1);\"><md-icon \nmd-font-icon=\"icon-trash\"><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-icon></md-button>\n</td></tr><tr><td colspan=\"3\"><div layout=\"row\"><md-button style=\"margin-left: 0\" class=\"md-icon-button mr-16\" \nng-click=\"vm.surcharge.fixedTime.push({price:0, tolerance: 0});\" flex><md-icon md-font-icon=\"icon-plus\"><md-tooltip>\n<span translate=\"APP.ADD\">Add</span></md-tooltip></md-icon></md-button></div></td></tr></tbody></table></md-content>\n</div>");
$templateCache.put("app/main/system.sales/views/tabs/general.html","<div layout=\"column\" layout-fill flex><ng-include ng-if=\"vm.loading\" layout-fill \nsrc=\"\'app/main/system.sales/views/partials/loading.html\'\"></ng-include><md-content ms-scroll ng-if=\"!vm.loading\" \nclass=\"m-10 md-whiteframe-1dp\"><div layout=\"column\"><div layout=\"row\" layout-wrap layout-margin><div layout=\"column\" \nlayout-margin flex=\"100\"><h2 translate=\"SYSTEM.SALES_ORDER\">Bestellungen</h2><md-input-container><label \ntranslate=\"SYSTEM.SALES_MIN_VALUE\">Mindestbestellwert</label><input ng-model=\"vm.shopConfig[\'sales.minPrice\']\" \ntype=\"number\" aria-label=\"\" step=\"0.01\" min=\"0.00\"><md-icon style=\"top: 0\" \nmd-font-icon=\"{{vm.config.localization.currency.icon}}\"></md-icon></md-input-container><md-input-container><label \ntranslate=\"SYSTEM.ORDER_FEE\">Auftragspauschale</label><input ng-model=\"vm.shopConfig[\'sales.orderFee\']\" type=\"number\" \naria-label=\"\" step=\"0.01\" min=\"0.00\"><md-icon style=\"top: 0\" md-font-icon=\"{{vm.config.localization.currency.icon}}\">\n</md-icon></md-input-container><md-input-container><label translate=\"ORDERS.SALES.VATPERCENT\">VAT</label><input \nng-model=\"vm.shopConfig[\'sales.vat\']\" type=\"number\" aria-label=\"\" step=\"0.01\" min=\"0.00\"><md-icon style=\"top: 0\" \nmd-font-icon=\"icon-percent\"></md-icon></md-input-container><md-input-container><label translate=\"CART.SHIPPING_TYPE\">\n</label><md-select ng-model=\"vm.shopConfig[\'default.shippingType\']\" class=\"m-0\" flex><md-option \nng-value=\"shippingType\" ng-repeat=\"shippingType in vm.shippingTypes\"><span>\n{{(\'CART.DELIVERY_TYPE.\' + shippingType.toUpperCase()) | translate}}</span></md-option></md-select>\n</md-input-container></div></div></div></md-content></div>");
$templateCache.put("app/main/system.sales/views/tabs/logistics.html","<div layout=\"column\" layout-fill flex><ng-include ng-if=\"vm.loading\" layout-fill \nsrc=\"\'app/main/system.sales/views/partials/loading.html\'\"></ng-include><md-content ms-scroll ng-if=\"!vm.loading\" \nclass=\"m-10 md-whiteframe-1dp\"><div layout=\"column\"><md-toolbar class=\"md-accent md-whiteframe-4dp md-hue-3\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-accent white-fg\" \nng-click=\"vm.showAddLogisticsTableDialog()\"><span translate=\"SALES.LOGISTICS_ADD_TABLE\">ADD TABLE</span></md-button>\n</div></md-toolbar><div layout=\"row\" layout-wrap layout-padding><span ng-if=\"vm.logisticTables.length < 1\" \ntranslate=\"SALES.NO_LOGISTIC_TABLES_FOUND\"></span><div layout=\"column\" \nng-repeat=\"table in vm.logisticTables track by $index\"><div layout=\"row\" layout-align=\"space-between center\"><h3 \nclass=\"text-truncate\" ng-if=\"table._edit !== true\">{{ table.name }}&nbsp;#{{$index+1}}</h3><md-input-container \nclass=\"pv-0 mv-0\" ng-if=\"table._edit === true\"><label translate=\"APP.NAME\">Name</label><input ng-model=\"table.name\" \ntype=\"text\" aria-label=\"\" required></md-input-container><div layout=\"row\" layout-align=\"center center\"><md-button \nstyle=\"margin: 0;padding-right: 0;padding-left: 0\" class=\"md-icon-button\" ng-click=\"vm.toggleEditTable(table)\"><md-icon\n md-font-icon=\"icon-pencil\"><md-tooltip><span translate=\"APP.EDIT_ALL\">Edit All</span></md-tooltip></md-icon>\n</md-button><md-button style=\"margin-left: 0\" class=\"md-icon-button mr-16\" ng-click=\"vm.deleteTable($index)\"><md-icon \nmd-font-icon=\"icon-trash\"><md-tooltip><span translate=\"APP.DELETE\">Delete</span></md-tooltip></md-icon></md-button>\n</div></div><table class=\"logistics-table mr-16 mb-24 md-whiteframe-4dp text-center\" \nng-if=\"table.prices === undefined || table.prices === null\"><tbody><tr \nng-if=\"table.weight !== undefined && table.weight !== null\"><td colspan=\"{{ vm.getLogisticsTableColumnCount(table) }}\">\n<md-icon md-font-icon=\"icon-weight\" class=\"mr-15 red-400-fg\"><md-tooltip><span translate=\"PROFILE.WEIGHT\">Weight</span>\n</md-tooltip></md-icon><md-menu ng-if=\"table.weight._edit === true\"><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span>{{ table.weight.comparator }}</span></md-button><md-menu-content><md-menu-item>\n<md-button ng-click=\"table.weight.comparator = \'>\'\"><span>&gt;</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"table.weight.comparator = \'>=\'\"><span>&gt;=</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"table.weight.comparator = \'<\'\"><span>&lt;</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"table.weight.comparator = \'<=\'\"><span>&lt;=</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"table.weight.comparator = \'=\'\"><span>=</span></md-button></md-menu-item></md-menu-content>\n</md-menu><span ng-if=\"table.weight._edit !== true\">{{ table.weight.comparator }}</span> <span \nng-if=\"table.weight._edit !== true\">{{ table.weight.value | nuitUnit:\'weight\' }}</span><md-input-container \nng-if=\"table.weight._edit === true\" class=\"m-0 w-80\"><label translate=\"APP.VALUE\">Wert</label><input type=\"number\" \nclass=\"text-right\" nuit-unit-input=\"weight\" ng-model=\"table.weight.value\" required></md-input-container><span \nng-if=\"table.weight._edit === true\">{{vm.config.units.weight.symbol}}</span><md-icon class=\"grey-400-fg ml-10\" \nng-if=\"table.weight._edit !== true\" md-font-icon=\"icon-pencil\" ng-click=\"table.weight._edit = !table.weight._edit\">\n<md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-icon><md-icon ng-if=\"table.weight._edit === true\" \nmd-font-icon=\"icon-close\" ng-click=\"table.weight._edit = !table.weight._edit\" class=\"ml-10\"><md-tooltip><span \ntranslate=\"APP.SAVE\"></span></md-tooltip></md-icon></td><td ng-if=\"table.lengths.length > 0\"></td></tr><tr \nng-if=\"table.lengths.length > 0\"><td ng-if=\"table.zips.length > 0\"><span translate=\"ADDRESS.ZIP\">ZIP</span></td><td \nng-repeat=\"length in table.lengths track by $index\"><md-icon md-font-icon=\"icon-ruler\" class=\"mr-15 green-400-fg\">\n<md-tooltip><span translate=\"PROFILE.LENGTH\"></span></md-tooltip></md-icon><md-menu ng-if=\"length._edit === true\">\n<md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span>{{ length.comparator }}</span>\n</md-button><md-menu-content><md-menu-item><md-button ng-click=\"length.comparator = \'>\'\"><span>&gt;</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"length.comparator = \'>=\'\"><span>&gt;=</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"length.comparator = \'<\'\"><span>&lt;</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"length.comparator = \'<=\'\"><span>&lt;=</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"length.comparator = \'=\'\"><span>=</span></md-button></md-menu-item></md-menu-content>\n</md-menu><span ng-if=\"length._edit !== true\">{{ length.comparator }}</span> <span ng-if=\"length._edit !== true\">\n{{ length.value | nuitUnit:\'length\' }}</span><md-input-container ng-if=\"length._edit === true\" class=\"m-0 w-80\"><label \ntranslate=\"APP.VALUE\">Wert</label><input type=\"number\" nuit-unit-input=\"length\" ng-model=\"length.value\" required>\n</md-input-container><md-icon class=\"grey-400-fg ml-10\" ng-if=\"length._edit !== true\" md-font-icon=\"icon-pencil\" \nng-click=\"length._edit = !length._edit\"><md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-icon><md-icon \nng-if=\"length._edit === true\" md-font-icon=\"icon-close\" ng-click=\"length._edit = !length._edit\" class=\"ml-10\">\n<md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-icon></td><td class=\"white-bg\" \nrowspan=\"{{ (table.lengths.length > 0 ? 1 : 0) + table.data.length }}\" ng-if=\"table.lengths.length > 0\"><div \nlayout=\"column\"><md-button class=\"md-icon-button\" ng-click=\"vm.addLogisticsColumn(table)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeLogisticsColumn(table)\"><md-icon md-font-icon=\"icon-minus\"></md-icon></md-button></div></td></tr><tr\n ng-repeat=\"data in table.data track by $index\"><td ng-if=\"table.zips.length > 0 && table.zips[$index] !== undefined\" \nlayout=\"row\" layout-align=\"end start\"><span ng-if=\"table.zips[$index]._edit !== true\">\n{{ (table.zips[$index].country?table.zips[$index].country:\'\') + (table.zips[$index].value?table.zips[$index].value:\'*\') }}\n</span><md-input-container ng-if=\"table.zips[$index]._edit === true\" class=\"m-0 pb-20\"><label \ntranslate=\"ADDRESS.COUNTRY\">Land</label><md-select ng-model=\"table.zips[$index].country\"><md-option \nng-value=\"undefined\" translate=\"APP.ALL\"></md-option><md-option ng-repeat=\"country in vm.countries\" \nng-value=\"country.code\">{{country.name}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"table.zips[$index]._edit === true\" class=\"m-0 w-80\"><label translate=\"APP.VALUE\">Wert</label><input type=\"text\" \nng-model=\"table.zips[$index].value\" ng-required=\"vm.config.ims.sales.logistics.zip.required\" md-maxlength=\"10\">\n</md-input-container><md-icon class=\"grey-400-fg ml-10\" ng-if=\"table.zips[$index]._edit !== true\" \nmd-font-icon=\"icon-pencil\" ng-click=\"table.zips[$index]._edit = !table.zips[$index]._edit\"><md-tooltip><span \ntranslate=\"APP.EDIT\"></span></md-tooltip></md-icon><md-icon ng-if=\"table.zips[$index]._edit === true\" \nmd-font-icon=\"icon-close\" ng-click=\"table.zips[$index]._edit = !table.zips[$index]._edit\" class=\"ml-10\"><md-tooltip>\n<span translate=\"APP.EDIT\"></span></md-tooltip></md-icon></td><td \nng-class=\"{\'green-100-bg\': vm.activeRules.indexOf(entry) >= 0}\" ng-repeat=\"entry in data track by $index\"><div \nlayout=\"row\" layout-align=\"center center\"><div><md-menu ng-if=\"entry._edit === true\"><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span ng-if=\"entry.operator === \'=\'\">=</span> <span \nng-if=\"entry.operator === \'+\'\">+</span> <span ng-if=\"entry.operator === \'-\'\">-</span></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"entry.operator = \'=\'\"><span>=</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"entry.operator = \'+\'\"><span>+</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"entry.operator = \'-\'\"><span>-</span></md-button></md-menu-item></md-menu-content></md-menu><span \nng-if=\"entry.operator === \'+\' && entry._edit !== true\" style=\"font-size: 1.2em\">+</span> <span \nng-if=\"entry.operator === \'-\' && entry._edit !== true\" style=\"font-size: 1.2em\">-</span></div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"noshrink\"><md-input-container ng-if=\"entry._edit === true\" \nclass=\"mt-0 mb-0 pb-0 pt-0 h-20 w-80\"><label translate=\"APP.VALUE\">Wert</label><input type=\"number\" class=\"text-right\" \nmin=\"0\" step=\"0.01\" ng-model=\"entry.value\" required></md-input-container><span ng-if=\"entry._edit !== true\">\n{{ entry.value | number: 2 }}</span><md-menu ng-if=\"entry._edit === true\"><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span ng-if=\"entry.type === \'c\'\">{{ vm.config.localization.currency.symbol }}</span> \n<span ng-if=\"entry.type === \'%\'\">%</span></md-button><md-menu-content><md-menu-item><md-button \nng-click=\"entry.type = \'c\'\"><span>{{ vm.config.localization.currency.symbol }}</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"entry.type = \'%\'\"><span>%</span></md-button></md-menu-item></md-menu-content>\n</md-menu><span ng-if=\"entry._edit !== true && entry.type === \'c\'\">{{ vm.config.localization.currency.symbol }}</span> \n<span ng-if=\"entry._edit !== true && entry.type === \'%\'\">%</span></div><div layout=\"row\" layout-align=\"end center\">\n<md-icon style=\"margin-right: 0\" class=\"grey-400-fg ml-10\" ng-if=\"entry._edit !== true\" md-font-icon=\"icon-pencil\" \nng-click=\"entry._edit = !entry._edit\"><md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-icon><md-icon \nstyle=\"margin-right: 0\" ng-if=\"entry._edit === true\" md-font-icon=\"icon-close\" ng-click=\"entry._edit = !entry._edit\" \nclass=\"ml-10\"><md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-icon></div></div></td></tr><tr \nng-if=\"table.zips.length > 0\"><td class=\"white-bg\" colspan=\"{{ vm.getLogisticsTableColumnCount(table) }}\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.addLogisticsRow(table)\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.removeLogisticsRow(table)\"><md-icon md-font-icon=\"icon-minus\"></md-icon>\n</md-button></td><td class=\"white-bg\" ng-if=\"table.lengths.length > 0\"></td></tr></tbody></table><table \nclass=\"logistics-table mr-16 mb-24 md-whiteframe-4dp text-center\" \nng-if=\"table.prices !== undefined && table.prices !== null\"><tbody><tr ng-repeat=\"data in table.data track by $index\">\n<td ng-class=\"{\'green-100-bg\': vm.activeRules.indexOf(data) >= 0}\"><md-icon md-font-icon=\"icon-cart-outline\" \nclass=\"mr-15 blue-400-fg\"><md-tooltip><span translate=\"CART.PRICE_MIN\"></span></md-tooltip></md-icon><md-menu \nng-if=\"table.prices[$index].min._edit === true\"><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span>{{ table.prices[$index].min.comparator }}</span></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"table.prices[$index].min.comparator = \'>\'\"><span>&gt;</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"table.prices[$index].min.comparator = \'>=\'\"><span>&gt;=</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"table.prices[$index].min.comparator = \'<\'\"><span>&lt;\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"table.prices[$index].min.comparator = \'<=\'\"><span>\n&lt;=</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"table.prices[$index].min.comparator = \'=\'\">\n<span>=</span></md-button></md-menu-item></md-menu-content></md-menu><span \nng-if=\"table.prices[$index].min._edit !== true\">{{ table.prices[$index].min.comparator }}</span> <span \nng-if=\"table.prices[$index].min._edit !== true\">{{ table.prices[$index].min.value | nuitCurrency }}</span>\n<md-input-container ng-if=\"table.prices[$index].min._edit === true\" class=\"m-0 w-80\"><label translate=\"APP.VALUE\">Wert\n</label><input type=\"number\" ng-model=\"table.prices[$index].min.value\" required></md-input-container><md-icon \nclass=\"grey-400-fg ml-10\" ng-if=\"table.prices[$index].min._edit !== true\" md-font-icon=\"icon-pencil\" \nng-click=\"table.prices[$index].min._edit = !table.prices[$index].min._edit\"><md-tooltip><span translate=\"APP.EDIT\">\n</span></md-tooltip></md-icon><md-icon ng-if=\"table.prices[$index].min._edit === true\" md-font-icon=\"icon-close\" \nng-click=\"table.prices[$index].min._edit = !table.prices[$index].min._edit\" class=\"ml-10\"><md-tooltip><span \ntranslate=\"APP.EDIT\"></span></md-tooltip></md-icon></td><td \nng-class=\"{\'green-100-bg\': vm.activeRules.indexOf(data) >= 0}\"><md-icon md-font-icon=\"icon-cart\" \nclass=\"mr-15 blue-400-fg\"><md-tooltip><span translate=\"CART.PRICE_MAX\"></span></md-tooltip></md-icon><md-menu \nng-if=\"table.prices[$index].max._edit === true\"><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span>{{ table.prices[$index].max.comparator }}</span></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"table.prices[$index].max.comparator = \'>\'\"><span>&gt;</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"table.prices[$index].max.comparator = \'>=\'\"><span>&gt;=</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"table.prices[$index].max.comparator = \'<\'\"><span>&lt;\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"table.prices[$index].max.comparator = \'<=\'\"><span>\n&lt;=</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"table.prices[$index].max.comparator = \'=\'\">\n<span>=</span></md-button></md-menu-item></md-menu-content></md-menu><span \nng-if=\"table.prices[$index].max._edit !== true\">{{ table.prices[$index].max.comparator }}</span> <span \nng-if=\"table.prices[$index].max._edit !== true\">{{ table.prices[$index].max.value | nuitCurrency }}</span>\n<md-input-container ng-if=\"table.prices[$index].max._edit === true\" class=\"m-0 w-80\"><label translate=\"APP.VALUE\">Wert\n</label><input type=\"number\" ng-model=\"table.prices[$index].max.value\" required></md-input-container><md-icon \nclass=\"grey-400-fg ml-10\" ng-if=\"table.prices[$index].max._edit !== true\" md-font-icon=\"icon-pencil\" \nng-click=\"table.prices[$index].max._edit = !table.prices[$index].max._edit\"><md-tooltip><span translate=\"APP.EDIT\">\n</span></md-tooltip></md-icon><md-icon ng-if=\"table.prices[$index].max._edit === true\" md-font-icon=\"icon-close\" \nng-click=\"table.prices[$index].max._edit = !table.prices[$index].max._edit\" class=\"ml-10\"><md-tooltip><span \ntranslate=\"APP.EDIT\"></span></md-tooltip></md-icon></td><td \nng-class=\"{\'green-100-bg\': vm.activeRules.indexOf(data) >= 0}\" ng-repeat=\"entry in data track by $index\"><div \nlayout=\"row\" layout-align=\"center center\"><div><md-menu ng-if=\"entry._edit === true\"><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span ng-if=\"entry.operator === \'=\'\">=</span> <span \nng-if=\"entry.operator === \'+\'\">+</span> <span ng-if=\"entry.operator === \'-\'\">-</span></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"entry.operator = \'=\'\"><span>=</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"entry.operator = \'+\'\"><span>+</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"entry.operator = \'-\'\"><span>-</span></md-button></md-menu-item></md-menu-content></md-menu><span \nng-if=\"entry.operator === \'+\' && entry._edit !== true\" style=\"font-size: 1.2em\">+</span> <span \nng-if=\"entry.operator === \'-\' && entry._edit !== true\" style=\"font-size: 1.2em\">-</span></div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"noshrink\"><md-input-container ng-if=\"entry._edit === true\" \nclass=\"mt-0 mb-0 pb-0 pt-0 h-20 w-80\"><label translate=\"APP.VALUE\">Wert</label><input type=\"number\" class=\"text-right\" \nmin=\"0\" step=\"0.01\" ng-model=\"entry.value\" required></md-input-container><span ng-if=\"entry._edit !== true\">\n{{ entry.value | number: 2 }}</span><md-menu ng-if=\"entry._edit === true\"><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span ng-if=\"entry.type === \'c\'\">{{ vm.config.localization.currency.symbol }}</span> \n<span ng-if=\"entry.type === \'%\'\">%</span></md-button><md-menu-content><md-menu-item><md-button \nng-click=\"entry.type = \'c\'\"><span>{{ vm.config.localization.currency.symbol }}</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"entry.type = \'%\'\"><span>%</span></md-button></md-menu-item></md-menu-content>\n</md-menu><span ng-if=\"entry._edit !== true && entry.type === \'c\'\">{{ vm.config.localization.currency.symbol }}</span> \n<span ng-if=\"entry._edit !== true && entry.type === \'%\'\">%</span></div><div layout=\"row\" layout-align=\"end center\">\n<md-icon style=\"margin-right: 0\" class=\"grey-400-fg ml-10\" ng-if=\"entry._edit !== true\" md-font-icon=\"icon-pencil\" \nng-click=\"entry._edit = !entry._edit\"><md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-icon><md-icon \nstyle=\"margin-right: 0\" ng-if=\"entry._edit === true\" md-font-icon=\"icon-close\" ng-click=\"entry._edit = !entry._edit\" \nclass=\"ml-10\"><md-tooltip><span translate=\"APP.EDIT\"></span></md-tooltip></md-icon></div></div></td></tr><tr><td \nclass=\"white-bg\" colspan=\"3\"><md-button class=\"md-icon-button\" ng-click=\"vm.addLogisticsRow(table)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeLogisticsRow(table)\"><md-icon md-font-icon=\"icon-minus\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div layout=\"row\" layout-wrap layout-padding ng-if=\"vm.logisticTables.length > 0\"><div \nlayout=\"column\"><h1 translate=\"SALES.LOGISTICS_PREVIEW\">Kontrolle</h1><div layout=\"row\"><div layout=\"column\" \nclass=\"mr-10\"><md-sidenav class=\"sidenav main-sidenav md-white-bg md-whiteframe-1dp\" ms-scroll \nmd-is-locked-open=\"true\" layout=\"column\" md-component-id=\"sidenav\" ms-sidenav-helper><div ms-scroll \nclass=\"content scrollable\"><md-list><md-list-item ng-class=\"{\'fuse-paleblue-50-bg\':vm.currentSubMenu === \'testing\'}\" \naria-label=\"n\" ng-click=\"vm.currentSubMenu = \'testing\'\"><md-icon md-font-icon=\"icon-clipboard-check\"></md-icon><p \ntranslate=\"SALES.LOGISTICS_TESTING\">Testdaten</p></md-list-item></md-list></div></md-sidenav></div><div \nclass=\"md-whiteframe-1dp\" layout=\"column\" layout-padding layout-align=\"start start\"><div layout=\"column\" layout-margin>\n<md-input-container><label><span translate=\"APP.WEIGHT\">Weight</span>&nbsp;({{ vm.config.units.weight.symbol }})\n</label><input type=\"number\" class=\"text-right\" min=\"0\" ng-model=\"vm.testWeight\" nuit-unit-input=\"weight\">\n</md-input-container><md-input-container><label><span translate=\"APP.LENGTH\">Length</span>\n&nbsp;({{ vm.config.units.length.symbol }})</label><input type=\"number\" class=\"text-right\" min=\"0\" \nng-model=\"vm.testLength\" nuit-unit-input=\"length\"></md-input-container><md-input-container><label translate=\"APP.ZIP\">\nZIP</label><input type=\"text\" ng-model=\"vm.testZIP\"></md-input-container><md-input-container><label><span \ntranslate=\"CART.PRICE\"></span>&nbsp;({{ vm.config.localization.currency.symbol }})</label><input type=\"number\" \nclass=\"text-right\" min=\"0\" ng-model=\"vm.testPrice\"></md-input-container><p class=\"text-center font-size-20\">\n{{ vm.getLogisticsTestPrice() | nuitCurrency }}</p></div></div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/system.sales/views/tabs/products.html","<div layout=\"column\" layout-fill flex><ng-include ng-if=\"vm.loading\" layout-fill \nsrc=\"\'app/main/system.sales/views/partials/loading.html\'\"></ng-include><md-content ms-scroll ng-if=\"!vm.loading\" \nclass=\"m-10 md-whiteframe-1dp\"><div layout=\"column\"><div layout=\"row\" layout-align=\"none top\" layout-wrap><div \nlayout=\"column\" layout-align=\"start top\" flex=\"noshrink\"><div layout=\"row\" layout-align=\"start top\" layout-margin \nclass=\"secondary-text mt-16\"><md-icon md-font-icon=\"icon-chart-areaspline\" class=\"mr-8\"></md-icon><span \nclass=\"md-title\" flex translate=\"PRODUCT.ADVANCED_PRICE_CALCULATION\">Erweiterte Preisberechnung</span></div><div \nlayout=\"column\" layout-margin><table class=\"simple mr-16 mb-100 md-whiteframe-4dp\"><thead><tr><th class=\"text-center\" \ntranslate=\"PRODUCT.SALES_RULE_TYPE\"></th><th class=\"text-center\" translate=\"PRODUCT.SALES_RULE_OPTIONS\"></th><th \nclass=\"text-center\" translate=\"PRODUCT.SALES_RULE_FACTOR\"></th><th class=\"text-center\" \ntranslate=\"PRODUCT.SALES_RULE_LIMIT\"></th><th class=\"text-center\"></th></tr></thead><tbody><tr \nng-class=\"{\'orange-200-bg\':vm.editedPriceRule === rule}\" ng-repeat=\"rule in vm.salesRules\"><td>\n{{ vm.ruleTypeToKey(rule.type) | translate }}</td><td><div layout=\"row\" layout-align=\"center center\"><span \nng-if=\"rule.type === \'attribute\'\">{{ vm.getAttributeById(rule.attributeId).name | nuitTranslate }}</span> <span \nng-if=\"rule.type === \'combination\'\">\n{{ (vm.getAttributeById(rule.lhAttributeId).name | nuitTranslate) + \', \' + (vm.getAttributeById(rule.rhAttributeId).name | nuitTranslate) }}\n</span> <span ng-if=\"rule.type === \'productdata\'\">{{ vm.getProductPropertyKey(rule.property) | translate }}</span>\n</div></td><td><span>\n{{ rule.priceModifier}}&nbsp;{{ rule.priceModifierValue.toFixed(2) + vm.priceModifierTypeToSymbol(rule.priceModifierType) }}\n</span><br><span style=\"white-space: pre-line\">\n{{ (vm.getComparatorKey(rule) | translate) + \' \' + vm.getRuleConditionDisplayValue(rule) }}<span \nng-if=\"rule.conditionStart !== undefined\">&nbsp;(>= {{ rule.conditionStart }})</span></span></td><td><span \nng-if=\"rule.priceModifierMin !== undefined\">\n{{ rule.priceModifier}}&nbsp;{{ rule.priceModifierMin}}&nbsp;{{ rule.priceModifierType}}</span><br><span \nng-if=\"rule.priceModifierMax !== undefined\">\n{{ rule.priceModifier}}&nbsp;{{ rule.priceModifierMax}}&nbsp;{{ rule.priceModifierType}}</span></td><td><div \nlayout=\"row\"><md-button ng-disabled=\"$first\" class=\"md-icon-button\" ng-click=\"vm.movePriceRule($index, -1)\"><md-icon \nmd-font-icon=\"icon-arrow-up\"></md-icon></md-button><md-button ng-disabled=\"$last\" class=\"md-icon-button\" \nng-click=\"vm.movePriceRule($index, 1)\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.editPriceRule($index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.deletePriceRule($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><div layout=\"row\" layout-align=\"center center\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span translate=\"{{vm.ruleTypeToKey(vm.salesRule.type)}}\"></span>\n<md-icon class=\"grey-300-fg\" ng-if=\"vm.salesRule.type === undefined\" md-font-icon=\"icon-cursor-pointer\"></md-icon>\n</md-button><md-menu-content><md-menu-item ng-repeat=\"ruletype in vm.priceRuleTypes\"><md-button \nng-click=\"vm.salesRule.type = ruletype.value\"><span translate=\"{{::ruletype.key}}\"></span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></td><td><ng-include \nsrc=\"\'app/main/system.sales/views/partials/sales/sales_rule_options.html\'\"></ng-include></td><td><ng-include \nsrc=\"\'app/main/system.sales/views/partials/sales/sales_rule_values.html\'\"></ng-include></td><td><ng-include \nsrc=\"\'app/main/system.sales/views/partials/sales/sales_rule_limits.html\'\"></ng-include></td><td><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-if=\"vm.editedPriceRule === undefined\" \nng-disabled=\"!vm.isRuleValid()\" ng-click=\"vm.createPriceRule()\"><span translate=\"APP.ADD\">Hinzufügen</span></md-button>\n<md-button class=\"md-primary md-raised\" ng-if=\"vm.editedPriceRule !== undefined\" ng-disabled=\"!vm.isRuleValid()\" \nng-click=\"vm.createPriceRule()\"><span translate=\"APP.EDIT\">Bearbeiten</span></md-button><md-button \nclass=\"md-primary md-raised\" ng-if=\"vm.editedPriceRule !== undefined\" ng-click=\"vm.resetRule()\"><span \ntranslate=\"APP.CANCEL\">Abbrechen</span></md-button></div></td></tr></tbody></table></div></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/system.sales/views/tabs/specials.html","<div layout=\"column\" layout-fill flex><ng-include ng-if=\"vm.loading\" layout-fill \nsrc=\"\'app/main/system.sales/views/partials/loading.html\'\"></ng-include><md-content ms-scroll ng-if=\"!vm.loading\" \nclass=\"m-10 md-whiteframe-1dp\"><div layout=\"column\"><div layout=\"column\" layout-margin><div layout=\"row\" \nlayout-align=\"start top\" layout-margin class=\"secondary-text mt-16\"><md-icon md-font-icon=\"icon-cog\" class=\"mr-8\">\n</md-icon><span class=\"md-title\" flex translate=\"SYSTEM.SALES_SPECIAL_PRICES\">Erweiterte Preisberechnung</span>\n<md-input-container ng-if=\"vm.config.languages.length > 1\"><label translate=\"APP.LANG\">Language</label><md-select \nng-model=\"vm.selectedLanguage\"><md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span \nclass=\"text-uppercase\">{{ ::lang }}</span></md-option></md-select></md-input-container></div><table \nclass=\"specials-table mr-16 mb-24 md-whiteframe-4dp\"><thead><tr><th class=\"text-center\" style=\"min-width: 100px\" \ntranslate=\"SALES.SPECIAL_ID\">Bezeichnung</th><th class=\"text-center\" style=\"min-width: 150px\" \ntranslate=\"SALES.SPECIAL_NAME\">Bezeichnung</th><th class=\"text-center\" translate=\"SALES.SPECIAL_IMAGE\">Bild</th><th \nclass=\"text-center\" translate=\"SALES.SPECIAL_DESCRIPTION\">Beschreibung</th><th class=\"text-center\"><span \ntranslate=\"SALES.SPECIAL_PRICE\">Preis</span>&nbsp;(<span>{{vm.config.localization.currency.symbol}}</span>)</th><th \nclass=\"text-center\"><span translate=\"SALES.SPECIAL_PRICE_RUNNINGMETER\">Preis / LFM</span>&nbsp;(<span>\n{{ vm.config.localization.currency.symbol + \'/\' + vm.nuitUnits(\'runningmeter\').symbol }}</span>)</th><th \nclass=\"text-center\"><span translate=\"SALES.SPECIAL_PRICE_AREA\">Preis / LFM</span>&nbsp;(<span>\n{{ vm.config.localization.currency.symbol + \'/\' + vm.nuitUnits(\'area\').symbol }}</span>)</th><th class=\"text-center\" \ntranslate=\"SALES.SPECIAL_REMOVABLE\">Bezeichnung</th><th class=\"text-center\" translate=\"SALES.SPECIAL_SELECTABLE\">\nBezeichnung</th><th class=\"w-80\"></th></tr></thead><tbody><tr ng-repeat=\"special in vm.specials track by $index\"><td>\n<div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\" flex><input \nng-model=\"special.id\" style=\"top:0\" class=\"pb-0 pt-0\" type=\"text\" aria-label=\"\"></md-input-container></div></td><td>\n<div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\" flex><input \nng-model=\"special.name[vm.selectedLanguage]\" style=\"top:0\" class=\"pb-0 pt-0\" type=\"text\" aria-label=\"\">\n</md-input-container></div></td><td><div layout=\"column\" layout-align=\"center center\"><img class=\"w-50 h-50\" \nng-if=\"special.img\" http-src=\"{{special.img}}\"><md-button ng-if=\"!special.img\" \nng-click=\"vm.addImageToSpecial(special)\"><label translate=\"APP.ADD\"></label></md-button><md-button ng-if=\"special.img\" \nng-click=\"special.img = null\"><label translate=\"APP.DELETE\"></label></md-button></div></td><td style=\"width:50%\"><div \nlayout=\"row\" layout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\" flex><input \nng-model=\"special.description[vm.selectedLanguage]\" style=\"top:0\" class=\"pb-0 pt-0\" type=\"text\" aria-label=\"\">\n</md-input-container></div></td><td><div layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"mt-0 mb-0 pb-0 pt-0 h-20\"><input ng-model=\"special.price\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" \ntype=\"number\" step=\"0.01\" aria-label=\"\"></md-input-container></div></td><td><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\"><input \nng-model=\"special.pricePerUnit\" style=\"text-align: right;top:0\" nuit-unit-input=\"perLengthUnitConversion\" \ninvert=\"true\" class=\"pb-0 pt-0\" type=\"number\" aria-label=\"\"></md-input-container></div></td><td><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\"><input \nng-model=\"special.pricePerArea\" style=\"text-align: right;top:0\" nuit-unit-input=\"area\" invert=\"true\" class=\"pb-0 pt-0\" \ntype=\"number\" aria-label=\"\"></md-input-container></div></td><td><div layout=\"row\" layout-align=\"center center\">\n<md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\" flex><md-checkbox ng-model=\"special.removable\" style=\"top:0\" \nclass=\"pb-0 pt-0\" type=\"text\" aria-label=\"\"></md-checkbox></md-input-container></div></td><td><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\" flex><md-checkbox \nng-model=\"special.selectable\" style=\"top:0\" class=\"pb-0 pt-0\" type=\"text\" aria-label=\"\"></md-checkbox>\n</md-input-container></div></td><td><div layout=\"row\" layout-align=\"center center\"><md-button \nng-style=\"{\'opacity\': $first ? 0.2 : 1.0 }\" ng-disabled=\"$first\" class=\"md-icon-button\" \nng-click=\"vm.moveSpecial($index, -1)\"><md-icon md-font-icon=\"icon-arrow-up\"></md-icon></md-button><md-button \nng-style=\"{\'opacity\': $last ? 0.2 : 1.0 }\" ng-disabled=\"$last\" class=\"md-icon-button\" \nng-click=\"vm.moveSpecial($index, 1)\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.removeSpecial($index)\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"APP.DELETE\">DELETE</span></md-tooltip><md-icon class=\"red-500-fg\" md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr class=\"white-bg\"><td colspan=\"8\"><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-icon-button\" \nng-click=\"vm.specials.push({id:\'\', img: null,name: {}, description: {}, price: 0.0, pricePerUnit: 0.0, removable: true, selectable: true})\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></td></tr></tbody></table></div></div></md-content></div>");
$templateCache.put("app/main/system.sales/views/tabs/surcharges.html","<div layout=\"column\" layout-fill flex><ng-include ng-if=\"vm.loading\" layout-fill \nsrc=\"\'app/main/system.sales/views/partials/loading.html\'\"></ng-include><md-content ms-scroll ng-if=\"!vm.loading\" \nclass=\"m-10 md-whiteframe-1dp p-24\"><div layout=\"row\"><div layout=\"column\"><table \nclass=\"simple mr-16 mb-24 md-whiteframe-4dp\"><thead><tr><th class=\"text-center\"><span translate=\"PROFILE.LENGTH\">Länge\n</span>&nbsp;({{ ::vm.nuitUnits(\'length\').symbol}})</th><th class=\"text-center\"><span translate=\"PROFILE.BLANK\">\nZuschnitt</span>&nbsp;({{ ::vm.nuitUnits(\'length\').symbol}})</th><th class=\"text-center\"><span \ntranslate=\"PROFILE.THICKNESS\">Dicke</span>&nbsp;({{ ::vm.nuitUnits(\'thickness\').symbol}})</th><th class=\"text-center\">\n<span translate=\"SYSTEM.SALES_SURCHARGE\">Rabatt</span>&nbsp;(%)</th><th class=\"text-center\"><span \ntranslate=\"SYSTEM.SALES_SURCHARGE_ABSOLUTE\">Absolut</span> ({{vm.config.localization.currency.symbol}})</th><th \nclass=\"w-80\"></th></tr></thead><tbody><tr ng-repeat=\"surcharge in vm.edgeSurcharge track by $index\"><td><div \nlayout=\"row\" layout-align=\"center center\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span>{{ surcharge.length.comparator}}</span></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"surcharge.length.comparator = \'>\'\"><span>&gt;</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"surcharge.length.comparator = \'>=\'\"><span>&gt;=</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"surcharge.length.comparator = \'<\'\"><span>&lt;</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"surcharge.length.comparator = \'<=\'\"><span>&lt;=</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"surcharge.length.comparator = \'=\'\"><span>=</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"surcharge.length.comparator = \'X\';surcharge.length.value = null\"><span>X</span>\n</md-button></md-menu-item></md-menu-content></md-menu><div layout=\"row\" layout-align=\"center center\" \nng-if=\"surcharge.length.comparator !== \'X\'\"><md-input-container class=\"h-20\"><input ng-model=\"surcharge.length.value\" \nng-required=\"true\" nuit-unit-input=\"length\" style=\"text-align: center;top:0\" class=\"pb-0 pt-0\" type=\"number\" \naria-label=\"\" min=\"0\"></md-input-container></div></div></td><td><div layout=\"row\" layout-align=\"center center\">\n<md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span>\n{{ surcharge.blank.comparator}}</span></md-button><md-menu-content><md-menu-item><md-button \nng-click=\"surcharge.blank.comparator = \'>\'\"><span>&gt;</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"surcharge.blank.comparator = \'>=\'\"><span>&gt;=</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"surcharge.blank.comparator = \'<\'\"><span>&lt;</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"surcharge.blank.comparator = \'<=\'\"><span>&lt;=</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"surcharge.blank.comparator = \'=\'\"><span>=</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"surcharge.blank.comparator = \'X\';surcharge.blank.value = null\"><span>X</span></md-button></md-menu-item>\n</md-menu-content></md-menu><div layout=\"row\" layout-align=\"center center\" ng-if=\"surcharge.blank.comparator !== \'X\'\">\n<md-input-container class=\"h-20\"><input ng-model=\"surcharge.blank.value\" ng-required=\"true\" nuit-unit-input=\"length\" \nstyle=\"text-align: center;top:0\" class=\"pb-0 pt-0\" type=\"number\" aria-label=\"\" min=\"0\"></md-input-container></div>\n</div></td><td><div layout=\"row\" layout-align=\"center center\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span>{{ surcharge.materialThickness.comparator}}</span></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"surcharge.materialThickness.comparator = \'>\'\"><span>&gt;</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"surcharge.materialThickness.comparator = \'>=\'\"><span>&gt;=</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"surcharge.materialThickness.comparator = \'<\'\"><span>&lt;\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"surcharge.materialThickness.comparator = \'<=\'\">\n<span>&lt;=</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"surcharge.materialThickness.comparator = \'=\'\"><span>=</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"surcharge.materialThickness.comparator = \'X\';surcharge.materialThickness.value = null\"><span>X\n</span></md-button></md-menu-item></md-menu-content></md-menu><div layout=\"row\" layout-align=\"center center\" \nng-if=\"surcharge.materialThickness.comparator !== \'X\'\"><md-input-container class=\"h-20\"><input \nng-model=\"surcharge.materialThickness.value\" ng-required=\"true\" nuit-unit-input=\"thickness\" \nstyle=\"text-align: center;top:0\" class=\"pb-0 pt-0\" type=\"number\" aria-label=\"\" min=\"0\"></md-input-container></div>\n</div></td><td><div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\">\n<input ng-model=\"surcharge.percent\" ng-required=\"true\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" type=\"number\" \naria-label=\"\" step=\"0.01\" max=\"100.00\" min=\"0.00\"></md-input-container></div></td><td><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container class=\"mt-0 mb-0 pb-0 pt-0 h-20\"><input ng-model=\"surcharge.absolute\" \nng-required=\"true\" style=\"text-align: right;top:0\" class=\"pb-0 pt-0\" type=\"number\" aria-label=\"\"></md-input-container>\n</div></td><td><div layout=\"row\" layout-align=\"end center\"><md-button tabindex=\"-1\" class=\"w-24 h-24 m-0\" \nstyle=\"border-radius:12px\" ng-click=\"vm.edgeSurcharge.splice($index, 1)\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"APP.DELETE\">DELETE</span></md-tooltip><md-icon class=\"s16 red-500-fg\" \nstyle=\"position:absolute;left:4px;top:4px\" md-font-icon=\"icon-close\"></md-icon></md-button></div></td></tr><tr><td \ncolspan=\"5\"><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.edgeSurcharge.push({length: {comparator: \'X\'}, blank: {comparator: \'X\'}, materialThickness: {comparator: \'X\'}, percent: 0, absolute: 0})\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></td></tr></tbody></table></div></div></md-content></div>");
$templateCache.put("app/main/system.system/dialogs/cart.edit-field/cart.edit-field.html","<md-dialog aria-label=\"New Color\" id=\"system-color-dialog\"><form name=\"fieldForm\" ng-submit=\"vm.submit()\" novalidate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-if=\"!vm.newField\" translate=\"APP.EDIT\">Edit</span> <span \nclass=\"title\" ng-if=\"vm.newField\" translate=\"CART.ADD_FIELD\">Neues Feld</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"column\"><div layout=\"row\"><md-input-container flex=\"85\"><label translate=\"CART.FIELD.NAME\">\nBezeichnung</label><input type=\"text\" name=\"name\" ng-model=\"vm.field.name[vm.currentLanguage]\" md-maxlength=\"100\" \nrequired><div ng-messages=\"fieldForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container><md-input-container flex=\"15\"><label \ntranslate=\"APP.LANGUAGE\">Lang</label><md-select ng-model=\"vm.currentLanguage\"><md-option \nng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\"><label \ntranslate=\"CART.FIELD.ID\">Identifier</label><input type=\"text\" name=\"id\" ng-model=\"vm.field.id\" md-maxlength=\"32\" \nrequired><div ng-messages=\"fieldForm.id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container><md-input-container flex-offset=\"10\" \nflex=\"40\"><label translate=\"CART.FIELD.REGEX\">Regex</label><input type=\"text\" name=\"regex\" ng-model=\"vm.field.regex\" \nmd-maxlength=\"24\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"30\"><label \ntranslate=\"CART.FIELD.MIN_LENGTH\">Min. length</label><input type=\"number\" min=\"0\" max=\"9999\" name=\"minlength\" \nng-model=\"vm.field.minlength\"></md-input-container><md-input-container flex-offset=\"5\" flex=\"30\"><label \ntranslate=\"CART.FIELD.MAX_LENGTH\">Max. Length</label><input type=\"number\" min=\"0\" max=\"9999\" name=\"maxlength\" \nng-model=\"vm.field.maxlength\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"30\"><md-checkbox \nng-model=\"vm.field.required\" aria-label=\"Required\"><span translate=\"CART.FIELD.REQUIRED\"></span></md-checkbox>\n</md-input-container></div><h3>Disable Condition</h3><config-editor-read-only-conditions value=\"vm.field.conditions\" \nactive=\"true\"></config-editor-read-only-conditions></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\"><md-button \nclass=\"md-warn\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nclass=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"fieldForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/system.system/dialogs/color/color.edit.html","<md-dialog aria-label=\"New Color\" id=\"system-color-dialog\"><form name=\"colorForm\" ng-submit=\"vm.submit()\" novalidate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-if=\"!vm.newColor\" translate=\"APP.EDIT\">Edit</span> <span \nclass=\"title\" ng-if=\"vm.newColor\" translate=\"COLORS.ADD_COLOR\">Neue Farbe</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"row\" layout-align=\"space-betweeen center\"><div layout=\"row\" layout-wrap \nlayout-align=\"start top\" flex><md-input-container flex=\"85\"><label translate=\"COLOR.NAME\">Bezeichnung</label><input \ntype=\"text\" name=\"name\" ng-model=\"vm.color.name[vm.currentLanguage]\" md-maxlength=\"100\" \nng-disabled=\"!vm.currentLanguage\" required><div ng-messages=\"colorForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container>\n<md-input-container flex=\"15\"><label translate=\"APP.LANGUAGE\">Lang</label><md-select ng-model=\"vm.currentLanguage\">\n<md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span>\n</md-option></md-select></md-input-container><md-input-container flex=\"33\"><label translate=\"COLOR.CODE\">Code</label>\n<input type=\"text\" name=\"code\" ng-model=\"vm.color.code\" md-maxlength=\"20\"></md-input-container><md-input-container \nflex=\"33\"><label translate=\"COLOR.HEX\">Code</label><input type=\"text\" name=\"code\" ng-model=\"vm.color.hex\" \nmd-maxlength=\"7\" ng-change=\"vm.setRgb()\" ng-model-options=\"{ updateOn: \'blur\', debounce: 50 }\"></md-input-container>\n<md-input-container flex=\"33\"><label translate=\"COLOR.EXTERNAL_ID\">Code</label><input type=\"text\" name=\"externalId\" \nng-model=\"vm.color.externalId\"></md-input-container></div><div class=\"color-preview\" \nstyle=\"background-color: rgb({{vm.color.value.r}}, {{vm.color.value.g}}, {{vm.color.value.b}})\"></div></div>\n<md-slider-container layout=\"row\"><span>R</span><md-slider flex min=\"0\" max=\"255\" ng-model=\"vm.color.value.r\" \naria-label=\"red\" ng-change=\"vm.setHex()\"></md-slider><md-input-container><input type=\"number\" \nng-model=\"vm.color.value.r\" aria-label=\"red\"></md-input-container></md-slider-container><md-slider-container><span>G\n</span><md-slider flex min=\"0\" max=\"255\" ng-model=\"vm.color.value.g\" aria-label=\"green\" ng-change=\"vm.setHex()\">\n</md-slider><md-input-container><input type=\"number\" ng-model=\"vm.color.value.g\" aria-label=\"green\">\n</md-input-container></md-slider-container><md-slider-container><span>B</span><md-slider flex min=\"0\" max=\"255\" \nng-model=\"vm.color.value.b\" aria-label=\"blue\" ng-change=\"vm.setHex()\"></md-slider><md-input-container><input \ntype=\"number\" ng-model=\"vm.color.value.b\" aria-label=\"blue\"></md-input-container></md-slider-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\"><md-button class=\"md-warn\" type=\"reset\" ng-click=\"vm.cancel()\">\n<span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"colorForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/system.system/dialogs/material.edit-filter/material.edit-filter.html","<md-dialog aria-label=\"New Filter\" id=\"system-filter-dialog\"><form name=\"filterForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-if=\"!vm.newFilter\" translate=\"APP.EDIT\">Edit</span> <span \nclass=\"title\" ng-if=\"vm.newFilter\" translate=\"PRODUCTS.ADD_FILTER\">Neuer Filter</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\"><md-input-container flex><label \ntranslate=\"APP.FILTER_TYPE\">Filter-Type</label><md-select ng-model=\"vm.selectedFilter\" \nng-change=\"vm.onFilterChanged()\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"attribute in vm.attributes\" ng-value=\"attribute\"><span>{{ attribute.name | nuitTranslate }}</span>\n</md-option></md-select></md-input-container><md-input-container><label translate=\"APP.FILTER_USE_COMPARATOR\"></label>\n<md-switch ng-model=\"vm.selectedFilter.useComparator\"></md-switch></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n</div><div layout=\"row\"><md-button class=\"md-warn\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">\nCancel</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"filterForm.$invalid\"><span \ntranslate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/system.system/dialogs/products.edit-filter/products.edit-filter.html","<md-dialog aria-label=\"New Filter\" id=\"system-filter-dialog\"><form name=\"filterForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-if=\"!vm.newFilter\" translate=\"APP.EDIT\">Edit</span> <span \nclass=\"title\" ng-if=\"vm.newFilter\" translate=\"PRODUCTS.ADD_FILTER\">Neuer Filter</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\"><div layout=\"row\"><md-input-container flex><label \ntranslate=\"APP.FILTER_TYPE\">Filter-Type</label><md-select ng-model=\"vm.selectedFilter\" \nng-change=\"vm.onFilterChanged()\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-optgroup \nlabel=\"{{ \'FILTERS.ATTRIBUTES\' | translate }}\"><md-option ng-repeat=\"attribute in vm.attributes\" ng-value=\"attribute\">\n<span>{{ attribute.name | nuitTranslate }}</span></md-option></md-optgroup><md-optgroup \nlabel=\"{{ \'FILTERS.GENERIC\' | translate }}\"><md-option \nng-value=\"{id: \'mg\', name:\'APP.MATERIALGROUP\', type:\'generic_materialgroup\', options: { showMaterialsOnSelect: false }}\">\n<span translate=\"APP.MATERIALGROUP\"></span></md-option><md-option ng-disabled=\"vm.colors.length <= 0\" \nng-value=\"{id: \'clr\', name:\'APP.COLOR\', type:\'generic_colors\', options: { restrictions: [], blacklist: true }}\"><span \ntranslate=\"APP.COLOR\"></span></md-option></md-optgroup></md-select></md-input-container></div><div \nng-if=\"vm.selectedFilter.type === \'generic_materialgroup\'\"><md-checkbox \nng-model=\"vm.selectedFilter.options.showMaterialsOnSelect\"><span translate=\"FILTER.SHOW_MATERIALS_ON_SELECT\"></span>\n</md-checkbox></div><div ng-if=\"vm.selectedFilter.type === \'generic_colors\' && vm.colors.length > 0\" layout=\"column\">\n<md-input-container><label translate=\"APP.COLORS\">Colors</label><md-select \nmd-selected-text=\"\'{{ vm.selectedFilter.options.restrictions.length }} {{ \'FILTER.COLORS_SELECTED\' | translate }}\'\" \nng-model=\"vm.selectedFilter.options.restrictions\" multiple=\"multiple\"><md-option ng-value=\"color.id\" \nng-repeat=\"color in vm.colors track by color.id\">{{color.name | nuitTranslate}}</md-option></md-select>\n</md-input-container></div><div ng-if=\"vm.selectedFilter.type === \'generic_colors\' && vm.colors.length > 0\">\n<md-checkbox ng-model=\"vm.selectedFilter.options.blacklist\"><span translate=\"FILTER.BLACKLIST\"></span></md-checkbox>\n</div><div ng-if=\"vm.selectedFilter.type === \'enum\'\" layout=\"column\"><md-checkbox \nng-model=\"vm.filter.restrictedOptions\"><span translate=\"FILTER.RESTRICT_OPTIONS\"></span></md-checkbox>\n<md-input-container ng-if=\"vm.attributes.length>0 && vm.selectedOptions.length>0 && vm.filter.restrictedOptions\"><label\n translate=\"APP.OPTIONS\">Filter-Type</label><md-select ng-model=\"vm.selectedOptions\" multiple=\"multiple\" \nng-model-options=\"{trackBy: \'$value\'}\"><md-option ng-value=\"option\" \nng-repeat=\"option in vm.selectedFilter.restrictions.options track by option\">{{option}}</md-option></md-select>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\"><md-button \nclass=\"md-warn\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nclass=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"filterForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/system.system/dialogs/profiles.edit-folder/profiles.edit-folder.html","<md-dialog><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 flex translate=\"FOLDERS.ADD\">Ordner hinzufügen\n</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"position:relative\"><div class=\"md-dialog-content\"><div \nlayout=\"column\"><div layout=\"row\" ng-repeat=\"lang in vm.languages\"><md-input-container flex><label \nclass=\"w-100 text-uppercase\">{{ lang }}</label><input type=\"text\" name=\"name[{{lang}}]\" \nng-model=\"vm.folder.name[lang]\" ng-required=\"lang === vm.currLang\"></md-input-container></div><md-input-container \nng-if=\"!vm.folder.child\"><label translate=\"APP.PARENT\">Parent</label><md-select ng-model=\"vm.folder.parentId\">\n<md-option ng-value=\"undefined\"><em>---</em></md-option><md-option ng-repeat=\"folder in vm.folders track by $index\" \nng-value=\"folder.id\">{{folder.name?(folder.name | nuitTranslate:\'???\'):\'???\'}}</md-option></md-select>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.save()\" class=\"md-warn md-raised\"><span translate=\"APP.SAVE\">Speichern</span></md-button>\n<md-button ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Abbrechen</span></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/system.system/dialogs/stamping.edit-generator/stamping.edit-generator.html","<md-dialog aria-label=\"New Color\" id=\"system-color-dialog\"><form name=\"stampingForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-if=\"!vm.newTool\" translate=\"APP.EDIT\">Edit</span> <span \nclass=\"title\" ng-if=\"vm.newTool\" translate=\"STAMPING.ADD_TOOL\">Neues Werkzeug</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"column\"><div layout=\"row\"><md-input-container flex=\"85\" class=\"mb-0\"><label \ntranslate=\"STAMPING.DIST_NAME\">Bezeichnung</label><input type=\"text\" name=\"name\" \nng-model=\"vm.generator.name[vm.currentLanguage]\" md-maxlength=\"100\" required><div \nng-messages=\"stampingForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">\nRequired</span></div></div></md-input-container><md-input-container flex=\"15\" ng-if=\"vm.availableLanguages.length > 1\" \nclass=\"mb-0\"><label translate=\"APP.LANGUAGE\">Lang</label><md-select ng-model=\"vm.currentLanguage\"><md-option \nng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select></md-input-container></div></div><div layout=\"column\"><p translate=\"STAMPING.GENERATOR_ATTACHMENT\">\nAttached to</p><md-radio-group ng-model=\"vm.generator.attachedTo\" required><md-radio-button value=\"top\"><span \ntranslate=\"STAMPING.TOP_EDGE\">Top</span></md-radio-button><md-radio-button value=\"bottom\"><span \ntranslate=\"STAMPING.BOTTOM_EDGE\">Bottom</span></md-radio-button></md-radio-group></div><div layout=\"row\">\n<md-input-container flex=\"85\" class=\"mb-0\"><label translate=\"STAMPING.DIST_TO_EDGE\">Bezeichnung</label><input \ntype=\"text\" name=\"name\" ng-model=\"vm.generator.nameDist[vm.currentLanguage]\" md-maxlength=\"100\" required><div \nng-messages=\"stampingForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">\nRequired</span></div></div></md-input-container><md-input-container flex=\"15\" ng-if=\"vm.availableLanguages.length > 1\" \nclass=\"mb-0\"><label translate=\"APP.LANGUAGE\">Lang</label><md-select ng-model=\"vm.currentLanguage\"><md-option \nng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select></md-input-container></div><div layout=\"row\"><div layout=\"column\" flex><p \ntranslate=\"STAMPING.RESTRICTIONS\">Restrictions</p><md-radio-group ng-model=\"vm.generator.restrictionsDist.type\" \nrequired><md-radio-button value=\"none\"><span translate=\"STAMPING.NONE\">None</span></md-radio-button><md-radio-button \nvalue=\"locked\"><span translate=\"STAMPING.LOCKED\">Locked</span></md-radio-button><md-radio-button value=\"limit\"><span \ntranslate=\"STAMPING.LIMIT\">Limit</span></md-radio-button></md-radio-group></div><div layout=\"column\" flex \nng-if=\"vm.generator.restrictionsDist.type === \'locked\'\"><md-input-container flex=\"45\" class=\"mb-0\"><label \ntranslate=\"APP.VALUE\">Value</label><input type=\"number\" min=\"0\" max=\"99999\" name=\"value\" \nng-model=\"vm.generator.restrictionsDist.value\" required nuit-unit-input=\"length\"></md-input-container></div><div \nlayout=\"column\" flex ng-if=\"vm.generator.restrictionsDist.type === \'limit\'\"><md-input-container flex class=\"mb-0\">\n<label translate=\"APP.MIN\">Min.</label><input type=\"number\" min=\"0\" max=\"99999\" name=\"min\" \nng-model=\"vm.generator.restrictionsDist.min\" required nuit-unit-input=\"length\"></md-input-container><md-input-container\n flex class=\"mb-0\"><label translate=\"APP.MAX\">Max.</label><input type=\"number\" min=\"0\" max=\"99999\" name=\"max\" \nng-model=\"vm.generator.restrictionsDist.max\" required nuit-unit-input=\"length\"></md-input-container></div></div><div \nlayout=\"row\" ng-if=\"vm.limitDist\"></div><div layout=\"row\"><md-input-container flex=\"85\" class=\"mb-0\"><label \ntranslate=\"STAMPING.DIST_FIRST\">Bezeichnung</label><input type=\"text\" name=\"name\" \nng-model=\"vm.generator.nameDistFirst[vm.currentLanguage]\" md-maxlength=\"100\" required><div \nng-messages=\"stampingForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">\nRequired</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"45\" class=\"mb-0\">\n<label translate=\"APP.MIN\">Min.</label><input type=\"number\" min=\"0\" max=\"99999\" name=\"distDistMin\" \nng-model=\"vm.generator.distFirstMin\" nuit-unit-input=\"length\"></md-input-container><md-input-container \nflex-offset=\"10\" flex=\"45\" class=\"mb-0\"><label translate=\"APP.MAX\">Max.</label><input type=\"number\" min=\"0\" \nmax=\"99999\" name=\"distDistMax\" ng-model=\"vm.generator.distFirstMax\" nuit-unit-input=\"length\"></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"85\" class=\"mb-0\"><label translate=\"STAMPING.DIST_BETWEEN\">Bezeichnung\n</label><input type=\"text\" name=\"name\" ng-model=\"vm.generator.nameDistBetween[vm.currentLanguage]\" md-maxlength=\"100\" \nrequired><div ng-messages=\"stampingForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"45\" class=\"mb-0\"><label translate=\"APP.MIN\">Min.</label><input type=\"number\" min=\"0\" \nmax=\"99999\" name=\"distBetweenMin\" ng-model=\"vm.generator.distBetweenMin\" nuit-unit-input=\"length\"></md-input-container>\n<md-input-container flex-offset=\"10\" flex=\"45\" class=\"mb-0\"><label translate=\"APP.MAX\">Max.</label><input \ntype=\"number\" min=\"0\" max=\"99999\" name=\"distBetweenMax\" ng-model=\"vm.generator.distBetweenMax\" \nnuit-unit-input=\"length\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"85\" class=\"mb-0\"><label\n translate=\"STAMPING.DIST_LAST\">Bezeichnung</label><input type=\"text\" name=\"name\" \nng-model=\"vm.generator.nameDistLast[vm.currentLanguage]\" md-maxlength=\"100\" required><div \nng-messages=\"stampingForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">\nRequired</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"45\" class=\"mb-0\">\n<label translate=\"APP.MIN\">Min.</label><input type=\"number\" min=\"0\" max=\"99999\" name=\"distLastMin\" \nng-model=\"vm.generator.distLastMin\" nuit-unit-input=\"length\"></md-input-container><md-input-container flex-offset=\"10\" \nflex=\"45\" class=\"mb-0\"><label translate=\"APP.MAX\">Max.</label><input type=\"number\" min=\"0\" max=\"99999\" \nname=\"distLastMax\" ng-model=\"vm.generator.distLastMax\" nuit-unit-input=\"length\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex class=\"mb-0\"><label translate=\"STAMPING.ALLOWED_TOOLS\">Form</label><md-select \nng-model=\"vm.generator.tools\" multiple=\"multiple\"><md-option ng-repeat=\"tool in vm.tools\" ng-value=\"tool.id\"><span \nclass=\"text-uppercase\">&nbsp;{{tool.name[vm.userLanguage]}}</span></md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\"><md-button class=\"md-warn\" type=\"reset\" ng-click=\"vm.cancel()\">\n<span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"stampingForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/system.system/dialogs/stamping.edit-tool/stamping.edit-tool.html","<md-dialog aria-label=\"New Color\" id=\"system-color-dialog\"><form name=\"toolForm\" ng-submit=\"vm.submit()\" novalidate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-if=\"!vm.newTool\" translate=\"APP.EDIT\">Edit</span> <span \nclass=\"title\" ng-if=\"vm.newTool\" translate=\"STAMPING.ADD_TOOL\">Neues Werkzeug</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"column\"><div layout=\"row\"><md-input-container flex><label translate=\"APP.NAME\">Bezeichnung\n</label><input type=\"text\" name=\"name\" ng-model=\"vm.tool.name[vm.currentLanguage]\" md-maxlength=\"100\" required><div \nng-messages=\"toolForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP.REQUIRED_FIELD\">\nRequired</span></div></div></md-input-container><md-input-container flex=\"15\" ng-if=\"vm.availableLanguages.length > 1\">\n<label translate=\"APP.LANGUAGE\">Lang</label><md-select ng-model=\"vm.currentLanguage\"><md-option \nng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\"><label \ntranslate=\"STAMPING.TOOL_ID\">Identifier</label><input type=\"text\" name=\"id\" ng-model=\"vm.tool.id\" md-maxlength=\"32\" \nrequired><div ng-messages=\"toolForm.id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP.REQUIRED_FIELD\">Required</span></div></div></md-input-container><md-input-container flex-offset=\"10\" \nflex=\"40\"><label translate=\"STAMPING.TOOL_SHAPE\">Form</label><md-select ng-model=\"vm.tool.shape\"><md-option \nng-repeat=\"shape in vm.shapes\" ng-value=\"shape\"><span class=\"text-uppercase\">{{shape}}</span></md-option></md-select>\n</md-input-container></div><div layout=\"row\" ng-switch=\"vm.tool.shape\"><md-input-container flex=\"30\" \nng-switch-when=\"\'circle\'\"><label translate=\"STAMPING.TOOL_RADIUS\">Radius</label><input type=\"number\" min=\"0\" \nmax=\"99999\" name=\"size\" ng-model=\"vm.tool.radius\" required nuit-unit-input=\"length\"></md-input-container>\n<md-input-container flex=\"30\" ng-switch-when=\"\'square\'\"><label translate=\"STAMPING.TOOL_WIDTH\">Width</label><input \ntype=\"number\" min=\"0\" max=\"99999\" name=\"size\" ng-model=\"vm.tool.width\" required nuit-unit-input=\"length\">\n</md-input-container><md-input-container flex=\"30\" ng-switch-when=\"\'roundedrect\'\"><label \ntranslate=\"STAMPING.TOOL_WIDTH\">Width</label><input type=\"number\" min=\"0\" max=\"99999\" name=\"size\" \nng-model=\"vm.tool.width\" required nuit-unit-input=\"length\"></md-input-container><md-input-container flex-offset=\"5\" \nflex=\"30\" ng-switch-when=\"\'roundedrect\'\"><label translate=\"STAMPING.TOOL_HEIGHT\">Height</label><input type=\"number\" \nmin=\"0\" max=\"99999\" name=\"size\" ng-model=\"vm.tool.height\" required nuit-unit-input=\"length\"></md-input-container></div>\n<div layout=\"row\"><md-input-container flex><md-checkbox ng-model=\"vm.tool.visible\" aria-label=\"Visible\"><span \ntranslate=\"STAMPING.TOOL_VISIBLE\"></span></md-checkbox></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n</div><div layout=\"row\"><md-button class=\"md-warn\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">\nCancel</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"toolForm.$invalid\"><span \ntranslate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/system.system/dialogs/translation/translation.html","<md-dialog id=\"systemtranslationdialog\"><form name=\"vm.translationForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 ng-if=\"!vm.new\">{{ vm.translation.key }}\n</h2><h2 ng-if=\"vm.new\" translate=\"TRANSLATIONS.ADD_TRANSLATION\">Add Translation</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.abort()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<div class=\"md-dialog-content\"><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.new\"><span \nclass=\"text-uppercase mr-24 md-subhead\">KEY</span><md-input-container class=\"mt-16 mb-16\" flex md-no-float><input \ntype=\"text\" name=\"vm.translationForm.key\" ng-model=\"vm.translation.key\" placeholder=\"Key\" \ntranslate-attr-placeholder=\"SYSTEM.TRANSLATION.KEY\"></md-input-container></div><div layout=\"row\" \nng-repeat=\"lang in vm.availableLanguages\" layout-align=\"start center\"><span class=\"text-uppercase mr-24 md-subhead\">\n{{ lang }}</span><md-input-container class=\"mt-16 mb-16\" flex md-no-float><input type=\"text\" \nname=\"vm.translationForm.key-{{lang}}\" ng-model=\"vm.translation.values[lang]\" placeholder=\"Übersetzung\" \ntranslate-attr-placeholder=\"SYSTEM.TRANSLATION_VALUE\"></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.abort()\" translate=\"APP.CANCEL\">Abort\n</md-button><md-button class=\"md-accent\" ng-click=\"vm.save()\" translate=\"APP.SAVE\">Save</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/system.system/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.system\" default-name=\"SYSTEM_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/system.system/views/tabs/colors.html","<div layout=\"column\" layout-fill flex id=\"colors\"><div class=\"content\" ng-if=\"vm.loading\" flex layout-fill><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content \nms-scroll ng-if=\"!vm.loading && vm.currentTab === \'colors\'\" class=\"m-24 md-whiteframe-1dp p-16\"><h1 class=\"p-8\" \ntranslate=\"SYSTEM.COLORS\">Color Settings</h1><div layout=\"row\" layout-wrap layout-align=\"center top\"><div \nclass=\"md-whiteframe-1dp item\" layout=\"column\" ng-repeat=\"color in vm.colors\"><div class=\"preview\"><div \nstyle=\"background-color:{{ color.hex }}\" class=\"color-preview\" ng-if=\"color.hex\"></div><div \nstyle=\"background-color: rgb({{ color.rgb }})\" class=\"color-preview\" ng-if=\"color.rgb && !color.hex\"></div></div><div \nclass=\"bottom md-background-bg md-hue-2\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><span \nclass=\"name\">{{color.name | nuitTranslate}}</span><label class=\"hex\" translate=\"{{ color.hex }}\">Hex</label></div><div \nclass=\"show-details\"><md-button class=\"md-icon-button\" aria-label=\"Edit color\" ng-click=\"vm.editColor(color)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Delete color\" \nng-click=\"vm.deleteColor(color)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/system.system/views/tabs/company.html","<div layout=\"column\" layout-fill flex><div class=\"content\" ng-if=\"vm.loading\" flex layout-fill><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content \nms-scroll ng-if=\"!vm.loading\" class=\"m-24 md-whiteframe-1dp p-24\"><form novalidate name=\"vm.companyForm\" \nng-submit=\"vm.submitCompanyData()\"><span class=\"md-headline\" translate=\"COMPANY.DATA\">Company Data</span><div \nlayout=\"column\" layout-margin><div layout=\"row\"><md-input-container flex=\"30\"><label translate=\"COMPANY.ADDRESS_NAME\">\nUnternehmensname</label><input type=\"text\" ng-model=\"vm.companyData.name.value\" name=\"name\" required><div \nng-messages=\"vm.companyForm.name.$error\"><div ng-message=\"required\" translate=\"ERRORS.REQUIRED\">\nDieses Feld ist ein Pflichtfeld</div></div></md-input-container><md-input-container flex=\"30\"><label \ntranslate=\"COMPANY.EMAIL\">Unternehmens E-Mail</label><input type=\"email\" ng-model=\"vm.companyData.email.value\" \nname=\"email\" required><div ng-messages=\"vm.companyForm.email.$error\"><div ng-message=\"required\" \ntranslate=\"ERRORS.REQUIRED\">Dieses Feld ist ein Pflichtfeld</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"15\"><label translate=\"COMPANY.COUNTRY_CODE\">Countrycode</label><input type=\"text\" \nng-model=\"vm.companyData.countryCode.value\" name=\"countrycode\" required><div \nng-messages=\"vm.companyForm.countrycode.$error\"><div ng-message=\"required\" translate=\"ERRORS.REQUIRED\">\nDieses Feld ist ein Pflichtfeld</div></div></md-input-container><md-input-container flex=\"15\"><label \ntranslate=\"COMPANY.COUNTRY_CODE_SHORT\">Countrycode</label><input type=\"text\" ng-model=\"vm.companyData.area.value\" \nname=\"area\"></md-input-container><md-input-container flex=\"30\"><label translate=\"COMPANY.CITY\">City</label><input \ntype=\"text\" ng-model=\"vm.companyData.city.value\" name=\"city\" required><div ng-messages=\"vm.companyForm.city.$error\">\n<div ng-message=\"required\" translate=\"ERRORS.REQUIRED\">Dieses Feld ist ein Pflichtfeld</div></div></md-input-container>\n<md-input-container flex=\"10\"><label translate=\"COMPANY.ZIP_CODE\">ZIP Code</label><input type=\"text\" \nng-model=\"vm.companyData.zipCode.value\" name=\"zipcode\" required><div ng-messages=\"vm.companyForm.zipcode.$error\"><div \nng-message=\"required\" translate=\"ERRORS.REQUIRED\">Dieses Feld ist ein Pflichtfeld</div></div></md-input-container>\n<md-input-container flex=\"30\"><label translate=\"COMPANY.STREET\">Street</label><input type=\"text\" \nng-model=\"vm.companyData.street.value\" name=\"street\" required><div ng-messages=\"vm.companyForm.street.$error\"><div \nng-message=\"required\" translate=\"ERRORS.REQUIRED\">Dieses Feld ist ein Pflichtfeld</div></div></md-input-container>\n<md-input-container flex=\"20\"><label translate=\"COMPANY.HOUSENUMBER\">Housenumber</label><input type=\"text\" \nng-model=\"vm.companyData.housenumber.value\" name=\"housenumber\" required><div \nng-messages=\"vm.companyForm.housenumber.$error\"><div ng-message=\"required\" translate=\"ERRORS.REQUIRED\">\nDieses Feld ist ein Pflichtfeld</div></div></md-input-container></div><div layout=\"row\"><md-button type=\"submit\" \nclass=\"md-raised md-accent\" ng-disabled=\"vm.companyForm.$pristine || vm.companyForm.$invalid\"><span \ntranslate=\"APP.SAVE\">Speichern</span></md-button></div></div></form></md-content></div>");
$templateCache.put("app/main/system.system/views/tabs/evo.html","<div layout=\"column\" layout-fill flex><div class=\"content\" ng-if=\"vm.loading\" flex layout-fill><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content \nms-scroll ng-if=\"!vm.loading\" class=\"m-24 md-whiteframe-1dp p-24\" layout=\"column\"><div layout=\"column\" \nng-repeat=\"section in vm.editableCartConfig\" ng-if=\"vm.hasConfigs(vm.cartConfig, section.configs)\"><h2>\n{{section.header | translate}}</h2><div layout=\"column\" layout-padding><config-single-type \nng-repeat=\"editableConfig in section.configs\" ng-if=\"vm.cartConfig\" config=\"vm.cartConfig\" use-dot-notation=\"true\" \nkey=\"{{editableConfig.key}}\" type=\"{{editableConfig.type}}\" default-value=\"editableConfig.defaultValue\" \nshow-default-value=\"false\" to-default-on-delete=\"false\" translation=\"{{editableConfig.translation}}\" \non-change=\"vm.saveConfig\"></config-single-type></div></div><div layout=\"column\" layout-fill layout-padding \nng-if=\"vm.cartConfig.assignee.enabled && vm.cartConfig.assignee.enabled.value\"><div layout=\"row\" layout-fill flex><div \nflex layout=\"column\" layout-fill class=\"pl-10\"><span flex=\"30\" class=\"text-bold\" layout=\"row\">assignee.users </span>\n<span translate=\"EVO_CART_SETTINGS.ASSIGNEE.USERS\"></span></div><div flex><config-editor-user-array \nvalue=\"vm.cartConfig.assignee.users.value\" active=\"true\" on-update=\"vm.saveConfig\"></config-editor-user-array></div>\n</div></div><div layout=\"row\" layout-fill><div layout=\"row\"><div layout=\"column\" \nng-if=\"vm.config.evo.editor.stamping.enabled\"><h2 translate=\"APP.STAMPING\">Stanzen</h2><div layout=\"row\" layout-wrap>\n<div layout=\"column\"><h3 translate=\"APP.GENERAL\">Allgemein</h3><md-checkbox class=\"md-primary\" \nng-model=\"vm.editorConfig.stamping.allowFreePlacement.value\" ng-change=\"vm.saveConfig()\"><span \ntranslate=\"STAMPING.ALLOW_FREE_PLACEMENT\"></span></md-checkbox><md-checkbox class=\"md-primary\" \nng-model=\"vm.editorConfig.stamping.allowMouseToolScaling.value\" ng-change=\"vm.saveConfig()\"><span \ntranslate=\"STAMPING.ALLOW_MOUSE_SCALING\"></span></md-checkbox></div><div layout=\"column\" flex layout-margin><h3 \ntranslate=\"APP.TOOLS\">Tools</h3><md-list flex \nng-if=\"vm.editorConfig.stamping.tools.value && vm.editorConfig.stamping.tools.value.length > 0\"><md-divider>\n</md-divider><md-list-item class=\"md-3-line\" ng-repeat=\"tool in vm.editorConfig.stamping.tools.value\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>Name: {{ tool.name[vm.currentLanguage] }}</h3><h4>ID: #{{ tool.id }}</h4>\n<p ng-if=\"tool.shape\">{{ tool.shape }}</p></div><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.moveUpElement(tool, vm.editorConfig.stamping.tools.value)\" ng-disabled=\"$first\" aria-label=\"moveup\">\n<md-icon md-font-icon=\"icon-arrow-up\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.moveDownElement(tool, vm.editorConfig.stamping.tools.value)\" ng-disabled=\"$last\" aria-label=\"movedown\">\n<md-icon md-font-icon=\"icon-arrow-down\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.editStampingTool(tool)\" aria-label=\"edit\"><md-icon md-font-icon=\"icon-border-color\"></md-icon></md-button>\n<md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.deleteElement(tool, vm.editorConfig.stamping.tools.value)\" \naria-label=\"delete\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></md-list-item><md-divider></md-divider>\n</md-list><md-button class=\"md-raised md-primary\" translate=\"STAMPING.ADD_TOOL\" ng-click=\"vm.addStampingTool()\">\nWerkzeug hinzufügen</md-button></div><div layout=\"column\" flex layout-margin><h3 translate=\"STAMPING.GENERATORS\">\nGeneratoren</h3><md-list flex \nng-if=\"vm.editorConfig.stamping.generators && vm.editorConfig.stamping.generators.value.length > 0\"><md-divider>\n</md-divider><md-list-item class=\"md-3-line\" ng-repeat=\"generator in vm.editorConfig.stamping.generators.value\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>Name: {{ generator.nameDist[vm.currentLanguage] }}</h3><h4>\nSide: {{ generator.attachedTo }}</h4><p>Restrictions: {{ generator.restrictionsDist.type }}</p></div><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.moveUpElement(generator, vm.editorConfig.stamping.generators.value)\" \nng-disabled=\"$first\" aria-label=\"moveup\"><md-icon md-font-icon=\"icon-arrow-up\"></md-icon></md-button><md-button \nclass=\"md-secondary md-icon-button\" \nng-click=\"vm.moveDownElement(generator, vm.editorConfig.stamping.generators.value)\" ng-disabled=\"$last\" \naria-label=\"movedown\"><md-icon md-font-icon=\"icon-arrow-down\"></md-icon></md-button><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.editStampingGenerator(generator)\" aria-label=\"edit\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.deleteElement(generator, vm.editorConfig.stamping.generators.value)\" aria-label=\"delete\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></md-list-item><md-divider></md-divider></md-list><md-button \nclass=\"md-raised md-primary\" translate=\"STAMPING.ADD_GENERATOR\" ng-click=\"vm.addStampingGenerator()\">\nGenerator hinzufügen</md-button></div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/system.system/views/tabs/holidays.html","<div layout=\"column\" layout-fill flex><md-content ms-scroll ng-if=\"!vm.loading\" class=\"m-24 md-whiteframe-1dp p-24\">\n<div layout=\"row\" layout-align=\"end center\" class=\"pb-30\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.save()\" \nng-disabled=\"!vm.isDirty || vm.isSaving\" translate=\"APP.SAVE\"></md-button></div><config-editor-holidays \nng-if=\"vm.holidays\" value=\"vm.holidays\" dirty=\"vm.isDirty\" active=\"true\" flex></config-editor-holidays></md-content>\n</div>");
$templateCache.put("app/main/system.system/views/tabs/import-export.html","<div layout=\"column\" layout-fill flex id=\"importExport\"><div class=\"content\" ng-if=\"vm.loading\" flex layout-fill><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content \nms-scroll ng-if=\"!vm.loading && vm.currentTab === \'importExport\'\" class=\"m-24 md-whiteframe-1dp p-16\"><h1 class=\"p-8\" \ntranslate=\"SYSTEM.IMPORT_EXPORT\">Import / Export</h1><div layout=\"column\" layout-wrap layout-align=\"start\"><div><h2 \nclass=\"ml-8\" translate=\"ATTRIBUTE.MATERIALS\"></h2></div><div layout=\"row\" layout-align=\"start\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.showImportMaterialsDialog()\"><span translate=\"MATERIALS.IMPORT_MATERIALS\">\nImport Colors</span></md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.showExportMaterialsDialog()\"><span \ntranslate=\"MATERIALS.EXPORT_MATERIALS\">Export Materials</span></md-button></div></div></md-content></div>");
$templateCache.put("app/main/system.system/views/tabs/ims.html","<div layout=\"column\" layout-fill flex><div class=\"content\" ng-if=\"vm.loading\" flex layout-fill><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" layout-fill><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span \nclass=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading</span> ...</span></div></div><md-content \nms-scroll ng-if=\"!vm.loading\" class=\"m-24 md-whiteframe-1dp p-24\"><h1>IMS SETTINGS</h1></md-content></div>");
$templateCache.put("app/main/system.system/views/tabs/translations.html","<div layout=\"column\" layout-fill flex id=\"translations\"><div \nclass=\"search md-whiteframe-1dp md-background-bg m-24 p-10\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchText\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"APP.SEARCH\" ng-change=\"vm.search()\" \nng-model-options=\"{debounce:1000}\"></div><md-content ms-scroll class=\"md-whiteframe-1dp mh-24\" flex><div \nclass=\"content\" ng-if=\"vm.loading\" flex layout-fill><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" layout-fill><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><span class=\"md-block md-headline mt-20\"><span translate=\"APP.LOADING\">Loading\n</span> ...</span></div></div><table class=\"simple\" ng-if=\"!vm.loading && vm.currentTab === \'translations\'\"><thead><tr>\n<th>&nbsp;</th><th>KEY</th><th ng-repeat=\"lang in vm.availableLanguages\">{{ lang }}</th><th>&nbsp;</th></tr></thead>\n<tbody><tr ng-repeat=\"(key, translation) in vm.translations\" \nng-show=\"vm.containsSearchText({key: key, values: translation})\"><td><md-button class=\"md-icon-button\" \nng-click=\"vm.openTranslation({key: key, values:translation})\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button></td><td>{{ ::key }}</td><td ng-repeat=\"lang in vm.availableLanguages\">{{ translation[lang] }}</td><td>\n<md-button class=\"md-icon-button\" ng-click=\"vm.deleteTranslation(key)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></td></tr></tbody></table></md-content></div>");
$templateCache.put("app/main/system.users/views/config/config.html","<config-editor whole-config=\"vm.config\" default-root=\"ims.users\" default-name=\"USERS_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/system.users/views/partials/admin.html","<md-content layout-fill flex ms-scroll><div layout=\"column\" layout-padding layout-margin class=\"mt-30\"><h2 \ntranslate=\"USERS.USERS\">Benutzer</h2><div layout=\"row\" layout-margin><md-input-container flex=\"40\"><label>Evo Version\n</label><md-select ng-model=\"vm.user.evoVersion\"><md-option ng-repeat=\"entry in vm.evoVersions\" ng-value=\"entry.value\">\n{{entry.key?(entry.key | translate):entry.label}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-margin><md-input-container flex=\"40\"><md-checkbox class=\"md-primary\" ng-model=\"vm.user.invoiced\"><div \ntranslate=\"USERS.INVOICED\">Invoiced</div></md-checkbox></md-input-container></div></div></md-content>");
$templateCache.put("app/main/system.users/views/partials/general.html","<md-content layout-fill flex ms-scroll><div layout=\"column\" layout-padding layout-margin class=\"mt-30\"><h2 \ntranslate=\"USER.DATA\">Daten</h2><div layout=\"row\" layout-margin><md-input-container flex><label \ntranslate=\"ACCOUNT.USER_FIRSTNAME\">Firstname</label><input type=\"text\" name=\"firstname\" ng-model=\"vm.user.firstName\" \nrequired></md-input-container><md-input-container flex><label translate=\"ACCOUNT.USER_SURNAME\">Surname</label><input \ntype=\"text\" name=\"lastname\" ng-model=\"vm.user.lastName\" required></md-input-container><md-input-container flex><label \ntranslate=\"ACCOUNT.USER_EMAIL\">Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.user.email\" required \nng-disabled=\"vm.isExistingUser\"></md-input-container><md-input-container flex><label translate=\"ACCOUNT.EXTERNAL_ID\">\nExternalId</label><input type=\"text\" name=\"externalId\" ng-model=\"vm.user.externalId\" \nng-disabled=\"({user: vm.user} | nuitConditionCheck:vm.config.ims.users.details.readOnlyConditions.externalId:true)\">\n</md-input-container></div><div layout=\"row\" layout-margin><md-input-container flex><label \ntranslate=\"ACCOUNT.USER_GENDER\">Gender</label><md-select ng-model=\"vm.user.gender\"><md-option ng-value=\"0\" \ntranslate=\"GENDER.UNKNOWN\">None</md-option><md-option ng-value=\"1\" translate=\"GENDER.FEMALE\">Female</md-option>\n<md-option ng-value=\"2\" translate=\"GENDER.MALE\">Male</md-option><md-option ng-value=\"4\" translate=\"GENDER.OTHER\">Other\n</md-option></md-select></md-input-container><md-input-container flex><label translate=\"APP.LANG\">Lang</label>\n<md-select ng-model=\"vm.user.locale\" required><md-option ng-repeat=\"lang in vm.config.languages\" ng-value=\"lang\"><span \nclass=\"text-uppercase\">{{ lang }}</span></md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"ACCOUNT.PHONE\">Phone</label><input type=\"text\" ng-model=\"vm.user.phone\" name=\"phone\"></md-input-container>\n<md-input-container flex><label translate=\"ACCOUNT.MOBILE\">Mobile</label><input type=\"text\" ng-model=\"vm.user.mobile\" \nname=\"mobile\" autocomplete=\"off\"></md-input-container></div><div layout=\"row\" layout-margin><md-input-container flex \nng-if=\"vm.roles.length > 0\"><label translate=\"ACCOUNT.USER_ROLE\">Role</label><md-select ng-model=\"vm.user.roleId\" \nrequired><md-option ng-repeat=\"role in vm.roles track by role.id\" ng-show=\"role.type===0\" ng-value=\"role.id\">\n{{ role.name[vm.translation.language] }}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"!vm.isExistingUser\"><label translate=\"ACCOUNT.USER_PASSWORD\">Password</label><input type=\"password\" \nname=\"password\" ng-model=\"vm.user.password\" required></md-input-container><md-input-container flex \nng-if=\"vm.isExistingUser\"><label translate=\"ACCOUNT.AVATAR\">Avatar</label><input ng-disabled=\"true\" type=\"text\" \nng-model=\"vm.user.avatar\" name=\"avatar\"></md-input-container><div class=\"ml-10\" style=\"width:68px;height:68px\" \nng-class=\"{\'md-whiteframe-5dp\': vm.user.avatar || vm.user.avatar === null}\"><img class=\"md-whiteframe-5dp\" \nstyle=\"max-height:68px;max-width:68px; width: auto; height:auto\" http-src=\"{{vm.user.avatar}}\" \nsrc=\"{{vm.user.avatar}}\" alt=\" \"></div><md-button class=\"md-primary md-raised md-fab md-mini\" flex=\"none\" \nng-click=\"vm.uploadImage()\"><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button></div></div></md-content>");
$templateCache.put("app/main/system.users/views/partials/permissions.html","<div layout=\"row\" layout-align=\"start top\" class=\"secondary-text mt-30 p-16\"><md-icon md-font-icon=\"icon-account-key\" \nclass=\"mr-8\"></md-icon><span class=\"md-title\" flex translate=\"USER.PERMISSIONS\">Permissions</span></div><md-content \nid=\"module-config\" ms-scroll class=\"m-24 md-whiteframe-1dp p-16\" layout=\"row\"><div layout=\"column\" flex=\"30\"><h1>EVO\n</h1><md-switch ng-if=\"vm.config.evo.cart.enabled\" ng-model=\"vm.userConfig.evo.cart.enabled.value\" aria-label=\"Cart\">\n<span translate=\"CART.CART_NAV\"></span></md-switch><md-switch ng-if=\"vm.config.evo.cart.showPrices\" class=\"pl-16\" \nng-model=\"vm.userConfig.evo.cart.showPrices.value\" aria-label=\"Prices\"><span translate=\"CART.SHOW_PRICES\"></span>\n</md-switch><md-switch ng-if=\"vm.config.evo.products.enabled\" ng-model=\"vm.userConfig.evo.products.enabled.value\" \naria-label=\"Products\"><span translate=\"PRODUCT.PRODUCT_NAV\"></span></md-switch><md-switch \nng-if=\"vm.config.evo.products.showPrices\" class=\"pl-16\" ng-model=\"vm.userConfig.evo.products.showPrices.value\" \naria-label=\"Prices\"><span translate=\"PRODUCTS.SHOW_PRICES\"></span></md-switch><md-switch \nng-if=\"vm.config.evo.editor.enabled\" ng-model=\"vm.userConfig.evo.editor.enabled.value\" aria-label=\"Editor\"><span \ntranslate=\"PROFILE.PROFILE_NAV\"></span></md-switch><md-switch ng-if=\"vm.config.evo.editor.stamping.enabled\" \nclass=\"pl-16\" ng-model=\"vm.userConfig.evo.editor.stamping.enabled.value\" aria-label=\"Stamping\"><span \ntranslate=\"EDITOR.STAMPING\"></span></md-switch></div><div layout=\"column\" flex=\"70\"><h1>IMS</h1><div layout=\"row\"><div \nlayout=\"column\" flex><strong translate=\"APP.GENERAL\"></strong><md-switch ng-if=\"vm.config.ims.enabled\" \nng-model=\"vm.userConfig.ims.enabled.value\" aria-label=\"IMS\"><span>IMS</span></md-switch><md-switch \nng-if=\"vm.config.ims.dashboard.enabled\" ng-model=\"vm.userConfig.ims.dashboard.enabled.value\" aria-label=\"Dashboard\">\n<span translate=\"DASHBOARD.DASHBOARD_NAV\"></span></md-switch></div><div layout=\"column\" flex><strong \ntranslate=\"ORDERMANAGEMENT.ORDERMANAGEMENT_NAV\"></strong><md-switch ng-if=\"vm.config.ims.orders.enabled\" \nng-model=\"vm.userConfig.ims.orders.enabled.value\" aria-label=\"Orders\"><span translate=\"ORDERS.ORDERS_NAV\"></span>\n</md-switch><md-switch ng-if=\"vm.config.ims.bills.enabled\" ng-model=\"vm.userConfig.ims.bills.enabled.value\" \naria-label=\"Bills\"><span translate=\"BILLS.BILLS_NAV\"></span></md-switch><md-switch \nng-if=\"vm.config.ims.proposals.enabled\" ng-model=\"vm.userConfig.ims.proposals.enabled.value\" aria-label=\"Proposals\">\n<span translate=\"PROPOSALS.PROPOSALS_NAV\"></span></md-switch></div><div layout=\"column\" flex><strong \ntranslate=\"PARTNERS.PARTNERS_NAV\"></strong><md-switch ng-if=\"vm.config.ims.companies.enabled\" \nng-model=\"vm.userConfig.ims.companies.enabled.value\" aria-label=\"Companies\"><span translate=\"PARTNERS.COMPANIES_NAV\">\n</span></md-switch><md-switch class=\"pl-20\" ng-if=\"vm.config.ims.companies.enabled\" \nng-model=\"vm.userConfig.ims.companies.admin.enabled.value\" aria-label=\"Companies\"><span \ntranslate=\"PARTNERS.COMPANIES_ADMIN_NAV\"></span></md-switch><md-switch ng-if=\"vm.config.ims.forwarders.enabled\" \nng-model=\"vm.userConfig.ims.forwarders.enabled.value\" aria-label=\"Forwarders\"><span \ntranslate=\"FORWARDERS.FORWARDERS_NAV\"></span></md-switch><md-switch ng-if=\"vm.config.ims.suppliers.enabled\" \nng-model=\"vm.userConfig.ims.suppliers.enabled.value\" aria-label=\"Suppliers\"><span translate=\"SUPPLIERS.SUPPLIERS_NAV\">\n</span></md-switch></div></div><div layout=\"row\" style=\"margin-top:24px\"><div layout=\"column\" flex><strong \ntranslate=\"MERCHANDISING.MERCHANDISING_NAV\"></strong><md-switch ng-if=\"vm.config.ims.materials.enabled\" \nng-model=\"vm.userConfig.ims.materials.enabled.value\" aria-label=\"Materials\"><span translate=\"MATERIALS.MATERIALS_NAV\">\n</span></md-switch><md-switch class=\"pl-20\" ng-if=\"vm.config.ims.materials.details.sales.enabled\" \nng-model=\"vm.userConfig.ims.materials.details.sales.enabled.value\" aria-label=\"Materials\"><span \ntranslate=\"MATERIALS.SALES\"></span></md-switch><md-switch ng-if=\"vm.config.ims.products.enabled\" \nng-model=\"vm.userConfig.ims.products.enabled.value\" aria-label=\"Products\"><span translate=\"PRODUCT.PRODUCT_NAV\"></span>\n</md-switch><md-switch class=\"pl-20\" ng-if=\"vm.config.ims.products.sales.enabled\" \nng-model=\"vm.userConfig.ims.products.sales.enabled.value\" aria-label=\"Products\"><span translate=\"PRODUCTS.SALES\">\n</span></md-switch></div><div layout=\"column\" flex><strong translate=\"CONTROLLING.CONTROLLING_NAV\"></strong><md-switch \nng-if=\"vm.config.ims.materialControlling.enabled\" ng-model=\"vm.userConfig.ims.materialControlling.enabled.value\" \naria-label=\"MaterialControlling\"><span translate=\"CONTROLLING.MATERIAL_NAV\"></span></md-switch><md-switch \nng-if=\"vm.config.ims.controllingSales.enabled\" ng-model=\"vm.userConfig.ims.controllingSales.enabled.value\" \naria-label=\"Sales\"><span translate=\"CONTROLLING.SALES_NAV\"></span></md-switch></div><div layout=\"column\" flex><strong \ntranslate=\"PRODUCTION.PRODUCTION_NAV\"></strong><md-switch ng-if=\"vm.config.ims.planning.enabled\" \nng-model=\"vm.userConfig.ims.planning.enabled.value\" aria-label=\"Planning\"><span translate=\"PRODUCTION.PLANNING\"></span>\n</md-switch><md-switch ng-if=\"vm.config.ims.productionEasy.enabled\" \nng-model=\"vm.userConfig.ims.productionEasy.enabled.value\" aria-label=\"Easy\"><span \ntranslate=\"PRODUCTION_EASY.PRODUCTION_EASY_NAV\"></span></md-switch><md-switch \nng-if=\"vm.config.ims.productionOrders.enabled\" ng-model=\"vm.userConfig.ims.productionOrders.enabled.value\" \naria-label=\"Orders\"><span translate=\"PRODUCTION_ORDERS.PRODUCTION_ORDERS_NAV\"></span></md-switch><md-switch \nng-if=\"vm.config.ims.machines.enabled\" ng-model=\"vm.userConfig.ims.machines.enabled.value\" aria-label=\"Machines\"><span \ntranslate=\"MACHINES.MACHINES_NAV\"></span></md-switch><md-switch ng-if=\"vm.config.ims.queue.enabled\" \nng-model=\"vm.userConfig.ims.queue.enabled.value\" aria-label=\"Queue\"><span translate=\"QUEUE.QUEUE_NAV\"></span>\n</md-switch></div></div><div layout=\"row\" style=\"margin-top:24px\"><div layout=\"column\" flex><strong \ntranslate=\"SYSTEM.SYSTEM_NAV\"></strong><md-switch ng-if=\"vm.config.ims.users.enabled\" \nng-model=\"vm.userConfig.ims.users.enabled.value\" aria-label=\"Users\"><span translate=\"USERS.USERS\"></span></md-switch>\n<md-switch ng-if=\"vm.config.ims.roles.enabled\" ng-model=\"vm.userConfig.ims.roles.enabled.value\" aria-label=\"Roles\">\n<span translate=\"USERS.ROLES\"></span></md-switch><md-switch ng-if=\"vm.config.ims.system.enabled\" \nng-model=\"vm.userConfig.ims.system.enabled.value\" aria-label=\"System\"><span translate=\"SYSTEM.SYSTEM_NAV\"></span>\n</md-switch><md-switch ng-if=\"vm.config.ims.sales.enabled\" ng-model=\"vm.userConfig.ims.sales.enabled.value\" \naria-label=\"Sales\"><span translate=\"SYSTEM.SALES_NAV\"></span></md-switch></div></div></div></md-content>");
$templateCache.put("app/main/system.users/views/partials/security.html","<md-content layout-fill flex ms-scroll><div layout=\"column\" layout-padding layout-margin class=\"mt-30\"><h2 \ntranslate=\"USER.LOGIN\">Login</h2><div layout=\"column\" layout-margin><div layout=\"row\"><md-input-container flex=\"40\">\n<label translate=\"ACCOUNT.PASSWORD\">Passwort</label><input type=\"password\" name=\"password\" ng-model=\"vm.password\">\n</md-input-container><md-input-container flex-offset=\"5\" flex=\"40\"><label translate=\"ACCOUNT.PASSWORD_REPEAT\">\nPasswort-Repeat</label><input type=\"password\" name=\"passwordRepeat\" ng-model=\"vm.passwordRepeat\"></md-input-container>\n<div><md-button class=\"md-primary md-raised\" ng-disabled=\"!vm.isPasswordChangeable()\" aria-label=\"\" \ntranslate=\"APP.CHANGE\" ng-click=\"vm.changePassword()\"></md-button></div></div></div><h2 translate=\"USER.NEW_EMAIL\">\nLogin</h2><div layout=\"column\" layout-margin><div layout=\"row\"><md-input-container flex=\"25\"><label \ntranslate=\"ACCOUNT.USER_EMAIL_NEW\">Email new</label><input type=\"email\" name=\"newEmail\" ng-model=\"vm.newEmail\">\n</md-input-container><md-input-container flex=\"25\" flex-offset=\"5\"><label translate=\"ACCOUNT.PASSWORD\">Passwort</label>\n<input type=\"password\" name=\"password\" ng-model=\"vm.passwordForEmail\"></md-input-container><md-input-container \nflex=\"25\" flex-offset=\"5\"><label translate=\"ACCOUNT.PASSWORD_REPEAT\">Passwort</label><input type=\"password\" \nname=\"passwordRepeat\" ng-model=\"vm.passwordRepeatForEmail\"></md-input-container><div><md-button \nclass=\"md-primary md-raised\" aria-label=\"\" translate=\"APP.CHANGE\" ng-disabled=\"!vm.isEmailChangeable()\" \nng-click=\"vm.changeEmail()\"></md-button></div></div></div></div></md-content>");
$templateCache.put("app/ims/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/ims/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/ims/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/ims/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/ims/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/ims/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/ims/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/ims/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/ims/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/ims/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\" layout=\"column\" flex><div class=\"ms-stepper-navigation-wrapper\" layout=\"column\"><div\n class=\"ms-stepper-navigation\" layout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\">{{$index + 1}}</div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"title\" translate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div \nclass=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" layout=\"column\" flex ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\" ng-include=\"\'wizard_buttons.html\'\"></div></div><script type=\"text/ng-template\" \nid=\"wizard_buttons.html\">\n<md-button class=\"md-accent\" ng-if=\"!MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">\n        <md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n        <span translate=\"APP.BACK\">Zurück</span>\n    </md-button>\n\n    <div class=\"ms-stepper-dots\">\n        <span ng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n        </span>\n    </div>\n\n    <md-button class=\"md-accent\" ng-click=\"MsStepper.gotoNextStep()\" ng-if=\"!MsStepper.isLastStep() && MsStepper.isStepValid(MsStepper.currentStepNumber) && !MsStepper.isStepHidden(MsStepper.currentStepNumber + 1)\">\n        <span translate=\"APP.NEXT\">Weiter</span>\n        <md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n    </md-button>\n</script>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/addressesByCountry.html","<config-editor-addresses-by-country value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-addresses-by-country>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/colorSelection.html","<config-editor-color-selection value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-color-selection>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/conditionalStyle.html","<config-editor-read-only-conditions type=\"style\" value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-read-only-conditions>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/customAttributes.html","<config-editor-custom-attributes value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-custom-attributes>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/customFields.html","<config-editor-custom-fields value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-custom-fields>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/customFieldsEvoCart.html","<config-editor-evo-cart-fields value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-evo-cart-fields>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/disableInvoiceStatis.html","<config-editor-disable-invoice-status type=\"\'invoice\'\" value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" \nflex></config-editor-disable-invoice-status>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/disableRemarkType.html","<config-editor-disable-invoice-status type=\"\'remark\'\" value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" \nflex></config-editor-disable-invoice-status>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/enableSelection.html","<config-editor-enable-selection value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-enable-selection>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/exchangeAppIdNodeRed.html","<config-exchange-app-id value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" type-filter=\"nodered\" flex>\n</config-exchange-app-id>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/exchangeAppIdQuickbook.html","<config-exchange-app-id value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" type-filter=\"quickbooks\" flex>\n</config-exchange-app-id>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/exchangeAppIdXero.html","<config-exchange-app-id value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" type-filter=\"xero\" flex>\n</config-exchange-app-id>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/exchangeFlowId.html","<config-exchange-flow-id value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-exchange-flow-id>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/exportOptions.html","<config-editor-export-options value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-export-options>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/favorites.html","<config-editor-favorites value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-favorites>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/filters.html","<config-editor-filters value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex></config-editor-filters>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/formatWithLineBreaks.html","<config-editor-format-with-line-breaks value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-format-with-line-breaks>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/holidays.html","<config-editor-holidays value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex></config-editor-holidays>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/imageUpload.html","<config-editor-image-upload value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-image-upload>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/materialFilters.html","<config-editor-product-filters value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" type=\"material\" flex>\n</config-editor-product-filters>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/mimeType.html","<config-editor-drop-down value=\"model.data.value\" multiple=\"true\" \nselectable-values=\"[\n				\'image/jpeg\',\n				\'image/png\',\n				\'application/pdf\',\n				\'text/csv\'\n			]\" \nactive=\"vm.isInConfig(model[\'model\'])\" flex></config-editor-drop-down>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/orderStatus.html","<config-editor-order-status value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-order-status>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/productFilters.html","<config-editor-product-filters value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" type=\"product\" flex>\n</config-editor-product-filters>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/proposalStatus.html","<config-editor-order-status value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" type-filter=\"proposal\" \nflex></config-editor-order-status>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/readOnlyConditions.html","<config-editor-read-only-conditions value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-read-only-conditions>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/readOnlyStatis.html","<config-editor-read-only-statis value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-read-only-statis>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/salesOrder.html","<config-editor-sales-order value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-sales-order>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/salesOrderOverrides.html","<config-editor-sales-order-overrides value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-sales-order-overrides>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/stampingAreas.html","<config-editor-stamping-areas value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" \nsizes=\"vm.stampingToolSizes\" on-areas-updated=\"vm.onStampingAreasUpdated(areas)\" flex></config-editor-stamping-areas>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/stampingTemplates.html","<config-editor-stamping-templates value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" \nsizes=\"vm.stampingToolSizes\" tools=\"vm.stampingTools\" areas=\"vm.stampingAreas\" flex></config-editor-stamping-templates>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/stampingTools.html","<config-editor-stamping-tools value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" \non-sizes-updated=\"vm.onStampingToolSizesUpdated(sizes)\" on-tools-updated=\"vm.onStampingToolsUpdated(tools)\" flex>\n</config-editor-stamping-tools>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/stateSelection.html","<config-editor-state-selection value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-state-selection>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/tagGroupSelection.html","<config-editor-tag-group-selection value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-tag-group-selection>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/toolType.html","<config-editor-array-order value=\"model.data.value\" \ndefault-values=\"[\n				\'oblong\',\n				\'rectangle\',\n				\'circle\'\n			]\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-array-order>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/translationArray.html","<config-editor-translation-array value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-translation-array>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/userArray.html","<config-editor-user-array value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex>\n</config-editor-user-array>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/workdays.html","<config-editor-workdays value=\"model.data.value\" active=\"vm.isInConfig(model[\'model\'])\" flex></config-editor-workdays>");
$templateCache.put("app/main/admin.setup/views/partials/settings/evo_cart.html","<config-editor whole-config=\"vm.config\" default-root=\"evo.cart\" default-name=\"EVO_CART_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/admin.setup/views/partials/settings/evo_products.html","<config-editor whole-config=\"vm.config\" default-root=\"evo.products\" default-name=\"EVO_PRODUCTS_SETTINGS\" \ncontroller=\"vm\"></config-editor>");
$templateCache.put("app/main/admin.setup/views/partials/settings/evo_profiles.html","<config-editor whole-config=\"vm.config\" default-root=\"evo.editor\" default-name=\"EVO_EDITOR_SETTINGS\" controller=\"vm\">\n</config-editor>");
$templateCache.put("app/main/admin.setup/views/partials/settings/evo_sketches.html","");
$templateCache.put("app/main/merchandising.products/views/partials/sales/sales_rule_limits.html","<div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.showRuleLimitations()\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"mr-8\">{{ vm.salesRule.priceModifier }}</span><md-input-container \nclass=\"mb-0 w-100\"><label translate=\"APP.MIN\">Wert</label><input class=\"text-right\" type=\"number\" min=\"0\" step=\"0.01\" \nng-model=\"vm.salesRule.priceModifierMin\"></md-input-container><span \nng-if=\"vm.salesRule.priceModifierType === \'currency\'\">{{vm.config.localization.currency.symbol}}</span> <span \nng-if=\"vm.salesRule.priceModifierType === \'percent\'\">%</span></div><div layout=\"row\" layout-align=\"center center\"><span\n class=\"mr-8\">{{ vm.salesRule.priceModifier }}</span><md-input-container class=\"mb-0 w-100\"><label translate=\"APP.MAX\">\nWert</label><input class=\"text-right\" type=\"number\" min=\"0\" step=\"0.01\" ng-model=\"vm.salesRule.priceModifierMax\">\n</md-input-container><span ng-if=\"vm.salesRule.priceModifierType === \'currency\'\">\n{{vm.config.localization.currency.symbol}}</span> <span ng-if=\"vm.salesRule.priceModifierType === \'percent\'\">%</span>\n</div></div>");
$templateCache.put("app/main/merchandising.products/views/partials/sales/sales_rule_options.html","<div layout=\"row\"><div layout=\"row\" ng-if=\"vm.salesRule.type === \'attribute\'\" flex><md-select \nng-model=\"vm.salesRule.attribute\" ng-model-options=\"{trackBy:\'$value.id\'}\" flex><md-option \nng-repeat=\"attribute in vm.currentProduct.attributes track by attribute.id\" ng-value=\"attribute\"><span>\n{{ attribute.name | nuitTranslate }}</span></md-option></md-select></div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.salesRule.type === \'combination\'\" flex><md-select \nng-model=\"vm.salesRule.lh_attribute\" ng-model-options=\"{\'trackBy\': \'$value.id\'}\" flex><md-option \nng-repeat=\"attribute in vm.currentProduct.attributes track by attribute.id\" \nng-if=\"vm.salesRule.rh_attribute !== attribute && (attribute.type === \'number\' || attribute.type === \'length\')\" \nng-value=\"attribute\"><span>{{attribute.name | nuitTranslate}}</span></md-option></md-select><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span ng-repeat=\"combinator in vm.numericCombinators\" \nng-if=\"vm.salesRule.combinationType === combinator.value\">{{ combinator.symbol }}</span></md-button><md-menu-content>\n<md-menu-item ng-repeat=\"combinator in vm.numericCombinators\"><md-button \nng-click=\"vm.salesRule.combinationType = combinator.value\">{{ combinator.symbol }}</md-button></md-menu-item>\n</md-menu-content></md-menu><md-select ng-model=\"vm.salesRule.rh_attribute\" \nng-model-options=\"{\'trackBy\': \'$value.id\'}\" flex><md-option \nng-repeat=\"attribute in vm.currentProduct.attributes track by attribute.id\" \nng-if=\"vm.salesRule.lh_attribute !== attribute && (attribute.type === \'number\' || attribute.type === \'length\')\" \nng-value=\"attribute\"><span>{{attribute.name | nuitTranslate}}</span></md-option></md-select></div><div layout=\"row\" \nng-if=\"vm.salesRule.type === \'productdata\'\" flex><md-select ng-model=\"vm.salesRule.property\" flex><md-optgroup \nng-repeat=\"category in vm.productProperties\" label=\"{{ category.key | translate }}\"><md-option \nng-repeat=\"property in category.properties\" \nng-disabled=\"property.disabled !== undefined && property.disabled(vm.currentProduct)\" ng-value=\"property.id\"><span \ntranslate=\"{{property.key}}\"></span></md-option></md-optgroup></md-select></div></div>");
$templateCache.put("app/main/merchandising.products/views/partials/sales/sales_rule_values.html","<div layout=\"column\"><div layout=\"row\" layout-align=\"space-around center\" ng-if=\"vm.showMaterialCondition()\"><md-switch\n ng-model=\"vm.salesRule.priceModifierType\" ng-true-value=\"\'{{vm.materialAttributeBase}}\'\" ng-false-value=\"undefined\">\n<label translate=\"SALES.USE_ATTRIBUTE_BASE\"></label></md-switch><md-menu \nng-if=\"vm.salesRule.priceModifierType===vm.materialAttributeBase\"><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span>{{vm.salesRule.priceModifier}}</span></md-button><md-menu-content><md-menu-item \nng-repeat=\"modifier in vm.priceModifiers\"><md-button ng-click=\"vm.salesRule.priceModifier = modifier.value\">\n{{ ::modifier.symbol }}</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-align=\"center center\" \nng-if=\"vm.showRulePriceModifier() && vm.salesRule.priceModifierType !== vm.materialAttributeBase\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span>{{vm.salesRule.priceModifier}}</span>\n</md-button><md-menu-content><md-menu-item ng-repeat=\"modifier in vm.priceModifiers\"><md-button \nng-click=\"vm.salesRule.priceModifier = modifier.value\">{{ ::modifier.symbol }}</md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container class=\"mb-0 w-100\" \nng-if=\"vm.salesRule.priceModifierType !== vm.materialAttributeBase\"><label translate=\"APP.VALUE\">Wert</label><input \nclass=\"text-right\" type=\"number\" min=\"0\" step=\"0.01\" name=\"price\" ng-model=\"vm.salesRule.priceModifierValue\">\n</md-input-container><md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span \nng-if=\"vm.salesRule.priceModifierType === \'percent\'\">%</span> <span \nng-if=\"vm.salesRule.priceModifierType === \'currency\'\">{{ vm.config.localization.currency.symbol }}</span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"modifierType in vm.priceModifierTypes\"><md-button \nng-click=\"vm.salesRule.priceModifierType = modifierType.value\">\n{{ (modifierType.symbol === \'$\') ? vm.config.localization.currency.symbol : modifierType.symbol }}</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" layout-align=\"space-around center\" \nng-if=\"vm.salesRule.type === \'attribute\' && vm.salesRule.attribute !== undefined && vm.salesRule.attribute.type === \'enum\'\">\n<md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span \nng-repeat=\"comparator in vm.booleanComparators\" ng-if=\"vm.salesRule.conditionType === comparator.condition\">\n{{ comparator.key | translate }}</span></md-button><md-menu-content><md-menu-item \nng-repeat=\"comparator in vm.booleanComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{::comparator.key}}\"></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container class=\"mr-16\" flex \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if\' || vm.salesRule.conditionType === \'not\')\">\n<label><span translate=\"APP.VALUE\">Value</span></label><md-select ng-model=\"vm.salesRule.conditionValue\"><md-option \nng-repeat=\"option in vm.salesRule.attribute.restrictions.options track by $index\" ng-value=\"option\"><span>{{ option }}\n</span></md-option></md-select></md-input-container><md-input-container class=\"mr-16\" flex \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if_multi\' || vm.salesRule.conditionType === \'not_multi\')\">\n<label><span translate=\"APP.VALUE\">Value</span></label><md-select multiple=\"multiple\" \nng-model=\"vm.salesRule.conditionValue\"><md-option \nng-repeat=\"option in vm.salesRule.attribute.restrictions.options track by $index\" ng-value=\"option\"><span>{{ option }}\n</span></md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.showNumberCondition()\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span \nng-repeat=\"comparator in vm.numericComparators\" ng-if=\"vm.salesRule.conditionType === comparator.condition\" \ntranslate=\"{{::comparator.key}}\"></span></md-button><md-menu-content><md-menu-item \nng-repeat=\"comparator in vm.numericComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{comparator.key}}\"></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container class=\"mb-0 w-100\"><label><span translate=\"APP.VALUE\">Value</span>\n&nbsp;<span ng-if=\"vm.salesRule.attribute.restrictions.unit\">({{vm.salesRule.attribute.restrictions.unit}})</span>\n</label><input type=\"number\" name=\"conditionValue\" ng-model=\"vm.salesRule.conditionValue\" min=\"0\"></md-input-container>\n</div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.showLengthCondition()\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span ng-repeat=\"comparator in vm.numericComparators\" \nng-if=\"vm.salesRule.conditionType === comparator.condition\" translate=\"{{::comparator.key}}\"></span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"comparator in vm.numericComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{comparator.key}}\"></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container class=\"mb-0 w-100\"><label><span translate=\"APP.VALUE\">Value</span>\n&nbsp;<span>({{vm.nuitUnits(\'length\').symbol}})</span></label><input type=\"number\" name=\"conditionValue\" \nnuit-unit-input=\"length\" ng-model=\"vm.salesRule.conditionValue\" min=\"0\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.showAreaCondition()\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised\"><span ng-repeat=\"comparator in vm.numericComparators\" \nng-if=\"vm.salesRule.conditionType === comparator.condition\" translate=\"{{::comparator.key}}\"></span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"comparator in vm.numericComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{comparator.key}}\"></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container class=\"mb-0 w-100\"><label><span translate=\"APP.VALUE\">Value</span>\n&nbsp;<span>({{vm.nuitUnits(\'area\').symbol}})</span></label><input type=\"number\" name=\"conditionValue\" \nnuit-unit-input=\"area\" ng-model=\"vm.salesRule.conditionValue\" min=\"0\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-around center\" \nng-if=\"vm.showMaterialCondition() && vm.salesRule.priceModifierType !== vm.materialAttributeBase\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span ng-repeat=\"comparator in vm.booleanComparators\" \nng-if=\"vm.salesRule.conditionType === comparator.condition\">{{ comparator.key | translate }}</span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"comparator in vm.booleanComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{::comparator.key}}\"></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container flex class=\"mr-16\" \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if\' || vm.salesRule.conditionType === \'not\')\">\n<label><span translate=\"PRODUCTS.PROFILE_MATERIALS\">Value</span></label><md-select \nmd-on-open=\"vm.reloadEnumSelection()\" ng-model=\"vm.salesRule.conditionValue\"><md-option \nng-repeat=\"material in vm.priceRuleEnum track by material.id\" ng-value=\"material.id\"><span>\n{{ material.name | nuitTranslate }}</span></md-option></md-select></md-input-container><md-input-container flex \nclass=\"mr-16\" \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if_multi\' || vm.salesRule.conditionType === \'not_multi\')\">\n<label><span translate=\"PRODUCTS.PROFILE_MATERIALS\">Value</span></label><md-select \nmd-on-open=\"vm.reloadEnumSelection()\" md-selected-text=\"vm.salesRule.conditionValue.length + \' materials selected\'\" \nng-model=\"vm.salesRule.conditionValue\" multiple=\"multiple\"><md-option \nng-repeat=\"material in vm.priceRuleEnum track by material.id\" ng-value=\"material.id\"><span>\n{{ material.name | nuitTranslate }}</span></md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-around center\" ng-if=\"vm.showColorCondition()\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised\"><span ng-repeat=\"comparator in vm.booleanComparators\" \nng-if=\"vm.salesRule.conditionType === comparator.condition\">{{ comparator.key | translate }}</span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"comparator in vm.booleanComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{::comparator.key}}\"></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container flex class=\"mr-16\" \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if\' || vm.salesRule.conditionType === \'not\')\">\n<label><span translate=\"APP.COLORS\">Value</span></label><md-select md-on-open=\"vm.reloadEnumSelection()\" \nng-model=\"vm.salesRule.conditionValue\"><md-option ng-repeat=\"color in vm.priceRuleEnum track by color.id\" \nng-value=\"color.id\"><span>{{ color.name | nuitTranslate }}</span></md-option></md-select></md-input-container>\n<md-input-container flex class=\"mr-16\" \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if_multi\' || vm.salesRule.conditionType === \'not_multi\')\">\n<label><span translate=\"APP.COLORS\">Value</span></label><md-select md-on-open=\"vm.reloadEnumSelection()\" \nmd-selected-text=\"vm.salesRule.conditionValue.length + \' colors selected\'\" ng-model=\"vm.salesRule.conditionValue\" \nmultiple=\"multiple\"><md-option ng-repeat=\"color in vm.priceRuleEnum track by color.id\" ng-value=\"color.id\"><span>\n{{ color.name | nuitTranslate }}</span></md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-around center\" ng-if=\"vm.showMaterialGroupCondition()\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span ng-repeat=\"comparator in vm.booleanComparators\" \nng-if=\"vm.salesRule.conditionType === comparator.condition\">{{ comparator.key | translate }}</span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"comparator in vm.booleanComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{::comparator.key}}\"></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container flex class=\"mr-16\" \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if\' || vm.salesRule.conditionType === \'not\')\">\n<label><span translate=\"PRODUCTS.PROFILE_MATERIAL_GROUPS\">Value</span></label><md-select \nng-model=\"vm.salesRule.conditionValue\"><md-option ng-repeat=\"group in vm.profileGroups\" ng-value=\"group\"><span>\n{{ group.name | nuitTranslate }}</span></md-option></md-select></md-input-container><md-input-container flex \nclass=\"mr-16\" \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if_multi\' || vm.salesRule.conditionType === \'not_multi\')\">\n<label><span translate=\"PRODUCTS.PROFILE_MATERIAL_GROUPS\">Value</span></label><md-select \nmd-selected-text=\"vm.salesRule.conditionValue.length + \' groups selected\'\" ng-model=\"vm.salesRule.conditionValue\" \nmultiple=\"multiple\"><md-option ng-repeat=\"group in vm.profileGroups\" ng-value=\"group\"><span>\n{{ group.name | nuitTranslate }}</span></md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" \nng-if=\"(vm.showNumberCondition() || vm.showLengthCondition() || vm.showAreaCondition()) && (vm.salesRule.conditionType === \'/\' || vm.salesRule.conditionType === \'$\')\">\n<md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span \nng-if=\"vm.salesRule.conditionStart === undefined\" translate=\"MATH.ALWAYS\">Immer</span> <span \nng-if=\"vm.salesRule.conditionStart !== undefined\" translate=\"MATH.AT\">Ab</span></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"vm.salesRule.conditionStart = undefined\"><span translate=\"MATH.ALWAYS\">Immer</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.salesRule.conditionStart = 0\"><span \ntranslate=\"MATH.AT\">Ab</span></md-button></md-menu-item></md-menu-content></md-menu><md-input-container \nclass=\"mb-0 w-100\" ng-if=\"vm.salesRule.conditionStart !== undefined && vm.showAreaCondition()\"><label><span \ntranslate=\"APP.VALUE\">Value</span>&nbsp;<span>({{vm.nuitUnits(\'area\').symbol}})</span></label><input type=\"number\" \nname=\"conditionStart\" nuit-unit-input=\"area\" ng-model=\"vm.salesRule.conditionStart\" min=\"0\"></md-input-container>\n<md-input-container class=\"mb-0 w-100\" ng-if=\"vm.salesRule.conditionStart !== undefined && vm.showLengthCondition()\">\n<label><span translate=\"APP.VALUE\">Value</span>&nbsp;<span>({{vm.nuitUnits(\'length\').symbol}})</span></label><input \ntype=\"number\" name=\"conditionStart\" nuit-unit-input=\"length\" ng-model=\"vm.salesRule.conditionStart\" min=\"0\">\n</md-input-container><md-input-container class=\"mb-0 w-100\" \nng-if=\"vm.salesRule.conditionStart !== undefined && vm.showNumberCondition()\"><label><span translate=\"APP.VALUE\">Value\n</span>&nbsp;<span ng-if=\"vm.salesRule.attribute.restrictions.unit\">({{vm.salesRule.attribute.restrictions.unit}})\n</span></label><input type=\"number\" name=\"conditionStart\" ng-model=\"vm.salesRule.conditionStart\" min=\"0\">\n</md-input-container></div></div>");
$templateCache.put("app/main/merchandising.products.attributes/dialogs/edit-attribute/partials/color.html","<div layout=\"column\" layout-fill><md-input-container><label translate=\"ATTRIBUTE.COLORS\">Colors</label><md-select \nng-model=\"vm.attribute.restrictions.colors\" md-on-open=\"vm.loadColors()\" ng-model-options=\"{trackBy: \'$value\'}\" \nmultiple=\"multiple\"><md-optgroup label=\"{{ \'ATTRIBUTE.COLORS\' | translate}}\"><md-option ng-value=\"color.id\" \nng-repeat=\"color in vm.colors track by color.id\">{{color.code}}&nbsp;-&nbsp;{{color.name | nuitTranslate}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container><md-switch \nng-model=\"vm.attribute.restrictions.blacklist\" aria-label=\"Blacklist\" class=\"md-warn\">\n{{ \'ATTRIBUTE.BLACKLIST\' | translate }}</md-switch></md-input-container></div>");
$templateCache.put("app/main/merchandising.products.attributes/dialogs/edit-attribute/partials/material.html","<div layout=\"column\" layout-fill><md-input-container><label translate=\"ATTRIBUTE.MATERIALS\">Material</label><md-select \nng-model=\"vm.attribute.restrictions.materials\" md-on-open=\"vm.loadMaterials()\" ng-model-options=\"{trackBy: \'$value\'}\" \nmultiple=\"multiple\"><md-optgroup label=\"{{ \'ATTRIBUTE.MATERIALS\' | translate}}\"><md-option ng-value=\"material.id\" \nng-repeat=\"material in vm.materials track by material.id\">{{material.name | nuitTranslate}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container><label translate=\"ATTRIBUTE.MATERIAL.GROUPS\">Materialgruppe\n</label><md-select ng-model=\"vm.attribute.restrictions.groups\" ng-model-options=\"{trackBy: \'$value\'}\" \nmd-on-open=\"vm.loadMaterialGroups()\" multiple=\"multiple\"><md-optgroup \nlabel=\"{{ \'ATTRIBUTE.MATERIAL.GROUPS\' | translate}}\"><md-option ng-value=\"group.id\" \nng-repeat=\"group in vm.materialGroups | orderByNuitTranslated:\'name\' track by group.id\">{{group.name | nuitTranslate}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container><md-switch \nng-model=\"vm.attribute.restrictions.blacklist\" aria-label=\"Blacklist\" class=\"md-warn\">\n{{ \'ATTRIBUTE.BLACKLIST\' | translate }}</md-switch></md-input-container></div>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-draw/nuit-draw.template.html","<div class=\"nuit-draw\" layout-fill flex ng-class=\"{\'no-padding\': vm.fullWidth,\'no-margin\': vm.fullWidth}\">\n<ng-transclude></ng-transclude></div>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-draw-2d/nuit-draw-2d.template.html","<md-button aria-label=\"Cutting\" class=\"md-raised blank\" ng-if=\"!vm.style.hideBlank\"><span translate=\"PROFILE.CUTTING\">\nZuschnitt</span> {{vm.totalLengthWithoutOffset|nuitUnit:\'length\'}}</md-button>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-draw-cutting/nuit-draw-cutting.template.html","<div ng-if=\"vm.editorCtrl.currentEditor.id === \'nuit-draw-cutting\' && !vm.hideUi\"><div \nstyle=\"position:absolute;top:0;left:30px\" layout=\"row\"><md-input-container style=\"width:100px\"><md-icon \nmd-svg-src=\"_nuit_/assets/angle-acute.svg\"></md-icon><input type=\"number\" ng-model=\"vm.angle\" step=\"1\">\n</md-input-container></div><div style=\"position:absolute;bottom:50px;left:50px\" layout=\"row\"><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"vm.showStretched()\" aria-label=\"n\" \nng-class=\"{\'md-raised\':vm.isStretched()}\"><md-icon md-svg-src=\"_nuit_/assets/ic_image_aspect_ratio_black_24px.svg\">\n</md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"MENUBAR.SHOW_STRETCHED\">Show stretched</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.showProportional()\" aria-label=\"n\" \nng-class=\"{\'md-raised\':vm.isProportional()}\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_photo_size_select_small_black_24px.svg\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"MENUBAR.SHOW_ORIGINAL\">Show proportional</span></md-tooltip></md-button></div></div>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-draw-stamping-rework/nuit-draw-stamping.template.html","<div style=\"position:absolute;bottom:50px;left:50px\" \nng-if=\"vm.editorCtrl.currentEditor.id === \'nuit-draw-stamping-rework\' && !vm.hideUi\" layout=\"row\"><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"vm.manager.showStretched()\" aria-label=\"n\" \nng-class=\"{\'md-raised\':vm.manager.isStretched()}\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_image_aspect_ratio_black_24px.svg\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"MENUBAR.SHOW_STRETCHED\">Show stretched</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"vm.manager.showProportional()\" aria-label=\"n\" \nng-class=\"{\'md-raised\':vm.manager.isProportional()}\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_photo_size_select_small_black_24px.svg\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"MENUBAR.SHOW_ORIGINAL\">Show proportional</span></md-tooltip></md-button></div><div \nstyle=\"position:absolute;top:0;left:30px\" \nng-if=\"vm.editorCtrl.currentEditor.id === \'nuit-draw-stamping-rework\' && !vm.hideUi\" layout=\"row\"><md-input-container \nng-if=\"!vm.manager.toolGroupsEnabled\"><md-select ng-model=\"vm.manager.selectedSize\"><md-option \nng-repeat=\"size in vm.manager.selectedTool.sizes\" ng-value=\"$index\">\n{{size.name | nuitTranslate}} ({{size.value | nuitUnit:\'length\'}})</md-option></md-select></md-input-container>\n<md-input-container \nng-if=\"vm.manager.toolGroupsEnabled && vm.manager.getSupportedShapesByType(vm.manager.selectedToolType).length>0\">\n<md-select ng-model=\"vm.manager.selectedShape\"><md-option \nng-repeat=\"shape in vm.manager.getSupportedShapesByType(vm.manager.selectedToolType)\" ng-value=\"shape\">{{shape.sizeId}}\n</md-option></md-select></md-input-container></div>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/nuit-editor.template.html","<div layout=\"column\" layout-fill><md-toolbar class=\"editor-menubar md-primary\" ng-if=\"vm.style.menubar.enabled\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.showNewProfileDialog();\" aria-label=\"Neu\" \nng-disabled=\"!vm.hasSegments() || vm.isReadOnly(\'newProfile\')\" ng-if=\"vm.style.menubar.showNewProfileButton\"><md-icon \nmd-svg-src=\"_nuit_/assets/file-outline.svg\"></md-icon><md-tooltip><span translate=\"MENUBAR.NEW\">New</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-disabled=\"vm.isReadOnly(\'openProfile\')\" \nng-click=\"vm.openProfileDialog()\" aria-label=\"n\" \nng-if=\"vm.openProfileDialogAvailable() && vm.style.menubar.showOpenProfileButton\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_folder_open_black_24px.svg\"></md-icon><md-tooltip><span translate=\"MENUBAR.OPEN\">\nOpen Profile</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-disabled=\"vm.isReadOnly(\'openProfile\')\" ui-sref=\"{{vm.openProfileState}}\" aria-label=\"n\" \nng-if=\"vm.openProfileStateAvailable() && vm.style.menubar.showOpenProfileButton\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_folder_open_black_24px.svg\"></md-icon><md-tooltip><span translate=\"MENUBAR.OPEN\">\nOpen Profile</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.saveProfile()\" \naria-label=\"n\" ng-disabled=\"!vm.hasSegments() || vm.isReadOnly(\'saveProfile\')\" \nng-if=\"vm.saveProfileAvailable() && vm.style.menubar.showSaveProfileButton\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_save_black_24px.svg\"></md-icon><md-tooltip><span translate=\"MENUBAR.SAVE\">Save</span>\n</md-tooltip></md-button><md-divider class=\"vertical-divider\"></md-divider><md-button \nng-disabled=\"!vm.historyBackAvailable\" aria-label=\"n\" class=\"md-icon-button\" ng-click=\"vm.historyBack()\" \nng-if=\"vm.style.menubar.enableHistory\"><md-icon md-svg-src=\"_nuit_/assets/ic_undo_black_24px.svg\"></md-icon>\n<md-tooltip><span translate=\"MENUBAR.BACK\">Back</span></md-tooltip></md-button><md-button \nng-disabled=\"!vm.historyForwardAvailable\" aria-label=\"n\" class=\"md-icon-button\" ng-click=\"vm.historyForward()\" \nng-if=\"vm.style.menubar.enableHistory\"><md-icon md-svg-src=\"_nuit_/assets/ic_redo_black_24px.svg\"></md-icon>\n<md-tooltip><span translate=\"MENUBAR.FORWARD\">Forward</span></md-tooltip></md-button><span flex \nclass=\"text-center text-truncate\">{{vm.name | nuitTranslate}}</span><md-button class=\"md-raised\" \nng-click=\"vm.showDynamicSegmentsDialog()\" aria-label=\"n\" ng-if=\"vm.config.editor.allowDynamicSegments\" \nng-disabled=\"!vm.hasDynamicSegments()\"><span>Dynamic segment settings</span></md-button><md-button class=\"md-raised\" \nng-click=\"vm.selectMaterial($event)\" aria-label=\"n\" \nng-if=\"vm.selectMaterialAvailable() && vm.style.menubar.showMaterialButton\" ng-disabled=\"vm.isReadOnlyMaterial()\" \nng-class=\"{\'md-warn\': !vm.hasMaterial()}\"><md-icon ng-if=\"vm.material.colors.front.hex\" \nmd-svg-src=\"_nuit_/assets/checkbox-blank.svg\" ng-style=\"{color: vm.material.colors.front.hex}\"></md-icon><md-tooltip>\n<span translate=\"PROFILE.SELECT_MATERIAL\">Select material</span></md-tooltip><span ng-if=\"!vm.material.name\" \ntranslate=\"PROFILE.SELECT_MATERIAL\">Select material</span> <span ng-if=\"vm.material.name\">\n{{vm.material.name | nuitTranslate}}</span><md-icon md-font-icon=\"icon-alert\" style=\"color: #c00; margin-left: 0.5em\" \nng-if=\"vm.material.orderable === false\"></md-icon></md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.finalAction($event)\" aria-label=\"n\" \nng-if=\"vm.finalActionAvailable() && vm.style.menubar.showFinalActionButton\" \nng-disabled=\" !vm.hasSegments() && !vm.hasMaterial() || !vm.hasSegments() || !vm.hasMaterial() \"><md-icon \nmd-svg-src=\"_nuit_/assets/baseline-add_shopping_cart-24px.svg\"></md-icon><span translate=\"PROFILE.ADD_TO_CART\">\nAdd to cart</span></md-button></div></md-toolbar><div layout=\"row\" id=\"editor\" flex layout-fill><md-content ms-scroll \nng-if=\"vm.style.toolbox.enabled\" class=\"editor-toolbox md-whiteframe-3dp\"><ng-include \nsrc=\"\'_nuit_/components/nuit-editor/toolbars/nuit-draw-2d.html\'\"></ng-include><ng-include \nsrc=\"\'_nuit_/components/nuit-editor/toolbars/nuit-draw-top.html\'\"></ng-include><ng-include \nsrc=\"\'_nuit_/components/nuit-editor/toolbars/nuit-draw-stamping.html\'\"></ng-include><ng-include \nsrc=\"\'_nuit_/components/nuit-editor/toolbars/nuit-draw-stamping-rework.html\'\"></ng-include><ng-include \nsrc=\"\'_nuit_/components/nuit-editor/toolbars/nuit-draw-cutting.html\'\"></ng-include></md-content><div flex layout-fill>\n<nuit-draw editor-config=\"vm.config\" on-config-changed=\"vm.inheritConfig(config)\" layout-fill flex><nuit-draw-2d \nng-if=\"vm.config.editor.nuitDraw2d.enabled\"></nuit-draw-2d><nuit-draw-top ng-if=\"vm.config.editor.nuitDrawTop.enabled\">\n</nuit-draw-top><nuit-draw-stamping ng-if=\"vm.config.editor.nuitDrawStamping.enabled\"></nuit-draw-stamping>\n<nuit-draw-stamping-rework ng-if=\"vm.config.editor.nuitDrawStampingRework.enabled\" hide-ui=\"false\">\n</nuit-draw-stamping-rework><nuit-draw-cutting ng-if=\"vm.config.editor.nuitDrawCutting.enabled\" hide-ui=\"false\">\n</nuit-draw-cutting></nuit-draw></div><md-sidenav class=\"md-sidenav-right editor-sidebar md-whiteframe-3dp\" \nmd-is-locked-open=\"true\" layout=\"column\" layout-align=\"start stretch\" layout-fill><div class=\"profile-depth\" \nlayout-padding layout=\"row\" layout-align=\"space-between center\" md-colors=\"{background:\'default-background\'}\"><span \ntranslate=\"PROFILE.LENGTH\">Länge</span><md-input-container class=\"no-error-spacer\"><input \nng-disabled=\"vm.isReadOnly(\'length\')\" type=\"number\" ng-model=\"vm.depth\" ng-model-options=\"{ updateOn:\'change\' }\" \naria-label=\"n\" nuit-unit-input=\"length\" ng-change=\"vm.reValidate()\"></md-input-container></div><md-tabs \nmd-border-bottom md-selected=\"vm.selectedIndex\" md-stretch-tabs=\"never\" flex><div \nng-repeat=\"tab in vm.tabs | orderBy: \'index\' track by tab.index\"><ng-include src=\"tab.src\"></ng-include></div>\n</md-tabs><ng-transclude ng-if=\"vm.show3d()\"></ng-transclude></md-sidenav></div></div>");
$templateCache.put("app/main/nuit-editor/src/dialogs/add-stamping-line/view.html","<md-dialog aria-label=\"n\" class=\"add-stamping-line-dialog\"><md-toolbar class=\"md-accent-bg\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"PROFILE.ADD_STAMPING_LINE\">Add Stamping Line</span></div></md-toolbar><form name=\"vm.form\" \nng-submit=\"vm.submit($event)\"><md-dialog-content class=\"md-dialog-content\"><md-input-container style=\"display:block\">\n<md-select ng-model=\"vm.line.meta.area.index\" required md-selected-text=\"vm.getSelectedAreaLabel()\" \nng-change=\"vm.setAreaProperties()\"><md-option ng-repeat=\"area in vm.manager.areas\" ng-if=\"area.isVisible\" \nng-value=\"$index\">{{area.name | nuitTranslate}}</md-option></md-select></md-input-container><div layout=\"column\" \nlayout-align=\"start stretch\" ng-show=\"vm.line.meta.area.index >= 0\"><span class=\"md-body-2\" style=\"font-weight:bold\" \ntranslate=\"PROFILE.TOOL_SELECTION\">Tool Selection</span><div layout=\"row\" layout-align=\"stretch center\" \nclass=\"no-error-spacer\"><md-input-container flex=\"50\"><label translate=\"PROFILE.TOOL\">Tool</label><md-select \nng-model=\"vm.line.tool.id\" aria-label=\"n\" ng-change=\"vm.setToolProperties()\" required><md-option \nng-repeat=\"tool in vm.getAvailableTools() track by tool.id\" ng-value=\"tool.id\">{{tool.name | nuitTranslate}}\n</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label translate=\"PROFILE.TOOL_SIZE\">Size\n</label><md-select ng-model=\"vm.line.tool.size\" aria-label=\"n\" required ng-disabled=\"!vm.line.tool.id\"><md-option \nng-repeat=\"size in vm.getAvailableSizes() track by size.index\" ng-value=\"size.index\">\n{{size.name | nuitTranslate}} ({{size.value | nuitUnit:\'length\'}})</md-option></md-select></md-input-container></div>\n<div layout=\"row\" layout-align=\"stretch center\" class=\"no-error-spacer\" ng-model-options=\"{updateOn: \'change click\'}\" \nng-if=\"vm.manager.showToolDistances\"><md-input-container><label translate=\"PROFILE.MIN_DISTANCE\">Min</label><input \ntype=\"number\" ng-model=\"vm.line.bounds.min\" nuit-unit-input=\"length\" required ng-disabled=\"!vm.line.tool.id\">\n</md-input-container><md-input-container><label translate=\"PROFILE.MAX_DISTANCE\">Max</label><input type=\"number\" \nng-model=\"vm.line.bounds.max\" nuit-unit-input=\"length\" required ng-disabled=\"!vm.line.tool.id\"></md-input-container>\n</div></div><div layout=\"column\" layout-align=\"start stretch\" ng-show=\"vm.line.tool.id\" \nng-model-options=\"{updateOn: \'change click\'}\"><span class=\"md-body-2\" style=\"font-weight:bold\" \ntranslate=\"PROFILE.STAMPING_POSITIONS\">Positions</span><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"no-error-spacer\"><md-input-container><label translate=\"PROFILE.FIRST_STAMPING\">First stamping</label><input \ntype=\"number\" ng-model=\"vm.line.first\" nuit-unit-input=\"length\" ng-min=\"vm.firstStampMinVal\" \nng-max=\"vm.firstStampMaxVal\" required><div class=\"hint\"><span translate=\"APP.MIN\"></span>\n {{vm.firstStampMinVal | nuitUnit:\'length\'}}, <span translate=\"APP.MAX\"></span>\n {{vm.firstStampMaxVal | nuitUnit:\'length\'}}</div></md-input-container><md-input-container><label \ntranslate=\"PROFILE.LAST_STAMPING\">Last stamping</label><input type=\"number\" ng-model=\"vm.line.last\" \nnuit-unit-input=\"length\" ng-min=\"vm.lastStampMinVal\" ng-max=\"vm.lastStampMaxVal\" \nng-required=\"vm.line.meta.type === \'amount\'\"><div class=\"hint\"><span translate=\"APP.MIN\"></span>\n {{vm.lastStampMinVal | nuitUnit:\'length\'}}, <span translate=\"APP.MAX\"></span>\n {{vm.lastStampMaxVal | nuitUnit:\'length\'}}</div></md-input-container></div><md-radio-group \nng-model=\"vm.line.meta.type\" layout=\"row\" layout-align=\"space-between start\" layout-wrap \nng-init=\"vm.line.meta.type=vm.line.meta.type || \'amount\'\"><md-radio-button value=\"amount\" aria-label=\"n\" \nflex=\"noshrink\"><span translate=\"PROFILE.AMOUNT_TYPE\">Amount</span></md-radio-button><md-radio-button value=\"distance\" \naria-label=\"n\" flex=\"noshrink\"><span translate=\"PROFILE.DISTANCE_BETWEEN_TYPE\">Distance between</span>\n</md-radio-button></md-radio-group><div layout=\"row\" layout-align=\"space-between center\" class=\"no-error-spacer\" \nng-model-options=\"{updateOn: \'change click\'}\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"50\">\n<md-input-container><label translate=\"PROFILE.STAMPING_AMOUNT\">Amount</label><input type=\"number\" \nng-model=\"vm.line.amount\" ng-disabled=\"!vm.line.meta.fixedAmount && vm.line.meta.type !== \'distance\'\" \nng-required=\"vm.line.meta.fixedAmount || vm.line.meta.type === \'distance\'\"></md-input-container><md-button \nng-click=\"vm.line.meta.fixedAmount = !vm.line.meta.fixedAmount\" flex=\"nogrow\" \nng-class=\"{\'md-raised md-primary\': vm.line.meta.fixedAmount}\" class=\"md-icon-button\" aria-label=\"n\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_lock_outline_black_24px.svg\" ng-if=\"!vm.line.meta.fixedAmount\"></md-icon><md-icon \nmd-svg-src=\"_nuit_/assets/ic_lock_open_black_24px.svg\" ng-if=\"vm.line.meta.fixedAmount\"></md-icon></md-button></div>\n<md-input-container><label translate=\"PROFILE.DISTANCE_BETWEEN\">Distance between</label><input type=\"number\" \nng-model=\"vm.line.meta.distBetweenStamps\" nuit-unit-input=\"length\" ng-disabled=\"vm.line.meta.type === \'amount\'\" \nng-required=\"vm.line.meta.type === \'distance\'\" ng-change=\"vm.updateAmount()\"></md-input-container></div>\n<md-input-container flex=\"50\" ng-model-options=\"{updateOn: \'change click\'}\"><label translate=\"PROFILE.OFFSET_TOP\">\nOffset top</label><input type=\"number\" ng-model=\"vm.line.y\" nuit-unit-input=\"length\" required ng-min=\"vm.offsetMinVal\" \nng-max=\"vm.offsetMaxVal\"><div class=\"hint\"><span translate=\"APP.MIN\"></span> {{vm.offsetMinVal | nuitUnit:\'length\'}}, \n<span translate=\"APP.MAX\"></span> {{vm.offsetMaxVal | nuitUnit:\'length\'}}</div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" class=\"md-raised md-primary\" \naria-label=\"n\" translate=\"APP.SAVE\">Save</md-button><md-button type=\"button\" class=\"md-warning\" aria-label=\"n\" \nng-click=\"vm.close()\" translate=\"APP.CANCEL\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/nuit-editor/src/dialogs/dynamic-segments/dynamic-segments.dialog.html","<md-dialog aria-label=\"n\" class=\"dynamic-segments-dialog\"><md-toolbar class=\"md-accent-bg\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"EDITOR.DYNAMIC_SEGMENTS_DIALOG_TITLE\">Dynamic Segments</span><md-button \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.close()\" aria-label=\"n\"><md-icon \nmd-svg-src=\"nuit::/assets/ic_close_black_24px.svg\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"APP.CLOSE\">Close</span></md-tooltip></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-dialog-content\"><ng-form layout=\"row\" layout-align=\"space-between center\" layout-padding name=\"vm.form\" \nng-repeat=\"segment in vm.dynamicSegments track by segment.index\" ng-submit=\"vm.submit($event)\"><span>\n# {{segment.index+1}}</span><div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"no-error-spacer\">\n<label translate=\"APP.NAME\">Name</label><input type=\"text\" name=\"name\" ng-model=\"segment.name[vm.currLang]\" required>\n</md-input-container><md-select ng-model=\"vm.currLang\" md-selected-text=\"vm.currLang.toUpperCase()\" aria-label=\"n\">\n<md-option ng-repeat=\"lang in vm.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select></div><md-input-container class=\"no-error-spacer\"><label translate=\"PRODUCTS.SEGMENT_LENGTH\">Length</label>\n<input type=\"number\" name=\"length\" ng-model=\"segment._originalSegment.length\" readonly=\"readonly\"></md-input-container>\n<md-input-container class=\"no-error-spacer\"><label translate=\"APP.MIN\">Min</label><input type=\"number\" name=\"min\" \nng-model=\"segment.min\" ng-min=\"0\" ng-max=\"segment._originalSegment.length\" nuit-unit-input=\"length\">\n</md-input-container><md-input-container class=\"no-error-spacer\"><label translate=\"APP.MAX\">Max</label><input \ntype=\"number\" name=\"max\" ng-min=\"segment._originalSegment.length\" ng-model=\"segment.max\" nuit-unit-input=\"length\">\n</md-input-container></ng-form></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button\n ng-click=\"vm.close()\" aria-label=\"n\"><span translate=\"APP.CANCEL\">Cancel</span></md-button><md-button \nng-click=\"vm.submit()\" class=\"md-accent md-raised\" aria-label=\"n\"><span translate=\"APP.SAVE\">Save</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/orders.accounting/views/dialogs/add-remark/add-remark.html","<md-dialog aria-label=\"Add remark\" style=\"width: 400px\"><form name=\"remarkForm\" ng-submit=\"vm.submit()\" novalidate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"INVOICE.REMARK_NEW\">New Remark</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-wrap class=\"ph-20\"><md-input-container \nng-if=\"vm.showRemarkType\"><label>{{\'INVOICE.REMARK_TYPE\' | translate}}</label><md-select ng-model=\"vm.remark.type\">\n<md-option ng-repeat=\"remarkType in vm.remarkTypeOptions track by remarkType.id\" ng-value=\"remarkType.id\" \nng-if=\"vm.config.ims.accounting.disabledRemarks.indexOf(remarkType.id)===-1 \">\n{{(\"INVOICE.REMARK_\" + remarkType.type | uppercase) | translate}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"\">Bemerkung</label><textarea ng-model=\"vm.remark.remark\" \nmd-maxlength=\"150\" rows=\"1\" md-select-on-focus></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n</div><div layout=\"row\"><md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel\n</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"attributeForm.$invalid\"><span \ntranslate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/orders.accounting/views/dialogs/change-status/change-status.html","<md-dialog aria-label=\"Change Status\" style=\"width: 400px\"><form name=\"attributeForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"ACCOUNTING.CHANGE_STATUS\">Change Status</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div class=\"mh-20\" layout=\"column\"><span \ntranslate=\"INVOICE.STATIS\">Status</span><md-input-container><md-select ng-model=\"vm.selectedStatus\"><md-option \nng-repeat=\"status in vm.statis track by status.id\" ng-value=\"status.id\" \nng-if=\"vm.config.ims.accounting.disabledStatis.indexOf(status.id)===-1 \">\n{{(\"INVOICE.STATUS_\" + status.type | uppercase) | translate}}</md-option></md-select></md-input-container></div><div \nclass=\"mh-20\" layout=\"column\" ng-if=\"vm.selectedStatus === 3\"><div class=\"mh-8 mb-15\"><span \ntranslate=\"INVOICE.PAID_AT\">Paid At</span></div><md-datepicker ng-model=\"vm.paidAt\" \nmd-placeholder=\"{{\'APP.SELECT\' | translate}}\"></md-datepicker></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\">\n<md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button>\n<md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"attributeForm.$invalid\"><span translate=\"APP.SAVE\">\nSUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/orders.credit/views/dialogs/change-status/change-status.html","<md-dialog aria-label=\"Change Status\" style=\"width: 550px\"><form name=\"updateCreditForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CREDIT.UPDATE_CREDIT\">Change Status</span><md-button\n class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div flex=\"50\" class=\"mh-20\" layout=\"column\"><span \ntranslate=\"INVOICE.STATIS\">Status</span><md-input-container><md-select ng-model=\"vm.selectedStatus\" \nng-change=\"vm.onStatusChange()\"><md-option ng-repeat=\"status in vm.statis track by status.id\" ng-value=\"status.id\">\n{{(\"CREDIT.STATUS_\" + status.type | uppercase) | translate}}</md-option></md-select></md-input-container></div><div \nflex=\"50\" class=\"mh-20\" layout=\"column\" ng-if=\"vm.selectedStatus !== 4\"><div class=\"mh-8\"><span \ntranslate=\"CREDIT.SUM_REDEEMED\">amount redeemed</span></div><md-input-container class=\"mb-0\"><input type=\"number\" \nng-model=\"vm.amountRedeemed\" ng-max=\"{{vm.sumAmount}}\" name=\"amount\" ng-pattern=\"/^(?:\\d*\\.\\d{1,2}|\\d+)$/\"><div \nng-class=\"{\'red-500-fg\' : updateCreditForm.amount.$error.max}\" class=\"hint\" style=\"font-size: 12px\"><span \ntranslate=\"CREDIT.FROM_TOTAL_AMOUNT\"></span>: <strong>{{vm.sumAmount | nuitCurrency}}</strong></div><div \nng-messages=\"updateCreditForm.amount.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\" \nclass=\"my-message\"><span translate=\"CREDIT.ONLY_TWO_DECIMAL_PLACES\"></span></div></div></md-input-container></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\"><md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span \ntranslate=\"APP.CANCEL\">Cancel</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"updateCreditForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/orders.credit/views/dialogs/update-sum-redeemed/update-sum-redeemed.html","<md-dialog aria-label=\"Add remark\" style=\"width: 400px\"><form name=\"sumRedeemedForm\" ng-submit=\"vm.submit()\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CREDIT.UPDATE_SUM_REDEEMED\">Update Sum Redeemed\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-wrap class=\"ph-20\">\n<md-input-container class=\"md-block\"><label translate=\"CREDIT.SUM_REDEEMED\">SumRedeemed</label><input type=\"number\" \nng-model=\"vm.sumRedeemed\"><div class=\"hint\" style=\"font-size: 13px\"><span translate=\"CREDIT.FROM_TOTAL_AMOUNT\"></span>\n: <strong>{{vm.sumAmount | nuitCurrency}}</strong></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n</div><div layout=\"row\"><md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel\n</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"sumRedeemedForm.$invalid\"><span \ntranslate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners.transport/views/dialogs/change-status/change-delivery-status.html","<md-dialog aria-label=\"Change Status\" style=\"width: 500px\"><form name=\"changeDeliveryStatusForm\" \nng-submit=\"vm.submit()\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ACCOUNTING.CHANGE_STATUS\">Change Status\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div class=\"mh-20\" layout=\"column\"><span \ntranslate=\"INVOICE.STATIS\">Status</span><md-input-container><md-select ng-model=\"vm.selectedStatus\"><md-option \nng-repeat=\"status in vm.statis track by status.id\" ng-value=\"status.id\">\n{{(\"TRANSPORT.\" + status.type | uppercase) | translate}}</md-option></md-select></md-input-container></div><div \nclass=\"mh-20\" layout=\"column\" ng-if=\"vm.selectedStatus === 4\"><div class=\"mh-8 mb-15\"><span \ntranslate=\"TRANSPORT.DELIVERY_PICKEDUP\">Picked up at</span></div><md-datepicker ng-model=\"vm.pickedUp\" \nmd-placeholder=\"{{\'APP.SELECT\' | translate}}\"></md-datepicker></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\">\n<md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button>\n<md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"changeDeliveryStatusForm.$invalid\"><span \ntranslate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners.transport/views/dialogs/postal-code-delays/postal-code-delay-dialog.html","<md-dialog aria-label=\"Change Status\"><form name=\"postalCodeDelayForm\" ng-submit=\"vm.submit()\" novalidate><md-toolbar \nclass=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"TRANSPORT.POSTAL_DELAY\">Add/change Delay</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout=\"column\"><div layout=\"row\" layout-align=\"space-between\"><md-input-container flex=\"50\"><label \ntranslate=\"COMPANY.COUNTRY_CODE\">Name</label><md-select ng-model=\"vm.delay.countryCode\"><md-option \nng-repeat=\"country in vm.countries | orderBy:\'code\'\" ng-value=\"country.code\">{{country.code}}</md-option></md-select>\n</md-input-container><md-input-container><label translate=\"COMPANY.ZIP_CODE\">Postal Code</label><input \nng-model=\"vm.delay.zipCode\"></md-input-container></div><div layout=\"column\"><md-switch \nng-model=\"vm.delay.zipCodeAsterisk\">*<span translate=\"TRANSPORT.DELAY_ZIP_CODE_ASTERISK\">* Autovervollständigung</span>\n</md-switch><md-input-container><label translate=\"TRANSPORT.DELIVERY_DELAY_DAYS\">Verzögerung</label><input \ntype=\"number\" ng-model=\"vm.delay.delay\"></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"></div><div layout=\"row\">\n<md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span translate=\"APP.CANCEL\">Cancel</span></md-button>\n<md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"postalCodeDelayForm.$invalid\"><span \ntranslate=\"APP.SAVE\">SUBMIT</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners.transport/views/dialogs/delivery-numbers/delivery-number-dialog.html","<md-dialog aria-label=\"Add delivery number\"><form name=\"vm.deliveryNumberForm\" ng-submit=\"vm.submit()\" novalidate>\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"TRANSPORT.DELIVERY_NUMBERS_ADD\">\nAdd/change Delivery Number</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nclass=\"mt-10\"><div layout=\"column\" layout-gt-md=\"row\" layout-align=\"start\"><div layout=\"row\"><div class=\"m-20\" \nlayout=\"column\" style=\"min-width: 320px\"><div layout=\"row\"><span translate=\"APP.INVOICE_NUMBER.START_DATE\">Start \n</span><span>*</span></div><md-input-container ng-if=\"vm.updatePossible\"><md-datepicker class=\"mv-10\" \nng-model=\"vm.deliveryNumber.start\" md-current-view=\"year\" md-placeholder=\"{{\'APP.SELECT\' | translate}}\" required \nname=\"dateFieldStart\"></md-datepicker><div ng-messages=\"vm.invoiceNumbersForm.dateFieldStart.$error\"><div \nng-message=\"valid\" translate=\"APP.INVOICE_NUMBER.INVALID_DATE\">The entered value is not a date!</div><div \nng-message=\"required\" translate=\"APP.INVOICE_NUMBER.REQUIRED_DATE\">This date is required!</div></div>\n</md-input-container><div ng-if=\"!vm.updatePossible\" layout=\"row\" layout-align=\"start center\" class=\"mv-20\"><md-icon \nclass=\"ml-0 mr-10\" md-font-icon=\"icon-calendar-check\"></md-icon><span>{{vm.deliveryNumber.start | nuitDate:\'date\'}}\n</span></div></div><div class=\"m-20 mr-80\" layout=\"column\"><div layout=\"row\"><span \ntranslate=\"APP.INVOICE_NUMBER.END_DATE\">End </span>*</div><md-input-container><md-datepicker class=\"mt-10\" \nng-model=\"vm.deliveryNumber.end\" md-current-view=\"year\" md-placeholder=\"{{\'APP.SELECT\' | translate}}\" name=\"dateField\" \nrequired name=\"dateField\"></md-datepicker><div ng-messages=\"vm.deliveryNumberForm.dateField.$error\"><div \nng-message=\"valid\" translate=\"APP.INVOICE_NUMBER.INVALID_DATE\">The entered value is not a date!</div><div \nng-message=\"required\" translate=\"APP.INVOICE_NUMBER.REQUIRED_DATE\">This date is required!</div></div>\n</md-input-container></div></div><div ng-if=\"vm.showNumbers\" class=\"m-20\" flex-order=\"-1\" flex-order-gt-md=\"1\"><div \nclass=\"p-10 blue-grey-50-bg\" layout=\"row\" style=\"width: fit-content\"><span translate=\"APP.INVOICE_NUMBER.NUMBER\">\nAnzahl von Rechnungen (Number)</span> <span>: <strong>{{vm.deliveryNumber.number}}</strong></span></div></div></div>\n<div><div class=\"m-20\" layout=\"column\" flex=\"40\"><md-input-container \nstyle=\"width: 680px; margin-top: 0; margin-bottom: 0 !important\"><div style=\"margin-bottom: 18px\"><span \ntranslate=\"APP.TEMPLATE\">Tpl </span>*</div><input name=\"tpl\" type=\"text\" ng-model=\"vm.deliveryNumber.tpl\" \nng-disabled=\"!vm.updatePossible\" required><div ng-messages=\"vm.deliveryNumberForm.tpl.$error\" role=\"alert\"><div \nng-message=\"required\" class=\"my-message\"><span translate=\"APP.TEMPLETE.ERROR\"></span></div></div></md-input-container>\n<div layout=\"row\"><md-button ng-repeat=\"field in vm.tplFields\" ng-click=\"vm.setTpl(field)\" \nclass=\"md-whiteframe-1dp mh-5\" ng-disabled=\"!vm.updatePossible\"><span>{{(\'APP.\' + (field | uppercase)) | translate }}\n</span></md-button></div></div></div><div layout=\"row\"><div class=\"m-20\" layout=\"column\"><md-input-container \nstyle=\"width: 320px\"><span translate=\"APP.INVOICE_NUMBER.OFFSET\">Offset</span> <input type=\"number\" \nng-model=\"vm.deliveryNumber.offset\" ng-disabled=\"!vm.updatePossible\"></md-input-container></div><div class=\"m-20\" \nlayout=\"column\"><md-input-container style=\"width: 320px\"><span translate=\"APP.INVOICE_NUMBER.SIZE\">Size</span> <input \nng-disabled=\"!vm.updatePossible\" type=\"number\" ng-model=\"vm.deliveryNumber.size\"></md-input-container></div></div><div \nlayout=\"row\"><div class=\"m-20\" layout=\"column\" style=\"width: 320px\"><md-switch ng-model=\"vm.deliveryNumber.autoRenew\" \nng-disabled=\"vm.requiredField\"><span translate=\"APP.INVOICE_NUMBER.AUTORENEW\"></span></md-switch></div><div \nclass=\"m-20\" layout=\"column\" ng-if=\"vm.deliveryNumber.autoRenew\"><md-input-container style=\"width: 320px\"><span>\nRenewOffset</span> <input type=\"number\" ng-model=\"vm.deliveryNumber.renewOffset\"></md-input-container></div></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\"><md-button class=\"\" type=\"reset\" ng-click=\"vm.cancel()\"><span \ntranslate=\"APP.CANCEL\">Cancel</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"vm.deliveryNumberForm.$invalid\"><span translate=\"APP.SAVE\">SUBMIT</span></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/system.sales/views/partials/sales/sales_rule_limits.html","<div layout=\"column\" layout-align=\"center center\" ng-if=\"vm.showRuleLimitations()\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"mr-8\">{{ vm.salesRule.priceModifier }}</span><md-input-container \nclass=\"mb-0 w-100\"><label translate=\"APP.MIN\">Wert</label><input class=\"text-right\" type=\"number\" min=\"0\" step=\"0.01\" \nng-model=\"vm.salesRule.priceModifierMin\"></md-input-container><span \nng-if=\"vm.salesRule.priceModifierType === \'currency\'\">{{vm.config.localization.currency.symbol}}</span> <span \nng-if=\"vm.salesRule.priceModifierType === \'percent\'\">%</span></div><div layout=\"row\" layout-align=\"center center\"><span\n class=\"mr-8\">{{ vm.salesRule.priceModifier }}</span><md-input-container class=\"mb-0 w-100\"><label translate=\"APP.MAX\">\nWert</label><input class=\"text-right\" type=\"number\" min=\"0\" step=\"0.01\" ng-model=\"vm.salesRule.priceModifierMax\">\n</md-input-container><span ng-if=\"vm.salesRule.priceModifierType === \'currency\'\">\n{{vm.config.localization.currency.symbol}}</span> <span ng-if=\"vm.salesRule.priceModifierType === \'percent\'\">%</span>\n</div></div>");
$templateCache.put("app/main/system.sales/views/partials/sales/sales_rule_options.html","<div layout=\"row\"><div layout=\"row\" ng-if=\"vm.salesRule.type === \'attribute\'\" flex><md-select \nng-model=\"vm.salesRule.attribute\" flex><md-option ng-repeat=\"attribute in vm.attributes\" \nng-if=\"attribute.value === undefined || attribute.value === null\" ng-value=\"attribute\"><span>\n{{ attribute.name | nuitTranslate }}</span></md-option></md-select></div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.salesRule.type === \'combination\'\" flex><md-select \nng-model=\"vm.salesRule.lh_attribute\" flex><md-option ng-repeat=\"attribute in vm.attributes\" \nng-if=\"(attribute.value === undefined || attribute.value === null) && vm.salesRule.rh_attribute !== attribute && (attribute.type === \'number\' || attribute.type === \'length\')\" \nng-value=\"attribute\"><span>{{attribute.name | nuitTranslate}}</span></md-option></md-select><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span ng-repeat=\"combinator in vm.numericCombinators\" \nng-if=\"vm.salesRule.combinationType === combinator.value\">{{ combinator.symbol }}</span></md-button><md-menu-content>\n<md-menu-item ng-repeat=\"combinator in vm.numericCombinators\"><md-button \nng-click=\"vm.salesRule.combinationType = combinator.value\">{{ combinator.symbol }}</md-button></md-menu-item>\n</md-menu-content></md-menu><md-select ng-model=\"vm.salesRule.rh_attribute\" flex><md-option \nng-repeat=\"attribute in vm.attributes\" \nng-if=\"(attribute.value === undefined || attribute.value === null) && vm.salesRule.lh_attribute !== attribute && (attribute.type === \'number\' || attribute.type === \'length\')\" \nng-value=\"attribute\"><span>{{attribute.name | nuitTranslate}}</span></md-option></md-select></div><div layout=\"row\" \nng-if=\"vm.salesRule.type === \'productdata\'\" flex><md-select ng-model=\"vm.salesRule.property\" flex><md-optgroup \nng-repeat=\"category in vm.productProperties\" label=\"{{ category.key | translate }}\"><md-option \nng-repeat=\"property in category.properties\" ng-value=\"property.id\"><span translate=\"{{property.key}}\"></span>\n</md-option></md-optgroup></md-select></div></div>");
$templateCache.put("app/main/system.sales/views/partials/sales/sales_rule_values.html","<div layout=\"column\"><div layout=\"row\" layout-align=\"space-around center\" ng-if=\"vm.showMaterialCondition()\"><md-switch\n ng-model=\"vm.salesRule.priceModifierType\" ng-true-value=\"\'{{vm.materialAttributeBase}}\'\" ng-false-value=\"undefined\">\n<label translate=\"SALES.USE_ATTRIBUTE_BASE\"></label></md-switch><md-menu \nng-if=\"vm.salesRule.priceModifierType===vm.materialAttributeBase\"><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised md-icon-button\"><span>{{vm.salesRule.priceModifier}}</span></md-button><md-menu-content><md-menu-item \nng-repeat=\"modifier in vm.priceModifiers\"><md-button ng-click=\"vm.salesRule.priceModifier = modifier.value\">\n{{ ::modifier.symbol }}</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-align=\"center center\" \nng-if=\"vm.showRulePriceModifier() && vm.salesRule.priceModifierType !== vm.materialAttributeBase\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span>{{vm.salesRule.priceModifier}}</span>\n</md-button><md-menu-content><md-menu-item ng-repeat=\"modifier in vm.priceModifiers\"><md-button \nng-click=\"vm.salesRule.priceModifier = modifier.value\">{{ ::modifier.symbol }}</md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container class=\"mb-0 w-100\" \nng-if=\"vm.salesRule.priceModifierType !== vm.materialAttributeBase\"><label translate=\"Wert\">Wert</label><input \nclass=\"text-right\" type=\"number\" min=\"0\" step=\"0.01\" name=\"price\" ng-model=\"vm.salesRule.priceModifierValue\">\n</md-input-container><md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised md-icon-button\"><span \nng-if=\"vm.salesRule.priceModifierType === \'percent\'\">%</span> <span \nng-if=\"vm.salesRule.priceModifierType === \'currency\'\">{{ vm.config.localization.currency.symbol }}</span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"modifierType in vm.priceModifierTypes\"><md-button \nng-click=\"vm.salesRule.priceModifierType = modifierType.value\">\n{{ (modifierType.symbol === \'$\') ? vm.config.localization.currency.symbol : modifierType.symbol }}</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" layout-align=\"space-around center\" \nng-if=\"vm.salesRule.type === \'attribute\' && vm.salesRule.attribute !== undefined && vm.salesRule.attribute.type === \'enum\'\">\n<md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span \nng-repeat=\"comparator in vm.booleanComparators\" ng-if=\"vm.salesRule.conditionType === comparator.condition\">\n{{ comparator.key | translate }}</span></md-button><md-menu-content><md-menu-item \nng-repeat=\"comparator in vm.booleanComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{::comparator.key}}\"></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container class=\"mr-16\" flex \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if\' || vm.salesRule.conditionType === \'not\')\">\n<label><span translate=\"APP.VALUE\">Value</span></label><md-select ng-model=\"vm.salesRule.conditionValue\"><md-option \nng-repeat=\"option in vm.salesRule.attribute.restrictions.options track by $index\" ng-value=\"option\"><span>{{ option }}\n</span></md-option></md-select></md-input-container><md-input-container class=\"mr-16\" flex \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if_multi\' || vm.salesRule.conditionType === \'not_multi\')\">\n<label><span translate=\"APP.VALUE\">Value</span></label><md-select multiple=\"multiple\" \nng-model=\"vm.salesRule.conditionValue\"><md-option \nng-repeat=\"option in vm.salesRule.attribute.restrictions.options track by $index\" ng-value=\"option\"><span>{{ option }}\n</span></md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.showNumberCondition()\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span \nng-repeat=\"comparator in vm.numericComparators\" ng-if=\"vm.salesRule.conditionType === comparator.condition\" \ntranslate=\"{{::comparator.key}}\"></span></md-button><md-menu-content><md-menu-item \nng-repeat=\"comparator in vm.numericComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{comparator.key}}\"></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container class=\"mb-0 w-100\"><label><span translate=\"APP.VALUE\">Value</span>\n&nbsp;<span ng-if=\"vm.salesRule.attribute.restrictions.unit\">({{vm.salesRule.attribute.restrictions.unit}})</span>\n</label><input type=\"number\" name=\"conditionValue\" ng-model=\"vm.salesRule.conditionValue\" min=\"0\"></md-input-container>\n</div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.showLengthCondition()\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span ng-repeat=\"comparator in vm.numericComparators\" \nng-if=\"vm.salesRule.conditionType === comparator.condition\" translate=\"{{::comparator.key}}\"></span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"comparator in vm.numericComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{comparator.key}}\"></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container class=\"mb-0 w-100\"><label><span translate=\"APP.VALUE\">Value</span>\n&nbsp;<span>({{vm.nuitUnits(\'length\').symbol}})</span></label><input type=\"number\" name=\"conditionValue\" \nnuit-unit-input=\"length\" ng-model=\"vm.salesRule.conditionValue\" min=\"0\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.showAreaCondition()\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" \nclass=\"md-raised\"><span ng-repeat=\"comparator in vm.numericComparators\" \nng-if=\"vm.salesRule.conditionType === comparator.condition\" translate=\"{{::comparator.key}}\"></span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"comparator in vm.numericComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{comparator.key}}\"></md-button></md-menu-item>\n</md-menu-content></md-menu><md-input-container class=\"mb-0 w-100\"><label><span translate=\"APP.VALUE\">Value</span>\n&nbsp;<span>({{vm.nuitUnits(\'area\').symbol}})</span></label><input type=\"number\" name=\"conditionValue\" \nnuit-unit-input=\"area\" ng-model=\"vm.salesRule.conditionValue\" min=\"0\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-around center\" \nng-if=\"vm.showMaterialCondition() && vm.salesRule.priceModifierType !== vm.materialAttributeBase\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span ng-repeat=\"comparator in vm.booleanComparators\" \nng-if=\"vm.salesRule.conditionType === comparator.condition\">{{ comparator.key | translate }}</span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"comparator in vm.booleanComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{::comparator.key}}\"></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container flex class=\"mr-16\" \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if\' || vm.salesRule.conditionType === \'not\')\">\n<label><span translate=\"PRODUCTS.PROFILE_MATERIALS\">Value</span></label><md-select \nng-model=\"vm.salesRule.conditionValue\"><md-option ng-repeat=\"material in vm.materials track by material.id\" \nng-value=\"material.id\"><span>{{ material.name | nuitTranslate }}</span></md-option></md-select></md-input-container>\n<md-input-container flex class=\"mr-16\" \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if_multi\' || vm.salesRule.conditionType === \'not_multi\')\">\n<label><span translate=\"PRODUCTS.PROFILE_MATERIALS\">Value</span></label><md-select \nmd-selected-text=\"vm.salesRule.conditionValue.length + \' materials selected\'\" ng-model=\"vm.salesRule.conditionValue\" \nmultiple=\"multiple\"><md-option ng-repeat=\"material in vm.materials track by material.id\" ng-value=\"material.id\"><span>\n{{ material.name | nuitTranslate }}</span></md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-around center\" ng-if=\"vm.showMaterialGroupCondition()\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span ng-repeat=\"comparator in vm.booleanComparators\" \nng-if=\"vm.salesRule.conditionType === comparator.condition\">{{ comparator.key | translate }}</span></md-button>\n<md-menu-content><md-menu-item ng-repeat=\"comparator in vm.booleanComparators\"><md-button \nng-click=\"vm.salesRule.conditionType = comparator.condition\" translate=\"{{::comparator.key}}\"></md-button>\n</md-menu-item></md-menu-content></md-menu><md-input-container flex class=\"mr-16\" \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if\' || vm.salesRule.conditionType === \'not\')\">\n<label><span translate=\"PRODUCTS.PROFILE_MATERIAL_GROUPS\">Value</span></label><md-select \nng-model=\"vm.salesRule.conditionValue\"><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.id\"><span>\n{{ group.name | nuitTranslate }}</span></md-option></md-select></md-input-container><md-input-container flex \nclass=\"mr-16\" \nng-if=\"vm.salesRule.conditionType !== undefined && (vm.salesRule.conditionType === \'if_multi\' || vm.salesRule.conditionType === \'not_multi\')\">\n<label><span translate=\"PRODUCTS.PROFILE_MATERIAL_GROUPS\">Value</span></label><md-select \nmd-selected-text=\"vm.salesRule.conditionValue.length + \' groups selected\'\" ng-model=\"vm.salesRule.conditionValue\" \nmultiple=\"multiple\"><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.id\"><span>\n{{ group.name | nuitTranslate }}</span></md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" \nng-if=\"(vm.showNumberCondition() || vm.showLengthCondition() || vm.showAreaCondition()) && (vm.salesRule.conditionType === \'/\' || vm.salesRule.conditionType === \'$\')\">\n<md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised\"><span \nng-if=\"vm.salesRule.conditionStart === undefined\" translate=\"MATH.ALWAYS\">Immer</span> <span \nng-if=\"vm.salesRule.conditionStart !== undefined\" translate=\"MATH.AT\">Ab</span></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"vm.salesRule.conditionStart = undefined\"><span translate=\"MATH.ALWAYS\">Immer</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.salesRule.conditionStart = 0\"><span \ntranslate=\"MATH.AT\">Ab</span></md-button></md-menu-item></md-menu-content></md-menu><md-input-container \nclass=\"mb-0 w-100\" ng-if=\"vm.salesRule.conditionStart !== undefined && vm.showAreaCondition()\"><label><span \ntranslate=\"APP.VALUE\">Value</span>&nbsp;<span>({{vm.nuitUnits(\'area\').symbol}})</span></label><input type=\"number\" \nname=\"conditionStart\" nuit-unit-input=\"area\" ng-model=\"vm.salesRule.conditionStart\" min=\"0\"></md-input-container>\n<md-input-container class=\"mb-0 w-100\" ng-if=\"vm.salesRule.conditionStart !== undefined && vm.showLengthCondition()\">\n<label><span translate=\"APP.VALUE\">Value</span>&nbsp;<span>({{vm.nuitUnits(\'length\').symbol}})</span></label><input \ntype=\"number\" name=\"conditionStart\" nuit-unit-input=\"length\" ng-model=\"vm.salesRule.conditionStart\" min=\"0\">\n</md-input-container><md-input-container class=\"mb-0 w-100\" \nng-if=\"vm.salesRule.conditionStart !== undefined && vm.showNumberCondition()\"><label><span translate=\"APP.VALUE\">Value\n</span>&nbsp;<span ng-if=\"vm.salesRule.attribute.restrictions.unit\">({{vm.salesRule.attribute.restrictions.unit}})\n</span></label><input type=\"number\" name=\"conditionStart\" ng-model=\"vm.salesRule.conditionStart\" min=\"0\">\n</md-input-container></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/addressesByCountry/addresses-by-country.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div layout-align=\"space-between\" \nng-repeat=\"value in vm.value\" layout=\"column\" class=\"pl-5 mt-5 b\"><md-select class=\"m-0\" ng-model=\"value.country\">\n<md-option ng-repeat=\"country in vm.countries\" ng-value=\"country.code\"><span class=\"text-uppercase\">{{country.name}}\n</span></md-option></md-select><config-editor-format-with-line-breaks active=\"vm.active\" value=\"value.address\">\n</config-editor-format-with-line-breaks><div flex=\"nogrow\"><md-button ng-click=\"vm.value.splice($index,1)\" \nclass=\"m-0 p-0 md-icon-button\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip><label translate=\"APP.DELETE\">\n</label></md-tooltip></md-button></div></div><div layout-align=\"start\"><md-button ng-disabled=\"!vm.active\" \nclass=\"md-accent mh-0\" ng-click=\"vm.value.push(vm.getDefault())\"><label translate=\"APP.ADD\"></label></md-button></div>\n</div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/arrayOrder/array-order.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label>\nDEFAULT</label></div><div ng-repeat=\"(index, line) in vm.value\"><div layout=\"row\" layout-align=\"end end\"><h4 flex>\n{{line}}</h4><md-icon md-font-icon=\"icon-eye\" ng-click=\"vm.remove(index)\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-up-bold\" ng-disabled=\"index===0\" ng-click=\"vm.moveUp(index)\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-down-bold\" ng-disabled=\"index>=vm.value.length-1\" ng-click=\"vm.moveDown(index)\"></md-icon>\n</div></div><div ng-repeat=\"(index, line) in vm.defaultValues\" ng-if=\"vm.value.indexOf(line)===-1\"><div layout=\"row\" \nlayout-align=\"end end\"><h4 flex>{{line}}</h4><md-icon md-font-icon=\"icon-eye-off\" ng-click=\"vm.add(line)\"></md-icon>\n</div></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/colorSelection/color-selection.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div layout=\"row\"><div \nclass=\"w-40 h-40 mr-20 text-center\" style=\"border: 1px grey solid\" ng-style=\"vm.getStyle()\"><span \nstyle=\"font-size: 30px; font-weight: bold; color: red\">{{vm.isValidHexColor()?\'\':\'!\'}}</span></div><md-input-container \nclass=\"m-0 p-0\" flex><input type=\"text\" aria-label=\"\" ng-disabled=\"!vm.active\" ng-model=\"vm.value\">\n</md-input-container></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/customAttributes/custom-attributes.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><md-select ng-if=\"vm.active\" class=\"m-0\" \nng-model=\"vm.currentLanguage\" ng-if=\"vm.availableLanguages.length>1\"><md-option \nng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select><div layout-align=\"space-between\" ng-repeat=\"value in vm.value\" layout=\"row\" class=\"pl-5 mt-5 b\"><div flex \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"row\" class=\"p-5\" layout-align=\"start center\"><label \nstyle=\"min-width: 85px\" class=\"pr-5\">Name:</label><input flex class=\"grey-100-bg\" style=\"padding: 5px !important\" \ntype=\"text\" ng-model=\"value.name[vm.currentLanguage]\"></div><div layout=\"row\" class=\"p-5\" layout-align=\"start center\">\n<label style=\"min-width: 85px\" class=\"pr-5\">Attribute:</label><input flex class=\"grey-100-bg\" \nstyle=\"padding: 5px !important\" type=\"text\" ng-model=\"value.attribute\"></div></div><div flex=\"nogrow\"><md-button \nng-click=\"vm.value.splice($index,1)\" class=\"m-0 p-0 md-icon-button\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<md-tooltip><label translate=\"APP.DELETE\"></label></md-tooltip></md-button></div></div><div layout-align=\"start\">\n<md-button ng-disabled=\"!vm.active\" class=\"md-accent mh-0\" ng-click=\"vm.value.push({name: {}})\"><label \ntranslate=\"APP.ADD\"></label></md-button></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/customFields/custom-fields.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><md-select ng-if=\"vm.active\" class=\"m-0\" \nng-model=\"vm.currentLanguage\" ng-if=\"vm.availableLanguages.length>1\"><md-option \nng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select><div layout-align=\"space-between\" ng-repeat=\"value in vm.value\" layout=\"row\" class=\"pl-5 mt-5 b\"><div flex \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"row\" class=\"p-5\" layout-align=\"start center\"><label \nstyle=\"min-width: 85px\" class=\"pr-5\">Name:</label><input flex class=\"grey-100-bg\" style=\"padding: 5px !important\" \ntype=\"text\" ng-model=\"value.name[vm.currentLanguage]\"></div><div layout=\"row\" class=\"p-5\" layout-align=\"start center\">\n<label style=\"min-width: 85px\" class=\"pr-5\">Format:</label><textarea flex class=\"grey-100-bg\" \nstyle=\"padding: 5px !important\" type=\"text\" ng-model=\"value.format\"></textarea></div></div><div flex=\"nogrow\">\n<md-button ng-click=\"vm.value.splice($index,1)\" class=\"m-0 p-0 md-icon-button\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><label translate=\"APP.DELETE\"></label></md-tooltip></md-button></div></div><div \nlayout-align=\"start\"><md-button ng-disabled=\"!vm.active\" class=\"md-accent mh-0\" ng-click=\"vm.value.push({name: {}})\">\n<label translate=\"APP.ADD\"></label></md-button></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/disableInvoiceStatus/disable-invoice-status.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label \ntranslate=\"APP.EMPTY\"></label></div><div ng-if=\"vm.active\"><div layout=\"column\" class=\"p-5\" layout-align=\"start start\">\n<label style=\"min-width: 85px\" class=\"pv-10\" ng-if=\"vm.type===\'invoice\'\">Statis:</label><label style=\"min-width: 85px\" \nclass=\"pv-10\" ng-if=\"vm.type===\'remark\'\">Remarks:</label><div ng-repeat=\"status in vm.statis\" class=\"m-0\"><md-checkbox \nng-click=\"vm.getStatus(status, vm.currentStatis)\" ng-checked=\"vm.exists(status.id, vm.currentStatis)\"><span \nng-if=\"vm.type===\'invoice\'\">{{\'INVOICE.STATUS_\' + status.type.toUpperCase() |translate}}</span> <span \nng-if=\"vm.type===\'remark\'\">{{\'INVOICE.REMARK_\' + status.type.toUpperCase() |translate}}</span></md-checkbox></div>\n</div></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/dropDown/drop-down.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label \ntranslate=\"APP.ALL\"></label></div><div ng-if=\"vm.active\"><md-select ng-model=\"vm.value\" multiple=\"{{vm.multiple}}\">\n<md-option ng-repeat=\"value in vm.selectableValues\" ng-value=\"value\">{{value}}</md-option></md-select></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/enableSelection/enable-selection.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b white-bg pl-8\"><div><div ng-repeat=\"entry in vm.value\"><md-switch \nng-disabled=\"!vm.active\" ng-model=\"entry.enabled\" class=\"mt-24\"><span>{{ entry.id }}</span></md-switch></div></div>\n</div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/evoCartFields/evo-cart-fields.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\"><span \ntranslate=\"APP.EMPTY\"></span></div><div ng-if=\"vm.active\"><md-list flex ng-if=\"vm.value.length > 0\"><md-list-item \nclass=\"md-3-line\" ng-repeat=\"field in vm.value\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\nName: {{ field.name[vm.currentLanguage] }}</h3><h4>ID: #{{ field.id }}</h4><p ng-if=\"field.regex\">\nRegex: {{ field.regex }}</p><p ng-if=\"field.minlength\">Min.: {{ field.minlength }}</p><p ng-if=\"field.maxlength\">\nMax.: {{ field.maxlength }}</p></div><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.moveUpElement(field, vm.value)\" ng-disabled=\"$first\" aria-label=\"moveup\"><md-icon \nmd-font-icon=\"icon-arrow-up\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.moveDownElement(field, vm.value)\" ng-disabled=\"$last\" aria-label=\"movedown\"><md-icon \nmd-font-icon=\"icon-arrow-down\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.editCartField(field)\" aria-label=\"edit\"><md-icon md-font-icon=\"icon-border-color\"></md-icon></md-button>\n<md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.deleteElement(field, vm.value)\" aria-label=\"delete\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></md-list-item><md-divider></md-divider></md-list><md-button \nclass=\"md-accent\" translate=\"CART.ADD_FIELD\" ng-click=\"vm.addCartField()\">Feld hinzufügen</md-button></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/exchangeAppId/exchange-app-id.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label \ntranslate=\"APP.EMPTY\"></label></div><div ng-if=\"vm.active\"><md-select ng-model=\"vm.value\"><md-option \nng-repeat=\"app in vm.apps track by app.id\" ng-value=\"app.id\">{{app.name}}</md-option></md-select></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/exchangeFlowId/exchange-flow-id.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label \ntranslate=\"APP.EMPTY\"></label></div><div ng-if=\"vm.active\"><md-select ng-model=\"vm.value\"><md-option \nng-repeat=\"flow in vm.flows track by flow.id\" ng-value=\"flow.id\">{{flow.name}}</md-option></md-select></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/exportOptions/exportOptions.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><md-select class=\"m-0\" \nng-model=\"vm.currentLanguage\" ng-if=\"vm.availableLanguages.length>1\"><md-option \nng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select><div ng-repeat=\"value in vm.value\" layout=\"row\" class=\"mt-5 mb-5 pl-10 b grey-50-bg\"><div layout=\"column\" \nflex class=\"fav-input\"><md-input-container md-no-float class=\"m-0\"><input type=\"text\" \nng-model=\"value.name[vm.currentLanguage]\" placeholder=\"Name\"></md-input-container><md-input-container md-no-float \nclass=\"m-0\"><input type=\"text\" ng-model=\"value.format\" placeholder=\"Format\"></md-input-container></div><md-button \nng-click=\"vm.value.splice($index,1)\" class=\"m-0 p-0 md-icon-button\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<md-tooltip><label translate=\"APP.DELETE\"></label></md-tooltip></md-button></div><div layout-align=\"start\"><md-button \nng-disabled=\"!vm.active\" class=\"md-accent mh-0\" ng-click=\"vm.value.push({name: {}, format: \'\'})\"><label \ntranslate=\"APP.ADD\"></label></md-button></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/favorites/favorites.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><md-select class=\"m-0\" \nng-model=\"vm.currentLanguage\" ng-if=\"vm.availableLanguages.length>1\"><md-option \nng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select><div layout-align=\"space-between\" ng-repeat=\"value in vm.value\" layout=\"row\" class=\"pl-5 mt-5 b fav-input\">\n<md-input-container md-no-float class=\"m-0\"><input type=\"text\" ng-model=\"value.name[vm.currentLanguage]\" \nplaceholder=\"Name\"></md-input-container><md-input-container class=\"m-0\"><input \nstlye=\"max-width: 30px; border-width: 0 !important;\" type=\"number\" ng-model=\"value.weight\"></md-input-container>\n<md-button ng-click=\"vm.value.splice($index,1)\" class=\"m-0 p-0 md-icon-button\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><label translate=\"APP.DELETE\"></label></md-tooltip></md-button></div><div layout-align=\"start\">\n<md-button ng-disabled=\"!vm.active\" class=\"md-accent mh-0\" ng-click=\"vm.value.push({name: {}, weight: 0})\"><label \ntranslate=\"APP.ADD\"></label></md-button></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/formatWithLineBreaks/format-with-line-breaks.component.html","<div ng-repeat=\"split in vm.getSplit()\" layout=\"row\" style=\"min-height: 24px\" layout-align=\"space-between center\"><div \nflex ng-if=\"vm.lineIndex!==$index || vm.lineIndex===-1\">{{split}}</div><input ng-model=\"vm.lineText\" type=\"text\" \nng-if=\"vm.lineIndex===$index\" flex class=\"green-100-bg\"><md-icon \nmd-font-icon=\"{{vm.lineIndex===$index?\'icon-check\':\'icon-pencil\'}}\" ng-click=\"vm.editLine($index)\" \nng-if=\"vm.active  && (vm.lineIndex===-1 || vm.lineIndex===$index)\"></md-icon><md-icon md-font-icon=\"icon-close\" \nng-click=\"vm.deleteLine($index)\" ng-if=\"vm.active && vm.lineIndex===-1\"></md-icon></div><div layout=\"row\" \nlayout-align=\"center\"><md-button ng-if=\"vm.active && vm.lineIndex===-1\" class=\"md-accent mh-0\" ng-click=\"vm.addLine()\">\n<label translate=\"APP.ADD\"></label></md-button></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/holidays/holidays.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"vm.value\" layout=\"row\" \nlayout-wrap><div ng-repeat=\"holiday in vm.value\" class=\"m-5\"><div class=\"grey-100-bg\" layout=\"row\" \nlayout-align=\"center center\"><label class=\"pl-10\">{{vm.formatHoliday(holiday)}}</label><md-button \nclass=\"md-icon-button\" ng-click=\"vm.removeHoliday($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></div></div><md-divider class=\"mt-5\"></md-divider><div><md-datepicker layout-fill ng-model=\"vm.date\" \nmd-date-filter=\"vm.filter\"></md-datepicker><md-button class=\"md-accent\" ng-click=\"vm.addBankHolidays()\" \ntranslate=\"APP.ADD\" ng-disabled=\"!vm.isDate()\"></md-button></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/imageUpload/image-upload.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\"><span \ntranslate=\"APP.EMPTY\"></span></div><div ng-if=\"vm.active\" layout=\"column\"><div class=\"ml-10\" ng-if=\"vm.value!==\'\'\"><img\n class=\"md-whiteframe-5dp\" style=\"width: auto; height:auto\" http-src=\"{{vm.value}}\" src=\"{{vm.value}}\" alt=\" \"></div>\n<div layout=\"row\"><md-input-container class=\"md-block\" flex><input type=\"text\" aria-label=\"\" ng-disabled=\"true\" \nng-model=\"vm.value\"></md-input-container><md-button class=\"md-primary md-raised md-fab md-mini\" flex=\"none\" \nng-click=\"vm.uploadImage()\"><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/orderStatus/order-status.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label \ntranslate=\"APP.EMPTY\"></label></div><div ng-if=\"vm.active\"><md-select ng-model=\"vm.value\"><md-option \nng-repeat=\"status in vm.statis track by status.id\" ng-value=\"status.id\">{{status.name | nuitTranslate}}</md-option>\n</md-select></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/productFilters/product-filters.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><md-list flex \nng-if=\"vm.value && vm.value.length > 0\"><md-list-item class=\"md-2-line\" ng-repeat=\"filter in vm.value\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>Name: {{ filter.name[vm.currentLanguage] }}</h3><h4>\nType: {{ filter.type }}</h4></div><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.moveUpElement(filter, vm.value)\" ng-disabled=\"$first\" aria-label=\"moveup\"><md-icon \nmd-font-icon=\"icon-arrow-up\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.moveDownElement(filter, vm.value)\" ng-disabled=\"$last\" aria-label=\"movedown\"><md-icon \nmd-font-icon=\"icon-arrow-down\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.editFilter(vm.type, vm.value,filter)\" aria-label=\"edit\"><md-icon md-font-icon=\"icon-border-color\">\n</md-icon></md-button><md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.deleteElement(filter, vm.value)\" \naria-label=\"delete\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></md-list-item><md-divider></md-divider>\n</md-list><md-button class=\"md-accent\" translate=\"PRODUCTS.ADD_FILTER\" ng-click=\"vm.addFilter(vm.type, vm.value)\">\nFilter hinzufügen</md-button></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/queueFilters/filters.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><md-select class=\"m-0\" \nng-model=\"vm.currentLanguage\" ng-if=\"vm.availableLanguages.length>1 && vm.active\"><md-option \nng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select><div ng-repeat=\"value in vm.value\" layout=\"row\" class=\"pl-5 mt-5 b\"><div layout=\"column\" flex \nlayout-align=\"space-between\"><div layout=\"row\" class=\"p-5\" layout-align=\"start center\"><label style=\"min-width: 85px\" \nclass=\"pr-5\">Name:</label><input class=\"grey-100-bg\" style=\"padding: 5px !important\" type=\"text\" \nng-model=\"value.name[vm.currentLanguage]\" placeholder=\"Name\"></div><div layout=\"row\" class=\"p-5\" \nlayout-align=\"start center\"><label style=\"min-width: 85px\" class=\"pr-5\">Id:</label><input class=\"grey-100-bg\" \nstyle=\"padding: 5px !important\" type=\"text\" ng-model=\"value.id\" placeholder=\"Id\"></div><div layout=\"row\" class=\"p-5\" \nlayout-align=\"start center\"><label style=\"min-width: 85px\" class=\"pr-5\">Attribute:</label><input class=\"grey-100-bg\" \nstyle=\"padding: 5px !important\" type=\"text\" ng-model=\"value.attribute\" placeholder=\"Attribute\"></div><div layout=\"row\" \nclass=\"p-5\" layout-align=\"start center\"><label style=\"min-width: 85px\" class=\"pr-5\">Input Typ:</label><md-select \nclass=\"m-0\" ng-model=\"value.inputType\" placeholder=\"InputTyp\"><md-option ng-repeat=\"input in vm.inputTypes\" \nng-value=\"input\"><span class=\"text-uppercase\">{{input}}</span></md-option></md-select></div><div layout=\"row\" \nclass=\"p-5\" layout-align=\"start center\"><label style=\"min-width: 85px\" class=\"pr-5\">Case Insensitive:</label>\n<md-checkbox class=\"m-0\" flex ng-model=\"value.caseInsensitive\"></md-checkbox></div></div><div flex=\"nogrow\"><md-button \nng-click=\"vm.value.splice($index,1)\" class=\"m-0 p-0 md-icon-button\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<md-tooltip><label translate=\"APP.DELETE\"></label></md-tooltip></md-button></div></div><div layout-align=\"start\">\n<md-button ng-disabled=\"!vm.active\" class=\"md-accent mh-0\" ng-click=\"vm.value.push({name: {} })\"><label \ntranslate=\"APP.ADD\"></label></md-button></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/readOnlyConditions/read-only-conditions.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div layout-align=\"space-between\" \nng-repeat=\"value in vm.value\" layout=\"row\" class=\"p-5 mb-10 grey-100-bg b\"><div flex layout=\"row\" \nlayout-align=\"space-between\" layout-wrap><div class=\"mb-10\"><span>Condition:</span><div layout=\"column\" \nclass=\"p-5 mt-5 b white-bg\" layout-align=\"space-between\"><div layout=\"row\" class=\"p-5\" layout-align=\"start center\">\n<label style=\"min-width: 85px\" class=\"pr-5\">Attribute:</label><input flex class=\"grey-100-bg\" \nstyle=\"padding: 5px !important\" type=\"text\" ng-model=\"value.attribute\"></div><div layout=\"row\" class=\"p-5\" \nlayout-align=\"start center\"><label style=\"min-width: 85px\" class=\"pr-5\">Typ:</label><md-select class=\"m-0\" \nng-model=\"value.type\" placeholder=\"Typ\"><md-option ng-repeat=\"con in vm.conditions\" ng-value=\"con\"><span>{{con}}</span>\n</md-option></md-select></div><div layout=\"row\" class=\"p-5\" layout-align=\"start center\"><label style=\"min-width: 85px\" \nclass=\"pr-5\">Value:</label><input flex class=\"grey-100-bg\" style=\"padding: 5px !important\" type=\"text\" \nng-model=\"value.value\"></div><div layout=\"row\" class=\"p-5\" layout-align=\"start center\" \nng-if=\"!$last && vm.type !== \'style\'\"><label style=\"min-width: 85px\" class=\"pr-5\">Operator:</label><md-select \nclass=\"m-0\" ng-model=\"value.operator\" placeholder=\"Operator\"><md-option ng-repeat=\"op in vm.operators\" ng-value=\"op\">\n<span>{{op}}</span></md-option></md-select></div></div></div><div ng-if=\"vm.type === \'style\'\"><span class=\"mt-5\">Style:\n</span><div class=\"p-5 mt-5 b white-bg\" layout=\"column\" layout-wrap><div ng-repeat=\"(key,val) in value.style\" \nlayout=\"row\" ng-if=\"vm.style\" layout-align=\"start center\"><span class=\"p-5\">{{key}}: </span><input flex \nclass=\"grey-100-bg\" style=\"padding: 5px !important\" type=\"text\" ng-model=\"val\"><md-button \nng-click=\"vm.deleteStyle(key, value.style)\" class=\"m-0 p-0 md-icon-button\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><label translate=\"APP.DELETE\"></label></md-tooltip></md-button></div><md-divider class=\"mv-10\">\n</md-divider><div layout=\"column\"><span class=\"pl-5\">New Style:</span><div layout=\"row\" class=\"p-5\" \nlayout-align=\"start center\" layout-wrap><label style=\"min-width: 85px\" class=\"pr-5\">Attribute:</label><input flex \nclass=\"grey-100-bg\" style=\"padding: 5px !important\" type=\"text\" ng-model=\"vm.styleAttribute\"></div><div layout=\"row\" \nclass=\"p-5\" layout-align=\"start center\" layout-wrap><label style=\"min-width: 85px\" class=\"pr-5\">Value:</label><input \nflex class=\"grey-100-bg\" style=\"padding: 5px !important\" type=\"text\" ng-model=\"vm.styleValue\"></div></div><div \nlayout-align=\"start\" layout=\"row\"><div style=\"min-width: 90px\"></div><md-button ng-disabled=\"!vm.active\" \nclass=\"md-accent mh-0\" ng-click=\"vm.newStyle($index)\"><label>ADD STYLE</label></md-button></div></div></div></div><div \nflex=\"nogrow\"><md-button ng-click=\"vm.value.splice($index,1)\" class=\"m-0 p-0 md-icon-button\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip><label translate=\"APP.DELETE\"></label></md-tooltip></md-button></div>\n</div><div layout-align=\"start\"><md-button ng-disabled=\"!vm.active\" class=\"md-accent mh-0\" \nng-click=\"vm.newCondition()\"><label translate=\"APP.ADD\"></label></md-button></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/readOnlyStatis/read-only-statis.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label \ntranslate=\"APP.EMPTY\"></label></div><div ng-if=\"vm.active\"><div layout=\"column\" class=\"p-5\" layout-align=\"start start\">\n<label style=\"min-width: 85px\" class=\"pv-10\">Statis:</label><div ng-repeat=\"status in vm.statis\" class=\"m-0\">\n<md-checkbox ng-click=\"vm.getStatus(status, vm.currentStatis)\" ng-checked=\"vm.exists(status.id, vm.currentStatis)\">\n<span>{{status.name[vm.currentLanguage]}}</span></md-checkbox></div></div></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/salesOrder/sales-order.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label>\nDEFAULT</label></div><div ng-repeat=\"(index, line) in vm.value\" ng-init=\"open = false\"><div layout=\"row\" \nlayout-align=\"end end\"><h4 flex>{{line.id}}</h4><md-icon md-font-icon=\"{{line.visible?\'icon-eye\':\'icon-eye-off\'}}\" \nng-click=\"line.visible=!line.visible\"></md-icon><md-icon md-font-icon=\"icon-arrow-up-bold\" ng-disabled=\"index===0\" \nng-click=\"vm.moveUp(index)\"></md-icon><md-icon md-font-icon=\"icon-arrow-down-bold\" \nng-disabled=\"index>=vm.value.length-1\" ng-click=\"vm.moveDown(index)\"></md-icon><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"open = !open\"></md-icon></div><config-editor-read-only-conditions \nng-if=\"open\" value=\"line.conditions\" active=\"vm.active\" flex></config-editor-read-only-conditions></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/salesOrderOverrides/sales-order-overrides.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label>\nDEFAULT</label></div><md-select ng-if=\"vm.active\" ng-change=\"vm.toggle()\" ng-model=\"vm.currentIds\" multiple=\"multiple\">\n<md-option ng-value=\"entry\" ng-repeat=\"entry in vm.getOptions()\">{{entry}}</md-option></md-select><div \nng-repeat=\"(index, line) in vm.value\" ng-init=\"open = false\"><div layout=\"row\" layout-align=\"end end\"><h4 flex>\n{{line.id}}</h4><md-icon md-font-icon=\"{{line.visible?\'icon-eye\':\'icon-eye-off\'}}\" \nng-click=\"line.visible=!line.visible\"></md-icon><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"open = !open\">\n</md-icon></div><config-editor-read-only-conditions ng-if=\"open\" value=\"line.conditions\" active=\"vm.active\" flex>\n</config-editor-read-only-conditions></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/stampingAreas/stamping-areas.component.html","<div class=\"grey-100-bg p-10\" id=\"stampingTools\"><md-button class=\"md-accent\" ng-click=\"vm.addArea()\" \nng-disabled=\"!vm.active\"><label>ADD AREA</label></md-button><md-tabs \nclass=\"md-whiteframe-1dp white-bg md-dynamic-height\"><md-tab ng-repeat=\"area in vm.value\" flex class=\"ph-10 pb-20\" \nmd-active=\"area.id === \'new Area\'\"><md-tab-label class=\"ph-24 pv-12\"><span>{{area.id}}</span></md-tab-label>\n<md-tab-body><div \nng-style=\"{\'pointer-events\': vm.active ? \'initial\' : \'none\', \'opacity\': vm.active ? \'initial\' : \'.5\'}\"><div \nclass=\"p-10\"><div layout=\"row\"><div flex=\"50\"><md-switch ng-model=\"area.isVisible\" aria-label=\"isVisible\">isVisible\n</md-switch></div><div flex=\"50\"><md-input-container flex><label>Selector Y</label><md-select \nng-model=\"area.selectorY\"><md-option value=\"none\">none</md-option><md-option value=\"longestSegment\">longestSegment\n</md-option></md-select></md-input-container></div></div><div layout=\"column\"><md-input-container flex><label>id\n</label><input type=\"text\" ng-model=\"area.id\"></md-input-container><div>Name</div><div layout=\"row\" flex>\n<md-input-container ng-repeat=\"lang in vm.availableLanguages\" flex><label>{{lang}}</label><input type=\"text\" \nng-model=\"area.name[lang]\"></md-input-container></div></div><div layout=\"row\" layout-align=\"between center\"><md-switch \nng-model=\"area.isTop\" aria-label=\"isTop\" ng-true-value=\"true\" ng-false-value=\"\" class=\"mr-10\" \nng-change=\"vm.isTop(area)\">isTop</md-switch><md-switch ng-model=\"area.isBottom\" aria-label=\"isBottom\" \nng-true-value=\"true\" ng-false-value=\"\" ng-change=\"vm.isBottom(area)\">isBottom</md-switch></div><div layout=\"row\" \nlayout-align=\"between center\"><md-switch ng-model=\"area.isLeft\" aria-label=\"isLeft\" ng-true-value=\"true\" \nng-false-value=\"\" class=\"mr-10\" ng-change=\"vm.isLeft(area)\">isLeft</md-switch><md-switch ng-model=\"area.isRight\" \naria-label=\"isRight\" ng-true-value=\"true\" ng-false-value=\"\" ng-change=\"vm.isRight(area)\">isRight</md-switch></div><div \nlayout=\"row\"><div><div>Position Y</div><md-input-container flex><label>from</label><input type=\"number\" \nng-model=\"area.y.from\" nuit-unit-input=\"length\"></md-input-container><md-input-container flex><label>to</label><input \ntype=\"number\" ng-model=\"area.y.to\" nuit-unit-input=\"length\"></md-input-container></div><div><div>Position X</div>\n<md-input-container flex><label>from</label><input type=\"number\" ng-model=\"area.x.from\" nuit-unit-input=\"length\">\n</md-input-container><md-input-container flex><label>to</label><input type=\"number\" ng-model=\"area.x.to\" \nnuit-unit-input=\"length\"></md-input-container></div></div><div ng-init=\"area.allow = area.allow || []\"><div>\nAllow (tool sizes)</div><md-chips ng-model=\"area.allow\" md-removable=\"true\" md-require-match=\"true\"><md-autocomplete \nmd-items=\"size in vm.sizes\" md-item-text=\"size\">{{size}}</md-autocomplete></md-chips></div></div><md-button \nclass=\"md-accent\" ng-click=\"vm.deleteArea(area)\"><label>DELETE AREA</label></md-button></div></md-tab-body></md-tab>\n</md-tabs></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/stampingTemplates/stamping-templates.component.html","<div class=\"grey-100-bg p-10\" id=\"stampingTools\"><md-button class=\"md-accent\" ng-click=\"vm.addTemplate()\" \nng-disabled=\"!vm.active\"><label>ADD Template</label></md-button><md-tabs \nclass=\"md-whiteframe-1dp white-bg md-dynamic-height\"><md-tab ng-repeat=\"(toolindex, template) in vm.value\" flex \nclass=\"ph-10 pb-20\" md-active=\"template.id === \'new Template\'\"><md-tab-label class=\"ph-24 pv-12\"><span>{{template.id}}\n</span></md-tab-label><md-tab-body><div \nng-style=\"{\'pointer-events\': vm.active ? \'initial\' : \'none\', \'opacity\': vm.active ? \'initial\' : \'.5\'}\"><div \nclass=\"p-10\"><div><md-input-container flex><label>id</label><input type=\"text\" ng-model=\"template.id\">\n</md-input-container></div><div><div>Name</div><div layout=\"row\" layout-wrap layout-align=\"start start\"><div \nng-repeat=\"lang in vm.availableLanguages\" flex><md-input-container flex><label>{{lang}}</label><input type=\"text\" \nng-model=\"template.name[lang]\"></md-input-container></div></div></div><div class=\"grey-100-bg\"><div \nclass=\"p-5 grey-200-bg\" layout=\"row\" layout-align=\"space-between center\" ng-click=\"vm.showLines = !vm.showLines\" \nstyle=\"cursor: pointer\"><div>Lines</div><div ng-if=\"vm.showLines\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon>\n</div><div ng-if=\"!vm.showLines\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div><div class=\"p-5\" \nng-if=\"vm.showLines\" layout=\"column\"><div layout=\"column\" layout-align=\"center\" flex \nng-repeat=\"(index, line) in template.lines\"><div layout=\"row\" class=\"bb p-5 mb-5\" flex><div layout=\"column\" flex><div \nlayout=\"row\" flex><md-input-container class=\"mb-0\" flex><label>areaId</label><md-select ng-model=\"line.areaId\">\n<md-option ng-repeat=\"area in vm.areas\" ng-value=\"area\">{{area}}</md-option></md-select></md-input-container>\n<md-input-container class=\"mb-0\" flex><label>toolId</label><md-select ng-model=\"line.toolId\"><md-option \nng-repeat=\"tool in vm.tools\" ng-value=\"tool\">{{tool}}</md-option></md-select></md-input-container><md-input-container \nclass=\"mb-0\" flex><label>toolSizeId</label><md-select ng-model=\"line.toolSizeId\"><md-option \nng-repeat=\"size in vm.sizes\" ng-value=\"size\">{{size}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" flex><div layout=\"row\" flex=\"50\"><md-input-container flex=\"50\" class=\"mb-0\"><label>y position</label>\n<md-select ng-model=\"line.y.position\"><md-option value=\"relative\">relative</md-option><md-option value=\"absolute\">\nabsolute</md-option></md-select></md-input-container><md-input-container flex class=\"mb-0\" \nng-if=\"line.y.position === \'relative\'\"><label>y vaule</label><input type=\"number\" ng-model=\"line.y.value\" min=\"0\" \nmax=\"1\"><div class=\"hint font-size-10 grey-500-fg\">Min = 0, Max = 1</div></md-input-container><md-input-container flex \nclass=\"mb-0\" ng-if=\"line.y.position === \'absolute\'\"><label>y vaule</label><input type=\"number\" ng-model=\"line.y.value\" \nnuit-unit-input=\"length\"></md-input-container></div><div layout=\"row\" flex=\"50\"><md-input-container flex=\"50\" \nclass=\"mb-0\"><label>distance position</label><md-select ng-model=\"line.distance.position\"><md-option value=\"relative\">\nrelative</md-option><md-option value=\"absolute\">absolute</md-option></md-select></md-input-container>\n<md-input-container flex class=\"mb-0\" ng-if=\"line.distance.position === \'relative\'\"><label>distance vaule</label><input\n type=\"number\" ng-model=\"line.distance.value\" min=\"0\" max=\"1\"><div class=\"hint font-size-10 grey-500-fg\">\nMin = 0, Max = 1</div></md-input-container><md-input-container flex class=\"mb-0\" \nng-if=\"line.distance.position === \'absolute\'\"><label>distance vaule</label><input type=\"number\" \nng-model=\"line.distance.value\" nuit-unit-input=\"length\"></md-input-container></div></div></div><md-button \nclass=\"mt-10 md-icon-button\" ng-click=\"vm.deleteLine(toolindex, index)\" style=\"margin-top: 12px !important\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></div></div><md-button class=\"md-accent\" \nng-click=\"vm.addLine(template)\"><label>ADD LINE</label></md-button></div></div></div><md-button class=\"md-accent\" \nng-click=\"vm.deleteTemplate(template)\"><label>DELETE Template</label></md-button></div></md-tab-body></md-tab>\n</md-tabs></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/stampingTools/stamping-tools.component.html","<div class=\"grey-100-bg p-10\" id=\"stampingTools\"><md-button class=\"md-accent\" ng-click=\"vm.addTool()\" \nng-disabled=\"!vm.active\"><label>ADD Tool</label></md-button><md-tabs \nclass=\"md-whiteframe-1dp white-bg md-dynamic-height\"><md-tab ng-repeat=\"(toolindex, tool) in vm.value\" flex \nclass=\"ph-10 pb-20\" md-active=\"tool.id === \'new Tool\'\"><md-tab-label class=\"ph-24 pv-12\"><span>{{tool.id}}</span>\n</md-tab-label><md-tab-body><div layout=\"row\" flex layout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-disabled=\"toolindex===0\" ng-click=\"vm.moveLeft(toolindex)\"><md-icon md-font-icon=\"icon-arrow-left-bold\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-disabled=\"toolindex>=vm.value.length-1\" \nng-click=\"vm.moveRight(toolindex)\"><md-icon md-font-icon=\"icon-arrow-right-bold\"></md-icon></md-button></div><div \nng-style=\"{\'pointer-events\': vm.active ? \'initial\' : \'none\', \'opacity\': vm.active ? \'initial\' : \'.5\'}\"><div \nclass=\"p-10\"><div><md-input-container flex><label>id</label><input type=\"text\" ng-model=\"tool.id\"></md-input-container>\n</div><div><div>Language</div><div layout=\"row\" layout-wrap layout-align=\"start start\"><div \nng-repeat=\"lang in vm.availableLanguages\" flex><md-input-container flex><label>{{lang}}</label><input type=\"text\" \nng-model=\"tool.name[lang]\"></md-input-container></div></div></div><div layout=\"column\"><div>Distance</div><div \nlayout=\"row\"><md-input-container flex><label>min</label><input type=\"number\" ng-model=\"tool.distance.min\">\n</md-input-container><md-input-container flex><label>max</label><input type=\"number\" ng-model=\"tool.distance.max\">\n</md-input-container><md-input-container flex><label>default</label><input type=\"number\" \nng-model=\"tool.distance.default\"></md-input-container></div></div><div class=\"grey-100-bg\"><div class=\"p-5\" \nlayout=\"row\" layout-align=\"space-between center\" ng-click=\"vm.showShapes = !vm.showShapes\" style=\"cursor: pointer\">\n<div>Shapes</div><div ng-if=\"vm.showShapes\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></div><div \nng-if=\"!vm.showShapes\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></div></div><div class=\"p-5\" \nng-if=\"vm.showShapes\" layout=\"column\" layout-align=\"center end\"><div layout=\"row\" layout-wrap \nng-repeat=\"(index, shape) in tool.shapes\"><md-input-container flex><label>x</label><input type=\"number\" \nng-model=\"shape.x\"></md-input-container><md-input-container flex><label>y</label><input type=\"number\" \nng-model=\"shape.y\"></md-input-container><md-input-container flex><label>width</label><input type=\"number\" \nng-model=\"shape.width\"></md-input-container><md-input-container flex><label>height</label><input type=\"number\" \nng-model=\"shape.height\"></md-input-container><md-input-container flex><label>radius</label><input type=\"number\" \nng-model=\"shape.radius\"></md-input-container><md-button class=\"mt-10 md-icon-button\" \nng-click=\"vm.deleteShape(toolindex, index)\" style=\"margin-top: 12px !important\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></div><md-button class=\"md-accent\" ng-click=\"vm.addShape(tool)\"><label>ADD SHAPE</label>\n</md-button></div></div><div class=\"grey-100-bg mt-10\"><div class=\"p-5\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"vm.showSizes = !vm.showSizes\" style=\"cursor: pointer\"><div>Sizes</div>\n<div ng-if=\"vm.showSizes\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></div><div ng-if=\"!vm.showSizes\"><md-icon\n md-font-icon=\"icon-chevron-right\"></md-icon></div></div><div class=\"p-5\" ng-if=\"vm.showSizes\" layout=\"column\" \nlayout-align=\"center\"><div layout=\"column\" layout-wrap ng-repeat=\"(index, size) in tool.sizes\" flex \nclass=\"grey-50-bg mb-8\" layout-padding><div layout=\"row\"><md-input-container flex><label>id</label><input type=\"text\" \nng-model=\"size.id\"></md-input-container><md-input-container flex><label>value</label><input type=\"number\" \nng-model=\"size.value\"></md-input-container><md-button class=\"md-icon-button\" ng-disabled=\"index===0\" \nng-click=\"vm.moveUp(tool.sizes,index)\" style=\"margin-top: 12px !important\"><md-icon md-font-icon=\"icon-arrow-up-bold\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-disabled=\"index>=vm.value.length-1\" \nng-click=\"vm.moveDown(tool.sizes,index)\" style=\"margin-top: 12px !important\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSize(toolindex, index)\" style=\"margin-top: 12px !important\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></div><div>Name</div><div layout=\"row\" flex><md-input-container \nng-repeat=\"lang in vm.availableLanguages\" flex><label>{{lang}}</label><input type=\"text\" ng-model=\"size.name[lang]\">\n</md-input-container></div></div><div layout=\"row\"><div flex></div><md-button class=\"md-accent\" \nng-click=\"vm.addSize(tool)\"><label>ADD SIZE</label></md-button></div></div></div></div><md-button class=\"md-accent\" \nng-click=\"vm.deleteTool(tool)\"><label>DELETE Tool</label></md-button></div></md-tab-body></md-tab></md-tabs></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/stateSelection/state-selection.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\" flex><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"m-0 p-0\" flex><input type=\"text\" ng-model=\"vm.value\" \nng-disabled=\"!vm.active\"></md-input-container><md-button class=\"md-icon-button m-0\" ng-click=\"vm.openPicker($event)\" \nng-disabled=\"!vm.active\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip>Pick a state</md-tooltip>\n</md-button></div><div class=\"mt-5 mb-10 text-italic grey-600-fg\" ng-if=\"vm.value\"><span><span \ntranslate=\"APP.REQUIRED\"></span>: <span class=\"text-bold\">{{vm.permissionFor(vm.value)?vm.permissionFor(vm.value):\'-\'}}\n</span></span></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/stateSelection/state-selection.info.html","<md-dialog aria-label=\"Pick a state\" style=\"max-width: 820px; width: 100%\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2 translate=\"APP.SELECT\"></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content p-16\" \nstyle=\"min-height: 320px\"><div ng-if=\"vm.showJson\" layout=\"column\"><div layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-primary m-0\" ng-click=\"vm.copyJson()\">Copy</md-button></div><textarea readonly=\"readonly\" \nrows=\"18\" style=\"width:100%; font-family:monospace; white-space:pre; resize:vertical\" ng-model=\"vm.pathsJson\">\n</textarea></div><md-input-container class=\"md-block m-0\" ng-if=\"!vm.showJson\"><label translate=\"APP.SEARCH\"></label>\n<input ng-model=\"vm.search\"></md-input-container><md-radio-group ng-model=\"vm.selected\" ng-if=\"!vm.showJson\"><table \nstyle=\"width:100%; border-collapse:collapse\"><thead><tr class=\"grey-100-bg\"><th class=\"p-5\" style=\"width:40px\"></th><th\n class=\"p-5\" style=\"text-align:left\" translate=\"APP.NAME\"></th><th class=\"p-5\" style=\"text-align:left\"></th><th \nclass=\"p-5\" style=\"text-align:left\" translate=\"ROLES.PERMISSIONS\"></th></tr></thead><tbody><tr \nng-repeat=\"state in vm.states | filter:vm.search track by state.state\" class=\"b-bottom\" style=\"cursor:pointer\" \nng-click=\"vm.selected = state.state\"><td class=\"p-5\"><md-radio-button value=\"{{state.state}}\" \naria-label=\"{{state.state}}\" class=\"m-0\"></md-radio-button></td><td class=\"p-5\">{{state.label}}</td><td \nclass=\"p-5 text-italic\">{{state.state}}</td><td class=\"p-5\">{{state.permission || \'—\'}}</td></tr></tbody></table>\n</md-radio-group></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.cancel()\" translate=\"APP.CANCEL\">\n</md-button><md-button ng-click=\"vm.confirm()\" class=\"md-primary\" ng-disabled=\"!vm.selected\" translate=\"APP.CONFIRM\">\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/tagGroupSelection/tag-group-selection.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\" flex><div class=\"bb mb-20\" \nng-repeat=\"group in vm.value\" layout=\"column\" layout-align=\"start center\" flex><div layout=\"row\" flex layout-fill>\n<md-input-container flex=\"20\" class=\"mb-0\"><label translate=\"APP.LANGUAGE\">Lang</label><md-select \nng-model=\"vm.currentLanguage\"><md-option ng-repeat=\"lang in vm.languages\" ng-value=\"lang\"><span class=\"text-uppercase\">\n{{lang}}</span></md-option></md-select></md-input-container><md-input-container flex=\"80\" class=\"mb-0\"><label \ntranslate=\"APP.NAME\">Name</label><input type=\"text\" ng-model=\"group.name[vm.currentLanguage]\"></md-input-container>\n<md-button ng-click=\"vm.value.splice($index,1)\" class=\"m-0 p-0 md-icon-button\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><label translate=\"APP.DELETE\"></label></md-tooltip></md-button></div><div layout=\"row\" flex \nlayout-fill><md-input-container flex><md-select ng-model=\"group.group\" required><md-option \nng-repeat=\"group in vm.getGroups()\" ng-value=\"group\"><div>{{group}}</div></md-option></md-select></md-input-container>\n</div><div layout=\"row\" flex layout-fill><md-input-container flex><md-checkbox ng-model=\"group.multiple\" flex><span>\nmultiple</span></md-checkbox></md-input-container><md-input-container flex><md-checkbox ng-model=\"group.required\" flex>\n<span>required</span></md-checkbox></md-input-container></div></div><md-button ng-disabled=\"!vm.active\" \nclass=\"md-accent mh-0\" ng-click=\"vm.newSelection()\"><label translate=\"APP.ADD\"></label></md-button></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/translationArray/translation-array.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><md-select ng-if=\"vm.active\" class=\"m-0\" \nng-model=\"vm.currentLanguage\" ng-if=\"vm.availableLanguages.length>1\"><md-option \nng-repeat=\"lang in vm.availableLanguages\" ng-value=\"lang\"><span class=\"text-uppercase\">{{lang}}</span></md-option>\n</md-select><div ng-if=\"vm.active\" layout-align=\"space-between\" ng-repeat=\"value in vm.value\" layout=\"row\" \nclass=\"p-5 mb-10 b\"><div flex layout=\"row\" layout-align=\"space-between\" layout-wrap><div layout=\"row\" class=\"p-5\" \nlayout-align=\"start center\"><label style=\"min-width: 85px\" class=\"pr-5\">id:</label><input flex class=\"grey-100-bg\" \nstyle=\"padding: 5px !important\" type=\"text\" ng-model=\"value.id\"></div><div layout=\"row\" class=\"p-5\" \nlayout-align=\"start center\"><label style=\"min-width: 85px\" class=\"pr-5\">Text:</label><input flex class=\"grey-100-bg\" \nstyle=\"padding: 5px !important\" type=\"text\" ng-model=\"value.text[vm.currentLanguage]\"></div></div><div flex=\"nogrow\">\n<md-button ng-click=\"vm.value.splice($index,1)\" class=\"m-0 p-0 md-icon-button\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip><label translate=\"APP.DELETE\"></label></md-tooltip></md-button></div></div><div \nng-if=\"vm.active\" layout-align=\"start\"><md-button ng-disabled=\"!vm.active\" class=\"md-accent mh-0\" \nng-click=\"vm.newTranslation()\"><label translate=\"APP.ADD\"></label></md-button></div><div ng-if=\"!vm.active\" \nlayout-align=\"start\" translate=\"APP.NONE\"></div></div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/userArray/user-array.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b white-bg p-8\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label></label>\n</div><div ng-if=\"vm.active\"><div ng-repeat=\"(index, id) in vm.value track by index\"><div layout=\"row\" \nlayout-align=\"end end\"><nuit-person-name flex person=\"vm.getPerson(id)\"></nuit-person-name><md-icon \nmd-font-icon=\"icon-delete\" ng-click=\"vm.remove(index)\"></md-icon><md-icon md-font-icon=\"icon-arrow-up-bold\" \nng-disabled=\"index===0\" ng-click=\"vm.moveUp(index)\"></md-icon><md-icon md-font-icon=\"icon-arrow-down-bold\" \nng-disabled=\"index>=vm.value.length-1\" ng-click=\"vm.moveDown(index)\"></md-icon></div></div><div><div layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-plus\" ng-click=\"vm.add(line)\"></md-icon></div></div></div>\n</div>");
$templateCache.put("app/main/admin.environment/components/config-editor/customInput/workDays/workdays.component.html","<div layout=\"column\" layout-align=\"start\" class=\"b ph-10 pt-10 white-bg\"><div ng-if=\"!vm.active\" class=\"mb-10\"><label \ntranslate=\"APP.EMPTY\"></label></div><div ng-if=\"vm.active\"><div layout=\"column\" class=\"p-5\" layout-align=\"start start\">\n<label style=\"min-width: 85px\" class=\"pv-10\">Work Days:</label><div layout=\"column\" class=\"m-0\"><md-checkbox \nng-click=\"vm.getDay(1, vm.currentDay)\" ng-checked=\"vm.exists(1, vm.currentDay)\"><span>{{\'APP.MONDAY\' | translate}} (1)\n</span></md-checkbox><md-checkbox ng-click=\"vm.getDay(2, vm.currentDay)\" ng-checked=\"vm.exists(2, vm.currentDay)\">\n<span>{{\'APP.TUESDAY\' | translate}} (2)</span></md-checkbox><md-checkbox ng-click=\"vm.getDay(3, vm.currentDay)\" \nng-checked=\"vm.exists(3, vm.currentDay)\"><span>{{\'APP.WEDNESDAY\' | translate}} (3)</span></md-checkbox><md-checkbox \nng-click=\"vm.getDay(4, vm.currentDay)\" ng-checked=\"vm.exists(4, vm.currentDay)\"><span>\n{{\'APP.THURSDAY\' | translate}} (4)</span></md-checkbox><md-checkbox ng-click=\"vm.getDay(5, vm.currentDay)\" \nng-checked=\"vm.exists(5, vm.currentDay)\"><span>{{\'APP.FRIDAY\' | translate}} (5)</span></md-checkbox><md-checkbox \nng-click=\"vm.getDay(6, vm.currentDay)\" ng-checked=\"vm.exists(6, vm.currentDay)\"><span>\n{{\'APP.SATURDAY\' | translate}} (6)</span></md-checkbox><md-checkbox ng-click=\"vm.getDay(0, vm.currentDay)\" \nng-checked=\"vm.exists(0, vm.currentDay)\"><span>{{\'APP.SUNDAY\' | translate}} (0)</span></md-checkbox></div></div></div>\n</div>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/sidebars/nuit-draw-2d.html","<md-tab md-on-select=\"vm.useEditor(\'nuit-draw-2d\');\" ng-if=\"vm.config.editor.nuitDraw2d.enabled\"><md-tab-label><span \ntranslate=\"PROFILE.PROFILE_EDITOR\">Profildetails</span></md-tab-label><md-tab-body><md-content ms-scroll layout-fill \nflex class=\"editor-sidebar-2d\"><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"!vm.isWrap(0) && !vm.manager.conicalMode\" class=\"addSegment\"><md-button class=\"md-primary\" \nng-click=\"vm.addSegment(0);\" aria-label=\"n\"><span translate=\"SEGMENT.ADD\">Add segment</span></md-button><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.addWrap(0)\" ng-if=\"vm.hasSegments()\" aria-label=\"n\"><md-tooltip><span \ntranslate=\"NUIT_PROFIL.HEM.ADD\"></span></md-tooltip><md-icon md-svg-src=\"_nuit_/assets/umschlag_offen.svg\" \nng-if=\"!vm.config.editor.closeHem\"></md-icon><md-icon md-svg-src=\"_nuit_/assets/umschlag_geschlossen.svg\" \nng-if=\"vm.config.editor.closeHem\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.addWrap(0);vm.setType(0)\" ng-if=\"vm.hasSegments() && vm.config.evo.editor.customSegments.enabled\" \naria-label=\"n\"><md-tooltip><span translate=\"NUIT_PROFIL.CUSTOM_SEGMENT.ADD\"></span></md-tooltip><md-icon \nmd-svg-src=\"_nuit_/assets/curl.svg\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"mr-20\" ng-if=\"vm.manager.conicalMode\"><span></span> <span translate=\"SEGMENT.FRONT\">Vorderlänge</span> <span \ntranslate=\"SEGMENT.BACK\">Hinterlänge</span> <span></span></div><md-list><md-list-item ng-if=\"vm.manager.conicalMode\">\n<div flex class=\"m-0 p-0\" ng-show=\"vm.manager.conicalMode\"><md-button class=\"measure\" \nng-click=\"vm.manager.setConicalBase(-1);\"><md-icon class=\"m-0 p-0\" \nmd-font-icon=\"{{(vm.manager.getConicalBase()===-1?\'icon-chevron-double-right\':\'icon-chevron-down\')}}\" class=\"inner\">\n<md-tooltip md-direction=\"bottom\"><span translate=\"EDITOR.CONICAL_BASE\">CONICAL BASE</span></md-tooltip></md-icon>\n</md-button></div></md-list-item><md-list-item ng-repeat=\"segment in vm.segments\" class=\"segment\" \nng-class=\"{ \'wrap\': segment.isWrap() }\" ng-model-options=\"{updateOn : \'change\'}\"><div layout=\"row\" flex \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" class=\"left\"><div flex \nclass=\"m-0 p-0\" \nng-show=\"vm.material && (vm.originalThickness >= vm.config.editor.innerOuterThicknessThreshold) && !vm.manager.conicalMode\">\n<md-button class=\"measure\" ng-if=\"segment.measureSide === vm.MEASURE.Outer\" ng-click=\"vm.toggleMeasure($index);\">\n<md-icon class=\"m-0 p-0\" md-svg-src=\"_nuit_/assets/ic_code_black_24px.svg\" class=\"inner\"><md-tooltip \nmd-direction=\"bottom\"><span translate=\"EDITOR.MEASURE_OUTER\">Außenmaß</span></md-tooltip></md-icon></md-button>\n<md-button class=\"measure\" ng-if=\"segment.measureSide === vm.MEASURE.Inner\" ng-click=\"vm.toggleMeasure($index);\">\n<md-icon class=\"m-0 p-0\" md-svg-src=\"_nuit_/assets/ic_inner_black_24px.svg\" class=\"inner\"><md-tooltip \nmd-direction=\"bottom\"><span translate=\"EDITOR.MEASURE_INNER\">Innenmaß</span></md-tooltip></md-icon></md-button></div>\n<div flex class=\"m-0 p-0\" ng-show=\"vm.manager.conicalMode\"><md-button class=\"measure\" \nng-click=\"vm.manager.setConicalBase($index);\"><md-icon class=\"m-0 p-0\" \nmd-font-icon=\"{{($index===vm.manager.getConicalBase()?\'icon-chevron-double-right\':\'icon-chevron-down\')}}\" \nclass=\"inner\"><md-tooltip md-direction=\"bottom\"><span translate=\"EDITOR.CONICAL_BASE\">CONICAL BASE</span></md-tooltip>\n</md-icon></md-button></div><div class=\"length\"><input type=\"number\" ng-model=\"segment.length\" \nng-disabled=\"segment.getType()!==undefined\" ng-change=\"vm.refreshFrontLength(segment, $index)\" \nng-blur=\"vm.unhighlightAll()\" ng-focus=\"vm.highlightSegment($index, {direction:\'front\'});\" aria-label=\"n\" \nid=\"length-front-{{segment.index}}\" nuit-unit-input=\"length\" data-length-focus=\"{{$index}}\" tabindex=\"{{$index*2+1}}\" \nng-keydown=\"vm.shortCutAction($event)\"> <span class=\"unit\">{{vm.config.units.length.symbol}}</span></div><md-button \nclass=\"md-icon-button\" aria-label=\"n\" ng-if=\"!segment.isWrap() && vm.manager.conicalMode\" \nng-click=\"vm.toggleConical($index)\" ng-class=\"{\'md-raised md-primary\':segment.isConical()}\" tabindex=\"-1\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_lock_open_black_24px.svg\" ng-if=\"segment.isConical()\"></md-icon><md-icon \nmd-svg-src=\"_nuit_/assets/ic_lock_outline_black_24px.svg\" ng-if=\"!segment.isConical()\"></md-icon></md-button><div \nclass=\"length\" ng-if=\"vm.manager.conicalMode\"><input type=\"number\" ng-disabled=\"!segment.isConical()\" \nng-model=\"segment.backLength\" ng-change=\"vm.refreshBackLength(segment, $index)\" ng-blur=\"vm.unhighlightAll()\" \nng-focus=\"vm.highlightSegment($index, {direction:\'back\'});\" aria-label=\"n\" id=\"length-back-{{segment.index}}\" \nnuit-unit-input=\"length\" data-backlength-focus=\"{{$index}}\" tabindex=\"{{$index*2+1}}\"> <span class=\"unit\">\n{{vm.config.units.length.symbol}}</span></div><div class=\"angle\" ng-if=\"$index>0 && !vm.manager.conicalMode\"><input \ntype=\"number\" min=\"-179\" max=\"180\" ng-model=\"segment.angleOffsetProp\" ng-change=\"vm.reValidate()\" \nng-blur=\"vm.unhighlightAll()\" ng-focus=\"vm.highlightAngle($event, $index);\" aria-label=\"n\" nuit-angle=\"$index\" \ndata-angle-focus=\"{{$index}}\" tabindex=\"{{$index*2}}\"> <span class=\"unit\">°</span></div></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"buttons-no-margin right\"><md-button class=\"md-icon-button\" tabindex=\"-1\" \naria-label=\"n\" ng-if=\"vm.isWrap($index) && $index === 0\" ng-click=\"vm.toggleBdir($index+1);\" \nstyle=\"transform: rotate(90deg)\"><md-tooltip><span translate=\"NUIT_PROFILE.SETTINGS.HEM_DIRECTION.CHANGE\"></span>\n</md-tooltip><md-icon md-svg-src=\"_nuit_/assets/ic_swap_horiz_black_24px.svg\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" tabindex=\"-1\" aria-label=\"n\" ng-if=\"vm.isWrap($index) && $index > 0\" \nng-click=\"vm.toggleBdir($index);\" style=\"transform: rotate(90deg)\"><md-tooltip><span \ntranslate=\"NUIT_PROFILE.SETTINGS.HEM_DIRECTION.CHANGE\"></span></md-tooltip><md-icon \nmd-svg-src=\"_nuit_/assets/ic_swap_horiz_black_24px.svg\"></md-icon></md-button><md-button class=\"md-icon-button\" \ntabindex=\"-1\" aria-label=\"n\" ng-click=\"vm.toggleClose($index)\" \nng-if=\"vm.isWrapMode($index, true, true) && segment.getType()===undefined\"><md-tooltip><span \ntranslate=\"NUIT_PROFIL.HEM.OPEN\"></span></md-tooltip><md-icon style=\"transform: scale(-1)\" \nmd-svg-src=\"_nuit_/assets/umschlag_geschlossen_gesp.svg\"></md-icon></md-button><md-button class=\"md-icon-button\" \ntabindex=\"-1\" aria-label=\"n\" ng-click=\"vm.toggleClose($index)\" \nng-if=\"vm.isWrapMode($index, true, false) && segment.getType()===undefined\"><md-tooltip><span \ntranslate=\"NUIT_PROFIL.HEM.CLOSE\"></span></md-tooltip><md-icon style=\"transform: scale(-1)\" \nmd-svg-src=\"_nuit_/assets/umschlag_offen_gesp.svg\"></md-icon></md-button><md-button class=\"md-icon-button\" \ntabindex=\"-1\" aria-label=\"n\" ng-click=\"vm.toggleClose($index)\" \nng-if=\"vm.isWrapMode($index, false, false) && segment.getType()===undefined\"><md-tooltip><span \ntranslate=\"NUIT_PROFIL.HEM.CLOSE\"></span></md-tooltip><md-icon style=\"transform: scale(-1)\" \nmd-svg-src=\"_nuit_/assets/umschlag_offen.svg\"></md-icon></md-button><md-button class=\"md-icon-button\" tabindex=\"-1\" \naria-label=\"n\" ng-click=\"vm.toggleClose($index)\" \nng-if=\"vm.isWrapMode($index, false, true) && segment.getType()===undefined\"><md-tooltip><span \ntranslate=\"NUIT_PROFIL.HEM.OPEN\"></span></md-tooltip><md-icon style=\"transform: scale(-1)\" \nmd-svg-src=\"_nuit_/assets/umschlag_geschlossen.svg\"></md-icon></md-button><md-button class=\"md-icon-button\" \ntabindex=\"-1\" aria-label=\"n\" \nng-if=\"vm.isWrap($index) && vm.config.evo.editor.customSegments.enabled && segment.getType()!==undefined\" \nng-click=\"vm.setType($index);\" style=\"transform: rotate(90deg)\"><md-tooltip><span \ntranslate=\"NUIT_PROFILE.SETTINGS.SET_TYPE\"></span></md-tooltip>{{segment.getType()}}</md-button><md-button \nclass=\"md-button\" ng-click=\"vm.addDynamicSegment($index)\" \nng-if=\"!vm.isDynamic($index) && !vm.hasHoles() && vm.config.editor.allowDynamicSegments\" tabindex=\"-1\" aria-label=\"n\">\n<md-icon md-svg-src=\"_nuit_/assets/ic_star_border_black_24px.svg\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.removeDynamicSegment($index)\" \nng-if=\"vm.isDynamic($index) && !vm.hasHoles() && vm.config.editor.allowDynamicSegments\" tabindex=\"-1\" aria-label=\"n\">\n<md-icon class=\"yellow-700-fg\" md-svg-src=\"_nuit_/assets/ic_star_black_24px.svg\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.removeSegment($index)\" tabindex=\"-1\" aria-label=\"n\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_close_black_24px.svg\"></md-icon></md-button></div></div></md-list-item><md-list-item \nng-if=\"vm.manager.conicalMode\"><div flex class=\"m-0 p-0\" ng-show=\"vm.manager.conicalMode\"><md-button class=\"measure\" \nng-click=\"vm.manager.setConicalBase(9999);\"><md-icon class=\"m-0 p-0\" \nmd-font-icon=\"{{(vm.manager.getConicalBase()===9999?\'icon-chevron-double-right\':\'icon-chevron-down\')}}\" class=\"inner\">\n<md-tooltip md-direction=\"bottom\"><span translate=\"EDITOR.CONICAL_BASE\">CONICAL BASE</span></md-tooltip></md-icon>\n</md-button></div></md-list-item></md-list><div layout=\"row\" layout-align=\"space-between center\" class=\"addSegment\" \nng-if=\"vm.hasSegments() && !vm.isWrap(vm.segmentCount() - 1) && !vm.manager.conicalMode && !segment.getType()\">\n<md-button class=\"md-primary\" ng-click=\"vm.addSegment(vm.segmentCount())\" aria-label=\"n\"><span translate=\"SEGMENT.ADD\">\nAdd segment</span></md-button><md-button class=\"md-secondary md-icon-button\" aria-label=\"n\" \nng-click=\"vm.addWrap(vm.segmentCount())\"><md-tooltip><span translate=\"NUIT_PROFIL.HEM.ADD\"></span></md-tooltip><md-icon\n style=\"transform: scale(-1)\" md-svg-src=\"_nuit_/assets/umschlag_offen.svg\" ng-if=\"!vm.config.editor.closeHem\">\n</md-icon><md-icon style=\"transform: scale(-1)\" md-svg-src=\"_nuit_/assets/umschlag_geschlossen.svg\" \nng-if=\"vm.config.editor.closeHem\"></md-icon></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.addWrap(vm.segmentCount());vm.setType(vm.segmentCount()-1)\" \nng-if=\"vm.hasSegments() && vm.config.evo.editor.customSegments.enabled\" aria-label=\"n\"><md-tooltip><span \ntranslate=\"NUIT_PROFIL.CUSTOM_SEGMENT.ADD\"></span></md-tooltip><md-icon md-svg-src=\"_nuit_/assets/curl.svg\"></md-icon>\n</md-button></div></md-content></md-tab-body></md-tab>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/sidebars/nuit-draw-cutting.html","<md-tab md-on-select=\"vm.useEditor(\'nuit-draw-cutting\')\" ng-if=\"vm.config.editor.nuitDrawCutting.enabled\" \nng-disabled=\"!vm.hasSegments()\"><md-tab-label><span translate=\"PROFILE.CUTTING\">Cutting</span></md-tab-label>\n<md-tab-body><md-content ms-scroll layout-fill flex class=\"editor-sidebar-cutting\"><div class=\"md-whiteframe-1dp\" \nstyle=\"margin-bottom:20px\" ng-repeat=\"cutting in vm.manager.cuttings\"><span class=\"md-title\" style=\"padding:10px 20px\" \nlayout layout-align=\"space-between center\" ng-click=\"vm.openCuttings = vm.openCuttings === $index ? null : $index\">\n<span><span translate=\"PROFILE.CUTTING\">Cutting</span> #{{$index}}</span><md-button class=\"md-icon-button\" \naria-label=\"n\" ng-click=\"vm.manager.removeCutting($index)\"><md-tooltip md-direction=\"left\" translate=\"MENUBAR.DELETE\">\nDelete</md-tooltip><md-icon md-svg-src=\"_nuit_/assets/baseline-delete_forever-24px.svg\"></md-icon></md-button></span>\n<div ng-show=\"vm.openCuttings === $index\"><div style=\"border-top:1px solid rgba(0,0,0,.12);padding:20px\" \nlayout=\"column\" layout-align=\"start stretch\" class=\"no-error-spacer\"><md-input-container><label \ntranslate=\"CUTTING.ANGLE\">Angle</label><input type=\"number\" ng-model=\"cutting.angle\" step=\"1\"></md-input-container><div\n layout=\"row\" layout-align=\"space-between center\"><md-input-container><label \ntranslate=\"CUTTING.REFERENCED_BENDING_LINE\">Referenced Bending Line</label><input type=\"number\" \nng-model=\"cutting.referenceSegment\" min=\"0\" step=\"1\"></md-input-container><md-input-container><label \ntranslate=\"CUTTING.DISTANCE_FROM_START\">Distance from start</label><input type=\"number\" ng-model=\"cutting.start\" \nmin=\"0\" step=\"1\"></md-input-container></div></div></div></div></md-content></md-tab-body></md-tab>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/sidebars/nuit-draw-stamping-rework.html","<md-tab md-on-select=\"vm.useEditor(\'nuit-draw-stamping-rework\')\" \nng-if=\"vm.config.editor.nuitDrawStampingRework.enabled\" ng-disabled=\"!vm.hasSegments()\"><md-tab-label><span \ntranslate=\"PROFILE.PUNCHINGS\">Punching</span></md-tab-label><md-tab-body><md-content ms-scroll layout-fill flex \nclass=\"editor-sidebar-stamping\" ng-model-options=\"{updateOn: \'change click\'}\"><div class=\"md-whiteframe-1dp\" \nstyle=\"margin-bottom:20px\" ng-repeat=\"line in vm.manager.stampingLines\" \nng-mouseenter=\"vm.highlightStampingLine($event, $index)\" ng-mouseleave=\"vm.unhighlightStampings()\"><span \nclass=\"md-title\" style=\"padding:10px 20px\" layout layout-align=\"space-between center\" \nng-click=\"vm.openStampings = vm.openStampings === $index ? null : $index\"><span><span \ntranslate=\"EDITOR.STAMPING_HEADER\">Punching</span> #{{$index + 1}} <span \nstyle=\"opacity:.7;font-size:.8em;font-style:italic\">({{line.area | nuitTranslate}})</span></span><md-button \nclass=\"md-icon-button\" aria-label=\"n\" ng-click=\"vm.manager.deleteStampingLine($index)\"><md-tooltip md-direction=\"left\">\nDelete</md-tooltip><md-icon md-svg-src=\"_nuit_/assets/baseline-delete_forever-24px.svg\"></md-icon></md-button></span>\n<div ng-show=\"vm.openStampings === $index\"><div style=\"border-top:1px solid rgba(0,0,0,.12);padding:20px\" \nlayout=\"column\" layout-align=\"start stretch\" class=\"no-error-spacer\"><span class=\"mb-10\"><span>\n{{line.tool.name | nuitTranslate}}</span> <span>{{line.tool.sizes[line.size].name | nuitTranslate}}</span> <span>\n({{line.tool.sizes[line.size].value | nuitUnit:\'length\'}})</span></span><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><label translate=\"PROFILE.FIRST_STAMPING\">First stamping\n</label><input type=\"number\" ng-model=\"line.first\" nuit-unit-input=\"length\" \nng-disabled=\"vm.manager.isDisabledByType(line.type)\" ng-blur=\"vm.manager.requireRefresh()\"></md-input-container>\n<md-input-container><label translate=\"PROFILE.LAST_STAMPING\">Last stamping</label><input type=\"number\" \nng-model=\"line.last\" nuit-unit-input=\"length\" ng-disabled=\"vm.manager.isDisabledByType(line.type)\" \nng-blur=\"vm.manager.requireRefresh()\"></md-input-container></div><md-radio-group ng-model=\"line.type\" layout=\"row\" \nlayout-align=\"space-between start\" layout-wrap ng-disabled=\"vm.manager.isDisabledByType(line.type)\" \nng-change=\"vm.manager.requireRefresh()\"><md-radio-button value=\"amount\" aria-label=\"n\" flex=\"noshrink\"><span>Amount\n</span></md-radio-button><md-radio-button value=\"distance\" aria-label=\"n\" flex=\"noshrink\"><span>Distance between</span>\n</md-radio-button></md-radio-group><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"50\"><md-input-container flex><label translate=\"PROFILE.STAMPING_AMOUNT\">\nAmount</label><input type=\"number\" ng-model=\"line.amount\" \nng-disabled=\"!line.fixedAmount || vm.manager.isDisabledByType(line.type)\" ng-blur=\"vm.manager.requireRefresh()\">\n</md-input-container><md-button ng-click=\"line.fixedAmount = !line.fixedAmount; vm.manager.requireRefresh();\" \nflex=\"nogrow\" ng-class=\"{\'md-raised md-primary\':line.fixedAmount}\" class=\"md-icon-button\" aria-label=\"n\" \nng-disabled=\"vm.manager.isDisabledByType(line.type)\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_lock_outline_black_24px.svg\" ng-if=\"!line.fixedAmount\"></md-icon><md-icon \nmd-svg-src=\"_nuit_/assets/ic_lock_open_black_24px.svg\" ng-if=\"line.fixedAmount\"></md-icon></md-button></div>\n<md-input-container flex=\"50\"><label translate=\"PROFILE.DISTANCE_BETWEEN\">Distance between</label><input type=\"number\" \nng-model=\"line.distBetweenStamps\" nuit-unit-input=\"length\" \nng-disabled=\"line.type !== \'distance\' || vm.manager.isDisabledByType(line.type)\" ng-blur=\"vm.manager.requireRefresh()\">\n</md-input-container></div><md-input-container><label translate=\"PROFILE.OFFSET_TOP\">Offset top</label><input \ntype=\"number\" ng-model=\"line.y\" nuit-unit-input=\"length\" ng-disabled=\"vm.manager.isDisabledByType(line.type)\" \nng-blur=\"vm.manager.requireRefresh()\"></md-input-container></div><div \nstyle=\"border-top:1px solid rgba(0,0,0,.12);padding:20px\" ng-if=\"vm.manager.showToolDistances\"><span class=\"md-body-2\" \nstyle=\"font-weight:bold\" translate=\"PROFILE.TOOL_SELECTION\">Tool Selection</span><div layout \nlayout-align=\"start center\" class=\"no-error-spacer\" ng-if=\"vm.manager.showToolDistances\"><md-input-container \nstyle=\"margin-bottom:0\"><label translate=\"PROFILE.MIN_DISTANCE\">Min</label><input type=\"number\" ng-model=\"line.min\" \nnuit-unit-input=\"length\" ng-disabled=\"vm.manager.isDisabledByType(line.type)\" ng-blur=\"vm.manager.requireRefresh()\">\n</md-input-container><md-input-container style=\"margin-bottom:0\"><label translate=\"PROFILE.MAX_DISTANCE\">Max</label>\n<input type=\"number\" ng-model=\"line.max\" nuit-unit-input=\"length\" ng-disabled=\"vm.manager.isDisabledByType(line.type)\" \nng-blur=\"vm.manager.requireRefresh()\"></md-input-container></div></div></div></div><md-button \nclass=\"md-raised md-primary\" style=\"padding:0 10px\" ng-click=\"vm.showAddStampingLineDialog();\" \ntranslate=\"EDITOR.ADD_STAMPING\">Add Stampings</md-button><md-button \nng-disabled=\"vm.manager.usesTemplate(template.config.id)\" class=\"md-raised md-primary\" style=\"padding:0 10px\" \nng-repeat=\"template in vm.manager.templates\" ng-click=\"vm.manager.generateTemplateStampingLine(template.config)\">\n{{template.config.name | nuitTranslate}}</md-button></md-content></md-tab-body></md-tab>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/sidebars/nuit-draw-stamping.html","<md-tab md-on-select=\"vm.useEditor(\'nuit-draw-stamping\')\" ng-if=\"vm.config.editor.nuitDrawStamping.enabled\" \nng-disabled=\"!vm.hasSegments()\"><md-tab-label><span translate=\"PROFILE.PUNCHINGS\">Punching</span></md-tab-label>\n<md-tab-body><md-content ms-scroll layout-fill flex class=\"editor-sidebar-stamping\"><form name=\"holesform\" \nng-submit=\"vm.generateStampings()\"><div layout=\"column\" ng-repeat=\"generator in vm.generators\" \nclass=\"generator md-whiteframe-1dp\" \nng-init=\"console.log(\'i bim da\',currGenerator);currGenerator={id:generator.id,attachedTo:generator.attachedTo};vm.generatorValues.push(currGenerator);\">\n<span class=\"md-title\">{{ vm.getLanguage(generator.name, \'Generator\') }}</span><div layout=\"column\" \nlayout-align=\"start center\"><span translate=\"STAMPING.GENERATOR_TYPE\">Generator type</span><md-radio-group \nng-model=\"currGenerator.type\" layout=\"row\" layout-align=\"space-between center\" layout-wrap \nng-init=\"currGenerator.type=\'distBetween\'\"><md-radio-button flex value=\"distBetween\"><span \ntranslate=\"STAMPING.GENERATOR_TYPE_DISTANCE_BETWEEN\">Distance between</span></md-radio-button><md-radio-button flex \nvalue=\"count\"><span translate=\"STAMPING.GENERATOR_TYPE_COUNT\">Count</span></md-radio-button></md-radio-group></div><div\n layout=\"row\" layout-align=\"space-between center\" \nng-init=\"distName=vm.getLanguage(generator.nameDist, \'Top/Bottom Distance\')\"><span class=\"title\" md-truncate \ntitle=\"{{ distName }}\">{{ distName }}</span><div layout=\"row\" layout-align=\"start center\" class=\"value\" flex=\"none\">\n<md-input-container class=\"no-error-spacer\"><input type=\"number\" aria-label=\"n\" nuit-unit-input=\"length\" \nng-model=\"currGenerator.distanceSide\" ng-disabled=\"generator.restrictionsDist.type===\'locked\'\" \nng-init=\"currGenerator.distanceSide=generator.restrictionsDist.value\" ng-min=\"generator.restrictionsDist.min\" \nng-max=\"generator.restrictionsDist.max\"></md-input-container><span>{{ vm.units.length.symbol}}</span></div></div><div \nlayout=\"row\" layout-align=\"space-between center\" \nng-init=\"distNameFirst=vm.getLanguage(generator.nameDistFirst, \'First Distance\')\"><span class=\"title\" md-truncate \ntitle=\"{{ distNameFirst }}\">{{ distNameFirst }}</span><div layout=\"row\" layout-align=\"start center\" class=\"value\" \nflex=\"none\"><md-input-container class=\"no-error-spacer\"><input type=\"number\" nuit-unit-input=\"length\" aria-label=\"n\" \nng-model=\"currGenerator.distanceFirst\" ng-min=\"generator.distFirstMin\" ng-max=\"generator.distFirstMax\">\n</md-input-container><span>{{vm.units.length.symbol}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"currGenerator.type===\'distBetween\'\" \nng-init=\"distNameBetween=vm.getLanguage(generator.nameDistBetween, \'Distance Between\')\"><span class=\"title\" \nmd-truncate title=\"{{ distNameBetween }}\">{{ distNameBetween }}</span><div layout=\"row\" layout-align=\"start center\" \nclass=\"value\" flex=\"none\"><md-input-container class=\"no-error-spacer\"><input type=\"number\" nuit-unit-input=\"length\" \naria-label=\"n\" ng-model=\"currGenerator.distanceBetween\" ng-min=\"generator.distBetweenMin\" \nng-max=\"generator.distBetweenMax\"></md-input-container><span>{{vm.units.length.symbol}}</span></div></div><div \nlayout=\"row\" layout-align=\"space-between center\" \nng-init=\"distNameLast=vm.getLanguage(generator.nameDistLast, \'Last Distance\')\"><span class=\"title\" md-truncate \ntitle=\"{{ distNameLast }}\">{{ distNameLast }}</span><div layout=\"row\" layout-align=\"start center\" class=\"value\" \nflex=\"none\"><md-input-container class=\"no-error-spacer\"><input type=\"number\" nuit-unit-input=\"length\" aria-label=\"n\" \nng-model=\"currGenerator.distanceLast\" ng-min=\"generator.distLastMin\" ng-max=\"generator.distLastMax\">\n</md-input-container><span>{{vm.units.length.symbol}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"currGenerator.type===\'count\'\"><span class=\"title\" \ntranslate=\"STAMPING.COUNT\" md-truncate>Count</span><div layout=\"row\" layout-align=\"start center\" class=\"value\" \nflex=\"none\"><md-input-container class=\"no-error-spacer\"><input type=\"number\" ng-model=\"currGenerator.count\" \naria-label=\"n\" step=\"1\" min=\"0\"></md-input-container></div></div><div layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"PUNCHING.TOOL\" class=\"title\" md-truncate>Tool</span><md-input-container class=\"no-error-spacer\" \nflex=\"50\"><md-select ng-model=\"currGenerator.tool\" aria-label=\"n\"><md-option ng-repeat=\"toolId in generator.tools\" \nclass=\"value\" ng-init=\"tool=vm.getToolById(toolId)\" ng-value=\"tool\">{{ vm.getLanguage(tool.name) }}</md-option>\n</md-select></md-input-container></div></div><md-button class=\"md-accent md-raised\" type=\"submit\" aria-label=\"n\"><span \ntranslate=\"HOLES.GENERATE\">Generate Holes</span></md-button></form></md-content></md-tab-body></md-tab>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/sidebars/nuit-draw-top.html","<md-tab md-on-select=\"vm.useEditor(\'nuit-draw-top\');\" ng-if=\"vm.config.editor.nuitDrawTop.enabled\" \nng-disabled=\"!vm.hasSegments()\"><md-tab-label><span translate=\"PROFILE.SPECIALS\">Sonderbearbeitung</span>\n</md-tab-label><md-tab-body><md-content ms-scroll layout-fill flex class=\"editor-sidebar-top\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"SEGMENT.FRONT\">Vorderlänge</span> <span translate=\"SEGMENT.BACK\">\nHinterlänge</span></div><md-list><md-list-item ng-repeat=\"segment in vm.segments\" class=\"segment\" \nng-model-options=\"{updateOn : \'change\'}\"><div layout=\"row\" flex layout-align=\"space-between center\"><div \nclass=\"length\"><input type=\"number\" ng-model=\"segment.length\" ng-change=\"vm.refreshFrontLength(segment, $index)\" \nng-blur=\"vm.unhighlightAll()\" ng-focus=\"vm.highlightSegment($index, {direction:\'front\'});\" aria-label=\"n\" \nid=\"length-front-{{segment.index}}\" nuit-unit-input=\"length\" data-length-focus=\"{{$index}}\" tabindex=\"{{$index*2+1}}\"> \n<span class=\"unit\">{{vm.config.units.length.symbol}}</span></div><md-button class=\"md-icon-button\" aria-label=\"n\" \nng-if=\"!segment.isWrap()\" ng-click=\"vm.toggleConical($index)\" ng-class=\"{\'md-raised md-primary\':segment.isConical()}\" \ntabindex=\"-1\"><md-icon md-svg-src=\"_nuit_/assets/ic_lock_open_black_24px.svg\" ng-if=\"segment.isConical()\"></md-icon>\n<md-icon md-svg-src=\"_nuit_/assets/ic_lock_outline_black_24px.svg\" ng-if=\"!segment.isConical()\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"n\" tabindex=\"-1\" ng-if=\"segment.isWrap()\" disabled=\"disabled\"><md-icon \nmd-svg-src=\"_nuit_/assets/umschlag_offen.svg\" md-colors=\"{color:\'default-primary\'}\"></md-icon></md-button><div \nclass=\"length\"><input type=\"number\" aria-label=\"n\" ng-model=\"segment.backLength\" ng-disabled=\"!segment.isConical()\" \nng-change=\"vm.refreshBackLength(segment, $index)\" ng-blur=\"vm.unhighlightAll()\" \nng-focus=\"vm.highlightSegment($index, {direction:\'back\'});\" id=\"length-back-{{segment.index}}\" \nnuit-unit-input=\"length\" data-backlength-focus=\"{{$index}}\" tabindex=\"{{$index*2+1}}\"> <span class=\"unit\">\n{{vm.config.units.length.symbol}}</span></div></div></md-list-item></md-list></md-content></md-tab-body></md-tab>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/toolbars/nuit-draw-2d.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.isView(\'nuit-draw-2d\')\"><md-button class=\"md-icon-button\" \nng-click=\"vm.manager.iterativeCenter()\" aria-label=\"n\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_aspect_ratio_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.FIT\">Darstellung anpassen</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-hold=\"vm.manager.zoom(vm.ZOOM_OUT_FACTOR)\" ng-hold-interval=\"400:10, 150\" aria-label=\"n\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_zoom_out_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.ZOOM_OUT\">Ansicht verkleinern</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-hold=\"vm.manager.zoom(vm.ZOOM_IN_FACTOR)\" ng-hold-interval=\"400:1, 150\" aria-label=\"n\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_zoom_in_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.ZOOM_IN\">Ansicht vergrößern</span></md-tooltip></md-button><md-divider style=\"width:100%\">\n</md-divider><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.manager.toggleAligning()\" \nng-disabled=\"!vm.hasSegments()\" ng-class=\"{\'md-raised\': vm.manager.isAligning()}\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_vertical_align_center_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.ALIGN\">Ausrichten</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-hold=\"vm.manager.rotate(vm.ROTATION_CCLOCKWISE)\" aria-label=\"n\" ng-disabled=\"!vm.hasSegments()\" \nng-hold-interval=\"400:1, 16\"><md-icon md-svg-src=\"_nuit_/assets/ic_rotate_left_black_24px.svg\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate=\"MENUBAR.ROTATE_LEFT\">Nach links drehen</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-hold=\"vm.manager.rotate(vm.ROTATION_CLOCKWISE)\" aria-label=\"n\" \nng-disabled=\"!vm.hasSegments()\" ng-hold-interval=\"400:1, 16\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_rotate_right_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.ROTATE_RIGHT\">Nach rechts drehen</span></md-tooltip></md-button><md-divider></md-divider><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"vm.manager.toggleRuler()\" aria-label=\"n\" \nng-class=\"{\'md-raised\': vm.manager.isMeasuring()}\"><md-icon md-svg-icon=\"_nuit_/assets/ic_straighten_black_24px.svg\">\n</md-icon><md-tooltip md-direction=\"right\"><span translate=\"MENUBAR.RULER\">Ruler</span></md-tooltip></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.manager.toggleVisibleSide()\" aria-label=\"n\" \nng-disabled=\"!vm.hasSegments()\"><md-icon md-svg-icon=\"_nuit_/assets/ic_swap_horiz_black_24px.svg\"></md-icon><md-tooltip\n md-direction=\"right\"><span translate=\"PROFILE.TOGGLE_VISIBLE_SIDE\">Toggle visible side</span></md-tooltip></md-button>\n</div>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/toolbars/nuit-draw-cutting.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.isView(\'nuit-draw-cutting\')\" style=\"width:52px\"></div>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/toolbars/nuit-draw-stamping-rework.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.isView(\'nuit-draw-stamping-rework\')\"><div \nng-if=\"vm.manager.toolGroupsEnabled\"><div ng-repeat=\"type in vm.manager.toolGroupsAvailable\"><div \nng-if=\"vm.manager.getSupportedShapesByType(type).length>0\"><md-button class=\"md-icon-button md-primary\" \nng-class=\"{\'md-raised\': vm.manager.selectedToolType === type}\" ng-click=\"vm.manager.selectedToolType = type\"><svg \nng-if=\"type===\'oblong\'\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"0\" \ny=\"10\" width=\"30\" height=\"10\" rx=\"5\" ry=\"5\"/></svg> <svg ng-if=\"type===\'rectangle\'\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"0\" y=\"0\" width=\"30\" height=\"30\"/></svg> <svg \nng-if=\"type===\'circle\'\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"0\" \ny=\"0\" width=\"30\" height=\"30\" rx=\"15\" ry=\"15\"/></svg></md-button></div></div></div><div \nng-if=\"!vm.manager.toolGroupsEnabled\" ng-repeat=\"tool in vm.manager.tools\"><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"vm.manager.selectedTool = $index\" aria-label=\"n\" \nng-class=\"{\'md-raised\': vm.manager.selectedTool === tool}\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 1 1\"><g \nng-repeat=\"shape in tool.icon\"><rect ng-attr-width=\"{{shape.width}}\" ng-attr-height=\"{{shape.height}}\" \nng-attr-rx=\"{{shape.radius}}\" ng-attr-ry=\"{{shape.radius}}\" ng-attr-x=\"{{shape.x - shape.width / 2 + 0.5}}\" \nng-attr-y=\"{{shape.y}}\"></rect></g></svg><md-tooltip md-direction=\"right\">{{tool.name | nuitTranslate}}</md-tooltip>\n</md-button></div><md-divider></md-divider><md-button class=\"md-icon-button\" ng-click=\"vm.manager.resetStamping()\" \naria-label=\"n\"><md-icon md-svg-src=\"_nuit_/assets/ic_close_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\">\n<span translate=\"MENUBAR.RESET\">Reset</span></md-tooltip></md-button></div>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/toolbars/nuit-draw-stamping.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.isView(\'nuit-draw-stamping\')\"><div \nng-repeat=\"tool in vm.tools\"><md-button class=\"md-icon-button md-primary\" ng-click=\"vm.manager.setTool(tool)\" \naria-label=\"n\" ng-class=\"{\'md-raised\': vm.manager.isTool(\'circle\')}\" ng-if=\"tool.shape===\'circle\'\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_radio_button_unchecked_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.CIRCLE_TOOL\">Kreis-Werkzeug</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"vm.manager.setTool(tool)\" aria-label=\"n\" \nng-class=\"{\'md-raised\': vm.manager.isTool(\'square\')}\" ng-if=\"tool.shape===\'square\'\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_check_box_outline_blank_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.QUAD_TOOL\">Quadrat-Werkzeug</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"vm.manager.setTool(tool)\" aria-label=\"n\" \nng-class=\"{\'md-raised\': vm.manager.isTool(\'roundedrect\')}\" ng-if=\"tool.shape===\'roundedrect\'\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_crop_16_9_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.ROUNDEDRECT_TOOL\">Langloch-Werkzeug</span></md-tooltip></md-button></div><md-divider></md-divider>\n<md-button class=\"md-icon-button\" ng-click=\"vm.manager.resetStamping()\" aria-label=\"n\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_close_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.RESET\">Reset</span></md-tooltip></md-button></div>");
$templateCache.put("app/main/nuit-editor/src/components/nuit-editor/toolbars/nuit-draw-top.html","<div layout=\"column\" layout-align=\"start start\" ng-if=\"vm.isView(\'nuit-draw-top\')\"><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"vm.manager.showStretched()\" aria-label=\"n\" \nng-class=\"{\'md-raised\':vm.manager.isStretched()}\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_image_aspect_ratio_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.SHOW_STRETCHED\">Show stretched</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button md-primary\" ng-click=\"vm.manager.showProportional()\" aria-label=\"n\" \nng-class=\"{\'md-raised\':vm.manager.isProportional()}\"><md-icon \nmd-svg-src=\"_nuit_/assets/ic_photo_size_select_small_black_24px.svg\"></md-icon><md-tooltip md-direction=\"right\"><span \ntranslate=\"MENUBAR.SHOW_ORIGINAL\">Show proportional</span></md-tooltip></md-button></div>");}]);